(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function () {
  "use strict";

  angular.module("app.core").component("leg", {
    templateUrl: "app/main/shipments/dialogs/modify-legs/leg/leg.html",
    bindings: {
      action: "=",
      sourceData: "=",
      billingInfoData: "=",
      rateVendorId: "=",
      isOwnVendorRate: "=",
      callback:'&'
    },
    controller: legController,
  });
  function legController(
    $log,
    $rootScope,
    $mdDialog,
    $window,
    $timeout,
    util,
    localStorageService,
    SearchService,
    shareQuoteService,
    BillingInfoService,
    ShipmentService,
    basisCalculation,
    api,
    constObj) {
    var vm = this;
    //local variable declaration for the service to use in templates
    vm.util = util;
    vm.constObj = constObj;

    vm.billingInfoService = BillingInfoService;
    //popup Actions
    //closing the popup
    vm.cancelDialog = cancelDialog;
    //misc properties
    vm.currencyList = util.currencyList;
    vm.billing_cust_curr = null;
    vm.vendorId = parseInt(
      localStorageService.get("authToken").value.vendor_id
    );
    vm.isShared = vm.util.isSharedPage();

    //shipment details response data
    vm.ShipmentsDetails = ShipmentService.shipmentManagementObj.shipment_meta;
    vm.mode = vm.ShipmentsDetails.mode;
    vm.resultId = vm.ShipmentsDetails._id;

    //ui restriction properties
    vm.showBuyRateInModal = true;
    vm.editBuyRate = true;
    vm.footerObj = {
      doneBtnDisable: false,
      buyTotalBaseCurr: 0,
      sellTotalBaseCurr: 0,
      profit: 0,
      rateExpired:false
    };
    //view exchange rate properties and functions
    vm.showExchangeRates =
      $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;
    vm.fnViewExchangeRate = fnViewExchangeRate;

    //submit functionality
    vm.submitRate = submitRate;
    vm.dataFormat = dataFormat;
    vm.updateRateStatus = updateRateStatus;
    vm.tempStatusChange = tempStatusChange;

    // Leg ui Actions
    //leg select properties
    vm.legSuggestionList = null;
    //leg select functions
    vm.fnLegNameChange = fnLegNameChange;
    vm.fnGetLegList = fnGetLegList;
    vm.fnLegSelected = fnLegSelected;
    vm.checkDuplicateLeg = checkDuplicateLeg;
    //leg delete properties
    vm.legDelete = false;
    vm.chargeDelete = false;
    //leg delete functions
    vm.fnDeleteLegConfirmation = fnDeleteLegConfirmation;
    vm.fnDeleteLeg = fnDeleteLeg;
    vm.addNewLeg = addNewLeg;
    vm.fnDeleteNewCharge =fnDeleteNewCharge;

    //Leg Calculation
    vm.changeLegCurrency = changeLegCurrency;
    vm.currencyReload = currencyReload;
    vm.l3Deleted = l3Deleted;
    vm.l3Added = l3Added;
    //Validations
    vm.fnLegValidation = fnLegValidation;
    //source download functions
    vm.sourceDownload = sourceDownload;
    vm.fnTrackAnalytics = fnTrackAnalytics;


    this.$onInit = function () {
      if(vm.action === 'Add'){
        vm.addNewLeg();
      }
      vm.leg_mode = vm.mode.includes('FCL') ? 'fcl':vm.mode.includes('LCL') ? 'lcl':'air'
      vm.l3LegCode = 'l3'+"_" + vm.leg_mode;
      vm.billing_cust_curr = vm.billingInfoData.rates[0].leg_total_currency;
      //initiate % basis meta
      basisCalculation.basisOnTotalObj = {};
      basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS] = {};
      basisCalculation.freightTotal.sellFreightTotal = null;
      basisCalculation.freightTotal.buyFreightTotal = null;

      vm.billingInfoData.rates.forEach(function (leg) {
        if ( (!leg.leg_status || leg.leg_status != "REMOVED") && leg.leg_code){
          if(leg.leg_code.includes('l3_')){
            basisCalculation.freightTotal.sellFreightTotal = leg.leg_currency_cost;
            basisCalculation.freightTotal.buyFreightTotal = leg.buy.leg_currency_cost;

          }
          leg.charges.forEach(function (charge) {
            if(!charge.buy.hasOwnProperty('total_units')){
              if(charge.charge_basis === constObj.FREIGHT_TOTAL_BASIS && leg.buy){
                charge.buy.total_units = leg.buy.leg_currency_cost;
              }else{
                charge.buy.total_units = charge.total_units;
              }
            }
            if((!charge.status || charge.status != "REMOVED") && charge.charge_basis && charge.charge_basis.includes('%')){
              basisCalculation.addCharge(leg.leg_code,charge,null,charge.charge_basis);
            }
            BillingInfoService.fnFillBasisMeta(charge,null, leg.leg_code,vm.mode);
          });
        }
      });
      BillingInfoService.fnDisplayProfit(vm.billingInfoData, vm.footerObj);
      vm.billingInfoDataCopy = angular.copy(vm.billingInfoData);
    };

    //for closing the leg dialog
    function cancelDialog() {
      vm.billingInfoData = vm.billingInfoDataCopy;
      vm.callback({item : {'billingInfoData':vm.billingInfoDataCopy}});
      $mdDialog.hide();
    }
    // get leg list using search text
    function fnGetLegList(searchText) {
      var obj = {
        mode: vm.mode,
        search: searchText,
      };
      return SearchService.getLegName(obj).then(
        function (response) {
          vm.legSuggestionList = response.data.data;
          return vm.legSuggestionList;
        },
        function (error) {
          $log.log(error);
        }
      );
    }
    //if leg is selected from suggestion
    function fnLegSelected(selectedLeg, legData) {
      if (selectedLeg == null) {
        return;
      }
      //same leg again selected
      if (selectedLeg.leg_id + "_" + vm.leg_mode === legData.leg_code) {
        return;
      }
      // find if duplicate leg selected
      var isLegPresent = checkDuplicateLeg(selectedLeg);
      if (isLegPresent) {
        document.querySelector("#" + legData.leg_code).focus(); //already commented
        angular.element("#" + legData.leg_code + "_leg").addClass("error-border");
        angular
          .element("#" + legData.leg_code + "_duplicateText")
          .addClass("error-text");
        legData.leg_name = "";
        legData.global_leg_id = "";
      } else {
        legData.leg_name = selectedLeg.leg_name;
        legData.leg_code = selectedLeg.leg_id + "_" + vm.leg_mode;
        legData.global_leg_id = selectedLeg.leg_id;
        //Checking currenct selected leg is l3
        if(selectedLeg.leg_id === 'l3'){
          vm.l3Added(legData);
         legData.charges.forEach(function(charge_data,index){
            BillingInfoService.fnFillBasisMeta(charge_data,null,legData.leg_code,vm.mode);
          })
        }else if(selectedLeg.leg_id === 'l1' || selectedLeg.leg_id === 'l5'){
         legData.charges.forEach(function(charge_data,index){
            BillingInfoService.fnFillBasisMeta(charge_data,null,legData.leg_code,vm.mode);
          });
        }
      }
    }
    //checking duplicate leg to show the error
    function checkDuplicateLeg(selectedLeg) {
      return vm.billingInfoData.rates.some(function (leg) {
        if (
          leg.leg_code == selectedLeg.leg_id + "_" + vm.leg_mode && (!leg.leg_status || leg.leg_status != "REMOVED")
        ) {
          return true;
        }
        return false;
      });
    }
    // on delete click open overlay for confirmation
    function fnDeleteLegConfirmation(legData) {
      BillingInfoService.fnCheckOverlay(); // hide overlay if available
      BillingInfoService.chargeDelete = false;
      BillingInfoService.legDelete = true;
      BillingInfoService.deleteChargeBtn = false;

      vm.deleteLegObj = legData;

      if (!legData.leg_name) {
        vm.fnDeleteLeg(legData);
      } else {
        BillingInfoService.openDeleteCard(legData.leg_code);
      }
    }
    $rootScope.$on('fnDeleteLeg', function(event, data) {
      vm.fnDeleteLeg(data);
    });
    //change status leg status to remove
    function fnDeleteLeg(legData) {
      BillingInfoService.deleteChargeBtn = true;
      if (!(legData.leg_name) || (legData.leg_status === "TEMP")) {
        var index = vm.billingInfoData.rates.findIndex(function (leg) {
          return (!leg.leg_status || leg.leg_status!= "REMOVED") && leg.leg_code === legData.leg_code;
        });
        vm.billingInfoData.rates.splice(index, 1);
        basisCalculation.deleteLeg(legData.leg_code,constObj.FREIGHT_TOTAL_BASIS);
      } else {
        legData.leg_status = "REMOVED";
        basisCalculation.deleteLeg(legData.leg_code,constObj.FREIGHT_TOTAL_BASIS);
      }
      if(legData.leg_code.includes('l3_')){
        vm.l3Deleted();
        basisCalculation.deleteLeg(legData.leg_code,constObj.FREIGHT_BASIS);
        basisCalculation.deleteParent(constObj.FREIGHT_BASIS);
        if(vm.mode === 'AIR'){
        basisCalculation.deleteLeg(legData.leg_code,constObj.AIR_FREIGHT_BASIS);
        basisCalculation.deleteParent(constObj.AIR_FREIGHT_BASIS);
        }
      }else if((legData.leg_code.includes('l2_')||legData.leg_code.includes('l4_'))&&!legData.leg_code.includes('cha')){
        basisCalculation.deleteLeg(legData.leg_code,constObj.FREIGHT_TOTAL_BASIS);
      }else if(legData.leg_code.includes('l1_')){
        basisCalculation.deleteLeg(legData.leg_code,constObj.PICKUP_BASIS)
        basisCalculation.deleteParent(constObj.PICKUP_BASIS);

      }else if(legData.leg_code.includes('l5_')){
        basisCalculation.deleteLeg(legData.leg_code,constObj.DELIVERY_BASIS)
        basisCalculation.deleteParent(constObj.DELIVERY_BASIS);
      }
      if(legData.leg_code.includes('l3_')){
        vm.l3Deleted();
      }

      BillingInfoService.fnDisplayProfit(vm.billingInfoData, vm.footerObj);
      BillingInfoService.cancelDelete(legData.leg_code);
      var isLegPresent = vm.billingInfoData.rates.some(function(leg){
        return (!leg.leg_status || leg.leg_status != "REMOVED")
      });
      if(!isLegPresent){
        vm.submitRate();
      }
    }
   
    function fnDeleteNewCharge(legCode){
      $rootScope.$emit('fnDeleteNewCharge', legCode);
    }

    //adding the empty leg
    function addNewLeg() {
      var legData = BillingInfoService.getEmptyLeg(vm.billingInfoData.rates, vm.vendorId);
      var chargeData = BillingInfoService.getEmptyCharge(legData, vm.vendorId,vm.mode);
      legData.leg_code = "lNew" + Math.floor(1000 + Math.random() * 9000) + "_" + vm.leg_mode;

      if (!vm.showBuyRateInModal) {
        delete chargeData.buy;
      }
      legData.charges.push(chargeData);
      vm.billingInfoData.rates.push(legData);
      legData.leg_code = "lNew" + Math.floor(1000 + Math.random() * 9000) + "_" + vm.leg_mode;
    }
    //do the calculations when leg currency change
    function changeLegCurrency(leg_data, action) {
      vm.currencyReload(leg_data.leg_code);
      if(action != 'fromCharge'){
        leg_data.buy.leg_currency = leg_data.leg_currency;
      }
      
        if ( (!leg_data.leg_status || leg_data.leg_status !== "REMOVED") && leg_data.leg_code){
          leg_data.charges.forEach(function (charge) {
            if((!charge.status || charge.status !== "REMOVED") && charge.charge_basis === constObj.FREIGHT_TOTAL_BASIS){
              var l3LegData = BillingInfoService.getLegData(vm.billingInfoData.rates,'l3');
              //storing converted value on total unit
              if(l3LegData){
                charge.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(l3LegData.leg_currency_cost),l3LegData.leg_currency,leg_data.leg_currency);
                charge.buy.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(l3LegData.buy.leg_currency_cost),l3LegData.leg_currency,leg_data.leg_currency);
              }
            }
          });
        }
      leg_data.charges.forEach(function (charge) {
        BillingInfoService.getChargeCost(
          charge,
          "sell",
          leg_data,
          vm.billing_cust_curr,
          vm.showBuyRateInModal,
          vm.billingInfoData,
          vm.footerObj
        );
        if (charge.buy) {
          BillingInfoService.getChargeCost(
            charge,
            "buy",
            leg_data,
            vm.billing_cust_curr,
            vm.showBuyRateInModal,
            vm.billingInfoData,
            vm.footerObj
          );
        }
      });
      if(leg_data.leg_code.includes('l3_')){
        if(vm.mode === 'AIR'){
          basisCalculation.setTotalUnitsForBasisOnCharge(constObj.AIR_FREIGHT_BASIS);
        }else{
          basisCalculation.setTotalUnitsForBasisOnCharge(constObj.FREIGHT_BASIS);
        }
      }else if(leg_data.leg_code.includes('l1_')){
        basisCalculation.setTotalUnitsForBasisOnCharge(constObj.PICKUP_BASIS);
      }else if(leg_data.leg_code.includes('l5_')){
        basisCalculation.setTotalUnitsForBasisOnCharge(constObj.DELIVERY_BASIS);
      }
      leg_data.charges.forEach(function (charge) {
        if(charge.charge_basis && charge.charge_basis.includes('%') && !charge.charge_basis.includes('total')){
        BillingInfoService.getChargeCost(
          charge,
          "sell",
          leg_data,
          vm.billing_cust_curr,
          vm.showBuyRateInModal,
          vm.billingInfoData,
          vm.footerObj
        );
        if (charge.buy) {
          BillingInfoService.getChargeCost(
            charge,
            "buy",
            leg_data,
            vm.billing_cust_curr,
            vm.showBuyRateInModal,
            vm.billingInfoData,
            vm.footerObj
          );
        }
      }
      });
      $rootScope.$emit("checkPercentageBasis");
    }
    function fnLegNameChange(legData,event){
      
      //need to do leg validation when leg name is change
      vm.fnLegValidation(legData.leg_code,event);
      //check l3 leg name updated
      // if(legData.leg_code.includes('l3')){
      //   vm.l3Deleted();
      // }else if((legData.leg_code.includes('l2')||legData.leg_code.includes('l4'))&&!legData.leg_code.includes('cha')){
      //     basisCalculation.deleteLeg(legData.leg_code);
      // }
       //check l3 leg name updated
       if(legData.leg_code.includes('l3_')){
        vm.l3Deleted();
        basisCalculation.deleteLeg(legData.leg_code,constObj.FREIGHT_BASIS);
        basisCalculation.deleteParent(constObj.FREIGHT_BASIS);
        if(vm.mode === 'AIR'){
          basisCalculation.deleteLeg(legData.leg_code,constObj.AIR_FREIGHT_BASIS);
          basisCalculation.deleteParent(constObj.AIR_FREIGHT_BASIS);
        }

      }else if((legData.leg_code.includes('l2_')||legData.leg_code.includes('l4_'))&&!legData.leg_code.includes('cha')){
        basisCalculation.deleteLeg(legData.leg_code,constObj.FREIGHT_TOTAL_BASIS);
      }else if(legData.leg_code.includes('l1_')){
        basisCalculation.deleteLeg(legData.leg_code,constObj.PICKUP_BASIS)
        basisCalculation.deleteParent(constObj.PICKUP_BASIS);

      }else if(legData.leg_code.includes('l5_')){
        basisCalculation.deleteLeg(legData.leg_code,constObj.DELIVERY_BASIS)
        basisCalculation.deleteParent(constObj.DELIVERY_BASIS);
      }
       //When leg name changed we need to defined leg code
       if(!legData.leg_code.includes('lNew')){
        var leg_number = 'lNew' + Math.floor(1000 + Math.random() * 9000) + '_' +vm.leg_mode;
        basisCalculation.changeLegcode(legData.leg_code,leg_number);
        legData.leg_code = leg_number;
        legData.global_leg_id = null;
      }
    }
    function l3Deleted(){
      // l3 is deleted so make % on total charges quantity to null because l3 is not present
      if(basisCalculation.freightTotal.sellFreightTotal !== null || basisCalculation.freightTotal.buyFreightTotal !== null){
        BillingInfoService.fnBasisOnTotalUnitUpdate(null,null,null, null,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
      }
    }
    function l3Added(l3LegData){

      //l3 doesn't contain % on total so we have to remove this leg from basisOnTotalObj
      basisCalculation.deleteLeg(vm.l3LegCode,constObj.FREIGHT_TOTAL_BASIS);
      // l3 is added so make % on total charges quantiy to l3 leg currency cost
      if(l3LegData.leg_currency_cost !== basisCalculation.freightTotal.sellFreightTotal || l3LegData.buy.leg_currency_cost !== basisCalculation.freightTotal.buyFreightTotal){
        BillingInfoService.fnBasisOnTotalUnitUpdate(l3LegData.leg_currency_cost,l3LegData.buy.leg_currency_cost,l3LegData, null,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
      }
    }
    // Error validation for leg
    function fnLegValidation(legkey, $event) {
      if ($event.keyCode != 13) {
        var key = legkey;
        angular.element("#" + key + "_text").removeClass("error-text");
        angular.element("#" + key + "_duplicateText").removeClass("error-text");
        angular.element("#" + key + "_leg").removeClass("error-border");
      }
    }
    //download source file using batchcode
    function sourceDownload(batchcode) {
      $window.open(util.sanitizeQueryParams(vm.sourceData[batchcode].sourceFileUrl));
    }
    function fnViewExchangeRate() {
      vm.util.redirectToExchangeRatesLink(
        "Shipment",
        vm.resultId,
        vm.vendorId,
        "SD-View exchange Rates",
        { Mode: vm.mode }
      );
    }
    function currencyReload(legCode){
      BillingInfoService.fnCheckOverlay(); // hide overlay if available
      document.getElementById(legCode+'_reloadCurrency').classList.remove("hide");
      $timeout(function(){
        document.getElementById(legCode+'_reloadCurrency').classList.add("hide");
      },400);
    }
    function submitRate() {
      //----------------Validation For Rates-----------------//
      var isDone = 1;
      var slabBreak = 1;
      const leg_map = {};
      var validityStatus = {};
      for (var i = 0; i < vm.billingInfoData.rates.length; i++) {
        var value = vm.billingInfoData.rates[i];
        if(value.leg_status === "REMOVED"){
          continue;
        }
        validityStatus = shareQuoteService.sellRateValidation(
          leg_map,
          value,
          value.leg_code,
          isDone
        );
        isDone = validityStatus.isDone;
        if (validityStatus.isBreak) {
          break;
        }
        for (var j = value.charges.length - 1; j >= 0; j--) {
          var charge = value.charges[j];
          if(charge.status === "REMOVED"){
            continue;
          }
          validityStatus = shareQuoteService.sellRateChargeValidation(
            value,
            charge,
            value.leg_code,
            j,
            isDone,
            slabBreak,
            vm.mode,
            value.charges
          );
          isDone = validityStatus.isDone;
          if (validityStatus.isBreak) {
            break;
          }
          if (vm.editBuyRate) {
            validityStatus = shareQuoteService.buyRateValidation(
              value,
              charge.buy,
              value.leg_code,
              j,
              isDone,
              slabBreak,
              vm.mode
            );
            isDone = validityStatus.isDone;
            if (validityStatus.isBreak) {
              break;
            }
          }
        }
        if (isDone === 0) {
          break;
        }
      }
      if (!isDone) {
        const elements = document.querySelectorAll('.error-border');
          if(elements.length){
            elements[0].scrollIntoView({ behavior: 'smooth' , block: 'center'});
        }
        return;
      }
      //----------------End of Validation For Rates-----------------//

      var custom_leg_pointer = 9;
      var custom_leg = 9;
      for (var i = 0; i < vm.billingInfoData.rates.length; i++) {
        var legdata = vm.billingInfoData.rates[i];
          //----------leg code generation for user defined charges------//
          if(legdata.leg_code && !legdata.leg_code.includes('lNew') && legdata.leg_code.match(/(\d+)/)){
            custom_leg = parseInt(legdata.leg_code.match(/(\d+)/)[0]) <= 8 ? custom_leg_pointer : parseInt(legdata.leg_code.match(/(\d+)/)[0]) + 1;
            custom_leg_pointer = custom_leg;
          }
          if(!legdata.leg_code || legdata.leg_code.includes('lNew')){
            legdata.leg_code = "l" + custom_leg + '_' + vm.ShipmentsDetails.mode.replace("SEA-", "").toLowerCase();
            custom_leg++;
            custom_leg_pointer = custom_leg;
          }
          //----------leg code generation for user defined charges------//
          vm.dataFormat(legdata);
          vm.updateRateStatus(i);
      }
      var payload = [];
      vm.tempStatusChange(payload);
      var postData = {
        'rates': payload
    };
    vm.fnTrackAnalytics("RateCard-Submit-Click",{"value":payload});
    util.isCallingApi = true;
    api.shipment.rate.update({'shipment_id':ShipmentService.shipment_id},postData,
        function(response){
            util.isCallingApi = false;
            vm.callback({item : {'billingInfoData':vm.billingInfoData}});
            $mdDialog.hide();
        },function(error){
            util.isCallingApi = false;
            $log.log(error);
            util.showToast(util.displayValidationError(error));
            vm.cancelDialog();
        });
    }
    function updateRateStatus(i){
      if (
        (!(vm.billingInfoData.rates[i].leg_status)||( vm.billingInfoData.rates[i].leg_status && vm.billingInfoData.rates[i].leg_status != "TEMP" && vm.billingInfoData.rates[i].leg_status != "REMOVED" ) )&&
        !angular.equals(vm.billingInfoData.rates[i], vm.billingInfoDataCopy.rates[i])
      ) {
        vm.billingInfoData.rates[i].leg_status = "UPDATED";
      }else{
        if(vm.billingInfoData.rates[i].leg_status === "UPDATED" || !vm.billingInfoData.rates[i].leg_status){
          vm.billingInfoData.rates[i].leg_status = "UNCHANGED"
        }
      } 
      for (var j = 0; j < vm.billingInfoData.rates[i].charges.length; j++) {
        if(vm.billingInfoData.rates[i].charges[j].status === "REMOVED" && vm.billingInfoData.rates[i].charges[j].charge_basis===constObj.AIR_FREIGHT_BASIS && vm.billingInfoData.rates[i].charges[j].total_units === null){
          vm.billingInfoData.rates[i].charges[j].total_units = 0;
          vm.billingInfoData.rates[i].charges[j].buy.total_units = 0;

        }
        if((!(vm.billingInfoData.rates[i].leg_status) || vm.billingInfoData.rates[i].leg_status != "TEMP" && vm.billingInfoData.rates[i].leg_status != "REMOVED") && !vm.billingInfoData.rates[i].charges[j].status || (vm.billingInfoData.rates[i].charges[j].status && vm.billingInfoData.rates[i].charges[j].status != "TEMP" && vm.billingInfoData.rates[i].charges[j].status != "REMOVED") ){     

        var charge = angular.copy(vm.billingInfoData.rates[i].charges[j]);
        var chargeCopy = angular.copy(vm.billingInfoDataCopy.rates[i].charges[j]); 
        if(charge && charge.buy) {
          delete charge.buy;
        }
        if(chargeCopy && chargeCopy.buy) {
          delete chargeCopy.buy;
        }
        if (
            !angular.equals(
            charge,
            chargeCopy
          )
        ) {
          vm.billingInfoData.rates[i].charges[j].status = "UPDATED";
         if( vm.billingInfoDataCopy.rates[i].charges[j].charge_cost != charge.charge_cost){
          vm.billingInfoData.rates[i].charges[j].prev_charge_cost = vm.billingInfoDataCopy.rates[i].charges[j].charge_cost;
         }
        }
        if (
            !angular.equals(
            vm.billingInfoData.rates[i].charges[j].buy,
            vm.billingInfoDataCopy.rates[i].charges[j].buy
          )
        ) {
          if( vm.billingInfoData.rates[i].charges[j].buy.charge_cost != vm.billingInfoDataCopy.rates[i].charges[j].buy.charge_cost  ){
            vm.billingInfoData.rates[i].charges[j].buy.prev_charge_cost = vm.billingInfoDataCopy.rates[i].charges[j].buy.charge_cost;
          }
          vm.billingInfoData.rates[i].charges[j].buy.status = "UPDATED";
        }
      }
    }
  }
  function dataFormat(legdata){
    for (var j = 0; j < legdata.charges.length; j++) {
      //% on basis charge quantity is null when parent is not present so we have to set % on basis charge quantity to 0 else BE will throw error
      if(legdata.charges[j].buy && legdata.charges[j].buy.total_units == null){
        legdata.charges[j].buy.total_units = 0;
      }
      if(legdata.charges[j].total_units == null){
        legdata.charges[j].total_units = 0;
      }

      if (util.isString(legdata.charges[j].charge_cost) && /^[-+]?[0-9]*\.?[0-9]+$/.test(legdata.charges[j].charge_cost)) {
        legdata.charges[j].charge_cost = Number(legdata.charges[j].charge_cost);
        legdata.charges[j].per_unit_rate = Number(legdata.charges[j].per_unit_rate);
      }

      if (vm.showBuyRateInModal && util.isString(legdata.charges[j].buy.charge_cost) && /^[-+]?[0-9]*\.?[0-9]+$/.test(legdata.charges[j].buy.charge_cost)) {
        legdata.charges[j].buy.charge_cost = Number(legdata.charges[j].buy.charge_cost);
        legdata.charges[j].buy.per_unit_rate = Number(legdata.charges[j].buy.per_unit_rate);
      }
      //For user defined charges changeSelectedCharge function not worked 
      //Added the charge_id for user defined charges 
      if(!legdata.charges[j].charge_id){
        legdata.charges[j].charge_id = 'UD'+ Math.random().toString(36).substring(2, 7).toUpperCase();
        legdata.charges[j].global_charge_id = 'UD'+ Math.random().toString(36).substring(2, 7).toUpperCase();
        legdata.charges[j].buy.charge_id = legdata.charges[j].charge_id;
      }
    }
  }

  function tempStatusChange(payload){
    vm.billingInfoData.rates.forEach(function (leg) {
      if((leg.leg_status === "NEW" && leg._id)){
        leg.leg_status = "UNCHANGED";
      }
      if (leg.leg_status === "TEMP") {
        leg.leg_status = "NEW";
      }
      leg.charges.forEach(function(charge){
        if(charge.status === "TEMP"){
          charge.status = "NEW";
          charge.buy.status = "NEW";
        }
      })
       
      if(leg.leg_status === "REMOVED"){
        var index = vm.billingInfoDataCopy.rates.findIndex(function(copyLeg){
          return copyLeg.leg_code === leg.leg_code;
        })
        if(vm.billingInfoDataCopy.rates[index].leg_status != leg.leg_status){
          payload.push(leg);
        }
      }else{
        payload.push(leg);

      }
    });
  }
  function fnTrackAnalytics(action, params){
    util.callMixpanel('SD'+'-'+action, params);
  }
}
})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .component('charge', {
        templateUrl: 'app/main/shipments/dialogs/modify-legs/charge-meta/charge.html',
        bindings: {
          legData:'=',
          footerObj:'=',
          billingInfoData:"=",
          rateVendorId:"=",
          callback : '&'
        },
        controller: chargeController
      });
      function chargeController($log, $rootScope,localStorageService,ShipmentService,util,shareQuoteService,  $filter,SearchService,BillingInfoService,QuotesService,$scope,basisCalculation,resultService, $mdPanel,constObj) {
        //local variable declaration for the service to use in templates
        var vm = this;
        vm.util = util;
        vm.constObj = constObj;

        vm.billingInfoService = BillingInfoService;
        vm._mdPanel = $mdPanel;

        //charge misc properties
        vm.currencyList = vm.util.currencyList;
        vm.basisDisableList = [constObj.FREIGHT_BASIS,constObj.PICKUP_BASIS,constObj.DELIVERY_BASIS];
        //charge misc functions
        vm.fnCheckIsNaN = fnCheckIsNaN;

        //ui restriction properties
        vm.isShowBuyCol = true;
        vm.editBuyRate = true;
        vm.showBuyRateInModal = true;
        vm.isEditCopyQuote = true;
        vm.quoteEdit = true;

        vm.vendorId = parseInt(localStorageService.get('authToken').value.vendor_id);

        //shipment details response data
        vm.ShipmentsDetails = ShipmentService.shipmentManagementObj.shipment_meta;
        vm.mode = vm.ShipmentsDetails.mode;

        vm.billing_cust_curr = null;
        vm.currency_rates = null;
        vm.billing_customer_currency = "";
        //get basis list 
        vm.viewBasis = [];
        vm.getBasisList = getBasisList;

      //Charge ui actions
        //charge select
        vm.getChargeList = getChargeList;
        vm.fnChargeSelection = fnChargeSelection;
        vm.fnChargeTextChange = fnChargeTextChange;

        //charge calculations
        vm.fnChangeBasis = fnChangeBasis;
        vm.fnGetContainerQty = fnGetContainerQty;
        vm.unitPriceChange = unitPriceChange;
        vm.unitPriceCurrencyChange = unitPriceCurrencyChange;
        vm.calculateQtyRange = calculateQtyRange;
        vm.updateBasisOnTotalObj = updateBasisOnTotalObj;
        vm.minimumChange = minimumChange;
        vm.maximumChange = maximumChange;
        //charge add and remove actions
        vm.addNewCharge = addNewCharge;
        vm.confirmDeleteCharge = confirmDeleteCharge;
        vm.fnDeleteNewCharge = fnDeleteNewCharge;
        vm.removeCharge = removeCharge;
        vm.fnOpenCommentPanel = fnOpenCommentPanel;
        //validation
        vm.fnChargeValidation = fnChargeValidation;
        vm.fnTrackAnalytics = fnTrackAnalytics;
        //% on air freight
        //constObj.AIR_FREIGHT_BASIS
        vm.basisArray = [shareQuoteService.airBasisName, shareQuoteService.pickupBasisName, shareQuoteService.deliveryBasisName, shareQuoteService.freightBasisName];
        vm.chargeArray = [shareQuoteService.airChargeId, shareQuoteService.pickupChargeId, shareQuoteService.deliveryChargeId, shareQuoteService.freightChargeId];
        vm.updatePercentageAirFreight = updatePercentageAirFreight;
        // vm.checkPercentageBasis = checkPercentageBasis;


        this.$onInit = function () {
          vm.billing_cust_curr = vm.billingInfoData.rates[0].leg_currency_cost;
          vm.billing_customer_currency = vm.billingInfoData.rates[0].leg_total_currency;
          vm.currency_rates = vm.billingInfoData.currency_conversion_rate && vm.billingInfoData.currency_conversion_rate ? vm.billingInfoData.currency_conversion_rate : [];
          vm.getBasisList();
        }
        //get Basis list 
        function getBasisList(){        
          if(!shareQuoteService.basisList[vm.ShipmentsDetails.mode]){
            shareQuoteService.fetchBasisList( vm.ShipmentsDetails.mode ).then(function(response){
              shareQuoteService.basisList[vm.ShipmentsDetails.mode] = util.removeBasis(response.data.data);
              vm.viewBasis = shareQuoteService.basisList[vm.ShipmentsDetails.mode].map(function(item){return item.basis_name})
            })
          }
          else{
            vm.viewBasis = shareQuoteService.basisList[vm.ShipmentsDetails.mode].map(function(item){return item.basis_name})
          }
        }
        function fnCheckIsNaN(charge, param){
        
        var result = '';
        if(param == 'per_unit_rate'){
          if(angular.isString(charge.per_unit_rate)){
              result = charge.per_unit_rate;
          }else{
              result =  $filter('currencyMask')(charge.per_unit_rate, 2);
          }
        }else{
          if(!charge.min_flag && angular.isString(charge.charge_cost)){
              result = charge.charge_cost;
          }else{
              result =  $filter('currencyMask')(charge.leg_currency_cost, 2);
          }
          }
        return result;
        }
        //get charge name suggestion list
        function getChargeList(searchText,legData){
          searchText = searchText;
          var global_leg_id = legData.global_leg_id ? legData.global_leg_id : ""
          var obj = {
              'mode': vm.mode,
              'leg': global_leg_id,
              "search" : searchText,
              "search_param" : vm.ShipmentsDetails
          }

          return QuotesService.getChargeName(obj).then(function(response){
            if (response.data.length){
              return response.data;
            } else {
              return [{'charge_name':searchText}];
            }

          },function(error){
              $log.log(error);
          });
        }
        function fnChargeTextChange(charge, index, legCode,event) {
          if(event.keyCode == 13){
            return;
          }
          BillingInfoService.fnCheckOverlay();
          if(vm.mode === 'SEA-FCL'){
            charge['calculated_slab'] = [] 
            charge['slab']=[];
          }
          charge.charge_category = null; 
          var parent =  basisCalculation.isParent(charge,vm.mode);
          var childBasis = null;
          if(parent){
            childBasis = basisCalculation.getChildBasis(charge,vm.mode);
            basisCalculation.deleteParentLoad(childBasis,charge.container_type);
            basisCalculation.setTotalUnitsForBasisOnCharge(childBasis); 
          }
          charge.charge_id = '';
          charge.charge_code = null;
        }
        function fnChargeSelection(selectedName, charge, legValue, index) {
          if(selectedName && (selectedName.source)){
              charge['source'] = selectedName.source;
              charge['source_data'] = selectedName.source_data;
          }
          //Pre fill not happen for LCL/AIR
          if(vm.mode === 'SEA-FCL'){
            if (selectedName != null) {
              charge.charge_name = selectedName.charge_name;
              charge.charge_id = selectedName.charge_id;
              charge.global_charge_id = selectedName.global_charge_id;
              charge.container_type = (legValue.leg_code != 'ins_'+vm.leg_mode) ? selectedName.load_code : null;
              charge.charge_basis = selectedName.charge_basis;
              charge.total_units = 0;
              charge.per_unit_rate =  selectedName.per_unit_rate ? selectedName.per_unit_rate : 0 ;
              charge.buy.per_unit_rate =  selectedName.per_unit_rate ? selectedName.per_unit_rate : 0 ;
              charge.charge_currency = selectedName.charge_currency ? selectedName.charge_currency : legValue.leg_currency;
              charge.charge_category = selectedName.charge_category;
              charge.charge_code = selectedName.charge_code;
            }
          }else{
            if(selectedName && selectedName.charge_category){
              charge.charge_category = selectedName.charge_category;
            }
            //AIR/LCL charge validation
            shareQuoteService.changeSelectedCharge(selectedName, charge, legValue, index,legValue.leg_code);
        }
        if(vm.mode === 'SEA-FCL'){
          //FCL basis change , charge validation and chargeCalculation
          vm.fnGetContainerQty(charge,index);          
        }else{
          //Air/Lcl Calculation
          BillingInfoService.getChargeCost(charge, 'sell', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
          BillingInfoService.getChargeCost(charge, 'buy', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
        }
        vm.fnChargeValidation(legValue.leg_code, index, charge ,'charge');
        vm.fnChargeValidation(legValue.leg_code, index, charge ,'buyUnit');
        vm.fnChargeValidation(legValue.leg_code, index, charge ,'sellUnit');

        }
        //quantity calculation function call on basis change and calculations for buy and sell
        function fnChangeBasis(chargeObj) {
          var airFreightCharge =  (basisCalculation.isParent(chargeObj) ) && (chargeObj.charge_basis == shareQuoteService.airBasisName);           // if air freight charge with constObj.AIR_FREIGHT_BASIS basis
          if(airFreightCharge) {
            chargeObj.total_units =  null;
            chargeObj.charge_cost = 0;
            chargeObj.leg_currency_cost = 0;
            return true;
          }
          vm.bL_value = parseInt(vm.ShipmentsDetails.load_data.load_details_value[0].bl_qty || 1);
          vm.sbL_value = vm.ShipmentsDetails.load_data.load_details_value[0].sbl_qty || 1;
          vm.equipment_value = 1;
          vm.per_container = 0;
          vm.cargoWeight=1;
          vm.per_teu=0;
          var loadTypeArr = SearchService.loadTypeArr != undefined ? SearchService.loadTypeArr : [];

          for (var i = 0; i < vm.ShipmentsDetails.load_data.load_details_value.length; i++) {
            vm.per_container += parseFloat(vm.ShipmentsDetails.load_data.load_details_value[i].qty);
            if(vm.ShipmentsDetails.load_data.load_details_value[i].type && chargeObj.charge_basis==='per teu'){
              for(var load=0;load<loadTypeArr.length;load++){
                if(loadTypeArr[load].load_code === vm.ShipmentsDetails.load_data.load_details_value[i].type){
                  vm.per_teu+=(loadTypeArr[load].teu*vm.ShipmentsDetails.load_data.load_details_value[i].qty);
                }
              }
            }
            if (chargeObj.container_type && (chargeObj.container_type == vm.ShipmentsDetails.load_data.load_details_value[i].type)) {
              vm.equipment_value = parseFloat(vm.ShipmentsDetails.load_data.load_details_value[i].qty);
              vm.cargoWeight=vm.ShipmentsDetails.load_data.load_details_value[i].load_metrics[0].weight_qty;
            }
          }

          if (chargeObj.charge_basis != 'per equipment' && chargeObj.charge_basis != 'per kg' && chargeObj.charge_basis != 'per ton' && chargeObj.charge_basis !== constObj.PICKUP_BASIS && chargeObj.charge_basis !== constObj.DELIVERY_BASIS && chargeObj.charge_basis !== constObj.FREIGHT_BASIS ) {
            chargeObj.container_type = null;
          }

          var per_WMTotal = (vm.ShipmentsDetails.mode != 'SEA-FCL') ? vm.ShipmentsDetails.load_data.load_meta.chargeable_weight : 0;
          // lcl LTL per_WM total
          if(vm.ShipmentsDetails.load_data.ltl_load_details){
            if(vm.legData.leg_code == 'l1_lcl' && vm.ShipmentsDetails.load_data.ltl_load_details.origin){
              per_WMTotal = vm.ShipmentsDetails.load_data.ltl_load_details.origin.chargeable_weight;
            }else if(vm.legData.leg_code == 'l5_lcl' && vm.ShipmentsDetails.load_data.ltl_load_details.destination){
              per_WMTotal = vm.ShipmentsDetails.load_data.ltl_load_details.destination.chargeable_weight;
            }
          }

          vm.per_container = parseFloat(vm.per_container);
          chargeObj.is_qty_editable = false;
          var pallet = vm.ShipmentsDetails.mode === 'SEA-LCL' && vm.ShipmentsDetails.load_data.load_meta.total_pallets ? vm.ShipmentsDetails.load_data.load_meta.total_pallets : 1;
          switch(chargeObj.charge_basis) {
            case "per equipment":
              chargeObj.total_units = vm.equipment_value;
              break;
            case "per ton":
                chargeObj.total_units = (vm.equipment_value*vm.cargoWeight)/1000;
                break;

            case "per kg":
                chargeObj.total_units = vm.equipment_value*vm.cargoWeight;
                break;

            case "per teu":
                chargeObj.total_units = vm.per_teu;
                break;

            case "per B/L":
              chargeObj.total_units = vm.bL_value;
              break;

            case "per shipping bill":
              chargeObj.total_units = vm.sbL_value;
              break;

            case "per container":
              chargeObj.total_units = vm.per_container;
              break;

            case "per shipping bill / per container":
              chargeObj.total_units = vm.per_container + (vm.ShipmentsDetails.load_data.load_details_value[0].sbl_qty || 1);
              if (chargeObj.charge_type === 'SLAB' && chargeObj.slab_type === 'INCREMENTAL') {
                chargeObj.total_units = chargeObj.total_units - 1;
              }
              break;

            case "volumetric_weight" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.volumetric_weight;
              break;

            case "gross_weight" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.gross_weight;
              break;

            case "chargeable_weight" :
              chargeObj.total_units =  vm.ShipmentsDetails.load_data.load_meta.chargeable_weight;
              break;

            case "chargable_weight" :
              chargeObj.total_units =  vm.ShipmentsDetails.load_data.load_meta.chargeable_weight;
              break;

            case "per_hawb" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.total_bl;
              break;

            case "per_bl" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.total_bl;
              break;

            case "per_quintal" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.calculated_weight_unit=='KGs'?vm.ShipmentsDetails.load_data.load_meta.gross_weight/100 : vm.ShipmentsDetails.load_data.load_meta.gross_weight * 10;
              break;

            case "per_ton" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.calculated_weight_unit=='KGs'?vm.ShipmentsDetails.load_data.load_meta.gross_weight / 1000 : vm.ShipmentsDetails.load_data.load_meta.gross_weight;
            break;

            case "per_doc" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.total_bl;
              break;

            case "per_kg" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.calculated_weight_unit=='KGs' ?  vm.ShipmentsDetails.load_data.load_meta.gross_weight:(vm.ShipmentsDetails.load_data.load_meta.gross_weight*1000);
              
              break;

            case "per_w/m" :
              chargeObj.total_units = per_WMTotal;
              break;

            case "per_cbm" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.volumetric_weight;
              break;

            case "per_hbl" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.total_bl;
              break;

            case "per_bl" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.total_bl;
              break;

            case "per_awb" :
              chargeObj.total_units = vm.ShipmentsDetails.load_data.load_meta.total_bl;
              break;

            case "per_lbs" :
              chargeObj.total_units =  vm.ShipmentsDetails.mode === 'SEA-LCL' ? vm.ShipmentsDetails.load_data.load_meta.chargeable_weight * 1000 * 2.2046 : vm.ShipmentsDetails.load_data.load_meta.chargeable_weight * 2.2046;
            break;

            case "per shipment":
              chargeObj.total_units = 1;
              break;

            case "flat" :
              chargeObj.total_units =  1;
              break;

            case "per_cft":
              chargeObj.total_units =  vm.ShipmentsDetails.load_data.load_meta.volumetric_weight * 35.5;
              break;

            case 'per carton':
            case 'per pallet':
            case "per belt":
            case 'per vehicle':
            case 'per shift':
            case 'per package':
            case 'per invoice':
            case 'per day':
            case 'per revalidation':
              chargeObj.total_units = 1;
            break;

            case 'per_pallet':
              chargeObj.total_units = pallet;
            break;

            case 'per_carton':
            case 'per_vehicle':
            case 'per_shift':
            case 'per_package':
            case 'per_invoice':
            case 'per_day':
            case 'per_revalidation':
              chargeObj.total_units = 1;
            break;
            case constObj.FREIGHT_TOTAL_BASIS:
              chargeObj.total_units = basisCalculation.freightTotal.sellFreightTotal;
                break;
            case constObj.PICKUP_BASIS:
              if(chargeObj.container_type || vm.mode != 'SEA-FCL'){
                chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS] && basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;                 
              }else{
                chargeObj.total_units = 1;
              }
              break;
            case constObj.DELIVERY_BASIS:
              if(chargeObj.container_type || vm.mode != 'SEA-FCL'){
                chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS] && basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;
              }else{
                chargeObj.total_units = 1;
              }
              break;
            case constObj.FREIGHT_BASIS:
              if(chargeObj.container_type){
                chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;
              }else if(vm.mode === "SEA-LCL"){
                chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;
              }else{
                chargeObj.total_units = 1;
              }
              break;
            case constObj.AIR_FREIGHT_BASIS:
                chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.AIR_FREIGHT_BASIS] && basisCalculation.basisOnTotalObj[constObj.AIR_FREIGHT_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.AIR_FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.AIR_FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.AIR_FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;
              break;
            default :
              chargeObj.total_units =  1;
          }
          if(chargeObj.charge_basis === constObj.FREIGHT_TOTAL_BASIS){
            chargeObj.buy.total_units = basisCalculation.freightTotal.buyFreightTotal;
          }
          else if(chargeObj.charge_basis && chargeObj.charge_basis.includes("%")){
            chargeObj.buy.total_units =  basisCalculation.basisOnTotalObj[chargeObj.charge_basis] && basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent && basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.buy ? basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.buy.leg_currency_cost : null;
          }
          // else if(chargeObj.charge_basis === constObj.AIR_FREIGHT_BASIS){
          //   chargeObj.buy.total_units = ( BillingInfoService.percentageCharge['AirFreight'] != null) ? BillingInfoService.percentageCharge['AirFreight'].buy.leg_currency_cost : null;
          // }
          else{
            chargeObj.buy.total_units = chargeObj.total_units;
          }
          vm.updateBasisOnTotalObj(chargeObj,vm.legData.leg_code);
        }
        function updateBasisOnTotalObj(chargeObj,legCode){
          if(chargeObj.charge_basis && chargeObj.charge_basis.includes('%')){
            basisCalculation.addCharge(legCode,chargeObj,null,chargeObj.charge_basis);
            var l3LegData = BillingInfoService.getLegData(vm.billingInfoData.rates,'l3');
            //storing converted value on total unit
            if(l3LegData && chargeObj.charge_basis == constObj.FREIGHT_TOTAL_BASIS){
              chargeObj.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(chargeObj.total_units),l3LegData.leg_currency,vm.legData.leg_currency);
              chargeObj.buy.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(chargeObj.buy.total_units),l3LegData.leg_currency,vm.legData.leg_currency);

            }
  
          }else{
            basisCalculation.removeCharge(legCode,chargeObj);
          }
            var deletedBasis = basisCalculation.removeParent(chargeObj,vm.mode);
            if(deletedBasis){
              basisCalculation.setTotalUnitsForBasisOnCharge(deletedBasis);  
            }
          
        }
        //quantity calculation based on basis
        function fnGetContainerQty(charge,index,type){
          if(!charge.charge_basis){
            return;
          }
          var getEditable= shareQuoteService.basisList[ vm.ShipmentsDetails.mode].find(function(item){return item.basis_name===charge.charge_basis});
          //dublicate validate when basis selected
          if(vm.mode === 'SEA-FCL' && charge.charge_name && index){
            resultService.checkExistingCharge(charge,index,vm.legData.charges,vm.legData.leg_code); //it's checking duplicate charge present or not.
          }
          if(type!='qty_edit'){
            vm.fnChangeBasis(charge);
          }
          if(charge.total_units){
          vm.fnChargeValidation(vm.legData.leg_code, index,charge,'quantity');
          }
          charge.is_qty_editable=getEditable.is_editable;
          BillingInfoService.getChargeCost(charge, 'sell', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
          if(charge.buy) {
            if(type === 'qty_edit'){
              charge.buy.total_units = charge.total_units;
            }
            BillingInfoService.getChargeCost(charge, 'buy', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
          }
          vm.updatePercentageAirFreight(charge);
        }
        function updatePercentageAirFreight(charge){
          // var checkCharge = BillingInfoService.fnFillBasisMeta(charge,vm.legData.leg_code);
          // if(checkCharge){
          //     vm.checkPercentageBasis();
          //     return;
          // };
            var checkCharge = BillingInfoService.fnFillBasisMeta(charge,null,vm.legData.leg_code,vm.mode);
          if(checkCharge && checkCharge.parent){
            basisCalculation.setTotalUnitsForBasisOnCharge(checkCharge.basis); 
            if(basisCalculation.basisOnTotalObj[checkCharge.basis]){
              Object.keys(basisCalculation.basisOnTotalObj[checkCharge.basis]).forEach(function(legcode) {
                if(legcode != "parent"){
                  basisCalculation.basisOnTotalObj[checkCharge.basis][legcode].forEach(function(chargeObj){
                    BillingInfoService.getChargeCost(chargeObj.sellCharge, 'buy', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
                    BillingInfoService.getChargeCost(chargeObj.sellCharge, 'sell', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
                });
              }
              });
            }
           
          }
        }
        $rootScope.$on('checkPercentageBasis', function(event, data) {
          // vm.checkPercentageBasis();
        });
        // function checkPercentageBasis(){
        //   Object.keys(basisCalculation.basisOnTotalObj[checkCharge.basis]).forEach(function(legcode) {
        //     if(legcode != "parent"){
        //       basisCalculation.basisOnTotalObj[checkCharge.basis][legcode].forEach(function(chargeObj){
        //         BillingInfoService.getChargeCost(chargeObj, 'buy', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
        //         BillingInfoService.getChargeCost(chargeObj, 'sell', vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
        //     });
        //   }
        //   });
        // }
        //buy ,sell unit change
        function unitPriceChange(charge,type){
          BillingInfoService.getChargeCost(charge, type, vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
          vm.updatePercentageAirFreight(charge);
        }
        //buy ,sell unit currency change
        function unitPriceCurrencyChange(charge,type){
          BillingInfoService.getChargeCost(charge, type, vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
          vm.updatePercentageAirFreight(charge);

          if(type == 'buy' && charge.buy.charge_currency == vm.billing_customer_currency){
            vm.legData.buy.leg_currency = angular.copy(charge.buy.charge_currency); 
            vm.callback(vm.legData);
          }
          else if(type == 'sell' && charge.charge_currency == vm.billing_customer_currency){
            vm.legData.leg_currency = angular.copy(charge.charge_currency); 
            vm.callback(vm.legData);
          }
        }
        //buy , sell minimum change
        function minimumChange(charge,type){
          BillingInfoService.getChargeCost(charge, type, vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
          vm.updatePercentageAirFreight(charge);
        }
          //buy , sell maximum change
          function maximumChange(charge,type){
            BillingInfoService.getChargeCost(charge, type, vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
            vm.updatePercentageAirFreight(charge);
          }
        
        //add new charge
        function addNewCharge(){
          var charge = BillingInfoService.getEmptyCharge(vm.legData,vm.vendorId);
          if(!vm.showBuyRateInModal){
            delete charge.buy;
          }
          vm.legData.charges.push(charge);
        }
        function confirmDeleteCharge(legCode, legData, index) {
          BillingInfoService.fnCheckOverlay(); // hide overlay if available
          BillingInfoService.chargeDelete = true;
          BillingInfoService.legDelete = false;
          BillingInfoService.deleteChargeBtn = false;
    
    
    
          vm.deleteChargeLeg = legData;
          vm.chargeIndex = index;
    
          BillingInfoService.deleteChargeLineObj = vm.deleteChargeLeg.charges[index];
          if (!(vm.deleteChargeLeg.charges[index].charge_name)) {
            vm.fnDeleteNewCharge();
          }
          else {
              BillingInfoService.openDeleteCard(legCode);
          }
        }
        $rootScope.$on('fnDeleteNewCharge', function(event, data) {
          vm.fnDeleteNewCharge(data);
        });
        // delete charge
        function fnDeleteNewCharge(legCode) {
          BillingInfoService.deleteChargeBtn = true;
          var sellObj = vm.deleteChargeLeg;
          var index = vm.chargeIndex;
          if(sellObj && index>-1){
           
            vm.removeCharge(sellObj,sellObj.charges[index],index);
            BillingInfoService.cancelDelete(legCode);
          }
        }
        //delete existing charge
        function removeCharge(sellObj,charge_data,index){
          if(charge_data.status=="TEMP"){
            var parent =  basisCalculation.isParent(sellObj.charges[index],vm.mode);
            var childBasis = null;
            if(parent){
              childBasis = basisCalculation.getChildBasis(sellObj.charges[index],vm.mode);
              basisCalculation.deleteParentLoad(childBasis,sellObj.charges[index].container_type);
              basisCalculation.setTotalUnitsForBasisOnCharge(childBasis)
            }
            if(sellObj.charges[index].charge_basis && sellObj.charges[index].charge_basis.includes("%")){
              basisCalculation.removeCharge(vm.legData.leg_code,charge_data);
            }
              vm.legData.charges.splice(index, 1);
             
          }
          else {
            var parent =  basisCalculation.isParent(sellObj.charges[index],vm.mode);
              var childBasis = null;
              if(parent){
                childBasis = basisCalculation.getChildBasis(sellObj.charges[index],vm.mode);
                basisCalculation.deleteParentLoad(childBasis,sellObj.charges[index].container_type);
                basisCalculation.setTotalUnitsForBasisOnCharge(childBasis)
              }
              if( sellObj.charges[index].charge_basis && sellObj.charges[index].charge_basis.includes("%") ){
                basisCalculation.removeCharge(vm.legData.leg_code,charge_data);
              }
              charge_data.status = "REMOVED";
              if(charge_data.buy) {
                  charge_data.buy.status = "REMOVED";
              }
              
          }
          if(!sellObj.charges.length){
            $rootScope.$emit('fnDeleteLeg', sellObj);
          }else{
            var isChargePresent = sellObj.charges.some(function(charge){
              return !charge.status || charge.status != "REMOVED";
            });
            if(!isChargePresent){
              $rootScope.$emit('fnDeleteLeg', sellObj);
            }
          }
          BillingInfoService.CalculateLegCurrencyCost(vm.legData);
          BillingInfoService.CalculateLegCurrencyCostBuy(vm.legData,vm.showBuyRateInModal);
          BillingInfoService.legCostChange(vm.legData,vm.billing_cust_curr,vm.showBuyRateInModal,vm.billingInfoData,vm.footerObj);
          BillingInfoService.fnDisplayProfit(vm.billingInfoData,vm.footerObj);
        };
        function calculateQtyRange(charge, key) {
          var unit = charge.total_units;
          if (unit >= charge.slab[key].to) {
            return (charge.slab[key].to - (charge.slab[key - 1] ? charge.slab[key - 1].to : 0));
          } else if (unit >= charge.slab[key].from) {
            return (unit - charge.slab[key].from + 1);
          } else {
            return 0;
          }
        }
        
        // Error validation for charges
      function fnChargeValidation(legCode,charge_index,charges,action){

        if((shareQuoteService.containerValidation && action == 'container' )|| vm.mode != 'SEA-FCL')
             shareQuoteService.containerValidation = false;
        if(shareQuoteService.quantityValidation && action == 'quantity')  
             shareQuoteService.quantityValidation = false;
        if(shareQuoteService.buyValidation && action == 'buyUnit') 
             shareQuoteService.buyValidation = false;
        if(shareQuoteService.sellValidation && action == 'sellUnit') 
             shareQuoteService.sellValidation = false;
        if((shareQuoteService.buyMaximumValidation && (action == 'buyMinimum' || action == 'buyMaximum')) || vm.mode == 'SEA-FCL')
             shareQuoteService.buyMaximumValidation = false;
        if((shareQuoteService.sellMaximumValidation && (action == 'sellMinimum' || action == 'sellMaximum')) || vm.mode == 'SEA-FCL')
             shareQuoteService.sellMaximumValidation = false;
        if((resultService.duplicateEquipment && action == 'basis')|| vm.mode != 'SEA-FCL')
             resultService.duplicateEquipment = false;
        if(shareQuoteService.userDefinedChargeValidation && action == 'charge')  {
         shareQuoteService.userDefinedChargeValidation = false;
        }   
        //  condition to remove background error color
        if(charges.charge_name && charges.charge_basis && !shareQuoteService.containerValidation && !shareQuoteService.quantityValidation && !shareQuoteService.buyValidation  && !shareQuoteService.buyMaximumValidation && !shareQuoteService.sellValidation && !shareQuoteService.sellMaximumValidation && !resultService.duplicateEquipment){  
          angular.element('#' + legCode + '_' + charge_index + '_row').removeClass("row-error");
          angular.element('.' + legCode + charge_index + 'remove-rates-bg').addClass("rates-bg");
        } 
       //  conditions to remove error border and error text ---start
        if( charges.charge_name && !shareQuoteService.userDefinedChargeValidation ){
           angular.element('#' + legCode + '_' + charge_index + '_charge').removeClass("error-border");
           angular.element('#' + legCode + '_' + charge_index + '_chargeError').removeClass("error-text");
           angular.element('#' + legCode + '_' + charge_index + '_duplicateCharge').removeClass("error-text");
           angular.element('#' + legCode + '_' + charge_index + '_userDefinedChargeError').removeClass("error-text");
          }
       if(charges.charge_basis){
            angular.element('#' + legCode + '_' + charge_index + '_basisError').removeClass("error-text");
            angular.element('#' + legCode + '_' + charge_index + '_chargeBasis').removeClass("error-border");
            angular.element('#' + legCode + '_' + charge_index + '_duplicateBasis').removeClass("error-text");
         }
       if((charges.container_type || (charges.charge_basis !== 'per equipment' && !charges.container_type)) && !(resultService.duplicateEquipment)) {
           angular.element('#' + legCode + '_' + charge_index + '_equipmentType').removeClass("error-border");
           angular.element('#' + legCode + '_' + charge_index + '_equipmentError').removeClass("error-text");
         }
       if(action == 'basis' || action == 'charge'){
           angular.element('#' + legCode + '_' + charge_index + '_duplicateEquipment').removeClass("error-text");
           angular.element('#' + legCode + '_' + charge_index + '_equipmentType').removeClass("error-border");
           angular.element('#' + legCode + '_' + charge_index + '_row').removeClass("row-error");
         }
      if(action == 'quantity'){
          angular.element('#' + legCode + '_' + charge_index + '_quantity').removeClass("error-border");
          angular.element('#' + legCode + '_' + charge_index + '_quantityError').removeClass("error-text");
          angular.element('#' + legCode + '_' + charge_index + '_quantityCharacter').removeClass("error-text");
         }
       if(action == 'buyUnit'){
           angular.element('#' + legCode + '_' + charge_index + '_buyUnit').removeClass("error-border");
           angular.element('#' + legCode + '_' + charge_index + '_buyUnitError').removeClass("error-text");
           angular.element('#' + legCode + '_' + charge_index + '_buyUnitCharacter').removeClass("error-text");
         }
       if(action == 'sellUnit'){
             angular.element('#' + legCode + '_' + charge_index + '_sellUnit').removeClass("error-border");
             angular.element('#' + legCode + '_' + charge_index + '_sellUnitError').removeClass("error-text");
             angular.element('#' + legCode + '_' + charge_index + '_sellUnitCharacter').removeClass("error-text");
         }
       if(action == 'buyMinimum' || action == 'buyMaximum'){
              angular.element('#' + legCode + '_' + charge_index + '_buyMaximum').removeClass("error-border");
              angular.element('#' + legCode + '_' + charge_index + '_buyMaximumError').removeClass("error-text");
              angular.element('#' + legCode + '_' + charge_index + '_buyMaximumCharacter').removeClass("error-text");
             }
       if(action == 'sellMinimum' || action == 'sellMaximum'){
           angular.element('#' + legCode + '_' + charge_index + '_sellMaximum').removeClass("error-border");
           angular.element('#' + legCode + '_' + charge_index + '_sellMaximumError').removeClass("error-text");
          //  angular.element('#' + legCode + '_' + charge_index + '_sellMaximumCharacter').removeClass("error-text");
         }
     //---End    

   }
   function fnTrackAnalytics(action, params){
    util.callMixpanel('SD'+'-'+action, params);
    }

   function fnOpenCommentPanel(ev ,selectedCharge){
      var locals = {
        chargeObj:selectedCharge,
        quoteEdit:true,
        vendor_id :vm.rateVendorId
      };
      util.fnOpenCommentPanel(ev , locals);
}
      }
    })();
(function ()
{
    'use strict';

    angular
        .module('app.pages.exchangeRates', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {

        // State
        $stateProvider.state('app.exchangeRates', {
          url      : '/exchange-rates?type?id?identity?activityid?isEfp',
          views    : {
              'content@app': {
                  templateUrl: 'app/main/pages/public-page/exchange-rates/exchange-rates.html',
                  controller : 'ExchangeRatesController as vm'
              },
              data : { pageTitle: 'Exchange-Rates' }
          },

          bodyClass: 'exchange-rates'
      })
      .state('app.webViewExchangeRates', {
        url  : '/web_view/exchange-rates?type?id?identity?activityid',
        views: {
            'main@'                             : {
              templateUrl: 'app/core/layouts/content-only.html',
              controller : 'MainController as vm'
            },
            'content@app.webViewExchangeRates': {
              templateUrl: 'app/main/pages/public-page/exchange-rates/exchange-rates.html',
              controller : 'ExchangeRatesController as vm'
            },
            data : { pageTitle: 'Exchange-Rates' }
        }
      });

    }

})();

(function(){
  'use strict';

  angular.module('app.pages.exchangeRates')
  .factory('ExchangeRatesService' , ExchangeRatesService);

  /** @ngInject */
  function ExchangeRatesService($q,$log,$mdToast,localStorageService, api, $http,$rootScope, util,efpUrl)
  {
      var ExchangeRatesService = {
         conversionRatesApi: conversionRatesApi,
         efpConversionRatesApi : efpConversionRatesApi,
         exchangeRatesApi: exchangeRatesApi
      };

      return ExchangeRatesService;


      function conversionRatesApi(data,token){

        var publicUrl = api.baseUrl + '/public/v2/conversion-rates?type='+data.type.toLowerCase()+'&id='+data.id+'&identity='+data.identity;

        if(data.activityId){
          publicUrl += '&activityId=' + data.activityId;
        }

        var settings = {
          'url': publicUrl,
          'method': 'GET',
          'headers': {
            'Authorization' : localStorageService.get('authToken')?localStorageService.get('authToken').value.access_token:'',
            'referer-domain' : $rootScope.domainData.host_name,
            'g-recaptcha-response': token
          }
        };

        return $.ajax(settings).done(function (response) {
          $log.log(response);
          return response;
        });
      }

      function efpConversionRatesApi(data){

        var publicUrl = efpUrl + '/api/efp/conversion-rates/entity?entity='+data.type.toLowerCase()+'&cardId='+data.id+'&domainSubscriberId=108';

        var settings = {
          'url': publicUrl,
          'method': 'GET',
          'headers': {
            'Authorization' : localStorageService.get('authToken')? 'Bearer '+localStorageService.get('authToken').value.access_token:'',
            'referer-domain' : $rootScope.domainData.host_name
          }
        };

        return $.ajax(settings).done(function (response) {
          $log.log(response);
          return response;
        });
      }

      function exchangeRatesApi(currency){
          var url = api.baseUrl + '/api/v2/exchange-rates?baseCurrency='+currency;
         return $http.get(url);
      }

  }

}());

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login-v2', {
            url      : '/login',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                },
                data : { pageTitle: 'Login' }
            },

            resolve : {
              LoginData : function( $stateParams ) {
                 console.log($stateParams);
                 return null;
              }
            },

            bodyClass: 'login-v2'
        })

        .state('app.login_with_uuid', {
          url      : '/access?aid',
          views    : {
              'main@': {
                  templateUrl: 'app/core/layouts/content-only.html',
                  controller : 'MainController as vm'
              },
              'content@app.login_with_uuid': {
                  templateUrl: 'app/main/pages/auth/login-v2/redirect-access.html',
                  controller : 'LoginV2Controller as vm'
              },
              data : { pageTitle: 'Login' }
          },

          resolve : {
            LoginData : function( $stateParams ,  loginSerivice , $state, util) {
              // loginSerivice.uuid = $stateParams.aid;
               return  loginSerivice.getAccessTokenByUUID($stateParams.aid).then(function(response){
                  return  response.data.data;
                }, function(err){
                  console.log(err);
                  $state.go('app.pages_auth_login-v2');  // // for login 'app.pages_auth_login-v2'
              });
            }
          },

          bodyClass: 'login-v2'
      });


        //api
        // msApiProvider.register('auth.login',['http://api.shipper.localhost/oauth/token']);


        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
        //     title : 'Login',
        //     state : 'app.pages_auth_login-v2',
        //     weight: 2
        // });
    }

})();

(function(){
    'use strict';

    angular.module('app.pages.auth.login-v2')
    .factory('loginSerivice' , loginSerivice);

    /** @ngInject */
    function loginSerivice($q,$http,$log,api,localStorageService,analytics,$location,util)
    {
        var loginservice = {
            loginUniqueDomain : loginUniqueDomain,
            isLogin : isLogin ,
            token : '',
            logout : logout,
            resetEmail : resetEmail,
            registerUser : registerUser,
            verifyOtp : verifyOtp,
            loginOtp : false,
            getOTP : getOTP,
            loginMultiDomain : loginMultiDomain,
            accountList : [],
            resendOTP : resendOTP,
            getAccessTokenByUUID : getAccessTokenByUUID,
            verifyEmailApi : verifyEmailApi,
            reset_password: false
            // isMultiDomain : false,
            // uuid : ''
        };

        return loginservice;

        //////

        /**
         * loginUniqueDomain
         *
         * @param payload
         *
         */
        function loginUniqueDomain(payload, config){

            return $http.post( api.baseUrl + '/oauth/token',payload,config);
            // .then(function(response){
            // },function(error){
            //     $log.error(error);
            // });
        }

        function resetEmail(data, config) {
          return $http.post(api.baseUrl + '/password/change', data, config);
        }

        function isLogin(){
            loginservice.token = localStorageService.get('authToken') ;
             if(loginservice.token && loginservice.token.value ){
                 var ExpiryDays =  ((new Date(loginservice.token.time + (loginservice.token.value.expires_in)*1000 ).getTime()) - (new Date().getTime()) )/(1000*60*60*24);
                 if(ExpiryDays > 0){
                    return true;
                 }else{
                    return  false;
                 }
             } else{
                 return false;
             }
        }

        function logout(isMultiDomain, uuid){
          try {
              if (window && window.productFruits) {
                window.productFruits.services.destroy()
              }
              if (window && window.dataLayer) {
                  window.dataLayer.push({
                      isProductFruitsLoaded: false
                  });
              }
          } catch (e) {
            console.error('Product Fruits logout failed', e);
          }

          //mixpanel code
            analytics.track("Logged Out");
            if(isMultiDomain) {
              return $http.delete(api.baseUrl + '/api/revoke-seesion?uuid=' + uuid);
            }
            else {
              return $http.delete(api.baseUrl + '/api/revoke-seesion');
            }
            // msNavigationService.clearNavigation();
            // localStorageService.remove('authToken'); // removing the auth token in local storage.
            // localStorageService.remove('currencyList');
        }

        function registerUser(data) {
          // Extract the captchaResponse from the data object
          var captchaResponse = data.data.captchaResponse;
          delete data.data.captchaResponse; // Remove the captcha response from the data object to avoid sending it in the body
      
          // Set up the headers
          var config = {
              headers: {
                  'Content-Type': 'application/json',
                  'g-recaptcha-response': captchaResponse // Set the captcha response header
              }
          };
      
          return $http.post(api.baseUrl + '/register-shipper', data, config);
      }

        function verifyOtp(otpData) {
          return $http.post(api.baseUrl + '/verify-shipper', otpData);
        }

        /**
         * login
         *
         * @param payload
         *
         */
        function getOTP(inputType, payload ,countryCode, config){
          if(inputType == 'mobile') {
            return $http.get(api.baseUrl + '/request-otp?mobile_number=' + payload + '&country_code=' + countryCode).then(function(response){
              return response.data;
            });
          }
          else if(inputType == 'email') {
            return $http.get(api.baseUrl + '/request-otp?email=' + payload, config).then(function(response){
            return response.data;
          });
          }
        }

        function resendOTP(otp_secret){
          return $http.get(api.baseUrl + '/resend-otp/' + otp_secret).then(function(response){
            loginservice.otp_secret = response.data.otp_secret;
            return response.data;
          });
        }

        /**
           * loginMultiDomain
         * @param {*} payload
         */

        function loginMultiDomain(payload, config){
          return $http.post(api.baseUrl + '/login', payload, config);
          // .then(function(response){
          //   loginservice.accountList = response.data.data;
          //   return loginservice.accountList;
          // });
        }

        function  getAccessTokenByUUID(uuid){
           return $http.get(api.baseUrl + '/login-uuid/' + uuid);
          //  .then(function (response){
          //    return response.data;
          //  }, function(error){
          //   $location.path('/login');
          //     $log.error(error);
          //  });

        }

        function verifyEmailApi(email, config) {
          return $http.get(api.baseUrl + '/request-otp?email='+email, config);
        }

    }

}());

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/password/reset?:token&:email',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            resolve: {
                PasswordResetData: function ($stateParams, resetService)
                {
                    resetService.token = $stateParams.token;
                    return resetService.getEmail($stateParams.token);
                }
            },
            bodyClass: 'reset-password'
        })
        // State
        $stateProvider.state('app.pages_auth_generate-password', {
            url      : '/password/generate?:token&:email',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_generate-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            resolve: {
                PasswordResetData: function ($stateParams, resetService)
                {
                    resetService.token = $stateParams.token;
                    return resetService.getEmail($stateParams.token);
                }
            },
            bodyClass: 'generate-password'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
        //     title : 'Reset Password',
        //     state : 'app.pages_auth_reset-password',
        //     weight: 6
        // });
    }

})();

(function(){
    'use strict';

    angular.module('app.pages.auth.reset-password')
    .factory('resetService' , resetService);

    /** @ngInject */
  function resetService($mdToast, $http, $log, api)
    {
      var resetservice = {
          reset : reset,
          getEmail: getEmail,
          token: '',
          email: '',
          resetPassoward: false
      };

      return resetservice;


      function reset(data) {
        return $http.post(api.baseUrl + '/password/reset', data);
      }

      function getEmail(url) {
        var link = api.baseUrl + '/reset-token/' + url;
        return $http.get(link).then(function(response){
            resetservice.email = response.data.email;
        },function(error){
            $log.error(error);
        });
      }
    }

}());

(function ()
{
    'use strict';

    angular
        .module('app.shipments', ['ngFileUpload','datatables','material.components.expansionPanels', 'ngSanitize','ngAvatar', 'ng.ckeditor','ngMaterialDateRangePicker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.shipments', {
                url    : '/shipments',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/shipments/shipments.html',
                        controller : 'ShipmentsController as vm'
                    },
                    data : { pageTitle: 'Shipments' }
                },
                // resolve: {
                //     ShipmentsData: function(ShipmentService, util, $state,analytics){
                //       //mixpanel code
                //       analytics.track("Shipments");

                //         if(!util.isFreightbro ){

                //             return ShipmentService.getShipmentList().then(function(response){
                //                 ShipmentService.shipmentList = response.data;
                //                 return ShipmentService.shipmentList;
                //             },function(error){
                //                 $state.go(util.redirectIfError(error));
                //             });
                //         }

                //         else{
                //             return [];
                //         }

                //     }
                // },
                bodyClass: 'shipments-page'
            })

            .state('app.shipments.shipment_details', {
                url  : '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/shipments/shipment_details/shipment_details.html',
                        controller : 'ShipmentsDetailsController as vm'
                    },
                    data : { pageTitle: 'Shipments' }
                },
                resolve: {

                    ShipmentDetailsData: function(ShipmentService, util, $state,$stateParams,$rootScope){
                        ShipmentService.shipment_id = $stateParams.id;
                        util.isCallingApi = true;
                        return ShipmentService.getShipmentDetails(ShipmentService.shipment_id).then(function(response){
                            $rootScope.loadingProgress = false;
                            util.isCallingApi = false;
                            return response.data.data;
                        },function(error){
                            util.isCallingApi = false;
                            $state.go(util.redirectIfError(error));
                        });
                    }
                },
                bodyClass: 'shipment-details-page'
            })

            .state('app.shared_shipment_details', {
                url  : '/uuid/:uuid/shipments/:id',
                views: {
                    'main@'                             : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.shared_shipment_details': {
                        templateUrl: 'app/main/shipments/shipment_details/shipment_details.html',
                        controller : 'ShipmentsDetailsController as vm'
                    },
                    data : { pageTitle: 'Shipments' }
                },
                resolve: {
                    ShipmentDetailsData: function ($stateParams,ShipmentService,api,apiUrl,util, $state,$rootScope)
                    {
                        //mixpanel code
                        // analytics.track("Shared Shipments");
                        ShipmentService.uuid = $stateParams.uuid;
                        ShipmentService.shipment_id = $stateParams.id;
                        api.baseMockUrl = apiUrl +'/shared/' + ShipmentService.uuid;   // to update base mock url.
                        return ShipmentService.getShipmentDetails(ShipmentService.shipment_id).then(function(response){
                            $rootScope.loadingProgress = false;
                            return response.data.data;
                        },function(error){
                            $state.go(util.redirectIfError(error));
                        });
                    }
                },
                bodyClass: 'shipment-details-page'
            })

            // Mobile app code below

            .state('app.mobile_shipment_details', {
                // SEC-3835: do not put JWT in query; prefer #token= / #access_token= (see setWebViewAuthToken).
                url  : '/shipments/:id/:web_view?user_id&permissionQuote&permissionShipment&permissionInquiry&vendor_id&expires_in&user_category&vendor_name',
                params: {
                    access_token: { value: null, squash: true, dynamic: true }
                },
                views: {
                    'main@'                             : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.mobile_shipment_details': {
                        templateUrl: 'app/main/shipments/shipment_details/shipment_details.html',
                        controller : 'ShipmentsDetailsController as vm'
                    },
                    data : { pageTitle: 'Shipments' }
                },
                resolve: {
                    ShipmentDetailsData: function ($stateParams,ShipmentService,localStorageService,util, $state, $rootScope)
                    {
                        ShipmentService.shipment_id = $stateParams.id;
                        util.setWebViewAuthToken($stateParams);
                        var auth = localStorageService.get('authToken');
                        ShipmentService.access_token = auth && auth.value ? auth.value.access_token : null;
                        return ShipmentService.getShipmentDetails(ShipmentService.shipment_id).then(function(response){
                            $rootScope.loadingProgress = false;
                            return response.data.data;
                        },function(error){
                            $state.go(util.redirectIfError(error));
                        });
                    }
                },
                bodyClass: 'shipment-details-page'
            });


        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/shipments');





        // Api
        // msApiProvider.register('shipments', ['app/data/shipments/shipments.json']);
        // msApiProvider.register('shipmentDetails', ['app/data/shipments/shipmentDetails.json']);

        // msNavigationServiceProvider.saveItem('fuse.shipments', {
        //     title    : 'Shipments',
        //     icon     : 'icon-format-list-bulleted',
        //     state    : 'app.shipments',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SHIPMENTS.SHIPMENTS_NAV',
        //     weight   : 1
        // });

    }


})();

(function () {
  "use strict";

  angular
    .module("app.shipments")
    .controller("trackingShipmentController", TrackingShipmentController);

  /** @ngInject */
  function TrackingShipmentController(
    ShipmentService,
    $sanitize,
    $log,
    util,
    api,
    $http,
    $timeout,
    $mdDialog,
    $scope,
    TrackService,
    DTOptionsBuilder,
    DTColumnBuilder,
    $compile,
    $window,
    $rootScope
  ) {
    var vm = this;
    vm.getMilestoneData = getMilestoneData;
    vm.changeWaypoints = changeWaypoints;
    vm.viewMilestone = viewMilestone;
    vm.cancelDialog = cancelDialog;
    vm.getTrackingData = getTrackingData;
    vm.trackingDetail = null;
    vm.shipTrackData = {};
    vm.getData = false;
    vm.noData = true;
    vm.showNoData = null;
    vm.fromShipmentTracking = true;
    vm.currentShipment = TrackService.currentShipment;
    vm.isMilestoneUpdate = false;
    vm.openAddMilestoneModal = openAddMilestoneModal;
    vm.submitMilestone = submitMilestone;
    vm.addMileStone = addMileStone;
    vm.updateMilestone = updateMilestone;
    vm.getMilestonesList = getMilestonesList;
    vm.getPort = util.getPorts;
    vm.getSelectedPortData = getSelectedPortData;
    vm.openEditMilestoneModal = openEditMilestoneModal;
    vm.deleteMilestone = deleteMilestone;
    vm.fnDeleteData = fnDeleteData;
    vm.openEditMilestoneModal = openEditMilestoneModal;
    vm.waypointsAvailable = true;
    vm.trackMode = ShipmentService.shipmentManagementObj.shipment_meta.mode;
    vm.formatResponse = formatResponse;
    vm.getDtColumnsData = getDtColumnsData;
    vm.trackingDataTable = trackingDataTable;
    vm.checkStatus = checkStatus;
    vm.spinRefreshIcon = false;
    vm.dtOptionsAir = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: "simple",
      autoWidth: false,
      ordering: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 30, 50, 100],
      pageLength: 5,
    };

    vm.shipmentService = ShipmentService;
    
    vm.milestoneToggle = {
      isHide:false,
      btnText:'Track and Trace'
    }

    vm.trackUrl = $rootScope.domainData.domain_info.COMPANY_TRACKING_URL;

    vm.toggleMilestoneHandler = toggleMilestoneHandler;
    vm.openTargetUrl = openTargetUrl;

    function init() {
      // NgMap.getMap({
      //   id: "my-map",
      // }).then(function (map) {
      //   vm.map = map;
      //   map.setZoom(4);
      // });
      if(ShipmentService.shipmentManagementObj.shipment_meta.mode !== "AIR"){
        vm.getMilestoneData();
      }
    }

    function toggleMilestoneHandler() {
      vm.milestoneToggle.isHide = true;
      vm.milestoneToggle.btnText = "Refresh";
      vm.trackResLoaded = false;

      // URL : /api/shipments/FWSTH3J7D/tracks
      TrackService.getAirShipmentTrackingDetail(ShipmentService.shipment_id).then(
        function (response) {
          vm.milesStone = response.data;
          vm.trackResLoaded = true;
        },
        function (error) {
          util.showToast(util.displayValidationError(error));
          vm.trackResLoaded = true;
          $log.log(error);
        }
      );
      
      
    }

    $scope.$on("tabInitEvent", function (event, data) {
      if (data == "TRACKING") {
        init();
      }
    });

    /**
     * function used to get the Deatils of Tracking of Data
     */
    function getTrackingData() {
      // util.isCallingApi=true;
      vm.currentShipment["awb_object"] = ShipmentService.shipmentManagementObj
        .shipment_meta
        ? ShipmentService.shipmentManagementObj.shipment_meta.awb_object
        : null;
      if (ShipmentService.shipmentManagementObj.shipment_meta.awb_object.mawb) {
        vm.trackAirShimmer = true;
        TrackService.getTrackingDetail(
          ShipmentService.shipmentManagementObj.shipment_meta.awb_object.mawb
        ).then(
          function (response) {
            vm.trackingDetail = response.data;
            vm.trackingStatus = vm.trackingDetail.tracking;
            vm.tracking_id = vm.trackingDetail._id;
            vm.trackAirShimmer = false;
            // util.isCallingApi=false;
          },
          function (error) {
            // util.isCallingApi=false;
            vm.trackAirShimmer = false;
            util.showToast(util.displayValidationError(error));
            $log.log(error);
          }
        );
      }
    }

    // function to open add milestone modal
    function openAddMilestoneModal(events, ev) {
      vm.isMilestoneUpdate = false;
      vm.currentEventList = events ? events : [];
      var milestones = {
        weight: {
          UOM: "KG",
        },
        time_stamp_actual: null,
        time_stamp_planned: null,
      };
      vm.milestoneData = angular.copy(milestones);
      vm.portData = [];
      $mdDialog.show({
        templateUrl:
          "app/main/track-n-trace/dialogs/add-milestone/add-milestone.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    // function to open edit milestone modal
    function openEditMilestoneModal(milestonesList, milestoneEvent, index, ev) {
      vm.portData = vm.getSelectedPortData(milestoneEvent.port_code);
      vm.isMilestoneUpdate = true;
      vm.currentEventList = milestonesList;
      milestoneEvent.time_stamp_actual = moment(
        milestoneEvent.time_stamp_actual
      ).toDate();
      milestoneEvent.time_stamp_planned = moment(
        milestoneEvent.time_stamp_planned
      ).toDate();

      vm.milestoneData = angular.copy(milestoneEvent);
      vm.editMilestoneIndex = index;
      $mdDialog.show({
        templateUrl:
          "app/main/track-n-trace/dialogs/add-milestone/add-milestone.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    //function to get port data for selected port
    function getSelectedPortData(port_code) {
      if (port_code) {
        util.getPorts(port_code, "AIR").then(
          function (response) {
            var portList = response;
            vm.portData = portList.find(function (element) {
              return element.port_code === port_code;
            });
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.portData = [];
      }
    }

    //function to submit milestone
    function submitMilestone(milestoneEvent) {
      if (vm.isMilestoneUpdate) {
        vm.updateMilestone(milestoneEvent);
      } else {
        vm.addMileStone(milestoneEvent);
      }
    }

    /**
     * functiomn to add the milestone data
     * @param {*} milestoneEvent
     */
    function addMileStone(milestoneEvent) {
      var codeData = vm.milestonesList.find(function (element) {
        return element.code === milestoneEvent.code;
      });

      if (!codeData) {
        util.showToast("Milestone Details Required!");
        return;
      }

      var milestoneData = {
        weight: {
          UOM: milestoneEvent.weight.UOM,
          value: milestoneEvent.weight.value,
        },
        code: milestoneEvent.code,
        flight_number: milestoneEvent.flight_number,
        details: milestoneEvent.details,
        code_desc: codeData.desc,
        no_of_pieces: milestoneEvent.no_of_pieces,
        port_code: vm.portData ? vm.portData.port_code : "",
        time_stamp_actual: moment(milestoneEvent.time_stamp_actual2)
          .utc()
          .toISOString(),
        time_stamp_planned: moment(milestoneEvent.time_stamp_planned2)
          .utc()
          .toISOString(),
      };

      if (!milestoneEvent._id) {
        var postData = angular.copy(vm.currentEventList);
        postData.push(milestoneData);
        var postMilestoneData = {
          data: {
            events: postData,
          },
        };
        TrackService.updateMilestones(postMilestoneData, vm.tracking_id).then(
          function (response) {
            vm.trackingDetail.events = response.data.events;
            util.showToast("Milestones Added Successfully");
            vm.cancelDialog();
          },
          function (error) {
            vm.cancelDialog();
            $log.log(error);
          }
        );
      }
    }

    /**
     * function used to get the Milestones list of data
     */
    function getMilestonesList() {
      TrackService.getMilestonesList().then(
        function (response) {
          vm.milestonesList = response.data;
          TrackService.milestonesList = angular.copy(vm.milestonesList);
        },
        function (error) {
          $log.log(error);
        }
      );
    }

    /**
     *  get the list of ports from api
     *  @param searchText
     */
    // function getPort(searchText,mode){
    //   searchText = $sanitize(searchText);
    //   // var url =  api.baseUrl + '/api/port';
    //   // var data =  {"data" :  {'mode': mode,'search_query' : searchText }};
    //   return util.getPorts(searchText, mode).then(function(response){
    //       return response.data.data.port;
    //   },function(error){
    //       $log.log(error.data);
    //       return [];
    //   });
    // }

    /**
     * function to update the milestone data
     * @param {*} milestoneEvent
     */
    function updateMilestone(milestoneEvent) {
      var codeData = vm.milestonesList.find(function (element) {
        return element.code === milestoneEvent.code;
      });
      var milestoneData = {
        weight: {
          UOM: milestoneEvent.weight.UOM,
          value: milestoneEvent.weight.value,
        },
        code: milestoneEvent.code,
        flight_number: milestoneEvent.flight_number,
        details: milestoneEvent.details,
        code_desc: codeData.desc,
        no_of_pieces: milestoneEvent.no_of_pieces,
        port_code: vm.portData ? vm.portData.port_code : "",
        time_stamp_actual: moment(milestoneEvent.time_stamp_actual2)
          .utc()
          .toISOString(),
        time_stamp_planned: moment(milestoneEvent.time_stamp_planned2)
          .utc()
          .toISOString(),
        _id: milestoneEvent._id,
      };

      var putData = vm.currentEventList;
      putData[vm.editMilestoneIndex] = milestoneData;
      var putMilestoneData = {
        data: {
          events: vm.currentEventList,
        },
      };
      TrackService.updateMilestones(putMilestoneData, vm.tracking_id).then(
        function (response) {
          vm.trackingDetail.events = response.data.events;
          util.showToast("Milestones Updated Successfully");
          vm.cancelDialog();
        },
        function (error) {
          vm.cancelDialog();
          $log.log(error);
        }
      );
    }

    /**
     * function to open confirm delete milestone modal
     * @param {*} milestonesList
     * @param {*} milestoneEvent
     * @param {*} index
     * @param {*} ev
     */
    function deleteMilestone(milestonesList, index, ev) {
      vm.deleteMilestoneList = milestonesList;
      vm.deleteIndex = index;
      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/confirm-delete/confirm-delete.html",
        targetEvent: ev,
        clickOutsideToClose: true,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    //function to delete the milestone
    function fnDeleteData() {
      var putData = angular.copy(vm.deleteMilestoneList);
      vm.deleteBtn = true;
      putData.splice(vm.deleteIndex, 1);

      var putMilestoneData = {
        data: {
          events: putData,
        },
      };
      TrackService.updateMilestones(putMilestoneData, vm.tracking_id).then(
        function (response) {
          vm.trackingDetail.events = response.data.events;
          util.showToast("Milestones Deleted Successfully");
          vm.deleteBtn = false;
          vm.cancelDialog();
        },
        function (error) {
          vm.cancelDialog();
          $log.log(error);
        }
      );
    }

    function changeWaypoints(markers, pathData, currentVessel) {
      if (!markers.length && !pathData.length) {
        vm.waypointsAvailable = false;
      } else {
        vm.waypointsAvailable = true;
      }
      vm.currentVessel = currentVessel;
      vm.markers = markers;
      vm.wayPoints = [];
      vm.pathTobeCompleted = [];
      if (pathData.length !== 0) {
        var markerList = pathData.slice();
        vm.currentMarker = markerList[markerList.length - 1];
        vm.pathTobeCompleted.push([
          vm.currentMarker.latitude,
          vm.currentMarker.longitude,
        ]);
        markerList.forEach(function (arrayItem) {
          vm.wayPoints.push([arrayItem.latitude, arrayItem.longitude]);
        });
      }

      markers.forEach(function (arrayItem) {
        if (arrayItem.key == "POD") {
          vm.pathTobeCompleted.push([arrayItem.latitude, arrayItem.longitude]);
        }
      });
    }

    function getMilestoneData() {
      vm.shipTrackData =
        ShipmentService.shipmentManagementObj.shipment_data.nav.find(function (
          item
        ) {
          return item.name == "TRACKING";
        });
      api.shipment.tracking.get(
        {
          shipment_id: ShipmentService.shipment_id,
        },
        function (response) {
          vm.getData = true;
          vm.spinRefreshIcon = false;
          if (response.status === "success") {
            vm.shipTrackData.data["tracking"].data = response.data;

            if (response.data != null && response.data.length !== 0) {
              vm.noData = false;
              vm.trackingDataTable(vm.formatResponse(response.data));
              vm.containerList =
                vm.shipTrackData.data["tracking"].data.container_shipments;
              if (vm.containerList.length > 0) {
                vm.changeWaypoints(
                  vm.containerList[0].track_markers,
                  vm.containerList[0].track_waypoints,
                  vm.containerList[0].container_shipment_id
                );
              } else {
                vm.containerList = [];
              }
            } else {
              vm.noData = true;
              vm.showNoData = response.data.message;
            }
          } else {
            vm.containerList = [];
            vm.noData = true;
          }
        },
        function (err) {
          vm.spinRefreshIcon = false;
          vm.noData = true;
          vm.getData = true;
          $log.error(err);
        }
      );
    }

    // function showMarkerDetail(event, iwDetail) {
    //   vm.iw = iwDetail.marker;
    //   vm.map.showInfoWindow('infoWindo', vm.iw.key);
    // }

    // function showCurrentMarkerDetail() {
    //   vm.map.showInfoWindow('bar');
    // }

    // function showModalMarkerDetail(event, iwDetail) {
    //   vm.iwModal = iwDetail.marker;
    //   vm.map1.showInfoWindow('cached', vm.iwModal.key);
    // }

    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: "simple",
      autoWidth: false,
      searching: false,
      targets: "no-sort",
      bSort: false,
      order: [],
      responsive: true,
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 10,
    };

    function viewMilestone(containers_index, metaData, ev) {
      // vm.milestonedata = tracks.milestones.reverse();
      // vm.milestoneMeta = tracks.container_data;
      var index = containers_index.split(",");
      var tracks = vm.containerDetailsTemp[index[0]].containers[index[1]];
      vm.milestonedata = tracks.milestones;
      vm.milestoneMeta = tracks;

      if (!vm.milestonedata.length) {
        vm.mode = "SEA";
        $mdDialog.show({
          templateUrl:
            "app/main/track-n-trace/dialogs/tracking-unavailable.html",
          targetEvent: ev,
          clickOutsideToClose: true,
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
        });
      } else {
        vm.changeWaypoints(
          tracks.track_markers,
          tracks.track_waypoints,
          tracks.container_shipment_id
        );

        // NgMap.getMap({
        //   id: "my-map-modal",
        // }).then(function (map) {
        //   vm.map1 = map;
        //   map.setZoom(4);
        // });

        $mdDialog.show({
          templateUrl: "app/main/shipments/dialogs/trackingDialog.html",
          targetEvent: ev,
          clickOutsideToClose: true,
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
        });
      }
    }

    function cancelDialog() {
      $mdDialog.hide();
    }

    function trackingDataTable(containerList) {
      vm.dtTrackingOptions = DTOptionsBuilder.newOptions()
        .withOption("data", containerList)
        .withOption("responsive", true)
        .withDOM('<"top left"f>ti<"bottom"lp><"clear">')
        .withOption("paging", false)
        .withOption("ordering", false)
        .withOption("searching", false)
        .withDisplayLength(50)
        .withPaginationType("simple")
        .withOption("createdRow", function (row, data, dataIndex) {
          if (data.row_span > 1) {
            // if grouping bl contianer apply rowspan
            var border_bottom =
              dataIndex + data.row_span >= 50 ? "border-bottom" : "";
            angular
              .element(row)
              .find("td:eq(0)")
              .attr("rowspan", data.row_span)
              .addClass("row-span-text " + border_bottom + " ");
          }
          if (data.row_span === null) {
            // if rowspan applied remove table bl column
            angular.element(row).find("td:eq(0)").addClass("td-hide");
          }
          // Recompiling so we can bind Angular directive to the DT
          $compile(angular.element(row).contents())($scope);
        });

      vm.getDtColumnsData(); //get dtcolumn data
    }

    // form dtColumns data for datatables
    function getDtColumnsData() {
      vm.dtTrackingColumns = [
        DTColumnBuilder.newColumn(null)
          .withClass("table_row border-right")
          .withOption("name", "bl_number")
          .renderWith(function (data) {
            return "<td ng-non-bindable>" + $sanitize(data.bl_number) + "</td>";
          })
          .withTitle("BL. No"),
        DTColumnBuilder.newColumn(null)
          .withClass("table_row")
          .withTitle("Container Number")
          .renderWith(function (data, type, full, meta) {
            var html =
              "<span ng-non-bindable>" +
              $sanitize(data.container_number) +
              "</span>";
            var containerRender =
              data.container_number !== null
                ? '<a class="md-link-fg" ng-class="{\'no-cursor\' : ' +
                  data.is_deleted +
                  ", 'pointer' : " +
                  !data.is_deleted +
                  ' }" ng-click="vm.viewMilestone(\'' +
                  data.container_index +
                  '\',$event);" ng-show="data.container_number !== null">' +
                  html +
                  "</a>"
                : '<p class="m-0"> - </p>';

            return (
              containerRender +
              '<p class="grey-fg font-size-12 m-0">' +
              $sanitize(data.liner_name) +
              "</p>"
            );
          }),
        DTColumnBuilder.newColumn(null)
          .withClass("table_row")
          .renderWith(function (data) {
            return (
              "<td ng-non-bindable>" + $sanitize(data.current_status) + "</td>"
            );
          })
          .withTitle("Current status"),
        DTColumnBuilder.newColumn(null)
          .withClass("table_row")
          .renderWith(function (data) {
            return "<td ng-non-bindable>" + $sanitize(data.POL) + "</td>";
          })
          .withTitle("POL"),
        DTColumnBuilder.newColumn(null)
          .withClass("table_row")
          .renderWith(function (data) {
            return "<td ng-non-bindable>" + $sanitize(data.POD) + "</td>";
          })
          .withTitle("POD"),
        //DTColumnBuilder.newColumn('ETA').withClass('table_row').withTitle('ETA'),
        DTColumnBuilder.newColumn(null)
          .withClass("table_row")
          .withTitle("Updated On")
          .renderWith(function (data) {
            return (
              "<td ng-non-bindable>" + $sanitize(data.updated_at) + "</td>"
            );
          })
          .withOption("name", "updated_at"),

        DTColumnBuilder.newColumn(null)
          .withClass("table_row")
          .withTitle("Status")
          .renderWith(function (data, type, full, meta) {
            var html =
              "<span ng-non-bindable>" + $sanitize(data.status) + "</span>";
            return (
              "<span ng-class=\"vm.checkStatus('" +
              data.status +
              "','" +
              data.is_deleted +
              "');\"><md-icon ng-class=\"vm.checkStatus('" +
              data.status +
              "','" +
              data.is_deleted +
              '\');" class="icon bullet-icon" md-font-icon="icon-checkbox-blank-circle" aria-label="icon-checkbox-blank-circle"> </md-icon>' +
              (data.is_deleted == true
                ? "Archived"
                : !data.status
                ? "Not Available"
                : html) +
              "</span>"
            );
          }),
      ];
      vm.dtTrackingInstanceCallback = {};
    }

    //form response with table structure
    function formatResponse(res_data) {
      vm.containerDetailsTemp = res_data;
      var new_res = [];
      var row_obj = {
        bl_number: "",
        liner_name: "",
        container_number: "",
        current_status: "",
        POD: "",
        POL: "",
        ETA: "",
        updated_at: "",
        milestone: "",
        milestone_message: "",
        status: "",
        subscription_id: "",
        container_index: "",
        is_deleted: "",
        row_span: null,
      };
      if (res_data === null) {
        return row_obj;
      }
      res_data.forEach(function (row, containers_index) {
        row.containers.forEach(function (container, index) {
          var new_row = angular.copy(row_obj);
          new_row.bl_number = row.bl_number ? row.bl_number : "-";
          new_row.container_number = container.container_shipment_id;
          new_row.liner_name = container.request_carrier_name;
          new_row.current_status = container.current_milestone.name
            ? container.current_milestone.name
            : "-";
          new_row.POL = container.pol_loc.name ? container.pol_loc.name : "N/A";
          new_row.POD = container.pod_loc.name ? container.pod_loc.name : "N/A";
          new_row.ETA =
            container.pod_vslarrival_planned_last !== null
              ? moment
                  .utc(new Date(container.pod_vslarrival_planned_last))
                  .format("DD MMM YYYY")
              : "N/A";
          new_row.updated_at = moment
            .utc(new Date(container.modified))
            .format("DD MMM YYYY");
          new_row.milestone = container.current_milestone
            ? container.current_milestone.location_name
            : "N/A";
          new_row.milestone_message = container.current_milestone
            ? container.current_milestone.name
            : "N/A";
          new_row.status = container.tracking;
          new_row.subscription_id = container.subscription_id;
          new_row.container_index = [containers_index, index];
          new_row.is_deleted = container.is_deleted;
          new_row.row_span = index === 0 ? row.containers.length : null;
          new_res.push(new_row);
        });
      });
      return new_res;
    }

    function checkStatus(statusColor, isDeleted) {
      var statusColor;
      if (isDeleted == true) {
        statusColor = "grey-fg";
      } else {
        switch (statusColor) {
          case "Fetching":
            statusColor = "orange-700-fg";
            break;

          case "Available":
            statusColor = "green-fg";
            break;

          case "Not Available":
            statusColor = "red-fg";
            break;

          case "Completed":
            statusColor = "md-primary-fg";
            break;

          case "Archived":
            statusColor = "grey-fg";
            break;

          default:
            statusColor = "red-fg";
        }
      }
      return statusColor;
    }

    function openTargetUrl(redirect_url) {
      $window.open(redirect_url, '_blank');
    }
  }
})();



(function () {
    'use strict';

    angular
        .module('app.shipments')
        .controller('shipmentdetailsShipmentController', DetailsShipmentController);

    /** @ngInject */
    function DetailsShipmentController(ShipmentService, $log, $scope, $element, util,api,$timeout,$mdDialog, SearchService, $sanitize, $rootScope, appCache, $filter,$state, resultService,shareQuoteService, $mdPanel,$rootElement, localStorageService) {

        var vm = this;
        vm.util = util;
        vm.deleteType="";
        vm._mdPanel = $mdPanel;
        vm.isSharedshipment = util.isSharedPage();
        vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER)
        vm.sharedMaskLiner=($rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER && util.isSharedPage())

        vm.getData = false;
        vm.showLoad = false;

        vm.disableLoadUpdate = false;
        vm.searchPartyData = null;
        if(!Object.keys($rootScope.domainData.domain_info).length){
            util.getDomainData().then(function(response){
              vm.shipmentEdit = $rootScope.domainData.domain_info.SHIPMENT_POL_POD_EDIT;
            },function(error){
                $log.log(error.data);
            });
          }else{
              vm.shipmentEdit = $rootScope.domainData.domain_info.SHIPMENT_POL_POD_EDIT;
        }
        vm.fnOpenScheduleEdit = fnOpenScheduleEdit;
        vm.fnOpenNewPartyModal = fnOpenNewPartyModal;
        vm.fnOpenAddtionalService = fnOpenAddtionalService;
        vm.fnOpenCommodityModal = fnOpenCommodityModal;
        vm.fnOpenSelectScheduleModal = fnOpenSelectScheduleModal;
        vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
        vm.cancelDialog = cancelDialog;
        vm.duplicateLoad = duplicateLoad;
        vm.fnSaveLoad = fnSaveLoad;
        vm.fnDeleteData = fnDeleteData;
        vm.saveCommodity = saveCommodity;
        vm.shipment_meta = ShipmentService.shipmentManagementObj.shipment_meta;
        vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
        vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
        vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';

        vm.saveScheduleTrack = saveScheduleTrack;
        vm.fnSaveParty = fnSaveParty;
        vm.fnChangeCargoType = fnChangeCargoType;
        vm.ifCategoryAdd = ifCategoryAdd;
        vm.getPartyStatus = getPartyStatus;
        vm.getPartyStatusDisplay = getPartyStatusDisplay;
        vm.fnGetSchedule = fnGetSchedule;
        vm.getLoad = getLoad;
        vm.getCommodity = getCommodity;
        vm.getParties = getParties;
        vm.getUserRoles = getUserRoles;
        vm.fnDisplayUser = fnDisplayUser;
        vm.selectUser = [];
        vm.isObjectEmpty = isObjectEmpty;
        // vm.showAlert = showAlert;
        vm.fnDeleteCommodity = fnDeleteCommodity;
        vm.selectedSchedule = selectedSchedule;
        vm.viewScheduleList = [];
        vm.current_schedule = {};
        vm.setCurrentSchedule = setCurrentSchedule;
        vm.indexCommodity = '';
        vm.getPort = util.getPorts;
        vm.getScheduleList = getScheduleList;
        vm.formContainerType = formContainerType;
        vm.getCommodityList = getCommodityList;
        vm.loadFilter = loadFilter;
        vm.addNewLoad = addNewLoad;
        vm.saveLoad = saveLoad;
        vm.getCompanyList = ShipmentService.getCompanyList;
        vm.setPartyDetails = ShipmentService.setPartyDetails;
        vm.partyTypes = ShipmentService.partyTypes;
        vm.restPartyObj = restPartyObj;
        vm.fnGetCargoTypeList = fnGetCargoTypeList;
        vm.trackEvent = trackEvent;
        vm.cargoTypeList = [];
        vm.IMCO_CodeList = util.imcoCodeList();
        vm.isWebView = util.isWebView();
        vm.shipDetailsData = {};
        vm.schedule = null;
        vm.commodity = {};
        vm.load_data = null;
        vm.allSchedule = [];

        vm.fnCopyID = fnCopyID;
        vm.isIdCopied = 'Click to Copy';

        vm.userRoles = [];
        vm.permission = {
            "schedule" : [],
            "load" : [],
            "commodity" :[],
            "parties" : []
        };

        vm.partyView = {
            "shipper" : false,
            "consignee" : false,
            "consignor" : false,
            "notifyParty" : false,
            "cha" : false
        };

        vm.emptyLoad = {
          "bl_qty": "1",
          "load_metrics": [{
            "volume_qty": 0,
            "volume_unit": "CBM",
            "weight_qty": 0,
            "weight_unit": "KGS"
          }],
          "qty": "1",
          "sbl_qty": 1,
          "type": ""
        };

        vm.fnOpenReferencesModal = fnOpenReferencesModal;
        vm.fnAddReference = fnAddReference;
        vm.fnRemoveReference = fnRemoveReference;
        vm.closeReferencesModal = closeReferencesModal;
        vm.newReference = {
          reference_label: '',
          reference_value: '',
          comment: ''
        };

        // airschedule
        vm.removeViaPort = removeViaPort;
        vm.daysOfService = [
          "Mon","Tue","Wed","Thu","Fri","Sat","Sun"
        ];
        vm.fnOpenAirSchedule = fnOpenAirSchedule;
        vm.fnClickNonStop = fnClickNonStop;
        vm.fnSaveAirSchedule = fnSaveAirSchedule;
        vm.addViaPort = addViaPort;
        vm.fnLclLoadDetails = fnLclLoadDetails;
        vm.fnViewInquiryDetails = fnViewInquiryDetails;
        vm.fnViewQuoteDetails = fnViewQuoteDetails;
        vm.hasPackageTypes = hasPackageTypes;

        //feed variables
        vm.postText = "";
        vm.send_notification = false;
        vm.shipDetailsFeedData = {};
        vm.feedData = {};
        vm.statusData = {};
        vm.getFeeds = getFeeds;
        vm.getStatus = getStatus;
        vm.init = init;
        vm.initialApiDataCalls = initialApiDataCalls;
        vm.permission = {
            "activity_feed" : [],
            "status" : []
        };
        vm.taToolbar = [
            ['quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink']
        ];
        vm.fnSubmitPost = fnSubmitPost;
        vm.userData = {};
        vm.getProfileData = getProfileData;
        vm.getProfileData();
        vm.toggleButton = toggleButton;
        vm.showLoadDetailPanel = showLoadDetailPanel;
        vm.fnCargoChange = fnCargoChange;
        vm.spinRefreshIcon = false;
        vm.measurementSystem = $rootScope.metric_system;

        CKEDITOR.config.image_previewText = CKEDITOR.tools.repeat( ' ', 1 );
        vm.shipmentUpdatesEditorConfig = angular.copy(vm.util.ckEditorConfig);
        vm.shipmentUpdatesEditorConfig.removeButtons = 'About,Image,Styles,Format';
        vm.lastScheduleTrackId = 0;
        vm.showShippersInParties = $rootScope.domainData && $rootScope.domainData.domain_info.ALLOW_SHIPPER_PARTY_IN_BOOKING_PAGE ;
        $scope.$on('tabInitEvent',function(event,data){
          if(data == 'BOOKING DETAILS'){
              vm.init();
          }
        })
        $rootScope.$on('getFeeds',function(){
          vm.getFeeds();
        })

        $rootScope.$on('getScheduleList',function(){
          vm.getScheduleList();
        })

        //method to get all the modules data on page Load
        function init(){
            vm.shipDetailsData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
                return item.name == "BOOKING DETAILS";
            });
            if(vm.shipDetailsData){
              vm.fnGetSchedule();
              vm.getLoad();
              vm.getCommodity();
              vm.getParties();
              vm.getUserRoles();
              vm.getScheduleList();
            }


          if (SearchService.loadTypeArr == undefined || SearchService.loadTypeArr.length == 0) {
            SearchService.getAllLoadList().then(function (response) {
              SearchService.loadTypeArr = response;
              vm.loadTypeArr = response;
              util.limitObj = response;
            }, function (error) {
              $log.log(error.data);
            });
          } else {
            vm.loadTypeArr = SearchService.loadTypeArr != undefined ? SearchService.loadTypeArr : [];
          }

          //feed init
          vm.initialApiDataCalls();

        }
        init();

        function saveLoad() {
          // console.log(vm.load_data.load_details_value);
        }

        function fnCopyID(copyedText){
          util.callMixpanel('SD-BookingId-Copy-Click');
          vm.isIdCopied = 'Copied!'
          var temp_input = $("<input>");
          $("body").append(temp_input);
          temp_input.id = 'tempCopyToClipboard';
          temp_input.val(copyedText).select();
          document.execCommand("copy");
          temp_input.remove();
          $timeout(function ()
          {
              vm.isIdCopied = 'Click to Copy';
          }, 1500);
        }

        function addNewLoad() {
          if (vm.load_data.load_details_value.length < vm.loadTypeArr.length) {
            vm.load_data.load_details_value.push(angular.copy(vm.emptyLoad));
          } else {
            util.showToast('No more load type to add!');
            return;
          }

        }
        function  trackEvent(category,label,value,type){
          if(!type){
            category=category.toLowerCase();
            category = (category == 'notify_party') ? 'notify party':category;

            if(label != 'Expand'){

              var string='POP-'+label;
            }
            else{
              string=label+'-Change';
            }

            if(category == 'shipper' || category == 'consignee' || category == 'notify party' || category == 'cha' || category == 'shippers'){
              util.callMixpanel("SD-"+category+"-"+string , {
                "Mode": vm.shipment_meta.mode,
                "Type":vm.editPartyModalTitle
              });
            }
          }
          else{
            util.callMixpanel(type,{
              "Mode":vm.shipment_meta.mode,
              "Type":vm.scheduleModalTitle,
              "value": value
            });
          }
          }
        function loadFilter(e) {
          var found = false;
          vm.load_data.load_details_value.some(function (i) {
            if (i.type === e.load_code) {
              found = true
              return true;
            }
          });

          if (found) {
            return false;
          } else {
            return true;
          }
        }

        $scope.$on('addParty',function(event,item, index, title, category){
            vm.fnOpenNewPartyModal(item, index, title, category);
        })

        function fnGetSchedule(){
            vm.permission.schedule = util.splitIntoArray(vm.shipDetailsData.data["schedule"].permission);
            vm.scheduleUrl = vm.shipDetailsData.data["schedule"].url;
            if(vm.permission.schedule[1]){
                api.shipment.schedule.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["schedule"].data = response.data;
                        vm.schedule = vm.shipDetailsData.data["schedule"].data;
                        vm.getData = true;
                        // storing schedule last track id on init
                        vm.lastScheduleTrackId = vm.schedule && vm.schedule.schedule_track && vm.schedule.schedule_track.length > 0 ? vm.schedule.schedule_track[vm.schedule.schedule_track.length - 1].id : 0;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }else{
                vm.getData = true;
            }
        }

        function getLoad(){
            vm.load_dataUrl = vm.shipDetailsData.data["load_data"].url;
            vm.permission.load = util.splitIntoArray(vm.shipDetailsData.data["load_data"].permission);
            if(vm.permission.load[1]){
                api.shipment.load_data.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["load_data"].data = response.data;
                        vm.load_data = angular.copy(vm.shipDetailsData.data["load_data"].data);
                        if(!util.limitObj.length){
                          SearchService.getAllLoadList().then(function(response){
                            util.limitObj = response;
                            vm.load_data.load_details_value = angular.copy(util.addLoadMaxKey(vm.load_data.load_details_value));
                            vm.showLoad = true;
                          },function(error){
                            util.limitObj = [];
                            vm.showLoad = true;
                          });
                        }else{
                          vm.load_data.load_details_value = angular.copy(util.addLoadMaxKey(vm.load_data.load_details_value));
                          vm.showLoad = true;
                        }
                        // to display lcl ltl load details
                        if(vm.shipment_meta.mode == 'SEA-LCL'){
                          vm.lclLoadArray = vm.fnLclLoadDetails(vm.load_data);
                        }else if(vm.shipment_meta.mode == 'AIR'){
                          vm.formContainerType(vm.shipment_meta.mode, vm.load_data, 'shipment' )
                        }
                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }else{
                vm.getData = true;
            }
        }

        /**
         * function to form load details
         * @param {*} loadDetails
         */
        function formContainerType(mode, load_data, page){
            vm.loadDispaly = '';
            if(load_data != null){
                var result = util.formAirLoadDetails(load_data, mode, page);
                vm.loadDispaly = result;
            }
            // return result;
        }

        function getCommodity(){
            vm.commodityUrl = vm.shipDetailsData.data["commodity"].url;
            vm.permission.commodity = util.splitIntoArray(vm.shipDetailsData.data["commodity"].permission);
            if(vm.permission.commodity[1]){
                api.shipment.commodity.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["commodity"].data = response.data;
                        vm.commodity = vm.shipDetailsData.data["commodity"].data;
                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }else{
                vm.getData = true;
            }
        }

        function getParties(){
            vm.partiesUrl = vm.shipDetailsData.data["parties"].url;
            vm.permission.parties = util.splitIntoArray(vm.shipDetailsData.data["parties"].permission);
            if(vm.permission.parties[1]){
                api.shipment.parties.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["parties"].data = response.data;
                        vm.parties = vm.shipDetailsData.data["parties"].data;
                        vm.ifCategoryAdd();
                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }else{
                vm.getData = true;
            }
        }

        function getUserRoles(){
            if(!util.isSharedPage()){
                api.shipment.userRoles.get({},function(response){
                    try{
                        vm.userRoles = response.data;

                        // AM : SUP-327
                        vm.userRoles = vm.userRoles.filter(function(item) {
                          return item.module_code != 'SHIPMENT_PRODUCT';
                        });

                    }catch(e){
                        $log.error(e);
                    }
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                })
            }
        }

        function isObjectEmpty(carr_schedule){
            return util.isObjectEmpty(carr_schedule);
         }

        function ifCategoryAdd(){
            vm.partyView.shipper = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "shipper"; });
            vm.partyView.consignee = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "consignee"; });
            vm.partyView.consignor = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "consignor"; });
            vm.partyView.notifyParty = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "notify_party"; });
            vm.partyView.cha = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "cha"; });
            vm.partyView.shippers = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "shippers"; });
        }

        function duplicateLoad(load,index){
            var matrixLoad = angular.copy(load);
            delete matrixLoad["_id"];
            vm.load_data.load_details_value[index].load_metrics.push(matrixLoad);
            vm.load_data.load_details_value[index].qty = parseInt(vm.load_data.load_details_value[index].qty) + 1;
        }

        function fnSaveLoad(loadObj) {
          if(vm.shipment_meta.mode == 'SEA-FCL') {
            for (var i = 0; i < loadObj.load_details_value.length; i++) {
              for (var j = 0; j < loadObj.load_details_value[i].load_metrics.length; j++) {
                var item = loadObj.load_details_value[i].load_metrics[j];
                if (!loadObj.load_details_value[i].type && loadObj.load_details_value[i].type === ""){
                  util.showToast("Don't leave load type empty.");
                  return true;
                }

                if (item.volume_unit == 'CBM' && item.max_volume_cbm != null && item.volume_qty > parseFloat(item.max_volume_cbm)) {
                  document.getElementById(loadObj.load_details_value[i].type + '_volume_qty_' + (j + 1)).focus();
                  util.showToast(loadObj.load_details_value[i].type + " load volume should be less than " + item.max_volume_cbm, "top right", 2000);
                  return true;
                }
                else if (item.volume_unit == 'CFT' && item.max_volume_cft != null && item.volume_qty > parseFloat(item.max_volume_cft)) {
                  document.getElementById(loadObj.load_details_value[i].type + '_volume_qty_' + (j + 1)).focus();
                  util.showToast(loadObj.load_details_value[i].type + " load volume should be less than " + item.max_volume_cft, "top right", 2000);
                  return true;
                }
                else if (item.weight_unit == 'TON' && item.max_weight_ton != null && item.weight_qty > parseFloat(item.max_weight_ton)) {
                  document.getElementById(loadObj.load_details_value[i].type + '_weight_qty_' + (j + 1)).focus();
                  util.showToast(loadObj.load_details_value[i].type + " load weight should be less than " + item.max_weight_ton, "top right", 2000);
                  return true;
                }
                else if (item.weight_unit == 'KGS' && item.max_weight_kgs != null && item.weight_qty > parseFloat(item.max_weight_kgs)) {
                  document.getElementById(loadObj.load_details_value[i].type + '_weight_qty_' + (j + 1)).focus();
                  util.showToast(loadObj.load_details_value[i].type + " load weight should be less than " + item.max_weight_kgs, "top right", 2000);
                  return true;
                }
              }
            }
            loadObj = util.fnRemoveMaxKey(loadObj);

            var postData = {
              "data":{
                  "load_details_value" : loadObj.load_details_value,
                  "load_type" : loadObj.load_type
              }
            };
          }
          else{
            var postData = {
                "data":{
                    "load_details_value" : loadObj.load_details_value,
                    "load_meta" : loadObj.load_meta,
                    "load_type" : loadObj.load_type
                }
            };
          }
          vm.disableLoadUpdate = true;
          api.shipment.load_data.update({'shipment_id':ShipmentService.shipment_id,'id' : loadObj._id},postData,function(response){
              try{
                  vm.shipDetailsData.data["load_data"].data = angular.copy(response.data);
                  vm.load_data = angular.copy(response.data);
                  $scope.$emit('updateLoad', { load : vm.load_data });  // call shipment function to refresh load view
                  ShipmentService.isLoadChanged = true;
              }catch(e){
                  $log.error(e);
              }
              // to display lcl ltl load details
              if(vm.shipment_meta.mode == 'SEA-LCL'){
                vm.lclLoadArray = vm.fnLclLoadDetails(vm.load_data);
              }
              else if(vm.shipment_meta.mode == 'AIR'){
                vm.formContainerType(vm.shipment_meta.mode, vm.load_data, 'shipment' )
              }
              if(vm.shipment_meta.mode == 'SEA-FCL'){
              $rootScope.$broadcast('initShipmentMeta');
              }
              util.showToast("Load details updated successfully.");
              ShipmentService.shipmentManagementObj.shipment_meta.load_data.load_details_value = loadObj.load_details_value;
              vm.disableLoadUpdate = false;

          },function(err) {
              $log.log(err);
              vm.disableLoadUpdate = false;
              vm.deleteBtn = false;
              vm.load_data = angular.copy(vm.shipDetailsData.data["load_data"].data);
              util.showToast(util.displayValidationError(err));
          });
        }


         // ******* end load Details action ***********

        function getScheduleList(){
            if(vm.permission.schedule[0] || vm.permission.schedule[2]){
                api.shipment.scheduleList.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.viewScheduleList = response.data;
                    }catch(e){
                        $log.error(e);
                    }
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }else{
                vm.viewScheduleList = [];
            }
        }

        function fnOpenSelectScheduleModal(ev){
            vm.scheduleBtn = false;
            $timeout(function () {
                vm.current_schedule = vm.schedule ? vm.viewScheduleList[0] : null;
                vm.selectedIndex = 1;
                vm.ratesVisible = false;
                vm.scheduleVisible = true;
                $mdDialog.show({
                    templateUrl        : 'app/main/shipments/dialogs/schedule-select/schedule-select.html',
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    controllerAs: 'ctrl',
                    controller: function() { this.parent = vm }
                });
            }, 100, false);
        }

        function selectedSchedule(scheduleObj){
            util.callMixpanel("SD-NewSchedule-SelectScheduleButton-Click",{
              "Mode":vm.shipment_meta.mode
            });
            vm.scheduleBtn = true;
            var tempScheduleObj = angular.copy(scheduleObj);
            delete tempScheduleObj['_id'];
            var postData = {
                "data" : tempScheduleObj
            };

            if(!vm.schedule){
              api.shipment.schedule.save({'shipment_id':ShipmentService.shipment_id}, postData,
                  function(response){
                    if(response.status === 'success') {
                      vm.schedule = response.data;
                      util.showToast("Schedule leg added successfully.");
                    }
                    vm.trackBtn = false;
                    $mdDialog.hide();
                  },function(err){
                    $log.log(err);
                    util.showToast(util.displayValidationError(err));
                    vm.trackBtn = false;
              });
            }
            else{
            api.shipment.schedule.update({'shipment_id':ShipmentService.shipment_id,'id':vm.schedule._id}, postData,
                function(){
                    var prevScheduleID = angular.copy(vm.schedule._id);
                    vm.schedule = angular.copy(scheduleObj);
                    vm.schedule._id = prevScheduleID;
                    util.showToast('schedule updated successfully.');
                    $mdDialog.hide();
                    vm.scheduleBtn = false;
                },function(err){
                    $log.log(err);
                    // util.showToast(error.message);
                    util.showToast(util.displayValidationError(err));
                    vm.scheduleBtn = false;
                    // $mdDialog.hide();
            });
          }

            $mdDialog.hide();
        }

        function setCurrentSchedule(current_schedule){
          util.callMixpanel("SD-NewSchedule-ScheduleListingCard-Click",{
               "Mode":vm.shipment_meta.mode,
               "CardIndex":current_schedule._id
          });
            vm.current_schedule = current_schedule;
            // vm.current_schedule_index =  index;
        }

        function fnOpenScheduleEdit(item, index, title, ev){
          vm.locationValidation=false;
          vm.serviceValidation=false;
          vm.vesselValidation=false;
          vm.departureValidation=false;
          vm.arrivalValidation=false;
          vm.scheduleModalTitle = title;
          vm.scheduleTrackIndex = index;
          vm.trackBtn = false;
          vm.scheduleExpiryMin = new Date();

            if(item.vgm_cutoff === 'Invalid date') {
              item.vgm_cutoff = null;
            }
            if(item.port_cutoff === 'Invalid date') {
              item.port_cutoff = null;
            }

            if(vm.scheduleModalTitle =='Add' || vm.scheduleModalTitle =='Add New'){
              vm.trackPort = null;
              vm.trackText = '';
              vm.edit_schedule_track = {
                  "port_code": null,
                  "port_name": null,
                  "departure_time": null,
                  "arrival_time": null,
                  "vgm_cutoff": null,
                  "port_cutoff": null,
                  "service_name": null,
                  "terminal": null,
                  "vessel": null,
                  "voyage": null,
                  "transit_time": null,
                  "voyage_local": null,
                  "mode": vm.shipment_meta.mode
              };
            }else{
              util.callMixpanel("SD-EditScheduleTrack-Click",{
                "Mode":vm.shipment_meta.mode
               });
                vm.edit_schedule_track = angular.copy(item);

                // vm.edit_schedule_track.departure_time =  moment(vm.edit_schedule_track.departure_time).toDate(); // new Date(moment.utc(vm.edit_schedule_track.departure_time).local());
                // vm.edit_schedule_track.arrival_time =  moment(vm.edit_schedule_track.arrival_time).toDate(); //new Date(moment.utc(vm.edit_schedule_track.arrival_time).local());

                // vm.edit_schedule_track.vgm_cutoff !== null ?  moment(vm.edit_schedule_track.vgm_cutoff).toDate() : null;

                // vm.edit_schedule_track.port_cutoff !== null ? moment(vm.edit_schedule_track.port_cutoff).toDate() : null;

                vm.track_id = vm.edit_schedule_track.id;
                delete vm.edit_schedule_track["id"];
            }

            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/schedule-edit/schedule-edit.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        function fnOpenAirSchedule(item, index, title, ev, mode){
          vm.scheduleModalTitle = title;
          vm.scheduleTrackIndex = index;
          vm.mode = mode;
          vm.trackBtn = false;
          vm.originDeparture = null;
          vm.destinationArrival =  null;

          if(vm.scheduleModalTitle == 'Add New'){
            util.callMixpanel("SD-AddAirSchedule-Click",{
              "Mode":vm.shipment_meta.mode
            });
              vm.viaPort = null;
              vm.viaSearchText = '';
              vm.edit_schedule_track = {
                "is_custom": true,
                "origin_port": vm.shipment_meta.pol.port_code,
                "origin_port_name": vm.shipment_meta.pol.name,
                "destination_port": vm.shipment_meta.pod.port_code,
                "destination_port_name": vm.shipment_meta.pod.name,
                "aircraft_type" : null,
                "flight_number" : null,
                "arrival_time" : null,
                "departure_time" :null,
                "air_transit_time" : { "DD":0, "hh": null, "mm": null },
                "service_days" : [],
                "non_stop" : true,
                "schedule_track" : [],
                "mode" : 'AIR',
                "carrier_code" : null
              };
          } else {
              util.callMixpanel("SD-EditAirSchedule-Click",{
                "Mode":vm.shipment_meta.mode
              });
              vm.edit_schedule_track = angular.copy(item);
              vm.tempEdit_schedule_track = angular.copy(item); // used for comaring to prev object

              vm.originDeparture = moment(vm.edit_schedule_track.departure_time);
              vm.destinationArrival = moment(vm.edit_schedule_track.arrival_time);
              if(vm.edit_schedule_track.schedule_track.length){
                for(var i = 0; i < vm.edit_schedule_track.schedule_track.length; i++){

                  vm.edit_schedule_track.schedule_track[i]["viaPort"] = {
                    "portcode_portname": vm.edit_schedule_track.schedule_track[i].port_code+'/'+ vm.edit_schedule_track.schedule_track[i].port_name,
                    "global_port_code": vm.edit_schedule_track.schedule_track[i].port_code,
                    portname: vm.edit_schedule_track.schedule_track[i].port_name
                  }

                  vm.edit_schedule_track.schedule_track[i]["arrivalTime"] = moment(vm.edit_schedule_track.schedule_track[i].arrival_time);
                  vm.edit_schedule_track.schedule_track[i]["departureTime"] = moment(vm.edit_schedule_track.schedule_track[i].departure_time);
                  vm.edit_schedule_track.schedule_track[i]["portcode_portname"] = vm.edit_schedule_track.schedule_track[i].port_code+'/'+ vm.edit_schedule_track.schedule_track[i].port_name;
                }
              }

              vm.track_id = vm.edit_schedule_track._id;
              delete vm.edit_schedule_track["id"];
          }

          if(vm.scheduleModalTitle =='Add New' || vm.scheduleModalTitle =='Edit') {
            vm.departureTimeValidation=false;
            vm.arrivalTimeValidation=false;
            vm.sameTimeValidation=false;
            vm.portValidation=false;
            $mdDialog.show({
              templateUrl        : 'app/main/shipments/dialogs/air-schedule-edit/air-schedule-edit.html',
              targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm }
            });
          }

        }

        function fnClickNonStop(value){
          // if(vm.edit_schedule_track.non_stop == value) {
          //   return true;
          // }
          vm.edit_schedule_track.non_stop = value;

          if(!vm.edit_schedule_track.non_stop  ){
            var viaTrack = {
              "id" : 1,
              "port_code": null,
              "port_name": null,
              "departure_time": null,
              "arrival_time": null,
              "viaPort" : null
            }
            if(!vm.edit_schedule_track.schedule_track.length){
              vm.edit_schedule_track.schedule_track.push(viaTrack);
            }
          }else {
            vm.edit_schedule_track.schedule_track = [];
          }
        }

        function saveScheduleTrack(form) {

            if(!vm.trackPort && !vm.edit_schedule_track.port_name ){
              vm.locationValidation=true;
            }

            if(!vm.edit_schedule_track.service_name){
              vm.serviceValidation=true;
            }
            if(!vm.edit_schedule_track.vessel){
              vm.vesselValidation=true;
            }
            if(!vm.edit_schedule_track.departure_time){
              vm.departureValidation=true;
            }
            if(!vm.edit_schedule_track.arrival_time){
              vm.arrivalValidation=true;
            }

            if( vm.locationValidation || vm.serviceValidation || vm.vesselValidation || vm.departureValidation || vm.arrivalValidation || form.$invalid){
              return;
            }
            vm.edit_schedule_track.arrival_time = vm.edit_schedule_track.arrival_time ? moment(vm.edit_schedule_track.arrival_time).local().format('YYYY-MM-DD HH:mm') : null;
            vm.edit_schedule_track.departure_time = vm.edit_schedule_track.departure_time ? moment(vm.edit_schedule_track.departure_time).local().format('YYYY-MM-DD HH:mm') : null;
            vm.edit_schedule_track.vgm_cutoff = vm.edit_schedule_track.vgm_cutoff ? moment(vm.edit_schedule_track.vgm_cutoff).local().format('YYYY-MM-DD HH:mm') : null;
            vm.edit_schedule_track.port_cutoff = vm.edit_schedule_track.port_cutoff ? moment(vm.edit_schedule_track.port_cutoff).local().format('YYYY-MM-DD HH:mm') : null;

            if(vm.scheduleModalTitle =='Add' && vm.trackPort != null){
                vm.edit_schedule_track.port_code = vm.trackPort.global_port_code;
                vm.edit_schedule_track.port_name = vm.trackPort.portcode_portname;
                vm.edit_schedule_track.origin_port_name = vm.trackPort.portcode_portname;
                // var lastScheduleTrackId =  vm.schedule.schedule_track.length == 2 ? vm.schedule.schedule_track[vm.schedule.schedule_track.length - 1].id : vm.schedule.schedule_track.length > 2 ? vm.schedule.schedule_track[vm.schedule.schedule_track.length - 2].id : 0;
                // vm.edit_schedule_track.id = lastScheduleTrackId + 1;
              //  updating schedule's last track when adding new track
                vm.lastScheduleTrackId += 1;
                vm.edit_schedule_track.id = vm.lastScheduleTrackId;
            }

            if(vm.scheduleModalTitle =='Add New' && vm.trackPort != null){
                vm.edit_schedule_track.origin_port = vm.trackPort.global_port_code;
                vm.edit_schedule_track.origin_port_name = vm.trackPort.portcode_portname;
                vm.edit_schedule_track.destination_port = ShipmentService.shipmentManagementObj.shipment_meta.pod.port_code;
                vm.edit_schedule_track.destination_port_name = ShipmentService.shipmentManagementObj.shipment_meta.pod.name;
                vm.edit_schedule_track.carrier_code = ShipmentService.shipmentManagementObj.shipment_meta.carrier_info.carrier_code;
                vm.edit_schedule_track.is_custom = 1;
                delete vm.edit_schedule_track['port_code'];
                delete vm.edit_schedule_track['port_name'];
                vm.track_1 = {
                    "id": 1,
                    "port_code": vm.edit_schedule_track.origin_port,
                    "port_name": vm.edit_schedule_track.origin_port_name,
                    "departure_time": vm.edit_schedule_track.departure_time,
                    "arrival_time": vm.edit_schedule_track.arrival_time,
                    "vgm_cutoff": vm.edit_schedule_track.vgm_cutoff,
                    "port_cutoff": vm.edit_schedule_track.port_cutoff,
                    "service_name": vm.edit_schedule_track.service_name,
                    "terminal": vm.edit_schedule_track.terminal,
                    "vessel": vm.edit_schedule_track.vessel,
                    "voyage": vm.edit_schedule_track.voyage,
                    "transit_time": vm.edit_schedule_track.transit_time,
                    "voyage_local": vm.edit_schedule_track.voyage_local
                }

                vm.track_2 = {
                    "id": 2,
                    "port_code": vm.edit_schedule_track.destination_port,
                    "port_name": vm.edit_schedule_track.destination_port_name,
                    "departure_time": null,
                    "arrival_time": null,
                    "vgm_cutoff": null,
                    "port_cutoff": null,
                    "service_name": null,
                    "terminal": null,
                    "vessel": null,
                    "voyage": null,
                    "transit_time": null,
                    "voyage_local": null
                }
                vm.lastScheduleTrackId = 2;

                vm.edit_schedule_track.schedule_track = [vm.track_1, vm.track_2];
            }

            if((vm.edit_schedule_track.port_name === null && vm.scheduleModalTitle =='Add') || (vm.edit_schedule_track.origin_port_name == null && vm.scheduleModalTitle =='Add New')){
                util.showToast('Please select the valid port.');
                return false;
            }



            vm.trackBtn = true;
            // vm.edit_schedule_track.departure_time = moment.utc(vm.edit_schedule_track.departure_time).format(util.utcDateFormat);
            // vm.edit_schedule_track.arrival_time = moment.utc(vm.edit_schedule_track.arrival_time).format(util.utcDateFormat);

            // vm.edit_schedule_track.vgm_cutoff !== null ? moment.utc(vm.edit_schedule_track.vgm_cutoff).format(util.utcDateFormat) : null;

            // vm.edit_schedule_track.port_cutoff !== null ? moment.utc(vm.edit_schedule_track.port_cutoff).format(util.utcDateFormat) : null;

            var postData = {
                "data" : angular.copy(vm.edit_schedule_track)
            }
            if(vm.scheduleModalTitle =='Add'){

                api.shipment.scheduleTrack.save({'shipment_id':ShipmentService.shipment_id,'id':vm.schedule._id}, postData,
                    function(response){
                      vm.fnGetSchedule();
                        // vm.edit_schedule_track['id'] = response.id;
                        // vm.schedule.schedule_track.splice(vm.schedule.schedule_track.length-1, 0, vm.edit_schedule_track);
                        util.showToast("Schedule leg added successfully.");
                        vm.trackBtn = false;
                        $mdDialog.hide();
                    },function(err){
                        // vm.showAlert("Failed to add Schedule leg.");
                        // util.showToast(err.message);
                        $log.log(err);
                        util.showToast(util.displayValidationError(err.data.message));
                        vm.trackBtn = false;
                        // $mdDialog.hide();
                });
            }
            else if(vm.scheduleModalTitle =='Edit'){

                api.shipment.scheduleTrack.update({'shipment_id':ShipmentService.shipment_id,'id':vm.schedule._id,'track_id':vm.track_id}, postData,
                    function(response){
                      vm.fnGetSchedule();
                        // vm.edit_schedule_track['id'] = vm.track_id;
                        // vm.schedule.schedule_track[vm.scheduleTrackIndex] = angular.copy(vm.edit_schedule_track);
                        util.showToast("Schedule leg updated successfully.");
                        vm.trackBtn = false;
                        $mdDialog.hide();
                    },function(err){
                        // util.showToast(err.message);
                        $log.log(err);
                        util.showToast(util.displayValidationError(err.data.message));
                        vm.trackBtn = false;
                        // $mdDialog.hide();
                });
            } else if(vm.scheduleModalTitle ==='Add New') {
                api.shipment.schedule.save({'shipment_id':ShipmentService.shipment_id}, postData,
                    function(response){
                        if(response.status === 'success') {
                            vm.schedule = response.data;
                            // vm.schedule['id'] = response.id;
                            // vm.schedule.schedule_track.splice(vm.schedule.schedule_track.length-1, 0, vm.edit_schedule_track);
                            util.showToast("Schedule leg added successfully.");
                        }
                            vm.trackBtn = false;
                            $mdDialog.hide();
                    },function(err){
                        // vm.showAlert("Failed to add Schedule leg.");
                        // util.showToast(err.message);
                        $log.log(err);
                        util.showToast(util.displayValidationError(err.data.message));
                        vm.trackBtn = false;
                        // $mdDialog.hide();
                });
            }
        }

        function fnSaveAirSchedule(){
          if (!vm.edit_schedule_track.departure_time) {
            vm.departureTimeValidation = true;
          }
           if (!vm.edit_schedule_track.arrival_time) {
            vm.arrivalTimeValidation = true;
          }
           if (vm.edit_schedule_track.departure_time && vm.edit_schedule_track.arrival_time && vm.edit_schedule_track.departure_time === vm.edit_schedule_track.arrival_time) {
           vm.sameTimeValidation = true;
          }
          if(!vm.edit_schedule_track.non_stop){
         angular.forEach(vm.edit_schedule_track.schedule_track, function(value, key) {
          if(!value.viaPort){
            vm.portValidation = true;
          }
         })
        }
        if( vm.departureTimeValidation || vm.arrivalTimeValidation || vm.sameTimeValidation || vm.portValidation){
          return
        }
          if(vm.scheduleModalTitle == 'Edit') {
            if(angular.equals(vm.tempEdit_schedule_track,vm.edit_schedule_track)){
              util.showToast('No changes !');
              return;
            }
          }

          if(vm.edit_schedule_track.aircraft_type) {
            if(!(vm.edit_schedule_track.aircraft_type.length >= 3 && vm.edit_schedule_track.aircraft_type.length <= 25)){
              document.querySelector('#aircraftType').focus();
              util.showToast('Aircarft type should be min 3 and Max 25');
              return;
            }

            // if(!(vm.edit_schedule_track.aircraft_type.match(/^[a-zA-Z0-9]+$/i))) {
            //   document.querySelector('#aircraftType').focus();
            //   util.showToast('Aircraft Type should be Alphanumeric');
            //   return;
            // }
          }

          if(vm.edit_schedule_track.flight_number) {
            if( !(vm.edit_schedule_track.flight_number.length >= 5 && vm.edit_schedule_track.flight_number.length <= 25) ){
              document.querySelector('#flightNumber').focus();
              util.showToast('The flight number should be a minimum of 5 characters and a maximum of 25 characters');
              return;
            }

            // if(!(vm.edit_schedule_track.flight_number.match(/^[a-zA-Z0-9]+$/i))) {
            //   document.querySelector('#flightNumber').focus();
            //   util.showToast('Flight number should be Alphanumeric');
            //   return;
            // }
          }



          // vm.edit_schedule_track.departure_time = moment.utc(new Date(vm.edit_schedule_track.departure_time)).format();
          // vm.edit_schedule_track.arrival_time = moment.utc(new Date(vm.edit_schedule_track.arrival_time)).format();

          var tempSchedule_track = angular.copy(vm.edit_schedule_track.schedule_track);
          if(tempSchedule_track.length){
            var count = 1;
            for(var i = 0; i < tempSchedule_track.length; i++){
              if(!tempSchedule_track[i].viaPort.global_port_code){
                util.showToast('Via Airport name is required');
                return;
              }
              tempSchedule_track[i].id = count++;
              tempSchedule_track[i].port_code = tempSchedule_track[i].viaPort.global_port_code;
              tempSchedule_track[i].port_name = tempSchedule_track[i].viaPort.portname;

              // tempSchedule_track[i].departure_time = tempSchedule_track[i].departure_time ? moment.utc(new Date(tempSchedule_track[i].departure_time)).format() : null;
              // tempSchedule_track[i].arrival_time = tempSchedule_track[i].arrival_time ? moment.utc(new Date(tempSchedule_track[i].arrival_time)).format() : null;

              delete tempSchedule_track[i].viaPort;
              delete tempSchedule_track[i]["portcode_portname"];
              delete tempSchedule_track[i].arrivalTime;
              delete tempSchedule_track[i].departureTime;
            }
          }
          vm.edit_schedule_track.schedule_track = angular.copy(tempSchedule_track);

          var tempServiceDays = [];
          vm.daysOfService.forEach(function(item){
            if( vm.edit_schedule_track.service_days.includes(item) ){
              tempServiceDays.push(item);
            }
          });
          vm.edit_schedule_track.service_days = angular.copy(tempServiceDays);

          vm.trackBtn = true;
          var postData = {
            "data" : angular.copy(vm.edit_schedule_track)
          }

          if(vm.scheduleModalTitle =='Add New'){
            util.isCallingApi = true;
            api.shipment.schedule.save({'shipment_id':ShipmentService.shipment_id}, postData,
                function(response){
                  if(response.status === 'success') {
                    vm.edit_schedule_track.schedule_track = angular.copy(tempSchedule_track);
                    vm.schedule = angular.copy(vm.edit_schedule_track);
                    util.showToast("Schedule added successfully");
                  }
                    vm.trackBtn = false;
                    util.isCallingApi = false;
                    vm.fnGetSchedule();
                    $mdDialog.hide();
                },function(err){
                    util.isCallingApi = false;
                    $log.log(err);
                    util.showToast(util.displayValidationError(err));
                    vm.trackBtn = false;
            });
          }
          else if(vm.scheduleModalTitle =='Edit'){
              util.isCallingApi = true;
              api.shipment.schedule.update({'shipment_id':ShipmentService.shipment_id,'id':vm.schedule._id}, postData,
                  function(response){
                      vm.edit_schedule_track.schedule_track = angular.copy(tempSchedule_track);
                      vm.schedule = angular.copy(vm.edit_schedule_track);
                      util.showToast('Schedule updated successfully');
                      vm.trackBtn = false;
                      util.isCallingApi = false;
                      vm.fnGetSchedule();
                      $mdDialog.hide();
                  },function(err){
                      util.isCallingApi = false;
                      $log.log(err);
                      util.showToast(util.displayValidationError(err));
                      vm.trackBtn = false;
              });
          }
        }

        function fnOpenConfirmDeleteModal(name,parentIndex,childIndex,ev, panel){
            vm.deleteBtn = false;
            vm.deleteName = name;

            if(name == 'load'){
                vm.loadContainerIndex = parentIndex;
                vm.matrixIndex = childIndex;
                vm.deleteType="Load";

                if(vm.load_data.load_details_value.length===1 && vm.load_data.load_details_value[0].load_metrics.length===1) {
                  util.showToast("At least one load is needed");
                  return true;
                }
            }
            else if(name == 'commodity'){
                vm.indexCommodity = childIndex;
                vm.deleteType="Commodity"
            }
            else if(name == 'air-schedule'){
              util.callMixpanel("SD-DeleteAirSchedule-Click",{
                "Mode":vm.shipment_meta.mode
              });
              vm.deleteType="schedule";
            }

            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        function fnDeleteData(name){
            vm.deleteBtn = true;
            if(name == 'load'){
                vm.load_data.load_details_value[vm.loadContainerIndex].load_metrics.splice(vm.matrixIndex,1);
                vm.load_data.load_details_value[vm.loadContainerIndex].qty = parseInt(vm.load_data.load_details_value[vm.loadContainerIndex].qty) - 1;
              if (!vm.load_data.load_details_value[vm.loadContainerIndex].load_metrics.length) {
                  vm.load_data.load_details_value.splice(vm.loadContainerIndex, 1);
                }
                // vm.fnSaveLoad(vm.load_data);
                vm.deleteBtn = false;
                $mdDialog.hide();
            }
            else if(name == 'commodity'){
              vm.fnDeleteCommodity(vm.indexCommodity);
            }

            else if(name == 'air-schedule'){
              //vm.deleteType="";
              fnDeleteAirSchedule();
            }

        }

        function fnDeleteCommodity(_id){
            api.shipment.commodity.remove({'shipment_id':ShipmentService.shipment_id,'id':_id},
                function(){
                    var deleteData = vm.commodity.find(function(item){
                        return item._id == _id;
                    });
                    vm.commodity.splice(deleteData, 1);
                    vm.deleteBtn = false;
                    $mdDialog.hide();
                    util.showToast("Commodity deleted successfully.");
                },function(err){
                    // util.showToast(err.message);
                    $log.log(err);
                    vm.deleteBtn = false;
                    util.showToast(util.displayValidationError(err));
                    // $mdDialog.hide();
            });

        }


        function fnDeleteAirSchedule(){
          api.shipment.schedule.remove({'shipment_id':ShipmentService.shipment_id,'id':vm.schedule._id},
              function(){
                vm.schedule = null;
                vm.deleteBtn = false;
                $mdDialog.hide();
                util.showToast("Schedule deleted successfully.");
              },function(err){
                $log.log(err);
                vm.deleteBtn = false;
                util.showToast(util.displayValidationError(err));
            });
        }


        function fnOpenCommodityModal(item, index, title, ev){
            vm.cargoValidation = false;
            vm.commodityValidation = false;
            vm.commodityBtn = false;
            vm.imcoValidation = false;
            vm.commodityModalTitle = title;
            vm.commodityIndex = index;
            vm.fnGetCargoTypeList();

            // TODO : cargo type
            if(vm.commodityModalTitle == "Add"){
              util.callMixpanel("SD-AddCommodity-Click",{
                "Mode":vm.shipment_meta.mode
              });
                vm.editCommodity = {
                    "name": null,
                    "hs_code": null,
                    "cargo_type": null,
                    "hazardous": 0,
                    "imco_code": 0,
                    "commodity_data" : []
                }
                vm.commoditySearchText = "";
                vm.commodityName = null;
                vm.isCargoTypeDisabled = false;
            }
            else{
                vm.editCommodity = angular.copy(item);
                vm.commodity_id = vm.editCommodity._id;
                delete vm.editCommodity["_id"];
                vm.commoditySearchText = vm.editCommodity.name;
                // check vendor id for editable cargo input
                if(vm.shipment_meta) {
                  vm.isCargoTypeDisabled = shareQuoteService.cargoInputDisabled(vm.shipment_meta.vendor_id);
                }
                else {
                  vm.isCargoTypeDisabled = false;
                }
            }
            vm.selected_imco = Math.floor(vm.editCommodity.imco_code);

            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/commodity-edit/commodity-edit.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        // get cargo type list
        function fnGetCargoTypeList(){
          // if(resultService.cargoTypeList.length){
          //     vm.cargoTypeList = resultService.cargoTypeList;
          // }else{
            var currentMode = vm.shipment_meta.mode.includes('-') ? vm.shipment_meta.mode.split('-')[1] : vm.shipment_meta.mode;
              resultService.getCargoList(currentMode).then(function(response){
                  resultService.cargoTypeList = response.data.data;
                  vm.cargoTypeList = resultService.cargoTypeList;
              },function(error){
                  vm.cargoTypeList = [];
              });
          // }
        }

        //function to get commodity list -ankita
        function getCommodityList(searchText){
            return ShipmentService.getCommodityList(searchText).then(function(response){
                return response.data.data;
            },function(error){
                $log.log(error.data);
                return [];
            });
        }

        function fnCargoChange(data){
          if(!data){
            vm.imcoValidation=false;
          }
        }

        function saveCommodity(){
            if(!vm.editCommodity.cargo_type){
              vm.cargoValidation = true;
            }
            if(!vm.editCommodity.commodity_data.length){
              vm.commodityValidation = true;

            }
            if(vm.editCommodity.hazardous && !vm.selected_imco){
              vm.imcoValidation=true;
              // util.showToast("Please select IMCO code.");
              // return true;
            }
            if(vm.commodityValidation || vm.cargoValidation || vm.imcoValidation){
              return false;
            }


           vm.commodityBtn = true;
           vm.editCommodity.imco_code = vm.selected_imco;
           vm.editCommodity.hazardous = vm.editCommodity.hazardous;
           vm.editCommodity.hs_code = (vm.editCommodity.hs_code == "") ? null : vm.editCommodity.hs_code;
           // setting commodity data array
           vm.editCommodity.commodity_data = shareQuoteService.commodityString(vm.editCommodity.commodity_data);
           vm.editCommodity.name = vm.editCommodity.commodity_data.length ? vm.editCommodity.commodity_data.join() : null ;

           var postData = {
               "data" : vm.editCommodity
           }
            if(vm.commodityModalTitle == 'Edit'){

                api.shipment.commodity.update({'shipment_id':ShipmentService.shipment_id,'id':vm.commodity_id}, postData,
                    function(){
                        if( vm.editCommodity.hazardous){
                            util.showToast("The rates may change upon selection of a hazardous commodity.");
                            $timeout(function () {
                                util.showToast("Commodity added successfully.");
                            }, 3000);
                        }else{
                            util.showToast("Commodity added successfully.");
                        }
                        vm.editCommodity['_id'] = vm.commodity_id;
                        vm.shipDetailsData.data["commodity"].data[vm.commodityIndex] = angular.copy(vm.editCommodity);
                        vm.commodityBtn = false;
                        $mdDialog.hide();
                    },function(err){
                        // util.showToast(err.message);
                        $log.error(err);
                        util.showToast(util.displayValidationError(err));
                        vm.commodityBtn = false;
                        // $mdDialog.hide();
                });
            }
            else if(vm.commodityModalTitle == 'Add'){
                api.shipment.commodity.save({'shipment_id':ShipmentService.shipment_id}, postData,
                    function(response){
                        if( vm.editCommodity.hazardous){
                            util.showToast("The rates may change upon selection of a hazardous commodity.");
                            $timeout(function () {
                                util.showToast("Commodity added successfully.");
                            }, 3000);
                        }else{
                            util.showToast("Commodity added successfully.");
                        }
                        vm.editCommodity['_id'] = response.id;
                        vm.commodity.push(vm.editCommodity);
                        vm.commodityBtn = false;
                        $mdDialog.hide();
                    },function(err){
                        // util.showToast(err.message);
                        $log.error(err);
                        util.showToast(util.displayValidationError(err));
                        vm.commodityBtn = false;
                        // $mdDialog.hide();
                });
            }

        }

        function fnChangeCargoType(){
          if(vm.editCommodity.cargo_type.name.toLowerCase() == 'hazardous'){
            vm.editCommodity.hazardous = 1;
          }else{
            vm.editCommodity.hazardous = 0;
          }
        }

        function fnDisplayUser(nav){
            vm.selectUser = vm.userRoles.filter(function(o1){
                return nav.some(function(o2){
                    return o1.module_code == o2.module_code;          // assumes unique id
                });
            }).map(function(o){
                    return o;
            });
        }

        function fnOpenNewPartyModal(item, index, title, category, ev,type){
          vm.validationObj={
          "permissionValidation":false,
           "expiryValidation":false,
            "emailValidation":false,
           "nameValidation":false,
           "companyValidation":false,
           "categoryValidation":false,
        }
            vm.partyBtn = false;
            if(vm.userRoles == undefined || !vm.userRoles.length){
                vm.getUserRoles();
            }

            var categoryName = angular.copy(category);
            categoryName = (categoryName.toLowerCase() == 'shipper') ? 'customer' : (categoryName == 'notify_party') ? 'Notify Party' : categoryName;
            vm.fixCategory = categoryName.charAt(0).toUpperCase() + categoryName.slice(1);

            vm.partyExpiryMin = new Date();
            vm.editParty = {};
            vm.selectUser = [];

            vm.editPartyModalTitle = title;
            vm.editPartyIndex = index;

            if(vm.editPartyModalTitle == 'Add'){
                vm.editParty = {
                        "name": null,
                        "category": category == "" ? null : category,
                        "company_name": null,
                        "email": null,
                        "address": null,
                        "contact": null,
                        "expiry_date": null,
                        "iec_number": null,
                        "country_code": null,
                        "revoke":0,
                        "nav":[] ,
                        "send_notification" : false
                };
            }
            else{
                vm.fnDisplayUser(item.nav);
                vm.prevEmail = angular.copy(item.email);
                vm.editParty = angular.copy(item);
                // vm.editParty["revoke"] = 0;
                vm.editParty.expiry_date = new Date( moment.utc(vm.editParty.expiry_date).local());
                vm.party_id = vm.editParty._id;
                delete vm.editParty["_id"];
            }

            // mixpanle event
            if(title == 'Add'){
              util.callMixpanel(type, {
                "Mode": vm.shipment_meta.mode,
              });
            }else if(title == 'Edit'){

              if(category == 'shipper' || category == 'consignee' || category == 'notify_party' || category == 'cha' || category == 'shippers'){
                category = (category == 'notify_party') ? 'notify party':category;
                util.callMixpanel("SD-"+category+"-Edit-Click" , {
                  "Mode": vm.shipment_meta.mode
                });
              }
            }
            $mdDialog.show({
              template: '<md-dialog id="new-party" class="popup-md"><new-party fix-category="ctrl.parent.fixCategory" edit-party-modal-title="ctrl.parent.editPartyModalTitle" validation-obj="ctrl.parent.validationObj" mode="ctrl.parent.shipment_meta.mode" edit-party="ctrl.parent.editParty" select-user="ctrl.parent.selectUser" user-roles="ctrl.parent.userRoles" prev-email="ctrl.parent.prevEmail" edit-party-index="ctrl.parent.editPartyIndex" party-id="ctrl.parent.party_id" party-btn="ctrl.parent.partyBtn" permission="ctrl.parent.permission" parties="ctrl.parent.parties" callback="ctrl.parent.ifCategoryAdd()"></new-party></md-dialog>',
                targetEvent: ev,
                clickOutsideToClose: false,
                parent: $rootElement,
                scope: $scope,
                controllerAs: 'ctrl',
                preserveScope: true,
                onRemoving: vm.restPartyObj,
                controller: function () { this.parent = vm },
            });
        }

        function restPartyObj(category) {
          vm.editParty = {
              "name": null,
              "category": category ? category : null,
              "company_name": null,
              "email": null,
              "address": null,
              "contact": null,
              "expiry_date": null,
              "iec_number": null,
              "country_code": null,
              "revoke":0,
              "nav":[] ,
              "send_notification" : false
          };
        }

        function fnSaveParty(form,category){

          if(!vm.editParty.category){
            vm.validationObj.categoryValidation = true;
          }
          if(!vm.editParty.company_name){
            vm.validationObj.companyValidation = true;
          }
          if(!vm.editParty.name){
            vm.validationObj.nameValidation = true;
          }
          if(!vm.editParty.email){
            vm.validationObj.emailValidation = true;
          }
          if(!vm.editParty.expiry_date){
            vm.validationObj.expiryValidation=true;
          }
          if(vm.selectUser.length <= 0){
            vm.validationObj.permissionValidation=true;
          }
            if( vm.validationObj.permissionValidation|| vm.validationObj.expiryValidation ||  vm.validationObj.emailValidation ||  vm.validationObj.nameValidation || vm.validationObj.companyValidation|| vm.validationObj.categoryValidation || form.$invalid) {
                return ;
            }
            category=category.toLowerCase();
            if(category == 'shipper' || category == 'consignee' || category == 'notify party' || category == 'cha'){
            util.callMixpanel("SD-"+category+"-Save-Click" , {
              "Mode": vm.shipment_meta.mode
            });
          }


            vm.partyBtn = true;
            vm.editParty.nav = vm.selectUser;
            vm.editParty.nav.forEach(function(item){
                // delete item.description,
                delete item.$mdSelectId
            });

            var tempExpiry = new Date(vm.editParty.expiry_date);
            tempExpiry.setHours(23);
            tempExpiry.setMinutes(59);

            vm.editParty.expiry_date = moment.utc(tempExpiry).format(util.utcDateFormat);

            var postData = {
                "data" : angular.copy(vm.editParty)
            };

            postData.data.category = (vm.editParty.category.toLowerCase() === 'notify party' || vm.editParty.category.toLowerCase() === 'notify_party') ? 'notify_party' :  vm.editParty.category;

            if(vm.editPartyModalTitle == 'Edit'){

                if(angular.equals(vm.prevEmail, vm.editParty.email)){
                    delete postData.data.email;
                }
                util.isCallingApi = true;
                api.shipment.parties.update({'shipment_id':ShipmentService.shipment_id,'id':vm.party_id}, postData,
                    function(){
                        vm.editParty['_id'] = vm.party_id;
                        vm.shipDetailsData.data["parties"].data[vm.editPartyIndex] = angular.copy(vm.editParty);
                        vm.ifCategoryAdd();
                        util.showToast("Party updated successfully.");
                        var i = 0, partiesInMeta = appCache.get('shippmentDetailsMeta').parties;
                        while (partiesInMeta[i]) {
                          if(partiesInMeta[i]._id === vm.editParty._id) {
                            partiesInMeta[i] = vm.editParty;
                            i = partiesInMeta.length;
                          }
                          i++;
                        }
                        $scope.$emit('callShipmentMeta', { category: vm.editParty.category });
                        vm.partyBtn = false;
                        util.isCallingApi = false;
                        $mdDialog.hide();
                    },function(err){
                        // util.showToast(err.message);
                        $log.error(err);
                        util.showToast(util.displayValidationError(err));
                        vm.partyBtn = false;
                        util.isCallingApi = false;
                        // $mdDialog.hide();
                });
            }
            else if(vm.editPartyModalTitle == 'Add'){
                util.isCallingApi = true;
                api.shipment.parties.save({'shipment_id':ShipmentService.shipment_id}, postData,
                    function(response){
                      vm.editParty.category = (vm.editParty.category.toLowerCase() === 'notify party' || vm.editParty.category.toLowerCase() === 'notify_party') ? 'notify_party' :  vm.editParty.category;
                        vm.editParty['_id'] = response.id;
                        if(vm.parties != undefined){
                            vm.parties.push(vm.editParty);
                            vm.ifCategoryAdd();
                        }
                        util.showToast("New party added successfully.");
                        ShipmentService.shipmentManagementObj.shipment_meta.parties.push(vm.editParty);
                        $scope.$emit('callShipmentMeta', { category: vm.editParty.category });
                        vm.partyBtn = false;
                        util.isCallingApi = false;
                        $mdDialog.hide();
                    },function(err){
                        util.isCallingApi = false;
                        // util.showToast(err.message);
                        $log.error(err);
                        util.showToast(util.displayValidationError(err));
                        vm.partyBtn = false;
                        // $mdDialog.hide();
                });
            }

        }

        function getPartyStatus(party){

            var statusResult = '';

            if(party.revoke == 1){
                statusResult = 'INACTIVE';
            }
            else if(party.expiry_date != null){
                var expiry = new Date(moment.utc(party.expiry_date).local());
                var todays = new Date().setHours(0,0,0);

                if (todays <= expiry) {
                    statusResult = 'ACTIVE';
                }
                else {
                    statusResult = 'INACTIVE';
                }
            }
            return statusResult;
        }

        function getPartyStatusDisplay(party){

            var statusResult = false;

            if(party.revoke == 1){
                statusResult = true;
            }
            else if(party.expiry_date != null){
                var expiry = new Date(moment.utc(party.expiry_date).local());
                var todays = new Date().setHours(0,0,0);

                if (todays <= expiry) {
                    statusResult = false;
                }
                else {
                    statusResult = true;
                }
            }
            return statusResult;
        }


        function cancelDialog(category,label){
          if(category){
            category=category.toLowerCase();
            if(category == 'shipper' || category == 'consignee' || category == 'notify party' || category == 'cha'){
            util.callMixpanel("SD-"+category+"-"+label+"-Click" , {
              "Mode": vm.shipment_meta.mode
            });
            }
          }

          $mdDialog.hide();
          }

        function fnOpenAddtionalService(ev){
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/additional-service/additional-service.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

         /**
         *  get the list of ports from api
         *  @param port for schedule
         */
        // function getPort(searchText, modeToSend) {
        //   var modeToSend = vm.edit_schedule_track.mode === 'AIR' ? 'AIR' : 'SEA';

        //   searchText = $sanitize(searchText);
        //   // var url =  api.baseUrl + '/api/port';
        //   // var data =  {'data' :  {'mode': mode,'search_query' : searchText }};
        //   return util.getPorts(searchText, modeToSend).then(function (response) {
        //     return response.data.data.port;
        //   }, function (error) {
        //     $log.log(error.data);
        //     return [];
        //   });
        // }

        function addViaPort() {
          var schedule_track = {
            "id" : vm.edit_schedule_track.schedule_track.length+1,
            "port_code": null,
            "port_name": null,
            "departure_time": null,
            "arrival_time": null,
            "viaPort" : null,
            "arrivalTime" : null,
            "departureTime" : null,
            "portcode_portname" : null
          };
          vm.edit_schedule_track.schedule_track.push(angular.copy(schedule_track));
        }

        function removeViaPort(index) {
          if(vm.edit_schedule_track.schedule_track.length === 1){
            return;
          }
          vm.edit_schedule_track.schedule_track.splice(index, 1);
        }

        function fnLclLoadDetails(load_data) {
          vm.convertedLoad = vm.util.metricSystemConversion(
            vm.shipment_meta.mode,
            load_data
          );
          var result = [
            {
              name: "Gross Wt",
              value:
                load_data.load_meta.gross_weight != null
                  ? $filter("currencyMask")(
                      $filter("weightUnit")(
                        load_data.load_meta.gross_weight,
                        "gross_weight",
                        vm.shipment_meta.mode
                      ),
                      2
                    ) +
                    " " +
                    (vm.shipment_meta.mode == "SEA-LCL"
                      ? $rootScope.domainData.domain_info.WEIGHT_UNIT &&
                        $rootScope.domainData.domain_info.WEIGHT_UNIT[
                          vm.shipment_meta.mode
                        ].gross_weight
                        ? $rootScope.domainData.domain_info.WEIGHT_UNIT[
                            vm.shipment_meta.mode
                          ].gross_weight.toUpperCase()
                        : ""
                      : vm.util.grossWeightUnit[vm.shipment_meta.mode]) +
                    (vm.measurementSystem != "metric"
                      ? " / " +
                        $filter("currencyMask")(
                          vm.convertedLoad.gross_weight.value,
                          2
                        ) +
                        " " +
                        vm.convertedLoad.gross_weight.unit
                      : "")
                  : "N/A"
            },
            {
              name: "Volumetric_Wt",
              value:
                load_data.load_meta.volumetric_weight != null
                  ? $filter("currencyMask")(
                      load_data.load_meta.volumetric_weight,
                      2
                    ) +
                    " " +
                    vm.util.volumetricWeightUnit[vm.shipment_meta.mode] +
                    (vm.measurementSystem != "metric"
                      ? " / " +
                        $filter("currencyMask")(
                          vm.convertedLoad.volumetric_weight.value,
                          2
                        ) +
                        " " +
                        vm.convertedLoad.volumetric_weight.unit
                      : "")
                  : "N/A"
            },
            {
              name: "LCL Chargeable Weight",
              value:
                load_data.load_meta.chargeable_weight != null
                  ? $filter("currencyMask")(
                      load_data.load_meta.chargeable_weight,
                      2
                    ) +
                    " " +
                    vm.util.chargeableUnit[vm.shipment_meta.mode]
                  : "N/A"
            },
            {
              name: "Total Qty",
              value: load_data.load_meta.total_qty
                ? load_data.load_meta.total_qty
                : "N/A"
            },
            {
              name: "LTL Origin Dimensional Wt",
              value: "N/A"
            },
            {
              name: "LTL Origin Chargeable Weight",
              value: "N/A"
            },
            {
              name: "LTL Destination Dimensional Wt",
              value: "N/A"
            },
            {
              name: "LTL Destination Chargeable Weight",
              value: "N/A"
            }
          ];

          // Handle LTL load details
          if (load_data.ltl_load_details) {
            if (load_data.ltl_load_details.origin) {
              // origin dimensional weight
              result[3].value = load_data.ltl_load_details.origin.dimensional_weight
                ? $filter("currencyMask")(
                    load_data.ltl_load_details.origin.dimensional_weight,
                    2
                  ) +
                  " " +
                  load_data.ltl_load_details.origin.dimensional_unit
                : "N/A";
              // origin chargeable weight
              result[4].value = load_data.ltl_load_details.origin.chargeable_weight
                ? $filter("currencyMask")(
                    load_data.ltl_load_details.origin.chargeable_weight,
                    2
                  ) +
                  " " +
                  load_data.ltl_load_details.origin.chargeable_unit
                : "N/A";
            }
            if (load_data.ltl_load_details.destination) {
              // destination dimensional weight
              result[5].value = load_data.ltl_load_details.destination
                .dimensional_weight
                ? $filter("currencyMask")(
                    load_data.ltl_load_details.destination.dimensional_weight,
                    2
                  ) +
                  " " +
                  load_data.ltl_load_details.destination.dimensional_unit
                : "N/A";
              // destination chargeable weight
              result[6].value = load_data.ltl_load_details.destination
                .chargeable_weight
                ? $filter("currencyMask")(
                    load_data.ltl_load_details.destination.chargeable_weight,
                    2
                  ) +
                  " " +
                  load_data.ltl_load_details.destination.chargeable_unit
                : "N/A";
            }
          }

          if (
            load_data.load_details_value &&
            load_data.load_details_value.length > 0
          ) {
            // Add package count
            result.push({
              name: "Total Packages",
              value: load_data.load_details_value.length
            });

            // Add package table data
            result.push({
              name: "Package Details",
              value: load_data.load_details_value,
              type: "package_table"
            });
          }

          return result;
        }

        // feed functions

        //function to get user profile data
        function getProfileData(){
          return util.getProfile().then(function(response){
              vm.userData = response.user;
              return vm.userData;
          },function(error){
              util.showToast(util.displayValidationError(error));
              $log.error(error);
          });
        }

        $scope.$on('updateDetailsTab',function(){
            vm.init();
        })

        //method to get all the modules data on page Load
        function initialApiDataCalls(isRefresh){
          if($state.current.name === 'app.shipments.shipment_details' || $state.current.name === 'app.shared_shipment_details'  || $state.current.name  == 'app.mobile_shipment_details'){
              vm.shipDetailsFeedData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
                  return item.name == "FEED";
              });
              if(vm.shipDetailsFeedData){
              vm.getFeeds(isRefresh);
              vm.getStatus();
              }
              else{
                vm.permission.activity_feed[1]=0;
              }
          }
        }

        //function to get feeds details
        function getFeeds(isRefresh){
          if(isRefresh){
            vm.spinRefreshIcon= true;
            util.callMixpanel("SD-Updates-IconRefresh-Click",{
              "Mode":vm.shipment_meta.mode,
              "Shipment Status":vm.shipment_meta.current_status.status
            });
          }
          vm.permission.activity_feed = util.splitIntoArray(vm.shipDetailsFeedData.data["activity_feed"].permission);
          vm.feedDataUrl = vm.shipDetailsFeedData.data["activity_feed"].url;
          if(vm.permission.activity_feed[1]){
              api.shipment.activity_feed.get({'shipment_id':ShipmentService.shipment_id},function(response){
                  try{
                      vm.shipDetailsFeedData.data["activity_feed"].data = response.data;
                      vm.feedData = vm.shipDetailsFeedData.data["activity_feed"].data;
                      vm.getData = true;
                      vm.spinRefreshIcon= false;
                  }catch(e){
                      $log.error(e);
                      vm.getData = true;
                      vm.spinRefreshIcon= false;
                  }

              },function(err){
                  util.showToast(util.displayValidationError(err));
                  $log.error(err);
                  vm.getData = true;
                  vm.spinRefreshIcon= false;
              })
          }
      }

        //function to get status details
        function getStatus(){
          vm.permission.status = util.splitIntoArray(vm.shipDetailsFeedData.data["status"].permission);
          vm.statusUrl = vm.shipDetailsFeedData.data["status"].url;
          if(vm.permission.status[1]){
              api.shipment.status.get({'shipment_id':ShipmentService.shipment_id},function(response){
                  try{
                      vm.shipDetailsFeedData.data["status"].data = response.data;
                      vm.statusData = vm.shipDetailsFeedData.data["status"].data;
                      vm.getData = true;
                      vm.statusData.sort(function (a, b) {
                          var key1 = new Date(a.milestone_date);
                          var key2 = new Date(b.milestone_date);

                          if (key1 > key2) {
                              return -1;
                          } else if (key1 == key2) {
                              return 0;
                          } else {
                              return 1;
                          }
                      });
                  }catch(e){
                      $log.error(e);
                      vm.getData = true;
                  }

              },function(err){
                  util.showToast(util.displayValidationError(err));
                  $log.error(err);
                  vm.getData = true;
              })
          }
        }

        //function to submit post
        function fnSubmitPost(){
          util.callMixpanel('SD-Update-PostButton-Click',{
            "Mode":vm.shipment_meta.mode
          });
          if(vm.postText != ""){
              vm.disabledPost = true;
              var todaysDate = new Date();
              var dateTime = $filter('date')(todaysDate, 'd MMM yyyy h:mm a');

              var postData = "<div layout='column' class='feedDiv'><div layout='row' class='pt-15 font-size-14' layout-wrap><div class='avatar-container'><ng-avatar string='"+vm.userData.user_first_name+" "+vm.userData.user_last_name+"'round-shape='true' auto-color='true'></ng-avatar></div><div layout='column' class='pt-5 pl-15' flex='85'><div class='font-size-14'><b>"+vm.userData.user_first_name+" "+vm.userData.user_last_name+"</b></div><span class='font-size-12 gray-color'>"+dateTime+"</span><div class='feed_border mt-10 mr-10 font-size-14' flex='100'><div class='m-10'><div id='feed' class='render-content text-show-content'>"+vm.postText+"</div><md-button md-no-ink class='md-link-btn pointer show-btn feedBtn' ng-click='vm.toggleButton($event);'> + Show More </md-button></div></div></div></div></div>";

              postData = encodeURIComponent(encodeURIComponent(postData));
              var saveData={
                  "data" : {
                      "happened_at" : dateTime,
                      "feed" : postData,
                      "send_notification" : vm.send_notification
                  }
              }
              util.isCallingApi = true;
              api.shipment.activity_feed.save({'shipment_id':ShipmentService.shipment_id},saveData,function(response){
                  vm.feedData.unshift(saveData.data);
                  vm.postText = "";
                  vm.disabledPost = false;
                  util.isCallingApi = false;
                  util.showToast("You have posted successfully.");

              },function(err){
                  util.isCallingApi = false;
                  util.showToast(util.displayValidationError(err));
                  vm.disabledPost = false;
                  $log.error(err);
              })
          }
        }

        // toggle feed post show more/less button
        function toggleButton($event) {
          var feedText =  $event.target;
          var feedClass = angular.element($event.target.previousElementSibling);
          // console.log(feedClass);
          if (feedText.innerText === "+ Show More") {
            feedText.innerText = "- Show Less";
            feedClass.toggleClass('more');
          } else {
            feedText.innerText = "+ Show More";
            feedClass.removeClass('more');
          }
        }

        // references
        function fnViewInquiryDetails(id){
          if(vm.isSharedshipment){
            return;
          }
          if(!util.isShipper && id){
            util.isCallingApi = true;
            if(vm.isWebView){
              $state.go('app.inquiry.webViewInquiryDetails',{ id: id});
            }else{
              $state.go('app.inquiry.inquiryDetails',{ id: id});
            }
          }
        }

        function fnViewQuoteDetails(id){
          if(vm.isSharedshipment){
            return;
          }
          if(!util.isShipper && id){
            util.isCallingApi = true;
            if(vm.isWebView){
              util.webViewObj.id = id;
              $state.go('app.webViewQuotesDetails', util.webViewObj);
            }else{
              $state.go('app.quotes.quotesDetails',{ id: id});
            }
          }
        }

        function showLoadDetailPanel(ev) {
          vm.load_data.load_type = vm.load_data.load_type.toLowerCase();
          // qty type change string to number
          for (var i = 0; i < vm.load_data.load_details_value.length; i++) {
            vm.load_data.load_details_value[i].qty = parseInt(vm.load_data.load_details_value[i].qty);
          }
          vm.load_data.load_meta.total_qty = parseInt(vm.load_data.load_meta.total_qty);

          var searchParam = {
            'load_data' : angular.copy(vm.load_data),
            'mode' : vm.shipment_meta.mode,
            'isLoadSubmit': false
          };

          var position = vm._mdPanel.newPanelPosition()
            .relativeTo('.panel-select-load-detail')
            .addPanelPosition(vm._mdPanel.xPosition.ALIGN_END, vm._mdPanel.yPosition.BELOW);

          var config = {
            attachTo: angular.element(document.body),
            templateUrl: 'app/main/component/load-detail-selector/load-detail-selector.html',
            controllerAs: 'ctrl',
            controller: 'LoadDetailController',
            position: position,
            openFrom: ev,
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: false,
            zIndex: 2,
            locals: {
              'searchParam': searchParam,
              'searchForm': vm.searchBarForm,
              'page': 'shipment',
              'type': 'SD'
            },
            onRemoving: function () {
              if(searchParam.isLoadSubmit){
                vm.load_data = angular.copy(searchParam.load_data)
                vm.fnSaveLoad(vm.load_data);
              }
            }
          };
          vm.formIsPristine = false;
          appCache.put('searchParam', searchParam);
          vm._mdPanel.open(config);
        }

        function hasPackageTypes(packages) {
            if (!packages || !packages.length) {
                return false;
            }

            return packages.some(function(pkg) {
                return pkg.type && pkg.type.trim() !== '';
            });
        }

        function fnOpenReferencesModal(ev) {
          vm.editReferences = vm.shipment_meta.references ? angular.copy(vm.shipment_meta.references) : [];
        
          if (!vm.editReferences.length) {
            vm.editReferences.push({ reference_label: '', reference_value: '', comment: '' });
          }
        
          $mdDialog.show({
            templateUrl: 'app/main/shipments/dialogs/references-edit/references-edit.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: false,
            controllerAs: 'ctrl',
            controller: function() {
              this.parent = vm;
            }
          });
        }
        

        function fnAddReference() {
          var lastRef = vm.editReferences[vm.editReferences.length - 1];
          if (lastRef && (lastRef.reference_label || lastRef.reference_value)) {
            vm.editReferences.push({ reference_label: '', reference_value: '', comment: '' });
          }
        }
        
        function fnRemoveReference(index) {
          if (vm.editReferences.length === 1 && index === 0) {
            vm.editReferences[0] = { reference_label: '', reference_value: '', comment: '' };
          } else {
            vm.editReferences.splice(index, 1);
            if (vm.editReferences.length === 0) {
              vm.editReferences.push({ reference_label: '', reference_value: '', comment: '' });
            }
          }
        }
        
        function closeReferencesModal() {
          vm.shipment_meta.references = vm.editReferences.filter(function(ref) {
            return ref.reference_label || ref.reference_value;
          });
          if (vm.shipment_meta.references && vm.shipment_meta.references.length > 0) {
            var authToken = localStorageService.get('authToken');
            var userId = authToken && authToken.value ? authToken.value.user_id : '';
            var userCategory = authToken && authToken.value ? authToken.value.user_category : '';
            vm.shipment_meta.references.forEach(function(ref) {
              if (!ref.added_by) ref.added_by = userCategory || 'FORWARDER';
              if (!ref.user_id) ref.user_id = userId || '';
              if (!ref.added_at) ref.added_at = new Date().toISOString();
              if (!ref.type) ref.type = 'string';
            });
          }
          var postData = {
            data: {
              shipment_meta: {
                quote_name: vm.shipment_meta.quote_name,
                incoterm: vm.shipment_meta.incoterm,
                impo_expo: vm.shipment_meta.impo_expo,
                search_type: vm.shipment_meta.search_type,
                bl_number: vm.shipment_meta.bl_number,
                other_details: vm.shipment_meta.other_details,
                arrival_date: vm.shipment_meta.arrival_date,
                departure_date: vm.shipment_meta.departure_date,
                carrier_info: {
                  name: vm.shipment_meta.carrier_info.name,
                  carrier_code: vm.shipment_meta.carrier_info.carrier_code,
                  sv_id: vm.shipment_meta.carrier_info.sv_id,
                  vessel: vm.shipment_meta.carrier_info.vessel || "",
                  voyage: vm.shipment_meta.carrier_info.voyage
                },
                pol: {
                  name: vm.shipment_meta.pol.name,
                  port_code: vm.shipment_meta.pol.port_code,
                  portcode_portname: vm.shipment_meta.pol.portcode_portname,
                  is_icd_port: vm.shipment_meta.pol.is_icd_port
                },
                pod: {
                  name: vm.shipment_meta.pod.name,
                  port_code: vm.shipment_meta.pod.port_code,
                  portcode_portname: vm.shipment_meta.pod.portcode_portname,
                  is_icd_port: vm.shipment_meta.pod.is_icd_port
                },
                origin_address: vm.shipment_meta.origin_address || "",
                destination_address: vm.shipment_meta.destination_address || "",
                liner_shipment_id: vm.shipment_meta.liner_shipment_id,
                references: vm.shipment_meta.references
              }
            }
          };
          util.callMixpanel("SD-References-Save-Click", {
            Mode: vm.shipment_meta.mode,
            "References Count": vm.shipment_meta.references ? vm.shipment_meta.references.length : 0
          });
          util.isCallingApi = true;
          api.shipment.shipment_info.update({ shipment_id: ShipmentService.shipment_id }, postData, function(response) {
            util.isCallingApi = false;
            util.showToast("References updated successfully");
            $mdDialog.hide();
          }, function(err) {
            util.isCallingApi = false;
            $log.log(err);
            util.showToast(util.displayValidationError(err));
          });
        }

        // Ankita-> To open door address modal
        vm.fnOpenDoorAddress = fnOpenDoorAddress;
        vm.fnSubmitDoorAdress = fnSubmitDoorAdress;
        vm.doorCheckArrey = { origin_address: 'pickup_address', destination_address: 'delivery_address' };
        function fnOpenDoorAddress(ev,address_type){
          vm.currentAddressType = address_type;
          vm.currentAddress = angular.copy(vm.shipment_meta[address_type]);
          $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/edit-address/edit-address.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                parent: $rootElement,
                scope: $scope,
                controllerAs: 'ctrl',
                preserveScope: true,
                // onRemoving: vm.restPartyObj,
                controller: function () { this.parent = vm },
          });
        }

        function fnSubmitDoorAdress(){
          vm.shipment_meta[vm.currentAddressType] = vm.currentAddress;
          var postData = {
            data: {
              shipment_meta: vm.shipment_meta
            }
          };
          util.isCallingApi = true;
          api.shipment.shipment_info.update({ shipment_id: ShipmentService.shipment_id }, postData, function(response) {
            util.isCallingApi = false;
            util.showToast("Address updated successfully");
            $mdDialog.hide();
          }, function(err) {
            util.isCallingApi = false;
            $log.log(err);
            util.showToast(util.displayValidationError(err));
          });
          vm.cancelDialog();
        }
        

    }
})();

(function () {
  'use strict';

  angular
    .module('app.shipments')
    .controller('rateproviderbillinginfoShipmentController', RateProviderBillingInfoShipmentController);

  /** @ngInject */
  function RateProviderBillingInfoShipmentController($log,$scope, util, api,localStorageService, ShipmentService,BillingInfoService) {

    //<---------declarations start------->
    var vm = this;
    vm.billingInfoService = BillingInfoService;
    //misc
    vm.shipDetailsData = {};
    vm.vendorId = parseInt(localStorageService.get('authToken').value.vendor_id);
    vm.permission = {
      "rateProviderBilling" : [],
  };
    //rates
    vm.total = 0;
    vm.isRatesLoaded = false;
    vm.bill_rates = [];
    vm.getDetails = getDetails;
    vm.getBillingRates = getBillingRates;
    vm.currency_conversion_rates = null;
    
    //shipment details
    vm.ShipmentsDetails = {};
    vm.ShipmentsDetails = ShipmentService.shipmentManagementObj.shipment_meta;
    //all in quote
    vm.all_in_quote_setting = vm.ShipmentsDetails.all_in_quote_setting ? vm.ShipmentsDetails.all_in_quote_setting : 'default';

    //code to get user profile details
    vm.userData = {};
    vm.getProfileData = getProfileData;

    //<--------declaration end--------->

    //init data when tab is 'RATE PROVIDER BILLING INFO'
    $scope.$on('tabInitEvent',function(event,data){
      if(data == 'RATE PROVIDER BILLING INFO'){
          vm.getDetails();
      }
    })

    function getDetails() {
      vm.shipDetailsData = ShipmentService.shipmentManagementObj.shipment_data.nav.find(function (item) {
        return item.name == "RATE PROVIDER BILLING INFO";
      });
      vm.getProfileData();
      vm.getBillingRates();
    }
    function getProfileData() {
      return util.getProfile().then(function (response) {
        vm.userData = response.user;
        return vm.userData;
      }, function (error) {
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }
     //function to get rates details
     function getBillingRates() {
      vm.isRatesLoaded = false;
      vm.permission.rateProviderBilling = util.splitIntoArray(vm.shipDetailsData.data["rate_provider_billing"].permission);
            if(vm.permission.rateProviderBilling[1]){
                api.shipment.rateProviderBilling.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["rate_provider_billing"].data = response;
                        vm.bill_rates = vm.shipDetailsData.data["rate_provider_billing"].data.rates;
                        vm.total = vm.billingInfoService.calulateRateTotal(vm.bill_rates,'sell');

                        vm.isRatesLoaded = true;
                    }catch(e){
                        $log.error(e);
                        vm.isRatesLoaded = true;
                    }
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.isRatesLoaded = true;
                })
            }
    }
    

   
  }
})();

(function () {
    'use strict';

    angular
        .module('app.shipments')
        .controller('quotesShipmentController', QuoteShipmentController);

    /** @ngInject */
    function QuoteShipmentController(ShipmentService,resultService, $filter, $log, util,api,$timeout,$mdDialog,$scope, $mdToast,$rootScope, localStorageService, SearchService, $interval,shareQuoteService) {

        var vm = this;
        vm.util = util;
        vm.title="";
        vm.showContractId=$rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES;
        vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER)
        vm.selectFile = selectFile;
        vm.fnGetFilterLeg = fnGetFilterLeg;
        vm.getData = false;
        vm.viewDetailsModal = viewDetailsModal;
        vm.allCardCharges = allCardCharges;
        vm.cancelDialog = cancelDialog;
        vm.quotes = null;
        vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
        vm.fnDeleteData = fnDeleteData;
        vm.rateTotalCustomCurr = rateTotalCustomCurr;
        vm.getCardRemarksInclusion = getCardRemarksInclusion;
        vm.showAsterix = showAsterix;
        vm.uploadedQuotes = [];
        vm.shipQuotesData = {};
        vm.uploadQuotes = uploadQuotes;
        vm.trackEvent= trackEvent;
        vm.shareQuoteService = shareQuoteService;
        vm.mainFreightNameChange = $rootScope.isJeenaDomain;
        vm.mainFreightName = 'Main Freight';
        vm.isString = isString;
        vm.fclSlab=[];

        vm.buyOrSell = 'sell_rates';
        vm.searchUser = {};
        vm.termsTabView = termsTabView;
        vm.basisArray = [shareQuoteService.airBasisName, shareQuoteService.pickupBasisName, shareQuoteService.deliveryBasisName,shareQuoteService.freightBasisName];
        vm.deleteType='';
        vm.footerObj = { 
          "doneBtnDisable" : false,
          "buyTotalWithConv" : 0,
          "buyTotalBaseCurr" : 0,
          "sellTotalBaseCurr" : 0,
          "profit" : 0,
          "rateExpired":false
        }
        vm.sourceRate={};
        vm.pageSource='';
        vm.remarksInclusionCkEditorConfig = angular.copy(util.ckEditorConfig);
        vm.remarksInclusionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
        vm.all_in_quote = ShipmentService.shipmentManagementObj.shipment_meta.all_in_quote_setting ? ShipmentService.shipmentManagementObj.shipment_meta.all_in_quote_setting : "default" ;
        if(util.isSharedPage()) {
            vm.user_category = null;
        } else {
            vm.user_category = localStorageService.get('authToken').value.user_category;
        }
        vm.downloadSourceRate=downloadSourceRate;
        vm.freeDaysTabView = freeDaysTabView;
        vm.isFreeDaysEdit = false;
        vm.loadWiseFreeDaysList = [];

         //method to get all the modules data on page Load
        function init(){

          
            vm.module = "shipment_quote";
            vm.shipQuotesData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
                return item.name == "QUOTES";
            });

            vm.l3_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'l3_fcl' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'l3_air' : 'l3_lcl' );

            vm.l1_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'l1_fcl' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'l1_air' : 'l1_lcl' );

            vm.l2_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'l2_fcl' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'l2_air' : 'l2_lcl' );

            vm.l2_cha_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'l2_fcl_cha' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'l2_air_cha' : 'l2_lcl_cha' );

            vm.l4_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'l4_fcl' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'l4_air' : 'l4_lcl' );

            vm.l4_cha_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'l4_fcl_cha' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'l4_air_cha' : 'l4_lcl_cha' );

            vm.l5_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'l5_fcl' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'l5_air' : 'l5_lcl' );

            vm.ins_leg = (ShipmentService.shipmentManagementObj.shipment_meta.mode == 'SEA-FCL') ? 'ins_fcl' : ((ShipmentService.shipmentManagementObj.shipment_meta.mode == 'AIR') ? 'ins_air' : 'ins_lcl' );

            vm.quotePermission = util.splitIntoArray(vm.shipQuotesData.data["quote"].permission);
            vm.quoteUrl = vm.shipQuotesData.data["quote"].url;
            if(vm.quotePermission[1]){
                api.shipment.quote.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipQuotesData.data["quote"].data = response.data;
                        vm.quotes = vm.shipQuotesData.data.quote.data.vendor_quote["result_data"] && vm.shipQuotesData.data.quote.data.vendor_quote.result_data["rates"] ? vm.shipQuotesData.data.quote.data.vendor_quote.result_data.rates : null;
                        vm.search_param = vm.shipQuotesData.data.quote.data.vendor_quote["search_param"];
                        vm.maskLinerText = (vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT) ? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
                        vm.maskv2 = (vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2) ? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
                        vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';

                        vm.uploadedQuotes = vm.shipQuotesData.data["quote"].data["other_quotes"];
                        vm.quote_id = vm.shipQuotesData.data["quote"].data._id;
                        if(!vm.search_param.hasOwnProperty('freight_charges')){
                          vm.search_param['freight_charges'] = true;
                        }
                        if(vm.quotes){
                          if(vm.quotes.is_shared){
                              if(!util.isShipper || (util.isShipper && vm.quotes.cards.length && vm.quotes.cards[0].data.sell_rates != undefined) ){
                                  vm.buyOrSell = 'sell_rates';
                              }
                              vm.searchUser = vm.quotes.created_by;
                          }else{
                              if(vm.quotes.cards.length){
                                  vm.quotes.cards.forEach(function(card) {
                                    if(!card.data.sell_rates){
                                      card.data.sell_rates = angular.copy(card.data.buy_rates);
                                    }
                                      card.meta["card_total_cost"] = 0;
                                      card.meta["isScheduleCall"] = true;

                                    // pickup service type
                                    if(!card.meta["pickup_service"]){
                                      card.meta["pickup_service"] = card.data[vm.buyOrSell][vm.l1_leg] && card.data[vm.buyOrSell][vm.l1_leg].rate_obj && card.data[vm.buyOrSell][vm.l1_leg].rate_obj.service_type ? card.data[vm.buyOrSell][vm.l1_leg].rate_obj.service_type : "";
                                    }

                                    // pickup sub-vendor
                                    if(!card.meta["pickup_sub_vendor"]){
                                        card.meta["pickup_sub_vendor"] = card.data[vm.buyOrSell][vm.l1_leg] && card.data[vm.buyOrSell][vm.l1_leg].rate_obj && card.data[vm.buyOrSell][vm.l1_leg].rate_obj.sub_vendor ? card.data[vm.buyOrSell][vm.l1_leg].rate_obj.sub_vendor : null;
                                    }

                                    // delivery service type
                                    if(!card.meta["delivery_service"]){
                                        card.meta["delivery_service"] = card.data[vm.buyOrSell][vm.l5_leg] && card.data[vm.buyOrSell][vm.l5_leg].rate_obj && card.data[vm.buyOrSell][vm.l5_leg].rate_obj.service_type ? card.data[vm.buyOrSell][vm.l5_leg].rate_obj.service_type : "";
                                    }

                                    // delivery sub-vendor
                                    if(!card.meta["delivery_sub_vendor"]){
                                        card.meta["delivery_sub_vendor"] = card.data[vm.buyOrSell][vm.l5_leg] && card.data[vm.buyOrSell][vm.l5_leg].rate_obj &&  card.data[vm.buyOrSell][vm.l5_leg].rate_obj.sub_vendor ? card.data[vm.buyOrSell][vm.l5_leg].rate_obj.sub_vendor : null;
                                    }


                                      for(var i in card.data[vm.buyOrSell]){
                                          if(card.data[vm.buyOrSell][i].rate_obj){
                                              card.meta.card_total_cost += parseFloat(card.data[vm.buyOrSell][i].rate_obj.leg_total_cost);
                                          }
                                      }
                                  });
                              }
                              vm.searchUser = vm.search_param.user;
                          }

                          vm.currency_rates = angular.copy(vm.quotes["currency_conversion_rates"]);
                          if(vm.quotes.cards.length){
                            vm.quotes.cards.forEach(function(card) {
                                   //  Storing old data into new key - Free days #DEV-10379
                                    if(vm.search_param.mode != 'AIR' && !card.data.buy_rates[vm.l3_leg].rate_obj.freeDays){
                                      card.data.buy_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(card.data.buy_rates[vm.l3_leg].rate_obj , vm.search_param);
                                      card.data.sell_rates ? card.data.sell_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(card.data.sell_rates[vm.l3_leg].rate_obj , vm.search_param):null;
                                    }
                            });
                          }
                        }

                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }else{
                vm.getData = true;
            }
        }

          function isString(data) {
            if (typeof data === 'string') {
              return true;
            } else {
              return false;
            }
          }

         function fnGetFilterLeg(legArray){
            legArray.forEach(function(item) {
                vm.filterConfig[item].is_selected = true;
                vm.filterConfig[item].is_available = true;
            });
            resultService.filterData = vm.filterConfig;
         }

         $scope.$on('tabInitEvent',function(event,data){
             if(data == "QUOTES"){
                 init();
             }
         })

        function fnOpenConfirmDeleteModal(id,index,ev){
            vm.uploadedFileId = id;
            vm.fileIndex = index;
            vm.deleteType="Quote";
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }
        function trackEvent(type){
          util.callMixpanel(type,{
            "Mode":ShipmentService.shipmentManagementObj.shipment_meta.mode
          });
        }
        function fnDeleteData(){
            vm.deleteBtn = true;
            api.shipment.quote.remove({'shipment_id': vm.quote_id,'id':vm.uploadedFileId},function(response){
                vm.deleteBtn = false;
                vm.uploadedQuotes.splice(vm.fileIndex,1);
                // vm.showAlert("Quotes deleted successfully.")
                util.showToast("Quotes deleted successfully.");
                $mdDialog.hide();
            },function(err){
                util.showToast(util.displayValidationError(err));
                // vm.showAlert("Failed to delete Quotes.")
                $log.error(err);
                $mdDialog.hide();
            })
        }



        function selectFile() {
            angular.element(document.querySelector('#fileInput_doc')).click();
        };


        function uploadQuotes(file) {
            $('.uploadFile').hide();
            vm.uploadButton = true;
            vm.onSelect = true;

            var form = new FormData();
            form.append("shipment_docs[file]", file);
            var url = ShipmentService.shipment_id+'/quotes';

            ShipmentService.saveFileUpload(form, url).then(function (response) {
                angular.element(document.querySelector('#remove_doc')).click();
                vm.onSelect = false;
                vm.uploadButton = false;
                var resData = JSON.parse(response);
                vm.uploadedQuotes.push(resData.data);
                // vm.showAlert("Quotes uploaded successfully.");
                util.showToast("Quotes uploaded successfully.");
            }, function (error) {
                util.showToast(util.displayValidationError(err));
                // vm.showAlert("Failed to upload Quotes.");
                $log.log(error);
            });
        };

        vm.maxHeight = {
            "max-height" : '200px'
        }

        vm.scheduleVisible = false;
        vm.airScheduleVisible = false;
        vm.quotationVisible = true;
        vm.analyticsVisible = false;
      vm.fnCheckIsNaN = fnCheckIsNaN;
      function fnCheckIsNaN(charge, param) {
        var result = '';
        if (param == 'per_unit_rate') {
          if (angular.isString(charge.per_unit_rate)) {
            result = charge.per_unit_rate;
          } else {
            result = $filter('number')(charge.per_unit_rate, 2);
          }
        } else {
          if (!charge.min_flag && angular.isString(charge.charge_cost)) {
            result = charge.charge_cost;
          } else {
            result = $filter('number')(charge.leg_currency_cost, 2);
          }
        }
        return result;
      }

      function showAsterix(array) {
        var showAsterix = false;
        if(array) {
          Object.keys(array).some(function (key) {
            if (array[key].leg_code === 'additional_services') {
              array[key].rate_obj.charges.some(function (i) {
                if (typeof i.charge_cost === 'string') {
                  showAsterix = true;
                  return true;
                }
              });
            }
          });
        }
        return showAsterix;
      }

        function viewDetailsModal(currCard, ev, activeTab){
          currCard.meta.remarks = util.decodeValue(currCard.meta.remarks);
          currCard.meta.inclusions = util.decodeValue(currCard.meta.inclusions);
          currCard.meta.internal_remarks = util.decodeValue(currCard.meta.internal_remarks);
          if(vm.util.isAdmin || vm.util.userProfile.user.is_pricing_user){
            downloadSourceRate(currCard)
          }
          var carrier = vm.search_param.mode === 'AIR' ? currCard.data.sell_rates[vm.l3_leg].rate_obj.airline.air_line_name : currCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name ;

            vm.rem_open = true;
            vm.inl_open = true;
            $rootScope.loadingDetails = true;
            vm.showData = true;
            vm.chargeShow = 5;
            vm.fclSlab = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab_charges;

            vm.ratesVisible = 0; //vm.search_param.mode == "AIR" && (util.isAdmin || util.isFreightbro) ? 1 : 0;

            vm.termsVisible = (vm.search_param.mode != 'AIR' && currCard.meta.type.includes('spot')) ? true : false;

            // tab selection 
            if(activeTab == 'rates' && vm.ratesVisible){
              vm.selectedIndex = 0;
            }
            if(activeTab == 'schedule'){
              vm.selectedIndex = vm.ratesVisible;
            }
            if(activeTab == 'quotation'){
              vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible;
            }
            if(activeTab == 'tnc'){
              vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible + (vm.quotationVisible ? 2 : 0);
            }
            
            if(vm.search_param.mode == 'AIR'){
              vm.displayRates = true;
            }
            else{
              vm.displayRates = false;
            }

            vm.currentCard =  angular.copy(currCard);
            vm.ScheduleCard = currCard;
            getDataForExchangeRate();
            // Get Dim leg list
            vm.dimLegList = [];
            vm.dimLegList = shareQuoteService.fnGetDimLegs(vm.currentCard.data[vm.buyOrSell]); 
  
            vm.currentCard.meta.remarks = util.decodeValue(vm.currentCard.meta.remarks);
            vm.currentCard.meta.inclusions = util.decodeValue(vm.currentCard.meta.inclusions);
            vm.currentCard.meta.internal_remarks = util.decodeValue(vm.currentCard.meta.internal_remarks);

            if (SearchService.loadTypeArr == undefined || SearchService.loadTypeArr.length == 0) {
              SearchService.getAllLoadList().then(function (response) {
                SearchService.loadTypeArr = response;
                vm.loadTypeArr = response;
                util.limitObj = response;
              }, function (error) {
                $log.log(error.data);
              });
            } else {
              vm.loadTypeArr = SearchService.loadTypeArr != undefined ? SearchService.loadTypeArr : [];
            }

            // disable ckeditor
            if(!vm.quoteEdit){
              vm.remarksInclusionCkEditorConfig.readOnly =  true;
             }
            var tempUrl = '';
            vm.pageSource="SD-Quotes-ViewDetails";
            if(vm.l3_leg == 'l3_fcl'){
                tempUrl = 'app/main/result/Dialogs/view-details/fclViewDetails.html';
            }else{
                tempUrl = 'app/main/result/Dialogs/view-details/airViewDetails.html'
            }
            vm.title="Details"
            $mdDialog.show({
                templateUrl        : tempUrl,
                targetEvent        : ev,
                clickOutsideToClose: false,
                onComplete: vm.afterShowAnimation,
                fullscreen : false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm },
                onRemoving: function (event, removePromise) {
                  for (var name in CKEDITOR.instances) {
                    CKEDITOR.instances[name].destroy();
                  }
                }
          });
        }

        function getDataForExchangeRate(){
          vm.resultType = 'Shipment';
        }

        function termsTabView(){
            vm.viewActiveTab = 'Terms';
            vm.termsShimmer = true;
            if(!vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data && vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.url){
                return resultService.getCardTerms(vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.url).then(function (response) {
                    vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
                    vm.ScheduleCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
                    vm.termsData = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
                    vm.termsShimmer = false;
                }, function (error) {
                    vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data = null;
                    vm.termsData = null;
                    vm.termsShimmer = false;
                    $log.log(error);
                });
            }else{
                vm.termsData = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data ? vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"] : '';
                vm.termsShimmer = false;
            }

            util.callMixpanel("SD-Quotes-T&CTab-Click",{
              "Mode": vm.search_param.mode,
              "Type": vm.resultType
            });
        }

        vm.rateTabView = rateTabView;
        vm.loadMoreRecords = loadMoreRecords;
        vm.afterShowAnimation = afterShowAnimation;
        vm.quotationTabView = quotationTabView;
        vm.remarksTabView = remarksTabView;

        function afterShowAnimation(){
            $rootScope.loadingDetails = false;
            vm.showData = false;
        }

        function rateTabView(){
          vm.legShow = 1;
          vm.showData = true;
          vm.viewActiveTab = 'rates';
          vm.rateDetails = vm.currentCard.data[vm.buyOrSell];

          vm.showData = false;
          util.callMixpanel("SD-CreateQuote-FclSlabTab-Click",{
            "Mode": vm.search_param.mode,
            "Type": vm.resultType
          });
        }
        
        function quotationTabView () {
          if(!vm.currentCard.data.sell_rates){
            vm.currentCard.data.sell_rates = angular.copy(vm.currentCard.data.buy_rates);
          }
          vm.viewActiveTab = 'quotation';
        }

        function remarksTabView(){
          vm.viewActiveTab = 'remarksInclusion';
          if(!(util.isSharedQuote() || util.isSharedPage())){
          vm.isOwnVendorRate = util.isOwnVendorRate(vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.vendor_id);
          }
          vm.hideInternalRemarks =  !vm.isOwnVendorRate || util.isSharedQuote() || util.isSharedPage() ;
        }

        function loadMoreRecords() {
            vm.chargeShow += 2;
        }


        // get card leg user base currency total
        function rateTotalCustomCurr(cards){
            var convertTotal = 0;
            angular.forEach(cards,function(value){
                if(value.rate_obj){
                    convertTotal += parseFloat(value.rate_obj.leg_total_cost);
                }
            });

            if($rootScope &&$rootScope.precision_decimals){
              convertTotal = $filter('number')(convertTotal, $rootScope.precision_decimals);
              }else{
                convertTotal = $filter('number')(convertTotal, 2);
              }            
            convertTotal = Number(convertTotal.split(',').join(''));
            return convertTotal;
        }


        // function to get the remarks or inclusion of cards
        function getCardRemarksInclusion(cardObj, key) {
            return resultService.getCardRemarksInclusion(cardObj, key);
        }


        /**
         *  function to calculate all card charges
         */
        function allCardCharges(){
            vm.currentCard.allCharges = [];
            angular.forEach(vm.currentCard.cardObject.cardLegs,function(value,key){
                if(value ){
                    angular.forEach(value.charges,function(childVal,childKey){
                        // childVal['customer_curr'] = value.leg_total_currency;
                        vm.currentCard.allCharges.push(childVal);
                    });
                }
            });
        }

        function cancelDialog(){
            $mdDialog.hide();
        }

        function downloadSourceRate(currCard){
          var batchcode=[]
          batchcode=resultService.getBatchcode(currCard)
          if(batchcode.length>0){
            resultService.getSourceRate(batchcode).then(function(response){
            vm.sourceRate=angular.copy(response.data.data);
            })
          }
        }

        function freeDaysTabView(){
          vm.viewActiveTab = 'loadWiseFreeDays';
        }
        // function showAlert(message){
        //     $mdToast.show(
        //         $mdToast.simple()
        //           .textContent(message)
        //           .position('top right')
        //     );
        // }

        // function getStatus(quoteData){
        //     var statusResult = '';

        //     if(quoteData == 'EXPIRED'){
        //         statusResult = 'pink-50-bg pink-400-fg';
        //     }
        //     else if(quoteData == 'NEW'){
        //         statusResult = 'indigo-100-bg indigo-400-fg';
        //     }
        //     else if(quoteData == 'ACTIVE'){
        //         statusResult = 'green-A700-fg green-A100-bg';
        //     }
        //     return statusResult;
        // }


    }
})();

(function () {
  'use strict';

  angular
    .module('app.shipments')
    .controller('productsShipmentController', ProductShipmentController);

  /** @ngInject */
  function ProductShipmentController(ShipmentService, $log, $mdToast, util, api, $timeout, $mdDialog, $scope, $q) {

    var vm = this;
    vm.cancelDialog = cancelDialog;
    vm.addRow = addRow;
    vm.saveProducts = saveProducts;
    vm.initialApiDataCalls = initialApiDataCalls;
    vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
    vm.fnDeleteData = fnDeleteData;
    vm.addedProducts = [];
    vm.editedProducts = [];
    vm.requiredFieldsEmpty = requiredFieldsEmpty;
    vm.emtyObject = {
      sku_id: '',
      product_number: '',
      description: '',
      quantity_size: '',
      gross_weight: '',
      weight_unit: '',
      invoice_details: '',
      sb_details: ''
    }
    // vm.showAlert = showAlert;
    vm.shipProductData = {};
    vm.permission = null;
    vm.getData = false;

    function init() {
      vm.initialApiDataCalls();
    }

    function initialApiDataCalls() {
      vm.shipProductData = ShipmentService.shipmentManagementObj.shipment_data.nav.find(function (item) {
        return item.name == "PRODUCTS";
      });

      api.shipment.product.get({
        'shipment_id': ShipmentService.shipment_id
      }, function (response) {
        if (response.status === "success") {
          vm.shipProductData.data["product"].data = response.data;
          vm.productList = vm.shipProductData.data["product"].data;
          vm.productUrl = vm.shipProductData.data["product"].url;
          vm.permission = util.splitIntoArray(vm.shipProductData.data["product"].permission);
          vm.tempList = angular.copy(vm.productList);
          vm.getData = true;
          vm.dataErr = false;
        }

        // vm.permission.schedule = vm.shipDetailsData.data["schedule"].permission.split('');
      }, function (err) {
        vm.dataErr = true;
        util.showToast(util.displayValidationError(err));
        $log.error(err);
      })
    }

    $scope.$on('tabInitEvent', function (event, data) {
      if (data == 'PRODUCTS') {
        init();
      }
    });

    function addRow() {
      vm.httpErr = false;
      var row = angular.copy(vm.emtyObject);
      vm.productList.push(row);
      vm.emptyProduct = angular.copy(row);
      vm.addedProducts.push(row);
    }

    function requiredFieldsEmpty() {
      vm.addedProducts.forEach(function (x, y) {
        if (x.sku_id === '' || x.product_number === '' || x.gross_weight === '' || x.weight_unit === '') {
          vm.emptyCheck = true;
        } else {
          vm.emptyCheck = false;
        }
      });
    }

    function saveProducts() {
      vm.disableSaveButton = true;
      vm.httpErr = false;

      vm.productList = removeEmptyObjects(vm.productList, vm.emptyProduct);
      vm.addedProducts = removeEmptyObjects(vm.addedProducts, vm.emptyProduct);

      vm.editedProducts = getChangesInList(vm.tempList, vm.productList);
      vm.editedProducts = vm.editedProducts.filter(function (k) {
        if (k._id) {
          return k;
        }
      });
      vm.emptyCheck = false;
      requiredFieldsEmpty();

      if (vm.addedProducts.length !== 0 && !vm.emptyCheck) {
        postCall();
      } else if (vm.editedProducts.length == 0 && !vm.emptyCheck) {
        $timeout(function () {
          vm.disableSaveButton = false;
          util.showToast("Nothing to save!");
        }, 1000)
      }

      if (vm.emptyCheck) {
        $timeout(function () {
          vm.disableSaveButton = false;
          util.showToast("Don't leave * fields empty");
        }, 1000)
      }

      if (vm.editedProducts.length !== 0) {
        updateProducts(vm.editedProducts);
      }
    }

    function updateProducts(arr) {
      var deferred = $q.defer();

      var promiseList = [];
      arr.forEach(function (k) {
        promiseList.push(putCall(k));
      });

      $q.all(promiseList).
      then(function (response) {
        deferred.resolve(response);
        $timeout(function () {
          vm.disableSaveButton = false;
        }, 1000)
        vm.tempList = angular.copy(vm.productList);
        vm.editedProducts = [];
      }).catch(function (error) {
        deferred.reject(error);
      });
    }

    function putCall(k) {
      if (angular.equals(vm.tempList, vm.productList) == false) {
        var data = {
          data: k
        }
        api.shipment.product.update({
            'shipment_id': ShipmentService.shipment_id,
            'id': k._id
          }, data,
          function (res) {
            if (res.status === "success") {
              vm.httpErr = false;
              util.showToast("Product updated successfully.");
            }
          },
          function (err) {
            vm.httpErr = true;
            util.showToast(util.displayValidationError(err));
            $log.error(err);
          }
        );
      }

    }

    function postCall() {
      if (angular.equals(vm.tempList, vm.productList) == false) {
        var dataArr = {
          data: vm.addedProducts
        };

        api.shipment.product.savelist({
            'shipment_id': ShipmentService.shipment_id
          }, dataArr,
          function (res) {
            var listLength = vm.addedProducts.length;
            res.forEach(function (x, y) {
              if (x.status === "success") {
                vm.httpErr = false;
                vm.productList[vm.productList.length - listLength + y]._id = x.id;
                util.showToast("Product saved successfully.");
              } else if (x.status === "error") {
                util.showToast("Failed to save Product.");
                vm.promiseList.splice(vm.promiseList.length - (y + 1), 1);
                vm.httpErr = true;
              }
            });
            vm.tempList = angular.copy(vm.productList);
            vm.addedProducts = [];
            $timeout(function () {
              vm.disableSaveButton = false;
            }, 1000)
          },
          function (err) {
            vm.httpErr = true;
            vm.disableUploadButton = false; 
            util.showToast(util.displayValidationError(err));
            $log.error(err);
          }
        );
      }
    }

    var removeEmptyObjects = function (arr, emptyobj) {
      arr = arr.filter(function (k) {
        if (angular.equals(emptyobj, k) == false) {
          return k;
        }
      });
      return arr;
    }

    var getChangesInList = function (oldArray, newArray) {
      var changes, i, item, j, len;
      if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
        return [];
      }
      changes = [];
      for (i = j = 0, len = newArray.length; j < len; i = ++j) {
        item = newArray[i];
        if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
          changes.push(item);
        }
      }
      return changes;
    };

    function fnOpenConfirmDeleteModal(id, index, ev) {
      if(angular.equals(vm.emtyObject, vm.productList[index])) {
        vm.productList.splice(index, 1);
      } else {
        vm.httpErr == false;
        vm.deleteId = id;
        vm.deleteIndex = index;

        $mdDialog.show({
          templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          controllerAs: 'ctrl',
          controller: function () {
            this.parent = vm
          }
        });
      }
    }

    // $scope.$watch('vm.productList', function(newValue,oldValue){
    //   vm.editedProducts = newValue;
    // },true);

    function fnDeleteData() {
      if(!angular.equals(vm.tempList, vm.productList)) {
        vm.productList.splice(vm.deleteIndex, 1);
        $mdDialog.hide();
      } else {
        vm.httpErr == false;

        api.shipment.product.remove({
            'shipment_id': ShipmentService.shipment_id,
            'id': vm.deleteId
          },
          function (res) {
            if (res.status === "success") {
              vm.productList.splice(vm.deleteIndex, 1);
              vm.httpErr = false;
              util.showToast("Row deleted successfully.");
              $mdDialog.hide();
            }
            vm.tempList = angular.copy(vm.productList);
          },
          function (err) {
            vm.httpErr = true;
            util.showToast(util.displayValidationError(err));
            $log.error(err);
            $mdDialog.hide();
          }
        );
      }
    }

    function cancelDialog() {
      $mdDialog.hide();
    };

    // function showAlert(message){
    //   $mdToast.show(
    //       $mdToast.simple()
    //         .textContent(message)
    //         .position('top right')
    //   );
    // }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.shipments')
        .controller('feedShipmentController', FeedShipmentController);

    /** @ngInject */
    function FeedShipmentController(ShipmentService, $log, util, api, $timeout, $mdDialog, $state, $scope, $filter) {

        var vm = this;
        vm.getData = false;
        vm.init = init;
        vm.postText = "";
        vm.send_notification = false;
        vm.feedData = {};
        vm.statusData = {};
        vm.shipDetailsData = {};
        vm.getFeeds = getFeeds;
        vm.getStatus = getStatus;
        vm.initialApiDataCalls = initialApiDataCalls;
        vm.permission = {
            "activity_feed" : [],
            "status" : []
        };
        vm.taToolbar = [
            ['quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink']
        ];
        vm.fnSubmitPost = fnSubmitPost;
        vm.cancelDialog = cancelDialog;
        vm.userData = {};
        vm.getProfileData = getProfileData;
        vm.getProfileData();

        CKEDITOR.config.image_previewText = CKEDITOR.tools.repeat( ' ', 1 );
        // vm.util.ckEditorConfig.removeButtons = 'About,Image'
        // vm.showAlert = showAlert;

        function init(){
            vm.initialApiDataCalls();
        }

        //function to get user profile data
        function getProfileData(){
            return util.getProfile().then(function(response){
                vm.userData = response.user;
                return vm.userData;
            },function(error){
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        }

        $scope.$on('updateFeedsAndStatus',function(){
            vm.initialApiDataCalls();
        })

        //method to get all the modules data on page Load
        function initialApiDataCalls(){
            if($state.current.name === 'app.shipments.shipment_details' || $state.current.name === 'app.shared_shipment_details'  || $state.current.name  == 'app.mobile_shipment_details'){
                vm.shipDetailsData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
                    return item.name == "FEED";
                });
                vm.getFeeds();
                vm.getStatus();
            }
        }

        //function to get feeds details
        function getFeeds(){
            vm.permission.activity_feed = util.splitIntoArray(vm.shipDetailsData.data["activity_feed"].permission);
            vm.feedDataUrl = vm.shipDetailsData.data["activity_feed"].url;
            if(vm.permission.activity_feed[1]){
                api.shipment.activity_feed.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["activity_feed"].data = response.data;
                        vm.feedData = vm.shipDetailsData.data["activity_feed"].data;
                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }

                },function(err){
                    if(err.status === 401) {
                        $timeout.cancel(vm.autoUpdate);
                    }
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }
        }

        //function to get status details
        function getStatus(){
            vm.permission.status = util.splitIntoArray(vm.shipDetailsData.data["status"].permission);
            vm.statusUrl = vm.shipDetailsData.data["status"].url;
            if(vm.permission.status[1]){
                api.shipment.status.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["status"].data = response.data;
                        vm.statusData = vm.shipDetailsData.data["status"].data;
                        vm.getData = true;
                        vm.statusData.sort(function (a, b) {
                            var key1 = new Date(a.changed_date);
                            var key2 = new Date(b.changed_date);

                            if (key1 < key2) {
                                return -1;
                            } else if (key1 == key2) {
                                return 0;
                            } else {
                                return 1;
                            }
                        });
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }
        }

        $scope.$on('tabInitEvent',function(event,data){
            if(data == 'FEED'){
                vm.init();
            }
        })

        //function to submit post
        function fnSubmitPost(){
            if(vm.postText != ""){
                vm.disabledPost = true;
                var todaysDate = new Date();
                var dateTime = $filter('date')(todaysDate, 'd MMM yyyy h:mm a');
                var postData = "<div layout='column' class='feedDiv' flex='100'><div layout='row' class='pt-15' flex='100'><div class='avatar-container'><ng-avatar string='"+vm.userData.user_first_name+" "+vm.userData.user_last_name+"'round-shape='true' auto-color='true'></ng-avatar></div><div layout='column' class='pt-5 pl-15 layout-column flex-85' flex='85'><div class='font-size-14'><b>"+vm.userData.user_first_name+" "+vm.userData.user_last_name+"</b></div><span class='font-size-12 gray-color'>"+dateTime+"</span><div class='feed_border mv-20 mr-10 font-size-14' flex='100'><div class='m-10'><div class='render-content'>"+vm.postText+"</div></div></div></div></div></div>";

                var saveData={
                    "data" : {
                        "happened_at" : dateTime,
                        "feed" : postData,
                        "send_notification" : vm.send_notification
                    }
                }
                util.isCallingApi = true;
                api.shipment.activity_feed.save({'shipment_id':ShipmentService.shipment_id},saveData,function(response){
                    vm.feedData.unshift(saveData.data);
                    vm.postText = "";
                    vm.disabledPost = false;
                    util.isCallingApi = false;
                    util.showToast("You have posted successfully.");

                },function(err){
                    util.isCallingApi = false;
                    util.showToast(util.displayValidationError(err));
                    vm.disabledPost = false;
                    $log.error(err);
                })
            }
        }

        function cancelDialog(){
            $mdDialog.hide();
        }

        // function showAlert(message){
        //     $mdToast.show(
        //         $mdToast.simple()
        //           .textContent(message)
        //           .position('top right')
        //     );
        // }



    }
})();

(function () {
  "use strict";

  angular
    .module("app.shipments")
    .controller("documentsShipmentController", DocumentShipmentController);

  /** @ngInject */
  function DocumentShipmentController(
    ShipmentService,
    $filter,
    $log,
    util,
    api,
    $timeout,
    $mdDialog,
    $scope,
    loginSerivice,
    $sanitize,
    $window,
    $rootScope,
    QuotesService
  ) {
    var vm = this;
    vm.util = util;
    vm.cancelDialog = cancelDialog;
    vm.selectFile = selectFile;
    // vm.uploadPic = uploadPic;
    vm.fnOpenRejectResonModal = fnOpenRejectResonModal;
    vm.fnOpenCommentModal = fnOpenCommentModal;
    vm.fnOpenModifyDateModal = fnOpenModifyDateModal;
    vm.uploadFile = uploadFile;
    vm.file = {};
    vm.errMsg = false;
    vm.docFile = null;
    vm.setStatus = setStatus;
    vm.rejectComment = "";
    vm.initialApiDataCalls = initialApiDataCalls;
    vm.addDeadlineToList = addDeadlineToList;
    vm.currentDate = new Date(Date.now());
    vm.newComment = newComment;
    vm.closeComment = closeComment;
    vm.deleteDocument = deleteDocument;
    vm.newDeadlineDate = null;
    vm.shipment_meta = ShipmentService.shipmentManagementObj.shipment_meta;
    vm.changedDeadline = changedDeadline;
    vm.getUidata = getUidata;
    vm.syncData = syncData;
    vm.toggleCheckbox = toggleCheckbox;
    vm.cancelSelectionMenu = cancelSelectionMenu;
    vm.documentSelection = false;
    vm.selectedSyncDocument = [];
    vm.fetchSyncData = fetchSyncData;
    vm.reSyncData = reSyncData;
    vm.trackEvent = trackEvent;
    vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
    vm.fnDeleteData = fnDeleteData;
    vm.getData = false;
    vm.isShipper = util.isShipper;
    vm.isShareable = util.isSharedPage();
    vm.checkFields = checkFields;
    vm.file.name = "";
    vm.disableUploadButton = true;
    vm.setFile = setFile;
    vm.disableClick = false;
    vm.downloadAllFile = downloadAllFile;
    vm.deleteType = "";
    vm.fileTypeList = [
      "DO/CRO",
      "Draft B/L",
      "Freight Invoice",
      "Commercial Invoice",
      "Original B/L",
      "Shipping Instructions",
      "Form 13/EIR",
      "VGM",
      "Shipping Bill",
      "Weighment Slip",
      "Certificates",
      "Licenses",
      "Packing List",
      "MSDS",
      "Booking Confirmation",
      "Other",
    ];

    vm.permission = null;

    vm.DocumentList = [];
    vm.shipDocumentData = {};
    vm.resetInputs = resetInputs;

    vm.fileSize = 20971520; //20 MB in bytes ,i.e. 20*1024*1024
    // List of allowed file extensions and MIME types
    vm.fileType = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-outlook",
      "text/csv",
      "application/pdf",
      "application/zip",
      "text/plain",
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/tiff",
      "image/svg+xml",
      "image/x-icon",
      "image/jp2",
      "image/avif",
      "image/heic",
    ];
    vm.fileSizeErrorMessage =
      "This file is too large, maximum file size is 20MB.";
    vm.fileTypeErrorMesssage =
      "Please upload only .pdf, .xls, .csv, .xlsx, .doc, .docx, .zip, .msg format or image files.";
    vm.tms_enabled = $rootScope.domainData.domain_info.TMS_ENABLED;
    vm.toggleAllCheckbox = toggleAllCheckbox;

    function init() {
      vm.initialApiDataCalls();
      // vm.file.type = vm.fileTypeList[0];
      var currentDate = new Date(Date.now());
      vm.dateMin = new Date();
      vm.file.approval_deadline = new Date(currentDate.getTime());
      vm.file.is_approval_required = "0";
      vm.changedComment = false;
      vm.getUidata();
    }
    init();

    $scope.$on("tabInitEvent", function (event, data) {
      if (data == "DOCUMENTS") {
        init();
      }
    });

    function setFile(file) {
      vm.picFile = file;
      vm.docFile = file;
      vm.checkFields();
    }
    function toggleAllCheckbox() {
      vm.selectedAll = !vm.selectedAll;
      if (vm.selectedAll) {
        vm.selectedSyncDocument = [];
        angular.forEach(vm.DocumentList, function (item) {
          if (item.sync_status.toLowerCase() != "success") {
            item.checked = true;
            vm.selectedSyncDocument.push(item);
          }
        });
      } else {
        angular.forEach(vm.DocumentList, function (item) {
          item.checked = false;
        });
        vm.selectedSyncDocument = [];
      }
    }

    function trackEvent(type) {
      util.callMixpanel(type, {
        Mode: vm.shipment_meta.mode,
      });
    }
    function toggleCheckbox(ev, item) {
      const checked = item.checked ? false : true;
      if (checked) {
        console.log();
        if (
          !vm.selectedSyncDocument.some(function (doc) {
            return doc._id == item._id;
          })
        ) {
          vm.selectedSyncDocument.push(item);
        }

        // else{
        //   vm.selectedSyncCard=[]
        //   vm.selectedSyncCardRef={}
        // }
      } else {
        vm.selectedSyncDocument.forEach(function (doc) {
          if (item._id == doc._id) {
            // doc.checked=false;
            // item.checked=false;
            vm.selectedSyncDocument.splice(
              vm.selectedSyncDocument.indexOf(item),
              1
            );
          }
        });
      }
    }
    function cancelSelectionMenu() {
      vm.documentSelection = false;
      vm.uiData.integrationComponentOptions.menu.isEnabled = true;
      vm.selectedSyncDocument.forEach(function (item) {
        item.checked = false;
      });
      vm.selectedSyncDocument = [];
    }
    function fetchSyncData(ev) {
      vm.uiData.integrationComponentOptions.menu.isEnabled = true;
      vm.documentSelection = false;
      util.isCallingApi = true;

      var data = {
        id: ShipmentService.shipment_id,
        vendor_id: vm.shipment_meta.vendor_id,
        entity:vm.selectedMenu.label,
        partner: vm.shipment_meta.partner,
        partner_reference_id: vm.shipment_meta.partner_reference_id,
        // "partner": 'cargowise',
        //  "partner_reference_id": 'SBJS25SO00053',
        documents: vm.selectedSyncDocument,
      };

      ShipmentService.syncDocument(data, "shipment").then(
        function (response) {
          vm.DocumentList = vm.DocumentList.map(function (item) {
            item.checked = false;
            var match = response.data.find(function (ele) {
              return ele._id === item._id;
            });
            return match ? match : item;
          });
          vm.addDeadlineToList();
          vm.selectedSyncDocument = [];
          util.isCallingApi = false;
        },
        function (error) {
          util.isCallingApi = false;
          vm.uiData.integrationComponentOptions.menu.isEnabled = true;

          util.showToast(error.data.message);
          $log.log(error);
        }
      );
    }

    function reSyncData(data) {
      vm.selectedSyncDocument.push(data);
      vm.fetchSyncData();
    }

    function checkFields() {
      if (
        vm.file.name !== "" &&
        vm.file.type !== undefined &&
        vm.docFile !== null &&
        vm.docFile !== undefined
      ) {
        vm.disableUploadButton = false;
      } else {
        vm.disableUploadButton = true;
      }
    }

    function initialApiDataCalls(isRefresh) {
      if (isRefresh) {
        vm.spinRefreshIcon = true;
        util.callMixpanel("SD-Documents-BtnRefresh-Clk", {
          Mode: vm.shipment_meta.mode,
          "Shipment Status": vm.shipment_meta.current_status.status,
        });
      }
      vm.shipDocumentData =
        ShipmentService.shipmentManagementObj.shipment_data.nav.find(function (
          item
        ) {
          return item.name == "DOCUMENTS";
        });

      api.shipment.documents.get(
        {
          shipment_id: ShipmentService.shipment_id,
        },
        function (response) {
          if (response.status === "success") {
            vm.shipDocumentData.data["document"].data = response.data;
            vm.DocumentList = vm.shipDocumentData.data["document"].data;
            vm.DocumentList = vm.DocumentList.reverse();
            vm.documentUrl = vm.shipDocumentData.data["document"].url;
            vm.permission = util.splitIntoArray(
              vm.shipDocumentData.data["document"].permission
            );
            vm.addDeadlineToList();
            vm.getData = true;
            vm.dataErr = false;
            vm.spinRefreshIcon = false;
          }
        },
        function (err) {
          vm.spinRefreshIcon = false;
          vm.dataErr = true;
          util.showToast(util.displayValidationError(err));
          $log.error(err);
        }
      );
    }

    function getUidata() {
      vm.syncShimmer = true;
      ShipmentService.getSyncUiData(
        ShipmentService.shipment_id,
        "shipment",
        "document"
      ).then(
        function (response) {
          vm.uiData = response.data;

          var checkData = vm.shipment_meta.partner_reference_id;
          vm.uiData.integrationComponentOptions.menu.isEnabled = checkData
            ? vm.uiData.integrationComponentOptions.menu.isEnabled
            : false;
          vm.uiData.integrationComponentOptions.menu["tooltipText"] = checkData
            ? ""
            : "Need to sync shipment first to sync documents";
          vm.syncShimmer = false;
        },
        function (error) {
          vm.uiData = [];
          vm.syncShimmer = false;
          $log.log(error);
        }
      );
    }
    function syncData(submenus) {
      vm.selectedMenu = submenus;
      vm.documentSelection = true;
      vm.selectedSyncDocument = [];
    }

    function addDeadlineToList() {
      vm.httpErr == false;
      vm.DocumentList.forEach(function (arrayItem) {
        var date = arrayItem.created_at;
        // if ((date instanceof Date) == false) {
        //   date = date.split(' ').join('T');
        //   date = new Date(date);
        // }

        date = moment.utc(date).local();

        // date = moment.utc(date).format().local();

        arrayItem.time_ago = timeSince(date);
        // if (arrayItem.approval_deadline instanceof Date) {
        //   // arrayItem.approval_deadline = arrayItem.approval_deadline.split(' ').join('T');
        //   // arrayItem.approval_deadline = new Date(arrayItem.approval_deadline);
        // } else {
        //   arrayItem.approval_deadline = new Date(Date.now());
        // }

        vm.currentDate = moment.utc(vm.currentDate).format();
        var compareDate = new Date(arrayItem.approval_deadline);
        compareDate = compareDate.setHours(0, 0, 0, 0);
        vm.currentDate = new Date(vm.currentDate);
        vm.currentDate = vm.currentDate.setHours(0, 0, 0, 0);

        if (vm.currentDate > compareDate) {
          arrayItem.has_expired = 1;
        } else {
          arrayItem.has_expired = 0;
        }
      });
      vm.tempList = angular.copy(vm.DocumentList);
    }

    // approve/reject functionality

    function fnOpenRejectResonModal(ev, index, data) {
      vm.reasonValidation = false;
      vm.disableClick = true;
      vm.httpErr == false;
      vm.rejectComment = "";
      vm.rejectIndex = index;
      vm.rejectData = data;
      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/reject-reason/reject-reason.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        onRemoving: (vm.disableClick = false),
        controller: function () {
          this.parent = vm;
        },
      });
    }

    function setStatus(status, index, statusData, form) {
      if (status === "REJECTED" && !vm.rejectComment && !form.reason.$invalid) {
        vm.reasonValidation = true;
        return;
      }
      if (status === "REJECTED" && form && form.reason.$invalid) {
        return;
      }

      var data = angular.copy(statusData);
      vm.httpErr == false;
      if (status === "APPROVED") {
        vm.status = "APPROVED";
        data.status = vm.status;
      } else if (status === "REJECTED") {
        vm.status = "REJECTED";
        data.reject_reason = vm.rejectComment;
        data.status = vm.status;
      }

      var payload = {};
      payload.data = angular.copy(data);
      delete payload.data["_id"];

      if (vm.disableClick === true) {
        return;
      }

      vm.disableClick = true;
      api.shipment.documents.update(
        {
          shipment_id: ShipmentService.shipment_id,
          id: data._id,
        },
        payload,
        function (res) {
          if (res.status === "success") {
            vm.httpErr = false;
            vm.DocumentList[index].status = vm.status;
            vm.DocumentList[index].reject_reason = vm.rejectComment;
            if (status === "APPROVED") {
              util.showToast("Document approved successfully!");
            } else {
              util.showToast("Document rejected successfully!");
            }
            vm.rejectComment = "";
            vm.disableClick = false;
          }
        },
        function (err) {
          vm.disableClick = false;
          vm.httpErr = true;
          util.showToast(util.displayValidationError(err));
          $log.error(err);
        }
      );
      vm.cancelDialog();
    }
    // end of approve/reject functionality

    // comment functionality

    function fnOpenCommentModal(ev, data, index) {
      vm.httpErr == false;
      vm.commentValidation = false;
      vm.commentData = data;
      vm.commentData.index = index;
      vm.comment = data.comment;
      $mdDialog.show({
        templateUrl: "app/main/shipments/dialogs/comment/comment.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    function newComment() {
      vm.changedComment = true;
    }

    function closeComment(id, index) {
      if (!vm.comment) {
        vm.commentValidation = true;
        return;
      }
      if (vm.changedComment == true) {
        var document = {
          data: {
            comment: vm.comment,
          },
        };
        api.shipment.documents.update(
          {
            shipment_id: ShipmentService.shipment_id,
            id: id,
            // 'id': id
          },
          document,
          function (res) {
            if (res.status === "success") {
              vm.DocumentList[index].comment = vm.comment;
              util.showToast("Comment updated successfully!");
              vm.httpErr = false;
            }
          },
          function (err) {
            vm.httpErr = true;
            util.showToast(util.displayValidationError(err));
            $log.error(err);
          }
        );
      }
      vm.changedComment = false;
      vm.commentData = "";
      vm.cancelDialog();
    }
    // end of comment functionality

    // modify deadline functionality

    function fnOpenModifyDateModal(ev, id, index) {
      vm.httpErr == false;
      vm.deadlineIndex = index;
      vm.deadlineId = id;
      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/modify-deadline/modify-deadline.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    function changedDeadline(id, index) {
      vm.httpErr == false;
      var document = {
        data: {
          approval_deadline: vm.newDeadlineDate,
        },
      };
      api.shipment.documents.update(
        {
          shipment_id: ShipmentService.shipment_id,
          id: id,
          // 'id': id
        },
        document,
        function (res) {
          if (res.status === "success") {
            util.showToast("Deadline updated successfully!");
            vm.DocumentList[index].approval_deadline = vm.newDeadlineDate;
            vm.addDeadlineToList();
            vm.httpErr = false;
          }
        },
        function (err) {
          vm.httpErr = true;
          util.showToast(util.displayValidationError(err));
          $log.error(err);
        }
      );
      vm.cancelDialog();
    }
    // end of modify deadline functionality

    // delete document functionality

    function deleteDocument(id, index) {
      vm.httpErr == false;
      api.shipment.documents.remove(
        {
          shipment_id: ShipmentService.shipment_id,
          id: id,
        },
        function (res) {
          if (res.status === "success") {
            util.showToast("Document deleted successfully!");
            vm.DocumentList.splice(index, 1);
            vm.httpErr = false;
          }
        },
        function (err) {
          vm.httpErr = true;
          util.showToast(util.displayValidationError(err));
          $log.error(err);
        }
      );
    }

    function fnOpenConfirmDeleteModal(id, index, ev) {
      vm.httpErr == false;
      vm.deleteId = id;
      vm.deleteIndex = index;
      vm.deleteType = "Document";
      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/confirm-delete/confirm-delete.html",
        targetEvent: ev,
        clickOutsideToClose: true,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    function fnDeleteData() {
      vm.deleteBtn = true;
      vm.httpErr == false;
      api.shipment.documents.remove(
        {
          shipment_id: ShipmentService.shipment_id,
          id: vm.deleteId,
        },
        function (res) {
          if (res.status === "success") {
            vm.deleteBtn = false;
            vm.DocumentList.splice(vm.deleteIndex, 1);
            vm.httpErr = false;
            // vm.showAlert("Document deleted successfully.");
            util.showToast("Document deleted successfully.");
            $mdDialog.hide();
          }
        },
        function (err) {
          vm.httpErr = true;
          util.showToast(util.displayValidationError(err));
          $log.error(err);
          $mdDialog.hide();
        }
      );
    }
    // end of delete document functionality

    // upload file functionality

    function uploadFile(file) {
      vm.disableUploadButton = true;
      vm.showProgressBar = true;
      if (file == undefined) {
        vm.noFile = true;
        vm.disableUploadButton = false;
      } else {
        vm.noFile = false;

        vm.httpErr == false;
        vm.errMsg = false;
        var data = {
          name: vm.file.name,
          type: vm.file.type,
          comment: vm.file.comment,
          is_approval_required: vm.file.is_approval_required,
          approval_deadline: vm.file.approval_deadline,
          created_at: new Date(Date.now()),
          updated_at: new Date(Date.now()),
          file: {},
        };

        if (
          data.name == undefined ||
          data.name == "" ||
          data.type == undefined ||
          data.type == "" ||
          data.approval_deadline == null
        ) {
          vm.errMsg = true;
          vm.disableUploadButton = false;
        }

        data.is_approval_required = parseInt(data.is_approval_required);

        if (vm.DocumentList.length !== 0) {
          var lastData = {};
          lastData = angular.copy(vm.DocumentList[vm.DocumentList.length - 1]);
          var lastCheck = {
            a: lastData.name,
            b: lastData.type,
            c: lastData.is_approval_required,
            d: lastData.approval_deadline,
          };
          var compareData = {
            a: data.name,
            b: data.type,
            c: data.is_approval_required,
            d: data.approval_deadline,
          };

          if (angular.equals(lastCheck, compareData) == false) {
            vm.sameData = false;
          } else {
            vm.sameData = true;
            vm.disableUploadButton = false;
          }
        } else {
          vm.sameData = false;
        }

        if (vm.errMsg == false && vm.sameData == false) {
          var form = new FormData();
          form.append("shipment_docs[file]", file);
          form.append("data[file_name]", util.escapeHtml(vm.file.name));
          form.append("data[name]", util.escapeHtml(file.name));
          form.append("data[type]", vm.file.type);
          if (vm.file.comment == undefined) {
            form.append("data[comment]", "");
          } else {
            form.append("data[comment]", util.escapeHtml(vm.file.comment));
          }
          form.append(
            "data[is_approval_required]",
            vm.file.is_approval_required
          );
          if (vm.file.is_approval_required == "1") {
            form.append("data[approval_deadline]", vm.file.approval_deadline);
          }

          if (!loginSerivice.isLogin()) {
            form.append("data[is_uploaded_by_party]", 0);
          } else {
            form.append("data[is_uploaded_by_party]", 1);
          }
          var url = ShipmentService.shipment_id + "/documents";

          $scope.$broadcast("progressCircleShow", { action: true });

          ShipmentService.saveFileUpload(form, url).then(
            function (response) {
              var resData = JSON.parse(response);
              if (resData.status === "success") {
                angular.element(document.querySelector("#remove_doc")).click();
                vm.onSelect = false;
                vm.uploadButton = false;
                vm.DocumentList.unshift(resData.data);
                vm.addDeadlineToList();
                vm.resetInputs();
                // vm.showAlert("Document uploaded successfully.");
                util.showToast("Document uploaded successfully.");
                vm.disableUploadButton = true;
              }
              vm.showProgressBar = false;
              $scope.$broadcast("progressCircleShow", { action: false });
            },
            function (error) {
              var err = JSON.parse(error.responseText);
              vm.showProgressBar = false;
              $scope.$broadcast("progressCircleShow", { action: false });
              vm.disableUploadButton = false;
              angular.element(document.querySelector("#remove_doc")).click();
              // vm.showAlert("Failed to upload Document.");
              util.showToast(util.displayValidationError(err));
              $log.error(err);
              // shipment details shared api access otp expired..
              if (err.message === "OTP Expired") {
                $rootScope.$broadcast("apiResponseOtpExpired");
              }
            }
          );
        }
      }
    }

    vm.beforeSelect = true;
    vm.onSelect = false;
    vm.afterSelect = false;

    function selectFile() {
      angular.element(document.querySelector("#fileInput_document")).click();
      // vm.docFile = document.querySelector('#fileInput_document');
      // vm.disableUploadButton = false;
    }

    // end of upload file functionality

    function timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);
      var interval = Math.floor(seconds / 31536000);
      if (interval > 1) {
        return interval + " years";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours";
      }
      interval = Math.floor(seconds / 60);
      if (interval >= 1) {
        return interval + " minutes";
      }
      if (seconds < 0) {
        return "0 seconds";
      }
      return Math.floor(seconds) + " seconds";
    }

    function cancelDialog() {
      $mdDialog.hide();
    }

    // function to download all files -ankita
    function downloadAllFile() {
      vm.disabledDownloadAllBtn = true;
      ShipmentService.downloadAllDoc(ShipmentService.shipment_id).then(
        function (response) {
          vm.disabledDownloadAllBtn = false;
          $window.open(util.sanitizeQueryParams(response.data));
        },
        function (error) {
          vm.disabledDownloadAllBtn = false;
          util.showToast(util.displayValidationError(error));
          $log.error(error);
        }
      );
    }

    // function showAlert(message){
    //   $mdToast.show(
    //       $mdToast.simple()
    //         .textContent(message)
    //         .position('top right')
    //   );
    // }

    // clearing inputs
    function resetInputs() {
      vm.file.approval_deadline = new Date(Date.now());
      vm.file.approval_deadline = new Date(vm.file.approval_deadline.getTime());
      vm.file.is_approval_required = "0";
      vm.changedComment = false;
      vm.file.name = "";
      vm.file.file_name = "";
      vm.file.type = undefined;
      vm.file.comment = "";
      vm.picFile = null;
      vm.setFile(vm.picFile);
      $scope.$broadcast("clearFile");
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.shipments')
    .controller('containersShipmentController', ContainerShipmentController);

  /** @ngInject */
  function ContainerShipmentController(ShipmentService, $log, util, api, $timeout, $mdDialog, $scope) {

    var vm = this;
    vm.cancelDialog = cancelDialog;
    vm.initialApiDataCalls = initialApiDataCalls;
    vm.shipContainerData = {};
    vm.getData = false;
    vm.shipment_meta = ShipmentService.shipmentManagementObj.shipment_meta;
    vm.trackEvent = trackEvent;
    vm.updateContainer = updateContainer;
    vm.editedContainers=[];
    // vm.emptyProduct = {
    //   container_number: '',
    //   seal_number: '',
    //   bl_number: '',
    //   tare_weight: '',
    //   empty_container_pickup: '',
    //   empty_conatiner_drop_off: '',
    //   company: '',
    //   container_type: '',
    // }

    function init() {
      vm.initialApiDataCalls();
    }

    function initialApiDataCalls() {
      vm.shipContainerData = ShipmentService.shipmentManagementObj.shipment_data.nav.find(function (item) {
        return item.name == "CONTAINERS";
      });

      api.shipment.container.get({
        'shipment_id': ShipmentService.shipment_id
      }, function (response) {
        if (response.status === "success") {
          vm.shipContainerData.data["container"].data = response.data;
          vm.containerList = vm.shipContainerData.data["container"].data;
          vm.permission = util.splitIntoArray(vm.shipContainerData.data["container"].permission);
          vm.tempList = angular.copy(vm.containerList);
          vm.getData = true;
          // vm.containerUrl = vm.shipContainerData.data["container"].url;
          vm.dataErr = false;
        }

        // vm.permission.schedule = vm.shipDetailsData.data["schedule"].permission.split('');
      }, function (err) {
        vm.dataErr = true;
        util.showToast(util.displayValidationError(err));
        $log.error(err);
      })
    }

    $scope.$on('tabInitEvent', function (event, data) {
      if (data == 'CONTAINERS') {
        init();
      }
    });

    function cancelDialog() {
      $mdDialog.hide();
    };

    function trackEvent(type){
      util.callMixpanel(type,{
        "Mode":vm.shipment_meta.mode
      });
    }

    function updateContainer() {
      vm.disableSaveButton = true;
      vm.editedContainers = getChangesInList(vm.tempList, vm.containerList);

      if (vm.editedContainers.length !== 0) {
        updateRow(vm.editedContainers);
      } else {
        // $timeout(function(){
        vm.disableSaveButton = false;
        util.showToast("Nothing to save!");
        // }, 1000)
      }
    }

    var getChangesInList = function (oldArray, newArray) {
      var changes, i, item, j, len;
      if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
        return [];
      }
      changes = [];
      for (i = j = 0, len = newArray.length; j < len; i = ++j) {

        item = newArray[i];
        if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
          changes.push(item);
        }
      }
      return changes;
    };

    function updateRow(arr) {
      putCall(arr);
      // var deferred = $q.defer();

      // var promiseList = [];
      // arr.forEach(function (k) {
      //   promiseList.push(putCall(k));
      // });

      // $q.all(promiseList).
      // then(function (response) {
      //   deferred.resolve(response);
      //   vm.tempList = angular.copy(vm.containerList);
      //     vm.disableSaveButton = false;
      // }).catch(function (error) {
      //   deferred.reject(error);
      // });
    }

    function putCall(k) {
        var data = {
          data: k
        }

      return ShipmentService.containerPutCall(ShipmentService.shipment_id, data).then(function () {
            util.showToast("Container updated successfully.");
            vm.disableSaveButton = false;
            ShipmentService.isGetLatestTracking = true;
      }, function (err) {
            util.showToast(util.displayValidationError(err));
            vm.disableSaveButton = false;
            $log.error(err);
      });

    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.shipments')
        .controller('carrierbillinginfoShipmentController', CarrierBillingInfoShipmentController);

    /** @ngInject */
  function CarrierBillingInfoShipmentController (ShipmentService, $mdToast, $log, util, analytics,api, $timeout, $mdDialog, $stateParams, $http, QuotesService, $filter, $scope, localStorageService, shareQuoteService,$rootScope,SearchService) {

        var vm = this;
        vm.util = util;
        vm.getDetails = getDetails;
        vm.shipDetailsData = {};
        vm.ShipmentsDetails = {};
        vm.bill_rates = {};
        vm.vendorId = parseInt(localStorageService.get('authToken').value.vendor_id);
        vm.permission = {
            "carrier_billing" : [],
        };
        vm.getProfileData = getProfileData;
        vm.getBillingRates = getBillingRates;
        vm.getCarrierData = false;
        vm.ShipmentsDetails = ShipmentService.shipmentManagementObj.shipment_meta;
        vm.billing_cust_curr = '';
        vm.showExchangeRates = $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;

        //code to get user profile details
        vm.userData = {};
        vm.getProfileData();

        function getProfileData(){
            return util.getProfile().then(function(response){
                vm.userData = response.user;
                return vm.userData;
            },function(error){
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        }

        function getDetails(){
            vm.shipDetailsData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
                return item.name == "CARRIER BILLING INFO";
            });
            vm.getBillingRates();
        }


        //function to get rates details
        function getBillingRates(){

            vm.permission.carrier_billing = util.splitIntoArray(vm.shipDetailsData.data["carrier_billing"].permission);
            vm.bill_ratesUrl = vm.shipDetailsData.data["carrier_billing"].url;
            if(vm.permission.carrier_billing[1]){
                api.shipment.carrier_booking.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["carrier_billing"].data = response;
                        vm.currency_conversion_rates = response.currency_conversion_rate;

                        shareQuoteService.setCurrencyConvSetting(vm.ShipmentsDetails.created_by.user_base_currency ,vm.currency_conversion_rates.markup,vm.currency_conversion_rates.directCurrencyMapping,vm.currency_conversion_rates.curr_data);

                        vm.bill_rates = vm.shipDetailsData.data["carrier_billing"].data;
                        vm.cardVendorId = (vm.bill_rates.legs.length) ? vm.bill_rates.legs[0].vendor_id : 0;
                        vm.billing_cust_curr = vm.bill_rates.card_total.currency;
                   
                        vm.getCarrierData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getCarrierData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getCarrierData = true;
                })
            }
        }

   

        $scope.$on('tabInitEvent',function(event,data){
            if(data == 'CARRIER BILLING INFO'){
                vm.getDetails();
            }
        })





    }
})();

(function () {
    'use strict';

    angular
        .module('app.shipments')
        .controller('contactShipmentController', ContactShipmentController);
    /** @ngInject */
    function ContactShipmentController(ShipmentService, $mdToast, $log, util,api,$timeout,$mdDialog,$scope,$sanitize) {

        var vm = this;
        vm.util = util;
        //vm.size = '200px';
        vm.init = init;
        vm.cancelDialog = cancelDialog;
        vm.fnOpenEditdeatils = fnOpenEditdeatils;
        vm.fnSubmitMgtDetails = fnSubmitMgtDetails;
        vm.trackEvent = trackEvent;
        vm.shipDetailsData = {};
        vm.splitData = splitData;
        vm.shipment_meta = ShipmentService.shipmentManagementObj.shipment_meta;
        vm.shipperExpert = {};
        vm.documentExpert = {};
        vm.customerExpert = {};
        vm.feedback = "";
        vm.fnSubmitPost = fnSubmitPost;
        vm.getSource = getSource;
        vm.getMangementData = getMangementData;
        vm.getFeedBack = getFeedBack;
        vm.getUserList = getUserList;

        // vm.showAlert = showAlert;
        vm.userRoleList ={
            url : 'shipment-roles',
            data : []
        };
        vm.permission = {
            "source" : [],
            "management" : [],
            "feedbacks" : []
        };
        vm.feedBackData = [];
        vm.getData = false;
        // vm.init();

        $scope.$on('tabInitEvent',function(event,data){
            if(data == 'CONTACT'){
                vm.init();
            }
        })

        function init(){

            vm.shipDetailsData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
                return item.name == "CONTACT";
            });
            vm.getSource();
            vm.getMangementData();
            vm.getFeedBack();
            vm.getUserList();

        }

        //function to get source data
        function getSource(){
            vm.permission.source = util.splitIntoArray(vm.shipDetailsData.data["source"].permission);
            if(vm.permission.source[1]){
                api.shipment.source.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["source"].data = response.data;
                        vm.sourceData = vm.shipDetailsData.data["source"].data;
                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }
        }

        //function to get management data
        function getMangementData(){
        vm.permission.management = util.splitIntoArray(vm.shipDetailsData.data["management"].permission);
        vm.managementDataUrl = vm.shipDetailsData.data["management"].url;
            if(vm.permission.management[1]){
                api.shipment.management.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["management"].data = response.data;
                        vm.managementData = vm.shipDetailsData.data["management"].data;
                        vm.splitData(vm.managementData);
                        vm.getData = true;

                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }
        }

        function getFeedBack(){
        vm.permission.feedbacks = util.splitIntoArray(vm.shipDetailsData.data["feedbacks"].permission);
        vm.feedbackDataUrl = vm.shipDetailsData.data["feedbacks"].url;
            if(vm.permission.feedbacks[1]){
                api.shipment.feedbacks.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["feedbacks"].data = response.data;
                        vm.feedbackData = vm.shipDetailsData.data["feedbacks"].data;
                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }
        }

        function getUserList(){
            api.shipment.userList.get({},function(response){
                vm.usersList  = response.data;
            },function(err){
                util.showToast(util.displayValidationError(err));
                $log.error(err);
            })
        }


        function splitData(mgtData){
            if(mgtData.length > 0){
                for (var i = 0; i < mgtData.length; i++)
                {
                    if(mgtData[i].type=="shipment_expert"){
                        vm.shipperExpert = mgtData[i];
                    }
                    if(mgtData[i].type=="document_expert"){
                        vm.documentExpert = mgtData[i];
                    }
                    if(mgtData[i].type=="customer_success_manager"){
                        vm.customerExpert = mgtData[i];
                    }
                }
            }

        }

        function fnOpenEditdeatils(ship_exprt,doc_exprt,cust_exprt,ev){


            vm.ship_Expert = angular.copy(ship_exprt);
            vm.doc_Expert = angular.copy(doc_exprt);
            vm.cust_Expert = angular.copy(cust_exprt);
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/edit-management/edit-management.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        function trackEvent(type){
            util.callMixpanel(type,{
                "Mode":vm.shipment_meta.mode
              });
        }

        function fnSubmitMgtDetails(ship_exprt,doc_exprt,cust_exprt){
            vm.managementFrm = true;
            var mgt_array =[];
            if(ship_exprt.id != undefined){
                ship_exprt.type = "shipment_expert";
                mgt_array.push(ship_exprt);
            }
            if(doc_exprt.id != undefined){
                doc_exprt.type = "document_expert";
                mgt_array.push(doc_exprt);
            }
            if(cust_exprt.id != undefined){
                cust_exprt.type = "customer_success_manager";
                mgt_array.push(cust_exprt);
            }
            var postData = {
                "data":mgt_array
            };
            util.isCallingApi = true;
            api.shipment.management.update({'shipment_id':ShipmentService.shipment_id,'id':'all'},postData,
                function(response){
                    vm.managementFrm = false;
                    vm.managementData = postData.data;
                    vm.splitData(vm.managementData);
                    $scope.$emit('addManagement', { management: vm.managementData });
                    util.isCallingApi = false;
                    util.showToast("Management details updated successfully");
                    vm.cancelDialog();
                },function(err){
                    util.isCallingApi = false;
                    vm.managementFrm = false;
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    $mdDialog.hide();
            });
        }

        function fnSubmitPost(post){
            if(vm.feedback != ""){
                vm.disabledPost = true;
                // var todyasDate = new Date();
                var dateTime = moment.utc().format('YYYY-MM-DD HH:mm:ss');
                var Savedata = {
                    "data": {
                        "created_at":dateTime,
                        "comment": post
                    }
                };
                util.isCallingApi = true;
                api.shipment.feedbacks.save({'shipment_id':ShipmentService.shipment_id},Savedata,function(response){
                    vm.feedbackData.unshift(Savedata.data);
                    vm.feedback = "";
                    vm.disabledPost = false;
                    util.isCallingApi = false;
                    util.showToast("Your feedback saved.");
                },function(err){
                    util.isCallingApi = false;
                    vm.disabledPost = false;
                    util.showToast(util.displayValidationError(err));
                    // vm.showAlert("Failed to save your feedback.");
                    $log.error(err);
                })
            }
        }

        function cancelDialog(type){

            $mdDialog.hide();
        }

        // function showAlert(message){
        //     $mdToast.show(
        //         $mdToast.simple()
        //           .textContent(message)
        //           .position('top right')
        //     );
        //   }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.shipments')
        .controller('billinginfoShipmentController', BillingInfoShipmentController);

    /** @ngInject */
  function BillingInfoShipmentController(ShipmentService, $mdToast, $log, util, api, $timeout, $mdDialog, $stateParams, $http, QuotesService, $filter, $scope, localStorageService, shareQuoteService,$rootScope,SearchService,resultService,$window) {

        var vm = this;
        vm.util = util;
        vm.deleteType='';
        vm.deleteValue='';
        vm.ratePopupAction = 'Add';
        vm.getDetails = getDetails;
        vm.shipDetailsData = {};
        vm.uploadInvoiceModal = uploadInvoiceModal;
        vm.trackEvent=trackEvent;
        vm.editInvoiceDetail = editInvoiceDetail;
        vm.cancelDialog = cancelDialog;
        vm.ShipmentsDetails = {};
        vm.bill_rates = {};
        vm.fnOpenRemarkModal = fnOpenRemarkModal;
        vm.updateBillRates = updateBillRates;
        vm.fnTrackAnalytics = fnTrackAnalytics;
        vm.invoiceData = vm.invoiceData;
        vm.getData = false;
        vm.getInvoiceData = false;
        vm.vendorId = parseInt(localStorageService.get('authToken').value.vendor_id);
        vm.permission = {
            "rate" : [],
            "invoice" : []
        };
        vm.getProfileData = getProfileData;
        vm.getBillingRates = getBillingRates;
        vm.getRatePopupAction = getRatePopupAction;
        vm.getInvoice = getInvoice;
        // vm.getDetails();
        vm.createInvoice = createInvoice;
        // Billing-Info : Charge modify
        vm.ShipmentsDetails = ShipmentService.shipmentManagementObj.shipment_meta;
        vm.all_in_quote_setting = vm.ShipmentsDetails.all_in_quote_setting ? vm.ShipmentsDetails.all_in_quote_setting : 'default';
        vm.resultId = vm.ShipmentsDetails._id;
        vm.LoadData = ShipmentService.shipmentManagementObj.shipment_meta.load_data.load_details_value;
        vm.legData={};
        vm.LegCurrencyList = util.currencyList;
        vm.deleteInvoiceFile = deleteInvoiceFile;
        vm.fnDeleteData = fnDeleteData;
        vm.billing_cust_curr = '';
        vm.isString = isString;
        vm.showTotal = showTotal;
        // vm.showAlert= showAlert;
        vm.basisArray = [shareQuoteService.airBasisName, shareQuoteService.pickupBasisName, shareQuoteService.deliveryBasisName, shareQuoteService.freightBasisName];
        vm.chargeArray = [shareQuoteService.airChargeId, shareQuoteService.pickupChargeId, shareQuoteService.deliveryChargeId, shareQuoteService.freightChargeId];
        // vm.fnCheckIfCharge = fnCheckIfCharge;
        vm.showExchangeRates = $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;
        vm.avblLegIcon = ['l1', 'l2', 'l3', 'l4', 'l5'];
        vm.sourceData=null;
        vm.downloadSource = downloadSource;
        vm.getBatchCodeList=getBatchCodeList;
        vm.sourceLinkDownload=sourceLinkDownload;
        vm.fnAddOrEditCard = fnAddOrEditCard;
        //code to get user profile details
        vm.userData = {};
        vm.getProfileData();
        vm.billing_info_data = {};
        vm.isOwnVendorRate = false;

        function getProfileData(){
            return util.getProfile().then(function(response){
                vm.userData = response.user;
                return vm.userData;
            },function(error){
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        }
        function isString(data) {
          if(typeof data === 'string') {
            return true;
          } else {
            return false;
          }
        }

        function showTotal(array) {
          var costFound = false;
          array.charges.some(function(i) {
            if (typeof i.charge_cost === 'number'){
              costFound = true;
              return true;
            }
          });
          return costFound;
        }

        function getDetails(){
            vm.shipDetailsData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
                return item.name == "BILLING INFO";
            });

            vm.legMode = (vm.ShipmentsDetails.mode == 'SEA-FCL') ? 'fcl' : ( (vm.ShipmentsDetails.mode == 'AIR') ? 'air' : 'lcl');

            vm.getBillingRates();
            vm.getInvoice();
            this.isOwnVendorRate = util.isOwnVendorRate(vm.ShipmentsDetails.vendor_id);
        }


        //function to get rates details
        function getBillingRates(){

            vm.permission.rate = util.splitIntoArray(vm.shipDetailsData.data["rate"].permission);
            vm.bill_ratesUrl = vm.shipDetailsData.data["rate"].url;
            if(vm.permission.rate[1]){
              //end point defined in index.api.js
                api.shipment.rate.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["rate"].data = response.rates;
                        vm.billing_info_data.rates = response.rates;
                        vm.billing_info_data.currency_conversion_rate = response.currency_conversion_rate;
                        vm.bill_rates = vm.shipDetailsData.data["rate"].data;
                        vm.getRatePopupAction();

                        shareQuoteService.setCurrencyConvSetting(vm.ShipmentsDetails.created_by.user_base_currency ,vm.billing_info_data.currency_conversion_rate.markup,vm.billing_info_data.currency_conversion_rate.directCurrencyMapping,vm.billing_info_data.currency_conversion_rate.curr_data);

                        
                        vm.cardVendorId = !!(vm.bill_rates.length) ? vm.bill_rates[0].vendor_id : vm.vendorId;
                        vm.billing_cust_curr = (vm.bill_rates.length) ? vm.bill_rates[0].leg_total_currency:'';
                        vm.getInvoiceData = true;
                        if(vm.util.isAdmin || vm.util.userProfile.user.is_pricing_user){
                          downloadSource(vm.bill_rates);
                        }
                    }catch(e){
                        $log.error(e);
                        vm.getInvoiceData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getInvoiceData = true;
                })
            }
        }
        function getRatePopupAction(){
          var isEdit = vm.bill_rates.some(function(leg){
            return (!leg.leg_status || leg.leg_status != "REMOVED")
          });
          vm.ratePopupAction = isEdit ? 'Edit':'Add';
        }
        //function to get invoice details
        function getInvoice(){
            vm.permission.invoice = util.splitIntoArray(vm.shipDetailsData.data["invoice"].permission);
            vm.invoiceDataUrl = vm.shipDetailsData.data["invoice"].url;
            if(vm.permission.invoice[1]){
                api.shipment.invoice.get({'shipment_id':ShipmentService.shipment_id},function(response){
                    try{
                        vm.shipDetailsData.data["invoice"].data = response.data;
                        vm.invoiceData = vm.shipDetailsData.data["invoice"].data;
                        vm.getData = true;
                    }catch(e){
                        $log.error(e);
                        vm.getData = true;
                    }

                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.getData = true;
                })
            }
        }

        $scope.$on('tabInitEvent',function(event,data){
            if(data == 'BILLING INFO'){
                vm.getDetails();
            }
        })

        /**
         * invoice form popup
         * @param {*} ev
         */
        //open add invoice modal
        function uploadInvoiceModal(invoiceData,ev){
            vm.fileValidation=false;

            vm.addInvoice = {
                'credit' :'',
                'due_date' :null,
                'created_date' :null,
                'amount' : ''
            }
            vm.showProgressBar = false;
            vm.invoiceFile="";
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/upload-invoice/add-invoice.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }
        function trackEvent(type,tittle){
          util.callMixpanel(type, {
            "Mode": vm.ShipmentsDetails.mode,
            "Type": tittle
          });
        }
        //function to open edit invoice modal
        function editInvoiceDetail(invoiceData,ev){
          invoiceData.created_date = invoiceData.created_date ? util.dateReplace(invoiceData.created_date) : null;
          invoiceData.due_date = invoiceData.due_date ? util.dateReplace(invoiceData.due_date) : null;
          vm.fileValidation=false;
            vm.editInvoice = angular.copy(invoiceData);
            vm.showProgressBar = false;
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/upload-invoice/edit-invoice.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        //open remarks modal
        function fnOpenRemarkModal(ev){
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/remark-edit/remark-edit.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        //create invoice details - ankita(17/05/2017)
        function createInvoice(invoiceData,file,form){

          if(file == null || file == ""){
            vm.fileValidation=true;
            return;
          }
          if(form.$invalid){
            return

          }
            vm.showProgressBar = true;
            invoiceData.due_date = $filter('date')(invoiceData.due_date, 'yyyy-MM-dd');
            invoiceData.created_date = $filter('date')(invoiceData.created_date, 'yyyy-MM-dd');
            file = (file == null) ? "" : file;
            invoiceData.amount = invoiceData.amount == null ? '' : invoiceData.amount;
            invoiceData.due_date = invoiceData.due_date == null ? '' : invoiceData.due_date;
            invoiceData.created_date = invoiceData.created_date == null ? '' : invoiceData.created_date;
            invoiceData.credit = invoiceData.credit == null ? '' : invoiceData.credit;
            var form = new FormData();
            if(file != ""){
                invoiceData.name = file.name;
                invoiceData.size = file.size;
                invoiceData.name = invoiceData.name == null ? '' : invoiceData.name;
                form.append("data[name]", invoiceData.name);
                form.append("shipment_docs[file]", file);
            }
            if(invoiceData._id != undefined){
                form.append("data[_id]", invoiceData._id);
            }
            form.append("data[amount]", invoiceData.amount);
            form.append("data[due_date]", invoiceData.due_date);
            form.append("data[created_date]", invoiceData.created_date);
            form.append("data[credit]", invoiceData.credit);
            var url = ShipmentService.shipment_id+'/invoices';
            ShipmentService.saveFileUpload(form, url).then(function (response) {
                if(invoiceData._id != undefined){
                    util.showToast("Invoice Updated Successfully.");
                }
                else{
                    util.showToast("Invoice Created successfully.");
                }
                vm.showProgressBar = false;
                var resData = JSON.parse(response);
                vm.invoiceData = resData.data;
                vm.cancelDialog();
            }, function (error) {
                util.showToast(util.displayValidationError(error));
                $log.log(error);
            });

        };

        //function to delete invoice modal- ankita(17/05/2017)
        function deleteInvoiceFile(invoiceData,ev){
            vm.deleteId = invoiceData._id;
            vm.deleteType="Invoice";
            vm.deleteValue='';
            $mdDialog.show({
                templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () {
                this.parent = vm
                }
            });
            vm.deleteModule = "delete_invoice";
        }

        //function to delete invoice file- ankita(17/05/2017)
        function fnDeleteData() {
            vm.deleteBtn = true;
            if(vm.deleteModule == "delete_invoice"){
                api.shipment.invoice.remove({'shipment_id':ShipmentService.shipment_id,'id': vm.deleteId},function(response){
                    vm.deleteBtn = false;
                    vm.invoiceData = response.data;
                    util.showToast("Invoice File Deleted Successfully!");
                    vm.invoiceFile = "";
                    cancelDialog();
                    // vm.checkBuyRateExists();
                },function(err){
                    util.showToast(util.displayValidationError(error));
                    $log.error(err);
                })
            }
        }

        function cancelDialog(type){
            $mdDialog.hide();
        };
        //Get source rate download function
        function downloadSource(legData){
          var batchcode=[];
          batchcode=getBatchCodeList(legData)
          if(batchcode.length){
            resultService.getSourceRate(batchcode).then(function(response){
              vm.sourceData=angular.copy(response.data.data);
            })
          }
        }   
        function getBatchCodeList(legData){
          var batchcode = [];
          angular.forEach(legData,function(leg){
            if(leg.batchcode && leg.batchcode.length){
              batchcode=batchcode.concat(leg.batchcode);
            }
          }) 
          return batchcode;
        }
        function sourceLinkDownload(batchcode){
          vm.trackEvent("SD-BillingInfo-DownloadSource");
          $window.open(util.sanitizeQueryParams(vm.sourceData[batchcode].sourceFileUrl));
        }
        function updateBillRates(item){
          vm.billing_info_data = item.billingInfoData;
          vm.bill_rates = item.billingInfoData.rates;
          vm.getBillingRates();

        }
        function fnTrackAnalytics(action, params){
          util.callMixpanel('SD'+'-'+action, params);
          }
        function fnAddOrEditCard() {
          vm.fnTrackAnalytics('RateCard-Edit-Click');
          vm.billingInfoPopupData = angular.copy(vm.billing_info_data);
          $mdDialog.show({
            template: '<md-dialog id="billing-info-leg" class="ViewModal popup-lg"><leg class="billing-leg" is-own-vendor-rate="ctrl.parent.isOwnVendorRate" action="ctrl.parent.ratePopupAction" source-data="ctrl.parent.sourceData" billing-info-data = "ctrl.parent.billingInfoPopupData" rate-vendor-id = "ctrl.parent.ShipmentsDetails.vendor_id"    callback="ctrl.parent.updateBillRates(item)"></leg></md-dialog>',
            // targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function () { this.parent = vm },
          });
        }
    }
})();

(function(){

    'use strict';
  
    angular
      .module('app.shipments')
      .factory('BillingInfoService' , BillingInfoService);
  
        /** @ngInject */
      function BillingInfoService($q,$log,$mdToast,$state,$http,api, $filter, localStorageService, $timeout,$rootScope, $mdPanel, analytics,SearchService,resultService,shareQuoteService,ShipmentService,util,basisCalculation,constObj){
  
        var billingInfoService = {
            percentageCharge:{},
            deleteLeg:null,
            chargeDelete : true,
            legDelete : false,
            deleteChargeBtn : false,
            deleteChargeLineObj:null,
    
            getEmptyLeg : getEmptyLeg,
            getEmptyCharge : getEmptyCharge,
            getChargeCost:getChargeCost,
            calculateQtyRange:calculateQtyRange,
            CalculateLegCurrencyCost:CalculateLegCurrencyCost,
            CalculateLegCurrencyCostBuy:CalculateLegCurrencyCostBuy,
            fnDisplayProfit:fnDisplayProfit,
            calulateRateTotal:calulateRateTotal,
            fnFillBasisMeta:fnFillBasisMeta,
            openDeleteCard:openDeleteCard,
            fnBasisOnTotalUnitUpdate:fnBasisOnTotalUnitUpdate,
            legCostChange:legCostChange,
            getLegData:getLegData,            
            fnCheckOverlay:fnCheckOverlay,
            cancelDelete:cancelDelete,
        }
        return billingInfoService;
        //for leg add
        function getEmptyLeg(bill_rates, vendorId){
            var legData = {
                "id": "",
                "leg_name": "",
                "leg_code": "",
                "leg_total_cost": 0,
                "leg_total_currency": (bill_rates.length) ? bill_rates[0].leg_total_currency : 'USD',
                "leg_currency_cost":0 ,
                "leg_currency": (bill_rates.length) ? bill_rates[0].leg_total_currency : 'USD',
                "leg_status":"TEMP",
                'manual':1,
                'charges':[],
                'vendor_id' : (bill_rates.length) ? bill_rates[0].vendor_id : vendorId,
                'buy': {
                  "leg_total_cost": 0,
                  "leg_total_currency": (bill_rates.length) ? bill_rates[0].leg_total_currency : 'USD',
                  "leg_currency_cost": 0,
                  "leg_currency": (bill_rates.length) ? bill_rates[0].leg_total_currency : 'USD'
                }
            };
             return legData;
        };
        //for charge add
        function getEmptyCharge(legData, vendorId, mode){
            var charge = {
                'id': "",
                "status": "TEMP",
                "prev_charge_cost": 0,
                'comments': "",
                "global_charge_id": "",
                "charge_name": null,
                "charge_type": "FIXED",
                'charge_basis': null,
                'per_unit_rate': 0,
                'total_units': 0,
                'charge_cost': 0,
                'charge_currency': legData.leg_currency,
                "minimum_charge_cost":mode === 'SEA-FCL'? 'NA': '',
                "maximum_charge_cost":mode === 'SEA-FCL'? 'NA': '',
                'container_type': null,
                'leg_currency_cost': 0,
                "customer_currency_cost": 0,
                "manual" : true,
                "is_qty_editable" : false,
                "charge_category" : null,
                "charge_code" : "",
                "internal_comments":'',
                "external_comments":'',
                'buy': {
                  'total_units': 0,
                  "status":"TEMP",
                  "per_unit_rate": 0,
                  "charge_cost": 0,
                  "prev_charge_cost": 0,
                  "charge_currency": legData.leg_currency,
                  "minimum_charge_cost": mode === 'SEA-FCL'? 'NA': '',
                  "maximum_charge_cost": mode === 'SEA-FCL'? 'NA': '',
                  "customer_currency_cost": 0,
                  "leg_currency_cost": 0
                }
              }
              return charge;
        }
        //buy , sell , leg calculations
        function getChargeCost(charge_data, type, legData,billing_cust_curr,showBuyRateInModal,bill_rates,footerObj){
          var totalSlabCost = 0;
          if(type === 'sell') {

            if(charge_data.per_unit_rate && util.isString(charge_data.per_unit_rate) && (/^[-+]?[0-9]*\.?[0-9]+$/.test(charge_data.per_unit_rate))) {
              charge_data.per_unit_rate = parseFloat(charge_data.per_unit_rate);
              charge_data.charge_cost = charge_data.per_unit_rate;
            }

            if (!charge_data.per_unit_rate){
              charge_data.per_unit_rate = 0;
            }

            if (charge_data.charge_type === 'SLAB' && charge_data.slab_type === 'INCREMENTAL') {
              charge_data.slab.forEach(function (i, k) {
                totalSlabCost += (parseFloat(i.cost) || 0) * billingInfoService.calculateQtyRange(charge_data, k);
              });

                charge_data.per_unit_rate = totalSlabCost / charge_data.total_units;

            }
            ShipmentService.fnCalculateChargeCostSell(charge_data, legData,billing_cust_curr);
            billingInfoService.CalculateLegCurrencyCost(legData);
          } else if (type === 'buy') {
            charge_data.buy["charge_currency"] = charge_data.buy["charge_currency"] ? charge_data.buy["charge_currency"]:legData.leg_currency;
            if (charge_data.buy.per_unit_rate && util.isString(charge_data.buy.per_unit_rate) && (/^[-+]?[0-9]*\.?[0-9]+$/.test(charge_data.buy.per_unit_rate))) {
              charge_data.buy.per_unit_rate = parseFloat(charge_data.buy.per_unit_rate);
              charge_data.buy.charge_cost = charge_data.buy.per_unit_rate;
            }

            if (!charge_data.buy.per_unit_rate) {
              charge_data.buy.per_unit_rate = 0;
            }

            if (charge_data.charge_type === 'SLAB' && charge_data.slab_type === 'INCREMENTAL') {
              charge_data.buy.total_units = charge_data.total_units;
              charge_data.buy.slab.forEach(function (i, k) {
                totalSlabCost += (parseFloat(i.cost) || 0) * billingInfoService.calculateQtyRange(charge_data.buy, k);
              });


              charge_data.buy.per_unit_rate = totalSlabCost / charge_data.buy.total_units;
            }
            if(!showBuyRateInModal){
              return;
            }
            ShipmentService.fnCalculateChargeCostBuy(charge_data,legData, billing_cust_curr);
            billingInfoService.CalculateLegCurrencyCostBuy(legData,showBuyRateInModal);
          }
          billingInfoService.legCostChange(legData,billing_cust_curr,showBuyRateInModal,bill_rates,footerObj);
          billingInfoService.fnDisplayProfit(bill_rates,footerObj);
        }
        function calculateQtyRange(charge, key) {
          var unit = charge.total_units;
          if (unit >= charge.slab[key].to) {
              return (charge.slab[key].to - (charge.slab[key - 1] ? charge.slab[key-1].to:0));
          } else if (unit >= charge.slab[key].from) {
              return (unit - charge.slab[key].from + 1);
          } else {
              return 0;
          }
      }
        //leg currency cost for sell using legData
        function CalculateLegCurrencyCost(leg) {
            var result = 0;
            var total_cost_res = 0;
            for (var i = 0; i < leg.charges.length; i++)
            {
                if(leg.charges[i].status != 'REMOVED'){
                    var currCost = !leg.charges[i].leg_currency_cost ? 0 : parseFloat(leg.charges[i].leg_currency_cost);
                    result = result + currCost;

                    var total_cost = !leg.charges[i].customer_currency_cost ? 0 : parseFloat(leg.charges[i].customer_currency_cost);
                    total_cost_res = total_cost_res + total_cost;
                }
            }
            leg.leg_currency_cost = result;
            leg.leg_total_cost = total_cost_res;
        }
        //leg currency cost for buy using legData
        function CalculateLegCurrencyCostBuy(leg,showBuyRateInModal) {
          if(!showBuyRateInModal) {
            return;
          }
          var result = 0;
          var total_cost_res = 0;
          for (var i = 0; i < leg.charges.length; i++)
          {
              if(leg.charges[i].status != 'REMOVED'){
                  var currCost = !leg.charges[i].buy.leg_currency_cost ? 0 : parseFloat(leg.charges[i].buy.leg_currency_cost);
                  result = result + currCost;

                  var total_cost = !leg.charges[i].buy.customer_currency_cost ? 0 : parseFloat(leg.charges[i].buy.customer_currency_cost);
                  total_cost_res = total_cost_res + total_cost;
              }
          }
          leg.buy.leg_currency_cost = result;
          leg.buy.leg_total_cost = total_cost_res;
        }
        //return l3 leg key
        function getLegData(rates,legCode){
          var legData = null;
          if(rates.length){
            legData = rates.find(function(leg){
            return leg.leg_code.includes(legCode) && (!leg.leg_status || leg.leg_status !=="REMOVED")
           })
          }
          return legData;
        }

        function fnBasisOnTotalUnitUpdate(sellFreightTotal,buyFreightTotal,l3LegData, legData,billing_cust_curr,showBuyRateInModal,bill_rates,footerObj){
          basisCalculation.freightTotal.buyFreightTotal = buyFreightTotal;
          basisCalculation.freightTotal.sellFreightTotal = sellFreightTotal;
          basisCalculation.setTotalUnitsOnBillingInfo(l3LegData,bill_rates.rates);
          if(sellFreightTotal === null && buyFreightTotal === null){
            return;
          }
          //Calculate buy amount and sell amount based on updated quantity
          Object.keys(basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS]).forEach(function(legCode) {
            basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][legCode].forEach(function(charge){
              var percentageLegData = billingInfoService.getLegData(bill_rates.rates,legCode)
              billingInfoService.getChargeCost(
                charge.sellCharge,
                "sell",
                percentageLegData,
                billing_cust_curr,
                showBuyRateInModal,
                bill_rates,
                footerObj
              );
              if (charge.sellCharge.buy) {
                billingInfoService.getChargeCost(
                  charge.sellCharge,
                  "buy",
                  percentageLegData,
                  billing_cust_curr,
                  showBuyRateInModal,
                  bill_rates,
                  footerObj
                );
              }
            });
          });
        }
        function legCostChange(legData,billing_cust_curr,showBuyRateInModal,bill_rates,footerObj){
          var l3LegData = billingInfoService.getLegData(bill_rates.rates,'l3');
          if(!l3LegData){
            if(basisCalculation.freightTotal.buyFreightTotal !== null || basisCalculation.freightTotal.sellFreightTotal != null){
              billingInfoService.fnBasisOnTotalUnitUpdate(null,null,l3LegData, legData,billing_cust_curr,showBuyRateInModal,bill_rates,footerObj);
            } //l3 is present and leg curreny cost is updated then update % on total basis charge quantity
          }else if(l3LegData.leg_currency_cost !== basisCalculation.freightTotal.sellFreightTotal || l3LegData.buy.leg_currency_cost !== basisCalculation.freightTotal.buyFreightTotal){
            billingInfoService.fnBasisOnTotalUnitUpdate(l3LegData.leg_currency_cost,l3LegData.buy.leg_currency_cost,l3LegData, legData,billing_cust_curr,showBuyRateInModal,bill_rates,footerObj);
          }
        }
        //profit display using leg total
        function fnDisplayProfit(bill_rates,footerObj){
          footerObj.buyTotalBaseCurr = billingInfoService.calulateRateTotal(bill_rates.rates,'buy');
          footerObj.sellTotalBaseCurr = billingInfoService.calulateRateTotal(bill_rates.rates,'sell');
          footerObj.profit = util.getProfitValue(footerObj.sellTotalBaseCurr, footerObj.buyTotalBaseCurr);
        }
        //for buy and sell rate leg total 
        function calulateRateTotal(bill_rates,buyOrSell){
          var total = 0;
          angular.forEach(bill_rates,function(item){
            var charge = buyOrSell === 'buy' ? item.buy : item;
              if(item.leg_status != 'REMOVED'){
                  total += parseFloat(charge.leg_total_cost);
              }
          });
          return total;
        }
      //check charge data and fill respective meta value for % on charge
      function fnFillBasisMeta(charge_data,buy_charge_data, legCode,mode){
        // var checkCharge = false;

        // if(charge_data.global_charge_id && charge_data.total_units != null){
        //   var checkCharge = false;
        //   if(  basisCalculation.isParent(charge_data) && legCode && legCode.toLowerCase().includes('l3')){
        //     billingInfoService.percentageCharge["AirFreight"] = charge_data;
        //     checkCharge = true;
        //   }
        // }
        // return checkCharge;

        var checkCharge = false;
        if(charge_data.total_units != null){
          var checkCharge = {parent:false,basis:""};
          var parent =  basisCalculation.isParent(charge_data,mode);
          var childBasis = null;
          if(parent){
            childBasis = basisCalculation.getChildBasis(charge_data,mode);
          }
          //need to optimize
          if( parent  && legCode && legCode.toLowerCase().includes('l3_') && childBasis === constObj.AIR_FREIGHT_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }else if( parent  && legCode && legCode.toLowerCase().includes('l1_') && childBasis === constObj.PICKUP_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }else if( parent  && legCode && legCode.toLowerCase().includes('l5_') && childBasis === constObj.DELIVERY_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }else if( parent  && legCode && legCode.toLowerCase().includes('l3_') && childBasis === constObj.FREIGHT_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }
        }
        return checkCharge;
    }
    function fillParentData(childBasis,charge_data,buy_charge_data,mode){
      var container_type = charge_data.charge_basis === 'per equipment' ? charge_data.container_type : null;
      if(container_type || !(mode.toLowerCase().includes('fcl'))){
        basisCalculation.basisOnTotalObj[childBasis] = basisCalculation.basisOnTotalObj[childBasis]  || {};
        basisCalculation.basisOnTotalObj[childBasis].parent = basisCalculation.basisOnTotalObj[childBasis].parent || {}
        basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'] = basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'] || {};
        basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].buy = buy_charge_data;
        basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].sell = charge_data;
        return {parent:true,basis:childBasis};
      }else{
        return {parent:false,basis:childBasis};

      }

    }
      
      //remove overlay if available
      function fnCheckOverlay(){
        if(billingInfoService.deleteLeg){
          billingInfoService.cancelDelete(billingInfoService.deleteLeg);
        }
      }
      //open overlay
      function openDeleteCard(legCode){
        billingInfoService.deleteLeg = legCode;
        document.getElementById(legCode+'_askDeleteLeg').classList.remove("hide");
      }
      //cancel delete
      function cancelDelete(legCode){
        if(legCode){
        document.getElementById(legCode+'_askDeleteLeg').classList.add("hide");
        billingInfoService.deleteLeg = null;
        }
      }

    }
    })();
(function () {
    'use strict';
  
    angular
    .module('app.core')
    .component('newParty', {
        templateUrl: 'app/main/shipments/dialogs/new-party/new-party.html',
        bindings : {
          fixCategory : '=',
          editPartyModalTitle:'=',
          validationObj:'=',
          mode:'=',
          editParty:"=",
          selectUser:"=",
          prevEmail:"=",
          editPartyIndex:"=",
          partyId:"=",
          partyBtn:"=",
          parties:"=",
          isFromQuote:"=",
          callback: '&'

        },
        controller: NewPartyController
    })
    .component('newUserQuote', {
      templateUrl: 'app/main/shipments/dialogs/new-party/new-user-quote.html',
      bindings : {
        fixCategory : '=',
        editPartyModalTitle:'=',
        validationObj:'=',
        mode:'=',
        editParty:"=",
        selectUser:"=",
        prevEmail:"=",
        editPartyIndex:"=",
        partyId:"=",
        partyBtn:"=",
        parties:"=",
        isFromQuote:"=",
        callback: '&'

      },
      controller: NewPartyController
  });
  
    function NewPartyController(ShipmentService,RoleService, $log, $scope, $element, util,api,$timeout,$mdDialog, SearchService, $sanitize, $rootScope, appCache, $filter,$state, resultService,shareQuoteService, $mdPanel,$rootElement , SettingService) {
      var vm = this;

      vm.fnSaveParty=fnSaveParty;
      vm.cancelDialog=cancelDialog;
      vm.restPartyObj=restPartyObj;
      vm.setPartyDetails = setPartyDetails
      vm.getCompanyList = ShipmentService.getCompanyList;
      vm.searchPartyData = null;
      vm.canCreateNewCompany = ShipmentService.canCreateNewCompany;
      vm.onCompanyTextChange = onCompanyTextChange;
      vm.util=util
      vm.trackEvent=trackEvent;
      vm.navigateToShipper = navigateToShipper;
      vm.isSharedshipment = util.isSharedPage();
      vm.userRoles=[];
      vm.getUserRoles=getUserRoles;
      vm.ifCategoryAdd=ifCategoryAdd;
      vm.shipDetailsData = {};
     vm.getData = false;

      vm.partyView = {
        "shipper" : false,
        "consignee" : false,
        "notifyParty" : false,
        "cha" : false
    };
    vm.getCountries = getCountries;
    vm.countrySelected = countrySelected ;
    vm.fnStoreStateList = fnStoreStateList;

     this.$onInit = function(){
        if(ShipmentService.shipmentManagementObj.shipment_data){
          vm.shipDetailsData =  ShipmentService.shipmentManagementObj.shipment_data.nav.find(function(item){
          return item.name == "BOOKING DETAILS";
      });
      if(vm.shipDetailsData){
          vm.getUserRoles();

        }
        vm.getCountries();
      }
      
      // Set searchPartyData for existing parties being edited
      if(vm.editPartyModalTitle === 'Edit' && vm.editParty && vm.editParty.company_name){
        vm.searchPartyData = {
          id: vm.editParty.company_id,
          company_name: vm.editParty.company_name
        };
      }
    } 
     

      function getUserRoles(){
        if(!util.isSharedPage()){
            api.shipment.userRoles.get({},function(response){
                try{
                    vm.userRoles = response.data;

                    // AM : SUP-327
                    vm.userRoles = vm.userRoles.filter(function(item) { 
                      return item.module_code != 'SHIPMENT_PRODUCT'; 
                    });

                }catch(e){
                    $log.error(e);
                }
            },function(err){
                util.showToast(util.displayValidationError(err));
                $log.error(err);
            })
        }
       }
       
       function ifCategoryAdd(){
        vm.partyView.shipper = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "shipper"; });
        vm.partyView.consignee = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "consignee"; });
        vm.partyView.notifyParty = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "notify_party"; });
        vm.partyView.cha = vm.parties.some(function (entry) { return entry.category.toLowerCase().trim() === "cha"; });
        } 
       function restPartyObj(category) {
        vm.editParty = {
            "name": null,
            "category": category ? category : null,
            "company_name": null,
            "email": null,
            "address": null,
            "contact": null,
            "expiry_date": null,
            "iec_number": null,
            "point_of_contact": null,
            "country_code": null,
            "revoke":0,
            "nav":[] ,
            "send_notification" : false
        };
      }

      function cancelDialog(category,label){
        if(category){
          category=category.toLowerCase();
          if((vm.isFromQuote =='Quotes') && category == 'shipper' || category == 'consignee' || category == 'notify party' || category == 'cha'){
          util.callMixpanel("SD-"+category+"-"+label+"-Change" , {
            "mode": vm.mode
          });
          }
        }
        
        $mdDialog.hide();
        }

       

        function  trackEvent(category,label,value,type){
          if(!type){
            category=category.toLowerCase();
            category = (category == 'notify_party') ? 'notify party':category;
            
            if(label != 'Expand'){
              
              var string=label;
            }
            else{
              string=label+"Click";
            }
            
            if(category == 'shipper' || category == 'consignee' || category == 'notify party' || category == 'cha'){
              if(vm.isFromQuote !='Quotes'){
                util.callMixpanel("SD-"+category+"-"+string+"-Change" , {
                  "mode": vm.mode,
                  "Type":vm.editPartyModalTitle
                });
              }
            }
          }
          else{
            util.callMixpanel(type,{
              "mode":vm.mode,
              "Type":vm.scheduleModalTitle
            });
          }
          } 


      function fnSaveParty(form,category){
      
        
        if(!vm.editParty.company_name){
          vm.validationObj.companyValidation = true;
        }
        
        // Validate that restricted party types must select from dropdown (not manually typed)
        // Quote flow allows new customer creation; company/user are created on quote submit when no id is sent.
        if(vm.isFromQuote !== 'Quotes' && !vm.canCreateNewCompany(vm.editParty.category) && vm.editParty.company_name && !vm.searchPartyData){
          vm.validationObj.companyValidation = true;
          util.showToast('Please select an existing company from the dropdown. Manual entry is not allowed for ' + vm.editParty.category + '.');
          // Clear the manually typed company name only for Add mode, not Edit mode
          if(vm.editPartyModalTitle !== 'Edit'){
            vm.editParty.company_name = '';
          }
          return;
        }
        if(!vm.editParty.email){
          vm.validationObj.emailValidation = true;
        }
        
        if (vm.editParty.email && !vm.util.emailRegex.test(vm.editParty.email.toLowerCase())) {
          vm.validationObj.emailValidation = true;
        }

        if(vm.isFromQuote!='Quotes'){
           if(!vm.editParty.category){
              vm.validationObj.categoryValidation = true;
           }
          if(!vm.editParty.expiry_date){
              vm.validationObj.expiryValidation=true;
           }
           if(vm.selectUser.length <= 0){
               vm.validationObj.permissionValidation=true;
           }
           if(!vm.editParty.name){
            vm.validationObj.nameValidation = true;
          }
         }
         else{
          if(!vm.editParty.firstName){
            vm.validationObj.firstNameValidation = true;
         }
        if(!vm.editParty.lastName){
            vm.validationObj.lastNameValidation=true;
         }

         }

          if( vm.validationObj.permissionValidation|| vm.validationObj.firstNameValidation ||vm.validationObj.lastNameValidation|| vm.validationObj.expiryValidation ||  vm.validationObj.emailValidation ||  vm.validationObj.nameValidation || vm.validationObj.companyValidation|| vm.validationObj.categoryValidation || form.$invalid) {
            return ;
          }
          category=category.toLowerCase();
          if(category == 'shipper' || category == 'consignee' || category == 'notify party' || category == 'cha'){
          if(vm.isFromQuote !='Quotes'){
            util.callMixpanel("SD-"+category+"-Save-Click" , {
              "mode": vm.mode
            });
          }
      }


          vm.partyBtn = true;
          vm.editParty.nav = vm.selectUser;
          vm.editParty.nav.forEach(function(item){
              // delete item.description,
              delete item.$mdSelectId
          });

          var tempExpiry = new Date(vm.editParty.expiry_date);
          tempExpiry.setHours(23);
          tempExpiry.setMinutes(59);

          vm.editParty.expiry_date = moment.utc(tempExpiry).format(util.utcDateFormat);

          var postData = {
              "data" : angular.copy(vm.editParty)
          };
          if(vm.isFromQuote!='Quotes'){
          postData.data.category = (vm.editParty.category.toLowerCase() === 'notify party' || vm.editParty.category.toLowerCase() === 'notify_party') ? 'notify_party' :  vm.editParty.category;
          }
          if(vm.editPartyModalTitle == 'Edit'){

              if(angular.equals(vm.prevEmail, vm.editParty.email)){
                  delete postData.data.email;
              }
              util.isCallingApi = true;
              api.shipment.parties.update({'shipment_id':ShipmentService.shipment_id,'id':vm.partyId}, postData,
                  function(){
                      vm.editParty['_id'] = vm.partyId;
                      vm.shipDetailsData.data["parties"].data[vm.editPartyIndex] = angular.copy(vm.editParty);
                      vm.ifCategoryAdd();
                      util.showToast("Party updated successfully.");
                      var i = 0, partiesInMeta = appCache.get('shippmentDetailsMeta').parties;
                      while (partiesInMeta[i]) {
                        if(partiesInMeta[i]._id === vm.editParty._id) {
                          partiesInMeta[i] = vm.editParty;
                          i = partiesInMeta.length;
                        }
                        i++;
                      }
                      $scope.$emit('callShipmentMeta', { category: vm.editParty.category });
                      vm.partyBtn = false;
                      util.isCallingApi = false;
                      $mdDialog.hide();
                  },function(err){
                      // util.showToast(err.message);
                      $log.error(err);
                      util.showToast(util.displayValidationError(err));
                      vm.partyBtn = false;
                      util.isCallingApi = false;
                      // $mdDialog.hide();
              });
          }
          else if(vm.editPartyModalTitle == 'Add'){
              if(vm.isFromQuote =='Quotes'){
                
                var shipperData={


                    "id" :null,
                    "user_first_name" : vm.editParty.firstName,
                    "user_last_name" :vm.editParty.lastName,
                    "email" : vm.editParty.email,
                    "user_mobile" : vm.editParty.contact,
                  company:{
                    "id" : null,
                      "company_name": vm.editParty.company_name,
                      "company_address" :vm.editParty.address
   
                    }
                }
                vm.callback({'data':shipperData});
                $mdDialog.hide();

                
               
              }
              else{
              api.shipment.parties.save({'shipment_id':ShipmentService.shipment_id}, postData,
                  function(response){
                    if(vm.isFromQuote!='Quotes'){
                    vm.editParty.category = (vm.editParty.category.toLowerCase() === 'notify party' || vm.editParty.category.toLowerCase() === 'notify_party') ? 'notify_party' :  vm.editParty.category;
                    }
                    vm.editParty['_id'] = response.id;
                      if(vm.parties != undefined){
                          vm.parties.push(vm.editParty);
                          vm.ifCategoryAdd();
                      }
                      util.showToast("New party added successfully.");
                      ShipmentService.shipmentManagementObj.shipment_meta.parties.push(vm.editParty);
                      $scope.$emit('callShipmentMeta', { category: vm.editParty.category });
                      vm.partyBtn = false;
                      util.isCallingApi = false;
                      vm.callback({'data':vm.partyView});
                      $mdDialog.hide();
                  },function(err){
                      util.isCallingApi = false;
                      // util.showToast(err.message);
                      $log.error(err);
                      util.showToast(util.displayValidationError(err));
                      vm.partyBtn = false;
                      // $mdDialog.hide();
              });
            }
          }

      }

      function getCountries() {
          if (!SettingService.countriesData) {
            vm.isDataLoading = true;
            SettingService.getCountryList().then(function (response) {
                  vm.countryList = response.data.data.countries;
                  vm.isDataLoading = false;
                  SettingService.countriesData = angular.copy(response.data.data);
                  vm.fnStoreStateList();
              }, function (err) {
                vm.isDataLoading = false;
                $log.log(err);
              });
          } else {
              vm.countryList = SettingService.countriesData.countries;
              vm.fnStoreStateList();
            }
        }

        function countrySelected(country_name) {
            vm.selectedState = '';
            vm.editParty.state = '';

           var selected_country =  vm.countryList.find(function(item){
              return item.country_name == country_name
            });
            vm.editParty.country_code = selected_country.country_code || '';
            if(selected_country.states.length > 0 ){
              vm.stateList =  selected_country.states;
              return;
            }
            SettingService.getStateList(country_name).then(function (response) {
              vm.stateList = response.data.data.countries[0] ? response.data.data.countries[0].states : [];
            }, function (err) {
              $log.log(err);
            });
        }

        function setPartyDetails(selectedCompany , partyDetails){
          ShipmentService.setPartyDetails(selectedCompany , partyDetails);
          vm.fnStoreStateList();
       }

        function  fnStoreStateList(){
            // storing states based on selected country on init
            var country =  vm.countryList.find(function(item){
              return (item.country_name === vm.editParty.country);
            });
            vm.stateList =  country && country.states.length > 0 ? country.states : [] ;
            vm.editParty.country_code = country && country.country_code ? country.country_code : null;
        }

        function onCompanyTextChange(searchText) {
          // Reset selected item when user types
          vm.searchPartyData = null;
        }

        function navigateToShipper(partyType) {
          const data = {
            'source': partyType,
            'from': 'shipment-details'
          };
          window.parent.postMessage(data, '*');
        }
    }
     
    })();
  
(function ()
{
    'use strict';

    angular
        .module('app.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.search', {
                url    : '/rates',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/search/search.html',
                        controller : 'SearchController as vm'
                    },
                    data : { pageTitle: 'Search' }
                },
                resolve: {
                    SearchParam : function(msApi){
                        return msApi.resolve('search@get');
                    },
                    User : function (util){
                      if(!Object.keys(util.userProfile).length){
                        return util.getProfile();
                      }
                      else{
                        return util.userProfile;
                      }
                    }
                },
                bodyClass: 'instant-rate'
            })
            .state('app.search.recentSearch', {
              url    : '/recent-search',
              views  : {
                  'content@app': {
                      templateUrl: 'app/main/search/views/search-history/search-history.html',
                      controller : 'SearchHistoryController as vm'
                  },
                  data : { pageTitle: 'Recent Searches' }
              },
              bodyClass: 'search-history'
          });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/search');

        // Api
        msApiProvider.register('search', ['app/data/search/search.json']);
        // msApiProvider.register('specialRates', ['app/data/specialRates/special-rates.json']);

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.search')
        .controller('SuperOffersController', SuperOffersController);

    /** @ngInject */
    function SuperOffersController($state, $log, $filter, SearchParam, util, SearchService, SpecialRatesService,$rootScope,analytics)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.init = init;
        vm.specialRates = [];
        vm.searchPostData = angular.copy(SearchParam.data.search_param_fcl);
        vm.currentState = $state.current.name;
        vm.goBackToSearch = goBackToSearch;
        vm.fnSpecialRateResult = fnSpecialRateResult;
        vm.searchConfig = $rootScope.domainData.domain_info["SEARCH_CONFIG"];
        vm.init();

        function init(){
          vm.util.isCallingApi = true;
          SpecialRatesService.getSpecialRates().then(function(response){
            vm.util.isCallingApi = false;
            vm.specialRates =   response.data ? response.data.data : [];
            vm.specialRates = SpecialRatesService.getRatesExpiry(vm.specialRates);
          },function(error){
              vm.util.isCallingApi = false;
              vm.specialRates = [];
              $log.log(error.data);
          });
        }

        function goBackToSearch(){
          $state.go('app.search');
          SearchService.specialparam = '';
        }

        function fnSpecialRateResult(item, load){

          vm.searchPostData.cargo_ready_date = $filter('date')(new Date(), 'yyyy-MM-dd');
          vm.searchPostData.origin_location = item.origin_location ? item.origin_location : item.origin_port;
          vm.searchPostData.destination_location = item.destination_location ? item.destination_location : item.destination_port;
          vm.searchPostData.inco_term = null;
          var loadData = [{"type" : load.container_type ,"count":1 }];

          vm.prefilledCardSearch=false;
          //If customers details is mandatory then prefilled search otherwise redirect to result page
          if(vm.searchConfig && (vm.searchConfig.stuffing.required || vm.searchConfig.shipper_company.required || vm.searchConfig.shipper_email.required)){
            vm.prefilledCardSearch = true;
          }

          if (!vm.prefilledCardSearch) {
              vm.searchPostData.search_name = vm.searchPostData.origin_location.location + ' to '+ vm.searchPostData.destination_location.location +' / '+ $filter('date')(vm.searchPostData.cargo_ready_date, 'd MMM yyyy');
          }

          vm.searchPostData.load_data = util.formFclSearchData(vm.searchPostData.load_data,loadData);

          vm.searchPostData["stuffing"] = $rootScope.domainData.domain_info["DEFAULT_STUFFING"];

          if( vm.searchPostData.origin_location.place_type == 'Door' ){
              vm.searchPostData.pickup = vm.searchPostData.origin_location;
              vm.searchPostData.pickup_selected = true;
              vm.searchPostData.origin_charges = true;
              vm.searchPostData.origin_customs = true;
          }
          if( vm.searchPostData.destination_location.place_type == 'Door' ){
              vm.searchPostData.delivery = vm.searchPostData.destination_location;
              vm.searchPostData.destination_charges = true;
              vm.searchPostData.destination_customs = true;
              vm.searchPostData.delivery_selected = true;
          }

          var data =  {
              "search_param" : vm.searchPostData
          }

          vm.fclLoadData = SearchService.getFclLoadDetails(data.search_param.load_data.load_details_value);

          //mixpanel code only for fcl
          analytics.track("Rates from Special Rates",{
              "Mode":data.search_param.mode,
              "Cargo Ready Date":data.search_param.cargo_ready_date,
              "Search Name":data.search_param.search_name,
              "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
              "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + vm.fclLoadData.loadtype,
              "Origin Port":data.search_param.origin_location.portcode_portname,
              "Destination Port":data.search_param.destination_location.portcode_portname,
              "Load Details":vm.fclLoadData.loadtype,
              "Load In TEUs": vm.fclLoadData.typexqty,
              "Origin Charges":data.search_param.origin_charges,
              "Origin Custom":data.search_param.origin_customs,
              "Destination Charges":data.search_param.destination_charges,
              "Destination Customs":data.search_param.destination_customs
          });
          if (vm.prefilledCardSearch) {

            SearchService.specialparam = vm.searchPostData;
            $state.go('app.search');
            
          }else{

              util.isCallingApi = true;

              data.search_param.origin_charges = true;
              data.search_param.origin_customs = true;
              data.search_param.destination_charges = true;
              data.search_param.destination_customs = true;

              if( data.search_param.origin_location.place_type == 'Door' ){
              data.search_param.pickup = data.search_param.origin_location;
              data.search_param.pickup_selected = true;
              }
              if( data.search_param.destination_location.place_type == 'Door' ){
              data.search_param.delivery = data.search_param.destination_location;
              data.search_param.delivery_selected = true;
              }

              data.search_param["search_type"] = (data.search_param.pickup ? 'D' : 'P') + '2' + (data.search_param.delivery ? 'D' : 'P');

              SearchService.postSearchData(data).then(function(response){
                  SearchService.FclResult =  response.data.data;
                  SearchService.isNewSearch = true;
                  $state.go('app.search.result',{ id: SearchService.FclResult._id});
                  util.isCallingApi = false;
              },function(error){
                  util.isCallingApi = false;
                  util.showToast(error.data.message);
                  $log.log(error);
              });
          }

      }





    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.search')
        .controller('SearchHistoryController', SearchHistoryController);

    /** @ngInject */
    function SearchHistoryController($state, $log, $filter, SearchParam, util, SearchService,$rootScope,analytics)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.init = init;
        vm.lastSearchArray = [];
        vm.SearchHistoryReceived = false;
        vm.loadMoreSearches = loadMoreSearches;
        vm.quote_search_fcl = angular.copy(SearchParam.data.search_param_fcl);
        vm.quote_search_air = angular.copy(SearchParam.data.search_param_air);
        vm.quote_search_lcl = angular.copy(SearchParam.data.search_param_lcl);
        vm.quote_search_ftl = angular.copy(SearchParam.data.search_param_getSearchHistory_ftl);
        var windowHeight = vm.util.isMobileApp ? angular.element(window).height()-100 : angular.element(window).height()- 195; //set max height for quote list scroll
        vm.maxHeight = {
            "max-height" : windowHeight
        }
        vm.currentState = $state.current.name;
        vm.goBackToSearch = goBackToSearch;
        vm.quoteSearch = quoteSearch;
        vm.loadMoreFtlSearches=loadMoreFtlSearches;
        vm.resultFtlSearch=resultFtlSearch;
        vm.searchConfig = $rootScope.domainData.domain_info["SEARCH_CONFIG"];
        vm.init();

        function init(){
          vm.util.isCallingApi = true;
          if(activeSearchTab!="FTL"){
            SearchService.getLatestSearch(0).then(function(response){
                var searchList = angular.copy(response.data.data.searches);
                vm.searchesCount = response.data.data.count;
                vm.util.isCallingApi = false;
                SearchService.searchHistoryData = searchList;
                vm.lastSearchArray = searchList;
                vm.SearchHistoryReceived = true;
                return response.data;
              },function(error){
                vm.util.isCallingApi =false;
                $log.log(error.data);
                vm.noSearchHistory = true;
                return [];
            });
          }
          else{
            SearchService.getLatestFtlSearch(0).then(function(response){
                var searchList = angular.copy(response.data.data);
                vm.searchesCount = response.data.data.length;
                vm.util.isCallingApi = false;
                SearchService.searchHistoryData = searchList;
                vm.lastSearchArray = searchList;
                vm.SearchHistoryReceived = true;
                return response.data;
              },function(error){
                vm.util.isCallingApi =false;
                $log.log(error.data);
                vm.noSearchHistory = true;
                return [];
            });
          }
          
        }

        function loadMoreSearches(){
            console.log("load more", vm.searchesCount,vm.lastSearchArray.length);
          if(vm.searchesCount != vm.lastSearchArray.length){
            util.isCallingApi = true;
            SearchService.getLatestSearch(vm.lastSearchArray.length).then(function(response){
                if(response.data.data.count!=0){
                    vm.lastSearchArray = vm.lastSearchArray.concat(response.data.data.searches);

                }
                util.isCallingApi = false;
            },function(error){
                util.isCallingApi = false;
                $log.log(error);
            });
          }
        }

        function loadMoreFtlSearches(){
            if(vm.searchesCount != vm.lastSearchArray.length){
                util.isCallingApi = true;
                SearchService.getLatestFtlSearch(vm.lastSearchArray.length).then(function(response){
                    if(response.data.data.length!=0){
                        vm.lastSearchArray = vm.lastSearchArray.concat(response.data.data);
                    }
                    util.isCallingApi = false;
                },function(error){
                    util.isCallingApi = false;
                    $log.log(error);
                });
              }
        }

        function goBackToSearch(){
          $state.go('app.search');
          SearchService.historyparam = '';
        }

        function quoteSearch(searchData){
          var key;
          var data;
          vm.prefilledCardSearch = false;
          if(searchData.result_meta.search_param.mode == 'SEA-FCL'){

              if(vm.searchConfig && 
                (vm.searchConfig.stuffing.required && !searchData.result_meta.search_param.sales_user) || 
                (vm.searchConfig.shipper_company && vm.searchConfig.shipper_company.required && !searchData.result_meta.search_param.shipper_user) || 
                (vm.searchConfig.shipper_email && vm.searchConfig.shipper_email.required && !searchData.result_meta.search_param.shipper_user) ){
                vm.prefilledCardSearch = true;
              }

              if(new Date().setHours(0,0,0) > new Date(searchData.result_meta.search_param.cargo_ready_date)){
                  vm.quote_search_fcl.cargo_ready_date = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
              }else{
                  vm.quote_search_fcl.cargo_ready_date = searchData.result_meta.search_param.cargo_ready_date;
              }

              vm.quote_search_fcl.origin_location = searchData.result_meta.search_param.origin_location;
              vm.quote_search_fcl.destination_location = searchData.result_meta.search_param.destination_location;

              // var loadData;
              if (!vm.prefilledCardSearch) {
                vm.quote_search_fcl.search_name = searchData.result_meta.search_param.origin_location.location + ' to ' + searchData.result_meta.search_param.destination_location.location + ' / ' + $filter('date')(searchData.result_meta.search_param.cargo_ready_date, 'd MMM yyyy');
              }

              vm.quote_search_fcl.load_data = searchData.result_meta.search_param.load_data;

              vm.quote_search_fcl["stuffing"] = searchData.result_meta.search_param.stuffing ? searchData.result_meta.search_param.stuffing : $rootScope.domainData.domain_info["DEFAULT_STUFFING"];
              vm.quote_search_fcl.inco_term = searchData.result_meta.search_param.inco_term;
              vm.quote_search_fcl.impo_expo = searchData.result_meta.search_param.impo_expo;

              vm.quote_search_fcl.shipper_user = "";
              vm.quote_search_fcl.sales_user = util.userProfile.user;

              data =  {
                  "search_param" : vm.quote_search_fcl
              }

              vm.fclLoadData = SearchService.getFclLoadDetails(data.search_param.load_data.load_details_value);
              //mixpanel code
              analytics.track("Rates from Search History",{
                  "Mode":data.search_param.mode,
                  "Cargo Ready Date":data.search_param.cargo_ready_date,
                  "Search Name":data.search_param.search_name,
                  "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
                  "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + vm.fclLoadData.loadtype,
                  "Origin Port":data.search_param.origin_location.portcode_portname,
                  "Destination Port":data.search_param.destination_location.portcode_portname,
                  "Load Details":vm.fclLoadData.loadtype,
                  "Load In TEUs":vm.fclLoadData.typexqty,
                  "Origin Charges":data.search_param.origin_charges,
                  "Origin Custom":data.search_param.origin_customs,
                  "Destination Charges":data.search_param.destination_charges,
                  "Destination Customs":data.search_param.destination_customs
              });


              if (vm.prefilledCardSearch) {
                SearchService.historyparam = vm.quote_search_fcl;
                $state.go('app.search');
              }else{
                  util.isCallingApi = true;

                  if( data.search_param.origin_location.place_type == 'Door' ){
                      data.search_param.pickup = data.search_param.origin_location;
                      data.search_param.pickup_selected = true;
                      data.search_param.origin_charges = true;
                      data.search_param.origin_customs = true;
                  }
                  if( data.search_param.destination_location.place_type == 'Door' ){
                      data.search_param.delivery = data.search_param.destination_location;
                      data.search_param.destination_charges = true;
                      data.search_param.destination_customs = true;
                      data.search_param.delivery_selected = true;
                  }

                  data.search_param["search_type"] = (data.search_param.pickup ? 'D' : 'P') + '2' + (data.search_param.delivery ? 'D' : 'P');

                  var pageState = 'app.search.result';
                  if($rootScope.domainData.domain_info.ALLOW_RESULT_POLLING){
                    data.search_param["fetchType"] = "pooling";
                    pageState = 'app.search.fclV2Rates'
                  }

                  SearchService.postSearchData(data).then(function(response){
                      SearchService.searchHistoryData = [];
                      SearchService.FclResult =  response.data.data;
                      SearchService.isNewSearch = true;
                      $state.go(pageState,{ id: SearchService.FclResult._id});
                      util.isCallingApi = false;
                  },function(error){
                      util.isCallingApi = false;
                      $log.log(error);
                  });
              }
          }
          else if(searchData.result_meta.search_param.mode == 'AIR'){

              for (key in vm.quote_search_air) {
                  if(vm.quote_search_air.hasOwnProperty(key) && searchData.result_meta.search_param.hasOwnProperty(key)) {
                      vm.quote_search_air[key] = searchData.result_meta.search_param[key];
                  }
              }

              if(new Date().setHours(0,0,0) > new Date(vm.quote_search_air.cargo_ready_date)){
                  vm.quote_search_air.cargo_ready_date = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
              }

              vm.quote_search_air.search_name = searchData.result_meta.search_param.search_name;

              if( vm.quote_search_air.origin_location.place_type == 'Door' ){
                  vm.quote_search_air.pickup = vm.quote_search_air.origin_location;
                  vm.quote_search_air.pickup_selected = true;
                  vm.quote_search_air.origin_charges = true;
                  vm.quote_search_air.origin_customs = true;
              }
              if( vm.quote_search_air.destination_location.place_type == 'Door' ){
                  vm.quote_search_air.delivery = vm.quote_search_air.destination_location;
                  vm.quote_search_air.destination_charges = true;
                  vm.quote_search_air.destination_customs = true;
                  vm.quote_search_air.delivery_selected = true;
              }

              vm.quote_search_air.shipper_user = "";
              vm.quote_search_air.sales_user = util.userProfile.user;

              data =  {
                  "search_param" : vm.quote_search_air
              }
              //mixpanel code
              analytics.track("Rates from Search History",{
                  "Mode":data.search_param.mode,
                  "Cargo Ready Date":data.search_param.cargo_ready_date,
                  "Search Name":data.search_param.search_name,
                  "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
                  "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                  "Origin Port":data.search_param.origin_location.portcode_portname,
                  "Destination Port":data.search_param.destination_location.portcode_portname,
                  "Load Details":data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                  "Origin Charges":data.search_param.origin_charges,
                  "Origin Custom":data.search_param.origin_customs,
                  "Destination Charges":data.search_param.destination_charges,
                  "Destination Customs":data.search_param.destination_customs
              });
              util.isCallingApi = true;
              SearchService.postSearchData(data).then(function(response){
                SearchService.searchHistoryData = [];
                SearchService.AirResult =  response.data.data;
                SearchService.isNewSearch = true;

                  $state.go('app.search.airResult',{ id: SearchService.AirResult._id });
                  util.isCallingApi = false;

              },function(error){
                  util.isCallingApi = false;
                  $log.log(error);
              });
          }
          else if(searchData.result_meta.search_param.mode == 'SEA-LCL'){
              for (key in vm.quote_search_lcl) {
                  if(vm.quote_search_lcl.hasOwnProperty(key) && searchData.result_meta.search_param.hasOwnProperty(key)) {
                      vm.quote_search_lcl[key] = searchData.result_meta.search_param[key];
                  }
              }

              if(new Date().setHours(0,0,0) > new Date(vm.quote_search_lcl.cargo_ready_date)){
                  vm.quote_search_lcl.cargo_ready_date = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
              }

              vm.quote_search_lcl.search_name = searchData.result_meta.search_param.search_name;

              if( vm.quote_search_lcl.origin_location.place_type == 'Door' ){
                  vm.quote_search_lcl.pickup = vm.quote_search_lcl.origin_location;
                  vm.quote_search_lcl.pickup_selected = true;
                  vm.quote_search_lcl.origin_charges = true;
                  vm.quote_search_lcl.origin_customs = true;
              }
              if( vm.quote_search_lcl.destination_location.place_type == 'Door' ){
                  vm.quote_search_lcl.delivery = vm.quote_search_lcl.destination_location;
                  vm.quote_search_lcl.destination_charges = true;
                  vm.quote_search_lcl.destination_customs = true;
                  vm.quote_search_lcl.delivery_selected = true;
              }

              vm.quote_search_lcl.shipper_user = "";
              vm.quote_search_lcl.sales_user = util.userProfile.user;

              data =  {
                  "search_param" : vm.quote_search_lcl
              }

              //mixpanel code
              analytics.track("Rates from Search History",{
                  "Mode":data.search_param.mode,
                  "Cargo Ready Date":data.search_param.cargo_ready_date,
                  "Search Name":data.search_param.search_name,
                  "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
                  "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                  "Origin Port":data.search_param.origin_location.portcode_portname,
                  "Destination Port":data.search_param.destination_location.portcode_portname,
                  "Load Details":data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                  "Origin Charges":data.search_param.origin_charges,
                  "Origin Custom":data.search_param.origin_customs,
                  "Destination Charges":data.search_param.destination_charges,
                  "Destination Customs":data.search_param.destination_customs
                  // "Load Container Type": load.container_type
                });

              util.isCallingApi = true;
              SearchService.postSearchData(data).then(function(response){
              SearchService.searchHistoryData = [];
              SearchService.LclResult =  response.data.data;
              SearchService.isNewSearch = true;
              // var loadData = [{"type" : load.container_type ,"count":1 }];

                  $state.go('app.search.lclResult',{ id: SearchService.LclResult._id });
                  util.isCallingApi = false;
              },function(error){
                  util.isCallingApi = false;
                  $log.log(error);
              });

          }
        }





    }
})();

(function () {
  'use strict';

    angular
    .module('app.core')
    .component('recentSearchCard', {
      templateUrl: 'app/main/search/components/recent-search-card/recent-search-card.html',
      bindings : {
        searchcard : '<',
        mode:'=',
        callback : '&'
      },
      controller: RecentSearchCardController
    })
    .component('recentSearchFtl', {
      templateUrl: 'app/main/search/components/recent-search-card/recent-search-ftl.html',
      bindings : {
        searchcard : '<',
        mode:'=',
        callback : '&'
      },
      controller: RecentSearchCardController
    });


    function RecentSearchCardController(util) {
        var vm = this;
        vm.util = util;
        vm.hideShimmer = false;
        vm.getTimeStampValue = getTimeStampValue;
        vm.formLoadData = formLoadData;
        vm.recentSearchLocation=recentSearchLocation;

        this.$onChanges = function (obj) {
          if(obj.searchcard.currentValue) {
            vm.hideShimmer = true;
          }
        }

        function getTimeStampValue(date){
          var time_ago;
          date = moment.utc(date).local();
          time_ago = timeSince(date);
          return time_ago;
        }

        function timeSince(date) {
          var seconds = Math.floor((new Date() - date) / 1000);
          var interval = Math.floor(seconds / 31536000);
          if (interval > 1) {
            return interval + " years";
          }
          interval = Math.floor(seconds / 2592000);
          if (interval > 1) {
            return interval + " months";
          }
          interval = Math.floor(seconds / 86400);
          if (interval > 1) {
            return interval + " days";
          }
          interval = Math.floor(seconds / 3600);
          if (interval >= 1) {
            return interval + " hours";
          }
          interval = Math.floor(seconds / 60);
          if (interval >= 1) {
            return interval + " minutes";
          }
          if(seconds < 0){
            return "0 seconds";
          }
          return Math.floor(seconds) + " seconds";
        }

        function formLoadData(load_data){
          var response = '';
            if(load_data!=null){
              var data=vm.mode=='FTL'? load_data :load_data.load_details_value;
              var length = data.length;
              if(length > 0){
                  data.map(function(item,index){
                      response +=  item.type + ' x ' +   item.qty  + ( (length-1) === index ? ' ' : ', '  );
                  });
              }
           }
          
          return response;
        }
        function recentSearchLocation(location){
          if(location){
            var locationString=[ (location.globalPortCode ? location.globalPortCode + '/' : '')+location.location , location.city ,location.regionCode ]
          }
          return util.filterArrayOfString(locationString)
        }
    }
})();

(function () {
    'use strict';

    angular
    .module('app.core')
    .component('productApiConfig', {
        templateUrl: 'app/main/roles/component/productApiConfig/product-api-config.html',
        bindings : {
            clientdata : '=',
            displaytype: '=',
            iseditable : '=',
            callback : '&'
        },
        controller: ProductApiConfigController
    });


    function ProductApiConfigController($scope, $state,$mdDialog,$timeout,$mdSelect, $log,$window) {
        var vm = this;
        vm.fnCopyContent = fnCopyContent;
        vm.isCopied = 'Click to Copy';

        this.$onInit =  function() {
        }

        function fnCopyContent(copyedText){
            vm.isCopied = 'Copied!'
            var temp_input = $("<input>");
            $("body").append(temp_input);
            temp_input.id = 'tempCopyToClipboard';
            temp_input.val(copyedText).select();
            document.execCommand("copy");
            temp_input.remove();
            $timeout(function ()
            {
                vm.isCopied = 'Click to Copy';
            }, 1500);
        }
        
    }

})();
(function () {
    'use strict';

    angular
    .module('app.core')
    .component('importMultipleUsers', {
        templateUrl: 'app/main/roles/component/importMultiUsers/import-multi-users.html',
        bindings : {
            importdata : '=',
            callback : '&'
        },
        controller: ImportMultipleUsersController
    });


    function ImportMultipleUsersController($scope, $state, util,$mdDialog,RoleService,$rootScope,$timeout,$mdSelect, $log,$window,DashboardService,cdnTemplateUrl) {
        var vm = this;
        vm.util = util;
        vm.getRolesList = getRolesList;
        vm.getCompanyList = getCompanyList;
        vm.newCompanyPanelShow = false;
        vm.searchCompanyPanelShow = false;
        vm.fnclickCompany = fnclickCompany;
        vm.fnAddNewCompany = fnAddNewCompany;
        vm.fnExistingCompany = fnExistingCompany;
        vm.fnSendImportMultiUsers = fnSendImportMultiUsers;
        vm.cancelDialog = cancelDialog;
        vm.imuFormObj = {};
        vm.userRoleId = '';
        vm.isUploading = false;
        vm.downloadUrl = cdnTemplateUrl + '/shipper-company.xlsx';
        vm.sampleFileDownload = sampleFileDownload;
        vm.fnImportUserRole = fnImportUserRole;
        vm.shipperRoleList = [];
        vm.forwarderRoleList = [];
        vm.validationObj={
            "roleValidation":false,
            "fileValidation":false,
            "companyValidation":false,
            "companyNameValidation":false,
             "emailValidation":false,
             "addressValidation":false,
              "countryValidation":false,
               "pincodeValidation":false,
        }
       
        
        vm.companyfinalData = {
            'id': util.userProfile.user.company.id,
            'companyName': util.userProfile.user.company.company_name,
            'companyAddress': util.userProfile.user.company.company_name,
            'companyEmail' : util.userProfile.user.company.company_name,
            'companyPhoneNumber' : util.userProfile.user.company.company_name,
            'postalCode' : util.userProfile.user.company.company_name,
            'country' : util.userProfile.user.company.company_name
        }
        
        this.$onInit =  function() {
            if(vm.importdata.importType == 'users'){
                vm.downloadUrl = cdnTemplateUrl + '/user.xlsx';
                if(util.shipperCompanyObj.length === 0){
                    vm.getCompanyList(); 
                }
                if(util.rolesListObj.length === 0){
                    vm.getRolesList();
                }
            }
        }    
        

        // get shipper company list
        function getCompanyList(searchText) {
            vm.listLoader = true;
            RoleService.getAssignedShipper(searchText).then(function (response) {
                util.shipperCompanyObj = angular.copy(response.data.data); 
                vm.listLoader = false;
                if(util.shipperCompanyObj.length === 0){
                    document.getElementById('add-new-company').style.position = "relative";
                }else{
                    document.getElementById('add-new-company').style.position = "sticky";
                }
            }, function (error) {
                vm.listLoader = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        } 
        
        // get shipper users role list
        function getRolesList() {
            DashboardService.getRolesList('').then(function (response) {
                var outObject = response.data.data.reduce(function(a, e) {
                    var estKey = (e['created_for']); 
                    (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e);
                    return a;
                  });
                util.rolesListObj = {
                    "forwarderRoleList" : angular.copy(outObject.FORWARDER),
                    "shipperRoleList" : angular.copy(outObject.SHIPPER)
                } 
            }, function (error) {
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        }

        function fnImportUserRole(userType){
            if(userType == 'FORWARDER'){
                vm.newCompanyPanelShow = false;
                vm.searchCompanyPanelShow = false;
            }else{
                // shipper user type
                fnExistingCompany();
            }
        }

        // Close dialog box
        function cancelDialog(){
            util.callMixpanel( (vm.importdata.importType == 'users' ? 'User' : 'Shipper')+'-Import-Close-Click' , {'Event':'CloseBy Icon'})
            $mdDialog.hide();
        }        

        // add compnay label apply from shipper company md-select
        function fnclickCompany(){
            $timeout(function ()
            {
                document.getElementById('add-new-company').style.position = "sticky";
                document.getElementById('add-new-company').style.bottom = "0";
                document.getElementById('add-new-company').style.padding = "11px";
                document.getElementById('add-new-company').style.background = "white";
                document.getElementById('add-new-company').style.width = "100%";
            },50);
            
        }

        // open panel for create new company 
        function fnAddNewCompany(){
            vm.newCompanyPanelShow = true;
            vm.searchCompanyPanelShow = false;
            $mdSelect.hide();
        }

        // open panel for exisiting compnay 
        function fnExistingCompany(){
            $mdSelect.hide();
            vm.newCompanyPanelShow = false;
            vm.searchCompanyPanelShow = true;
        }

        // submit form import multiple users..
        function fnSendImportMultiUsers(imuForm){
            var formData = new FormData();
            vm.importFileError = '';
            // Mixpanel code
            var importValidationObj={
                'UserRole': '',
                'CompanyName':'',
                'ImportFile' : ''
            }
            var mixpanelObj = {
                'User Role' : vm.imuFormObj.selectRolesList,
                'Shipper Company' : vm.searchCompanyPanelShow ? (vm.imuFormObj.selectedCompany ? vm.imuFormObj.selectedCompany.company_name : '') : '',
                'Validations' : importValidationObj,
                'NewCompany' : {}
            }
            if(vm.importdata.importType == 'users'){
                if(vm.newCompanyPanelShow == true){
                    mixpanelObj.NewCompany.companyName = vm.imuFormObj.companyName;
                    mixpanelObj.NewCompany.companyAddress = vm.imuFormObj.address;
                    mixpanelObj.NewCompany.companyEmail = vm.imuFormObj.emailId;
                    mixpanelObj.NewCompany.companyPhoneNumber = vm.imuFormObj.phoneNumber;
                    mixpanelObj.NewCompany.postalCode = vm.imuFormObj.zipcode;
                    mixpanelObj.NewCompany.country = vm.imuFormObj.country;

                 }
            }
            var mixpanelEventName = vm.importdata.importType + '-Import-Submit-Click';

            if(vm.importdata.importType == 'users'){
                
                if(!vm.imuFormObj.selectRolesList){
                    vm.validationObj.roleValidation=true;
                    importValidationObj.UserRole = 'Required';
                }
                if(vm.searchCompanyPanelShow && !vm.imuFormObj.selectedCompany){
                    vm.validationObj.companyValidation=true;
                    importValidationObj.companyName = 'Required';
                }
                if(vm.newCompanyPanelShow){
                    importValidationObj.addCompany = {};
                    if(!vm.imuFormObj.companyName){
                        vm.validationObj.companyNameValidation=true;
                        importValidationObj.addCompany.companyName = 'Required';
                    }
                    if(!vm.imuFormObj.emailId){
                        vm.validationObj.emailValidation=true;
                        importValidationObj.addCompany.emailId = 'Required';
                    }
                    if(!vm.imuFormObj.address){
                        vm.validationObj.addressValidation=true;
                        importValidationObj.addCompany.address = 'Required';
                    }
                    if(!vm.imuFormObj.country){
                        vm.validationObj.countryValidation=true;
                        importValidationObj.addCompany.country = 'Required';
                    }
                    if(!vm.imuFormObj.zipcode){
                        importValidationObj.addCompany.zipcode = 'Required';
                        vm.validationObj.pincodeValidation=true;
                    }
                }
            }
            if(!vm.imuFormObj.importFile){
                vm.validationObj.fileValidation=true;
                importValidationObj.ImportFile = 'Required';
            }
            if( vm.validationObj.fileValidation || vm.validationObj.companyValidation || vm.validationObj.companyNameValidation || vm.validationObj.emailValidation || vm.validationObj.addressValidation || vm.validationObj.countryValidation || vm.validationObj.pincodeValidation )
            {
                util.callMixpanel(mixpanelEventName , mixpanelObj );
                return
            }
            if(vm.isUploading == true){
                return;
            }
            vm.isUploading = true;
            // create new compnay param
            if(vm.imuFormObj.phoneNumber == '' || vm.imuFormObj.phoneNumber == undefined){
                vm.imuFormObj.phoneNumber = null;
            }
            if(vm.importdata.importType == 'users'){
                if(vm.newCompanyPanelShow == true){ 
                    vm.companyfinalData.id = null;
                    vm.companyfinalData.companyName = vm.imuFormObj.companyName;
                    vm.companyfinalData.companyAddress = vm.imuFormObj.address;
                    vm.companyfinalData.companyEmail = vm.imuFormObj.emailId;
                    vm.companyfinalData.companyPhoneNumber = vm.imuFormObj.phoneNumber;
                    vm.companyfinalData.postalCode = vm.imuFormObj.zipcode;
                    vm.companyfinalData.country = vm.imuFormObj.country;
                    vm.companyfinalData.companyType = vm.imuFormObj.companyType || 'customer';
                    vm.companyfinalData.externalReferenceCode = vm.imuFormObj.externalReferenceCode;


                }else if(vm.searchCompanyPanelShow == true){ // exisiting compnay param
                    vm.companyfinalData.id = vm.imuFormObj.selectedCompany.id;
                    vm.companyfinalData.companyName = vm.imuFormObj.selectedCompany.company_name;
                    vm.companyfinalData.companyAddress = vm.imuFormObj.selectedCompany.company_address;
                    vm.companyfinalData.companyEmail = vm.imuFormObj.selectedCompany.company_email;
                    vm.companyfinalData.companyPhoneNumber = vm.imuFormObj.selectedCompany.company_phone_number;
                    vm.companyfinalData.postalCode = vm.imuFormObj.selectedCompany.postal_code;
                    vm.companyfinalData.country = vm.imuFormObj.selectedCompany.country;
                    vm.companyfinalData.companyType = vm.imuFormObj.selectedCompany.company_type || 'customer';
                    vm.companyfinalData.externalReferenceCode = vm.imuFormObj.selectedCompany.external_reference_id;
                }
                formData.append("notifyForPasswordGeneration", false);
                formData.append("company", JSON.stringify(vm.companyfinalData));
            }
            vm.userRoleId = vm.imuFormObj.selectRolesList;
            formData.append("roleId", vm.userRoleId);
            formData.append("dataFile", vm.imuFormObj.importFile);

            // god user
            if(util.isFreightbro){
                formData.append("id", $rootScope.forwarder_id);
            }   
           
            RoleService.fnSendIMUData(formData,vm.importdata.importType).then(function(response){
                util.callMixpanel(mixpanelEventName , mixpanelObj );
                vm.isUploading = false;
                vm.cancelDialog();
                var totalRecords = angular.fromJson(response).data[0].count.total;
                vm.callback({'data' : { 'totalRecordsImported': totalRecords}});
                util.showToast(RoleService.importFileUploadedMessage(totalRecords));  
            },function(error){
                vm.isUploading = false;
                var errorText = angular.fromJson(error.responseText);
                
                // if(errorText.errors.file){
                //     $timeout(function () { vm.importFileError = errorText.errors.file[0]; },5);
                
                // toast message for file validation errors
                if(error.status === 500 || (errorText.errors && errorText.errors.file)){
                    var message = errorText.errors && errorText.errors.file ? errorText.errors.file[0] : 
                                 'Invalid file format or empty file. Please check your Excel file and ensure it matches the template format.';
                    util.showToast(message);
                }else{
                    util.showToast(util.displayValidationError(error));
                }
                $log.error(error);
            });
        }

        function sampleFileDownload(){
            util.callMixpanel((vm.importdata.importType == 'users' ? 'Users': 'Shipper') + '-Import-SampleFileDownload-Click')
            $window.open(util.sanitizeQueryParams(vm.downloadUrl));
        }
    }

})();
(function () {
    'use strict';

    angular
    .module('app.core')
    .component('importFileStatusBar', {
        templateUrl: 'app/main/roles/component/import-file-status-bar/import-file-status-bar.html',
        bindings : {
            importstatusobj : '=',
            callback : '&'
        },
        controller: importFileStatusBarController
    });


    function importFileStatusBarController($scope, util,RoleService,$timeout, $log,$window) {
        var vm = this;
        vm.util = util;


    }
})();
(function () {
    'use strict';

    angular
    .module('app.core')
    .component('exportMultipleUsers', {
        templateUrl: 'app/main/roles/component/exportMultiUsers/export-multi-users.html',
        bindings : {
            exportdata : '=',
            callback : '&'
        },
        controller: ExportMultipleUsersController
    });


    function ExportMultipleUsersController(util,$mdDialog,$rootScope,$http,$window) {
        var vm = this;
        vm.util = util;
        vm.fnSendEmportMultiUsers=fnSendEmportMultiUsers;
        vm.cancelDialog = cancelDialog;
        vm.exportTypeList=[{
            "label":"XLS",
            "value":"XLS"
        
        }]
        vm.exportSelectedType='XLS';
        vm.limit=0;
        vm.isDownloading=false;
       
        
        this.$onInit =  function() {
            
         vm.limit=vm.exportdata.totalLength
        }    
        

    

        // Close dialog box
        function cancelDialog(){
           
            util.callMixpanel( (vm.exportdata.importType == 'users' ? 'User' : 'Shipper')+'-Export-Close-Click' , {'Event':'CloseBy Icon'})
            $mdDialog.hide();
        }        

     function fnSendEmportMultiUsers(){
        
        vm.isDownloading=true;
        util.callMixpanel( (vm.exportdata.importType == 'users' ? 'User' : 'Shipper')+'-Export-Download-Click')
        var url = new URL(vm.exportdata.url);
        url.searchParams.set('limit', vm.limit);
        if(vm.limit == vm.exportdata.totalLength){
            var paramsToRemove = ['from_date', 'to_date','requested_company','requested_fwdr_users','role_id','status','requested_shpr_users'];
            angular.forEach(paramsToRemove, function (param) {
                if(url.searchParams.has(param)){
                    url.searchParams.delete(param);
                }
              
              });
         
        }
        vm.exportdata.url =url.toString();
       
        $http.get(vm.exportdata.url).then(function (response) {
            vm.isDownloading=false;
            $mdDialog.hide();
            $window.open(util.sanitizeQueryParams(response.data.signedUrl));
        },function(error){
            $mdDialog.hide();
            util.showToast(util.displayValidationError(error));
            $log.log(error);
        });
     }
    }

})();
(function () {
    'use strict';

    angular
      .module('app.core')
      .component('vasCharge', {
        templateUrl: 'app/main/result/Dialogs/vas-charge/vas-charges-modal.html',
        bindings : {
          vasdetails: '=',
          callback: '&'
        },
        controller: function VasChargeController(util,resultService,$log,$mdDialog,$filter,$timeout,$mdToast,shareQuoteService,analytics,constObj) {
          var vm = this;
          vm.shareQuoteService = shareQuoteService;
          vm.constObj = constObj;

          vm.currencyList = util.currencyList;
          vm.getVasChargesByleg = getVasChargesByleg;
          vm.addVasCharge = addVasCharge;
          vm.deleteAdditionalCharge = deleteAdditionalCharge;
          vm.closeDialog = closeDialog;
          vm.scrollBottom = scrollBottom;
          vm.conversionOnPriceChange = conversionOnPriceChange;
          vm.fnChangeBasis = fnChangeBasis;
          vm.closeToast = closeToast;
          vm.fnDeleteNewCharge = fnDeleteNewCharge;
          vm.isNumber = isNumber;
          vm.submitVasDetails = submitVasDetails;
          vm.getChargeCostForLclAir = getChargeCostForLclAir;
          vm.fnGetContainerQty = fnGetContainerQty;
          vm.isStringPresent = isStringPresent;

          // Init function
          this.$onInit = function() {
            // vm.editMode = util.isAdmin ? true : (util.isFreightbro ? true : false);
            vm.editMode = util.isShipper ? false : true;
            vm.value_added_charges = angular.copy(vm.vasdetails.value_added_charges);
            vm.legList = angular.copy(vm.vasdetails.legList); // leg list for editing
            vm.currency_rates  = vm.vasdetails.currency_rates;
            // Currency conversion setting code
            shareQuoteService.currencyConverter = {}; //Reset currency converter setting
            shareQuoteService.setCurrencyConvSetting(vm.vasdetails.search_param.user.user_base_currency,vm.vasdetails.currency_conversion_rates.markup,vm.vasdetails.currency_conversion_rates.directCurrencyMapping,vm.currency_rates);

            if(!vm.value_added_charges.length && (!vm.legList.sell_rates.additional_services.rate_obj.charges.length)){
              vm.getVasChargesByleg(); //get value added charges
            }
            vm.view_basis = util.getBasisList(vm.vasdetails.search_param.mode);
          };

          // get value added charges list on leg tab click
          function getVasChargesByleg(){
              vm.loading = true;
              return resultService.getVasChargesByleg(vm.vasdetails).then(function(response){
                vm.value_added_charges = response.data.data;
                vm.vasdetails.value_added_charges = angular.copy(response.data.data);
                vm.loading = false;
              },function(error){
                vm.loading = false;
                $log.log(error.data);
                return [];
              });

          }

          //function to add value added charge to addition charges list
          function addVasCharge(key,charge){

            charge.leg_currency_cost = (parseFloat(charge.leg_currency_cost) || 0);
            charge.customer_currency_cost = (parseFloat(charge.customer_currency_cost) || 0);

            vm.legList.sell_rates[key].rate_obj.charges.push(angular.copy(charge));
            vm.legList.buy_rates[key].rate_obj.charges.push(angular.copy(charge));

            var deleteIndex = vm.value_added_charges.findIndex(function(item){
                return item._id === charge._id;
            });

            vm.value_added_charges.splice(deleteIndex, 1);
            var charge_index = vm.legList.sell_rates[key].rate_obj.charges.length-1;
            shareQuoteService.addLclAirCharge = true;


            vm.conversionOnPriceChange(vm.legList.sell_rates[key].rate_obj.charges[charge_index], vm.legList.sell_rates[key].rate_obj, charge_index,1);  // for sell rates

            vm.conversionOnPriceChange(vm.legList.buy_rates[key].rate_obj.charges[charge_index], vm.legList.buy_rates[key].rate_obj, charge_index,1); // for buy Rates

              if (vm.editMode) {
                shareQuoteService.addLclAirCharge = true;
              }
          }

          function scrollBottom(){
            $('.vas-charge-dialog').animate({
              scrollTop: 1000
          }, 2000);
          }

          // Function to close modal dialog
          function closeDialog(){
            $mdDialog.hide();
          }

          //cost convertion if charge cost or currency change
          function conversionOnPriceChange (charge, sellRates, charge_index,new_charge_add) {
            vm.doneBtnDisable = true;
            if(vm.vasdetails.search_param.mode !== 'SEA-FCL' || (vm.search_param.mode === 'SEA-FCL' && (charge.charge_basis === shareQuoteService.pickupBasisName || charge.charge_basis === shareQuoteService.deliveryBasisName || charge.charge_basis === shareQuoteService.freightBasisName))){
              // shareQuoteService.isQuoteOrNewcard = 'quote';
              vm.getChargeCostForLclAir(sellRates,charge);

            }else{
              var prev_charge_leg_cost = angular.copy(sellRates.charges[charge_index].leg_currency_cost);
              var prev_cust_curr_cost = angular.copy(sellRates.charges[charge_index].customer_currency_cost);
              var charge_currency_rate = vm.currency_rates[charge.charge_currency];
              var leg_currency_rate = vm.currency_rates[sellRates.leg_currency];
              var customer_currency_rate = vm.currency_rates[vm.vasdetails.search_param.user.user_base_currency];

              var total_units = sellRates.charges[charge_index].total_units;
              var charge_cost = total_units * (parseFloat(charge.per_unit_rate) || 0);

              charge_cost = ((sellRates.leg_code == 'additional_services') && charge.per_unit_rate != undefined && charge.per_unit_rate != 0 && !vm.isNumber(charge.per_unit_rate) ) ? charge.per_unit_rate : charge_cost;

              sellRates.charges[charge_index].charge_cost = charge_cost;

              // sellRates.charges[charge_index].leg_currency_cost = !vm.isNumber(charge_cost) ? 0 : ((parseFloat(charge_cost) || 0) * leg_currency_rate) / charge_currency_rate;

              sellRates.charges[charge_index].leg_currency_cost = !vm.isNumber(charge_cost) ? 0 :shareQuoteService.currencyConverter.convert(parseFloat(charge_cost), charge.charge_currency, sellRates.leg_currency)

              // sellRates.charges[charge_index].customer_currency_cost = !vm.isNumber(charge_cost) ? 0 : ((parseFloat(charge_cost) || 0) * customer_currency_rate) / charge_currency_rate;
              sellRates.charges[charge_index].customer_currency_cost = !vm.isNumber(charge_cost) ? 0 :shareQuoteService.currencyConverter.convert(parseFloat(charge_cost), charge.charge_currency, vm.vasdetails.search_param.user.user_base_currency)


              if(!new_charge_add){
                // sellRates.leg_currency_cost -= (isNaN(prev_charge_leg_cost) ? 0 : prev_charge_leg_cost);
                sellRates.leg_currency_cost -= prev_charge_leg_cost;
                sellRates.leg_total_cost -= prev_cust_curr_cost;
              }

              sellRates.leg_currency_cost += sellRates.charges[charge_index].leg_currency_cost;
              sellRates.leg_total_cost += sellRates.charges[charge_index].customer_currency_cost;
              // sellRates.leg_currency_cost += sellRates.charges[charge_index].leg_currency_cost;
              // sellRates.leg_currency_cost += (isNaN(charge.per_unit_rate) ? 0 : sellRates.charges[charge_index].leg_currency_cost);

              var leg_total_currency_rate = vm.currency_rates[sellRates.leg_total_currency];

              // sellRates.leg_total_cost = (sellRates.leg_currency_cost) * (leg_total_currency_rate) / leg_currency_rate;
              // sellRates.leg_total_cost = shareQuoteService.currencyConverter.convert(parseFloat(sellRates.leg_currency_cost), sellRates.leg_currency, sellRates.leg_total_currency);
            }

            $timeout(function(){
                vm.doneBtnDisable = false;
            },200);
          }

          // change basis
          function fnChangeBasis(chargeObj, sellRate, charge_index, buyCharge, buyLeg) {
            vm.chargeError = false;
            var charge_type = chargeObj.container_type;
            vm.pickup_qty = 0;
            vm.delivery_qty = 0;
            vm.bL_value = 1;
            vm.sbL_value = vm.vasdetails.search_param.load_data.load_details_value[0].sbl_qty;
            vm.equipment_value = 1;
            vm.per_container = 0;

            if (!chargeObj.charge_basis) {
                chargeObj.total_units = 0;
                chargeObj.charge_cost = 0;
                // chargeObj.leg_currency_cost = 0;
                vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj, charge_index)
                if (vm.editMode) {
                  vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj, charge_index);
                }
                return true;
            }

            for (var i = 0; i < vm.vasdetails.search_param.load_data.load_details_value.length; i++) {
              vm.per_container += vm.vasdetails.search_param.load_data.load_details_value[i].qty;
              if (charge_type && (charge_type == vm.vasdetails.search_param.load_data.load_details_value[i].type)) {
                vm.bL_value = vm.vasdetails.search_param.load_data.load_details_value[i].bl_qty;
                // vm.sbL_value = vm.vasdetails.search_param.load_data.load_details_value[i].sbl_qty || 0;
                vm.equipment_value = vm.vasdetails.search_param.load_data.load_details_value[i].qty;
              }
            }

            if (chargeObj.charge_basis == 'per B/L' && !charge_type) {
              vm.bL_value = vm.vasdetails.search_param.load_data.load_details_value[0].bl_qty;
            }

            switch (chargeObj.charge_basis) {
                case "per equipment":
                chargeObj.total_units = vm.equipment_value;
                break;

                case constObj.PICKUP_BASIS:
                chargeObj.total_units = vm.pickup_qty;
                break;

                case "per B/L":
                chargeObj.total_units = vm.bL_value;
                break;

                case "per shipment":
                chargeObj.total_units = 1;
                break;

                case "per shipping bill":
                chargeObj.total_units = vm.sbL_value;
                break;

                case "per container":
                chargeObj.total_units = vm.per_container;
                  break;

                case "per shipping bill / per container":
                chargeObj.total_units = vm.per_container + vm.vasdetails.search_param.load_data.load_details_value[0].sbl_qty;
                if (chargeObj.charge_type === 'SLAB' && chargeObj.slab_type === 'INCREMENTAL') {
                  chargeObj.total_units = chargeObj.total_units - 1;
                }
                  break;

                case constObj.DELIVERY_BASIS:
                chargeObj.total_units = vm.delivery_qty;
                break;

                default:
                chargeObj.total_units = 1;
            }

            if (chargeObj.total_units == 0) {
                chargeObj.charge_cost = 0;
                chargeObj.leg_currency_cost = 0;
            }

            else {
                vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj, charge_index)
            }

            if (vm.editMode) {
              buyCharge.charge_basis = angular.copy(chargeObj.charge_basis);
              buyCharge.total_units = angular.copy(chargeObj.total_units);
              if(buyCharge.total_units && !isNaN(buyCharge.per_unit_rate) ) {
                vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj, charge_index);
              }
            }
          }

          //confirmation to delete charge
          function deleteAdditionalCharge (sellKey, sellRate, charge, index) {
            vm.chargeDelete = true;
            vm.deleteChargeBtn = false;
            vm.deleteCharge = charge;
            vm.legKeyName = sellKey;
            vm.deleteChargeLeg = sellRate;
            vm.chargeIndex = index;
            vm.deleteCharge_buyLeg = vm.legList.buy_rates[sellKey].rate_obj;

            vm.deleteChargeLineObj = vm.deleteChargeLeg.charges[index];
                $mdToast.show({
                hideDelay: false,
                position: 'top right',
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm },
                templateUrl: 'app/main/result/Dialogs/delete-charge/delete-charge.html'
            });
          }

          // delete Toast
          function closeToast () {
              $mdToast.hide();
          }

          // Delete Charge from additional charge table
          function fnDeleteNewCharge () {
              vm.deleteChargeBtn = true;
              var sellObj = vm.deleteChargeLeg;
              var buyObj = vm.deleteCharge_buyLeg;

              var index;
              index = vm.chargeIndex;

              sellObj.leg_currency_cost -= (isNaN(sellObj.charges[index].leg_currency_cost) ? 0 : sellObj.charges[index].leg_currency_cost);

              // sellObj.leg_total_cost = ((sellObj.leg_currency_cost) * (vm.currency_rates[sellObj.leg_total_currency])) / vm.currency_rates[sellObj.leg_currency];

              // sellObj.leg_total_cost = shareQuoteService.currencyConverter.convert(parseFloat(sellObj.leg_currency_cost), sellObj.leg_currency, sellObj.leg_total_currency);
              sellObj.leg_total_cost -= sellObj.charges[index].customer_currency_cost;

              sellObj.charges.splice(index, 1);

              buyObj.leg_currency_cost -= (isNaN(buyObj.charges[index].leg_currency_cost) ? 0 : buyObj.charges[index].leg_currency_cost);
              // buyObj.leg_total_cost = ((buyObj.leg_currency_cost) * (vm.currency_rates[buyObj.leg_total_currency])) / vm.currency_rates[buyObj.leg_currency];
              // buyObj.leg_total_cost = shareQuoteService.currencyConverter.convert(parseFloat(buyObj.leg_currency_cost), buyObj.leg_currency, buyObj.leg_total_currency);
              buyObj.leg_total_cost -= buyObj.charges[index].customer_currency_cost;

              buyObj.charges.splice(index, 1);

              var addVasCharge = vm.vasdetails.value_added_charges.find(function(item){ //restore original charge in value added charge table
                  return (item._id === vm.deleteCharge._id);
              });

              if(!addVasCharge){
                vm.value_added_charges.push(vm.deleteCharge);
              }else{ vm.value_added_charges.push(addVasCharge); }

              $mdToast.hide();
          }

          // check if it is number
          function isNumber(value){
            if(isNaN(value)){
              return false;
            }else{
              return true;
            }
          }

          // submit vas details
          function submitVasDetails(){
            var isDone = 1;

            for (var i in vm.legList.sell_rates) {
              var value = vm.legList.sell_rates[i];

              for (var j = 0; j < value.rate_obj.charges.length; j++) {
                var charge = value.rate_obj.charges[j];

                if (charge.charge_name == undefined || charge.charge_name == null || charge.charge_name == "") {
                  util.showToast("Please enter charge name.");
                  document.querySelector('#' + i + '_' + j + '').focus();
                  isDone = 0;
                  break;
                }
                if (!charge.charge_basis) {
                  util.showToast("Please select charge basis.");
                  document.querySelector('#' + i + '_' + j + '_unit').focus();
                  isDone = 0;
                  break;
                }
                if (charge.charge_basis == 'per equipment' && !charge.container_type) {
                  util.showToast("Please select equipment type");
                  document.querySelector('#' + i + '_' + j + '_unit').focus();
                  isDone = 0;
                  break;
                }
                if(charge.total_units == null){
                  util.showToast("Please select valid charge basis.");
                  document.querySelector('#'+i+'_'+j+'_unit').focus();
                  isDone = 0;
                  break;
                }
                if(charge.per_unit_rate == null || charge.per_unit_rate === "" || ( value.leg_code != 'additional_services' && isNaN(charge.per_unit_rate) ) ){
                  util.showToast("Please enter valid charge unit price.");
                  document.querySelector('#'+i+'_'+j+'_unit').focus();
                  isDone = 0;
                  break;
                }else{
                  charge.per_unit_rate = !isNaN(charge.per_unit_rate) ? parseFloat(charge.per_unit_rate) : charge.per_unit_rate;
                }

                if( vm.vasdetails.search_param.mode != 'SEA-FCL' && (charge.minimum_charge_cost == null || charge.minimum_charge_cost === "" || ( value.leg_code != 'additional_services' && isNaN(charge.minimum_charge_cost) ) ) ){
                  util.showToast("Please enter valid minimum price.");
                  document.querySelector('#' + i + '_' + j + '_min_unit').focus();
                  isDone = 0;
                  break;
                }else{
                  charge.minimum_charge_cost = !isNaN(charge.minimum_charge_cost) ? parseFloat(charge.minimum_charge_cost) : charge.minimum_charge_cost;
                }

                if (vm.vasdetails.search_param.mode === 'SEA-FCL') {
                  vm.legList.buy_rates[i].rate_obj.charges[j].container_type = vm.legList.sell_rates[i].rate_obj.charges[j].container_type;
                }


              }
              if (isDone === 0) {
                break;
              }
            }

            if(vm.editMode){
              for (var i in vm.legList.buy_rates) {
                var value = vm.legList.buy_rates[i];
                for (var j = 0; j < value.rate_obj.charges.length; j++) {
                  var charge = value.rate_obj.charges[j];
                  if(charge.per_unit_rate == null || charge.per_unit_rate === "" || ( value.leg_code != 'additional_services' && isNaN(charge.per_unit_rate))){
                    util.showToast("Please enter valid charge unit price.");
                    document.querySelector('#'+i+'_'+j+'_buyUnit').focus();
                    isDone = 0;
                    break;
                  }else{
                    charge.per_unit_rate = !isNaN(charge.per_unit_rate) ? parseFloat(charge.per_unit_rate) : charge.per_unit_rate;
                  }
                }
                if (isDone === 0) {
                  break;
                }
              }
            }

            if(isDone===1){
              vm.vasdetails.legList = vm.legList;
              vm.vasdetails.value_added_charges = vm.value_added_charges;
              $mdDialog.hide();
              vm.callback({data : {'data' : vm.vasdetails}});
               //mixpanel code
                analytics.track("VAS Used",{
                  "Module": vm.vasdetails.module,
                  "No of Charges Added": vm.vasdetails.legList.sell_rates.additional_services.rate_obj.charges.length
              });
            }

          }

          // lcl and air
          function fnGetContainerQty(leg_data, charge_data, action, charge_index, buyCharge, buyLeg){
            if( charge_data.charge_basis != '' || charge_data.charge_basis != null){

              // var airFreightValue = (vm.getAirFreightQty != null) ? vm.getAirFreightQty.leg_currency_cost : null; //air
              // shareQuoteService.fnGetContainerQty(charge_data, vm.vasdetails.search_param.load_data.load_meta, airFreightValue); //air
              var payload = {
                "charge" : charge_data,
                "load_meta" : vm.vasdetails.search_param.load_data.load_meta,
                "airFreightValue" : null,
                "pickupValue" : null,
                "deliveryValue" : null,
                "global_leg_id" : leg_data.global_leg_id,
                "ltl_load_details" : null,
                "mode" : vm.vasdetails.search_param.mode,
                "dimChargeableValue" :  leg_data.dim_data && leg_data.dim_data.chargeable_weight_in_kg && leg_data.dim_data.chargeable_weight_in_kg !== 0 ? leg_data.dim_data.chargeable_weight_in_kg : null
              }

              shareQuoteService.fnGetContainerQty(payload);

              if(charge_data.total_units == null) {
                charge_data.charge_cost = 0;
                charge_data.leg_currency_cost = 0;
              }
              else if(charge_data.total_units != null && charge_data.per_unit_rate !== null && charge_data.per_unit_rate !== 0) {
                  vm.getChargeCostForLclAir(charge_data,leg_data,charge_index);
              }

              if(vm.editMode){
                buyCharge.charge_basis = angular.copy(charge_data.charge_basis);
                buyCharge.total_units = angular.copy(charge_data.total_units);

                if (buyCharge.total_units != null && buyCharge.per_unit_rate !== null && buyCharge.per_unit_rate !== 0) {
                  vm.getChargeCostForLclAir(buyCharge, buyLeg, charge_index);
                }
              }
            }
          }

          //Get charge cost
          function getChargeCostForLclAir(leg_data,charge_data){
            // if(isNaN(charge_data.per_unit_rate) || isNaN(charge_data.minimum_charge_cost)){ //if sell price and minimum value is string
            //   shareQuoteService.fnGetLegTotal(leg_data,0,charge_data.leg_currency_cost,vm.currency_rates);
            //   charge_data.leg_currency_cost = isNaN(charge_data.per_unit_rate) ? charge_data.per_unit_rate : charge_data.minimum_charge_cost;
            // }else{
              shareQuoteService.getChargeCost(leg_data, charge_data, vm.vasdetails.search_param.user.user_base_currency);
              //air
              // if(charge_data.global_charge_id != null && (charge_data.global_charge_id.indexOf(shareQuoteService.airChargeId)) >= 0 && charge_data.total_units != null){
              //   vm.checkIfAirFreightCharge(leg_data, charge_data);
              // }
            // }
          }

          // is string present in charge leg currency cost
          function isStringPresent(charges){
            var found = charges.find(function(value) {
              return isNaN(value.charge_cost);
            });
            return found;
          }

          vm.fnCheckIsNaN = fnCheckIsNaN;
          vm.isString = isString;
          function fnCheckIsNaN(charge, param){
            var result = '';
            if(param == 'per_unit_rate'){
              if(angular.isString(charge.per_unit_rate)){
                  result = charge.per_unit_rate;
              }else{
                  result =  $filter('number')(charge.per_unit_rate, 2);
              }
            }else{
              if(!charge.min_flag && angular.isString(charge.charge_cost) ){
                  result = charge.charge_cost;
              }else{
                  result =  $filter('number')(charge.leg_currency_cost, 2);
              }
            }
            return result;
          }

          function isString(data) {
            if (typeof data === 'string') {
              return true;
            } else {
              return false;
            }
          }

        }
      });

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('scheduleComponent', {
      templateUrl: 'app/main/result/Dialogs/schedule-component/schedule-component.html',
      bindings: {
          searchParam : '=',
          maskLiner : '=',
          currentCard : '=',
          validationObj : '=',
          currentSchedule : '=',
          errorTextObj:'=',
          pageSource:'='
          // callback : '&'
      },
      controller: scheduleComponentController
    })
    .component('airScheduleComponent', {
      templateUrl: 'app/main/result/Dialogs/schedule-component/air-schedule-component.html',
      bindings: {
          searchParam : '=',
          maskLiner : '=',
          currentCard : '=',
          validationObj : '=',
          currentSchedule : '=',
          pageSource:'='
          // callback : '&'
      },
      controller: scheduleComponentController
    });


  function scheduleComponentController(util, api, QuotesService, $filter, resultService, $log) {
    var vm = this;
    vm.util = util;

    vm.selectedSchedule = selectedSchedule;
    vm.setCurrentSchedule = setCurrentSchedule;
    vm.fnGetSheduleList = fnGetSheduleList;
    vm.fnMetaValidation = fnMetaValidation;
    vm.fnTrackAnalytics = fnTrackAnalytics;
    vm.selectMultiSchedule = selectMultiSchedule ;
    vm.fnScheduleOldData = fnScheduleOldData;
    vm.fnClearAllSchedule = fnClearAllSchedule;

    this.$onInit = function () {

      vm.leg_mode = (vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
      vm.l3_leg = 'l3_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
      vm.l1_leg = 'l1_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
      vm.l5_leg = 'l5_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
      vm.multi_schedule_list =  vm.currentCard.meta.multi_schedule_list || [];
      
      // setTimeout(function () {
      //   vm.scheduleDivHeight =  document.getElementsByClassName('rate-card-detail-modal')[0].offsetHeight;
      // }, 100);
      vm.fnGetSheduleList();
    }

    function fnGetSheduleList(){
      vm.scheduleList = [];
      vm.getSchedule = false;
      vm.validationErrorArray = [];

      if(vm.searchParam.mode == 'AIR' && !vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data.length){
        vm.getSchedule = true;
        return;
      }
      
      if (!vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data.length) {

        if(vm.fnMetaValidation() > 0){
          vm.getSchedule = true;
          return;
        }
        
        var l3_obj = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj;
        var cargo_date = $filter("date")(new Date(), "yyyy-MM-dd");

        vm.currentCard.meta.port_data.origin_portname =
          vm.currentCard.meta.port_data.origin_port_code && vm.currentCard.meta.port_data.origin_port_code["portname"]
            ? vm.currentCard.meta.port_data.origin_port_code["portname"]
            : vm.currentCard.meta.port_data.origin_portname;

        var origin =
          vm.currentCard.meta.port_data.origin_port_code && vm.currentCard.meta.port_data.origin_port_code["global_port_code"]
            ? vm.currentCard.meta.port_data.origin_port_code["global_port_code"]
            : vm.currentCard.meta.port_data.origin_port_code;

        var via_pol =
          vm.currentCard.meta.via_pol && vm.currentCard.meta.via_pol["global_port_code"]
            ? vm.currentCard.meta.via_pol["global_port_code"]
            : vm.currentCard.meta.via_pol;

        vm.currentCard.meta.port_data.destination_portname =
          vm.currentCard.meta.port_data.destination_port_code && vm.currentCard.meta.port_data.destination_port_code["portname"]
            ? vm.currentCard.meta.port_data.destination_port_code["portname"]
            : vm.currentCard.meta.port_data.destination_portname;

        var destination =
          vm.currentCard.meta.port_data.destination_port_code && vm.currentCard.meta.port_data.destination_port_code["global_port_code"]
            ? vm.currentCard.meta.port_data.destination_port_code["global_port_code"]
            : vm.currentCard.meta.port_data.destination_port_code;

        var via_pod =
          vm.currentCard.meta.via_pod && vm.currentCard.meta.via_pod["global_port_code"]
            ? vm.currentCard.meta.via_pod["global_port_code"]
            : vm.currentCard.meta.via_pod;
        var source = vm.searchParam.mode === "SEA-FCL" ? "SEA_FCL" : "SEA_LCL" ;
        var scheduleUrl = api.baseUrl + "/api/schedules?from_port=" +
          origin + "&to_port=" +
          destination + "&carrier_code=" +
          l3_obj.sub_vendor.schedule_provider_code + "&from_date=" +
          cargo_date + "&mode=" + vm.searchParam.mode+'&source='+source;

        if (via_pol) {
          scheduleUrl += "&via_pol=" + via_pol;
        }
        if (via_pod) {
          scheduleUrl += "&via_pod=" + via_pod;
        }

        return QuotesService.getScheduleList(scheduleUrl).then(function (response) {
            vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data = angular.copy(response);
            vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = angular.copy(response);
            vm.scheduleList = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;
            var selectedScheduleIndex = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(vm.currentCard, vm.l3_leg) : 0;

            vm.currentCard.meta.selected_schedule =  selectedScheduleIndex !== null ? angular.copy(vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data[selectedScheduleIndex]) : null;
            vm.currentSchedule = angular.copy(vm.currentCard.meta.selected_schedule);
            if(!!vm.currentSchedule){
              vm.selectedSchedule(vm.currentSchedule);
            }
            vm.getSchedule = true;
            vm.fnScheduleOldData();
          },
          function (error) {
            vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data =
              [];
            vm.getSchedule = true;
            $log.log(error);
          });
      } else {
        vm.scheduleList = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;
        var selectedScheduleIndex = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(vm.currentCard, vm.l3_leg) : 0;

        vm.currentCard.meta.selected_schedule = vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule : vm.scheduleList.length &&  selectedScheduleIndex !== null ? angular.copy(vm.scheduleList[selectedScheduleIndex]) : null;
        vm.currentSchedule = angular.copy(vm.currentCard.meta.selected_schedule);
        if(vm.currentSchedule !== null){
          vm.selectedSchedule(vm.currentSchedule);
        }
        vm.getSchedule = true;
        vm.fnScheduleOldData('fromExisting');
      }

      if (vm.currentSchedule != null && vm.currentSchedule.departure_time > vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry) {
        vm.ifExpireCross = true;
      } else {
        vm.ifExpireCross = false;
      }
    }

    function fnMetaValidation(){
      var isError = 0;

      // Place of Reciept 
      if(!vm.currentCard.meta.port_data.origin_port_code){
        vm.validationObj.originPortValidation = true;
        vm.errorTextObj.originPortErrorText = 'Enter Port of Origin';
        vm.validationErrorArray.push('Port of Origin');
        isError++;
      }

      // pol
      if(vm.currentCard.meta.port_data.origin_port_code && vm.currentCard.meta.port_data.is_icd_port_origin && !vm.currentCard.meta.via_pol){
        vm.validationObj.polValidation = true;
        vm.validationErrorArray.push('Port of Loading');
        vm.errorTextObj.polErrorText = 'Enter Port of Loading';
        isError++;
      }

      // Final Destination 
      if(!vm.currentCard.meta.port_data.destination_port_code){
        vm.validationObj.destinationPortValidation = true;
        vm.errorTextObj.destinationPortErrorText = 'Enter Port of Destination';
        vm.validationErrorArray.push('Port of Destination');
        isError++;
      }

      // pod
      if( vm.currentCard.meta.port_data.destination_port_code && vm.currentCard.meta.port_data.is_icd_port_destination && !vm.currentCard.meta.via_pod){
        vm.validationObj.podValidation = true;
        vm.errorTextObj.podErrorText = 'Enter Port of Discharge';
        vm.validationErrorArray.push('Port of Discharge');
        isError++;
      }

      if(vm.searchParam.mode != 'AIR'){
        // liner
        if(!vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id){
          vm.validationObj.linerValidation = true;
          vm.validationErrorArray.push('Liner');
          isError++;
        }

        // expiry date
        // if(!vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry){
        //   vm.validationObj.expiryValidation = true;
        //   vm.validationErrorArray.push('Expiry Date');
        //   isError++;
        // }
      }else{
        // Airline
        if(!vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.airline || !vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.airline["airline_code"]){
          vm.validationObj.airlinerValidation = true;
          isError++;
        }

        // // ETD
        // if(!vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.departure_time){
        //   vm.validationObj.departureTimeValidation = true;
        //   isError++;
        // }

        // // ETA
        // if(!vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.arrival_time){
        //   vm.validationObj.arrivalTimeValidation = true;
        //   isError++;
        // }
      }

      return isError;
    }

    function selectedSchedule(scheduleObj){
      vm.currentCard.meta.selected_schedule = scheduleObj;
      vm.currentCard.meta.multi_schedule_list = vm.multi_schedule_list;
      vm.currentCard.meta["transit_time"] = vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule.transit_time : null ;
      // vm.callback({'card' :{'meta' : vm.currentCard.meta}});
    }

    function setCurrentSchedule(currentSchedule, index){
      if(vm.multi_schedule_list && vm.multi_schedule_list.length == 15 ){
        util.showToast("Maximum limit reached - 15");
        return;
      }
      if(!currentSchedule.isSelected){
        currentSchedule["isSelected"] = true;
        vm.multi_schedule_list.push(currentSchedule);
      }
      vm.currentSchedule = currentSchedule;

      if (vm.currentSchedule != null && vm.currentSchedule.departure_time > vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.expiry) {
        vm.ifExpireCross = true;
      } else {
        vm.ifExpireCross = false;
      }
      var cardIndex = index+1;
      vm.selectedSchedule(vm.currentSchedule);
     
    }
    function fnTrackAnalytics(action, params){
      if(!params){
        var params = {};
      }
      var shortPageName = '';
      if(vm.pageSource.includes('Inquiry')){
        shortPageName = 'ID';
      }
      else if(vm.pageSource.includes('Quote')){
        if(vm.pageSource.includes('Copy')){
          shortPageName = 'QC';
        }
        else{
          shortPageName = 'QD';
        }
      }
      else{
        shortPageName = 'RR';
      }
      params.mode = vm.searchParam.mode;
      params.action = vm.pageSource.includes('new') ? 'add' : 'edit';
      util.callMixpanel(shortPageName+'-'+action, params);
    }

    function selectMultiSchedule(selectedSchedule ){
      if(vm.multi_schedule_list && vm.multi_schedule_list.length == 15 && selectedSchedule.isSelected){
          selectedSchedule.isSelected = false;
          util.showToast("Maximum limit reached - 15");
          return;
      }
      if(!selectedSchedule.isSelected){
          vm.multi_schedule_list = vm.multi_schedule_list.filter(function(schedule){
            return schedule.id != selectedSchedule.id
          })
          // removing current schedule if it's removed from multi schedule list
          if(vm.currentSchedule && (selectedSchedule.id ==  vm.currentSchedule.id)){
            vm.currentSchedule = null
            vm.currentSchedule = vm.multi_schedule_list.length ? vm.multi_schedule_list[0] : null;
          }
       
      }else{
        // setting the first selected schedule from multi schedule as a current schedule if it is empty
        vm.currentSchedule = vm.currentSchedule ? vm.currentSchedule : (!vm.multi_schedule_list.length ? selectedSchedule : null );
        vm.multi_schedule_list.push(selectedSchedule)
        
      }
      vm.selectedSchedule(vm.currentSchedule);
    }
    function fnScheduleOldData(type){
        // storing old rates schedule on multi list
        if(vm.currentSchedule && vm.currentSchedule.schedule_track){
          if(!vm.multi_schedule_list.length){
              vm.currentSchedule["isSelected"] = true;
              vm.multi_schedule_list.push(vm.currentSchedule);
          }
          angular.forEach(vm.scheduleList ,function(schedule){
            if(schedule.id == vm.currentSchedule.id){
              schedule["isSelected"] = true
            }
          });
        }
        if(type){
          angular.forEach(vm.scheduleList ,function(scheduleFromDB){
            angular.forEach(vm.multi_schedule_list ,function(scheduleFromMulti){
              if(scheduleFromDB.id == scheduleFromMulti.id){
                scheduleFromDB["isSelected"] = true
              }
            });
          });
        }

    }
    function fnClearAllSchedule(){
      if(vm.multi_schedule_list && vm.multi_schedule_list.length) {
      vm.currentSchedule = null;
      vm.multi_schedule_list = [];
      angular.forEach(vm.scheduleList ,function(schedule){
        schedule["isSelected"] = false;
      });
      vm.selectedSchedule(vm.currentSchedule );
    }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('remarksInclusionPopup', {
      templateUrl: 'app/main/result/Dialogs/remarks-inclusion-popup/remarks-inclusion-popup.html',
      bindings: {
          quoteEdit : '=',
          currentCard : '=',
          callback : '&'
      },
      controller: remarksInclusionPopupController
    });


  function remarksInclusionPopupController(util) {
    var vm = this;
    vm.util = util;
    vm.termsConditionCkEditorConfig = angular.copy(util.ckEditorConfig);
    vm.termsConditionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
    this.$onInit = function () {
    }
  }
})();
(function () {
  "use strict";

  angular
    .module("app.core")
    .controller("PerWMController", PerWMController)
    .factory("perWMFactory", function () {
      return {panelClosed: false};
    });
  function PerWMController(mdPanelRef, perWMFactory) {

    var vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.closePanel = closePanel;

    // Variable Declaration
    vm.perWMFactory = perWMFactory;

    // console.log(vm.globalid, vm.charge, vm.ltldetails);

    // Declare functions for template
    function closePanel() {
      vm._mdPanelRef && vm._mdPanelRef.close();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('getLegs', {
      templateUrl: 'app/main/quotes/dialogs/get-legs/get-legs.html',
      bindings: {
          getLegOptions : '=',
          callback : '&'
      },
      controller: GetLegsController
    });
    
    function GetLegsController(util) {

      // data
      var vm = this;
      vm.util = util;

      // method
      vm.selectLeg = selectLeg;

      this.$onInit = function () {}


      function selectLeg(legKey, rates){
        
        vm.getLegOptions[legKey].selectedRate = rates.selected ? rates : null;

        angular.forEach(vm.getLegOptions[legKey].legs,function(item,key){
          item.selected = (vm.getLegOptions[legKey].selectedRate && vm.getLegOptions[legKey].selectedRate._id == item._id) ? true : false;
        });
      }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .component('createQuoteDialog', {
      templateUrl: 'app/main/quotes/dialogs/create-quote-dialog/create-quote-dialog.html',
      // bindings: {
      //    pageTitle:"=",
      //    templateName:"=",
      //    type:"=",
      //    callback:"&"
      // },
      controller: CreateQuoteDialogController
    });


  function CreateQuoteDialogController($mdDialog,$mdSelect,$state,$timeout,util,QuotesService,$rootScope,$http) {
    var vm = this;
    vm.util = util;
    vm.mdSelect = $mdSelect;
    vm.templateList = [];
    vm.tempTemplateList = [];
    vm.mode = "SEA-FCL";
    vm.modeValidation=false;
    vm.templateValidationError=false;
    vm.templateFilterLoader = false;
    vm.panelView=true;
    vm.searchText = "";
    vm.templateSelectedOptions = {},
    vm.templateListCheck=templateListCheck;
    vm.getListBySearch = getListBySearch;
    vm.modeChange = modeChange;
    vm.trackEvent=trackEvent;
    vm.closeDialog = closeDialog;
    vm.createQuoteRedirection=createQuoteRedirection;
    vm.validateAndCreateQuote=validateAndCreateQuote;
    vm.getTemplateList = getTemplateList;
    vm.checkValue = checkValue;
    vm.isEfpDomain = $rootScope.domainData && $rootScope.domainData.domain_info && $rootScope.domainData.domain_info.IS_EFP_DOMAIN;
    vm.modes = [
      { label: 'FCL', permission: 'FCL', mode: 'SEA-FCL' },
      { label: 'LCL', permission: 'LCL', mode: 'SEA-LCL' },
      { label: 'AIR', permission: 'AIR', mode: 'AIR' }
    ];

    function checkValue(){
        vm.searchText = "";
        vm.templateQueryParam.query = "";
        vm.templateList = vm.tempTemplateList;
        if(vm.templateSelectedOptions.quote_id){
          vm.templateListCheck();
        }
        vm.templateListCount = vm.templateList.length;
    }

    vm.templateQueryParam = {
      "mode": vm.isEfpDomain ? "fcl" : vm.mode,
      "limit" : 10,
      "offset" : 0,
      "query" : ""
    }

    function modeChange(){
      vm.templateSelectedOptions = {}
      if(vm.isEfpDomain){
        var modeMap = {
          "SEA-FCL": "fcl",
          "SEA-LCL": "lcl",
          "AIR": "air"
        };
        vm.templateQueryParam.mode = modeMap[vm.mode] || "all";
      }
      getTemplateList();
    }
    
    function closeDialog(event){
      util.callMixpanel(event);
      $mdDialog.hide();
    }

    this.$onInit = function () {
      setDefaultMode();
      getTemplateList();
    }

    function setDefaultMode() {
      var firstAvailable = vm.modes.find(function (tab) {
        return util.isModulePresent(tab.permission);
      });
      vm.mode = firstAvailable ? firstAvailable.mode : null;
      if (vm.isEfpDomain && vm.mode) {
        var modeMap = {
          "SEA-FCL": "fcl",
          "SEA-LCL": "lcl",
          "AIR": "air"
        };
        vm.templateQueryParam.mode = modeMap[vm.mode] || "fcl";
      } else {
        vm.templateQueryParam.mode = vm.mode;
      }
      vm.modes = vm.modes.filter(function (tab) {
        return util.isModulePresent(tab.permission);
      });
    }

    function isModeSelectable(modeValue) {
      var tab = vm.modes.find(function (m) { return m.mode === modeValue; });
      if (!tab) {
        return false;
      }
      return util.isModulePresent(tab.permission);
    }

    function templateListCheck(){
      vm.templateList.some(function(value){ return  value.quote_id === vm.templateSelectedOptions.quote_id }) ? "" : vm.templateList.push(vm.templateSelectedOptions)
    }
    function getTemplateList(){
      vm.templateFilterLoader =true;
      if(!vm.isEfpDomain){
        vm.templateQueryParam.mode=vm.mode;
      }
      QuotesService.getTemplateList(vm.templateQueryParam, vm.isEfpDomain)
      .then(function(response){
        if(vm.isEfpDomain){
          vm.templateList = response.data.data.template;
        } else {
          vm.templateList = response.data.templates;
        }
        vm.templateListCount=response.data.count;
        if(!vm.templateQueryParam.query && vm.templateSelectedOptions.quote_id ){
          vm.templateListCheck();
         }
        if(!vm.templateQueryParam.query && !vm.isEfpDomain){
          vm.tempTemplateList = response.data.templates;
        } else if(!vm.templateQueryParam.query && vm.isEfpDomain){
          vm.tempTemplateList = response.data.data.template;
        }
        vm.templateFilterLoader =false;
      },function(error){
        vm.templateFilterLoader =false;
        console.log(error);
      });
    }

    function validateAndCreateQuote(event){
      var isValid = true;
      
      if(!vm.mode || !isModeSelectable(vm.mode)){
        vm.modeValidation = true;
        isValid = false;
      }
      
      if(!vm.templateSelectedOptions || !vm.templateSelectedOptions.quote_id){
        vm.templateValidationError = true;
        isValid = false;
      }
      
      if(isValid){
        createQuoteRedirection(event);
      }
    }

    function createQuoteRedirection(event){
      if(!vm.mode || !isModeSelectable(vm.mode)){
        vm.modeValidation=true;
        return
      }
      $mdDialog.hide();
      
      if(vm.isEfpDomain && vm.templateSelectedOptions.quote_id){
        var quoteDataCache;
        QuotesService.getEfpQuoteDetails(vm.templateSelectedOptions.quote_id)
          .then(function(response){
            quoteDataCache = response.data.data;
            return $http.get('app/data/efp-search/search.json');
          })
          .then(function(searchResponse){
            var searchParam = angular.copy(searchResponse.data.data);
            var firstCard = quoteDataCache.rateOptions && quoteDataCache.rateOptions[0];
            
            searchParam.mode = quoteDataCache.mode;
            searchParam.load = quoteDataCache.load;
            searchParam.cargoType = quoteDataCache.cargoType;
            searchParam.metaOrigin = firstCard && firstCard.meta ? firstCard.meta.metaOrigin : null;
            searchParam.metaDestination = firstCard && firstCard.meta ? firstCard.meta.metaDestination : null;
            searchParam.searchCurrency = firstCard.pricingLevels[0].priceTotal[quoteDataCache.mode.toLowerCase()].currency;
            quoteDataCache.createdFromTemplate = {
              name: quoteDataCache.templateDetails.name,
              quoteId: quoteDataCache._id,
              quoteNumber: quoteDataCache.quoteNumber
            }
            quoteDataCache.type = "QUOTE"
            quoteDataCache.quoteNumber = ""
            quoteDataCache._id = ""
            
            var eventData = {
              data: {
                source: 'one-quote',
                from: 'quote-template',
                pageSource: 'quote-template',
                selectedCard: quoteDataCache.rateOptions,
                currencyConversion: quoteDataCache.currencyConversionRates,
                searchParam: searchParam,
                quoteData: quoteDataCache
              }
            };
            util.redirectToOneQuote(eventData);
          })
          .catch(function(error){
            console.log(error);
            util.showToast("Error loading quote template");
          });
      } else {
        $timeout(function () {
          util.showToast("Please wait while we redirect you to the create quote page you requested")
          if (vm.templateSelectedOptions.quote_id){
            $state.go("app.CreateQuotesController", {
              mode: vm.mode,
              id: vm.templateSelectedOptions.quote_id
            });
          }
          else{
            $state.go("app.CreateQuotesController", {
              mode: vm.mode,
              id: null
            });
          }
        }, 500);
      }
    }

    function getListBySearch(event){
      vm.templateFilterLoader =true;
      vm.templateQueryParam.query = event; 
       vm.getTemplateList();
    }

    function trackEvent(event,data){
      util.callMixpanel(event,{
        "optionValue":data
      });
    }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('addNewRate', {
      templateUrl: 'app/main/quotes/dialogs/add-new-rate/add-new-rate.html',
      bindings: {
          searchParam : '=',
          pageInfo:'=',
          resultCardFilter : '=',
          cardData : '=',
          pageSource : '=',
          inquiryPricing : '=',
          fromInquiry : '=',
          footerObj : '=',
          sourceRate:'=',
          isAddNewRateLoaded:'=',
          allInQuote : '=',
          co2eResponse : '=',
          callback : '&'
      },
      controller: AddNewRateController
    });


  function AddNewRateController($sanitize, $log,$rootScope, resultService, SearchService, shareQuoteService, $mdToast, util, $timeout, localStorageService, $filter, $mdDialog, QuotesService, api, basisCalculation,constObj) {

      var vm = this;
      vm.util = util;
      vm.constObj = constObj;

      vm.quoteEdit = true;
      vm.editBuyRate = true;
      vm.shareQuoteService = shareQuoteService;
      vm.isWebView = util.isWebView();
      vm.isShared = util.isSharedQuote();
      vm.termsConditionCkEditorConfig = angular.copy(util.ckEditorConfig);
      vm.termsConditionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
      vm.getSubvendor = [];
      vm.getAirline = [];
      vm.commodityArray = [];
      vm.todaysDate = new Date();
      // validation 
      vm.validationObj={
        "expiryValidation":false,
        "sailingValidation":false,
        "startDateValidation": false,
        "departureTimeValidation":false,
        "arrivalTimeValidation":false,
        "originPortValidation":false,
        "linerValidation":false,
        "airlinerValidation":false,
        "emptyPickupValidation": false,
        "emptyDropValidation": false,
        "originDoorValidation":false,
        "destinationDoorValidation":false,
        "destinationPortValidation":false,
        "polValidation":false,
        "podValidation":false,
        "chargeNameValidation":false,
        "chargeBasicValidation":false,
        "chargeUnitValidation":false,
        "chargeContainerValidation":false,
        "chargeCurrencyValidation":false,
      };
      vm.errorTextObj = {
        "emptyPickupErrorText": "",
        "emptyDropErrorText":"",
        "originDoorErrorText" : "",
        "destinationDoorErrorText" : "",
        "originPortErrorText" : "",
        "destinationPortErrorText" : "",
        "polErrorText" : "",
        "podErrorText" : "",
      };
      vm.serviceModeList = [
        {
          "code": "SD",
          "name": "SD"
        },
        {
          "code": "CY",
          "name": "CY"
        }
      ];
      // // Free days
      // vm.freeDaysData = {
      //   "origin" : {
      //     "detention":null,
      //     "demurrage":null,
      //     "combinedDays":null
      //   },
      //   "destination" : {
      //     "detention":null,
      //     "demurrage":null,
      //     "combinedDays":null
      //   },
      //   "freeDaysTotal" : null,

      // };
      // free days validation
      // vm.freedaysValidationObj = {
      //   "originDemurrageValidation":false,
      //   "originDetentionValidation":false,
      //   "destinationDemurageValidation":false,
      //   "destinationDetentionValidation":false,
      //   "originCombinedValidation":false,
      //   "destinationCombinedValidation":false
      // };
      vm.via_port='';
      vm.showExchangeRates = $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;
      vm.quotePreview = util.sanitizeQueryParams(window.location.href).indexOf("quote_preview") >= 0 ? true : false;
      vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER);
      vm.isPcmsEnabled =$rootScope.domainData.domain_info.POSTALCODES_ENABLED;

      // vm.openFreeDaysPanel=false;
      vm.noteBlock = false;
      vm.loadWiseFreeDaysList = [];
      // vm.freeDaysError = false;
      vm.isFreeDaysEdit = true;
      vm.getL1Subvendor = [];
      vm.getL5Subvendor = []
      vm.transporterDetails = {};
      vm.selectedL3LinerData = {};

      // method
      vm.cancelDialog = cancelDialog;
      vm.fnTrackAnalytics = fnTrackAnalytics;
      vm.fnDisplayProfit = fnDisplayProfit;
      vm.fngetSubVendorDetails = fngetSubVendorDetails;
      vm.fngetTransporterDetails = fngetTransporterDetails;
      vm.fnGetLinerList = fnGetLinerList;
      vm.fnGetAirlineList = fnGetAirlineList;
      vm.fnCardStructure = fnCardStructure;
      vm.fnAddNewCard = fnAddNewCard;
      vm.getPort = util.getPorts;
      vm.fnDefaultCharge = fnDefaultCharge;
      vm.getChargeList = getChargeList;
      vm.changeSelectedCharge = changeSelectedCharge;
      vm.rateTabView = rateTabView;
      vm.remarksTabView = remarksTabView;
      vm.quotationTabView = quotationTabView;
      vm.scheduleTabView = scheduleTabView;
      vm.airScheduleTabView = airScheduleTabView;
      vm.termsTabView = termsTabView;
      vm.fnScheduleSubmit = fnScheduleSubmit;
      vm.conversionOnPriceChange = conversionOnPriceChange;
      vm.submitRate = submitRate;
      vm.submitCharges = submitCharges;
      vm.fnMetaValidation = fnMetaValidation;
      vm.fnChangeBasis = fnChangeBasis;
      vm.getChargeCost = getChargeCost;
      vm.checkPercentageBasis = checkPercentageBasis;
      vm.rateTotalCustomCurr = rateTotalCustomCurr;
      vm.fnSelectedPlace = fnSelectedPlace;
      // vm.openFreeDays = openFreeDays;       
      // vm.hideFreeDays = hideFreeDays; 
      // vm.closeFreeDaysPanel=closeFreeDaysPanel;
      // vm.fnFreeDaysTotal=fnFreeDaysTotal;
      vm.selectedViaPort='';
      vm.buttonType='';
      vm.fnTransporterChanged = fnTransporterChanged;
      vm.fnDateSelection = fnDateSelection;
      // vm.getDataForExchangeRate=getDataForExchangeRate;
      vm.fnGetCurrencyconversion = fnGetCurrencyconversion;
      vm.fnSetCardInput = fnSetCardInput;
      vm.fnFillCardPortData = fnFillCardPortData;
      vm.removeInfoFromCard = removeInfoFromCard;
      vm.fnGetRates = fnGetRates;
      vm.fetchRatesSubmit = fetchRatesSubmit;
      vm.fnDateUTCFormat = fnDateUTCFormat;
      vm.fbGoBack = fbGoBack;
      vm.fnDuplicatesString = fnDuplicatesString;
      vm.fnViewExchangeRate = fnViewExchangeRate;
      vm.fnCheckCo2e = fnCheckCo2e;
      vm.fnSetCo2InCard = fnSetCo2InCard;
      vm.fnGetCo2e = fnGetCo2e;
      vm.freeDaysTab = freeDaysTab;
      vm.fnSetSubVendorInit = fnSetSubVendorInit;
      vm.fnPushSubVendorToList = fnPushSubVendorToList;
      vm.isExistInList = isExistInList;
      vm.fnGetAirlineData = fnGetAirlineData;
     

      this.$onInit = function () {
        vm.authvalue = vm.isShared ? null : localStorageService.get("authToken").value;
        vm.headingText = vm.pageSource.toLowerCase().includes('new') ? 'Create New Card' : 'Update Card' ;
        if(vm.searchParam.mode !== 'AIR'){
            vm.fnGetLinerList(); // required for all l1/l5 transporter and fcl/lcl l3 subvendor
         }else if(vm.searchParam.origin_location.place_type == 'Door' || vm.searchParam.destination_location.place_type == 'Door'){
            vm.fnGetLinerList();   //l1/l5 transporter - AIR
            vm.fnGetAirlineData();  //Air l3 airline
         }else{
            vm.fnGetAirlineData();  //if not D2D - l3 airline data
         }
       
        vm.leg_mode = (vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l3_leg = 'l3_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l1_leg = 'l1_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l5_leg = 'l5_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.modeName = (vm.searchParam.mode == 'SEA-FCL') ? '_fcl' : ((vm.searchParam.mode == 'AIR') ? '_air' : '_lcl' );

        vm.searchUser = vm.searchParam.user;
        vm.screenNumber = 1;
        
        vm.fnCardStructure();
        vm.fnAddNewCard();

        vm.fclSlab = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.slab_charges ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.slab_charges : [];
        // condition to show slab tab
        if(!vm.pageSource.toLowerCase().includes('inquiry') && vm.searchParam.mode == 'AIR' && (util.isAdmin || util.isFreightbro) ){
          vm.ratesVisible = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.slab_rate ? 1 : 0;
        }else if(vm.searchParam.mode == 'SEA-FCL' && (util.isAdmin || util.isFreightbro) ){
          vm.ratesVisible = vm.fclSlab && vm.fclSlab.length ? 1 : 0;
        }else{
          vm.ratesVisible = 0;
        }
        vm.airScheduleVisible = vm.searchParam.mode == "AIR" ? 1 : 0;
        vm.scheduleVisible = vm.searchParam.mode != "AIR" ? 1 : 0;
        vm.analyticsVisible = 0;
        vm.quotationVisible = 1;
        vm.termsVisible = !vm.maskLiner && vm.addNewCard.meta.type.includes("spot") && (vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.terms_and_condition.data || vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.terms_and_condition.url) ? 1 : 0;

        vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible;
        vm.chargesTabIndex = angular.copy(vm.selectedIndex);
        // vm.fnFreeDaysTotal();
        vm.loadSlowly = false;
        $timeout(function () {
          vm.loadSlowly = true;
        },5);
      }

      function fnCardStructure() {
        // charge obj
        vm.cardChargeObj = {
          id: "0001",
          charge_id: null,
          charge_name: null,
          charge_description: null,
          charge_type: "FIXED",
          charge_basis: null,
          per_unit_rate: 0,
          total_units: 0,
          charge_cost: 0,
          charge_currency: vm.searchUser.user_base_currency,
          minimum_charge_cost: vm.searchParam.mode == 'SEA-FCL' ? 'NA' : '',
          maximum_charge_cost: vm.searchParam.mode == 'SEA-FCL' ? 'NA' : '',
          container_type: null,
          global_charge_id: "",
          customer_currency_cost: 0,
          leg_currency_cost: 0,
          tax_type: "GST",
          tax_percent: 0,
          manual: true,
          is_qty_editable: false,
          charge_category: null,
          charge_code: "",
          internal_comments:"",
          external_comments:"",
        };
        
        // leg object
        vm.cardLegData = {
          leg_name: "",
          leg_code: "",
          vendor_id: vm.isShared ? "" : (vm.authvalue.vendor_id),
          rate_obj: {
            origin_service_mode: "",
            destination_service_mode: "",
            agent_id: "",
            _id: "",
            schedule: {
              url: null,
              data: [],
            },
            analytics: {
              graph: {
                url: null,
              },
            },
            is_special: false,
            charges: [],
            manual: 1,
            airline: {
              air_line_name: "",
              airline_code: "",
              airline_prefix: "",
            },
            airline_code: null,
            slab_currency: null,
            slab: null,
            rate_type: "msr_rate",
            leg_name: "",
            leg_code: "",
            vendor_id: vm.isShared ? "" : (vm.authvalue.vendor_id),
            sub_vendor_id: "",
            service_type: null,
            via_route: null,
            transit_time: null,
            detention_details:{
              origin:[],
              destination:[]
            },
            demurrage_details:{
              origin:[],
              destination:[]
            },
            combined_details:{
              origin:[],
              destination:[]
            },
            contract_number: "",
            remarks: null,
            inclusions: null,
            start_date: null,
            expiry: null,
            sailing_date:null,
            departure_time:null,
            arrival_time : null,
            // frequency : null,
            // rate_id: null,
            other_charges: null,
            if_applicable_charges: null,
            load_stat: null,
            global_leg_id: "",
            leg_total_cost: 0,
            leg_total_currency: vm.searchUser.user_base_currency,
            leg_currency_cost: 0,
            leg_currency: vm.searchUser.user_base_currency,
            vendor: {
              vendor_name: vm.isShared ? "" : vm.authvalue.vendor_name,
            },
            sub_vendor: {
              sub_vendor_name: "",
              carrier_code: "",
              logo: null,
              sv_id: 0
            },
            ltl_load_details: null,
            commodity_data: [],
            cargo_type_data: null,
          },
        };
  
        vm.is_nearbyOrigin_icd = 0;
        vm.is_nearbyDestination_icd = 0;
        for (var i = 0; i < vm.searchParam.nearby_ports.length; i++) {
          if (vm.searchParam.nearby_ports[i].is_icd_port) {
            vm.is_nearbyOrigin_icd = 1;
            break;
          }
        }
  
        for (var j = 0; j < vm.searchParam.nearby_ports_destination.length; j++) {
          if (vm.searchParam.nearby_ports_destination[j].is_icd_port) {
            vm.is_nearbyDestination_icd = 1;
            break;
          }
        }
        
        // new card structure
        vm.addNewCardInit = {
          data: {
            sell_rates: {},
            buy_rates: {},
          },
          meta: {
            airline_code: null,
            card_total_cost: 0,
            delta_percent: null,
            haulage: "",
            destination_haulage: "",
            pickup_transport_mode:"",
            delivery_transport_mode:"",
            pickup_sub_vendor:"",
            pickup_service: "",
            delivery_sub_vendor:"",
            delivery_service:"",
            haulage_available: false,
            inclusions: null,
            is_selected: false,
            network_id: null,
            port_data: {
              delivery_country_name : null,
              delivery_pincode_ui : null,
              delivery_location : null,

              destination_city : null,
              destination_port_code : null,
              destination_portname : null,
              destination_region : null,
              destination_state : null,
              is_icd_port_destination : 0,

              is_icd_port_origin : 0,
              origin_city : null,
              origin_port_code : null,
              origin_portname : null,
              origin_region : null,
              origin_state : null,

              pickup_country_name : null,
              pickup_pincode_ui : null,
              pickup_location : null,
            },
            remarks: null,
            selected_schedule: null,
            type: "msr_rates",
            vendor_id: vm.isShared ? "" : parseInt(vm.authvalue.vendor_id),
            via_pod: null,
            via_pol: null,
            ltl_load_details: null,
          },
          schedule: [],
          sub_vendor: "",
          airline: "",
          _id: "",
        };
        
      }

      function fnFillCardPortData(){
        vm.cardPickupId = "";
        vm.cardOriginId = "";
        vm.cardPolId = "";
        vm.cardPodId = "";
        vm.cardDestinationId = "";
        vm.cardDeliveryId = "";
        
        if(vm.searchParam.destination_location.place_type == 'Door'){
          vm.addNewCard.meta.port_data.delivery_country_name = vm.searchParam.destination_location.country;
          vm.addNewCard.meta.port_data.delivery_pincode_ui = vm.searchParam.destination_location.pin_code_ui;
          vm.addNewCard.meta.port_data.delivery_location = vm.searchParam.destination_location.location;
          vm.cardDeliveryId = vm.searchParam.destination_location._id;
        }

        if(vm.searchParam.destination_location.place_type != 'Door'){
          vm.addNewCard.meta.port_data.destination_city = vm.searchParam.destination_location.city;
          vm.addNewCard.meta.port_data.destination_port_code = vm.searchParam.destination_location.global_port_code;
          vm.addNewCard.meta.port_data.destination_portname = vm.searchParam.destination_location.portname;
          vm.addNewCard.meta.port_data.destination_region = vm.searchParam.destination_location.region;
          vm.addNewCard.meta.port_data.destination_state = vm.searchParam.destination_location.state;
          vm.cardDestinationId = vm.searchParam.destination_location._id;
        }
        
        vm.addNewCard.meta.port_data.is_icd_port_destination = vm.searchParam.destination_location.is_icd_port ? 1 : 0;
        vm.addNewCard.meta.port_data.is_icd_port_origin = vm.searchParam.origin_location.is_icd_port ? 1 : 0;

        if(vm.searchParam.origin_location.place_type != 'Door'){
          vm.addNewCard.meta.port_data.origin_city = vm.searchParam.origin_location.city;
          vm.addNewCard.meta.port_data.origin_port_code = vm.searchParam.origin_location.global_port_code;
          vm.addNewCard.meta.port_data.origin_portname = vm.searchParam.origin_location.portname;
          vm.addNewCard.meta.port_data.origin_region = vm.searchParam.origin_location.region;
          vm.addNewCard.meta.port_data.origin_state = vm.searchParam.origin_location.state;
          vm.cardOriginId = vm.searchParam.origin_location._id;
        }

        if(vm.searchParam.origin_location.place_type == 'Door'){
          vm.addNewCard.meta.port_data.pickup_country_name = vm.searchParam.origin_location.country;
          vm.addNewCard.meta.port_data.pickup_pincode_ui = vm.searchParam.origin_location.pin_code_ui;
          vm.addNewCard.meta.port_data.pickup_location = vm.searchParam.origin_location.location;
          vm.cardPickupId = vm.searchParam.origin_location._id;
        }
      }

      function fnAddNewCard() {
        vm.addCardData = false;
        vm.card_originSearchText = null;
        vm.card_destinationSearchText = null;
        vm.card_originDoorSearchText = null;
        vm.card_destinationDoorSearchText = null;
        vm.card_originWetPortSearchText = null;
        vm.card_destinationWetSearchText = null;
        vm.card_pickupContainerSearchText = null;
        vm.card_dropContainerSearchText = null;
        vm.addNewCard = angular.copy(vm.addNewCardInit);
  
        vm.addNewCard._id ="cNew" + Math.floor(1000 + Math.random() * 9000) + "_" + (vm.searchParam.mode == "SEA-FCL" ? "fcl" : vm.searchParam.mode == "AIR" ? "air" : "lcl");
        resultService.searchLoadState = [];
        if (vm.searchParam.mode == "SEA-FCL") {
          vm.load_stat = {};
          vm.searchParam.load_data.load_details_value.forEach(function (load) {
            vm.load_stat[load.type] = 0;
            resultService.searchLoadState.push(load.type);
          });
        }

        if(!vm.cardData){
          vm.addNewCard.data.sell_rates[vm.l3_leg] = angular.copy(vm.cardLegData);
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.load_stat = vm.searchParam.mode == "SEA-FCL" ? vm.load_stat : null;
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.global_leg_id = "l3";
          vm.addNewCard.data.sell_rates[vm.l3_leg].leg_name = "Main Freight";
          vm.addNewCard.data.sell_rates[vm.l3_leg].leg_code = vm.l3_leg;
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.leg_name = "Main Freight";
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.leg_code = vm.l3_leg;
          // setting default cargo-type to FAK
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.cargo_type_data = {
            name: "FAK",
            code: "FAK",
          };
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.charges.push( angular.copy(vm.cardChargeObj) );
          vm.addNewCard.data.buy_rates = angular.copy(vm.addNewCard.data.sell_rates); //copying sell rates data to buy rates when there is no card data available for new add new rate card
          vm.fnFillCardPortData();

        }else{
          vm.noteBlock = true;
          vm.addNewCard = angular.copy(vm.cardData);

          vm.commodityArray = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.commodity_data;
          // vm.selectedViaPort = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.via_route;
          vm.selectedLiner = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id;
          vm.selectedAirline = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.airline_code;
          
           //  Storing old data into new key - Free days #DEV-10379
           if(vm.searchParam.mode != 'AIR' && !vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.freeDays){
            vm.addNewCard.data.sell_rates ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj , vm.searchParam) : null;
            vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj , vm.searchParam);
          }
          
          // if (vm.searchParam.mode == "SEA-LCL") {
          // Free days
        //   vm.freeDaysData = {
        //     "origin" : {
        //       "detention":(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.detention_details && vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.detention_details.origin.length) ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.detention_details.origin[0].free_days : null,
        //       "demurrage":(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details && vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details.origin.length) ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details.origin[0].free_days : null,
        //       "combinedDays":(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.combined_details && vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.combined_details.origin.length) ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.combined_details.origin[0].free_days : null
        //     },
        //     "destination" : {
        //       "detention":(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.detention_details && vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.detention_details.destination.length) ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.detention_details.destination[0].free_days : null,
        //       "demurrage":(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details && vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details.destination.length) ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details.destination[0].free_days : null,
        //       "combinedDays": (vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.combined_details && vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.combined_details.destination.length) ? vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.combined_details.destination[0].free_days : null,
        //     },
        //     "freeDaysTotal" : null,
        //   };
        // }
          
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.transit_time = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.transit_time ? parseInt(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.transit_time) : null;
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date ? vm.fnDateUTCFormat(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date) : null;
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.start_date = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.start_date ? vm.fnDateUTCFormat(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.start_date) : null;
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry ? vm.fnDateUTCFormat(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry) : null;
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.departure_time =  vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.departure_time ? vm.fnDateUTCFormat( vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.departure_time) : null;
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.arrival_time =  vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.arrival_time ? vm.fnDateUTCFormat(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.arrival_time) : null;

          if(vm.pageSource.toLowerCase().includes('new')){
            vm.addNewCard.meta.type = 'msr_rates';
            vm.removeInfoFromCard(vm.addNewCard.meta, vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj);
          }
          vm.fnSetSubVendorInit(vm.addNewCard);
          
        }
        
        vm.addNewCard.meta.haulage = vm.addNewCard.meta.haulage ? vm.addNewCard.meta.haulage.toLowerCase() : '';
        vm.addNewCard.meta.destination_haulage = vm.addNewCard.meta.destination_haulage ? vm.addNewCard.meta.destination_haulage.toLowerCase() : '';
        vm.addNewCard.meta["pickup_transport_mode"] = vm.addNewCard.meta.pickup_transport_mode ? vm.addNewCard.meta.pickup_transport_mode.toLowerCase() : '';
        vm.addNewCard.meta["delivery_transport_mode"] = vm.addNewCard.meta.delivery_transport_mode ? vm.addNewCard.meta.delivery_transport_mode.toLowerCase() : '';
        
        vm.fnSetCardInput();
        

          var getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(function (element) {
                                return element.vendor_id == vm.addNewCard.meta.vendor_id;
                              });
          shareQuoteService.currencyConverter = {}; //Reset currency converter setting
          if (!getCurrencyRate) {
            vm.fnGetCurrencyconversion( vm.searchUser.user_base_currency, vm.addNewCard.meta.vendor_id );
            vm.addNewCard.meta.conversionRate = vm.currencyObj;
          } else {
            vm.currency_rates = getCurrencyRate.curr_data;
            vm.addNewCard.meta.conversionRate = getCurrencyRate;
            // Currency conversion setting code
            shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency, getCurrencyRate.markup, getCurrencyRate.directCurrencyMapping, vm.currency_rates);
            vm.callingConversionApi = false;
            if(vm.searchParam.mode == "SEA-FCL" && !vm.cardData){
              vm.fnDefaultCharge();
            }
          }

          if (vm.searchParam.mode != "SEA-FCL") {
            vm.addNewCard.meta["isScheduleCall"] = true;
          }

        vm.expMaxDate = new Date();
        vm.sell_rates_display = false;
        vm.schedule_display = false;
      }

      function fnDateUTCFormat(date){
        var shortDate = $filter('date')(util.dateReplace(date), "yyyy-MM-dd");
        return util.dateReplace(new Date(shortDate).toISOString());
      }

      function fnSetCardInput(){
        // setting input model veriable 
        vm.selectedPickupContainer = vm.addNewCard.meta.port_data.empty_container_pickup ? vm.addNewCard.meta.port_data.empty_container_pickup.port_name : null;
        vm.selectedOriginDoor = vm.addNewCard.meta.port_data.pickup_location ? vm.addNewCard.meta.port_data.pickup_location : vm.addNewCard.meta.port_data.pickup_pincode_ui;
        vm.selectedOrigin = vm.addNewCard.meta.port_data.origin_port_code;
        vm.selectedPOL = vm.addNewCard.meta.via_pol;
        vm.selectedPOD = vm.addNewCard.meta.via_pod;
        vm.selectedDestination = vm.addNewCard.meta.port_data.destination_port_code;
        vm.selectedDestinationDoor = vm.addNewCard.meta.port_data.delivery_location ? vm.addNewCard.meta.port_data.delivery_location : vm.addNewCard.meta.port_data.delivery_pincode_ui ;
        vm.selectedDropContainer = vm.addNewCard.meta.port_data.empty_container_drop ? vm.addNewCard.meta.port_data.empty_container_drop.port_name : null;
        vm.selectedPickupTransporter = vm.addNewCard.meta.pickup_sub_vendor ? vm.addNewCard.meta.pickup_sub_vendor.sv_id : null;
        vm.selectedDeliveryTransporter = vm.addNewCard.meta.delivery_sub_vendor ? vm.addNewCard.meta.delivery_sub_vendor.sv_id : null;

        // setting card ICD flag
        vm.isOriginDryPort = vm.searchParam.mode != 'AIR' && (vm.searchParam.origin_location.place_type == 'Door' || vm.searchParam.origin_location.is_icd_port || vm.addNewCard.meta.via_pol) ? true : false;
        vm.isDestinationDryPort = vm.searchParam.mode != 'AIR' && (vm.searchParam.destination_location.place_type == 'Door' || vm.searchParam.destination_location.is_icd_port || vm.addNewCard.meta.via_pod) ? true : false;

      }

      // call conversion rates api
      function fnGetCurrencyconversion(user_base_currency, vendor_id){
        vm.callingConversionApi = true;
        return resultService.getCurrencyConversionForVendor(user_base_currency, vendor_id,vm.searchParam.mode,true).then(function(response){
          vm.currencyObj = response.data;
          vm.resultCardFilter.currency_conversion_rates.push(vm.currencyObj);
          vm.callingConversionApi = false;
          vm.fnDefaultCharge();
          vm.currency_rates = vm.currencyObj.curr_data;
          // Currency conversion setting code
          shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency,vm.currencyObj.markup,vm.currencyObj.directCurrencyMapping,vm.currency_rates)
        },function(error){
          // Currency conversion setting code
          shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency,null,[],vm.currency_rates);
          vm.callingConversionApi = false;
          $log.log(error.data);
          util.showToast(util.displayValidationError(error));
        });
      }

      function removeInfoFromCard(meta, rate_obj){
        rate_obj.contract_number = null;
        rate_obj.rate_type = 'msr_rates';
        meta.type = 'msr_rates';
        rate_obj.tags = [];
        rate_obj.vendor = {
          'vendor_name': vm.authvalue.vendor_name,
        };
        meta.vendor_id = parseInt(vm.authvalue.vendor_id);
        rate_obj.vendor_id = (vm.authvalue.vendor_id);
        rate_obj.agent_id = null;
        rate_obj.agent = null;
        rate_obj.price_id = null;
        rate_obj.terms_and_condition = {'url' : null};
      }

      // function fnFreeDaysTotal(){
      //   vm.freeDaysData.freeDaysTotal = null;

      //   var destinationTotal = null;
      //   var originTotal = null;

      //   // destination free days total
      //   if(vm.freeDaysData.destination.combinedDays){
      //       destinationTotal = vm.freeDaysData.destination.combinedDays;
      //   }else{
      //       destinationTotal = (vm.freeDaysData.destination.detention ? vm.freeDaysData.destination.detention : null) + (vm.freeDaysData.destination.demurrage ? vm.freeDaysData.destination.demurrage : null);
      //   }
        
      //   // origin free days total
      //   if(vm.freeDaysData.origin.combinedDays){
      //       originTotal = vm.freeDaysData.origin.combinedDays;
      //   }else{
      //       originTotal = (vm.freeDaysData.origin.detention ? vm.freeDaysData.origin.detention : null) + (vm.freeDaysData.origin.demurrage ? vm.freeDaysData.origin.demurrage : null);
      //   }

      //   vm.freeDaysData.freeDaysTotal = $rootScope.domainData.domain_info.SHOW_DEFAULT_FREE_DAYS === 'ORIGIN' ? (originTotal ? originTotal : destinationTotal)  : (destinationTotal ? destinationTotal : originTotal);
        
      // }

      // function openFreeDays(){
      //   if(!vm.freedaysValidationObj.originDemurrageValidation && !vm.freedaysValidationObj.originDetentionValidation && !vm.freedaysValidationObj.originCombinedValidation && !vm.freedaysValidationObj.destinationDemurageValidation && !vm.freedaysValidationObj.destinationDetentionValidation && !vm.freedaysValidationObj.destinationCombinedValidation)
      //   vm.openFreeDaysPanel=!vm.openFreeDaysPanel;
      // }

      // function hideFreeDays(){
      //   if(!vm.freedaysValidationObj.originDemurrageValidation && !vm.freedaysValidationObj.originDetentionValidation && !vm.freedaysValidationObj.originCombinedValidation && !vm.freedaysValidationObj.destinationDemurageValidation && !vm.freedaysValidationObj.destinationDetentionValidation && !vm.freedaysValidationObj.destinationCombinedValidation)
      //   {
      //     vm.openFreeDaysPanel = false;
      //   }
      // }

      // function closeFreeDaysPanel(ev){
      //   ev.stopPropagation();
      //   vm.openFreeDaysPanel  = false
      // }

      function fnGetLinerList(searchText , subVendorType){
        if(!searchText && (util.carrierData.data.length)){
          //  storing sub vendor details on L3
          if(vm.searchParam.mode !== 'AIR'){
            vm.getSubvendor = angular.copy(util.carrierData.data);
          }
          vm.getL1Subvendor = angular.copy(util.carrierData.data);
          vm.getL5Subvendor = angular.copy(util.carrierData.data);
          // if search text not present then resetting to initial list and pushing the existing selected item
           vm.fnPushSubVendorToList();
        }else{
          var type = 'subvendor';
          var queryData = searchText ? searchText : '';
          vm.filterLoader = true;
            resultService.getLinersData(type,queryData).then(function(response){
              // storing the API response based on subVendorType
              vm.getL1Subvendor = (!searchText || subVendorType == 'l1') ?  response.data.data : vm.getL1Subvendor;
              vm.getL5Subvendor = (!searchText || subVendorType == 'l5') ?  response.data.data : vm.getL5Subvendor;
              if(vm.searchParam.mode !== 'AIR'){
                 vm.getSubvendor = (!searchText || subVendorType == 'l3') ?  response.data.data : vm.getSubvendor;
              }
              if(!searchText){
                // updating the mode as FCL while storing sub vendor data
                util.carrierData.mode = vm.searchParam.mode === 'AIR' ? 'SEA-FCL' :vm.searchParam.mode ;
                util.carrierData.data = angular.copy(response.data.data);
              }
              vm.fnPushSubVendorToList(subVendorType);
              vm.filterLoader = false;
            },function(error){
              vm.getSubvendor = [];
              vm.filterLoader = false;
            });
        }
      }

      function fnGetAirlineList(){
        if(!util.getAirline.length){
          resultService.getAirlineData().then(function(response){
              vm.getAirline = response.data.data;
              util.getAirline = angular.copy(vm.getAirline);
          },function(error){
              vm.getAirline = [];
              util.getAirline = [];
          });
        }else{
            vm.getAirline = angular.copy(util.getAirline);
        }
      }

      // sub-ventor selection on l3 leg for all mode
      function fngetSubVendorDetails(cardMeta, rate_data) {
        if (vm.searchParam.mode == "AIR") {
          if(vm.selectedAirline == rate_data.airline.airline_code){
            return
          }
          for (var i = 0; i < vm.getSubvendor.length; i++) {
            if (vm.getSubvendor[i].code == vm.selectedAirline) {
              rate_data.airline_code = vm.selectedAirline;
              rate_data.airline.airline_code = vm.getSubvendor[i].code;
              rate_data.airline.air_line_name = vm.getSubvendor[i].name;
              rate_data.airline.airline_prefix = vm.getSubvendor[i].prefix;
              vm.addNewCard.meta.airline_code = vm.getSubvendor[i].code;
              vm.addNewCard.airline = vm.getSubvendor[i].name;
              vm.selectedL3LinerData =  vm.getSubvendor[i];
              break;
            }
          }
        } else {
          if(vm.selectedLiner == rate_data.sub_vendor_id){
            return
          }
          for (var j = 0; j < vm.getSubvendor.length; j++) {
            if (vm.getSubvendor[j].id == vm.selectedLiner) {
              rate_data.sub_vendor_id = vm.getSubvendor[j].id.toString();
              rate_data.sub_vendor.logo = vm.getSubvendor[j].logo;
              rate_data.sub_vendor.sub_vendor_name = vm.getSubvendor[j].name;
              rate_data.sub_vendor.carrier_code = vm.getSubvendor[j].code;
              rate_data.sub_vendor.sv_id = vm.getSubvendor[j].id;
              vm.addNewCard.sub_vendor = vm.getSubvendor[j].name;
              vm.selectedL3LinerData =  vm.getSubvendor[i];
              break;
            }
          }
        }
        cardMeta.selected_schedule = null;
        cardMeta.multi_schedule_list = [];
        rate_data.schedule.data = [];
        vm.schedule_display = false;
        vm.removeInfoFromCard(cardMeta,rate_data);
      }

      // selection of pickup / delivery transported 
      function fngetTransporterDetails(cardMeta, selectedItem, objectName , subVendorDetails){
        
        // if selected transporter and previous transporter is same then return
        if(cardMeta[objectName] && cardMeta[objectName].sv_id == selectedItem){
          return;
        }

        var matchedObj = null;
        for (var j = 0; j < subVendorDetails.length; j++) {
          if (subVendorDetails[j].id == selectedItem) {
            matchedObj = {
              "logo" : subVendorDetails[j].logo,
              "sub_vendor_name" : subVendorDetails[j].name,
              "carrier_code" : subVendorDetails[j].code,
              "sv_id" : subVendorDetails[j].id
            };
            vm.transporterDetails[objectName] = subVendorDetails[j];
            break;
          }
        }
        cardMeta[objectName] = matchedObj;
      }

      function fnTransporterChanged(transport, leg){
        
        if(vm.addNewCard.data.sell_rates[leg] && vm.addNewCard.data.sell_rates[leg].rate_obj){
          vm.addNewCard.data.sell_rates[leg].rate_obj.transport_mode = transport;
          vm.addNewCard.data.buy_rates[leg].rate_obj.transport_mode = transport;
        }
      }
      
      function fnDateSelection(value, action){
        vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj[action] = value;
        vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj[action] = value;
        var eventName = '';
        if(action == 'sailing_date'){
          vm.validationObj.sailingValidation = false;
          eventName = 'SailingDate';
        } else if (action == 'start_date') {
          vm.validationObj.startDateValidation = false;
          eventName = 'StartDate';
        }
        else if(action == 'expiry'){
          eventName = 'ExpiryDate';
          vm.validationObj.expiryValidation = false;

          // removing load wise expiry when changing the expiry
          if(vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj['detailed_effective_load'] || vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj['detailed_effective_load']){
            vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj['detailed_effective_load'] = {};
            vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj['detailed_effective_load'] = {};
          }
        }
      }
      

      function fnSelectedPlace(event, action){
        if(action == 'Pickup_container' && event){
          vm.addNewCard.meta.port_data.empty_container_pickup.port_name =(event.place_type == 'Door')? event.location : event.portname;
          vm.addNewCard.meta.port_data.empty_container_pickup.port_code =(event.place_type == 'Door')? null: event.global_port_code;
          vm.validationObj.emptyPickupValidation = false;
        }
        else if(action == 'origin_door'){
          vm.addNewCard.meta.port_data.pickup_country_name = event ? event.country : null;
          vm.addNewCard.meta.port_data.pickup_location = event ? event.location : null;
          vm.addNewCard.meta.port_data.pickup_pincode_ui = event ? event.pin_code_ui : null;
          vm.cardPickupId = event ? event._id : "";
          vm.validationObj.originDoorValidation = false;

          if(event && event.place_type != 'Door'){
            vm.validationObj.originDoorValidation = true;
            vm.errorTextObj.originDoorErrorText = 'Enter Valid Pickup Door';
          }
        }
        else if(action == 'origin'){
          vm.addNewCard.meta.port_data.is_icd_port_origin = event ? event.is_icd_port : null;
          vm.addNewCard.meta.port_data.origin_city = event ? event.city : null;
          vm.addNewCard.meta.port_data.origin_port_code = event ? event.global_port_code : null;
          vm.addNewCard.meta.port_data.origin_portname = event ? event.portname : null;
          vm.addNewCard.meta.port_data.origin_region = event ? event.region : null;
          vm.addNewCard.meta.port_data.origin_state = event ? event.state : null;
          vm.cardOriginId = event ? event._id : "";
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.meta_origin_port = event ? event.global_port_code : null;

          if(vm.errorTextObj.destinationPortErrorText && vm.errorTextObj.destinationPortErrorText.toLowerCase().includes('origin')){
            vm.validationObj.destinationPortValidation = false;
          }

          if(vm.errorTextObj.podErrorText && vm.errorTextObj.podErrorText.toLowerCase().includes('origin')){
            vm.validationObj.podValidation = false;
          }
          
          if(vm.searchParam.origin_location.place_type == 'Door' || vm.searchParam.origin_location.is_icd_port){
            vm.validationObj.originPortValidation = false;
          }else{
            vm.validationObj.polValidation = false;
          }
        }
        else if(action == 'destination'){
          vm.addNewCard.meta.port_data.is_icd_port_destination = event ? event.is_icd_port : null;
          vm.addNewCard.meta.port_data.destination_city = event ? event.city : null;
          vm.addNewCard.meta.port_data.destination_port_code = event ? event.global_port_code : null;
          vm.addNewCard.meta.port_data.destination_portname = event ? event.portname : null;
          vm.addNewCard.meta.port_data.destination_region = event ? event.region : null;
          vm.addNewCard.meta.port_data.destination_state = event ? event.state : null;
          vm.cardDestinationId = event ? event._id : "";
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.meta_destination_port = event ? event.global_port_code : null;
          if(vm.searchParam.destination_location.place_type == 'Door' || vm.searchParam.destination_location.is_icd_port){
            vm.validationObj.destinationPortValidation = false;
          }else{
            vm.validationObj.podValidation = false;
          }
        }
        else if(action == 'destination_door'){
          vm.addNewCard.meta.port_data.delivery_country_name = event ? event.country : null;
          vm.addNewCard.meta.port_data.delivery_location = event ? event.location : null;
          vm.addNewCard.meta.port_data.delivery_pincode_ui = event ? event.pin_code_ui : null;
          vm.cardDeliveryId = event ? event._id : "";
          vm.validationObj.destinationDoorValidation = false;
          if(event && event.place_type != 'Door'){
            vm.validationObj.destinationDoorValidation = true;
            vm.errorTextObj.destinationDoorErrorText = 'Enter Valid Delivery Door';
          }
        }
        else if(action == 'pol'){
          vm.addNewCard.meta.via_pol = event ? event.global_port_code : null;
          vm.cardPolId = event ? event._id : "";
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.via_pol = event ? event.global_port_code : null;
          vm.validationObj.polValidation = false;
          if(vm.errorTextObj.destinationPortErrorText && vm.errorTextObj.destinationPortErrorText.toLowerCase().includes('pol')){
            vm.validationObj.destinationPortValidation = false;
          }
          if(vm.errorTextObj.podErrorText && vm.errorTextObj.podErrorText.toLowerCase().includes('pol')){
            vm.validationObj.podValidation = false;
          }
        }
        else if(action == 'pod'){
          vm.addNewCard.meta.via_pod = event ? event.global_port_code : null;
          vm.cardPodId = event ? event._id : "";
          vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.via_pod = event ? event.global_port_code : null;
          vm.validationObj.podValidation = false;
        }
        // else if(action == 'via_port'){
        //   vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.via_route = event ? event.global_port_code : null;
        // }
        else if(action == 'drop_container'){
          vm.addNewCard.meta.port_data.empty_container_drop.port_name =(event.place_type == 'Door')? event.location : event.portname;
          vm.addNewCard.meta.port_data.empty_container_drop.port_code =(event.place_type == 'Door')? null: event.global_port_code;
          vm.validationObj.emptyDropValidation = false;
        }

        vm.addNewCard.meta.selected_schedule = null;
        vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data = [];
        vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = [];
      }

      function fnDisplayProfit(){
        vm.footerObj.buyTotalWithConv = 0;
        vm.footerObj.buyTotalBaseCurr = vm.rateTotalCustomCurr(vm.addNewCard.data.buy_rates);
        vm.footerObj.sellTotalBaseCurr = vm.rateTotalCustomCurr(vm.addNewCard.data.sell_rates);
        // Add Convenience fee if present
        if(vm.addNewCard.meta.additional_charges && vm.addNewCard.meta.additional_charges.data){
          vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr + parseFloat(vm.addNewCard.meta.additional_charges.data.leg_total_cost);
        }else{
          vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr;
        }
        vm.footerObj.profit = util.getProfitValue(vm.footerObj.sellTotalBaseCurr, vm.footerObj.buyTotalWithConv);
      }

       // get card leg user base currency total
       function rateTotalCustomCurr (cards) {
        var convertTotal = 0;
        angular.forEach(cards, function (value) {
            if (value.rate_obj) {
            convertTotal += parseFloat(value.rate_obj.leg_total_cost);
            }
        });

        if($rootScope &&$rootScope.precision_decimals){
          convertTotal = $filter('number')(convertTotal, $rootScope.precision_decimals);
          }else{
            convertTotal = $filter('number')(convertTotal, 2);
          }        convertTotal = Number(convertTotal.split(',').join(''));
        return convertTotal;
      }

      // close popup
      function cancelDialog () {
        vm.isAddNewRateLoaded=false;
        
        vm.addNewCard.meta.remarks = util.encodeValue(vm.addNewCard.meta.remarks);
        vm.addNewCard.meta.inclusions = util.encodeValue(vm.addNewCard.meta.inclusions);
        vm.addNewCard.meta.internal_remarks = util.encodeValue(vm.addNewCard.meta.internal_remarks);
        $mdDialog.hide();
      }

      function fnDefaultCharge() {
        vm.getChargeList("Ocean Freight", vm.l3_leg, vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0]).then(
          function (response) {
            vm.changeSelectedCharge(response[0], vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0], vm.addNewCard.data.sell_rates[vm.l3_leg], 0, vm.l3_leg);
            vm.addNewCard.meta["isScheduleCall"] = true;
            vm.addCardData = true;
          },
          function (error) {
            vm.currencyList = [];
            vm.addCardData = true;
            $log.log(error);
          }
        );
      }
      
      //get charge name suggestion list
      function getChargeList(searchText, leg_code, chargeObj) {
        return shareQuoteService.getChargeList(searchText, leg_code, chargeObj, vm.searchParam);
      }

       //charge autocomplete object
      function changeSelectedCharge( selectedName, charge, legValue, index, legKey ) {
        if (selectedName && !!selectedName.source) {
          charge["source"] = selectedName.source;
          charge["source_data"] = selectedName.source_data;
        }

        if (vm.searchParam.mode === "SEA-FCL") {
          if (selectedName != null) {
            charge.charge_name = selectedName.charge_name;
            charge.charge_id = selectedName.charge_id;
            charge.global_charge_id = selectedName.global_charge_id;
            charge.container_type = selectedName.container_type;
            charge.charge_basis = selectedName.charge_basis;
            charge.total_units = 0;
            charge.per_unit_rate = selectedName.per_unit_rate ? selectedName.per_unit_rate : 0;
            charge.charge_currency = selectedName.charge_currency ? selectedName.charge_currency : legValue.rate_obj.leg_currency;
            charge.charge_category = selectedName.charge_category;
            charge.charge_code = selectedName.charge_code;
          } else {
            charge.charge_id = "";
            charge.global_charge_id = "";
          }
        } else {
          if (selectedName.charge_category) {
            charge.charge_category = selectedName.charge_category;
          }
          shareQuoteService.changeSelectedCharge(selectedName, charge, legValue, index ,legKey);
        }

        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].charge_name = angular.copy(charge.charge_name);
        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].charge_id = angular.copy(charge.charge_id);
        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].global_charge_id = angular.copy(charge.global_charge_id);
        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].container_type = angular.copy(charge.container_type);
        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].charge_basis = angular.copy(charge.charge_basis);
        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].total_units = angular.copy(charge.total_units);
        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].charge_category = angular.copy(charge.charge_category);
        vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].charge_code = angular.copy(charge.charge_code);

        if (vm.editBuyRate) {
          vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].per_unit_rate = angular.copy(charge.per_unit_rate);
          vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index].charge_currency = angular.copy(charge.charge_currency);
        }

        if (vm.searchParam.mode === "SEA-FCL") {
          vm.fnChangeBasis( charge, legValue, index, vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index], vm.addNewCard.data.buy_rates[legKey] ,'charge',legKey);
        } else {
          vm.conversionOnPriceChange(charge, legValue);
          if (vm.editBuyRate) {
            vm.conversionOnPriceChange( vm.addNewCard.data.buy_rates[legKey].rate_obj.charges[index], vm.addNewCard.data.buy_rates[legKey].rate_obj);
          }
        }
      }

      // set qty on basis change
      function fnChangeBasis(chargeObj, sellRate, charge_index, buyCharge, buyLeg, param,legKey) {
        // vm.fnCheckOverlay(); // hide overlay if available
        if (!chargeObj.charge_basis) {
            chargeObj.total_units = 0;
            chargeObj.charge_cost = 0;
            vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj);
            if(vm.editBuyRate){
              vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj);
            }
            return true;
        }
        if(vm.searchParam.mode === 'SEA-FCL' && chargeObj.charge_name){
          resultService.checkExistingCharge(chargeObj,charge_index,sellRate.rate_obj.charges,legKey); //it's checking duplicate charge present or not.
        }
        
        if(param != 'quantity'){
          shareQuoteService.fnGetFclTotalUnits(chargeObj, vm.searchParam.load_data.load_details_value);
        }

        if (chargeObj.total_units == 0) {
            chargeObj.charge_cost = 0;
            chargeObj.leg_currency_cost = 0;
        } else {
            vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj)
        }

        // copying buy charge basis and total_units value
        buyCharge.charge_basis = angular.copy(chargeObj.charge_basis);
        buyCharge.total_units = angular.copy(chargeObj.total_units);
        buyCharge.container_type = angular.copy(chargeObj.container_type);
        buyCharge.is_qty_editable = angular.copy(chargeObj.is_qty_editable);

        if(vm.editBuyRate && buyCharge.total_units && !isNaN(buyCharge.per_unit_rate) ) {
          vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj);
        }
      }

      //cost convertion if charge cost or currency change
      function conversionOnPriceChange(charge, sellRates) {
        vm.footerObj.doneBtnDisable = true;

        if (vm.searchParam.mode !== "SEA-FCL" ||
          (vm.searchParam.mode === "SEA-FCL" &&
            (charge.charge_basis === shareQuoteService.pickupBasisName ||
              charge.charge_basis === shareQuoteService.deliveryBasisName ||
              charge.charge_basis === shareQuoteService.freightBasisName))
        ) {
          vm.getChargeCost(sellRates, charge);
        } else {
          shareQuoteService.getFclCharge(sellRates, charge, vm.searchUser.user_base_currency);
        }

        vm.fnDisplayProfit();

        $timeout(function () {
          vm.footerObj.doneBtnDisable = false;
        }, 200);
      }

      function getChargeCost(leg_data, charge_data){
        shareQuoteService.getChargeCost(leg_data, charge_data, vm.searchUser.user_base_currency);

        if(charge_data.global_charge_id && charge_data.total_units != null){
          var checkCharge = false;
          if( basisCalculation.isParent(charge_data)){
            vm.currentCard.meta["AirFreight"] = charge_data;
            checkCharge = true;
          }
          // else if( charge_data.global_charge_id.indexOf(shareQuoteService.pickupChargeId) >= 0){
          //   vm.currentCard.meta["pickupCharge"] = charge_data;
          //   checkCharge = true;
          // }else if( charge_data.global_charge_id.indexOf(shareQuoteService.deliveryChargeId) >= 0){
          //   vm.currentCard.meta["deliveryCharge"] = charge_data;
          //   checkCharge = true;
          // }else if( charge_data.global_charge_id.indexOf(shareQuoteService.freightChargeId) >= 0){
          //   vm.currentCard.meta["freightCharge"] = charge_data;
          //   checkCharge = true;
          // }

          if(checkCharge){
            vm.checkPercentageBasis(leg_data, charge_data);
          }
        }
      }

      function checkPercentageBasis(legs, charge_data){
        if(shareQuoteService.isQuoteOrNewcard == 'newCard'){
          fnChargeLoop(legs);
        } else{
          angular.forEach(vm.currentCard.data.sell_rates,function(value, key){
            if(value.rate_obj){
              fnChargeLoop(value.rate_obj);
            }
          });
        }

        function fnChargeLoop(legRateObj){
          angular.forEach(legRateObj.charges,function(childValue){
            if( childValue.charge_basis === constObj.AIR_FREIGHT_BASIS ){
              childValue.total_units = (charge_data != null) ? charge_data.leg_currency_cost : null;
              shareQuoteService.getChargeCost(legRateObj, childValue, vm.searchUser.user_base_currency);
            }
          });
        }
      }
      function rateTabView() {
        vm.viewActiveTab = 'rates';
        vm.rateDetails = vm.addNewCard.data.sell_rates;
      }

      function remarksTabView() {
        // vm.fnTrackAnalytics('RateCard-Remarks-And-Inclusions-Click');
        vm.isOwnVendorRate = util.isOwnVendorRate(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.vendor_id);
        vm.hideInternalRemarks =  !vm.isOwnVendorRate || util.isSharedQuote() || util.isSharedPage() ;
        vm.viewActiveTab = "remarksInclusion";
      }

      function quotationTabView() {
        vm.viewActiveTab = "quotation";
      }

      function scheduleTabView() {
        vm.getSchedule = false;
        vm.currentSchedule = null;
        vm.viewActiveTab = "schedule";
        $timeout(function () {
          vm.getSchedule = true;
        }, 200);
      }

      function airScheduleTabView(){
        vm.getSchedule = true;
        vm.currentSchedule = null;
        vm.viewActiveTab = 'airline schedule';
      }

      function termsTabView(){
        vm.viewActiveTab = 'Terms';
        vm.termsShimmer = true;
        if(!vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data && vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.url){
            return resultService.getCardTerms(vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.url).then(function (response) {
                vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
                vm.termsData = vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
                vm.termsShimmer = false;
            }, function (error) {
                vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data = null;
                vm.termsData = null;
                vm.termsShimmer = false;
                $log.log(error);
            });
        }else{
            vm.termsData = vm.addNewCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
            vm.termsShimmer = false;
        }

      }

      // schedule selected for rate
      function fnScheduleSubmit (scheduleObj,newRateForm) {
        vm.addNewCard.meta.selected_schedule = scheduleObj;
        vm.addNewCard.meta.isScheduleCall = true;
        vm.addNewCard.meta["transit_time"] = vm.addNewCard.meta.selected_schedule.transit_time ;

        vm.submitRate(vm.addNewCard,newRateForm);
      }

      function fnMetaValidation(newRateForm){
        var isError = 0;

        // Removing time from Expiry , Sailing and start date 
        var temp_expiry = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry ? $filter('date')(util.dateReplace(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry), "yyyy-MM-dd")  : null;
        var temp_sailing = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date ? $filter('date')(util.dateReplace(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date), "yyyy-MM-dd") : null;
        var temp_start = vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.start_date ?$filter('date')(util.dateReplace(vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.start_date), "yyyy-MM-dd")  : null;

        // empty pickup 
        if(vm.validationObj.emptyPickupValidation){
          isError++;
        }else if(!vm.selectedPickupContainer && vm.card_pickupContainerSearchText){
          vm.validationObj.emptyPickupValidation = true;
          vm.errorTextObj.emptyPickupErrorText = 'Enter Valid Empty Container Pickup';
          isError++;
        }

        // Pickup
        if(vm.validationObj.originDoorValidation){
          isError++;
        }else if(vm.searchParam.origin_location.place_type == 'Door' && !(vm.addNewCard.meta.port_data.pickup_location || vm.addNewCard.meta.port_data.pickup_pincode_ui)){
          vm.validationObj.originDoorValidation = true;
          vm.errorTextObj.originDoorErrorText = 'Enter Pickup Door';
          isError++;
        }

        // Place of Reciept
        if(!vm.addNewCard.meta.port_data.origin_port_code){
          vm.validationObj.originPortValidation = true;
          vm.errorTextObj.originPortErrorText = vm.isOriginDryPort ? 'Enter Port of Origin' : 'Enter Port of Loading';
          isError++;
        }

        // Final Destination 
        if(!vm.addNewCard.meta.port_data.destination_port_code){
          vm.validationObj.destinationPortValidation = true;
          vm.errorTextObj.destinationPortErrorText = vm.isDestinationDryPort ? 'Enter Port of Destination' : 'Enter Port of Discharge';
          isError++;
        }

        // pol
        if(!vm.isOriginDryPort && !vm.addNewCard.meta.port_data.origin_port_code){
          vm.validationObj.polValidation = true;
          vm.errorTextObj.polErrorText = 'Enter Port of Loading';
          isError++;
        }

        if(vm.card_originWetPortSearchText && !vm.addNewCard.meta.via_pol){
          vm.validationObj.polValidation = true;
          vm.errorTextObj.polErrorText = 'Enter Port of Loading';
          isError++;
        }

        // pod
        if(!vm.isDestinationDryPort && !vm.addNewCard.meta.port_data.destination_port_code){
          vm.validationObj.podValidation = true;
          vm.errorTextObj.podErrorText = 'Enter Port of Discharge';
          isError++;
        }

        if(vm.card_destinationWetSearchText && !vm.addNewCard.meta.via_pod){
          vm.validationObj.podValidation = true;
          vm.errorTextObj.podErrorText = 'Enter Port of Discharge';
          isError++;
        }
        
        // Delivery
        if(vm.validationObj.destinationDoorValidation){
          isError++;
        }else if(vm.searchParam.destination_location.place_type == 'Door' && !(vm.addNewCard.meta.port_data.delivery_location || vm.addNewCard.meta.port_data.delivery_pincode_ui)){
          vm.validationObj.destinationDoorValidation = true;
          vm.errorTextObj.destinationDoorErrorText = 'Enter Delivery Door';
          isError++;
        }

        // empty drop
        if(vm.validationObj.emptyDropValidation){
          isError++;
        }else if(!vm.selectedDropContainer && vm.card_dropContainerSearchText){
          vm.validationObj.emptyDropValidation = true;
          vm.errorTextObj.emptyDropErrorText = 'Enter Valid Empty Container Drop';
          isError++;
        }

        // pickup & delivery can not same
        var pickup_location = vm.addNewCard.meta.port_data.pickup_location ? vm.addNewCard.meta.port_data.pickup_location : vm.addNewCard.meta.port_data.pickup_pincode_ui;
        var delivery_location = vm.addNewCard.meta.port_data.delivery_location ? vm.addNewCard.meta.port_data.delivery_location : vm.addNewCard.meta.port_data.delivery_pincode_ui;
        if(pickup_location && delivery_location && angular.equals(pickup_location, delivery_location) ){
          vm.validationObj.destinationDoorValidation = true;
          vm.errorTextObj.destinationDoorErrorText = 'Pickup & Delivery Location can not be same.';
          isError++;
        }

        // origin & destination can not same
        if(vm.addNewCard.meta.port_data.origin_port_code && vm.addNewCard.meta.port_data.destination_port_code && angular.equals(vm.addNewCard.meta.port_data.origin_port_code, vm.addNewCard.meta.port_data.destination_port_code)){
          var origintext = vm.isOriginDryPort ? 'Origin ' : 'POL ';
          var destinationtext = vm.isDestinationDryPort ? 'Destination ' : 'POD ';
          vm.validationObj.destinationPortValidation = true;
          vm.errorTextObj.destinationPortErrorText = origintext +' and ' + destinationtext + ' can not be same.';
          isError++;
         
        }

        if(vm.addNewCard.meta.via_pol && vm.addNewCard.meta.port_data.destination_port_code && angular.equals(vm.addNewCard.meta.via_pol, vm.addNewCard.meta.port_data.destination_port_code)){
          var destinationtext = vm.isDestinationDryPort ? 'Destination ' : 'POD '
          vm.validationObj.destinationPortValidation = true;
          vm.errorTextObj.destinationPortErrorText = 'POL and '+ destinationtext +' can not be same.';
          isError++;
          
        }

        // pol and pod can not same
        if(vm.addNewCard.meta.via_pol && vm.addNewCard.meta.via_pod && angular.equals(vm.addNewCard.meta.via_pol, vm.addNewCard.meta.via_pod)){
            vm.validationObj.podValidation = true;
            vm.errorTextObj.podErrorText = 'POL and POD can not be same.';
            isError++;
        }

        if(vm.addNewCard.meta.port_data.origin_port_code && vm.addNewCard.meta.via_pod && angular.equals(vm.addNewCard.meta.port_data.origin_port_code, vm.addNewCard.meta.via_pod)){
          var origintext = vm.isOriginDryPort ? 'Origin ' : 'POL '
          vm.validationObj.podValidation = true;
          vm.errorTextObj.podErrorText = origintext +' and POD can not be same.';
          isError++;
        }

        // Empty Container Pickup and Drop can not same
        if(vm.addNewCard.meta.port_data.empty_container_pickup && vm.addNewCard.meta.port_data.empty_container_drop && angular.equals(vm.addNewCard.meta.port_data.empty_container_pickup, vm.addNewCard.meta.port_data.empty_container_drop)){
          vm.validationObj.emptyDropValidation = true;
          vm.errorTextObj.emptyDropErrorText = 'Empty Container Pickup and Empty Container Drop can not be same.';
          isError++;
        }
        
        // Expiry Date
         if(!vm.addNewCard.meta.type.includes('spot') && !vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry){
          vm.validationObj.expiryValidation = true;
          isError++;
        }
        if((temp_expiry && temp_start) && (temp_expiry < temp_start)){
          vm.validationObj.expiryValidation = true;
          isError++; 
        }

        //  sailing date
       if((temp_sailing && temp_start) && (temp_sailing < temp_start)){
            vm.validationObj.sailingValidation = true;
            isError++; 
        }
       // start date
        if((temp_expiry && temp_start) && (temp_start > temp_expiry)){
            vm.validationObj.startDateValidation = true;
            isError++; 
         }
        
        if(vm.searchParam.mode != 'AIR'){

          // Liner / Carrier
          if(!vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id){
            vm.validationObj.linerValidation = true;
            isError++;
          }
          
          // Free days
          // if(vm.freedaysValidationObj.originDemurrageValidation || vm.freedaysValidationObj.originDetentionValidation || vm.freedaysValidationObj.originCombinedValidation || vm.freedaysValidationObj.destinationDemurageValidation || vm.freedaysValidationObj.destinationDetentionValidation || vm.freedaysValidationObj.destinationCombinedValidation ){
          //   isError++;
          // }

          // Sailing Date
          // if(!vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date){
          //   vm.validationObj.sailingValidation = true;
          //   isError++;
          // }

           // Date validation for Non mandatory fields
          if(newRateForm.start_date.$error.valid || newRateForm.sailing_date.$error.valid || newRateForm.expiry.$error.valid){
            isError++; 
          }
         

        }else{
          // Airline
          if(!vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.airline || !vm.addNewCard.data.sell_rates[vm.l3_leg].rate_obj.airline["airline_code"]){
            vm.validationObj.airlinerValidation = true;
            isError++;
          }

           // Date validation for Non mandatory fields
          if( newRateForm.departure_time.$error.valid || newRateForm.arrival_time.$error.valid){
            isError++; 
          }

        }
      
        return isError;
      }

      function submitRate(currentCard,newRateForm){
        var mixpanelCard = angular.copy(currentCard);
        delete mixpanelCard.meta.conversionRate;
        var legArray = Object.keys(currentCard.data.buy_rates);
        angular.forEach(legArray,function(leg){
          if( mixpanelCard.data.buy_rates[leg].rate_obj){
            mixpanelCard.data.buy_rates[leg].rate_obj = currentCard.data.buy_rates[leg].rate_obj.charges
          }
        })
        var legArray = Object.keys(currentCard.data.sell_rates);
        angular.forEach(legArray,function(leg){
          if( mixpanelCard.data.sell_rates[leg].rate_obj){
            mixpanelCard.data.sell_rates[leg].rate_obj = currentCard.data.sell_rates[leg].rate_obj.charges
          }
        })
        // Empty batch code to when liner is change to avoid source rate visibility
        if(Object.keys(currentCard.data.sell_rates).length ==1 && !currentCard.data.sell_rates[Object.keys(currentCard.data.sell_rates)[0]].rate_obj.charges.length){
          util.showToast("Add a leg and its corresponding charges to continue");
          return;
        }
        // Empty batch code to when liner is change to avoid source rate visibility
        if(vm.cardData &&
          vm.cardData.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id!==currentCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id){
          var legs=Object.keys(currentCard.data.sell_rates);
          legs.forEach(function(leg){
            if(currentCard.data.sell_rates[leg].rate_obj && currentCard.data.sell_rates[leg].rate_obj.batchcode){
              currentCard.data.sell_rates[leg].rate_obj.batchcode=[];
            }
          });
          legs=Object.keys(currentCard.data.buy_rates);
          legs.forEach(function(leg){
            if(currentCard.data.buy_rates[leg].rate_obj && currentCard.data.buy_rates[leg].rate_obj.batchcode){
              currentCard.data.buy_rates[leg].rate_obj.batchcode=[];
            }
          });
          }
        // Assigning Freedays data

        // FCL
        if(vm.searchParam.mode == "SEA-FCL"){
          vm.freeDaysError = false;
          // Error validation
          vm.freeDaysError = util.fnFreeDaysValidation(vm.loadWiseFreeDaysList);
          if( vm.freeDaysError){
            vm.footerObj.doneBtnDisable = false;
            vm.selectedIndex = angular.copy(vm.chargesTabIndex) + (vm.termsVisible ? 3 : 2);
            return;
          }
          currentCard.data.sell_rates[vm.l3_leg].rate_obj['freeDays'] = JSON.parse(JSON.stringify(fbUtils.FreeDays.transform(null)['freeDays']));
        // structuring the free days data with child component data - send to payload
        var isFreedaysExist =  false;
         vm.loadWiseFreeDaysList.forEach(function(freeDays){
          util.freeDaysKeys.forEach(function(key){
            util.routeKeys.forEach(function(route){
              if(freeDays[route][key]['freeDays']){
                if(freeDays.loadType != 'All'){
                   isFreedaysExist = true;
                  currentCard.data.sell_rates[vm.l3_leg].rate_obj['freeDays'][route][key].push(
                     {
                         "free_days":freeDays[route][key]['freeDays'],
                         "free_days_type":freeDays[route][key]['freeDaysType'],
                         "container_type":freeDays.loadType
                     }
                  );
               }else{
                 isFreedaysExist = true;
                vm.searchParam.load_data.load_details_value.forEach(function(load){
                  currentCard.data.sell_rates[vm.l3_leg].rate_obj['freeDays'][route][key].push(
                    {
                        "free_days":freeDays[route][key]['freeDays'],
                        "free_days_type":freeDays[route][key]['freeDaysType'],
                        "container_type":load.type
                    } );
                }) }
             }     
            });
          });
          });
          if(!isFreedaysExist){
            currentCard.data.sell_rates[vm.l3_leg].rate_obj['freeDays'] =  null;
          }
        }

         //  LCL
      //   if(vm.searchParam.mode == "SEA-LCL"){
      //      // combined data
      //      currentCard.data.sell_rates[vm.l3_leg].rate_obj['combined_details'].origin = vm.freeDaysData.origin.combinedDays ? [{free_days:vm.freeDaysData.origin.combinedDays}] : [] ;
      //      currentCard.data.sell_rates[vm.l3_leg].rate_obj['combined_details'].destination = vm.freeDaysData.destination.combinedDays ? [{free_days:vm.freeDaysData.destination.combinedDays}] : [];
        
      //  // Detention
      //  var detention_details={
      //   origin : vm.freeDaysData.origin.detention ? [{free_days:vm.freeDaysData.origin.detention}] : [],
      //   destination : vm.freeDaysData.destination.detention?[{free_days:vm.freeDaysData.destination.detention }] : []
      //  }
      //  currentCard.data.sell_rates[vm.l3_leg].rate_obj.detention_details=detention_details;
     
      //  //  Demurrage
      //   var demurrage_details={
      //     origin : vm.freeDaysData.origin.demurrage?[{free_days:vm.freeDaysData.origin.demurrage}]:[],
      //     destination : vm.freeDaysData.destination.demurrage?[{free_days:vm.freeDaysData.destination.demurrage}]:[]
      //   }
      //  currentCard.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details = demurrage_details;

      //   origin free days
      //   if(currentCard.data.sell_rates[vm.l3_leg].rate_obj.origin_combined_free_days){
      //       currentCard.data.sell_rates[vm.l3_leg].rate_obj.origin_free_days = currentCard.data.sell_rates[vm.l3_leg].rate_obj.origin_combined_free_days;
      //   }
      //   else{
      //       currentCard.data.sell_rates[vm.l3_leg].rate_obj.origin_free_days = (detention_details.origin.length && detention_details.origin[0].free_days ? detention_details.origin[0].free_days : null)+( demurrage_details.origin.length && demurrage_details.origin[0].free_days ? demurrage_details.origin[0].free_days : null)
      //   }

      //   destination free days
      //   if(currentCard.data.sell_rates[vm.l3_leg].rate_obj.destination_combined_free_days){
      //       currentCard.data.sell_rates[vm.l3_leg].rate_obj.destination_free_days = currentCard.data.sell_rates[vm.l3_leg].rate_obj.destination_combined_free_days;
      //   }
      //   else{
      //     currentCard.data.sell_rates[vm.l3_leg].rate_obj.destination_free_days = (detention_details.destination.length && detention_details.destination[0].free_days ? detention_details.destination[0].free_days : null)+( demurrage_details.destination.length && demurrage_details.destination[0].free_days ? demurrage_details.destination[0].free_days : null)
      //   }
      // }
     
        vm.footerObj.doneBtnDisable = true;

        if(vm.fnMetaValidation(newRateForm) > 0){
          var metaValidation = angular.copy(vm.validationObj);
          angular.forEach(Object.keys(metaValidation),function(metaName){
            if(metaValidation[metaName]){
              metaValidation[metaName] = 'invalid';
            }
            else{
              metaValidation[metaName] = 'valid';
            }
          });
          vm.fnTrackAnalytics('RateCard-'+vm.buttonType+'Click',{'value':mixpanelCard,'validation':metaValidation});
          vm.footerObj.doneBtnDisable = false;
           // scroll top 
           var popupElement = angular.element(document.querySelector('.body'));
           popupElement.scrollTop(0);
          return;
        }
        
        var isChargeValid = shareQuoteService.fnRateEditValidation(currentCard,vm.editBuyRate,vm.searchParam,vm.cardData,vm.pageSource);

        if (isChargeValid === 0) {
          const elements = document.querySelectorAll('.error-border');
            if(vm.viewActiveTab != 'quotation'){
                vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible;
            }else{
              if(elements.length && elements[0]){
                elements[0].scrollIntoView({ behavior: 'smooth' , block: 'center'});
              }
            }
          vm.footerObj.doneBtnDisable = false;
          vm.selectedIndex = angular.copy(vm.chargesTabIndex);
        } else if (isChargeValid === 1) {
          vm.disableDoneBtn = true;
          // create user define _id for new card
          if(!currentCard['_id']){
            var card_number = (vm.shareQuoteService.fnGuuid() + vm.shareQuoteService.fnGuuid() + "-" + vm.shareQuoteService.fnGuuid() + "-4" + vm.shareQuoteService.fnGuuid().substr(0,3) + "-" + vm.shareQuoteService.fnGuuid() + "-" + vm.shareQuoteService.fnGuuid() + vm.shareQuoteService.fnGuuid() + vm.shareQuoteService.fnGuuid()).toLowerCase();
            currentCard['_id'] =  card_number;
          }
          currentCard.meta.remarks = currentCard.meta.remarks ? currentCard.meta.remarks : "";
          currentCard.meta.inclusions = currentCard.meta.inclusions ? currentCard.meta.inclusions : "";
          currentCard.meta.internal_remarks = currentCard.meta.internal_remarks ? currentCard.meta.internal_remarks : "";
          currentCard.meta.port_data.empty_container_pickup = vm.selectedPickupContainer ? currentCard.meta.port_data.empty_container_pickup : null;
          currentCard.meta.port_data.empty_container_drop = vm.selectedDropContainer ? currentCard.meta.port_data.empty_container_drop : null;
          currentCard.meta.pickup_sub_vendor = currentCard.meta["pickup_sub_vendor"] || null;
          currentCard.meta.delivery_sub_vendor = currentCard.meta["delivery_sub_vendor"] || null;
          currentCard.meta.pickup_service = currentCard.meta.pickup_service || null;
          currentCard.meta.delivery_service = currentCard.meta.delivery_service || null;

          currentCard.data.sell_rates[vm.l3_leg].rate_obj.origin_haulage = currentCard.meta.haulage;
          currentCard.data.sell_rates[vm.l3_leg].rate_obj.destination_haulage = currentCard.meta.destination_haulage;

          currentCard.data.sell_rates[vm.l3_leg].rate_obj.commodity_data = angular.copy(vm.shareQuoteService.commodityString(vm.commodityArray));
          // start date
          currentCard.data.sell_rates[vm.l3_leg].rate_obj.start_date = currentCard.data.sell_rates[vm.l3_leg].rate_obj.start_date ? $filter('date')(util.dateReplace(currentCard.data.sell_rates[vm.l3_leg].rate_obj.start_date), "yyyy-MM-dd") : null;  
          // expiry date
          currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry = currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry ? $filter('date')(util.dateReplace(currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry), "yyyy-MM-dd") : null;  
          // sailing date
          currentCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date = currentCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date ?  $filter('date')(util.dateReplace(currentCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date), "yyyy-MM-dd") : null;

          if(vm.searchParam.mode == "AIR"){
            // ETD 
            currentCard.data.sell_rates[vm.l3_leg].rate_obj.departure_time = currentCard.data.sell_rates[vm.l3_leg].rate_obj.departure_time ? $filter('date')(util.dateReplace(currentCard.data.sell_rates[vm.l3_leg].rate_obj.departure_time), "yyyy-MM-dd") : null;

            // ETA
            currentCard.data.sell_rates[vm.l3_leg].rate_obj.arrival_time = currentCard.data.sell_rates[vm.l3_leg].rate_obj.arrival_time ? $filter('date')(util.dateReplace(currentCard.data.sell_rates[vm.l3_leg].rate_obj.arrival_time), "yyyy-MM-dd") : null;
          }

          // coppying l3 sell value in l3 buy rates
          var tempL3BuyObj = angular.copy(currentCard.data.sell_rates[vm.l3_leg].rate_obj);

          tempL3BuyObj.charges = currentCard.data.buy_rates[vm.l3_leg].rate_obj.charges;
          tempL3BuyObj.leg_total_currency = currentCard.data.buy_rates[vm.l3_leg].rate_obj.leg_total_currency;
          tempL3BuyObj.leg_total_cost = currentCard.data.buy_rates[vm.l3_leg].rate_obj.leg_total_cost;
          tempL3BuyObj.leg_currency_cost = currentCard.data.buy_rates[vm.l3_leg].rate_obj.leg_currency_cost;
          tempL3BuyObj.leg_currency = currentCard.data.buy_rates[vm.l3_leg].rate_obj.leg_currency;

          currentCard.data.buy_rates[vm.l3_leg].rate_obj = angular.copy(tempL3BuyObj);
          if(vm.pageSource!=='newCardSearch'){
            currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);
            currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);
            currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);
          }

          if(vm.searchParam.mode == 'SEA-FCL'){
            // if origin destination liner has changed remove co2e 
            vm.fnCheckCo2e(currentCard);
          }
          // else{
            vm.submitCharges(currentCard);
          // }
        }
      }

      function fnGetRates(currentCard){

        var legType = resultService.requiredLegUrl(vm.searchParam, currentCard, vm.modeName);

        if(!legType){
          vm.fetchRatesSubmit(currentCard);
          return;
        }
        legType = legType.split(",");

        // l3 buy rates and sell rates
        var tempBuyRates = angular.copy(currentCard.data.buy_rates['l3'+vm.modeName].rate_obj);

        var sell_rates = {
          "charges" : currentCard.data.sell_rates['l3'+vm.modeName].rate_obj.charges,
          "leg_total_cost": currentCard.data.sell_rates['l3'+vm.modeName].rate_obj.leg_total_cost,
          "leg_total_currency": currentCard.data.sell_rates['l3'+vm.modeName].rate_obj.leg_total_currency,
          "leg_currency_cost": currentCard.data.sell_rates['l3'+vm.modeName].rate_obj.leg_currency_cost,
          "leg_currency": currentCard.data.sell_rates['l3'+vm.modeName].rate_obj.leg_currency
        }

        tempBuyRates.sell_leg_object = angular.copy(sell_rates);
        
        // get-rates api request param
        vm.reqPram = {
          "meta": {
            "id": vm.pageInfo.pageId,
            "source": vm.pageInfo.pageType.toLowerCase(),
            "type": "msr_rates",
            "mode": vm.searchParam.mode,
            "nearby_only": false,
            "origin_door": {
              "_id": vm.cardPickupId ? vm.cardPickupId : "",
              "global_port_code": null
            },
            "origin_port": {
              "_id": vm.cardOriginId ? vm.cardOriginId : "",
              "global_port_code": currentCard.meta.port_data.origin_port_code
            },
            "destination_port": {
              "_id": vm.cardDestinationId ? vm.cardDestinationId : "",
              "global_port_code": currentCard.meta.port_data.destination_port_code
            },
            "destination_door": {
              "_id": vm.cardDeliveryId ? vm.cardDeliveryId : "",
              "global_port_code": null
            },
            "via_pol": {
              "_id": vm.cardPolId ? vm.cardPolId : "",
              "global_port_code": currentCard.meta.via_pol
            },
            "via_pod": {
              "_id": vm.cardPodId ? vm.cardPodId : "",
              "global_port_code": currentCard.meta.via_pod
            },
            "leg_type": legType,
            "origin_haulage": currentCard.meta.haulage,
            "origin_trasporter_id": null,
            "destination_haulage": currentCard.meta.destination_haulage,
            "destination_trasporter_id": null,

            "pickup_haulage": currentCard.meta.pickup_transport_mode,
            "pickup_transporter_id": currentCard.meta.pickup_sub_vendor,
            "pickup_service_type": currentCard.meta.pickup_service,

            "delivery_haulage": currentCard.meta.delivery_transport_mode,
            "delivery_transporter_id": currentCard.meta.delivery_sub_vendor,
            "delivery_service_type": currentCard.meta.delivery_service,
            // following keys are allready in l3
            "sub_vendor_id": currentCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id,
            "via_ports": currentCard.data.sell_rates[vm.l3_leg].rate_obj.via_route ? [
              currentCard.data.sell_rates[vm.l3_leg].rate_obj.via_route 
            ] : [],
            "service_type": currentCard.data.sell_rates[vm.l3_leg].rate_obj.service_type,
            "start_date": currentCard.data.sell_rates[vm.l3_leg].rate_obj.start_date,
            "end_date": currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry, 
            "cargo_type": currentCard.data.sell_rates[vm.l3_leg].rate_obj.cargo_type_data.code,
            "commodities": currentCard.data.sell_rates[vm.l3_leg].rate_obj.commodity_data,
            "sailing_date": currentCard.data.sell_rates[vm.l3_leg].rate_obj.sailing_date
          },
          "data": tempBuyRates
        }

        var data =  vm.reqPram;

        resultService.fnGetFetchLegs(data).then(function (response) {
          vm.getLegOptions = response.data.rate;
          if(vm.getLegOptions && Object.keys(vm.getLegOptions).length){
            vm.screenNumber = 2;
          }else{
            vm.fetchRatesSubmit(currentCard);
          }
        },
        function (error) {
          vm.getLegOptions = null;
          vm.fetchRatesSubmit(currentCard);
          $log.log(error);
        });
      }

      function fetchRatesSubmit(currentCard){
        vm.disableFetchBtn = true;
        vm.tempNewCard = angular.copy(currentCard);
        vm.cardLegNameTemp = angular.copy(vm.cardLegNameList);
        angular.forEach(vm.getLegOptions,function(value, key){

          if(value.selectedRate){
             // find duplicated leg name if any
            vm.cardLegNameTemp.push(value.selectedRate.leg_name.toLowerCase());

            vm.tempNewCard.data.buy_rates[value.leg_code] = {
              "leg_name" : value.selectedRate.leg_name,
              "leg_code" : value.selectedRate.leg_code,
              "vendor_id" : value.selectedRate.vendor_id,
              'rate_obj' : angular.copy(value.selectedRate)
            };

            vm.tempNewCard.data.sell_rates[value.leg_code] = angular.copy(vm.tempNewCard.data.buy_rates[value.leg_code]);
              
            var card_sell = vm.tempNewCard.data.sell_rates[value.leg_code]['rate_obj'];

            if(card_sell.sell_leg_object){
              card_sell.charges = angular.copy(card_sell.sell_leg_object.charges);
              card_sell.leg_total_cost = angular.copy(card_sell.sell_leg_object.leg_total_cost);
              card_sell.leg_total_currency = angular.copy(card_sell.sell_leg_object.leg_total_currency);
              card_sell.leg_currency_cost = angular.copy(card_sell.sell_leg_object.leg_currency_cost);
              card_sell.leg_currency = angular.copy(card_sell.sell_leg_object.leg_currency);
            }
            delete card_sell.sell_leg_object;
            delete vm.tempNewCard.data.buy_rates[value.leg_code]['rate_obj'].sell_leg_object;
            delete vm.tempNewCard.data.buy_rates[value.leg_code]['rate_obj']._id;

            vm.tempNewCard.meta["remarks"] += value.selectedRate.remarks ? value.selectedRate.remarks+ ' '  : "";
            vm.tempNewCard.meta["inclusions"] += value.selectedRate.inclusions ? value.selectedRate.inclusions+ ' ' : "";
            vm.tempNewCard.meta["internal_remarks"] += value.selectedRate.internal_remarks ? value.selectedRate.internal_remarks+ ' ' : "";
          }

        });

        var duplicateLegName = vm.fnDuplicatesString(vm.cardLegNameTemp);
        if( duplicateLegName.length > 0){
          var messageText = "There are multiple leg name of "
          for(var i = 0; i < duplicateLegName.length; i++){
            messageText += duplicateLegName[i] + ", ";
          }
          // messageText.substring(0,messageText.length-1);
          messageText += " please eliminate the irrelevant one before proceeding.";
          util.showToast(messageText);
          vm.disableFetchBtn = false;
          return;
        }
        
        vm.tempNewCard.meta.card_total_cost = resultService.calCardTotal(vm.tempNewCard.data.sell_rates);
        vm.tempNewCard.meta.buy_leg_total = resultService.calCardTotal(vm.tempNewCard.data.buy_rates);
        vm.disableDoneBtn = false;
        vm.disableFetchBtn = false;
        vm.callback({item : {'currentCard':vm.tempNewCard, 'action': vm.pageSource.toLowerCase().includes('edit') ? 'editRate' : 'addRate'}});
      }

      

      function fnDuplicatesString(arr) {
        var result = arr.filter(function (item, index) {
          if (arr.indexOf(item) !== index) {
            return item;
          }
        });
        return result;
      }

      function submitCharges(currentCard){
        var maxLegNum = 10; 
        angular.forEach(currentCard.data.sell_rates, function (value, key) {
            if (value.leg_code) {
              var match = value.leg_code.match(/(\d+)/); //checking the number from leg code
              if (match) {
                var num = parseInt(match[0]); //converting "3" to 3 for comparison
                if (num > maxLegNum) {
                  maxLegNum = num; //checking the maximum legcode used from this
                }
              }        
            }
          });
        var custom_leg = maxLegNum + 1;
        var custom_leg_pointer = custom_leg;
        var tempSellRates = {};
        var tempBuyRates = {};
        vm.cardLegNameList = [];
        angular.forEach(currentCard.data.sell_rates, function (value, key) {
          if(key.toLowerCase().includes('lnew') || key !== vm.l3_leg){
            if(value.leg_code===vm.l3_leg){
              var templeg=value.rate_obj;
              value = currentCard.data.sell_rates[vm.l3_leg];
              value.leg_name = templeg.leg_name;
              value.rate_obj.leg_name = templeg.leg_name;
              value.rate_obj.charges=templeg.charges;
              value.rate_obj.leg_total_currency=templeg.leg_total_currency;
              value.rate_obj.leg_total_cost=templeg.leg_total_cost;
              value.rate_obj.leg_currency_cost=templeg.leg_currency_cost;
              value.rate_obj.leg_currency=templeg.leg_currency
              value.rate_obj.manual=templeg.manual;
            }  
          }
          if(value.rate_obj){
            if (vm.searchParam.mode == "SEA-FCL") {
              value.rate_obj.load_stat = angular.copy(vm.load_stat);
            }

            if (value.leg_code) {
              tempSellRates[value.leg_code] = value;
              if(value.leg_code===vm.l3_leg && ( key.toLowerCase().includes('lnew') || key !== vm.l3_leg )){
                var buytempleg= currentCard.data.buy_rates[key].rate_obj;
                tempBuyRates[value.leg_code]=currentCard.data.buy_rates[vm.l3_leg];
                tempBuyRates[value.leg_code].leg_name = currentCard.data.buy_rates[key].leg_name
                tempBuyRates[value.leg_code].rate_obj.leg_name = currentCard.data.buy_rates[key].leg_name;
                tempBuyRates[value.leg_code].rate_obj.charges=buytempleg.charges;
                tempBuyRates[value.leg_code].rate_obj.leg_total_currency=buytempleg.leg_total_currency;
                tempBuyRates[value.leg_code].rate_obj.leg_total_cost=buytempleg.leg_total_cost;
                tempBuyRates[value.leg_code].rate_obj.leg_currency_cost=buytempleg.leg_currency_cost;
                tempBuyRates[value.leg_code].rate_obj.leg_currency=buytempleg.leg_currency;
                tempBuyRates[value.leg_code].rate_obj.manual=buytempleg.manual
              }
              else if(value.leg_code == vm.l1_leg || value.leg_code == vm.l5_leg){
                var legName = value.leg_code == vm.l1_leg ? "pickup" : "delivery";

                value.rate_obj.sub_vendor = currentCard.meta[legName+"_sub_vendor"] ? currentCard.meta[legName+"_sub_vendor"] : value.rate_obj.sub_vendor;
                value.rate_obj.sub_vendor_id = currentCard.meta[legName+"_sub_vendor"] ? currentCard.meta[legName+"_sub_vendor"].sv_id : null ;
                value.rate_obj.service_type = currentCard.meta[legName+"_service"] ? currentCard.meta[legName+"_service"] : value.rate_obj.service_type;
                value.rate_obj.cargo_type_data =  currentCard.data.sell_rates[vm.l3_leg].rate_obj.cargo_type_data;
                tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
                tempBuyRates[value.leg_code].rate_obj.sub_vendor = value.rate_obj.sub_vendor;
                tempBuyRates[value.leg_code].rate_obj.sub_vendor_id = value.rate_obj.sub_vendor_id;
                tempBuyRates[value.leg_code].rate_obj.service_type = value.rate_obj.service_type;
                tempBuyRates[value.leg_code].rate_obj.cargo_type_data = value.rate_obj.cargo_type_data;
                
              }
              else{
                tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
              }
              custom_leg = parseInt(value.leg_code.match(/(\d+)/)[0]) <= 8 ? custom_leg_pointer : parseInt(value.leg_code.match(/(\d+)/)[0]) + 1;
              custom_leg_pointer = custom_leg;
            }
            else if (!value.leg_code) {
              value.leg_code = "l" + custom_leg + vm.modeName;
              value.rate_obj.leg_code = value.leg_code;
              value.rate_obj.leg_name = value.leg_name;
              currentCard.data.buy_rates[key].leg_code = value.leg_code;
              currentCard.data.buy_rates[key].leg_name = value.leg_name;
              currentCard.data.buy_rates[key].rate_obj.leg_code = value.leg_code;
              currentCard.data.buy_rates[key].rate_obj.leg_name = value.leg_name;
              custom_leg++;
              custom_leg_pointer=custom_leg;

              tempSellRates[value.leg_code] = value;
              tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
            }

            vm.cardLegNameList.push(value.leg_name.toLowerCase());

            angular.forEach(value.rate_obj.charges, function (childValue, chargeKey) {
              if (vm.searchParam.mode == "SEA-FCL" && childValue.container_type) {
                value.rate_obj.load_stat[childValue.container_type] = 1;
              }
              if (!childValue.charge_id) {
                childValue.charge_id = "UD" + Math.random().toString(36).substring(2, 7).toUpperCase();
                childValue.global_charge_id = "UD" + Math.random().toString(36).substring(2, 7).toUpperCase();

                // random id for buy and sell rate charges
                tempSellRates[value.leg_code].rate_obj.charges[chargeKey].charge_id = childValue.charge_id;
                tempBuyRates[value.leg_code].rate_obj.charges[chargeKey].charge_id = childValue.charge_id;

                tempSellRates[value.leg_code].rate_obj.charges[chargeKey].global_charge_id = childValue.global_charge_id;
                tempBuyRates[value.leg_code].rate_obj.charges[chargeKey].global_charge_id = childValue.global_charge_id;
              }
            });

            if (vm.editBuyRate) {
              tempBuyRates[value.leg_code].rate_obj.load_stat = angular.copy(value.rate_obj.load_stat);
            } else {
              tempBuyRates[value.leg_code].rate_obj.load_stat = tempBuyRates[value.leg_code].rate_obj.load_stat? tempBuyRates[value.leg_code].rate_obj.load_stat : angular.copy(vm.load_stat);
            }
          }

          if(!currentCard.data.sell_rates[key].rate_obj.sub_vendor_id){
            currentCard.data.buy_rates[key].rate_obj.sub_vendor_id = currentCard.data.buy_rates[vm.l3_leg].rate_obj.sub_vendor_id;
            currentCard.data.buy_rates[key].rate_obj.sub_vendor = currentCard.data.buy_rates[vm.l3_leg].rate_obj.sub_vendor;

            currentCard.data.sell_rates[key].rate_obj.sub_vendor_id = currentCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id;
            currentCard.data.sell_rates[key].rate_obj.sub_vendor = currentCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor;
          }

        });

        currentCard.data.sell_rates = tempSellRates;
        currentCard.data.buy_rates = tempBuyRates;
        currentCard.meta.card_total_cost = resultService.calCardTotal(currentCard.data.sell_rates);
        currentCard.meta.buy_leg_total = resultService.calCardTotal(currentCard.data.buy_rates);
        vm.footerObj.doneBtnDisable = false;

        if(vm.pageSource.toLowerCase().includes('new') && vm.pageInfo.pageId){
          vm.fnGetRates(currentCard);
        }else{
          vm.disableDoneBtn = false;
          vm.callback({item : {'currentCard':currentCard, 'action': vm.pageSource.toLowerCase().includes('edit') ? 'editRate' : 'addRate'}});
        }
      }

      function fbGoBack(){
        vm.disableDoneBtn = false;
        vm.screenNumber = 1;
      }

      // mixpanle event
      function fnTrackAnalytics(action, params){
        if(!params){
          var params = {};
        }
        var shortPageName = '';
        if(vm.pageSource.includes('Inquiry')){
          shortPageName = 'ID';
        }
        else if(vm.pageSource.includes('Quote')){
          if(vm.pageSource.includes('Copy')){
            shortPageName = 'QC';
          }
          else{
            shortPageName = 'QD';
          }
        }
        else{
          shortPageName = 'RR';
        }
        params.mode = vm.searchParam.mode;
        params.action = vm.pageSource.includes('new') ? 'add' : 'edit';
        util.callMixpanel(shortPageName+'-'+action, params);
      }

      function fnViewExchangeRate(){
        var page_id = vm.pageInfo.pageType && vm.pageInfo.pageType.toLowerCase() == 'inquiry' ? vm.pageInfo.activityListId : vm.pageInfo.pageId;
        vm.util.redirectToExchangeRatesLink(vm.pageInfo.pageType, page_id, vm.cardData.meta.vendor_id, '', null, vm.pageInfo.activityId);
      }
      
      // **** CO2E feature start ******
      // for fcl check co2e 
      function fnCheckCo2e(card){
        var rate_obj = card.data.sell_rates[vm.l3_leg].rate_obj;
        var meta = card.meta;
        var porPair = {
          "origin" : meta.selected_schedule ? meta.selected_schedule.origin_port : meta.port_data.origin_port_code,
          "destination" : meta.selected_schedule ? meta.selected_schedule.destination_port : meta.port_data.destination_port_code
        }

        if(!vm.cardData || vm.cardData.meta.port_data.origin_port_code != porPair.origin ||
          vm.cardData.meta.port_data.destination_port_code != porPair.destination || 
          vm.cardData.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.carrier_code != rate_obj.sub_vendor.carrier_code){
            meta["co2eData"] = null;
        }

        
        // vm.fnSetCo2InCard(rate_obj, meta, porPair);

        // if(!meta["co2eData"]){
        //   var payloadObj = {
        //       "data" : {
        //         "containers": resultService.searchLoadState,
        //         "routesData": []
        //       }
        //   };

        //   resultService.fnSetCo2Payload(rate_obj, porPair, payloadObj.data);

        //   vm.fnGetCo2e(payloadObj, rate_obj, meta, porPair);
          
        // }
      }

      // BE api for new set of co2e
      function fnGetCo2e(payloadObj, rate_obj, meta, portPair){
        if(vm.searchParam.search_type === 'P2P'){
        resultService.fnCo2ApiCall(payloadObj,vm.searchParam.mode).then(function (response) {
          var co2eData = response.data;
          if(!co2eData || !co2eData[rate_obj.sub_vendor.carrier_code].length){
            vm.submitCharges(vm.addNewCard);
            return;
          }

          // if(co2eData && co2eData[rate_obj.sub_vendor.carrier_code].length){
            if(vm.co2eResponse && Object.keys(vm.co2eResponse).length){
              Object.assign(vm.co2eResponse,co2eData);
            }else{
              vm.co2eResponse = co2eData;
            }
            
          // }
          
          // calculate container wise total and co2e total
          resultService.fnCalculateCo2Total(co2eData, vm.searchParam.load_data.load_details_value);
          
          vm.fnSetCo2InCard(rate_obj, meta, portPair);
        },function(error){
          vm.submitCharges(vm.addNewCard);
          $log.log(error.data);
        });
        }
      }

      // storte co2e in card meta
      function fnSetCo2InCard(rate_obj, meta, portPair){
        if(!vm.co2eResponse){
          return;
        }
        var co2ForCarrier = vm.co2eResponse[rate_obj.sub_vendor.carrier_code];
        if(co2ForCarrier && co2ForCarrier.length){
          for(var i = 0; i < co2ForCarrier.length; i++){
            if((co2ForCarrier[i].origin === portPair.origin ) && (co2ForCarrier[i].destination === portPair.destination) && co2ForCarrier[i].container_emissions.length){
              meta["co2eData"] = angular.copy(co2ForCarrier[i]);
            }
          }
          vm.submitCharges(vm.addNewCard);
        }

        
      }
       // **** CO2E feature end ******
      
      // **** load wise freedays edit - start ******

      function freeDaysTab(){
        vm.viewActiveTab = "loadWiseFreeDays";
        var shortPageName = '';
        if(vm.pageSource){

        if(vm.pageSource.includes('Inquiry')){
          shortPageName = 'ID';
        }
        else if(vm.pageSource.includes('Quote')){
          if(vm.pageSource.includes('Copy')){
            shortPageName = 'QC';
          }
          else{
            shortPageName = 'QD';
          }
        }
        else{
          shortPageName = 'RR';
        }
          }
      }

      function fnGetAirlineData(searchText){
          if(!searchText && (util.airlineData.data.length)){
            //  storing Airline details on L3
              vm.getSubvendor = angular.copy(util.airlineData.data);
              vm.fnPushSubVendorToList('l3');
          }else{
            var type = 'airline';
            var queryData = searchText ? searchText : '';
            vm.filterLoader = true;
              resultService.getLinersData(type,queryData).then(function(response){
                  vm.getSubvendor = response.data.data
                if(!searchText){
                  util.airlineData.data = angular.copy(response.data.data);
                }
                vm.fnPushSubVendorToList('l3');
                vm.filterLoader = false;
              },function(error){
                vm.getSubvendor = [];
                vm.filterLoader = false;
              });
          }
      }

      function fnSetSubVendorInit(card){

          var l3SubVendor = vm.searchParam.mode == "AIR" ? card.data.sell_rates[vm.l3_leg].rate_obj.airline : card.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor;
          var l1SubVendor =  card.meta.pickup_sub_vendor || {};
          var l5SubVendor =  card.meta.delivery_sub_vendor || {};
        
          //  pickup transporter
          if(Object.keys(l1SubVendor).length !== 0){
                var l1TempSubVendor = {
                  "code" : l1SubVendor.carrier_code,
                  "name" : l1SubVendor.sub_vendor_name,
                  "id": l1SubVendor.sv_id
                }
                vm.transporterDetails['pickup_sub_vendor'] = l1TempSubVendor;
          }
          //  pickup transporter
          if(Object.keys(l5SubVendor).length !== 0){
                var l5TempSubVendor = {
                  "code" : l5SubVendor.carrier_code,
                  "name" : l5SubVendor.sub_vendor_name,
                  "id" : l5SubVendor.sv_id
                }
                vm.transporterDetails['delivery_sub_vendor'] = l5TempSubVendor
          }
          // l3 sub vendor
          if(vm.searchParam.mode == "AIR"){
                vm.selectedL3LinerData = {
                  "code": l3SubVendor.airline_code,
                  "name": l3SubVendor.air_line_name
                };
          }else{
                vm.selectedL3LinerData = {
                  "code": l3SubVendor.carrier_code,
                  "name": l3SubVendor.sub_vendor_name,
                  "id": l3SubVendor.sv_id
                };
          }
          vm.fnPushSubVendorToList();

      }

        // adding the previous selection to API response 
         function fnPushSubVendorToList(subVendorType){
            if( (subVendorType == 'l1' || !subVendorType) && vm.transporterDetails['pickup_sub_vendor'] && vm.transporterDetails['pickup_sub_vendor'].name){
              //checking selected data present in list or not 
                if (!vm.isExistInList(vm.getL1Subvendor , vm.transporterDetails['pickup_sub_vendor'])) {
                  vm.getL1Subvendor.push(vm.transporterDetails['pickup_sub_vendor']);
                }
            }
            if( (subVendorType == 'l5' || !subVendorType) && vm.transporterDetails['delivery_sub_vendor'] && vm.transporterDetails['delivery_sub_vendor'].name){
                if (!vm.isExistInList(vm.getL5Subvendor , vm.transporterDetails['delivery_sub_vendor'])) {
                  vm.getL5Subvendor.push(vm.transporterDetails['delivery_sub_vendor']);
                }
            }
             if( (subVendorType == 'l3' || !subVendorType) && vm.selectedL3LinerData && vm.selectedL3LinerData.name){
                if(!vm.isExistInList(vm.getSubvendor , vm.selectedL3LinerData)) {
                  vm.getSubvendor.push(vm.selectedL3LinerData);
                }
            }
       }

       function isExistInList(vendorObj , selectedData){
          return vendorObj.some(function(obj){
            return obj.code === selectedData.code
          });
       }


  }

})();

(function () {
    'use strict';
  
    angular
      .module('app.core')
      .component('termsConditionPopup', {
        templateUrl: 'app/main/quotes/components/terms-condition-popup/terms-condition-popup.html',
        bindings : {
          termsCondition:'=',
          quoteType:'=',
          callback:'&',
        },
        controller: function termsConditionPopupController(QuotesService,util,$log,$rootScope,$mdDialog,$scope,$filter) {
            var vm = this;
            vm.util = util;
            vm.cancelDialog = cancelDialog;
            vm.submitTermsCondition=submitTermsCondition;
            vm.termsConditionCkEditorConfig = angular.copy(util.ckEditorConfig);
            vm.termsConditionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
           // disable applied for Quotes page 
           this.$onInit = function() {
            if(vm.quoteType=='quote'){
            vm.termsConditionCkEditorConfig.readOnly =  true;
           }
          }
          
          function cancelDialog(ev,type){
            $mdDialog.hide();
          }

          function submitTermsCondition(){
            if(vm.quoteType==='copyQuote'){
              vm.callback({'data':vm.termsCondition});      
            }
            $mdDialog.hide();

           }
             
        }
      });
  
  })();
(function () {
    'use strict';

    angular
      .module('app.core')
      .component('quoteFilter', {
        templateUrl: 'app/main/quotes/components/filter-quote/filter-quote.html',
        bindings : {
          filterobj: '=',
          quoteData: '<',
          callback: '&',
          isLoadComponent:'<'
        },
        controller: function quoteFilterController(QuotesService,util,$log,$rootScope,$mdSidenav,$scope,$filter,$timeout) {
            var vm = this;
            vm.util = util;
            vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED;
            vm.filterListObject = {
              'status': null,
              'mode' : null,
              'date_range' : null,
              'templateList' : null,
              'created_by' : null,
              'incoterms' : null,
              'customer_details' : null,
              'origin'  : null,
              'destination' : null,
              'load_details' : null,
              'integrations' : null
            }
            vm.filterLoader = true;
            vm.fnGetFilterList = fnGetFilterList;
            vm.filterItemtoggle = filterItemtoggle;
            vm.trackEvent = trackEvent;
            vm.collapseIt = collapseIt;
            vm.setDatePicker = setDatePicker;
            vm.callBackCreatedBy = callBackCreatedBy;
            vm.callBackIncoTerms = callBackIncoTerms;
            vm.callBackCustomer = callBackCustomer;
            vm.callBackOrigin = callBackOrigin;
            vm.callBackDestination = callBackDestination;
            vm.storeFilterObject = null;
            //vm.resizeScreenSize = resizeScreenSize;
            vm.resetFilter = resetFilter;
            vm.callBackLoadType = callBackLoadType;
            vm.toggleSideNav = toggleSideNav;
            vm.callBackTemplateFilter = callBackTemplateFilter;
            vm.restructureIncoterms = restructureIncoterms;
            // Init function
            this.$onInit = function() {
                vm.createdByFilterConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.quoteData.createdBySelected,
                  'placeholder': 'Search users',
                  'isGroupOptions' : false,
                  'groupList' : {groupTitle:'Internal Users',keyTitle:'first_name',subKeyTitle:'email'},
                  'selectedCount' : 0
                }
                vm.templateNameFilterConditions={
                  'listLoader':false,
                  'selectedOptions': vm.quoteData.templateSelectedValue,
                  'placeholder': 'Search Template',
                  'isGroupOptions' : false,
                  'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:'created_by'},
                  'selectedCount' : 0
                }
                vm.customerFilterConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.quoteData.customerSelected,
                  'placeholder': 'Search Customer Details',
                  'isGroupOptions' : true,
                  'groupList' : {'user':{groupTitle:'User Name',keyTitle:'first_name',subKeyTitle:'email'},'company':{groupTitle:'Customer Company',keyTitle:'name',subKeyTitle:''}},
                  'selectedCount' : 0
                }
                vm.originFilterConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.quoteData.originSelected,
                  'placeholder': 'Search by Port/Country',
                  'isGroupOptions' : false,
                  'groupList' : {groupTitle:'',keyTitle:'port_name',subKeyTitle:'country'},
                  'selectedCount' : 0
                }
                vm.destFilterConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.quoteData.destSelected,
                  'placeholder': 'Search by Port/Country',
                  'isGroupOptions' : false,
                  'groupList' : {groupTitle:'',keyTitle:'port_name',subKeyTitle:'country'},
                  'selectedCount' : 0
                }
                vm.loadTypeFilterConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.quoteData.loadTypeSelected,
                  'placeholder': 'Search Load Type',
                  'isGroupOptions' : false,
                  'groupList' : {groupTitle:'',keyTitle:'load_code',subKeyTitle:''},
                  'selectedCount' : 0,
                  'isUpperCase' : true
                }
                vm.incoTermsConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.quoteData.incoTermsSelected,
                  'placeholder': 'Search Incoterms',
                  'isGroupOptions' : false,
                  'groupList' : {groupTitle:'',keyTitle:'code',subKeyTitle:'description'},
                  'selectedCount' : 0,
                  'isUpperCase' : true,
                  'mixpanelPageSource':'QL'
                }

                vm.fnGetFilterList(null);
            }  

            vm.$onChanges = function() {
              //it's used for god users when change user accounts 
              if(vm.isLoadComponent){
                vm.resetFilter();
              }
            }

            /*function resizeScreenSize() {
              vm.quoteData.deviceName = util.resizeScreen(vm.quoteData.deviceName);
            }
            window.onresize = vm.resizeScreenSize;*/

            function fnGetFilterList(queryParam){
              QuotesService.getFilterList(queryParam).then(function (response) {
                if(queryParam === null){ // it's on Init filter list
                  vm.filterListObject.status = response.data.data.status.data;
                  vm.filterListObject.mode = response.data.data.mode.data;
                  vm.filterListObject.date_range = vm.filterobj.created_on;
                  vm.filterListObject.origin = response.data.data.origin.data;
                  vm.filterListObject.destination = response.data.data.destination.data;
                  vm.filterListObject.load_details = response.data.data.load_details.data;
                  vm.filterListObject.templates = response.data.data.templates.data;
                  if(!util.isShipper){
                    vm.filterListObject.incoterms = vm.restructureIncoterms(response.data.data.incoterms.data);
                    vm.filterListObject.created_by = response.data.data.created_by.data;
                    vm.filterListObject.customer_details = response.data.data.customer_details.data;
                    vm.filterListObject.integrations = response.data.data.integrations ? response.data.data.integrations.data: [];
                  }
                  vm.storeFilterObject = angular.copy(vm.filterListObject);
                }else{ // it's on search query parameter filter list;
                  vm.filterListObject[queryParam.query_source] = response.data.data[queryParam.query_source].data;
                   util.callMixpanel(queryParam.mixedPanelEvent, {
                    "optionValue":vm.filterListObject[queryParam.query_source],
                    "searchVal" : queryParam.query
                  });
                }
                //console.log(vm.filterListObject);
                dropDownFilterLoader();
                calculateMaxHeight();
              }, function (error) {
                dropDownFilterLoader();
                vm.quoteParam.isResetFilter = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
                calculateMaxHeight();
              });
           } 

           function restructureIncoterms(incotermList) {
              return incotermList.map(function(item) {
                return {
                  mode: item.mode,
                  code: item.code + '-' + item.mode,
                  description: item.description,
                };
              });
            }

          function filterItemtoggle(item, list, entity,type) {

            if(!type) {
              if (!list[entity]) {
                list[entity] = [];
              }
              var idx = list[entity].indexOf(item);
              if (idx > -1) {
                list[entity].splice(idx, 1);
              } else {
                list[entity].push(item);
              }
            }
            else {
              vm.filterobj.status = [item.status];
            }
            //if directly select on load type filter option then also select SEA-FCL mode filter
            if(entity === 'load_types' && vm.filterobj.mode.indexOf('SEA-FCL') === -1){
              vm.filterobj.mode.push("SEA-FCL");
            }
            // if unselect SEA-FCL mode filter then reset also load type filter option
            if(entity === 'mode' && vm.filterobj.mode.indexOf('SEA-FCL') === -1){
              vm.filterobj.load_types = [];
            }
            vm.callback();
            //vm.resizeScreenSize();
          }

          function trackEvent(type,value) {
            if(type === 'QL-Filter-CreatedBy-Search' || type === 'QL-Filter-CreatedFor-Search' || type === 'Quote-filter-Load-Type-Search') {
              util.callMixpanel(type, {
                "value":value
              });
            }
            if(type === 'QL-Filter-CreatedFor-Option') {
              util.callMixpanel(type, {
                "optionValue":value
              });
            }
            if(type === 'Quote-filter-Createdby-ShowAll' || type === 'QL-Filter-CreatedFor-ShowAll') {
              util.callMixpanel(type);
            }
            
            if(type === 'quoteFilterStatus') {
              util.callMixpanel("Quote-filter-Status");
            }
            if(type === 'quoteFilterCustomerDetails') {
              util.callMixpanel("Quote-filter-Customer-Details");
            }
            if(type === 'quoteFilterOrigin') {
              util.callMixpanel("Quote-filter-Origin");
            }
            if(type === 'quoteFilterDestination') {
              util.callMixpanel("Quote-filter-Destination");
            }
            if(type === 'quoteLoadType') {
              util.callMixpanel("Quote-filter-Load-Type");
            }
            if(type === 'Quote-filter-Load-Details-Option'){
              util.callMixpanel("Quote-filter-Load-Details-Option", {
                "optionValue":value
              });
            }
          }

          //function to expand and collapse div
        function collapseIt(id, e){
          return;
          if(id==="quotes_status"){
              util.callMixpanel("Quote-filter-Status");
          }
          if(id==="quotes_mode"){
                util.callMixpanel("Quote-filter-Mode");
          }
          if(id==="quotes_created_by"){
              util.callMixpanel("Quote-filter-Createdby");
          }
          if(id==="quotes_created_for"){
              util.callMixpanel("Quote-filter-CreatedFor");
          }
          //angular.element('#'+id).slideToggle();
        }

        function setDatePicker(data) {
          // util.callMixpanel("quote-filter-Created-On-Select", {
          // });
          vm.filterobj.date_range={};
          vm.filterobj.date_range.from = $filter('date')(data.start_date, 'yyyy-MM-dd');
          vm.filterobj.date_range.to =  $filter('date')(data.end_date, 'yyyy-MM-dd');
          vm.callback();
          //vm.resizeScreenSize();
        }

        function callBackCreatedBy(payload){
          if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query_source' : "created_by",'query' : payload.searchText
            ,mixedPanelEvent : 'Quote-filter-Created-By-Search'} : null;
            vm.createdByFilterConditions.filterLoader = true;
            vm.fnGetFilterList(queryParam);
          }

          if(payload.selectedOptions){ // selected options
            vm.filterobj.created_by.data = [];
            if(vm.createdByFilterConditions.selectedCount !== 0){
              vm.quoteData.createdBySelected = payload.selectedOptions;
              vm.filterobj.created_by.data = payload.selectedOptions;
            }
            vm.callback();
            //vm.resizeScreenSize();
          }
        }

        function callBackIncoTerms(payload){
          if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query_source' : "incoterms",'query' : payload.searchText
            ,mixedPanelEvent : 'Quote-filter-inco-terms-Search'} : null;
            vm.incoTermsConditions.filterLoader = true;
            vm.fnGetFilterList(queryParam);
          }

          if(payload.selectedOptions){ // selected options
            vm.filterobj.incoterms = [];
            if(vm.incoTermsConditions.selectedCount !== 0){
              vm.quoteData.incoTermsSelected = payload.selectedOptions;
              angular.forEach(payload.selectedOptions,function(option){
                vm.filterobj.incoterms.push(option.code)
              })
            }
            vm.callback();
            //vm.resizeScreenSize();
          }
        }


        function callBackTemplateFilter(payload){
          if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query_source' : "templates",'query' : payload.searchText
            ,mixedPanelEvent : 'Quote-Filter-Template'} : null;
            vm.templateNameFilterConditions.filterLoader = true;
            vm.fnGetFilterList(queryParam);
          }

          if(payload.selectedOptions){ // selected options
            vm.filterobj.templates = [];
            if(vm.templateNameFilterConditions.selectedCount !== 0){
              vm.quoteData.templateSelectedValue = payload.selectedOptions;
              angular.forEach(payload.selectedOptions,function(option){
                vm.filterobj.templates.push({
                  "name": option.name,
                  "id": option.quote_id,
                })
              })
            }
            vm.callback();
            // vm.resizeScreenSize();
          }
        }

        function calculateMaxHeight(){
          if(!['tablet','mobile'].includes(vm.quoteData.deviceName)){
            var maxHeight = null;
            vm.maxFilterHeight = util.getModuleMaxHeight(maxHeight,'quotesFilter',-45)
          }
        }

        function callBackCustomer(payload){
          if(payload.searchText || payload.searchText === ''){ // search result 
              var queryParam = payload.searchText !== '' ? {'query_source' : "customer_details",'query' : payload.searchText,
              mixedPanelEvent : 'Quote-filter-Customer-Details-Search'} : null;

              vm.customerFilterConditions.filterLoader = true;
              vm.fnGetFilterList(queryParam);
          }

          if(payload.selectedOptions){ // selected options
            if(vm.customerFilterConditions.selectedCount !== 0){
              vm.quoteData.customerSelected = payload.selectedOptions;
              vm.filterobj.customer_details.data['user'] = [];
              vm.filterobj.customer_details.data['company'] = [];
              angular.forEach(payload.selectedOptions,function(item,key){
                vm.filterobj.customer_details.data[item.groupType].push({id:item.id})
              });
            }else{
              angular.forEach(vm.filterobj.customer_details.data,function(item,key){
                vm.filterobj.customer_details.data[key] = []; //reset group object list 
              }); 
            }
            vm.callback();
            //vm.resizeScreenSize();
          }
        }

        function callBackOrigin(payload){
          if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query_source' : "origin",'query' : payload.searchText
            ,mixedPanelEvent : 'Quote-filter-Origin-Search'} : null;
            vm.originFilterConditions.filterLoader = true;
            vm.fnGetFilterList(queryParam);
          }

          if(payload.selectedOptions){ // selected options
            vm.filterobj.origin = [];
            if(vm.originFilterConditions.selectedCount !== 0){
              vm.quoteData.originSelected = payload.selectedOptions;
              vm.filterobj.origin = payload.selectedOptions;
            }
            vm.callback();
            //vm.resizeScreenSize();
          }
        }

        function callBackDestination(payload){
          if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query_source' : "destination",'query' : payload.searchText
            ,mixedPanelEvent : 'Quote-filter-Destination-Search'} : null;
            vm.destFilterConditions.filterLoader = true;
            vm.fnGetFilterList(queryParam);
          }

          if(payload.selectedOptions){ // selected options
            vm.filterobj.destination = [];
            if(vm.destFilterConditions.selectedCount !== 0){
              vm.quoteData.destSelected = payload.selectedOptions;
              vm.filterobj.destination = payload.selectedOptions;
            }
            vm.callback();
            //vm.resizeScreenSize();
          }
        }

        function dropDownFilterLoader(){
          vm.filterLoader = false;
          vm.createdByFilterConditions.filterLoader = false;
          vm.customerFilterConditions.filterLoader = false;
          vm.incoTermsConditions.filterLoader = false;
          vm.originFilterConditions.filterLoader = false;
          vm.destFilterConditions.filterLoader = false;
          vm.templateNameFilterConditions.filterLoader = false;
        }

        

        function resetFilter(){
          vm.quoteData.isResetFilter = true;
          vm.quoteData.customerSelected = [];
          vm.quoteData.createdBySelected = [];
          vm.quoteData.incoTermsSelected = [];
          vm.quoteData.originSelected = [];
          vm.quoteData.destSelected = [];
          vm.quoteData.templateSelectedValue = [];
          this.$onInit();
          $rootScope.$broadcast('resetFilter', { any: '' });
          vm.callback();
        }

        function callBackLoadType(payload){
          if(payload.searchText || payload.searchText === ''){ // search result 
            vm.loadTypeFilterConditions.filterLoader = true;
              var searchString = payload.searchText.toLowerCase();
              var searchResult = [];
              // find existing load type list
              angular.forEach(vm.storeFilterObject.load_details, function (item) {
                var toFilterStr = item.load_code;
                vm.util.searchTextOption(searchResult,item,searchString,toFilterStr)
              });
              vm.trackEvent('Quote-filter-Load-Type-Search',searchString); // mixpanel tracking search
              $timeout(function (){
                vm.filterListObject.load_details = searchResult;
                vm.loadTypeFilterConditions.filterLoader = false;
              },100); 
          }
          if(payload.selectedOptions){ // selected options
            if(vm.loadTypeFilterConditions.selectedCount !== 0){
              vm.filterobj.load_types = [];
              vm.loadTypeFilterConditions.selectedOptions = payload.selectedOptions;
              angular.forEach(payload.selectedOptions,function(item,key){
                vm.filterobj.load_types.push(item['load_code'])
              });
            }else{
              vm.filterobj.load_types = [];
            }
            vm.callback();
          }
        }

        // Sidenav taggle function
        function toggleSideNav(sidenavId) {
          $mdSidenav(sidenavId).toggle();
        }
      }
      });

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('duplicateQuoteFooter', {
      templateUrl: 'app/main/quotes/components/duplicate-quote-footer/duplicate-quote-footer.html',
      bindings : {
        isduplicatequote: '=',
        selectedduplicatecard: '=',
        copyquoted: '=',
        linerdata: '=',
        callback: '&'
      },
      controller: function DuplicateQuoteFooterController(QuotesService,util,$log,$rootScope,$mdSidenav,$scope,analytics,$filter) {
          var vm = this;
          vm.util = util;
          vm.proceedCopyQuote = proceedCopyQuote;
          
        // Init function
        this.$onInit = function() {
          
        }

        function proceedCopyQuote(ev,type){
          vm.callback({'action': type});
        }
      }
    });

})();
(function () {
    'use strict';
  
    angular
    .module('app.core')
    .component('copyQuoteConfirmation', {
        templateUrl: 'app/main/quotes/components/copy-quote-confirmation/copy-quote-confirmation.html',
        bindings : {
            to:'=',
            from:'=',
            type:'=',
            isDestinationDoor:'=',
            isOriginDoor:'=',
            includeRateCards:'=',
            searchParam:'=',
            param:'=',
            loadArray:'=',
            quoteCardData:'=',
            searchType:'=',
            loadBoxString:'=',
            loadTooltipString:'=',
            copyDestinationLocation:'=',
            copyOriginLocation:'=',
            copyLoadFcl:'=',
            copyWeight:'=',
            sourceCurrency:'=',
            targetCurrency:'=',
            callback:'&'

            
        },
        controller: copyQuoteConfirmationController
    });
  
    function copyQuoteConfirmationController(ShipmentService, $log, $scope, $element, util,api,$timeout,$mdDialog, SearchService, $sanitize, $rootScope, appCache, $filter,$state, resultService,shareQuoteService, $mdPanel, analytics,$rootElement,loadDataFactory) {
        var vm = this;
        vm.closePanel=closePanel;
        vm.submitPanel=submitPanel;
        vm.checkForSamePorts=checkForSamePorts;
        vm.originPortdata=null;
        vm.destinationPortdata=null;
        vm.validationObj={
            "originPortValidation":false,
            "destinationPortValidation":false
        }
        vm.getPort = util.getPorts;
        vm.makeLoadBoxString=makeLoadBoxString;
        vm.loadBoxStringFunction=loadBoxStringFunction;
        vm.fromLoadString='';
        vm.toLoadString='';

        this.$onInit = function () {
            vm.l3_leg = 'l3_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        }

        function submitPanel(form,type){
            if(vm.type === 'currency'){
                vm.callback({status:'yes'});
                $mdDialog.hide();
                return;
            }
            vm.validationObj.originPortValidation=false;
            vm.validationObj.destinationPortValidation=false;
            if(vm.type==='location'){  
                if(!vm.originPortdata  && vm.param=='origin' && vm.isOriginDoor && vm.includeRateCards){
                    vm.validationObj.originPortValidation=true;
                }
                if(!vm.destinationPortdata && vm.param=='destination' && vm.isDestinationDoor && vm.includeRateCards){
                    vm.validationObj.destinationPortValidation=true;
                }
    
                if( vm.validationObj.originPortValidation|| vm.validationObj.destinationPortValidation) {
                    return ;
                }
                vm.copyDestinationLocation=vm.searchParam.destination_location;
                vm.copyOriginLocation=vm.searchParam.origin_location;
                vm.searchParam.origin_port=vm.originPortdata;
                vm.searchParam.destination_port=vm.destinationPortdata;
                if(vm.includeRateCards){
                    angular.forEach(vm.quoteCardData, function (value, key) {
                        value.meta.selected_schedule=null;
                        value.data.buy_rates[vm.l3_leg].rate_obj.schedule.data=[];
                        value.data.buy_rates[vm.l3_leg].rate_obj.schedule.url="";
                        value.data.sell_rates[vm.l3_leg].rate_obj.schedule.data=[];
                        value.data.sell_rates[vm.l3_leg].rate_obj.schedule.url="";

                        value.meta["isScheduleCall"] = false;
                        if(vm.param=='origin' ){

                         value.meta.port_data.pickup_location=(vm.isOriginDoor)  ? vm.searchParam.origin_location.location : null,
                         value.meta.port_data.pickup_pincode_ui=(vm.isOriginDoor ) ? vm.searchParam.origin_location.pin_code_ui : null,
                         value.meta.port_data.pickup_country_name =(vm.isOriginDoor) ? vm.searchParam.origin_location.country : null,
                         value.meta.port_data.origin_port_code =(vm.isOriginDoor) ? vm.searchParam.origin_port.global_port_code: vm.searchParam.origin_location.global_port_code,
                         value.meta.port_data.origin_city = (vm.isOriginDoor) ?vm.searchParam.origin_port.city :vm.searchParam.origin_location.city,
                         value.meta.port_data.origin_portname =(vm.isOriginDoor) ? vm.searchParam.origin_port.portname:vm.searchParam.origin_location.portname,
                         value.meta.port_data.is_icd_port_origin= (vm.isOriginDoor) ?vm.searchParam.origin_port.is_icd_port:vm.searchParam.origin_location.is_icd_port,
                         value.meta.via_pol = '';
                        }

                        if(vm.param=='destination'){
                            value.meta.port_data.delivery_location =(vm.isDestinationDoor)?vm.searchParam.destination_location.location : null,
                         value.meta.port_data.delivery_pincode_ui = (vm.isDestinationDoor) ?vm.searchParam.destination_location.pin_code_ui : null,
                         value.meta.port_data.delivery_country_name= (vm.isDestinationDoor) ?vm.searchParam.destination_location.country : null,
                         value.meta.port_data.destination_port_code = (vm.isDestinationDoor) ?  vm.searchParam.destination_port.global_port_code : vm.searchParam.destination_location.global_port_code,
                         value.meta.port_data.destination_portname = (vm.isDestinationDoor) ? vm.searchParam.destination_port.portname:vm.searchParam.destination_location.portname,
                         value.meta.port_data.is_icd_port_destination =(vm.isDestinationDoor)?vm.searchParam.destination_port.is_icd_port:vm.searchParam.destination_location.is_icd_port,
                         value.meta.port_data.destination_city =(vm.isDestinationDoor)  ?vm.searchParam.destination_port.city :vm.searchParam.destination_location.city
                        value.meta.via_pod =''; 
                        }
                        // setTimeout(() => {
                        //     value.meta["isScheduleCall"] = true;
                        // }, 100);

                        setTimeout(function () {
                            value.meta["isScheduleCall"] = true;
                          }, 100);
                        
                        
                    });

                }


            }
            else{
                if(vm.searchParam.mode==='SEA-FCL'){
                    vm.copyLoadFcl=angular.copy(vm.searchParam.load_data);
                    vm.searchParam.load_data.load_details_value=vm.to;
                }
                else{
                    vm.copyWeight=angular.copy(vm.searchParam.load_data);
                    vm.searchParam.load_data=vm.to;
                }
                vm.callback();
            }
           $mdDialog.hide();
        }

        function makeLoadBoxString(load) {
            var  loadString= '';
            if(load && load.length){
                load.forEach(function (i, k) {
                    if (i.type) {
                      loadString = loadString + (loadString === '' ? '' : ', ') + i.type +' x ' + (i.qty || 0)+' ('+i.load_metrics[0].weight_qty+'Kg)';
                    }
                  });
            }
            return loadString;
          }

          function loadBoxStringFunction() {
            vm.loadBoxString='';
            vm.loadTooltipString='';
            vm.loadArray.forEach(function (i, k) {
              if (i.type) {
                vm.loadBoxString = vm.loadBoxString + (vm.loadBoxString === '' ? '' : ', ') + i.type + ' x' + (i.count || 0);
                vm.loadTooltipString = vm.loadTooltipString + (vm.loadTooltipString === '' ? '' : '\n') + i.type + ' x' + (i.count || 0);
              }
            });
        }
        function closePanel(type){
           if(type=='close'){
            if(vm.type === 'currency'){
                vm.callback({status:'no'});
                $mdDialog.hide();
                return;
            }
                if(vm.type=='load_weight'){
                    vm.searchParam.load_data=vm.from;
                }
                if(vm.type=='load'){
                    vm.searchParam.load_data.load_details_value=vm.from;
                    vm.loadArray = util.getLoadArrayFromParam(vm.searchParam.load_data.load_details_value);
                    vm.loadBoxStringFunction();
                }
                if(vm.type=='location'){
                    if(vm.param==='origin'){
                        vm.searchParam.origin_location=vm.from;
                    }
                    else{
                        vm.searchParam.destination_location=vm.from;
                    }                      
                }
                vm.callback();
                $mdDialog.hide();

            }
        }

        function checkForSamePorts(param,ev){

            vm.validationObj={
                "originPortValidation":false,
                "destinationPortValidation":false
            }
            if ((vm.searchParam.origin_location && vm.searchParam.destination_location) && (vm.searchParam.origin_location.portcode_portname === vm.searchParam.destination_location.portcode_portname)) {
              vm.copyQuoteForm.$error.samePortError = true;
            } else if (vm.copyQuoteForm.$error.samePortError) {
              delete vm.copyQuoteForm.$error.samePortError;
            }
        }

          }
     
    })();
  

(function ()
{
    'use strict';

    angular
        .module('app.pages.exchangeRates')
        .controller('ExchangeRatesController', ExchangeRatesController);

    /** @ngInject */
    function ExchangeRatesController($timeout, captchaKey, $window, $document, loginSerivice, $stateParams, ExchangeRatesService,$state,util,$scope)
    {
      var vm = this;
      vm.captchaResponse = null;
      vm.isCaptchaSolved = false;
      vm.util = util;
      vm.isTokenPresent  = loginSerivice.isLogin();
      vm.dtOptions = {
        dom       : '<"top"lf>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        autoWidth : false,
        responsive: true,
        pageLength  : 1000
      };
      vm.showRates = false;
      vm.toggleSearch = toggleSearch;
      vm.currencyConversionApi = currencyConversionApi;
      vm.goToLogin = goToLogin;
      vm.exchangeRates = [];

      function init() {
        if(!$stateParams.isEfp){
            renderCaptcha();
        }
        else{
          callConversionRatesApi("")
        }
        if(!($stateParams.type && $stateParams.id && $stateParams.identity) && ($stateParams.type == 'Inquiry' && !$stateParams.activityid)){
            $state.go('app.pages_share_error');
        }
        if(!vm.isTokenPresent && !util.isWebView()){
            document.getElementById("inner-content").style.maxWidth = "100%";
            document.getElementById("inner-content").style.padding = "0";
            document.querySelectorAll("#toolbar-navigation-container")[0].style.display = 'none';
        }
    }

        function renderCaptcha() {
          if (!vm.isCaptchaSolved) {
              $timeout(function() {
                  var recaptchaElement = document.getElementById('exchangeRates');
                  if(recaptchaElement) {
                      grecaptcha.render(recaptchaElement, {
                          'sitekey': captchaKey,
                          'callback': onCaptchaSuccess,
                          'theme': 'light'
                      });
                  }
              }, 2000);
          }
        }
  


        function onCaptchaSuccess(token) {
              vm.captchaResponse = token;
              callConversionRatesApi(token);
        }

      function callConversionRatesApi(token){
        var data = {
          "type": $stateParams.type,
          "id": $stateParams.id,
          "identity": $stateParams.identity,
          "g-recaptcha-response": token,
          "activityId": $stateParams.activityid
        }
        if(!$stateParams.isEfp){
          ExchangeRatesService.conversionRatesApi(data,token).then(function(response){
            vm.exchangeRates = response.rates;
            vm.baseCurrency=response.baseCurrency;
            vm.syncedOn = response.syncedOn;
            vm.showRates = true;
            vm.isCaptchaSolved = true;
            $scope.$apply();
          },function(error){
            util.showToast(util.displayValidationError(error));
            vm.showRates = true;
            vm.isCaptchaSolved = false;
            $scope.$apply();
          });
        }else{
          ExchangeRatesService.efpConversionRatesApi(data).then(function(response){
            vm.exchangeRates = response.data.markedUpRoeData;
            vm.baseCurrency=response.data.searchCurrency;
            vm.syncedOn = response.data.syncedOn;
            vm.showRates = true;
            vm.isCaptchaSolved = true;
            $scope.$apply();
          },function(error){
            util.showToast(util.displayValidationError(error));
            vm.showRates = true;
            vm.isCaptchaSolved = false;
            $scope.$apply();
          });
        }
      }

      function toggleSearch(e){
        e.preventDefault();
        $("#ratesearchbar").toggleClass("collapsed");
      }

      function currencyConversionApi(){
        if (!vm.captchaResponse && !$stateParams.isEfp) {
          util.showToast('Please complete the CAPTCHA challenge.');
          return;
      }
        vm.currencySearch = '';
        vm.exchangeRates = [];
        vm.showRates = false;
        ExchangeRatesService.exchangeRatesApi(vm.baseCurrency).then(function(response){
          vm.exchangeRates = response.data.rates;
          vm.baseCurrency = response.data.baseCurrency;
          vm.syncedOn = response.data.syncedOn;
          vm.showRates = true;
        },function(error){
          vm.showRates = true;
          util.showToast(util.displayValidationError(error));
        });
      }

      function goToLogin(){
        $state.go('app.pages_auth_login-v2');
      }
      init();
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.unpaid-module-error', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_unpaid_module_error', {
            // url      : '/share-error',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_unpaid_module_error': {
                    templateUrl: 'app/main/pages/errors/unpaid-module-error/unpaid-module-error.html',
                    controller : 'UnpaidModuleErrorController as vm'
                }
            },
            bodyClass: 'unpaid-module-error'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.unpaid-module-error')
        .controller('UnpaidModuleErrorController', UnpaidModuleErrorController);

    /** @ngInject */
    function UnpaidModuleErrorController($state,util,$location, msNavigationService, localStorageService)
    {
        // Data
        var vm = this;
        vm.goBackHome = goBackHome;
        // Methods
        function goBackHome(){
            // if(util.isSharedPage()){
            //     $location.path('/login');
            // }
                msNavigationService.clearNavigation();
                util.getNavList(localStorageService.get('authToken').value.user_category);
                util.fnReDirectToHome();

                
            }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.share-error', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_share_error', {
            // url      : '/share-error',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_share_error': {
                    templateUrl: 'app/main/pages/errors/share-page-error/share-error.html',
                    controller : 'ShareErrorController as vm'
                }
            },
            bodyClass: 'share-error'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/errors/share-page-error');

        // // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors.error-500', {
        //     title : '500',
        //     state : 'app.pages_errors_error-500',
        //     weight: 2
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.share-error')
        .controller('ShareErrorController', ShareErrorController);

    /** @ngInject */
    function ShareErrorController($state,util,$location, msNavigationService, localStorageService)
    {
        // Data
        var vm = this;
        vm.goBackHome = goBackHome;
        // Methods
        function goBackHome(){
            if(util.isSharedPage()){
                $location.path('/login');
            }else{

                msNavigationService.clearNavigation();
                util.getNavList(localStorageService.get('authToken').value.user_category);
                util.fnReDirectToHome();
               
            }
        }
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-internet', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-internet', {
            // url      : '/pages/errors/error-internet',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-internet': {
                    templateUrl: 'app/main/pages/errors/internet/error-internet.html',
                    controller : 'ErrorInternetController as vm'
                }
            },
            bodyClass: 'error-internet'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-internet')
        .controller('ErrorInternetController', ErrorInternetController);

    /** @ngInject */
    function ErrorInternetController()
    {
        // Data
        var vm = this;
        vm.reload = reload;
        // Methods
        function reload(){
            location.reload();
        }
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
    .module('app.pages.error-internet')
    .controller('Error503Controller', Error503Controller);

    /** @ngInject */
    function Error503Controller($rootScope,$state,util,msNavigationService,localStorageService){
        // Data
        var vm = this;
        // Methods
        function init(){
            vm.message=$rootScope.message_503;
         }
         init();
         
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-internet')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller($state,util,msNavigationService,localStorageService)
    {
        // Data
        var vm = this;
        vm.refresh = refresh;
        vm.goBackHome = goBackHome;
        // Methods
        function refresh(){
            location.reload();
        }
        function goBackHome(){
            // $state.go('app.search');
            msNavigationService.clearNavigation();

            util.getNavList(localStorageService.get('authToken').value.user_category);
            util.fnReDirectToHome();
            // $state.go('app.'+util.state[0]);
        }
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller($state,util)
    {
        // Data
        var vm = this;
        vm.reload = reload;
        vm.goBackHome = goBackHome;
        // Methods
        function reload(){
            location.reload();
        }

        function goBackHome(){
            // $state.go('app.search');
            // $state.go('app.'+util.state[0]);
            util.fnReDirectToHome();
        }
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.sso-switch-account', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.sso-switch-account', {
            url      : '/sso-switch-account',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.sso-switch-account': {
                    templateUrl: 'app/main/pages/auth/sso-switch-account/sso-switch-account.html',
                    controller : 'SSOAccountController as vm'
                }
            },
            bodyClass: 'account'
        });
    }

})();
(function () {
    'use strict';
  
    angular
        .module('app.pages.auth.sso-switch-account')
        .controller('SSOAccountController', SSOAccountController);
  
    /** @ngInject */
    function SSOAccountController(localStorageService, $filter, $rootScope, $sce, iamUrl, util) {
      var vm = this;
      vm.util = util;
      vm.currentDomain = $rootScope.domainData.host_name;
    
      function init() {
        var authToken = localStorageService.get('authToken');
        var token = authToken && authToken.value ? authToken.value.access_token : '';
    
        var urlWithParam = iamUrl + '/account' + '?host=' + encodeURIComponent(iamUrl);
    
        var blobContent = [
          '<html><body><script>',
          'var xhr = new XMLHttpRequest();',
          'xhr.open(\'GET\', \'' + urlWithParam + '\', true);',
          'xhr.setRequestHeader(\'Authorization\', \'Bearer ' + token + '\');',
          'xhr.onload = function() { document.write(xhr.responseText); };',
          'xhr.send();',
          '</script></body></html>'
        ].join('');
    
        var blob = new Blob([blobContent], {type: 'text/html'});
        vm.iframeSrcForMultiDomainViaSSO = $sce.trustAsResourceUrl(URL.createObjectURL(blob));      
      }
      init();
    }
    
  })();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.signup', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.signup', {
            url      : '/signup',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.signup': {
                    templateUrl: 'app/main/pages/auth/signup/signup.html',
                    controller : 'SignupController as vm'
                }
            },
            bodyClass: 'signup'
        });
    }

})();

(function () {
  'use strict';

  angular
    .module('app.pages.auth.signup')
    .controller('SignupController', SignupController);

  /** @ngInject */
  function SignupController($rootScope, $interval, $scope, $state, $log, loginSerivice, $timeout, $window, $document, localStorageService, fcmService, util, captchaKey) {
    var vm = this;
    vm.util = util;
    util.isCallingApi = false;
    vm.signupError = '';
    vm.showPassword = false;
    vm.domainArray = ['ship.freightbro.com','devship.freightbro.com', 'qaship.freightbro.com','stagingship.freightbro.com'];
    vm.registerNow = registerNow;
    vm.submitRegisterForm = submitRegisterForm;
    vm.getDomainData = getDomainData;
    vm.showRegisterLoader = false;
    vm.signupSuccessHeading = '';
    vm.signupSuccessSuheading = '';
    vm.otpSignupSuccessHeading = '';
    vm.otpSignupSuccessSuheading = '';
    vm.captchaResponse = null;
    vm.isOtpRequired = false;
    vm.otp = '';
    vm.uuid = '';
    vm.otpError = '';
    vm.isSignupFormDisabled = false;
    vm.countryList = [];
    vm.isCountryLoading = false;
    vm.getCountries = getCountries;
    vm.getDomainData();
    vm.resendCooldown = 60; // Starting with 60 seconds cooldown
    vm.canResendOTP = false;
    vm.resendOTP = resendOTP;
    vm.renderCaptcha = renderCaptcha;
    vm.setResponse = setResponse;
    vm.resetCaptcha = resetCaptcha;
    vm.verifyOtp = verifyOtp;

    vm.getCountries();
    vm.renderCaptcha(); // init the captcha

    function renderCaptcha() {
      $timeout(function() {
          var recaptchaElement = $document[0].getElementById('recaptcha');
          if($window.grecaptcha && recaptchaElement) {
              $window.grecaptcha.render(recaptchaElement, {
                  'sitekey'  : captchaKey,
                  'callback' : function(response) {
                    vm.setResponse(response);
                  }
              });
          }
      }, 2000);
    }

    function setResponse(response) {
        vm.captchaResponse = response; // Store the captcha response
        vm.disableRegisterBtn = !response; // Enable the register button if there's a captcha response
    }

    function resetCaptcha() {
      if(vm.captchaWidgetId !== null && $window.grecaptcha) {
          $window.grecaptcha.reset(vm.captchaWidgetId);
      }
    }

    function getDomainData(){
        if(!Object.keys($rootScope.domainData.domain_info).length){
          vm.showRegisterLoader = true;
          util.getDomainData().then(function(){
            vm.showRegisterLoader = false;
            vm.registrationConfig = $rootScope.domainData.domain_info["REGISTRATION_FIELDS"];
            checkModuleAccess();
          },function(error){
              vm.showRegisterLoader = false;
              $log.log(error.data);
          });
        }else{
          vm.registrationConfig = $rootScope.domainData.domain_info["REGISTRATION_FIELDS"];
          checkModuleAccess();
        }
    }

    // Function to get countries list from API
    function getCountries() {
      vm.isCountryLoading = true;
      util.getCountries().then(function(response) {
        vm.isCountryLoading = false;
        if (response && response.data && response.data.data && response.data.data.countries) {
          vm.countryList = response.data.data.countries;
        }
      }, function(error) {
        vm.isCountryLoading = false;
        $log.log('Error fetching countries:', error);
      });
    }

    function checkModuleAccess(){
      if(!$rootScope.domainData.domain_info.REGISTRATION_ENABLED){
        $state.go('app.pages_share_error');
      }
    }

    function registerNow() {
      vm.registerToggle = true;
      vm.disableResetBtn = false;
      vm.showResetBtnLoader = false;
      vm.successSubmit = false;
      vm.signupError = '';
      vm.registerFrm = {
        'user_first_name': '',
        'user_last_name': '',
        'user_mobile': '',
        'user_mobile_code': '',
        'user_mobile_country': '',
        'email': '',
        'company_name': '',
        'IEC_code': '',
        'country': ''
      };
    }

    function verifyOtp() {
      var otpData = {
          uuid: vm.uuid,
          otp: vm.otp
      };
      util.isCallingApi = true;
      loginSerivice.verifyOtp(otpData).then(function (res) {
          vm.isSignupFormDisabled = true; 
          vm.isOtpRequired = true;
          util.isCallingApi = false;
          vm.successSubmit = true;
          vm.otpSignupSuccessHeading = res.data.data.heading;
          vm.otpSignupSuccessSuheading = res.data.data.text;
      }, function (error) {
          util.isCallingApi = false;
          vm.otpError = error.data.message;
          $log.log(error);
      });
    }

    function resendOTP() {
      if (!vm.canResendOTP) return; // Prevent action if cooldown is active
      
      var resentOTP = {
        uuid: vm.uuid,
        type: "resend"
      };
      
      loginSerivice.verifyOtp(resentOTP).then(function() {
        util.showToast('OTP resent to your inbox successfully.');
        vm.otpError = ''; // Clear any previous error
        vm.canResendOTP = false; // Disable resend button
        startCooldown(); // Start cooldown timer
      }, function(error) {
        // Handle error, display in the same field as OTP verification errors
        vm.otpError = error.data.message;
      });
    }

    function activateOtpForm() {
      vm.isOtpRequired = true;
      startCooldown(); // Immediately start the cooldown timer
  }

    // Function to start and handle the cooldown timer
    function startCooldown() {
      vm.canResendOTP = false;
  
      var currentCooldown = vm.resendCooldown || 60;
      
      var cooldownInterval = $interval(function() {
          currentCooldown -= 1;
          vm.resendCooldown = currentCooldown; // Update the displayed cooldown time
  
          if (currentCooldown <= 0) {
              $interval.cancel(cooldownInterval);
              // Here we double the cooldown time for the next resend attempt
              vm.resendCooldown *= 2; 
              vm.canResendOTP = true; // Re-enable the resend button after the cooldown
          }
      }, 1000); // Update the cooldown every second
  
      currentCooldown = vm.resendCooldown;
  }
  

    function submitRegisterForm(userData, registerFrm) {
      if(vm.registrationConfig.mobile.required){
        registerFrm.user_mobile.$touched = true;
      }
      if(!registerFrm.$valid){
        return;
      }
      if (!userData.IEC_code && vm.registrationConfig.iec_number.required) {
        util.showToast('Enter valid Exporter Reference ID');
        return;
      } else if (!userData.user_mobile && vm.registrationConfig.mobile.required) {
        util.showToast('Enter valid phone number');
        return;
      }

      var data = {
        'data': {
          'user_first_name': userData.user_first_name,
          'user_last_name': userData.user_last_name,
          'mobile': userData.user_mobile,
          'mobile_country_code': userData.mobile_country_code,
          'mobile_country_iso_code': userData.mobile_country_iso_code,
          'email': userData.email,
          'company_name': userData.company_name,
          'iec_number': userData.IEC_code,
          'country': userData.country,
          'captchaResponse': vm.captchaResponse
        }
      };

      util.isCallingApi = true;
      vm.disableRegisterBtn = true;
      loginSerivice.registerUser(data).then(function (res) {
        util.isCallingApi = false;
        vm.disableRegisterBtn = true;
        vm.uuid = res.data.data.uuid;
        vm.signupSuccessHeading = res.data.data.heading;
        vm.signupSuccessSuheading = res.data.data.text;
        vm.successSubmit = false;
        activateOtpForm();
      }, function (error) {
        util.isCallingApi = false;
        vm.disableRegisterBtn = false;
        vm.signupError = error.data.message;
        vm.resetCaptcha();
        $log.log(error);
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.pages.auth.login-v2')
    .controller('LoginV2Controller', LoginV2Controller);

  /** @ngInject */
  function LoginV2Controller($rootScope, LoginData, $location, $scope, $state, $log, loginSerivice, localStorageService, fcmService, util, $window, msNavigationService, $timeout, analytics, $mdDialog, mixPanelToken, resetService, msUtils, $document, captchaKey, clientId, clientId2) {
    util.isCallingApi = false;
    var vm = this;
    vm.util = util;
    vm.invalidLoginCount=0;  
    vm.otpTitle='Log in';

    // Data
    vm.form = {
      email: '',
      password: '',
      otp: ''
    };

    vm.loginError = {
      error: '',
      message: ''
    };

    vm.resetEmail = '';
    vm.reset = {
      message: ''
    };

    vm.resetError = {
      message: ''
    };

    vm.signupError = '';

    vm.showPassword = false;
    vm.forgotToggle = resetService.resetPassoward;
    vm.headerMessage = 'Recover your password';
    vm.sentEmail = false;
    vm.loginbtndisabled = false;
    vm.mobileOperatingSystem = null;
    vm.accountToggle = loginSerivice.loginOtp;

    vm.activeScreen = 'login-pass';  // default value to display login with username & password screen

    vm.loginOtpError = false;
    vm.validateOtpError = false;
    vm.loginOtpErrorMsg = vm.loginOtpErrorMsg;
    vm.inputType = 'email';
    vm.otp_secret = '';
    vm.email_otp_secret = '';
    vm.domainArray = ['ship.freightbro.com','devship.freightbro.com', 'qaship.freightbro.com','stagingship.freightbro.com'];
    vm.getOtpForm = {};

    // Methods
    vm.resetPasswordError = resetPasswordError;
    vm.togglePassword = togglePassword;
    vm.resetLink = resetLink;
    vm.resetForm = resetForm;
    vm.clearError = clearError;
    vm.redirectAfterLogin = redirectAfterLogin;
    vm.showQrCode = showQrCode;
    vm.checkTypeInput = checkTypeInput;


    // new login flow related function declaration
    vm.initAccess = initAccess;
    vm.switchScreen = switchScreen;
    vm.getOTP = getOTP;
    vm.resendOTP = resendOTP;
    vm.inputValidate = inputValidate;
    vm.otpValidate = otpValidate;
    vm.loginUsingUUID =  loginUsingUUID;
    vm.loginUniqueDomain = loginUniqueDomain;
    vm.loginMultiDomain = loginMultiDomain;
    vm.callLogin = callLogin;
    vm.init = init;
    vm.forgotPassword = forgotPassword;
    $mdDialog.hide();
    vm.getDomainData = getDomainData;
    vm.showRegisterLoader = false;
    vm.getDomainData();

    vm.captchaResponse = null;
    vm.renderCaptcha = renderCaptcha;
    vm.setResponse = setResponse;
    vm.resetCaptcha = resetCaptcha;
    vm.enbledEmailOtp = false;
    vm.verifyEmail = verifyEmail;
    vm.enforce_otp_for_login= $rootScope.domainData.domain_info["ENFORCE_OTP_FOR_LOGIN"]; //key to enable OTP based login  feature
 
    function init() {
      receiveResponseFromIAM();
        if( document.getElementById('userName')){
          document.getElementById('userName').focus();
        }
      vm.mobileOperatingSystem = (navigator.appVersion.indexOf("iPhone") != -1) ? 'iPhone' : 'Android';
      vm.renderCaptcha();
      if(loginSerivice.reset_password){
        vm.headerMessage = 'Your password has been expired';
        vm.reset.message = 'We have e-mailed your password reset link!';
        vm.forgotToggle = true;
        vm.sentEmail = true;
        vm.loginbtndisabled = false;
        loginSerivice.reset_password = false;
      }
    }

    vm.handleSSOButtonClick = function() {
      var stateObj = {
        clientId: $rootScope.domainData.domain_info.FREIGHTIFY_CLIENT_ID,
        redirectUri: $rootScope.domainData.domain_info.CURRENT_CALLBACK_DOMAIN
      };
      var stateStr = encodeURIComponent(JSON.stringify(stateObj));
    
      var url = $rootScope.domainData.domain_info.AUTH_ENDPOINT + 
                '?response_type=code&client_id=' + $rootScope.domainData.domain_info.VENDOR_CLIENT_ID + 
                '&redirect_uri=' + $rootScope.domainData.domain_info.REDIRECT_URI + 
                '&scope=' + $rootScope.domainData.domain_info.SSO_SCOPE + 
                '&state=' + stateStr;
      window.location.href = util.sanitizeQueryParams(url);
    };
      

    function receiveResponseFromIAM() {
      var fragment = $location.hash();
      if (fragment) {
        var params = new URLSearchParams("?" + fragment);
        var encodedResponse = params.get("response");
        if (encodedResponse) {
          var decodedResponse = atob(encodedResponse);
          try {
            var response = JSON.parse(decodedResponse);
            localStorageService.set("authToken", response);
            util.getNavList(localStorageService.get('authToken').value.user_category);
            if ($rootScope.domainData && $rootScope.domainData.domain_info && $rootScope.domainData.domain_info.SHOW_LOGIN_OPTIONS) {
              $state.go('app.account');
            } else {
              var sanitizeTitle = util.escapeHtml(document.title);
              var loginPath = util.isEpEnabled ? '/search' : '/rates';
              window.history.replaceState({}, sanitizeTitle,loginPath );
              window.location.reload();
            }
          } catch (e) {
            console.error("Error parsing response: ", e);
          }
        }
      }
    }

    function getDomainData(){
      if(!Object.keys($rootScope.domainData.domain_info).length){
        vm.showRegisterLoader = true;
        util.getDomainData().then(function(){
          vm.showRegisterLoader = false;
          vm.registrationConfig = $rootScope.domainData.domain_info["REGISTRATION_FIELDS"];
          vm.enforce_otp_for_login= $rootScope.domainData.domain_info["ENFORCE_OTP_FOR_LOGIN"];
        },function(error){
            vm.showRegisterLoader = false;
            $log.log(error.data);
        });
      }else{
        vm.registrationConfig = $rootScope.domainData.domain_info["REGISTRATION_FIELDS"];
        vm.enforce_otp_for_login= $rootScope.domainData.domain_info["ENFORCE_OTP_FOR_LOGIN"];
      }
    }

    function initAccess(){
      if(LoginData){
        if(LoginData.auth_token.reset_password){
          loginSerivice.reset_password = LoginData.auth_token.reset_password;
          $state.go('app.pages_auth_login-v2');
        }else { vm.loginUsingUUID(); }
      }else{
        $state.go('app.pages_auth_login-v2'); // redirecting login page
      }
    }

    function getRecaptchaConfig() {
      return {
        headers: {
          'g-recaptcha-response': vm.captchaResponse
        }
      };
    }

    //////////

    function inputValidate(username) {
      // var mobilePattern = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/i;
      

      if(username == '' || username == null) {
        vm.loginOtpError = true;
        document.querySelector('#userName').focus();
        vm.loginOtpErrorMsg = 'Input field is required';
      }

        if(vm.inputType === 'email' && !vm.util.emailRegex.test(String(username).toLowerCase())) {
          vm.loginOtpError = true;
          document.querySelector('#userName').focus();
          vm.loginOtpErrorMsg = 'Email must be a valid e-mail address';
        }


    }

    function otpValidate(otp) {
      if(otp == '' || otp == null) {
        vm.validateOtpError = true;
        document.querySelector('#otp').focus();
        vm.validateOtpErrorMsg = 'Otp is required';
      }

    }

    /**
     * login
     */
    function loginUniqueDomain(inputName) {
      // vm.form.email = $sanitize(vm.form.username);
      var username =  (inputName === 'username_password') ? vm.form.username :  vm.getOtpForm.username ;
      vm.inputValidate(username);

      if(inputName == 'username_otp'){
        vm.otpValidate(vm.submitLoginOtpForm.otp);
      }
      // switch case for payload
      var payload = null;
      switch (inputName) {
        case 'username_otp':
          payload =
          {
            'client_id': clientId,
            'username': vm.getOtpForm.username,
            'otp': vm.submitLoginOtpForm.otp,
            'otp_secret': vm.otp_secret,
            'grant_type':'otp',
            'scope':'',
            'source':'PLATFORM'
          };
          break;

        case 'username_password':
          payload =
          {
            'client_id': clientId,
            'username': vm.form.username,
            'password': vm.form.password,
            'otp': vm.enforce_otp_for_login ? vm.form.otp : '',
            'otp_secret': vm.enforce_otp_for_login ? vm.email_otp_secret : '',
            'grant_type':'password',
            'scope':'',
            'source':'PLATFORM'
          };
          break;

          case 'email_otp':
            payload =
            {
              'client_id': clientId2,
              'username': vm.getOtpForm.username,
              'otp': vm.submitLoginOtpForm.otp,
              'otp_secret': vm.otp_secret,
              'grant_type':'otp',
              'scope':'',
              'source':'PLATFORM'
            };
            break;

            case 'mobile_otp':
              payload =
              {
                'client_id': clientId2,
                'username': vm.getOtpForm.username,
                'otp': vm.submitLoginOtpForm.otp,
                'otp_secret': vm.otp_secret,
                'grant_type':'otp',
                'scope':'',
                'source':'PLATFORM'
              };
              break;
      }

      vm.loginbtndisabled = true;
      var captchaConfig = !vm.enforce_otp_for_login && $rootScope.domainData.domain_info.PLATFORM_CAPTCHA && $rootScope.domainData.domain_info.PLATFORM_CAPTCHA.otp_login_captcha ? getRecaptchaConfig() : '';
      return loginSerivice.loginUniqueDomain(payload, captchaConfig).then(function (response) {
        localStorageService.remove('authToken'); // removing the auth token in local storage.
        localStorageService.remove('currencyList');
        localStorageService.remove('erpIntegrationList');
        util.createMenuList = [];
        util.navPermission = [];
        if(response.data.reset_password){
          vm.headerMessage = 'Your password has been expired';
          vm.reset.message = 'We have e-mailed your password reset link!';
          vm.forgotToggle = true;
          vm.sentEmail = true;
          vm.loginbtndisabled = false;
          return;
        }
        //alias & identify are used to identify same user using different browsers or platforms to login.
        localStorageService.set('authToken', response.data); // setting the auth token in local storage.
        util.solution_type = response.data.SOLUTION_TYPE;
        util.callerpIntegrationApi();
        $timeout(function () {
          fcmService.callFcmToken('login');

          util.getCurrencyList().then(function (response) {
            vm.currencyList = util.currencyList;
          }, function (error) {
            vm.currencyList = [];
            $log.log(error);
          });

          msNavigationService.clearNavigation();

          util.getNavList(localStorageService.get('authToken').value.user_category);

          //mixPanel
          util.checkUserExit('fromLogin', mixPanelToken).then(function (response) {
            vm.redirectAfterLogin();
          }, function (error) {
            $log.log(error);
            vm.redirectAfterLogin();
          });

        }, 30);
      }, function (error) {
        vm.loginbtndisabled = false;
        if (!angular.isUndefined(error)) {
          if (error.data.hasOwnProperty('available_domins') && error.data.available_domins.length > 0) {
            $window.location.href = util.sanitizeQueryParams('https://' + error.data.available_domins[0]);
          }
          $log.log(error);
          vm.loginError.error = error.data ? error.data.error : 'Something went wrong!';
          vm.loginError.message = error.data ? error.data.message : 'Something went wrong!';
          // vm.invalidLoginCount++;
          // if(vm.invalidLoginCount>3 && inputName === 'username_password'){
          //   vm.switchScreen('request-otp','invalidLoginWithOtp');
          // }
        }
        vm.resetCaptcha();
      });
    }

    function checkTypeInput(element , id) {
      if(/^[0-9+() -]+$/.test(element)) {
        vm.inputType = 'mobile';
        $timeout(function(){

         document.getElementById('userMobile').focus();
         vm.form.username = element; 


        });

      } else
      {
       vm.inputType = 'email';
        $timeout(function(){         
           document.getElementById('userName').focus();

        });

      }
    }

    function showQrCode() {
      var substring = '.freightbro.com';
      if (util.sanitizeQueryParams($window.location.href).indexOf(substring) !== -1) {
        return true;
      } else {
        return false;
      }
    }


    function redirectAfterLogin() {
      if ($rootScope.redirectUrl != undefined && $rootScope.redirectUrl != null) {
        var stateArrObj = $state.get();
        stateArrObj.some(function (value, key) {
          if (value.abstract || !(value.url)) {
            return;
          }
          var url = $rootScope.redirectUrl;
          var patt = new RegExp(value.url);
          var match = patt.test(url);
          if (match) {
            $log.log('Matched state: ' + value.name + ' and parameters: ', value, match);
            $location.path($rootScope.redirectUrl);
            return true;
          }
          else if (stateArrObj.length == key + 1) {
            if (util.state.includes('search')) {
              $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
            } else if (util.state.includes('track-n-trace')) {
              $state.go('app.track-n-trace');
            } else {
              $state.go('app.' + util.state[0]);
            }
          }
        });
      } else {

        if (util.state.includes('search')) {
          $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
        } else if (util.state.includes('track-n-trace')) {
          $state.go('app.track-n-trace');
        } else {
          $state.go('app.' + util.state[0]);
        }
      }
    }


    function resetPasswordError(type) {
      vm.loginError = {
        error: '',
        message: ''
      };
      vm.inputType = type==='otp' ? 'email' : vm.inputType;
    }

    function togglePassword() {
      if (vm.showPassword === false) {
        vm.showPassword = true;
      } else {
        vm.showPassword = false;
      }
    }

    function resetForm() {
      vm.renderCaptcha();
      vm.forgotToggle = false;
      vm.sentEmail = false;
      vm.reset.message = '';
      vm.resetEmail = '';
    }

    function resetLink(resetForm) {
      if(!resetForm.$valid){
        return;
      }
      vm.disableResetBtn = true;
      vm.showResetBtnLoader = true;
   
      var payload = {
        email: vm.resetEmail
      };

      loginSerivice.resetEmail(payload, getRecaptchaConfig()).then(function (response) {
        if (response.data.status === 'success') {
          vm.reset.message = response.data.message;
          vm.sentEmail = true;
          vm.showResetBtnLoader = false;
        }
      }, function (error) {
        vm.disableResetBtn = false;
        vm.showResetBtnLoader = false;
        $log.log(error);
        vm.resetError.message = error.data.message;
        vm.resetCaptcha();
      });
    }

    function clearError() {
      vm.resetError = {
        message: ''
      };
    }

    // New Login FLow Function starts from here

    /**
     * Function to switch between auth screen
     * @param {*} screen_name
     */
    function switchScreen(screen_name,inputType) {
      vm.invalidLoginCount=0;
      vm.otpTitle='Log in';    
      vm.resetPasswordError();
      if(screen_name !== 'login-otp'){
        vm.getOtpForm.username = '';
        vm.form.username = '';
        vm.form.password = '';
      }
      vm.activeScreen = screen_name;
      if(inputType=='invalidLoginWithOtp'){
        vm.otpTitle='Try';
      }
      vm.renderCaptcha();
    }

    /**
     * function to get the OTP aginast user email or phone numbar
     * @param {*} payload
     */
    function getOTP(otpForm){
      vm.submitLoginOtpForm={
        otp:""
      }
      if(!otpForm.$valid){
        return;
      }
      vm.inputValidate(vm.getOtpForm.username);
      var countryData = '';
      vm.loginbtndisabled = true;
      // call the otp API here and store the OTP secret which will be used  while logged as per flow
      loginSerivice.getOTP(vm.inputType, vm.getOtpForm.username, countryData.dialCode, getRecaptchaConfig()).then(function(response){
        vm.switchScreen('login-otp');
        vm.otp_secret = response.data.otp_secret;
        util.showToast(response.message);
        vm.loginbtndisabled = false;
      },function(error){
        vm.loginbtndisabled = false;
        $log.error(error);
        vm.loginError.message = error.data.message;
        vm.resetCaptcha();
      });
    }

    /**
     * submitLoginWithOTP
     * @param {*} payload
     */

    function loginMultiDomain(inputName){

      var username =  (inputName === 'username_password') ? vm.form.username :  vm.getOtpForm.username ;
      vm.inputValidate(username);

      if(inputName == 'username_otp'){
        vm.otpValidate(vm.submitLoginOtpForm.otp);
        inputName = (vm.inputType === 'mobile') ? 'mobile_otp' : 'email_otp';
      }

      // vm.submitLoginOtpForm.otp = $sanitize(vm.submitLoginOtpForm.otp);
      var payload = null;
      switch (inputName) {

        case 'username_password':
          payload =
          {
            'client_id': clientId,
            'username': vm.form.username,
            'password': vm.form.password,
            'otp': vm.enforce_otp_for_login ? vm.form.otp : '',
            'otp_secret': vm.enforce_otp_for_login ? vm.email_otp_secret : '',
            'grant_type':'password',
            'scope':'',
            'source':'PLATFORM'
          };
          break;

        case 'email_otp':
          payload =
          {
            'client_id': clientId,
            'email': vm.getOtpForm.username,
            'grant_type':'otp',
            'otp': vm.submitLoginOtpForm.otp,
            'otp_secret': vm.otp_secret,
            'scope':'',
            'source':'PLATFORM'
          };
          break;

        case 'mobile_otp':
          payload =
          {
            'client_id': clientId,
            'user_mobile': vm.getOtpForm.username,
            'grant_type':'otp',
            'otp': vm.submitLoginOtpForm.otp,
            'otp_secret': vm.otp_secret,
            'scope':'',
            'source':'PLATFORM'
          };
          break;
      }
      vm.loginbtndisabled = true;
      var captchaConfig = !vm.enforce_otp_for_login && $rootScope.domainData.domain_info.PLATFORM_CAPTCHA.otp_login_captcha ? getRecaptchaConfig() : '';
      return loginSerivice.loginMultiDomain(payload, captchaConfig).then(function (response) {
        localStorageService.set('accountList', response.data.data); // setting accountList in localstorage
        if(response.data.data.length){
          $state.go('app.account');
        }else{
          vm.loginUniqueDomain(inputName);
        }
      },function(error){
        vm.loginbtndisabled = false;
        $log.error(error);
        vm.loginError.error = error.data ? error.data.error : 'Something went wrong!';
        vm.loginError.message = error.data ? error.data.message : 'Something went wrong!';
        // vm.invalidLoginCount++;
        // if(vm.invalidLoginCount>3 && inputName === 'username_password'){
        //   vm.switchScreen('request-otp','invalidLoginWithOtp');
        // }
        vm.resetCaptcha();
      });
    }

    function resendOTP() {
      vm.checkIsRequired = false;
      vm.submitLoginOtpForm={
        otp:""
      }
      vm.validateOtpError = false;
      vm.loginError.error ='';
      vm.loginError.message = '';
      loginSerivice.resendOTP(vm.otp_secret).then(function (response) {
        vm.submitLoginOTP();
        util.showToast(response.message);
      }, function (error) {
        $log.error(error);
        util.showToast(error.data.message);
      });
    }

    function loginUsingUUID(){
      util.createMenuList = [];
      util.navPermission = [];
      localStorageService.remove('authToken'); // removing the auth token in local storage.
      localStorageService.remove('currencyList');
      //alias & identify are used to identify same user using different browsers or platforms to login.
      localStorageService.set('authToken', LoginData.auth_token); // setting the auth token in local storage.
      localStorageService.set('accountList', LoginData.available_domains); // setting accountList in localstorage

      // $timeout(function () {
        fcmService.callFcmToken('login');

        util.getCurrencyList().then(function (response) {
          vm.currencyList = util.currencyList;
        }, function (error) {
          vm.currencyList = [];
          $log.log(error);
        });

        msNavigationService.clearNavigation();

        util.getNavList(localStorageService.get('authToken').value.user_category);

        //mixPanel
        util.checkUserExit('fromLogin', mixPanelToken).then(function (response) {
          vm.redirectAfterLogin();
        }, function (error) {
          $log.log(error);
          vm.redirectAfterLogin();
        });

      // }, 30);
    }

    function callLogin(screenName,loginForm) {
      if(!vm.enbledEmailOtp && vm.enforce_otp_for_login){
        vm.verifyEmail(loginForm);
      }else{
        vm.checkIsRequired = true;
        if(screenName == 'username_otp' && !vm.submitLoginOtpForm.otp){
          return;
        }
        if(!loginForm.$valid){
          return;
        }
        if($rootScope.domainData.domain_info["SHOW_LOGIN_OPTIONS"]){
          vm.loginMultiDomain(screenName);
        }
        else {
          vm.loginUniqueDomain(screenName);
        }
      }
    }

    function forgotPassword(){
      vm.renderCaptcha();
      vm.resetPasswordError();
      vm.forgotToggle = true;
      vm.headerMessage = 'Recover your password';
      vm.disableResetBtn = false;
      vm.showResetBtnLoader = false;
      vm.resetError.message='';
      vm.resetEmail='';
      vm.form.username = '';
      vm.form.password = '';
      vm.form.otp = '';
    }

    function renderCaptcha() {
      $timeout(function() {
          var recaptchaElement = $document[0].getElementById('recaptcha');
          if ($window.grecaptcha && recaptchaElement && !recaptchaElement.hasChildNodes()) {
              $window.grecaptcha.render(recaptchaElement, {
                  'sitekey'  : captchaKey,
                  'callback' : function(response) {
                    vm.setResponse(response);
                  }
              });
          }
      }, 2000);
    }

    function setResponse(response) {
      vm.captchaResponse = response;
      vm.disableRegisterBtn = !response;
    }

    function resetCaptcha() {
      if(vm.captchaWidgetId !== null && $window.grecaptcha) {
          $window.grecaptcha.reset(vm.captchaWidgetId);
      }
    } 

    function verifyEmail(loginForm) {
      if(!loginForm.email.$invalid && !loginForm.password.$invalid){
        vm.sendOtpDisabled = true;
        loginSerivice.verifyEmailApi(vm.form.username, getRecaptchaConfig()).then(function (response) {
          util.showToast(response.data.message);
          vm.email_otp_secret = response.data.data.otp_secret;
          vm.enbledEmailOtp = true;
          vm.sendOtpDisabled = false;
          }, function (error) {
            $log.log(error);
            vm.sendOtpDisabled = false;
            util.showToast(error.data.message);
            vm.resetCaptcha();
        });
      }
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(resetService, $log, util, $location, $timeout,$state,analytics,$rootScope,localStorageService,$window)
    {
        var vm = this;
        // Data
        vm.form = {
            email : resetService.email,
            password : '',
            passwordConfirm: ''
        };

        vm.resetError = {
          message : ''
        };

        vm.reset = {
          message: ''
        };

        vm.resetPassword = resetPassword;
        vm.passwordChange = false;
        vm.clearError = clearError;
        vm.showPassword = false;
        vm.showCurrentPassword = false;
        vm.togglePassword = togglePassword;
        vm.goBackToLogin = goBackToLogin;
        vm.showPassErr = showPassErr;
        vm.validatePassword = validatePassword;
        vm.showQrCode = showQrCode;
        vm.currentState = $state.current.name;
        vm.util=util;

        // Methods
        function resetPassword(resetForm) {
          if(!resetForm.$valid){
            return;
          }
          if(vm.form.password !== vm.form.passwordConfirm) {
            util.showToast('Passwords do not match!');
            return;
          }
          vm.disableSubmit = true;
          var data = {
            "email": vm.form.email,
            "token": resetService.token,
            "password": vm.form.password,
            "password_confirmation": vm.form.passwordConfirm
          }

          resetService.reset(data).then(function(response) {
              if(response.data.status === 'success') {
                  vm.reset.message = response.data.message;
                  vm.passwordChange = true;
                  $timeout(function () {
                    localStorageService.remove('authToken'); // removing the auth token in local storage.
                    $location.path('/login');
                  }, 2000);
              }
              vm.disableSubmit = false;
              //mixpanel code
                if(vm.showCurrentPassword == 'app.pages_auth_reset-password'){
                    analytics.track("Password Reset",{
                        "Forwarder Name": $rootScope.domainData.domain_info.domain_title,
                        "Product category": $rootScope.domainData.domain_info.PLAN_TYPE=='ELITE' ? 'WLS' : 'NWLS',
                        "User Email": vm.form.email
                    });
                }else{
                    analytics.track("Account Activated",{
                        "Forwarder Name": $rootScope.domainData.domain_info.domain_title,
                        "Product category": $rootScope.domainData.domain_info.PLAN_TYPE=='ELITE' ? 'WLS' : 'NWLS',
                        "User Email": vm.form.email
                    });
                }
          },function(error) {
              vm.disableSubmit = false;
              $log.log(error);
              vm.resetError.message = error.data.message;
          });
        }

        function clearError() {
            vm.resetError = {
              message : ''
            };
        }

        function togglePassword(input_name){
            if(input_name === 'password'){
                vm.showPassword = vm.showPassword === false ? true : false;
            }
            if(input_name === 'current_password'){
                vm.showCurrentPassword = vm.showCurrentPassword === false ? true : false;
            }
        }

        function goBackToLogin(){
            resetService.resetPassoward = true;
            localStorageService.remove('authToken'); // removing the auth token in local storage.
            $state.go('app.pages_auth_login-v2');
        }

        function showPassErr(type){
          document.getElementById('message').style.display = type === 'focus' ? 'block' : 'none';
        }

        function validatePassword(){
            var myInput = document.getElementById('reset_pwd');
            var special = document.getElementById('special');
            var number = document.getElementById('number');
            var length = document.getElementById('length');

            // Validate capital letters
            var upperCaseLetters = /[!@#\$%\^&\*]/g;
            if(myInput.value.match(upperCaseLetters)) {
                special.classList.remove('passInvalid');
                special.classList.add('passValid');
            } else {
                special.classList.remove('passValid');
                special.classList.add('passInvalid');
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if(myInput.value.match(numbers)) {
                number.classList.remove('passInvalid');
                number.classList.add('passValid');
            } else {
                number.classList.remove('passValid');
                number.classList.add('passInvalid');
            }

            // Validate length
            if(myInput.value.length >= 8) {
                length.classList.remove('passInvalid');
                length.classList.add('passValid');
            } else {
                length.classList.remove('passValid');
                length.classList.add('passInvalid');
            }
        }

        function showQrCode() {
          var substring = '.freightbro.com';
          if (util.sanitizeQueryParams($window.location.href).indexOf(substring) !== -1) {
            return true;
          } else {
            return false;
          }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.account', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.account', {
            url      : '/account',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.account': {
                    templateUrl: 'app/main/pages/auth/account/account.html',
                    controller : 'AccountController as vm'
                }
            },
            bodyClass: 'account'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.account')
        .controller('AccountController', AccountController);

    /** @ngInject */
    function AccountController(localStorageService, $filter,$rootScope, util)
    {
      var vm = this;
      vm.util = util;

      vm.currentDomain =  $rootScope.domainData.host_name;

      var account_list  = localStorageService.get('accountList');
      if(account_list !=  null && !!account_list.value){
        vm.accountList = account_list.value;
        vm.otherAccountArray = $filter('filter')(vm.accountList, { is_authenticated : false});
      }

    }
})();
(function () {
  'use strict';

  angular
  .module('app.core')
  .component('portTravellerUi', {
      templateUrl: 'app/main/Inquiry/components/portTravellerUi/portTravellerUi.html',
      bindings : {
        details : '<',
      },
      controller: PortTravellerUiController
  });

  function PortTravellerUiController(util) {
    var vm = this;
    vm.util = util;

    this.$onInit = function() {

      vm.portDetails = {
        "mode" : vm.details.mode,
        "origin_port" : {
          "global_port_code": vm.details.origin_location.location,
          "pickup_pincode_ui":vm.details.origin_location.pin_code_ui,
          "city" : vm.details.origin_location.city,
          "portname" : vm.details.origin_location.portname,
          "country" : vm.details.origin_location.country
        },
        "destination_port" : {
          "global_port_code": vm.details.destination_location.location,
          "delivery_pincode_ui":vm.details.destination_location.pin_code_ui,
          "city" :  vm.details.destination_location.city,
          "portname" : vm.details.destination_location.portname,
          "country" : vm.details.destination_location.country
        }
      }
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.inquiry', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.inquiry', {
            url      : '/inquiry',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/Inquiry/inquiry.html',
                    controller : 'InquiryController as vm'
                }
            },
            // resolve: {
               
            // },
            bodyClass: 'inquiry-management'
        })

        .state('app.inquiry.inquiryDetails', {
            url  : '/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Inquiry/inquiryDetails/inquiryDetails.html',
                    controller : 'InquiryDetailsController as vm'
                },
                data : { pageTitle: 'Inquiry-Detail' }
            },
            resolve: {
                InquiryDetailsData: function ($stateParams,InquiryService){
                    return InquiryService.getInquiryDetails($stateParams.id);
                }
            },
            bodyClass: 'Inquiry-Details'
        })
        .state('app.inquiry.webViewInquiryDetails', {
            url  : '/web_view/:id',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.inquiry.webViewInquiryDetails': {
                    templateUrl: 'app/main/Inquiry/inquiryDetails/inquiryDetails.html',
                    controller : 'InquiryDetailsController as vm'
                },
                data : { pageTitle: 'Inquiry-Detail' }
            },
            resolve: {
                InquiryDetailsData: function ($stateParams,InquiryService){
                    return InquiryService.getInquiryDetails($stateParams.id);
                }
            },
            bodyClass: 'Inquiry-Details'
        });

        // msNavigationServiceProvider.saveItem('fuse.inquiry', {
        //     title    : 'Inquiry',
        //     icon     : 'icon-file-find',
        //     state    : 'app.inquiry',
        //     // translate: 'UPLOADRATES.UPLOADRATES_NAV',
        //     weight   : 1
        // });


    }

})();

(function () {
  'use strict';

  angular
    .module('app.inquiry')
    .component('inquiryMetaComponent', {
      templateUrl: 'app/main/Inquiry/components/inquiry-meta/inquiryMeta.html',
      bindings: {
        metadetail: '=',
        searchParam:'=',
        callback: '&'
      },
      controller: function InquiryMetaController(util,$filter,$rootScope) {

        var vm = this;

        // Variables
        vm.util = util;
        vm.today = new Date();
        vm.isViewMoreExpanded = false;
        vm.IMCO_CodeList = util.imcoCodeList();

        // Functions
        vm.toggleViewMore = toggleViewMore;
        vm.formContainerType = formContainerType;
        vm.getDomainData = getDomainData;
        vm.originPorts = [];
        vm.destinationPorts = [];

        this.$onInit = function() {

          vm.getDomainData();
          vm.formContainerType(vm.metadetail.search_data.mode, vm.metadetail.search_data.load_data);

          vm.originPorts = util.getSearchParamOrigin(vm.searchParam);
          vm.destinationPorts = util.getSearchParamDestination(vm.searchParam);

          
          vm.hazardousImco = null;
          if(vm.metadetail.search_data.imco_code){
           var selectedImco = $filter('filter')(vm.IMCO_CodeList, { 'class_number': vm.metadetail.search_data.imco_code }, true);
           vm.hazardousImco = selectedImco[0];
          }
        }

        function getDomainData(){
          if(!Object.keys($rootScope.domainData.domain_info).length){
            util.getDomainData().then(function(){
              vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
            },function(error){
                $log.log(error.data);
            });
          }else{
              vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
          }
        }


        function toggleViewMore() {
          if (vm.isViewMoreExpanded) {
            vm.isViewMoreExpanded = false;
          } else {
            vm.isViewMoreExpanded = true;
          }
          angular.element('#view-more-div').slideToggle();
        }


        // @param {*} loadDetails
        function formContainerType(mode, loadDetails){
          var result = '';
          if(loadDetails != null){
              if(mode == 'SEA-FCL'){
                  result =  util.formLoadDetails(loadDetails);
                  vm.loadDispaly = result;
                  vm.loadTooltip = vm.loadDispaly;
              }
              else if(mode != 'SEA-FCL'){
                  result =  util.formAirLoadDetails(loadDetails, mode);
                  vm.loadDispaly = result;
                  vm.loadTooltip = vm.loadDispaly.split("| ").join("</br>");
              }
          }
      }

      vm.fnGetColorByStatusName = fnGetColorByStatusName;
      function fnGetColorByStatusName(color){
        var statusColor = {
          'color' : color,
          'background-color': color+ '30',
        };
        return statusColor;
      }

      }
    });

})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .component('inquiryFilter', {
        templateUrl: 'app/main/Inquiry/components/inquiry-filter/inquiryFilter.html',
        bindings : {
          filterobj: '=',
          inquiryData: '<',
          callback: '&',
          isLoadComponent: '<'
        },
        controller: function inquiryFilterController(InquiryService,util,$log,$rootScope,$mdSidenav,$scope,$filter,$timeout) {
            var vm = this;
            vm.util = util;
            //vm.updateSearch = updateSearch;
            //vm.fnSubmitFilter = fnSubmitFilter;
            vm.resetFilter = resetFilter;
            //vm.users_list_selected = [];
            //vm.customer_list_selected = [];
            //vm.company_list_selected = [];
            //vm.getListBySearch = getListBySearch;
            //vm.maxDate = new Date();
            vm.toggleSidenav = toggleSidenav;
            vm.setDatePicker = setDatePicker;
            vm.collapseDiv = collapseDiv;
            //$scope.pickerModel = { dateStart: null};
            //vm.clearDatePicker = clearDatePicker;
            //vm.filterItemExists = filterItemExists;
            vm.filterItemtoggle = filterItemtoggle;
            vm.resizeScreenSize = resizeScreenSize;
            vm.fnTrackAnalytics = fnTrackAnalytics;
            vm.fnGetFilterList = fnGetFilterList
            vm.callBackCreatedBy = callBackCreatedBy;
            vm.callBackCustomer = callBackCustomer;
            vm.callBackIncoTerms = callBackIncoTerms;
            vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED;
            vm.filterListObject = {
              'status': null,
              'mode' : null,
              'date_range' : null,
              'created_by' : null,
              'customer_details' : null,
              'incoterms' : null,
              'integrations' : null
            }
            vm.filterLoader = true;
            function resizeScreenSize() {
              vm.inquiryData.deviceName = util.resizeScreen(vm.inquiryData.deviceName);
            }
            window.onresize = vm.resizeScreenSize;


            // banner listner
            var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
                calculateMaxHeight();
            });
            $scope.$on('$destroy', bannerListener);

            // Init function
            this.$onInit = function() {
                vm.createdByFilterConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.inquiryData.createdBySelected,
                  'placeholder': 'Search users',
                  'isGroupOptions' : true,
                  'groupList' : {'internal_user':{groupTitle:'Internal Users',keyTitle:'first_name',subKeyTitle:'email'},'customer_user':{groupTitle:'Customers',keyTitle:'first_name',subKeyTitle:'email'}},
                  'selectedCount' : 0
                }
                vm.customerFilterConditions = {
                  'listLoader':false,
                  'selectedOptions': vm.inquiryData.customerSelected,
                  'placeholder': 'Search Customer Details',
                  'isGroupOptions' : true,
                  'groupList' : {'user':{groupTitle:'User Name',keyTitle:'first_name',subKeyTitle:'email'},'company':{groupTitle:'Customer Company',keyTitle:'name',subKeyTitle:''}},
                  'selectedCount' : 0
              }
              vm.incoTermsFilterConditions = {
                'listLoader':false,
                'selectedOptions': vm.inquiryData.incoTermsSelected,
                'placeholder': 'Search Incoterms',
                'isGroupOptions' : false,
                'groupList' : {groupTitle:'',keyTitle:'code',subKeyTitle:'description'},
                'selectedCount' : 0,
                'isUpperCase' : true,
                'mixpanelPageSource':'IL'

            }
                vm.fnGetFilterList(null);
                vm.resizeScreenSize();
                /*
                InquiryService.getUsersListForFilter('inquiry_filter').then(function (response) {
                  vm.users_list_unselected = response.data.FORWARDER;
                  vm.users_copy = angular.copy(response.data);
                  vm.customer_list_unselected = response.data.SHIPPER;
                  vm.company_list_unselected = response.data.SHIPPERCOMPANY;
                  calculateMaxHeight();
                }, function (error) {
                  util.showToast(util.displayValidationError(error));
                  $log.error(error);
                  calculateMaxHeight();
                });*/
            };

            vm.$onChanges = function() {
              if(vm.isLoadComponent){
                vm.resetFilter();
              }
            }
            function calculateMaxHeight(){
              vm.maxFilterHeight = util.getModuleMaxHeight(vm.inquiryData.maxHeight,'inquiryFilter',-45)
            }

            // stop event propogartion
            /*function updateSearch(e){
                e.stopPropagation();
            }

            // Submit filter
            function fnSubmitFilter() {
              analytics.track("Inq-filter-Apply ", {
              });
              var modesList = [];
              angular.forEach(vm.filterobj.mode,function(value){
                if(value.selected){
                  modesList.push(value.mode);
                }
              });
              InquiryService.filterParams = {
                'users' : vm.filterobj.users,
                'customer' : vm.filterobj.customer,
                'customer_company' : vm.filterobj.customer_company,
                'mode' : modesList,
                'search' : InquiryService.filterParams.search,
                'start_date' : $scope.pickerModel.dateStart,
                'end_date' : $scope.pickerModel.dateEnd
              };
              vm.callback();
              vm.resizeScreenSize();
              if(vm.filterobj.deviceName !== 'laptop'){
                vm.toggleSidenav('right');
              }
            }*/

            // Reset filter
            function resetFilter(){
              vm.inquiryData.isResetFilter = true;
              vm.inquiryData.customerSelected = [];
              vm.inquiryData.createdBySelected = [];
              vm.inquiryData.incoTermsSelected = [];
              this.$onInit();
              $rootScope.$broadcast('resetFilter', { any: '' });
              //if(!vm.isLoadComponent){
                vm.callback();
              //}
              
               /*
              angular.forEach(vm.filterobj.mode,function(value){
                value.selected = false;
              });
              vm.users_list_selected = [];
              vm.customer_list_selected = [];
              vm.company_list_selected = [];
              vm.filterobj = {
                'status': '',
                'users' : '',
                'customer' : '',
                'customer_company' : '',
                'mode' : vm.filterobj.mode,
                'start_date' : null,
                'end_date' : null
              }
              $scope.pickerModel = { dateStart: null};
              InquiryService.filterParams = {
                'status' : '',
                'users' : '',
                'customer' : '',
                'customer_company' : '',
                'mode' : '',
                'search' : vm.filterobj.mode,
                'start_date' : null,
                'end_date' : null
              };
              $rootScope.$broadcast('emptyInquirySearchBox', { any: '' });
              vm.callback();
              vm.resizeScreenSize();
              if(vm.filterobj.deviceName !== 'laptop'){
                vm.toggleSidenav('right');
              }*/
            }
            //it's used for god users when change user accounts
            // initialise datepicker
            function setDatePicker(data) {
              vm.filterobj.date_range={};
              vm.filterobj.date_range.from = $filter('date')(data.start_date, 'yyyy-MM-dd');
              vm.filterobj.date_range.to =  $filter('date')(data.end_date, 'yyyy-MM-dd');
              vm.callback();
              vm.resizeScreenSize();
            }

            // clear date
            /*function clearDatePicker() {
              vm.filterobj.start_date = null;
              vm.filterobj.end_date = null;
              $scope.pickerModel = { dateStart: null };
            }

            // function to get users list by search text
            function getListBySearch(searchText,type,selected_list){
              vm.listLoader = true;
              InquiryService.getUsersListForFilter('inquiry_filter',type,searchText).then(function (response) {
                if(type == 'FORWARDER'){
                  analytics.track("Inq-filter-Sales-Team-User-Search", {
                    "value": searchText
                  });
                  vm.users_list_unselected = response.data.FORWARDER;
                  vm.listLoader = false;
                  angular.forEach(selected_list, function (item) {
                    var isPresent = vm.users_list_unselected.some(function (el) { return el.id === item.id; });
                    if(!isPresent) { vm.users_list_unselected.unshift(item); }
                  });
                }
                if(type == 'SHIPPER'){
                  analytics.track("Inq-filter-Customer-Search", {
                    "value": searchText
                  });
                  vm.customer_list_unselected = response.data.SHIPPER;
                  vm.listLoader = false;
                  angular.forEach(selected_list, function (item) {
                    var isPresent = vm.customer_list_unselected.some(function (el) { return el.id === item.id; });
                    if(!isPresent) { vm.customer_list_unselected.unshift(item); }
                  });
                }
                if(type == 'SHIPPERCOMPANY'){
                  analytics.track("Inq-filter-Customer-Company-Search", {
                    "value": searchText
                  });
                  vm.company_list_unselected = response.data.SHIPPERCOMPANY;
                  vm.listLoader = false;
                  angular.forEach(selected_list, function (item) {
                    var isPresent = vm.company_list_unselected.some(function (el) { return el.id === item.id; });
                    if(!isPresent) { vm.company_list_unselected.unshift(item); }
                  });
                }
              }, function (error) {
                vm.listLoader = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
              });
            }*/

            // Sidenav taggle function
            function toggleSidenav(sidenavId) {
              $mdSidenav(sidenavId).toggle();
            }

            // function to expand and collapse div
            function collapseDiv(id, e){
              return;
              angular.element('#'+id).slideToggle();
            }

            // function to bind the value during callback
            function filterItemtoggle(item, list, entity, type) {
              if(!type) {
                if (!list[entity]) {
                  list[entity] = [];
                }
                var idx = list[entity].indexOf(item);
                if (idx > -1) {
                  list[entity].splice(idx, 1);
                } else {
                  list[entity].push(item);
                }
              }
              else {
                vm.filterobj.status = [item.status];
              }
              vm.callback();
              vm.resizeScreenSize();
            };
            // function to check if the value exists and toggle the checkbox
            /*function filterItemExists(item, list, entity, type) {
              
              if(!type) {
                if (!list[entity]) {
                  return;
                }
                return list[entity].indexOf(item) > -1;
              }
              else {
                if( !!vm.filterobj.status ){
                  return  vm.filterobj.status.status  === item.status ? true : false;
                }
                return false;
              }

            }*/

            function fnTrackAnalytics(event,params) {
              if(!params){
                params={};
              }
              util.callMixpanel(event,params);              
            }

             function fnGetFilterList(queryParam){
                InquiryService.getFilterList(queryParam).then(function (response) {
                  if(queryParam === null){ // it's on Init filter list
                    vm.filterListObject.status = response.data.data.status.data;
                    vm.filterListObject.mode = response.data.data.mode.data;
                    vm.filterListObject.date_range = vm.filterobj.date_range;
                    vm.filterListObject.created_by = response.data.data.created_by.data;
                    if(!util.isShipper){ // shipper users not access this module 
                      vm.filterListObject.customer_details = response.data.data.customer_details.data;
                      vm.filterListObject.incoterms = response.data.data.incoterms.data;
                      vm.filterListObject.integrations = response.data.data.integrations.data;
                    }
                  }else{ // it's on search query parameter filter list;
                    vm.filterListObject[queryParam.query_source] = response.data.data[queryParam.query_source].data;
                    var mixedPanelEvent = queryParam.query_source === "created_by" ? "Inq-filter-Created-By-Search" :
                     "Inq-filter-Customer-Details-Search";
                  }
                  vm.filterLoader = false;
                  vm.customerFilterConditions.filterLoader = false;
                  vm.createdByFilterConditions.filterLoader = false;
                  vm.incoTermsFilterConditions.filterLoader = false;
                  $timeout(function () {
                    calculateMaxHeight();
                  });
                }, function (error) {
                  vm.filterLoader = false;
                  vm.customerFilterConditions.filterLoader = false;
                  vm.createdByFilterConditions.filterLoader = false;
                  vm.incoTermsFilterConditions.filterLoader = false;
                  vm.inquiryParam.isResetFilter = false;
                  util.showToast(util.displayValidationError(error));
                  $log.error(error);
                  calculateMaxHeight();
                });
             } 

            function callBackCreatedBy(payload){
              if(payload.searchText || payload.searchText === ''){ // search result 
                  var queryParam = payload.searchText !== '' ? {'query_source' : "created_by",'query' : payload.searchText
                    } : null;
                  vm.createdByFilterConditions.filterLoader = true;
                  vm.fnGetFilterList(queryParam);
              }
              angular.forEach(vm.filterobj.created_by.data,function(item,key){
                vm.filterobj.created_by.data[key] = [];
              }); 
              if(payload.selectedOptions){ // selected options
                if(vm.createdByFilterConditions.selectedCount !== 0){
                  vm.inquiryData.createdBySelected = payload.selectedOptions;
                  angular.forEach(payload.selectedOptions,function(item, key){
                    if(key === 0){ 
                      vm.filterobj.created_by.data[item.groupType] = [] 
                    }
                    vm.filterobj.created_by.data[item.groupType].push({id:item.id})
                  });
                }else{
                  angular.forEach(vm.filterobj.created_by.data,function(item,key){
                    vm.filterobj.created_by.data[key] = [];
                  }); 
                }
                vm.callback();
                vm.resizeScreenSize();
              }
            }

            function callBackCustomer(payload){
              if(payload.searchText || payload.searchText === ''){ // search result 
                var queryParam = payload.searchText !== '' ? {'query_source' : "customer_details",'query' : payload.searchText
                    } : null;
                  
                  vm.customerFilterConditions.filterLoader = true;
                  vm.fnGetFilterList(queryParam);
              }

              if(payload.selectedOptions){ // selected options
                if(vm.customerFilterConditions.selectedCount !== 0){
                  vm.inquiryData.customerSelected = payload.selectedOptions;
                  vm.filterobj.customer_details.data['user'] = [];
                  vm.filterobj.customer_details.data['company'] = [];
                  angular.forEach(payload.selectedOptions,function(item,key){
                    vm.filterobj.customer_details.data[item.groupType].push({id:item.id})
                  });
                }else{
                  angular.forEach(vm.filterobj.customer_details.data,function(item,key){
                    vm.filterobj.customer_details.data[key] = [];
                  }); 
                }
                vm.callback();
                vm.resizeScreenSize();
              }
            }

            function callBackIncoTerms(payload){
              if(payload.searchText || payload.searchText === ''){ // search result 
                var queryParam = payload.searchText !== '' ? {'query_source' : "incoterms",'query' : payload.searchText} : null;
                vm.incoTermsFilterConditions.filterLoader = true;
                vm.fnGetFilterList(queryParam);
              }
    
              if(payload.selectedOptions){ // selected options
                vm.filterobj.incoterms = [];
                if(vm.incoTermsFilterConditions.selectedCount !== 0){
                  vm.inquiryData.incoTermsSelected = payload.selectedOptions;
                  angular.forEach(payload.selectedOptions,function(option){
                    vm.filterobj.incoterms.push(option.code)
                  })
                }
                vm.callback();
                //vm.resizeScreenSize();
              }
            }

        }

      });

})();

(function () {
    'use strict';

    angular
    .module('app.core')
    .component('inquiryCardView', {
        templateUrl: 'app/main/Inquiry/components/inquiry-card/inquiryCard.html',
        bindings : {
            islastactivity : '=',
            searchparam :'=',
            carddata : '=',
            resultfilter : '=',
            activitytype : '=',
            inquiryid : '=',
            pricingiscopy : '=',
            activityId: '=',
            inquiryactivityid: '=',
            co2eResponse : '=',
            callback : '&'
        },
        controller: InquiryCardController
    })
    .component('newCardView', {
      templateUrl: 'app/main/Inquiry/components/inquiry-card/new-card.html',
      bindings : {
          islastactivity : '=',
          searchparam :'=',
          carddata : '=',
          resultfilter : '=',
          inquiryid : '=',
          co2eResponse : '=',
          callback : '&'
      },
      controller: InquiryCardController
    });


    function InquiryCardController($scope, util, SearchService,$attrs, $mdDialog, $rootScope, $filter, localStorageService, $timeout, $mdToast, $mdMedia, $state, InquiryService, QuotesService, resultService, shareQuoteService,api,$log, $interval,constObj) {
        var vm = this;

        vm.util = util;
        vm.constObj = constObj;

        // vm.showContractId=$rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES;
        vm.shareQuoteService = shareQuoteService;
        vm.today = new Date();
        vm.title="";
        vm.ifExpireCross = false;
        vm.isAddNewRateLoaded=false;
        vm.currencyList = util.currencyList;
        vm.currentState = $state.current.name;
        vm.user_category = localStorageService.get('authToken').value.user_category;
        vm.statusCondition = InquiryService.statusCondition;
        vm.footerObj = { 
          "doneBtnDisable" : false,
          "buyTotalWithConv" : 0,
          "buyTotalBaseCurr" : 0,
          "sellTotalBaseCurr" : 0,
          "profit" : 0,
          "rateExpired":false
        }
        vm.sourceRate={};
        vm.pageSource='';
        vm.remarksInclusionCkEditorConfig = angular.copy(util.ckEditorConfig);
        vm.remarksInclusionCkEditorConfig.removeButtons = util.TnCRemoveButtons;

        vm.screenIsSmall = $mdMedia('xs');
        vm.fnTrackAnalytics = fnTrackAnalytics;
        vm.viewDetailsModal = viewDetailsModal;
        vm.afterShowAnimation = afterShowAnimation;
        vm.rateTabView = rateTabView;
        vm.scheduleTabView = scheduleTabView;
        vm.quotationTabView = quotationTabView;
        vm.rateTotalCustomCurr = rateTotalCustomCurr;
        vm.setCurrentSchedule = setCurrentSchedule;
        vm.selectedSchedule = selectedSchedule;
        vm.getCardRemarksInclusion= getCardRemarksInclusion;
        vm.fnSwitchPages= fnSwitchPages;
        vm.fnAddLeg = fnAddLeg;
        vm.fnAddNewCharge = fnAddNewCharge;
        vm.confirmDeleteLeg = confirmDeleteLeg;
        vm.fnDeleteLeg= fnDeleteLeg;
        vm.confirmDeleteCharge = confirmDeleteCharge;
        vm.closeToast= closeToast;
        vm.fnDeleteNewCharge= fnDeleteNewCharge;
        vm.getMatches = getMatches;
        vm.changeSelectedLeg= changeSelectedLeg;
        vm.getChargeList = getChargeList;
        vm.pushToquoteArray = pushToquoteArray;
        vm.removeCard= removeCard;
        vm.requestToBook = requestToBook;
        vm.fnChangeBasis = fnChangeBasis;
        vm.conversionOnPriceChange = conversionOnPriceChange;
        vm.conversionOnLegCurrencyChange = conversionOnLegCurrencyChange;
        vm.fnGetBuyChargeCurrency = fnGetBuyChargeCurrency;
        vm.fnGetBuyMinAmount = fnGetBuyMinAmount;
        vm.fnGetBuyUnitPrice = fnGetBuyUnitPrice;
        vm.fnGetBuyChargeLegCurrencyCost = fnGetBuyChargeLegCurrencyCost;
        vm.changeSelectedCharge = changeSelectedCharge;
        vm.changeTextCharge = changeTextCharge;
        vm.cancelDialog = cancelDialog;
        vm.openDeleteCard = openDeleteCard;
        vm.openEditCardModal = openEditCardModal;
        vm.isLegLoadMissing = isLegLoadMissing;
        vm.legPerUnitCost = legPerUnitCost;
        vm.loadMoreRecords= loadMoreRecords;
        vm.fnCardStructure = fnCardStructure;
        vm.fngetSubVendorDetails = fngetSubVendorDetails;
        vm.fnGetLinerList = fnGetLinerList;
        vm.fnGetAirlineList = fnGetAirlineList;
        vm.getAdditionalLeg = getAdditionalLeg;
        vm.calculateQtyRange = calculateQtyRange;
        vm.showAsterix = showAsterix;
        vm.getPort = util.getPorts;
        vm.termsTabView = termsTabView;
        vm.remarksTabView = remarksTabView;

        vm.fnAddOrEditCard = fnAddOrEditCard;
        vm.mainFreightNameChange = $rootScope.isJeenaDomain;
        vm.mainFreightName = 'Main Freight';
        vm.getSubvendor = [];
        vm.isShared = util.isSharedQuote();
        vm.openDatePicker = false;
        vm.fnDisplayProfit = fnDisplayProfit;
        vm.getConvFeeCost = getConvFeeCost;
        vm.showConvLoader = false;
        vm.expMaxDate = new Date();

        vm.checkPercentageBasis = checkPercentageBasis;
        vm.deleteFreightBasisCharge = deleteFreightBasisCharge;
        vm.showDeleteBasisCharge = showDeleteBasisCharge;
        vm.addInQuote = addInQuote;
        vm.airScheduleTabView = airScheduleTabView;
        vm.getChargeCost = getChargeCost;
        vm.removeCardFromQuote = removeCardFromQuote;
        vm.cancelDeleteCard = cancelDeleteCard;
        vm.undoDeleteCard = undoDeleteCard;
        vm.fnUndoChanges = fnUndoChanges;
        vm.fnGetContainerQty = fnGetContainerQty;
        vm.getWidgetHeight = getWidgetHeight;
        vm.fnCheckIsNaN = fnCheckIsNaN;
        vm.isString = isString;
        vm.basisArray = [shareQuoteService.airBasisName, shareQuoteService.pickupBasisName, shareQuoteService.deliveryBasisName ,shareQuoteService.freightBasisName];
        vm.fnGetCurrencyconversion = fnGetCurrencyconversion;
        vm.fnDefaultCharge = fnDefaultCharge;
        vm.fclSlab=[];
        vm.showQuoteProceedDiv = showQuoteProceedDiv;
        vm.downloadSourceRate = downloadSourceRate;
        vm.freeDaysTabView = freeDaysTabView;
        vm.isFreeDaysEdit = false;
        vm.loadWiseFreeDaysList = [];
        vm.selectMultiSchedule = selectMultiSchedule;
        vm.fnScheduleOldData = fnScheduleOldData;
        vm.fnClearAllSchedule = fnClearAllSchedule;
        vm.fnCopyID=fnCopyID;
        vm.all_in_quote = 'default';
        vm.$onInit = function() {
            vm.search_param = angular.copy(vm.searchparam);
            vm.searchUser = vm.search_param.user;
            vm.pricingiscopy = vm.pricingiscopy ? vm.pricingiscopy : false;

            vm.modeName = (vm.search_param.mode == 'SEA-FCL') ? '_fcl' : ((vm.search_param.mode == 'AIR') ? '_air' : '_lcl' );
            vm.buyOrSell = 'sell_rates'; //!util.isShipper ? 'sell_rates' : 'buy_rates';
            vm.l3_leg = vm.search_param.mode == 'SEA-FCL' ? 'l3_fcl' : (vm.search_param.mode == 'AIR' ? 'l3_air' : 'l3_lcl' );
            vm.leg_mode = (vm.search_param.mode == 'SEA-FCL') ? '_fcl' : ((vm.search_param.mode == 'AIR') ? '_air' : '_lcl' );
            vm.l1_leg = 'l1'+vm.leg_mode;
            vm.l2_leg = 'l2'+vm.leg_mode;
            vm.l2_leg_cha = 'l2'+vm.leg_mode+'_cha';
            vm.l4_leg = 'l4'+vm.leg_mode;
            vm.l4_leg_cha = 'l4'+vm.leg_mode+'_cha';
            vm.l5_leg = 'l5'+vm.leg_mode;
            vm.ins_leg = 'ins'+vm.leg_mode;
            vm.pageInfo={
              "pageId": vm.inquiryid._id,
              "pageType":'Inquiry',
              "activityId": vm.activityId,
              "activityListId": vm.inquiryactivityid
            }

            vm.ifExpireCross = false;

            if(!vm.quoteNewCardInit){
              vm.fnCardStructure();
            }
            //  Storing old data into new key - Free days #DEV-10379
            if(vm.carddata && vm.search_param.mode != 'AIR' && !vm.carddata.data.buy_rates[vm.l3_leg].rate_obj.freeDays){
               vm.carddata.data.buy_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(vm.carddata.data.buy_rates[vm.l3_leg].rate_obj , vm.search_param);
               vm.carddata.data.sell_rates ? vm.carddata.data.sell_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(vm.carddata.data.sell_rates[vm.l3_leg].rate_obj , vm.search_param):null;
              }
              vm.showContractId = vm.carddata && vm.carddata.data.sell_rates[vm.l3_leg].rate_obj.show_contract_number;
        }

        $scope.$on("inquiryRefresh",function(){
            vm.$onInit();
        });

        function showAsterix(array) {
          var showAsterix = false;
          if(array) {
            Object.keys(array).some(function (key) {
              if (array[key].leg_code === 'additional_services') {
                array[key].rate_obj.charges.some(function (i) {
                  if (typeof i.charge_cost === 'string') {
                    showAsterix = true;
                    return true;
                  }
                });
              }
            });
          }
          return showAsterix;
        }
        function fnCopyID(copyedText){
          vm.isIdCopied = 'Copied!'
          var temp_input = $("<input>");
          $("body").append(temp_input);
          temp_input.id = 'tempCopyToClipboard';
          temp_input.val(copyedText).select();
          document.execCommand("copy");
          temp_input.remove();
          $timeout(function ()
          {
              vm.isIdCopied = 'Click to Copy';
          }, 1500);
        }

      function calculateQtyRange(charge, key) {
        var unit = charge.total_units;
        if (unit >= charge.slab[key].to) {
          return (charge.slab[key].to - (charge.slab[key - 1] ? charge.slab[key - 1].to : 0));
        } else if (unit >= charge.slab[key].from) {
          return (unit - charge.slab[key].from + 1);
        } else {
          return 0;
        }
      }

      function openViewDrtailFcl(ev) {
        vm.title="Details"
        setTimeout(function () {
          vm.scheduleDivHeight =  document.getElementsByClassName('rate-card-detail-modal')[0].offsetHeight;
        }, 100);
        vm.pageSource="Inquiry-ViewDetails";
        // ckeditor disable 
        if(!vm.quoteEdit){
          vm.remarksInclusionCkEditorConfig.readOnly =  true;
         }
        
        $mdDialog.show({
          templateUrl: (vm.l3_leg == 'l3_fcl') ? 'app/main/result/Dialogs/view-details/fclViewDetails.html' : 'app/main/result/Dialogs/view-details/airViewDetails.html',
          targetEvent: ev,
          clickOutsideToClose: false,
          onComplete: vm.afterShowAnimation,
          animation: false,
          controllerAs: 'ctrl',
          controller: function () { this.parent = vm },
          onRemoving: function (event, removePromise) {
            for (var name in CKEDITOR.instances) {
              CKEDITOR.instances[name].destroy();
            }
          }
        });
      }

        //open modal to view card details
        function viewDetailsModal(currCard, ev,activeTab, msrOrNetwork,index,actionType){
          currCard.meta.remarks = util.decodeValue(currCard.meta.remarks);
          currCard.meta.inclusions = util.decodeValue(currCard.meta.inclusions);
          currCard.meta.internal_remarks = util.decodeValue(currCard.meta.internal_remarks);
            //api call for source rate
            if(vm.util.isAdmin || vm.util.userProfile.user.is_pricing_user){
              downloadSourceRate(currCard);
            }


            if(!currCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data){
              currCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = [];
            }
            if(!currCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data){
              currCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data = [];
            }
            
            if( currCard.meta.shimmer){
              return true;
            }
            vm.footerObj.doneBtnDisable = false;
            vm.fromInquiry = $rootScope.domainData.domain_info.MAKE_RATES_GLOBAL_FROM_INQUIRY && util.userProfile.user.is_pricing_user;
            vm.inquiryPricing = util.userProfile.user.is_pricing_user ? true : false;
            vm.rem_open = true;
            vm.inl_open = true;
            vm.fclSlab = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab_charges;
            vm.activeTab = activeTab;

            // condition to show slab tab
            if(vm.search_param.mode == 'SEA-FCL' && (util.isAdmin || util.isFreightbro) ){
              vm.ratesVisible = vm.fclSlab && vm.fclSlab.length ? 1 : 0;
            }else{
              vm.ratesVisible = 0;
            }

             // vm.search_param.mode == "AIR" && currCard.data.sell_rates[vm.l3_leg].rate_obj.slab_rate && (util.isAdmin || util.isFreightbro) ? true : false;
            vm.airScheduleVisible = (vm.search_param.mode == 'AIR') ? true : false;
            vm.scheduleVisible = (vm.search_param.mode != 'AIR') ? true : false;
            vm.analyticsVisible = false;
            vm.quotationVisible = true;
            vm.termsVisible = !vm.maskLiner && currCard.meta.type.includes("spot") && (currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data || currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.url) ? true : false;
            
            vm.msrOrNetwork = msrOrNetwork;

            currCard.meta["isRateGlobal"] = currCard.meta["isRateGlobal"] ? currCard.meta["isRateGlobal"] : "No";

            if(!currCard.meta["make_rates_global"]){
              currCard.meta["make_rates_global"] = [];
              currCard.meta["isRateGlobal"] = "No";
            }

            // if(vm.activeTab != 'rates' && vm.activeTab != 'tnc'){
              
              vm.getDataSchedule = true;
              vm.getNetworkSchedule = true;
              vm.getIataSchedule = true;

              if( vm.activeTab == 'addNewQuote' || vm.activeTab == 'quotationEdit' || vm.activeTab == 'schedule'){
                vm.quoteEdit = true;
                currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry = currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry ? moment(currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry).format('YYYY-MM-DD') : null;
                vm.editBuyRate = true;
              }else{
                if(vm.inquiryPricing){
                  vm.quoteEdit = false;
                }else{
                  vm.quoteEdit = (vm.inquiryid.current_status.status != vm.statusCondition && vm.islastactivity) && vm.activitytype != 'BOOKING' ? true : false;
                }
                
                vm.editBuyRate = ( (!util.userProfile.user.is_pricing_user && (!vm.islastactivity || vm.inquiryid.current_status.status == vm.statusCondition)) || util.userProfile.user.is_pricing_user || vm.activitytype == 'BOOKING') ? false: true;
              }

              if((vm.activeTab == 'addNewQuote' || vm.activeTab == 'schedule') ){

                if( vm.search_param.mode != 'AIR' && !currCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id){
                  util.showToast("Please select liner name.");
                  return true;
                }else if( vm.search_param.mode == 'AIR' && !currCard.data.sell_rates[vm.l3_leg].rate_obj.airline_code){
                  util.showToast("Please select airline name.");
                  return true;
                }
                if(currCard.meta.type != 'msr_spot' && currCard.meta.type != 'network_spot' && !currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry){
                  util.showToast("Please select expiry date.");
                  return true;
                }

                // Origin port
                if(!currCard.meta.port_data.origin_port_code){
                  if(currCard.meta.port_data.is_icd_port_origin){
                    util.showToast("Please select valid Origin port.");
                  }else{
                    util.showToast("Please select valid loading port.");
                  }
                  return true;
                }

                // origin haulage validation
                if( vm.search_param.mode == 'SEA-FCL' && !vm.copyCard && currCard.meta.port_data.is_icd_port_origin && !currCard.meta.haulage ){
                  util.showToast("Please select Origin haulage.");
                  return true;
                }

                // pol validation
                if(!vm.copyCard && currCard.meta.port_data.is_icd_port_origin && !currCard.meta.via_pol ){
                  util.showToast("Please select valid loading port.");
                  return true;
                }

                // pod validation
                if(!vm.copyCard && currCard.meta.port_data.is_icd_port_destination && !currCard.meta.via_pod ){
                  util.showToast("Please select valid Discharge port.");
                  return true;
                }

                // destination haulage validation
                if(vm.search_param.mode == 'SEA-FCL' && !vm.copyCard && currCard.meta.port_data.is_icd_port_destination && !currCard.meta.destination_haulage ){
                  util.showToast("Please select Destination haulage.");
                  return true;
                }

                // Destination port
                if(!currCard.meta.port_data.destination_port_code){
                  if(currCard.meta.port_data.is_icd_port_destination){
                    util.showToast("Please select valid Destination port.");
                  }else{
                    util.showToast("Please select valid Discharge port.");
                  }
                  return true;
                }

                if(QuotesService.samePortValidation(currCard)){
                  return true;
                }

              } else if (vm.activeTab == 'quotationEdit'){
                vm.allowEditMainData = true;
              }
              
            if(activeTab == 'rates' && vm.ratesVisible){
              vm.selectedIndex = 0;
            }
            if(activeTab == 'schedule'){
              vm.selectedIndex = vm.ratesVisible;
            }
            if(activeTab == "quotationEdit" || activeTab == "addNewQuote" || activeTab == 'quotation' ){
              vm.selectedIndex = 1 + vm.ratesVisible + vm.analyticsVisible;
            }
            if(activeTab == 'tnc'){
              vm.selectedIndex = 1 + vm.ratesVisible + vm.analyticsVisible + (vm.quotationVisible ? 2 : 0);
            }


            var getCurrencyRate = null;

            getCurrencyRate = vm.resultfilter.currency_conversion_rates.find(function(element) {
              return ( element.vendor_id == currCard.meta.vendor_id );
            });

            shareQuoteService.currencyConverter = {}; //Reset currency converter setting

            if(!getCurrencyRate){
              vm.fnGetCurrencyconversion(vm.searchUser.user_base_currency,currCard.meta.vendor_id);
              currCard.meta.conversionRate = vm.currencyObj;
            }else{
              vm.currency_rates = getCurrencyRate.curr_data;
              currCard.meta.conversionRate = getCurrencyRate;
              // Currency conversion setting code
              shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency,getCurrencyRate.markup,getCurrencyRate.directCurrencyMapping,vm.currency_rates);
              vm.callingConversionApi = false;
            }

            vm.legSuggestionList = [];
            vm.quotationDetailsVisible = true;
            $rootScope.loadingDetails = true;
            vm.showData = true;
            if(vm.search_param.mode == 'AIR' && util.isShipper) {
              vm.displayRates = true;
            }
            else if(vm.search_param.mode != 'AIR' && util.isShipper){
              vm.displayRates = false;
            }
            vm.ScheduleCard = currCard;

            //Conveniance fee code
            vm.getConvFeeCost(currCard);

            vm.currentCard = angular.copy(currCard);

            getDataForExchangeRate();
            
            // Get Dim leg list
            vm.dimLegList = [];
            vm.dimLegList = shareQuoteService.fnGetDimLegs(vm.currentCard.data.buy_rates); 

            vm.footerObj.sellTotalBaseCurr = 0;
            vm.chargeShow = 5;

            if(vm.search_param.mode == 'SEA-FCL'){
              if (SearchService.loadTypeArr == undefined || SearchService.loadTypeArr.length == 0) {
                SearchService.getAllLoadList().then(function (response) {
                  SearchService.loadTypeArr = response;
                  vm.loadTypeArr = response;
                  util.limitObj = response;
                  openViewDrtailFcl(ev);
                }, function (error) {
                  $log.log(error.data);
                });
              } else {
                vm.loadTypeArr = SearchService.loadTypeArr != undefined ? SearchService.loadTypeArr : [];
                openViewDrtailFcl(ev);
              }
            }else{
              openViewDrtailFcl(ev);
            }
        }

        // call conversion rates api
        function fnGetCurrencyconversion(user_base_currency, vendor_id, action){
          vm.callingConversionApi = true;
          return resultService.getCurrencyConversionForVendor(user_base_currency, vendor_id,vm.search_param.mode,true).then(function(response){
            vm.currencyObj = response.data;
            vm.resultfilter.currency_conversion_rates.push(vm.currencyObj);
            vm.callingConversionApi = false;
            if(action == 'addNewCard'){
              vm.fnDefaultCharge();
            }
            vm.currency_rates = vm.currencyObj.curr_data;
            // Currency conversion setting code
            shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency,vm.currencyObj.markup,vm.currencyObj.directCurrencyMapping,vm.currency_rates)
          },function(error){
            // Currency conversion setting code
            shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency,null,[],vm.currency_rates);
            vm.callingConversionApi = false;
            $log.log(error.data);
            util.showToast(util.displayValidationError(error));
          });
        }

        function getDataForExchangeRate(){
          vm.resultId = vm.inquiryid._id;
          vm.cardVendorId = vm.currentCard.meta.vendor_id;
          vm.resultType = 'Inquiry';
          vm.showExchangeRates = vm.activityId && !vm.activityId.includes('cNew') && !vm.activityId.includes('-') ? $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES : false;
        }



        //Conveniance fee code
        function getConvFeeCost(currCard){
          if( vm.search_param.mode=='SEA-FCL' && currCard.meta.additional_charges){

            if (currCard.meta.additional_charges.url && !currCard.meta.additional_charges.data) {

              var total_cost = vm.rateTotalCustomCurr(currCard.data.buy_rates);
              vm.showConvLoader = true;
              vm.footerObj.doneBtnDisable = true;
              resultService.getConvFee(currCard,total_cost,SearchService.FclResult._id,currCard.data.buy_rates[vm.l3_leg].rate_obj.leg_total_currency).then(function(response){

                vm.fnDisplayProfit(); // calling dispay profit only in quotation tab
                vm.currentCard.meta.additional_charges = angular.copy(currCard.meta.additional_charges);
                vm.showConvLoader = false;
                vm.footerObj.doneBtnDisable = false;

              }, function(error){
                vm.showConvLoader = false;
                vm.footerObj.doneBtnDisable = false;
                $log.error(error);
              });

            }
          }
        }

        //Calculate Profit
        function fnDisplayProfit(){

          vm.footerObj.buyTotalWithConv = 0;
          vm.footerObj.buyTotalBaseCurr = vm.rateTotalCustomCurr(vm.currentCard.data.buy_rates);
          vm.footerObj.sellTotalBaseCurr = vm.rateTotalCustomCurr(vm.currentCard.data.sell_rates);
          // Add Conveinance fee if present
          if(vm.currentCard.meta.additional_charges && vm.currentCard.meta.additional_charges.data){
            vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr + parseFloat(vm.currentCard.meta.additional_charges.data.leg_total_cost);
          }else{
            vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr;
          }
          vm.footerObj.profit = util.getProfitValue(vm.footerObj.sellTotalBaseCurr, vm.footerObj.buyTotalWithConv);

        }

        function afterShowAnimation () {
            vm.showData = false;
            $rootScope.loadingDetails = false;
        }

        function rateTabView() {
          vm.legShow = 1;
          vm.showData = true;
          vm.chargeShow = 5;
          vm.viewActiveTab = 'rates';
          vm.rateDetails = vm.currentCard.data[vm.buyOrSell];

          // vm.interval = $interval(function(){
          //   vm.legShow++;
          //   if(vm.legShow == Object.keys(vm.rateDetails).length){
          //     $interval.cancel(vm.interval);
          //   }
          // }, 500);
          vm.showData = false;
        }

        function scheduleTabView(){
            vm.viewActiveTab = 'schedule';
            vm.getSchedule = false;
              if(!vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data.length){

                var l3_obj = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj;
                var cargo_date = $filter('date')(new Date(vm.search_param.cargo_ready_date), 'yyyy-MM-dd');

                vm.currentCard.meta.port_data.origin_portname = vm.currentCard.meta.port_data.origin_port_code && vm.currentCard.meta.port_data.origin_port_code["portname"] ? vm.currentCard.meta.port_data.origin_port_code["portname"] : vm.currentCard.meta.port_data.origin_portname;

                var origin = vm.currentCard.meta.port_data.origin_port_code && vm.currentCard.meta.port_data.origin_port_code["global_port_code"] ? vm.currentCard.meta.port_data.origin_port_code["global_port_code"] : vm.currentCard.meta.port_data.origin_port_code;

                var via_pol = vm.currentCard.meta.via_pol && vm.currentCard.meta.via_pol["global_port_code"] ? vm.currentCard.meta.via_pol["global_port_code"] : vm.currentCard.meta.via_pol;

                vm.currentCard.meta.port_data.destination_portname = vm.currentCard.meta.port_data.destination_port_code && vm.currentCard.meta.port_data.destination_port_code["portname"] ? vm.currentCard.meta.port_data.destination_port_code["portname"] : vm.currentCard.meta.port_data.destination_portname;

                var destination = vm.currentCard.meta.port_data.destination_port_code && vm.currentCard.meta.port_data.destination_port_code["global_port_code"] ? vm.currentCard.meta.port_data.destination_port_code["global_port_code"] : vm.currentCard.meta.port_data.destination_port_code;

                var via_pod = vm.currentCard.meta.via_pod && vm.currentCard.meta.via_pod["global_port_code"] ? vm.currentCard.meta.via_pod["global_port_code"] : vm.currentCard.meta.via_pod;

                var source = vm.search_param.mode === 'SEA-FCL' ? 'SEA_FCL' : 'SEA_LCL' ;

                vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.url = api.baseUrl + '/api/schedules?from_port='+origin+'&to_port='+destination+'&carrier_code='+l3_obj.sub_vendor.schedule_provider_code+'&from_date='+cargo_date+'&mode='+vm.search_param.mode+'&source='+source;

                if(via_pol){
                  vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.url += '&via_pol='+via_pol;
                }
                if(via_pod){
                  vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.url += '&via_pod='+via_pod;
                }

                vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.url = angular.copy(vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.url);

                return QuotesService.getScheduleList(vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.url).then(function (response) {

                  vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data = angular.copy(response);
                  vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = angular.copy(response);

                  vm.ScheduleCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data = angular.copy(response);
                  vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = angular.copy(response);

                  vm.scheduleList = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data;
                  vm.currentCard.meta.schedulefromAPi = true;
                  vm.currentCard.meta.isScheduleApiCall = true;
                  var selectedSchedule = null;
                  if(resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
                    // var selectedScheduleIndex = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(vm.currentCard, vm.l3_leg) : 0;
                    vm.currentCard.meta.selected_schedule = vm.scheduleList.length ? angular.copy(vm.scheduleList[0]) : null;
                  }else{
                    angular.forEach(response, function(item){
                      if(!selectedSchedule){
                        selectedSchedule = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
                       }
                    });
                  }
                  vm.current_schedule = vm.currentCard.meta.selected_schedule ? angular.copy(vm.currentCard.meta.selected_schedule) : selectedSchedule;
                  vm.getSchedule = true;
                  if(vm.current_schedule !== null && resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
                    vm.selectedSchedule(vm.current_schedule, 'fromNewSchedule');
                  }
                  vm.fnScheduleOldData();
                }, function (error) {
                  vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data = [];
                  vm.getSchedule = true;
                  $log.log(error);
                });
              }else{
                vm.scheduleList = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data;
                var selectedSchedule = null;
                if(resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
                  // var selectedScheduleIndex = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(vm.currentCard, vm.l3_leg) : 0;
                  vm.currentCard.meta.selected_schedule = vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule : (vm.scheduleList.length ? vm.scheduleList[0] : null);
                }else{
                  angular.forEach(vm.scheduleList, function(item){
                    if(!selectedSchedule){
                      selectedSchedule = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
                      }
                  });
                } 
                vm.current_schedule = vm.currentCard.meta.selected_schedule ? angular.copy(vm.currentCard.meta.selected_schedule) : selectedSchedule;
                vm.getSchedule = true;
                vm.fnScheduleOldData('fromExisting');
              }
            if((util.isShipper || (vm.islastactivity && util.userProfile.user.is_pricing_user && !vm.currentCard.meta.isScheduleApiCall)) && vm.scheduleList.length){
              vm.scheduleList = [];
              if(vm.current_schedule !== null){
                vm.scheduleList.push(vm.current_schedule);
              }
            }

            if(vm.current_schedule != null && vm.current_schedule.departure_time > vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry){
                vm.ifExpireCross = true;
            }else{
                vm.ifExpireCross = false;
            }

        }

        function quotationTabView(){
            vm.legShow = 1;
            vm.showData = true;
            vm.chargeShow = 3;
            vm.viewActiveTab = 'quotation';
            vm.showChargesInfo = false;

            angular.forEach(vm.currentCard.data.buy_rates, function (value, key) {
              if(!value.rate_obj){
                  delete vm.currentCard.data.buy_rates[key];
              }
            });

            if ((vm.activeTab == 'quotation' || ( vm.activeTab == 'rates') ) && !vm.currentCard.data.sell_rates) {
              var temp_sellRates = angular.copy(vm.currentCard.data.buy_rates);

              angular.forEach(temp_sellRates, function (value, key) {
                value.buy_rate_id = value.rate_id;
                delete value.rate_id;

                if( vm.search_param.mode == 'AIR' && vm.currentCard.meta.type == 'iata_rates' && !value.rate_obj.hasOwnProperty("iataCommission")){
                  value.rate_obj["iataCommission"] = true;
                }

                angular.forEach(value.rate_obj.charges, function (childValue) {

                  if (childValue.charge_basis == 'per shpt') {
                    childValue.charge_basis == 'per shipment';
                  }
                  if(vm.search_param.mode != 'SEA-FCL'){
                    if(key == 'l3_air' && childValue.global_charge_id != null && childValue.global_charge_id != "" && (childValue.global_charge_id.indexOf(shareQuoteService.airChargeId)) >= 0){
                      vm.ScheduleCard.meta["AirFreight"] = childValue;
                    }
                    if(key == 'l1_lcl' && childValue.global_charge_id && (childValue.global_charge_id.indexOf(shareQuoteService.pickupChargeId)) >= 0){
                      vm.ScheduleCard.meta["pickupCharge"] = angular.copy(childValue);
                    }
                    if(key == 'l5_lcl' && childValue.global_charge_id && (childValue.global_charge_id.indexOf(shareQuoteService.deliveryChargeId)) >= 0){
                      vm.ScheduleCard.meta["deliveryCharge"] = angular.copy(childValue);
                    }
                  }

                });
              });

              vm.ScheduleCard.data.sell_rates = angular.copy(temp_sellRates);
              vm.currentCard.data.sell_rates = angular.copy(temp_sellRates);

              vm.ScheduleCard.meta["inclusions"] = resultService.getCardRemarksInclusion(temp_sellRates, 'INCLUSIONS');
              vm.ScheduleCard.meta["remarks"] = resultService.getCardRemarksInclusion(temp_sellRates, 'REMARKS');
              vm.currentCard.meta = angular.copy(vm.ScheduleCard.meta);

            }else{
              angular.forEach(vm.currentCard.data.sell_rates, function (value, key) {
                if(!value.rate_obj){
                    delete vm.currentCard.data.sell_rates[key];
                }
              });
              var temp_sellRates = angular.copy(vm.currentCard.data.sell_rates);

              angular.forEach(temp_sellRates, function (value, key) {

                if(!vm.currentCard.data.buy_rates.hasOwnProperty(key)){
                  vm.currentCard.data.buy_rates[key] = angular.copy(vm.cardLegData);
                  vm.currentCard.data.buy_rates[key].leg_name = value.leg_name;
                  vm.currentCard.data.buy_rates[key].leg_code = key;
                  vm.currentCard.data.buy_rates[key].rate_obj.leg_name = value.leg_name;
                  vm.currentCard.data.buy_rates[key].rate_obj.leg_code = key;
                }

                angular.forEach(value.rate_obj.charges, function (childValue) {

                  var getCharge = $filter('filter')(vm.currentCard.data.buy_rates[key].rate_obj.charges, { 'id': childValue.id }, true);

                  if(!getCharge.length){
                    var newBuyCharge = angular.copy(childValue);
                    newBuyCharge.per_unit_rate = 0;
                    newBuyCharge.charge_cost = 0;
                    newBuyCharge.minimum_charge_cost = "";
                    newBuyCharge.maximum_charge_cost = "";
                    newBuyCharge.customer_currency_cost = 0;
                    newBuyCharge.leg_currency_cost = 0;

                    vm.currentCard.data.buy_rates[key].rate_obj.charges.push(newBuyCharge);
                  }

                  if (childValue.charge_basis == 'per shpt') {
                    childValue.charge_basis == 'per shipment';
                  }

                  if(vm.search_param.mode != 'SEA-FCL'){
                    if(key == 'l3_air' && childValue.global_charge_id != null && childValue.global_charge_id != "" && (childValue.global_charge_id.indexOf(shareQuoteService.airChargeId)) >= 0){
                      vm.currentCard.meta["AirFreight"] = childValue;
                    }
                  }

                });
              });
              vm.currentCard.data.sell_rates = angular.copy(temp_sellRates);

              if(!vm.currentCard.meta["inclusions"]){
                vm.currentCard.meta["inclusions"] = resultService.getCardRemarksInclusion(temp_sellRates, 'INCLUSIONS');
              }
              if(!vm.currentCard.meta["remarks"]){
                vm.currentCard.meta["remarks"] = resultService.getCardRemarksInclusion(temp_sellRates, 'REMARKS');
              }
            }

            vm.showChargesInfo = true;

            vm.showData = false;
        }

        function termsTabView(){
          vm.viewActiveTab = 'Terms';
          vm.termsShimmer = true;
          if(!vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data && vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.url){
              return resultService.getCardTerms(vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.url).then(function (response) {
                  vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
                  vm.ScheduleCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
                  vm.termsData = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
                  vm.termsShimmer = false;
              }, function (error) {
                  vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data = null;
                  vm.termsData = null;
                  vm.termsShimmer = false;
                  $log.log(error);
              });
          }else{
              vm.termsData = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
              vm.termsShimmer = false;
          }

          //mixpanel code
        }

        function remarksTabView(){
          vm.viewActiveTab = 'remarksInclusion';
          if(!(util.isSharedQuote() || util.isSharedPage())){
          vm.isOwnVendorRate = util.isOwnVendorRate(vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.vendor_id);
          }
          vm.hideInternalRemarks =  !vm.isOwnVendorRate || util.isSharedQuote() || util.isSharedPage() ;
        }

        function airScheduleTabView(){
          vm.viewActiveTab = 'airline schedule';
          vm.scheduleList = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data;
          vm.getSchedule = true;

          var selectedSchedule = null
         if(!resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
            angular.forEach(vm.scheduleList, function(item){
            if(!selectedSchedule){
              selectedSchedule = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
              }
            });
          }

          vm.current_schedule = vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule : selectedSchedule;
          vm.display_airlineName = vm.ScheduleCard.data[vm.buyOrSell].l3_air.rate_obj.airline.air_line_name;
        }

        // get card leg user base currency total
        function rateTotalCustomCurr (cards) {
            var convertTotal = 0;
            angular.forEach(cards, function (value) {
                if (typeof value.rate_obj != "undefined" && value.rate_obj != null) {
                convertTotal += parseFloat(value.rate_obj.leg_total_cost);
                }
            });

            if($rootScope &&$rootScope.precision_decimals){
              convertTotal = $filter('number')(convertTotal, $rootScope.precision_decimals);
              }else{
                convertTotal = $filter('number')(convertTotal, 2);
              }
            convertTotal = Number(convertTotal.split(',').join(''));
            return convertTotal;
        }

        function setCurrentSchedule (current_schedule, index) {
            if(vm.multi_schedule_list && vm.multi_schedule_list.length == 15 ){
              util.showToast("Maximum limit reached - 15");
              return;
            }
            if(!current_schedule.isSelected && vm.search_param.mode != "AIR"){
              current_schedule["isSelected"] = true;
              vm.multi_schedule_list.push(current_schedule);
            }
            vm.current_schedule = current_schedule;
            if (vm.current_schedule != null && vm.current_schedule.departure_time > vm.ScheduleCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry) {
                vm.ifExpireCross = true;
            } else {
                vm.ifExpireCross = false;
            }

            var cardIndex = index+1;
            vm.selectedSchedule(vm.current_schedule , 'scheduleSelection');
        }

        function selectedSchedule(scheduleObj, from){
            vm.currentCard.meta.selected_schedule = scheduleObj;
            vm.currentCard.meta["multi_schedule_list"] = vm.multi_schedule_list;

            if((vm.activeTab == 'addNewQuote' || vm.activeTab == 'schedule') && from != 'fromNewSchedule'){

              if(vm.islastactivity && util.userProfile.user.is_pricing_user){
                $mdDialog.hide();
                return;
              }
              vm.quoteNewCard.meta.selected_schedule = angular.copy(scheduleObj);
              vm.quoteNewCard.meta["multi_schedule_list"] = angular.copy(vm.multi_schedule_list);
              vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;

              vm.quoteNewCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;


            }else{
              vm.ScheduleCard.meta.selected_schedule = scheduleObj;
              vm.ScheduleCard.meta["multi_schedule_list"] = vm.multi_schedule_list;
            }

            vm.schedule_display = true;
            if(from != 'fromNewSchedule' && vm.search_param.mode == 'AIR'){
              $mdDialog.hide();
            }

        }

        // function to get the remarks or inclusion of cards
        function getCardRemarksInclusion(cardObj,key){
            var result = '';
            if ( vm.activeTab == 'rates' ) {
              if(key == 'REMARKS'){
                result = vm.currentCard.meta.remarks != null && vm.currentCard.meta.remarks != '' ? vm.currentCard.meta.remarks : "" ;

                result = result ? result : resultService.getCardRemarksInclusion(cardObj,key);
              }
              else if(key == 'INCLUSIONS'){
                result = vm.currentCard.meta.inclusions != null && vm.currentCard.meta.inclusions != '' ? vm.currentCard.meta.inclusions : "" ;

                result = result ? result : resultService.getCardRemarksInclusion(cardObj,key);
              }
            }else{
              if(key == 'REMARKS'){
                result = vm.currentCard.meta.remarks;
              }
              else if(key == 'INCLUSIONS'){
                result = vm.currentCard.meta.inclusions;
              }
            }
            return result;
        }

        function fnSwitchPages(str) {
            if (str == "remarks") {
                vm.quotationDetailsVisible = false;
            } else if (str == "quotationDetails") {
                vm.quotationDetailsVisible = true;
            }
        }

        function fnCardStructure(){
          vm.cardChargeObj = {
              "id": "0001",
              "charge_id": null,
              "charge_name": null,
              "charge_type": "FIXED",
              "charge_basis": null,
              "per_unit_rate": 0,
              "total_units": 0,
              "charge_cost": 0,
              "charge_currency": vm.searchUser.user_base_currency,
              "minimum_charge_cost": vm.search_param.mode == 'SEA-FCL' ? 'NA':'',
              "maximum_charge_cost": vm.search_param.mode == 'SEA-FCL' ? 'NA':'',
              "container_type": null,
              "global_charge_id": "",
              "customer_currency_cost": 0,
              "leg_currency_cost": 0,
              "tax_type": "GST",
              "tax_percent": 0,
              "manual" : true,
              "is_qty_editable" : false,
              "charge_category": null,
              "charge_code" : ""
          };

          vm.cardLegData = {
              "leg_name": "",
              "leg_code": "",
              "vendor_id": (localStorageService.get('authToken').value.vendor_id),
              "rate_obj": {
                  "agent_id": "",
                  "_id": "",
                  "schedule": {
                    "url" : null,
                    "data" : []
                  },
                  "analytics": {
                    "graph": {
                        "url": null
                    }
                  },
                  "is_special": false,
                  "charges": [],
                  "manual": 1,
                  "airline": {
                    "air_line_name": "",
                    "airline_code": "",
                    "airline_prefix": ""
                  },
                  "airline_code": null,
                  "slab_currency": null,
                  "slab": null,
                  "rate_type": "msr_rate",
                  "leg_name": "",
                  "leg_code": "",
                  "vendor_id": (localStorageService.get('authToken').value.vendor_id),
                  "sub_vendor_id": null,
                  "service_type": null,
                  "via_route": null,
                  "transit_time": null,
                  "contract_number": "",
                  "remarks": null,
                  "inclusions": null,
                  "expiry": null,
                  "other_charges": null,
                  "if_applicable_charges": null,
                  "load_stat": null,
                  "global_leg_id": "",
                  "leg_total_cost": 0,
                  "leg_total_currency": vm.searchUser.user_base_currency,
                  "leg_currency_cost": 0,
                  "leg_currency": vm.searchUser.user_base_currency,
                  "vendor": {
                    "vendor_name": localStorageService.get('authToken').value.vendor_name
                  },
                  "sub_vendor": {
                    "sub_vendor_name": "",
                    "carrier_code": "",
                    "logo" : null
                  },
                  "ltl_load_details" : null,
                  "commodity_data" : [],
                  "cargo_type_data" : null
              }
          };

          vm.is_nearbyOrigin_icd = 0;
          vm.is_nearbyDestination_icd = 0;
          if( vm.search_param.nearby_ports.length ){
            for( var i = 0; i < vm.search_param.nearby_ports.length; i++){
              if( vm.search_param.nearby_ports[i].is_icd_port){
                vm.is_nearbyOrigin_icd = 1;
                break;
              }
            }
          }

          if( vm.search_param.nearby_ports_destination.length ){
            for( var i = 0; i < vm.search_param.nearby_ports_destination.length; i++){
              if( vm.search_param.nearby_ports_destination[i].is_icd_port){
                vm.is_nearbyDestination_icd = 1;
                break;
              }
            }
          }

          vm.quoteNewCardInit = {
            "data": {
              "sell_rates": {},
              "buy_rates": {}
            },
            "meta": {
              "airline_code" : null,
              "card_total_cost": 0,
              "delta_percent" : null,
              "haulage" : "",
              "destination_haulage" : "",
              "haulage_available" : false,
              "inclusions": null,
              "is_selected": false,
              "network_id" : null,
              "port_data": {
                "pickup_location": vm.search_param.origin_location.place_type == 'Door' ? vm.search_param.origin_location.location : null,
                "origin_port_code": null,
                "origin_portname": vm.search_param.origin_location.portname,
                "is_icd_port_origin": vm.search_param.origin_location.is_icd_port || vm.is_nearbyOrigin_icd,

                "delivery_location": vm.search_param.destination_location.place_type == 'Door' ? vm.search_param.destination_location.location : null,
                "destination_port_code": null,
                "destination_portname": vm.search_param.destination_location.portname,
                "is_icd_port_destination": vm.search_param.destination_location.is_icd_port || vm.is_nearbyDestination_icd
              },
              "remarks": null,
              "selected_schedule": null,
              "type": "msr_rates",
              "vendor_id": vm.isShared ? "" : parseInt(localStorageService.get('authToken').value.vendor_id),
              "via_pod" : null,
              "via_pol" : null,
              "make_rates_global" : [],
              "isRateGlobal" : "No",
              "ltl_load_details" : null
            },
            "schedule": [],
            "sub_vendor": "",
            "_id" : ""
          };
        }

        function fnAddOrEditCard(card, action, ev, actionType){
          vm.fnTrackAnalytics('ID-'+actionType+'-Click');
          vm.editCard = card ? angular.copy(card) : null;
          if(vm.util.isAdmin || vm.util.userProfile.user.is_pricing_user){
            downloadSourceRate(card);
          }
          if(vm.editCard){
            if (action.toLowerCase().includes("new")) {
              delete vm.editCard["_id"];
            }
            angular.forEach(vm.editCard.data.buy_rates, function (value, key) {
              if(!value.rate_obj){
                  delete vm.editCard.data.buy_rates[key];
                  delete vm.editCard.data["sell_rates"][key];
              }
            });
            // removing load wise expiry while copy/create quote
            vm.editCard.data.buy_rates[vm.l3_leg].rate_obj['detailed_effective_load'] = {};
            vm.editCard.data.sell_rates[vm.l3_leg].rate_obj['detailed_effective_load'] = {};
          }

          vm.footerObj = { 
            "doneBtnDisable" : false,
            "buyTotalWithConv" : 0,
            "buyTotalBaseCurr" : 0,
            "sellTotalBaseCurr" : 0,
            "profit" : 0,
            "rateExpired":false
          };
          vm.pageSource = action; // 'newCardInquiry';
          vm.fromInquiry = $rootScope.domainData.domain_info.MAKE_RATES_GLOBAL_FROM_INQUIRY && util.userProfile.user.is_pricing_user;
          vm.inquiryPricing = util.userProfile.user.is_pricing_user ? true : false;

          $mdDialog.show({
            template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" source-rate="ctrl.parent.sourceRate"  result-card-filter="ctrl.parent.resultfilter" card-data="ctrl.parent.editCard" footer-obj="ctrl.parent.footerObj" from-inquiry="ctrl.parent.fromInquiry" inquiry-pricing="ctrl.parent.inquiryPricing" co2e-response="ctrl.parent.co2eResponse" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function () { this.parent = vm },
            onRemoving: function (event, removePromise) {
              for (var name in CKEDITOR.instances) {
                CKEDITOR.instances[name].destroy();
              }
            }
          });
        }

        function showQuoteProceedDiv(item){
          if (item.action == "addRate") {
            item.currentCard.data.buy_rates[vm.l3_leg].rate_obj.manual = 1;
            item.currentCard.data.sell_rates[vm.l3_leg].rate_obj.manual = 1;
            resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,item.currentCard);
            // delete item.currentCard.meta.buy_leg_total;
            delete item.currentCard.meta.view;
            delete item.currentCard.meta["slabPersentage"];
            delete item.currentCard.meta["selectedLeg"];
            delete item.currentCard.meta["init_sort_total"];
            delete item.currentCard.data.buy_rates[vm.l3_leg]["rate_obj_1"];
            delete item.currentCard.data.buy_rates[vm.l3_leg]["rate_obj_2"];
            delete item.currentCard.data.sell_rates[vm.l3_leg]["rate_obj_1"];
            delete item.currentCard.data.sell_rates[vm.l3_leg]["rate_obj_2"];
    
            item.currentCard.meta["status"] = "new";
            vm.addInQuote(item.currentCard, "newCard");
            $mdDialog.hide();
          }else if(item.action == "editRate"){
            resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,item.currentCard);
            item.currentCard.meta["status"] = item.currentCard.meta["status"] != "new" ? "modified" : "new";
            vm.addInQuote(item.currentCard,'quotationEdit');
            $mdDialog.hide();
          } 
        }

        

        function fnDefaultCharge(){
          vm.getChargeList('Ocean Freight',vm.l3_leg, vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0]).then(function(response){
            var defaultChargeObj =  response.find(function(element) {
              return ( element.charge_id == shareQuoteService.freightChargeId );
            });
            vm.changeSelectedCharge(defaultChargeObj, vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0], vm.currentCard.data.sell_rates[vm.l3_leg], 0, vm.l3_leg);
            vm.currentCard.meta["isScheduleCall"] = true;
            vm.quoteNewCard.meta["isScheduleCall"] = true;
            vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry = angular.copy(vm.quoteNewCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry);
            vm.quoteNewCard.data = angular.copy(vm.currentCard.data);
            vm.addCardData = true;
          },function(error){
              vm.currencyList = [];
              vm.addCardData = true;
              $log.log(error);
          });
        }

        function fnAddLeg(currCard) {
            vm.legShow++;
            var leg_number = 'lNew' + Math.floor(1000 + Math.random() * 9000) + '_'+(vm.search_param.mode == 'SEA-FCL' ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl'));

            if (currCard.data.sell_rates == null) {
              currCard.data.sell_rates = {};
            }

            currCard.data.sell_rates[leg_number] = angular.copy(vm.cardLegData);
            currCard.data.sell_rates[leg_number].rate_obj.charges.push(angular.copy(vm.cardChargeObj));
            currCard.data.buy_rates[leg_number] = angular.copy(vm.cardLegData);
            currCard.data.buy_rates[leg_number].rate_obj.charges.push(angular.copy(vm.cardChargeObj));
            vm.legSuggestionList = [];

            setTimeout(function () {
              document.querySelector('#' + leg_number + '').focus();
            }, 50);

        }

        function fnAddNewCharge(sellKey, sellObj) {
            var charge_number = 'lNew' + Math.floor(1000 + Math.random() * 9000) + '_'+(vm.search_param.mode == 'SEA-FCL' ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl'));

            if (sellObj.leg_name == null) {
              util.showToast("Please enter leg name.");
              document.querySelector('#' + sellKey).focus();
              return false;
            }

            var charge_obj = angular.copy(vm.cardChargeObj);
            charge_obj.id = charge_number;
            charge_obj.charge_currency = sellObj.rate_obj.leg_currency;

            sellObj.rate_obj.charges.push(charge_obj);
            vm.currentCard.data.buy_rates[sellKey].rate_obj.charges.push(angular.copy(charge_obj));
            vm.chargeShow = sellObj.rate_obj.charges.length;

            $timeout(function () {
              document.querySelector('#' + sellKey + '_' + (sellObj.rate_obj.charges.length - 1) + '').focus();
            }, 50);

        }

        function confirmDeleteLeg(sellKey, sellRate) {
            vm.chargeDelete = false;
            vm.legDelete = true;

            vm.deleteChargeBtn = false;
            vm.all_pickup_basis_delete = false;
            vm.all_delivery_basis_delete = false;
            vm.is_delete_l3_leg = false;

            vm.legKeyName = sellKey;
            vm.deleteLegObj = sellRate;

            if (sellRate.leg_name == null || sellRate.leg_name == "") {
              vm.fnDeleteLeg();
            }
            else {
              if (sellKey == vm.l3_leg) {
                vm.is_delete_l3_leg = true;
                util.showToast('You can not delete this leg.');
                return true;
              }
              vm.currentPage = 'quote';
              $mdToast.show({
                hideDelay: false,
                position: 'top right',
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm },
                templateUrl: 'app/main/result/Dialogs/delete-charge/delete-charge.html'
              });
            }
        }

        function fnDeleteLeg() {
            vm.deleteChargeBtn = true;

            if (vm.is_delete_l3_leg) {
                $mdToast.hide();
                $mdDialog.hide();
                return;
            }

            delete vm.currentCard.data.sell_rates[vm.legKeyName];
            delete vm.currentCard.data.buy_rates[vm.legKeyName];

            vm.fnDisplayProfit();

            $mdToast.hide();
        }

        function confirmDeleteCharge(sellKey, sellRate, index, action) {
            vm.chargeDelete = true;
            vm.legDelete = false;
            vm.deleteChargeBtn = false;

            vm.is_delete_l3_leg = false;
            vm.airBasisLegCharge = {};
            vm.pickupBasisLegCharge = {};
            vm.deliveryBasisLegCharge = {};
            vm.airBasisCharges = false;
            vm.all_pickup_basis_delete = false;
            vm.all_delivery_basis_delete = false;

            vm.legKeyName = sellKey;
            vm.deleteChargeLeg = sellRate;
            vm.deleteCharge_buyLeg = vm.currentCard.data.buy_rates[sellKey].rate_obj;
            vm.chargeIndex = index;

            vm.deleteChargeLineObj = vm.deleteChargeLeg.charges[index];
            vm.isQuoteOrCard = action;

            if( vm.deleteChargeLeg.charges[index].global_charge_id != null && vm.deleteChargeLeg.charges[index].global_charge_id != ""){

              var ifAirCharge = vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(shareQuoteService.airChargeId) >= 0; // air freight charge
              var ifPickupCharge = vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(shareQuoteService.pickupChargeId) >= 0;  // pickup charge
              var ifDeliveryCharge = vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(shareQuoteService.deliveryChargeId) >= 0; // delivery charge
              if(ifAirCharge || ifPickupCharge || ifDeliveryCharge ){

                var chargeName = ifAirCharge ? 'air_charge' : (ifPickupCharge ? 'pickup_charge' : 'delivery_charge');
                vm.showDeleteBasisCharge(action, chargeName);
                if(vm.is_delete_l3_leg){
                  util.showToast('You can not delete this charge.');
                  return true;
                }
              }
            }

            vm.currentPage = 'quote';
            if (vm.deleteChargeLeg.charges[index].charge_name == null || vm.deleteChargeLeg.charges[index].charge_name == "") {
              if (action == 'quote' && sellKey == vm.l3_leg && vm.deleteChargeLeg.charges.length == 1) {
                vm.is_delete_l3_leg = true;
                util.showToast('You can not delete this charge.');
                return true;
              }
              vm.fnDeleteNewCharge();
            }
            else {
              if (action == 'quote' && sellKey == vm.l3_leg && vm.deleteChargeLeg.charges.length == 1) {
                vm.is_delete_l3_leg = true;
                util.showToast('You can not delete this charge.');
                return true;
              }

              $mdToast.show({
                hideDelay: false,
                position: 'top right',
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm },
                templateUrl: 'app/main/result/Dialogs/delete-charge/delete-charge.html'
              });
            }
        }

        function closeToast () {
            $mdToast.hide();
        }

        function fnDeleteNewCharge() {
            vm.deleteChargeBtn = true;
            var sellObj = vm.deleteChargeLeg;
            var buyObj = vm.deleteCharge_buyLeg;
            var index = vm.chargeIndex;

            if (vm.is_delete_l3_leg) {
              $mdToast.hide();
              $mdDialog.hide();
              return;
            }

            sellObj.leg_currency_cost -= sellObj.charges[index].leg_currency_cost;

            sellObj.leg_total_cost -= sellObj.charges[index].customer_currency_cost;

            if(sellObj.charges[index].global_charge_id != null && sellObj.charges[index].global_charge_id != ""){
              if(sellObj.charges[index].global_charge_id.indexOf(shareQuoteService.airChargeId) >= 0 ){
                vm.currentCard.meta["AirFreight"] = null;
              }else if( sellObj.charges[index].global_charge_id.indexOf(shareQuoteService.pickupChargeId) >= 0 ){
                vm.currentCard.meta["pickupCharge"] = null;
              }else if( sellObj.charges[index].global_charge_id.indexOf(shareQuoteService.deliveryChargeId) >= 0 ){
                vm.currentCard.meta["deliveryCharge"] = null;
              }
            }

            sellObj.charges.splice(index, 1);
            buyObj.leg_currency_cost -= buyObj.charges[index].leg_currency_cost;

            buyObj.leg_total_cost -= buyObj.charges[index].customer_currency_cost;
            buyObj.charges.splice(index, 1);

            if (vm.isQuoteOrCard == 'quote' && !sellObj.charges.length) {
              delete vm.currentCard.data.sell_rates[vm.legKeyName];
              delete vm.currentCard.data.buy_rates[vm.legKeyName];
            }

            if(vm.airBasisCharges || vm.all_pickup_basis_delete || vm.all_delivery_basis_delete){
              vm.deleteFreightBasisCharge(vm.isQuoteOrCard);
            }

            if (vm.isQuoteOrCard == 'quote') {
              vm.fnDisplayProfit();
            }

            $mdToast.hide();
        }

        // delete dependant basis charges
        function deleteFreightBasisCharge(action){
          fnLegLoop(vm.airBasisLegCharge);
          fnLegLoop(vm.pickupBasisLegCharge);
          fnLegLoop(vm.deliveryBasisLegCharge);

          if(action == 'quote' && !Object.keys(vm.currentCard.data.sell_rates).length){
            vm.currentCard.data.sell_rates = null;
          }

          function fnLegLoop(basisLeg){
            angular.forEach(basisLeg, function (parent_value, parent_key) {

              var sellObj = vm.currentCard.data.sell_rates[parent_key].rate_obj;
              var buyObj = vm.currentCard.data.buy_rates[parent_key].rate_obj;

              angular.forEach(parent_value.charges, function (child_value) {
                if(sellObj){
                  var index = sellObj.charges.indexOf(child_value);

                  sellObj.charges[index].total_units = null;
                  buyObj.charges[index].total_units = null;

                }
              });

              if(action == 'quote' && sellObj && !sellObj.charges.length){
                delete vm.currentCard.data.sell_rates[parent_key];
              }
            });
          }
        }

        function showDeleteBasisCharge(action, chargeName){

          if(action == 'quote'){
            angular.forEach(vm.currentCard.data.sell_rates,function(value, key){
              vm.airBasisLegCharge[key] = { "leg_name" : value.leg_name, "charges" : [] };
              vm.pickupBasisLegCharge[key] = { "leg_name" : value.leg_name, "charges" : [] };
              vm.deliveryBasisLegCharge[key] = { "leg_name" : value.leg_name, "charges" : [] };

              angular.forEach(value.rate_obj.charges,function(childValue){
                if(childValue.charge_basis == shareQuoteService.airBasisName && chargeName == 'air_charge'){
                  vm.airBasisLegCharge[key].charges.push(childValue);
                }
                else if(childValue.charge_basis == shareQuoteService.pickupBasisName && chargeName == 'pickup_charge'){
                  vm.pickupBasisLegCharge[key].charges.push(childValue);
                }
                else if(childValue.charge_basis == shareQuoteService.deliveryBasisName && chargeName == 'delivery_charge'){
                  vm.deliveryBasisLegCharge[key].charges.push(childValue);
                }
              });

              if(!vm.airBasisLegCharge[key].charges.length ){
                delete vm.airBasisLegCharge[key];
              }
              if(!vm.pickupBasisLegCharge[key].charges.length ){
                delete vm.pickupBasisLegCharge[key];
              }
              if(!vm.deliveryBasisLegCharge[key].charges.length ){
                delete vm.deliveryBasisLegCharge[key];
              }
            });
          }

          if(action == 'quote' && Object.keys(vm.airBasisLegCharge).length !== 0 && vm.airBasisLegCharge["l3_air"] != undefined && (vm.currentCard.data.sell_rates["l3_air"].rate_obj.charges.length == (vm.airBasisLegCharge["l3_air"].charges.length +1) || vm.currentCard.data.sell_rates["l3_air"].rate_obj.charges.length == (vm.airBasisLegCharge["l3_air"].charges.length))){
            vm.is_delete_l3_leg = true;
          }

          vm.airBasisCharges = (Object.keys(vm.airBasisLegCharge).length === 0 || vm.is_delete_l3_leg) ? false : true;
          vm.all_pickup_basis_delete = (Object.keys(vm.pickupBasisLegCharge).length === 0) ? false : true;
          vm.all_delivery_basis_delete = (Object.keys(vm.deliveryBasisLegCharge).length === 0) ? false : true;
        }

        // get leg name list
        function getMatches (searchText) {
            searchText = searchText;
            var obj = {
                'mode': vm.search_param.mode,
                'search': searchText
            }

            return SearchService.getLegName(obj).then(function (response) {
                vm.legSuggestionList = response.data.data;
                return vm.legSuggestionList;
            }, function (error) {
                $log.log(error);
            });
        }

        //if leg is  selected from suggestion
        function changeSelectedLeg(selectedLeg, sellRate, sellKey) {
            var leg_code = (vm.search_param.mode == 'SEA-FCL') ? '_fcl' : ((vm.search_param.mode == 'AIR') ? '_air' : '_lcl' );
            if (selectedLeg != null) {

              var isLegPresent = Object.keys(vm.currentCard.data.sell_rates).some(function (key) {
                if (vm.currentCard.data.sell_rates[key].leg_code == selectedLeg.leg_id + leg_code) {
                  return true;
                }
                return false;
              });

              if (isLegPresent && (sellRate.leg_code == null || sellRate.leg_code == "")) {
                util.showToast('Leg already exist! Please Select another leg');
                sellRate.leg_name = "";
                sellRate.leg_code = "";
                sellRate.rate_obj.leg_name = "";
                sellRate.rate_obj.leg_code = "";
                sellRate.rate_obj.global_leg_id = "";
              } else {
                sellRate.leg_name = selectedLeg.leg_name;
                sellRate.leg_code = selectedLeg.leg_id + leg_code;
                sellRate.rate_obj.leg_name = selectedLeg.leg_name;
                sellRate.rate_obj.leg_code = selectedLeg.leg_id + leg_code;
                sellRate.rate_obj.global_leg_id = selectedLeg.leg_id;
              }
            } else {
              if (!sellKey.includes('l3')){
                  sellRate.leg_code = "";
                  sellRate.rate_obj.leg_code = "";
              } 
            }

            vm.currentCard.data.buy_rates[sellKey].leg_name = angular.copy(sellRate.leg_name);
            vm.currentCard.data.buy_rates[sellKey].leg_code = angular.copy(sellRate.leg_code);
            vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_name = angular.copy(sellRate.rate_obj.leg_name);
            vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_code = angular.copy(sellRate.rate_obj.leg_code);
            vm.currentCard.data.buy_rates[sellKey].rate_obj.global_leg_id = angular.copy(sellRate.rate_obj.global_leg_id);
        }

        //get charge name suggestion list
        function getChargeList(searchText, leg_code, chargeObj) {
          return shareQuoteService.getChargeList(searchText, leg_code, chargeObj, vm.search_param);
        }

        // get selected card with sell rates
        function pushToquoteArray(currentCard) {
        
          if(Object.keys(currentCard.data.sell_rates).length ==1 && !currentCard.data.sell_rates[Object.keys(currentCard.data.sell_rates)[0]].rate_obj.charges.length){
            util.showToast("Add a leg and its corresponding charges to continue");
             return;
           }
            vm.footerObj.doneBtnDisable = true;
            if(!(currentCard['_id'])){
              var card_number = (vm.shareQuoteService.fnGuuid() + vm.shareQuoteService.fnGuuid() + "-" + vm.shareQuoteService.fnGuuid() + "-4" + vm.shareQuoteService.fnGuuid().substr(0,3) + "-" + vm.shareQuoteService.fnGuuid() + "-" + vm.shareQuoteService.fnGuuid() + vm.shareQuoteService.fnGuuid() + vm.shareQuoteService.fnGuuid()).toLowerCase();
              currentCard['_id'] =  card_number;
            }

            if (currentCard.meta.remarks == undefined || currentCard.meta.remarks == "") {
              currentCard.meta.remarks = null;
            }
            if (currentCard.meta.inclusions == undefined || currentCard.meta.inclusions == "" ) {
              currentCard.meta.inclusions = null;
            }

            var isDone = shareQuoteService.fnRateEditValidation(currentCard, vm.editBuyRate, vm.search_param);
            if(isDone === 0){
              const elements = document.querySelectorAll('.error-border');
              if(vm.viewActiveTab != 'quotation'){
                  vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible;
              }else{
                if(elements.length && elements[0]){
                  elements[0].scrollIntoView({ behavior: 'smooth' , block: 'center'});
                }
              }
              vm.footerObj.doneBtnDisable = false;
            }else if (isDone === 1) {

              var custom_leg = 9;
              var tempSellRates = {};
              var tempBuyRates = {};
              var load_stat = {};
              if(vm.search_param.mode == 'SEA-FCL'){
                //leg charge summary calculate factory instance 
                var chargeSummaryObj = new fbUtils.ChargeSummaryFactory.getInstance(vm.search_param.load_data, vm.search_param.mode);
                load_stat = {};
                vm.search_param.load_data.load_details_value.forEach(function(load) {
                  load_stat[load.type] = 0;
                });
              }
              
              angular.forEach(currentCard.data.sell_rates, function (value, key) {
                if(key.toLowerCase().includes('lnew') || key !== vm.l3_leg){
                  if(value.leg_code===vm.l3_leg){
                    var templeg=value.rate_obj;
                    value=currentCard.data.sell_rates[vm.l3_leg];
                    value.leg_name = templeg.leg_name;
                    value.rate_obj.leg_name = templeg.leg_name;
                    value.rate_obj.charges=templeg.charges;
                    value.rate_obj.leg_total_currency=templeg.leg_total_currency;
                    value.rate_obj.leg_total_cost=templeg.leg_total_cost;
                    value.rate_obj.leg_currency_cost=templeg.leg_currency_cost;
                    value.rate_obj.leg_currency=templeg.leg_currency;
                    value.rate_obj.manual=templeg.manual
                  }  
                }

                if(vm.search_param.mode == 'SEA-FCL'){
                value.rate_obj.load_stat = angular.copy(load_stat);
                }

                if (value.leg_code != null && value.leg_code != "") {
                  tempSellRates[value.leg_code] = value;
                  if(value.leg_code===vm.l3_leg &&  ( key.toLowerCase().includes('lnew') || key !== vm.l3_leg )){
                    var buytempleg= currentCard.data.buy_rates[key].rate_obj;
                    tempBuyRates[value.leg_code]=currentCard.data.buy_rates[vm.l3_leg];
                    tempBuyRates[value.leg_code].leg_name = currentCard.data.buy_rates[key].leg_name
                    tempBuyRates[value.leg_code].rate_obj.leg_name = currentCard.data.buy_rates[key].leg_name;
                    tempBuyRates[value.leg_code].rate_obj.charges=buytempleg.charges;
                    tempBuyRates[value.leg_code].rate_obj.leg_total_currency=buytempleg.leg_total_currency;
                    tempBuyRates[value.leg_code].rate_obj.leg_total_cost=buytempleg.leg_total_cost;
                    tempBuyRates[value.leg_code].rate_obj.leg_currency_cost=buytempleg.leg_currency_cost;
                    tempBuyRates[value.leg_code].rate_obj.leg_currency=buytempleg.leg_currency;
                    tempBuyRates[value.leg_code].rate_obj.manual=buytempleg.manual
                  }
                  else{
                    tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
                  }                  // Charge Summery calculation
                  if(vm.search_param.mode == 'SEA-FCL'){
                    var buySummaryData = chargeSummaryObj.calculate(currentCard.data.buy_rates[key].rate_obj);
                    var sellSummaryData = chargeSummaryObj.calculate(currentCard.data.sell_rates[key].rate_obj);
                    currentCard.data.buy_rates[key]['charge_summary'] = buySummaryData;
                    currentCard.data.sell_rates[key]['charge_summary'] = sellSummaryData;
                  }
                  
                  custom_leg = parseInt(value.leg_code.match(/(\d+)/)[0]) <= 8 ? 9 : parseInt(value.leg_code.match(/(\d+)/)[0]) + 1;
                }
                else if (value.leg_code == null || value.leg_code == "") {
                  value.leg_code = 'l' + custom_leg + vm.modeName;
                  value.rate_obj.leg_code = value.leg_code;
                  value.rate_obj.leg_name = value.leg_name;

                  currentCard.data.buy_rates[key].leg_code = value.leg_code;
                  currentCard.data.buy_rates[key].leg_name = value.leg_name;
                  currentCard.data.buy_rates[key].rate_obj.leg_code = value.leg_code;
                  currentCard.data.buy_rates[key].rate_obj.leg_name = value.leg_name;
                  custom_leg++;
                  tempSellRates[value.leg_code] = value;
                  tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
                }

                angular.forEach(value.rate_obj.charges, function (childValue, chargeKey) {
                  if(vm.search_param.mode == 'SEA-FCL' && childValue.container_type){
                    value.rate_obj.load_stat[childValue.container_type] = 1;
                  }

                  if(!childValue.charge_id){
                    childValue.charge_id = 'UD'+ Math.random().toString(36).substring(2, 7).toUpperCase();
                    childValue.global_charge_id = 'UD'+ Math.random().toString(36).substring(2, 7).toUpperCase();

                    // random id for buy and sell rate charges
                    tempSellRates[value.leg_code].rate_obj.charges[chargeKey].charge_id = childValue.charge_id;
                    tempBuyRates[value.leg_code].rate_obj.charges[chargeKey].charge_id = childValue.charge_id;

                    tempSellRates[value.leg_code].rate_obj.charges[chargeKey].global_charge_id = childValue.global_charge_id;
                    tempBuyRates[value.leg_code].rate_obj.charges[chargeKey].global_charge_id = childValue.global_charge_id;
                  }
                });
                if(vm.editBuyRate){
                  tempBuyRates[value.leg_code].rate_obj.load_stat = angular.copy(value.rate_obj.load_stat);
                }else{
                  tempBuyRates[value.leg_code].rate_obj.load_stat = tempBuyRates[value.leg_code].rate_obj.load_stat ? tempBuyRates[value.leg_code].rate_obj.load_stat : angular.copy(load_stat);
                }
              });

              angular.forEach(vm.ScheduleCard.data.buy_rates, function (value, key) {
                if(!value.rate_obj && !tempBuyRates[key]){
                    tempBuyRates[key] = angular.copy(vm.ScheduleCard.data.buy_rates[key]);
                    tempSellRates[key] = angular.copy(vm.ScheduleCard.data.buy_rates[key]);
                }
              });

              currentCard.data.sell_rates = tempSellRates;
              currentCard.data.buy_rates = tempBuyRates;
              currentCard.meta.card_total_cost = resultService.calCardTotal(currentCard.data.sell_rates);
              currentCard.meta.is_selected = true;
              if(!currentCard.meta.selected_schedule){
                currentCard.meta.selected_schedule = currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data.length ? currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data[0] : null;
              }

              currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);  
              currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);  
              currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);

              delete currentCard.meta["init_sort_total"];

              if (vm.activeTab == 'quotationEdit'){
                vm.shareQuoteService.copysellToBuy(currentCard, vm.search_param.mode, vm.l3_leg);
                currentCard.meta["status"] = currentCard.meta["status"] != "new" ? "modified" : "new";
                vm.addInQuote(currentCard,'quotationEdit');

              }else if(vm.activeTab == 'addNewQuote' || vm.activeTab == 'schedule'){
                currentCard.meta["status"] = "new";
                vm.shareQuoteService.copysellToBuy(currentCard, vm.search_param.mode, vm.l3_leg);
                vm.quoteNewCard = angular.copy(currentCard);
                vm.sell_rates_display = true;
                if(vm.copyCard == true){
                  vm.addInQuote(currentCard,'newCard');
                  vm.copyCard = false;
                }
              } else if (vm.activeTab == 'quotation' || ( vm.activeTab == 'rates' ) ){
                currentCard.meta["status"] = "new";
                currentCard.meta.is_selected = true;
                vm.ScheduleCard.meta = angular.copy(currentCard.meta);
                vm.ScheduleCard.data = angular.copy(currentCard.data);
                vm.addInQuote(currentCard,'addInToQuote');
              }
              $mdDialog.hide();
              vm.footerObj.doneBtnDisable = false;
            }
        }

        // new card submit btn
        function addInQuote(currentCard, action){
          currentCard= QuotesService.setData(currentCard);

          if( currentCard.meta.isRateGlobal == 'Yes' ){
            var globalrateObj = {
              "leg_code":"l3_fcl",
              "batch_code": null,
              "error": null
            }
            currentCard.meta.make_rates_global =(currentCard.meta.make_rates_global && currentCard.meta.make_rates_global.length)? currentCard.meta.make_rates_global : [globalrateObj];
          }else{
            currentCard.meta.make_rates_global = [];
          }

          if(!currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data.length){
            var l3_obj = currentCard.data.sell_rates[vm.l3_leg].rate_obj;
            var cargo_date = $filter('date')(new Date(), 'yyyy-MM-dd');

            currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.url = api.baseUrl + '/api/schedules?from_port='+currentCard.meta.port_data.origin_port_code+'&to_port='+currentCard.meta.port_data.destination_port_code+'&carrier_code='+l3_obj.sub_vendor.schedule_provider_code+'&from_date='+cargo_date+'&mode='+vm.search_param.mode;

            if(currentCard.meta.via_pol){
              currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.url += '&via_pol='+currentCard.meta.via_pol;
            }
            if(currentCard.meta.via_pod){
              currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.url += '&via_pod='+currentCard.meta.via_pod;
            }

            currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.url = angular.copy(currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.url);
            finalCallback();
          }else{
            finalCallback();
          }

          function finalCallback(){
            // if(action == 'newCard' || action == 'addNewQuote'){
            //   vm.getAdditionalLeg(currentCard, action);
            // }
            vm.shareQuoteService.copysellToBuy(currentCard, vm.search_param.mode, vm.l3_leg);
            if(action == 'newCard'){
              vm.quoteNewCard = angular.copy(vm.quoteNewCardInit);
            }
            vm.callback({card : {'currentCard' :currentCard, 'action' : action, 'activityId':vm.activityId }});
          }
        }

        function getAdditionalLeg(currentCard, action){

          if(vm.currentState == 'app.inquiry.inquiryDetails'){
            var dataId = vm.inquiryid._id;
            var page = 'inquiry';
          }else{
            var dataId = vm.inquiryid;
            var page = 'search';
          }
          vm.resultfilter.sendRatesBtn = true;
          resultService.fnAutoFetchBinding(vm.search_param, currentCard, dataId, page, vm.l3_leg).then(function(response){
            // add remarks & inclusion
            response.meta['remarks'] = response.meta['remarks'] ? response.meta['remarks'] : "";
            response.meta['inclusions'] = response.meta['inclusions'] ? response.meta['inclusions'] : "";
            angular.forEach(response.data.buy_rates, function (leg_value, leg_key) {
              if(leg_value.rate_obj){
                response.meta['remarks'] += leg_value.rate_obj.remarks ? leg_value.rate_obj.remarks : "";
                response.meta['inclusions'] +=  leg_value.rate_obj.inclusions ? leg_value.rate_obj.inclusions : "";
              }
            });
            vm.resultfilter.sendRatesBtn = false;
          },function(error){
            vm.resultfilter.sendRatesBtn = false;
          });
        }

        function removeCard(currentCard){
          if(currentCard.meta.shimmer){
            return true;
          }
          vm.callback({card : {'currentCard' :currentCard, 'action' : 'removeFromQuote' }});
        }

        function requestToBook(currentCard, action){
            if( !util.navPermission.shipments[0] || !currentCard.meta.selected_schedule ){
                return true;
            }

            vm.callback({card : {'currentCard' :currentCard, 'action' : 'bookingRequest' }});
        }

        function fnChangeBasis(chargeObj, sellRate, charge_index, buyCharge, buyLeg, param,legKey) {

            if (!chargeObj.charge_basis) {
              chargeObj.total_units = 0;
              chargeObj.charge_cost = 0;
              vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj);
              if(vm.editBuyRate){
                var buylegData = (vm.search_param.mode !== 'SEA-FCL') ? buyLeg.rate_obj : buyLeg;
                vm.conversionOnPriceChange(buyCharge, buylegData.rate_obj);
              }
              return true;
            }
            if(vm.search_param.mode === 'SEA-FCL' && chargeObj.charge_name){
              resultService.checkExistingCharge(chargeObj,charge_index,sellRate.rate_obj.charges,legKey); //it's checking duplicate charge present or not.
            }
            
            if(param != 'quantity'){
              shareQuoteService.fnGetFclTotalUnits(chargeObj, vm.search_param.load_data.load_details_value);
            }

            if (chargeObj.total_units == 0) {
              chargeObj.charge_cost = 0;
              chargeObj.leg_currency_cost = 0;
            } else{
              vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj);
            }

            buyCharge.charge_basis = angular.copy(chargeObj.charge_basis);
            buyCharge.total_units = angular.copy(chargeObj.total_units);
            buyCharge.container_type = angular.copy(chargeObj.container_type);
            buyCharge.is_qty_editable = angular.copy(chargeObj.is_qty_editable);

            if(vm.editBuyRate && buyCharge.total_units && !isNaN(buyCharge.per_unit_rate) ) {
              var buylegData = (vm.search_param.mode !== 'SEA-FCL') ? buyLeg.rate_obj : buyLeg;
              vm.conversionOnPriceChange(buyCharge, buylegData.rate_obj);
            }
        }

        //cost convertion if charge cost or currency change
        function conversionOnPriceChange(charge, sellRates) {
            vm.footerObj.doneBtnDisable = true;

            if(vm.search_param.mode !== 'SEA-FCL' || (vm.search_param.mode === 'SEA-FCL' && (charge.charge_basis === shareQuoteService.pickupBasisName || charge.charge_basis === shareQuoteService.deliveryBasisName || charge.charge_basis === shareQuoteService.freightBasisName))){
            shareQuoteService.isQuoteOrNewcard = 'quote';
                vm.getChargeCost(sellRates,charge);
            }else{
              shareQuoteService.getFclCharge(sellRates, charge, vm.searchUser.user_base_currency);
            }

            vm.fnDisplayProfit();

            $timeout(function(){
              vm.footerObj.doneBtnDisable = false;
            },200);

        }

        //if quotation tab sell rate leg currency change
        function conversionOnLegCurrencyChange(leg_key, leg_currency) {
            vm.footerObj.doneBtnDisable = true;
            shareQuoteService.LegCurrUpdate(vm.currentCard.data.sell_rates, leg_key, leg_currency, vm.search_param.mode, vm.searchUser.user_base_currency);

              var buyKey = '';
              for (var i in vm.currentCard.data.buy_rates) {
                if (i == leg_key) {
                  buyKey = i;
                }
              }

            vm.currentCard.data.buy_rates[buyKey].rate_obj.leg_currency = leg_currency;
            shareQuoteService.LegCurrUpdate(vm.currentCard.data.buy_rates, buyKey, leg_currency, vm.search_param.mode, vm.searchUser.user_base_currency);
            vm.fnDisplayProfit();

            $timeout(function(){
              vm.footerObj.doneBtnDisable = false;
            },200);
        }

        function getChargeCost(leg_data,charge_data){
            shareQuoteService.getChargeCost(leg_data, charge_data, vm.searchUser.user_base_currency);

            if(charge_data.global_charge_id && charge_data.total_units != null){
              var checkCharge = false;
              if( charge_data.global_charge_id.indexOf(shareQuoteService.airChargeId) >= 0){
                vm.currentCard.meta["AirFreight"] = charge_data;
                checkCharge = true;
              }
              // else if( charge_data.global_charge_id.indexOf(shareQuoteService.pickupChargeId) >= 0){
              //   vm.currentCard.meta["pickupCharge"] = charge_data;
              //   checkCharge = true;
              // }else if( charge_data.global_charge_id.indexOf(shareQuoteService.deliveryChargeId) >= 0){
              //   vm.currentCard.meta["deliveryCharge"] = charge_data;
              //   checkCharge = true;
              // }else if( charge_data.global_charge_id.indexOf(shareQuoteService.freightChargeId) >= 0){
              //   vm.currentCard.meta["freightCharge"] = charge_data;
              //   checkCharge = true;
              // }

              if(checkCharge){
                vm.checkPercentageBasis(leg_data, charge_data);
              }
            }
        }

        function fnGetBuyChargeCurrency(key_name, id){
            var result = '-';
            if(vm.currentCard.data.buy_rates.hasOwnProperty(key_name)){
                // if(id != null && id != ""){
                    var chargeObj = $filter('filter')(vm.currentCard.data.buy_rates[key_name].rate_obj.charges,{'id' : id }, true);
                    result = chargeObj.length ? chargeObj[0].charge_currency  : '-';
                // }
            }
            return result;
        }

        function fnGetBuyMinAmount(key_name, id){
            var result = '-';
            var chargeObj = $filter('filter')(vm.currentCard.data.buy_rates[key_name].rate_obj.charges,{'id' : id }, true);
            result = chargeObj.length ? chargeObj[0].minimum_charge_cost  : '-';
            return result;
        }

        function fnGetBuyUnitPrice(key_name, id){
            var result = '-';

            if(vm.currentCard.data.buy_rates.hasOwnProperty(key_name)){
                // if(id != null && id != ""){
                    var chargeObj = $filter('filter')(vm.currentCard.data.buy_rates[key_name].rate_obj.charges,{'id' : id }, true);
                    result = chargeObj.length ? $filter('number')(chargeObj[0].per_unit_rate, 2) : '-';
                // }
            }
            return result;
        }

        function fnGetBuyChargeLegCurrencyCost(key_name, id){
            var result = '-';

            if(vm.currentCard.data.buy_rates.hasOwnProperty(key_name)){
                // if(id != null && id != ""){
                    var chargeObj = $filter('filter')(vm.currentCard.data.buy_rates[key_name].rate_obj.charges,{'id' : id }, true);
                    result = chargeObj.length ? $filter('number')(chargeObj[0].leg_currency_cost, 2) : '-';
                // }
            }
            return result;
        }

        //charge autocomplete object
        function changeSelectedCharge(selectedName, charge, legValue, index, legKey) {

            if(selectedName && !!(selectedName.source)){
                charge['source'] = selectedName.source;
                charge['source_data'] = selectedName.source_data;
            }

            if(vm.search_param.mode === 'SEA-FCL'){
                if (selectedName != null) {
                  charge.charge_name = selectedName.charge_name;
                  charge.charge_id = selectedName.charge_id;
                  charge.global_charge_id = selectedName.global_charge_id;
                  charge.container_type = (legValue.leg_code != 'ins_fcl') ? selectedName.load_code : null;
                  charge.charge_basis = selectedName.charge_basis;
                  charge.total_units = 0;
                  charge.per_unit_rate =  selectedName.per_unit_rate ? selectedName.per_unit_rate : 0 ;
                  charge.charge_currency = selectedName.charge_currency ? selectedName.charge_currency : legValue.rate_obj.leg_currency;
                  charge.charge_category = selectedName.charge_category;
                  charge.charge_code = selectedName.charge_code;
                }
                else {
                  charge.charge_id = "";
                  charge.global_charge_id = "";
                }
            }else{
              if(selectedName.charge_category){
                charge.charge_category = selectedName.charge_category;
              }
              shareQuoteService.changeSelectedCharge(selectedName, charge, legValue, index,legKey);
            }

              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_name = angular.copy(charge.charge_name);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_id = angular.copy(charge.charge_id);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].global_charge_id = angular.copy(charge.global_charge_id);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].container_type = angular.copy(charge.container_type);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_basis = angular.copy(charge.charge_basis);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].total_units = angular.copy(charge.total_units);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_category = angular.copy(charge.charge_category);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_code = angular.copy(charge.charge_code);
            if(vm.editBuyRate){
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].per_unit_rate = angular.copy(charge.per_unit_rate);
              vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_currency = angular.copy(charge.charge_currency);
            }

            if(vm.search_param.mode === 'SEA-FCL'){
              vm.fnChangeBasis(charge, legValue, index, vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index],vm.currentCard.data.buy_rates[legKey],legKey);
            }else{
              vm.conversionOnPriceChange(charge,legValue);
              if(vm.editBuyRate){
                vm.conversionOnPriceChange(vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index], vm.currentCard.data.buy_rates[legKey].rate_obj);
              }
            }
        }

        //autocomplete charge text change
        function changeTextCharge(charge, index, leg_code) {
            if(vm.search_param.mode === 'SEA-FCL'){
                charge.charge_id = "";
                charge.global_charge_id = "";
            }else{
                if(charge.global_charge_id != null && charge.global_charge_id != "" && (charge.global_charge_id.indexOf(shareQuoteService.airChargeId)) >= 0){
                  vm.checkPercentageBasis(null, null);
                }
                charge.charge_id = "";
                charge.global_charge_id = "";
            }
            charge.charge_category = null;
            charge.charge_code = charge.charge_name.toLowerCase().replace(/ /g,"_")+'_'+vm.shareQuoteService.fnGuuid();
            vm.currentCard.data.buy_rates[leg_code].rate_obj.charges[index].charge_name = angular.copy(charge.charge_name);
        }

        //  close dialog function
        function cancelDialog() {
            $mdDialog.hide();
        }

        function openDeleteCard(ev, carddata, index, actionType){
            vm.fnTrackAnalytics('ID-'+actionType+'-Click');
            vm.callback({card : {'currentCard' : carddata, 'action' : 'manualCardDelete' }});
        }

        function openEditCardModal(ev, carddata){
            vm.callback({card : {'currentCard' : carddata, 'action' : 'manualCardEdit' }});
        }

        function removeCardFromQuote(ev,card_id, index){
            document.getElementById(card_id +'_'+index+ '_askDeletecard').classList.add("hide");
            document.getElementById(card_id +'_'+index+ '_deletecard').classList.remove("hide");
            // document.getElementById(card_id + '_card').classList.add("hide");

            var getCardData = $filter('filter')(vm.quote_CardData, { '_id': card_id }, true);

            if(getCardData[0].meta["status"] == "modified"){
              getCardData[0].meta["status"] = "editRemove";
            }else if(getCardData[0].meta["status"] == "new"){
              getCardData[0].meta["status"] = "newRemove";
            }else{
              getCardData[0].meta["status"] = "remove";
            }
            vm.isQuoteModify = true;
            // vm.ifInitQuoteModify();
        }

        function cancelDeleteCard(ev,card_id, index){
            document.getElementById(card_id +'_'+index+ '_askDeletecard').classList.add("hide");
            document.getElementById(card_id +'_'+index+ '_deletecard').classList.add("hide");
        }

        function undoDeleteCard(ev,card_id, index){
            document.getElementById(card_id +'_'+index+ '_askDeletecard').classList.add("hide");
            document.getElementById(card_id +'_'+index+ '_deletecard').classList.add("hide");
            // document.getElementById(card_id + '_card').classList.remove("hide");
            var getCardData = $filter('filter')(vm.quote_CardData, { '_id': card_id }, true);

            if(getCardData[0].meta["status"] == "editRemove"){
              getCardData[0].meta["status"] = "modified";
              vm.isQuoteModify = true;
            }else if(getCardData[0].meta["status"] == "newRemove"){
              getCardData[0].meta["status"] = "new";
              vm.isQuoteModify = true;
            }else{
             delete getCardData[0].meta["status"];
            }
            // vm.ifInitQuoteModify();
        }

        function fnUndoChanges(ev){
            var confirm = $mdDialog.confirm()
              // .title('Warning')
              .textContent('All your changes will be lost, do you want to continue?')
              .ariaLabel('discard')
              .targetEvent(ev)
              .ok('Yes, Proceed')
              .cancel('No, Cancel');

            $mdDialog.show(confirm).then(function () {
              var className = document.querySelectorAll('.overlayCard');

              className.forEach(function(element) {
                element.classList.add('hide');
              });

              vm.isQuoteModify = false;
              vm.showTermsConditions = false;
              vm.quote_result = angular.copy(vm.temp_quoteData);
              vm.search_param = angular.copy(vm.tempSearch_param );
              resultService.setLegFilter( vm.filterConfig, vm.search_param );
              vm.quote_CardData = angular.copy(vm.quote_result.result_data.cards);
              if(vm.newSearchFetch){
                vm.newSearchFetch = false;
                vm.fnSearchNewRates();
              }
            }, function () {
              return true;
            });
        }

        // function to determine leg load Missing or not
        function isLegLoadMissing (loadObj, Key) {
            return resultService.isLegLoadMissing(loadObj, Key);
        }

        function legPerUnitCost(rateObj){
            var leTotal = 0;

            angular.forEach(rateObj.charges, function (value) {
                leTotal += parseFloat(value.leg_currency_cost / value.total_units);
            });
            return leTotal;
        }

        function loadMoreRecords() {
            vm.chargeShow += 2;
        }

        vm.maxHeight = {
            "max-height": '200px'
        }

        vm.hoverIn = function () {
        this.hoverEdit = true;
        };

        vm.hoverOut = function () {
        this.hoverEdit = false;
        };

        vm.hoverTransitIn = function () {
        this.hoverTransitEdit = true;
        };

        vm.hoverTransitOut = function () {
        this.hoverTransitEdit = false;
        };

        function fnGetLinerList(){
            if(!util.getSubvendor.length){
                resultService.getSubVendor().then(function(response){
                    angular.forEach(response.data.subvendor_data, function(item){
                        if(item.carrier_code != null && item.carrier_code != ""){
                            vm.getSubvendor.push(item);
                            util.getSubvendor = angular.copy(vm.getSubvendor);
                        }
                    });
                },function(error){
                    vm.getSubvendor = [];
                    util.getSubvendor = [];
                });
            }else{
                vm.getSubvendor = angular.copy(util.getSubvendor);
            }
        }

        function fnGetAirlineList(){
          if(!util.getAirline.length){
            resultService.getAirlineData().then(function(response){
                vm.getAirline = response.data.data;
                util.getAirline = angular.copy(vm.getAirline);
            },function(error){
                vm.getAirline = [];
                util.getAirline = [];
            });
          }else{
              vm.getAirline = angular.copy(util.getAirline);
          }
        }

        function fngetSubVendorDetails(cardMeta, rate_data) {
            if(vm.search_param.mode == 'AIR'){
              for (var i = 0; i < vm.getAirline.length; i++) {
                if (vm.getAirline[i].airline_code == rate_data.airline_code) {
                  rate_data.airline.airline_code = vm.getAirline[i].airline_code;
                  rate_data.airline.air_line_name = vm.getAirline[i].air_line_name;
                  rate_data.airline.airline_prefix = vm.getAirline[i].airline_prefix;
                  cardMeta.selected_schedule = null;
                  rate_data.schedule.data = [];
                  rate_data.schedule.url = null;
                  vm.schedule_display = false;
                  return;
                }
              }
            }else{
              for (var i = 0; i < vm.getSubvendor.length; i++) {
                if (vm.getSubvendor[i].id == rate_data.sub_vendor_id) {
                  rate_data.sub_vendor_id = vm.getSubvendor[i].id;
                  rate_data.sub_vendor.logo = vm.getSubvendor[i].logo;
                  rate_data.sub_vendor.sub_vendor_name = vm.getSubvendor[i].name;
                  rate_data.sub_vendor.carrier_code = vm.getSubvendor[i].carrier_code;
                  cardMeta.selected_schedule = null;
                  rate_data.schedule.data = [];
                  rate_data.schedule.url = null;
                  vm.schedule_display = false;
                  return;
                }
              }
            }
        }

        function fnGetContainerQty(leg_data,charge_data, action, charge_index, buyCharge, buyLeg, param){
            if( charge_data.charge_basis != '' || charge_data.charge_basis != null){
              if(param != 'quantity'){
                var payload = {
                  "charge" : charge_data,
                  "load_meta" : vm.search_param.load_data.load_meta,
                  "airFreightValue" : (vm.currentCard.meta["AirFreight"] != null) ? vm.currentCard.meta["AirFreight"].leg_currency_cost : null,
                  "pickupValue" : (vm.currentCard.meta["pickupCharge"] != null) ? vm.currentCard.meta["pickupCharge"].leg_currency_cost : null,
                  "deliveryValue" :  (vm.currentCard.meta["deliveryCharge"] != null) ? vm.currentCard.meta["deliveryCharge"].leg_currency_cost : null,
                  "global_leg_id" : leg_data.global_leg_id,
                  "ltl_load_details" : vm.currentCard.meta["ltl_load_details"],
                  "mode" : vm.search_param.mode,
                  "dimChargeableValue" : leg_data.dim_data && leg_data.dim_data.chargeable_weight_in_kg !== 0 ? leg_data.dim_data.chargeable_weight_in_kg : null
                }

                shareQuoteService.fnGetContainerQty(payload);
              }

              if(charge_data.total_units == null) {
                charge_data.charge_cost = 0;
                charge_data.leg_currency_cost = 0;
              }
              else if(charge_data.total_units != null && charge_data.per_unit_rate !== null && charge_data.per_unit_rate !== 0) {
                  vm.conversionOnPriceChange(charge_data,leg_data);
              }

              buyCharge.charge_basis = angular.copy(charge_data.charge_basis);
              buyCharge.total_units = angular.copy(charge_data.total_units);
              buyCharge.is_qty_editable = angular.copy(charge_data.is_qty_editable);

              if(vm.editBuyRate && buyCharge.total_units != null && buyCharge.per_unit_rate !== null && buyCharge.per_unit_rate !== 0) {
                vm.conversionOnPriceChange(buyCharge, buyLeg);
              }
            }
        }

        function checkPercentageBasis(legs, charge_data){
            if(shareQuoteService.isQuoteOrNewcard == 'newCard'){
              fnChargeLoop(legs);
            }
            else{
            angular.forEach(vm.currentCard.data.sell_rates,function(value, key){
              fnChargeLoop(value.rate_obj);
            });
            }
            function fnChargeLoop(legRateObj){
              angular.forEach(legRateObj.charges,function(childValue){
                if( childValue.charge_basis === constObj.AIR_FREIGHT_BASIS ){
                  childValue.total_units = (charge_data != null) ? charge_data.leg_currency_cost : null;
                  shareQuoteService.getChargeCost(legRateObj, childValue, vm.searchUser.user_base_currency);
                }
              });
            }
        }

        // Function to get widget back height
        function getWidgetHeight(){
          return angular.element('.custom-add-back').height();
        }

        function fnCheckIsNaN(charge, param){
          var result = '';
          if(param == 'per_unit_rate'){
           if(angular.isString(charge.per_unit_rate)){
               result = charge.per_unit_rate;
           }else{
               result =  $filter('number')(charge.per_unit_rate, 2);
           }
          }else{
           if(!charge.min_flag && angular.isString(charge.charge_cost)){
               result = charge.charge_cost;
           }else{
               result =  $filter('number')(charge.leg_currency_cost, 2);
           }
           }
          return result;
        }

        function isString(data) {
          if(typeof data === 'string') {
            return true;
          } else {
            return false;
          }
        }
        function downloadSourceRate(currCard){
          var batchcode=[]
          batchcode=resultService.getBatchcode(currCard)
          if(batchcode.length){
            resultService.getSourceRate(batchcode).then(function(response){
              vm.sourceRate=angular.copy(response.data.data);
            })
          }
        }
        //Mixpanle code

        function fnTrackAnalytics(action, params){
          if(!params){
              var params = {};
          }
          params.mode = vm.search_param.mode;
          util.callMixpanel(action, params);
        }

        function freeDaysTabView(){
          vm.viewActiveTab = 'loadWiseFreeDays';
        }

        function selectMultiSchedule(selectedSchedule , isSelected){
          if(vm.multi_schedule_list && vm.multi_schedule_list.length == 15 && selectedSchedule.isSelected){
            selectedSchedule.isSelected = false;
            util.showToast("Maximum limit reached - 15");
            return;
          }
          if(!selectedSchedule.isSelected){
              vm.multi_schedule_list = vm.multi_schedule_list.filter(function(schedule){
                return schedule.id != selectedSchedule.id
              })
              // removing current schedule if it's removed from multi schedule list
              if(vm.current_schedule && (selectedSchedule.id ==  vm.current_schedule.id)){
                vm.current_schedule = null
                vm.current_schedule = vm.multi_schedule_list.length ? vm.multi_schedule_list[0] : null;
              }
           
          }else{
            // setting the first selected schedule from multi schedule as a current schedule if it is empty
            vm.current_schedule = vm.current_schedule ? vm.current_schedule : (!vm.multi_schedule_list.length ? selectedSchedule : null );
            vm.multi_schedule_list.push(selectedSchedule)
            
          }
          vm.selectedSchedule(vm.current_schedule , "scheduleSelection");
  
        }

        function fnScheduleOldData(type){
          vm.multi_schedule_list = vm.currentCard.meta.multi_schedule_list || [];
          // storing old rates schedule on multi list
          if(vm.current_schedule && vm.current_schedule.schedule_track){
            if(!vm.multi_schedule_list.length){
                vm.current_schedule["isSelected"] = true;
                vm.multi_schedule_list.push(vm.current_schedule);
            }
            angular.forEach(vm.scheduleList ,function(schedule){
              if(schedule.id == vm.current_schedule.id){
                schedule["isSelected"] = true
              }
            });
          }
          if(type){
            angular.forEach(vm.scheduleList ,function(scheduleFromDB){
              angular.forEach(vm.multi_schedule_list ,function(scheduleFromMulti){
                if(scheduleFromDB.id == scheduleFromMulti.id){
                  scheduleFromDB["isSelected"] = true
                }
              });
            });
          }
        }

        function fnClearAllSchedule(){
          if(vm.multi_schedule_list && vm.multi_schedule_list.length) {
                vm.current_schedule = null;
                vm.multi_schedule_list = [];
                angular.forEach(vm.scheduleList ,function(schedule){
                  schedule["isSelected"] = false;
                })
                vm.selectedSchedule();
          }
      }

        // get the list of ports from api
        // function getPort(searchText, mode) {

        // var modeName = (mode != 'AIR') ? 'SEA' : 'AIR';
        //   searchText = $sanitize(searchText);
        //   return util.getPorts(searchText, modeName).then(function (response) {
        //     return response.data.data.port;
        //   }, function (error) {
        //     $log.log(error.data);
        //     return [];
        //   });
        // }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.track-n-trace', ['datatables','moment-picker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
        .state('app.track-n-trace', {
            url  : '/track-n-trace',
            views: {
                'content@app': {
                    templateUrl: 'app/main/track-n-trace/track-n-trace.html',
                    controller : 'TrackTraceController as vm'
                },
                data : { pageTitle: 'track-n-trace' }
            },
            resolve : {
            },
            bodyClass: 'track-n-trace'
        })
        .state('app.track-n-trace.track-n-trace-details', {
            url  : '/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/track-n-trace/track-n-trace-details/track-n-trace-details.html',
                    controller : 'TrackTraceDetailController as vm'
                },
                data : { pageTitle: 'track-n-trace-details' }
            },
            resolve: {
                
            },
            bodyClass: 'track-n-trace-details'
        });
         // Translation
        // $translatePartialLoaderProvider.addPart('app/main/track-n-trace');

        // msNavigationServiceProvider.saveItem('fuse.track-n-trace', {
        //     title    : 'Track and Trace',
        //     icon     : 'icon-map-marker',
        //     state    : 'app.track-n-trace',
        //     // translate: 'UPLOADRATES.UPLOADRATES_NAV',
        //     weight   : 1
        // });
    }

})();
(function () {
    'use strict';

    angular
      .module('app.track-n-trace')
      .controller('TrackTraceDetailController', TrackTraceDetailController);

    /** @ngInject */
    function TrackTraceDetailController(util,TrackService,$state,$stateParams,$log,$mdDialog,$filter) {

        var vm = this;
        vm.util = util;
        vm.trackingDetail = {};
        vm.isMilestoneUpdate =  false;
        vm.goBack =  goBack;
        vm.openAddMilestoneModal = openAddMilestoneModal;
        vm.submitMilestone = submitMilestone;
        vm.openEditMilestoneModal = openEditMilestoneModal;
        vm.getPort = util.getPorts;
        vm.cancelDialog = cancelDialog;
        vm.formLoadStructure = formLoadStructure;
        vm.currentShipment =   TrackService.currentShipment;
        vm.FromPage = TrackService.FromPage;
        vm.trackingNumber = '';
        vm.addMileStone  =  addMileStone;
        vm.updateMilestone =  updateMilestone;
        vm.deleteMilestone =  deleteMilestone;
        vm.fnDeleteData = fnDeleteData;
        vm.getSelectedPortData = getSelectedPortData;

        function init(){
            getTrackingData();

            if(!TrackService.milestonesList.length){ // calling the milestones list
                getMilestonesList();
            } else{
                vm.milestonesList = TrackService.milestonesList;
            }
            vm.trackingNumber =  $stateParams.id;
        }

        init();

        /**
         * function used to get the Deatils of Tracking of Data
         */
        function getTrackingData(){
            util.isCallingApi=true;
            vm.trackAirShimmer = true;
            TrackService.getTrackingDetail($stateParams.id ).then(function(response){
                vm.trackingDetail = response.data;
                vm.trackingStatus = vm.trackingDetail.tracking;
                vm.tracking_id = vm.trackingDetail._id;
                util.isCallingApi=false;
                vm.trackAirShimmer = false;
            },function(error){
                util.isCallingApi=false;
                vm.trackAirShimmer = false;
                util.showToast(util.displayValidationError(error));
                $log.log(error);
            });
        }


        /**
         * function used to get the Milestones list of data
         */
        function getMilestonesList(){
            TrackService.getMilestonesList().then(function(response){
                vm.milestonesList =  response.data;
                TrackService.milestonesList = angular.copy(vm.milestonesList);
            },function(error){
                console.log(error);
            });
        }

        function goBack() {
         $state.go('app.track-n-trace');
        }

        /**
         *  get the list of ports from api
         *  @param searchText
         */
        // function getPort(searchText,mode){
        //     searchText = $sanitize(searchText);
        //     // var url =  api.baseUrl + '/api/port';
        //     // var data =  {"data" :  {'mode': mode,'search_query' : searchText }};
        //     return util.getPorts(searchText, mode).then(function(response){
        //         return response.data.data.port;
        //     },function(error){
        //         $log.log(error.data);
        //         return [];
        //     });
        // }

         // function to open add milestone modal
        function openAddMilestoneModal(events,ev){
            vm.isMilestoneUpdate = false;
            vm.currentEventList = events ? events : [];
            var milestones = {
                'weight': {
                'UOM': 'KG'
                    },
                'time_stamp_actual': null,
                'time_stamp_planned': null,
            };
            vm.milestoneData = angular.copy(milestones);
            vm.portData = [];
            $mdDialog.show({
                templateUrl        : 'app/main/track-n-trace/dialogs/add-milestone/add-milestone.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        //function to submit milestone
        function submitMilestone(milestoneEvent){
            if(vm.isMilestoneUpdate ){
                vm.updateMilestone(milestoneEvent);
            }else{
                vm.addMileStone(milestoneEvent);
            }
        }

        /**
         * functiomn to add the milestone data
         * @param {*} milestoneEvent
         */
        function addMileStone(milestoneEvent){

            var codeData = vm.milestonesList.find(function(element) {
                return element.code === milestoneEvent.code;
            });

            if(!codeData){
                util.showToast('Milestone Details Required!');
                return;
            }

            var milestoneData = {
                'weight': {
                'UOM': milestoneEvent.weight.UOM,
                'value': milestoneEvent.weight.value
                },
                'code':   milestoneEvent.code ,
                'flight_number': milestoneEvent.flight_number,
                'details': milestoneEvent.details,
                'code_desc': codeData.desc,
                'no_of_pieces': milestoneEvent.no_of_pieces,
                'port_code': vm.portData ? vm.portData.port_code : '',
                'time_stamp_actual':  moment(milestoneEvent.time_stamp_actual2).utc().toISOString() ,
                'time_stamp_planned':  moment(milestoneEvent.time_stamp_planned2).utc().toISOString()
              };

            if(!milestoneEvent._id){
                var postData = angular.copy(vm.currentEventList);
                postData.push(milestoneData);
                var postMilestoneData = {
                    'data' : {
                        'events' :postData
                    }
                };
                TrackService.updateMilestones(postMilestoneData,vm.tracking_id).then(function(response){
                    vm.trackingDetail.events = response.data.events;
                    util.showToast('Milestones Added Successfully');
                    vm.cancelDialog();
                },function(error){
                    vm.cancelDialog();
                    console.log(error);
                });
            }

        }

        /**
         * function to update the milestone data
         * @param {*} milestoneEvent
         */
        function updateMilestone(milestoneEvent){
            var codeData = vm.milestonesList.find(function(element) {
                return element.code === milestoneEvent.code;
            });
            var milestoneData = {
                'weight': {
                'UOM': milestoneEvent.weight.UOM,
                'value': milestoneEvent.weight.value
                },
                'code':   milestoneEvent.code ,
                'flight_number': milestoneEvent.flight_number,
                'details': milestoneEvent.details,
                'code_desc':codeData.desc,
                'no_of_pieces': milestoneEvent.no_of_pieces,
                'port_code': vm.portData ? vm.portData.port_code : '',
                'time_stamp_actual':  moment(milestoneEvent.time_stamp_actual2).utc().toISOString() ,
                'time_stamp_planned':   moment(milestoneEvent.time_stamp_planned2).utc().toISOString(),
                '_id' : milestoneEvent._id
              };

                var putData = vm.currentEventList;
                putData[vm.editMilestoneIndex] = milestoneData;
                var putMilestoneData = {
                    'data' : {
                        'events' : vm.currentEventList
                    }
                };
                TrackService.updateMilestones(putMilestoneData,vm.tracking_id).then(function(response){
                    vm.trackingDetail.events = response.data.events;
                    util.showToast('Milestones Updated Successfully');
                    vm.cancelDialog();
                },function(error){
                    vm.cancelDialog();
                    console.log(error);
                });


        }



        /**
         * function to open confirm delete milestone modal
         * @param {*} milestonesList
         * @param {*} milestoneEvent
         * @param {*} index
         * @param {*} ev
         */
        function deleteMilestone(milestonesList,index,ev){
           vm.deleteMilestoneList =  milestonesList;
           vm.deleteIndex = index;
            $mdDialog.show({
                templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () {
                this.parent = vm
                }
            });

        }

        //function to delete the milestone
        function fnDeleteData(){
            var putData = angular.copy(vm.deleteMilestoneList);
            vm.deleteBtn = true;
            putData.splice(vm.deleteIndex,1);

            var putMilestoneData = {
                'data' : {
                    'events' : putData
                }
            };
            TrackService.updateMilestones(putMilestoneData,vm.tracking_id).then(function(response){
                vm.trackingDetail.events = response.data.events;
                util.showToast('Milestones Deleted Successfully');
                vm.deleteBtn = false;
                vm.cancelDialog();
            },function(error){
                vm.cancelDialog();
                console.log(error);
            });
        }

        // function to open edit milestone modal
        function openEditMilestoneModal(milestonesList,milestoneEvent,index,ev){
            vm.portData = vm.getSelectedPortData(milestoneEvent.port_code);
            vm.isMilestoneUpdate =  true;
            vm.currentEventList = milestonesList;
            milestoneEvent.time_stamp_actual =   moment(milestoneEvent.time_stamp_actual).toDate();
            milestoneEvent.time_stamp_planned =  moment(milestoneEvent.time_stamp_planned).toDate();

            vm.milestoneData = angular.copy(milestoneEvent);
            vm.editMilestoneIndex = index;
            $mdDialog.show({
                templateUrl        : 'app/main/track-n-trace/dialogs/add-milestone/add-milestone.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        //function to get port data for selected port
        function getSelectedPortData(port_code){
            if(port_code){
                 util.getPorts(port_code, 'AIR').then(function(response){
                    var portList = response;
                    vm.portData = portList.find(function(element) {
                        return element.port_code === port_code;
                    });
                },function(error){
                    $log.log(error.data);
                });
            }else{
                vm.portData = [];
            }
        }

        //function to close modal
        function cancelDialog(){
            $mdDialog.hide();
        }

        /**
         * function to get the load details
         * @param {*} load_data
         */
        function formLoadStructure(load_data){
            var load_arr = [];
            angular.forEach(load_data.load_details_value, function(value,key){
                 angular.forEach(value.load_metrics, function(childvalue,childkey){
                     Object.assign(childvalue,{'load_number' : value.load_number});
                     load_arr.push(childvalue);
                 });
            });
            return load_arr;
         }


    }
})();

(function(){

    'use strict';

    angular
        .module('app.track-n-trace')
        .factory('TrackService' , TrackService);

        /** @ngInject */
        function TrackService($http,api,util, localStorageService, $rootScope){

            var trackService = {
                airLineData : [],
                milestonesList : [],
                shipmentList : [],
                recentTrackings : [],
                currentShipment : {},
                FromPage : 'Tracking',

                getAIrlineData : getAIrlineData,
                getRecentTrackings : getRecentTrackings,
                createTracking : createTracking,
                getTrackingDetail : getTrackingDetail,

                getManulalShipments  : getManulalShipments,
                getShipmentTrackings : getShipmentTrackings,
                getSeaTracking : getSeaTracking,
                filterShipments : filterShipments,
                updateMilestones : updateMilestones,
                getMilestonesList : getMilestonesList,
                exportShipments : exportShipments,
                editShipment : editShipment,
                getEachTrackingDetail : getEachTrackingDetail,
                offset : 0,
                deleteTrackData : deleteTrackData,
                // getPorts :  getPorts,
                fnSendTrackFile : fnSendTrackFile,
                getSeaMilestones : getSeaMilestones,
                editSeaContainer : editSeaContainer,
                createByFileSeaTracking : createByFileSeaTracking,
                getTrackSubVendor : getTrackSubVendor,
                getBlContainerTracking:getBlContainerTracking,
                getAirShipmentTrackingDetail: getAirShipmentTrackingDetail
            };
            return trackService;


            // Shipment realated functions

            function getManulalShipments(payload) {
              var data = {
                'data': payload
              }

              return $http.post($rootScope.forwarder_id ? api.baseUrl + '/api/shipments-list?forwarder_company_id=' + $rootScope.forwarder_id : api.baseUrl + '/api/shipments-list', data).then(function(response){
                  return response.data.data;
              });
            }

            function exportShipments(url) {
              return $http.get(api.baseMockUrl + '/manual-shipments-excel?shipments=' + url + util.fnGetForwarderIdApi('&')).then(function(response){
                  return response.data;
              });
            }

            function editShipment(data, url) {
              return $http.put(api.baseMockUrl + '/shipments/' + url, data).then(function(response){
                  return response.data;
              });
            }

            function getEachTrackingDetail(data) {
              return $http.post(api.baseMockUrl + '/air-tracks', data).then(function(response){
                return response.data;
            });
            }

            function getShipmentTrackings(data){
                return $http.get('https://4b4b3e47-8531-4e72-8d48-bdff0ad21a34.mock.pstmn.io/api/sea-container-track?page=1');
            }


            function getSeaTracking(data){
              return $http.get(api.baseMockUrl + '/fcl-container-track?container_id=' + data.container_no + '&type=' + data.type + '&liner=' + data.liner.carrier_code + '&linername=' + data.liner.carrier_name);
            }

            function createByFileSeaTracking(fileData){
                var authToken = '';
                var auth = {};
                authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
                auth = {
                    'authorization': authToken,
                    'referer-domain' : $rootScope.domainData.host_name
                };

                var settings = {
                    "async": true,
                    "crossDomain": true,
                    "url":  api.baseMockUrl + '/fcl-track/file',
                    "method": "POST",
                    "headers": auth,
                    "processData": false,
                    "contentType": false,
                    "mimeType": "multipart/form-data",
                    "data": fileData
                };

                return $.ajax(settings).done(function (response) {
                    return response;
                });
            }


            function filterShipments(data){
                return $http.post(api.baseMockUrl + '/fcl-track/list' + util.fnGetForwarderIdApi('?'), data).then(function(response){
                    return response.data;
                });
            }

            function getSeaMilestones(subscription_id){
                return $http.get(api.baseMockUrl + '/fcl-container-track/'+subscription_id);
            }


            /**
             * function to get AIrLine List using in searching the airline
             */
            function getAIrlineData(){
               return  $http.get(api.baseMockUrl+'/track-airlines'+ util.fnGetForwarderIdApi('?')).then(function(response){
                    return response.data;
                });
            }

            /**
             * functio to get latest tracking list of loggedin user
             */
            function getRecentTrackings(){
                return $http.get(api.baseMockUrl + '/air-track-search'+ util.fnGetForwarderIdApi('?')).then(function(response){
                    return response.data;
                });
            }

            /**
             *  function to submit the tracking request to backend
             */
            function createTracking(payload){
                return $http.post(api.baseMockUrl + '/air-track-search', payload).then(function(response){
                    return response.data;
                });
            }

            /**
             * function to get tracking details by passing tracking id or AWB no
             * @param {*} id
             */
            function getTrackingDetail(id){
                return $http.get(api.baseMockUrl + '/air-track/'+id + util.fnGetForwarderIdApi('?')).then(function(response){
                    return response.data;
                });
            }

            function getMilestonesList(){
                return $http.get(api.baseMockUrl + '/airlines-milestone-list'+ util.fnGetForwarderIdApi('?')).then(function(response){
                    return response.data;
                });
            }

            function updateMilestones(data,id){
               return $http.put(api.baseMockUrl + '/air-track/'+id, data).then(function(response){
                    return response.data;
                });
            }

            function deleteTrackData(id, data){
                return $http.delete(api.baseMockUrl + '/air-track-search/'+id, data).then(function(response){
                    return response.data;
                });
            }

            function fnSendTrackFile(id, trackFile){
                var authToken = '';
                var auth = {};

                authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
                auth = {
                    'authorization': authToken,
                    'referer-domain' : $rootScope.domainData.host_name
                };

                var settings = {
                  "async": true,
                  "crossDomain": true,
                  "url":  api.baseUrl +'/api/s3upload',
                  "method": "POST",
                  "headers": auth,
                  "processData": false,
                  "contentType": false,
                  "mimeType": "multipart/form-data",
                  "data": trackFile
                };

                return $.ajax(settings).done(function (response) {
                    return response;
                });
            }

            function editSeaContainer(data){
                return $http.patch(api.baseMockUrl + '/fcl-track/edit', data).then(function(response){
                    return response.data;
                });
            }

            //get sub vendor list for create new card
            function getTrackSubVendor(){
                var url = api.baseMockUrl + '/subvendor?source=tracking';
                return $http.get(url);
            }

            function getBlContainerTracking(data){
                var parameters = Object.entries(data).map(function(e){ return e.join('=') }).join('&');
                return $http.get(api.baseMockUrl + '/fcl-track?' + parameters);
                
            }

            // Function to get tracking data for air in shipments
            function getAirShipmentTrackingDetail(shipment_id){
                var url = api.baseMockUrl + '/shipments/'+shipment_id+'/tracks';
                return $http.get(url);
            }

        }

})();

(function () {

  'use strict';

  angular
    .module('app.inquiry')
    .factory('StandardQuotationService', StandardQuotationService);

  /** @ngInject */
  function StandardQuotationService($http, api,$q,util,$state) {
    var standardQuotationService = {
      standardQuoationData: '',
    }
    return standardQuotationService;
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.specialRates', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
        .state('app.search.specialRates', {
            url  : '/specialRates',
            views: {
                'content@app': {
                    templateUrl: 'app/main/specialRates/specialRates.html',
                    controller : 'specialRatesController as vm'
                },
                data : { pageTitle: 'Special Rates' }
            },
            resolve : {
                SpecialRatesData: function(SpecialRatesService,util,$state){
                    util.isCallingApi = true;
                    return SpecialRatesService.getSpecialRates().then(function(response){
                        util.isCallingApi = false;
                        return response.data;
                    },function(error){
                        util.isCallingApi = false;
                        $state.go(util.redirectIfError(error));
                    });
                },
                SearchParam : function(msApi){
                    return msApi.resolve('search@get');
                }
            },
            bodyClass: 'special-rates'
        })

         // Translation
        // $translatePartialLoaderProvider.addPart('app/main/specialRates');
    }

})();
(function(){

    'use strict';

    angular
        .module('app.specialRates')
        .factory('SpecialRatesService' , SpecialRatesService);

        /** @ngInject */
        function SpecialRatesService($q,$log,$mdToast,$state,$http,api, $filter,util,loginSerivice){

            var specialRatesService = {
                getSpecialRates : getSpecialRates,
                getLanes : getLanes,
                specialFinalArray :[],
                fnSortLane : fnSortLane,
                getRatesExpiry : getRatesExpiry
            }
            return specialRatesService;

            function getSpecialRates(){
                // if(!util.isSharedQuote() && loginSerivice.isLogin()) {
                  var url = api.baseUrl + '/api/special-rates' + util.fnGetForwarderIdApi('?');
                  return $http.get(url);
                //   return $http.get(url).then(function(response){
                //       return response.data;
                //   },function(error){
                //       $log.error(error);
                //   });
                // }
            }

            function getLanes(){
                var url = api.baseUrl + '/api/lanes';
                return $http.get(url).then(function(response){

                    var len =response.data.data.length +1;
                    response.data.data.push( {"id": len,"lane_code":"Others","lane_name":"Others"} );
                    return response.data;
                },function(error){
                    $log.error(error);
                });
            }

            function fnSortLane(lane, cardArray){
                specialRatesService.specialFinalArray = [];

                angular.forEach(lane, function(item){
                    var displayCard = {"lane" : item, ratesCard : []};

                    angular.forEach(cardArray, function(parentItem){
                        if(parentItem.lane_code == null || parentItem.lane_code == ""){
                            parentItem.lane_code = "Others";
                        }
                       if(displayCard.lane.lane_code == parentItem.lane_code){
                        displayCard.ratesCard.push(parentItem);
                       }
                    })

                    if(displayCard.ratesCard.length){
                        specialRatesService.specialFinalArray.push(displayCard);
                    }
                })
                return specialRatesService.specialFinalArray;
            }


            function getRatesExpiry(specialRates){
                angular.forEach(specialRates, function(parentItem){
                    var maxExpiryDate = parentItem.rates.map(function(childItem){
                        return moment(childItem.expiry);
                    });
                    parentItem["cardExpiry"] = moment.min(maxExpiryDate);
                });
                return specialRates;
            }
        }

})();

(function () {
  "use strict";

  angular
    .module("app.shipments")
    .controller("ShipmentsDetailsController", ShipmentsDetailsController);

  /** @ngInject */
  function ShipmentsDetailsController( $state, ShipmentDetailsData, localStorageService, $scope, ShipmentService, $log, util, Upload, api, $timeout, $http, $mdDialog, $mdMenu, $mdExpansionPanel, $q, $filter, NotificationService, $sanitize, $window, mixPanelToken, resultService, $rootScope, $rootElement, appCache ,shareQuoteService) {
    var vm = this;

    if (typeof ShipmentDetailsData == "undefined") {
      // if no result redirect to search page
      return;
    }
    ShipmentService.shipmentManagementObj = ShipmentDetailsData;
    vm.shareQuoteService = shareQuoteService;
    vm.shipment_data = ShipmentDetailsData.shipment_data;
    vm.shipment_consignee = {};
    vm.shipment_notify_party = {};
    vm.shipment_shipper = {};
    vm.uploadButton = false;

    if (!Object.keys($rootScope.domainData.domain_info).length) {
      util.getDomainData().then(
        function (response) {
          vm.shipmentEdit = $rootScope.domainData.domain_info.SHIPMENT_POL_POD_EDIT;
          vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
        },
        function (error) {
          $log.log(error.data);
        }
      );
    } else {
      vm.shipmentEdit = $rootScope.domainData.domain_info.SHIPMENT_POL_POD_EDIT;
      vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
    }

    //method
    vm.enableResend = false;
    vm.selectFile = selectFile;
    vm.afterShowAnimation = afterShowAnimation;
    vm.showData = true;
    vm.uploadPic = uploadPic;
    vm.checkNull = checkNull;
    vm.displayStatus = displayStatus;
    vm.toggleInfoview = toggleInfoview;
    vm.updateInfo = updateInfo;
    vm.getScheduleDate = getScheduleDate;
    vm.proceedCarrierBooking = proceedCarrierBooking;
    vm.fnDeleteData = fnDeleteData;
    vm.fnGetRateDifference = fnGetRateDifference;
    vm.otpCheck = otpCheck;
    vm.getPort = util.getPorts;
    vm.editConsignee = true;
    vm.editNotify = true;
    vm.editshipper = true;
    vm.dataErr = false;
    vm.sendingOtp = true;
    vm.otpVerified = false;
    vm.isClickEnable = true;
    vm.disableOtpBtn = true;
    vm.showTab = true;
    vm.bookingBtnDisabled = false;

    vm.loadingCarrierBtn = false;
    vm.fncarrierBooking = fncarrierBooking;
    vm.fnCardSelection = fnCardSelection;
    vm.fnOpenCarrierCharges = fnOpenCarrierCharges;

    vm.cancelDialog = cancelDialog;
    vm.shimpent_id_data = {};
    vm.carrierBookingData = {};
    vm.selectedCard = {};
    vm.openStatusMenu = openStatusMenu;
    vm.openExpansionPanel = openExpansionPanel;
    vm.fnOpenChangeStatus = fnOpenChangeStatus;
    appCache.put("shippmentDetailsMeta", ShipmentDetailsData.shipment_meta);
    vm.shipment_meta = appCache.get("shippmentDetailsMeta");
    ShipmentService.shipment_meta = ShipmentDetailsData.shipment_meta;
    vm.shipment_meta.permission = util.splitIntoArray(
      vm.shipment_meta.permission
    );
    vm.dynamicNav = [];
    vm.openExpansionPanel();
    vm.onTabSelected = onTabSelected;
    vm.getAvailableStatus = getAvailableStatus;
    vm.achievedStatus = [];
    vm.availableList = [];
    vm.fnMapStatus = fnMapStatus;
    vm.getModulePermission = getModulePermission;
    vm.getParty = getParty;
    vm.fnOpenEditShipment = fnOpenEditShipment;
    vm.getExperts = getExperts;
    vm.fnSaveEditShipment = fnSaveEditShipment;
    vm.responseStatusData = [];
    vm.selectedPort = selectedPort;
    vm.fnSubmitStatus = fnSubmitStatus;
    vm.fnAddParty = fnAddParty;
    vm.generateOtp = generateOtp;
    vm.checkOtp = checkOtp;
    vm.removeResponse = removeResponse;
    vm.util = util;
    vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER)
    vm.sharedMaskLiner=($rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER && util.isSharedPage())
    vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
    vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
    vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';

    vm.getCarrier = getCarrier;
    vm.goBack = goBack;
    ShipmentService.fromChild = 1;
    ShipmentService.filterParams = {
      count: 30,
      offset: 0,
      mode: "",
      status: "",
      search: "",
    };
    vm.getdynamicTab = getdynamicTab;
    vm.updateShipmentMeta = updateShipmentMeta;
    vm.getAirline = [];
    vm.shipmentDoorPortArray = [];
    vm.fnDisplayPenalty = fnDisplayPenalty;
    vm.formContainerType = formContainerType;
    vm.fnViewInquiryDetails = fnViewInquiryDetails;
    vm.sendToErrType = "";
    vm.erp_data = ShipmentDetailsData.shipment_meta.erp_data;
    vm.loadShimmer = false;
    vm.spinRefreshIcon = false;
    vm.showRefreshButton = $state.current.name === "app.shipments.shipment_details" || $state.current.name === "app.shared_shipment_details" || $state.current.name == "app.mobile_shipment_details";

    // Function to open expansion initially
    function openExpansionPanel() {
      if (!util.isSharedPage()) {
        $mdExpansionPanel()
          .waitFor("shipdetails")
          .then(function (instance) {
            instance.expand();
            // instance.collapse({animation: true});
          });
      }
    }

    function goBack(mode) {
      $state.go("app.shipments");
    }

    function init() {

      util.isModulePaid('shipments');
      if (util.isSharedPage()) {
        setCurrentuuid();
        otpValidation();
        util.createUserData( vm.shipment_meta, vm.uuid, "shipment", mixPanelToken );
      }

      if (!util.isSharedPage()) {
        vm.getCarrier();
      }
      vm.l3_leg = (vm.shipment_meta.mode == 'SEA-FCL') ? 'l3_fcl' : ((vm.shipment_meta.mode == 'AIR') ? 'l3_air' : 'l3_lcl' );
      vm.subvendorList = [];
      vm.getdynamicTab();
      vm.consigneesList = vm.getParty("consignee", "name");
      vm.shipperList = vm.getParty("shipper", "name");
      vm.shipperListCompany = vm.getParty("shipper", "company_name"); //  DEV-4399
      vm.shipperReferenceCompany = vm.getParty("shipper", "external_reference_id");
      vm.ShipmentExpert = vm.getExperts("shipment_expert");
      vm.documentExpert = vm.getExperts("document_expert");
      vm.statusPermission = vm.getModulePermission(
        vm.shipment_data.nav,
        "FEED",
        "status"
      );
      vm.partiesPermission = vm.getModulePermission(
        vm.shipment_data.nav,
        "BOOKING DETAILS",
        "parties"
      );
      vm.getAvailableStatus();
      vm.selectedTab = NotificationService.getActiveTab(
        ShipmentService.shipmentManagementObj.shipment_data.nav
      );

      vm.shipmentDoorPortArray = ShipmentService.fnShipmentDoorPort(
        vm.shipment_meta
      );

      vm.formContainerType(
        vm.shipment_meta.mode,
        vm.shipment_meta.load_data,
        "shipment"
      );
    }
    init();
    $rootScope.$on("initShipmentMeta", function () {
      updateShipmentMeta();
    });
    function getdynamicTab() {
      var ifContainer = $filter("filter")(
        vm.shipment_data.nav,
        { name: "CONTAINERS" },
        true
      );
      // var ifTrack = $filter('filter')(vm.shipment_data.nav, { 'name': "TRACKING" }, true);

      if (vm.shipment_meta.mode == "AIR") {
        if (ifContainer.length) {
          var index = vm.shipment_data.nav.indexOf(ifContainer[0]);
          vm.shipment_data.nav.splice(index, 1);
        }

        // if(ifTrack.length){
        //     var index = vm.shipment_data.nav.indexOf(ifTrack[0]);
        //     vm.shipment_data.nav.splice(index,1);
        // }
      }
      vm.dynamicNav = ShipmentService.createShipmentNav(
        vm.shipment_data.nav,
        vm.shipment_meta.mode
      );
      // find feed and remove
      ShipmentService.shipmentManagementObj.shipment_data.nav.find(function (
        item
      ) {
        var isScheduleTab = false;
        vm.dynamicNav.find(function (nav) {
          if (nav && nav.title === "BOOKING DETAILS") {
            isScheduleTab = true;
          }
        });
        vm.dynamicNav.find(function (nav, index) {
          if (nav && nav.title === "FEED" && isScheduleTab) {
            vm.dynamicNav.splice(index, 1);
          } else if (nav && nav.title === "FEED" && !isScheduleTab) {
            nav.title = "BOOKING DETAILS";
            nav.controller = "shipmentdetailsShipmentController  as vm";
            nav.template =
              "app/main/shipments/tabs/shipmentdetails/shipmentdetails.html";
          }
        });

        // Remove tracking if mode is AIR
        // var ifTrack = $filter("filter")(
        //   vm.dynamicNav,
        //   { title: "TRACKING" },
        //   true
        // );
        // if (vm.shipment_meta.mode === "AIR" && ifTrack.length) {
        //   var index = vm.dynamicNav.indexOf(ifTrack[0]);
        //   vm.dynamicNav.splice(index, 1);
        // }

        // remove product tab : SUP-327
        vm.dynamicNav = vm.dynamicNav.filter(function (item) {
          return item.title != "PRODUCTS";
        });
        return vm.dynamicNav;
      });
      vm.showTab = false;
    }
    function getCarrier() {
      vm.subvendorList = [];
      vm.getAirline = [];
      if (vm.shipment_meta.mode == "AIR") {
        resultService.getAirlineData().then(
          function (response) {
            angular.forEach(response.data.data, function (item) {
              vm.getAirline.push({
                id: item.id,
                name: item.air_line_name,
                code: item.airline_code,
              });
            });
          },
          function (error) {
            vm.getAirline = [];
          }
        );
      } else {
        resultService.getSubVendor().then(
          function (response) {
            angular.forEach(response.data.subvendor_data, function (item) {
              if (item.carrier_code != null && item.carrier_code != "") {
                vm.subvendorList.push(item);
              }
            });
            util.getSubvendor = angular.copy(vm.subvendorList);
          },
          function () {
            vm.subvendorList = [];
            util.getSubvendor = [];
          }
        );
      }
    }
    function removeResponse(id, index) {
      vm.responseStatusData.splice(index, 1);
    }
    function otpCheck() {
      vm.otpError = "";
      if (
        vm.a !== "" &&
        vm.b !== "" &&
        vm.c !== "" &&
        vm.d !== "" &&
        vm.e !== "" &&
        vm.f !== "" &&
        vm.a !== undefined &&
        vm.b !== undefined &&
        vm.c !== undefined &&
        vm.d !== undefined &&
        vm.e !== undefined &&
        vm.f !== undefined &&
        vm.a !== null &&
        vm.b !== null &&
        vm.c !== null &&
        vm.d !== null &&
        vm.e !== null &&
        vm.f !== null
      ) {
        vm.disableOtpBtn = false;
      } else {
        vm.disableOtpBtn = true;
      }
    }

    function updateShipmentMeta(isRefresh) {
      vm.showTab = true;
      if (isRefresh) {
        vm.spinRefreshIcon = true;
        util.callMixpanel("SD-RefreshButton-Click", {
          Mode: vm.shipment_meta.mode,
          "Shipment Status": vm.shipment_meta.current_status.status,
        });
      }
      if (
        $state.current.name === "app.shipments.shipment_details" ||
        $state.current.name === "app.shared_shipment_details" ||
        $state.current.name == "app.mobile_shipment_details"
      ) {
        ShipmentService.getShipmentDetails(ShipmentService.shipment_id).then(
          function (res) {
            appCache.put("shippmentDetailsMeta", res.data.data.shipment_meta);
            vm.shipment_data = res.data.data.shipment_data;
            vm.shipment_meta.co2eData = res.data.data.shipment_meta.co2eData;
            ShipmentService.shipmentManagementObj.shipment_meta = res.data.data.shipment_meta;
            ShipmentService.shipmentManagementObj.shipment_data = angular.copy(
              vm.shipment_data
            );
            vm.spinRefreshIcon = false;
            vm.getdynamicTab();
            vm.consigneesList = vm.getParty("consignee", "name");
            vm.shipperList = vm.getParty("shipper", "name");
            vm.ShipmentExpert = vm.getExperts("shipment_expert");
            vm.documentExpert = vm.getExperts("document_expert");
            vm.shipment_meta.permission = util.splitIntoArray(
              vm.shipment_meta.permission
            );
          },
          function (err) {
            vm.spinRefreshIcon = false;
            util.showToast(util.displayValidationError(err));
            $log.error(err);
            vm.showTab = false;
            $log.error(err);
          }
        );
      } else {
        vm.showTab = false;
      }
    }

    // Set current uuid - by isaac

    function setCurrentuuid() {
      var url = util.sanitizeQueryParams($window.location.href);
      var id = url.split("uuid")[1];
      vm.uuid = id.split("/")[1];
    }

    // functions validate OTP - by Isaac

    function otpValidation() {
      var otp = localStorage.getItem("otp");
      otp = angular.fromJson(otp);
      var time_now = new Date().getTime();

      if (otp == null && otp == undefined) {
        var i = {};
        localStorage.setItem("otp", angular.toJson(i));
        vm.showSharedFooter = true;
      } else if (!(vm.uuid in otp)) {
        vm.showSharedFooter = true;
      } else if (vm.uuid in otp) {
        localStorageService.otp = otp[vm.uuid].split("-")[0];
        var a = otp[vm.uuid];
        a = a.split("-")[1];
        if (a - time_now > 21600000) {
          util.showToast("OTP has expired!");
          delete otp[vm.uuid];
          localStorage.setItem("otp", angular.toJson(otp));
          vm.showSharedFooter = true;
        } else {
          vm.showSharedFooter = false;
        }
      }

      // clean up of expired OTPs

      for (a in otp) {
        var checkTime = otp[a].split("-")[1];
        if (checkTime - time_now > 21600000) {
          delete otp[a];
          localStorage.setItem("otp", angular.toJson(otp));
        }
      }
    }

    // functions check OTP - by Isaac

    function checkOtp() {
      vm.disableOtpBtn = true;
      vm.otpError = "";
      var otp = "";
      if (
        vm.a !== "" &&
        vm.b !== "" &&
        vm.c !== "" &&
        vm.d !== "" &&
        vm.e !== "" &&
        vm.f !== "" &&
        vm.a !== undefined &&
        vm.b !== undefined &&
        vm.c !== undefined &&
        vm.d !== undefined &&
        vm.e !== undefined &&
        vm.f !== undefined
      ) {
        otp = "" + vm.a + vm.b + vm.c + vm.d + vm.e + vm.f;
        var data2 = {
          otp: otp,
        };
        var data = {
          data: data2,
        };
        api.shipment.shared_link.save(
          {
            shipment_id: ShipmentService.shipment_id,
          },
          data,
          function (response) {
            if (response.status === "success") {
              // vm.disableOtpBtn = false;
              vm.dataErr = false;

              var retrievedObject = localStorage.getItem("otp");
              retrievedObject = angular.fromJson(retrievedObject);
              var i = vm.uuid;
              retrievedObject[i] = response.auth + "-" + new Date().getTime();
              localStorage.setItem("otp", angular.toJson(retrievedObject));
              localStorageService.otp = response.auth;
              vm.otpVerified = true;
              util.showToast("OTP verified successfully!");

              $timeout(function () {
                $mdDialog.hide();
                vm.showSharedFooter = false;
                vm.sendingOtp = true;
                vm.dataErr = false;
                vm.otpVerified = false;
              }, 2000);
            }
            // vm.permission.schedule = vm.shipDetailsData.data["schedule"].permission.split('');
          },
          function (err) {
            // vm.disableOtpBtn = false;
            if (err.data.message === "Invalid OTP") {
              vm.otpError = err.data.message;
              vm.a = "";
              vm.b = "";
              vm.c = "";
              vm.d = "";
              vm.e = "";
              vm.f = "";
              angular.element("#otp-input1").focus();
            } else {
              vm.dataErr = true;
              $timeout(function () {
                $mdDialog.hide();
                vm.sendingOtp = true;
              }, 2000);
            }
            util.showToast(err.data.message);

            vm.dataErr = false;
            vm.otpVerified = false;
            $log.error(err);
          }
        );
      } else {
        vm.otpError = "Not a valid OTP";
      }
    }

    // functions generate OTP - by Isaac

    function generateOtp() {
      vm.isClickEnable = false;
      vm.hereButton = false;

      if (vm.enableResend == false) {
        ShipmentService.openOtpPopup("", vm);
        $timeout(function () {
          vm.enableResend = true;
        }, 60000);
      } else {
        vm.otpError = "";
        vm.a = "";
        vm.b = "";
        vm.c = "";
        vm.d = "";
        vm.e = "";
        vm.f = "";
        vm.enableResend = false;
      }
      vm.sendingOtp = true;
      api.shipment.shared_link.get(
        {
          shipment_id: ShipmentService.shipment_id,
        },
        function (response) {
          if (response.status === "success") {
            vm.sendingOtp = false;
            vm.dataErr = false;
            vm.isClickEnable = true;
            // $timeout(function () {
            //     $mdDialog.hide();
            // }, 250);
          }
          // vm.permission.schedule = vm.shipDetailsData.data["schedule"].permission.split('');
        },
        function (err) {
          util.showToast(err.data.message);
          vm.dataErr = true;
          vm.isClickEnable = true;
          $log.error(err);
          $timeout(function () {
            $mdDialog.hide();
            vm.sendingOtp = true;
            vm.dataErr = false;
          }, 2000);
        }
      );
    }

    //function to get parties by category
    function getParty(category, key) {
      var list = [];
      for (var i = 0; i < vm.shipment_meta.parties.length; i++) {
        if (
          vm.shipment_meta.parties[i].category == category &&
          vm.shipment_meta.parties[i][key] != ""
        ) {
          list.push(vm.shipment_meta.parties[i][key]);
        }
      }
      return list;
    }

    //function to get management expert
    function getExperts(type) {
      var expert = [];
      for (var i = 0; i < vm.shipment_meta.management.length; i++) {
        if (vm.shipment_meta.management[i].type == type) {
          expert = vm.shipment_meta.management[i];
        }
      }
      return expert;
    }

    //function to get status permission
    function getModulePermission(nav, tab, name) {
      var permission = [0, 0, 0, 0];
      ShipmentService.shipmentManagementObj.shipment_data.nav.find(function (
        item
      ) {
        if (item.name == tab) {
          permission = util.splitIntoArray(item.data[name].permission);
        }
      });
      return permission;
    }

    function onTabSelected(tab) {
      //mixpanel code
      util.callMixpanel("SD-" + tab.title.toLowerCase() + "Tab-Click");

      if (ShipmentService.isLoadChanged && tab.title == "CONTAINERS") {
        tab.active = 0;
        ShipmentService.isLoadChanged = false;
      }

      if (ShipmentService.isGetLatestTracking && tab.title == "TRACKING") {
        // get Latest tracking records
        tab.active = 0;
        ShipmentService.isGetLatestTracking = false;
      }

      if (!tab.active) {
        tab.active = 1;
        try {
          $scope.$broadcast("tabInitEvent", tab.title);
        } catch (err) {
          $log.error(err);
        }
      }
    }

    function fnAddParty(item, index, title, category) {
      //mixpanel code
      util.callMixpanel("SD-" + category + "-Add-Click", {
        Mode: vm.shipment_meta.mode,
      });
      if (vm.partiesPermission[0]) {
        $scope.$broadcast("addParty", item, index, title, category);
      } else {
        util.showToast("You do not have permission.");
      }
    }

    $scope.$on("callShipmentMeta", function (event, args) {
      if (args.category == "consignee") {
        vm.consigneesList = vm.getParty(args.category, "name");
      } else if (args.category == "shipper") {
        vm.shipperList = vm.getParty(args.category, "name");
        vm.shipperListCompany = vm.getParty(args.category, "company_name");
        vm.shipperReferenceCompany = vm.getParty(args.category, "external_reference_id");
      }
    });

    $scope.$on("addManagement", function (event, data) {
      vm.shipment_meta.management = data.management;
      vm.ShipmentExpert = vm.getExperts("shipment_expert");
      vm.documentExpert = vm.getExperts("document_expert");
    });

    // refresh load meta value after load update
    $scope.$on("updateLoad", function (event, args) {
      vm.loadShimmer = true;
      vm.shipment_meta.load_data = args.load;
      $timeout(function () {
        vm.formContainerType(
          vm.shipment_meta.mode,
          vm.shipment_meta.load_data,
          "shipment"
        );
        vm.loadShimmer = false;
      }, 200);
    });

    /**
     * function to calculate all cards total
     * @param {*} cardLegs
     */
    // function calulateRateTotal(){
    //     var total = 0;
    //     angular.forEach(ShipmentDetailsData.shipment_info.shipment_rates,function(item){
    //         if(item.leg_status != 'REMOVED'){
    //             total += parseFloat(item.leg_total_cost);
    //         }
    //     });
    //     return total;
    // };

    function getScheduleDate() {
      if (vm.ShipmentsDetails.schedule.length) {
        vm.etd = vm.ShipmentsDetails.schedule.departure_time;
        vm.eta = vm.ShipmentsDetails.schedule.arrival_time;
      } else {
        vm.etd = vm.ShipmentsDetails.departure_date;
        vm.eta = vm.ShipmentsDetails.arrival_date;
      }
    }

    /**
     * function to edit screen consignee, notify, shipper info
     */
    function toggleInfoview(infoTital) {
      if (infoTital == "consignee") {
        vm.shipment_consignee = angular.copy(vm.init_consignee);
        vm.editConsignee = !vm.editConsignee;
      } else if (infoTital == "notify_party") {
        vm.shipment_notify_party = angular.copy(vm.init_notify_party);
        vm.editNotify = !vm.editNotify;
      } else if (infoTital == "shipper") {
        vm.shipment_shipper = angular.copy(vm.init_shipper);
        vm.editshipper = !vm.editshipper;
      }
    }

    /**
     * function to update consignee, notify, shipper info
     */
    function updateInfo(info, title) {
      var data = {
        shipment_info: {},
      };
      data.shipment_info["shipment_" + title] = info;
      $log.log(data);

      ShipmentService.updateOtherInfo(data, vm.ShipmentsDetails.id).then(
        function (response) {
          vm.toggleInfoview(title);
        },
        function (error) {
          $log.log(error);
        }
      );
    }

    function checkNull(value) {
      var result = "";
      if (value == null || value == "") {
        result = "N/A";
      } else {
        result = value;
      }
      return result;
    }

    function displayStatus(status) {
      var result = "";
      if (status == null || status == "") {
        result = "-";
      } else {
        var str = status.replace(/_/g, " ");
        result = str.toUpperCase();
      }
      return result;
    }

    vm.beforeSelect = true;
    vm.onSelect = false;
    vm.afterSelect = false;
    function selectFile() {
      angular.element(document.querySelector("#fileInput")).click();
      // file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    }

    function uploadPic(file, doc_name) {
      doc_name = doc_name;
      angular.element(".uploadfile").hide();
      vm.uploadButton = true;
      vm.onSelect = true;
      // var ext = file.name.split('.').pop().toLowerCase();
      // if($.inArray(ext, ['pdf','doc','docx']) == -1) {
      //     util.showToast('Please upload only pdf,doc,docx format files.');
      //     // alert('Please upload only pdf,doc,docx format files.');
      //     return false;
      // }

      ShipmentService.fileUpload(file, doc_name, vm.ShipmentsDetails.id).then(
        function (response) {
          vm.onSelect = false;
          var fileObj = angular.fromJson(response);
          vm.shipmentDocs.push(fileObj.data.document_obj);
          util.showToast("File successfully uploaded");
          angular.element(document.querySelector("#remove_doc")).click();
          vm.doc_name = "";
          vm.uploadButton = false;
        },
        function (error) {
          $log.log(error);
        }
      );

      // $http.post(url,settings).then(function(response){
      // });
    }

    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: "simple",
      autoWidth: false,
      searching: false,
      targets: "no-sort",
      bSort: false,
      order: [],
      responsive: true,
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 10,
    };
    function fnCardSelection(selectedCard) {
      angular.forEach(vm.carrierBookingData.new_rates, function (card) {
        if (
          card.meta._id == selectedCard.meta._id &&
          selectedCard.meta.is_selected
        ) {
          card.meta.is_selected = true;
          vm.selectedCard = angular.copy(selectedCard);
        } else {
          card.meta.is_selected = false;
        }
      });
    }
    function fncarrierBooking() {
      if(!vm.carrierBookingData.new_rates.length){
        vm.selectedCard = vm.carrierBookingData.original_rate;
      }
      if (!Object.keys(vm.selectedCard).length) {
        util.showToast("Select one rate card for booking");
        return;
      }
      vm.bookingBtnDisabled = true;
      util.callMixpanel("SD-CarrierBooking-BookNow");
      util.isCallingApi = true;
      var data = {
        shipment_id: vm.shipment_meta.shipment_id,
        search_id: ((vm.shipment_meta.mode=='AIR'||vm.shipment_meta.mode=='SEA-LCL') && !vm.carrierBookingData.latest_search_id)? vm.carrierBookingData.search_id :  vm.carrierBookingData.latest_search_id,
        card_id: vm.selectedCard.meta._id,
        schedule: {
          url: vm.selectedCard.leg[vm.l3_leg].schedule.url,
          data: (vm.shipment_meta.mode=='AIR'||vm.shipment_meta.mode=='SEA-LCL') ? vm.selectedCard.leg[vm.l3_leg].schedule.data : vm.selectedCard.meta.selected_schedule,
        },
        parties: vm.shipment_meta.parties,
        remarks: "",
      };
      ShipmentService.fncarrierBooking(data).then(
        function (response) {
          vm.shipment_meta.carrier_booking_reference =
            response.data.carrier_booking_reference;
          vm.updateShipmentMeta();
          vm.bookingBtnDisabled = false;
          $mdDialog.hide();
          util.isCallingApi = false;
          vm.responseStatusData.push({
            responseFrom: "QUOTES",
            status: "COMPLETED",
            message: response.data.message,
          });
        },
        function (err) {
          $log.error(err);
          vm.bookingBtnDisabled = false;
          util.isCallingApi = false;
          vm.responseStatusData.push({
            responseFrom: "QUOTES",
            status: "FAILED",
            message: err.data.message,
          });
          $mdDialog.hide();
        }
      );
    }
    function cancelDialog(type) {
      $mdDialog.hide();
      vm.dataErr = false;
      vm.otpError = "";
    }

    //function to get available list
    function getAvailableStatus() {
      if (vm.statusPermission) {
        if (vm.statusPermission[0] || vm.statusPermission[2]) {
          api.shipment.status.get(
            { shipment_id: ShipmentService.shipment_id },
            function (response) {
              vm.achievedStatus = response.data;
            },
            function (err) {
              $log.error(err);
            }
          );
          ShipmentService.getAvailableStatus(ShipmentService.shipment_id).then(
            function (response) {
              vm.availableList = response.data;
            },
            function (error) {
              $log.error(error);
            }
          );
        }
      }
    }

    //function to map available status -ankita(15/5/18)
    function fnMapStatus() {
      var statusList = [];
      var current_item = "";
      var is_find = false;

      for (var i = 0; i < vm.availableList.length; i++) {
        current_item = vm.availableList[i];
        is_find = vm.achievedStatus.find(function (item) {
          return item.id == current_item.id;
        });

        if (is_find) {
          current_item["is_completed"] = true;
          statusList.push(current_item);
        } else {
          current_item["is_completed"] = false;
          statusList.push(current_item);
        }
        is_find = false;
      }
      return statusList;
    }

    //open status menu dropdown
    function openStatusMenu($mdMenu, ev) {
      vm.milestoneValidation = false;
      vm.statusList = vm.fnMapStatus();
      $mdMenu.open(ev);
    }

    //function to open change status modal
    function fnOpenChangeStatus(statusData, index, ev) {
      vm.milestone_date = null;
      vm.current_date = moment().format("YYYY-MM-DD HH:mm");
      vm.min_date = moment(vm.current_date)
        .subtract(1, "years")
        .format("YYYY-MM-DD HH:mm");
      if (vm.statusPermission) {
        if (statusData.is_completed != true && vm.statusPermission[0]) {
          var postStatusStructure = {
            id: statusData.id,
            status: statusData.status,
            color_code: statusData.color_code,
            comment: "",
            max_alloted_hrs: statusData.max_alloted_hrs,
            send_email: 0,
            send_comment: 0,
            milestone_date: vm.current_date ? vm.current_date : null,
            milestone_date_offset: 0,
          };
          vm.statusDataCopy = angular.copy(postStatusStructure);
          vm.statusIndex = index;
          $mdDialog.show({
            templateUrl:
              "app/main/shipments/dialogs/change-status/change-status.html",
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: "ctrl",
            controller: function () {
              this.parent = vm;
            },
          });
        }
      }

      util.callMixpanel("SD-ShipmentStatus-Option-Click", {
        optionValue: statusData.status,
      });
    }

    //function to submit status
    function fnSubmitStatus(statusData) {
      if (!vm.milestone_date) {
        vm.milestoneValidation = true;
        return;
      }
      statusData.comment = statusData.comment;
      statusData.status = statusData.status;
      statusData.milestone_date = moment(statusData.milestone_date).format(
        "YYYY-MM-DD HH:mm"
      );
      statusData.milestone_date_offset = moment(
        statusData.milestone_date
      ).zone();
      var milestoneDate = $("#milestoneDate").val();
      var validDate = moment(milestoneDate);

      if (!validDate.isValid()) {
        document.querySelector("#milestoneDate").focus();
        util.showToast("Invalid Date Format");
        return;
      }

      vm.disabledstatusFrm = true;
      var postData = {
        data: statusData,
      };
      util.isCallingApi = true;
      api.shipment.status.save(
        { shipment_id: ShipmentService.shipment_id },
        postData,
        function (response) {
          vm.disabledstatusFrm = false;
          vm.shipment_meta.current_status = statusData;
          $scope.$broadcast("updateDetailsTab");
          vm.getAvailableStatus();
          util.showToast("Status updated successfully");
          $mdDialog.hide();
          util.isCallingApi = false;
        },
        function (err) {
          util.isCallingApi = false;
          vm.disabledstatusFrm = false;
          $log.log(err);
          util.showToast(util.displayValidationError(err));
          $mdDialog.hide();
        }
      );
    }
    //function to edit shipments
    function fnOpenEditShipment(editData, ev) {
      vm.orginValidation = false;
      vm.destinationValidation = false;
      vm.isBLInvalid = false;
      vm.samePortValidation = false;
      vm.showUpdateScheduleMsg = false;
      vm.todayDate = new Date(); // used to keep min data validation in shipment edit --> cargo sailing date validation
      vm.editShipment_meta = angular.copy(editData);
      vm.tempEditShipment_meta = angular.copy(editData);
      vm.editShipment_meta.departure_date = vm.editShipment_meta.departure_date
        ? util.dateReplace(vm.editShipment_meta.departure_date)
        : null;
      vm.editShipment_meta.arrival_date = vm.editShipment_meta.arrival_date
        ? util.dateReplace(vm.editShipment_meta.arrival_date)
        : null;
      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/edit-shipment/edit-shipment.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }
    function selectedPort(updateData) {
      if (vm.editShipment_meta.pol && vm.editShipment_meta.pod) {
        if (
          angular.equals(updateData.pol.port_code, updateData.pod.port_code)
        ) {
          vm.samePortValidation = true;
        }
      }
    }
    //function to submit edited shipment details -Ankita
    function fnSaveEditShipment(updateData, form) {
      if (!updateData.pol) {
        vm.orginValidation = true;
      }
      if (!updateData.pod) {
        vm.destinationValidation = true;
      }


      //BL number Validation..
      /*if( updateData.bl_number && (/[*|\":<>[\]{}`\\()';@&$]/.test(updateData.bl_number) || !/[0-9]/.test(updateData.bl_number) || !/[A-Za-z]/.test(updateData.bl_number))) {
                form.bl_number.$error = true;
                document.querySelector('#bl_number').focus();
                return;
            }*/

      if (
        vm.orginValidation ||
        vm.destinationValidation ||
        vm.samePortValidation ||
        form.$invalid
      ) {
        return;
      }
      if (angular.equals(vm.tempEditShipment_meta, updateData)) {
        util.showToast("No changes !");
        return;
      } else if (updateData.pol.port_code === updateData.pod.port_code) {
        vm.samePortValidation = true;
        return;
      }

      vm.disabledFrm = true;
      var isDirtyBookingId =
        updateData.mode != "AIR" ? form.liner_shipment_id.$dirty : true;
      updateData.arrival_date = $filter("date")(
        updateData.arrival_date,
        "yyyy-MM-dd"
      );
      updateData.departure_date = $filter("date")(
        updateData.departure_date,
        "yyyy-MM-dd"
      );
      var postData = {
        data: {
          shipment_meta: {
            quote_name: updateData.quote_name,
            incoterm: updateData.incoterm,
            impo_expo: updateData.impo_expo,
            search_type: updateData.search_type,
            bl_number: updateData.bl_number,
            other_details: updateData.other_details,
            arrival_date: updateData.arrival_date,
            departure_date: updateData.departure_date,
            carrier_info: {
              name: updateData.carrier_info.name,
              carrier_code: updateData.carrier_info.carrier_code,
              sv_id: updateData.carrier_info.id,
              vessel: updateData.carrier_info.vessel || "",
              voyage: updateData.carrier_info.voyage,
            },
            pol: {
              name: updateData.pol.portname || updateData.pol.name,
              port_code:
                updateData.pol.global_port_code || updateData.pol.port_code,
              portcode_portname: updateData.pol.portcode_portname,
              is_icd_port: updateData.pol.is_icd_port,
            },
            pod: {
              name: updateData.pod.portname || updateData.pod.name,
              port_code:
                updateData.pod.global_port_code || updateData.pod.port_code,
              portcode_portname: updateData.pod.portcode_portname,
              is_icd_port: updateData.pod.is_icd_port,
            },
            origin_address: updateData.origin_address,
            destination_address: updateData.destination_address
          },
        },
      };
      if (isDirtyBookingId) {
        postData.data.shipment_meta.liner_shipment_id =
          updateData.liner_shipment_id;
      }

      if (updateData.mode == "AIR") {
        postData.data.shipment_meta["awb_object"] = updateData.awb_object;
        postData.data.shipment_meta["airline"] = updateData.airline;
        postData.data.shipment_meta["additional_attributes"] = updateData.additional_attributes;
        if(updateData.carrier_info.sv_id){
          postData.data.shipment_meta.carrier_info["sv_id"] = updateData.carrier_info.sv_id;
        }
      }
      util.isCallingApi = true;
      api.shipment.shipment_info.update(
        { shipment_id: ShipmentService.shipment_id },
        postData,
        function (response) {
          if (vm.shipment_meta.awb_object && (vm.shipment_meta.awb_object.mawb != updateData.awb_object.mawb)) {
            var ifTrack = $filter("filter")(
              vm.dynamicNav,
              { title: "TRACKING" },
              true
            );
            if (ifTrack.length) {
              ifTrack[0].active = 0;
            }
          }

          if (vm.shipment_meta.bl_number !== updateData.bl_number) {
            ShipmentService.isGetLatestTracking = true;
          }

          vm.disabledFrm = false;
          vm.shipment_meta.liner_shipment_id = updateData.liner_shipment_id;
          vm.shipment_meta.awb_object = updateData.awb_object;
          if (updateData.mode == "AIR") {
            ShipmentService.shipmentManagementObj.shipment_meta.awb_object = updateData.awb_object;
            ShipmentService.shipmentManagementObj.shipment_meta.additional_attributes = updateData.additional_attributes;
          }

          vm.shipment_meta.bl_number = updateData.bl_number;
          vm.shipment_meta.other_details = updateData.other_details;
          vm.shipment_meta.quote_name = updateData.quote_name;
          vm.shipment_meta.incoterm = updateData.incoterm;
          vm.shipment_meta.impo_expo = updateData.impo_expo;
          vm.shipment_meta.search_type = updateData.search_type;
          vm.shipment_meta.arrival_date = updateData.arrival_date;
          vm.shipment_meta.departure_date = updateData.departure_date;
          vm.shipment_meta.carrier_info = postData.data.shipment_meta.carrier_info;
          vm.shipment_meta.carrier_info.voyage = updateData.carrier_info.voyage;
          vm.shipment_meta.pol = postData.data.shipment_meta.pol;
          vm.shipment_meta.pod = postData.data.shipment_meta.pod;
          vm.shipment_meta.airline = postData.data.shipment_meta.airline;
          util.isCallingApi = false;
          vm.shipmentDoorPortArray = ShipmentService.fnShipmentDoorPort(
            vm.shipment_meta
          );
          $rootScope.$broadcast("getScheduleList");
          util.showToast("Details updated successfully");
          $mdDialog.hide();
        },
        function (err) {
          util.isCallingApi = false;
          vm.disabledFrm = false;
          $log.log(err);
          var errMsg = util.displayValidationError(err);
          if (errMsg === "Invalid Liner" || errMsg === "Invalid Number") {
            vm.isBLInvalid = true;
            vm.errorMsg = errMsg;
          }
          util.showToast(errMsg);
        }
      );
    }

    function fnDisplayPenalty(ev) {
      $mdDialog.show({
        template:
          '<md-dialog id="penalty-fees" class="dialobox" ng-cloak><md-dialog-content class="p-0"><penalty-fees penaltyfeesobj="ctrl.parent.shipment_meta.penalty_details" ></penalty-fees></md-dialog-content></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: true,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () {
          this.parent = vm;
        },
        controllerAs: "ctrl",
      });
    }

    function formContainerType(mode, loadDetails, page, list) {
      if (loadDetails == null) return;
      var result = "";
      if (mode == "SEA-FCL") {
        result = util.formLoadDetails(loadDetails, list);
        vm.loadDispaly = result;
        vm.loadTooltip = vm.loadDispaly;
      } else if (mode != "SEA-FCL") {
        result = util.formAirLoadDetails(loadDetails, mode, page);
        vm.loadDispaly = result;
        vm.loadTooltip = vm.loadDispaly.split("| ").join("</br>");
      }
    }

    function proceedCarrierBooking(ev) {
      if (vm.shipment_data.button.carrier_booking.data.text == 'Cancel Carrier Booking') {
        confirmCancelBooking(ev);
      } else if (vm.shipment_data.button.carrier_booking.data.text == 'Carrier Booking') {
        fnGetRateDifference(ev);
      }
    }

    function confirmCancelBooking(ev) {
      vm.deleteType = 'Carrier-Booking';
      vm.deleteBtnText = 'Yes';
      $mdDialog.show({
        templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm; }
      });
    }

    function fnDeleteData() {
      vm.deleteBtn = true;
      ShipmentService.cancelCarrierBooking('shipments', ShipmentService.shipment_id).then(function (response) {
        vm.updateShipmentMeta();
        vm.deleteBtn = false;
        $mdDialog.hide();
        vm.loadingCarrierBtn = false;
        vm.responseStatusData.push({
          responseFrom: "QUOTES",
          status: "COMPLETED",
          message: response.data.message,
        });
      }, function (err) {
        vm.deleteBtn = false;
        $mdDialog.hide();
        vm.responseStatusData.push({
          responseFrom: "QUOTES",
          status: "FAILED",
          message: err.data.message,
        })
        vm.loadingCarrierBtn = false;
        $log.error(err);
      });
    }

    function fnGetRateDifference(ev) {
      vm.loadingCarrierBtn = true;
      ShipmentService.getCarrierBookingRates('shipments',ShipmentService.shipment_id,vm.shipment_meta.mode).then(function(response) {
          vm.carrierBookingData=response.data;
          vm.loadingCarrierBtn=false;
          vm.fnOpenCarrierCharges(ev);
      },function(err){
        vm.responseStatusData.push({
          responseFrom: "QUOTES",
          status: "FAILED",
          message:err.data.message ,
        })
        vm.loadingCarrierBtn=false;
          $log.error(err);
      });
    }

    //function to open carrier  charges details popup
    function fnOpenCarrierCharges(ev) {
      vm.selectedCard = {};
      util.callMixpanel("SD-CarrierBooking-CarrierChargess-Click");
      vm.search_param = angular.copy(vm.shipment_meta);

      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/carrier-booking/carrier-booking.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: false,
        onComplete: vm.afterShowAnimation,
        controllerAs: "ctrl",
        locals: {
          search_param: vm.search_param,
          carrierBookingData: vm.carrierBookingData,
        },
        bindToController: true,
        controller: function () {
          this.parent = vm;
        },
      });
    }

    // function fnCheckInputText(newInputText, oldInputText) {
    //   vm.showUpdateScheduleMsg = false;

    //   if(!(angular.equals(newInputText,oldInputText))){
    //     vm.showUpdateScheduleMsg = true;
    //   }

    // }
    function afterShowAnimation() {
      vm.showData = false;
    }
    function fnViewInquiryDetails(id) {
      if (!util.isShipper && id) {
        util.isCallingApi = true;
        $state.go("app.inquiry.inquiryDetails", { id: id });
      }
    }

    $rootScope.$on("apiResponseOtpExpired", function () {
      vm.showSharedFooter = true;
      localStorageService.otp = "";
      localStorage.setItem("otp", "{}");
    });
  }
})();

(function(){
    'use strict';

    angular
    .module('app.shipments')
    .factory('ShipmentService' , ShipmentService);

    /** @ngInject */
    function ShipmentService($location,$q,$state,$mdToast,$http,$log,api,msApi,$resource,$filter,localStorageService,$rootScope, $mdDialog, util, shareQuoteService)
    {
        // var shipmentData = {};

        var shipmentService = {
            // showConsigneeName : showConsigneeName,
            getShipmentList : getShipmentList,
            getShipmentDetails : getShipmentDetails,
            info_stucture : info_stucture,
            updateOtherInfo : updateOtherInfo,
            updateShipmentDetails : updateShipmentDetails,
            fnCalculateChargeCostSell : fnCalculateChargeCostSell,
            fnCalculateChargeCostBuy: fnCalculateChargeCostBuy,
            fncarrierBooking:fncarrierBooking,
            billingInfo : {},
            deleteShipmentData : deleteShipmentData,
            updateStatus : updateStatus,
            createShipmentNav : createShipmentNav,
            setShipmentNav : [],
            shipmentManagementObj : {},
            getCarrierBookingRates:getCarrierBookingRates,
            cancelCarrierBooking: cancelCarrierBooking,
            shipment_id : '',
            access_token: '',
            uuid: '',
            toolbarSearchText: '',
            saveFileUpload : saveFileUpload,
            containerPutCall: containerPutCall,
            shipmentList : [],
            // Details : defineDetailResource
            // filterTabWiseModule : filterTabWiseModule
            openOtpPopup : openOtpPopup,
            getAvailableStatus : getAvailableStatus,
            fromChild : 0,
            getCommodityList : getCommodityList,
            getCompanyList : getCompanyList,
            downloadAllDoc : downloadAllDoc,
            deleteShipments : deleteShipments,
            createShipment : createShipment,
            setPartyDetails : setPartyDetails,
            // fromToolbar : 0
            fnShipmentDoorPort : fnShipmentDoorPort,
            fnBookingDoorPort : fnBookingDoorPort,
            getShipmentFilters : getShipmentFilters,
            cleanObj : cleanObj,
            syncDocument:syncDocument,
            getSyncUiData:getSyncUiData,
            partyTypes : ['customer', 'consignee', 'consignor', 'cha', 'notify_party', 'others'],
            isLoadChanged : false,
            isGetLatestTracking : false,
            canCreateNewCompany : canCreateNewCompany
        };

        return shipmentService;


        function cleanObj(obj) {
          for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined || obj[propName].length === 0) {
              delete obj[propName];
            }
          }
        }

        function getCarrierBookingRates(source,id,mode){
          var url = api.baseMockUrl +'/v2/validate-rates'
          url +=  '?source=' +source+'&shipmentId='+id+'&mode='+mode;
            return $http.get(url);
        }

        function cancelCarrierBooking(source,id){
          var url = api.baseMockUrl +'/v2/shipment/carrier/booking/cancel/'+id;
          return $http.get(url);
        } 

        function fncarrierBooking(data){
          var url = api.baseMockUrl +'/v2/shipment/carrier/booking'

            return $http.post(url,data);
        }
        function getShipmentFilters(data) {
          return $http.post($rootScope.forwarder_id ? api.baseUrl + '/api/shipment/filters?forwarder_company_id=' + $rootScope.forwarder_id : api.baseUrl + '/api/shipment/filters', data);
        }

        function info_stucture(srcObj) {
            if( srcObj == undefined || Object.keys(srcObj).length <= 0){
                return true;
            }
            var destObj = { "name":"", "company": "", "address": "", "phone": "", "email": "" };

            for (var key in destObj) {
                if(destObj.hasOwnProperty(key) && srcObj.hasOwnProperty(key)) {
                    if(srcObj[key] == null){
                        srcObj[key] = "";
                    }
                    destObj[key] = srcObj[key];
                }
            }
            return destObj;
        }



        function openOtpPopup(ev, vm){
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/otp-popup/otp.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }


        // function showConsigneeName(consignee){
        //     var result = '';
        //     if(Object.keys(consignee).length > 0) {
        //         for (var i = 0; i < consignee.length; i++){
        //             if(consignee[i].company != null && consignee[i].company != ''){
        //                 if(i>0){   result += ', ';    }
        //                 result += consignee[i].company ;
        //             }
        //             else{
        //                 result = 'Not Added';
        //             }
        //         }
        //         result = result != '' ? result : '-';
        //     }
        //     else{
        //         result = 'Not Added';
        //     }
        //     return result;
        // }

        function getShipmentList(payload) {
          shipmentService.cleanObj(payload);
          var data = {
            'data': payload
          }
          var url =  api.baseUrl + '/api/shipments-list' + util.fnGetForwarderIdApi('?');

          return $http.post(url, data);

        }

        function getShipmentDetails(id){
            if(id == ''){
                return ;
            }
            var url = api.baseMockUrl + '/shipments/'+id;

            return $http.get(url);
        }

        function containerPutCall(id, data) {
          return $http.put(api.baseUrl + '/api/shipments/' + id + '/containers', data);
        }

        // file save on document tab - By Isaac

        function saveFileUpload(file,url) {
            var authToken = '';
            var auth = {};
            if(util.isSharedPage() && localStorage.getItem('otp') !==  null) {
                authToken = localStorageService.otp;
                auth = {
                    'otp': authToken,
                    'referer-domain' : $rootScope.domainData.host_name
                }
            } else {
                authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
                auth = {
                    'authorization': authToken,
                    'referer-domain' : $rootScope.domainData.host_name
                };
            }

            var settings = {
              "async": true,
              "crossDomain": true,
              "url":  api.baseMockUrl + '/shipments/'+ url ,
              "method": "POST",
              "headers": auth,
              "processData": false,
              "contentType": false,
              "mimeType": "multipart/form-data",
              "data": file
            };

            return $.ajax(settings).done(function (response) {
                return response;
            });
        };

        function updateOtherInfo(data,id){
            return $http.put(api.baseUrl + '/api/shipments/'+ id , data);
        }

        function updateShipmentDetails(shipmentDeatils,id){

            var url = api.baseUrl + '/api/shipment-update/' + id;

            return $http.post(url,shipmentDeatils).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        }

        //TODO : change with new api
        function deleteShipmentData(data ,id ){

            var url = api.baseUrl + '/api/shipments/' + id;

            var config = {
                method : "DELETE",
                url : url,
                data : data,
                headers : {
                    "content-type": "application/json"
                }
            }
            $http(config).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        };

        function fnCalculateChargeCostSell(charge_data, leg_data,cust_curr){
            if(charge_data.per_unit_rate != null && charge_data.total_units != null){

            var isMarkup = cust_curr === leg_data.leg_currency ? true : false;
            var per_unit = charge_data.per_unit_rate == '' ? 0 : (parseFloat(charge_data.per_unit_rate) || 0);
            var total_units = charge_data.total_units == '' ? 0 : parseFloat(charge_data.total_units);

                if( charge_data.charge_basis && charge_data.charge_basis.includes("%")){
                    charge_data.charge_currency = leg_data.leg_currency;
                    charge_data.charge_cost = ((per_unit * total_units) / 100);
                }else{
                    charge_data.charge_cost =  (per_unit * total_units);
                }
                if( charge_data.minimum_charge_cost && !isNaN(charge_data.minimum_charge_cost) && ( ( parseFloat(charge_data.minimum_charge_cost) || 0 )  > ( parseFloat(charge_data.charge_cost) || 0 ) ) ){

                  charge_data.charge_cost = isNaN(charge_data.minimum_charge_cost) ? 0 : (parseFloat(charge_data.minimum_charge_cost) || 0);

                  charge_data.leg_currency_cost = isNaN(charge_data.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.minimum_charge_cost), charge_data.charge_currency, leg_data.leg_currency, isMarkup));
        
                  
                  charge_data.customer_currency_cost = isNaN(charge_data.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.minimum_charge_cost), charge_data.charge_currency, leg_data.leg_total_currency, true));
        
                  charge_data.min_flag = 1;                 
                   charge_data.max_flag = 0;
                }
                else  if( charge_data.maximum_charge_cost && !isNaN(charge_data.maximum_charge_cost) && ( ( parseFloat(charge_data.maximum_charge_cost) || 0 )  < ( parseFloat(charge_data.charge_cost) || 0 ) ) ){

                  charge_data.charge_cost = isNaN(charge_data.maximum_charge_cost) ? 0 : (parseFloat(charge_data.maximum_charge_cost) || 0);
        
                  charge_data.leg_currency_cost = isNaN(charge_data.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.maximum_charge_cost), charge_data.charge_currency, leg_data.leg_currency, isMarkup));
        
        
                  charge_data.customer_currency_cost = isNaN(charge_data.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.maximum_charge_cost), charge_data.charge_currency, leg_data.leg_total_currency, true));
                  charge_data.min_flag = 0;
                  charge_data.max_flag = 1;
                }
                else{
                  charge_data.min_flag = 0;
                  charge_data.max_flag = 0;
                  if(leg_data.leg_currency == charge_data.charge_currency ){
                      charge_data.leg_currency_cost = charge_data.charge_cost;
                  }else{
                      charge_data.leg_currency_cost = shareQuoteService.currencyConverter.convert(parseFloat(charge_data.charge_cost), charge_data.charge_currency, leg_data.leg_currency, isMarkup);
                  }
  
                  if(charge_data.charge_currency == cust_curr ){
                      charge_data.customer_currency_cost = charge_data.charge_cost;
                  }
                  else{
                      charge_data.customer_currency_cost = shareQuoteService.currencyConverter.convert(parseFloat(charge_data.charge_cost), charge_data.charge_currency, leg_data.leg_total_currency, true);
                  }
                }

            }
            return charge_data;
        }

        function fnCalculateChargeCostBuy(charge_data, leg_data, cust_curr) {
          if (charge_data.buy.per_unit_rate != null && charge_data.buy.total_units != null) {

            var isMarkup = cust_curr === leg_data.leg_currency ? true : false;
            var per_unit = charge_data.buy.per_unit_rate == '' ? 0 : (parseFloat(charge_data.buy.per_unit_rate) || 0);
            var total_units = charge_data.buy.total_units == '' ? 0 : parseFloat(charge_data.buy.total_units);

            if ( charge_data.charge_basis && charge_data.charge_basis.includes("%")) {
              charge_data.buy.charge_currency = leg_data.leg_currency;
              charge_data.buy.charge_cost = ((per_unit * total_units) / 100);
            } else {
              charge_data.buy.charge_cost = (per_unit * total_units);
            }
            if( charge_data.buy.minimum_charge_cost && !isNaN(charge_data.buy.minimum_charge_cost) && ( ( parseFloat(charge_data.buy.minimum_charge_cost) || 0 )  > ( parseFloat(charge_data.buy.charge_cost) || 0 ) ) ){

              charge_data.buy.charge_cost = isNaN(charge_data.buy.minimum_charge_cost) ? 0 : (parseFloat(charge_data.buy.minimum_charge_cost) || 0);
    
              charge_data.buy.leg_currency_cost = isNaN(charge_data.buy.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.buy.minimum_charge_cost), charge_data.buy.charge_currency, leg_data.leg_currency, isMarkup));
    
    
              charge_data.buy.customer_currency_cost = isNaN(charge_data.buy.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.buy.minimum_charge_cost), charge_data.buy.charge_currency, leg_data.leg_total_currency, true));
              charge_data.buy.min_flag = 1;
              charge_data.buy.max_flag = 0;
            }else if( charge_data.buy.maximum_charge_cost && !isNaN(charge_data.buy.maximum_charge_cost) && ( ( parseFloat(charge_data.buy.maximum_charge_cost) || 0 )  < ( parseFloat(charge_data.buy.charge_cost) || 0 ) ) ){

              charge_data.buy.charge_cost = isNaN(charge_data.buy.maximum_charge_cost) ? 0 : (parseFloat(charge_data.buy.maximum_charge_cost) || 0);
    
              charge_data.buy.leg_currency_cost = isNaN(charge_data.buy.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.buy.maximum_charge_cost), charge_data.buy.charge_currency, leg_data.leg_currency, isMarkup));
    
    
              charge_data.buy.customer_currency_cost = isNaN(charge_data.buy.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.buy.maximum_charge_cost), charge_data.buy.charge_currency, leg_data.leg_total_currency, true));
              charge_data.buy.min_flag = 0;
              charge_data.buy.max_flag = 1;
            }
            else{
              charge_data.buy.min_flag = 0;
              charge_data.buy.max_flag = 0;
              if (leg_data.leg_currency == charge_data.buy.charge_currency) {
                charge_data.buy.leg_currency_cost = charge_data.buy.charge_cost;
              } else {
                charge_data.buy.leg_currency_cost = shareQuoteService.currencyConverter.convert(parseFloat(charge_data.buy.charge_cost), charge_data.buy.charge_currency, leg_data.leg_currency, isMarkup);
              }

              if (charge_data.buy.charge_currency == cust_curr) {
                charge_data.buy.customer_currency_cost = charge_data.buy.charge_cost;
              }
              else {
                charge_data.buy.customer_currency_cost = shareQuoteService.currencyConverter.convert(parseFloat(charge_data.buy.charge_cost), charge_data.buy.charge_currency, leg_data.leg_total_currency, true)
              }
            }

          }
          return charge_data;
        }

        //TODO : change with new api
        function updateStatus(status ,id){

            var url = api.baseUrl + '/api/shipment-update/' +id +'/status/';

            return $http.post(url,status).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });

            // return $http.post(url,status);
        }

        function createShipmentNav(getNav, mode){
            shipmentService.setShipmentNav = [];
            angular.forEach(getNav, function(item){
                var name = (item.name).replace(/\s/g,'').toLowerCase();
                var navObj = { title : "", controller : "", template : "", active : 0 };
                navObj.title = item.name;
                name = name == 'bookingdetails' ? 'shipmentdetails' : name
                // if(mode == 'AIR' && name == 'tracking'){
                //     navObj.template = 'app/main/track-n-trace/track-n-trace-details/track-n-trace-details.html';

                // }else{
                     var template = 'app/main/shipments/tabs/'+name+'/'+name+'.html';
                    navObj.template = util.escapeHtml(template);
                    
                // }
                navObj.controller = item.name == 'BOOKING DETAILS' ? "shipmentdetailsShipmentController  as vm" :  (item.name).replace(/\s/g,'').toLowerCase() +"ShipmentController  as vm";
                shipmentService.setShipmentNav.push(navObj);
              });
            return shipmentService.setShipmentNav;
        }

        function getAvailableStatus(id){
            var url = api.baseMockUrl + '/shipments/'+id+'/available-status';
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        }

        function getCommodityList(query){
            var url = api.baseMockUrl + '/commodity-list?query='+query;
            return $http.get(url);
        }

        function getCompanyList(searchText, type) {
            var companyTypes;
            switch(type) {
                case 'shipper': companyTypes = ['SHIPPER']; break;
                case 'consignee': companyTypes = ['CONSIGNEE', 'SHIPPER']; break;
                case 'consignor': companyTypes = ['CONSIGNOR', 'SHIPPER']; break;
                case 'notify_party': companyTypes = ['SHIPPER', 'CONSIGNEE', 'CONSIGNOR', 'NOTIFY_PARTY']; break;
                case 'shippers': companyTypes = ['SHIPPER']; break;
                default: companyTypes = [type.toUpperCase()];
            }
            
            if (companyTypes.length === 1) {
                var url = api.baseMockUrl + '/get-shipper-companies?name=' + searchText + '&type=' + companyTypes[0];
                return $http.get(url).then(function (response) {
                    return response.data.data;
                }, function (error) {
                    $log.log(error.data);
                });
            } else {
                var promises = companyTypes.map(function(companyType) {
                    var url = api.baseMockUrl + '/get-shipper-companies?name=' + searchText + '&type=' + companyType;
                    return $http.get(url);
                });
                
                return $q.all(promises).then(function(responses) {
                    var allCompanies = [];
                    var seenIds = {};
                    responses.forEach(function(response) {
                        if (response.data && response.data.data) {
                            response.data.data.forEach(function(company) {
                                if (!seenIds[company.id]) {
                                    seenIds[company.id] = true;
                                    allCompanies.push(company);
                                }
                            });
                        }
                    });
                    return allCompanies;
                }, function (error) {
                    $log.log(error.data);
                });
            }
        }

        function setPartyDetails (company, partyData , party_type, mode) {
          if(!company) {
            partyData.company_id = null;
            partyData.address = null;
            partyData.city = null;
            partyData.email = null;
            partyData.contact = null;
            partyData.country_code = null;
            partyData.external_reference_id = null;
            // window.intlTelInputGlobals.getInstance($('.tel-input')[0]).setNumber('');
            partyData.iec_number = null;
            partyData.point_of_contact = null;
            partyData.country = null;
            partyData.state = null;
            partyData.postal_code = null;
          }

            if(company && company.company_name) {
                partyData.company_id = company.id;
                partyData.company_name = company.company_name;
                partyData.address = company.company_address;
                partyData.city = company.city;
                partyData.email = company.company_email;
                partyData.external_reference_id = company.external_reference_id;
                // $timeout(function () {
                //   window.intlTelInputGlobals.getInstance($('.tel-input')[0]).setNumber('+' +   company.company_phone_code +   company.company_phone_number);
                // }, 500);

                // partyData.contact = company.company_phone_number ? intlTelInputUtils.formatNumber('+' + company.company_phone_code + company.company_phone_number, null, intlTelInputUtils.numberFormat.INTERNATIONAL) : null;
                partyData.contact = company.company_phone_number;
                partyData.country_code = company.company_phone_code;
                partyData.iec_number = company.iec_number;
                partyData.point_of_contact = company.point_of_contact;
                partyData.country = company.country;
                partyData.state = company.state;
                partyData.postal_code = company.postal_code;
            }
        }

        // api function for download all files in document section
        function downloadAllDoc(id){
            var url = api.baseMockUrl + '/shipments/'+id+'/document-zip';
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        }

        //function to delete shipments
        function deleteShipments(data){
            var url = api.baseMockUrl + '/shipments';
            return $http.delete(url,data);
        }



        function createShipment(shipment){
            var url = api.baseMockUrl + '/shipment';
            return $http.post(url,shipment).then(function(response){
                return response.data;
            })
        }

        function fnShipmentDoorPort(shipment_meta){
          var shipmentDoorPortArray = [];
          if(shipment_meta.pickup_address.place_type == 'Door'){
            shipmentDoorPortArray.push(
              {
                "name": 'Pickup',
                "value": shipment_meta.pickup_address.location ? shipment_meta.pickup_address.location : 'NA'
              }
            )
          }

          shipmentDoorPortArray.push(
            {
              "name": (shipment_meta.mode != 'AIR' && shipment_meta.via_pol ? 'Origin Port' : 'Port of Loading'),
              "value": shipment_meta.pol.port_code ? (shipment_meta.pol.port_code + '-' + shipment_meta.pol.name) : 'NA'
            }
          )

          if(shipment_meta.mode != 'AIR' && shipment_meta.via_pol){
            shipmentDoorPortArray.push(
              {
                "name": 'Port of Loading',
                "value": shipment_meta.via_pol ? shipment_meta.via_pol : 'NA'
              }
            )
          }

          if(shipment_meta.mode != 'AIR' && shipment_meta.via_pod){
            shipmentDoorPortArray.push(
              {
                "name": 'Port of Discharge',
                "value": shipment_meta.via_pod ? shipment_meta.via_pod : 'NA'
              }
            )
          }

          shipmentDoorPortArray.push(
            {
              "name": (shipment_meta.mode != 'AIR' && shipment_meta.via_pod ? 'Destination Port' : 'Port of Discharge'),
              "value": shipment_meta.pod.port_code ? (shipment_meta.pod.port_code + '-' +shipment_meta.pod.name) : 'NA'
            }
          )

          if(shipment_meta.delivery_address.place_type == 'Door'){
            shipmentDoorPortArray.push(
              {
                "name": 'Delivery',
                "value": shipment_meta.delivery_address.location ? shipment_meta.delivery_address.location : 'NA'
              }
            )
          }
          return shipmentDoorPortArray;

      }

      function fnBookingDoorPort(booking_searchData, booking_meta){
        var bookingDoorPortArray = [];
        if(booking_searchData.origin_location.place_type == 'Door'){
          bookingDoorPortArray.push(
            {
              "name": 'Pickup',
              "value": booking_meta.port_data.pickup_location ? booking_meta.port_data.pickup_location : 'NA'
            }
          )
        }

        bookingDoorPortArray.push(
          {
            "name": 'Port of ' + (booking_meta.mode != 'AIR' && booking_meta.via_pol ? 'Origin' : 'Loading'),
            "value": booking_meta.port_data.origin_port_code ? (booking_meta.port_data.origin_port_code + '-' + booking_meta.port_data.origin_portname) : 'NA'
          }
        )

        if(booking_meta.mode != 'AIR' && booking_meta.via_pol){
          bookingDoorPortArray.push(
            {
              "name": 'Port of Loading',
              "value": booking_meta.via_pol ? booking_meta.via_pol : 'NA'
            }
          )
        }

        if(booking_meta.mode != 'AIR' && booking_meta.via_pod){
          bookingDoorPortArray.push(
            {
              "name": 'Port of Discharge',
              "value": booking_meta.via_pod ? booking_meta.via_pod : 'NA'
            }
          )
        }

        bookingDoorPortArray.push(
          {
            "name": 'Port of ' + (booking_meta.mode != 'AIR' && booking_meta.via_pod ? 'Destination' : 'Discharge'),
            "value": booking_meta.port_data.destination_port_code ? (booking_meta.port_data.destination_port_code + '-' +booking_meta.port_data.destination_portname) : 'NA'
          }
        )

        if(booking_searchData.destination_location.place_type == 'Door'){
          bookingDoorPortArray.push(
            {
              "name": 'Delivery',
              "value": booking_meta.port_data.delivery_location ? booking_meta.port_data.delivery_location : 'NA'
            }
          )
        }
        return bookingDoorPortArray;
      }

      function syncDocument(data,type){
        var url = api.baseMockUrl +'/v2/'+type+'/documentSync'

        return $http.post(url,data);
      }

      function getSyncUiData(id,type,syncType){
        var url = api.baseUrl + '/api/v2/'+type+'/menu-configuration';
        var body ={
          "id":id,
          "syncType":syncType
        }

       // var url = api.baseUrl + '/api/v2/quote/CMS000000001050/menu-configuration';
        return $http.post(url,body)
  
    }

    function canCreateNewCompany(partyType) {
        var allowedTypes = ['notify_party', 'cha', 'others'];
        return allowedTypes.indexOf(partyType) !== -1;
    }

    }
})();

(function () {
  'use strict';

  angular
  .module('app.core')
  .component('portTraveller', {
      templateUrl: 'app/main/shipments/port-traveller/port-traveller.html',
      bindings : {
        details : '<',
      },
      controller: PortTravellerController
  });

  function PortTravellerController() {
    var vm = this;

    this.$onChanges = function() {
      vm.portDetails = {
        "port_data": {
          "pickup_location": vm.details.pickup_address.place_type == 'Door' ? vm.details.pickup_address.location : null,
          "pickup_pincode_ui": vm.details.pickup_address.place_type == 'Door' ? vm.details.pickup_address.pin_code_ui : null,
          "pickup_country_name": vm.details.pickup_address.place_type == 'Door' ? vm.details.pickup_address.country : null,
          "origin_port_code": vm.details.pol.port_code,
          "origin_city" : vm.details.pol.name,
          "destination_city" : vm.details.pod.name,
          "origin_portname": vm.details.pickup_address.portname,
          "is_icd_port_origin": vm.details.pol.is_icd_port,
          "empty_container_pickup":vm.details.empty_container_pickup ? vm.details.empty_container_pickup : null,

          "delivery_location": vm.details.delivery_address.place_type == 'Door' ? vm.details.delivery_address.location : null,
          "delivery_pincode_ui": vm.details.delivery_address.place_type == 'Door' ? vm.details.delivery_address.pin_code_ui : null,
          "delivery_country_name": vm.details.delivery_address.place_type == 'Door' ? vm.details.delivery_address.country : null,
          "destination_port_code": vm.details.pod.port_code,
          "destination_portname": vm.details.delivery_address.portname,
          "is_icd_port_destination": vm.details.pod.is_icd_port,
          "empty_container_drop":vm.details.empty_container_drop ? vm.details.empty_container_drop : null,
        },
        "via_pol" : vm.details.via_pol,
        "via_pod" : vm.details.via_pod,
        "haulage" : vm.details.haulage,
        "destination_haulage" : vm.details.destination_haulage
      }
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.teams', ['datatables','ngAvatar'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.teams', {
            url      : '/teams',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/teams/teams.html',
                    controller : 'TeamController as vm'
                }
            },
            bodyClass: 'setting-teams'
        });

 
    }

})();

(function () {
    'use strict';

    angular
        .module('app.teams')
        .controller('TeamController', TeamController);

    /** @ngInject */
    function TeamController(SettingService, $log, util, $mdSidenav, api, $mdDialog,$scope, $rootScope) {
        var vm = this;
        vm.deleteType='';
        vm.deleteValue='';
        vm.configurations = SettingService;
        vm.teamPermission = SettingService.getModulePermission('TEAMS');
        vm.fnGetTeamList = fnGetTeamList;
        vm.fnSubmitTeam = fnSubmitTeam;
        vm.fnEditTeam = fnEditTeam;
        vm.fnUpdateTeam = fnUpdateTeam;
        vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
        vm.fnDeleteData = fnDeleteData;
        vm.cancelDialog = cancelDialog;
        vm.fnTrackAnalytics=fnTrackAnalytics;
        vm.fnGetTeamList();
        vm.managerList = [];
        vm.membersList = [];
        vm.getUsersList = getUsersList;
        vm.init = init;
        vm.init();
        vm.getUsersList();
        vm.fnFormArrayOfIDs = fnFormArrayOfIDs;
        vm.fnValidateTeamForm = fnValidateTeamForm;
        vm.userComparer = userComparer;
        vm.removedUsers = [];
        vm.checkDuplicateName = checkDuplicateName;
        SettingService.displayForwarderSelectBox(util.isFreightbro);
        vm.fnCreateTeam = fnCreateTeam;
        vm.fnViewTeam = fnViewTeam;

        $scope.$on('app.teams',function(){
            vm.getUsersList();
            vm.fnGetTeamList();
        });

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            ordering: false,
            responsive: true,
            lengthMenu  : [5, 10, 20, 30, 50, 100],
            pageLength  : 10
        };

        // get user list for member and manger list
        function getUsersList(){
            return SettingService.getManagerList().then(function (response) {
                vm.userList = response.data;
                vm.managerList = vm.userList;
                vm.membersList = vm.userList;
                vm.userListCopy = angular.copy(vm.userList);
            }, function (error) {
                $log.log(error.data);
                return [];
            });
        }

        //initialize data
        function init() {
            vm.managerList = angular.copy(vm.userListCopy);
            vm.membersList = angular.copy(vm.userListCopy);
            vm.team_data = {
                'name': '',
                'managers': [],
                'members': [],
                'parent': ''
            };
            vm.button_name = 'Add';
            // vm.getUsersList();
        }

        function fnCreateTeam(ev){
            vm.teamnameValidation=false;
            vm.managerValidation=false;
            vm.teamValidation=false;
            vm.parenTeamValidation=false;
            init();
            vm.fnTrackAnalytics('Team-Create-Click')
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/team-form/team-form.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }
        function fnTrackAnalytics(action, params){
            if(!params){
              var params = {};
            }
            util.callMixpanel(action, params);
        }
        //edit team
        function fnEditTeam(team, index, ev) {
            // document.querySelector('.selectbox').setAttribute('selectedIndex', '-1'); //empty selectbox
            vm.fnTrackAnalytics('Team-Edit-Click',{'Team Name':team.name})
            vm.teamnameValidation=false;
            vm.managerValidation=false;
            vm.teamValidation=false;
            vm.parenTeamValidation=false;
            vm.managerList = angular.copy(vm.userListCopy);
            vm.membersList = angular.copy(vm.userListCopy);
            vm.button_name = 'Update';
            vm.updateIndex = index;
            var managers = vm.fnFormArrayOfIDs(team.managers,'manager');
            var members = vm.fnFormArrayOfIDs(team.members,'member');
            vm.team_data = {
                '_id': team._id,
                'name': team.name,
                'managers': managers,
                'members': members,
                'parent': team.parent ? team.parent._id : ''
            };
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/team-form/team-form.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
            vm.team_data_copy = angular.copy(vm.team_data);
        }

        //form array of IDs
        function fnFormArrayOfIDs(users,user) {
            var arr = [];
            angular.forEach(users, function (key) {
                if(user === 'manager'){
                    var isManagerPresent = vm.managerList.some(function (el) { return el.id === key.id; });
                    if (!isManagerPresent) {
                    vm.managerList.push(key);}
                }
                else{
                    var isMemberPresent = vm.membersList.some(function (el) { return el.id === key.id; });
                    if (!isMemberPresent) {
                    vm.membersList.push(key);}
                }
                arr.push(key.id);

            });
            return arr;
        }

        // get all Team list
        function fnGetTeamList() {
            vm.isDataLoading = true;
            api.userManagement.team.get({'forwarder_company_id' : $rootScope.forwarder_id },function (response) {
                try {
                    vm.teamList = response.data;
                    vm.isDataLoading = false;
                    SettingService.teamData = vm.teamList;
                } catch (e) {
                    vm.isDataLoading = false;
                    $log.error(e);
                }
            }, function (err) {
                vm.isDataLoading = false;
                $log.log(err);
            });
        }

        //submit Team
        function fnSubmitTeam() {
            if(!vm.team_data.name){
                vm.teamnameValidation=true;
            }
            if(vm.team_data.managers.length ===0){
                vm.managerValidation=true;
            }
           
            if(vm.teamnameValidation || vm.managerValidation){
                return false;
            }
            // if(!vm.team_data.name){
            //     util.showToast('Team Name is required');
            //     return false;
            // }
            if(!vm.fnValidateTeamForm()){
                return false;
            }
            if (vm.team_data._id) {
                vm.fnUpdateTeam();
            }
            else {
                if(vm.teamList){
                    var isPresent = vm.teamList.some(function (el) { return el.name === vm.team_data.name; });
                    if (isPresent) {
                        vm.teamValidation=true;
                        return
                    }
                }
                var postData = {
                    'data': {
                        'name':vm.team_data.name,
                        'managers': vm.team_data.managers,
                        'members': vm.team_data.members,
                        'parent': vm.team_data.parent,
                        'forwarder_company_id' : $rootScope.forwarder_id
                    }
                };
                vm.fnTrackAnalytics('Team-Create-Confirm-Click',postData.data)
                 vm.submit_disabled = true;
                api.userManagement.team.save(postData, function (response) {
                    vm.init();
                    vm.teamList.push(response.data);
                    vm.submit_disabled = false;
                    util.showToast('Team Created successfully');
                    vm.cancelDialog();
                }, function (err) {
                    vm.submit_disabled = false;
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                });
            }
        }

        //function to validate submit form
        function fnValidateTeamForm(){
            // if(vm.team_data.managers.length === 0) {
            //      util.showToast('Please select manager !');
            //     return false;
            // }
            for (var i = 0; i < vm.team_data.managers.length; i++) {
                if (vm.team_data.members.indexOf(vm.team_data.managers[i]) !== -1) {
                    util.showToast('Manager and member can not be same !');
                    return false;
                }
            }
            return true;
        }

        //update team
        function fnUpdateTeam() {
            if (vm.team_data._id === vm.team_data.parent) {
                vm.parenTeamValidation=true;
                return false;
            }
            if(!vm.checkDuplicateName(vm.teamList,vm.updateIndex)){
                vm.removedUsers = vm.team_data_copy.managers.filter(vm.userComparer(vm.team_data.managers));
                vm.removedUsers = vm.removedUsers.concat(vm.team_data_copy.members.filter(vm.userComparer(vm.team_data.members)));
    
                var postData = {
                    'data': {
                        'name': vm.team_data.name,
                        'managers': vm.team_data.managers,
                        'members': vm.team_data.members,
                        'parent': vm.team_data.parent,
                        'removedUsers': vm.removedUsers,
                        'forwarder_company_id' : $rootScope.forwarder_id
                    }
                };
                vm.fnTrackAnalytics('Team-Edit-Confirm-Click',postData.data)
                api.userManagement.team.update({ 'id': vm.team_data._id }, postData, function (response) {
                    vm.init();
                    vm.teamList[vm.updateIndex] = response.data;
                    vm.submit_disabled = false;
                    util.showToast(''+vm.team_data.name+'Team Updated successfully');
                    vm.cancelDialog();
                }, function (err) {
                    vm.submit_disabled = false;
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                });
            }

           
        }

        function userComparer(otherArray) {
          return function (current) {
            return otherArray.filter(function (other) {
              return (other === current && other === current);
            }).length === 0;
          };
        }

        //open delete confirmation modal
        function fnOpenConfirmDeleteModal(team, ev) {
            vm.deleteType='Team';
            vm.deleteBtn = false;
            vm.deleteName = team._id;
            vm.deleteValue = team.name;
            $mdDialog.show({
                templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        //delete Team
        function fnDeleteData(id) {

            vm.deleteBtn = true;
            api.userManagement.team.remove({ 'id': id },
                function () {
                    var deleteData = vm.teamList.findIndex(function (item) {
                        return item._id === id;
                    });
                    vm.fnTrackAnalytics('Team-Delete-Confirm-Click',{'Team Name':deleteData.name})
                    vm.teamList.splice(deleteData, 1);
                    vm.deleteBtn = false;
                    $mdDialog.hide();
                    util.showToast('Team deleted successfully');
                }, function (err) {
                    util.showToast(util.displayValidationError(err));
                    $log.log(err);
                    vm.deleteBtn = false;
                    $mdDialog.hide();
                }
            );
        }

        function cancelDialog() {
            $mdDialog.hide();
        }

        //function to check team duplicate value
        function checkDuplicateName(teamsData){
            for (var i = 0; i < teamsData.length; i++)
                {
                if((vm.team_data.name.toLowerCase() === teamsData[i].name.toLowerCase() && i !== vm.updateIndex)){
                    vm.teamValidation=true;
                    return true;
                }
            }
        }

        //view team tree
        function fnViewTeam(teamData,ev){
            vm.fnTrackAnalytics('Team-View-Click',{'Team Name':teamData.name})
            vm.children = [];
            vm.isTeamLoading = true;
            api.userManagement.team.get({ 'id': teamData._id ,'forwarder_company_id' : $rootScope.forwarder_id },function (response) {
                try {
                    vm.isTeamLoading = false;
                    vm.children = response.data;
                } catch (e) {
                    vm.isTeamLoading = false;
                    $log.error(e);
                }
            }, function (err) {
                vm.isTeamLoading = false;
                $log.log(err);
            });
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/team-view/team-view.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.tags', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.tags', {
            url      : '/tags',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/tags/tags.html',
                    controller : 'TagController as vm'
                }
            },
            bodyClass: 'setting-tags'
        });

 
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.tags')
        .controller('TagController', TagController);

    /** @ngInject */
    function TagController(SettingService,util,$log,$mdSidenav,api,$mdDialog,$scope,$rootScope)
    {
        var vm = this;
        vm.configurations = SettingService;
        vm.deleteType='';
        vm.deleteValue='';
        vm.tagPermission = SettingService.getModulePermission('TAGS');
        vm.tag_color_arr = ['red-fg','grey-fg','green-fg','blue-fg','indigo-fg','yellow-700-fg','orange-fg','teal-fg'];
        vm.tag_color = 'orange-fg';
        vm.fnGetTagList = fnGetTagList;
        vm.fnSubmitTag = fnSubmitTag;
        vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
        vm.fnDeleteData = fnDeleteData;
        vm.cancelDialog = cancelDialog;
        vm.fnCreateTag = fnCreateTag;
        SettingService.displayForwarderSelectBox(util.isFreightbro);
        vm.fnGetTagList();

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            ordering: false,
            lengthMenu  : [5, 10, 20, 30, 50, 100],
            pageLength  : 10
        };

        $scope.$on('app.tags',function(){
            vm.fnGetTagList();
        });

        // get all Tag list
        function fnGetTagList(){
            vm.isDataLoading = true;
            api.userManagement.tag.get({'forwarder_company_id' : $rootScope.forwarder_id},function(response){
                try{
                    vm.isDataLoading = false;
                    vm.tagList = response.data;
                    SettingService.tagData = vm.tagList;
                }catch(e){
                    vm.isDataLoading = false;
                    $log.error(e);
                }
            },function(err){
                vm.isDataLoading = false;
                $log.log(err);
            });
        }

        //submit Tag
        function fnSubmitTag(){
            if(!vm.tag_name){
                vm.tagnameValidation= true;
            };
            if(vm.tagList){
                var isPresent = vm.tagList.some(function(el){ return el.name === vm.tag_name;}); 
                if(isPresent){
                    vm.tagValidation= true;
                }
            }
            if( vm.tagnameValidation || vm.tagValidation){
                return;
            }
           
            vm.submit_disabled = true;
            var postData = {
                'data': {
                  'name': vm.tag_name,
                  'tag_color' : vm.tag_color,
                  'forwarder_company_id' : $rootScope.forwarder_id
                }
            };
            api.userManagement.tag.save(postData,function(response){
                vm.tag_name = '';
                if(!vm.tagList){
                    vm.tagList = [];
                }
                vm.tagList.push(response.data);
                vm.submit_disabled = false;
                vm.cancelDialog();
                util.showToast('Tag submitted successfully');
            },function(err){
                vm.submit_disabled = false;
                util.showToast(util.displayValidationError(err));
                $log.error(err);
            });
        }

        function fnOpenConfirmDeleteModal(tag,ev){
            vm.deleteBtn = false;
            vm.deleteName = tag._id;
            vm.deleteType= 'Tag';
            vm.deleteValue= tag.name;
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm; }
            });
        }

        //delete tag
        function fnDeleteData(id){
            vm.deleteBtn = true;
            api.userManagement.tag.remove({'id': id},
                function(){
                    var deleteData = vm.tagList.findIndex(function(item){
                        return item._id === id;
                    });
                    vm.tagList.splice(deleteData, 1);
                    vm.deleteBtn = false;
                    $mdDialog.hide();
                    util.showToast('Tag deleted successfully');
                },function(err){
                    util.showToast(util.displayValidationError(err));
                    $log.log(err);
                    vm.deleteBtn = false;
                    $mdDialog.hide();
                }
            );
        }

        function fnCreateTag(ev){
            vm.tagnameValidation= false;
            vm.tagValidation= false;
            vm.tag_color = 'orange-fg';
            vm.tag_name = '';
            $mdDialog.show({
                templateUrl        : 'app/main/settings/dialogs/tag-form/tag-form.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm; }
            });
        }

        function cancelDialog(){
            $mdDialog.hide();
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.shipmentStatus', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.shipmentStatus', {
            url      : '/shipment-status',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/shipment-status/shipment-status.html',
                    controller : 'ShipmentStatusController as vm'
                }
            },
            bodyClass: 'setting-shipment-status'
        });

 
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.shipmentStatus')
        .controller('ShipmentStatusController', ShipmentStatusController);

    /** @ngInject */
    function ShipmentStatusController($mdSidenav,ProfileService,util,$mdDialog,$log,$scope,$sanitize,SettingService,$rootScope,localStorageService)
    {
        var vm = this;
        vm.util = util;
        vm.configurationPermission= SettingService.getModulePermission('CONFIGURATION');
        vm.getVendorData = getVendorData;
        vm.forwarderStatus = {};
        vm.fnISFirstSelect = fnISFirstSelect;
        vm.capitalizeStatusName = capitalizeStatusName;
        SettingService.displayForwarderSelectBox(util.isFreightbro);

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            ordering: false,
            lengthMenu  : [5, 10, 20, 30, 50, 100],
            pageLength  : 10
        };

        vm.getVendorData($rootScope.vendor_id);

        $scope.$on('app.shipmentStatus',function(){
            vm.getVendorData($rootScope.vendor_id);
        });

        //function to get status data by vendor id
        function getVendorData(vendor_id){
            vendor_id = $rootScope.vendor_id ? $rootScope.vendor_id : parseInt(localStorageService.get('authToken').value.vendor_id)
            vm.isDataLoading = true;
            ProfileService.getForwarderStatusByVendor(vendor_id).then(function(response){
                vm.forwarderStatus = response.data.status_obj;
                vm.isDataLoading = false;
                return vm.forwarderStatus;
            },function(error){
                vm.isDataLoading = false;
                $log.log(error);
            });
        }

    
        function fnISFirstSelect(statusData,mode){
            if(mode === 'fcl'){
                statusData.is_first_fcl = 1;
            }
            else if(mode === 'lcl'){
                statusData.is_first_lcl = 1;
            }
            else if(mode === 'air'){
                statusData.is_first_air = 1;
            }

            for(var i = 0; i < vm.forwarderStatus.length; i++){
                if(vm.forwarderStatus[i].id !== statusData.id ){
                    if( statusData.is_first_fcl === 1){
                        vm.forwarderStatus[i].is_first_fcl = 0;
                    }
                    if( statusData.is_first_lcl === 1){
                         vm.forwarderStatus[i].is_first_lcl = 0;
                    }
                    if( statusData.is_first_air === 1){
                         vm.forwarderStatus[i].is_first_air = 0;
                    }
                }
            }

            var data = {
                'shipper_settings' :{
                    'status' : statusData
                }
            }

            ProfileService.updateShipmentStatus(data).then(function(){
                // vm.forwarderStatus[index] = response.data.status_obj;
                // statusData
                util.showToast('Status Updated Successfully!!','top right', 3000);
                vm.cancelDialog();
                // return vm.forwarderStatus;
            },function(error){
                $log.log(error);
                if(error.status === 422){
                    util.showToast(error.data.message);
                    return false;
                }
            });
    }

    //function to capitalize status name
    function capitalizeStatusName(status){
        status = status.toLowerCase().split(' ');
          for (var i = 0; i < status.length; i++) {
            status[i] = status[i].charAt(0).toUpperCase() + status[i].slice(1);
          }
          status =  status.join(' ');
          return status;
    }

        // Methods

        ////////

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.roles', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.roles', {
            url      : '/roles',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/roles/roles.html',
                    controller : 'RoleController as vm'
                }
            },
            bodyClass: 'setting-roles'
        });

 
    }

})();

(function () {
    'use strict';

    angular
        .module('app.roles')
        .controller('RoleController', RoleController);

    /** @ngInject */
    function RoleController($mdSidenav, $log, SettingService, api, util, $mdDialog,$scope,$mdToast,$state,$rootScope, localStorageService) {
        var vm = this;
        vm.configurations = SettingService;
        vm.deleteValue='';
        vm.rolePermission = SettingService.getModulePermission('ROLES');
        vm.util = util;
        vm.toggleSidenav = toggleSidenav;
        vm.init = init;
        vm.getModuleList = getModuleList;
        vm.getPricingLevels = getPricingLevels;
        vm.pricingLevels = [];
        vm.fnTrackAnalytics=fnTrackAnalytics;
        vm.moduleList = [];
        vm.fnSubmitRoles = fnSubmitRoles;
        vm.fnGetSelectedModulesList = fnGetSelectedModulesList;
        vm.fnChangeRolesType = fnChangeRolesType;
        vm.fnDeleteModule = fnDeleteModule;
        vm.openRoleDeleteConfirmModal = openRoleDeleteConfirmModal;
        vm.fnDeleteData = fnDeleteData;
        vm.fnUpdateRole = fnUpdateRole;
        vm.fnGetUpdatedList = fnGetUpdatedList;
        vm.addModule = addModule;
        vm.cancelDialog = cancelDialog;
        vm.fnSelectAllPermission = fnSelectAllPermission;
        vm.getRolesData = getRolesData;
        vm.makeDetailBoxString=makeDetailBoxString;
        vm.fnChangeCreateFor = fnChangeCreateFor;
        vm.fnGetModuleListByUserType = fnGetModuleListByUserType;
        vm.reBuildRolesList = reBuildRolesList;
        vm.init();
        vm.fnGetModuleListByUserType();
        vm.getRolesData();
        vm.getPricingLevels();
        vm.fnValidateModuleFrm = fnValidateModuleFrm;
        vm.allowOperation = allowOperation;
        SettingService.displayForwarderSelectBox(util.isFreightbro);
        $scope.$on('app.roles',function(){
            vm.init();
            vm.getRolesData();
        });
        vm.getModulesCount = getModulesCount;
        vm.showDeleteErrorMsg = showDeleteErrorMsg;
        vm.showUserList = showUserList;
        vm.closeToast = closeToast;
        vm.viewUsersModule = viewUsersModule;
        vm.freightbroModulesList = [];
        vm.fnDefaultAccessModule = fnDefaultAccessModule;
        vm.toggleSuperuser = toggleSuperuser;
        vm.fnCreateRole = fnCreateRole;
        vm.fnEditRole = fnEditRole;
        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            ordering: false,
            responsive: true,
            lengthMenu  : [5, 10, 20, 30, 50, 100],
            pageLength  : 10
        };

        //function to initialize data
        function init() {
            vm.roles = {
                'name': '',
                'type': '',
                'created_for' : '',
                'modules': [],
                'is_super_role': 0,
                'is_unpublished_rates_allowed' : 0,
                'accessible_pricing_levels': []
            };
            vm.search_module_name = '';
            if(util.isFreightbro){
                vm.moduleList = [];
                vm.moduleListCopy = [];
            }
            vm.selectedModuleList = [];
            if(!util.isFreightbro){vm.roles.created_for = 'FORWARDER'; }
        }

        //function
        function fnGetModuleListByUserType(){
            vm.getModuleList('FORWARDER');
            if(util.isFreightbro){
                vm.getModuleList('SHIPPER');
                vm.getModuleList('FREIGHTBRO');
            }
            if(util.isAdmin){
              vm.getModuleList('SHIPPER');
            }
        }

        function getRolesData(){
            vm.isDataLoading = true;
            api.userManagement.role.get({'company_id' : $rootScope.forwarder_id },function (response) {
                try {
                    vm.rolesList = response.data;
                    vm.reBuildRolesList(vm.rolesList);
                    vm.isDataLoading = false;
                    vm.rolesListCopy = angular.copy(vm.rolesList);
                    SettingService.rolesData = vm.rolesList;
                } catch (e) {
                    vm.isDataLoading = false;
                    $log.error(e);
                }
            }, function (err) {
                vm.isDataLoading = false;
                $log.log(err);
            });
        }

        //function to get list of all modules
        function getModuleList(userType) {
            SettingService.getRolesModuleList(userType).then(function (response) {
                try {
                    if(userType === 'FORWARDER'){
                        vm.forwarderModulesList = response.data.modules;
                    }
                    if(userType === 'FREIGHTBRO'){
                        vm.freightbroModulesList = response.data.modules;
                    }
                    if(userType === 'SHIPPER'){
                        vm.shipperModulesList = response.data.modules;
                    }
                    vm.fnChangeCreateFor(vm.roles.created_for);
                    vm.reBuildRolesList(vm.rolesList);
                } catch (e) {
                    $log.error(e);
                }
            }, function (error) {
                $log.log(error.data);
            });

        }

        //function to get list of pricing levels
        function getPricingLevels() {
            api.userManagement.pricingLevels.get(function (response) {
                try {
                    vm.pricingLevels = response.data;
                } catch (e) {
                    $log.error(e);
                }
            }, function (error) {
                $log.log(error);
            });
        }

        function makeDetailBoxString(){
            vm.selectedModuleList=[];
            vm.detailBoxString="";
            vm.detailBoxTooltip="";
            vm.selectedModuleList = vm.fnGetSelectedModulesList();
         
            angular.forEach(vm.selectedModuleList,function(value,key,index){
                // DEV-15823 - roles module name fix
                vm.detailBoxString += value.title || value.module_name;
                vm.detailBoxString+=(key>=0 && key<(index.length-1)) ? ",":"";
                vm.detailBoxTooltip += value.title || value.module_name;
                vm.detailBoxTooltip+=(key>=0 && key<(index.length-1)) ? ",":"";

            });
        }
        //function  to hide forwarder selection if user type is global
        function fnChangeRolesType(role_type) {
            vm.fnTrackAnalytics('Role-RoleType-Change')
            if (role_type === 'GLOBAL') {
                SettingService.showForwarderSelectBox = false;
            } else {
                SettingService.showForwarderSelectBox = true;
            }
            vm.makeDetailBoxString();
        }

        function fnDefaultAccessModule() {
          // inq, quote, shipment module accesss is given
          vm.fnTrackAnalytics('Role-AccessAll-Change')
          for(var i = 0; i < vm.moduleList.length; i++){
            if(vm.roles.is_super_role){
              if(vm.moduleList[i].module_name === 'Quotes' || vm.moduleList[i].module_name === 'Enquiries' || vm.moduleList[i].module_name === 'Shipments') {
                vm.moduleList[i].isSelected = 1;
                fnSelectAllPermission(1, vm.moduleList[i]);
              }
            }
            else if(vm.moduleList[i].module_name === 'Quotes' || vm.moduleList[i].module_name === 'Enquiries' || vm.moduleList[i].module_name === 'Shipments') {
              vm.moduleList[i].isSelected = 0;
              vm.selectedModuleList = [];
            }
            else {
              vm.moduleList[i].isSelected = 0;
              vm.selectedModuleList = [];
            }
          }
          vm.moduleValidation=false;
          vm.makeDetailBoxString();
        }

        //submit roles
        function fnSubmitRoles() {
            vm.fnTrackAnalytics('Role-Edit-Update-Click');
            vm.selectedModuleList = [];
            vm.selectedModuleList = vm.fnGetSelectedModulesList();
            if(vm.roles.created_for === 0){
                vm.createdForValidation= true;
            }
            if(!vm.roles.name){
                vm.rolesValidation= true;
            }
            if(!vm.selectedModuleList.length){
                vm.moduleValidation=true;
            }
            var isPresent = vm.rolesList.some(function (el) { return el.name === vm.roles.name; });
            if (isPresent) {
               vm.roleNameValidation=true;
            }
            if(vm.createdForValidation || vm.rolesValidation ||  vm.moduleValidation || vm.roleNameValidation){
                return false;
            }
            angular.forEach(vm.selectedModuleList, function(item, index, array){
                delete item.isSelected;
            });
            vm.roles.type = !vm.util.isFreightbro ? 'USER_DEFINED' : vm.roles.type;
            var postData = {
                'data': {
                    'name': vm.roles.name,
                    'type': vm.roles.type,
                    'modules': vm.selectedModuleList,
                    'created_for' : vm.roles.created_for,
                    'company_id': $rootScope.forwarder_id,
                    'is_super_role': vm.roles.is_super_role ? 1 : 0,
                    'is_unpublished_rates_allowed' : vm.roles.is_unpublished_rates_allowed ? 1 : 0,
                    'accessible_pricing_levels': vm.roles.accessible_pricing_levels && vm.roles.accessible_pricing_levels.length > 0 ? vm.roles.accessible_pricing_levels.join(',') : ''
                }
            };
            vm.fnTrackAnalytics('Role-Create-Confirm-Click',postData.data)
            if(vm.util.isFreightbro && !$rootScope.forwarder_id){
                postData.data.company_id = localStorageService.get('authToken').value.user_company_id;
            }
            // postData.data.company_id = vm.roles.type === 'GLOBAL' ? '' :  $rootScope.forwarder_id;
            util.isCallingApi = true;
            vm.submit_disabled = true;
            api.userManagement.role.save(postData, function (response) {
                vm.moduleList = angular.copy(vm.moduleListCopy);
                vm.init();
                vm.rolesList.push(response.data);
                vm.reBuildRolesList(vm.rolesList);
                vm.rolesListCopy = angular.copy(vm.rolesList);
                vm.submit_disabled = false;
                //vm.toggleSidenav('roles');
                util.showToast('Role created successfully');
                vm.cancelDialog();
                util.isCallingApi = false;
            }, function (err) {
                util.isCallingApi = false;
                vm.submit_disabled = false;
                vm.selectedModuleList = [];
                angular.forEach(vm.selectedModuleListCopy, function(item, index) {
                  angular.forEach(vm.moduleList, function(val2, index) {
                    if(angular.equals(item.module_name, val2.module_name)) {
                      Object.assign(val2,item);
                    }
                  });
                });
                util.showToast(util.displayValidationError(err));
                $log.error(err);
            });
        }

        //function to get  only selected module list while creating roles
        function fnGetSelectedModulesList() {
            angular.forEach(vm.moduleList, function (item) {
                if (item.isSelected) {
                    vm.selectedModuleList.push(item);
                    vm.selectedModuleListCopy = angular.copy(vm.selectedModuleList);
                }
            });
            angular.forEach(vm.selectedModuleList, function(item, index, array){
                //delete item.isSelected;
                return array.indexOf(item) === index;
            });
            return vm.selectedModuleList;
        }

        //function to add module in role
        function addModule(role) {
            vm.fnTrackAnalytics('Role-Action-Change');
            if (role.module) {
                if(!role.module.module_name){
                    util.showToast('Please Select Module Name');
                }
                if(role.module.module_name){
                    var moduleData = {
                        'module_name': role.module.module_name,
                        'module_code': role.module.module_code,
                        'create': role.module.create,
                        'delete': role.module.delete,
                        'read': role.module.read,
                        'edit': role.module.edit,
                        'is_removed' : 0,
                    };
                    role.modules.push(moduleData);
                    role.module = {
                        'module_name': '',
                        'module_code': '',
                        'create': '',
                        'delete': '',
                        'read': '',
                        'edit': ''
                    };
                }
            }
        }

        //function to open module delete confirmation dialog box
        function fnDeleteModule(moduleDelete, ev) {
            vm.fnTrackAnalytics('Role-Action-Change');
            vm.deleteType = 'Module';
            vm.deleteModule = moduleDelete;
            vm.fnDeleteData();
        }

        //function to open role delete confirmation dialog box
        function openRoleDeleteConfirmModal(role, ev) {
            vm.deleteType = 'Role';
            vm.deleteValue=role.name;
            vm.deleteBtn = false;
            vm.deleteName = role.id;
            
            $mdDialog.show({
                templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        //delete role
        function fnDeleteData(id) {
            vm.deleteBtn = true;
            if(vm.deleteType === 'Role') {

                util.isCallingApi = true;
                api.userManagement.role.remove({ 'id': id },
                    function () {
                        var deleteData = vm.rolesList.findIndex(function (item) {
                            return item.id === id;
                        });
                        util.callMixpanel("Role-DeleteConfirm-Click",{
                            "Role Name": deleteData.name
                        })
                        vm.rolesList.splice(deleteData, 1);
                        vm.deleteBtn = false;
                        util.isCallingApi = false;
                        $mdDialog.hide();
                        util.showToast('Role deleted successfully');
                    }, function (err) {
                        util.isCallingApi = false;
                        vm.showDeleteErrorMsg(err);
                        $log.log(err);
                        vm.deleteBtn = false;
                        $mdDialog.hide();
                    }
                );
            }else{
                vm.deleteModule.is_removed = 1;
            }
        }

        function showDeleteErrorMsg(err){
            if(err.data.users){
                vm.deleteErr = err;
                $mdToast.show({
                    hideDelay   : 3000,
                    position    : 'top right',
                    controllerAs: 'ctrl',
                    controller: function () { this.parent = vm; },
                    template : '<md-toast><span class="md-toast-text" flex>'+err.data.message+'</span><md-button md-no-ink class="font-weight-600 md-accent-fg" ng-click="ctrl.parent.showUserList($event,ctrl.parent.deleteErr.data.users)"> Show Users </md-button><md-button md-no-ink ng-click="ctrl.parent.closeToast()">Close</md-button></md-toast>'
                });
            }else{ util.showToast(util.displayValidationError(err)); }
        }

        function showUserList(ev,users){
            vm.showUsersList = users;
            // vm.showUsers = vm.showUserList ? false : true;
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/show-user/show-users.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        function closeToast() {
            $mdToast.hide();
        }

        //update team
        function fnUpdateRole(roleData, index) {
            vm.fnTrackAnalytics('Role-Edit-Update-Click');
            if (angular.equals(roleData,vm.rolesListCopy[index])) {
                util.showToast('No changes !');
                return false;
            }
            //to avoid role data reference modification before api response 
            var role = angular.copy(roleData);
            // Convert array back to comma-separated string for API
            if (role.accessible_pricing_levels && Array.isArray(role.accessible_pricing_levels)) {
                role.accessible_pricing_levels = role.accessible_pricing_levels.length > 0 ? role.accessible_pricing_levels.join(',') : '';
            } else if (!role.accessible_pricing_levels) {
                role.accessible_pricing_levels = '';
            }
            if(role.module){
                if(role.module.module_name){
                    vm.addModule(role);
                }
            }
            var updatedRoleModule = vm.fnGetUpdatedList(role.modules,vm.rolesListCopy[index].modules);
            role.modules = updatedRoleModule;
            delete role.module;
            angular.forEach(role.modules, function (modules) {
                if (modules.is_removed === undefined) {
                    modules.is_removed = 0;
                }
            });
            var moduleListCpy = angular.copy(role.moduleList);
            if(role.moduleList){
                delete role.moduleList;
            }
            var putData = {
                'data': role
            };
            util.isCallingApi = true;
            api.userManagement.role.update({ 'id': role.id }, putData, function (response) {
                vm.rolesList[index] = response.data[0];
                vm.rolesList[index].moduleList = moduleListCpy;
                vm.rolesListCopy[index] = angular.copy(vm.rolesList[index]);
                vm.submit_disabled = false;
                util.isCallingApi = false;
                util.showToast('' + role.name + ' Role Updated successfully');
                vm.cancelDialog();
            }, function (err) {
                util.isCallingApi = false;
                vm.rolesList[index].moduleList = moduleListCpy;
                vm.submit_disabled = false;
                util.showToast(util.displayValidationError(err));
                $log.error(err);
            });
        }

        //function to get only updated/edited list of modules
        function fnGetUpdatedList(newModule,oldModule){
            var updatedModule = [];
            angular.forEach(newModule, function (newM) {
                //pushed module if module edited
                oldModule.find(function (oldM) {
                    if((oldM.id === newM.id) && (newM.is_removed !== 1)){
                        if(JSON.stringify(oldM) !== JSON.stringify(newM)){
                            updatedModule.push(newM);
                        }
                    }
                });
                //pushed module if module deleted
                if (newM.is_removed === 1 && newM.id) {
                    updatedModule.push(newM);
                }
                //pushed module if module created
                if (newM.is_removed === 0) {
                    updatedModule.push(newM);
                }
            });
            return updatedModule;
        }

        function toggleSidenav(sidenavId,form) {
            vm.init();
            vm.moduleList = angular.copy(vm.moduleListCopy);
            if(form){
                form.$setPristine();
                form.$setUntouched();
            }
            
            $mdSidenav(sidenavId).toggle();
        }

        function cancelDialog(event) {
            if(event){
                vm.fnTrackAnalytics(event)
            }
            $mdDialog.hide();
        }

        //if checkbox selected then select all permission i.e CRUD
        function fnSelectAllPermission(isSelected, roleModule){
            if(isSelected){
                roleModule.create = 1;
                roleModule.edit = 1;
                roleModule.delete = 1;
                roleModule.read = 1;
            }
            else{
                roleModule.create = 0;
                roleModule.edit = 0;
                roleModule.delete = 0;
                roleModule.read = 0;
            }
        }

        //check module duplicate value
        function fnValidateModuleFrm(role){
            vm.fnTrackAnalytics('Role-Modules-Change')
            angular.forEach(role.modules, function(item,index) {
                if(item.module_code === role.module.module_code){
                    if(item.is_removed){
                        role.modules.splice(index, 1);
                    }else{
                        util.showToast(role.module.module_name+' module already exist');
                        role.module = {
                            'module_name': '',
                            'module_code': '',
                            'create': '',
                            'delete': '',
                            'read': '',
                            'edit': ''
                        };
                    }
                    
                }
            });
        }

        //function to allow CRUD operation based role type
        function allowOperation(roles){
            if(roles.type === 'GLOBAL'){
                if(!util.isFreightbro){ //only god user can edit,add and delete global roles
                    return false;
                }else { return true; }
            }
            else{
                return true;
            }
        }

        //function to get module list by its user category while changing values
        function fnChangeCreateFor(userType){
            vm.fnTrackAnalytics('Role-CreatedFor-Change')
            if(userType === 'FORWARDER'){
                vm.moduleList = angular.copy(vm.forwarderModulesList);
                vm.moduleListCopy = angular.copy(vm.moduleList);
                vm.toggleSuperuser();
            }
            if(userType === 'SHIPPER'){
                vm.moduleList = angular.copy(vm.shipperModulesList);
                vm.moduleListCopy = angular.copy(vm.moduleList);
                vm.toggleSuperuser();
            }
            vm.makeDetailBoxString();
        }

        //function to restructure data roles data with module list w.r.t role type
        function reBuildRolesList(rolesData) {
            if(rolesData){
                rolesData.forEach(function(i){
                    if(i.created_for === 'FORWARDER'){
                        i.moduleList = vm.forwarderModulesList;
                    }if(i.created_for === 'FREIGHTBRO'){
                        i.moduleList = vm.freightbroModulesList;
                    }
                    else{
                        if(i.created_for === 'SHIPPER'){
                            i.moduleList = vm.shipperModulesList;
                        }
                    }
                });
                return rolesData;
            }
        }

        //function to get module counts
        function getModulesCount(modules){
            var count = 0;
            modules.forEach(function(i){
                if(!i.is_removed){
                    count = count +  1;
                }
            });
            return count;
        }

        //function to view users module
        function viewUsersModule(){
            if(util.navPermission.users && util.navPermission.users[1]){
                $mdDialog.hide().then(function(){
                    $state.go('app.users');
                })
            }
        }

        vm.fnChangePermission = fnChangePermission;

        //function to mark read access if update/delete/create is checked while changing permission
        function fnChangePermission(modules){
            vm.fnTrackAnalytics('Role-Permission-Change');
            if(modules.create || modules.edit ||  modules.delete){
                modules.read = 1;
            }
        }

        // function to toggle and remove slected list when created for changes
        function toggleSuperuser() {
          if(vm.roles.is_super_role) {
            vm.roles.is_super_role = !(vm.roles.is_super_role);
            vm.selectedModuleList = [];
            vm.selectedModuleListCopy = [];
          }
        }
        function fnTrackAnalytics(action, params){
            if(!params){
              var params = {};
            }
            util.callMixpanel(action, params);
        }
        function fnCreateRole(role,index,ev){
            vm.createdForValidation=false;
            vm.rolesValidation=false;
            vm.moduleValidation=false;
            vm.roleNameValidation=false;
            vm.init();
           vm.fnTrackAnalytics("Role-Create-Click")
            angular.forEach(vm.moduleListCopy, function(item,index) {
                item.isSelected=0;
            });
            vm.moduleList = angular.copy(vm.moduleListCopy);
            vm.detailBoxString="";
            vm.detailBoxTooltip="";
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/role-form/role-add.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        function fnEditRole(role,index,ev){
            vm.roles = angular.copy(role);
            // Convert comma-separated string to array for multi-select
            if (vm.roles.accessible_pricing_levels && typeof vm.roles.accessible_pricing_levels === 'string') {
                vm.roles.accessible_pricing_levels = vm.roles.accessible_pricing_levels.split(',').filter(function(level) {
                    return level.trim() !== '';
                });
            } else if (!vm.roles.accessible_pricing_levels) {
                vm.roles.accessible_pricing_levels = [];
            }
            var action = vm.allowOperation(vm.roles);
            vm.fnTrackAnalytics("Role-"+(action ? "Edit" : "View")+"-Click",{
                "Role Name": vm.roles.name
            })
            vm.editedIndex = index;
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/role-form/role-edit.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }
        $rootScope.$on("$mdMenuClose", function() {
            vm.detailBoxString='';
            vm.detailBoxTooltip="";
            vm.makeDetailBoxString();
          });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings',
            [
                'app.companyInformation',
                'app.teams',
                'app.companyGroups',
                'app.tags',
                'app.assignShippers',
                'app.shipmentStatus',
                'app.roles',
                'app.pdfConfigurations'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'Admin',
        //     group : true,
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.setting', {
        //     title : 'Settings',
        //     icon  : 'icon-cog',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.setting.profile', {
        //     title: 'Profile',
        //     state: 'app.profile'
        // });

        // msNavigationServiceProvider.saveItem('fuse.setting.status', {
        //     title: 'Status',
        //     state: 'app.status'
        // });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/settings');

    }

})();

(function () {

    'use strict';
  
    angular
      .module('app.settings')
      .factory('SettingService', SettingService);
  
    /** @ngInject */
    function SettingService($http, api, util, $rootScope) {
  
      var SettingService = {
        vendor_id: '',
        company_id: '',
        shipmentStatus: '',
        tagData: '',
        departmentsData: '',
        locationData: '',
        designationData: '',
        teamData: '',
        countriesData : '',
        modulesList : '',
        getManagerList: getManagerList,
        getCountryList: getCountryList,
        getStateList: getStateList,
        getSuggestedDesignationList: getSuggestedDesignationList,
        getRolesModuleList: getRolesModuleList,
        getAllForwarder: getAllForwarder,
        getAllShippers: getAllShippers,
        getAssignedForwarders: getAssignedForwarders,
        getAssignedShippers: getAssignedShippers,
        postAssignedShippers: postAssignedShippers,
        putAssignedShippers: putAssignedShippers,
        deleteForwarder: deleteForwarder,
        permissions : {
          'departments' : [],
          'locations' : [],
          'tags' : [],
          'roles' : [],
          'teams' : [],
          'designations' : [],
          'assign_shippers' : [],
          'configurations' : []
        },
        showForwarderSelectBox : false,
        displayForwarderSelectBox : displayForwarderSelectBox,
        getModulePermission : getModulePermission,
        getLanguageList : getLanguageList,
        getTermsConditions : getTermsConditions
       
  
      };
      return SettingService;
  
      function deleteForwarder(id) {
        var url = api.baseUrl + '/api/assign-shipper/' + id;
        return $http.delete(url);
      }
  
      function getAllForwarder(user, id) {
        var url = '';
        if (user === 'god') {
          url = api.baseUrl + '/api/team_users'+util.fnGetForwarderIdApi('?');
        } else {
          url = api.baseUrl + '/api/team_users';
        }
        return $http.get(url);
      }
  
      function postAssignedShippers(data) {
        var url = api.baseUrl + '/api/assign-shipper';
        return $http.post(url, data);
      }
  
      function putAssignedShippers(data, id) {
        var url = api.baseUrl + '/api/assign-shipper/' + id;
        return $http.put(url, data);
      }
   
      function getAssignedForwarders(user, id) {
        var url = '';
        if (user === 'god') {
          url = api.baseUrl + '/api/get-assigned-forwarders'+util.fnGetForwarderIdApi('?');
        } else {
          url = api.baseUrl + '/api/get-assigned-forwarders';
        }
        return $http.get(url);
      }
  
      function getAssignedShippers(id, fwdId) {
        var url = '';
        url = api.baseUrl + '/api/get-assigned-shippers/' + id  + '?forwarder_company_id=' + fwdId;
        return $http.get(url);
      }
  
      function getAllShippers(user, id) {
        var url = '';
        if (user === 'god') {
          url = api.baseUrl + '/api/get-shippers?id=' + id;
        } else {
          url = api.baseUrl + '/api/get-shippers';
        }
        return $http.get(url);
      }
  
      function getManagerList() {
        var url = api.baseUrl + '/api/team_users'+ util.fnGetForwarderIdApi('?') ;
        return $http.get(url);
      }
  
      function getCountryList(uuid) {
        var url = '';
        if(util.isSharedQuote()) {
          url = api.baseUrl +'/shared/countries/'+uuid;
        }else{
          var url = api.baseUrl + '/api/countries';
        }
        return $http.get(url);
      }
  
      function getStateList(q) {
        var url = api.baseUrl + '/api/countries?q=' + q;
        return $http.get(url);
      }
  
      function getSuggestedDesignationList() {
        var url = api.baseUrl + '/api/suggested_designation';
        return $http.get(url);
      }
  
      function getRolesModuleList(user_type) {
        var url = api.baseUrl + '/api/modules-list?created_for='+user_type;
        return $http.get(url);
      }
  
      function displayForwarderSelectBox(isFreightBro){
          if(!isFreightBro) {
              SettingService.showForwarderSelectBox = false;
          } else {
              SettingService.showForwarderSelectBox = true;
          }
      }
      //function to form each module permission in array
      function getModulePermission(nav){
        var permission = [0,0,0,0];
        util.get_nav.find(function(item){
            if(item.code === nav){
                permission = util.splitIntoArray(item.permissions);
            }
        });
        return permission;
      }

      function getLanguageList() {
        var url = api.baseUrl + '/api/languages';
        return $http.get(url);
      }

      function getTermsConditions(mode, standard, language) {
        var url = "";
        url = api.baseUrl + '/api/terms?mode=' + mode + '&standard=' + standard + '&language=' + language;
        return $http.get(url);
      }
    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.pdfConfigurations', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pdfConfigurations', {
            url      : '/pdf-configuration/:entity',
            params   : {
                entity: { squash: true, value: null }
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/pdf-configuration/pdf-configuration.html',
                    controller : 'PdfConfigurationController as vm'
                }
            },
            bodyClass: 'setting-pdf-configuration'
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pdfConfigurations')
        .controller('PdfConfigurationController', PdfConfigurationController);

    /** @ngInject */
    function PdfConfigurationController($stateParams, $sce, iframeService, $window)
    {
        var vm = this;

        // Extract entity from URL (e.g., 'booking' or 'quote')
        vm.entity = $stateParams.entity || 'booking';

        // Set iframe height based on window
        vm.iframeHeight = iframeService.calculateMaxHeight($window.innerHeight);

        init();

        function init() {
            // Build the iframe URL for the PDF configuration based on the entity
            // e.g., 'pdf-configuration/booking'
            var appName = 'pdf-configuration/' + vm.entity;
            var url = iframeService.fnGetIframeUrl(appName, 'pdfConfigurations', 'web');
            
            // Trust the URL for the iframe src
            vm.iframeUrl = $sce.trustAsResourceUrl(url);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.companyInformation', ['datatables','ng.ckeditor'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.companyInformation', {
            url      : '/company-information',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/company-information/company-information.html',
                    controller : 'CompanyInformationController as vm'
                }
            },
            bodyClass: 'setting-company-information'
        });

 
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.companyInformation')
        .controller('CompanyInformationController', CompanyInformationController);

    /** @ngInject */
    function CompanyInformationController(ProfileService,util,$log,$sanitize,SettingService,shareQuoteService,$scope,$filter,$mdSidenav,$timeout,$mdDialog,$rootScope)
    {
        var vm = this;
        vm.util = util;
        vm.configurations = SettingService;
        vm.configurationPermission = SettingService.permissions.configurations;
        vm.getVendorData = getVendorData;
        vm.company_logo = '';
        vm.original_logo = '';
        vm.getCompanyProfileData = getCompanyProfileData;
        vm.updateCompanyProfile = updateCompanyProfile;
        // To Do make api and call from Backend
        vm.constitutionList = [
            {
             'name':'Pvt.Ltd',
             'value':'pvt_ltd'
            },
            {
             'name':'Public Ltd',
             'value':'public_ltd'
            },
            {
             'name':'Partnership',
             'value':'partnership'
            },
            {
             'name':'Proprietorship',
             'value':'proprietorship'
            }
        ];
        vm.terms_condition_focus = terms_condition_focus;
        vm.terms_condition_key_up = terms_condition_key_up;

        vm.getConstitution = getConstitution;
        vm.validateEmail = validateEmail;
        vm.isEmptyOrNull = isEmptyOrNull;
        vm.toggleSidenav = toggleSidenav;
        vm.editView = false;
        vm.fnLogoValidation = fnLogoValidation;
        vm.getCompanyProfileData(); //init to get company profile data
        vm.fnResetLogo = fnResetLogo;
        SettingService.displayForwarderSelectBox(util.isFreightbro);
        // functions for cropped logo
        vm.cropper = '';
        vm.origFilename = '';
        vm.origType = '';
        vm.src = '';
        vm.saveImg = saveImg;
        vm.cancelDialog = cancelDialog;
        vm.confirmLeave = confirmLeave;
        vm.fnlogoStyleChange = fnlogoStyleChange;
        vm.openMenu = openMenu;
        vm.srcToFile = srcToFile;
        vm.fnReplaceLogo = fnReplaceLogo;
        vm.isLogoUpdated = false;
        vm.isPreview = false;
        vm.checkOriginalLogo = checkOriginalLogo;
        vm.fnOrigLogo = fnOrigLogo;
        vm.termsConditionCkEditorConfig = angular.copy(util.ckEditorConfig);
        vm.termsConditionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
        vm.init = init;
        vm.getLanguageList = getLanguageList;
        vm.languageChanged = languageChanged;
        vm.isTermsLoading = true;
        vm.isFfcDomain = isFfcDomain;

        function isFfcDomain() {
            var flag = vm.companyProfile && vm.companyProfile.is_ffc;
            return flag === true || flag === 1 || flag === '1';
        }

        $scope.$on('app.companyInformation',function(){
            vm.getCompanyProfileData();
        });

        function init(){
            vm.getLanguageList();
            vm.isTermsLoading = false;
        }
        vm.init();

        //function to get status data by vendor id
        function getVendorData(vendor_id){
            ProfileService.getQuoteStatusByVendor(vendor_id).then(function(response){
                vm.quoteStatus = response.data.data;
                return vm.quoteStatus;
            },function(error){
                $log.log(error);
            });
        }

        // function to show original logo if url present
        function fnOrigLogo() {
            $(document).ready(function(){
                var cropped = document.querySelector('.cropped-img');
                cropped.src = vm.companyProfile.company_logo;
                vm.src = vm.companyProfile.original_logo;
            });
        }

        //Code to get company profile data
        function getCompanyProfileData(){
            vm.isDataLoading = true;
            ProfileService.getCompanyProfile($rootScope.forwarder_id).then(function(response){
                vm.companyProfile = response.data;
                vm.companyProfile.date_of_establishment = vm.companyProfile.date_of_establishment == 'null' ? null : vm.companyProfile.date_of_establishment;
                vm.companyProfile.domain_data.shared_rate_receivers = vm.companyProfile.domain_data.shared_rate_receivers ? vm.companyProfile.domain_data.shared_rate_receivers.split(',') : [] ;
                vm.companyProfile.original_logo = vm.companyProfile.original_logo == '' ? '' : vm.companyProfile.original_logo;
                vm.companyProfileCopy = angular.copy(vm.companyProfile);
                getImgMeta(vm.companyProfile.company_logo);
                vm.checkOriginalLogo(false);
                // Ckeditor sanitzation
                vm.companyProfile.company_address = util.decodeValue(vm.companyProfile.company_address);
                vm.companyProfile.tnc_fcl = util.decodeValue(vm.companyProfile.tnc_fcl);
                vm.companyProfile.tnc_lcl = util.decodeValue(vm.companyProfile.tnc_lcl);
                vm.companyProfile.tnc_air = util.decodeValue(vm.companyProfile.tnc_air);
                vm.companyProfile.language = 'en';
                vm.isDataLoading = false;
                return vm.companyProfile;
            },function(error){
                vm.isDataLoading = false;
                $log.log(error);
            });

        }

        //Code to updateCompanyProfile
        function updateCompanyProfile(tabName){
            var mixpanelObj={
                'Tab name':tabName,
                'Company Name': vm.companyProfile.company_name,
                'Company Website': vm.companyProfile.domain_data.company_website_url,
                'Phone Number': vm.companyProfile.company_phone_number,
                'Company Tracking Url': vm.companyProfile.domain_data.company_tracking_url,
                'Company Email ID':vm.companyProfile.company_email,
                'Company Address': vm.companyProfile.company_address ,
                'City': vm.companyProfile.city,
                'Company Logo': vm.company_logo,
                'Terms and Condition Link': vm.companyProfile.domain_data.terms_and_condtion,
                'Terms and Condition':{
                    'FCL':vm.companyProfile.tnc_fcl,
                    'LCL':vm.companyProfile.tnc_lcl,
                    'AIR':vm.companyProfile.tnc_air
                },
               ' Document Submit Required': vm.companyProfile.domain_data.document_submit_required,
                'Document Submit Email': vm.companyProfile.domain_data.document_submit_email,
                'Shipment Notification From Specialist': vm.companyProfile.domain_data.shipment_notification_from_specialist,
               ' Common Email': vm.companyProfile.domain_data.common_email,
               ' Sender Name':vm.companyProfile.domain_data.mail_from_name,
                'Shared Rate Receivers':vm.companyProfile.domain_data.shared_rate_receivers
            }
            util.callMixpanel('CI-ApplyChanges-Click',mixpanelObj)
            vm.companyProfile.company_address = vm.companyProfile.company_address == null ? '' : vm.companyProfile.company_address;
            vm.companyProfile.state = vm.companyProfile.state == null ? '' : vm.companyProfile.state;
            vm.companyProfile.country = vm.companyProfile.country == null ? '' : vm.companyProfile.country;
            vm.companyProfile.postal_code = vm.companyProfile.postal_code == null ? '' : vm.companyProfile.postal_code;
            vm.companyProfile.terms_and_condtion = vm.companyProfile.terms_and_condtion == null ? '' : vm.companyProfile.terms_and_condtion;
            vm.companyProfile.company_turnover = !vm.companyProfile.company_turnover ? '' : vm.companyProfile.company_turnover;
            vm.companyProfile.number_of_employees = !vm.companyProfile.number_of_employees ? '' : vm.companyProfile.number_of_employees;
            var form = new FormData();
            vm.companyProfile.date_of_establishment =  $filter('date')(vm.companyProfile.date_of_establishment, 'yyyy-MM-dd');
            form.append('data[number_of_employees]', (vm.companyProfile.number_of_employees ? vm.companyProfile.number_of_employees : ""));
            form.append('data[company_turnover]', (vm.companyProfile.company_turnover ? vm.companyProfile.company_turnover : ""));
            form.append('data[iata_commission]',  (vm.companyProfile.iata_commission ? vm.companyProfile.iata_commission : ""));
            form.append('data[incentive]', (vm.companyProfile.incentive ? vm.companyProfile.incentive : ""));
            form.append("data[date_of_establishment]", (vm.companyProfile.date_of_establishment ? vm.companyProfile.date_of_establishment : ""));
            form.append("data[assignor_company_id]", vm.companyProfile.assignor_company_id);
            form.append("data[company_name]", vm.companyProfile.company_name);
            form.append("data[company_address]", (vm.companyProfile.company_address ? util.encodeValue(vm.companyProfile.company_address) : ""));
            form.append("data[city]", (vm.companyProfile.city ? vm.companyProfile.city : ""));
            form.append("data[company_constitution]", (vm.companyProfile.company_constitution ? vm.companyProfile.company_constitution : ""));
            form.append("data[company_email]", (vm.companyProfile.company_email ? vm.companyProfile.company_email : ""));

            form.append("data[company_phone_number]", (vm.companyProfile.company_phone_number ? vm.companyProfile.company_phone_number : ""));
            form.append('data[company_phone_code]', vm.companyProfile.company_phone_code);
            form.append('data[company_phone_country]', vm.companyProfile.company_phone_country);

            form.append("data[state]", (vm.companyProfile.state ? vm.companyProfile.state : ""));
            form.append("data[country]", (vm.companyProfile.country ? vm.companyProfile.country : ""));
            form.append("data[postal_code]", (vm.companyProfile.postal_code ? vm.companyProfile.postal_code : ""));
            form.append("data[tnc_fcl]", util.encodeValue(vm.companyProfile.tnc_fcl));
            form.append("data[tnc_lcl]", util.encodeValue(vm.companyProfile.tnc_lcl));
            form.append("data[tnc_air]", util.encodeValue(vm.companyProfile.tnc_air));
            form.append("data[std_tnc_fcl]", util.encodeValue(vm.companyProfile.std_tnc_fcl));
            form.append("data[std_tnc_lcl]", util.encodeValue(vm.companyProfile.std_tnc_lcl));
            form.append("data[std_tnc_air]", util.encodeValue(vm.companyProfile.std_tnc_air));
            form.append("data[language]", vm.companyProfile.language);
            // domain
            form.append("data[domain]", vm.companyProfile.domain);
            form.append("data[domain_data][solution_type]", (vm.companyProfile.domain_data.solution_type));
            form.append("data[domain_data][mailgun_domain_verified_status]", (vm.companyProfile.domain_data.mailgun_domain_verified_status));
            form.append("data[domain_data][mailgun_domain]", vm.companyProfile.domain_data.mailgun_domain);
            form.append("data[domain_data][mailgun_apikey]", vm.companyProfile.domain_data.mailgun_apikey);
            form.append("data[domain_data][common_email]", (vm.companyProfile.domain_data.common_email ? vm.companyProfile.domain_data.common_email : ""));
            form.append("data[domain_data][domain_name]", (vm.companyProfile.domain));
            form.append("data[domain_data][document_submit_required]", (vm.companyProfile.domain_data.document_submit_required));
            form.append("data[domain_data][document_submit_email]", (vm.companyProfile.domain_data.document_submit_email ? vm.companyProfile.domain_data.document_submit_email : ""));
            form.append("data[domain_data][shipment_notification_from_specialist]", (vm.companyProfile.domain_data.shipment_notification_from_specialist));
            form.append("data[domain_data][send_shipment_booking_confirmation]", (vm.companyProfile.domain_data.send_shipment_booking_confirmation ? vm.companyProfile.domain_data.send_shipment_booking_confirmation : ""));
            form.append("data[domain_data][reply_to]", (vm.companyProfile.domain_data.reply_to ? vm.companyProfile.domain_data.reply_to : ""));
            form.append("company_logo", (vm.company_logo ? vm.company_logo : ""));
            if(vm.isLogoUpdated && vm.original_logo) {
                form.append("original_logo", (vm.original_logo ? vm.original_logo : ""));
            }

            //new fields
            form.append("data[domain_data][toll_free_contact]", vm.companyProfile.domain_data.toll_free_contact);
            form.append("data[domain_data][terms_and_condtion]",(vm.companyProfile.domain_data.terms_and_condtion ? vm.companyProfile.domain_data.terms_and_condtion : ""));
            form.append("data[domain_data][company_website_url]",vm.companyProfile.domain_data.company_website_url);
            form.append("data[domain_data][company_tracking_url]", vm.companyProfile.domain_data.company_tracking_url);
            form.append("data[domain_data][mail_from_name]", vm.companyProfile.domain_data.mail_from_name);
            form.append("data[domain_data][shared_rate_receivers]", vm.companyProfile.domain_data.shared_rate_receivers);
            form.append('data[domain_data][shipment_initials]', vm.companyProfile.domain_data.shipment_initials);
            form.append('data[domain_data][quote_initials]', vm.companyProfile.domain_data.quote_initials);

            util.isCallingApi = true;
            vm.isLogoUpdated = true;
            vm.isPreview = true;
            var selectedLanguage = vm.companyProfile.language;
            ProfileService.updateCompanyProfile(form, vm.companyProfile.id).then(function(response){
                var resData = angular.fromJson(response);
                vm.companyProfile = resData.company;
                vm.companyProfile.domain_data.shared_rate_receivers = vm.companyProfile.domain_data.shared_rate_receivers ? vm.companyProfile.domain_data.shared_rate_receivers.split(',') : [] ;
                vm.companyProfile.date_of_establishment = vm.companyProfile.date_of_establishment == 'null' ? null : vm.companyProfile.date_of_establishment;
                var random = (new Date()).toString();
                if(!util.isFreightbro){
                    $('#domain-comp-logo').attr('src', resData.company.company_logo);
                    $rootScope.domainData.logo = resData.company.company_logo;
                }

                // Ckeditor sanitzation
                vm.companyProfile.company_address = util.decodeValue(vm.companyProfile.company_address);
                vm.companyProfile.tnc_fcl = util.decodeValue(vm.companyProfile.tnc_fcl);
                vm.companyProfile.tnc_lcl = util.decodeValue(vm.companyProfile.tnc_lcl);
                vm.companyProfile.tnc_air = util.decodeValue(vm.companyProfile.tnc_air);
                vm.companyProfile.language = selectedLanguage;
                
                // vm.companyProfile.company_logo = resData.company.company_logo + "?cb=" + random;
                // vm.companyProfile.original_logo = resData.company.original_logo === "" ? "" : (resData.company.original_logo + "?cb=" + random);
                vm.companyProfileCopy = angular.copy(vm.companyProfile);
                // vm.editView = false; //according to tester it should remain on same page
                util.isCallingApi = false;
                util.showToast('Profile Updated Successfully!!','top right', 3000);
                if(vm.companyProfile.original_logo) {
                    vm.isOrigLogo = true;
                    vm.fnOrigLogo();
                }
                vm.isLogoUpdated = false;
                vm.isPreview = false;
            },function(error){
                vm.companyProfile.company_address = util.decodeValue(vm.companyProfile.company_address);
                vm.companyProfile.tnc_fcl = util.decodeValue(vm.companyProfile.tnc_fcl);
                vm.companyProfile.tnc_lcl = util.decodeValue(vm.companyProfile.tnc_lcl);
                vm.companyProfile.tnc_air = util.decodeValue(vm.companyProfile.tnc_air);
                util.isCallingApi = false;
                vm.isLogoUpdated = false;
                vm.isPreview = false;
                $log.log(error);
                util.showToast(util.displayValidationError(error));
            });
        }

        function getConstitution(constitute){
            if(constitute){
                var constitution = vm.constitutionList.find(function(item){
                    return item.value === constitute;
                   });
                return constitution.name;
            }
            else{
                return 'N/A';
            }
        }

        // function to validate email in chips
        function validateEmail(emails, userInput){
          util.validateEmail(emails, userInput);
          if(util.invalidEmail) {
            $('.comp-invalidErrorMsg').show().delay(1000).fadeOut();
          }
          else if(util.duplicateEmail) {
            $('.comp-duplicateErrorMsg').show().delay(1000).fadeOut();
          }
          else{
            util.callMixpanel('CI-SharedRateReceivers-Change',{"Value" : userInput })
          }
        }

        //forms terms and condition with bullets points
        function terms_condition_focus(className){
            if(document.getElementById(className).value === ''){
                document.getElementById(className).value +='• ';
            }
        }

        function terms_condition_key_up(event,className){
            util.getBulletPontOnInput(event,className);
        }

        //show N/A if data/value unavailable
        function isEmptyOrNull(data){
            if(!data){
                return 'N/A';
            }
            else {
                return data;
            }
        }

        //toggle side-nav
        function toggleSidenav(sidenavId){
            $mdSidenav(sidenavId).toggle();
        }

        // Methods////////

        function checkOriginalLogo(isEdit, ev) {

            // if original logo present and viewmode
            if(vm.companyProfile && !isEdit) {
                vm.isOrigLogo = vm.companyProfile.original_logo ? true : false;
                vm.fnOrigLogo();
            }

            // view mode -- change to edit mode directly
            if(!isEdit) {
                vm.editView = !vm.editView;
            }

        }

        // leave without saving warning modal
        function confirmLeave(type, ev) {

            // yes -- switch to view profile and remove changes
            if(type==="yes") {
                vm.editView = false;
                vm.fnResetLogo();
                $mdDialog.hide();
            }

            // no -- remain on edit profile
            else {
                vm.editView = true;
                vm.cancelDialog();
            }
        }

        // upload logo and validate
        function fnLogoValidation(type, file, ev){

            // for init and replace logo
            if(type === 'init') {

                // return if file is > 10mb
                if(vm.generalFrm.company_logo && vm.generalFrm.company_logo.$error.maxSize) {
                    return;
                }

                vm.original_logo_copy = file;

                if (ev.target.files.length) {
                    // save file name and type for response
                    vm.origFilename = ev.target.files[0].name;
                    vm.origType = ev.target.files[0].type;
                    // start file reader
                    var reader = new FileReader();
                    vm.original_logo_copy = ev.target.files[0];

                    // on image laod
                    reader.onload = function(ev) {
                        if(ev.target.result){
                            // save src to pass in cropper dialog
                            vm.src = ev.target.result;
                            // save this url for edit option as well
                            vm.srcCopy = angular.copy(vm.src);
                            // set variable value to show rectangle crop box auto-selected
                            vm.logoStyle = 'rectangle';

                            // show modal
                            $mdDialog.show({
                                templateUrl: 'app/main/settings/dialogs/edit-logo/edit-logo.html',
                                targetEvent: ev,
                                clickOutsideToClose: false,
                                scope: $scope,
                                preserveScope: true,
                                controllerAs: 'ctrl',
                                controller: function () { this.parent = vm; },
                                onComplete : function () {
                                    vm.image = document.getElementById('image');
                                    vm.fnlogoStyleChange(vm.image);
                                }
                            });
                        }
                    };

                    // read file
                    reader.readAsDataURL(ev.target.files[0]);
                }
            }

            // for edit logo
            if(type === 'edit') {

                // if original logo is file object
                if(vm.companyProfile.original_logo instanceof File) {
                    vm.src = vm.srcCopy;
                    vm.original_logo_copy = vm.companyProfile.original_logo;

                    // show modal
                    $mdDialog.show({
                        templateUrl: 'app/main/settings/dialogs/edit-logo/edit-logo.html',
                        targetEvent: ev,
                        clickOutsideToClose: false,
                        scope: $scope,
                        preserveScope: true,
                        controllerAs: 'ctrl',
                        controller: function () { this.parent = vm; },
                        onComplete : function () {

                            vm.image = document.getElementById('image');
                            vm.fnlogoStyleChange(vm.image);
                        }
                    });
                }

                else {

                    // if original logo is https link from api response
                    vm.src = vm.companyProfile.original_logo;
                    getImgMeta(vm.companyProfile.company_logo);

                    // show modal
                    $mdDialog.show({
                        templateUrl: 'app/main/settings/dialogs/edit-logo/edit-logo.html',
                        targetEvent: ev,
                        clickOutsideToClose: false,
                        scope: $scope,
                        preserveScope: true,
                        controllerAs: 'ctrl',
                        controller: function () { this.parent = vm; },
                        onComplete : function () {
                            vm.image = document.getElementById('image');
                            vm.fnlogoStyleChange(vm.image);
                        }
                    });
                }
            }
        }

        // Get style of image by url
        function getImgMeta(url) {
            var img = new Image();
            img.src = url;
            img.onload = function() { 
                if(this.width === this.height){
                    vm.logoStyle = 'square';
                }else{
                    vm.logoStyle = 'rectangle';
                }
            }
        }

        // rectangle/square select
        function fnlogoStyleChange(img) {

            // select rectangle option
            if(vm.logoStyle === 'rectangle') {

                if(vm.cropper){
                    vm.cropper.destroy();
                }
                vm.cropper = new Cropper(img, {
                    minCropBoxWidth : 135,
                    minCropBoxHeight : 45,
                    // cropBoxResizable : false,
                    // cropBoxMovable : false,
                    toggleDragModeOnDblclick : false,
                    center : false,
                    aspectRatio : 3/1
                });
            }
            else {

                // select square option
                if(vm.cropper){
                    vm.cropper.destroy();
                }
                vm.cropper = new Cropper(img, {
                    minCropBoxWidth : 45,
                    minCropBoxHeight : 45,
                    // cropBoxResizable : false,
                    // cropBoxMovable : false,
                    toggleDragModeOnDblclick : false,
                    center : false,
                    aspectRatio : 1/1
                });
            }
        }

        // reset logo on delete and cancel click
        function fnResetLogo(){
            vm.company_logo = null;
            vm.original_logo = null;
            if(vm.cropper) {
                vm.cropper.destroy();
            }
            vm.isPreview = false;
            vm.isLogoUpdated = false;
            vm.isOrigLogo = false;
        }

        // save on click
        function saveImg(e) {
            e.preventDefault();
            vm.isPreview = true;
            vm.editView = true;
            // vm.isLogoUpdated = true;

            // get result to data url
            if(vm.logoStyle === 'rectangle') {
                var imgSrc = vm.cropper.getCroppedCanvas({
                    // width : 135,
                    // height: 45,
                    imageSmoothingQuality: 'high',
                    // fillColor: '#ffffff'
                }).toDataURL(vm.origType);

                vm.isLogoRectangle = true;
            }
            else {
                var imgSrc = vm.cropper.getCroppedCanvas({
                    // width : 45,
                    // height: 45,
                    imageSmoothingQuality: 'high',
                    // fillColor: '#ffffff'
                }).toDataURL(vm.origType);

                vm.isLogoRectangle = false;
            }

            if(!vm.original_logo_copy && vm.companyProfile.original_logo){
                var imgFile = vm.companyProfile.original_logo.split('/');
                vm.origFilename = imgFile[imgFile.length-1];
                vm.origType = 'img/'+imgFile[imgFile.length-1].split('.')[1];
            }

            // convert data url to file object for api request
            vm.srcToFile(imgSrc, vm.origFilename, vm.origType).then(function(file){
                
                vm.company_logo = file;
                vm.original_logo = vm.original_logo_copy ? vm.original_logo_copy : vm.companyProfile.original_logo;

                if(vm.original_logo_copy) {
                    vm.isLogoUpdated = true;
                }
                else {
                    vm.isLogoUpdated = false;
                }
            });

            vm.cancelDialog();

            // capture cropped preview box
            var cropped = document.querySelector('.cropped-img');

            // show image cropped
            cropped.src = imgSrc;
            util.callMixpanel('CI-CompanyLogo-Change')
        }

        // converting cropper response to file object to pass in api response
        function srcToFile(origLogoSrc, fileName, mimeType){
            return (fetch(origLogoSrc)
                .then(function(res){return res.arrayBuffer();})
                .then(function(buf){return new File([buf], fileName, {type:mimeType});})
            );
        }

        //function to open menu dropdown
        function openMenu($mdMenu,ev){
            ev.stopPropagation();
            $mdMenu.open(ev);
        }

        // replace logo
        function fnReplaceLogo() {
            $('#fileEdit_company_logo').click();
        }

        // cancel dialog
        function cancelDialog() {
            $mdDialog.hide();
        }

        vm.languageLoading = false;
        vm.languageList = [];
        function getLanguageList() {
            vm.languageLoading = true;
            SettingService.getLanguageList().then(function(response) {
                try {
                    vm.languageList = response.data.data.languages || [];
                    
                    // Ensure English is always available
                    var hasEnglish = vm.languageList.find(function(lang) { return lang.language_code === 'en'; });
                    if (!hasEnglish) {
                        vm.languageList.unshift({language_code: 'en', language_name: 'English'});
                    }
                    vm.languageLoading = false;
                } catch (e) {
                    vm.languageLoading = false;
                    vm.languageList = [{language_code: 'en', language_name: 'English'}]; // Fallback to English
                    $log.error(e);
                }
            }, function(error) {
                vm.languageLoading = false;
                vm.languageList = [{language_code: 'en', language_name: 'English'}]; // Fallback to English
                $log.log(error);
            });
        }


        function languageChanged(){
            var allMode = ['fcl', 'lcl', 'air'];
            vm.isTermsLoading = true;
            allMode.forEach(function(mode){
                SettingService.getTermsConditions( mode ,false ,vm.companyProfile.language).then(function(response) {
                    try {
                        vm.companyProfile['tnc_'+mode] = util.decodeValue(response.data.terms);
                        $timeout(function () {
                            vm.isTermsLoading = false;
                        }, 500);
                    } catch (e) {
                        vm.isTermsLoading = false;
                        $log.error(e);
                    }
                }, function(error) {
                    vm.isTermsLoading = false;
                    $log.log(error);
                });
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.companyGroups', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.companyGroups', {
            url      : '/company-groups',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/company-groups/company-groups.html',
                    controller : 'CompanyGroupController as vm'
                }
            },
            bodyClass: 'setting-company-groups'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.companyGroups')
        .controller('CompanyGroupController', CompanyGroupController);

    /** @ngInject */
    function CompanyGroupController(SettingService, $log, util, $mdDialog, api, $rootScope, $http, apiUrl, $scope, localStorageService) {
        var vm = this;
        
        // Variables
        vm.deleteType = '';
        vm.deleteValue = '';
        vm.configurations = SettingService;
        vm.companyGroupPermission = SettingService.getModulePermission('COMPANY_GROUPS');
        
        // Functions
        vm.fnGetCompanyGroupList = fnGetCompanyGroupList;
        vm.fnSubmitCompanyGroup = fnSubmitCompanyGroup;
        vm.fnEditCompanyGroup = fnEditCompanyGroup;
        vm.fnUpdateCompanyGroup = fnUpdateCompanyGroup;
        vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
        vm.fnDeleteData = fnDeleteData;
        vm.cancelDialog = cancelDialog;
        vm.fnCreateCompanyGroup = fnCreateCompanyGroup;
        vm.fnValidateForm = fnValidateForm;
        vm.checkDuplicateName = checkDuplicateName;
        vm.getCustomerCompanies = getCustomerCompanies;
        vm.fnViewCompanyGroup = fnViewCompanyGroup;
        vm.getCompanyNamesByIds = getCompanyNamesByIds;
        vm.init = init;

        // Initialize
        vm.init();
        
        // Ensure forwarder_id is set from localStorage before making API calls
        if (util.isFreightbro && localStorageService.get('forwarder') && localStorageService.get('forwarder').value) {
            $rootScope.forwarder_id = localStorageService.get('forwarder').value.id;
        }
        
        vm.fnGetCompanyGroupList();
        vm.getCustomerCompanies();

        // Listen for company group updates
        $scope.$on('app.companyGroups', function() {
            vm.fnGetCompanyGroupList();
            vm.getCustomerCompanies();
        });

        // DataTable options
        vm.dtOptions = {
            dom: '<\"top\"f>rt<\"bottom\"<\"left\"<\"length\"l>><\"right\"<\"info\"i><\"pagination\"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            ordering: false,
            responsive: true,
            lengthMenu: [5, 10, 20, 30, 50, 100],
            pageLength: 10
        };

        // Initialize data
        function init() {
            vm.companyGroup_data = {
                'groupName': '',
                'companyType': 'SHIPPER', // Always store as SHIPPER in DB
                'companyIds': []
            };
            vm.button_name = 'Add';
            vm.groupNameValidation = false;
            vm.companyValidation = false;
            vm.duplicateValidation = false;
        }

        // Get customer companies for dropdown
        function getCustomerCompanies() {
            // Use a simple $http call for companies endpoint
            $http.get(apiUrl + '/api/companies', {
                params: {'forwarder_company_id': $rootScope.forwarder_id}
            }).then(function (response) {
                vm.customerCompanies = response.data.data || [];
            }, function (error) {
                $log.error('Error fetching customer companies:', error);
                vm.customerCompanies = [];
            });
        }

        // Create company group dialog
        function fnCreateCompanyGroup(ev) {
            vm.init();
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/company-group-form/company-group-form.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        // Edit company group
        function fnEditCompanyGroup(companyGroup, index, ev) {
            vm.init();
            vm.button_name = 'Update';
            vm.updateIndex = index;
            vm.companyGroup_data = {
                '_id': companyGroup._id,
                'groupName': companyGroup.groupName,
                'companyType': 'SHIPPER', // Always use SHIPPER for DB storage
                'companyIds': companyGroup.companyIds || []
            };
            vm.companyGroup_data_copy = angular.copy(vm.companyGroup_data);
            
            // Set display company type for UI
            vm.displayCompanyType = 'Customer';
            
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/company-group-form/company-group-form.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        // Get company group list
        function fnGetCompanyGroupList() {
            vm.isDataLoading = true;
            api.userManagement.companyGroup.get({'forwarder_company_id': $rootScope.forwarder_id}, 
                function (response) {
                    try {
                        vm.companyGroupList = response.data || [];
                        vm.isDataLoading = false;
                    } catch (e) {
                        vm.isDataLoading = false;
                        $log.error(e);
                    }
                }, function (err) {
                    vm.isDataLoading = false;
                    $log.error(err);
                }
            );
        }

        // Submit company group
        function fnSubmitCompanyGroup() {
            // Reset validations
            vm.groupNameValidation = false;
            vm.companyValidation = false;
            vm.duplicateValidation = false;

            // Validate form
            if (!vm.fnValidateForm()) {
                return false;
            }

            if (vm.companyGroup_data._id) {
                vm.fnUpdateCompanyGroup();
            } else {
                // Check for duplicate name
                if (vm.checkDuplicateName()) {
                    return false;
                }

                var postData = {
                    'data': {
                        'groupName': vm.companyGroup_data.groupName,
                        'companyType': vm.companyGroup_data.companyType,
                        'companyIds': vm.companyGroup_data.companyIds,
                        'forwarder_company_id': $rootScope.forwarder_id
                    }
                };

                vm.submit_disabled = true;
                api.userManagement.companyGroup.save(postData, 
                    function (response) {
                        vm.init();
                        vm.companyGroupList.push(response.data);
                        vm.submit_disabled = false;
                        util.showToast('Company Group created successfully');
                        vm.cancelDialog();
                    }, function (err) {
                        vm.submit_disabled = false;
                        util.showToast(util.displayValidationError(err));
                        $log.error(err);
                    }
                );
            }
        }

        // Update company group
        function fnUpdateCompanyGroup() {
            if (vm.checkDuplicateName()) {
                return false;
            }

            var postData = {
                'data': {
                    'groupName': vm.companyGroup_data.groupName,
                    'companyType': vm.companyGroup_data.companyType,
                    'companyIds': vm.companyGroup_data.companyIds,
                    'forwarder_company_id': $rootScope.forwarder_id
                }
            };

            vm.submit_disabled = true;
            api.userManagement.companyGroup.update({'id': vm.companyGroup_data._id}, postData,
                function (response) {
                    vm.init();
                    vm.companyGroupList[vm.updateIndex] = response.data;
                    vm.submit_disabled = false;
                    util.showToast('Company Group updated successfully');
                    vm.cancelDialog();
                }, function (err) {
                    vm.submit_disabled = false;
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                }
            );
        }

        // Validate form
        function fnValidateForm() {
            var isValid = true;

            if (!vm.companyGroup_data.groupName) {
                vm.groupNameValidation = true;
                isValid = false;
            }

            if (!vm.companyGroup_data.companyIds || vm.companyGroup_data.companyIds.length === 0) {
                vm.companyValidation = true;
                isValid = false;
            }

            return isValid;
        }

        // Check duplicate name
        function checkDuplicateName() {
            if (vm.companyGroupList) {
                for (var i = 0; i < vm.companyGroupList.length; i++) {
                    if (vm.companyGroup_data.groupName.toLowerCase() === vm.companyGroupList[i].groupName.toLowerCase() && 
                        i !== vm.updateIndex) {
                        vm.duplicateValidation = true;
                        return true;
                    }
                }
            }
            return false;
        }

        // Open delete confirmation modal
        function fnOpenConfirmDeleteModal(companyGroup, ev) {
            vm.deleteType = 'Company Group';
            vm.deleteBtn = false;
            vm.deleteName = companyGroup._id;
            vm.deleteValue = companyGroup.groupName;
            
            $mdDialog.show({
                templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        // Delete company group
        function fnDeleteData(id) {
            vm.deleteBtn = true;
            api.userManagement.companyGroup.remove({'id': id},
                function () {
                    var deleteIndex = vm.companyGroupList.findIndex(function (item) {
                        return item._id === id;
                    });
                    vm.companyGroupList.splice(deleteIndex, 1);
                    vm.deleteBtn = false;
                    $mdDialog.hide();
                    util.showToast('Company Group deleted successfully');
                }, function (err) {
                    util.showToast(util.displayValidationError(err));
                    $log.error(err);
                    vm.deleteBtn = false;
                    $mdDialog.hide();
                }
            );
        }

        // Cancel dialog
        function cancelDialog() {
            $mdDialog.hide();
        }

        // View company group
        function fnViewCompanyGroup(companyGroup, ev) {
            vm.selectedCompanyGroup = companyGroup;
            vm.selectedCompanies = [];
            
            // Get company details for the selected company IDs
            if (companyGroup.companyIds && companyGroup.companyIds.length > 0) {
                vm.selectedCompanies = vm.customerCompanies.filter(function(company) {
                    return companyGroup.companyIds.indexOf(company.id) !== -1;
                });
            }
            
            $mdDialog.show({
                templateUrl: 'app/main/settings/dialogs/company-group-view/company-group-view.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        // Get company names by IDs for display
        function getCompanyNamesByIds(companyIds) {
            if (!companyIds || !companyIds.length || !vm.customerCompanies) {
                return [];
            }
            
            return vm.customerCompanies.filter(function(company) {
                return companyIds.indexOf(company.id) !== -1;
            }).map(function(company) {
                return company.company_name;
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.assignShippers', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.assignShippers', {
            url      : '/assign-shipper',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/settings/assign-shipper/assign-shipper.html',
                    controller : 'AssignShipperController as vm'
                }
            },
            bodyClass: 'setting-assign-shipper'
        });

 
    }

})();

(function () {
  'use strict';

  angular
    .module('app.assignShippers')
    .controller('AssignShipperController', AssignShipperController);

  /** @ngInject */
  function AssignShipperController(SettingService, $mdSidenav, $log, localStorageService, util, $scope, $rootScope) {
    var vm = this;
    vm.util = util;
    vm.configurations = SettingService;
    vm.isDataLoading = true;
    vm.forwarderList = [];
    vm.assignedShipperList = [];
    vm.shipperList = [];
    vm.groupedShipperList = [];
    vm.assignedShipperLength = 0;
    vm.disableBtn = false;
    vm.forwarderClick = false;
    vm.fwd_active_tab = '';
    vm.shipperListLoading = true;

    // Data
    vm.selectedMenu = 'Settings';
    // $('#forwarder_select').hide();
    vm.init = init;
    vm.getShippers = getShippers;
    vm.getAllForwarders = getAllForwarders;
    vm.groupShipperList = groupShipperList;
    vm.masterCheck = masterCheck;
    vm.checkIfParentClick = checkIfParentClick;
    vm.getAssignedForwarders = getAssignedForwarders;
    vm.getAssignedShippers = getAssignedShippers;
    vm.saveShippers = saveShippers;
    vm.reBuildForwarderList = reBuildForwarderList;
    vm.checkAssignedUsers = checkAssignedUsers;
    vm.clickParent = clickParent;
    vm.countTrack = countTrack;
    vm.sortGroupedList = sortGroupedList;
    vm.toggleSidenav = toggleSidenav;
    vm.showAssignedCount = showAssignedCount;
    SettingService.displayForwarderSelectBox(util.isFreightbro);

    $scope.$on('app.assignShippers', function () {
      vm.getAllForwarders($rootScope.forwarder_id);
      vm.groupedShipperList = [];
      vm.forwarderClick = false;
    });

    function init() {
      vm.getAllForwarders($rootScope.forwarder_id);
    }
    vm.init();

    function countTrack(bol) {
      if (bol) {
        vm.assignedShipperLength += 1;
      } else {
        vm.assignedShipperLength -= 1;
      }
    }

    function getAllForwarders(id) {
      if (util.isFreightbro) {
        SettingService.getAllForwarder('god', id).then(function (response) {
          vm.forwarderList = response.data;
          vm.isDataLoading = false;
          vm.getAssignedForwarders($rootScope.forwarder_id);
          vm.getShippers(vm.forwarderList[0]);
        }, function (err) {
          util.showToast(util.displayValidationError(err));
          vm.isDataLoading = false;
          $log.log(err);
        });
      } else {
        SettingService.getAllForwarder('nongod', localStorageService.get('authToken').value.user_company_id).then(function (response) {
          vm.forwarderList = response.data;
          vm.isDataLoading = false;
          vm.getAssignedForwarders($rootScope.forwarder_id);
          vm.getShippers(vm.forwarderList[0]);
        }, function (err) {
          util.showToast(util.displayValidationError(err));
          vm.isDataLoading = false;
          $log.log(err);
        });
      }
    }

    function masterCheck(event, value, arr) {
      event.stopPropagation();
      arr.forEach(function (i) {
        if (!value) {
          if(i.checked === false) {
            i.checked = true;
            vm.assignedShipperLength += 1;
          }
        } else {
          if(i.checked === true) {
            i.checked = false;
            vm.assignedShipperLength -= 1;
          }
        }
      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function checkIfParentClick(arr) {
      var found = arr.users.find(function (i) {
        return i.checked === true;
      });

      if (found) {
        arr.isChecked = true;
      } else {
        arr.isChecked = false;

      }
    }
    // forwarder.user_company_id, forwarder.id, forwarder.isAssigned
    function getShippers(forwarder) {
      vm.assignedShipperLength = 0;
      if (window.innerWidth < 600) {
        vm.toggleSidenav('assign-shipper');
      }
      vm.currentForwarderData = forwarder;
      vm.forwarderClick = true;
      vm.fwd_active_tab = forwarder.id;
      vm.currentForwarderId = forwarder.id;
      vm.currentForwarderIsAssigned = forwarder.isAssigned;
      vm.search_shipper = '';
      if (util.isFreightbro) {
        util.isCallingApi = true;
        SettingService.getAllShippers('god', forwarder.user_company_id).then(function (response) {
          vm.shipperList = response.data.data;
          vm.shipperListLoading = false;
          if (vm.currentForwarderIsAssigned) {
            vm.getAssignedShippers(forwarder.id);
          } else {
            vm.assignedShippers = null;
            vm.groupShipperList();
          }
          util.isCallingApi = false;
        }, function (err) {
          util.isCallingApi = false;
          util.showToast(util.displayValidationError(err));
          $log.log(err);
        });
      } else {

        if (vm.shipperList.length == 0) { //ankita
          util.isCallingApi = true;
          SettingService.getAllShippers('nongod', localStorageService.get('authToken').value.user_company_id).then(function (response) {
            vm.shipperList = response.data.data;
            if (vm.currentForwarderIsAssigned) {
              vm.getAssignedShippers(forwarder.id);
            } else {
              vm.assignedShippers = null;
              vm.groupShipperList();
            }
            vm.shipperListLoading = false;
            util.isCallingApi = false;
          }, function (err) {
            util.isCallingApi = false;
            util.showToast(util.displayValidationError(err));
            $log.log(err);
          });
        } else {
          if (vm.currentForwarderIsAssigned) {
            vm.getAssignedShippers(forwarder.id);
          } else {
            vm.assignedShippers = null;
            vm.groupShipperList();
          }
        }

      }
    }

    function reBuildForwarderList() {
      vm.assignedForwarders.forEach(function (i) {
        vm.forwarderList.forEach(function (j) {
          if (i.id === j.id) {
            j.isAssigned = true;
          } else {
            if (!j.isAssigned) {
              j.isAssigned = false;
            }
          }
        });
      });
    }

    function groupShipperList() {
      vm.groupedShipperList = [];
      vm.shipperList.forEach(function (i) {

        // vm.groupedShipperList.forEach(function(j){
        // if(j.company.id != i.company.id){
        var found = vm.groupedShipperList.find(function (element) {
          if( element.company && i.company ) {
            return element.company.id === i.company.id;
          }
        });

        if (!found) {
          vm.groupedShipperList.push({
            'company': i.company,
            'users': [],
            'isChecked': false
          });
        }
        // }
        // });
      });

      vm.groupedShipperList.forEach(function (i) {
        vm.shipperList.forEach(function (j) {
          if (i.company && j.company && (i.company.id === j.company.id)) {
            var found = i.users.find(function (user) {
              return user.id === j.id;
            });
            if (!found) {
              i.users.push({
                'id': j.id,
                'first': j.user_first_name,
                'last': j.user_last_name,
                'checked': false
              });
            }
          }
        });
      });
      vm.sortGroupedList();
    }

    function showAssignedCount(user){
      var resultCount = 0;
      for(var i = 0; i < user.length; i++){
        if(user[i].checked){
          resultCount++;
        }
      }
      return resultCount;
    }

    function sortGroupedList(){
      vm.groupedShipperList.forEach(function (i, k) {
        if (i.isChecked === true) {
          vm.groupedShipperList.splice(k, 1);
          vm.groupedShipperList.unshift(i);
        }
      });
    }

    function checkAssignedUsers() {
      vm.assignedShipperLength = 0;
      vm.groupedShipperList.forEach(function (i) {
        i.users.forEach(function (j) {
          vm.assignedShippers.shippers.forEach(function (a) {
            if (i.company.id === a.company.id) {
              a.users.forEach(function (b) {
                if (b.id === j.id) {
                  j.checked = true;
                  vm.assignedShipperLength += 1;
                } else if (!j.checked) {
                  j.checked = false;
                }
              });
            }
          });
        });
      });
      vm.clickParent();
    }

    function clickParent() {
      vm.groupedShipperList.forEach(function (i) {
        var found = i.users.find(function (j) {
          return j.checked === true;
        });

        if (!found) {
          i.isChecked = false;
        } else {
          i.isChecked = true;
        }
      });
    }

    function getAssignedForwarders(id) {
      if (util.isFreightbro) {
        SettingService.getAssignedForwarders('god', id).then(function (response) {
          vm.assignedForwarders = response.data.data;
          vm.reBuildForwarderList();
          // vm.groupShipperList();
        }, function (err) {
          util.showToast(util.displayValidationError(err));
          $log.log(err);
        });
      } else {
        SettingService.getAssignedForwarders('nongod', localStorageService.get('authToken').value.user_company_id).then(function (response) {
          vm.assignedForwarders = response.data.data;
          vm.reBuildForwarderList(); //ankita
        }, function (err) {
          util.showToast(util.displayValidationError(err));
          vm.permissionErr = err.status === 403 ? true : false;
          $log.log(err);
        });
      }
    }

    function getAssignedShippers(id) {
      vm.forwarderClick = false;
      SettingService.getAssignedShippers(id, $rootScope.forwarder_id).then(function (response) {

        vm.assignedShippers = response.data.data;
        vm.groupShipperList();
        vm.checkAssignedUsers();
      }, function (err) {
        util.showToast(util.displayValidationError(err));
        $log.log(err);
      });
    }

    function saveShippers() {
      vm.disableBtn = true;
      var shippersToSend = [];
      vm.groupedShipperList.some(function (i) {
        var checkedShipperArray = [];
        i.users.forEach(function (j) {
          if (j.checked === true) {
            checkedShipperArray.push(j.id);
          }
        });

        if (checkedShipperArray.length !== 0) {
          shippersToSend.push({
            'company': i.company.id,
            'users': checkedShipperArray
          });
        }
      });

      var data = {
        'data': {
          'forwarder_user': vm.currentForwarderId,
          'forwarder_company_id': $rootScope.forwarder_id,
          'shippers': shippersToSend
        }
      };

      if (vm.currentForwarderData.isAssigned && vm.assignedShipperLength === 0 ) {
        if(vm.assignedShippers){
          SettingService.deleteForwarder(vm.assignedShippers._id).then(function (response) {
          util.showToast(response.data.data);
          vm.currentForwarderData.isAssigned = false;
          vm.currentForwarderIsAssigned = false;
          vm.disableBtn = false;
        }, function (err) {
          util.showToast(util.displayValidationError(err));
          vm.disableBtn = false;
          $log.log(err);
        });
       }
      } else {
        if (vm.currentForwarderIsAssigned === true) {
          SettingService.putAssignedShippers(data, vm.assignedShippers._id).then(function (response) {
            vm.disableBtn = false;
            util.showToast('Saved successfully!');
            // if(!response.data.data.shippers.length){
            //   vm.currentForwarderData.isAssigned = false;
            // vm.currentForwarderIsAssigned = false;
            // }
            vm.assignedShippers = response.data.data;
          }, function (err) {
            util.showToast(util.displayValidationError(err));
            vm.disableBtn = false;
            $log.log(err);
          });
        } else {
          SettingService.postAssignedShippers(data).then(function (response) {
            vm.currentForwarderData.isAssigned = true;
            vm.currentForwarderIsAssigned = true;
            vm.assignedShippers = response.data.data;
            vm.disableBtn = false;
            util.showToast('Saved successfully!');
          }, function (err) {
            util.showToast(util.displayValidationError(err));
            vm.disableBtn = false;
            $log.log(err);
          });
        }
      }

    }

    ////////

  }
})();

(function(){
    'use strict';

    angular.module('app.search')
    .factory('SearchService' , SearchService);

    /** @ngInject */
    function SearchService($q,$mdToast,$http,$log,api,$filter,util,$rootScope, localStorageService, msApi)
    {

        var SearchService = {
          postSearchData: postSearchData,
          getLatestSearch: getLatestSearch,
          getLatestFtlSearch: getLatestFtlSearch,
          FclResult: {},
          AirResult: {},
          LclResult: {},
          FtlResult: {},
          FclEfpResult:{},
          rateTypeFilter: [],
          loadTypeArr: [],
          loadTypeFtl: [],
          previewData: {},
          getShipperList: getShipperList,
          getLegName: getLegName,
          getResultFromId: getResultFromId,
          getResultFromFtlId: getResultFromFtlId,
          getAllLoadList: getAllLoadList,
          airLcl_add_load: airLcl_add_load,
          airLcl_remove_load: airLcl_remove_load,
          calculateAirLoad: calculateAirLoad,
          calculateLclLoad: calculateLclLoad,
          formSearchData: formSearchData,
          getLanes: getLanes,
          getFclLoadDetails: getFclLoadDetails,
          loadValidation: loadValidation,
          getSearchLocations: getSearchLocations,
          // fetchNearbyRates : fetchNearbyRates,
          getRateToasterStatus: getRateToasterStatus,
          wlsFilterCustomerDetails: wlsFilterCustomerDetails,
          knowMoreServices: knowMoreServices,
          postSearchFtlData: postSearchFtlData,
          getPortsLocation: getPortsLocation,
          setThreeNumberDecimal: setThreeNumberDecimal,
          getEmptySearchParam: getEmptySearchParam,
          getBannerList: getBannerList,
          getResultFilter: getResultFilter,
          getPortsLocationFtl: getPortsLocationFtl,
          getTruckerData: getTruckerData,
          getAllLoadListFtl: getAllLoadListFtl,
          getCarrierSelectionData : getCarrierSelectionData,
          getResultFromFclEfpId:getResultFromFclEfpId,
          emptySearchParam: null,
          activeModeTab: "SEA-FCL",
          historyparam: "",
          specialparam: "",
          searchHistoryData : [],
          carrierSelectionData : {},
          isCarrierApiTriggered : false,
          isNewSearch : false,
          searchMode : null,
          getResultV2FromId:getResultV2FromId
        };

        return SearchService;

        //////

        

        // Function to get port list for search and result module
        function getSearchLocations(searchText, mode, input_type, search_type){
            var vendor_id = localStorageService.get('authToken') ? localStorageService.get('authToken').value.vendor_id : "";
            var data = {'data' :
                            {
                                'mode': mode,
                                'search_query' : searchText,
                                'input_type':input_type,
                                'search_type': search_type,
                                'vendor_id' : vendor_id
                            }
                    };
            var url =  api.baseUrl + '/api/places';
            return $http.post(url,data);
        }

        function getEmptySearchParam() {
          return msApi.resolve('search@get');
        }

        function getPortsLocation(searchText, mode, input_type, search_type,type) {
            
          angular.element('md-virtual-repeat-container').addClass('custom-container');
          var data = {
            'data' : {
              'mode': mode,
              'search_query' : searchText ? searchText : '',
              'input_type':input_type,
              'search_type': search_type || null,
              'vendor_id' : localStorageService.get('authToken') ? localStorageService.get('authToken').value.vendor_id : ""
            }
          };
            var url =  api.baseUrl + '/api/places';
            return $http.post(url,data).then(function(response){
              if(type){
                response.data.data.location.forEach(function(port_details){
                  port_details["input_type"]=type
               });
              }
              return response.data.data.location;
          },function(error){
              $log.log(error.data);
              return [];
          });
        }

        function getPortsLocationFtl(searchText, mode, inputType, searchType) {
          var vendor_id = localStorageService.get('authToken') ? localStorageService.get('authToken').value.vendor_id : "";
            angular.element('md-virtual-repeat-container').addClass('custom-container');
            var data = {
              data: {
                mode: "FTL",
                searchType: searchType,
                vendorId: vendor_id,
              },
            };
            if(searchText){
                data.data['query'] =searchText;
            }
            var config={
              params:data.data
            }
              var url =  api.baseUrl + '/api/v3/places';
              return $http.get(url,config).then(function(response){
                return response.data.data;
            },function(error){
                $log.log(error.data);
                return [];
            });
          }

        function getLanes(){
            var url =  api.baseUrl + '/api/lanes';
            return $http.get(url);
        }

        function getResultFilter(){
            var url =  api.baseUrl + '/api/v2/result-filters';
                return $http.get(url).then(function (response){
                    return response.data;
                },function(error){
                    $log.log(error.data);
                    return [];
                })
        }

        /**
         * post the Fcl Search Data
         *  @param {*} searchData
         */
        function postSearchData(searchData){
            return $http.post(api.baseUrl + '/api/v2/search', searchData);
        }

        function postSearchFtlData(searchData){
          return $http.post(api.baseUrl + '/api/v3/search', searchData);

        }
        

        /**
         * function to form load details
         * @param {*} AirloadDetails
         */
        function formAirLoadDetails(AirloadDetails){
            var response = 'gross_weight: ' +  $filter('number')(AirloadDetails.gross_weight, 2) + ' | volumetric_weight: ' +  $filter('number')(AirloadDetails.volumetric_weight, 2) + ' | chargeable_weight:' + $filter('number')(AirloadDetails.chargeable_weight, 2);
            return response;
        }

        function getLatestSearch(offset){
          if(util.navPermission.search && util.navPermission.search[1]){
            var url = api.baseUrl + '/api/search?count=9&offset='+offset + util.fnGetForwarderIdApi('&');
            if(SearchService.activeModeTab){
              url = url+'&mode='+SearchService.activeModeTab;
            }
            return $http.get(url);
          }
        }

        function getLatestFtlSearch(offset){
          if(util.navPermission.search && util.navPermission.search[1]){
            var url = api.baseUrl + '/api/v3/recent-searches?count=9&offset='+offset + util.fnGetForwarderIdApi('&');
            if(SearchService.activeModeTab){
              url = url+'&mode=FTL';
            }
            return $http.get(url);
          }
        }

        function getTruckerData(type,mode){
          var vendorId = localStorageService.get('authToken') ? localStorageService.get('authToken').value.vendor_id : "";
          var url = api.baseUrl +'/api/v3/carriers?mode=FTL&type=transporter'+'&vendorId='+vendorId;
          return $http.get(url).then(function(response){
            if(response.data) {
              return response.data;
            }
           },function(error){
              $log.error(error);
           });        }

        function getLegName(data){
            var url = api.baseUrl + '/api/legs';
            return $http.post(url,data).then(function(response){
                return response;
            },function(error){
                console.log(error);
            });
        }

        function getShipperList(url) {
            return $http.get(url).then(function(response){
                return response;
            },function(error){
                console.log(error);
            });
        }

        //get data after reload result page
        function getResultFromId(id){
            var url = api.baseUrl + '/api/search/' + id;
            return $http.get(url);
        }

        //get data after reload result page
        function getResultV2FromId(id){
          var url = api.baseUrl + '/api/v2/search/' + id;
          return $http.get(url);
      }

        function getResultFromFtlId(id){
          var url = api.baseUrl + '/api/v3/search/' + id;
          return $http.get(url);
      }

       function getResultFromFclEfpId(id){
          var url = api.baseUrl + '/api/efp/search/' + id;
          return $http.get(url);
      }

        function getAllLoadList(){
          var url =  api.baseUrl;
          if( util.isSharedPage() || util.isSharedQuote() ){
            url += '/get-load-types';
          }else{
            url += '/api/get-load-types';
          }

            return $http.get(url).then(function(response){
                return response.data.data;
            },function(error){
                console.log(error);
            });
        }
             function getAllLoadListFtl() {
               var url = api.baseUrl;
               
                 url += "/api/v3/loads";

               return $http.get(url).then(
                 function (response) {
                   return response.data.data;
                 },
                 function (error) {
                   console.log(error);
                 }
               );
             }


        //add air and lcl load
        function airLcl_add_load(load_data){
            if( load_data.length < 25){
                var load_obj =  {
                                    "qty": 1,
                                    "length": "",
                                    "breadth": "",
                                    "height": "",
                                    "weight": "",
                                    "volume": "",
                                    "load_metrics": []
                                };

                load_data.push(load_obj);
            }
            return load_data;
        }

        //remove air and lcl load
        function airLcl_remove_load(index,load_data){
            for(var i = 0; i < load_data.length; i++){
                if(index == i){
                    load_data.splice(i , 1);
                }
            }
        }

        //calculate air load data
        function calculateAirLoad(load){
            load.load_meta.volumetric_weight = 0;
            load.load_meta.gross_weight = 0;
            load.load_meta.chargeable_weight = 0;

            if(load.load_type == 'total_shipment'){  // when users selected calculate by units

                load.load_meta.volumetric_weight = load.load_meta.volume_unit == 'CBM' ? (load.load_meta.total_volume /0.006) : (load.load_meta.total_volume /(0.006*35.3147)); // calculating final volumetric_weight

                if (load.load_meta.volume_unit == 'CBM'){
                  load.load_meta.volumetric_weight = load.load_meta.total_volume / 0.006;
                } else if (load.load_meta.volume_unit == 'CFT'){
                  load.load_meta.volumetric_weight = load.load_meta.total_volume / (0.006 * 35.3147);
                } else if (load.load_meta.volume_unit == 'KG') {
                  load.load_meta.volumetric_weight = load.load_meta.total_volume / 1;
                } else if (load.load_meta.volume_unit == 'LBS') {
                  load.load_meta.volumetric_weight = load.load_meta.total_volume * 0.45;
                }

                load.load_meta.volumetric_weight = load.load_meta.volumetric_weight ? parseFloat(load.load_meta.volumetric_weight) : 0;

                load.load_meta.volumetric_weight = (load.load_meta.volumetric_weight < 1 ? 1 : load.load_meta.volumetric_weight);

                load.load_meta.gross_weight = load.load_meta.total_weight;

                load.load_meta.gross_weight = load.load_meta.input_weight_unit == 'KGs' ? load.load_meta.total_weight :( load.load_meta.total_weight *  0.45359237); // calculating final gross_weight
                load.load_meta.gross_weight = load.load_meta.gross_weight ? parseFloat(load.load_meta.gross_weight) : 0;

                load.load_meta.chargeable_weight = load.load_meta.volumetric_weight > load.load_meta.gross_weight ? load.load_meta.volumetric_weight : load.load_meta.gross_weight; // calculating chargeable weight
                load.load_meta.chargeable_weight = load.load_meta.chargeable_weight ? parseFloat(load.load_meta.chargeable_weight) : 0;
            }

            else if(load.load_type == 'units'){  // when users selected calculate by units
                var unit_load_data = load.load_details_value;
                var units_total_volume = 0;
                var units_total_weight = 0;
                load.load_meta.total_qty = 0;
                for(var i = 0; i < unit_load_data.length; i++){

                    unit_load_data[i].volume = ( ((unit_load_data[i].breadth == ''? 0 : unit_load_data[i].breadth) * (unit_load_data[i].height == ''? 0 : unit_load_data[i].height) * (unit_load_data[i].length == ''? 0 : unit_load_data[i].length)) * unit_load_data[i].qty );

                    if(load.load_meta.dimension_unit == 'CMS'){

                        units_total_volume += (unit_load_data[i].volume/1000000);
                    }
                    else if(load.load_meta.dimension_unit == 'Inches'){

                        units_total_volume += (unit_load_data[i].volume/1728);
                    }

                    units_total_weight += (unit_load_data[i].weight * unit_load_data[i].qty);

                    load.load_meta.total_qty += unit_load_data[i].qty;
                }

                load.load_meta.volumetric_weight = load.load_meta.dimension_unit == 'CMS' ? (units_total_volume /0.006) : (units_total_volume /(0.006*35.3147)); // calculating final volumetric_weight
                load.load_meta.volumetric_weight = load.load_meta.volumetric_weight ? parseFloat(load.load_meta.volumetric_weight) : 0;
                load.load_meta.volumetric_weight = (load.load_meta.volumetric_weight < 1 ? 1 : load.load_meta.volumetric_weight);

                load.load_meta.gross_weight = units_total_weight;

                load.load_meta.gross_weight = load.load_meta.input_weight_unit == 'KGs' ? units_total_weight :( units_total_weight *  0.45359237); // calculating final gross_weight
                load.load_meta.gross_weight = load.load_meta.gross_weight ? parseFloat(load.load_meta.gross_weight) : 0;

                load.load_meta.chargeable_weight = load.load_meta.volumetric_weight > load.load_meta.gross_weight ? load.load_meta.volumetric_weight : load.load_meta.gross_weight; // calculating chargeable weight
                load.load_meta.chargeable_weight = load.load_meta.chargeable_weight ? parseFloat(load.load_meta.chargeable_weight) : 0;
            }
            return load;
        }

        //calculate Lcl load data
        function calculateLclLoad(load){
            load.load_meta.volumetric_weight = 0;
            load.load_meta.gross_weight = 0;
            load.load_meta.chargeable_weight = 0;

            if(load.load_type == 'total_shipment'){  // when users selected calculate by units

                load.load_meta.volumetric_weight = load.load_meta.volume_unit == 'CBM' ? load.load_meta.total_volume : (load.load_meta.total_volume * 0.028316846592); // calculating final volumetric_weight
                load.load_meta.volumetric_weight = load.load_meta.volumetric_weight ? parseFloat(load.load_meta.volumetric_weight) : 0;

                load.load_meta.gross_weight = load.load_meta.input_weight_unit == 'KGs' ? (load.load_meta.total_weight / 1000 ) :( load.load_meta.total_weight *  0.00045359237); // calculating final gross_weight
                load.load_meta.gross_weight = load.load_meta.gross_weight ? parseFloat(load.load_meta.gross_weight) : 0;
            }

            else if(load.load_type == 'units'){  // when users selected calculate by units
                var unit_load_data = load.load_details_value;
                var units_total_volume = 0;
                var units_total_weight = 0;
                load.load_meta.total_qty = 0;
                for(var i = 0; i < unit_load_data.length; i++){

                    unit_load_data[i].volume = ( ((unit_load_data[i].breadth == ''? 0 : unit_load_data[i].breadth) * (unit_load_data[i].height == ''? 0 : unit_load_data[i].height) * (unit_load_data[i].length == ''? 0 : unit_load_data[i].length)) * unit_load_data[i].qty );

                    if(load.load_meta.dimension_unit == 'CMS'){

                        units_total_volume += (unit_load_data[i].volume/1000000);
                    }
                    else if(load.load_meta.dimension_unit == 'Inches'){

                        units_total_volume += (unit_load_data[i].volume/1728);
                    }

                    units_total_weight += (unit_load_data[i].weight * unit_load_data[i].qty);

                    load.load_meta.total_qty += unit_load_data[i].qty;
                }

                load.load_meta.volumetric_weight = load.load_meta.dimension_unit == 'CMS' ? units_total_volume : (units_total_volume * 0.028316846592); // calculating final volumetric_weight
                load.load_meta.volumetric_weight = load.load_meta.volumetric_weight ? parseFloat(load.load_meta.volumetric_weight) : 0;

                load.load_meta.gross_weight = load.load_meta.input_weight_unit == 'KGs' ? (units_total_weight / 1000) :( units_total_weight * 0.00045359237); // calculating final gross_weight
                load.load_meta.gross_weight = load.load_meta.gross_weight ? parseFloat(load.load_meta.gross_weight) : 0;
            }

            load.load_meta.chargeable_weight = load.load_meta.volumetric_weight > load.load_meta.gross_weight ? load.load_meta.volumetric_weight : load.load_meta.gross_weight; // final chargeable_weight calculation

            load.load_meta.chargeable_weight =  parseFloat(load.load_meta.chargeable_weight);

            // load.load_meta.weight_unit = load.load_meta.volumetric_weight > load.load_meta.gross_weight ? 'CBM' : 'Tons';

            return load;
        }

        //form final search data
        function formSearchData(searchData){
            var result = false;

            searchData.cargo_ready_date =  $filter('date')(searchData.cargo_ready_date, 'yyyy-MM-dd');

            if(!searchData.origin_location){
                util.showToast('Please select the valid origin.');
                result = true;
                // return false;
            }

            if(!searchData.destination_location){
                util.showToast('Please select the valid destination.');
                result = true;
                // return false;
            }

            if(searchData.origin_location && searchData.destination_location){
              if(searchData.origin_location._id === searchData.destination_location._id){
                util.showToast('Origin and Destination can not be same!');
                result = true;
                // return false;
              }
            }

            if(!result){
                if(searchData.cargo_ready_date != "" && searchData.cargo_ready_date != null){
                    searchData.cargo_ready_date =   $filter('date')(searchData.cargo_ready_date, 'yyyy-MM-dd');
                }else{
                    searchData.cargo_ready_date = $filter('date')(new Date(), 'yyyy-MM-dd');
                }

                if(searchData.search_name == ""){
                    searchData.search_name = searchData.origin_location.location + ' to '+ searchData.destination_location.location +' / '+ $filter('date')(searchData.cargo_ready_date, 'd MMM yyyy');
                } 
            }
            return result;
        }

        function getFclLoadDetails(load_details_value){
          var result = {
              "loadtype" : '',
              "typexqty" : null
          };
          load_details_value.forEach(function(value, i){
              if((load_details_value.length - 1) === i) {
                  result.loadtype += value.type + "X" + value.qty;
                      }
              else {
                  result.loadtype += value.type + "X" + value.qty + ',';
              }
              if(value.type === "20GP" || value.type === "20OT"|| value.type === "20RE" ||value.type === "20FR")
              {
                  result.typexqty += (value.qty * 1);
              }else{
                  result.typexqty += (value.qty * 2);
              }
          });
          return result;
        }

        function loadValidation(containerType){
            var result = true;
            var loadObj = util.limitObj.find(function(element) {
                return (element.load_code == containerType.type );
            });
            if(containerType.weight_qty <= 0){
                util.showToast('Please increase weight of ' + containerType.type + '.');
                result = false;
            }
            else if ( containerType.weight_unit == 'KGs' && loadObj.KGS != null && containerType.weight_qty > parseFloat(loadObj.KGS)) {
                util.showToast(containerType.type + ' load weight should be less than ' + loadObj.KGS);
                result = false;
            }else if ( containerType.weight_unit == 'Tons' && loadObj.TON != null && containerType.weight_qty > parseFloat(loadObj.TON)) {
                util.showToast(containerType.type + ' load weight should be less than ' + loadObj.TON);
                result = false;
            }
            return result;
        }

        // function fetchNearbyRates(data){
        //     data.data.cargo_ready_date = $filter('date')(data.data.cargo_ready_date, 'yyyy-MM-dd');
        //     var url =  api.baseUrl + '/api/port/nearby';
        //     return $http.post(url,data);
        // }

        // Function to show or hide rate fluctuation toaster
        function getRateToasterStatus(){
          var rateToasterStatus  = localStorageService.get('rateToasterStatus');
          if(rateToasterStatus==null){
            localStorageService.set('rateToasterStatus', true);
            return true;
          }else{
            return rateToasterStatus.value;
          }
        }

        //filter customer details for wls
        function wlsFilterCustomerDetails(userInput,filterFor, selectList, rfq_customer_company){
          var results = [];
          var user_input =  !userInput ? '' :  userInput.toLowerCase();
          if(selectList){
              if(filterFor === 'customer'){
                results = [];
                var isfouund  = false;
                selectList.forEach(function(item){
                  if(item.company && (item.company.company_name.toLowerCase().indexOf(user_input.toLowerCase()) !== -1) || ((item.email.toLowerCase()).indexOf(user_input.toLowerCase()) !== -1 )   ){
                       isfouund = !!(results.find(function(citem){ return citem.company.id === item.company.id;  }));
                      if( !isfouund ) {
                         results.push(item);
                      }
                  }
                });
              }
              else if(filterFor === 'company'){
                  results = [];
                  var isfouund  = false;
                  selectList.forEach(function(item){ // code for filtering the distinct company obj from shippers list
                      if(item.company && item.company.company_name.toLowerCase().indexOf(user_input.toLowerCase()) !== -1  ){
                           isfouund = !!(results.find(function(citem){ return citem.company.id === item.company.id;  }));
                          if( !isfouund ) {
                             results.push(item);
                          }
                      }
                  });
              }
              else if( filterFor === 'company_user') {

                  if(rfq_customer_company.id){  // code to filter customers list if company is selectwed
                      results = selectList.filter(function(item){
                          return  ((item.email.toLowerCase()).indexOf(user_input.toLowerCase()) !== -1 &&  rfq_customer_company.id === item.company.id );
                      });
                  }
              }
              else {
                      results = selectList.filter(function(item){ // code to filter customers as it is.
                          return  ((item.email.toLowerCase()).indexOf(user_input.toLowerCase()) !== -1 );
                      });

              }
          }

          return results;
      }

      function setThreeNumberDecimal(e) {
        /*
          48-57 - (0-9)Numbers
          8 - (backspace)
        */
       var num = e.currentTarget.value; // value as string
       var keyCode = (e.which) ? e.which : e.keyCode; //get keycode on keypress
       if(num !== '' && num.includes('.') && keyCode !== 8) {
          if(num.split('.')[1].length > 3) { // checking length after decimal
            num = parseFloat(num).toFixed(3); //remove the string after 3rd digit
            e.currentTarget.value = num;
          }
        }
      }


      //function to call api after know more click
      function knowMoreServices(data){
        var url =  api.baseUrl + '/api/notice-response';
        return $http.post(url,data);
      }

      // Function to get banner data
      function getBannerList() {
        var url = api.baseUrl + '/api/notice';
        return $http.get(url).then(function(response){
          if(response.data) {
            return response.data.data;
          }
         },function(error){
            $log.error(error);
         });
      }

      // Function to get banner data
      function getCarrierSelectionData(url,limit,offset,query,source) {
        var url = api.baseUrl+'/'+url+"?&query="+query+"&source="+source;
        return $http.get(url).then(function(response){
          if(response.data) {
            return response.data;
          }
         },function(error){
            $log.error(error);
         });
      }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.scheduleSearch', ['datatables','material.components.expansionPanels'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.scheduleSearch', {
                url    : '/Schedule-Search',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/schedulesSearch/schedulesSearch.html',
                        controller : 'ScheduleSearchController as vm'
                    },
                    data : { pageTitle: 'Schedule-Search' }
                },
                // resolve: {
                //     linersName: function(ScheduleSearchService, util, $state,analytics){
                //       //mixpanel code
                //       analytics.track("Schedule-Search");
                //       util.isCallingApi = true;
                //         return ScheduleSearchService.getLinersList().then(function(response){
                //             util.isCallingApi = false;
                //             return response.data;
                //         },function(error){
                //             util.isCallingApi = false;
                //             $state.go(util.redirectIfError(error));
                //         });
                //     }
                // },
                bodyClass: 'Schedule-Search-Page'
            });
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/schedulesSearch');

        // msNavigationServiceProvider.saveItem('fuse.scheduleSearch', {
        //     title    : 'Schedule-Search',
        //     icon     : 'icon-timetable',
        //     state    : 'app.scheduleSearch',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SCHEDULESEARCH.SCHEDULESEARCH_NAV',
        //     weight   : 1
        // });
    }


})();

(function(){
    'use strict';

    angular.module('app.scheduleSearch')
    .factory('ScheduleSearchService' , ScheduleSearchService);

    /** @ngInject */
    function ScheduleSearchService($q,$mdToast,$http,$log,api,$filter,util,$state,analytics)
    {

        var ScheduleSearchService = {
            getLinersList : getLinersList,
            generatePdf : generatePdf,
            getScheduleSearch : getScheduleSearch,
            getScheduleLinerName : getScheduleLinerName,
            originPort : null,
            destinationPort : null,
            scheduleData : [],
            scheduleLinerList : [],
            getCommaSeparatedData: getCommaSeparatedData
        };

        return ScheduleSearchService;

        function getScheduleSearch(originPort, destinationPort ,from_date, range, page, originPortname, destinationPortname, multiport){
          ScheduleSearchService.originPort = originPortname;
          ScheduleSearchService.destinationPort = destinationPortname;
          var url = api.baseMockUrl + '/v1/schedules?from_port='+originPort+'&to_port='+destinationPort+'&from_date='+from_date+'&weeks='+range+'&source=SEA_SCHEDULE';
          util.isCallingApi = true;
          return $http.get(url).then(function(response){
            ScheduleSearchService.scheduleData = response.data.data ? response.data.data : [];
            ScheduleSearchService.scheduleLinerList = response.data.liner_schedule_count;
            if(page === "search") {
              //mixpanel code
              analytics.track("Schedule Search Used",{
                "Origin Port": multiport ? getCommaSeparatedData(originPortname,'global_port_code') : originPortname.portcode_portname,
                "Destination Port": multiport ? getCommaSeparatedData(destinationPortname,'global_port_code') : destinationPortname.portcode_portname,
                "Duration in Weeks": range,
                "multi-port-enabled": multiport,
                "Total Available Schedules": ScheduleSearchService.scheduleData.length,
                "Liner List For Schedule": ScheduleSearchService.getScheduleLinerName(ScheduleSearchService.scheduleLinerList),
                "Liner Count": ScheduleSearchService.scheduleLinerList.length
              });
              $state.go('app.scheduleSearch');
            }
            util.isCallingApi = false;
            return response.data;
          },function(error){
              util.isCallingApi = false;
              $log.error(error);
          });
        }

        function getScheduleLinerName(linerList) {
          var result = [];
          angular.forEach(linerList, function (item){
              result.push(item.carrier_name);
          });
          return result.toString();
        }

        function getLinersList(){
          var url = api.baseMockUrl + '/carriers';
          return $http.get(url);
        }

        function generatePdf(data){
          var url = api.baseMockUrl + '/generate-schedule-pdf';
          return $http.post(url,data);
        }

        // function to get comma separted sring
        function getCommaSeparatedData(data,key){
          if(data && data.length){
            var searchStr = [];
             data.map(function (item) {
              if(item[key]){
                searchStr.push(item[key]);
              }
            });
            return searchStr.join(',');
          }
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.users', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.users', {
                url    : '/users',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/roles/user/shipperusers.html',
                        controller : 'UsersController as vm'
                    }
                },
                // resolve  : {
                // UserData: function(RoleService, util, $state,analytics){
                //     //   //mixpanel code
                //       analytics.track("Users");
                //       util.isCallingApi = true;
                //         return RoleService.getUser().then(function(response){
                //             util.isCallingApi = false;
                //             return response.data;
                //         },function(error){
                //             util.isCallingApi = false;
                //             $state.go(util.redirectIfError(error));
                //         });
                //     }
                // },
                bodyClass: 'Users-page'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/roles/user');


        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'USERS',
        //     group : true,
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.shipperUsers', {
        //     title    : 'Users',
        //     icon     : 'icon-account-multiple-plus',
        //     state    : 'app.shipperusers',
        //     translate: 'SHIPPERUSER.SHIPPERUSER_NAV',
        //     weight   : 1
        // });
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($state,$sanitize,$mdDialog, $mdToast, $mdSidenav,RoleService, $log, $filter, util,localStorageService,api, analytics, $rootScope,DTOptionsBuilder,DTColumnBuilder,$http,$compile,$scope,$timeout)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.deleteValue='';
        vm.util.screenTitle = "Users";
        vm.shipperDetailsTemp = [];
        vm.filterLoader=true;
        vm.create_shipper = create_shipper;
        vm.viewShipper = viewShipper;
        vm.activate_user = activate_user;
        vm.cancelDialog = cancelDialog;
        vm.pass_Error = false;
        vm.submitShipperUser = submitShipperUser;
        vm.updateShipperUser = updateShipperUser;
        vm.createShipperUser = createShipperUser;
        vm.deleteShipperUser = deleteShipperUser;
        vm.updateColumn=updateColumn;
        vm.createData = {};
        vm.userOfList = [];
        vm.fnChangeCreatedOf = fnChangeCreatedOf;
        vm.syncCustomerActiveStatus = syncCustomerActiveStatus;
        vm.onUserStatusChange = onUserStatusChange;
        vm.toggleSidenav=toggleSidenav;
        vm.getForwarderList = getForwarderList;
        vm.getShipperList = getShipperList;
        vm.getUserType = getUserType;
        vm.forwarderList = [];
        vm.shipperList = [];
        vm.getCompanyList = [];
        vm.userTypeList = [];
        vm.showTable= true;
        vm.showLoader= false;
        vm.user_type = [];
        vm.showPassword = false;
        vm.showCurrentPassword = false;
        vm.togglePassword = togglePassword;
        vm.selectedType = [];
        vm.showPassErr = showPassErr;
        vm.validatePassword = validatePassword;
        vm.resizeScreenSize=resizeScreenSize;
        vm.clearFilter=clearFilter;
        vm.calculateMaxHeight=calculateMaxHeight;
        vm.callBackUserSearch=callBackUserSearch;
        vm.fnSortBy=fnSortBy;
        vm.selectedIndex=0;
        vm.tms_enabled=false;
        vm.tmsSuggest = { open: null, filtered: [] };
        vm.openTmsSuggestions = openTmsSuggestions;
        vm.closeTmsSuggestions = closeTmsSuggestions;
        vm.selectTmsSuggestion = selectTmsSuggestion;
        vm.onTmsFieldInput = onTmsFieldInput;
        vm.filtertoggle=filtertoggle;
        vm.callBackRolesSearch=callBackRolesSearch;
        vm.fnTrackEvent = fnTrackEvent;
        vm.exportShipper=exportShipper;
        vm.filterList = ["Forwarder","Shipper"];
        vm.user_base_currency = '';
        vm.importUserStatusData = [];
        // vm.requestUser={
        //     query_source:'',
        //     query_value:''
        // }
        vm.disableAutoInquiryInput = $rootScope.domainData.domain_info.DISABLE_AUTO_INQUIRY_INPUT;
        vm.callBackFileImport = callBackFileImport;
        vm.totalRecordsImported = null;

        var fromDate = new Date(new Date().setDate(new Date().getDate() - 30));
        vm.userData = {
            'deviceName' : '',
            'userSelected' : [],
            'customerSelected' : [],
            'isResetFilter' : false,
            'defaultvalue':'',
            'rolesSelected':[]

          };
        vm.dtOptions = {
            dom       : '<"top"lf>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            lengthMenu  : [5, 10, 20, 30, 50, 100],
            pageLength  : 5
        };
        vm.filterobj={
              "user_type":null,
              "user_details": null,
              "customer_details": null,
              "roles": null,
              "status": null,
              "date_range":{
                "from": fromDate,
                "to": new Date()
            }
          };
          vm.filterListObject = {
            "date_range":null,
            "user_details": null,
            "customer_details": null,
            "roles": null,
            "status": null,
            "sort_by":'created_at',
            "sort_by_type":'DESC',
          };
          vm.sortType={
            'name':'DESC',
            'created_at':'DESC'
          }
          vm.defaultfilterList=angular.copy(vm.filterListObject);
         
        vm.userFilterConditions = {
            'listLoader':false,
            'selectedOptions': vm.userData.userSelected,
            'placeholder': 'Search Users',
            'isGroupOptions' : false,
            'groupList' :  {groupTitle:'Internal Users',keyTitle:'first_name',subKeyTitle:'email'},
            'selectedCount' : 0
          };
          vm.rolesFilterConditions = {
            'listLoader':false,
            'selectedOptions': vm.userData.rolesSelected,
            'placeholder': 'Search Roles',
            'isGroupOptions' : false,
            'groupList' :  {groupTitle:'Roles',keyTitle:'name',subKeyTitle:''},
            'selectedCount' : 0
          };
          vm.cutomerFilterConditions = {
            'listLoader':false,
            'selectedOptions': vm.userData.customerSelected,
            'placeholder': 'Search Users',
            'isGroupOptions' : true,
            'groupList' :null,
            'selectedCount' : 0
          };
        vm.getRolesList = getRolesList;
        vm.getTagsList = getTagsList;
        // vm.getDesignationList = getDesignationList;
        // vm.getDepartmentList = getDepartmentList;
        // vm.getLocationList = getLocationList;
        vm.changeUser = changeUser;
        vm.shipper_user = false;
        vm.forwarder_user = true;
        vm.displayModulePermission = displayModulePermission;
        vm.userCategory = vm.displayModulePermission();
        vm.formatResponse = formatResponse;
        vm.initUsersTable = initUsersTable;
        vm.formUserApiUrl = formUserApiUrl;
        vm.getDtColumnsData = getDtColumnsData;
        vm.fnDeleteData = fnDeleteData;
        vm.importShipper = importShipper;
        vm.getDomainData = getDomainData;
        vm.getImportUserStatus = getImportUserStatus;
        vm.fnRemoveFileStatus = fnRemoveFileStatus;
        vm.deleteType='';
        vm.collapseIt=collapseIt;
        vm.getFilterList = getFilterList;
        vm.callBackCustomersSearch=callBackCustomersSearch;
        vm.setDatePicker=setDatePicker;
        vm.measurementsytem='Metric';
        vm.units = vm.util.matricNumberObj.unit_measurements;
        vm.number_formates = vm.util.matricNumberObj.number_formats;
        vm.fnTrackEvent = fnTrackEvent;


        function resizeScreenSize() {
            vm.userData.deviceName = util.resizeScreen(vm.userData.deviceName);
        }
        window.onresize = vm.resizeScreenSize;
          
        var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
            calculateMaxHeight();
        });
        $scope.$on('$destroy', bannerListener);
    
        function calculateMaxHeight(){
            vm.maxFilterHeight = vm.util.getModuleMaxHeight(vm.maxFilterHeight,'filter',0);
        }

          function init() {

            util.isModulePaid('users');
            vm.getDomainData();
            // analytics.track("Users"); //mixpanel code
            localStorageService.remove('DataTables_user_tables_/users');
            
            vm.initUsersTable();  //initialize user table

            if(!util.isShipper){
                if(!util.isAdmin){
                vm.getForwarderList(); //get forwarder list
                }
                vm.getShipperList(); // get Shippers list
            }
           vm.getUserType();
           vm.resizeScreenSize();
           vm.collapseIt('quotesCustomerDetails');
           vm.getFilterList();
          if(vm.util.navPermission.IMPORT_USERS[0]){
            vm.getImportUserStatus();    //get import users status
          }
        }

        init();

        $rootScope.$on('app.users', function(event, args) {
            init();
        });

        //Function to get Roles list
        function getRolesList(id,userType){
                if(vm.createData.user_data){
                    vm.createData.user_data.role_id = '';
                    vm.rolesList = [];

                    if(userType.toLowerCase() === 'forwarder'){
                        vm.createData.user_data.department = '';
                        vm.createData.user_data.tags = '';
                        vm.createData.user_data.designation = '';
                        vm.createData.user_data.locations = '';
                        vm.tagsList = [];
                        // vm.departmentList = [];
                        // vm.designationList = [];
                        // vm.locationsList = [];
                    }
                }

                RoleService.getRolesList(id,userType).then(function(response){
                    try {
                        vm.rolesList = response.data.data;
                    } catch (e) {
                        vm.rolesList = [];
                        $log.error(e);
                    }
                },function(err){
                    vm.rolesList = [];
                    $log.log(err);
                });

                if(userType.toLowerCase() === 'forwarder'){
                    vm.getTagsList(id); // get Tags list
                   // vm.getDesignationList(id); // get Designation list
                   // vm.getDepartmentList(id); // get Department list
                    //vm.getLocationList(id); // get Locations list
                }
        }
        function collapseIt(id,e){
            angular.element('#'+id).slideToggle();
          }
          function toggleSidenav(sidenavId) {
            util.callMixpanel("User-Mobile-FilterIcon-Click")
            $mdSidenav(sidenavId).toggle();
          }
  
        //Function to get Tags list
        function getTagsList(id){
            RoleService.getTagsList(id).then(function (response) {
                try {
                    vm.tagsList = response.data.data;
                } catch (e) {
                    vm.tagsList = [];
                    $log.error(e);
                }
            }, function (err) {
                vm.tagsList = [];
                $log.log(err);
            });
        }

        //Function to get Department list
        // function getDepartmentList(id){
        //     RoleService.getDepartmentsList(id).then(function (response) {
        //         try {
        //             vm.departmentList = response.data.data;
        //         } catch (e) {
        //             vm.departmentList = [];
        //             $log.error(e);
        //         }
        //     }, function (err) {
        //         vm.departmentList = [];
        //         $log.log(err);
        //     });
        // }

        //Function to get Designation list
        // function getDesignationList(id){
        //     RoleService.getDesignationsList(id).then(function (response) {
        //         try {
        //             vm.designationList = response.data.data;
        //         } catch (e) {
        //             vm.designationList = [];
        //             $log.error(e);
        //         }
        //     }, function (err) {
        //         vm.designationList = [];
        //         $log.log(err);
        //     });
        // }

        //Function to get Location list
        // function getLocationList(id){
        //     RoleService.getLocationsList(id).then(function (response) {
        //         try {
        //             vm.locationsList = response.data.data;
        //         } catch (e) {
        //             vm.locationsList = [];
        //             $log.error(e);
        //         }
        //     }, function (err) {
        //         vm.locationsList = [];
        //         $log.log(err);
        //     });
        // }

        // Function to get role list w.r.t company name while changing 'create user of' value
        function fnChangeCreatedOf(userType , changeEvent){
            if(changeEvent){
            util.callMixpanel("User-UserType-Change",{"Value":userType , "Source":vm.createData.form_heading });
            }
            if(userType == "Forwarder"){
                vm.getCompanyList = angular.copy(vm.forwarderList);
                vm.user_type = vm.userTypeList["FORWARDER"];
                if(vm.createData.user_data){ vm.getRolesList(vm.createData.user_data.user_company_id,'FORWARDER'); }

            }
            else if(userType == "Shipper"){
                vm.getCompanyList = angular.copy(vm.shipperList);
                vm.user_type = vm.userTypeList["SHIPPER"];
                if(vm.createData.user_data){ vm.getRolesList(vm.createData.user_data.user_company_id,'SHIPPER'); }
            }
            else if(userType == "Own"){
                var ownUser = localStorageService.get('authToken').value.user_category;
                vm.user_type = vm.userTypeList[ownUser];
                vm.getRolesList(util.userProfile.user.user_company_id,ownUser);
            }
            if(vm.createData.user_data && !vm.createData.updateView){  //condition to show roles designation input fields based on user category
                vm.createData.user_data.user_category = (userType === 'Own' && util.isAdmin) ? 'Forwarder' :  userType;
                // Customer (Shipper) users default to deactivated; others default to active
                vm.createData.user_data.active_status = userType === 'Shipper' ? 0 : 1;
            }
        }

        // When creating a Customer, auto-activate if both role and password are filled
        function syncCustomerActiveStatus(){
            if(!vm.createData || !vm.createData.user_data || vm.createData.updateView || vm.loginType !== 'Shipper'){
                return;
            }
            if(vm.createData.user_data.role_id && vm.createData.user_data.password){
                vm.createData.user_data.active_status = 1;
            }
        }

        // Clear role/password required errors when Customer is switched back to Inactive
        function onUserStatusChange(){
            fnTrackEvent('User-UserStatus-Change', vm.createData.form_heading);
            if(!vm.createData || !vm.createData.user_data || vm.createData.updateView || vm.loginType !== 'Shipper'){
                return;
            }
            if(!vm.createData.user_data.active_status){
                vm.validationObj.roleValidation = false;
                vm.validationObj.passwordValidation = false;
                vm.validationObj.confirmPasswordValidation = false;
            }
        }

        // Resolve GLOBAL SHIPPER USER role id from the loaded roles list
        function getDefaultShipperUserRoleId(){
            var defaultRole = null;
            angular.forEach(vm.rolesList || [], function(role){
                if(!defaultRole &&
                    role.name === 'SHIPPER USER' &&
                    role.type === 'GLOBAL' &&
                    role.created_for === 'SHIPPER' &&
                    (role.is_super_role == 0 || role.is_super_role === false)){
                    defaultRole = role;
                }
            });
            return defaultRole ? defaultRole.id : '';
        }

        // Activate or dectivate shipper user
        function activate_user(active_status){
            vm.createData.user_data.active_status = active_status == 1 ? 0 : 1;
        };

        var tmsFieldConfig = {
            branch: { model: 'branch_id', domainKey: 'tms_branch', trackEvent: 'User-BranchId-Change' },
            department: { model: 'department', domainKey: 'tms_department', trackEvent: 'User-Department-Change' },
            company: { model: 'tms_company', domainKey: 'tms_company', trackEvent: 'User-TMSCompany-Change' }
        };
        var tmsSuggestClosePromise = null;

        function cancelTmsSuggestClose() {
            if (tmsSuggestClosePromise) {
                $timeout.cancel(tmsSuggestClosePromise);
                tmsSuggestClosePromise = null;
            }
        }

        function refreshTmsFiltered(fieldKey) {
            var config = tmsFieldConfig[fieldKey];
            if (!config || !vm.createData || !vm.createData.user_data) {
                vm.tmsSuggest.filtered = [];
                return;
            }
            vm.tmsSuggest.filtered = util.filterTmsIntegrationOptions(
                vm.createData.user_data[config.model],
                config.domainKey
            );
        }

        function openTmsSuggestions(fieldKey) {
            cancelTmsSuggestClose();
            vm.tmsSuggest.open = fieldKey;
            refreshTmsFiltered(fieldKey);
        }

        function closeTmsSuggestions(fieldKey) {
            cancelTmsSuggestClose();
            tmsSuggestClosePromise = $timeout(function () {
                tmsSuggestClosePromise = null;
                var active = document.activeElement;
                var activeName = active && active.getAttribute ? active.getAttribute('name') : '';
                if (activeName === 'branch_id' || activeName === 'department' || activeName === 'tms_company') {
                    return;
                }
                if (!fieldKey || vm.tmsSuggest.open === fieldKey) {
                    vm.tmsSuggest.open = null;
                    vm.tmsSuggest.filtered = [];
                }
            }, 200);
        }

        function onTmsFieldInput(fieldKey) {
            var config = tmsFieldConfig[fieldKey];
            if (!config || !vm.createData || !vm.createData.user_data) {
                return;
            }
            cancelTmsSuggestClose();
            vm.tmsSuggest.open = fieldKey;
            refreshTmsFiltered(fieldKey);
            vm.fnTrackEvent(config.trackEvent, vm.createData.form_heading);
        }

        function selectTmsSuggestion(fieldKey, option) {
            var config = tmsFieldConfig[fieldKey];
            if (!config || !vm.createData || !vm.createData.user_data) {
                return;
            }
            cancelTmsSuggestClose();
            vm.createData.user_data[config.model] = option;
            vm.tmsSuggest.open = null;
            vm.tmsSuggest.filtered = [];
            vm.fnTrackEvent(config.trackEvent, vm.createData.form_heading);
        }

        function getDomainData(){
            if(!Object.keys($rootScope.domainData.domain_info).length){
              util.getDomainData().then(function(){
                vm.disableAutoInquiryInput = $rootScope.domainData.domain_info.DISABLE_AUTO_INQUIRY_INPUT;
                vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED
              },function(error){
                  $log.log(error.data);
              });
            }else{
                vm.disableAutoInquiryInput = $rootScope.domainData.domain_info.DISABLE_AUTO_INQUIRY_INPUT;
                vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED
            }
          }
       //For Creating  shipper user
        function create_shipper(ev){
            vm.selectedIndex=0;
            util.callMixpanel("User-CreateUser-Click")
            vm.validationObj={
                "loginTypeValidation" :false,
                "companyNameValidation":false,
                "firstNameValidation" :false,
                "lastNameValidation":false,
                "roleValidation" :false,
                 "emailValidation" :false,
                 "passwordValidation":false,
                 "confirmPasswordValidation":false,
                 "branchValidation":false,
                 "departmentValidation":false,
                 "tmsCompanyValidation":false,
                 "tmsReferenceIDValidation":false,
                }
            vm.userBtn = false;
            if(util.isFreightbro){  vm.userOfList = ["Forwarder","Shipper"];  }
            else if(util.isAdmin){
                vm.userOfList = ["Own","Shipper"];
                vm.getRolesList(util.userProfile.user.user_company_id,'FORWARDER');
            }
            else if(util.isShipper){
                 vm.userOfList = ["Own"];
                 vm.getRolesList(util.userProfile.user.user_company_id,'SHIPPER');
             }

            vm.loginType = vm.userOfList[0];
            vm.fnChangeCreatedOf(vm.loginType);
            vm.pass_Error = false;
            vm.createData = {
                "user_data" : {
                    "company_name" : "",
                    "user_type" : "",
                    "user_first_name" : "",
                    "user_last_name" : "",
                    "user_mobile" : "",
                    "active_status" : vm.loginType === 'Shipper' ? 0 : 1,
                    'password' : "",
                    "email" : "",
                    "is_sales_cordinator" : 0,
                    "is_pricing_user" : 0,
                    "auto_inquiry_fcl" : 0,
                    "auto_inquiry_lcl" : 0,
                    "auto_inquiry_air" : 0,
                    "user_company_id" : null,
                    "metric_system":$rootScope.metric_system,
                    "number_formates":$rootScope.number_format,
                    "precision_decimals":$rootScope.precision_decimals,
                    "user_category" : vm.loginType === 'Own' && util.isAdmin ?  'Forwarder' : vm.loginType,
                    "user_base_currency" : $rootScope.domainData.domain_info.BASE_CURRENCY,
                    "department":"",
                    "branch_id":"",
                    "reference_id":"",
                    "tms_company":"",
                    "tms_owner":"",

                    },
                    "viewShipper" : false,
                    "form_heading" : "Create",
                    "button_type" : "Submit",
                    "updateView" : false,
                    "create_user" : true
            };

            $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/userForm/user_form.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        };

        // View shipper user
        function viewShipper(shipperdata,from_heading, update_index, ev){
            
            vm.selectedIndex=0;
            vm.validationObj={
            "loginTypeValidation" :false,
            "companyNameValidation":false,
            "firstNameValidation" :false,
            "lastNameValidation":false,
            "roleValidation" :false,
             "emailValidation" :false,
             "passwordValidation":false,
             "confirmPasswordValidation":false,
             "branchValidation":false,
             "departmentValidation":false,
             "tmsCompanyValidation":false,
             "tmsReferenceIDValidation":false,
            }
            vm.userBtn = false;
            vm.pass_Error = false;
            vm.selectedIndex=0;
            var selectedUSer = vm.shipperDetailsTemp.find(function (i) {
                return i.id == shipperdata;
             });
            if(util.isFreightbro){  vm.userOfList = ["Forwarder","Shipper"]; }
            else if(util.isAdmin){ vm.userOfList = ["Own","Shipper"]; }
            else if(util.isShipper){ vm.userOfList = ["Own"]; }

            if(util.isFreightbro){
                 vm.getRolesList(selectedUSer.user_company_id,selectedUSer.company.type);
            }
            vm.loginType = vm.userOfList[0];
            // vm.fnChangeCreatedOf(vm.loginType);
            vm.createData = {
                "user_data" : {
                    'id' : selectedUSer.id,
                    'user_first_name' : selectedUSer.user_first_name,
                    'user_last_name' : selectedUSer.user_last_name,
                    "user_type" : selectedUSer.user_type,
                    'active_status' : selectedUSer.active_status,
                    'user_mobile' : selectedUSer.user_mobile,
                    'user_mobile_code' : selectedUSer.user_mobile_code,
                    'user_mobile_country' : selectedUSer.user_mobile_country,
                    'company_name' : selectedUSer.company.company_name,
                    'email' : selectedUSer.email,
                    "metric_system":selectedUSer.metric_system,
                    "number_formates":selectedUSer.number_format,
                    "precision_decimals":selectedUSer.precision_decimals,
                    'user_company_id':selectedUSer.user_company_id,
                    "user_category" : selectedUSer.company.type,
                    "is_sales_cordinator" : selectedUSer.is_sales_cordinator,
                    "is_pricing_user" : selectedUSer.is_pricing_user,
                    "auto_inquiry_fcl" : selectedUSer.auto_inquiry_fcl,
                    "auto_inquiry_lcl" : selectedUSer.auto_inquiry_lcl,
                    "auto_inquiry_air" : selectedUSer.auto_inquiry_air,
                    "user_base_currency": selectedUSer.user_base_currency ? selectedUSer.user_base_currency: $rootScope.domainData.domain_info.BASE_CURRENCY,
                    "department":selectedUSer.department,
                    "branch_id":selectedUSer.branch_id,
                    "reference_id":selectedUSer.reference_id,
                    "tms_company":selectedUSer.tms_company,
                    "tms_owner":selectedUSer.tms_owner

                    },
                    "updateView" : true,
                    "viewShipper" : from_heading == 'Edit' ? false : true,
                    "form_heading" : from_heading,
                    "button_type" : "Update",
                    "shipper_index"  : update_index,
            };

            if(util.isAdmin || util.isShipper){
                vm.getRolesList(util.userProfile.user.user_company_id,selectedUSer.company.type);
            }

            vm.createData.user_data.role_id = selectedUSer.role_id;
            if(vm.createData.user_data.user_category.toLowerCase() === 'forwarder'){
                // vm.getRolesList(vm.createData.user_data.user_company_id);
                vm.createData.user_data.department = selectedUSer.department;
                vm.createData.user_data.tags = selectedUSer.tags;
                vm.createData.user_data.designation = selectedUSer.designation;
                vm.createData.user_data.locations = selectedUSer.locations;
            }
          // mixpanel code
            if(from_heading == 'Edit'){
                util.callMixpanel("User-EditUser-Click" ,  {'Name': selectedUSer.user_first_name + ' '+ selectedUSer.user_last_name})
            }
            else{
                util.callMixpanel("User-ViewUser-Click", {'Name': selectedUSer.user_first_name + ' '+ selectedUSer.user_last_name})
            }

            $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/userForm/user_form.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        };

        // Submit shipper user
        function submitShipperUser(shipData, button,form){

            var userFormValidation = {
                'User Type' : '',
                'Company Name': '',
                'First Name' : '',
                'Last Name': '',
                'User Role': '',
                'EmailId': '',
                'Password': '',
                'Confirm Password': ''
            }

            var mixpanelObj = {
                'User Type' : shipData.loginType,
                'First Name' : shipData.user_first_name ,
                'Last Name' : shipData.user_last_name ,
                'User Currency' : shipData.user_base_currency ,
                'Phone Number' : shipData.user_mobile ,
                'User Role' : shipData.role_id ,
                'EmailId' : shipData.email ,
                'User Status' : shipData.active_status == "" ? 0 : shipData.active_status,
                'User Team' : {
                    'IsSalesCoOrdinator' : shipData.is_sales_cordinator ,
                    'IsPricingUser' : shipData.is_pricing_user
                },
                'AutoInquiry' : {
                    'AutoInquiryFCL' : shipData.auto_inquiry_fcl,
                    'AutoInquiryLCL' : shipData.auto_inquiry_lcl,
                    'AutoInquiryAIR' : shipData.auto_inquiry_air,
                },
                'Tags' : shipData.tags,
                'Source' : vm.createData.form_heading,
                'User Form Validations' : userFormValidation
            }
            var tmsValidation = vm.createData.user_data.branch_id || vm.createData.user_data.department || vm.createData.user_data.tms_company || vm.createData.user_data.reference_id;
            
       
            if(!vm.createData.updateView && !vm.util.isShipper && !vm.loginType){
                vm.validationObj.loginTypeValidation=true;
                userFormValidation["User Type"]='Required';
            }
            if(vm.loginType != 'Own' && !vm.createData.updateView && !vm.createData.user_data.user_company_id){
                vm.validationObj.companyNameValidation=true;
                userFormValidation["Company Name"]='Required';
            }
            if(!vm.createData.user_data.user_first_name){
                vm.validationObj.firstNameValidation=true;
                userFormValidation["First Name"]='Required';
            }
            if(!vm.createData.user_data.user_last_name){
                vm.validationObj.lastNameValidation=true;
                userFormValidation["Last Name"]='Required';
            }
            // Inactive Customer users can be created without role / password,
            // but if either role or password is filled, the other becomes mandatory
            var isOptionalAuthFields = !vm.createData.updateView && vm.loginType === 'Shipper' && !vm.createData.user_data.active_status;
            var hasRole = !!vm.createData.user_data.role_id;
            var hasPassword = !!vm.createData.user_data.password;
            var hasConfirmPassword = !!vm.createData.user_data.user_confirm_password;
            if(!hasRole && (!isOptionalAuthFields || hasPassword || hasConfirmPassword)){
                vm.validationObj.roleValidation=true;
                userFormValidation["User Role"]='Required';
            }
            if(!vm.createData.user_data.email){
                vm.validationObj.emailValidation=true;
                userFormValidation["EmailId"]='Required';
            }
           if(vm.tms_enabled && tmsValidation && !vm.createData.user_data.branch_id && vm.createData.user_data.user_category.toLowerCase() == 'forwarder'){
            vm.validationObj.branchValidation=true;
            userFormValidation["Branch"]='Required';
          }
          if(vm.tms_enabled && tmsValidation && !vm.createData.user_data.department && vm.createData.user_data.user_category.toLowerCase() == 'forwarder'){
            vm.validationObj.departmentValidation=true;
            userFormValidation["Department"]='Required';
          }
          if(vm.tms_enabled && tmsValidation && !vm.createData.user_data.tms_company && vm.createData.user_data.user_category.toLowerCase() == 'forwarder'){
            vm.validationObj.tmsCompanyValidation=true;
            userFormValidation["tmsCompany"]='Required';
          }
          if(vm.tms_enabled && tmsValidation && !vm.createData.user_data.reference_id ){
            vm.validationObj.tmsReferenceIDValidation=true;
            userFormValidation["tmsReferenceID"]='Required';
          }
            vm.validationObj.passwordValidation = false;
            vm.validationObj.confirmPasswordValidation = false;
            if(!vm.createData.viewShipper && !vm.createData.updateView && !hasPassword && !form.password.$invalid && (!isOptionalAuthFields || hasRole || hasConfirmPassword)){
                vm.validationObj.passwordValidation=true;
                userFormValidation["Password"]='Required';
            }
            if(!vm.createData.viewShipper && !vm.createData.updateView && !hasConfirmPassword && !form.user_confirm_password.$invalid && (!isOptionalAuthFields || hasRole || hasPassword)){
                vm.validationObj.confirmPasswordValidation=true;
                userFormValidation["Confirm Password"]='Required';
            }
            
            if( !form.password.$invalid && vm.createData.updateView && (vm.createData.user_data.password &&!vm.createData.user_data.user_confirm_password)){
                vm.validationObj.confirmPasswordValidation=true;
                userFormValidation["Confirm Password"]='Required';
             }
             if( !form.password.$invalid && vm.createData.updateView && (!vm.createData.user_data.password &&vm.createData.user_data.user_confirm_password)){
                vm.validationObj.passwordValidation=true;
                userFormValidation["Password"]='Required';
             }

            if(vm.validationObj.loginTypeValidation || vm.validationObj.companyNameValidation || vm.validationObj.firstNameValidation || vm.validationObj.lastNameValidation ||vm.validationObj.roleValidation || vm.validationObj.emailValidation || vm.validationObj.passwordValidation || vm.validationObj.confirmPasswordValidation ||vm.pwvalid){
                util.callMixpanel("User-Submit-Click",mixpanelObj);
                vm.selectedIndex=0;
                return;
            }

            if( form.password.$invalid && vm.createData.updateView){
                userFormValidation["Password"]='Invalid';
                util.callMixpanel("User-Submit-Click",mixpanelObj);
                vm.selectedIndex=0;
                return ;
             }
         
            if (shipData.password && shipData.password != shipData.user_confirm_password){
                vm.pass_Error = true;
                userFormValidation["Confirm Password"]='Invalid';
                 util.callMixpanel("User-Submit-Click",mixpanelObj);
                 vm.selectedIndex=0;
                return false;
            }
            if( vm.tms_enabled && (vm.validationObj.branchValidation || vm.validationObj.departmentValidation || vm.validationObj.tmsCompanyValidation || vm.validationObj.tmsReferenceIDValidation)){
                vm.selectedIndex=1;
                util.callMixpanel("User-Submit-Click",mixpanelObj);
                return;
            }
            else{
                  util.callMixpanel("User-Submit-Click",mixpanelObj);
                  button == 'Submit' ? vm.createShipperUser(shipData) : vm.updateShipperUser(shipData) ;
            }
            vm.userBtn = true;

         
           
        };

        //Create users
        function createShipperUser(shipData){
            
            if(vm.loginType == 'Own'){
                shipData.user_company_id = localStorageService.get('authToken').value.user_company_id;
            }

            var roleId = shipData.role_id;
            // Inactive Customer create without role: default to GLOBAL SHIPPER USER
            if(!roleId && vm.loginType === 'Shipper' && !shipData.active_status){
                roleId = getDefaultShipperUserRoleId();
            }

            var data = {
                "data": {
                    'user_type' : "ADMIN",
                    'login_type' : vm.loginType, // Customer = 'Shipper', Internal = 'Own', etc.
                    'user_first_name' : shipData.user_first_name,
                    'user_last_name' : shipData.user_last_name,
                    'email' : shipData.email,
                    'active_status' : shipData.active_status == "" ? 0 : shipData.active_status,
                    'user_mobile' : shipData.user_mobile,
                    'user_mobile_code' : shipData.user_mobile_code,
                    'user_mobile_country' : shipData.user_mobile_country,
                    'password' : shipData.password,
                    'user_company_id':shipData.user_company_id,
                    "is_sales_cordinator" : shipData.is_sales_cordinator,
                    "is_pricing_user" : shipData.is_pricing_user,
                    'user_alternate_number' : null,
                    'user_dob':null,
                    'user_address' : null,
                    "metric_system":shipData.metric_system,
                    "number_format":shipData.number_formates,
                    "precision_decimals":shipData.precision_decimals,
                    'auto_inquiry_fcl' : shipData.auto_inquiry_fcl,
                    'auto_inquiry_lcl' : shipData.auto_inquiry_lcl,
                    'auto_inquiry_air' : shipData.auto_inquiry_air,
                    'role_id' : roleId,
                    'user_base_currency': shipData.user_base_currency,
                    "department":shipData.department,
                    "branch_id":shipData.branch_id,
                    "reference_id":shipData.reference_id,
                    "tms_company":shipData.tms_company,
                    "tms_owner":shipData.tms_owner,
                }
            };

            //send roles,designation,department and location values if user category is forwarder
            if(shipData.user_category.toLowerCase() === 'forwarder'){
                // data.data.role_id = shipData.role_id;
                data.data.tags = shipData.tags;
                // data.data.department = shipData.department;
                // data.data.designation = shipData.designation;
                // data.data.locations = shipData.locations;
            }
            util.isCallingApi = true;
            RoleService.createShipperUser(data).then(function(response){
                vm.dtInstanceCallback.rerender(); //Refersh user table with latest data

                util.showToast('Created Successfully!!','top right', 3000);
                vm.userBtn = false;
                 vm.cancelDialog();
                util.isCallingApi = false;

            },function(error){
                util.isCallingApi = false;
                $log.log(error);
                util.showToast(util.displayValidationError(error));
                vm.userBtn = false;
            });
        };

        //Update users
        function updateShipperUser(shipData){

            var data =
            {
                "data" : {
                    'id': shipData.id,
                    'user_type' : "ADMIN",
                    'user_first_name' : shipData.user_first_name,
                    'user_last_name' : shipData.user_last_name,
                    'active_status' : shipData.active_status,
                    'email' : shipData.email,
                    'user_mobile' : shipData.user_mobile,
                    'user_mobile_code' : shipData.user_mobile_country,
                    'user_mobile_country' : shipData.user_mobile_country,
                    'user_company_id': shipData.user_company_id,
                    'user_alternate_number' : null,
                    'user_dob':null,
                    'user_address' : null,
                    "metric_system":shipData.metric_system,
                    "number_format":shipData.number_formates,
                    "precision_decimals":shipData.precision_decimals,
                    "is_sales_cordinator" : shipData.is_sales_cordinator,
                    "is_pricing_user" : shipData.is_pricing_user,
                    'role_id' : shipData.role_id,
                    'auto_inquiry_fcl' : shipData.auto_inquiry_fcl,
                    'auto_inquiry_lcl' : shipData.auto_inquiry_lcl,
                    'auto_inquiry_air' : shipData.auto_inquiry_air,
                    'password' : shipData.password == undefined ? "" : shipData.password,
                    'user_base_currency': shipData.user_base_currency,
                    "department":shipData.department,
                    "branch_id":shipData.branch_id,
                    "reference_id":shipData.reference_id,
                    "tms_company":shipData.tms_company,
                    "tms_owner":shipData.tms_owner,
                }
            };

            //send roles,designation,department and location values if user category is forwarder
            if(shipData.user_category.toLowerCase() === 'forwarder'){
                // data.data.role_id = shipData.role_id;
                data.data.tags = shipData.tags;
                // data.data.department = shipData.department;
                // data.data.designation = shipData.designation;
                // data.data.locations = shipData.locations;
            }

            util.isCallingApi = true;
            RoleService.updateShipperUser(data,shipData.id)
            .then(function(response){
                vm.dtInstanceCallback.rerender(); //Refersh user table with latest data

                util.showToast('Updated Successfully!!','top right', 3000);
                vm.userBtn = false;
                vm.cancelDialog();
                util.isCallingApi = false;

            },function(error){
                util.isCallingApi = false;
                $log.log(error);
                util.showToast(util.displayValidationError(error));
                vm.userBtn = false;
            });
        };

        //delete Users
        function deleteShipperUser(id, delete_index, ev){
            vm.deleteType="User";
            vm.deleteValue=vm.shipperDetailsTemp[delete_index].user_first_name + ' ' + vm.shipperDetailsTemp[delete_index].user_last_name;
            vm.deleteId = id;
            vm.deleteIndex = delete_index;
            vm.deleteBtn = false;
            util.callMixpanel("User-DeleteUser-Click", {'Name':vm.deleteValue})
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm; }
            });
           
        }

        function fnDeleteData(id){
            vm.deleteBtn = true;
            RoleService.deleteShipperUser(vm.deleteId).then(function(response){
                util.callMixpanel("User-DeleteUser-Proceed-Click" ,  {'Name':vm.deleteValue});
                vm.dtInstanceCallback.rerender(); //Refersh user table with latest data

                util.showToast('User deleted successfully.');
                vm.deleteBtn = false;
                $mdDialog.hide();

             },function(error){
                vm.deleteBtn = false;
                $log.log(error);
                util.showToast(util.displayValidationError(error));
             });
        }

        //close modal
        function cancelDialog(event , deleteEvent ){
            if(event){
                util.callMixpanel("User-Close-Click", {'Event':event , 'Source':vm.createData.form_heading});
            }
           if(deleteEvent){
                util.callMixpanel("User-DeleteUser-cancel-Click");
            }
            $mdDialog.hide();
        };

        //Get list for fowarders
        function getForwarderList(){
            RoleService.getForwarder().then(function(response){
                vm.forwarderList = response.data.data;
            },function(error){
                $log.log(error);
            });
        }

        //Get list of shippers
        function getShipperList(searchText){
          vm.listLoader = true;
          RoleService.getAssignedShipper(searchText).then(function(response){
              vm.shipperList = response.data.data;
              fnChangeCreatedOf('Shipper');
              vm.listLoader = false;
          },function(error){
              vm.listLoader = false;
              $log.log(error);
          });
        }

        //Get list of user names and it's type
        function getUserType(){
            RoleService.getUserType().then(function(response){
                vm.userTypeList =  response;
            },function(error){
                $log.log(error);
            });

        }

        //********************Code for modules permission - Ankita**************************

        vm.viewPermissionModal = viewPermissionModal;
        vm.editMode = [];
        vm.addModule = addModule;
        vm.removeModule = removeModule;
        vm.getModuleCode = getModuleCode;
        vm.moduleChange = moduleChange;
        vm.getEditedData = getEditedData;
        vm.fnSubmitUserPermission = fnSubmitUserPermission;
        vm.getAvailableModuleList = getAvailableModuleList;
        vm.modulePermissions = {};
        vm.available_modules = {};

        //function to show permission by checking user category - ankita
        function displayModulePermission(){
            var category = localStorageService.get('authToken').value.user_category;
            var type = localStorageService.get('authToken').value.user_type;
                if(category == "FREIGHTBRO"){
                    return "FREIGHTBRO";
                }
                if(category == "FORWARDER" && type == 60){
                    return "FORWARDER-ADMIN";
                }
                else{
                    return '';
                }
        }

        //function to get availble list module - ankita
        function getAvailableModuleList(id){
            RoleService.getAvailableList(id).then(function(response){
                vm.available_modules = response.data.available_modules;
                return vm.available_modules;
            },function(error){
                $log.log(error);
            });
        }

        //function to view permission model - ankita
        function viewPermissionModal(data, ev){
            RoleService.getUserById(data).then(function(response){
                vm.editMode = [];
                vm.editId = data;
                vm.modulePermissionsCopy =  angular.copy(response.data.user.user_modules);
                vm.modulePermissions = angular.copy(vm.modulePermissionsCopy);
                vm.getAvailableModuleList(data);
                vm.shipper_user_name = response.data.user.user_first_name+' '+response.data.user.user_last_name;
                $mdDialog.show({
                    templateUrl        : 'app/main/roles/dialogs/permission/user-permissions.html',
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    controllerAs: 'ctrl',
                    controller: function() { this.parent = vm }
                });

            },function(error){
                $log.log(error);
            });
        }

        //function to add module - ankita
        function addModule(index){
            var entry =  {
                "module_name": "",
                "module_code": "",
                "is_assigned": 1,
                "is_custom": true,
                "permissions": {
                  "create": 0,
                  "read": 0,
                  "edit": 0,
                  "delete": 0
                },
                "title": ""
            };
            vm.modulePermissions.push(entry);
            vm.editMode[index] = true;
        }

        //function to remove module - ankita
        function removeModule(data, index){
            if(data.module_name!=""){
                var input = confirm("Are you sure you want to remove this module?");
                if(input) {
                    data.is_assigned = 0;
                }
            }
            else{
                  vm.modulePermissions.splice(index, 1);
            }
        }

        //function to check if module exist after selecting module - ankita
        function moduleChange(permission){
            var keys = [];
            vm.available_modules.find(function(item){
              if(item.module_code === permission.module_code) {
                permission.module_name = item.module_name;
                permission.title = item.title;
              }
            })

            angular.forEach(vm.modulePermissions, function(item) {
                if(item.is_assigned==1){
                    var key = item.module_code;
                    if(keys.indexOf(key) === -1) {
                        keys.push(key);
                    }
                    else{
                        vm.getModuleCode(permission);
                        item.module_code = "";
                        item.module_name = "";
                        item.title = "";
                    }
                }
            });
        }

        //function to get module Code by module name - ankita
        function getModuleCode(permission){
            if(permission.module_code!=""){
                angular.forEach(vm.available_modules, function(item) {
                    if(item.module_code == permission.module_code){
                        util.showToast(item.module_name+' module already exist');
                    }
                });
            }
        }

        //function to submit modified permission - ankita
        function fnSubmitUserPermission(){
            vm.editedModules = getEditedData(vm.modulePermissionsCopy, vm.modulePermissions);
            if(vm.editedModules.length > 0){
                var putData = {
                    "data" : vm.editedModules
                }
                RoleService.updateUserModule(putData,vm.editId).then(function(response){
                    util.showToast('Updated Successfully!!','top right', 3000);
                },function(error){
                    $log.log(error);
                });
            }
            else{
                util.showToast('No changes!!','top right', 3000);
            }
            vm.cancelDialog();
        }

        //function to get only edited data - ankita
        function getEditedData(oldArray, newArray) {
            var changes, i, item, j, len;
            var arrIndex = {};
            if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
              return [];
            }
            changes = [];
            for (i = j = 0, len = newArray.length; j < len; i = ++j) {
              item = newArray[i];
              if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
                var index = arrIndex[item.module_code];  //code to add or replace array
                    if(index === undefined) {
                        index = changes.length;
                        arrIndex[item.module_code] = index;
                    }
                    changes[index] = item;
                }
            }
            return changes;
        };

        function togglePassword(input_name){
            if(input_name === 'password'){
                vm.showPassword = vm.showPassword === false ? true : false;
            }
            if(input_name === 'user_confirm_password'){
                vm.showCurrentPassword = vm.showCurrentPassword === false ? true : false;
            }
        }

        // Re-render user table while clicking shipper/forwarder filter
        function changeUser(user){
           util.callMixpanel("User-Filter-UserType-Change", {
                value: user.type
              })
            if(user.type == 'FORWARDER'){
                vm.rolesFilter=true;
                vm.forwarder_user = true;
                vm.shipper_user = false;
                vm.userFilterConditions.selectedOptions = [];
                vm.rolesFilterConditions.selectedOptions = [];
                vm.dtColumns[0].visible = false;
                if(vm.tms_enabled){
                    vm.dtColumns[1].visible = false;
                    vm.dtColumns[3].visible = true;
                }
               
                vm.updateColumn();

            }else if(user.type == 'SHIPPER'){
                vm.rolesFilter=true;
                vm.forwarder_user = false;
                vm.shipper_user = true;
                vm.cutomerFilterConditions.selectedOptions = [];
                vm.rolesFilterConditions.selectedOptions = [];
                vm.dtColumns[0].visible = true;
                if(vm.tms_enabled){
                vm.dtColumns[1].visible = true;
                vm.dtColumns[3].visible = false;
                }
                vm.updateColumn();
            }
            vm.radioReset=false;
            vm.filterListObject = angular.copy(vm.defaultfilterList);
            vm.filterobj.date_range= {
                "from": fromDate,
                "to": new Date()
            }
            $rootScope.$broadcast('resetFilter', { any: '' });
            vm.userData.isResetFilter = true;
            vm.getFilterList();
            vm.dtInstanceCallback.rerender();
           
        }

       function updateColumn(){
       var tableData = localStorageService.get('DataTables_user_tables_/users');
       if(tableData && tableData.columns && tableData.columns.length){
        tableData.columns = vm.dtColumns;
        localStorageService.set('DataTables_user_tables_/users', tableData);

       }
       }
        //********************Code for user pagination - Ankita **************************

        //  initialize datatable with server side pgination
        function initUsersTable(){
            vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('headerCallback', function(thead) {
                
                 var nameIndex =  vm.userData.defaultvalue === 'FORWARDER' ? 0 : vm.tms_enabled ?  2 : 1;
               
                 var createdIndex =  vm.userData.defaultvalue === 'FORWARDER' ? vm.tms_enabled ? 4 : 3 : vm.tms_enabled ? 5 : 4;
               
                // Add click for 'Customer Name' header
                $(thead).find('th').eq(nameIndex).html('Name'+'<md-icon md-svg-src="assets/icons/custom/sort-icon.svg" class="s16 pl-5 pointer" ng-click="vm.fnSortBy(\'name\')"></md-icon>');
                 
        
                // Add click for 'Last Updated On' header
                $(thead).find('th').eq(createdIndex).html('Created On '+'<md-icon md-svg-src="assets/icons/custom/sort-icon.svg" class="s16 pl-5 pointer" ng-click="vm.fnSortBy(\'created_at\')"></md-icon>');
                 
        
                // Compile the header to bind AngularJS directives
                $compile(thead)($scope);
            })
                .withOption('ajax', function (data, callback, settings) {       
                var url = vm.formUserApiUrl(data, callback, settings,false);  //get url
                    vm.settings = settings;
                $http.get(url).then(function (res) {
                    var res_data = res.data.data;
                    var new_res = formatResponse(res_data); //form response with table structure
                    var table_data = {
                        'data': new_res,
                        'recordsTotal': res.data.count,
                        'recordsFiltered': res.data.count
                    };
                    vm.userLength = res.data.count;
                    vm.totalLength = res.data.totalCount;
                    calculateMaxHeight();
                    callback(table_data);
                    vm.dtOptions.lengthChange= vm.userLength>0 ?true : false;
                    },
                    function (error) {
                        vm.dtOptions.lengthChange= vm.userLength>0 ?true : false;
                    calculateMaxHeight();
                    util.showToast(error.message, 'top right', 3000);
                    });
                })
                .withDataProp('data')
                .withOption('responsive', true)
                .withOption('serverSide', true)
                .withOption('processing', true)
                .withDisplayLength(10)
                .withPaginationType('simple')
                .withOption('aaSorting', [])
                .withOption('lengthChange',false )
                .withOption('stateSave', true)
                //.withOption('language', {search : "", searchPlaceholder: "Search", lengthMenu: "Show entries _MENU_"})
                .withOption('createdRow', function (row, data, dataIndex) {
                  // Recompiling so we can bind Angular directive to the DT
                  $compile(angular.element(row).contents())($scope);
                });

            vm.getDtColumnsData();    //get dtcolumn data

            $scope.$on('$destroy', function() {
                localStorage.removeItem('DataTables_user_tables_/users');
          });
         

        }

        // form user api with parameter count,offset,search,type and forwarder id
        function formUserApiUrl(data, callback, settings,exportFlag){           
           
                var filterUserType = (vm.forwarder_user &&  !vm.util.isShipper) ? 'FORWARDER' :  'SHIPPER' ;

            var apiUrl=exportFlag ? '/api/v2/user/export' : '/api/v2/user';
           
            var url = api.baseUrl + apiUrl + '?limit='+ settings._iDisplayLength + '&offset='+ settings._iDisplayStart  + '' +util.fnGetForwarderIdApi('&');
                url += '&company_type='+filterUserType+'';

                //adding query source and value for url
            angular.forEach(vm.filterListObject,function(value,key){
                if(value){
                    if(value.query_source){
                        angular.forEach(value.query_value,function(value1,key1){
                            url += '&'+value.query_source+'='+value1+'';});
                    }
                    else{
                       angular.forEach((vm.filterListObject[key]),function(value1,key1){
                    if(key1 && value1.query_source){
                        if(value1.query_value.length < 1){
                            url += '&'+value1.query_source+'='+value1.query_value+'';
                        }
                        else{
                            angular.forEach(value1.query_value,function(item,index){
                                url += '&'+value1.query_source+'='+item+'';
                            });
                        }
                    } });
                    }
                } 
            });
            
            url +='&sort_by='+vm.filterListObject.sort_by+'&sort_by_type='+vm.filterListObject.sort_by_type+'';
            if(exportFlag){
                url += '&export=true';
            }
            return url;
            // var type=vm.forwarder_user ? 'FORWARDER' : 'SHIPPER';

            // var url = api.baseUrl + '/api/user?count='+ settings._iDisplayLength + '&offset='+ settings._iDisplayStart + 'user_id' +util.userProfile.user.id;
            // url += '&company_type='+filterUserType+'';

            // if(vm.filterParams){
            //     url += '&'+vm.filterParams.query_source+'='+vm.filterParams.query_value+'';
            // }
            // return url;
        }



        // form dtColumns data for datatables
        function getDtColumnsData(){
            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle('Company').withOption('name', 'company_name').withOption('visible', false).renderWith(function (data) {
           
                    var html = '<span ng-non-bindable>'+ $sanitize(data.company_name) +'</span>'
                     return '<td>' + html + '<md-tooltip  md-direction="top">'+html+'</md-tooltip></td>'
                  }).notSortable().notSortable(),
                  DTColumnBuilder.newColumn(null).withTitle('External Refrence Code').withOption('name', 'reference_id').withOption('visible', false).renderWith(function (data) {
                     var refernceID = data.reference_id ? data.reference_id : 'NA';
                    var html = '<span ng-non-bindable>'+$sanitize(refernceID) +'</span>'
                     return '<td>' + html + '<md-tooltip  md-direction="top">'+html+'</md-tooltip></td>'
                  }).notSortable(),

                  DTColumnBuilder.newColumn(null).withTitle('Name').withOption('name', 'user').renderWith(function (data) {
           
                    var html = '<span ng-non-bindable>'+$sanitize(data.user) +'</span>'
                     return '<td>' + html + '<md-tooltip  md-direction="top">'+html+'</md-tooltip></td>'
                  }).notSortable(),

                DTColumnBuilder.newColumn(null).withTitle('External Refrence Code').withOption('name', 'reference_id').withOption('visible', false).renderWith(function (data) {
                    var refernceID = data.reference_id ? data.reference_id : 'NA';
                    var html = '<span ng-non-bindable>'+$sanitize(refernceID) +'</span>'
                     return '<td>' + html + '<md-tooltip  md-direction="top">'+html+'</md-tooltip></td>'
                  }).notSortable(),
                  
        
                //DTColumnBuilder.newColumn('user_mobile').withTitle('Phone No').withOption('name', 'user_mobile').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Email').withOption('name', 'email').renderWith(function (data) {
                     var html = '<span ng-non-bindable>'+$sanitize(data.email)+'</span>'
                     return '<td>' + html + '<md-tooltip  md-direction="top">'+html+'</md-tooltip></td>'
                    }).notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Role').withOption('name', 'role_name').renderWith(function (data) {
                    var html = '<span ng-non-bindable>'+$sanitize(data.role_name) +'</span>'
                     return '<td>' + html + '<md-tooltip  md-direction="top">'+html+'</md-tooltip></td>'
                  }).notSortable(),
                

                DTColumnBuilder.newColumn(null).withTitle('Created On').withOption('name', 'created_at').renderWith(function (data) {
                    var html = '<span ng-non-bindable>'+$sanitize(data.created_at) +'</span>'
                     return '<td>' + html + '<md-tooltip  md-direction="top">'+html+'</md-tooltip></td>'
                  }).notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Status')
                .renderWith(function (data, type, full, meta) {
                   
                    if(data.active_status){
                        return '<span class="green-fg cursor"> Active </span>';
                    }else{
                        return '<span class="red-fg cursor"> Deactive </span>';
                    }

                }).notSortable()
            ];


            // if(vm.userCategory == 'FORWARDER-ADMIN' || vm.userCategory == 'FREIGHTBRO'){
            //     vm.dtColumns.push(DTColumnBuilder.newColumn('company_type').withTitle('Forwarder/Shipper').withOption('name', 'company_type').notSortable());
            // }
            if(vm.userCategory == 'FREIGHTBRO'){
              vm.dtColumns.push(DTColumnBuilder.newColumn(null).withClass('all').withTitle('Permission')
                .renderWith(function (data, type, full, meta) {
                    return '<a class="md-link-fg cursor" ng-click="vm.viewPermissionModal(\'' + data.id + '\',$event)">View Permission</a>';
                }).notSortable());
            }

            vm.dtColumns.push(DTColumnBuilder.newColumn(null).withClass('all').withTitle('Actions')
                .renderWith(function (data, type, full, meta) {
                return '<span>' +
                '<md-icon ng-if="vm.util.navPermission.users[2]" md-svg-src="assets/icons/custom/edit-icon.svg" class="s12 cursor" ng-click="vm.viewShipper(\'' + data.id + '\',\'Edit\','+meta.row+',$event)"></md-icon>'+
                '<md-icon ng-if="vm.util.navPermission.users[1]" md-font-icon="icon-eye" class="cursor ml-10 mb-10 view_icon" title="View" ng-click="vm.viewShipper(\'' + data.id + '\',\'View\','+meta.row+')" class="green-fg mh-5"></md-icon>'+
                '<md-icon ng-if="vm.util.navPermission.users[3]" md-svg-src="assets/icons/custom/delete-icon.svg" ng-click="vm.deleteShipperUser(\'' + data.id + '\','+meta.row+')" class="red-fg cursor"></md-icon>'+
                '</span>';
            }).notSortable());
            if(vm.tms_enabled){
                vm.dtColumns[3].visible = true;
            }
            vm.dtInstanceCallback = {};
        }

        //form response with table structure
        function formatResponse(res_data){

            vm.shipperDetailsTemp = res_data;

            var new_res = [];
                var row_obj = {
                'user' : '',
                'user_mobile': '',
                'company_name' : '',
                'role_name' : '',
                'email' : '',
                'company_type' : '',
                'created_at' : '',
                'id': '',
                'active_status' : 0,
                'reference_id' : ''
                
                };

                res_data.forEach(function (row) {
                var new_row = angular.copy(row_obj);
                    new_row.id = row.id;
                    new_row.user = row.user_first_name+ ' ' + row.user_last_name;
                    new_row.user_mobile = row.user_mobile ? row.user_mobile : 'NA';
                    new_row.company_name = row.company ? row.company.company_name : 'NA' ;
                    new_row.role_name = row.role ? row.role.name : 'NA' ;
                    new_row.email = row.email ? row.email : 'NA' ;
                    // SHIPPER becomes CUSTOMER, other company type stay same
                    var backendCompanyType = row.company ? row.company.type : 'NA';
                    new_row.company_type = backendCompanyType === 'SHIPPER' ? 'CUSTOMER' : backendCompanyType;
                    new_row.created_at = row.created_at ?  $filter('date')(row.created_at, 'yyyy-MM-dd'): 'NA' ;
                    new_row.reference_id = row.reference_id ? row.reference_id : 'NA';
                    new_row.active_status = row.active_status;
                new_res.push(new_row);
                });

            return new_res;
        }

        function showPassErr(type){
            document.getElementById('message').style.display = type === 'focus' ? 'block' : 'none';
        }
        function exportShipper(ev){
            util.callMixpanel("Shipper-ExportPopup-Open-Click");
            vm.exportShipperParam = {
              'formHeadTitle': 'Export Data',
              'formSubTitle': '',
              'importType':'user',
              'settings':vm.settings,
              'count':vm.userLength,
              'totalLength':vm.totalLength,
              'url':vm.formUserApiUrl("", "", vm.settings,true)
         
            }
            $mdDialog.show({
                template: '<md-dialog id="nwls-multiple-users-export" class="popup-md"><export-multiple-users exportdata="ctrl.parent.exportShipperParam" callback="ctrl.parent.callBackFileImport(data)"></export-multiple-users></md-dialog>',
                targetEvent: ev,
                clickOutsideToClose: false,
                preserveScope: true,
                controller: function () { this.parent = vm },
                controllerAs: 'ctrl',
            });
        };
        function validatePassword(){
            var myInput = document.getElementById('user_pwd');
            var special = document.getElementById('special');
            var number = document.getElementById('number');
            var length = document.getElementById('length');

            // Validate capital letters
            var upperCaseLetters = /[!@#\$%\^&\*]/g;
            if(myInput.value.match(upperCaseLetters)) {
                special.classList.remove('passInvalid');
                special.classList.add('passValid');
            } else {
                special.classList.remove('passValid');
                special.classList.add('passInvalid');
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if(myInput.value.match(numbers)) {
                number.classList.remove('passInvalid');
                number.classList.add('passValid');
            } else {
                number.classList.remove('passValid');
                number.classList.add('passInvalid');
            }

            // Validate length
            if(myInput.value.length >= 8) {
                length.classList.remove('passInvalid');
                length.classList.add('passValid');
            } else {
                length.classList.remove('passValid');
                length.classList.add('passInvalid');
            }
        }

        function importShipper(ev){
            vm.importShipperParam = {
                'formHeadTitle': 'Import Users',
                'formSubTitle': '',
                'importType':'users'
            }
            util.callMixpanel("User-Import-Open-Click");
            $mdDialog.show({
                template: '<md-dialog id="nwls-multiple-users-import" class="popup-md"><import-multiple-users importdata="ctrl.parent.importShipperParam" callback="ctrl.parent.callBackFileImport(data)"></import-multiple-users></md-dialog>',
                targetEvent: ev,
                clickOutsideToClose: false,
                preserveScope: true,
                controller: function () { this.parent = vm },
                controllerAs: 'ctrl',
              });
             
        };
        function callBackFileImport(data){
            vm.totalRecordsImported = RoleService.importFileUploadedMessage(data.totalRecordsImported);
            $timeout(function () {
                vm.totalRecordsImported = null;
            }, 10000);
        }
        function getImportUserStatus(){
            RoleService.getImportUserStatus().then(function(response){
                vm.importUserStatusData = angular.copy(response.data);
            },function(error){
                $log.error(error);
                vm.rfqBtn = false;
            });
        }

        function fnRemoveFileStatus(requestId,index){
            vm.markClosedObj = {
                'requestId' : requestId,
                'isMarkedClosed': true
            }
            RoleService.importUserStatusClosed(vm.markClosedObj).then(function(response){
                vm.importUserStatusData.splice(index, 1);
            },function(error){
                $log.error(error);
                vm.rfqBtn = false;
            });
        }
        function clearFilter(){
            
           util.callMixpanel("User-Filter-ClearAll-Click")
            vm.userData.isResetFilter = true;
            vm.userFilterConditions.selectedOptions = [];
            vm.cutomerFilterConditions.selectedOptions = [];
            vm.rolesFilterConditions.selectedOptions = [];
            vm.radioReset=false
            vm.filterListObject = angular.copy(vm.defaultfilterList);
            vm.getFilterList();
            vm.dtInstanceCallback.rerender();     
              $rootScope.$broadcast('resetFilter', { any: '' });
          }

        function getFilterList(queryParam){
            var type= (vm.forwarder_user &&  !vm.util.isShipper) ? 'FORWARDER' :  'SHIPPER' ;
            vm.cutomerFilterConditions.groupList =  !vm.util.isShipper? {'company':{groupTitle:'Customer Company',keyTitle:'name',subKeyTitle:''},'user':{groupTitle:'User Name',keyTitle:'first_name',subKeyTitle:'email',company_name:'company_name'}}:{'user':{groupTitle:'',keyTitle:'first_name',subKeyTitle:'email',company_name:'company_name'}} ;
            var url = api.baseUrl + '/api/v2/user/filters?filter_type='+type + '' +util.fnGetForwarderIdApi('&');
            if(queryParam){
              url +=  '&query_source=' + queryParam.query_source +'&query='+ queryParam.query;
            }
            $http.get(url).then(function(response){
                vm.filterobj.date_range= {
                    "from": fromDate,
                    "to": new Date()
                }
                if(type =='FORWARDER' ){
                    if(!queryParam){
                vm.filterobj.user_type = response.data.data.user_type.data;
                vm.filterobj.user_details = response.data.data.user_details.data;
                vm.filterobj.roles = response.data.data.roles.data[type.toLowerCase()];
                vm.rolesFilter=false;
                vm.filterobj.status = response.data.data.status.data;
                    }
                    else{
                        vm.filterobj.user_details = response.data.data.user_details.data;
                    }
                angular.forEach(vm.filterobj.user_type,function(item,key){
                    if(item.selected){
                        vm.userData.defaultvalue=item.type;
                    }
             })
            }
                else if(type =='SHIPPER') {
                    if(!queryParam){

                    vm.filterobj.roles = response.data.data.roles.data[type.toLowerCase()];
                    vm.rolesFilter=false;
                    vm.filterobj.customer_details =response.data.data.company_details.data;
                    vm.filterobj.status = vm.util.isShipper ? response.data.data.status.data:vm.filterobj.status;
                    }
                    else{
                        vm.filterobj.customer_details =response.data.data.company_details.data;
                    }}
                    vm.tempValue=angular.copy( vm.filterobj.roles);
                vm.filterLoader = false;
                vm.userFilterConditions.filterLoader = false;
                vm.cutomerFilterConditions.filterLoader = false;
                vm.rolesFilterConditions.filterLoader = false;
            }, function (error) {
                vm.userData.isResetFilter=false;
                vm.filterLoader = false;
                vm.userFilterConditions.filterLoader = false;
                vm.cutomerFilterConditions.filterLoader = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            })
          }
          function callBackUserSearch(payload){
            util.callMixpanel("User-Filter-UserDetails-Change",{'Value' : payload.selectedOptions , 'SearchQuery':payload.searchText})
          
            if(payload.searchText || payload.searchText === ''){ // search result 
                var queryParam = payload.searchText !== '' ? {'query_source' : "user_details",'query' : payload.searchText
                  } : null;
                vm.userFilterConditions.filterLoader = true;
                vm.getFilterList(queryParam);
            }

            if(payload.selectedOptions){ // selected options
              if(vm.userFilterConditions.selectedCount !== 0){
                vm.userData.userSelected = payload.selectedOptions;
                angular.forEach(payload.selectedOptions,function(item,key){
                  if(key === 0){ vm.filterListObject.user_details={}
                  vm.filterListObject.user_details={
                    query_source:null,
                    query_value:[],
                } }
                vm.filterListObject.user_details.query_source='requested_fwdr_users';
                  
                vm.filterListObject.user_details.query_value.push(item.id);
                });
               
              }else{
                angular.forEach(vm.filterListObject.user_details,function(item,key){
                    vm.filterListObject.user_details=null
                }); 
              }
             
              vm.dtInstanceCallback.rerender();
            //   vm.resizeScreenSize();
            }
          }
          function callBackCustomersSearch(payload){
            vm.filterListObject.customer_details={
                'user':{query_source:null,
                    query_value:[]},
                'company':{query_source:null,
                    query_value:[]}
            }
            if(payload.searchText || payload.searchText === ''){ // search result 
                var queryParam = payload.searchText !== '' ? {'query_source' : "company_details",'query' : payload.searchText
                  } : null;
                vm.cutomerFilterConditions.filterLoader = true;
                vm.getFilterList(queryParam);
            }
            //var companyValue={query_source:null,
                //query_value:[]};
            if(payload.selectedOptions){ // selected options
              util.callMixpanel("User-Filter-CustomerDetails-Change",{'Value' : payload.selectedOptions , 'SearchQuery':payload.searchText})
              if(vm.cutomerFilterConditions.selectedCount !== 0){
                vm.userData.customerSelected = payload.selectedOptions;
                
                angular.forEach(payload.selectedOptions,function(item,key){
                  if(key === 0){
                    //vm.filterListObject.customer_details={}
                    //addidng query source and query value
                    vm.filterListObject.customer_details[item.groupType]={}
                     vm.filterListObject.customer_details[item.groupType] ={
                        query_source:null,
                        query_value:[],
                    } }
                    vm.filterListObject.customer_details[item.groupType].query_source= item.groupType == 'user'?'requested_shpr_users':'requested_company';
                    vm.filterListObject.customer_details[item.groupType].query_value.push(item.id);
                });
               
              }else{
                angular.forEach(vm.filterListObject.customer_details,function(item,key){
                    vm.filterListObject.customer_details=null
                }); 
              }
              vm.dtInstanceCallback.rerender();
            }
          }
          function callBackRolesSearch(payload){
            util.callMixpanel("User-Filter-Roles-Change",{'Value' : payload.selectedOptions , 'SearchQuery':payload.searchText})
            vm.filterListObject.roles={}
            vm.filterListObject.roles.query_value=[] 
             if( payload.searchText === ''){ 
                vm.filterobj.roles=null
                vm.rolesFilterConditions.filterLoader = true;
                 vm.getFilterList();
             }
             else if(payload.searchText){
                vm.filterobj.roles= $filter('filter')(vm.tempValue,{"name":payload.searchText});
    
             }
    
            if(payload.selectedOptions){ // selected options
              if(vm.rolesFilterConditions.selectedCount !== 0){
                vm.userData.rolesSelected = payload.selectedOptions;
                
                angular.forEach(payload.selectedOptions,function(item,key){
                  if(key === 0){

            vm.filterListObject.roles.query_value=[]  
        }
            vm.filterListObject.roles.query_source = 'role_id';
            vm.filterListObject.roles.query_value.push(item.id);
                });
               
              }else{
                angular.forEach( vm.filterListObject.roles,function(item,key){
                    vm.filterListObject.roles=null
                }); 
              }
              vm.dtInstanceCallback.rerender();

            }
          }
          function filtertoggle(roles){
                util.callMixpanel("User-Filter-Status-Change" , {'Value' :roles })
                vm.filterListObject.status={}
                  //addidng query source and query value
                vm.filterListObject.status.query_value=[]
                vm.filterListObject.status.query_source= 'status';
                vm.filterListObject.status.query_value.push(roles);
                vm.dtInstanceCallback.rerender();
             }
          function setDatePicker(date){
            if(date){
                vm.filterListObject.date_range={
                    'from':{'query_value':[]},
                    'to':{ 'query_value':[]}
                }
            }    
              //addidng query source and query value        
            vm.filterListObject.date_range.from.query_source = 'from_date';
            vm.filterListObject.date_range.from.query_value.push( $filter('date')(date.start_date, 'yyyy-MM-dd'));
            vm.filterobj.date_range.from = $filter('date')(date.start_date, 'yyyy-MM-dd');
            vm.filterListObject.date_range.to.query_source = 'to_date';
            vm.filterListObject.date_range.to.query_value.push( $filter('date')(date.end_date, 'yyyy-MM-dd'));
            vm.filterobj.date_range.to = $filter('date')(date.end_date, 'yyyy-MM-dd');

            // mixpanel code 
            util.callMixpanel("User-Filter-DateRange-Change", {'Start date' : vm.filterobj.date_range.from , 'End Date':vm.filterobj.date_range.to})

            vm.dtInstanceCallback.rerender();
        }
          function fnSortBy(type){
            vm.filterListObject.sort_by=type
            vm.sortType[type]= vm.sortType[type]  === 'DESC' ? 'ASC' : 'DESC'
            vm.filterListObject.sort_by_type = vm.sortType[type];
            util.callMixpanel("User-SortBy-CreatedOn-Click", {
              "sortByType":  vm.filterListObject.sort_by_type
            });
            vm.listLoader = true;
            vm.dtInstanceCallback.rerender()
        }  

        function fnTrackEvent(eventName ,source , searchQuery){
            util.callMixpanel(eventName, {
               "Source":source,
               "Search Query":searchQuery,
              });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.shippers', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.shippers', {
                url    : '/shippers',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/roles/shipper/shippers.html',
                        controller : 'ShippersController as vm'
                    }
                },
                // resolve:{
               
                // },
                bodyClass: 'shippers-page'
            });
            // .state('app.shippers.shipper_form', {
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/shipper/shipper_form.html',
            //             controller : 'ShippersController as vm'
            //         }
            //     }
            // });
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/roles/shipper');

        // Api
        // msApiProvider.register('shippers', ['app/data/shippers/account.json']);

        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'SHIPPERS',
        //     group : true,
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.shippers', {
        //     title    : 'Shippers',
        //     icon     : 'icon-ferry',
        //     state    : 'app.shippers',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SHIPPERS.SHIPPERS_NAV',
        //     weight   : 1
        // });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.shippers')
        .controller('ShippersController', ShippersController);

    /** @ngInject */
    function ShippersController(SettingService, $state , RoleService,$mdSidenav, $mdDialog ,$mdToast ,$log, $filter, util, $sanitize, $rootScope, DTOptionsBuilder, DTColumnBuilder, $http,$compile, $scope, api,$timeout,localStorageService)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.util.screenTitle = "Shippers";
        // vm.shipperData = Shipper.data;
        vm.create_shipper = create_shipper;
        vm.viewShipper = viewShipper;
        vm.fnCopyID=fnCopyID;
        vm.submit_shipper = submit_shipper;
        vm.toggleSidenav=toggleSidenav;
        vm.updateShipper = updateShipper;
        vm.createShipper = createShipper;
        vm.deleteShipper = deleteShipper;
        vm.cancelDialog = cancelDialog;
        vm.updateColumn=updateColumn;
        vm.selectedIndex=0;
        vm.tms_enabled=false;
        vm.preLoadAnimation=preLoadAnimation;
        vm.getForwarderList = getForwarderList;
        vm.fnDeleteData = fnDeleteData;
        vm.forwarderList = [];
        vm.showTable= true;
        vm.showLoader= false;
        vm.filterLoader=true;
        vm.getCountries = getCountries;
        vm.maxFilterHeight={}
        vm.countryList = [];
        // vm.timeZones = [];
        vm.countrySelected = countrySelected;
        vm.stateList = [];
        vm.importShipper = importShipper; 
        vm.exportShipper = exportShipper;
        vm.getImportUserShipperStatus = getImportUserShipperStatus;
        vm.fnRemoveFileStatus = fnRemoveFileStatus;
        vm.shipperUserStatusData = [];  
        vm.formatResponse = formatResponse;
        vm.initShipperTable = initShipperTable;
        vm.formShipperApiUrl = formShipperApiUrl;
        vm.getDtColumnsData = getDtColumnsData;
        vm.callBackFileImport = callBackFileImport;
        vm.totalRecordsImported = null;
        vm.resizeScreenSize=resizeScreenSize;
        vm.fnSortBy = fnSortBy;
        vm.clearFilter=clearFilter;
        vm.getFilterList=getFilterList;
        vm.calculateMaxHeight=calculateMaxHeight;
        vm.setDatePicker=setDatePicker;
        vm.callBackComapnySearch=callBackComapnySearch;
        vm.setCompanyTypeFilter=setCompanyTypeFilter;
        vm.fnTrackEvent = fnTrackEvent;
        vm.getDomainData=getDomainData;
        vm.shipperDetailsTemp = [];
        vm.getDisplayCompanyType = getDisplayCompanyType;
        vm.getLanguageList = getLanguageList;
        vm.languageList = [];
        vm.languageLoading = false;
        vm.languageValidation = false;

        // Function to get display company type for UI
        function getDisplayCompanyType(backendCompanyType) {
            var companyTypeMapping = {
                'SHIPPER': 'CUSTOMER',
                'FORWARDER': 'FORWARDER',
                'FREIGHTBRO': 'FREIGHTBRO',
                // 'CUSTOMER': 'CUSTOMER',
                'CONSIGNEE': 'CONSIGNEE',
                'CONSIGNOR': 'CONSIGNOR'
            };
            return companyTypeMapping[backendCompanyType] || backendCompanyType;
        }
        
        
        var fromDate = new Date(new Date().setDate(new Date().getDate() - 30));
        vm.dtOptions = {
          dom       : '<"top"lf>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          autoWidth : false,
          responsive: true,
          lengthMenu  : [5, 10, 20, 30, 50, 100],
          pageLength  : 5
      };
      vm.filterobj={
        "company_name": null,
        "date_range":{
          "from": fromDate,
          "to": new Date()
        },
        "company_type": "ALL"
      };
      
      vm.shipperfilterdata= {
        'deviceName' : '',
        'companySelected' : [],
        'isResetFilter' : false,
      };
      vm.companyFilterConditions = {
        'listLoader':false,
        'selectedOptions': vm.shipperfilterdata.companySelected,
        'placeholder': 'Search Company',
        'isGroupOptions' : false,
        'groupList' :  {groupTitle:'Internal Users',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0
      };
      vm.filterListObject = {
        "date_range":null,
        "company_details": null,
        "company_type": null,
        "sort_by_type":'DESC',
        "sort_by":'created_at',
      };
      vm.sortType={
        'company_name':'DESC',
        'updated_at':'DESC'
      }
      vm.defaultfilterList=angular.copy(vm.filterListObject);
      function resizeScreenSize() {
        vm.shipperfilterdata.deviceName = util.resizeScreen(vm.shipperfilterdata.deviceName);
      }
      window.onresize = vm.resizeScreenSize;
      
      var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
        calculateMaxHeight();
    });
    $scope.$on('$destroy', bannerListener);


      function calculateMaxHeight(){
        vm.maxFilterHeight = vm.util.getModuleMaxHeight(vm.maxFilterHeight,'filter',0);
      }
        function init(){
          vm.getDomainData();
          util.isModulePaid('shippers');
          localStorageService.remove('DataTables_shipper_tables_/shippers');        
            //mixpanel code
            util.callMixpanel("Shippers");
            vm.initShipperTable();  //initialize user table
            vm.getForwarderList();
            vm.getCountries();
            vm.getLanguageList();
            vm.getImportUserShipperStatus();
            vm.resizeScreenSize();
            vm.getFilterList();
        }
        init();

        $rootScope.$on('app.shippers', function(event, args) {
            init();
        });
        function getDomainData(){
          if(!Object.keys($rootScope.domainData.domain_info).length){
            util.getDomainData().then(function(){
              vm.disableAutoInquiryInput = $rootScope.domainData.domain_info.DISABLE_AUTO_INQUIRY_INPUT;
              vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED
              if( vm.tms_enabled && vm.dtColumns && vm.dtColumns.length > 0){
              vm.dtColumns[2].visible = true;  // External Reference Code
              vm.dtColumns[10].visible = true;  // TMS Log Number
              vm.updateColumn();
            
              }
            },function(error){
                $log.log(error.data);
            });
          }else{
              vm.disableAutoInquiryInput = $rootScope.domainData.domain_info.DISABLE_AUTO_INQUIRY_INPUT;
              vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED
              if( vm.tms_enabled && vm.dtColumns && vm.dtColumns.length > 0){
                vm.dtColumns[2].visible = true;  // External Reference Code
                vm.dtColumns[10].visible = true;  // TMS Log Number
                vm.updateColumn();
              
                }
          }
        }
        function updateColumn(){
          var tableData = localStorageService.get('DataTables_shipper_tables_/shippers');
          if(tableData && tableData.columns && tableData.columns.length){
           tableData.columns = vm.dtColumns;
           localStorageService.set('DataTables_shipper_tables_/shippers', tableData);
   
          }
        }
        function create_shipper(ev){
          vm.selectedIndex=0;
          util.callMixpanel("Shipper-AddShipper-Open-Click");
          vm.companyNameValidation =false;
            vm.emailValidation=false;
            vm.shipperFormBtn = false;
            vm.tmsReferenceIDValidation=false;
            // vm.closestPortValidation=false; // Removed - field is now optional
            vm.shipperType=false;
            vm.languageValidation=false;
            // vm.selectedCountry = '';
            // vm.selectedState = '';
            // vm.getCountries();

            vm.shipperInfo = {
                "assignor_company_id" : util.isFreightbro ? "" : util.userProfile.user.company.id,
                "date_of_establishment" : null,
                "updateView" : false,
                "viewShipper" : false,
                "form_heading" : "Create",
                "button_type" : "Submit",
                "state" : "",
                "country" : "",
                "is_debtor" : 0,
                "is_creditor" : 0,
                "external_reference_id" : "",
                "type" : "",
                "company_default_language" : ""


            };

            $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/shipperForm/shipper_form.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });

        };

        function viewShipper(shipper,from_heading, update_index, ev){
               vm.selectedIndex=0;
               vm.companyNameValidation =false;
               vm.emailValidation=false;
               vm.shipperFormBtn = false;
               vm.tmsReferenceIDValidation=false;
               // vm.closestPortValidation=false; // Removed - field is now optional
               vm.shipperType=false;
               vm.languageValidation=false;
               vm.selectedIndex=0;
            var selectedUSer = vm.shipperDetailsTemp.find(function (i) {
              return i.id == shipper;
           });
           util.callMixpanel("Shipper-" + from_heading+"Shipper-Click",{'CompanyName':selectedUSer.company_name})
            if(util.isFreightbro){
              var companyData = vm.forwarderList.find(function(item){
                  return item.domain == selectedUSer.domain;// DEV-15811 - adding domain instead of assignor_company_id
              });
              vm.AssignorName = companyData.company_name;
            }

            try {
            vm.editEmail = selectedUSer.company_email == null ? true : false;
            vm.shipperInfo = {
                'id' : selectedUSer.id,
                'assignor_company_id': selectedUSer.assignor_company_id,
                'company_name' : selectedUSer.company_name,
                'company_constitution' : selectedUSer.company_constitution,
                "company_email" : selectedUSer.company_email,
                "company_phone_number": selectedUSer.company_phone_number,
                "company_phone_code" : selectedUSer.company_phone_code,
                "company_phone_country" : selectedUSer.company_phone_country,
                'company_address' : selectedUSer.company_address,
                'city' : selectedUSer.city,
                'state' : selectedUSer.state,
                'country' : selectedUSer.country,
                'postal_code' : selectedUSer.postal_code,
                'date_of_establishment' : selectedUSer.date_of_establishment,
                'iec_number': selectedUSer.iec_number,
                'point_of_contact' : selectedUSer.point_of_contact,
                'company_turnover' : parseInt(selectedUSer.company_turnover),
                'number_of_employees' : parseInt(selectedUSer.number_of_employees),
                "is_debtor" : selectedUSer.is_debtor,
                "is_creditor" : selectedUSer.is_creditor,
                "external_reference_id" : selectedUSer.external_reference_id,
                "closest_port" : selectedUSer.closest_port,
                "type" : selectedUSer.type,
                "company_default_language" : selectedUSer.company_default_language,

                "updateView" : true,
                "viewShipper" : from_heading == 'Edit' ? false : true,
                "form_heading" : from_heading,
                "button_type" : "Update",
                "shipper_index"  : update_index
            };

            var country =  vm.countryList.find(function(item){
              return (item.country_name === vm.shipperInfo.country);
            });

            if( country && country.states.length > 0){
              vm.stateList =  country.states;
            }

              $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/shipperForm/shipper_form.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });

        } catch (error) {
                $log.log(error);
        }
        }

        function toggleSidenav(sidenavId) {
          util.callMixpanel("Shipper-Mobile-FilterIcon-Click");
          $mdSidenav(sidenavId).toggle();
        }

        function submit_shipper(form, shipData, button){

          var shipperValidationObj ={
            'Company Name' :'',
            'Email Id': '',
            'Phone Number' : '',
            'Exporter Reference ID': ''
          }
          var  mixpanelObj = {
            ' Forwarder Name' : shipData.assignor_company_id,
            ' Company Name' : shipData.company_name ,
            ' Constitution' : shipData.company_constitution,
            ' Email Id' : shipData.company_email,
             'Company Address' : shipData.company_address,
            ' Phone Number' : shipData.company_phone_number,
             'Country' : shipData.country,
             'State' : shipData.state,
             'Postal Code' :shipData.postal_code,
             'Exporter Reference ID' :shipData.iec_number,
             'Point of Contact' : shipData.point_of_contact,
             'Source' : shipData.form_heading,
             'Shipper Form Validation': shipperValidationObj
           }
          var tmsValidation = vm.shipperInfo.external_reference_id || vm.shipperInfo.closest_port || vm.shipperInfo.is_debtor || vm.shipperInfo.is_creditor
          if(!vm.shipperInfo.company_name){
            vm.companyNameValidation=true;
            shipperValidationObj["Company Name"] = 'Required'
          }
          // Email is now optional - validation removed
          // if(!vm.shipperInfo.company_email){
          //   vm.emailValidation=true;
          //   shipperValidationObj["Email Id"] = 'Required'
          // }
          if(!vm.shipperInfo.company_default_language){
            vm.languageValidation=true;
            shipperValidationObj["Language"] = 'Required'
          }
          if(!vm.shipperInfo.external_reference_id && tmsValidation && vm.tms_enabled){
            vm.tmsReferenceIDValidation=true;
            shipperValidationObj["TMS Reference ID"] = 'Required'
          }
          // Closest Port is now optional - validation removed
          if(tmsValidation && vm.tms_enabled && !(vm.shipperInfo.is_debtor ||vm.shipperInfo.is_creditor)){
            vm.shipperType=true;
            shipperValidationObj["Shipper Type"] = 'Required'

          }
          if(vm.companyNameValidation || vm.languageValidation){
            util.callMixpanel("Shipper-Submit-Click",mixpanelObj);
            vm.selectedIndex=0;
            return
          }
   if(vm.tms_enabled && (vm.tmsReferenceIDValidation || vm.shipperType)){
    util.callMixpanel("Shipper-Submit-Click",mixpanelObj);
    vm.selectedIndex=1;
    return
    }
          // if(vm.util.isFreightbro && form.roles.$error.required){
          //   return true;
          // }

          // if(form.company_name.$error.required){
          //   document.querySelector('#shipper-company-name').focus();
          //   return true;
          // }

          // if(form.company_email.$error.required || form.company_email.$invalid){
          //   document.querySelector('#shipper-email').focus();
          //   return true;
          // }

          if( form.company_phone_number.$invalid ){
            document.querySelector('#shipper-phone').focus();
            shipperValidationObj["Phone Number"] = 'Invalid';
            util.callMixpanel("Shipper-Submit-Click",mixpanelObj);
            return true;
          }

          if( form.iec_number.$invalid ){
            document.querySelector('#shipper-iec').focus();
            shipperValidationObj["Exporter Reference ID"] = 'Invalid';
            util.callMixpanel("Shipper-Submit-Click",mixpanelObj);
            return true;
          }

          util.callMixpanel("Shipper-Submit-Click",mixpanelObj);
          shipData.date_of_establishment =   $filter('date')(shipData.date_of_establishment, 'yyyy-MM-dd');
          button == 'Submit' ? vm.createShipper(shipData) : vm.updateShipper(shipData) ;

          vm.shipperFormBtn = true;
         
        }

        function createShipper(shipData){
            // delete shipData["updateView"];
            // delete shipData["form_heading"];
            // delete shipData["button_type"];

            var data = {
            "data" :{
                "assignor_company_id":shipData.assignor_company_id,
                "company_name": shipData.company_name,
                "company_address": shipData.company_address,
                "city": shipData.city,
                "company_logo": null,
                "company_constitution": shipData.company_constitution,
                "company_email": shipData.company_email,
                "company_phone_number": shipData.company_phone_number,
                "company_phone_code" : null,
                "company_phone_country": null,
                "state": shipData.state,
                "country": shipData.country,
                "postal_code": shipData.postal_code,
                "date_of_establishment": shipData.date_of_establishment,
                "number_of_employees": shipData.number_of_employees,
                "company_turnover": shipData.company_turnover,
                "iec_number": shipData.iec_number,
                "point_of_contact": shipData.point_of_contact,
                "external_reference_id":shipData.external_reference_id,
                "closest_port":shipData.closest_port,
                "is_debtor":shipData.is_debtor,
                "is_creditor":shipData.is_creditor,
                "type":shipData.type,
                "company_default_language":shipData.company_default_language,
              }
            };

            util.isCallingApi = true;
            RoleService.createShipper(data).then(function(response){
                // vm.preLoadAnimation();
                // vm.shipperData.push(response.data.data);
                vm.dtInstanceCallback.rerender();
                vm.getFilterList(); // Refresh filter data to show new company
                util.showToast('Submitted Successfully!!','top right', 3000);
                vm.shipperFormBtn = false;
                vm.cancelDialog();
                util.isCallingApi = false;
            },function(error){
                util.isCallingApi = false;
                $log.log(error);
                util.showToast(util.displayValidationError(error));
                vm.shipperFormBtn = false;
            });
        };

        function updateShipper(shipData){
            var shipper_index = angular.copy(shipData["shipper_index"]);
            // delete shipData["updateView"];
            // delete shipData["form_heading"];
            // delete shipData["button_type"];
            // delete shipData["shipper_index"];

            var data = {
                "data" :{
                    "assignor_company_id":shipData.assignor_company_id,
                    "company_name": shipData.company_name,
                    "company_address": shipData.company_address,
                    "city": shipData.city,
                    "company_logo": null,
                    "company_constitution": shipData.company_constitution,
                    "company_email": shipData.company_email,
                    "company_phone_number": shipData.company_phone_number,
                    "company_phone_code" : shipData.company_phone_code,
                    "company_phone_country" : shipData.company_phone_country,
                    "state": shipData.state,
                    "country": shipData.country,
                    "postal_code": shipData.postal_code,
                    "date_of_establishment": shipData.date_of_establishment,
                    "number_of_employees": shipData.number_of_employees,
                    "company_turnover": shipData.company_turnover,
                    "iec_number": shipData.iec_number,
                    "point_of_contact": shipData.point_of_contact,
                    "external_reference_id":shipData.external_reference_id,
                    "closest_port":shipData.closest_port,
                    "is_debtor":shipData.is_debtor,
                    "is_creditor":shipData.is_creditor,
                    "type":shipData.type,
                    "company_default_language":shipData.company_default_language,
                }
            };
            util.isCallingApi = true;
            RoleService.updateShipper(data , shipData.id)
            .then(function(response){
                // vm.preLoadAnimation();
                // vm.shipperData[shipper_index] = response.data.company;
                vm.dtInstanceCallback.rerender();
                vm.getFilterList(); // Refresh filter data to show updated company
                util.showToast('Updated Successfully!!','top right', 3000);
                vm.shipperFormBtn = false;
                vm.cancelDialog();
                util.isCallingApi = false;
            },function(error){
                util.isCallingApi = false;
                $log.log(error);
                util.showToast(util.displayValidationError(error));
                vm.shipperFormBtn = false;
            });
        };

        //delete Users
        function deleteShipper(id, delete_index, user_count, ev){
          // DEV-15823 - Fix: label for Delete popup
          var companyType = vm.shipperDetailsTemp[delete_index].type;
          // Map SHIPPER type to Customer for UI display
          if (companyType === 'SHIPPER' || companyType === 'CUSTOMER') {
            vm.deleteType = "Customer";
          } else {
            vm.deleteType = companyType && companyType !== 'NA' ? companyType : "Customer";
          }
          vm.deleteValue=vm.shipperDetailsTemp[delete_index].user_first_name + ' ' + vm.shipperDetailsTemp[delete_index].user_last_name;
          vm.deletedCompanyName  = vm.shipperDetailsTemp[delete_index].company_name ;
          vm.deleteId = id;
          vm.deleteIndex = delete_index;
          vm.noOfShipperUser = user_count;
          vm.deleteBtn = false;
          util.callMixpanel("Shipper-DeleteShipper-Click",{'Name':vm.deletedCompanyName})
          $mdDialog.show({
              templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
              targetEvent        : ev,
              clickOutsideToClose: true,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm; }
          });
         
        }

        function fnDeleteData(){
          util.callMixpanel("Shipper-DeleteShipper-Proceed-Click" , {'Name':vm.deletedCompanyName});
          vm.deleteBtn = true;
          RoleService.deleteShipper(vm.deleteId).then(function(response){

              vm.dtInstanceCallback.rerender(); //Refersh user table with latest data
              vm.getFilterList(); // Refresh filter data after deletion

              var successMessage = vm.deleteType + ' deleted successfully';
              util.showToast(successMessage);
              vm.deleteBtn = false;
              $mdDialog.hide();

           },function(error){
              vm.deleteBtn = false;
              $log.log(error);
              util.showToast(util.displayValidationError(error));
           });
        }

        function getForwarderList(){
          vm.forwarderLoading = true;
          RoleService.getForwarder().then(function(response){
            try{
              vm.forwarderLoading = false;
              vm.forwarderList = response.data.data;
            } catch (e) {
              vm.forwarderLoading = false;
              $log.error(e);
            }
          },function(error){
            vm.forwarderLoading = false;
            $log.log(error);
          });
        }

        //close modal
        function cancelDialog(event , deleteEvent){
          if(event){
            util.callMixpanel("Shipper-Close-Click", {'Event':event , 'Source':vm.shipperInfo.form_heading});
          }
         if(deleteEvent){
            util.callMixpanel("Shipper-DeleteShipper-Cancel-Click");
         }
            $mdDialog.hide();
        };
        //preloading animation function - sanchit
        function preLoadAnimation(){
          vm.showTable=false;
          vm.showLoader=true;
          setTimeout(function(){
          vm.showTable=true;
          vm.showLoader=false;
          },5);

      }

      //get country list
      function getCountries() {
      if (!SettingService.countriesData) {
        vm.isDataLoading = true;
        SettingService.getCountryList().then(function (response) {
            try {
              vm.countryList = response.data.data.countries;
              vm.isDataLoading = false;
              SettingService.countriesData = angular.copy(response.data.data);
            } catch (e) {
              vm.isDataLoading = false;
              $log.error(e);
            }
          }, function (err) {
            vm.isDataLoading = false;
            $log.log(err);
          });
      } else {
          vm.countryList = SettingService.countriesData.countries;
        }
      }


      function countrySelected(contry_name) {
        vm.selectedState = '';
        vm.shipperInfo.state = '';
       var selected_country =  vm.countryList.find(function(item){
          return item.country_name == contry_name
        });

        if(selected_country.states && selected_country.states.length > 0 ){
          vm.stateList =  selected_country.states;
          return;
        }

        SettingService.getStateList(contry_name).then(function (response) {
          vm.stateList = response.data.data.countries[0] ? response.data.data.countries[0].states : [];
        }, function (err) {
          $log.log(err);
        });

      }
    function importShipper(ev){
        util.callMixpanel("Shipper-ImportPopup-Open-Click");
        vm.importShipperParam = {
          'formHeadTitle': 'Import Customer Companies & User',
          'formSubTitle': 'Note: By default, users in the upload file would only be created as Customer - User roles.',
          'importType':'shipper-users'
        }
        $mdDialog.show({
            template: '<md-dialog id="nwls-multiple-users-import" class="popup-md"><import-multiple-users importdata="ctrl.parent.importShipperParam" callback="ctrl.parent.callBackFileImport(data)"></import-multiple-users></md-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            preserveScope: true,
            controller: function () { this.parent = vm },
            controllerAs: 'ctrl',
        });
    };

    function exportShipper(ev){
     
      util.callMixpanel("Shipper-ExportPopup-Open-Click");
      vm.exportShipperParam = {
        'formHeadTitle': 'Export Data',
        'formSubTitle': '',
        'importType':'shipper',
        'settings':vm.settings,
        'count':vm.shipperLength,
        'totalLength':vm.totalLength,
        'url':vm.formShipperApiUrl("","",vm.settings,true)
        
   
      }
      $mdDialog.show({
          template: '<md-dialog id="nwls-multiple-users-export" class="popup-md"><export-multiple-users exportdata="ctrl.parent.exportShipperParam" callback="ctrl.parent.callBackFileImport(data)"></export-multiple-users></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          preserveScope: true,
          controller: function () { this.parent = vm },
          controllerAs: 'ctrl',
      });
  };
    function callBackFileImport(data){
      vm.totalRecordsImported = RoleService.importFileUploadedMessage(data.totalRecordsImported);
      $timeout(function () {
        vm.totalRecordsImported = null;
    }, 10000);
    }
    function getImportUserShipperStatus(){
        RoleService.getShipperUserStatus().then(function(response){
            vm.shipperUserStatusData = angular.copy(response.data);
        },function(error){
            $log.error(error);
        });
    }

    function fnRemoveFileStatus(requestId,index){
        vm.markClosedObj = {
            'requestId' : requestId,
            'isMarkedClosed': true
        }
        RoleService.importShipperStatusClosed(vm.markClosedObj).then(function(response){
            vm.shipperUserStatusData.splice(index, 1);
        },function(error){
            $log.error(error);
        });

      } 
      //******************** Code for shipper pagination - Shivani **************************

      //  initialize datatable with server side pgination

      function initShipperTable(){
        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('headerCallback', function(thead) {
          var createdOnIndex = vm.tms_enabled ? 9 : 8 // "Created On" position after adding City column
          // Add click for 'Company Name' header
          $(thead).find('th').eq(0).html('Company Name'+'<md-icon md-svg-src="assets/icons/custom/sort-icon.svg" class="s16 pl-5 pointer" ng-click="vm.fnSortBy(\'company_name\')"></md-icon>');
  
          // Add click for 'Created On' header
          $(thead).find('th').eq(createdOnIndex).html('Created On '+'<md-icon md-svg-src="assets/icons/custom/sort-icon.svg" class="s16 pl-5 pointer" ng-click="vm.fnSortBy(\'created_at\')"></md-icon>');
               
          // Compile the header to bind AngularJS directives
          $compile(thead)($scope);
      })
              .withOption('ajax', function (data, callback, settings) {

              var url = vm.formShipperApiUrl(data, callback, settings,false);  //get url
              vm.settings = settings;
              $http.get(url).then(function (response) {
                vm.shipperData = response.data.data;
                var new_res = formatResponse(vm.shipperData); //form response with table structure
                var table_data = {
                    'data': new_res,
                    'recordsTotal': response.data.count,
                    'recordsFiltered': response.data.count
                };
              
                vm.shipperLength = response.data.count;
                vm.totalLength = response.data.totalCount;
                callback(table_data);
                calculateMaxHeight();
                vm.dtOptions.lengthChange= vm.shipperLength>0 ?true : false;
                },
                function (error) {
                  vm.dtOptions.lengthChange= vm.shipperLength>0 ?true : false;
                util.showToast(error.message, 'top right', 3000);
                calculateMaxHeight();
                });
            })
            .withDataProp('data')
            .withOption('responsive', true)
            .withOption('serverSide', true)
            .withOption('processing', true)
            .withDisplayLength(10)
            .withPaginationType('simple')
            .withOption('aaSorting', [])
            .withOption('lengthChange',false)
            .withOption('stateSave', true)
            .withOption('language', { lengthMenu: "Show entries _MENU_"})
            .withOption('createdRow', function (row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });

        vm.getDtColumnsData();  //get dtcolumn data
      
        $scope.$on('$destroy', function() {
          localStorageService.remove('DataTables_shipper_tables_/shippers');        
      });

      }

      // form user api with parameter count,offset,search,type
      function formShipperApiUrl(data, callback, settings,exportFlag){
        var apiUrl=exportFlag ? '/api/v2/company/export' : '/api/v2/company';
        var url = api.baseUrl + apiUrl + '?limit='+ settings._iDisplayLength + '&offset='+ settings._iDisplayStart + util.fnGetForwarderIdApi('&');
        //adding query source and value to url
        angular.forEach(vm.filterListObject,function(value,key){
          if(key === 'company_type' && value && value.query_source){
            url += '&'+value.query_source+'='+value.query_value+'';
          } else if(key !== 'company_type'){
            angular.forEach((vm.filterListObject[key]),function(value1,key1){
              if(value1.query_source){
                   url += '&'+value1.query_source+'='+value1.query_value+''
                 }
            })
          }
        });
        url +='&sort_by='+vm.filterListObject.sort_by+'&sort_by_type='+vm.filterListObject.sort_by_type+'';
        if(exportFlag){
          url += '&export=true';
        }
        return url;
      }



      // form dtColumns data for datatables
      function getDtColumnsData(){
        
       
        vm.dtColumns = [
                // 1
                DTColumnBuilder.newColumn(null).withTitle('Company Name').withOption('name', 'company_name').renderWith(function (data) {
                  var html = '<span ng-non-bindable>'+ $sanitize(data.company_name)+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                     .withClass('ellipsis-text').notSortable(),
                // 2 - NEW: Type column
                DTColumnBuilder.newColumn(null).withTitle('Type').withOption('name', 'type').renderWith(function (data) {
                  var type = data.type ? $sanitize(data.type) : 'NA';
                  var html = '<span ng-non-bindable>'+type+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                     .withClass('ellipsis-text').notSortable(),
                // 3
                DTColumnBuilder.newColumn(null).withTitle('External Reference Code').withOption('name', 'external_reference_id').withOption('visible', false).renderWith(function (data) {
                  var referenceId = data.external_reference_id ? $sanitize(data.external_reference_id) : 'NA';
                  var html = '<span ng-non-bindable>'+referenceId +'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                     .withClass('ellipsis-text').notSortable(),

                DTColumnBuilder.newColumn(null).withTitle('Email').withOption('name', 'company_email').renderWith(function (data) {
                  var html = '<span ng-non-bindable>'+$sanitize(data.company_email)+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                      .withClass('ellipsis-text').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Address').withOption('name', 'company_address').renderWith(function (data) {
                        var html = '<span ng-non-bindable>'+$sanitize(data.company_address)+'</span>';
                        return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                            .withClass('ellipsis-text').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('City').withOption('name', 'city').renderWith(function (data) {
                              var html = '<span ng-non-bindable>'+$sanitize(data.city)+'</span>';
                              return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                                  .withClass('ellipsis-text').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Country').withOption('name', 'country').renderWith(function (data) {
                              var html = '<span ng-non-bindable>'+$sanitize(data.country)+'</span>';
                              return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                                  .withClass('ellipsis-text').notSortable(),
                // Language column
                DTColumnBuilder.newColumn(null).withTitle('Language').withOption('name', 'company_default_language').renderWith(function (data) {
                              var html = '<span ng-non-bindable>'+$sanitize(data.company_default_language)+'</span>';
                              return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                                  .withClass('ellipsis-text').notSortable(),
                
                      
                // 3
                // DTColumnBuilder.newColumn('company_phone_number').withTitle('Phone Number').withOption('name', 'company_phone_number').notSortable(),
                // 4
                DTColumnBuilder.newColumn(null).withTitle('No. of Users').withOption('name', 'no_shipper_user').renderWith(function (data) {
                  var html = '<span ng-non-bindable>'+$sanitize(data.no_shipper_user)+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' }).notSortable(),
                // 5
                DTColumnBuilder.newColumn(null).withTitle('Created On').withOption('name', 'created_at').renderWith(function (data) {
                  var html = '<span ng-non-bindable>'+$sanitize(data.created_at)+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' }).notSortable(),
                  // 6
                  DTColumnBuilder.newColumn(null).withTitle('TMS Log Number').withOption('name', 'transaction_id').withOption('visible', false).renderWith(function (data) {
                    var transactionId = data.transaction_id ? $sanitize(data.transaction_id) : 'NA';
                    var html = '<span ng-non-bindable>'+transactionId +'</span>';
                    var showIcon = transactionId !== 'NA' ? true : false;
        
                    return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'<span>' +
            '<md-icon  ng-if="showIcon"  md-font-icon="icon-content-copy"  class="s16 pl-5 pointer content-copy" ng-click="vm.fnCopyID(\'' + transactionId + '\')"></md-icon>'+
            // '<md-icon md-font-icon="icon-delete" ng-disabled="true" class="blue-dot pl-5" title="Delete" ng-if="vm.util.navPermission.shippers[3]" ng-click="vm.deleteShipper(shipper.id,$index,$event)"></md-icon>'
            '</span>'+'</td>' }).notSortable()
                ];
                if(vm.tms_enabled){
                  vm.dtColumns[2].visible = true;  // External Reference Code
                  vm.dtColumns[10].visible = true;  // TMS Log Number (moved after Language column)
                 // localStorageService.set('DataTables_shipper_tables_/shippers').columns = vm.dtColumns;
                }
             
                 
                // 6
                // DTColumnBuilder.newColumn('iec_number').withTitle('IEC Number').withOption('name', 'iec_number').notSortable(),
            // 6
            // DTColumnBuilder.newColumn('iec_verification_status').withClass('hide').withTitle('IEC Status')
            //   .renderWith(function(data, type, full, meta) {
            //     return '<span hide ng-class="{\'green-fg\' : '+data.iec_verification_status+', \'red-fg\' : '+!data.iec_verification_status+' }">'+ (data.iec_verification_status ? 'Verified' : 'Unverified' )+ '</span>';
            //   }),
       

        if(vm.userCategory == 'FREIGHTBRO'){
          vm.dtColumns.push(DTColumnBuilder.newColumn('domain').withTitle('Forwarder Domain').withOption('name', 'domain').notSortable());
        }

        vm.dtColumns.push(DTColumnBuilder.newColumn(null).withClass('all').withTitle('Action')
            .renderWith(function (data, type, full, meta) {
            return '<span>' +
            '<md-icon ng-if="vm.util.navPermission.shippers[2]" md-svg-src="assets/icons/custom/edit-icon.svg" class="cursor ml-10" ng-click="vm.viewShipper(\'' + data.id + '\',\'Edit\','+meta.row+',$event)"></md-icon>'+
            '<md-icon ng-if="vm.util.navPermission.shippers[1]" md-font-icon="icon-eye" class="cursor ml-10 mb-10 view_icon" title="View" ng-click="vm.viewShipper(\'' + data.id + '\',\'View\','+meta.row+',$event)" class="green-fg mh-5"></md-icon>'+
            '<md-icon ng-if="vm.util.navPermission.shippers[3]" md-svg-src="assets/icons/custom/delete-icon.svg" ng-click="vm.deleteShipper(\'' + data.id + '\','+meta.row+','+data.no_shipper_user+')" class="red-fg cursor"></md-icon>'+
            // '<md-icon md-font-icon="icon-delete" ng-disabled="true" class="blue-dot pl-5" title="Delete" ng-if="vm.util.navPermission.shippers[3]" ng-click="vm.deleteShipper(shipper.id,$index,$event)"></md-icon>'
            '</span>';
        }).notSortable());

        vm.dtInstanceCallback = {};
       // localStorageService.set('DataTables_shipper_tables_/shippers').columns = vm.dtColumns;
      }
      function fnCopyID(copyedText){
    
        vm.isIdCopied = 'Copied!'
        var temp_input = $("<input>");
        $("body").append(temp_input);
        temp_input.id = 'tempCopyToClipboard';
        temp_input.val(copyedText).select();
        document.execCommand("copy");
        temp_input.remove();
        $timeout(function ()
        {
            vm.isIdCopied = 'Click to Copy';
        }, 1500);
      }
      //form response with table structure
      function formatResponse(res_data){
        vm.shipperDetailsTemp = res_data;

        var new_res = [];
        var row_obj = {
        'company_email' : '',
        'company_phone_number': '',
        'company_name' : '',
        'type': '',  // NEW: Type field
        'no_shipper_user':'',
        'created_at' : '',
        'iec_number' : '',
        // 'iec_verification_status' : '',
        'domain' : '',
        'id': '',
        'updated_at': '',
        'transaction_id': '',
        'external_reference_id': '',
        'company_default_language': '',
        'city': '',
        };

        res_data.forEach(function (row) {
          
          var new_row = angular.copy(row_obj);
          new_row.id = row.id;
          new_row.company_email = row.company_email ? row.company_email : 'NA';
          new_row.company_phone_number = row.company_phone_number ? row.company_phone_number : 'NA';
          new_row.company_name = row.company_name ? row.company_name : 'NA' ;
          // Use display mapping to convert backend company type to UI display name
          var backendType = row.type ? row.type : 'NA';
          new_row.type = backendType !== 'NA' ? getDisplayCompanyType(backendType) : 'NA';
          new_row.no_shipper_user = row.user_count;
          new_row.iec_number = row.iec_number ? row.iec_number : 'NA' ;
          // new_row.iec_verification_status = row.iec_verification_status ? row.iec_verification_status : 'NA' ;
          new_row.domain = row.domain ? row.domain : 'NA' ;
          new_row.created_at = row.created_at ?  $filter('date')(row.created_at, 'yyyy-MM-dd') : 'NA' ;
          new_row.updated_at = row.updated_at ?  $filter('date')(row.updated_at, 'yyyy-MM-dd') : 'NA' ;
          new_row.transaction_id = row.transaction_id;
          new_row.external_reference_id = row.external_reference_id;
          new_row.company_address = row.company_address ? row.company_address : 'NA' ;
          new_row.city = row.city ? row.city : 'NA' ;
          new_row.country = row.country ? row.country : 'NA' ;
          // Map language code to language name for display
          if (row.company_default_language) {
            var languageObj = vm.languageList.find(function(lang) {
              return lang.language_code === row.company_default_language.toLowerCase();
            });
            new_row.company_default_language = languageObj ? languageObj.language_name : row.company_default_language.toUpperCase();
          } else {
            new_row.company_default_language = 'NA';
          }
          

          new_res.push(new_row);
        });

        return new_res;
      }

      function getFilterList(queryParam){
        var url = api.baseUrl + '/api/v2/company/filters';
        var hasParams = false;
        
        if(queryParam && queryParam.query){
          url +=  '?query='+ queryParam.query;
          hasParams = true;
        }
        
        // Add company type filter if not 'ALL'
        if(vm.filterobj.company_type && vm.filterobj.company_type !== 'ALL'){
          url += (hasParams ? '&' : '?') + 'company_type=' + vm.filterobj.company_type;
          hasParams = true;
        }
        
        url += util.fnGetForwarderIdApi(hasParams ? '&': '?');
        console.log('Company filter URL:', url); // Debug log
        $http.get(url).then(function(response){
          vm.filterobj.date_range= {
            "from": fromDate,
            "to": new Date()
        }
          vm.filterobj.company_name=response.data.data.company_details.data; 
             vm.filterLoader = false;
             vm.companyFilterConditions.filterLoader = false;
        }, function (error) {
            vm.shipperfilterdata.isResetFilter=false;
            vm.filterLoader = false;
            vm.companyFilterConditions.filterLoader = false;
            util.showToast(util.displayValidationError(error));
            $log.error(error);
        })
      }

      function clearFilter(){
        util.callMixpanel("Shipper-Filter-ClearAll-Click");
       
        vm.companyFilterConditions.selectedOptions = [];
        vm.filterListObject = angular.copy(vm.defaultfilterList);
        vm.filterobj.company_type = "ALL";
        vm.shipperfilterdata.isResetFilter = true;
        vm.dtInstanceCallback.rerender();
        vm.getFilterList();
          $rootScope.$broadcast('clearFilter', { any: '' });
       
      }
      function callBackComapnySearch(payload){
        util.callMixpanel("Shipper-Filter-CompanyName-Change",{'Value':payload.selectedOptions,'SearchQuery':payload.searchText});
          
        if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query' : payload.searchText
              } : null;
            vm.companyFilterConditions.filterLoader = true;
            vm.getFilterList(queryParam);
        }

        if(payload.selectedOptions){ // selected options
          if(vm.companyFilterConditions.selectedCount !== 0){
            vm.shipperfilterdata.companySelected = payload.selectedOptions;
            angular.forEach(payload.selectedOptions,function(item,key){
              if(key === 0){ vm.filterListObject.company_details=[]
              //vm.filterListObject.company_details={} 
            } //add query source and query value 
            var request={
              query_source:'',
              query_value:''
            }
            request.query_source='requested_company';
            request.query_value =(item.id);
            vm.filterListObject.company_details.push(request);

            });
           
          }else{
            angular.forEach(vm.filterListObject.company_details,function(item,key){
                vm.filterListObject.company_details=null
            }); 
          }
          vm.dtInstanceCallback.rerender();
        //   vm.resizeScreenSize();
        }
      }

      function setDatePicker(data){
        util.callMixpanel("Shipper-Filter-CreatedOn-Change", {'Value':data})
            if(data){
                vm.filterListObject.date_range={
                   'from':{},
                  'to':{}
                }
            }            //add query source and query value 
            vm.filterListObject.date_range.from.query_source = 'from_date';
            vm.filterListObject.date_range.from.query_value =  $filter('date')(data.start_date, 'yyyy-MM-dd');
            vm.filterobj.date_range.from = $filter('date')(data.start_date, 'yyyy-MM-dd');
            vm.filterListObject.date_range.to.query_source = 'to_date';
            vm.filterListObject.date_range.to.query_value =  $filter('date')(data.end_date, 'yyyy-MM-dd');
            vm.filterobj.date_range.to = $filter('date')(data.end_date, 'yyyy-MM-dd');
            vm.dtInstanceCallback.rerender();
        }

      function setCompanyTypeFilter(type){
        util.callMixpanel("Shipper-Filter-CompanyType-Change", {'Value':type});
        vm.filterobj.company_type = type;
        if(type !== 'ALL'){
          vm.filterListObject.company_type = {
            'query_source': 'company_type',
            'query_value': type
          };
        } else {
          vm.filterListObject.company_type = null;
        }
        // Refresh company name filter to show only companies of selected type
        vm.getFilterList();
        vm.dtInstanceCallback.rerender();
      }
          function fnSortBy(type){
            //console.log(action,"f")
            vm.filterListObject.sort_by=type
            vm.sortType[type]= vm.sortType[type]  === 'DESC' ? 'ASC' : 'DESC'
            vm.filterListObject.sort_by_type = vm.sortType[type];
            util.callMixpanel("Shipper-SortBy-CreatedOn-Click", {
              "sortByType":  vm.filterListObject.sort_by_type
            });
            vm.listLoader = true;
            vm.dtInstanceCallback.rerender()
      }
      function fnTrackEvent(eventName ,source , searchQuery){
          util.callMixpanel(eventName, {
             "Source":source,
             "Search Query":searchQuery
            });
      }

      function getLanguageList() {
          vm.languageLoading = true;
          $http.get(api.baseUrl + '/api/languages').then(function(response) {
              try {
                  var languages = response.data.data.languages || [];
                  // Transform API response to match frontend format
                  vm.languageList = languages.map(function(lang) {
                      return {
                          language_code: lang.code,
                          language_name: lang.name
                      };
                  });
                  // Ensure English is always available
                  var hasEnglish = vm.languageList.find(function(lang) { return lang.language_code === 'en'; });
                  if (!hasEnglish) {
                      vm.languageList.unshift({language_code: 'en', language_name: 'English'});
                  }
                  vm.languageLoading = false;
              } catch (e) {
                  vm.languageLoading = false;
                  vm.languageList = [{language_code: 'en', language_name: 'English'}]; // Fallback to English
                  $log.error(e);
              }
          }, function(error) {
              vm.languageLoading = false;
              vm.languageList = [{language_code: 'en', language_name: 'English'}]; // Fallback to English
              $log.log(error);
          });
      }
}
})();

(function ()
{
    'use strict';

    angular
        .module('app.userRoles',
            [   
                'app.forwarders',
                'app.forwarderOffices',
                'app.shippers',
                'app.agents',
                'app.users',
                'app.charges'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'Admin',
        //     group : true,
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.roles', {
        //     title : 'Roles',
        //     icon  : 'icon-cog',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.roles.shippers', {
        //     title: 'Shipper',
        //     state: 'app.shippers'
        // });

        // msNavigationServiceProvider.saveItem('fuse.roles.users', {
        //     title: 'Users',
        //     state: 'app.users'
        // });
    }

})();
(function(){
    'use strict';

    angular.module('app.userRoles')
    .factory('RoleService' , RoleService);

    /** @ngInject */
    function RoleService($q,$log,$mdToast,localStorageService, api, $http,$rootScope, util, efpUrl)
    {
        var RoleService = {
            getshipper : getshipper,
            createShipper : createShipper,
            updateShipper : updateShipper,
            updateAgent:updateAgent,
            deleteShipper : deleteShipper,
            deleteAgent : deleteAgent,
            getUser : getUser,
            // getShipperList : getShipperList,
            createShipperUser : createShipperUser,
            updateShipperUser : updateShipperUser,
            deleteShipperUser : deleteShipperUser,
            getUserById : getUserById,
            submitPermission : submitPermission,
            getForwarder : getForwarder,
            createForwarder : createForwarder,
            updateForwarder : updateForwarder,
            deleteForwarder : deleteForwarder,
            getForwarderOffices : getForwarderOffices,
            searchForwarderOffices : searchForwarderOffices,
            createForwarderOffice : createForwarderOffice,
            updateForwarderOffice : updateForwarderOffice,
            deleteForwarderOffice : deleteForwarderOffice,
            listForwarderAssignments : listForwarderAssignments,
            listAssignedReceivers : listAssignedReceivers,
            createForwarderAssignment : createForwarderAssignment,
            deleteForwarderAssignment : deleteForwarderAssignment,
            listPartnerRateAssignments : listPartnerRateAssignments,
            patchPartnerRateAssignment : patchPartnerRateAssignment,
            getV2Carriers : getV2Carriers,
            getAirlinesList : getAirlinesList,
            getUserType : getUserType,
            getAvailableList : getAvailableList,
            updateUserModule : updateUserModule,
            getNwlsData : getNwlsData,
            getRolesList : getRolesList,
            get_standard_terms : get_standard_terms,
            getAssignedShipper : getAssignedShipper,
            getTagsList : getTagsList,
            // getDepartmentsList : getDepartmentsList,
            // getDesignationsList : getDesignationsList,
            // getLocationsList : getLocationsList,
            fnSendIMUData: fnSendIMUData,
            getImportUserStatus:getImportUserStatus,
            getShipperUserStatus:getShipperUserStatus,
            importUserStatusClosed:importUserStatusClosed,
            importShipperStatusClosed:importShipperStatusClosed,
            getSampleFileDownload:getSampleFileDownload,
            createClients:createClients,
            getClients:getClients,
            enableDisableApi:enableDisableApi,
            importFileUploadedMessage : importFileUploadedMessage,
            createAgent:createAgent,
            getFilterListAgent:getFilterListAgent,
            getAgent:getAgent,
            createCharge: createCharge,
            updateCharge: updateCharge,
            deleteCharge: deleteCharge,
            getChargesList: getChargesList,
            getPricingModels: getPricingModels
        };

        return RoleService;

        function getshipper(){
            var url = api.baseUrl + '/api/shipper' + util.fnGetForwarderIdApi('?');
           return $http.get(url);
        //    .then(function(response){
        //         return response.data;
        //     },function(error){
        //         $log.error(error);
        //     });
        }

        function createShipper(shipper){
             var url = api.baseUrl + '/api/shipper';
             return  $http.post(url, shipper);
        }

        function updateShipper(shipper , id){
            var url = api.baseUrl + '/api/shipper/'+id;
            return $http.put(url, shipper);
        }

        function updateAgent(agent , id){
            var url = api.baseUrl + '/api/v2/agent/'+id;
            return $http.put(url, agent);
        }

        function createAgent(agent){
            var url = api.baseUrl + '/api/v2/agent';
            return  $http.post(url, agent);
        }

        function deleteShipper(id){
            var url = api.baseUrl + '/api/shipper/'+id;
            return $http.delete(url);
        }

        function deleteAgent(id){
            var url = api.baseUrl + '/api/v2/agent/'+id;
            return $http.delete(url);
        }

        function getAgent(getAgentApiUrl){
            var url=api.baseUrl+'/api/v2/agent?'+getAgentApiUrl;
            return $http.get(url);
        }

        function getFilterListAgent(queryParam){
            var url = api.baseUrl + '/api/v2/agent/filters';
            if(queryParam){
              url +=  '?query='+ queryParam.query;
            }
            url += util.fnGetForwarderIdApi(queryParam ? '&': '?');
            return $http.get(url);
        }

        // function getShipperList(){
        //     var url = api.baseUrl + '/api/shipper';
        //     return $http.get(url).then(function(response){
        //         return response.data;
        //     },function(error){
        //         $log.error(error);
        //     });
        // };

        function getUser(){
            var url = api.baseUrl + '/api/user' + util.fnGetForwarderIdApi('?');
            return $http.get(url);
        }

        function getUserById(id){
            var url = api.baseUrl + '/api/user/'+id;
            return $http.get(url);
        }

        function createShipperUser(shipperUser){
             var url = api.baseUrl + '/api/user';
             return  $http.post(url, shipperUser);
        }

        function updateShipperUser(shipperUser , id){
            // var url = api.baseUrl + '/api/shipper/'+id;
            var url = api.baseUrl + '/api/user/'+id;
            return $http.put(url, shipperUser);
        }

        function deleteShipperUser(id){
            // var url = api.baseUrl + '/api/shipper-user/'+id;
            var url = api.baseUrl + '/api/user/'+id;
            return $http.delete(url);
        }

        function submitPermission(data){
            var url = api.baseUrl + '/api/user/'+data.data.id;
            return $http.put(url,data).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        }

        function getForwarder(){
            var url = api.baseUrl + '/api/forwarder' + util.fnGetForwarderIdApi('?');
           return $http.get(url);
        }

        function createForwarder(form){
            var settings = {
                "async": true,
                "crossDomain": true,
                "url":  api.baseUrl + '/api/forwarder',
                "method": "POST",
                "headers": {
                    'authorization' : 'Bearer '+localStorageService.get('authToken').value.access_token,
                    'referer-domain' : $rootScope.domainData.host_name
                },
                "processData": false,
                "contentType": false,
                "mimeType": "multipart/form-data",
                "data": form
            };
            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        function updateForwarder(form, id){
            var settings = {
                "async": true,
                "crossDomain": true,
                "url":  api.baseUrl + '/api/forwarder-update/'+ id ,
                "method": "POST",
                "headers": {
                    'authorization' : 'Bearer '+localStorageService.get('authToken').value.access_token,
                    'referer-domain' : $rootScope.domainData.host_name
                },
                "processData": false,
                "contentType": false,
                "mimeType": "multipart/form-data",
                "data": form
            };
            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        function deleteForwarder(id){
           var url = api.baseUrl + '/api/forwarder/'+id;
           return $http.delete(url);
        }

        function getForwarderOffices(options){
            options = options || {};
            var url = api.baseUrl + '/api/forwarder-offices' + util.fnGetForwarderIdApi('?');
            var sep = url.indexOf('?') === -1 ? '?' : '&';
            var params = [];
            if (options.search) {
                params.push('query=' + encodeURIComponent(options.search));
            }
            if (options.limit !== undefined && options.limit !== null) {
                params.push('limit=' + options.limit);
            }
            if (options.offset !== undefined && options.offset !== null) {
                params.push('offset=' + options.offset);
            }
            if (params.length) {
                url += sep + params.join('&');
            }
            return $http.get(url);
        }

        function searchForwarderOffices(searchText){
            var url = api.baseUrl + '/api/forwarder-offices/search?query=' + encodeURIComponent(searchText) + '&limit=30&offset=0';
            return $http.get(url);
        }

        function createForwarderOffice(payload){
            var data = angular.copy(payload) || {};
            data.forwarder_company_id = $rootScope.forwarder_id;
            return $http.post(api.baseUrl + '/api/forwarder-offices', {'data': data});
        }

        function updateForwarderOffice(payload){
            var data = angular.copy(payload) || {};
            data.forwarder_company_id = $rootScope.forwarder_id;
            return $http.put(api.baseUrl + '/api/forwarder-offices', {'data': data});
        }

        function deleteForwarderOffice(domain){
            var url = api.baseUrl + '/api/forwarder-offices/' + encodeURIComponent(domain);
            return $http.delete(url);
        }

        function listForwarderAssignments(options){
            options = options || {};
            var params = [];
            if (options.query) {
                params.push('query=' + encodeURIComponent(options.query));
            }
            if (options.limit !== undefined && options.limit !== null) {
                params.push('limit=' + options.limit);
            }
            if (options.offset !== undefined && options.offset !== null) {
                params.push('offset=' + options.offset);
            }
            var url = api.baseUrl + '/api/forwarder-assignment' + (params.length ? '?' + params.join('&') : '');
            return $http.get(url);
        }

        function listAssignedReceivers(options){
            options = options || {};
            var params = [];
            if (options.supplierDomainSubscriberId) {
                params.push('supplierDomainSubscriberId=' + encodeURIComponent(options.supplierDomainSubscriberId));
            }
            if (options.query) {
                params.push('query=' + encodeURIComponent(options.query));
            }
            if (options.limit !== undefined && options.limit !== null) {
                params.push('limit=' + options.limit);
            }
            if (options.offset !== undefined && options.offset !== null) {
                params.push('offset=' + options.offset);
            }
            var url = api.baseUrl + '/api/forwarder-assignment/receivers' + (params.length ? '?' + params.join('&') : '');
            return $http.get(url);
        }

        function createForwarderAssignment(payload){
            return $http.post(api.baseUrl + '/api/forwarder-assignment', payload || {});
        }

        function deleteForwarderAssignment(payload){
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/api/forwarder-assignment',
                data: payload || {},
                headers: { 'Content-Type': 'application/json' }
            });
        }

        /**
         * Same behaviour as util.fnGetForwarderIdApi: for FREIGHTBRO users, sync forwarder from
         * localStorage and append forwarder_company_id so Laravel User::get_vendor_id() resolves.
         */
        function partnerRateGodForwarderCompanyIdParam() {
            if (util.isFreightbro && localStorageService.get('forwarder') && localStorageService.get('forwarder').value) {
                $rootScope.forwarder_id = localStorageService.get('forwarder').value.id;
            }
            if (util.isFreightbro && $rootScope.forwarder_id) {
                return 'forwarder_company_id=' + encodeURIComponent($rootScope.forwarder_id);
            }
            return '';
        }

        function listPartnerRateAssignments(options){
            options = options || {};
            var params = [];
            if (options.role) {
                params.push('role=' + encodeURIComponent(options.role));
            }
            if (options.query) {
                params.push('query=' + encodeURIComponent(options.query));
            }
            if (options.limit !== undefined && options.limit !== null) {
                params.push('limit=' + options.limit);
            }
            if (options.offset !== undefined && options.offset !== null) {
                params.push('offset=' + options.offset);
            }
            var godFwd = partnerRateGodForwarderCompanyIdParam();
            if (godFwd) {
                params.push(godFwd);
            }
            var url = api.baseUrl + '/api/partner-rate-management/assignments' + (params.length ? '?' + params.join('&') : '');
            return $http.get(url);
        }

        function patchPartnerRateAssignment(id, payload){
            var godFwd = partnerRateGodForwarderCompanyIdParam();
            var url = api.baseUrl + '/api/partner-rate-management/assignments/' + encodeURIComponent(id) + (godFwd ? '?' + godFwd : '');
            return $http.patch(url, payload || {});
        }

        function getV2Carriers(params){
            params = params || {};
            var type = params.type || 'subvendor';
            var source = params.source || 'common';
            var limit = params.limit != null ? params.limit : 60;
            var offset = params.offset != null ? params.offset : 0;
            var q = [
                'type=' + encodeURIComponent(type),
                'source=' + encodeURIComponent(source),
                'limit=' + limit,
                'offset=' + offset
            ];
            if (params.query) {
                q.push('query=' + encodeURIComponent(params.query));
            }
            return $http.get(api.baseUrl + '/api/v2/carriers?' + q.join('&'));
        }

        function getAirlinesList(){
            return $http.get(api.baseUrl + '/api/airlines');
        }

        function getUserType(){
            var url = 'app/data/roles/user.json';
            return $http.get(url).then(function(response){
                 return response.data;
             },function(error){
                 $log.error(error);
             });
        }

        function getAvailableList(id){
            var url = api.baseUrl + '/api/available-modules/'+id;
            return $http.get(url);
        }

        function updateUserModule(modules , id){
            var url = api.baseUrl + '/api/modules/'+id;
            return $http.put(url, modules);
        }

        function getNwlsData(){
            var url = api.baseUrl + '/api/nwls-data';
            return $http.get(url);
        }

        function get_standard_terms(){
          var url = api.baseUrl + '/api/get-standard-terms';
          return $http.get(url);
        }

        function getRolesList(companyId,user_type){
            var url = api.baseUrl + '/api/roles-list?company_id='+companyId+'&created_for='+user_type;
            return $http.get(url);
        }

        function getAssignedShipper(searchText){
          var url = api.baseUrl + '/api/v2/company?limit=30&offset=0&company_type=SHIPPER' + util.fnGetForwarderIdApi('&');
          if(searchText) {
            url += '&query=' + searchText;
          }
            return $http.get(url);
        }

        function getTagsList(companyId){
            var url = api.baseUrl + '/api/tag-list?forwarder_company_id='+companyId;
           return $http.get(url);
        }

        // function getDepartmentsList(companyId){
        //     var url = api.baseUrl + '/api/department-list?forwarder_company_id='+companyId;
        //    return $http.get(url);
        // }

        // function getDesignationsList(companyId){

        //     var url = api.baseUrl + '/api/designation-list';
        //     if(companyId != null){
        //         url += '?forwarder_company_id='+companyId;
        //     }
        //    return $http.get(url);
        // }

        // function getLocationsList(companyId){
        //     var url = api.baseUrl + '/api/location-list?forwarder_company_id='+companyId;
        //    return $http.get(url);
        // }

        function fnSendIMUData(imuData,importType) {
            var authToken = '';
            var auth = {};
            if (util.isSharedPage() && localStorage.getItem('otp') !== null) {
                authToken = localStorageService.otp;
                auth = {
                'otp': authToken,
                'referer-domain': $rootScope.domainData.host_name
                }
            } else {
                authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
                auth = {
                'authorization': authToken,
                'referer-domain': $rootScope.domainData.host_name
                };
            }
            var apiType = importType === 'users' ? 'import-users':'import-shippers';
            var url = api.baseUrl + '/api/v2/'+apiType;
            var settings = {
                "async": true,
                "crossDomain": true,
                "url":  url,
                "method": "POST",
                "headers": auth,
                "processData": false,
                "contentType": false,
                "mimeType": "multipart/form-data",
                "data": imuData
            };

            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        function getImportUserStatus(){
            var authToken = '';
            var auth = {};
            if (util.isSharedPage() && localStorage.getItem('otp') !== null) {
                authToken = localStorageService.otp;
                auth = {
                'otp': authToken,
                'referer-domain': $rootScope.domainData.host_name
                }
            } else {
                authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
                auth = {
                'authorization': authToken,
                'referer-domain': $rootScope.domainData.host_name
                };
            }
            
            var settings = {
                "async": false,
                "crossDomain": true,
                "url":  api.baseUrl + '/api/v2/import-users-status',
                "method": "GET",
                "headers": auth,
                "processData": false,
                "contentType": false
            };

            return $.ajax(settings).done(function (response) {
                return response;
            });

        }

        function getShipperUserStatus(){
            var authToken = '';
            var auth = {};
            if (util.isSharedPage() && localStorage.getItem('otp') !== null) {
                authToken = localStorageService.otp;
                auth = {
                'otp': authToken,
                'referer-domain': $rootScope.domainData.host_name
                }
            } else {
                authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
                auth = {
                'authorization': authToken,
                'referer-domain': $rootScope.domainData.host_name
                };
            }
            
            var settings = {
                "async": false,
                "crossDomain": true,
                "url":  api.baseUrl + '/api/v2/import-shippers-status',
                "method": "GET",
                "headers": auth,
                "processData": false,
                "contentType": false
            };

            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        function importUserStatusClosed(data){
            return $http.patch(api.baseUrl + '/api/v2/import-users-status', data).then(function(response){
                return response.data;
            });
        }

        function importShipperStatusClosed(data){
            return $http.patch(api.baseUrl + '/api/v2/import-shippers-status', data).then(function(response){
                return response.data;
            });
        }

        function getSampleFileDownload(importType){
            var authToken = '';
            var auth = {};
            if (util.isSharedPage() && localStorage.getItem('otp') !== null) {
                authToken = localStorageService.otp;
                auth = {
                'otp': authToken,
                'referer-domain': $rootScope.domainData.host_name
                }
            } else {
                authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
                auth = {
                'authorization': authToken,
                'referer-domain': $rootScope.domainData.host_name
                };
            }

            var url = api.baseUrl + '/api/v2/import-file-sample/shipper';
            if(importType == 'users'){
                url = api.baseUrl + '/api/v2/import-file-sample/user'
            }
            
            var settings = {
                "async": false,
                "crossDomain": true,
                "url":  url,
                "method": "GET",
                "headers": auth,
                "processData": false,
                "contentType": false
            };

            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        function createClients(form){
            var settings = {
                "crossDomain": true,
                "url":  api.baseUrl + '/oauth2/clients',
                "method": "POST",
                "headers": {
                    'authorization' : 'Bearer '+localStorageService.get('authToken').value.access_token,
                    'referer-domain' : $rootScope.domainData.host_name
                },
                "processData": false,
                "contentType": false,
                "data": form
            };
            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        function getClients(domain){
            var forwarderId = util.fnGetForwarderIdApi('?');
            var url = api.baseUrl + '/oauth2/clients'+ forwarderId;
            if(domain) {
                url += (forwarderId === '' ? '?' : '&') + 'domain=' + domain;
              }
            return $http.get(url);
        }

        function enableDisableApi(form){
            
            var settings = {
                "crossDomain": true,
                "url":  api.baseUrl + '/oauth2/apikey/'+form.clientId+'/update',
                "method": "PATCH",
                "headers": {
                    'authorization' : 'Bearer '+localStorageService.get('authToken').value.access_token,
                    'referer-domain' : $rootScope.domainData.host_name,
                    "content-type": "application/json"
                },
                "processData": false,
                "contentType": false,
                "data": JSON.stringify(form.formData)
            };
            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        function importFileUploadedMessage(totalRecords){
            //"Import in process.. Please check back in a moment.", // upload below 100 files then show message
            //"Import in process.. You will be notified, once processed." // upload above 100 files then show message
            return totalRecords <= 100 ? "Import in process.. Please check back in a moment." : "Import in process.. You will be notified, once processed."
        }

        function createCharge(charge) {
            var url = efpUrl + '/api/efp/charge';
            return $http.post(url, charge);
        }
        
        function updateCharge(charge, id) {
            var url = efpUrl + '/api/efp/charge/' + id;
            return $http.put(url, charge);
        }
        
        function deleteCharge(id) {
            var url = efpUrl + '/api/efp/charge/' + id;
            return $http.delete(url);
        }
        
        function getChargesList(getChargeApiUrl) {
            var url = efpUrl + '/api/efp/charge/list?' + getChargeApiUrl;
            return $http.get(url);
        }
        
        function getPricingModels(mode) {
            var url = efpUrl + '/api/efp/pricing-models';
            if (mode) {
                url += '?mode=' + encodeURIComponent(mode);
            }
            return $http.get(url);
        }

    }

}());

(function ()
{
    'use strict';

    angular
        .module('app.forwarders', ['datatables', 'ng.ckeditor'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.forwarders', {
                url    : '/forwarders',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/roles/forwarder/forwarders.html',
                        controller : 'ForwardersController as vm'
                    }
                },
                // resolve: {
                //     Forwarder: function (RoleService, util, $state)
                //     {
                //         util.isCallingApi = true;
                //         return RoleService.getForwarder().then(function(response){
                //             util.isCallingApi = false;
                //             return response.data;
                //         },function(error){
                //             util.isCallingApi = false;
                //             $state.go(util.redirectIfError(error));
                //         });
                //     }
                // },
                bodyClass: 'forwarders-page'
            });

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.forwarders')
        .controller('ForwardersController', ForwardersController);

    /** @ngInject */
    function ForwardersController(RoleService, $sanitize,$mdDialog, $log, $filter, localStorageService, util, shareQuoteService, $rootScope, $timeout, fuseGenerator, $scope,DTOptionsBuilder,DTColumnBuilder,api,$compile,$http)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.util.screenTitle = "Forwarders";
        // vm.forwarderData = Forwarder.data;
        vm.create_forwarder = create_forwarder;
        vm.viewForwarder = viewForwarder;
        vm.submit_forwarder = submit_forwarder;
        vm.updateForwarder = updateForwarder;
        vm.createForwarder = createForwarder;
        vm.deleteForwarder = deleteForwarder;
        vm.fnDeleteData = fnDeleteData;
        vm.forwarderList = [];
        vm.resetImage = resetImage;
        vm.getNwlsData = getNwlsData;
        vm.dtOptions = {
            dom       : '<"top"lf>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            lengthMenu  : [5, 10, 20, 30, 50, 100],
            pageLength  : 5
        };
        vm.validateEmail = validateEmail;
        vm.invalidEmail = false;
        vm.getDomainUrl = getDomainUrl;
        vm.submitAdminUser = submitAdminUser;
        vm.validatePassword = validatePassword;
        vm.showPassErr = showPassErr;
        vm.showPassword = false;
        vm.showCurrentPassword = false;
        vm.togglePassword = togglePassword;
        vm.terms_condition_key_up = terms_condition_key_up;
        vm.std_tnc = null;
        vm.validateSecondaryColor = validateSecondaryColor;
        vm.fnLogoValidation = fnLogoValidation;
        vm.fnResetLogo = fnResetLogo;
        // functions for cropped logo
        vm.cropper = '';
        vm.origFilename = '';
        vm.origType = '';
        vm.src = '';
        vm.saveImg = saveImg;
        vm.cancelDialog = cancelDialog;
        vm.fnlogoStyleChange = fnlogoStyleChange;
        vm.openMenu = openMenu;
        vm.srcToFile = srcToFile;   
        vm.fnReplaceLogo = fnReplaceLogo;
        vm.isLogoUpdated = false;
        vm.isPreview = false;
        vm.fnOrigLogo = fnOrigLogo;
        vm.pickerModel = {}
        vm.setDatePicker = setDatePicker;
        vm.editDatePicker = editDatePicker;
        vm.lastpicker={};
        vm.initForwardersTable = initForwardersTable;
        vm.forwardersApiUrl = forwardersApiUrl;
        vm.getDtColumnsData = getDtColumnsData;
        vm.formatResponse = formatResponse;
        vm.fnClientGenerate = fnClientGenerate;
        vm.getClients = getClients;
        vm.clientsObj = null;
        vm.fnEnableDisableApi = fnEnableDisableApi;


        function init(){
            util.isModulePaid('forwarders');
            vm.initForwardersTable();  //initialize Forwarders Table

          RoleService.get_standard_terms()
            .then(function(response){
              vm.std_tnc = response.data.data;
            },function(error){
                $log.log(error);
                vm.std_tnc = null;
            });

            // vm.fnOrigLogo();
        }
        init();

        $rootScope.$on('app.forwarders', function(event, args) {
            init();
        });

        function create_forwarder(ev){
            angular.element('#stepper_submit').removeAttr('disabled') ;
            vm.forwarderBtn = false;
            vm.favicon = null;
            vm.company_logo = null;
            vm.original_logo = null;
            vm.trialErr = '';
            vm.forwarderInfo = {
                'assignor_company_id': localStorageService.get('authToken').value.user_company_id,
                'company_logo': null,
                'original_logo': null,
                'domain_data' : {
                    'solution_type' : 'NWLS',
                    'shipment_initial_incremental' : 'false',
                    'quote_initial_incremental' : 'false',
                    'mailgun_domain_verified_status' : 'false',
                    'app_config' : {
                        'min_version' : '',
                        'max_version' : '',
                        'android_link' : 'https://play.google.com/store/apps/details?id=com.freightbro.ship.fb',
                        'ios_link' : 'https://apps.apple.com/us/app/freightbro/id1453841696'
                    },
                    'theme_config': {
                      'primary_color': '#233669',
                      'secondary_color': '#f7961d',
                      'dark_mode': false
                    },
                    'base_currency': ''
                },
                'favicon': null,
                'date_of_establishment' : null,
                'updateView' : false,
                'form_heading' : 'CREATE',
                'button_type' : 'SUBMIT',
                'user_data' : {},
                'tnc_fcl':'',
                'tnc_air':'',
                'tnc_lcl':'',
                'std_tnc_fcl': vm.std_tnc != null ? vm.std_tnc.fcl : '',
                'std_tnc_air': vm.std_tnc != null ? vm.std_tnc.air : '',
                'std_tnc_lcl': vm.std_tnc != null ? vm.std_tnc.lcl : ''
            };
            vm.pickerModel = {};
            vm.forwarderInfoCopy = angular.copy(vm.forwarderInfo);
            vm.forwarderInfo.domain_data.shared_rate_receivers = [];
            vm.forwarderInfo.domain_data.shipment_cc_emails = [];
            vm.getNwlsData(vm.forwarderInfo); //call api to get  nwls data

            $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/forwarderForm/forwarder-add.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                fullscreen: true,
                preserveScope: true,
                controllerAs: 'ctrl',               
                controller: function() { this.parent = vm },
                onRemoving: function () {
                    for (var name in CKEDITOR.instances) {
                      CKEDITOR.instances[name].destroy();
                    }
                  }
            });

        };

        function viewForwarder(update_index, ev){
            angular.element('#stepper_submit').removeAttr('disabled') ;
            var forwarder = angular.copy(vm.forwarderDetailsTemp[update_index]);
            vm.forwarderBtn = false;
            vm.lastpicker=forwarder.trial_period ? new Date(forwarder.trial_period.starts_at) : null,
            forwarder.domain_data.solution_type = !forwarder.domain_data.solution_type ? 'NWLS' : forwarder.domain_data.solution_type;
            vm.trialErr = '';
            vm.forwarderInfo = {
                    'id' : forwarder.id,
                    'assignor_company_id': localStorageService.get('authToken').value.user_company_id,
                    'company_name' : forwarder.company_name,
                    'company_constitution' : forwarder.company_constitution,
                    "company_email" : forwarder.company_email,
                    'company_phone_number' : forwarder.company_phone_number,
                    'company_phone_code': forwarder.company_phone_code,
                    'company_phone_country': forwarder.company_phone_country,
                    'company_address' : util.decodeValue(forwarder.company_address),
                    'state' : forwarder.state,
                    'country' : forwarder.country,
                    'postal_code' : forwarder.postal_code,
                    'date_of_establishment' : forwarder.date_of_establishment ? util.dateReplace(forwarder.date_of_establishment) : null,
                    'company_turnover' : parseInt(forwarder.company_turnover),
                    'number_of_employees' : parseInt(forwarder.number_of_employees),
                    "domain" : forwarder.domain,
                    "incentive" : forwarder.incentive,
                    "iata_commission" : forwarder.iata_commission,
                    "domain_data": forwarder.domain_data,
                    "favicon": forwarder.favicon,
                    "company_logo": forwarder.company_logo,
                    "original_logo": forwarder.original_logo,
                    "updateView" : true,
                    "form_heading" : "EDIT",
                    "button_type" : "UPDATE",
                    "forwarder_index"  : update_index,
                    "user_data" : {},
                    'tnc_fcl': util.decodeValue(forwarder.tnc_fcl),
                    'tnc_air': util.decodeValue(forwarder.tnc_air),
                    'tnc_lcl': util.decodeValue(forwarder.tnc_lcl),
                    'std_tnc_fcl': util.decodeValue(forwarder.std_tnc_fcl),
                    'std_tnc_air': util.decodeValue(forwarder.std_tnc_air), 
                    'std_tnc_lcl': util.decodeValue(forwarder.std_tnc_lcl)
            };
            // get oauth Generated client
            vm.clientsObj = {'Production': [],'Sandbox' : []};
            vm.getClients(forwarder.domain);

            vm.pickerModel = {
                'dateStart' : forwarder.trial_period ? new Date(forwarder.trial_period.starts_at) : null,
                'dateEnd' : forwarder.trial_period ? new Date(forwarder.trial_period.ends_at) : null
            }
            vm.pickerModelcopy = angular.copy(forwarder.trial_period);


            vm.forwarderInfoCopy = angular.copy(vm.forwarderInfo);
            getImgMeta(vm.forwarderInfoCopy.company_logo);
            vm.getNwlsData(vm.forwarderInfo); //call api to get  nwls data
            vm.getDomainUrl (vm.forwarderInfo); //get frontend url and redirect base url
            vm.forwarderInfo.domain_data.shared_rate_receivers = vm.forwarderInfo.domain_data.shared_rate_receivers ? vm.forwarderInfo.domain_data.shared_rate_receivers.split(',') : [] ;
            vm.forwarderInfo.domain_data.shipment_cc_emails = vm.forwarderInfo.domain_data.shipment_cc_emails ? vm.forwarderInfo.domain_data.shipment_cc_emails.split(',') : [] ;
            // if(vm.forwarderInfo.domain_data.common_email){
            //     // var domain = "@"+vm.forwarderInfo.domain_data.common_email.split('@')[1];
            //     vm.forwarderInfo.domain_data.common_email = vm.forwarderInfo.domain_data.common_email.split('@')[0] ;
            // }

            // Primary and secondary_color
            if(vm.forwarderInfo.domain_data.theme_config)
            {
              vm.forwarderInfo.domain_data.theme_config.primary_color = vm.forwarderInfo.domain_data.theme_config.primary_color ?  vm.forwarderInfo.domain_data.theme_config.primary_color : '#233669';

              vm.forwarderInfo.domain_data.theme_config.secondary_color = vm.forwarderInfo.domain_data.theme_config.secondary_color ? vm.forwarderInfo.domain_data.theme_config.secondary_color : '#f7961d';

            }else{
              vm.forwarderInfo.domain_data.theme_config = {
                'primary_color' : '#233669',
                'secondary_color' : '#f7961d',
                'dark_mode' : false
              };
            }
            vm.favicon = null;

            vm.oauthGenerate = {
                "name": forwarder.company_name,
                "redirect": forwarder.domain_data.redirect_base_url ? forwarder.domain_data.redirect_base_url : null,
                "personal": false,
                "vendorId": forwarder.vendor_id,
                "password": true,
                "domain": forwarder.domain,
                "environment": null,
                "accessTokenExpiryInMinutes": 20,
                "enabled": true,
                "limitType": "DAY",//DAY|WEEK|MONTH
                "limit": null,
                "rateLimit": 1,
                "burstLimit": 10,
                "trialExpiryInDays": null
            } 

            $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/forwarderForm/forwarder-edit.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                // preserveScope: true,
                controllerAs: 'ctrl',
                onComplete : function () {
                    if(vm.forwarderInfo.original_logo) {
                        vm.isOrigLogo = true;
                        vm.fnOrigLogo();
                    }
                },
                onRemoving: function () {
                    for (var name in CKEDITOR.instances) {
                      CKEDITOR.instances[name].destroy();
                    }
                },
                controller: function() { this.parent = vm }
            });
           
        }

        function getNwlsData(fwdData){
            if(fwdData.domain_data.solution_type == 'NWLS' && !vm.nwlsData && vm.util.isFreightbro){
                RoleService.getNwlsData().then(function(response){
                    vm.nwlsData = response.data.data;
                    fwdData.domain_data.mailgun_apikey = vm.nwlsData.mailgun_apikey;
                    fwdData.domain_data.mailgun_domain = vm.nwlsData.mailgun_domain;
                    fwdData.domain_data.mailgun_domain_verified_status = vm.nwlsData.mailgun_domain_verified_status === true ? 'true' : 'false';
                },function(error){
                    $log.log(error);
                    util.showToast(util.displayValidationError(error));
                });
            }
            else if(fwdData.domain_data.solution_type == 'WLS'){
                fwdData.domain_data.mailgun_apikey = vm.forwarderInfoCopy.domain_data.mailgun_apikey;
                fwdData.domain_data.mailgun_domain = vm.forwarderInfoCopy.domain_data.mailgun_domain;
                fwdData.domain_data.mailgun_domain_verified_status = vm.forwarderInfoCopy.domain_data.mailgun_domain_verified_status;
            }
            else{
                fwdData.domain_data.mailgun_apikey = vm.nwlsData.mailgun_apikey;
                fwdData.domain_data.mailgun_domain = vm.nwlsData.mailgun_domain;
                fwdData.domain_data.mailgun_domain_verified_status = vm.nwlsData.mailgun_domain_verified_status === true ? 'true' : 'false';
            }
        }

        function submit_forwarder(shipData, clientsData, button){

            if((shipData.user_data.password !== shipData.user_data.user_confirm_password) && !shipData.updateView){
                vm.pass_Error = true;
                util.showToast('Password do not match.!');
                return false;
            }
            if(shipData.domain_data.mailgun_domain_verified_status == 'false'){
                util.showToast('Please Select mail domain verified status!');
                return false;
            }
            else{

                vm.pass_Error = false;
                shipData.favicon = vm.favicon ? vm.favicon : shipData.favicon;
                shipData.company_logo = vm.company_logo ? vm.company_logo : shipData.company_logo;
                // if(vm.isLogoUpdated){
                    shipData.original_logo = vm.original_logo;
                // }
                
                shipData.date_of_establishment =   $filter('date')(shipData.date_of_establishment, 'yyyy-MM-dd');
                shipData.company_turnover = !shipData.company_turnover ? '' : shipData.company_turnover;
                shipData.number_of_employees = !shipData.number_of_employees ? '' : shipData.number_of_employees;
                shipData.domain_data.send_shipment_booking_confirmation = !shipData.domain_data.send_shipment_booking_confirmation ? null : shipData.domain_data.send_shipment_booking_confirmation
                shipData.iata_commission = !shipData.iata_commission ? '' : shipData.iata_commission;
                shipData.incentive = !shipData.incentive ? '' : shipData.incentive;
                shipData.domain_data.terms_and_condtion = shipData.domain_data.terms_and_condtion == null ? '' : shipData.domain_data.terms_and_condtion;
                shipData.shipment_initial_length = !shipData.shipment_initial_length ? '' : shipData.shipment_initial_length;
                shipData.quote_initial_length = !shipData.quote_initial_length ? '' : shipData.quote_initial_length;
                shipData.domain = shipData.domain.toLowerCase()
                var form = new FormData();
                form.append('data[assignor_company_id]', shipData.assignor_company_id);
                form.append('data[company_name]', shipData.company_name);
                form.append('data[company_address]', (util.encodeValue(shipData.company_address)));
                form.append('data[company_constitution]', (shipData.company_constitution ? shipData.company_constitution : ""));
                form.append('data[company_email]', (shipData.company_email ? shipData.company_email : ""));
                form.append('data[company_phone_number]', (shipData.company_phone_number ? shipData.company_phone_number : ""));
                form.append('data[company_phone_code]', (shipData.company_phone_code ? shipData.company_phone_code : ""));
                form.append('data[company_phone_country]', (shipData.company_phone_country ? shipData.company_phone_country : ""));
                form.append('data[state]', (shipData.state ?  shipData.state : ""));
                form.append('data[country]', (shipData.country ? shipData.country : ""));
                form.append('data[postal_code]', (shipData.postal_code ? shipData.postal_code : ""));
                form.append('data[date_of_establishment]', (shipData.date_of_establishment ? shipData.date_of_establishment : ""));
                form.append('data[number_of_employees]', (shipData.number_of_employees ? shipData.number_of_employees : ""));
                form.append('data[company_turnover]', (shipData.company_turnover ? shipData.company_turnover : ""));
                form.append('data[iata_commission]',  (shipData.iata_commission ? shipData.iata_commission : ""));
                form.append('data[incentive]', (shipData.incentive ? shipData.incentive : ""));
                form.append("data[tnc_fcl]", (util.encodeValue(shipData.tnc_fcl)));
                form.append("data[tnc_lcl]", (util.encodeValue(shipData.tnc_lcl)));
                form.append("data[tnc_air]", (util.encodeValue(shipData.tnc_air)));
                form.append("data[std_tnc_fcl]", (util.encodeValue(shipData.std_tnc_fcl)));
                form.append("data[std_tnc_lcl]", (util.encodeValue(shipData.std_tnc_lcl)));
                form.append("data[std_tnc_air]", (util.encodeValue(shipData.std_tnc_air)));
                angular.forEach(clientsData,function(client, key){
                  for (var i = 0; i < client.length; i++) {
                    var trialExpiry = new Date(client[i].trialExpiry);
                    trialExpiry.setHours('23');
                    trialExpiry.setMinutes('59');
                    trialExpiry = moment(trialExpiry).format("YYYY-MM-DD HH:mm:ss");
                    
                    form.append("data[oauth_client_details]["+key+"][trial_expiry]", trialExpiry);
                    form.append("data[oauth_client_details]["+key+"][limit]", client[i].limit);
                    form.append("data[oauth_client_details]["+key+"][access_token_expiry]", client[i].accessTokenExpiryInMinutes);
                  }
                });
                
                if(shipData.trial_period){
                    form.append("data[trial_period][starts_at]", shipData.trial_period.starts_at);
                    form.append("data[trial_period][ends_at]", shipData.trial_period.ends_at);
                }

                // domain data
                form.append('data[domain]', shipData.domain);
                form.append('data[domain_data][solution_type]', (shipData.domain_data.solution_type));
                form.append('data[domain_data][domain_name]', (shipData.domain));
                form.append('data[domain_data][mailgun_domain_verified_status]', (shipData.domain_data.mailgun_domain_verified_status));
                form.append('data[domain_data][mailgun_domain]', shipData.domain_data.mailgun_domain);
                form.append('data[domain_data][mailgun_apikey]', shipData.domain_data.mailgun_apikey);
                form.append('data[domain_data][common_email]', (shipData.domain_data.common_email ? shipData.domain_data.common_email : ""));
                form.append('data[domain_data][document_submit_required]', (shipData.domain_data.document_submit_required ? shipData.domain_data.document_submit_required : ""));
                form.append('data[domain_data][document_submit_email]', (shipData.domain_data.document_submit_email ? shipData.domain_data.document_submit_email : ""));
                form.append('data[domain_data][shipment_notification_from_specialist]', (shipData.domain_data.shipment_notification_from_specialist));
                form.append('data[domain_data][send_shipment_booking_confirmation]', (shipData.domain_data.send_shipment_booking_confirmation ? shipData.domain_data.send_shipment_booking_confirmation : ""));
                form.append('data[domain_data][reply_to]', (shipData.domain_data.reply_to ? shipData.domain_data.reply_to : ""));
                form.append('favicon', (shipData.favicon ? shipData.favicon : ""));
                form.append('company_logo', (shipData.company_logo ? shipData.company_logo : ""));
                if(vm.isLogoUpdated) {
                    form.append("original_logo", (shipData.original_logo ? shipData.original_logo : ""));
                }

                form.append('data[domain_data][sms_sender_id]', (shipData.domain_data.sms_sender_id ? shipData.domain_data.sms_sender_id : ""));
                form.append('data[domain_data][mail_from_name]', shipData.domain_data.mail_from_name);
                form.append('data[domain_data][frontend_url]', shipData.domain_data.frontend_url);
                form.append('data[domain_data][redirect_base_url]', shipData.domain_data.redirect_base_url);
                form.append('data[domain_data][toll_free_contact]', (shipData.domain_data.toll_free_contact ? shipData.domain_data.toll_free_contact : ""));
                form.append('data[domain_data][shipment_initials]', shipData.domain_data.shipment_initials);
                form.append('data[domain_data][company_website_url]', shipData.domain_data.company_website_url);
                form.append('data[domain_data][company_tracking_url]', shipData.domain_data.company_tracking_url);
                form.append('data[domain_data][quote_initials]', shipData.domain_data.quote_initials);
                form.append('data[domain_data][shared_rate_receivers]', shipData.domain_data.shared_rate_receivers);
                form.append('data[domain_data][no_emails_to_admins_in_cc]', shipData.domain_data.no_emails_to_admins_in_cc);
                form.append('data[domain_data][shipment_cc_emails]', shipData.domain_data.shipment_cc_emails);
                form.append('data[domain_data][terms_and_condtion]', (shipData.domain_data.terms_and_condtion ? shipData.domain_data.terms_and_condtion : ""));
                form.append('data[domain_data][quote_initial_incremental]', shipData.domain_data.quote_initial_incremental);
                form.append('data[domain_data][quote_initial_length]', (shipData.domain_data.quote_initial_length ? shipData.domain_data.quote_initial_length : ""));
                form.append('data[domain_data][shipment_initial_incremental]', shipData.domain_data.shipment_initial_incremental);
                form.append('data[domain_data][shipment_initial_length]', (shipData.domain_data.shipment_initial_length ? shipData.domain_data.shipment_initial_length : ""));
                form.append('data[domain_data][plan_type]', (shipData.domain_data.plan_type ? shipData.domain_data.plan_type : ""));
                form.append('data[domain_data][base_currency]', (shipData.domain_data.base_currency ? shipData.domain_data.base_currency : ""));
                if(shipData.domain_data.app_config)
                {
                    form.append('data[domain_data][app_config][min_version]', shipData.domain_data.app_config.min_version);
                    form.append('data[domain_data][app_config][max_version]', shipData.domain_data.app_config.max_version);
                    form.append('data[domain_data][app_config][android_link]', shipData.domain_data.app_config.android_link);
                    form.append('data[domain_data][app_config][ios_link]', shipData.domain_data.app_config.ios_link);
                }
                if(shipData.domain_data.theme_config)
                {
                    form.append('data[domain_data][theme_config][primary_color]',shipData.domain_data.theme_config.primary_color);
                    form.append('data[domain_data][theme_config][secondary_color]', shipData.domain_data.theme_config.secondary_color);
                    form.append('data[domain_data][theme_config][dark_mode]', shipData.domain_data.theme_config.dark_mode);
                }
                //new keys

                button == 'SUBMIT' ? vm.createForwarder(shipData,form) : vm.updateForwarder(shipData,form) ;

                vm.forwarderBtn = true;
            }
            // shipData.domain_data.common_email = shipData.domain_data.common_email+'@'+shipData.domain_data.mailgun_domain;
            // vm.cancelDialog();

        }

        function createForwarder(shipData,form){
            angular.element('#stepper_submit').attr('disabled','disabled') ;
            vm.isLogoUpdated = true;
            vm.isPreview = true;
            util.isCallingApi = true;
            RoleService.createForwarder(form)
            .then(function(response){
                var resData = angular.fromJson(response);
                //vm.forwarderData.push(resData.data);
                vm.submitAdminUser(shipData.user_data,resData.data.id);
                util.isCallingApi = false;
                vm.dtInstanceCallback.rerender();
                util.showToast('Submitted Successfully!!','top right', 3000);
                vm.forwarderBtn = false;
                vm.cancelDialog();
                vm.nwlsData = '';
                vm.isLogoUpdated = false;
                vm.isPreview = false;
            },function(error){
                util.isCallingApi = false;
                angular.element('#stepper_submit').removeAttr('disabled') ;
                $log.log(error);
                util.showToast(util.displayValidationError(error));
                vm.forwarderBtn = false;
                // vm.isLogoUpdated = false;
                // vm.isPreview = false;
                // vm.cancelDialog();
            });
        };

        function updateForwarder(shipData,form){
            angular.element('#stepper_submit').attr('disabled','disabled') ;
            var forwarder_index = angular.copy(shipData["forwarder_index"]);
            vm.isLogoUpdated = true;
            vm.isPreview = true;
            util.isCallingApi = true;
            RoleService.updateForwarder(form , shipData.id)
            .then(function(response){
                //var resData = angular.fromJson(response);
                //vm.forwarderData[forwarder_index] = resData.company;
                util.isCallingApi = false;
                vm.dtInstanceCallback.rerender();
                util.showToast('Updated Successfully!!','top right', 3000);
                vm.forwarderBtn = false;
                vm.cancelDialog();
                vm.nwlsData = '';
                // angular.element('#stepper_submit').removeAttr('disabled') ;
                if(resData.company.original_logo) {
                    vm.isOrigLogo = true;
                    vm.fnOrigLogo();
                }
                vm.isLogoUpdated = false;
                vm.isPreview = false;
            },function(error){
                util.isCallingApi = false;
                angular.element('#stepper_submit').removeAttr('disabled') ;
                vm.forwarderBtn = false;
                // vm.isLogoUpdated = false;
                // vm.isPreview = false;
                // vm.cancelDialog();
                $log.log(error);
                util.showToast(util.displayValidationError(error));

            });

        };

        function deleteForwarder(id ,delete_index ,ev){

            vm.deleteBtn = false;
            vm.deleteIndex = delete_index;
            vm.deleteId = id;
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm; }
            });

        }

        function fnDeleteData(id){
            vm.deleteBtn = true;
            RoleService.deleteForwarder(vm.deleteId);
            //vm.forwarderData.splice(vm.deleteIndex,1);
            vm.dtInstanceCallback.rerender();
            vm.deleteBtn = false;
            $mdDialog.hide();
        }

        // function getForwarderList(){
        //     RoleService.getForwarder().then(function(response){
        //         vm.forwarderList = response.data;
        //     },function(error){
        //     });
        // }

        function resetImage(){
            angular.element("input[type='file']").val(null);
            vm.favicon = '';
            vm.forwarderInfo.favicon = '';
        }

        // forwarder setting
        function validateEmail(emails,input_name) {
            vm.email_input_name = input_name;
            if(emails.length!=0){
                for (var i = 0; i < emails.length; i++) {
                    
                    if (!vm.util.emailRegex.test(emails[i])) {
                         vm.invalidEmail = true;
                         emails.splice(i, 1);
                    }
                    else {
                         vm.invalidEmail = false;
                    }
                }
            }else{
                vm.invalidEmail = false;
            }

        }

        function getDomainUrl(fwd_data){
            if(fwd_data.domain){
                fwd_data.domain_data.frontend_url = 'https://'+ fwd_data.domain +'/#!/';
                fwd_data.domain_data.redirect_base_url = 'https://'+ fwd_data.domain;
            }
        }

        function submitAdminUser(user_data,id) {
            var data = {
                'data': {
                    'user_type' : 'ADMIN',
                    'user_first_name' : user_data.user_first_name,
                    'user_last_name' : user_data.user_last_name,
                    'email' : user_data.email,
                    'active_status' : !user_data.active_status ? 0 : user_data.active_status,
                    'user_mobile' : user_data.user_mobile,
                    'user_mobile_code' : user_data.user_mobile_code,
                    'user_mobile_country' : user_data.user_mobile_country,
                    'password' : user_data.password,
                    'user_company_id':id
                }
            };
            RoleService.createShipperUser(data).then(function(){
            },function(error){
                $log.log(error);
                util.showToast(util.displayValidationError(error));
            });
        }

        function showPassErr(type){
            document.getElementById('message').style.display = type === 'focus' ? 'block' : 'none';
        }

        function validatePassword(){
            var myInput = document.getElementById('psw');
            var special = document.getElementById('special');
            var number = document.getElementById('number');
            var length = document.getElementById('length');

            // Validate capital letters
            var upperCaseLetters = /[!@#\$%\^&\*]/g;
            if(myInput.value.match(upperCaseLetters)) {
                special.classList.remove('passInvalid');
                special.classList.add('passValid');
            } else {
                special.classList.remove('passValid');
                special.classList.add('passInvalid');
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if(myInput.value.match(numbers)) {
                number.classList.remove('passInvalid');
                number.classList.add('passValid');
            } else {
                number.classList.remove('passValid');
                number.classList.add('passInvalid');
            }

            // Validate length
            if(myInput.value.length >= 8) {
                length.classList.remove('passInvalid');
                length.classList.add('passValid');
            } else {
                length.classList.remove('passValid');
                length.classList.add('passInvalid');
            }
        }

        function togglePassword(input_name){
            if(input_name === 'password'){
                vm.showPassword = vm.showPassword === false ? true : false;
            }
            if(input_name === 'current_password'){
                vm.showCurrentPassword = vm.showCurrentPassword === false ? true : false;
            }
        }

        function terms_condition_key_up(event,className){
          util.getBulletPontOnInput(event,className);
        }
        // Validate secondary color based on contrast color
        function validateSecondaryColor(color,form){
          form.$error.constrastClrErr = false;
          if(!form.primary_color.$invalid){
            var contrastClr = fuseGenerator.getContrast(color,true);
            if(contrastClr==='white'){
              delete form.$error.constrastClrErr;
            }else{
              form.$error.constrastClrErr = true
            }
          }

        }

        // function to show original logo if url present
        function fnOrigLogo() {
            $(document).ready(function(){
                var cropped = document.querySelector('.cropped-img');
                cropped.src = vm.forwarderInfo.company_logo;
                vm.src = vm.forwarderInfo.original_logo;
            });
        }

        // upload logo and validate
        function fnLogoValidation(type, file, ev){
           
            if(type === 'init') {

                // return if file is > 10mb
                if(vm.generalFrm.company_logo && vm.generalFrm.company_logo.$error.maxSize) {
                    return;
                }

                vm.original_logo_copy = file;

                if (ev.target.files.length) {
                    // save file name and type for response
                    vm.origFilename = ev.target.files[0].name;
                    vm.origType = ev.target.files[0].type;
                    // start file reader
                    var reader = new FileReader();
                    vm.original_logo_copy = ev.target.files[0];

                    // on image laod
                    reader.onload = function(ev) {
                        if(ev.target.result){
                            // save src to pass in cropper dialog
                            vm.src = ev.target.result;
                            // save this url for edit option as well
                            vm.srcCopy = angular.copy(vm.src);
                            // set variable value to show rectangle crop box auto-selected                         
                            vm.logoStyle = 'rectangle';
    
                            // show modal
                            $mdDialog.show({
                                templateUrl: 'app/main/settings/dialogs/edit-logo/edit-logo.html',
                                targetEvent: ev,
                                clickOutsideToClose: false,
                                scope: $scope,
                                preserveScope: true,
                                controllerAs: 'ctrl',
                                multiple: true,
                                controller: function () { this.parent = vm; },
                                onComplete : function () {                                  
                                    vm.image = document.getElementById('image');
                                    vm.fnlogoStyleChange(vm.image);
                                }
                            });
                        }
                    };
    
                    // read file
                    reader.readAsDataURL(ev.target.files[0]);
                }
            }
            
            if(type === 'edit') {

                // for old data where logo is updated and original logo is not present
                if(vm.isLogoUpdated) {
                    console.log(vm.original_logo);
                    vm.forwarderInfo.original_logo = vm.original_logo_copy;
                }

                // if original logo is file object
                if(vm.forwarderInfo.original_logo instanceof File) {
                    vm.src = vm.srcCopy;
                    vm.original_logo_copy = vm.forwarderInfo.original_logo;

                    // show modal
                    $mdDialog.show({
                        templateUrl: 'app/main/settings/dialogs/edit-logo/edit-logo.html',
                        targetEvent: ev,
                        clickOutsideToClose: false,
                        scope: $scope,
                        preserveScope: true,
                        controllerAs: 'ctrl',
                        multiple: true,
                        controller: function () { this.parent = vm; },
                        onComplete : function () {
                            
                            vm.image = document.getElementById('image');
                            vm.fnlogoStyleChange(vm.image);
                        }
                    });
                }

                else {

                    // if original logo is https link from api response
                    vm.src = vm.forwarderInfo.original_logo;
                    getImgMeta(vm.forwarderInfo.company_logo);

                    // show modal
                    $mdDialog.show({
                        templateUrl: 'app/main/settings/dialogs/edit-logo/edit-logo.html',
                        targetEvent: ev,
                        clickOutsideToClose: false,
                        scope: $scope,
                        preserveScope: true,
                        controllerAs: 'ctrl',
                        multiple: true,
                        controller: function () { this.parent = vm; },
                        onComplete : function () {                           
                            vm.image = document.getElementById('image');
                            vm.fnlogoStyleChange(vm.image);
                        }
                    });
                }      
            }
        }

        // Get style of image by url
        function getImgMeta(url) {
            var img = new Image();
            img.src = url;
            img.onload = function() { 
                if(this.width === this.height){
                    vm.logoStyle = 'square';
                }else{
                    vm.logoStyle = 'rectangle';
                }
            }
        }

        // rectangle/square select
        function fnlogoStyleChange(img) {

            // select rectangle option
            if(vm.logoStyle === 'rectangle') {
                
                if(vm.cropper){
                    vm.cropper.destroy();
                }
                vm.cropper = new Cropper(img, {
                    minCropBoxWidth : 135,
                    minCropBoxHeight : 45,
                    // cropBoxResizable : false,
                    // cropBoxMovable : false,
                    toggleDragModeOnDblclick : false,
                    center : false,
                    aspectRatio : 3/1,
                });
            }
            else {

                // select square option
                if(vm.cropper){
                    vm.cropper.destroy();
                }      
                vm.cropper = new Cropper(img, {
                    minCropBoxWidth : 45,
                    minCropBoxHeight : 45,
                    // cropBoxResizable : false,
                    // cropBoxMovable : false,
                    toggleDragModeOnDblclick : false,
                    center : false,
                    aspectRatio : 1/1,
                });
            }
        }

        // reset logo on delete and cancel click
        function fnResetLogo(){
            vm.company_logo = null;
            vm.original_logo = null;
            if(vm.cropper) {
                vm.cropper.destroy();
            }  
            vm.isPreview = false;
            vm.isLogoUpdated = false;
            vm.isOrigLogo = false;
        }
        
        // save on click     
        function saveImg(e) {
            e.preventDefault();
            vm.isPreview = true;
            vm.editView = true;
            vm.isLogoUpdated = true;

            // get result to data uri 
            if(vm.logoStyle === 'rectangle') {
                var imgSrc = vm.cropper.getCroppedCanvas({
                    // width : 135,
                    // height: 45,
                    imageSmoothingQuality: 'high',
                    // fillColor: '#ffffff'
                }).toDataURL(vm.origType);

                vm.isLogoRectangle = true;
            }
            else {
                var imgSrc = vm.cropper.getCroppedCanvas({
                    // width : 45,
                    // height: 45,
                    imageSmoothingQuality: 'high',
                    // fillColor: '#ffffff'
                }).toDataURL(vm.origType);

                vm.isLogoRectangle = false;
            }
                    

            if(!vm.original_logo_copy && vm.forwarderInfo.original_logo){
                var imgFile = vm.forwarderInfo.original_logo.split('/');
                vm.origFilename = imgFile[imgFile.length-1];
                vm.origType = 'img/'+imgFile[imgFile.length-1].split('.')[1];
            }
            
           // convert data url to file object for api request
           vm.srcToFile(imgSrc, vm.origFilename, vm.origType).then(function(file){
                vm.company_logo = file;
                vm.original_logo = vm.original_logo_copy ? vm.original_logo_copy : vm.forwarderInfo.original_logo;

                if(vm.original_logo_copy) {
                    vm.isLogoUpdated = true;
                }
                else {
                    vm.isLogoUpdated = false;
                }
            });

            vm.cancelDialog();

            // capture cropped preview box
            var cropped = document.querySelector('.cropped-img');

            // show image cropped
            cropped.src = imgSrc;
        }

        // converting cropper response to file object to pass in api response
        function srcToFile(origLogoSrc, fileName, mimeType){
            return (fetch(origLogoSrc)
                .then(function(res){return res.arrayBuffer();})
                .then(function(buf){return new File([buf], fileName, {type:mimeType});})
            );
        }

        //function to open menu dropdown
        function openMenu($mdMenu,ev){
            ev.stopPropagation();
            $mdMenu.open(ev);
        }

        // replace logo
        function fnReplaceLogo() {
            $('#fileEdit_company_logo').click();
        }

        // cancel dialog
        function cancelDialog(type) {
            if(type === 'close') {
                vm.fnResetLogo();
            }            
            $mdDialog.hide();
        }

        function editDatePicker(forwarder,data){
            if(vm.lastpicker){
                if($filter('date')(vm.lastpicker, 'yyyy-MM-dd')!=$filter('date')(data.dateStart, 'yyyy-MM-dd')){
                    vm.trialErr = 'Changing start date is not allowed!';
                    forwarder.trial_period = {
                        'starts_at' : $filter('date')(vm.lastpicker, 'yyyy-MM-dd'),
                        'ends_at' : $filter('date')(data.dateEnd, 'yyyy-MM-dd')
                    } 
                    
                    vm.pickerModel = {
                        'dateStart' : new Date(vm.pickerModelcopy.starts_at),
                        'dateEnd' : new Date(vm.pickerModelcopy.ends_at),
                        'selectedTemplateName' : $filter('date')(vm.pickerModelcopy.starts_at, 'dd MMM')+'-'+$filter('date')(vm.pickerModelcopy.ends_at, 'dd MMM yyyy')
                    }
                }
                else{
                    vm.trialErr = '';
                    forwarder.trial_period = {
                        'starts_at' : $filter('date')(data.dateStart, 'yyyy-MM-dd'),
                        'ends_at' : $filter('date')(data.dateEnd, 'yyyy-MM-dd')
                    } 
                }
            }
            else{
                vm.setDatePicker(forwarder,data);
            }   
        }

        function setDatePicker(forwarder,data) {
            var today = new Date()
            if($filter('date')(data.dateStart, 'yyyy-MM-dd')<$filter('date')(today, 'yyyy-MM-dd')){
                vm.trialErr = 'Start date can not be the past date.Please select valid date!';
                vm.pickerModel = {};
                forwarder.trial_period = {};
             }
             else{
                vm.trialErr = '';
                forwarder.trial_period = {
                    'starts_at' : $filter('date')(data.dateStart, 'yyyy-MM-dd'),
                    'ends_at' : $filter('date')(data.dateEnd, 'yyyy-MM-dd')
                }  
             }
        }
        // form user api with parameter count,offset,search,type and forwarder id
        function forwardersApiUrl(data, callback, settings){

            var url = api.baseUrl + '/api/forwarder?limit='+ settings._iDisplayLength + '&offset='+ settings._iDisplayStart + '' +util.fnGetForwarderIdApi('?');

            if(data.search.value) {
                url += '&query=' + data.search.value;
            }
            return url;
        }


        //  initialize datatable with server side pgination
        function initForwardersTable(){

            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption('ajax', function (data, callback, settings) {

                var url = vm.forwardersApiUrl(data, callback, settings);  //get url

                $http.get(url).then(function (response) {
                        var res_data = response.data.data;
                        var total_count = response.data.count;
                        var new_res = formatResponse(res_data); //form response with table structure
                        var table_data = {
                            'data': new_res,
                            'recordsTotal': total_count,
                            'recordsFiltered': total_count
                        };
                        vm.forwarderLength = total_count;
                        callback(table_data);
                    },
                    function (error) {
                        util.isCallingApi = false;
                        if(error.status === 422){
                            var table_data = {
                                'data': {},
                                'recordsTotal': 0,
                                'recordsFiltered': 0
                            };
                            vm.forwarderLength = 0;
                            callback(table_data);
                        }
                        $state.go(util.redirectIfError(error));
                    });
                })
                .withDataProp('data')
                .withOption('responsive', true)
                .withOption('serverSide', true)
                .withOption('processing', true)
                .withDisplayLength(10)
                .withPaginationType('simple')
                .withOption('aaSorting', [])
                .withOption('language', {search : "", searchPlaceholder: "Search", lengthMenu: "Show entries _MENU_"})
                .withOption('createdRow', function (row, data, dataIndex) {
                  // Recompiling so we can bind Angular directive to the DT
                  $compile(angular.element(row).contents())($scope);
                });

            vm.getDtColumnsData();    //get dtcolumn data
        }

        //form response with table structure
        function formatResponse(res_data){

            vm.forwarderDetailsTemp = res_data;

            var new_res = [];
                var row_obj = {
                'id':'',
                'company_name' : '',
                'domain': '',
                'company_email' : '',
                'company_phone_number' : '',
                'starts_at' : '',
                'ends_at' : ''
                };

                res_data.forEach(function (row) {
                var new_row = angular.copy(row_obj);
                    new_row.id = row.id;
                    new_row.company_name = row.company_name ? row.company_name : 'N/A';
                    new_row.domain = row.domain ? row.domain : 'N/A';
                    new_row.company_email = row.company_email ? row.company_email : 'NA' ;
                    new_row.company_phone_number = row.company_phone_number ? row.company_phone_number : 'NA' ;
                    new_row.starts_at = row.trial_period ? row.trial_period.starts_at : 'NA' ;
                    new_row.ends_at = row.trial_period ? row.trial_period.ends_at : 'NA' ;
                    new_res.push(new_row);
                });

            return new_res;
        }

        // form dtColumns data for datatables
        function getDtColumnsData(){

            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle('Forwarder Name').withOption('name', 'company_name').renderWith(function (data) {
                 
                    return '<td ng-non-bindable>'+ $sanitize(data.company_name) +'</td>' }).notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Domain').renderWith(function (data) {
                   
                    return '<td ng-non-bindable>'+  $sanitize(data.domain) +'</td>' }).withOption('name', 'domain').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Email').renderWith(function (data) {

                    return '<td ng-non-bindable>'+  $sanitize(data.company_email) +'</td>' }).withOption('name', 'company_email').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Phone Number').renderWith(function (data) {

                    return '<td ng-non-bindable>'+  $sanitize(data.company_phone_number) +'</td>' }).withOption('name', 'company_phone_number').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data) {

                    return '<td ng-non-bindable>'+  $sanitize(data.starts_at) +'</td>' }).withOption('name', 'starts_at').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data) {

                    return '<td ng-non-bindable>'+  $sanitize(data.ends_at) +'</td>' }).withOption('name', 'ends_at').notSortable(),
            ];

            vm.dtColumns.push(DTColumnBuilder.newColumn(null).withClass('all').withTitle('Actions')
            .renderWith(function (data, type, full, meta) {
            return '<span>' +
            '<md-icon ng-if="vm.util.navPermission.forwarders[2]" md-svg-src="assets/icons/custom/edit-icon.svg" class="s12 cursor" ng-click="vm.viewForwarder(\''+meta.row+'\',$event)"></md-icon>';
            }).notSortable());
           
            vm.dtInstanceCallback = {};
        }

        //Oauth client generate
        function fnClientGenerate(formData,ev){
            RoleService.createClients(JSON.stringify([formData]))
            .then(function(response){
                vm.client = response;
                $mdDialog.show({
                    templateUrl: 'app/main/roles/dialogs/forwarderForm/client-generate-success.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    scope: $scope,
                    preserveScope: true,
                    multiple: true,
                    controllerAs: 'ctrl',
                    controller: function () { this.parent = vm }
                });
                $timeout(function ()
                {
                    var clinetObj = {   
                        apiKey: response[0].apiKey,
                        clientId: response[0].clientId,
                        clientName: response[0].clientName,
                        clientSecret:response[0].clientSecret,
                        environment: response[0].environment,
                        limit: response[0].limit,
                        trialExpiry: response[0].trialExpiry,
                        accessTokenExpiryInMinutes: vm.oauthGenerate.accessTokenExpiryInMinutes,
                        domain: vm.oauthGenerate.domain,
                        enabled: vm.oauthGenerate.enabled,
                        password: vm.oauthGenerate.password,
                        personal: vm.oauthGenerate.false,
                        redirect: vm.oauthGenerate.redirect
                    }
                    vm.clientsObj[response[0].environment].push(clinetObj); 
                }, 500);
                
            },function(error){
                $log.log(error);
                util.showToast(util.displayValidationError(error.responseJSON.message));
            });
        }

        function getClients(domain){
            RoleService.getClients(domain)
            .then(function(response){
                angular.forEach(response.data,function(item){
                    vm.clientsObj[item.environment].push(item);
                });
            },function(error){
                $log.log(error);
                util.showToast(util.displayValidationError(error.responseJSON.message));
                vm.clientsObj = null;
            });
        }

        function fnEnableDisableApi(client){
            var clientObj = {
                "clientId" : client.clientId,
                "formData" : {"enabled": client.enabled}
            }
            RoleService.enableDisableApi(clientObj)
            .then(function(response){
                util.showToast(response.message);
            },function(error){
                $log.log(error);
                util.showToast(util.displayValidationError(error.responseJSON.message));
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.forwarderOffices', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.forwarderOffices', {
                url    : '/forwarder-offices',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/roles/forwarder-offices/forwarder-offices.html',
                        controller : 'ForwarderOfficesController as vm'
                    }
                },
                bodyClass: 'forwarder-offices-page'
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.forwarderOffices')
        .controller('ForwarderOfficesController', ForwarderOfficesController);

    /** @ngInject */
    function ForwarderOfficesController(RoleService, util, $mdDialog, $log, $rootScope, $scope, $timeout, localStorageService)
    {
        var vm = this;
        var maxDepth = 2;
        var searchDebounce = null;

        vm.util = util;
        vm.util.screenTitle = 'Forwarder Offices';
        vm.permission = util.navPermission.forwarderOffices || [0, 0, 0, 0];
        vm.officeList = [];
        vm.visibleOffices = [];
        vm.expanded = {};
        vm.selectedOffice = null;
        vm.searchText = '';
        vm.isDataLoading = false;
        vm.hasLoadedOnce = false;
        vm.submit_disabled = false;
        vm.deleteInProgress = false;
        vm.isGodLogin = util.isFreightbro;
        vm.pageSize = 10;
        vm.pageIndex = 0;
        vm.totalRoots = 0;

        vm.init = init;
        vm.loadOffices = loadOffices;
        vm.refreshTree = refreshTree;
        vm.selectOffice = selectOffice;
        vm.toggleOffice = toggleOffice;
        vm.isSelected = isSelected;
        vm.getOfficeId = getOfficeId;
        vm.getOfficeName = getOfficeName;
        vm.getOfficeDomain = getOfficeDomain;
        vm.getOfficeDomainSubscriberId = getOfficeDomainSubscriberId;
        vm.getParentId = getParentId;
        vm.getChildren = getChildren;
        vm.getParent = getParent;
        vm.getDepth = getDepth;
        vm.openAddRoot = openAddRoot;
        vm.openAddChild = openAddChild;
        vm.openEdit = openEdit;
        vm.searchForwarderOfficeResults = searchForwarderOfficeResults;
        vm.selectForwarderOfficeResult = selectForwarderOfficeResult;
        vm.clearOfficeDomainValidation = clearOfficeDomainValidation;
        vm.submitOffice = submitOffice;
        vm.confirmDelete = confirmDelete;
        vm.cancelDialog = cancelDialog;
        vm.onSearchChange = onSearchChange;
        vm.triggerSearchNow = triggerSearchNow;
        vm.hasActiveSearch = hasActiveSearch;
        vm.clearSearch = clearSearch;
        vm.totalPages = totalPages;
        vm.rangeStart = rangeStart;
        vm.rangeEnd = rangeEnd;
        vm.canPrev = canPrev;
        vm.canNext = canNext;
        vm.prevPage = prevPage;
        vm.nextPage = nextPage;

        init();

        $scope.$on('app.forwarderOffices', function () {
            vm.selectedOffice = null;
            init();
        });

        function init()
        {
            util.isModulePaid('forwarderOffices');
            if (util.isFreightbro && localStorageService.get('forwarder') && localStorageService.get('forwarder').value) {
                $rootScope.forwarder_id = localStorageService.get('forwarder').value.id;
            }
            loadOffices();
        }

        function loadOffices()
        {
            vm.isDataLoading = true;
            RoleService.getForwarderOffices({
                search: vm.searchText,
                limit: vm.pageSize,
                offset: vm.pageIndex * vm.pageSize
            }).then(function (response) {
                var responseData = response.data ? response.data.data : {};
                vm.officeList = normalizeOfficeList(responseData);
                vm.totalRoots = (responseData && typeof responseData.count === 'number')
                    ? responseData.count
                    : countRoots(vm.officeList);

                if (!vm.officeList.length && vm.pageIndex > 0) {
                    vm.pageIndex = Math.max(0, vm.pageIndex - 1);
                    vm.isDataLoading = false;
                    loadOffices();
                    return;
                }

                if (vm.selectedOffice && !findOfficeById(getOfficeId(vm.selectedOffice))) {
                    vm.selectedOffice = null;
                }
                if (vm.officeList.length && !vm.selectedOffice) {
                    selectOffice(vm.officeList[0]);
                }
                refreshTree();
                vm.isDataLoading = false;
                vm.hasLoadedOnce = true;
            }, function (error) {
                vm.officeList = [];
                vm.visibleOffices = [];
                vm.selectedOffice = null;
                vm.totalRoots = 0;
                vm.isDataLoading = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        }

        function countRoots(list)
        {
            var n = 0;
            for (var i = 0; i < list.length; i++) {
                if (!getParentId(list[i])) {
                    n += 1;
                }
            }
            return n;
        }

        function normalizeOfficeList(responseData)
        {
            if (angular.isArray(responseData)) {
                return responseData;
            }
            if (responseData && angular.isArray(responseData.forwarderOffices)) {
                return responseData.forwarderOffices;
            }
            if (responseData && angular.isArray(responseData.data)) {
                return responseData.data;
            }
            return [];
        }

        function refreshTree()
        {
            var roots = vm.officeList.filter(function (office) {
                return !getParentId(office);
            });
            vm.visibleOffices = [];
            angular.forEach(roots, function (office) {
                appendVisibleOffice(office, 0);
            });
        }

        function appendVisibleOffice(office, depth)
        {
            var children = getChildren(getOfficeId(office));
            var query = (vm.searchText || '').toLowerCase();

            vm.visibleOffices.push({
                office: office,
                depth: depth,
                hasChildren: children.length > 0
            });

            if (children.length && (vm.expanded[getOfficeId(office)] || query)) {
                angular.forEach(children, function (child) {
                    appendVisibleOffice(child, depth + 1);
                });
            }
        }

        function selectOffice(office)
        {
            vm.selectedOffice = office;
            if (office) {
                vm.expanded[getOfficeId(office)] = true;
                expandAncestors(office);
                refreshTree();
            }
        }

        function expandAncestors(office)
        {
            var parent = getParent(office);
            while (parent) {
                vm.expanded[getOfficeId(parent)] = true;
                parent = getParent(parent);
            }
        }

        function toggleOffice(office, event)
        {
            if (!getChildren(getOfficeId(office)).length) {
                return;
            }
            if (event) {
                event.stopPropagation();
            }
            var officeId = getOfficeId(office);
            vm.expanded[officeId] = !vm.expanded[officeId];
            refreshTree();
        }

        function isSelected(office)
        {
            return vm.selectedOffice && getOfficeId(vm.selectedOffice) === getOfficeId(office);
        }

        function getOfficeId(office)
        {
            return office ? (office.id || office._id) : null;
        }

        function getOfficeName(office)
        {
            return office ? (office.companyName || office.name || office.officeName || office.company_name || '') : '';
        }

        function getOfficeDomain(office)
        {
            return office ? (office.officeDomain || office.domain || '') : '';
        }

        function getOfficeDomainSubscriberId(office)
        {
            return office ? (office.domainSubscriberId || office.vendorId || office.vendor_id || '') : '';
        }

        function getParentId(office)
        {
            return office ? (office.parentCompanyId || office.parentId || office.parent_id || null) : null;
        }

        function getChildren(officeId)
        {
            return vm.officeList.filter(function (office) {
                return getParentId(office) === officeId;
            });
        }

        function getParent(office)
        {
            var parentId = getParentId(office);
            return parentId ? findOfficeById(parentId) : null;
        }

        function findOfficeById(officeId)
        {
            for (var i = 0; i < vm.officeList.length; i++) {
                if (getOfficeId(vm.officeList[i]) === officeId) {
                    return vm.officeList[i];
                }
            }
            return null;
        }

        function getDepth(office)
        {
            var depth = 0;
            var parent = getParent(office);
            while (parent) {
                depth += 1;
                parent = getParent(parent);
            }
            return depth;
        }

        function openAddRoot(ev)
        {
            openOfficeDialog('Add', null, ev);
        }

        function openAddChild(parentOffice, ev)
        {
            if (getDepth(parentOffice) >= maxDepth) {
                util.showToast('Max depth reached');
                return;
            }
            openOfficeDialog('Add', parentOffice, ev);
        }

        function openEdit(office, ev)
        {
            openOfficeDialog('Update', office, ev);
        }

        function openOfficeDialog(buttonName, office, ev)
        {
            var parentOffice = buttonName === 'Add' ? office : getParent(office);
            vm.button_name = buttonName;
            vm.officeForm = {
                id: buttonName === 'Update' ? getOfficeId(office) : null,
                domain: buttonName === 'Update' ? getOfficeDomain(office) : '',
                parentId: parentOffice ? getOfficeId(parentOffice) : null,
                parentName: parentOffice ? getOfficeName(parentOffice) : '',
                parentDomain: parentOffice ? getOfficeDomain(parentOffice) : '',
                selectedOffice: null
            };
            vm.officeValidation = {};

            $mdDialog.show({
                templateUrl: 'app/main/roles/forwarder-offices/forwarder-office-form.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                escapeToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        function searchForwarderOfficeResults(searchText)
        {
            if (!vm.isGodLogin || !searchText || searchText.length < 1) {
                return [];
            }

            return RoleService.searchForwarderOffices(searchText).then(function (response) {
                return normalizeSearchResults(response.data ? response.data.data : []);
            }, function (error) {
                $log.error(error);
                return [];
            });
        }

        function normalizeSearchResults(responseData)
        {
            if (angular.isArray(responseData)) {
                return responseData;
            }
            if (responseData && angular.isArray(responseData.data)) {
                return responseData.data;
            }
            return [];
        }

        function selectForwarderOfficeResult(selectedOffice)
        {
            if (!selectedOffice) {
                return;
            }

            vm.officeForm.domain = selectedOffice.domain;
            clearOfficeDomainValidation();
        }

        function clearOfficeDomainValidation()
        {
            vm.officeValidation.domain = false;
            vm.officeValidation.duplicateDomain = false;
        }

        function submitOffice()
        {
            if (!validateOfficeForm()) {
                return;
            }

            var payload = {
                domain: vm.officeForm.domain
            };

            if (vm.officeForm.parentDomain) {
                payload.parentDomain = vm.officeForm.parentDomain;
            }

            vm.submit_disabled = true;
            var request = vm.officeForm.id ?
                RoleService.updateForwarderOffice(payload) :
                RoleService.createForwarderOffice(payload);

            request.then(function () {
                vm.submit_disabled = false;
                util.showToast('Forwarder Office ' + (vm.officeForm.id ? 'updated' : 'created') + ' successfully');
                cancelDialog();
                loadOffices();
            }, function (error) {
                vm.submit_disabled = false;
                handleOfficeFormError(error);
                $log.error(error);
            });
        }

        function handleOfficeFormError(error)
        {
            var status = error && error.status;
            var message = extractServerMessage(error);

            if (status === 409 && /already exists/i.test(message || '')) {
                vm.officeValidation.duplicateDomain = true;
                return;
            }

            util.showToast(message || util.displayValidationError(error) || 'Something went wrong. Please try again.');
        }

        function extractServerMessage(error)
        {
            if (!error || !error.data) {
                return '';
            }
            if (typeof error.data.message === 'string' && error.data.message) {
                return error.data.message;
            }
            if (error.data.data && typeof error.data.data.message === 'string') {
                return error.data.data.message;
            }
            return '';
        }

        function validateOfficeForm()
        {
            vm.officeValidation = {};
            if (!vm.officeForm.domain) {
                vm.officeValidation.domain = true;
            }
            return !vm.officeValidation.domain;
        }

        function confirmDelete(office, ev)
        {
            var childCount = getChildren(getOfficeId(office)).length;
            var isRoot = !getParent(office);
            var message = 'This action cannot be undone.';
            if (isRoot && childCount) {
                message = 'This will also delete ' + childCount + ' child office' + (childCount === 1 ? '' : 's') + '. This action cannot be undone.';
            }

            var confirm = $mdDialog.confirm()
                .title('Delete ' + getOfficeName(office) + '?')
                .textContent(message)
                .ariaLabel('Delete Forwarder Office')
                .targetEvent(ev)
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                vm.deleteInProgress = true;
                RoleService.deleteForwarderOffice(getOfficeDomain(office)).then(function () {
                    util.showToast('Forwarder Office deleted successfully');
                    if (isSelected(office)) {
                        vm.selectedOffice = null;
                    }
                    vm.deleteInProgress = false;
                    loadOffices();
                }, function (error) {
                    vm.deleteInProgress = false;
                    util.showToast(util.displayValidationError(error));
                    $log.error(error);
                });
            });
        }

        function cancelDialog()
        {
            $mdDialog.cancel();
        }

        function onSearchChange()
        {
            vm.pageIndex = 0;
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
            }
            searchDebounce = $timeout(function () {
                searchDebounce = null;
                loadOffices();
            }, 300);
        }

        function triggerSearchNow()
        {
            vm.pageIndex = 0;
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
                searchDebounce = null;
            }
            loadOffices();
        }

        function hasActiveSearch()
        {
            return !!(vm.searchText && vm.searchText.length);
        }

        function clearSearch()
        {
            vm.searchText = '';
            vm.pageIndex = 0;
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
                searchDebounce = null;
            }
            loadOffices();
        }

        function totalPages()
        {
            return Math.max(1, Math.ceil(vm.totalRoots / vm.pageSize));
        }

        function rangeStart()
        {
            return vm.totalRoots ? vm.pageIndex * vm.pageSize + 1 : 0;
        }

        function rangeEnd()
        {
            return Math.min(vm.totalRoots, (vm.pageIndex + 1) * vm.pageSize);
        }

        function canPrev()
        {
            return vm.pageIndex > 0;
        }

        function canNext()
        {
            return vm.pageIndex + 1 < totalPages();
        }

        function prevPage()
        {
            if (canPrev()) {
                vm.pageIndex -= 1;
                loadOffices();
            }
        }

        function nextPage()
        {
            if (canNext()) {
                vm.pageIndex += 1;
                loadOffices();
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.charges', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.charges', {
                url    : '/charges',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/roles/charges/charges.html',
                        controller : 'ChargesController as vm'
                    }
                },
                bodyClass: 'charges-page'
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.charges')
        .controller('ChargesController', ChargesController);

    /** @ngInject */
    function ChargesController($mdSidenav,util,$mdDialog,RoleService, DTOptionsBuilder, DTColumnBuilder,$compile,$scope,$rootScope,$log,$rootElement,$sanitize,$filter, $state){
    var vm=this;
    vm.util=util
    vm.resizeScreenSize=resizeScreenSize;
    vm.toggleSidenav=toggleSidenav;
    vm.create_charge_popup=create_charge_popup;
    vm.create_charge=create_charge;
    vm.update_charge=update_charge;
    vm.cancelDialog=cancelDialog;
    vm.submitCharge=submitCharge;
    vm.fnCreatedSortBy=fnCreatedSortBy;
    vm.getDtColumnsData=getDtColumnsData;
    vm.initChargeTable=initChargeTable;
    vm.formChargeApiUrl=formChargeApiUrl;
    vm.chargeLength=null;
    vm.formatResponse=formatResponse;
    vm.calculateMaxHeight=calculateMaxHeight;
    vm.chargeDetailsTemp = [];
    vm.fnDeletetData=fnDeletetData;
    vm.getFilterList=getFilterList;
    vm.clearFilter=clearFilter;
    vm.callBackChargeSearch=callBackChargeSearch;
    vm.trackEvent = trackEvent;
    vm.generateChargeCode = generateChargeCode;
    vm.setChargeTypeFilter = setChargeTypeFilter;
    vm.setCalculationTypeFilter = setCalculationTypeFilter;
    vm.setDefaultBasisFilter = setDefaultBasisFilter;
    vm.setModeFilter = setModeFilter;
    vm.setStatusFilter = setStatusFilter;
    vm.formatUserName = formatUserName;
    vm.loadBasisOptions = loadBasisOptions;
    vm.loadFormBasisOptions = loadFormBasisOptions;
    vm.onModeChange = onModeChange;
    vm.dtOptions = {
        dom       : '<"top"lf>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        autoWidth : false,
        responsive: true,
        lengthMenu  : [5, 10, 20, 30, 50, 100],
        pageLength  : 5
    };


    vm.viewCharge=viewCharge;
    vm.deleteCharge=deleteCharge;
    vm.validationErrorName="";
    vm.codeEditMode = false;
    vm.enableCodeEdit = enableCodeEdit;
    vm.disableCodeEdit = disableCodeEdit;
    
    // Initialize filter selections
    vm.selectedChargeType = null;
    vm.selectedCalculationType = null;
    vm.selectedDefaultBasis = null;
    vm.selectedMode = null;
    vm.selectedStatus = null;

    //charge form structure 
    vm.chargeInfo = {
        'name':null,
        'code':null,
        'descriptionShort':null,
        'description':null,
        'isFreightRate':false,
        'chargeType':null,
        'isHazardous':false,
        'defaultCalculationType':'SUBJECT-TO',
        'defaultBasis':null,
        'mode':'FCL',
        'allowedLegs':['L1','L2','L2CHA','L3','L4','L4CHA','L5','L3TAO','L3TAD','L2IHO','L4IHD','L6'],
        'defaultLeg':'L6',
        'replacesCodes':null,
        'internalRemarks':null,
        'status':'ACTIVE',
        'isActive':true,
        'isGlobal':false,
        'domain':null,
        'domainSubscriberId':null,
        "updateView" : false,
        "viewCharge" : false,
        "form_heading" : "",
        "button_type" : ""
    }
    vm.filterobj={
        "charge_type_options": [
          {value: 'SURCHARGE', label: 'Surcharge'},
          {value: 'LOCAL-CHARGE', label: 'Local Charge'},
          {value: 'CUSTOMS', label: 'Customs'},
          {value: 'GRI', label: 'GRI'},
          {value: 'MARKUP', label: 'Markup'},
          {value: 'REBATE', label: 'Rebate'}
        ],
        "calculation_type_options": [
          {value: 'NOT-APPLICABLE', label: 'Not Applicable'},
          {value: 'INCLUDED', label: 'Included'},
          {value: 'SUBJECT-TO', label: 'Subject To'},
          {value: 'CONDITIONAL', label: 'Conditional'},
          {value: 'ON-REQUEST', label: 'On Request'}
        ],
        "default_basis_options": [], // Will be populated dynamically based on mode
        "mode_options": [
          {value: 'FCL', label: 'FCL'},
          {value: 'LCL', label: 'LCL'}
        ]
    };

    // Separate basis options for form dropdown to prevent interference with filter
    vm.formBasisOptions = [];

    vm.chargefilterdata= {
        'deviceName' : '',
        'chargeSelected' : [],
        'isResetFilter' : false,
      };
    
    vm.chargeFilterConditions = {
        'listLoader':false,
        'selectedOptions': vm.chargefilterdata.chargeSelected,
        'placeholder': 'Search Charge',
        'isGroupOptions' : false,
        'groupList' :  {groupTitle:'Charges',keyTitle:'code',subKeyTitle:'descriptionShort'},
        'selectedCount' : 0
      };

    vm.filterListObject = {
        "charge_details": null,
        "charge_type": null,
        "calculation_type": null,
        "default_basis": null,
        "mode": null,
        "status": null,
        "sort_by":'createdAt',
        "sort_by_type":'DESC'
      };
      vm.defaultfilterList=angular.copy(vm.filterListObject);

      var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
        calculateMaxHeight();
    });
    $scope.$on('$destroy', bannerListener);

    function init(){
        vm.util.isModulePaid('charges')
        vm.initChargeTable();  //initialize charge table
        vm.resizeScreenSize();
        vm.getFilterList();//get charge filter list
        
        // Load basis options for default mode (FCL)
        // vm.loadBasisOptions(vm.selectedMode || 'FCL');
        vm.loadBasisOptions('FCL'); // Load FCL basis by default for form
    }
    init();

    $rootScope.$on('app.charges', function(event, args) {
      init();
    });

    function toggleSidenav(sidenavId) {
        $mdSidenav(sidenavId).toggle();
    }
   
    function initChargeTable(){
        vm.dtOptions = DTOptionsBuilder.newOptions()
              .withOption('ajax', function (data, callback, settings) {
              var url = vm.formChargeApiUrl(data, callback, settings);  //get url
              RoleService.getChargesList(url).then(function (response) {
                var responseData = response.data.data || response.data;
                vm.chargeData = responseData.data || responseData;
                var new_res = formatResponse(vm.chargeData); //form response with table structure
                var table_data = {
                    'data': new_res,
                    'recordsTotal': responseData.count || vm.chargeData.length,
                    'recordsFiltered': responseData.count || vm.chargeData.length
                };
                vm.chargeLength = responseData.count || vm.chargeData.length;
                callback(table_data);
                calculateMaxHeight();
                vm.dtOptions.lengthChange= vm.chargeLength>0 ?true : false;
                },
                function (error) {
                  vm.dtOptions.lengthChange= vm.chargeLength>0 ?true : false;
                util.showToast(error.message, 'top right', 3000);
                calculateMaxHeight();
                });
            })
            .withDataProp('data')
            .withOption('responsive', true)
            .withOption('serverSide', true)
            .withOption('processing', true)
            .withDisplayLength(10)
            .withPaginationType('simple')
            .withOption('aaSorting', [])
            .withOption('lengthChange',false)
            .withOption('language', { lengthMenu: "Show entries _MENU_"})
            .withOption('createdRow', function (row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });

        vm.getDtColumnsData();  //get dtcolumn data
      }

      //view/update charge
      function viewCharge(charge,from_heading, update_index, ev){

        vm.codeEditMode = false;
        vm.validationObj={
            "chargeNameValidation" :false,
            "chargeTypeValidation":false,
            "defaultCalculationTypeValidation":false,
            "defaultBasisValidation":false,
            "modeValidation":false,
            "sameNameValidation":false,
            "codeValidation":false,
            }       
         var selectedCharge = vm.chargeDetailsTemp.find(function (i) {
            return i.id == charge || i.id === charge;
         });
         if(!selectedCharge) {
           util.showToast('Charge not found: ' + charge, 'top right', 3000);
           return;
         }

         vm.selectedChargeName = selectedCharge.code;
         util.callMixpanel('Charge-'+from_heading+'Charge-Click',{'Charge Name':vm.selectedChargeName});
        try{
            vm.chargeInfo = {
                'name':selectedCharge.descriptionShort || selectedCharge.name,
                'code':selectedCharge.code,
                'id':selectedCharge.id,
                'chargeType':selectedCharge.chargeType,
                'defaultCalculationType':selectedCharge.defaultCalculationType,
                'defaultBasis':selectedCharge.defaultBasis,
                'mode':selectedCharge.mode,
                'descriptionShort':selectedCharge.descriptionShort,
                'description':selectedCharge.description,
                'isActive':selectedCharge.status === 'ACTIVE',
                'isGlobal':selectedCharge.isGlobal || false,
                'domain':selectedCharge.domain || '',
                'domainSubscriberId':selectedCharge.domainSubscriberId || '',
                "updateView" : from_heading == 'Edit' ? true : false,
                "viewCharge" : from_heading == 'Edit' ? false : true,
                "form_heading" : from_heading,
                "button_type" : "Update",
            }
            
            // Load basis options for the selected charge's mode
            vm.loadFormBasisOptions(selectedCharge.mode);
            
            $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/chargeForm/chargeForm.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }
       catch (error) {
        $log.log(error);
        }
      }

      function deleteCharge(id, delete_index, ev){
        
        var deletedCharge = vm.chargeDetailsTemp.find(function (i) {
          return i.id == id || i.id === id;
       });
        if(!deletedCharge) {
          util.showToast('Charge not found: ' + id, 'top right', 3000);
          return;
        }
        vm.deletedChargeName = deletedCharge.code;
        util.callMixpanel("Charge-DeleteCharge-Click",{'Charge Name': vm.deletedChargeName});
        vm.deleteId = id;
        vm.deleteIndex = delete_index;
        vm.deleteBtn = false;
        vm.pageSource='charge'

        $mdDialog.show({
            template: '<md-dialog id="delete-popup" class="popup-xs"><delete-popup card-id="" card-index="" deletion-source="vm.pageSource" callback="ctrl.parent.fnDeletetData()"></delete-popup></md-dialog>',
            clickOutsideToClose: true,
            parent: $rootElement,
            scope: $scope,
            controllerAs: 'ctrl',
            preserveScope: true,
            controller: function () { this.parent = vm },
          });
       
      }
      //deleting charge from the list
      function fnDeletetData(){
        vm.deleteBtn = true;
        RoleService.deleteCharge(vm.deleteId).then(function(response){
          util.callMixpanel("Charge-DeleteCharge-Proceed",{'Charge Name':vm.deletedChargeName});
            vm.dtInstanceCallback.rerender(); //Refersh user table with latest data

            util.showToast('Charge deleted successfully.');
            vm.deleteBtn = false;
            $mdDialog.hide();

         },function(error){
            vm.deleteBtn = false;
            $log.log(error);
            util.showToast(util.displayValidationError(error));
         });
      }

    function enableCodeEdit() {
        if (!vm.chargeInfo.viewCharge && !vm.chargeInfo.updateView) {
            vm.codeEditMode = true;
            setTimeout(function() {
                document.getElementById('charge_code').focus();
            }, 100);
        }
    }

    function disableCodeEdit() {
        vm.codeEditMode = false;
    }

      function formChargeApiUrl(data, callback, settings){
        var url ='limit='+ settings._iDisplayLength + '&skip='+ settings._iDisplayStart;
        
        // Add mode parameter (default to FCL if not set)
        // var mode = vm.selectedMode || 'FCL';
        // url += '&mode=' + encodeURIComponent(mode);
        if(vm.selectedMode) {
          url += '&mode=' + encodeURIComponent(vm.selectedMode);
        }
        
        // Add filter parameters - use selected values
        if(vm.selectedChargeType) {
          url += '&chargeType=' + encodeURIComponent(vm.selectedChargeType);
        }
        if(vm.selectedCalculationType) {
          url += '&defaultCalculationType=' + encodeURIComponent(vm.selectedCalculationType);
        }
        if(vm.selectedDefaultBasis) {
          url += '&defaultBasis=' + encodeURIComponent(vm.selectedDefaultBasis);
        }
        
        if(vm.selectedStatus) {
          url += '&status=' + encodeURIComponent(vm.selectedStatus);
        }
        
        //adding query source and value to url
        angular.forEach(vm.filterListObject,function(value,key){
          if(value && angular.isArray(value)){
            angular.forEach(value,function(value1,key1){
              if(value1 && value1.query_source){
                   url += '&'+value1.query_source+'='+encodeURIComponent(value1.query_value);
                 }
            });
          }
        });
        
        url +='&sortBy='+encodeURIComponent(vm.filterListObject.sort_by)+'&sortByType='+encodeURIComponent(vm.filterListObject.sort_by_type);
        return url;
      }

      function getFilterList(queryParam){
        var url = '';
        if(queryParam && queryParam.query) {
          url = 'query=' + encodeURIComponent(queryParam.query);
        }
        RoleService.getChargesList(url)
        .then(function(response){
          var responseData = response.data.data || response.data;
          vm.filterobj.charge_name = responseData.data || responseData || []; 
             vm.filterLoader = false;
             vm.chargeFilterConditions.filterLoader = false;
        }, function (error) {
            vm.chargefilterdata.isResetFilter=false;
            vm.filterLoader = false;
            vm.chargeFilterConditions.filterLoader = false;
            util.showToast(util.displayValidationError(error));
            $log.error(error);
        })
      }

      //clear all filter
      function clearFilter(){
        util.callMixpanel("Charge-Filter-ClearAll-Click")
        vm.chargeFilterConditions.selectedOptions = [];
        vm.filterListObject = angular.copy(vm.defaultfilterList);
        vm.chargefilterdata.isResetFilter = true;
        // Reset dropdown filters
        vm.selectedChargeType = null;
        vm.selectedCalculationType = null;
        vm.selectedDefaultBasis = null;
        // vm.selectedMode = 'FCL'; // Reset to default FCL
        vm.selectedMode = null; 
        vm.selectedStatus = null;
        vm.dtInstanceCallback.rerender();
        vm.getFilterList();
      }

      //charge filter search
      function callBackChargeSearch(payload){
        util.callMixpanel("Charge-Filter-ChargeName-Change",{"Value": payload.selectedOptions ,"SearchQuery":payload.searchText? payload.searchText :''})
        if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query' : payload.searchText} : null;
            vm.chargeFilterConditions.filterLoader = true;
            vm.getFilterList(queryParam);
            
            // Add search query to filterListObject for API call
            if(payload.searchText && payload.searchText !== '') {
              if(!vm.filterListObject.charge_details) {
                vm.filterListObject.charge_details = [];
              }
              // Remove existing query filter
              vm.filterListObject.charge_details = vm.filterListObject.charge_details.filter(function(item) {
                return item.query_source !== 'query';
              });
              // Add new query filter
              vm.filterListObject.charge_details.push({
                query_source: 'query',
                query_value: payload.searchText
              });
            } else {
              // Remove query filter if search is empty
              if(vm.filterListObject.charge_details) {
                vm.filterListObject.charge_details = vm.filterListObject.charge_details.filter(function(item) {
                  return item.query_source !== 'query';
                });
                if(vm.filterListObject.charge_details.length === 0) {
                  vm.filterListObject.charge_details = null;
                }
              }
            }
        }

        if(payload.selectedOptions){ // selected options
          var chargeData="";
          if(payload.selectedOptions && payload.selectedOptions.length > 0){
            var request={
              query_source:'',
              query_value:''
            }
            request.query_source='ids';
            vm.chargefilterdata.chargeSelected = payload.selectedOptions;
            angular.forEach(payload.selectedOptions,function(item,key){
              if(key === 0){ 
                if(!vm.filterListObject.charge_details) {
                  vm.filterListObject.charge_details = [];
                }
                // Remove existing ids filter
                vm.filterListObject.charge_details = vm.filterListObject.charge_details.filter(function(item) {
                  return item.query_source !== 'ids';
                });
             } 
             if(key==((payload.selectedOptions.length-1))){
              chargeData+=item.id;
             }
             else{
              chargeData+=item.id+',';
             }
            
            });
            request.query_value=chargeData
            vm.filterListObject.charge_details.push(request);

           
          }else{
            if(vm.filterListObject.charge_details) {
              vm.filterListObject.charge_details = vm.filterListObject.charge_details.filter(function(item) {
                return item.query_source !== 'ids' && item.query_source !== 'query';
              });
              if(vm.filterListObject.charge_details.length === 0) {
                vm.filterListObject.charge_details = null;
              }
            }
          }
          vm.dtInstanceCallback.rerender();
        }
      }

    function calculateMaxHeight(){
        vm.maxFilterHeight = vm.util.getModuleMaxHeight(vm.maxFilterHeight,'filter',0);
    }

    //response format for table data
    function formatResponse(res_data){
        vm.chargeDetailsTemp = res_data;

        var new_res = [];
        var row_obj = {
        'id': '',
        'code': '',
        'descriptionShort' : '',
        'description': '',
        'chargeType':'',
        'defaultCalculationType': '',
        'defaultBasis': '',
        'mode': '',
        'replacesCodes': '',
        'internalRemarks': '',
        'status': '',
        'isGlobal': false,
        'domain': '',
        'domainSubscriberId': '',
        'createdAt': '',
        'createdBy': '',
        'updatedAt': '',
        'updatedBy': ''
        };

        res_data.forEach(function (row) {
          var new_row = angular.copy(row_obj);
          new_row.id = row.id;
          new_row.code = row.code ? row.code : 'NA';
          new_row.descriptionShort = row.descriptionShort ? row.descriptionShort : 'NA';
          new_row.description = row.description ? row.description : 'NA' ;
          new_row.chargeType = row.chargeType? row.chargeType : 'NA';
          new_row.defaultCalculationType = row.defaultCalculationType ? row.defaultCalculationType : 'NA';
          new_row.defaultBasis = row.defaultBasis ? row.defaultBasis : 'NA';
          new_row.mode = row.mode ? row.mode : 'NA';
          new_row.replacesCodes = row.replacesCodes && row.replacesCodes.length ? row.replacesCodes.join(', ') : 'NA';
          new_row.internalRemarks = row.internalRemarks ? row.internalRemarks : 'NA';
          new_row.status = row.status ? row.status : 'NA' ;
          new_row.isGlobal = row.isGlobal || false;
          new_row.domain = row.domain || 'NA';
          new_row.domainSubscriberId = row.domainSubscriberId || 'NA';
          new_row.createdAt = row.createdAt ? $filter('date')(row.createdAt, 'dd/MM/yyyy HH:mm') : 'NA';
          new_row.createdBy = row.createdBy ? row.createdBy : 'NA';
          new_row.updatedAt = row.updatedAt ? $filter('date')(row.updatedAt, 'dd/MM/yyyy HH:mm') : 'NA';
          new_row.updatedBy = row.updatedBy ? row.updatedBy : 'NA';
          new_res.push(new_row);
        });
        return new_res;
      }

    function resizeScreenSize() {
        vm.chargefilterdata.deviceName = util.resizeScreen(vm.chargefilterdata.deviceName);
    }
    window.onresize = vm.resizeScreenSize;

    function create_charge_popup(ev){
        util.callMixpanel("Charge-CreateCharge-Click");
        vm.codeEditMode = false;
        vm.validationObj={
        "chargeNameValidation" :false,
        "chargeTypeValidation":false,
        "defaultCalculationTypeValidation":false,
        "defaultBasisValidation":false,
        "modeValidation":false,
        "sameNameValidation":false,
        "codeValidation":false
        }
        vm.chargeInfo = {
            'name':null,
            'code':null,
            'descriptionShort':null,
            'description':null,
            'chargeType':null,
            'defaultCalculationType':null,
            'defaultBasis':null,
            'mode':'FCL',
            'isActive':true,
            'isGlobal':false,
            // 'domain':null,
            // 'domainSubscriberId':null,
            "updateView" : false,
            "viewCharge" : false,
            "form_heading" : "Create",
            "button_type" : "Submit",
        }
        
        // Load basis options for FCL when opening create dialog
        vm.loadFormBasisOptions('FCL');

        $mdDialog.show({
            templateUrl        : 'app/main/roles/dialogs/chargeForm/chargeForm.html',
            targetEvent        : ev,
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
        });
    }

     //close modal
     function cancelDialog(label,type){
        util.callMixpanel("Charge-Close-Click" ,{'Event' : type , 'Source' :label })
        $mdDialog.hide();
     }

    //sumbit function for charge popup
    function submitCharge(chargeForm,chargeInfo){
      var chargeFormValidationObj = {
        'Charge Name':'',
        'Charge Code':'',
        'Charge Type' :''
      }
      var mixpanelData = {
        'Charge Name' : chargeInfo.name ,
        'Charge Code' : chargeInfo.code ,
        'Charge Type' : chargeInfo.chargeType,
        'Source' : chargeInfo.form_heading,
        'Charge Form validation':chargeFormValidationObj
      }
      
        if(!chargeInfo.name){
            vm.validationObj.chargeNameValidation=true;
            chargeFormValidationObj["Charge Name"]='Required';
        }
        if(!chargeInfo.code || chargeInfo.code.trim() === ''){
            vm.validationObj.codeValidation=true;
            chargeFormValidationObj["Charge Code"]='Required';
        }
        // Set descriptionShort from name if not provided
        if(!chargeInfo.descriptionShort && chargeInfo.name) {
            chargeInfo.descriptionShort = chargeInfo.name;
        }
        if(!chargeInfo.chargeType){
            vm.validationObj.chargeTypeValidation=true;
            chargeFormValidationObj["Charge Type"]='Required';
        }
        if(!chargeInfo.defaultCalculationType){
            vm.validationObj.defaultCalculationTypeValidation=true;
            chargeFormValidationObj["Default Calculation Type"]='Required';
        }
        if(!chargeInfo.defaultBasis){
            vm.validationObj.defaultBasisValidation=true;
            chargeFormValidationObj["Default Basis"]='Required';
        }
        if(!chargeInfo.mode){
            vm.validationObj.modeValidation=true;
            chargeFormValidationObj["Mode"]='Required';
        }
        
        if(vm.validationObj.chargeNameValidation || vm.validationObj.codeValidation || vm.validationObj.chargeTypeValidation || vm.validationObj.defaultCalculationTypeValidation || vm.validationObj.defaultBasisValidation || vm.validationObj.modeValidation){
          util.callMixpanel("Charge-Submit-Click",mixpanelData)
            return;
        }

        if(chargeForm.charge_name && chargeForm.charge_name.$invalid ){
            document.querySelector('#charge_name').focus();
            return true;
          }
         
          util.callMixpanel("Charge-Submit-Click",mixpanelData);
          chargeInfo.button_type=='Submit'?create_charge(chargeInfo):update_charge(chargeInfo);
    }

    function create_charge(chargeInfo){
      var chargeData={
        'code':chargeInfo.code,
        'descriptionShort':chargeInfo.descriptionShort || chargeInfo.name,
        'description':chargeInfo.description || chargeInfo.name,
        'chargeType':chargeInfo.chargeType,
        'defaultCalculationType':chargeInfo.defaultCalculationType || 'SUBJECT-TO',
        'defaultBasis':chargeInfo.defaultBasis,
        'mode':chargeInfo.mode,
        'allowedLegs': 'L1,L2,L2CHA,L3,L4,L4CHA,L5,L3TAO,L3TAD,L2IHO,L4IHD,L6',
        'defaultLeg': 'L6',
        'status': chargeInfo.isActive ? 'ACTIVE' : 'INACTIVE'
      }
      util.isCallingApi = true;
      RoleService.createCharge(chargeData)
      .then(function(response){
          util.isCallingApi = false;
          util.showToast('Charge Created Successfully!!','top right', 3000);
          vm.cancelDialog()
          vm.dtInstanceCallback.rerender();

      },function(error){
          if(error.data && error.data.errors && error.data.errors.code){
              vm.validationObj.sameNameValidation=true;
              vm.validationErrorName=error.data.errors.code[0];
            }
          else if(error.data && error.data.message){
              // Handle backend duplicate validation - "Charge code already exists for this mode"
              if(error.data.message.toLowerCase().includes('already exists')){
                  vm.validationObj.sameNameValidation=true;
                  vm.validationErrorName=error.data.message;
              } else {
                  util.showToast(error.data.message);
              }
          }
          else{
              util.showToast('Error creating charge');
          }
          util.isCallingApi = false;
      });
    }


    function update_charge(chargeInfo){
      var chargeData={
        'code':chargeInfo.code,
        'descriptionShort':chargeInfo.descriptionShort,
        'description':chargeInfo.description,
        'chargeType':chargeInfo.chargeType,
        'defaultCalculationType':chargeInfo.defaultCalculationType,
        'defaultBasis':chargeInfo.defaultBasis,
        'mode':chargeInfo.mode,
        'domain':chargeInfo.domain,
        'domainSubscriberId':chargeInfo.domainSubscriberId,
        'status':chargeInfo.isActive ? 'ACTIVE' : 'INACTIVE'
      }

      util.isCallingApi = true;
      RoleService.updateCharge(chargeData, chargeInfo.id)
      .then(function(response){
          util.isCallingApi = false;
          util.showToast('Charge Updated Successfully!!','top right', 3000);
          vm.cancelDialog()
          vm.dtInstanceCallback.rerender();

      },function(error){
          if(error.data && error.data.errors && error.data.errors.code){
              vm.validationObj.sameNameValidation=true;
              vm.validationErrorName=error.data.errors.code[0];
            }
          else if(error.data && error.data.message){
              // Handle backend duplicate validation - "Charge code already exists for this mode"
              if(error.data.message.toLowerCase().includes('already exists')){
                  vm.validationObj.sameNameValidation=true;
                  vm.validationErrorName=error.data.message;
              } else {
                  util.showToast(error.data.message);
              }
          }
          else{
              util.showToast('Error updating charge');
          }
          util.isCallingApi = false;
      });
    }

    function fnCreatedSortBy(action){
        vm.filterListObject.sort_by_type = action === 'DESC' ? 'ASC' : 'DESC';
        vm.filterListObject.sort_by = 'createdAt'; // Ensure we're sorting by the correct field
        vm.listLoader = true;
        util.callMixpanel("Charge-SortBy-CreatedOn-Click" , {'Value': vm.filterListObject.sort_by_type })
        vm.dtInstanceCallback.rerender();
    }  


    function getDtColumnsData(){
        vm.dtColumns = [
                // Always visible - most important
                DTColumnBuilder.newColumn(null).withTitle('Code').withOption('name', 'code').renderWith(function (data) {
                  var globalBadge = data.isGlobal ? '<span style="background: #2196F3; color: white; padding: 2px 6px; border-radius: 10px; font-size: 10px; margin-left: 5px;">GLOBAL</span>' : '';
                  var userBadge = !data.isGlobal ? '<span style="background: #6366F1; color: white; padding: 2px 6px; border-radius: 10px; font-size: 10px; margin-left: 5px;">USER</span>' : '';
                  var html = '<span ng-non-bindable>'+ $sanitize(data.code) + globalBadge + userBadge +'</span>';
                  return '<td>'+ html +'<md-tooltip md-direction="top">'+$sanitize(data.code)+'</md-tooltip>'+'</td>' })
                     .withClass('ellipsis-text all').notSortable(),
                // Main important column - always visible
                DTColumnBuilder.newColumn(null).withTitle('Description').withOption('name', 'descriptionShort').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ $sanitize(data.descriptionShort) +'</td>' })
                      .withClass('ellipsis-text all').notSortable(),
                // Visible on large tablet and up
                DTColumnBuilder.newColumn(null).withTitle('Charge Type').withOption('name', 'chargeType').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ $sanitize(data.chargeType) +'</td>' }).withClass('desktop tablet-l').notSortable(),
                // Desktop only
                DTColumnBuilder.newColumn(null).withTitle('Calculation Type').withOption('name', 'defaultCalculationType').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ $sanitize(data.defaultCalculationType) +'</td>' }).withClass('desktop').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Default Basis').withOption('name', 'defaultBasis').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ $sanitize(data.defaultBasis) +'</td>' }).withClass('desktop').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Mode').withOption('name', 'mode').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ $sanitize(data.mode) +'</td>' }).withClass('desktop').notSortable(),
                // Visible on tablet and up - Status with colors
                DTColumnBuilder.newColumn(null).withTitle('Status').withOption('name', 'status').renderWith(function (data) {
                  var statusColor = data.status === 'ACTIVE' ? '#4CAF50' : '#F44336';
                  return '<td><span style="color: ' + statusColor + '; font-weight: 500;" ng-non-bindable>'+ $sanitize(data.status) +'</span></td>' }).withClass('desktop tablet-l tablet-p').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Is Global').withOption('name', 'isGlobal').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ (data.isGlobal ? 'Yes' : 'No') +'</td>' }).withClass('desktop').notSortable(),
                // Audit columns - after isGlobal
                DTColumnBuilder.newColumn(null).withTitle('Created By').withOption('name', 'createdBy').renderWith(function (data) {
                  if (data.isGlobal) {
                    return '<td>-</td>';
                  }
                  var formattedName = vm.formatUserName(data.createdBy);
                  return '<td><span ng-non-bindable title="' + $sanitize(data.createdBy) + '">'+ $sanitize(formattedName) +'</span></td>' }).withClass('desktop').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Created At').withOption('name', 'createdAt').renderWith(function (data) {
                  if (data.isGlobal) {
                    return '<td>-</td>';
                  }
                  return '<td ng-non-bindable>'+ $sanitize(data.createdAt) +'</td>' }).withClass('desktop').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Updated By').withOption('name', 'updatedBy').renderWith(function (data) {
                  if (data.isGlobal) {
                    return '<td>-</td>';
                  }
                  var formattedName = vm.formatUserName(data.updatedBy);
                  return '<td><span ng-non-bindable title="' + $sanitize(data.updatedBy) + '">'+ $sanitize(formattedName) +'</span></td>' }).withClass('desktop').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Updated At').withOption('name', 'updatedAt').renderWith(function (data) {
                  if (data.isGlobal) {
                    return '<td>-</td>';
                  }
                  return '<td ng-non-bindable>'+ $sanitize(data.updatedAt) +'</td>' }).withClass('desktop').notSortable()
        ];

        vm.dtColumns.push(DTColumnBuilder.newColumn(null).withClass('all text-center').withTitle('Action')
            .renderWith(function (data, type, full, meta) {
              var editIcon = (data.isGlobal || !vm.util.navPermission.charges || !vm.util.navPermission.charges[2]) ? '<span class="action-icon-placeholder"></span>' : '<md-icon md-svg-src="assets/icons/custom/edit-icon.svg" class="action-icon cursor" ng-click="vm.viewCharge(\'' + data.id + '\',\'Edit\',' + meta.row + ',$event)" title="Edit"></md-icon>';
              var deleteIcon = (data.isGlobal || !vm.util.navPermission.charges || !vm.util.navPermission.charges[3]) ? '' : '<md-icon md-svg-src="assets/icons/custom/delete-icon.svg" ng-click="vm.deleteCharge(\'' + data.id + '\',' + meta.row + ')" class="action-icon cursor red-fg" title="Delete"></md-icon>';
              var viewIcon = '<md-icon md-font-icon="icon-eye" class="action-icon cursor view_icon" title="View" ng-click="vm.viewCharge(\'' + data.id + '\',\'View\','+meta.row+',$event)"></md-icon>';            
            return '<div class="action-buttons">' + editIcon + viewIcon + deleteIcon + '</div>';
        }).notSortable());

        vm.dtInstanceCallback = {};
    }

    function trackEvent(eventName,source){
       vm.util.callMixpanel(eventName,{
        "Source":source,
       })
    }

    function formatUserName(name) {
        if (!name || name === 'NA') return name;
        if (name.length <= 15) return name;
        return name.substring(0,12) + '...';
    }
  
    function generateChargeCode(){
        if(!vm.chargeInfo.name) {
            vm.chargeInfo.code = '';
            return;
        }
        
        var name = vm.chargeInfo.name.trim();
        var code = '';
        
        // Split by spaces, hyphens, pipes, parentheses, and ampersands
        var words = name.split(/[\s\-\|\(\)&]+/).filter(function(word) {
            return word.length > 0;
        });
        
        // Generate code from first letters of significant words
        for(var i = 0; i < words.length; i++) {
            var word = words[i].trim();
            if(word.length > 0) {
                // Skip common words
                var skipWords = ['and', 'the', 'of', 'for', 'in', 'on', 'at', 'to', 'a', 'an', 'or'];
                if(skipWords.indexOf(word.toLowerCase()) === -1) {
                    code += word.charAt(0).toUpperCase();
                }
            }
        }
        
        // If code is too short, add more letters from first significant word
        if(code.length < 2 && words.length > 0) {
            var firstWord = words[0].toUpperCase();
            code = firstWord.substring(0, Math.min(firstWord.length, 6));
        }
        
        // Limit to 10 characters max
        vm.chargeInfo.code = code.substring(0, 10);
    }

    function setChargeTypeFilter(value) {
        vm.selectedChargeType = value;
        vm.dtInstanceCallback.rerender();
    }

    function setCalculationTypeFilter(value) {
        vm.selectedCalculationType = value;
        vm.dtInstanceCallback.rerender();
    }

    function setDefaultBasisFilter(value) {
        vm.selectedDefaultBasis = value;
        vm.dtInstanceCallback.rerender();
    }

    function setModeFilter(value) {
        vm.selectedMode = value;
        vm.dtInstanceCallback.rerender();
    }

    function setStatusFilter(value) {
        vm.selectedStatus = value;
        vm.dtInstanceCallback.rerender();
    }
    
    function loadBasisOptions(mode) {
        if (!mode) return;
        
        RoleService.getPricingModels(mode)
            .then(function(response) {
                var pricingModels = response.data.data || [];
                var basisOptions = [];
                
                // Convert API data to dropdown format
                pricingModels.forEach(function(model) {
                    if (model.pricingModel) {
                        basisOptions.push({
                            value: model.pricingModel,
                            label: model.title
                        });
                    }
                });
                
                vm.filterobj.default_basis_options = basisOptions;
            })
            .catch(function(error) {
                $log.error('Error loading basis options:', error);
                vm.filterobj.default_basis_options = [];
            });
    }

    function loadFormBasisOptions(mode) {
        if (!mode) return;
        
        RoleService.getPricingModels(mode)
            .then(function(response) {
                var pricingModels = response.data.data || [];
                var basisOptions = [];
                
                // Convert API data to dropdown format
                pricingModels.forEach(function(model) {
                    if (model.pricingModel) {
                        basisOptions.push({
                            value: model.pricingModel,
                            label: model.title
                        });
                    }
                });
                
                vm.formBasisOptions = basisOptions;
            })
            .catch(function(error) {
                $log.error('Error loading form basis options:', error);
                vm.formBasisOptions = [];
            });
    }

    function onModeChange(mode) {
        // Load basis options for the form only
        vm.loadFormBasisOptions(mode);
        
        // Clear basis selection when mode changes
        if (vm.chargeInfo) {
            vm.chargeInfo.defaultBasis = null;
        }
    }
    
    }
}
)();
(function ()
{
    'use strict';

    angular
        .module('app.agents', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.agents', {
                url    : '/agents',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/roles/agents/agents.html',
                        controller : 'AgentsController as vm'
                    }
                },
                bodyClass: 'agents-page'
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.agents')
        .controller('AgentsController', AgentsController);

    /** @ngInject */
    function AgentsController($mdSidenav,util,$mdDialog,RoleService, DTOptionsBuilder, DTColumnBuilder,$compile,$scope,$rootScope,$log,$rootElement,$sanitize,$filter){
    var vm=this;
    vm.util=util
    vm.resizeScreenSize=resizeScreenSize;
    vm.toggleSidenav=toggleSidenav;
    vm.create_agent_popup=create_agent_popup;
    vm.create_agent=create_agent;
    vm.update_agent=update_agent;
    vm.cancelDialog=cancelDialog;
    vm.submitAgent=submitAgent;
    vm.setDatePicker=setDatePicker;
    vm.fnCreatedSortBy=fnCreatedSortBy;
    vm.getDtColumnsData=getDtColumnsData;
    vm.initAgentTable=initAgentTable;
    vm.formAgentApiUrl=formAgentApiUrl;
    vm.agentLength=null;
    vm.formatResponse=formatResponse;
    vm.calculateMaxHeight=calculateMaxHeight;
    vm.agentDetailsTemp = [];
    vm.fnDeletetData=fnDeletetData;
    vm.getFilterList=getFilterList;
    vm.clearFilter=clearFilter;
    vm.callBackAgentSearch=callBackAgentSearch;
    vm.trackEvent = trackEvent;
    vm.dtOptions = {
        dom       : '<"top"lf>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        autoWidth : false,
        responsive: true,
        lengthMenu  : [5, 10, 20, 30, 50, 100],
        pageLength  : 5
    };


    vm.viewAgent=viewAgent;
    vm.deleteAgent=deleteAgent;
    vm.validationErrorName="";
    vm.validationErrorEmail="";
    vm.validationErrorMobile="";
    var fromDate = new Date(new Date().setDate(new Date().getDate() - 30));

    //agent form structure 
    vm.agentInfo = {
        'email':"",
        'mobile':"",
        'name':"",
        'type':"Forwarder",
        "updateView" : false,
        "viewAgent" : false,
        "form_heading" : "",
        "button_type" : "",
    }
    vm.filterobj={
        "agent_name":null,
        "date_range":{
          "from": fromDate,
          "to": new Date()
      }
    };

    vm.agentfilterdata= {
        'deviceName' : '',
        'agentSelected' : [],
        'isResetFilter' : false,
      };
    
    vm.agentFilterConditions = {
        'listLoader':false,
        'selectedOptions': vm.agentfilterdata.agentSelected,
        'placeholder': 'Search Agent',
        'isGroupOptions' : false,
        'groupList' :  {groupTitle:'Internal Users',keyTitle:'agent_name',subKeyTitle:'email'},
        'selectedCount' : 0
      };

    vm.filterListObject = {
        "date_range":null,
        "agent_details": null,
        "sort_by":'created_at',
        "sort_by_type":'DESC',
      };
      vm.defaultfilterList=angular.copy(vm.filterListObject);

      var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
        calculateMaxHeight();
    });
    $scope.$on('$destroy', bannerListener);

    function init(){
        vm.initAgentTable();  //initialize agent table
        vm.resizeScreenSize();
        vm.getFilterList();//get agent filter list
    }
    init();

    function toggleSidenav(sidenavId) {
        $mdSidenav(sidenavId).toggle();
    }
   
    function initAgentTable(){
        vm.dtOptions = DTOptionsBuilder.newOptions()
              .withOption('ajax', function (data, callback, settings) {
              var url = vm.formAgentApiUrl(data, callback, settings);  //get url
              RoleService.getAgent(url).then(function (response) {
                vm.agentData = response.data.data.data;
                var new_res = formatResponse(vm.agentData); //form response with table structure
                var table_data = {
                    'data': new_res,
                    'recordsTotal': response.data.data.count,
                    'recordsFiltered': response.data.data.count
                };
                vm.agentLength = response.data.data.count;
                callback(table_data);
                calculateMaxHeight();
                vm.dtOptions.lengthChange= vm.agentLength>0 ?true : false;
                },
                function (error) {
                  vm.dtOptions.lengthChange= vm.agentLength>0 ?true : false;
                util.showToast(error.message, 'top right', 3000);
                calculateMaxHeight();
                });
            })
            .withDataProp('data')
            .withOption('responsive', true)
            .withOption('serverSide', true)
            .withOption('processing', true)
            .withDisplayLength(10)
            .withPaginationType('simple')
            .withOption('aaSorting', [])
            .withOption('lengthChange',false)
            .withOption('language', { lengthMenu: "Show entries _MENU_"})
            .withOption('createdRow', function (row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });

        vm.getDtColumnsData();  //get dtcolumn data
      }

      //view/update agent
      function viewAgent(agent,from_heading, update_index, ev){

        vm.validationObj={
            "agentNameValidation" :false,
            "agentTypeValidation":false,
            "emailValidation" :false,
            "phoneNumberValidation":false,
            "sameNameValidation":false,
            "sameEmailValidation":false,
            "sameMobileValidation":false
            }       
         var selectedUSer = vm.agentDetailsTemp.find(function (i) {
            return i.agent_id == agent;
         });
         vm.selectedAgentName = selectedUSer.agent_name;
         util.callMixpanel('Agent-'+from_heading+'Agent-Click',{'Agent Name':vm.selectedAgentName});
        try{
            vm.agentInfo = {
                'email':selectedUSer.email,
                'mobile':selectedUSer.mobile,
                'name':selectedUSer.agent_name,
                'agent_id':selectedUSer.agent_id,
                'type':"Forwarder",
                "updateView" : from_heading == 'Edit' ? true : false,
                "viewAgent" : from_heading == 'Edit' ? false : true,
                "form_heading" : from_heading,
                "button_type" : "Update",
            }
            $mdDialog.show({
                templateUrl        : 'app/main/roles/dialogs/agentForm/agentForm.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }
       catch (error) {
        $log.log(error);
        }
      }

      function deleteAgent(id, delete_index, ev){
        var DeletedUSer = vm.agentDetailsTemp.find(function (i) {
          return i.agent_id == id;
       });
        vm.deletedAgentName = DeletedUSer.agent_name;
        util.callMixpanel("Agent-DeleteAgent-Click",{'Agent Name': vm.deletedAgentName});
        vm.deleteId = id;
        vm.deleteIndex = delete_index;
        vm.deleteBtn = false;
        vm.pageSource='agent'

        $mdDialog.show({
            template: '<md-dialog id="delete-popup" class="popup-xs"><delete-popup card-id="" card-index="" deletion-source="vm.pageSource" callback="ctrl.parent.fnDeletetData()"></delete-popup></md-dialog>',
            clickOutsideToClose: true,
            parent: $rootElement,
            scope: $scope,
            controllerAs: 'ctrl',
            preserveScope: true,
            controller: function () { this.parent = vm },
          });
       
      }
      //deleting agent from the list
      function fnDeletetData(){
        vm.deleteBtn = true;
        RoleService.deleteAgent(vm.deleteId).then(function(response){
          util.callMixpanel("Agent-DeleteAgent-Proceed",{'Agent Name':vm.deletedAgentName});
            vm.dtInstanceCallback.rerender(); //Refersh user table with latest data

            util.showToast('Agent deleted successfully.');
            vm.deleteBtn = false;
            $mdDialog.hide();

         },function(error){
            vm.deleteBtn = false;
            $log.log(error);
            util.showToast(util.displayValidationError(error));
         });
      }

      

      function formAgentApiUrl(data, callback, settings){
        var url ='limit='+ settings._iDisplayLength + '&offset='+ settings._iDisplayStart + ''  + util.fnGetForwarderIdApi('&');
        //adding query source and value to url
        angular.forEach(vm.filterListObject,function(value,key){
          angular.forEach((vm.filterListObject[key]),function(value1,key1){
            if(value1.query_source){
                 url += '&'+value1.query_source+'='+value1.query_value+''
               }
          })
        });
        url +='&sortBy='+vm.filterListObject.sort_by+'&sortByType='+vm.filterListObject.sort_by_type+'';
        return url;
      }

      function getFilterList(queryParam){
        RoleService.getFilterListAgent(queryParam)
        .then(function(response){
          vm.filterobj.date_range= {
            "from": fromDate,
            "to": new Date()
        }
          vm.filterobj.agent_name=response.data.data; 
             vm.filterLoader = false;
             vm.agentFilterConditions.filterLoader = false;
        }, function (error) {
            vm.agentfilterdata.isResetFilter=false;
            vm.filterLoader = false;
            vm.agentFilterConditions.filterLoader = false;
            util.showToast(util.displayValidationError(error));
            $log.error(error);
        })
      }

      //clear all filter
      function clearFilter(){
        util.callMixpanel("Agent-Filter-ClearAll-Click")
        vm.agentFilterConditions.selectedOptions = [];
        vm.filterListObject = angular.copy(vm.defaultfilterList);
        vm.agentfilterdata.isResetFilter = true;
        vm.dtInstanceCallback.rerender();
        vm.getFilterList();
      }

      //agent filter search
      function callBackAgentSearch(payload){
        util.callMixpanel("Agent-Filter-AgentName-Change",{"Value": payload.selectedOptions ,"SearchQuery":payload.searchText? payload.searchText :''})
        if(payload.searchText || payload.searchText === ''){ // search result 
            var queryParam = payload.searchText !== '' ? {'query' : payload.searchText
              } : null;
            vm.agentFilterConditions.filterLoader = true;
            vm.getFilterList(queryParam);
        }

        if(payload.selectedOptions){ // selected options
          var agentData="";
          if(vm.agentFilterConditions.selectedCount !== 0){
            var request={
              query_source:'',
              query_value:''
            }
            request.query_source='ids';
            vm.agentfilterdata.agentSelected = payload.selectedOptions;
            angular.forEach(payload.selectedOptions,function(item,key){
              if(key === 0){ 
                vm.filterListObject.agent_details=[];
             } 
             if(key==((payload.selectedOptions.length-1))){
              agentData+=item.agent_id;
             }
             else{
              agentData+=item.agent_id+',';
             }
            
            });
            request.query_value=agentData
            vm.filterListObject.agent_details.push(request);

           
          }else{
            angular.forEach(vm.filterListObject.agent_details,function(item,key){
                vm.filterListObject.agent_details=null
            }); 
          }
          vm.dtInstanceCallback.rerender();
        }
      }

    function calculateMaxHeight(){
        vm.maxFilterHeight = vm.util.getModuleMaxHeight(vm.maxFilterHeight,'filter',0);
    }

    //response format for table data
    function formatResponse(res_data){

        vm.agentDetailsTemp = res_data;

        var new_res = [];
        var row_obj = {
        'email' : '',
        'mobile': '',
        'agent_name' : '',
        'agent_type':'',
        'created_at' : '',
        'agent_id': '',
        };

        res_data.forEach(function (row) {
          var new_row = angular.copy(row_obj);
          new_row.agent_id = row.agent_id;
          new_row.email = row.email ? row.email : 'NA';
          new_row.mobile = row.mobile ? row.mobile : 'NA';
          new_row.agent_name = row.agent_name ? row.agent_name : 'NA' ;
          new_row.agent_type = row.agent_type? row.agent_type : 'NA';
          // new_row.iec_verification_status = row.iec_verification_status ? row.iec_verification_status : 'NA' ;
          new_row.created_at = row.created_at ? (moment.utc(new Date(row.created_at)).format("DD-MM-YYYY")): 'NA' ;
          new_res.push(new_row);
        });

        return new_res;
      }
    function resizeScreenSize() {
        vm.agentfilterdata.deviceName = util.resizeScreen(vm.agentfilterdata.deviceName);
    }
    window.onresize = vm.resizeScreenSize;

    function create_agent_popup(ev){
        util.callMixpanel("Agent-CreateAgent-Click");
        vm.validationObj={
        "agentNameValidation" :false,
        "agentTypeValidation":false,
        "emailValidation" :false,
        "phoneNumberValidation":false,
        "sameNameValidation":false,
        "sameEmailValidation":false,
        "sameMobileValidation":false
        }
        vm.agentInfo = {
            'email':null,
            'mobile':null,
            'name':null,
            'type':"Forwarder",
            "updateView" : false,
            "viewAgent" : false,
            "form_heading" : "Create",
            "button_type" : "Submit",
        }

        $mdDialog.show({
            templateUrl        : 'app/main/roles/dialogs/agentForm/agentForm.html',
            targetEvent        : ev,
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
        });
    }

     //close modal
     function cancelDialog(label,type){
        util.callMixpanel("Agent-Close-Click" ,{'Event' : type , 'Source' :label })
        $mdDialog.hide();
     }

    //sumbit function for aganet popup
    function submitAgent(agentForm,agentInfo){
      var agentFormValidationObj = {
        'Agent Name':'',
        'Agent Type' :'',
        'Phone Number':'',
        'Email Id' :''
      }
      var mixpanelData = {
        'Agent Type' : "Forwarder" ,
        'Agent Name' : agentInfo.name ,
        'Phone Number' : agentInfo.mobile ,
        'Email Id' : agentInfo.email,
        'Source' : agentInfo.form_heading,
        'Agent Form validation':agentFormValidationObj
      }
      
        if(!agentInfo.name){
            vm.validationObj.agentNameValidation=true;
            agentFormValidationObj["Agent Name"]='Required';
        }
        if(!agentInfo.type){
            vm.validationObj.agentTypeValidation=true;
            agentFormValidationObj["Agent Type"]='Required';
        }
        if(!agentInfo.email){
            vm.validationObj.emailValidation=true;
            agentFormValidationObj["Email Id"]='Required';
        }
        if(!agentInfo.mobile){
            vm.validationObj.mobileNumberValidation=true;
            agentFormValidationObj["Phone Number"]='Required';
        }
        if(vm.validationObj.agentNameValidation || vm.validationObj.agentTypeValidation || vm.validationObj.emailValidation || vm.validationObj.mobileNumberValidation ){
          util.callMixpanel("Agent-Submit-Click",mixpanelData)
            return;
        }

        if(agentForm.agent_name.$invalid ){
            document.querySelector('#agent_name').focus();
            return true;
          }
        if(agentForm.agent_email.$invalid ){
            document.querySelector('#agent_mail').focus();
            return true;
          }

          if(agentForm.agent_mobile.$invalid ){
            document.querySelector('#agent_mobile').focus();
            return true;
          }
         
          util.callMixpanel("Agent-Submit-Click",mixpanelData);
          agentInfo.button_type=='Submit'?create_agent(agentInfo):update_agent(agentInfo);
    }

    function create_agent(agentInfo){
      var agentData={
        'email':agentInfo.email,
        'mobile':agentInfo.mobile,
        'name':agentInfo.name,
        'type':"Forwarder",
      }
      util.isCallingApi = true;
      RoleService.createAgent(agentData)
      .then(function(response){
          util.isCallingApi = false;
          util.showToast('Agent Created Successfully!!','top right', 3000);
          vm.cancelDialog()
          vm.dtInstanceCallback.rerender();

      },function(error){
          if(error.data.errors.name){
              vm.validationObj.sameNameValidation=true;
              vm.validationErrorName=error.data.errors.name[0];
            }
            else if(error.data.errors.email){
              vm.validationObj.sameEmailValidation=true;
              vm.validationErrorEmail=error.data.errors.email[0];
          }
          else if(error.data.errors.mobile){
              vm.validationObj.sameMobileValidation=true;
              vm.validationErrorMobile=error.data.errors.mobile[0];
          }
          else{
              util.showToast(error.data.errors.message);
          }
          util.isCallingApi = false;
      });
    }


    function update_agent(agentInfo){
      var agentData={
        'email':agentInfo.email,
        'mobile':agentInfo.mobile,
        'name':agentInfo.name,
        'type':"Forwarder",
      }
      util.isCallingApi = true;
      RoleService.updateAgent(agentData,agentInfo.agent_id)
      .then(function(response){
          util.isCallingApi = false;
          util.showToast('Agent Updated Successfully!!','top right', 3000);
          vm.cancelDialog()
          vm.dtInstanceCallback.rerender();

      },function(error){
          if(error.data.errors.name){
              vm.validationObj.sameNameValidation=true;
              vm.validationErrorName=error.data.errors.name[0];
            }
          else if(error.data.errors.email){
              vm.validationObj.sameEmailValidation=true;
              vm.validationErrorEmail=error.data.errors.email[0];
          }
          else if(error.data.errors.mobile){
              vm.validationObj.sameMobileValidation=true;
              vm.validationErrorMobile=error.data.errors.mobile[0];
          }
          else{
              util.showToast(error.data.errors.message);
          }
          util.isCallingApi = false;
      });
    }

    function setDatePicker(date){
      util.callMixpanel("Agent-Filter-DateRange-Change",{'Value':vm.filterListObject.date_range})
        if(date){
            vm.filterListObject.date_range={
                'from':{'query_value':[]},
                'to':{ 'query_value':[]}
            }
        }    
        //addidng query source and query value  for date
        vm.filterListObject.date_range.from.query_source = 'fromDate';
        vm.filterListObject.date_range.from.query_value.push( $filter('date')(date.start_date, 'yyyy-MM-dd'));
        vm.filterobj.date_range.from = $filter('date')(date.start_date, 'yyyy-MM-dd');
        vm.filterListObject.date_range.to.query_source = 'toDate';
        vm.filterListObject.date_range.to.query_value.push( $filter('date')(date.end_date, 'yyyy-MM-dd'));
        vm.filterobj.date_range.to = $filter('date')(date.end_date, 'yyyy-MM-dd');
        vm.dtInstanceCallback.rerender();
    }

    function fnCreatedSortBy(action){
        vm.filterListObject.sort_by_type = action === 'DESC' ? 'ASC' : 'DESC';
        vm.listLoader = true;
        util.callMixpanel("Agent-SortBy-CreatedOn-Click" , {'Value': vm.filterListObject.sort_by_type })
        vm.dtInstanceCallback.rerender();
    }  


    function getDtColumnsData(){
        vm.dtColumns = [
                // 1
                DTColumnBuilder.newColumn(null).withTitle('Agent Name').withOption('name', 'agent_name').renderWith(function (data) {
                 
                  var html = '<span ng-non-bindable>'+ $sanitize(data.agent_name) +'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                     .withClass('ellipsis-text').notSortable(),
                // 2
                DTColumnBuilder.newColumn(null).withTitle('Email').withOption('name', 'email').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ $sanitize(data.email) +'</td>' })
                      .withClass('ellipsis-text').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('Created On').withOption('name', 'created_at').renderWith(function (data) {
                  return '<td ng-non-bindable>'+ $sanitize(data.created_at) +'</td>' }).notSortable(),
        ];

        vm.dtColumns.push(DTColumnBuilder.newColumn(null).withClass('all').withTitle('Action')
            .renderWith(function (data, type, full, meta) {
            return '<span>' +
            '<md-icon ng-if="vm.util.navPermission.agents && vm.util.navPermission.agents[2]" md-svg-src="assets/icons/custom/edit-icon.svg" class="cursor ml-10" ng-click="vm.viewAgent(\'' + data.agent_id + '\',\'Edit\','+meta.row+',$event)"></md-icon>'+
            '<md-icon ng-if="vm.util.navPermission.agents && vm.util.navPermission.agents[1]" md-font-icon="icon-eye" class="cursor ml-10 mb-10 view_icon" title="View" ng-click="vm.viewAgent(\'' + data.agent_id + '\',\'View\','+meta.row+',$event)" class="green-fg mh-5"></md-icon>'+
            '<md-icon ng-if="vm.util.navPermission.agents && vm.util.navPermission.agents[3]" md-svg-src="assets/icons/custom/delete-icon.svg" ng-click="vm.deleteAgent(\'' + data.agent_id + '\','+meta.row+')" class="red-fg cursor"></md-icon>'+
            // '<md-icon md-font-icon="icon-delete" ng-disabled="true" class="blue-dot pl-5" title="Delete" ng-if="vm.util.navPermission.shippers[3]" ng-click="vm.deleteShipper(shipper.id,$index,$event)"></md-icon>'
            '</span>';
        }).notSortable());

        vm.dtInstanceCallback = {};
    }

    function trackEvent(eventName,source){
       vm.util.callMixpanel(eventName,{
        "Source":source,
       })
    }
    
    }
}
)();
(function ()
{
    'use strict';

    angular
        .module('app.result',['app.book','ng.ckeditor'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider)
    {
        $stateProvider
        .state('app.search.result', {
            url  : '/result/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/result.html',
                    controller : 'ResultController as vm'
                },
                data : { pageTitle: 'Results' }
            },
            resolve : {
                ResultData : function($stateParams,SearchService,$location,util){

                    if( Object.keys(SearchService.FclResult).length != 0 && SearchService.FclResult.result_meta != undefined && SearchService.FclResult.result_meta.search_param.user != undefined && SearchService.FclResult._id == $stateParams.id && SearchService.isNewSearch){
                        return SearchService.FclResult;
                    }
                    else if( Object.keys(SearchService.FclResult).length != 0 && SearchService.FclResult.result_meta != undefined && SearchService.FclResult.result_meta.search_param.user != undefined && (SearchService.FclResult._id != $stateParams.id || (SearchService.FclResult._id == $stateParams.id && !SearchService.isNewSearch)) ){
                        return SearchService.getResultFromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.FclResult = response.data.data;
                            return SearchService.FclResult;
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else if( (Object.keys(SearchService.FclResult).length == 0 || SearchService.FclResult.result_meta == undefined || SearchService.FclResult.result_meta.search_param.user == undefined) && $stateParams.id != ""){
                        return SearchService.getResultFromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.FclResult = response.data.data;
                            return SearchService.FclResult;
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else{
                        $location.path('/rates');
                    }
                }
            },
            bodyClass: 'Shipper-Project'
        })
        // air result module
        .state('app.search.airResult', {
            url  : '/airresult/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/result.html',
                    controller : 'AirResultController as vm'
                },
                data : { pageTitle: 'Air-result-page' }
            },
            resolve : {
                AirResultData : function($stateParams,SearchService,$location,util){

                    if( Object.keys(SearchService.AirResult).length != 0 && SearchService.AirResult.result_meta != undefined && SearchService.AirResult.result_meta.search_param.user != undefined && SearchService.AirResult._id == $stateParams.id && SearchService.isNewSearch){
                        return SearchService.AirResult;
                    }
                    else if( Object.keys(SearchService.AirResult).length != 0 && SearchService.AirResult.result_meta != undefined && SearchService.AirResult.result_meta.search_param.user != undefined && (SearchService.AirResult._id != $stateParams.id || (SearchService.AirResult._id == $stateParams.id && !SearchService.isNewSearch)) ){
                        return SearchService.getResultFromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.AirResult = response.data.data;
                            return SearchService.AirResult;
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else if( (Object.keys(SearchService.AirResult).length == 0 || SearchService.AirResult.result_meta == undefined || SearchService.AirResult.result_meta.search_param.user == undefined) && $stateParams.id != ""){
                        return SearchService.getResultFromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.AirResult = response.data.data;
                            return SearchService.AirResult;
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else{
                        $location.path('/rates');
                    }
                }
            },
            bodyClass: 'Shipper-Project'
        })
        // lcl result module
        .state('app.search.lclResult', {
            url  : '/lclresult/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/result.html',
                    controller : 'LclResultController as vm'
                },
                data : { pageTitle: 'Lcl-result-page' }
            },
            resolve : {
                LclResultData : function($stateParams,SearchService,$location,util){

                    if( Object.keys(SearchService.LclResult).length != 0 && SearchService.LclResult.result_meta != undefined && SearchService.LclResult.result_meta.search_param.user != undefined && SearchService.LclResult._id == $stateParams.id && SearchService.isNewSearch){
                        return SearchService.LclResult;
                    }
                    else if( Object.keys(SearchService.LclResult).length != 0 && SearchService.LclResult.result_meta != undefined && SearchService.LclResult.result_meta.search_param.user != undefined && (SearchService.LclResult._id != $stateParams.id || (SearchService.LclResult._id == $stateParams.id && !SearchService.isNewSearch)) ){
                        return SearchService.getResultFromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.LclResult = response.data.data;
                            return SearchService.LclResult;
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else if( (Object.keys(SearchService.LclResult).length == 0 || SearchService.LclResult.result_meta == undefined || SearchService.LclResult.result_meta.search_param.user == undefined) && $stateParams.id != ""){
                        return SearchService.getResultFromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.LclResult = response.data.data;
                            return SearchService.LclResult;
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else{
                        $location.path('/rates');
                    }
                }
            },
            bodyClass: 'Shipper-Project'
        })
         // ftl result module
         .state('app.search.ftlResult', {
            url  : '/ftlresult/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/ftlResult.html',
                    controller : 'FtlResultController as vm'
                },
                data : { pageTitle: 'Ftl-result-page' }
            },
            resolve : {
                FtlResultData : function($stateParams,SearchService,$location,util){
                    if( SearchService.FtlResult != undefined && Object.keys(SearchService.FtlResult).length != 0  && SearchService.FtlResult.salesUser != undefined && SearchService.FtlResult._id == $stateParams.id ){
                        return SearchService.FtlResult;
                    }
                    else if(SearchService.FtlResult != undefined && Object.keys(SearchService.FtlResult).length != 0  && SearchService.FtlResult.salesUser != undefined && (SearchService.FtlResult._id != $stateParams.id) ){
                        return SearchService.getResultFromFtlId($stateParams.id).then(function(response){
                            SearchService.FtlResult = response.data.searchParam;
                            return SearchService.FtlResult;
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else if (
                      (SearchService.FtlResult == undefined ||
                         Object.keys(SearchService.FtlResult).length == 0 ||
                        SearchService.FtlResult.salesUser == undefined) &&
                      $stateParams.id != ""
                    ) {
                      return SearchService.getResultFromFtlId(
                        $stateParams.id
                      ).then(
                        function (response) {
                          SearchService.FtlResult = response.data.searchParam;
                          return SearchService.FtlResult;
                        },
                        function (error) {
                          $location.path("/rates");
                        }
                      );
                    } else {
                      $location.path("/rates");
                    }
                }
            },
            bodyClass: 'Shipper-Project'
        })
        //state for shipment booking
        .state('app.resultBookShipment', {
            url  : '/booking/:mode',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/bookShipment/booking-shipment.html',
                    controller : 'bookShipmentFclController as vm'
                },
                data : { pageTitle: 'Book Shipment' }
            },
            resolve : {
                BookingData :function($window,SearchService,resultService, $stateParams,util){
                    if($stateParams.mode == 'fcl'){
                        if(SearchService.FclResult.result_meta !== undefined && SearchService.FclResult.result_meta.search_param !== undefined ){
                            if(!angular.equals(SearchService.FclResult.result_meta.search_param.user, resultService.requestToBookData.search_param.user)){
                                $window.history.back();
                            }
                            else{
                                return resultService.requestToBookData;
                            }
                        }else{
                            $window.history.back();
                        }
                    }else if($stateParams.mode == 'air'){
                        if(SearchService.AirResult.result_meta != undefined && SearchService.AirResult.result_meta.search_param != undefined ){
                            if(!angular.equals(SearchService.AirResult.result_meta.search_param.user, resultService.requestToBookData.search_param.user)){
                                $window.history.back();
                            }
                            else{
                                return resultService.requestToBookData;
                            }
                        }else{
                            $window.history.back();
                        }
                    }else if($stateParams.mode == 'lcl'){
                        if(SearchService.LclResult.result_meta != undefined && SearchService.LclResult.result_meta.search_param != undefined ){
                            if(!angular.equals(SearchService.LclResult.result_meta.search_param.user, resultService.requestToBookData.search_param.user)){
                                $window.history.back();
                            }
                            else{
                                return resultService.requestToBookData;
                            }
                        }else{
                            $window.history.back();
                        }
                    }
                }
            }
        })
        .state('app.resultConfirmShipment', {
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/bookShipment/confirm_booking.html',
                    controller : function($scope, resultService,$state,util){
                        var vm = this;
                        vm.bookResponseData = resultService.bookResponseData;
                        vm.goToShipmentDetail = goToShipmentDetail;
                        vm.redirectOnClose = redirectOnClose;

                        function redirectOnClose (){
                            util.fnReDirectToHome();
                            // $state.go('app.'+util.state[0]);
                        }

                        function goToShipmentDetail(){
                          if(!util.isWebView()){
                            $state.go('app.shipments.shipment_details', { id: vm.bookResponseData.shipment_id });
                          }
                        }
                      },
                    'controllerAs' : 'vm'
                },
                data : { pageTitle: 'Book Shipment' }
            }
        })
        // V2 version FCL result module
        .state('app.search.fclV2Rates', {
            url  : '/fcl/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/polling-result/pollingResult.html',
                    controller : 'PollingResultController as vm'
                },
                data : { pageTitle: 'FCL | Result' }
            },
            resolve : {
                ResultData : function($stateParams,SearchService,$location,util){
                    SearchService.searchMode = {
                        mode : 'fcl',
                        state: 'fclV2Rates'
                    };
                    var modeType = "SEA-FCL"
                    if( Object.keys(SearchService.FclResult).length != 0 && SearchService.FclResult.result_meta != undefined && SearchService.FclResult.result_meta.search_param.user != undefined && SearchService.FclResult._id == $stateParams.id && SearchService.isNewSearch){
                        return SearchService.FclResult;
                    }
                    else if( Object.keys(SearchService.FclResult).length != 0 && SearchService.FclResult.result_meta != undefined && SearchService.FclResult.result_meta.search_param.user != undefined && (SearchService.FclResult._id != $stateParams.id || (SearchService.FclResult._id == $stateParams.id && !SearchService.isNewSearch)) ){
                        return SearchService.getResultV2FromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.FclResult = response.data.data;
                            if(response.data.data.result_meta.search_param.mode === modeType){
                                return SearchService.FclResult;
                            }else{
                                $location.path('/rates');
                            }
                            
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else if( (Object.keys(SearchService.FclResult).length == 0 || SearchService.FclResult.result_meta == undefined || SearchService.FclResult.result_meta.search_param.user == undefined) && $stateParams.id != ""){
                        return SearchService.getResultV2FromId($stateParams.id).then(function(response){
                            SearchService.isNewSearch = false;
                            SearchService.FclResult = response.data.data;
                            if(response.data.data.result_meta.search_param.mode === modeType){
                                return SearchService.FclResult;
                            }else{
                                $location.path('/rates');
                            }
                        },function(error){
                            $location.path('/rates');
                        });
                    }
                    else{
                        $location.path('/rates');
                    }
                }
            
            },
            bodyClass: 'Shipper-Project'
        })

         // efp version FCL result module
        .state('app.searchV2Module.fclEfpRates', {
            url  : '/resultV2/fcl/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/result-v2/result-v2.html',
                    controller : 'FclResultV2Controller as vm'
                },
                data : { pageTitle: 'FCL | EfpResult' }
            },
            resolve : {
                 FclEfpResultData : function($stateParams,SearchService,$location,util){
                     SearchService.searchMode = {
                        mode : 'fcl',
                        state: 'fclEfpRates'
                    };
                    // if( SearchService.FclEfpResult != undefined && Object.keys(SearchService.FclEfpResult).length != 0  && SearchService.FclEfpResult.userDetails.salesUser != undefined && SearchService.FclEfpResult._id == $stateParams.id ){
                    //     return SearchService.FclEfpResult;
                    // }
                    // else if(SearchService.FclEfpResult != undefined && Object.keys(SearchService.FclEfpResult).length != 0  && SearchService.FclEfpResult.userDetails.salesUser != undefined && (SearchService.FclEfpResult._id != $stateParams.id) ){
                    //     return SearchService.getResultFromFclEfpId($stateParams.id).then(function(response){
                    //         SearchService.FclEfpResult = response.data.searchParam;
                    //         return SearchService.FclEfpResult;
                    //     },function(error){
                    //         $location.path('/search');
                    //     });
                    // }
                    // else if (
                    //   (SearchService.FclEfpResult == undefined ||
                    //      Object.keys(SearchService.FclEfpResult).length == 0 ||
                    //     SearchService.FclEfpResult.userDetails.salesUser == undefined) &&
                    //   $stateParams.id != ""
                    // ) {
                    //   return SearchService.getResultFromFclEfpId(
                    //     $stateParams.id
                    //   ).then(
                    //     function (response) {
                    //       SearchService.FclEfpResult = response.data.searchParam;
                    //       return SearchService.FclEfpResult;
                    //     },
                    //     function (error) {
                    //       $location.path("/search");
                    //     }
                    //   );
                    // } else {
                    //   $location.path("/search");
                    // }
                }
            
            },
            bodyClass: 'Shipper-Project'
        })

        .state('app.searchV2Module.lclEfpRates', {
            url  : '/resultV2/lcl/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/result-v2/result-v2.html',
                    controller : 'LclResultV2Controller as vm'
                },
                data : { pageTitle: 'LCL | EfpResult' }
            },
            resolve : {
                 FclEfpResultData : function($stateParams,SearchService,$location,util){
                     SearchService.searchMode = {
                        mode : 'lcl',
                        state: 'lclEfpRates'
                    };
                    // if( SearchService.FclEfpResult != undefined && Object.keys(SearchService.FclEfpResult).length != 0  && SearchService.FclEfpResult.userDetails.salesUser != undefined && SearchService.FclEfpResult._id == $stateParams.id ){
                    //     return SearchService.FclEfpResult;
                    // }
                    // else if(SearchService.FclEfpResult != undefined && Object.keys(SearchService.FclEfpResult).length != 0  && SearchService.FclEfpResult.userDetails.salesUser != undefined && (SearchService.FclEfpResult._id != $stateParams.id) ){
                    //     return SearchService.getResultFromFclEfpId($stateParams.id).then(function(response){
                    //         SearchService.FclEfpResult = response.data.searchParam;
                    //         return SearchService.FclEfpResult;
                    //     },function(error){
                    //         $location.path('/search');
                    //     });
                    // }
                    // else if (
                    //   (SearchService.FclEfpResult == undefined ||
                    //      Object.keys(SearchService.FclEfpResult).length == 0 ||
                    //     SearchService.FclEfpResult.userDetails.salesUser == undefined) &&
                    //   $stateParams.id != ""
                    // ) {
                    //   return SearchService.getResultFromFclEfpId(
                    //     $stateParams.id
                    //   ).then(
                    //     function (response) {
                    //       SearchService.FclEfpResult = response.data.searchParam;
                    //       return SearchService.FclEfpResult;
                    //     },
                    //     function (error) {
                    //       $location.path("/search");
                    //     }
                    //   );
                    // } else {
                    //   $location.path("/search");
                    // }
                }
            
            },
            bodyClass: 'Shipper-Project'
        })

        .state('app.searchV2Module.airEfpRates', {
            url  : '/resultV2/air/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/result/result-v2/result-v2.html',
                    controller : 'AirResultV2Controller as vm'
                },
                data : { pageTitle: 'AIR | EfpResult' }
            },
            resolve : {
                 AirEfpResultData : function($stateParams,SearchService,$location,util){
                     SearchService.searchMode = {
                        mode : 'air',
                        state: 'airEfpRates'
                    };
                }
            
            },
            bodyClass: 'Shipper-Project'
        })
        // V2 version LCL result module
        // .state('app.search.lclV2Rates', {
        //     url  : '/lcl/:id',
        //     views: {
        //         'content@app': {
        //             templateUrl: 'app/main/result/polling-result/pollingResult.html',
        //             controller : 'PollingResultController as vm'
        //         },
        //         data : { pageTitle: 'Lcl Results' }
        //     },
        //     resolve : {
        //         LclResultData : function($stateParams,SearchService,$location,util){
        //             SearchService.searchMode = {
        //                 mode : 'lcl',
        //                 state: 'lclV2Rates'
        //             };
        //             var modeType = "SEA-LCL"
        //             if( Object.keys(SearchService.LclResult).length != 0 && SearchService.LclResult.result_meta != undefined && SearchService.LclResult.result_meta.search_param.user != undefined && SearchService.LclResult._id == $stateParams.id && SearchService.isNewSearch){
        //                 return SearchService.LclResult;
        //             }
        //             else if( Object.keys(SearchService.LclResult).length != 0 && SearchService.LclResult.result_meta != undefined && SearchService.LclResult.result_meta.search_param.user != undefined && (SearchService.LclResult._id != $stateParams.id || (SearchService.LclResult._id == $stateParams.id && !SearchService.isNewSearch)) ){
        //                 return SearchService.getResultFromId($stateParams.id).then(function(response){
        //                     SearchService.isNewSearch = false;
        //                     SearchService.LclResult = response.data.data;
        //                     if(response.data.data.result_meta.search_param.mode === modeType){
        //                         return SearchService.LclResult;
        //                     }else{
        //                         $location.path('/rates');
        //                     }
                            
        //                 },function(error){
        //                     $location.path('/rates');
        //                 });
        //             }
        //             else if( (Object.keys(SearchService.LclResult).length == 0 || SearchService.LclResult.result_meta == undefined || SearchService.LclResult.result_meta.search_param.user == undefined) && $stateParams.id != ""){
        //                 return SearchService.getResultFromId($stateParams.id).then(function(response){
        //                     SearchService.isNewSearch = false;
        //                     SearchService.LclResult = response.data.data;
        //                     if(response.data.data.result_meta.search_param.mode === modeType){
        //                         return SearchService.LclResult;
        //                     }else{
        //                         $location.path('/rates');
        //                     }
        //                 },function(error){
        //                     $location.path('/rates');
        //                 });
        //             }
        //             else{
        //                 $location.path('/rates');
        //             }
        //         }
            
        //     },
        //     bodyClass: 'Shipper-Project'
        // })
        // // V2 version Air result module
        // .state('app.search.airV2Rates', {
        //     url  : '/air/:id',
        //     views: {
        //         'content@app': {
        //             templateUrl: 'app/main/result/polling-result/pollingResult.html',
        //             controller : 'PollingResultController as vm'
        //         },
        //         data : { pageTitle: 'Air Results' }
        //     },
        //     resolve : {
        //         AirResultData : function($stateParams,SearchService,$location,util){
        //             SearchService.searchMode = {
        //                 mode : 'air',
        //                 state: 'airV2Rates'
        //             };
        //             var modeType = "AIR"
        //             if( Object.keys(SearchService.AirResult).length != 0 && SearchService.AirResult.result_meta != undefined && SearchService.AirResult.result_meta.search_param.user != undefined && SearchService.AirResult._id == $stateParams.id && SearchService.isNewSearch){
        //                 return SearchService.AirResult;
        //             }
        //             else if( Object.keys(SearchService.AirResult).length != 0 && SearchService.AirResult.result_meta != undefined && SearchService.AirResult.result_meta.search_param.user != undefined && (SearchService.AirResult._id != $stateParams.id || (SearchService.AirResult._id == $stateParams.id && !SearchService.isNewSearch)) ){
        //                 return SearchService.getResultFromId($stateParams.id).then(function(response){
        //                     SearchService.isNewSearch = false;
        //                     SearchService.AirResult = response.data.data;
        //                     if(response.data.data.result_meta.search_param.mode === modeType){
        //                         return SearchService.AirResult;
        //                     }else{
        //                         $location.path('/rates');
        //                     }
                            
        //                 },function(error){
        //                     $location.path('/rates');
        //                 });
        //             }
        //             else if( (Object.keys(SearchService.AirResult).length == 0 || SearchService.AirResult.result_meta == undefined || SearchService.AirResult.result_meta.search_param.user == undefined) && $stateParams.id != ""){
        //                 return SearchService.getResultFromId($stateParams.id).then(function(response){
        //                     SearchService.isNewSearch = false;
        //                     SearchService.AirResult = response.data.data;
        //                     if(response.data.data.result_meta.search_param.mode === modeType){
        //                         return SearchService.AirResult;
        //                     }else{
        //                         $location.path('/rates');
        //                     }
        //                 },function(error){
        //                     $location.path('/rates');
        //                 });
        //             }
        //             else{
        //                 $location.path('/rates');
        //             }
        //         }
            
        //     },
        //     bodyClass: 'Shipper-Project'
        // })

         // Translation
        $translatePartialLoaderProvider.addPart('app/main/result');

        // Api
        // msApiProvider.register('result', ['app/data/result/result.json']);
        // msApiProvider.register('airResult', ['app/data/result/airResult.json']);


    }

})();

(function(){

  'use strict';

  angular
    .module('app.result')
    .factory('shareQuoteService' , shareQuoteService);

      /** @ngInject */
    function shareQuoteService($q,$log,$mdToast,$state,$http,api, $filter,util, localStorageService, $timeout,$rootScope, $mdPanel, analytics,SearchService,resultService, basisCalculation,constObj){

      var shareQuoteService = {
        fnGetContainerQty : fnGetContainerQty,
        getChargeCost : getChargeCost,
        getCustCurrencyCost : getCustCurrencyCost,
        fnGetLegTotal : fnGetLegTotal,
        airBasisName : constObj.AIR_FREIGHT_BASIS,
        airChargeId : "FBMT1530", // initialization of air freight charge id
        pickupBasisName : constObj.PICKUP_BASIS,
        pickupChargeId : "FBPU0010", // initialization of pickup charge id
        deliveryBasisName : constObj.DELIVERY_BASIS,
        deliveryChargeId : "FBDY2310", // initialization of delivery charge id
        freightBasisName : constObj.FREIGHT_BASIS,
        freightChargeId : "30001",
        l3_mode : '',
        isQuoteOrNewcard : '',
        chargeValidation : {},
        addChargeName : addChargeName,
        addChargeInLeg : addChargeInLeg,
        changeSelectedCharge : changeSelectedCharge,
        fnProcessTermsString : fnProcessTermsString,
        fnInitializeQuoteDetails : fnInitializeQuoteDetails,
        fnsortCardsExpiry : fnsortCardsExpiry,
        fnsortExpiryFinal : fnsortExpiryFinal,
        fnValidateExpiryDate : fnValidateExpiryDate,
        fnGetBuyChargeCurrency : fnGetBuyChargeCurrency,
        fnGetBuyChargeCost : fnGetBuyChargeCost,
        LegCurrUpdate : LegCurrUpdate,
        max_date : max_date,
        getSelectedCardSubvendor : getSelectedCardSubvendor,
        getAirlineName : getAirlineName,
        // getAirSlabUnit : getAirSlabUnit,
        getFclCharge : getFclCharge,
        calculateQtyRange : calculateQtyRange,
        fnRateEditValidation : fnRateEditValidation,
        sellRateValidation:sellRateValidation,
        sellRateChargeValidation:sellRateChargeValidation,
        buyRateValidation:buyRateValidation,
        getChargeName : getChargeName,
        getChargeList : getChargeList,
        fnGetFclTotalUnits : fnGetFclTotalUnits,
        fnDuplicateCharge : fnDuplicateCharge,
        setCurrencyConvSetting : setCurrencyConvSetting,
        currencyConverter: {},
        showCargoCommodity : showCargoCommodity,
        commodityString : commodityString,
        cargoInputDisabled : cargoInputDisabled,
        calLegTotalByCustCurrCost : calLegTotalByCustCurrCost,
        fnGetDimLegs : fnGetDimLegs,
        fnGuuid : fnGuuid,
        copysellToBuy : copysellToBuy,
        fnFillBasisMeta : fnFillBasisMeta,
        fnFillBasisMetaCharge : fnFillBasisMetaCharge,
        // showDeleteBasisCharge : showDeleteBasisCharge,
        getL3LegKey : getL3LegKey,
        airBasisLegCharge : {},
        pickupBasisLegCharge : {},
        deliveryBasisLegCharge : {},
        airBasisCharges: null,
        all_pickup_basis_delete:null,
        all_delivery_basis_delete : null,
        showCo2ContainerData : showCo2ContainerData,
        userDefinedChargeValidation : false,
        basisValidation : false,
        containerValidation : false,
        quantityValidation : false,
        buyValidation : false,
        buyMinimumValidation : false,
        sellValidation : false,
        sellMinimumValidation : false,
        basisList:{},
        fetchBasisList:fetchBasisList,
        showEffectivePeriodPanel:showEffectivePeriodPanel,
       
      }
      return shareQuoteService;
      
      // AIR - LCL basis & quantity
      function fnGetContainerQty(payload){
          var pallet = payload.mode === 'SEA-LCL' && payload.load_meta.total_pallets ? payload.load_meta.total_pallets : 1;
          var per_WMTotal = (payload.mode != 'SEA-FCL') ? payload.load_meta.chargeable_weight : 0;
          // lcl LTL per_WM total
          if(payload.mode == 'SEA-LCL' && payload.ltl_load_details){
            if(payload.global_leg_id == 'l1' && payload.ltl_load_details.origin){
              per_WMTotal = payload.ltl_load_details.origin.chargeable_weight;
            }else if(payload.global_leg_id == 'l5' && payload.ltl_load_details.destination){
              per_WMTotal = payload.ltl_load_details.destination.chargeable_weight;
            }
          }

          // set quantity edit false if user change basis editable to non-editable
          payload.charge.is_qty_editable = false;
          switch(payload.charge.charge_basis) {
            case "volumetric_weight" :
            payload.charge.total_units = payload.load_meta.volumetric_weight;
            break;

            case "gross_weight" :
            payload.charge.total_units = payload.load_meta.gross_weight;
            break;

            case "chargeable_weight" :
            payload.charge.total_units =  payload.load_meta.chargeable_weight;
            break;

            case "chargable_weight" :
            payload.charge.total_units =  payload.load_meta.chargeable_weight;
            break;

            case "per_hawb" :
            payload.charge.total_units = payload.load_meta.total_bl;
            break;

            case "per_bl" :
            payload.charge.total_units = payload.load_meta.total_bl;
            break;

            case constObj.AIR_FREIGHT_BASIS :
            payload.charge.total_units =  payload.airFreightValue;
            break;
            case constObj.FREIGHT_BASIS:
              payload.charge.total_units = basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[payload.charge.container_type ? payload.charge.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[payload.charge.container_type ? payload.charge.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[payload.charge.container_type ? payload.charge.container_type : 'N/A'].sell.leg_currency_cost : null;
            break;
            case "per_kg" :
            payload.charge.total_units = payload.load_meta.calculated_weight_unit=='KGs'? payload.load_meta.gross_weight:(payload.load_meta.gross_weight*1000);
            break;

            case "per_w/m" :
            payload.charge.total_units = per_WMTotal;
            break;

            case "per_cbm" :
            payload.charge.total_units = payload.load_meta.volumetric_weight;
            break;

            case "per_hbl" :
            payload.charge.total_units = payload.load_meta.total_bl;
            break;

            case "per_bl" :
            payload.charge.total_units = payload.load_meta.total_bl;
            break;

            case "per_awb" :
            payload.charge.total_units = payload.load_meta.total_bl;
            break;

            case "per shipping bill" :
            payload.charge.total_units = payload.load_meta.total_sbl ? payload.load_meta.total_sbl : 1;
            break;

            case "per_quintal" :
            payload.charge.total_units = payload.load_meta.calculated_weight_unit=='KGs'?payload.load_meta.gross_weight/100 : payload.load_meta.gross_weight * 10;
            break;

            case "per_ton" :
            payload.charge.total_units = payload.load_meta.calculated_weight_unit=='KGs'?payload.load_meta.gross_weight / 1000 : payload.load_meta.gross_weight;
            break;

            case "per_doc" :
            payload.charge.total_units = payload.load_meta.total_bl;
            break;

            case constObj.PICKUP_BASIS :
            payload.charge.total_units =  payload.pickupValue;
            break;

            case constObj.DELIVERY_BASIS :
            payload.charge.total_units =  payload.deliveryValue;
            break;

            case "per_lbs" :
              payload.charge.total_units = payload.load_meta.chargeable_weight * 2.2046; // Air Lbs Calculation..
              if(payload.mode === 'SEA-LCL'){
                payload.charge.total_units = payload.dimChargeableValue !== null ? payload.dimChargeableValue * 2.2046 : payload.load_meta.chargeable_weight * 1000 * 2.2046
              } 
            break;

            case "per_shipment" :
            payload.charge.total_units =  1;
            break;

            case "flat" :
            payload.charge.total_units =  1;
            break;

            case "per_cft":
            payload.charge.total_units =  payload.load_meta.volumetric_weight * 35.5;
            break;
            case 'per_pallet':
            payload.charge.total_units = pallet;
            break;
          
            case 'per_carton':
            case 'per_vehicle':
            case 'per_shift':
            case 'per_package':
            case 'per_invoice':
            case 'per_day':
            case 'per_revalidation':
              payload.charge.total_units = 1;
            break;
            case constObj.FREIGHT_TOTAL_BASIS:
              payload.charge.total_units = basisCalculation.freightTotal.sellFreightTotal;
                break;

            default :
              payload.charge.total_units =  1;
          }
      }
      
      function fetchBasisList(mode){
        var url = api.baseUrl;
        
        if (util.isSharedQuote() || util.isSharedPage()) {
          url += '/get-available-basis?mode='+mode;
        } else {
          url += '/api/get-available-basis?mode='+mode;
        }

        return $http.get(url);      
      }

      // FCL basis & quantity 
      function fnGetFclTotalUnits(chargeObj, loadData){
            var bL_value = loadData[0].bl_qty || 1;
            var sbL_value = loadData[0].sbl_qty || 1;
            var equipment_value = 1;
            var per_container = 0;
            var per_teu=0;
            var cargoWeight=0;
            var teu=0;
            var loadTypeArr = SearchService.loadTypeArr != undefined ? SearchService.loadTypeArr : [];
            for (var i = 0; i < loadData.length; i++) {
                per_container += loadData[i].qty;
                if(loadData[i].type && chargeObj.charge_basis==='per teu'){
                  for(var load=0;load<loadTypeArr.length;load++){
                    if(loadData[i].type && loadTypeArr[load].load_code === loadData[i].type){
                      per_teu+=(loadData[i].qty * loadTypeArr[load].teu);
                    }
                  }
                }
                if (chargeObj.container_type && (chargeObj.container_type == loadData[i].type)) {
                    equipment_value = loadData[i].qty;
                    cargoWeight= loadData[i].load_metrics[0].weight_qty;
                }
            }

            if(chargeObj.charge_basis != 'per equipment'  && chargeObj.charge_basis !== 'per kg' && chargeObj.charge_basis !== 'per ton' && chargeObj.charge_basis !== constObj.PICKUP_BASIS &&  chargeObj.charge_basis !== constObj.DELIVERY_BASIS && chargeObj.charge_basis !== constObj.FREIGHT_BASIS){
                chargeObj.container_type = "";
            }
            // set quantity edit false if user change basis editable to non-editable
            chargeObj.is_qty_editable = false;

            switch (chargeObj.charge_basis) {
                case "per equipment":
                  chargeObj.total_units = equipment_value;
                  break;
                case "per ton":
                  chargeObj.total_units = (equipment_value*cargoWeight)/1000;
                  break;
                case "per kg":
                  chargeObj.total_units = equipment_value*cargoWeight;
                  break;
                case "per teu":
                  chargeObj.total_units =per_teu;
                  break;

                case "per B/L":
                chargeObj.total_units = bL_value;
                break;

                case "per shipping bill":
                chargeObj.total_units = sbL_value;
                break;

                case "per container":
                chargeObj.total_units = per_container;
                break;

                case "per shipping bill / per container":
                chargeObj.total_units = per_container +  sbL_value;
                if (chargeObj.charge_type === 'SLAB' && chargeObj.slab_type === 'INCREMENTAL'){
                  chargeObj.total_units = chargeObj.total_units - 1;
                }
                break;

                case "per shipment":
                chargeObj.total_units = 1;
                break;

                case 'per carton':
                case 'per pallet':
                case "per belt":
                case 'per vehicle':
                case 'per shift':
                case 'per package':
                case 'per invoice':
                case 'per day':
                case 'per revalidation':
                  chargeObj.total_units =  1;
                break;
                case constObj.FREIGHT_TOTAL_BASIS:
                  chargeObj.total_units = basisCalculation.freightTotal.sellFreightTotal;
                  break;
                case constObj.PICKUP_BASIS:
                  if(chargeObj.container_type){
                    chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS] && basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.PICKUP_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;                 
                  }else{
                    chargeObj.total_units = 1;
                  }
                  break;
                case constObj.DELIVERY_BASIS:
                  if(chargeObj.container_type){
                    chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS] && basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.DELIVERY_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;
                  }else{
                    chargeObj.total_units = 1;
                  }
                  break;
                case constObj.FREIGHT_BASIS:
                  if(chargeObj.container_type){
                    chargeObj.total_units = basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[constObj.FREIGHT_BASIS].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell.leg_currency_cost : null;
                  }else{
                    chargeObj.total_units = 1;
                  }
                  break;
                default:
                chargeObj.total_units = 1;
            }
      }

      function calculateQtyRange(charge, key) {
        var unit = charge.total_units;
        if (unit >= charge.slab[key].to) {
          return (charge.slab[key].to - (charge.slab[key - 1] ? charge.slab[key - 1].to : 0));
        } else if (unit >= charge.slab[key].from) {
          return (unit - charge.slab[key].from + 1);
        } else {
          return 0;
        }
      }

      function getFclCharge(sellRates, charge_data, search_currency){
        var totalSlabCost = 0;
        var isMarkup = sellRates.leg_currency === search_currency ? true : false;

        if (charge_data.charge_type === 'SLAB' && charge_data.slab_type === 'INCREMENTAL') {
          charge_data.slab.forEach(function (i, k) {
            totalSlabCost += (parseFloat(i.cost) || 0)* shareQuoteService.calculateQtyRange(charge_data, k);
          });
          charge_data.per_unit_rate = totalSlabCost / charge_data.total_units;
        }

        var prev_charge_leg_cost = angular.copy(charge_data.leg_currency_cost);
        var prev_cust_curr_cost = angular.copy(charge_data.customer_currency_cost);

        var total_units = charge_data.total_units;
        if(charge_data.charge_basis && charge_data.charge_basis.includes("%")){
          charge_data.charge_currency = sellRates.leg_currency;
          var charge_cost = (charge_data.charge_type === 'SLAB' && charge_data.slab_type === 'INCREMENTAL') ? totalSlabCost : ((total_units * (parseFloat(charge_data.per_unit_rate) || 0))/100);
        }else{
          var charge_cost = (charge_data.charge_type === 'SLAB' && charge_data.slab_type === 'INCREMENTAL') ? totalSlabCost : (total_units * (parseFloat(charge_data.per_unit_rate) || 0));
        }

        //charge cost value for vas charges
        charge_cost = ((sellRates.leg_code == 'additional_services') && charge_data.per_unit_rate != undefined && charge_data.per_unit_rate != 0 && isNaN(charge_data.per_unit_rate)) ? charge_data.per_unit_rate : charge_cost;

        charge_data.charge_cost = charge_cost;
        
        charge_data.leg_currency_cost = isNaN(charge_cost) ? 0 : shareQuoteService.currencyConverter.convert(parseFloat(charge_cost),charge_data.charge_currency, sellRates.leg_currency, isMarkup);

        charge_data.customer_currency_cost = isNaN(charge_cost) ? 0 : shareQuoteService.currencyConverter.convert(parseFloat(charge_cost),charge_data.charge_currency, sellRates.leg_total_currency, true);

        sellRates.leg_currency_cost -= prev_charge_leg_cost;
        sellRates.leg_currency_cost += charge_data.leg_currency_cost;

        sellRates.leg_total_cost -= prev_cust_curr_cost;
        sellRates.leg_total_cost += charge_data.customer_currency_cost;
      }

      //Get charge cost
      function getChargeCost(leg_data, charge_data, search_currency){
        if(charge_data.per_unit_rate != null && charge_data.total_units != null){
          var basisArray = [shareQuoteService.airBasisName, shareQuoteService.pickupBasisName, shareQuoteService.deliveryBasisName,shareQuoteService.freightBasisName];

          var per_unit = ( parseFloat(charge_data.per_unit_rate) || 0 ) ;
          var total_units = charge_data.total_units == '' ? 0 : parseFloat(charge_data.total_units);

          if(charge_data.charge_basis && charge_data.charge_basis.includes("%")){
            charge_data.charge_currency = leg_data.leg_currency;
            charge_data.charge_cost =  ((per_unit * total_units)/100);
          }else{
            charge_data.charge_cost =  (per_unit * total_units);
          }

          charge_data.charge_cost = ( (leg_data.leg_code == 'additional_services') && charge_data.per_unit_rate != undefined && charge_data.per_unit_rate != 0 && isNaN(charge_data.per_unit_rate) ) ? charge_data.per_unit_rate : charge_data.charge_cost;

          var charge_value = angular.copy(charge_data.charge_cost);

          if(charge_data.charge_currency != ''){
            shareQuoteService.getCustCurrencyCost(leg_data, charge_data, charge_value, search_currency);
          }
        }
      }

      // get charge leg currency & customer base currency
      function getCustCurrencyCost(leg_data, charge_data, charge_value, search_currency){
        var prev_charge_leg_cost = angular.copy(charge_data.leg_currency_cost);
        var isMarkup = leg_data.leg_currency === search_currency ? true : false;

        if( leg_data.iataCommission && (charge_data.global_charge_id.indexOf(shareQuoteService.airChargeId)) >= 0 && (leg_data.iata_commission || leg_data.iata_incentive) ){
            prev_charge_leg_cost = (prev_charge_leg_cost - prev_charge_leg_cost*0.01*leg_data.iata_commission);
            prev_charge_leg_cost = prev_charge_leg_cost - prev_charge_leg_cost*0.01*leg_data.iata_incentive;
        }

        if( charge_data.minimum_charge_cost && !isNaN(charge_data.minimum_charge_cost) && ( ( parseFloat(charge_data.minimum_charge_cost) || 0 )  > ( parseFloat(charge_value) || 0 ) ) ){

          charge_data.charge_cost = isNaN(charge_data.minimum_charge_cost) ? 0 : (parseFloat(charge_data.minimum_charge_cost) || 0);

          charge_data.leg_currency_cost = isNaN(charge_data.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.minimum_charge_cost), charge_data.charge_currency, leg_data.leg_currency, isMarkup));
          

          charge_data.customer_currency_cost = isNaN(charge_data.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.minimum_charge_cost), charge_data.charge_currency, leg_data.leg_total_currency, true));

          charge_data.min_flag = 1;
          charge_data.max_flag = 0;
        }else if( charge_data.maximum_charge_cost && !isNaN(charge_data.maximum_charge_cost) && ( ( parseFloat(charge_data.maximum_charge_cost) || 0 )  < ( parseFloat(charge_value) || 0 ) ) ){

          charge_data.charge_cost = isNaN(charge_data.maximum_charge_cost) ? 0 : (parseFloat(charge_data.maximum_charge_cost) || 0);

          charge_data.leg_currency_cost = isNaN(charge_data.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.maximum_charge_cost), charge_data.charge_currency, leg_data.leg_currency, isMarkup));

          charge_data.customer_currency_cost = isNaN(charge_data.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.maximum_charge_cost), charge_data.charge_currency, leg_data.leg_total_currency, true));
          charge_data.min_flag = 0;
          charge_data.max_flag = 1;
        }else{

          charge_data.leg_currency_cost = isNaN(charge_data.charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.charge_cost), charge_data.charge_currency, leg_data.leg_currency, isMarkup));

          charge_data.customer_currency_cost = isNaN(charge_data.charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge_data.charge_cost), charge_data.charge_currency, leg_data.leg_total_currency, true));

          charge_data.max_flag = 0;
          charge_data.min_flag = 0;
        }

        var marginCommission = angular.copy(charge_data.leg_currency_cost);

        if( leg_data.iataCommission && (charge_data.global_charge_id.indexOf(shareQuoteService.airChargeId)) >= 0 && (leg_data.iata_commission || leg_data.iata_incentive) ){

          marginCommission = (marginCommission - marginCommission*0.01*leg_data.iata_commission);
          marginCommission = marginCommission - marginCommission*0.01*leg_data.iata_incentive;

        }
          shareQuoteService.fnGetLegTotal(leg_data, marginCommission, prev_charge_leg_cost);
      }


      //Get leg total currency
      function fnGetLegTotal(leg_data, new_charge_leg_cost, prev_charge_leg_cost){
        if(!shareQuoteService.addLclAirCharge){
          leg_data.leg_currency_cost -= prev_charge_leg_cost;
        }
        leg_data.leg_currency_cost += new_charge_leg_cost;

        leg_data.leg_total_cost = calLegTotalByCustCurrCost(leg_data.charges);

        shareQuoteService.addLclAirCharge = false;
      }

      function LegCurrUpdate(rates, leg_key, leg_currency, mode, l3LegKey, search_currency){
        var total_charge_cost = 0;
        var isMarkup = leg_currency === search_currency ? true : false;

        if(rates[leg_key].rate_obj){

          rates[leg_key].rate_obj.charges.forEach(function(charge){
            charge.leg_currency = leg_currency;
            var prev_cust_curr_cost = angular.copy(charge.customer_currency_cost);
            if(charge.charge_basis === constObj.FREIGHT_TOTAL_BASIS){
              charge.charge_currency = leg_currency;
              if(l3LegKey){
                charge.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(rates[l3LegKey].rate_obj.leg_currency_cost),rates[l3LegKey].rate_obj.leg_currency,rates[leg_key].rate_obj.leg_currency);
              }
            }


            // if minimum cost is greater than charge cost
            if( (charge.minimum_charge_cost && !isNaN(charge.minimum_charge_cost) && ( parseFloat(charge.minimum_charge_cost) || 0 )  > ( parseFloat(charge.charge_cost) || 0 )) && (mode!=='SEA-FCL')){
              charge.leg_currency_cost = isNaN(charge.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge.minimum_charge_cost), charge.charge_currency, leg_currency, isMarkup));

              charge.customer_currency_cost = isNaN(charge.minimum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge.minimum_charge_cost), charge.charge_currency, rates[leg_key].rate_obj.leg_total_currency, true));

            }else if( (charge.maximum_charge_cost && !isNaN(charge.maximum_charge_cost) && ( parseFloat(charge.maximum_charge_cost) || 0 )  < ( parseFloat(charge.charge_cost) || 0 )) && (mode!=='SEA-FCL')){
              charge.leg_currency_cost = isNaN(charge.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge.maximum_charge_cost), charge.charge_currency, leg_currency, isMarkup));

              charge.customer_currency_cost = isNaN(charge.maximum_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge.maximum_charge_cost), charge.charge_currency, rates[leg_key].rate_obj.leg_total_currency, true));

            }else{
              charge.leg_currency_cost = isNaN(charge.charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge.charge_cost), charge.charge_currency, leg_currency, isMarkup));

              charge.customer_currency_cost = isNaN(charge.charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(charge.charge_cost), charge.charge_currency, rates[leg_key].rate_obj.leg_total_currency, true));
            }

            var marginCommission = angular.copy(charge.leg_currency_cost);
            //check and apply margin and commission
            if( charge.global_charge_id != null && (charge.global_charge_id.indexOf(shareQuoteService.airChargeId)) >= 0 && (rates[leg_key].rate_obj.iata_commission || rates[leg_key].rate_obj.iata_incentive) ){
              marginCommission = (marginCommission - marginCommission*0.01*rates[leg_key].rate_obj.iata_commission);
              marginCommission = marginCommission - marginCommission*0.01*rates[leg_key].rate_obj.iata_incentive;
              total_charge_cost += marginCommission;
            }
            else{
              total_charge_cost += charge.leg_currency_cost;
            }
            rates[leg_key].rate_obj.leg_total_cost -= prev_cust_curr_cost;
            rates[leg_key].rate_obj.leg_total_cost += charge.customer_currency_cost;
          })

          rates[leg_key].rate_obj.leg_currency_cost = total_charge_cost;
          rates[leg_key].rate_obj.leg_total_cost = isNaN(total_charge_cost) ? 0 : (shareQuoteService.currencyConverter.convert(parseFloat(total_charge_cost), leg_currency, rates[leg_key].rate_obj.leg_total_currency, false));
        }
      }

      function addChargeName(charge_id,index, leg_data, main_charge_list){
        var temCharges = angular.copy(leg_data.charges);
        temCharges.splice(index,1);
        var ischargePresent = Object.keys(temCharges).some(function(key) {
            if(temCharges[key].charge_id == charge_id){
                return true;
            }
            return false;
        });

        if(ischargePresent){
          util.showToast('Charge already exist! Please Select another charge');
          leg_data.charges[index].charge_name = "";
          leg_data.charges[index].charge_id = "";
          leg_data.charges[index].global_charge_id = "";
          leg_data.charges[index].charge_basis = "";
          leg_data.charges[index].total_units =  0;
          leg_data.charges[index].charge_cost = 0;
          leg_data.charges[index].leg_currency_cost = 0;
          return;
        }

        for (var i = 0; i < main_charge_list.length; i++) {
          if(main_charge_list[i].charge_id === charge_id){
            leg_data.charges[index].charge_name = main_charge_list[i].charge_name ;
            leg_data.charges[index].charge_id = main_charge_list[i].charge_id ;
            leg_data.charges[index].global_charge_id = main_charge_list[i].global_charge_id;
            leg_data.charges[index].charge_category = main_charge_list[i].charge_category;
            leg_data.charges[index].charge_code = main_charge_list[i].charge_code;
            leg_data.charges[index].charge_basis = "";
            leg_data.charges[index].total_units =  0;
            leg_data.charges[index].charge_cost = 0;
            leg_data.charges[index].leg_currency_cost = 0;
          }
        }
      }

      function addChargeInLeg(leg_data){
        leg_data.charges.push({
            "charge_id": "",
            "charge_name": "",
            "charge_description": "",
            "charge_basis": "",
            "charge_category":null,
            "per_unit_rate": '',
            "total_units": '',
            "charge_cost": 0,
            "charge_currency": '',
            "minimum_charge_cost": '',
            "maximum_charge_cost": '',
            "min_flag": 0,
            "global_charge_id": "",
            "customer_currency_cost": 0,
            "leg_currency_cost": 0,
            "charge_code" : ""
        });
      }

      function changeSelectedCharge(selectedName, charge, sell_rates, index,legKey){

        if(selectedName != null){

          if(selectedName && !!(selectedName.source)){
            charge['source'] = selectedName.source;
            charge['source_data'] = selectedName.source_data;
          }


          var temCharges = angular.copy(sell_rates.charges);
          temCharges.splice(index,1);
          var ischargePresent = Object.keys(temCharges).some(function(key) {
              if(temCharges[key].charge_id == selectedName.charge_id &&  (!temCharges[key].status || temCharges[key].status !== "REMOVED")){
                  return true;
              }
              return false;
          });

          if(ischargePresent){
            angular.element('.' + legKey + index + 'remove-rates-bg').removeClass("rates-bg");
            document.querySelector('#' + legKey + '_' + index + '_row').classList.add("row-error");
            angular.element('#' +legKey + '_' + index + '_charge').addClass("error-border");
            angular.element('#' +legKey + '_' + index + '_duplicateCharge').addClass("error-text");
          
            charge.charge_name = null;
            charge.charge_id = "";
            charge.global_charge_id = "";
            charge.charge_basis = null;
            charge.total_units = 0;
            charge.per_unit_rate = 0;
          }else{
            charge.charge_name = selectedName.charge_name;
            charge.charge_code = selectedName.charge_code;
            charge.charge_id = selectedName.charge_id;
            charge.global_charge_id = selectedName.global_charge_id;
            charge.charge_basis = null;
            charge.total_units = 0;
            charge.per_unit_rate = 0;
          }
        }
        else{
            charge.charge_name = null;
            charge.charge_id = "";
            charge.global_charge_id = "";
            charge.charge_basis = null;
            charge.total_units = 0;
            charge.per_unit_rate = 0;
        }
      }

    function fnProcessTermsString(str){
      var parser = new DOMParser;
      var dom = parser.parseFromString(
          '<!doctype html><body>' + str,
          'text/html');
      var str = dom.body.textContent;
      return str;
    }

    function fnInitializeQuoteDetails(l2_cha, l4_cha){
      var quoteDetails = {
        customs: (l2_cha || l4_cha) ? true : false,
        hazardous: false,
        perishable: false,
        start_date : new Date(),
        expiry_date : null,
        generate_pdf : false,
        print_schedule : false,
        send_mail : false,
        show_zero_sell_rates : $rootScope.domainData.domain_info["ENABLE_ZERO_SELL_RATES_ON_PDF_CHECKBOX"] ? false : true,
        cc_emails : []
      };
      return quoteDetails;
    }

    function fnsortCardsExpiry(item1,item2){
      var dateA = new Date(item1.data.buy_rates[shareQuoteService.l3_mode].rate_obj.expiry).getTime();
      var dateB = new Date(item2.data.buy_rates[shareQuoteService.l3_mode].rate_obj.expiry).getTime();
      return dateA < dateB ? 1 : -1;
    };

    function fnsortExpiryFinal(item1,item2){
      var dateA = new Date(item1).getTime();
      var dateB = new Date(item2).getTime();
      return dateA > dateB ? 1 : -1;
    };

    function max_date(all_dates) {
      var max_dt = all_dates[0];
      var max_dtObj = new Date(all_dates[0]);
      all_dates.forEach(function(dt, index){
        if ( new Date( dt ) > max_dtObj){
          max_dt = dt;
          max_dtObj = new Date(dt);
        }
      });
      return max_dt;
    }

    function fnValidateExpiryDate(selectedCard,cargo_ready_date, l3_mode){

      var expiryCardArray = [];
      angular.forEach(selectedCard, function (item, index) {
        if(item.data.buy_rates[l3_mode].rate_obj.expiry){
          expiryCardArray.push(item.data.buy_rates[l3_mode].rate_obj.expiry);
        }
      });

      expiryCardArray.push(moment.utc(cargo_ready_date).format());
      var result = shareQuoteService.max_date(expiryCardArray);
      return result;
    }


    function fnGetBuyChargeCurrency(id, buy_leg, charge_key){
      var result = '-';
      if(buy_leg.rate_obj){
        var chargeObj = $filter('filter')(buy_leg.rate_obj.charges,{'id' : id }, true);
        result = chargeObj.length ? chargeObj[0][charge_key]  : '-';
      }
      return result;
    }

    function fnGetBuyChargeCost(id, buy_leg, charge_key){
        var result = '-';
        if(buy_leg.rate_obj){
          var chargeObj = $filter('filter')(buy_leg.rate_obj.charges,{'id' : id }, true);
          result = chargeObj.length ? $filter('number')(chargeObj[0][charge_key], 2) : '-';
        }
        return result;
    }

    function getSelectedCardSubvendor(cards, action){
      var subVendorList = [];
      cards.map(function(card){
        angular.forEach(card.data.buy_rates, function(buy_value){
          if(buy_value.rate_obj && buy_value.rate_obj.global_leg_id == 'l3'){

            if( action == 'liner' && (buy_value.rate_obj.sub_vendor.sub_vendor_name != null &&  buy_value.rate_obj.sub_vendor.sub_vendor_name != '') ){
                subVendorList.push(buy_value.rate_obj.sub_vendor.sub_vendor_name);
            }
            else if( action == 'vendor' && (buy_value.rate_obj.vendor.vendor_name != null &&  buy_value.rate_obj.vendor.vendor_name != '' && (subVendorList.indexOf(buy_value.rate_obj.vendor.vendor_name))) ){
              subVendorList.push(buy_value.rate_obj.vendor.vendor_name);
            }
          }
        });
      });
      return subVendorList.toString();
    }

    function getAirlineName(airlineObj) {
      var result = [];
      for (var i = 0; i < airlineObj.length; i++) {
          if (airlineObj[i].air_line_name != "" && airlineObj[i].air_line_name != null ) {
            result.push(airlineObj[i].air_line_name);
          }
      }
      return result.toString();
    }


    function fnRateEditValidation(currentCard, editBuyRate, search_param,UnModifiedCard,pageSource){
      var isDone = 1;
      var slabBreak = 1;
      shareQuoteService.chargeValidation = {};
      const leg_map= {}
      var validityStatus = {};
      for (var i in currentCard.data.sell_rates) {
        if(currentCard.data.sell_rates[i].rate_obj && currentCard.data.sell_rates[i].rate_obj.charges.length){
          var value = currentCard.data.sell_rates[i];
          validityStatus = shareQuoteService.sellRateValidation(leg_map,value,i,isDone);
          isDone = validityStatus.isDone;
          if(validityStatus.isBreak){
            break;
          }
          for (var j = value.rate_obj.charges.length-1; j >= 0; j--) {
            var charge = value.rate_obj.charges[j];
            validityStatus = shareQuoteService.sellRateChargeValidation(value,charge,i,j,isDone,slabBreak,search_param.mode,value.rate_obj.charges);
            isDone = validityStatus.isDone;
            if(validityStatus.isBreak){
              break;
            }
            if ( charge.charge_name && currentCard.meta["isRateGlobal"] && currentCard.meta["isRateGlobal"] == 'Yes' &&(!charge.charge_id || charge.charge_id.startsWith("UD"))) { //charge.charge_id == "~*~"
              // util.showToast("Please select charge from existing charge list.");
              if(document.querySelector('#' + value.leg_code + '_' + j + '_duplicateCharge')){
                document.querySelector('#' + i + '_' + j + '_duplicateCharge').classList.remove("error-text");
              }

              shareQuoteService.userDefinedChargeValidation = true;
              document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
              document.querySelector('#' + i + '_' + j + '_charge').classList.add("error-border");
              document.querySelector('#' + i + '_' + j + '_userDefinedChargeError').classList.add("error-text");
              angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
              // angular.element('#' + i + '_' + j + '').focus();
              shareQuoteService.chargeValidation.globalRates = 'invalid';
              isDone = 0;
            }
          }
          if (isDone === 0) {
            shareQuoteService.chargeValidation.sellMinimum = 'invalid';
            break;
          }
        }
      }

      if(editBuyRate){
        for (var i in currentCard.data.buy_rates) {
          var value = currentCard.data.buy_rates[i];
          if(value.rate_obj){
            for (var j = 0; j < value.rate_obj.charges.length; j++) {
              var charge = value.rate_obj.charges[j];
            if(pageSource && pageSource.toLowerCase().includes('quote') && UnModifiedCard){
                //code for activity capture on buy rate edit
                var UnModifiedCharge = null;
                if(UnModifiedCard.data.buy_rates[i]){
                  UnModifiedCharge = UnModifiedCard.data.buy_rates[i].rate_obj.charges.find(function(tempUnModifiedCharge){
                    return charge.charge_basis == tempUnModifiedCharge.charge_basis && charge.container_type == tempUnModifiedCharge.container_type && charge.charge_name ==  tempUnModifiedCharge.charge_name
                  })
                }
                if(UnModifiedCharge && (charge.charge_currency != UnModifiedCharge.charge_currency || charge.per_unit_rate != UnModifiedCharge.per_unit_rate || charge.minimum_charge_cost != UnModifiedCharge.minimum_charge_cost || charge.maximum_charge_cost != UnModifiedCharge.maximum_charge_cost ) &&  !(charge.manual) ){
                  currentCard['meta']['buyRateEdit'] = true;
                }
            }
              validityStatus = shareQuoteService.buyRateValidation(value,charge,i,j,isDone,slabBreak,search_param.mode);
              isDone = validityStatus.isDone;
              if(validityStatus.isBreak){
                break;
              }
            }
          }
          if (isDone === 0) {
            shareQuoteService.chargeValidation.buyMinimum = 'invalid';
            break;
          }
        }
      }
      return isDone;
    }
    function sellRateValidation(leg_map,value,i,isDone){
      var validityStatus = {
        isDone:isDone,
        isBreak:false
      }
      leg_map[value.leg_name.toLowerCase()]=(leg_map[value.leg_name.toLowerCase()] || 0) + 1
          var idx = "";
          if(leg_map[value.leg_name.toLowerCase()]>1){
            idx=i;
            document.querySelector('#' + idx + '_leg').classList.add("error-border");
            document.querySelector('#' +idx+'_duplicateText').classList.add("error-text");
            isDone = 0;
          }
          else{
          if(document.querySelector('#' +i+'_duplicateText')&&( document.querySelector('#' + i + '_leg'))){
            document.querySelector('#' + i+'_duplicateText').classList.remove("error-text");
            document.querySelector('#' + i + '_leg').classList.remove("error-border");
          }
          }

          if (value.leg_name == undefined || value.leg_name == null || value.leg_name == "") {
            if(document.querySelector('#' + i +'_duplicateText')){
              document.querySelector('#' + i +'_duplicateText').classList.remove("error-text");
            }

            document.getElementById( i + '_leg').classList.add('error-border');
            document.querySelector('#' + i +'_text').classList.add("error-text");
            isDone = 0;
            validityStatus.isDone = isDone;
            validityStatus.isBreak = true;
            return validityStatus;
          }
          validityStatus.isDone = isDone;
          validityStatus.isBreak = false;
          return validityStatus;

    }
    function fnDuplicateCharge(chargeArray, currentCharge, index){
      var tempCharges = angular.copy(chargeArray);
      tempCharges.splice(index,1);

      var isChargePresent = Object.keys(tempCharges).some(function(key) {
        var isChargeNameDuplicate = tempCharges[key]["status"] != "REMOVED" && currentCharge["status"] != "REMOVED" &&((tempCharges[key].charge_name).toLowerCase() == (currentCharge.charge_name).toLowerCase() || tempCharges[key].charge_id && tempCharges[key].charge_id == currentCharge.charge_id);
        
        if( isChargeNameDuplicate && 
          tempCharges[key].charge_basis == currentCharge.charge_basis && tempCharges[key].container_type &&
          tempCharges[key].container_type == currentCharge.container_type ){
          return true;
        }
        else if(isChargeNameDuplicate && 
          tempCharges[key].charge_basis == currentCharge.charge_basis){
          return true;
        }
        return false;
      });

      return isChargePresent;
    }

    function getChargeName(data){
      data.leg = data.leg.includes('sop') ? 'sop_leg' : data.leg ;
      var url = api.baseUrl + '/api/chargeline ';
      return $http.post(url,data);
    }

    //get charge name suggestion list
    function getChargeList (searchText , global_leg_id, chargeObj, search_param) {

      var obj = {
          'mode': search_param.mode,
          'leg': global_leg_id,
          "search": searchText,
          "search_param" : search_param
      }

      return shareQuoteService.getChargeName(obj).then(function (response) {
          var Charge_name_list = [];
          var j;
          if(response.data.length){
            if(search_param.mode === 'SEA-FCL'){
              for (var i = 0; i < response.data.length; i++) {
                Charge_name_list.push({
                  "charge_id": response.data[i].charge_id,
                  "charge_name": response.data[i].charge_name,
                  "charge_category": response.data[i].charge_category,
                  "charge_basis" : response.data[i].charge_basis,
                  "load_code": response.data[i].container_type,
                  "charge_currency": response.data[i].charge_currency,
                  "container_type": response.data[i].container_type,
                  "per_unit_rate": response.data[i].per_unit_rate,
                  "global_charge_id": response.data[i].global_charge_id,
                  "name_alias": response.data[i].charge_name ,
                  "source" : response.data[i].source ? response.data[i].source : null ,
                  "source_data" : response.data[i].source_data ? response.data[i].source_data : null,
                  "charge_code" : response.data[i].charge_code
                });
              }
            }else{
              for(var i = 0; i < response.data.length; i++){
                Charge_name_list.push({
                    "charge_id": response.data[i].charge_id,
                    "charge_name":response.data[i].charge_name,
                    "charge_basis" : response.data[i].charge_basis,
                    "global_charge_id" : response.data[i].global_charge_id,
                    "name_alias" : response.data[i].charge_name,
                    "source" : response.data[i].source ? response.data[i].source : null ,
                    "source_data" : response.data[i].source_data ? response.data[i].source_data : null,
                    "charge_category": response.data[i].charge_category,
                    "charge_code": response.data[i].charge_code 
                });
              }
            }
          }
          return Charge_name_list;
      }, function (error) {
          $log.log(error);
          return [];
      });
    }

    function showCargoCommodity(ev, card_id, leg, type, mode) {
      var position = $mdPanel.newPanelPosition()
        .relativeTo('.cargo-'+card_id)
        .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: 'app/main/component/cargo-commodity-view/cargo-commodity-view.html',
        controllerAs: 'ctrl',
        controller: 'CargoCommodityViewController',
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          'cargo_type_data': leg.rate_obj.cargo_type_data,
          'commodity_data': leg.rate_obj.commodity_data
        },
        onOpenComplete: function () {
          // cargoCommodityViewFactory.panelClosed = false;
        },
        onRemoving: function () {
          // cargoCommodityViewFactory.panelClosed = true;
        }
      };

      $mdPanel.open(config);
    }

    function commodityString(commodity_data){
      var tempArray = [];
      angular.forEach(commodity_data, function(el){
        var title = el.commodity_title ? el.commodity_title : el;

        if(title && tempArray.indexOf(title) == -1){
          tempArray.push(title);
        }
      });

      commodity_data = angular.copy(tempArray);
      return commodity_data;
    }


    function setCurrencyConvSetting(baseCurrency,markup,directCurrencyMapping,curr_data){
      markup = markup ? markup : null;
      directCurrencyMapping = directCurrencyMapping && directCurrencyMapping.length ? directCurrencyMapping : [];
      if(!curr_data){
        util.showToast("Something went wrong!");
      }
      var exchangeRate = new fbUtils.ExchangeRate(baseCurrency, curr_data);
      var currencySetting = new fbUtils.CurrencySetting(markup, exchangeRate, directCurrencyMapping);
      shareQuoteService.currencyConverter = fbUtils.CurrencyConverter.getInstance(currencySetting);
      basisCalculation.currencyConverter = fbUtils.CurrencyConverter.getInstance(currencySetting);
    }


    function cargoInputDisabled(card_vendorId) {
      if(localStorageService.get('authToken').value.vendor_id == card_vendorId) {
        return false;
      }
      else {
        return true;
      }
    }

    function calLegTotalByCustCurrCost(charge_data){
      var legTotal = 0;
      angular.forEach(charge_data, function (item) {
        legTotal+= item.customer_currency_cost;
      });
      return legTotal;
    }

    // Function to get list of DIM calculation w.r.t leg
    function fnGetDimLegs(legData){
      var dimLegList = [];
      angular.forEach(legData, function (item) {
        if(item.rate_obj && item.rate_obj.dim && item.rate_obj.dim_data){
          dimLegList.push({
            'leg_name': item.leg_name,
            'cbm' : item.rate_obj.dim_data.cbm
          });
        }
      });
      return dimLegList;
    }

    function fnGuuid() {
      return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }

    function copysellToBuy(cardData, mode, l3_leg){
      var expiryDate = cardData.data.sell_rates[l3_leg].rate_obj.expiry ? moment(cardData.data.sell_rates[l3_leg].rate_obj.expiry).format('YYYY-MM-DD') : null;
      var sailingDate = cardData.data.sell_rates[l3_leg].rate_obj.sailing_date ? moment(cardData.data.sell_rates[l3_leg].rate_obj.sailing_date).format('YYYY-MM-DD') : null;

        cardData.data.buy_rates[l3_leg].rate_obj.sub_vendor_id = cardData.data.sell_rates[l3_leg].rate_obj.sub_vendor_id;
        cardData.data.buy_rates[l3_leg].rate_obj.sub_vendor.sub_vendor_name = cardData.data.sell_rates[l3_leg].rate_obj.sub_vendor.sub_vendor_name;
        cardData.data.buy_rates[l3_leg].rate_obj.sub_vendor.carrier_code = cardData.data.sell_rates[l3_leg].rate_obj.sub_vendor.carrier_code;

        if(mode == 'AIR'){
          var arrivalDate = cardData.data.sell_rates[l3_leg].rate_obj.arrival_time ? moment(cardData.data.sell_rates[l3_leg].rate_obj.arrival_time).format('YYYY-MM-DD') : null;
          var departureDate = cardData.data.sell_rates[l3_leg].rate_obj.departure_time ? moment(cardData.data.sell_rates[l3_leg].rate_obj.departure_time).format('YYYY-MM-DD') : null;

          cardData.data.buy_rates[l3_leg].rate_obj.airline.air_line_name = cardData.data.sell_rates[l3_leg].rate_obj.airline.air_line_name;
          cardData.data.buy_rates[l3_leg].rate_obj.airline.airline_code = cardData.data.sell_rates[l3_leg].rate_obj.airline.airline_code;
          cardData.data.buy_rates[l3_leg].rate_obj.airline.airline_prefix = cardData.data.sell_rates[l3_leg].rate_obj.airline.airline_prefix;
          // arrival date
          cardData.data.buy_rates[l3_leg].rate_obj.arrival_time = arrivalDate;
          cardData.data.sell_rates[l3_leg].rate_obj.arrival_time = arrivalDate;
          // departure date
          cardData.data.buy_rates[l3_leg].rate_obj.departure_time = departureDate;
          cardData.data.sell_rates[l3_leg].rate_obj.departure_time = departureDate;
        }
        // expiry date
        cardData.data.sell_rates[l3_leg].rate_obj.expiry = expiryDate;
        cardData.data.buy_rates[l3_leg].rate_obj.expiry = expiryDate;
        // sailing date
        cardData.data.sell_rates[l3_leg].rate_obj.sailing_date = sailingDate;
        cardData.data.buy_rates[l3_leg].rate_obj.sailing_date = sailingDate;
        
        cardData.data.buy_rates[l3_leg].rate_obj.service_type = cardData.data.sell_rates[l3_leg].rate_obj.service_type; // service type
        cardData.data.buy_rates[l3_leg].rate_obj.via_route = cardData.data.sell_rates[l3_leg].rate_obj.via_route; // via_route
        cardData.data.buy_rates[l3_leg].rate_obj.transit_time = cardData.data.sell_rates[l3_leg].rate_obj.transit_time; //transite time
        // commodity data
        cardData.data.buy_rates[l3_leg].rate_obj.commodity_data = angular.copy(cardData.data.sell_rates[l3_leg].rate_obj.commodity_data);
        cardData.data.buy_rates[l3_leg].rate_obj.cargo_type_data = angular.copy(cardData.data.sell_rates[l3_leg].rate_obj.cargo_type_data); //cargo type

    }
    //iterating the card data to fill the basis meta for % on charge
    function fnFillBasisMeta(rates,card,mode){
      Object.keys(rates).forEach(function(legCode){
        if(rates[legCode].rate_obj){
            rates[legCode].rate_obj.charges.forEach(function(chargeData,index){
            shareQuoteService.fnFillBasisMetaCharge(chargeData, card.data.buy_rates[legCode].rate_obj.charges[index],rates[legCode].rate_obj.leg_code,mode);
          })
        }
      })
    }
    //check charge data and fill respective meta value for % on charge
    function fnFillBasisMetaCharge(charge_data,buy_charge_data, legCode,mode){
        var checkCharge = false;
        if(charge_data.total_units != null){
          var checkCharge = {parent:false,basis:""};
          //check parent 
          var parent =  basisCalculation.isParent(charge_data,mode);
          var childBasis = null;
          if(parent){
            //return  child basis for the parent
            childBasis = basisCalculation.getChildBasis(charge_data,mode);
          }
          if( parent  && legCode && legCode.toLowerCase().includes('l3_') && childBasis === constObj.AIR_FREIGHT_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }else if( parent  && legCode && legCode.toLowerCase().includes('l1_') && childBasis === constObj.PICKUP_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }else if( parent  && legCode && legCode.toLowerCase().includes('l5_') && childBasis === constObj.DELIVERY_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }else if( parent  && legCode && legCode.toLowerCase().includes('l3_') && childBasis === constObj.FREIGHT_BASIS){
            return fillParentData(childBasis,charge_data,buy_charge_data, mode);
          }
        }
        return checkCharge;
    }
    function fillParentData(childBasis,charge_data,buy_charge_data,mode){
      //per equipment only consider as the parent for fcl
      var container_type = charge_data.charge_basis === 'per equipment' ? charge_data.container_type : null;
      if(container_type || (!(mode.toLowerCase().includes('fcl')) && ( !charge_data.charge_basis || (charge_data.charge_basis && !charge_data.charge_basis.includes('%'))))){
        basisCalculation.basisOnTotalObj[childBasis] = basisCalculation.basisOnTotalObj[childBasis]  || {};
        basisCalculation.basisOnTotalObj[childBasis].parent = basisCalculation.basisOnTotalObj[childBasis].parent || {}
        basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'] = basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'] || {};
        basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].buy = buy_charge_data;
        basisCalculation.basisOnTotalObj[childBasis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].sell = charge_data;
        return {parent:true,basis:childBasis};
      }else{
        return {parent:false,basis:childBasis};

      }

    }
    
   
      //return l3 leg key
      function getL3LegKey(currentCard){
        var l3LegKey = null;
        if(currentCard){
          Object.keys(currentCard.data.sell_rates).forEach(function(legCode){
            if(currentCard.data.sell_rates[legCode].rate_obj.leg_code.toLowerCase().includes('l3_')){
              l3LegKey = legCode;
              return true;
            }
          });
        }
        return l3LegKey;
      }
   
    
    // function showDeleteBasisCharge(action, chargeName, currentCard, is_delete_l3_leg){

    //   if(action == 'quote'){
    //     angular.forEach(currentCard.data.sell_rates,function(value, key){
    //       shareQuoteService.airBasisLegCharge[key] = { "leg_name" : value.leg_name, "charges" : [] };
    //       shareQuoteService.pickupBasisLegCharge[key] = { "leg_name" : value.leg_name, "charges" : [] };
    //       shareQuoteService.deliveryBasisLegCharge[key] = { "leg_name" : value.leg_name, "charges" : [] };

    //       if(value.rate_obj){
    //         angular.forEach(value.rate_obj.charges,function(childValue){
    //           if(childValue.charge_basis == shareQuoteService.airBasisName && chargeName == 'air_charge'){
    //             shareQuoteService.airBasisLegCharge[key].charges.push(childValue);
    //           }
    //           else if(childValue.charge_basis == shareQuoteService.pickupBasisName && chargeName == 'pickup_charge'){
    //             shareQuoteService.pickupBasisLegCharge[key].charges.push(childValue);
    //           }
    //           else if(childValue.charge_basis == shareQuoteService.deliveryBasisName && chargeName == 'delivery_charge'){
    //             shareQuoteService.deliveryBasisLegCharge[key].charges.push(childValue);
    //           }
    //         });
    //       }

    //       if(!shareQuoteService.airBasisLegCharge[key].charges.length ){
    //         delete shareQuoteService.airBasisLegCharge[key];
    //       }
    //       if(!shareQuoteService.pickupBasisLegCharge[key].charges.length ){
    //         delete shareQuoteService.pickupBasisLegCharge[key];
    //       }
    //       if(!shareQuoteService.deliveryBasisLegCharge[key].charges.length ){
    //         delete shareQuoteService.deliveryBasisLegCharge[key];
    //       }
    //     });
    //   }

    //   if(action == 'quote' && Object.keys(shareQuoteService.airBasisLegCharge).length !== 0 && shareQuoteService.airBasisLegCharge["l3_air"] != undefined && (currentCard.data.sell_rates["l3_air"].rate_obj.charges.length == (shareQuoteService.airBasisLegCharge["l3_air"].charges.length +1) || currentCard.data.sell_rates["l3_air"].rate_obj.charges.length == (shareQuoteService.airBasisLegCharge["l3_air"].charges.length))){
    //     shareQuoteService.is_delete_l3_leg = true;
    //   }

    //   shareQuoteService.airBasisCharges = (Object.keys(shareQuoteService.airBasisLegCharge).length === 0 || is_delete_l3_leg.is_delete_l3_leg) ? false : true;
    //   shareQuoteService.all_pickup_basis_delete = (Object.keys(shareQuoteService.pickupBasisLegCharge).length === 0) ? false : true;
    //   shareQuoteService.all_delivery_basis_delete = (Object.keys(shareQuoteService.deliveryBasisLegCharge).length === 0) ? false : true;
    // }
    function showCo2ContainerData(ev, card_id, co2eData) {
      var position = $mdPanel.newPanelPosition()
        .relativeTo('.co2e-'+card_id)
        .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: 'app/main/component/co2-emission/co2-emission-panel.html',
        controllerAs: 'ctrl',
        controller: 'Co2EmissionPanelController',
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 10000,
        locals: {
          'co2e': co2eData,
        },
        onOpenComplete: function () {
          // co2eViewFactory.panelClosed = false;
        },
        onRemoving: function () {
          // co2eViewFactory.panelClosed = true;
        }
      };

      $mdPanel.open(config);
    }
    function sellRateChargeValidation(value,charge,i,j,isDone,slabBreak,mode,charges){
      var validityStatus = {
        isDone:isDone,
        isBreak:false
      }
      if(document.querySelector('#' + i + '_' + j + '_row') && document.querySelector('#' + i + '_' + j + '_row').classList.contains('row-error')){
              document.querySelector('#' + i + '_' + j + '_row').classList.remove("row-error");
            }

            if (!charge.charge_name) {
              if(document.querySelector('#' + value.leg_code + '_' + j + '_duplicateCharge')){
                document.querySelector('#' + i + '_' + j + '_duplicateCharge').classList.remove("error-text");
              }

              // util.showToast("Please enter charge name.");
              document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
              document.querySelector('#' + i + '_' + j + '_charge').classList.add("error-border");
              document.querySelector('#' + i + '_' + j + '_chargeError').classList.add("error-text");
              angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
              // var selection = document.querySelector('#' + i + '_' + j + '') !== null;
              // if (selection) {
            // document.querySelector('#' + i + '_' + j + '').focus();
              // } else {
              //   if(charge.charge_type == 'SLAB'){
              //     document.querySelector('#' + i + '_' + j + '_0_unit').focus();
              //   }else{
              //     document.querySelector('#' + i + '_' + j + '_unit').focus();
              //   }
              // }
              isDone = 0;
              
            }
            else{
              if(resultService.checkExistingCharge(charge,j,charges,i)){
                isDone = 0 ;
                validityStatus.isDone = isDone;
                validityStatus.isBreak = true;
                return validityStatus;
              }
            }
            if (!charge.charge_basis) {
              shareQuoteService.basisValidation = true;
              // util.showToast("Please select charge basis.");
              if(document.querySelector('#' + value.leg_code + '_' + j + '_duplicateBasis')){
                document.querySelector('#' + i + '_' + j + '_duplicateBasis').classList.remove("error-text");
              }

              document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
              document.querySelector('#' + i + '_' + j + '_chargeBasis').classList.add("error-border");
              document.querySelector('#' + i + '_' + j + '_basisError').classList.add("error-text");
              angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
              // document.querySelector('#' + i + '_' + j + '_unit').focus();
              isDone = 0;
            }

            if ((charge.charge_basis == 'per equipment' || charge.charge_basis == 'per kg' || charge.charge_basis == 'per ton' || charge.charge_basis === constObj.PICKUP_BASIS || charge.charge_basis === constObj.DELIVERY_BASIS || charge.charge_basis === constObj.FREIGHT_BASIS)&& !charge.container_type && mode === 'SEA-FCL') {
              shareQuoteService.containerValidation = true;
              // util.showToast("Please select equipment type");
              if(document.querySelector('#' + value.leg_code + '_' + j + '_duplicateEquipment')){
                document.querySelector('#' + i + '_' + j + '_duplicateEquipment').classList.remove("error-text");
              }

              document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
              document.querySelector('#' + i + '_' + j + '_equipmentType').classList.add("error-border");
              document.querySelector('#' + i + '_' + j + '_equipmentError').classList.add("error-text");
              angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
              // document.querySelector('#' + i + '_' + j + '_unit').focus();
              isDone = 0;
              // break;
            }
            if(charge.charge_basis == constObj.FREIGHT_TOTAL_BASIS && charge.total_units == null){
              isDone = 0;
            }
            if( (charge.charge_basis == constObj.AIR_FREIGHT_BASIS || charge.charge_basis == constObj.FREIGHT_BASIS || charge.charge_basis == constObj.PICKUP_BASIS || charge.charge_basis == constObj.DELIVERY_BASIS) && charge.total_units == null ){
              isDone = 0;
            }
            if (charge.is_qty_editable && charge.total_units <= 0 && typeof(charge.total_units)=="number") {
              shareQuoteService.quantityValidation = true;
              //util.showToast("Quantity should be greater than 0.");
              document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
              document.querySelector('#' + i + '_' + j + '_quantity').classList.add("error-border");
              document.querySelector('#' + i + '_' + j + '_quantityCharacter').classList.add("error-text");
              angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
              // document.querySelector('#' + i + '_' + j + '_unit').focus();
              isDone = 0;
              // break;
            }
            else{
              if (charge.is_qty_editable && (charge.total_units == null || charge.total_units == "")) {
                // util.showToast("Please enter valid quantity.");
                shareQuoteService.quantityValidation = true;
                document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
                document.querySelector('#' + i + '_' + j + '_quantity').classList.add("error-border");
                document.querySelector('#' + i + '_' + j + '_quantityError').classList.add("error-text");
                angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
                // document.querySelector('#' + i + '_' + j + '_unit').focus();
                isDone = 0;
              }
            }

            if(charge.charge_type=='SLAB'){
              for (var k = 0; k < charge.slab.length; k++) {
                if( charge.slab[k].cost == null || charge.slab[k].cost === "" || ( value.leg_code != 'additional_services' && isNaN(charge.slab[k].cost) ) ){
                    // util.showToast("Please enter valid unit price.");
                    document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
                    angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
                    // document.querySelector('#' + i + '_'+ j +'_' + k + '_unit').focus();
                    slabBreak = 0;
                  
                }else{
                    charge.slab[k].cost = !isNaN(charge.slab[k].cost) ? parseFloat(charge.slab[k].cost) : charge.slab[k].cost;
                }
              }
              if( charge.per_unit_rate != null && charge.per_unit_rate !== "" ){
                charge.per_unit_rate = !isNaN(charge.per_unit_rate) ? parseFloat(charge.per_unit_rate) : charge.per_unit_rate;
              }
              if(slabBreak == 0){
                  isDone = 0;
                
              }
            }else{
              if( charge.per_unit_rate == null || charge.per_unit_rate === "" || ( value.leg_code != 'additional_services'&& isNaN(charge.per_unit_rate)) ){
                // util.showToast("Please enter valid charge unit price.");
                shareQuoteService.sellValidation = true;
                document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
                document.querySelector('#' + i + '_' + j + '_sellUnit').classList.add("error-border");
                if(isNaN(charge.per_unit_rate)){
                  document.querySelector('#' + i + '_' + j + '_sellUnitCharacter').classList.add("error-text");
                }
                else{
                  document.querySelector('#' + i + '_' + j + '_sellUnitError').classList.add("error-text");
                }
                angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
                // document.querySelector('#' + i + '_' + j + '_unit').focus();
                isDone = 0;
              }else{
                  charge.per_unit_rate = !isNaN(charge.per_unit_rate) ? parseFloat(charge.per_unit_rate) : charge.per_unit_rate;
              }
            }

            if( mode != 'SEA-FCL' && charge.minimum_charge_cost!="" && charge.maximum_charge_cost!="" && !isNaN(charge.minimum_charge_cost) && !isNaN(charge.maximum_charge_cost) && (parseFloat(charge.minimum_charge_cost) > parseFloat(charge.maximum_charge_cost)) ){
              // util.showToast("Please enter valid minimum price.");
              shareQuoteService.sellMinimumValidation = true;
              document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
              document.querySelector('#' + i + '_' + j + '_sellMaximum').classList.add("error-border");
              
                document.querySelector('#' + i + '_' + j + '_sellMaximumError').classList.add("error-text");
              
              angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
              // document.querySelector('#' + i + '_' + j + '_min_unit').focus();
              isDone = 0;
            }
            validityStatus.isDone = isDone;
            validityStatus.isBreak = false;
            return validityStatus;

          }
    // To open the effective period panel which contains load wise effective period
    function showEffectivePeriodPanel(ev,card_id,loadWiseEffectivePeriod , loadDetails){
      var position = $mdPanel.newPanelPosition()
        .relativeTo('.effective-period-'+card_id)
        .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
        var config = {
          attachTo: angular.element(document.body),
          templateUrl: 'app/main/component/effective-period-panel/effective-period-panel.html',
          controllerAs: 'ctrl',
          controller: 'EffectivePeriodPanelController',
          position: position,
          openFrom: ev,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: false,
          zIndex: 10000,
          locals: {
            'effectivePeriod': loadWiseEffectivePeriod,
            'search_load_details' : loadDetails
          }
        };
        $mdPanel.open(config);
    }
  

function buyRateValidation(value,charge,i,j,isDone,slabBreak,mode){
  var validityStatus = {
    isDone:isDone,
    isBreak:false
  }
  if(charge.charge_type=='SLAB'){
    for (var k = 0; k < charge.slab.length; k++) {
      if( charge.slab[k].cost == null || charge.slab[k].cost === "" || ( value.leg_code != 'additional_services' && isNaN(charge.slab[k].cost) ) ){
          util.showToast("Please enter valid unit price.");
          document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
          angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
          // document.querySelector('#' + i + '_'+ j +'_' + k + '_buyUnit').focus();
          slabBreak = 0;
          break;
      }else{
          charge.slab[k].cost = !isNaN(charge.slab[k].cost) ? parseFloat(charge.slab[k].cost) : charge.slab[k].cost;
      }
    }
    if( charge.per_unit_rate != null && charge.per_unit_rate !== "" ){
      charge.per_unit_rate = !isNaN(charge.per_unit_rate) ? parseFloat(charge.per_unit_rate) : charge.per_unit_rate;
    }
    if(slabBreak == 0){
        isDone = 0;
        validityStatus.isDone = isDone;
        validityStatus.isBreak = true;
        return validityStatus;
    }
  }else{
    if( charge.per_unit_rate == null || charge.per_unit_rate === "" || ( value.leg_code != 'additional_services' && isNaN(charge.per_unit_rate)) ){
      // util.showToast("Please enter valid charge unit price.");
      shareQuoteService.buyValidation = true;
      document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
      document.querySelector('#' + i + '_' + j + '_buyUnit').classList.add("error-border");
      if(isNaN(charge.per_unit_rate)){
        document.querySelector('#' + i + '_' + j + '_buyUnitCharacter').classList.add("error-text");
      }
      else{
        document.querySelector('#' + i + '_' + j + '_buyUnitError').classList.add("error-text");
      }
      angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
      // document.querySelector('#'+i+'_'+j+'_buyUnit').focus();
      isDone = 0;
      
    }else{
        charge.per_unit_rate = !isNaN(charge.per_unit_rate) ? parseFloat(charge.per_unit_rate) : charge.per_unit_rate;
    }
  }

  if( mode != 'SEA-FCL' && charge.minimum_charge_cost!="" && charge.maximum_charge_cost!="" && !isNaN(charge.minimum_charge_cost) && !isNaN(charge.maximum_charge_cost) && (parseFloat(charge.minimum_charge_cost) > parseFloat(charge.maximum_charge_cost)) ){
    // util.showToast("Please enter valid minimum price.");
    shareQuoteService.buyMinimumValidation = true;
    document.querySelector('#' + i + '_' + j + '_row').classList.add("row-error");
    document.querySelector('#' + i + '_' + j + '_buyMaximum').classList.add("error-border");
    document.querySelector('#' + i + '_' + j + '_buyMaximumError').classList.add("error-text");
    angular.element('.' + i + j + 'remove-rates-bg').removeClass("rates-bg");
    // document.querySelector('#' + i + '_' + j + '_buy_min_unit').focus();
    isDone = 0;
    
  }
  validityStatus.isDone = isDone;
  validityStatus.isBreak = false;
  return validityStatus;
}


  }
})();

(function () {

  'use strict';

  angular
    .module('app.result')
    .factory('resultService', resultService);

  /** @ngInject */
  function resultService($q, $log, $mdToast, $state, $http, api, $filter, util, localStorageService, $rootScope, analytics , SearchService, constObj) {
    var resultService = {

      requestToBookData: {},
      confirmBooking: confirmBooking,
      bookResponseData: {},
      RateCardLegObj: {},
      arrAllCardObject: [],
      direct: 'direct',
      airlinesList: [],
      leg_selectObj: {
        'is_selected': false,
        'is_disabled': false,
        'is_available': false,
        'leg_name': ''
      },
      pref_liner: [],
      basicContainersShow: true,
      duplicateEquipment:false,
      userVendorID : (localStorageService.get('authToken') && localStorageService.get('authToken').value) ? parseInt(localStorageService.get('authToken').value.vendor_id) : null,
      isDownloadRatesLoader:false,
      updateSearchResult: updateSearchResult,
      getObjViaDirect: getObjViaDirect,
      getScheduleViaMetaRoute: getScheduleViaMetaRoute,
      sortByDeparture: sortByDeparture,
      getCardRemarksInclusion: getCardRemarksInclusion,
      isLegLoadMissing: isLegLoadMissing,
      getAnalytics: getAnalytics,
      getScheduleResponse: getScheduleResponse,
      shareQuote: shareQuote,
      quoteCreation:quoteCreation,
      formRateCardMsr: formRateCardMsr,
      calCardTotal: calCardTotal,
      getDelta: getDelta,
      getDataMsrFromUrl: getDataMsrFromUrl,
      getAdditionalLeg: getAdditionalLeg,
      getBookingRates: getBookingRates,
      getIncoterms: getIncoterms,
      getTermsConditions: getTermsConditions,
      getSubVendor: getSubVendor,
      getvendorData: getvendorData,
      getAirlineData: getAirlineData,
      fnsubmitLeg: fnsubmitLeg,
      updateCard: updateCard,
      deleteCard: deleteCard,
      setLegFilter: setLegFilter,
      setLegModeWise: setLegModeWise,
      fnSetRfqObj: fnSetRfqObj,
      fnSendRFQData: fnSendRFQData,
      searchCount: searchCount,
      matchRates: matchRates,
      fnBookingQty: fnBookingQty,
      fnGetInsuranseLeg: fnGetInsuranseLeg,
      getLowestCard: getLowestCard,
      getAllSalesPerson: getAllSalesPerson,
      fnSendRfqFile: fnSendRfqFile,
      getAgents: getAgents,
      getSalesPersonList: getSalesPersonList,
      getVasChargesByleg: getVasChargesByleg,
      applyVASLegToCard: applyVASLegToCard,
      fnCalculateSlab: fnCalculateSlab,
      getAdditionLegStructure: getAdditionLegStructure,
      fnAutoFetchBinding: fnAutoFetchBinding,
      trackMixPanelForInquiry: trackMixPanelForInquiry,
      getPoolingData: getPoolingData,
      getQtyRemaining: getQtyRemaining,
      getCardTerms: getCardTerms,
      fnGetConversionRates: fnGetConversionRates,
      currencyConversion: currencyConversion,
      applyCoupon: applyCoupon,
      dwnloadpdf: dwnloadpdf,
      getSpecialMeta: getSpecialMeta,
      fnCallScheduleUrl: fnCallScheduleUrl,
      fnCallConvFeeApi : fnCallConvFeeApi,
      formLoadStructure: formLoadStructure,
      getConvFee: getConvFee,
      fnCardFilter : fnCardFilter,
      fnSetTransitTime : fnSetTransitTime,
      // callConvenienceApi: callConvenienceApi,
      requiredLegUrl: requiredLegUrl,
      fnGetPdfLink: fnGetPdfLink,
      getResultType: getResultType,
      fnMatchRate: fnMatchRate,
      fnGetLegName: fnGetLegName,
      getCommodityList: getCommodityList,
      getCurrencyConversionForVendor : getCurrencyConversionForVendor,
      user_base_currency : "",
      getCargoList : getCargoList,
      cargoTypeList : [],
      getCargoTypeFixedOrder : getCargoTypeFixedOrder,
      fnMissingFlag: fnMissingFlag,
      searchLoadState: [],
      scheduleResponse: [],
      customFeilds:[],
      getSchedule:getSchedule,
      fnScheduleResponseBind:fnScheduleResponseBind,
      getLinersData: getLinersData,
      checkExistingCharge : checkExistingCharge,
      getScheduleSelectIndex:getScheduleSelectIndex,
      triggerDatatableButton:triggerDatatableButton,
      fnScheduleMatchingCard:fnScheduleMatchingCard,
      fnScheduleDisplayConfig:fnScheduleDisplayConfig,
      getSourceRate:getSourceRate,
      getBatchcode:getBatchcode,
      fnGetFetchLegs: fnGetFetchLegs,
      fnCreateRates: fnCreateRates,
      fnUpdateRates:fnUpdateRates,
      fnCo2ApiCall : fnCo2ApiCall,
      fnCalculateCo2Total : fnCalculateCo2Total,
      fnSetCo2Payload : fnSetCo2Payload,
      calculateChargeSummary:calculateChargeSummary,
      getCustomFeilds:getCustomFeilds,
      refreshQuoteData: {
        quote_id: '',
        quote_number: '',
        selectedCards: [],
        from_quote_search_param:{},
        oldCards:[]

      },
      getNoRatesList : getNoRatesList ,
      fnSetNoRates : fnSetNoRates,
      fnXenetaRateCall : fnXenetaRateCall
      
    };

    return resultService;

    function currencyConversion(amount, amountCurrency, conversionCurrency) {
      return (amount * conversionCurrency) / amountCurrency;
    }

    function getCustomFeilds(){
     if(!resultService.customFeilds.length){
      var url = api.baseUrl + '/api/v2/custom-fields?limit=10&offset=0&query=&vendorId='+parseInt(localStorageService.get('authToken').value.vendor_id);
       $http.get(url).then(function(response){
       resultService.customFeilds = response.data.customFields;
      
    },function(error){
        $log.log(error);
    });
     }
   return resultService.customFeilds 
    }
    
    function applyCoupon(data) {
      var url = api.baseUrl + '/api/coupons';
      return $http.post(url, data);
    }
    function dwnloadpdf(search_param,selectedCard) {
      if(resultService.isDownloadRatesLoader){
        return;
      }
      resultService.isDownloadRatesLoader=true;
      var data = {"data" :  [{
        "shipmentMode":search_param.mode,
        "logoURL":$rootScope.domainData.domain_info.LOGO,
        "userDetails":util.userProfile.user,
        "rateCardList":selectedCard, 
        "searchParam": {
          "load_data" : search_param.load_data,
          "search_type" : search_param.search_type,
          "user_pol": search_param.user_pol,
          "user_pod": search_param.user_pod,
          "origin_location": search_param.origin_location,
          "destination_location": search_param.destination_location,
          "pickup_selected" : search_param.pickup_selected,
          "delivery_selected": search_param.delivery_selected,
          "freight_charges": search_param.freight_charges,
          "origin_charges": search_param.origin_charges,
          "origin_custom_charges": search_param.origin_custom_charges,
          "destination_charges": search_param.destination_charges,
          "destination_custom_charges": search_param.destination_custom_charges,
        }
      }]};
      if(search_param.search_type == 'D2D'){
        data.data[0].originDoor =search_param.origin_location.location;
        data.data[0].destinationDoor=search_param.destination_location.location
       }
       analytics.track("Instant Rate - Download Rate Button", {
        "Mode": search_param.mode
      });

       var fileName = search_param.user.user_company_name+'_'+'rates_'+search_param.origin_location.location+'_'+search_param.destination_location.location+'.pdf';
       var a_tag= document.createElement("a");
       var url = api.baseUrl + '/api/rate-cardpdf';
       $http.post(url, data,{responseType:'arraybuffer'}).then(function(response){
        var file = new Blob([response.data], {type: 'application/pdf;charset=utf-8;'});
        var fileURL = URL.createObjectURL(file);
        a_tag.href = fileURL;
        a_tag.download = fileName;
         a_tag.click();
          resultService.isDownloadRatesLoader=false;
      },function(error){
        resultService.isDownloadRatesLoader=false;
      });
    }

    //get msr, nearby msr data from url
    function getDataMsrFromUrl(url) {
      return $http.get(api.baseUrl +'/'+ url);
    }

    // bind buy/sell rate_obj
    function formRateCardMsr(rates, cards, ConversionRates,search_param, co2Payload) {
      var l3_leg = '';
      if(!search_param.hasOwnProperty('freight_charges')){
        search_param['freight_charges'] = true;
      }
      angular.forEach(cards, function (card) {
        card.meta["showCard"] = true; // initially display all cards

        // code related to partial rate message condition -- DEV-2317
        card.meta['partialRate'] = '';
        card.meta['missingFlag'] = [];

        card.meta['inclusions'] = card.meta['inclusions'] ? card.meta['inclusions'] : '' ;
        card.meta['remarks'] = card.meta['remarks'] ? card.meta['remarks'] : '' ;
        card.meta['internal_remarks'] = card.meta['internal_remarks'] ? card.meta['internal_remarks'] : '' ;

        if(!card.data.sell_rates){
          card.data["sell_rates"] = angular.copy(card.data.buy_rates);
        }

        angular.forEach(card.data.buy_rates, function (buy_value, buy_key) {
          // if leg id not available
          if(!buy_value.rate_id){
            card.meta['partialRate'] = 'charge';  // charge --> it will indicate card have missing charge
          }else{

            var rateObj = rates[buy_value.rate_id];
            buy_value['rate_obj'] = angular.copy(rateObj);

            if(card.data.sell_rates){
              // bind sell_rates rate_obj
              card.data.sell_rates[buy_key]['rate_obj'] = angular.copy(rateObj);
              
              var sell_rates_obj = card.data.sell_rates[buy_key]['rate_obj'];
  
              if(sell_rates_obj.sell_leg_object){

                sell_rates_obj.charges = angular.copy(sell_rates_obj.sell_leg_object.charges);
                sell_rates_obj.leg_total_cost = angular.copy(sell_rates_obj.sell_leg_object.leg_total_cost);
                sell_rates_obj.leg_total_currency = angular.copy(sell_rates_obj.sell_leg_object.leg_total_currency);
                sell_rates_obj.leg_currency_cost = angular.copy(sell_rates_obj.sell_leg_object.leg_currency_cost);
                sell_rates_obj.leg_currency = angular.copy(sell_rates_obj.sell_leg_object.leg_currency);
              }
              delete sell_rates_obj.sell_leg_object;
              delete buy_value['rate_obj'].sell_leg_object;
            }
            
              card.meta['remarks'] += ( !card.meta['remarks'] && rateObj.remarks != null && rateObj.remarks !== '') ? rateObj.remarks : "";
              card.meta['inclusions'] +=  (!card.meta['inclusions'] && rateObj.inclusions != null && rateObj.inclusions !== '') ? rateObj.inclusions : "";
              card.meta['internal_remarks'] +=  (!card.meta['internal_remarks'] && rateObj["internal_remarks"] != null && rateObj["internal_remarks"] !== '') ? rateObj.internal_remarks : "";
              // get iata rates
              if (buy_value.rate_obj.global_leg_id === 'l3') {
                l3_leg = buy_value.leg_code;

                if(search_param.mode == 'SEA-FCL' && search_param.search_type==='P2P'){
                  // create co2 api payload 
                  var porPair = {
                    "origin" : card.meta.port_data.origin_port_code,
                    "destination" : card.meta.port_data.destination_port_code
                  }
                  resultService.fnSetCo2Payload(buy_value.rate_obj, porPair, co2Payload);
                }
                if (card.meta.type == 'iata_rates' && rateObj.alternate_object) {
                  buy_value['rate_obj_1'] = (buy_value.rate_obj);
                  buy_value['rate_obj_2'] = (buy_value.rate_obj.alternate_object);
                  resultService.fnCalculateSlab(card);
                }
              }
          }

          if( buy_value.leg_code.includes("fcl") || !buy_value.rate_obj){
            resultService.fnMissingFlag(buy_value, card.meta); // this is checking missing leg charge
          }
          
          if(!buy_value.rate_id || !buy_value.rate_obj){
            delete card.data.buy_rates[buy_key]; //leg delete if rates not available
            delete card.data.sell_rates[buy_key];
          }
        });
        if(card.meta['partialRate'] !== 'charge'){  // this block of code to determine whether remarks available for partial code -- DEV-2317
          card.meta['partialRate'] = (card.meta['inclusions'].length > 0  || card.meta['remarks'].length > 0 ) ? 'rmk-inc' : 'default';
        }
        
        card.meta['conversionRate'] = resultService.fnGetConversionRates(ConversionRates, card.meta.vendor_id, card.meta , search_param.mode);
        card.meta['buy_leg_total'] = resultService.calCardTotal(card.data.buy_rates);
        card.meta['card_total_cost'] = resultService.calCardTotal(card.data.sell_rates);
        card.meta['init_sort_total'] = card.data.sell_rates[l3_leg].rate_obj.leg_total_cost;
        resultService.getSpecialMeta(card, l3_leg);


      });
    }

    function fnCallScheduleUrl(cards, l3_leg) {

      var deferred = $q.defer();
      var promiseList = [];

      angular.forEach(cards, function (card) {
        if (card.data.buy_rates[l3_leg].rate_obj.schedule.url && !card.data.buy_rates[l3_leg].rate_obj.schedule.data.length) {

          var scheduleUrl = card.data.buy_rates[l3_leg].rate_obj.schedule.url.split('rate_id')[0];
          var isPresentScheduleStore = resultService.scheduleResponse.find(function(item) {
            return item.schedule_url === scheduleUrl;
          });
        
          if(!isPresentScheduleStore){ // if not present Schedule url
            var scheduledict = {
              "schedule_url" : scheduleUrl,
              "card_obj" : [card],
              "schedule_response" : [],
              "isResponseDone" : false,
              "l3_key" : l3_leg
            }
            resultService.scheduleResponse.push(scheduledict);
            promiseList.push(resultService.getSchedule(scheduledict).catch(function (error) {
              $log.error(error);
              resultService.fnScheduleResponseBind(scheduledict); 
            }));
          }else{ // if present Schedule url
            isPresentScheduleStore.card_obj.push(card);

            if(isPresentScheduleStore.schedule_response.length > 0 || isPresentScheduleStore.isResponseDone ) {
              card.data.buy_rates[isPresentScheduleStore.l3_key].rate_obj.schedule.data = isPresentScheduleStore.schedule_response;
              card.data.sell_rates[isPresentScheduleStore.l3_key].rate_obj.schedule.data = isPresentScheduleStore.schedule_response;
              card.meta["isScheduleCall"] = true; 

              if (card.data.buy_rates[isPresentScheduleStore.l3_key].rate_obj.schedule.data) {
                resultService.getScheduleViaMetaRoute(card, isPresentScheduleStore.l3_key);
              }else{
                resultService.fnSetTransitTime(card, isPresentScheduleStore.l3_key);
              }
            }
          }

        } else {
          card.meta['isScheduleCall'] = true;
          // var selectedScheduleIndex = card.data.buy_rates[l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(card,l3_leg) : 0;

          card.meta.selected_schedule = card.data.buy_rates[l3_leg].rate_obj.schedule.data.length && resultService.fnScheduleDisplayConfig(card,l3_leg) ? card.data.buy_rates[l3_leg].rate_obj.schedule.data[0] : null;
          
          resultService.fnSetTransitTime(card, l3_leg);
        }
      });
      $q.all(promiseList).then(function (response) {
        deferred.resolve(response);
      }).catch(function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    // get schedule list from api
    function getSchedule(scheduledict) {
      var source = scheduledict.l3_key === "l3_fcl" ? "SEA_FCL" : "SEA_LCL";
      var url = api.baseUrl +'/'+ scheduledict.schedule_url+'&source='+source;
      return $http.get(url).then(function (response) {
        try {
          scheduledict.schedule_response = response.data.data;
          scheduledict.isResponseDone = true;
          resultService.fnScheduleResponseBind(scheduledict); 
        } catch (error) {
          $log.error(error);
          resultService.fnScheduleResponseBind(scheduledict); 
        }
      }, function (error) {
        $log.error(error);
        resultService.fnScheduleResponseBind(scheduledict); 
      });
    }
    
    // store schedule response to card meta schedule
    function fnScheduleResponseBind(scheduledict){
      scheduledict.card_obj.map(function(value,index){
        value.data.buy_rates[scheduledict.l3_key].rate_obj.schedule.data = scheduledict.schedule_response;
        value.data.sell_rates[scheduledict.l3_key].rate_obj.schedule.data = scheduledict.schedule_response;
        value.meta["isScheduleCall"] = true;
        if (value.data.buy_rates[scheduledict.l3_key].rate_obj.schedule.data) {
          resultService.getScheduleViaMetaRoute(value, scheduledict.l3_key);
        }else{
          resultService.fnSetTransitTime(value, scheduledict.l3_key);
        }
      });
    }

    function getSpecialMeta(card, l3_leg) {
      if (card.data.buy_rates[l3_leg].rate_obj.is_special && card.data.buy_rates[l3_leg].rate_obj.special_meta.length) {
        card.meta.applied_special_meta = card.data.buy_rates[l3_leg].rate_obj.special_meta[0];
        if (card.data.buy_rates[l3_leg].rate_obj.special_meta.length > 1) {
          var minQty = resultService.getQtyRemaining(card.data.buy_rates[l3_leg].rate_obj.special_meta[0]);
          card.data.buy_rates[l3_leg].rate_obj.special_meta.forEach(function (item) {
            var itemQty = resultService.getQtyRemaining(item)
            if (minQty > itemQty) {
              minQty = itemQty;
              card.meta.applied_special_meta = item;
            }
          });
        }
      }
    }

    function getQtyRemaining(rates) {
      if (rates.special_qty_rem) {
        return (rates.special_qty_basis === 'TEUs' ? rates.special_qty_rem.TEUs : (rates.special_qty_basis === 'Containers' ? rates.special_qty_rem['20GP'] : ''));
      }
    }

    function getAgents() {
      var url = api.baseUrl + '/api/agents';
      return $http.get(url);
    }

    function fnCalculateSlab(card) {

      var result1 = (((card.data.buy_rates.l3_air.rate_obj_2.leg_total_cost - card.data.buy_rates.l3_air.rate_obj_1.leg_total_cost) / card.data.buy_rates.l3_air.rate_obj_1.leg_total_cost) * 100);

      var result2 = (((card.data.buy_rates.l3_air.rate_obj_1.leg_total_cost - card.data.buy_rates.l3_air.rate_obj_2.leg_total_cost) / card.data.buy_rates.l3_air.rate_obj_2.leg_total_cost) * 100);

      card.meta["slabPersentage"] = card.data.buy_rates.l3_air.rate_obj_1.is_higher_slab ? result1 : result2;
      if (result1 > result2) {
        card.meta["selectedLeg"] = "rate_obj_1";
        card.data.buy_rates.l3_air.rate_obj = angular.copy(card.data.buy_rates.l3_air["rate_obj_1"]);
      } else {
        card.meta["selectedLeg"] = "rate_obj_2";
        card.data.buy_rates.l3_air.rate_obj = angular.copy(card.data.buy_rates.l3_air["rate_obj_2"]);
      }
    }

    /**
     * get schedule data from api
     * @param {*} card, l3_rates
     */
    function getScheduleResponse(card, l3_key) {
      return $http.get(api.baseUrl +'/'+ card.data.buy_rates[l3_key].rate_obj.schedule.url).then(function (response) {
        try {
          card.data.buy_rates[l3_key].rate_obj.schedule.data = response.data.data;
          card.data.sell_rates[l3_key].rate_obj.schedule.data = response.data.data;
          card.meta["isScheduleCall"] = true;
          if (card.data.buy_rates[l3_key].rate_obj.schedule.data.length) {
            resultService.getScheduleViaMetaRoute(card, l3_key);
          }else{
            resultService.fnSetTransitTime(card, l3_key);
          }
          return card;
        } catch (error) {
          $log.error(error);
          card.meta["isScheduleCall"] = true;
          card.data.buy_rates[l3_key].rate_obj.schedule.data = [];
          card.data.sell_rates[l3_key].rate_obj.schedule.data = [];
          resultService.fnSetTransitTime(card, l3_key);
        }
      }, function (error) {
        $log.error(error);
        card.meta["isScheduleCall"] = true;
        card.data.buy_rates[l3_key].rate_obj.schedule.data = [];
        card.data.sell_rates[l3_key].rate_obj.schedule.data = [];
        resultService.fnSetTransitTime(card, l3_key);
      });
    }

    /**
    * remove schedule object if l3 via not match
    */
    function getScheduleViaMetaRoute(card, l3_key) {
      var l3_data = card.data ? card.data.buy_rates[l3_key].rate_obj : card.leg[l3_key]; //checking the structure for carrier booking
      var temp_l3 = [];
      var selectedScheduleIndex = 0;
      var isSailingDate = false;
      l3_data.schedule.data = angular.copy(resultService.sortByDeparture(l3_data.schedule.data));  // schedule data list sorting
      var new_date = moment(l3_data.expiry).add(7, 'day').format(); // 7 days date after db expire

        for (var i = 0; i < l3_data.schedule.data.length; i++) {
          if (moment(new_date).isAfter(l3_data.schedule.data[i].departure_time) || l3_data.expiry === null ) {

            if (l3_data.via_route && l3_data.via_route.toLowerCase().trim() !== resultService.direct && (!l3_data.schedule.data[i].via_port || (l3_data.schedule.data[i].via_port && l3_data.schedule.data[i].via_port.toLowerCase().trim() !== resultService.direct) )) {   // db via route is not direct
              temp_l3.push(l3_data.schedule.data[i]);
            }
            else if (l3_data.via_route && l3_data.via_route.toLowerCase().trim() === resultService.direct && (l3_data.schedule.data[i].via_port && l3_data.schedule.data[i].via_port.toLowerCase().trim() === resultService.direct)) {   // db via route is direct
              temp_l3.push(l3_data.schedule.data[i]);
            }
            else{ // db via route is null
              temp_l3.push(l3_data.schedule.data[i]);
            }
            // if(card.data.buy_rates[l3_key].rate_obj.sailing_date && !isSailingDate){ // if present sailing_date value 
            //   if($filter('date')(new Date(card.data.buy_rates[l3_key].rate_obj.sailing_date),'yyyy-MM-dd') === $filter('date')(new Date(l3_data.schedule.data[i].departure_time),'yyyy-MM-dd')){ // if matching sailing date then this date default selected schedule tab
            //     isSailingDate = true;
            //     selectedScheduleIndex =  i; // it's selected schedule tab
            //   }else{
            //     selectedScheduleIndex =  null; // it's no any selected schedule tab
            //   }
            // }
          } else {
            break;
          }
        }
        l3_data.schedule.is_schedule_available_in_cache = temp_l3.length ? l3_data.schedule.is_schedule_available_in_cache : false;
        l3_data.schedule.data = temp_l3;
        card.data ? card.data.sell_rates[l3_key].rate_obj.schedule.data = temp_l3 : '';

      card.meta.selected_schedule = l3_data.schedule.data.length && resultService.fnScheduleDisplayConfig(card,l3_key) ? l3_data.schedule.data[selectedScheduleIndex] : null;
      resultService.fnSetTransitTime(card, l3_key);
    }

    /**
     * if l3 via_route is direct or null result in object
     * @param {*} initialArray
     */
    function getObjViaDirect(tempCards, l3_key) {

      tempCards.map(function (card) {
        if(!card.meta.isError){
        var l3_data = card.data.buy_rates[l3_key].rate_obj;
        var scheduleConfig = resultService.fnScheduleDisplayConfig(card,l3_key);
        if (l3_data.via_route == null || l3_data.via_route == '') {
          if (l3_data.schedule.data.length) {
            var result = [];
            l3_data.schedule.data.map(function (el, index) {
              if (el.via_port != null) {
                if (el.via_port && el.via_port.toLowerCase().trim() === resultService.direct) {
                  result.push(el);
                }
              }
            });
            if (result.length) {
              l3_data.schedule["direct"] = result;
              card.data.sell_rates[l3_key].rate_obj.schedule["direct"] = result;
              card.meta.selected_schedule = l3_data.schedule.direct.length && scheduleConfig ? l3_data.schedule.direct[0] : null;
            }
          }
        }
        else if (l3_data.via_route.toLowerCase().trim() === resultService.direct) {
          if (l3_data.schedule.data.length) {
            var result = [];
            l3_data.schedule.data.map(function (el, index) {
              if (el.via_port && el.via_port.toLowerCase().trim() === resultService.direct) {
                result.push(el);
              }
            })
            l3_data.schedule["direct"] = result;
            card.data.sell_rates[l3_key].rate_obj.schedule["direct"] = result;
            card.meta.selected_schedule = l3_data.schedule.direct.length && scheduleConfig ? l3_data.schedule.direct[0] : null;
          }
        }

        resultService.fnSetTransitTime(card, l3_key);
      }
      });
    }

    function getLowestCard(cardsArray) {
      if (cardsArray.length) {
        cardsArray.sort(function (a, b) {
          return b.meta["init_sort_total"] - a.meta["init_sort_total"];
        })
        cardsArray[cardsArray.length - 1].meta["is_lowest"] = true;
      }
      return cardsArray;
    }

    /**
     * list of schedule arrange by date
     * @param {*} tempArray
     */
    function sortByDeparture(tempArray) {
      return tempArray.sort(function (a, b) {
        var dateA = new Date(moment.utc(a.departure_time).local()),
          dateB = new Date(moment.utc(b.departure_time).local());
        return dateA - dateB; //sort by date ascending
      });
    }

    //card leg total with vendor currency conversion
    function calCardTotal(buy_rates, solution_type) {
      var total = 0;

      // var domainType = (solution_type != undefined) ? solution_type : util.solution_type;
      // if( domainType != 'WLS'  && $state.current.name == 'app.search.result' ){

      //     angular.forEach(buy_rates, function (value) {
      //         if( value.rate_obj){
      //             angular.forEach(value.rate_obj.charges, function (childValue) {
      //                 total += parseFloat(childValue.customer_currency_cost / childValue.total_units);
      //             });
      //         }
      //     });
      // }else{
      angular.forEach(buy_rates, function (value) {
        if (value.rate_obj) {
          total += parseFloat(value.rate_obj.leg_total_cost);
        } else if (value.charges) {
          total += parseFloat(value.leg_total_cost);
        }
      });
      // }
      return total;
    }

    //get delta response
    function getDelta(rates, delta) {
      $http.get(delta.url).then(function (response) {
        delta.data = response.data;

        delta.data.map(function (deltaItem) {
          rates.map(function (ratesItem) {
            if (ratesItem.global_leg_id == 'l3' && ratesItem.sub_vendor_id == deltaItem.sub_vendor_id && ratesItem.vendor_id == deltaItem.vendor_id && ratesItem.service_type == deltaItem.service_type) {
              ratesItem.analytics["delta_percentage"] = deltaItem.Percentage;
            }
          });
        });

      }, function (error) {
        $log.error(error);
        delta.data = [];
      });
    }

    //GET additional legs tab wise
    function getAdditionalLeg(url) {
      return $http.get(url);
    }

    // ***********************************************************

    // function to get analytic data - ankita
    function getAnalytics(analyticsUrl) {
      var deferred = $q.defer();
      $http.get(analyticsUrl).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        $log.error(error);
        deferred.reject(error);
      });
      return deferred.promise;
    }

    /**
     * function to post the update result
     */
    function updateSearchResult(data, search_id) {
      return $http.put(api.baseUrl + '/api/search/' + search_id, data);
    }

    function getBookingRates(card, buyOrSell) {
      // shipper direct booking copy buy into sell
      if(!card.data.sell_rates){
        card.data.sell_rates = angular.copy(card.data.buy_rates);
      }
      var tempCard = angular.copy(card);
      var result = {
        "rate_ids": [],
        "rates_obj": []
      };
      angular.forEach(tempCard.data[buyOrSell], function (value, key) {
        if (value.rate_obj) {
          result.rate_ids.push(value.rate_obj._id);
          delete value.rate_obj._id;
          result.rates_obj.push(value.rate_obj);
        } else if (value.leg_code === 'other_charges_fcl') {
          result.rates_obj.push(value);
        }
      });
      return result;
    }

    /**
     *
     * @param {*} data
     */
    function confirmBooking(data, quote_id) {
      if (util.isSharedQuote()) {
        return $http.post(api.baseUrl + '/shared/' + quote_id + '/v2/shipments', data);
      } else {
        return $http.post(api.baseUrl + '/api/v2/shipments', data);
      }
    }

    /**
     * function to get the remarks or inclusion
     * @param {*} cardLegs
     * @param {*} requiredField
     */
    function getCardRemarksInclusion(cardLegs, requiredField) {
      var remarks = '';
      var inclusion = '';
      if (requiredField == 'REMARKS') {
        angular.forEach(cardLegs, function (value, key) {
          if (value.rate_obj) {
            remarks += (value.rate_obj.remarks != null && value.rate_obj.remarks != '') ? value.rate_obj.remarks : "";
          }
        });
        return remarks;
      }
      else if (requiredField == 'INCLUSIONS') {
        angular.forEach(cardLegs, function (value, key) {
          if (value.rate_obj) {
            inclusion += (value.rate_obj.inclusions != null && value.rate_obj.inclusions != '') ? value.rate_obj.inclusions : "";
          }
        });
        return inclusion;
      }
    }

    /**
     * function to determine whether rate card have missing loads or Leg have missing loads
     * @param {*} legObj
     * @param {*} param1
     */
    function isLegLoadMissing(legObj, type) {
      var isMissing = false;
      if (type === 'LEGOBJ') {  // for detrmining whether call from leg Object or Rate Card Object
        angular.forEach(legObj, function (value, key) {
          if (!value) {
            isMissing = true;
            return;
          }
        });
        return isMissing;
      }
      else if (type === 'CARDOBJ') {
        angular.forEach(legObj, function (value, key) {
          if (value !== undefined && value != null && value.leg_code != 'ins_fcl' && value.rate_obj) {
            angular.forEach(value.rate_obj.load_stat, function (childValue, childKey) {
              if (!childValue) {
                isMissing = true;
                return;
              }
            });
          }
        });
        return isMissing;
      }
    }

    //api for share quote
    function shareQuote(data, id) {
      return $http.post(api.baseUrl + '/api/quote', data);
    }
    function quoteCreation(data, id) {
      return $http.post(api.baseUrl + '/api/v2/quote', data);
    }

    //api for incoterms for quotation sharing
    function getIncoterms() {
      var url = api.baseUrl + '/api/incoterms';
      return $http.get(url);
    }

    function getTermsConditions(mode, standard) {
      var url = "";
      if (util.isSharedQuote()) {
        url = api.baseUrl +'/shared/terms?mode=' + mode + '&standard=' + standard;
      }else{
        url = api.baseUrl + '/api/terms?mode=' + mode + '&standard=' + standard;
      }
      return $http.get(url);
    }

    //get sub vendor list for create new card
    function getSubVendor() {
      var url = api.baseUrl + '/api/subvendor?source=COMMON_AND_DOMAIN';
      return $http.get(url);
    }

    function getvendorData() {
      var url = api.baseUrl + '/api/vendor';
      return $http.get(url);
    }

    function getAirlineData() {
      var url = api.baseUrl + '/api/airlines';
      return $http.get(url);
    }

    //api call for add /edit new card
    function fnsubmitLeg(legData, id, action) {
      var url = api.baseUrl + '/api/search/' + id + '/card';
      return $http.post(url, legData);
    }

    function fnCreateRates(legData, id, action) {
      var url = api.baseUrl + '/api/v2/search/' + id + '/cards';
      return $http.post(url, legData);
    }

    function fnUpdateRates(legData, id, rateId) {
      var url = api.baseUrl + '/api/v2/search/' + id + '/cards';
      return $http.put(url, legData);
    }

    function updateCard(legData, id, rateId) {
      var url = api.baseUrl + '/api/search/' + id + '/card/' + rateId;
      return $http.put(url, legData);
    }

    function deleteCard(id, cardId) {
      var url = api.baseUrl + '/api/search/' + id + '/card/' + cardId;
      return $http.delete(url);
    }


    //initial set leg filter value
    function setLegFilter(filterConfig, search_param) {
      var leg_code = (search_param.mode == 'SEA-FCL') ? 'fcl' : ((search_param.mode == 'AIR') ? 'air' : 'lcl');
      filterConfig['l1_' + leg_code].is_selected = search_param.pickup_selected || false;
      filterConfig['l2_' + leg_code].is_selected = search_param.origin_charges;
      filterConfig['l2_' + leg_code + '_cha'].is_selected = search_param.origin_customs;
      filterConfig['l4_' + leg_code].is_selected = search_param.destination_charges;
      filterConfig['l4_' + leg_code + '_cha'].is_selected = search_param.destination_customs;
      filterConfig['ins_' + leg_code].is_selected = search_param.shipment_insurance;
      filterConfig['l5_' + leg_code].is_selected = search_param.delivery_selected || false;

      filterConfig['l1_' + leg_code].is_available = search_param.pickup_selected || false;
      filterConfig['l2_' + leg_code].is_available = search_param.origin_charges;
      filterConfig['l2_' + leg_code + '_cha'].is_available = search_param.origin_customs;
      filterConfig['l4_' + leg_code].is_available = search_param.destination_charges;
      filterConfig['l4_' + leg_code + '_cha'].is_available = search_param.destination_customs;
      filterConfig['ins_' + leg_code].is_available = search_param.shipment_insurance;
      filterConfig['l5_' + leg_code].is_available = search_param.delivery_selected || false;
    }

    function setLegModeWise(mode, filterConfig) {

      var leg_code = (mode == 'SEA-FCL') ? 'fcl' : ((mode == 'AIR') ? 'air' : 'lcl');

      filterConfig['l1_' + leg_code] = angular.copy(resultService.leg_selectObj);
      filterConfig['l1_' + leg_code].leg_name = 'Pickup Charges';

      filterConfig['l2_' + leg_code] = angular.copy(resultService.leg_selectObj);
      filterConfig['l2_' + leg_code].leg_name = 'Origin Charges';

      filterConfig['l2_' + leg_code + '_cha'] = angular.copy(resultService.leg_selectObj);
      filterConfig['l2_' + leg_code + '_cha'].leg_name = 'Origin Custom';

      filterConfig['l3_' + leg_code] = angular.copy(resultService.leg_selectObj);
      filterConfig['l3_' + leg_code].is_selected = true;
      filterConfig['l3_' + leg_code].is_disabled = true;
      filterConfig['l3_' + leg_code].is_available = true;
      filterConfig['l3_' + leg_code].leg_name = $rootScope.isJeenaDomain ? 'Freight' : 'Main Freight';

      filterConfig['l4_' + leg_code] = angular.copy(resultService.leg_selectObj);
      filterConfig['l4_' + leg_code].leg_name = 'Destination Charges';

      filterConfig['l4_' + leg_code + '_cha'] = angular.copy(resultService.leg_selectObj);
      filterConfig['l4_' + leg_code + '_cha'].leg_name = 'Destination Custom';

      filterConfig['l5_' + leg_code] = angular.copy(resultService.leg_selectObj);
      filterConfig['l5_' + leg_code].leg_name = 'Deliery Charges';

      filterConfig['ins_' + leg_code] = angular.copy(resultService.leg_selectObj);
      filterConfig['ins_' + leg_code].leg_name = 'Insurance Charges';
    }

    function fnSetRfqObj(search_param) {
      var rfq_Obj = {
        "better_rate": false,
        "customs_clearance_station": "",
        "insurance": {
          "is_selected": search_param.shipment_insurance ? true : false,
          "value_of_goods": search_param.shipment_insurance ? search_param.insurance_leg_cost : 0,
          "currency": search_param.shipment_insurance ? search_param.insurance_currency : "USD"
        },
        "pickup_selected": search_param.pickup_selected,
        "delivery_selected": search_param.delivery_selected,
        "pickup": search_param.pickup,
        "delivery": search_param.delivery,
        "origin_charges": search_param.origin_charges,
        "origin_customs": search_param.origin_customs,
        "destination_charges": search_param.destination_charges,
        "destination_customs": search_param.destination_customs,
        "carrier_preference": (search_param.carrier_preference != undefined && search_param.carrier_preference.length) ? search_param.carrier_preference : [],
        "airline_preference": [],
        "demurrage_detention": search_param.detention ? search_param.detention : 7,
        "weight_slab": search_param.weight_slab ? search_param.weight_slab : null,
        "commodities": search_param.commodity,
        "hazardous_material": search_param.hazardous_material,
        "hs_code": search_param.hs_code ? search_param.hs_code : null,
        "imco_code": search_param.imco_code ? search_param.imco_code : null,
        "inco_term": search_param.inco_term,
        "reason_for_revising": null,
        "console_list": false,
        "odc_owc": false,
        "odc_owc_details": {
          "cargo_length": null,
          "cargo_width": null,
          "cargo_height": null,
          "volume_unit": "CMS",
          "weight": null,
          "weight_unit": "KGs"
        },
        "target_load_data": search_param.load_data,
        "rfq_raised_by": null,
        "shipper_user": search_param.shipper_user,
        "user": search_param.user,
        "sales_user": search_param.sales_user,
        "stuffing": search_param.stuffing ? search_param.stuffing : null,
        "preferred_sailing_date": search_param.cargo_ready_date,
        "files": [],
        "req_commodity_data": search_param.req_commodity_data ?  search_param.req_commodity_data : [],
        "req_cargo_type_data": search_param.req_cargo_type_data ? search_param.req_cargo_type_data  : null 
      };

      return rfq_Obj;
    }

    function fnSendRFQData(id, rfqData) {
      return $http.post(api.baseUrl + '/api/search/' + id + '/ticket', rfqData);
    }

    function fnSendRfqFile(id, rfqFile) {
      var authToken = '';
      var auth = {};
      if (util.isSharedPage() && localStorage.getItem('otp') !== null) {
        authToken = localStorageService.otp;
        auth = {
          'otp': authToken,
          'referer-domain': $rootScope.domainData.host_name
        }
      } else {
        authToken = 'Bearer '+localStorageService.get('authToken').value.access_token;
        auth = {
          'authorization': authToken,
          'referer-domain': $rootScope.domainData.host_name
        };
      }

      var settings = {
        "async": true,
        "crossDomain": true,
        "url": api.baseUrl + '/api/s3upload',
        "method": "POST",
        "headers": auth,
        "processData": false,
        "contentType": false,
        "mimeType": "multipart/form-data",
        "data": rfqFile
      };

      return $.ajax(settings).done(function (response) {
        return response;
      });
    }

    function searchCount(pol, pod) {
      return $http.get(api.baseUrl + '/api/search-count?origin=' + pol + '&destination=' + pod);
    }

    function matchRates(data) {
      return $http.post(api.baseUrl + '/api/match-rates', data);
    }

    function fnBookingQty(data) {
      return $http.post(api.baseUrl + '/api/v2/shipment-rates', data);
    }

    function fnGetInsuranseLeg(data) {
      return $http.get(api.baseUrl + '/api/insurance-rate?mode=' + data.mode + '&currency=' + data.curr + '&cost=' + data.value + '&customer_currency=' + data.customer_currency);
    }

    function getAllSalesPerson() {
      var url = api.baseUrl + '/api/get-forwarders';
      return $http.get(url);
    }

    function getSalesPersonList(id,searchText) {

      var url = api.baseUrl + '/api/v2/user?company_type=FORWARDER&limit=30&offset=0&user_id=' + id + util.fnGetForwarderIdApi('&');
      if(searchText){
        url += '&query=' + searchText;
      }
      return $http.get(url);
    }

    // Get Vas charges list by leg data
    function getVasChargesByleg(vas_data) {
      var postData = {
        "data": {
          "leg_code": vas_data.selected_legs,
          "search_param": vas_data.search_param
        }
      }
      return $http.post(api.baseUrl + '/api/get-additional-charges', postData);
    }

    // function to apply vas legs in rate cards
    function applyVASLegToCard(cardarray, vasLeg, frompage) {

      angular.forEach(cardarray, function (value, key) {
        value.data.buy_rates['additional_services'] = vasLeg.buy_rates['additional_services'];
        if (!value.data.sell_rates) {
          value.data.sell_rates = {};
          value.data.sell_rates = angular.copy(value.data.buy_rates);
          value.data.sell_rates['additional_services'] = vasLeg.sell_rates['additional_services'];
        } else {
          value.data.sell_rates['additional_services'] = vasLeg.sell_rates['additional_services'];
        }
        if (frompage == 'result') {
          value.meta['buy_leg_total'] = resultService.calCardTotal(value.data.buy_rates);
        }
        else if (frompage == 'quote') {
          value.meta['card_total_cost'] = resultService.calCardTotal(value.data.sell_rates);
          value.meta["status"] = (value.meta["status"] != "new") ? "modified" : "new";
        }
        else if (frompage == 'inquiry') {
          value.meta['card_total_cost'] = resultService.calCardTotal(value.data.sell_rates);
        }
      });
    }

    function getAdditionLegStructure(search_param) {
      var legObj = {
        "leg_name": "Additional Services",
        "leg_code": "additional_services",
        "vendor_id": parseInt(localStorageService.get('authToken').value.vendor_id),
        "rate_obj": {
          "_id": "",
          "schedule": {
            "url": null,
            "data": []
          },
          "analytics": {
            "graph": {
              "url": null
            }
          },
          "is_special": false,
          "charges": [],
          "manual": 1,
          "airline": {
            "air_line_name": "",
            "airline_code": "",
            "airline_prefix": ""
          },
          "airline_code": null,
          "slab_currency": null,
          "slab": null,
          "rate_type": "msr_rate",  
          "leg_name": "Additional Services",
          "leg_code": "additional_services",
          "vendor_id": parseInt(localStorageService.get('authToken').value.vendor_id),
          "sub_vendor_id": null,
          "service_type": null,
          "via_route": null,
          "transit_time": null,
          "contract_number": "",
          "remarks": null,
          "inclusions": null,
          "expiry": null,
          "other_charges": null,
          "if_applicable_charges": null,
          "load_stat": null,
          "global_leg_id": "",
          "leg_total_cost": 0,
          "leg_total_currency": search_param.user.user_base_currency,
          "leg_currency_cost": 0,
          "leg_currency": search_param.user.user_base_currency,
          "vendor": {
            "vendor_name": localStorageService.get('authToken').value.vendor_name
          },
          "sub_vendor": {
            "sub_vendor_name": "",
            "carrier_code": "",
            "logo": null
          },
          "ltl_load_details" : null
        }
      };
      return legObj;
    }

    function fnAutoFetchBinding(search_param, currentCard, id, source, l3_leg) {
      var deferred = $q.defer();
      var leg_code = (search_param.mode == 'SEA-FCL') ? '_fcl' : ((search_param.mode == 'AIR') ? '_air' : '_lcl');
      var origin_port = currentCard.meta.port_data.origin_port_code;
      var destination_port = currentCard.meta.port_data.destination_port_code;
      var sub_vendor_id = currentCard.data.sell_rates[l3_leg].rate_obj.sub_vendor_id;

      // create required leg url
      var legType = resultService.requiredLegUrl(search_param, currentCard, leg_code);

      if (legType != "") {
        var msrUrl = api.baseUrl + '/api/get-rates?id=' + id + '&type=msr_rates&mode=' + search_param.mode + '&nearby_only=false&origin_port=' + origin_port + '&destination_port=' + destination_port + '&leg_type=' + legType + '&source=' + source + '&return_type=leg';

        msrUrl += (search_param.mode != 'AIR') ? '&sub_vendor_id='+sub_vendor_id : "";

        currentCard.meta.shimmer = true;
        resultService.getAdditionalLeg(msrUrl).then(function (response) {
          if (response.data.data != undefined) {
            var legList = angular.copy(response.data.data.rates);

            // create array of required legs
            var legArray = "";
            if (legType.indexOf('&') != -1) {
              legArray = (legType.substring(0, legType.indexOf('&'))).split(",");
            } else {
              legArray = legType.split(",");
            }

            for (var i = 0; i < legArray.length; i++) {

              var rateObj = resultService.fnMatchRate(legList, legArray[i], currentCard, l3_leg);     // get rates if all required params match
              currentCard.data.sell_rates[legArray[i]] = {
                "leg_code": legArray[i],
                "leg_name": rateObj ? rateObj.leg_name : resultService.fnGetLegName(leg_code, legArray[i]),
                "rate_obj": rateObj,
                "sub_vendor_id": rateObj ? parseInt(rateObj.sub_vendor_id) : null,
                "vendor_id": rateObj ? parseInt(rateObj.vendor_id) : null,
              }
              currentCard.data.buy_rates[legArray[i]] = angular.copy(currentCard.data.sell_rates[legArray[i]]);
            }
          }
          currentCard.meta.shimmer = false;
          currentCard.meta.card_total_cost = resultService.calCardTotal(currentCard.data.sell_rates);
          deferred.resolve(currentCard);
        }, function (error) {
          $log.error(error);
          currentCard.meta.shimmer = false;
          deferred.reject(error);
        });
      } else {
        deferred.resolve(currentCard);
      }

      return deferred.promise;
    }

    // match rates with l3 rates and return
    function fnMatchRate(legList, legArray, currentCard, l3_leg){
      var leg_0_Obj = null; // along with condition store 0 subvendor
      var air_0_Obj = null;  // along with condition store empty airline
      var leg_code = l3_leg.split('l3')[1];
      var isModeAir = leg_code.indexOf('air') > -1;

      var matchObjRate = null;
      // find form response data
      if(Object.keys(legList).length){
        var matchObjRate = legList.find(function (element) {
          var matchLeg = element.leg_code == legArray;

          if(matchLeg){
            // rate combination condition
            var matchVendor = element.vendor_id == currentCard.meta.vendor_id;
            var matchAgent = currentCard.data.sell_rates[l3_leg].rate_obj.agent_id ? (element.agent_id == currentCard.data.sell_rates[l3_leg].rate_obj.agent_id) : !element.agent_id ;
            var matchSubVendor = element.sub_vendor_id == currentCard.data.sell_rates[l3_leg].rate_obj.sub_vendor_id;
            var matchAirline = isModeAir ? (element.airline && element.airline.airline_code == currentCard.data.sell_rates[l3_leg].rate_obj.airline.airline_code) : false;

            var serviceType = false;
            if(currentCard.data.sell_rates[l3_leg].rate_obj.service_type){
              serviceType = element.service_type && element.service_type.toLowerCase() == currentCard.data.sell_rates[l3_leg].rate_obj.service_type.toLowerCase();
            }else{
              serviceType = !element.service_type;
            }

            // l2 leg, l4 leg combination
            if(!legArray.includes('cha') && (legArray.includes('l2') || legArray.includes('l4'))){
              var condition = matchVendor && matchAgent && serviceType && (isModeAir ? matchAirline : matchSubVendor);

              // via pol condition
              if (condition && legArray == 'l2'+leg_code) {
                if (currentCard.meta.port_data.is_icd_port_origin && currentCard.meta.via_pol == element.via_pol) {
                  return element;
                }else if(!currentCard.meta.port_data.is_icd_port_origin){
                  return element;
                }
              }
              // via pod condition
              if (condition && legArray == 'l4'+leg_code) {
                if (currentCard.meta.port_data.is_icd_port_destination && currentCard.meta.via_pod == element.via_pod) {
                  return element;
                }else if(!currentCard.meta.port_data.is_icd_port_destination){
                  return element;
                }
              }
              // if matched airline not found then store null airline.
              if(matchVendor && matchAgent && serviceType && (!element.airline || !element.airline.airline_code) && !air_0_Obj){
                air_0_Obj = element;
              }

              if(legArray.includes('cha')){
                return element;
              }
            }else{
              // if sv_combination has l3 sub-vendor id or sv_combination is empty and sub-vendor == l3 sub-vendor
              var matchSvCombination = element.sv_combination && ((element.sv_combination.length && element.sv_combination.indexOf(currentCard.data.sell_rates[l3_leg].rate_obj.sub_vendor_id.toString()) > -1) || (!element.sv_combination.length && matchSubVendor));

              // find 0 sub-vendor id if sv_combination is empty
              if (matchVendor && (element.sv_combination && !element.sv_combination.length) && element.sub_vendor_id == 0) {
                leg_0_Obj = element;
              }

              // if matched airline not found then store null airline.
              if(isModeAir && matchVendor && (!element.airline || !element.airline.airline_code) && !air_0_Obj){
                air_0_Obj = element;
              }

              if (matchVendor && (!isModeAir ? matchSvCombination : true) ) {
                return element;
              }
            }
          }
        });
      }

      var rateObj = matchObjRate ? matchObjRate : (isModeAir ? air_0_Obj : leg_0_Obj);
      return rateObj;
    }
    function getNoRatesList(id){
      var url = api.baseUrl + '/api/v2/search/'+ id +'/status';
      return $http.get(url);
    }

    // find and return leg name
    function fnGetLegName(leg_code, legArray){
      switch (legArray) {
        case 'l1' + leg_code:
          return 'Pickup Charges';

        case 'l2' + leg_code:
          return 'Origin Charges';

        case 'l2' + leg_code + '_cha':
          return 'Origin Custom';

        case 'l3' + leg_code:
          return $rootScope.isJeenaDomain ? 'Freight' : 'Main Freight';

        case 'l4' + leg_code:
          return 'Destination Charges';

        case 'l4' + leg_code + '_cha':
          return 'Destination Custom';

        case 'l5' + leg_code:
          return 'Deliery Charges';

        case 'ins' + leg_code:
          return 'Insurance Charges';
      }
    }

    function requiredLegUrl(search_param, currentCard, leg_code){
      var legUrl = "";
      if (search_param.pickup_selected && (!currentCard.data.sell_rates['l1' + leg_code] || !currentCard.data.sell_rates['l1' + leg_code].rate_obj)) {
        legUrl += 'l1' + leg_code + ',';
      }
      if (search_param.origin_charges && (!currentCard.data.sell_rates['l2' + leg_code] || !currentCard.data.sell_rates['l2' + leg_code].rate_obj)) {
        legUrl += 'l2' + leg_code + ',';
      }
      if (search_param.origin_customs && (!currentCard.data.sell_rates['l2' + leg_code + '_cha'] || !currentCard.data.sell_rates['l2' + leg_code + '_cha'].rate_obj)) {
        legUrl += 'l2' + leg_code + '_cha' + ',';
      }
      if (search_param.destination_charges && (!currentCard.data.sell_rates['l4' + leg_code] || !currentCard.data.sell_rates['l4' + leg_code].rate_obj)) {
        legUrl += 'l4' + leg_code + ',';
      }
      if (search_param.destination_customs && (!currentCard.data.sell_rates['l4' + leg_code + '_cha'] || !currentCard.data.sell_rates['l4' + leg_code + '_cha'].rate_obj)) {
        legUrl += 'l4' + leg_code + '_cha' + ',';
      }
      if (search_param.delivery_selected && (!currentCard.data.sell_rates['l5' + leg_code] || !currentCard.data.sell_rates['l5' + leg_code].rate_obj)) {
        legUrl += 'l5' + leg_code + ',';
      }

      if (search_param.shipment_insurance && (!currentCard.data.sell_rates['ins' + leg_code] || !currentCard.data.sell_rates['ins' + leg_code].rate_obj)) {
        legUrl += 'ins' + leg_code + '&value_of_good=' + search_param.insurance_leg_cost + '&currency=' + search_param.insurance_currency + ',';
      }

      legUrl = legUrl.length ? legUrl.slice(0, -1) : legUrl;
      return legUrl;
    }

    function trackMixPanelForInquiry(inquiryData, search_data, source, quote_number, search_param) {
      //mixpanel code
      analytics.track("Inq-Inquiry Created", {
        "Inquiry No.": inquiryData ? (inquiryData.inquiry_number ? inquiryData.inquiry_number : 'NA') : 'NA',
        "Quotation No.": quote_number,
        "Source": source,
        "Port-Pair": search_data.origin_location.location + ' to ' + search_data.destination_location.location,
        "Search Param": search_data.origin_location.location + ' to ' + search_data.destination_location.location + ' / ' + $filter('date')(search_data.cargo_ready_date, 'd MMM yyyy') + ' / ' + search_param.loadtype,
        "Mode": search_data.mode,
        "Created On": $filter('date')(new Date(), 'yyyy-MM-dd'),
        "Created By": util.userProfile.user.user_first_name + ' ' + util.userProfile.user.user_last_name,
        "Created For": inquiryData ? (inquiryData.shipper_user ? inquiryData.shipper_user.user_first_name + ' ' + inquiryData.shipper_user.user_last_name : 'NA') : 'NA',
        "Inquiry Status": inquiryData ? (inquiryData.current_status ? inquiryData.current_status.status : 'NA') : 'NA'
      });
    }

    // get pooling data
    function getPoolingData(action, id) {
      var url = api.baseUrl + '/api/inquiry-pooling?from=' + action + '&id=' + id;
      return $http.get(url).then(function (response) {
        return response.data;
      });
    }

    function getCardTerms(url) {
      // var url = api.baseUrl + '/api/agents';
      return $http.get(api.baseUrl + '/'+ url);
    }

    // conversion rates in card
    function fnGetConversionRates(ConversionRates, vendor_id, card_meta , mode) {

      var getCurrencyRate = ConversionRates.find(function (element) {
        return (element.vendor_id == vendor_id);
      });

      if (!getCurrencyRate) {
        resultService.getCurrencyConversionForVendor(resultService.user_base_currency, vendor_id,mode,true).then(function(response){
          var currencyObj = response.data;
          ConversionRates.push(currencyObj);
          getCurrencyRate = currencyObj;
          if(!!card_meta){
            card_meta['conversionRate'] = getCurrencyRate;
          }
          return getCurrencyRate;
        },function(error){
          $log.log(error.data);
        });
      }else{
        return getCurrencyRate;
      }
    }

    function getCurrencyConversionForVendor(currency, vendor_id, mode,applyMarkup){

      var url = api.baseUrl + '/api/v2/currency-conversion?baseCurrency='+currency+'&applyMarkup='+applyMarkup+'&vendorId='+vendor_id+'&mode='+mode
      return $http.get(url);
    }

    // Get conveniance fee cost
    // function fnGetConvFeeCost(additional_charges, total_cost, search_id, currency) {

    //   var url = additional_charges.url + "&total_cost=" + total_cost + "&id=" + search_id + "&currency=" + currency;
    //   return $http.get(url).then(function (response) {
    //     additional_charges.data = response.data.data;
    //   }, function (error) {
    //     $log.log(error);
    //   });
    // }

    // API Call for conveniance fee
    function fnCallConvFeeApi(url){
      return $http.get(url);
    }

    // Form FCL load structure ex.20GPX1_40GPX2
    function formLoadStructure(load_data) {
      var response = '';
      if (load_data != null) {
        var length = load_data.load_details_value.length;
        if (length > 0) {
          load_data.load_details_value.map(function (item, index) {
            response += item.type + 'x' + item.qty + ((length - 1) === index ? '' : '_');
          });
        }
      }
      return response;
    }

    // Get Conveniance fee leg by calling api
    function getConvFee(currentCard, total_cost, search_id, currency) {

      if (currentCard.meta.additional_charges.url && !currentCard.meta.additional_charges.data) {

        var url = api.baseUrl +'/'+ currentCard.meta.additional_charges.url + "&total_cost=" + total_cost + "&id=" + search_id + "&currency=" + currency;
        return $http.get(url).then(function (response) {
          currentCard.meta.additional_charges.data = response.data.data;
        }, function (error) {
          $log.log(error);
        });

        // resultService.fnGetConvFeeCost(currentCard.meta.additional_charges,total_cost,search_id,currency);
        // console.log(currentCard.meta.additional_charges);
      }

    }

    function fnCardFilter(mode, resultCardArray, selected_filter_obj ) {
      var resultByFilter = resultCardArray;
      var cardsCount = resultCardArray.length;
      var selectedFilterCount = 0;
      var onlyFbRates = true;
      var filterRatesCard = [];

        //  logic to hide - show card
        if(resultByFilter != undefined ){

          resultByFilter.filter(function (el) {
            var isSubvendor = 0; var isAirlines = 0; var isOriginTransporter = 0; var isDestinationTransporter = 0; var isPickupTransporter = 0; var isDeliveryTransporter = 0; var isViaPol = 0; var isViaPod = 0; var isOriginHaulage = 0;
            var isDestinationHaulage = 0; var isViaRoute = 0; var israteType = 0; var isCardStatus = 0;
            var isFbRates = 1; var isRollable = 1; var isOriginPort = 0; var isDestinationPort = 0; var isAgent = 0; var isCommodity = 0; var isContractId = 0; var isCargo = 0; var isEmptyContainerPickup = 0; var isEmptyContainerDrop = 0; var showNoRates = 0;

            // dispaly fb rates
            if( resultService.userVendorID != '104' && el.meta.vendor_id == '104' && onlyFbRates == false){
              isFbRates = 0;
            }

            // rollable
            if(selected_filter_obj.rollable == true){
              if(el.data.buy_rates['l3_'+mode].rate_obj && el.data.buy_rates['l3_'+mode].rate_obj["rollable_available"]){
                isRollable = 1;
              }else{
                isRollable = 0;
              }
            }

            // if no field selected for filter
            if( !selected_filter_obj.selected_liners.length && !selected_filter_obj.selected_airlines.length && !selected_filter_obj.selected_originTransporter.length && !selected_filter_obj.selected_destinationTransporter.length && !selected_filter_obj.selected_pickupTransporter.length && !selected_filter_obj.selected_deliveryTransporter.length && !selected_filter_obj.selected_loadingPort.length && !selected_filter_obj.selected_dischargePort.length && !selected_filter_obj.selected_originHaulage.length && !selected_filter_obj.selected_destinationHaulage.length &&
            !selected_filter_obj.selected_originPort.length && !selected_filter_obj.selected_destinationPort.length && !selected_filter_obj.selected_agent.length && selected_filter_obj.via_route_filter != 'Direct' && !selected_filter_obj.selected_commodity.length && selected_filter_obj.selected_cargoType == 'All' && selected_filter_obj.selected_ratesType == 'All' &&  !selected_filter_obj.selected_depoContainerPickup.length && !selected_filter_obj.selected_depoContainerDrop.length){

              el.meta["showCard"] = isRollable ? ( isFbRates ? true : false ) : false;
              cardsCount -= !el.meta.showCard ? 1 : 0;

            }else{

              // subvendor
              if(selected_filter_obj.selected_liners.length && (selected_filter_obj.selected_liners.indexOf(el.data.buy_rates['l3_'+mode].rate_obj.sub_vendor.sv_id) >= 0)  ){
                isSubvendor = 1;
              }else if(!selected_filter_obj.selected_liners.length){
                isSubvendor = 1;
              }

              // airlines
              if(selected_filter_obj.selected_airlines.length && (selected_filter_obj.selected_airlines.indexOf(el.data.buy_rates['l3_'+mode].rate_obj.airline.airline_code) >= 0)  ){
                isAirlines = 1;
              }else if(!selected_filter_obj.selected_airlines.length){
                isAirlines = 1;
              }

              // agents
              if(selected_filter_obj.selected_agent.length && (el.data.buy_rates['l3_'+mode].rate_obj.agent && selected_filter_obj.selected_agent.indexOf(el.data.buy_rates['l3_'+mode].rate_obj.agent.agent_name) >= 0)  ){
                isAgent = 1;
              }else if(!selected_filter_obj.selected_agent.length){
                isAgent = 1;
              }

              //ratesType 
              var rates_vendorId = mode === "air" ? el.data.buy_rates['l3_'+mode].rate_obj.airline.airline_code : el.data.buy_rates['l3_'+mode].rate_obj.sub_vendor.sv_id;
              if(selected_filter_obj.selected_rateType == "All"){
                israteType = 1;
              }
              else if(SearchService.ratesTypeFilter.carrier_mappings[mode.toUpperCase()][selected_filter_obj.selected_rateType].includes(rates_vendorId)){
                israteType = 1;
              }

              // origin transporter
              if( selected_filter_obj.selected_originTransporter.length && (el.data.buy_rates['l2_'+mode] && el.data.buy_rates['l2_'+mode].rate_obj && selected_filter_obj.selected_originTransporter.indexOf(el.data.buy_rates['l2_'+mode].rate_obj.sub_vendor.sub_vendor_name) >= 0) ) {
                isOriginTransporter = 1;
              }else if(!selected_filter_obj.selected_originTransporter.length){
                isOriginTransporter = 1;
              }

              // destination transporter
              if( selected_filter_obj.selected_destinationTransporter.length && ( el.data.buy_rates['l4_'+mode] && el.data.buy_rates['l4_'+mode].rate_obj && selected_filter_obj.selected_destinationTransporter.indexOf(el.data.buy_rates['l4_'+mode].rate_obj.sub_vendor.sub_vendor_name) >= 0) ) {
                isDestinationTransporter = 1;
              }else if(!selected_filter_obj.selected_destinationTransporter.length){
                isDestinationTransporter = 1;
              }

              // pickup transporter
              if( selected_filter_obj.selected_pickupTransporter.length && (el.data.buy_rates['l1_'+mode] && el.data.buy_rates['l1_'+mode].rate_obj && selected_filter_obj.selected_pickupTransporter.indexOf(el.data.buy_rates['l1_'+mode].rate_obj.sub_vendor.sub_vendor_name) >= 0) ) {
                isPickupTransporter = 1;
              }else if(!selected_filter_obj.selected_pickupTransporter.length){
                isPickupTransporter = 1;
              }

              // delivery transporter
              if( selected_filter_obj.selected_deliveryTransporter.length && ( el.data.buy_rates['l5_'+mode] && el.data.buy_rates['l5_'+mode].rate_obj && selected_filter_obj.selected_deliveryTransporter.indexOf(el.data.buy_rates['l5_'+mode].rate_obj.sub_vendor.sub_vendor_name) >= 0) ) {
                isDeliveryTransporter = 1;
              }else if(!selected_filter_obj.selected_deliveryTransporter.length){
                isDeliveryTransporter = 1;
              }

              // loading port

              var isLoadingAvl = (!el.meta.via_pol && selected_filter_obj.selected_loadingPort.indexOf('N/A') >= 0) ||
              (el.meta.via_pol && selected_filter_obj.selected_loadingPort.indexOf(el.meta.via_pol) >= 0) ||
              ( !el.meta.via_pol && selected_filter_obj.selected_loadingPort.indexOf(el.meta.port_data.origin_port_code) >= 0 )

              if(selected_filter_obj.selected_loadingPort.length && isLoadingAvl ){
                isViaPol = 1;
              }else if(!selected_filter_obj.selected_loadingPort.length){
                isViaPol = 1;
              }

              // discharge port
              var isDischargeAvl = (!el.meta.via_pod && selected_filter_obj.selected_dischargePort.indexOf('N/A') >= 0) ||
              (el.meta.via_pod && selected_filter_obj.selected_dischargePort.indexOf(el.meta.via_pod) >= 0) ||
              ( !el.meta.via_pod && selected_filter_obj.selected_dischargePort.indexOf(el.meta.port_data.destination_port_code) >= 0 )

              if(selected_filter_obj.selected_dischargePort.length && isDischargeAvl ){
                isViaPod = 1;
              }else if(!selected_filter_obj.selected_dischargePort.length){
                isViaPod = 1;
              }

              // Container pickup
              if(selected_filter_obj.selected_depoContainerPickup.length && (selected_filter_obj.selected_depoContainerPickup.indexOf(el.meta.port_data.empty_container_pickup && el.meta.port_data.empty_container_pickup.port_code) >= 0) ){
                isEmptyContainerPickup = 1;
              }else if(!selected_filter_obj.selected_depoContainerPickup.length){
                isEmptyContainerPickup = 1;
              }

              // Container drop
              if(selected_filter_obj.selected_depoContainerDrop.length && (selected_filter_obj.selected_depoContainerDrop.indexOf(el.meta.port_data.empty_container_drop && el.meta.port_data.empty_container_drop.port_code) >= 0) ){
                isEmptyContainerDrop = 1;
              }else if(!selected_filter_obj.selected_depoContainerDrop.length){
                isEmptyContainerDrop = 1;
              }

              // origin port    
              //remove this condition && !el.meta.via_pol
              if(selected_filter_obj.selected_originPort.length && (selected_filter_obj.selected_originPort.indexOf(el.meta.port_data.origin_port_code) >= 0) ){
                isOriginPort = 1;
              }else if(!selected_filter_obj.selected_originPort.length){
                isOriginPort = 1;
              }
              
              // destination port    
              //remove this condition && !el.meta.via_pod
              if(selected_filter_obj.selected_destinationPort.length && (selected_filter_obj.selected_destinationPort.indexOf(el.meta.port_data.destination_port_code) >= 0 ) ){
                isDestinationPort = 1;
              }else if(!selected_filter_obj.selected_destinationPort.length){
                isDestinationPort = 1;
              }

              // origin haulage
              var isHaulageAvl = selected_filter_obj.selected_originHaulage.find(function(item){ return el.meta.haulage && el.meta.haulage.toLowerCase().includes(item) });

              var originHaulage = (!el.meta.haulage && selected_filter_obj.selected_originHaulage.indexOf('not available') >= 0) ||
              (el.meta.haulage && isHaulageAvl);

              if(selected_filter_obj.selected_originHaulage.length && (el.meta.via_pol && originHaulage)  ){
                isOriginHaulage = 1;
              }else if(!selected_filter_obj.selected_originHaulage.length){
                isOriginHaulage = 1;
              }

              // destination haulage
              var isDestHaulageAvl = selected_filter_obj.selected_destinationHaulage.find(function(item){ return el.meta.destination_haulage && el.meta.destination_haulage.toLowerCase().includes(item) });

              var destinationHaulage = (!el.meta.destination_haulage && selected_filter_obj.selected_destinationHaulage.indexOf('not available') >= 0) ||
              (el.meta.destination_haulage && isDestHaulageAvl);

              if(selected_filter_obj.selected_destinationHaulage.length && (el.meta.via_pod && destinationHaulage ) ){
                isDestinationHaulage = 1;
              }else if(!selected_filter_obj.selected_destinationHaulage.length){
                isDestinationHaulage = 1;
              }

              // via route
              if( selected_filter_obj.via_route_filter == 'Direct' && !el.meta.isError &&
              el.data.buy_rates['l3_'+mode].rate_obj.schedule.direct != undefined ||
              (el.data.buy_rates['l3_'+mode].rate_obj.via_port != null && el.data.buy_rates['l3_'+mode].rate_obj.via_port != '' &&
              el.data.buy_rates['l3_'+mode].rate_obj.via_port.toLowerCase().trim() === 'direct') ){
                isViaRoute = 1;
              }else if( selected_filter_obj.via_route_filter != 'Direct' ){
                isViaRoute = 1;
              }

              // commodity
              var commodityObj = false;
              if(selected_filter_obj.selected_commodity.length && el.data.buy_rates['l3_'+mode].rate_obj.commodity_data){
                isCommodity = selected_filter_obj.selected_commodity.some(function (item) {
                  if(item == 'NOT AVAILABLE' && el.data.buy_rates['l3_'+mode].rate_obj.commodity_data.length <= 0){
                    commodityObj = false //angular.copy(el.data.buy_rates['l3_'+mode].rate_obj.commodity_data)
                  }else{
                    commodityObj = el.data.buy_rates['l3_'+mode].rate_obj.commodity_data.includes(item) 
                  }
                  return commodityObj;
                });
              }else if(!selected_filter_obj.selected_commodity.length){
                isCommodity = 1;
              }

              //Contract ID
              var contractIdObject = false;
              if(selected_filter_obj.selected_contractId.length && el.data.buy_rates['l3_'+mode].rate_obj.contract_number && !util.isShipper && (!el.meta.type.includes('network')  ||  $rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES)){
                isContractId = selected_filter_obj.selected_contractId.some(function (item) {
                     contractIdObject = el.data.buy_rates['l3_'+mode].rate_obj.contract_number.toLowerCase() == item.toLowerCase();                 
                     return contractIdObject;
                });
              }else if(!selected_filter_obj.selected_contractId.length){
                isContractId = 1;
              }
              // card status 
              if(selected_filter_obj.selected_cardStatus != 'All' && (util.getStatusData(el.data.buy_rates['l3_'+mode].rate_obj).toLowerCase() == selected_filter_obj.selected_cardStatus.toLowerCase())){
                isCardStatus = 1;
              }else if(selected_filter_obj.selected_cardStatus == 'All'){
                isCardStatus = 1;
              }

              //cargo type
              if(selected_filter_obj.selected_cargoType != 'All' && el.data.buy_rates['l3_'+mode].rate_obj.cargo_type_data && el.data.buy_rates['l3_'+mode].rate_obj.cargo_type_data.name == selected_filter_obj.selected_cargoType){
                isCargo = 1;
              }else if(selected_filter_obj.selected_cargoType == 'All'){
                isCargo = 1;
              }
              // No rates
              if(selected_filter_obj.no_rates_filter && !el.meta.isError){
                showNoRates = 1;
              }else if(!selected_filter_obj.no_rates_filter){
                showNoRates = 1;
              }

              //contract/online rate filter

              // if(el.data.buy_rates['l3_'+mode].rate_obj.sub_vendor.sv_id.includes)

              // hide - show card according selcted filter
              if(isSubvendor && isAirlines && isOriginTransporter && isDestinationTransporter && isPickupTransporter && isDeliveryTransporter && isViaPol && isViaPod && isOriginHaulage && isDestinationHaulage && isViaRoute && isFbRates && isRollable && isOriginPort && isDestinationPort && isAgent && isCommodity && isContractId && isCargo && israteType && isEmptyContainerPickup && isEmptyContainerDrop && showNoRates && isCardStatus){
                // el.meta["showCard"] = true;
                filterRatesCard.push(el);
              }else{
                // el.meta["showCard"] = false;
                cardsCount--;
              }
            }
          });

        }

        // total selected filter
        if(selected_filter_obj.via_route_filter == 'Direct'){
          selectedFilterCount++;
        }
        if(selected_filter_obj.no_rates_filter){
          selectedFilterCount++;
        }
        if(selected_filter_obj.rollable){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_liners.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_airlines.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_loadingPort.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_dischargePort.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_originHaulage.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_destinationHaulage.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_depoContainerPickup.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_depoContainerDrop.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_originPort.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_destinationPort.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_commodity.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_contractId.length){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_cargoType != 'All'){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_rateType != 'All'){
          selectedFilterCount++;
        }
        if(selected_filter_obj.selected_cardStatus != 'All'){
          selectedFilterCount++;
        
        }
        var result = {
          'cardsCount' : cardsCount,
          'selectedFilterCount' : selectedFilterCount,
          'filterRatesCard' : filterRatesCard
        }
        return result;
    };

    function fnGetPdfLink(id) {
      var url = '';
      if (util.isSharedQuote()) {
        url = api.baseUrl +'/shared/quote-pdf/' + id;
      }else{
        url = api.baseUrl +'/api/quote-pdf/' + id;
      }
      return $http.get(url);
    }

    function fnSetTransitTime(card, l3_leg){
      if(card.meta.selected_schedule){
        card.meta['transit_time'] = parseFloat(card.meta.selected_schedule.transit_time);
        card.meta['sailing_date'] = card.meta.selected_schedule.departure_time;
        }else{
        card.meta['transit_time'] = card.data ? (card.data.buy_rates[l3_leg].rate_obj.transit_time ? parseFloat(card.data.buy_rates[l3_leg].rate_obj.transit_time) : 'N/A'):(card.leg[l3_leg].transit_time ? parseFloat(card.leg[l3_leg].transit_time):'N/A');  //checking the structure for carrier booking
        card.meta['sailing_date'] = card.data ? (card.data.buy_rates[l3_leg].rate_obj.sailing_date ? card.data.buy_rates[l3_leg].rate_obj.sailing_date : 'N/A'):(card.leg[l3_leg].sailing_date ? card.leg[l3_leg].sailing_date:'N/A');
      }
    }

    function getResultType(){
      if($state.current.name=='app.search.result' || $state.current.name=='app.search.airResult' || $state.current.name=='app.resultBookShipment'){
        return 'Search';
      }else if($state.current.name == 'app.copyQuotesDetails' || $state.current.name == 'app.webViewQuotesDetails' || $state.current.name == 'app.shareQuotesDetails' || $state.current.name =='app.quoteBookShipment' || $state.current.name == 'app.quoteWebViewBookShipment' || $state.current.name == 'app.quoteSharedBookShipment' || $state.current.name == 'app.preview'){
        return 'Quote';
      }else if($state.current.name=='app.inquiry.inquiryDetails'){
        return 'Inquiry';
      }else if($state.current.name=='app.shipments.shipment_details' || $state.current.name=='app.shared_shipment_details' || $state.current.name=='app.mobile_shipment_details'){
        return 'Shipment';
      }else return '';
    }

    function getCommodityList(query){
      var url = api.baseMockUrl + '/commodity-list?query='+query;
      return $http.get(url);
    }

    function getCargoList(mode){
      var url = api.baseMockUrl + '/cargo-types?mode='+mode;
      if (util.isSharedQuote()) {
        url =  api.baseMockUrl + '/cargo-types?mode='+mode + '&vendor_id='+ resultService.requestToBookData.user.company.vendor_id;
      }
      
      return $http.get(url);
    }

    // function callConvenienceApi(data) {
    //   var url = api.baseUrl + '/api/other-charges/get';
    //   return $http.post(url, data);
    // }

    //******* below code currently not required --> formRateCardMsr
    // var results = resultService.pref_liner.some(function (entry) { return entry.name === buy_value.rate_obj.sub_vendor.sub_vendor_name; });
    // if (results) {
    //   card.meta['is_prefer'] = 0;
    // } else {
    //   card.meta['is_prefer'] = 1;
    // }

    function getCargoTypeFixedOrder(){
      return ["All","FAK","Perishable","Non-Perishable","Hazardous","Chilled","Out of Gauge","Flexi-bags"];
    }

  function fnMissingFlag(rateObj, cardMeta){
      var missingFlagObj = {
        'legName' : '',
        'loadState' : '',
        'message' : ''
      }

      // missing charges applicable only below leg
      var legNameArray =["l2_fcl", "l3_fcl", "l4_fcl", "l2_lcl", "l3_lcl", "l4_lcl", "l2_air", "l3_air", "l4_air"];
      
      if(legNameArray.includes(rateObj.leg_code)){
        missingFlagObj.legName = rateObj.leg_code.includes("l3") ? 'Freight Charges' : rateObj.leg_name;

        if(rateObj.leg_code.includes("fcl")){
          var loadArray = [];
          if(!rateObj.rate_obj){
            loadArray = resultService.searchLoadState;

          }else{
            angular.forEach(rateObj.rate_obj.load_stat, function (loadStateValue, key) {
              if(loadStateValue === 0){ // it's checking load state missing..
                loadArray.push(key);
              }
            });
          }

          if(loadArray.length){
            missingFlagObj.loadState = loadArray.join(', ');
            missingFlagObj.message = missingFlagObj.legName + ' are missing for '+ missingFlagObj.loadState + '.';
          }

        }else{
          if(!rateObj.rate_obj){
            missingFlagObj.message = missingFlagObj.legName + ' are missing.';
          }
        }
      }

      if(missingFlagObj.message != ''){
        cardMeta['missingFlag'].push(missingFlagObj.message);
      }
    }

    function getLinersData(type, query){
      var url = api.baseUrl +'/api/v2/carriers?type='+type+'&source=common&limit=60&offset=0';

      if(query){
        url += '&query='+query;
      }

      return $http.get(url);
    }

    function checkExistingCharge(chargeObj,charge_index,charges,legKey){
      resultService.duplicateEquipment =false;
      // angular.element('#' + buyLeg.leg_code + '_' + charge_index + '_row').removeClass("row-error");
      //it's checking Exist charge present or not.
      var isChargePresent = charges.find(function(charge,key){

        if(charge.charge_name && (!charge.status || charge.status != 'REMOVED')){
          if((chargeObj.container_type) && charge.charge_name.toLowerCase() === chargeObj.charge_name.toLowerCase() && chargeObj.charge_basis === charge.charge_basis && charge.container_type === chargeObj.container_type && charge_index !== key){
            return charge
          } 
          else if((!chargeObj.container_type) && charge.charge_name.toLowerCase() === chargeObj.charge_name.toLowerCase() && chargeObj.charge_basis === charge.charge_basis && charge_index !== key){
            return charge;
          }
        }
      });
      angular.element('#' + legKey + '_' + charge_index + '_duplicateEquipment').removeClass("error-text");
      if(isChargePresent){
        angular.element('#' + legKey + '_' + charge_index + '_row').addClass("row-error");
        var alertMsg = !chargeObj.container_type ? 'Basis' : 'Equipment Type';
        if(alertMsg==='Equipment Type'){
          resultService.duplicateEquipment = true;
          document.querySelector('#' + legKey + '_' + charge_index + '_row').classList.add("row-error");
          angular.element('#' + legKey + '_' + charge_index + '_equipmentType').addClass("error-border");
          angular.element('#' + legKey + '_' + charge_index + '_duplicateEquipment').addClass("error-text");
          angular.element('#' + legKey + '_' + charge_index + '_equipmentError').removeClass("error-text");
          angular.element('.' + legKey + charge_index + 'remove-rates-bg').removeClass("rates-bg");
        }
        if(alertMsg==='Basis'){
        angular.element('#' + legKey + '_' + charge_index + '_chargeBasis').addClass("error-border")
        angular.element('#' + legKey + '_' + charge_index + '_duplicate'+alertMsg).addClass("error-text");
        angular.element('.' + legKey + charge_index + 'remove-rates-bg').removeClass("rates-bg");
      }
        if(chargeObj.charge_basis == 'per equipment' || chargeObj.charge_basis == 'per kg' || chargeObj.charge_basis == 'per ton'||chargeObj.charge_basis === constObj.PICKUP_BASIS || chargeObj.charge_basis === constObj.DELIVERY_BASIS || chargeObj.charge_basis === constObj.FREIGHT_BASIS){
          chargeObj.container_type = '';
          return true;
        }
        chargeObj.charge_basis = '';
        return true;
      }
      return false;
    }

    function getScheduleSelectIndex(card,l3_leg){
      var scheduleIndex = card.data.buy_rates[l3_leg].rate_obj.schedule.data.findIndex(function(item){
        return $filter('date')(new Date(card.data.buy_rates[l3_leg].rate_obj.sailing_date),'yyyy-MM-dd') === $filter('date')(new Date(item.departure_time),'yyyy-MM-dd')
      });
      return scheduleIndex >= 0 ? scheduleIndex : null;
    }

    function triggerDatatableButton(buttonClass, data){
      //it's datatable action button
      if(buttonClass === '.buttons-columnVisibility'){
        $rootScope.$broadcast('columnVisibility',data);
        return;
      }
      angular.element(buttonClass).trigger("click");
    }

    function fnScheduleMatchingCard(currentCard,leg,schedule){
      var selectedSchedule = null;
      var matchViaPort = schedule.via_port && currentCard.data.buy_rates[leg].rate_obj.via_route ? (schedule.via_port.toLowerCase().indexOf(currentCard.data.buy_rates[leg].rate_obj.via_route.toLowerCase()) > -1 ||  schedule.via_port.toLowerCase().indexOf(currentCard.data.buy_rates[leg].rate_obj.via_route.toLowerCase()) > -1) : false;
      
      if($filter('date')(new Date(currentCard.data.buy_rates[leg].rate_obj.sailing_date),'yyyy-MM-dd') === $filter('date')(new Date(schedule.departure_time),'yyyy-MM-dd') && matchViaPort){ 
        selectedSchedule =  schedule; // it's selected schedule tab
      }
      return selectedSchedule;
    }

    function fnScheduleDisplayConfig(currentCard,l3_key){
      return (['msr_spot','network_spot'].includes(currentCard.meta.type) && !currentCard.data.buy_rates[l3_key].rate_obj.card_id.toLowerCase().includes('rpa'));
    }
    function getBatchcode(currentCard){
      var batchcode = [];
      var legs= currentCard ? Object.keys(currentCard.data.buy_rates) : [];
      for(var i=0;i<legs.length;i++){
        if(currentCard.data.buy_rates[legs[i]].rate_obj && currentCard.data.buy_rates[legs[i]].rate_obj.batchcode  && currentCard.data.buy_rates[legs[i]].rate_obj.batchcode.length && Array.isArray(currentCard.data.buy_rates[legs[i]].rate_obj.batchcode)){  
          currentCard.data.buy_rates[legs[i]].rate_obj.batchcode.forEach(function(batchcodeData){
            if(batchcodeData){
              batchcode.push(batchcodeData);
            }
          })
        }
      } 
      return batchcode;
    }

    function getSourceRate(batchcode){
      var url = api.baseMockUrl + '/source-sheet?batchcodes='+batchcode.join(',');
      return $http.get(url);
    }

    function fnGetFetchLegs(data){
      var url = api.baseUrl + '/api/v2/get-rate-legs';
      return $http.post(url, data);
    }


    //Function for co2 structure and api call 
    function fnSetCo2Payload(l3_Rate, porPair, co2Payload) {
      // var svId = l3_Rate.sub_vendor.sv_id+"";
      var carrierCode = l3_Rate.provider && l3_Rate.provider.carrier_code ? l3_Rate.provider.carrier_code : l3_Rate.sub_vendor.carrier_code;
  
      // Check if svId is not in co2Payload.routesData
      var carrierInfo = co2Payload.routesData.find(function(data){
        return data.carrierCode === carrierCode;
      });
      
      if (!carrierInfo) {
          // Create a new object with the required structure
          var newRouteData = {
              // "carrierId": svId,
              "carrierCode": carrierCode,
              "routes": [
                {
                  "origin": porPair.origin,
                  "destination": porPair.destination,
                  "via" : ""
                }
              ]
          };
  
          // Push the new object into co2Payload.routesData
          co2Payload.routesData.push(newRouteData);
      }else{

        var isRoutePresent = carrierInfo.routes.some(function(route) {
          return route.origin === porPair.origin && route.destination === porPair.destination;
        });
  
        // If the route is not present, add it
        if (!isRoutePresent) {
          carrierInfo.routes.push({
              "origin": porPair.origin,
              "destination": porPair.destination,
              "via" : ""
          });
        }  
      }
    }

    // call co2 api
    function fnCo2ApiCall(co2Payload,mode){
      var url = api.baseUrl + '/api/co2e?mode='+ mode ;
      return $http.post(url, co2Payload);
    }

    // calculate co2 container total with search load qty
    function fnCalculateCo2Total(co2Response, loadDetails){
      angular.forEach(co2Response, function (value, key) {

        for(var i = 0; i < value.length; i++){
          var co2e = {
            "total": 0,
            "intensity": 0,
            "well_to_tank": 0,
            "tank_to_wheel": 0
          }
          for(var k = 0; k < value[i].container_emissions.length; k++){
            var containerDetails = value[i].container_emissions[k];

            var isMatched = loadDetails.find(function(item) {
              return item.type === containerDetails.load_type;
            });
            
            if(isMatched){
              // save per qty for calculation
              if(!containerDetails["perQty"]){
                containerDetails["perQty"] = {
                  "total": angular.copy(containerDetails.co2e.total),
                  "intensity": angular.copy(containerDetails.co2e.intensity),
                  "well_to_tank": angular.copy(containerDetails.co2e.well_to_tank),
                  "tank_to_wheel": angular.copy(containerDetails.co2e.tank_to_wheel)
                }
              }

              containerDetails.co2e.tank_to_wheel = isMatched.qty * (containerDetails.perQty.tank_to_wheel != null ? containerDetails.perQty.tank_to_wheel : null);
              containerDetails.co2e.total = isMatched.qty * (containerDetails.perQty.total != null ? containerDetails.perQty.total : null);
              containerDetails.co2e.well_to_tank = isMatched.qty * (containerDetails.perQty.well_to_tank != null ? containerDetails.perQty.well_to_tank : null);

              co2e.total += containerDetails.co2e.total ? containerDetails.co2e.total : 0;
              co2e.intensity += containerDetails.co2e.intensity ? containerDetails.co2e.intensity : 0;
              co2e.well_to_tank += containerDetails.co2e.well_to_tank ? containerDetails.co2e.well_to_tank : 0;
              co2e.tank_to_wheel += containerDetails.co2e.tank_to_wheel ? containerDetails.co2e.tank_to_wheel : 0;
            }
          }
          value[i].co2e = angular.copy(co2e);
        }

      });
    }
    function fnSetNoRates(noRatesArray , allRatesArrayCopy, resultCardArray, legName ){
      var cardData = {
        data:{
        cards:[],
        rates:{}
        }
       }
        angular.forEach(noRatesArray, function(card){
          card.meta["isScheduleCall"] = true;
          if(legName != 'l3_air'){
            card.data.sell_rates[legName].rate_obj = {"sub_vendor": card.data.sell_rates.l3_fcl.sub_vendor}
            card.data.buy_rates[legName].rate_obj = {"sub_vendor": card.data.sell_rates.l3_fcl.sub_vendor}
          }
          else{
            card.data.sell_rates[legName].rate_obj = {"airline": card.data.sell_rates.l3_fcl.airline}
            card.data.buy_rates[legName].rate_obj = {"airline": card.data.sell_rates.l3_fcl.airline}
          }
          cardData.data.cards.push(card);
          resultCardArray.push(card);
                
        });
        allRatesArrayCopy.push(cardData);

        var noRatesList ={
          "allRatesArrayCopy": allRatesArrayCopy,
          "resultCardArray" : resultCardArray
         }
         return noRatesList ;

    };
    
    function calculateChargeSummary(load_data,mode,currentCard){
      if(mode.toLowerCase().includes('fcl')){
          var chargeSummaryObj = new fbUtils.ChargeSummaryFactory.getInstance(load_data, mode);
      }
          angular.forEach(currentCard.data.sell_rates, function (value, key) {
            if(mode.toLowerCase().includes('fcl')){
              var buySummaryData = chargeSummaryObj.calculate(currentCard.data.buy_rates[key].rate_obj);
              var sellSummaryData = chargeSummaryObj.calculate(currentCard.data.sell_rates[key].rate_obj);
              currentCard.data.buy_rates[key]['charge_summary'] = buySummaryData;
              currentCard.data.sell_rates[key]['charge_summary'] = sellSummaryData;
            }else{
              currentCard.data.buy_rates[key]['charge_summary'] = null;
              currentCard.data.sell_rates[key]['charge_summary'] = null;
            }
        });
    }

    function fnXenetaRateCall(payload, vendorId, searchId, type){

      var url = api.baseUrl + '/api/freightAnalysis?vendorId='+ vendorId + '&searchId=' + searchId + '&source=freightIndex&rateType='+ type;
      return $http.post(url, payload);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.result")
    .controller("LclResultV2Controller", LclResultV2Controller);

  /** @ngInject */
  function LclResultV2Controller(
    util,
    iframeService,
    $timeout,
    $state,
    $rootScope,
    SearchService,
    $stateParams,
    $scope
  ) {
    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;
    vm.searchService = SearchService;
    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.getIframeRequest = getIframeRequest;
    vm.fnRfqConfirmation=fnRfqConfirmation
    vm.util = util;

    // if god user changed forwarder refresh data
    $rootScope.$on(
      "app.search" + vm.searchService.searchMode.state,
      function (event, args) {
        vm.init();
      }
    );

    $scope.$on('$destroy', function () {
      if (window.removeEventListener) {
        window.removeEventListener("message", getNewRatesObj, true);
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", getNewRatesObj);
      }
    });
    vm.init();

    function init() {
      util.isModulePaid('SEA-LCL');
      vm.minHeight = vm.iframeService.iframeHeight;
      if(!(util.isEfpEnabled)){
            $state.go('app.pages_share_error');
        }

      vm.formIframeUrl(); // Get Iframe src url
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";
      $timeout(function () {
        var windowHeight =
          document.getElementById("content-container").offsetHeight + 7;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
      }, 800);
      $rootScope.loadingDetails = false;
      if (window.addEventListener) {
        window.addEventListener("message", getNewRatesObj, true);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", getNewRatesObj, true);
      }
    }

    function getIframeRequest(event) {
      if ( event.origin.indexOf(util.iframeOrigin) && event.data.source === "polling" ) {
        var targetOrigin = new URL(vm.iframeUrl).origin;
        if (event.origin === targetOrigin) {
          document.getElementById("result-v2-iframe").contentWindow.postMessage( { navPermission: util.navPermission, dataSource: "polling" }, targetOrigin);
        }
      }
    }
    function formIframeUrl() {
      var ftlResultIframe = document.getElementById("result-v2-iframe");
      var resultpath = "resultV2/";
      vm.iframeUrl = iframeService.fnGetIframeUrl(
        resultpath + vm.searchService.searchMode.mode + "/" + $stateParams.id,'','web'
      );
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&searchId=" + $stateParams.id);
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl,
        "&reqAccessV2LclPollingData=1&parentUrl=" +
        window.location.origin +
        "&quotePermission=" +
        util.navPermission["quotes"] +
        "&inquiryPermission=" +
        util.navPermission["inquiry"] +
        "&bookingPermission=" +
        util.navPermission["shipments"]);
      ftlResultIframe.src = vm.iframeUrl;
      util.isCallingApi = true;
      ftlResultIframe.onload = function () {
        $timeout(function () {
          util.isCallingApi = false;
        });
      };
    }

     function fnRfqConfirmation(event) {
       if (event.data.redirectTo == "search") {
         util.showToast(
           util.displayValidationError("Redirecting to search page.")
         );
         $state.go("app.searchV2Module");
       } else {
         util.showToast(
           util.displayValidationError("Redirecting to enquiry page.")
         );
         if (util.isShipper) {
           $state.go("app.enquiry");
         } else {
           $state.go("app.enquiry.enquiryDetails", { id: event.data.id });
         }
       }
     };

    function getNewRatesObj(event) {
      var data = event && event.data;
      if (!data || typeof data !== "object" || !data.source) {
        return;
      }
      if (data.source === "standard-quotation" || data.source === "polling") {
        return;
      }

      var statePage = "";
      var resultIframe = document.getElementById("result-v2-iframe");
      var targetOrigin = vm.iframeUrl ? new URL(vm.iframeUrl).origin : "";

      switch (data.source) {
        case "fcl-v2-result":
          if (data.resultId && data.resultId !== $stateParams.id) {
            statePage = "app.searchV2Module.fclEfpRates";
          }
          break;
        case "lcl-v2-result":
          if (resultIframe && resultIframe.contentWindow && targetOrigin) {
            resultIframe.contentWindow.postMessage(
              {
                selectedCard: util.oneQuoteData.selectedCard,
                quoteData: util.oneQuoteData.quoteData,
                pageSource: util.oneQuoteData.pageSource,
                dataSource: "lcl-v2-result",
                currencyConversion: util.oneQuoteData.currencyConversion,
                searchParam: util.oneQuoteData.searchParam,
                from: util.oneQuoteData.from,
                searchId: util.oneQuoteData.searchId
              },
              targetOrigin
            );
          }
          if (data.resultId && data.resultId !== $stateParams.id) {
            statePage = "app.searchV2Module.lclEfpRates";
          }
          break;
        case "air-v2-result":
          if (data.resultId && data.resultId !== $stateParams.id) {
            statePage = "app.searchV2Module.airEfpRates";
          }
          break;
        case "create-bookingv2":
          vm.util.redirectToBooking(event);
          return;
        case "goToBasket":
          statePage = "app.basketModule";
          break;
        case "one-quote":
          vm.util.redirectToOneQuote(event);
          return;
        case "RFQ":
          vm.fnRfqConfirmation(event);
          return;
        case "tariffHeaderList":
          if (data.reqData && data.reqData._id) {
            var tariffUrl = $state.href("app.tariffDetails", { id: data.reqData._id });
            window.open(util.sanitizeQueryParams(tariffUrl), "_blank", "noopener");
          }
          return;
        case "error":
          vm.util.redirectToErrorPage(data.errorStatusCode);
          return;
        default:
          return;
      }

      if (statePage && data.resultId) {
        $state.go(statePage, { id: data.resultId });
      } else if (statePage && !data.resultId) {
        $state.go(statePage);
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.result")
    .controller("FclResultV2Controller", FclResultV2Controller);

  /** @ngInject */
  function FclResultV2Controller(
    util,
    iframeService,
    $timeout,
    $state,
    $rootScope,
    SearchService,
    $stateParams,
    shareQuoteService,
    resultService,
    $mdDialog,
    analytics,
    $scope
  ) {
    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;
    vm.searchService = SearchService;
    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.getIframeRequest = getIframeRequest;
    vm.util = util;
    vm.fnRfqConfirmation = fnRfqConfirmation;

    // if god user changed forwarder refresh data
    $rootScope.$on(
      "app.search" + vm.searchService.searchMode.state,
      function (event, args) {
        vm.init();
      }
    );

    $scope.$on('$destroy', function () {
      if (window.removeEventListener) {
        window.removeEventListener("message", getNewRatesObj, true);
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", getNewRatesObj);
      }
    });
    vm.init();

    function init() {
      util.isModulePaid('SEA-FCL');
      vm.minHeight = vm.iframeService.iframeHeight;
         if(!util.isEfpEnabled){
            $state.go('app.pages_share_error');
        }
      vm.formIframeUrl(); // Get Iframe src url
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";
      $timeout(function () {
        var windowHeight =
          document.getElementById("content-container").offsetHeight + 7;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
      }, 800);
      if (window.addEventListener) {
        window.addEventListener("message", getNewRatesObj, true);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", getNewRatesObj, true);
      }
      $rootScope.loadingDetails = false;
    }

    function getIframeRequest(event) {
      if ( event.origin.indexOf(util.iframeOrigin) && event.data.source === "polling" ) {
        var targetOrigin = new URL(vm.iframeUrl).origin;
        if (event.origin === targetOrigin) {
          document.getElementById("result-v2-iframe").contentWindow.postMessage( { navPermission: util.navPermission, dataSource: "polling" }, targetOrigin);
        }
      }
    }
    function formIframeUrl() {
      var ftlResultIframe = document.getElementById("result-v2-iframe");
      var resultpath = "resultV2/";
      vm.iframeUrl = iframeService.fnGetIframeUrl(
        resultpath + vm.searchService.searchMode.mode + "/" + $stateParams.id,'','web'
      );
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&searchId=" + $stateParams.id);
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl,
        "&reqAccessV2FclPollingData=1&parentUrl=" +
        window.location.origin +
        "&oneQuoteData=" +
        vm.util.oneQuoteData.pageSource +
        "&quotePermission=" +
        util.navPermission["quotes"] +
        "&inquiryPermission=" +
        util.navPermission["inquiry"] +
        "&bookingPermission=" +
        util.navPermission["shipments"]);
      ftlResultIframe.src = vm.iframeUrl;
      util.isCallingApi = true;
      ftlResultIframe.onload = function () {
        $timeout(function () {
          util.isCallingApi = false;
        });
      };
    }

    function fnRfqConfirmation(event) {
      if (event.data.redirectTo == "search") {
        util.showToast(
          util.displayValidationError("Redirecting to search page.")
        );
        $state.go("app.searchV2Module");
      } else {
        util.showToast(
          util.displayValidationError("Redirecting to enquiry page.")
        );
        if (util.isShipper) {
          $state.go("app.enquiry");
        } else {
            $state.go("app.enquiry.enquiryDetails", { id: event.data.id });
        }
      }
    }

    function getNewRatesObj(event) {
      var data = event && event.data;
      if (!data || typeof data !== "object" || !data.source) {
        return;
      }
      if (data.source === "standard-quotation" || data.source === "polling") {
        return;
      }

      var statePage = "";
      var resultIframe = document.getElementById("result-v2-iframe");
      var targetOrigin = vm.iframeUrl ? new URL(vm.iframeUrl).origin : "";

      switch (data.source) {
        case "fcl-v2-result":
          if (resultIframe && resultIframe.contentWindow && targetOrigin) {
            resultIframe.contentWindow.postMessage(
              {
                selectedCard: util.oneQuoteData.selectedCard,
                quoteData: util.oneQuoteData.quoteData,
                pageSource: util.oneQuoteData.pageSource,
                dataSource: "fcl-v2-result",
                currencyConversion: util.oneQuoteData.currencyConversion,
                searchParam: util.oneQuoteData.searchParam,
                from: util.oneQuoteData.from,
                searchId: util.oneQuoteData.searchId
              },
              targetOrigin
            );
          }
          if (data.resultId && data.resultId !== $stateParams.id) {
            statePage = "app.searchV2Module.fclEfpRates";
          }
          break;
        case "lcl-v2-result":
          if (data.resultId && data.resultId !== $stateParams.id) {
            statePage = "app.searchV2Module.lclEfpRates";
          }
          break;
        case "air-v2-result":
          if (data.resultId && data.resultId !== $stateParams.id) {
            statePage = "app.searchV2Module.airEfpRates";
          }
          break;
        case "goToBasket":
          statePage = "app.basketModule";
          break;
        case "one-quote":
          vm.util.redirectToOneQuote(event);
          return;
        case "create-bookingv2":
          vm.util.redirectToBooking(event);
          return;
        case "RFQ":
          vm.fnRfqConfirmation(event);
          return;
        case "tariffHeaderList":
          if (data.reqData && data.reqData._id) {
            var tariffUrl = $state.href("app.tariffDetails", { id: data.reqData._id });
            window.open(util.sanitizeQueryParams(tariffUrl), "_blank", "noopener");
          }
          return;
        case "error":
          vm.util.redirectToErrorPage(data.errorStatusCode);
          return;
        default:
          return;
      }

      if (statePage && data.resultId) {
        $state.go(statePage, { id: data.resultId });
      } else if (statePage && !data.resultId) {
        $state.go(statePage);
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.result")
    .controller("AirResultV2Controller", AirResultV2Controller);

  /** @ngInject */
  function AirResultV2Controller(
    util,
    iframeService,
    $timeout,
    $state,
    $rootScope,
    SearchService,
    $stateParams,
    $scope
  ) {
    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;
    vm.searchService = SearchService;
    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.getIframeRequest = getIframeRequest;
    vm.fnRfqConfirmation = fnRfqConfirmation;
    vm.util = util;

    // if god user changed forwarder refresh data
    $rootScope.$on(
      "app.search" + vm.searchService.searchMode.state,
      function (event, args) {
        vm.init();
      }
    );

    $scope.$on("$destroy", function () {
      if (window.removeEventListener) {
        window.removeEventListener("message", getNewRatesObj, true);
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", getNewRatesObj);
      }
    });
    vm.init();

    function init() {
      util.isModulePaid("AIR");
      vm.minHeight = vm.iframeService.iframeHeight;
      if (!util.isEfpEnabled) {
        $state.go("app.pages_share_error");
      }

      vm.formIframeUrl();
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";
      $timeout(function () {
        var windowHeight =
          document.getElementById("content-container").offsetHeight + 7;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
      }, 800);
      $rootScope.loadingDetails = false;
      if (window.addEventListener) {
        window.addEventListener("message", getNewRatesObj, true);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", getNewRatesObj, true);
      }
    }

    function getIframeRequest(event) {
      if (
        event.data &&
        event.data.source === "polling"
      ) {
        var targetOrigin = new URL(vm.iframeUrl).origin;
        if (event.origin === targetOrigin) {
          document
            .getElementById("result-v2-iframe")
            .contentWindow.postMessage(
              { navPermission: util.navPermission, dataSource: "polling" },
              targetOrigin
            );
        }
      }
    }
    function formIframeUrl() {
      var ftlResultIframe = document.getElementById("result-v2-iframe");
      var resultpath = "resultV2/";
      vm.iframeUrl = iframeService.fnGetIframeUrl(
        resultpath +
          vm.searchService.searchMode.mode +
          "/" +
          $stateParams.id,
        "",
        "web"
      );
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&searchId=" + $stateParams.id);
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl,
        "&reqAccessV2AirPollingData=1&parentUrl=" +
        window.location.origin +
        "&quotePermission=" +
        util.navPermission["quotes"] +
        "&inquiryPermission=" +
        util.navPermission["inquiry"] +
        "&bookingPermission=" +
        util.navPermission["shipments"]);
      ftlResultIframe.src = vm.iframeUrl;
      util.isCallingApi = true;
      ftlResultIframe.onload = function () {
        $timeout(function () {
          util.isCallingApi = false;
        });
      };
    }

    function fnRfqConfirmation(event) {
      if (event.data.redirectTo == "search") {
        util.showToast(
          util.displayValidationError("Redirecting to search page.")
        );
        $state.go("app.searchV2Module");
      } else {
        util.showToast(
          util.displayValidationError("Redirecting to enquiry page.")
        );
        if (util.isShipper) {
          $state.go("app.enquiry");
        } else {
          $state.go("app.enquiry.enquiryDetails", { id: event.data.id });
        }
      }
    }

    function getNewRatesObj(event) {
      var data = event && event.data;
      if (!data || typeof data !== "object" || !data.source) {
        return;
      }
      if (data.source === "standard-quotation" || data.source === "polling") {
        return;
      }
      var statePage = "";
      var resultIframe = document.getElementById("result-v2-iframe");
      var targetOrigin = vm.iframeUrl ? new URL(vm.iframeUrl).origin : "";

      switch (data.source) {
        case "fcl-v2-result":
          statePage = "app.searchV2Module.fclEfpRates";
          break;
        case "lcl-v2-result":
          statePage = "app.searchV2Module.lclEfpRates";
          break;
        case "air-v2-result":
          if (resultIframe && resultIframe.contentWindow && targetOrigin) {
            resultIframe.contentWindow.postMessage(
              {
                selectedCard: util.oneQuoteData.selectedCard,
                quoteData: util.oneQuoteData.quoteData,
                pageSource: util.oneQuoteData.pageSource,
                dataSource: "air-v2-result",
                currencyConversion: util.oneQuoteData.currencyConversion,
                searchParam: util.oneQuoteData.searchParam,
                from: util.oneQuoteData.from,
                searchId: util.oneQuoteData.searchId,
              },
              targetOrigin
            );
          }
          if (data.resultId && data.resultId !== $stateParams.id) {
            statePage = "app.searchV2Module.airEfpRates";
          }
          break;
        case "create-bookingv2":
          vm.util.redirectToBooking(event);
          return;
        case "goToBasket":
          statePage = "app.basketModule";
          break;
        case "one-quote":
          vm.util.redirectToOneQuote(event);
          return;
        case "RFQ":
          vm.fnRfqConfirmation(event);
          return;
        case "error":
          vm.util.redirectToErrorPage(data.errorStatusCode);
          return;
        case "tariffHeaderList":
            if (event.data.reqData && event.data.reqData._id) {
              var tariffUrl = $state.href("app.tariffDetails", { id: event.data.reqData._id });
              window.open(util.sanitizeQueryParams(tariffUrl), "_blank", "noopener");
            }
            return;
        default:
          return;
      }

      if (statePage && data.resultId) {
        $state.go(statePage, { id: data.resultId });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
    .module('app.core')
    .component('nwlsRequestForQuote', {
        templateUrl: 'app/main/result/request-for-quote/request-popup.html',
        bindings : {
            rfqdata : '=',
            callback : '&'
        },
        controller: RequestForQuoteController
    });


    function RequestForQuoteController($scope, $state, util, resultService,ShipmentService, SearchService, api, $log, $mdDialog, $rootElement, $attrs, analytics, $rootScope, $filter, localStorageService, shareQuoteService, $timeout, $mdToast, $mdMedia, $q) {

        var vm = this;
        vm.util = util;
        vm.shareQuoteService = shareQuoteService;

        vm.fnGetLoadList = fnGetLoadList;
        vm.getSubVendorList = getSubVendorList;
        vm.makeDetailBoxString=makeDetailBoxString;
        vm.getCurrencyList = getCurrencyList;
        vm.changeEmailText = changeEmailText;
        vm.getShipperCompany = getShipperCompany;
        vm.changeCompany = changeCompany;
        vm.getSalesPersonList = getSalesPersonList;
        vm.fnchangeSalesPerson = fnchangeSalesPerson;
        vm.loadFilter = loadFilter;
        vm.removeLoad = removeLoad;
        vm.addNewLoad = addNewLoad;
        vm.fnOpenAdvancedSearch = fnOpenAdvancedSearch;
        vm.fnSendRFQ = fnSendRFQ;
        vm.fnChangeOdcOwc = fnChangeOdcOwc;
        vm.fnStuffingEnable = fnStuffingEnable;
        vm.objInitialize = objInitialize;
        vm.getAirlineList = getAirlineList;
        vm.inquirySuccessErrorModal = inquirySuccessErrorModal;
        vm.selectFile = selectFile;
        vm.setFile = setFile;
        vm.closeDialog = closeDialog;
        vm.fnInquiryDone = fnInquiryDone;
        vm.fnGoToInquiry = fnGoToInquiry;
        vm.fnCollapseContent =  fnCollapseContent;
        vm.cancelDialog = cancelDialog;
        vm.getUserProfile = getUserProfile;
        vm.trackEvent=trackEvent;
        vm.showChargePanel=false;

        vm.IMCO_CodeList = util.imcoCodeList();
        vm.isWebView = util.isWebView();
        vm.currencyList = [];
        vm.startDateStart = new Date();
        vm.getSubvendor = [];
        vm.advanceContainerType = [];
        vm.salesPersonList = [];
        vm.msdsfile = {
            'name' : ''
        };
        vm.otherDocument = {
            'name' : ''
        };
        vm.loadSalesPersonList = loadSalesPersonList;

        // decimal points handling
        vm.setThreeNumberDecimal = SearchService.setThreeNumberDecimal;

        this.$onInit = function() {
         
            vm.mode = vm.rfqdata.search_param.mode;
            vm.rfqObj = angular.copy(vm.rfqdata.rfqObj);
            vm.validationObj={
            "reasonValidation":false,
             "imcoValidationError":false,
             "sailingDateValidation":false,
            "msdsValidationError":false,
            "targetValidation":false 
            }
            vm.salesPersoneFromSearch =  angular.copy(vm.rfqObj.sales_user);
            vm.rfqObj.better_rate = vm.rfqdata.isBetterRates;
            vm.getSubVendorList();
            if(vm.mode == 'SEA-FCL'){
                vm.fnStuffingEnable();
                vm.fnGetLoadList();
            }
            else{
                vm.rfqObj.target_load_data.load_meta["target_rate"] = "";
                vm.rfqObj.target_load_data.load_meta["target_rate_currency"] = (vm.mode == 'AIR') ? vm.util.userProfile.user.user_base_currency : "USD";
                vm.rfqObj.target_load_data.load_meta["target_rate_basis"] = (vm.mode == 'AIR') ? "per_KGs" : 'per_W/M';
            }
            vm.initSelected = true;
            vm.getUserProfile();
            if(vm.rfqObj.hazardous_material){
                vm.rfqObj.req_cargo_type_data={"name":"Hazardous","code":"HAZARDOUS"};
            }
        };

        vm.objInitialize();
        vm.getCurrencyList();

        function objInitialize(){
            vm.rfq_customer = {
                "email": null,
                "user_mobile": null,
                "user_first_name": null,
                "user_last_name": null,
                "id" : null
            };

            vm.rfq_customer_company = {
                "company_name": null,
                "id": null
            };

            vm.loadObj = {
                'type': '',
                'count': 1,
                'bl_qty': 1,
                'sbl_qty': 1,
                'max_weight': '',
                'max_volume': '',
                'target_rate' : '',
                'target_rate_currency' : 'USD'
            };
        }
        
        function getCurrencyList(){
            if(!util.currencyList.length){
                util.getCurrencyList().then(function(response){
                  vm.currencyList = util.currencyList;
                },function(error){
                    vm.currencyList = [];
                    $log.log(error);
                });
            }else{
                vm.currencyList = util.currencyList;
            }
        }

        function getSubVendorList(searchText){
            if(!searchText && (util.carrierData.mode == vm.mode && util.carrierData.data.length)){
                vm.getSubvendor = angular.copy(util.carrierData.data);
              }else{
                var type = vm.mode == 'AIR' ? 'airline' : 'subvendor';
                var queryData = searchText ? searchText : '';
                vm.filterLoader = true;
                  resultService.getLinersData(type,queryData).then(function(response){
                    vm.getSubvendor = response.data.data;
                    if(!searchText){
                        util.carrierData.mode = vm.mode;
                        util.carrierData.data = angular.copy(response.data.data);
                    }
                    vm.filterLoader = false;
                  },function(error){
                    vm.getSubvendor = [];
                    vm.filterLoader = false;
                  });
              }
        }

        function getAirlineList(){
            if(!util.getAirline.length){
                resultService.getAirlineData().then(function(response){
                    vm.getAirline = response.data.data;
                    util.getAirline = angular.copy(vm.getAirline);
                },function(error){
                    vm.getAirline = [];
                    util.getAirline = [];
                });
            }else{
                vm.getAirline = angular.copy(util.getAirline);
            }
        }

        function fnGetLoadList(){
            if(!util.limitObj || util.limitObj.length <= 0){
                SearchService.getAllLoadList().then(function(response){
                    vm.container_type = response ? angular.copy(response) : [];
                    util.limitObj = response ?response : [];
                    vm.fnOpenAdvancedSearch();
                },function(error){
                    vm.container_type = [];
                    $log.log(error.data);
                });
            }else{
                vm.container_type = angular.copy(util.limitObj);
                vm.fnOpenAdvancedSearch();
            }
        }

        function getUserProfile(){
            if(!util.userProfile.user){
                util.getProfile().then(function(){
                    vm.rfqObj.rfq_raised_by = util.userProfile.user.is_sales_cordinator ? 'SALES_COORDINATOR' : (!util.isShipper ? 'SALES_USER' : 'SHIPPER_USER' );
                    vm.getSalesPersonList();
                },function(error){
                    $log.log(error.data);
                });
            }else{
                vm.rfqObj.rfq_raised_by = util.userProfile.user.is_sales_cordinator ? 'SALES_COORDINATOR' : (!util.isShipper ? 'SALES_USER' : 'SHIPPER_USER' );
                vm.getSalesPersonList();
            }
        }

        function getSalesPersonList(){
            if(!util.salesPersonList || !util.salesPersonList.length){
                vm.loadSalesPersonList('','init');
            }else{
                vm.salesPersonList = util.salesPersonList;
                if(vm.rfqObj.sales_user){
                    var results = vm.salesPersonList.find(function(item){
                        return  ( vm.rfqObj.sales_user.id === item.id );
                    });
                    vm.fnchangeSalesPerson(results,"init");
                }
            }
        }

        function loadSalesPersonList(searchText,init){
            vm.isSalesApiLoading = true;
            return resultService.getSalesPersonList(util.userProfile.user.id,searchText).then(function (response) {
                vm.salesPersonsCount = response.data.count;
                vm.salesPersonList = angular.copy(response.data.data);
                if(vm.rfqObj.sales_user){
                    var user = vm.salesPersonList.find(function(element) {
                    return (element.id == vm.rfqObj.sales_user.id );
                    });
                    if(!user){
                        vm.salesPersonList.push(vm.rfqObj.sales_user);
                    }
                    var results = vm.salesPersonList.find(function(item){
                        return  ( vm.rfqObj.sales_user.id === item.id );
                    });
                    vm.fnchangeSalesPerson(results,"init");
                }
                if(init){
                  util.salesPersonList = vm.salesPersonList;
                }
                vm.isSalesApiLoading = false;

              }, function (error) {
                vm.isSalesApiLoading = false;
                vm.salesPersonList = [];
                vm.salesPersonsCount = 0;
                $log.log(error.data);
            });
        }

        function fnchangeSalesPerson(person,type){
            vm.salesInitial = person.user_first_name.charAt(0);
            vm.rfqObj.sales_user = person;
            // vm.wlsGetCustomerList();

            vm.salesPersonType = (util.userProfile.user && util.userProfile.user.is_sales_cordinator) ? 'SALES_COORDINATOR' : (!util.isShipper ? 'SALES_USER' : 'SHIPPER_USER');

            if (vm.salesPersonType === 'SALES_USER' && vm.selectList && vm.selectList.length) {
              return true;
            }

            if (type !== 'init') {
              vm.rfqObj.shipper_user = null;
              vm.selectListShow = true;
              vm.getShipperCompany();
            }

        }

        function loadFilter(e) {
            var found = false;
            vm.advanceContainerType.some(function(i){
              if(i.type === e.load_code) {
                found = true;
                return true;
              }
            });

            if(found) {
              return false;
            } else {
              return true;
            }
        }

        function removeLoad(index) {
            if(vm.advanceContainerType.length === 1){
              return;
            }
            vm.advanceContainerType.splice(index, 1);
        }

        function addNewLoad() {
            vm.advanceContainerType.push(angular.copy(vm.loadObj));
        }

        function fnOpenAdvancedSearch() {
            vm.advanceContainerType = [];

            angular.forEach(vm.rfqObj.target_load_data.load_details_value,function(value){
                vm.container_type.find(function (item) {
                    if(item.load_code === value.type){
                        item["count"] = value.qty;
                        item["type"] = item.load_code;
                        item["bl_qty"] = value.bl_qty;
                        item["sbl_qty"] = value.sbl_qty;
                        item["target_rate"] = "";
                        item["target_rate_currency"] = "USD";
                        item["weight_qty"] = value.load_metrics[0].weight_qty;
                        item["weight_unit"] = value.load_metrics[0].weight_unit;
                    }
                });
            });

            vm.load_bl_qty = vm.rfqObj.target_load_data.load_details_value[0].bl_qty;
            vm.load_sbl_qty = vm.rfqObj.target_load_data.load_details_value[0].sbl_qty;

            vm.container_type.forEach(function(i){
                if(i.count){
                    vm.advanceContainerType.push(i);
                }
            });

            if(!vm.advanceContainerType.length) {
                vm.advanceContainerType = [
                    {
                    'type': '20GP',
                    'count': 0,
                    'bl_qty': 1,
                    'sbl_qty': 1,
                    'show': true,
                    'max_weight' : '',
                    'max_volume' : '',
                    'target_rate' : '',
                    'target_rate_currency' : 'USD',
                    'weight_qty' : 0,
                    'weight_unit' : 'Tons'
                    }
                ];
            }
        }


        function changeEmailText() {
            vm.customerEmailValidationError = false;
            vm.customerEmailValidationError = false;
            vm.customerNameValidationError = false;
            vm.customerPhoneValidationError = false;
            vm.customerCompanyValidationError = false;
            vm.readOnly = false;
        }

        function changeCompany(selected) {
            if (selected != null) {
              vm.rfq_customer_company.id = selected.id;
              vm.rfq_customer_company.company_name = selected.company_name;
            }
            else if (selected == null) {
              vm.rfq_customer_company.id = null;
            }
        }

        function getShipperCompany(searchText) {
          vm.selectList = [];
          var url = api.baseUrl + '/api/get-shippers?limit=30&offset=0&salesperson_id='+ vm.rfqObj.sales_user.id;

          if(searchText){

            url += '&email=' + searchText;
          }

          return SearchService.getShipperList(url).then(function (response) {
            vm.selectListShow = false;
            vm.selectList = response.data.data;
            return vm.selectList;
          }, function (error) {
            vm.selectListShow = false;
            $log.log(error.data);
            return [];
          });
        }

        // callRFQapi renamed to fnSendRFQ due to pickup and delivery hide
        function fnSendRFQ(rfqForm){
           var mixpanelValidtionObj = {
               Reason : '',
               TargetRate : '',
               SailingDate : '',
               ImcoType : '',
               Msds : ''
           }
            if(!vm.rfqObj.reason_for_revising){
                vm.validationObj.reasonValidation=true;
                mixpanelValidtionObj.Reason = "required";
            }
            if(vm.mode !== 'SEA-FCL' && !vm.rfqObj.target_load_data.load_meta.target_rate){
                vm.validationObj.targetValidation=true;
                mixpanelValidtionObj.TargetRate="required";
            }
            if(!vm.rfqObj.preferred_sailing_date){
                vm.validationObj.sailingDateValidation=true;
                mixpanelValidtionObj.SailingDate="required"
            }
            if(vm.rfqObj.hazardous_material) {
                if(!vm.rfqObj.imco_code){
                    vm.validationObj.imcoValidationError = true;
                    mixpanelValidtionObj.ImcoType="required"
                }
                if(vm.msdsfile == null || vm.msdsfile.name == ""  ){
                    vm.validationObj.msdsValidationError = true;
                    mixpanelValidtionObj.Msds="required"
                }
            }

            if( vm.validationObj.reasonValidation ||  vm.validationObj.imcoValidationError ||  vm.validationObj.msdsValidationError || vm.validationObj.targetValidation|| vm.validationObj.sailingDateValidation || rfqForm.$invalid ){
                return
            }
          if(rfqForm && rfqForm.shipperName && rfqForm.shipperName.$invalid){
            return;
          }
            vm.rfqBtn = false;
            var blockCode = false;
            vm.advanceContainerType.some(function(i, k) {
                if(!SearchService.loadValidation(vm.advanceContainerType[k])){
                    blockCode = true;
                    return true;
                }
            });

            if(blockCode === true){
                return;
            }

            // hazardous imco_code validation
            // if(vm.rfqObj.hazardous_material) {
            //     if(!vm.rfqObj.imco_code){
            //         vm.imcoValidationError = true;
            //         return true;
            //     }
            //     if(vm.msdsfile == null || vm.msdsfile.name == ""  ){
            //         vm.msdsValidationError = true;
            //         return true;
            //     }
            // }

            //sale cordinator validation
            if(!util.isShipper && (vm.rfqObj.sales_user == "" || vm.rfqObj.sales_user == null)){
                vm.salesPersonValidationError = true;
                document.querySelector('#sale_person').focus();
                return true;
            }
            //Date validation
            vm.rfqObj.preferred_sailing_date=moment(vm.rfqObj.preferred_sailing_date).format('YYYY-MM-DD') ;
            // Reason validation
            // if(vm.rfqObj.better_rate && (vm.rfqObj.reason_for_revising == "" || vm.rfqObj.reason_for_revising == null)){
            //     // $('#wls-request-for-quote').scrollTop($('#wls-request-for-quote')[0].scrollHeight);
            //     vm.reasonValidationError = true;
            //     document.querySelector('#reason').focus();
            //     vm.reasonValidationMsg = 'Please type reason.';
            //     return true;
            // }

            if(vm.mode == 'SEA-FCL'){
                vm.rfqObj.target_load_data.load_details_value = [];
                angular.forEach(vm.advanceContainerType, function(value,key){
                    value.count = value.qty ? value.qty : value.count;
                    if(value.count  > 0){
                        var temp_qty = angular.copy(value.weight_qty);
                        var load_obj = {
                            'qty': value.count,
                            'bl_qty': vm.load_bl_qty,
                            'sbl_qty': vm.load_sbl_qty,
                            'type': value.type,
                            'teu':value.teu,
                            'load_metrics': Array(value.count).fill({
                                'weight_qty': temp_qty ? temp_qty : 28,
                                'weight_unit': temp_qty ? value.weight_unit : 'Tons',
                                'volume_qty': 0,
                                'volume_unit': 'CBM'
                            }),
                            'target_rate' : value.target_rate,
                            'target_rate_currency' : value.target_rate_currency
                        };
                        vm.rfqObj.target_load_data.load_details_value.push(load_obj);
                    }
                });
            }

            vm.rfqObj.req_commodity_data = vm.shareQuoteService.commodityString(vm.rfqObj.req_commodity_data);
            vm.rfqObj.user = vm.rfqdata.search_param.user;
            vm.rfqObj.insurance.is_selected = vm.rfqObj.insurance.value_of_goods ? 1 : 0;


            var rfq_temp = angular.copy(vm.rfqObj);
            rfq_temp.insurance.is_selected = rfq_temp.insurance.is_selected ? 1 : 0;

            if(!rfq_temp.insurance.is_selected){
                rfq_temp.insurance.value_of_goods = null;
                rfq_temp.insurance.currency = null;
            }

            if(!rfq_temp.hazardous_material){
                rfq_temp.imco_code = null;
            }

            if(vm.mode == 'SEA-FCL' && rfq_temp.carrier_preference.length){
                angular.forEach(rfq_temp.carrier_preference,function(value,key){
                delete value["$$mdSelectId"];
                delete value["id"];
                });
            }

            if(vm.mode == 'AIR' && rfq_temp.airline_preference.length){
                angular.forEach(rfq_temp.airline_preference,function(value,key){
                delete value["$$mdSelectId"];
                delete value["id"];
                });
            }

            rfq_temp.insurance.value_of_goods = parseFloat(rfq_temp.insurance.value_of_goods);
            // rfq_temp.pickup.pickup_location =  $sanitize(rfq_temp.pickup.pickup_location);
            // rfq_temp.delivery.delivery_location = $sanitize(rfq_temp.delivery.delivery_location);
            rfq_temp.demurrage_detention = rfq_temp.demurrage_detention || 0;
            // rfq_temp.commodities = $sanitize(rfq_temp.commodities);
            rfq_temp.files = [];

            if( vm.msdsfile != null && vm.msdsfile.name != "" ){
                rfq_temp.files.push(
                    {
                    "ref_name": "MSDS",
                    "url": vm.msdsfile.url,
                    "file_name": vm.msdsfile.name
                    }
                );
            }
            if( vm.otherDocument != null && vm.otherDocument.name != "" ){
                rfq_temp.files.push(
                    {
                    "ref_name": "other",
                    "url": vm.otherDocument.url,
                    "file_name": vm.otherDocument.name
                    }
                );
            }

            var finalData = {
                "data" : rfq_temp
            };

            vm.rfqBtn = true;
            util.isCallingApi = true;
            resultService.fnSendRFQData(vm.rfqdata.id,finalData).then(function(response){
                // vm.rfqBtn = false;
                util.isCallingApi = false;
                vm.inquirySuccessErrorModal('success', response.data);
                vm.mixpanelSearchParam = vm.mode=='SEA-FCL' ? SearchService.getFclLoadDetails(vm.rfqdata.search_param.load_data.load_details_value) : vm.rfqdata.search_param.load_data.load_meta.chargeable_weight + ' Kgs';
                resultService.trackMixPanelForInquiry(vm.rfqObj,vm.rfqdata.search_param,(vm.rfqObj.better_rate ? 'Better Rates' : 'RFQ'),'NA',vm.mixpanelSearchParam);
            },function(error){
                $log.error(error);
                vm.rfqBtn = false;
                util.isCallingApi = false;
                vm.inquirySuccessErrorModal('error',error);
            });

        }

        function inquirySuccessErrorModal(action,data, ev){

            vm.inquiryValue = data.data;

            vm.inquryDone = (action == 'success') ? true : false;

            $mdDialog.show({
                templateUrl: 'app/main/search/views/inquiry-modals/inquiry-modal.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm },
                onRemoving: vm.cancelEdit
            });
        }

        function fnGoToInquiry(id){
            $mdDialog.hide().then(function() {
                util.showToast(util.displayValidationError('Redirecting to inquiry page.'));
                if(util.isShipper){
                    $state.go('app.inquiry');
                }else{
                    $state.go('app.inquiry.inquiryDetails',{ id: id });
                }
            });
        }

        function closeDialog(){
            $mdDialog.hide();
        }

        function fnInquiryDone(){
            $mdDialog.hide().then(function() {
                util.showToast(util.displayValidationError('Redirecting to search page.'));
                $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
            });
        }

        function selectFile(action) {
            if(action == 'msds'){

                document.getElementById('fileInput_msds').click();

                // angular.element(document.querySelector('#fileInput_msds')).click();
            }else{
                document.getElementById('fileInput_all').click();
                // angular.element(document.querySelector('#fileInput_all')).click();
            }
        };

        function setFile(file, action){
            if(action == 'msds'){
                vm.msdsfile = file;
                vm.msdsProgress = true;
            }else{
                vm.otherDocument = file;
                vm.otherProgress = true;
            }

            if(file != null){
                vm.rfqBtn = true;
                var form = new FormData();
                form.append("upload", file);

                resultService.fnSendRfqFile(vm.rfqdata.id,form).then(function(response){
                    vm.rfqBtn = false;
                    response = JSON.parse(response);
                    if(action == 'msds'){
                        vm.msdsfile["url"] = response.url;
                    }else{
                        vm.otherDocument["url"] = response.url;
                    }
                    vm.msdsProgress = false;
                    vm.otherProgress = false;
                    $scope.$apply();
                },function(error){
                    $log.error(error);
                    vm.msdsProgress = false;
                    vm.otherProgress = false;
                    vm.rfqBtn = false;
                });
            }else{
                vm.msdsProgress = false;
                vm.otherProgress = false;
            }
        }

        function fnChangeOdcOwc(value){
            if(value == false){
                vm.rfqObj.odc_owc_details.cargo_length = "";
                vm.rfqObj.odc_owc_details.cargo_width = "";
                vm.rfqObj.odc_owc_details.cargo_height = "";
                vm.rfqObj.odc_owc_details.volume_unit = "CMS";
                vm.rfqObj.odc_owc_details.weight = "";
                vm.rfqObj.odc_owc_details.weight_unit = "KGs";
            }
        }

        function fnStuffingEnable(){
            if(vm.rfqObj.origin_charges || vm.rfqObj.origin_customs){
                vm.stuffingDisable = false;
            }else{
                vm.stuffingDisable = true;
                vm.rfqObj.stuffing = vm.rfqdata.search_param.stuffing;
            }
        }

        function fnCollapseContent(content_id){
            var id = '#' + content_id;
            angular.element(id).slideToggle();
        }

        function cancelDialog(){
            $mdDialog.hide();
        }
        function makeDetailBoxString() {
            vm.detailBoxString = ((vm.rfqObj.origin_charges ? 'Origin, ' : '') + (vm.rfqObj.origin_customs ? 'Origin Custom, ' : '') +(vm.rfqObj.destination_charges ? 'Destination, ' : '') + (vm.rfqObj.destination_customs ? 'Destination Custom, ' : '') ) || 'Select Charges';
      
            vm.rfqObj.detailBoxTooltip = ((vm.rfqObj.origin_charges ? 'Origin\n' : '') + (vm.rfqObj.origin_customs ? 'Origin Custom\n' : '')+(vm.rfqObj.destination_charges ? 'Destination\n' : '') + (vm.rfqObj.destination_customs ? 'Destination Custom\n' : '') ) || 'Select Charges';
      
            vm.rfqObj.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;
      
          }
          $rootScope.$on("$mdMenuClose", function() {
            vm.makeDetailBoxString();
          });

        function trackEvent(type,value){
            if(value){
                analytics.track(type,{
                    "Mode":vm.mode,
                    "Value":value
                });
            }
            else{
                analytics.track(type,{
                    "Mode":vm.mode
                });
            }
           
        }

}

})();



    //     // company name validation
    //     if( !util.isShipper && (vm.rfq_customer_company.company_name == null || vm.rfq_customer_company.company_name == "") ){
    //         vm.customerCompanyValidationError = true;
    //         vm.customerCompanyValidationMsg = 'Customer company name is required.';
    //         vm.cust_open = true;
    //         angular.element('#rfq_br_cust').slideDown();
    //         setTimeout(function(){
    //           angular.element( document.querySelector( '#customer_company_id' ) ).focus();
    //         },500);
    //         return true;
    //     }

    //     if(vm.rfq_customer_company.company_name && !vm.selectedCompany){
    //         vm.customerCompanyValidationError = true;
    //         vm.customerCompanyValidationMsg = 'Please select an existing company.';
    //         vm.cust_open = true;
    //         angular.element('#rfq_br_cust').slideDown();
    //         setTimeout(function(){
    //           angular.element( document.querySelector( '#customer_company_id' ) ).focus();
    //         },500);
    //         return true;
    //     }

    //     if (!util.isShipper && (vm.rfq_customer.email == null || vm.rfq_customer.email == "")) {
    //         vm.customerEmailValidationError = true;
    //         vm.customerEmailValidationMsg = 'Please enter valid email address.';
    //         vm.cust_open = true;
    //         angular.element('#rfq_br_cust').slideDown();
    //         setTimeout(function(){
    //           angular.element( document.querySelector( '#customer_email_id' ) ).focus();
    //         },500);
    //         return true;
    //     }else if( !util.isShipper && vm.rfq_customer.email && !emailPattern.test(String(vm.rfq_customer.email).toLowerCase())){
    //         vm.customerEmailValidationError = true;
    //         vm.customerEmailValidationMsg = 'Please enter valid email address.';
    //         vm.cust_open = true;
    //         angular.element('#rfq_br_cust').slideDown();
    //         setTimeout(function(){
    //           angular.element( document.querySelector( '#customer_email_id' ) ).focus();
    //         },500);
    //         return true;
    //     }

    //     if(vm.rfq_customer.email && !vm.selectedEmail){
    //         vm.customerEmailValidationError = true;
    //         vm.customerEmailValidationMsg = 'Please select an existing email.';
    //         vm.cust_open = true;
    //         angular.element('#rfq_br_cust').slideDown();
    //         setTimeout(function(){
    //           angular.element( document.querySelector( '#customer_email_id' ) ).focus();
    //         },500);
    //         return;
    //     }

    //     //phone number validation
    //     if (!util.isShipper && (vm.rfq_customer.user_mobile == null || vm.rfq_customer.user_mobile == "") && !vm.readOnly ) {
    //         vm.customerPhoneValidationError = true;
    //         vm.customerPhoneValidationMsg = 'Please Enter Valid mobile number.';
    //         vm.cust_open = true;
    //         angular.element('#rfq_br_cust').slideDown();
    //         setTimeout(function(){
    //           angular.element( document.querySelector( '#customer_email_id' ) ).focus();
    //         },500);
    //         return true;
    //     }else if( !util.isShipper && vm.rfq_customer.user_mobile && !PhonePattern.test(String(vm.rfq_customer.user_mobile)) && !vm.readOnly ){
    //         vm.customerPhoneValidationError = true;
    //         vm.customerPhoneValidationMsg = 'Please Enter Valid mobile number.';
    //         vm.cust_open = true;
    //         angular.element('#rfq_br_cust').slideDown();
    //         setTimeout(function(){
    //           angular.element( document.querySelector( '#customer_email_id' ) ).focus();
    //         },500);
    //         return true;
    //     }else if( !util.isShipper && vm.rfq_customer.user_mobile && !PhonePattern.test(String(vm.rfq_customer.user_mobile)) && !vm.readOnly ){
    //       vm.customerPhoneValidationError = true;
    //       document.querySelector('#customer_phone_id').focus();
    //       vm.customerPhoneValidationMsg = 'Please Enter Valid mobile number.';
    //       vm.cust_open = true;
    //       angular.element('#rfq_br_cust').slideDown();
    //       return true;
    //     }
    // }

    // insurance validation
    // if(vm.rfqObj.insurance.value_of_goods > 500000){
    //     vm.insuranceValidationMsg = 'Value of goods is too high';
    //     vm.insuranceValidationError = true;
        // if(util.solution_type === 'WLS'){
        //     document.querySelector('#rfq_ins').focus();
        //     vm.shpmnt_open = true;
        //     angular.element('#rfq_br_shipment').slideDown();
        // }
    //     return true;
    // }



    // if(!util.isShipper){
    //     vm.rfqObj.shipper_user = {
    //         "company" : {}
    //     };
    //     var countryData = $('.tel-input')[0] ? window.intlTelInputGlobals.getInstance($('.tel-input')[0]).getSelectedCountryData() : null;
    //     vm.rfqObj.shipper_user["email"] = $sanitize(vm.rfq_customer.email);
    //     vm.rfqObj.shipper_user["user_mobile"] = vm.rfq_customer.user_mobile && countryData ? $sanitize(vm.rfq_customer.user_mobile.replace('+' + countryData.dialCode, '').replace(/\s/g,'').replace('-', '')): null;
    //     vm.rfqObj.shipper_user["user_mobile_code"] = vm.rfq_customer.user_mobile && countryData ? countryData.dialCode : null;
    //     vm.rfqObj.shipper_user["user_mobile_country"] = vm.rfq_customer.user_mobile && countryData ? countryData.iso2.toUpperCase() : null;
    //     vm.rfqObj.shipper_user["user_first_name"] = $sanitize(vm.rfq_customer.user_first_name);
    //     vm.rfqObj.shipper_user["user_last_name"] = $sanitize(vm.rfq_customer.user_last_name);
    //     vm.rfqObj.shipper_user["user_address"] = vm.rfq_customer.user_address;
    //     vm.rfqObj.shipper_user["id"] = vm.rfq_customer.id ? vm.rfq_customer.id : null;
    //     vm.rfqObj.shipper_user["company"]["company_name"] = $sanitize(vm.rfq_customer_company.company_name);
    //     vm.rfqObj.shipper_user["company"]["id"] = vm.rfq_customer_company.id ? vm.rfq_customer_company.id : null;
    // }else{
    //     vm.rfqObj.shipper_user = null;
    // }

    // if(!util.userProfile.user.is_sales_cordinator && util.userProfile.user.is_pricing_user){
    //     vm.rfqObj.sales_user = vm.rfqdata.search_param.user;
    // }
    // else if(!util.userProfile.user.is_sales_cordinator){
    //     vm.rfqObj.sales_user = null;
    // }


    // inco term validation
    // if(util.solution_type === 'WLS' && (vm.rfqObj.inco_term == "" || vm.rfqObj.inco_term == null)){
    //     vm.incoTermValidationError = true;
    //     document.querySelector('#inco_term').focus();
    //     return true;
    // }

    // if(util.solution_type == 'WLS' ){

    //     var emailPattern = /^(([^<>()\[\]\.,;:\s@\”]+(\.[^<>()\[\]\.,;:\s@\”]+)*)|(\”.+\”))@(([^<>()[\]\.,;:\s@\”]+\.)+[^<>()[\]\.,;:\s@\”]{2,})$/i;
    //     var PhonePattern = /^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[789]\d{9}|(\d[ -]?){10}\d$/;


    // get customer list for wls
    // vm.wlsGetCustomerList = wlsGetCustomerList;
    // function wlsGetCustomerList(){
    //     vm.selectList = [];
    //     vm.selectListShow = true;
    //     var url = api.baseUrl + '/api/get-shippers?salesperson_id=' +vm.rfqObj.sales_user.id;
    //     SearchService.getShipperList(url).then(function (response) {
    //         vm.selectListShow = false;
    //         vm.selectList = response.data.data;
    //         vm.rfq_customer.email = null;
    //         vm.rfq_customer_company.id = null;
    //         vm.rfq_customer_company.company_name = null;

    //         if(vm.rfqObj.shipper_user && vm.rfqObj.shipper_user.email && vm.initSelected){
    //             vm.selectedEmail = vm.rfqObj.shipper_user.email;
    //             vm.selectedCompany = vm.rfqObj.shipper_user.company.company_name;
    //             vm.selectedToChange(vm.rfqObj.shipper_user);

    //         }else if(vm.rfqObj.shipper_user && vm.rfqObj.shipper_user.company && vm.initSelected){
    //             vm.selectedCompany = vm.rfqObj.shipper_user.company.company_name;
    //             vm.selectedToChange(vm.rfqObj.shipper_user.company,'company');

    //         }else{
    //             vm.selectedToChange(null);
    //             vm.selectedEmail = null;
    //             vm.selectedCompany = null;
    //         }
    //         vm.initSelected = false;
    //     }, function (error) {
    //         $log.log(error.data);
    //     });
    // }

    // vm.selectedToChange = selectedToChange;
    // function selectedToChange(selected,input_type) {
    //     vm.customerEmailValidationError = false;
    //     vm.customerNameValidationError = false;
    //     vm.customerPhoneValidationError = false;
    //     vm.customerCompanyValidationError = false;

    //     if (selected != null) {

    //         if(input_type == 'company'){
    //           SearchService.wlsFilterCustomerDetails('' , 'company_user', vm.selectList, vm.rfq_customer_company );
    //             if(selected.company){
    //                 vm.rfq_customer_company.id = selected.company.id;
    //                 vm.rfq_customer_company.company_name = selected.company.company_name;
    //             }else{
    //                 vm.rfq_customer_company.id = selected.id;
    //                 vm.rfq_customer_company.company_name = selected.company_name;
    //             }
    //         }
    //         else{
    //             vm.rfq_customer.id = selected.id;
    //             vm.rfq_customer.email = selected.email;
    //             vm.rfq_customer.user_first_name = selected.user_first_name;
    //             vm.rfq_customer.user_last_name = selected.user_last_name;
    //             vm.rfq_customer.user_mobile = selected.user_mobile ? intlTelInputUtils.formatNumber('+' + selected.user_mobile_code + selected.user_mobile, null, intlTelInputUtils.numberFormat.INTERNATIONAL) : null;
    //             vm.rfq_customer.user_address = selected.user_address;
    //             vm.rfq_customer_company.id = selected.company.id;
    //             vm.rfq_customer_company.company_name = selected.company.company_name;

    //         }
    //       vm.readOnly = true;

    //     }
    //     else if (selected == null) {
    //       vm.rfq_customer.id = null;
    //       vm.rfq_customer.user_first_name = null;
    //       vm.rfq_customer.user_last_name = null;
    //       vm.rfq_customer.user_mobile = null;
    //       vm.rfq_customer.user_address = null;
    //       if(input_type == 'company'){
    //         vm.rfq_customer.email = null;
    //       }
    //       vm.readOnly = false;
    //     }
    // }

      // vm.filterStringList = filterStringList;
    // function filterStringList(userInput) {
    //   var results;

    //   if(!!vm.rfq_customer_company.company_name){
    //       results  = SearchService.wlsFilterCustomerDetails(userInput, 'company_user', vm.selectList, vm.rfq_customer_company);
    //   }else{
    //       results  = SearchService.wlsFilterCustomerDetails(userInput, '', vm.selectList, vm.rfq_customer_company);
    //   }

    //   var  deferred = $q.defer();
    //   $timeout(function () { deferred.resolve( results ); },  200, false);
    //   return deferred.promise;
    // }

    // vm.fnHideRequestForm = fnHideRequestForm;
    // function fnHideRequestForm(){
    //     vm.rfqObj.sales_user = null;
    //     vm.callback({action : 'closeRfq'});
    // }

(function ()
{
    'use strict';

    angular
        .module('app.result')
        .controller('PollingResultController', PollingResultController);

    /** @ngInject */
    function PollingResultController(util, iframeService, $timeout,$transitions, $state, $rootScope,SearchService,$stateParams , shareQuoteService , resultService , $mdDialog,analytics) {

        // data
        var vm = this;
        vm.todaysDate = Date.now();
        vm.iframeService = iframeService;
        vm.searchService=SearchService
        // method
        vm.init = init;
        vm.formIframeUrl = formIframeUrl;
        vm.fnGenerateQuote = fnGenerateQuote ;
        vm.fnGetTnCData = fnGetTnCData;
        vm.fnDefaultQuotation = fnDefaultQuotation;
        vm.fnStandardQuotation = fnStandardQuotation;
        vm.createBooking = createBooking;
        vm.fnRfqConfirmation = fnRfqConfirmation;
        vm.getIframeRequest = getIframeRequest;
        vm.util=util;
        vm.l3_leg = 'l3_fcl';
        vm.leg_mode = null;
        vm.result_id = null;
        vm.redirectToQuote  = redirectToQuote;
        vm.resizeScreenSize = resizeScreenSize;
        
        // if god user changed forwarder refresh data
        $rootScope.$on('app.search'+vm.searchService.searchMode.state, function (event, args) {
          vm.init();
        });

        // Listen to state change start event
        $transitions.onStart({}, function() {
            window.removeEventListener("message", getNewRatesObj, true);
        });
    
        function init() { 
          vm.minHeight = vm.iframeService.iframeHeight;
          if(util.isEfpEnabled){
            $state.go('app.pages_share_error');
         }
          vm.formIframeUrl(); // Get Iframe src url
          document.getElementById("inner-content").style.maxWidth = "100%";
          document.getElementById("inner-content").style.padding = "0";
          vm.fnGetTnCData();
          vm.resizeScreenSize();
          $rootScope.loadingDetails = false;
          if(window.addEventListener) {
            window.addEventListener("message", getNewRatesObj, true);        
          } 
          else if (window.attachEvent) {
            window.attachEvent("onmessage", getNewRatesObj, true);
          }
        }
        vm.init();
        function getIframeRequest(event){
          if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'polling'){
            var targetOrigin = (new URL(vm.iframeUrl)).origin;
              if(event.origin === targetOrigin){
          document.getElementById('polling-result-iframe').contentWindow.postMessage({ navPermission: util.navPermission,dataSource:'polling'},targetOrigin);
              }}
      }
        // get add-rates iframe url
        function formIframeUrl() {
          var ftlResultIframe = document.getElementById('polling-result-iframe');
          vm.iframeUrl = iframeService.fnGetIframeUrl('rates/'+vm.searchService.searchMode.mode+'/'+$stateParams.id,'','web');
          vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&searchId=" + $stateParams.id);
          vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&reqAccessPollingData=1&parentUrl="+ window.location.origin);
          ftlResultIframe.src = vm.iframeUrl
          
          util.isCallingApi = true;
          ftlResultIframe.onload = function() {
            $timeout(function () {
              util.isCallingApi = false;
            });
          };
        }

        function getNewRatesObj(event){
          var statePage = '';
          //standard-quotation should not run redirect navigation 
          if(!event.data.source || event.data.source  === 'standard-quotation'){
            return;
          }
          if (event.target === window && !event.data.source === 'polling' && !event.data.source === 'fcl-result') {
              window.removeEventListener("message", getNewRatesObj, true);
          }
          if(event.origin.indexOf(vm.util.iframeOrigin)){
          switch (event.data.source) {
            case "fcl-result":
              statePage = "app.search.fclV2Rates";
              break;

            case "generate-quotation":
              vm.fnGenerateQuote(event);
              return;

            case "create-booking":
              vm.createBooking(event);
              return;

            case "add-to-quote":
              vm.redirectToQuote(event);
              return;

            case "RFQ":
              vm.fnRfqConfirmation(event);
              return;
            case "polling":
              vm.getIframeRequest(event);
              return;
            case "one-quote":
              vm.util.redirectToOneQuote(event);
              return;
            case 'inquiry':
              $state.go('app.inquiry.inquiryDetails',{ id: event.data.inquiry_id });
            return; 
            case "basket-iframe":
              $state.go("app.basketModule")
              return;
            default:
              statePage = "searchV2Module";
          }
    
          $state.go(statePage,{ id: event.data.resultId });
         }
         }


        function fnGenerateQuote(event){
            vm.fclLoadData = SearchService.getFclLoadDetails(event.data.search_param.load_data.load_details_value);
            var origin_custom_selected = event.data.search_param.origin_customs || false;
            var destination_custom_selected = event.data.search_param.destination_customs || false;
            var quoteDetails = shareQuoteService.fnInitializeQuoteDetails(origin_custom_selected,destination_custom_selected );
            quoteDetails.terms = vm.termsAndConditions;
            quoteDetails.incoterms = (event.data.search_param.inco_term) ? event.data.search_param.inco_term : null;
            quoteDetails.impo_expo = (event.data.search_param.impo_expo) ? event.data.search_param.impo_expo : null;
            quoteDetails.hazardous = event.data.search_param.hazardous_material;
            quoteDetails.all_in_quote_setting = 'default';
            quoteDetails.generate_quote_type = event.data.quote_type ;
            quoteDetails.termsAndConditions = vm.termsAndConditions;
            quoteDetails.stdTermsAndConditions = vm.stdTermsAndConditions;
            if(event.data.quote_type == 'standard'){
              vm.fnStandardQuotation(quoteDetails , event.data)
            }else{
              vm.fnDefaultQuotation(quoteDetails , event.data)

            }
          // return;
        }

        function fnStandardQuotation(quoteDetails , parentData){
          vm.l3_leg = (parentData.search_param.mode == 'SEA-FCL' ? 'l3_fcl' : parentData.search_param.mode == 'SEA-LCL' ? 'l3_lcl' : 'l3_air');
          var data= {
            "source":'result',
            "cards": parentData.selected_card,
            "currency_conversion_rates": parentData.currency_conversion_rates,
            "search_param": parentData.search_param,
            "search_id": parentData.result_id,
            "start_date": quoteDetails.start_date,
            "expiry_date": util.dateReplace(shareQuoteService.fnValidateExpiryDate(parentData.selected_card,parentData.search_param.cargo_ready_date, vm.l3_leg)),
            "customs": quoteDetails.customs,
            "perishable": quoteDetails.perishable,
            "cc_emails" : quoteDetails.cc_emails,
            "hazardous": quoteDetails.hazardous,
            "send_mail": quoteDetails.send_mail,
            "co2e" : quoteDetails.co2e,
            "generate_pdf": quoteDetails.generate_pdf,
            "print_schedule" : quoteDetails.print_schedule,
            "show_zero_sell_rates" : quoteDetails.show_zero_sell_rates,
            "carrier_mask_for_shipper": $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER && $rootScope.domainData.domain_info.MASKING_CHECK_BOX.checked_state,
            "incoterms": parentData.search_param.incoterms ? parentData.search_param.incoterms : null,
            "pdf_preferred_language": "en",
            "impo_expo": parentData.search_param.impo_expo ? parentData.search_param.impo_expo : null,
            "terms": vm.termsAndConditions,
            "all_in_quote_setting": 'default',
            "is_duplicate_quote": false,
            "parent_quote_id": null,
            "generate_quote_type": parentData.quote_type,
            "number_formats":$rootScope.number_format,
            "activity" : [
              {
              "message": 'Quotation Created' ,
              "type": "quote_created",
              "timestamp": new Date(),
              "user_id": util.userProfile.user.id,
              "user_name": util.userProfile.user.user_first_name + ' '+ util.userProfile.user.user_last_name,
              "activity_data": {}
              }
            ],
            "additional_charges" : {
                "selected" : vm.vas_details ? vm.vas_details.legList : [],
                "available" : vm.vas_details ? vm.vas_details.value_added_charges : []
            }
        }
        util.standardQuotationData = data;
        $state.go('app.standardQuotation');

        }

        function fnDefaultQuotation(quoteDetails , parentData){

          vm.shareQuoteObj = {
            'quoteDetails' : quoteDetails,
            'termsAndConditions' : vm.termsAndConditions,
            'stdTermsAndConditions' : vm.stdTermsAndConditions,
            'selectedCard' : parentData.selected_card,
            'search_param' : parentData.search_param,
            'generateQuoteBtn' : false,
            'currency_conversion_rates' : parentData.currency_conversion_rates,
            'fclLoadData' : vm.fclLoadData,
            'result_id' : parentData.result_id,
            'vas_details' : vm.vasDetails,
            'sales_user' : parentData.search_param.sales_user,
            'shipper_user' : parentData.search_param.shipper_user,
            'quoteFrom': 'Search',
            'exchangeRateId': parentData.result_id
          }

            //mixpanel code
            var generateQuote = {
              "Mode":parentData.search_param.mode,
              "Search Name":parentData.search_param.search_name,
              "Port-Pair":parentData.search_param.origin_location.location + ' to ' + parentData.search_param.destination_location.location,
              "No. of rate card":parentData.selected_card.length
            };

          $mdDialog.show({
            template : '<md-dialog id="share-quotation" class="dialobox" ng-cloak><md-dialog-content class="p-0"><share-quotation sharequoteobj="ctrl.parent.shareQuoteObj"></share-quotation></md-dialog-content></md-dialog>',
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function () { this.parent = vm },
            onRemoving: function (event, removePromise) {
              for(var name in CKEDITOR.instances)
              {
                  CKEDITOR.instances[name].destroy()
                  window.addEventListener("message", getNewRatesObj, true);   
              } 
            }
          });

        } 

        function fnGetTnCData(){
          if(util.isAdmin || util.isFreightbro){
        
            resultService.getTermsConditions('fcl','true').then(function(response){
                vm.stdTermsAndConditions = util.decodeValue(response.data.terms);
            },function(error){
                vm.stdTermsAndConditions = "";
            });
    
              resultService.getTermsConditions('fcl','false').then(function(response){
                  vm.termsAndConditions = util.decodeValue(response.data.terms);
              },function(error){
                  vm.termsAndConditions = "";
              });
        }
        }

        function  createBooking(event){
          vm.util.isCallingApi = true;
          vm.result_id = event.data.result_id;
          // if( (!util.navPermission.shipments || !util.navPermission.shipments[0]) || (!event.data.selected_card.meta.selected_schedule && ( !event.data.selected_card.meta.isScheduleCall )) ){
          //     return true;
          // }
          event.data.selected_card.meta.conversionRate = event.data.currency_conversion_rates
          vm.requestToBook(event.data.selected_card,event.data.search_param);
        }

        vm.requestToBook = requestToBook;
        function requestToBook(currCard,search_param) {
          vm.booked_leg_type = [];
          var count = 1;
          if (currCard.data.buy_rates.l3_fcl.rate_obj.is_special && currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment != null) {
    
            for (var j in currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment) {
              for (var i = 0; i < search_param.load_data.load_details_value.length; i++) {
                if (search_param.load_data.load_details_value[i].type == j && search_param.load_data.load_details_value[i].qty > currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment[j]) {
                  util.showToast("Max quantity allowed for " + j + " is " + currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment[j]);
                  count = 0;
                  break;
                }
              }
              if (count === 0) {
                break;
              }
            }
    
            if (count === 0) {
              return;
            }
          }
    
          angular.forEach(currCard.data.sell_rates, function (value) {
            if (value.rate_obj) {
              vm.booked_leg_type.push(value.leg_code);
            }
          });
    
          var cards = angular.copy(currCard);
          cards.meta["card_total_cost"] = resultService.calCardTotal(cards.data.sell_rates);
          delete cards.meta['buy_leg_total'];
    
          var booking_data = {
            "search_param": angular.copy(search_param),
            "card_item": angular.copy(cards),
            "id": vm.result_id,
            "booked_leg_type": angular.copy(vm.booked_leg_type),
            "buyOrSell": 'sell_rates',
            "user": search_param.user,
            "page": "search",
            "create_for" : util.userProfile.user,
            "shipper" : util.isShipper ? util.userProfile.user : (search_param.shipper_user ? search_param.shipper_user : null), //DEV-3744
            "send_mail" : search_param.shipper_user ? true : false,
            "cardIndex":0,
            "all_in_quote_setting" : util.all_in_quote
          }
    
          resultService.requestToBookData = booking_data;
          //mixpanel code
          analytics.track("Book Now",{
            "Mode":search_param.mode,
            "Search Name":search_param.search_name,
            "Port-Pair":search_param.origin_location.location + ' to ' + search_param.destination_location.location,
           // "Card Details":cards
          });
    
          $timeout(function(){
            vm.util.isCallingApi = false;
            if (util.isSharedQuote()) {
              $state.go('app.resultSharedBookShipment');
            } else {
              $state.go('app.resultBookShipment', { mode: 'fcl' });
            }
          }, 200)
        }

        function fnRfqConfirmation(event){
          if(event.data.redirectTo == 'search'){
            util.showToast(util.displayValidationError('Redirecting to search page.'));
                $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');

          }else{
            util.showToast(util.displayValidationError('Redirecting to inquiry page.'));
            if(util.isShipper){
              $state.go('app.inquiry');
            }else{
                $state.go('app.inquiry.inquiryDetails',{ id: event.data.id });
            }
          }
        }

        function redirectToQuote(event){
          var selectedCards = angular.copy(event.data.selected_card)
          if(selectedCards && selectedCards.length){
            resultService.refreshQuoteData.selectedCards = angular.copy(selectedCards);
          }
          var searcParam = angular.copy(event.data.search_param);
          resultService.refreshQuoteData.from_quote_search_param = searcParam;
          resultService.refreshQuoteData.quote_id = searcParam.quote_id;
          resultService.refreshQuoteData.quote_number = searcParam.quote_number;
          if(searcParam.source=='quote'){
            $state.go("app.quotes.quotesDetails", {
              id: searcParam.quote_id,
            });
          }else if(searcParam.source=='copy_quote'){
            $state.go('app.CopyQuoteDetailsController',{ id: searcParam.quote_id});
          }else if(searcParam.source=='create_quote'){
            $state.go("app.CreateQuotesController",
            { 
              mode: searcParam.mode,
              id: searcParam.quote_id
            });
          }
          
        }

        function resizeScreenSize() {
          $timeout(function () {
            var windowHeight = document.getElementById("content-container").offsetHeight + 7;   
            vm.minHeight = iframeService.calculateMaxHeight(windowHeight); 
          },800);
        }


        window.onresize = vm.resizeScreenSize;
    
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.book', ['material.components.expansionPanels'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
    // $stateProvider
    //     .state('app.book.bookShipment', {
    //         url  : '/book-shipment-fcl',
    //         views: {
    //             'content@app': {
    //                 templateUrl: 'app/main/result/bookShipment/bookShipmentFcl.html',
    //                 controller : 'bookShipmentFclController as vm'
    //             },
    //             data : { pageTitle: 'Book Shipment' }
    //         },
    //         resolve : {
    //         }
    //     })

    }

})();

(function () {
  'use strict';

  angular
    .module('app.book')
    .controller('bookShipmentFclController', bookShipmentFclController);

  /** @ngInject */
  function bookShipmentFclController(localStorageService, analytics, $scope, $anchorScroll, $location, $filter, $window, $log, $state, $mdDialog, BookingData, resultService, QuotesService, util, ShipmentService, SearchService, $rootScope, $rootElement, appCache, $timeout, shareQuoteService,SettingService) {

    var vm = this;
    vm.util = util;
    vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER);
    // vm.showContractId=$rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES;
    vm.isCommodity = $rootScope.domainData.domain_info.QUOTE_POPUP_SETTING ? $rootScope.domainData.domain_info.QUOTE_POPUP_SETTING.SHOW_COMMODITY : false;
    vm.QuotesService = QuotesService;
    vm.shareQuoteService = shareQuoteService;
    vm.isShared = util.isSharedQuote();
    if (BookingData != undefined && Object.keys(BookingData).length) {
      vm.booking_data = angular.copy(BookingData);
    } else {
      util.showToast('Data not available redirecting to result page');
      $state.go('app.search');
      return;
    }

    vm.domainType = vm.isShared ? ( vm.booking_data.create_for.solution_type ? vm.booking_data.create_for.solution_type :'NWLS' ) : util.solution_type;
    vm.booking_data["comments"] = null;

    vm.partyView = {
      "shipper": false,
      "consignee": false,
      "consignor": false,
      "notifyParty": false,
      "cha": false,
      "shippers":false
    };
    vm.shipper = {};
    vm.consignee = {};
    vm.consignor = {};
    vm.notifyParty = {};
    vm.shippersData = {};

    // Methods
    vm.formLoadDetails = formLoadDetails;
    vm.scrollToHash = scrollToHash;
    vm.formContainerType = formContainerType;
    vm.confirmBooking = confirmBooking;
    vm.bookResponseData = {};
    vm.goBack = goBack;
    vm.duplicateLoad = duplicateLoad;
    vm.confirm_btn = false;
    vm.isObjectEmpty = isObjectEmpty;
    vm.fnOpenConfirmDeleteModal = fnOpenConfirmDeleteModal;
    vm.fnDeleteData = fnDeleteData;
    vm.cancelDialog = cancelDialog;
    vm.fnOpenNewPartyModal = fnOpenNewPartyModal;
    vm.fnSaveParty = fnSaveParty;
    vm.parties = [];
    vm.ifCategoryAdd = ifCategoryAdd;
    vm.getImcoCodeText = getImcoCodeText;
    vm.loadbtndisplay=false;
    vm.saveBtnDisplay=false;
    vm.fnChangeQty = fnChangeQty;
    vm.fnSaveLoadQty= fnSaveLoadQty;
    vm.resetLoad = resetLoad;
    vm.fnUpdateInsuranceLeg = fnUpdateInsuranceLeg;
    vm.isString = isString;
    vm.fnCheckIsNaN = fnCheckIsNaN;
    vm.collapseIt = collapseIt;
    vm.applyCoupon = applyCoupon;
    vm.cleanInput = cleanInput;
    vm.toggleChargeList = toggleChargeList;
    vm.checkInsurance = checkInsurance;
    vm.getConvenienceLegIndex = getConvenienceLegIndex;
    vm.resetCoupon = resetCoupon;
    vm.restPartyObj = restPartyObj;
    vm.codeMessage = '';
    vm.showLoad = false;
    vm.showSpotLoader = false;
    vm.convenienceIndex = null;
    vm.couponResponse = null;
    vm.couponData = {
      'prevLegCurrencyCost': null,
      'legTotalCost': null,
      'legCurrencyCost': null,
      'chargeCost': null,
      'customerCurrencyCost': null,
      'cardTotalAmount': null
    }
    vm.IMCO_CodeList = util.imcoCodeList();
    vm.callConvenienceFeeApi = callConvenienceFeeApi;
    vm.calculateCouponAmounts = calculateCouponAmounts;
    vm.revertSavedData = revertSavedData;
    vm.fnDeleteNewPartyModal=fnDeleteNewPartyModal;

    vm.tempLoad = angular.copy(vm.booking_data.search_param.load_data.load_details_value);
    vm.mainFreightName = 'Main Freight';
    vm.bookingDoorPortArray = [];
    vm.hideToaster = hideToaster;
    vm.fnDisplayPenalty = fnDisplayPenalty;
    vm.getDisplayPortName=getDisplayPortName;
    vm.formConvenienceFeeLeg = formConvenienceFeeLeg;

    vm.searchPartyData = null;
    vm.getCompanyList = ShipmentService.getCompanyList;
    vm.setPartyDetails = setPartyDetails;
    vm.canCreateNewCompany = ShipmentService.canCreateNewCompany;
    vm.partyTypes = ShipmentService.partyTypes;
    vm.onCompanyTextChange = onCompanyTextChange;
    vm.fnLclLoadDetails = fnLclLoadDetails;
    vm.fnNotificationToggle = fnNotificationToggle;
    vm.fnFCLLoadValue = fnFCLLoadValue;
    vm.fnSetLegCode = fnSetLegCode;
    vm.fnSetShipperDetails = fnSetShipperDetails;
    vm.showExchangeRates = $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;
    vm.resultType = '';
    vm.setCommodity = setCommodity;
    vm.fnGetLoadList = fnGetLoadList;
    vm.trackEvent=trackEvent;
    vm.measurementSystem = $rootScope.metric_system;
    vm.mixPanelEvent = mixPanelEvent;
    vm.partyMixpanel = partyMixpanel;
    vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
    vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
    vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';
    vm.getCountries = getCountries;
    vm.countrySelected = countrySelected ;
    vm.fnStoreStateList = fnStoreStateList;
    vm.cargoTypeChange = cargoTypeChange;
    vm.showShippersInParties = $rootScope.domainData && $rootScope.domainData.domain_info.ALLOW_SHIPPER_PARTY_IN_BOOKING_PAGE ;

    vm.addReference = addReference;
    vm.removeReference = removeReference;
    vm.updateReference = updateReference;
    vm.initializeAddresses = initializeAddresses;

    function init() {
      // Currency conversion setting code
      shareQuoteService.currencyConverter = {}; //Reset currency converter setting
      shareQuoteService.setCurrencyConvSetting(vm.booking_data.user.user_base_currency,vm.booking_data.card_item.meta.conversionRate.markup,vm.booking_data.card_item.meta.conversionRate.directCurrencyMapping,vm.booking_data.card_item.meta.conversionRate.curr_data);

      vm.fnSetLegCode(); // set leg code name
      vm.setCommodity(); // set commodity details
      vm.fnGetLoadList();  // load container list for fcl
      vm.getDisplayPortName(); // origin and destination display text
      vm.resultType = resultService.getResultType(); // get result type for viewExchangeRate
      vm.booking_data.card_item.meta['card_total_cost'] = resultService.calCardTotal(vm.booking_data.card_item.data[vm.booking_data.buyOrSell], vm.domainType);
      var cardRates = resultService.getBookingRates(vm.booking_data.card_item, vm.booking_data.buyOrSell);
      vm.bookingRates = cardRates.rates_obj;
      vm.rate_id = cardRates.rate_ids;
      vm.bookingL3_rates = $filter('filter')(vm.bookingRates,{'leg_code' : vm.l3_leg }, true);
      if(vm.booking_data.search_param.mode == 'AIR') {
        vm.booking_data.search_param.load_data.load_meta.chargeable_weight = vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.is_higher_slab ? vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.slab : vm.booking_data.search_param.load_data.load_meta.chargeable_weight;
        vm.airLoadArray=vm.formContainerType(vm.booking_data.search_param.mode,vm.booking_data.search_param.load_data )
      }else if(vm.booking_data.search_param.mode == 'SEA-LCL'){
        vm.lclLoadArray = vm.fnLclLoadDetails(vm.booking_data.search_param.load_data );
      }

      // set insurance details
      if(vm.booking_data.search_param.shipment_insurance){
        vm.insurance_leg_cost = angular.copy(vm.booking_data.search_param.insurance_leg_cost);
        vm.insurance_currency = angular.copy(vm.booking_data.search_param.insurance_currency);
      }else{
        vm.insurance_leg_cost = null;
        vm.insurance_currency = 'USD';
      }

      if(vm.booking_data.search_param.mode == 'SEA-FCL' && vm.booking_data.card_item.meta.additional_charges){
        if(vm.booking_data.card_item.meta.additional_charges.data){
          vm.formConvenienceFeeLeg(vm.booking_data.card_item.meta.additional_charges);
        }else{
          if(vm.booking_data.card_item.meta.additional_charges.url && !vm.isShared){
            callConvenienceFeeApi();
          }
        }
      }

      vm.booking_data.search_param.origin_location = util.mapPortData(vm.booking_data.search_param.nearby_ports, vm.booking_data.search_param.origin_location, vm.booking_data.card_item.meta.port_data.origin_port_code);
      vm.booking_data.search_param.destination_location = util.mapPortData(vm.booking_data.search_param.nearby_ports_destination, vm.booking_data.search_param.destination_location, vm.booking_data.card_item.meta.port_data.destination_port_code);

      vm.bookingDoorPortArray = ShipmentService.fnBookingDoorPort(vm.booking_data.search_param, vm.booking_data.card_item.meta);

      if( vm.domainType === 'NWLS' ){
        vm.showRateToaster = SearchService.getRateToasterStatus();
      }

      // if shipper details available
      if(vm.booking_data.shipper){
        vm.fnSetShipperDetails();
      }

      // Remarks and inclusion code
      vm.remarks = vm.booking_data.card_item.meta.remarks;
      vm.inclusions = vm.booking_data.card_item.meta.inclusions;
      vm.checkRemarksIncl = false;
      if(util.isAdmin && (vm.remarks || vm.inclusions)) {
        vm.checkRemarksIncl = true;
      }

      // check vendor id for editable cargo input
      if(vm.booking_data.card_item) {
        if(vm.isShared){
         vm.isCargoTypeDisabled = !!( vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].vendor_id == vm.booking_data.user.company.vendor_id );
        }else{
        vm.isCargoTypeDisabled = vm.shareQuoteService.cargoInputDisabled(vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].vendor_id);
        }
      }
      else {
        vm.isCargoTypeDisabled = false;
      }
      vm.getCountries();
      vm.showContractId = vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.show_contract_number

      vm.initializeAddresses();

      if (!vm.booking_data.references) {
        vm.booking_data.references = [{
          reference_label: '',
          reference_value: '',
          comment: '',
          type: 'string',
          added_at: new Date().toISOString(),
          added_by: vm.booking_data.user && vm.booking_data.user.user_category ? vm.booking_data.user.user_category : 'FORWARDER',
          user_id: vm.booking_data.user && vm.booking_data.user.user_id ? vm.booking_data.user.user_id : ''
        }];
      }

    }
    init();

    function getDisplayPortName(){
        vm.displayPortName = {
          "origin" : "",
          "destination" : "",
          "originIcon" : "",
          "deliverIcon" : ""
        }

      //origin card meta binding value
      if(vm.booking_data.card_item.meta.port_data.pickup_location || vm.booking_data.card_item.meta.port_data.pickup_pincode_ui ) { //origin door
        vm.displayPortName.origin = [vm.booking_data.card_item.meta.port_data.pickup_location, vm.booking_data.card_item.meta.port_data.pickup_pincode_ui, vm.booking_data.card_item.meta.port_data.pickup_country_name];
      }else{ //origin port
        vm.displayPortName.origin = [vm.booking_data.card_item.meta.port_data.origin_port_code+'/'+vm.booking_data.card_item.meta.port_data.origin_portname, vm.booking_data.card_item.meta.port_data.origin_city, vm.booking_data.card_item.meta.port_data.origin_region];
      }
      vm.displayPortName.origin = util.filterArrayOfString(vm.displayPortName.origin); // final origin display string

      //origin icon
      // if (vm.booking_data.card_item.meta.port_data && (vm.booking_data.card_item.meta.port_data.pickup_location || vm.booking_data.card_item.meta.port_data.origin_portname || vm.booking_data.card_item.meta.port_data.pickup_pincode_ui)) {
      if(vm.booking_data.search_param.mode !=='AIR'){
        vm.displayPortName.originIcon = !(vm.booking_data.card_item.meta.port_data.pickup_location || vm.booking_data.card_item.meta.port_data.pickup_pincode_ui) ?
        !vm.booking_data.card_item.meta.port_data.is_icd_port_origin  ? 'assets/icons/custom/search-bar/port.svg' : 'assets/icons/custom/search-bar/icd.svg' :
        'assets/icons/custom/search-bar/door.svg';
      }else{
        vm.displayPortName.originIcon = 'assets/icons/custom/search-bar/air_pod.svg'
      }
      // }else {
      //   vm.displayPortName.originIcon= 'assets/icons/custom/search-bar/empty.svg'
      // }

      //destination card meta binding value
      if(vm.booking_data.card_item.meta.port_data.delivery_location || vm.booking_data.card_item.meta.port_data.delivery_pincode_ui) { //destination door
        vm.displayPortName.destination = [vm.booking_data.card_item.meta.port_data.delivery_location, vm.booking_data.card_item.meta.port_data.delivery_pincode_ui, vm.booking_data.card_item.meta.port_data.delivery_country_name];
      }else{ //destination port
        vm.displayPortName.destination = [vm.booking_data.card_item.meta.port_data.destination_port_code+'/'+vm.booking_data.card_item.meta.port_data.destination_portname, vm.booking_data.card_item.meta.port_data.destination_city, vm.booking_data.card_item.meta.port_data.destination_region];
      }
      vm.displayPortName.destination = util.filterArrayOfString(vm.displayPortName.destination); // final destination display string

      //destination icon
      // if  (vm.booking_data.card_item.meta.port_data && (vm.booking_data.card_item.meta.port_data.delivery_location || vm.booking_data.card_item.meta.port_data.destination_portname || vm.booking_data.card_item.meta.port_data.delivery_pincode_ui)) {
      if(vm.booking_data.search_param.mode !=='AIR'){
        vm.displayPortName.deliverIcon = !(vm.booking_data.card_item.meta.port_data.delivery_location || vm.booking_data.card_item.meta.port_data.delivery_pincode_ui) ?
        !vm.booking_data.card_item.meta.port_data.is_icd_port_destination ? 'assets/icons/custom/search-bar/port.svg' : 'assets/icons/custom/search-bar/icd.svg' :
        'assets/icons/custom/search-bar/door.svg';
      }
      else{
        vm.displayPortName.deliverIcon ='assets/icons/custom/search-bar/air_pol.svg'
      }
      // }else {
      //   vm.displayPortName.deliverIcon ='assets/icons/custom/search-bar/empty.svg'
      // }

    }




    // initialize commodity object
    function setCommodity(){
      vm.booking_data["commodity"] = {
        "name": null,
        "cargo_type": vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.cargo_type_data,
        "hazardous": false,
        "hs_code": vm.booking_data.search_param.hs_code,
        "imco_code": vm.booking_data.search_param.imco_code ? vm.booking_data.search_param.imco_code : 0,
        "commodity_data": []
      };
      if(vm.isCommodity && vm.booking_data.page !== "search"){
        vm.booking_data.commodity.commodity_data = vm.booking_data.card_item.meta.commodity_data ?  vm.booking_data.card_item.meta.commodity_data : [];
      }
      else{
        vm.booking_data.commodity.commodity_data = vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.commodity_data ? angular.copy(vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.commodity_data) : [];
      }
      vm.booking_data.commodity.hazardous = vm.booking_data.commodity.cargo_type && vm.booking_data.commodity.cargo_type.name && vm.booking_data.commodity.cargo_type.name.toLowerCase() == 'hazardous' ? true : false;
      if(util.isAdmin && vm.booking_data.commodity.cargo_type && vm.booking_data.commodity.cargo_type.code=='FAK' && !vm.booking_data.commodity.commodity_data.length){
        vm.booking_data.commodity.commodity_data.push('General');
      }
    }

    // get container list
    function fnGetLoadList(){
      if (vm.booking_data.search_param.mode != 'SEA-FCL') {
        return;
      }
        if(!util.limitObj.length){
          SearchService.getAllLoadList().then(function(response){
            util.limitObj = response;
            vm.fnFCLLoadValue();
          },function(error){
            $log.log(error);
            util.limitObj = [];
            vm.showLoad = true;
          });
        }else{
          vm.fnFCLLoadValue();
        }
    }

    // set fcl load value
    function fnFCLLoadValue(){
      vm.booking_data.search_param.load_data.load_details_value = angular.copy(util.addLoadMaxKey(vm.booking_data.search_param.load_data.load_details_value));

      for(var i=0; i < vm.booking_data.search_param.load_data.load_details_value.length; i++){
        vm.fnChangeQty(vm.booking_data.search_param.load_data.load_details_value[i]);
      }
      vm.checkLoad = false;
      vm.showLoad = true;
    }

    // set leg code
    function fnSetLegCode(){
      vm.l3_leg = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'l3_fcl' : ((vm.booking_data.search_param.mode == 'AIR') ? 'l3_air' : 'l3_lcl');

      vm.l1_leg = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'l1_fcl' : ((vm.booking_data.search_param.mode == 'AIR') ? 'l1_air' : 'l1_lcl');

      vm.l2_leg = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'l2_fcl' : ((vm.booking_data.search_param.mode == 'AIR') ? 'l2_air' : 'l2_lcl');

      vm.l2_leg_cha = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'l2_fcl_cha' : ((vm.booking_data.search_param.mode == 'AIR') ? 'l2_air_cha' : 'l2_lcl_cha');

      vm.l4_leg = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'l4_fcl' : ((vm.booking_data.search_param.mode == 'AIR') ? 'l4_air' : 'l4_lcl');

      vm.l4_leg_cha = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'l4_fcl_cha' : ((vm.booking_data.search_param.mode == 'AIR') ? 'l4_air_cha' : 'l4_lcl_cha');

      vm.l5_leg = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'l5_fcl' : ((vm.booking_data.search_param.mode == 'AIR') ? 'l5_air' : 'l5_lcl');

      vm.ins_leg = (vm.booking_data.search_param.mode == 'SEA-FCL') ? 'ins_fcl' : ((vm.booking_data.search_param.mode == 'AIR') ? 'ins_air' : 'ins_lcl');
    }

    // set shipper details on init
    function fnSetShipperDetails(){
      var shipperObj = {
        "name": vm.booking_data.shipper.user_first_name + ' ' + vm.booking_data.shipper.user_last_name,
        "category": "shipper",
        "company_name": vm.booking_data.shipper.company.company_name,
        "external_reference_id": vm.booking_data.shipper.company.external_reference_id,
        "email": vm.booking_data.shipper.email,
        "address": vm.booking_data.shipper.company.company_address,
        "contact": vm.booking_data.shipper.user_mobile,
        "country_code":  vm.booking_data.shipper.user_mobile_code,
        "iec_number":  vm.booking_data.shipper.company.iec_number,
        "point_of_contact" : vm.booking_data.shipper.company.point_of_contact,
        "send_notification" : vm.booking_data.send_mail,
        "country" : vm.booking_data.shipper.company.country,
        "state" : vm.booking_data.shipper.company.state,
        "city" : vm.booking_data.shipper.company.city,
        "postal_code" : vm.booking_data.shipper.company.postal_code
      };

      vm.shipper = shipperObj;
      vm.partyView.shipper = true;
      vm.parties.push(vm.shipper);
    }
      function fnDeleteNewPartyModal(party){
        angular.forEach(vm.parties,function(value,key){
          if(value.category == party){
            vm.parties.splice(key,1);
          }
        })
        if(party ==='shipper'){
          vm.shipper={};
          vm.partyView.shipper=false;
        }
        else if(party ==='notify_party'){
          vm.notifyParty={};
          vm.partyView.notifyParty=false;
        }
        else if(party ==='consignee'){
          vm.consignee={};
          vm.partyView.consignee=false;
        }
        else if(party ==='consignor'){
          vm.consignor={};
          vm.partyView.consignor=false;
        }else if(party ==='shippers'){
          vm.shippersData = {};
          vm.partyView.shippers = false;
        }
      }
    // Call convenience api on load change
    function callConvenienceFeeApi(){
      vm.showSpotLoader = true;
      var total_cost = resultService.calCardTotal(vm.booking_data.card_item.data[vm.booking_data.buyOrSell]);
      var load_type = resultService.formLoadStructure(vm.booking_data.search_param.load_data);

      var url = vm.booking_data.card_item.meta.additional_charges.url + "&total_cost=" + total_cost + "&id=" + vm.booking_data.id + "&currency=" + vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.leg_total_currency + "&load_type=" + load_type;

      return resultService.fnCallConvFeeApi(url).then(function (response) {
        vm.booking_data.card_item.meta.additional_charges.data = response.data.data;
        if(!BookingData.card_item.meta.additional_charges.data){
          BookingData.card_item.meta.additional_charges.data = angular.copy(response.data.data);
        }
        if(!!vm.booking_data.card_item.meta.additional_charges.data){
          vm.formConvenienceFeeLeg(vm.booking_data.card_item.meta.additional_charges);
        }
        vm.showSpotLoader = false;
      }, function (error) {
        vm.showSpotLoader = false;
          $log.log(error);
      });
    }

    // Form rates obj with conveniance fee
    function formConvenienceFeeLeg(additional_charges){
      vm.getConvenienceLegIndex();
      vm.convenienceIndex = vm.bookingRates.length;
      vm.bookingRates.push(additional_charges.data);

      vm.booking_data.card_item.data.sell_rates[additional_charges.data.leg_code] = additional_charges.data;
      vm.booking_data.card_item.data.buy_rates[additional_charges.data.leg_code] = additional_charges.data;
      vm.booking_data.card_item.meta['card_total_cost'] = resultService.calCardTotal(vm.booking_data.card_item.data[vm.booking_data.buyOrSell], vm.domainType);

      if(vm.couponResponse) {
        vm.calculateCouponAmounts(vm.couponResponse);
      }
    }

    function getConvenienceLegIndex() {
      vm.bookingRates.some(function (rate, rateIndex) {
        if (rate.leg_code === 'other_charges_fcl') {
          vm.convenienceIndex = rateIndex;
          return true;
        }
      });
    }

    function toggleChargeList(e, data) {
      angular.element(e.currentTarget).parent().parent().next().slideToggle();
      if(data.selected){
        data.selected = false;
      } else {
        data.selected = true;
      }
    }

    function resetCoupon() {

        vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost = vm.couponData.legCurrencyCost;
        vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost = vm.couponData.chargeCost;
        vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost = vm.couponData.customerCurrencyCost;
        vm.bookingRates[vm.convenienceIndex].leg_currency_cost = vm.couponData.prevLegCurrencyCost;
        vm.bookingRates[vm.convenienceIndex].leg_total_cost = vm.couponData.legTotalCost;
        vm.booking_data.card_item.meta['card_total_cost'] = vm.couponData.cardTotalAmount;

        vm.codeSuccess = null;
        vm.codeToSend = null;
        vm.appliedCode = false;

        vm.couponResponse = null;

        vm.couponData = {
          'prevLegCurrencyCost': null,
          'legTotalCost': null,
          'legCurrencyCost': null,
          'chargeCost': null,
          'customerCurrencyCost': null,
          'cardTotalAmount': null
        }
    }

    function cleanInput() {
      vm.codeMessage = '';
    }

    function applyCoupon(code) {

      if(!vm.codeToSend) {
        vm.codeMessage = "Enter code first!";
        vm.codeSuccess = false;
        return;
      }

      if(vm.appliedCode) {
        return;
      }

      // if (vm.booking_data.card_item.meta.type !== 'msr_spot' && vm.booking_data.card_item.meta.type !== 'network_spot') {
      //   vm.appliedCode = false;
      //   vm.codeMessage = 'Coupon code is not valid.';
      //   vm.codeSuccess = false;
      //   return;
      // }

      var data = {
        'data': {
          "coupon_code": code
        }
      }
      vm.appliedCode = true;
      resultService.applyCoupon(data).then(function(response) {
        vm.couponResponse = response.data.data;
        vm.codeSuccess = true;

        vm.appliedCode = false;

        vm.calculateCouponAmounts(response.data.data);
      },function(error){
          vm.appliedCode = false;
          vm.codeMessage = error.data.message;
          vm.codeSuccess = false;
          $log.log(error.data);
      });
    }

    function revertSavedData() {
      //leg stuff
      vm.bookingRates[vm.convenienceIndex].leg_currency_cost = vm.couponData.prevLegCurrencyCost;
      vm.bookingRates[vm.convenienceIndex].leg_total_cost = vm.couponData.legTotalCost;

      //charge stuff
      vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost = vm.couponData.legCurrencyCost;
      vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost = vm.couponData.chargeCost;
      vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost = vm.couponData.customerCurrencyCost;

      //total
      vm.booking_data.card_item.meta['card_total_cost'] = vm.couponData.cardTotalAmount;
    }

    function calculateCouponAmounts(payLoad) {

      //leg stuff
      vm.couponData.prevLegCurrencyCost = vm.bookingRates[vm.convenienceIndex].leg_currency_cost;
      vm.couponData.legTotalCost = vm.bookingRates[vm.convenienceIndex].leg_total_cost;

      //charge stuff
      vm.couponData.legCurrencyCost = vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost;
      vm.couponData.chargeCost = vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost;
      vm.couponData.customerCurrencyCost = vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost;

      //total
      vm.couponData.cardTotalAmount = vm.booking_data.card_item.meta['card_total_cost'];

      if (payLoad.type === 'flat') {
        if (payLoad.currency === vm.bookingRates[vm.convenienceIndex].charges[0].charge_currency) {
          vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost = vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost - parseInt(payLoad.amount);
        } else {
          // vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost - resultService.currencyConversion(payLoad.amount, vm.booking_data.card_item.meta.conversionRate[payLoad.currency], vm.booking_data.card_item.meta.conversionRate[vm.bookingRates[vm.convenienceIndex].charges[0].charge_currency]));
          vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost - shareQuoteService.currencyConverter.convert(parseFloat(payLoad.amount), payLoad.currency, vm.bookingRates[vm.convenienceIndex].charges[0].charge_currency));
        }

        if (payLoad.currency === vm.bookingRates[vm.convenienceIndex].leg_currency) {
          vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost = vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost - parseInt(payLoad.amount);
          vm.bookingRates[vm.convenienceIndex].leg_currency_cost = vm.bookingRates[vm.convenienceIndex].leg_currency_cost - parseInt(payLoad.amount);
        } else {
          // vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost - resultService.currencyConversion(payLoad.amount, vm.booking_data.card_item.meta.conversionRate[payLoad.currency], vm.booking_data.card_item.meta.conversionRate[vm.bookingRates[vm.convenienceIndex].leg_currency]));
          vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost - shareQuoteService.currencyConverter.convert(parseFloat(payLoad.amount), payLoad.currency, vm.bookingRates[vm.convenienceIndex].leg_currency));

          // vm.bookingRates[vm.convenienceIndex].leg_currency_cost = vm.bookingRates[vm.convenienceIndex].leg_currency_cost - resultService.currencyConversion(payLoad.amount, vm.booking_data.card_item.meta.conversionRate[payLoad.currency], vm.booking_data.card_item.meta.conversionRate[vm.bookingRates[vm.convenienceIndex].leg_currency]);

          vm.bookingRates[vm.convenienceIndex].leg_currency_cost = vm.bookingRates[vm.convenienceIndex].leg_currency_cost - shareQuoteService.currencyConverter.convert(parseFloat(payLoad.amount), payLoad.currency, vm.bookingRates[vm.convenienceIndex].leg_currency);
        }

        if (payLoad.currency === vm.bookingRates[vm.convenienceIndex].leg_total_currency) {
          vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost = vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost - parseInt(payLoad.amount);
          vm.bookingRates[vm.convenienceIndex].leg_total_cost = vm.bookingRates[vm.convenienceIndex].leg_total_cost - parseInt(payLoad.amount);
          vm.booking_data.card_item.meta['card_total_cost'] = vm.booking_data.card_item.meta['card_total_cost'] - parseInt(payLoad.amount);
        } else {
          // vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost - resultService.currencyConversion(payLoad.amount, vm.booking_data.card_item.meta.conversionRate[payLoad.currency], vm.booking_data.card_item.meta.conversionRate[vm.bookingRates[vm.convenienceIndex].leg_total_currency]));

          vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost - resultService.currencyConversion(payLoad.amount, payLoad.currency, vm.bookingRates[vm.convenienceIndex].leg_total_currency));


          // vm.bookingRates[vm.convenienceIndex].leg_total_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].leg_total_cost - resultService.currencyConversion(payLoad.amount, vm.booking_data.card_item.meta.conversionRate[payLoad.currency], vm.booking_data.card_item.meta.conversionRate[vm.bookingRates[vm.convenienceIndex].leg_total_currency]));

          vm.bookingRates[vm.convenienceIndex].leg_total_cost = Math.max(0, vm.bookingRates[vm.convenienceIndex].leg_total_cost - resultService.currencyConversion(payLoad.amount, payLoad.currency, vm.bookingRates[vm.convenienceIndex].leg_total_currency));

          // vm.booking_data.card_item.meta['card_total_cost'] = Math.max(0, vm.booking_data.card_item.meta['card_total_cost'] - resultService.currencyConversion(payLoad.amount, vm.booking_data.card_item.meta.conversionRate[payLoad.currency], vm.booking_data.card_item.meta.conversionRate[vm.bookingRates[vm.convenienceIndex].leg_total_currency]));
          vm.booking_data.card_item.meta['card_total_cost'] = Math.max(0, vm.booking_data.card_item.meta['card_total_cost'] - resultService.currencyConversion(payLoad.amount, payLoad.currency, vm.bookingRates[vm.convenienceIndex].leg_total_currency));
        }

      } else {
        vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost = vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost - (vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost * (parseInt(payLoad.amount) / 100));

        vm.bookingRates[vm.convenienceIndex].leg_currency_cost = vm.bookingRates[vm.convenienceIndex].leg_currency_cost - (vm.bookingRates[vm.convenienceIndex].leg_currency_cost * (parseInt(payLoad.amount) / 100));

        vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost = vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost - (vm.bookingRates[vm.convenienceIndex].charges[0].charge_cost * (parseInt(payLoad.amount) / 100));

        vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost = vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost - (vm.bookingRates[vm.convenienceIndex].charges[0].customer_currency_cost * (parseInt(payLoad.amount) / 100));

        vm.bookingRates[vm.convenienceIndex].leg_total_cost = vm.bookingRates[vm.convenienceIndex].leg_total_cost - (vm.bookingRates[vm.convenienceIndex].leg_total_cost * (parseInt(payLoad.amount) / 100));

        vm.booking_data.card_item.meta['card_total_cost'] = vm.booking_data.card_item.meta['card_total_cost'] - (vm.couponData.customerCurrencyCost * (parseInt(payLoad.amount) / 100));
      }
      vm.codeMessage = 'Coupon Code Applied! You saved ' + Math.round((vm.couponData.cardTotalAmount - vm.booking_data.card_item.meta['card_total_cost']) * 100) / 100 + ' ' + vm.booking_data.user.user_base_currency;
    }

    function collapseIt(e, type) {
      if(type === 'mobile') {
        angular.element('#edit-load-mobile').slideToggle();
        if(!vm.hideEditBtn){
          vm.hideEditBtn = true;
        } else {
          analytics.track("BookingDetails-EditCancel",{
            "Mode":vm.booking_data.search_param.mode
          });
          vm.hideEditBtn = false;
        }
      } else if(type==='commodity-mobile') {
        angular.element('#commodity-mobile').slideToggle();
        if(!vm.hideCommodityBtn){
          vm.hideCommodityBtn = true;
        } else {
          vm.hideCommodityBtn = false;
        }
      } else if(type==='parties-mobile') {
        angular.element('#parties-mobile').slideToggle();
        if(!vm.hidePartiesBtn){
          vm.hidePartiesBtn = true;
        } else {
          vm.hidePartiesBtn = false;
        }
      } else {
        angular.element('#edit-load').slideToggle();
        if(!vm.hideEditBtn){
          analytics.track("BookingDetails-EditLoadDetails",{
            "Mode":vm.booking_data.search_param.mode
          });
          vm.hideEditBtn = true;
        } else {
          analytics.track("BookingDetails-EditCancel",{
            "Mode":vm.booking_data.search_param.mode
          });
          vm.hideEditBtn = false;
        }
      }
    }

    function ifCategoryAdd() {
      vm.partyView.shipper = vm.parties.some(function (entry) {
        return entry.category.toLowerCase().trim() === "shipper";
      });
      vm.partyView.consignee = vm.parties.some(function (entry) {
        return entry.category.toLowerCase().trim() === "consignee";
      });
      vm.partyView.consignor = vm.parties.some(function (entry) {
        return entry.category.toLowerCase().trim() === "consignor";
      });
      vm.partyView.notifyParty = vm.parties.some(function (entry) {
        return entry.category.toLowerCase().trim() === "notify_party";
      });
      vm.partyView.shippers = vm.parties.some(function (entry) {
        return entry.category.toLowerCase().trim() === "shippers";
      });
    }

    //function to form load details
    function formContainerType(mode, load_data, page) {
      var convertedLoad = vm.util.metricSystemConversion(mode, load_data);
      var result=[]
      if (load_data != null) {
         result = [{
          "name" : "Gross Weight",
          "value" :(load_data.load_meta.gross_weight != null
            ? $filter("currencyMask")($filter("weightUnit")(load_data.load_meta.gross_weight, 'gross_weight',mode),2)
            : "N/A") +
          " " +
          (mode == "AIR" || (mode ==='SEA-LCL' && $rootScope.domainData.domain_info.WEIGHT_UNIT && $rootScope.domainData.domain_info.WEIGHT_UNIT[mode] && $rootScope.domainData.domain_info.WEIGHT_UNIT[mode].gross_weight.toLowerCase() == 'kg') ? 'KG' : 'MT') +
          (vm.measurementSystem != 'metric' ? ' / '+ $filter("currencyMask")(convertedLoad.gross_weight.value, 2) + " " + (convertedLoad.gross_weight.unit) : "")
        },{
          "name" : "Volumetric Weight",
          "value":(load_data.load_meta.volumetric_weight != null
            ? $filter("currencyMask")(load_data.load_meta.volumetric_weight, 2)
            : "N/A") +
          " " +
          (mode == "AIR" ? 'KG': 'CBM') +
          (vm.measurementSystem != 'metric' ? ' / '+ $filter("currencyMask")(convertedLoad.volumetric_weight.value, 2) + " " + (convertedLoad.volumetric_weight.unit) : "")
        }]
      }
      return result;
    }

    function fnLclLoadDetails(load_data){
      vm.convertedLoad = vm.util.metricSystemConversion(vm.booking_data.search_param.mode, load_data);
      var result = [
        {
          "name" : "Gross Weight",
          "value" : (load_data.load_meta.gross_weight != null) ?
          ($filter("currencyMask")($filter("weightUnit")(load_data.load_meta.gross_weight, 'gross_weight',vm.booking_data.search_param.mode),2)          +
            ' ' + (vm.booking_data.search_param.mode == 'SEA-LCL' ? (($rootScope.domainData.domain_info.WEIGHT_UNIT && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.booking_data.search_param.mode] && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.booking_data.search_param.mode].gross_weight.toLowerCase() == 'kg') ? 'KG' : 'MT'):(vm.util.grossWeightUnit[vm.booking_data.search_param.mode])) +
            (vm.measurementSystem != 'metric' ? ' / ' + $filter('currencyMask')(vm.convertedLoad.gross_weight.value, 2) +' '+ vm.convertedLoad.gross_weight.unit : '' ) ):
            'N/A'
        },
        {
          "name" : "Volumetric Weight",
          "value" : (load_data.load_meta.volumetric_weight != null) ?
          ($filter('currencyMask')(load_data.load_meta.volumetric_weight, 2) ) +
            ' ' + vm.util.volumetricWeightUnit[vm.booking_data.search_param.mode] +
            (vm.measurementSystem != 'metric' ? ' / ' + $filter('currencyMask')(vm.convertedLoad.volumetric_weight.value, 2) +' '+ vm.convertedLoad.volumetric_weight.unit : '' ) :
            'N/A'
        },
        {
          "name" : "LCL Chargeable Weight",
          "value" : ( load_data.load_meta.chargeable_weight != null) ?
          ($filter('currencyMask')(load_data.load_meta.chargeable_weight,2) ) +
            ' ' + vm.util.chargeableUnit[vm.booking_data.search_param.mode] :
            'N/A'
        },
        {
          "name" : "LTL Origin Dimensional Wt",
          "value" : "N/A"
        },
        {
          "name" : "LTL Origin Chargeable Weight",
          "value" : "N/A"
        },
        {
          "name" : "LTL Destination Dimensional Wt",
          "value" : "N/A"
        },
        {
          "name" : "LTL Destination Chargeable Weight",
          "value" : "N/A"
        }
    ];

      if(vm.booking_data.card_item.meta.ltl_load_details){
        if(vm.booking_data.card_item.meta.ltl_load_details.origin){
          // origin dimensional weight
          result[3].value = vm.booking_data.card_item.meta.ltl_load_details.origin.dimensional_weight ? $filter('currencyMask')(vm.booking_data.card_item.meta.ltl_load_details.origin.dimensional_weight, 2) + ' ' + vm.booking_data.card_item.meta.ltl_load_details.origin.dimensional_unit : 'N/A';
          // origin chargeable weight
          result[4].value = vm.booking_data.card_item.meta.ltl_load_details.origin.chargeable_weight ? $filter('currencyMask')(vm.booking_data.card_item.meta.ltl_load_details.origin.chargeable_weight, 2) + ' ' + vm.booking_data.card_item.meta.ltl_load_details.origin.chargeable_unit : 'N/A';
        }
        if(vm.booking_data.card_item.meta.ltl_load_details.destination){
          // destination dimensional weight
          result[5].value = vm.booking_data.card_item.meta.ltl_load_details.destination.dimensional_weight ? $filter('currencyMask')(vm.booking_data.card_item.meta.ltl_load_details.destination.dimensional_weight, 2) + ' ' + vm.booking_data.card_item.meta.ltl_load_details.destination.dimensional_unit : 'N/A';
          // destination chargeable weight
          result[6].value = vm.booking_data.card_item.meta.ltl_load_details.destination.chargeable_weight ? $filter('currencyMask')(vm.booking_data.card_item.meta.ltl_load_details.destination.chargeable_weight, 2) + ' ' + vm.booking_data.card_item.meta.ltl_load_details.destination.chargeable_unit : 'N/A'
        }
      }

      return result;
    }

    function duplicateLoad(load, index) {
      var matrixLoad = angular.copy(load);
      vm.booking_data.search_param.load_data.load_details_value[index].load_metrics.push(matrixLoad)
    }

    function fnOpenConfirmDeleteModal(parentIndex, childIndex, ev) {
      vm.loadContainerIndex = parentIndex;
      vm.matrixIndex = childIndex;

      $mdDialog.show({
        templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        controllerAs: 'ctrl',
        controller: function () {
          this.parent = vm
        }
      });
    }

    function fnDeleteData() {
      vm.booking_data.search_param.load_data.load_details_value[vm.loadContainerIndex].load_metrics.splice(vm.matrixIndex, 1);
      $mdDialog.hide();
    }

    //scrolling to hash
    function scrollToHash(id) {
      $anchorScroll.yOffset = 50; //I want it top drop 80px from id. You can remove this.
      $location.hash(id);
      $anchorScroll();
    }

    //function to load details
    function formLoadDetails(load_details) {
      return resultService.formLoadDetails(load_details);
    }

    function goBack() {
      $rootScope.loadingDetails = true;
      $window.history.back();
    }

    function isObjectEmpty(curr_schedule) {
      return util.isObjectEmpty(curr_schedule);
    }

    function cancelDialog(category,type,mode) {
      $mdDialog.hide();
    }

    function fnOpenNewPartyModal(action, category, ev) {
      vm.editParty = {};
      vm.partyBtn = false;
      vm.companyValidationError = false;
      vm.nameValidationError = false;
      vm.emailValidationError = false;
      vm.editPartyModalAction = action;

      if (vm.editPartyModalAction == 'Add') {
        vm.searchPartyData = null;
        vm.editParty = {
          "name": null,
          "category": category,
          "company_name": null,
          "email": null,
          "address": null,
          "contact": null,
          "country_code": null,
          "iec_number": null,
          "point_of_contact": null,
          "send_notification" : false,
          "city": null
        };
      } else {
        if(category == 'shipper'){
          vm.editParty = angular.copy(vm.shipper);
        }else if(category == 'consignee'){
          vm.editParty = angular.copy(vm.consignee);
        }else if(category == 'consignor'){
          vm.editParty = angular.copy(vm.consignor);
        }else if(category == 'notify_party'){
          vm.editParty = angular.copy(vm.notifyParty);
        }else if(category == 'shippers'){
          vm.editParty = angular.copy(vm.shippersData);
        }
        // vm.editParty.contact =  (vm.editParty.country_code ? '+' + vm.editParty.country_code : '') + vm.editParty.contact;
      }
      var eventName = vm.editPartyModalAction === "Add" ? 'AddDetails' : 'EditDetails';
      util.callMixpanel('BS-Parties-'+eventName+'-Click',{
        "mode":vm.booking_data.search_param.mode,
        "pagesource":vm.booking_data.page =='quote' ? 'Quotes': 'Instant Rates',
        "parties_category":category,
        "parties_type":vm.editPartyModalAction
      })

      if(vm.editParty.category == 'notify_party'){
        vm.partyTitle = vm.editPartyModalAction === 'Add' ? 'Select/Add Notify Party' : 'Notify Party';
      }else if(vm.editParty.category == 'shipper'){
        vm.partyTitle = vm.editPartyModalAction === 'Add' ? 'Select Customer' : 'Customer';
      }else if(vm.editParty.category == 'consignee'){
        vm.partyTitle = vm.editPartyModalAction === 'Add' ? 'Select Consignee' : 'Consignee';
      }else if(vm.editParty.category == 'consignor'){
        vm.partyTitle = vm.editPartyModalAction === 'Add' ? 'Select Consignor' : 'Consignor';
      }else if(vm.editParty.category == 'cha'){
        vm.partyTitle = vm.editPartyModalAction === 'Add' ? 'Select/Add CHA' : 'CHA';
      }else {
        vm.partyTitle = vm.editParty.category
      }
      vm.fnStoreStateList();
      $mdDialog.show({
        templateUrl: 'app/main/result/bookShipment/dialogs/party-modal.html',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: 'ctrl',
        controller: function () {
          this.parent = vm;
        }
      });
    }

    function partyMixpanel(id,category,type,mode){
      if(id === "notification"){
        // commented as per the ticket QMS-467
        // util.callMixpanel('BS-Parties-SendNofitication-Click',{
        //   "mode":mode,
        //   "parties_catagoery":category,
        //   "parties_type":type
        // })
      }
      else{
        util.callMixpanel('BS-Parties-'+id+'-Change',{
          "mode":mode,
          "parties_catagoery":category,
          "parties_type":type
        });
      }
    }

    function fnSaveParty(form) {
      if(!vm.editParty.company_name){
        vm.companyValidationError = true;
        //document.querySelector('#company_name').invalid();
        //return;
      }
      
      // Validate that restricted party types must select from dropdown (not manually typed)
      // Skip this validation for Edit mode when company_id exists (existing party)
      if(!vm.canCreateNewCompany(vm.editParty.category) && vm.editParty.company_name && !vm.searchPartyData && vm.editPartyModalAction === 'Add'){
        vm.companyValidationError = true;
        util.showToast('Please select an existing company from the dropdown. Manual entry is not allowed for ' + vm.editParty.category + '.');
        // Clear the manually typed company name
        vm.editParty.company_name = '';
        return;
      }
      
      if(!vm.editParty.name ){
        vm.nameValidationError = true;
        //document.querySelector('#customer_name').focus();
        //return;
      }
      if(!vm.editParty.email){
        vm.emailValidationError = true;
       // document.querySelector('#customer_email').focus();
        //return;
      }
      if(vm.nameValidationError || vm.companyValidationError || vm.emailValidationError){
        return;
      }


      if(form.$invalid){
        return;
      }

      vm.editParty.name = vm.editParty.name;
      vm.editParty.company_name = vm.editParty.company_name;

      vm.partyBtn = true;

      if(vm.editParty.category == 'shipper'){
        vm.shipper = angular.copy(vm.editParty);
      }else if(vm.editParty.category == 'consignee'){
        vm.consignee = angular.copy(vm.editParty);
      }else if(vm.editParty.category == 'consignor'){
        vm.consignor = angular.copy(vm.editParty);
      }else if(vm.editParty.category == 'notify_party'){
        vm.notifyParty = angular.copy(vm.editParty);
      }else if(vm.editParty.category == 'shippers'){
        vm.shippersData = angular.copy(vm.editParty);
      }

      if (vm.editPartyModalAction == 'Edit') {
        var matchObj = vm.parties.find(function (entry) {
          return entry.category.toLowerCase().trim() === vm.editParty.category;
        });

        var index = vm.parties.indexOf(matchObj);
        vm.parties[index] = vm.editParty;
        
        // Show success message for update
        util.showToast(vm.editParty.category.charAt(0).toUpperCase() + vm.editParty.category.slice(1) + ' details updated successfully');

      } else if (vm.editPartyModalAction == 'Add') {
        vm.parties.push(vm.editParty);
        vm.ifCategoryAdd();
        
        // Show success message for add
        util.showToast(vm.editParty.category.charAt(0).toUpperCase() + vm.editParty.category.slice(1) + ' details added successfully');
      }
      vm.partyBtn = false;
      $mdDialog.hide();

    }

    function fnNotificationToggle(partyData){
      var matchObj = vm.parties.find(function (entry) {
        return entry.category.toLowerCase().trim() === partyData.category;
      });

      var index = vm.parties.indexOf(matchObj);
      vm.parties[index] = partyData;
    }

    function getImcoCodeText(code) {
      if (code != 0) {
        var matchObj = vm.IMCO_CodeList.find(function (item) {
          return item.class_number == code;
        });
        return matchObj.class_name;
      } else {
        return "Select IMCO Code"
      }
    }

    function mixPanelEvent(eventName){
      util.callMixpanel(eventName,{
        "Mode":vm.booking_data.search_param.mode,
        "pageSource":vm.booking_data.page =='quote' ? 'Quotes': 'Instant Rates'
      })
    }

    function fnChangeQty(load){
      var temp_load = angular.copy(load);

      var matrixObj = {
        "max_volume_cbm": null,
        "max_volume_cft": null,
        "max_weight_kgs": null,
        "max_weight_ton": null,
        "volume_qty": 0,
        "volume_unit": "CBM",
        "weight_qty": 0,
        "weight_unit": "KGs",
      }

      load.load_metrics =  [];
      if(!load.qty){
        load.load_metrics.push(angular.copy(matrixObj));
      }
      else{
        for( var i = 0; i < load.qty; i++ ){
          load.load_metrics.push(angular.copy(matrixObj));
          if(temp_load.load_metrics[i]){
            load.load_metrics[i].weight_qty = temp_load.load_metrics[i].weight_qty;
            load.load_metrics[i].weight_unit = temp_load.load_metrics[i].weight_unit;
            load.load_metrics[i].volume_qty = temp_load.load_metrics[i].volume_qty;
            load.load_metrics[i].volume_unit = temp_load.load_metrics[i].volume_unit;
          }
          util.setLoadMaxValue(load, i, 'volume');
          util.setLoadMaxValue(load, i, 'weight');
        }
      }
      vm.checkLoad = true;
    }

    function fnSaveLoadQty(ev){
      if (vm.booking_data.search_param.mode == 'SEA-FCL') {
        for (var i = 0; i < vm.booking_data.search_param.load_data.load_details_value.length; i++) {

          if(vm.booking_data.search_param.load_data.load_details_value[i].qty <= 0){
            util.showToast('Please increase load QTY.');
            return true;
          }

          for (var j = 0; j < vm.booking_data.search_param.load_data.load_details_value[i].load_metrics.length; j++) {
            if (vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_qty == undefined) {
              util.showToast('Please add volume for ' + vm.booking_data.search_param.load_data.load_details_value[i].type);
              return true;
            } else if (vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_qty == undefined) {
              util.showToast('Please add weight for ' + vm.booking_data.search_param.load_data.load_details_value[i].type);
              return true;
            }

            if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_unit == 'CBM' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cbm != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cbm)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load volume should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cbm);
              return true;
            }else if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_unit == 'CFT' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cft != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cft)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load volume should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cft);
              return true;
            }else if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_unit == 'KGs' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_kgs != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_kgs)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load weight should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_kgs);
              return true;
            }else if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_unit == 'Tons' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_ton != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_ton)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load weight should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_ton);
              return true;
            }
          }
        }

        var loadData = angular.copy(vm.booking_data.search_param.load_data);

        var loadObj = {
          "data" : {
            "load" : {
              "load_type" : loadData.load_type,
              "load_details_value" : loadData.load_details_value
            },
            "card" : vm.booking_data.card_item,
            "mode": vm.booking_data.search_param.mode

          }
        }

        // if(vm.booking_data.page == 'search'){
        //   loadObj.data["search_id"] = vm.booking_data.id;
        //   loadObj.data["rate_ids"] = vm.rate_id;
        // }else{
        //   loadObj.data["quote_id"] = vm.booking_data.id;
        //   loadObj.data["card_id"] = vm.booking_data.card_item._id;
        // }
        util.isCallingApi = true;
        vm.loadBtn = true;
        resultService.fnBookingQty(loadObj).then(function (response) {
          vm.tempLoad = angular.copy(vm.booking_data.search_param.load_data.load_details_value);
          vm.booking_data.card_item = response.data.data;


          var cardRates = resultService.getBookingRates(vm.booking_data.card_item, vm.booking_data.buyOrSell);
          vm.bookingRates = cardRates.rates_obj;
          vm.rate_id = cardRates.rate_ids;

          vm.booking_data.card_item.meta['card_total_cost'] = resultService.calCardTotal(vm.booking_data.card_item.data[vm.booking_data.buyOrSell], vm.domainType);
          util.showToast('Load details updated successfully');
          util.isCallingApi = false;

          vm.loadBtn = false;
          vm.checkLoad = false;
          vm.saveBtnDisplay = true;
          vm.loadBtnDisplay = false;
          // calculate co2e
          if(vm.booking_data.card_item.meta.co2eData){
            var co2Response = {
              'data' : [vm.booking_data.card_item.meta.co2eData]
            }

            resultService.fnCalculateCo2Total(co2Response, vm.booking_data.search_param.load_data.load_details_value);
          }

          if (vm.booking_data.search_param.mode==='SEA-FCL' && vm.booking_data.card_item.meta.additional_charges.data) {
            vm.getConvenienceLegIndex();
            vm.bookingRates.splice(vm.convenienceIndex, 1);
            vm.callConvenienceFeeApi();
          }

        }, function (error) {
          util.isCallingApi = false;
          $log.log(error);
          vm.loadBtn = false;
          vm.errorLoad = angular.copy(vm.tempLoad);
          vm.checkLoad = false;
        });
      }
    }

    function resetLoad(){
      vm.booking_data.search_param.load_data.load_details_value = angular.copy(vm.tempLoad);
      vm.checkLoad = false;
    }

    function fnUpdateInsuranceLeg(){
      vm.insuranceValidationError = false;
      if(vm.booking_data.search_param.shipment_insurance) {
        if(!vm.insurance_leg_cost) {
          vm.insuranceValidationMsg = 'Please enter value of goods';
          document.querySelector('.insurance_value').focus();
          vm.insuranceValidationError = true;
          return;
        }else if(vm.insurance_leg_cost > 500000){
          vm.insuranceValidationMsg = 'Value of goods is too high';
          vm.insuranceValidationError = true;
          document.querySelector('.insurance_value').focus();
          return;
        }
      }

      var data = {
        "mode" : vm.booking_data.search_param.mode,
        "value" : vm.insurance_leg_cost,
        "curr" : vm.insurance_currency,
        "customer_currency" : vm.booking_data.user.user_base_currency
      };

      resultService.fnGetInsuranseLeg( data ).then(function (response) {
        if(vm.booking_data.card_item.data[vm.booking_data.buyOrSell][response.data.data.leg_code] == undefined){
          vm.booking_data.card_item.data[vm.booking_data.buyOrSell][response.data.data.leg_code] = {
            "leg_code": response.data.data.leg_code,
            "leg_name": response.data.data.leg_name,
            "rate_id": response.data.data._id,
            "rate_obj": response.data.data,
            "sub_vendor_id": response.data.data.sub_vendor_id,
            "vendor_id": response.data.data.vendor_id
          };
        }else{
          vm.booking_data.card_item.data[vm.booking_data.buyOrSell][response.data.data.leg_code].rate_obj = response.data.data;
        }

        var cardRates = resultService.getBookingRates(vm.booking_data.card_item, vm.booking_data.buyOrSell);
        vm.bookingRates = cardRates.rates_obj;

        vm.rate_id = cardRates.rate_ids;
        if (vm.booking_data.card_item.meta.type === 'msr_spot' || vm.booking_data.card_item.meta.type === 'network_spot') {
          vm.getConvenienceLegIndex();
        }
        if(vm.couponResponse) {
          vm.revertSavedData();
          vm.calculateCouponAmounts(vm.couponResponse);
        }

        vm.booking_data.card_item.meta['card_total_cost'] = resultService.calCardTotal(vm.booking_data.card_item.data[vm.booking_data.buyOrSell],vm.domainType);

      }, function (error) {
        $log.log(error);
      });
    }

    function checkInsurance() {
      if(vm.booking_data.search_param.shipment_insurance){
        vm.book_ins_web = true;
        vm.book_ins = true;
      }else{
        vm.book_ins_web = false;
        vm.book_ins = false;
      }
      vm.insuranceValidationError = false;
      vm.insurance_leg_cost = null;
      vm.insurance_currency = 'USD';
      if(!vm.booking_data.search_param.shipment_insurance && vm.booking_data.card_item.data[vm.booking_data.buyOrSell].hasOwnProperty(vm.ins_leg)){
        delete vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.ins_leg];

        var cardRates = resultService.getBookingRates(vm.booking_data.card_item, vm.booking_data.buyOrSell);
        vm.bookingRates = cardRates.rates_obj;
        vm.rate_id = cardRates.rate_ids;
        if (vm.booking_data.card_item.meta.type === 'msr_spot' || vm.booking_data.card_item.meta.type === 'network_spot') {
          vm.getConvenienceLegIndex();
        }
        if(vm.couponResponse) {
          vm.revertSavedData();
          vm.calculateCouponAmounts(vm.couponResponse);
        }
        vm.booking_data.card_item.meta['card_total_cost'] = resultService.calCardTotal(vm.booking_data.card_item.data[vm.booking_data.buyOrSell], vm.domainType);
      }
    }

    function restPartyObj(category) {
      vm.editParty = {
        "name": null,
        "category": category ? category : null,
        "company_name": null,
        "email": null,
        "address": null,
        "contact": null,
        "country_code": null,
        "iec_number": null,
        "point_of_contact": null,
        "send_notification" : false,
        "city": null
      };
    }

    $window.onbeforeunload = function (e) {
      if ($state.current.name == 'app.resultBookShipment' || $state.current.name == 'app.quoteBookShipment' || $state.current.name == 'app.quoteSharedBookShipment') {
        return false;
      }
    }

    function isString(data) {
      if(typeof data === 'string') {
        return true;
      } else {
        return false;
      }
    }

    // check nan value
    function fnCheckIsNaN(charge, param){
      var result = '';
       if(!charge.min_flag && angular.isString(charge.charge_cost)){
           result = charge.charge_cost;
       }else{
           result =  $filter('number')(charge.leg_currency_cost, 2);
       }
      return result;
    }

    // function for confirmBooking
    function confirmBooking() {

      var mixpanelValidtionObj = {
         commodity : '',
         cargoType : '',
         imcoType : '',
         remarks : '',
         insurance : '',
      }

      if(!vm.booking_data.commodity.commodity_data.length){
        vm.requiredCommodity = true;
        mixpanelValidtionObj.commodity = 'required';
          if(util.isMobileDevice){
            angular.element('#commodity-mobile').slideDown();
            document.querySelector('#commodity_id_mobile').focus();
          }
          document.querySelector('#commodity_id_web').focus();
        return;
      }

      if(!vm.booking_data.commodity.cargo_type){
        vm.cargoValidationError = true;
        mixpanelValidtionObj.cargoType = 'required';
        document.querySelector('#book-cargo-type').focus();
        util.showToast("Please Select Cargo Type.");
        return;
      }

      if( vm.booking_data.commodity.hazardous ) {
        if(!vm.booking_data.commodity.imco_code){
          vm.imcoValidationError = true;
          mixpanelValidtionObj.imcoType = 'required';
          document.querySelector('#book-imco-code').focus();
          return;
        }
      }

      if(vm.booking_data.search_param.shipment_insurance ) {
        if(!vm.insurance_leg_cost) {
          vm.insuranceValidationMsg = 'Please enter value of goods';
          mixpanelValidtionObj.insurance = 'Please enter value of goods';
          document.querySelector('.insurance_value').focus();
          vm.insuranceValidationError = true;
          return;
        }else if(vm.insurance_leg_cost > 500000){
          vm.insuranceValidationMsg = 'Value of enter value of goods';
          vm.insuranceValidationError = true;
          mixpanelValidtionObj.insurance = 'Value of enter value of goods';
          document.querySelector('.insurance_value').focus();
          return;
        }
      }
      if((!!vm.inclusions || !!vm.remarks) && !vm.checkRemarksIncl){
        vm.remarksValidation=true;
        mixpanelValidtionObj.remarks = 'required';
        //util.showToast("Please agree to Remarks & Inclusions");
        return;
      }
      if (vm.booking_data.search_param.mode == 'SEA-FCL') {
        for (var i = 0; i < vm.booking_data.search_param.load_data.load_details_value.length; i++) {
          for (var j = 0; j < vm.booking_data.search_param.load_data.load_details_value[i].load_metrics.length; j++) {
            if (vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_qty == undefined) {
              util.showToast('Please add volume for ' + vm.booking_data.search_param.load_data.load_details_value[i].type);
              return true;
            } else if (vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_qty == undefined) {
              util.showToast('Please add weight for ' + vm.booking_data.search_param.load_data.load_details_value[i].type);
              return true;
            }

            if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_unit == 'CBM' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cbm != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cbm)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load volume should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cbm);
              return true;
            }else if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_unit == 'CFT' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cft != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].volume_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cft)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load volume should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_volume_cft);
              return true;
            }else if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_unit == 'KGs' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_kgs != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_kgs)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load weight should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_kgs);
              return true;
            }else if ( vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_unit == 'Tons' && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_ton != null && vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].weight_qty > parseFloat(vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_ton)) {
              util.showToast(vm.booking_data.search_param.load_data.load_details_value[i].type + ' load weight should be less than ' + vm.booking_data.search_param.load_data.load_details_value[i].load_metrics[j].max_weight_ton);
              return true;
            }
          }
        }

        if(vm.checkLoad){
          var confirm = $mdDialog.confirm()
          // .title('Warning')
          .textContent('Load changes are not saved. Proceed without updating?')
          .ariaLabel('discard')
          // .targetEvent(ev)
          .ok('Yes, Proceed')
          .cancel('No, Cancel');

          $mdDialog.show(confirm).then(function () {
            vm.resetLoad();
            vm.confirmBooking();
          }, function () {
            return true;
          });
          //util.showToast('Please save load details');
          return;
        }else{
          if(vm.errorLoad){
            vm.booking_data.search_param.load_data.load_details_value = angular.copy(vm.tempLoad);
          }
        }
      }
      // Condition to check if 20 gp ,40gp and 40HC load qty is greater than maximum qty per shipment
      if(vm.booking_data.card_item.meta.applied_special_meta){
        var user_load_qty = 0;
        vm.booking_data.search_param.load_data.load_details_value.find(function(element) {
          if( element.type == '20GP'){
            user_load_qty += element.qty;
          } else if(element.type == '40GP' || element.type == '40HC') {
            user_load_qty += element.qty * 2;
          }
        });

        if(user_load_qty && ((user_load_qty > vm.booking_data.card_item.meta.applied_special_meta.special_qty_rem.TEUs) || (user_load_qty > vm.booking_data.card_item.meta.applied_special_meta.max_qty_per_shipment.TEUs))){
          util.showToast('You can not book more than '+vm.booking_data.card_item.meta.applied_special_meta.max_qty_per_shipment.TEUs+'containers');
          return;
        }
      }

      // Check if terms and condition accepted or not


      vm.confirm_btn = true;
      $rootScope.loadingDetails = true;
      util.isCallingApi = true;
      vm.booking_data.commodity.commodity_data = vm.shareQuoteService.commodityString(vm.booking_data.commodity.commodity_data);
      vm.booking_data.commodity.hazardous = ( vm.booking_data.commodity.hazardous ) ? 1 : 0;

      // filling the commodity name from commodity data array-- to be used in shipment details
      vm.booking_data.commodity.name  =    vm.booking_data.commodity.commodity_data ?   vm.booking_data.commodity.commodity_data.join() : null ;

      if(vm.booking_data.card_item.meta.applied_special_meta){
        delete vm.booking_data.card_item.meta["applied_special_meta"];  //remove special meta code
      }

      var current_date = moment().format('YYYY-MM-DD HH:mm');

      vm.booking_data.search_param.load_data['ltl_load_details'] = vm.booking_data.card_item.meta.ltl_load_details ? vm.booking_data.card_item.meta.ltl_load_details : null
      var data = {
        "data": {
          "shipment": {
            "mode": vm.booking_data.search_param.mode,
            "incoterm": vm.booking_data.search_param.inco_term,
            "pol": {
              "name": vm.booking_data.card_item.meta.port_data.origin_portname,
              "port_code": vm.booking_data.card_item.meta.port_data.origin_port_code,
              "is_icd_port": vm.booking_data.card_item.meta.port_data.is_icd_port_origin,
              "portcode_portname": vm.booking_data.card_item.meta.port_data.origin_portname +'('+vm.booking_data.card_item.meta.port_data.origin_port_code +')'
            },
            "pod": {
              "name": vm.booking_data.card_item.meta.port_data.destination_portname,
              "port_code": vm.booking_data.card_item.meta.port_data.destination_port_code,
              "is_icd_port": vm.booking_data.card_item.meta.port_data.is_icd_port_destination,
              "portcode_portname": vm.booking_data.card_item.meta.port_data.destination_portname +'('+vm.booking_data.card_item.meta.port_data.destination_port_code +')'
            },
            "stuffing" : vm.booking_data.search_param.stuffing,
            "search_type": vm.booking_data.search_param["search_type"],
            // origin and destination location appended in pickup and delivery address
            "pickup_address": vm.booking_data.search_param.origin_location,
            "delivery_address": vm.booking_data.search_param.destination_location,
            "origin_address": formatAddressForAPI(vm.booking_data.origin_address),
            "destination_address": formatAddressForAPI(vm.booking_data.destination_address),
            "references": vm.booking_data.references ? vm.booking_data.references.filter(function(ref) {
                    return ref.reference_value && ref.reference_value.trim() !== '';
                  }) : [],            
            "cargo_ready_date": $filter('date')(new Date(vm.booking_data.search_param.cargo_ready_date), util.dateFormat),
            "comments": vm.booking_data.comments,
            "departure_date": vm.booking_data.card_item.meta.selected_schedule ?
              $filter('date')(util.dateReplace(new Date(vm.booking_data.card_item.meta.selected_schedule.departure_time)), util.dateFormat) :
              vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.sailing_date ,
            "arrival_date": vm.booking_data.card_item.meta.selected_schedule ?
              $filter('date')(util.dateReplace(new Date(vm.booking_data.card_item.meta.selected_schedule.arrival_time)), util.dateFormat) :
              null,
            "booked_leg_type": vm.booking_data.booked_leg_type,
            "rollable_available" : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.rollable_available,
            "penalty_details": vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details,
            'milestone_date' : current_date ? current_date : null,
            'milestone_date_offset' : moment(current_date).zone() ? moment(current_date).zone() : 0,
            'all_in_quote_setting' : vm.booking_data.all_in_quote_setting
          },
          "commodity": vm.booking_data.commodity,
          "load": vm.booking_data.search_param.mode == 'SEA-FCL' ? util.fnRemoveMaxKey(vm.booking_data.search_param.load_data) : util.formatLCLAIRLoad(vm.booking_data.search_param.load_data),
          "parties": vm.parties,
          // "rates": vm.bookingRates, //resultService.getRatesFromCard(vm.bookingRates,vm.booking_data.rates),
          "card": vm.booking_data.card_item,
          "schedule": vm.booking_data.card_item.meta.selected_schedule,
          "coupon": vm.couponResponse ? vm.couponResponse : null
        }
      };

      if (vm.booking_data.page == 'search') {
        data.data.shipment["search_id"] = vm.booking_data.id;
      } else if (vm.booking_data.page == 'quote') {
        data.data.shipment["quote_id"] = vm.booking_data.id;
      }else if(vm.booking_data.page == 'inquiry'){
        data.data.shipment["inquiry_id"] = vm.booking_data.id;
      }

      vm.fclLoadData = SearchService.getFclLoadDetails(vm.booking_data.search_param.load_data.load_details_value);

      var service_type = (vm.booking_data.card_item.meta.selected_schedule != null && vm.booking_data.search_param.mode == "SEA-FCL")  ? vm.booking_data.card_item.meta.selected_schedule.service_name : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.service_type;

      var via_port = (vm.booking_data.card_item.meta.selected_schedule != null && vm.booking_data.search_param.mode == "SEA-FCL") ? vm.booking_data.card_item.meta.selected_schedule.via_port :  vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.via_route;

      var departure_time = (vm.booking_data.card_item.meta.selected_schedule != null && vm.booking_data.search_param.mode == "SEA-FCL") ? vm.booking_data.card_item.meta.selected_schedule.departure_time : 'N/A';

      var mixPanelData = {
        "Mode": vm.booking_data.search_param.mode,
        "Origin Port": vm.booking_data.search_param.origin_location.portcode_portname,
        "Destination Port": vm.booking_data.search_param.destination_location.portcode_portname,
        "Cargo Ready Date": vm.booking_data.search_param.cargo_ready_date,
        "Search Name" : vm.booking_data.search_param.search_name,
        "Port-Pair":vm.booking_data.search_param.origin_location.location + ' to ' + vm.booking_data.search_param.destination_location.location,
        "Service type" : service_type,
        "Via port" : via_port,
        "Departure Date" : departure_time,
        "Commodity Name": vm.booking_data.commodity.commodity_data,
        "Booking data quote id": vm.booking_data.id,
        "Carrier List":vm.booking_data.search_param.mode != 'AIR' ? vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.airline.air_line_name,
        "Buying rate" : vm.booking_data.card_item.data.buy_rates != undefined ? resultService.calCardTotal(vm.booking_data.card_item.data.buy_rates, vm.domainType) : null,
        "Booking main freight cost": vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.leg_total_cost,
        "Booking total cost": vm.booking_data.card_item.meta.card_total_cost,
        "Currency" : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.leg_total_currency,
        "Customer Email" : vm.booking_data.create_for.email,
        "Customer Name" : vm.booking_data.create_for.user_first_name + ' ' + vm.booking_data.create_for.user_last_name,
        "Customer Company Name" : vm.booking_data.create_for.company.company_name,
        "Customer Mobile" : vm.booking_data.create_for.user_mobile,
        "No. of rate card":1
      };

      if(vm.booking_data.search_param.mode == "SEA-FCL"){
        var searchName = vm.booking_data.search_param.origin_location.location + ' to ' + vm.booking_data.search_param.destination_location.location + ' / ' + $filter('date')(vm.booking_data.search_param.cargo_ready_date, 'd MMM yyyy') + ',' + vm.fclLoadData.loadtype;
        mixPanelData["Load Details"] = vm.fclLoadData.loadtype;
        mixPanelData["Load In TEUs"] = vm.fclLoadData.typexqty;
        mixPanelData["Search Param"] = searchName;
        mixPanelData["Rates by"] = vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.vendor.vendor_name;
        mixPanelData["Vessel"] = vm.booking_data.card_item.meta.selected_schedule != null ? vm.booking_data.card_item.meta.selected_schedule.vessel : 'No Schedule Available';
        mixPanelData["Transit Time"] = vm.booking_data.card_item.meta.selected_schedule != null ? vm.booking_data.card_item.meta.selected_schedule.transit_time :  'No Schedule Available';
      }else{
        var chargeable_weight = vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.is_higher_slab ? vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.slab : vm.booking_data.search_param.load_data.load_meta.chargeable_weight;
        var searchName = vm.booking_data.search_param.origin_location.location + ' to ' + vm.booking_data.search_param.destination_location.location + ' / ' + $filter('date')(vm.booking_data.search_param.cargo_ready_date, 'd MMM yyyy') + ',' + chargeable_weight;
        mixPanelData["Load Details"] =  chargeable_weight + ' Kgs';
        mixPanelData["Search Param"] = searchName;
        mixPanelData["Gross Weight"]= vm.booking_data.search_param.load_data.load_meta.gross_weight + ' Kgs',
        mixPanelData["Volumetric Weight"]= vm.booking_data.search_param.load_data.load_meta.volumetric_weight + ' Kgs';
        if(vm.booking_data.search_param.mode == "AIR" && vm.booking_data.card_item.meta.selected_schedule != null ){
          mixPanelData["Flight Number"] = vm.booking_data.card_item.meta.selected_schedule != null ? vm.booking_data.card_item.meta.selected_schedule.flight_number : 'Flight Number Not Available';
          mixPanelData["Departare Time"] = vm.booking_data.card_item.meta.selected_schedule != null ? vm.booking_data.card_item.meta.selected_schedule.departure :  'Departure Time Not Available';
        }
      }

      resultService.confirmBooking(data, QuotesService.quote_id).then(function (response) {
        if(localStorageService.get('dashboardCache')){
          if(localStorageService.get('dashboardCache').value === true){
            localStorageService.set('dashboardCache', false);
          }
        }
        vm.bookResponseData = response.data;
        appCache.remove('filterStructure');
        vm.bookResponseData["mode"] = vm.booking_data.search_param.mode;
        vm.bookResponseData["webViewObj"] = vm.booking_data.webViewObj;
        resultService.bookResponseData = vm.bookResponseData;
        vm.confirm_btn = false;
        $rootScope.loadingDetails = false;
        util.isCallingApi = false;

        if (vm.booking_data.page == 'search') {
          if (vm.isShared) {
            $state.go('app.resultSharedConfirmShipment');
          } else {
            $state.go('app.resultConfirmShipment');
          }
        } else if (vm.booking_data.page == 'quote') {
          if (vm.isShared || util.isWebView()) {
            $state.go('app.quoteSharedConfirmShipment');
          } else {
            $state.go('app.quoteConfirmShipment');
          }
        }
      }, function (error) {
        util.showToast(util.displayValidationError(error.data));
        vm.confirm_btn = false;
        $rootScope.loadingDetails = false;
        util.isCallingApi = false;
        $log.log(error);
      });
    }

    function hideToaster(){
      localStorageService.set('rateToasterStatus', false);
      vm.showRateToaster = false;
    }

    function fnDisplayPenalty(ev){
      $mdDialog.show({
        template: '<md-dialog id="penalty-fees" class="popup-md" ng-cloak><penalty-fees penaltyfeesobj="ctrl.parent.booking_data.card_item.data[ctrl.parent.booking_data.buyOrSell][ctrl.parent.l3_leg].rate_obj.penalty_details" ></penalty-fees></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: true,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () { this.parent = vm },
        controllerAs: 'ctrl',
      });
    }
    function trackEvent(type){
      util.callMixpanel(type,{
        "Mode":vm.booking_data.search_param.mode
      });
    }

    function getCountries() {
      if (!SettingService.countriesData) {
        vm.isDataLoading = true;
        SettingService.getCountryList(vm.booking_data.uuid).then(function (response) {
              vm.countryList = response.data.data.countries;
              vm.isDataLoading = false;
              SettingService.countriesData = angular.copy(response.data.data);
          }, function (err) {
            vm.isDataLoading = false;
            $log.log(err);
          });
      } else {
          vm.countryList = SettingService.countriesData.countries;
        }
    }

    function countrySelected(country_name) {
        vm.selectedState = '';
        vm.editParty.state = '';

       var selected_country =  vm.countryList.find(function(item){
          return item.country_name == country_name
        });
        vm.editParty.country_code = selected_country.country_code || '';
        if(selected_country.states.length > 0 ){
          vm.stateList =  selected_country.states;
          return;
        }
        SettingService.getStateList(country_name).then(function (response) {
          vm.stateList = response.data.data.countries[0] ? response.data.data.countries[0].states : [];
        }, function (err) {
          $log.log(err);
        });
    }

    function setPartyDetails(selectedCompany , partyDetails){
      ShipmentService.setPartyDetails(selectedCompany , partyDetails, vm.editPartyModalAction, vm.booking_data.search_param.mode);
      //  while changing company , prefill country and store state list
      vm.fnStoreStateList();
   }

    function onCompanyTextChange(searchText) {
      // Reset selected item when user types
      vm.searchPartyData = null;
    }

    function  fnStoreStateList(){
      // storing states based on selected country on init
      var country =  vm.countryList.find(function(item){
        return (item.country_name === vm.editParty.country);
      });
      vm.stateList =  country && country.states.length > 0 ? country.states : [] ;
      vm.editParty.country_code = country && country.country_code ? country.country_code : null;
  }

  function cargoTypeChange(){
    // commented as per the ticket QMS-467
    // util.callMixpanel('BS-CargoType-Change',{value : vm.booking_data.commodity.cargo_type.name})
  }

  function initializeAddresses() {
    if (!vm.booking_data.origin_address || angular.isString(vm.booking_data.origin_address)) {
      vm.booking_data.origin_address = {
        company_name: '',
        contact_email: '',
        street_address: '',
        city: '',
        state: '',
        country: '',
        postal_code: '',
        note: ''
      };
    }
    
    if (!vm.booking_data.destination_address || angular.isString(vm.booking_data.destination_address)) {
      vm.booking_data.destination_address = {
        company_name: '',
        contact_email: '',
        street_address: '',
        city: '',
        state: '',
        country: '',
        postal_code: '',
        note: ''
      };
    }
  
    if (!vm.booking_data.references) {
      var authToken = localStorageService.get('authToken');
      var userId = authToken && authToken.value ? authToken.value.user_id : '';
      var userCategory = authToken && authToken.value ? authToken.value.user_category : 'FORWARDER';
      
      
      if ($rootScope.domainData && 
          $rootScope.domainData.domain_info && 
          $rootScope.domainData.domain_info.BOOKING_REFERENCE_FIELDS) {
        
        var referenceFields = $rootScope.domainData.domain_info.BOOKING_REFERENCE_FIELDS;
      }
      
      if (referenceFields && angular.isArray(referenceFields) && referenceFields.length > 0) {
        vm.booking_data.references = referenceFields.map(function(label) {
          return {
            reference_label: label,
            reference_value: '',
            comment: '',
            type: 'string',
            added_at: new Date().toISOString(),
            added_by: userCategory,
            user_id: userId || ''
          };
        });
      } else {
        vm.booking_data.references = [{
          reference_label: '',
          reference_value: '',
          comment: '',
          type: 'string',
          added_at: new Date().toISOString(),
          added_by: userCategory,
          user_id: userId || ''
        }];
      }
    }
  }

  function addReference() {
    var authToken = localStorageService.get('authToken');
    var userId = authToken && authToken.value ? authToken.value.user_id : '';
    var userCategory = authToken && authToken.value ? authToken.value.user_category : '';
    
    var newReference = {
      reference_label: '',
      reference_value: '',
      comment: '',
      type: 'string',
      added_at: new Date().toISOString(),
      added_by: userCategory || 'FORWARDER',
      user_id: userId || ''
    };
    
    
    if ($rootScope.domainData && 
        $rootScope.domainData.domain_info && 
        $rootScope.domainData.domain_info.BOOKING_REFERENCE_FIELDS) {
      
      var referenceFields = $rootScope.domainData.domain_info.BOOKING_REFERENCE_FIELDS;
    }
    
    if (referenceFields && angular.isArray(referenceFields)) {
      var usedLabels = vm.booking_data.references.map(function(ref) {
        return ref.reference_label;
      });
      
      var unusedLabels = referenceFields.filter(function(label) {
        return usedLabels.indexOf(label) === -1;
      });
      
      if (unusedLabels.length > 0) {
        newReference.reference_label = unusedLabels[0];
      }
    }
    
    vm.booking_data.references.push(newReference);
    
    util.callMixpanel('BS-References-Add-Click', {
      Mode: vm.booking_data.search_param.mode,
      Count: vm.booking_data.references.length
    });
  }

  function removeReference(index) {
    if (vm.booking_data.references.length > 1) {
      vm.booking_data.references.splice(index, 1);
      util.callMixpanel('BS-References-Remove-Click', {
        Mode: vm.booking_data.search_param.mode,
        Count: vm.booking_data.references.length
      });
    }
  }

  function updateReference(index, field, value) {
    var reference = vm.booking_data.references[index];
    reference[field] = value;
    reference.added_at = new Date().toISOString();
    
    util.callMixpanel('BS-References-Update', {
      Mode: vm.booking_data.search_param.mode,
      Field: field
    });
  }

  function formatAddressForAPI(addressObj) {
    if (!addressObj || angular.isString(addressObj)) {
      return null;
    }
    
    var hasValue = Object.keys(addressObj).some(function(key) {
      return addressObj[key] && addressObj[key].toString().trim() !== '';
    });
    
    if (!hasValue) return null;
    
    return {
      company_name: addressObj.company_name || '',
      contact_email: addressObj.contact_email || '',
      company_id: addressObj.company_id || '',
      user_id: addressObj.user_id || '',
      street_address: addressObj.street_address || '',
      city: addressObj.city || '',
      state: addressObj.state || '',
      country: addressObj.country || '',
      postal_code: addressObj.postal_code || '',
      note: addressObj.note || ''
    };
  }

  vm.clearAdresses = clearAdresses;
  function clearAdresses(address) {
    vm.booking_data[address] = {
      company_name: '',
      contact_email: '',
      street_address: '',
      city: '',
      state: '',
      country: '',
      postal_code: '',
      note: ''
    }
  }
}

})();

(function ()
{
    'use strict';

    angular
        .module('app.quotes', ['app.book'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.quotes', {
                url    : '/quotes',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/quotes/quotes.html',
                        controller : 'QuotesController as vm'
                    },
                    data : { pageTitle: 'Quotes' }
                },
                // resolve: {
                // },
                bodyClass: 'quotes-page'
            })
            .state('app.quotes.quotesDetails', {
                url  : '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/quotes/quotesDetails/fcl-quote-details.html',
                        controller : 'QuotesDetailsController as vm'
                    },
                    data : { pageTitle: 'Quotes' }
                },
                resolve: {
                    QuoteDetailsData: function ($stateParams,QuotesService)
                    {
                        // if(!angular.equals({}, QuotesService.FclQuote) && QuotesService.FclQuote.result_data && $stateParams.id === QuotesService.FclQuote.result_data._id) {
                        //     return QuotesService.FclQuote;
                        // }else{
                            return QuotesService.getQuoteDetails($stateParams.id);
                        // }
                    }
                },
                bodyClass: 'quote-details-page'
            })
            .state('app.CopyQuoteDetailsController', {
                url  : '/copyquote/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/quotes/copyQuoteDetails/copy-quote-details.html',
                        controller : 'CopyQuoteDetailsController as vm'
                    },
                    data : { pageTitle: 'Copy Quotes' }
                },
                resolve: {
                    QuoteDetailsData: function ($stateParams,QuotesService)
                    {
                            return QuotesService.getQuoteDetails($stateParams.id);
                    }
                },
                bodyClass: 'copy-quotes-details-page'
            })
            .state('app.webViewCopyQuoteDetailsController', {
                url  : '/web_view/copyquote/:id',
                views: {
                    'main@'                             : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.webViewCopyQuoteDetailsController': {
                        templateUrl: 'app/main/quotes/copyQuoteDetails/copy-quote-details.html',
                        controller : 'CopyQuoteDetailsController as vm'
                    },
                    data : { pageTitle: 'Copy Quotes' }
                },
                resolve: {
                    QuoteDetailsData: function ($stateParams,QuotesService)
                    {
                            return QuotesService.getQuoteDetails($stateParams.id);
                    }
                },
                bodyClass: 'copy-quotes-details-page'
            })
            .state('app.CreateQuotesController', {
                url    : '/create-quotes/:mode/:id?',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/create-quote/create-quote.html',
                        controller : 'CreateQuotesController as vm'
                    },
                    data : { pageTitle: 'Create Quotes' }
                },
                resolve: {
                    CreateQuoteModeData: function ($stateParams){
                        return $stateParams.mode;
                    },
                    QuoteDetailsData: function ($stateParams,QuotesService){
                        if($stateParams.id){
                        return QuotesService.getQuoteDetails($stateParams.id);
                        }
                     },
                    SearchParam : function(msApi){
                        return msApi.resolve('search@get');
                    }
                },
                bodyClass: 'quotes-page'
            })
    
            .state('app.shareQuotesDetails', {
                url  : '/shared/:id',
                views: {
                    'main@'                             : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.shareQuotesDetails': {
                        templateUrl: 'app/main/quotes/quotesDetails/fcl-quote-details.html',
                        controller : 'QuotesDetailsController as vm'
                    }
                },
                resolve: {
                    QuoteDetailsData: function ($stateParams,QuotesService,api,apiUrl)
                    {
                        //mixpanel code
                        // analytics.track("Shared Quotes");
                        QuotesService.quote_id = $stateParams.id;
                        api.baseMockUrl = apiUrl +'/shared/' + QuotesService.quote_id;   // to update base mock url.
                        if(!angular.equals({}, QuotesService.sharedQuoteResult) && QuotesService.sharedQuoteResult.result_data && $stateParams.id === QuotesService.sharedQuoteResult.result_data.uuid) {
                            return QuotesService.sharedQuoteResult;
                        } else {
                          return QuotesService.getQuoteDetails($stateParams.id);
                        }
                    }
                },
                bodyClass: 'quote-details-page'
            })
            .state('app.webViewQuotesDetails', {
                // SEC-3835: do not put JWT in query; prefer #token= / #access_token= (see setWebViewAuthToken).
                url  : '/quotes/:id/:web_view?user_id&permissionQuote&permissionShipment&permissionInquiry&vendor_id&expires_in&user_category&vendor_name',
                params: {
                    access_token: { value: null, squash: true, dynamic: true }
                },
                views: {
                    'main@'                             : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.webViewQuotesDetails': {
                        templateUrl: 'app/main/quotes/quotesDetails/fcl-quote-details.html',
                        controller : 'QuotesDetailsController as vm'
                    }
                },
                resolve: {
                    QuoteDetailsData: function ($stateParams,QuotesService,api,apiUrl,analytics,localStorageService,util,$location)
                    {
                        QuotesService.quote_id = $stateParams.id;
                        util.setWebViewAuthToken($stateParams);
                        return QuotesService.getQuoteDetails($stateParams.id);
                    }
                },
                bodyClass: 'quote-details-page'
            })
            .state('app.quoteBookShipment', {
                url  : '/quotebooking',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/result/bookShipment/booking-shipment.html' ,
                        controller : 'bookShipmentFclController as vm'
                    },
                    data : { pageTitle: 'Book Shipment' }
                },
                resolve : {
                    BookingData :function($window,QuotesService,resultService){

                        if(QuotesService.FclQuote.result_meta != undefined && QuotesService.FclQuote.result_meta.search_param != undefined){
                            if(!angular.equals(QuotesService.FclQuote.result_meta.search_param.user, resultService.requestToBookData.search_param.user)){
                                $window.history.back();
                            }
                            else {
                                return resultService.requestToBookData;
                            }
                        } else{
                            $window.history.back();
                        }
                    }
                }
            })
            .state('app.quoteWebViewBookShipment', {
              url  : '/web_view/quotebooking',
              views: {
                  'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                  },
                  'content@app.quoteWebViewBookShipment': {
                      templateUrl: 'app/main/result/bookShipment/booking-shipment.html',
                      controller : 'bookShipmentFclController as vm'
                  },
                  data : { pageTitle: 'Book Shipment' }
              },
              resolve : {
                  BookingData :function($window,QuotesService,resultService){

                      if(QuotesService.FclQuote.result_meta != undefined && QuotesService.FclQuote.result_meta.search_param != undefined){
                          if(!angular.equals(QuotesService.FclQuote.result_meta.search_param.user, resultService.requestToBookData.search_param.user)){
                              $window.history.back();
                          }
                          else {
                              return resultService.requestToBookData;
                          }
                      } else{
                          $window.history.back();
                      }
                  }
              }
            })
            .state('app.quoteSharedBookShipment', {
                url  : '/shared/quotes/quotebooking',
                views: {
                    'main@'                             : {
                      templateUrl: 'app/core/layouts/content-only.html',
                      controller : 'MainController as vm'
                    },
                    'content@app.quoteSharedBookShipment': {
                        templateUrl: 'app/main/result/bookShipment/booking-shipment.html',
                        controller : 'bookShipmentFclController as vm'
                    },
                    data : { pageTitle: 'Book Shipment' }
                },
                resolve : {
                    BookingData :function($window,QuotesService,resultService){
                        if(QuotesService.FclQuote.result_meta != undefined && QuotesService.FclQuote.result_meta.search_param !== undefined){
                            if(!angular.equals(QuotesService.FclQuote.result_meta.search_param.user, resultService.requestToBookData.search_param.user)){
                                $window.history.back();
                            }
                            else{
                                return resultService.requestToBookData;
                            }
                        }else{
                            $window.history.back();
                        }

                    }
                }
            })
            .state('app.quoteConfirmShipment', {
                views: {
                    'content@app': {
                        templateUrl: 'app/main/result/bookShipment/confirm_booking.html',
                        controller : function($scope, resultService,$state,util){
                            var vm = this;
                            vm.util = util;
                            vm.bookResponseData = resultService.bookResponseData;
                            vm.redirectOnClose = redirectOnClose;
                            vm.goToShipmentDetail = goToShipmentDetail;

                            function redirectOnClose (){
                                util.fnReDirectToHome();
                                // $state.go('app.'+util.state[0]);
                            }

                            function goToShipmentDetail(){
                              if(util.isWebView()){
                                util.webViewObj.id =  vm.bookResponseData.shipment_id;
                                $state.go('app.mobile_shipment_details',util.webViewObj);
                              }else{
                                $state.go('app.shipments.shipment_details', { id: vm.bookResponseData.shipment_id });
                              }
                            }
                          },
                        'controllerAs' : 'vm'
                    },
                    data : { pageTitle: 'Book Shipment' }
                }
            })
            .state('app.quoteSharedConfirmShipment', {
              views: {
                  'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                  },
                  'content@app.quoteSharedConfirmShipment': {
                      templateUrl: 'app/main/result/bookShipment/confirm_booking.html',
                      controller : function(util,resultService,$state,$location){
                          var vm = this;
                          vm.util = util;
                          vm.quoteShare = util.isSharedQuote();
                          vm.bookResponseData = resultService.bookResponseData;
                          vm.redirectOnClose = redirectOnClose;
                          vm.goToShipmentDetail = goToShipmentDetail;

                          function redirectOnClose (){
                            if(vm.quoteShare) {
                              $location.path('/login');
                            } else {
                              $state.go('app.search'); 
                            }
                          }

                          function goToShipmentDetail(){
                            if(util.isWebView()){
                              util.webViewObj.id = vm.bookResponseData.shipment_id; 
                              $state.go('app.mobile_shipment_details',util.webViewObj);
                            }else{
                              $state.go('app.shipments.shipment_details', { id: vm.bookResponseData.shipment_id });
                            }
                          }
                        },
                      'controllerAs' : 'vm'
                  },
                  data : { pageTitle: 'Book Shipment' }
              }
            })
            .state('app.preview', {
                url  : '/quote_preview',
                views: {
                    'main@'                             : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.preview': {
                        templateUrl: 'app/main/quotes/quotesDetails/fcl-quote-details.html',
                        controller : 'QuotesDetailsController as vm'
                    },
                    data : { pageTitle: 'Results' }
                },
                resolve : {
                    QuoteDetailsData : function(util, $rootScope, $log, $q) {
                        var deferred = $q.defer();
                        var previewCardData=JSON.parse(sessionStorage.getItem("preview_cards"))
                        util.isCallingApi = true;
                        util.getProfile().then(
                            function() {
                                $rootScope.number_format = util.userProfile.user.number_format ? util.userProfile.user.number_format : 'en-US';
                                $rootScope.metric_system = util.userProfile.user.metric_system ? util.userProfile.user.metric_system : 'metric';
                                $rootScope.precision_decimals = util.userProfile.user.precision_decimals ? util.userProfile.user.precision_decimals : 2;
                                util.isCallingApi = false;
                                deferred.resolve(previewCardData);
                            },
                            function(error) {
                                $log.log(error.data);
                                util.isCallingApi = false;
                                deferred.reject(error);
                            }
                        );
                        return deferred.promise;
                    }
                },
                bodyClass: 'quote-details-page'
            });


        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/quotes');
    }
})();

(function () {
  "use strict";

  angular
    .module("app.quotes")
    .controller("QuotesDetailsController", QuotesDetailsController);

  /** @ngInject */
  function QuotesDetailsController(
    $window,
    QuoteDetailsData,
    $timeout,
    api,
    localStorageService,
    QuotesService,
    resultService,
    $mdDialog,
    $filter,
    $log,
    util,
    $q,
    $http,
    $state,
    $rootScope,
    shareQuoteService,
    $mdSidenav,
    SearchService,
    $mdToast,
    analytics,
    $scope,
    $location,
    $anchorScroll,
    mixPanelToken,
    $rootElement,
    $interval,
    $mdPanel,
    basisCalculation,
    StandardQuotationService,
    constObj,
    $stateParams,
    ShipmentService
  ) {
    // Data
    var vm = this;
    vm.util = util;
    vm.constObj = constObj;

    vm.shareQuoteService = shareQuoteService;
    vm.title = "";
    vm._mdPanel = $mdPanel;
    vm._mdPaneRef = "";
    vm.isShared = util.isSharedQuote();
    vm.isWebView = util.isWebView();
    vm.maskLiner = util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER;
    vm.sharedMaskLiner = $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER && vm.isShared;
    vm.expMaxDate = new Date();
    $rootScope.loadingDetails = false;
    vm.quotePreview = util.sanitizeQueryParams($window.location.href).indexOf("quote_preview") >= 0 ? true : false;
    vm.dataErr = QuoteDetailsData ? false : true;
    vm.mainFreightNameChange = $rootScope.isJeenaDomain;
    vm.mainFreightName = "Main Freight";
    vm.isAddNewRateLoaded=false;
    vm.currentState = $state.current.name;
    vm.isString = isString;
    vm.webViewObj = null;
    vm.proceedDuplicate = false;
    vm.copyquoted = false;
    vm.syncShimmer=false;
    vm.selectedSyncCardRef={}
    vm.selectedDuplicateCard = [];
    vm.responseStatusData = [];
    vm.templateName = "";
    vm.checkTemplate = false;
    vm.deleteType = "Template";
    vm.templateError = false;
    vm.deleteContent = "";
    vm.activityId = '';
    vm.templateValueChange = false;
    vm.checkUnmapped=checkUnmapped;
    vm.templateActivityMonitor=templateActivityMonitor;
    vm.templateValueAssign=templateValueAssign;
    vm.fnUpdateLocation=fnUpdateLocation;
    vm.reSyncTmsData=reSyncTmsData
    vm.loopCards = loopCards;
    vm.rateCardSelection=false;
    vm.isPanelOpened = true;
    vm.isMappedPanelOpened=false;
    vm.selectedSyncCard=[];
    vm.user_category = vm.isShared ? null : localStorageService.get("authToken").value.user_category;
    vm.isCommodity = $rootScope.domainData.domain_info.QUOTE_POPUP_SETTING ? $rootScope.domainData.domain_info.QUOTE_POPUP_SETTING.SHOW_COMMODITY : false;
    vm.showContractId = $rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES;
    vm.unmappedList=[];

    if (!vm.isShared && vm.isWebView && !util.currencyList.length) {
      util.getCurrencyList().then(
        function (response) {
          vm.currencyList = util.currencyList;
        },
        function (error) {
          vm.currencyList = [];
          $log.log(error);
        }
      );
    } else {
      vm.currencyList = util.currencyList;
    }

    if (vm.dataErr) {
      return;
    }

    vm.quote_result = angular.copy(QuoteDetailsData);
    if(vm.isCommodity){
      vm.quote_result.result_data.commodity_data = vm.quote_result.result_data.commodity_data ? vm.quote_result.result_data.commodity_data : [];
      vm.commodityValue = shareQuoteService.commodityString(vm.quote_result.result_data.commodity_data);
    }
    vm.all_in_quote = vm.quote_result.result_data.all_in_quote_setting ? vm.quote_result.result_data.all_in_quote_setting : "default" ;
    vm.pageInfo={
      "pageId":vm.quotePreview ? vm.quote_result.result_data.exchangeRateId : vm.quote_result.result_data._id,
      "pageType":vm.quotePreview ? vm.quote_result.result_data.quoteFrom : "Quote",
      "activityId": vm.quote_result.result_data.activityId
    }
    vm.search_param = vm.quote_result.result_meta.search_param;
    vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT: "";
    vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
    vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';

    vm.salesPersonType = util.userProfile.user && util.userProfile.user.is_sales_cordinator ? 'SALES_COORDINATOR' : (!util.isShipper ? 'SALES_USER' : 'SHIPPER_USER' );
    vm.isDuplicateQuote = false;
    vm.tempSearch_param = angular.copy(
      vm.quote_result.result_meta.search_param
    );
    vm.temp_quoteData = angular.copy(vm.quote_result);
    vm.searchUser = vm.quote_result.result_data.created_by;
    vm.pdf_link = vm.quote_result.result_data.pdf_link;
    vm.quote_Status = !vm.quotePreview
      ? vm.quote_result.result_data.status.status_list[
          vm.quote_result.result_data.status.status_list.length - 1
        ].status
      : null;

    vm.refreshRates = !util.isWebView() && vm.search_param.mode == 'SEA-FCL' && (vm.quote_Status=='Active' || vm.quote_Status=='Follow-up Required') && util.isAdmin && !vm.isShared && !vm.quotePreview && $rootScope.domainData.domain_info.ENABLE_RATE_REFRESH_FROM_QUOTE;
    
    vm.isLost = !vm.quotePreview && vm.quote_Status == "Lost" ? true : false;
    vm.isExpired =
      !vm.quotePreview && vm.quote_Status == "Expired" ? true : false;
    vm.quoteActivity = vm.quote_result.result_data.activity;
    vm.quote_CardData = vm.quote_result.result_data.cards;
    vm.dateExpired =
      new Date(vm.quote_result.result_data.expiry_date) > vm.expMaxDate;
    vm.disableSetReminder = false;
    vm.sourceRate={};
    vm.pageSource='';
    vm.remarksInclusionCkEditorConfig = angular.copy(util.ckEditorConfig);
    vm.remarksInclusionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
    vm.printDiv = printDiv;
    vm.cancelDialog = cancelDialog;
    vm.viewDetailsModal = viewDetailsModal;
    vm.selectedSchedule = selectedSchedule;
    vm.setCurrentSchedule = setCurrentSchedule;
    vm.requestToBook = requestToBook;
    vm.isLegLoadMissing = isLegLoadMissing;
    vm.getCardRemarksInclusion = getCardRemarksInclusion;
    vm.showTemplateAction=showTemplateAction;
    vm.generateOtp = generateOtp;
    vm.formContainerType = formContainerType;
    vm.checkOtp = checkOtp;
    vm.rateTotalCustomCurr = rateTotalCustomCurr;
    vm.fnGetLegs = fnGetLegs;
    vm.fnGetBuyChargeLegCurrencyCost = fnGetBuyChargeLegCurrencyCost;
    vm.fnGetBuyUnitPrice = fnGetBuyUnitPrice;
    vm.fnGetBuyChargeCurrency = fnGetBuyChargeCurrency;
    vm.fnGetBuyMinAmount = fnGetBuyMinAmount;
    vm.getQuotesActivityList = getQuotesActivityList;
    vm.fnSwitchPages = fnSwitchPages;
    vm.otpCheck = otpCheck;
    vm.toggleSideNav = toggleSideNav;
    vm.fnOpenEditQuoteModal = fnOpenEditQuoteModal;
    vm.closeToast = closeToast;
    vm.fnGetColorByStatusName = fnGetColorByStatusName;
    vm.checkTemplateData = vm.checkTemplateData;
    vm.getTimeStampValue = getTimeStampValue;
    vm.timeSince = timeSince;
    vm.calculateQtyRange = calculateQtyRange;
    vm.loadMoreRecords = loadMoreRecords;
    vm.afterShowAnimation = afterShowAnimation;
    vm.rateTabView = rateTabView;
    vm.scheduleTabView = scheduleTabView;
    vm.quotationTabView = quotationTabView;
    vm.airScheduleTabView = airScheduleTabView;
    vm.fnAddOrEditCard = fnAddOrEditCard;
    vm.fngetSubVendorDetails = fngetSubVendorDetails;
    vm.conversionOnPriceChange = conversionOnPriceChange;
    vm.conversionOnLegCurrencyChange = conversionOnLegCurrencyChange;
    vm.fnAddLeg = fnAddLeg;
    vm.fnAddNewCharge = fnAddNewCharge;
    vm.pushToquoteArray = pushToquoteArray;
    vm.changeSelectedLeg = changeSelectedLeg;
    vm.getMatches = getMatches;
    vm.confirmDeleteLeg = confirmDeleteLeg;
    vm.changeSelectedCharge = changeSelectedCharge;
    vm.changeTextCharge = changeTextCharge;
    vm.getChargeList = getChargeList;
    vm.fnChangeBasis = fnChangeBasis;
    vm.confirmDeleteCharge = confirmDeleteCharge;
    vm.addInQuote = addInQuote;
    vm.fnDeleteNewCharge = fnDeleteNewCharge;
    vm.fnDeleteLeg = fnDeleteLeg;
    vm.fnQuoteModify = fnQuoteModify;
    vm.fnUndoChanges = fnUndoChanges;
    vm.fnGetContainerQty = fnGetContainerQty;
    vm.getChargeCost = getChargeCost;
    // vm.checkPercentageBasis = checkPercentageBasis;
    // vm.deleteFreightBasisCharge = deleteFreightBasisCharge;
    // vm.showDeleteBasisCharge = showDeleteBasisCharge;

    vm.getAdditionalLeg = getAdditionalLeg;
    vm.openDeleteCard = openDeleteCard;
    vm.removeCardFromQuote = removeCardFromQuote;
    vm.cancelDeleteCard = cancelDeleteCard;
    vm.undoDeleteCard = undoDeleteCard;
    vm.fnGetLoadList = fnGetLoadList;
    vm.reduceContainerSize = reduceContainerSize;
    vm.increaseContainerSize = increaseContainerSize;
    vm.fnFormLoadArr = fnFormLoadArr;
    vm.add_lcl_air_load = add_lcl_air_load;
    vm.rm_lcl_air_load = rm_lcl_air_load;
    vm.fnSearchMetaEdit = fnSearchMetaEdit;
    vm.addNewLoad = addNewLoad;
    vm.removeFromLoad = removeFromLoad;
    vm.showRemoveIcon = showRemoveIcon;
    vm.isActiveFunction = isActiveFunction;
    vm.fnFclLoadChanged = fnFclLoadChanged;
    vm.fnAirLclLoadChanged = fnAirLclLoadChanged;
    vm.quoteCardAfterSearchChange = quoteCardAfterSearchChange;
    vm.quoteCardAfterLclAirSearchChange = quoteCardAfterLclAirSearchChange;
    vm.terms_condition_focus = terms_condition_focus;
    vm.terms_condition_key_up = terms_condition_key_up;
    vm.fnDefaultTermsAndConditions = fnDefaultTermsAndConditions;
    vm.getQuoteVersion = getQuoteVersion;
    vm.nextVersionChar = nextVersionChar;
    vm.getCardHeight = getCardHeight;
    vm.getCardFlexValue = getCardFlexValue;
    vm.ifInitQuoteModify = ifInitQuoteModify;
    vm.fnCheckCardsDetails = fnCheckCardsDetails;
    vm.fnCheckMetaDetails = fnCheckMetaDetails;
    vm.fnOpenMatchRatesModal = fnOpenMatchRatesModal;
    vm.fnOpenSetReminderModal = fnOpenSetReminderModal;
    vm.showQuoteProceedDiv = showQuoteProceedDiv;
    vm.fnCheckIsNaN = fnCheckIsNaN;
    vm.fnOpenVASModal = fnOpenVASModal;
    vm.ctrlapplyVASLegToQuoteCard = ctrlapplyVASLegToQuoteCard;
    vm.getLegDetailsForVas = getLegDetailsForVas;
    vm.fnCardStructure = fnCardStructure;
    vm.showAsterix = showAsterix;
    vm.removeLoad = removeLoad;
    vm.loadFilter = loadFilter;
    vm.validateContainerData = validateContainerData;
    vm.getPort = util.getPorts;
    vm.fnSetReminderApi = fnSetReminderApi;
    vm.getVasDetails = getVasDetails;
    vm.toggleViewMore = toggleViewMore;
    vm.fnViewQuoteList = fnViewQuoteList;
    vm.fnclosePanel = fnclosePanel;
    vm.fnDeleteData = fnDeleteData;
    vm.fclSlab=[];
    vm.currentCard = {};
    vm.selectedIndex = 0;
    vm.disableLeg = true;
    vm.currency_conversion = {};
    vm.todays = moment.utc(new Date()).format();
    vm.expMinDate = new Date(vm.search_param.cargo_ready_date);
    vm.columnsData = [];
    vm.chart = null;
    vm.deletedChargeList = [];
    vm.totalLoads = [];
    vm.getData = false;
    vm.enableResend = false;
    vm.sendingOtp = true;
    vm.otpVerified = false;
    vm.isClickEnable = true;
    vm.buyOrSell = "buy_rates";
    vm.showBookBtn = true;
    vm.ScheduleCard = {};
    vm.disableOtpBtn = true;
    vm.showSharedFooter = false;
    vm.card_data = {};
    vm.filterConfig = {};
    vm.newRateCards = [];
    vm.revise_quote = false;
    vm.isQuoteModify = false;
    vm.isSearchMetaModify = false;
    vm.selectedCheckbox=false;
    vm.isActive = false;
    vm.chargeMappingErr = {}
    vm.editQuoteMeta = {};
    vm.quoteType = "Create";
    vm.maxHeight = {
      "max-height": "200px",
    };
    vm.fnopenTermsCondition=fnopenTermsCondition;
    vm.removeValidation=removeValidation;
    vm.mappingIntergration=mappingIntergration;
    vm.checkChargeMappingRes=checkChargeMappingRes;
    vm.ifExpireCross = false;
    vm.booked_leg_type = [];
    vm.sell_rates_display = false;
    vm.schedule_display = false;
    vm.activityStatusList = ["added", "deleted", "updated", "refreshed"];
    vm.selectedStatus = "added";
    vm.getIataData = true;
    vm.isNewRatesFetach = false;
    vm.showTermsConditions = false;
    vm.isVasApplied = false;
    vm.curr_vas_leg_arr = [];
    vm.viewInquiryDetails = viewInquiryDetails;
    vm.saveQuoteTemplate = saveQuoteTemplate;
    vm.percentageOnTotalBasis = percentageOnTotalBasis;
    vm.percentageOnChargeBasis = percentageOnChargeBasis;
    vm.panelMappedExpansion=panelMappedExpansion;
    vm.newIataCards = {
      data: {
        cards: [],
        rates: [],
      },
    };
    vm.newMsrCards = {
      data: {
        cards: [],
        rates: [],
      },
    };
    vm.newNetworkCards = {
      data: {
        cards: [],
        rates: [],
      },
    };
    vm.initNewLoad = [
      {
        CBM: null,
        CFT: null,
        KGS: null,
        TON: null,
        bl_qty: 1,
        count: 1,
        load_code: null,
        load_description: null,
        type: null,
      },
    ];
    vm.matchRatesObj = {
      search_param: vm.quote_result.result_meta.search_param,
      id: vm.quote_result.result_data._id,
      match_rates: vm.quote_result.result_data.match_rates,
      quote_number: vm.quote_result.result_data.quote_id,
      additional_charges: {
        selected: [],
        available: [],
      },
    };
    vm.resultCardFilter = {
      currency_conversion_rates:
        vm.quote_result.result_data.currency_conversion_rates,
      via_route_filter: "Transhipment",
      getDataSchedule: false,
      getNetworkSchedule: false,
      getIataSchedule: vm.search_param.mode == "AIR" ? false : true,
      hideBookBtn: false,
      deviceName: "",
      generateQuoteBtn: false,
      ratesLoading: false,
      total_cost: "card_total_cost",
      buyOrSell: vm.buyOrSell,
      co2eApiCalled : false
    };

    vm.loadObj = {
      type: "",
      count: 1,
      bl_qty: 1,
      sbl_qty: 1,
      max_weight: "",
      weight_qty: 20000,
      weight_unit: "KGs",
      max_volume: "",
    };

    vm.newRateButtonObj = {
      searchParam: vm.search_param,
      source: "quote-page",
    };
    util.isCallingApi = true;
    vm.getDomainData = getDomainData;
    vm.termsTabView = termsTabView;
    vm.remarksTabView = remarksTabView;
    vm.fnDisplayProfit = fnDisplayProfit;
    vm.getConvFeeCost = getConvFeeCost;
    vm.fnopenCreateTemplate = fnopenCreateTemplate;
    vm.showConvLoader = false;
    vm.setThreeNumberDecimal = SearchService.setThreeNumberDecimal;
    vm.fnSetCharges = fnSetCharges;
    vm.newCardValidation = newCardValidation;
    vm.getExpiryMaxDate = getExpiryMaxDate;
    vm.validateExpirydate = validateExpirydate;
    vm.basisArray = [
      shareQuoteService.airBasisName,
      shareQuoteService.pickupBasisName,
      shareQuoteService.deliveryBasisName,
      shareQuoteService.freightBasisName,
    ];
    vm.goToShipmentDetail = goToShipmentDetail;
    vm.fnGetCurrencyconversion = fnGetCurrencyconversion;
    vm.fnDefaultCharge = fnDefaultCharge;
    vm.resizeScreenSize = resizeScreenSize;
    vm.fnProceedDuplicateQuote = fnProceedDuplicateQuote;
    vm.fnGetFwrdTerms = fnGetFwrdTerms;
    vm.generateQuote = generateQuote;
    vm.fnopenCopyQuotewalkthrough = fnopenCopyQuotewalkthrough;
    vm.selectedDuplicateQuote = selectedDuplicateQuote;
    vm.proceedCopyQuote = proceedCopyQuote;
    vm.updateForDuplicate = updateForDuplicate;
    vm.removeResponse = removeResponse;
    vm.trackEvent = trackEvent;
    vm.syncData=syncData;
    vm.fetchSyncData=fetchSyncData;
    vm.fnChargeSelection=fnChargeSelection;
    vm.getCustomerList=getCustomerList;
    vm.fnCustomerSelection=fnCustomerSelection;
    vm.getChargeMappingList=getChargeMappingList;
    vm.validateChargeMapping=validateChargeMapping;
    vm.customerDataValidation=customerDataValidation;
    vm.linerData = [];
    vm.destination_alias=[];
    vm.origin_alias=[];
    vm.footerObj = {
      doneBtnDisable: false,
      buyTotalWithConv: 0,
      buyTotalBaseCurr: 0,
      sellTotalBaseCurr: 0,
      profit: 0,
      rateExpired:false
    };
    vm.submitCharges = submitCharges;
    vm.fnPrevScreen=fnPrevScreen;
    vm.fnNextScreen=fnNextScreen;
    vm.validateCustomerMapping=validateCustomerMapping;
    vm.updateChargeStatus=updateChargeStatus;
    vm.showScreen = 0;
    vm.rateCardSelection=false;
    vm.selectedMenu={}
    vm.cardSelection=cardSelection;
    vm.toggleCheckbox=toggleCheckbox;
    vm.quoteTemplateType = "New";
    vm.measurementSystem = $rootScope.metric_system;
    vm.co2eResponse = {}; //co2e response
    vm.util.co2ApiLoaded = true;
    vm.freeDaysTabView = freeDaysTabView;
    vm.isFreeDaysEdit = false;
    vm.loadWiseFreeDaysList = [];
    vm.standardQuotationService = StandardQuotationService;
    vm.isStandardQuote = (vm.quote_result.result_data.generate_quote_type && vm.quote_result.result_data.generate_quote_type === 'standard') ? true : false;
    vm.standardQuoteBtn = vm.search_param.mode == 'SEA-FCL' && (vm.quote_Status=='Active' || vm.quote_Status=='Follow-up Required') && !vm.isShared && !vm.quotePreview && $rootScope.domainData.domain_info.ENABLE_STANDARD_QUOTATION && vm.isStandardQuote && util.isAdmin;
    vm.fnOpenStatusChangePanel =  fnOpenStatusChangePanel ;
    vm.fnChangeStatus = fnChangeStatus ;
    vm.fnCallStatusChangeApi = fnCallStatusChangeApi ;
    vm.getUidata=getUidata;
    vm.panelExpansion=panelExpansion;
    vm.hideStatusChange = (vm.util.isShipper || vm.util.isEfpEnabled || vm.isShared || (vm.quote_result.result_data.available_status && vm.quote_result.result_data.available_status.length < 1) );

    function resizeScreenSize() {
      vm.resultCardFilter.deviceName =
        window.innerWidth < 992
          ? "mobile"
          : util.resizeScreen(vm.resultCardFilter.deviceName);
    }
    window.onresize = vm.resizeScreenSize;
    vm.originPorts = [];
    vm.destinationPorts = [];
    vm.isDoorCardPresent = false;
    function init() {
      
      if(vm.standardQuotationService.standardQuoationData && vm.quote_result.result_data._id == vm.standardQuotationService.standardQuoationData.parent_quote_id && $rootScope.previousState == 'app.standardQuotation'){
        resetRefreshData();
        vm.loopCards(vm.quote_CardData,vm.standardQuotationService.standardQuoationData.cards);
        vm.quote_CardData = vm.standardQuotationService.standardQuoationData.cards;
        vm.quote_CardData.forEach(function (card) {
          card.meta["status"] = card.meta["status"] != "new" ? "modified" : "new";
        });
        vm.search_param = vm.standardQuotationService.standardQuoationData.search_param;
        vm.quote_result.result_data.incoterms = vm.standardQuotationService.standardQuoationData.incoterms;
        vm.quote_result.result_data.impo_expo  = vm.standardQuotationService.standardQuoationData.impo_expo; 
        vm.quote_result.result_data.customField = vm.standardQuotationService.standardQuoationData.customField; 
        vm.quote_result.result_data.terms = vm.standardQuotationService.standardQuoationData.terms; 
        vm.removedCardIdsFromSQ = vm.standardQuotationService.standardQuoationData.removedCardIds || [] 
        vm.isQuoteModify = true;
      }

        vm.quote_result.result_data.terms =  util.decodeValue(vm.quote_result.result_data.terms);

      vm.quote_CardData.forEach(function(currentCard){
        shareQuoteService.fnFillBasisMeta(currentCard.data[vm.buyOrSell],currentCard);
      });

      util.isModulePaid('quotes');
      vm.getDomainData();
      vm.authValue = vm.isShared ? null : localStorageService.get("authToken").value;
      vm.formContainerType(vm.search_param.mode, vm.search_param.load_data);
      if(vm.quote_result.result_data.template_data){
        vm.checkTemplate = true;
        vm.templateName = vm.quote_result.result_data.template_data.name;
      }
     
      resultService.setLegModeWise(vm.search_param.mode, vm.filterConfig);
      resultService.setLegFilter(vm.filterConfig, vm.search_param);
        
      vm.modeName =
        vm.search_param.mode == "SEA-FCL"
          ? "_fcl"
          : vm.search_param.mode == "AIR"
          ? "_air"
          : "_lcl";
      vm.subVendorList = [];

      vm.l3_leg = Object.keys(vm.filterConfig)[3];
      vm.l1_leg = Object.keys(vm.filterConfig)[0];
      vm.l2_leg = Object.keys(vm.filterConfig)[1];
      vm.l2_leg_cha = Object.keys(vm.filterConfig)[2];
      vm.l4_leg = Object.keys(vm.filterConfig)[4];
      vm.l4_leg_cha = Object.keys(vm.filterConfig)[5];
      vm.l5_leg = Object.keys(vm.filterConfig)[6];
      vm.ins_leg = Object.keys(vm.filterConfig)[7];
      vm.disableScheduleBtn =
        vm.quote_result.result_data.is_booked || vm.isLost || vm.quotePreview;

      if (vm.isShared) {
        setCurrentid();
        otpValidation();
        util.createUserData(
          vm.quote_result.result_data.created_by,
          vm.id,
          "quote",
          mixPanelToken
        );
      } else {
        if (!vm.quotePreview) {
          vm.getUidata();
          vm.showVasButton =
            (util.isShipper ||
              util.isAdmin ||
              util.userProfile.user.is_sales_cordinator) &&
            util.solution_type === "WLS";
          if (util.solution_type === "WLS") {
            vm.getVasDetails();
          }
        }
      }

      if (vm.quote_result.result_data.reminder) {
        vm.disableSetReminder =
          vm.quote_result.result_data.reminder.created_by.id !=
          util.userProfile.user.id
            ? true
            : false;
      }

      if ((!vm.isShared && !util.isShipper) || vm.quotePreview) {
        vm.fnGetFwrdTerms();
        vm.buyOrSell = "sell_rates";
        vm.resultCardFilter.buyOrSell = vm.buyOrSell;
      }
      //add result cards into quote cards
      addCardsFromResult();
      vm.originPorts = util.getOrigin(vm.search_param.mode,vm.quote_CardData);
      vm.destinationPorts = util.getDestination(vm.search_param.mode,vm.quote_CardData);

      vm.quote_CardData.forEach(function (card) {
        card.meta["card_total_cost"] = 0;
        card.meta["isScheduleCall"] = true;
        card.meta["missingFlag"] = [];

        // Check if door card present or not
        var  portData = card.meta.port_data;
        if(portData && portData.pickup_location || portData.pickup_pincode_ui || portData.delivery_location || portData.delivery_pincode_ui){
          vm.isDoorCardPresent = true;
        }

        for (var i in card.data[vm.buyOrSell]) {
          if (card.data[vm.buyOrSell][i].rate_obj) {
            card.meta.card_total_cost += parseFloat(
              card.data[vm.buyOrSell][i].rate_obj.leg_total_cost
            );
          }
          resultService.fnMissingFlag(card.data[vm.buyOrSell][i], card.meta);
        }
      });

      if (vm.quotePreview) {
        vm.getData = true;
      } else {
        if (vm.quote_CardData.length) {
          vm.getData = true;
        }
      }

      vm.showEditBtn =
        !vm.isShared &&
        !vm.quote_result.result_data.is_booked &&
        !vm.quote_result.result_data.revised &&
        !vm.quotePreview &&
        !vm.isLost && !vm.standardQuoteBtn;

      if (vm.isWebView) {
        // param for shipment redirection
        vm.webViewObj = {
          access_token: vm.authValue.access_token,
          web_view: "web_view",
          user_id: util.userProfile.user.id,
        };
        util.createUserData(
          vm.quote_result.result_data.created_by,
          QuotesService.quote_id,
          "quote",
          mixPanelToken
        );
        //mixpanel code
        util.callMixpanel("QD-Mobile Quotes");
      }
      util.isCallingApi = false;
      vm.fclLoadData = SearchService.getFclLoadDetails(
        vm.search_param.load_data.load_details_value
      );
      vm.fnCardStructure();
      vm.resizeScreenSize();
    }
    function loopCards(UnModifiedData,newData){
      newData.forEach(function(currentCard){
        if(!currentCard["status"])
        {
          var UnModifiedCard =   UnModifiedData.find(function(OldCardData){
            return currentCard._id == OldCardData._id
          })
          if(currentCard.data.buy_rates){
            for (var i in currentCard.data.buy_rates) {
              var value = currentCard.data.buy_rates[i];
              if(value.rate_obj){
                for (var j = 0; j < value.rate_obj.charges.length; j++) {
                  var charge = value.rate_obj.charges[j];
                if(UnModifiedCard){
                    //code for activity capture on buy rate edit
                    var UnModifiedCharge = null;
                    if(UnModifiedCard.data.buy_rates[i]){
                      UnModifiedCharge = UnModifiedCard.data.buy_rates[i].rate_obj.charges.find(function(tempUnModifiedCharge){
                        return charge.charge_basis == tempUnModifiedCharge.charge_basis && charge.container_type == tempUnModifiedCharge.container_type && charge.charge_name ==  tempUnModifiedCharge.charge_name
                      })
                    }
                    if(UnModifiedCharge && (charge.charge_currency != UnModifiedCharge.charge_currency || charge.per_unit_rate != UnModifiedCharge.per_unit_rate || charge.minimum_charge_cost != UnModifiedCharge.minimum_charge_cost || charge.maximum_charge_cost != UnModifiedCharge.maximum_charge_cost ) &&  !(charge.manual) ){
                      currentCard['meta']['buyRateEdit'] = true;
                    }
                }
                  
                }
              }
            }
          }
        }
      });
    }
    function getUidata(){
      vm.syncShimmer=true;
      QuotesService.getSyncUiData(vm.quote_result.result_data.quote_id).then(function(response){
        vm.uiData = response.data.uiData;
        var checkData =( vm.quote_result.result_data.created_for.company.external_reference_id);
        vm.uiData.integrationComponentOptions.menu.isEnabled = checkData ? vm.uiData.integrationComponentOptions.menu.isEnabled : false;
        vm.uiData.integrationComponentOptions.menu['tooltipText']= checkData ? "" : "This customer is not a part of cargowise";
        vm.syncShimmer=false;
      },function(error){
        vm.uiData =[];
        vm.syncShimmer=false
        $log.log(error);
      });
    }
    function panelExpansion() {
      vm.isPanelOpened = !vm.isPanelOpened;
    }
    function panelMappedExpansion() {
     
      vm.isMappedPanelOpened = !vm.isMappedPanelOpened;
    }
   function syncData(submenus){
    vm.selectedMenu=submenus;
    vm.rateCardSelection=true;
    vm.selectedSyncCardRef["checked"] =false;
    vm.selectedSyncCard=[]
    vm.selectedSyncCardRef={}
    vm.showScreen = 0;
//console.log(vm.quote_result)
   }
   function cardSelection(card){
    if (card.partner_reference_id) {
      util.showToast("This rate has already been used to quote. Please chose another rate card!");
      card.checked = false;
      vm.selectedSyncCardRef.checked =false;
      vm.selectedSyncCard=[]
      return;
    }
 
   }
   function toggleCheckbox(ev,item){
   
    const checked =item.checked ? false : true
   
   
    if(vm.selectedSyncCardRef && vm.selectedSyncCardRef != item ){
      vm.selectedSyncCardRef.checked =false;
      vm.selectedSyncCard=[]
    }
   
    // 
    if(checked){
    
      vm.selectedSyncCardRef=item
      vm.selectedSyncCard.push(item._id)
   
    }
    else{
      vm.selectedSyncCard=[]
      vm.selectedSyncCardRef={}
    }

  }
   function checkUnmapped(event){
    event.stopPropagation();
    
  
  
    for (var key in vm.chargeMappingObj.chargeMap) {
     vm.removeValidation(key,'_partnerCharge');
     
    
    }
   }
   function fetchSyncData(ev){
    util.isCallingApi = true;
    vm.unmappedList=[];
    const query={
      "cardId":vm.selectedSyncCard,
      "quotationID":vm.quote_result.result_data.quote_id,
      "partner":vm.selectedMenu.partner

    }
    if(vm.selectedMenu.onClick.actionType
       =='SHOW_POPUP'
      ){
      
            
        QuotesService.getMappingData(query,'quote').then(
          function (response) {
        util.isCallingApi = false;
        vm.chargeMappingObj = response.data.data
         vm.configuration=vm.selectedMenu.onClick.Configuration
         vm.mappedCharges={};
         vm.unmappedCharges={}

         for (var key in vm.chargeMappingObj.chargeMap) {
          if (vm.chargeMappingObj.chargeMap.hasOwnProperty(key)) {  
            const charge = vm.chargeMappingObj.chargeMap[key];

            if(!vm.chargeMappingObj.chargeMap[key].partner.chargeName){
              vm.unmappedList.push(key)
              vm.unmappedCharges[key]=charge
              
            }
            else{
              vm.mappedCharges[key]=charge
            }
          }
        }
        vm.showUnmappedCharge= vm.unmappedList.length > 0 ? true : false;
        vm.copyMappingObj = angular.copy(vm.chargeMappingObj);
        $mdDialog.show({
          templateUrl:
            "app/main/quotes/dialogs/quote-sync-mapping/quote-sync-mapping.html",
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: "ctrl",
            controller: function () {
              this.parent = vm;
            },
        });
          },
          function (error) {
            util.isCallingApi = false;
            vm.uiData.integrationComponentOptions.menu.isEnabled=true;
            vm.chargeMappingObj={}
            util.showToast(error.data.message);
            $log.log(error);
          }
        );

    }
   }
   function fnPrevScreen(num) {
   
      var listElements = document.querySelectorAll("ul.stepper-bar li");
      listElements.forEach(function (item, index) {
       
        if (index == num) {
          vm.showScreen=num;
          item.classList.add("active")
        }
        else {
          item.classList.remove("active")
        }
      })
      // if (num == 1) {
      //   vm.showScreen = 1;
      // }
    
  }
  function fnNextScreen(num) {
   
    var listElements = document.querySelectorAll("ul.stepper-bar li");
    listElements.forEach(function (item, index) {
      if (index == num) {
        item.classList.remove("active")
      }
      if (index + 1 == num + 1) {
        vm.showScreen=index + 1;
        item.classList.add("active")
      }
    })
   
  }
  function fnCustomerSelection(selectedCustomer){
    vm.chargeMappingObj.companyMap.partner=selectedCustomer
  }
  function getCustomerList(searchText){
    //console.log( QuotesService.getCustomerMappingList(searchText,util.userProfile.user.company.id,util.userProfile.user.company.vendor_id)
     return QuotesService.getCustomerMappingList(searchText,util.userProfile.user.company.id,util.userProfile.user.company.vendor_id
      ).then(
        function (response) {
         
          return response.data.data;
        },
        function (error) {
          $log.log(error.data);
          return error.data;
        }
      );
  }
  function fnChargeSelection(selectedCharge, key){
  vm.chargeMappingObj.chargeMap[key].partner=selectedCharge
}
function getChargeMappingList(searchText){
  return  QuotesService.getChargeMappingList(searchText,vm.search_param.mode,vm.selectedSyncCardRef.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.
    sv_id,vm.chargeMappingObj.linerMappingId);
}
function validateCustomerMapping(){
  //console.log(form);
  vm.error=0
   vm.customerDataValidation();
    
  if(vm.error || vm.customerForm.$invalid){
    return
 }else{
  vm.fnNextScreen(vm.showScreen);
 }
}
function validateChargeMapping(){
  vm.error=0
  //vm.customerDataValidation();
  vm.updateChargeStatus();
  if(vm.error || vm.chargeMappingForm.$invalid){
     return
  }else{
    vm.fnNextScreen(vm.showScreen);
    vm.mappingIntergration();
  }
}
function customerDataValidation(){
  if(!vm.chargeMappingObj.companyMap.partner.customerName){
      var element = document.getElementById("customer_mapping");
      angular.element(element).addClass("error-border-auto");
      vm.error++
      return
    }
}
function removeValidation(key,type ){
 
  var id = key + (type ? type : '');
  
  var element = document.getElementById(id);
    angular.element(element).removeClass("error-border-auto");
  // if(type=='agent'){
  //   var element = document.getElementById(key+"_agent");
  //   angular.element(element).removeClass("error-border");
  //   var code_element = document.getElementById(key+"_agent_code");
  //   angular.element(code_element).removeClass("error-border");

  //   // while changing the agent remove it's corresponding leg 
  //   vm.chargeMappingObj.chargeMap[key].serviceLeg = '';
  //  // prefilling the leg if already selected for this Agent
  //  if(vm.chargeMappingObj.chargeMap[key].agent && vm.chargeMappingObj.chargeMap[key].agent.reference_id){
  //       vm.chargeMappingObj.chargeMap[key].serviceLeg = vm.legMapping[vm.chargeMappingObj.chargeMap[key].agent.agent_name] ;
  //  }
  // }else{
  //   var element = document.getElementById(key+"_partnerCharge");
  //   angular.element(element).removeClass("error-border-auto");
  // }
}
function updateChargeStatus(){
  for (var key in vm.chargeMappingObj.chargeMap) {
    if(!vm.chargeMappingObj.chargeMap[key].partner.chargeName && !vm.chargeMappingObj.isUnmapped){
      var element = document.getElementById(key+"_partnerCharge");
      angular.element(element).addClass("error-border-auto");
    vm.error++
    vm.unmappedList.includes(key) ?  vm.isPanelOpened=true : vm.isMappedPanelOpened=true
   
    return
    }
    if (vm.chargeMappingObj.chargeMap.hasOwnProperty(key) && vm.copyMappingObj.chargeMap.hasOwnProperty(key) ) {
      
      if(vm.copyMappingObj.chargeMap[key].partner.chargeName){
      if(angular.equals(vm.copyMappingObj.chargeMap[key].partner,vm.chargeMappingObj.chargeMap[key].partner)){
       vm.chargeMappingObj.chargeMap[key].status="UNCHANGED"
      }
      else{
       vm.chargeMappingObj.chargeMap[key].status="UPDATED"
      }
      }
     else{
      if(!vm.chargeMappingObj.isUnmapped){
           vm.chargeMappingObj.chargeMap[key].status="CREATED"
      }
      else{
         vm.chargeMappingObj.chargeMap[key].status=""
      }
       
     } 
     
     }
  }
  
  
 }
 function mappingIntergration(){
 // vm.selectedMenu.partner="Cargowise"
  util.isCallingApi = true;
  var url='/api/sync/quotations?partner='+vm.selectedMenu.partner+'&id='+vm.quote_result.result_data.quote_id+'&entity=quote&cardId='+vm.selectedSyncCard[0];
  vm.chargeMappingObj.is_auto_sync =  $rootScope.domainData.domain_info.ALLOW_AUTO_SYNC
  vm.chargeMappingObj.pdf_link = QuotesService.open_pdf_link
  var config = {
   method : vm.selectedMenu.onClick.Configuration.actionHTTPMethod,
  // method:"PATCH",
   url : url, 
   data: vm.chargeMappingObj
 }

 util.cargowiseIntegration(config).then(function(response){
 util.isCallingApi = false;
  if(response.status == 200){
vm.uiData.integrationComponentOptions.menu.isEnabled=true;
    vm.selectedMenu.status_code = response.status;
    vm.selectedMenu.sync_time = response.data.data.last_synced_at;
    vm.selectedSyncCardRef.partner_reference_id=response.data.data.partner_reference_id;
   vm.selectedSyncCardRef.document_details=response.data.data.document_details
//    vm.selectedSyncCardRef.documentDetails={
//     syncedAt : "2025-02-20" ,
//     syncStatus : "SUCCESS"
// }
    //vm.selectedSyncCardRef.partner_reference_id="dfghjkl"
  vm.sendtoerrtype = response.status_code;
  var activityObj = {
    message:" Rate card was sent to  CargoWise One-Off Quote." ,
    type: "intergration",
    comment:"Cargowise Quotation Number "+response.data.data.partner_reference_id,
    timestamp: new Date(),
    user_id: util.userProfile.user.id,
    user_name:
      util.userProfile.user.user_first_name +
      " " +
      util.userProfile.user.user_last_name,
    activity_data: [],
  };
  vm.quoteActivity.activity.push(activityObj);
  if(response.data.data.document_details){
    if(response.data.data.document_details.sync_status.toLowerCase() == "success"){
      var activityObj = {
        message:"Quote PDF was sent to CargoWise One-Off Quote." ,
        type: "intergration",
        comment:"Cargowise Quotation Number "+response.data.data.partner_reference_id,
        timestamp: new Date(),
        user_id: util.userProfile.user.id,
        user_name:
          util.userProfile.user.user_first_name +
          " " +
          util.userProfile.user.user_last_name,
        activity_data: [],
      };
      vm.quoteActivity.activity.push(activityObj);
    }
    else if(response.data.data.document_details.sync_status.toLowerCase() == "failed" ){
      var activityObj = {
        message:"Failed to Sync Quote PDF to CargoWise One-Off Quote." ,
        type: "intergration",
        comment:"Cargowise Quotation Number "+response.data.data.partner_reference_id,
        timestamp: new Date(),
        user_id: util.userProfile.user.id,
        user_name:
          util.userProfile.user.user_first_name +
          " " +
          util.userProfile.user.user_last_name,
        activity_data: [],
      };
      vm.quoteActivity.activity.push(activityObj);
    }

  }
  vm.checkChargeMappingRes(response,true);
 
}


else{
 vm.checkChargeMappingRes(response,false);
 util.showToast(util.displayValidationError(response.data.message));
}
 },function(error){
  util.isCallingApi = false;
  util.showToast(util.displayValidationError(error));
  $log.log(error);
});

 }
 function checkChargeMappingRes(response,isSuccess){
 
    vm.chargeMappingErr = {
      'responseFrom': "QUOTES",
      'status': isSuccess ? "COMPLETED" : "FAILED",
      'message':response.data.display_message ,
    }
}
    function getDomainData() {
      if (!Object.keys($rootScope.domainData.domain_info).length) {
        util.getDomainData().then(
          function () {
            vm.showReferenceNumber =
              $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
            vm.gross_weight_unit =  vm.search_param.mode=='SEA-LCL' && $rootScope.domainData.domain_info.WEIGHT_UNIT && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode] && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode].gross_weight.toLowerCase() == 'kg' ? 'KG' : 'MT';

            
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.showReferenceNumber =
          $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
          vm.gross_weight_unit = vm.search_param.mode=='SEA-LCL'&& $rootScope.domainData.domain_info.WEIGHT_UNIT && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode] && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode].gross_weight.toLowerCase() == 'kg' ? 'KG' : 'MT';

      }
    }

    function loadFilter(e) {
      var found = false;
      vm.editLoadType.some(function (i) {
        if (i.type === e.load_code) {
          found = true;
          return true;
        }
      });

      if (found) {
        return false;
      } else {
        return true;
      }
    }

    function removeLoad(index) {
      if (vm.editLoadType.length === 1) {
        return;
      }
      vm.editLoadType.splice(index, 1);
    }

    function showAsterix(array) {
      var showAsterix = false;
      if (array) {
        Object.keys(array).some(function (key) {
          if (array[key].leg_code === "additional_services") {
            array[key].rate_obj.charges.some(function (i) {
              if (typeof i.charge_cost === "string") {
                showAsterix = true;
                return true;
              }
            });
          }
        });
      }
      return showAsterix;
    }

    function calculateQtyRange(charge, key) {
      var unit = charge.total_units;
      if (unit >= charge.slab[key].to) {
        return (
          charge.slab[key].to -
          (charge.slab[key - 1] ? charge.slab[key - 1].to : 0)
        );
      } else if (unit >= charge.slab[key].from) {
        return unit - charge.slab[key].from + 1;
      } else {
        return 0;
      }
    }

    function openViewDrtailFcl(ev) {
      vm.title = "Details";
      // disable ckeditor
      if(!vm.quoteEdit){
        vm.remarksInclusionCkEditorConfig.readOnly =  true;
       }
      setTimeout(function () {
        vm.scheduleDivHeight =  document.getElementsByClassName('rate-card-detail-modal')[0].offsetHeight;
      }, 100);
      var tempUrl = "";
      vm.pageSource="Quote-ViewDetails";
      if (vm.l3_leg == "l3_fcl") {
        tempUrl = "app/main/result/Dialogs/view-details/fclViewDetails.html";
      } else {
        tempUrl = "app/main/result/Dialogs/view-details/airViewDetails.html";
      }
      $mdDialog.show({
        templateUrl: tempUrl,
        targetEvent: ev,
        clickOutsideToClose: false,
        onComplete: vm.afterShowAnimation,
        animation: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        }
      });
    }
    
    function getInitData() {
      vm.getSubvendor = [];
      if (util.isAdmin || util.isFreightbro) {
        
        if (vm.search_param.mode == "AIR") {
          resultService.getAirlineData().then(
            function (response) {
              vm.getAirline = response.data.data;
            },
            function (error) {
              vm.getAirline = [];
            }
          );
        }

        var mode =
          vm.search_param.mode == "SEA-FCL"
            ? "fcl"
            : vm.search_param.mode == "AIR"
            ? "air"
            : "lcl";
        resultService.getTermsConditions(mode, "true").then(
          function (response) {
            vm.stdTermsAndConditions = util.decodeValue(response.data.terms);
          },
          function (error) {
            vm.stdTermsAndConditions = "";
          }
        );

        if (!util.getSubvendor.length) {
          resultService.getSubVendor().then(
            function (response) {
              angular.forEach(response.data.subvendor_data, function (item) {
                if (item.carrier_code != null && item.carrier_code != "") {
                  vm.getSubvendor.push(item);
                  util.getSubvendor = angular.copy(vm.getSubvendor);
                }
              });
            },
            function (error) {
              vm.getSubvendor = [];
              util.getSubvendor = [];
            }
          );
        } else {
          vm.getSubvendor = angular.copy(util.getSubvendor);
        }
      }
    }
    init();
    getInitData();
    vm.fnGetLoadList();

    // bind card leg according buyRates or SellRates data
    function fnGetLegs(cardItem) {
      var result = [];
      result = cardItem[vm.buyOrSell];
      return result;
    }

    // Set current id - by isaac
    function setCurrentid() {
      vm.id = QuotesService.quote_id;
    }

    function cancelDialog(type) {
      if(vm.disabledStatusSubmit){
        return;
      }
      if(type === "CancelTemp"){
        util.callMixpanel('QD-SaveAsTemplate-Delete-Cancel-Click','')
      }
      
      $mdDialog.hide();
      vm.dataErr = false;
      vm.otpError = "";
    }


    // functions validate OTP - by Isaac
    function otpValidation() {
      var otp = localStorage.getItem("otp");
      otp = angular.fromJson(otp);
      var time_now = new Date().getTime();

      if (!otp) {
        var i = {};
        localStorage.setItem("otp", angular.toJson(i));
        vm.showSharedFooter = true;
      } else if (!(vm.id in otp)) {
        vm.showSharedFooter = true;
      } else if (vm.id in otp) {
        var a = otp[vm.id];
        var otpToSave = a.substr(0, a.lastIndexOf("-"));
        localStorageService.otp = otpToSave;
        a = a.split("-")[a.split("-").length - 1];
        if (a - time_now > 21600000) {
          util.showToast("OTP has expired!");
          delete otp[vm.id];
          localStorage.setItem("otp", angular.toJson(otp));
          vm.showSharedFooter = true;
        } else {
          vm.showSharedFooter = false;
        }
      }

      // clean up of expired OTPs

      for (a in otp) {
        var checkTime = otp[a].split("-")[1];
        if (checkTime - time_now > 21600000) {
          delete otp[a];
          localStorage.setItem("otp", angular.toJson(otp));
        }
      }
    }

    function otpCheck() {
      vm.otpError = "";
      if (
        vm.a !== "" &&
        vm.b !== "" &&
        vm.c !== "" &&
        vm.d !== "" &&
        vm.e !== "" &&
        vm.f !== "" &&
        vm.a !== undefined &&
        vm.b !== undefined &&
        vm.c !== undefined &&
        vm.d !== undefined &&
        vm.e !== undefined &&
        vm.f !== undefined &&
        vm.a !== null &&
        vm.b !== null &&
        vm.c !== null &&
        vm.d !== null &&
        vm.e !== null &&
        vm.f !== null
      ) {
        vm.disableOtpBtn = false;
      } else {
        vm.disableOtpBtn = true;
      }
    }

    // functions check OTP - by Isaac
    function checkOtp() {
      vm.otpError = "";
      var otp = "";
      if (
        vm.a !== "" &&
        vm.b !== "" &&
        vm.c !== "" &&
        vm.d !== "" &&
        vm.e !== "" &&
        vm.f !== "" &&
        vm.a !== undefined &&
        vm.b !== undefined &&
        vm.c !== undefined &&
        vm.d !== undefined &&
        vm.e !== undefined &&
        vm.f !== undefined
      ) {
        otp = "" + vm.a + vm.b + vm.c + vm.d + vm.e + vm.f;
        var data = {
          otp: Number(otp),
        };
        vm.disableOtpBtn = true;
        QuotesService.checkQuoteOtp(QuotesService.quote_id, data).then(
          function (response) {
            if (response.data.status === "success") {
              // vm.disableOtpBtn = false;
              vm.dataErr = false;

              var retrievedObject = localStorage.getItem("otp");
              retrievedObject = angular.fromJson(retrievedObject);
              var i = vm.id;
              retrievedObject[i] =
                response.data.data.auth + "-" + new Date().getTime();
              localStorage.setItem("otp", angular.toJson(retrievedObject));
              localStorageService.otp = response.data.data.auth;
              vm.otpVerified = true;
              util.showToast("OTP verified successfully!");

              $timeout(function () {
                $mdDialog.hide();
                vm.showSharedFooter = false;
                vm.sendingOtp = true;
                vm.dataErr = false;
                vm.otpVerified = false;
                Object.keys(vm.card_data).length > 0
                  ? requestToBook(vm.card_data)
                  : null;
              }, 2000);
            }
            // vm.permission.schedule = vm.shipDetailsData.data['schedule'].permission.split('');
          },
          function (err) {
            // vm.disableOtpBtn = false;
            if (err.data.message === "invalid OTP") {
              vm.otpError = "Not a valid OTP";
              vm.a = "";
              vm.b = "";
              vm.c = "";
              vm.d = "";
              vm.e = "";
              vm.f = "";
              angular.element("#otp-input1").focus();
            } else {
              vm.dataErr = true;
            }
            util.showToast(err.data.message);

            vm.dataErr = false;
            vm.otpVerified = false;
            $log.error(err);
          }
        );
      } else {
        vm.otpError = "Not a valid OTP";
      }
    }

    // functions generate OTP - by Isaac
    function generateOtp() {
      vm.isClickEnable = false;
      vm.hereButton = false;

      if (vm.enableResend === false) {
        QuotesService.openOtpPopup("", vm);
        $timeout(function () {
          vm.enableResend = true;
        }, 60000);
      } else {
        vm.otpError = "";
        vm.a = "";
        vm.b = "";
        vm.c = "";
        vm.d = "";
        vm.e = "";
        vm.f = "";
        vm.enableResend = false;
      }
      vm.sendingOtp = true;
      QuotesService.getQuoteOtp(QuotesService.quote_id).then(
        function (response) {
          if (response.data.status === "success") {
            vm.sendingOtp = false;
            vm.dataErr = false;
            vm.isClickEnable = true;
            // $timeout(function () {
            //     $mdDialog.hide();
            // }, 250);
          }
          // vm.permission.schedule = vm.shipDetailsData.data['schedule'].permission.split('');
        },
        function (err) {
          util.showToast(err.data.message);
          vm.dataErr = true;
          vm.isClickEnable = true;
          $log.error(err);
          $timeout(function () {
            $mdDialog.hide();
            vm.sendingOtp = true;
            vm.dataErr = false;
          }, 2000);
        }
      );
    }

    function printDiv(printLink) {
      // $window.print();
      $window.open(util.sanitizeQueryParams(printLink), "pdfLink");
      // a.focus();
    }

    //function to form load details
    function formContainerType(mode, loadDetails) {
      var result = "";
      if (mode == "SEA-FCL") {
        result = util.formLoadDetails(loadDetails);
        vm.loadDispaly = result;
        vm.loadTooltip = vm.loadDispaly;
      } else if (mode != "SEA-FCL") {
        result = util.formAirLoadDetails(loadDetails, mode);
        vm.loadDispaly = result;
        vm.loadTooltip = vm.loadDispaly.split("| ").join("</br>");
      }
    }

    //open modal to view card details
    function viewDetailsModal(currCard, ev, activeTab, msrOrNetwork) {

      if((vm.isShared || util.isShipper) && !currCard.data.sell_rates){
        currCard.data.sell_rates = angular.copy(currCard.data.buy_rates);
      }
      // REQUEST BOOKING FRO SHIPPER
      vm.btnShipperBooking = false;
      //  ( (vm.util.navPermission.shipments[0] && vm.showBookBtn) || vm.isShared ) &&
      //   !vm.copyquoted &&
      //   !vm.proceedduplicate
      //     ? true
      //     : false;

      // if (vm.btnShipperBooking) {

      //   vm.btnShipperBooking =
      //   ((currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj
      //   .expiry && vm.util.getStatusData(
      //         currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj
      //       ) != "EXPIRED") || !currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj
      //       .expiry) &&
      //       !vm.quotePreview &&
      //       !vm.quote_result.result_data.is_booked &&
      //       !vm.isquotemodify &&
      //       !vm.quote_result.result_data.revised &&
      //       !vm.isLost &&
      //       !vm.isExpired
          
      //       ? true
      //       : false;
      // }

      if (currCard.meta.shimmer) {
        return true;
      }

      vm.footerObj.doneBtnDisable = false;
      vm.rem_open = true;
      vm.inl_open = true;
      vm.addOrEditCard = activeTab;
      vm.quoteEdit = false;
      vm.editBuyRate = false;
      vm.allowEditMainData = false;
      vm.msrOrNetwork = msrOrNetwork;

      vm.fclSlab = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab_charges;

      // condition to show slab tab
      if(vm.search_param.mode == 'AIR' && (util.isAdmin || util.isFreightbro) ){
        vm.ratesVisible = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab_rate ? 1 : 0;
      }else if(vm.search_param.mode == 'SEA-FCL' && (util.isAdmin || util.isFreightbro) ){
        vm.ratesVisible = vm.fclSlab && vm.fclSlab.length ? 1 : 0;
      }else{
        vm.ratesVisible = 0;
      }
      
      vm.airScheduleVisible = vm.search_param.mode == "AIR" ? 1 : 0;
      vm.scheduleVisible = vm.search_param.mode != "AIR" ? 1 : 0;
      vm.analyticsVisible = 0;
      vm.quotationVisible = 1;
      vm.termsVisible = !vm.maskLiner && currCard.meta.type.includes("spot") && (currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data || currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.url) ? 1 : 0;

      if (activeTab == "rates" && vm.ratesVisible) {
        vm.selectedIndex = 0;
      }
      if (activeTab == "schedule") {
        vm.selectedIndex = vm.ratesVisible;
      }
      if (
        activeTab == "quotationEdit" ||
        activeTab == "addNewQuote" ||
        activeTab == "quotation"
      ) {
        vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible;
      }
      if (activeTab == "tnc") {
        vm.selectedIndex =
        (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible + (vm.quotationVisible ? 2 : 0);
      }

      if (
        activeTab == "addNewQuote" ||
        activeTab == "quotationEdit" ||
        activeTab == "schedule"
      ) {
        vm.quoteEdit = true;
        // vm.ratesVisible = false;
        vm.getData = true;
        vm.resultCardFilter.getDataSchedule = true;
        vm.editBuyRate = true;
        currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry = currCard.data
          .sell_rates[vm.l3_leg].rate_obj.expiry
          ? moment(currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry).format(
              "YYYY-MM-DD"
            )
          : null; //popup meta expiry date for new card

        if (activeTab == "addNewQuote" || activeTab == "schedule") {
          var validation = vm.newCardValidation(currCard);

          if (validation) {
            return;
          }
        } else if (activeTab == "quotationEdit") {
          vm.allowEditMainData = true;
        }
      } else if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
        vm.quoteEdit = true;
        // vm.ratesVisible = (vm.isShared || util.isShipper) ? true : false;
        vm.getData = true;
        vm.resultCardFilter.getDataSchedule = true;

        vm.editBuyRate = util.userProfile.user.allow_edit ? true : false;

        var count = 1;
        if (
          vm.search_param.mode == "SEA-FCL" &&
          currCard.data.buy_rates[vm.l3_leg].rate_obj.is_special &&
          currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
            .max_qty_per_shipment != null
        ) {
          for (var j in currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
            .max_qty_per_shipment) {
            for (
              var i = 0;
              i < vm.search_param.load_data.load_details_value.length;
              i++
            ) {
              if (
                vm.search_param.load_data.load_details_value[i].type == j &&
                vm.search_param.load_data.load_details_value[i].qty >
                  currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
                    .max_qty_per_shipment[j]
              ) {
                if (vm.selectedIndex == 3) {
                  util.showToast(
                    "Max quantity allowed for " +
                      j +
                      " is " +
                      currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
                        .max_qty_per_shipment[j]
                  );
                  count = 0;
                }
                vm.quotationVisible = false;
                break;
              }
            }
            if (count === 0) {
              break;
            }
          }

          if (count === 0) {
            return;
          }
        }
      }

      var getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
        function (element) {
          return element.vendor_id == currCard.meta.vendor_id;
        }
      );

      shareQuoteService.currencyConverter = {}; //Reset currency converter setting
      if (!getCurrencyRate) {
        vm.fnGetCurrencyconversion(
          vm.searchUser.user_base_currency,
          currCard.meta.vendor_id
        );
        currCard.meta.conversionRate = vm.currencyObj;
      } else {
        vm.currency_rates = getCurrencyRate.curr_data;
        currCard.meta.conversionRate = getCurrencyRate;
        vm.callingConversionApi = false;
        // Currency conversion setting code
        shareQuoteService.setCurrencyConvSetting(
          vm.searchUser.user_base_currency,
          getCurrencyRate.markup,
          getCurrencyRate.directCurrencyMapping,
          vm.currency_rates
        );
      }
      $rootScope.loadingDetails = true;
      vm.showData = true;
      vm.ScheduleCard = currCard;
      if (vm.search_param.mode == "AIR" && (util.isShipper || vm.isShared)) {
        vm.displayRates = true;
      } else if (
        vm.search_param.mode != "AIR" &&
        (util.isShipper || vm.isShared)
      ) {
        vm.displayRates = false;
      }

      // Conveniance fee
      vm.getConvFeeCost(currCard);

      vm.currentCard = angular.copy(currCard);

      getDataForExchangeRate();

      // Get Dim leg list
      vm.dimLegList = [];
      vm.dimLegList = shareQuoteService.fnGetDimLegs(
        vm.currentCard.data.buy_rates
      );

      vm.legSuggestionList = [];
      vm.footerObj.sellTotalBaseCurr = 0;
      vm.chargeShow = 5;

      if (vm.search_param.mode == "SEA-FCL" && (SearchService.loadTypeArr == undefined || SearchService.loadTypeArr.length == 0)) {
        SearchService.getAllLoadList().then(
          function (response) {
            SearchService.loadTypeArr = response;
            vm.loadTypeArr = response;
            util.limitObj = response;
            openViewDrtailFcl(ev);
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.loadTypeArr = SearchService.loadTypeArr != undefined ? SearchService.loadTypeArr : [];
        openViewDrtailFcl(ev);
      }
    }

    function fnclosePanel(){
      $mdDialog.hide();
    }

    // call conversion rates api
    function fnGetCurrencyconversion(user_base_currency, vendor_id, action) {
      vm.callingConversionApi = true;
      return resultService
        .getCurrencyConversionForVendor(user_base_currency, vendor_id,vm.search_param.mode,true)
        .then(
          function (response) {
            vm.currencyObj = response.data;
            vm.resultCardFilter.currency_conversion_rates.push(vm.currencyObj);
            vm.callingConversionApi = false;
            if (action == "addNewCard") {
              vm.fnDefaultCharge();
            }
            vm.currency_rates = vm.currencyObj.curr_data;
            // Currency conversion setting code
            shareQuoteService.setCurrencyConvSetting(
              vm.searchUser.user_base_currency,
              vm.currencyObj.markup,
              vm.currencyObj.directCurrencyMapping,
              vm.currency_rates
            );
          },
          function (error) {
            // Currency conversion setting code
            shareQuoteService.setCurrencyConvSetting(
              vm.searchUser.user_base_currency,
              null,
              [],
              vm.currency_rates
            );
            vm.callingConversionApi = false;
            $log.log(error.data);
            util.showToast(util.displayValidationError(error));
          }
        );
    }

    function getDataForExchangeRate() {
      vm.resultId = vm.quotePreview
        ? vm.quote_result.result_data.exchangeRateId
        : vm.quote_result.result_data._id;
      vm.cardVendorId = vm.currentCard.meta.vendor_id;
      vm.resultType = vm.quotePreview
        ? vm.quote_result.result_data.quoteFrom
        : "Quote";
      vm.activityId = vm.quote_result.result_data.activityId;
      vm.showExchangeRates =
        $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;
    }



    //Conveniance fee code
    function getConvFeeCost(currCard) {
      if (
        vm.search_param.mode == "SEA-FCL" &&
        currCard.meta.additional_charges
      ) {
        if (
          currCard.meta.additional_charges.url &&
          !currCard.meta.additional_charges.data && !vm.isShared
        ) {
          var total_cost = vm.rateTotalCustomCurr(currCard.data.buy_rates);
          vm.showConvLoader = true;
          vm.footerObj.doneBtnDisable = true;
          resultService
            .getConvFee(
              currCard,
              total_cost,
              SearchService.FclResult._id,
              currCard.data.buy_rates[vm.l3_leg].rate_obj.leg_total_currency
            )
            .then(
              function (response) {
                vm.fnDisplayProfit(); // calling dispay profit only in quotation tab
                vm.currentCard.meta.additional_charges = angular.copy(currCard.meta.additional_charges);
                vm.showConvLoader = false;
                vm.footerObj.doneBtnDisable = false;
              },
              function (error) {
                vm.showConvLoader = false;
                vm.footerObj.doneBtnDisable = false;
                $log.error(error);
              }
            );
        }
      }
    }

    //Calculate profit
    function fnDisplayProfit() {
      vm.footerObj.buyTotalWithConv = 0;
      vm.footerObj.buyTotalBaseCurr = vm.rateTotalCustomCurr(
        vm.currentCard.data.buy_rates
      );
      vm.footerObj.sellTotalBaseCurr = vm.rateTotalCustomCurr(
        vm.currentCard.data.sell_rates
      );
      // Add Conveinance fee if present
      if (
        vm.currentCard.meta.additional_charges &&
        vm.currentCard.meta.additional_charges.data
      ) {
        vm.footerObj.buyTotalWithConv =
          vm.footerObj.buyTotalBaseCurr +
          parseFloat(
            vm.currentCard.meta.additional_charges.data.leg_total_cost
          );
      } else {
        vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr;
      }
      vm.footerObj.profit = util.getProfitValue(
        vm.footerObj.sellTotalBaseCurr,
        vm.footerObj.buyTotalWithConv
      );
    }

    function afterShowAnimation() {
      $rootScope.loadingDetails = false;
      vm.showData = false;
    }

    function rateTabView() {
      vm.legShow = 1;
      vm.viewActiveTab = "rates";

      if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
        vm.rateDetails = vm.currentCard.data.buy_rates;
      } else {
        vm.rateDetails = vm.currentCard.data[vm.buyOrSell];
      }
      util.callMixpanel("QD-FclSlabTab-Click",{
        "Mode": vm.search_param.mode,
        "Type": vm.resultType
      });
    }

    function scheduleTabView() {
      vm.viewActiveTab = "schedule";
      vm.getSchedule = false;
      if (
        vm.addOrEditCard == "addNewQuote" ||
        vm.addOrEditCard == "quotationEdit" ||
        vm.addOrEditCard == "schedule"
      ) {
        if (
          !vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data
            .length
        ) {
          var l3_obj = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj;
          var cargo_date = $filter("date")(new Date(), "yyyy-MM-dd");

          vm.currentCard.meta.port_data.origin_portname =
            vm.currentCard.meta.port_data.origin_port_code &&
            vm.currentCard.meta.port_data.origin_port_code["portname"]
              ? vm.currentCard.meta.port_data.origin_port_code["portname"]
              : vm.currentCard.meta.port_data.origin_portname;

          var origin =
            vm.currentCard.meta.port_data.origin_port_code &&
            vm.currentCard.meta.port_data.origin_port_code["global_port_code"]
              ? vm.currentCard.meta.port_data.origin_port_code[
                  "global_port_code"
                ]
              : vm.currentCard.meta.port_data.origin_port_code;

          var via_pol =
            vm.currentCard.meta.via_pol &&
            vm.currentCard.meta.via_pol["global_port_code"]
              ? vm.currentCard.meta.via_pol["global_port_code"]
              : vm.currentCard.meta.via_pol;

          vm.currentCard.meta.port_data.destination_portname =
            vm.currentCard.meta.port_data.destination_port_code &&
            vm.currentCard.meta.port_data.destination_port_code["portname"]
              ? vm.currentCard.meta.port_data.destination_port_code["portname"]
              : vm.currentCard.meta.port_data.destination_portname;

          var destination =
            vm.currentCard.meta.port_data.destination_port_code &&
            vm.currentCard.meta.port_data.destination_port_code[
              "global_port_code"
            ]
              ? vm.currentCard.meta.port_data.destination_port_code[
                  "global_port_code"
                ]
              : vm.currentCard.meta.port_data.destination_port_code;

          var via_pod =
            vm.currentCard.meta.via_pod &&
            vm.currentCard.meta.via_pod["global_port_code"]
              ? vm.currentCard.meta.via_pod["global_port_code"]
              : vm.currentCard.meta.via_pod;

          var scheduleUrl =
            api.baseUrl +
            "/api/schedules?from_port=" +
            origin +
            "&to_port=" +
            destination +
            "&carrier_code=" +
            l3_obj.sub_vendor.schedule_provider_code +
            "&from_date=" +
            cargo_date +
            "&mode=" +
            vm.search_param.mode;

          if (via_pol) {
            scheduleUrl += "&via_pol=" + via_pol;
          }
          if (via_pod) {
            scheduleUrl += "&via_pod=" + via_pod;
          }

          return QuotesService.getScheduleList(scheduleUrl).then(
            function (response) {
              vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data = angular.copy(response);
              vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = angular.copy(response);
              vm.scheduleList = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;
              var selectedSchedule = null;
              if(resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
                // var selectedScheduleIndex = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(vm.currentCard, vm.l3_leg) : 0;
                vm.currentCard.meta.selected_schedule = vm.scheduleList.length ? angular.copy(vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data[0]) : null;
               }else{
                angular.forEach(vm.scheduleList, function(item){
                  if(!selectedSchedule){
                    selectedSchedule = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
                  }
                });
              }
                
              vm.current_schedule = vm.currentCard.meta.selected_schedule ? angular.copy(vm.currentCard.meta.selected_schedule) : selectedSchedule;
              if(vm.current_schedule !== null && resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
                vm.selectedSchedule(vm.current_schedule, 'fromNewSchedule');
              }
              vm.getSchedule = true;
            },
            function (error) {
              vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data =
                [];
              vm.getSchedule = true;
              $log.log(error);
            }
          );
        } else {
          vm.scheduleList = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data;
          var selectedSchedule = null;
            if(resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
              // var selectedScheduleIndex = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(vm.currentCard, vm.l3_leg) : 0;
              vm.currentCard.meta.selected_schedule = vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule : (vm.scheduleList.length ? angular.copy(vm.scheduleList[0]) : null);
            }else{
              angular.forEach(vm.scheduleList, function(item){
                if(!selectedSchedule){
                  selectedSchedule = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
                }
              });
            }
            vm.current_schedule = vm.currentCard.meta.selected_schedule ? angular.copy(vm.currentCard.meta.selected_schedule) : selectedSchedule;
            if(vm.current_schedule !== null && resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
              vm.selectedSchedule(vm.current_schedule, 'fromNewSchedule');
            }
          vm.getSchedule = true;
        }
      } else {
        if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
          vm.scheduleList =
            vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;
        } else {
          vm.scheduleList =
            vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data;
        }

        vm.current_schedule = vm.currentCard.meta.selected_schedule;
        vm.getSchedule = true;
      }

      vm.multi_schedule_list = vm.currentCard.meta.multi_schedule_list || [];
      // storing old rates schedule on multi list
      if(vm.current_schedule && vm.current_schedule.schedule_track){
        if(!vm.multi_schedule_list.length){
            vm.current_schedule["isSelected"] = true;
            vm.multi_schedule_list.push(vm.current_schedule);
        }
      }

      if ((util.isShipper || vm.isShared) && vm.scheduleList.length) {
        vm.scheduleList = [];
        if(vm.current_schedule || vm.multi_schedule_list.length){
          vm.scheduleList = vm.multi_schedule_list;

          angular.forEach(vm.scheduleList ,function(scheduleFromDB){
            angular.forEach(vm.multi_schedule_list ,function(scheduleFromMulti){
              if(scheduleFromDB.id == scheduleFromMulti.id){
                scheduleFromDB["isSelected"] = true
              }
            });
          });
        }
      }

      var leg_expiry =
        vm.addOrEditCard == "rates" && vm.msrOrNetwork
          ? vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.expiry
          : vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry;

      if (
        vm.current_schedule != null &&
        vm.current_schedule.departure_time > leg_expiry
      ) {
        vm.ifExpireCross = true;
      } else {
        vm.ifExpireCross = false;
      }


   
    }

    function quotationTabView() {
      vm.legShow = 1;
      // vm.showData = true;
      vm.viewActiveTab = "quotation";
      vm.showChargesInfo = false;

      if (!util.isAdmin && !util.isFreightbro) {
        vm.currentCard.data.sell_rates = angular.copy(
          vm.currentCard.data.buy_rates
        );
      }

      angular.forEach(vm.currentCard.data.buy_rates, function (value, key) {
        if (!value.rate_obj) {
          delete vm.currentCard.data.buy_rates[key];
        }
      });

      if (
        vm.addOrEditCard == "rates" &&
        vm.msrOrNetwork &&
        !vm.currentCard.data.sell_rates
      ) {
        var temp_sellRates = angular.copy(vm.currentCard.data.buy_rates);

        angular.forEach(temp_sellRates, function (value, key) {
          value.buy_rate_id = value.rate_id;
          delete value.rate_id;

          if (
            vm.search_param.mode == "AIR" &&
            vm.currentCard.meta.type == "iata_rates" &&
            !value.rate_obj.hasOwnProperty("iataCommission")
          ) {
            value.rate_obj["iataCommission"] = true;
          }

          vm.fnSetCharges(key, value, "rates");
        });

        vm.ScheduleCard.data.sell_rates = angular.copy(temp_sellRates);
        vm.currentCard.data.sell_rates = angular.copy(temp_sellRates);

        vm.ScheduleCard.meta["inclusions"] =
          resultService.getCardRemarksInclusion(temp_sellRates, "INCLUSIONS");
        vm.ScheduleCard.meta["remarks"] = resultService.getCardRemarksInclusion(
          temp_sellRates,
          "REMARKS"
        );
        vm.currentCard.meta = angular.copy(vm.ScheduleCard.meta);
      } else {
        angular.forEach(vm.currentCard.data.sell_rates, function (value, key) {
          if (!value.rate_obj) {
            delete vm.currentCard.data.sell_rates[key];
          }
        });

        var temp_sellRates = angular.copy(vm.currentCard.data.sell_rates);

        angular.forEach(temp_sellRates, function (value, key) {
          if (!vm.currentCard.data.buy_rates.hasOwnProperty(key)) {
            vm.currentCard.data.buy_rates[key] = angular.copy(vm.cardLegData);
            vm.currentCard.data.buy_rates[key].leg_name = value.leg_name;
            vm.currentCard.data.buy_rates[key].leg_code = key;
            vm.currentCard.data.buy_rates[key].rate_obj.leg_name =
              value.leg_name;
            vm.currentCard.data.buy_rates[key].rate_obj.leg_code = key;
          }

          vm.fnSetCharges(key, value);
        });
        vm.currentCard.data.sell_rates = angular.copy(temp_sellRates);
        vm.ScheduleCard.data.sell_rates = angular.copy(temp_sellRates);
      }
      vm.showChargesInfo = true;
    }

    function remarksTabView() {
      vm.viewActiveTab = "remarksInclusion";
      if(!(util.isSharedQuote() || util.isSharedPage())){
        vm.isOwnVendorRate = util.isOwnVendorRate(vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.vendor_id);

      }
      vm.hideInternalRemarks =  !vm.isOwnVendorRate || util.isSharedQuote() || util.isSharedPage() ;
    }

    function termsTabView() {
      vm.viewActiveTab = "Terms";
      vm.termsShimmer = true;
      if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
        vm.l3_termsCondition =
          vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition;
      } else {
        vm.l3_termsCondition =
          vm.currentCard.data[vm.buyOrSell][
            vm.l3_leg
          ].rate_obj.terms_and_condition;
      }

      if (!vm.l3_termsCondition.data && vm.l3_termsCondition.url) {
        return resultService.getCardTerms(vm.l3_termsCondition.url).then(
          function (response) {
            vm.l3_termsCondition.data = angular.copy(response.data.data);

            if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
              vm.ScheduleCard.data.buy_rates[
                vm.l3_leg
              ].rate_obj.terms_and_condition.data = angular.copy(
                response.data.data
              );
            } else {
              vm.ScheduleCard.data[vm.buyOrSell][
                vm.l3_leg
              ].rate_obj.terms_and_condition.data = angular.copy(
                response.data.data
              );
            }
            vm.termsData =
              vm.l3_termsCondition.data["terms_and_condition_data"];
            vm.termsShimmer = false;
          },
          function (error) {
            vm.l3_termsCondition.data = null;
            vm.termsData = null;
            vm.termsShimmer = false;
            $log.log(error);
          }
        );
      } else {
        vm.termsData = vm.l3_termsCondition.data["terms_and_condition_data"];
        vm.termsShimmer = false;
      }

      //mixpanel code
      util.callMixpanel("QD-T&CTab-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
    }

    function airScheduleTabView() {
      util.callMixpanel("QD-AirSchTab-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
      vm.viewActiveTab = "airline schedule";
  
      vm.scheduleList = vm.currentCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.schedule.data;
      vm.getSchedule = true;

      var selectedSchedule = null
      if(!resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
         angular.forEach(vm.scheduleList, function(item){
         if(!selectedSchedule){
           selectedSchedule = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
           }
         });
       }

      vm.current_schedule = vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule : selectedSchedule;
      vm.display_airlineName =
        vm.ScheduleCard.data.buy_rates.l3_air.rate_obj.airline.air_line_name;
    }

    function fnopenTermsCondition(ev){
      vm.termsCondition= util.decodeValue(vm.quote_result.result_data.terms);
      vm.quoteType='quote'
      util.callMixpanel('QD-ViewMore-Click');
      $mdDialog.show({
        template        :'<md-dialog id="copy-quote-popup" class="popup-md"><terms-condition-popup  quote-type="vm.quoteType" terms-condition="vm.termsCondition" callback="vm.submitTermsCondition(data)"></terms-condition-popup></md-dialog>',
        clickOutsideToClose: false,
        parent: $rootElement,
        scope: $scope,
        controllerAs: 'ctrl',
        preserveScope: true,
        controller: function () { this.parent = vm },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        }
      });

    }
    // set sell rates charges
    function fnSetCharges(key, value, action) {
      angular.forEach(value.rate_obj.charges, function (childValue) {
        if (action == "rates") {
          var getCharge = vm.currentCard.data.buy_rates[
            value.leg_code
          ].rate_obj.charges.find(function (element) {
            return element.charge_id == childValue.charge_id;
          });

          if (!getCharge) {
            var newBuyCharge = angular.copy(childValue);
            newBuyCharge.per_unit_rate = 0;
            newBuyCharge.charge_cost = 0;
            newBuyCharge.minimum_charge_cost = '';
            newBuyCharge.maximum_charge_cost = '';
            newBuyCharge.customer_currency_cost = 0;
            newBuyCharge.leg_currency_cost = 0;

            vm.currentCard.data.buy_rates[value.leg_code].rate_obj.charges.push(
              newBuyCharge
            );

            var getCard = vm.temp_quoteData.result_data.cards.find(function (
              element
            ) {
              return element._id == vm.currentCard._id;
            });

            if (getCard) {
              var newBuyCard = angular.copy(getCard.data.buy_rates);

              if (!newBuyCard.hasOwnProperty(value.leg_code)) {
                newBuyCard[value.leg_code] =
                  vm.currentCard.data.buy_rates[value.leg_code];
              } else {
                var getCharge = newBuyCard[
                  value.leg_code
                ].rate_obj.charges.find(function (element) {
                  return element.charge_id == childValue.charge_id;
                });

                if (!getCharge) {
                  newBuyCard[value.leg_code].rate_obj.charges.push(
                    newBuyCharge
                  );
                }
              }

              getCard.data.buy_rates = angular.copy(newBuyCard);
            }
          }
        }

        if (childValue.charge_basis == "per shpt") {
          childValue.charge_basis == "per shipment";
        }

        if (vm.search_param.mode != "SEA-FCL") {
          if (
            key == "l3_air" &&
            childValue.global_charge_id != null &&
            childValue.global_charge_id != "" &&
            childValue.global_charge_id.indexOf(
              shareQuoteService.airChargeId
            ) >= 0
          ) {
            vm.currentCard.meta["AirFreight"] = childValue;
          }

          if (
            key == "l1_lcl" &&
            childValue.global_charge_id &&
            childValue.global_charge_id.indexOf(
              shareQuoteService.pickupChargeId
            ) >= 0
          ) {
            vm.ScheduleCard.meta["pickupCharge"] = angular.copy(childValue);
          }
          if (
            key == "l5_lcl" &&
            childValue.global_charge_id &&
            childValue.global_charge_id.indexOf(
              shareQuoteService.deliveryChargeId
            ) >= 0
          ) {
            vm.ScheduleCard.meta["deliveryCharge"] = angular.copy(childValue);
          }
        }
      });
    }

    // new card validation toast
    function newCardValidation(currCard) {
      if (
        vm.search_param.mode != "AIR" &&
        !currCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id
      ) {
        util.showToast("Please select liner name.");
        return true;
      } else if (
        vm.search_param.mode == "AIR" &&
        !currCard.data.sell_rates[vm.l3_leg].rate_obj.airline_code
      ) {
        util.showToast("Please select airline name.");
        return true;
      }

      if (!currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry) {
        util.showToast("Please select expiry date.");
        return true;
      }

      // Origin
      if (!vm.quoteNewCard.meta.port_data.origin_port_code) {
        if (vm.quoteNewCard.meta.port_data.is_icd_port_origin) {
          util.showToast("Please select valid origin port.");
        } else {
          util.showToast("Please select valid loading port.");
        }
        return true;
      }

      // origin haulage validation
      if (
        vm.search_param.mode == "SEA-FCL" &&
        vm.quoteNewCard.meta.port_data.is_icd_port_origin &&
        !vm.quoteNewCard.meta.haulage
      ) {
        util.showToast("Please select valid origin haulage.");
        return true;
      }

      // pol validation
      if (
        vm.quoteNewCard.meta.port_data.is_icd_port_origin &&
        !vm.quoteNewCard.meta.via_pol
      ) {
        util.showToast("Please select valid loading port.");
        return true;
      }

      // pod validation
      if (
        vm.quoteNewCard.meta.port_data.is_icd_port_destination &&
        !vm.quoteNewCard.meta.via_pod
      ) {
        util.showToast("Please select valid Discharge port.");
        return true;
      }

      // destination haulage validation
      if (
        vm.search_param.mode == "SEA-FCL" &&
        vm.quoteNewCard.meta.port_data.is_icd_port_destination &&
        !vm.quoteNewCard.meta.destination_haulage
      ) {
        util.showToast("Please select destination haulage.");
        return true;
      }

      // Destination port
      if (!vm.quoteNewCard.meta.port_data.destination_port_code) {
        if (vm.quoteNewCard.meta.port_data.is_icd_port_destination) {
          util.showToast("Please select valid destination port.");
        } else {
          util.showToast("Please select valid discharge port.");
        }
        return true;
      }
      if(QuotesService.samePortValidation(currCard)){
        return true;
      }
    }

    function loadMoreRecords() {
      vm.chargeShow += 2;
    }

    // get card leg user base currency total
    function rateTotalCustomCurr(cards) {
      var convertTotal = 0;
      angular.forEach(cards, function (value) {
        if (value.rate_obj) {
          convertTotal += parseFloat(value.rate_obj.leg_total_cost);
        }
      });

      if($rootScope &&$rootScope.precision_decimals){
        convertTotal = $filter('number')(convertTotal, $rootScope.precision_decimals);
        }else{
          convertTotal = $filter('number')(convertTotal, 2);
        }      
      convertTotal = Number(convertTotal.split(",").join(""));
      return convertTotal;
    }

    //for freightbro user can select schedule
    function selectedSchedule(scheduleObj, from) {
      vm.currentCard.meta.selected_schedule = scheduleObj;
      vm.currentCard.meta["multi_schedule_list"] = vm.multi_schedule_list;

      if (vm.addOrEditCard == "addNewQuote" || vm.addOrEditCard == "schedule") {
        vm.quoteNewCard.meta.selected_schedule = angular.copy(scheduleObj);
        vm.quoteNewCard.meta["multi_schedule_list"] = angular.copy(vm.multi_schedule_list);
        vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data =
          vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;

        vm.quoteNewCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data =
          vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;
      } else {
        var getCardData = $filter("filter")(
          vm.quote_CardData,
          { _id: vm.currentCard._id },
          true
        );
        vm.ScheduleCard.meta.selected_schedule = scheduleObj;
        vm.ScheduleCard.meta["multi_schedule_list"] = vm.multi_schedule_list;

        if (getCardData.length) {
          var index = vm.quote_CardData.indexOf(getCardData[0]);

          if (
            !angular.equals(
              vm.quote_CardData[index].meta.selected_schedule,
              scheduleObj
            ) || !angular.equals(
              vm.quote_CardData[index].meta["multi_schedule_list"],
              vm.multi_schedule_list
            )
          ) {
            vm.isQuoteModify = true;
          }
          vm.quote_CardData[index].meta.selected_schedule =
            angular.copy(scheduleObj);

          vm.quote_CardData[index].meta["multi_schedule_list"] =
            angular.copy(vm.multi_schedule_list);

          vm.quote_CardData[index].data.sell_rates[
            vm.l3_leg
          ].rate_obj.schedule.data =
            vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;

          vm.quote_CardData[index].data.buy_rates[
            vm.l3_leg
          ].rate_obj.schedule.data =
            vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;
        }
      }
      vm.ScheduleCard.meta.isScheduleCall = false;
      $timeout(function () {
        vm.ScheduleCard.meta.isScheduleCall = true;
      },50)
      vm.schedule_display = true;
      if (from != "fromNewSchedule" && vm.search_param.mode == 'AIR') {
        $mdDialog.hide();
      }

      //mixpanel code
      util.callMixpanel("QD-SchSelectButton-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
    }

    //for freightbro user can set schedule
    function setCurrentSchedule(current_schedule, index) {
      if(vm.disableScheduleBtn){
        current_schedule["isSelected"] = false;
        return;
      }
      if(!current_schedule.isSelected && vm.search_param.mode != "AIR"){
        current_schedule["isSelected"] = true;
        vm.multi_schedule_list.push(current_schedule);
      }
      vm.current_schedule = current_schedule;
      var l3expiryDate = "";
      if (!vm.ScheduleCard.data[vm.buyOrSell]) {
        l3expiryDate =
          vm.ScheduleCard.data["buy_rates"][vm.l3_leg].rate_obj.expiry;
      } else {
        l3expiryDate =
          vm.ScheduleCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry;
      }
      if (
        vm.current_schedule != null &&
        vm.current_schedule.departure_time > l3expiryDate
      ) {
        vm.ifExpireCross = true;
      } else {
        vm.ifExpireCross = false;
      }

      var cardIndex = index + 1;
      //mixpanel code
      util.callMixpanel("QD-SchListingCard", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
        CardIndex: cardIndex,
      });
      if(vm.search_param.mode != "AIR"){
        vm.selectedSchedule(vm.current_schedule);
      }
    }

    //function to request tyhe booking data
    function requestToBook(card_item) {
      if (
        (card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry &&
          util.getStatusData(card_item.data.buy_rates[vm.l3_leg].rate_obj) ==
            "EXPIRED") ||
        vm.quotePreeview ||
        vm.quote_result.result_data.is_booked ||
        vm.isQuoteModify ||
        vm.quote_result.result_data.revised ||
        vm.isLost ||
        vm.isExpired
      ) {
        util.showToast("Sorry, booking not allowed from this card.");
        return true;
      }

      vm.card_data = card_item;
      if (vm.showSharedFooter) {
        vm.generateOtp();
        return;
      }

      angular.forEach(card_item.data[vm.buyOrSell], function (value) {
        vm.booked_leg_type.push(value.leg_code);
      });

      card_item.meta["conversionRate"] = resultService.fnGetConversionRates(
        vm.resultCardFilter.currency_conversion_rates,
        card_item.meta.vendor_id,
        vm.search_param.mode
      );

      var booking_data = {
        search_param: angular.copy(vm.search_param),
        card_item: angular.copy(card_item),
        id: vm.quote_result.result_data._id,
        booked_leg_type: angular.copy(vm.booked_leg_type),
        buyOrSell:
          (!vm.isShared && !util.isShipper) || vm.quotePreview
            ? "sell_rates"
            : vm.buyOrSell,
        user: vm.searchUser,
        page: "quote",
        create_for: vm.quote_result.result_data.created_for,
        shipper: vm.quote_result.result_data.created_for
          ? vm.quote_result.result_data.created_for
          : null,
        send_mail: vm.quote_result.result_data.send_mail,
        webViewObj: vm.webViewObj,
        all_in_quote_setting : vm.all_in_quote, 
        uuid : vm.isShared ? $stateParams.id : null
      };
      if(vm.isCommodity){
        booking_data.card_item.meta['commodity_data']=shareQuoteService.commodityString(vm.quote_result.result_data.commodity_data);
      }
      resultService.requestToBookData = booking_data;
      if (vm.isShared) {
        $state.go("app.quoteSharedBookShipment");
      } else if (vm.isWebView) {
        $state.go("app.quoteWebViewBookShipment");
      } else {
        $state.go("app.quoteBookShipment");
      }
    }

    //function to determine leg load Missing or not
    function isLegLoadMissing(loadObj, Key) {
      return resultService.isLegLoadMissing(loadObj, Key);
    }

    //function to get the remarks or inclusion of cards
    function getCardRemarksInclusion(cardObj, key) {
      var result = "";
      // if ( vm.addOrEditCard == 'rates' && vm.msrOrNetwork ) {

      //   result = resultService.getCardRemarksInclusion(cardObj,key);
      // }else
      // {
      if (key == "REMARKS") {
        result = !!vm.currentCard.meta.remarks
          ? vm.currentCard.meta.remarks
          : "";

        result = result
          ? result
          : resultService.getCardRemarksInclusion(cardObj, key);
      } else if (key == "INCLUSIONS") {
        result = !!vm.currentCard.meta.inclusions
          ? vm.currentCard.meta.inclusions
          : "";

        result = result
          ? result
          : resultService.getCardRemarksInclusion(cardObj, key);
      }
      // }
      return result;
    }

    //get buy rate charge currency in quote tab
    function fnGetBuyChargeCurrency(key_name, id) {
      var result = "-";
      if (vm.currentCard.data.buy_rates.hasOwnProperty(key_name)) {
        var chargeObj = $filter("filter")(
          vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
          { id: id },
          true
        );
        result = chargeObj.length ? chargeObj[0].charge_currency : "-";
      }
      return result;
    }

    //get buy rate charge minimum amount in quote tab
    function fnGetBuyMinAmount(key_name, id) {
      var result = "-";
      var chargeObj = $filter("filter")(
        vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
        { id: id },
        true
      );
      result = chargeObj.length ? chargeObj[0].minimum_charge_cost : "-";
      return result;
    }

    //get buy rate charge unit price in quote tab
    function fnGetBuyUnitPrice(key_name, id) {
      var result = "-";

      if (vm.currentCard.data.buy_rates.hasOwnProperty(key_name)) {
        var chargeObj = $filter("filter")(
          vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
          { id: id },
          true
        );
        result = chargeObj.length
          ? $filter("number")(chargeObj[0].per_unit_rate, 2)
          : "-";
      }
      return result;
    }

    //get buy rate charge leg currency cost in quote tab
    function fnGetBuyChargeLegCurrencyCost(key_name, id) {
      var result = "-";

      if (vm.currentCard.data.buy_rates.hasOwnProperty(key_name)) {
        var chargeObj = $filter("filter")(
          vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
          { id: id },
          true
        );
        result = chargeObj.length
          ? $filter("number")(chargeObj[0].leg_currency_cost, 2)
          : "-";
      }
      return result;
    }

    vm.hoverIn = function () {
      this.hoverEdit = true;
    };

    vm.hoverOut = function () {
      this.hoverEdit = false;
    };

    function toggleSideNav(sidenavId,close) {
      if (vm.quotePreview) {
        return;
      }
      $mdSidenav(sidenavId).toggle();
      vm.util.fnRestrictPageHeight();
    }

    // add / edit rates
    function fnAddOrEditCard(card, action, ev) {
      vm.editCard = card ? angular.copy(card) : null;
      vm.footerObj = { 
        "doneBtnDisable" : false,
        "buyTotalWithConv" : 0,
        "buyTotalBaseCurr" : 0,
        "sellTotalBaseCurr" : 0,
        "profit" : 0,
        "rateExpired":false
      };
      vm.pageSource = action; //'newCardCopyQuote' 'editCardCopyQuote;
      $mdDialog.show({
        template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" source-rate="ctrl.parent.sourceRate"  search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" result-card-filter="ctrl.parent.resultCardFilter" card-data="ctrl.parent.editCard" footer-obj="ctrl.parent.footerObj" all-in-quote="ctrl.parent.all_in_quote" co2e-response="ctrl.parent.co2eResponse" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        }
      });
    }
    

    function fnDefaultCharge() {
      vm.getChargeList(
        "Ocean Freight",
        vm.l3_leg,
        vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0]
      ).then(
        function (response) {
          vm.changeSelectedCharge(
            response[0],
            vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0],
            vm.currentCard.data.sell_rates[vm.l3_leg],
            0,
            vm.l3_leg
          );
          vm.currentCard.meta["isScheduleCall"] = true;
          vm.quoteNewCard.meta["isScheduleCall"] = true;
          vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry =
            angular.copy(
              vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry
            );
          vm.quoteNewCard.data = angular.copy(vm.currentCard.data);
          vm.addCardData = true;
        },
        function (error) {
          vm.currencyList = [];
          vm.addCardData = true;
          $log.log(error);
        }
      );
    }

    function fngetSubVendorDetails(cardMeta, rate_data) {
      if (vm.search_param.mode == "AIR") {
        for (var i = 0; i < vm.getAirline.length; i++) {
          if (vm.getAirline[i].airline_code == rate_data.airline_code) {
            rate_data.airline.airline_code = vm.getAirline[i].airline_code;ote
            rate_data.airline.air_line_name = vm.getAirline[i].air_line_name;
            rate_data.airline.airline_prefix = vm.getAirline[i].airline_prefix;
            vm.quoteNewCard.airline = vm.getAirline[i].air_line_name;
            cardMeta.selected_schedule = null;
            rate_data.schedule.data = [];
            vm.schedule_display = false;
            return;
          }
        }
      } else {
        for (var i = 0; i < vm.getSubvendor.length; i++) {
          if (vm.getSubvendor[i].id == rate_data.sub_vendor_id) {
            rate_data.sub_vendor_id = vm.getSubvendor[i].id;
            rate_data.sub_vendor.logo = vm.getSubvendor[i].logo;
            rate_data.sub_vendor.sub_vendor_name = vm.getSubvendor[i].name;
            rate_data.sub_vendor.carrier_code = vm.getSubvendor[i].carrier_code;
            vm.quoteNewCard.sub_vendor = vm.getSubvendor[i].name;
            cardMeta.selected_schedule = null;
            rate_data.schedule.data = [];
            vm.schedule_display = false;
            return;
          }
        }
      }
    }

    //cost convertion if charge cost or currency change
    function conversionOnPriceChange(charge, sellRates) {
      vm.footerObj.doneBtnDisable = true;

      if (
        vm.search_param.mode !== "SEA-FCL" ||
        (vm.search_param.mode === "SEA-FCL" &&
          (charge.charge_basis === shareQuoteService.pickupBasisName ||
            charge.charge_basis === shareQuoteService.deliveryBasisName ||
            charge.charge_basis === shareQuoteService.freightBasisName))
      ) {
        shareQuoteService.isQuoteOrNewcard = "quote";
        vm.getChargeCost(sellRates, charge);
      } else {
        shareQuoteService.getFclCharge(sellRates, charge, vm.searchUser.user_base_currency);
      }

      vm.fnDisplayProfit();

      $timeout(function () {
        vm.footerObj.doneBtnDisable = false;
      }, 200);
    }

    //if quotation tab sell rate leg currency change
    function conversionOnLegCurrencyChange(leg_key, leg_currency) {
      util.callMixpanel("QD-Chargetab-Currency", {
        value: leg_currency,
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
      vm.footerObj.doneBtnDisable = true;
      shareQuoteService.LegCurrUpdate(
        vm.currentCard.data.sell_rates,
        leg_key,
        leg_currency,
        vm.search_param.mode,
        vm.searchUser.user_base_currency
      );

      var buyKey = "";
      for (var i in vm.currentCard.data.buy_rates) {
        if (i == leg_key) {
          buyKey = i;
        }
      }

      vm.currentCard.data.buy_rates[buyKey].rate_obj.leg_currency =
        leg_currency;

      shareQuoteService.LegCurrUpdate(
        vm.currentCard.data.buy_rates,
        buyKey,
        leg_currency,
        vm.search_param.mode,
        vm.searchUser.user_base_currency
      );

      vm.fnDisplayProfit();

      $timeout(function () {
        vm.footerObj.doneBtnDisable = false;
      }, 200);
    }

    function fnAddLeg(currCard) {
      vm.legShow++;
      var leg_number =
        "lNew" +
        Math.floor(1000 + Math.random() * 9000) +
        "_" +
        (vm.search_param.mode == "SEA-FCL"
          ? "fcl"
          : vm.search_param.mode == "AIR"
          ? "air"
          : "lcl");

      if (currCard.data.sell_rates == null) {
        currCard.data.sell_rates = {};
      }

      currCard.data.sell_rates[leg_number] = angular.copy(vm.cardLegData);
      currCard.data.sell_rates[leg_number].rate_obj.charges.push(
        angular.copy(vm.cardChargeObj)
      );
      currCard.data.buy_rates[leg_number] = angular.copy(vm.cardLegData);
      currCard.data.buy_rates[leg_number].rate_obj.charges.push(
        angular.copy(vm.cardChargeObj)
      );
      vm.legSuggestionList = [];

      setTimeout(function () {
        document.querySelector("#" + leg_number + "").focus();
      }, 50);

      //mixpanel code
      util.callMixpanel("QD-Chargetab-AddLeg-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
    }

    function fnAddNewCharge(sellKey, sellObj) {
      var charge_number =
        "lNew" +
        Math.floor(1000 + Math.random() * 9000) +
        "_" +
        (vm.search_param.mode == "SEA-FCL"
          ? "fcl"
          : vm.search_param.mode == "AIR"
          ? "air"
          : "lcl");

      if (sellObj.leg_name == null) {
        util.showToast("Please enter leg name.");
        document.querySelector("#" + sellKey).focus();
        return false;
      }

      var charge_obj = angular.copy(vm.cardChargeObj);
      charge_obj.id = charge_number;
      charge_obj.charge_currency = sellObj.rate_obj.leg_currency;

      sellObj.rate_obj.charges.push(charge_obj);
      vm.currentCard.data.buy_rates[sellKey].rate_obj.charges.push(
        angular.copy(charge_obj)
      );
      vm.chargeShow = sellObj.rate_obj.charges.length;
      $timeout(function () {
        document
          .querySelector(
            "#" + sellKey + "_" + (sellObj.rate_obj.charges.length - 1) + ""
          )
          .focus();
      }, 50);

      //mixpanel code
      util.callMixpanel("QD-Chargetab-AddCharge-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
    }

    // get selected card with sell rates
    function pushToquoteArray(currentCard) {
      
      util.callMixpanel("QD-Chargetab-Done-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
      vm.footerObj.doneBtnDisable = true;

      if (
        currentCard.meta.remarks == undefined ||
        currentCard.meta.remarks == ""
      ) {
        currentCard.meta.remarks = null;
      }
      if (
        currentCard.meta.inclusions == undefined ||
        currentCard.meta.inclusions == ""
      ) {
        currentCard.meta.inclusions = null;
      }

      var isDone = shareQuoteService.fnRateEditValidation(
        currentCard,
        vm.editBuyRate,
        vm.search_param
      );

      if (isDone === 0) {
        vm.footerObj.doneBtnDisable = false;
      } else if (isDone === 1) {
        currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);
        currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);
        currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);
        vm.submitCharges(currentCard);
      }
    }

    function submitCharges(currentCard){
      var custom_leg = 9;
        var tempSellRates = {};
        var tempBuyRates = {};
        var load_stat = {};
        if (vm.search_param.mode == "SEA-FCL") {
          //leg charge summary calculate factory instance 
          var chargeSummaryObj = new fbUtils.ChargeSummaryFactory.getInstance(vm.search_param.load_data, vm.search_param.mode);
          load_stat = {};
          vm.search_param.load_data.load_details_value.forEach(function (load) {
            load_stat[load.type] = 0;
          });
        }
        
        angular.forEach(currentCard.data.sell_rates, function (value, key) {
          if(key.toLowerCase().includes('lnew') || key !== vm.l3_leg){
            if(value.leg_code===vm.l3_leg){
              var templeg=value.rate_obj;
              value=currentCard.data.sell_rates[vm.l3_leg];
              value.leg_name = templeg.leg_name;
              value.rate_obj.leg_name = templeg.leg_name;
              value.rate_obj.charges=templeg.charges;
              value.rate_obj.leg_total_currency=templeg.leg_total_currency;
              value.rate_obj.leg_total_cost=templeg.leg_total_cost;
              value.rate_obj.leg_currency_cost=templeg.leg_currency_cost;
              value.rate_obj.leg_currency=templeg.leg_currency;
              value.rate_obj.manual=templeg.manual
            }  
          }
          if (vm.search_param.mode == "SEA-FCL") {
            value.rate_obj.load_stat = angular.copy(load_stat);
          }

          if (value.leg_code != null && value.leg_code != "") {
            tempSellRates[value.leg_code] = value;
            tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
            // Charge Summery calculation
            if(vm.search_param.mode == 'SEA-FCL'){
              var buySummaryData = chargeSummaryObj.calculate(currentCard.data.buy_rates[key].rate_obj);
              var sellSummaryData = chargeSummaryObj.calculate(currentCard.data.sell_rates[key].rate_obj);
              currentCard.data.buy_rates[key]['charge_summary'] = buySummaryData;
              currentCard.data.sell_rates[key]['charge_summary'] = sellSummaryData;
            }
            
            custom_leg =
              parseInt(value.leg_code.match(/(\d+)/)[0]) <= 8
                ? 9
                : parseInt(value.leg_code.match(/(\d+)/)[0]) + 1;
          } else if (value.leg_code == null || value.leg_code == "") {
            value.leg_code = "l" + custom_leg + vm.modeName;
            value.rate_obj.leg_code = value.leg_code;
            value.rate_obj.leg_name = value.leg_name;
            currentCard.data.buy_rates[key].leg_code = value.leg_code;
            currentCard.data.buy_rates[key].leg_name = value.leg_name;
            currentCard.data.buy_rates[key].rate_obj.leg_code = value.leg_code;
            currentCard.data.buy_rates[key].rate_obj.leg_name = value.leg_name;
            custom_leg++;

            tempSellRates[value.leg_code] = value;
            tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
          }

          angular.forEach(
            value.rate_obj.charges,
            function (childValue, chargeKey) {
              if (
                vm.search_param.mode == "SEA-FCL" &&
                childValue.container_type
              ) {
                value.rate_obj.load_stat[childValue.container_type] = 1;
              }
              if (!childValue.charge_id) {
                childValue.charge_id =
                  "UD" +
                  Math.random().toString(36).substring(2, 7).toUpperCase();
                childValue.global_charge_id =
                  "UD" +
                  Math.random().toString(36).substring(2, 7).toUpperCase();

                // random id for buy and sell rate charges
                tempSellRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].charge_id = childValue.charge_id;
                tempBuyRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].charge_id = childValue.charge_id;

                tempSellRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].global_charge_id = childValue.global_charge_id;
                tempBuyRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].global_charge_id = childValue.global_charge_id;
              }
            }
          );
          if (vm.editBuyRate) {
            tempBuyRates[value.leg_code].rate_obj.load_stat = angular.copy(
              value.rate_obj.load_stat
            );
          } else {
            tempBuyRates[value.leg_code].rate_obj.load_stat = tempBuyRates[
              value.leg_code
            ].rate_obj.load_stat
              ? tempBuyRates[value.leg_code].rate_obj.load_stat
              : angular.copy(load_stat);
          }
        });

        angular.forEach(vm.ScheduleCard.data.buy_rates, function (value, key) {
          if (!value.rate_obj && !tempBuyRates[key]) {
            tempBuyRates[key] = angular.copy(
              vm.ScheduleCard.data.buy_rates[key]
            );
            tempSellRates[key] = angular.copy(
              vm.ScheduleCard.data.buy_rates[key]
            );
          }
        });

        currentCard.data.sell_rates = tempSellRates;
        currentCard.data.buy_rates = tempBuyRates;
        currentCard.meta.card_total_cost = resultService.calCardTotal(
          currentCard.data.sell_rates
        );
        currentCard.meta.is_selected = true;

        if (vm.addOrEditCard == "quotationEdit") {
          vm.shareQuoteService.copysellToBuy(currentCard, vm.search_param.mode, vm.l3_leg);

          var getCardData = $filter("filter")(
            vm.quote_CardData,
            { _id: vm.currentCard._id },
            true
          );
          var index = vm.quote_CardData.indexOf(getCardData[0]);

          currentCard.meta["status"] = currentCard.meta["status"] != "new" ? "modified" : "new";
          vm.quote_CardData[index] = angular.copy(currentCard);
        } else if (
          vm.addOrEditCard == "addNewQuote" ||
          vm.addOrEditCard == "schedule"
        ) {
          currentCard.meta["status"] = "new";
          vm.quoteNewCard = angular.copy(currentCard);
          vm.sell_rates_display = true;
        } else if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
          currentCard.data.buy_rates[vm.l3_leg].rate_obj.manual = 1;
          currentCard.data.sell_rates[vm.l3_leg].rate_obj.manual = 1;
          currentCard.meta["status"] = "new";
          vm.addInQuote(currentCard, "searchCard");
        }

        if (vm.isDuplicateQuote && vm.copyquoted) {
          vm.updateForDuplicate(currentCard);
        }

        $mdDialog.hide();
        vm.footerObj.doneBtnDisable = false;
        vm.ifInitQuoteModify();
    }

    // save changes in duplicate cards
    function updateForDuplicate(currentCard) {
      var item = vm.selectedDuplicateCard.find(function (element) {
        return element._id == currentCard._id;
      });
      var index = vm.selectedDuplicateCard.indexOf(item);
      vm.selectedDuplicateCard[index] = angular.copy(currentCard);
    }

    function fnSwitchPages(str) {
      if (str == "remarks") {
        vm.quotationDetailsVisible = false;
        //mixpanel.code
        util.callMixpanel("QD-Chargetab-Remarks-Click", {
          Mode: vm.search_param.mode,
          Type: vm.resultType,
        });
      } else if (str == "quotationDetails") {
        util.callMixpanel("QD-Chargetab-Quotation-Click", {
          Mode: vm.search_param.mode,
          Type: vm.resultType,
        });
        vm.quotationDetailsVisible = true;
      }
    }

    //if leg is  selected from suggestion
    function changeSelectedLeg(selectedLeg, sellRate, sellKey) {
        var leg_code =
        vm.search_param.mode == "SEA-FCL"
          ? "_fcl"
          : vm.search_param.mode == "AIR"
          ? "_air"
          : "_lcl";
      if (selectedLeg != null) {
        var isLegPresent = Object.keys(vm.currentCard.data.sell_rates).some(
          function (key) {
            if (
              vm.currentCard.data.sell_rates[key].leg_code ==
              selectedLeg.leg_id + leg_code
            ) {
              return true;
            }
            return false;
          }
        );

        if (
          isLegPresent &&
          (sellRate.leg_code == null || sellRate.leg_code == "")
        ) {
          util.showToast('Leg already exist! Please Select another leg');
          sellRate.leg_name = "";
          sellRate.leg_code = "";
          sellRate.rate_obj.leg_name = "";
          sellRate.rate_obj.leg_code = "";
          sellRate.rate_obj.global_leg_id = "";
        } else {
          sellRate.leg_name = selectedLeg.leg_name;
          sellRate.leg_code = selectedLeg.leg_id + leg_code;
          sellRate.rate_obj.leg_name = selectedLeg.leg_name;
          sellRate.rate_obj.leg_code = selectedLeg.leg_id + leg_code;
          sellRate.rate_obj.global_leg_id = selectedLeg.leg_id;
        }
      } else {
        sellRate.leg_code = "";
        sellRate.rate_obj.leg_code = "";
      }
      vm.currentCard.data.buy_rates[sellKey].leg_name = angular.copy(
        sellRate.leg_name
      );
      vm.currentCard.data.buy_rates[sellKey].leg_code = angular.copy(
        sellRate.leg_code
      );
      vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_name = angular.copy(
        sellRate.rate_obj.leg_name
      );
      vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_code = angular.copy(
        sellRate.rate_obj.leg_code
      );
      vm.currentCard.data.buy_rates[sellKey].rate_obj.global_leg_id =
        angular.copy(sellRate.rate_obj.global_leg_id);
    }

    // get leg name list
    function getMatches(searchText) {
      var obj = {
        mode: vm.search_param.mode,
        search: searchText,
      };

      return SearchService.getLegName(obj).then(
        function (response) {
          vm.legSuggestionList = response.data.data;
          return vm.legSuggestionList;
        },
        function (error) {
          $log.log(error);
        }
      );
    }

    function confirmDeleteLeg(sellKey, sellRate) {
      vm.chargeDelete = false;
      vm.legDelete = true;

      vm.deleteChargeBtn = false;
      vm.all_pickup_basis_delete = false;
      vm.all_delivery_basis_delete = false;
      vm.is_delete_l3_leg = false;
      vm.airBasisLegCharge = {};
      vm.airBasisCharges = false;

      vm.legKeyName = sellKey;

      vm.deleteLegObj = sellRate;

      if (sellRate.leg_name == null || sellRate.leg_name == "") {
        vm.fnDeleteLeg();
      } else {
        if (sellKey == vm.l3_leg) {
          vm.is_delete_l3_leg = true;
          util.showToast("You can not delete this leg.");
          return true;
        }
        vm.currentPage = "quote";
        $mdToast.show({
          hideDelay: false,
          position: "top right",
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
          templateUrl:
            "app/main/result/Dialogs/delete-charge/delete-charge.html",
        });
      }
    }

    function fnDeleteLeg() {
      vm.deleteChargeBtn = true;

      if (vm.is_delete_l3_leg) {
        $mdToast.hide();
        $mdDialog.hide();
        return;
      }

      delete vm.currentCard.data.sell_rates[vm.legKeyName];
      delete vm.currentCard.data.buy_rates[vm.legKeyName];

      vm.fnDisplayProfit();

      $mdToast.hide();
    }

    //autocomplete charge text change
    function changeTextCharge(charge, index, leg_code) {
      if (vm.search_param.mode === "SEA-FCL") {
        charge.charge_id = "";
        charge.global_charge_id = "";
      } else {
       
        charge.charge_id = "";
        charge.global_charge_id = "";
      }
      charge.charge_category = null;
      charge.charge_code =
        charge.charge_name.toLowerCase().replace(/ /g, "_") +
        "_" +
        vm.shareQuoteService.fnGuuid();
      vm.currentCard.data.buy_rates[leg_code].rate_obj.charges[
        index
      ].charge_name = angular.copy(charge.charge_name);
    }

    //charge autocomplete object
    function changeSelectedCharge(
      selectedName,
      charge,
      legValue,
      index,
      legKey
    ) {
      if (selectedName && !!selectedName.source) {
        charge["source"] = selectedName.source;
        charge["source_data"] = selectedName.source_data;
      }

      if (vm.search_param.mode === "SEA-FCL") {
        if (selectedName != null) {
          charge.charge_name = selectedName.charge_name;
          charge.charge_id = selectedName.charge_id;
          charge.global_charge_id = selectedName.global_charge_id;
          charge.container_type =
            legValue.leg_code != "ins_fcl"
              ? selectedName.load_code
                ? selectedName.load_code
                : charge.container_type
              : null;
          charge.charge_basis = selectedName.charge_basis;
          charge.total_units = 0;
          charge.per_unit_rate = selectedName.per_unit_rate
            ? selectedName.per_unit_rate
            : 0;
          charge.charge_currency = selectedName.charge_currency
            ? selectedName.charge_currency
            : legValue.rate_obj.leg_currency;
          charge.charge_category = selectedName.charge_category;
          charge.charge_code = selectedName.charge_code;
        } else {
          charge.charge_id = "";
          charge.global_charge_id = "";
        }
      } else {
        if (selectedName.charge_category) {
          charge.charge_category = selectedName.charge_category;
        }
        shareQuoteService.changeSelectedCharge(
          selectedName,
          charge,
          legValue,
          index,
          legKey
        );
      }

      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_name = angular.copy(charge.charge_name);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_id =
        angular.copy(charge.charge_id);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].global_charge_id = angular.copy(charge.global_charge_id);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].container_type = angular.copy(charge.container_type);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_basis = angular.copy(charge.charge_basis);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].total_units = angular.copy(charge.total_units);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_category = angular.copy(charge.charge_category);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_code = angular.copy(charge.charge_code);

      if (vm.editBuyRate) {
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
          index
        ].per_unit_rate = angular.copy(charge.per_unit_rate);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
          index
        ].charge_currency = angular.copy(charge.charge_currency);
      }

      if (vm.search_param.mode === "SEA-FCL") {
        vm.fnChangeBasis(
          charge,
          legValue,
          index,
          vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index],
          vm.currentCard.data.buy_rates[legKey],
          legKey
        );
      } else {
        vm.conversionOnPriceChange(charge, legValue);
        if (vm.editBuyRate) {
          vm.conversionOnPriceChange(
            vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index],
            vm.currentCard.data.buy_rates[legKey].rate_obj
          );
        }
      }
    }

    //get charge name suggestion list
    function getChargeList(searchText, leg_code, chargeObj) {
      return shareQuoteService.getChargeList(
        searchText,
        leg_code,
        chargeObj,
        vm.search_param
      );
    }

    function fnGetContainerQty(
      leg_data,
      charge_data,
      action,
      charge_index,
      buyCharge,
      buyLeg,
      param
    ) {
      if (charge_data.charge_basis != "" || charge_data.charge_basis != null) {
        if (param != "quantity") {
          var payload = {
            charge: charge_data,
            load_meta: vm.search_param.load_data.load_meta,
            airFreightValue:
              vm.currentCard.meta["AirFreight"] != null
                ? vm.currentCard.meta["AirFreight"].leg_currency_cost
                : null,
            pickupValue:
              vm.currentCard.meta["pickupCharge"] != null
                ? vm.currentCard.meta["pickupCharge"].leg_currency_cost
                : null,
            deliveryValue:
              vm.currentCard.meta["deliveryCharge"] != null
                ? vm.currentCard.meta["deliveryCharge"].leg_currency_cost
                : null,
            global_leg_id: leg_data.global_leg_id,
            ltl_load_details: vm.currentCard.meta["ltl_load_details"],
            mode: vm.search_param.mode,
            dimChargeableValue:
              leg_data.dim_data &&
              leg_data.dim_data.chargeable_weight_in_kg !== 0
                ? leg_data.dim_data.chargeable_weight_in_kg
                : null,
          };

          shareQuoteService.fnGetContainerQty(payload);
        }

        if (charge_data.total_units == null) {
          charge_data.charge_cost = 0;
          charge_data.leg_currency_cost = 0;
        } else if (
          charge_data.total_units != null &&
          charge_data.per_unit_rate !== null &&
          charge_data.per_unit_rate !== 0
        ) {
          vm.conversionOnPriceChange(charge_data, leg_data);
        }

        buyCharge.charge_basis = angular.copy(charge_data.charge_basis);
        buyCharge.total_units = angular.copy(charge_data.total_units);
        buyCharge.is_qty_editable = angular.copy(charge_data.is_qty_editable);

        if (
          vm.editBuyRate &&
          buyCharge.total_units != null &&
          buyCharge.per_unit_rate !== null &&
          buyCharge.per_unit_rate !== 0
        ) {
          vm.conversionOnPriceChange(buyCharge, buyLeg);
        }
      }
    }

    //Get charge cost
    function getChargeCost(leg_data, charge_data) {
      shareQuoteService.getChargeCost(leg_data, charge_data, vm.searchUser.user_base_currency);

      if (charge_data.global_charge_id && charge_data.total_units != null) {
        // var checkCharge = false;
        // if (
        //   basisCalculation.isParent(charge_data)
        // ) {
        //   vm.currentCard.meta["AirFreight"] = charge_data;
        //   checkCharge = true;
        // } 
        // else if (
        //   charge_data.global_charge_id.indexOf(
        //     shareQuoteService.pickupChargeId
        //   ) >= 0
        // ) {
        //   vm.currentCard.meta["pickupCharge"] = charge_data;
        //   checkCharge = true;
        // } else if (
        //   charge_data.global_charge_id.indexOf(
        //     shareQuoteService.deliveryChargeId
        //   ) >= 0
        // ) {
        //   vm.currentCard.meta["deliveryCharge"] = charge_data;
        //   checkCharge = true;
        // } else if (
        //   charge_data.global_charge_id.indexOf(
        //     shareQuoteService.freightChargeId
        //   ) >= 0
        // ) {
        //   vm.currentCard.meta["freightCharge"] = charge_data;
        //   checkCharge = true;
        // }

        // if (checkCharge) {
        //   vm.checkPercentageBasis(leg_data, charge_data);
        // }
      }
    }

    // charge calculation if charge basis '% on air'
    // function checkPercentageBasis(legs, charge_data) {
    //   if (shareQuoteService.isQuoteOrNewcard == "newCard") {
    //     fnChargeLoop(legs);
    //   } else {
    //     angular.forEach(vm.currentCard.data.sell_rates, function (value, key) {
    //       fnChargeLoop(value.rate_obj);
    //     });
    //   }

    //   function fnChargeLoop(legRateObj) {
    //     angular.forEach(legRateObj.charges, function (childValue) {
    //       if (childValue.charge_basis === constObj.AIR_FREIGHT_BASIS) {
    //         childValue.total_units =
    //           charge_data != null ? charge_data.leg_currency_cost : null;
    //         shareQuoteService.getChargeCost(
    //           legRateObj,
    //           childValue,
    //           vm.currency_rates
    //         );
    //       }
    //     });
    //   }
    // }

    // function showDeleteBasisCharge(action, chargeName) {
    //   if (action == "quote") {
    //     angular.forEach(vm.currentCard.data.sell_rates, function (value, key) {
    //       vm.airBasisLegCharge[key] = { leg_name: value.leg_name, charges: [] };
    //       vm.pickupBasisLegCharge[key] = {
    //         leg_name: value.leg_name,
    //         charges: [],
    //       };
    //       vm.deliveryBasisLegCharge[key] = {
    //         leg_name: value.leg_name,
    //         charges: [],
    //       };

    //       angular.forEach(value.rate_obj.charges, function (childValue) {
    //         if (
    //           childValue.charge_basis == shareQuoteService.airBasisName &&
    //           chargeName == "air_charge"
    //         ) {
    //           vm.airBasisLegCharge[key].charges.push(childValue);
    //         } else if (
    //           childValue.charge_basis == shareQuoteService.pickupBasisName &&
    //           chargeName == "pickup_charge"
    //         ) {
    //           vm.pickupBasisLegCharge[key].charges.push(childValue);
    //         } else if (
    //           childValue.charge_basis == shareQuoteService.deliveryBasisName &&
    //           chargeName == "delivery_charge"
    //         ) {
    //           vm.deliveryBasisLegCharge[key].charges.push(childValue);
    //         }
    //       });

    //       if (!vm.airBasisLegCharge[key].charges.length) {
    //         delete vm.airBasisLegCharge[key];
    //       }
    //       if (!vm.pickupBasisLegCharge[key].charges.length) {
    //         delete vm.pickupBasisLegCharge[key];
    //       }
    //       if (!vm.deliveryBasisLegCharge[key].charges.length) {
    //         delete vm.deliveryBasisLegCharge[key];
    //       }
    //     });
    //   }

    //   if (
    //     action == "quote" &&
    //     Object.keys(vm.airBasisLegCharge).length !== 0 &&
    //     vm.airBasisLegCharge["l3_air"] != undefined &&
    //     (vm.currentCard.data.sell_rates["l3_air"].rate_obj.charges.length ==
    //       vm.airBasisLegCharge["l3_air"].charges.length + 1 ||
    //       vm.currentCard.data.sell_rates["l3_air"].rate_obj.charges.length ==
    //         vm.airBasisLegCharge["l3_air"].charges.length)
    //   ) {
    //     vm.is_delete_l3_leg = true;
    //   }

    //   vm.airBasisCharges =
    //     Object.keys(vm.airBasisLegCharge).length === 0 || vm.is_delete_l3_leg
    //       ? false
    //       : true;
    //   vm.all_pickup_basis_delete =
    //     Object.keys(vm.pickupBasisLegCharge).length === 0 ? false : true;
    //   vm.all_delivery_basis_delete =
    //     Object.keys(vm.deliveryBasisLegCharge).length === 0 ? false : true;
    // }

    function fnChangeBasis(
      chargeObj,
      sellRate,
      charge_index,
      buyCharge,
      buyLeg,
      param,
      legKey
    ) {
      if (!chargeObj.charge_basis) {
        chargeObj.total_units = 0;
        chargeObj.charge_cost = 0;
        vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj);
        if (vm.editBuyRate) {
          vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj);
        }
        return true;
      }
      if (vm.search_param.mode === "SEA-FCL" && chargeObj.charge_name) {
        resultService.checkExistingCharge(chargeObj, charge_index, sellRate.rate_obj.charges,legKey); //it's checking duplicate charge present or not.
      }

      if (param != "quantity") {
        shareQuoteService.fnGetFclTotalUnits(
          chargeObj,
          vm.search_param.load_data.load_details_value
        );
      }

      if (chargeObj.total_units == 0) {
        chargeObj.charge_cost = 0;
        chargeObj.leg_currency_cost = 0;
      } else {
        vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj);
      }

      buyCharge.charge_basis = angular.copy(chargeObj.charge_basis);
      buyCharge.total_units = angular.copy(chargeObj.total_units);
      buyCharge.container_type = angular.copy(chargeObj.container_type);
      buyCharge.is_qty_editable = angular.copy(chargeObj.is_qty_editable);

      if (
        vm.editBuyRate &&
        buyCharge.total_units &&
        !isNaN(buyCharge.per_unit_rate)
      ) {
        vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj);
      }
    }

    function confirmDeleteCharge(sellKey, sellRate, index, action) {
      vm.chargeDelete = true;
      vm.legDelete = false;
      vm.deleteChargeBtn = false;

      vm.is_delete_l3_leg = false;
      vm.airBasisLegCharge = {};
      vm.pickupBasisLegCharge = {};
      vm.deliveryBasisLegCharge = {};
      vm.airBasisCharges = false;
      vm.all_pickup_basis_delete = false;
      vm.all_delivery_basis_delete = false;

      vm.legKeyName = sellKey;
      vm.deleteChargeLeg = sellRate;
      vm.deleteCharge_buyLeg = vm.currentCard.data.buy_rates[sellKey].rate_obj;
      vm.chargeIndex = index;

      vm.deleteChargeLineObj = vm.deleteChargeLeg.charges[index];
      vm.isQuoteOrCard = action;

      // if (
      //   vm.deleteChargeLeg.charges[index].global_charge_id != null &&
      //   vm.deleteChargeLeg.charges[index].global_charge_id != ""
      // ) {
      //   var ifAirCharge =
      //     vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.airChargeId
      //     ) >= 0; // air freight charge
      //   var ifPickupCharge =
      //     vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.pickupChargeId
      //     ) >= 0; // pickup charge
      //   var ifDeliveryCharge =
      //     vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.deliveryChargeId
      //     ) >= 0; // delivery charge
      //   if (ifAirCharge || ifPickupCharge || ifDeliveryCharge) {
      //     var chargeName = ifAirCharge
      //       ? "air_charge"
      //       : ifPickupCharge
      //       ? "pickup_charge"
      //       : "delivery_charge";
      //     vm.showDeleteBasisCharge(action, chargeName);
      //     if (vm.is_delete_l3_leg) {
      //       util.showToast("You can not delete this charge.");
      //       return true;
      //     }
      //   }
      // }

      vm.currentPage = "quote";
      if (
        vm.deleteChargeLeg.charges[index].charge_name == null ||
        vm.deleteChargeLeg.charges[index].charge_name == ""
      ) {
        if (
          action == "quote" &&
          sellKey == vm.l3_leg &&
          vm.deleteChargeLeg.charges.length == 1
        ) {
          vm.is_delete_l3_leg = true;
          util.showToast("You can not delete this charge.");
          return true;
          // $mdToast.show({
          //   hideDelay: false,
          //   position: 'top right',
          //   controllerAs: 'ctrl',
          //   controller: function () { this.parent = vm },
          //   templateUrl: 'app/main/result/Dialogs/delete-charge/delete-charge.html'
          // });
          // return;
        }
        vm.fnDeleteNewCharge();
      } else {
        if (
          action == "quote" &&
          sellKey == vm.l3_leg &&
          vm.deleteChargeLeg.charges.length == 1
        ) {
          vm.is_delete_l3_leg = true;
          util.showToast("You can not delete this charge.");
          return true;
        }

        $mdToast.show({
          hideDelay: false,
          position: "top right",
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
          templateUrl:
            "app/main/result/Dialogs/delete-charge/delete-charge.html",
        });
      }
    }

    function fnDeleteNewCharge() {
      vm.deleteChargeBtn = true;
      var sellObj = vm.deleteChargeLeg;
      var buyObj = vm.deleteCharge_buyLeg;
      var index = vm.chargeIndex;

      if (vm.is_delete_l3_leg) {
        $mdToast.hide();
        $mdDialog.hide();
        return;
      }

      sellObj.leg_currency_cost -= sellObj.charges[index].leg_currency_cost;
      sellObj.leg_total_cost -= sellObj.charges[index].customer_currency_cost;

      // if (
      //   sellObj.charges[index].global_charge_id != null &&
      //   sellObj.charges[index].global_charge_id != ""
      // ) {
      //   if (
      //     sellObj.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.airChargeId
      //     ) >= 0
      //   ) {
      //     vm.currentCard.meta["AirFreight"] = null;
      //   } else if (
      //     sellObj.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.pickupChargeId
      //     ) >= 0
      //   ) {
      //     vm.currentCard.meta["pickupCharge"] = null;
      //   } else if (
      //     sellObj.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.deliveryChargeId
      //     ) >= 0
      //   ) {
      //     vm.currentCard.meta["deliveryCharge"] = null;
      //   }
      // }

      sellObj.charges.splice(index, 1);

      buyObj.leg_currency_cost -= buyObj.charges[index].leg_currency_cost;
      buyObj.leg_total_cost -= buyObj.charges[index].customer_currency_cost;

      buyObj.charges.splice(index, 1);

      if (vm.isQuoteOrCard == "quote" && !sellObj.charges.length) {
        delete vm.currentCard.data.sell_rates[vm.legKeyName];
        delete vm.currentCard.data.buy_rates[vm.legKeyName];
      }

      // if (
      //   vm.airBasisCharges ||
      //   vm.all_pickup_basis_delete ||
      //   vm.all_delivery_basis_delete
      // ) {
      //   vm.deleteFreightBasisCharge(vm.isQuoteOrCard);
      // }

      if (vm.isQuoteOrCard == "quote") {
        vm.fnDisplayProfit();
      }

      $mdToast.hide();
    }

    // delete dependant basis charges
    // function deleteFreightBasisCharge(action) {
    //   fnLegLoop(vm.airBasisLegCharge);
    //   fnLegLoop(vm.pickupBasisLegCharge);
    //   fnLegLoop(vm.deliveryBasisLegCharge);

    //   if (
    //     action == "quote" &&
    //     !Object.keys(vm.currentCard.data.sell_rates).length
    //   ) {
    //     vm.currentCard.data.sell_rates = null;
    //   }

    //   function fnLegLoop(basisLeg) {
    //     angular.forEach(basisLeg, function (parent_value, parent_key) {
    //       var sellObj = vm.currentCard.data.sell_rates[parent_key].rate_obj;
    //       var buyObj = vm.currentCard.data.buy_rates[parent_key].rate_obj;

    //       angular.forEach(parent_value.charges, function (child_value) {
    //         if (sellObj) {
    //           var index = sellObj.charges.indexOf(child_value);
    //           sellObj.charges[index].total_units = null;
    //           buyObj.charges[index].total_units = null;

    //           // sellObj.leg_currency_cost -= sellObj.charges[index].leg_currency_cost;
    //           // sellObj.leg_total_cost -= sellObj.charges[index].customer_currency_cost;
    //           // sellObj.charges.splice(index, 1);

    //           // buyObj.leg_currency_cost -= buyObj.charges[index].leg_currency_cost;
    //           // buyObj.leg_total_cost -= buyObj.charges[index].customer_currency_cost;
    //           // buyObj.charges.splice(index, 1);
    //           console.log(sellObj.charges[index]);
    //         }
    //       });

    //       if (action == "quote" && sellObj && !sellObj.charges.length) {
    //         delete vm.currentCard.data.sell_rates[parent_key];
    //       }
    //     });
    //   }
    // }
   
    function addInQuote(card, action) {
     
      card = QuotesService.setData(card);
      card.meta["isScheduleCall"] = true;
      var tempCard = angular.copy(card);
      if (action == "newCard") {
        vm.shareQuoteService.copysellToBuy(tempCard, vm.search_param.mode, vm.l3_leg);
        vm.quoteNewCard = angular.copy(vm.quoteNewCardInit);
      }

      // vm.getAdditionalLeg(tempCard, action);

      // adding additional leg
      if (vm.isVasApplied) {
        var rate_card = [tempCard];
        resultService.applyVASLegToCard(rate_card, vm.vasDetails.legList, "quote");
      }
      if (!tempCard.meta["card_total_cost"]) {
        tempCard.meta["card_total_cost"] = resultService.calCardTotal(tempCard.data.sell_rates);
      }

      pushNewCards(tempCard);

      util.showToast("card added in quote.");
      vm.isQuoteModify = true;
      if (vm.isDuplicateQuote && vm.copyquoted) {
        vm.selectedDuplicateQuote(tempCard);
      }
      vm.ifInitQuoteModify();
    }



    function getAdditionalLeg(currentCard, action) {
      vm.modifyBtn = true;
      resultService
        .fnAutoFetchBinding(
          vm.search_param,
          currentCard,
          vm.quote_result.result_data._id,
          "quote",
          vm.l3_leg
        )
        .then(
          function (response) {
            // add remarks & inclusion
            response.meta["remarks"] = response.meta["remarks"]
              ? response.meta["remarks"]
              : "";
            response.meta["inclusions"] = response.meta["inclusions"]
              ? response.meta["inclusions"]
              : "";

            angular.forEach(
              response.data.buy_rates,
              function (leg_value, leg_key) {
                if (leg_value.rate_obj) {
                  response.meta["remarks"] += leg_value.rate_obj.remarks
                    ? leg_value.rate_obj.remarks
                    : " ";
                  response.meta["inclusions"] += leg_value.rate_obj.inclusions
                    ? leg_value.rate_obj.inclusions
                    : " ";
                }
              }
            );
            vm.modifyBtn = false;
          },
          function (error) {
            vm.modifyBtn = false;
          }
        );
    }

    function openDeleteCard(ev, card_id, index) {
      document
        .getElementById(card_id + "_" + index + "_askDeletecard")
        .classList.remove("hide");
      document
        .getElementById(card_id + "_" + index + "_deletecard")
        .classList.add("hide");

      // document.getElementById(card_id + '_card').classList.add("hide");
    }

    function removeCardFromQuote(ev, card_id, index) {
      document
        .getElementById(card_id + "_" + index + "_askDeletecard")
        .classList.add("hide");
      document
        .getElementById(card_id + "_" + index + "_deletecard")
        .classList.remove("hide");
      // document.getElementById(card_id + '_card').classList.add("hide");

      var getCardData = $filter("filter")(
        vm.quote_CardData,
        { _id: card_id },
        true
      );

      if (getCardData[0].meta["status"] == "modified") {
        getCardData[0].meta["status"] = "editRemove";
      } else if (getCardData[0].meta["status"] == "new") {
        getCardData[0].meta["status"] = "newRemove";
      } else {
        getCardData[0].meta["status"] = "remove";
      }
      vm.isQuoteModify = true;
      vm.ifInitQuoteModify();
    }

    function cancelDeleteCard(ev, card_id, index) {
      document
        .getElementById(card_id + "_" + index + "_askDeletecard")
        .classList.add("hide");
      document
        .getElementById(card_id + "_" + index + "_deletecard")
        .classList.add("hide");
    }

    function undoDeleteCard(ev, card_id, index) {
      document
        .getElementById(card_id + "_" + index + "_askDeletecard")
        .classList.add("hide");
      document
        .getElementById(card_id + "_" + index + "_deletecard")
        .classList.add("hide");
      // document.getElementById(card_id + '_card').classList.remove("hide");
      var getCardData = $filter("filter")(
        vm.quote_CardData,
        { _id: card_id },
        true
      );

      if (getCardData[0].meta["status"] == "editRemove") {
        getCardData[0].meta["status"] = "modified";
        vm.isQuoteModify = true;
      } else if (getCardData[0].meta["status"] == "newRemove") {
        getCardData[0].meta["status"] = "new";
        vm.isQuoteModify = true;
      } else {
        delete getCardData[0].meta["status"];
      }
      vm.ifInitQuoteModify();
    }

    function fnQuoteModify() {
      var deleteCount = 0;
      var emptyChargeSubVendorList = [];
      var subVendorObj={};
      vm.quote_CardData.forEach(function (card) {
        if(card.hasOwnProperty('checked')){
          delete card['checked'];
        }
        var isDeletedCard = false;
        if (
          card.meta["status"] == "remove" ||
          card.meta["status"] == "editRemove" ||
          card.meta["status"] == "newRemove"
        ) {
          deleteCount++;
          isDeletedCard = true;
        }

        // checking except expired and deleted cards
        if((!card.data.sell_rates[vm.l3_leg].rate_obj.expiry || new Date(card.data.sell_rates[vm.l3_leg].rate_obj.expiry) > new Date()) && !isDeletedCard){
           angular.forEach(card.data.sell_rates, function(sellLegValue,sellLegKey){
                if((sellLegKey == vm.l3_leg) && Object.keys(card.data.sell_rates).length==1 && (!sellLegValue.rate_obj.charges.length || !sellLegValue.rate_obj.charges[0].charge_id)){
                    //  storing all the subvendor as object key 
                    // here, duplicate Subvendor name will overwrite wiith the existing one
                    subVendorObj[sellLegValue.rate_obj.sub_vendor.sub_vendor_name]=1;
                }
                else{
                  if(Object.keys(card.data.sell_rates).length ==1 && !card.data.sell_rates[Object.keys(card.data.sell_rates)[0]].rate_obj.charges.length){
                    subVendorObj[sellLegValue.rate_obj.sub_vendor.sub_vendor_name]=1;
                   }
                }
      });
    }
     // storing subvendor name in array
      emptyChargeSubVendorList=Object.keys(subVendorObj);
        
      });
      if(emptyChargeSubVendorList.length){
          var subVendorStr = (emptyChargeSubVendorList.length > 1) ? emptyChargeSubVendorList.join(', ') : emptyChargeSubVendorList[0] ;
          util.showToast("Enter the charges for  " + subVendorStr + " to proceed.");
          return;
      }
      if (vm.quote_CardData.length == deleteCount) {
        util.showToast("Minimum one rate required for quote modification.");
        return;
      }

      var activityObj = {
        message: "",
        type: "",
        timestamp: new Date(),
        user_id: util.userProfile.user.id,
        user_name:
          util.userProfile.user.user_first_name +
          " " +
          util.userProfile.user.user_last_name,
        activity_data: {},
      };

      vm.modifyData = angular.copy(vm.quote_CardData);
      vm.search_param.hazardous_material = angular.copy(
        vm.quote_result.result_data.hazardous
      );
      vm.search_param.customs = angular.copy(
        vm.quote_result.result_data.customs
      );
      // vm.search_param.inco_term = angular.copy(
      //   vm.quote_result.result_data.incoterms
      // );

      var request_data = {
        data: {
          activity: [],
          additional_charges: {
            selected: vm.vasDetails ? vm.vasDetails.legList : [],
            available: vm.vasDetails ? vm.vasDetails.value_added_charges : [],
          },
          quote: {
            search_param: vm.search_param,
            customField: vm.quote_result.result_data.customField,
            meta: {
              customs: vm.quote_result.result_data.customs,
              perishable: vm.quote_result.result_data.perishable,
              hazardous: vm.quote_result.result_data.hazardous,
              incoterms: vm.quote_result.result_data.incoterms,
              impo_expo: vm.quote_result.result_data.impo_expo,
              expiry_date: $filter('date')(util.dateReplace(vm.quote_result.result_data.expiry_date), "yyyy-MM-dd"),
              terms: vm.quote_result.result_data.terms
            },
            revise_quote: vm.revise_quote,
            cards: {
              new: [],
              modified: [],
              remove: [],
            },
          },
        },
      };
      if(vm.isCommodity){
        request_data.data.quote.meta['commodity_data']= shareQuoteService.commodityString(vm.quote_result.result_data.commodity_data);
      }
      request_data.data.quote.cards.remove = vm.removedCardIdsFromSQ || [];
      vm.modifyData.forEach(function (card) {
        var linerName = "";
        if (card.meta["status"] == "new") {
          if (vm.search_param.mode === "AIR") {
            linerName =
              card.data.sell_rates[vm.l3_leg].rate_obj.airline.air_line_name;
          } else {
            linerName =
              card.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor
                .sub_vendor_name;
          }

          angular.forEach(card.data.sell_rates, function (sellValue, sellKey) {
            if (!sellValue.rate_obj) {
              delete card.data.sell_rates[sellKey];
              delete card.data.buy_rates[sellKey];
            }
          });

          delete card._id;
          delete card.meta.status;
          // setting undefined selected_schedule to null --> backend team asked for it
          card.meta.selected_schedule = !!card.meta.selected_schedule
            ? card.meta.selected_schedule
            : null;

          var tempObj = angular.copy(activityObj);
          tempObj.message = card.data.sell_rates[vm.l3_leg].rate_obj
            .service_type
            ? linerName +
              " rate card with service " +
              card.data.sell_rates[vm.l3_leg].rate_obj.service_type +
              " has been created."
            : linerName + " rate card has been created.";
          tempObj.type = "rate_card_added";
          request_data.data.activity.push(tempObj);
          request_data.data.quote.cards.new.push(card);
        } else if (card.meta["status"] == "modified" ||  card.meta["buyRateEdit"]) {
          var getCard = $filter("filter")(
            vm.temp_quoteData.result_data.cards,
            { _id: card._id },
            true
          );

          if (getCard.length) {
            if (vm.search_param.mode === "AIR") {
              linerName =
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.airline
                  .air_line_name;
            } else {
              linerName =
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.sub_vendor
                  .sub_vendor_name;
            }
          }

          delete card.meta.status;
          var tempObj = angular.copy(activityObj);
          if(card.meta["buyRateEdit"]){
            tempObj.message =   linerName + " rate card buy rate has been updated.";
            tempObj.type = "rate_card_buy_rate_added";
            delete card.meta["buyRateEdit"];
          }else{
            tempObj.message = getCard[0].data.sell_rates[vm.l3_leg].rate_obj
            .service_type
            ? linerName +
              " rate card with service " +
              getCard[0].data.sell_rates[vm.l3_leg].rate_obj.service_type +
              " has been updated."
            : linerName + " rate card has been updated.";
            tempObj.type = "rate_card_modified";
          }
          request_data.data.activity.push(tempObj);
          request_data.data.quote.cards.modified.push(card);
        } else if (
          card.meta["status"] == "remove" ||
          card.meta["status"] == "editRemove"
        ) {
          var getCard = $filter("filter")(
            vm.temp_quoteData.result_data.cards,
            { _id: card._id },
            true
          );

          if (getCard.length) {
            if (vm.search_param.mode === "AIR") {
              linerName =
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.airline
                  .air_line_name;
            } else {
              linerName =
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.sub_vendor
                  .sub_vendor_name;
            }

            delete card.meta.status;
            var tempObj = angular.copy(activityObj);
            tempObj.message = getCard[0].data.sell_rates[vm.l3_leg].rate_obj
              .service_type
              ? linerName +
                " rate card with service " +
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.service_type +
                " has been deleted."
              : linerName + " rate card has been deleted.";
            tempObj.type = "rate_card_removed";
            request_data.data.activity.push(tempObj);
            request_data.data.quote.cards.remove.push(card._id);
          }
        } else if (card.meta["status"] != "newRemove") {
          var getCard = $filter("filter")(
            vm.temp_quoteData.result_data.cards,
            { _id: card._id },
            true
          );

          if (getCard.length) {
            if (vm.search_param.mode === "AIR") {
              linerName =
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.airline
                  .air_line_name;
            } else {
              linerName =
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.sub_vendor
                  .sub_vendor_name;
            }
          }

          if (
            getCard.length &&
            !angular.equals(
              getCard[0].meta.selected_schedule,
              card.meta.selected_schedule
            )
          ) {
            var tempObj = angular.copy(activityObj);
            tempObj.message = getCard[0].data.sell_rates[vm.l3_leg].rate_obj
              .service_type
              ? "Schedule in " +
                linerName +
                " rate card with service " +
                getCard[0].data.sell_rates[vm.l3_leg].rate_obj.service_type +
                " has been updated."
              : "Schedule in " + linerName + " rate card has been updated.";
            tempObj.type = "rate_card_modified";
            request_data.data.activity.push(tempObj);
            request_data.data.quote.cards.modified.push(card);
          }
        }
      });

      // activity for for Refresh Rates
      if(vm.newResultCard && vm.newResultCard.length){
        var tempObj = angular.copy(activityObj);
          tempObj.message = "Rate card has been added from refresh.";
          tempObj.type = "rate_card_added";
        request_data.data.activity.push(tempObj);
      }

      if (vm.search_param.mode === "SEA-FCL") {
        for (
          var i = 0;
          i < vm.search_param.load_data.load_details_value.length;
          i++
        ) {
          var getload = $filter("filter")(
            vm.tempSearch_param.load_data.load_details_value,
            { type: vm.search_param.load_data.load_details_value[i].type },
            true
          );

          if (
            getload.length &&
            getload[0].qty !=
              vm.search_param.load_data.load_details_value[i].qty
          ) {
            var tempObj = angular.copy(activityObj);
            tempObj.message =
              getload[0].type +
              " container qty has been updated from " +
              getload[0].qty +
              " to " +
              vm.search_param.load_data.load_details_value[i].qty +
              ".";
            tempObj.type = "load_qty_changed";
            request_data.data.activity.push(tempObj);
          } else if (!getload.length) {
            var tempObj = angular.copy(activityObj);
            tempObj.message =
              vm.search_param.load_data.load_details_value[i].type +
              " container qty has been added.";
            // vm.search_param.load_data.load_details_value[i].qty + '.';
            tempObj.type = "new_load_type_added";
            request_data.data.activity.push(tempObj);
          }
        }
      } else {
        if (
          vm.tempSearch_param.load_data.load_meta.gross_weight !=
          vm.search_param.load_data.load_meta.gross_weight
        ) {
          var tempObj = angular.copy(activityObj);
          tempObj.message =
            "Gross weight has been updated from " +
            vm.tempSearch_param.load_data.load_meta.gross_weight +
            " to " +
            vm.search_param.load_data.load_meta.gross_weight +
            ".";
          tempObj.type = "gross_weight_changed";
          request_data.data.activity.push(tempObj);
        }
        if (
          vm.tempSearch_param.load_data.load_meta.volumetric_weight !=
          vm.search_param.load_data.load_meta.volumetric_weight
        ) {
          var tempObj = angular.copy(activityObj);
          tempObj.message =
            "Volumetric weight has been updated from " +
            vm.tempSearch_param.load_data.load_meta.volumetric_weight +
            " to " +
            vm.search_param.load_data.load_meta.volumetric_weight +
            ".";
          tempObj.type = "volumetric_weight_changed";
          request_data.data.activity.push(tempObj);
        }
        if (
          vm.tempSearch_param.load_data.load_meta.chargeable_weight !=
          vm.search_param.load_data.load_meta.chargeable_weight
        ) {
          var tempObj = angular.copy(activityObj);
          tempObj.message =
            "Chargeable weight has been updated from " +
            vm.tempSearch_param.load_data.load_meta.chargeable_weight +
            " to " +
            vm.search_param.load_data.load_meta.chargeable_weight +
            ".";
          tempObj.type = "chargeable_weight_changed";
          request_data.data.activity.push(tempObj);
        }
      }

      if (
        !angular.equals(
          new Date(vm.temp_quoteData.result_data.expiry_date).getTime(),
          new Date(vm.quote_result.result_data.expiry_date).getTime()
        )
      ) {
        var tempObj = angular.copy(activityObj);
        tempObj.message = "Quote expiry date has been updated.";
        tempObj.type = "meta_changed";
        request_data.data.activity.push(tempObj);
      }

      if (
        !angular.equals(
          vm.tempSearch_param.origin_charges,
          vm.search_param.origin_charges
        ) ||
        !angular.equals(
          vm.tempSearch_param.origin_customs,
          vm.search_param.origin_customs
        ) ||
        !angular.equals(
          vm.tempSearch_param.destination_charges,
          vm.search_param.destination_charges
        ) ||
        !angular.equals(
          vm.tempSearch_param.destination_customs,
          vm.search_param.destination_customs
        ) ||
        !angular.equals(
          vm.tempSearch_param.shipment_insurance,
          vm.search_param.shipment_insurance
        ) ||
        !angular.equals(
          vm.tempSearch_param.insurance_currency,
          vm.search_param.insurance_currency
        ) ||
        !angular.equals(
          vm.tempSearch_param.insurance_leg_cost,
          vm.search_param.insurance_leg_cost
        )
      ) {
        var tempObj = angular.copy(activityObj);
        tempObj.message = "Additional services has been updated.";
        tempObj.type = "meta_changed";
        request_data.data.activity.push(tempObj);
      }

      if (
        !angular.equals(
          vm.temp_quoteData.result_data.hazardous,
          vm.quote_result.result_data.hazardous
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.customs,
          vm.quote_result.result_data.customs
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.perishable,
          vm.quote_result.result_data.perishable
        )
      ) {
        var text = "";
        if (
          !angular.equals(
            vm.temp_quoteData.result_data.hazardous,
            vm.quote_result.result_data.hazardous
          )
        ) {
          text += "Hazardous ,";
        }
        if (
          !angular.equals(
            vm.temp_quoteData.result_data.customs,
            vm.quote_result.result_data.customs
          )
        ) {
          text += "Customs ,";
        }
        if (
          !angular.equals(
            vm.temp_quoteData.result_data.perishable,
            vm.quote_result.result_data.perishable
          )
        ) {
          text += "Perishable ,";
        }

        text = text.length ? text.slice(0, -1) : text;

        var tempObj = angular.copy(activityObj);
        tempObj.message = text + "has been updated.";
        tempObj.type = "meta_changed";
        request_data.data.activity.push(tempObj);
      }

      if (
        !angular.equals(
          vm.temp_quoteData.result_data.terms,
          vm.quote_result.result_data.terms
        )
      ) {
        var tempObj = angular.copy(activityObj);
        tempObj.message = "Terms has been updated.";
        tempObj.type = "meta_changed";
        request_data.data.activity.push(tempObj);
      }

      if (
        !angular.equals(
          vm.temp_quoteData.result_data.incoterms,
          vm.quote_result.result_data.incoterms
        )
      ) {
        var tempObj = angular.copy(activityObj);
        tempObj.message = "Incoterms has been updated.";
        tempObj.type = "meta_changed";
        request_data.data.quote.meta.incoterms =
          vm.quote_result.result_data.incoterms;
        request_data.data.activity.push(tempObj);
      }

      if (
        !angular.equals(
          new Date(vm.tempSearch_param.cargo_ready_date),
          new Date(vm.search_param.cargo_ready_date)
        )
      ) {
        var tempObj = angular.copy(activityObj);
        tempObj.message = "Cargo ready date has been updated.";
        tempObj.type = "meta_changed";
        request_data.data.activity.push(tempObj);
      }
      vm.modifyBtn = true;
      $rootScope.loadingDetails = true;
      util.isCallingApi = true;

        request_data.data.quote.meta.terms = util.encodeValue(request_data.data.quote.meta.terms);

      QuotesService.modifyQuote(
        vm.quote_result.result_data._id,
        request_data
      ).then(
        function (response) {
          vm.isQuoteModify = false;
          // reset refresh data
          resetRefreshData();

          if (!vm.revise_quote) {
            QuotesService.FclQuote = {};
            $state.reload();
            vm.modifyBtn = false;
            $rootScope.loadingDetails = false;
            // util.isCallingApi = false;
          } else {
            QuotesService.FclQuote = {};
            if(vm.isWebView){
              util.webViewObj.id = response.data.data._id;
              $state.go('app.webViewQuotesDetails',util.webViewObj);
            }else{
              $state.go('app.quotes.quotesDetails', { id: response.data.data._id});
            }
            vm.modifyBtn = false;
            $rootScope.loadingDetails = false;
            // util.isCallingApi = false;
          }
        },
        function (error) {
          util.isCallingApi = false;
          $log.log(error.data);
          $rootScope.loadingDetails = false;
          util.showToast(util.displayValidationError(error));
          vm.modifyBtn = false;
        });
      }

    function fnUndoChanges(ev) {
      var confirm = $mdDialog
        .confirm()
        // .title('Warning')
        .textContent("Changes made to this quote will be lost. Proceed anyway?")
        .ariaLabel("discard")
        .targetEvent(ev)
        .ok("Yes, Proceed")
        .cancel("No, Cancel");

      $mdDialog.show(confirm).then(
        function () {
          var className = document.querySelectorAll(".overlayCard");
          
          className.forEach(function (element) {
            element.classList.add("hide");
          });

          vm.isQuoteModify = false;
          vm.showTermsConditions = false;
          vm.quote_result = angular.copy(vm.temp_quoteData);
          vm.search_param = angular.copy(vm.tempSearch_param);
          resultService.setLegFilter(vm.filterConfig, vm.search_param);
          vm.quote_CardData = angular.copy(vm.quote_result.result_data.cards);
          vm.commodityValue = shareQuoteService.commodityString(vm.quote_result.result_data.commodity_data);
          resetRefreshData();
    
          // if(vm.newSearchFetch){
          //   vm.newSearchFetch = false;
          //   vm.fnSearchNewRates();
          // }
        },
        function () {
          return true;
        }
      );
    }

    //Quote-management - Ankita
    function showRemoveIcon(load) {
      var isContainer = vm.tempSearch_param.load_data.load_details_value.some(
        function (el) {
          return el.type === load.type;
        }
      );

      if (isContainer) {
        return false;
      } else {
        return true;
      }
    }

    function addNewLoad() {
      vm.editLoadType.push(angular.copy(vm.loadObj));
    }

    function validateContainerData() {
      var breakLoop = false;
      vm.editLoadType.some(function (i) {
        if (i.type == null || !i.type) {
          util.showToast(" Please select load type !");
          breakLoop = true;
          return true;
        }

        if (i.count <= 0) {
          util.showToast(" Please add load quantity !");
          breakLoop = true;
          return true;
        }
      });

      if (!vm.load_bl_qty && vm.editQuoteMeta.mode === "SEA-FCL") {
        util.showToast(" Please enter B/L quantity !");
        breakLoop = true;
      } else if (!vm.load_sbl_qty && vm.editQuoteMeta.mode === "SEA-FCL") {
        util.showToast(" Please enter SB/L quantity !");
        breakLoop = true;
      }

      if (breakLoop) {
        return true;
      }
    }

    function removeFromLoad(index, load) {
      vm.editLoadType.splice(index, 1);
    }

    function fnOpenEditQuoteModal(ev) {
      vm.validationObj={
      "shippingBillValidation":false,
      "billValidation":false,
      "typeValidation":false,
      "weightValidation":false,
      "qtyValidation":false,
      "AWBValidation":false,
      "unitValidation":false, 
      "TSVolumeValidation":false,
      "TSWeightValidation":false,
      "shippinglclbillValidation":false,
      "palletsValidation":false,
      "unitsheightValidation" :false,
      "unitsbreadthValidation":false,
      "unitsLengthValidation" :false,
      "unitsQtyValidation":false,
      "unitsweightValidation":false,
      "cargoDateValiation":false,
      "expiryValitdation":false,
      "showDateNote":false,
      }
      vm.editQuoteMeta = angular.copy(vm.search_param);
      // if (!vm.editQuoteMeta.insurance_currency) {
      //   vm.editQuoteMeta.insurance_currency = vm.searchUser.user_base_currency;
      // }

      vm.hazardousEdit = angular.copy(vm.quote_result.result_data.hazardous);
      vm.customsEdit = angular.copy(vm.quote_result.result_data.customs);
      vm.perishableEdit = angular.copy(vm.quote_result.result_data.perishable);
      vm.termsEdit = util.decodeValue(vm.quote_result.result_data.terms);
      vm.incotermsEdit = angular.copy(vm.quote_result.result_data.incoterms);
      vm.impoExpoEdit = angular.copy(vm.quote_result.result_data.impo_expo);
      vm.InitEditLoadType = [];
      vm.defaultLoadType = [];

      vm.startDateStart = new Date();
      vm.expiryEdit = angular.copy(util.dateReplace(vm.quote_result.result_data.expiry_date));
      vm.getExpiryMaxDate(vm.quote_result.result_data.start_date);
      vm.editQuoteMeta.cargo_ready_date = util.dateReplace(moment.utc(vm.editQuoteMeta.cargo_ready_date).format());
      vm.expiryDateEnd = new Date(
        shareQuoteService.fnValidateExpiryDate(
          vm.quote_CardData,
          vm.editQuoteMeta.cargo_ready_date,
          vm.l3_leg
        )
      );
      vm.validateExpirydate(vm.expiryEdit);

      vm.newLoad = angular.copy(vm.initNewLoad);

      angular.forEach(
        vm.editQuoteMeta.load_data.load_details_value,
        function (value) {
          vm.container_type.find(function (item) {
            if (item.type === value.type) {
              item.count = value.qty;
              item["bl_qty"] = value.bl_qty;
              item["sbl_qty"] = value.sbl_qty || 1;
              item.weight_qty = value.load_metrics[0].weight_qty;
              item.weight_unit = value.load_metrics[0].weight_unit;
              vm.InitEditLoadType.push(item);
              vm.defaultLoadType.push(angular.copy(item.type));
            }
          });
        }
      );

      vm.editLoadType = angular.copy(vm.InitEditLoadType);
      var tempUrl;

      if (vm.editQuoteMeta.mode === "SEA-FCL") {
        vm.load_bl_qty = vm.editLoadType[0].bl_qty;
        vm.load_sbl_qty = vm.editLoadType[0].sbl_qty || 1;
        tempUrl = "app/main/quotes/dialogs/edit-quote/fcl-edit-quote.html";
      } else {
        tempUrl = "app/main/quotes/dialogs/edit-quote/lcl-edit-quote.html";
      }
      $mdDialog.show({
        templateUrl: tempUrl,
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: false,
        onComplete: vm.afterShowAnimation,
        animation: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    

    //calculate load data
    $scope.$watch(
      "vm.editQuoteMeta.load_data",
      function () {
        if (vm.editQuoteMeta.mode === "AIR") {
          vm.editQuoteMeta.load_data = SearchService.calculateAirLoad(vm.editQuoteMeta.load_data);
        } else if (vm.editQuoteMeta.mode === "SEA-LCL") {
          vm.editQuoteMeta.load_data = SearchService.calculateLclLoad(vm.editQuoteMeta.load_data);
        }
        if(vm.editQuoteMeta.load_data){
        vm.convertedLoad = vm.util.metricSystemConversion(vm.editQuoteMeta.mode, vm.editQuoteMeta.load_data);
        }
      },
      true
    );

    function isActiveFunction(card) {
      if (
        vm.isActive &&
        util.getStatusData(card.data[vm.buyOrSell][vm.l3_leg].rate_obj) !=
          "EXPIRED"
      ) {
        return true;
      } else if (
        vm.isActive &&
        !util.getStatusData(card.data[vm.buyOrSell][vm.l3_leg].rate_obj) !=
          "EXPIRED"
      ) {
        return false;
      }
    }

    function fnSearchMetaEdit(form) {
      if(!vm.editQuoteMeta.cargo_ready_date){
        vm.validationObj.cargoDateValiation=true;
      }
      if(!vm.expiryEdit){
        vm.validationObj.expiryValitdation=true;
      }
      var editQuoteData = {
        Mode : vm.editQuoteMeta.mode ? vm.editQuoteMeta.mode : null,
        Incoterms : vm.editQuoteMeta.inco_term ? vm.editQuoteMeta.inco_term : null,
        "Cargo Ready Date" : vm.editQuoteMeta.cargo_ready_date ? vm.editQuoteMeta.cargo_ready_date : null,
        "Expiry Date" : vm.expiryEdit? vm.expiryEdit : null,
        "No of B/L" : vm.load_bl_qty ? vm.load_bl_qty : null,
        "No of Shipping Bill" : vm.load_sbl_qty ? vm.load_sbl_qty : null,
        "Load Details" : vm.editQuoteMeta.load_data ? vm.editQuoteMeta.load_data.load_details_value : null
      }
      if(vm.editQuoteMeta.mode === 'SEA-FCL' ){
         
        if(!vm.load_sbl_qty){
              vm.validationObj.shippingBillValidation=true;
        }
        if(!vm.load_bl_qty){
          vm.validationObj.billValidation=true;
        }
        
        if(vm.editLoadType) {
          angular.forEach(vm.editLoadType, function(item){
            if(!item.count){
              vm.validationObj.qtyValidation=true;
            }  
            if(!item.type){
              vm.validationObj.typeValidation=true;
            } 
            if(!item.weight_qty){
              vm.validationObj.weightValidation=true;
            } 
          })
        }
        
        if(vm.validationObj.shippingBillValidation || vm.validationObj.billValidation || vm.validationObj.qtyValidation || vm.validationObj.typeValidation || vm.validationObj.weightValidation ||  vm.validationObj.cargoDateValiation || vm.validationObj.expiryValitdation){
          return false;
        } 
      }else{
         
        if(!vm.editQuoteMeta.load_data.load_meta.total_bl){
          vm.validationObj.AWBValidation=true;
        }
        if(!vm.editQuoteMeta.load_data.load_meta.total_sbl){
          vm.validationObj.shippinglclbillValidation=true;
        }
        if(vm.editQuoteMeta.mode === 'SEA-LCL' && !vm.editQuoteMeta.load_data.load_meta.total_pallets){
          vm.validationObj.palletsValidation=true;
        }
        if(vm.editQuoteMeta.load_data.load_type == 'total_shipment'){
          if(!vm.editQuoteMeta.load_data.load_meta.total_qty){
            vm.validationObj.unitValidation=true;
          }
          if(!vm.editQuoteMeta.load_data.load_meta.total_volume){
            vm.validationObj.TSVolumeValidation=true;
          }
          if(!vm.editQuoteMeta.load_data.load_meta.total_weight){
            vm.validationObj.TSWeightValidation=true;
          }
        }
        if(vm.editQuoteMeta.load_data.load_type == 'units'){
          angular.forEach(vm.editQuoteMeta.load_data.load_details_value, function(load){
            if(!load.qty){
              vm.validationObj.unitValidation=true;
            }
            if(!load.length){
              vm.validationObj.unitsLengthValidation=true;
              
            }
            if(!load.breadth){
              vm.validationObj.unitsbreadthValidation=true;
            }
            if(!load.height){
              vm.validationObj.unitsheightValidation=true;
            }
            if(!load.weight){
              vm.validationObj.unitsweightValidation=true;
            }
          })
        }
        if( vm.validationObj.unitValidation || vm.validationObj.cargoDateValiation||  vm.validationObj.expiryValitdation || vm.validationObj.TSVolumeValidation || vm.validationObj.TSWeightValidation || vm.validationObj.AWBValidation || vm.validationObj.shippinglclbillValidation || vm.validationObj.palletsValidation ||  vm.validationObj.unitsheightValidation 
          ||  vm.validationObj.unitsbreadthValidation || vm.validationObj.unitsLengthValidation  ||  vm.validationObj.unitsweightValidation){
          return false;
        }
      }
      var improperData = vm.validateContainerData();
      if (improperData) {
        return;
      }
      vm.editLoadType.forEach(function (i) {
        i.bl_qty = vm.load_bl_qty;
        i.sbl_qty = vm.load_sbl_qty;
      });
      vm.fetchLoad = false;

      var oldExpire = new Date(vm.temp_quoteData.result_data.expiry_date).getTime();
      var newExpire = new Date(moment.utc(vm.expiryEdit).format()).getTime();

      var newcargo = $filter("date")(vm.editQuoteMeta.cargo_ready_date, "yyyy-MM-dd");

      if (!angular.equals(vm.tempSearch_param.cargo_ready_date, newcargo) ||
        !angular.equals(oldExpire, newExpire) ||
        !angular.equals(vm.temp_quoteData.result_data.hazardous, vm.hazardousEdit) ||
        !angular.equals(vm.temp_quoteData.result_data.customs, vm.customsEdit) ||
        !angular.equals(vm.temp_quoteData.result_data.perishable, vm.perishableEdit ) ||
        !angular.equals(vm.quote_result.result_data.terms, vm.termsEdit) ||
        !angular.equals(vm.quote_result.result_data.incoterms, vm.incotermsEdit) ||
        !angular.equals(vm.quote_result.result_data.impo_expo, vm.impoExpoEdit)
      ) {
        vm.isQuoteModify = true;
      }

      vm.editQuoteMeta.cargo_ready_date = $filter("date")(vm.editQuoteMeta.cargo_ready_date, "yyyy-MM-dd" );
      vm.quote_result.result_data.expiry_date = angular.copy($filter("date")(util.dateReplace(vm.expiryEdit), "yyyy-MM-dd" ));
      vm.quote_result.result_data.hazardous = angular.copy(vm.hazardousEdit);
      vm.quote_result.result_data.customs = angular.copy(vm.customsEdit);
      vm.quote_result.result_data.perishable = angular.copy(vm.perishableEdit);
      vm.quote_result.result_data.incoterms = angular.copy(vm.incotermsEdit);
      vm.quote_result.result_data.impo_expo = angular.copy(vm.impoExpoEdit);

      vm.quote_result.result_data.terms = angular.copy(vm.termsEdit);

      if (vm.editQuoteMeta.mode === "SEA-FCL" && !angular.equals(vm.InitEditLoadType, vm.editLoadType)) {
        vm.fnFclLoadChanged();
      } else if ( vm.editQuoteMeta.mode !== "SEA-FCL" && !angular.equals(vm.editQuoteMeta.load_data, vm.search_param.load_data)) {
        vm.fnAirLclLoadChanged();
      } else {
        if (!angular.equals(vm.editQuoteMeta.origin_charges, vm.search_param.origin_charges) ||
          !angular.equals(vm.editQuoteMeta.origin_customs, vm.search_param.origin_customs ) ||
          !angular.equals(vm.editQuoteMeta.destination_charges, vm.search_param.destination_charges) ||
          !angular.equals(vm.editQuoteMeta.destination_customs, vm.search_param.destination_customs) ||
          !angular.equals(vm.editQuoteMeta.shipment_insurance, vm.search_param.shipment_insurance) ||
          !angular.equals(vm.editQuoteMeta.insurance_currency, vm.search_param.insurance_currency) ||
          !angular.equals(vm.editQuoteMeta.insurance_leg_cost, vm.search_param.insurance_leg_cost)
        ) {
          if (vm.editQuoteMeta.shipment_insurance) {
            if (vm.editQuoteMeta.insurance_leg_cost == "" || vm.editQuoteMeta.insurance_leg_cost == undefined) {
              util.showToast("Please Enter value of good!");
              return;
            } else if (vm.editQuoteMeta.insurance_leg_cost.toString().length > 12) {
              util.showToast("The value is too long");
              return;
            }
            if (vm.editQuoteMeta.insurance_currency == "" || vm.editQuoteMeta.insurance_currency == undefined) {
              util.showToast("Please select currency!");
              return;
            }
          }

          if (!angular.equals(vm.editQuoteMeta.insurance_currency, vm.search_param.insurance_currency) ||
            !angular.equals(vm.editQuoteMeta.insurance_leg_cost, vm.search_param.insurance_leg_cost)) {
            vm.fnFclLoadChanged();
          }
          vm.fetchLoad = true;
          vm.isQuoteModify = true;
        }

        vm.search_param = angular.copy(vm.editQuoteMeta);
        vm.search_param.hazardous_material = angular.copy(vm.hazardousEdit);
        // vm.search_param.inco_term = angular.copy(vm.incotermsEdit);

        if (vm.fetchLoad) {
          resultService.setLegFilter(vm.filterConfig, vm.search_param);

          // if(vm.newSearchFetch){
          //   vm.newSearchFetch = false;
          //   vm.fnSearchNewRates();
          // }
        }
      }
      vm.commodityValue = shareQuoteService.commodityString(vm.quote_result.result_data.commodity_data);
      $mdDialog.hide();
      vm.ifInitQuoteModify();
    }

    function fnFclLoadChanged() {
      if (vm.editLoadType.length) {
        vm.editQuoteMeta.load_data = util.formFclSearchData(vm.editQuoteMeta.load_data,vm.editLoadType);
      }

      vm.search_param = angular.copy(vm.editQuoteMeta);
      var calculateCo2e = false;

      var load_stat = {};
      var editedLoadType = [];
      vm.editQuoteMeta.load_data.load_details_value.forEach(function (load) {
        load_stat[load.type] = 0;
        editedLoadType.push(load.type);
      });

      if(angular.equals(editedLoadType, vm.defaultLoadType)){
        calculateCo2e = true;
      }

      vm.quote_CardData.forEach(function (card) {
        var getCurrencyRate = null;
        var vendor_0_obj = null;
        vm.currentCard = card;

        // calculate co2e 
        if(vm.currentCard.meta.co2eData && calculateCo2e){
          var co2Response = {
            'data' : [vm.currentCard.meta.co2eData]
          }
          
          resultService.fnCalculateCo2Total(co2Response, vm.search_param.load_data.load_details_value);
        }else if(!calculateCo2e){
          vm.currentCard.meta["co2eData"] = null;
        }

        getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
          function (element) {
            if (element.vendor_id == 0) {
              vendor_0_obj = element;
            }
            return element.vendor_id == card.meta.vendor_id;
          }
        );
        if (!getCurrencyRate) {
          if(card.meta.conversionRate)
            {
              getCurrencyRate = card.meta.conversionRate;
              vm.resultCardFilter.currency_conversion_rates.push(getCurrencyRate);
            }        
          }
        if (!getCurrencyRate) {
          getCurrencyRate = vendor_0_obj;
        }

        shareQuoteService.currencyConverter = {}; //Reset currency converter setting

        vm.currency_rates = getCurrencyRate.curr_data;

        // Currency conversion setting code
        shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency,getCurrencyRate.markup,getCurrencyRate.directCurrencyMapping,vm.currency_rates);

        // buy_rates/ sell_rates
        vm.quoteCardAfterSearchChange(card.data.buy_rates,vm.currency_rates,load_stat,card);
        vm.quoteCardAfterSearchChange(card.data.sell_rates,vm.currency_rates,load_stat,card);
        vm.percentageOnTotalBasis(card.data.buy_rates,card);
        vm.percentageOnTotalBasis(card.data.sell_rates,card);
        vm.percentageOnChargeBasis(card);
        card.meta.card_total_cost = resultService.calCardTotal(card.data[vm.buyOrSell]);
        if(!vm.util.isShipper && $rootScope.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL && card.data.buy_rates){
          card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
        }
        var getCardData = $filter("filter")(
          vm.temp_quoteData.result_data.cards,
          { _id: card._id },
          true
        );

        if (getCardData.length && !angular.equals(getCardData[0], card)) {
          if (card.meta["status"] == "remove") {
            card.meta["status"] = "editRemove";
          } else if (card.meta["status"] == "editRemove") {
            card.meta["status"] = "remove";
          } else {
            card.meta["status"] = "modified";
          }
        }
      });

      if (
        !angular.equals(
          vm.temp_quoteData.result_meta.search_param,
          vm.quote_result.result_meta.search_param
        )
      ) {
        vm.isSearchMetaModify = true;
      } else {
        vm.isSearchMetaModify = false;
      }
      vm.isQuoteModify = true;
    }

    function fnAirLclLoadChanged() {
      vm.search_param = angular.copy(vm.editQuoteMeta);

      vm.quote_CardData.forEach(function (card) {
        var getCurrencyRate = null;
        var vendor_0_obj = null;
        vm.currentCard = card;


        getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
          function (element) {
            if (element.vendor_id == 0) {
              vendor_0_obj = element;
            }
            return element.vendor_id == card.meta.vendor_id;
          }
        );

        if (!getCurrencyRate) {
          getCurrencyRate = vendor_0_obj;
        }

        shareQuoteService.currencyConverter = {}; //Reset currency converter setting

        vm.currency_rates = getCurrencyRate.curr_data;

        // Currency conversion setting code
        shareQuoteService.setCurrencyConvSetting(
          vm.searchUser.user_base_currency,
          getCurrencyRate.markup,
          getCurrencyRate.directCurrencyMapping,
          vm.currency_rates
        );

        // buy_rates/ sell_rates
        vm.quoteCardAfterLclAirSearchChange(
          card.meta,
          card.data.buy_rates,
          vm.currency_rates,
          card
        );
        vm.quoteCardAfterLclAirSearchChange(
          card.meta,
          card.data.sell_rates,
          vm.currency_rates,
          card
        );
        vm.percentageOnChargeBasis(card);
        vm.percentageOnTotalBasis(card.data.buy_rates,card);
        vm.percentageOnTotalBasis(card.data.sell_rates,card);
        card.meta.card_total_cost = resultService.calCardTotal(
          card.data[vm.buyOrSell]
        );
        if(!vm.util.isShipper && $rootScope.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL && card.data.buy_rates){
          card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
        }
        var getCardData = $filter("filter")(
          vm.temp_quoteData.result_data.cards,
          { _id: card._id },
          true
        );

        if (getCardData.length && !angular.equals(getCardData[0], card)) {
          if (card.meta["status"] == "remove") {
            card.meta["status"] = "editRemove";
          } else if (card.meta["status"] == "editRemove") {
            card.meta["status"] = "remove";
          } else {
            card.meta["status"] = "modified";
          }
        }
      });

      if (
        !angular.equals(
          vm.temp_quoteData.result_meta.search_param,
          vm.quote_result.result_meta.search_param
        )
      ) {
        vm.isSearchMetaModify = true;
      } else {
        vm.isSearchMetaModify = false;
      }
      vm.isQuoteModify = true;
    }

    function quoteCardAfterSearchChange(legs, currency_rates, load_stat , card) {
      angular.forEach(legs, function (leg_value, leg_key) {
        if (leg_value.rate_obj) {
          leg_value.rate_obj.load_stat = angular.copy(load_stat);
          var temp_charges = [];

          leg_value.rate_obj.charges.forEach(function (charge_value,charge_key) {
            var containerData = $filter("filter")(vm.editQuoteMeta.load_data.load_details_value,{ type: charge_value.container_type },true);

            if (containerData.length && leg_value.leg_code != "ins" + vm.modeName) {
              leg_value.rate_obj.load_stat[charge_value.container_type] = 1;
              temp_charges.push(charge_value);
            } else if (leg_value.leg_code == "ins" + vm.modeName) {
              charge_value.charge_cost = (0.05 / 100) * vm.search_param.insurance_leg_cost;
              charge_value.charge_currency = vm.search_param.insurance_currency;
              temp_charges.push(charge_value);
            } else if (charge_value.container_type == null ||charge_value.container_type == "") {
              temp_charges.push(charge_value);
            } else {
              // if charge is removed from array substract leg currency cost and total cost
              leg_value.rate_obj.leg_currency_cost -= charge_value.leg_currency_cost;
              leg_value.rate_obj.leg_total_cost -= charge_value.customer_currency_cost;
            }

            if (!charge_value.is_qty_editable) {
              shareQuoteService.fnGetFclTotalUnits(charge_value,vm.editQuoteMeta.load_data.load_details_value);
            }

            vm.conversionOnPriceChange( charge_value, leg_value.rate_obj );
          });
          leg_value.rate_obj.charges = angular.copy(temp_charges);

          shareQuoteService.LegCurrUpdate( legs, leg_key, leg_value.rate_obj.leg_currency, vm.search_param.mode, vm.searchUser.user_base_currency );

          // delete empty leg except freight
          if(leg_key != vm.l3_leg && !leg_value.rate_obj.charges.length){
            delete card.data.buy_rates[leg_key];
            delete card.data.sell_rates[leg_key];
          }
           //if l3 leg is empty then adding empty charge row  exept expired cards 
          if (
            leg_key == vm.l3_leg &&
            Object.keys(card.data.sell_rates).length == 1 &&
            !leg_value.rate_obj.charges.length &&
            (!card.data.sell_rates[vm.l3_leg].rate_obj.expiry ||
              new Date(card.data.sell_rates[vm.l3_leg].rate_obj.expiry) >
                new Date())
          ) {
            leg_value.rate_obj.charges.push(angular.copy(vm.cardChargeObj));
          }
        }
      });
    }
    function percentageOnChargeBasis(card){
      angular.forEach(card.data.sell_rates, function (leg_value, leg_key) {
        leg_value.rate_obj.charges.forEach(function (
          charge_value,
          charge_key
        ){
          shareQuoteService.fnFillBasisMetaCharge(charge_value,card.data.buy_rates[leg_key].rate_obj.charges[charge_key],leg_key,vm.search_param.mode);
        })
      });
      angular.forEach(card.data.sell_rates, function (leg_value, leg_key) {
        leg_value.rate_obj.charges.forEach(function (
          charge_value,
          charge_key
        ){
          if(charge_value.charge_basis && charge_value.charge_basis.includes('%') && !charge_value.charge_basis.includes('total')){
            charge_value.total_units = basisCalculation.basisOnTotalObj[charge_value.charge_basis] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].sell.leg_currency_cost : null;
            card.data.buy_rates[leg_key].rate_obj.charges[charge_key].total_units = basisCalculation.basisOnTotalObj[charge_value.charge_basis] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].buy.leg_currency_cost : null;
          }
          vm.conversionOnPriceChange(
            charge_value,
            leg_value.rate_obj
          );
          vm.conversionOnPriceChange(
            card.data.buy_rates[leg_key].rate_obj.charges[charge_key],
            card.data.buy_rates[leg_key].rate_obj
          );
        })
      });
       
    }
    function percentageOnTotalBasis(legs,card){
    
      angular.forEach(legs, function (leg_value, leg_key) {
        leg_value.rate_obj.charges.forEach(function (
          charge_value,
          charge_key
        ){
            if(charge_value.charge_basis === constObj.FREIGHT_TOTAL_BASIS){
              if(card.data.sell_rates['l3'+vm.modeName]){
                var convertedQuantity = shareQuoteService.currencyConverter.convert(parseFloat(legs['l3'+vm.modeName].rate_obj.leg_currency_cost),card.data.sell_rates['l3'+vm.modeName].rate_obj.leg_currency,card.data.sell_rates[leg_key].rate_obj.leg_currency);
                charge_value.total_units   = convertedQuantity;
              }
            }
            vm.conversionOnPriceChange(
              charge_value,
              leg_value.rate_obj
            );
        });
      });
    }
    function showTemplateAction(ev){
      var position = vm._mdPanel.newPanelPosition()
      .relativeTo('.edit-actions')
      .addPanelPosition(vm._mdPanel.xPosition.OFFSET_END, vm._mdPanel.yPosition.BELOW);
      var config = {
        attachTo: angular.element(document.body),
        templateUrl:'app/main/quotes/quotesDetails/template-panel/template-panel.html',
        controllerAs: "ctrl",
        controller:function () {
          this.parent = vm;
        },
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
      };
      vm._mdPanel.open(config).then(function(ref){
        vm._mdPaneRef = ref;
      });     
    }

    function quoteCardAfterLclAirSearchChange(cardMeta, legs, currency_rates, currentCard) {
    
      angular.forEach(legs, function (leg_value, leg_key) {
        var temp_charges = [];
        if (leg_value.rate_obj) {
          leg_value.rate_obj.charges.forEach(function (
            charge_value,
            charge_key
          ) {
            if (leg_value.leg_code != "ins" + vm.modeName) {
              var payload = {
                charge: charge_value,
                load_meta: vm.search_param.load_data.load_meta,
                airFreightValue:
                   null,
                pickupValue:
                 null,
                deliveryValue:
                  null,
                global_leg_id: leg_value.rate_obj.global_leg_id,
                ltl_load_details: cardMeta["ltl_load_details"],
                mode: vm.search_param.mode,
                dimChargeableValue:
                  leg_value.rate_obj.dim_data &&
                  leg_value.rate_obj.dim_data.chargeable_weight_in_kg &&
                  leg_value.rate_obj.dim_data.chargeable_weight_in_kg !== 0
                    ? leg_value.rate_obj.dim_data.chargeable_weight_in_kg
                    : null,
              };

              if (!charge_value.is_qty_editable) {
                shareQuoteService.fnGetContainerQty(payload);
              }
            } else if (leg_value.leg_code == "ins" + vm.modeName) {
              charge_value.charge_cost =
                (0.05 / 100) * vm.search_param.insurance_leg_cost;
              charge_value.charge_currency = vm.search_param.insurance_currency;
              temp_charges.push(charge_value);
            }

            if (charge_value.per_unit_rate != null && charge_value.total_units != null) {
              var per_unit = parseFloat(charge_value.per_unit_rate) || 0;
              var total_units = charge_value.total_units == "" ? 0 : parseFloat(charge_value.total_units);

              if (charge_value.charge_basis == shareQuoteService.airBasisName) {
                charge_value.charge_currency = leg_value.rate_obj.leg_currency;
                charge_value.charge_cost = (per_unit * total_units) / 100;
              } else {
                charge_value.charge_cost = per_unit * total_units;
              }
            }

            temp_charges.push(charge_value);
          });

          leg_value.rate_obj.charges = angular.copy(temp_charges);

          shareQuoteService.LegCurrUpdate(
            legs,
            leg_key,
            leg_value.rate_obj.leg_currency,
            vm.search_param.mode,
            vm.searchUser.user_base_currency
          );
        }
      });
   
    }

    function fnGetLoadList() {
      if (util.limitObj.length <= 0) {
        SearchService.getAllLoadList().then(
          function (response) {
            vm.container_type = angular.copy(response);
            util.limitObj = response;
            SearchService.loadTypeArr = util.limitObj;
            vm.fnFormLoadArr(vm.container_type);
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        SearchService.loadTypeArr = util.limitObj;
        vm.container_type = angular.copy(util.limitObj);
        vm.fnFormLoadArr(vm.container_type);
      }
    }

    function fnFormLoadArr(load_list) {
      angular.forEach(load_list, function (value) {
        value.count = 0;
        value.type = value.load_code;
      });
    }

    function reduceContainerSize(container_type, load) {
      var isContainer = vm.search_param.load_data.load_details_value.some(
        function (el) {
          return el.type === load.type;
        }
      );

      if (isContainer && load.count == 1) {
        util.showToast("You do not have access to remove " + load.type + " !");
        return;
      }

      util.reduceContainerSize(container_type, load.type);
    }

    function increaseContainerSize(container_type, load) {
      util.increaseContainerSize(container_type, load.type);
    }

    //Add load - Air,Lcl
    function add_lcl_air_load(load_data) {
      SearchService.airLcl_add_load(load_data.load_details_value);
    }

    //remove load - Air,Lcl
    function rm_lcl_air_load(index, load_data) {
      SearchService.airLcl_remove_load(index, load_data.load_details_value);
    }
    // vm.getQuotesActivityList();

    // function to get activity list
    function getQuotesActivityList() {
      if (vm.quote_result.result_data.activity) {
        QuotesService.getQuotesActivityList(
          vm.quote_result.result_data.activity._id
        ).then(
          function (response) {
            vm.activityList = response;
          },
          function (error) {
            $log.log(error.data);
          }
        );
      }
    }

    function closeToast() {
      $mdToast.hide();
    }

    function fnGetColorByStatusName(status) {
      return util.fnGetColorBuStatusName(status);
    }

    function terms_condition_focus(className) {
      if (document.getElementById(className).value === "") {
        document.getElementById(className).value += "• ";
      }
    }

    function terms_condition_key_up(event, className) {
      util.getBulletPontOnInput(event, className);
    }

    function fnDefaultTermsAndConditions() {
      if (!vm.showTermsConditions) {
        vm.termsEdit = util.decodeValue(vm.stdTermsAndConditions);
      } else {
        // var defalutTerms = angular.copy(vm.temp_quoteData.result_data.terms);
        vm.termsEdit = util.decodeValue(vm.quote_result.result_data.terms);
        // vm.termsEdit = shareQuoteService.fnProcessTermsString(defalutTerms);
      }
    }

    function getQuoteVersion(str) {
      var result = "A";
      if (str.split("-")[1] != undefined) {
        result = str.split("-")[1];
      }
      return result;
    }

    function nextVersionChar(c) {
      return String.fromCharCode(c.charCodeAt(0) + 1);
    }

    function getCardHeight(id) {
      var height = angular.element("#" + id)[0].offsetHeight + 5;
      var hoverCardHeight = {
        height: height,
      };
      return hoverCardHeight;
    }

    function getCardFlexValue(card_size) {
      if (card_size == 0) {
        var widget_back_height = angular.element(".new_card_back").height();
        vm.widget_back_height = {
          height: widget_back_height,
        };
      } else {
        vm.widget_back_height = {
          height: "unset",
        };
      }

      var windowWidth = angular.element(window).width();
      var flexValue;
      if (
        !vm.isShared &&
        util.navPermission.quotes[2] &&
        !vm.quote_result.result_data.is_booked &&
        !vm.quote_result.result_data.revised &&
        !vm.quotePreview &&
        !vm.isLost
      ) {
        if (windowWidth <= 1100) {
          flexValue = 60;
        }
        if (windowWidth <= 1330) {
          if (card_size > 2) {
            flexValue = 75;
          }
        }
        if (windowWidth <= 1750) {
          if (card_size > 3) {
            flexValue = 75;
          }
        }
        if (windowWidth > 1750) {
          if (card_size > 4) {
            flexValue = 75;
          }
        }
      }
      return flexValue;
    }


    function getTimeStampValue(date) {
      var time_ago;
      date = moment.utc(date).local();
      time_ago = timeSince(date);
      return time_ago;
    }

    function timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);
      var interval = Math.floor(seconds / 31536000);
      if (interval > 1) {
        return interval + " years";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours";
      }
      interval = Math.floor(seconds / 60);
      if (interval >= 1) {
        return interval + " minutes";
      }
      if (seconds < 0) {
        return "0 seconds";
      }
      return Math.floor(seconds) + " seconds";
    }

    function ifInitQuoteModify() {
      vm.isQuoteModify = false;
      var loadData = angular.copy(vm.search_param.load_data);
      var initLoadData = angular.copy(vm.temp_quoteData.result_meta.search_param.load_data);

      var withoutLoad = angular.copy(vm.search_param);
      delete withoutLoad["load_data"];
      var initWithoutLoad = angular.copy(vm.temp_quoteData.result_meta.search_param);
      delete initWithoutLoad["load_data"];

      if (!angular.equals(initLoadData, loadData)) {
        if (vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(parseFloat($filter("number")(initLoadData.load_meta.volumetric_weight, 3)),parseFloat($filter("number")(loadData.load_meta.volumetric_weight, 3)))
        ) {
          vm.isQuoteModify = true;
          // console.log('search volumetric changed');
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(parseFloat($filter("number")(initLoadData.load_meta.chargeable_weight, 3)),parseFloat($filter("number")(loadData.load_meta.chargeable_weight, 3))
          )
        ) {
          vm.isQuoteModify = true;
          // console.log('search chargeable changed');
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(parseFloat($filter("number")(initLoadData.load_meta.gross_weight, 3)),parseFloat($filter("number")(loadData.load_meta.gross_weight, 3))
          )
        ) {
          vm.isQuoteModify = true;
          // console.log('search gross changed');
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(initLoadData.load_meta.total_bl,loadData.load_meta.total_bl)
        ) {
          vm.isQuoteModify = true;
          // console.log('search changed');
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode == "SEA-FCL"
        ) {
          vm.isQuoteModify = true;
          // console.log('search changed');
        }
      }

      if (!angular.equals(initWithoutLoad, withoutLoad)) {
        vm.isQuoteModify = true;
        // console.log('search changed');
      }

      if (
        !angular.equals(new Date(vm.temp_quoteData.result_data.expiry_date).getTime(),new Date(vm.quote_result.result_data.expiry_date).getTime() ) ||
        !angular.equals(vm.temp_quoteData.result_data.hazardous, vm.quote_result.result_data.hazardous ) ||
        !angular.equals(vm.temp_quoteData.result_data.customs, vm.quote_result.result_data.customs ) ||
        !angular.equals(vm.temp_quoteData.result_data.perishable, vm.quote_result.result_data.perishable ) ||
        !angular.equals(vm.temp_quoteData.result_data.terms, vm.quote_result.result_data.terms ) ||
        !angular.equals(vm.temp_quoteData.result_data.incoterms, vm.quote_result.result_data.incoterms) || 
        !angular.equals(vm.temp_quoteData.result_data.commodity_data, shareQuoteService.commodityString(vm.quote_result.result_data.commodity_data))
      ) {
        vm.isQuoteModify = true;
        // console.log('extra param changed');
      }
      vm.fnCheckCardsDetails();
    }

    function fnCheckCardsDetails() {
      if (vm.quote_CardData.length != vm.temp_quoteData.result_data.cards.length) {
        vm.isQuoteModify = true;
        // console.log('card added or remove');
      } else {
        vm.quote_CardData.forEach(function (card) {
          var getCard = $filter("filter")(vm.temp_quoteData.result_data.cards,{ _id: card._id },true);
          if (getCard.length) {
            vm.fnCheckMetaDetails(getCard,card);
            if (
              !angular.equals(getCard[0].meta.selected_schedule,card.meta.selected_schedule) ||
              card.meta["status"] == "editRemove" ||
              card.meta["status"] == "remove" ||
              !angular.equals(getCard[0].meta.remarks, card.meta.remarks) ||
              !angular.equals(getCard[0].meta.inclusions,card.meta.inclusions) ||
              (getCard[0].data.sell_rates &&
                (!angular.equals(getCard[0].data.sell_rates[vm.l3_leg].rate_obj.service_type,card.data.sell_rates[vm.l3_leg].rate_obj.service_type) ||
                  card.data.sell_rates[vm.l3_leg].rate_obj.expiry &&  
                  !angular.equals($filter("date")(new Date(getCard[0].data.sell_rates[vm.l3_leg].rate_obj.expiry), "yyyy-MM-dd"),$filter("date")(new Date(moment.utc(card.data.sell_rates[vm.l3_leg].rate_obj.expiry).format()),"yyyy-MM-dd"))
                ))
            ) {
              vm.isQuoteModify = true;
              // console.log('card schedule changed/ card delete');
            }

            if (
              getCard[0].data.sell_rates &&
              Object.keys(card.data.sell_rates).length !=
                Object.keys(getCard[0].data.sell_rates).length
            ) {
              vm.isQuoteModify = true;
              // console.log('leg add or remove');
            } else {
              angular.forEach(card.data.sell_rates,function (rateValue, rateKey) {
                  var isLegPresent = false;
                  if (getCard[0].data.sell_rates) {
                    var isLegPresent = Object.keys(getCard[0].data.sell_rates).some(function (key) {
                      if (rateKey == key) {
                        return true;
                      }
                      return false;
                    });
                  }

                  if (isLegPresent) {
                    if (rateValue.rate_obj) {
                      if (
                        !angular.equals(
                          rateValue.leg_name,
                          getCard[0].data.sell_rates[rateKey].leg_name
                        ) ||
                        !angular.equals(
                          rateValue.rate_obj.leg_currency,
                          getCard[0].data.sell_rates[rateKey].rate_obj
                            .leg_currency
                        )
                      ) {
                        vm.isQuoteModify = true;
                        // console.log('leg currency or name changed');
                      }

                      if (
                        rateValue.rate_obj.charges.length !=
                        getCard[0].data.sell_rates[rateKey].rate_obj.charges
                          .length
                      ) {
                        vm.isQuoteModify = true;
                        // console.log('chanrge add or remove');
                      } else {
                        rateValue.rate_obj.charges.forEach(function (
                          chargeValue
                        ) {
                          var getCharge = $filter("filter")(
                            getCard[0].data.sell_rates[rateKey].rate_obj
                              .charges,
                            { charge_id: chargeValue.charge_id },
                            true
                          );

                          var getBuyCharge = $filter("filter")(
                            getCard[0].data.buy_rates[rateKey].rate_obj.charges,
                            { charge_id: chargeValue.charge_id },
                            true
                          );
                          var initBuyCharge = $filter("filter")(
                            card.data.buy_rates[rateKey].rate_obj.charges,
                            { charge_id: chargeValue.charge_id },
                            true
                          );

                          if (getCharge.length || getBuyCharge.length) {
                            if (
                              !angular.equals(
                                chargeValue.charge_name,
                                getCharge[0].charge_name
                              ) ||
                              !angular.equals(
                                chargeValue.charge_currency,
                                getCharge[0].charge_currency
                              ) ||
                              !angular.equals(
                                chargeValue.per_unit_rate,
                                getCharge[0].per_unit_rate
                              ) ||
                              !angular.equals(
                                chargeValue.total_units,
                                getCharge[0].total_units
                              ) ||
                              !angular.equals(
                                chargeValue.minimum_charge_cost,
                                getCharge[0].minimum_charge_cost
                              ) ||
                              !angular.equals(
                                chargeValue.maximum_charge_cost,
                                getCharge[0].maximum_charge_cost
                              )  ||
                              !angular.equals(
                                chargeValue.charge_basis,
                                getCharge[0].charge_basis
                              ) ||
                              !angular.equals(
                                getBuyCharge[0].charge_currency,
                                initBuyCharge[0].charge_currency
                              ) ||
                              !angular.equals(
                                getBuyCharge[0].per_unit_rate,
                                initBuyCharge[0].per_unit_rate
                              ) ||
                              !angular.equals(
                                getBuyCharge[0].minimum_charge_cost,
                                initBuyCharge[0].minimum_charge_cost
                              )||
                              !angular.equals(
                                getBuyCharge[0].maximum_charge_cost,
                                initBuyCharge[0].maximum_charge_cost
                              )
                            ) {
                              vm.isQuoteModify = true;
                              // console.log('charge basis/ name/ currency/ unit changed');
                            }
                          } else {
                            vm.isQuoteModify = true;
                            // console.log('new charge added');
                          }
                        });
                      }
                    }
                  } else {
                    vm.isQuoteModify = true;
                    // console.log('card new leg added');
                  }
                }
              );
            }
          } else {
            vm.isQuoteModify = true;
            // console.log('card added changed');
          }
        });
      }
    }

    function fnCheckMetaDetails(getCard,card){
     // Pickup Location , Origin Haulage , port of  Origin  ,Delivery ,Destination Haulage,port of Destination
      if(!angular.equals(getCard[0].meta.port_data, card.meta.port_data) ||
         !angular.equals(getCard[0].meta.haulage, card.meta.haulage) ||
         !angular.equals(getCard[0].meta.destination_haulage, card.meta.destination_haulage) ||
         !angular.equals(getCard[0].meta.via_pod, card.meta.via_pod) ||
         !angular.equals(getCard[0].meta.via_pol, card.meta.via_pol) 
       ){
        vm.isQuoteModify = true;
       }

     // sailing date ,commodity ,cargo type , liner , airline , transist time, ETA , ETD  , Via Port,Free days
     if(getCard[0].data.sell_rates &&(
      !angular.equals(
       getCard[0].data.sell_rates[vm.l3_leg].rate_obj.sailing_date ,
       card.data.sell_rates[vm.l3_leg].rate_obj.sailing_date) ||
      !angular.equals(
       getCard[0].data.sell_rates[vm.l3_leg].rate_obj.commodity_data ,
       card.data.sell_rates[vm.l3_leg].rate_obj.commodity_data) ||
      !angular.equals(
       getCard[0].data.sell_rates[vm.l3_leg].rate_obj.cargo_type_data ,
       card.data.sell_rates[vm.l3_leg].rate_obj.cargo_type_data) ||
      !angular.equals(
        getCard[0].data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name ,
        card.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name) ||
      !angular.equals(
        getCard[0].data.sell_rates[vm.l3_leg].rate_obj.transit_time ,
        card.data.sell_rates[vm.l3_leg].rate_obj.transit_time) ||
      !angular.equals(getCard[0].data.sell_rates[vm.l3_leg].rate_obj.airline, card.data.sell_rates[vm.l3_leg].rate_obj.airline) ||
       !angular.equals(
         getCard[0].data.sell_rates[vm.l3_leg].rate_obj.departure_time,
         card.data.sell_rates[vm.l3_leg].rate_obj.departure_time) ||
       !angular.equals(
         getCard[0].data.sell_rates[vm.l3_leg].rate_obj.arrival_time,
         card.data.sell_rates[vm.l3_leg].rate_obj.arrival_time) ||
        !angular.equals(
          getCard[0].data.sell_rates[vm.l3_leg].rate_obj.via_route,
          card.data.sell_rates[vm.l3_leg].rate_obj.via_route) ||
       !angular.equals(
         getCard[0].data.sell_rates[vm.l3_leg].rate_obj.demurrage_details,
         card.data.sell_rates[vm.l3_leg].rate_obj.demurrage_details) ||
       !angular.equals(
          getCard[0].data.sell_rates[vm.l3_leg].rate_obj.detention_details,
          card.data.sell_rates[vm.l3_leg].rate_obj.detention_details) ||  
       !angular.equals(
          getCard[0].data.sell_rates[vm.l3_leg].rate_obj.origin_free_days,
          card.data.sell_rates[vm.l3_leg].rate_obj.origin_free_days) ||
       !angular.equals(
          getCard[0].data.sell_rates[vm.l3_leg].rate_obj.destination_free_days ,
          card.data.sell_rates[vm.l3_leg].rate_obj.destination_free_days )     
       )){
         vm.isQuoteModify = true;
       }
    }

    function fnOpenSetReminderModal(ev) {
      if(vm.disableSetReminder){
        return;
      }
      vm.remdinerDisabledButton = true;
      vm.dateValidation = false;
      if (vm.quote_result.result_data.reminder) {
        vm.oldReminder = angular.copy(
          vm.quote_result.result_data.reminder.reminder_date
        );
      }

      var date = new Date();
      date.setDate(date.getDate() + 1);
      vm.set_reminder_obj = {
        End_date: angular.copy(new Date(vm.quote_result.result_data.expiry_date)),
        Start_date: date,
        reminder_date: vm.quote_result.result_data.reminder ? util.dateReplace(vm.quote_result.result_data.reminder.reminder_date) : null,
      };

      $mdDialog.show({
        templateUrl: "app/main/quotes/dialogs/set-Reminder/set-reminder.html",
        targetEvent: ev,
        clickOutsideToClose: false,
        onComplete: vm.afterShowAnimation,
        animation: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }
    function fnSetReminderApi(statusData,form) {
      if(!vm.set_reminder_obj.reminder_date){
        vm.dateValidation = true;
      }
      if(vm.dateValidation || form.$invalid){
        return
      }
      var newStatus = angular.copy(statusData);
      var display = vm.oldReminder
        ? "A reminder has been update from " +
          moment(vm.oldReminder).format("DD MMM YYYY") +
          " to " +
          moment(statusData).format("DD MMM YYYY")
        : "A reminder has been set for " +
          moment(statusData).format("DD MMM YYYY");
      var activityObj = {
        message: display,
        type: "reminder",
        comment: "",
        timestamp: new Date(),
        user_id: util.userProfile.user.id,
        user_name:
          util.userProfile.user.user_first_name +
          " " +
          util.userProfile.user.user_last_name,
        activity_data: [],
      };
      var reminder = {
        quote_id: vm.quote_result.result_data._id,
        user_id: util.userProfile.user.id,
        reminder_id: vm.quote_result.result_data.reminder
          ? vm.quote_result.result_data.reminder._id
          : "",
        reminder_date: moment(statusData).format(),
        comment: "",
        user_email: util.userProfile.user.email,
      };
      var data = {
        data: {
          activity: [activityObj],
          reminder: reminder,
        },
      };

      QuotesService.setReminder(data).then(
        function () {
          if (!vm.quote_result.result_data.reminder) {
            vm.quote_result.result_data.reminder = {};
          }
          vm.quote_result.result_data.reminder.reminder_date = angular.copy(
            data.data.reminder.reminder_date
          );
          vm.quoteActivity.activity.push(activityObj);
          vm.cancelDialog();
          vm.responseStatusData.push({
            responseFrom: "QUOTES",
            status: "COMPLETED",
            message: display,
          });
          // vm.showResponse('response-success',display);
        },
        function (error) {
          vm.disabledStatusSubmit = false;
          vm.cancelDialog();
          vm.responseStatusData.push({
            responseFrom: "QUOTES",
            status: "FAILED",
            message: "Unable to set reminder!Please Retry",
          });
          $log.log(error);
        }
      );
    }
    function removeResponse(id, index) {
      util.callMixpanel("QD-RemoveResponse-Click", {
        Mode: vm.search_param.mode,
      });
      vm.responseStatusData.splice(index, 1);
    }
    // Funtion to open RFQ form modal
    function fnOpenMatchRatesModal(ev) {
      if (vm.util.isAdmin) {
        vm.pageSource = "QD-RBR";
      }
      else{
        util.callMixpanel('QD-MatchRates-Click',{
          Mode: vm.search_param.mode,
        });
        vm.pageSource = "QD-MatchRates";
      }
      $mdDialog.show({
        template:
          '<md-dialog id="wls-match-rates" class="popup-md"><match-rates page-source="ctrl.parent.pageSource" matchratesparam="ctrl.parent.matchRatesObj"></match-rates></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () {
          this.parent = vm;
        },
        controllerAs: "ctrl",
      });
    }

    // open vas modal
    function fnOpenVASModal(ev) {
      //mixpanel code
      util.callMixpanel("QD-VAS-Click");

      vm.quote_result.result_data.additional_charges =
        vm.quote_result.result_data.hasOwnProperty("additional_charges")
          ? vm.quote_result.result_data.additional_charges
          : {};

      if (!Object.keys(vm.vasDetails.legList).length) {
        vm.vasDetails.legList = vm.getLegDetailsForVas();
      }

      $mdDialog.show({
        template:
          '<md-dialog class="vas-charge dialobox" ng-cloak><md-dialog-content class="p-0 vas-charge-dialog"><vas-charge vasdetails="ctrl.parent.vasDetails" callback="ctrl.parent.ctrlapplyVASLegToQuoteCard(data)"></vas-charge></md-dialog-content></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
      });
    }

    function ctrlapplyVASLegToQuoteCard(vasdetails) {
      // applyting vas charges to existing quote cards
      vm.matchRatesObj.additional_charges.selected = vm.vasDetails.legList;
      vm.matchRatesObj.additional_charges.available =
        vm.vasDetails.value_added_charges;
      var rate_cards = vm.quote_CardData;
      resultService.applyVASLegToCard(
        rate_cards,
        vasdetails.data.legList,
        "quote"
      );
      vm.isVasApplied = true;
      vm.ifInitQuoteModify();
    }

    //callback function from card component
    function showQuoteProceedDiv(item) {
      if(item.hasOwnProperty('sourceRate')){
        vm.sourceRate=item.sourceRate;
      }
      if (item.action == "duplicate") {
        vm.selectedDuplicateQuote(item.currentCard);
      }

      if (item.action == "viewQuoteRates") {
        if(item.activeTab == 'quotationEdit'){
          vm.fnAddOrEditCard(item.currentCard, 'editCardQuote', item.ev);
        }else{
          vm.viewDetailsModal(item.currentCard, item.ev, item.activeTab);
        }
      }
      if (item.action == "undoDeleteCard" && !vm.isDuplicateQuote) {
        vm.undoDeleteCard(item.ev, item.currentCard._id, item.index);
      }
      if (item.action == "undoDeleteCard" && vm.isDuplicateQuote) {
        document
          .getElementById(
            item.currentCard._id + "_" + item.index + "_askDeletecard"
          )
          .classList.add("hide");
        document
          .getElementById(
            item.currentCard._id + "_" + item.index + "_deletecard"
          )
          .classList.add("hide");
        vm.selectedDuplicateQuote(item.currentCard, "deleteCopyQuote");
      }
      if (item.action == "cancelDeleteCard") {
        vm.cancelDeleteCard(item.ev, item._id, item.index);
      }
      if (item.action == "removeCardFromQuote") {
        vm.removeCardFromQuote(item.ev, item.currentCard._id, item.index);
      }
      if (item.action == "removeCardFromQuote" && vm.isDuplicateQuote) {
        document.getElementById(item.currentCard._id + "_" + item.index +"_askDeletecard").classList.add("hide");
        document
          .getElementById(
            item.currentCard._id + "_" + item.index + "_deletecard"
          )
          .classList.remove("hide");
        vm.selectedDuplicateQuote(item.currentCard, "deleteCopyQuote");
      }

      if (item.action == "bookRequest") {
        // if(! item.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0].charge_id){ return false;}
        vm.requestToBook(item.currentCard);
      }

      if (item.action == "addRate") {
        item.currentCard.data.buy_rates[vm.l3_leg].rate_obj.manual = 1;
        item.currentCard.data.sell_rates[vm.l3_leg].rate_obj.manual = 1;
        resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,item.currentCard);
        delete item.currentCard.meta.view;
        delete item.currentCard.meta["slabPersentage"];
        delete item.currentCard.meta["selectedLeg"];
        delete item.currentCard.meta["init_sort_total"];
        delete item.currentCard.data.buy_rates[vm.l3_leg]["rate_obj_1"];
        delete item.currentCard.data.buy_rates[vm.l3_leg]["rate_obj_2"];
        delete item.currentCard.data.sell_rates[vm.l3_leg]["rate_obj_1"];
        delete item.currentCard.data.sell_rates[vm.l3_leg]["rate_obj_2"];

        item.currentCard.meta["status"] = "new";
        vm.addInQuote(item.currentCard, "newCard");
        $mdDialog.hide();
      } else if(item.action == "editRate"){
        vm.shareQuoteService.copysellToBuy(item.currentCard, vm.search_param.mode, vm.l3_leg);
        resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,item.currentCard);
        var getCardData = $filter("filter")(
          vm.quote_CardData,
          { _id: item.currentCard._id },
          true
        );
        var index = vm.quote_CardData.indexOf(getCardData[0]);

        item.currentCard.meta["status"] = item.currentCard.meta["status"] != "new" ? "modified" : "new";
        vm.quote_CardData[index] = angular.copy(item.currentCard);
        vm.fnCheckCardsDetails();
        $mdDialog.hide();
      }  else if (item.action == "scheduleSelect") {
        if (item.currentCard.meta.type == "msr_rates") {
          var tempId = $filter("filter")(
            vm.newMsrCards.data.cards,
            { _id: item.currentCard._id },
            true
          );
          tempId[0].meta.selected_schedule =
            item.currentCard.meta.selected_schedule;
          tempId[0].meta.multi_schedule_list =
            item.currentCard.meta.multi_schedule_list || [];
        } else if (item.currentCard.meta.type == "iata_rates") {
          var tempId = $filter("filter")(
            vm.newIataCards.data.cards,
            { _id: item.currentCard._id },
            true
          );
          tempId[0].meta.selected_schedule =
            item.currentCard.meta.selected_schedule;
          tempId[0].meta.multi_schedule_list =
            item.currentCard.meta.multi_schedule_list || [];
        } else {
          var tempId = $filter("filter")(
            vm.newNetworkCards.data.cards,
            { _id: item.currentCard._id },
            true
          );
          tempId[0].meta.selected_schedule =
            item.currentCard.meta.selected_schedule;
          tempId[0].meta.multi_schedule_list =
            item.currentCard.meta.multi_schedule_list || [];
        }
      } else if (item.action == "removeFromQuote") {
        vm.removeFromQuote(item.currentCard);

        if (!vm.quoteArray.length) {
          vm.resultCardFilter.hideBookBtn = false;
        }
      } else if (item.action == "bookingRequest") {
        vm.requestToBook(item.currentCard);
      } else if (item.action == "deleteCharge") {
        var index = vm.quoteArray.indexOf(item.currentCard._id);
        if (index > -1) {
          vm.quoteArray.splice(index, 1);
          item.currentCard.meta.is_selected = false;
          item.currentCard.data.sell_rates = null;
          vm.selectedCard.pop(item.currentCard);
        }
      } else if (item.action == "manualCardDelete") {
        vm.openDeleteCard(item, item.currentCard._id, item.index);
      } else if (item.action == "manualCardEdit") {
        vm.openEditCardModal(item.currentCard);
      }
      else if(item.action == "reSyncTmsData"){
        vm.reSyncTmsData(item.currentCard);
      }
    }

    function getLegDetailsForVas() {
      var legObj = resultService.getAdditionLegStructure(vm.search_param);
      var legList = { buy_rates: {}, sell_rates: {} };
      legList.buy_rates["additional_services"] = angular.copy(legObj);
      legList.sell_rates["additional_services"] = angular.copy(legObj);
      return legList;
    }

    function fnCheckIsNaN(charge, param) {
      var result = "";
      if (param == "per_unit_rate") {
        if (angular.isString(charge.per_unit_rate)) {
          result = charge.per_unit_rate;
        } else {
          result = $filter("number")(charge.per_unit_rate, 2);
        }
      } else {
        if (!charge.min_flag && angular.isString(charge.charge_cost)) {
          result = charge.charge_cost;
        } else {
          result = $filter("number")(charge.leg_currency_cost, 2);
        }
      }
      return result;
    }

    function isString(data) {
      if (typeof data === "string") {
        return true;
      } else {
        return false;
      }
    }

    function fnCardStructure() {
      vm.cardChargeObj = {
        id: "0001",
        charge_id: "",
        charge_name: "",
        charge_description: null,
        charge_type: "FIXED",
        charge_basis: "",
        per_unit_rate: 0,
        total_units: 0,
        charge_cost: 0,
        charge_currency: vm.searchUser.user_base_currency,
        minimum_charge_cost: vm.search_param.mode === "SEA-FCL" ?  'NA' : "",
        maximum_charge_cost: vm.search_param.mode === "SEA-FCL" ?  'NA' : "",

        container_type: null,
        global_charge_id: "",
        customer_currency_cost: 0,
        leg_currency_cost: 0,
        tax_type: "GST",
        tax_percent: 0,
        manual: true,
        is_qty_editable: false,
        charge_category: null,
        charge_code: "",
      };

      vm.cardLegData = {
        leg_name: "",
        leg_code: "",
        vendor_id: vm.isShared ? "" : vm.authValue.vendor_id,
        rate_obj: {
          agent_id: "",
          _id: "",
          schedule: {
            url: null,
            data: [],
          },
          analytics: {
            graph: {
              url: null,
            },
          },
          is_special: false,
          charges: [],
          manual: 1,
          airline: {
            air_line_name: "",
            airline_code: "",
            airline_prefix: "",
          },
          airline_code: null,
          slab_currency: null,
          slab: null,
          rate_type: "msr_rate",
          leg_name: "",
          leg_code: "",
          vendor_id: vm.isShared ? "" : vm.authValue.vendor_id,
          sub_vendor_id: null,
          service_type: null,
          via_route: null,
          transit_time: null,
          contract_number: "",
          remarks: null,
          inclusions: null,
          expiry: null,
          other_charges: null,
          if_applicable_charges: null,
          load_stat: null,
          global_leg_id: "",
          leg_total_cost: 0,
          leg_total_currency: vm.searchUser.user_base_currency,
          leg_currency_cost: 0,
          leg_currency: vm.searchUser.user_base_currency,
          vendor: {
            vendor_name: vm.isShared ? "" : vm.authValue.vendor_name,
          },
          sub_vendor: {
            sub_vendor_name: "",
            carrier_code: "",
            logo: null,
          },
          ltl_load_details: null,
          commodity_data: [],
          cargo_type_data: null,
        },
      };

      vm.is_nearbyOrigin_icd = 0;
      vm.is_nearbyDestination_icd = 0;
      if (vm.search_param.nearby_ports.length) {
        for (var i = 0; i < vm.search_param.nearby_ports.length; i++) {
          if (vm.search_param.nearby_ports[i].is_icd_port) {
            vm.is_nearbyOrigin_icd = 1;
            break;
          }
        }
      }

      if (vm.search_param.nearby_ports_destination.length) {
        for (
          var i = 0;
          i < vm.search_param.nearby_ports_destination.length;
          i++
        ) {
          if (vm.search_param.nearby_ports_destination[i].is_icd_port) {
            vm.is_nearbyDestination_icd = 1;
            break;
          }
        }
      }

      vm.quoteNewCardInit = {
        data: {
          sell_rates: {},
          buy_rates: {},
        },
        meta: {
          airline_code: null,
          card_total_cost: 0,
          delta_percent: null,
          haulage: "",
          destination_haulage: "",
          haulage_available: false,
          inclusions: null,
          is_selected: false,
          network_id: null,
          port_data: {
            pickup_location:
              vm.search_param.origin_location.place_type == "Door"
                ? vm.search_param.origin_location.location
                : null,
            origin_port_code: null,
            origin_portname: vm.search_param.origin_location.portname,
            is_icd_port_origin:
              vm.search_param.origin_location.is_icd_port ||
              vm.is_nearbyOrigin_icd,

            delivery_location:
              vm.search_param.destination_location.place_type == "Door"
                ? vm.search_param.destination_location.location
                : null,
            destination_port_code: null,
            destination_portname: vm.search_param.destination_location.portname,
            is_icd_port_destination:
              vm.search_param.destination_location.is_icd_port ||
              vm.is_nearbyDestination_icd,
          },
          remarks: null,
          selected_schedule: null,
          type: "msr_rates",
          vendor_id: vm.isShared ? "" : parseInt(vm.authValue.vendor_id),
          via_pod: null,
          via_pol: null,
          ltl_load_details: null,
        },
        schedule: [],
        sub_vendor: "",
        airline: "",
        _id: "",
      };
    }

    function getVasDetails() {
      if (!vm.quote_result.result_data.hasOwnProperty("additional_charges")) {
        vm.quote_result.result_data.additional_charges = {
          selected: {},
          available: {},
        };
      }

      if (vm.search_param.origin_charges) {
        vm.curr_vas_leg_arr.push("l2");
      }
      if (vm.search_param.origin_customs) {
        vm.curr_vas_leg_arr.push("l2_cha");
      }
      if (vm.search_param.destination_charges) {
        vm.curr_vas_leg_arr.push("l2");
      }
      if (vm.search_param.destination_customs) {
        vm.curr_vas_leg_arr.push("l2_cha");
      }

      var getCurrencyRate = null;
      var vendor_0_obj = null;

      getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
        function (element) {
          if (element.vendor_id == 0) {
            vendor_0_obj = element;
          }
          return (
            element.vendor_id ==
            (util.isFreightbro &&
            localStorageService.get("forwarder") &&
            localStorageService.get("forwarder").value
              ? localStorageService.get("forwarder").value.vendor_id
              : vm.authValue.vendor_id)
          );
        }
      );

      if (!getCurrencyRate) {
        getCurrencyRate = vendor_0_obj;
      }

      vm.vasDetails = {
        search_param: vm.search_param,
        legList: Object.keys(
          vm.quote_result.result_data.additional_charges.selected
        ).length
          ? vm.quote_result.result_data.additional_charges.selected
          : {},
        currency_rates: getCurrencyRate.curr_data,
        currency_conversion_rates: getCurrencyRate,
        value_added_charges: Object.keys(
          vm.quote_result.result_data.additional_charges.available
        ).length
          ? vm.quote_result.result_data.additional_charges.available
          : [],
        selected_legs: vm.curr_vas_leg_arr,
        module: "Quotes",
      };

      vm.matchRatesObj.additional_charges.selected = vm.vasDetails.legList;
      vm.matchRatesObj.additional_charges.available =
        vm.vasDetails.value_added_charges;
    }

    function toggleViewMore() {
      if (vm.isViewMoreExpanded) {
        vm.isViewMoreExpanded = false;
      } else {
        vm.isViewMoreExpanded = true;
      }
      angular.element("#view-more-div").slideToggle();
    }

    function fnViewQuoteList() {
      if (vm.isDuplicateQuote) {
        vm.proceedCopyQuote("cancelCopyQuote");
      } else {
        $state.go("app.quotes");
      }
    }

    function viewInquiryDetails(id) {
      if (!vm.isShared && !util.isShipper && id != "null") {
        util.isCallingApi = true;
        if(vm.isWebView){
          $state.go("app.inquiry.webViewInquiryDetails", { id: id });
        }else{
          $state.go("app.inquiry.inquiryDetails", { id: id });
        }
      }
    }

    // get expiry max date
    function getExpiryMaxDate(startDate) {
      vm.expiryMaxDate = null;
      if (startDate) {
        var startD = new Date(startDate);
        vm.expiryMaxDate = new Date(
          startD.getFullYear() + 1,
          startD.getMonth(),
          startD.getDate()
        );
      }
    }

    // vaidate expiry date is greater than selected rate expiry date
    function validateExpirydate(expiry_date) {
      if (expiry_date > vm.expiryDateEnd) {
        vm.validationObj.showDateNote = true;
      } else {
        vm.validationObj.showDateNote = false;
      }
    }

    function goToShipmentDetail() {
      if (vm.isWebView) {
        util.webViewObj.id = vm.quote_result.result_data.shipment_id;
        $state.go("app.mobile_shipment_details", util.webViewObj);
      } else {
        $state.go("app.shipments.shipment_details", {
          id: vm.quote_result.result_data.shipment_id,
        });
      }
    }

    // Binding Services to scope
   
    vm.showCostBreakdown = showCostBreakdown;

    function showCostBreakdown(cardData, ev) {
      vm.viewCostCard = cardData;
      var pageData={};
      //var dialog = angular.element(document.querySelector('.quote-newCard-'+vm.viewCostCard._id));
      var position = vm._mdPanel.newPanelPosition()
      .relativeTo(ev.target)
      .addPanelPosition('center', 'below');
        if(vm.search_param.mode == 'SEA-FCL'){
          pageData.url='app/main/component/charges-view/charges-view.html';
          pageData.controller='ChargesViewController';
        }
        else{
          pageData.url= 'app/main/component/cost-view/cost-view.html';
          pageData.controller='CostViewController';
        }

      var config = {
        attachTo: angular.element(document.body),
        templateUrl:pageData.url ,
        controllerAs: "ctrl",
        controller: pageData.controller,
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          'userbasecurrency': vm.search_param.user.user_base_currency,
          'card': vm.viewCostCard,
          'l3_leg': vm.l3_leg,
          'mainFreightName': vm.mainFreightName,
          // 'totalCost': vm.viewCostCard.meta[vm.resultCardFilter.total_cost],
          'buyOrSell': vm.buyOrSell,
          'search_param':vm.search_param
        },
        
        onOpenComplete: function () {
          // costViewFactory.panelClosed = false;
        },
        onRemoving: function () {
          // costViewFactory.panelClosed = true;
        },
      };
     // console.log(config)
      vm._mdPanel.open(config);

      //mixpanel code
      util.callMixpanel("QD-RatecardTotal", {
        Mode: vm.search_param.mode,
      });
    }

    function selectedDuplicateQuote(currData, type) {
      var index = vm.selectedDuplicateCard.findIndex(function (item) {
        return item._id === currData._id;
      });
      var LinerIndex = vm.linerData.findIndex(function (item) {
        return (
          item.vendor_name ===
          (vm.search_param.mode === "AIR"
            ? currData.airline
            : currData.sub_vendor)
        );
      });
      if (index <= -1) {
        vm.selectedDuplicateCard.push(currData);
        if (LinerIndex <= -1) {
          vm.linerData.push({
            vendor_name:
              vm.search_param.mode === "AIR"
                ? currData.airline
                : currData.sub_vendor,
            count: 1,
          });
        } else {
          vm.linerData[LinerIndex].count++;
        }
      } else {
        vm.selectedDuplicateCard.splice(index, 1);
        if (vm.linerData[LinerIndex].count == 1) {
          vm.linerData.splice(LinerIndex, 1);
        } else {
          vm.linerData[LinerIndex].count--;
        }
      }
      if (!vm.selectedDuplicateCard.length && type === "deleteCopyQuote") {
        util.showToast("Minimum one rate required for quote modification.");
        return;
      }
    }

    //Copy quote
    function fnProceedDuplicateQuote(ev) {
      $mdDialog.hide();
      util.showToast("Please wait while we redirect you to the copy quote page you requested");
      $timeout(function(){
        if(vm.isWebView){
          $state.go("app.webViewCopyQuoteDetailsController",{ id: vm.quote_result.result_data._id});
        }else{
          $state.go("app.CopyQuoteDetailsController",{ id: vm.quote_result.result_data._id});
        }
      }, 500);
    }


    function proceedCopyQuote(type, ev) {
      if(type==='tooltip'){
        util.callMixpanel("QC-Selected",{
          "Mode": vm.search_param.mode,
          "Type": vm.resultType
         });
      }
      else if (type === "copyQuote") {
        vm.proceedDuplicate = false;
        vm.copyquoted = true;
        vm.quote_CardData = angular.copy(vm.selectedDuplicateCard);
        util.callMixpanel("QC-bar-CTA",{
          "Mode": vm.search_param.mode,
          "Type": vm.resultType
        });
      } else if (type == "remove") {
        vm.proceedDuplicate = false;
        vm.selectedDuplicateCard = [];
        vm.isDuplicateQuote = false;
        vm.isQuoteModify = false;
        vm.quote_CardData = vm.quote_CardDataCopy;
        util.callMixpanel("QC-bar-RemoveAll",{
          "Mode": vm.search_param.mode,
          "Type": vm.resultType
        });
      } else if (type === "generateQuote") {
        vm.generateQuote(ev);
        util.callMixpanel("QC-SendQuote-Click",{
          "Mode": vm.search_param.mode,
          "Type": vm.resultType
        });
      } else {
        var confirm = $mdDialog
          .confirm()
          // .title('Warning')
          .textContent(
            "Changes made to this quote will be lost. Proceed anyway?"
          )
          .ariaLabel("discard")
          .targetEvent(ev)
          .ok("Yes, Proceed")
          .cancel("No, Cancel");
        $mdDialog.show(confirm).then(
          function () {
            var className = document.querySelectorAll(".overlayCard");
            className.forEach(function (element) {
              element.classList.add("hide");
            });

            vm.proceedDuplicate = false;
            vm.selectedDuplicateCard = [];
            vm.quote_CardData = vm.quote_CardDataCopy;
            vm.isDuplicateQuote = false;
            vm.copyquoted = false;
            vm.isQuoteModify = false;

            util.callMixpanel("QC-SendCancel-Click",{
              "Mode": vm.search_param.mode,
              "Type": vm.resultType
            });
          },
          function () {
            return true;
          }
        );
      }
    }

    function fnGetFwrdTerms() {
      var mode =
        vm.search_param.mode == "SEA-FCL"
          ? "fcl"
          : vm.search_param.mode == "AIR"
          ? "air"
          : "lcl";
      resultService.getTermsConditions(mode, "false").then(
        function (response) {
          vm.termsAndConditions = response.data.terms;
        },
        function (error) {
          vm.termsAndConditions = "";
        }
      );
    }

    function generateQuote(ev) {
      vm.isDuplicateQuote = true;
      vm.quoteDetails = shareQuoteService.fnInitializeQuoteDetails(
        vm.search_param.origin_customs,
        vm.search_param.destination_customs
      );
      vm.quoteDetails.terms = vm.termsAndConditions;
      vm.quoteDetails.incoterms = vm.search_param.inco_term
        ? vm.search_param.inco_term
        : null;
      vm.quoteDetails.hazardous = vm.search_param.hazardous_material;
      vm.shareQuoteObj = {
        quoteDetails: vm.quoteDetails,
        termsAndConditions: vm.termsAndConditions,
        stdTermsAndConditions: vm.stdTermsAndConditions,
        selectedCard: vm.selectedDuplicateCard,
        search_param: vm.search_param,
        generateQuoteBtn: vm.resultCardFilter.generateQuoteBtn,
        currency_conversion_rates:
          vm.resultCardFilter.currency_conversion_rates,
        fclLoadData: vm.fclLoadData ? vm.fclLoadData : null,
        result_id: vm.quote_result.result_data.search_id,
        vas_details: vm.vasDetails,
        sales_user: null,
        shipper_user: null,
        quoteFrom: "Quote",
        exchangeRateId: vm.quote_result.result_data._id,
        is_duplicate_quote: vm.isDuplicateQuote,
        parent_quote_id: vm.quote_result.result_data._id,
        copy_quote_id: vm.quote_result.result_data.quote_id,
      };
      $mdDialog.show({
        template:
          '<md-dialog id="share-quotation" class="dialobox" ng-cloak><md-dialog-content class="p-0"><share-quotation sharequoteobj="ctrl.parent.shareQuoteObj" isduplicatequote="ctrl.parent.isDuplicateQuote"></share-quotation></md-dialog-content></md-dialog>',
        // templateUrl: 'app/main/result/Dialogs/share-quotation/share-quotation.html',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        },

        // onRemoving: vm.resetSendQuotey
      });
    }

    function fnopenCopyQuotewalkthrough(ev) {
      $mdDialog.show({
        templateUrl:
          "app/main/quotes/components/copy-quote/copy-quote-overview-popup.html",
        targetEvent: ev,
        clickOutsideToClose: true,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () {
          this.parent = vm;
        },
        controllerAs: "ctrl",
      });
    }

    function saveQuoteTemplate(type){
      if(!vm.templateName.length && type != "Delete"){
        vm.templateError = true;
        return ;
      }
      if(!vm.templateValueChange && type != "Delete"){
        util.showToast("Make any changes to process further ");
        return
      }
      var payload = {
        "name": vm.templateName
      }
      vm.deleteContent = vm.templateName;
      if(type === "New"){
        QuotesService.fnSetQuoteTemplateName(vm.quote_result.result_data._id,payload).then(function(response){
          //activity monitor object push
          vm.templateActivityMonitor("This Quote is saved as a template ")
          //assigning template value
          vm.templateValueAssign();
          vm.checkTemplate = true;
          vm.responseStatusData.push({
            responseFrom: "QUOTES",
            status: "COMPLETED",
            message: response.data.message,
          })
         
        },function(error){
          vm.responseStatusData.push({
            responseFrom: "QUOTES",
            status: "FAILED",
            message: error.data.message,
          })
            $log.error(error);
        });
        vm.quoteTemplateType = "Edit";
        $mdDialog.hide();
      }
      else if(type === "Edit"){
        vm._mdPaneRef.close();
          QuotesService.fnModifyQuoteTemplateName(vm.quote_result.result_data._id,payload).then(function(response){
            vm.templateValueAssign();
            vm.templateActivityMonitor("Quote Template name modified to ")
            vm.checkTemplate = true;
            vm.responseStatusData.push({
              responseFrom: "QUOTES",
              status: "COMPLETED",
              message: response.data.message,
            })
          },function(error){
            vm.responseStatusData.push({
              responseFrom: "QUOTES",
              status: "FAILED",
              message: error.data.message,
            })
              $log.error(error);
          });
          $mdDialog.hide();
        }
      else{
        vm._mdPaneRef.close();
        $mdDialog.show({
          templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
          // targetEvent: ev,
          clickOutsideToClose: true,
          controllerAs: 'ctrl',
          controller: function () { this.parent = vm }
        });
      }
    }

    function fnDeleteData(val){
      vm._mdPaneRef.close();
      if(vm.quote_result.result_data.template_data){
        vm.checkTemplate = false;
        vm.templateName = "";
      }
      QuotesService.fnQuoteTemplateDelete(vm.quote_result.result_data._id).then(function(response){
       
        vm.templateActivityMonitor("Quote template removed")
        vm.quote_result.result_data.template_data=null
        vm.responseStatusData.push({
          responseFrom: "QUOTES",
          status: "COMPLETED",
          message: response.data.message,
        })
      },function(error){
        vm.responseStatusData.push({
          responseFrom: "QUOTES",
          status: "FAILED",
          message: error.data.message,
        })
          $log.error(error);
          
      });
      
      $mdDialog.hide();
    }

    function templateValueAssign(){
      vm.quote_result.result_data.template_data={
        created_at:new Date(Date.now()) ,
        created_by: util.userProfile.user.user_first_name +
        " " +
        util.userProfile.user.user_last_name,
        name: vm.templateName
      }
    }

    function templateActivityMonitor(message){
      var activityObj = {
        message: message+vm.templateName,
        type: "",
        timestamp: new Date(),
        user_id: util.userProfile.user.id,
        user_name:
          util.userProfile.user.user_first_name +
          " " +
          util.userProfile.user.user_last_name,
        activity_data: {},
      };    
      vm.quoteActivity.activity.push(activityObj);
    }

    function fnopenCreateTemplate(ev,type) {
      vm.templateName = (vm.quote_result.result_data.template_data && vm.quote_result.result_data.template_data.name) ? vm.quote_result.result_data.template_data.name : "";
      vm.quoteTemplateType = type === "Edit" ? "Edit" : "New";
      if(type === "Edit"){
        vm._mdPaneRef.close();
      }
      vm.templateError = false;
      vm.templateValueChange = false;
      $mdDialog.show({
        templateUrl:"app/main/quotes/quotesDetails/create-template/create-template.html",
        targetEvent: ev,
        clickOutsideToClose: true,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () {
          this.parent = vm;
        },
        controllerAs: "ctrl",
      });
    }

    // mixpanel event
    function trackEvent(type,query) {
     util.callMixpanel(type,{
        "Mode": vm.search_param.mode,
        "Type": vm.resultType       
     });
    }

    function freeDaysTabView(){
      vm.viewActiveTab = 'loadWiseFreeDays';
    }
    
    vm.fnOpenRefreshRatesPopup = fnOpenRefreshRatesPopup;
    vm.updateCardwiseSearchParam = updateCardwiseSearchParam;

    // Funtion to open rate refresh popup
    function fnOpenRefreshRatesPopup(ev){ 
      vm.source='quote';
      vm.updateCardwiseSearchParam();
      vm.copySearchParam = angular.copy(vm.search_param);
      // console.log(vm.getPort('INNSA', 'SEA-FCL', 'origin','P2P'))
      $mdDialog.show({
          template: '<md-dialog id="refresh-rates" class="popup-md" ng-cloak><refresh-rates search-param="ctrl.parent.copySearchParam" source="ctrl.parent.source" quote-result="ctrl.parent.quote_result" load-string="ctrl.parent.loadDispaly"></refresh-rates></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          parent: $rootElement,
          scope: $scope,
          preserveScope: true,
          controller: function () { this.parent = vm },
          controllerAs: 'ctrl',
      });
    }

    // Function to add cards which is selected from result
    function addCardsFromResult(){
      vm.refreshQuoteId = resultService.refreshQuoteData.quote_id;
      if(vm.refreshRates &&  ['app.search.result','app.search.fclV2Rates'].includes($rootScope.previousState) && vm.refreshQuoteId === vm.quote_result.result_data._id){
        vm.isQuoteModify = true;
        vm.newResultCard = angular.copy(resultService.refreshQuoteData.selectedCards);
        vm.newResultCard.forEach(function (card) {
          card.meta["status"] = "new";
        });
        vm.quote_CardData = vm.newResultCard.concat(vm.quote_CardData);
      }
      
    }

    // reset refresh data after updating the quote
    function resetRefreshData(){
      vm.newResultCard = [];
      resultService.refreshQuoteData = {
        quote_id: '',
        quote_number: '',
        selectedCards: [],
        from_quote_search_param:{},
        oldCards:[]
      }
      calBuyTotal();
    }

    // function to push newly card added
    function pushNewCards(card){
      if(vm.newResultCard && vm.newResultCard.length){
        vm.newResultCard.push(card);
        vm.quote_CardData.unshift(card);
      }else{
        vm.quote_CardData.push(card);
      }
    }
    vm.editStandardQuotation = editStandardQuotation;
    function editStandardQuotation(){
      analytics.track('QD-StandardQuote-Edit-Click');
      var data= {
          "source":'quotes',
          "cards": vm.quote_CardData,
          "currency_conversion_rates": vm.resultCardFilter.currency_conversion_rates,
          "search_param": vm.search_param,
          "search_id": vm.quote_result.result_data.search_id,
          "start_date": vm.quote_result.result_data.start_date,
          "expiry_date": vm.quote_result.result_data.expiry_date,
          "customs": vm.quote_result.result_data.customs,
          "perishable": vm.quote_result.result_data.perishable,
          "cc_emails" : vm.quote_result.result_data.cc_emails,
          "hazardous": vm.quote_result.result_data.hazardous,
          "send_mail": vm.quote_result.result_data.send_mail,
          "co2e" : vm.quote_result.result_data.co2e,
          "generate_pdf": vm.quote_result.result_data.generate_pdf,
          "print_schedule" : vm.quote_result.result_data.print_schedule,
          "show_zero_sell_rates" : vm.quote_result.result_data.show_zero_sell_rates,
          "carrier_mask_for_shipper": vm.quote_result.result_data.carrier_mask_for_shipper,
          "incoterms": vm.quote_result.result_data.incoterms ? vm.quote_result.result_data.incoterms : null,
          "pdf_preferred_language": vm.quote_result.result_data.pdf_preferred_language || "en",
          "impo_expo": vm.quote_result.result_data.impo_expo ? vm.quote_result.result_data.impo_expo : null,
          "terms": vm.quote_result.result_data.terms ? vm.quote_result.result_data.terms : null,
          "all_in_quote_setting": vm.quote_result.result_data.all_in_quote_setting,
          "generate_quote_type": vm.quote_result.result_data.generate_quote_type ? vm.quote_result.result_data.generate_quote_type : 'default',
          "is_duplicate_quote":vm.is_duplicate_quote?vm.is_duplicate_quote:false,
          "parent_quote_id":vm.quote_result.result_data._id?vm.quote_result.result_data._id:null,
          "number_formats":$rootScope.number_format,
          "quote_number": vm.quote_result.result_data.quote_id,
          "created_for" : vm.quote_result.result_data.created_for,
          "customField" : vm.quote_result.result_data.customField,
          "activity" : {},
          "additional_charges" : {
              "selected" : vm.vas_details ? vm.vas_details.legList : [],
              "available" : vm.vas_details ? vm.vas_details.value_added_charges : []
          }
      }
      util.standardQuotationData = data;
      $state.go('app.standardQuotation');
    }

    function fnOpenStatusChangePanel(quoteData,ev){
      vm.quoteInfo = quoteData;
      if(vm.hideStatusChange){
        return;
      }
      ev.stopPropagation();
      var dropDownPosition = 'quote-status-panel' ;
     
        var position = $mdPanel.newPanelPosition()
        .relativeTo('.'+ dropDownPosition)
        .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
  
      var config = {
        templateUrl:
          "app/main/component/status-change-panel/status-change-panel.html",
        controllerAs: "ctrl",
        controller: "statusChangePanelController",
        position: position,
        openFrom: ev,
        trapFocus: true,
        zIndex: 1501,
        clickOutsideToClose: true,
        escapeToClose: false,
        focusOnOpen: true,
        locals: {
          quoteInfo : quoteData
        },
        onRemoving: function (event) {
          if(event.config.scope.ctrl.selectedStatus){
            vm.fnChangeStatus(quoteData ,event.config.scope.ctrl.selectedStatus ,ev);
          }
        }
      };
      $mdPanel.open(config);

    }

    //Quote status change
    function fnChangeStatus(quote, statusData, ev){
      vm.followupValidation=false;
      vm.disableSetReminder=false;
          vm.oldReminder=null;
      if(quote.reminder && quote.reminder.length >0 && quote.reminder[0].reminder_date){
          vm.disableSetReminder = (quote.reminder[0].created_by.id != util.userProfile.user.id) ? true:false;
           vm.oldReminder = angular.copy(quote.reminder[0].reminder_date) ;
           statusData.reminder_date=util.dateReplace(quote.reminder[0].reminder_date);
           }
      if(statusData.status==="Lost"){
          analytics.track("Quote-MarkAslost");
      }
      if(statusData.status==="Follow-up Required"){
          analytics.track("Quote-FollowUpRequired");
      }
      ev.stopPropagation();
      if(statusData.comment_required){
          statusData.comment = '';
          var date = new Date();
          // add a day
          date.setDate(date.getDate() + 1);
          
          vm.status_change_obj = {
              'statusData' : statusData,
              'quote' : quote,
              'End_date': angular.copy( new Date(quote.expiry_date)) ,
              'Start_date':date,
          }
          $mdDialog.show({
              templateUrl        : 'app/main/quotes/dialogs/quote-status-change/quote-status-change.html',
              targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm }
          });
      }else{
          vm.fnCallStatusChangeApi(quote, statusData);
      }

  }

  function fnCallStatusChangeApi(quote, statusData,form){
          
    if(vm.status_change_obj && !vm.status_change_obj.statusData.comment && !form.comment.$invalid){
      vm.followupValidation=true;
      return;
    }
  if(form && form.$invalid){
      return;
  };
      vm.disabledStatusSubmit = true;
      var data = QuotesService.fnSetActivityList(quote , statusData,vm.oldReminder)
      QuotesService.statusQuoteChange(data,quote.status._id).then(function(){
          vm.disabledStatusSubmit = false ;
          vm.cancelDialog();
          util.showToast('Status Changed Successfully.');
          $state.reload();
      },function(error){
          vm.disabledStatusSubmit = false;
          util.showToast(util.displayValidationError(error));
          $log.log(error);
      });
  }
    function calBuyTotal(){
      if(!vm.util.isShipper && $rootScope.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL){
        vm.quote_CardData.forEach(function (card) {
        if(card && !card.meta.buy_leg_total){
          card.meta["buy_leg_total"] = resultService.calCardTotal(card.data.buy_rates);
        }
      });
    } 
      
    }

    // update user_nearby_origin and user_nearby_destination values with available cards distinct port data
    function updateCardwiseSearchParam(){
      vm.fnUpdateLocation();
      var searchedOrgArr = mergeNearbyPorts(vm.search_param.user_nearby_origin, vm.search_param.origin_location, vm.search_param.nearby_ports);
      var searchedDestArr = mergeNearbyPorts(vm.search_param.user_nearby_destination, vm.search_param.destination_location, vm.search_param.nearby_ports_destination);
      var user_nearby_origin = getDistinctCardsPorts(searchedOrgArr,'origin_port_code','origin',vm.search_param.user_nearby_origin);
      var user_nearby_destination = getDistinctCardsPorts(searchedDestArr,'destination_port_code','destination',vm.search_param.user_nearby_destination);
      if(user_nearby_origin && user_nearby_origin.length){
        vm.search_param.user_nearby_origin = user_nearby_origin;
      }
      if(user_nearby_destination && user_nearby_destination.length){
        vm.search_param.user_nearby_destination = user_nearby_destination;
      }
    }
    function fnUpdateLocation(){
      if(vm.search_param.user_nearby_origin && vm.search_param.user_nearby_origin.length){
        vm.search_param['nearby_origin']=vm.search_param.user_nearby_origin.filter(function(item){
          return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
        });
        vm.origin_alias=vm.search_param.user_nearby_origin.filter(function(item){
          return (item.input_type == 'alias');
        });
        vm.search_param.user_nearby_origin =  vm.search_param.user_nearby_origin.filter(function(item){
          return (item.input_type == 'user' || !item.input_type);
        });
        vm.search_param.user_nearby_origin.forEach(function(value){
          if(!value.input_type){
           value['input_type']='user'
          }
         })
      }
      if(vm.search_param.user_nearby_destination &&vm.search_param.user_nearby_destination.length){

      
     
      vm.search_param['nearby_destination']=vm.search_param.user_nearby_destination.filter(function(item){
        return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
      });
     

      vm.destination_alias=vm.search_param.user_nearby_destination.filter(function(item){
        return (item.input_type == 'alias');
      });
     
      vm.search_param.user_nearby_destination =  vm.search_param.user_nearby_destination.filter(function(item){
        return (item.input_type == 'user' || !item.input_type);
      });
   
       vm.search_param.user_nearby_destination.forEach(function(value){
         if(!value.input_type){
          value['input_type']='user'
         }
        })
      }
    
    }
    // merge user_neraby and location objects
    function mergeNearbyPorts(user_nearby_ports, port_location, nearby_ports){
      var nearbyCopy = angular.copy(user_nearby_ports);
      nearbyCopy.push(port_location);
      nearbyCopy = nearbyCopy.concat(nearby_ports);
      return nearbyCopy;
    }

    // get distinct ports from cards by mapping global port code from search data else call places api
    function getDistinctCardsPorts(searchPorts,portKey,search_type,searchParamPort){
      searchParamPort = [];
      vm.quote_CardData.forEach(function (card) {
        var  portData = card.meta.port_data;
        var port = null;
        if(vm.search_param['user_nearby_'+search_type] && vm.search_param['user_nearby_'+search_type].length && vm.search_param['user_nearby_'+search_type][0].place_type =="Door"){
          port = searchPorts.find(function(item) {
            if(item.pin_code_ui ){
              return item.pin_code_ui === (search_type == 'origin'? portData.pickup_pincode_ui : portData.delivery_pincode_ui)}else{
                return item.location === (search_type == 'origin'? portData.pickup_location : portData.delivery_location)
              }
          });
        }else{
      // Check if an port object with the same global_port_code exists in the array
      port = searchPorts.find(function(item) {
        return item.global_port_code === portData[portKey];
      });
        }
  
        if(!port){
            SearchService.getPortsLocation(portData[portKey], 'SEA-FCL', search_type, 'P2P')
            .then(function(response) {
              var port = response.find(function(item) {
                return item.global_port_code === portData[portKey];
              });
              if(port && !searchParamPort.includes(port)){ searchParamPort.push(port); }
            })
            .catch(function(error) {
              $log.log(error.data);
              return null; 
            });
        }else if(!searchParamPort.includes(port)){ searchParamPort.push(port); }
      });
      return searchParamPort;
    }

    function reSyncTmsData(card){
     
      util.isCallingApi = true;
       var data ={
        card_id:card._id,
        id:vm.quote_result.result_data.quote_id,
        partner:card.partner,
        partner_reference_id:card.partner_reference_id,
        pdf_link:QuotesService.open_pdf_link,
        vendor_id:util.userProfile.user.company.vendor_id,

       }
     
      ShipmentService.syncDocument(data,'quote').then(
        function (response) {
     card.document_details=response.data.document_details;
  
      util.isCallingApi = false;
      if(response.data.document_details.sync_status.toLowerCase() === 'success'){
        util.showToast("Document Synced Successfully!");
      
      var activityObj = {
        message:"Quote PDF was sent to CargoWise One-Off Quote." ,
        type: "intergration",
        comment:"Cargowise Quotation Number "+response.data.data.partner_reference_id,
        timestamp: new Date(),
        user_id: util.userProfile.user.id,
        user_name:
          util.userProfile.user.user_first_name +
          " " +
          util.userProfile.user.user_last_name,
        activity_data: [],
      };
      vm.quoteActivity.activity.push(activityObj);
      }
        },
        function (error) {
          util.isCallingApi = false;
          //vm.uiData.integrationComponentOptions.menu.isEnabled=true;
          
          util.showToast(error.data.message);
          $log.log(error);
        }
      );

    }

  }

})();

(function(){
    'use strict';

    angular
    .module('app.quotes')
    .factory('QuotesService' , QuotesService);

    /** @ngInject */
    function QuotesService($rootScope,$q,$mdToast,$http,api,$filter,util, $mdDialog,$log,efpUrl)
    {

        var quotesService = {
            quoteType: null,
            getQuoteList : getQuoteList,
            getQuoteDetails : getQuoteDetails,
            setReminder:setReminder,
            fnGetContainerQtyByBasis : fnGetContainerQtyByBasis,
            getSubVendor : getSubVendor,
            getvendorData : getvendorData,
            getChargeName : getChargeName,
            setData:setData,
            samePortValidation:samePortValidation,
            addChargebyLegName : addChargebyLegName,
            removeChargebyLegName : removeChargebyLegName,
            addBasisbyCharge : addBasisbyCharge,
            fnGetCurrencyCoversion : fnGetCurrencyCoversion,
            fnsubmitLeg : fnsubmitLeg,
            updateCard : updateCard,
            deleteCard : deleteCard,
            openOtpPopup : openOtpPopup,
            getQuoteOtp : getQuoteOtp,
            checkQuoteOtp : checkQuoteOtp,
            uuid: '',                     //for implementing shareable quotes - Isaac
            quote_id: '',                //mignt need for shareable quotes - Isaac
            getStatusList : getStatusList,
            statusQuoteChange : statusQuoteChange,
            FclQuote : {},
            AirQuote : {},
            sharedQuoteResult : {},
            getUsersListForFilter:getUsersListForFilter,
            getScheduleList : getScheduleList,
            getTemplateList : getTemplateList,
            getMappingData:getMappingData,
            getCustomerMappingList:getCustomerMappingList,
            getChargeMappingList:getChargeMappingList,
            getSyncUiData:getSyncUiData,
            filterParams : {
                'mode' : '',
                'status' : '',
                'created_by' : '',
                'created_for' : '',
                'search' : '',
                'company_id' : '',
                'isBooked' : '',
                'shipper_companies':''
            },
            filterForwarderId : '',
            searchText : '',
            open_pdf_link:'',
            getQuotesActivityList : getQuotesActivityList,
            searchNewRates : searchNewRates,
            modifyQuote : modifyQuote,
            getQuoteData : getQuoteData,
            getFilterList: getFilterList,
            getQuotesList : getQuotesList,
            fnSetQuoteTemplateName:fnSetQuoteTemplateName,
            fnModifyQuoteTemplateName:fnModifyQuoteTemplateName,
            fnQuoteTemplateDelete:fnQuoteTemplateDelete ,
            fnSetActivityList : fnSetActivityList,
            getEfpQuoteDetails: getEfpQuoteDetails
        };

        return quotesService;


        /**
         * get list of Quotes
         */
        function getQuoteList(isResolveCall){
            var url = api.baseUrl + '/api/quote-status-count?list_view=true' + util.fnGetForwarderIdApi('?');
            if(isResolveCall){
                quotesService.filterParams = {
                    'mode' : '',
                    'status' : '',
                    'created_by' : '',
                    'created_for' : '',
                    'search' : quotesService.filterParams.search,
                    'isBooked' : '',
                    'shipper_companies':''
                };
            }
            if(util.navPermission.quotes[1]){
                var data = {};
                if(quotesService.filterParams.company_id){
                    data.forwarder_company_id = quotesService.filterParams.company_id;
                }
                if(quotesService.filterParams.mode.length > 0){
                    data.mode = quotesService.filterParams.mode;
                }
                if(quotesService.filterParams.created_by.length > 0){
                    data.users = quotesService.filterParams.created_by;
                }
                if(quotesService.filterParams.created_for.length > 0){
                    data.shipper_users = quotesService.filterParams.created_for;
                }
                if(quotesService.filterParams.search){
                    data.search = quotesService.filterParams.search;
                }
                if(quotesService.filterParams.isBooked){
                    
                    data.is_booked = quotesService.filterParams.isBooked;
                }
                if(quotesService.filterParams.shipper_companies){
                    data.shipper_companies = quotesService.filterParams.shipper_companies;
                }
                
                return $http.post(url,data);
            }else{
                return [];
            }
        }

        function openOtpPopup(ev, vm){
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/otp-popup/otp.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm; }
            });
            vm.sendingOtp = true;
            return vm.sendingOtp;
        }

        /**
         * to get single quote details
         * @param {*} id
         */
        function getQuoteDetails(id){
            var url = '';
            if(util.isSharedQuote()) {
                url = api.baseUrl + '/shared/quote/' +id;
            } else {
                url = api.baseUrl + '/api/quote/' + id;
            }
            util.isCallingApi = true;

            return $http.get(url).then(function(response){

                util.isCallingApi = false;
                $rootScope.loadingProgress = true;
                  quotesService.FclQuote["result_meta"] = {};
                  quotesService.FclQuote.result_meta["search_param"] = response.data.data.search_param;
                  if(!quotesService.FclQuote.result_meta["search_param"].hasOwnProperty('freight_charges')){
                    quotesService.FclQuote.result_meta.search_param['freight_charges'] = true;
                  }             
                 quotesService.FclQuote["result_data"] = response.data.data;
                  delete quotesService.FclQuote.result_data.search_param;
                if(util.isSharedQuote()) {
                    quotesService.sharedQuoteResult = angular.copy(quotesService.FclQuote);
                    return quotesService.sharedQuoteResult;
                } else {
                    return quotesService.FclQuote;
                }
            },function(error){
                util.isCallingApi = false;
                $log.error(error);
            });
        }


        function setReminder(data){
            var url =api.baseUrl + '/api/quote-reminder';

             return $http.post(url,data)
        }

        /**
         * to get single quote details
         * @param {*} id
         */
        function statusQuoteChange(data,id){
            var url = '';
            if(util.isSharedQuote()) {
                url = api.baseUrl + '/shared/quote/status/'+id;
            } else {
                url = api.baseUrl + '/api/quote/status/'+id;
            }
            return $http.post(url,data);
            // .then(function(response){
            //     return response.data;
            //     $rootScope.loadingProgress = true;
            // },function(error){
            //     $log.error(error);
            // });
        }

      function getQuoteOtp(id){
        var url = api.baseUrl + '/shared/' + id + '/otp';
            return $http.get(url);
      }

      function checkQuoteOtp(id, data){
        var url = api.baseUrl + '/shared/' + id + '/otp';
            return $http.post(url,data);
      }

      function samePortValidation(card){
        card= quotesService.setData(card);
        if(angular.equals(card.meta.port_data.origin_port_code,card.meta.port_data.destination_port_code) ){
              util.showToast("Origin and Destination cannot be same");
              return true;
            }
        if(card.meta.port_data.is_icd_port_origin && card.meta.via_pol ){
          if(angular.equals( card.meta.via_pol,card.meta.port_data.origin_port_code)){
                 util.showToast("Origin and Port of Loading cannot be same");
                 return true;
              }
              if(angular.equals( card.meta.via_pol,card.meta.port_data.destination_port_code)){
                util.showToast("Destination and Port of Loading cannot be same");
                return true;
             }
        }
        if(card.meta.port_data.is_icd_port_destination && card.meta.via_pod ){
          if(angular.equals( card.meta.via_pod,card.meta.port_data.origin_port_code)){
            util.showToast("Origin and Port of Discharge cannot be same");
            return true;
         }
         if(angular.equals( card.meta.via_pod,card.meta.port_data.destination_port_code)){
          util.showToast("Destination and Port of Discharge cannot be same");
           return true;
        }
        if(card.meta.port_data.is_icd_port_origin && card.meta.via_pol ){
          if(angular.equals( card.meta.via_pod,card.meta.via_pol )){
            util.showToast("Port of Discharge and Port of Loading cannot be same");
            return true;
         }
        }
        }
  
      }

      function setData(card){
        card.meta.port_data.origin_portname =
        card.meta.port_data.origin_port_code &&
        card.meta.port_data.origin_port_code["portname"]
          ? card.meta.port_data.origin_port_code["portname"]
          : card.meta.port_data.origin_portname;
      card.meta.port_data.origin_port_code =
        card.meta.port_data.origin_port_code &&
        card.meta.port_data.origin_port_code["global_port_code"]
          ? card.meta.port_data.origin_port_code["global_port_code"]
          : card.meta.port_data.origin_port_code;
  
      card.meta.port_data.destination_portname =
        card.meta.port_data.destination_port_code &&
        card.meta.port_data.destination_port_code["portname"]
          ? card.meta.port_data.destination_port_code["portname"]
          : card.meta.port_data.destination_portname;
      card.meta.port_data.destination_port_code =
        card.meta.port_data.destination_port_code &&
        card.meta.port_data.destination_port_code["global_port_code"]
          ? card.meta.port_data.destination_port_code["global_port_code"]
          : card.meta.port_data.destination_port_code;
  
      card.meta.via_pol =
        card.meta.via_pol != null && card.meta["via_pol"]["global_port_code"]
          ? card.meta.via_pol.global_port_code
          : card.meta.via_pol;
      card.meta.via_pod =
        card.meta.via_pod != null && card.meta["via_pod"]["global_port_code"]
          ? card.meta.via_pod.global_port_code
          : card.meta.via_pod;
      card.meta.haulage =
        card.meta.haulage == "not available" ? null : card.meta.haulage;
      card.meta.destination_haulage =
        card.meta.destination_haulage == "not available"
          ? null
          : card.meta.destination_haulage;
  
          return card 
      }

        function fnGetContainerQtyByBasis(loadData,leg_data){

            if(leg_data.charge_basis === 'per shipment' || leg_data.charge_basis === 'per shipping bill'){
                leg_data.total_units = 1;
            }
            else{

                for (var i = 0; i < loadData.length; i++) {

                    if(loadData[i].type === leg_data.container_type)
                    {
                        if(leg_data.charge_basis === 'per B/L'){
                            leg_data.total_units = loadData[i].bl_qty;
                        }
                        else{
                            leg_data.total_units = loadData[i].qty;
                        }
                    }
                }
            }
            return leg_data;
        }

        function getSubVendor(){
            var url = api.baseUrl + '/api/subvendor?source=COMMON_AND_DOMAIN';
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        }

        function getvendorData(){
            var url = api.baseUrl + '/api/vendor';
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        }

        function getChargeName(data){
            data.leg = data.leg.includes('sop') ? 'sop_leg' : data.leg ;
            var url = api.baseUrl + '/api/chargeline ';
            return $http.post(url,data);
        }

        function addChargebyLegName(leg_data){

            leg_data.rate.charges.push({
                // 'charge_id': '',
                // 'charge_name': '',
                // 'charge_description': '',
                // 'charge_basis': '',
                // 'per_unit_rate': '',
                // 'total_units': '',
                // 'charge_cost': '',
                // 'charge_currency': '',
                // 'container_type': '',
                // 'customer_currency_cost' : ''

                "charge_id": "",
                "charge_name": "",
                "charge_description": "",
                "charge_basis": "",
                "charge_category":null,
                "per_unit_rate": '',
                "total_units": '',
                "charge_cost": 0,
                "charge_currency": '',
                "minimum_charge_cost": "NA",
                "maximum_charge_cost": "NA",

                "container_type": null,
                "global_charge_id": "",
                "customer_currency_cost": 0,
                "leg_currency_cost": 0,
                "charge_code" : ""
            });
            return leg_data;
        }

        function removeChargebyLegName(leg_data , charge_data, deletedChargeList){

            var index = leg_data.rate.charges.findIndex(function(item){
                return item.charge_id === charge_data.charge_id;
            });

            leg_data.rate.charges.splice(index, 1);

            if(angular.isDefined(charge_data.id)){
                deletedChargeList.push(charge_data.id);
            }
        }

        function addBasisbyCharge(leg_data , charge_id , index ,charge_list){

            for (var i = 0; i < charge_list.length; i++) {
                if(charge_list[i].charge_id === charge_id){
                    leg_data.rate.charges[index].charge_name = charge_list[i].charge_name ;
                    leg_data.rate.charges[index].charge_id = charge_list[i].charge_id ;
                    // leg_data.charges[index].charge_basis = charge_list[i].charge_basis;
                }
            }
        }

        function fnGetCurrencyCoversion(currency){

            var url = api.baseUrl + '/api/currency-conversion?from=' + currency;

            return $http.get(url);
        }

        //api call for add /edit new card
        function fnsubmitLeg(legData, id, action){
            var url;
            if(action == 'addLeg'){
                url = api.baseUrl + '/api/rates/' + id + '/card';
                return $http.post(url,legData);
            }else{
                url = api.baseUrl + '/api/rates/' + id;
                return $http.put(url,legData);
            }
        }

        function updateCard(legData, id, cardId){
            var url = api.baseUrl + '/api/rates/' + id + '/card/' + cardId;
            return $http.put(url,legData);
        }

        function deleteCard(cardData,legId){
            var url = api.baseUrl + '/api/rates/' + legId + '/card';
            return $http.put(url,cardData);
        }

        function getStatusList(vendorId){
            var url = api.baseUrl + '/api/quote-status/'+vendorId;
            return $http.get(url);
        }

        // function getCreatedForList(searchText){
        //     var url = api.baseUrl + '/api/shipper-list?limit=30&offset=0';
        //     if(searchText){
        //       url += '&query=' + searchText;
        //     }
        //     return $http.get(url).then(function(response){
        //         return response.data.data;
        //     },function(error){
        //         $log.error(error);
        //     });
        // }
        function getUsersListForFilter(module_filter,type,serach_text){
            var url = api.baseUrl + '/api/user?count=30&offset=0&source='+module_filter;
            if(type){
                url += '&type='+type+'';
            }
            if(serach_text){
                url += '&search='+serach_text+'';
            }
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
          }

        // function getCreatedByList(){
        //     var url = api.baseUrl + '/api/get-forwarders';
        //     return $http.get(url).then(function(response){
        //         return response.data.data;
        //     },function(error){
        //         $log.error(error);
        //     });
        // }

        function getScheduleList(scheduleUrl){
          return $http.get(scheduleUrl).then(function(response){
              return response.data.data;
          },function(error){
              $log.error(error);
          });
        }

        function getQuotesActivityList(quote_id){
            var url = api.baseUrl + '/api/quote-activity/'+quote_id;
            return $http.get(url).then(function(response){
                return response.data.data;
            },function(error){
                $log.error(error);
            });
        }

        function searchNewRates(searchMeta){

          // var url = 'app/data/result/newRates.json';
          // return $http.get(url);
            return $http.post(api.baseUrl + '/api/rate-fetch', searchMeta);
        }

        function modifyQuote(id, request_data){
          var url = api.baseUrl + '/api/quote/'+ id;
          return $http.put(url, request_data);
        }

        function getQuoteData(data){
            var url = api.baseUrl + '/api/quotes-data';
            return $http.post(url,data).then(function(response){
                return response.data.data;
            },function(error){
                $log.error(error);
            });
        }

        function getFilterList(queryParam){
            var forwarderId = util.fnGetForwarderIdApi('?');
            var url = api.baseUrl + '/api/v2/quote/filters'+ util.fnGetForwarderIdApi('?');
            if(queryParam !== null){
                url += (forwarderId === '' ? '?' : '&') + 'query_source=' + queryParam.query_source +'&query='+ queryParam.query;
            }
            return $http.get(url);
        }

        function getQuotesList(data){
            var url = api.baseUrl + '/api/v2/quote/list'+ util.fnGetForwarderIdApi('?');
            return $http.post(url,data);
        }

        function getTemplateList(queryparam, isEfpDomain){
            var url;
            if(isEfpDomain){
                url = efpUrl + '/api/efp/quote-templates?mode=' + queryparam.mode + 
                      '&limit=' + queryparam.limit + 
                      '&offset=' + queryparam.offset + 
                      '&query=' + encodeURIComponent(queryparam.query || '');
            } else {
                url = api.baseUrl + '/api/v2/quote-templates?mode=' + queryparam.mode + 
                      '&limit=' + queryparam.limit + 
                      '&offset=' + queryparam.offset + 
                      '&query=' + queryparam.query;
            }
            return $http.get(url);
        }

        function getEfpQuoteDetails(quoteId){
            var url = efpUrl + '/api/efp/quote/' + quoteId;
            return $http.get(url);
        }

        function fnSetQuoteTemplateName(id,data){
            var url = api.baseUrl +"/api/v2/quote/"+id+"/template";
            return $http.post(url,data);
        }

        function fnModifyQuoteTemplateName(id,data){
            var url = api.baseUrl +"/api/v2/quote/"+id+"/template";
            return $http.patch(url,data);
        }

        function fnQuoteTemplateDelete(id){
            var url = api.baseUrl +"/api/v2/quote/"+id+"/template";
            return $http.delete(url);
        }

        function fnSetActivityList(quote ,statusData ,oldReminder){
            var newStatus = angular.copy(statusData);
             //delete newStatus.id;
            newStatus["quote_id"] = quote._id;
            var reminder={}
            var current_status = quote.current_status ? quote.current_status.status : quote.status.status_list[quote.status.status_list.length-1].status ;
            var display= oldReminder ? 'A reminder has been update from '+moment(oldReminder).format('DD MMM YYYY')+' to '+ moment(statusData.reminder_date).format('DD MMM YYYY'):'A reminder has been set for '+ moment(statusData.reminder_date).format('DD MMM YYYY') ;
            var ActivityMessage = ('Quote '+ quote.quote_id +' has been changed from '+ current_status +' to '+ statusData.status+ (statusData.status == 'Won' ? ' manually' : '') +'.');
            var activityObj = [{
                "message": ActivityMessage ,
                "type": "status_changed",
                "comment" : statusData.comment,   
                "timestamp": new Date(),
                "user_id": util.userProfile.user.id,
                "user_name": util.userProfile.user.user_first_name + ' '+ util.userProfile.user.user_last_name,
                "activity_data": {}
              }];
              if(statusData.reminder_date){
                  var reminderActivity={
                    "message": display,
                    "type": "reminder",
                    "comment" : statusData.comment,
                    "timestamp": new Date(),
                    "user_id": util.userProfile.user.id,
                    "user_name": util.userProfile.user.user_first_name + ' '+ util.userProfile.user.user_last_name,
                    "activity_data": {}
                  }
                    activityObj.push(reminderActivity);
                    reminder={
                        "quote_id": quote._id,
                        "user_id": util.userProfile.user.id,
                        "reminder_id": quote.reminder && quote.reminder.length >0 ? quote.reminder[0]._id:null,
                        "reminder_date":statusData.reminder_date? moment(statusData.reminder_date).format():null,
                        "comment": statusData.comment,
                        "user_email":util.userProfile.user.email
                    }
              }
            var data = {
                "data" : {
                    "status" : newStatus,
                    "activity" : activityObj,
                    "reminder" : reminder
                }
            }
            return data;
        }

        function getMappingData(queryparam,type){
            var url = api.baseUrl +'/api/v2/sync/'+type+'/partner/charge/mapping?'+(type === 'rate' ? 'searchId=' + queryparam.searchID : 'quoteId=' + queryparam.quotationID)+'&partnerId='+queryparam.partner+'&cardId='+queryparam.cardId[0]
            return $http.get(url);
            
        }
        function getCustomerMappingList(queryparam,platform_id,vendor){
            var url = api.baseUrl + '/api/v2/search/partner/mapping?searchText='+queryparam;
            return $http.get(url)
        }
        function getChargeMappingList(query,mode,subVendorID,partner){
            var url = api.baseUrl + '/api/v2/search/quotations/partner/charge/mapping?query='+query+'&mode='+mode+'&subVendor='+subVendorID+'&linerMappingId='+partner;
            return $http.get(url).then(
              function (response) {
               // console.log(response)
                return response.data;
              },
              function (error) {
                $log.log(error.data);
                return error.data;
              }
            );
          }
        function getSyncUiData(quoteId){
            var url = api.baseUrl + '/api/v2/quote/'+quoteId+'/menu-configuration';
           // var url = api.baseUrl + '/api/v2/quote/CMS000000001050/menu-configuration';
            return $http.get(url)
              
        
        }
    }

})();

(function () {
    "use strict";
  
    angular
      .module("app.core")
      .controller("CopyQuoteDetailsController", CopyQuoteDetailsController);
  
    /** @ngInject */
    function CopyQuoteDetailsController(QuotesService,QuoteDetailsData){
      var vm = this;
      vm.quote_result = angular.copy(QuoteDetailsData);
      vm.is_manual=false;
    }})();

(function ()
{
    'use strict';

    angular
        .module('app.quoteListModule', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.quoteListModule', {
                url    : '/quote-list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/quote-list/quote-list.html',
                        controller : 'QuoteListController as vm'
                    },
                    data : { pageTitle: 'Quote List' }
                },
                resolve : {}
            }),
            // State
        $stateProvider
        .state('app.quoteListModule.quoteDetailsModule', {
            url    : '/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/quote-list/quote-details/quote-details.html',
                    controller : 'QuoteDetailsController as vm'
                },
                data : { pageTitle: 'Quote Details' }
            },
            resolve : {}
        });
    }


})();


(function () {
    "use strict";
  
    angular.module("app.quoteListModule").controller("QuoteDetailsController", QuoteDetailsController);
  
    /** @ngInject */
    function QuoteDetailsController(util, iframeService, $timeout, $state,$scope) {
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();
      $scope.$on('$destroy', function () {
        if (window.removeEventListener) {
          window.removeEventListener("message", getQuoteDetailsIframeRequest, true);
        } else if (window.detachEvent) {
          window.detachEvent("onmessage", getQuoteDetailsIframeRequest);
        }
      });
  
      function init() {
        util.isModulePaid('quotes');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.quotes && util.navPermission.quotes[1])){
            $state.go('app.pages_share_error');
        }
        util.callMixpanel("EFP-Quotes-Details");
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getQuoteDetailsIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getQuoteDetailsIframeRequest, true);
        }

  
      }
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('quote-details','','web');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&quoteDetailsAccessData=1&parentUrl="+ window.location.origin);
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, '&quoteId=' + $state.params.id +"&bookingPermission=" +util.navPermission["shipments"]);
        document.getElementById("quote-details-iframe").src = vm.iframeUrl;
      }

      function getQuoteDetailsIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if(event.origin.indexOf(util.iframeOrigin) && document.getElementById('quote-details-iframe')){
          if(event.data.source === 'quote-list'){
            $state.go("app.quoteListModule");
          }
          if(event.data.source === 'one-quote'){
            util.redirectToOneQuote(event);
           }
          if
          (event.data.source === 'create-bookingv2'){
             util.redirectToBooking(event);
          }
           if (event.data.source === "enquiry") {
             $state.go("app.enquiry.enquiryDetails", { id: event.data.id });
           }
           if(event.data.source === 'quotes'){
            $state.go("app.quoteListModule.quoteDetailsModule",{ id: event.data.id });
          }
          if(event.data.source === 'booking-list'){
            $state.go("app.bookingv2.bookingDetailsV2",{ id: event.data.id });
          }
          if(event.data.source === 'tariffHeaderList' && event.data.reqData && event.data.reqData._id){
            var tariffUrl = $state.href('app.tariffDetails', { id: event.data.reqData._id });
            window.open(util.sanitizeQueryParams(tariffUrl), '_blank', 'noopener');
          }
        }
        if(event.data.source === 'redirectToHome'){
          $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
        }
      }
  
    }
  })();
  
  
(function ()
{
    'use strict';

    angular
        .module('app.profile',['ng.ckeditor'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.profile', {
            url      : '/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
                    AccountData: function (ProfileService)
                    {
                        return ProfileService.getProfile();
                    }
            },
            bodyClass: 'setting-profile'
        });


    }

})();

(function(){
    'use strict';

    angular.module('app.profile')
    .factory('ProfileService' , ProfileService);

    /** @ngInject */
    function ProfileService($q,$mdToast,$http,$log,api,localStorageService,$rootScope)
    {
        var ProfileService = {
            getProfile : getProfile,
            getCompanyProfile : getCompanyProfile,
            updateUser : updateUser,
            getForwarderStatusByVendor : getForwarderStatusByVendor,
            getQuoteStatusByVendor : getQuoteStatusByVendor,
            addShipmentStatus : addShipmentStatus,
            updateShipmentStatus : updateShipmentStatus,
            deleteShipmentStatus : deleteShipmentStatus,
            addQuoteStatus : addQuoteStatus,
            updateQuoteStatus : updateQuoteStatus,
            deleteQuoteStatus : deleteQuoteStatus,
            updateCompanyProfile : updateCompanyProfile
        };

        return ProfileService;

        function getProfile(){
            var url = api.baseUrl + '/api/profile/'+localStorageService.get('authToken').value.user_id;
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        };

        function getCompanyProfile(id){
            var company_id = id ? id : localStorageService.get('authToken').value.user_company_id;
            var url = api.baseUrl + '/api/forwarder/'+company_id ;
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        };

        function updateUser(user_data , id){

            var url = api.baseUrl + '/api/profile/'+id;
            return $http.put(url, user_data);

        };

        function getForwarderStatusByVendor(id){

             var url = api.baseUrl + '/api/forwarder-status/'+id;
             return $http.get(url);

        };

        function getQuoteStatusByVendor(id){

            var url = api.baseUrl + '/api/quote-status/'+id;
            return $http.get(url);

        };

        function addShipmentStatus(status_data){

             var url = api.baseUrl + '/api/forwarder-status';
             return  $http.post(url, status_data);

        };

        function updateShipmentStatus(status_data){

             var url = api.baseUrl + '/api/forwarder-status/'+status_data.shipper_settings.status.vendor_id;
             return  $http.put(url, status_data);

        };

        function deleteShipmentStatus(data,id){

            var url = api.baseUrl + '/api/forwarder-status/' + id;

            var config = {
                method : "DELETE",
                url : url,
                data : data,
                headers : {
                    "content-type": "application/json"
                }
            }
            $http(config).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        };

        function addQuoteStatus(status_data){

            var url = api.baseUrl + '/api/quote-status';
            return  $http.post(url, status_data);

        };

        function updateQuoteStatus(status_data){
            var url = api.baseUrl + '/api/quote-status/'+status_data.data.vendor_id;
            return  $http.put(url, status_data);
        };

        function deleteQuoteStatus(data,id){

            var url = api.baseUrl + '/api/quote-status/' + id;

            var config = {
                method : "DELETE",
                url : url,
                data : data,
                headers : {
                    "content-type": "application/json"
                }
            }
            $http(config).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        };

        function updateCompanyProfile(form,id){
            var settings = {
                "async": true,
                "crossDomain": true,
                "url":  api.baseUrl + '/api/forwarder-update/'+ id ,
                "method": "POST",
                "headers": {
                    'authorization' : 'Bearer '+localStorageService.get('authToken').value.access_token,
                    'referer-domain' : $rootScope.domainData.host_name
                },
                "processData": false,
                "contentType": false,
                "mimeType": "multipart/form-data",
                "data": form
              };
              return $.ajax(settings).done(function (response) {
                  return response;
              });
        };


    }

}());

(function ()
{
    'use strict';

    angular
        .module('app.notification',['ngAvatar'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.notification', {
            url      : '/notification',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/notification/notification.html',
                    controller : 'NotificationController as vm'
                }
            },
            resolve  : {
                    NotificationData: function (NotificationService)
                    {
                        return NotificationService.getNotificationData(0,10);
                    }
            },
            bodyClass: 'notification-page'
        });

 
    }

})();
(function(){
    'use strict';

    angular.module('app.notification')
    .factory('NotificationService' , NotificationService);

    /** @ngInject */
    function NotificationService($q,$mdToast,$http,$log,api,localStorageService)
    {
        var NotificationService = {
            notificationData : {},
            getNotificationData : getNotificationData,
            totalNotificationCount : 0,
            unReadNotificationCount : 0,
            unSeenNotificationCount : 0,
            shipment_active_tab : '',
            getActiveTab : getActiveTab,
            updateNotificationData : updateNotificationData,
            markSeenNotificationData : markSeenNotificationData
        };

        return NotificationService;

        function getNotificationData(offset,count){
            var url = api.baseMockUrl + '/notifications?count='+count+'&offset='+offset;
            return $http.get(url).then(function(response){
                NotificationService.notificationData = response.data.data;
                NotificationService.totalNotificationCount = response.data.data.meta.totalCount;
                NotificationService.unReadNotificationCount = response.data.data.meta.totalUnreadCount;
                NotificationService.unSeenNotificationCount = response.data.data.meta.totalUnseenCount; 
                return NotificationService;
            },function(error){
                console.log(error);
            });
        }

        // function getUnreadNotificationCount(NotificationData){
        //     // NotificationService.unReadNotificationCount = 0;
        //     // for (var i = 0; i < NotificationData.length; i++) {
        //     //     if(!NotificationData[i].read){
        //     //         NotificationService.unReadNotificationCount = NotificationService.unReadNotificationCount + 1;
        //     //     }
        //     // }
        //     // return NotificationService.unReadNotificationCount;
        // }

        function getActiveTab(shipment_nav){
            var selectedTab = 0;
            if(NotificationService.shipment_active_tab!==''){
                for(var i = 0; i < shipment_nav.length; i++){
                    if(shipment_nav[i].name === NotificationService.shipment_active_tab){
                        selectedTab = i;
                    }
                }
            }
            return selectedTab;
        }

        function updateNotificationData(postData,id){
            var url = api.baseUrl + '/api/notifications/' + id;

            return $http.put(url,postData).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
            // return $http.put(api.baseUrl + '/api/shipments/'+ id , data);
        }

        function markSeenNotificationData(data){
            var url = api.baseUrl + '/api/notifications/seen';

            return $http.put(url,data).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        }

    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.dauFclLeg', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.dauFclLeg', {
                url    : '/maintain-rates-fcl',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/modify-rates/dau-fcl-leg/dauFclLeg.html',
                        controller : 'DauController as vm'
                    },
                    data : { pageTitle: 'Maintain Rates Fcl' }
                },
                resolve: {},
            });

    }


})();

(function () {
    "use strict";
  
    angular.module("app.dauFclLeg").controller("DauController", DauController);
  
    /** @ngInject */
    function DauController(util, iframeService, $timeout, $state, $rootScope) {
  
      // data
      var vm = this;
      vm.iframeService = iframeService;
  
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
  
      // if god user changed forwarder refresh data
      $rootScope.$on('app.dauFclLeg', function (event, args) {
        vm.init();
      });
  
      function init() {
        util.isModulePaid('dauFclLeg');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.dauFclLeg && util.navPermission.dauFclLeg[1])){ 
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 50);
  
      }
      vm.init();
  
      // get dauFclLeg iframe url
            
      function formIframeUrl() {  
        vm.iframeUrl = iframeService.getIntegrationUrl('dauFclLeg');
        document.getElementById("dauFclLeg-iframe").src = vm.iframeUrl
      }
    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.bulkUpdate', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.bulkUpdate', {
                url    : '/bulk-update',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/modify-rates/bulk-update/bulkUpdate.html',
                        controller : 'BulkUpdateController as vm'
                    },
                    data : { pageTitle: 'Bulk Update' }
                },
                resolve: {},
            });

    }


})();

(function () {
    "use strict";
  
    angular.module("app.bulkUpdate").controller("BulkUpdateController", BulkUpdateController);
  
    /** @ngInject */
    function BulkUpdateController(util, iframeService, $timeout, $state, $rootScope) {
  
      // data
      var vm = this;
      vm.iframeService = iframeService;
  
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
  
      // if god user changed forwarder refresh data
      $rootScope.$on('app.bulkUpdate', function (event, args) {
        vm.init();
      });
  
      function init() {
        util.isModulePaid('bulkUpdate');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.bulkUpdate && util.navPermission.bulkUpdate[1])){ 
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 50);
  
      }
      vm.init();
  
      // get bulk update iframe url
            
      function formIframeUrl() {  
        vm.iframeUrl = iframeService.getIntegrationUrl('bulkUpdate');
        document.getElementById("bulk-update-iframe").src = vm.iframeUrl
      }
    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.auditTrail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.auditTrail', {
                url    : '/audit-trail',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/modify-rates/audit-trail/auditTrail.html',
                        controller : 'AuditTrailController as vm'
                    },
                    data : { pageTitle: 'Audit Trail' }
                },
                resolve: {},
            });

    }


})();

(function () {
    "use strict";
  
    angular.module("app.auditTrail").controller("AuditTrailController", AuditTrailController);
  
    /** @ngInject */
    function AuditTrailController(util, iframeService, $timeout, $state, $rootScope) {
  
      // data
      var vm = this;
      vm.iframeService = iframeService;
  
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
  
      // if god user changed forwarder refresh data
      $rootScope.$on('app.auditTrail', function (event, args) {
        vm.init();
      });
  
      function init() {
        util.isModulePaid('auditTrail');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.auditTrail && util.navPermission.auditTrail[1])){ 
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 50);
  
      }
      vm.init();
  
      // get bulk update iframe url
            
      function formIframeUrl() {  
        vm.iframeUrl = iframeService.getIntegrationUrl('auditTrail');
        document.getElementById("audit-trail-iframe").src = vm.iframeUrl
      }
    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.enquiry',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.enquiry', {
            url      : '/enquiry-list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/enquiry-v2/enquiry-list.html',
                    controller : 'EnquiryListController as vm'
                }
            },
            // resolve: {
               
            // },
            bodyClass: 'enquiry-List'
        })

        .state('app.enquiry.enquiryDetails', {
            url  : '/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/enquiry-v2/enquiry-details/enquiry-details.html',
                    controller : 'EnquiryDetailsController as vm'
                },
                data : { pageTitle: 'enquiry-Detail' }
            },
            // resolve: {
            //     enquiryDetailsData: function ($stateParams,enquiryService){
            //         return enquiryService.getenquiryDetails($stateParams.id);
            //     }
            // },
            bodyClass: 'Inquiry-Details'
        });

        // msNavigationServiceProvider.saveItem('fuse.inquiry', {
        //     title    : 'Inquiry',
        //     icon     : 'icon-file-find',
        //     state    : 'app.inquiry',
        //     // translate: 'UPLOADRATES.UPLOADRATES_NAV',
        //     weight   : 1
        // });


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.enquiry')
        .controller('EnquiryDetailsController', EnquiryDetailsController);

    /** @ngInject */
    function EnquiryDetailsController(util, $scope, $state, iframeService,$timeout)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.iframeService = iframeService;

        // method
        vm.init = init;
        vm.formIframeUrl = formIframeUrl;
        vm.init();
        $scope.$on('$destroy', function () {
            if (window.removeEventListener) {
            window.removeEventListener("message", getEnquiryDetailsIframeRequest, true);
            } else if (window.detachEvent) {
            window.detachEvent("onmessage", getEnquiryDetailsIframeRequest);
            }
        });
  
      function init() {
        // util.isModulePaid('inquiry');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.inquiry && util.navPermission.inquiry[1])){
            $state.go('app.pages_share_error');
        }
        util.callMixpanel("EFP-Inquiry-Details");
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getEnquiryDetailsIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getEnquiryDetailsIframeRequest, true);
        }

  
      }
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('enquiry','','web');
        vm.iframeUrl = vm.iframeUrl.replace('/shared', '/'+$state.params.id+'/shared');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&enquiryDetailsAccessData=1&parentUrl="+ window.location.origin);
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, '&enquiryId=' + $state.params.id +"&bookingPermission=" + util.navPermission["shipments"]);
        document.getElementById("enquiry-details-iframe").src = vm.iframeUrl;
      }

      function getEnquiryDetailsIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if(event.origin.indexOf(util.iframeOrigin) && document.getElementById('enquiry-details-iframe')){
          if(event.data.source === 'enquiry-list'){
            $state.go("app.enquiry");
          }

          if(event.data.source === 'create-bookingv2'){
             util.redirectToBooking(event);
          }
          if(event.data.source === 'one-quote'){
            util.redirectToOneQuote(event);
           }
           
              if (event.data.source === "quotes") {
                $state.go("app.quoteListModule.quoteDetailsModule", {
                  id: event.data.id
                });
              }
              
        }
        if(event.data.source === 'redirectToHome'){
          $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
        }

        if (event.data.source === "bookingDetails") {
          $state.go("app.bookingv2.bookingDetailsV2", { id: event.data.id });
        }

        if(event.data.source === 'tariffHeaderList' && event.data.reqData && event.data.reqData._id){
          var tariffUrl = $state.href('app.tariffDetails', { id: event.data.reqData._id });
          window.open(util.sanitizeQueryParams(tariffUrl), '_blank', 'noopener');
        }
      }

    }
})();

(function() {
  "use strict";

  angular.module("app.rates", []).config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider
  ) {
    $stateProvider.state("app.rates", {
      url: "/customRates",
      views: {
        "content@app": {
          templateUrl: "app/main/customRates/customRates.html",
          controller: "CustomRatesController as vm"
        },
        data: { pageTitle: "CustomRates" }
      },
      resolve: {
        // Incoterms : function(resultService){
        //     return resultService.getIncoterms();
        // },
        // TermsConditions : function(resultService){
        //     return resultService.getTermsConditions()
        // }
      },
      bodyClass: "Custom-Rates"
    });

    // Translation
    $translatePartialLoaderProvider.addPart("app/main/customRates");

    // msNavigationServiceProvider.saveItem("fuse.customRates", {
    //   title: "Custom Rates",
    //   icon: "icon-document",
    //   state: "app.customRates",
    //   /*stateParams: {
    //             'param1': 'page'
    //          },*/
    //   translate: "CUSTOMRATES.CUSTOMRATES_NAV",
    //   weight: 1
    // });
  }
})();

(function () {
  "use strict";

  angular
    .module("app.rates")
    .factory("customRatesService", customRatesService);

  /** @ngInject */
  function customRatesService(api, $http) {

    var customRatesService = {
      getCountries: getCountries,
      getPortsOfCountry: getPortsOfCountry,
      submitRates: submitRates,
      getChargeList: getChargeList,
      getUploadedData: getUploadedData,
      putUploadedData: putUploadedData,
      deleteUploadedData: deleteUploadedData,
      // ratesData: null,
      loadTypeArr: [],
      localUrl: 'https://e2fe7885.ngrok.io',
      config: {
        headers: {
          'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjQ2NzVjNDJlZDFiNDBiMzdhMGQ0NmJmNGZjNGQ3ZDU3NmI2OTc0OTk0YTNmNGJlYWM0NTRmMzhmYmRmMmU5ZmZiMzRiOTRmNDlhYmFlZjc5In0.eyJhdWQiOiIyIiwianRpIjoiNDY3NWM0MmVkMWI0MGIzN2EwZDQ2YmY0ZmM0ZDdkNTc2YjY5NzQ5OTRhM2Y0YmVhYzQ1NGYzOGZiZGYyZTlmZmIzNGI5NGY0OWFiYWVmNzkiLCJpYXQiOjE1NjA0OTU1MjQsIm5iZiI6MTU2MDQ5NTUyNCwiZXhwIjoxNTYxNzkxNTIzLCJzdWIiOiI2NmNjZDA3MC1hZGNkLTExZTgtOTU4Ny03YmMxYjc2OWQ3NmYiLCJzY29wZXMiOltdfQ.Ay7rCK19PxmBht8X6NhryQf0Ws9DJ0voJHwZTJkBxuZppkGMTUgEkxIqgo4274ESKOXH7s9tpTk5VsNWQTwGHlKGQmhsKa5cfw13b8tNUE667Cl5KRVK1I65dNbPsq7ZpFxqdsKqZ8kyisGL4bUwxV8xTV4MHaRRo7kuqHRe8Ko1Ox848W9vNLFBlUF-FAOaPDa1KNoPoNjrjVMGBoj5KS5UN9C5FB7QuQgrIG5Jl6dW2HiDaHvy0fd8obMaB02uneTtPJMLAtujlsB43ObzBxVnNOhsSoRxFnfDVGKe99pkc3TKQ1wtcru7s6KT0mM2UCUgGzLima6PO5_O4HUpw-N3kfm3ge6NoMoHmM1nsmBVPATrFNiuVO9X1X-cTaGRcpzRjb98R1E6XyYpIpvyZM3hKgT-q9E37P8A-yv3rm6YE8S0_NDIgHdOFcrAXwlrLq1Omqfmua4xLjfcu9PwCpTUNNvoQ6BxSjQw9Ifqm2m8TxPYHNt64Bb4aKao-1qdd6ZmOa8GbQdT3C4AS3XgqTmJIw26jKG3nf_3O2-uRVP79bVWZ_7Riig2WtXiVFf1g1Sz4G1sGVBm3slZR-MH_j1n068Qhk86mXq_JkuMv9W2DRrZ84LKCC5rd0jcYRArHJCvpO0r_KxpCy9FUr1JLHzZPTrDt1NKdkDgj7Fr69s'
        }
      }
    };
    return customRatesService;

    function deleteUploadedData(id, mode) {
      var url = api.baseUrl + '/api/custom-rates' + '/' + id + '?leg_code=' + mode ;
      return $http.delete(url);
    }


    function putUploadedData(data) {
      var url = api.baseUrl + '/api/custom-rates';
      return $http.put(url, data);
    }

    function getUploadedData(mode, id) {
      var url;
      if(id) {
        url = api.baseUrl + '/api/custom-rates?leg_code=' + mode + '&company_id=' + id;
      } else {
        url = api.baseUrl + '/api/custom-rates?leg_code=' + mode;
      }
      return $http.get(url);
    }

    function getCountries() {
      var url = api.baseUrl + '/api/country-list';
      return $http.get(url);
    }

    function getPortsOfCountry(data) {
      var url = api.baseUrl + '/api/ports';
      return $http.post(url, data);
    }

    function submitRates(data) {
      var url = api.baseUrl + '/api/custom-rates';
      return $http.post(url, data);
    }

    function getChargeList(mode, leg) {
      var obj = {
        'mode': mode,
        'leg': leg
      };
      var url = api.baseUrl + '/api/custom-rates-chargeline';
      return $http.post(url, obj);
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createShipment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {
        // State
        $stateProvider
            // .state('app.createShipment', {
            //     url    : '/create-shipments',
            //     views  : {
            //         'content@app': {
            //             templateUrl: 'app/main/create-shipment/create-shipment.html',
            //             controller : 'CreateShipmentsController as vm'
            //         },
            //         data : { pageTitle: 'Create-Shipments' }
            //     },
               
            //     bodyClass: 'shipments-page'
            // })
            .state('app.createShipment', {
                url    : '/create-shipment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/create-shipment/fcl-create-shipment/fcl-create-shipment.html',
                        controller : 'FclCreateShipmentController as vm'
                    },
                    data : { pageTitle: 'Create Shipment' }
                },
               
                bodyClass: 'create-shipment'
            });

    }


})();

(function () {
  'use strict';

  angular
      .module('app.createShipment')
      .controller('FclCreateShipmentController', FclCreateShipmentController);

  /** @ngInject */
  function FclCreateShipmentController(util, iframeService, $timeout, $state, $rootScope) {

    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;
    vm.util=util;

    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;

    // if god user changed forwarder refresh data
    $rootScope.$on('app.createShipment', function (event, args) {
      vm.init();
    });

    function init() {
      util.isModulePaid('createShipment');
      vm.minHeight = vm.iframeService.iframeHeight;
      if(!(util.navPermission.createShipment && util.navPermission.createShipment[0])){
        $state.go('app.pages_share_error');
      }

      vm.formIframeUrl(); // Get Iframe src url
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

       $timeout(function () {
        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
       }, 50);

      document.getElementById('fcl-create-shipment-iframe').onload = function() {
        var postParam = {
            'parentOrigin': util.sanitizeUrl(window.location.origin),
            'requestObj': iframeService.requestObj
        }

        var targetOrigin = (new URL(vm.iframeUrl)).origin;
        document.getElementById('fcl-create-shipment-iframe').contentWindow.postMessage(postParam,targetOrigin);
        iframeService.requestObj = {
          searchParam:null,
          source:null
        }
      };
      vm.isShipmentCreated = false
      window.removeEventListener('message', fnRedirectToShipment, true);
      if(window.addEventListener) {
        window.addEventListener("message", fnRedirectToShipment, true);        
      } 
      else if (window.attachEvent) {
        window.attachEvent("onmessage", fnRedirectToShipment, true);
      }

    }
    vm.init();

    // get add-rates iframe url
    function formIframeUrl() {
      vm.iframeUrl = iframeService.fnGetIframeUrl('createShipment');
      document.getElementById("fcl-create-shipment-iframe").src = vm.iframeUrl
    }

    function fnRedirectToShipment(event){
      if(!vm.isShipmentCreated && event.data.id && event.data.source=='shipments' && event.origin.indexOf(vm.util.iframeOrigin)){
        vm.isShipmentCreated = true;
        $state.go('app.shipments.shipment_details',{ id: event.data.id});
      }
    }
  }
})();
(function () {
    "use strict";
  
    angular
      .module("app.core")
      .controller("XenetaRateIndexController", XenetaRateIndexController)
      .factory("xenetaViewFactory", function () {
        return {panelClosed: false};
      });
  
    function XenetaRateIndexController(mdPanelRef, xenetaViewFactory,util) {
  
      var vm = this;
      vm._mdPanelRef = mdPanelRef;
      vm.closePanel = closePanel;

      vm.fnDrawChart = fnDrawChart;
      vm.labels = [];
      vm.displayGraph = true;
      vm.datasets = [];

      vm.xenetaViewFactory = xenetaViewFactory; // Variable Declaration
  

      this.$onInit = function() {
        vm.fnDrawChart();
      }

      function fnDrawChart(){
        vm.displayGraph = false;
        
        vm.datasets = [];
        angular.forEach(vm.card.meta.xenetaRateArray, function (item, index) {

            if(vm.card.meta.xenetaRateAverage.containerType === item.container_type){
                var data = {
                    label: "",
                    data: [],
                    borderColor: vm.card.meta.xenetaRateAverage.textColor,
                    backgroundColor: vm.card.meta.xenetaRateAverage.textColor,
                    fill: false,
                    borderWidth: 2,
                    radius : 1,
                    tension: 0
                };

                data.label = item.container_type;

                angular.forEach(item.market_rates_by_day.mean, function (childItem, childIndex) {
                    vm.labels.push( moment(new Date(childItem.day)).format('DD MMM YYYY'));
                    data.data.push(childItem.value);
                });

                vm.datasets.push(data);
            }
        });

        setTimeout(function() {
            
            var ctx = document.getElementById('xenetaLieChart').getContext('2d');
            new Chart(ctx, {
                type: 'line',
                data: {
                labels: vm.labels,
                datasets: vm.datasets
                },
                options: {
                  responsive: false,
                  interaction: {
                      mode: 'index',
                      intersect: false,
                  },
                  tooltips: {
                    callbacks : {
                        afterTitle: function footer (tooltipItem) {
                            return "Market Rate : Average";
                        },
                        label: function footer (tooltipItem,data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || '';
                            return label+" : $"+tooltipItem.yLabel;
                        },
                    }
                },
                  legend: {display: false},
                  scales: {
                    xAxes: [{
                      ticks: {
                        maxTicksLimit: 4,
                        maxRotation: 0,
                        fontColor: '#FFFFFF',
                        padding: 10,
                      },
                      gridLines: {
                        display: true, 
                        color: '#FFFFFF',
                        drawBorder: true,
                        drawTicks: false,
                        drawOnChartArea: false,
                      },
                    }],
                    yAxes: [{
                      ticks: {
                        fontColor: '#FFFFFF',
                        padding: 10,
                      },
                      gridLines: {
                        display: true, 
                        color: '#FFFFFF',
                        drawBorder: true,
                        drawTicks: false,         
                        drawOnChartArea: false,
                      },
                    }],
                  }
                }
            });
        }, 0);
    }
      

      function closePanel() {
        vm._mdPanelRef && vm._mdPanelRef.close();
      }
      
    }
  
  })();
  
(function () {
    'use strict';
  
    angular
    .module('app.core')
    .component('xenetaRateIndex', {
        templateUrl: 'app/main/component/xeneta-rate-index/xeneta-rate-index.html',
        bindings : {
            rateIndexData : '=',
        },
        controller: XenetaRateIndexController
    });
  
  
    function XenetaRateIndexController(util) {
        var vm = this;
        vm.lineColors = ['#0E9CFF', '#FFB8FF', '#89FA1A', '#9a66ff'];
        vm.hexToRgba = hexToRgba;
        vm.fnDrawChart = fnDrawChart;
        vm.equipmentList = []; // all available container types
        vm.selectedEquipment = [];
        vm.displayGraph = true;
        vm.labels = [];

        this.$onInit = function() { 

            vm.originPort = vm.rateIndexData[0].meta.actual_origin.location + ", " + vm.rateIndexData[0].meta.actual_origin.name;

            vm.destinationPort = vm.rateIndexData[0].meta.actual_destination.location + ", " + vm.rateIndexData[0].meta.actual_destination.name;

            vm.marketInput = 'Average';

            angular.forEach(vm.rateIndexData, function (item, index) {
                vm.selectedEquipment.push(item.container_type);

                angular.forEach(item.market_rates_by_day.mean, function (childItem, childIndex) {
                    if(index == 0) {
                        vm.labels.push( moment(new Date(childItem.day)).format('DD MMM YYYY'));
                    }
                });
            });
            vm.equipmentList = angular.copy(vm.selectedEquipment);

            vm.fnDrawChart();
        };


        function fnDrawChart(){
            vm.displayGraph = false;
            
            vm.datasets = [];

            angular.forEach(vm.rateIndexData, function (item, index) {
                
                var matchedContainer = vm.selectedEquipment.find(function(el){ 
                    return el === item.container_type; 
                  });

                if(matchedContainer){
                    var data = {
                        label: "",
                        data: [],
                        borderColor: vm.lineColors[index],
                        backgroundColor: vm.lineColors[index],
                        fill: false,
                        borderWidth: 2,
                        radius : 1,
                        tension: 0,
                    };

                    data.label = item.container_type;

                    angular.forEach(item.market_rates_by_day.mean, function (childItem, childIndex) {
                        data.data.push(childItem.value);
                    });

                    vm.datasets.push(data);
                }
            });

            setTimeout(function() {
                
                var ctx = document.getElementById('dueAmountOverTimeChart').getContext('2d');
                new Chart(ctx, {
                    type: 'line',
                    data: {
                    labels: vm.labels,
                    datasets: vm.datasets
                    },
                    options: {
                        responsive: true,
                        interaction: {
                            mode: 'index',
                            intersect: true,
                        },
                        tooltips: {
                            callbacks : {
                                // title: function footer (tooltipItem) {
                                //     var label = new Date(tooltipItem[0].label);
                                //     return moment(label, 'DD/MM/YYYY', true).format('MMM DD,YYYY')
                                // },
                                afterTitle: function footer (tooltipItem) {
                                    return "Market Rate : Average";
                                },
                                label: function footer (tooltipItem,data) {
                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                    return label+" : $"+tooltipItem.yLabel;
                                },
                            }
                        },
                        legend: {
                            display: true,
                            position: 'top',    // top of the chart
                            labels: {
                                boxWidth: 12,
                                padding: 10,
                            }
                        },
                        scales: {
                            xAxes: [{
                              ticks: {
                                maxTicksLimit: 14,
                                maxRotation: 0,
                                padding: 10,
                              },
                              gridLines: {
                                display: true, 
                                drawBorder: true,
                                drawTicks: false,
                              },
                            }],
                            yAxes: [{
                                ticks: {
                                    // fontColor: '#FFFFFF',
                                    padding: 10,
                                },
                                gridLines: {
                                  display: true, 
                                  drawBorder: true,
                                  drawTicks: false,
                                },
                              }]
                        }
                    }
                });
            }, 0);
        }

        function hexToRgba(hex, opacity) {
            // Ensure the input is a valid HEX color
            hex = hex.replace(/^#/, '');
        
            // Convert 3-digit HEX to 6-digit HEX
            if (hex.length === 3) {
                hex = hex.split('').map(function (char, index) {
                    return char + char.join('');
                });
            }
        
            // Extract RGB values
            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);
        
            return 'rgba '+ r +','+ g +','+ b +','+ opacity;
        }

    }

})();
(function () {
    "use strict";
    angular
    .module('app.core')
    .controller('warningPanelController', warningPanelController);
   
    function warningPanelController(mdPanelRef,$mdDialog) {

       //  variables
        var vm = this;
        vm._mdPanelRef = mdPanelRef;
        // methods
        vm.fnConfirmationCancel = fnConfirmationCancel;

        function fnConfirmationCancel(event) {
                if(event){
                      $mdDialog.hide();
                }
            vm._mdPanelRef && vm._mdPanelRef.close();
         }
        
    }


})();

(function () {
  'use strict';

  angular
  .module('app.core')
  .component('syncButton', {
      templateUrl: 'app/main/component/sync-button/sync-button.html',
      bindings : {
        erpdata: '=',
        sendtoerrtype: '=',
        entity: '=',
        responsestatusdata:'=',
        shipmentmeta:'=',
        shipmentdata:'=',
          callback : '&'
      },
      controller: SyncButtonController
  });


  function SyncButtonController(util,localStorageService,$rootScope,$timeout,api, $mdDialog, $mdMenu, $log ,$mdPanel) {
      var vm = this;
      vm.util = util;
      vm._mdPanel = $mdPanel;
      vm.zyboReference="Zybo";
      vm.cargowiseReference="cargowise";
      vm.otmReference="OTM";
      vm.fresaReference = "Fresa";
      vm.patnerReference=[];
      vm.openSendToMenu = openSendToMenu;
      vm.fnShipmentSendTo = fnShipmentSendTo;
      vm.fnCargowiseSendto =fnCargowiseSendto;
      vm.erpIntegrationList=[];
      vm.openConfirmation=openConfirmation;
      vm.integrationList = [];
      vm.new_org=false;
      vm.getErpData=getErpData;
      vm.fnCargowiseIntergration=fnCargowiseIntergration;
      vm.cancelDialog=cancelDialog;
      vm.fnGetSubMenu=fnGetSubMenu;
      vm.errorMessageDisplay=errorMessageDisplay;
      vm.updateBookingStatus = updateBookingStatus;
      vm.fnOpenChargeMapping = fnOpenChargeMapping;
      vm.fnChargeSelection = fnChargeSelection;
      vm.fnAgentSelection=fnAgentSelection;
      vm.getChargeList = getChargeList;
      vm.getAgentList = getAgentList;
      vm.fnSubmitCharges =fnSubmitCharges;
      vm.updateChargeStatus=updateChargeStatus;
      vm.removeValidation=removeValidation;
      vm.checkUnmapped=checkUnmapped;
      vm.fnNextScreen = fnNextScreen;
      vm.showScreen = 1;
      vm.fnPrevScreen = fnPrevScreen;
      vm.validateChargeMapping = validateChargeMapping;
      vm.chargeMappingErr = {};
      vm.fnNominatedChange = fnNominatedChange;
      vm.agentList = [];
      vm.fnLegSelect = fnLegSelect;
      vm.showConfirmationModel = showConfirmationModel;
      vm.legMapping = {};
      vm.unmapped =[]
      vm.isPanelOpened = true;
      vm.isMappedPanelOpened = false;
      vm.panelExpansion = panelExpansion;
      vm.panelMappedExpansion = panelMappedExpansion;

      /** True when value is CargoWise by display name (e.g. Cargowise) or erp_code (e.g. CARGOWISE). */
      function isCargowisePartner(value) {
        return value != null && String(value).toLowerCase() === vm.cargowiseReference;
      }

      this.$onInit = function() {
        if(!vm.util.isShipper && (vm.util.isAdmin || vm.util.isFreightbro)){
          getErpData();
        }
      }
      function updateBookingStatus(){
        var isMatch =  vm.patnerReference.some(function(element) {
          return element === vm.shipmentmeta.partner;
        });
        vm.isBooked= isMatch && vm.shipmentmeta.additional_attributes && vm.shipmentmeta.additional_attributes.current_booking_id ? true : false;
        vm.isShipmentDone = isMatch && vm.shipmentmeta.additional_attributes && vm.shipmentmeta.additional_attributes.current_shipment_id ? true : false;

        // vm.isCargoBooked=vm.shipmentmeta.partner == vm.cargowiseReference && vm.shipmentmeta.additional_attributes && vm.shipmentmeta.additional_attributes.current_booking_id ? true : false;
        // vm.isCargoShipmentDone = vm.shipmentmeta.partner == vm.cargowiseReference && vm.shipmentmeta.additional_attributes && vm.shipmentmeta.additional_attributes.current_shipment_id ? true : false;
      }

      function getErpData(){
        if(localStorageService.get('erpIntegrationList') && !vm.util.isFreightbro){
          vm.erpIntegrationList = localStorageService.get('erpIntegrationList').value[vm.entity];
        }else{
          util.callerpIntegrationApi().then(function(response) {
            vm.erpIntegrationList = localStorageService.get('erpIntegrationList') ? localStorageService.get('erpIntegrationList').value[vm.entity] : [];
            fnGetErpIntegrationList();
          },function(error) {
              $log.log(error.data);
          });
        }
        vm.patnerReference=vm.erpIntegrationList.map(function(obj) {
          return obj['code'];
        });
        fnGetErpIntegrationList();
      }
      function openSendToMenu($mdMenu,ev){
        if(!vm.integrationList.length){
          fnGetErpIntegrationList();
          }
        $mdMenu.open(ev);
      }

      // Get list of forwader account list for shipment send
      function fnGetErpIntegrationList(){
        vm.integrationList =[];
        vm.updateBookingStatus();
        vm.erpIntegrationList.forEach(function (erp) {
          if(erp.name == vm.zyboReference && vm.shipmentmeta.mode != 'SEA-FCL'){
            return
          }

          var avaiableObj = (vm.erpdata && vm.erpdata.length) ? vm.erpdata.find(function(item){ return item.erp_code === erp.code; }) : '';
          var isPartnerMatch = vm.shipmentmeta.partner != null && String(vm.shipmentmeta.partner).toLowerCase() === String(erp.code).toLowerCase();
                    var erpObj = {
            "_id": erp._id,
            "status_code": avaiableObj ? avaiableObj.status_code :vm.shipmentmeta.last_synced_at && isPartnerMatch ? 200: "",
            "erp_code": avaiableObj ? avaiableObj.erp_code : erp.code,
            "sync_time": avaiableObj ? avaiableObj.sync_time : vm.shipmentmeta.last_synced_at && isPartnerMatch ? vm.shipmentmeta.last_synced_at :"",
            "message": avaiableObj ? avaiableObj.message : "Yet to sync",
            "name": erp.name,
            "is_charge_mapping_required":erp.is_charge_mapping_required,
            "status": erp.status,
            "isDisabled": ((vm.otmReference === erp.name) && vm.isShipmentDone) || ((vm.fresaReference === erp.name) && vm.isShipmentDone),
            "sub_menus":{}
          }
          var entities = erp.entity.split(',').map(function(entity) {
            return entity.trim();
          });
    
          entities.forEach(function(entity) {
            erpObj.sub_menus[entity] = erp.sub_menus ? vm.fnGetSubMenu(erp, entity) : [];
          });
          vm.integrationList.push(erpObj);
        });
      }

      function fnGetSubMenu(erp,type){
        vm.updateBookingStatus();
        var erpObj = angular.copy(erp);
        var sub_menus = erpObj.sub_menus[type] ? erpObj.sub_menus[type] : erpObj.sub_menus;
        var isSynced = (type === 'booking') ? vm.isBooked : vm.isShipmentDone;
        var isOtmBooking = (type === 'booking') && (vm.otmReference === erpObj.name)
        var isFresaBooking = (type === 'booking') && (vm.fresaReference === erpObj.name)
        var isMenu = (erpObj.code || erpObj.erp_code) === vm.shipmentmeta.partner;
        var formatedType = type.charAt(0).toUpperCase() + type.slice(1);
        sub_menus.forEach(function (menu) {
          if(menu.name=='Create New' && !isOtmBooking && !isFresaBooking){
            menu.displayName= (isSynced && isMenu )  ? "Send As New "+formatedType: "Send "+formatedType;
          }
          if(menu.name=='Update Existing' && !isOtmBooking && !isFresaBooking){
            menu.displayName= (isSynced && isMenu ) ? "Update Existing "+formatedType:"";
          }
          menu.isDisabled = (type === 'booking') ?
                            (vm.isShipmentDone && isCargowisePartner(erpObj.code || erpObj.erp_code)) || (vm.isBooked && erpObj.name === vm.zyboReference) :
                            (type === 'shipment' && erpObj.name === vm.zyboReference);
        });
        return sub_menus;
      }

      function errorMessageDisplay(error){
        var errorMessage=[];
        angular.forEach(error,function(value){
            angular.forEach(value,function(message){
              errorMessage.push( message)
            })
          });
        return errorMessage     
      }
      // send shipment to selected forwarder account
      function fnShipmentSendTo(company){
        util.callMixpanel('SD-'+company.erp_code+'-Click');
        vm.showloader = true;
        vm.sendtoerrtype = '';
        var reqData = {
          "data": {
            "integration_id": company._id ,
            "entity_id": vm.shipmentmeta.shipment_id,
            "entity": vm.entity
          }
        }
        util.postErpIntegration(reqData).then(function(response){
         var resObj= response;
         if(!resObj.erp_code){
          util.showToast(resObj.message);
          vm.showloader = false;
         }
         var index = vm.integrationList.findIndex(function(item){
          return item.erp_code === resObj.erp_code;
         });
         vm.integrationList[index].status = resObj.status;
         vm.integrationList[index].status_code = resObj.status_code;
         vm.integrationList[index].sync_time = resObj.sync_time;
         vm.integrationList[index].message = resObj.message;
         vm.showloader = false;
         vm.sendtoerrtype = resObj.status_code;
          $timeout(function () {
            vm.sendtoerrtype = '';
          }, 5000);
        },function(error){
            vm.showloader = false;
            util.showToast(util.displayValidationError(error));
            $log.log(error);
        });
      }

      function fnCargowiseSendto(submenus,index,ev,partner,type,mapping){
        var isSynced = type === 'booking' ? vm.isBooked : vm.isShipmentDone;
        var newBooking = (submenus.name =='Create New' && isSynced) ? true :false
         var data={}
         if(newBooking){
         var partner_reference_id = type === 'booking' ? vm.shipmentmeta.additional_attributes && vm.shipmentmeta.additional_attributes["current_booking_id"] : vm.shipmentmeta.additional_attributes && vm.shipmentmeta.additional_attributes["current_shipment_id"];
         data= {
            "title":'Send as a new '+type+' ?',
            "content":'In '+partner+ ', there will be two '+type+'s by sending as a new '+type+'. Old '+ partner_reference_id+' will still exist, and this will be created as a new '+type+'.',
            "newBooking":newBooking,
            "submenus":submenus,
            "new_org":false,
            "partner":partner,
            "type":type,
            "mapping":mapping
           }
          vm.openConfirmation(data,ev);
          return;
         }
         util.callMixpanel('SD-'+partner+'-'+submenus.displayName+'-Click');
         vm.fnCargowiseIntergration(newBooking,ev,submenus,false,partner,type,mapping);
      }
      function fnCargowiseIntergration(newBooking,ev,submenus,new_org,partner,type,mapping){
        var data={}
        vm.new_org=new_org
        vm.showloader = true;
        if(vm.otmReference !== partner && !isCargowisePartner(vm.partner)){
          vm.cancelDialog('');
        }else{
          vm.chargeMappingErr = {};
          var nextScreen = isCargowisePartner(vm.partner) ? 1 : 2;
          fnNextScreen(nextScreen);
          vm.showScreen = nextScreen + 1;
        }
        var index = vm.integrationList.findIndex(function(item){
          return item.erp_code === partner;
         });
         if(mapping){
          //getAgentList();
          vm.fnOpenChargeMapping(newBooking,ev,submenus,partner,type);
          return;
         }
         var url='/api/sync/booking?partner='+partner+'&force_new='+newBooking+'&create_org='+vm.new_org+'&id='+vm.shipmentmeta.shipment_id+'&entity='+type;
         var config = {
          method : submenus.http_method,
          url : url, 
          data: vm.chargeMappingObj
        }
       
        util.cargowiseIntegration(config).then(function(response){
         vm.showloader = false;
         if(response.status == 200){
         vm.responsestatusdata.push({
          responseFrom: "QUOTES",
          status: "COMPLETED",
          message:response.data.display_message ,
        });

         vm.integrationList[index].status_code = response.status;
         vm.integrationList[index].sync_time = response.data.data.last_synced_at;
         vm.shipmentmeta.partner_reference_id=response.data.data.partner_reference_id;
         vm.shipmentmeta.partner=partner;
         vm.shipmentmeta.additional_attributes = vm.shipmentmeta.additional_attributes || {};
         if(type === 'shipment'){
           vm.shipmentmeta.additional_attributes["current_shipment_id"] = response.data.data.partner_reference_id;
           vm.integrationList[index].isDisabled = (vm.otmReference === partner) || (vm.fresaReference === partner)
          // vm.integrationList[index].isDisabled = (vm.fresaReference === partner) 
         }else{
          vm.shipmentmeta.additional_attributes["current_booking_id"] = response.data.data.partner_reference_id;
         }

         if(Object.keys(vm.integrationList[index].sub_menus).length){
          Object.keys(vm.integrationList[index].sub_menus).forEach(function(type){
            vm.integrationList[index].sub_menus[type] = vm.integrationList[index].sub_menus[type] ? vm.fnGetSubMenu(vm.integrationList[index],type): []
          })
         }
         
         vm.sendtoerrtype = response.status_code;
         checkChargeMappingRes(partner, response,true);
         $rootScope.$broadcast('getFeeds');
         
      }
      else if(response.status == 400 && response.data.errors  ){
        data={
          "title":response.data.message,
          "errorMessage":vm.errorMessageDisplay(response.data.errors),
          "newBooking":newBooking,
          "addShipper":"addShipper",
          "submenus":submenus,
          "new_org":false,
          "partner":partner,
          "type":type,
          "mapping":mapping
         }
        vm.openConfirmation(data,ev)
      }
      else if(response.status == 404 && isCargowisePartner(partner)){
        data={
          "title":'Synchronisation Failed',
          "content":'Please verify the following:<ul><li><strong>User Profile:</strong> Ensure your user profile in Freightify has the correct Integration Details configured.</li><li><strong>Customer & Carrier:</strong> Confirm that both the carrier and customer\'s External Reference codes exist in CargoWise.</li><li><strong>Meta Details:</strong> Check that all other fields are correctly entered.</li></ul>',
          "addShipper":"addShipper",
          "newBooking":newBooking,
          "submenus":submenus,
          "new_org":true,
          "partner":partner,
          "type":type,
          "mapping":mapping
          
         }
        vm.openConfirmation(data,ev)
      }
     
      else{
        if(response.status == 500){
          $rootScope.$broadcast('getFeeds');
        }
        vm.responsestatusdata.push({
          responseFrom: "QUOTES",
          status: "FAILED",
          message:response.data.display_message ,
        });
        checkChargeMappingRes(partner, response,false);
        util.showToast(util.displayValidationError(response.data.message));
      }
        },function(error){
         vm.showloader = false;
         util.showToast(util.displayValidationError(error));
         $log.log(error);
     });
      }
      function cancelDialog(event){
        if(event && vm.showScreen != 3){
          showConfirmationModel(event);
        }else{
          $mdDialog.hide();
        }
      }
     
function openConfirmation(data,ev) {
  vm.data=data;
 $mdDialog.show({
   templateUrl: 'app/main/shipments/dialogs/confirm-shipper-creation/confirm-shipper-creation.html',
   targetEvent: ev,
   clickOutsideToClose: true,
   controllerAs: 'ctrl',
   controller: function () { this.parent = vm }
 });
}

function fnOpenChargeMapping(newBooking,ev,submenus,partner,type){
  vm.newBooking=newBooking;
  vm.ev=ev;
  vm.submenus=submenus;
  vm.partner=partner;
  vm.type=type;
  vm.showScreen = 1;
 
  util.chargeMapping(vm.shipmentmeta.shipment_id,partner).then(
    function(response){                   
    vm.showloader = false;
    vm.chargeMappingObj = response.data
    vm.copyMappingObj = angular.copy(vm.chargeMappingObj);
    vm.mappedCharges={};
    vm.unmappedCharges={}
    if(vm.chargeMappingObj)
    {
      vm.legMapping = {};
      if(vm.chargeMappingObj.agent && vm.chargeMappingObj.agent.isSpotCarrier){
        vm.agentList.push(vm.chargeMappingObj.agent);
      }
    vm.chargeMappingObj.is_nominated = !vm.chargeMappingObj.is_nominated ?  false :  vm.chargeMappingObj.is_nominated;
    if(isCargowisePartner(partner)){
      for (var key in vm.chargeMappingObj.chargeMap) {
        if (vm.chargeMappingObj.chargeMap.hasOwnProperty(key)) {  
          const charge = vm.chargeMappingObj.chargeMap[key];

          if(!vm.chargeMappingObj.chargeMap[key].partner.chargeName){
            vm.unmapped.push(key)
            vm.unmappedCharges[key]=charge
            
          }
          else{
            vm.mappedCharges[key]=charge
          }
        }
      }
      vm.showUnmappedCharge= vm.unmapped.length ? true : false;
      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/cargowise-charge-mapping/cargowise-charge-mapping.html",
          targetEvent: ev,
          clickOutsideToClose: false,
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
      });
    }else{
      $mdDialog.show({
        templateUrl:
          "app/main/shipments/dialogs/charge-mapping/charge-mapping.html",
          targetEvent: ev,
          clickOutsideToClose: false,
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
      });
    }
    
    }
    else{
      vm.responsestatusdata.push({
        responseFrom: "QUOTES",
        status: "FAILED",
        message:response.message ,
      });
    }
   },function(error){
    vm.showloader = false;
    vm.responsestatusdata.push({
      responseFrom: "QUOTES",
      status: "FAILED",
      message:response.message ,
    });
    util.showToast(util.displayValidationError(error));
    $log.log(error);
});



}

function getAgentList(query){
  
  return  util.getAgentsData(query).then(function(response){
      // util.agentList = response.data.data;
      // vm.agentList = util.agentList;
      return response.data.data;
    });
  
}

function fnChargeSelection(selectedCharge, key){
  vm.chargeMappingObj.chargeMap[key].partner=selectedCharge
}
function fnAgentSelection(selectedAgent, key){
  vm.chargeMappingObj.chargeMap[key].agent=selectedAgent
}

function getChargeList(searchText){
  return  util.getChargeMappingList(searchText,vm.shipmentmeta.mode,vm.shipmentmeta.carrier_info.sv_id,vm.chargeMappingObj.linerMappingId);
}

function removeValidation(key,type ){
  if(type=='agent'){
    var element = document.getElementById(key+"_agent");
    angular.element(element).removeClass("error-border");
    var code_element = document.getElementById(key+"_agent_code");
    angular.element(code_element).removeClass("error-border");

    // while changing the agent remove it's corresponding leg 
    vm.chargeMappingObj.chargeMap[key].serviceLeg = '';
   // prefilling the leg if already selected for this Agent
   if(vm.chargeMappingObj.chargeMap[key].agent && vm.chargeMappingObj.chargeMap[key].agent.reference_id){
        vm.chargeMappingObj.chargeMap[key].serviceLeg = vm.legMapping[vm.chargeMappingObj.chargeMap[key].agent.agent_name] ;
   }
  }else{
    var element = document.getElementById(key+"_partnerCharge");
    angular.element(element).removeClass("error-border-auto");
  }
}

function validateChargeMapping(){
  vm.error=0
  vm.updateChargeStatus();
  if(vm.error || vm.chargeMappingForm.$invalid){
     return
  }else{
    if(isCargowisePartner(vm.partner)){
      vm.fnCargowiseIntergration(vm.newBooking,vm.ev,vm.submenus,vm.new_org,vm.partner,vm.type,false);
    }else{
    fnNextScreen(1);
    vm.showScreen = 2;
    }
  }
}
function fnSubmitCharges(){
  vm.isNominatedIdEmpty = false;
  if(vm.chargeMappingObj.is_nominated && !vm.chargeMappingObj.nominated_id){
    util.showToast("Please enter FI ID");
    vm.isNominatedIdEmpty = true;
    return;
  }
  if(!vm.chargeMappingObj.paymentMethod){
    util.showToast("Please select payment type");
    return;
  }
  vm.fnCargowiseIntergration(vm.newBooking,vm.ev,vm.submenus,vm.new_org,vm.partner,vm.type,false);
}
 function updateChargeStatus(){
  var checkUnmappedValue =  isCargowisePartner(vm.partner) ?  !vm.chargeMappingObj.isUnmapped : true

  for (var key in vm.chargeMappingObj.chargeMap) {
    if(!vm.chargeMappingObj.chargeMap[key].partner.chargeName && checkUnmappedValue){
      var element = document.getElementById(key+"_partnerCharge");
      angular.element(element).addClass("error-border-auto");
      vm.unmapped.includes(key) ?  vm.isPanelOpened=true : vm.isMappedPanelOpened=true
    vm.error++
    return
    }
    if(vm.otmReference == vm.partner){
      if(!vm.chargeMappingObj.chargeMap[key].agent){
        var element = document.getElementById(key+"_agent");
        angular.element(element).addClass("error-border");
        vm.error++
        return
      }
      if(vm.chargeMappingObj.chargeMap[key].agent && !vm.chargeMappingObj.chargeMap[key].agent.reference_id){
        var element = document.getElementById(key+"_agent_code");
        angular.element(element).addClass("error-border");
        util.showToast("Service provider code is empty. Please select another service provider.");
        vm.error++
        return
      }
      if(!vm.chargeMappingObj.chargeMap[key].serviceLeg){
        var element = document.getElementById(key+"_leg_name");
        angular.element(element).addClass("error-border");
        vm.error++
        return
      }
    }
    
    if (vm.chargeMappingObj.chargeMap.hasOwnProperty(key) && vm.copyMappingObj.chargeMap.hasOwnProperty(key) ) {
      
     if(vm.copyMappingObj.chargeMap[key].partner.chargeName){
     if(angular.equals(vm.copyMappingObj.chargeMap[key].partner,vm.chargeMappingObj.chargeMap[key].partner)){
      vm.chargeMappingObj.chargeMap[key].status="UNCHANGED"
     }
     else{
      vm.chargeMappingObj.chargeMap[key].status="UPDATED"
     }
     }
    else{
      if(checkUnmappedValue){
      vm.chargeMappingObj.chargeMap[key].status="CREATED"
      }
      else{
        vm.chargeMappingObj.chargeMap[key].status=""
      }
     
    } 
    
    }
  }
 }
 function checkUnmapped(event){
  event.stopPropagation();
  


  for (var key in vm.chargeMappingObj.chargeMap) {
   vm.removeValidation(key,'_partnerCharge');
   
  
  }
 }
  function fnNextScreen(num) {
    var listElements = document.querySelectorAll("ul.stepper-bar li");
    listElements.forEach(function (item, index) {
      if (index + 1 == num) {
        item.classList.remove("active")
      }
      if (index + 1 == num + 1) {
        item.classList.add("active")
      }
    })
    if (num == 1) {
      vm.showScreen = 2;
    } else if (num == 2) {
      vm.showScreen = 3;
    }
  }

  function fnPrevScreen(num) {
    if (vm.showScreen == 2) {
      var listElements = document.querySelectorAll("ul.stepper-bar li");
      listElements.forEach(function (item, index) {
        if (index == num) {
          item.classList.remove("active")
        }
        if (index == num - 1) {
          item.classList.add("active")
        }
      })
      if (num == 1) {
        vm.showScreen = 1;
      }
    }
  }

  function checkChargeMappingRes(partner,response,isSuccess){
    if(vm.otmReference == partner || isCargowisePartner(partner)){
      // fnNextScreen(2);
      // vm.showScreen = 3;
      vm.chargeMappingErr = {
        responseFrom: "QUOTES",
        status: isSuccess ? "COMPLETED" : "FAILED",
        message:response.data.display_message ,
      }
    }
  }

  function fnNominatedChange(){
    // removing nominated_id if non-nominated selected
    vm.chargeMappingObj.nominated_id = !vm.chargeMappingObj.is_nominated ? null : vm.chargeMappingObj.nominated_id; 
  }

  function fnLegSelect(key , charge){
    var element = document.getElementById(key+"_leg_name");
    angular.element(element).removeClass("error-border");
    vm.legMapping[charge.agent.agent_name] = charge.serviceLeg
    for (var key in vm.chargeMappingObj.chargeMap) {
      //prefilling the leg by comparing the agent's id
      if(charge.agent.reference_id == vm.chargeMappingObj.chargeMap[key].agent.reference_id){
        vm.chargeMappingObj.chargeMap[key].serviceLeg = charge.serviceLeg;
      }
    }

  }

  function showConfirmationModel(ev) {
    var position = vm._mdPanel
      .newPanelPosition()
      .absolute()
      .center();
    var config = {
      templateUrl: "app/main/component/warning-panel/warning-panel.html",
      controllerAs: "ctrl",
      controller:"warningPanelController",
      position: position,
      openFrom: ev,
      trapFocus: true,
      clickOutsideToClose: false,
      escapeToClose: true,
      focusOnOpen: false,
      zIndex: 1501,
    };
    vm._mdPanel.open(config);
}
function panelExpansion() {
  vm.isPanelOpened = !vm.isPanelOpened;
}
function panelMappedExpansion() {
  vm.isMappedPanelOpened = !vm.isMappedPanelOpened;
}

  vm.isEmpty = isEmpty;
  function isEmpty(obj) {
    return !obj || Object.keys(obj).length === 0;
  };


  }
 

})();

(function () {
    "use strict";
    angular
    .module('app.core')
    .controller('statusChangePanelController', statusChangePanelController);
   
    function statusChangePanelController(mdPanelRef, util,$rootScope, $scope, analytics) {

       //  variables
        var vm = this;
        vm._mdPanelRef = mdPanelRef;
        vm.util=util;
        vm.isShared = false;
        // methods
        // vm.getStatusColor = getStatusColor;
        vm.fnChangeStatus = fnChangeStatus;
        vm.closePanel = closePanel;



        this.$onInit = function () {
            // blocking the selection for share quote - quote details
            vm.isShared =  util.isSharedQuote() ;
          
        }

        function fnChangeStatus(statusObj){
            vm.selectedStatus = statusObj
            closePanel();
            
        }

        function closePanel() {
            vm._mdPanelRef && vm._mdPanelRef.close();
          }
        
    }


})();

(function () {
  'use strict';

  angular
  .module('app.core')
  .component('shareQuotation', {
      templateUrl: 'app/main/component/share-quotation/share-quotation.html',
      bindings : {
          sharequoteobj : '=',
          isduplicatequote:'=',
          callback : '&',
      },
      controller: ShareQuotationController
  });


  function ShareQuotationController(util, SearchService,$mdDialog, analytics, $rootScope, $filter, localStorageService, resultService, shareQuoteService, $state,api,$window, $q) {
      var vm = this;
      vm.util = util;
      vm.fnGotoFirstScreen = fnGotoFirstScreen;
      vm.fnPrevScreen = fnPrevScreen;
      // vm.fnSendQuotationAgain = fnSendQuotationAgain;
      vm.fnDefaultTermsAndConditions = fnDefaultTermsAndConditions;
      vm.terms_condition_focus = terms_condition_focus;
      vm.terms_condition_key_up = terms_condition_key_up;
      vm.fnSendQuotation = fnSendQuotation;
      vm.fnNextScreen = fnNextScreen;
      vm.closeShareDialog = closeShareDialog;
      vm.cancelDialog = cancelDialog;
      vm.selectedToChange = selectedToChange;
      vm.getSalesPersonList = getSalesPersonList;
      vm.closeDialog = closeDialog;
      vm.isGeneratePDF = isGeneratePDF;
      vm.fnMultiEmailValidation= fnMultiEmailValidation;
      vm.filterStringList = filterStringList;
      vm.wlsGetCustomerList = wlsGetCustomerList;
      vm.getShipperCompany = getShipperCompany;
      vm.changeCompany = changeCompany;
      vm.changeEmailText = changeEmailText;
      vm.resetSendQuote = resetSendQuote;
      vm.fnCustomerDetailsSave = fnCustomerDetailsSave;
      vm.previewQuotes = previewQuotes;
      vm.trackEvent=trackEvent;
      vm.currentState = $state.current.name;
      vm.incotermsWarning = false;
      vm.linerMask = $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER;
      vm.linerMaskCheckBox = vm.linerMask && $rootScope.domainData.domain_info.MASKING_CHECK_BOX.is_masked;
      vm.isCommodity = $rootScope.domainData.domain_info.QUOTE_POPUP_SETTING ? $rootScope.domainData.domain_info.QUOTE_POPUP_SETTING.SHOW_COMMODITY : false;
      vm.commodityValue=[];
      vm.termsConditionCkEditorConfig = angular.copy(util.ckEditorConfig);
      vm.termsConditionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
      vm.user = {
          "email": null,
          "user_mobile": null,
          "user_first_name": null,
          "user_last_name": null,
          "id" : null
      };

      vm.company = {
          "company_name": null,
          "id": null
      };
      vm.salesPersonList = [];
      vm.cust_min_length = 3;
      vm.shareQuoteData = null;
      vm.previewUrl = "";
      vm.showScreen = 1;
      vm.showTermsConditions = false;
      vm.mixpanel_subVendor = [];
      vm.selected_vendorName = [];
      vm.fnCheckShipper = fnCheckShipper;
      vm.getExpiryMaxDate = getExpiryMaxDate;
      vm.validateExpirydate = validateExpirydate;
      vm.searchTextChange = searchTextChange;
      vm.downloadPdf = downloadPdf;
      vm.fnGetPdfLink = fnGetPdfLink;
      vm.fnChangeQuoteType = fnChangeQuoteType;
      this.$onInit = function() {
        vm.validationObj={
          "salesValidation":false,
         "companyValidation":false,
          "emailValidation":false, 
          "emailPatternValidation":false,
          "firstNameValidation":false,
          "lastNameValidation":false,
          "incotermsError" : false,
          "startDateValidation" :false,
          "expiryDateValidation":false,
          "showDateNote":false
        };
          vm.isIncotermsRequired = $rootScope.domainData.domain_info["INCO_TERM_MANDATORY"];
          vm.enable_zero_sell_rates_on_pdf_checkbox = $rootScope.domainData.domain_info["ENABLE_ZERO_SELL_RATES_ON_PDF_CHECKBOX"];
          vm.quoteDetails = vm.sharequoteobj.quoteDetails;
          vm.quoteDetails.carrier_mask_for_shipper = vm.linerMask && $rootScope.domainData.domain_info.MASKING_CHECK_BOX.checked_state;          
          //  Disable "Print charges with “Zero” in PDF" option if quote generated with allin total/legwise total 
          vm.disable_zero_sell_rates_on_pdf_checkbox = vm.quoteDetails.all_in_quote_setting &&( vm.quoteDetails.all_in_quote_setting == 'legwise_total' ||  vm.quoteDetails.all_in_quote_setting == 'all_in_total');
          vm.termsAndConditions = vm.sharequoteobj.termsAndConditions;
          vm.stdTermsAndConditions = vm.sharequoteobj.stdTermsAndConditions;
          vm.selectedCard = vm.sharequoteobj.selectedCard;
          vm.search_param = vm.sharequoteobj.search_param;
          vm.generateQuoteBtn = vm.sharequoteobj.generateQuoteBtn;
          vm.currency_conversion_rates = vm.sharequoteobj.currency_conversion_rates;
          vm.fclLoadData = vm.sharequoteobj.fclLoadData;
          vm.result_id = vm.sharequoteobj.result_id;
          vm.inquiry_id = vm.sharequoteobj.inquiry_id;
          vm.sales_user = vm.sharequoteobj.sales_user;
          vm.shipper_user = vm.sharequoteobj.shipper_user;
          vm.erp_data = vm.sharequoteobj.erp_data;
          vm.vas_details = vm.sharequoteobj.vas_details;
          vm.is_duplicate_quote=vm.sharequoteobj.is_duplicate_quote;
          vm.parent_quote_id=vm.sharequoteobj.parent_quote_id
          vm.copy_quote_id=vm.sharequoteobj.copy_quote_id;
           vm.l3_leg = (vm.search_param.mode == 'SEA-FCL') ? 'l3_fcl' : (vm.search_param.mode == 'AIR' ? 'l3_air' : 'l3_lcl' );

          vm.salesPersonType = util.userProfile.user.is_sales_cordinator ? 'SALES_COORDINATOR' : (!util.isShipper ? 'SALES_USER' : 'SHIPPER_USER' );

          vm.expiryDateEnd = util.dateReplace(shareQuoteService.fnValidateExpiryDate(vm.selectedCard,vm.search_param.cargo_ready_date, vm.l3_leg));
          vm.quoteDetails.expiry_date = vm.expiryDateEnd;
          vm.getExpiryMaxDate(vm.quoteDetails.start_date);

          if(vm.search_param.mode == 'AIR'){
              var selectedAirlineList = [];
              angular.forEach(vm.selectedCard,function(value, key){
              selectedAirlineList.push(value.data.sell_rates.l3_air.rate_obj.airline);
              });

              vm.mixpanel_subVendor = shareQuoteService.getAirlineName(selectedAirlineList);
          }else{
              vm.mixpanel_subVendor = shareQuoteService.getSelectedCardSubvendor(vm.selectedCard, 'liner');
          }

          vm.selected_vendorName = shareQuoteService.getSelectedCardSubvendor(vm.selectedCard, 'vendor');
          if(util.solution_type === 'WLS'){
              vm.cust_min_length =  0;
              vm.salesPerson = {};
              if( vm.sales_user ){
                vm.salesPerson  =  vm.sales_user;
                vm.fnCheckShipper();
              }else if(!util.isShipper){
                vm.salesPerson  = vm.search_param.user;
                
                if(vm.is_duplicate_quote){
                  vm.getSalesPersonList('');
                }else{
                  vm.fnCheckShipper();
                  vm.wlsGetCustomerList();
                  vm.getSalesPersonList('','init');
                }
              }
              
          }
         vm.allInQuoteOptions = $rootScope.domainData.domain_info.QUOTE_OPTIONS;
         vm.quote_pdf_languages = $rootScope.domainData.domain_info.QUOTE_PDF_LANGUAGES;
      }

      function fnCheckShipper(){
          if(vm.shipper_user && vm.shipper_user.email ){
              vm.selectedToChange(vm.shipper_user);
              vm.disableCustomerEmail = true;
              vm.disableCustomerCompany = true;
          }else if(vm.shipper_user && vm.shipper_user.company){
              vm.disableCustomerCompany = true;
              vm.wlsGetCustomerList().then(function (response) {
                  vm.selectedToChange(vm.shipper_user.company,'company');
              }, function (error) {
                  $log.log(error.data);
              });
          }else if(!vm.shipper_user){
              vm.wlsGetCustomerList();
          }
      }

      // get customer list for wls
      function wlsGetCustomerList(){
          if(vm.salesPerson.id){
              vm.selectList = [];
              vm.selectListShow = true;
              if(vm.salesPersonType != 'SALES_USER'){
                vm.user.email = null;
                vm.company.id = null;
                vm.company.company_name = null;
                vm.selectedToChange(null);
              }

              var url = api.baseUrl + '/api/get-shippers?limit=30&offset=0&salesperson_id=' +vm.salesPerson.id;
              return SearchService.getShipperList(url).then(function (response) {
                  vm.selectList = response.data.data;
                  vm.selectListShow = false;
                  if(vm.currentState === 'app.inquiry.inquiryDetails'){
                      vm.selectedToChange(vm.shipper_user);
                  }
                  return vm.selectList;
              }, function (error) {
                  $log.log(error.data);
                  return [];
              });
          }else{
              return [];
          }
      }

      // function to get sales person list
      function getSalesPersonList(searchText,init){
          vm.isSalesApiLoading = true;
          return resultService.getSalesPersonList(util.userProfile.user.id,searchText).then(function (response) {
            vm.salesPersonsCount = response.data.count;
            if(response.data.data.length && init){ //check if sales users list is blank or not
                vm.salesPerson = response.data.data[0];
            }
            vm.salesPersonList = angular.copy(response.data.data);
            var results = vm.salesPersonList.find(function(item){
                return  ( vm.salesPerson.id === item.id );
            });
            if(!results && !init){
              vm.salesPersonList.push(vm.salesPerson);
            }else{
              vm.salesPerson = results;
            }
            vm.wlsGetCustomerList();
            vm.isSalesApiLoading = false;
          }, function (error) {
            vm.isSalesApiLoading = false;
            vm.salesPersonList = [];
            vm.salesPersonsCount = 0;
            $log.log(error.data);
        });
      }

      function selectedToChange(selected,input_type) {
          if (selected != null) {

            if(input_type == 'company'){
                // SearchService.wlsFilterCustomerDetails('' , 'company_user', vm.selectList,vm.company );
                if(selected.company){
                  vm.company.id = selected.company.id;
                  vm.company.company_name = selected.company.company_name;
                  vm.company.company_address = selected.company.company_address;
                }else{
                  vm.company.id = selected.id;
                  vm.company.company_name = selected.company_name;
                  vm.company.company_address = selected.company_address;
                }
            }
            else{
                vm.user.id = selected.id;
                vm.user.email = selected.email;
                vm.user.user_first_name = selected.user_first_name;
                vm.user.user_last_name = selected.user_last_name;
                vm.user.user_mobile = selected.user_mobile;
                // vm.user.user_address = selected.user_address;
                vm.company.id = selected.company.id;
                vm.company.company_name = selected.company.company_name;
                vm.company.company_address = selected.company.company_address;
            }
            vm.readOnly = true;
          }
          else if (selected == null) {

            if(input_type == 'company'){
              vm.company.id = null;
              vm.company.company_address = null;
              // vm.user.email = null;
            }
            else{
              vm.user.id = null;
              vm.user.user_first_name = null;
              vm.user.user_last_name = null;
              vm.user.user_mobile = null;
              // vm.user.user_address = null;
            }
            vm.readOnly = false;
          }
      }

      function searchTextChange(selected,input_type){
        if(selected == null) {
          if(input_type == 'company'){
            vm.company.id = null;
            vm.company.company_address = null;
          }else{
            vm.user.id = null;
            vm.user.user_first_name = null;
            vm.user.user_last_name = null;
            vm.user.user_mobile = null;
            // vm.user.user_address = null;
          // vm.user.email = null;
          }

        }
      }

      function filterStringList(userInput) {
       
            vm.selectList = [];
            var url = api.baseUrl + '/api/get-shippers?limit=30&offset=0';

            if(userInput){
              url += '&query=' +userInput;
            }

            if(vm.salesPerson && vm.salesPerson.id){
              url += '&salesperson_id=' +vm.salesPerson.id;
            }
            if(vm.company && vm.company.id){
              url += '&user_company_id=' +vm.company.id;
            }

            return SearchService.getShipperList(url).then(function (response) {
              vm.selectList = response.data.data;
              return vm.selectList;
            }, function (error) {
              $log.log(error.data);
              return [];
            });

          // if(util.solution_type !== 'WLS'){
          //   vm.selectList = [];
          //   var url = api.baseUrl + '/api/get-shippers?limit=30&offset=0&email=' + userInput;
          //   return SearchService.getShipperList(url).then(function (response) {
          //     vm.selectList = response.data.data;
          //     return vm.selectList;
          //   }, function (error) {
          //     $log.log(error.data);
          //     return [];
          //   });
          // }else{
          //   var results;

            // if(!!vm.company.company_name){
            //     results  = SearchService.wlsFilterCustomerDetails(userInput, 'company_user', vm.selectList, vm.company);
            // }else{
            //     results  = SearchService.wlsFilterCustomerDetails(userInput, '', vm.selectList, vm.company);
            // }

          //   var  deferred = $q.defer();
          //   $timeout(function () { deferred.resolve( results ); },  200, false);
          //   return deferred.promise;
          // }

      }

      function getShipperCompany(company_name) {
          var url = api.baseUrl + '/api/get-shipper-companies?limit=30&offset=0';
          if(company_name) {
            url += '&name=' + company_name;
          }
          if(vm.salesPerson && vm.salesPerson.id){
            url += '&salesperson_id=' +vm.salesPerson.id;
          }
          return SearchService.getShipperList(url).then(function (response) {
            vm.selectCompanyList = response.data.data;
            return vm.selectCompanyList;
          }, function (error) {
            $log.log(error.data);
            return [];
          });
          // if(util.solution_type !== 'WLS'){
          //   var url = api.baseUrl + '/api/get-shipper-companies?limit=30&offset=0&name=' + company_name;
          //   return SearchService.getShipperList(url).then(function (response) {
          //     vm.selectCompanyList = response.data.data;
          //     return vm.selectCompanyList;
          //   }, function (error) {
          //     $log.log(error.data);
          //     return [];
          //   });
          // }else{
          //   var results = SearchService.wlsFilterCustomerDetails(company_name,"company", vm.selectList, vm.company);

          //   var  deferred = $q.defer();
          //   $timeout(function () { deferred.resolve( results ); },  200, false);
          //   return deferred.promise;
          // }
      }

      function changeCompany(selected) {
          if (selected != null) {
            vm.company.id = selected.id;
            vm.company.company_name = selected.company_name;
            vm.company.company_address = selected.company_address;
          }
          else if (selected == null) {
            vm.company.id = null;
            vm.company.company_address = null;
          }
      }

      function changeEmailText() {
          vm.readOnly = false;
      }

      //share quote user info reset
      function resetSendQuote() {
          vm.quoteSent = false;
          vm.user = {
          "email": null,
          "user_mobile": null,
          "user_first_name": null,
          "user_last_name": null,
          "id": null
          };

          vm.company = {
          "company_name": null,
          "id": null
          };
      }

      function fnDefaultTermsAndConditions() {
          if (!vm.showTermsConditions) {
            vm.quoteDetails.terms = util.decodeValue(vm.stdTermsAndConditions);
          } else {
            vm.quoteDetails.terms = util.decodeValue(vm.termsAndConditions);
          }
      }

      function fnGotoFirstScreen() {
          vm.shareQuoteBtn = false;
          vm.fnPrevScreen(1);
      }

      function fnPrevScreen(num) {
          if (vm.showScreen == 2) {
            var listElements = document.querySelectorAll("ul.stepper-bar li");
            listElements.forEach(function (item, index) {
              if (index == num) {
                item.classList.remove("active")
              }
              if (index == num - 1) {
                item.classList.add("active")
              }
            })
            if (num == 1) {
              vm.showScreen = 1;
            }
          }
      }

      //this function responds to Quote Details
      function fnSendQuotation(form) {
        
        if(!vm.quoteDetails.start_date){
          vm.validationObj.startDateValidation=true;
        }
        if(!vm.quoteDetails.expiry_date){
          vm.validationObj.expiryDateValidation=true
        }
          if(vm.isIncotermsRequired && !vm.quoteDetails.incoterms){
              vm.validationObj.incotermsError = true;
          }
          if(vm.validationObj.startDateValidation || vm.validationObj.expiryDateValidation ||  vm.validationObj.incotermsError  || form.$invalid){
            return
          }
          
          var tempStart = new Date(vm.quoteDetails.start_date);
          tempStart.setHours('00');
          tempStart.setMinutes('01');
          vm.fnNextScreen(1);
          vm.invalidEmail = false;
      }

      function fnNextScreen(num) {
          var listElements = document.querySelectorAll("ul.stepper-bar li");
          listElements.forEach(function (item, index) {
            if (index + 1 == num) {
              item.classList.remove("active")
            }
            if (index + 1 == num + 1) {
              item.classList.add("active")
            }
          })
          if (num == 1) {
            vm.showScreen = 2;
          } else if (num == 2) {
            vm.showScreen = 3;
          }
      }

      function terms_condition_focus(className){
          if(document.getElementById(className).value === ''){
              document.getElementById(className).value +='• ';
          }
      }

      function terms_condition_key_up(event,className){
        util.getBulletPontOnInput(event,className);
      }

      function isGeneratePDF(isSelect){
          if(!isSelect){
            vm.quoteDetails.print_schedule = false;
          }
      }

      // function to validate email in chips
      function fnMultiEmailValidation(emails, userInput) {
        util.validateEmail(emails, userInput);
        if(util.invalidEmail) {
          $('.quote-invalidErrorMsg').show().delay(1000).fadeOut();
        }
        if(util.duplicateEmail) {
          $('.quote-duplicateErrorMsg').show().delay(1000).fadeOut();
        }
      }

      // close dialog function
      function cancelDialog(action) {

          if (vm.showScreen == 3) {
              vm.closeShareDialog(action);
          }
          vm.previewUrl = "";
          vm.quoteDetails = {};
          vm.showScreen = 1;
          vm.showTermsConditions = false;
          $mdDialog.hide();
      }

      function closeDialog() {
          return $mdDialog.hide();
      }

      function closeShareDialog(action) {
          vm.closeDialog().then(function() {

          if(action == 'quote') {
              util.showToast(util.displayValidationError('Redirecting to generated quote page.'));
              $state.go('app.quotes.quotesDetails', { id: vm.shareQuoteResponse._id });
          }else if(action == 'inquiry') {
              if(vm.currentState == 'app.inquiry.inquiryDetails'){
                  $state.reload();
              }else{
                  util.showToast(util.displayValidationError('Redirecting to inquiry detail page.'));
                  $state.go('app.inquiry.inquiryDetails', { id: vm.shareQuoteResponse.inquiry_id });
              }
          }

          if(vm.search_param.mode == 'SEA-FCL'){
              SearchService.FclResult = {};
          }else if(vm.search_param.mode == 'AIR'){
              SearchService.AirResult = {};
          }else if(vm.search_param.mode == 'SEA-LCL'){
              SearchService.LclResult = {};
          }
          });
      }

      // quote store in localStorage
      function previewQuotes() {
          if ($window.open('','previewLink') != null) {
              $window.open('','previewLink').close();
          }
          if (vm.previewUrl == "") {
              vm.previewUrl = $state.href("app.preview");
              event.preventDefault();
          }

          var cards = angular.copy(vm.selectedCard);
          angular.forEach(cards, function (card) {
              card.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = card.meta.selected_schedule ? [card.meta.selected_schedule] : card.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;
              card.data.sell_rates[vm.l3_leg].rate_obj.schedule.data = card.meta.selected_schedule ? [card.meta.selected_schedule] : card.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;
              card.meta.card_total_cost = resultService.calCardTotal(card.data.sell_rates);
              delete card.data.buy_rates[vm.l3_leg]["rate_obj_1"];
              delete card.data.buy_rates[vm.l3_leg]["rate_obj_2"];
              delete card.data.sell_rates[vm.l3_leg]["rate_obj_1"];
              delete card.data.sell_rates[vm.l3_leg]["rate_obj_2"];
              delete card.meta["slabPersentage"];
              delete card.meta["selectedLeg"];
          });

          var previewViewData = {
              "result_meta": {
                  "search_param": vm.search_param
              },
              "result_data": {
                  "cards": cards,
                  "currency_conversion_rates": vm.currency_conversion_rates,
                  "created_by": util.solution_type === 'WLS' ? vm.salesPerson : vm.search_param.user,
                  "created_for": vm.user,
                  "sales_coordinator" : util.userProfile.user.is_sales_cordinator == 1 ? util.userProfile.user : null,
                  "expiry_date" : vm.quoteDetails.expiry_date,
                  "start_date" : vm.quoteDetails.start_date,
                  "quote_id" : 'N/A',
                  "created_on" : moment.utc(new Date()).format(),
                  "incoterms" : vm.quoteDetails.incoterms,
                  "pdf_preferred_language": vm.quoteDetails.pdf_preferred_language || "en",
                  "impo_expo" : vm.quoteDetails.impo_expo,
                  "terms": vm.quoteDetails.terms,
                  "customs" : vm.quoteDetails.customs,
                  "hazardous" : vm.quoteDetails.hazardous,
                  "perishable" : vm.quoteDetails.perishable,
                  "exchangeRateId": vm.sharequoteobj.exchangeRateId,
                  "quoteFrom": vm.sharequoteobj.quoteFrom,
                  "activityId": vm.sharequoteobj.activityId,
                  "commodity_data": shareQuoteService.commodityString(vm.commodityValue)
              }
          }
          if(util.solution_type === 'WLS'){
            previewViewData.result_data.created_by.user_base_currency = vm.search_param.user.user_base_currency;
          }
          sessionStorage.setItem('preview_cards', JSON.stringify(previewViewData));         
          //opens quote preview in new window
          var a = $window.open(util.sanitizeQueryParams(vm.previewUrl),'previewLink');
          if(a) {
            a.focus();
          }
      }

      //this function responds to Customer Details form
      function fnCustomerDetailsSave(form) {
         var mixPanelvalidationObj = {
             salesPerson : '',
             companyName : '',
             customerEmail : '',
             firstName : '',
             lastName : ''
         };
          var data = angular.copy(vm.quoteDetails);
          if(util.solution_type === 'WLS' && !vm.salesPerson){
            vm.validationObj.salesValidation=true;
            mixPanelvalidationObj.salesPerson = "required";
          }
          if(!vm.company.company_name){
              vm.validationObj.companyValidation=true;
              mixPanelvalidationObj.companyName = "required";
          }
          if(!vm.user.email){
            vm.validationObj.emailValidation=true;
            mixPanelvalidationObj.customerEmail = "required";
          }
          if(!vm.user.user_first_name){
            vm.validationObj.firstNameValidation=true;
            mixPanelvalidationObj.firstName = "required"
          }
          if(!vm.user.user_last_name){
            vm.validationObj.lastNameValidation=true;
            mixPanelvalidationObj.lastName = "required";
          }
         
          var PhonePattern = /^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[789]\d{9}|(\d[ -]?){10}\d$/;
          if (!vm.util.emailRegex.test(String(vm.user.email).toLowerCase())) {
            vm.validationObj.emailPatternValidation=true;
          }

          if(vm.validationObj.salesValidation || vm.validationObj.companyValidation || vm.validationObj.emailValidation ||  vm.validationObj.firstNameValidation || vm.validationObj.lastNameValidation || vm.validationObj.emailPatternValidation){
            return ;
          }
       

          if(util.solution_type === 'WLS' && vm.salesPersonType=='SALES_COORDINATOR' && !vm.sales_user && vm.currentState !== 'app.inquiry.inquiryDetails'){
              if(form.searchSalesPerson.$error.required){
                  return true;
              }
          }


          if( form.PhoneNumber.$invalid ){
              document.querySelector('#customer_phone_number').focus();
              vm.phoneValidation = true;
              return true;
          }

          vm.user.user_first_name = vm.user.user_first_name;
          vm.user.user_last_name = vm.user.user_last_name;
          vm.company.company_name = vm.company.company_name;

          var user = {};
          var company = {};
          var cards = [];
          var currency_conversion_rates = [];
          var vendor_0_obj = null;

          var getCurrUserRate = vm.currency_conversion_rates.find(function(element) {
            if( element.vendor_id == 0){
                vendor_0_obj = element;
            }
            return ( element.vendor_id == parseInt(localStorageService.get('authToken').value.vendor_id) );
          });

          if(getCurrUserRate){
              currency_conversion_rates.push(getCurrUserRate);
          }
          if(vendor_0_obj){
              currency_conversion_rates.push(vendor_0_obj);
          }

          var search_data = angular.copy(vm.search_param);
          // search_data.inco_term = vm.quoteDetails.incoterms ? vm.quoteDetails.incoterms : null;
          // search_data.impo_expo = vm.quoteDetails.impo_expo ? vm.quoteDetails.impo_expo : null;
          search_data.hazardous_material = vm.quoteDetails.hazardous;
          search_data.customs = vm.quoteDetails.customs;
          if(search_data['nearby_origin'] && search_data['nearby_origin'].length &&  vm.mode != 'AIR'){
 
            search_data.user_nearby_origin=search_data.user_nearby_origin.concat(search_data['nearby_origin'])
            delete search_data['nearby_origin']
            
          }
          if(search_data['nearby_destination'] && search_data['nearby_destination'].length &&  vm.mode != 'AIR'){
            search_data.user_nearby_destination=search_data.user_nearby_destination.concat(search_data['nearby_destination'])
            delete search_data['nearby_destination']
          }
          

          cards = angular.copy(vm.selectedCard);

          angular.forEach(cards, function (card) {
              // delete card._id;
              delete card.meta.buy_leg_total;
              delete card.meta.view;
              delete card.meta["status"];
              delete card.meta["slabPersentage"];
              delete card.meta["selectedLeg"];
              delete card.meta["init_sort_total"];
              delete card.data.buy_rates[vm.l3_leg]["rate_obj_1"];
              delete card.data.buy_rates[vm.l3_leg]["rate_obj_2"];
              delete card.data.sell_rates[vm.l3_leg]["rate_obj_1"];
              delete card.data.sell_rates[vm.l3_leg]["rate_obj_2"];
              card.meta.card_total_cost = resultService.calCardTotal(card.data.sell_rates);

              var getCurrencyRate = vm.currency_conversion_rates.find(function(element) {
                  return ( element.vendor_id == card.meta.vendor_id );
              });

              if(getCurrencyRate){
                  currency_conversion_rates.push(getCurrencyRate);
              }

              angular.forEach(card.data.sell_rates, function (sellValue, sellKey) {
                  if(sellValue.rate_obj){
                      delete sellValue.rate_obj._id;

                      angular.forEach(sellValue.rate_obj.load_stat, function (loadValue, loadKey) {
                        if(sellValue.rate_obj.charges.length){
                          var result = sellValue.rate_obj.charges.some(function (entry) { return loadKey == entry.container_type; });
                          if (result) {
                              sellValue.rate_obj.load_stat[loadKey] = 1;
                              card.data.buy_rates[sellKey].rate_obj.load_stat[loadKey] = 1;
                          } else {
                              sellValue.rate_obj.load_stat[loadKey] = 0;
                              card.data.buy_rates[sellKey].rate_obj.load_stat[loadKey] = 0;
                          }
                        }
                      })
                  }else{
                      delete card.data.sell_rates[sellKey];
                      delete card.data.buy_rates[sellKey];
                  }
              });
          });

          user["email"] = vm.user.email;
          user["user_mobile"] = vm.user.user_mobile;
          user["user_mobile_code"] = vm.user.user_mobile_code;
          user["user_mobile_country"] = vm.user.user_mobile_country;
          user["user_first_name"] = vm.user.user_first_name;
          user["user_last_name"] = vm.user.user_last_name;
          company["company_address"] = vm.company.company_address;
          company["company_name"] = vm.company.company_name;

          if(vm.user.id){
            user["id"] = vm.user.id;
          }

          if (vm.company.id) {
            company["id"] = vm.company.id;
          }

          // var quoteExpire = new Date(vm.quoteDetails.expiry_date);
          // quoteExpire.setHours('23');
          // quoteExpire.setMinutes('59');
          var quoteExpire = moment(vm.quoteDetails.expiry_date).format('YYYY-MM-DD');  // remove Z from expiry date

          vm.quoteDetails.expiry_date = quoteExpire;

          // var quoteStart = new Date(vm.quoteDetails.start_date);
          // quoteStart.setHours('00');
          // quoteStart.setMinutes('00');
          var quoteStart = moment(vm.quoteDetails.start_date).format('YYYY-MM-DD');  // remove Z from expiry date

          vm.quoteDetails.start_date = quoteStart;

          vm.shareQuoteBtn = true;

          var data = {
              "data": {
                  "sales_user": util.solution_type === 'WLS' ? vm.salesPerson : util.userProfile.user,
                  "user": user,
                  "company": company,
                  "cards": cards,
                  "currency_conversion_rates": currency_conversion_rates,
                  "search_param": search_data,
                  "search_id": vm.result_id,
                  "start_date": vm.quoteDetails.start_date,
                  "expiry_date": vm.quoteDetails.expiry_date,
                  "customs": vm.quoteDetails.customs,
                  "perishable": vm.quoteDetails.perishable,
                  "cc_emails" : vm.quoteDetails.cc_emails,
                  "hazardous": vm.quoteDetails.hazardous,
                  "send_mail": vm.quoteDetails.send_mail,
                  "co2e" : vm.quoteDetails.co2e,
                  "generate_pdf": vm.quoteDetails.generate_pdf,
                  "print_schedule" : vm.quoteDetails.print_schedule,
                  "show_zero_sell_rates" : vm.quoteDetails.show_zero_sell_rates,
                  "carrier_mask_for_shipper": vm.quoteDetails.carrier_mask_for_shipper,
                  "incoterms": vm.quoteDetails.incoterms ? vm.quoteDetails.incoterms : null,
                  "pdf_preferred_language": vm.quoteDetails.pdf_preferred_language || "en",
                  "impo_expo": vm.quoteDetails.impo_expo ? vm.quoteDetails.impo_expo : null,
                  "terms": util.encodeValue(vm.quoteDetails.terms),
                  "all_in_quote_setting": vm.quoteDetails.all_in_quote_setting,
                  "generate_quote_type": vm.quoteDetails.generate_quote_type,
                  "is_duplicate_quote":vm.is_duplicate_quote?vm.is_duplicate_quote:false,
                  "parent_quote_id":vm.parent_quote_id?vm.parent_quote_id:null,
                  "activity" : [
                      {
                      "message": 'Quotation created' + (vm.is_duplicate_quote ?( ' - ' + vm.copy_quote_id ):'') ,
                      "type": "quote_created",
                      "timestamp": new Date(),
                      "user_id": util.userProfile.user.id,
                      "user_name": util.userProfile.user.user_first_name + ' '+ util.userProfile.user.user_last_name,
                      "activity_data": {}
                      }
                  ],
                  "additional_charges" : {
                      "selected" : vm.vas_details ? vm.vas_details.legList : [],
                      "available" : vm.vas_details ? vm.vas_details.value_added_charges : []
                  },
                  is_manual:false
                  
              }
          }

          if(vm.isCommodity){
            data.data['commodity_data'] = shareQuoteService.commodityString(vm.commodityValue);
          }
          
          vm.buyOrCard_total = 'buy_leg_total';
          if(vm.currentState === 'app.inquiry.inquiryDetails'){
              data.data["erp_data"] = ( vm.erp_data) ?  vm.erp_data : null;
              data.data["inquiry_id"] = vm.inquiry_id;
              vm.buyOrCard_total = 'card_total_cost';
          }

          vm.selectedCard.sort(function(a, b) {
              return b.meta[vm.buyOrCard_total] - a.meta[vm.buyOrCard_total];
          })

          util.isCallingApi = true;
          resultService.quoteCreation(data, vm.search_param.id).then(function (response) {
              vm.shareQuoteResponse = response.data;
              var mixpanlGenerateQuote = {
                  "Mode":vm.search_param.mode,
                  "Search Name":vm.search_param.search_name,
                  "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
                  "Origin Port":vm.search_param.origin_location.portcode_portname,
                  "Destination Port":vm.search_param.destination_location.portcode_portname,
                  "Highest rate" : vm.selectedCard[0].meta[vm.buyOrCard_total],
                  "Lowest rate" : vm.selectedCard[vm.selectedCard.length-1].meta[vm.buyOrCard_total],
                  "Currency" : vm.search_param.user.user_base_currency,
                  "Rates by" : vm.selected_vendorName,
                  "Customer Email":vm.user.email,
                  "Customer First Name":vm.user.user_first_name,
                  "Customer Last Name":vm.user.user_last_name,
                  "Customer Contact Number": vm.user.user_mobile,
                  "Company Name":vm.company.company_name,
                  "Carrier List" : vm.mixpanel_subVendor,
                  "No. of rate card":vm.selectedCard.length,
                  "Incoterms":vm.quoteDetails.incoterms,
                  "Pdf Preffered Language":vm.quoteDetails.pdf_preferred_language || 'en',
                  "Item Perishable" :vm.quoteDetails.perishable,
                  "Item Hazardous":vm.quoteDetails.hazardous,
                  "Include Customs":vm.quoteDetails.customs,
                  "Quote Type" : vm.quoteDetails.all_in_quote_setting
                  // "Pdf link":vm.previewUrl,
                  // "Quote ID":vm.quoteId,
              }

              if(vm.search_param.mode == 'SEA-FCL'){
                  var numOfFreightbroCards = 0;
                  for(var i=0; i< vm.selected_vendorName.length;i++){
                      if(vm.selected_vendorName[i] === "FreightBro")
                      numOfFreightbroCards++;
                  }

                  mixpanlGenerateQuote["Search Param"] = vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location + ' / ' + $filter('date')(vm.search_param.cargo_ready_date, 'd MMM yyyy')+ ' / ' + vm.fclLoadData.loadtype;
                  mixpanlGenerateQuote["Load Details"] = vm.fclLoadData.loadtype;
                  mixpanlGenerateQuote["Load In TEUs"] = vm.fclLoadData.typexqty;
                  mixpanlGenerateQuote["No. of Freightbro Rates"] = numOfFreightbroCards;
                  mixpanlGenerateQuote["Highest rate by"] = vm.selectedCard[0].data.buy_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name;
                  mixpanlGenerateQuote["Lowest rate by"] = vm.selectedCard[vm.selectedCard.length-1].data.buy_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name;
              }else{
                  mixpanlGenerateQuote["Search Param"] = vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location + ' / ' + $filter('date')(vm.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' +vm.search_param.load_data.load_meta.chargeable_weight + ' Kgs';
                  mixpanlGenerateQuote["Load Details"] = vm.search_param.load_data.load_meta.chargeable_weight + ' Kgs';
                  mixpanlGenerateQuote["Gross Weight"] = vm.search_param.load_data.load_meta.gross_weight + ' Kgs';
                  mixpanlGenerateQuote["Volumetric Weight"] = vm.search_param.load_data.load_meta.volumetric_weight + ' Kgs';

                  if(vm.search_param.mode == 'AIR'){
                      mixpanlGenerateQuote["Highest rate by"] = vm.selectedCard[0].data.buy_rates.l3_air.rate_obj.airline.air_line_name;
                      mixpanlGenerateQuote["Lowest rate by"] = vm.selectedCard[vm.selectedCard.length-1].data.buy_rates.l3_air.rate_obj.airline.air_line_name;
                  }else {
                      mixpanlGenerateQuote["Highest rate by"] = vm.selectedCard[0].data.buy_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name;
                      mixpanlGenerateQuote["Lowest rate by"] = vm.selectedCard[vm.selectedCard.length-1].data.buy_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name;
                  }
              }

              // if (response.data.data.pdf_link != null) {
              //     var pdfLink = response.data.data.pdf_link;
              //     var a = $window.open(pdfLink, "sharedLink");
              //     if (a) {
              //     a.focus();
              //     }
              // }
              if(localStorageService.get('dashboardCache')){
                  if(localStorageService.get('dashboardCache').value === true){
                  localStorageService.set('dashboardCache', false);
                  }
              }
              vm.quoteId = response.data.quote_id;
              vm.shareQuoteData = response.data._id;
              vm.pdf_link =response.data.pdf_link;
              vm.downloadProgressValue = 1;
              vm.fnGetPdfLink();
              vm.quoteSent = true;
              vm.shareQuoteBtn = false;
              vm.generateQuoteBtn = true;
              vm.customerDetails = {};
              util.isCallingApi = false;
              vm.fnNextScreen(2);

          }, function (error) {
              util.isCallingApi = false;
              vm.quoteId = null;
              vm.shareQuoteData = null;
              util.showToast(util.displayValidationError(error));
              vm.shareQuoteBtn = false;
              $log.error(error.statusText);
          })
      }

      function fnGetPdfLink(){
        vm.downloadProgressValue = vm.isPdfFailed ? 1 : vm.downloadProgressValue;
        vm.isPdfErrOccured = false;
        vm.isPdfFailed = false;
        vm.isPdfGenerated = false;
        resultService.fnGetPdfLink(vm.shareQuoteData).then(function (response) {

          vm.pdf_link = response.data.data.pdf_link;

          if(vm.pdf_link) {  // pdf link success
            clearInterval(vm.autoUpdate);
            vm.isPdfGenerated = true;
            vm.isPdfFailed = false;
            vm.downloadProgressValue = 5;
          }
          else{   //pdf link failed
            vm.autoUpdate = setTimeout(fnGetPdfLink, 5000);
            vm.downloadProgressValue+= 1;
            if(vm.downloadProgressValue >= 5){
              clearInterval(vm.autoUpdate);
              vm.isPdfFailed = true;
              vm.downloadProgressValue = 0;
            }
          }
        }, function (error) {
          vm.isPdfGenerated = true;
          vm.isPdfErrOccured = true;
          vm.downloadProgressValue = 0;
          $log.error(error);
        });
      }

      function downloadPdf(){
        // $window.open(vm.pdf_link);
        var anchorTag = document.createElement('a');
        anchorTag.setAttribute('href',vm.pdf_link);
        anchorTag.setAttribute('download',true);
        anchorTag.setAttribute('target','_blank')
        document.body.appendChild(anchorTag);
        anchorTag.click();
        document.body.removeChild(anchorTag);
  
      }

      // get expiry max date
      function getExpiryMaxDate(startDate){
          vm.expiryMaxDate = null;
          if(startDate){
            vm.expiryMaxDate = new Date(
              startDate.getFullYear() + 1,
            startDate.getMonth(),
            startDate.getDate()
          );
        }
      }

      // vaidate expiry date is greater than selected rate expiry date
      function validateExpirydate(expiry_date){
         if(expiry_date > vm.expiryDateEnd){
          vm.validationObj.showDateNote = true;
        }
        else{
          vm.validationObj.showDateNote = false;
        }

      }

      function fnChangeQuoteType(){
        vm.trackEvent('AllIn');
         //  Disable and  "Print charges with “Zero” in PDF" option if quote generated with allin total/legwise total 
         if(vm.quoteDetails.all_in_quote_setting &&( vm.quoteDetails.all_in_quote_setting == 'legwise_total' ||  vm.quoteDetails.all_in_quote_setting == 'all_in_total')){
             vm.disable_zero_sell_rates_on_pdf_checkbox = true;
             vm.quoteDetails.show_zero_sell_rates = false;

         }else{
          vm.disable_zero_sell_rates_on_pdf_checkbox = false;
         }
      }

      function trackEvent(type,value){
          if(type==="incoterms"){
            // commented as per the ticket QMS-467
            // util.callMixpanel("RR-QuoteGenerate-Incoterms-Change",{
            //   "Mode":vm.search_param.mode,
            //  });
          }
          else{
          if(type==="language"){
            util.callMixpanel("GQ-QuoteDetails-PdfPrefferedLanguage",{
              "Mode":vm.search_param.mode,
              "optionValue":value
             });
          }
          if(type === "GQ-Carrier-Masking-In-Pdf"){
            util.callMixpanel(type,{
              "Mode":vm.search_param.mode,
              "linerMask":vm.quoteDetails.carrier_mask_for_shipper
             });
          }
          if(type === "AllIn"){
            analytics.track('GQ-AllIn-Quote-Change',{
              "Mode":vm.search_param.mode,
              "optionValue":vm.quoteDetails.all_in_quote_setting
             });
          }

       
      }
    }
}
})();

(function () {
    "use strict";
    angular
      .module('app.core')
      .component('serviceModeComponent', {
          templateUrl: 'app/main/component/service-panel/service-mode.html',
          bindings: {
            relativeTo : "<",
            title: "<",
            serviceList : "<",
            selectedValue : "=",
            isDisabled : "<"
          },
         controller: ServiceModeController 
    });
    function ServiceModeController ($mdPanel) {
        var vm = this;
        vm._mdPanel = $mdPanel;
        vm.showServiceModelPanel = showServiceModelPanel;
        function showServiceModelPanel(ev) {
            var position = vm._mdPanel.newPanelPosition()
              .relativeTo("."+vm.relativeTo)
              .addPanelPosition(vm._mdPanel.xPosition.ALIGN_END, vm._mdPanel.yPosition.BELOW);
            var config = {
              attachTo: angular.element(document.body),
              templateUrl: "app/main/component/service-panel/service-panel.html",
              controllerAs: "ctrl",
              controller:function () {
                this.parent = vm;
              },
              position: position,
              openFrom: ev,
              clickOutsideToClose: true,
              escapeToClose: true,
              focusOnOpen: false,
              zIndex: 2,
            };
            vm._mdPanel.open(config);
        };
    }
    })();
(function () {
  "use strict";

  angular.module("app.core").component("searchBarInland", {
    templateUrl: "app/main/component/search-bar-inland/search-bar-inland.html",
    bindings: {
      searchParamInput: "<",
      resultcardfilter: "<",
      userselectedparam: "<",
      callback: "&",
      mode: "@",
    },
    controller: SearchBarInlandController,
  });

  function SearchBarInlandController(
    util,
    SearchService,
    resultService,
    $mdPanel,
    $rootScope,
    $state,
    loadDataFactory,
    analytics,
    appCache,
    api,
    $q,
    $filter,
    $mdSelect,
    $timeout
  ) {
    var vm = this;
    vm.util = util;
    vm.formIsPristine = true;
    vm._mdPanel = $mdPanel;
    vm.prepSearchData = prepSearchData;
    vm.getPortsLocation = getPortsLocation;
    vm.showLoadPanel = showLoadPanel;
    vm.prepLoadData = prepLoadData;
    vm.makeLoadBoxString = makeLoadBoxString;
    vm.makeDetailBoxString = makeDetailBoxString;
    vm.getLoadArrayFromParam = getLoadArrayFromParam;
    vm.showChargePanel = showChargePanel;
    vm.setChargeValidity = setChargeValidity;
    vm.setLoadValidity = setLoadValidity;
    vm.preStuffingData = preStuffingData;
    vm.getSalesPersonList = getSalesPersonList;
    vm.salesPersonList = [];
    vm.getShipperCompany = getShipperCompany;
    vm.getTrucker = getTrucker;
    vm.selectAllTrucker = selectAllTrucker;
    vm.submitSearchForm = submitSearchForm;
    vm.refinePayload = refinePayload;
    vm.formFtlLoadData = formFtlLoadData;
    vm.reduceSearchParam = reduceSearchParam;
    vm.getEmptySearchParam = getEmptySearchParam;
    vm.fnchangeSalesPerson = fnchangeSalesPerson;
    vm.preLinerFilterData = preLinerFilterData;
    vm.formUserCustomerData = formUserCustomerData;
    vm.formSearchResponseUserData = formSearchResponseUserData;
    vm.checkForSamePorts = checkForSamePorts;
    vm.showLoadAlias=showLoadAlias;
    vm.fnDialogSwitchToDoorPort =fnDialogSwitchToDoorPort;
    vm.getsearchTypeData = getsearchTypeData;
    vm.trackEvent=trackEvent;
    vm.searchOrgText = "";
    vm.searchDestText = "";
    vm.viewToggleOrigin = "";
    vm.viewToggleDestination = "";
    vm.truckerList = [];
    vm.truckerListLoading = true;
    vm.truckerChecked=false;
    vm.selectedtruckerLoading=true;
    vm.searchParamLoading=true;
    vm.selectedtrucker = [];
    vm.load_type_alias = $rootScope.domainData.domain_info.LOAD_TYPE_ALIAS;
    vm.isload_type_alias =
      vm.load_type_alias && Object.keys(vm.load_type_alias).length
        ? true
        : false;
    vm.currentState =
      $state.current.name === "app.search" ? "app.search" : "app.search.result";
    vm.mdSelect = $mdSelect;
    var today = new Date();
    vm.cargoMinDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      0,
      0,
      0
    );
    vm.searchParamData = null;
    vm.isPcmsEnabled =
          $rootScope.domainData.domain_info.POSTALCODES_ENABLED;
    vm.showLocationToggle = [];
    vm.serviceMode = ["DOOR","CY"];
    vm.isShipper = util.isShipper;
          

    this.$onInit = function () {
      // vm.searchParam = angular.copy(vm.searchParamInput);
      getLoadListFtl();
      getTrucker();
       // prepLoadData();
       getEmptySearchParam();
       // prepSearchData();
       // preStuffingData();
       // preLinerFilterData();

      var serviceLocationToggle = $rootScope.domainData.domain_info.SHOW_LOCATION_TOGGLE;
      var accountType = util.isShipper ? 'SHIPPER' : 'FORWARDER';
      var checkServiceMode = util.checkKeyPresent(serviceLocationToggle,accountType,vm.mode);
      vm.isLoadingServiceMode = true;
      if(checkServiceMode && checkServiceMode.length === 1) {
        vm.showLocationToggle = checkServiceMode.map(function (item) { return item.toUpperCase() });
        util.isCallingApi = true;
      }else{
        vm.showLocationToggle = vm.serviceMode;
      }

      $timeout(function () {
        if(checkServiceMode && checkServiceMode.length === 1){
          serviceToggleMapping();
        }
        util.isCallingApi = false;
        vm.isLoadingServiceMode = false;
      }, 200);

    };

    function serviceToggleMapping(){
      var viewServiceToggle = vm.showLocationToggle[0] === 'DOOR' ? 'door' : 'port';
      if((viewServiceToggle === 'door' && vm.searchParam.search_type != 'D2D') || (viewServiceToggle === 'port' && vm.searchParam.search_type != 'P2P')){
        vm.fnDialogSwitchToDoorPort(viewServiceToggle,'origin');
        vm.fnDialogSwitchToDoorPort(viewServiceToggle,'destination');
      }
    }

    this.$onChanges = function (obj) {
      vm.searchParamLoading=true;
      if (
        obj.searchParamInput.currentValue &&
        obj.searchParamInput.currentValue.mode === vm.mode
      ) {
        if (vm.formIsPristine || vm.userselectedparam) {
          vm.searchParam = angular.copy(vm.searchParamInput);
          vm.searchParamLoading = false;

        }
        if (!util.isShipper && vm.currentState === "app.search") {
          vm.searchParam.salesUser = angular.copy(
            vm.formUserCustomerData(util.userProfile.user)
          );
          vm.searchParam.customer = null;
        }

        if (vm.currentState === "app.search.result") {
          appCache.put("verificationsearchParam", angular.copy(vm.searchParam));
          appCache.get("verificationsearchParam").cargoReadyDate = $filter(
            "date"
          )(vm.searchParam.cargoReadyDate, "yyyy-MM-dd");
          vm.searchParam.cargoReadyDate = moment(
            $filter("date")(vm.searchParam.cargoReadyDate, "yyyy-MM-dd"),
            "YYYY-MM-DD"
          ).toDate();
        } else {
          vm.searchParam.cargoReadyDate = addDays(
            new Date(),
            $rootScope.domainData.domain_info["DEFAULT_CARGO_READY_OFFSET_FTL"] || 0
          );
        }

        prepLoadData();
        prepSearchData();
        preStuffingData();
        preLinerFilterData();
        getsearchTypeData();
        if(vm.showLocationToggle.length === 1){
          serviceToggleMapping();
        }
      }
    };

    // Helper function to add days to a date
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }

    this.$onDestroy = function () {
      if (appCache.get("searchParam")) {
        appCache.remove("searchParam");
      }

      if (appCache.get("verificationsearchParam")) {
        appCache.remove("verificationsearchParam");
      }
    };

    function prepSearchData() {
      vm.searchConfig = $rootScope.domainData.domain_info["SEARCH_CONFIG"];
      vm.salesPersonType =
        util.userProfile.user && util.userProfile.user.is_sales_cordinator
          ? "SALES_COORDINATOR"
          : !util.isShipper
          ? "SALES_USER"
          : "SHIPPER_USER";

      if (
        vm.searchConfig &&
        vm.searchConfig.sales_person &&
        !util.isShipper &&
        vm.salesPersonList &&
        !vm.salesPersonList.length &&
        !vm.isSalesApiLoading
      ) {
        vm.getSalesPersonList("", "init");
      }
      if (!(vm.currentState === "app.search.ftlResult")) {
        vm.searchParam.referenceText = null;
      }
    }

    function preLinerFilterData() {
      vm.selectedtruckerLoading=true;
      for (var i = 0; i < vm.searchParam.filters.length; i++) {
        if (vm.searchParam.filters[i].name === "carrier") {
          vm.selectedtrucker = vm.searchParam.filters[i].values;
        }
      }
      if(vm.selectedtrucker.length===vm.truckerList.length){
          vm.truckerChecked=true;
      }
      else{
          vm.truckerChecked = false;
      }
            vm.selectedtruckerLoading = false;

    }

    function fnDialogSwitchToDoorPort(event, type) {
      if (type == "origin") {
        if (vm.viewToggleOrigin === event) {
          return;
        }
        vm.viewToggleOrigin = event;
        vm.searchParam.origin = [];
        vm.searchBarForm.$error = {};
        vm.searchBarForm.ftl_origin_port.$error.required = false;
        vm.searchBarForm.ftl_origin_port.$dirty = false;
      } else {
        if (vm.viewToggleDestination === event) {
          return;
        }
        vm.viewToggleDestination = event;
        vm.searchParam.destination = [];
        vm.show_destination_port = false;
        vm.searchBarForm.$error = {};
        vm.searchBarForm.ftl_destination_port.$error.required = false;
        vm.searchBarForm.ftl_destination_port.$dirty = false;
      }
    }

     function getsearchTypeData() {
      if (vm.searchParam){
        var originType = vm.searchParam.searchType
          ? vm.searchParam.searchType.charAt(0)
          : "P";
       var destinationType = vm.searchParam.searchType
         ? vm.searchParam.searchType.charAt(2)
         : "P";
       vm.viewToggleOrigin = originType == "P" ? "port" : "door";
       vm.viewToggleDestination = destinationType == "P" ? "port" : "door";
      }
     }

    function getSalesPersonList(searchText, init) {
      vm.isSalesApiLoading = true;
      return resultService
        .getSalesPersonList(util.userProfile.user.id, searchText)
        .then(
          function (response) {
            response.data.data = response.data.data.map(formUserCustomerData);
            vm.salesPersonsCount = response.data.count;

            if (vm.searchParam.salesUser) {
              var user = response.data.data.find(function (element) {
                return element.id == vm.searchParam.salesUser.id;
              });
              if (!user) {
                response.data.data.push(vm.searchParam.salesUser);
              }
            }
            vm.salesPersonList = angular.copy(response.data.data);

            if (init) {
              util.salesPersonList = vm.salesPersonList;
              vm.fnchangeSalesPerson("init");
            }
            vm.isSalesApiLoading = false;
          },
          function (error) {
            vm.isSalesApiLoading = false;
            vm.salesPersonList = [];
            vm.salesPersonsCount = 0;
            $log.log(error.data);
          }
        );
    }
    function checkForSamePorts(params) {
      if (
        vm.searchParam.origin[0] &&
        vm.searchParam.destination[0] &&
        vm.searchParam.origin[0].location ===
          vm.searchParam.destination[0].location
      ) {
        vm.searchBarForm.$error.samePortError = true;
      } else if (vm.searchBarForm.$error.samePortError) {
        delete vm.searchBarForm.$error.samePortError;
      }
    }

    function formUserCustomerData(userList) {
      const data = {
        id: userList.id,
        email: userList.email,
        userMobile: userList.user_mobile,
        userMobileCode: userList.user_mobile_code,
        userMobileCountry: userList.user_mobile_country,
        userFirstName: userList.user_first_name,
        userLastName: userList.user_last_name,
        userCompanyID: userList.user_company_id,
        userCompanyName: userList.user_company_name,
        userBaseCurrency: userList.user_base_currency,
        domain: userList.domain,
        roleID: userList.role_id,
        isSalesCoordinator: userList.is_sales_cordinator,
        isPricingUser: userList.is_pricing_user,
        name: userList.user_first_name + " " + userList.user_last_name,
      };
      return data;
    }

    function formSearchResponseUserData(list) {
      const data = {
        id: list.id,
        email: list.email,
        userMobile: list.userMobile,
        userMobileCode: list.userMobileCode,
        userMobileCountry: list.userMobileCountry,
        userFirstName: list.userFirstName,
        userLastName: list.userLastName,
        userCompanyID: list.userCompanyID,
        userCompanyName: list.userCompanyName,
        userBaseCurrency: list.userBaseCurrency,
        domain: list.domain,
        roleID: list.roleID,
        isSalesCoordinator: list.isSalesCoordinator,
        isPricingUser: list.isPricingUser,
        name: list.userFirstName + " " + list.userLastName,
      };
      return data;
    }

    function fnchangeSalesPerson(type, searchQuery) {
      if (!vm.searchParam.salesUser) {
        vm.searchParam.customer = null;
        return;
      }
      if (vm.selectListShow && type !== "init") {
        return true;
      }
      if (
        util.shipperList.length &&
        angular.equals(util.selectedSalesPerson, vm.searchParam.salesUser)
      ) {
        vm.selectList = angular.copy(util.shipperList);
        return true;
      }

      vm.selectListShow = true;
      var url =
        api.baseUrl + "/api/v2/user?company_type=SHIPPER&limit=30&offset=0";
      if (vm.searchParam.salesUser.id) {
        url += "&user_id=" + vm.searchParam.salesUser.id;
      }
      vm.searchParam.salesUser.id;
      SearchService.getShipperList(url).then(
        function (response) {
          vm.selectListShow = false;
          vm.selectList = response.data.data;
          vm.shipperListCount = response.data.data.map(formUserCustomerData);
          util.shipperList = angular.copy(vm.selectList);
          util.selectedSalesPerson = angular.copy(vm.searchParam.salesUser);
          if (type !== "init") {
            vm.searchParam.customer = null;
          }
        },
        function (error) {
          vm.selectListShow = false;
          $log.log(error.data);
        }
      );
    }

    function submitSearchForm() {
      vm.formSubmit = true;
      var todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      vm.searchParamData = angular.copy(vm.searchParam);

      //it's checking selected "cargoReadyDate" is past date or not
      if (vm.searchParamData.cargoReadyDate < todayDate) {
        vm.searchParamData.cargoReadyDate.$error.mindate = true;
        return false;
      }
      vm.searchParamData.loads = vm.formFtlLoadData(vm.loadArray);
      vm.searchParamData.salesUser = !vm.isShipper  ? {
        _id: vm.searchParamData.salesUser.id,
      } : '';
      if (vm.searchParamData.customer) {
        vm.searchParamData.customer = {
          _id: vm.searchParamData.customer.id,
        };
      }
      if (util.userProfile.user) {
        vm.searchParamData.user = {
          _id: util.userProfile.user.id,
        };
      }

      if (
        vm.searchConfig &&
        vm.searchConfig.sales_person &&
        vm.searchConfig.sales_person.required &&
        !vm.searchParamData.salesUser &&
        !util.isShipper
      ) {
        util.showToast("Please select sales person!");
        return;
      }

      if (
        vm.searchConfig &&
        vm.searchConfig.shipper_email &&
        vm.searchConfig.shipper_email.required &&
        !vm.searchParamData.customer &&
        !util.isShipper
      ) {
        util.showToast("Please enter customer details!");
        return;
      }

      if (Object.keys(vm.searchBarForm.$error).length) {
        return;
      }
      vm.searchParamData.origin[0].isUserInput = true;
      vm.searchParamData.destination[0].isUserInput = true;
      vm.searchParamData.carrierPreferenceUI = [];
      vm.searchParamData.requestedLegs = ["LANDFREIGHT"];
      vm.searchParamData.referenceText = vm.searchParamData.referenceText
        ? vm.searchParamData.referenceText
        : vm.searchParamData.origin[0].location +
          " to " +
          vm.searchParamData.destination[0].location +
          " / " +
          $filter("date")(vm.searchParamData.cargoReadyDate, "d MMM yyyy");
      if (!vm.searchParamData.referenceText) {
        util.showToast("Please enter valid search name!");
        return;
      }
      vm.searchParamData.cargoReadyDate = $filter("date")(
        vm.searchParamData.cargoReadyDate,
        "yyyy-MM-dd"
      );
      if (
        vm.isStateResult &&
        angular.equals(appCache.get("verificationsearchParam"), vm.searchParam)
      ) {
        util.showToast("No changes made");
        vm.searchParamData.cargoReadyDate = moment(
          vm.searchParamData.cargoReadyDate,
          "YYYY-MM-DD"
        ).toDate();
        return;
      }

      vm.searchParamData.stuffing =
        vm.searchParamData.stuffing === ("D" ||"DOCK")  ? "DOCK" : "FACTORY";
      vm.searchParamData.filters = [];
      if (vm.selectedtrucker.length) {
        vm.filtersLiner = {
          name: "carrier",
          values: vm.selectedtrucker,
        };
        vm.searchParamData.filters.push(vm.filtersLiner);
      }

      vm.searchParamData.origin[0].inputText = vm.searchOrgText;
      vm.searchParamData.destination[0].inputText = vm.searchDestText;

      util.callMixpanel("IR-SearchRate-Click", {
        Mode: vm.mode,
        SearchName: vm.searchParamData.referenceText,
        PortPair:
          vm.searchParamData.origin[0].location +
          " to " +
          vm.searchParamData.destination[0].location,
        Currency: vm.searchParamData.searchCurrency,
      });


      // if(vm.resultcardfilter){
      //   vm.resultcardfilter["isSearchUpdate"] = true;
      //   vm.resultcardfilter["countApiCard"] = 1;
      // }
      vm.callback({ payload: refinePayload(vm.searchParamData, vm.mode) });
    }

    function getEmptySearchParam() {
      if (!SearchService.emptySearchParam) {
        SearchService.getEmptySearchParam().then(
          function (response) {
            SearchService.emptySearchParam = response.data;
            vm.emptySearchParam = SearchService.emptySearchParam;
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.emptySearchParam = SearchService.emptySearchParam;
      }
    }
    function showLoadAlias(ev) {
      var position = vm._mdPanel
        .newPanelPosition()
        .relativeTo(".load-alias")
        .addPanelPosition(
          vm._mdPanel.xPosition.CENTER,
          vm._mdPanel.yPosition.ABOVE
        );

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: "app/main/component/load-alias/load-alias.html",
        bindToController: true,
        controller: "LoadAliasController",
        controllerAs: "ctrl",
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
      };
      vm._mdPanel.open(config);
    }

    function refinePayload(data, mode) {
      return reduceSearchParam(
        vm.emptySearchParam.search_param_inland_ftl,
        data
      );
    }

    function formFtlLoadData(loadData) {
      var loadArray = [];
      loadData.forEach(function (load) {
        (load = util.formFtlSearchData(SearchService.loadTypeFtl, load)),
          (loadArray[loadArray.length] = {
            loadType: "container",
            type: load.type,
            qty: load.count,
            weightQty: load.weight_qty,
            weightUnit: load.weight_unit,
            teu: load.teu,
            sequence: load.sequence,
          });
      });
      return loadArray;
    }

    function reduceSearchParam(srcObj, destObj) {
      var objToReturn = {};
      for (var key in srcObj) {
        if (destObj.hasOwnProperty(key) && srcObj.hasOwnProperty(key)) {
          objToReturn[key] = destObj[key];
        }
      }
      return objToReturn;
    }

    function selectAllTrucker() {
      if (vm.selectedtrucker.length != vm.truckerList.length) {
        vm.selectedtrucker = angular.copy(vm.truckerList);
      } else {
        vm.selectedtrucker = [];
      }
    }

    function getShipperCompany(searchText) {
      var offset = 0;
      var url =
        api.baseUrl +
        "/api/v2/user?company_type=SHIPPER&limit=30&offset=" +
        offset;
      if (searchText) {
        url += "&query=" + searchText;
      }
      if (vm.searchParam.salesUser && vm.searchParam.salesUser.id) {
        url += "&user_id=" + vm.searchParam.salesUser.id;
      }
      var deferred = $q.defer();
      SearchService.getShipperList(url).then(
        function (response) {
          vm.selectList = response.data.data.map(formUserCustomerData);
          deferred.resolve(vm.selectList);
        },
        function (error) {
          $log.log(error.data);
        }
      );
      return deferred.promise;
    }

    function prepLoadData() {
      vm.loadArray = vm.getLoadArrayFromParam(vm.searchParam.loads);
      vm.resetLoadObj = angular.copy(vm.loadArray);
      makeLoadBoxString();
      preStuffingData();
      makeDetailBoxString();
    }
    function preStuffingData() {
      if (vm.searchParam.stuffing === "DOCK" || vm.searchParam.stuffing === "D") {
        vm.searchParam.stuffing = "D";
      } else {
        vm.searchParam.stuffing = "F";
      }
    }

    function getTrucker() {
      vm.truckerListLoading = true;
      vm.truckerList = [];
      var truckerResponse = [];
      var type =
        vm.mode === "AIR"
          ? "airlines"
          : vm.mode === "FTL"
          ? "transporter"
          : "liners";
      SearchService.getTruckerData(type, vm.mode).then(
        function (response) {
          truckerResponse = response.data;
          truckerResponse.map(function (item) {
            vm.truckerList.push({
              value: item.id.toString(),
              name: item.name,
            });
          });
          vm.truckerListLoading = false;
        },
        function (error) {
          $log.log(error.data);
        }
      );
    }

    function showChargePanel(ev) {
      analytics.track("IR-locals&Customs/Incoterms-dropdown-Click", {
        Mode: vm.mode,
      });
      var position = vm._mdPanel
        .newPanelPosition()
        .relativeTo(".panel-select-charge")
        .addPanelPosition(
          vm._mdPanel.xPosition.ALIGN_END,
          vm._mdPanel.yPosition.BELOW
        );

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: "app/main/component/charge-selector/charge-select.html",
        controllerAs: "ctrl",
        controller: "ChargeSelectController",
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          searchParam: vm.searchParam,
          searchMode: vm.mode,
          pageSource:'IR'
        },
        onRemoving: function () {
          makeDetailBoxString();
          setChargeValidity();
        },
      };
      vm.formIsPristine = false;
      appCache.put("searchParam", vm.searchParam);
      vm._mdPanel.open(config);
    }
    function setChargeValidity() {
      if (!vm.searchParam.units.bl || !vm.searchParam.units.sbl) {
        vm.searchBarForm.$error.chargeError = true;
      } else if (vm.searchBarForm.$error.chargeError) {
        delete vm.searchBarForm.$error.chargeError;
      }
    }

    function showLoadPanel(ev) {
      var position = vm._mdPanel
        .newPanelPosition()
        .relativeTo(".panel-select-load")
        .addPanelPosition(
          vm._mdPanel.xPosition.CENTER,
          vm._mdPanel.yPosition.BELOW
        );

      var config = {
        attachTo: angular.element(document.body),
        templateUrl:
          "app/main/component/load-selector/load-select-wrapper.html",
        controllerAs: "ctrl",
        controller: "LoadWrapperController",
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          resetLoadObj: vm.resetLoadObj,
          loadTypeArr: SearchService.loadTypeFtl,
          mode: vm.mode,
          type:'IR'
        },
        onOpenComplete: function () {
          loadDataFactory.panelClosed = false;
        },
        onRemoving: function () {
          vm.loadArray = loadDataFactory.loadData;
          loadDataFactory.panelClosed = true;
          makeLoadBoxString();
          setLoadValidity();
        },
      };
      vm.formIsPristine = false;
      loadDataFactory.loadData = vm.loadArray;
      vm._mdPanel.open(config);
    }
    function setLoadValidity() {
      var loadHasError = false;

      loadHasError = vm.loadArray.some(function (load, key) {
        if (!load.type || !load.count || !load.weight_qty) {
          return true;
        }
      });

      if (loadHasError) {
        vm.searchBarForm.$error.loadError = true;
      } else if (vm.searchBarForm.$error.loadError) {
        delete vm.searchBarForm.$error.loadError;
      }
    }

    function getLoadListFtl() {
      if (
        SearchService.loadTypeFtl == undefined ||
        SearchService.loadTypeFtl.length == 0
      ) {
        SearchService.getAllLoadListFtl().then(
          function (response) {
            SearchService.loadTypeFtl = response;
            vm.loadTypeArr = response;
            util.ftlLimitObj = response;
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.loadTypeArr =
          SearchService.loadTypeFtl != undefined
            ? SearchService.loadTypeFtl
            : [];
      }
    }

    function getPortsLocation(searchText, mode, searchType) {
      var placeType = "";
      if (searchType == "origin") {
        if (searchText) {
          vm.searchOrgText = searchText;
        }
        placeType=vm.viewToggleOrigin=='port' ? 'P2P' : 'D2D'
      } else {
        if (searchText) {
          vm.searchDestText = searchText;
        }
        placeType = vm.viewToggleDestination == "port" ? "P2P" : "D2D";
      }
      return SearchService.getPortsLocationFtl(
        searchText,
        mode,
        searchType,
        placeType
      );
    }

    function makeLoadBoxString() {
      vm.LoadBoxString = "";
      vm.LoadTooltipString = "";
      vm.loadArray.forEach(function (i, k) {
        if (i.type) {
          vm.LoadBoxString =
            vm.LoadBoxString +
            (vm.LoadBoxString === "" ? "" : ", ") +
            i.type +
            " x" +
            (i.count || 0);
          vm.LoadTooltipString =
            vm.LoadTooltipString +
            (vm.LoadTooltipString === "" ? "" : "\n") +
            i.type +
            " x" +
            (i.count || 0);
        }
      });
    }

    function makeDetailBoxString() {
      vm.detailBoxString =
        (vm.searchParam.stuffing === "F"
          ? "Factory Stuffing"
          : "Dock Stuffing") || "Select Charges";

      vm.detailBoxTooltip =
        (vm.searchParam.stuffing === "F"
          ? "Factory Stuffing"
          : "Dock Stuffing") || "Select Charges";
      vm.detailBoxString =
        vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ","
          ? vm.detailBoxString.slice(0, -2)
          : vm.detailBoxString;
    }

    function getLoadArrayFromParam(loadData) {
      var loadArray = [];
      loadData.forEach(function (load) {
        loadArray[loadArray.length] = {
          type: load.type,
          count: load.qty,
          max_weight: "",
          weight_qty: load.weightQty,
          weight_unit: "KGs",
          max_volume: "",
          teu: load.teu,
        };
      });
      return loadArray;
    }

    function trackEvent(type, searchQuery) {
        util.callMixpanel(type, {
          Mode: vm.mode,
          searchQuery: searchQuery,
        });
      }
      
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('searchBar', {
      templateUrl: 'app/main/component/search-bar/search-bar.html',
      bindings: {
        searchParamInput: '<',
        resultcardfilter: '<',
        searchFromQuote: '<',
        userselectedparam: '<',
        allSalesPersonsData: '<',
        isLoadingApi:'<',
        callback: '&',
        mode: '@'
      },
      controller: SearchBarController
    });


  function SearchBarController(util,$scope, SearchService, $mdPanel, $rootScope, resultService, api, appCache, $filter, $state, $q, $timeout, loadDataFactory, ScheduleSearchService, $log) {
    var vm = this;

    // Binding Services to scope
    vm._mdPanel = $mdPanel;
    vm.util = util;

    // Variables declarations
    vm.LoadBoxString = '';
    vm.formSubmit = false;
    vm.chargeBoxString = '';
    vm.formIsPristine = true;
    vm.openDatePicker = false;
    vm.searchFromClose = false;
    vm.searchCurrency='';
    vm.pageSource = '';
    vm.lastShipperSearchText = "";
    // vm.cargoMinDate =  moment().toDate();//new Date(); // global time
    // Like Fri, 26 Sep 2014 18:30:00 GMT
    var today = new Date();
    // vm.cargoMinDate = $filter('date')(today, 'yyyy-MM-dd');
    vm.isShipper = util.isShipper;
    vm.isAdmin = util.isAdmin;
    vm.isMobileDevice = angular.element(window).width() < 600 ? true : false;
    vm.currentState = $state.current.name === 'app.search' ? 'app.search' : 'app.search.result';

    // Object declarations
    vm.chargeList = ['Origin Charges', 'Destination Charges', 'Insurance', 'Handling Charges'];
    vm.trackEvent = trackEvent;  
    // Functions for template
    vm.goBack = goBack;
    vm.focusElem = focusElem;
    // vm.fetchNearby = fetchNearBy;
    vm.fnEditSearch = fnEditSearch;
    vm.showLoadPanel = showLoadPanel;
    vm.showLoadAlias = showLoadAlias;
    vm.showChargePanel = showChargePanel;
    vm.submitSearchForm = submitSearchForm;
    vm.getShipperCompany = getShipperCompany;
    vm.checkForSamePorts = checkForSamePorts;
    vm.toggleFormForResult = toggleFormForResult;
    vm.showLoadDetailPanel = showLoadDetailPanel;
    vm.fnchangeSalesPerson = fnchangeSalesPerson;
    vm.getPortsLocation = getPortsLocation;
    vm.submitScheduleForm = submitScheduleForm;
    vm.refreshSearchLoadRates = refreshSearchLoadRates;
    vm.fnDialogSwitchToDoorPort = fnDialogSwitchToDoorPort;
    vm.getsearchTypeData = getsearchTypeData;
    vm.viewToggleOrigin="";
    vm.viewToggleDestination=""
    vm.scheduleSearch = false;
    vm.selectList = [];
    vm.salesPersonList = [];
    vm.getSalesPersonList = getSalesPersonList;
    vm.searchOrgText = '';  //To store search text after selection
    vm.searchDestText = '';
    vm.checkForDuplicatePorts = checkForDuplicatePorts
    vm.checkExistingPort = null;
    vm.checkOtherPort = null; 
    vm.load_type_alias = $rootScope.domainData.domain_info.LOAD_TYPE_ALIAS;
    vm.isIncotermSearch=  $rootScope.domainData.domain_info["ENABLE_INCOTERM_SEARCH"];
    if($rootScope.domainData.domain_info["SEARCH_CONFIG"]){
      vm.isCarrierServiceMode =  $rootScope.domainData.domain_info.SEARCH_CONFIG.hasOwnProperty("service_mode");
      vm.isCarrierSelection =  $rootScope.domainData.domain_info.SEARCH_CONFIG.hasOwnProperty("carrier_selection");
    }
    vm.isPcmsEnabled = $rootScope.domainData.domain_info.POSTALCODES_ENABLED;
      // vm.isPcmsEnabled =false;
    vm.isload_type_alias =(vm.load_type_alias &&  Object.keys(vm.load_type_alias).length) ? true : false;
    vm.validateLC = validateLC;
    vm.selectAllClicked = selectAllClicked;
    vm.getCarrierSelectionData = getCarrierSelectionData;
    vm.checkDefaultServiceMode = checkDefaultServiceMode;
    vm.valueChanged = valueChanged;
    vm.origin_service_mode = "";
    vm.destination_service_mode = "";
    vm.carrierSearchTextChange = carrierSearchTextChange;
    vm.carrierSelectionList = {};
    vm.selectedCarrierOption = [];
    vm.destination_alias=[];
    vm.origin_alias=[];
    vm.carrierCallBack = carrierCallBack;
    vm.carrierSelectionCopy = {};
    vm.carrierSelectionError = false;
    vm.getDefaultValue = "";
    vm.carrierFilter = false;
    vm.carrierShimmer = true;
    vm.includeSdOrigin=false;
    vm.includeSdDestination=false
    vm.show_origin_port = false;
    vm.show_destination_port = false;
    vm.duplicatePortValidation = '';
    vm.originPortLimit = $rootScope.domainData.domain_info["MAX_POL_POD"] ? $rootScope.domainData.domain_info["MAX_POL_POD"].origin : 1;
    vm.destinationPortLimit =  $rootScope.domainData.domain_info["MAX_POL_POD"] ?$rootScope.domainData.domain_info["MAX_POL_POD"].destination :1;
    vm.originNearbyPortLimit = 1;
    vm.destinationNearbyPortLimit = 1;
    vm.enabled_pol_pod = $rootScope.domainData.domain_info["ENABLED_POL_POD"];
    vm.enabled_nearby = $rootScope.domainData.domain_info["GET_NEARBY_PORT_RESULT"] ? true: false;
    vm.is_independent_search = $rootScope.domainData.domain_info["ENABLED_POL_POD"] && $rootScope.domainData.domain_info["POSTALCODES_ENABLED"];
    vm.co2eToggleVisible = $rootScope.domainData.domain_info.ENABLE_CO2E;
    vm.fnRemovePortChip = fnRemovePortChip;
    vm.formPayload=formPayload;
    vm.fnPrefillPolPodData = fnPrefillPolPodData;
    vm.fnPrefillNearbyPortData=fnPrefillNearbyPortData;
    vm.getPolPodLocation = getPolPodLocation;
    vm.fnCheckToShowPolPod = fnCheckToShowPolPod;
    vm.limitedDisplayListOption = limitedDisplayListOption
    vm.refreshSearchRates = refreshSearchRates;
    vm.fnUpdateLocation=fnUpdateLocation;
    vm.showLocationToggle = [];
    vm.serviceMode = {
        "FCL": ["DOOR","CY"],
        "LCL": ["DOOR","CFS"],
        "AIR": ["DOOR","AIRPORT"],
    }
    vm.isLoadingServiceMode = false;

    //multi door
    vm.isStopOriginPortInput = isStopOriginPortInput;
    vm.isStopDestinationPortInput = isStopDestinationPortInput;
    if(vm.isCarrierServiceMode){
      vm.carrier_service_mode = $rootScope.domainData.domain_info.SEARCH_CONFIG["service_mode"];
      vm.getDefaultValue = vm.carrier_service_mode.data.find(function(value){ return value.default});
    }
    if(vm.isCarrierSelection){
      vm.carrierSelectionConfig = $rootScope.domainData.domain_info.SEARCH_CONFIG["carrier_selection"];
    }
    function carrierCallBack(payload){
      if(payload.selectAll){
        vm.selectAllClicked(payload.selectAll);
      }
      if(payload.valueChange){
        vm.valueChanged(payload.label,payload.currentObj)
      }
      if(payload.searchText){
        vm.carrierSearchTextChange(payload.searchTextValue)
      }
    }
    function carrierSearchTextChange(carrierSearchText){
      vm.carrierFilter = true;
      var searchText = carrierSearchText.toLowerCase();
      for(var key in vm.carrierList.data.carrier_mappings.FCL){
        if(!carrierSearchText){
            vm.carrierList.data.carrier_mappings.FCL[key].data = angular.copy(vm.carrierSelectionCopy.data.carrier_mappings.FCL[key].data);
        }
        else{
          vm.carrierList.data.carrier_mappings.FCL[key].data =  angular.copy(vm.carrierSelectionCopy.data.carrier_mappings.FCL[key].data).filter(function(value){
            return value.name.toLowerCase().includes(searchText);
           })
        }
        vm.limitedDisplayListOption(searchText,key);
      }
      vm.carrierFilter = false;
    }
    function valueChanged(catagery,currenobj){
      if( vm.carrierList.data.carrier_mappings.FCL[catagery].selectAll){
        vm.carrierSelectionCopy.data.carrier_mappings.FCL[catagery].data.forEach(function(value){
          var index = vm.selectedCarrierOption.findIndex(function(selectedValue){ return selectedValue.uniqueId === value.uniqueId});
          if(index !== -1 && value.uniqueId !== currenobj.uniqueId ){
            vm.carrierSelectionList[catagery].push(value);
          }
        });
        vm.carrierList.data.carrier_mappings.FCL[catagery].selectedCount = vm.carrierSelectionList[catagery].length;
        vm.carrierList.data.carrier_mappings.FCL[catagery].selectAll = false;
      }
      else{
        var isPresent = vm.selectedCarrierOption.findIndex(function(value){return value.uniqueId === currenobj.uniqueId})
        if(isPresent === -1){
          vm.carrierSelectionList[catagery].push(currenobj);
        }
        else{
         var index = vm.carrierSelectionList[catagery].findIndex(function(value){return value.uniqueId === currenobj.uniqueId});
         vm.carrierSelectionList[catagery].splice(index,1);
        }

        vm.carrierList.data.carrier_mappings.FCL[catagery].selectedCount = vm.carrierSelectionList[catagery].length;

        if(vm.carrierSelectionList[catagery].length == vm.carrierList.data.carrier_mappings.FCL[catagery].activeTotalCount){
          vm.carrierSelectionList[catagery] = [];
          vm.carrierList.data.carrier_mappings.FCL[catagery].selectAll = true;
          vm.carrierList.data.carrier_mappings.FCL[catagery].selectedCount = vm.carrierList.data.carrier_mappings.FCL[catagery].activeTotalCount;
        }
        
      }
    }
    function selectAllClicked(catagery){
      if(vm.carrierList.data.carrier_mappings.FCL[catagery].selectAll){
        vm.carrierSelectionList[catagery] = [];
        vm.carrierSelectionCopy.data.carrier_mappings.FCL[catagery].data.forEach(function(value){
          var isPresent = vm.selectedCarrierOption.findIndex(function(selectedValue){return selectedValue.uniqueId === value.uniqueId})
            if(!value.disabled && isPresent===-1){
              vm.selectedCarrierOption.push(value);
            }
          })
        vm.carrierList.data.carrier_mappings.FCL[catagery]["selectedCount"] =  vm.carrierList.data.carrier_mappings.FCL[catagery].activeTotalCount;
      }
      else{
        vm.carrierSelectionCopy.data.carrier_mappings.FCL[catagery].data.forEach(function(value) {
          var index = vm.selectedCarrierOption.findIndex(function(data) { return data.uniqueId === value.uniqueId; });
          if (index !== -1) {
            vm.selectedCarrierOption.splice(index, 1);
          }
        });
        vm.carrierSelectionList[catagery] = [];
        vm.carrierList.data.carrier_mappings.FCL[catagery]["selectedCount"] = 0;
      }
    }
    function getCarrierSelectionData(response){
      vm.carrierList = angular.copy(response);
      SearchService.carrierSelectionData = angular.copy(response);
      vm.carrierShimmer = false;
      vm.carrierList.data.labels.forEach(function(key){
        if (vm.searchParam.hasOwnProperty("selected_carrier") && vm.searchParam.selected_carrier !== null) {
            if (vm.searchParam["selected_carrier"].hasOwnProperty(key.value)) {
                vm.carrierSelectionList[key.value] = vm.searchParam["selected_carrier"][key.value];
                vm.carrierSelectionList[key.value].forEach(function(value){
                  value["uniqueId"]=key.value+"_"+value.id;
                })
            } else {
                vm.carrierSelectionList[key.value] = [];
            }
            var allKey = "all_" + key.value;
            if (vm.searchParam["selected_carrier"].hasOwnProperty(allKey)) {
                vm.carrierList.data.carrier_mappings.FCL[key.value]["selectAll"] = vm.searchParam["selected_carrier"][allKey];
            } else {
                vm.carrierList.data.carrier_mappings.FCL[key.value]["selectAll"] = true ;
            }
        } 
        else {
          vm.carrierSelectionList[key.value] = [];
          vm.carrierList.data.carrier_mappings.FCL[key.value]["selectAll"] = true;
        }
      })
      for(var key in vm.carrierList.data.carrier_mappings.FCL){
        vm.carrierList.data.carrier_mappings.FCL[key]["label"] = vm.carrierList.data.labels.find(function (val) { if (val.value === key) return val }).label;
        var activeTotalCount = 0;
        vm.carrierList.data.carrier_mappings.FCL[key].data.forEach(function (value){
          value["uniqueId"]= key+"_"+value.id;
          if(!value.disabled){
            activeTotalCount++;
          }
        });
        vm.carrierList.data.carrier_mappings.FCL[key]['activeTotalCount'] = activeTotalCount;
      }
      vm.carrierSelectionCopy = angular.copy(vm.carrierList);
      vm.selectedCarrierOption = [];
      for (var key in vm.carrierSelectionList) {
        if (vm.carrierSelectionList.hasOwnProperty(key)) {
           if(vm.carrierList.data.carrier_mappings.FCL[key].selectAll){
            vm.carrierList.data.carrier_mappings.FCL[key].data.forEach(function(value){
              if(!value.disabled){
                vm.selectedCarrierOption.push(value);
              }
            })
            vm.carrierList.data.carrier_mappings.FCL[key]["selectedCount"] =  vm.carrierList.data.carrier_mappings.FCL[key].activeTotalCount;
           }
           else{
            util.updateIfNotPresent(vm.carrierSelectionList[key],vm.selectedCarrierOption,"uniqueId");
            vm.carrierList.data.carrier_mappings.FCL[key]["selectedCount"] = vm.carrierSelectionList[key].length;
           }
        }
        vm.limitedDisplayListOption(null,key);
      }
    }

    function fnDialogSwitchToDoorPort(event,type){
      if(type=='origin'){
        
        if (vm.viewToggleOrigin===event) {
        
          return
        }
        vm.viewToggleOrigin = event;
        vm.searchParam.origin_location = null;
        vm.searchParam.user_nearby_origin = [];
        vm.searchParam['nearby_origin']=[]
        vm.searchParam.origin_port = null;
        vm.show_origin_port = false;
        vm.searchBarForm.$error = {};
        vm.searchBarForm.fcl_origin_port.$error.required = false;
        vm.searchBarForm.fcl_origin_port.$dirty = false;
        vm.includeSdOrigin=false;
        vm.searchParam.fetch_nearby_origin=false;
      }
      else{
        if (vm.viewToggleDestination === event) {
          return;
        }
       vm.viewToggleDestination = event;
       vm.searchParam.destination_location = null;
       vm.searchParam.user_nearby_destination = [];
       vm.searchParam['nearby_destination']=[];
       vm.searchParam.destination_port = null;
        vm.show_destination_port = false;
        vm.searchBarForm.$error = {};
        vm.searchBarForm.fcl_destination_port.$error.required = false;
        vm.searchBarForm.fcl_destination_port.$dirty = false;
        vm.includeSdDestination = false;
        vm.searchParam.fetch_nearby_destination=false;

      }
    }
    function checkDefaultServiceMode(){
      if (vm.searchParam.hasOwnProperty("origin_service_mode") && vm.searchParam.origin_service_mode !==null ) {
          vm.origin_service_mode = vm.searchParam["origin_service_mode"];
       } else {
        vm.origin_service_mode = vm.getDefaultValue.value;
      }
      if (vm.searchParam.hasOwnProperty("destination_service_mode") && vm.searchParam.destination_service_mode !==null) {
        vm.destination_service_mode = vm.searchParam["destination_service_mode"];
      } else {
         vm.destination_service_mode = vm.getDefaultValue.value;
      }
    }
    // Component init
    this.$onInit = function () {
      var pastDate = (new Date(Date.now()-(90*24*60*60*1000)))
      pastDate.setHours(0,0,0,0);
      vm.cargoMinDate=$rootScope.domainData.domain_info["IS_HISTORICAL_SEARCH_ENABLED"] && $rootScope.domainData.domain_info["IS_HISTORICAL_SEARCH_ENABLED"][vm.mode] && vm.isAdmin  ? pastDate : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
      if (vm.currentState === 'app.search.result' || vm.currentState === 'app.search.lclResult' || vm.currentState === 'app.search.airResult') {
        vm.isStateResult = true;
      } else {
        vm.isStateResult = false;
      }
     
      vm.pageSource = vm.isStateResult ? 'RR' : 'IR'
      // check schedule search permissions
      if( (util.navPermission["scheduleSearch"] != undefined && util.navPermission["scheduleSearch"][1])){
        vm.scheduleSearch = true;
      }
      getLoadList();
      getEmptySearchParam();
      
      if($rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"] && $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode] && $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode].includes('*')){
       var portLimitList = $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode].split('*')
        vm.originMultiPortPairLimit = portLimitList[0];
        vm.destinationMultiPortPairLimit = portLimitList[1];
        vm.is_nXn_search = true;
      }else{
        vm.multiPortPairLimit =  $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode];
        vm.is_nXn_search = false;
      }
      if($rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode] && vm.mode=='SEA-FCL'){
        if($rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode].includes('*')){
          var portLimitList = $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode].split('*')
           vm.originMultiDoorLimit= portLimitList[0];
           vm.destinationMultiDoorLimit = portLimitList[1];
           vm.is_door_nXn_search = true;
         }else{
           vm.multiDoorLimit =  $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode];
           vm.is_door_nXn_search = false;
         }
       }
      vm.isMultiPort =  $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] && ((vm.multiPortPairLimit > 1) || (vm.originMultiPortPairLimit > 1 || vm.destinationMultiPortPairLimit > 1)) ? true : false;   
      vm.isMultiDoor =  $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] &&  vm.mode=='SEA-FCL' ? true : false;
      vm.originNearbyPortLimit = vm.isMultiPort ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] : 1 :$rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] ? $rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] : 1;
      vm.destinationNearbyPortLimit =  vm.isMultiPort ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] : 1 :$rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] ? $rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] : 1;

      var serviceLocationToggle = $rootScope.domainData.domain_info.SHOW_LOCATION_TOGGLE;
      var accountType = util.isShipper ? 'SHIPPER' : 'FORWARDER';
      var mode = vm.mode === 'SEA-FCL' ? 'FCL' : (vm.mode === 'AIR' ? 'AIR' : 'LCL');
      var serviceMode = util.checkKeyPresent(serviceLocationToggle,accountType,mode);
      
      if(serviceMode && serviceMode.length === 1) {
        vm.isLoadingServiceMode = true;
        util.isCallingApi = true;
      }else{
        vm.showLocationToggle = vm.serviceMode[mode];
      }
      
      $timeout(function () {
        prefilledMultiportData();
        getsearchTypeData();
        //fnUpdateLocation();
        if(serviceMode && serviceMode.length === 1){
          vm.showLocationToggle = serviceMode.map(function (item) { return item.toUpperCase() });
          serviceToggleMapping();
        }
        util.isCallingApi = false;
        vm.isLoadingServiceMode = false;
      }, 500);
      
    }

    function serviceToggleMapping(){
      var viewServiceToggle = vm.showLocationToggle[0] === 'DOOR' ? 'door' : 'port';
      if(viewServiceToggle === 'door'){
        vm.scheduleSearch = false;
      }
      if((viewServiceToggle === 'door' && vm.searchParam.search_type != 'D2D') || (viewServiceToggle === 'port' && vm.searchParam.search_type != 'P2P')){
        vm.fnDialogSwitchToDoorPort(viewServiceToggle,'origin');
        vm.fnDialogSwitchToDoorPort(viewServiceToggle,'destination');
      }
    }

    function fnUpdateLocation(){
     if(vm.searchParamCopyData.user_nearby_origin && vm.searchParamCopyData.user_nearby_origin.length){
      vm.searchParam['nearby_origin']=vm.searchParamCopyData.user_nearby_origin.filter(function(item){
        return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
      });
      vm.origin_alias=vm.searchParamCopyData.user_nearby_origin.filter(function(item){
        return (item.input_type == 'alias');
      });
      vm.searchParam.user_nearby_origin =  vm.searchParamCopyData.user_nearby_origin.filter(function(item){
        return (item.input_type == 'user' || !item.input_type);
      });
      vm.searchParam.user_nearby_origin.forEach(function(value){
        if(!value.input_type){
         value['input_type']='user'
        }
       })
     }
   if(vm.searchParamCopyData.user_nearby_destination &&vm.searchParamCopyData.user_nearby_destination.length){
    vm.searchParam['nearby_destination']=vm.searchParamCopyData.user_nearby_destination.filter(function(item){
      return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
    });
  
    vm.destination_alias=vm.searchParamCopyData.user_nearby_destination.filter(function(item){
      return (item.input_type == 'alias');
    });
  
    vm.searchParam.user_nearby_destination =  vm.searchParamCopyData.user_nearby_destination.filter(function(item){
      return (item.input_type == 'user' || !item.input_type);
    });
  
    vm.searchParam.user_nearby_destination.forEach(function(value){
      if(!value.input_type){
       value['input_type']='user'
      }
     })
   }
    
      if(!vm.enabled_nearby){
        vm.searchParam['nearby_origin']=[]
        vm.searchParam['nearby_destination']=[]
        vm.searchParam.fetch_nearby_destination=false;
        vm.searchParam.fetch_nearby_origin=false;
        
      }
    }
    function getsearchTypeData(){
      if(vm.searchParam){
      var originType =
          vm.searchParam.search_type ? vm.searchParam.search_type.charAt(0) : 'P';
      var destinationType = vm.searchParam.search_type
        ? vm.searchParam.search_type.charAt(2)
        : "P";
      vm.viewToggleOrigin=originType=='P' ? 'port' : 'door';
      vm.viewToggleDestination = destinationType == "P" ? "port" : "door";
      if(vm.currentState !== "app.search"){
        vm.includeSdOrigin =
          vm.searchParam.origin_service_mode == "CY/SD" ? true : false;
        vm.includeSdDestination =
          vm.searchParam.destination_service_mode == "CY/SD" ? true : false;
      }
      else{
        vm.includeSdOrigin =false;
        vm.includeSdDestination=false;
      };

      }
    }

    function prefilledMultiportData(){

      vm.is_nXn_search = $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"] && $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode] && $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode].includes('*') ; 
      // checking data type is array or not if not convert into array - md-chip working with array only 
       if(vm.searchParam.user_nearby_origin && !Array.isArray(vm.searchParam.user_nearby_origin)){
        vm.searchParam.user_nearby_origin = [vm.searchParam.user_nearby_origin];
       }
       if(vm.searchParam.user_nearby_destination && !Array.isArray(vm.searchParam.user_nearby_destination)){
        vm.searchParam.user_nearby_destination = [vm.searchParam.user_nearby_destination];
       }
       vm.fnUpdateLocation();
      //  checking multi port allowed or not
      // if multi port limit is less than port count then taking first set of ports based on port limit
      if(vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length && vm.searchParam.user_nearby_origin[0].place_type == 'Door' && vm.isMultiDoor){
          var originLimit = vm.is_door_nXn_search ? vm.originMultiDoorLimit : vm.multiDoorLimit;
          var destinationLimit = vm.is_door_nXn_search ? vm.destinationMultiDoorLimit : vm.multiDoorLimit;
          vm.searchParam.user_nearby_origin =  (vm.searchParam.user_nearby_origin ? (vm.searchParam.user_nearby_origin.length > originLimit ? vm.searchParam.user_nearby_origin.slice(0,originLimit)  :vm.searchParam.user_nearby_origin ) : []);
          vm.searchParam.user_nearby_destination =  (vm.searchParam.user_nearby_destination ?  (vm.searchParam.user_nearby_destination.length > destinationLimit ? vm.searchParam.user_nearby_destination.slice(0,destinationLimit) : vm.searchParam.user_nearby_destination) : []);
      }
      else if(vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length && vm.searchParam.user_nearby_origin[0].place_type == 'Port' && $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"]){
        var originLimit = vm.is_nXn_search ? vm.originMultiPortPairLimit : vm.multiPortPairLimit;
        var destinationLimit = vm.is_nXn_search ? vm.destinationMultiPortPairLimit : vm.multiPortPairLimit;
          vm.searchParam.user_nearby_origin =  (vm.searchParam.user_nearby_origin ? (vm.searchParam.user_nearby_origin.length > originLimit ? vm.searchParam.user_nearby_origin.slice(0,originLimit)  :vm.searchParam.user_nearby_origin ) : []);
          vm.searchParam.user_nearby_destination =  (vm.searchParam.user_nearby_destination ?  (vm.searchParam.user_nearby_destination.length > destinationLimit ? vm.searchParam.user_nearby_destination.slice(0,destinationLimit) : vm.searchParam.user_nearby_destination) : []);
         //  if current search is 1*N but previous search is N*N then taking single data from n*n
         if(!vm.is_nXn_search && vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length > 1 && vm.searchParam.user_nearby_destination.length >1){
            vm.searchParam.user_nearby_origin =  vm.searchParam.user_nearby_origin.slice(0,1);
            vm.searchParam.user_nearby_destination = vm.searchParam.user_nearby_destination.slice(0,1);
        }
        }
      // multi port not allowed then take first port from multi port data
      else{
        vm.searchParam.user_nearby_origin =  (vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length ? vm.searchParam.user_nearby_origin.slice(0,1) : []);
        vm.searchParam.user_nearby_destination =  (vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length ? vm.searchParam.user_nearby_destination.slice(0,1) : []);
     }

      if((vm.isMultiPort ||  vm.isMultiDoor)&& vm.searchParam['user_nearby_origin'].length==0 && vm.searchParam.origin_location){
        vm.searchParam.origin_location['input_type']='user'
        vm.searchParam.destination_location['input_type']='user'
        vm.searchParam['user_nearby_origin'].push(vm.searchParam.origin_location);
        vm.searchParam['user_nearby_destination'].push(vm.searchParam.destination_location);
      }
      if(vm.enabled_pol_pod){
         // checking pol/pod count is greater than pol/pod limit or not
        vm.searchParam["user_pol"] = (vm.searchParam.user_pol ? (vm.searchParam.user_pol.length > vm.originPortLimit ? vm.searchParam.user_pol.slice(0,vm.originPortLimit)  :vm.searchParam.user_pol ) : []);
        vm.searchParam["user_pod"] = (vm.searchParam.user_pod ? (vm.searchParam.user_pod.length > vm.destinationPortLimit ? vm.searchParam.user_pod.slice(0,vm.destinationPortLimit)  :vm.searchParam.user_pod ) : []);
      }else{
         // making pol/pod data as empty if config is off
        vm.searchParam["user_pol"] = [];
        vm.searchParam["user_pod"] = [];
      }
      if(vm.enabled_nearby){
        vm.searchParam['nearby_origin']= (vm.searchParam['nearby_origin'] ? (vm.searchParam['nearby_origin'].length > vm.originNearbyPortLimit ? vm.searchParam['nearby_origin'].slice(0,vm.originNearbyPortLimit)  :vm.searchParam['nearby_origin'] ) : []);
        vm.searchParam['nearby_destination'] = (vm.searchParam['nearby_destination'] ? (vm.searchParam['nearby_destination'].length > vm.destinationNearbyPortLimit ? vm.searchParam['nearby_destination'].slice(0,vm.destinationNearbyPortLimit)  :vm.searchParam['nearby_destination'] ) : []);
      }
      else{
        vm.searchParam['nearby_origin']=[]
        vm.searchParam['nearby_destination']=[]
        vm.searchParam.fetch_nearby_destination=false;
        vm.searchParam.fetch_nearby_origin=false;
      }
    }
    
    this.$onChanges = function (obj) {
    
      if (obj.searchParamInput && obj.searchParamInput.currentValue && (obj.searchParamInput.currentValue.mode === vm.mode)) {
        if (vm.formIsPristine || vm.userselectedparam) {
          vm.searchParam = angular.copy(vm.searchParamInput);
        }

        if(!util.isShipper && vm.currentState === 'app.search'){
          vm.searchParam.sales_user = util.userProfile.user;
          vm.searchParam.shipper_user = null;
        }
        
        if (vm.currentState === 'app.search.result') {
          appCache.put('verificationsearchParam', angular.copy(vm.searchParam));
          appCache.get('verificationsearchParam').cargo_ready_date = $filter('date')(vm.searchParam.cargo_ready_date, 'yyyy-MM-dd');
          vm.searchParam.cargo_ready_date =  moment($filter('date')(vm.searchParam.cargo_ready_date, 'yyyy-MM-dd'), 'YYYY-MM-DD').toDate();
        } else {
          vm.searchParam.cargo_ready_date = (new Date()).addDays(getDefaultDateDomain() || 0);
        }

        vm.isMultiDoor =  $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] &&  vm.mode=='SEA-FCL' ? true : false;
        if($rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode] && vm.mode=='SEA-FCL'){
          if($rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode].includes('*')){
            var portLimitList = $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode].split('*')
             vm.originMultiDoorLimit= portLimitList[0];
             vm.destinationMultiDoorLimit = portLimitList[1];
             vm.is_door_nXn_search = true;
           }else{
             vm.multiDoorLimit =  $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode];
             vm.is_door_nXn_search = false;
           }
         }
         vm.searchParamCopyData=angular.copy(vm.searchParam);
        prepLoadData();
        prepSearchData();
        prefilledMultiportData();
        getsearchTypeData();
        $timeout(function () {
          if(vm.showLocationToggle.length === 1){
            serviceToggleMapping();
          }
        })
        
       
        if(vm.mode === "SEA-FCL" && !vm.isShipper && vm.isCarrierSelection && Object.keys(vm.searchParam['selected_carrier']).length){
          if(Object.keys(SearchService.carrierSelectionData).length){
            if(util.userProfile && util.userProfile.user.use_recent_searches_on_search_ui === 'true' && vm.currentState === 'app.search'){
              vm.searchParam['selected_carrier']['all_online_liners'] = false;
              vm.searchParam['selected_carrier']['online_liners'] = [] 
            }
            else if(util.userProfile && util.userProfile.user.use_recent_searches_on_search_ui === 'default' && vm.currentState === 'app.search'){
              vm.searchParam['selected_carrier']['all_online_liners'] = true;
              vm.searchParam['selected_carrier']['online_liners'] = []
            }
            getCarrierSelectionData(SearchService.carrierSelectionData);
          }
          else if(!SearchService.isCarrierApiTriggered){
            SearchService.isCarrierApiTriggered = true;
            SearchService.getCarrierSelectionData(vm.carrierSelectionConfig.url,0,0,"","").then(function(response){
              if(util.userProfile && util.userProfile.user.use_recent_searches_on_search_ui === 'true' && vm.currentState === 'app.search'){
                vm.searchParam['selected_carrier']['all_online_liners'] = false;
                vm.searchParam['selected_carrier']['online_liners'] = []
              }
              else if(util.userProfile && util.userProfile.user.use_recent_searches_on_search_ui === 'default' && vm.currentState === 'app.search'){
                vm.searchParam['selected_carrier']['all_online_liners'] = true;
                vm.searchParam['selected_carrier']['online_liners'] = []
              }
              getCarrierSelectionData(response);       
             }).catch(function (error) {
              SearchService.isCarrierApiTriggered = false;
              console.log("Carrier selection api error",error)
            })
          }
        }
        if(vm.mode === "SEA-FCL" && !vm.isShipper && !vm.isCarrierSelection && Object.keys(vm.searchParam['selected_carrier']).length){
          vm.searchParam['selected_carrier']={
            "online_liners": [],
            "contract_liners": [],
            "all_online_liners": true,
            "all_contract_liners": true
          }
        }

        if(vm.mode === "SEA-FCL" && !vm.isShipper && vm.isCarrierServiceMode){
          checkDefaultServiceMode();
        }
       
        vm.show_origin_port = vm.fnCheckToShowPolPod('origin');
        vm.show_destination_port = vm.fnCheckToShowPolPod('destination');
      }
     
      if(vm.searchParam && vm.mode === "SEA-FCL" && (!vm.searchParam.hasOwnProperty("user_pol") || !vm.searchParam.hasOwnProperty("user_pod"))){
        vm.searchParam["user_pol"] = [];
        vm.searchParam["user_pod"] = [];
      }
    }

    this.$onDestroy = function () {
      if (appCache.get('searchParam')) {
        appCache.remove('searchParam');
      }

      if (appCache.get('verificationsearchParam')) {
        appCache.remove('verificationsearchParam');
      }
    }

    // get ports by search text
    function getPortsLocation(searchText, mode ,searchType,type){
      var placeType = '';
         if(searchType=='origin'){
           if(searchText){
             vm.searchOrgText = searchText;
            } 
          vm.searchParam.pickup_selected = false;
          if(!vm.isMultiPort && !vm.isMultiDoor && vm.searchParam.origin_location && vm.searchParam.origin_location.place_type == 'Door') {
            vm.searchParam.pickup_selected = true;
          }
          if((vm.isMultiPort||vm.isMultiDoor) && vm.searchParam.user_nearby_origin.length){
             if(vm.searchParam.user_nearby_origin[0].place_type == 'Port'){
              placeType = 'P2P';
             }else {
              vm.searchParam.pickup_selected = true;
             };
        }

        placeType=vm.viewToggleOrigin==='port' ? 'P2P' : 'D2D'
        // if(vm.isMultiPort && vm.searchParam.user_nearby_destination.length > 1){
        //   if(!vm.searchParam.user_nearby_origin.length || (vm.searchParam.user_nearby_origin.length && vm.is_nXn_search)){
        //     placeType = 'P2P';
        //   }else  return [];
        // }

      }else{
        if(searchText){
        vm.searchDestText = searchText;
        }
        vm.searchParam.delivery_selected = false;
        if(!vm.isMultiPort && !vm.isMultiDoor && vm.searchParam.destination_location && vm.searchParam.destination_location.place_type == 'Door') {
          vm.searchParam.delivery_selected = true;
        }
        if((vm.isMultiPort || vm.isMultiDoor )&& vm.searchParam.user_nearby_destination.length){
          if(vm.searchParam.user_nearby_destination[0].place_type == 'Port'){
            placeType = 'P2P';
          }else {
            vm.searchParam.delivery_selected = true;
          };
        }
        // if(vm.isMultiPort && vm.searchParam.user_nearby_origin.length > 1){
        //   if(!vm.searchParam.user_nearby_destination.length || (vm.searchParam.user_nearby_destination.length && vm.is_nXn_search)){
        //     placeType = 'P2P';
        //   }else  return [];
        // }
        placeType = vm.viewToggleDestination === "port" ? "P2P" : "D2D";

        
     }
     makeDetailBoxString();
    return SearchService.getPortsLocation(searchText, mode, searchType, placeType,type);
    }

    function refreshSearchLoadRates(){
       if (vm.mode === "SEA-FCL") {
         vm.loadArray = [
           {
             bl_qty: 1,
             count: 1,
             max_volume: "",
             max_weight: "",
             sbl_qty: 1,
             type: "20GP",
             weight_qty: 20000,
             weight_unit: "KGs",
           },
         ];
         makeLoadBoxString();
       } else if(vm.mode=='AIR'){
         vm.searchParam.load_data = {
           load_details_value: [
             {
               qty: 1,
               length: "",
               breadth: "",
               height: "",
               weight: "",
               volume: "",
               load_metrics: [],
             },
           ],
           load_type: "total_shipment",
           load_meta: {
             gross_weight: 0,
             volumetric_weight: 0,
             chargeable_weight: 0,
             total_qty: 1,
             total_bl: 1,
             total_sbl: 1,
             volume_unit: "KG",
             input_weight_unit: "KGs",
             calculated_weight_unit: "KGs",
             dimension_unit: "CMS",
             total_weight: 0,
             total_volume: 0,
           },
         };
       }
       else{
        vm.searchParam.load_data = {
          load_details_value: [
            {
              qty: 1,
              length: "",
              breadth: "",
              height: "",
              weight: "",
              volume: "",
              load_metrics: [],
            },
          ],
          load_type: "units",
          load_meta: {
            gross_weight: 0,
            volumetric_weight: 0,
            chargeable_weight: 0,
            total_qty: 1,
            total_bl: 1,
            total_sbl: 1,
            volume_unit: "CBM",
            input_weight_unit: "KGs",
            calculated_weight_unit: "W/M",
            dimension_unit: "CMS",
            total_weight: 0,
            total_volume: 0,
          },
        };
       }
    }
    
    function refreshSearchRates(){
      vm.searchParam.origin_location=null;
      vm.searchParam.destination_location = null;
      vm.searchParam.user_nearby_origin=[];
      vm.searchParam.user_nearby_destination = [];
      vm.searchParam['nearby_origin']=[];
      vm.searchParam['nearby_destination']=[];
      vm.origin_alias=[];
      vm.destination_alias=[];
      vm.searchParam.fetch_nearby_destination=false;
      vm.searchParam.fetch_nearby_origin=false;
      vm.searchParam.destination_port=null;
      vm.searchParam.origin_port = null;
      vm.show_destination_port=false;
      vm.show_origin_port = false;
      vm.searchParam.origin_service_mode ="CY/SD";
      vm.searchParam.destination_service_mode = "CY/SD";
      vm.includeSdDestination=false;
      vm.includeSdOrigin=false;
      vm.searchBarForm.$error={}; 
      vm.searchBarForm.fcl_origin_port.$error.required=false;
      vm.searchBarForm.fcl_destination_port.$error.required = false;
      vm.searchBarForm.fcl_origin_port.$dirty = false;
      vm.searchBarForm.fcl_destination_port.$dirty = false;
      vm.refreshSearchLoadRates();
      vm.searchParam.selected_carrier={
              all_contract_liners: true,
              all_online_liners: util.isShipper ? true : false,
              contract_liners:[] ,
              online_liners :[]
      }
       vm.selectedCarrierOption=[];
       if (Object.keys(SearchService.carrierSelectionData).length) {
          if(util.userProfile && !util.isShipper && util.userProfile.user.use_recent_searches_on_search_ui === 'true' && vm.currentState === 'app.search'){
            vm.searchParam['selected_carrier']['all_online_liners'] = false;
            vm.searchParam['selected_carrier']['online_liners'] = []
          }
          else if(util.userProfile && util.userProfile.user.use_recent_searches_on_search_ui === 'default' && vm.currentState === 'app.search'){
            vm.searchParam['selected_carrier']['all_online_liners'] = true;
            vm.searchParam['selected_carrier']['online_liners'] = []
          }
         getCarrierSelectionData(SearchService.carrierSelectionData);
       }
       vm.searchParam.search_currency = util.userProfile.user.user_base_currency;
       vm.searchParam.enable_co2e = false;
    }

    function getDefaultDateDomain() {
      return (vm.mode === 'SEA-FCL' ? $rootScope.domainData.domain_info["DEFAULT_CARGO_READY_OFFSET_FCL"] : (vm.mode === 'AIR' ? $rootScope.domainData.domain_info["DEFAULT_CARGO_READY_OFFSET_AIR"] : $rootScope.domainData.domain_info["DEFAULT_CARGO_READY_OFFSET_LCL"]));
    }

    function prepLoadData() {
      if (vm.mode === 'SEA-FCL') {
        vm.searchParam.freight_charges = $rootScope.domainData.domain_info["ENABLE_DEFAULT_FREIGHT_SELECTION"] || vm.searchParam.freight_charges;
        vm.loadArray = util.getLoadArrayFromParam(vm.searchParam.load_data.load_details_value);
        vm.resetLoadObj = angular.copy(vm.loadArray);
        makeLoadBoxString();
      } else {
        vm.searchParam.freight_charges = vm.mode == 'SEA-LCL' ? ($rootScope.domainData.domain_info["ENABLE_DEFAULT_FREIGHT_SELECTION"] || vm.searchParam.freight_charges) : true;
        vm.searchParam.load_data = (vm.mode === 'AIR' ? SearchService.calculateAirLoad(vm.searchParam.load_data) : SearchService.calculateLclLoad(vm.searchParam.load_data));
        if (vm.searchBarForm && vm.searchBarForm.$error.loadDetailError) {
          setLoadDetailValidity();
        }
      }
      makeDetailBoxString();
    }

    function prepSearchData() {
      vm.searchConfig = $rootScope.domainData.domain_info["SEARCH_CONFIG"];
      vm.salesPersonType = (util.userProfile.user && util.userProfile.user.is_sales_cordinator) ? 'SALES_COORDINATOR' : (!util.isShipper ? 'SALES_USER' : 'SHIPPER_USER');
      
        if(vm.searchConfig && vm.searchConfig.sales_person && !util.isShipper && (vm.salesPersonList && !vm.salesPersonList.length && !vm.isSalesApiLoading)){
          vm.getSalesPersonList('','init'); 
        }
     
      if( !(vm.currentState === 'app.search.result' || vm.currentState === 'app.search.lclResult' || vm.currentState === 'app.search.airResult') ){
      vm.searchParam.search_name = null;
      }
    }

    function getSalesPersonList(searchText,init){
      if(vm.isLoadingApi && !vm.isLoadingApi.allSalesPerson && vm.allSalesPersonsData && !searchText){
        vm.salesPersonsCount = vm.allSalesPersonsData.data.count;
        if(vm.searchParam.sales_user){
          var user = vm.allSalesPersonsData.data.data.find(function(element) {
            return (element.id == vm.searchParam.sales_user.id );
          });
          if(!user){
            vm.allSalesPersonsData.data.data.push(vm.searchParam.sales_user);
          }
        }
        vm.salesPersonList = angular.copy(vm.allSalesPersonsData.data.data);
        if(init){
          util.salesPersonList = vm.salesPersonList;
          // vm.fnchangeSalesPerson('init');
        }
        return;
      }
      else if(!vm.isLoadingApi || ((vm.isLoadingApi &&!vm.isLoadingApi.allSalesPerson) && (searchText || !vm.allSalesPersonsData))){
      vm.isSalesApiLoading = true;
      return resultService.getSalesPersonList(util.userProfile.user.id,searchText).then(function (response) {
        vm.salesPersonsCount = response.data.count;
        if(vm.searchParam.sales_user){
          var user = response.data.data.find(function(element) {
            return (element.id == vm.searchParam.sales_user.id );
          });
          if(!user){
            response.data.data.push(vm.searchParam.sales_user);
          }
        }
        vm.salesPersonList = angular.copy(response.data.data);
        if(init){
          util.salesPersonList = vm.salesPersonList;
          // vm.fnchangeSalesPerson('init');
        }
        vm.isSalesApiLoading = false;
      }, function (error) {
        vm.isSalesApiLoading = false;
        vm.salesPersonList = [];
        vm.salesPersonsCount = 0;
        $log.log(error.data);
      });
    }
    }

    function toggleFormForResult(event) {

      angular.element("#content").animate({
        scrollTop: 0
      }, 100);

      if (event) {
        event.stopPropagation();
      }
      angular.element('#search-open-form').slideToggle();
      if (vm.searchFromClose) {
        vm.searchFromClose = false;
        if (util.isMobileDevice) {
          vm.editSearch = false;
        }
        // document.getElementById("content").classList.remove("parent-content");
        document.getElementById('inner-content').style.height = 'auto';
        document.getElementById('inner-content').style.overflow = 'unset';

        vm.editSearch = vm.resultcardfilter.deviceName == 'mobile' ? false : true;
      } else {
        vm.searchFromClose = true;
        if (util.isMobileDevice) {
          vm.editSearch = true;
        }
        // document.getElementById("content").classList.add("parent-content");
        // document.getElementById('content').style.minHeight = 'fit-content';
        document.getElementById('inner-content').style.height = document.getElementById("content-container").offsetHeight - 62 + 'px'; // '100%'
        document.getElementById('inner-content').style.overflow = 'hidden';

      }
    }

    function focusElem() {
      setTimeout(function () {
        if (angular.element('#ref-name-search')[0]) {
          angular.element('#ref-name-search')[0].focus();
        }
      }, 50);
    }

    function closeSearchBarResult(event) {
      if (vm.isStateResult) {
        event.stopPropagation();
        vm.toggleFormForResult();
        // console.log("modify submit end");
      }
    }

    function checkForSamePorts(params) {
      if(vm.mode === "SEA-FCL" && vm.isCarrierServiceMode ){
        var checkOriginPort = (vm.isMultiPort || vm.isMultiDoor) ? vm.searchParam.user_nearby_origin[0] : vm.searchParam.origin_location;
        var checkDestinationPort = (vm.isMultiPort || vm.isMultiDoor) ? vm.searchParam.user_nearby_destination[0] : vm.searchParam.destination_location;
        if(checkOriginPort === null || ( checkOriginPort && checkOriginPort.place_type === 'Door' && !vm.enabled_pol_pod)){
          vm.origin_service_mode = "";
        }
        else{
          vm.origin_service_mode = vm.origin_service_mode ? vm.origin_service_mode : vm.getDefaultValue.value;
        }
        if(checkDestinationPort === null || (checkDestinationPort && checkDestinationPort.place_type === 'Door' && !vm.enabled_pol_pod)){
          vm.destination_service_mode = "";
        }
        else{
          vm.destination_service_mode = vm.destination_service_mode ? vm.destination_service_mode : vm.getDefaultValue.value;
        }
      }

     
      // Duplicate port validation with pol/pod - single port case
      if(!vm.isMultiPort && !vm.isMultiDoor && vm.enabled_pol_pod && vm.mode === "SEA-FCL"  && (params == 'origin_location' || params == 'destination_location' )){
        vm.duplicatePortValidation = '';
        if( vm.searchParam[params]){
          vm.fnPrefillPolPodData(vm.searchParam[params] , params);
            var nearbyPortsKey = (params== 'origin_location')?vm.searchParam["user_pod"]:vm.searchParam["user_pol"];
            var checkDuplicatePort = nearbyPortsKey.findIndex(function (item) {
            return item.portcode_portname === vm.searchParam[params].portcode_portname;
            });
            if(checkDuplicatePort >= 0){
                vm.duplicatePortValidation = params;
            }
          }
      }
      if ((vm.searchParam.origin_location && vm.searchParam.destination_location) && ((vm.searchParam.origin_location.place_type == 'Port' && vm.searchParam.origin_location.portcode_portname === vm.searchParam.destination_location.portcode_portname) || (vm.searchParam.origin_location.place_type == 'Door' && vm.searchParam.origin_location.pin_code_ui === vm.searchParam.destination_location.pin_code_ui))) {
        vm.searchBarForm.$error.samePortError = true;
      } else if (vm.searchBarForm.$error.samePortError) {
        delete vm.searchBarForm.$error.samePortError;
      }
      vm.searchParam.pickup_selected = vm.mode !== "AIR" && !vm.isMultiPort && !vm.isMultiDoor && vm.searchParam.origin_location && vm.searchParam.origin_location.place_type == 'Door' ? true : vm.searchParam.pickup_selected;
    
      vm.searchParam.delivery_selected = vm.mode !== "AIR" && !vm.isMultiPort && !vm.isMultiDoor&& vm.searchParam.destination_location && vm.searchParam.destination_location.place_type == 'Door'? true : vm.searchParam.delivery_selected;

      vm.show_origin_port = vm.fnCheckToShowPolPod('origin');
      vm.show_destination_port = vm.fnCheckToShowPolPod('destination');
     //  making pol/pod data as empty if origin/destination is not a door
      vm.searchParam["user_pol"] = vm.show_origin_port ? vm.searchParam["user_pol"] : [];
      vm.searchParam["user_pod"] = vm.show_destination_port ? vm.searchParam["user_pod"] : [];
      if(!vm.isMultiPort && !vm.isMultiDoor && (params ==='origin_location' || params ==='destination_location' )){
        vm.fnPrefillNearbyPortData('' , params ==='origin_location' ? 'nearbyOrigin' : 'nearbyDestination');
      }
    }

    function makeLoadBoxString() {
      vm.LoadBoxString = '';
      vm.LoadTooltipString = '';
      vm.loadArray.forEach(function (i, k) {
        if (i.type) {
          vm.LoadBoxString = vm.LoadBoxString + (vm.LoadBoxString === '' ? '' : ', ') + i.type + ' x' + (i.count || 0);
          vm.LoadTooltipString = vm.LoadTooltipString + (vm.LoadTooltipString === '' ? '' : '\n') + i.type + ' x' + (i.count || 0);
        }
      });
    }

    function makeDetailBoxString() {
      if(vm.searchParam.inco_term && vm.searchParam.impo_expo && $rootScope.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !vm.util.isShipper){
        vm.detailBoxString = vm.searchParam.inco_term+ '-' +vm.searchParam.impo_expo;
      }else{
        vm.detailBoxString = ((vm.searchParam.pickup_selected && vm.is_independent_search ? 'Pickup, ' : '') + (vm.searchParam.freight_charges ? 'Freight, ' : '') + (vm.searchParam.origin_charges ? 'Origin, ' : '') + (vm.searchParam.origin_customs ? 'Origin Custom, ' : '') + (vm.searchParam.destination_charges ? 'Destination, ' : '') + (vm.searchParam.destination_customs ? 'Destination Custom, ' : '') + (vm.searchParam.delivery_selected && vm.is_independent_search ? 'delivery, ' : '') + (vm.mode === 'SEA-FCL' ? (vm.searchParam.stuffing === 'F' ? 'Factory Stuffing' : 'Dock Stuffing') : '')) || 'Select Charges';

        vm.detailBoxTooltip = ((vm.searchParam.pickup_selected && vm.is_independent_search ? 'Pickup\n' : '') + (vm.searchParam.freight_charges ? 'Freight\n' : '') + (vm.searchParam.origin_charges ? 'Origin\n' : '') + (vm.searchParam.origin_customs ? 'Origin Custom\n' : '') + (vm.searchParam.destination_charges ? 'Destination\n' : '') + (vm.searchParam.destination_customs ? 'Destination Custom\n' : '') + (vm.searchParam.delivery_selected && vm.is_independent_search ? 'delivery\n' : '') + (vm.mode === 'SEA-FCL' ? (vm.searchParam.stuffing === 'F' ? 'Factory Stuffing' : 'Dock Stuffing') : '')) || 'Select Charges';

        vm.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;
      }
      

    }

    function getLoadList() {
      if (SearchService.loadTypeArr == undefined || SearchService.loadTypeArr.length == 0) {
        SearchService.getAllLoadList().then(function (response) {
          SearchService.loadTypeArr = response;
          vm.loadTypeArr = response;
          util.limitObj = response;
        }, function (error) {
          $log.log(error.data);
        });
      } else {
        vm.loadTypeArr = SearchService.loadTypeArr != undefined ? SearchService.loadTypeArr : [];
      }
    }

    function getEmptySearchParam() {
      if (!SearchService.emptySearchParam) {
        SearchService.getEmptySearchParam().then(function (response) {
          SearchService.emptySearchParam = response.data
          vm.emptySearchParam = SearchService.emptySearchParam;
        }, function (error) {
          $log.log(error.data);
        });
      } else {
        vm.emptySearchParam = SearchService.emptySearchParam;
      }
    }

    function updateLoadArray() {
      vm.loadArray.forEach(function (load) {
        load.bl_qty = vm.searchParam.load_data.load_details_value[0].bl_qty;
        load.sbl_qty = vm.searchParam.load_data.load_details_value[0].sbl_qty;
      });
    }

    function fnchangeSalesPerson(type,searchQuery) {
      if(!vm.searchParam.sales_user){
        vm.searchParam.shipper_user = null;
        return;
      }
      if(vm.selectListShow && type !== 'init'){
        return true;
      }
      if(util.shipperList.length && util.selectedSalesPerson.id === vm.searchParam.sales_user.id ){
       vm.selectList = angular.copy(util.shipperList);
       return true;
      }

      vm.selectListShow = true;
      var url = api.baseUrl + '/api/get-shippers?limit=30&offset=0&salesperson_id=' + vm.searchParam.sales_user.id;
      SearchService.getShipperList(url).then(function (response) {
        vm.selectListShow = false;
        vm.selectList = response.data.data;
        vm.shipperListCount = response.data.count;
        util.shipperList = angular.copy(vm.selectList);
        util.selectedSalesPerson = angular.copy(vm.searchParam.sales_user);
        if (type !== 'init') {
          vm.searchParam.shipper_user = null;
        }
      }, function (error) {
        vm.selectListShow = false;
        vm.selectList = null;
        $log.log(error.data);
      });
    }

    function getShipperCompany(searchText) {
      var deferred = $q.defer();
      if ( ( vm.selectList.length && (vm.lastShipperSearchText === searchText &&  vm.searchParam.sales_user && util.selectedSalesPerson.id === vm.searchParam.sales_user.id))  || (vm.selectList.length && vm.searchParam.sales_user === null)) {
        $timeout(function() {
            deferred.resolve(vm.selectList);
        }, 1000);
        
        return deferred.promise;
    }
      var offset = 0;
      var url = api.baseUrl + '/api/get-shippers?limit=30&offset=' + offset;
      if(searchText) {
        url += '&query=' + searchText;
      }
      if(vm.searchParam.sales_user && vm.searchParam.sales_user.id){
        url += '&salesperson_id=' + vm.searchParam.sales_user.id;
      }
      SearchService.getShipperList(url).then(function (response) {
        vm.selectList = response.data.data;
        util.selectedSalesPerson = angular.copy(vm.searchParam.sales_user);
        vm.lastShipperSearchText = searchText;
        deferred.resolve(vm.selectList);
      }, function (error) {
        vm.lastShipperSearchText = "";
        $log.log(error.data);
      });
      return deferred.promise;
    }

    function setLoadValidity() {
      var loadHasError = false;

      loadHasError = vm.loadArray.some(function (load, key) {
        if (!load.type || !load.count || !load.weight_qty) {
          return true;
        }
      });

      if (loadHasError) {
        vm.searchBarForm.$error.loadError = true;
      } else if (vm.searchBarForm.$error.loadError) {
        delete vm.searchBarForm.$error.loadError;
      }
    }

    function setChargeValidityFCL() {
      if (!vm.searchParam.load_data.load_details_value[0].bl_qty || !vm.searchParam.load_data.load_details_value[0].sbl_qty) {
        vm.searchBarForm.$error.chargeError = true;
      } else if (vm.searchBarForm.$error.chargeError) {
        delete vm.searchBarForm.$error.chargeError;
      }
    }

    function setChargeValidity() {
      if (!vm.searchParam.load_data.load_meta.total_bl || !vm.searchParam.load_data.load_meta.total_sbl || (vm.searchParam.mode === 'SEA-LCL' && !vm.searchParam.load_data.load_meta.total_pallets)) {
        vm.searchBarForm.$error.chargeError = true;
      } else if (vm.searchBarForm.$error.chargeError) {
        delete vm.searchBarForm.$error.chargeError;
      }
    }

    function setLoadDetailValidity() {
      if ((vm.searchParam.load_data.load_type === 'total_shipment' && (!vm.searchParam.load_data.load_meta.total_qty || !vm.searchParam.load_data.load_meta.total_volume || !vm.searchParam.load_data.load_meta.total_weight)) || (vm.searchParam.load_data.load_type === 'units' && unitLoadHasError())) {
        vm.searchBarForm.$error.loadDetailError = true;
      } else if (vm.searchBarForm.$error.loadDetailError) {
        delete vm.searchBarForm.$error.loadDetailError;
      }

      function unitLoadHasError() {
        return vm.searchParam.load_data.load_details_value.some(function (load) {
          return !load.breadth || !load.height || !load.length || !load.qty || !load.weight;
        });
      }
    }

    
    function submitSearchForm(event) {
      var searchFormValidations = {
         'Origin':'',
         'CutOff Date':'',
         'Destination':'',
         'Load Type':'',
         'Local and Customs':'',
         'Sales Person':'',
         'Customer Details':''
          
      }
      vm.formSubmit = true;
      // console.log("search clicked", event);
      var todayDate = new Date();
      todayDate.setHours(0,0,0,0);
      vm.searchParam['user_timezone_id'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      vm.polValidation = false;
      vm.podValidation = false;
      if(vm.mode === "SEA-FCL" && !vm.isShipper ){
        if(vm.isCarrierSelection){
          // if(vm.isCarrierSelection && vm.carrierSelectionConfig.required && !vm.selectedCarrierOption.length){
          //   vm.carrierSelectionError = true;
          //   return
          // }
          // else{
          //   vm.carrierSelectionError = false;
          // }
          for(var key in vm.carrierSelectionList){
            if(Array.isArray(vm.carrierSelectionList[key]))
            vm.carrierSelectionList[key].forEach(function(value){
              delete value.code;
              delete value.uniqueId;
              delete value.$$hashKey;
            })
          }
          vm.searchParam["selected_carrier"]=vm.carrierSelectionList;
          for(var key in vm.carrierList.data.carrier_mappings.FCL){
            vm.searchParam["selected_carrier"]["all_"+key] = vm.carrierList.data.carrier_mappings.FCL[key].selectAll;
          }
        }
     
      }
       if (vm.mode === "SEA-FCL") {
         if (vm.viewToggleOrigin == "door") {
           vm.searchParam["origin_service_mode"] = "SD";
         } else if (vm.includeSdOrigin && vm.viewToggleOrigin == "port") {
           vm.searchParam["origin_service_mode"] = "CY/SD";
         } else {
           vm.searchParam["origin_service_mode"] = "CY";
         }
         if (vm.viewToggleDestination == "door") {
           vm.searchParam["destination_service_mode"] = "SD";
         } else if (
           vm.includeSdDestination &&
           vm.viewToggleDestination == "port"
         ) {
           vm.searchParam["destination_service_mode"] = "CY/SD";
         } else {
           vm.searchParam["destination_service_mode"] = "CY";
         }
       }
      //it's checking selected "cargo_ready_date" is past date or not
      if(vm.searchParam.cargo_ready_date < vm.cargoMinDate){
        vm.searchBarForm.cargo_ready_date.$error.mindate = true;
        searchFormValidations['CutOff Date']='Invalid';
        return false;
      }

      if (vm.mode === 'SEA-FCL') {
        vm.searchParam.load_data = util.formFclSearchData(vm.searchParam.load_data, vm.loadArray);
      } else {
        setLoadDetailValidity();
      }

      if(vm.searchConfig && vm.searchConfig.sales_person && vm.searchConfig.sales_person.required && !vm.searchParam.sales_user && !util.isShipper){
        util.showToast('Please select sales person!');
        searchFormValidations['Sales Person']='Required';
        return;
      }

     if(vm.searchConfig && vm.searchConfig.shipper_email && vm.searchConfig.shipper_email.required && !vm.searchParam.shipper_user && !util.isShipper){
        util.showToast('Please enter customer details!');
        searchFormValidations['Customer Details']='Required';
        return;
      }
      if(vm.searchBarForm.nearby_origin_ports && vm.searchParam.user_pol.length > vm.originPortLimit){
        vm.searchBarForm.nearby_origin_ports.$error.maxchips= true;
        return;
      }
      if(vm.searchBarForm.nearby_destination_ports && vm.searchParam.user_pod.length > vm.destinationPortLimit){
        vm.searchBarForm.nearby_destination_ports.$error.maxchips= true;
        return;
      }
      if(vm.searchParam['nearby_origin'].length > vm.originNearbyPortLimit && vm.searchParam.fetch_nearby_origin){
        vm.searchBarForm.nearby_origin.$error.maxchips= true;
        return;
      }
      if(vm.searchParam['nearby_destination'].length > vm.destinationNearbyPortLimit && vm.searchParam.fetch_nearby_destination){
        vm.searchBarForm.nearby_destination.$error.maxchips= true;
        return;
      }
     

      if (Object.keys(vm.searchBarForm.$error).length || ((vm.isMultiPort || vm.isMultiDoor) && (!vm.searchParam.user_nearby_origin.length || !vm.searchParam.user_nearby_destination.length))) {
        searchFormValidations['Origin']= vm.isMultiPort || vm.isMultiDoor ? (!vm.searchParam.user_nearby_origin.length ? 'Required' :'') : (!vm.searchParam.origin_location ? 'Required' :'');
        searchFormValidations['Destination']=  vm.isMultiPort || vm.isMultiDoor ? (!vm.searchParam.user_nearby_destination.length ? 'Required' :'') : (!vm.searchParam.destination_location ? 'Required' :'') ;
        return;
      }

      if(!vm.validateLC()){
        searchFormValidations['Local and Customs']='Invalid';
        return;
      }

      checkForMultiPort();

      // vm.searchParam.origin_port = vm.searchParam.origin_location;
      // vm.searchParam.destination_port = vm.searchParam.destination_location;
      vm.searchParam.cargo_ready_date = $filter('date')(vm.searchParam.cargo_ready_date, 'yyyy-MM-dd');
      if (vm.isStateResult && angular.equals(appCache.get('verificationsearchParam'), vm.searchParam)) {
        util.showToast('No changes made');
        vm.searchParam.cargo_ready_date =  moment(vm.searchParam.cargo_ready_date, 'YYYY-MM-DD').toDate();
        return;
      }
      vm.polValidation = (vm.enabled_pol_pod && ( vm.searchParam.origin_location.place_type == 'Door' || (vm.searchParam.user_nearby_origin &&  vm.searchParam.user_nearby_origin.length && vm.searchParam.user_nearby_origin[0].placeType== 'Door')) && !vm.searchParam["user_pol"].length);
      vm.podValidation = (vm.enabled_pol_pod && ( vm.searchParam.destination_location.place_type == 'Door'|| ((vm.searchParam.user_nearby_origin &&  vm.searchParam.user_nearby_origin.length && vm.searchParam.user_nearby_origin[0].placeType== 'Door'))) && !vm.searchParam["user_pod"].length);
      vm.nearByOriginValidation= vm.mode != 'AIR' && vm.enabled_nearby && vm.searchParam.fetch_nearby_origin && !vm.searchParam['nearby_origin'].length
      vm.nearByDestinationValidation= vm.mode != 'AIR' && vm.enabled_nearby && vm.searchParam.fetch_nearby_destination && !vm.searchParam['nearby_destination'].length
        if(vm.nearByOriginValidation || vm.nearByDestinationValidation){
          return
           }
      if(vm.mode === 'SEA-FCL' && (vm.polValidation || vm.podValidation || vm.duplicatePortValidation ) ){
        return;
      }
      vm.searchParam.origin_input_text = vm.searchOrgText;
      vm.searchParam.destination_input_text = vm.searchDestText;

      if(vm.resultcardfilter){
        vm.resultcardfilter["isSearchUpdate"] = true;
        vm.resultcardfilter["countApiCard"] = 1;
      }
      //if domain config is false making pol and pod as empty to ignore the previous data 
      if(!vm.enabled_pol_pod && vm.mode === 'SEA-FCL'){
        vm.searchParam["user_pol"] = [];
        vm.searchParam["user_pod"] = [];
      }
      if( vm.mode != 'AIR' && !vm.enabled_nearby){
        vm.searchParam.fetch_nearby_destination=false;
        vm.searchParam.fetch_nearby_origin=false;
        vm.searchParam['nearby_destination'] = [];
        vm.searchParam['nearby_origin'] = [];
      }
      if( !(vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length) || (!(vm.isMultiDoor || vm.isMultiPort)) )
     {
       vm.searchParam.user_nearby_origin = [];
       vm.searchParam.user_nearby_origin.push(vm.searchParam.origin_location);
     }
     if(  !(vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length) || (!(vm.isMultiDoor || vm.isMultiPort)))
     {
       vm.searchParam.user_nearby_destination = [];
       vm.searchParam.user_nearby_destination.push(vm.searchParam.destination_location);
     }
     if( vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length ){
      vm.searchParam.origin_location = vm.searchParam.user_nearby_origin[0];
    }
    if(vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length){
        vm.searchParam.destination_location = vm.searchParam.user_nearby_destination[0];
    }
    vm.searchParam.search_name = (vm.searchParam.search_name ? vm.searchParam.search_name : vm.searchParam.origin_location.location + ' to ' + vm.searchParam.destination_location.location + ' / ' + $filter('date')(vm.searchParam.cargo_ready_date, 'd MMM yyyy'));
    if(!vm.searchParam.search_name){
      util.showToast('Please enter valid search name!');
      return;
    }
    vm.copySearchParam=angular.copy(vm.searchParam);
    if(vm.copySearchParam['nearby_origin'] && vm.copySearchParam['nearby_origin'].length &&  vm.mode != 'AIR'){
    
      vm.copySearchParam.user_nearby_origin=vm.copySearchParam.user_nearby_origin.concat(vm.copySearchParam['nearby_origin'])
      delete vm.copySearchParam['nearby_origin']
      
    }
    if(vm.copySearchParam['nearby_destination'] && vm.copySearchParam['nearby_destination'].length &&  vm.mode != 'AIR'){
      vm.copySearchParam.user_nearby_destination=vm.copySearchParam.user_nearby_destination.concat(vm.copySearchParam['nearby_destination'])
      delete vm.copySearchParam['nearby_destination']
    }
 

      vm.callback({
        payload: refinePayload(vm.copySearchParam, vm.mode)
      });
      closeSearchBarResult(event);
    }

    function checkForMultiPort(){
      if(vm.isMultiPort || vm.isMultiDoor){
        vm.searchParam.origin_location = vm.searchParam.user_nearby_origin[0];
        vm.searchParam.destination_location = vm.searchParam.user_nearby_destination[0];
        if(!vm.searchParam.search_name){
          var searchStr = '';
          var originPorts=  ScheduleSearchService.getCommaSeparatedData(vm.searchParam.user_nearby_origin,'location');
          var destinationPorts=  ScheduleSearchService.getCommaSeparatedData(vm.searchParam.user_nearby_destination,'location');
          searchStr =  originPorts+' to '+destinationPorts;
          vm.searchParam.search_name = searchStr.trim()+ ' / ' + $filter('date')(vm.searchParam.cargo_ready_date, 'd MMM yyyy');
        }
      }
    }

    function refinePayload(data, mode) {
      var payload;
      if (mode === 'SEA-FCL') {
        payload = reduceSearchParam(vm.emptySearchParam.search_param_fcl, data);
      } else if (mode === 'SEA-LCL') {
        payload = reduceSearchParam(vm.emptySearchParam.search_param_lcl, data);
      } else {
        payload = reduceSearchParam(vm.emptySearchParam.search_param_air, data);
      }
      return payload;
    }

    function reduceSearchParam(srcObj, destObj) {
      var objToReturn = {};
      for (var key in srcObj) {
        if (destObj.hasOwnProperty(key) && srcObj.hasOwnProperty(key)) {
          objToReturn[key] = destObj[key];
        }
      }
      return objToReturn;
    }

    // function fetchNearBy(origin, mode, input_type, cargo_date, destination) {
    //   analytics.track("Cut off date", {
    //     "Mode": mode
    //   });
      // if (origin && origin.place_type == 'Door' && (input_type == 'cargo_date' || input_type == 'origin')) {
        // var data = {
        //   "data": {
        //     "location": origin.location,
        //     "input_type": 'origin',
        //     "cargo_ready_date": cargo_date,
        //     "mode": mode,
        //     "nearby_port_limit": 0,
        //     "location_id": origin._id,
        //     "vendor_id": origin.vendor_id,
        //     "location_pincode": origin.pin_code_ui,
        //     "country_code": origin.country_code
          // }
        // }
        // SearchService.fetchNearbyRates(data);
      // }
      // if (destination && destination.place_type == 'Door' && (input_type == 'cargo_date' || input_type == 'destination')) {
      //   var data = {
      //     "data": {
      //       "location": destination.location,
      //       "input_type": 'destination',
      //       "cargo_ready_date": cargo_date,
      //       "mode": mode,
      //       "nearby_port_limit": 0,
      //       "location_id": destination._id,
      //       "vendor_id": destination.vendor_id,
      //       "location_pincode": destination.pin_code_ui,
      //       "country_code": destination.country_code
      //     }
      //   }
        // SearchService.fetchNearbyRates(data);
      // }
    // }

    function showLoadAlias(ev){
      var position = vm._mdPanel.newPanelPosition()
      .relativeTo(".load-alias")
      .addPanelPosition(vm._mdPanel.xPosition.CENTER, vm._mdPanel.yPosition.ABOVE);

      var config ={
        attachTo: angular.element(document.body),
        templateUrl: "app/main/component/load-alias/load-alias.html",
        bindToController: true,
        controller: "LoadAliasController",
        controllerAs: "ctrl",
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        
      };
      vm._mdPanel.open(config);   
      
    };

    function showLoadPanel(ev) {
      var position = vm._mdPanel.newPanelPosition()
        .relativeTo('.panel-select-load')
        .addPanelPosition(vm._mdPanel.xPosition.CENTER, vm._mdPanel.yPosition.BELOW);

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: 'app/main/component/load-selector/load-select-wrapper.html',
        controllerAs: 'ctrl',
        controller: 'LoadWrapperController',
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          'resetLoadObj': vm.resetLoadObj,
          'loadTypeArr': vm.loadTypeArr,
          'mode': vm.mode,
          'type':vm.pageSource
        },
        onOpenComplete: function () {
          loadDataFactory.panelClosed = false;
        },
        onRemoving: function () {
          vm.loadArray = loadDataFactory.loadData;
          loadDataFactory.panelClosed = true;
          setLoadValidity();
          makeLoadBoxString();
          updateLoadArray();
        }
      };
      vm.formIsPristine = false;
      loadDataFactory.loadData = vm.loadArray;
      vm._mdPanel.open(config);
    };

    function showChargePanel(ev) {
      var position = vm._mdPanel.newPanelPosition()
        .relativeTo('.panel-select-charge')
        .addPanelPosition(vm._mdPanel.xPosition.ALIGN_END, vm._mdPanel.yPosition.BELOW);

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: 'app/main/component/charge-selector/charge-select.html',
        controllerAs: 'ctrl',
        controller: 'ChargeSelectController',
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          'searchParam': vm.searchParam,
          'searchMode': vm.mode,
          'pageSource':vm.pageSource,
          'is_independent_search':vm.is_independent_search
        },
        onRemoving: function () {
          makeDetailBoxString();
          if (vm.mode === 'SEA-FCL') {
            setChargeValidityFCL();
            updateLoadArray();
          } else {
            setChargeValidity();
            vm.searchParam.load_data = (vm.mode === 'AIR' ? SearchService.calculateAirLoad(vm.searchParam.load_data) : SearchService.calculateLclLoad(vm.searchParam.load_data));
          }

        }
      };
      vm.formIsPristine = false;
      appCache.put('searchParam', vm.searchParam);
      vm._mdPanel.open(config);
    };

    function showLoadDetailPanel(ev) {
      var position = vm._mdPanel.newPanelPosition()
        .relativeTo('.panel-select-load-detail')
        .addPanelPosition(vm._mdPanel.xPosition.ALIGN_END, vm._mdPanel.yPosition.BELOW);

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: 'app/main/component/load-detail-selector/load-detail-selector.html',
        controllerAs: 'ctrl',
        controller: 'LoadDetailController',
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          'searchParam': vm.searchParam,
          'searchForm': vm.searchBarForm,
          'type':vm.pageSource
        },
        onRemoving: function () {
          setLoadDetailValidity();
        }
      };
      vm.formIsPristine = false;
      appCache.put('searchParam', vm.searchParam);
      vm._mdPanel.open(config);
    }

    Date.prototype.addDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    }

    function goBack() {
      $state.go('app.search');
      // $window.history.back();
    }

    function fnEditSearch() {
      vm.editSearch = true;
      vm.toggleFormForResult();
    }

    function submitScheduleForm(origin, destination) {

       // check if data is empty
       if (Object.keys(vm.searchBarForm.fcl_origin_port.$error).length  || Object.keys(vm.searchBarForm.fcl_destination_port.$error).length || Object.keys(vm.searchBarForm.cargo_ready_date.$error).length) {
        return;
      }

      // it's multiple ports for origin and destination ports
      var origin_portcode = '';
      var destination_portcode = '';
      if(vm.isMultiPort){
        if(!vm.searchParam.user_nearby_origin.length || !vm.searchParam.user_nearby_destination.length){
          return
        }
        if(vm.searchParam.user_nearby_origin[0].place_type == 'Door' || vm.searchParam.user_nearby_destination[0].place_type == 'Door') {
          util.showToast('Only the ports at the origin and destination are included in the schedule search');
          return;
        }
        origin_portcode = ScheduleSearchService.getCommaSeparatedData(vm.searchParam.user_nearby_origin,'global_port_code');
        destination_portcode = ScheduleSearchService.getCommaSeparatedData(vm.searchParam.user_nearby_destination,'global_port_code');
        origin = vm.searchParam.user_nearby_origin;
        destination = vm.searchParam.user_nearby_destination;

      }
      // single PORT search but passing values in array due to multi door enabled
      else if(!vm.isMultiPort && vm.isMultiDoor){
        if(vm.searchParam.user_nearby_origin[0].place_type == 'Door' || vm.searchParam.user_nearby_destination[0].place_type == 'Door') {
          util.showToast('Only the ports at the origin and destination are included in the schedule search');
          return;
        }
        origin_portcode = vm.searchParam.user_nearby_origin[0].global_port_code;
        destination_portcode = vm.searchParam.user_nearby_destination[0].global_port_code;
        // passing object from array if multi port not enabled
        origin = vm.searchParam.user_nearby_origin[0];
        destination = vm.searchParam.user_nearby_destination[0];
      }
      else{
        if((origin && origin.place_type == 'Door') || (destination && destination.place_type == 'Door')) {
          util.showToast('Only the ports at the origin and destination are included in the schedule search');
          return;
        }
        origin_portcode = origin.global_port_code;
        destination_portcode = destination.global_port_code;
      }

      vm.searchParam.cargo_ready_date = $filter('date')(vm.searchParam.cargo_ready_date, 'yyyy-MM-dd');
      var range = 2;
      var page = "search";
      var scheduleSearchData = {
        'origin':origin_portcode,
        'Destination':destination_portcode,
        'Cutoff Date':vm.searchParam.cargo_ready_date
       }
      // var origin_text = vm.searchParam.origin_location;
      // var destination_text = vm.searchParam.destination_location;
      util.isCallingApi = true;
      ScheduleSearchService.getScheduleSearch(origin_portcode, destination_portcode, vm.searchParam.cargo_ready_date,range, page, origin, destination, vm.isMultiPort).then(function(response){
        // $state.go('app.scheduleSearch');
        util.isCallingApi = false;
        return response;
      },function(error){
        util.isCallingApi = false;
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }

    function trackEvent(type,searchQuery,eventName) {
      if(type === 'edit') {
        util.callMixpanel("RR-EditMeta-Click", {
          "Mode": vm.mode
        });
      }

      if(type === 'hide') {
        util.callMixpanel( "RR-HideDetails-Click", {
          "Mode": vm.mode
        });
      }
      if(type=='common'){
        util.callMixpanel(vm.pageSource+'-'+eventName, {
          "Mode": vm.mode,
        });
      }

    }
 
    function checkForDuplicatePorts(chips,source,otherPort){
      vm.portExistIn = '';
      if(chips){
        // removing pol/pod validation if data present
        vm.polValidation = (source == 'originPort') ? false : vm.polValidation ;
        vm.podValidation = (source == 'destinationPort') ? false : vm.podValidation;
        if(!vm.isMultiPort &&  !vm.isMultiDoor){
          vm.searchParam.user_nearby_origin = [];
          vm.searchParam.user_nearby_destination = [];
          if(vm.searchParam.origin_location){
            vm.searchParam.user_nearby_origin[0]=vm.searchParam.origin_location;
          }
          if(vm.searchParam.destination_location){
            vm.searchParam.user_nearby_destination[0]=vm.searchParam.destination_location;
          }
        }
        fnPrefillPolPodData(chips , source);
       
       
        // checking duplicate ports in same fields
          var nearByPortType = source.endsWith('Port') ? (source === 'originPort'? vm.searchParam.user_pol :vm.searchParam.user_pod) : (source === 'origin' ? vm.searchParam.user_nearby_origin :source === 'destination' ? vm.searchParam.user_nearby_destination:[]);
          var checkDuplicatePort = nearByPortType.findIndex(function (item) {
            if(item && item.place_type != 'Door'){
            return item.portcode_portname === chips.portcode_portname;
            }
          });
          var checkSameDuplicateDoor = nearByPortType.findIndex(function (item) {
            if(item && item.place_type === 'Door'){
              return item._id === chips._id;
            }
          });
         
        // checking duplicate ports in other fields
          if(source.startsWith('origin') ){
            if( vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length){
            var originDetails =  (vm.searchParam.user_nearby_destination[0].place_type == 'Door' && vm.enabled_pol_pod) ? vm.searchParam.user_pod : vm.searchParam.user_nearby_destination ;
            vm.portExistIn = (vm.searchParam.user_nearby_destination[0].place_type == 'Door' && vm.enabled_pol_pod) ? 'destination CY' : 'destination' ;
            var checkDuplicateOtherPort = originDetails.findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
       
          }     
          if( vm.searchParam['nearby_origin'] && vm.searchParam['nearby_origin'].length){
           
             var checkDuplicateNearBY= vm.searchParam['nearby_origin'].findIndex(function (item) {
               return item.portcode_portname === chips.portcode_portname;
             });
             if(checkDuplicateNearBY >= 0){
            vm.portExistIn ='Origin Nearby CY'
            vm.checkOtherPort = source;
            return null;
            }
           
         } 
         if (vm.searchParam['nearby_destination'] && vm.searchParam['nearby_destination'].length){
         
          var checkDuplicateNearBY= vm.searchParam['nearby_destination'].findIndex(function (item) {
            return item.portcode_portname === chips.portcode_portname;
          });
          if(checkDuplicateNearBY >= 0){
            vm.portExistIn ='Destination Nearby CY'
            vm.checkOtherPort = source;
            return null;
            }
          } 
        }
          if(source.startsWith('destination') ){
            if( vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length){
            var destinationDetails =  (vm.searchParam.user_nearby_origin[0].place_type == 'Door' && vm.enabled_pol_pod) ? vm.searchParam.user_pol : vm.searchParam.user_nearby_origin;
            vm.portExistIn = (vm.searchParam.user_nearby_origin[0].place_type == 'Door' && vm.enabled_pol_pod) ? 'origin CY' : 'origin';
            var checkDuplicateOtherPort = destinationDetails.findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
          }    
          if (vm.searchParam['nearby_destination'] && vm.searchParam['nearby_destination'].length){
           
            var checkDuplicateNearBY= vm.searchParam['nearby_destination'].findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
            if(checkDuplicateNearBY >= 0){
             vm.portExistIn ='Destination Nearby CY'
             vm.checkOtherPort = source;
             return null;
            }
            }  
            if( vm.searchParam['nearby_origin'] && vm.searchParam['nearby_origin'].length){
             
               var checkDuplicateNearBY= vm.searchParam['nearby_origin'].findIndex(function (item) {
                 return item.portcode_portname === chips.portcode_portname;
               });
               if(checkDuplicateNearBY >= 0){
                vm.portExistIn ='Origin Nearby CY'
                vm.checkOtherPort = source;
                return null;
               }
             
           } 
        }
            // checking duplicate ports in other fields
            if(source.startsWith('origin') && vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length){
              if(vm.searchParam.user_nearby_destination[0].place_type == 'Door'){
                vm.doorExistIn = 'destination' ;
                var checkDuplicateDoor = vm.searchParam.user_nearby_destination.findIndex(function (item) {
                  return item._id === chips._id;
                });
              }
            }   
            if(source.startsWith('destination') && vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length){
              if(vm.searchParam.user_nearby_origin[0].place_type == 'Door')
              {
                vm.doorExistIn = 'origin' ;

                var checkDuplicateDoor= vm.searchParam.user_nearby_origin.findIndex(function (item) {
                  return item.portcode_portname === chips.portcode_portname;
                });
              }
           }  
            if(source ==='nearbyOrigin' ){
              if (vm.searchParam['nearby_destination'] && vm.searchParam['nearby_destination'].length){
               
                var checkDuplicateNearBY= vm.searchParam['nearby_destination'].findIndex(function (item) {
                  return item.portcode_portname === chips.portcode_portname;
                });
                if(checkDuplicateNearBY >= 0){
                  vm.portExistIn ='Destination Nearby CY'
                  vm.checkOtherPort = source;
                  return null;
              }
                }  
                if (vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length){
                
                  var checkDuplicateOtherPort= vm.searchParam.user_nearby_origin.findIndex(function (item) {
                    return item.portcode_portname === chips.portcode_portname;
                  });
                  if(checkDuplicateOtherPort >= 0){
                      vm.portExistIn ='Origin'
                      vm.checkOtherPort = source;
            return null;
                  }
                  }  
                  if (vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length){
                   
                    var checkDuplicateOtherPort= vm.searchParam.user_nearby_destination.findIndex(function (item) {
                      return item.portcode_portname === chips.portcode_portname;
                    });
                    if(checkDuplicateOtherPort >= 0){
                     vm.portExistIn ='Destination'
                     vm.checkOtherPort = source;
                    return null;
                  }
                    }  
             
            var checkDuplicateSameNearBY=vm.searchParam['nearby_origin'].findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
           }
            if(source ==='nearbyDestination'){ 
              if( vm.searchParam['nearby_origin'] && vm.searchParam['nearby_origin'].length){
             
              var checkDuplicateNearBY= vm.searchParam['nearby_origin'].findIndex(function (item) {
                return item.portcode_portname === chips.portcode_portname;
              });
              if(checkDuplicateNearBY >= 0){
                
              vm.portExistIn ='Origin Nearby CY'
              vm.checkOtherPort = source;
              return null;
                
               }
            
          }  
          if (vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length){
            
            var checkDuplicateOtherPort= vm.searchParam.user_nearby_destination.findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
            if(checkDuplicateOtherPort >= 0){
              
             vm.portExistIn ='Destination'
             vm.checkOtherPort = source;
             return null;
             
            }
            }  
            if (vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length){
             
              var checkDuplicateOtherPort= vm.searchParam.user_nearby_origin.findIndex(function (item) {
                return item.portcode_portname === chips.portcode_portname;
              });
              if(checkDuplicateOtherPort >= 0){
                vm.portExistIn ='Origin'
                vm.checkOtherPort = source;
            return null;
                  
                 }
            
              }  
          var checkDuplicateSameNearBY=vm.searchParam['nearby_destination'].findIndex(function (item) {
            return item.portcode_portname === chips.portcode_portname;
          });
        }
          
          $timeout(function () {
            vm.checkExistingPort = null;
            vm.checkExistingDoor = null;
            vm.checkOtherPort = null;
          },3000)
          if(checkDuplicatePort >= 0){
           
           
            vm.checkExistingPort = source;
            return null;
          }
          if(checkDuplicateDoor >= 0){
            vm.checkExistingDoor = source;
            return null;
          }
          if(checkSameDuplicateDoor >= 0){
            vm.checkExistingDoor = source;
            return null;
          }
          if(checkDuplicateOtherPort >= 0){
            vm.checkOtherPort = source;
            return null;
          }
          if(checkDuplicateNearBY >= 0){
           
            vm.checkOtherPort = source;
            return null;
          }
          if(checkDuplicateSameNearBY >= 0){
            vm.checkExistingPort = source;
            return null;
          }
          if( source.startsWith('origin')  || source.startsWith('destination')){
            fnPrefillNearbyPortData(chips , source.startsWith('origin') ? 'nearbyOrigin' : 'nearbyDestination');
            }
        }
      
    }

    // function to check if incoterm or any leg is selected or not
    function validateLC(){
      if(!vm.searchParam){
        return true;
      }else {
        var isOtherLegSelected = vm.searchParam.freight_charges || vm.searchParam.origin_charges || vm.searchParam.origin_customs|| vm.searchParam.destination_charges|| vm.searchParam.destination_customs;

        vm.is_independent_search_error = vm.is_independent_search && vm.searchParam.pickup_selected && vm.searchParam.delivery_selected && !vm.searchParam.freight_charges ? 'Select Freight section for Door to Door inputs':'';

        // check either incoterm and for local n custom, if D2D then other leg should be selected
        return ((vm.searchParam.inco_term && $rootScope.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !vm.util.isShipper) || (vm.is_independent_search && vm.searchParam.pickup_selected && vm.searchParam.delivery_selected ? vm.searchParam.freight_charges : (!vm.is_independent_search? isOtherLegSelected : (vm.searchParam.pickup_selected || isOtherLegSelected || vm.searchParam.delivery_selected))));
      }
    }

    function fnRemovePortChip(chip , routeType){
    // removing errors while removing the chips/port 
    if(routeType == 'origin_location'){
      if(vm.searchBarForm.nearby_origin_ports){
      vm.searchBarForm.nearby_origin_ports.$error.maxchips = false ; 
      }
    }else if(routeType == 'destination_location'){
      if(vm.searchBarForm.nearby_destination_ports){
      vm.searchBarForm.nearby_destination_ports.$error.maxchips = false; 
      }
    }
    else if(routeType == 'nearby_origin'){
      vm.searchBarForm.nearby_origin.$error.maxchips = false; 
      vm.nearByOriginValidation=false;
    }
    else if(routeType == 'nearby_destination'){
      vm.searchBarForm.nearby_destination.$error.maxchips = false; 
      vm.nearByDestinationValidation=false;
    }
    if((routeType == 'origin_location' || routeType == 'destination_location') && !vm.isMultiPort && !vm.isMultiDoor  && vm.searchParam[routeType]){
        if(chip.portcode_portname == vm.searchParam[routeType].portcode_portname){
          vm.duplicatePortValidation = '';
        }

      }else{
            if(routeType == 'origin'){
              if(vm.searchBarForm.user_nearby_origin){
              vm.searchBarForm.user_nearby_origin.$error.maxchips = false;
              }
              vm.polValidation = false;

              if(!(vm.searchParam.user_nearby_origin && vm.searchParam.user_nearby_origin.length)){
                vm.show_origin_port = false ;

                vm.searchParam["user_pol"] = [];

              }

            }else{
              if(routeType == 'destination'){
                if(vm.searchBarForm.nearby_destination_ports){
                vm.searchBarForm.nearby_destination_ports.$error.maxchips = false; 
                }
                vm.podValidation = false;

               if( !(vm.searchParam.user_nearby_destination && vm.searchParam.user_nearby_destination.length)){
     
              vm.show_destination_port = false ; 
              vm.searchParam["user_pod"] = [];
               }
              }
            }
          }
    }

     // function to prefill pod/pol data from API
     function fnPrefillPolPodData(selectedData , routeType){
     if(selectedData.place_type == 'Door' && vm.enabled_pol_pod && vm.mode === 'SEA-FCL'){
          var enabledPort = (routeType == 'origin' || routeType == 'origin_location') ? "user_pol" :"user_pod";
          var leg_code = (enabledPort == 'user_pol') ? 'l1' : 'l5' ;
          var origin_details = [];
          var destination_details = [];
          if(vm.isMultiPort || vm.isMultiDoor){
              origin_details = vm.searchParam.user_nearby_origin.length ? (vm.searchParam.user_nearby_origin[0].place_type == 'Door' ? vm.searchParam.user_pol : vm.searchParam.user_nearby_origin) : [];
              destination_details = vm.searchParam.user_nearby_destination.length ? (vm.searchParam.user_nearby_destination[0].place_type == 'Door' ? vm.searchParam.user_pod : vm.searchParam.user_nearby_destination) : [];
          }else{
              origin_details = vm.searchParam.origin_location ? (vm.searchParam.origin_location.place_type == 'Door' ? vm.searchParam.user_pol : [vm.searchParam.origin_location]) : [];
              destination_details = vm.searchParam.destination_location ? (vm.searchParam.destination_location.place_type == 'Door' ? vm.searchParam.user_pod : [vm.searchParam.destination_location]) : [];
          }

          var isExist = false;
          var isExistInSameLocation = false;
          util.isCallingApi = true;
          var ApiResponse = [];
          vm.util.fnGetPolPod(selectedData , leg_code , vm.mode).then(
              function (response) {
                ApiResponse = response.data.data;
                  // ignoring duplicate ports from other port
                if((origin_details && origin_details.length)  || (destination_details && destination_details.length)){
                  ApiResponse.forEach(function(port_details){
                    isExist = false;
                    isExistInSameLocation = false;
                    if(origin_details && origin_details.length){
                    isExist = origin_details.some(function (other_port_details) {
                      return port_details.portcode_portname === other_port_details.portcode_portname;
                  });
                }
                  if(destination_details && destination_details.length){
                  isExistInSameLocation = destination_details.some(function (other_port_details) {
                    return port_details.portcode_portname === other_port_details.portcode_portname;
                });
              }
                    if(!isExist && !isExistInSameLocation){
                      vm.searchParam[enabledPort].push(port_details);
                    }
                  });
                }else{
                  vm.searchParam[enabledPort] = ApiResponse;
                }
                util.isCallingApi = false;
              },
              function (error) {
                util.isCallingApi = false;
                $log.log(error.data);
              }
      );
    }
  }
  function fnPrefillNearbyPortData(selectedData , routeType){
var nearbySelected = routeType == 'nearbyOrigin' ? vm.searchParam.fetch_nearby_origin : vm.searchParam.fetch_nearby_destination;
var enabledPort = (routeType == 'nearbyOrigin') ? "nearby_origin" :"nearby_destination";
    if(vm.enabled_nearby && vm.mode != 'AIR' && nearbySelected){  
        
        // var leg_code = (enabledPort == 'user_pol') ? 'l1' : 'l5' ;
         var origin_details = [];
         var destination_details = [];
         var selected_origin=[];
         var selected_destination=[];
         origin_details = vm.searchParam['nearby_origin'].length ? vm.searchParam['nearby_origin'] : [];
         destination_details = vm.searchParam['nearby_destination'].length ?   vm.searchParam['nearby_destination'] : [];
         if(vm.isMultiPort || vm.isMultiDoor){
          selected_origin = vm.searchParam.user_nearby_origin.length ? vm.searchParam.user_nearby_origin : [];
          selected_destination = vm.searchParam.user_nearby_destination.length ?  vm.searchParam.user_nearby_destination : [];
           
         }else{
          selected_origin = vm.searchParam.origin_location ?  [vm.searchParam.origin_location] : [];
          selected_destination = vm.searchParam.destination_location ? [vm.searchParam.destination_location] : [];
         }
         var duplicateToCheck = (enabledPort == 'nearby_origin') ? angular.copy(origin_details): angular.copy(destination_details )  ;
         var isExist = false;
         util.isCallingApi = true;
         var ApiResponse = [];
         var data = enabledPort == 'nearby_origin' ? angular.copy(selected_origin): angular.copy(selected_destination)
         selectedData ? data.push(selectedData):''; 
         data.filter(function(obj, index, self){
          index === self.findIndex(function(item)  {
              item.global_port_code === obj.global_port_code
         })
    });
         var payload = vm.formPayload(data);
         vm.util.fnGetNearby(payload).then(
             function (response) {
                response.data.forEach(function(port_details){
                  port_details["input_type"]='nearby_user'
               });
               ApiResponse = response.data
                 // ignoring duplicate ports from other port
               
               if(duplicateToCheck && duplicateToCheck.length){
                 ApiResponse.forEach(function(port_details){
                  
                    isExist = false;
                    isExist = duplicateToCheck.some(function (other_port_details) {
                      return port_details.global_port_code === other_port_details.global_port_code;
                  });
                    if(!isExist){
                      vm.searchParam[enabledPort].push(port_details);
                    }
                  });
                  util.isCallingApi = false;
                }
                else{
                  vm.searchParam[enabledPort] = ApiResponse;
                  util.isCallingApi = false;
                }
              
              },
              function (error) {
                util.isCallingApi = false;
                $log.log(error.data);
              }
      );

    }
   if(!nearbySelected){
    vm.searchParam[enabledPort]=[]
   }
 }
function formPayload(data){
  var payload=[];
  data.forEach(function(item){
      payload.push(item._id);
  });
return {
  'ports': payload
};
}
   // Usual places API call to pol/Pod
   function getPolPodLocation(searchText,mode,searchType,type){
    var placeType = 'P2P';
    return SearchService.getPortsLocation(searchText, mode, searchType, placeType,type);

  }

  function fnCheckToShowPolPod(routeType){
    var searchData = {};
    // storing origin/destination data based multi port condition
    if(vm.isMultiPort || vm.isMultiDoor){
      searchData['origin'] = vm.searchParam.user_nearby_origin[0];
      searchData['destination'] = vm.searchParam.user_nearby_destination[0];
    }else{
      searchData['origin'] = vm.searchParam.origin_location;
      searchData['destination'] = vm.searchParam.destination_location;
    }
    var isShow =(vm.enabled_pol_pod && vm.mode === 'SEA-FCL' && searchData[routeType] && searchData[routeType].place_type ==='Door');
    return isShow;
  }

  function limitedDisplayListOption(carrierSearchText,key){
    if(vm.carrierList.data.carrier_mappings.FCL[key].data.length >= 250){
      var getOptions = !carrierSearchText ? vm.selectedCarrierOption.filter(function(value,index){
        return index < 50 && value.uniqueId.toLowerCase().includes(key);
      }) : [];
      
      var optionListLength = vm.carrierList.data.carrier_mappings.FCL[key].data.length;
      vm.carrierList.data.carrier_mappings.FCL[key].data.length = optionListLength <= 100 ? optionListLength - getOptions.length : 100 - getOptions.length;

      if(!carrierSearchText){
        var optionsDataMerge = angular.copy(getOptions.concat(vm.carrierList.data.carrier_mappings.FCL[key].data));
        vm.carrierList.data.carrier_mappings.FCL[key].data = vm.removeDuplicateOptions(optionsDataMerge,'uniqueId');
      }
    }
  }

  vm.removeDuplicateOptions = function removeDuplicates(array, property) {
    var uniqueArray = [];
    var propertyValues = [];

    for (var i = 0; i < array.length; i++) {
        var value = array[i][property];
        if (propertyValues.indexOf(value) === -1) {
            propertyValues.push(value);
            uniqueArray.push(array[i]);
        }
    }
    return uniqueArray;
  }
  function isStopOriginPortInput(){
    if(vm.searchParam && vm.searchParam.user_nearby_origin.length){
      if(vm.viewToggleOrigin == vm.viewToggleDestination &&vm.searchParam.user_nearby_destination.length>1 && ((vm.viewToggleOrigin== 'port' &&!vm.is_nXn_search) || (vm.viewToggleOrigin== 'door' && !vm.is_door_nXn_search)) )
      {
        return true;
      }else{
        if( vm.searchParam.user_nearby_origin[0].place_type === 'Port' ){
          return (vm.searchParam.user_nearby_origin.length >=1 && !vm.isMultiPort)|| (vm.searchParam.user_nearby_origin.length >= (vm.is_nXn_search ? vm.originMultiPortPairLimit : vm.multiPortPairLimit));
        }
          
        if( vm.searchParam.user_nearby_origin[0].place_type === 'Door' ){
          return (vm.searchParam.user_nearby_origin.length >=1 && !vm.isMultiDoor)|| (vm.searchParam.user_nearby_origin.length >= (vm.is_door_nXn_search ? vm.originMultiDoorLimit : vm.multiDoorLimit));
        }
      }
    }else{
      return false;
    };
  }
  function isStopDestinationPortInput(){
    if( vm.searchParam && vm.searchParam.user_nearby_destination.length){
      if(vm.viewToggleDestination == vm.viewToggleOrigin &&  vm.searchParam.user_nearby_origin.length>1 && ((vm.viewToggleDestination== 'port' &&!vm.is_nXn_search) || vm.viewToggleDestination== 'door' && !vm.is_door_nXn_search ) ){
        return true;
      } else{
    if(vm.searchParam.user_nearby_destination[0].place_type == 'Port') {
      return (vm.searchParam.user_nearby_destination.length >=1 && !vm.isMultiPort) || vm.searchParam.user_nearby_destination.length >= (vm.is_nXn_search ? vm.destinationMultiPortPairLimit : vm.multiPortPairLimit)
    }
    if(vm.searchParam.user_nearby_destination[0].place_type == 'Door') {
      return (vm.searchParam.user_nearby_destination.length >=1 && !vm.isMultiDoor) || vm.searchParam.user_nearby_destination.length >= (vm.is_door_nXn_search ? vm.destinationMultiDoorLimit : vm.multiDoorLimit)
    }
      }   
    }else{
      return false;
    }
  }

  }



})();

(function () {
  'use strict';

  angular
  .module('app.core')
  .component('wlsCardListResult', {
      templateUrl: 'app/main/component/result-card/result-vertical-card.html',
      bindings : {
          searchparam :'=',
          carddata : '=',
          resultfilter : '=',
          callback : '&'
      },
      controller: ResultCardController
  })
  .component('cardListResult', {
      templateUrl: 'app/main/component/result-card/result-horizontal-card.html',
      bindings : {
          searchparam :'=',
          carddata : '=',
          resultfilter : '=',
          index:'=',
          showshimmer:'=',
          proceedduplicate:'=',
          copyquoted:'=',
          showeditbtn:'=',
          showbookbtn:'=',
          parentPage:'=',
          isquotemodify:'=',
          quoteresult:'=',
          iscopyquote:'=',
          quoteType:"=",
          mixpanelSorce:"=",
          standardquote:"=",
          ratecardselection:"=",
          uidata:"=",
          callback : '&'
      },
      controller: ResultCardController
  })
  .component('buttonResultCard', {
    templateUrl: 'app/main/component/result-card/button-result-card.html',
    bindings : {
        searchparam :'=',
        carddata : '=',
        resultfilter : '=',
        index:'=',
        showshimmer:'=',
        proceedduplicate:'=',
        copyquoted:'=',
        showeditbtn:'=',
        showbookbtn:'=',
        parentPage:'=',
        mixpanelSorce:"=",
        isquotemodify:'=',
        standardquote:"=",
        quoteresult:'=',
        iscopyquote:'=',
        callback : '&'
    },
    controller: ResultCardController
})
  .component('fclNewCard', {
      templateUrl: 'app/main/component/result-card/customCard.html',
      bindings : {
          searchparam :'=',
          carddata : '=',
          resultfilter : '=',
          callback : '&'
      },
      controller: ResultCardController
  });



  function ResultCardController($scope, util,QuotesService, SearchService,$attrs,analytics, $mdDialog, $rootScope, $filter, localStorageService, resultService, shareQuoteService, $timeout, $mdToast, $mdMedia, $state, $log, $sce, $mdPanel, perWMFactory, $interval, costViewFactory,$window, basisCalculation) {
      var vm = this;
  
      vm.util = util;
      vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER);
      //vm.showContractId=$rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES;
      vm.showContractShipper=$rootScope.domainData.domain_info.SHOW_CONTRACT_NUMBER_TO_SHIPPER;
      vm.isWebView = util.isWebView();
      vm.isShared = util.isSharedQuote();
      vm.title="";
      vm.shareQuoteService = shareQuoteService;
      vm.currencyList = util.currencyList;
      vm.currentState = $state.current.name;
      vm.today = new Date();
      vm.analyticsVisible = (util.isAdmin || util.isFreightbro) ? true : false;
      vm.ifExpireCross = false;
      vm.quoteEdit = (util.isAdmin || util.isFreightbro) ? true : false;
      vm.user_category = vm.isShared ? null : localStorageService.get('authToken').value.user_category;
      vm.mainFreightName = 'Main Freight';
      vm.l3_leg = 'l3_fcl';
      vm.screenIsSmall = $mdMedia('xs');
      vm.isShared = util.isSharedQuote();
      vm.mainFreightNameChange = $rootScope.isJeenaDomain;
      vm.quotePreview = util.sanitizeQueryParams($window.location.href).indexOf('quote_preview') >= 0 ? true : false;
      vm.showConvLoader = false;
      vm.expMaxDate = new Date();
      vm.leaveType = "removeCardConfirmation";
      vm.footerObj = { 
        "doneBtnDisable" : false,
        "buyTotalWithConv" : 0,
        "buyTotalBaseCurr" : 0,
        "sellTotalBaseCurr" : 0,
        "profit" : 0,
        "rateExpired":false
      }
      vm.sourceRate={};
      vm.pageSource='';
      vm.remarksInclusionCkEditorConfig = angular.copy(util.ckEditorConfig);
      vm.remarksInclusionCkEditorConfig.removeButtons = util.TnCRemoveButtons;
      vm.isFreeDaysEdit = false;
      vm.loadWiseFreeDaysList = [];
      vm.multi_schedule_list = [];
      vm.isIdCopied = 'Click to Copy';
      vm.customFeilds = [];
      vm.all_in_rates= [],
      vm.isWalmart =$rootScope.domainData.domain_info.THEME_CONFIG.rate_card_version && $rootScope.domainData.domain_info.THEME_CONFIG.rate_card_version.toLowerCase() === 'walmart';
      vm.showContractCondition=false;

      // methods
      vm.viewQuoteDetails=viewQuoteDetails;
      vm.showAsterix = showAsterix;
      vm.cancelDialogXeneta=cancelDialogXeneta;
      vm.viewDetailsModal = viewDetailsModal;
      vm.afterShowAnimation = afterShowAnimation;
      vm.rateTabView = rateTabView;
      vm.scheduleTabView = scheduleTabView;
      vm.analyticsTabView = analyticsTabView;
      vm.quotationTabView = quotationTabView;
      vm.rateTotalCustomCurr = rateTotalCustomCurr;
      vm.setCurrentSchedule = setCurrentSchedule;
      vm.selectedSchedule = selectedSchedule;
      vm.getCardRemarksInclusion= getCardRemarksInclusion;
      vm.fnGuuid = fnGuuid;
      vm.closeToast= closeToast;
      vm.pushToquoteArray = pushToquoteArray;
      vm.removeCard= removeCard;
      vm.showRemoveConfirmationPopup = showRemoveConfirmationPopup
      vm.requestToBook = requestToBook;
      vm.cancelDialog = cancelDialog;
      vm.openDeleteCard = openDeleteCard;
      vm.openEditCardModal = openEditCardModal;
      vm.isLegLoadMissing = isLegLoadMissing;
      vm.legPerUnitCost = legPerUnitCost;
      vm.loadMoreRecords= loadMoreRecords;
      vm.calculateQtyRange = calculateQtyRange;
      vm.airScheduleTabView = airScheduleTabView;
      vm.fnSwitchRates = fnSwitchRates;
      vm.fnCalAirSlab = fnCalAirSlab;
      vm.fnCheckIsNaN = fnCheckIsNaN;
      vm.isString = isString;
      vm.fnCollapseContent = fnCollapseContent;
      //vm.fnCardStructure = fnCardStructure;
      vm.remarksTabView=remarksTabView;
      vm.termsTabView = termsTabView;
      vm.fnDisplayProfit = fnDisplayProfit;
      vm.getConvFeeCost = getConvFeeCost;
      vm.fnCheckSpecialRate = fnCheckSpecialRate;
      vm.fnLoadList = fnLoadList;
      vm.trackEvent = trackEvent;
      vm.cancelDeleteCard=cancelDeleteCard;
      vm.undoDeleteCard=undoDeleteCard;
      vm.removeCardFromQuote=removeCardFromQuote;
      vm.selectedDuplicateQuote=selectedDuplicateQuote;
      vm.downloadSourceRate=downloadSourceRate;
      vm.ShowNoRatesInfo = ShowNoRatesInfo ;
      vm.fnSetCo2InCard = fnSetCo2InCard;
      vm.freeDaysTabView = freeDaysTabView;
      vm.selectMultiSchedule = selectMultiSchedule ;
      vm.fnClearAllSchedule = fnClearAllSchedule
      vm.fnCopyID=fnCopyID;
      vm.RateIndexView = RateIndexView;
      vm.showRateIndex = false;
      vm.showXenetaGraph = showXenetaGraph;
      vm.syncData=syncData;
      vm.showScreen=0;
      vm.panelExpansion=panelExpansion;
      vm.isPanelOpened = true;
      vm.checkUnmapped=checkUnmapped;
      vm.fnChargeSelection=fnChargeSelection;
      vm.getChargeMappingList=getChargeMappingList;
      vm.fnPrevScreen=fnPrevScreen;
      vm.chargeMappingErr ={}
      vm.checkChargeMappingRes=checkChargeMappingRes;
      vm.redirectToInquiry = redirectToInquiry;
      vm.validateChargeMapping=validateChargeMapping;
      vm.updateChargeStatus=updateChargeStatus;
      vm.mappingIntergration=mappingIntergration;
      vm.removeValidation=removeValidation;
      vm.panelMappedExpansion=panelMappedExpansion;
      vm.isMappedPanelOpened=false;
      vm.fnNextScreen = fnNextScreen;
  
      vm.reSyncTmsData=reSyncTmsData;
      vm.allowDownloadRateForShipper = $rootScope.domainData.domain_info.ALLOW_DOWNLOAD_RATE_FOR_SHIPPER

      // init function
      this.$onInit = function() { 
          vm.search_param = angular.copy(vm.searchparam);
          vm.searchUser = vm.search_param.user;
          vm.buyOrSell = vm.resultfilter.buyOrSell;
          vm.leg_mode = (vm.search_param.mode == 'SEA-FCL' ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl'));
          vm.l3_leg = 'l3_'+(vm.search_param.mode == 'SEA-FCL' ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl'));
          vm.l1_leg = 'l1_'+(vm.search_param.mode == 'SEA-FCL' ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl'));
          vm.l5_leg = 'l5_'+(vm.search_param.mode == 'SEA-FCL' ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl'));
          if(vm.carddata){
            vm.carddata.meta.applied_special_meta = null;
            if(vm.isWalmart){
            vm.customFeilds=angular.copy(resultService.getCustomFeilds());
           
            vm.customFeilds.forEach(function (obj1,index) {
             var match ={}
               vm.carddata.data.buy_rates[vm.l3_leg].rate_obj.custom_fields.find(function(item){
                if(obj1.key === item.key) {
                match=item;
               }
                 
               });
              if (match) {
                vm.customFeilds[index]['value'] = match.value;
              }
            });
          }
          }
         
          //vm.getCustomFeilds();
         
          if(vm.quoteresult){
            vm.quote_Status = !vm.quotePreview ? vm.quoteresult.result_data.status.status_list[vm.quoteresult.result_data.status.status_list.length-1].status : null;
            vm.isLost = (!vm.quotePreview && vm.quote_Status == 'Lost') ? true : false;
            vm.isExpired = (!vm.quotePreview && vm.quote_Status == 'Expired') ? true : false;
            vm.hideLegTotal = (vm.quoteresult.result_data.all_in_quote_setting == 'all_in_total' && (vm.util.isShipper || vm.isShared)) ? true : false;
          }
          vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : '';
          vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
          vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';
        // disable ckeditor
          if(!vm.quoteEdit){
            vm.remarksInclusionCkEditorConfig.readOnly =  true;
           }
          //  Storing old data into new key - Free days #DEV-10379
          if(vm.carddata  && vm.search_param.mode != 'AIR' && ! vm.carddata.data.buy_rates[vm.l3_leg].rate_obj.freeDays){
                 vm.carddata.data.buy_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(vm.carddata.data.buy_rates[vm.l3_leg].rate_obj , vm.search_param);
                 vm.carddata.data.sell_rates ? vm.carddata.data.sell_rates[vm.l3_leg].rate_obj = vm.util.storeOldData(vm.carddata.data.sell_rates[vm.l3_leg].rate_obj , vm.search_param):null;
          }

          if(!vm.util.isShipper && vm.carddata && !vm.carddata.meta.buy_leg_total && $rootScope.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL){
            vm.carddata.meta.buy_leg_total = resultService.calCardTotal(vm.carddata.data.buy_rates);
          }
          //console.log(vm.carddata.data.buy_rates[vm.l3_leg].rate_obj.all_in_rates,"sss")
          if(vm.isWalmart && vm.carddata &&  vm.carddata.data.buy_rates[vm.l3_leg].rate_obj &&  vm.carddata.data.buy_rates[vm.l3_leg].rate_obj.all_in_rates){
          vm.all_in_rates = vm.carddata.data.buy_rates[vm.l3_leg].rate_obj.all_in_rates;
          }

          vm.isNetwork = vm.carddata && vm.carddata.meta.type.includes('network');

          $timeout(function ()
          {
            showContractId();
          }, 500);
      
          
      };

      // show contract id based on the card meta type and show_contract_number key
      function showContractId(){
        if(vm.carddata){
          if(vm.carddata.data.buy_rates[vm.l3_leg]){
            vm.showContractId = vm.carddata.data.buy_rates[vm.l3_leg].rate_obj.show_contract_number ;
          }
          if(vm.carddata.data[vm.buyOrSell][vm.l3_leg].rate_obj.contract_number  && (!vm.carddata.meta.type.includes('network')  ||  vm.showContractId)){
            vm.showContractCondition=true;
          }
          if(vm.util.isShipper){
            vm.showContractCondition= vm.showContractCondition && vm.showContractShipper;
          }
        }
      }

      // Charge Mapping functions starts here
      function syncData(ev,menu,card){
      util.isCallingApi = true;
      vm.selectedSyncCardRef=card;
      vm.selectedMenu=menu;
      vm.unmappedList=[];
  
    var query={
      "cardId":[vm.selectedSyncCardRef._id],
      "searchID":SearchService.FclResult._id,
      "partner":menu.partner
    }
    if(menu.onClick.actionType
       =='SHOW_POPUP'
      ){ 
        QuotesService.getMappingData(query,'rate').then(
          function (response) {
        util.isCallingApi = false;
        
        vm.chargeMappingObj = response.data.data;
         vm.configuration=menu.onClick.Configuration;
         vm.mappedCharges={};
         vm.unmappedCharges={}

         for (var key in vm.chargeMappingObj.chargeMap) {
          if (vm.chargeMappingObj.chargeMap.hasOwnProperty(key)) {  
            var charge = vm.chargeMappingObj.chargeMap[key];

            if(!vm.chargeMappingObj.chargeMap[key].partner.chargeName){
              vm.unmappedList.push(key)
              vm.unmappedCharges[key]=charge
              
            }
            else{
              vm.mappedCharges[key]=charge
            }
          }
        }
        vm.showUnmappedCharge= vm.unmappedList.length > 0 ? true : false;
        vm.copyMappingObj = angular.copy(vm.chargeMappingObj);
        $mdDialog.hide();
        $mdDialog.show({
          templateUrl:
            "app/main/quotes/dialogs/quote-sync-mapping/quote-sync-mapping.html",
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: "ctrl",
            controller: function () {
              this.parent = vm;
            },
        });
          },
          function (error) {
            util.isCallingApi = false;
            // vm.uiData.integrationComponentOptions.menu.isEnabled=true;
            vm.chargeMappingObj={}
            util.showToast(error.data.message);
            $log.log(error);
          }
        );

    }
      }
      function panelExpansion() {
        vm.isPanelOpened = !vm.isPanelOpened;
      }

      function checkUnmapped(event){
        event.stopPropagation();
        for (var key in vm.chargeMappingObj.chargeMap) {
         vm.removeValidation(key,'_partnerCharge');
        }
      }

      function fnChargeSelection(selectedCharge, key){
        vm.chargeMappingObj.chargeMap[key].partner=selectedCharge
      }

      function getChargeMappingList(searchText){
        return  QuotesService.getChargeMappingList(searchText,vm.search_param.mode,vm.selectedSyncCardRef.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.
          sv_id,vm.chargeMappingObj.linerMappingId);
      }

      function fnPrevScreen(num) {
        var listElements = document.querySelectorAll("ul.stepper-bar li");
        listElements.forEach(function (item, index) {
         
          if (index == num) {
            vm.showScreen=num;
            item.classList.add("active")
          }
          else {
            item.classList.remove("active")
          }
        })
        // if (num == 1) {
        //   vm.showScreen = 1;
        // }
      
      }
      function checkChargeMappingRes(response,isSuccess){
 
        vm.chargeMappingErr = {
          'responseFrom': "RESULT",
          'status': isSuccess ? "COMPLETED" : "FAILED",
          'message':response.data.display_message ,
          'inquiry_id':response.data.data? response.data.data.inquiry_details.id  : null,
          'inquiry_number':response.data.data? response.data.data.inquiry_details.inquiry_number  : null,
        }
      }
      function validateChargeMapping(){
        vm.error=0
        //vm.customerDataValidation();
        vm.updateChargeStatus();
        if(vm.error || vm.chargeMappingForm.$invalid){
          return
        }else{
          vm.fnNextScreen(vm.showScreen);
          vm.mappingIntergration();
        }
      }

      function fnNextScreen(num) {
        var listElements = document.querySelectorAll("ul.stepper-bar li");
        listElements.forEach(function (item, index) {
          if (index + 1 == num) {
            item.classList.remove("active")
          }
          if (index + 1 == num + 1) {
            item.classList.add("active")
          }
        })
        if (num == 1) {
          vm.showScreen = 2;
        } else if (num == 2) {
          vm.showScreen = 3;
        }
      }
      function updateChargeStatus(){
        for (var key in vm.chargeMappingObj.chargeMap) {
          if(!vm.chargeMappingObj.chargeMap[key].partner.chargeName && !vm.chargeMappingObj.isUnmapped){
            var element = document.getElementById(key+"_partnerCharge");
            angular.element(element).addClass("error-border-auto");
          vm.error++
          vm.unmappedList.includes(key) ?  vm.isPanelOpened=true : vm.isMappedPanelOpened=true
          return
          }
          if (vm.chargeMappingObj.chargeMap.hasOwnProperty(key) && vm.copyMappingObj.chargeMap.hasOwnProperty(key) ) {
            
            if(vm.copyMappingObj.chargeMap[key].partner.chargeName){
            if(angular.equals(vm.copyMappingObj.chargeMap[key].partner,vm.chargeMappingObj.chargeMap[key].partner)){
            vm.chargeMappingObj.chargeMap[key].status="UNCHANGED"
            }
            else{
            vm.chargeMappingObj.chargeMap[key].status="UPDATED"
            }
            }
          else{
            if(!vm.chargeMappingObj.isUnmapped){
                vm.chargeMappingObj.chargeMap[key].status="CREATED"
            }
            else{
              vm.chargeMappingObj.chargeMap[key].status=""
            }
            
          } 
          
          }
        }
        
        
      }
      function panelMappedExpansion() {
        
        vm.isMappedPanelOpened = !vm.isMappedPanelOpened;
      }
      function mappingIntergration(){
        // vm.selectedMenu.partner="Cargowise"
        util.isCallingApi = true;
        var url='/api/sync/rate?partner='+vm.selectedMenu.partner+'&searchId='+SearchService.FclResult._id+'&entity=rate&cardId='+vm.selectedSyncCardRef._id;
        var config = {
          method : vm.selectedMenu.onClick.Configuration.actionHTTPMethod,
        // method:"PATCH",
          url : url, 
          data: vm.chargeMappingObj
        }
      
        util.cargowiseIntegration(config).then(function(response){
        util.isCallingApi = false;
        vm.uidata.integrationComponentOptions.menu.isEnabled=true;
        if(response.status == 200){
          vm.selectedMenu.status_code = response.status;
          vm.selectedMenu.sync_time = response.data.data.last_synced_at;
          vm.selectedSyncCardRef.partner_reference_id=response.data.data.partner_reference_id;
          //vm.selectedSyncCardRef.partner_reference_id="dfghjkl"
        vm.sendtoerrtype = response.status;
        vm.showScreen = vm.showScreen + 1;
        vm.checkChargeMappingRes(response,true);
        
      }
      
      
      else{
        vm.showScreen = vm.showScreen + 1;
        vm.checkChargeMappingRes(response,false);
      }
        },function(error){
          vm.uidata.integrationComponentOptions.menu.isEnabled=true;
        util.isCallingApi = false;
        util.showToast(util.displayValidationError(error));
        $log.log(error);
      });
      
      }
      function removeValidation(key,type ){
        var id = key + (type ? type : '');
        
        var element = document.getElementById(id);
          angular.element(element).removeClass("error-border-auto");
        
      }
      function redirectToInquiry(inquiryId){
        $state.go('app.inquiry.inquiryDetails', { id: inquiryId });
      }
      // Charge Mapping functions ends here

      function showAsterix(array) {
        var showAsterix = false;
        if(array) {
          Object.keys(array).some(function (key) {
            if (array[key].leg_code === 'additional_services') {
              array[key].rate_obj.charges.some(function (i) {
                if (typeof i.charge_cost === 'string') {
                  showAsterix = true;
                  return true;
                }
              });
            }
          });
        }
        return showAsterix;
      }

      function calculateQtyRange(charge, key) {
          var unit = charge.total_units;
          if (unit >= charge.slab[key].to) {
              return (charge.slab[key].to - (charge.slab[key - 1] ? charge.slab[key-1].to:0));
          } else if (unit >= charge.slab[key].from) {
              return (unit - charge.slab[key].from + 1);
          } else {
              return 0;
          }
      }
      function fnCopyID(copyedText){
        vm.isIdCopied = 'Copied!'
        var temp_input = $("<input>");
        $("body").append(temp_input);
        temp_input.id = 'tempCopyToClipboard';
        temp_input.val(copyedText).select();
        document.execCommand("copy");
        temp_input.remove();
        $timeout(function ()
        {
            vm.isIdCopied = 'Click to Copy';
        }, 1500);
      }
      function viewDetailsModal(currCard, ev, activeTab, msrOrNetwork, skipPopup) {

        currCard.meta.remarks = util.decodeValue(currCard.meta.remarks);        
        currCard.meta.inclusions = util.decodeValue(currCard.meta.inclusions);        
        currCard.meta.internal_remarks = util.decodeValue(currCard.meta.internal_remarks);
        
          //api call for source rate
          if(vm.util.isAdmin ||(vm.util.userProfile.user && vm.util.userProfile.user.is_pricing_user)){
            downloadSourceRate(currCard);
          }
       if(currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry && (vm.util.getStatusData(currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj) === 'EXPIRED')){
          vm.footerObj.rateExpired = true;
           }
           else{
            vm.footerObj.rateExpired = false;
           }
          // popup booking button for shipper
          vm.btnShipperBooking = vm.util.isShipper && (vm.util.navPermission.shipments && vm.util.navPermission.shipments[0]) && !vm.resultfilter.hideBookBtn && !vm.generateQuoteBtn && !vm.resultfilter.countApiCard ? true : false;

          if( !currCard.meta.isScheduleCall ){
              return true;
          }
          vm.footerObj.doneBtnDisable = false;
          vm.rem_open = true;
          vm.inl_open = true;
          vm.generateQuoteBtn = vm.resultfilter.generateQuoteBtn;
          vm.msrOrNetwork = msrOrNetwork;
          vm.editBuyRate = true;
          // if schedule list not available then schedule tab not visible
          vm.scheduleList = (vm.resultfilter.via_route_filter == 'Direct') ? currCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.direct : currCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;

          // store l3 fcl slab range
          vm.fclSlab = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab_charges;

          // condition to show slab tab
          if(vm.search_param.mode == 'AIR' && (util.isAdmin || util.isFreightbro) ){
            vm.ratesVisible = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab_rate ? 1 : 0;
          }else if(vm.search_param.mode == 'SEA-FCL' && (util.isAdmin || util.isFreightbro) ){
            vm.ratesVisible = vm.fclSlab && vm.fclSlab.length ? 1 : 0;
          }else{
            vm.ratesVisible = 0;
          }

          vm.scheduleVisible = (vm.search_param.mode != 'AIR' && vm.scheduleList.length) ? 1 : 0;
          vm.airScheduleVisible = (vm.search_param.mode == 'AIR' && vm.scheduleList.length) ? 1 : 0;
          vm.quotationVisible = 1;
          vm.analyticsVisible = ( (util.isAdmin || util.isFreightbro) && currCard.data.buy_rates[vm.l3_leg].rate_obj.analytics.graph.url) ? 1 : 0;
          vm.termsVisible = !vm.maskLiner && currCard.meta.type.includes("spot") && (currCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data || currCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.url) ? 1 : 0;
          vm.xenetaVisible = (util.isAdmin || util.isFreightbro) && currCard.meta["xenetaRateArray"] && currCard.meta["xenetaRateArray"].length ? true : false;

          if(activeTab == 'rates' && vm.ratesVisible){
            vm.selectedIndex = 0;
          }
          if(activeTab == 'schedule'){
            vm.selectedIndex = vm.ratesVisible;
          }
          if(activeTab == 'quotation'){
            vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible;
          }
          if(activeTab == 'tnc'){
            vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible + (vm.quotationVisible ? 2 : 0);
          }


          if(vm.search_param.mode == 'AIR' && util.isShipper) {
            vm.displayRates = true;
          }
          else if(vm.search_param.mode != 'AIR' && util.isShipper){
            vm.displayRates = false;
          }

          // check if special rates
          if(vm.search_param.mode == 'SEA-FCL' && vm.fnCheckSpecialRate(currCard)){
            return;
          }

          $rootScope.loadingDetails = !skipPopup ? true : false;
          vm.showData = true;
          vm.ScheduleCard = currCard;

          // Convenience fee
          vm.getConvFeeCost(currCard);

          shareQuoteService.currencyConverter = {}; //Reset currency converter setting

          vm.currentCard = angular.copy(currCard);
          vm.conversionRate = vm.currentCard.meta.conversionRate;
          vm.currency_rates = vm.conversionRate.curr_data;

          // Currency conversion setting code
          shareQuoteService.setCurrencyConvSetting(vm.searchUser.user_base_currency, vm.conversionRate.markup, vm.conversionRate.directCurrencyMapping, vm.currency_rates);

          vm.legSuggestionList = [];

          // Data Required For Public exchange rates Link
          getDataForExchangeRate();

          // get fcl load list and open details modal
          vm.fnLoadList(ev,skipPopup);

          // Get Dim leg list
          vm.dimLegList = [];
          vm.dimLegList = shareQuoteService.fnGetDimLegs(vm.currentCard.data.buy_rates); 
      }

      function getDataForExchangeRate(){
        vm.resultId = vm.search_param.mode == 'SEA-FCL' ? SearchService.FclResult._id : (vm.search_param.mode == 'SEA-LCL' ? SearchService.LclResult._id : SearchService.AirResult._id);
        vm.cardVendorId = vm.currentCard.meta.vendor_id;
        vm.resultType = 'Search';
        vm.showExchangeRates = $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;
      }

      function fnCheckSpecialRate(currCard){
        var result = false;
        var count = 1;
        if (currCard.data.buy_rates[vm.l3_leg].rate_obj.is_special && currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment != null) {
          //  special rate max_qty_per_shipment loop
          for (var j in currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment) {
              for (var i = 0; i < vm.search_param.load_data.load_details_value.length; i++) {
                  if (vm.search_param.load_data.load_details_value[i].type == j && vm.search_param.load_data.load_details_value[i].qty > currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment[j]) {
                    if (vm.selectedIndex == 3) {
                        util.showToast("Max quantity allowed for " + j + " is " + currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment[j]);
                        count = 0;
                    }
                    vm.quotationVisible = false;
                    break;
                  }
              }
              if (count === 0) {
                  break;
              }
          }

          if (count === 0) {
            result = true;
          }
        }

        return result;
      }

      // get fcl load list and open details modal
      function fnLoadList(ev,skipPopup){
        if(vm.search_param.mode == 'SEA-FCL' && (!SearchService.loadTypeArr || SearchService.loadTypeArr.length == 0) ) {
          SearchService.getAllLoadList().then(function (response) {
              SearchService.loadTypeArr = response;
              vm.loadTypeArr = response;
              util.limitObj = response;
              if(!skipPopup){
                openViewDetailFcl(ev);
              }else{
                vm.currentCard.data.sell_rates = angular.copy(vm.currentCard.data.buy_rates);
                vm.pushToquoteArray(vm.currentCard);
              }
          }, function (error) {
              $log.log(error.data);
          });
        } else {
          vm.loadTypeArr = (SearchService.loadTypeArr && SearchService.loadTypeArr.length) ? SearchService.loadTypeArr : [];
          if(!skipPopup){
            openViewDetailFcl(ev);
          }else{
            vm.currentCard.data.sell_rates = angular.copy(vm.currentCard.data.buy_rates);
            vm.pushToquoteArray(vm.currentCard);
          }
        }

        function openViewDetailFcl(ev) {
          vm.all_in_quote = util.all_in_quote;
          vm.title="Details"
          setTimeout(function () {
            vm.scheduleDivHeight =  document.getElementsByClassName('rate-card-detail-modal')[0].offsetHeight;
          }, 200);
          
          vm.pageSource="Instant-ViewDetails";
          vm.searchFromQuote = vm.search_param.mode==='SEA-FCL' && (vm.search_param.source=='quote' || vm.search_param.source=='create_quote' || vm.search_param.source=='copy_quote');
          $mdDialog.show({
          templateUrl: vm.leg_mode == 'fcl' ? 'app/main/result/Dialogs/view-details/fclViewDetails.html' : 'app/main/result/Dialogs/view-details/airViewDetails.html',
          targetEvent: ev,
          clickOutsideToClose: false,
          onComplete: vm.afterShowAnimation,
          animation: false,
          controllerAs: 'ctrl',
          controller: function () { this.parent = vm },
          onRemoving: function (event, removePromise) {
            for (var name in CKEDITOR.instances) {
              CKEDITOR.instances[name].destroy();
            }
          }
          });

        }
      }

      //Convenience fee code
      function getConvFeeCost(currCard){
        if( vm.search_param.mode=='SEA-FCL' && currCard.meta.additional_charges){

          if (currCard.meta.additional_charges.url && !currCard.meta.additional_charges.data) {

            var total_cost = vm.rateTotalCustomCurr(currCard.data.buy_rates);
            vm.showConvLoader = true;
            vm.footerObj.doneBtnDisable = true;
            resultService.getConvFee(currCard,total_cost,SearchService.FclResult._id,currCard.data.buy_rates[vm.l3_leg].rate_obj.leg_total_currency).then(function(response){

              vm.fnDisplayProfit(); // calling dispay profit only in quotation tab
              vm.currentCard.meta.additional_charges = angular.copy(currCard.meta.additional_charges);
              vm.showConvLoader = false;
              vm.footerObj.doneBtnDisable = false;

            }, function(error){
              vm.showConvLoader = false;
              vm.footerObj.doneBtnDisable = false;
              $log.error(error);
            });

          }
        }
      }

      function afterShowAnimation () {
          vm.showData = false;
          $rootScope.loadingDetails = false;
      }

      function rateTabView() {
        vm.legShow = 1;
        vm.chargeShow = 5;
        vm.viewActiveTab = 'rates';
        vm.rateDetails = vm.currentCard.data.buy_rates;

        vm.interval = $interval(function(){
          vm.legShow++;
          if(vm.legShow == Object.keys(vm.rateDetails).length){
            $interval.cancel(vm.interval);
          }
        }, 500);
        //mixpanel.code
        util.callMixpanel(vm.mixpanelSorce+'-RateCard-FclSlabTab-click',{
          "Mode": vm.search_param.mode,
          "Type": vm.resultType
        }); 
      }

      function scheduleTabView () {
          vm.viewActiveTab = 'schedule';
          vm.scheduleList = (vm.resultfilter.via_route_filter == 'Direct') ? vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.direct : vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;

          // rate card schedule matching to big schedule
          var selectedScheduleIndex =  null;
          if(!resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
            angular.forEach(vm.scheduleList, function(item){
            if(!selectedScheduleIndex){
                selectedScheduleIndex = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
              }
            });
          }
          vm.current_schedule =  vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule : selectedScheduleIndex;
          // storing old rates schedule on multi list
          // ignoring the shipper to select multi schedules
        if(vm.current_schedule && vm.current_schedule.schedule_track && !util.isShipper){
          if(!vm.multi_schedule_list.length){
              vm.current_schedule["isSelected"] = true;
              vm.multi_schedule_list.push(vm.current_schedule);
          }
          angular.forEach(vm.scheduleList ,function(scheduleFromDB){
            angular.forEach(vm.multi_schedule_list ,function(scheduleFromMulti){
              if(scheduleFromDB.id == scheduleFromMulti.id){
                scheduleFromDB["isSelected"] = true
              }
            });
          });
        }

          if (vm.current_schedule != null && vm.current_schedule.departure_time > vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.expiry) {
              vm.ifExpireCross = true;
          } else {
              vm.ifExpireCross = false;
          }
          vm.getSchedule = true;

          //mixpanel.code
          var id= vm.mixpanelSorce+'-RateCard-ScheduleTab-Click'
          util.callMixpanel(id,{
           "Mode": vm.search_param.mode,
           "Type": vm.resultType
         });
         
      }

      function airScheduleTabView(){
        vm.viewActiveTab = 'airline schedule';
        var id= vm.mixpanelSorce+'-RateCard-AirScheduleTab-Click'
        util.callMixpanel(id,{
         "Mode": vm.search_param.mode,
         "Type": vm.resultType
       });
       
         vm.getSchedule = true;
         vm.scheduleList = (vm.resultfilter.via_route_filter == 'Direct') ? vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.direct : vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;
         var selectedSchedule = null
         if(!resultService.fnScheduleDisplayConfig(vm.currentCard,vm.l3_leg)){
            angular.forEach(vm.scheduleList, function(item){
            if(!selectedSchedule){
              selectedSchedule = resultService.fnScheduleMatchingCard(vm.currentCard,vm.l3_leg,item);
              }
            });
          }
        vm.current_schedule = vm.currentCard.meta.selected_schedule ? vm.currentCard.meta.selected_schedule : selectedSchedule;
        vm.display_airlineName = vm.ScheduleCard.data.buy_rates.l3_air.rate_obj.airline.air_line_name;
      }

      function analyticsTabView () {
          vm.viewActiveTab = 'analytics';
          if (!vm.currentCard.meta.hasOwnProperty('view')) {
              vm.currentCard.meta["view"] = true;
          } else {
              vm.currentCard.meta.view = false;
          }

          if (vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.analytics.graph.url && vm.currentCard.meta.view) {

              resultService.getAnalytics(gravm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.analytics.ph.url).then(function (response) {
              graph["data"] = response.data;
              vm.analyticsData = response.data;
              vm.is_rate_history_empty = util.validateAnalyticData(vm.analyticsData);
              vm.showGraph();
              }, function (error) {
              $log.log(error);
              graph["data"] = null;
              vm.analyticsData = null;
              vm.is_rate_history_empty = true;
              util.showToast(util.displayValidationError(error));
              });
          } else {
              vm.is_rate_history_empty = true;
          }

          //mixpanel.code
          var id= vm.mixpanelSorce+'-RateCard-AnalyticsTab-Click'
          util.callMixpanel(id,{
           "Mode": vm.search_param.mode,
           "Type": vm.resultType
         });
         
      }

      function quotationTabView () {
          vm.legShow = 1;
          vm.chargeShow = 3;
          vm.viewActiveTab = 'quotation';

          vm.showChargesInfo = false;

          if (!vm.currentCard.data.sell_rates || vm.currentCard.data.sell_rates.hasOwnProperty('additional_services')  ) {
              var temp_sellRates = {};

              if(vm.currentCard.data.sell_rates && vm.currentCard.data.sell_rates.hasOwnProperty('additional_services')){
                  temp_sellRates = angular.copy(vm.currentCard.data.sell_rates);
              }
              else{
                  temp_sellRates = angular.copy(vm.currentCard.data.buy_rates);
              }

              angular.forEach(temp_sellRates, function (value, key) {
                if(value.rate_obj){
                  angular.forEach(value.rate_obj.charges, function (childValue) {
                    childValue.charge_basis = (childValue.charge_basis == 'per shpt') ? 'per shipment' : childValue.charge_basis;

                    if(key == 'l3_air' && basisCalculation.isParent(childValue)
                    ){
                      vm.ScheduleCard.meta["AirFreight"] = angular.copy(childValue);
                    }
                    if(key == 'l1_lcl' && childValue.global_charge_id && (childValue.global_charge_id.indexOf(shareQuoteService.pickupChargeId)) >= 0){
                      vm.ScheduleCard.meta["pickupCharge"] = angular.copy(childValue);
                    }
                    if(key == 'l5_lcl' && childValue.global_charge_id && (childValue.global_charge_id.indexOf(shareQuoteService.deliveryChargeId)) >= 0){
                      vm.ScheduleCard.meta["deliveryCharge"] = angular.copy(childValue);
                    }
                  });
                }
              });

              vm.ScheduleCard.data.sell_rates = angular.copy(temp_sellRates);
              vm.currentCard.data.sell_rates = angular.copy(temp_sellRates);
              vm.currentCard.meta = angular.copy(vm.ScheduleCard.meta);
          }
          vm.showChargesInfo = true;
      }

      function termsTabView(){
        vm.viewActiveTab = 'Terms';
        vm.termsShimmer = true;

        if (vm.search_param.mode == 'SEA-FCL') {
          if(!vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data && vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.url){
            return resultService.getCardTerms(vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.url).then(function (response) {
              vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
              vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
              vm.termsData = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
              vm.termsShimmer = false;
            }, function (error) {
              vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data = null;
              vm.termsData = null;
              vm.termsShimmer = false;
              $log.log(error);
            });
          } else {
            vm.termsData = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
            vm.termsShimmer = false;
          }
        } 
        else {
          vm.stdTermsAndConditions = util.stdTermsAndConditions || "";
          
          // Case 1: Check if terms are available in card data via URL
          if(!vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data && 
             vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.url){
              
            return resultService.getCardTerms(vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.url).then(function (response) {
              vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
              vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data = angular.copy(response.data.data);
              vm.termsData = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
              vm.termsShimmer = false;
            }, function (error) {
              // If error fetching card terms, fall back to standard terms
              vm.termsData = util.stdTermsAndConditions || "No terms and conditions available";
              vm.termsShimmer = false;
              $log.log(error);
            });
          } 
          // Case 2: Check if terms are already available in card data directly
          else if (vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data) {
            vm.termsData = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.terms_and_condition.data["terms_and_condition_data"];
            vm.termsShimmer = false;
          }
          // Case 3: Fall back to standard terms from util service or parent controller
          else {
            vm.termsData = util.stdTermsAndConditions || "No terms and conditions available";
            vm.termsShimmer = false;
          }
        }
      
        //mixpanel code
        var id= vm.mixpanelSorce+'-RateCard-T&CTab-Click'
        util.callMixpanel(id,{
         "Mode": vm.search_param.mode,
         "Type": vm.resultType
        });
      }

      function remarksTabView(){
        vm.viewActiveTab = 'remarksInclusion';
        if(!(util.isSharedQuote() || util.isSharedPage())){
        vm.isOwnVendorRate = util.isOwnVendorRate(vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.vendor_id);
        }
        vm.hideInternalRemarks =  !vm.isOwnVendorRate || util.isSharedQuote() || util.isSharedPage() ;
      }

      function RateIndexView(){
        vm.showRateIndex = true;
        vm.viewActiveTab = 'rateIndex';
        vm.rateIndexData = vm.currentCard.meta["xenetaRateArray"];
      }
      
      // get card leg user base currency total
      function rateTotalCustomCurr (cards) {
          var convertTotal = 0;
          angular.forEach(cards, function (value) {
              if (value.rate_obj) {
              convertTotal += parseFloat(value.rate_obj.leg_total_cost);
              }
          });
          if($rootScope &&$rootScope.precision_decimals){
            convertTotal = $filter('number')(convertTotal, $rootScope.precision_decimals);
            }else{
              convertTotal = $filter('number')(convertTotal, 2);
            }
          convertTotal = Number(convertTotal.split(',').join(''));
          return convertTotal;
      }

      function fnDisplayProfit(){
          vm.footerObj.buyTotalWithConv = 0;
          vm.footerObj.buyTotalBaseCurr = vm.rateTotalCustomCurr(vm.currentCard.data.buy_rates);
          vm.footerObj.sellTotalBaseCurr = vm.rateTotalCustomCurr(vm.currentCard.data.sell_rates);
          // Add Convenience fee if present
          if(vm.currentCard.meta.additional_charges && vm.currentCard.meta.additional_charges.data){
            vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr + parseFloat(vm.currentCard.meta.additional_charges.data.leg_total_cost);
          }else{
            vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr;
          }
          vm.footerObj.profit = util.getProfitValue(vm.footerObj.sellTotalBaseCurr, vm.footerObj.buyTotalWithConv);
      }

      function setCurrentSchedule (current_schedule, index) {
        if(vm.multi_schedule_list && vm.multi_schedule_list.length == 15 ){
          util.showToast("Maximum limit reached - 15");
          return;
        }
          if(!current_schedule.isSelected && !util.isShipper && vm.search_param.mode != "AIR"){
            current_schedule["isSelected"] = true;
            vm.multi_schedule_list.push(current_schedule);
          }
          
          vm.current_schedule = current_schedule;
          if (vm.current_schedule != null && vm.current_schedule.departure_time > vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.expiry) {
              vm.ifExpireCross = true;
          } else {
              vm.ifExpireCross = false;
          }

          var cardIndex = index+1;
         vm.selectedSchedule();
      }

      function selectedSchedule () {

          vm.ScheduleCard.meta.selected_schedule = vm.current_schedule;
          vm.ScheduleCard.meta["transit_time"] = vm.current_schedule ? vm.current_schedule.transit_time : '' ;
          vm.ScheduleCard.meta["sailing_date"] = vm.current_schedule ? vm.current_schedule.departure_time : '';
          vm.ScheduleCard.meta.multi_schedule_list = vm.multi_schedule_list;
          vm.ScheduleCard.meta.isScheduleCall = false;
          vm.callback({card : {'currentCard' : vm.ScheduleCard, 'action' : 'scheduleSelect' }});
          if(vm.search_param.mode == "AIR"){
            $mdDialog.hide();
          }
          else{
          //  updating the isSelected key in card schedule list by updating with scheduleList
          if(vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.direct){
            vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.direct =  vm.scheduleList
          }else{
            vm.ScheduleCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = vm.scheduleList
          }

          vm.currentCard.meta.selected_schedule = vm.current_schedule;
          vm.currentCard.meta.multi_schedule_list = vm.multi_schedule_list;
          vm.currentCard.meta["transit_time"] = vm.current_schedule ?  vm.current_schedule.transit_time : '' ;
          vm.currentCard.meta["sailing_date"] = vm.current_schedule ? vm.current_schedule.departure_time : '' ;

          //  updating the isSelected key in card schedule list by updating with scheduleList
          if(vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.direct){
            vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.direct =  vm.scheduleList
          }else{
            vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data = vm.scheduleList
          }
        }

        
      }

      // function to get the remarks or inclusion of cards
      function getCardRemarksInclusion (cardObj, key) {
          return resultService.getCardRemarksInclusion(cardObj, key);
      }

      function fnGuuid() {
          return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      }

      function closeToast () {
          $mdToast.hide();
      }

      // get selected card with sell rates
      function pushToquoteArray (currentCard, action) {

         if(Object.keys(currentCard.data.sell_rates).length ==1 && !currentCard.data.sell_rates[Object.keys(currentCard.data.sell_rates)[0]].rate_obj.charges.length){
          util.showToast("Add a leg and its corresponding charges to continue");
           return;
         }
          vm.footerObj.doneBtnDisable = true;

          if(!(currentCard['_id'])){
              var card_number = (vm.fnGuuid() + vm.fnGuuid() + "-" + vm.fnGuuid() + "-4" + vm.fnGuuid().substr(0,3) + "-" + vm.fnGuuid() + "-" + vm.fnGuuid() + vm.fnGuuid() + vm.fnGuuid()).toLowerCase();
              currentCard['_id'] =  card_number;
          }

          if (currentCard.meta.remarks == undefined || currentCard.meta.remarks == "") {
              currentCard.meta.remarks = null;
          }
          if (currentCard.meta.inclusions == undefined || currentCard.meta.inclusions == "") {
              currentCard.meta.inclusions = null;
          }

          var isDone = shareQuoteService.fnRateEditValidation(currentCard, vm.editBuyRate, vm.search_param);

          if(isDone === 0){
            const elements = document.querySelectorAll('.error-border');
          if(elements.length){ 
            if(vm.viewActiveTab != 'quotation'){
                vm.selectedIndex = (vm.scheduleVisible || vm.airScheduleVisible) + vm.ratesVisible + vm.analyticsVisible;
            }else{
                elements[0].scrollIntoView({ behavior: 'smooth' , block: 'center'});
            }
          }
          vm.footerObj.doneBtnDisable = false;
          }else if (isDone === 1) {

              var custom_leg = 9;
              var tempSellRates = {};
              var tempBuyRates = {};
              var load_stat = {};

              if(vm.search_param.mode == 'SEA-FCL'){
                //leg charge summary calculate factory instance 
                var chargeSummaryObj = new fbUtils.ChargeSummaryFactory.getInstance(vm.search_param.load_data, vm.search_param.mode);
                  load_stat = {};
                  vm.search_param.load_data.load_details_value.forEach(function(load) {
                    load_stat[load.type] = 0;
                  });
              }

              angular.forEach(currentCard.data.sell_rates, function (value, key) {
                if(key.toLowerCase().includes('lnew') || key !==vm.l3_leg){
                  if(value.leg_code===vm.l3_leg){
                    var templeg=value.rate_obj;
                    value = currentCard.data.sell_rates[vm.l3_leg];
                    value.leg_name = templeg.leg_name;
                    value.rate_obj.leg_name = value.leg_name;
                    value.rate_obj.charges=templeg.charges;
                    value.rate_obj.leg_total_currency=templeg.leg_total_currency;
                    value.rate_obj.leg_total_cost=templeg.leg_total_cost;
                    value.rate_obj.leg_currency_cost=templeg.leg_currency_cost;
                    value.rate_obj.leg_currency=templeg.leg_currency;
                    value.rate_obj.manual=templeg.manual
      
                  }  
                }
      
                  if(vm.search_param.mode == 'SEA-FCL' && value.rate_obj){
                      value.rate_obj.load_stat = angular.copy(load_stat);
                  }

                  if (value.leg_code != null && value.leg_code != "") {
                      tempSellRates[value.leg_code] = value;
                      if(value.leg_code===vm.l3_leg && ( key.toLowerCase().includes('lnew') || key !== vm.l3_leg )){
                        var buytempleg= currentCard.data.buy_rates[key].rate_obj;
                        tempBuyRates[value.leg_code] = currentCard.data.buy_rates[vm.l3_leg];
                        tempBuyRates[value.leg_code].leg_name = currentCard.data.buy_rates[key].leg_name
                        tempBuyRates[value.leg_code].rate_obj.leg_name = currentCard.data.buy_rates[key].leg_name;
                        tempBuyRates[value.leg_code].rate_obj.charges=buytempleg.charges;
                        tempBuyRates[value.leg_code].rate_obj.leg_total_currency=buytempleg.leg_total_currency;
                        tempBuyRates[value.leg_code].rate_obj.leg_total_cost=buytempleg.leg_total_cost;
                        tempBuyRates[value.leg_code].rate_obj.leg_currency_cost=buytempleg.leg_currency_cost;
                        tempBuyRates[value.leg_code].rate_obj.leg_currency=buytempleg.leg_currency;
                        tempBuyRates[value.leg_code].rate_obj.manual=buytempleg.manual
                      }
                      else{
                        tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
                      }

                      // Charge Summery calculation
                      //Get legs wise total charge summary
                      if(vm.search_param.mode == 'SEA-FCL'){
                        var buySummaryData = chargeSummaryObj.calculate(currentCard.data.buy_rates[key].rate_obj);
                        var sellSummaryData = chargeSummaryObj.calculate(currentCard.data.sell_rates[key].rate_obj);
                        currentCard.data.buy_rates[key]['charge_summary'] = buySummaryData;
                        currentCard.data.sell_rates[key]['charge_summary'] = sellSummaryData;
                      }
                      

                      custom_leg = parseInt(value.leg_code.match(/(\d+)/)[0]) <= 8 ? 9 : parseInt(value.leg_code.match(/(\d+)/)[0]) + 1;
                  }
                  else if (value.leg_code == null || value.leg_code == "") {
                      value.leg_code = 'l' + custom_leg + '_'+vm.leg_mode;
                      value.rate_obj.leg_code = value.leg_code;
                      value.rate_obj.leg_name = value.leg_name;

                      currentCard.data.buy_rates[key].leg_code = value.leg_code;
                      currentCard.data.buy_rates[key].leg_name = value.leg_name;
                      currentCard.data.buy_rates[key].rate_obj.leg_code = value.leg_code;
                      currentCard.data.buy_rates[key].rate_obj.leg_name = value.leg_name;
                      custom_leg++;
                      tempSellRates[value.leg_code] = value;
                      tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
                  }
                  if(value.rate_obj){
                      angular.forEach(value.rate_obj.charges, function (childValue, chargeKey) {
                          if(vm.search_param.mode == 'SEA-FCL' && childValue.container_type){
                              value.rate_obj.load_stat[childValue.container_type] = 1;
                          }

                          if(!childValue.charge_id){
                            childValue.charge_id = 'UD'+ Math.random().toString(36).substring(2, 7).toUpperCase();
                            childValue.global_charge_id = 'UD'+ Math.random().toString(36).substring(2, 7).toUpperCase();

                            // random id for buy and sell rate charges
                            tempSellRates[value.leg_code].rate_obj.charges[chargeKey].charge_id = childValue.charge_id;
                            tempBuyRates[value.leg_code].rate_obj.charges[chargeKey].charge_id = childValue.charge_id;

                            tempSellRates[value.leg_code].rate_obj.charges[chargeKey].global_charge_id = childValue.global_charge_id;
                            tempBuyRates[value.leg_code].rate_obj.charges[chargeKey].global_charge_id = childValue.global_charge_id;
                          }
                      });
                      if(vm.editBuyRate){
                          tempBuyRates[value.leg_code].rate_obj.load_stat = angular.copy(value.rate_obj.load_stat);
                      }else{
                          tempBuyRates[value.leg_code].rate_obj.load_stat = tempBuyRates[value.leg_code].rate_obj.load_stat ? tempBuyRates[value.leg_code].rate_obj.load_stat : angular.copy(load_stat);
                      }
                  }
              });

              if(vm.currentState != 'app.quotes.quotesDetails' && action != 'bookingRequest'){
                vm.ScheduleCard = vm.ScheduleCard ? vm.ScheduleCard : currentCard;
                  angular.forEach(vm.ScheduleCard.data.buy_rates, function (value, key) {
                      if(!value.rate_obj && !tempBuyRates[key]){
                          tempBuyRates[key] = angular.copy(vm.ScheduleCard.data.buy_rates[key]); // coping orignal null object to show N/A on card
                          tempSellRates[key] = angular.copy(vm.ScheduleCard.data.buy_rates[key]);
                      }
                  });
              }

              currentCard.data.sell_rates = tempSellRates;
              currentCard.data.buy_rates = tempBuyRates;
              currentCard.meta.is_selected = true;
              currentCard.meta.buy_leg_total = resultService.calCardTotal(currentCard.data.buy_rates);
              currentCard.meta['card_total_cost'] = resultService.calCardTotal(currentCard.data.sell_rates);
              // To store Co2 data
              vm.fnSetCo2InCard(currentCard.data.buy_rates[vm.l3_leg].rate_obj, currentCard.meta, currentCard.meta.port_data.origin_port_code, currentCard.meta.port_data.destination_port_code);

              currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);
              currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);
              currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);

              if(vm.currentState != 'app.quotes.quotesDetails' && action != 'bookingRequest'){
                  vm.ScheduleCard.meta = angular.copy(currentCard.meta);
                  vm.ScheduleCard.data = angular.copy(currentCard.data);
              }

              if(action == 'bookingRequest'){
                vm.requestToBook(currentCard, 'fromModal');
                return;
              }
              vm.callback({card : {'currentCard' :currentCard, 'action' : 'addInToQuote' }});
              $mdDialog.hide();
              vm.footerObj.doneBtnDisable = false;

              //mixpanel code
              util.callMixpanel("Rate Card Added To Quote",{
                  "Mode": vm.search_param.mode
              });
          }
      }
      
      vm.removeCurrentCard = null

      function showRemoveConfirmationPopup(currentCard, ev) {
        vm.removeCurrentCard = currentCard
         $mdDialog.show({
            templateUrl        : 'app/main/component/rate-card-table/confirm-leave/confirm-leave.html',
            targetEvent        : ev,
            clickOutsideToClose: true,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
      });
      }
      
      vm.confirmLeave = confirmLeave;
      

        function confirmLeave(type, card , ev) {
          // console.log(card)
            // yes -- switch to view profile and remove changes
            if(type==="yes") {
             vm.removeCard(card)
                // vm.editView = false;
                // vm.fnResetLogo();
            }
             $mdDialog.hide();
        }

      function removeCard(currentCard){ 
        vm.callback({card : {'currentCard' :currentCard, 'action' : 'removeFromQuote' }});
      }

      function requestToBook(currentCard, action){
        currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);
        currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);
        currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);
        
        // quote page booking
          if(vm.parentPage == 'quotes'){
            vm.callback({card : {'currentCard' :currentCard, 'index':vm.index, 'action' : 'bookingRequest' }});
            return;
          }
          
          if( (!util.navPermission.shipments || !util.navPermission.shipments[0]) || (!currentCard.meta.selected_schedule && ( !currentCard.meta.isScheduleCall )) ){
              return true;
          }

          if(action == 'fromModal'){
            vm.util.isCallingApi = true; // loading icon
              $mdDialog.hide().then(function() {
              vm.callback({card : {'currentCard' :currentCard, 'index':vm.index, 'action' : 'bookingRequest' }});
              }, function() {
            vm.util.isCallingApi = false; 
              return false;
              });
          }else{
              vm.callback({card : {'currentCard' :currentCard, 'index':vm.index, 'action' : 'bookingRequest' }});
          }
      }

      //  close dialog function
      function cancelDialog() {
        vm.currentCard.meta.remarks = util.encodeValue(vm.currentCard.meta.remarks);
        vm.currentCard.meta.inclusions = util.encodeValue(vm.currentCard.meta.inclusions);
        vm.currentCard.meta.internal_remarks = util.encodeValue(vm.currentCard.meta.internal_remarks);
        
          $mdDialog.hide();
      }

      function openDeleteCard(ev, carddata,index,quoteType){
          vm.callback({card : {'currentCard' : carddata, 'action' : 'manualCardDelete' ,'index':index,'quoteType':quoteType}});
      }

      function openEditCardModal(ev, carddata){
          vm.callback({card : {'currentCard' : carddata, 'action' : 'manualCardEdit' }});
      }

      // function to determine leg load Missing or not
      function isLegLoadMissing (loadObj, Key) {
          var tempLoad = angular.copy(loadObj);
          // angular.forEach(filterconfigObj, function (value, key) {
          //     if (!(key == 'inco_term' || key == 'search_name' || key == vm.l3_leg || key == 'value_of_good' || key == 'insurance_currency')) {
          //     if (!value.is_selected) {
          //         delete tempLoad[key];
          //     }
          //     }
          // });
          return resultService.isLegLoadMissing(tempLoad, Key);
      }

      function legPerUnitCost(rateObj){
          var leTotal = 0;

          angular.forEach(rateObj.charges, function (value) {
              leTotal += parseFloat(value.leg_currency_cost / value.total_units);
          });
          return leTotal;
      }

      function loadMoreRecords() {
          vm.chargeShow += 2;
      }

      vm.maxHeight = {
          "max-height": '200px'
      }

      vm.hoverIn = function () {
      this.hoverEdit = true;
      };

      vm.hoverOut = function () {
      this.hoverEdit = false;
      };

      vm.hoverTransitIn = function () {
      this.hoverTransitEdit = true;
      };

      vm.hoverTransitOut = function () {
      this.hoverTransitEdit = false;
      };


      function fnSwitchRates(card, rateName){
        card.meta.selectedLeg = rateName;
        card.data.buy_rates[vm.l3_leg].rate_obj = angular.copy(card.data.buy_rates[vm.l3_leg][rateName]);
        card.data.sell_rates = null;
        card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
        card.meta['card_total_cost'] = resultService.calCardTotal(card.data.sell_rates);

      }

      function fnCalAirSlab(val){
         var result = 0;
         result = Math.abs(val);
         return result;
      }



      function fnCheckIsNaN(charge, param){
         var result = '';
         if(param == 'per_unit_rate'){
          if(angular.isString(charge.per_unit_rate)){
              result = charge.per_unit_rate;
          }else{
              result =  $filter('number')(charge.per_unit_rate, 2);
          }
         }else{
          if(!charge.min_flag && angular.isString(charge.charge_cost)){
              result = charge.charge_cost;
          }else{
              result =  $filter('number')(charge.leg_currency_cost, 2);
          }
          }
         return result;
      }

      function isString(data) {
        if(typeof data === 'string') {
          return true;
        } else {
          return false;
        }
      }

      function fnCollapseContent(content_id){
          var id = '#' + content_id;
          angular.element(id).slideToggle();
      }


      // Binding Services to scope
      vm._mdPanel = $mdPanel;
      vm.showCostBreakdown = showCostBreakdown;
      vm.showWMInfo = showWMInfo;

      function showCostBreakdown(cardData, ev, rate_type) {
        vm.viewCostCard = cardData;
        var tooltipId = rate_type == 'buy_rates' ? 'buy' : 'sell'
        var pageData={}
        var position = vm._mdPanel.newPanelPosition()
          .relativeTo('.card-'+vm.viewCostCard._id+'-'+tooltipId)
          .addPanelPosition(vm._mdPanel.xPosition.CENTER, vm._mdPanel.yPosition.BELOW);
          if(vm.search_param.mode == 'SEA-FCL'){
            pageData.url='app/main/component/charges-view/charges-view.html';
            pageData.controller='ChargesViewController';
          }
          else{
            pageData.url= 'app/main/component/cost-view/cost-view.html';
            pageData.controller='CostViewController';
          }

        var config = {
          attachTo: angular.element(document.body),
          templateUrl:pageData.url ,
          controllerAs: 'ctrl',
          controller: pageData.controller,
          position: position,
          openFrom: ev,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: false,
          zIndex: 2,
          locals: {
            'userbasecurrency': vm.searchparam.user.user_base_currency,
            'card': vm.viewCostCard,
            'l3_leg': vm.l3_leg,
            'mainFreightName': vm.mainFreightName,
            'totalCost':vm.viewCostCard.meta[vm.resultfilter.total_cost],
            'buyOrSell': rate_type ? rate_type : vm.buyOrSell,
            'search_param':vm.search_param
          },
          onOpenComplete: function () {
            // costViewFactory.panelClosed = false;
          },
          onRemoving: function () {
            // costViewFactory.panelClosed = true;
          }
        };

        vm._mdPanel.open(config);

        //mixpanel code
        var id = vm.mixpanelSorce+'-RateCard-TotalCost-Click';
  
        util.callMixpanel(id,{
          "Mode": vm.search_param.mode
        });
      }

      function showWMInfo(ev, leg, key){
        var position = vm._mdPanel.newPanelPosition()
          .relativeTo('.charge_'+leg.global_leg_id+'_'+key)
          .addPanelPosition(vm._mdPanel.xPosition.CENTER, vm._mdPanel.yPosition.BELOW);

        var config = {
          attachTo: angular.element(document.body),
          templateUrl: 'app/main/result/Dialogs/per_wm_info/per_wm_info.html',
          controllerAs: 'ctrl',
          controller: 'PerWMController',
          position: position,
          openFrom: ev,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: false,
          zIndex: 2,
          locals: {
            'globalid': leg.global_leg_id,
            'charge': leg.charges[key],
            'ltldetails': vm.currentCard.meta.ltl_load_details
          },
          onOpenComplete: function () {
            // perWMFactory.panelClosed = false;
          },
          onRemoving: function () {
            // perWMFactory.panelClosed = true;
          }
        };

        vm._mdPanel.open(config);
      }

      function ShowNoRatesInfo(ev, card_id, noRatesMessage) {
        var position = $mdPanel.newPanelPosition()
          .relativeTo('.noRates-'+card_id)
          .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
  
        var config = {
          attachTo: angular.element(document.body),
          templateUrl: 'app/main/component/no-rates-info/no-rates-info.html',
          controllerAs: 'ctrl',
          controller: 'NoRatesInfoController',
          position: position,
          openFrom: ev,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: false,
          zIndex: 10000,
          locals: {
            'errorMessage': noRatesMessage,
          },
          onOpenComplete: function () {
          },
          onRemoving: function () {
          }
        };
  
        vm._mdPanel.open(config);
      }

      function selectedDuplicateQuote(currentCard){
        vm.callback({card : {'currentCard' :currentCard, 'action' : 'duplicate' }});
      }
      function viewQuoteDetails(currentCard,ev,activeTab){
        // removing load wise expiry while copying card
        currentCard.meta.remarks = util.decodeValue(currentCard.meta.remarks);        
        currentCard.meta.inclusions = util.decodeValue(currentCard.meta.inclusions);        
        currentCard.meta.internal_remarks = util.decodeValue(currentCard.meta.internal_remarks);

        if(activeTab == 'newCopyQuote'){
          currentCard.data.buy_rates[vm.l3_leg].rate_obj['detailed_effective_load'] = {};
          currentCard.data.sell_rates[vm.l3_leg].rate_obj['detailed_effective_load'] = {};
        }
        if(vm.util.isAdmin ||(vm.util.userProfile.user && vm.util.userProfile.user.is_pricing_user)){
          var batchcode=[]
          batchcode=resultService.getBatchcode(currentCard)
          if(batchcode.length){
            resultService.getSourceRate(batchcode).then(function(response){
            vm.sourceRate=angular.copy(response.data.data);
            vm.callback({card : {'currentCard' :currentCard, 'action' : 'viewQuoteRates','ev': ev,'activeTab':activeTab,'sourceRate':vm.sourceRate}});
            },function(error){
              vm.callback({card : {'currentCard' :currentCard, 'action' : 'viewQuoteRates','ev': ev,'activeTab':activeTab}});
            })
          }
          else
          {
            vm.callback({card : {'currentCard' :currentCard, 'action' : 'viewQuoteRates','ev': ev,'activeTab':activeTab}});
          }
        }
        else{
        vm.callback({card : {'currentCard' :currentCard, 'action' : 'viewQuoteRates','ev': ev,'activeTab':activeTab}});
        }
      }

      function cancelDeleteCard(ev,currentId,index){
        vm.callback({card : {'_id' :currentId, 'action' : 'cancelDeleteCard' ,'index':index}});
      }

      function undoDeleteCard(ev,currentCard,index){
        vm.callback({card : {'currentCard' :currentCard, 'action' : 'undoDeleteCard' ,'index':index}});
      }

      function removeCardFromQuote(ev,currentCard,index){
        vm.callback({card : {'currentCard' :currentCard, 'action' : 'removeCardFromQuote' ,'index':index}});

      }

      function trackEvent(type) {
       var id= vm.mixpanelSorce+'-RateCard-'
        if(type === "viewDetails"){
          var carrier = vm.search_param.mode === 'AIR' ? vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.airline.air_line_name : vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name ;
          util.callMixpanel( id+type+'-Click', {
            "Mode": vm.search_param.mode,
            "Carrier":carrier
          });
        }
        if(type === "spotHover") {
          util.callMixpanel(id+"Spotinfo-Hover",{
            "Mode": vm.search_param.mode
          });
        }
        if(type === "cargoHover") {
          util.callMixpanel(id+"CargoDetails-Hover",{
            "Mode": vm.search_param.mode
          });
        }
        if(type === "missingHover") {
          util.callMixpanel(id+"MissingIcon-Hover",{
            "Mode": vm.search_param.mode
          });
        }
      }
      function downloadSourceRate(currCard){
        var batchcode=[]
        batchcode=resultService.getBatchcode(currCard)
        if(batchcode.length){
          resultService.getSourceRate(batchcode).then(function(response){
            vm.sourceRate=angular.copy(response.data.data);
          })
        }
      }

      // set co2e in respective card meta
      function fnSetCo2InCard(rate_obj, meta, origin , destination){
        if(!vm.resultfilter.co2eResponse || !Object.keys(vm.resultfilter.co2eResponse).length || rate_obj.manual || meta["co2eData"]){
          return;
        }
          var carrierCode = rate_obj.provider && rate_obj.provider.carrier_code ? rate_obj.provider.carrier_code : rate_obj.sub_vendor.carrier_code;
          var co2ForCarrier = vm.resultfilter.co2eResponse[carrierCode];
          if(co2ForCarrier && co2ForCarrier.length){
            for(var i = 0; i < co2ForCarrier.length; i++){
              if((co2ForCarrier[i].origin === origin ) && (co2ForCarrier[i].destination === destination) && co2ForCarrier[i].container_emissions.length){
                meta["co2eData"] = angular.copy(co2ForCarrier[i]);
              }
            }
          }
      }

      function freeDaysTabView(){
        vm.viewActiveTab = 'loadWiseFreeDays';

      }

      function selectMultiSchedule(selectedSchedule , isSelected){
        if(vm.multi_schedule_list && vm.multi_schedule_list.length == 15 && selectedSchedule.isSelected){
          selectedSchedule.isSelected = false;
          util.showToast("Maximum limit reached - 15");
          return;
        }
        if(!selectedSchedule.isSelected){
            vm.multi_schedule_list = vm.multi_schedule_list.filter(function(schedule){
              return schedule.id != selectedSchedule.id
            })
            // removing current schedule if it's removed from multi schedule list
            if(vm.current_schedule && (selectedSchedule.id ==  vm.current_schedule.id)){
              vm.current_schedule = null
              vm.current_schedule = vm.multi_schedule_list.length ? vm.multi_schedule_list[0] : null;
            }
         
        }else{
          // setting the first selected schedule from multi schedule as a current schedule if it is empty
          vm.current_schedule = vm.current_schedule ? vm.current_schedule : (!vm.multi_schedule_list.length ? selectedSchedule : null );
          vm.multi_schedule_list.push(selectedSchedule)
          
        }
        vm.selectedSchedule();

      }
      function fnClearAllSchedule(){
          if(vm.multi_schedule_list && vm.multi_schedule_list.length) {
                vm.current_schedule = null;
                vm.multi_schedule_list = [];
                angular.forEach(vm.scheduleList ,function(schedule){
                  schedule["isSelected"] = false;
                })
                vm.selectedSchedule();
          }
      }

      function cancelDialogXeneta(){
        $mdDialog.hide();
      }

      function showXenetaGraph(ev, cardData) {
        if(!cardData.meta.isError){
        var position = $mdPanel.newPanelPosition()
          .relativeTo('.xeneta-'+cardData._id)
          .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
  
        var config = {
          attachTo: angular.element(document.body),
          templateUrl: 'app/main/component/xeneta-view/xeneta-view.html',
          controllerAs: 'ctrl',
          controller: 'XenetaRateIndexController',
          position: position,
          openFrom: ev,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: false,
          zIndex: 2,
          locals: {
            'card': cardData,
          },
          onOpenComplete: function () {
            // cargoCommodityViewFactory.panelClosed = false;
          },
          onRemoving: function () {
            // cargoCommodityViewFactory.panelClosed = true;
          }
        };
  
        $mdPanel.open(config);
      }
      else{
        vm.xenetadata=cardData
       $mdDialog.show({
            templateUrl        : 'app/main/result/Dialogs/view-details/xenetaNoRatesPopup.html',
          targetEvent: ev,
          clickOutsideToClose: false,
          onComplete: vm.afterShowAnimation,
          animation: false,
          controllerAs: 'ctrl',
          controller: function () { this.parent = vm },
          onRemoving: function (event, removePromise) {
            for (var name in CKEDITOR.instances) {
              CKEDITOR.instances[name].destroy();
            }
          }
          });

      }
      }

      function reSyncTmsData(currentCard){
       
        vm.callback({card : {'currentCard' :currentCard, 'action' : 'reSyncTmsData' }});
      }
  }

})();

(function () {
  'use strict';

  angular
  .module('app.core')
  .component('refreshRates', {
      templateUrl: 'app/main/component/refresh-rates/refresh-rates.html',
      bindings : {
        searchParam : '=',
        quoteResult: '=',
        loadString: '=',
        source: '=',
          callback : '&'
      },
      controller: RefreshRatesController
  });


  function RefreshRatesController(util,$mdDialog,$filter,$state,$log,SearchService,$rootScope,resultService,analytics,$timeout, ScheduleSearchService) {
      var vm = this;

      vm.util = util;
      vm.rateRefresh = rateRefresh;
      vm.closeDialog = closeDialog;
      vm.makeDetailBoxString = makeDetailBoxString;
      vm.trackEvent = trackEvent;
      vm.cargo_ready_date ;
      vm.detailBoxString;
      vm.detailBoxTooltip;
      vm.minDate = new Date();
      vm.cargoDateValidation = false;
      vm.fnDialogSwitchToDoorPort = fnDialogSwitchToDoorPort;
      vm.fnRemovePortChip = fnRemovePortChip;
      vm.checkForDuplicatePorts = checkForDuplicatePorts;
      vm.checkForSamePorts = checkForSamePorts;
      vm.getPortsLocation = getPortsLocation;
      vm.getsearchTypeData = getsearchTypeData;
      vm.fnCheckToShowPolPod=fnCheckToShowPolPod;
      vm.getPolPodLocation=getPolPodLocation;
      vm.fnPrefillPolPodData = fnPrefillPolPodData;
      vm.viewToggleOrigin="";
      vm.viewToggleDestination=""
      vm.duplicatePortValidation = '';
      vm.includeSdOrigin=false;
      vm.formSubmit = false;
      vm.show_origin_port = false;
      vm.formIsPristine = true;
      vm.originNearbyPortLimit = 1;
      vm.destinationNearbyPortLimit =  1;
      vm.enabled_nearby = $rootScope.domainData.domain_info["GET_NEARBY_PORT_RESULT"] ? true: false;
      vm.isPcmsEnabled = $rootScope.domainData.domain_info.POSTALCODES_ENABLED;
      vm.originPortLimit = $rootScope.domainData.domain_info["MAX_POL_POD"] ? $rootScope.domainData.domain_info["MAX_POL_POD"].origin : 1;
      vm.destinationPortLimit =  $rootScope.domainData.domain_info["MAX_POL_POD"] ?$rootScope.domainData.domain_info["MAX_POL_POD"].destination :1;
      vm.enabled_pol_pod = $rootScope.domainData.domain_info["ENABLED_POL_POD"];
      vm.is_independent_search = $rootScope.domainData.domain_info["ENABLED_POL_POD"] && $rootScope.domainData.domain_info["POSTALCODES_ENABLED"];
      vm.isStopOriginPortInput = isStopOriginPortInput;
      vm.isStopDestinationPortInput = isStopDestinationPortInput;
      vm.fnPrefillNearbyPortData=fnPrefillNearbyPortData;
      vm.formPayload=formPayload;
      vm.fnUpdateLocation=fnUpdateLocation;
      vm.showLocationToggle = [];
      vm.serviceMode = {
          "FCL": ["DOOR","CY"],
          "LCL": ["DOOR","CFS"],
          "AIR": ["DOOR","AIRPORT"],
      }
    vm.isLoadingServiceMode = false;
      this.$onInit = function() {
        vm.searchParamData = angular.copy(vm.searchParam);
        vm.mode=vm.searchParamData.mode;
        vm.fnUpdateLocation();
        vm.isMultiDoor =  $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] &&  vm.mode=='SEA-FCL' ? true : false;
        if($rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode] && $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode].includes('*')){
          var portLimitList = $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode].split('*')
           vm.originMultiPortPairLimit = portLimitList[0];
           vm.destinationMultiPortPairLimit = portLimitList[1];
           vm.is_nXn_search = true;
         }else{
           vm.multiPortPairLimit =  $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode];
           vm.is_nXn_search = false;
         }
         if($rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode] && vm.mode=='SEA-FCL'){
          if($rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode].includes('*')){
            var portLimitList = $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode].split('*')
             vm.originMultiDoorLimit= portLimitList[0];
             vm.destinationMultiDoorLimit = portLimitList[1];
             vm.is_door_nXn_search = true;
           }else{
             vm.multiDoorLimit =  $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][vm.mode];
             vm.is_door_nXn_search = false;
           }
         }
        vm.isMultiPort =  $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] && ((vm.multiPortPairLimit > 1 && !vm.is_nXn_search) || ((vm.originMultiPortPairLimit > 1 || vm.destinationMultiPortPairLimit > 1) && vm.is_nXn_search))  && vm.searchParamData.mode=='SEA-FCL' ? true : false;
        vm.originNearbyPortLimit = vm.isMultiPort  ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] : 1 :$rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] ? $rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] : 1;
        vm.destinationNearbyPortLimit =  vm.isMultiPort  ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] : 1 :$rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] ? $rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] : 1;
        
        var serviceLocationToggle = $rootScope.domainData.domain_info.SHOW_LOCATION_TOGGLE;
        var accountType = util.isShipper ? 'SHIPPER' : 'FORWARDER';
        var mode = vm.mode === 'SEA-FCL' ? 'FCL' : (vm.mode === 'AIR' ? 'AIR' : 'LCL');
        var serviceMode = util.checkKeyPresent(serviceLocationToggle,accountType,mode);
        
        if(serviceMode && serviceMode.length === 1) {
          vm.isLoadingServiceMode = true;
          util.isCallingApi = true;
        }else{
          vm.showLocationToggle = vm.serviceMode[mode];
        }
        
        $timeout(function () {
          prefilledMultiportData();
          getsearchTypeData();

          if(serviceMode && serviceMode.length === 1){
            vm.showLocationToggle = serviceMode.map(function (item) { return item.toUpperCase() });
            serviceToggleMapping();
          }
          util.isCallingApi = false;
          vm.isLoadingServiceMode = false;
         
        }, 1000);
        if(!vm.isMultiPort && !vm.isMultiDoor){
          vm.searchParamData.origin_location['input_type']='user'
          vm.searchParamData.destination_location['input_type']='user'
          vm.searchParamData['user_nearby_origin'] = [vm.searchParamData.origin_location];
          vm.searchParamData['user_nearby_destination'] = [vm.searchParamData.destination_location];
        }
       
        vm.searchParamData.shipper_user = vm.quoteResult.result_data.created_for;
        vm.pagePrefix = vm.source === 'quote' ? 'QD' : 'QC';
        vm.makeDetailBoxString();
        vm.show_origin_port = vm.fnCheckToShowPolPod('origin');
        vm.show_destination_port = vm.fnCheckToShowPolPod('destination');
      }

      function serviceToggleMapping(){
        var viewServiceToggle = vm.showLocationToggle[0] === 'DOOR' ? 'door' : 'port';
        if((viewServiceToggle === 'door' && vm.searchParamData.search_type != 'D2D') || (viewServiceToggle === 'port' && vm.searchParamData.search_type != 'P2P')){
          vm.fnDialogSwitchToDoorPort(viewServiceToggle,'origin');
          vm.fnDialogSwitchToDoorPort(viewServiceToggle,'destination');
        }
      }

      function checkForMultiPort(){
        if(vm.isMultiPort  || vm.isMultiDoor){
          vm.searchParamData.origin_location = vm.searchParamData.user_nearby_origin[0];
          vm.searchParamData.destination_location = vm.searchParamData.user_nearby_destination[0];
          if(!vm.searchParamData.search_name){
            var searchStr = '';
            var originPorts=  ScheduleSearchService.getCommaSeparatedData(vm.searchParamData.user_nearby_origin,'location');
            var destinationPorts=  ScheduleSearchService.getCommaSeparatedData(vm.searchParamData.user_nearby_destination,'location');
            searchStr =  originPorts+' to '+destinationPorts;
            vm.searchParamData.search_name = searchStr.trim()+ ' / ' + $filter('date')(vm.searchParamData.cargo_ready_date, 'd MMM yyyy');
          }
        }
      }
      function fnUpdateLocation(){
        // vm.searchParamData['nearby_origin']=vm.searchParamData.user_nearby_origin.filter(function(item){
        //   return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
        // });
        // vm.searchParamData['nearby_destination']=vm.searchParamData.user_nearby_destination.filter(function(item){
        //   return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
        // });
        // vm.searchParamData['origin_alias']=vm.searchParamData.user_nearby_origin.filter(function(item){
        //   return (item.input_type == 'alias');
        // });
  
        // vm.searchParamData['destination_alias']=vm.searchParamData.user_nearby_destination.filter(function(item){
        //   return (item.input_type == 'alias');
        // });
        // vm.searchParamData.user_nearby_origin =  vm.searchParamData.user_nearby_origin.filter(function(item){
        //   return (item.input_type == 'user' || !item.input_type);
        // });
        // vm.searchParamData.user_nearby_destination =  vm.searchParamData.user_nearby_destination.filter(function(item){
        //   return (item.input_type == 'user' || !item.input_type);
        // });
        // vm.searchParamData.user_nearby_origin.forEach(function(value){
        //   if(!value.input_type){
        //    value['input_type']='user'
        //   }
        //  })
        //  vm.searchParamData.user_nearby_destination.forEach(function(value){
        //    if(!value.input_type){
        //     value['input_type']='user'
        //    }
        //   })
        // if(!vm.enabled_nearby){
          vm.searchParamData['nearby_origin']=[]
          vm.searchParamData['nearby_destination']=[]
          vm.searchParamData.fetch_nearby_destination=false;
          vm.searchParamData.fetch_nearby_origin=false;
          
       // }
      }
  
      function rateRefresh() {
        var searchFormValidations = {
          'Origin':'',
          'CutOff Date':'',
          'Destination':'',         
       }
       vm.formSubmit = true;
       vm.polValidation = false;
       vm.podValidation = false;
       if(vm.mode === "SEA-FCL" && !vm.isShipper ){
   
        if (vm.viewToggleOrigin == "door"){
             vm.searchParamData["origin_service_mode"] = "SD";
        }
        else if (vm.includeSdOrigin && vm.viewToggleOrigin == "port") {
            vm.searchParamData["origin_service_mode"] = "CY/SD";
        }
        else{
           vm.searchParamData["origin_service_mode"] = "CY";
        }
          if (vm.viewToggleDestination == "door") {
            vm.searchParamData["destination_service_mode"] = "SD";
          } else if (vm.includeSdDestination && vm.viewToggleDestination == "port") {
            vm.searchParamData["destination_service_mode"] = "CY/SD";
          } else {
            vm.searchParamData["destination_service_mode"] = "CY";
          }
        
      }
        vm.tempMinDate = $filter('date')(vm.minDate, 'yyyy-MM-dd');
        if(vm.searchParamData.cargo_ready_date < vm.tempMinDate){
          vm.cargoDateValidation = true;
          return;
        }
        if(vm.isMultiPort && vm.searchParamData['user_nearby_origin'].length > vm.multiPortPairLimit){
          vm.refreshForm.user_nearby_origin.$error.maxchips= true;
          return;
        }
        if(vm.isMultiPort && vm.searchParamData ['user_nearby_destination'].length > vm.multiPortPairLimit){
          vm.refreshForm.user_nearby_destination.$error.maxchips= true;
          return;
        } 
        if(vm.refreshForm.nearby_origin_ports && vm.searchParamData.user_pol.length > vm.originPortLimit){
          vm.refreshForm.nearby_origin_ports.$error.maxchips= true;
          return;
        }
        if(vm.refreshForm.nearby_destination_ports && vm.searchParamData.user_pod.length > vm.destinationPortLimit){
          vm.refreshForm.nearby_destination_ports.$error.maxchips= true;
          return;
        }
        if(vm.searchParamData.fetch_nearby_origin && vm.searchParamData['nearby_origin'].length > vm.originNearbyPortLimit){
          vm.refreshForm.nearby_origin.$error.maxchips= true;
          return;
        }
        if(vm.searchParamData.fetch_nearby_destination && vm.searchParamData['nearby_destination'].length > vm.destinationNearbyPortLimit ){
          vm.refreshForm.nearby_destination.$error.maxchips= true;
          return;
        }
  
       
        if (Object.keys(vm.refreshForm.$error).length || ((vm.isMultiPort || vm.isMultiDoor) && (!vm.searchParamData.user_nearby_origin.length || !vm.searchParamData.user_nearby_destination.length))) {
          searchFormValidations['Origin']= (vm.isMultiPort || vm.isMultiDoor) ? (!vm.searchParamData.user_nearby_origin.length ? 'Required' :'') : (!vm.searchParamData.origin_location ? 'Required' :'');
          searchFormValidations['Destination']=  (vm.isMultiPort || vm.isMultiDoor) ? (!vm.searchParamData.user_nearby_destination.length ? 'Required' :'') : (!vm.searchParamData.destination_location ? 'Required' :'') ;
          return;
        }
          checkForMultiPort();
          vm.polValidation = (vm.enabled_pol_pod &&  vm.searchParamData.origin_location.place_type == 'Door' && !vm.searchParamData["user_pol"].length);
    vm.podValidation = (vm.enabled_pol_pod &&  vm.searchParamData.destination_location.place_type == 'Door' && !vm.searchParamData["user_pod"].length);
    vm.nearByOriginValidation= vm.mode != 'AIR' && vm.enabled_nearby && vm.searchParamData.fetch_nearby_origin && !vm.searchParamData['nearby_origin'].length
    vm.nearByDestinationValidation= vm.mode != 'AIR' && vm.enabled_nearby && vm.searchParamData.fetch_nearby_destination && !vm.searchParamData['nearby_destination'].length
      if(vm.nearByOriginValidation || vm.nearByDestinationValidation){
        return
         }

    if(vm.mode === 'SEA-FCL' && (vm.polValidation || vm.podValidation || vm.duplicatePortValidation) ){
      return;
    }
    vm.searchParamData.origin_input_text = vm.searchOrgText;
    vm.searchParamData.destination_input_text = vm.searchDestText;
    if(!vm.enabled_pol_pod && vm.mode === 'SEA-FCL'){
      vm.searchParamData["user_pol"] = [];
      vm.searchParamData["user_pod"] = [];
    }
    if( vm.mode != 'AIR' && !vm.enabled_nearby){
      vm.searchParamData.fetch_nearby_destination=false;
      vm.searchParamData.fetch_nearby_origin=false;
      vm.searchParamData['nearby_origin']=[];
      vm.searchParamData['nearby_destination']=[];
    }

        vm.searchParamData.cargo_ready_date = $filter('date')(vm.searchParamData.cargo_ready_date, 'yyyy-MM-dd');
        vm.searchParamData.quote_id= vm.quoteResult.result_data._id,
        vm.searchParamData.quote_number= vm.source=='quote' ? vm.quoteResult.result_data.quote_id : '',
        vm.searchParamData.source = vm.source.replace('-', '_');
        
        vm.searchParamData["fetchType"] = $rootScope.domainData.domain_info.ALLOW_RESULT_POLLING ? "pooling" : null;
        if(vm.searchParamData['nearby_origin'] && vm.searchParamData['nearby_origin'].length &&  vm.mode != 'AIR'){
          vm.searchParamData.user_nearby_origin=vm.searchParamData.user_nearby_origin.concat(vm.searchParamData['nearby_origin'])
          delete vm.searchParamData['nearby_origin']
        }
        if(vm.searchParamData['nearby_destination'] &&vm.searchParamData['nearby_destination'].length &&  vm.mode != 'AIR'){
          vm.searchParamData.user_nearby_destination=vm.searchParamData.user_nearby_destination.concat(vm.searchParamData['nearby_destination'])
          delete vm.searchParamData['nearby_destination']
        }
       
        
        if(!(vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length) || (!(vm.isMultiDoor || vm.isMultiPort)) )
          {
            vm.searchParamData.user_nearby_origin = [];
            vm.searchParamData.user_nearby_origin.push(vm.searchParamData.origin_location);
          }
          if(  !(vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length) || (!(vm.isMultiDoor || vm.isMultiPort)))
          {
            vm.searchParamData.user_nearby_destination = [];
            vm.searchParamData.user_nearby_destination.push(vm.searchParamData.destination_location);
          }
          if( vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length ){
            vm.searchParamData.origin_location = vm.searchParamData.user_nearby_origin[0];
         }
         if(vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length){
            vm.searchParamData.destination_location = vm.searchParamData.user_nearby_destination[0];
         }
         vm.searchParamData.search_name = (vm.searchParamData.search_name ? vm.searchParamData.search_name : vm.searchParamData.origin_location.location + ' to ' + vm.searchParamData.destination_location.location + ' / ' + $filter('date')(vm.searchParamData.cargo_ready_date, 'd MMM yyyy'));
         
        var data = { search_param : vm.searchParamData };
        util.isCallingApi = true;
        resultService.refreshQuoteData.oldCards=vm.quoteResult.result_data.cards;
        SearchService.postSearchData(data).then(function(response){
          if(response.data.data.result_meta.search_param.mode == "SEA-FCL"){
            SearchService.FclResult =  response.data.data;
            SearchService.isNewSearch = true;
            var pageState = $rootScope.domainData.domain_info.ALLOW_RESULT_POLLING ? 'app.search.fclV2Rates' :  'app.search.result';
            redirectToResult(pageState, SearchService.FclResult._id);
          }
          else if(response.data.data.result_meta.search_param.mode == "AIR"){
            SearchService.AirResult =  response.data.data;
            SearchService.isNewSearch = true;
            redirectToResult('app.search.airResult', SearchService.AirResult._id);
          }
          else if(response.data.data.result_meta.search_param.mode == "SEA-LCL"){
            SearchService.LclResult =  response.data.data;
            SearchService.isNewSearch = true;
            redirectToResult('app.search.lclResult', SearchService.LclResult._id);
          }
          util.isCallingApi = false;
      },function(error){
          util.isCallingApi = false;
          util.showToast(error.data.message);
          $log.log(error);
      });
      }
      function fnRemovePortChip(chip , routeType){
        if(routeType == 'origin_location'){
          vm.refreshForm.nearby_origin_ports.$error.maxchips = false ; 
        }else if(routeType == 'destination_location'){
          vm.refreshForm.nearby_destination_ports.$error.maxchips = false; 
        }
        else if(routeType == 'nearby_origin'){
          vm.refreshForm.nearby_origin.$error.maxchips = false; 
          vm.nearByOriginValidation=false;
        }
        else if(routeType == 'nearby_destination'){
          vm.refreshForm.nearby_destination.$error.maxchips = false; 
          vm.nearByDestinationValidation=false;
        }
    
        // removing errors while removing the chips/port 
          if((routeType == 'origin_location' || routeType == 'destination_location') && !vm.isMultiPort && !vm.isMultiDoor && vm.searchParamData[routeType]){
            if(chip.portcode_portname == vm.searchParamData[routeType].portcode_portname){
              vm.duplicatePortValidation = '';
            }
    
          }else{
                if(routeType == 'origin'){
                  vm.refreshForm.user_nearby_origin.$error.maxchips = false; 
                  if(!(vm.searchParamData.user_nearby_origin &&vm.searchParamData.user_nearby_origin.length)){
                  vm.show_origin_port = false ;
                  vm.searchParamData["user_pol"] = [];
                  vm.polValidation = false;
                  }
    
                }else{
                  if(routeType == 'destination'){
                  vm.refreshForm.user_nearby_destination.$error.maxchips = false ; 
                  if(!(vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length)){
                  vm.show_destination_port = false ; 
                  vm.searchParamData["user_pod"] = [];
                  vm.podValidation = false;
                  }
                  }
                }
              }
        }
        function fnPrefillNearbyPortData(selectedData , routeType){
          var nearbySelected = routeType == 'nearbyOrigin' ? vm.searchParamData.fetch_nearby_origin : vm.searchParamData.fetch_nearby_destination;
          var enabledPort = (routeType == 'nearbyOrigin') ? "nearby_origin" :"nearby_destination";
          if( vm.enabled_nearby && vm.mode != 'AIR' && nearbySelected){
              // var leg_code = (enabledPort == 'user_pol') ? 'l1' : 'l5' ;
               var origin_details = [];
               var destination_details = [];
               var selected_origin=[];
               var selected_destination=[];
               origin_details = vm.searchParamData.nearby_origin.length ? vm.searchParamData.nearby_origin : [];
               destination_details = vm.searchParamData.nearby_destination.length ?   vm.searchParamData.nearby_destination : [];
               if(vm.isMultiPort || vm.isMultiDoor){
                selected_origin = vm.searchParamData.user_nearby_origin.length ? vm.searchParamData.user_nearby_origin : [];
                selected_destination = vm.searchParamData.user_nearby_destination.length ?   vm.searchParamData.user_nearby_destination : [];
               }else{
                selected_origin = vm.searchParamData.origin_location ?  [vm.searchParamData.origin_location] : [];
                selected_destination = vm.searchParamData.destination_location ? [vm.searchParamData.destination_location] : [];
               }
               var duplicateToCheck = (enabledPort == 'nearby_origin') ? angular.copy(origin_details): angular.copy(destination_details )  ;
               var isExist = false;
               util.isCallingApi = true;
               var ApiResponse = [];
               var data = enabledPort == 'nearby_origin' ? angular.copy(selected_origin): angular.copy(selected_destination)
               selectedData ? data.push(selectedData):'';
               data.filter(function(obj, index, self){
                index === self.findIndex(function(item)  {
                    item.global_port_code === obj.global_port_code
               })
          });
               var payload = vm.formPayload(data);
               vm.util.fnGetNearby(payload).then(
                   function (response) {
                    response.data.forEach(function(port_details){
                      port_details["input_type"]='nearby_user'
                   });
                     ApiResponse = response.data;
                       // ignoring duplicate ports from other port
                     if(duplicateToCheck && duplicateToCheck.length){
                       ApiResponse.forEach(function(port_details){
                        port_details["input_type"]='nearby_user'
                         isExist = false;
                         isExist = duplicateToCheck.some(function (other_port_details) {
                           return port_details.global_port_code === other_port_details.global_port_code;
                       });
                         if(!isExist){
                           vm.searchParamData[enabledPort].push(port_details);
                         }
                       });
                       util.isCallingApi = false;
                     }else{

                       vm.searchParamData[enabledPort] = ApiResponse;
                       util.isCallingApi = false;
                     }
                    
                   },
                   function (error) {
                     util.isCallingApi = false;
                     $log.log(error.data);
                   }
           );
         }
         if(!nearbySelected){
          vm.searchParamData[enabledPort]=[]
         }
       }
       function formPayload(data){
        var payload=[];
        data.forEach(function(item){
            payload.push(item._id);
        });
      return {
        'ports': payload
      };
      }
        function checkForDuplicatePorts(chips,source,otherPort){
          vm.portExistIn = '';
          if(chips){
            // removing pol/pod validation if data present
            vm.polValidation = (source == 'originPort') ? false : vm.polValidation ;
            vm.podValidation = (source == 'destinationPort') ? false : vm.podValidation;
            if(!vm.isMultiPort && !vm.isMultiDoor){
              vm.searchParamData.user_nearby_origin = [];
              vm.searchParamData.user_nearby_destination = [];
              if(vm.searchParamData.origin_location){
                vm.searchParamData.user_nearby_origin[0]=vm.searchParamData.origin_location;
              }
              if(vm.searchParamData.destination_location){
                vm.searchParamData.user_nearby_destination[0]=vm.searchParamData.destination_location;
              }
            }
            fnPrefillPolPodData(chips , source);
          
           
            // checking duplicate ports in same fields
            var nearByPortType = source.endsWith('Port') ? (source === 'originPort'? vm.searchParamData.user_pol :vm.searchParamData.user_pod) : (source === 'origin' ? vm.searchParamData.user_nearby_origin :source === 'destination' ? vm.searchParamData.user_nearby_destination:[]);
              var checkDuplicatePort = nearByPortType.findIndex(function (item) {
                if(item && item.place_type !== 'Door'){
                  return item.portcode_portname === chips.portcode_portname;
                }
              });
              var checkSameDuplicateDoor = nearByPortType.findIndex(function (item) {
                if(item && item.place_type === 'Door'){
                  return item._id === chips._id;
                }
              });
           // checking duplicate ports in other fields
           if(source.startsWith('origin') ){
            if( vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length){
            var originDetails =  (vm.searchParamData.user_nearby_destination[0].place_type == 'Door' && vm.enabled_pol_pod) ? vm.searchParamData.user_pod : vm.searchParamData.user_nearby_destination ;
            vm.portExistIn = (vm.searchParamData.user_nearby_destination[0].place_type == 'Door' && vm.enabled_pol_pod) ? 'destination CY' : 'destination' ;
            var checkDuplicateOtherPort = originDetails.findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
          }     
          if( vm.searchParamData['nearby_origin'] && vm.searchParamData['nearby_origin'].length){
           
             var checkDuplicateNearBY= vm.searchParamData['nearby_origin'].findIndex(function (item) {
               return item.portcode_portname === chips.portcode_portname;
             });
             if(checkDuplicateNearBY >= 0){
           
            vm.portExistIn ='Origin Nearby CY'
              vm.checkOtherPort = source;
              return null;
            }
           
           
         } 
         if (vm.searchParamData['nearby_destination'] && vm.searchParamData['nearby_destination'].length){
        
          var checkDuplicateNearBY= vm.searchParamData['nearby_destination'].findIndex(function (item) {
            return item.portcode_portname === chips.portcode_portname;
          });
          if(checkDuplicateNearBY >= 0){
            vm.portExistIn ='Destination Nearby CY'
            vm.checkOtherPort = source;
            return null;
            }
          } 
        }
          if(source.startsWith('destination') ){
            if( vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length){
            var destinationDetails =  (vm.searchParamData.user_nearby_origin[0].place_type == 'Door' && vm.enabled_pol_pod) ? vm.searchParamData.user_pol : vm.searchParamData.user_nearby_origin;
            vm.portExistIn = (vm.searchParamData.user_nearby_origin[0].place_type == 'Door' && vm.enabled_pol_pod) ? 'origin CY' : 'origin';
            var checkDuplicateOtherPort = destinationDetails.findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
          }    
          if (vm.searchParamData['nearby_destination'] && vm.searchParamData['nearby_destination'].length){
           
            var checkDuplicateNearBY= vm.searchParamData['nearby_destination'].findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
            if(checkDuplicateNearBY >= 0){
            vm.portExistIn ='Destination Nearby CY'
           
              vm.checkOtherPort = source;
              return null;
            }
            }  
            if( vm.searchParamData['nearby_origin'] && vm.searchParamData['nearby_origin'].length){
             
               var checkDuplicateNearBY= vm.searchParamData['nearby_origin'].findIndex(function (item) {
                 return item.portcode_portname === chips.portcode_portname;
               });
               if(checkDuplicateNearBY >= 0){
                vm.portExistIn ='Origin Nearby CY'
                vm.checkOtherPort = source;
                return null;
               }
             
           } 
        }
            // checking duplicate ports in other fields
            if(source.startsWith('origin') && vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length){
              if(vm.searchParamData.user_nearby_destination[0].place_type == 'Door'){
                vm.doorExistIn = 'destination' ;
                var checkDuplicateDoor = vm.searchParamData.user_nearby_destination.findIndex(function (item) {
                  return item._id === chips._id;
                });
              }
            }   
            if(source.startsWith('destination') && vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length){
              if(vm.searchParamData.user_nearby_origin[0].place_type == 'Door')
              {
                vm.doorExistIn = 'origin' ;

                var checkDuplicateDoor= vm.searchParamData.user_nearby_origin.findIndex(function (item) {
                  return item.portcode_portname === chips.portcode_portname;
                });
              }
           }  
            if(source ==='nearbyOrigin' ){
              if (vm.searchParamData['nearby_destination'] && vm.searchParamData['nearby_destination'].length){
                var checkDuplicateNearBY= vm.searchParamData['nearby_destination'].findIndex(function (item) {
                  return item.portcode_portname === chips.portcode_portname;
                });
                if(checkDuplicateNearBY >= 0){
                  vm.portExistIn ='Destination Nearby CY'
                  vm.checkOtherPort = source;
                  return null;
              }
                }  
                if (vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length){
                 
                  var checkDuplicateOtherPort= vm.searchParamData.user_nearby_origin.findIndex(function (item) {
                    return item.portcode_portname === chips.portcode_portname;
                  });
                  if(checkDuplicateOtherPort >= 0){
                     vm.portExistIn ='Origin'
                    vm.checkOtherPort = source;
                    return null;
                  }
                  }  
                  if (vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length){
                
                    var checkDuplicateOtherPort= vm.searchParamData.user_nearby_destination.findIndex(function (item) {
                      return item.portcode_portname === chips.portcode_portname;
                    });
                    if(checkDuplicateOtherPort >= 0){
                      vm.portExistIn ='Destination'
                      vm.checkOtherPort = source;
                     return null;
                   }
                  
                    }  
             
            var checkDuplicateSameNearBY=vm.searchParamData['nearby_origin'].findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
           }
            if(source ==='nearbyDestination'){ 
              if( vm.searchParamData['nearby_origin'] && vm.searchParamData['nearby_origin'].length){
             
              var checkDuplicateNearBY= vm.searchParamData['nearby_origin'].findIndex(function (item) {
                return item.portcode_portname === chips.portcode_portname;
              });
              if(checkDuplicateNearBY >= 0){
                
                vm.portExistIn ='Origin Nearby CY'
                vm.checkOtherPort = source;
                return null;
                  
                 }
            
          }  
          if (vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length){
            
            var checkDuplicateOtherPort= vm.searchParamData.user_nearby_destination.findIndex(function (item) {
              return item.portcode_portname === chips.portcode_portname;
            });
            if(checkDuplicateOtherPort >= 0){
               vm.portExistIn ='Destination'
              vm.checkOtherPort = source;
              return null;
            }
            }  
            if (vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length){
            
              var checkDuplicateOtherPort= vm.searchParamData.user_nearby_origin.findIndex(function (item) {
                return item.portcode_portname === chips.portcode_portname;
              });
              if(checkDuplicateOtherPort >= 0){
                vm.portExistIn ='Origin'
                vm.checkOtherPort = source;
            return null;
                  
                 }
              }  
          var checkDuplicateSameNearBY=vm.searchParamData['nearby_destination'].findIndex(function (item) {
            return item.portcode_portname === chips.portcode_portname;
          });
        }
          
          $timeout(function () {
            vm.checkExistingPort = null;
            vm.checkExistingDoor = null;
            vm.checkOtherPort = null;
          },3000)
          if(checkDuplicatePort >= 0){
           
           
            vm.checkExistingPort = source;
            return null;
          }
          if(checkDuplicateDoor >= 0){
            vm.checkExistingDoor = source;
            return null;
          }
          if(checkSameDuplicateDoor >= 0){
            vm.checkExistingDoor = source;
            return null;
          }
          if(checkDuplicateOtherPort >= 0){
            vm.checkOtherPort = source;
            return null;
          }
          if(checkDuplicateNearBY >= 0){
           
            vm.checkOtherPort = source;
            return null;
          }
          if(checkDuplicateSameNearBY >= 0){
            vm.checkExistingPort = source;
            return null;
          }
          if( source.startsWith('origin')  || source.startsWith('destination')){
            fnPrefillNearbyPortData(chips ,  source.startsWith('origin') ? 'nearbyOrigin' : 'nearbyDestination');
            }
        }
      
    }
        function fnPrefillPolPodData(selectedData , routeType){
          if(selectedData.place_type == 'Door' && vm.enabled_pol_pod && vm.mode === 'SEA-FCL'){
               var enabledPort = (routeType == 'origin' || routeType == 'origin_location') ? "user_pol" :"user_pod";
               var leg_code = (enabledPort == 'user_pol') ? 'l1' : 'l5' ;
               var origin_details = [];
               var destination_details = [];
               if(vm.isMultiPort ||  vm.isMultiDoor){
                   origin_details = vm.searchParamData.user_nearby_origin.length ? (vm.searchParamData.user_nearby_origin[0].place_type == 'Door' ? vm.searchParamData.user_pol : vm.searchParamData.user_nearby_origin) : [];
                   destination_details = vm.searchParamData.user_nearby_destination.length ? (vm.searchParamData.user_nearby_destination[0].place_type == 'Door' ? vm.searchParamData.user_pod : vm.searchParamData.user_nearby_destination) : [];
               }else{
                   origin_details = vm.searchParamData.origin_location ? (vm.searchParamData.origin_location.place_type == 'Door' ? vm.searchParamData.user_pol : [vm.searchParamData.origin_location]) : [];
                   destination_details = vm.searchParamData.destination_location ? (vm.searchParamData.destination_location.place_type == 'Door' ? vm.searchParamData.user_pod : [vm.searchParamData.destination_location]) : [];
               }
               var isExist = false;
               var isExistInSameLocation = false;
               util.isCallingApi = true;
               var ApiResponse = [];
               vm.util.fnGetPolPod(selectedData , leg_code , vm.mode).then(
                   function (response) {
                     ApiResponse = response.data.data;
                       // ignoring duplicate ports from other port
                     if((destination_details && destination_details.length) || (origin_details && origin_details.length)){
                       ApiResponse.forEach(function(port_details){
                         isExist = false;
                         isExistInSameLocation =false;
                         if(destination_details && destination_details.length){
                         isExist = destination_details.some(function (other_port_details) {
                           return port_details.portcode_portname === other_port_details.portcode_portname;
                       });
                      }
                      if(origin_details && origin_details.length){
                       isExistInSameLocation = origin_details.some(function (other_port_details) {
                        return port_details.portcode_portname === other_port_details.portcode_portname;
                    });
                  }
                         if(!isExist && !isExistInSameLocation){
                           vm.searchParamData[enabledPort].push(port_details);
                         }
                       });
                     }else{
                       vm.searchParamData[enabledPort] = ApiResponse;
                     }
                     util.isCallingApi = false;
                   },
                   function (error) {
                     util.isCallingApi = false;
                     $log.log(error.data);
                   }
           );

         }
       }
       function checkForSamePorts(params) {
        if(vm.mode === "SEA-FCL" && vm.isCarrierServiceMode ){
          var checkOriginPort = (vm.isMultiPort || vm.isMultiDoor) ? vm.searchParamData.user_nearby_origin[0] : vm.searchParamData.origin_location;
          var checkDestinationPort = (vm.isMultiPort || vm.isMultiDoor) ? vm.searchParamData.user_nearby_destination[0] : vm.searchParamData.destination_location;
          if(checkOriginPort === null || ( checkOriginPort && checkOriginPort.place_type === 'Door' && !vm.enabled_pol_pod)){
            vm.origin_service_mode = "";
          }
          else{
            vm.origin_service_mode = vm.origin_service_mode ? vm.origin_service_mode : vm.getDefaultValue.value;
          }
          if(checkDestinationPort === null || (checkDestinationPort && checkDestinationPort.place_type === 'Door' && !vm.enabled_pol_pod)){
            vm.destination_service_mode = "";
          }
          else{
            vm.destination_service_mode = vm.destination_service_mode ? vm.destination_service_mode : vm.getDefaultValue.value;
          }
        }
       
        // Duplicate port validation with pol/pod - single port case
        if(!vm.isMultiPort && !vm.isMultiDoor && vm.enabled_pol_pod && vm.mode === "SEA-FCL"  && (params == 'origin_location' || params == 'destination_location' )){
          vm.duplicatePortValidation = '';
          if( vm.searchParamData[params]){
            vm.fnPrefillPolPodData(vm.searchParamData[params] , params);
              var nearbyPortsKey = (params== 'origin_location')?vm.searchParamData["user_pod"]:vm.searchParamData["user_pol"];
              var checkDuplicatePort = nearbyPortsKey.findIndex(function (item) {
              return item.portcode_portname === vm.searchParamData[params].portcode_portname;
              });
              if(checkDuplicatePort >= 0){
                  vm.duplicatePortValidation = params;
              }
            }
        }
        if ((vm.searchParamData.origin_location && vm.searchParamData.destination_location) && ((vm.searchParamData.origin_location.place_type == 'Port' && vm.searchParamData.origin_location.portcode_portname === vm.searchParamData.destination_location.portcode_portname) || (vm.searchParamData.origin_location.place_type == 'Door' && vm.searchParamData.origin_location.pin_code_ui === vm.searchParamData.destination_location.pin_code_ui))) {
          vm.refreshForm.$error.samePortError = true;
        } else if (vm.refreshForm.$error.samePortError) {
          delete vm.refreshForm.$error.samePortError;
        }
  
        vm.show_origin_port = vm.fnCheckToShowPolPod('origin');
        vm.show_destination_port = vm.fnCheckToShowPolPod('destination');
       //  making pol/pod data as empty if origin/destination is not a door
        vm.searchParamData["user_pol"] = vm.show_origin_port ? vm.searchParamData["user_pol"] : [];
        vm.searchParamData["user_pod"] = vm.show_destination_port ? vm.searchParamData["user_pod"] : [];
        if(!vm.isMultiPort && !vm.isMultiDoor && (params ==='origin_location' || params ==='destination_location' )){
          vm.fnPrefillNearbyPortData('' , params ==='origin_location' ? 'nearbyOrigin' : 'nearbyDestination');
        }
      }
      function fnDialogSwitchToDoorPort(event,type){
        if(type=='origin'){
          if (vm.viewToggleOrigin===event) {
            return
          }
          vm.viewToggleOrigin = event;
          vm.searchParamData.origin_location = null;
          vm.searchParamData.user_nearby_origin = [];
          vm.searchParamData['nearby_origin']=[]
          vm.searchParamData.origin_port = null;
          vm.show_origin_port = false;
          vm.refreshForm.$error = {};
          vm.refreshForm.fcl_origin_port.$error.required = false;
          vm.refreshForm.fcl_origin_port.$dirty = false;
          vm.includeSdOrigin=false;
          vm.searchParamData.fetch_nearby_origin=false;
        }
        else{
          if (vm.viewToggleDestination === event) {
            return;
          }
         vm.viewToggleDestination = event;
         vm.searchParamData.destination_location = null;
         vm.searchParamData.user_nearby_destination = [];
         vm.searchParamData['nearby_destination']=[];
         vm.searchParamData.destination_port = null;
          vm.show_destination_port = false;
          vm.refreshForm.$error = {};
          vm.refreshForm.fcl_destination_port.$error.required = false;
          vm.refreshForm.fcl_destination_port.$dirty = false;
          vm.includeSdDestination = false;
          vm.searchParamData.fetch_nearby_destination=false;

  
        }
      }
// Usual places API call to pol/Pod
 function getPolPodLocation(searchText,mode,searchType,type){
  var placeType = 'P2P';
  return SearchService.getPortsLocation(searchText, mode, searchType, placeType,type);

}
      function fnCheckToShowPolPod(routeType){
        var searchData = {};
        // storing origin/destination data based multi port condition
        if(vm.isMultiPort  || vm.isMultiDoor){
          searchData['origin'] = vm.searchParamData.user_nearby_origin[0];
          searchData['destination'] = vm.searchParamData.user_nearby_destination[0];
        }else{
          searchData['origin'] = vm.searchParamData.origin_location;
          searchData['destination'] = vm.searchParamData.destination_location;
        }
        var isShow =(vm.enabled_pol_pod && vm.mode === 'SEA-FCL' && searchData[routeType] && searchData[routeType].place_type ==='Door');
        return isShow;
      }
      function getsearchTypeData(){
        if(vm.searchParamData){
        var originType =
            vm.searchParamData.search_type ? vm.searchParamData.search_type.charAt(0) : 'P';
        var destinationType = vm.searchParamData.search_type
          ? vm.searchParamData.search_type.charAt(2)
          : "P";
        vm.viewToggleOrigin=originType=='P' ? 'port' : 'door';
        vm.viewToggleDestination = destinationType == "P" ? "port" : "door";
        if(vm.currentState !== "app.search"){
          vm.includeSdOrigin =
            vm.searchParamData.origin_service_mode == "CY/SD" ? true : false;
          vm.includeSdDestination =
            vm.searchParamData.destination_service_mode == "CY/SD" ? true : false;
        }
        else{
          vm.includeSdOrigin =false;
          vm.includeSdDestination=false;
        };
  
        }
      }
      function getPortsLocation(searchText, mode ,searchType,type){
        var placeType = '';
           if(searchType=='origin'){
             if(searchText){
               vm.searchOrgText = searchText;
              } 
            vm.searchParamData.pickup_selected = false;
            if(!vm.isMultiPort && !vm.isMultiDoor && vm.searchParamData.origin_location && vm.searchParamData.origin_location.place_type == 'Door') {
              vm.searchParamData.pickup_selected = true;
            }
            if((vm.isMultiPort || vm.isMultiDoor) && vm.searchParamData.user_nearby_origin.length){
               if(vm.searchParamData.user_nearby_origin[0].place_type == 'Port'){
                placeType = 'P2P';
               }else {
                vm.searchParamData.pickup_selected = true;
               };
          }
  
          placeType=vm.viewToggleOrigin==='port' ? 'P2P' : 'D2D'
          // if(vm.isMultiPort && vm.searchParamData.user_nearby_destination.length > 1){
          //   if(!vm.searchParamData.user_nearby_origin.length || (vm.searchParamData.user_nearby_origin.length && vm.is_nXn_search)){
          //     placeType = 'P2P';
          //   }else  return [];
          // }
  
        }else{
          if(searchText){
          vm.searchDestText = searchText;
          }
          vm.searchParamData.delivery_selected = false;
          if(!vm.isMultiPort && !vm.isMultiDoor && vm.searchParamData.destination_location && vm.searchParamData.destination_location.place_type == 'Door') {
            vm.searchParamData.delivery_selected = true;
          }
          if((vm.isMultiPort || vm.isMultiDoor) && vm.searchParamData.user_nearby_destination.length){
            if(vm.searchParamData.user_nearby_destination[0].place_type == 'Port'){
              placeType = 'P2P';
            }else {
              vm.searchParamData.delivery_selected = true;
            };
          }
          // if(vm.isMultiPort && vm.searchParamData.user_nearby_origin.length > 1){
          //   if(!vm.searchParamData.user_nearby_destination.length || (vm.searchParamData.user_nearby_destination.length && vm.is_nXn_search)){
          //     placeType = 'P2P';
          //   }else  return [];
          // }
          placeType = vm.viewToggleDestination === "port" ? "P2P" : "D2D";
  
          
       }
       makeDetailBoxString();
      return SearchService.getPortsLocation(searchText, mode, searchType, placeType,type);
      }
      function makeDetailBoxString() {
        if(vm.searchParamData.inco_term && vm.searchParamData.impo_expo && $rootScope.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !vm.util.isShipper){
          vm.detailBoxString = vm.searchParamData.inco_term+ '-' +vm.searchParamData.impo_expo;
        }else{
          vm.detailBoxString = ((vm.searchParamData.pickup_selected && vm.is_independent_search ? 'Pickup, ' : '') + (vm.searchParamData.freight_charges ? 'Freight, ' : '') + (vm.searchParamData.origin_charges ? 'Origin, ' : '') + (vm.searchParamData.origin_customs ? 'Origin Custom, ' : '') + (vm.searchParamData.destination_charges ? 'Destination, ' : '') + (vm.searchParamData.destination_customs ? 'Destination Custom, ' : '') + (vm.searchParamData.delivery_selected && vm.is_independent_search ? 'delivery, ' : '') + (vm.mode === 'SEA-FCL' ? (vm.searchParamData.stuffing === 'F' ? 'Factory Stuffing' : 'Dock Stuffing') : '')) || 'Select Charges';
  
          vm.detailBoxTooltip = ((vm.searchParamData.pickup_selected && vm.is_independent_search ? 'Pickup\n' : '') + (vm.searchParamData.freight_charges ? 'Freight\n' : '') + (vm.searchParamData.origin_charges ? 'Origin\n' : '') + (vm.searchParamData.origin_customs ? 'Origin Custom\n' : '') + (vm.searchParamData.destination_charges ? 'Destination\n' : '') + (vm.searchParamData.destination_customs ? 'Destination Custom\n' : '') + (vm.searchParamData.delivery_selected && vm.is_independent_search ? 'delivery\n' : '') + (vm.mode === 'SEA-FCL' ? (vm.searchParamData.stuffing === 'F' ? 'Factory Stuffing' : 'Dock Stuffing') : '')) || 'Select Charges';
  
          vm.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;
        }
        
  
      }
      function prefilledMultiportData(){

        vm.is_nXn_search = $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode] && $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode].includes('*') ; 
        // checking data type is array or not if not convert into array - md-chip working with array only 
         if(vm.searchParamData.user_nearby_origin && !Array.isArray(vm.searchParamData.user_nearby_origin)){
          vm.searchParamData.user_nearby_origin = [vm.searchParamData.user_nearby_origin];
         }
         if(vm.searchParamData.user_nearby_destination && !Array.isArray(vm.searchParamData.user_nearby_destination)){
          vm.searchParamData.user_nearby_destination = [vm.searchParamData.user_nearby_destination];
         }
       
        //  checking multi port allowed or not
        // if multi port limit is less than port count then taking first set of ports based on port limit
      if(vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length && vm.searchParamData.user_nearby_origin[0].place_type == 'Door' && vm.isMultiDoor){
          var originLimit = vm.is_door_nXn_search ? vm.originMultiDoorLimit : vm.multiDoorLimit;
          var destinationLimit = vm.is_door_nXn_search ? vm.destinationMultiDoorLimit : vm.multiDoorLimit;
          vm.searchParamData.user_nearby_origin =  (vm.searchParamData.user_nearby_origin ? (vm.searchParamData.user_nearby_origin.length > originLimit ? vm.searchParamData.user_nearby_origin.slice(0,originLimit)  :vm.searchParamData.user_nearby_origin ) : []);
          vm.searchParamData.user_nearby_destination =  (vm.searchParamData.user_nearby_destination ?  (vm.searchParamData.user_nearby_destination.length > destinationLimit ? vm.searchParamData.user_nearby_destination.slice(0,destinationLimit) : vm.searchParamData.user_nearby_destination) : []);
      }
      else if(vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length && vm.searchParamData.user_nearby_origin[0].place_type == 'Port' && $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"]){
        var originLimit = vm.is_nXn_search ? vm.originMultiPortPairLimit : vm.multiPortPairLimit;
        var destinationLimit = vm.is_nXn_search ? vm.destinationMultiPortPairLimit : vm.multiPortPairLimit;
          vm.searchParamData.user_nearby_origin =  (vm.searchParamData.user_nearby_origin ? (vm.searchParamData.user_nearby_origin.length > originLimit ? vm.searchParamData.user_nearby_origin.slice(0,originLimit)  :vm.searchParamData.user_nearby_origin ) : []);
          vm.searchParamData.user_nearby_destination =  (vm.searchParamData.user_nearby_destination ?  (vm.searchParamData.user_nearby_destination.length > destinationLimit ? vm.searchParamData.user_nearby_destination.slice(0,destinationLimit) : vm.searchParamData.user_nearby_destination) : []);
         //  if current search is 1*N but previous search is N*N then taking single data from n*n
         if(!vm.is_nXn_search && vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length > 1 && vm.searchParamData.user_nearby_destination.length >1){
            vm.searchParamData.user_nearby_origin =  vm.searchParamData.user_nearby_origin.slice(0,1);
            vm.searchParamData.user_nearby_destination = vm.searchParamData.user_nearby_destination.slice(0,1);
        }
        }
      // multi port not allowed then take first port from multi port data
      else{
        vm.searchParamData.user_nearby_origin =  (vm.searchParamData.user_nearby_origin && vm.searchParamData.user_nearby_origin.length ? vm.searchParamData.user_nearby_origin.slice(0,1) : []);
        vm.searchParamData.user_nearby_destination =  (vm.searchParamData.user_nearby_destination && vm.searchParamData.user_nearby_destination.length ? vm.searchParamData.user_nearby_destination.slice(0,1) : []);
     }
  
        if((vm.isMultiPort || vm.isMultiDoor) && vm.searchParamData['user_nearby_origin'].length==0 && vm.searchParamData.origin_location){
          vm.searchParamData.origin_location['input_type']='user'
          vm.searchParamData.destination_location['input_type']='user'
          vm.searchParamData['user_nearby_origin'].push(vm.searchParamData.origin_location);
          vm.searchParamData['user_nearby_destination'].push(vm.searchParamData.destination_location);
        }
        if(vm.enabled_pol_pod){
           // checking pol/pod count is greater than pol/pod limit or not
          vm.searchParamData["user_pol"] = (vm.searchParamData.user_pol ? (vm.searchParamData.user_pol.length > vm.originPortLimit ? vm.searchParamData.user_pol.slice(0,vm.originPortLimit)  :vm.searchParamData.user_pol ) : []);
          vm.searchParamData["user_pod"] = (vm.searchParamData.user_pod ? (vm.searchParamData.user_pod.length > vm.destinationPortLimit ? vm.searchParamData.user_pod.slice(0,vm.destinationPortLimit)  :vm.searchParamData.user_pod ) : []);
        }else{
           // making pol/pod data as empty if config is off
          vm.searchParamData["user_pol"] = [];
          vm.searchParamData["user_pod"] = [];
        }
        if(vm.enabled_nearby){
          vm.searchParamData['nearby_origin']= (vm.searchParamData['nearby_origin'] ? (vm.searchParamData['nearby_origin'].length > vm.originNearbyPortLimit ? vm.searchParamData['nearby_origin'].slice(0,vm.originNearbyPortLimit)  :vm.searchParamData['nearby_origin'] ) : []);
          vm.searchParamData['nearby_destination'] = (vm.searchParamData['nearby_destination'] ? (vm.searchParamData['nearby_destination'].length > vm.destinationNearbyPortLimit ? vm.searchParamData['nearby_destination'].slice(0,vm.destinationNearbyPortLimit)  :vm.searchParamData['nearby_destination'] ) : []);
        }
        else{
          vm.searchParamData['nearby_origin']=[]
          vm.searchParamData['nearby_destination']=[]
          vm.searchParamData.fetch_nearby_destination=false;
          vm.searchParamData.fetch_nearby_origin=false;
        }
       
      }
      function redirectToResult(state, resultId){
        vm.closeDialog().then(function() {
          $state.go(state,{ id: resultId });
        });
      }

      function makeDetailBoxString() {
        if(vm.searchParamData.inco_term && vm.searchParamData.impo_expo && $rootScope.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !vm.util.isShipper){
          vm.detailBoxString = vm.searchParamData.inco_term+ '-' +vm.searchParamData.impo_expo;
          vm.detailBoxTooltip = vm.searchParamData.inco_term+ '-' +vm.searchParamData.impo_expo;
        }else{
          vm.detailBoxString = ((vm.searchParamData.pickup_selected && vm.is_independent_search ? 'Pickup, ' : '') + (vm.searchParamData.freight_charges ? 'Freight, ' : '') + (vm.searchParamData.origin_charges ? 'Origin, ' : '') + (vm.searchParamData.origin_customs ? 'Origin Custom, ' : '') + (vm.searchParamData.destination_charges ? 'Destination, ' : '') + (vm.searchParamData.destination_customs ? 'Destination Custom, ' : '') + (vm.searchParamData.delivery_selected && vm.is_independent_search ? 'delivery, ' : '') + (vm.mode === 'SEA-FCL' ? (vm.searchParamData.stuffing === 'F' ? 'Factory Stuffing' : 'Dock Stuffing') : '')) || 'Select Charges';
  
          vm.detailBoxTooltip = ((vm.searchParamData.pickup_selected && vm.is_independent_search ? 'Pickup\n' : '') + (vm.searchParamData.freight_charges ? 'Freight\n' : '') + (vm.searchParamData.origin_charges ? 'Origin\n' : '') + (vm.searchParamData.origin_customs ? 'Origin Custom\n' : '') + (vm.searchParamData.destination_charges ? 'Destination\n' : '') + (vm.searchParamData.delivery_selected && vm.is_independent_search ? 'Delivery\n' : '') + (vm.searchParamData.destination_customs ? 'Destination Custom\n' : '') + (vm.mode === 'SEA-FCL' ? (vm.searchParamData.stuffing === 'F' ? 'Factory Stuffing' : 'Dock Stuffing') : '')) || 'Select Charges';
  
          vm.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;
        }
        
  
      }

      function trackEvent(eventName){
        analytics.track(vm.pagePrefix+'-RateRefresh-'+eventName);
      }

      function closeDialog() {
        return $mdDialog.hide();
      }
      function isStopOriginPortInput(){
        if(vm.searchParamData && vm.searchParamData.user_nearby_origin.length){
          if(vm.viewToggleOrigin == vm.viewToggleDestination &&vm.searchParamData.user_nearby_destination.length>1 && ((vm.viewToggleOrigin== 'port' &&!vm.is_nXn_search) || (vm.viewToggleOrigin== 'door' && !vm.is_door_nXn_search)) )
          {
            return true;
          }else{
            if( vm.searchParamData.user_nearby_origin[0].place_type === 'Port' ){
              return (vm.searchParamData.user_nearby_origin.length >=1 && !vm.isMultiPort)|| (vm.searchParamData.user_nearby_origin.length >= (vm.is_nXn_search ? vm.originMultiPortPairLimit : vm.multiPortPairLimit));
            }
              
            if( vm.searchParamData.user_nearby_origin[0].place_type === 'Door' ){
              return (vm.searchParamData.user_nearby_origin.length >=1 && !vm.isMultiDoor)|| (vm.searchParamData.user_nearby_origin.length >= (vm.is_door_nXn_search ? vm.originMultiDoorLimit : vm.multiDoorLimit));
            }
          }
        }else{
          return false;
        };
      }
      function isStopDestinationPortInput(){
        if( vm.searchParamData && vm.searchParamData.user_nearby_destination.length){
          if(vm.viewToggleDestination == vm.viewToggleOrigin &&  vm.searchParamData.user_nearby_origin.length>1 && ((vm.viewToggleDestination== 'port' &&!vm.is_nXn_search) || vm.viewToggleDestination== 'door' && !vm.is_door_nXn_search ) ){
            return true;
          } else{
        if(vm.searchParamData.user_nearby_destination[0].place_type == 'Port') {
          return (vm.searchParamData.user_nearby_destination.length >=1 && !vm.isMultiPort) || vm.searchParamData.user_nearby_destination.length >= (vm.is_nXn_search ? vm.destinationMultiPortPairLimit : vm.multiPortPairLimit)
        }
        if(vm.searchParamData.user_nearby_destination[0].place_type == 'Door') {
          return (vm.searchParamData.user_nearby_destination.length >=1 && !vm.isMultiDoor) || vm.searchParamData.user_nearby_destination.length >= (vm.is_door_nXn_search ? vm.destinationMultiDoorLimit : vm.multiDoorLimit)
        }
          }   
        }else{
          return false;
        }
      
      }

  }

})();



(function () {
  'use strict';

  angular
    .module('app.core')
    .component('rateModification', {
      templateUrl: 'app/main/component/rate-modification/rate-modification.html',
      bindings: {
          searchParam : '=',
          currentCard : '=',
          pageSource : '=',
          quoteEdit : '=',
          inquiryPricing : '=',
          fromInquiry : '=',
          footerObj : '=',
          editBuyRate : '=',
          sourceRate : '=',
          isAddNewRateLoaded : '=',
          allInQuote : '='        
      },
      controller: RateModificationController
    })
    .component('airLclRateModification', {
      templateUrl: 'app/main/component/rate-modification/air-lcl-rate-modification.html',
      bindings: {
        searchParam : '=',
        currentCard : '=',
        pageSource : '=',
        quoteEdit : '=',
        inquiryPricing : '=',
        fromInquiry : '=',
        footerObj : '=',
        editBuyRate : '=',
        sourceRate : '=',
        isAddNewRateLoaded : '=',
        allInQuote : '='
      },
      controller: RateModificationController
    });


  function RateModificationController($log,$mdPanel, resultService, SearchService, shareQuoteService, $mdToast, util, $timeout, localStorageService, $filter ,$window, basisCalculation , $mdDialog,constObj,$rootScope) {

      var vm = this;
      vm.util = util;
      vm._mdPanel = $mdPanel;
      vm.shareQuoteService = shareQuoteService;
      vm.constObj = constObj;
      vm.isWebView = util.isWebView();
      vm.isShared = util.isSharedQuote();
      vm.mainFreightName = 'Main Freight';
      vm.currencyList = util.currencyList;
      vm.basisArray = [shareQuoteService.airBasisName, shareQuoteService.pickupBasisName, shareQuoteService.deliveryBasisName ,shareQuoteService.freightBasisName];
      shareQuoteService.userDefinedChargeValidation = false;
      //To maintain freight leg key for constObj.FREIGHT_TOTAL_BASIS
      vm.l3LegKey = null;
      vm.isBuyRateEditable = false;
      // method
      vm.fnLegNameChange = fnLegNameChange;
      vm.fnModelInterface = fnModelInterface;
      vm.closeToast = closeToast;
      vm.fnAddNewLeg = fnAddNewLeg;
      vm.fnGetLegList = fnGetLegList;
      vm.fnLegSelected = fnLegSelected;
      vm.fnLegCurrencyChange = fnLegCurrencyChange;
      vm.fnDeleteLegConfirmation = fnDeleteLegConfirmation;
      vm.fnDeleteLeg = fnDeleteLeg;

      vm.getChargeList = getChargeList;
      vm.fnChargeTextChange = fnChargeTextChange;
      vm.fnChargeSelection = fnChargeSelection;
      vm.copyChargeIntoBuy = copyChargeIntoBuy;
      vm.fnChangeBasis = fnChangeBasis;
      vm.conversionOnPriceChange = conversionOnPriceChange;
      vm.getChargeCost = getChargeCost;
      vm.fnDisplayProfit = fnDisplayProfit;
      vm.rateTotalCustomCurr = rateTotalCustomCurr;
      vm.calculateQtyRange = calculateQtyRange;
      vm.isString = isString;
      vm.fnCheckIsNaN = fnCheckIsNaN;
      vm.confirmDeleteCharge = confirmDeleteCharge;
      vm.fnDeleteNewCharge = fnDeleteNewCharge;
      vm.fnAddNewCharge = fnAddNewCharge;
      vm.fnGuuid = fnGuuid;
      vm.fnGetContainerQty = fnGetContainerQty;
      vm.openDeleteCard=openDeleteCard;
      vm.cancelDelete=cancelDelete;
      vm.currencyReload=currencyReload;
      vm.fnCheckOverlay = fnCheckOverlay;
      vm.fnChargeValidation = fnChargeValidation;
      vm.fnLegValidation = fnLegValidation;
      vm.getBasisList=getBasisList;
      vm.sourceDownload = sourceDownload;
      vm.fnTrackAnalytics = fnTrackAnalytics;

      //initialize % on total related items
      vm.initBasisOnTotal = initBasisOnTotal;
      // For updating constObj.FREIGHT_TOTAL_BASIS charge quantity when freight leg total is changed 
      vm.fnBasisOnTotalUnitUpdate = fnBasisOnTotalUnitUpdate;
      vm.updateBasisOnTotalObj = updateBasisOnTotalObj;
      vm.l3Deleted = l3Deleted;
      vm.l3Added = l3Added;
      vm.legCostDataUpdated = legCostDataUpdated;
      vm.fnOpenCommentPanel = fnOpenCommentPanel;
      vm.formBuyRateEditCondition = formBuyRateEditCondition;
      this.$onInit = function () {

        vm.authvalue = vm.isShared ? null : localStorageService.get("authToken").value;
        //To check isAddNewRateLoaded boolean value passed or not
        if(!(vm.isAddNewRateLoaded == undefined || vm.isAddNewRateLoaded == null)){
          vm.isAddNewRateLoaded=true;
        }
        vm.leg_mode = (vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l3_leg = 'l3_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l1_leg = 'l1_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l5_leg = 'l5_'+(vm.searchParam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchParam.mode == 'AIR' ? 'air' : 'lcl'));

        initBasisOnTotal();

        vm.isShowBuyCol = (util.isAdmin || util.isFreightbro) ? true : false;
        // vm.isShowBuyCol = true;
        vm.isEditCopyQuote=(vm.pageSource && vm.pageSource.includes('Copy'))?true:false;
        vm.formBuyRateEditCondition();
        vm.getBasisList();
        vm.searchUser = vm.searchParam.user;
        vm.conversionRate = vm.currentCard.meta.conversionRate ? vm.currentCard.meta.conversionRate : null;
        vm.currency_rates = vm.conversionRate && vm.conversionRate.curr_data ? vm.conversionRate.curr_data : [];
        shareQuoteService.fnFillBasisMeta(vm.currentCard.data.sell_rates,vm.currentCard,vm.searchParam.mode);
        vm.fnDisplayProfit();
        vm.dimLegList = [];
        vm.dimLegList = shareQuoteService.fnGetDimLegs(
          vm.currentCard.data.buy_rates
        );
        vm.checkDefaultKey =(!(util.isShipper || vm.isShared) || ((util.isShipper  || vm.isShared) && (vm.allInQuote == "default" || vm.allInQuote == "default_without_total" || vm.allInQuote == "default_without_subtotal" )));
      }
      //Based on domain config decide whether buy rate is edit  or not #DEV-12668
      function formBuyRateEditCondition(){
        if(vm.authvalue){
        var isSharedRate = vm.currentCard.meta.vendor_id != vm.authvalue.vendor_id;
        }
        //currently quote only have the domain config feature
        if(!(vm.pageSource &&  vm.pageSource.toLowerCase().includes('quote')) || vm.isShared){
          vm.isBuyRateEditable = (vm.isEditCopyQuote || vm.inquiryPricing);
        }
        //shared rate have separate domain config key
        else if(isSharedRate){
          vm.isBuyRateEditable = (vm.isEditCopyQuote || vm.inquiryPricing || ( $rootScope.domainData.domain_info.ALLOW_BUYRATE_EDIT_ON && $rootScope.domainData.domain_info.ALLOW_BUYRATE_EDIT_ON.SHARED_RATES));
        }else{
          vm.isBuyRateEditable = (vm.isEditCopyQuote || vm.inquiryPricing || ($rootScope.domainData.domain_info.ALLOW_BUYRATE_EDIT_ON && $rootScope.domainData.domain_info.ALLOW_BUYRATE_EDIT_ON.OWN_RATES));
        }
      }
      
      function initBasisOnTotal(){

        //initialize basisOnTotalObj which hold % on total charges
        basisCalculation.basisOnTotalObj = {};
        basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS]={};

        //Checking whether l3 is present or not and initialize the freight total and l3 leg key
        if( vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges.length ){ 
          basisCalculation.freightTotal.sellFreightTotal = vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.leg_currency_cost;
          basisCalculation.freightTotal.buyFreightTotal = vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.leg_currency_cost;
          vm.l3LegKey = vm.l3_leg;
        }else{
          basisCalculation.freightTotal.sellFreightTotal = null;
          basisCalculation.freightTotal.buyFreightTotal = null;
          vm.l3LegKey = null;
        }

        //looping charges to put % based charges into basisOnTotalObj
        Object.keys(vm.currentCard.data.sell_rates).forEach(function(legCode){
          if(vm.currentCard.data.sell_rates[legCode].rate_obj){
            vm.currentCard.data.sell_rates[legCode].rate_obj.charges.forEach(function(chargeData, index){
              if(chargeData.charge_basis && chargeData.charge_basis.includes("%")){
                basisCalculation.addCharge(legCode,chargeData,vm.currentCard.data.buy_rates[legCode].rate_obj.charges[index],chargeData.charge_basis);
              }
            })
          }
        })
      }
      // GET BASIS LIST AND REUSE IT 

      function getBasisList(){
        if(!shareQuoteService.basisList[vm.searchParam.mode]){
          shareQuoteService.fetchBasisList(vm.searchParam.mode).then(function(response){  
            shareQuoteService.basisList[vm.searchParam.mode] = util.removeBasis(response.data.data);
            vm.viewBasis = shareQuoteService.basisList[vm.searchParam.mode].map(function(item){return item.basis_name});
          })
        }
        else{
          vm.viewBasis = shareQuoteService.basisList[vm.searchParam.mode].map(function(item){return item.basis_name});
        }
     }
      // leg and charge interface creation
      function fnModelInterface(param){
        var result = null;
        vm.cardChargeObj = {
            "id": "0001",
            "charge_id": null,
            "charge_name": null,
            "charge_type": "FIXED",
            "charge_basis": null,
            "per_unit_rate": 0,
            "total_units": 0,
            "charge_cost": 0,
            "charge_currency": vm.searchUser.user_base_currency,
            "minimum_charge_cost": vm.searchParam.mode === 'SEA-FCL' ? 'NA' : '',
            "maximum_charge_cost": vm.searchParam.mode === 'SEA-FCL' ? 'NA' : '',
            "container_type": null,
            "global_charge_id": "",
            "customer_currency_cost": 0,
            "leg_currency_cost": 0,
            "tax_type": "GST",
            "tax_percent": 0,
            "manual" : true,
            "is_qty_editable" : false,
            "charge_category" : null,
            "charge_code" : "",
            "internal_comments":'',
            "external_comments":''
        };

        vm.cardLegData = {
            "leg_name": "",
            "leg_code": "",
            "vendor_id": vm.isShared ? null : (vm.authvalue.vendor_id),
            "rate_obj": {
                "_id": "",
                "schedule": {
                  "url" : null,
                  "data" : []
                },
                "analytics": {
                  "graph": {
                      "url": null
                  }
                },
                "is_special": false,
                "charges": [],
                "manual": 1,
                "airline": {
                  "air_line_name": "",
                  "airline_code": "",
                  "airline_prefix": ""
                },
                "airline_code": null,
                "slab_currency": null,
                "slab": null,
                "rate_type": "msr_rate",
                "leg_name": "",
                "leg_code": "",
                "vendor_id": vm.isShared ? null : (vm.authvalue.vendor_id),
                "sub_vendor_id": null,
                "service_type": null,
                "via_route": null,
                "transit_time": null,
                "contract_number": "",
                "remarks": null,
                "inclusions": null,
                "expiry": null,
                "other_charges": null,
                "if_applicable_charges": null,
                "load_stat": null,
                "global_leg_id": "",
                "leg_total_cost": 0,
                "leg_total_currency": vm.searchUser.user_base_currency,
                "leg_currency_cost": 0,
                "leg_currency": vm.searchUser.user_base_currency,
                "vendor": {
                  "vendor_name": vm.isShared ? null : vm.authvalue.vendor_name
                },
                "sub_vendor": {
                  "sub_vendor_name": "",
                  "carrier_code": "",
                  "logo" : null
                },
                "ltl_load_details" : null
            }
        };

        result = param == 'leg' ? vm.cardLegData : vm.cardChargeObj;
        return result;
      }

      // close popup
      function closeToast () {
        $mdToast.hide();
      }


    // ****** Start Leg Interaction ******

      // Creating new leg with empty charge
      function fnAddNewLeg (currCard) {
        vm.fnCheckOverlay(); // hide overlay if available
        // create random leg key
        var leg_number = 'lNew' + Math.floor(1000 + Math.random() * 9000) + '_' +vm.leg_mode;
        if (currCard.data.sell_rates == null) {
            currCard.data.sell_rates = {};
        }

        var newLegModel = vm.fnModelInterface('leg');
        var newChargeModel = vm.fnModelInterface('charge');
        currCard.data.sell_rates[leg_number] = angular.copy(newLegModel);
        currCard.data.sell_rates[leg_number].rate_obj.charges.push(angular.copy(newChargeModel));
        currCard.data.buy_rates[leg_number] = angular.copy(newLegModel);
        currCard.data.buy_rates[leg_number].rate_obj.charges.push(angular.copy(newChargeModel));
        vm.legSuggestionList = [];
        setTimeout(function () {
            document.querySelector('#' + leg_number + '').focus();
        }, 50);

      }

      // get default leg list
      function fnGetLegList (searchText) {
        var obj = {
            'mode': vm.searchParam.mode,
            'search': searchText
        }

        return SearchService.getLegName(obj).then(function (response) {
            vm.legSuggestionList = response.data.data;
            return vm.legSuggestionList;
        }, function (error) {
            $log.log(error);
        });
      }

      // on delete click open overlay for confirmation
      function openDeleteCard(leg_key){
        vm.deleteLeg = leg_key;
        document.getElementById(leg_key+'_askDeleteLeg').classList.remove("hide");
      }

      // if overlay is display close it on click
      function fnCheckOverlay(){
        if(vm.deleteLeg){
          vm.cancelDelete(vm.deleteLeg);
        }
      }

      function currencyReload(leg_key){
        vm.fnCheckOverlay(); // hide overlay if available
        document.getElementById(leg_key+'_reloadCurrency').classList.remove("hide");
        $timeout(function(){
          document.getElementById(leg_key+'_reloadCurrency').classList.add("hide");
        },400);
      }

      function fnLegNameChange(sellKey,event){
        //need to do leg validation when leg name is change
        vm.fnLegValidation(sellKey,event);
        //check l3 leg name updated
        // if(vm.currentCard.data.sell_rates[sellKey].leg_code.includes('l3_')){
          // vm.l3Deleted();
          // basisCalculation.deleteLeg(sellKey,constObj.FREIGHT_BASIS);
          // basisCalculation.deleteParent(constObj.FREIGHT_BASIS);
          // if(vm.searchParam.mode === 'AIR'){
          // basisCalculation.deleteLeg(sellKey,constObj.AIR_FREIGHT_BASIS);
          // basisCalculation.deleteParent(constObj.AIR_FREIGHT_BASIS);
          // }
        // }else 
        if((vm.currentCard.data.sell_rates[sellKey].leg_code.includes('l2_')||vm.currentCard.data.sell_rates[sellKey].leg_code.includes('l4_'))&&!vm.currentCard.data.sell_rates[sellKey].leg_code.includes('cha')){
          basisCalculation.deleteLeg(sellKey,constObj.FREIGHT_TOTAL_BASIS);
        }else if(vm.currentCard.data.sell_rates[sellKey].leg_code.includes('l1_')){
          basisCalculation.deleteLeg(sellKey,constObj.PICKUP_BASIS)
          basisCalculation.deleteParent(constObj.PICKUP_BASIS);

        }else if(vm.currentCard.data.sell_rates[sellKey].leg_code.includes('l5_')){
          basisCalculation.deleteLeg(sellKey,constObj.DELIVERY_BASIS)
          basisCalculation.deleteParent(constObj.DELIVERY_BASIS);
        }
        //leg name is edited. Need to delete leg_code
        if (!vm.currentCard.data.sell_rates[sellKey].leg_code.includes("l3_")){
             vm.currentCard.data.sell_rates[sellKey].leg_code = "";
             vm.currentCard.data.buy_rates[sellKey].leg_code = "";
        }else{
          // while editing l3 leg name updating inside rate_obj also
             vm.currentCard.data.sell_rates[sellKey].rate_obj.leg_name = vm.currentCard.data.sell_rates[sellKey].leg_name;
             vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_name = vm.currentCard.data.buy_rates[sellKey].leg_name;
        }   
         
      }
      //if leg is selected from suggestion
      function fnLegSelected(selectedLeg, sellRate, sellKey) {
        if(selectedLeg === null){
          return;
        }
        // condition to check duplicate or not while selecting from dropdown
        if( selectedLeg.leg_id + '_'+vm.leg_mode === sellRate.leg_code){
          return;
        }
          // find if duplicate leg selected

          var isLegPresent = Object.keys(vm.currentCard.data.sell_rates).some(function (key) {
            if (vm.currentCard.data.sell_rates[key].rate_obj && vm.currentCard.data.sell_rates[key].leg_code == selectedLeg.leg_id + '_'+vm.leg_mode && vm.currentCard.data.sell_rates[key].rate_obj.charges.length) {
                return true;
            }
            return false;
          });

          if (isLegPresent) {
            // document.querySelector('#' + sellKey).focus();
            angular.element('#' + sellKey + '_leg').addClass("error-border");
            angular.element('#' +sellKey+'_duplicateText').addClass("error-text");
            sellRate.leg_name = "";
            sellRate.leg_code = "";
            sellRate.rate_obj.leg_name = "";
            sellRate.rate_obj.leg_code = "";
            sellRate.rate_obj.global_leg_id = "";
          } else {
            //Checking previously selected leg is l3
            if(sellRate.leg_code.includes('l3_')){
              vm.l3Deleted();
            }
            sellRate.leg_name = selectedLeg.leg_name;
            sellRate.leg_code = selectedLeg.leg_id + '_'+vm.leg_mode;
            sellRate.rate_obj.leg_name = selectedLeg.leg_name;
            sellRate.rate_obj.leg_code = selectedLeg.leg_id + '_'+vm.leg_mode;
            sellRate.rate_obj.global_leg_id = selectedLeg.leg_id;
            //Checking current selected leg is l3
            // Put parent charge in basisOnTotalObj
            if(selectedLeg.leg_id === 'l3'){
              vm.l3Added(sellKey);
              sellRate.rate_obj.charges.forEach(function(charge_data,index){
                shareQuoteService.fnFillBasisMetaCharge(charge_data,vm.currentCard.data.buy_rates[sellKey].rate_obj.charges[index],sellRate.leg_code,vm.searchParam.mode);
              })
            }else if(selectedLeg.leg_id === 'l1' || selectedLeg.leg_id === 'l5'){
              sellRate.rate_obj.charges.forEach(function(charge_data,index){
                shareQuoteService.fnFillBasisMetaCharge(charge_data,vm.currentCard.data.buy_rates[sellKey].rate_obj.charges[index],sellRate.leg_code,vm.searchParam.mode);
              });
            }
          }
        
        if(vm.currentCard.data.buy_rates[sellKey].rate_obj){
           if (sellKey === vm.l3_leg) {
             vm.currentCard.data.buy_rates[
               selectedLeg.leg_id + "_" + vm.leg_mode
             ] = angular.copy(vm.currentCard.data.buy_rates[sellKey]);
             vm.currentCard.data.sell_rates[
               selectedLeg.leg_id + "_" + vm.leg_mode
             ] = angular.copy(vm.currentCard.data.buy_rates[sellKey]);
             vm.currentCard.data.buy_rates[
               selectedLeg.leg_id + "_" + vm.leg_mode
             ].rate_obj.charges = [];
             vm.currentCard.data.sell_rates[
               selectedLeg.leg_id + "_" + vm.leg_mode
             ].rate_obj.charges = [];
           }
           vm.currentCard.data.buy_rates[sellKey].leg_name = angular.copy(
             sellRate.leg_name
           );
           vm.currentCard.data.buy_rates[sellKey].leg_code = angular.copy(
             sellRate.leg_code
           );
           vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_name =
             angular.copy(sellRate.rate_obj.leg_name);
           vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_code =
             angular.copy(sellRate.rate_obj.leg_code);
           vm.currentCard.data.buy_rates[sellKey].rate_obj.global_leg_id =
             angular.copy(sellRate.rate_obj.global_leg_id);
         }
            
      }

      function l3Deleted(){
        //update status of  l3 leg key
        vm.l3LegKey = null;

        // l3 is deleted so make % on total charges quantiy to null because l3 is not present
        if(basisCalculation.freightTotal.sellFreightTotal !== null || basisCalculation.freightTotal.buyFreightTotal != null){
          vm.fnBasisOnTotalUnitUpdate(null,null);
        }
      }
      function l3Added(l3LegKey){
          //To update l3 leg key
          vm.l3LegKey = l3LegKey;

          //l3 doesn't contain % on total so we have to remove this leg from basisOnTotalObj
          basisCalculation.deleteLeg(l3LegKey,constObj.FREIGHT_TOTAL_BASIS);

          // l3 is added so make % on total charges quantiy to l3 leg currency cost
          if(vm.currentCard.data.sell_rates[vm.l3LegKey].rate_obj.leg_currency_cost !== basisCalculation.freightTotal.sellFreightTotal || vm.currentCard.data.buy_rates[vm.l3LegKey].rate_obj.leg_currency_cost !==  basisCalculation.freightTotal.buyFreightTotal){
            vm.fnBasisOnTotalUnitUpdate(vm.currentCard.data.sell_rates[vm.l3LegKey].rate_obj.leg_currency_cost,vm.currentCard.data.buy_rates[vm.l3LegKey].rate_obj.leg_currency_cost);
          }
      }

      //if quotation tab sell rate leg currency change
      function fnLegCurrencyChange(leg_key, leg_currency) {
        vm.footerObj.doneBtnDisable = true;
        vm.currencyReload(leg_key);
        var l3LegKey = shareQuoteService.getL3LegKey(vm.currentCard);
        if(vm.currentCard.data.sell_rates[leg_key].rate_obj){
          shareQuoteService.LegCurrUpdate(vm.currentCard.data.sell_rates, leg_key, leg_currency, vm.searchParam.mode, vm.l3LegKey, vm.searchUser.user_base_currency);

          var buyKey = '';
          for (var i in vm.currentCard.data.buy_rates) {
              if (i == leg_key) {
              buyKey = i;
              break;
              }
          }

          vm.currentCard.data.buy_rates[buyKey].rate_obj.leg_currency = leg_currency;
          shareQuoteService.LegCurrUpdate(vm.currentCard.data.buy_rates, buyKey, leg_currency, vm.searchParam.mode, vm.l3LegKey, vm.searchUser.user_base_currency);
          //After leg currency updated need to calculate quantity, buy amount and sell amount
          vm.fnBasisOnTotalUnitUpdate(vm.currentCard.data.sell_rates[leg_key].rate_obj.leg_currency_cost,vm.currentCard.data.buy_rates[leg_key].rate_obj.leg_currency_cost);
          if(vm.currentCard.data.sell_rates[leg_key].leg_code.includes('l3_')){
            if(vm.searchParam.mode === 'AIR'){
              basisCalculation.setTotalUnitsForBasisOnCharge(constObj.AIR_FREIGHT_BASIS);
            }else{
              basisCalculation.setTotalUnitsForBasisOnCharge(constObj.FREIGHT_BASIS);
            }                                                                                                                                                                                                   
          }else if(vm.currentCard.data.sell_rates[leg_key].leg_code.includes('l1_')){
            basisCalculation.setTotalUnitsForBasisOnCharge(constObj.PICKUP_BASIS);
          }else if(vm.currentCard.data.sell_rates[leg_key].leg_code.includes('l5_')){
            basisCalculation.setTotalUnitsForBasisOnCharge(constObj.DELIVERY_BASIS);
          }
          $timeout(function(){
            vm.footerObj.doneBtnDisable = false;
          },200);
          
        }
      }

      function cancelDelete(leg_key){
        if(leg_key){
        document.getElementById(leg_key+'_askDeleteLeg').classList.add("hide");
        vm.deleteLeg = null;
        }
      }

      function fnDeleteLegConfirmation (sellKey, sellRate) {
        vm.fnCheckOverlay(); // hide overlay if available
        vm.chargeDelete = false;
        vm.legDelete = true;
        vm.deleteChargeBtn = false;
        shareQuoteService.all_pickup_basis_delete = false;
        shareQuoteService.all_delivery_basis_delete = false;
        shareQuoteService.is_delete_l3_leg = false;

        vm.legKeyName = sellKey;
        vm.deleteLegObj = sellRate;

        if (sellRate.leg_name == null || sellRate.leg_name == "") {
            vm.fnDeleteLeg(sellKey);
        }
        else {
            if (sellKey == vm.l3_leg){
              vm.is_delete_l3_leg = true;
                if(vm.searchParam.freight_charges && vm.searchParam.mode==='AIR') {
              util.showToast('You can not delete this leg.');
              return true;
              }
          }

            vm.currentPage = 'result';
            vm.openDeleteCard(sellKey);
        }
      }

      function fnDeleteLeg(sellKey) {
        vm.deleteChargeBtn = true;
        var sellObj = vm.deleteChargeLeg;
        if (vm.is_delete_l3_leg) {
          if (vm.searchParam.freight_charges && vm.searchParam.mode==='AIR') {
            vm.cancelDelete(sellKey);
            return;
          } else {
            vm.is_delete_l3_leg = true;

            vm.currentCard.data.sell_rates[vm.legKeyName].rate_obj.charges = [];
            vm.currentCard.data.sell_rates[
              vm.legKeyName
            ].rate_obj.leg_currency_cost = 0;
            vm.currentCard.data.sell_rates[
              vm.legKeyName
            ].rate_obj.leg_total_cost = 0;
            vm.currentCard.data.buy_rates[vm.legKeyName].rate_obj.charges = [];
            vm.currentCard.data.buy_rates[
              vm.legKeyName
            ].rate_obj.leg_currency_cost = 0;
            vm.currentCard.data.buy_rates[
              vm.legKeyName
            ].rate_obj.leg_total_cost = 0;
        //delete charges from basisOnTotalObj
        if(vm.currentCard.data.sell_rates[vm.legKeyName].leg_code.includes('l3_')){
          vm.l3Deleted();
          basisCalculation.deleteLeg(vm.legKeyName,constObj.FREIGHT_BASIS);
          basisCalculation.deleteParent(constObj.FREIGHT_BASIS);
          if(vm.searchParam.mode === 'AIR'){
          basisCalculation.deleteLeg(vm.legKeyName,constObj.AIR_FREIGHT_BASIS);
          basisCalculation.deleteParent(constObj.AIR_FREIGHT_BASIS);
          }
        }else if((vm.currentCard.data.sell_rates[vm.legKeyName].leg_code.includes('l2_')||vm.currentCard.data.sell_rates[vm.legKeyName].leg_code.includes('l4_'))&&!vm.currentCard.data.sell_rates[vm.legKeyName].leg_code.includes('cha')){
          basisCalculation.deleteLeg(vm.legKeyName,constObj.FREIGHT_TOTAL_BASIS);
        }else if(vm.currentCard.data.sell_rates[vm.legKeyName].leg_code.includes('l1_')){
          basisCalculation.deleteLeg(vm.legKeyName,constObj.PICKUP_BASIS)
          basisCalculation.deleteParent(constObj.PICKUP_BASIS);

        }else if(vm.currentCard.data.sell_rates[vm.legKeyName].leg_code.includes('l5_')){
          basisCalculation.deleteLeg(vm.legKeyName,constObj.DELIVERY_BASIS)
          basisCalculation.deleteParent(constObj.DELIVERY_BASIS);
        }
        if(vm.legKeyName === vm.l3LegKey){
          vm.l3Deleted();
        }
        vm.legCostDataUpdated();
        vm.is_delete_l3_leg = false;
        vm.cancelDelete(sellKey);
        return;
        }
      }
        
        delete vm.currentCard.data.sell_rates[vm.legKeyName];
        delete vm.currentCard.data.buy_rates[vm.legKeyName];
        vm.legCostDataUpdated();
        vm.cancelDelete(sellKey);
      }

    // ****** End Leg Interaction ******

    // ****** Start Charge Interaction ******

      //get charge name suggestion list
      function getChargeList (searchText , sell_value, chargeObj ) {
        var global_leg_id = sell_value.rate_obj && sell_value.rate_obj.global_leg_id ? sell_value.rate_obj.global_leg_id : '';
        return shareQuoteService.getChargeList(searchText, global_leg_id, chargeObj, vm.searchParam);
      }

      // Charge text change
      function fnChargeTextChange(charge, index, legKey,event) {
        if(event.keyCode == 13){
          return;
        }
        
        vm.fnCheckOverlay(); // hide overlay if available
        
        // charge.charge_id = "";     //hided because of DEV-7273
        // charge.global_charge_id = ""; //hided because of DEV-7273
        if(vm.searchParam.mode === 'SEA-FCL'){
          charge['calculated_slab'] = [] 
          charge['slab']=[];
        }
        charge.charge_category = null; 
        var parent =  basisCalculation.isParent(charge,vm.searchParam.mode);
        var childBasis = null;
        if(parent){
          childBasis = basisCalculation.getChildBasis(charge,vm.searchParam.mode);
          basisCalculation.deleteParentLoad(childBasis,charge.container_type);
          basisCalculation.setTotalUnitsForBasisOnCharge(childBasis); 
        }        
        charge.charge_id = '';
        charge.charge_code = charge.charge_name ? charge.charge_name.toLowerCase().replace(/ /g,"_")+'_'+vm.shareQuoteService.fnGuuid():'';
        //copy sell into buy
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_code = angular.copy(charge.charge_code);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_name = angular.copy(charge.charge_name);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_id = angular.copy(charge.charge_id);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].global_charge_id = angular.copy(charge.global_charge_id);
        
        
      }

      //charge autocomplete object
      function fnChargeSelection(selectedName, charge, legValue, index, legKey) {
        if(selectedName && !!(selectedName.source)){
            charge['source'] = selectedName.source;
            charge['source_data'] = selectedName.source_data;
        }

        if(vm.searchParam.mode === 'SEA-FCL'){
          if (selectedName != null) {
            charge.charge_name = selectedName.charge_name;
            charge.charge_id = selectedName.charge_id;
            charge.global_charge_id = selectedName.global_charge_id;
            charge.container_type = (legValue.leg_code != 'ins_'+vm.leg_mode) ? selectedName.load_code : null;
            charge.charge_basis = selectedName.charge_basis;
            charge.total_units = 0;
            charge.per_unit_rate =  selectedName.per_unit_rate ? selectedName.per_unit_rate : 0 ;
            charge.charge_currency = selectedName.charge_currency ? selectedName.charge_currency : legValue.rate_obj.leg_currency;
            charge.charge_category = selectedName.charge_category;
            charge.charge_code = selectedName.charge_code;
          }
          // else {
          //   charge.charge_id = "";
          //   charge.global_charge_id = "";
          // }
        }else{
          if (selectedName != null) {

          if(selectedName && selectedName.charge_category){
            charge.charge_category = selectedName.charge_category;
          }
          shareQuoteService.changeSelectedCharge(selectedName, charge, legValue, index,legKey);
        }
        }

        vm.copyChargeIntoBuy(legKey, index, charge); //copy charge name details into buy charge
      
        if(vm.searchParam.mode === 'SEA-FCL'){
          vm.fnChangeBasis(charge, legValue, index, vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index],vm.currentCard.data.buy_rates[legKey],'charge',legKey);
        }else{
          vm.conversionOnPriceChange(charge, legValue, index, legKey); 
          if(vm.editBuyRate){     
          vm.conversionOnPriceChange(vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index], vm.currentCard.data.buy_rates[legKey].rate_obj,index, legKey);
        }
      }
      vm.fnChargeValidation(legKey, legValue, index, charge ,'charge');
      vm.fnChargeValidation(legKey, legValue, index, charge ,'buyUnit');
      vm.fnChargeValidation(legKey, legValue, index, charge ,'sellUnit');

    }

      // copy sell charge details into buy charge
      function copyChargeIntoBuy(legKey, index, charge){
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_name = angular.copy(charge.charge_name);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_id = angular.copy(charge.charge_id);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].global_charge_id = angular.copy(charge.global_charge_id);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].container_type = angular.copy(charge.container_type);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_basis = angular.copy(charge.charge_basis);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].total_units = angular.copy(charge.total_units);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_category = angular.copy(charge.charge_category);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_code = angular.copy(charge.charge_code);

        if(vm.editBuyRate){
          vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].per_unit_rate = angular.copy(charge.per_unit_rate);
          vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_currency = angular.copy(charge.charge_currency);
        }
      }

      // set qty on basis change
      function fnChangeBasis(chargeObj, sellRate, charge_index, buyCharge, buyLeg, param,legKey) {
        vm.fnCheckOverlay(); // hide overlay if available
       
     // here we are checking with the original reponse array and stroing it into a variable and using it down
        var getEditable= shareQuoteService.basisList[vm.searchParam.mode].find(function(item){return item.basis_name===chargeObj.charge_basis});

        if (!chargeObj.charge_basis) {
            chargeObj.total_units = 0;
            chargeObj.charge_cost = 0;
            vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj, charge_index,legKey);
            if(vm.editBuyRate){
              vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj, charge_index,legKey);
            }
            return true;
        }
        if(vm.searchParam.mode === 'SEA-FCL' && chargeObj.charge_name && charge_index){
          resultService.checkExistingCharge(chargeObj,charge_index,sellRate.rate_obj.charges,legKey); //it's checking duplicate charge present or not.
        }
        
        if(param != 'quantity'){
          shareQuoteService.fnGetFclTotalUnits(chargeObj, vm.searchParam.load_data.load_details_value);
        }
        if(param === 'basis' || param === 'charge'){
          vm.updateBasisOnTotalObj(chargeObj,legKey,buyLeg.rate_obj, charge_index);

        }
        if(param === 'container'){
          if(vm.searchParam.mode.toLowerCase().includes('fcl')){
            var deletedBasis = basisCalculation.removeParent(chargeObj,vm.searchParam.mode);
            if(deletedBasis){
              basisCalculation.setTotalUnitsForBasisOnCharge(deletedBasis);  
            }
          }
        }

      
        if(chargeObj.total_units){
          vm.fnChargeValidation(legKey,sellRate,charge_index,chargeObj,'quantity');
        }

        vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj, charge_index, legKey)

        chargeObj.is_qty_editable = getEditable ? getEditable.is_editable : false;
      
       
        // copying buy charge basis and total_units value
        buyCharge.charge_basis = angular.copy(chargeObj.charge_basis);
        if(chargeObj.charge_basis === constObj.FREIGHT_TOTAL_BASIS){
          if(vm.l3LegKey){
            buyCharge.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(basisCalculation.freightTotal.buyFreightTotal),vm.currentCard.data.sell_rates[vm.l3LegKey].rate_obj.leg_currency,vm.currentCard.data.sell_rates[legKey].rate_obj.leg_currency);
          }
        }else if(chargeObj.charge_basis && chargeObj.charge_basis.includes("%")){
          buyCharge.total_units =  basisCalculation.basisOnTotalObj[chargeObj.charge_basis] && basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent && basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].buy ? basisCalculation.basisOnTotalObj[chargeObj.charge_basis].parent[chargeObj.container_type ? chargeObj.container_type : 'N/A'].buy.leg_currency_cost : null;
        }
          else{
          buyCharge.total_units = angular.copy(chargeObj.total_units);
        }
        buyCharge.container_type = angular.copy(chargeObj.container_type);
        buyCharge.is_qty_editable = angular.copy(chargeObj.is_qty_editable);

        if(vm.editBuyRate && !isNaN(buyCharge.per_unit_rate) ) {
          vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj,charge_index, legKey);
        }
          
      }
      function updateBasisOnTotalObj(chargeObj,legKey,buyLeg, charge_index){
        if(chargeObj.charge_basis && chargeObj.charge_basis.includes("%")){
          basisCalculation.addCharge(legKey,chargeObj,buyLeg.charges[charge_index],chargeObj.charge_basis);
          //storing converted value on total unit
          if(vm.l3LegKey && chargeObj.charge_basis == constObj.FREIGHT_TOTAL_BASIS){
            chargeObj.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(chargeObj.total_units),vm.currentCard.data.sell_rates[vm.l3LegKey].rate_obj.leg_currency,vm.currentCard.data.sell_rates[legKey].rate_obj.leg_currency);
          }

        }else{
          basisCalculation.removeCharge(legKey,chargeObj);
        }
        //remove Parent based on load type and basis
          var deletedBasis = basisCalculation.removeParent(chargeObj,vm.searchParam.mode);
          if(deletedBasis){
            basisCalculation.setTotalUnitsForBasisOnCharge(deletedBasis);  
          }
        
    

      }

      //cost conversion if charge cost or currency change
      function conversionOnPriceChange (charge, sellRates, index, legKey, action) {
        vm.fnCheckOverlay(); // hide overlay if available
        vm.footerObj.doneBtnDisable = true;

        if(index !== ''){
          var checkCharge = shareQuoteService.fnFillBasisMetaCharge(vm.currentCard.data.sell_rates[legKey].rate_obj.charges[index],vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index],sellRates.leg_code,vm.searchParam.mode);
        }
        
        if(vm.searchParam.mode !== 'SEA-FCL' || (vm.searchParam.mode === 'SEA-FCL' && (charge.charge_basis === shareQuoteService.freightBasisName || charge.charge_basis === shareQuoteService.pickupBasisName || charge.charge_basis === shareQuoteService.deliveryBasisName))){
            shareQuoteService.isQuoteOrNewcard = 'quote';
            vm.getChargeCost(sellRates,charge);
        }else{
            shareQuoteService.getFclCharge(sellRates, charge, vm.searchUser.user_base_currency);
        }
        if(checkCharge && checkCharge.parent){
          basisCalculation.setTotalUnitsForBasisOnCharge(checkCharge.basis); 
          Object.keys(basisCalculation.basisOnTotalObj[checkCharge.basis]).forEach(function(legcode) {
            if(legcode != "parent"){
              basisCalculation.basisOnTotalObj[checkCharge.basis][legcode].forEach(function(chargeObj){
              if(vm.searchParam.mode.toLowerCase().includes("air")){
                if(vm.currentCard.data.buy_rates){
                  shareQuoteService.getChargeCost(vm.currentCard.data.buy_rates[legKey].rate_obj, chargeObj.buyCharge, vm.searchUser.user_base_currency);
                }
                shareQuoteService.getChargeCost(sellRates, chargeObj.sellCharge, vm.searchUser.user_base_currency);

              }else{
                vm.fnChangeBasis(chargeObj.sellCharge,vm.currentCard.data.sell_rates[legcode],'',chargeObj.buyCharge,vm.currentCard.data.buy_rates[legcode],'quantity',legcode);
              }
            });
          }
          });
        }
        vm.legCostDataUpdated();

        if(action && action.includes('currency') && charge.charge_currency == vm.searchUser.user_base_currency){
          sellRates.leg_currency = angular.copy(charge.charge_currency); 
          vm.currentCard.data.buy_rates[legKey].rate_obj.leg_currency = angular.copy(charge.charge_currency);
          vm.currentCard.data.sell_rates[legKey].rate_obj.leg_currency = angular.copy(charge.charge_currency);
          vm.fnLegCurrencyChange(legKey, sellRates.leg_currency);
        }

        $timeout(function(){
            vm.footerObj.doneBtnDisable = false;
        },200);
      }

      function getChargeCost(leg_data,charge_data){
        shareQuoteService.getChargeCost(leg_data, charge_data, vm.searchUser.user_base_currency);
       
      }


      function fnDisplayProfit(){
        vm.footerObj.buyTotalWithConv = 0;
        vm.footerObj.buyTotalBaseCurr = vm.rateTotalCustomCurr(vm.currentCard.data.buy_rates);
        vm.footerObj.sellTotalBaseCurr = vm.rateTotalCustomCurr(vm.currentCard.data.sell_rates);
        // Add Convenience fee if present
        if(vm.currentCard.meta.additional_charges && vm.currentCard.meta.additional_charges.data){
          vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr + parseFloat(vm.currentCard.meta.additional_charges.data.leg_total_cost);
        }else{
          vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr;
        }
        vm.footerObj.profit = util.getProfitValue(vm.footerObj.sellTotalBaseCurr, vm.footerObj.buyTotalWithConv);
      }

      // get card leg user base currency total
      function rateTotalCustomCurr (cards) {
        var convertTotal = 0;
        angular.forEach(cards, function (value) {
            if (value.rate_obj) {
            convertTotal += parseFloat(value.rate_obj.leg_total_cost);
            }
        });
        if($rootScope &&$rootScope.precision_decimals){
        convertTotal = $filter('number')(convertTotal, $rootScope.precision_decimals);
        }else{
          convertTotal = $filter('number')(convertTotal, 2);
        }
        
        convertTotal = Number(convertTotal.split(',').join(''));
        return convertTotal;
      }

      function calculateQtyRange(charge, key) {
        var unit = charge.total_units;
        if (unit >= charge.slab[key].to) {
            return (charge.slab[key].to - (charge.slab[key - 1] ? charge.slab[key-1].to:0));
        } else if (unit >= charge.slab[key].from) {
            return (unit - charge.slab[key].from + 1);
        } else {
            return 0;
        }
      }

      function isString(data) {
        if(typeof data === 'string') {
          return true;
        } else {
          return false;
        }
      }

      function fnCheckIsNaN(charge, param){
        
        var result = '';
        if(param == 'per_unit_rate'){
         if(angular.isString(charge.per_unit_rate)){
             result = charge.per_unit_rate;
         }else{
             var roudingvalue = ($rootScope.precision_decimals !== undefined && $rootScope.precision_decimals !== null) ? $rootScope.precision_decimals : 2;
             result =  $filter('numberMask')(charge.per_unit_rate,2,roudingvalue);
         }
        }else{
         if(!charge.min_flag && angular.isString(charge.charge_cost)){
             result = charge.charge_cost;
         }else{
             result =  $filter('currencyMask')(charge.leg_currency_cost);
         }
         }
        return result;
      }

      function confirmDeleteCharge (sellKey, sellRate, index, action) {
        vm.fnCheckOverlay(); // hide overlay if available
        vm.chargeDelete = true;
        vm.legDelete = false;
        vm.deleteChargeBtn = false;
        vm.is_delete_l3_leg = false;
        shareQuoteService.airBasisLegCharge = {};
        shareQuoteService.pickupBasisLegCharge = {};
        shareQuoteService.deliveryBasisLegCharge = {};
        shareQuoteService.airBasisCharges = false;
        shareQuoteService.all_pickup_basis_delete = false;
        shareQuoteService.all_delivery_basis_delete = false;

        vm.legKeyName = sellKey;
        vm.deleteChargeLeg = sellRate;
        vm.deleteCharge_buyLeg = vm.currentCard.data.buy_rates[sellKey].rate_obj;
        vm.chargeIndex = index;

        vm.deleteChargeLineObj = vm.deleteChargeLeg.charges[index];
        vm.isQuoteOrCard = action;
        if ((vm.deleteChargeLeg.charges[index].charge_name == null || vm.deleteChargeLeg.charges[index].charge_name == "" ) && !(sellKey == vm.l3_leg && vm.deleteChargeLeg.charges.length == 1 && vm.searchParam.freight_charges)) {
          vm.fnDeleteNewCharge(sellKey);
        }
        else {
            if (action == 'quote' && sellKey == vm.l3_leg && vm.deleteChargeLeg.charges.length == 1) {
              vm.is_delete_l3_leg = true;
                if(vm.searchParam.freight_charges && vm.searchParam.mode==='AIR'){
                util.showToast('You can not delete this charge.');
                return true;
              }

              
            }
            vm.currentPage = 'result';
            vm.openDeleteCard(sellKey);
        }
      }


      // delete charge
      function fnDeleteNewCharge (sellKey) {
        vm.deleteChargeBtn = true;
        var sellObj = vm.deleteChargeLeg;
        var buyObj = vm.deleteCharge_buyLeg;
        var index = vm.chargeIndex;
        vm.footerObj.doneBtnDisable = false;
        if (vm.is_delete_l3_leg) {
          if (vm.searchParam.freight_charges && vm.searchParam.mode==='AIR') {
            vm.cancelDelete(sellKey);
            return;
          } else {
            vm.is_delete_l3_leg = true;
            sellObj.charges = [];
            sellObj.leg_currency_cost = 0;
            sellObj.leg_total_cost = 0;
            buyObj.charges = [];
            buyObj.leg_currency_cost = 0;
            buyObj.leg_total_cost = 0;
            vm.l3Deleted();
            vm.legCostDataUpdated();
            vm.cancelDelete(sellKey);

            return;
          }
          }

        if(vm.searchParam.mode == 'AIR'){
            var marginCommission = angular.copy(sellObj.charges[index].leg_currency_cost);
            if( basisCalculation.isParent(sellObj.charges[index]) && (sellObj.iata_commission || sellObj.iata_incentive) ){
                marginCommission = (marginCommission - marginCommission*0.01*sellObj.iata_commission);
                marginCommission = marginCommission - marginCommission*0.01*sellObj.iata_incentive;
            }
            sellObj.leg_currency_cost -= marginCommission;
        }else{
            sellObj.leg_currency_cost -= sellObj.charges[index].leg_currency_cost;
        }
        //if parent deleted need to update child on basisOnTotalObj
        var parent =  basisCalculation.isParent(sellObj.charges[index],vm.searchParam.mode);
        var childBasis = null;
        if(parent){
          childBasis = basisCalculation.getChildBasis(sellObj.charges[index],vm.searchParam.mode);
          basisCalculation.deleteParentLoad(childBasis,sellObj.charges[index].container_type);
          basisCalculation.setTotalUnitsForBasisOnCharge(childBasis); 
        }

        sellObj.leg_total_cost -= sellObj.charges[index].customer_currency_cost;
        //Remove % on total charge from basisOnTotalObj when same charge is delete from leg
        if(sellObj.charges[index].charge_basis && sellObj.charges[index].charge_basis.includes("%")){
          basisCalculation.removeCharge(sellKey,sellObj.charges[index]);
        }
        sellObj.charges.splice(index, 1);

        buyObj.leg_currency_cost -= buyObj.charges[index].leg_currency_cost;
        buyObj.leg_total_cost -= buyObj.charges[index].customer_currency_cost;


        buyObj.charges.splice(index, 1);

        if (vm.isQuoteOrCard == 'quote' && !sellObj.charges.length) {
          delete vm.currentCard.data.sell_rates[vm.legKeyName];
          delete vm.currentCard.data.buy_rates[vm.legKeyName];
          if(vm.l3LegKey === vm.legKeyName){
            vm.l3Deleted();
          }
          if (!Object.keys(vm.currentCard.data.sell_rates).length) {
          vm.currentCard.data.sell_rates = null;
          }
          if (!Object.keys(vm.currentCard.data.buy_rates).length) {
            vm.currentCard.data.buy_rates = null;
          }
        }

        // if(shareQuoteService.airBasisCharges || shareQuoteService.all_pickup_basis_delete || shareQuoteService.all_delivery_basis_delete){
          // shareQuoteService.deleteFreightBasisCharge(vm.isQuoteOrCard,vm.currentCard);
        // }

        if (vm.isQuoteOrCard == 'quote') {
            vm.legCostDataUpdated();
        }
        vm.cancelDelete(sellKey);
      }


      function fnAddNewCharge (sellKey, sellObj) {
        vm.fnCheckOverlay();
        if (sellObj.leg_name == null) {
            util.showToast("Please enter leg name.");
            document.querySelector('#' + sellKey).focus();
            return false;
        }

        var guid = (vm.fnGuuid() + vm.fnGuuid() + "-" + vm.fnGuuid() + "-4" + vm.fnGuuid().substr(0,3) + "-" + vm.fnGuuid() + "-" + vm.fnGuuid() + vm.fnGuuid() + vm.fnGuuid()).toLowerCase();

        var charge_obj = angular.copy(vm.fnModelInterface('charge'));
        charge_obj.id = guid;
        charge_obj.charge_currency = sellObj.rate_obj.leg_currency;

        sellObj.rate_obj.charges.push(charge_obj);
        vm.currentCard.data.buy_rates[sellKey].rate_obj.charges.push(angular.copy(charge_obj));
        vm.chargeShow = sellObj.rate_obj.charges.length;
        $timeout(function () {
            document.querySelector('#' + sellKey + '_' + (sellObj.rate_obj.charges.length - 1) + '').focus();
        }, 50);

      }

      function fnGuuid() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      }

      function fnGetContainerQty(leg_data, charge_data, action, charge_index, buyCharge, buyLeg, param, legKey){
        vm.fnCheckOverlay(); // hide overlay if available
        // here we are checking with the original reponse array and stroing it into a variable and using it down
        var getEditable= shareQuoteService.basisList[vm.searchParam.mode].find(function(item){return item.basis_name===charge_data.charge_basis});
      
        if(charge_data.charge_basis){
          if(param != 'quantity'){
            var l3LegKey = shareQuoteService.getL3LegKey(vm.currentCard);
            var payload = {
              "charge" : charge_data,
              "load_meta" : vm.searchParam.load_data.load_meta,
              "airFreightValue" : (basisCalculation.basisOnTotalObj[charge_data.charge_basis] && basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent &&  basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A']) ?basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].sell.leg_currency_cost  : null,
              "pickupValue" : (basisCalculation.basisOnTotalObj[charge_data.charge_basis] && basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent && basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A']) ?basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].sell.leg_currency_cost  : null,
              "deliveryValue" :  (basisCalculation.basisOnTotalObj[charge_data.charge_basis] && basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent &&  basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A']) ?basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].sell.leg_currency_cost  : null,
              "global_leg_id" : leg_data.global_leg_id,
              "ltl_load_details" : vm.currentCard.meta["ltl_load_details"],
              "mode" : vm.searchParam.mode,
              "dimChargeableValue" : leg_data.dim_data && leg_data.dim_data.chargeable_weight_in_kg && leg_data.dim_data.chargeable_weight_in_kg !== 0 ? leg_data.dim_data.chargeable_weight_in_kg : null
            }
            shareQuoteService.fnGetContainerQty(payload);
            vm.updateBasisOnTotalObj(charge_data,legKey,buyLeg, charge_index);
          }

            if(charge_data.total_units == null) { 
                charge_data.charge_cost = 0;
                charge_data.leg_currency_cost = 0;
            }
            else if(charge_data.total_units != null && charge_data.per_unit_rate !== null ) {
                if(action == 'newCard'){
                    vm.getChargeCost(leg_data,charge_data);
                }else{
                    vm.conversionOnPriceChange(charge_data,leg_data,charge_index,legKey);
                }
            }
            // here we are overriding the chargedata is eidtable after the shareqoute service fngetcontainerqty is inovked 
            // this way is implemeted beacuse if we change fngetContainer in share quote service other areas will get affetced 
            charge_data.is_qty_editable = getEditable ? getEditable.is_editable :  false;
            
            buyCharge.charge_basis = charge_data ? angular.copy(charge_data.charge_basis) : null;
            if(charge_data.charge_basis === constObj.FREIGHT_TOTAL_BASIS){
              buyCharge.total_units = basisCalculation.totalUnitsCurrencyConversion(parseFloat(basisCalculation.freightTotal.buyFreightTotal),vm.currentCard.data.sell_rates[vm.l3LegKey].rate_obj.leg_currency,vm.currentCard.data.sell_rates[legKey].rate_obj.leg_currency);
            }else if(charge_data.charge_basis && charge_data.charge_basis.includes("%") && !(charge_data.charge_basis && charge_data.charge_basis.includes("total"))){
         
              buyCharge.total_units = ( basisCalculation.basisOnTotalObj[charge_data.charge_basis] &&basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent && basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'])  ? basisCalculation.basisOnTotalObj[charge_data.charge_basis].parent[charge_data.container_type ? charge_data.container_type : 'N/A'].buy.leg_currency_cost  : null;
            }else{
              buyCharge.total_units = angular.copy(charge_data.total_units);

            }
            buyCharge.is_qty_editable = angular.copy(charge_data.is_qty_editable);
            if(charge_data.total_units){
              vm.fnChargeValidation(legKey,leg_data,charge_index,charge_data,'quantity');
            }
            if(vm.editBuyRate && buyCharge.total_units != null && buyCharge.per_unit_rate !== null ) {
                vm.conversionOnPriceChange(buyCharge, buyLeg, charge_index,legKey);
            }
        }
      }
 
      // Error validation for leg
      function fnLegValidation(legkey,$event){
        if($event.keyCode != 13){
        var key = legkey
        angular.element('#' +key+'_text').removeClass("error-text");
        angular.element('#' +key+'_duplicateText').removeClass("error-text");
        angular.element('#' + key + '_leg').removeClass("error-border");
        }
      }
      // Error validation for charges
      function fnChargeValidation(legKey,buyLeg,charge_index,charges,action){

           if((shareQuoteService.containerValidation && action == 'container' )|| vm.searchParam.mode != 'SEA-FCL')
                shareQuoteService.containerValidation = false;
           if(shareQuoteService.quantityValidation && action == 'quantity')  
                shareQuoteService.quantityValidation = false;
           if(shareQuoteService.buyValidation && action == 'buyUnit') 
                shareQuoteService.buyValidation = false;
           if(shareQuoteService.sellValidation && action == 'sellUnit') 
                shareQuoteService.sellValidation = false;
           if((shareQuoteService.buyMaximumValidation && (action == 'buyMinimum' || action == 'buyMaximum')) || vm.searchParam.mode == 'SEA-FCL')
                shareQuoteService.buyMaximumValidation = false;
           if((shareQuoteService.sellMaximumValidation && (action == 'sellMinimum' || action == 'sellMaximum')) || vm.searchParam.mode == 'SEA-FCL')
                shareQuoteService.sellMaximumValidation = false;
           if((resultService.duplicateEquipment && action == 'basis')|| vm.searchParam.mode != 'SEA-FCL')
                resultService.duplicateEquipment = false;
           if(shareQuoteService.userDefinedChargeValidation && action == 'charge')  {
            shareQuoteService.userDefinedChargeValidation = false;
           }   
     
          //  condition to remove background error color
           if(!(vm.currentCard.meta["isRateGlobal"] && vm.currentCard.meta["isRateGlobal"] == 'Yes' &&(!charges.charge_id || charges.charge_id.startsWith("UD"))) && charges.charge_name && charges.charge_basis && !shareQuoteService.containerValidation && !shareQuoteService.quantityValidation && !shareQuoteService.buyValidation  && !shareQuoteService.buyMaximumValidation && !shareQuoteService.sellValidation && !shareQuoteService.sellMaximumValidation && !resultService.duplicateEquipment){  
              angular.element('#' + legKey + '_' + charge_index + '_row').removeClass("row-error");
              angular.element('.' + legKey + charge_index + 'remove-rates-bg').addClass("rates-bg");
             } 
 
          //  conditions to remove error border and error text ---start
           if( charges.charge_name && !shareQuoteService.userDefinedChargeValidation ){
              angular.element('#' + legKey + '_' + charge_index + '_charge').removeClass("error-border");
              angular.element('#' + legKey + '_' + charge_index + '_chargeError').removeClass("error-text");
              angular.element('#' + legKey + '_' + charge_index + '_duplicateCharge').removeClass("error-text");
              angular.element('#' + legKey + '_' + charge_index + '_userDefinedChargeError').removeClass("error-text");
             }
          if(charges.charge_basis){
               angular.element('#' + legKey + '_' + charge_index + '_basisError').removeClass("error-text");
               angular.element('#' + legKey + '_' + charge_index + '_chargeBasis').removeClass("error-border");
               angular.element('#' + legKey + '_' + charge_index + '_duplicateBasis').removeClass("error-text");
            }
          if((charges.container_type || (charges.charge_basis !== 'per equipment' && charges.container_type== "")) && !(resultService.duplicateEquipment)) {
              angular.element('#' + legKey + '_' + charge_index + '_equipmentType').removeClass("error-border");
              angular.element('#' + legKey + '_' + charge_index + '_equipmentError').removeClass("error-text");
            }
          if(action == 'basis' || action == 'charge'){
              angular.element('#' + legKey + '_' + charge_index + '_duplicateEquipment').removeClass("error-text");
              angular.element('#' + legKey + '_' + charge_index + '_equipmentType').removeClass("error-border");
              angular.element('#' + legKey + '_' + charge_index + '_row').removeClass("row-error");
            }
         if(action == 'quantity'){
             angular.element('#' + legKey + '_' + charge_index + '_quantity').removeClass("error-border");
             angular.element('#' + legKey + '_' + charge_index + '_quantityError').removeClass("error-text");
             angular.element('#' + legKey + '_' + charge_index + '_quantityCharacter').removeClass("error-text");
            }
          if(action == 'buyUnit'){
              angular.element('#' + legKey + '_' + charge_index + '_buyUnit').removeClass("error-border");
              angular.element('#' + legKey + '_' + charge_index + '_buyUnitError').removeClass("error-text");
              angular.element('#' + legKey + '_' + charge_index + '_buyUnitCharacter').removeClass("error-text");
            }
          if(action == 'sellUnit'){
                angular.element('#' + legKey + '_' + charge_index + '_sellUnit').removeClass("error-border");
                angular.element('#' + legKey + '_' + charge_index + '_sellUnitError').removeClass("error-text");
                angular.element('#' + legKey + '_' + charge_index + '_sellUnitCharacter').removeClass("error-text");
            }
          if(action == 'buyMinimum' || action == 'buyMaximum'){
                 angular.element('#' + legKey + '_' + charge_index + '_buyMaximum').removeClass("error-border");
                 angular.element('#' + legKey + '_' + charge_index + '_buyMaximumError').removeClass("error-text");
                 angular.element('#' + legKey + '_' + charge_index + '_buyMaximumCharacter').removeClass("error-text");
                }
          if(action == 'sellMinimum' || action == 'sellMaximum'){
              angular.element('#' + legKey + '_' + charge_index + '_sellMaximum').removeClass("error-border");
              angular.element('#' + legKey + '_' + charge_index + '_sellMaximumError').removeClass("error-text");
              // angular.element('#' + legKey + '_' + charge_index + '_sellMaximumCharacter').removeClass("error-text");
            }
        //---End    

      }
      function sourceDownload(batchcode){
          $window.open(util.sanitizeQueryParams(vm.sourceRate[batchcode].sourceFileUrl));
      }
      function fnBasisOnTotalUnitUpdate(sellFreightTotal,buyFreightTotal){
        basisCalculation.freightTotal.buyFreightTotal = buyFreightTotal;
        basisCalculation.freightTotal.sellFreightTotal = sellFreightTotal;
        basisCalculation.setTotalUnits(vm.l3LegKey,vm.currentCard);
        //Calculate buy amount and sell amount based on updated quantity
        Object.keys(basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS]).forEach(function(legcode) {
          basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][legcode].forEach(function(chargeObj){
            fnChangeBasis(chargeObj.sellCharge,vm.currentCard.data.sell_rates[legcode],'',chargeObj.buyCharge,vm.currentCard.data.buy_rates[legcode],'quantity',legcode);
          });
        });
      }
      function legCostDataUpdated(){
        //l3 not present then make % on total basis charge quantiy as null
        if(!vm.l3LegKey){
          if(basisCalculation.freightTotal.sellFreightTotal !== null || basisCalculation.freightTotal.buyFreightTotal != null){
            vm.fnBasisOnTotalUnitUpdate(null,null);
          } //l3 is present and leg curreny cost is updated then update % on total basis charge quantity
        }else if(vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.leg_currency_cost !== basisCalculation.freightTotal.sellFreightTotal || vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.leg_currency_cost !== basisCalculation.freightTotal.buyFreightTotal){
            vm.fnBasisOnTotalUnitUpdate(vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.leg_currency_cost,vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.leg_currency_cost);
        }

        vm.fnDisplayProfit();
      }
    // ****** End charge Interaction ******

   function fnOpenCommentPanel(ev ,selectedCharge , quoteEdit , buyCharge){
    
      var locals = {
          chargeObj:selectedCharge,
          vendor_id:vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.vendor_id,
          quoteEdit : quoteEdit,
          buyCharge : buyCharge,
          // isCopyBuyToSell : true
      };
      util.fnOpenCommentPanel(ev , locals);
  }

      // mixpanle event
      function fnTrackAnalytics(action, params){
        if(!params){
          var params = {};
        }
        var shortPageName = '';
        if(vm.pageSource.includes('Inquiry')){
          shortPageName = 'ID';
        }
        else if(vm.pageSource.includes('Quote')){
          if(vm.pageSource.includes('Copy')){
            shortPageName = 'QC';
          }
          else{
            shortPageName = 'QD';
          }
        }
        else{
          shortPageName = 'RR';
        }
        params.mode = vm.searchParam.mode;
        if(vm.quoteEdit){
          params.action = vm.pageSource.includes('new') ? 'add' : 'edit';
        }
        util.callMixpanel(shortPageName+'-'+action, params);
      }

  }
  

})();

(function () {
  "use strict";

  angular.module("app.core").component("rateDisplay", {
    templateUrl: "app/main/component/rate-display/rate-display.html",
    bindings: {
      currentCard: "=",
      mode: "=",
      rateType: "=",
      loadData :"<",
      searchParam:"<",
      callback: "&",
    },
    controller: rateDisplayController,
  });

  function rateDisplayController($log, resultService, $rootScope, analytics, shareQuoteService ,util) {
    var vm = this;
    vm.util = util;
    vm.l3_leg = "";
    vm.shareQuoteService = shareQuoteService;
    vm.selectedSailing = null;
    vm.isPanelOpened = false;
    vm.scheduleSelection = scheduleSelection;
    vm.filterItemtoggle = filterItemtoggle;
    vm.panelExpansion = panelExpansion;
    vm.finishLoading = finishLoading;
    vm.dataLoaded = true;

    this.$onInit = function () {
      vm.l3_leg =
        vm.mode == "SEA-FCL"
          ? "l3_fcl"
          : vm.mode == "AIR"
          ? "l3_air"
          : "l3_lcl";
      if (vm.rateType === "new") {
        resultService.getScheduleViaMetaRoute(vm.currentCard, vm.l3_leg);
        vm.currentCard.meta.selected_schedule =
          vm.currentCard.leg[vm.l3_leg].schedule.data.length &&
          vm.currentCard.meta.selected_schedule
            ? vm.currentCard.meta.selected_schedule
            : vm.currentCard.leg[vm.l3_leg].schedule.data[0];
        vm.selectedSailing = vm.currentCard.meta.selected_schedule;
      }
      //  Storing old data into new key - Free days #DEV-10379
      if(vm.mode != 'AIR' && !vm.currentCard.leg[vm.l3_leg].freeDays){
        vm.currentCard.leg[vm.l3_leg] = vm.util.storeOldData(vm.currentCard.leg[vm.l3_leg] , vm.searchParam);
      }
    };

    function panelExpansion() {
      analytics.track("SD-CB-CD-RateCard");
      vm.isPanelOpened = !vm.isPanelOpened;
    }
    function finishLoading() {
      vm.dataLoaded = false;
    }
    function scheduleSelection() {
      analytics.track("SD-CB-CD-SailingDate");
      vm.currentCard.meta.selected_schedule = vm.selectedSailing;
      vm.selectedCard = angular.copy(vm.currentCard);
      vm.callback({ selectedCard: vm.selectedCard });
      $rootScope.$broadcast("getInitData");
    }

    function filterItemtoggle(event, item) {
      event.stopPropagation();
      vm.selectedCard = angular.copy(vm.currentCard);
      vm.selectedCard.meta.is_selected = !vm.selectedCard.meta.is_selected;
      if (vm.selectedCard.meta.is_selected) {
        analytics.track("SD-CB-CD-NewRate-Radio", {
          selected_card: vm.selectedCard,
        });
        vm.callback({ selectedCard: vm.selectedCard });
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module('app.core')
    .component('rateCardTable', {
        templateUrl: 'app/main/component/rate-card-table/rate-card-table.html',
        bindings: {
          resultcardarray:'=',
          mode :'<',
          filterenterprisetable:'<',
          sortBy:'<',
          mdInputId: '<',
          resultfilter:'=',
          resultcardfilter: '=',
          callback : '&',
          searchparam:'=',
          listoffilterobj:'=',
          apiprogressstatus:'=',
          columnsvisible:'<',
          cardscount:'=',
          tabledisplaymode:'<'
      },
        controller: rateCardTableController
    });
  function rateCardTableController(resultService, util,$timeout,$scope, $rootScope, $filter,$compile,$q,shareQuoteService,$mdDialog , SearchService) {
      var vm = this;
      vm.util = util;
      // vm.showContractId=$rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES;
      vm.initDataTableSetting = initDataTableSetting;
      vm.addNewRate = {}
      vm.getLinersData = getLinersData;
      vm.callBackFilter =  callBackFilter;
      vm.tableRowSelect = tableRowSelect;
      vm.rateCardFilterFilled = rateCardFilterFilled;
      vm.formatDataTableBody = formatDataTableBody;
      vm.fnCardCallback = fnCardCallback;
      vm.formatNumber = formatNumber;
      vm.emptyRatesFilter = emptyRatesFilter;
      vm.dtInstanceCallback = {};
      vm.resultCardObject = [];
      vm.dtOptions = {};
      vm.linerObject = null;
      vm.isUpdated = 0;
      vm.date_range = null;
      vm.isShowTable = false;
      vm.cardIndexObj = [];
      vm.ratesType = ratesType;
      vm.selectedLinerFilter = '';
      vm.selectedRateTypeFilter = '';
      vm.linerFilterConditions = {
        'listLoader':false,
        'selectedOptions': [],
        'placeholder': 'Search Liner',
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0,
        'storeObject' : []
      }
      
      vm.polFilterConditions = {
        'listLoader':false,
        'selectedOptions': [],
        'placeholder': 'Search POL',
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0,
        'storeObject' : [],
        'isUpperCase': true
      }
      
      vm.podFilterConditions = {
        'listLoader':false,
        'selectedOptions': [],
        'placeholder': 'Search POD',
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0,
        'storeObject' : [],
        'isUpperCase': true
      }
      
      vm.cargoFilterConditions = {
        'listLoader':false,
        'selectedOptions': [],
        'placeholder': 'Search Cargo Type',
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0,
        'storeObject' : []
      }
      
      vm.commodityFilterConditions = {
        'listLoader':false,
        'selectedOptions': [],
        'placeholder': 'Search Commodity',
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0,
        'storeObject' : []
      }
      vm.rateByFilterConditions = {
        'listLoader':false,
        'selectedOptions': [],
        'placeholder': 'Search Rate By',
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0,
        'storeObject' : []
      }
      vm.isResetFilter = false;
      vm.exportType = '';
      vm.fnCreateNewRow = fnCreateNewRow;
      vm.fnCompileComponant = fnCompileComponant;
      vm.getFilterSort = getFilterSort;
      vm.polObject = [];
      vm.podObject = [];
      vm.loadType = [];
      vm.updatedResultArray = [];
      vm.exportColspanHeader = [];
      vm.tableColumnHeader = tableColumnHeader;
      vm.tabledisplaymode = 'colspan';
      vm.showCargoCommodity = showCargoCommodity;
      vm.setValueToExport = setValueToExport;
      
      vm.legList = {};
      vm.loadList = [];
      vm.rateByFilterData = [];
      vm.searchLoadArray = [];
      
      $scope.$on('$locationChangeStart', function(event, next, current){
        event.preventDefault();            
      });

      this.$onInit = function () {
        
        vm.getLinersData();
        vm.l3_leg = 'l3_'+(vm.searchparam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchparam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l1_leg = 'l1_'+(vm.searchparam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchparam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l5_leg = 'l5_'+(vm.searchparam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchparam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l2_leg = 'l2_'+(vm.searchparam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchparam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l2_leg_cha = 'l2_'+(vm.searchparam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchparam.mode == 'AIR' ? 'air' : 'lcl'))+'_cha';
        vm.l4_leg = 'l4_'+(vm.searchparam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchparam.mode == 'AIR' ? 'air' : 'lcl'));
        vm.l4_leg_cha = 'l4_'+(vm.searchparam.mode == 'SEA-FCL' ? 'fcl' : (vm.searchparam.mode == 'AIR' ? 'air' : 'lcl'))+'_cha';

        //initialize table header columns legs
        vm.legList = getLegList();

        vm.searchparam.load_data.load_details_value.forEach(function(load){
          vm.searchLoadArray.unshift(load.type);
        });
      }

      function getLegList(){
        var legList =  {};
        legList[vm.l3_leg] = {
          title : "Freight",
          summeryheader : ['Freight Total','Per Unit','Basic ocean Freight','Other Fixed Charge']
        };
        getLoadList(legList[vm.l3_leg]);

        if(vm.searchparam.origin_location.place_type=='Door'){
          legList[vm.l1_leg] = {
            title : "Pickup",
            summeryheader : ['Pickup Total','Per Unit','Pickup Charge','Other Fixed Charge']
          };
          getLoadList(legList[vm.l1_leg]);
        }

        if(vm.searchparam.origin_charges){
          legList[vm.l2_leg] = {
            title : "Origin",
            summeryheader : ['Origin Total','Per Unit','Origin Terminal Handling Charge','Other Fixed Charge']
          };
          getLoadList(legList[vm.l2_leg]);
        }

        // if(vm.searchparam.origin_customs){
        //   legList[vm.l2_leg_cha] = {
        //     title : "Origin Custom",
        //     summeryheader : ['Origin Custom Total','Equipment Total','Per Unit','Origin Terminal Handling Charge','Other Fixed Charge']
        //   };
        //   getLoadList(legList[vm.l2_leg_cha]);
        // }

        if(vm.searchparam.destination_charges){
          legList[vm.l4_leg] = {
            title : "Destination",
            summeryheader : ['Destination Total','Per Unit','Destination Terminal Handling Charge','Other Fixed Charge']
          };
          getLoadList(legList[vm.l4_leg]);
        }
        // if(vm.searchparam.destination_customs){
        //   legList[vm.l4_leg_cha] = {
        //     title : "Destination Custom",
        //     summeryheader : ['Destination Custom Total','Equipment Total','Per Unit','Destination Terminal Handling Charge','Other Fixed Charge']
        //   };
        //   getLoadList(legList[vm.l4_leg_cha]);
        // }
        if(vm.searchparam.destination_location.place_type=='Door'){
          legList[vm.l5_leg] = {
            title : "Delivery",
            summeryheader : ['Delivery Total','Per Unit','Delivery Charge','Other Fixed Charge']
          };
          getLoadList(legList[vm.l5_leg]);
        }
        return legList;
      }

      function getLoadList(legName){
        // it's basis unit wise initialize load type
        angular.forEach(legName.summeryheader, function (item,index) {
          if(index >= 1 && index <= 2){
            var legArray = vm.searchparam.load_data.load_details_value.map(function(el) {
              var objectArray = Object.assign({}, el);
              objectArray.leg = legName.title
              objectArray.basis = item
              return objectArray;
            });
            Array.prototype.push.apply(vm.loadList,legArray);
          }
        });
        vm.loadType = vm.searchparam.load_data.load_details_value;
      }
      
      $scope.$on("updateRateTable",function(event, data){
        if(data.action === 'removeCard'){
          vm.resultCardObject.findIndex(function(obj){
            if(obj.meta.is_selected){
              obj.meta.is_selected = false;
            }
          });
        }
        if(data.action === 'addNewCard'){
          vm.fnCreateNewRow(data,data.cardIndex);
          vm.rateCardFilterFilled();
        }
      });
      
      vm.$onChanges = function(){
        vm.resultfilterObject = vm.resultfilter;
        vm.filterObject = vm.listoffilterobj;
        vm.dtOptions = {};
        vm.rateCardFilterFilled();
        vm.isUpdated = 1;
        vm.resultCardFilter = vm.resultcardfilter;
        vm.resultCardObject = vm.resultcardarray; 
        vm.initDataTableSetting();
        
        vm.polObject = vm.filterenterprisetable.polObject;
        vm.podObject = vm.filterenterprisetable.podObject;
        vm.polFilterConditions.storeObject = vm.filterenterprisetable.polObject;
        vm.podFilterConditions.storeObject = vm.filterenterprisetable.podObject;

        vm.rateByFilterData = vm.filterenterprisetable.rateBy;
        vm.rateByFilterConditions.storeObject = vm.filterenterprisetable.rateBy;

      }

      function getLinersData(query){
        var type = vm.mode === 'AIR' ? 'airline' : 'subvendor';
        var queryData = query ? query : '';
        vm.linerFilterConditions.filterLoader = true;

        if(!queryData && (util.carrierData.mode == vm.mode && util.carrierData.data.length)){
          vm.linerObject = angular.copy(util.carrierData.data);
          vm.linerFilterConditions.storeObject = vm.linerObject;
          vm.linerFilterConditions.filterLoader = false;
        }else{

          return resultService.getLinersData(type, queryData).then(function(response){
            vm.linerObject = response.data.data;
            vm.linerFilterConditions.storeObject = vm.linerObject;
            if(!queryData){
              util.carrierData.mode = vm.mode;
              util.carrierData.data = angular.copy(response.data.data);
            }
            vm.linerFilterConditions.filterLoader = false;
          },function(error){
            vm.linerFilterConditions.filterLoader = false;
            $log.log(error.data);
              return [];
          });
        }
      }

      function tableColumnHeader(data) {
        var columnName = [];
        angular.forEach(data, function(rowValue) {
          var column = [];
          angular.forEach(rowValue, function(data) {
            if(data.cell.innerText !== '' && data.cell.innerText.toLowerCase() !== 'action') {
              column.push(data.cell.innerText);
            };
          });
          columnName.push(column);
          column = [];
        });
        var j=0, i=1;
        vm.exportColspanHeader = columnName[0];
        while(i < columnName.length){
          if(j >= columnName[0].length){
            i++;
            j=0;
          }
          if(i < columnName.length) {
            if(columnName[i][j] !== vm.exportColspanHeader[j] && columnName[i-1][j] != columnName[i][j]){
              vm.exportColspanHeader[j] += " " + columnName[i][j];
            }
            j++;
          }
        }
      }

      function formatDataTableBody(data, row, column, node) { //On Export
          var value = node.textContent.trim();
          if(angular.element(node).find('#free-days').length){
            value = angular.element(node).find('#free-days').text().trim();
          }
          if(angular.element(node).attr('data-card-index')){
            vm.cardIndexObj.push(angular.element(node).attr('data-card-index'))
          }
          return (value === undefined || value === null) ? '-': value;
      }

      function initDataTableSetting(){
        vm.dtOptions = {
          "destroy": true,
          "order": [],
          "columnDefs": [ {
            "targets"  : 'no-sort',
            "orderable": false,
          }],
          "bSortClasses": false,
          "drawCallback": function(settings) {
            $timeout(function (){
              if(angular.element("tbody tr.selected").length){
                angular.element("tbody tr.selected").each(function() {
                  angular.element(this).find(".selecte-row").prop('checked',true);
                });
              }else{
                angular.element(".selecte-row").prop('checked',false);
              }
            }); 
          },
          ordering: true,
          select: {
            style: "multi",
            selector: "td .selecte-row:first-child",
          },
          lengthMenu: [10, 20, 50, 100, 200],
          dom: 'B<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: "simple",
          pageLength: 10,
          buttons: [
            {
              extend: 'excelHtml5',
              className: 'exportExcel',
              // autoFilter: true,
              title: '',
              exportOptions: {
                rows: function ( idx, data, node ) {
                  return  angular.element(node).attr('data-meta-isError') ? false : true;
                },
                 columns: function ( idx, data, node ) {
                  if(node.className.includes('noExport')) {
                    return false;
                  }
                  return true;
                },
                format: {
                  header: function (data, column, row) {
                    return angular.element(row).attr('data-name');
                  },
                  body: function (data, row, column, node) {
                    return vm.formatDataTableBody(data, row, column, node);
                  },
                 },      
                customizeData: function (data) {
                  var selectedIndex = data.header.findIndex(function(item){
                    return item.toLowerCase() === 'rate by';
                  });
                  
                  data.header.splice(selectedIndex, 0 , "Inclusions");
                  data.header.splice(selectedIndex, 0 , "Remarks");
                  // adding the header based on search load type
                  vm.searchLoadArray.forEach(function(searchLoadType){
                    data.header.splice(selectedIndex, 0 , "Freedays "+searchLoadType);
                  });

                  angular.forEach(data.body, function(rowItem, rowIndex) {
                    var inclusionsCol =  util.decodeValue(vm.resultCardObject[vm.cardIndexObj[rowIndex]].meta.inclusions);
                    rowItem.splice(selectedIndex, 0, inclusionsCol ? convertDomToText(inclusionsCol)  : '-');

                    var remarksCol = util.decodeValue(vm.resultCardObject[vm.cardIndexObj[rowIndex]].meta.remarks);
                    rowItem.splice(selectedIndex, 0, remarksCol ? convertDomToText(remarksCol) : '-');
                    vm.searchLoadArray.forEach(function(searchLoadType){
                       var freeDaysCol = vm.setValueToExport(vm.resultCardObject[vm.cardIndexObj[rowIndex]].data[vm.resultcardfilter.buyOrSell][vm.l3_leg].rate_obj , searchLoadType)
                       rowItem.splice(selectedIndex, 0, freeDaysCol ? freeDaysCol +' Days' : '-');
                    });
                  });
                  vm.cardIndexObj = [];
                  vm.util.isCallingApi = false;
                },
                
              },
              // customize: function (xlsx) {

              //   var sheet = xlsx.xl.worksheets['sheet1.xml'];
              //   angular.element("row",sheet).each(function() {
              //     // console.log(angular.element(this).find('c:nth-child('+vm.spliceColIndex.remarks+')').html());
              //   if ( $('c:nth-child('+vm.spliceColIndex.remarks+') is t', this).text().indexOf("http") >= 0 ) {

              //     // (2.) change the type to `str` which is a formula
              //     angular.element(this).find('c:nth-child('+vm.spliceColIndex.remarks+')').attr('t', 'str');
              //     //append the formula
              //     var urlRegex = /(https?:\/\/[^\s]+)/g;
              //     var text = $('c:nth-child('+vm.spliceColIndex.remarks+') is t', this).text().replace(urlRegex, function(url) {
              //       return '<f> HYPERLINK("'+url+'","yahoo") </f>';
              //     })

              //     angular.element(this).find('c:nth-child('+vm.spliceColIndex.remarks+')').append(text);
              //     //remove the inlineStr
              //     angular.element(this).find('c:nth-child('+vm.spliceColIndex.remarks+') is').remove();
              //     // (3.) underline
              //     // angular.element(this).find('c:nth-child('+vm.spliceColIndex.remarks+')').attr( 's', '4' );
              // }
                
              //   // console.log(angular.element(this).find('c:nth-child('+vm.spliceColIndex.remarks+')').html());
              // //   if(['Remarks','Inclusions'].includes(angular.element(this).find("is t").text())){
              // //     // angular.element(this).attr('s', '35');
              // //     console.log(angular.element(this).find("is t").text());
              // //   }

              // });
              // //  $('row c[r^="AB"], row c[r^="AC"]', sheet).attr( 's', '35' );

              // }
            },
            {
              text: 'Reset',
              className: 'resetFilter',
              action: function ( e, dt, node, config ) {
                $.fn.dataTable.ext.search.pop();
                dt.columns('').search('').draw();
                resetFilter();
              }
            }
          ],   
          deferRender: true,
          bLengthChange: true,
          bAutoWidth: false,
          scrollX: true,
          fixedColumns: {
            left: 0,
            right: 2,
          },
          initComplete:function(data){
            vm.columnsvisible.columnsList = [];
            vm.columnsvisible.columnsHide = 0;
            $timeout(function (){
              vm.enterpriseLocalStorage = vm.tabledisplaymode === 'colspan' ? 'enterpriseColSpan' : 'enterpriseRowSpan'
              var enterpriseColumns = JSON.parse(localStorage.getItem(vm.enterpriseLocalStorage));
              vm.tableColumnHeader(data.aoHeader); // modifying thead for export
              angular.forEach(data.aoColumns, function(trItem){
                var columnName =  trItem.sName;
                if(!['checkBox','Total Cost','Action','Total Buy Rates'].includes(columnName)){ 
                  var trId = trItem.idx;
                  if(enterpriseColumns){
                    var index = enterpriseColumns.findIndex(function(item){
                      return parseInt(item.colSeq) === trId;
                    });
                  }
                   //it's checking colspan value
                   var duplicateItem = vm.columnsvisible.columnsList.find(function(item){
                    return trItem.parentColumn === item.column;
                  });
                  var columnActive = (enterpriseColumns && enterpriseColumns[index] ? enterpriseColumns[index].isActive : true);
                  var columnObj = {
                    column: trItem.parentColumn ? trItem.parentColumn : columnName,
                    colSeq: [trId],
                    isActive: enterpriseColumns ? vm.tabledisplaymode === 'colspan' ?  (duplicateItem ? duplicateItem.isActive : columnActive) : columnActive : trItem.bVisible
                  }
                  if(!duplicateItem){
                    //it's count hide columns
                    if(!columnObj.isActive){
                      vm.columnsvisible.columnsHide++
                    }
                    vm.columnsvisible.columnsList.push(columnObj);
                  }else{
                    duplicateItem.colSeq.push(trId);
                  }
                  $timeout(function (){
                    vm.dtInstanceCallback.DataTable.columns(trId).visible(columnObj.isActive);
                  },300);
                  if(['POL','POD'].includes(columnName)){
                    vm.getFilterSort(data.aoData,trId,columnName)
                  }
                }
                if(columnName === 'Rate By'){
                  var rateByIndex = 0;
                  vm.rateByFilterData = [];
                  angular.forEach(data.aoData,function(item){
                    if(item._aFilterData[trId].trim() !== '-'){
                      var isPresent = vm.rateByFilterData.findIndex(function(data){ return data.name === item._aFilterData[trId] });
                      if(isPresent < 0){
                        vm.rateByFilterData.push({id:rateByIndex,name:item._aFilterData[trId]});
                        rateByIndex++;
                      }
                      item._aFilterData[trId] = item._aFilterData[trId].replace(/[.,/()\s]/g, " ").toLowerCase();
                    }else{
                      item._aFilterData[trId] = 'Not Applicable';
                    }
                  });
                  vm.rateByFilterData.push({id:rateByIndex,name:'Not Applicable'});
                  vm.rateByFilterConditions.storeObject = angular.copy(vm.rateByFilterData);
                  vm.filterenterprisetable.rateBy= angular.copy(vm.rateByFilterData);
                }
              });
              localStorage.setItem(vm.enterpriseLocalStorage,JSON.stringify(vm.columnsvisible.columnsList));
              // load type wise applyed fixed width for parent leg;
              var thLegsContainerWidth = ['429','653.31','880.26','1106.33'];
              angular.element('.leg-width').attr('style',  'width:'+thLegsContainerWidth[vm.searchparam.load_data.load_details_value.length-1]+'px')
            });
          }
        };
        $timeout(function (){
          vm.isShowTable = true;
          vm.dtInstanceCallback.DataTable.on( 'select', function ( e, dt, type, indexes ) {
            vm.callback({payload:{action:'selectRow'}});
          });
        },400) 
      }

      function tableRowSelect(){
        var selectedRows = vm.dtInstanceCallback.DataTable.rows({selected: true}).nodes().length;
        if(selectedRows === 0 || angular.element('.select-all').prop("checked") == true){
          vm.dtInstanceCallback.DataTable.rows(vm.exportType).select();
          angular.element('.selecte-row').prop('checked',true);
        }else{
          angular.element('.selecte-row').prop('checked',false);
          vm.dtInstanceCallback.DataTable.rows().deselect();
        }
        vm.callback({payload:{action:'selectRow'}});
      }
      
      function callBackFilter(columnName,filterType,payload,filterObject) {
        var isLinerFilterChange = filterType === "linerFilterConditions" ? true : false ;
        filterType = filterType === "rateTypeFilterCondition" ? "linerFilterConditions" : filterType ;

        var column = vm.exportColspanHeader.findIndex(function(item){
          return item.trim() === columnName.trim();
        }) + 1;
        if(payload.searchText || payload.searchText === ''){ // search result 
          vm.getLinersData(payload.searchText);
          // vm[filterType].filterLoader = true;
          //   var searchString = payload.searchText.toLowerCase();
          //   var searchResult = [];
          //   // find existing load type list
          //   angular.forEach(vm[filterType].storeObject, function (item) {
          //     var toFilterStr = item.name;
          //     vm.util.searchTextOption(searchResult,item,searchString,toFilterStr)
          //   });
          //   $timeout(function (){
          //     vm[filterObject] = searchResult;
          //     vm[filterType].filterLoader = false;
          //   },100); 
        }
        if(payload.selectedOptions){ // selected options
          var selectedFilter = '';
          if(vm[filterType] && vm[filterType].selectedCount !== 0){
            var selectedFilter = [];
            angular.forEach(payload.selectedOptions,function(item,key){
              selectedFilter.push(filterType === "linerFilterConditions" ? item.code : item.name.toLowerCase() );
            });
            selectedFilter = selectedFilter.join('|');
          }
          if(selectedFilter === 'not available') {
            selectedFilter = '-';
          }
          if(selectedFilter === 'all'){
            selectedFilter = '';
          }
          if(filterType === "linerFilterConditions"){
            selectedFilter = selectedFilter.length ? '^('+selectedFilter+')$' : selectedFilter ;  // for multiple liner selection we need exact regex pattern match 
          }else if(filterType == 'emptyRates'){
            selectedFilter = payload.selectedOptions;
          }
          else{
            selectedFilter = selectedFilter.replace(/[.,/()\s]/g, (filterType === 'commodityFilterConditions'? '' : ' ')).trim();
          }
          vm.dtInstanceCallback.DataTable.columns(column).search(selectedFilter,true, false).draw();
          vm.exportType = {search:'applied'};
          vm.callback({payload:{action:'filterUpdate', linerFilterChange: isLinerFilterChange}});
          vm.cardscount = vm.dtInstanceCallback.DataTable.page.info().recordsDisplay;
          $(".dataTables_empty").html("No matching records found please reset the filter.");
        }
      }


      function rateCardFilterFilled(){
        vm.cargoTypeObject = [];
        vm.filterObject.cargoTypeList.forEach(function(item,index) {
          vm.cargoTypeObject.push({id:index,name:item});
        });

        vm.cargoFilterConditions.storeObject = angular.copy(vm.cargoTypeObject);

        vm.commodityTypeObject = [];
        vm.filterObject.commodityList.forEach(function(item,index) {
          vm.commodityTypeObject.push({id:index,name:item});
        });
        vm.commodityFilterConditions.storeObject = angular.copy(vm.commodityTypeObject);
      }

      function resetFilter(){
        vm.exportType = '';
        vm.date_range = null;
        vm.isResetFilter = true;
        vm.linerFilterConditions.selectedOptions = [];
        vm.linerFilterConditions.selectedCount = 0;

        vm.polFilterConditions.selectedOptions = [];
        vm.polFilterConditions.selectedCount = 0;

        vm.podFilterConditions.selectedOptions = [];
        vm.podFilterConditions.selectedCount = 0;

        vm.cargoFilterConditions.selectedOptions = [];
        vm.cargoFilterConditions.selectedCount = 0;

        vm.commodityFilterConditions.selectedOptions = [];
        vm.commodityFilterConditions.selectedCount = 0;

        vm.rateByFilterConditions.selectedOptions = [];
        vm.rateByFilterConditions.selectedCount = 0;

        angular.element('.select-all').prop('checked',false);
        vm.dtInstanceCallback.DataTable.rows().deselect();
        vm.cardscount = vm.resultcardarray.length;
      }

    function fnCardCallback(cardData, index){
      vm.util.isCallingApi = true;
      var bindings = {
        searchparam: vm.searchparam,
        card_item: cardData.currentCard,
        resultcardfilter : vm.resultcardfilter,
        index: index,
        l3_leg: vm.l3_leg,
        l1_leg : vm.l1_leg,
        l5_leg:vm.l5_leg,
        l2_leg:vm.l2_leg,
        l2_leg_cha:vm.l2_leg_cha,
        l4_leg:vm.l4_leg,
        l4_leg_cha:vm.l4_leg_cha,
        legList : vm.legList,
        viewRemarksInclusions : vm.viewRemarksInclusions
      }
      var cardtemplate = '<tr role="row" ng-include="\'app/main/component/rate-card-table/table-row.html\'"></tr>';
      angular.element('.totalCost'+index).addClass('hide');
      angular.element('.shimmerUpdateTd'+index).removeClass('hide');
      vm.fnCompileComponant(cardtemplate,bindings).then(function(response) {
      angular.element('.instance_tr_componant_container').html(response);
      $timeout( function (){
        angular.element(".instance_tr_componant_container tr td").each(function(col_index,column) {
          var columnData = angular.element(".instance_tr_componant_container tr td:eq("+col_index+")").attr('data-column');
          if(!['commodity','free_days','checkbox','action','liner_name','remarks','inclusions'].includes(columnData)){ 
            var data = angular.element(".instance_tr_componant_container tr td:eq("+col_index+")").html().trim();
            vm.dtInstanceCallback.DataTable.cell({row: index, column:col_index}).data(data).invalidate();
          }
        });
         angular.element('.totalCost'+index).removeClass('hide');
         angular.element('.shimmerUpdateTd'+index).addClass('hide');
         vm.util.isCallingApi = false;
      },100);
        vm.callback({payload:cardData});
      }, function(reason) {});
    }

    function formatNumber(x) {
      return $filter("number")(x, 2)
    }
    function fnCreateNewRow(data){
      vm.isUpdated = 0;
      vm.isShowTable = false;
      vm.resultCardObject = vm.resultcardarray; 
      $timeout( function (){
        vm.isUpdated = 1;
        vm.isShowTable = true;
      },50);
      return;
   }

   function fnCompileComponant(template,bindings){
      var defer = $q.defer();
      var scope = angular.extend($scope.$new(true), {
          $ctrl: bindings
      });
      defer.resolve($compile(template)(scope));
      return defer.promise;
   }

   function getFilterSort(columnData,colId,columnName){
     var filterObject = columnName === 'POL' ? 'polObject' : 'podObject';
    var polFilterConditions = columnName === 'POL' ? 'polFilterConditions' : 'podFilterConditions';
    vm[filterObject] = [];
    var index = 0;
    angular.forEach(columnData,function(item){
      if(item._aFilterData[colId].trim() !== '-'){
        var isPresent = vm[filterObject].findIndex(function(data){ return data.name === item._aFilterData[colId] });
        if(isPresent < 0){
          vm[filterObject].push({id:index,name:item._aFilterData[colId]});
          index++;
        }
        item._aFilterData[colId] = item._aFilterData[colId].replace(/[.,/()\s]/g, " ").toLowerCase();
      }else{
        item._aFilterData[colId] = 'Not Applicable'
      }
    });
    vm[filterObject].push({id:index,name:'Not Applicable'})
    vm[polFilterConditions].storeObject = angular.copy(vm[filterObject]);
    vm.filterenterprisetable[filterObject] = angular.copy(vm[filterObject]);
   }

   $scope.$watch('$ctrl.tabledisplaymode', function(data) {
    vm.isUpdated = 0;
    vm.isShowTable = false;
    $timeout( function (){
      vm.isUpdated = 1;
      vm.isShowTable = true;
      vm.util.isCallingApi = false;
    },100);
  });


  //rateType Filter

  var ratesType = $rootScope.$on("rateType",function(e,selected_rateType_option){
    var count = 0 ;
    vm.linerFilterConditions.selectedOptions = [];
    if(selected_rateType_option !== "All"){
      var current_mode = (vm.mode == 'SEA-FCL') ? 'FCL' : ((vm.mode == 'AIR') ? 'AIR' : 'LCL');
      var selected_rateType_option_list = SearchService.ratesTypeFilter.carrier_mappings[current_mode][selected_rateType_option];
      angular.forEach(vm.linerFilterConditions.storeObject,function (liner){
        if(selected_rateType_option_list.includes(liner.id)){
          vm.linerFilterConditions.selectedOptions.push(liner);
          count ++ ;
        }
      })
    }
    vm.linerFilterConditions.selectedCount = count;
    var payload = {
      selectedOptions : vm.linerFilterConditions.selectedOptions
    };
    vm.callBackFilter('Liners','rateTypeFilterCondition',payload,"linerObject");
  })
  $rootScope.$on('$destroy', ratesType);

  var columnVisibility = $rootScope.$on('columnVisibility', function (e,data) {
    angular.forEach(data.colSeq, function(trId){ 
      vm.dtInstanceCallback.DataTable.columns(trId).visible(data.isActive);
    });
    var enterpriseColumns = JSON.parse(localStorage.getItem(vm.enterpriseLocalStorage));
    var index = enterpriseColumns.findIndex(function(item){
      return item.column === data.column;
    });
    enterpriseColumns[index].isActive = data.isActive;
    localStorage.setItem(vm.enterpriseLocalStorage, JSON.stringify(enterpriseColumns));
  });
  $rootScope.$on('$destroy', columnVisibility);

  function showCargoCommodity(event, id, card_item,source, mode){
    var cardData = angular.copy(card_item)
    cardData.rate_obj.cargo_type_data = '';
    return shareQuoteService.showCargoCommodity(event,id,cardData,source,mode)
  }
  vm.viewRemarksInclusions = viewRemarksInclusions;
  function viewRemarksInclusions(ev,header,contents){
    vm.contents = contents;
    vm.header =  header;
    $mdDialog.show({
      templateUrl: 'app/main/component/rate-card-table/remarks-inclusions-dailog.html',
      targetEvent: ev,
                clickOutsideToClose: false,
                preserveScope: true,
                controller: function () { this.parent = vm },
                controllerAs: 'ctrl',
    });
  }

  vm.cancelDialog = cancelDialog;
  // Close dialog box
  function cancelDialog(){
    $mdDialog.hide();
  }

  function convertDomToText(dom){
    var domElement = document.createElement("div");
    domElement.innerHTML = dom;
    angular.element('a',domElement).each(function(i) {
      domElement.getElementsByTagName("a")[i].textContent = "("+domElement.getElementsByTagName("a")[i].textContent+': '+domElement.getElementsByTagName("a")[i].getAttribute("href")+")";
    });
    return domElement.textContent;
  }

  //function tto  passing free days value to export 
  function setValueToExport(rate_obj , colLoadType){
    var freeDaysToExport = null ;
    var freeDaysStructuredObj =  {
      "id" : (Math.floor(Math.random() * 90000) + 10000),
      "origin": {
          "demurrage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "detention": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "combined": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "storage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "demurageAndStorage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "combinedAndStorage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          
      },
      "destination": {
          "demurrage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "detention": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "combined": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "storage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "demurageAndStorage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          ,
          "combinedAndStorage": 
              {
                  
                  "freeDays": null,
                  
                  "freeDaysType": "",
                  
              }
          
      }
  }; 
     var freeDays ={
       'origin':null,
       'destination':null
      }
    // getting structured obj
    var loadWiseFreeDaysList = [];
    if(!rate_obj.freeDays ){
      rate_obj.freeDays = fbUtils.FreeDays.transform({'detention_details':rate_obj.detention_details,'demurrage_details':rate_obj.demurrage_details,'combined_details':rate_obj.combined_details})['freeDays'];
    }
    var  structuredData = util.fnSetFreeDays(rate_obj , loadWiseFreeDaysList , freeDaysStructuredObj , vm.searchLoadArray , 'EL')
    loadWiseFreeDaysList = structuredData.loadWiseFreeDaysList;
      loadWiseFreeDaysList.forEach(function(freeDaysData){
        if(freeDaysData.loadType == colLoadType){
          vm.util.routeKeys.forEach(function(routeKey){
            var total = 0
            vm.util.freeDaysKeys.forEach(function(dnd){
              if( freeDaysData[routeKey][dnd][['freeDays']]){
                total = total + freeDaysData[routeKey][dnd]['freeDays'];
              }
           });
           freeDays[routeKey] = total;
          });
        }
     });
       // framing free days value based on domain key
       freeDaysToExport = $rootScope.domainData.domain_info.SHOW_DEFAULT_FREE_DAYS === 'ORIGIN' ? (freeDays['origin'] ? freeDays['origin'] : freeDays['destination']) : (freeDays['destination'] ? freeDays['destination'] : freeDays['origin']);
       return freeDaysToExport;
  }
  $rootScope.$on('emptyRates', function(event, data) {
    vm.emptyRatesFilter(data);
  });
  function emptyRatesFilter(hideRates){
    
      if(hideRates  == 'hideEmptyRates'){
    vm.callBackFilter('Total Cost','emptyRates',{selectedOptions:['^(?!.*N/A).*$']});
  }else{
    vm.callBackFilter('Total Cost','emptyRates',{selectedOptions:['']});
  }
  }

  }
})();

(function () {
  "use strict";

  angular.module("app.core").component("quoteSyncButton", {
    templateUrl: "app/main/component/quote-sync-button/quote-sync-button.html",
    bindings: {
      integrationoptions: "=",
      source: "=",
      quotemodify: "=",
      callback: "&",
    },
    controller: QuoteSyncButtonController
  });

  function QuoteSyncButtonController(
    util,
    localStorageService,
    $rootScope,
    $timeout,
    api,
    $mdDialog,
    $mdMenu,
    $log,
    $mdPanel
  ) {
    var vm = this;
    vm.util = util;
    vm._mdPanel = $mdPanel;
    vm.openSendToMenu = openSendToMenu;
    vm.fnSendto = fnSendto;

    this.$onInit = function () {};

    function openSendToMenu($mdMenu, ev) {
      // if(!vm.integrationList.length){
      //   fnGetErpIntegrationList();
      //   }
      $mdMenu.open(ev);
    }

    function fnSendto(submenus) {
      vm.integrationoptions.menu.isEnabled =
        vm.source == "result" ? true : false;
      vm.callback({ submenus: submenus });
    }
  }
})();

(function () {
  "use strict";

  angular.module("app.core")
  .component("quoteModification", {
    templateUrl: "app/main/component/quote-modification/quote-modification-details.html",
    bindings: {
      quoteValue: "=", 
      pageTitle:"=",
      isManual:"="
    },
    controller: quoteModificationController,
  });

  /** @ngInject */
  function quoteModificationController(
    $window,
    // QuoteDetailsData,
    $timeout,
    api,
    localStorageService,
    QuotesService,
    resultService,
    $mdDialog,
    $filter,
    $log,
    util,
    $state,
    $rootScope,
    shareQuoteService,
    $mdSidenav,
    SearchService,
    $mdToast,
    analytics,
    $scope,
    $anchorScroll,
    mixPanelToken,
    $rootElement,
    loadDataFactory,
    $mdPanel,
    appCache,
    basisCalculation,
    constObj
  ) {
    // Data
    var vm = this;
    vm.util = util;
    vm.constObj = constObj;

    vm.shareQuoteService = shareQuoteService;
    vm.title = "";
    vm.isShared = util.isSharedQuote();
    vm.isWebView = util.isWebView();
    vm.maskLiner =
      util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER;
    vm.sharedMaskLiner =
      $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER && vm.isShared;
    vm.searchConfig = $rootScope.domainData.domain_info.SEARCH_CONFIG;
    vm.todayDate = new Date ();
    $rootScope.loadingDetails = false;
    vm.quotePreview =
    util.sanitizeQueryParams($window.location.href).indexOf("quote_preview") >= 0 ? true : false;
    // vm.dataErr = QuoteDetailsData ? false : true;
    vm.mainFreightNameChange = $rootScope.isJeenaDomain;
    vm.mainFreightName = "Main Freight";
    vm.currentState = $state.current.name;
    vm.isString = isString;
    vm.proceedDuplicate = false;
    vm.copyquoted = false;
    vm.selectedDuplicateCard = [];
    vm.checkForSamePorts = checkForSamePorts;
    vm.makeLoadBoxString = makeLoadBoxString;
    vm.loadBoxString = loadBoxString;
    vm.showLoadAlias=showLoadAlias;
    vm.updateLoadArray = updateLoadArray;
    vm.setLoadValidity = setLoadValidity;
    vm.showLoadPanel = showLoadPanel;
    vm.showLoadDetailPanel = showLoadDetailPanel;
    vm.submitTermsCondition = submitTermsCondition;
    vm.fnopenTermsCondition = fnopenTermsCondition;
    vm.searchCurrencyRateCardUpdate = searchCurrencyRateCardUpdate;
    vm.isPcmsEnabled =$rootScope.domainData.domain_info.POSTALCODES_ENABLED;
    vm.enabled_nearby = $rootScope.domainData.domain_info["GET_NEARBY_PORT_RESULT"] ? true: false;
    vm.setDatePicker = setDatePicker;
    vm.today = new Date();
    //vm.clearDatePicker = clearDatePicker;
    vm.shareQuoteResponse = null;
    vm.quoteId = null;
    vm.shareQuoteData = null;
    vm.pdf_link = null;
    vm.downloadProgressValue = 0;
    vm.quoteSent = false;
    vm.shareQuoteBtn = false;
    vm.generateQuoteBtn = false;
    vm.isAddNewRateLoaded = false;
    vm.currency  = '';
    vm.deleteActionItem=""
    vm.customerDetails = {};
    vm.fnGetPdfLink = fnGetPdfLink;
    vm.downloadPdf = downloadPdf;
    vm.closeShareDialog = closeShareDialog;
    vm.pickerModel = { dateStart: null ,dateEnd:null};
    vm.dateRangeError = false;
    vm.authTokenValue = vm.isShared ? null : localStorageService.get("authToken").value;
    vm.user_category = vm.isShared ? null : vm.authTokenValue.user_category;
    vm.percentageOnTotalBasis = percentageOnTotalBasis;
    vm.percentageOnChargeBasis = percentageOnChargeBasis;
    if (!vm.isShared && vm.isWebView && !util.currencyList.length) {
      util.getCurrencyList().then(
        function (response) {
          vm.currencyList = util.currencyList;
        },
        function (error) {
          vm.currencyList = [];
          $log.log(error);
        }
      );
    } else {
      vm.currencyList = util.currencyList;
    }

    if (vm.dataErr) {
      return;
    }
    vm.user = {
      email: null,
      user_mobile: null,
      user_first_name: null,
      user_last_name: null,
      id: null,
    };

    vm.company = {
      company_name: null,
      id: null,
    };

    vm.printDiv = printDiv;
    vm.cancelDialog = cancelDialog;
    vm.viewDetailsModal = viewDetailsModal;
    vm.selectedSchedule = selectedSchedule;
    vm.setCurrentSchedule = setCurrentSchedule;
    vm.isLegLoadMissing = isLegLoadMissing;
    vm.getCardRemarksInclusion = getCardRemarksInclusion;
    vm.formContainerType = formContainerType;
    vm.rateTotalCustomCurr = rateTotalCustomCurr;
    vm.fnGetLegs = fnGetLegs;
    vm.fnGetBuyChargeLegCurrencyCost = fnGetBuyChargeLegCurrencyCost;
    vm.fnGetBuyUnitPrice = fnGetBuyUnitPrice;
    vm.fnGetBuyChargeCurrency = fnGetBuyChargeCurrency;
    vm.fnGetBuyMinAmount = fnGetBuyMinAmount;
    vm.closeToast = closeToast;
    vm.fnGetColorByStatusName = fnGetColorByStatusName;
    vm.calculateQtyRange = calculateQtyRange;
    vm.fnAddOrEditCard = fnAddOrEditCard;
    vm.fngetSubVendorDetails = fngetSubVendorDetails;
    vm.conversionOnPriceChange = conversionOnPriceChange;
    vm.pushToquoteArray = pushToquoteArray;
    vm.changeSelectedLeg = changeSelectedLeg;
    vm.getMatches = getMatches;
    vm.confirmDeleteLeg = confirmDeleteLeg;
    vm.changeSelectedCharge = changeSelectedCharge;
    vm.changeTextCharge = changeTextCharge;
    vm.getChargeList = getChargeList;
    vm.fnChangeBasis = fnChangeBasis;
    vm.confirmDeleteCharge = confirmDeleteCharge;
    vm.addInQuote = addInQuote;
    vm.fnDeleteNewCharge = fnDeleteNewCharge;
    vm.fnDeleteLeg = fnDeleteLeg;
    vm.fnGetContainerQty = fnGetContainerQty;
    vm.getChargeCost = getChargeCost;
    // vm.checkPercentageBasis = checkPercentageBasis;
    // vm.deleteFreightBasisCharge = deleteFreightBasisCharge;
    // vm.showDeleteBasisCharge = showDeleteBasisCharge;
    vm.focusElem = focusElem;
    vm.getAdditionalLeg = getAdditionalLeg;
    vm.openDeleteCard = openDeleteCard;
    vm.removeCardFromQuote = removeCardFromQuote;
    vm.cancelDeleteCard = cancelDeleteCard;
    vm.fnGetLoadList = fnGetLoadList;
    vm.reduceContainerSize = reduceContainerSize;
    vm.increaseContainerSize = increaseContainerSize;
    vm.fnFormLoadArr = fnFormLoadArr;
    vm.add_lcl_air_load = add_lcl_air_load;
    vm.rm_lcl_air_load = rm_lcl_air_load;
    vm.fnSearchMetaEdit = fnSearchMetaEdit;
    vm.showRemoveIcon = showRemoveIcon;
    vm.isActiveFunction = isActiveFunction;
    vm.fnFclLoadChanged = fnFclLoadChanged;
    vm.fnAirLclLoadChanged = fnAirLclLoadChanged;
    vm.quoteCardAfterSearchChange = quoteCardAfterSearchChange;
    vm.quoteCardAfterLclAirSearchChange = quoteCardAfterLclAirSearchChange;
    vm.terms_condition_focus = terms_condition_focus;
    vm.terms_condition_key_up = terms_condition_key_up;
    vm.fnDefaultTermsAndConditions = fnDefaultTermsAndConditions;
    vm.getQuoteVersion = getQuoteVersion;
    vm.nextVersionChar = nextVersionChar;
    vm.getCardHeight = getCardHeight;
    vm.getCardFlexValue = getCardFlexValue;
    vm.ifInitQuoteModify = ifInitQuoteModify;
    vm.fnCheckCardsDetails = fnCheckCardsDetails;
    vm.showQuoteProceedDiv = showQuoteProceedDiv;
    vm.fnCheckIsNaN = fnCheckIsNaN;
    vm.deleteCopyQuote = deleteCopyQuote;
    vm.fnCardStructure = fnCardStructure;
    vm.showAsterix = showAsterix;
    vm.loadFilter = loadFilter;
    vm.validateContainerData = validateContainerData;
    vm.getPort = util.getPorts;
    vm.getVasDetails = getVasDetails;
    vm.fnViewQuoteList = fnViewQuoteList;
    vm.fclSlab = [];
    vm.currentCard = {};
    vm.selectedIndex = 0;
    vm.disableLeg = true;
    vm.currency_conversion = {};
    vm.todays = moment.utc(new Date()).format();
    vm.columnsData = [];
    vm.chart = null;
    vm.deletedChargeList = [];
    vm.totalLoads = [];
    vm.getData = false;
    vm.enableResend = false;
    vm.sendingOtp = true;
    vm.otpVerified = false;
    vm.isClickEnable = true;
    vm.buyOrSell = "buy_rates";
    vm.showBookBtn = true;
    vm.ScheduleCard = {};
    vm.disableOtpBtn = true;
    vm.showSharedFooter = false;
    vm.card_data = {};
    vm.filterConfig = {};
    vm.newRateCards = [];
    vm.revise_quote = false;
    vm.isQuoteModify = false;
    vm.isSearchMetaModify = false;
    vm.isActive = false;
    vm.termsCondition = "";
    vm.editQuoteMeta = {};
    vm.maxHeight = {
      "max-height": "200px",
    };
    vm.ifExpireCross = false;
    vm.booked_leg_type = [];
    vm.sell_rates_display = false;
    vm.schedule_display = false;
    vm.selectedStatus = "added";
    vm.fnExpiryDateChanged = fnExpiryDateChanged;
    vm.expiryCheck=false;
    vm.newExpiryDate;
    vm.getIataData = true;
    vm.isNewRatesFetach = false;
    vm.showTermsConditions = false;
    vm.isVasApplied = false;
    vm.curr_vas_leg_arr = [];
    vm.viewInquiryDetails = viewInquiryDetails;
    vm._mdPanel = $mdPanel;
    vm.util = util;
    vm.searchHighlight = searchHighlight;
    vm.getPortsLocation = getPortsLocation;
    vm.searchCurrencyChange = searchCurrencyChange;
    vm.fillSearchParam = fillSearchParam;
    // Variables declarations
    vm.LoadBoxString = "";
    vm.LoadTooltipString = "";
    vm.formSubmit = false;
    vm.formIsPristine = true;
    vm.openDatePicker = false;
    vm.searchFromClose = false;
    vm.includeRateCards = false;
    vm.isCreateQuote = false;
    vm.isCreateQuoteValueChange = false;
    vm.isCreateQuoteOriginValueChange = false;
    vm.isCreateQuoteDesValueChange = false;
    vm.newIataCards = {
      data: {
        cards: [],
        rates: [],
      },
    };
    vm.newMsrCards = {
      data: {
        cards: [],
        rates: [],
      },
    };
    vm.newNetworkCards = {
      data: {
        cards: [],
        rates: [],
      },
    };
    vm.initNewLoad = [
      {
        CBM: null,
        CFT: null,
        KGS: null,
        TON: null,
        bl_qty: 1,
        count: 1,
        load_code: null,
        load_description: null,
        type: null,
      },
    ];
    util.isCallingApi = true;
    vm.getDomainData = getDomainData;
    vm.fnDisplayProfit = fnDisplayProfit;
    vm.getConvFeeCost = getConvFeeCost;
    vm.showConvLoader = false;
    vm.setThreeNumberDecimal = SearchService.setThreeNumberDecimal;
    vm.fnSetCharges = fnSetCharges;
    vm.newCardValidation = newCardValidation;
    vm.getExpiryMaxDate = getExpiryMaxDate;
    vm.validateExpirydate = validateExpirydate;
    vm.basisArray = [
      shareQuoteService.airBasisName,
      shareQuoteService.pickupBasisName,
      shareQuoteService.deliveryBasisName,
      shareQuoteService.freightBasisName,
    ];
    vm.goToShipmentDetail = goToShipmentDetail;
    vm.fnGetCurrencyconversion = fnGetCurrencyconversion;
    vm.fnDefaultCharge = fnDefaultCharge;
    vm.resizeScreenSize = resizeScreenSize;
    vm.fnUpdateLocation=fnUpdateLocation;
    vm.fnGetFwrdTerms = fnGetFwrdTerms;
    vm.generateQuote = generateQuote;
    vm.fnopenCopyQuotewalkthrough = fnopenCopyQuotewalkthrough;
    vm.updateForDuplicate = updateForDuplicate;
    vm.trackEvent = trackEvent;
    vm.getDefaultCargoReadyDate = getDefaultCargoReadyDate;
    vm.updateRateRefreshCardSearchCurrency = updateRateRefreshCardSearchCurrency;
    //vm.fetchNearBy = fetchNearBy;
    vm.copyOriginLocation = {};
    vm.copyDestinationLocation = {};
    vm.copyLoadFcl = [];
    vm.copyWeight = [];
    vm.linerData = [];
    vm.footerObj = {
      doneBtnDisable: false,
      buyTotalWithConv: 0,
      buyTotalBaseCurr: 0,
      sellTotalBaseCurr: 0,
      profit: 0,
      rateExpired:false
    };
    vm.getAllLoadList = getAllLoadList;
    vm.closePanel = closePanel;
    vm.co2eResponse = {}; //co2e response
    vm.util.co2ApiLoaded = true;
    vm.disableRefreshRates = false;
    vm.resetRefreshData = resetRefreshData;
    vm.origin_alias=[];
    vm.destination_alias=[];
    function resizeScreenSize() {
      vm.resultCardFilter.deviceName =
        window.innerWidth < 992
          ? "mobile"
          : util.resizeScreen(vm.resultCardFilter.deviceName);
    }
    window.onresize = vm.resizeScreenSize;

    function getAllLoadList(){
      SearchService.getAllLoadList().then(
        function (response) {
          SearchService.loadTypeArr = response;
          vm.loadTypeArr = response;
          util.limitObj = response;
          openViewDrtailFcl(ev);
        },
        function (error) {
          $log.log(error.data);
        }
      );
    }

    vm.$onInit = function (){
  
      vm.quote_result = angular.copy(vm.quoteValue);
      vm.quote_result.result_data.terms =  util.decodeValue(vm.quote_result.result_data.terms);
      if(resultService.refreshQuoteData.quote_id === vm.quote_result.result_data._id){
      if(Object.keys(resultService.refreshQuoteData.from_quote_search_param).length > 0){
        vm.quote_result.result_meta.search_param =angular.copy(resultService.refreshQuoteData.from_quote_search_param);
      }
      if(resultService.refreshQuoteData.oldCards.length > 0){
        vm.quote_result.result_data.cards = resultService.refreshQuoteData.oldCards;
              }
            } 
                 
      vm.quote_result.result_data.cards.forEach(function(currentCard){
        currentCard.partner_reference_id="";
        currentCard.document_details={};
        shareQuoteService.fnFillBasisMeta(currentCard.data[vm.buyOrSell],currentCard);
      });

      getAllLoadList();
      vm.pageInfo = {
        "pageId": vm.quotePreview ? vm.quote_result.result_data.exchangeRateId : vm.quote_result.result_data._id,
        "pageType": vm.quotePreview ? vm.quote_result.result_data.quoteFrom : "Quote",
        "activityId": vm.quote_result.result_data.activityId,
      };

      vm.search_param = vm.quote_result.result_meta.search_param;
      vm.fnUpdateLocation();

       if(vm.pageTitle =='create-quote' && vm.isManual){
        util.getProfile().then(function (value){
             vm.search_param["user"] = value.user
             vm.currency = vm.search_param.user.user_base_currency;
             vm.search_param.search_currency =  vm.search_param.user.user_base_currency
          });
          if(vm.search_param.mode === "SEA-FCL"){
            vm.search_param.load_data.load_details_value.push(
              {
                "qty": 1,
                "bl_qty": 1,
                "sbl_qty": 1,
                "type": "20GP",
                "load_metrics": [
                    {
                        "weight_qty": 25000,
                        "weight_unit": "KGs",
                        "volume_qty": 0,
                        "volume_unit": "CBM"
                    }
                ],
                "teu": 1
              })
          }
          Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
          }

          vm.search_param.stuffing = $rootScope.domainData.domain_info.DEFAULT_STUFFING;
          vm.search_param.cargo_ready_date = (new Date()).addDays(getDefaultCargoReadyDate() || 0);
          vm.search_param.customs = true;
      }else{
        vm.currency = vm.search_param.user.user_base_currency;
      }



       

        //calculate load data
        $scope.$watch(
          "vm.editQuoteMeta.load_data",
          function () {
            if (vm.editQuoteMeta.mode === "AIR") {
              vm.editQuoteMeta.load_data = SearchService.calculateAirLoad(
                vm.editQuoteMeta.load_data
              );
            } else if (vm.editQuoteMeta.mode === "SEA-LCL") {
              vm.editQuoteMeta.load_data = SearchService.calculateLclLoad(
                vm.editQuoteMeta.load_data
              );
            }
          },
          true
        );

      vm.maskLinerText =
        vm.maskLiner &&
        $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT
          ? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT
          : ""
      vm.maskv2 =
        vm.maskLiner &&
        $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2
          ? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2
          : "";

      vm.isDuplicateQuote = false;
      vm.tempSearch_param = angular.copy(
        vm.quote_result.result_meta.search_param
      );
      vm.temp_quoteData = angular.copy(vm.quote_result);
      vm.searchUser = vm.quote_result.result_data.created_by;
      vm.pdf_link = vm.quote_result.result_data.pdf_link;
      vm.quote_Status = !vm.quotePreview
      ? vm.quote_result.result_data.status.status_list[
          vm.quote_result.result_data.status.status_list.length - 1
        ].status
      : null;
      vm.isLost = !vm.quotePreview && vm.quote_Status == "Lost" ? true : false;
      vm.isExpired =
        !vm.quotePreview && vm.quote_Status == "Expired" ? true : false;
      vm.quote_CardData = vm.quote_result.result_data.cards;
      // refresh rates
      vm.refreshRates = !util.isWebView() && !vm.isManual && vm.search_param.mode == 'SEA-FCL' && util.isAdmin && $rootScope.domainData.domain_info.ENABLE_RATE_REFRESH_FROM_QUOTE && (vm.pageTitle =='create-quote' || (vm.pageTitle =='copy-quote'));

      vm.quoteData = vm.quote_result.result_data.cards;
      vm.cutoffMaxDate =new Date(vm.quote_result.result_data.expiry_date);
      vm.expMinDate = new Date(vm.search_param.cargo_ready_date);
   
      vm.resultCardFilter = {
        currency_conversion_rates:
          vm.quoteValue.result_data.currency_conversion_rates,
        via_route_filter: "Transhipment",
        getDataSchedule: false,
        getNetworkSchedule: false,
        getIataSchedule: vm.search_param.mode == "AIR" ? false : true,
        hideBookBtn: false,
        deviceName: "",
        generateQuoteBtn: false,
        ratesLoading: false,
        total_cost: "card_total_cost",
        buyOrSell: vm.buyOrSell,
        co2eApiCalled : false
      };

      addCardsFromResult();
  
      vm.loadObj = {
        type: "",
        count: 1,
        bl_qty: 1,
        sbl_qty: 1,
        max_weight: "",
        weight_qty: 20000,
        weight_unit: "KGs",
        max_volume: "",
      };
  

    // Internal Details part --start

    vm.internalDetails = {
      inquiry_number: vm.quote_result.result_data.inquiry_number,
      search_reference: vm.search_param.search_name,
      customer_details: {
        user: {
          id: null,
          user_first_name: null,
          user_last_name: null,
          email: null,
          user_mobile: null,
        },
        company: {
          id:null,
          company_name: null,
          company_address: null,
        },
      },
      cc_email: [],
    };

    vm.newUserData = {};
    vm.customerValidationObj = {
      customerDataValidation: false,
      ccMailValidation: false,
    };
    vm.quote_result.result_data.cc_emails = vm.internalDetails.cc_email;
    vm.quote_result.result_data.carrier_mask_for_shipper = $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER ? true : false;
    vm.quote_result.result_data.company =
      vm.internalDetails.customer_details.company;
    vm.quote_result.result_data.user = vm.internalDetails.customer_details.user;
    // Internal Details part --End
      if (vm.currentState === "app.copyQuotesDetails") {
        vm.isStateResult = true;
      } else {
        vm.isStateResult = false;
      }

      vm.editSearch = vm.resultCardFilter.deviceName == "mobile" ? false : true;
      // assigning current date to cargo date if it is older than current date.
      if(!vm.isManual){
        vm.search_param.cargo_ready_date = new Date(vm.search_param.cargo_ready_date) < new Date() ? new Date() :  new Date(vm.search_param.cargo_ready_date);
      }

      if(moment(vm.quote_result.result_data.expiry_date) < moment()){
        vm.quote_result.result_data.start_date = moment().format("DD MMM YYYY");
        vm.quote_result.result_data.expiry_date = moment().add("30","days").format("DD MMM YYYY");
        vm.cutoffMaxDate =new Date(vm.quote_result.result_data.expiry_date);
        $mdDialog.show({
          templateUrl: "app/main/quotes/copyQuoteDetails/copy-quote-expiryChange-info.html",
          clickOutsideToClose: false,
          controllerAs: 'ctrl',
          controller: function () { this.parent = vm },
        });
      }
      
      vm.pickerModel = {
        dateStart: vm.quote_result.result_data.start_date
          ? new Date(util.dateReplace(vm.quote_result.result_data.start_date))
          : null,
        dateEnd: vm.quote_result.result_data.expiry_date
          ? new Date(util.dateReplace(vm.quote_result.result_data.expiry_date))
          : null,
      };
      vm.copyOriginLocation = vm.search_param.origin_location;
      vm.copyDestinationLocation = vm.search_param.destination_location;
      // ch
      vm.getDomainData();
      resultService.setLegModeWise(vm.search_param.mode, vm.filterConfig);
      resultService.setLegFilter(vm.filterConfig, vm.search_param);
      vm.modeName = vm.search_param.mode == "SEA-FCL" ? "_fcl" : (vm.search_param.mode == "AIR") ? "_air" : "_lcl";
      vm.subVendorList = [];

      vm.l3_leg = Object.keys(vm.filterConfig)[3];
      vm.l1_leg = Object.keys(vm.filterConfig)[0];
      vm.l2_leg = Object.keys(vm.filterConfig)[1];
      vm.l2_leg_cha = Object.keys(vm.filterConfig)[2];
      vm.l4_leg = Object.keys(vm.filterConfig)[4];
      vm.l4_leg_cha = Object.keys(vm.filterConfig)[5];
      vm.l5_leg = Object.keys(vm.filterConfig)[6];
      vm.ins_leg = Object.keys(vm.filterConfig)[7];
      vm.disableScheduleBtn = vm.quote_result.result_data.is_booked || vm.isLost || vm.quotePreview;

      if ((!vm.isShared && !util.isShipper) || vm.quotePreview) {
        vm.fnGetFwrdTerms();
        vm.buyOrSell = "sell_rates";
        vm.resultCardFilter.buyOrSell = vm.buyOrSell;
      }

      vm.quote_CardData.forEach(function (card) {
        card.meta["card_total_cost"] = 0;
        card.meta["isScheduleCall"] = true;
        card.meta["missingFlag"] = [];
        card.meta.vendor_id = parseInt(vm.authTokenValue.vendor_id);
        for (var i in card.data[vm.buyOrSell]) {
          if (card.data[vm.buyOrSell][i].rate_obj) {
            card.data[vm.buyOrSell][i].rate_obj.vendor = { 'vendor_name': vm.authTokenValue.vendor_name };
            card.data[vm.buyOrSell][i].rate_obj.vendor_id = (vm.authTokenValue.vendor_id);
            card.data[vm.buyOrSell][i].vendor_id = (vm.authTokenValue.vendor_id);
            
            card.data["buy_rates"][i].rate_obj.vendor = card.data[vm.buyOrSell][i].rate_obj.vendor;
            card.data["buy_rates"][i].rate_obj.vendor_id = card.data[vm.buyOrSell][i].rate_obj.vendor_id;
            card.data["buy_rates"][i].vendor_id = card.data[vm.buyOrSell][i].vendor_id;
            

            if (i == vm.l3_leg) {
              card.data[vm.buyOrSell][i].rate_obj.contract_number = null;
              card.data[vm.buyOrSell][i].rate_obj.rate_type = 'msr_rates';
              card.data[vm.buyOrSell][i].rate_obj.tags = [];
              card.data[vm.buyOrSell][i].rate_obj.agent_id = null;
              card.data[vm.buyOrSell][i].rate_obj.agent = null;
              card.data[vm.buyOrSell][i].rate_obj.price_id = null;
              card.data[vm.buyOrSell][i].rate_obj.terms_and_condition = {'url' : null};
               // removing load wise expiry while copy/create quote
              if(vm.search_param.mode == "SEA-FCL"){
                card.data[vm.buyOrSell][i].rate_obj['detailed_effective_load'] = {};
              }
            }
            if (card.data[vm.buyOrSell][i].rate_obj.expiry) {
              var expiry = new Date(card.data[vm.buyOrSell][i].rate_obj.expiry);
              var todays = new Date(new Date().setHours(0, 0, 0, 0));
              if (expiry < todays) {
                vm.expiryCheck=true;  
                card.data["sell_rates"][i].rate_obj.expiry = moment(vm.quote_result.result_data.expiry_date).format("YYYY-MM-DD");
                card.data["buy_rates"][i].rate_obj.expiry = moment(vm.quote_result.result_data.expiry_date).format("YYYY-MM-DD");
              }
            }

            card.meta.type = 'msr_rates';
            card.meta.card_total_cost += parseFloat(card.data[vm.buyOrSell][i].rate_obj.leg_total_cost);
          }
          resultService.fnMissingFlag(card.data[vm.buyOrSell][i], card.meta);
        }
      });

      if (vm.quotePreview) {
        vm.getData = true;
      } else {
        if (vm.quote_CardData.length) {
          vm.getData = true;
        }
      }

      vm.showEditBtn =
        !vm.isShared &&
        !vm.quote_result.result_data.is_booked &&
        !vm.quote_result.result_data.revised &&
        !vm.quotePreview &&
        !vm.isLost;

      if (vm.isWebView) {
        util.createUserData(
          vm.quote_result.result_data.created_by,
          QuotesService.quote_id,
          "quote",
          mixPanelToken
        );
        //mixpanel code
        util.callMixpanel("QC-Mobile-Quotes");
      }
      util.isCallingApi = false;
      vm.fclLoadData = SearchService.getFclLoadDetails(
        vm.search_param.load_data.load_details_value
      );
      prepLoadData();
      vm.copyLoadFcl = angular.copy(vm.search_param.load_data);
      vm.copyWeight = angular.copy(vm.search_param.load_data);

      prepSearchData();
      vm.fnCardStructure();
      vm.resizeScreenSize();
      getInitData();
      vm.fnGetLoadList();
      vm.fillSearchParam();
    }
    function fnUpdateLocation(){
      if(vm.search_param.user_nearby_origin &&vm.search_param.user_nearby_origin.length){
        vm.search_param['nearby_origin']=vm.search_param.user_nearby_origin.filter(function(item){
          return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
        });
        vm.origin_alias=vm.search_param.user_nearby_origin.filter(function(item){
          return (item.input_type == 'alias');
        });
        vm.search_param.user_nearby_origin =  vm.search_param.user_nearby_origin.filter(function(item){
          return (item.input_type == 'user' || !item.input_type);
        });
        vm.search_param.user_nearby_origin.forEach(function(value){
          if(!value.input_type){
           value['input_type']='user'
          }
         })
      }
     if(vm.search_param.user_nearby_destination &&vm.search_param.user_nearby_destination.length){

     
      vm.search_param['nearby_destination']=vm.search_param.user_nearby_destination.filter(function(item){
        return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
      });
    

      vm.destination_alias=vm.search_param.user_nearby_destination.filter(function(item){
        return (item.input_type == 'alias');
      });
   
      vm.search_param.user_nearby_destination =  vm.search_param.user_nearby_destination.filter(function(item){
        return (item.input_type == 'user' || !item.input_type);
      });
   
       vm.search_param.user_nearby_destination.forEach(function(value){
         if(!value.input_type){
          value['input_type']='user'
         }
        })
      }
        if(!vm.enabled_nearby){
          vm.search_param['nearby_origin']=[]
          vm.search_param['nearby_destination']=[]
          vm.search_param.fetch_nearby_destination=false;
          vm.search_param.fetch_nearby_origin=false;
          
        }
    
    }
function updateRateRefreshCardSearchCurrency (){
  vm.quote_CardData.forEach(function (card) {

     
    angular.forEach(card.data.buy_rates, function (leg_value, leg_key) {
      if(card.data.buy_rates){
      if(card.data.buy_rates[leg_key].rate_obj && card.data.buy_rates[leg_key].rate_obj.leg_total_currency != vm.search_param.user.user_base_currency){
        card.data.buy_rates[leg_key].rate_obj.leg_total_currency = vm.search_param.user.user_base_currency;
      }
    }
      if(card.data.sell_rates){
      if(card.data.sell_rates[leg_key].rate_obj && card.data.sell_rates[leg_key].rate_obj.leg_total_currency != vm.search_param.user.user_base_currency){
        card.data.sell_rates[leg_key].rate_obj.leg_total_currency = vm.search_param.user.user_base_currency;
        }
      }
 });
});
vm.search_param.mode === 'SEA-FCL' ? vm.fnFclLoadChanged() : vm.fnAirLclLoadChanged();

}
    function getDefaultCargoReadyDate(){
      return (vm.search_param.mode === 'SEA-FCL' ? $rootScope.domainData.domain_info["DEFAULT_CARGO_READY_OFFSET_FCL"] : (vm.search_param.mode === 'AIR' ? $rootScope.domainData.domain_info["DEFAULT_CARGO_READY_OFFSET_AIR"] : $rootScope.domainData.domain_info["DEFAULT_CARGO_READY_OFFSET_LCL"]));
    }

    function closePanel(){
      $mdDialog.hide();
    }
    
    function getDomainData() {
      if (!Object.keys($rootScope.domainData.domain_info).length) {
        util.getDomainData().then(
          function () {
            vm.showReferenceNumber =
              $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
              vm.gross_weight_unit = vm.search_param.mode === 'SEA-LCL' && $rootScope.domainData.domain_info.WEIGHT_UNIT && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode] &&$rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode].gross_weight.toLowerCase() == 'kg' ? 'KG' : 'MT';

          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.showReferenceNumber =
          $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
          vm.gross_weight_unit = vm.search_param.mode === 'SEA-LCL' &&$rootScope.domainData.domain_info.WEIGHT_UNIT && $rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode] &&$rootScope.domainData.domain_info.WEIGHT_UNIT[vm.search_param.mode].gross_weight.toLowerCase() == 'kg' ? 'KG' : 'MT';

      }
    }

  
    function loadFilter(e) {
      var found = false;
      vm.editLoadType.some(function (i) {
        if (i.type === e.load_code) {
          found = true;
          return true;
        }
      });

      if (found) {
        return false;
      } else {
        return true;
      }
    }


    function showAsterix(array) {
      var showAsterix = false;
      if (array) {
        Object.keys(array).some(function (key) {
          if (array[key].leg_code === "additional_services") {
            array[key].rate_obj.charges.some(function (i) {
              if (typeof i.charge_cost === "string") {
                showAsterix = true;
                return true;
              }
            });
          }
        });
      }
      return showAsterix;
    }

    function fnopenTermsCondition(ev) {
      vm.termsCondition = util.decodeValue(vm.quote_result.result_data.terms);
      vm.quoteType = "copyQuote";
      $mdDialog.show({
        template:
          '<md-dialog id="copy-quote-popup" class="popup-md"><terms-condition-popup  quote-type="$ctrl.quoteType" terms-condition="$ctrl.termsCondition" callback="$ctrl.submitTermsCondition(data)"></terms-condition-popup></md-dialog>',
        clickOutsideToClose: false,
        parent: $rootElement,
        scope: $scope,
        controllerAs: "ctrl",
        preserveScope: true,
        controller: function () {
          this.parent = vm;
        },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        },
      });
    }

    function setDatePicker(data) {
      vm.quote_result.result_data.start_date = data.dateStart;
      vm.quote_result.result_data.expiry_date = data.dateEnd;
      vm.dateRangeError = false;
      vm.cutoffMaxDate =new Date(data.dateEnd)
      vm.newExpiryDate = data.dateEnd;
        // if(vm.quote_Status == "Expired" && vm.expiryCheck){
        //   setTimeout( function () {
        //     $mdDialog.show({
        //       templateUrl: "app/main/quotes/copyQuoteDetails/expiry-change-confirmation.html",
        //       clickOutsideToClose: false,
        //       controllerAs: 'ctrl',
        //       controller: function () { this.parent = vm },
        //     });
        //   },100);
        // }
    }

    function fnExpiryDateChanged(type){
      vm.quote_CardData.forEach(function (card) {
        if(util.getStatusData(card.data[vm.buyOrSell][vm.l3_leg].rate_obj) ==
        "EXPIRED" && !card.meta.type.includes("spot") && type=='submit' && vm.includeRateCards){
        card.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry = moment(vm.newExpiryDate).format("DD MMM YYYY");
        vm.expiryCheck = false; //To hide pop-up after making expired card to active 
        }
      })
      $mdDialog.hide();
    }

    // clear date
    // function clearDatePicker() {
    //   vm.filterobj.start_date = null;
    //   vm.filterobj.expiry_date = null;
    //   $scope.pickerModel = { dateStart: null };
    // }

    function submitTermsCondition(item) {
      vm.quote_result.result_data.terms = item;
    }

    function showLoadDetailPanel(ev) {
       vm.copyWeight = JSON.parse(JSON.stringify(vm.search_param.load_data));
      var position = vm._mdPanel
        .newPanelPosition()
        .relativeTo(".panel-select-load-detail")
        .addPanelPosition(
          vm._mdPanel.xPosition.CENTER,
          vm._mdPanel.yPosition.BELOW
        );

      var config = {
        attachTo: angular.element(document.body),
        templateUrl:
          "app/main/component/load-detail-selector/load-detail-selector.html",
        controllerAs: "ctrl",
        controller: "LoadDetailController",
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          searchParam: vm.search_param,
          searchForm: vm.copyQuoteForm,
          type: vm.isManual ? '' : "copyQuote",
        },
        onRemoving: function () {
          setLoadDetailValidity();
        },
      };
      vm.formIsPristine = false;
      appCache.put("searchParam", vm.search_param);
      vm._mdPanel.open(config);
    }

    function showLoadPanel(ev) {
      var position = vm._mdPanel
        .newPanelPosition()
        .relativeTo(".panel-select-load")
        .addPanelPosition(
          vm._mdPanel.xPosition.CENTER,
          vm._mdPanel.yPosition.BELOW
        );
      var config = {
        attachTo: angular.element(document.body),
        templateUrl:
          "app/main/component/load-selector/load-select-wrapper.html",
        controllerAs: "ctrl",
        controller: "LoadWrapperController",
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          resetLoadObj: vm.resetLoadObj,
          loadTypeArr: vm.loadTypeArr,
          mode: vm.search_param.mode,
          type: vm.isManual ? '' : "copyQuote",
        },
        onOpenComplete: function () {
          loadDataFactory.panelClosed = false;
        },
        onRemoving: function () {
          vm.loadArray = loadDataFactory.loadData;
          loadDataFactory.panelClosed = true;
          setLoadValidity();
          makeLoadBoxString();
          updateLoadArray();
        },
      };
      vm.formIsPristine = false;
      loadDataFactory.loadData = vm.loadArray;
      vm._mdPanel.open(config);
    }

    function getPortsLocation(searchText, mode, searchType) {
      var placeType = "";
      return SearchService.getPortsLocation(
        searchText,
        mode,
        searchType,
        placeType
      );
    }

    function prepLoadData() {
      if (vm.search_param.mode === "SEA-FCL") {
        vm.loadArray = util.getLoadArrayFromParam(
          vm.search_param.load_data.load_details_value
        );
        vm.resetLoadObj = angular.copy(vm.loadArray);
        makeLoadBoxString();
      } else {
        vm.search_param.load_data =
          vm.search_param.mode === "AIR"
            ? SearchService.calculateAirLoad(vm.search_param.load_data)
            : SearchService.calculateLclLoad(vm.search_param.load_data);
        if (vm.copyQuoteForm && vm.copyQuoteForm.$error.loadDetailError) {
          setLoadDetailValidity();
        }
      }
      makeDetailBoxString();
    }

    function makeDetailBoxString() {
      vm.detailBoxString =
        (vm.search_param.origin_charges ? "Origin, " : "") +
          (vm.search_param.origin_customs ? "Origin Custom, " : "") +
          (vm.search_param.destination_charges ? "Destination, " : "") +
          (vm.search_param.destination_customs ? "Destination Custom, " : "") +
          (vm.search_param.mode === "SEA-FCL"
            ? vm.search_param.stuffing === "F"
              ? "Factory Stuffing"
              : "Dock Stuffing"
            : "") || "Select Charges";

      vm.detailBoxTooltip =
        (vm.search_param.origin_charges ? "Origin\n" : "") +
          (vm.search_param.origin_customs ? "Origin Custom\n" : "") +
          (vm.search_param.destination_charges ? "Destination\n" : "") +
          (vm.search_param.destination_customs ? "Destination Custom\n" : "") +
          (vm.search_param.mode === "SEA-FCL"
            ? vm.search_param.stuffing === "F"
              ? "Factory Stuffing"
              : "Dock Stuffing"
            : "") || "Select Charges";

      vm.detailBoxString =
        vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ","
          ? vm.detailBoxString.slice(0, -2)
          : vm.detailBoxString;
    }

    function prepSearchData() {
      vm.searchConfig = $rootScope.domainData.domain_info["SEARCH_CONFIG"];
      vm.salesPersonType =
        util.userProfile.user && util.userProfile.user.is_sales_cordinator
          ? "SALES_COORDINATOR"
          : !util.isShipper
          ? "SALES_USER"
          : "SHIPPER_USER";

      if (
        vm.searchConfig &&
        vm.searchConfig.sales_person &&
        !util.isShipper &&
        vm.salesPersonList &&
        !vm.salesPersonList.length &&
        !vm.isSalesApiLoading
      ) {
        vm.getSalesPersonList("", "init");
      }

      if (!(vm.currentState === "app.copyQuotesDetails")) {
        vm.search_param.search_name = null;
      }
    }

    function setLoadDetailValidity() {
      vm.includeRateCards = true;
      vm.type = "load_weight";
      if (
        (vm.search_param.load_data.load_type === "total_shipment" &&
          (!vm.search_param.load_data.load_meta.total_qty ||
            !vm.search_param.load_data.load_meta.total_volume ||
            !vm.search_param.load_data.load_meta.total_weight)) ||
        (vm.search_param.load_data.load_type === "units" && unitLoadHasError())
      ) {
        vm.copyQuoteForm.$error.loadDetailError = true;
        vm.disableRefreshRates = true;
      } else if (vm.copyQuoteForm.$error.loadDetailError) {
        vm.disableRefreshRates = false;
        delete vm.copyQuoteForm.$error.loadDetailError;
      }
      if (
        !angular.equals(
          vm.copyWeight,
          vm.search_param.load_data
        ) &&
        !vm.copyQuoteForm.$error.loadDetailError && vm.quote_CardData.length
      ) {
        $mdDialog.show({
          template:
            '<md-dialog id="copy-quote-confirmation" class="popup-sm"><copy-quote-confirmation from="$ctrl.copyWeight"  to="$ctrl.search_param.load_data" copy-weight="$ctrl.copyWeight" load-array="$ctrl.loadArray" type="$ctrl.type" include-rate-cards="$ctrl.includeRateCards" search-param="$ctrl.search_param" quoteCardData="$ctrl.quote_CardData" callback="$ctrl.fnAirLclLoadChanged()"></copy-quote-confirmation></md-dialog>',
          clickOutsideToClose: false,
          parent: $rootElement,
          scope: $scope,
          controllerAs: "ctrl",
          preserveScope: true,
          controller: function () {
            this.parent = vm;
          },
        });
      }
      unitLoadHasError();
    }


    function unitLoadHasError() {
      return vm.search_param.load_data.load_details_value.some(function (
        load
      ) {
        return (
          !load.breadth ||
          !load.height ||
          !load.length ||
          !load.qty ||
          !load.weight
        );
      });
    }

    function makeLoadBoxString() {
      vm.LoadBoxString = "";
      vm.LoadTooltipString = "";
      vm.loadArray.forEach(function (i, k) {
        if (i.type) {
          vm.LoadBoxString =
            vm.LoadBoxString +
            (vm.LoadBoxString === "" ? "" : ", ") +
            i.type +
            " x" +
            (i.count || 0);
          vm.LoadTooltipString =
            vm.LoadTooltipString +
            (vm.LoadTooltipString === "" ? "" : "\n") +
            i.type +
            " x" +
            (i.count || 0);
        }
      });
    }

    function loadBoxString(load) {
      var loadString = "";
      if (load) {
        load.forEach(function (i, k) {
          if (i.type) {
            loadString =
              loadString +
              (loadString === "" ? "" : ", ") +
              i.type +
              " x" +
              (i.qty || 0);
          }
        });
      }
      return loadString;
    }

    function updateLoadArray() {
      vm.type = "load";
      vm.includeRateCards = true;
      if (
        vm.loadArray.length &&
        vm.search_param.load_data.load_details_value.length
      ) {
        vm.loadArray.forEach(function (load) {
          load.bl_qty = vm.search_param.load_data.load_details_value[0].bl_qty;
          load.sbl_qty =
            vm.search_param.load_data.load_details_value[0].sbl_qty;
        });
      }
      vm.FormatloadArray = util.formFclSearchData(
        vm.search_param.load_data,
        vm.loadArray
      );
      if (
        !angular.equals(
         vm.copyLoadFcl.load_details_value,
          vm.search_param.load_data.load_details_value
        ) &&
        vm.search_param.load_data.load_details_value.length &&
        !vm.copyQuoteForm.$error.loadError  && vm.quote_CardData.length
      ) {
        $mdDialog.show({
          template:
            '<md-dialog id="copy-quote-confirmation" class="popup-sm"><copy-quote-confirmation from="$ctrl.copyLoadFcl.load_details_value"  to="$ctrl.search_param.load_data.load_details_value" copy-load-fcl="$ctrl.copyLoadFcl" load-array="$ctrl.loadArray" type="$ctrl.type" include-rate-cards="$ctrl.includeRateCards" search-param="$ctrl.search_param" quote-card-data="$ctrl.quote_result.result_data.cards"  load-box-string="$ctrl.LoadBoxString" load-tooltip-string="$ctrl.LoadTooltipString" callback="$ctrl.fnFclLoadChanged()"></copy-quote-confirmation></md-dialog>',
          clickOutsideToClose: false,
          parent: $rootElement,
          scope: $scope,
          controllerAs: "ctrl",
          preserveScope: true,
          controller: function () {
            this.parent = vm;
          },
        });
      }
    }

    function setLoadValidity() {
      var loadHasError = false;

      loadHasError = vm.loadArray.some(function (load, key) {
        if (!load.type || !load.count || !load.weight_qty) {
          return true;
        }
      });

      if (loadHasError) {
        vm.copyQuoteForm.$error.loadError = true;
        vm.disableRefreshRates = true;
      } else if (vm.copyQuoteForm.$error.loadError) {
        vm.disableRefreshRates = false;
        delete vm.copyQuoteForm.$error.loadError;
      }
    }

    // function fetchNearBy(origin, mode, input_type, cargo_date, destination) {
    //   util.callMixpanel("Cut off date", {
    //     Mode: mode,
    //   });
    //   if (
    //     origin &&
    //     origin.place_type == "Door" &&
    //     (input_type == "cargo_date" || input_type == "origin")
    //   ) {
    //     var data = {
    //       data: {
    //         location: origin.location,
    //         input_type: "origin",
    //         cargo_ready_date: cargo_date,
    //         mode: mode,
    //         nearby_port_limit: 0,
    //         location_id: origin._id,
    //         vendor_id: origin.vendor_id,
    //         location_pincode: origin.pin_code_ui,
    //         country_code: origin.country_code,
    //       },
    //     };
    //     //SearchService.fetchNearbyRates(data);
    //   }
    //   if (
    //     destination &&
    //     destination.place_type == "Door" &&
    //     (input_type == "cargo_date" || input_type == "destination")
    //   ) {
    //     var data = {
    //       data: {
    //         location: destination.location,
    //         input_type: "destination",
    //         cargo_ready_date: cargo_date,
    //         mode: mode,
    //         nearby_port_limit: 0,
    //         location_id: destination._id,
    //         vendor_id: destination.vendor_id,
    //         location_pincode: destination.pin_code_ui,
    //         country_code: destination.country_code,
    //       },
    //     };
    //     //SearchService.fetchNearbyRates(data);
    //   }
    // }

    function checkForSamePorts(params, ev,oldvalue) {
      vm.fillSearchParam();
      vm.isDestinationReceipt = false;
      vm.isOriginReceipt = false;
      vm.params = params;
      vm.includeRateCards = false;
      vm.type = "location";
      vm.searchType = "";
      vm.disableRefreshRates = false;
      //Assigning old value for manual create quote
      params === "origin" ? vm.copyOriginLocation=oldvalue : vm.copyDestinationLocation=oldvalue ;
    vm.from =
    params === "origin"
      ? (vm.copyOriginLocation)
      : vm.copyDestinationLocation;
      vm.to =
        params === "origin"
          ? vm.search_param.origin_location
          : vm.search_param.destination_location;
      if (
        vm.search_param.origin_location &&
        vm.search_param.origin_location.place_type === "Door"
      ) {
        vm.isOriginReceipt = true;
      }
      if (
        vm.search_param.destination_location &&
        vm.search_param.destination_location.place_type === "Door"
      ) {
        vm.isDestinationReceipt = true;
      }
      if (
        vm.from && vm.to &&
        !angular.equals(vm.from.location, vm.to.location) &&
        vm.from.location && vm.to.location && vm.quote_CardData.length
      ) {
        $mdDialog.show({
          template:
            '<md-dialog id="copy-quote-confirmation" class="popup-sm"><copy-quote-confirmation from="$ctrl.from"  to="$ctrl.to" type="$ctrl.type"  copy-origin-location="$ctrl.copyOriginLocation" copy-destination-location="$ctrl.copyDestinationLocation" is-destination-door="$ctrl.isDestinationReceipt" is-Origin-Door="$ctrl.isOriginReceipt" include-rate-cards="$ctrl.includeRateCards" search-param="$ctrl.search_param" param="$ctrl.params" quote-card-Data="$ctrl.quote_CardData" search-type="$ctrl.searchType"></copy-quote-confirmation></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          parent: $rootElement,
          scope: $scope,
          controllerAs: "ctrl",
          preserveScope: true,
          controller: function () {
            this.parent = vm;
          },
        });
      }
      // vm.fetchNearBy(
      //   vm.search_param.origin_location,
      //   vm.search_param.mode,
      //   params,
      //   vm.search_param.cargo_ready_date,
      //   vm.search_param.destination_location
      // );
      if (
        vm.search_param.origin_location &&
        vm.search_param.destination_location &&
        vm.search_param.origin_location.portcode_portname ===
          vm.search_param.destination_location.portcode_portname
      ) {
        vm.copyQuoteForm.$error.samePortError = true;
        vm.disableRefreshRates = true;
      } else if (vm.copyQuoteForm.$error.samePortError) {
        vm.disableRefreshRates = false;
        delete vm.copyQuoteForm.$error.samePortError;
      }
      //rates refresh button disable
      if(vm.copyQuoteForm.fcl_origin_port.$invalid || vm.copyQuoteForm.fcl_destination_port.$invalid ){
        vm.disableRefreshRates = true;
      }
      
    }

    function calculateQtyRange(charge, key) {
      var unit = charge.total_units;
      if (unit >= charge.slab[key].to) {
        return (
          charge.slab[key].to -
          (charge.slab[key - 1] ? charge.slab[key - 1].to : 0)
        );
      } else if (unit >= charge.slab[key].from) {
        return unit - charge.slab[key].from + 1;
      } else {
        return 0;
      }
    }


    function searchHighlight(text, search) {
      if (search && search !== "" && text) {
        text = text.charAt(0).toUpperCase() + text.slice(1);
        return text.replace(
          new RegExp(search.replace(/\\/g, " ").replace(/[{(*+)}]/g, ""), "gi"),
          '<span class="searchTextStyle">$&</span>'
        );
      }
      return text;
    }

    function focusElem() {
      setTimeout(function () {
        if (angular.element("#ref-name-search")[0]) {
          angular.element("#ref-name-search")[0].focus();
        }
      }, 50);
    }

    function getInitData() {
      vm.getSubvendor = [];
      if (util.isAdmin || util.isFreightbro) {

        if (vm.search_param.mode == "AIR") {
          resultService.getAirlineData().then(
            function (response) {
              vm.getAirline = response.data.data;
            },
            function (error) {
              vm.getAirline = [];
            }
          );
        }

        var mode =
          vm.search_param.mode == "SEA-FCL"
            ? "fcl"
            : vm.search_param.mode == "AIR"
            ? "air"
            : "lcl";
        // resultService.getTermsConditions(mode, "true").then(
        //   function (response) {
        //     vm.stdTermsAndConditions = response.data.terms;
        //     //vm.quote_result.result_data.terms = (vm.stdTermsAndConditions && !vm.quote_result.result_data.terms && vm.pageSource =='create-quote') ? vm.stdTermsAndConditions :  vm.quote_result.result_data.terms 
        //   },
        //   function (error) {
        //     vm.stdTermsAndConditions = "";
        //   }
        // );

        if (!util.getSubvendor.length) {
          resultService.getSubVendor().then(
            function (response) {
              angular.forEach(response.data.subvendor_data, function (item) {
                if (item.carrier_code != null && item.carrier_code != "") {
                  vm.getSubvendor.push(item);
                  util.getSubvendor = angular.copy(vm.getSubvendor);
                }
              });
            },
            function (error) {
              vm.getSubvendor = [];
              util.getSubvendor = [];
            }
          );
        } else {
          vm.getSubvendor = angular.copy(util.getSubvendor);
        }
      }
    }
    // init();
    // bind card leg according buyRates or SellRates data
    function fnGetLegs(cardItem) {
      var result = [];
      result = cardItem[vm.buyOrSell];
      return result;
    }

    // Set current id - by isaac
    function setCurrentid() {
      vm.id = QuotesService.quote_id;
    }

    function cancelDialog() {
      util.callMixpanel("QC-POP-Close-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
      $mdDialog.hide();
      vm.dataErr = false;
      vm.otpError = "";
    }

    // functions validate OTP - by Isaac
    function otpValidation() {
      var otp = localStorage.getItem("otp");
      otp = angular.fromJson(otp);
      var time_now = new Date().getTime();

      if (!otp) {
        var i = {};
        localStorage.setItem("otp", angular.toJson(i));
        vm.showSharedFooter = true;
      } else if (!(vm.id in otp)) {
        vm.showSharedFooter = true;
      } else if (vm.id in otp) {
        var a = otp[vm.id];
        var otpToSave = a.substr(0, a.lastIndexOf("-"));
        localStorageService.otp = otpToSave;
        a = a.split("-")[a.split("-").length - 1];
        if (a - time_now > 21600000) {
          util.showToast("OTP has expired!");
          delete otp[vm.id];
          localStorage.setItem("otp", angular.toJson(otp));
          vm.showSharedFooter = true;
        } else {
          vm.showSharedFooter = false;
        }
      }

      // clean up of expired OTPs

      for (a in otp) {
        var checkTime = otp[a].split("-")[1];
        if (checkTime - time_now > 21600000) {
          delete otp[a];
          localStorage.setItem("otp", angular.toJson(otp));
        }
      }
    }



    function printDiv(printLink) {
      // $window.print();
      $window.open(util.sanitizeQueryParams(printLink), "pdfLink");
      // a.focus();
    }

    //function to form load details
    function formContainerType(mode, loadDetails) {
      var result = "";
      if (mode == "SEA-FCL") {
        result = util.formLoadDetails(loadDetails);
      } else if (mode != "SEA-FCL") {
        result = util.formAirLoadDetails(loadDetails, mode);
      }
      return result;
    }

    //open modal to view card details
    function viewDetailsModal(currCard, ev, activeTab, msrOrNetwork) {

      currCard.meta.remarks = util.decodeValue(currCard.meta.remarks);
      currCard.meta.inclusions = util.decodeValue(currCard.meta.inclusions);
      currCard.meta.internal_remarks = util.decodeValue(currCard.meta.internal_remarks);
      
      // REQUEST BOOKING FRO SHIPPER
      vm.btnShipperBooking = false;
      //  ( (vm.util.navPermission.shipments[0] && vm.showBookBtn) || vm.isShared ) &&
      //   !vm.copyquoted &&
      //   !vm.proceedduplicate
      //     ? true
      //     : false;

      // if (vm.btnShipperBooking) {

      //   vm.btnShipperBooking =
      //   ((currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj
      //   .expiry && vm.util.getStatusData(
      //         currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj
      //       ) != "EXPIRED") || !currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj
      //       .expiry) &&
      //       !vm.quotePreview &&
      //       !vm.quote_result.result_data.is_booked &&
      //       !vm.isquotemodify &&
      //       !vm.quote_result.result_data.revised &&
      //       !vm.isLost &&
      //       !vm.isExpired

      //       ? true
      //       : false;
      // }

      if ((vm.isShared || util.isShipper) && !currCard.data.sell_rates) {
        currCard.data.sell_rates = angular.copy(currCard.data.buy_rates);
      }

      vm.footerObj.doneBtnDisable = false;
      vm.rem_open = true;
      vm.inl_open = true;
      vm.addOrEditCard = activeTab;
      vm.quoteEdit = false;
      vm.editBuyRate = true;
      vm.allowEditMainData = false;
      vm.msrOrNetwork = msrOrNetwork;

      vm.fclSlab = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab_charges;

      // condition to show slab tab
      if (
        vm.search_param.mode == "AIR" &&
        (util.isAdmin || util.isFreightbro)
      ) {
        vm.ratesVisible = currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj
          .slab_rate
          ? 1
          : 0;
      } else if (
        vm.search_param.mode == "SEA-FCL" &&
        (util.isAdmin || util.isFreightbro)
      ) {
        vm.ratesVisible = vm.fclSlab && vm.fclSlab.length ? 1 : 0;
      } else {
        vm.ratesVisible = 0;
      }

      vm.airScheduleVisible = vm.search_param.mode == "AIR" ? 1 : 0;
      vm.scheduleVisible = vm.search_param.mode != "AIR" ? 1 : 0;
      vm.analyticsVisible = 0;
      vm.quotationVisible = 1;
      vm.termsVisible =
        vm.search_param.mode != "AIR" && currCard.meta.type.includes("spot")
          ? 1
          : 0;

      if (activeTab == "rates" && vm.ratesVisible) {
        vm.selectedIndex = 0;
      }
      if (activeTab == "schedule") {
        vm.selectedIndex = vm.ratesVisible;
      }
      if (
        activeTab == "quotationEdit" ||
        activeTab == "addNewQuote" ||
        activeTab == "quotation" ||
        activeTab == "newCopyQuote"
      ) {
        vm.selectedIndex =
          (vm.scheduleVisible || vm.airScheduleVisible) +
          vm.ratesVisible +
          vm.analyticsVisible;
      }
      if (activeTab == "tnc") {
        vm.selectedIndex =
          (vm.scheduleVisible || vm.airScheduleVisible) +
          vm.ratesVisible +
          vm.analyticsVisible +
          (vm.quotationVisible ? 2 : 0);
      }

      if (
        activeTab == "addNewQuote" ||
        activeTab == "quotationEdit" ||
        activeTab == "schedule" ||
        activeTab == "newCopyQuote"
      ) {
        vm.quoteEdit = true;
        // vm.ratesVisible = false;
        vm.getData = true;
        vm.resultCardFilter.getDataSchedule = true;
        vm.editBuyRate = true;
        currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry = currCard.data
          .sell_rates[vm.l3_leg].rate_obj.expiry
          ? moment(currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry).format(
              "YYYY-MM-DD"
            )
          : null; //popup meta expiry date for new card

        if (activeTab == "addNewQuote" || activeTab == "schedule") {
          var validation = vm.newCardValidation(currCard);

          if (validation) {
            return;
          }
        } else if (
          activeTab == "quotationEdit" ||
          activeTab == "newCopyQuote"
        ) {
          vm.allowEditMainData = true;
        }
      } else if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
        vm.quoteEdit = true;
        // vm.ratesVisible = (vm.isShared || util.isShipper) ? true : false;
        vm.getData = true;
        vm.resultCardFilter.getDataSchedule = true;

        // vm.editBuyRate = util.userProfile.user.allow_edit ? true : false;
        vm.editBuyRate = true;

        var count = 1;
        if (
          vm.search_param.mode == "SEA-FCL" &&
          currCard.data.buy_rates[vm.l3_leg].rate_obj.is_special &&
          currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
            .max_qty_per_shipment != null
        ) {
          for (var j in currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
            .max_qty_per_shipment) {
            for (
              var i = 0;
              i < vm.search_param.load_data.load_details_value.length;
              i++
            ) {
              if (
                vm.search_param.load_data.load_details_value[i].type == j &&
                vm.search_param.load_data.load_details_value[i].qty >
                  currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
                    .max_qty_per_shipment[j]
              ) {
                if (vm.selectedIndex == 3) {
                  util.showToast(
                    "Max quantity allowed for " +
                      j +
                      " is " +
                      currCard.data.buy_rates[vm.l3_leg].rate_obj.special_meta
                        .max_qty_per_shipment[j]
                  );
                  count = 0;
                }
                vm.quotationVisible = false;
                break;
              }
            }
            if (count === 0) {
              break;
            }
          }

          if (count === 0) {
            return;
          }
        }
      }

      var getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
        function (element) {
          return element.vendor_id == currCard.meta.vendor_id;
        }
      );

      shareQuoteService.currencyConverter = {}; //Reset currency converter setting
      if (!getCurrencyRate) {
        vm.fnGetCurrencyconversion(
          vm.searchUser.user_base_currency,
          currCard.meta.vendor_id
        );
        currCard.meta.conversionRate = vm.currencyObj;
      } else {
        vm.currency_rates = getCurrencyRate.curr_data;
        currCard.meta.conversionRate = getCurrencyRate;
        vm.callingConversionApi = false;
        // Currency conversion setting code
        shareQuoteService.setCurrencyConvSetting(
          vm.searchUser.user_base_currency,
          getCurrencyRate.markup,
          getCurrencyRate.directCurrencyMapping,
          vm.currency_rates
        );
      }
      $rootScope.loadingDetails = true;
      vm.showData = true;
      vm.ScheduleCard = currCard;
      if (vm.search_param.mode == "AIR" && (util.isShipper || vm.isShared)) {
        vm.displayRates = true;
      } else if (
        vm.search_param.mode != "AIR" &&
        (util.isShipper || vm.isShared)
      ) {
        vm.displayRates = false;
      }

      // Conveniance fee
      vm.getConvFeeCost(currCard);

      vm.currentCard = angular.copy(currCard);

      getDataForExchangeRate();

      // Get Dim leg list
      vm.dimLegList = [];
      vm.dimLegList = shareQuoteService.fnGetDimLegs(
        vm.currentCard.data.buy_rates
      );

      vm.legSuggestionList = [];
      vm.footerObj.sellTotalBaseCurr = 0;
      vm.chargeShow = 5;

      if (
        vm.search_param.mode == "SEA-FCL" &&
        (SearchService.loadTypeArr == undefined ||
          SearchService.loadTypeArr.length == 0)
      ) {
        SearchService.getAllLoadList().then(
          function (response) {
            SearchService.loadTypeArr = response;
            vm.loadTypeArr = response;
            util.limitObj = response;
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.loadTypeArr =
          SearchService.loadTypeArr != undefined
            ? SearchService.loadTypeArr
            : [];
      }
    }

    // call conversion rates api
    function fnGetCurrencyconversion(user_base_currency, vendor_id, action) {
      vm.callingConversionApi = true;
      return resultService
        .getCurrencyConversionForVendor(user_base_currency, vendor_id,vm.search_param.mode,true)
        .then(
          function (response) {
            vm.currencyObj = response.data;
            vm.resultCardFilter.currency_conversion_rates.push(vm.currencyObj);
            vm.callingConversionApi = false;
            if (action == "addNewCard") {
              vm.fnDefaultCharge();
            }
            vm.currency_rates = vm.currencyObj.curr_data;
            // Currency conversion setting code
            shareQuoteService.setCurrencyConvSetting(
              vm.searchUser.user_base_currency,
              vm.currencyObj.markup,
              vm.currencyObj.directCurrencyMapping,
              vm.currency_rates
            );
          },
          function (error) {
            // Currency conversion setting code
            shareQuoteService.setCurrencyConvSetting(
              vm.searchUser.user_base_currency,
              null,
              [],
              vm.currency_rates
            );
            vm.callingConversionApi = false;
            $log.log(error.data);
            util.showToast(util.displayValidationError(error));
          }
        );
    }

    function getDataForExchangeRate() {
      vm.resultId = vm.quotePreview
        ? vm.quote_result.result_data.exchangeRateId
        : vm.quote_result.result_data._id;
      vm.cardVendorId = vm.currentCard.meta.vendor_id;
      vm.resultType = vm.quotePreview
        ? vm.quote_result.result_data.quoteFrom
        : "Quote";
    }



    //Conveniance fee code
    function getConvFeeCost(currCard) {
      if (
        vm.search_param.mode == "SEA-FCL" &&
        currCard.meta.additional_charges
      ) {
        if (
          currCard.meta.additional_charges.url &&
          !currCard.meta.additional_charges.data && !vm.isShared
        ) {
          var total_cost = vm.rateTotalCustomCurr(currCard.data.buy_rates);
          vm.showConvLoader = true;
          vm.footerObj.doneBtnDisable = true;
          resultService
            .getConvFee(
              currCard,
              total_cost,
              SearchService.FclResult._id,
              currCard.data.buy_rates[vm.l3_leg].rate_obj.leg_total_currency
            )
            .then(
              function (response) {
                vm.fnDisplayProfit(); // calling dispay profit only in quotation tab
                vm.currentCard.meta.additional_charges = angular.copy(currCard.meta.additional_charges);
                vm.showConvLoader = false;
                vm.footerObj.doneBtnDisable = false;
              },
              function (error) {
                vm.showConvLoader = false;
                vm.footerObj.doneBtnDisable = false;
                $log.error(error);
              }
            );
        }
      }
    }

    //Calculate profit
    function fnDisplayProfit() {
      vm.footerObj.buyTotalWithConv = 0;
      vm.footerObj.buyTotalBaseCurr = vm.rateTotalCustomCurr(
        vm.currentCard.data.buy_rates
      );
      vm.footerObj.sellTotalBaseCurr = vm.rateTotalCustomCurr(
        vm.currentCard.data.sell_rates
      );
      // Add Conveinance fee if present
      if (
        vm.currentCard.meta.additional_charges &&
        vm.currentCard.meta.additional_charges.data
      ) {
        vm.footerObj.buyTotalWithConv =
          vm.footerObj.buyTotalBaseCurr +
          parseFloat(
            vm.currentCard.meta.additional_charges.data.leg_total_cost
          );
      } else {
        vm.footerObj.buyTotalWithConv = vm.footerObj.buyTotalBaseCurr;
      }
      vm.footerObj.profit = util.getProfitValue(
        vm.footerObj.sellTotalBaseCurr,
        vm.footerObj.buyTotalWithConv
      );
    }


    // set sell rates charges
    function fnSetCharges(key, value, action) {
      angular.forEach(value.rate_obj.charges, function (childValue) {
        if (action == "rates") {
          var getCharge = vm.currentCard.data.buy_rates[
            value.leg_code
          ].rate_obj.charges.find(function (element) {
            return element.charge_id == childValue.charge_id;
          });

          if (!getCharge) {
            var newBuyCharge = angular.copy(childValue);
            newBuyCharge.per_unit_rate = 0;
            newBuyCharge.charge_cost = 0;
            newBuyCharge.minimum_charge_cost = 0;
            newBuyCharge.customer_currency_cost = 0;
            newBuyCharge.leg_currency_cost = 0;

            vm.currentCard.data.buy_rates[value.leg_code].rate_obj.charges.push(
              newBuyCharge
            );

            var getCard = vm.temp_quoteData.result_data.cards.find(function (
              element
            ) {
              return element._id == vm.currentCard._id;
            });

            if (getCard) {
              var newBuyCard = angular.copy(getCard.data.buy_rates);

              if (!newBuyCard.hasOwnProperty(value.leg_code)) {
                newBuyCard[value.leg_code] =
                  vm.currentCard.data.buy_rates[value.leg_code];
              } else {
                var getCharge = newBuyCard[
                  value.leg_code
                ].rate_obj.charges.find(function (element) {
                  return element.charge_id == childValue.charge_id;
                });

                if (!getCharge) {
                  newBuyCard[value.leg_code].rate_obj.charges.push(
                    newBuyCharge
                  );
                }
              }

              getCard.data.buy_rates = angular.copy(newBuyCard);
            }
          }
        }

        if (childValue.charge_basis == "per shpt") {
          childValue.charge_basis == "per shipment";
        }

        if (vm.search_param.mode != "SEA-FCL") {
          if (
            key == "l3_air" &&
            childValue.global_charge_id != null &&
            childValue.global_charge_id != "" &&
            childValue.global_charge_id.indexOf(
              shareQuoteService.airChargeId
            ) >= 0
          ) {
            vm.currentCard.meta["AirFreight"] = childValue;
          }

          if (
            key == "l1_lcl" &&
            childValue.global_charge_id &&
            childValue.global_charge_id.indexOf(
              shareQuoteService.pickupChargeId
            ) >= 0
          ) {
            vm.ScheduleCard.meta["pickupCharge"] = angular.copy(childValue);
          }
          if (
            key == "l5_lcl" &&
            childValue.global_charge_id &&
            childValue.global_charge_id.indexOf(
              shareQuoteService.deliveryChargeId
            ) >= 0
          ) {
            vm.ScheduleCard.meta["deliveryCharge"] = angular.copy(childValue);
          }
        }
      });
    }

    // new card validation toast
    function newCardValidation(currCard) {
      if (
        vm.search_param.mode != "AIR" &&
        !currCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id
      ) {
        util.showToast("Please select liner name.");
        return true;
      } else if (
        vm.search_param.mode == "AIR" &&
        !currCard.data.sell_rates[vm.l3_leg].rate_obj.airline_code
      ) {
        util.showToast("Please select airline name.");
        return true;
      }

      if (!currCard.data.sell_rates[vm.l3_leg].rate_obj.expiry) {
        util.showToast("Please select expiry date.");
        return true;
      }

      // Origin
      if (!vm.quoteNewCard.meta.port_data.origin_port_code) {
        if (vm.quoteNewCard.meta.port_data.is_icd_port_origin) {
          util.showToast("Please select valid origin port.");
        } else {
          util.showToast("Please select valid loading port.");
        }
        return true;
      }

      // origin haulage validation
      if (
        vm.search_param.mode == "SEA-FCL" &&
        vm.quoteNewCard.meta.port_data.is_icd_port_origin &&
        !vm.quoteNewCard.meta.haulage
      ) {
        util.showToast("Please select valid origin haulage.");
        return true;
      }

      // pol validation
      if (
        vm.quoteNewCard.meta.port_data.is_icd_port_origin &&
        !vm.quoteNewCard.meta.via_pol
      ) {
        util.showToast("Please select valid loading port.");
        return true;
      }

      // pod validation
      if (
        vm.quoteNewCard.meta.port_data.is_icd_port_destination &&
        !vm.quoteNewCard.meta.via_pod
      ) {
        util.showToast("Please select valid Discharge port.");
        return true;
      }

      // destination haulage validation
      if (
        vm.search_param.mode == "SEA-FCL" &&
        vm.quoteNewCard.meta.port_data.is_icd_port_destination &&
        !vm.quoteNewCard.meta.destination_haulage
      ) {
        util.showToast("Please select destination haulage.");
        return true;
      }

      // Destination port
      if (!vm.quoteNewCard.meta.port_data.destination_port_code) {
        if (vm.quoteNewCard.meta.port_data.is_icd_port_destination) {
          util.showToast("Please select valid destination port.");
        } else {
          util.showToast("Please select valid discharge port.");
        }
        return true;
      }
      if (QuotesService.samePortValidation(currCard)) {
        return true;
      }
    }


    // get card leg user base currency total
    function rateTotalCustomCurr(cards) {
      var convertTotal = 0;
      angular.forEach(cards, function (value) {
        if (value.rate_obj) {
          convertTotal += parseFloat(value.rate_obj.leg_total_cost);
        }
      });

      convertTotal = $filter("number")(convertTotal, 2);
      convertTotal = Number(convertTotal.split(",").join(""));
      return convertTotal;
    }

    //for freightbro user can select schedule
    function selectedSchedule(scheduleObj, from) {
      vm.currentCard.meta.selected_schedule = scheduleObj;

      if (vm.addOrEditCard == "addNewQuote" || vm.addOrEditCard == "schedule") {
        vm.quoteNewCard.meta.selected_schedule = angular.copy(scheduleObj);
        vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data =
          vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;

        vm.quoteNewCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data =
          vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;
      } else {
        var getCardData = $filter("filter")(
          vm.quote_CardData,
          { _id: vm.currentCard._id },
          true
        );
        vm.ScheduleCard.meta.selected_schedule = scheduleObj;

        if (getCardData.length) {
          var index = vm.quote_CardData.indexOf(getCardData[0]);

          if (
            !angular.equals(
              vm.quote_CardData[index].meta.selected_schedule,
              scheduleObj
            )
          ) {
            vm.isQuoteModify = true;
          }
          vm.quote_CardData[index].meta.selected_schedule =
            angular.copy(scheduleObj);

          vm.quote_CardData[index].data.sell_rates[
            vm.l3_leg
          ].rate_obj.schedule.data =
            vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.schedule.data;

          vm.quote_CardData[index].data.buy_rates[
            vm.l3_leg
          ].rate_obj.schedule.data =
            vm.currentCard.data.buy_rates[vm.l3_leg].rate_obj.schedule.data;
        }
      }

      vm.schedule_display = true;
      if (from != "fromNewSchedule") {
        $mdDialog.hide();
      }

      //mixpanel code
      util.callMixpanel("QC-SchSelectButton-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
    }

    //for freightbro user can set schedule
    function setCurrentSchedule(current_schedule, index) {
      vm.current_schedule = current_schedule;
      var l3expiryDate = "";
      if (!vm.ScheduleCard.data[vm.buyOrSell]) {
        l3expiryDate =
          vm.ScheduleCard.data["buy_rates"][vm.l3_leg].rate_obj.expiry;
      } else {
        l3expiryDate =
          vm.ScheduleCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry;
      }
      if (
        vm.current_schedule != null &&
        vm.current_schedule.departure_time > l3expiryDate
      ) {
        vm.ifExpireCross = true;
      } else {
        vm.ifExpireCross = false;
      }

      var cardIndex = index + 1;
      //mixpanel code
      util.callMixpanel("QC-SchListingCard-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
        CardIndex: cardIndex,
      });
    }


    //function to determine leg load Missing or not
    function isLegLoadMissing(loadObj, Key) {
      return resultService.isLegLoadMissing(loadObj, Key);
    }

    //function to get the remarks or inclusion of cards
    function getCardRemarksInclusion(cardObj, key) {
      var result = "";
      // if ( vm.addOrEditCard == 'rates' && vm.msrOrNetwork ) {

      //   result = resultService.getCardRemarksInclusion(cardObj,key);
      // }else
      // {
      if (key == "REMARKS") {
        result = !!vm.currentCard.meta.remarks
          ? vm.currentCard.meta.remarks
          : "";

        result = result
          ? result
          : resultService.getCardRemarksInclusion(cardObj, key);
      } else if (key == "INCLUSIONS") {
        result = !!vm.currentCard.meta.inclusions
          ? vm.currentCard.meta.inclusions
          : "";

        result = result
          ? result
          : resultService.getCardRemarksInclusion(cardObj, key);
      }
      // }
      return result;
    }

    //get buy rate charge currency in quote tab
    function fnGetBuyChargeCurrency(key_name, id) {
      var result = "-";
      if (vm.currentCard.data.buy_rates.hasOwnProperty(key_name)) {
        var chargeObj = $filter("filter")(
          vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
          { id: id },
          true
        );
        result = chargeObj.length ? chargeObj[0].charge_currency : "-";
      }
      return result;
    }

    //get buy rate charge minimum amount in quote tab
    function fnGetBuyMinAmount(key_name, id) {
      var result = "-";
      var chargeObj = $filter("filter")(
        vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
        { id: id },
        true
      );
      result = chargeObj.length ? chargeObj[0].minimum_charge_cost : "-";
      return result;
    }

    //get buy rate charge unit price in quote tab
    function fnGetBuyUnitPrice(key_name, id) {
      var result = "-";

      if (vm.currentCard.data.buy_rates.hasOwnProperty(key_name)) {
        var chargeObj = $filter("filter")(
          vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
          { id: id },
          true
        );
        result = chargeObj.length
          ? $filter("number")(chargeObj[0].per_unit_rate, 2)
          : "-";
      }
      return result;
    }

    //get buy rate charge leg currency cost in quote tab
    function fnGetBuyChargeLegCurrencyCost(key_name, id) {
      var result = "-";

      if (vm.currentCard.data.buy_rates.hasOwnProperty(key_name)) {
        var chargeObj = $filter("filter")(
          vm.currentCard.data.buy_rates[key_name].rate_obj.charges,
          { id: id },
          true
        );
        result = chargeObj.length
          ? $filter("number")(chargeObj[0].leg_currency_cost, 2)
          : "-";
      }
      return result;
    }

    vm.hoverIn = function () {
      this.hoverEdit = true;
    };

    vm.hoverOut = function () {
      this.hoverEdit = false;
    };

   

    // add / edit / copy rates
    function fnAddOrEditCard(card, action, ev) {
      vm.isCreateQuoteDesValueChange = true;
      vm.isCreateQuoteOriginValueChange = true;
      //checking load details empty or not
      if(vm.pageTitle === "create-quote"){
        vm.isCreateQuote = true;
        if (
          (vm.search_param.load_data.load_type === "total_shipment" && (!vm.search_param.load_data.load_meta.total_qty || !vm.search_param.load_data.load_meta.total_volume || !vm.search_param.load_data.load_meta.total_weight)) 
          ||
          (vm.search_param.load_data.load_type === "units" && unitLoadHasError())
        ) {
          vm.copyQuoteForm.$error.loadDetailError = true;
          vm.disableRefreshRates = true;
        } else if (vm.copyQuoteForm.$error.loadDetailError) {
          vm.disableRefreshRates = false;
          delete vm.copyQuoteForm.$error.loadDetailError;
        }

      }
      if (Object.keys(vm.copyQuoteForm.$error).length) {
        document.getElementById("copy-quote-meta").scrollIntoView();
        return;
      }
      vm.editCard = card ? angular.copy(card) : null;
          
      // adding empty charge row if l3 is empty(copy or edit card)- SUP-868 
      if (
        
        vm.editCard && Object.keys(vm.editCard.data.sell_rates).length ==1 && 
        !vm.editCard.data.sell_rates[vm.l3_leg].rate_obj.charges.length
      ) {
        vm.editCard.data.sell_rates[vm.l3_leg].rate_obj.charges.push(
          angular.copy(vm.cardChargeObj)
        );
        vm.editCard.data.buy_rates[vm.l3_leg].rate_obj.charges.push(
          angular.copy(vm.cardChargeObj)
        );
      }

      if (!util.isAdmin && !util.isFreightbro) {
        vm.editCard.data.sell_rates = angular.copy(vm.editCard.data.buy_rates);
      }

      if (vm.editCard) {
        if (action.toLowerCase().includes("new")) {
          delete vm.editCard["_id"];
        }
        angular.forEach(vm.editCard.data.buy_rates, function (value, key) {
          if (!value.rate_obj) {
            delete vm.editCard.data.buy_rates[key];
            delete vm.editCard.data["sell_rates"][key];
          }
        });
      }
      vm.footerObj = {
        doneBtnDisable: false,
        buyTotalWithConv: 0,
        buyTotalBaseCurr: 0,
        sellTotalBaseCurr: 0,
        profit: 0,
        rateExpired:false
      };
      vm.pageSource = action; //'newCardCopyQuote' 'editCardCopyQuote;
      $mdDialog.show({
        template:
          '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" source-rate="ctrl.parent.sourceRate"page-info="ctrl.parent.pageInfo" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" result-card-filter="ctrl.parent.resultCardFilter" card-data="ctrl.parent.editCard" footer-obj="ctrl.parent.footerObj" co2e-response="ctrl.parent.co2eResponse" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: "ctrl",
        controller: function () {
          this.parent = vm;
        },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        },
      });
    }

    function fnDefaultCharge() {
      vm.getChargeList(
        "Ocean Freight",
        vm.l3_leg,
        vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0]
      ).then(
        function (response) {
          vm.changeSelectedCharge(
            response[0],
            vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.charges[0],
            vm.currentCard.data.sell_rates[vm.l3_leg],
            0,
            vm.l3_leg
          );
          vm.currentCard.meta["isScheduleCall"] = true;
          vm.quoteNewCard.meta["isScheduleCall"] = true;
          vm.currentCard.data.sell_rates[vm.l3_leg].rate_obj.expiry =
            angular.copy(
              vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry
            );
          vm.quoteNewCard.data = angular.copy(vm.currentCard.data);
          vm.addCardData = true;
        },
        function (error) {
          vm.currencyList = [];
          vm.addCardData = true;
          $log.log(error);
        }
      );
    }

    function fngetSubVendorDetails(cardMeta, rate_data) {
      if (vm.search_param.mode == "AIR") {
        for (var i = 0; i < vm.getAirline.length; i++) {
          if (vm.getAirline[i].airline_code == rate_data.airline_code) {
            rate_data.airline.airline_code = vm.getAirline[i].airline_code;
            rate_data.airline.air_line_name = vm.getAirline[i].air_line_name;
            rate_data.airline.airline_prefix = vm.getAirline[i].airline_prefix;
            vm.quoteNewCard.airline = vm.getAirline[i].air_line_name;
            cardMeta.selected_schedule = null;
            rate_data.schedule.data = [];
            vm.schedule_display = false;
            return;
          }
        }
      } else {
        for (var i = 0; i < vm.getSubvendor.length; i++) {
          if (vm.getSubvendor[i].id == rate_data.sub_vendor_id) {
            rate_data.sub_vendor_id = vm.getSubvendor[i].id;
            rate_data.sub_vendor.logo = vm.getSubvendor[i].logo;
            rate_data.sub_vendor.sub_vendor_name = vm.getSubvendor[i].name;
            rate_data.sub_vendor.carrier_code = vm.getSubvendor[i].carrier_code;
            vm.quoteNewCard.sub_vendor = vm.getSubvendor[i].name;
            cardMeta.selected_schedule = null;
            rate_data.schedule.data = [];
            vm.schedule_display = false;
            return;
          }
        }
      }
    }

    //cost convertion if charge cost or currency change
    function conversionOnPriceChange(charge, sellRates) {
      vm.footerObj.doneBtnDisable = true;

      if (
        vm.search_param.mode !== "SEA-FCL" ||
        (vm.search_param.mode === "SEA-FCL" &&
          (charge.charge_basis === shareQuoteService.pickupBasisName ||
            charge.charge_basis === shareQuoteService.deliveryBasisName ||
            charge.charge_basis === shareQuoteService.freightBasisName))
      ) {
        shareQuoteService.isQuoteOrNewcard = "quote";
        vm.getChargeCost(sellRates, charge);
      } else {
        shareQuoteService.getFclCharge(sellRates, charge, vm.searchUser.user_base_currency);
      }

      vm.fnDisplayProfit();

      $timeout(function () {
        vm.footerObj.doneBtnDisable = false;
      }, 200);
    }

  

    // get selected card with sell rates
    function pushToquoteArray(currentCard) {

      if (Object.keys(vm.copyQuoteForm.$error).length) {
        document.getElementById("copy-quote-meta").scrollIntoView();
        return;
      }
      if(Object.keys(currentCard.data.sell_rates).length ==1 && !currentCard.data.sell_rates[Object.keys(currentCard.data.sell_rates)[0]].rate_obj.charges.length){
        util.showToast("Add a leg and its corresponding charges to continue");
         return;
       }
      util.callMixpanel("QC-Chargetab-Done-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
      vm.footerObj.doneBtnDisable = true;

      if (
        currentCard.meta.remarks == undefined ||
        currentCard.meta.remarks == ""
      ) {
        currentCard.meta.remarks = null;
      }
      if (
        currentCard.meta.inclusions == undefined ||
        currentCard.meta.inclusions == ""
      ) {
        currentCard.meta.inclusions = null;
      }

      var isDone = shareQuoteService.fnRateEditValidation(
        currentCard,
        vm.editBuyRate,
        vm.search_param
      );

      if (isDone === 0) {
        vm.footerObj.doneBtnDisable = false;
      } else if (isDone === 1) {
        var custom_leg = 9;
        var tempSellRates = {};
        var tempBuyRates = {};
        var load_stat = {};
        if (vm.search_param.mode == "SEA-FCL") {
          load_stat = {};
          vm.search_param.load_data.load_details_value.forEach(function (load) {
            load_stat[load.type] = 0;
          });
        }

        angular.forEach(currentCard.data.sell_rates, function (value, key) {
          if(key.toLowerCase().includes('lnew') || key !== vm.l3_leg){
            if(value.leg_code===vm.l3_leg){
              var templeg=value.rate_obj;
              value=currentCard.data.sell_rates[vm.l3_leg];
              value.leg_name = templeg.leg_name;
              value.rate_obj.leg_name = templeg.leg_name;
              value.rate_obj.charges=templeg.charges;
              value.rate_obj.leg_total_currency=templeg.leg_total_currency;
              value.rate_obj.leg_total_cost=templeg.leg_total_cost;
              value.rate_obj.leg_currency_cost=templeg.leg_currency_cost;
              value.rate_obj.leg_currency=templeg.leg_currency;
              value.rate_obj.manual=templeg.manual
            }  
          }
          if (vm.search_param.mode == "SEA-FCL") {
            value.rate_obj.load_stat = angular.copy(load_stat);
          }

          if (value.leg_code != null && value.leg_code != "") {
            tempSellRates[value.leg_code] = value;
            tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
            custom_leg =
              parseInt(value.leg_code.match(/(\d+)/)[0]) <= 8
                ? 9
                : parseInt(value.leg_code.match(/(\d+)/)[0]) + 1;
          } else if (value.leg_code == null || value.leg_code == "") {
            value.leg_code = "l" + custom_leg + vm.modeName;
            value.rate_obj.leg_code = value.leg_code;
            value.rate_obj.leg_name = value.leg_name;
            currentCard.data.buy_rates[key].leg_code = value.leg_code;
            currentCard.data.buy_rates[key].leg_name = value.leg_name;
            currentCard.data.buy_rates[key].rate_obj.leg_code = value.leg_code;
            currentCard.data.buy_rates[key].rate_obj.leg_name = value.leg_name;
            custom_leg++;

            tempSellRates[value.leg_code] = value;
            tempBuyRates[value.leg_code] = currentCard.data.buy_rates[key];
          }

          angular.forEach(
            value.rate_obj.charges,
            function (childValue, chargeKey) {
              if (
                vm.search_param.mode == "SEA-FCL" &&
                childValue.container_type
              ) {
                value.rate_obj.load_stat[childValue.container_type] = 1;
              }
              if (!childValue.charge_id) {
                childValue.charge_id =
                  "UD" +
                  Math.random().toString(36).substring(2, 7).toUpperCase();
                childValue.global_charge_id =
                  "UD" +
                  Math.random().toString(36).substring(2, 7).toUpperCase();

                // random id for buy and sell rate charges
                tempSellRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].charge_id = childValue.charge_id;
                tempBuyRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].charge_id = childValue.charge_id;

                tempSellRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].global_charge_id = childValue.global_charge_id;
                tempBuyRates[value.leg_code].rate_obj.charges[
                  chargeKey
                ].global_charge_id = childValue.global_charge_id;
              }
            }
          );
          if (vm.editBuyRate) {
            tempBuyRates[value.leg_code].rate_obj.load_stat = angular.copy(
              value.rate_obj.load_stat
            );
          } else {
            tempBuyRates[value.leg_code].rate_obj.load_stat = tempBuyRates[
              value.leg_code
            ].rate_obj.load_stat
              ? tempBuyRates[value.leg_code].rate_obj.load_stat
              : angular.copy(load_stat);
          }
        });

        angular.forEach(vm.ScheduleCard.data.buy_rates, function (value, key) {
          if (!value.rate_obj && !tempBuyRates[key]) {
            tempBuyRates[key] = angular.copy(
              vm.ScheduleCard.data.buy_rates[key]
            );
            tempSellRates[key] = angular.copy(
              vm.ScheduleCard.data.buy_rates[key]
            );
          }
        });

        currentCard.data.sell_rates = tempSellRates;
        currentCard.data.buy_rates = tempBuyRates;
        currentCard.meta.card_total_cost = resultService.calCardTotal(
          currentCard.data.sell_rates
        );
        currentCard.meta.is_selected = true;
        
        currentCard.meta.remarks = encodeValue(currentCard.meta.remarks);
        currentCard.meta.inclusions = encodeValue(currentCard.meta.inclusions);
        currentCard.meta.internal_remarks = encodeValue(currentCard.meta.internal_remarks);

        if (vm.addOrEditCard == "quotationEdit") {
          vm.shareQuoteService.copysellToBuy(
            currentCard,
            vm.search_param.mode,
            vm.l3_leg
          );

          var getCardData = $filter("filter")(
            vm.quote_CardData,
            { _id: vm.currentCard._id },
            true
          );
          var index = vm.quote_CardData.indexOf(getCardData[0]);

          currentCard.meta["status"] =
            currentCard.meta["status"] != "new" ? "modified" : "new";
          vm.quote_CardData[index] = angular.copy(currentCard);
        } else if (
          vm.addOrEditCard == "addNewQuote" ||
          vm.addOrEditCard == "schedule"
        ) {
          currentCard.meta["status"] = "new";
          vm.quoteNewCard = angular.copy(currentCard);
          vm.sell_rates_display = true;
        } else if (vm.addOrEditCard == "rates" && vm.msrOrNetwork) {
          currentCard.data.buy_rates[vm.l3_leg].rate_obj.manual = 1;
          currentCard.data.sell_rates[vm.l3_leg].rate_obj.manual = 1;
          currentCard.meta["status"] = "new";
          vm.addInQuote(currentCard, "searchCard");
        }

        if (vm.isDuplicateQuote && vm.copyquoted) {
          vm.updateForDuplicate(currentCard);
        }

        $mdDialog.hide();
        vm.footerObj.doneBtnDisable = false;
        if (vm.addOrEditCard === "newCopyQuote") {
          currentCard.meta["status"] = "new";
          currentCard._id =
            "COPY" + Math.random().toString(36).substring(2, 7).toUpperCase();
          vm.quoteNewCard = currentCard;
          vm.addInQuote(currentCard, "searchCard");
        } else {
          vm.ifInitQuoteModify();
        }
      }
    }

    // save changes in duplicate cards
    function updateForDuplicate(currentCard) {
      var item = vm.selectedDuplicateCard.find(function (element) {
        return element._id == currentCard._id;
      });
      var index = vm.selectedDuplicateCard.indexOf(item);
      vm.selectedDuplicateCard[index] = angular.copy(currentCard);
    }


    //if leg is  selected from suggestion
    function changeSelectedLeg(selectedLeg, sellRate, sellKey) {
      var leg_code =
        vm.search_param.mode == "SEA-FCL"
          ? "_fcl"
          : vm.search_param.mode == "AIR"
          ? "_air"
          : "_lcl";
      if (selectedLeg != null) {
        var isLegPresent = Object.keys(vm.currentCard.data.sell_rates).some(
          function (key) {
            if (
              vm.currentCard.data.sell_rates[key].leg_code ==
              selectedLeg.leg_id + leg_code
            ) {
              return true;
            }
            return false;
          }
        );

        if (
          isLegPresent &&
          (sellRate.leg_code == null || sellRate.leg_code == "")
        ) {
          util.showToast('Leg already exist! Please Select another leg');
          sellRate.leg_name = "";
          sellRate.leg_code = "";
          sellRate.rate_obj.leg_name = "";
          sellRate.rate_obj.leg_code = "";
          sellRate.rate_obj.global_leg_id = "";
        } else {
          sellRate.leg_name = selectedLeg.leg_name;
          sellRate.leg_code = selectedLeg.leg_id + leg_code;
          sellRate.rate_obj.leg_name = selectedLeg.leg_name;
          sellRate.rate_obj.leg_code = selectedLeg.leg_id + leg_code;
          sellRate.rate_obj.global_leg_id = selectedLeg.leg_id;
        }
      } else {
        sellRate.leg_code = "";
        sellRate.rate_obj.leg_code = "";
      }
      vm.currentCard.data.buy_rates[sellKey].leg_name = angular.copy(
        sellRate.leg_name
      );
      vm.currentCard.data.buy_rates[sellKey].leg_code = angular.copy(
        sellRate.leg_code
      );
      vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_name = angular.copy(
        sellRate.rate_obj.leg_name
      );
      vm.currentCard.data.buy_rates[sellKey].rate_obj.leg_code = angular.copy(
        sellRate.rate_obj.leg_code
      );
      vm.currentCard.data.buy_rates[sellKey].rate_obj.global_leg_id =
        angular.copy(sellRate.rate_obj.global_leg_id);
    }

    // get leg name list
    function getMatches(searchText) {
      var obj = {
        mode: vm.search_param.mode,
        search: searchText,
      };

      return SearchService.getLegName(obj).then(
        function (response) {
          vm.legSuggestionList = response.data.data;
          return vm.legSuggestionList;
        },
        function (error) {
          $log.log(error);
        }
      );
    }

    function confirmDeleteLeg(sellKey, sellRate) {
      vm.chargeDelete = false;
      vm.legDelete = true;

      vm.deleteChargeBtn = false;
      vm.all_pickup_basis_delete = false;
      vm.all_delivery_basis_delete = false;
      vm.is_delete_l3_leg = false;
      vm.airBasisLegCharge = {};
      vm.airBasisCharges = false;

      vm.legKeyName = sellKey;

      vm.deleteLegObj = sellRate;

      if (sellRate.leg_name == null || sellRate.leg_name == "") {
        vm.fnDeleteLeg();
      } else {
        if (sellKey == vm.l3_leg) {
          vm.is_delete_l3_leg = true;
          util.showToast("You can not delete this leg.");
          return true;
        }
        vm.currentPage = "quote";
        $mdToast.show({
          hideDelay: false,
          position: "top right",
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
          templateUrl:
            "app/main/result/Dialogs/delete-charge/delete-charge.html",
        });
      }
    }

    function fnDeleteLeg() {
      vm.deleteChargeBtn = true;

      if (vm.is_delete_l3_leg) {
        $mdToast.hide();
        $mdDialog.hide();
        return;
      }

      delete vm.currentCard.data.sell_rates[vm.legKeyName];
      delete vm.currentCard.data.buy_rates[vm.legKeyName];

      vm.fnDisplayProfit();

      $mdToast.hide();
    }

    //autocomplete charge text change
    function changeTextCharge(charge, index, leg_code) {
      if (vm.search_param.mode === "SEA-FCL") {
        charge.charge_id = "";
        charge.global_charge_id = "";
      } else {
     
        charge.charge_id = "";
        charge.global_charge_id = "";
      }
      charge.charge_category = null;
      charge.charge_code =
        charge.charge_name.toLowerCase().replace(/ /g, "_") +
        "_" +
        vm.shareQuoteService.fnGuuid();
      vm.currentCard.data.buy_rates[leg_code].rate_obj.charges[
        index
      ].charge_name = angular.copy(charge.charge_name);
    }

    //charge autocomplete object
    function changeSelectedCharge(
      selectedName,
      charge,
      legValue,
      index,
      legKey
    ) {
      if (selectedName && !!selectedName.source) {
        charge["source"] = selectedName.source;
        charge["source_data"] = selectedName.source_data;
      }

      if (vm.search_param.mode === "SEA-FCL") {
        if (selectedName != null) {
          charge.charge_name = selectedName.charge_name;
          charge.charge_id = selectedName.charge_id;
          charge.global_charge_id = selectedName.global_charge_id;
          charge.container_type =
            legValue.leg_code != "ins_fcl"
              ? selectedName.load_code
                ? selectedName.load_code
                : charge.container_type
              : null;
          charge.charge_basis = selectedName.charge_basis;
          charge.total_units = 0;
          charge.per_unit_rate = selectedName.per_unit_rate
            ? selectedName.per_unit_rate
            : 0;
          charge.charge_currency = selectedName.charge_currency
            ? selectedName.charge_currency
            : legValue.rate_obj.leg_currency;
          charge.charge_category = selectedName.charge_category;
          charge.charge_code = selectedName.charge_code;
        } else {
          charge.charge_id = "";
          charge.global_charge_id = "";
        }
      } else {
        if (selectedName.charge_category) {
          charge.charge_category = selectedName.charge_category;
        }
        shareQuoteService.changeSelectedCharge(
          selectedName,
          charge,
          legValue,
          index
        );
      }

      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_name = angular.copy(charge.charge_name);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index].charge_id =
        angular.copy(charge.charge_id);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].global_charge_id = angular.copy(charge.global_charge_id);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].container_type = angular.copy(charge.container_type);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_basis = angular.copy(charge.charge_basis);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].total_units = angular.copy(charge.total_units);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_category = angular.copy(charge.charge_category);
      vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
        index
      ].charge_code = angular.copy(charge.charge_code);

      if (vm.editBuyRate) {
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
          index
        ].per_unit_rate = angular.copy(charge.per_unit_rate);
        vm.currentCard.data.buy_rates[legKey].rate_obj.charges[
          index
        ].charge_currency = angular.copy(charge.charge_currency);
      }

      if (vm.search_param.mode === "SEA-FCL") {
        vm.fnChangeBasis(
          charge,
          legValue,
          index,
          vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index],
          vm.currentCard.data.buy_rates[legKey]
        );
      } else {
        vm.conversionOnPriceChange(charge, legValue);
        if (vm.editBuyRate) {
          vm.conversionOnPriceChange(
            vm.currentCard.data.buy_rates[legKey].rate_obj.charges[index],
            vm.currentCard.data.buy_rates[legKey].rate_obj
          );
        }
      }
    }

    //get charge name suggestion list
    function getChargeList(searchText, leg_code, chargeObj) {
      return shareQuoteService.getChargeList(
        searchText,
        leg_code,
        chargeObj,
        vm.search_param
      );
    }

    function fnGetContainerQty(
      leg_data,
      charge_data,
      action,
      charge_index,
      buyCharge,
      buyLeg,
      param
    ) {
      if (charge_data.charge_basis != "" || charge_data.charge_basis != null) {
        if (param != "quantity") {
          var payload = {
            charge: charge_data,
            load_meta: vm.search_param.load_data.load_meta,
            airFreightValue:
              vm.currentCard.meta["AirFreight"] != null
                ? vm.currentCard.meta["AirFreight"].leg_currency_cost
                : null,
            pickupValue:
              vm.currentCard.meta["pickupCharge"] != null
                ? vm.currentCard.meta["pickupCharge"].leg_currency_cost
                : null,
            deliveryValue:
              vm.currentCard.meta["deliveryCharge"] != null
                ? vm.currentCard.meta["deliveryCharge"].leg_currency_cost
                : null,
            global_leg_id: leg_data.global_leg_id,
            ltl_load_details: vm.currentCard.meta["ltl_load_details"],
            mode: vm.search_param.mode,
            dimChargeableValue:
              leg_data.dim_data &&
              leg_data.dim_data.chargeable_weight_in_kg !== 0
                ? leg_data.dim_data.chargeable_weight_in_kg
                : null,
          };

          shareQuoteService.fnGetContainerQty(payload);
        }

        if (charge_data.total_units == null) {
          charge_data.charge_cost = 0;
          charge_data.leg_currency_cost = 0;
        } else if (
          charge_data.total_units != null &&
          charge_data.per_unit_rate !== null &&
          charge_data.per_unit_rate !== 0
        ) {
          vm.conversionOnPriceChange(charge_data, leg_data);
        }

        buyCharge.charge_basis = angular.copy(charge_data.charge_basis);
        buyCharge.total_units = angular.copy(charge_data.total_units);
        buyCharge.is_qty_editable = angular.copy(charge_data.is_qty_editable);

        if (
          vm.editBuyRate &&
          buyCharge.total_units != null &&
          buyCharge.per_unit_rate !== null &&
          buyCharge.per_unit_rate !== 0
        ) {
          vm.conversionOnPriceChange(buyCharge, buyLeg);
        }
      }
    }

    //Get charge cost
    function getChargeCost(leg_data, charge_data) {
      shareQuoteService.getChargeCost(leg_data, charge_data, vm.searchUser.user_base_currency);

      // if (charge_data.global_charge_id && charge_data.total_units != null) {
      //   var checkCharge = false;
      //   if (
      //     basisCalculation.isParent(charge_data)
      //   ) {
      //     vm.currentCard.meta["AirFreight"] = charge_data;
      //     checkCharge = true;
      //   } 
        // else if (
        //   charge_data.global_charge_id.indexOf(
        //     shareQuoteService.pickupChargeId
        //   ) >= 0
        // ) {
        //   vm.currentCard.meta["pickupCharge"] = charge_data;
        //   checkCharge = true;
        // } else if (
        //   charge_data.global_charge_id.indexOf(
        //     shareQuoteService.deliveryChargeId
        //   ) >= 0
        // ) {
        //   vm.currentCard.meta["deliveryCharge"] = charge_data;
        //   checkCharge = true;
        // } else if (
        //   charge_data.global_charge_id.indexOf(
        //     shareQuoteService.freightChargeId
        //   ) >= 0
        // ) {
        //   vm.currentCard.meta["freightCharge"] = charge_data;
        //   checkCharge = true;
        // }

        // if (checkCharge) {
        //   vm.checkPercentageBasis(leg_data, charge_data);
        // }
      // }
    }

    // charge calculation if charge basis '% on air'
    

    // function showDeleteBasisCharge(action, chargeName) {
    //   if (action == "quote") {
    //     angular.forEach(vm.currentCard.data.sell_rates, function (value, key) {
    //       vm.airBasisLegCharge[key] = { leg_name: value.leg_name, charges: [] };
    //       vm.pickupBasisLegCharge[key] = {
    //         leg_name: value.leg_name,
    //         charges: [],
    //       };
    //       vm.deliveryBasisLegCharge[key] = {
    //         leg_name: value.leg_name,
    //         charges: [],
    //       };

    //       angular.forEach(value.rate_obj.charges, function (childValue) {
    //         if (
    //           childValue.charge_basis == shareQuoteService.airBasisName &&
    //           chargeName == "air_charge"
    //         ) {
    //           vm.airBasisLegCharge[key].charges.push(childValue);
    //         } else if (
    //           childValue.charge_basis == shareQuoteService.pickupBasisName &&
    //           chargeName == "pickup_charge"
    //         ) {
    //           vm.pickupBasisLegCharge[key].charges.push(childValue);
    //         } else if (
    //           childValue.charge_basis == shareQuoteService.deliveryBasisName &&
    //           chargeName == "delivery_charge"
    //         ) {
    //           vm.deliveryBasisLegCharge[key].charges.push(childValue);
    //         }
    //       });

    //       if (!vm.airBasisLegCharge[key].charges.length) {
    //         delete vm.airBasisLegCharge[key];
    //       }
    //       if (!vm.pickupBasisLegCharge[key].charges.length) {
    //         delete vm.pickupBasisLegCharge[key];
    //       }
    //       if (!vm.deliveryBasisLegCharge[key].charges.length) {
    //         delete vm.deliveryBasisLegCharge[key];
    //       }
    //     });
    //   }

    //   if (
    //     action == "quote" &&
    //     Object.keys(vm.airBasisLegCharge).length !== 0 &&
    //     vm.airBasisLegCharge["l3_air"] != undefined &&
    //     (vm.currentCard.data.sell_rates["l3_air"].rate_obj.charges.length ==
    //       vm.airBasisLegCharge["l3_air"].charges.length + 1 ||
    //       vm.currentCard.data.sell_rates["l3_air"].rate_obj.charges.length ==
    //         vm.airBasisLegCharge["l3_air"].charges.length)
    //   ) {
    //     vm.is_delete_l3_leg = true;
    //   }

    //   vm.airBasisCharges =
    //     Object.keys(vm.airBasisLegCharge).length === 0 || vm.is_delete_l3_leg
    //       ? false
    //       : true;
    //   vm.all_pickup_basis_delete =
    //     Object.keys(vm.pickupBasisLegCharge).length === 0 ? false : true;
    //   vm.all_delivery_basis_delete =
    //     Object.keys(vm.deliveryBasisLegCharge).length === 0 ? false : true;
    // }

    function fnChangeBasis(
      chargeObj,
      sellRate,
      charge_index,
      buyCharge,
      buyLeg,
      param
    ) {
      if (!chargeObj.charge_basis) {
        chargeObj.total_units = 0;
        chargeObj.charge_cost = 0;
        vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj);
        if (vm.editBuyRate) {
          vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj);
        }
        return true;
      }
      if (vm.search_param.mode === "SEA-FCL" && chargeObj.charge_name) {
        resultService.checkExistingCharge(chargeObj, charge_index, sellRate.rate_obj.charges); //it's checking duplicate charge present or not.
      }

      if (param != "quantity") {
        shareQuoteService.fnGetFclTotalUnits(
          chargeObj,
          vm.search_param.load_data.load_details_value
        );
      }

      if (chargeObj.total_units == 0) {
        chargeObj.charge_cost = 0;
        chargeObj.leg_currency_cost = 0;
      } else {
        vm.conversionOnPriceChange(chargeObj, sellRate.rate_obj);
      }

      buyCharge.charge_basis = angular.copy(chargeObj.charge_basis);
      buyCharge.total_units = angular.copy(chargeObj.total_units);
      buyCharge.container_type = angular.copy(chargeObj.container_type);
      buyCharge.is_qty_editable = angular.copy(chargeObj.is_qty_editable);

      if (
        vm.editBuyRate &&
        buyCharge.total_units &&
        !isNaN(buyCharge.per_unit_rate)
      ) {
        vm.conversionOnPriceChange(buyCharge, buyLeg.rate_obj);
      }
    }

    function confirmDeleteCharge(sellKey, sellRate, index, action) {
      vm.chargeDelete = true;
      vm.legDelete = false;
      vm.deleteChargeBtn = false;

      vm.is_delete_l3_leg = false;
      vm.airBasisLegCharge = {};
      vm.pickupBasisLegCharge = {};
      vm.deliveryBasisLegCharge = {};
      vm.airBasisCharges = false;
      vm.all_pickup_basis_delete = false;
      vm.all_delivery_basis_delete = false;

      vm.legKeyName = sellKey;
      vm.deleteChargeLeg = sellRate;
      vm.deleteCharge_buyLeg = vm.currentCard.data.buy_rates[sellKey].rate_obj;
      vm.chargeIndex = index;

      vm.deleteChargeLineObj = vm.deleteChargeLeg.charges[index];
      vm.isQuoteOrCard = action;

      // if (
      //   vm.deleteChargeLeg.charges[index].global_charge_id != null &&
      //   vm.deleteChargeLeg.charges[index].global_charge_id != ""
      // ) {
      //   var ifAirCharge =
      //     vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.airChargeId
      //     ) >= 0; // air freight charge
      //   var ifPickupCharge =
      //     vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.pickupChargeId
      //     ) >= 0; // pickup charge
      //   var ifDeliveryCharge =
      //     vm.deleteChargeLeg.charges[index].global_charge_id.indexOf(
      //       shareQuoteService.deliveryChargeId
      //     ) >= 0; // delivery charge
      //   if (ifAirCharge || ifPickupCharge || ifDeliveryCharge) {
      //     var chargeName = ifAirCharge
      //       ? "air_charge"
      //       : ifPickupCharge
      //       ? "pickup_charge"
      //       : "delivery_charge";
      //     vm.showDeleteBasisCharge(action, chargeName);
      //     if (vm.is_delete_l3_leg) {
      //       util.showToast("You can not delete this charge.");
      //       return true;
      //     }
      //   }
      // }

      vm.currentPage = "quote";
      if (
        vm.deleteChargeLeg.charges[index].charge_name == null ||
        vm.deleteChargeLeg.charges[index].charge_name == ""
      ) {
        if (
          action == "quote" &&
          sellKey == vm.l3_leg &&
          vm.deleteChargeLeg.charges.length == 1
        ) {
          vm.is_delete_l3_leg = true;
          util.showToast("You can not delete this charge.");
          return true;
          // $mdToast.show({
          //   hideDelay: false,
          //   position: 'top right',
          //   controllerAs: 'ctrl',
          //   controller: function () { this.parent = vm },
          //   templateUrl: 'app/main/result/Dialogs/delete-charge/delete-charge.html'
          // });
          // return;
        }
        vm.fnDeleteNewCharge();
      } else {
        if (
          action == "quote" &&
          sellKey == vm.l3_leg &&
          vm.deleteChargeLeg.charges.length == 1
        ) {
          vm.is_delete_l3_leg = true;
          util.showToast("You can not delete this charge.");
          return true;
        }

        $mdToast.show({
          hideDelay: false,
          position: "top right",
          controllerAs: "ctrl",
          controller: function () {
            this.parent = vm;
          },
          templateUrl:
            "app/main/result/Dialogs/delete-charge/delete-charge.html",
        });
      }
    }

    function fnDeleteNewCharge() {
      vm.deleteChargeBtn = true;
      var sellObj = vm.deleteChargeLeg;
      var buyObj = vm.deleteCharge_buyLeg;
      var index = vm.chargeIndex;

      if (vm.is_delete_l3_leg) {
        $mdToast.hide();
        $mdDialog.hide();
        return;
      }

      sellObj.leg_currency_cost -= sellObj.charges[index].leg_currency_cost;

      
      sellObj.leg_total_cost -= sellObj.charges[index].customer_currency_cost;


      sellObj.charges.splice(index, 1);

      buyObj.leg_currency_cost -= buyObj.charges[index].leg_currency_cost;

      buyObj.leg_total_cost -= buyObj.charges[index].customer_currency_cost;

      buyObj.charges.splice(index, 1);

      if (vm.isQuoteOrCard == "quote" && !sellObj.charges.length) {
        delete vm.currentCard.data.sell_rates[vm.legKeyName];
        delete vm.currentCard.data.buy_rates[vm.legKeyName];
      }


      if (vm.isQuoteOrCard == "quote") {
        vm.fnDisplayProfit();
      }

      $mdToast.hide();
    }


    function addInQuote(card, action) {
      card.meta["isScheduleCall"] = true;
      var tempCard = angular.copy(card);
      if (action == "newCard") {
        vm.shareQuoteService.copysellToBuy(
          tempCard,
          vm.search_param.mode,
          vm.l3_leg
        );
        vm.quoteNewCard = angular.copy(vm.quoteNewCardInit);
      }

      // if(!vm.isManual){
      // vm.getAdditionalLeg(tempCard, action);
      // }

      // adding additional leg
      if (vm.isVasApplied) {
        var rate_card = [tempCard];
        resultService.applyVASLegToCard(
          rate_card,
          vm.vasDetails.legList,
          "quote"
        );
      }
      if (!tempCard.meta["card_total_cost"]) {
        tempCard.meta["card_total_cost"] = resultService.calCardTotal(
          tempCard.data.sell_rates
        );
      }
      
      pushNewCards(tempCard);

      var message=vm.pageTitle == 'create-quote' ? "create quote" : "copy quote."
      util.showToast("Rate card added in "+message);
    }

    function getAdditionalLeg(currentCard, action) {
      vm.modifyBtn = true;
      resultService.fnAutoFetchBinding(vm.search_param, currentCard, vm.quote_result.result_data._id, "quote", vm.l3_leg).then(
          function (response) {
            // add remarks & inclusion
            response.meta["remarks"] = response.meta["remarks"] ? response.meta["remarks"] : "";
            response.meta["inclusions"] = response.meta["inclusions"] ? response.meta["inclusions"] : "";

            angular.forEach(response.data.buy_rates, function (leg_value, leg_key) {
                if (leg_value.rate_obj) {
                  response.meta["remarks"] += leg_value.rate_obj.remarks ? leg_value.rate_obj.remarks : " ";
                  response.meta["inclusions"] += leg_value.rate_obj.inclusions ? leg_value.rate_obj.inclusions : " ";
                }
              });
            vm.modifyBtn = false;
          },
          function (error) {
            vm.modifyBtn = false;
          });
    }

    function deleteCopyQuote(item) {
      vm.removeCardFromQuote(item.ev, item._id, item.index);
    }

    function openDeleteCard(ev, card_id, index, quoteType) {
      vm.index = index;
      vm.card_id = card_id;
      util.callMixpanel("QC-DeleteQuotes-Click", {
        Mode: vm.search_param.mode,
        CardIndex: index + 1,
      });
      if (quoteType == "copyQuote") {
        vm.deleteActionItem="card"
        $mdDialog.show({
          template:
            '<md-dialog id="delete-popup" class="popup-xs"><delete-popup card-id="$ctrl.card_id" card-index="$ctrl.index" deletion-source="$ctrl.deleteActionItem" callback="ctrl.parent.deleteCopyQuote(data)"></delete-popup></md-dialog>',
          clickOutsideToClose: true,
          parent: $rootElement,
          scope: $scope,
          controllerAs: "ctrl",
          preserveScope: true,
          controller: function () {
            this.parent = vm;
          },
        });
      } else {
        document
          .getElementById(card_id + "_" + index + "_askDeletecard")
          .classList.remove("hide");
        document
          .getElementById(card_id + "_" + index + "_deletecard")
          .classList.add("hide");
      }

      // document.getElementById(card_id + '_card').classList.add("hide");
    }

    function removeCardFromQuote(ev, card_id, index) {
      // document.getElementById(card_id + '_card').classList.add("hide");

      var getCardData = $filter("filter")(
        vm.quote_CardData,
        { _id: card_id },
        true
      );

      if (getCardData[0].meta["status"] == "modified") {
        getCardData[0].meta["status"] = "editRemove";
      } else if (getCardData[0].meta["status"] == "new") {
        getCardData[0].meta["status"] = "newRemove";
      } else {
        getCardData[0].meta["status"] = "remove";
      }
      vm.isQuoteModify = true;
      vm.ifInitQuoteModify();
      var deleteCount = 0;
      vm.quote_CardData.forEach(function (card) {
        if (
          card.meta["status"] == "remove" ||
          card.meta["status"] == "editRemove" ||
          card.meta["status"] == "newRemove"
        ) {
          deleteCount++;
        }
      });

      if (vm.quote_CardData.length <= 1) {
        util.showToast("Minimum one rate required for quote modification.");
        return;
      } else {
        vm.quote_CardData.splice(index, 1);
        if(vm.newResultCard && vm.newResultCard.length){
          {
            vm.newResultCard.splice(index, 1);
          }
        }
      }
    }

    function cancelDeleteCard(ev, card_id, index) {
      // document.getElementById(card_id + '_card').classList.remove("hide");
      var getCardData = $filter("filter")(
        vm.quote_CardData,
        { _id: card_id },
        true
      );

      if (getCardData[0].meta["status"] == "editRemove") {
        getCardData[0].meta["status"] = "modified";
        vm.isQuoteModify = true;
      } else if (getCardData[0].meta["status"] == "newRemove") {
        getCardData[0].meta["status"] = "new";
        vm.isQuoteModify = true;
      } else {
        delete getCardData[0].meta["status"];
      }
      vm.ifInitQuoteModify();
    }


    //Quote-management - Ankita
    function showRemoveIcon(load) {
      var isContainer = vm.tempSearch_param.load_data.load_details_value.some(
        function (el) {
          return el.type === load.type;
        }
      );

      if (isContainer) {
        return false;
      } else {
        return true;
      }
    }


    function validateContainerData() {
      var breakLoop = false;
      vm.editLoadType.some(function (i) {
        if (i.type == null || !i.type) {
          util.showToast(" Please select load type !");
          breakLoop = true;
          return true;
        }

        if (i.count <= 0) {
          util.showToast(" Please add load quantity !");
          breakLoop = true;
          return true;
        }
      });

      if (!vm.load_bl_qty && vm.editQuoteMeta.mode === "SEA-FCL") {
        util.showToast(" Please enter B/L quantity !");
        breakLoop = true;
      } else if (!vm.load_sbl_qty && vm.editQuoteMeta.mode === "SEA-FCL") {
        util.showToast(" Please enter SB/L quantity !");
        breakLoop = true;
      }

      if (breakLoop) {
        return true;
      }
    }

    function isActiveFunction(card) {
      if (
        vm.isActive &&
        util.getStatusData(card.data[vm.buyOrSell][vm.l3_leg].rate_obj) !=
          "EXPIRED"
      ) {
        return true;
      } else if (
        vm.isActive &&
        !util.getStatusData(card.data[vm.buyOrSell][vm.l3_leg].rate_obj) !=
          "EXPIRED"
      ) {
        return false;
      }
    }
//
    function showLoadAlias(ev){
      var position = vm._mdPanel.newPanelPosition()
      .relativeTo(".load-alias")
      .addPanelPosition(vm._mdPanel.xPosition.CENTER, vm._mdPanel.yPosition.BELOW);

      var config ={
        attachTo: angular.element(document.body),
        templateUrl: "app/main/component/load-alias/load-alias.html",
        bindToController: true,
        controller: "LoadAliasController",
        controllerAs: "ctrl",
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          'type':"copyQuote",
        },
        
      };
      vm._mdPanel.open(config);

      
    };
    function fnSearchMetaEdit(form) {
      if (!vm.editQuoteMeta.cargo_ready_date) {
        vm.validationObj.cargoDateValiation = true;
      }
      if (!vm.expiryEdit) {
        vm.validationObj.expiryValitdation = true;
      }
      if (vm.editQuoteMeta.mode === "SEA-FCL") {
        if (!vm.load_sbl_qty) {
          vm.validationObj.shippingBillValidation = true;
        }
        if (!vm.load_bl_qty) {
          vm.validationObj.billValidation = true;
        }

        if (vm.editLoadType) {
          angular.forEach(vm.editLoadType, function (item) {
            if (!item.count) {
              vm.validationObj.qtyValidation = true;
            }
            if (!item.type) {
              vm.validationObj.typeValidation = true;
            }
            if (!item.weight_qty) {
              vm.validationObj.weightValidation = true;
            }
          });
        }

        if (
          vm.validationObj.shippingBillValidation ||
          vm.validationObj.billValidation ||
          vm.validationObj.qtyValidation ||
          vm.validationObj.typeValidation ||
          vm.validationObj.weightValidation ||
          vm.validationObj.cargoDateValiation ||
          vm.validationObj.expiryValitdation
        ) {
          return false;
        }
      } else {
        if (!vm.editQuoteMeta.load_data.load_meta.total_bl) {
          vm.validationObj.AWBValidation = true;
        }
        if (!vm.editQuoteMeta.load_data.load_meta.total_sbl) {
          vm.validationObj.shippinglclbillValidation = true;
        }
        if (vm.editQuoteMeta.load_data.load_type == "total_shipment") {
          if (!vm.editQuoteMeta.load_data.load_meta.total_qty) {
            vm.validationObj.unitValidation = true;
          }
          if (!vm.editQuoteMeta.load_data.load_meta.total_volume) {
            vm.validationObj.TSVolumeValidation = true;
          }
          if (!vm.editQuoteMeta.load_data.load_meta.total_weight) {
            vm.validationObj.TSWeightValidation = true;
          }
        }
        if (vm.editQuoteMeta.load_data.load_type == "units") {
          angular.forEach(
            vm.editQuoteMeta.load_data.load_details_value,
            function (load) {
              if (!load.qty) {
                vm.validationObj.unitValidation = true;
              }
              if (!load.length) {
                vm.validationObj.unitsLengthValidation = true;
              }
              if (!load.breadth) {
                vm.validationObj.unitsbreadthValidation = true;
              }
              if (!load.height) {
                vm.validationObj.unitsheightValidation = true;
              }
              if (!load.weight) {
                vm.validationObj.unitsweightValidation = true;
              }
            }
          );
        }
        if (
          vm.validationObj.unitValidation ||
          vm.validationObj.cargoDateValiation ||
          vm.validationObj.expiryValitdation ||
          vm.validationObj.TSVolumeValidation ||
          vm.validationObj.TSWeightValidation ||
          vm.validationObj.AWBValidation ||
          vm.validationObj.shippinglclbillValidation ||
          vm.validationObj.unitsheightValidation ||
          vm.validationObj.unitsbreadthValidation ||
          vm.validationObj.unitsLengthValidation ||
          vm.validationObj.unitsweightValidation
        ) {
          return false;
        }
      }

      var improperData = vm.validateContainerData();
      if (improperData) {
        return;
      }

      vm.editLoadType.forEach(function (i) {
        i.bl_qty = vm.load_bl_qty;
        i.sbl_qty = vm.load_sbl_qty;
      });
      vm.fetchLoad = false;

      var oldExpire = new Date(
        vm.temp_quoteData.result_data.expiry_date
      ).getTime();
      var newExpire = new Date(moment.utc(vm.expiryEdit).format()).getTime();

      var newcargo = $filter("date")(
        vm.editQuoteMeta.cargo_ready_date,
        "yyyy-MM-dd"
      );

      if (
        !angular.equals(vm.tempSearch_param.cargo_ready_date, newcargo) ||
        !angular.equals(oldExpire, newExpire) ||
        !angular.equals(
          vm.temp_quoteData.result_data.hazardous,
          vm.hazardousEdit
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.customs,
          vm.customsEdit
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.perishable,
          vm.perishableEdit
        ) ||
        !angular.equals(vm.quote_result.result_data.terms, vm.termsEdit) ||
        !angular.equals(vm.quote_result.result_data.incoterms, vm.incotermsEdit) ||
        !angular.equals(vm.quote_result.result_data.impo_expo, vm.impoExpoEdit)

      ) {
        vm.isQuoteModify = true;
      }

      vm.editQuoteMeta.cargo_ready_date = $filter("date")(
        vm.editQuoteMeta.cargo_ready_date,
        "yyyy-MM-dd"
      );
      vm.quote_result.result_data.expiry_date = angular.copy(
        moment.utc(vm.expiryEdit).format()
      );
      vm.quote_result.result_data.hazardous = angular.copy(vm.hazardousEdit);
      vm.quote_result.result_data.customs = angular.copy(vm.customsEdit);
      vm.quote_result.result_data.perishable = angular.copy(vm.perishableEdit);
      vm.quote_result.result_data.incoterms = angular.copy(vm.incotermsEdit);
      vm.quote_result.result_data.impo_expo = angular.copy(vm.impoExpoEdit);

      vm.quote_result.result_data.terms = angular.copy(vm.termsEdit);

      if (
        vm.editQuoteMeta.mode === "SEA-FCL" &&
        !angular.equals(vm.InitEditLoadType, vm.editLoadType)
      ) {
        vm.fnFclLoadChanged();
      } else if (
        vm.editQuoteMeta.mode !== "SEA-FCL" &&
        !angular.equals(vm.editQuoteMeta.load_data, vm.search_param.load_data)
      ) {
        vm.fnAirLclLoadChanged();
      } else {
        if (
          !angular.equals(
            vm.editQuoteMeta.origin_charges,
            vm.search_param.origin_charges
          ) ||
          !angular.equals(
            vm.editQuoteMeta.origin_customs,
            vm.search_param.origin_customs
          ) ||
          !angular.equals(
            vm.editQuoteMeta.destination_charges,
            vm.search_param.destination_charges
          ) ||
          !angular.equals(
            vm.editQuoteMeta.destination_customs,
            vm.search_param.destination_customs
          ) ||
          !angular.equals(
            vm.editQuoteMeta.shipment_insurance,
            vm.search_param.shipment_insurance
          ) ||
          !angular.equals(
            vm.editQuoteMeta.insurance_currency,
            vm.search_param.insurance_currency
          ) ||
          !angular.equals(
            vm.editQuoteMeta.insurance_leg_cost,
            vm.search_param.insurance_leg_cost
          )
        ) {
          if (vm.editQuoteMeta.shipment_insurance) {
            if (
              vm.editQuoteMeta.insurance_leg_cost == "" ||
              vm.editQuoteMeta.insurance_leg_cost == undefined
            ) {
              util.showToast("Please Enter value of good!");
              return;
            } else if (
              vm.editQuoteMeta.insurance_leg_cost.toString().length > 12
            ) {
              util.showToast("The value is too long");
              return;
            }
            if (
              vm.editQuoteMeta.insurance_currency == "" ||
              vm.editQuoteMeta.insurance_currency == undefined
            ) {
              util.showToast("Please select currency!");
              return;
            }
          }

          if (
            !angular.equals(
              vm.editQuoteMeta.insurance_currency,
              vm.search_param.insurance_currency
            ) ||
            !angular.equals(
              vm.editQuoteMeta.insurance_leg_cost,
              vm.search_param.insurance_leg_cost
            )
          ) {
            vm.fnFclLoadChanged();
          }
          vm.fetchLoad = true;
          vm.isQuoteModify = true;
        }

        vm.search_param = angular.copy(vm.editQuoteMeta);
        vm.search_param.hazardous_material = angular.copy(vm.hazardousEdit);
        // vm.search_param.inco_term = angular.copy(vm.incotermsEdit);

        if (vm.fetchLoad) {
          resultService.setLegFilter(vm.filterConfig, vm.search_param);

          // if(vm.newSearchFetch){
          //   vm.newSearchFetch = false;
          //   vm.fnSearchNewRates();
          // }
        }
      }
      $mdDialog.hide();
      vm.ifInitQuoteModify();
    }

    function fnFclLoadChanged() {
      var load_stat = {};
      vm.search_param.load_data.load_details_value.forEach(function (load) {
        load_stat[load.type] = 0;
      });

      vm.quote_CardData.forEach(function (card) {
        var getCurrencyRate = null;
        var vendor_0_obj = null;
        vm.currentCard = card;

        // calculate co2e 
        if(vm.currentCard.meta.co2eData){
          var co2Response = {
            'data' : [vm.currentCard.meta.co2eData]
          }
          
          resultService.fnCalculateCo2Total(co2Response, vm.search_param.load_data.load_details_value);
        }

        getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
          function (element) {
            if (element.vendor_id == 0) {
              vendor_0_obj = element;
            }
            return element.vendor_id == card.meta.vendor_id;
          }
        );
        if(!getCurrencyRate){
          if(card.meta.conversionRate)
          {
            getCurrencyRate = card.meta.conversionRate;
            vm.resultCardFilter.currency_conversion_rates.push(getCurrencyRate);
          }
        }

        if (!getCurrencyRate) {
          getCurrencyRate = vendor_0_obj;
        }

        shareQuoteService.currencyConverter = {}; //Reset currency converter setting

        vm.currency_rates = getCurrencyRate.curr_data;

        // Currency conversion setting code
        shareQuoteService.setCurrencyConvSetting(
          vm.searchUser.user_base_currency,
          getCurrencyRate.markup,
          getCurrencyRate.directCurrencyMapping,
          vm.currency_rates
        );

        // buy_rates/ sell_rates
        vm.quoteCardAfterSearchChange(
          card.data.buy_rates,
          vm.currency_rates,
          load_stat
        );
        vm.quoteCardAfterSearchChange(
          card.data.sell_rates,
          vm.currency_rates,
          load_stat
        );
        vm.percentageOnChargeBasis(card);
        vm.percentageOnTotalBasis(card.data.buy_rates,card);
        vm.percentageOnTotalBasis(card.data.sell_rates,card);

        card.meta.card_total_cost = resultService.calCardTotal(
          card.data[vm.buyOrSell]
        );

        if(!vm.util.isShipper && $rootScope.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL && card.data.buy_rates){
          card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
        }

        var getCardData = $filter("filter")(
          vm.quote_CardData,
          { _id: card._id },
          true
        );

        if (getCardData.length && !angular.equals(getCardData[0], card)) {
          if (card.meta["status"] == "remove") {
            card.meta["status"] = "editRemove";
          } else if (card.meta["status"] == "editRemove") {
            card.meta["status"] = "remove";
          } else {
            card.meta["status"] = "modified";
          }
        }
      });

      vm.isSearchMetaModify = true;
      vm.isQuoteModify = true;
    }

    function fnAirLclLoadChanged() {
      vm.quote_CardData.forEach(function (card) {
        var getCurrencyRate = null;
        var vendor_0_obj = null;
        vm.currentCard = card;
        getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
          function (element) {
            if (element.vendor_id == 0) {
              vendor_0_obj = element;
            }
            return element.vendor_id == card.meta.vendor_id;
          }
        );

        if (!getCurrencyRate) {
          getCurrencyRate = vendor_0_obj;
        }

        shareQuoteService.currencyConverter = {}; //Reset currency converter setting

        vm.currency_rates = getCurrencyRate.curr_data;

        // Currency conversion setting code
        shareQuoteService.setCurrencyConvSetting(
          vm.searchUser.user_base_currency,
          getCurrencyRate.markup,
          getCurrencyRate.directCurrencyMapping,
          vm.currency_rates
        );

        // buy_rates/ sell_rates
        vm.quoteCardAfterLclAirSearchChange(
          card.meta,
          card.data.buy_rates,
          vm.currency_rates,
          card
        );
        vm.quoteCardAfterLclAirSearchChange(
          card.meta,
          card.data.sell_rates,
          vm.currency_rates,
          card
        );
        vm.percentageOnTotalBasis(card.data.buy_rates,card);
        vm.percentageOnTotalBasis(card.data.sell_rates,card);
        vm.percentageOnChargeBasis(card);

        card.meta.card_total_cost = resultService.calCardTotal(
          card.data[vm.buyOrSell]
        );

        if(!vm.util.isShipper && $rootScope.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL && card.data.buy_rates){
          card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
        }

        var getCardData = $filter("filter")(
          vm.quote_CardData,
          { _id: card._id },
          true
        );

        if (getCardData.length && !angular.equals(getCardData[0], card)) {
          if (card.meta["status"] == "remove") {
            card.meta["status"] = "editRemove";
          } else if (card.meta["status"] == "editRemove") {
            card.meta["status"] = "remove";
          } else {
            card.meta["status"] = "modified";
          }
        }
      });

      vm.isSearchMetaModify = true;
      vm.isQuoteModify = true;
    }

    function quoteCardAfterSearchChange(legs, currency_rates, load_stat) {
      angular.forEach(legs, function (leg_value, leg_key) {
        if (leg_value.rate_obj) {
          leg_value.rate_obj.load_stat = angular.copy(load_stat);
          var temp_charges = [];

          leg_value.rate_obj.charges.forEach(function (
            charge_value,
            charge_key
          ) {
            var containerData = $filter("filter")(
              vm.search_param.load_data.load_details_value,
              { type: charge_value.container_type },
              true
            );

            if (
              containerData.length &&
              leg_value.leg_code != "ins" + vm.modeName
            ) {
              leg_value.rate_obj.load_stat[charge_value.container_type] = 1;
              temp_charges.push(charge_value);
            } else if (leg_value.leg_code == "ins" + vm.modeName) {
              charge_value.charge_cost =
                (0.05 / 100) * vm.search_param.insurance_leg_cost;
              charge_value.charge_currency = vm.search_param.insurance_currency;
              temp_charges.push(charge_value);
            } else if (
              charge_value.container_type == null ||
              charge_value.container_type == ""
            ) {
              temp_charges.push(charge_value);
            } else {
              // if charge is removed from array substract leg currency cost and total cost
              leg_value.rate_obj.leg_currency_cost -=
                charge_value.leg_currency_cost;
              leg_value.rate_obj.leg_total_cost -=
                charge_value.customer_currency_cost;
            }

            if (!charge_value.is_qty_editable) {
              shareQuoteService.fnGetFclTotalUnits(
                charge_value,
                vm.search_param.load_data.load_details_value
              );
            }

            vm.conversionOnPriceChange(
              charge_value,
              leg_value.rate_obj
            );
          });
          leg_value.rate_obj.charges = angular.copy(temp_charges);

          shareQuoteService.LegCurrUpdate(
            legs,
            leg_key,
            leg_value.rate_obj.leg_currency,
            vm.search_param.mode, 
            vm.searchUser.user_base_currency
          );
        }
      });
    }
    function percentageOnTotalBasis(legs,card){
    
      angular.forEach(legs, function (leg_value, leg_key) {
        leg_value.rate_obj.charges.forEach(function (
          charge_value,
          charge_key
        ){
            if(charge_value.charge_basis === constObj.FREIGHT_TOTAL_BASIS){
              if(card.data.sell_rates['l3'+vm.modeName]){
                var convertedQuantity = shareQuoteService.currencyConverter.convert(parseFloat(legs['l3'+vm.modeName].rate_obj.leg_currency_cost),card.data.sell_rates['l3'+vm.modeName].rate_obj.leg_currency,card.data.sell_rates[leg_key].rate_obj.leg_currency);
                charge_value.total_units   = convertedQuantity;
              }
            }
            vm.conversionOnPriceChange(
              charge_value,
              leg_value.rate_obj
            );
        });
      });
    }
    function percentageOnChargeBasis(card){
      angular.forEach(card.data.sell_rates, function (leg_value, leg_key) {
        leg_value.rate_obj.charges.forEach(function (
          charge_value,
          charge_key
        ){
          shareQuoteService.fnFillBasisMetaCharge(charge_value,card.data.buy_rates[leg_key].rate_obj.charges[charge_key],leg_key,vm.search_param.mode);
        })
      });
      angular.forEach(card.data.sell_rates, function (leg_value, leg_key) {
        leg_value.rate_obj.charges.forEach(function (
          charge_value,
          charge_key
        ){
          if(charge_value.charge_basis && charge_value.charge_basis.includes('%') && !charge_value.charge_basis.includes('total')){
            charge_value.total_units = basisCalculation.basisOnTotalObj[charge_value.charge_basis] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].sell.leg_currency_cost : null;
            card.data.buy_rates[leg_key].rate_obj.charges[charge_key].total_units = basisCalculation.basisOnTotalObj[charge_value.charge_basis] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'] && basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[charge_value.charge_basis].parent[charge_value.container_type ? charge_value.container_type : 'N/A'].buy.leg_currency_cost : null;
          }
          vm.conversionOnPriceChange(
            charge_value,
            leg_value.rate_obj
          );
          vm.conversionOnPriceChange(
            card.data.buy_rates[leg_key].rate_obj.charges[charge_key],
            card.data.buy_rates[leg_key].rate_obj
          );
        })
      });

    }
    function quoteCardAfterLclAirSearchChange(cardMeta, legs, currency_rates, currentCard) {
     

      angular.forEach(legs, function (leg_value, leg_key) {
        var temp_charges = [];
        if (leg_value.rate_obj) {
          leg_value.rate_obj.charges.forEach(function (
            charge_value,
            charge_key
          ) {
            if (leg_value.leg_code != "ins" + vm.modeName) {
              var payload = {
                charge: charge_value,
                load_meta: vm.search_param.load_data.load_meta,
                airFreightValue:
                  null,
                pickupValue:
                 null,
                deliveryValue:
                 null,
                global_leg_id: leg_value.rate_obj.global_leg_id,
                ltl_load_details: cardMeta["ltl_load_details"],
                mode: vm.search_param.mode,
                dimChargeableValue:
                  leg_value.rate_obj.dim_data &&
                  leg_value.rate_obj.dim_data.chargeable_weight_in_kg &&
                  leg_value.rate_obj.dim_data.chargeable_weight_in_kg !== 0
                    ? leg_value.rate_obj.dim_data.chargeable_weight_in_kg
                    : null,
              };

              if (!charge_value.is_qty_editable) {
                shareQuoteService.fnGetContainerQty(payload);
              }
            } else if (leg_value.leg_code == "ins" + vm.modeName) {
              charge_value.charge_cost =
                (0.05 / 100) * vm.search_param.insurance_leg_cost;
              charge_value.charge_currency = vm.search_param.insurance_currency;
              temp_charges.push(charge_value);
            }

            if (
              charge_value.per_unit_rate != null &&
              charge_value.total_units != null
            ) {
              var per_unit = parseFloat(charge_value.per_unit_rate) || 0;
              var total_units =
                charge_value.total_units == ""
                  ? 0
                  : parseFloat(charge_value.total_units);

              if (charge_value.charge_basis == shareQuoteService.airBasisName) {
                charge_value.charge_currency = leg_value.rate_obj.leg_currency;
                charge_value.charge_cost = (per_unit * total_units) / 100;
              } else {
                charge_value.charge_cost = per_unit * total_units;
              }
            }

            temp_charges.push(charge_value);
          });

          leg_value.rate_obj.charges = angular.copy(temp_charges);

          shareQuoteService.LegCurrUpdate(
            legs,
            leg_key,
            leg_value.rate_obj.leg_currency,
            vm.search_param.mode,
            vm.searchUser.user_base_currency
          );
        }
      });
    }

    function fnGetLoadList() {
      if (util.limitObj.length <= 0) {
        SearchService.getAllLoadList().then(
          function (response) {
            vm.container_type = angular.copy(response);
            util.limitObj = response;
            vm.fnFormLoadArr(vm.container_type);
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.container_type = angular.copy(util.limitObj);
        vm.fnFormLoadArr(vm.container_type);
      }
    }

    function fnFormLoadArr(load_list) {
      angular.forEach(load_list, function (value) {
        value.count = 0;
        value.type = value.load_code;
      });
    }

    function reduceContainerSize(container_type, load) {
      var isContainer = vm.search_param.load_data.load_details_value.some(
        function (el) {
          return el.type === load.type;
        }
      );

      if (isContainer && load.count == 1) {
        util.showToast("You do not have access to remove " + load.type + " !");
        return;
      }

      util.reduceContainerSize(container_type, load.type);
    }

    function increaseContainerSize(container_type, load) {
      util.increaseContainerSize(container_type, load.type);
    }

    //Add load - Air,Lcl
    function add_lcl_air_load(load_data) {
      SearchService.airLcl_add_load(load_data.load_details_value);
    }

    //remove load - Air,Lcl
    function rm_lcl_air_load(index, load_data) {
      SearchService.airLcl_remove_load(index, load_data.load_details_value);
    }



    function closeToast() {
      $mdToast.hide();
    }

    function fnGetColorByStatusName(status) {
      return util.fnGetColorBuStatusName(status);
    }

    function terms_condition_focus(className) {
      if (document.getElementById(className).value === "") {
        document.getElementById(className).value += "• ";
      }
    }

    function terms_condition_key_up(event, className) {
      util.getBulletPontOnInput(event, className);
    }

    function fnDefaultTermsAndConditions() {
      if (!vm.showTermsConditions) {
        vm.termsEdit = vm.stdTermsAndConditions;
      } else {
        // var defalutTerms = angular.copy(vm.temp_quoteData.result_data.terms);
        vm.termsEdit = angular.copy(vm.temp_quoteData.result_data.terms);
        // vm.termsEdit = shareQuoteService.fnProcessTermsString(defalutTerms);
      }
    }

    function getQuoteVersion(str) {
      var result = "A";
      if (str.split("-")[1] != undefined) {
        result = str.split("-")[1];
      }
      return result;
    }

    function nextVersionChar(c) {
      return String.fromCharCode(c.charCodeAt(0) + 1);
    }

    function getCardHeight(id) {
      var height = angular.element("#" + id)[0].offsetHeight + 5;
      var hoverCardHeight = {
        height: height,
      };
      return hoverCardHeight;
    }

    function getCardFlexValue(card_size) {
      if (card_size == 0) {
        var widget_back_height = angular.element(".new_card_back").height();
        vm.widget_back_height = {
          height: widget_back_height,
        };
      } else {
        vm.widget_back_height = {
          height: "unset",
        };
      }

      var windowWidth = angular.element(window).width();
      var flexValue;
      if (
        !vm.isShared &&
        util.navPermission.quotes[2] &&
        !vm.quote_result.result_data.is_booked &&
        !vm.quote_result.result_data.revised &&
        !vm.quotePreview &&
        !vm.isLost
      ) {
        if (windowWidth <= 1100) {
          flexValue = 60;
        }
        if (windowWidth <= 1330) {
          if (card_size > 2) {
            flexValue = 75;
          }
        }
        if (windowWidth <= 1750) {
          if (card_size > 3) {
            flexValue = 75;
          }
        }
        if (windowWidth > 1750) {
          if (card_size > 4) {
            flexValue = 75;
          }
        }
      }
      return flexValue;
    }


    function ifInitQuoteModify() {
      vm.isQuoteModify = false;
      var loadData = angular.copy(vm.search_param.load_data);
      var initLoadData = angular.copy(
        vm.temp_quoteData.result_meta.search_param.load_data
      );

      var withoutLoad = angular.copy(vm.search_param);
      delete withoutLoad["load_data"];
      var initWithoutLoad = angular.copy(
        vm.temp_quoteData.result_meta.search_param
      );
      delete initWithoutLoad["load_data"];

      if (!angular.equals(initLoadData, loadData)) {
        if (
          vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(
            parseFloat(
              $filter("number")(initLoadData.load_meta.volumetric_weight, 3)
            ),
            parseFloat(
              $filter("number")(loadData.load_meta.volumetric_weight, 3)
            )
          )
        ) {
          vm.isQuoteModify = true;
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(
            parseFloat(
              $filter("number")(initLoadData.load_meta.chargeable_weight, 3)
            ),
            parseFloat(
              $filter("number")(loadData.load_meta.chargeable_weight, 3)
            )
          )
        ) {
          vm.isQuoteModify = true;
          // console.log('search chargeable changed');
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(
            parseFloat(
              $filter("number")(initLoadData.load_meta.gross_weight, 3)
            ),
            parseFloat($filter("number")(loadData.load_meta.gross_weight, 3))
          )
        ) {
          vm.isQuoteModify = true;
          // console.log('search gross changed');
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode != "SEA-FCL" &&
          !angular.equals(
            initLoadData.load_meta.total_bl,
            loadData.load_meta.total_bl
          )
        ) {
          vm.isQuoteModify = true;
          // console.log('search changed');
        } else if (
          vm.temp_quoteData.result_meta.search_param.mode == "SEA-FCL"
        ) {
          vm.isQuoteModify = true;
          // console.log('search changed');
        }
      }

      if (!angular.equals(initWithoutLoad, withoutLoad)) {
        vm.isQuoteModify = true;
        // console.log('search changed');
      }

      if (
        !angular.equals(
          new Date(vm.temp_quoteData.result_data.expiry_date).getTime(),
          new Date(vm.quote_result.result_data.expiry_date).getTime()
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.hazardous,
          vm.quote_result.result_data.hazardous
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.customs,
          vm.quote_result.result_data.customs
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.perishable,
          vm.quote_result.result_data.perishable
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.terms,
          vm.quote_result.result_data.terms
        ) ||
        !angular.equals(
          vm.temp_quoteData.result_data.incoterms,
          vm.quote_result.result_data.incoterms
        )
      ) {
        vm.isQuoteModify = true;
        // console.log('extra param changed');
      }
      vm.fnCheckCardsDetails();
    }

    function fnCheckCardsDetails() {
      if (
        vm.quote_CardData.length != vm.temp_quoteData.result_data.cards.length
      ) {
        vm.isQuoteModify = true;
        // console.log('card added or remove');
      } else {
        vm.quote_CardData.forEach(function (card) {
          var getCard = $filter("filter")(
            vm.temp_quoteData.result_data.cards,
            { _id: card._id },
            true
          );
          if (getCard.length) {
            if (
              !angular.equals(
                getCard[0].meta.selected_schedule,
                card.meta.selected_schedule
              ) ||
              card.meta["status"] == "editRemove" ||
              card.meta["status"] == "remove" ||
              !angular.equals(getCard[0].meta.remarks, card.meta.remarks) ||
              !angular.equals(
                getCard[0].meta.inclusions,
                card.meta.inclusions
              ) ||
              (getCard[0].data.sell_rates &&
                (!angular.equals(
                  getCard[0].data.sell_rates[vm.l3_leg].rate_obj.service_type,
                  card.data.sell_rates[vm.l3_leg].rate_obj.service_type
                ) ||
                  !angular.equals(
                    $filter("date")(
                      new Date(
                        getCard[0].data.sell_rates[vm.l3_leg].rate_obj.expiry
                      ),
                      "yyyy-MM-dd"
                    ),
                    $filter("date")(
                      new Date(
                        moment
                          .utc(card.data.sell_rates[vm.l3_leg].rate_obj.expiry)
                          .format()
                      ),
                      "yyyy-MM-dd"
                    )
                  )))
            ) {
              vm.isQuoteModify = true;
              // console.log('card schedule changed/ card delete');
            }

            if (
              getCard[0].data.sell_rates &&
              Object.keys(card.data.sell_rates).length !=
                Object.keys(getCard[0].data.sell_rates).length
            ) {
              vm.isQuoteModify = true;
              // console.log('leg add or remove');
            } else {
              angular.forEach(
                card.data.sell_rates,
                function (rateValue, rateKey) {
                  var isLegPresent = false;
                  if (getCard[0].data.sell_rates) {
                    var isLegPresent = Object.keys(
                      getCard[0].data.sell_rates
                    ).some(function (key) {
                      if (rateKey == key) {
                        return true;
                      }
                      return false;
                    });
                  }

                  if (isLegPresent) {
                    if (rateValue.rate_obj) {
                      if (
                        !angular.equals(
                          rateValue.leg_name,
                          getCard[0].data.sell_rates[rateKey].leg_name
                        ) ||
                        !angular.equals(
                          rateValue.rate_obj.leg_currency,
                          getCard[0].data.sell_rates[rateKey].rate_obj
                            .leg_currency
                        )
                      ) {
                        vm.isQuoteModify = true;
                        // console.log('leg currency or name changed');
                      }

                      if (
                        rateValue.rate_obj.charges.length !=
                        getCard[0].data.sell_rates[rateKey].rate_obj.charges
                          .length
                      ) {
                        vm.isQuoteModify = true;
                        // console.log('chanrge add or remove');
                      } else {
                        rateValue.rate_obj.charges.forEach(function (
                          chargeValue
                        ) {
                          var getCharge = $filter("filter")(
                            getCard[0].data.sell_rates[rateKey].rate_obj
                              .charges,
                            { charge_id: chargeValue.charge_id },
                            true
                          );

                          var getBuyCharge = $filter("filter")(
                            getCard[0].data.buy_rates[rateKey].rate_obj.charges,
                            { charge_id: chargeValue.charge_id },
                            true
                          );
                          var initBuyCharge = $filter("filter")(
                            card.data.buy_rates[rateKey].rate_obj.charges,
                            { charge_id: chargeValue.charge_id },
                            true
                          );

                          if (getCharge.length || getBuyCharge.length) {
                            if (
                              !angular.equals(
                                chargeValue.charge_name,
                                getCharge[0].charge_name
                              ) ||
                              !angular.equals(
                                chargeValue.charge_currency,
                                getCharge[0].charge_currency
                              ) ||
                              !angular.equals(
                                chargeValue.per_unit_rate,
                                getCharge[0].per_unit_rate
                              ) ||
                              !angular.equals(
                                chargeValue.total_units,
                                getCharge[0].total_units
                              ) ||
                              !angular.equals(
                                chargeValue.minimum_charge_cost,
                                getCharge[0].minimum_charge_cost
                              )||
                              !angular.equals(
                                chargeValue.maximum_charge_cost,
                                getCharge[0].maximum_charge_cost
                              ) ||
                              !angular.equals(
                                chargeValue.charge_basis,
                                getCharge[0].charge_basis
                              ) ||
                              !angular.equals(
                                getBuyCharge[0].charge_currency,
                                initBuyCharge[0].charge_currency
                              ) ||
                              !angular.equals(
                                getBuyCharge[0].per_unit_rate,
                                initBuyCharge[0].per_unit_rate
                              ) ||
                              !angular.equals(
                                getBuyCharge[0].minimum_charge_cost,
                                initBuyCharge[0].minimum_charge_cost
                              ) ||
                              !angular.equals(
                                getBuyCharge[0].maximum_charge_cost,
                                initBuyCharge[0].maximum_charge_cost
                              )
                            ) {
                              vm.isQuoteModify = true;
                              // console.log('charge basis/ name/ currency/ unit changed');
                            }
                          } else {
                            vm.isQuoteModify = true;
                            // console.log('new charge added');
                          }
                        });
                      }
                    }
                  } else {
                    vm.isQuoteModify = true;
                    // console.log('card new leg added');
                  }
                }
              );
            }
          } else {
            vm.isQuoteModify = true;
            // console.log('card added changed');
          }
        });
      }
    }


    //callback function from card component
    function showQuoteProceedDiv(item) {
      if(item.hasOwnProperty('sourceRate')){
        vm.sourceRate=item.sourceRate;
      }
      if (item.action == "duplicate") {
        vm.selectedDuplicateQuote(item.currentCard);
      }
      if (item.action == "viewQuoteRates") {
        if (item.activeTab == "quotationEdit") {
          vm.fnAddOrEditCard(item.currentCard, "editCardCopyQuote", item.ev);
        } else if (item.activeTab == "newCopyQuote") {
          vm.fnAddOrEditCard(item.currentCard, "newCardCopyQuote", item.ev);
        } else {
          vm.viewDetailsModal(item.currentCard, item.ev, item.activeTab);
        }
      }
      if (item.action == "cancelDeleteCard") {
        vm.cancelDeleteCard(item.ev, item._id, item.index);
      }
      if (item.action == "removeCardFromQuote") {
        vm.removeCardFromQuote(item.ev, item.currentCard._id, item.index);
      }
      if (item.action == "removeCardFromQuote" && vm.isDuplicateQuote) {
        document
          .getElementById(
            item.currentCard._id + "_" + item.index + "_askDeletecard"
          )
          .classList.add("hide");
        document
          .getElementById(
            item.currentCard._id + "_" + item.index + "_deletecard"
          )
          .classList.remove("hide");
        vm.selectedDuplicateQuote(item.currentCard, "deleteCopyQuote");
      }

      if (item.action == "addRate") {
        resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,item.currentCard);
        item.currentCard.data.buy_rates[vm.l3_leg].rate_obj.manual = 1;
        item.currentCard.data.sell_rates[vm.l3_leg].rate_obj.manual = 1;

        // delete item.currentCard.meta.buy_leg_total;
        delete item.currentCard.meta.view;
        delete item.currentCard.meta["slabPersentage"];
        delete item.currentCard.meta["selectedLeg"];
        delete item.currentCard.meta["init_sort_total"];
        delete item.currentCard.data.buy_rates[vm.l3_leg]["rate_obj_1"];
        delete item.currentCard.data.buy_rates[vm.l3_leg]["rate_obj_2"];
        delete item.currentCard.data.sell_rates[vm.l3_leg]["rate_obj_1"];
        delete item.currentCard.data.sell_rates[vm.l3_leg]["rate_obj_2"];

        item.currentCard.meta["status"] = "new";
        vm.addInQuote(item.currentCard, "newCard");
        $mdDialog.hide();
      } else if (item.action == "editRate") {
        resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,item.currentCard);
        vm.shareQuoteService.copysellToBuy(
          item.currentCard,
          vm.search_param.mode,
          vm.l3_leg
        );

        var getCardData = $filter("filter")(
          vm.quote_CardData,
          { _id: item.currentCard._id },
          true
        );
        var index = vm.quote_CardData.indexOf(getCardData[0]);

        item.currentCard.meta["status"] =
          item.currentCard.meta["status"] != "new" ? "modified" : "new";
        vm.quote_CardData[index] = angular.copy(item.currentCard);
        $mdDialog.hide();
      } else if (item.action == "scheduleSelect") {
        if (item.currentCard.meta.type == "msr_rates") {
          var tempId = $filter("filter")(
            vm.newMsrCards.data.cards,
            { _id: item.currentCard._id },
            true
          );
          tempId[0].meta.selected_schedule =
            item.currentCard.meta.selected_schedule;
          tempId[0].meta.multi_schedule_list =
            item.currentCard.meta.multi_schedule_list || [];  
        } else if (item.currentCard.meta.type == "iata_rates") {
          var tempId = $filter("filter")(
            vm.newIataCards.data.cards,
            { _id: item.currentCard._id },
            true
          );
          tempId[0].meta.selected_schedule =
            item.currentCard.meta.selected_schedule;
          tempId[0].meta.multi_schedule_list =
            item.currentCard.meta.multi_schedule_list || [];
        } else {
          var tempId = $filter("filter")(
            vm.newNetworkCards.data.cards,
            { _id: item.currentCard._id },
            true
          );
          tempId[0].meta.selected_schedule =
            item.currentCard.meta.selected_schedule;
          tempId[0].meta.multi_schedule_list =
            item.currentCard.meta.multi_schedule_list || [];  
        }
      } else if (item.action == "removeFromQuote") {
        vm.removeFromQuote(item.currentCard);

        if (!vm.quoteArray.length) {
          vm.resultCardFilter.hideBookBtn = false;
        }
      } else if (item.action == "deleteCharge") {
        var index = vm.quoteArray.indexOf(item.currentCard._id);
        if (index > -1) {
          vm.quoteArray.splice(index, 1);
          item.currentCard.meta.is_selected = false;
          item.currentCard.data.sell_rates = null;
          vm.selectedCard.pop(item.currentCard);
        }
      } else if (item.action == "manualCardDelete") {
        vm.openDeleteCard(
          item,
          item.currentCard._id,
          item.index,
          item.quoteType
        );
      } else if (item.action == "manualCardEdit") {
        vm.openEditCardModal(item.currentCard);
      }
    }


    function fnCheckIsNaN(charge, param) {
      var result = "";
      if (param == "per_unit_rate") {
        if (angular.isString(charge.per_unit_rate)) {
          result = charge.per_unit_rate;
        } else {
          result = $filter("number")(charge.per_unit_rate, 2);
        }
      } else {
        if (!charge.min_flag && angular.isString(charge.charge_cost)) {
          result = charge.charge_cost;
        } else {
          result = $filter("number")(charge.leg_currency_cost, 2);
        }
      }
      return result;
    }

    function isString(data) {
      if (typeof data === "string") {
        return true;
      } else {
        return false;
      }
    }

    function fnCardStructure() {
      vm.cardChargeObj = {
        id: "0001",
        charge_id: null,
        charge_name: null,
        charge_description: null,
        charge_type: "FIXED",
        charge_basis: null,
        per_unit_rate: 0,
        total_units: 0,
        charge_cost: 0,
        charge_currency: vm.searchUser.user_base_currency,
        minimum_charge_cost: vm.search_param.mode === 'SEA-FCL' ? 'NA':'',
        maximum_charge_cost: vm.search_param.mode === 'SEA-FCL' ? 'NA':'',
        container_type: null,
        global_charge_id: "",
        customer_currency_cost: 0,
        leg_currency_cost: 0,
        tax_type: "GST",
        tax_percent: 0,
        manual: true,
        is_qty_editable: false,
        charge_category: null,
        charge_code: "",
      };

      vm.cardLegData = {
        leg_name: "",
        leg_code: "",
        vendor_id: vm.isShared ? "" : (vm.authTokenValue.vendor_id),
        rate_obj: {
          agent_id: "",
          _id: "",
          schedule: {
            url: null,
            data: [],
          },
          analytics: {
            graph: {
              url: null,
            },
          },
          is_special: false,
          charges: [],
          manual: 1,
          airline: {
            air_line_name: "",
            airline_code: "",
            airline_prefix: "",
          },
          airline_code: null,
          slab_currency: null,
          slab: null,
          rate_type: "msr_rate",
          leg_name: "",
          leg_code: "",
          vendor_id: vm.isShared ? "" : (vm.authTokenValue.vendor_id),
          sub_vendor_id: null,
          service_type: null,
          via_route: null,
          transit_time: null,
          contract_number: "",
          remarks: null,
          inclusions: null,
          expiry: null,
          other_charges: null,
          if_applicable_charges: null,
          load_stat: null,
          global_leg_id: "",
          leg_total_cost: 0,
          leg_total_currency: vm.searchUser.user_base_currency,
          leg_currency_cost: 0,
          leg_currency: vm.searchUser.user_base_currency,
          vendor: {
            vendor_name: vm.isShared ? "" : vm.authTokenValue.vendor_name,
          },
          sub_vendor: {
            sub_vendor_name: "",
            carrier_code: "",
            logo: null,
          },
          ltl_load_details: null,
          commodity_data: [],
          cargo_type_data: null,
        },
      };

      vm.is_nearbyOrigin_icd = 0;
      vm.is_nearbyDestination_icd = 0;
      if (vm.search_param.nearby_ports.length) {
        for (var i = 0; i < vm.search_param.nearby_ports.length; i++) {
          if (vm.search_param.nearby_ports[i].is_icd_port) {
            vm.is_nearbyOrigin_icd = 1;
            break;
          }
        }
      }

      if (vm.search_param.nearby_ports_destination.length) {
        for (
          var i = 0;
          i < vm.search_param.nearby_ports_destination.length;
          i++
        ) {
          if (vm.search_param.nearby_ports_destination[i].is_icd_port) {
            vm.is_nearbyDestination_icd = 1;
            break;
          }
        }
      }

      vm.quoteNewCardInit = {
        data: {
          sell_rates: {},
          buy_rates: {},
        },
        meta: {
          airline_code: null,
          card_total_cost: 0,
          delta_percent: null,
          haulage: "",
          destination_haulage: "",
          haulage_available: false,
          inclusions: null,
          is_selected: false,
          network_id: null,
          port_data: {
            pickup_location:
            vm.search_param.origin_location && vm.search_param.origin_location.place_type == "Door"
                ? vm.search_param.origin_location.location
                : null,
            origin_port_code: null,
            origin_portname: vm.search_param.origin_location ? vm.search_param.origin_location.portname : null,
            is_icd_port_origin:
            vm.search_param.origin_location ?   vm.search_param.origin_location.is_icd_port ||
              vm.is_nearbyOrigin_icd: null,

            delivery_location:
            vm.search_param.destination_location && vm.search_param.destination_location.place_type == "Door"
                ? vm.search_param.destination_location.location
                : null,
            destination_port_code: null,
            destination_portname: vm.search_param.destination_location ? vm.search_param.destination_location.portname : null,
            is_icd_port_destination: vm.search_param.destination_location ? 
              vm.search_param.destination_location.is_icd_port ||
              vm.is_nearbyDestination_icd : null,
          },
          remarks: null,
          selected_schedule: null,
          type: "msr_rates",
          vendor_id: vm.isShared ? "" : parseInt(vm.authTokenValue.vendor_id),
          via_pod: null,
          via_pol: null,
          ltl_load_details: null,
        },
        schedule: [],
        sub_vendor: "",
        airline: "",
        _id: "",
      };
    }

    function getVasDetails() {
      if (!vm.quote_result.result_data.hasOwnProperty("additional_charges")) {
        vm.quote_result.result_data.additional_charges = {
          selected: {},
          available: {},
        };
      }

      if (vm.search_param.origin_charges) {
        vm.curr_vas_leg_arr.push("l2");
      }
      if (vm.search_param.origin_customs) {
        vm.curr_vas_leg_arr.push("l2_cha");
      }
      if (vm.search_param.destination_charges) {
        vm.curr_vas_leg_arr.push("l2");
      }
      if (vm.search_param.destination_customs) {
        vm.curr_vas_leg_arr.push("l2_cha");
      }

      var getCurrencyRate = null;
      var vendor_0_obj = null;

      getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(
        function (element) {
          if (element.vendor_id == 0) {
            vendor_0_obj = element;
          }
          return (
            element.vendor_id ==
            (util.isFreightbro &&
            localStorageService.get("forwarder") &&
            localStorageService.get("forwarder").value ? localStorageService.get("forwarder").value.vendor_id : parseInt(vm.authTokenValue.vendor_id))
          );
        }
      );

      if (!getCurrencyRate) {
        getCurrencyRate = vendor_0_obj;
      }

      vm.vasDetails = {
        search_param: vm.search_param,
        legList: Object.keys(
          vm.quote_result.result_data.additional_charges.selected
        ).length
          ? vm.quote_result.result_data.additional_charges.selected
          : {},
        currency_rates: getCurrencyRate.curr_data,
        currency_conversion_rates: getCurrencyRate,
        value_added_charges: Object.keys(
          vm.quote_result.result_data.additional_charges.available
        ).length
          ? vm.quote_result.result_data.additional_charges.available
          : [],
        selected_legs: vm.curr_vas_leg_arr,
        module: "Quotes",
      };
    }

    

    function fnViewQuoteList(action) {
      $state.go("app.quotes");
    }

    function viewInquiryDetails(id) {
      if (!vm.isShared && !util.isShipper && id != "null") {
        util.isCallingApi = true;
        if(vm.isWebView){
          $state.go("app.inquiry.webViewInquiryDetails", { id: id });
        }
        else{
          $state.go("app.inquiry.inquiryDetails", { id: id });
        }
      }
    }

    // get expiry max date
    function getExpiryMaxDate(startDate) {
      vm.expiryMaxDate = null;
      if (startDate) {
        var startD = new Date(startDate);
        vm.expiryMaxDate = new Date(
          startD.getFullYear() + 1,
          startD.getMonth(),
          startD.getDate()
        );
      }
    }

    // vaidate expiry date is greater than selected rate expiry date
    function validateExpirydate(expiry_date) {
      if (expiry_date > vm.expiryDateEnd) {
        vm.validationObj.showDateNote = true;
      } else {
        vm.validationObj.showDateNote = false;
      }
    }

    function goToShipmentDetail() {
      if (vm.isWebView) {
        util.webViewObj.id = vm.quote_result.result_data.shipment_id;
        $state.go("app.mobile_shipment_details", util.webViewObj.id);
      } else {
        $state.go("app.shipments.shipment_details", {
          id: vm.quote_result.result_data.shipment_id,
        });
      }
    }

    // Binding Services to scope
    vm._mdPanel = $mdPanel;
    vm.showCostBreakdown = showCostBreakdown;

    function showCostBreakdown(cardData, ev) {
      vm.viewCostCard = cardData;
      var pageData = {};
      //var dialog = angular.element(document.querySelector('.quote-newCard-'+vm.viewCostCard._id));
      var position = vm._mdPanel
        .newPanelPosition()
        .relativeTo(ev.target)
        .addPanelPosition("center", "below");
      if (vm.search_param.mode == "SEA-FCL") {
        pageData.url = "app/main/component/charges-view/charges-view.html";
        pageData.controller = "ChargesViewController";
      } else {
        pageData.url = "app/main/component/cost-view/cost-view.html";
        pageData.controller = "CostViewController";
      }

      var config = {
        attachTo: angular.element(document.body),
        templateUrl: pageData.url,
        controllerAs: "ctrl",
        controller: pageData.controller,
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        locals: {
          userbasecurrency: vm.search_param.user.user_base_currency,
          card: vm.viewCostCard,
          l3_leg: vm.l3_leg,
          mainFreightName: vm.mainFreightName,
          totalCost: vm.viewCostCard.meta[vm.resultCardFilter.total_cost],
          buyOrSell: vm.buyOrSell,
          search_param: vm.search_param,
        },
        onOpenComplete: function () {
          // costViewFactory.panelClosed = false;
        },
        onRemoving: function () {
          // costViewFactory.panelClosed = true;
        },
      };

      vm._mdPanel.open(config);

      //mixpanel code
      util.callMixpanel("QC-Ratecard-Total-Change", {
        Mode: vm.search_param.mode,
      });
    }

    function fnGetFwrdTerms() {
      var mode =
        vm.search_param.mode == "SEA-FCL"
          ? "fcl"
          : vm.search_param.mode == "AIR"
          ? "air"
          : "lcl";
      resultService.getTermsConditions(mode, "false").then(
        function (response) {
          vm.termsAndConditions = util.decodeValue(response.data.terms);
          if(vm.isManual){
            vm.quote_result.result_data.terms=angular.copy(vm.termsAndConditions)
          }
        },
        function (error) {
          vm.termsAndConditions = "";
        }
      );
    }

    function getQuoteCreationErrorMessage(error) {
      var message = util.displayValidationError(error);
      if (message && message.indexOf('Email already exists') !== -1) {
        return 'Customer user email address is already present in the system, please enter different email address';
      }
      return message;
    }

    function generateQuote(ev) {
      //setting date 
      vm.setDatePicker(vm.pickerModel)
      //validations for mandatory fields 
      if (Object.keys(vm.copyQuoteForm.$error).length) {
        document.getElementById("copy-quote-meta").scrollIntoView();
        return;
      }
      if(!vm.pickerModel.dateStart || !vm.pickerModel.dateEnd ){
        vm.dateRangeError = true;
        return;
      }
      if (!vm.cutomerData.$valid) {
        document.getElementById("internal-deatils").scrollIntoView();
        vm.customerValidationObj.customerDataValidation = true;
        return;
      }
  
      vm.quoteType = "copyQuote";
      vm.isDuplicateQuote =  !vm.isManual;
      vm.quoteDetails = shareQuoteService.fnInitializeQuoteDetails(
        vm.search_param.origin_customs,
        vm.search_param.destination_customs
      );
      vm.quoteDetails.terms = vm.quote_result.result_data.terms;
      vm.quoteDetails.customs = vm.search_param.customs;
      vm.quoteDetails.incoterms = vm.search_param.inco_term
        ? vm.search_param.inco_term
        : null;
      vm.quoteDetails.impo_expo = vm.search_param.impo_expo
        ? vm.search_param.impo_expo
        : null;
        
      vm.quoteDetails.cc_emails = vm.quote_result.result_data.cc_emails;
      vm.quoteDetails.generate_pdf = vm.quote_result.result_data.generate_pdf;
      vm.quoteDetails.print_schedule = vm.quote_result.result_data.print_schedule;
      vm.quoteDetails.send_mail = vm.quote_result.result_data.send_mail;
      vm.quoteDetails.show_zero_sell_rates =
      vm.quote_result.result_data.show_zero_sell_rates;
      vm.quoteDetails.all_in_quote_setting = vm.quote_result.result_data.all_in_quote_setting;
      vm.quoteDetails.pdf_preferred_language = vm.quote_result.result_data.pdf_preferred_language || "en";
      vm.quoteDetails.co2e = vm.quote_result.result_data.co2e;
      vm.quoteDetails.carrier_mask_for_shipper = vm.quote_result.result_data.carrier_mask_for_shipper
      vm.quoteDetails.hazardous = vm.search_param.hazardous_material;
      vm.user.user_first_name = vm.user.user_first_name;
      vm.user.user_last_name = vm.user.user_last_name;
      vm.company.company_name = vm.company.company_name;
      var user = {};
      var company = {};
      var cards = [];
      var currency_conversion_rates = [];
      var vendor_0_obj = null;
      vm.quoteDetails.incoterms = vm.search_param.inco_term
        ? vm.search_param.inco_term
        : null;
      vm.quoteDetails.hazardous = vm.search_param.hazardous_material;
      vm.shareQuoteObj = {
        quoteDetails: vm.quoteDetails,
        termsAndConditions: vm.search_param.termsAndConditions,
        stdTermsAndConditions: vm.search_param.stdTermsAndConditions,
        selectedCard: vm.quote_CardData,
        search_param: vm.search_param,
        generateQuoteBtn: vm.resultCardFilter.generateQuoteBtn,
        currency_conversion_rates:
          vm.resultCardFilter.currency_conversion_rates,
        fclLoadData: vm.fclLoadData ? vm.fclLoadData : null,
        result_id: vm.quote_result.result_data.search_id,
        vas_details: vm.vasDetails,
        sales_user: null,
        shipper_user: null,
        quoteFrom: "search",
        exchangeRateId: vm.quote_result.result_data._id,
        is_duplicate_quote: vm.isManual ? false:true ,
        parent_quote_id: vm.quote_result.result_data._id,
        copy_quote_id: vm.quote_result.result_data.quote_id,
      };
      vm.isIncotermsRequired =
        $rootScope.domainData.domain_info["INCO_TERM_MANDATORY"];
      vm.enable_zero_sell_rates_on_pdf_checkbox =
        $rootScope.domainData.domain_info[
          "ENABLE_ZERO_SELL_RATES_ON_PDF_CHECKBOX"
        ];
      vm.quoteDetails = vm.shareQuoteObj.quoteDetails;
      vm.termsAndConditions = vm.shareQuoteObj.termsAndConditions;
      vm.stdTermsAndConditions = vm.shareQuoteObj.stdTermsAndConditions;
      vm.selectedCard = vm.shareQuoteObj.selectedCard;
      vm.search_param = vm.shareQuoteObj.search_param;
      vm.generateQuoteBtn = vm.shareQuoteObj.generateQuoteBtn;
      vm.currency_conversion_rates = vm.shareQuoteObj.currency_conversion_rates;
      vm.fclLoadData = vm.shareQuoteObj.fclLoadData;
      vm.result_id = vm.shareQuoteObj.result_id;
      vm.inquiry_id = vm.shareQuoteObj.inquiry_id;
      vm.sales_user = vm.shareQuoteObj.sales_user;
      vm.shipper_user = vm.shareQuoteObj.shipper_user;
      vm.erp_data = vm.shareQuoteObj.erp_data;
      vm.vas_details = vm.shareQuoteObj.vas_details;
      vm.is_duplicate_quote = vm.shareQuoteObj.is_duplicate_quote;
      vm.parent_quote_id = vm.shareQuoteObj.parent_quote_id;
      vm.copy_quote_id = vm.shareQuoteObj.copy_quote_id;
      vm.currency_conversion_rates = vm.shareQuoteObj.currency_conversion_rates;
      var getCurrUserRate = vm.currency_conversion_rates.find(function (
        element
      ) {
        if (element.vendor_id == 0) {
          vendor_0_obj = element;
        }
        return (
          element.vendor_id == parseInt(vm.authTokenValue.vendor_id)
        );
      });
      if (getCurrUserRate) {
        currency_conversion_rates.push(getCurrUserRate);
      }
      if (vendor_0_obj) {
        currency_conversion_rates.push(vendor_0_obj);
      }
      vm.search_param.user_nearby_origin = [];
      vm.search_param.user_nearby_origin.push(vm.search_param.origin_location);
      vm.search_param.user_nearby_destination = [];
      vm.search_param.user_nearby_destination.push(vm.search_param.destination_location);
      if(vm.search_param['nearby_origin'] && vm.search_param['nearby_origin'].length &&  vm.mode != 'AIR'){
        vm.search_param.user_nearby_origin=vm.search_param.user_nearby_origin.concat(vm.search_param['nearby_origin'])
        delete vm.search_param['nearby_origin']
      }
      if(vm.search_param['nearby_destination'] &&vm.search_param['nearby_destination'].length &&  vm.mode != 'AIR'){
        vm.search_param.user_nearby_destination=vm.search_param.user_nearby_destination.concat(vm.search_param['nearby_destination'])
        delete vm.search_param['nearby_destination']
      }
 
      
      var search_data = angular.copy(vm.search_param);
      
      search_data.inco_term = vm.quoteDetails.incoterms
        ? vm.quoteDetails.incoterms
        : null;
      search_data.hazardous_material = vm.quoteDetails.hazardous;
      search_data.customs = vm.quoteDetails.customs;
      search_data.search_name = vm.internalDetails.search_reference ? vm.internalDetails.search_reference:null ;
      cards = angular.copy(vm.shareQuoteObj.selectedCard);
      angular.forEach(cards, function (card) {
        // delete card._id;
        delete card.meta.buy_leg_total;
        delete card.meta.view;
        delete card.meta["status"];
        delete card.meta["slabPersentage"];
        delete card.meta["selectedLeg"];
        delete card.meta["init_sort_total"];
        delete card.data.buy_rates[vm.l3_leg]["rate_obj_1"];
        delete card.data.buy_rates[vm.l3_leg]["rate_obj_2"];
        delete card.data.sell_rates[vm.l3_leg]["rate_obj_1"];
        delete card.data.sell_rates[vm.l3_leg]["rate_obj_2"];
        card.meta.card_total_cost = resultService.calCardTotal(
          card.data.sell_rates
        );
        var getCurrencyRate = vm.currency_conversion_rates.find(function (
          element
        ) {
          return element.vendor_id == card.meta.vendor_id;
        });
        if (getCurrencyRate) {
          currency_conversion_rates.push(getCurrencyRate);
        }
        angular.forEach(card.data.sell_rates, function (sellValue, sellKey) {
          if (sellValue.rate_obj) {
            delete sellValue.rate_obj._id;
            angular.forEach(
              sellValue.rate_obj.load_stat,
              function (loadValue, loadKey) {
                var result = sellValue.rate_obj.charges.some(function (entry) {
                  return loadKey == entry.container_type;
                });
                if (result) {
                  sellValue.rate_obj.load_stat[loadKey] = 1;
                  card.data.buy_rates[sellKey].rate_obj.load_stat[loadKey] = 1;
                } else {
                  sellValue.rate_obj.load_stat[loadKey] = 0;
                  card.data.buy_rates[sellKey].rate_obj.load_stat[loadKey] = 0;
                }
              }
            );
          } else {
            delete card.data.sell_rates[sellKey];
            delete card.data.buy_rates[sellKey];
          }
        });
      });
      user["email"] = vm.internalDetails.customer_details.user.email;
      user["user_mobile"] =
        vm.internalDetails.customer_details.user.user_mobile;
      user["user_first_name"] =
        vm.internalDetails.customer_details.user.user_first_name;
      user["user_last_name"] =
        vm.internalDetails.customer_details.user.user_last_name;
      company["company_address"] =
        vm.internalDetails.customer_details.company.company_address;
      company["company_name"] =
        vm.internalDetails.customer_details.company.company_name;
      if (vm.internalDetails.customer_details.user.id) {
        user["id"] = vm.internalDetails.customer_details.user.id;
      }
      if (vm.internalDetails.customer_details.company.id) {
        company["id"] =vm.internalDetails.customer_details.company.id 
        }
      // var quoteExpire = new Date(vm.quoteDetails.expiry_date);
      // quoteExpire.setHours('23');
      // quoteExpire.setMinutes('59');

      var quoteExpire = moment(vm.quote_result.result_data.expiry_date).format(
        "YYYY-MM-DD"
      ); // remove Z from expiry date
      vm.quoteDetails.expiry_date = quoteExpire;
      // var quoteStart = new Date(vm.quoteDetails.start_date);
      // quoteStart.setHours('00');
      // quoteStart.setMinutes('00');
      var quoteStart = moment(vm.quote_result.result_data.start_date).format(
        "YYYY-MM-DD"
      ); // remove Z from expiry date
      vm.quoteDetails.start_date = quoteStart;
      vm.shareQuoteBtn = true;
      var quoteId= vm.is_duplicate_quote ?( ' - ' + vm.copy_quote_id ):'';
      var activityMessage='Quotation created ' + (vm.pageTitle == 'create-quote' && !vm.isManual ? 'from Template': quoteId);
      var activityDescription=(vm.pageTitle == "create-quote" && !vm.isManual ? 'Template Name:'+vm.quote_result.result_data.template_data.name :"");
      var data = {
        data: {
          sales_user:util.userProfile.user,
          user: user,
          company: company,
          cards: cards,
          currency_conversion_rates: currency_conversion_rates,
          search_param: search_data,
          search_id: vm.result_id,
          start_date: vm.quoteDetails.start_date,
          expiry_date: vm.quoteDetails.expiry_date,
          customs: vm.quoteDetails.customs,
          perishable: vm.quoteDetails.perishable,
          cc_emails: vm.quoteDetails.cc_emails,
          hazardous: vm.quoteDetails.hazardous,
          send_mail: vm.quoteDetails.send_mail
            ? vm.quoteDetails.send_mail
            : false,
          generate_pdf: vm.quoteDetails.generate_pdf,
          print_schedule: vm.quoteDetails.print_schedule
            ? vm.quoteDetails.print_schedule
            : false,
          show_zero_sell_rates: vm.quoteDetails.show_zero_sell_rates
            ? vm.quoteDetails.show_zero_sell_rates
            : false,
          incoterms: vm.quoteDetails.incoterms
            ? vm.quoteDetails.incoterms
            : null,
          impo_expo: vm.quoteDetails.impo_expo
            ? vm.quoteDetails.impo_expo
            : null,
            
          terms: util.encodeValue(vm.quoteDetails.terms),
          is_duplicate_quote: !vm.isManual,
          parent_quote_id: vm.parent_quote_id ? vm.parent_quote_id : null,
          all_in_quote_setting : vm.quoteDetails.all_in_quote_setting,
          pdf_preferred_language : vm.quoteDetails.pdf_preferred_language || "en",
          co2e : vm.quoteDetails.co2e,
          carrier_mask_for_shipper: vm.quoteDetails.carrier_mask_for_shipper,
          activity: [
            {
              message: activityMessage,
              description:activityDescription,
              type: "quote_created",
              timestamp: new Date(),
              user_id: util.userProfile.user.id,
              user_name:
                util.userProfile.user.user_first_name +
                " " +
                util.userProfile.user.user_last_name,
              activity_data: {},
            },
          ],
          additional_charges: {
            selected: vm.vas_details ? vm.vas_details.legList : [],
            available: vm.vas_details ? vm.vas_details.value_added_charges : [],
          },
          is_manual:vm.isManual,
          customField: vm.quote_result.result_data.customField
        }
      };

      // activity for for Refresh Rates
      if(vm.newResultCard && vm.newResultCard.length){
        data.data.activity.push({
          message: "Rate card has been added from refresh",
          description: "",
          type: "rate_card_added",
          timestamp: new Date(),
          user_id: util.userProfile.user.id,
          user_name:
            util.userProfile.user.user_first_name +
            " " +
            util.userProfile.user.user_last_name,
          activity_data: {},
        });
      }

      vm.buyOrCard_total = "buy_leg_total";
      if (vm.currentState === "app.inquiry.inquiryDetails") {
        data.data["erp_data"] = vm.erp_data ? vm.erp_data : null;
        data.data["inquiry_id"] = vm.inquiry_id;
        vm.buyOrCard_total = "card_total_cost";
      }
      vm.shareQuoteObj.selectedCard.sort(function (a, b) {
        return b.meta[vm.buyOrCard_total] - a.meta[vm.buyOrCard_total];
      });
      util.isCallingApi = true;
     resultService.quoteCreation(data, vm.search_param.id).then(
      //resultService.shareQuote(data, vm.search_param.id).then(
        function (response) {
          //console.log(response)
          vm.shareQuoteResponse = response.data;
          vm.selected_vendorName = shareQuoteService.getSelectedCardSubvendor(
            vm.selectedCard,
            "vendor"
          );

          if (vm.search_param.mode == "SEA-FCL") {
            var numOfFreightbroCards = 0;
            for (var i = 0; i < vm.selected_vendorName.length; i++) {
              if (vm.selected_vendorName[i] === "FreightBro")
                numOfFreightbroCards++;
            }
          }
          // if (response.data.data.pdf_link != null) {
          //     var pdfLink = response.data.data.pdf_link;
          //     var a = $window.open(pdfLink, "sharedLink");
          //     if (a) {
          //     a.focus();
          //     }
          // }

          vm.quoteId = response.data.quote_id;
          vm.shareQuoteData = response.data._id;
          vm.pdf_link = response.data.pdf_link;
          vm.downloadProgressValue = 1;
          vm.fnGetPdfLink();
          vm.quoteSent = true;
          vm.shareQuoteBtn = false;
          vm.generateQuoteBtn = true;
          vm.customerDetails = {};
          util.isCallingApi = false;

          $mdDialog.show({
            templateUrl:"app/main/component/quote-modification/quote-modification-quotation.html",
            targetEvent: ev,
            clickOutsideToClose: false,
            parent: $rootElement,
            scope: $scope,
            controllerAs: "ctrl",
            preserveScope: true,
            controller: function () {
              this.parent = vm;
            },

            // onRemoving: vm.resetSendQuotey
          });
        },
        function (error) {
          util.isCallingApi = false;
          vm.quoteId = null;
          vm.shareQuoteData = null;
          util.showToast(getQuoteCreationErrorMessage(error));
          vm.shareQuoteBtn = false;
          $log.error(error.statusText);
        }
      );
    }

    function fnGetPdfLink() {
      vm.downloadProgressValue = vm.isPdfFailed ? 1 : vm.downloadProgressValue;
      vm.isPdfErrOccured = false;
      vm.isPdfFailed = false;
      vm.isPdfGenerated = false;
      resultService.fnGetPdfLink(vm.shareQuoteData).then(
        function (response) {
          vm.pdf_link = response.data.data.pdf_link;

          if (vm.pdf_link) {
            // pdf link success
            clearInterval(vm.autoUpdate);
            vm.isPdfGenerated = true;
            vm.isPdfFailed = false;
            vm.downloadProgressValue = 5;
          } else {
            //pdf link failed
            vm.autoUpdate = setTimeout(fnGetPdfLink, 5000);
            vm.downloadProgressValue += 1;
            if (vm.downloadProgressValue >= 5) {
              clearInterval(vm.autoUpdate);
              vm.isPdfFailed = true;
              vm.downloadProgressValue = 0;
            }
          }
        },
        function (error) {
          vm.isPdfGenerated = true;
          vm.isPdfErrOccured = true;
          vm.downloadProgressValue = 0;
          $log.error(error);
        }
      );
    }

    function closeShareDialog(action) {
      $mdDialog.hide().then(function() {
        if (vm.search_param.mode == "SEA-FCL") {
          SearchService.FclResult = {};
        } else if (vm.search_param.mode == "AIR") {
          SearchService.AirResult = {};
        } else if (vm.search_param.mode == "SEA-LCL") {
          SearchService.LclResult = {};
        }
        if (action == "quote") {
            util.showToast(
              util.displayValidationError("Redirecting to generated quote page.")
            );
            if(vm.isWebView){
              util.webViewObj.id = vm.shareQuoteResponse._id;
              $state.go("app.webViewQuotesDetails", util.webViewObj);
            }else{
              $state.go("app.quotes.quotesDetails", {
                id: vm.shareQuoteResponse._id,
              });
            }
        } else if (action == "inquiry") {
          if (vm.currentState == "app.inquiry.inquiryDetails") {
              $state.reload();
          } else {
            $mdDialog.hide();
              util.showToast(
                util.displayValidationError("Redirecting to inquiry detail page.")
              );
              if(vm.isWebView){
                $state.go("app.inquiry.webViewInquiryDetails", {
                  id: vm.shareQuoteResponse.inquiry_id,
                });
              }else{
                $state.go("app.inquiry.inquiryDetails", {
                  id: vm.shareQuoteResponse.inquiry_id,
                });
              }
          }
        }
      });   
    }

    function downloadPdf() {
      // $window.open(vm.pdf_link);
      var anchorTag = document.createElement('a');
      anchorTag.setAttribute('href',vm.pdf_link);
      anchorTag.setAttribute('download',true);
      anchorTag.setAttribute('target','_blank')
      document.body.appendChild(anchorTag);
      anchorTag.click();
      document.body.removeChild(anchorTag);

    }

    function fnopenCopyQuotewalkthrough(ev) {
      util.callMixpanel("QC-CopyQuote-Click", {
        Mode: vm.search_param.mode,
        Type: vm.resultType,
      });
      $mdDialog.show({
        templateUrl:
          "app/main/quotes/components/copy-quote/copy-quote-overview-popup.html",
        targetEvent: ev,
        clickOutsideToClose: true,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () {
          this.parent = vm;
        },
        controllerAs: "ctrl",
      });
    }

    // mixpanel event
    function trackEvent(eventName,data) {
      util.callMixpanel(eventName,{
        "Quote Data":data
      });
    }

    vm.fnOpenRefreshRatesPopup = fnOpenRefreshRatesPopup;

    // Funtion to open rate refresh popup
    function fnOpenRefreshRatesPopup(ev){
      util.callMixpanel('QC-RateRefresh-Click');
      vm.copySearchParam = angular.copy(vm.search_param);
      $mdDialog.show({
        // vm.editBuyRate = util.userProfile.user.allow_edit ? true : false;
          template: '<md-dialog id="refresh-rates" class="popup-md" ng-cloak><refresh-rates search-param="ctrl.parent.copySearchParam" source="ctrl.parent.pageTitle" quote-result="ctrl.parent.quote_result"  load-string="$ctrl.LoadBoxString"></refresh-rates></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          parent: $rootElement,
          scope: $scope,
          preserveScope: true,
          controller: function () { this.parent = vm },
          controllerAs: 'ctrl',
      });
    }

    // Function to add cards which is selected from result
    function addCardsFromResult(){
      vm.refreshQuoteId = resultService.refreshQuoteData.quote_id;
      if(vm.refreshRates && vm.refreshQuoteId === vm.quote_result.result_data._id){
        vm.isQuoteModify = true;
        vm.newResultCard = angular.copy(resultService.refreshQuoteData.selectedCards);
        vm.newResultCard.forEach(function (card) {
          card.meta["status"] = "new";
        });
        vm.quote_CardData = vm.newResultCard.concat(vm.quote_CardData);
        vm.resetRefreshData();
        updateRateRefreshCardSearchCurrency();
      }
    }
    function resetRefreshData(){
      resultService.refreshQuoteData =       {quote_id: '',
        quote_number: '',
        selectedCards: [],
        from_quote_search_param:{},
        oldCards:[]};
    }

    // function to push newly card added
    function pushNewCards(card){
      if(vm.newResultCard && vm.newResultCard.length){
        vm.newResultCard.push(card);
        vm.quote_CardData.unshift(card);
      }else{
        vm.quote_CardData.push(card);
      }
    }
    function searchCurrencyRateCardUpdate(status){
      if(status === 'yes'){
      vm.search_param.search_currency =  vm.currency;
      vm.search_param.user.user_base_currency = vm.currency;
      vm.quote_CardData.forEach(function (card) {

     
        angular.forEach(card.data.buy_rates, function (leg_value, leg_key) {
          if(card.data.buy_rates){
          if(card.data.buy_rates[leg_key].rate_obj){
            card.data.buy_rates[leg_key].rate_obj.leg_total_currency = vm.search_param.search_currency;
          }
        }
          if(card.data.sell_rates){
          if(card.data.sell_rates[leg_key].rate_obj){
            card.data.sell_rates[leg_key].rate_obj.leg_total_currency = vm.search_param.search_currency;
            }
          }
     });
    
     
    
      
    });
      vm.search_param.mode === 'SEA-FCL' ? vm.fnFclLoadChanged() : vm.fnAirLclLoadChanged();
     }else{
       vm.currency= vm.search_param.search_currency;

  }
  return;
    }
    function fillSearchParam(){
      var originType = '';
      var destinationType = '';
      if(vm.search_param.origin_location){
        if(vm.search_param.origin_location.place_type === "Door"){
          originType = "D";
        }else{
          originType = "P";
        }
        vm.search_param.user_nearby_origin = [];
        vm.search_param.user_nearby_origin.push(vm.search_param.origin_location);

      }
      if(vm.search_param.destination_location){
        vm.search_param.user_nearby_destination = [];
        if(vm.search_param.destination_location.place_type === "Door"){
          destinationType = "D";
        }else{
          destinationType = "P";
        }
        vm.search_param.user_nearby_destination.push(vm.search_param.destination_location);
      }
      if(originType && destinationType){
        vm.search_param.search_type = originType+"2"+destinationType;
      }
    }
    function searchCurrencyChange(ev){
      if(! (vm.quote_CardData && vm.quote_CardData.length)){
          vm.currency = ev;
          vm.search_param.search_currency =  vm.currency;
          vm.search_param.user.user_base_currency = vm.currency;
          return;
      }
      vm.popupType = 'currency';
      vm.includeRateCards = true;
      $mdDialog.show({
        template:
          '<md-dialog id="copy-quote-confirmation" class="popup-sm"><copy-quote-confirmation  type="$ctrl.popupType" source-currency="$ctrl.search_param.search_currency" target-currency="$ctrl.currency" include-rate-cards="$ctrl.includeRateCards" search-param="$ctrl.search_param" callback="$ctrl.searchCurrencyRateCardUpdate(status)"></copy-quote-confirmation></md-dialog>',
        clickOutsideToClose: false,
        parent: $rootElement,
        scope: $scope,
        controllerAs: "ctrl",
        preserveScope: true,
        controller: function () {
          this.parent = vm;
        },
      });
    }
  }
})();

(function () {
    "use strict";
    angular
      .module('app.core')
      .component('internalDetails', {
          templateUrl: 'app/main/component/quote-internal-details/quote-internal-details.html',
          bindings: {
            internalDetails:'=',
            searchParam:'=',
            validationObj:'=',
            editParty:'=',
            cutomerData:'='
          },
         controller: InternalDetailsController
    });
    function InternalDetailsController($mdDialog,$rootElement,$scope,ShipmentService,api,$log,SearchService,util) {

      var vm = this;
      vm.util=util;
      // methods
      vm.addShipper = addShipper;
      vm.filterStringList = filterStringList;
      vm.selectedToChange = selectedToChange;
      vm.searchTextChange = searchTextChange;
      vm.fnMultiEmailValidation = fnMultiEmailValidation;
      vm.trackEvent=trackEvent;
      vm.selectedEmail=null;

      vm.cutomerData={};
      vm.shipDetailsData = {};
      vm.internalDetails={
        "inquiry_number":null,
        "search_reference":null,
         customer_details:{
          user:{
            "id":null,
            "user_first_name":null,
            "user_last_name":null,
            "email":null,
            "user_mobile":null
           },
           company:{
            "id":null,
            "company_name":null,
            "company_address":null
           }
          },
        "cc_email":[]
      }

      vm.validationObj={
        "customerDataValidation":false,
        "ccMailValidation":false
      }

      //Customer-details 

      function searchTextChange(text){
          vm.internalDetails.customer_details.user.id = null;
          vm.internalDetails.customer_details.user.user_first_name = null;
          vm.internalDetails.customer_details.user.user_last_name =  null;
          vm.internalDetails.customer_details.user.email = null;
          vm.internalDetails.customer_details.user.user_mobile = null;
 
          vm.internalDetails.customer_details.company.id = null;
          vm.internalDetails.customer_details.company.company_name =  null;
          vm.internalDetails.customer_details.company.company_address = null;
      }


      function selectedToChange(selected) {
        vm.shipDetailsData = selected;
        vm.selectedEmail= vm.shipDetailsData;
        if(selected != null){
          vm.internalDetails.customer_details.user.id =selected.id
          vm.internalDetails.customer_details.user.user_first_name = selected.user_first_name
          vm.internalDetails.customer_details.user.user_last_name = selected.user_last_name;
          vm.internalDetails.customer_details.user.email = selected.email;
          vm.internalDetails.customer_details.user.user_mobile = selected.user_mobile;
 
          vm.internalDetails.customer_details.company.id = selected.company.id;
          vm.internalDetails.customer_details.company.company_name = selected.company.company_name;
          vm.internalDetails.customer_details.company.company_address = selected.company.company_address;
        }
      }


      function filterStringList(userInput) {
        vm.selectList = [];
        var url = api.baseUrl + '/api/get-shippers?limit=30&offset=0';

        if(userInput){
          url += '&query=' +userInput;
        }
        if(util.userProfile){
          url += '&salesperson_id=' +util.userProfile.user.id;
        }

        return SearchService.getShipperList(url).then(function (response) {
          vm.selectList = response.data.data;
          return vm.selectList;
        }, function (error) {
          $log.log(error.data);
          return [];
        });
      }
    //  if(vm.internalDetails.customer_details.company.company_name || vm.internalDetails.customer_details.user.email || vm.internalDetails.customer_details.user.user_first_name || vm.internalDetails.customer_details.user.user_last_name){
    //      vm.validationObj.customerDataValidation = true;
    //    }
     
      
      // Add shipper

     
      function addShipper(ev){

        //  <!-- DEV-15792 - Add New Customer - Navigate to shippers page in new tab-->
        // $window.open('/shippers', '_blank');
        // <!-- DEV-15792 - fix: Add New Customer-->
        vm.editParty = {
          "category": 'Customer'
        };
        vm.popupValidationObj={
           "emailValidation":false, 
          "nameValidation":false,
          "companyValidation":false,
        }
        vm.fixCategory='Customer';
        vm.editPartyModalTitle ='Add';
        vm.selectUser=[];
        vm.parties='Customer'
        vm.mode=vm.searchParam.mode;
        vm.sourcePage = 'Quotes';
        vm.partyBtn = true
        $mdDialog.show({
            template: '<md-dialog id="new-party" class="popup-md"><new-user-quote fix-category="ctrl.parent.fixCategory" edit-party-modal-title="ctrl.parent.editPartyModalTitle" validation-obj="ctrl.parent.popupValidationObj" mode="ctrl.parent.mode" edit-party="ctrl.parent.editParty" select-user="ctrl.parent.selectUser"  party-id="ctrl.parent.party_id" party-btn="ctrl.parent.partyBtn"   is-from-quote="ctrl.parent.sourcePage" callback="ctrl.parent.selectedToChange(data)"></new-user-quote></md-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            parent: $rootElement,
            scope: $scope,
            controllerAs: 'ctrl',
            preserveScope: true,
            onRemoving: vm.restPartyObj,
            controller: function () { this.parent = vm },
        });
      }

      // CC Email

      function fnMultiEmailValidation(emails, userInput) {
        
        util.validateEmail(emails, userInput);
        if(util.invalidEmail) {
          $('.quote-invalidErrorMsg').show().delay(1000).fadeOut();
        }
        if(util.duplicateEmail) {
          $('.quote-duplicateErrorMsg').show().delay(1000).fadeOut();
        }
      }

        function trackEvent(event){
          util.callMixpanel(event);
        }
    }
})();
(function () {
  'use strict';

  angular
  .module('app.core')
  .component('portToPort', {
      templateUrl: 'app/main/component/pol-to-pod/pol-to-pod.html',
      bindings : {
        card : '<',
        buyorsell : '<',
        mode : '<',
        callback : '&'
      },
      controller: PortToPortController
  });

  function PortToPortController(util,$rootScope) {
    var vm = this;
    vm.util = util;
    vm.initData=initData;
    vm.fnLength = fnLength;
    vm.pickupTransport = [];
    vm.deliveryTransport = [];
    vm.arrayToObject = arrayToObject;
    vm.getPickupData = getPickupData;
    vm.getDeliveryData = getDeliveryData;

    this.$onChanges = function() {
        vm.initData();
    }
    $rootScope.$on('getInitData',function(){
      vm.initData();
    })
    function initData(){
      vm.l1_leg = (vm.mode == 'SEA-FCL') ? 'l1_fcl' : ((vm.mode == 'AIR') ? 'l1_air' : 'l1_lcl' );
      vm.l3_leg = (vm.mode == 'SEA-FCL') ? 'l3_fcl' : ((vm.mode == 'AIR') ? 'l3_air' : 'l3_lcl' );
      vm.l5_leg = (vm.mode == 'SEA-FCL') ? 'l5_fcl' : ((vm.mode == 'AIR') ? 'l5_air' : 'l5_lcl' );
      vm.buyorsell = vm.buyorsell;
      vm.isViaAvailable = false;
      vm.isScheduleVia = false;
      vm.portDetails = ['Port of Loading', 'Port of Discharge'];
      //vm.card.data[vm.buyorsell][vm.l3_leg].rate_obj.via_route ='INNSA,DEHAM, INMAA,INENR'
      if(vm.card.meta.selected_schedule){
          vm.isScheduleVia = true;
      }
      else if(!vm.card.meta.selected_schedule) {
          if(vm.card.data && vm.card.data[vm.buyorsell][vm.l3_leg].rate_obj.via_route && vm.card.data[vm.buyorsell][vm.l3_leg].rate_obj.via_route != 'Direct'){
          vm.isViaAvailable = true;
        }
        else if(vm.card.leg && vm.card.leg[vm.l3_leg].via_route && vm.card.leg[vm.l3_leg].via_route != 'Direct'){
          vm.isViaAvailable = true;
        }
        vm.isScheduleVia = false;
      }

      vm.getPickupData();
      vm.getDeliveryData();
    }

    function arrayToObject(transportArray){
      var result = [];
      for (var i = 0; i < transportArray.length; i++) {
        var item = {};
        var isIconAvl = transportArray[i].toLowerCase() == 'rail' || transportArray[i].toLowerCase() == 'road' || transportArray[i].toLowerCase() == 'barge' || transportArray[i].toLowerCase() == 'truck';

        item['icon'] = isIconAvl ? transportArray[i].toLowerCase() : null;
        item['value'] = transportArray[i];
        result.push(item);
      }
      return result;
    }

    function getPickupData(){

      var pickupData = vm.card.data ? vm.card.data[vm.buyorsell] : vm.card.leg
      // haulage 
      if(vm.card.meta.pickup_transport_mode){
        var transportL1 = vm.card.meta.pickup_transport_mode ? vm.card.meta.pickup_transport_mode.split('/') : [];

        vm.pickupTransport = vm.arrayToObject(transportL1);
      }

      // service type
      if(!vm.card.meta["pickup_service"]){
        vm.card.meta["pickup_service"] = pickupData[vm.l1_leg] && pickupData[vm.l1_leg].rate_obj && pickupData[vm.l1_leg].rate_obj.service_type ? pickupData[vm.l1_leg].rate_obj.service_type : pickupData[vm.l1_leg]  && pickupData[vm.l1_leg].service_type ? pickupData[vm.l1_leg].service_type :  "";
      }

      // sub-vendor
      if(!vm.card.meta["pickup_sub_vendor"]){
        vm.card.meta["pickup_sub_vendor"] = pickupData[vm.l1_leg] && pickupData[vm.l1_leg].rate_obj && pickupData[vm.l1_leg].rate_obj.sub_vendor ? pickupData[vm.l1_leg].rate_obj.sub_vendor : pickupData[vm.l1_leg]  && pickupData[vm.l1_leg].sub_vendor ? pickupData[vm.l1_leg].sub_vendor : null;
      }
      
    }

    function getDeliveryData(){

      var deliveryData = vm.card.data ? vm.card.data[vm.buyorsell] : vm.card.leg

      if(vm.card.meta.delivery_transport_mode){
        var transportL5 = vm.card.meta.delivery_transport_mode ? vm.card.meta.delivery_transport_mode.split('/') : [];

        vm.deliveryTransport = vm.arrayToObject(transportL5);
      }

      if(!vm.card.meta["delivery_service"]){
        vm.card.meta["delivery_service"] =   deliveryData[vm.l5_leg] && deliveryData[vm.l5_leg].rate_obj && deliveryData[vm.l5_leg].rate_obj.service_type ? deliveryData[vm.l5_leg].rate_obj.service_type : deliveryData[vm.l5_leg]  && deliveryData[vm.l5_leg].service_type ? deliveryData[vm.l5_leg].service_type : "";
      }

      if(!vm.card.meta["delivery_sub_vendor"]){
        vm.card.meta["delivery_sub_vendor"] =   deliveryData[vm.l5_leg] && deliveryData[vm.l5_leg].rate_obj && deliveryData[vm.l5_leg].rate_obj.sub_vendor ? deliveryData[vm.l5_leg].rate_obj.sub_vendor : deliveryData[vm.l5_leg]  && deliveryData[vm.l5_leg].sub_vendor ? deliveryData[vm.l5_leg].sub_vendor : null;
      }
      
    }

    function fnLength(){
      return Math.floor(vm.card.meta.selected_schedule.schedule_track.length/2) -1;
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('app.core')
  .component('penaltyFees', {
      templateUrl: 'app/main/component/penalty-fees/penalty-fees.html',
      bindings : {
        penaltyfeesobj : '=',
          callback : '&'
      },
      controller: PenaltyFeesController
  });


  function PenaltyFeesController(util,$mdDialog ) {
      var vm = this;

      vm.util = util;
      vm.closeDialog = closeDialog;

      this.$onInit = function() {

        vm.penaltyfeesArray = vm.penaltyfeesobj.penalty_fees;

      }

      function closeDialog() {
        $mdDialog.hide();
      }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('notificationBar', {
      templateUrl: 'app/main/component/notification-bar/notification-bar.html',
      bindings: {
        // freedaysdata: '<',
        // type: '<'
      },
      controller: NotificationBarController
    });


  function NotificationBarController($log, util, SearchService, analytics, $mdDialog, localStorageService, $window, $rootScope, ToolbarSerivice, appCache, $state, $element, $timeout, $transitions) {

    var vm = this;
    vm.util = util;
    vm.showRateToaster = false;
    vm.knowMoreServices = knowMoreServices;
    vm.interestedCustomersApi = interestedCustomersApi;
    vm.cancelDialog = cancelDialog;
    vm.hideToaster = hideToaster;
    vm.getBannerList = getBannerList;
    vm.callToAction = callToAction;
    vm.currentPageIndex = 0;
    vm.currentChildPageIndex=0;
    vm.prevButtonDisabled = true;
    vm.nextButtonDisabled = false;
    vm.prevBanner = prevBanner;
    vm.prevChildBanner=prevChildBanner;
    vm.nextBanner = nextBanner;
    vm.nextChildBanner=nextChildBanner;
    vm.showBanner = true;
    vm.newUpdate = null;
    vm.bannerList = [];
    vm.getForwarderList = getForwarderList;
    vm.getAllByForwarder = getAllByForwarder;
    vm.fnSearchForwarder = fnSearchForwarder;
    vm.onForwarderSelectClose = onForwarderSelectClose;
    vm.onForwarderSelectOpen = onForwarderSelectOpen;
    vm.getForwarderSelectedText = getForwarderSelectedText;
    vm.getSelectedForwarder = getSelectedForwarder;
    vm.getForwarderEfpLabel = getForwarderEfpLabel;
    vm.shouldDisableForwarderOption = shouldDisableForwarderOption;
    vm.searchValue = null;
    vm.listLoader = false;
    vm.forwarderSearchEmpty = false;
    vm._previousFilterForwarder = null;
    vm.hasEfpForwardersAvailable = false;
    vm._forwarderListLoaded = false;

    this.$onInit = function() {
      if(!util.userProfile.user){
        util.getProfile().then(function(){
            if( util.solution_type === 'NWLS' ){
              vm.showRateToaster = SearchService.getRateToasterStatus();
            }
        },function(error){
            $log.log(error.data);
            util.isCallingApi = false;
        });
      }
      else{
        if( util.solution_type === 'NWLS' ){
          vm.showRateToaster = SearchService.getRateToasterStatus();
        }
      }

      if(localStorageService.get("showBannerStatus") == null) {
        vm.showBanner = true;
      }
      else {
        vm.showBanner = localStorageService.get("showBannerStatus").value;
      }

      if(vm.showBanner) {
        getBannerList();
      }
      else {
        getBannerList();
        vm.oldUpdate = localStorageService.get("prevBannerUpdate").value ? localStorageService.get("prevBannerUpdate").value : null;
      }

      if( util.isFreightbro ){
        angular.element($element).addClass('has-forwarder-context');
        vm.getForwarderList();

        $transitions.onSuccess({}, function (transition) {
          if (!util.isFreightbro) {
            return;
          }
          var toName = transition.to() && transition.to().name;
          if (toName === 'app.searchV2Module') {
            // Avoid applying against the temporary [Own]-only list mid-fetch
            if (vm.listLoader) {
              return;
            }
            if (vm._forwarderListLoaded) {
              applySearchPageForwarderRules(getApiForwardersFromList());
            } else {
              vm.getForwarderList();
            }
          } else {
            $rootScope.disableEfpSearchUi = false;
          }
        });
      }
    }

    //Function of air import service after clicking on know more
    function knowMoreServices(ev){

      if(!vm.knowMoreApiCalling){
        // mixpanel code
        analytics.track("KnowMore");

        $mdDialog.show({
          templateUrl        : 'app/main/search/dialogs/exclusive-service/exclusive-service.html',
          targetEvent        : ev,
          clickOutsideToClose: true,
          controllerAs: 'ctrl',
          controller: function() { this.parent = vm }
        });

        vm.showSuccessMsg = false;
        vm.knowMoreApiCalling = true; //to prevent multiple clicks
        var postData = {
          'data' : null
        }

        SearchService.knowMoreServices(postData).then(function(){
          vm.knowMoreApiCalling = false;
        },function(error){
            vm.knowMoreApiCalling = false;
            $log.log(error);
        });
      }

    }

    //Function of air import service after clicking 'I am interested'
    function interestedCustomersApi(){
      analytics.track("I am Interested");
      vm.showSuccessMsg = true;
      vm.hideToaster();
    }

    // Close dialog box
    function cancelDialog(){
      $mdDialog.hide();
    }

    // Hide toaster
    function hideToaster(){
      localStorageService.set('rateToasterStatus', false);
      vm.showRateToaster = false;
    }

    // Function to get banner data
    function getBannerList(){
      SearchService.getBannerList().then(function(response){
        vm.newUpdate = angular.copy(response.updated_at);
        vm.bannerList = response;

        // comparision of data updated
        if(vm.oldUpdate <= vm.newUpdate) {
          vm.showBanner = vm.oldUpdate < vm.newUpdate ? true : false;
        }
        else {
          vm.showBanner = true;
        }

        localStorageService.set('showBannerStatus', vm.showBanner);
        localStorageService.set('prevBannerUpdate', response.updated_at);
        return vm.bannerList;
      },function(error){
        $log.log(error);
      });
    }

    function prevBanner() {
      vm.currentPageIndex--;
      vm.nextButtonDisabled = false;
      if(vm.currentPageIndex == 0) {
        vm.prevButtonDisabled = true;
      }
    }
    function prevChildBanner(){
      vm.currentChildPageIndex--;
      vm.nextChildButtonDisabled = false;
      if(vm.currentChildPageIndex == 0) {
        vm.prevChildButtonDisabled = true;
      }
    }

    function nextBanner() {
      vm.currentPageIndex++;
      vm.prevButtonDisabled = false;
      if((vm.bannerList.length-1) == vm.currentPageIndex) {
        vm.nextButtonDisabled = true;
      }
    } 

    function nextChildBanner(){
      vm.currentChildPageIndex++;
      vm.prevChildButtonDisabled = false;
      if((vm.bannerList[vm.currentPageIndex].data.length-1) == vm.currentChildPageIndex) {
        vm.nextChildButtonDisabled = true;
      }
    }

    // call to action for buton
    function callToAction(action, index,childIndex) {
     
      if(action.toLowerCase() == "launch_url") {
        $window.open(util.sanitizeQueryParams(vm.bannerList[index].data[childIndex].action.url), '_blank', "noopener")
      }
      else if((action.toLowerCase() == "dismiss")) {
        var tempObj = vm.bannerList;
  
          tempObj.splice(index, 1);

          if(vm.currentPageIndex >= vm.bannerList.length) {
            vm.currentPageIndex = vm.bannerList.length - 1;
          }
  
          if(vm.bannerList.length === 0) {
            localStorageService.set('showBannerStatus', false);
          }
  
          setTimeout(function() {
            $rootScope.$emit('calculateMaxHeight');
          }, 50);
        
        
      
     

        return tempObj;
      }
    }

    // Forwarder select logic

    function isOnSearchPage() {
      return $state.current && $state.current.name === 'app.searchV2Module';
    }

    function isEfpForwarder(forwarder) {
      return !!(forwarder && !forwarder.is_own && forwarder.is_efp);
    }

    function getApiForwardersFromList() {
      return (vm.forwarderList || []).filter(function (forwarder) {
        return !forwarder.is_own;
      });
    }

    function getOwnForwarderId() {
      return localStorageService.get('authToken').value.user_company_id;
    }

    function shouldDisableForwarderOption(vendor) {
      if (!isOnSearchPage() || !vendor) {
        return false;
      }
      // Own is always allowed on /search
      if (vendor.is_own) {
        return false;
      }
      if (isEfpForwarder(vendor)) {
        return false;
      }
      // Keep the already-selected non-EFP enabled so md-select can retain it
      if (vm.filterForwarder && vendor.id === vm.filterForwarder) {
        return false;
      }
      return true;
    }

    function selectForwarderQuietly(forwarder) {
      if (!forwarder) {
        return;
      }
      vm.filterForwarder = forwarder.id;
      vm._previousFilterForwarder = forwarder.id;
      localStorageService.set('forwarder', forwarder);
      $rootScope.vendor_id = forwarder.vendor_id || localStorageService.get('authToken').value.vendor_id;
      if (forwarder.id == getOwnForwarderId() || forwarder.is_own) {
        $rootScope.forwarder_id = null;
        util.setImpersonatedDomain(null);
      } else {
        $rootScope.forwarder_id = forwarder.id;
        util.setImpersonatedDomain(forwarder);
      }
    }

    function applySearchPageForwarderRules(apiForwarders) {
      if (!isOnSearchPage()) {
        $rootScope.disableEfpSearchUi = false;
        return;
      }

      var ownId = getOwnForwarderId();
      var ownForwarder = (vm.forwarderList || []).find(function (forwarder) {
        return forwarder.is_own || forwarder.id === ownId;
      });
      if (!ownForwarder) {
        ownForwarder = buildOwnForwarderRow();
        vm.forwarderList = [ownForwarder].concat(apiForwarders || []);
      }

      var currentId = vm.filterForwarder;
      var currentForwarder = (vm.forwarderList || []).find(function (forwarder) {
        return forwarder.id === currentId;
      });
      // Prefer previously stored selection when typed search results omit it
      if (!currentForwarder && localStorageService.get('forwarder') && localStorageService.get('forwarder').value) {
        currentForwarder = localStorageService.get('forwarder').value;
        if (currentForwarder.is_efp === true || currentForwarder.is_efp === 1 || currentForwarder.is_efp === '1') {
          currentForwarder.is_efp = true;
        } else if (currentForwarder.is_efp === false || currentForwarder.is_efp === 0 || currentForwarder.is_efp === '0') {
          currentForwarder.is_efp = false;
        }
      }

      if (currentForwarder) {
        selectForwarderQuietly(currentForwarder);
        // Own / non-EFP → fallback UI; real EFP → search enabled
        $rootScope.disableEfpSearchUi = !isEfpForwarder(currentForwarder);
      } else if (!vm.searchValue) {
        selectForwarderQuietly(ownForwarder);
        $rootScope.disableEfpSearchUi = true;
      }
    }

    function restoreForwarderSelection() {
      var ownId = getOwnForwarderId();
      vm.filterForwarder = ownId;
      $rootScope.forwarder_id = null;

      if (localStorageService.get('forwarder') && localStorageService.get('forwarder').value) {
        var stored = localStorageService.get('forwarder').value;
        vm.filterForwarder = stored.id;
        $rootScope.forwarder_id = stored.id === ownId ? null : stored.id;
        $rootScope.vendor_id = stored.vendor_id;
        var forwarder = vm.forwarderList.find(function (obj) { return obj.id === vm.filterForwarder; });
        if (!forwarder && !vm.searchValue) {
          if (stored.is_efp === true || stored.is_efp === 1 || stored.is_efp === '1') {
            stored.is_efp = true;
          } else if (stored.is_efp === false || stored.is_efp === 0 || stored.is_efp === '0') {
            stored.is_efp = false;
          }
          vm.forwarderList.push(stored);
        }
      }

      util.setImpersonatedDomain($rootScope.forwarder_id ? getSelectedForwarder() : null);
      vm._previousFilterForwarder = vm.filterForwarder;
    }

    function buildOwnForwarderRow() {
      var auth = localStorageService.get('authToken').value;
      var domain =
        (util.userProfile && util.userProfile.user && util.userProfile.user.domain) ||
        (auth && auth.domain) ||
        ($rootScope.domainData && $rootScope.domainData.domain_name) ||
        '';

      return {
        company_name: 'Own (FreightBro account)',
        id: auth.user_company_id,
        vendor_id: auth.vendor_id,
        domain: domain,
        is_own: true
      };
    }

    function getSelectedForwarder() {
      if (!vm.filterForwarder || !vm.forwarderList || !vm.forwarderList.length) {
        return null;
      }
      return vm.forwarderList.find(function (obj) {
        return obj.id === vm.filterForwarder;
      }) || null;
    }

    function getForwarderSelectedText() {
      var forwarder = getSelectedForwarder();
      if (!forwarder) {
        return 'Select forwarder';
      }
      return forwarder.company_name;
    }

    function getForwarderEfpLabel(forwarder) {
      if (!forwarder) {
        return '—';
      }

      if (forwarder.is_own) {
        var isOwnEfp =
          ($rootScope.domainData &&
            $rootScope.domainData.domain_info &&
            $rootScope.domainData.domain_info.IS_EFP_DOMAIN) ||
          false;

        return isOwnEfp ? 'Yes' : 'No';
      }

      if (forwarder.is_efp === true || forwarder.is_efp === 1 || forwarder.is_efp === '1') {
        return 'Yes';
      }

      if (forwarder.is_efp === false || forwarder.is_efp === 0 || forwarder.is_efp === '0') {
        return 'No';
      }

      return '—';
    }

    function onForwarderSelectOpen() {
      $timeout(function () {
        var panel = document.querySelector('.md-select-menu-container.forwarder-select-panel');
        if (!panel) {
          return;
        }
        var options = panel.querySelectorAll('md-option');
        angular.forEach(options, function (option) {
          option.style.height = 'auto';
          var textNode = option.querySelector('.md-text');
          if (textNode) {
            textNode.style.height = 'auto';
            textNode.style.whiteSpace = 'normal';
          }
        });
      }, 0);
    }

    function onForwarderSelectClose() {
      if (vm.searchValue) {
        vm.searchValue = null;
        getForwarderList();
      }
    }

    //get forwarder list
    function getForwarderList(){
      $rootScope.forwarder_id = null;

      vm.forwarderList = [buildOwnForwarderRow()];
      vm.listLoader = true;
      vm.forwarderSearchEmpty = false;
      ToolbarSerivice.getForwarder(vm.searchValue).then(function(response){
          var apiForwarders = (response.data.data || []).map(function(forwarder) {
            forwarder.is_efp =
              forwarder.is_efp === true ||
              forwarder.is_efp === 1 ||
              forwarder.is_efp === '1';

            return forwarder;
          });
          vm.forwarderList = [buildOwnForwarderRow()].concat(apiForwarders);
          vm.forwarderSearchEmpty = !!vm.searchValue && apiForwarders.length === 0;

          if (!vm.searchValue) {
            vm.hasEfpForwardersAvailable = apiForwarders.some(function (forwarder) {
              return !!forwarder.is_efp;
            });
            vm._forwarderListLoaded = true;
          }

          restoreForwarderSelection();

          if (isOnSearchPage()) {
            applySearchPageForwarderRules(apiForwarders);
          } else {
            $rootScope.disableEfpSearchUi = false;
          }

          vm.listLoader = false;
      },function(error){
          $log.log(error);
          vm.listLoader = false;
          vm.forwarderSearchEmpty = !!vm.searchValue;
      });
    }

    function getAllByForwarder(vendor_id){
      var forwarder = vm.forwarderList.find(function (obj) { return obj.id === vendor_id; });

      if (isOnSearchPage() && forwarder) {
        var isOwn = !!forwarder.is_own;
        // Block switching to a different non-EFP on /search; keep the current one
        if (!isEfpForwarder(forwarder) && !isOwn && forwarder.id !== vm._previousFilterForwarder) {
          vm.filterForwarder = vm._previousFilterForwarder;
          return;
        }
        // Own / non-EFP → fallback UI; only a real EFP forwarder enables search
        $rootScope.disableEfpSearchUi = isOwn || !isEfpForwarder(forwarder);
      } else if (!isOnSearchPage()) {
        $rootScope.disableEfpSearchUi = false;
      }

      appCache.removeAll();
      localStorageService.set('forwarder', forwarder);
      vm._previousFilterForwarder = vendor_id;
      $rootScope.vendor_id = forwarder ? forwarder.vendor_id : localStorageService.get('authToken').value.vendor_id;
        if(vendor_id == localStorageService.get('authToken').value.user_company_id){
            $rootScope.forwarder_id = null;
            util.setImpersonatedDomain(null);
        }else{
            $rootScope.forwarder_id = vendor_id;
            util.setImpersonatedDomain(forwarder);
        }

        if( $state.current.name == 'app.shipments.shipment_details' ){
            $state.go('app.shipments');
        }else if( $state.current.name == 'app.quotes.quotesDetails'){
            $state.go('app.quotes');
        }else if( $state.current.name == 'app.inquiry.inquiryDetails'){
            $state.go('app.inquiry');
        }else if($state.current.name == 'app.tariffDetails'){
          $state.go('app.tariffHeader');
        }else if($state.current.name == 'app.quoteListModule.quoteDetailsModule'){
          $state.go('app.quoteListModule');
        }else if($state.current.name == 'app.uploadRatesDetails'){
          $state.go('app.uploadRatesV2');
        }else if($state.current.name == 'app.enquiry.enquiryDetails'){
          $state.go('app.enquiry');
        }else if($state.current.name == 'app.bookingv2.bookingDetailsV2'){
          $state.go('app.bookingv2');
        }else if(
          $state.current.name === 'app.searchV2Module.fclEfpRates' ||
          $state.current.name === 'app.searchV2Module.lclEfpRates'
        ){
          $state.go('app.searchV2Module');
        }else if(util.isEfpEnabled && (
          $state.current.name === 'app.search.fclV2Rates' ||
          $state.current.name === 'app.search.lclResult' ||
          $state.current.name === 'app.search.result' ||
          $state.current.name === 'app.search.airResult'
        )){
          $state.go('app.searchV2Module');
        }else if(
          $state.current.name === 'app.search.fclV2Rates' ||
          $state.current.name === 'app.search.lclResult' ||
          $state.current.name === 'app.search.result' ||
          $state.current.name === 'app.search.airResult'
        ){
          $state.go('app.search');
        }else{
            $rootScope.$broadcast($state.current.name, { any: $state.current.name });
        }
    }
    
    function fnSearchForwarder(searchVal){
      vm.searchValue = searchVal;
      vm.getForwarderList();
    }
  }

})();

(function () {
    "use strict";

    angular
    .module("app.core")
    .controller("NoRatesInfoController",NoRatesInfoController);


    function NoRatesInfoController(mdPanelRef, $rootScope, $scope, $window, analytics){

        var vm = this;
        vm._mdPanelRef = mdPanelRef;

    }


   




})();
(function () {
  "use strict";

  angular
    .module('app.core')
    .component('multiSelectGroup', {
        templateUrl: 'app/main/component/multi-select-group/multi-select-group.html',
        bindings: {
          optionList : '<',
          selectedOptions : '=',
          callback : '&',
          viewLimit : "<",
          groupingOptions : '<',
          placeholderText : '<',
          isDisabled : '<',
          isError : '<',
          filterLoader:'<',
          pageSource : '<'
      },
        controller: MultiSelectGroupController
    });
  function MultiSelectGroupController(util,$mdSelect,$timeout) {

      var vm = this;
      vm.util = util;
      vm.getListBySearch = getListBySearch;
      vm.showMore = showMore;
      vm.getSelectedText = getSelectedText;
      vm.selectAllClicked = selectAllClicked;
      vm.sumbitData = sumbitData;
      vm.currentCatagory = '';
      vm.currentSelectedValue = '';
      vm.valueChanged = valueChanged;
      vm.showTooltip = false;
      vm.currentSearchText = '';
      vm.$mdSelect = $mdSelect;
      vm.carrierShimmer = true;
      vm.fnTrackEvent = fnTrackEvent;
      vm.searchtext = '';
      $timeout(function () {
        vm.carrierShimmer = false;
      }, 200);
      
      function getListBySearch(searchText){
        vm.currentSearchText = searchText;
        vm.fnTrackEvent('Carrier-Search-Change',{'SearchQuery':searchText})
        vm.callback({'payload' : {'searchText' : true,'searchTextValue':searchText}});
      }

      function getSelectedText(){
        if(vm.selectedOptions.length){
          if(vm.selectedOptions.length === 1){
            return vm.selectedOptions[0].name;
          }
          else{
            return vm.selectedOptions[0].name + " +"+( vm.selectedOptions.length-1 );
          }
        }
        else{
          return vm.placeholderText
        }        
      }
      
      function valueChanged(key,obj , type){
        if(!obj.disabled){
          vm.currentCatagory = key;
          vm.callback({'payload' : {'valueChange' : vm.selectedOptions , 'currentObj': obj , 'label':vm.currentCatagory}});
        }
      }

      function showMore(data){
        vm.callback({'payload' : {'showMore' : data,'currentSearchText':vm.currentSearchText}});
      }

      function selectAllClicked(data ,value , type){
        var mixpanelObj={
          "Value":value,
          "Type":type
        }
        vm.callback({'payload' : {'selectAll' : data}});
      }
      
      function sumbitData(){
        vm.searchtext = '';
        vm.showTooltip = false;
        vm.callback({'payload' : {'searchText' : true,'searchTextValue':''}});
        vm.$mdSelect.hide()
      }

      function fnTrackEvent(eventName , eventData){
        util.callMixpanel(vm.pageSource+'-'+eventName , eventData)

      }
  }
})();

(function () {
  "use strict";

  angular
    .module('app.core')
    .component('multiSelectChips', {
        templateUrl: 'app/main/component/multi-select-chips/multi-select-chips.html',
        bindings: {
          optionsDataObj:'<',
          queryConditions :'<',
          mdInputId: '<',
          pageSource: '<',
          callback : '&',
        
      },
        controller: MultiSelectChipsController
    });
  function MultiSelectChipsController($mdSelect,$scope,$rootScope,util) {
      var vm = this;

      //variables define
      vm.util=util;
      vm.optionsListData = null;
      vm.queryConditions = null;
      vm.displayGroupObj = null;
      vm.groupSelectedOption = null;
      vm.mdSelect = $mdSelect;
      vm.isUpdateState = false;
      vm.isMixpanelDone = false;
      vm.fnTrackAnalytics = fnTrackAnalytics;
      //methods define
      vm.getListBySearch = getListBySearch;
      vm.fnSaveSelectedOptions = fnSaveSelectedOptions;
      vm.searchTitleHighlight = searchTitleHighlight;
      vm.fnRemoveChips = fnRemoveChips;
      
      
      vm.$onChanges = function() {
        //vm.isUpdateState = false;
        vm.queryConditions.selectedCount = vm.queryConditions.selectedOptions.length;
        vm.isGroupOptions = vm.queryConditions.isGroupOptions;
        vm.totalListCount = 0;

        // it's for display grouping option 
        if(vm.optionsDataObj && vm.optionsDataObj !== null && vm.isGroupOptions === true){ 
          vm.optionsListData = vm.optionsDataObj;
          vm.groupsObj = vm.queryConditions.groupList;
          angular.forEach(vm.groupsObj,function(item,key){
            vm.totalListCount += vm.optionsListData[key].length;
          })
        }
        
        // it's for display single list option
        if(vm.optionsDataObj && vm.optionsDataObj !== null && vm.isGroupOptions === false){  
          vm.groupsObj = {
            'customIndex' : vm.queryConditions.groupList
          };
          vm.optionsListData = {
            'customIndex' : vm.optionsDataObj
          };
          vm.totalListCount = vm.optionsDataObj.length;
        } 
      }

      //  save selected options list
      function fnSaveSelectedOptions(){
        //To prevent done mixpanel event trigger again for remove chip
        if(vm.isMixpanelDone){
         
          vm.isMixpanelDone = !vm.isMixpanelDone;
        }
        if(vm.isUpdateState === true){
          vm.isUpdateState = false;
          vm.queryConditions.selectedCount = vm.queryConditions.selectedOptions.length;
          vm.callback({'payload' : {'selectedOptions' : vm.queryConditions.selectedOptions}});
        }
        $mdSelect.hide();
      }

      // function to get options list by search text
      function getListBySearch(searchText){
        vm.optionsListData = null;
        vm.callback({'payload' : {'searchText' : searchText}});
      }
      
      // it's search text highlight from options list 
      function searchTitleHighlight(text,option){
        var titleText =  text +' '+(option.last_name ? option.last_name : '');
        return util.searchHighlight(titleText,vm.searchtext);
      }

      

      // remove chips tags for selected options list
      function fnRemoveChips(removedData){
        vm.isUpdateState = true;
        vm.isMixpanelDone=true;
        vm.fnSaveSelectedOptions();
      }
      function fnTrackAnalytics(event,params){
        if(vm.pageSource){
          if(!params){
            params = {};
          }
          util.callMixpanel(vm.pageSource+'-'+event,params);
        }     
      }

      $scope.$watch('$ctrl.queryConditions.selectedOptions', function(data) {
        //vm.isUpdateState = true;
      });
      $rootScope.$on('resetFilter', function(event, args) {
        vm.searchtext = '';
      });
  }
})();

(function () {
  "use strict";

  angular
    .module('app.core')
    .component('multiSelect', {
        templateUrl: 'app/main/component/multi-select/multi-select.html',
        bindings: {
          optionsDataObj:'<',
          queryConditions :'<',
          mdInputId: '<',
          callback : '&',
        
      },
        controller: MultiSelectController
    });
  function MultiSelectController($mdSelect,$scope,$rootScope,analytics,util) {
      var vm = this;
      vm.util = util;
      //variables define
      vm.optionsListData = null;
      vm.queryConditions = null;
      vm.displayGroupObj = null;
      vm.groupSelectedOption = null;
      vm.mdSelect = $mdSelect;
      vm.isUpdateState = false;

      //methods define
      vm.getListBySearch = getListBySearch;
      vm.fnSaveSelectedOptions = fnSaveSelectedOptions;
      vm.searchTitleHighlight = searchTitleHighlight;
      vm.fnRemoveChips = fnRemoveChips;
      vm.fnClearFilter = fnClearFilter;
      vm.fnSelectAll = fnSelectAll;


      vm.$onChanges = function() {
        //vm.isUpdateState = false;
        vm.queryConditions.selectedCount = vm.queryConditions.selectedOptions.length;
        vm.isGroupOptions = vm.queryConditions.isGroupOptions;
        vm.totalListCount = 0;

        // it's for display grouping option 
        if(vm.optionsDataObj && vm.optionsDataObj !== null && vm.isGroupOptions === true){ 
          vm.optionsListData = vm.optionsDataObj;
          vm.groupsObj = vm.queryConditions.groupList;
          angular.forEach(vm.groupsObj,function(item,key){
            vm.totalListCount += vm.optionsListData[key].length;
          })
        }
        
        // it's for display single list option
        if(vm.optionsDataObj && vm.optionsDataObj !== null && vm.isGroupOptions === false){  
          vm.groupsObj = {
            'customIndex' : vm.queryConditions.groupList
          };
          vm.optionsListData = {
            'customIndex' : vm.optionsDataObj
          };
          vm.totalListCount = vm.optionsDataObj.length;
        } 
      }

      //  save selected options list
      function fnSaveSelectedOptions(){
        if(vm.isUpdateState === true){
          vm.isUpdateState = false;
          vm.queryConditions.selectedCount = vm.queryConditions.selectedOptions.length;
          vm.callback({'payload' : {'selectedOptions' : vm.queryConditions.selectedOptions}});
        }
        $mdSelect.hide();
      }

      // function to get options list by search text
      function getListBySearch(searchText){
        vm.optionsListData = null;
        vm.callback({'payload' : {'searchText' : searchText}});
      }
      
      // it's search text highlight from options list 
      function searchTitleHighlight(text,option){
        var titleText =  text +' '+(option.last_name ? option.last_name : '');
        return util.searchHighlight(titleText,vm.searchtext);
      }


      // remove chips tags for selected options list
      function fnRemoveChips(){
        vm.isUpdateState = true;
        vm.fnSaveSelectedOptions();
      }
      $scope.$watch('$ctrl.queryConditions.selectedOptions', function(data) {
        //vm.isUpdateState = true;
      });
      $rootScope.$on('resetFilter', function(event, args) {
        vm.searchtext = '';
      });

      function fnClearFilter(){
        vm.isUpdateState = true;
        vm.queryConditions.selectedOptions = [];
      }

      function fnSelectAll(){
        vm.isUpdateState = true;
        vm.queryConditions.selectedOptions = vm.optionsDataObj;
      }
  }
})();

(function () {
    'use strict';

    angular
    .module('app.core')
    .component('matchRates', {
        templateUrl: 'app/main/component/match-my-rates/match-rates.html',
        bindings : {
            matchratesparam : '=',
            inquirydata : '=',
            pageSource : '=',
            callback : '&'
        },
        controller: MatchMyRatesController
    });


    function MatchMyRatesController(util,$rootScope, $scope,SearchService, resultService,shareQuoteService, InquiryService, $mdDialog, $log, $filter, $state) {
        var vm = this;

        vm.util = util;
        vm.submitMatchRates = submitMatchRates;
        vm.closeDialog = closeDialog;
        vm.makeDetailBoxString=makeDetailBoxString;
        vm.shareQuoteService=shareQuoteService
        vm.getCurrencyList = getCurrencyList;
        vm.getSubVendorList = getSubVendorList;
        vm.getAirlineList = getAirlineList;
        vm.getTargetValue = getTargetValue;
        vm.inquirySuccessErrorModal = inquirySuccessErrorModal;
        vm.fnInquiryDone = fnInquiryDone;
        vm.fnGoToInquiry = fnGoToInquiry;
        vm.selectFile=selectFile;
        vm.setFile=setFile;
        vm.IMCO_CodeList = util.imcoCodeList();
        vm.fnTrackAnalytics=fnTrackAnalytics;
        vm.isWlsUser = false;
        vm.startDateStart = new Date();
        vm.expiryDateStart = new Date();
        vm.currentState = $state.current.name;
        vm.msdsfile = {
            'name' : ''
        };
        vm.otherDocument = {
            'name' : ''
        };

        vm.currencyList = [];
        vm.getSubvendor = [];
        vm.isWebView = util.isWebView();
        vm.quoteRate = 'Rate';
      
        this.$onInit = function() {
        // function init(){
            vm.showErrorMsg = false;
            vm.carrier_preference = null;
            vm.airline_preference = null;
            vm.isInquiryOrQuote = false;
            vm.validationObj={
            "reasonValidation": false,
            "imcoValidationError": false,
            "msdsValidationError": false,
            "targetValidation":false,
            "sailingValidation": false
        }
            vm.mode = vm.matchratesparam.search_param.mode;

            vm.quote_number = vm.inquirydata? vm.inquirydata.quote_number : (vm.matchratesparam.quote_number ? vm.matchratesparam.quote_number : 'NA');
            vm.mixpanelSearchParam = vm.mode=='SEA-FCL' ? SearchService.getFclLoadDetails(vm.matchratesparam.search_param.load_data.load_details_value) : vm.matchratesparam.search_param.load_data.load_meta.chargeable_weight + ' Kgs';

            vm.matchRatesObj = {
                "data": {
                        "carrier_preference": [],
                        "airline_preference": [],
                        "preferred_sailing_date": new Date(new Date().getTime() + (7 * 24 * 60 * 60 * 1000)),
                        "reason_for_revising": "",
                        "target_load_data": null,
                        "additional_charges" : vm.matchratesparam.additional_charges,
                        "req_commodity_data":[],
                        "destination_charges":vm.matchratesparam.search_param.destination_charges,
                        "destination_customs":vm.matchratesparam.search_param.destination_customs,
                        "origin_customs":vm.matchratesparam.search_param.origin_customs,
                        "origin_charges":vm.matchratesparam.search_param.origin_charges
                }
            };


            if( util.solution_type === 'WLS' ){
                vm.isWlsUser = true;
                vm.fontExtraBold = 'font-weight-900';
                vm.headingFont = 'font-weight-900';
                vm.fontBold = 'font-weight-600';
            }else{
                vm.isWlsUser = false;
                vm.fontExtraBold = 'Font-ExtraBold';
                vm.headingFont = 'Font-Bold';
                vm.fontBold = 'Font-Bold';
            }

            if(vm.currentState === 'app.inquiry.inquiryDetails'){
                vm.isInquiryOrQuote = true;
                vm.matchRatesObj.data["inquiry_id"] = vm.matchratesparam.id;
                vm.getTargetValue(vm.matchratesparam.search_param.load_data);
            }else{

                if(vm.currentState === 'app.quotes.quotesDetails' || vm.currentState === 'app.webViewQuotesDetails'){
                    vm.matchRatesObj.data["quote_id"] = vm.matchratesparam.id;
                    vm.isInquiryOrQuote = true;
                    vm.quoteRate = 'Quote';
                }else{
                    vm.matchRatesObj.data["search_id"] = vm.matchratesparam.id;
                    if (vm.matchratesparam.match_rates && Object.keys(vm.matchratesparam.match_rates).length) {
                        vm.showSuccessMsg = true;
                    } else {
                        vm.showSuccessMsg = false;
                    }
                }


                vm.getTargetValue(vm.matchratesparam.search_param.load_data);

            }

            vm.getCurrencyList();
            if(vm.mode !='AIR'){
                vm.getSubVendorList();
            }else if(vm.mode == 'AIR'){
                vm.getAirlineList();
            }
            vm.makeDetailBoxString();
            if(vm.matchratesparam.search_param.hazardous_material){
                vm.matchRatesObj.data.req_cargo_type_data={"name":"Hazardous","code":"HAZARDOUS"};
            }
        }
        // init();

        function getTargetValue(loadData){
            if(vm.mode == 'SEA-FCL'){
                for (var i = 0; i < loadData.load_details_value.length; i++) {
                    loadData.load_details_value[i]["target_rate"] = "";
                    loadData.load_details_value[i]["target_rate_currency"] = "USD";
                }
            }else{
                loadData.load_meta["target_rate"] = "";
                loadData.load_meta["target_rate_currency"] = (vm.mode == 'AIR') ? vm.util.userProfile.user.user_base_currency : "USD";
                loadData.load_meta["target_rate_basis"] = (vm.mode == 'AIR') ? "per_KGs" : 'per_W/M';
            }
            vm.matchRatesObj.data["target_load_data"] = angular.copy(loadData);
        }

        function getCurrencyList(){
            if(!util.currencyList.length){
                util.getCurrencyList().then(function(response){
                  vm.currencyList = util.currencyList;
                },function(error){
                    vm.currencyList = [];
                    $log.log(error);
                });
            }else{
                vm.currencyList = util.currencyList;
            }
        }

        function getSubVendorList(){
            if(!util.getSubvendor.length){
                resultService.getSubVendor().then(function(response){
                    angular.forEach(response.data.subvendor_data, function(item){
                        if(item.carrier_code != null && item.carrier_code != ""){
                            vm.getSubvendor.push(item);
                            util.getSubvendor = angular.copy(vm.getSubvendor);
                        }
                    });
                },function(error){
                    vm.getSubvendor = [];
                    util.getSubvendor = [];
                });
            }else{
                vm.getSubvendor = angular.copy(util.getSubvendor);
            }
        }

        function getAirlineList(){
            if(!util.getAirline.length){
                resultService.getAirlineData().then(function(response){
                    vm.getAirline = response.data.data;
                    util.getAirline = angular.copy(vm.getAirline);
                },function(error){
                    vm.getAirline = [];
                    util.getAirline = [];
                });
            }else{
                vm.getAirline = angular.copy(util.getAirline);
            }
        }
        function makeDetailBoxString() {
            vm.detailBoxString = ((vm.matchRatesObj.data.origin_charges ? 'Origin, ' : '') + (vm.matchRatesObj.data.origin_customs ? 'Origin Custom, ' : '') +(vm.matchRatesObj.data.destination_charges ? 'Destination, ' : '') + (vm.matchRatesObj.data.destination_customs ? 'Destination Custom, ' : '')) || 'Select Charges';
      
            vm.detailBoxTooltip = ((vm.matchRatesObj.data.origin_charges ? 'Origin\n' : '') + (vm.matchRatesObj.data.origin_customs ? 'Origin Custom\n ' : '')+(vm.matchRatesObj.data.destination_charges ? 'Destination\n' : '') + (vm.matchRatesObj.data.destination_customs ? 'Destination Custom\n' : '') ) || 'Select Charges';
            vm.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;
      
          }

          function selectFile(action) {
            if(action == 'msds'){
                document.getElementById('fileInput_msds').click();
                // angular.element(document.querySelector('#fileInput_msds')).click();
            }else{
                document.getElementById('fileInput_all').click();
                // angular.element(document.querySelector('#fileInput_all')).click();
            }
        }
        function setFile(file, action){
            if(action == 'msds'){
                vm.msdsfile = file;
                vm.msdsProgress = true;
            }else{
                vm.otherDocument = file;
                vm.otherProgress = true;
            }

            if(file != null){
                vm.matchBtn = true;
                var form = new FormData();
                form.append("upload", file);

                resultService.fnSendRfqFile( vm.matchratesparam.id,form).then(function(response){
                    vm.matchBtn = false;
                    response = JSON.parse(response);
                    if(action == 'msds'){
                        vm.msdsfile["url"] = response.url;
                    }else{
                        vm.otherDocument["url"] = response.url;
                    }
                    vm.msdsProgress = false;
                    vm.otherProgress = false;
                    $scope.$apply();
                },function(error){
                    $log.error(error);
                    vm.msdsProgress = false;
                    vm.otherProgress = false;
                    vm.matchBtn = false;
                });
            }else{
                vm.msdsProgress = false;
                vm.otherProgress = false;
            }
        }
        function submitMatchRates(form){
            if(!vm.matchRatesObj.data.reason_for_revising){
                vm.validationObj.reasonValidation=true;
            }
            if(vm.mode !== 'SEA-FCL' && !vm.matchRatesObj.data.target_load_data.load_meta.target_rate){
                vm.validationObj.targetValidation=true;

            }
            if(!vm.matchRatesObj.data.preferred_sailing_date){
                vm.validationObj.sailingValidation=true;  

            }
            if(vm.matchratesparam.search_param.hazardous_material) {
                if(!vm.matchRatesObj.data.imco_code){
                    vm.validationObj.imcoValidationError = true;
                }
                if(vm.msdsfile == null || vm.msdsfile.name == ""  ){
                    vm.validationObj.msdsValidationError = true;
                }
            }
            if(vm.validationObj.reasonValidation ||   vm.validationObj.imcoValidationError  ||  vm.validationObj.msdsValidationError || vm.validationObj.targetValidation || vm.validationObj.sailingValidation || form.$invalid){
                return
            }

            // form match rates object for mixpanel
            var mixpanelObjToSend = {
                "Load Details":vm.mode == 'SEA-FCL' ? util.formLoadDetails(vm.matchratesparam.search_param.load_data) : util.formAirLoadDetails(vm.matchratesparam.search_param.load_data,vm.mode),
                "Preferred Carrier":vm.carrier_preference ? vm.carrier_preference.name : '',
                "Sailing date":vm.matchRatesObj.data.preferred_sailing_date ? $filter('date')(vm.matchRatesObj.data.preferred_sailing_date, 'd MMM yyyy') : ''
            }

            if(vm.mode == 'SEA-FCL'){
                for (var i = 0; i < vm.matchRatesObj.data.target_load_data.load_details_value.length; i++) {
                    vm.text = "Target Price Given("+vm.matchRatesObj.data.target_load_data.load_details_value[i].type+")";
                    mixpanelObjToSend[''+vm.text] = vm.matchRatesObj.data.target_load_data.load_details_value[i].target_rate+ " " +vm.matchRatesObj.data.target_load_data.load_details_value[i].target_rate_currency;
                    delete vm.matchRatesObj.data.target_load_data.load_details_value[i]['$$hashKey'];
                }
            }
           

            vm.matchRatesObj.data.files=[];
            if( vm.msdsfile != null && vm.msdsfile.name != "" ){
                vm.matchRatesObj.data.files.push(
                    {
                    "ref_name": "MSDS",
                    "url": vm.msdsfile.url,
                    "file_name": vm.msdsfile.name
                    }
                );
            }
            if( vm.otherDocument != null && vm.otherDocument.name != "" ){
                vm.matchRatesObj.data.files.push(
                    {
                    "ref_name": "other",
                    "url": vm.otherDocument.url,
                    "file_name": vm.otherDocument.name
                    }
                );
            }

            // if(vm.carrier_preference){
            //     vm.matchRatesObj.data.carrier_preference = [{
            //         "carrier_code" : vm.carrier_preference.carrier_code,
            //         "logo" : vm.carrier_preference.logo,
            //         "name" : vm.carrier_preference.name
            //     }];

            // }

            // if(vm.airline_preference){
            //     vm.matchRatesObj.data.airline_preference = [{
            //         "airline_code" : vm.airline_preference.airline_code,
            //         "airline_prefix" : vm.airline_preference.airline_prefix,
            //         "air_line_name" : vm.airline_preference.air_line_name
            //     }];
            // }
            vm.matchRatesObj.data.req_commodity_data = vm.shareQuoteService.commodityString(vm.matchRatesObj.data.req_commodity_data);

            vm.matchBtn = true;
            util.isCallingApi = true;
            
            if(vm.currentState === 'app.inquiry.inquiryDetails'){

                var data = {
                    "data": {
                        "current_status": {
                            "status": InquiryService.statusCondition,
                            "description": "",
                            "color_code": "#42a9e0",
                            "comment": "",
                            "created_on" : new Date(),
                            "user": {
                                "id": util.userProfile.user.id,
                                "email": util.userProfile.user.email,
                                "user_mobile": util.userProfile.user.user_mobile,
                                "user_first_name": util.userProfile.user.user_first_name,
                                "user_last_name": util.userProfile.user.user_last_name
                            }
                        },
                        "activity": {
                            "meta" : vm.matchRatesObj.data,
                            "cards": [],
                            "message": "has requested for better rates",
                            "timestamp": new Date(),
                            "quote_number": vm.inquirydata.quote_number,
                            "quote_id": vm.inquirydata.quote_id,
                            "shipment_number": vm.inquirydata.shipment_number,
                            "shipment_id": vm.inquirydata.shipment_id,
                            "inquiry_from": "INQUIRY",
                            "inquiry_trigger": "",
                            "activity_type": "MMR",
                            "user": util.userProfile.user
                        },
                        "additional_charges" : vm.matchratesparam.additional_charges
                    }
                }
                InquiryService.updateInquiry(vm.matchratesparam.id, data).then(function (response) {
                    vm.matchBtn = false;
                    util.isCallingApi = false;
                    vm.showSuccessMsg = true;
                    vm.showErrorMsg = false;
                    //mixpanel code
                    if(vm.mode == 'SEA-FCL' && util.solution_type === 'NWLS'){
                        mixpanelObjToSend['Customer Request'] = 'Success';
                    }

                    var responseData = {
                        "_id" : response.data.data.activity_detail._id,
                        "link": response.data.data.link,
                        "data" : response.data.data.activity_detail
                    }
                    vm.inquiryMatchResponse = angular.copy(responseData);
                    resultService.trackMixPanelForInquiry(vm.inquirydata,vm.matchratesparam.search_param,'MMR',vm.quote_number,vm.mixpanelSearchParam);

                }, function (error) {
                    $log.error(error);
                    vm.matchBtn = false;
                    util.isCallingApi = false;
                    vm.showSuccessMsg = false;
                    vm.showErrorMsg = true;
                    //mixpanel code for failed request
                    if(vm.mode == 'SEA-FCL' && util.solution_type === 'NWLS'){
                        mixpanelObjToSend['Customer Request'] = 'Failed';
                    }
                });

            }else{

                resultService.matchRates( vm.matchRatesObj ).then(function(response){
                    if(vm.isWlsUser){
                        $mdDialog.hide().then(function() {
                            vm.inquirySuccessErrorModal('success', response.data);
                            vm.matchBtn = false;
                            util.isCallingApi = false;
                            vm.showSuccessMsg = true;
                            vm.showErrorMsg = false;
                        });
                    }else{
                        //mixpanel code
                        if(vm.mode == 'SEA-FCL'){
                            mixpanelObjToSend['Customer Request'] = 'Success';
                        }
                        vm.matchBtn = false;
                        util.isCallingApi = false;
                        vm.showSuccessMsg = true;
                        vm.showErrorMsg = false;
                    }
                    resultService.trackMixPanelForInquiry(vm.inquirydata,vm.matchratesparam.search_param,'MMR',vm.quote_number,vm.mixpanelSearchParam);
                },function(error){

                    $log.error(error);
                    vm.matchBtn = false;
                    util.isCallingApi = false;
                    vm.showSuccessMsg = false;
                    vm.showErrorMsg = true;
                    util.showToast(util.displayValidationError(error));
                    //mixpanel code for failed request
                    if(vm.mode == 'SEA-FCL' && util.solution_type === 'NWLS'){
                        mixpanelObjToSend['Customer Request'] = 'Failed';
                    }
                });
            }
        }

        vm.fnSuccessDone = fnSuccessDone
        function fnSuccessDone(){
            vm.closeDialog();
            vm.callback({data : {'response' : vm.inquiryMatchResponse, 'action' : 'matchRatesDone' }});
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function inquirySuccessErrorModal(action,data, ev){

            vm.inquiryValue = data.data;

            vm.inquryDone = (action == 'success') ? true : false;

            $mdDialog.show({
                templateUrl: 'app/main/search/views/inquiry-modals/inquiry-modal.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm },
                onRemoving: vm.cancelEdit
            });
        }

        function fnInquiryDone(){
            vm.fnTrackAnalytics('BackToSearch-Click');
            $mdDialog.hide().then(function() {
                util.showToast(util.displayValidationError('Redirecting to search page.'));
                $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
            });
        }


        function fnGoToInquiry(id){
            vm.fnTrackAnalytics('BackToEnquiry-Click');
            $mdDialog.hide().then(function() {
                util.showToast(util.displayValidationError('Redirecting to enquiry page.'));
                if(util.isShipper){
                    $state.go('app.inquiry');
                }else{
                    $state.go('app.inquiry.inquiryDetails',{ id: id });
                }
            });
        }
        $rootScope.$on("$mdMenuClose", function() {
            vm.makeDetailBoxString();
          });
     function fnTrackAnalytics(event,params){
            if(!params){
                params={};
            }
            util.callMixpanel(vm.pageSource+'-'+event,params);
        }
    }

})();

(function () {
    "use strict";
    angular
      .module('app.core')
      .component('loadWiseFreeDays', {
          templateUrl: 'app/main/component/load-wise-free-days/load-wise-free-days.html',
          bindings: {
            rateObj:'<',
            searchParam: '<',
            isError: '<',
            isEdit : '<',
            loadWiseFreeDaysList : '=',
            pageSource:'='
          },
         controller: LoadWiseFreeDaysController
    });
    function LoadWiseFreeDaysController(util) {

      // variables
        var vm = this;
        vm.util = util;
        vm.loadWiseFreeDaysList = [];
        vm.loadArray = [];
        vm.disableAddIcon = false;
        vm.showNotAvailable = false;
        vm.freeDaysObj =  {
            "id" : (Math.floor(Math.random() * 90000) + 10000),
            "origin": {
                "demurrage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "detention": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "combined": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "storage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "demurageAndStorage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "combinedAndStorage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                
            },
            "destination": {
                "demurrage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "detention": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "combined": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "storage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "demurageAndStorage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                ,
                "combinedAndStorage": 
                    {
                        
                        "freeDays": null,
                        
                        "freeDaysType": "",
                        
                    }
                
            }
        }; 
        vm.freeDaysTypeOptions = [
            {
                name: '--Select Type--',
                value: ''
            },
            {
                name: 'Business Days (B)',
                value: 'Business'
            },
            {
                name: 'Calendar Days (C)',
                value: 'Calendar'
            }
        ];
        
      // methods
      vm.loadFilter = loadFilter;
      vm.fnRemoveLoad = fnRemoveLoad;
      vm.fnAddLoad = fnAddLoad;
      vm.dndValidation = dndValidation;
      vm.fnRemoveLoadError = fnRemoveLoadError;
      vm.formatFreeDaysEvent = formatFreeDaysEvent;

      this.$onInit = function(){
       // load from search param
        vm.searchParam.load_data.load_details_value.forEach(function(load){
            vm.loadArray.push(load.type);
        });

      if(!vm.rateObj.freeDays ){
        vm.rateObj.freeDays = fbUtils.FreeDays.transform({'detention_details':vm.rateObj.detention_details,'demurrage_details':vm.rateObj.demurrage_details,'combined_details':vm.rateObj.combined_details})['freeDays'];
      }
         var structuredFreeDays = vm.util.fnSetFreeDays(vm.rateObj , vm.loadWiseFreeDaysList , vm.freeDaysObj , vm.loadArray , 'rateCard');
         vm.loadWiseFreeDaysList = structuredFreeDays.loadWiseFreeDaysList;
         vm.loadArray = structuredFreeDays.loadArray;
         
         vm.showNotAvailable = (!vm.loadWiseFreeDaysList[0].loadType && !vm.isEdit);
        if(vm.loadArray.length >1){
            vm.loadArray.unshift('All');
        }
        vm.disableAddIcon = (vm.loadWiseFreeDaysList .length == (vm.loadArray.includes('All')? vm.loadArray.length -1 : vm.loadArray.length)) ? true : false;
        var route = [
          { 'key': 'origin', 'title': 'Origin' },
          { 'key': 'destination', 'title': 'Destination' }
        ];      
         vm.DnD = [
          { 'key': 'detention', 'title': 'Detention' },
          { 'key': 'demurrage', 'title': 'Demurrage' },
          { 'key': 'storage', 'title': 'Storage' },
          { 'key': 'demurageAndStorage', 'title': 'Demurrage with Storage' },
          { 'key': 'combined', 'title': 'Combined D&D' },
          { 'key': 'combinedAndStorage', 'title': 'Combined D&D  with Storage' }
  
        ]; 
        
      }

      // function to disable selected load type option
      function loadFilter(loadFromArray, activeLoad) {
        var found = false;
        vm.loadWiseFreeDaysList.some(function (load) {
          if ((load.loadType === loadFromArray && load.loadType !== activeLoad) || (loadFromArray == 'All' && vm.loadWiseFreeDaysList.length >1)) {
            found = true
            return true;
          }
        });
  
        if (found) {
          return true;
        } else {
          return false;
        }
      }

      // removing error while changing/Adding load
      function fnRemoveLoadError( id){
        if(angular.element('.' + id  + '_loadErrorBorder')){
            angular.element('.' + id  +'_loadErrorBorder').removeClass("error-border");
            angular.element('.' + id  +'_loadErrorText').removeClass("error-text");
        }
      }

      function fnRemoveLoad(index , id){
        vm.trackEvent('RemoveLoad-Click');
        //  reset the first index free days when clicking remove
        if (vm.loadWiseFreeDaysList.length === 1) {
            if(angular.element('.' + id  + '_loadErrorBorder')){
                angular.element('.' + id  +'_loadErrorBorder').removeClass("error-border");
                angular.element('.' + id  +'_loadErrorText').removeClass("error-text");
            }
            vm.loadWiseFreeDaysList = [];
            vm.loadWiseFreeDaysList.push(angular.copy(vm.freeDaysObj));
            
            return;
          }
          vm.loadWiseFreeDaysList.splice(index, 1);
          vm.disableAddIcon = false;


      }

      function fnAddLoad(loadType){
        if(loadType == 'All' || vm.loadArray.length == 1 || vm.disableAddIcon){
            return;
        }
        vm.freeDaysObj.id = (Math.floor(Math.random() * 90000) + 10000);
        vm.loadWiseFreeDaysList.push(angular.copy(vm.freeDaysObj));
        vm.disableAddIcon = (vm.loadWiseFreeDaysList .length == (vm.loadArray.includes('All')? vm.loadArray.length -1 : vm.loadArray.length)) ? true : false;     }

      function dndValidation(value){
        var isError = false;
        if((value > 99 || value<1) && value!=null){
           isError = true;
        }
        return isError;
      }
      function formatFreeDaysEvent(route,key,type,value){
        key = key.charAt(0).toUpperCase() + key.slice(1);
      }
       
    }


})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('loadSelect', {
      templateUrl: 'app/main/component/load-selector/load-select.html',
      bindings: {
        loadobjects: '<',
        resetLoadObj: '&',
        loadlist: '<',
        type:'=',
        callback : '&',
        mode: '<'
      },
      controller: LoadSelectController
    });


  function LoadSelectController(util,$state) {

    var vm = this;
    vm.util = util;
    
    // Object declarations
    vm.emptyLoad = {
      'type': '',
      'count': 1,
      'bl_qty': 1,
      'sbl_qty': 1,
      'max_weight': '',
      'weight_qty': 20000,
      'weight_unit': 'KGs',
      'max_volume': ''
    };

    

    // Declare functions for template
    vm.addLoad = addLoad;
    vm.removeLoad = removeLoad;
    vm.resetLoad = resetLoad;
    vm.loadFilter = loadFilter;
    vm.closePanel = closePanel;
    vm.trackEvent = trackEvent;
    vm.loadTypeObject = {};
    vm.showLoadMaxErr = false;
  // variables

    
    this.$onInit = function(){
      vm.pageSource = vm.type ? vm.type :'QC';
      vm.showLoadMaxErr =
        vm.mode === "SEA-FCL" &&
        ($state.current.name == "app.search.result" ||
          $state.current.name == "app.searchV2Module" || $state.current.name == "app.search");
      vm.loadTypeObject = vm.loadlist.reduce(function(acc, current) {
        acc[current.load_code] = current;
        return acc;
      }, {});
    }

    function addLoad() {
      vm.loadobjects[vm.loadobjects.length] = angular.copy(vm.emptyLoad);
    }

    function removeLoad(index) {
      if (vm.loadobjects.length === 1) {
        return;
      }
      vm.loadobjects.splice(index, 1);
    }

    function resetLoad() {
      vm.resetLoadObj();
    }

    function loadFilter(e, activeLoad) {
      var found = false;
      vm.loadobjects.some(function (i) {
        if (vm.mode=='SEA-FCL'){
             if (i.type === e.load_code && i.type !== activeLoad) {
               found = true;
               return true;
             }
        }
        else{
           if (i.type === e.code && i.type !== activeLoad) {
             found = true;
             return true;
           }
        }
         
      });

      if (found) {
        return true;
      } else {
        return false;
      }
    }

    function trackEvent(eventName, data) {
      util.callMixpanel(eventName, {
        Mode: vm.mode,
        Page: vm.type ? "Instant Rates" : "Create Quote"
      });
    }
    function closePanel(data) {
      vm.callback();
    }
    
  }

})();

(function () {
  "use strict";

  angular
    .module("app.core")
    .controller("LoadWrapperController", LoadWrapperController)
    .factory("loadDataFactory", function () {
      return {loadData: {}, panelClosed: false};
    });

  function LoadWrapperController(mdPanelRef, loadDataFactory) {
    var vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.closePanel = closePanel;
    vm.resetLoad = resetLoad;
    vm.loadArray = loadDataFactory.loadData;

    // Variable Declaration
    vm.loadDataFactory = loadDataFactory;

    // Declare functions for template
    function closePanel() {
      vm._mdPanelRef && vm._mdPanelRef.close();
    }

    function resetLoad() {
      loadDataFactory.loadData = vm.loadArray = angular.copy(vm.resetLoadObj);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('LoadDetailController', LoadDetailController);


  function LoadDetailController(mdPanelRef, util,SearchService,$rootScope, $scope) {

    var vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.util=util;

    if (!vm.searchParam.stuffing) {
      vm.searchParam.stuffing = 'F';
    }

    // Object declarations

    // Declare functions for template
    vm.closePanel = closePanel;
    vm.addLoad = addLoad;
    vm.removeLoad = SearchService.airLcl_remove_load;
    vm.decimalFormatter = SearchService.setThreeNumberDecimal;
    vm.setLoadDetailValidity = setLoadDetailValidity;
    // need to optimize this in connversion details 
    vm.measurementSystem=$rootScope.metric_system;
    vm.weightUnit = $rootScope.domainData.domain_info.WEIGHT_UNIT;

    vm.pageSource = vm.type ? vm.type : 'QC';
    function addLoad(){
      
      SearchService.airLcl_add_load(vm.searchParam.load_data.load_details_value);
      setTimeout(function () {
        var myDiv = document.getElementsByClassName("load-units");
        myDiv[0].scrollTop = myDiv[0].scrollHeight;
      }, 50);
    }

    function closePanel(action) {
      if(vm.page == 'shipment'){
        vm.searchParam.isLoadSubmit = (action == 'done') ? true : false;
        if(vm.searchParam.isLoadSubmit){
          setLoadDetailValidity();   // check if load details validation
          if(vm.searchForm.$error.loadDetailError){
            return true;
          }
        }
      }
      
      
      vm._mdPanelRef && vm._mdPanelRef.close();
    }

    $scope.$watch('ctrl.searchParam.load_data', function () {
      vm.searchParam.load_data = (vm.searchParam.mode === 'AIR' ? SearchService.calculateAirLoad(vm.searchParam.load_data) : SearchService.calculateLclLoad(vm.searchParam.load_data));
      vm.convertedLoad = vm.util.metricSystemConversion(vm.searchParam.mode, vm.searchParam.load_data);
    }, true);
    

    // AIR LCL load details validation
    function setLoadDetailValidity() {
      if ((vm.searchParam.load_data.load_type === 'total_shipment' && (!vm.searchParam.load_data.load_meta.total_qty || !vm.searchParam.load_data.load_meta.total_volume || !vm.searchParam.load_data.load_meta.total_weight)) || (vm.searchParam.load_data.load_type === 'units' && unitLoadHasError())) {
        vm.searchForm.$error.loadDetailError = true;
      } else if (vm.searchForm.$error.loadDetailError) {
        delete vm.searchForm.$error.loadDetailError;
      }

      function unitLoadHasError() {
        return vm.searchParam.load_data.load_details_value.some(function (load) {
          return !load.breadth || !load.height || !load.length || !load.qty || !load.weight;
        });
      }
    }
  }


})();

(function () {
    "use strict";

    angular
    .module("app.core")
    .controller("LoadAliasController",LoadAliasController);


    function LoadAliasController(mdPanelRef, $rootScope, $scope, $window, util){

        var vm = this;
        vm.util = util;
        vm._mdPanelRef = mdPanelRef;
        vm.load_type_alias = $rootScope.domainData.domain_info.LOAD_TYPE_ALIAS;
        vm.trackEvent = trackEvent;
        vm.learMoreUrl = "https://support.freightify.com/portal/en/kb/articles/load-type-reference-26-3-2023";


        function trackEvent(type){
            // Removed Mixpanel as per the QMS-467 request
            // if(type === 'learn-more'){
            //   util.callMixpanel("IR-LoadDetails-learnMore");
            // }
            
        }

        
    }


   




})();
(function () {
    "use strict";
  
    angular
      .module('app.core')
      .component('incotermSelect', {
          templateUrl: 'app/main/component/incoterm-select/incoterm-select.html',
          bindings: {
            incoterm:'=',
            impoExpo:'=',
            mixpanelSource:'=',
            callback : '&',
            fullBorder:'=',
            selectPanelWidth:'=',
            isRequired: '<'
          
        },
          controller: IncotermSelectController
      });
    function IncotermSelectController($mdSelect,$scope,$rootScope,util) {
        var vm = this;
        vm.util = util;
        vm.mdSelect = $mdSelect;
        vm.selectedIncoTerm = {};
        vm.fnBindIncoterm = fnBindIncoterm;
        vm.changeIncoterm = changeIncoterm;
        //variables define
        vm.incotermList = [];
  
  
        $scope.$on('resetIncoterm', function(e) {  
            vm.selectedIncoTerm = {};        
        });

        vm.$onChanges = function() {
          initData();
        }

        function initData(){
            if(!util.v2IncotermList.length){
                util.getIncotermList().then(function(response){
                    util.v2IncotermList = response.data.incoterms;
                    vm.incotermList = util.v2IncotermList;
                    fnFindIncoterm();
                },function(error){
                    $log.log(error.data);
                });
            }else{
                vm.incotermList = util.v2IncotermList;
                fnFindIncoterm()
            }
            
        }



        function fnFindIncoterm(){
            vm.selectedIncoTerm = vm.incotermList.find(function (obj) {
                return (obj.code === vm.incoterm && obj.mode === vm.impoExpo);
            });
        }

        function fnBindIncoterm(){
            if(vm.selectedIncoTerm){
                vm.incoterm = vm.selectedIncoTerm.code;
                vm.impoExpo = vm.selectedIncoTerm.mode;
            }
        }

        function changeIncoterm(){
            vm.callback();
        }
  
       
    }
  })();
  
(function () {
    "use strict";
    angular
      .module('app.core')
      .component('freeDaysBox', {
          templateUrl: 'app/main/component/free-days-box/free-days-box.html',
          bindings: {
            freeDays:'=',
            validationObj:'=',
            mode:'=',
            pageSource:'=',
            callback:'&'
          },
         controller: FreeDaysBoxController
    });
    function FreeDaysBoxController($scope,util,$rootScope) {
        var vm = this;
       
        vm.originDisabled=false;
        vm.combinedOriginDisabled=false;
        vm.destinationDisabled=false;
        vm.combinedDestinationDisabled=false;
        vm.originDemurrageValidation=false;
        vm.originDetentionValidation = false;

        // methods
        vm.closePanel=closePanel;
        vm.disableOrigin = disableOrigin;
        vm.disableDestination = disableDestination;
        vm.disableOriginCombined = disableOriginCombined;
        vm.disableDestinationCombined = disableDestinationCombined;
        vm.dndValidation = dndValidation;
        vm.fnFreeDaysTotal = fnFreeDaysTotal;
        vm.clearAll = clearAll;
        vm.fnTrackAnalytics = fnTrackAnalytics;

      vm.validationObj={
        "originDemurrageValidation":false,
        "originDetentionValidation":false,
        "destinationDemurageValidation":false,
        "destinationDetentionValidation":false,
        "originCombinedValidation":false,
        "destinationCombinedValidation":false
      }

      this.$onInit = function () {
        vm.fnFreeDaysTotal();
      }
   
       
        function disableOrigin(){
            vm.originDisabled=true;
            vm.combinedOriginDisabled=false;
            vm.freeDays.origin.detention=null;
            vm.freeDays.origin.demurrage =null;
            vm.validationObj.originDemurrageValidation=false;
            vm.validationObj.originDetentionValidation = false;
            fnFreeDaysTotal();
        }
        function disableDestination(){
            vm.destinationDisabled = true;
            vm.combinedDestinationDisabled = false;
            vm.freeDays.destination.detention=null;
            vm.freeDays.destination.demurrage = null;
            vm.validationObj.destinationDemurageValidation=false;
            vm.validationObj.destinationDetentionValidation = false;
            fnFreeDaysTotal();
        }
        function disableOriginCombined(){
            vm.validationObj.originCombinedValidation=false;
            vm.combinedOriginDisabled = true;
            vm.originDisabled = false;
            vm.freeDays.origin.combinedDays = null;
            fnFreeDaysTotal();
        }
        function disableDestinationCombined(){
            vm.validationObj.destinationCombinedValidation=false;
            vm.combinedDestinationDisabled = true;
            vm.destinationDisabled = false;
            vm.freeDays.destination.combinedDays = null;
            fnFreeDaysTotal();
        }
        function clearAll(action){
            if(action == 'origin'){
                // values removed
                vm.freeDays.origin.detention = '';
                vm.freeDays.origin.demurrage = '';
                vm.freeDays.origin.combinedDays = '';

                 // validation removed
                 vm.validationObj.originDemurrageValidation=false;
                 vm.validationObj.originDetentionValidation = false;
                 vm.validationObj.originCombinedValidation=false;

                //  disable state removed
                vm.originDisabled = false;
                vm.combinedOriginDisabled=false;
            }
            else{
                // values removed
                vm.freeDays.destination.detention = '';
                vm.freeDays.destination.demurrage = '';
                vm.freeDays.destination.combinedDays = '';

                // validation removed
                vm.validationObj.destinationDemurageValidation=false;
                vm.validationObj.destinationDetentionValidation = false;
                vm.validationObj.destinationCombinedValidation=false;

                //  disable state removed
                vm.combinedDestinationDisabled = false;
                vm.destinationDisabled = false;
            }
            vm.fnTrackAnalytics('RateCard-FreeDays-'+action.charAt(0).toUpperCase() + action.slice(1)+'-ClearAll-Click');
            fnFreeDaysTotal();

        }
        // vm.isError=1;
        function dndValidation(event){
            if(event=='originDemurrage'){
                if((vm.freeDays.origin.demurrage > 99 || vm.freeDays.origin.demurrage<1)&& vm.freeDays.origin.demurrage!=null ){
                    vm.validationObj.originDemurrageValidation=true;
                }else{
                    vm.validationObj.originDemurrageValidation=false;
                }
            }

            if(event=='originDetention'){
                if((vm.freeDays.origin.detention > 99 || vm.freeDays.origin.detention<1)&& vm.freeDays.origin.detention!=null ){
                    vm.validationObj.originDetentionValidation=true;
                }else{
                    vm.validationObj.originDetentionValidation=false;
                }
            }

            if(event=='destinationDetention'){
                if((vm.freeDays.destination.detention > 99 || vm.freeDays.destination.detention<1)&& vm.freeDays.destination.detention!=null ){
                    vm.validationObj.destinationDetentionValidation=true;
                }else{
                    vm.validationObj.destinationDetentionValidation=false;
                }
            }

            if(event=='destinationDemurrage'){
                if((vm.freeDays.destination.demurrage > 99 || vm.freeDays.destination.demurrage<1)&& vm.freeDays.destination.demurrage!=null ){
                    vm.validationObj.destinationDemurageValidation=true;
                }else{
                    vm.validationObj.destinationDemurageValidation=false;
                }
            }
           
            if(event=='originCombined'){
                if((vm.freeDays.origin.combinedDays > 99 || vm.freeDays.origin.combinedDays<1)&& vm.freeDays.origin.combinedDays!=null ){
                    vm.validationObj.originCombinedValidation=true;
                }else{
                    vm.validationObj.originCombinedValidation=false;
                }
            }

            if(event=='destinationCombined'){
                if((vm.freeDays.destination.combinedDays > 99 || vm.freeDays.destination.combinedDays<1)&& vm.freeDays.destination.combinedDays!=null ){
                    vm.validationObj.destinationCombinedValidation=true;
                }else{
                    vm.validationObj.destinationCombinedValidation=false;
                }
            }
            vm.fnTrackAnalytics('RateCard-FreeDays-'+event.charAt(0).toUpperCase() + event.slice(1)+'-Change');
            fnFreeDaysTotal();

        }

        function fnFreeDaysTotal(){
            vm.freeDays.freeDaysTotal = null;

            var destinationTotal = null;
            var originTotal = null;

            // destination free days total
            if(vm.freeDays.destination.combinedDays){
                destinationTotal = vm.freeDays.destination.combinedDays;
            }else{
                destinationTotal = (vm.freeDays.destination.detention ? vm.freeDays.destination.detention : null) + (vm.freeDays.destination.demurrage ? vm.freeDays.destination.demurrage : null);
            }
            
            // origin free days total
            if(vm.freeDays.origin.combinedDays){
                originTotal = vm.freeDays.origin.combinedDays;
            }else{
                originTotal = (vm.freeDays.origin.detention ? vm.freeDays.origin.detention : null) + (vm.freeDays.origin.demurrage ? vm.freeDays.origin.demurrage : null);
            }

            vm.freeDays.freeDaysTotal = $rootScope.domainData.domain_info.SHOW_DEFAULT_FREE_DAYS === 'ORIGIN' ? (originTotal ? originTotal : destinationTotal)  : (destinationTotal ? destinationTotal : originTotal);
            
        }

         function closePanel(ev){
         if(!vm.validationObj.originDemurrageValidation && !vm.validationObj.originDetentionValidation && !vm.validationObj.originCombinedValidation && !vm.validationObj.destinationDemurageValidation && !vm.validationObj.destinationDetentionValidation && !vm.validationObj.destinationCombinedValidation){
           vm.callback( {'ev':ev});
         }
         }
        
        function fnTrackAnalytics(event,params){
            if(!params){
                params={}
            }
            var shortPageName = '';
            if(vm.pageSource.includes('Inquiry')){
            shortPageName = 'ID';
            }
            else if(vm.pageSource.includes('Quote')){
            if(vm.pageSource.includes('Copy')){
                shortPageName = 'QC';
            }
            else{
                shortPageName = 'QD';
            }
            }
            else{
            shortPageName = 'RR';
            }
            params.mode = vm.mode;
            params.action = vm.pageSource.includes('new') ? 'add' : 'edit';
            util.callMixpanel(shortPageName+'-'+event,params);
        }
    }


})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .component('freeDays', {
      templateUrl: 'app/main/component/free-days/free-days.html',
      bindings: {
        freedaysdata: '<',
        type: '<',
        cardid:'<',
        mode: '<',
        searchLoadData :'<'
      },
      controller: FreeDaysController
    });


  function FreeDaysController($mdPanel, freeDaysFactory , util) {

    var vm = this;
    vm.util = util;
    // Binding Services to scope
    vm._mdPanel = $mdPanel;
    vm.tableData = null;
    vm.loadType = [];
    vm.loadToDisplay = [];
    vm.showFreeDays = showFreeDays;
    vm.getLoadType = getLoadType;
    vm.getFreeDaysTableData = getFreeDaysTableData;
    vm.trackEvent = trackEvent;
    vm.renderData = renderData;

    this.$onChanges = function () {
      vm.detailData = {};
      vm.showDetailedData = false;
      vm.tableData = null;
      vm.loadType = [];

      if(!vm.freedaysdata.freeDays){
        vm.freedaysdata.freeDays = fbUtils.FreeDays.transform({'detention_details':vm.freedaysdata.detention_details,'demurrage_details':vm.freedaysdata.demurrage_details,'combined_details':vm.freedaysdata.combined_details})['freeDays'];
          vm.renderData();
      }else{
        vm.renderData();
      }
    }


    function renderData(){
      vm.showNotAvailable = true;
      var isFreedaysExist = false;

      util.freeDaysKeys.forEach(function(key){
        util.routeKeys.forEach(function(route){
          vm.freedaysdata.freeDays[route][key].forEach(function(freeDaysObj){
            if(freeDaysObj['free_days']){
              isFreedaysExist = true;
            }
          })
        });
      });

      if(isFreedaysExist){
        vm.getFreeDaysTableData();
        vm.showNotAvailable = false;
      }else{
        vm.showNotAvailable = true;
      }
    }

    function trackEvent(pageSource,event){
      var shortPageName = '';
      if(pageSource){
        if(pageSource.includes('result')){
          shortPageName = "RR"
        }else if(pageSource.includes('quote')){
          if(pageSource.includes('copy')){
            shortPageName = "QC"
          }
          else{
            shortPageName = "QD"
          }
        }else if(pageSource.includes('inquiry')){
          shortPageName = "ID";
        }
        else if(pageSource){
          shortPageName = pageSource;
        }
        util.callMixpanel(shortPageName+'-'+event+'-Click');
      }

    }
    function getFreeDaysTableData(){
      var route = [
        { 'key': 'origin', 'title': 'Origin' },
        { 'key': 'destination', 'title': 'Destination' }
      ];      
      var DnD = [
        { 'key': 'detention', 'title': 'Detention' },
        { 'key': 'demurrage', 'title': 'Demurrage' },
        { 'key': 'storage', 'title': 'Storage' },
        { 'key': 'demurageAndStorage', 'title': 'Demurrage with Storage' },
        { 'key': 'combined', 'title': 'Combined D&D' },
        { 'key': 'combinedAndStorage', 'title': 'Combined D&D  with Storage' }

      ];      
      vm.tableData = {
        'route': route,
        'DnD':DnD
      }   
      getLoadType(DnD , route);   
    }
    function getLoadType(DnD , routeKey){
      var freeDaysDataArray = [];
      var searchLoadArray = [];
      
        DnD.forEach(function(freeDaysType) {
          routeKey.forEach(function(route) {
            if(vm.freedaysdata.freeDays[route.key] && vm.freedaysdata.freeDays[route.key][freeDaysType.key].length){
              freeDaysDataArray = freeDaysDataArray.concat(vm.freedaysdata.freeDays[route.key][freeDaysType.key]);
            }
           });
        });
         freeDaysDataArray.forEach(function(freeDaysData) {
          // taking free days load types
          if(!vm.loadType.includes(freeDaysData.container_type)){
            vm.loadType.push(freeDaysData.container_type);
          }
        });
         // taking free load types from search if only have free days - to following order
          vm.searchLoadData.forEach(function(load){
          if(vm.loadType.includes(load.type)){
            searchLoadArray.push(load.type);
          }
         }); 
        // Adding free days container type if missed in search load - to cover Quote edit scenario
         vm.loadType.forEach(function(load){
         if(!searchLoadArray.includes(load)){
             searchLoadArray.push(load);
          }
         });
        vm.loadToDisplay = angular.copy(searchLoadArray);
    }

    // free days tooltip panel
    function showFreeDays(ev, cardid ) {
      vm.trackEvent(vm.freedaysdata.pageSource,'FreeDays-ViewPanel')
      var position = vm._mdPanel.newPanelPosition()
      .relativeTo(ev.target)
      .addPanelPosition('center', 'below');
      var config = {
        attachTo: angular.element(document.body),
        templateUrl: 'app/main/component/free-days/free-days-panel.html',
        controllerAs: 'ctrl',
        controller: 'FreeDaysPanelController',
        position: position,
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 100,
        locals: {
          'showdetaileddata': vm.showDetailedData,
          'tableData':  vm.tableData,
          'freedaysdata': vm.freedaysdata.freeDays,
          'detaildata': vm.detailData,
          'loadType': vm.loadToDisplay,
          'mode': vm.mode
        },
        onOpenComplete: function () {
          // freeDaysFactory.panelClosed = false;
        },
        onRemoving: function () {
          // freeDaysFactory.panelClosed = true;
        }
       
      };

      vm._mdPanel.open(config);
      ev.stopPropagation()
      //mixpanel code
    }

  }

})();

(function () {
  "use strict";

  angular
    .module("app.core")
    .controller("FreeDaysPanelController", FreeDaysPanelController)
    .factory("freeDaysFactory", function () {
      return {panelClosed: false};
    });
  function FreeDaysPanelController(mdPanelRef, freeDaysFactory ,  $timeout) {

    var vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.closePanel = closePanel;

    // Variable Declaration
    vm.freeDaysFactory = freeDaysFactory;
    $timeout(function() {
      var emptyState = '-'
      var tdElementList = document.querySelectorAll('.freeDaysCell');
      tdElementList.forEach(function(tdElement){
       if(!tdElement.innerText.trim()){
        tdElement.innerText = emptyState ;
       } 
      
      })
  });
    // Declare functions for template
    function closePanel() {
      vm._mdPanelRef && vm._mdPanelRef.close();
    }
  }

})();


(function () {
    "use strict";

    angular
      .module('app.core')
      .component('footerStrip', {
          templateUrl: 'app/main/component/footer-strip/footer-strip.html',
          bindings: {
            quoteData : "=",
            quoteDetails:"=",
            searchParam: "=",
            pageTitle: "=",
            callback:'&'
        },
          controller: FooterStripController
      });
      function FooterStripController(util,$rootScope) {
        var vm = this;
        vm.util = util;
        vm.trackEvent = trackEvent;
        vm.fnCheckZeroSellRates = fnCheckZeroSellRates;
        vm.generateQuote=generateQuote;
        vm.fnIsCo2Present = fnIsCo2Present;
        vm.hasCo2eData = false ;
        vm.enable_zero_sell_rates_on_pdf_checkbox = $rootScope.domainData.domain_info["ENABLE_ZERO_SELL_RATES_ON_PDF_CHECKBOX"];
        vm.linerMask = $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER ? true : false
        vm.linerMaskCheckBox = vm.linerMask && $rootScope.domainData.domain_info.MASKING_CHECK_BOX.is_masked;
        this.$onInit = function () {
          vm.quoteDetails.result_data.carrier_mask_for_shipper = vm.linerMask && $rootScope.domainData.domain_info.MASKING_CHECK_BOX.checked_state;
          vm.quoteDetails.result_data.all_in_quote_setting = 'default'
          vm.quoteDetails.result_data.co2e = false
          vm.fnIsCo2Present(vm.quoteDetails.result_data.cards);
          vm.allInQuoteOptions = $rootScope.domainData.domain_info.QUOTE_OPTIONS;
          vm.quote_pdf_languages = $rootScope.domainData.domain_info.QUOTE_PDF_LANGUAGES;
        }

       function fnCheckZeroSellRates(value){
        //  Disable "Print charges with “Zero” in PDF" option if select allin total/legwise total 
        vm.disable_zero_sell_rates_on_pdf_checkbox = vm.quoteDetails.result_data.all_in_quote_setting &&( vm.quoteDetails.result_data.all_in_quote_setting == 'legwise_total' ||  vm.quoteDetails.result_data.all_in_quote_setting == 'all_in_total');
        if((value == 'legwise_total' || value == 'all_in_total') && vm.quoteDetails.result_data.show_zero_sell_rates){
          vm.quoteDetails.result_data.show_zero_sell_rates = false;
        }
       }

      //  function fnTrackEvent(selectedValue){
      //   if(selectedValue === "QC-Allin-Change")
      //   {
      //     var eventName = (vm.pageTitle == 'copy-quote' ? 'QC-Allin-Change' : 'MQ-Allin-Change');
      //     analytics.track(eventName,{"QuoteType" : selectedValue})
      //   }
      //   if(selectedValue === "GQ-Carrier-Masking-In-Pdf"){
      //     analytics.track(selectedValue,{
      //       "Mode":vm.searchParam.mode,
      //       "linerMask": vm.quoteDetails.result_data.carrier_mask_for_shipper
      //      });
      //   }
      //  }

        function generateQuote(){
         if(vm.searchParam && vm.searchParam.mode === 'SEA-FCL'){
          var emptyChargeSubVendorList = [];
          var subVendorObj={};
          //  checking empty charge row in f3 leg
          vm.quoteData.forEach(function (card) {
            if(!card.data.sell_rates["l3_fcl"].rate_obj.expiry || (new Date(card.data.sell_rates["l3_fcl"].rate_obj.expiry) > new Date())){
                angular.forEach(card.data.sell_rates, function(sellLegValue,sellLegKey){
                if(sellLegKey == "l3_fcl" && Object.keys(card.data.sell_rates).length==1 && (!sellLegValue.rate_obj.charges.length || !sellLegValue.rate_obj.charges[0].charge_id)){
                     //  storing all the subvendor as object key 
                     // here, duplicate Subvendor name will overwrite wiith the existing one
                      subVendorObj[sellLegValue.rate_obj.sub_vendor.sub_vendor_name]=1;
                  }
                 else{
                    if(Object.keys(card.data.sell_rates).length ==1 && !card.data.sell_rates[Object.keys(card.data.sell_rates)[0]].rate_obj.charges.length){
                        subVendorObj[sellLegValue.rate_obj.sub_vendor.sub_vendor_name]=1;
                      }
                 }
                });
              }
          // storing subvendor name in array
           emptyChargeSubVendorList=Object.keys(subVendorObj);
       });

      if(emptyChargeSubVendorList.length){
        var subVendorStr = (emptyChargeSubVendorList.length > 1) ? emptyChargeSubVendorList.join(', ') : emptyChargeSubVendorList[0] ;
        util.showToast("Enter the charges for  " + subVendorStr + " to proceed.");
        return;
    }
    }
          vm.callback();
        }
        
        function trackEvent(eventName , value){
          util.callMixpanel(eventName,{
            Mode : vm.searchParam.mode,
            Value : value
          });
        }


        // Print Co2eData in PDF
       function fnIsCo2Present(quoteDetailsCard){
        for (var i = 0; i < quoteDetailsCard.length; i++) {
          if (quoteDetailsCard[i].meta.co2eData) {
              // If at least one card has the co2eData show print pdf options in footer
              vm.hasCo2eData = true;
              break;
          }
        }
       }
      }
    })();
      
(function(){
  'use strict';

  angular
    .module('app.core')
    .component('filterPanel', {
        templateUrl: 'app/main/component/filter-panel/filter-panel.html',
        bindings : {
          listoffilterobj: '=',
          selectedfilterobj: '=',
          side: '<',
          mode: '=',
          searchheight: '<',
          callback: '&',
          showshimmer: '='
        },
        controller: FilterController
    });

  function FilterController(util, $mdSidenav, $rootScope, $scope, analytics, resultService,$log,$timeout) {
    var vm = this;
    vm.util = util;

    vm.callBackContractId = callBackContractId;
    vm.fnSelectAirLines = fnSelectAirLines;
    vm.fnSelectLoading = fnSelectLoading;
    vm.fnSelectDischarge = fnSelectDischarge;
    vm.fnSelectDepoContainerPickup = fnSelectDepoContainerPickup;
    vm.fnSelectDepoContainerDrop = fnSelectDepoContainerDrop;
    vm.fnSelectLiner = fnSelectLiner;
    vm.fnSelectPickupTransporter = fnSelectPickupTransporter;
    vm.fnSelectOriginHaulage = fnSelectOriginHaulage;
    vm.fnSelectDeliveryTransporter = fnSelectDeliveryTransporter;
    vm.fnSelectDestinationHaulage = fnSelectDestinationHaulage;
    vm.fnSelectOriginTransporter = fnSelectOriginTransporter;
    vm.fnSelectDestinationTransporter = fnSelectDestinationTransporter;
    vm.applyFilter = applyFilter;
    vm.clearFilter = clearFilter;
    vm.toggleSidenav = toggleSidenav;
    vm.fnSelectOrigin = fnSelectOrigin;
    vm.fnSelectDestination = fnSelectDestination;
    vm.fnSelectAgent = fnSelectAgent;
    vm.fnSelectCommodity = fnSelectCommodity;
    vm.fnRollable = fnRollable;
    vm.fnDirectRoute = fnDirectRoute;
    vm.fnCargoChange = fnCargoChange;
    // vm.trackEvent = trackEvent;
    vm.callBackLiner = callBackLiner;
    vm.fnRateTypeChange = fnRateTypeChange;
    vm.fnCardStatusChange=fnCardStatusChange;
    vm.fnSetCardHeight = fnSetCardHeight;
    vm.trackMixpanel = trackMixpanel;
    vm.fnToHideErrorRates = fnToHideErrorRates;
    vm.callBackOriginServiceModeFilter=callBackOriginServiceModeFilter;
    vm.callBackDestinationServiceModeFilter=callBackDestinationServiceModeFilter;

    vm.contractIdObject = [];
    vm.linerList = [];
    vm.linerObject = null;
    vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER);
    vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
    vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
    vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';
    // search filter params
    vm.pickupTransporterSearch ='';
    vm.depoContainerPickup ='';
    vm.depoContainerDrop = '';
    vm.commoditySearch = '';
    vm.loadingSearch= '';
    vm.dischargeSearch = '';
    vm.originSearch = '';
    vm.destinationSearch = '';
    vm.deliveryTransporterSearch = '';
    vm.originTransporterSearch = '';
    vm.destinationTransporterSearch = '';
    vm.agentSearch = '';
    
    // banner listner
    var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
        calculateMaxHeight();
    });
    $scope.$on('$destroy', bannerListener);

    function calculateMaxHeight(){
      vm.maxFilterHeight = vm.util.getModuleMaxHeight(vm.maxFilterHeight,'filter',0);
    }

    this.$onChanges = function(obj) {

      vm.listOfFilterObj = vm.listoffilterobj;
      vm.selected_filter_obj = vm.selectedfilterobj;
      vm.linerMode = vm.mode !== "AIR" ? 'selected_liners' : 'selected_airlines';
      vm.linerFilterConditions = {
        'listLoader':false,
        'selectedOptions': vm.selected_filter_obj[vm.linerMode],
        'placeholder': vm.mode !== 'AIR' ? 'Search Liner' : 'Search AirLines' ,
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
        'selectedCount' : 0
      }
      vm.contractIdFilterConditions = {
        'listLoader':false,
        'selectedOptions': vm.selected_filter_obj["selected_contractId"],
        'placeholder': "Search Contract ID",
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'id',subKeyTitle:''},
        'selectedCount' : 0,
        'ignoreCaseChange' : true
      }
      vm.originServiceModeFilterConditions = {
        'listLoader':false,
        'selectedOptions': vm.selected_filter_obj["selected_originServiceMode"],
        'placeholder': "Search Origin Service Mode",
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'id',subKeyTitle:''},
        'selectedCount' : 0,
        'ignoreCaseChange' : true
      }
      vm.destinationServiceModeFilterConditions = {
        'listLoader':false,
        'selectedOptions': vm.selected_filter_obj["selected_destinationServiceMode"],
        'placeholder': "Search Destination Service Mode",
        'isGroupOptions' : false,
        'groupList' : {groupTitle:'',keyTitle:'id',subKeyTitle:''},
        'selectedCount' : 0,
        'ignoreCaseChange' : true
      }
      calculateMaxHeight();

    }

    this.$onInit = function () {
      vm.contractIdObject = vm.listOfFilterObj.contractId;
      getLinersData();
    }

    //function to get liner list
    function getLinersData(query){
      var type = vm.mode=='AIR' ? 'airline' : 'subvendor';
      var queryData = query ? query : '';
      vm.linerFilterConditions.filterLoader = true;

      if(!queryData && (util.carrierData.mode == vm.mode && util.carrierData.data.length)){
        vm.linerObject = angular.copy(util.carrierData.data);
        vm.linerFilterConditions.filterLoader = false;
      }else{
       
        return resultService.getLinersData(type, queryData).then(function(response){
          vm.linerObject = response.data.data;
          if(!queryData){
            util.carrierData.mode = vm.mode;
            util.carrierData.data = angular.copy(response.data.data);
          }
          // vm.storeLinerObject = vm.linerObject;
          // if(vm.mode!=='AIR'){
          //   angular.forEach(response.data.data, function (liner) {
          //     vm.linerList.push(liner.name);
          //   });
          // }else{
          //   vm.linerList = response.data.data;
          // }
          vm.linerFilterConditions.filterLoader = false;
        },function(error){
          vm.linerFilterConditions.filterLoader = false;
            $log.log(error.data);
            return [];
        });
      }
    }

    function fnRateTypeChange(){
      applyFilter();
    }
    function fnCardStatusChange(){
      analytics.track("Instant-Fitler-CardStatus",{
        "optionvalue":vm.selected_filter_obj.selected_cardStatus,
        "Mode" : vm.mode
      });
      applyFilter();
    }
    //store rollable
    function fnRollable(isSwitch){
      // on the fly apply card filter
      applyFilter();
    }

    //store Direct Route
    function fnDirectRoute(isSwitch){
      // on the fly apply card filter
      util.callMixpanel("RR-Filter-DirectRoute-Change",{
        "value": vm.selected_filter_obj.via_route_filter,
        "Mode" : vm.mode
      });
      applyFilter();
    }

    // store selected liner
    function fnSelectLiner(item) {
      var idx = vm.selected_filter_obj.selected_liners.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_liners.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_liners.push(item);
      }
      // on the fly apply card filter
      applyFilter();
    };

    // store selected liner
    function fnSelectAirLines(item) {
      var idx = vm.selected_filter_obj.selected_airlines.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_airlines.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_airlines.push(item);
      }
      // on the fly apply card filter
      applyFilter();
    };

    // store selected commodity
    function fnSelectCommodity(item){
      var idx = vm.selected_filter_obj.selected_commodity.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_commodity.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_commodity.push(item);
      }
      util.callMixpanel("RR-Filter-Commodity-Change",{
        "value": vm.selected_filter_obj.selected_commodity,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // on change of cargo type
    function fnCargoChange(){
      // on the fly apply card filter
      util.callMixpanel("RR-Filter-CargoType-Select",{
        "value": vm.selected_filter_obj.selected_cargoType,
        "Mode" : vm.mode
      });
      applyFilter();
    }

    function trackMixpanel(id, value){
      util.callMixpanel('RR-Filter-'+id+'-Search',{
        "mode":vm.mode,
        "Search Query":value
      })
    }

    // store selected container pickup
    function fnSelectDepoContainerPickup(item){
      var idx = vm.selected_filter_obj.selected_depoContainerPickup.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_depoContainerPickup.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_depoContainerPickup.push(item);
      }
      // on the fly apply card filter
      applyFilter();
    }

     // store selected container drop
     function fnSelectDepoContainerDrop(item){
      var idx = vm.selected_filter_obj.selected_depoContainerDrop.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_depoContainerDrop.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_depoContainerDrop.push(item);
      }
      // on the fly apply card filter
      applyFilter();
    }

    // store selected loading port
    function fnSelectLoading(item){
      var idx = vm.selected_filter_obj.selected_loadingPort.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_loadingPort.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_loadingPort.push(item);
      }
      util.callMixpanel("RR-Filter-Pol-Select",{
        "value": vm.selected_filter_obj.selected_loadingPort,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // store selected discharge port
    function fnSelectDischarge(item){
      var idx = vm.selected_filter_obj.selected_dischargePort.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_dischargePort.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_dischargePort.push(item);
      }
      util.callMixpanel("RR-Filter-Pod-Select",{
        "value":  vm.selected_filter_obj.selected_dischargePort,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // store selected origin transporter
    function fnSelectPickupTransporter(item){
      var idx = vm.selected_filter_obj.selected_pickupTransporter.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_pickupTransporter.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_pickupTransporter.push(item);
      }
      util.callMixpanel("RR-Filter-pickupTransporter-Select",{
        "value": vm.selected_filter_obj.selected_pickupTransporter,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // store selected origin haulage
    function fnSelectOriginHaulage(item){
      var idx = vm.selected_filter_obj.selected_originHaulage.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_originHaulage.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_originHaulage.push(item);
      }
      // on the fly apply card filter
      applyFilter();
    }

    function fnSelectOriginTransporter(item){
      var idx = vm.selected_filter_obj.selected_originTransporter.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_originTransporter.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_originTransporter.push(item);
      }
      util.callMixpanel("RR-Filter-originTransporter-Select",{
        "value": vm.selected_filter_obj.selected_originTransporter,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    function fnSelectDestinationTransporter(item){
      var idx = vm.selected_filter_obj.selected_destinationTransporter.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_destinationTransporter.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_destinationTransporter.push(item);
      }
      util.callMixpanel("RR-Filter-destinationTransporter-Select",{
        "value":vm.selected_filter_obj.selected_destinationTransporter,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // store selected destination transporter
    function fnSelectDeliveryTransporter(item){
      var idx = vm.selected_filter_obj.selected_deliveryTransporter.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_deliveryTransporter.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_deliveryTransporter.push(item);
      }
      util.callMixpanel("RR-Filter-deliveryTransporter-Select",{
        "value": vm.selected_filter_obj.selected_deliveryTransporter,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // store selected destination haulage
    function fnSelectDestinationHaulage(item){
      var idx = vm.selected_filter_obj.selected_destinationHaulage.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_destinationHaulage.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_destinationHaulage.push(item);
      }
      // on the fly apply card filter
      applyFilter();
    }

    // store selected origin port
    function fnSelectOrigin(item){
      var idx = vm.selected_filter_obj.selected_originPort.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_originPort.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_originPort.push(item);
      }
      util.callMixpanel("RR-Filter-Origin-Select",{
        "value": vm.selected_filter_obj.selected_originPort,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // store selected destination port
    function fnSelectDestination(item){
      var idx = vm.selected_filter_obj.selected_destinationPort.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_destinationPort.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_destinationPort.push(item);
      }
      util.callMixpanel("RR-Filter-Destination-Select",{
        "value":  vm.selected_filter_obj.selected_destinationPort,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // store selected agent name
    function fnSelectAgent(item){
      var idx = vm.selected_filter_obj.selected_agent.indexOf(item);
      if (idx > -1) {
        vm.selected_filter_obj.selected_agent.splice(idx, 1);
      }else {
        vm.selected_filter_obj.selected_agent.push(item);
      }
      util.callMixpanel("RR-Filter-Agents-Select",{
        "value": vm.selected_filter_obj.selected_agent,
        "Mode" : vm.mode
      });
      // on the fly apply card filter
      applyFilter();
    }

    // function to apply filter to remove no-rates 
    function fnToHideErrorRates(event){
        // on the fly apply card filter
        applyFilter();
    }

    function applyFilter(){
      vm.callback({'selectedFilterObj' : vm.selected_filter_obj});
      // if(vm.side == 'right'){
      //   vm.toggleSidenav(vm.side);
      // }
    }

    function clearFilter(){


      var clearFilterObj = {
        "selected_liners" : [],
        "selected_airlines" : [],
        "selected_originPort" : [],
        "selected_destinationPort" : [],
        "selected_loadingPort" : [],
        "selected_dischargePort" : [],
        "selected_originHaulage" : [],
        "selected_destinationHaulage" : [],
        "selected_originTransporter" : [],
        "selected_destinationTransporter" : [],
        "selected_pickupTransporter" : [],
        "selected_deliveryTransporter" : [],
        "rollable" : false,
        "via_route_filter" : "Transhipment",
        "selected_agent" : [],
        "selected_commodity" : [],
        "selected_cargoType" : "All",
        "selected_rateType" : "All",
        "selected_cardStatus" : "All",
        "selected_contractId" : [],
        "selected_depoContainerPickup" : [],
        "selected_depoContainerDrop" : [],
        "no_rates_filter" : false
      }
      vm.linerFilterConditions.selectedOptions = [];
      vm.contractIdFilterConditions.selectedOptions = [];
      vm.selected_filter_obj = angular.copy(clearFilterObj);
      vm.callback({'selectedFilterObj' : vm.selected_filter_obj});
      if(vm.side == 'right'){
        vm.toggleSidenav(vm.side);
      }
    }

    // toggling the sidenav for add services asection
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    // function trackEvent(type) {
    //   if(type === "liner") {
    //     analytics.track("Instant Filter Liners",{
    //       "Mode": vm.mode
    //     });
    //   }
    //   if(type === "airline") {
    //     analytics.track("Instant Filter Airlines",{
    //       "Mode": vm.mode
    //     });
    //   }
    //   if(type === "directRoute") {
    //     analytics.track("Instant Filter Direct Route",{
    //       "Mode": vm.mode
    //     });
    //   }
    //   if(type === "cargoType") {
    //     analytics.track("Instant Filter Cargo Type",{
    //       "Mode": vm.mode
    //     });
    //   }
    //   if(type === "commodity") {
    //     analytics.track("Instant Filter Commodity",{
    //       "Mode": vm.mode
    //     });
    //   }
    //   if(type === "pol") {
    //     analytics.track("Instant Filter POL",{
    //       "Mode": vm.mode
    //     });
    //   }
    //   if(type === "pod") {
    //     analytics.track("Instant Filter POD",{
    //       "Mode": vm.mode
    //     });
    //   }
    //   if(type === "rollable") {
    //     analytics.track("Instant Filter Rollable",{
    //       "Mode": vm.mode
    //     });
    //   }
    // }

    function callBackLiner(payload){
      if(payload.searchText || payload.searchText === ''){ // search result 
        getLinersData(payload.searchText);
        // vm.linerFilterConditions.filterLoader = true;
          var searchString = payload.searchText.toLowerCase();
          // var searchResult = [];
          // find existing load type list
          // angular.forEach(vm.storeLinerObject, function (item) {
          //   var toFilterStr = item.name;
          //     vm.util.searchTextOption(searchResult,item,searchString,toFilterStr)
          // });
          // $timeout(function (){
          //   vm.linerObject = searchResult;
          //   vm.linerFilterConditions.filterLoader = false;
          // },100); 
      }
      if(payload.selectedOptions){ // selected options
        vm.selected_filter_obj[vm.linerMode] = [];
        if(vm.linerFilterConditions.selectedCount !== 0){
          angular.forEach(payload.selectedOptions,function(item,key){
            vm.selected_filter_obj[vm.linerMode].push(vm.mode !== 'AIR' ? item.id : item.code)
          });
        }
        // on the fly apply card filter
        applyFilter();
      }
    }
    
    function callBackContractId(payload){
      if(payload.searchText || payload.searchText === ''){ // search functionality 
        util.callMixpanel("RR-Filter-Contract-Search",{
          "Mode": vm.mode,
          "search-Query": payload.searchText
        });
        vm.contractIdFilterConditions.filterLoader = true;
          var searchString = payload.searchText.toLowerCase();
          var searchResult = [];
          angular.forEach(vm.contractIdObject, function (item) {
              var toFilterStr = item.id;
              vm.util.searchTextOption(searchResult,item,searchString,toFilterStr);
          });
          $timeout(function (){
            vm.listOfFilterObj.contractId = searchResult;
            vm.contractIdFilterConditions.filterLoader = false;
          },100); 
      
        // on the fly apply card filter
      }
      if(payload.selectedOptions){ // filter functionality
        vm.selected_filter_obj.selected_contractId = [];
        if(vm.contractIdFilterConditions.selectedCount){
          angular.forEach(payload.selectedOptions,function(item){
            vm.selected_filter_obj["selected_contractId"].push(item.id);
          });
        }
        util.callMixpanel("RR-Filter-Contract-Select",{
          "Mode": vm.mode,
          "value": vm.selected_filter_obj["selected_contractId"]
        });
        applyFilter();
      }
    }
    function callBackOriginServiceModeFilter(payload){
      if(payload.searchText || payload.searchText === ''){ // search functionality 
        util.callMixpanel("RR-Filter-OriginServiceMode-Search",{
          "Mode": vm.mode,
          "search-Query": payload.searchText
        });
        vm.originServiceModeFilterConditions.filterLoader = true;
          var searchString = payload.searchText.toLowerCase();
          var searchResult = [];
          angular.forEach(vm.listOfFilterObj.originServiceMode, function (item) {
              var toFilterStr = item.id;
              vm.util.searchTextOption(searchResult,item,searchString,toFilterStr);
          });
          $timeout(function (){
            vm.listOfFilterObj.originServiceMode = searchResult;
            vm.originServiceModeFilterConditions.filterLoader = false;
          },100); 
      
        // on the fly apply card filter
      }
      if(payload.selectedOptions){ // filter functionality
        vm.selected_filter_obj.selected_originServiceMode = [];
        if(vm.originServiceModeFilterConditions.selectedCount){
          angular.forEach(payload.selectedOptions,function(item){
            vm.selected_filter_obj["selected_originServiceMode"].push(item.id);
          });
        }
        util.callMixpanel("RR-Filter-OriginServiceMode-Select",{
          "Mode": vm.mode,
          "value": vm.selected_filter_obj["selected_originServiceMode"]
        });
        applyFilter();
      }
    }
    function callBackDestinationServiceModeFilter(payload){
      if(payload.searchText || payload.searchText === ''){ // search functionality 
        util.callMixpanel("RR-Filter-DestinationServiceMode-Search",{
          "Mode": vm.mode,
          "search-Query": payload.searchText
        });
        vm.destinationServiceModeFilterConditions.filterLoader = true;
          var searchString = payload.searchText.toLowerCase();
          var searchResult = [];
          angular.forEach(vm.listOfFilterObj.destinationServiceMode, function (item) {
              var toFilterStr = item.id;
              vm.util.searchTextOption(searchResult,item,searchString,toFilterStr);
          });
          $timeout(function (){
            vm.listOfFilterObj.destinationServiceMode = searchResult;
            vm.destinationServiceModeFilterConditions.filterLoader = false;
          },100); 
      
        // on the fly apply card filter
      }
      if(payload.selectedOptions){ // filter functionality
        vm.selected_filter_obj.selected_destinationServiceMode = [];
        if(vm.destinationServiceModeFilterConditions.selectedCount){
          angular.forEach(payload.selectedOptions,function(item){
            vm.selected_filter_obj["selected_destinationServiceMode"].push(item.id);
          });
        }
        util.callMixpanel("RR-Filter-DestinatiomnServiceMode-Select",{
          "Mode": vm.mode,
          "value": vm.selected_filter_obj["selected_destinationServiceMode"]
        });
        applyFilter();
      }
    }
    var resetFilter = $scope.$on('clearCardFilter', function () {
        vm.side = null;
        clearFilter();
    });
    $scope.$on('$destroy', resetFilter);

    function fnSetCardHeight(){
      $timeout(function () {
        angular.element('.virtualHeight').height(Math.round(angular.element('.filter-container').height() + 100));
      })
      
    }
  }

})();

(function(){
    'use strict';
    angular
    .module('app.core')
    .component('fileDragAndDrop',{
        templateUrl:'app/main/component/file-drag-and-drop/file-drag-and-drop.html',
        bindings: {
            fileType: '=',
            fileSize: '=',
            fileSizeErrorMessage: '=',
            fileTypeErrorMesssage: '=',
            pageSource: '=',
            callback: '&'
        },
        controller: FileDragAndDropController 
    });

    function FileDragAndDropController(util,$scope){
        var vm = this;
        vm.setFile = setFile;
        vm.selectFile = selectFile;
        vm.uploadFile = uploadFile;
        vm.removeFile = removeFile;
        vm.trackEvent = trackEvent;
        vm.progressCircle = false;
        vm.fileSizeError = false;
        vm.fileTypeError = false;
        vm.picFile;

        $scope.$watch('$ctrl.picFile', function(newFile) {
            if (newFile) {
                // Handle the dropped file here
                vm.uploadFile(newFile);
            }
        });

        function setFile(file){
            vm.picFile = file;
            vm.uploadFile(file);
        };

        function selectFile() {
            angular.element(document.querySelector('#fileInput_document')).click();
        };

        function removeFile(file){
            vm.fileSizeError = false;
            vm.fileTypeError = false;
            vm.callback({file : file});
        };

        function uploadFile(file) {
            var file_type = file.type;


            // File size validation
            if (file.size <= vm.fileSize) {
                vm.fileSizeError = false;

                // File type validation
                if (vm.fileType.indexOf(file_type) !== -1) {
                    vm.fileTypeError = false;
                    vm.callback({ file: file });
                }
                else {
                    // Invalid file type
                    vm.fileTypeError = true;
                }
            }
            else {
                // Invalid file size
                vm.fileSizeError = true;
            }   
        };

        $scope.$on("clearFile",function() {
                vm.picFile = null ;
                vm.fileSizeError = false;
                vm.fileTypeError = false;
        });

        $scope.$on("progressCircleShow",function(event, data) {
            vm.progressCircle = data.action ;
        });

        function trackEvent(eventName){
            util.callMixpanel(vm.pageSource+'-'+eventName);
        };
    }
    
})();
(function () {
    "use strict";
  
    angular
      .module("app.core")
      .controller("EffectivePeriodPanelController", EffectivePeriodPanelController)
      .factory("effectivePeriodPanelFactory", function () {
        return {panelClosed: false};
      });
  
    function EffectivePeriodPanelController(mdPanelRef, effectivePeriodPanelFactory) {
  
      var vm = this;
      vm._mdPanelRef = mdPanelRef;
      vm.closePanel = closePanel;
      this.$onInit = function() {
      }

      // Variable Declaration
      vm.effectivePeriodPanelFactory = effectivePeriodPanelFactory;
  
      // Declare functions for template
      function closePanel() {
        vm._mdPanelRef && vm._mdPanelRef.close();
      }
  
    }
  
  })();
  
(function () {
    'use strict';
  
    angular
    .module('app.core')
    .component('doorAddress', {
        templateUrl: 'app/main/component/door-address/door-address.html',
        bindings : {
            addressData: '=',       // Two-way binding for address object (origin/destination)
            label: '@'              // Optional label like "Origin" or "Destination"
        },
        controller: DoorAddressController
    });
  
  
    function DoorAddressController($mdDialog,util,SettingService,$log) {
        var vm = this;
        vm.util=util;
        vm.countryList = [];    

        this.$onInit = function () {
            getCountries();
        }

        function getCountries(){
            if(!SettingService.countriesData){
                SettingService.getCountryList().then(function(response){
                    SettingService.countriesData = angular.copy(response.data.data);
                    vm.countryList = SettingService.countriesData.countries;
                },function(err){
                    $log.error(err);
                });
            }
            else{
                vm.countryList = SettingService.countriesData.countries;
            }
        }

    }

})();
(function () {
  'use strict';

  angular
  .module('app.core')
  .component('downloadPdf', {
      templateUrl: 'app/main/component/donwload-pdf/download-pdf.html',
      bindings : {
        quoteid : '=',
          callback : '&',
          resultType : '=',
          mode : '='



      },
      controller: DownloadPdfController
  });


  function DownloadPdfController(util,resultService, $window, $stateParams,QuotesService) {
      var vm = this;
      vm.util = util;
      vm.downloadPdf = downloadPdf;
      vm.fnGetPdfLink = fnGetPdfLink;
      vm.isShared = util.isSharedQuote();

      this.$onInit = function() {
        vm.downloadProgressValue = 1;

        vm.fnGetPdfLink();
      }

      function fnGetPdfLink(){
        vm.downloadProgressValue = vm.isPdfFailed ? 1 : vm.downloadProgressValue;
        vm.isPdfFailed = false;
        vm.isPdfGenerated = false;

        var quote_id = vm.isShared ? $stateParams.id : vm.quoteid;

        resultService.fnGetPdfLink(quote_id).then(function (response) {

          vm.pdf_link = response.data.data.pdf_link;
          QuotesService.open_pdf_link = response.data.data.pdf_link;
          if(vm.pdf_link) {  // pdf link success
            clearInterval(vm.autoUpdate);
            vm.isPdfGenerated = true;
            vm.isPdfFailed = false;
            vm.downloadProgressValue = 5;
          }
          else{   //pdf link failed
            vm.autoUpdate = setTimeout(fnGetPdfLink, 5000);
            vm.downloadProgressValue+= 1;
            if(vm.downloadProgressValue >= 5){
              clearInterval(vm.autoUpdate);
              vm.isPdfFailed = true;
              vm.downloadProgressValue = 0;
            }
          }
        }, function (error) {
          vm.isPdfGenerated = true;
          vm.isPdfErrOccured = true;
          $log.error(error);
        });
      }

      function downloadPdf(){
        if(vm.pdf_link) {
          // $window.open(vm.pdf_link);
          var anchorTag = document.createElement('a');
          anchorTag.setAttribute('href',vm.pdf_link);
          anchorTag.setAttribute('download',true);
          anchorTag.setAttribute('target','_blank')
          document.body.appendChild(anchorTag);
          anchorTag.click();
          document.body.removeChild(anchorTag);
    
        }
      }

  }

})();

(function () {
    'use strict';
  
    angular
    .module('app.core')
    .component('deletePopup', {
        templateUrl: 'app/main/component/delete-popup/delete-popup.html',
        bindings : {
            callback : '&',
            cardId:'=',
            cardIndex:'=',
            deletionSource:'='
  
  
        },
        controller: DeletePopupController
    });
  
  
    function DeletePopupController($mdDialog,util) {
        var vm = this;
        vm.util=util;
        vm.deleteData=deleteData;
        vm.cancelPanel=cancelPanel;

        function deleteData(event,type){
            if(vm.deletionSource=='card'){
                vm.callback({data : {'_id' : vm.cardId,'index':vm.cardIndex,'ev':event}});
            }
            else{
                util.callMixpanel("QC-AgentDelete-Yes-Click")
                vm.callback();
            }
            $mdDialog.hide();

        }
        function cancelPanel(type){
            if(vm.deletionSource=='agent'){
                util.callMixpanel("Agent-DeleteAgent-cancel")
            }
            else{
                util.callMixpanel("QC-AgentDelete-No-Click")
            }
            $mdDialog.hide();
        }
    }

})();
(function () {
  "use strict";

  angular
    .module('app.core')
    .component('dateRangePicker', {
        templateUrl: 'app/main/component/date-range-picker/date-range-picker.html',
        bindings: {
          mdInputId: '=',
          isResetDatePicker : '=',
          dateRangeValue : '<',
          callback: '&'
      },
        controller: DateRangePickerController
    });
  function DateRangePickerController($mdSelect,$scope,$timeout) {
      var vm = this;
      vm.fnDataFormatSet = fnDataFormatSet;
      $scope.pickerModel = {dateStart: null , dateEnd:null};
      $scope.format = function (dateStart, dateEnd, template, templateName) {
       vm.fnDataFormatSet(dateStart, dateEnd);
      }
      vm.fnSetDatePicker = fnSetDatePicker;
      vm.$onChanges = function() {
        if(vm.dateRangeValue){
          $scope.pickerModel.dateStart = new Date(vm.dateRangeValue.from);
          $scope.pickerModel.dateEnd = new Date(vm.dateRangeValue.to);
          if(vm.isResetDatePicker){
            vm.isResetDatePicker = false;
            vm.fnDataFormatSet($scope.pickerModel.dateStart,$scope.pickerModel.dateEnd);
          }
        }
        
      };

      function fnSetDatePicker(data) {
        var dateRangeObj = {
          'start_date' : data.dateStart,
          'end_date' : data.dateEnd
        }
        vm.callback({'date' : dateRangeObj});
      }
      
      function fnDataFormatSet(dateStart, dateEnd){
        if(dateStart && dateEnd){
          var dateFormatTemplate = '<div class="date_template"><div class="start_date">From</div>  <div class="end_date">To</div></div> <span class="date-icon-filter-outline"></span>';
          dateFormatTemplate += '<div class="date_template"><div class="start_date_input start_date">'+dateStart.toLocaleDateString("en-US", {day:'2-digit'})+' '+(dateStart.toLocaleDateString("en-US", {month:'short', year: 'numeric' }) + '</div><div class="end_date_input start_date">' + dateEnd.toLocaleDateString("en-US", {day:'2-digit'})+' '+dateEnd.toLocaleDateString("en-US", {month:'short', year: 'numeric' }))+'</div></div>';
  
          
          $timeout(function() {
            angular.element('md-date-range#'+vm.mdInputId+' .md-select-value .ng-binding').html(dateFormatTemplate);
          });
        }else{
          $timeout(function () {
            angular.element('md-date-range#'+vm.mdInputId+' .md-select-value .ng-binding').html('<div class="date_template"><div class="start_date_input start_date placeholder">From</div>  <div class="end_date_input start_date placeholder">To</div></div> <span class="date-icon-filter-outline"></span>')
          });  
        }
        $timeout(function() {
          var getDateRangeMenuId = angular.element('md-date-range#'+vm.mdInputId+' md-menu .md-select-value').attr('aria-owns');
          angular.element('#'+getDateRangeMenuId+' md-menu-content span.ng-binding:eq(0)').html((dateStart ? 'From: '+dateStart.toLocaleDateString("en-US", {day:'2-digit'})+' '+dateStart.toLocaleDateString("en-US", {month:'short', year: 'numeric' }) : '')+(dateEnd ? '   &nbsp;&nbsp;To: '+dateEnd.toLocaleDateString("en-US", {day:'2-digit'})+' '+dateEnd.toLocaleDateString("en-US", {month:'short', year: 'numeric' }): ''));
        });
      }

      
     /* angular.element('.md-date-range-picker__calendar__selected').mouseover(function(e){
        console.log($(this),'asa');
        $(this).addClass('hide1rr')
        var foundFirst = 0;
        var isBetween = false;
        angular.element(".md-date-range-picker").each(function() {
          if(angular.element(this).hasClass("md-date-range-picker__calendar__selected")) {
              if(foundFirst==0) foundFirst=-1;
              isBetween = (foundFirst == -1 ? true : false);
          }
          if(angular.element(this).hasClass("ui-state-hover")) {
              if(foundFirst==0) foundFirst=1;
              isBetween = (foundFirst == 1 ? true : false);
          }
          if(isBetween) {
              $(this).addClass("between-date");
          } 
      });
      });*/
  }
})();

(function () {
    "use strict";
    angular
      .module('app.core')
      .component('datePicker', {
          templateUrl: 'app/main/component/date-picker/date-picker.html',
          bindings: {
              mdInputId:'=',
              isDisabled:'=',
              minDateValue:'=',
              maxDateValue:'=',
              dateFormat:'=',
              isEditable:'=',
              inputName:'=',
              isValidate:'=',
              inputRequired:'=',
              datePlaceholder:'=',
              modelValue:'=',
              callback:'&',
              fullBorder:'='
          },
         controller: DatePickerController
    });
    function DatePickerController($mdDateLocale,analytics) {
        var vm = this;
        vm.isValid = false;
        vm.isOpen = false;
        vm.fnDateFormat = fnDateFormat;
        vm.onFocus = onFocus;
        vm.onBlur=onBlur;
        vm.fnOpenDatePicker = fnOpenDatePicker;
        vm.fnSetMinMaxDate = fnSetMinMaxDate;

        vm.Check = function(event)
        {
            var key = event.key;
            
            if (!((key === "Backspace" || key === "Delete" ) && vm.isEditable)) {
                event.preventDefault();
                return false;
                }
        }

        vm.$onInit = function()
        {
            fnSetMinMaxDate();
           var format = vm.dateFormat === true ? 'DD MMM YYYY' : 'DD/MM/YYYY';
           vm.fnDateFormat(format);
        }

        vm.fndateChange = function(){
            fnSetMinMaxDate();
            vm.callback({'value':vm.modelValue});
        }

        function fnDateFormat(value)
           {
                $mdDateLocale.formatDate = function(date) {
                    return date ? moment(date).format(value) : '';
                };
                $mdDateLocale.parseDate = function (dateString) {
                    var m = moment(dateString,value, true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                };
                fnSetMinMaxDate();
           }

          function fnSetMinMaxDate(){
                 // converting min date and max date to date string
                 vm.minLimit = angular.copy(vm.minDateValue);
                 vm.maxLimit = angular.copy(vm.maxDateValue);

                 vm.minLimit =  vm.minLimit ? new Date(vm.minLimit):  vm.minLimit;
                 vm.maxLimit = vm.maxLimit ? new Date(vm.maxLimit): vm.maxLimit;
          }

           function fnOpenDatePicker(){
            vm.isOpen = true ;
            fnSetMinMaxDate();
           }

           function onFocus(){
            return vm.isValid = vm.isDisabled === true ? false : true;
           }
           
           function onBlur(){
            return vm.isValid = false;
           }
      }
    })();

(function () {
    "use strict";
  
    angular
    .module('app.core')
    .component('databrainComponent', {
        templateUrl: 'app/main/component/databrain/databrain.html',
        bindings : {
          dashboardName: '@',
          dashboardId : '@',
          dashboardFilterData : '<'
        },
        controller: DataBrainController
    });
  
    /** @ngInject */
    function DataBrainController(util, iframeService, $timeout, $state) {
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.loader = true;
      vm.iframeService = iframeService;

      // method
      vm.formIframeUrl = formIframeUrl;
  
      this.$onInit = function () {
        vm.minHeight = vm.iframeService.iframeHeight;
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('databrain');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&DataBrainReport=1&parentUrl="+ window.location.origin);
        var dataBrainIframe = document.getElementById("databrain-iframe");
        dataBrainIframe.src = vm.iframeUrl
       
        dataBrainIframe.onload = function() {
          $timeout(function () {
            vm.loader = false
          },1000);
        };
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'databrain-reports'){
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
          if(event.origin === targetOrigin){
            var obj = util.ResultPageDataBrainReport.find(function(item) { return item.name === vm.dashboardName && item.external_report_id === vm.dashboardId});
            if(obj){
              document.getElementById('databrain-iframe').contentWindow.postMessage(
                { dataBrainReport : { report : obj, filter : vm.dashboardFilterData } , dataSource:'databrain-reports' },
              targetOrigin);
            }
          }}
      }
  
    }
  })();
  
  
(function () {
  'use strict';

  angular
  .module('app.core')
  .component('currencyDropdown', {
      templateUrl: 'app/main/component/currency-dropdown/currency-dropdown.html',
      bindings : {
        fieldValue : '=',
        fullBorder: '=',
        isRequired: '=',
        isDisabled: '=',
        isSearchBar: '=',
        pageSource: '=',
        callback : '&' 
      },
      controller: CurrencyDropdownController
  });


  function CurrencyDropdownController(util) {
      var vm = this;
      vm.isCurrencyListLoaded=false;
      vm.currencyList = util.mappingCurrencyList;
      vm.trackEvent = trackEvent;
      this.$onInit = function() {
        if(!vm.currencyList || !vm.currencyList.length){
          getMappingCurrecyList();
        }
        else{
          vm.isCurrencyListLoaded=true;
        }
      }

      // get currency list
      function getMappingCurrecyList(){
        util.getMappingCurrencyList().then(function(){
          vm.currencyList = util.mappingCurrencyList;
          vm.isCurrencyListLoaded=true;
        },function(error){
            $log.log(error.data);
        });
      }
      function trackEvent(searchCurrency) {
        vm.callback({'selectedValue':vm.fieldValue});
      }
  }

})();

(function () {
  "use strict";

  angular
    .module("app.core")
    .controller("CostViewController", CostViewController)
    .factory("costViewFactory", function () {
      return {panelClosed: false};
    });

  function CostViewController(mdPanelRef, costViewFactory) {

    var vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.closePanel = closePanel;

    // Variable Declaration
    vm.costViewFactory = costViewFactory;

    // Declare functions for template
    function closePanel() {
      vm._mdPanelRef && vm._mdPanelRef.close();
    }

  }

})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .component('commodityChips', {
        templateUrl: 'app/main/component/commodity-chips/commodity-chips.html',
        bindings: {
            isValid:'=',
            commodityArray: '=',
            mdInputId: '<',
            category: '=',
            pageSource:'=',
            mode:'=',
        },
        controller: CommodityChipsController
      });


    function CommodityChipsController($log, resultService, util) {

      var vm = this;
      vm.getCommodityList = getCommodityList;
      vm.fnTrackAnalytics= fnTrackAnalytics;
      vm.fnRemoveChips = fnRemoveChips;
      vm.selectedCommodityItem = null;
      vm.commoditySearchText = null;

      this.$onInit = function () {
      }

    // function to get commodity list
    function getCommodityList(searchText) {
        if(vm.category){
          util.callMixpanel("SD-"+vm.category+"-POP-Commodity",{
            "Value":searchText
        });
        }
        return resultService.getCommodityList(searchText).then(function (response) {
          return response.data.data;
        }, function (error) {
          $log.log(error.data);
          return [];
        });
    }
    function fnRemoveChips(value){
      // commented as per the ticket QMS-467
      // vm.fnTrackAnalytics('Commodity-Remove-Click',{'value':value});
    }
    function fnTrackAnalytics(action, params){
      if(!params){
        var params = {};
      }
      var shortPageName = '';
      if(vm.pageSource && vm.pageSource.includes('RateCard')){
            if(vm.pageSource.includes('Inquiry')){
              shortPageName = 'ID';
            }
            else if(vm.pageSource.includes('Quote')){
            if(vm.pageSource.includes('Copy')){
              shortPageName = 'QC';
            }
            else{
              shortPageName = 'QD';
            }
          }
          else{
            shortPageName = 'RR';
          }
          params.mode = vm.mode;
          params.action = vm.pageSource.includes('new') ? 'add' : 'edit';
          util.callMixpanel(shortPageName+'-RateCard-'+action, params);
        }
        else if(vm.pageSource){
          params.mode = vm.mode;
          util.callMixpanel(vm.pageSource+'-'+action, params);
        }
    }
  }

  })();

(function () {
    "use strict";
  
    angular
      .module("app.core")
      .controller("Co2EmissionPanelController", Co2EmissionPanelController)
      .factory("co2eViewFactory", function () {
        return {panelClosed: false};
      });
     
    function Co2EmissionPanelController(mdPanelRef, co2eViewFactory) {
  
      var vm = this;
      vm._mdPanelRef = mdPanelRef;
      vm.closePanel = closePanel;

      vm.co2eViewFactory = co2eViewFactory;

      vm.rowTitle = [
        {
          title : 'Total',
          key : 'total',
          metrics : 'g'
        },
        {
          title : 'TTW',
          key : 'tank_to_wheel',
          metrics : 'g'
        },
        {
          title : 'WTT',
          key : 'well_to_tank',
          metrics : 'g'
        },
        {
          title : 'Intensity',
          key : 'intensity',
          metrics : '(kg/tkm)' 
        }
      ]
  
      // Declare functions for template
      function closePanel() {
        vm._mdPanelRef && vm._mdPanelRef.close();
      }
    }
  
  })();
  
(function () {
    "use strict";
  
    angular
      .module("app.core")
      .controller("ChargesViewController", ChargesViewController)
      .factory("chargesViewFactory", function () {
        return {panelClosed: false};
      });
  
    function ChargesViewController(mdPanelRef, chargesViewFactory,util) {
  
      var vm = this;
      vm._mdPanelRef = mdPanelRef;
      vm.closePanel = closePanel;

      vm.getContainerWiseLeg = getContainerWiseLeg;
      vm.fnGetAllLegTotal = fnGetAllLegTotal;
      vm.fnGetAvailableContainer = fnGetAvailableContainer;


      vm.chargesViewFactory = chargesViewFactory; // Variable Declaration

      vm.cardLegCostArray = [];
      vm.containerObj = null;
      vm.customerCurrCostObj = null;
  

      this.$onInit = function() {
        vm.containerObj = vm.fnGetAvailableContainer(vm.search_param.load_data.load_details_value); //Store selected container
        vm.getContainerWiseLeg();
        vm.fnGetAllLegTotal();
      }

      // initial available container object 
      function fnGetAvailableContainer(loadDetails){
        var result= {};

        loadDetails.forEach(function(load) {
          result[load.type] = {
            "legCurrencyTotal": 0,
            "customerCurrencyTotal": 0,
          }
        });
        return result;
      }

      function closePanel() {
        vm._mdPanelRef && vm._mdPanelRef.close();
      }
      
      function getContainerWiseLeg(){
        vm.cardLegCostArray=[];

        angular.forEach( vm.card.data[vm.buyOrSell],function(value,key){

          if(value.rate_obj && value.rate_obj.charges.length) {
          // store single leg name, currency, per container total cost
          var temp = {
            "leg_name" : value.rate_obj.leg_code == vm.l3_leg && value.leg_name == vm.mainFreightName ? 'Freight' : value.leg_name,
            "leg_currency" : value.rate_obj.leg_currency,
            "container" : angular.copy(vm.containerObj)
          };

          angular.forEach(value.rate_obj.charges,function(charges){
            if(charges.charge_basis == 'per equipment'){
                temp.container[charges.container_type].legCurrencyTotal += (charges.leg_currency_cost/charges.total_units); //leg charges per unit leg currency total

                temp.container[charges.container_type].customerCurrencyTotal += (charges.customer_currency_cost/charges.total_units);  //leg charges per unit customer currency total
            }         
            else if (charges.charge_basis === 'per container' && !charges.container_type) {
                    angular.forEach(temp.container, function (containerData) {
                        containerData.legCurrencyTotal += (charges.leg_currency_cost / charges.total_units);
                        containerData.customerCurrencyTotal += (charges.customer_currency_cost / charges.total_units);
                    });
                }
          });
        
          vm.cardLegCostArray.push(temp);
          }
        })
       
      }

      // get all leg per container total
      function fnGetAllLegTotal(){
        vm.CustomerCurrCostObj = angular.copy(vm.containerObj);

        angular.forEach(vm.cardLegCostArray, function(leg){
          angular.forEach(leg.container,function(value,key){
            vm.CustomerCurrCostObj[key].legCurrencyTotal += value.legCurrencyTotal; // all total in leg currency total
            vm.CustomerCurrCostObj[key].customerCurrencyTotal += value.customerCurrencyTotal;   // all total in customer currency total
          });
        });
      }
      
    }
  
  })();
  
(function () {
    'use strict';

    angular
      .module('app.core')
      .component('chargesDisplay', {
        templateUrl: 'app/main/component/charges-display/charges-display.html',
        bindings: {
            chargesData: '=',
            mode: '=',
            pageSource :'='
        },
        controller: chargesDisplayController
      });


    function chargesDisplayController(analytics, $mdPanel , util , resultService , $window) {

        var vm = this;
        vm.util = util ;
        vm.sourceData = {};
        vm.fnOpenCommentPanel = fnOpenCommentPanel;
        vm.downloadSource = downloadSource;
        vm.getBatchCodeList = getBatchCodeList; 
        vm.sourceDownload = sourceDownload;
       
        this.$onInit = function () {
          if(vm.pageSource === 'rateProviderBilling'){
            vm.downloadSource(vm.chargesData);
          }

        }
        function fnOpenCommentPanel(ev ,selectedCharge){

          var locals = {
            chargeObj:selectedCharge,
            hide_internal_comments : true,
          };
         util.fnOpenCommentPanel(ev , locals)

      }

       //Get source rate download function
       function downloadSource(legData){
        var batchcode=[];
        batchcode=vm.getBatchCodeList(legData)
        if(batchcode.length){
          resultService.getSourceRate(batchcode).then(function(response){
            vm.sourceData=angular.copy(response.data.data);
          })
        }
      }   
      function getBatchCodeList(legData){
        var batchcode = [];
        angular.forEach(legData,function(leg){
          if(leg.batchcode && leg.batchcode.length){
            batchcode=batchcode.concat(leg.batchcode);
          }
        }) 
        return batchcode;
      }
      function sourceDownload(batchcode){
        $window.open(util.sanitizeQueryParams(vm.sourceData[batchcode].sourceFileUrl));
      }
      

    }

  })();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('ChargeSelectController', ChargeSelectController);


  function ChargeSelectController(mdPanelRef, $mdSelect, $scope, util, $rootScope) {

    var vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.closePanel = closePanel;
    vm.trackEvent = trackEvent;
    vm.mdSelect = $mdSelect;
    vm.resetPanel = resetPanel;
    vm.clearAllLC = clearAllLC;
    vm.selectAllLC = selectAllLC;
    vm.getChangedValue = getChangedValue;
    vm.util = util;

  vm.getSelectedLegs = getSelectedLegs;

  vm.legList = [
    {
      'leg_key' : 'freight_charges',
      'leg_name' : 'Main Freight'
    },
    {
      'leg_key' : 'origin_charges',
      'leg_name' : 'Origin Charges'
    },
    {
      'leg_key' : 'origin_customs',
      'leg_name' : 'Origin Custom Charges'
    },
    {
      'leg_key' : 'destination_charges',
      'leg_name' : 'Destination Charges'
    },
    {
      'leg_key' : 'destination_customs',
      'leg_name' : 'Destination Custom Charges'
    }
  ]
    // condition to show error message for other details section
     getChangedValue();

    // Object declarations


    // Declare functions for template


    function getChangedValue(billType , eventName, value){
       // condition to show error message for other details section
       vm.showErrorMessage = (vm.searchMode ==='SEA-FCL' && (!vm.searchParam.load_data.load_details_value[0].bl_qty || !vm.searchParam.load_data.load_details_value[0].sbl_qty))||((vm.searchMode =='SEA-LCL' || vm.searchMode =='SEA-LCL') && (!vm.searchParam.load_data.load_meta.total_bl || !vm.searchParam.load_data.load_meta.total_sbl)) || (vm.searchMode =='FTL' && ( !vm.searchParam.units.sbl || !vm.searchParam.units.bl));
      //  mixpanel function
      if(billType){
        trackEvent(billType,eventName, value);
      }

      if(vm.is_independent_search){
        vm.legList.push({
          'leg_key' : 'pickup_selected',
          'leg_name' : 'Pickup Charges'
        },{
          'leg_key' : 'delivery_selected',
          'leg_name' : 'Delivery Charges'
        })
      }

    }

    function closePanel() {
      vm._mdPanelRef && vm._mdPanelRef.close();
    }

    

    function trackEvent(type, eventName, value) {
      if (type === "stuffing") {
        var stuffingType = vm.searchParam.stuffing === "F" ? "Factory" : "Dock";

      }

      if (type === "otherDetails") {
        util.callMixpanel(vm.pageSource + eventName, {
          Mode: vm.searchMode,
        });
      }
      if (type === "SelectAll") {
        util.callMixpanel(vm.pageSource + "-LocalCustoms-SelectAll-Click", {
          Mode: vm.searchMode,
        });
      }
     
      
    }

    // function to set values of legs in searchparams from selected leg list
    function getSelectedLegs(){
      for(var i = 0; i < vm.legList.length; i++){ 
        vm.searchParam[vm.legList[i].leg_key] = (vm.selectedlegs.indexOf(vm.legList[i])!==-1);
      }
    }

    // Function to reset panel data
    function resetPanel(){
      vm.clearAllLC();
      vm.searchParam.inco_term = '';
      vm.searchParam.impo_expo = '';
      if(vm.searchParam.mode === 'FTL'){
      vm.searchParam.units.sbl = 1;
      vm.searchParam.units.bl = 1;
      }else if(vm.searchParam.mode === 'SEA-LCL' || vm.searchParam.mode === 'AIR'){
        vm.searchParam.load_data.load_meta.total_bl = 1;
        vm.searchParam.load_data.load_meta.total_sbl = 1;
        if(vm.searchParam.mode === 'SEA-LCL'){
          vm.searchParam.load_data.load_meta.total_pallets = 1;
        }
      }else if(vm.searchParam.mode === 'SEA-FCL'){
        vm.searchParam.load_data.load_details_value[0].sbl_qty = 1;
        vm.searchParam.load_data.load_details_value[0].bl_qty = 1;
      }
      $scope.$broadcast ('resetIncoterm');
    }

    function clearAllLC(){
      if(vm.searchParam.mode == 'AIR' || (vm.searchParam.mode !== 'AIR' && $rootScope.domainData.domain_info.ENABLE_DEFAULT_FREIGHT_SELECTION)){
        var selectedLegTemp = [];
        for(var i = 0; i < vm.selectedlegs.length; i++){ 
          if(vm.selectedlegs[i].leg_key === 'freight_charges' || vm.selectedlegs[i].leg_key === 'pickup_selected' || vm.selectedlegs[i].leg_key === 'delivery_selected'){
            selectedLegTemp.push(vm.selectedlegs[i]);
          } 
        }
        vm.selectedlegs = selectedLegTemp;
      }else{
        vm.selectedlegs = vm.selectedlegs.filter(function(leg) {
          return leg.leg_key === 'pickup_selected' || leg.leg_key === 'delivery_selected';
        });
      }
      vm.getSelectedLegs();
    }

    function selectAllLC(){ 
      for(var i = 0; i < vm.legList.length; i++){ 
        if(vm.legList[i].leg_key === 'pickup_selected' || vm.legList[i].leg_key === 'delivery_selected'){
          var isSelected = vm.selectedlegs.some(function(leg) {
            return leg.leg_key === vm.legList[i].leg_key;
          });
          if(isSelected){ vm.selectedlegs.push(vm.legList[i]);}
        }else{
          vm.selectedlegs.push(vm.legList[i]);
        }
      }
      vm.trackEvent('SelectAll')
    }


  }

})();

(function () {
    "use strict";
    angular
    .module('app.core')
    .controller('chargeLevelCommentsController', chargeLevelCommentsController);
   
    function chargeLevelCommentsController(mdPanelRef, util,$rootScope, $scope, analytics) {

       //  variables
        var vm = this;
        vm._mdPanelRef = mdPanelRef;
        vm.util=util;
        vm.isShared = false;
        vm.copyOfChargeObj;
        // methods
        vm.fnSubmitComments = fnSubmitComments;
        vm.closePanel = closePanel;



        this.$onInit = function () {
            vm.commentsCkEditorConfig = angular.copy(vm.util.ckEditorConfig);
            // disabling the editor
            if(util.isShipper || !vm.quoteEdit || vm.hide_internal_comments){
                vm.commentsCkEditorConfig.readOnly =  true;
            }
            vm.isShared = util.isSharedPage() || util.isSharedQuote() || !util.isOwnVendorRate(vm.vendor_id);
            vm.copyOfChargeObj = angular.copy(vm.chargeObj);

            vm.copyOfChargeObj.internal_comments = util.decodeValue(vm.copyOfChargeObj.internal_comments);

            vm.copyOfChargeObj.external_comments =  util.decodeValue(vm.copyOfChargeObj.external_comments);
        }

        function fnSubmitComments(){
            
            vm.chargeObj.internal_comments = util.encodeValue(vm.copyOfChargeObj.internal_comments);
            vm.chargeObj.external_comments =  util.encodeValue(vm.copyOfChargeObj.external_comments);
            // copying comments from sell to buy   
            if(vm.buyCharge){
                 vm.buyCharge.internal_comments = angular.copy(vm.chargeObj.internal_comments);
                 vm.buyCharge.external_comments = angular.copy(vm.chargeObj.external_comments);
             }
            closePanel('');
            
        }

        function closePanel(type) {
            if(type){
                // analytics.track("RateCard-addComments-Cancel-Click")
            }
            vm._mdPanelRef && vm._mdPanelRef.close();
          }
        
    }


})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .component('cargoTypeSelection', {
        templateUrl: 'app/main/component/cargo-type-selection/cargo-type-selection.html',
        bindings: {
            cargoTypeData: '=',
            hazardousValue: '=',
            fullBorder: '=',
            isRequired: '<',
            isDisabled: '=',
            isValid: '=',
            category: '=',
            mode: '=',
            pageSource: '=',
            callback : '&'
        },
        controller: CargoTypeSelectionController
      });


    function CargoTypeSelectionController($log, resultService, util) {

        var vm = this;
        vm.fnGetCargoTypeList = fnGetCargoTypeList;
        vm.changeCargoType = changeCargoType;
        vm.searchText = searchText;
        vm.fnTrackAnalytics=fnTrackAnalytics;
        vm.cargoTypeList = [{"name":"FAK","code":"FAK"},{"name":"Perishable","code":"PERISHABLE"},{"name":"Non-Perishable","code":"NON_PERISHABLE"},{"name":"Hazardous","code":"HAZARDOUS"},{"name":"Chilled","code":"CHILLED"},{"name":"Out of Gauge","code":"OUT_OF_GAUGE"},{"name":"Flexi-bags","code":"FLEXI_BAGS"}];


        this.$onInit = function () {
            vm.fnGetCargoTypeList();
            if(vm.isDisabled && vm.cargoTypeData == null) {
              vm.cargoTypeData = {"name":"FAK","code":"FAK"};
            }

        }

        // get cargo type list
        function fnGetCargoTypeList(){
            // if(resultService.cargoTypeList.length){
            //     vm.cargoTypeList = resultService.cargoTypeList;
            // }else{
                var currentMode = vm.mode.includes('-') ? vm.mode.split('-')[1] : vm.mode;
                resultService.getCargoList(currentMode).then(function(response){
                    // if(!resultService.cargoTypeList.length){
                        
                        if( response.data.data.length > 0){
                            resultService.cargoTypeList = response.data.data;
                            vm.cargoTypeList = resultService.cargoTypeList;
                        }
                    // }
                },function(error){
                    vm.cargoTypeList = [];
                });
            // }
        }

        function changeCargoType(){
            if(vm.hazardousValue != undefined){
                if(vm.cargoTypeData.name.toLowerCase() == 'hazardous'){
                    vm.hazardousValue = true;
                }else{
                    vm.hazardousValue = false;
                }
            }
            vm.callback({'value': vm.hazardousValue});
        }

        function searchText(type ,event){
            if(vm.category=="booking"){
                util.callMixpanel("BS-"+type+"-Search",{
                    "Search Query": event.target.value,
                })
            }
            else if(vm.category=="RR"){
                util.callMixpanel("RR-RequestBetterRates-"+type+"-Search",{
                    "Search Query": event.target.value
                });
            }
            else if(vm.category){
                util.callMixpanel("SD-"+vm.category+"-POP-"+type+'-Search',{
                    "Search Query": event.target.value
                });
            }
                
        }
        function fnTrackAnalytics(event, params){
            if(!params){
                params = {};
            }
            var shortPageName = '';
            if(vm.pageSource && vm.pageSource.includes('RateCard')){
                if(vm.pageSource.includes('Inquiry')){
                shortPageName = 'ID';
                }
                else if(vm.pageSource.includes('Quote')){
                if(vm.pageSource.includes('Copy')){
                    shortPageName = 'QC';
                }
                else{
                    shortPageName = 'QD';
                }
                }
                else{
                shortPageName = 'RR';
                }
                params.mode = vm.mode;
                params.action = vm.pageSource.includes('new') ? 'add' : 'edit';
                util.callMixpanel(shortPageName+'-RateCard-'+event,params);
            }
            else if(vm.pageSource){
                params.mode = vm.mode;
                util.callMixpanel(vm.pageSource+'-'+event, params);
            }
        }

    }

  })();

(function () {
    "use strict";
  
    angular
      .module("app.core")
      .controller("CargoCommodityViewController", CargoCommodityViewController)
      .factory("cargoCommodityViewFactory", function () {
        return {panelClosed: false};
      });
  
    function CargoCommodityViewController(mdPanelRef, cargoCommodityViewFactory) {
  
      var vm = this;
      vm._mdPanelRef = mdPanelRef;
      vm.closePanel = closePanel;
  
      // Variable Declaration
      vm.cargoCommodityViewFactory = cargoCommodityViewFactory;
  
      // Declare functions for template
      function closePanel() {
        vm._mdPanelRef && vm._mdPanelRef.close();
      }
  
    }
  
  })();
  
(function () {
    'use strict';

    angular
      .module('app.core')
      .component('billingInfoCharges', {
        templateUrl: 'app/main/component/billing-info-charges/billing-info-charges.html',
        bindings: {
            billRates:'=',
            mode: '=',
            allInQuoteSetting:'=',
            sourceData:'=',
            pageSource:'=',
            userData: '=',
            isOwnVendorRate: '='
        },
        controller: billingInfoChargesController
      });
      function billingInfoChargesController($log, $rootScope,resultService,analytics,localStorageService,util,ShipmentService,$window) {

        var vm = this;
        vm.util = util;
        vm.resultId = ShipmentService.shipmentManagementObj.shipment_meta._id;
        vm.profitPercentage = null;
        vm.sourceData = null;
        vm.showExchangeRates = $rootScope.domainData.domain_info.SHOW_EXCHANGE_RATES;;
        vm.cardVendorId = null;
        vm.vendorId = parseInt(localStorageService.get('authToken').value.vendor_id);
        vm.buyRateExists = null;
        vm.trackEvent=trackEvent;
        vm.calulateRateTotal=calulateRateTotal;
        vm.calulateBuyRateTotal = calulateBuyRateTotal;
        vm.sourceLinkDownload = sourceLinkDownload;
        vm.calulateProfit = calulateProfit;
        vm.checkBuyRateExists = checkBuyRateExists;
        vm.isString = isString;
        vm.fnOpenCommentPanel = fnOpenCommentPanel;
        this.$onInit = function () {
          vm.cardVendorId = !!(vm.billRates.length) ? vm.billRates[0].vendor_id : vm.vendorId;
          vm.checkBuyRateExists();
        }
        
/**
         * function to calculate all cards total
         * @param {*} cardLegs
         */
function calulateRateTotal(){
    var total = 0;
    angular.forEach(vm.billRates,function(item){
        if(item.leg_status != 'REMOVED'){
            total += parseFloat(item.leg_total_cost);
        }
    });
    return total;
}
function calulateBuyRateTotal() {
    var total = 0;
    angular.forEach(vm.billRates, function (item) {
      if (item.buy && item.leg_status != 'REMOVED') {
        total += parseFloat(item.buy.leg_total_cost || 0);
      }
    });
    return total;
  }
vm.avblLegIcon = ['l1', 'l2', 'l3', 'l4', 'l5'];
//Get source rate download function
  function sourceLinkDownload(batchcode){
    vm.trackEvent("SD-BillingInfo-DownloadSource");
    $window.open(util.sanitizeQueryParams(vm.sourceData[batchcode].sourceFileUrl));
  }
  function trackEvent(type){
    analytics.track(type);
  }
  function isString(data) {
    if(typeof data === 'string') {
      return true;
    } else {
      return false;
    }
  }
  function calulateProfit(buy, sell) {
    vm.profitPercentage = (((sell-buy) / buy) * 100);
    return (sell-buy);
  }
  function checkBuyRateExists() {
    vm.buyRateExists = false;
    vm.billRates.some(function(i,k) {
      if(i.buy) {
        vm.buyRateExists = true;
        vm.buyRateIndex = k;
        return true;
      }
    });
  }

  function fnOpenCommentPanel(ev ,selectedCharge){

    var locals = {
      chargeObj:selectedCharge,
      hide_internal_comments : true,
    };
   util.fnOpenCommentPanel(ev , locals)

}
}
})();

(function () {
  "use strict";

  angular.module("app.bookingFormV2", []).config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      .state("app.createBooking", {
        url: "/create-booking?source",
        views: {
          "content@app": {
            templateUrl: "app/main/booking-v2/booking-form-v2/booking-form-v2.html",
            controller: "BookingFormV2Controller as vm"
          }
        },
        bodyClass: "booking-Create-V2",
        resolve: {
          BookingData: function(util, $window, $stateParams) {
            if ($stateParams.source && !Object.keys(util.bookingData || {}).length) {
              $window.history.back();
            }
          }
        }
      })
      .state("app.editBooking", {
        url: "/edit-booking/:id?source",
        views: {
          "content@app": {
            templateUrl: "app/main/booking-v2/booking-form-v2/booking-form-v2.html",
            controller: "BookingFormV2Controller as vm"
          }
        },
        bodyClass: "booking-Edit-V2"
      });
  }
})();
(function () {
  "use strict";

  angular
    .module("app.bookingFormV2")
    .controller("BookingFormV2Controller", BookingFormV2Controller);

  /** @ngInject */
  function BookingFormV2Controller(
    util,
    $state,
    $stateParams,
    iframeService,
    $scope,
    $timeout,
    $rootScope
  ) {
    var vm = this;
    vm.util = util;
    vm.bookingId = $stateParams.id;
    vm.isEditMode = $state.current.name === "app.editBooking";
    vm.iframeService = iframeService;
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.init();

    $scope.$on("$destroy", function () {
      if (window.removeEventListener) {
        window.removeEventListener("message", getBookingFormIframeRequest, true);
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", getBookingFormIframeRequest);
      }
    });

    function init() {
      vm.minHeight = vm.iframeService.iframeHeight;

      if (!(util.navPermission.shipments && util.navPermission.shipments[1] && util.isEfpEnabled)) {
        $state.go("app.pages_share_error");
      }
      // Clear old booking data if coming from toolbar/manual navigation
      if (!$stateParams.source || $stateParams.source === 'manual') {
        util.bookingData = {};
      }

      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

      $timeout(function () {
        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        vm.formIframeUrl();
      }, 400);

      if (window.addEventListener) {
        window.addEventListener("message", getBookingFormIframeRequest, true);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", getBookingFormIframeRequest, true);
      }
    }

    $rootScope.$on('app.bookingFormV2', function(event, args) {
      init();
    });

    function formIframeUrl() {
      vm.iframeUrl = iframeService.fnGetIframeUrl("create-bookingv2", "", "web");
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl,
        "&createBookingAccessData=1&permissionDataAccess=true&parentUrl=" + window.location.origin);
      document.getElementById("booking-form-v2-iframe").src = vm.iframeUrl;
    }

    function getBookingFormIframeRequest(event) {
      if (!event.data.source) {
        return;
      }
      
      if (event.origin.indexOf(util.iframeOrigin)) {
        var targetOrigin = (new URL(vm.iframeUrl)).origin;
        
        if (event.data.source === "create-bookingv2" && event.origin === targetOrigin && document.getElementById("booking-form-v2-iframe")) {
          var bookingCards = util.bookingData.cards && util.bookingData.cards.length
            ? util.bookingData.cards
            : (util.bookingData.card ? [util.bookingData.card] : []);
          document.getElementById("booking-form-v2-iframe").contentWindow.postMessage(
            {
              dataSource: "create-bookingv2",
              card: bookingCards[0] || util.bookingData.card,
              cards: bookingCards,
              source:util.bookingData.source,
              bookingData:util.bookingData.bookingData,
              bookingId:util.bookingData.bookingId,
              mode:util.bookingData.mode,
              pageSource:util.bookingData.pageSource,
              from:util.bookingData.from,
              termsAndCondition:  util.bookingData.termsAndCondition || null,
              resumeChargeDetails: !!util.bookingData.resumeChargeDetails,
              headerFormValue: util.bookingData.headerFormValue || null,
              existingCardCountForBasket: util.bookingData.existingCardCountForBasket || 0,
              navPermission: util.navPermission
            },
            targetOrigin
          );
          return;
        }
        if (event.data.reqData === "permissionDataAccess") {
          if (!vm.iframeUrl) {
            return;
          }
          var permissionTargetOrigin = new URL(vm.iframeUrl).origin;
          if (event.origin === permissionTargetOrigin) {
            var bookingIframe = document.getElementById("booking-form-v2-iframe");
            if (bookingIframe && bookingIframe.contentWindow) {
              bookingIframe.contentWindow.postMessage(
                { navPermission: util.navPermission, dataSource: "permissionModule" },
                permissionTargetOrigin
              );
            }
          }
          return;
        }

        if (event.data.source === "goToBasket") {
          util.applyBookingBridgePayload(event.data);
          if (event.data.selectedCard) {
            util.oneQuoteData.selectedCard = event.data.selectedCard;
          }
          util.oneQuoteData.pageSource = event.data.pageSource;
          util.oneQuoteData.quoteData = event.data.quoteData;
          util.oneQuoteData.searchParam = event.data.searchParam;
          util.oneQuoteData.currencyConversion = event.data.currencyConversion;
          util.oneQuoteData.from = event.data.from;
          util.oneQuoteData.searchId = event.data.searchId;
          $timeout(function () {
            $state.go("app.basketModule");
          });
          return;
        }

        if(event.data.source === 'booking-details'){
            $state.go("app.quoteListModule.quoteDetailsModule",{ id: event.data.id });
        }
        
        if (event.data.source === "redirectToBookingList") {
          $timeout(function() {
            $state.go("app.bookingv2");
          });
        }

        if (event.data.source === "bookingDetails") {
          $state.go("app.bookingv2.bookingDetailsV2", { id: event.data.id });
        }
        
        if (event.data.source === "redirectToHome") {
          $timeout(function() {
            $state.go(util.isEfpEnabled ? "app.searchV2Module" : "app.search");
          });
        }

        if (event.data.source === "customer") {
          var targetUrl = $state.href("app.shippers", {}, { absolute: true }); 
          window.open(targetUrl, "_blank");
        }

        if(event.data.source === 'cancelBooking'){
            $state.go($rootScope.previousState, $rootScope.previousParams, { reload: true });
          }
      }
    }
  }
})();
(function () {
  "use strict";

  angular.module("app.bookingv2", []).config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state("app.bookingv2", {
        url: "/booking-list",
        views: {
          "content@app": {
            templateUrl:
              "app/main/booking-v2/booking-v2-list/booking-v2-list.html",
            controller: "BookingListV2Controller as vm"
          }
        },
        bodyClass: "booking-List-V2"
      })
      .state("app.bookingv2.bookingDetailsV2", {
        url: "/:id",
        views: {
          "content@app": {
            templateUrl: "app/main/booking-v2/booking-details-v2/booking-details-v2.html",
            controller: "BookingDetailsV2Controller as vm"
          }
        },
        bodyClass: "booking-Details-V2"
      });
  }
})();

(function () {
  "use strict";

  angular
    .module("app.bookingv2")
    .controller("BookingListV2Controller", BookingListV2Controller);

  /** @ngInject */
  function BookingListV2Controller(
    util,
    $state,
    iframeService,
    $scope,
    $rootScope,
    $timeout,
    $window
  ) {
    // Variables
    var vm = this;
    vm.util = util;

    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.init();

    $scope.$on("$destroy", function () {
      if (window.removeEventListener) {
        window.removeEventListener(
          "message",
          getEnquiryListIframeRequest,
          true
        );
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", getEnquiryListIframeRequest);
      }
    });

    function init() {
      // util.isModulePaid('oneQuote');
      vm.minHeight = vm.iframeService.iframeHeight;

      if (
        !(
          util.navPermission.shipments &&
          util.navPermission.shipments[1] &&
          util.isEfpEnabled
        )
      ) {
        $state.go("app.pages_share_error");
      }

      util.callMixpanel("EFP-Booking-V2-list");
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

      $timeout(function () {
        var windowHeight =
          document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        vm.formIframeUrl();
      }, 400);

      if (window.addEventListener) {
        window.addEventListener("message", getEnquiryListIframeRequest, true);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", getEnquiryListIframeRequest, true);
      }
    }

    $rootScope.$on('app.bookingv2', function(event, args) {
      init();
    });

    // get iframe url
    function formIframeUrl() {
      vm.iframeUrl = iframeService.fnGetIframeUrl("bookingv2", "", "web");
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl,
        "&reqAccessV2bookingListV2=1&parentUrl=" +
        window.location.origin +
        "&maxHeight=" +
        vm.minHeight["max-height"]);
      document.getElementById("booking-list-v2-iframe").src = vm.iframeUrl;
    }

    function getEnquiryListIframeRequest(event) {
      if (!event.data.source) {
        return;
      }
      if (
        event.origin.indexOf(util.iframeOrigin) &&
        document.getElementById("booking-list-v2-iframe")
      ) {
        if (event.data.source === "bookingDetails") {
          $state.go("app.bookingv2.bookingDetailsV2", { id: event.data.id });
        }
        if (event.data.source === "create-bookingv2") {
          vm.util.redirectToBooking(event);
        }
        if (event.data.source === "old-Bookings") {
          $window.open("/shipments", "_blank");
        }
      }
      if (event.data.source === "redirectToHome") {
        $state.go(util.isEfpEnabled ? "app.searchV2Module" : "app.search");
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.bookingv2")
    .controller("BookingDetailsV2Controller", BookingDetailsV2Controller);

  /** @ngInject */
  function BookingDetailsV2Controller(
    util,
    $state,
    $stateParams,
    iframeService,
    $scope,
    $rootScope,
    $timeout
  ) {
    var vm = this;
    vm.util = util;
    vm.bookingId = $stateParams.id;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.init();

    $scope.$on("$destroy", function () {
      if (window.removeEventListener) {
        window.removeEventListener("message", getBookingDetailsIframeRequest, true);
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", getBookingDetailsIframeRequest);
      }
    });

    function init() {
      vm.minHeight = vm.iframeService.iframeHeight;

      if (!(util.navPermission.shipments && util.navPermission.shipments[1] && util.isEfpEnabled)) {
        $state.go("app.pages_share_error");
      }

      util.callMixpanel("EFP-Booking-V2-details");
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

      $timeout(function () {
        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        vm.formIframeUrl();
      }, 400);

      if (window.addEventListener) {
        window.addEventListener("message", getBookingDetailsIframeRequest, true);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", getBookingDetailsIframeRequest, true);
      }
    }

    function formIframeUrl() {
      vm.iframeUrl = iframeService.fnGetIframeUrl("bookingv2", "", "web");
      vm.iframeUrl = vm.iframeUrl.replace(
                "/shared",
                "/" + $state.params.id + "/shared"
              );
     vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&reqAccessV2bookingDetailsV2AccessData=1&parentUrl=" + window.location.origin + "&bookingId=" + vm.bookingId + "&maxHeight=" + vm.minHeight["max-height"]);
      document.getElementById("booking-details-v2-iframe").src = vm.iframeUrl;
    }

    function getBookingDetailsIframeRequest(event) {
      if (!event.data.source) {
        return;
      }
      if (event.origin.indexOf(util.iframeOrigin) && document.getElementById("booking-details-v2-iframe")) {
        if (event.data.source === "redirectToBookingList") {
          $state.go("app.bookingv2");
        }
      }
      if (event.data.source === "redirectToHome") {
        $state.go(util.isEfpEnabled ? "app.searchV2Module" : "app.search");
      }
       if (event.data.source === "quotes") {
         $state.go("app.quoteListModule.quoteDetailsModule", {
           id: event.data.id
         });
       }
       if (event.data.source === "enquiry") {
         $state.go("app.enquiry.enquiryDetails", { id: event.data.id });
       }
      if (event.data.source === "customer") {
          var targetUrl = $state.href("app.shippers", {}, { absolute: true }); 
          window.open(targetUrl, "_blank");
        }
      if (event.data.source === "create-bookingv2") {
             vm.util.redirectToBooking(event);
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.bannerBroadcast', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.bannerBroadcast', {
                url    : '/bannerBroadcast',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/banner/banner.html',
                        controller : 'BannerController as vm'
                    }
                   
                },
                bodyClass: 'banner-page'
            });
      

    }


})();

(function(){
    'use strict';

    angular.module('app.bannerBroadcast')
    .factory('BannerService' , BannerService);

    /** @ngInject */
    function BannerService($q,$log,$mdToast,localStorageService, api, $http,$rootScope, util)
    {
        var BannerService = {
            deleteBanner:deleteBanner,
            createBanner:createBanner,
            updateBanner:updateBanner,
            getBannerIconList:getBannerIconList,
        };

        return BannerService;
        function deleteBanner(id){
            var url = api.baseUrl + '/api/v1/notices/'+id;
            return $http.delete(url);
          }
          function createBanner(data){
            var url = api.baseUrl + '/api/v1/notices';
            return  $http.post(url, data);
       }

       function updateBanner(data , id){
        var url = api.baseUrl + '/api/v1/notices/'+id;
        return $http.put(url, data);
    }
    function getBannerIconList(){
        var url = api.baseUrl + '/api/v1/icons';
        return $http.get(url);
        }

    }

}());

(function ()
{
    'use strict';

    angular
        .module('app.dashboard', ['ui.grid','ui.grid.rowEdit','ui.grid.selection','ui.grid.resizeColumns','ui.grid.infiniteScroll','ui.grid.pagination'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.dashboard', {
                url    : '/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/analytics/dashboard/dashboard.html',
                        controller : 'DashboardController as vm'
                    },
                    data : { pageTitle: 'dashboard' }
                },
                bodyClass: 'dashboard-page'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/dashboard');

        // Api
        // msApiProvider.register('quotes', ['app/data/quotes/quotes.json']);

        // msNavigationServiceProvider.saveItem('fuse.dashboard', {
        //     title    : 'Dashboard',
        //     icon     : 'icon-tile-four',
        //     state    : 'app.dashboard',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'DASHBOARD.DASHBOARD_NAV',
        //     weight   : 1
        // });
    }
})();

(function(){

    'use strict';

    angular
        .module('app.dashboard')
        .factory('DashboardService' , DashboardService);

        /** @ngInject */
        function DashboardService($q, $log, $mdToast, $state, $http, api, util){

            var dashboardService = {
                getDashboardData : getDashboardData,
                getGraphData : getGraphData,
                getDonutGraphData : getDonutGraphData,
                quoteInsightData : quoteInsightData,
                quoteStatsData : quoteStatsData,
                shipmentStatsData: shipmentStatsData,
                quotePerformanceData : quotePerformanceData,
                getDepartmentList: getDepartmentList,
                getDesignationList: getDesignationList,
                getLocationList: getLocationList,
                getRolesList:getRolesList,
                getTagList: getTagList,
                getStackInsightTableData: getStackInsightTableData,
                getCompanylist: getCompanylist,
                getUserlist: getUserlist,
                getTeamlist: getTeamlist,
                shipmentInsightData: shipmentInsightData,
                shipmentPerformanceData: shipmentPerformanceData,
                getAnalyticsUrl : getAnalyticsUrl,
                getReportsData : getReportsData,
                saveGraphData : '',
                quotesStatusTableData: null,
                quotesInsightTableData: null,
                quotesPerformanceTableData: null
            }
            return dashboardService;

            function getDashboardData(){
                var url = api.baseUrl + '/api/get-shipment-stats' + util.fnGetForwarderIdApi('?');
                return $http.get(url);
            }

            function getStackInsightTableData(data, link) {
              var url = api.baseUrl + '/' + link;
              return $http.post(url, data);
            }

            function getDonutGraphData(){
                var url = api.baseUrl + '/api/get-quote-stats ';
                return $http.get(url).then(function(response){
                    return response;
                },function(error){
                    $log.log(error);
                });
            }

            function getGraphData(start, end) {
              var url = api.baseUrl + '/api/shipment-stats' + util.fnGetForwarderIdApi('?') + (util.fnGetForwarderIdApi('?') ?  '&' : '?') +'from='+start+'&to='+end+' '+ '11:59:59';
              return $http.get(url);
            }

            function quoteInsightData(data) {
              var url = api.baseUrl + '/api/quote-history-count';
              return $http.post(url, data);
              // var url = 'https://api.myjson.com/bins/19vl28';
              // return $http.get(url);
            }

            function shipmentInsightData(data) {
              // var url = 'https://cb62a426-319e-45c9-a3b1-c8b07928e7d3.mock.pstmn.io/api/shipments-insight';
              // return $http.post(url, data);
              var url = api.baseUrl + '/api/shipment-history-count';
              return $http.post(url, data);
            }

            function quoteStatsData(data) {
              var url = api.baseUrl + '/api/quote-status-count' + util.fnGetForwarderIdApi('?');
              return $http.post(url, data);
              // var url = 'https://api.myjson.com/bins/qtppc';
              // return $http.get(url);
            }

            function shipmentStatsData(data) {
              // var url = 'https://cb62a426-319e-45c9-a3b1-c8b07928e7d3.mock.pstmn.io/api/shipments-stats';
              // return $http.post(url, data);
              var url = api.baseUrl + '/api/shipment-status-count' + util.fnGetForwarderIdApi('?');
              return $http.post(url, data);

            }

            function quotePerformanceData(data) {
              var url = api.baseUrl + '/api/quote-performance-count';
              return $http.post(url, data);
              // var url = 'https://api.myjson.com/bins/h7760';
              // return $http.get(url);
            }

            function shipmentPerformanceData(data) {
              // var url = 'https://cb62a426-319e-45c9-a3b1-c8b07928e7d3.mock.pstmn.io/api/shipments-performance';
              // return $http.post(url, data);
              var url = api.baseUrl + '/api/shipment-performance-count';
              return $http.post(url, data);
            }

            function getDepartmentList(id) {
              var url = api.baseUrl + '/api/department-list';
              if(id != null){
                url += '?forwarder_company_id=' + id;
              }
              return $http.get(url);
            }

            function getDesignationList(id) {
              var url = api.baseUrl + '/api/designation-list';
              if(id != null){
                url += '?forwarder_company_id=' + id;
              }
              return $http.get(url);
            }

            function getLocationList(id) {
              var url = api.baseUrl + '/api/location-list';
              if(id != null){
                url += '?forwarder_company_id=' + id;
              }
              return $http.get(url);
            }

            function getRolesList(id) {
              var url = api.baseUrl + '/api/roles-list';
              if(id != null){
                url += '?forwarder_company_id=' + id;
              }
              return $http.get(url);
            }

            function getTagList(id) {
              var url = api.baseUrl + '/api/tag-list';
              if(id != null){
                url += '?forwarder_company_id=' + id;
              }
              return $http.get(url);
            }

            function getCompanylist(url) {
              return $http.get(url).then(function(response){
                return response;
              },function(error){
                  console.log(error);
              });
              // var url = api.baseUrl + '/api/shipper-company-list';
              // if(id != null){
              //   url += '?forwarder_company_id=' + id;
              // }
              // return $http.get(url);
            }

            function getTeamlist(id) {
              var url = api.baseUrl + '/api/assigned-team-list';
              if(id != null){
                url += '?forwarder_company_id=' + id;
              }
              return $http.get(url);
            }

            function getUserlist(id) {
              var url = api.baseUrl + '/api/user-list';
              if(id != null){
                url += '?forwarder_company_id=' + id;
              }
              return $http.get(url);
            }

            function getAnalyticsUrl(question){
              var url = api.baseUrl + '/api/metabase-url?question='+question; // question is metabse analytics id
              return $http.get(url);
            }

            function getReportsData(query){
              var url = api.baseUrl + '/api/list-reports?menu='+query; 
              return $http.get(url);
            }

            function formIframeUrl(id, dataBrainList) {
              vm.iframeUrl = iframeService.fnGetIframeUrl(id);
              $timeout(function () {
                document.getElementById(id).src = vm.iframeUrl
                vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
                document.getElementById(id).onload = function() {
                  var targetOrigin = (new URL(vm.iframeUrl)).origin;
                  document.getElementById(id).contentWindow.postMessage({
                    dataBrainList : vm.dataBrainList
                  },targetOrigin);
                }
              }, 50);
            };

        }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reports', ['ui.grid','ui.grid.rowEdit','ui.grid.selection','ui.grid.resizeColumns','ui.grid.infiniteScroll','ui.grid.pagination'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.reports', {
                url    : '/reports',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/analytics/reports/reports.html',
                        controller : 'ReportsController as vm'
                    },
                    data : { pageTitle: 'Reports' }
                },
                bodyClass: 'reports-page'
            });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('ReportsController', ReportsController);

  function ReportsController(DashboardService, $sce, $scope, $timeout, analytics, util, iframeService,$state, $rootScope) {
    var vm = this;
    vm.util = util;
    vm.init = init;
    vm.lastUpdateUrl = "";
    vm.spinRefreshIcon = false;
    vm.metabaseUrl = "";
    vm.isLoading = true;
    vm.iframe = null;
    vm.trackMixpanel = trackMixpanel;
    vm.reportTabArray = [];
    vm.dataBrainList = [];
    
    vm.getAnalyticsUrl = getAnalyticsUrl;
    vm.checkIframeLoaded = checkIframeLoaded;
    vm.fnAppendIframeSrc = fnAppendIframeSrc;
    vm.fnGetReports = fnGetReports;
    vm.formIframeUrl = formIframeUrl;


    var windowHeight = angular.element(window).height() - 89; //set max height for quote list scroll

    function init() {
      util.isModulePaid('reports');
      if(!(util.navPermission.reports && util.navPermission.reports[1])){
        $state.go('app.pages_share_error');
      }
      else{
        vm.fnGetReports();
      }
    };
    vm.init();

    $rootScope.$on('app.reports', function(event, args) {
      init();
    });

    function getAnalyticsUrl(action,question,iframeUrl) {
      var iframeId = 'metabase-iframe-'+question;
      vm.iframe = document.getElementById(iframeId);
      vm.iframe.hidden = true;
      vm.isLoading = true;
      vm.spinRefreshIcon = true;

      if(action == 'refresh'){
        DashboardService.getAnalyticsUrl(question).then(
          function (response) {
            vm.checkIframeLoaded();
            vm.fnAppendIframeSrc(response.data.data.url);
          },
          function (err) {
            console.log(err);
            vm.spinRefreshIcon = false;
            vm.isLoading = false;
          }
        );
      }else{
        vm.checkIframeLoaded();
        vm.fnAppendIframeSrc(iframeUrl);
      }
    }

    function fnAppendIframeSrc(url){
      vm.metabaseUrl = $sce.trustAsResourceUrl(url);
      vm.lastUpdateUrl = moment(new Date()).format("hh:mm A");
      vm.spinRefreshIcon = false;
    }


     //  display metabase tab
     function fnGetReports(){
      util.isCallingApi = true;
      DashboardService.getReportsData("Reports").then(function (response) {
        var responseArray = response.data.reports;
        util.isCallingApi = false;

        responseArray.forEach(function (value) {
          if(value.partner === 'Databrain' && value.sub_menu === 'Reports'){
            vm.dataBrainList.push(value);
          }
          else if (value.partner === 'Metabase'){
            value['isLoaded'] = false;
            vm.reportTabArray.push(value);
          }
        });

        if(vm.dataBrainList.length){
          vm.formIframeUrl();
        }

        if(vm.reportTabArray.length){
          vm.reportTabArray[0]['isLoaded'] = true;
          $timeout(function(){
            vm.getAnalyticsUrl('init',vm.reportTabArray[0].external_report_id, vm.reportTabArray[0].url);
          },0)
        }
      }, function (error) {
        util.isCallingApi = false;
      });
      
    }

    function formIframeUrl() {
      vm.iframeUrl = iframeService.fnGetIframeUrl('liveReports');
      $timeout(function () {
        document.getElementById("liveReports").src = vm.iframeUrl
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        document.getElementById('liveReports').onload = function() {
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
          document.getElementById('liveReports').contentWindow.postMessage({
            dataBrainList : vm.dataBrainList
          },targetOrigin);
        }
      }, 50);
    };

    function checkIframeLoaded() {
      vm.iframe.onload = function() { 
        vm.iframe.hidden = false;
        vm.isLoading = false;
        $scope.$apply();
      };
    } 
    function trackMixpanel(event_name, data){

      if(data && !data.isLoaded){
        var isDataAvl =  vm.reportTabArray.find(function(item){
          return item.id == data.id;
        });

        if(isDataAvl){
          isDataAvl.isLoaded = true;
        }
        $timeout(function(){
          vm.getAnalyticsUrl('init',data.external_report_id, data.url); 
        },0)
      }
      
      //mixpanel code
      analytics.track(event_name);
    }
    function formIframeUrl() {
      var windowHeight = $(window).height() - 89; //set max height for quote list scroll
      vm.iframeUrl = iframeService.fnGetIframeUrl('liveReports');
      $timeout(function () {
        document.getElementById("liveReports").src = vm.iframeUrl
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        document.getElementById('liveReports').onload = function() {
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
          document.getElementById('liveReports').contentWindow.postMessage({
            dataBrainList : vm.dataBrainList
          },targetOrigin);
        }
      }, 50);
    };
    
    
  }
})();

(function () {
  'use strict';

  angular
    .module('app.dashboard')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController(util,iframeService,$timeout,$state, $rootScope) {
    // Initialize
    var vm = this;
    vm.util = util;
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    var windowWidth = angular.element(window).width(); //set max Width for notification list scroll
    var windowHeight = angular.element(window).height() - 89;
    if (windowWidth < 960) {
      vm.maxWidth = {
        'width': 960
      }
    } else {

      if(vm.util.activatedTheme !== 'transpost') {
        vm.maxWidth = {
          'width': (windowWidth - 120)
        }
      }
        else {
          vm.maxWidth = {
            'width': windowWidth
          }
        }
    }
  
   
    // vm.trackMixpanel = trackMixpanel;
  
    function init() {
      util.isModulePaid('dashboard');
      if(!(util.navPermission.dashboard && util.navPermission.dashboard[1])){
        $state.go('app.pages_share_error');
      }
      vm.formIframeUrl('dashboard');
    }
    vm.init();

    $rootScope.$on('app.dashboard', function(event, args) {
      init();
    });
 

    function formIframeUrl(id) {
      vm.iframeUrl = iframeService.fnGetIframeUrl(id);
      $timeout(function () {
        document.getElementById(id).src = vm.iframeUrl;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        document.getElementById(id).onload = function() {
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
          document.getElementById(id).contentWindow.postMessage({
            dataBrainList : vm.dataBrainList
          },targetOrigin);
        }
      }, 50);
    };

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.rateProvider', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.rateProvider', {
                url    : '/rate-provider',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/RateProvider/customCurrency.html',
                        controller : 'RateProviderController as vm'
                    }
                },
                resolve: {
                    providerData : function(customCurrencyService){
                        return customCurrencyService.getRateProvider();
                    },
                    vendorData : function(QuotesService){
                        return QuotesService.getvendorData();
                    }
                },
                bodyClass: 'rateProvider'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/RateProvider');

        // Api
        // msApiProvider.register('quotes', ['app/data/quotes/quotes.json']);

        // msNavigationServiceProvider.saveItem('fuse.rateProvider', {
        //     title    : 'Rate Provider',
        //     icon     : 'icon-chart-bar',
        //     state    : 'app.rateProvider',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'RATEPROVIDER.RATEPROVIDER_NAV',
        //     weight   : 1
        // });
    }
})();
(function(){
    'use strict';

    angular.module('app.rateProvider')
    .factory('customCurrencyService' , customCurrencyService);

    /** @ngInject */
    function customCurrencyService($q,$http,$log,api)
    {
        var customCurrencyService = {
            getRateProvider : getRateProvider,
            submitProvider : submitProvider,
            submitCurrency : submitCurrency
        };

        return customCurrencyService;

        function getRateProvider(){
            var url = api.baseUrl + '/api/shipper-rate-provider';
            return $http.get(url).then(function(response){
                return response.data;
            },function(error){
                $log.error(error);
            });
        };

        function submitProvider(data){
            var url = api.baseUrl + '/api/shipper-rate-provider';
            return $http.post(url,data);
        }

        function submitCurrency(data){
            var url = api.baseUrl + '/api/shipper-rate-provider/'+data.rate_provider.id;
            return $http.put(url,data);
        };

    }

}());
(function () {

  'use strict';

  angular
    .module('app.inquiry')
    .factory('InquiryService', InquiryService);

  /** @ngInject */
  function InquiryService($http, api,$q,util,$state,$log) {

    var inquiryService = {
      getAllInquries: getAllInquries,
      getActiveInquries: getActiveInquries,
      getInquiryDetails : getInquiryDetails,
      getConversionCurrency : getConversionCurrency,
      conversionCurr : {},
      getIterationData : getIterationData,
      updateInquiry : updateInquiry,
      updateInquiryActivity : updateInquiryActivity,
      FclInquiry : {},
      filterParams : {
        'users' : '',
        'customer' : '',
        'customer_company' : '',
        'mode' : '',
        'search' : '',
        'start_date' : null,
        'end_date' : new Date()
      },
      getUsersListForFilter : getUsersListForFilter,
      generatePdf : generatePdf,
      activeInquiryTab : '',
      getInquriesList : getInquriesList,
      getFilterList : getFilterList,
      statusCondition : 'Rates Requested'
    }
    return inquiryService;

    function getAllInquries() {
      var url = api.baseUrl + '/api/inquiry-status-count'+ util.fnGetForwarderIdApi('?');
      if(util.navPermission.inquiry[1]){
          var data = {};
          if(inquiryService.filterParams.mode.length > 0){
              data.mode = inquiryService.filterParams.mode;
          }
          if(inquiryService.filterParams.users.length > 0){
              data.users = inquiryService.filterParams.users;
          }
          if(inquiryService.filterParams.customer.length > 0){
            data.shipper_users = inquiryService.filterParams.customer;
          }
          if(inquiryService.filterParams.customer_company.length > 0){
              data.shippers = inquiryService.filterParams.customer_company;
          }
          if(inquiryService.filterParams.search){
              data.search = inquiryService.filterParams.search;
          }
          if(inquiryService.filterParams.start_date){
              data.start_date = inquiryService.filterParams.start_date;
          }
          if(inquiryService.filterParams.end_date){
              data.end_date = inquiryService.filterParams.end_date;
          }
          return $http.post(url,data);
      }else{
          return [];
      }

    }

    function getActiveInquries(ids) {
      var url = api.baseUrl + '/api/inquiries-data';
      return $http.post(url, ids);
    }

    function getInquiryDetails(id){
      var url = api.baseUrl +'/api/inquiry/' + id;

      return $http.post(url).then(function(response){
        util.isCallingApi = false;
        inquiryService.FclInquiry = response.data.data;
        return inquiryService.FclInquiry;
      },function(error){
          util.isCallingApi = false;
          $state.go(util.redirectIfError(error));
          $log.error(error);
      });
    }

    function getConversionCurrency(){
      var url = api.baseUrl +'/api/currency-conversion?from=USD';
      return $http.get(url);
    }

    function getIterationData(url){

      var activityUrl = api.baseUrl + url;
      var deferred = $q.defer();
      $http.post(activityUrl).then(function(response){
        deferred.resolve(response.data.data.activity_detail);
      },function(error){
          $log.error(error);
          deferred.reject(error);
      });
      return deferred.promise;
    }

    function updateInquiryActivity(id, activityId, data){
      if(activityId){
        return $http.put(api.baseUrl + '/api/inquiry-activity/'+ id + '/'+ activityId , data);
      }else{
        return $http.put(api.baseUrl + '/api/inquiry-activity/'+ id , data);
      }
    }

    function updateInquiry(id, data){
      return $http.put(api.baseUrl + '/api/inquiry/'+ id , data);
    }

    function getUsersListForFilter(module_filter,type,serach_text){
      var url = api.baseUrl + '/api/user?count=30&offset=0&source='+module_filter;
      if(type){
          url += '&type='+type+'';
      }
      if(serach_text){
          url += '&search='+serach_text+'';
      }
      return $http.get(url);
    }

    function generatePdf(id){
      var url = api.baseMockUrl + '/quote-pdf/'+id;
      return $http.get(url);
    }

    function getInquriesList(data){
      var url = api.baseUrl + '/api/v2/inquiry/list'+ util.fnGetForwarderIdApi('?');
      return $http.post(url,data);
    }

    function getFilterList(queryParam){
      var forwarderId = util.fnGetForwarderIdApi('?');
      var url = api.baseUrl + '/api/v2/inquiry/filters'+ util.fnGetForwarderIdApi('?');
      if(queryParam !== null){
        url += (forwarderId === '' ? '?' : '&') + 'query_source=' + queryParam.query_source +'&query='+ queryParam.query;
      }
      return $http.get(url);
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.inquiry')
        .controller('InquiryDetailsController', InquiryDetailsController);

    /** @ngInject */
    function InquiryDetailsController(util,$mdSidenav, $mdDialog,$rootElement, $scope, InquiryService, InquiryDetailsData,resultService, $filter,shareQuoteService,SearchService,api,localStorageService, $state,QuotesService,$window,$log, $rootScope)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.toggleSideNav = toggleSideNav;
        vm.fnMakeInquiryLost = fnMakeInquiryLost;
        vm.closeDialog = closeDialog;
        vm.fnLostInquiry = fnLostInquiry;
        vm.fnOpenMatchRatesModal = fnOpenMatchRatesModal;
        vm.collapseIt = collapseIt;
        vm.showQuoteProceedDiv = showQuoteProceedDiv;
        vm.fnCarrierName = fnCarrierName;
        vm.fnInitCard = fnInitCard;
        vm.fnFilterConversionRates = fnFilterConversionRates;
        vm.cancelDialog = cancelDialog;
        vm.fnSendRates = fnSendRates;
        vm.requestToBook = requestToBook;
        vm.generateQuoteModal = generateQuoteModal;
        vm.getQuoteVersion = getQuoteVersion;
        vm.nextVersionChar = nextVersionChar;
        vm.removeFromQuote = removeFromQuote;
        vm.openDeleteCard = openDeleteCard;
        vm.fnDeleteData = fnDeleteData;
        vm.fnSuccessErrorModal = fnSuccessErrorModal;
        vm.isWebView = util.isWebView();
        vm.goToShipmentDetail = goToShipmentDetail;
        vm.goToQuoteDetail = goToQuoteDetail;
        vm.shareQuoteData = {};
        vm.showScreen = 1;
        vm.deleteType='';
        vm.requestRateSource = '';
        vm.user = {
            "email": null,
            "user_mobile": null,
            "user_first_name": null,
            "user_last_name": null,
            "id" : null
        };

        vm.company = {
            "company_name": null,
            "id": null
        };
        vm.statusCondition = InquiryService.statusCondition;

        vm.freezInquiry = false;
        vm.inquiryDetails = angular.copy(InquiryDetailsData);
        vm.search_param = vm.inquiryDetails.search_data;
        vm.buyOrSell = 'sell_rates'; //!util.isShipper ? 'sell_rates' : 'buy_rates';
        vm.quote_CardData = [];
        vm.l3_leg = (vm.search_param.mode == 'SEA-FCL') ? 'l3_fcl' : (vm.search_param.mode == 'AIR' ? 'l3_air' : 'l3_lcl' );
        vm.l1_leg = (vm.search_param.mode == 'SEA-FCL') ? 'l1_fcl' : (vm.search_param.mode == 'AIR' ? 'l1_air' : 'l1_lcl' );
        vm.l5_leg = (vm.search_param.mode == 'SEA-FCL') ? 'l5_fcl' : (vm.search_param.mode == 'AIR' ? 'l5_air' : 'l5_lcl' );
        var is_pricing  =  false;
        vm.inquiryLost = (vm.inquiryDetails.current_status.status == "Lost") ? true : false;
        vm.fnOpenVASModal = fnOpenVASModal;
        vm.ctrlapplyVASLegToCard = ctrlapplyVASLegToCard;

        vm.displayAddRatesDiv = false;
        vm.displayGoBackDiv = false;

        function isPricingUser(){
            if(!!(util.userProfile.user)){
                is_pricing =  util.userProfile.user.is_pricing_user ? true : false;
            }else{
                util.getProfile();
            }
            return is_pricing;
        }

        vm.resultCardFilter = {
            'currency_conversion_rates' : [],
            'via_route_filter' : 'Transhipment',
            'getDataSchedule' : true,
            'getNetworkSchedule' : true,
            'getIataSchedule' : true,
            'hideBookBtn' : false,
            'deviceName' : 'laptop',
            'generateQuoteBtn' : isPricingUser(),
            'ratesLoading' : false,
            'sendRatesBtn' : false,
            'co2eApiCalled' : false
        };
        vm.newCardArray = [];
        vm.getIterationDetails = getIterationDetails;
        vm.fnGetStdTerms = fnGetStdTerms;
        vm.fnGetFwrdTerms = fnGetFwrdTerms;
        vm.goBack = goBack;
        vm.fnConfirmSendCard = fnConfirmSendCard;
        vm.fnMatchRatesCall = fnMatchRatesCall;
        vm.matchRatesObj = {
            "search_param" : InquiryService.FclInquiry.search_data,
            "id" : InquiryService.FclInquiry._id,
            "match_rates" : null,
            "additional_charges" : {
                "selected" : [],
                "available" : []
            }
        }
        vm.inquiryIterations = angular.copy(vm.inquiryDetails.activity.activity_list.slice(0).reverse());
        vm.curr_vas_leg_arr = [];
        vm.getLegDetailsForVas = getLegDetailsForVas;
        vm.getVasDetails = getVasDetails;
        vm.getUserProfile = getUserProfile;
        vm.downloadPDF = downloadPDF;
        vm.fnAddRatesCondition = fnAddRatesCondition;
        vm.inquiryRefreash = inquiryRefreash;
        vm.spinRefreshIcon = false;
        vm.fnTrackAnalytics = fnTrackAnalytics;
        vm.all_in_quote_setting = 'default';
        vm.co2eResponse = {}; //co2e response
        vm.util.co2ApiLoaded = true;
        
        function init(){
            util.isModulePaid('inquiry');

            vm.responseTrue = false;
            vm.freezInquiry = (vm.inquiryDetails.current_status.status == "Lost" || vm.inquiryDetails.current_status.status == "Expired" || vm.inquiryDetails.current_status.status == "Booking Placed") ? true : false;

            vm.isQuotedOrRatesAvailable = (vm.inquiryDetails.current_status.status == 'Quoted' || vm.inquiryDetails.current_status.status == 'Rates available' || vm.inquiryDetails.current_status.status == 'No rates' || vm.inquiryDetails.current_status.status == 'With rates') ? true : false;

            if(!Object.keys($rootScope.domainData.domain_info).length){
                util.getDomainData().then(function(){
                    vm.getUserProfile();
                },function(error){
                    vm.getUserProfile();
                });
            }else{
                vm.getUserProfile();
            }

            vm.fclLoadData = SearchService.getFclLoadDetails(vm.search_param.load_data.load_details_value);

            if(!vm.search_param.hasOwnProperty('freight_charges')){
                vm.search_param['freight_charges'] = true;
            }

            vm.quoteArray = [];
            vm.selectedCard = [];

            vm.getIterationDetails();
            vm.fnGetStdTerms();
            vm.fnGetFwrdTerms();


        }
        init();

        function getUserProfile(){
            if(!util.userProfile.user){
                util.getProfile().then(function(){
                    vm.fnAddRatesCondition();
                    if(util.solution_type && util.solution_type === 'WLS'){
                        vm.getVasDetails();
                    }
                },function(error){
                    $log.log(error.data);
                });
            }
            else{
                vm.fnAddRatesCondition();
                if(util.solution_type && util.solution_type === 'WLS'){
                    vm.getVasDetails();
                }
            }
        }

        function fnAddRatesCondition(){
            if( util.userProfile.user.is_pricing_user && !vm.freezInquiry && (vm.inquiryDetails.current_status.status == vm.statusCondition || ($rootScope.domainData.domain_info["INQUIRY_ADD_RATE_ON_RAQ"] && vm.isQuotedOrRatesAvailable)) ){
                vm.displayAddRatesDiv = true;
            }else if( !util.userProfile.user.is_pricing_user && vm.inquiryDetails.current_status.status == vm.statusCondition && !vm.freezInquiry ){
                vm.displayGoBackDiv = true;
            }
        }

        function getIterationDetails(){
            for(var i = 0; i < vm.inquiryIterations.length; i++){
                if(i == 0){
                    var iterationID = vm.inquiryIterations[i]._id;
                }
                if(vm.inquiryIterations[i].link){
                    InquiryService.getIterationData(vm.inquiryIterations[i].link).then(function (response) {
                        vm.responseTrue = true;
                        var currentActivity = $filter('filter')(vm.inquiryIterations, { '_id': response._id }, true);
                        var iteration = currentActivity[0];

                        iteration.data = angular.copy(response);
                        if(iteration.data.cards && iteration.data.cards.length){
                            iteration.data.cards = vm.fnInitCard(iteration.data.cards, i);
                        }

                        vm.fnFilterConversionRates(iteration.data.currency_conversion_rates);

                        iteration["view"] = false;
                        if( iteration.data.activity_type == 'MMR' || iteration.data.activity_type == 'RFQ' || iteration.data.activity_type == 'BETTER_RATE' ){
                            iteration["view"] = true;
                        }else if(iterationID == iteration._id && iteration.data.cards && iteration.data.cards.length){
                            iteration["view"] = true;
                            vm.tempRecentCard = angular.copy(iteration.data.cards);
                        }

                        if(iterationID == iteration._id && (vm.inquiryIterations[0].data.activity_type == 'MMR' || vm.inquiryIterations[0].data.activity_type == 'RFQ' || vm.inquiryIterations[0].data.activity_type == 'BETTER_RATE')){

                             if(util.userProfile.user.is_pricing_user && !vm.freezInquiry){
                                vm.resultCardFilter.generateQuoteBtn = false;
                            }else{
                                vm.resultCardFilter.generateQuoteBtn = true;
                            }
                        }else if(iterationID == iteration._id && (vm.inquiryIterations[0].data.activity_type != 'MMR' || vm.inquiryIterations[0].data.activity_type != 'RFQ' || vm.inquiryIterations[0].data.activity_type != 'BETTER_RATE')){
                            if(!util.userProfile.user.is_pricing_user && !vm.freezInquiry){
                                vm.resultCardFilter.generateQuoteBtn = false;
                            }else{
                                vm.resultCardFilter.generateQuoteBtn = true;
                            }
                        }

                    }, function (error) {
                        $log.log(error);
                    });
                }
            }
        }

        function fnGetStdTerms(){
            var mode = (vm.search_param.mode == 'SEA-FCL') ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl' );
            resultService.getTermsConditions(mode,'true').then(function(response){
                vm.stdTermsAndConditions = util.decodeValue(response.data.terms);
                // util.stdTermsAndConditions = vm.stdTermsAndConditions;
            },function(error){
                vm.stdTermsAndConditions = "";
            });
        }

        function fnGetFwrdTerms(){
            var mode = (vm.search_param.mode == 'SEA-FCL') ? 'fcl' : (vm.search_param.mode == 'AIR' ? 'air' : 'lcl' );
            resultService.getTermsConditions(mode,'false').then(function(response){
                vm.termsAndConditions = util.decodeValue(response.data.terms);
                // util.termsAndConditions = vm.termsAndConditions;
            },function(error){
                vm.termsAndConditions = "";
            });
        }

        function toggleSideNav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function goBack() {
            $state.go('app.inquiry');
        }

        //status change popup
        function fnMakeInquiryLost(ev){
            vm.lostValidation=false;
            if(vm.inquiryLost == true){
                vm.lostReason = "";

                $mdDialog.show({
                    templateUrl: 'app/main/Inquiry/Dialogs/inquryLostModal.html',
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    controllerAs: 'ctrl',
                    onRemoving : vm.inquiryLost = vm.lostReason ? true : false,
                    controller: function () { this.parent = vm }
                });
            }
        }

        function closeDialog(action) {
            if(action == 'lost'){
                vm.inquiryLost = false;
            }
            return $mdDialog.hide();
        }

        function fnConfirmSendCard(ev){
            vm.fromInquiry = $rootScope.domainData.domain_info.MAKE_RATES_GLOBAL_FROM_INQUIRY;
            vm.confirmationRates = [];

            angular.forEach(vm.newCardArray, function (card) {

              if(card.meta.isRateGlobal == 'Yes'){
                vm.confirmationRates.push(card.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name);
              }
            });
            $mdDialog.show({
              templateUrl: 'app/main/Inquiry/Dialogs/global-rates-popup/global-rates-confirmation.html',
              targetEvent: ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              // onRemoving : vm.inquiryLost = vm.lostReason ? true : false,
              controller: function () { this.parent = vm }
            });
        }

        // pricing user card add function
        function fnSendRates(){
            $mdDialog.hide();
            var copyNewCardArray = angular.copy(vm.newCardArray);
            var currency_conversion_rates = [];
            var cardArray = [];
            var vendor_0_obj = null;

            var getCurrUserRate = vm.resultCardFilter.currency_conversion_rates.find(function(element) {
              if( element.vendor_id == 0){
                  vendor_0_obj = element;
              }
              return ( element.vendor_id == parseInt(localStorageService.get('authToken').value.vendor_id) );
            });

            if(getCurrUserRate){
                currency_conversion_rates.push(getCurrUserRate);
            }
            if(vendor_0_obj){
                currency_conversion_rates.push(vendor_0_obj);
            }

            angular.forEach(copyNewCardArray, function (card) {

                var getCurrencyRate = vm.resultCardFilter.currency_conversion_rates.find(function(element) {
                    return ( element.vendor_id == card.meta.vendor_id );
                });

                if(getCurrencyRate){
                    currency_conversion_rates.push(getCurrencyRate);
                }

                card.meta.is_selected = false;
                card.meta["isScheduleCall"] = true;
                delete card.meta.status;
                delete card.meta["shimmer"];
                delete card.meta["isRateGlobal"];
                cardArray.push(card);
            });

            var latestActivityId = (vm.inquiryDetails.current_status.status == 'Rates available') ? vm.inquiryIterations[0]._id : null;

            var data = {
                "data" : {
                    "meta" : null,
                    "cards" : cardArray,
                    "currency_conversion_rates" : currency_conversion_rates,
                    "message": latestActivityId ? "has updated rates" : "has added rates",
                    "timestamp": new Date(),
                    "quote_number": vm.inquiryDetails.quote_number,
                    "quote_id": vm.inquiryDetails.quote_id,
                    "shipment_number": vm.inquiryDetails.shipment_number,
                    "shipment_id": vm.inquiryDetails.shipment_id,
                    "inquiry_from": "",
                    "inquiry_trigger": "",
                    "activity_type": latestActivityId ? "CARD_UPDATED" : "CARD_ADDED",
                    "user": util.userProfile.user
                }
            }

            vm.sentRateBtn = true;
            util.isCallingApi = true;
            InquiryService.updateInquiryActivity(vm.inquiryDetails._id, latestActivityId, data).then(function (response) {

                vm.sentRateBtn = false;
                util.isCallingApi = false;
                vm.newCardArray = [];

                vm.resultCardFilter.generateQuoteBtn = true;
                vm.sendRatesResponse = response.data.data.global_rate_status;
                setTimeout(function(){
                  vm.fnSuccessErrorModal('success');
                },200);
            }, function (error) {
                $log.log(error);
                vm.sentRateBtn = false;
                util.isCallingApi = false;
                vm.sendRatesErrorMessage = error.data.message;
                vm.sendRatesError = error.data.data.global_rate_status;

              for(var i = 0; i < vm.sendRatesError.liners_rates_published.length; i++ ){
                vm.newCardArray.find(function(element) {
                  if( element.data.buy_rates[vm.l3_leg].rate_obj.sub_vendor.carrier_code == vm.sendRatesError.liners_rates_published[i].carrier_code){
                    element.meta.make_rates_global[0].batch_code = vm.sendRatesError.liners_rates_published[i].batch_code ?vm.sendRatesError.liners_rates_published[i].batch_code[vm.l3_leg] : null;
                  }
                });
              }
              vm.fnSuccessErrorModal('error');
            });
        }

        function fnSuccessErrorModal(action, ev){

          if(action == 'success'){
            $mdDialog.show({
              templateUrl: 'app/main/Inquiry/Dialogs/global-rates-popup/global-rates-success.html',
              targetEvent: ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function () { this.parent = vm }
            });
          }else if(action == 'error'){
            $mdDialog.show({
              templateUrl: 'app/main/Inquiry/Dialogs/global-rates-popup/global-rates-error.html',
              targetEvent: ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function () { this.parent = vm }
            });
          }
        }

        //status change api call
        function fnLostInquiry(form){
            if(!vm.lostReason && !form.comment.$invalid){
                vm.lostValidation=true;
                return;
              }
            if(form.comment.$invalid){
                return;
            };

            var data = {
                "data": {
                    "current_status": {
                        "status": "Lost",
                        "description": "",
                        "color_code": "#6f52ea",
                        "comment": vm.lostReason,
                        "created_on" : new Date(),
                        "user" :{
                            "id": util.userProfile.user.id,
                            "email": util.userProfile.user.email,
                            "user_mobile": util.userProfile.user.user_mobile,
                            "user_first_name": util.userProfile.user.user_first_name,
                            "user_last_name": util.userProfile.user.user_last_name
                        }
                    },
                    "activity": {
                            "meta": null,
                            "cards": [],
                            "comment": vm.lostReason,
                            "message": "has marked lost",
                            "timestamp": new Date(),
                            "quote_number": vm.inquiryDetails.quote_number,
                            "quote_id": vm.inquiryDetails.quote_id,
                            "shipment_number": vm.inquiryDetails.shipment_number,
                            "shipment_id": vm.inquiryDetails.shipment_id,
                            "inquiry_from": "",
                            "inquiry_trigger": "",
                            "activity_type": "LOST",
                            "user": util.userProfile.user
                    }
                }
            }

            vm.lostBtn = true;
            util.isCallingApi = true;
            InquiryService.updateInquiry(vm.inquiryDetails._id, data).then(function(response){
                vm.freezInquiry = true;
                vm.lostBtn = false;
                util.isCallingApi = false;
                util.showToast('Inquiry status changed from '+(vm.inquiryDetails.current_status.status_alias ? vm.inquiryDetails.current_status.status_alias : vm.inquiryDetails.current_status.status)  + ' to lost.');

                vm.inquiryDetails.current_status = {
                    "status": "Lost",
                    "description": "",
                    "color_code": "#6f52ea",
                    "comment": vm.lostReason,
                    "created_on" : new Date(),
                    "user" : {
                        "id": util.userProfile.user.id,
                        "email": util.userProfile.user.email,
                        "user_mobile": util.userProfile.user.user_mobile,
                        "user_first_name": util.userProfile.user.user_first_name,
                        "user_last_name": util.userProfile.user.user_last_name
                    }
                };

                var responseData = {
                    "_id" : response.data.data.activity_detail._id,
                    "link": response.data.data.link,
                    "data" : response.data.data.activity_detail
                }

                vm.cancelDialog();
                vm.resultCardFilter.generateQuoteBtn = true;
                vm.inquiryLost = true;
                vm.inquiryIterations.unshift(responseData);
                init()

            },function(error){
                vm.lostBtn = false;
                util.isCallingApi = false;
                util.showToast(util.displayValidationError(error));
                $log.log(error);
            });
        }

        function fnMatchRatesCall(data){
            vm.inquiryDetails.current_status = {
                "status": InquiryService.statusCondition,
                "description": "",
                "color_code": "#42a9e0"
            };
            vm.inquiryIterations.unshift(data.response);
            init();
        }

        // Funtion to open RFQ form modal
        function fnOpenMatchRatesModal(ev){
            $mdDialog.show({
                template: '<md-dialog id="match-rates" class="popup-md"><match-rates matchratesparam="ctrl.parent.matchRatesObj" inquirydata="ctrl.parent.inquiryDetails" page-source="ctrl.parent.requestRateSource"callback="ctrl.parent.fnMatchRatesCall(data)"></match-rates></md-dialog>',
                targetEvent: ev,
                clickOutsideToClose: false,
                parent: $rootElement,
                scope: $scope,
                preserveScope: true,
                controller: function () { this.parent = vm },
                controllerAs: 'ctrl',
            });
        }

        //function to expand and collapse div
        function collapseIt(id, data, e){
            angular.element('#'+id).slideToggle();
            if(data.view == true){
                data.view = false;
            }else{
                data.view = true;
            }
        }

        function fnCarrierName(carrierArray){
            var result = [];
            if(vm.search_param.mode == 'SEA-FCL'){
                angular.forEach(carrierArray, function (item){
                    result.push(item.name);
                });
            }else if(vm.search_param.mode == 'AIR'){
                angular.forEach(carrierArray, function (item){
                    result.push(item.air_line_name);
                });
            }
            result = result.join(', ');

            if(!result){
                result = 'N/A';
            }
            return result;
        }

        function fnInitCard(cards, index){
            cards.map(function(card){
                card.meta['is_selected'] = false;
                card.meta["card_total_cost"] = 0;
                card.meta["init_sort_total"] = 0;
                card.meta["isScheduleCall"] = true;

                if(card.data.sell_rates == undefined || card.data.sell_rates == null){
                    card.data.sell_rates = angular.copy(card.data.buy_rates);
                }

                // pickup service type
                if(!card.meta["pickup_service"]){
                    card.meta["pickup_service"] = card.data[vm.buyOrSell][vm.l1_leg] && card.data[vm.buyOrSell][vm.l1_leg].rate_obj && card.data[vm.buyOrSell][vm.l1_leg].rate_obj.service_type ? card.data[vm.buyOrSell][vm.l1_leg].rate_obj.service_type : "";
                }

                // pickup sub-vendor
                if(!card.meta["pickup_sub_vendor"]){
                    card.meta["pickup_sub_vendor"] = card.data[vm.buyOrSell][vm.l1_leg] && card.data[vm.buyOrSell][vm.l1_leg].rate_obj && card.data[vm.buyOrSell][vm.l1_leg].rate_obj.sub_vendor ? card.data[vm.buyOrSell][vm.l1_leg].rate_obj.sub_vendor : null;
                }

                // delivery service type
                if(!card.meta["delivery_service"]){
                    card.meta["delivery_service"] = card.data[vm.buyOrSell][vm.l5_leg] && card.data[vm.buyOrSell][vm.l5_leg].rate_obj && card.data[vm.buyOrSell][vm.l5_leg].rate_obj.service_type ? card.data[vm.buyOrSell][vm.l5_leg].rate_obj.service_type : "";
                }

                // delivery sub-vendor
                if(!card.meta["delivery_sub_vendor"]){
                    card.meta["delivery_sub_vendor"] = card.data[vm.buyOrSell][vm.l5_leg] && card.data[vm.buyOrSell][vm.l5_leg].rate_obj &&  card.data[vm.buyOrSell][vm.l5_leg].rate_obj.sub_vendor ? card.data[vm.buyOrSell][vm.l5_leg].rate_obj.sub_vendor : null;
                }

                for(var i in card.data[vm.buyOrSell]){
                    if( card.data[vm.buyOrSell][i].rate_obj){
                        card.meta.card_total_cost += parseFloat(card.data[vm.buyOrSell][i].rate_obj.leg_total_cost);
                    }
                }
                card.meta['init_sort_total'] = card.data[vm.buyOrSell][vm.l3_leg].rate_obj.leg_total_cost;
            });

            cards = (resultService.getLowestCard([].concat(cards))).reverse();
            return cards;
        }

        function fnFilterConversionRates(currency_rates){
            angular.forEach(currency_rates, function(value, key){
                var isGetCurrency = vm.resultCardFilter.currency_conversion_rates.some(function (entry) { return value.vendor_id === entry.vendor_id; });

                if(!isGetCurrency){
                    vm.resultCardFilter.currency_conversion_rates.push(value);
                }
            });
        }

        function showQuoteProceedDiv(item){
            vm.selectedActivityId = item.activityId;
            if(item.action == 'newCard' || item.action == 'addNewQuote'){
                vm.newCardArray.push(item.currentCard);
                util.showToast("New rate card created.");
            }
            else if(item.action == 'quotationEdit'){
                var getCardData = $filter('filter')(vm.newCardArray, { '_id': item.currentCard._id }, true);
                var index = vm.newCardArray.indexOf(getCardData[0]);
                vm.newCardArray[index] = angular.copy(item.currentCard);
            }
            else if(item.action == 'addInToQuote'){
                if (!vm.quoteArray.includes(item.currentCard._id)) {
                    vm.quoteArray.push(item.currentCard._id);
                    vm.selectedCard.push(item.currentCard);
                } else {
                    var replaceCard = $filter('filter')(vm.selectedCard, { '_id': item.currentCard._id }, true);
                    var index = vm.selectedCard.indexOf(replaceCard[0]);
                    vm.selectedCard[index] = item.currentCard;
                }
            }
            else if( item.action == 'manualCardDelete'){
              vm.openDeleteCard(item.currentCard);
            }
            else if(item.action == 'removeFromQuote'){
              vm.removeFromQuote(item.currentCard);

              if(!vm.quoteArray.length){
                vm.resultCardFilter.hideBookBtn = false;
              }
            }
            else if( item.action == 'bookingRequest'){
              vm.requestToBook(item.currentCard);
            }
            else if( item.action == 'deleteCharge' ){
              var index = vm.quoteArray.indexOf(item.currentCard._id);
              if (index > -1) {
                vm.quoteArray.splice(index, 1);
                item.currentCard.meta.is_selected = false;
                item.currentCard.data.sell_rates = null;
                vm.selectedCard.pop(item.currentCard);
              }
            }
            else if( item.action == 'scheduleSelect'){
              var cardObj = $filter('filter')(vm.selectedCard, { '_id': item.currentCard._id }, true);

              if (cardObj.length) {
                cardObj[0].meta.selected_schedule = item.currentCard.meta.selected_schedule;
                cardObj[0].meta.multi_schedule_list = item.currentCard.meta.multi_schedule_list || [];
              }
            }else if( item.action == 'manualCardEdit' ){
              vm.openEditCardModal(item.currentCard);
            }
        }

        // remove card from quote creation
        function removeFromQuote(card) {
        var index = vm.quoteArray.indexOf(card._id);
            if (index > -1) {
                vm.quoteArray.splice(index, 1);
                card.meta.is_selected = false;

                var tempId = $filter('filter')(vm.tempRecentCard, { '_id': card._id }, true);

                var iterationCardId = $filter('filter')(vm.inquiryIterations[0].data.cards, { '_id': card._id }, true);
                var cardIndex = vm.inquiryIterations[0].data.cards.indexOf(iterationCardId[0]);
                vm.inquiryIterations[0].data.cards[cardIndex] = angular.copy(tempId[0]);
                var selectId = $filter('filter')(vm.selectedCard, { '_id': card._id }, true);
                var selectIndex = vm.selectedCard.indexOf(selectId[0]);
                vm.selectedCard.splice(selectIndex, 1);

                if(vm.isVasApplied){
                    var rate_card  = [vm.inquiryIterations[0].data.cards[cardIndex]];
                    resultService.applyVASLegToCard( rate_card,  vm.vasDetails.legList , 'inquiry');
                }else{
                    card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
                }
            }
        }

        function openDeleteCard(card, ev) {
            vm.deleteLeg = card;
            vm.deleteType="Rate Card"
            $mdDialog.show({
              templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
              targetEvent: ev,
              clickOutsideToClose: true,
              controllerAs: 'ctrl',
              controller: function () { this.parent = vm }
            });
        }

        //function to delete card - ankita - 23/5/18
        function fnDeleteData() {
            vm.fnTrackAnalytics("ID-DeleteRateCard-Yes-Click");
            vm.deleteBtn = true;
            util.isCallingApi = true;

            var getCardData = $filter('filter')(vm.newCardArray, { '_id': vm.deleteLeg._id }, true);
            var index = vm.newCardArray.indexOf(getCardData[0]);
            vm.newCardArray.splice(index, 1);
            vm.cancelDialog();
            vm.deleteBtn = false;
            util.isCallingApi = false;
        }

        // function cancelDialog(){
        //     $mdDialog.hide();
        // }

        function cancelDialog() {
            // if (vm.showScreen == 3) {
            //   vm.closeShareDialog();
            // }
            // vm.previewUrl = "";
            // vm.quoteDetails = {};
            // vm.showScreen = 1;
            // vm.showTermsConditions = false;
            $mdDialog.hide();
        }


        // function to request tyhe booking data
        vm.booked_leg_type = [];
        function requestToBook(currCard) {

            var count = 1;
            if (currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.is_special && currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment != null) {

                for (var j in currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment) {
                for (var i = 0; i < vm.search_param.load_data.load_details_value.length; i++) {
                    if (vm.search_param.load_data.load_details_value[i].type == j && vm.search_param.load_data.load_details_value[i].qty > currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment[j]) {
                    util.showToast("Max quantity allowed for " + j + " is " + currCard.data[vm.buyOrSell][vm.l3_leg].rate_obj.special_meta.max_qty_per_shipment[j]);
                    count = 0;
                    break;
                    }
                }
                if (count === 0) {
                    break;
                }
                }

                if (count === 0) {
                return;
                }
            }

            angular.forEach(currCard.data[vm.buyOrSell],function(value){
                vm.booked_leg_type.push(value.leg_code);
            });

            currCard.meta["conversionRate"] = resultService.fnGetConversionRates(vm.resultCardFilter.currency_conversion_rates, currCard.meta.vendor_id,vm.search_param.mode);

            var cards = angular.copy(currCard);


            var booking_data = {
                "search_param": angular.copy(vm.search_param),
                "card_item": angular.copy(cards),
                "id": vm.inquiryDetails._id,
                "booked_leg_type": angular.copy(vm.booked_leg_type),
                "buyOrSell": vm.buyOrSell,
                "user": vm.search_param.user,
                "page": "inquiry",
                "create_for" : util.userProfile.user,
                "shipper" : vm.search_param.shipper_user ? vm.search_param.shipper_user : null,
                "send_mail" : vm.search_param.shipper_user ? true : false,
                "all_in_quote_setting" : 'default'
            }

            resultService.requestToBookData = booking_data;
            if (util.isSharedQuote()) {
                $state.go('app.resultSharedBookShipment');
            } else {
                $state.go('app.resultBookShipment', { mode: 'fcl' });
            }
        }


        //Open Modal to fill new card details
        function generateQuoteModal(ev) {
            vm.quoteDetails = shareQuoteService.fnInitializeQuoteDetails(vm.search_param.origin_customs, vm.search_param.destination_customs);
            vm.quoteDetails.terms = vm.termsAndConditions;
            vm.quoteDetails.incoterms = (vm.search_param.inco_term) ? vm.search_param.inco_term : null;
            vm.quoteDetails.impo_expo = (vm.search_param.impo_expo) ? vm.search_param.impo_expo : null;
            vm.quoteDetails.hazardous = vm.search_param.hazardous_material;
            vm.quoteDetails.all_in_quote_setting = vm.all_in_quote_setting;

            vm.shareQuoteObj = {
                'quoteDetails' : vm.quoteDetails,
                'termsAndConditions' : vm.termsAndConditions,
                'stdTermsAndConditions' : vm.stdTermsAndConditions,
                'selectedCard' : vm.selectedCard,
                'search_param' : vm.search_param,
                'generateQuoteBtn' : vm.resultCardFilter.generateQuoteBtn,
                'currency_conversion_rates' : vm.resultCardFilter.currency_conversion_rates,
                'fclLoadData' : vm.fclLoadData,
                'result_id' : vm.inquiryDetails.search_id,
                'inquiry_id' : vm.inquiryDetails._id,
                'sales_user' : vm.inquiryDetails.sales_user,
                'shipper_user' : vm.inquiryDetails.shipper_user,
                'erp_data' : vm.inquiryDetails.erp_data,
                'vas_details' : vm.vasDetails,
                'quoteFrom': 'Inquiry',
                'exchangeRateId': vm.inquiryDetails.activity._id,
                'activityId': vm.selectedActivityId
            }

            vm.disableCustomerDetails = true;
            $mdDialog.show({
                template : '<md-dialog id="share-quotation" class="dialobox" ng-cloak><md-dialog-content class="p-0"><share-quotation sharequoteobj="ctrl.parent.shareQuoteObj"></share-quotation></md-dialog-content></md-dialog>',
                // templateUrl: 'app/main/result/Dialogs/share-quotation/share-quotation.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm },
                // onRemoving: vm.resetSendQuotey
                onRemoving: function (event, removePromise) {
                    for (var name in CKEDITOR.instances) {
                      CKEDITOR.instances[name].destroy();
                    }
                  }
            });
        }

        function getQuoteVersion(str) {
          var result = 'A';
          if((str.split('-')[1]) != undefined){
            result = str.split('-')[1];
          }
          return result;
        }

        function nextVersionChar(c) {
          return String.fromCharCode(c.charCodeAt(0) + 1);
        }

        // revise quote
        vm.revise_quote = false;
        vm.fnUndoChanges = fnUndoChanges;
        vm.fnQuoteModify = fnQuoteModify;

        function fnUndoChanges(ev){
            var confirm = $mdDialog.confirm()
            //   .title('Warning')
              .textContent('Changes made to this quote will be lost. Proceed anyway?')
              .ariaLabel('discard')
              .targetEvent(ev)
              .ok('Yes, Proceed')
              .cancel('No, Cancel');

            $mdDialog.show(confirm).then(function () {
            // vm.isQuoteModify = false;
            vm.quoteArray = [];
            vm.selectedCard = [];
            vm.inquiryIterations[0].data.cards = angular.copy(vm.tempRecentCard);
            }, function () {
              return true;
            });
        }

        function fnQuoteModify(){
            var activityObj = {
              "message": "",
              "type": "",
              "timestamp": new Date(),
              "user_id": util.userProfile.user.id,
              "user_name": util.userProfile.user.user_first_name + ' '+ util.userProfile.user.user_last_name,
              "activity_data": {}
            };

            vm.modifyData = angular.copy(vm.selectedCard);
            var request_data = {
              "data" : {
                "inquiry_id": vm.inquiryDetails._id,
                "activity" : [],
                "quote" : {
                  "search_param" : vm.search_param,
                  "meta" : {
                    "customs": vm.inquiryDetails.search_data.customs ? vm.inquiryDetails.search_data.customs : false,
                    "perishable": vm.inquiryDetails.perishable ? vm.inquiryDetails.perishable : false,
                    "hazardous": vm.search_param.hazardous_material,
                    "incoterms": vm.search_param.inco_term,
                    "expiry_date": vm.search_param.cargo_ready_date,
                    "show_zero_sell_rates" : true,
                    "terms": vm.inquiryDetails.terms ? vm.inquiryDetails.terms : null
                  },
                  "revise_quote" : vm.revise_quote,
                  "cards": {
                    "new" : [],
                    "modified": [],
                    "remove": []
                  }
                },
                "additional_charges" : {
                    "selected" : vm.vasDetails ? vm.vasDetails.legList : [],
                    "available" : vm.vasDetails ? vm.vasDetails.value_added_charges : []
                }
              }
            };

            vm.modifyData.forEach(function(card) {
              var linerName = "";
                if(vm.search_param.mode === 'AIR'){
                  linerName = card.data.sell_rates[vm.l3_leg].rate_obj.airline.air_line_name;
                }else{
                  linerName = card.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name
                }

                angular.forEach(card.data.sell_rates, function (sellValue, sellKey) {
                    if(!sellValue.rate_obj){
                        delete card.data.sell_rates[sellKey];
                        delete card.data.buy_rates[sellKey];
                    }
                });

                delete card._id;
                delete card.meta.status;
                var tempObj  = angular.copy(activityObj);
                tempObj.message = card.data.sell_rates[vm.l3_leg].rate_obj.service_type ? linerName + ' rate card with service '+ card.data.sell_rates[vm.l3_leg].rate_obj.service_type+ ' has been created.' : linerName + ' rate card has been created.' ;
                tempObj.type = "rate_card_added";
                request_data.data.activity.push(tempObj);
                request_data.data.quote.cards.new.push(card);
            });

          vm.modifyBtn = true;
          util.isCallingApi = true;
          QuotesService.modifyQuote(vm.inquiryDetails.quote_id, request_data).then(function(response){
            vm.isQuoteModify = false;
            if(!vm.revise_quote){
              QuotesService.FclQuote = {};
              util.showToast(util.displayValidationError('Redirecting to quote page.'));
                if(vm.isWebView){
                    util.webViewObj.id = response.data.data._id;
                    $state.go('app.webViewQuotesDetails',util.webViewObj);
                  }else{
                    $state.go('app.quotes.quotesDetails', { id: response.data.data._id});
                  }
            }else{
              QuotesService.FclQuote = {};
              util.showToast(util.displayValidationError('Redirecting to quote page.'));
              if(vm.isWebView){
                util.webViewObj.id = response.data.data._id;
                $state.go('app.webViewQuotesDetails',util.webViewObj);
              }else{
                $state.go('app.quotes.quotesDetails', { id: response.data.data._id});
              }
            }
            vm.modifyBtn = false;
            util.isCallingApi = false;
          },function(error){
            util.isCallingApi = false;
            vm.modifyBtn = false;
            $log.log(error.data);
            util.showToast(util.displayValidationError(error));
          });
        }

        function fnOpenVASModal(ev){


            var getCurrencyRate = $filter('filter')(vm.resultCardFilter.currency_conversion_rates, { 'vendor_id': parseInt(localStorageService.get('authToken').value.vendor_id) }, true);

            vm.vasDetails.currency_rates = getCurrencyRate[0].curr_data;
            if(!Object.keys(vm.vasDetails.legList).length){
                vm.vasDetails.legList = vm.getLegDetailsForVas();
            }

            $mdDialog.show({
                template: '<md-dialog class="vas-charge dialobox" ng-cloak><md-dialog-content class="p-0 vas-charge-dialog"><vas-charge vasdetails="ctrl.parent.vasDetails" callback="ctrl.parent.ctrlapplyVASLegToCard(data)"></vas-charge></md-dialog-content></md-dialog>',
                targetEvent: ev,
                clickOutsideToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm }
            });
        }

        vm.isVasApplied =  false; // to check whether vas charges applied to card or not
        function ctrlapplyVASLegToCard(vasdetails){
            var rate_cards  =   vm.inquiryIterations.length ?  vm.inquiryIterations[0].data.cards : [] ; //vm.msr_rates.data.cards.concat(vm.network_rates.data.cards);
            resultService.applyVASLegToCard(rate_cards , vasdetails.data.legList , 'inquiry');
            vm.isVasApplied =  true;
            vm.matchRatesObj.additional_charges.selected = vm.vasDetails.legList;
            vm.matchRatesObj.additional_charges.available = vm.vasDetails.value_added_charges;
        }

        function getLegDetailsForVas(){
            var legObj = resultService.getAdditionLegStructure(vm.search_param);
            var legList = {"buy_rates" : {},"sell_rates" :{}};
            legList.buy_rates['additional_services'] = angular.copy(legObj);
            legList.sell_rates['additional_services'] = angular.copy(legObj);
            return legList;
        }

        function getVasDetails(){

            if(!vm.inquiryDetails.hasOwnProperty("additional_charges")){
              vm.inquiryDetails.additional_charges = {
                "selected" : {},
                "available" : {}
              }
            }

            if( vm.search_param.origin_charges){
                vm.curr_vas_leg_arr.push('l2');
            }
            if(vm.search_param.origin_customs){
                vm.curr_vas_leg_arr.push('l2_cha');
            }
            if(vm.search_param.destination_charges){
                vm.curr_vas_leg_arr.push('l2');
            }
            if(vm.search_param.destination_customs){
                vm.curr_vas_leg_arr.push('l2_cha');
            }

            vm.vasDetails = {
                "search_param" : vm.search_param,
                "legList" : Object.keys(vm.inquiryDetails.additional_charges.selected).length ? vm.inquiryDetails.additional_charges.selected : {},
                "currency_rates" : [],
                "value_added_charges" : Object.keys(vm.inquiryDetails.additional_charges.available).length ? vm.inquiryDetails.additional_charges.available : [],
                "selected_legs" : vm.curr_vas_leg_arr,
                "module" : "Inquiry"
            }

            vm.matchRatesObj.additional_charges.selected = vm.vasDetails.legList;
            vm.matchRatesObj.additional_charges.available = vm.vasDetails.value_added_charges;

        }

        // Download PDF of inquiry details
        function downloadPDF(id){
            vm.disableDownloadBtn = true;
            return InquiryService.generatePdf(id).then(function(response){
                vm.disableDownloadBtn = false;
                // $window.open(response.data.data.pdf_link);
                var anchorTag = document.createElement('a');
                anchorTag.setAttribute('href',response.data.data.pdf_link);
                anchorTag.setAttribute('download',true);
                anchorTag.setAttribute('target','_blank')
                document.body.appendChild(anchorTag);
                anchorTag.click();
                document.body.removeChild(anchorTag);
          

            },function(error){
                vm.disableDownloadBtn = false;
                $log.log(error.data);
                util.showToast(util.displayValidationError(error));
                return [];
            });
        }

        function inquiryRefreash(){

            $mdDialog.hide();
            vm.spinRefreshIcon = true;
            InquiryService.getInquiryDetails(vm.inquiryDetails._id).then(function(response){
                vm.inquiryDetails = angular.copy(response);
                vm.search_param = vm.inquiryDetails.search_data;
                if(!vm.search_param.hasOwnProperty('freight_charges')){
                    vm.search_param['freight_charges'] = true;
                  }
                vm.inquiryLost = (vm.inquiryDetails.current_status.status == "Lost") ? true : false;
                vm.displayAddRatesDiv = false;
                vm.displayGoBackDiv = false;

                vm.resultCardFilter = {
                    'currency_conversion_rates' : [],
                    'via_route_filter' : 'Transhipment',
                    'getDataSchedule' : true,
                    'getNetworkSchedule' : true,
                    'getIataSchedule' : true,
                    'hideBookBtn' : false,
                    'deviceName' : 'laptop',
                    'generateQuoteBtn' : isPricingUser(),
                    'ratesLoading' : false,
                    'sendRatesBtn' : false,
                    'co2eApiCalled' : false
                };
                vm.newCardArray = [];
                vm.matchRatesObj = {
                    "search_param" : InquiryService.FclInquiry.search_data,
                    "id" : InquiryService.FclInquiry._id,
                    "match_rates" : null,
                    "additional_charges" : {
                        "selected" : [],
                        "available" : []
                    }
                }
                vm.inquiryIterations = angular.copy(vm.inquiryDetails.activity.activity_list.slice(0).reverse());
                vm.curr_vas_leg_arr = [];
                init();
                $scope.$broadcast("inquiryRefresh");
                vm.spinRefreshIcon = false;
            },function(error){
                vm.spinRefreshIcon = false;
                $log.log(error.data);
                util.showToast(util.displayValidationError(error));
            });
        }
          function fnTrackAnalytics(action, params){
            if(!params){
                var params = {};
            }
            params.mode = vm.search_param.mode;
            util.callMixpanel(action, params);
          }
          function goToQuoteDetail(){
            if(vm.isWebView){
                util.webViewObj.id = vm.inquiryDetails.quote_id;
                $state.go('app.webViewQuotesDetails',util.webViewObj);
              }else{
                $state.go('app.quotes.quotesDetails', { id: vm.inquiryDetails.quote_id });
              }
          }
          function goToShipmentDetail() {
            if (vm.isWebView) {
                util.webViewObj.id = vm.inquiryDetails.shipment_number;
              $state.go("app.mobile_shipment_details",util.webViewObj);
            } else {
              $state.go("app.shipments.shipment_details", {
                id: vm.inquiryDetails.shipment_number,
              });
            }
          }



    }
})();

(function () {
    'use strict';
  
    angular
      .module("app.core").directive('resizeHandler', function ($window, $timeout,iframeService) {
    return {
        link: function (scope, element, attrs) {
            var resizeTimeout;
            
            function onResize() {
                if (resizeTimeout) $timeout.cancel(resizeTimeout);
                
                resizeTimeout = $timeout(function () {
                    var contentContainer = document.getElementById("content-container");
                    
                    if (contentContainer) {
                        var windowHeight = contentContainer.offsetHeight;
                        scope.vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
                    }
                }, 200); // Debounce time (adjust as needed)
            }

            angular.element($window).on('resize', onResize);

            // Cleanup on destroy to prevent memory leaks
            scope.$on('$destroy', function () {
                angular.element($window).off('resize', onResize);
            });

            // Initial resize trigger
            $timeout(onResize, 0);
        }
    };
})
})();

(function () {
  'use strict';

  angular
    .module("app.core")
    .directive("truncate", function ($timeout) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {

          scope.$watch(function () {
            return attrs.truncate;
          }, function (value) {
            var text = element[0].firstChild.nodeValue.split(',');
            var prevText = '';

            element[0].firstChild.nodeValue = '';

            for (var i = 0; i < text.length; i++) {
              if (element[0].scrollWidth - 1 <= element[0].offsetWidth) {
                prevText = element[0].firstChild.nodeValue;
                element[0].firstChild.nodeValue = element[0].firstChild.nodeValue + (element[0].firstChild.nodeValue === '' ? '' : ', ') + text[i];
              } else {
                element[0].firstChild.nodeValue = prevText;
                element[0].firstChild.nodeValue = element[0].firstChild.nodeValue + ' +' + (text.length - (i - 1));
                break;
              }
            }

            if (element[0].scrollWidth - 1 > element[0].offsetWidth && text.length > 1) {
              element[0].firstChild.nodeValue = prevText;
              element[0].firstChild.nodeValue = element[0].firstChild.nodeValue + ' +' + (text.length - (i - 1));
            }
          });

        }
      }
    });

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('divSlideShow', function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var interval;
          $timeout(function() {
            if(element[0].children.length > 1) {
              element.children().css('display', 'none');
              element[0].children[0].style.display = 'block';
              interval = setInterval(timer, 2800);
            }
          });
          function timer() {
            var divs = element.children(),
            now = divs.filter(':visible'),
            next = now.next().length ? now.next() : divs.first(),
            speed = 2000;

            now.fadeOut(speed);
            next.fadeIn(speed);
          }
          element.on('$destroy', function() {
            clearInterval(interval);
            interval = 0;
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('restrictTo', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var re = RegExp(attrs.restrictTo);
          var exclude = /Backspace|Enter|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|ArrowLeft|Left|ArrowRight|Right/;

          element[0].addEventListener('keydown', function (event) {
            if (!exclude.test(event.key) && !re.test(event.key)) {
              event.preventDefault();
            }
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('compileHtml', ['$compile','$parse','$sanitize', function ($compile,$parse,$sanitize) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          scope.$watch(function () {
            var cleanAttr = $sanitize(attrs.compileHtml);
            return $parse(cleanAttr)(scope);
          }, function (value) {
            value = decodeURIComponent(decodeURIComponent(value));
            var cleaned =value ? String(value)
              .replace(/constructor\s*\./g, '')
              .replace(/\blocation\s*=/g, '')
              .replace(/javascript\s*:/g, '')
              .replace(/onerror\s*=/g, '')
              .replace(/\$eval\(/g, '')
              .replace(/{{/g, '')
              .replace(/}}/g, '')
              .replace(/\{\{([^}]*)(constructor|prototype|__proto__|window|localStorage|sessionStorage)([^}]*)\}\}/g, '') 
              .replace(/onclick\s*=/g, '') : value;
          
            // Set the sanitized HTML directly
            element.html(cleaned);
          
          
            // element.html(value);
            $compile(element.contents())(scope);
          });
        }
      };
    }]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msUpdateTitle', msUpdateTitle);

    /** @ngInject */
    function msUpdateTitle($rootScope, $timeout,$transitions)
    {
       return {
          link: function(scope, element) {
            var listener = function(event) {

              var title;

              var toState = event.to();

              if(toState.views.data != undefined){

                title =   $rootScope.domainData.domain_name.length > 0 ? $rootScope.domainData.domain_name + '-' + toState.views.data.pageTitle : toState.views.data.pageTitle;

              }
              else{
                title = $rootScope.domainData.domain_name; //'Freightbro';
              }

              $timeout(function() {
                element.text(title);
              }, 0, false);
            };
            $transitions.onStart({},listener);
          }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                // gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout,$parse, $sanitize)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var cleanSearch = $sanitize(vm.onSearch)
                var expression = $parse(cleanSearch);
                var onSearchEvaluated = expression(scope.$parent, { query: current }),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig,$parse,$sanitize)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        var cleanAttr = $sanitize(iAttrs.msScroll)
                        options = $parse(cleanAttr)(scope);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // for (let i = 0; i < vm.navigation[0].children.length; i++) {
        //   if(vm.navigation[0].children[i].title === "More"){
        //     var tempObj = angular.copy(vm.navigation[0].children[i]);
        //     vm.navigation[0].children.splice(i, 1);
        //     vm.navigation[0].children.push(tempObj);
        //   }
        // }

        // msNavigationService.navigationList = angular.copy(vm.navigation);

        // Restructure the navigation moules based on the screen width
        // function restructureModules(){
        //   if(($(window).width()<966) && ($(window).width()>599) && (msNavigationService.navigationList[0].children.length > 4)){
        //     var tempNavigation =angular.copy(msNavigationService.navigationList);
        //     var navChild = tempNavigation[0].children;
        //     var tempObj = angular.copy(navChild[navChild.length-3]);
        //     tempNavigation[0].children.splice(navChild.length-3, 1);
        //     tempNavigation[0].children[navChild.length-1].children.push(tempObj);
        //     vm.navigation = angular.copy(tempNavigation);
        //   }
        //   if($(window).width()>966){
        //     vm.navigation = angular.copy(msNavigationService.navigationList);
        //   }
        // }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        // $(window).on('resize',function(){
        //   restructureModules();
        // });

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
            // restructureModules();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService,$transitions)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    $transitions.onStart({}, function()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService,$transitions)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $transitions.onStart({},function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state,$transitions, msNavigationService, util)
    {
        var vm = this;
        vm.util = util;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $transitions.onStart({},function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry,$transitions,msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent =  $transitions.onStart({},function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('ngIntlTelInput', function ($log, util) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elm, attr, ctrl) {
          // Warning for bad directive usage.
          if ((!!attr.type && (attr.type !== 'text' && attr.type !== 'tel')) || elm[0].tagName !== 'INPUT') {
            $log.warn('ng-intl-tel-input can only be applied to a *text* or *tel* input');
            return;
          }

          elm[0].addEventListener('countrychange', handleCountryChange);

          // Initialize.
          var iti = intlTelInput(
            elm[0],
            {
              initialCountry:  (util.userLocation && util.userLocation.country) ? util.userLocation.country.toLowerCase() : 'in',
              preferredCountries: ['in', 'us', 'ca'],
              formatOnDisplay: false
            });

          // Handle Country Changes.
          function handleCountryChange() {
            if (elm[0].value) {
              if(iti.isValidNumber()) {
                ctrl.$valid = true;
                ctrl.$invalid = false;
                ctrl.$$parentForm.$error = {};
                handleParentvalidation();
              } else {
                ctrl.$valid = false;
                ctrl.$invalid = true;
              }
            }
          }

          // Trigger parent form validation
          function handleParentvalidation() {
            var inValidForm = ctrl.$$parentForm.$$controls.some(function(k) {
              if(k.$valid === false){
                return true;
              }
            });

            if(inValidForm) {
              ctrl.$$parentForm.$valid = false;
              ctrl.$$parentForm.$invalid = true;
            } else {
              ctrl.$valid = true;
              ctrl.$invalid = false;
              ctrl.$$parentForm.$valid = true;
              ctrl.$$parentForm.$invalid = false;
            }
          }


          // Validation.
          ctrl.$validators.intlTelInput = function (value) {
            // if phone number is deleted / empty do not run phone number validation
            if (value || elm[0].value.length > 0) {
              return iti.isValidNumber();
            } else {
              return true;
            }
          };

          // Set model value to valid, formatted version.
          ctrl.$parsers.push(function (value) {
            return iti.getNumber();
          });

          // Set input value to model value and trigger evaluation.
          ctrl.$formatters.push(function (value) {
            if (value) {
              iti.setNumber(value);
              // var countryData = iti.getSelectedCountryData();
              // value.replace('+'+countryData.dialCode,'')
            }
            return value;
          });

          // Clear unused resources
          elm.on('$destroy', function() {
            elm[0].removeEventListener('countrychange', handleCountryChange);
            iti.destroy();
          });

        }
      };
    });
})();


(function ()
{
    'use strict';
    angular
        .module('app.core')
        .directive('closeOnOutsideClick', closeOnOutsideClickDirective);
    /** @ngInject */
    function closeOnOutsideClickDirective($document)
    {
        return {
            restrict: 'A',
            link: function(scope, elem, attr, ctrl) {
              elem.bind('click', function(e) {
                e.stopPropagation();
              });
              $document.bind('click', function() {
                scope.$apply(attr.closeOnOutsideClick);
              })
            }
          }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ckeditor', Directive);

    function Directive($rootScope,localStorageService,api) {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                var editorOptions;
                if (attr.ckeditor === 'minimal') {
                    // minimal editor
                    editorOptions = {
                        height: 100,
                        toolbar: [
                            { name: 'basic', items: ['Bold', 'Italic', 'Underline'] },
                            // { name: 'links', items: ['Link', 'Unlink'] },
                            { name: 'tools', items: ['Maximize'] },
                            // { name: 'document', items: ['Source'] },
                        ],
                        removePlugins: 'elementspath',
                        resize_enabled: true
                    };
                } else {
                    // regular editor
                    editorOptions = {
                        filebrowserImageUploadUrl: api.baseUrl+'/api/s3upload',
                        removeButtons: 'About,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Save,CreateDiv,Language,BidiLtr,BidiRtl,Flash,Iframe,addFile,Styles,Source,Link,Unlink'
                    };
                }

                // enable ckeditor
                var ckeditor = element.ckeditor(editorOptions);

                // update ngModel on change
                ckeditor.editor.on('change', function () {
                    ngModel.$setViewValue(this.getData());
                });

                ckeditor.editor.on( 'fileUploadRequest', function( evt ) {
                    var xhr = evt.data.fileLoader.xhr;
                    xhr.setRequestHeader( 'authorization', 'Bearer '+localStorageService.get('authToken').value.access_token );
                    xhr.setRequestHeader( 'referer-domain', $rootScope.domainData.host_name );

                } );
                // adding extra plugins
                CKEDITOR.config.extraPlugins = "justify";
                CKEDITOR.config.versionCheck = false;
            }
        };
    }
  })();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive("moveNextOnMaxlength", function () {

      return {
        restrict: "A",
        link: function ($scope, element) {
          if(element.prev().length ===0){
            element.focus();          
          }
          element.on("input", function (e) {
            if (element.val().length == element.attr("maxlength")) {
              var $nextElement = element.next();
              if ($nextElement.length) {
                $nextElement[0].focus();
              }
            } else if(element.val().length == 0) {
              var $nextElement = element.prev();
              if ($nextElement.length) {
                $nextElement[0].focus();
              }
            }
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('countUp', function ($compile) {
      return {
          restrict: 'E',
          replace: false,
          scope: {
              countTo: "=countTo",
              interval: '=interval',
              countFrom: '=countFrom'
          },
          controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element) {
              $scope.millis = $scope.countFrom;
              if ($element.html().trim().length === 0) {
                  $element.append($compile('<span>{{millis}}</span>')($scope));
              } else {
                  $element.append($compile($element.contents())($scope));
              }

              var i = $scope.countFrom;
              function timeloop () {
                  setTimeout(function () {
                      $scope.millis++
                      $scope.$digest();
                      i++;
                      if (i<$scope.countTo) {
                          timeloop();
                      }
                  }, $scope.interval)
              }
              timeloop();
          }]
      }
    });
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', ['ngAvatar'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider,msApiProvider)
    {
        // $translatePartialLoaderProvider.addPart('app/toolbar');

    }
})();

(function(){
    'use strict';

    angular.module('app.toolbar')
    .factory('ToolbarSerivice' , ToolbarSerivice);

    /** @ngInject */
    function ToolbarSerivice($q,$mdToast,$http,api,$filter)
    {

        var toolbarserivice = {
            // getUserCurrency : getUserCurrency,
            updateCurrency : updateCurrency,
            reloadResultPage : reloadResultPage,
            getForwarder : getForwarder,
            currentState : '',
            userFirstName : ''
        };

        return toolbarserivice;

        // function getUserCurrency(id){
        //     var url = api.baseUrl + '/api/profile/' + id;
        //     return $http.get(url);
        // }

        function updateCurrency(user,id){
            var url = api.baseUrl + '/api/profile/' + id;
            return $http.put(url, user);
        };

        function reloadResultPage(id,isPolling){
            var url =  api.baseUrl + !isPolling ? '/api/search/' + id : '/api/v2/search/' + id;
            return $http.get(url);
        };

        function getForwarder(searchVal){
            var url = api.baseUrl + '/api/god-forwarders?limit=20';
            if(searchVal) {
                url += '&query=' + searchVal;
            }
           return $http.get(url);
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.uploadRatesV2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.uploadRatesV2', {
                url    : '/tariff/files/upload',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/upload-rates-v2/uploadRatesV2.html',
                        controller : 'uploadRatesV2Controller as vm'
                    },
                    data : { pageTitle: 'Upload Rates' }
                },
                resolve : {},
                bodyClass: 'upload-rates-v2'
            })
            .state('app.uploadRatesDetails', {
                url  : '/tariff/files/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/upload-rates-v2/uploadRatesV2.html',
                        controller : 'uploadRatesV2DetailsController as vm'
                    },
                    data : { pageTitle: 'Upload Rates Details' }
                },
                resolve: {},
                bodyClass: 'upload-rates-v2'
            });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.uploadRatesV2')
        .controller('uploadRatesV2DetailsController', uploadRatesV2DetailsController);

    /** @ngInject */
    function uploadRatesV2DetailsController(util, iframeService, $timeout, $state, $stateParams, $rootScope) {
              // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();

      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        window.removeEventListener("message", getIframeRequest, true);
      });
  

      function init() {
        util.isCallingApi = true;
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.uploadRatesV2 && util.navPermission.uploadRatesV2[1])){
          util.isCallingApi = false
            $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();
  
      // get iframe url
      function formIframeUrl() {
        var tariffId =  $stateParams.id;
        vm.iframeUrl = iframeService.fnGetIframeUrl('tariff/files/'+tariffId);
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&actionType=" + util.uploadRatesAction);
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&permissionDataAccess=true&parentUrl="+ window.location.origin);
        document.getElementById("upload-rates-v2").src = vm.iframeUrl;
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'tariff-pages'){
          $timeout(function () {
            util.isCallingApi = false;
          },10);
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
            if(event.origin === targetOrigin){
                document.getElementById('upload-rates-v2').contentWindow.postMessage({ navPermission: util.navPermission,dataSource:'permissionModule'},targetOrigin);
            }
        }
        if(event.data.source == 'uploadRatesV2'){
          $state.go('app.myRatesV2');
      }
        
      }
  
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.uploadRatesV2')
        .controller('uploadRatesV2Controller', uploadRatesV2Controller);

    /** @ngInject */
    function uploadRatesV2Controller(util, iframeService, $timeout, $state, $rootScope) {
              // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();

      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        window.removeEventListener("message", getIframeRequest, true);
      });
  
      function init() {
        util.isCallingApi = true;
        
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.uploadRatesV2 && util.navPermission.uploadRatesV2[1])){
          util.isCallingApi = false
            $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();

      $rootScope.$on('app.uploadRatesV2', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('tariff/files/upload');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&permissionDataAccess=true&parentUrl="+ window.location.origin);
        document.getElementById("upload-rates-v2").src = vm.iframeUrl;
       
      }
      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'tariff-pages'){
          $timeout(function () {
            util.isCallingApi = false;
          },10);
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
            if(event.origin === targetOrigin){
                document.getElementById('upload-rates-v2').contentWindow.postMessage({ navPermission: util.navPermission,dataSource:'permissionModule'},targetOrigin);
            }
        }
        if(event.data.source == 'uploadRatesV2'){
            $state.go('app.myRatesV2');
        }
        if(event.data.source === 'redirectToHome'){
          $state.go(util.isEfpEnabled ? "app.searchV2Module" : "app.search");
        }
        
      }
  
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.uploadRateSheet', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.uploadRateSheet', {
                url    : '/upload-rates',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/upload-rates/upload-rates.html',
                        controller : 'UploadRatesController as vm'
                    },
                    data : { pageTitle: 'Upload Rates' }
                },
                resolve: {},
                bodyClass: 'upload-rates'
            });
    }


})();

(function () {
    "use strict";
  
    angular.module("app.uploadRateSheet").controller("UploadRatesController", UploadRatesController);
  
    /** @ngInject */
    function UploadRatesController(util, iframeService, $timeout, $state, $rootScope) {
  
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;
      vm.util=util;
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
  
      // if god user changed forwarder refresh data
      $rootScope.$on('app.uploadRates', function (event, args) {
        vm.init();
      });
  
      function init() {
        util.isModulePaid('uploadRateSheet');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.uploadRateSheet && util.navPermission.uploadRateSheet[0])){
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
         $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
         }, 400);

         document.getElementById('upload-rates-iframe').onload = function() {
          var postParam = {
              'parentOrigin': util.sanitizeUrl(window.location.origin),
              'requestUploadRates': true
          }
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
          document.getElementById('upload-rates-iframe').contentWindow.postMessage(postParam,targetOrigin);
        };
         
         if(window.addEventListener) {
          window.addEventListener("message", getUploadRatesAction, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getUploadRatesAction, true);
        }
      }
      vm.init();

      $rootScope.$on('app.uploadRateSheet', function(event, args) {
        init();
      });
  
      // get my-rates iframe url
      function formIframeUrl() {
  
        vm.iframeUrl = iframeService.fnGetIframeUrl('uploadRates');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&parentOrigin=" + window.location.origin);
        document.getElementById("upload-rates-iframe").src = vm.iframeUrl
      }
      vm.getUploadRatesAction = getUploadRatesAction;
      function getUploadRatesAction(event){
        var statePage = '';
        if(!event.data.source){
           return;
        }
        if(event.origin.indexOf(vm.util.iframeOrigin)){
          switch(event.data.source){
            case 'my-rates':
              statePage = 'app.myRates'
            break;
          }
          $state.go(statePage);
        }
      }
    }
  })();
  
(function () {
  'use strict';

  angular
    .module('app.track-n-trace')
    .controller('TrackTraceController', TrackTraceController);

  /** @ngInject */
  function TrackTraceController($mdToast,$sanitize,$mdMedia,$mdSidenav,util,TrackService,$state,$log,$mdDialog,$filter,$rootScope,DTOptionsBuilder,DTColumnBuilder,$compile,$scope,$window) {

    var vm = this;
    vm.util = util;
    vm.goBack = goBack;
    vm.airLineData = [];
    vm.recentTrackings = [];
    vm.selectedairline = {};
    vm.awb_no = '';
    vm.trackingDetail = {};
    vm.shipmentList = [];
    vm.shipperList = [];
    vm.portList = [];
    vm.applyButtonVisible = false;
    vm.todayDate = new Date();
    vm.tomorrowDate = new Date();
    vm.tomorrowDate.setDate(vm.todayDate.getDate()+1);
    vm.FromPage = TrackService.FromPage;

    // function declaration starts here
    vm.submitTracking =  submitTracking;
    vm.getTrackingData =  getTrackingData;
    vm.getRecentTrackings = getRecentTrackings;

    vm.getShipmentList = getShipmentList;
    vm.getShipperList = getShipperList;
    vm.formLoadStructure =  formLoadStructure;
    vm.getShipmentsTrackingData = getShipmentsTrackingData;
    vm.cancelDialog = cancelDialog;
    vm.getPort =  util.getPorts;
    vm.clearFilter = clearFilter;
    vm.applyFilter = applyFilter;
    vm.selectShipment = selectShipment;
    vm.submitMilestone = submitMilestone;
    vm.editShipment = editShipment;
    vm.updateShipmentCall = updateShipmentCall;
    vm.searchShipments = searchShipments;
    vm.exportShipments = exportShipments;
    vm.clearAllEdit = clearAllEdit;
    vm.addLoad = addLoad;
    vm.removeLoad = removeLoad;
    vm.loadMoreRecords = loadMoreRecords;
    vm.getRecentShipments = getRecentShipments;
    vm.activeTab  = 'DASHBOARD';
    vm.resetSelectedShipmentList = resetSelectedShipmentList;
    vm.hideApplyButton = hideApplyButton;
    vm.getUrlParamsForShipment = getUrlParamsForShipment;
    vm.getEachMilestone = getEachMilestone;
    vm.getModulePermission = getModulePermission;
    vm.deleteTrack = deleteTrack;
    vm.fnDeleteData = fnDeleteData;
    vm.manualShipment = false;

    vm.toggleSidenav = toggleSidenav;
    vm.deleteSeaTrack = deleteSeaTrack;
    vm.editSeaTrack = editSeaTrack;
    vm.showCustomToast = showCustomToast;
    vm.closeToast = closeToast;
    vm.getSubvendor = getSubvendor;
    vm.applySeaFilter = applySeaFilter;
    // vm.openTrackTraceDialog = openTrackTraceDialog;
    vm.typeList = [{'id':1,'name':'Import'}, {'id':2,'name':'Export'}, {'id':3,'name':'Not Specified'}];
    vm.statusList = [{'id':1,'name':'Fetch'}, {'id':2,'name':'Completed'}, {'id':3,'name':'Archived'}, {'id':4,'name':'Available'}, {'id':5,'name':'Not Available'}];
    vm.isDataLoading = false;
    vm.isSeaDataLoading = false;
    vm.seaTrackTable = [];
    vm.uploadFile = uploadFile;
    vm.createTrackData = {
      "carrier_pref" : null,
      "sea_track_type" : "bl",
      "trackingNum" : null
    }
    vm.tempTrackData = angular.copy(vm.createTrackData);
    vm.submitSeaTracking = submitSeaTracking;
    vm.checkStatus = checkStatus;
    vm.seaFilterData = {
      "count" : 10,
      "offset" : 0,
      "filter_by" : {
          "liner": [],
          "origin": null,
          "destination": null,
          "type": [],
          "status":[],
          "from_date": null,
          "to_date": null ,
          "container_id" : ""
      },
      "is_file" : false
    }
    vm.initContainerTable = initContainerTable;
    vm.getDtColumnsData = getDtColumnsData;
    vm.tempFilterData = angular.copy(vm.seaFilterData);
    vm.editTrackData = {};
    vm.selectFile = selectFile;
    vm.upload_document = null;
    vm.getMilestoneData = getMilestoneData;
    vm.changeWaypoints = changeWaypoints;
    vm.shipTrackData = {};
    vm.trackingDetail = null;
    vm.containerDetailsTemp = [];
    vm.downloadFile = downloadFile;
    vm.openDeleteSeaTrack = openDeleteSeaTrack;
    vm.screenIsSmall = $mdMedia('sm');
    vm.screenIsExtraSmall = $mdMedia('xs');
    vm.customScreen = $mdMedia('gt-sm');
    vm.viewSampleFile = viewSampleFile;
    vm.isMilestoneLoading = false;
    vm.setFile = setFile;
    vm.isSidenavOpen = false;
    vm.fnTrackAnalytics = fnTrackAnalytics;

    function addLoad(index){
      vm.shipmentEditData.load.push({
          'pallet_no': '',
          'gross_weight': '',
          'chargeable_weight': '',
          'qty': '',
          'gross_weight_unit': 'KG',
          'chargeable_weight_unit': 'KG',
          'remarks': '',
          // 'volumetric_weight': '',
          // 'volumetric_weight_unit': 'KG',
          'load_number':  vm.shipmentEditData.load[index].load_number
      });
    }

    /**
     * function to remove load
     */
    function removeLoad(index){
        vm.shipmentEditData.load.splice(index,1);
    }

    vm.dtOptions = {
      dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth : false,
      searching: false,
      targets: 'no-sort',
      bSort: false,
      order: [],
      responsive: true,
      lengthMenu  : [10, 20, 30, 50, 100],
      pageLength  : 10
  };

      var windowHeight = vm.util.isMobileApp ? angular.element(window).height()-130 : angular.element(window).height()- 364; //set max height for quote list scroll
      vm.maxHeight = {
          'max-height' : windowHeight,
          'overflow' : 'auto'
      };

      /**
       * function used to initialize the controller
       */
      function init(){
          util.isModulePaid('track-n-trace');
          if(!(util.navPermission["track-n-trace"] && util.navPermission["track-n-trace"][1])){
            $state.go('app.pages_share_error');
          }

          if(util.navPermission.TRACK_SEA[1]){
            vm.seaTabActive = true;
            vm.initContainerTable();
          }else if(util.navPermission.TRACK_AIR[1]){
            vm.airTabActive = true;
            vm.getRecentTrackings();
          }

          vm.getModulePermission();
          vm.getSubvendor();

          if(!TrackService.airLineData.length){ // calling the airline list
              getAirLineList();
          } else{
              vm.airLineData = TrackService.airLineData;
          }

          // if(!TrackService.recentTrackings.length){ // calling the recent tracking list
              // vm.getRecentTrackings();
          // } else {
          //     vm.recentTrackings = TrackService.recentTrackings;
          // }

          // if(!TrackService.shipmentList.length){ // function to get the manual shipment list
          if( (vm.util.navPermission["createShipment"] != undefined && vm.util.navPermission["createShipment"][1]) || $rootScope.manualShipment ){
              vm.manualShipment = true;
              vm.getShipmentList();
          }
          // }
          // else{
          //     vm.shipmentList = TrackService.shipmentList;
          // }

          if(!TrackService.milestonesList.length){ // calling the milestones list
              getMilestonesList();
          } else{
              vm.milestonesList = TrackService.milestonesList;
          }

          // analytics.track('Track and Trace');
      }
      init();

      $rootScope.$on('app.track-n-trace', function(event, args) {
          // vm.isDataLoaded = false;
          TrackService.airLineData = [];
          TrackService.recentTrackings = [];
          TrackService.shipmentList = [];
          TrackService.milestonesList = [];
          vm.seaTabActive = false;
          vm.airTabActive = false;
          if(util.navPermission.TRACK_SEA[1]){
            vm.seaTabActive = true;
            vm.dtSeaInstanceCallback.rerender();
          }

          if(util.navPermission.TRACK_AIR[1]){
            vm.airTabActive = true;
            vm.getRecentTrackings();
          }

      });

      /**
       * function used to get the AirLine list of data
       */
      function getAirLineList(){
          TrackService.getAIrlineData().then(function(response){
              vm.airLineData =  response.data;
              TrackService.airLineData = angular.copy(vm.airLineData);
          },function(error){
              $log.error(error);
          });
      }


      /**
       * function used to get the Milestones list of data
       */
      function getMilestonesList(){
          vm.isDataLoading = true;
          TrackService.getMilestonesList().then(function(response){
            vm.isDataLoading = false;
            vm.milestonesList =  response.data;
            TrackService.milestonesList = angular.copy(vm.milestonesList);
          },function(error){
              $log.error(error);
          });
      }


      /**
       * funcrtion used to get the list of recent tracking data
       */
      function getRecentTrackings(){
          if (vm.spinRefreshIcon === true) {
              return;
          }
          vm.spinRefreshIcon = true;
          vm.isDataLoading = true;
          TrackService.getRecentTrackings().then(function(response){
              vm.spinRefreshIcon = false;
              vm.isDataLoading = false;
              vm.recentTrackings = response.data;
              TrackService.recentTrackings =  angular.copy(vm.recentTrackings);
          },function(error){
              vm.isDataLoading = false;
              vm.spinRefreshIcon = false;
              $log.error(error);
          });
      }

      /**
       * function used to submit the track record
       */
      function submitTracking(mode){
          if(!vm.selectedairline.name){
              util.showToast("Please Select Airline.");
              return;
          }
          if(!vm.awb_no){
              util.showToast("Please Enter AWB Number.");
              return;
          }

          if(vm.awb_no.length < 8){
              util.showToast("Please Enter Valid AWB Number.");
              return;
          }

          if( !(/^-?\d*$/.test(vm.awb_no))){
              util.showToast("Please Enter Number Only!");
              return;
          }

          var payload = {
              'tracking_type': 'awb',
              'tracking_number': vm.selectedairline.prefix+''+vm.awb_no,
              'airline_details': {
                'name': vm.selectedairline.name,
                'prefix': vm.selectedairline.prefix,
                'code': vm.selectedairline.code
              }
          };
          vm.submitDisabled = true;
          // analytics.track("Trac-Tracked",{
          //     "Mode": mode
          // });
          TrackService.createTracking(payload).then(function(response){
              vm.recentTrackings.unshift(response.data);
              vm.selectedairline = {};
              vm.awb_no = '';
              vm.submitDisabled = false;
          },function(error){
              vm.submitDisabled = false;
              util.showToast(util.displayValidationError(error));
              $log.error(error);
          });
      }

      /**
       * function used to get the Deatils of Tracking of Data called from Tracking Tab
       */
      function getTrackingData(awb,tracking,ev){
        vm.mode = 'AIR';
        if(tracking === 'NOT AVAILABLE'){
            $mdDialog.show({
                templateUrl        : 'app/main/track-n-trace/dialogs/tracking-unavailable.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
            return;
        }
        if(tracking === 'FETCHING'){
            $mdDialog.show({
                templateUrl        : 'app/main/track-n-trace/dialogs/tracking-request-submit.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }else{

            TrackService.currentShipment =  null;
            TrackService.FromPage = 'TRACKING';
            $state.go('app.track-n-trace.track-n-trace-details', {'id': awb});
        }
      }

      /**
       * function to get the tracking data called from shipment
       * @param {*} awb
       * @param {*} tracking
       * @param {*} shipment
       * @param {*} ev
       */
      function getShipmentsTrackingData(awb,tracking,shipment,ev){
          event.stopPropagation();
          if(shipment.isAvailableTracking){
              tracking =  shipment.isAvailableTracking;
          }

          if(tracking === 'FETCHING'){
              $mdDialog.show({
                  templateUrl        : 'app/main/track-n-trace/dialogs/tracking-request-submit.html',
                  targetEvent        : ev,
                  clickOutsideToClose: true,
                  controllerAs: 'ctrl',
                  controller: function() { this.parent = vm }
              });
          }
          else if(tracking === 'No Data Available'){
            $mdDialog.show({
                templateUrl        : 'app/main/track-n-trace/dialogs/tracking-unavailable.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
          }
          else{
              TrackService.currentShipment =  shipment;
              TrackService.FromPage = 'DASHBOARD';

              $state.go('app.track-n-trace.track-n-trace-details', {'id': awb});
          }
      }

      /**
       *  function to get the list of manual AIR shipments
       */
      function getShipmentList(){
          vm.isShipmentListLoading = true;
          var data = {
            'manual': true,
            'offset': TrackService.offset,
            'count': 10
          }
          TrackService.getManulalShipments(data).then(function(response){
              vm.shipmentList =  response.shipments;
              vm.shipmentListCount = response.count;
              TrackService.shipmentList = angular.copy(vm.shipmentList);
              vm.isDataLoaded = true;
              vm.isShipmentListLoading = false;
              vm.getEachMilestone();
          },function(err){
              vm.isShipmentListLoading = false;
              $log.log(err);
          });
      }

      /**
       * function to get the all shipper data
       */
      function getShipperList(){
          if(vm.shipperList.length){
              return  vm.shipperList;
          }
          return util.getShipperList().then(function (response){
              vm.shipperList =  response.data.data;
              return response.data.data;
          }, function(err){
              $log.error(err);
          });
      }


      /**
       * function to get the load details
       * @param {*} load_data
       */
      function formLoadStructure(load_data){
         var load_arr = [];
         angular.forEach(load_data.load_details_value, function(value){
              angular.forEach(value.load_metrics, function(childvalue){
                  Object.assign(childvalue,{'load_number' : value.load_number});
                  load_arr.push(childvalue);
              });
         });
         return load_arr;
      }

      function goBack() {
          $state.go('app.track-n-trace');
      }

      function cancelDialog(){
          $mdDialog.hide();
      }

      //code for Track List functionality
      vm.openMenu = openMenu;
      vm.collapseIt = collapseIt;
      vm.scrollDiv = scrollDiv;
      vm.openAddMilestoneModal = openAddMilestoneModal;
      vm.closeDialog = closeDialog;
      vm.selectShipment = selectShipment;
      vm.refreshMilestone = refreshMilestone;
      vm.selectedShipmentList = [];

      //function to open menu dropdown
      function openMenu($mdMenu,ev){
          event.stopPropagation();
          $mdMenu.open(ev);
      }

      //function to expand and collapse div
      function collapseIt(id, e, data){
          angular.element(e.currentTarget).next().slideToggle();
          vm.collapseId = (vm.collapseId === id)?-1:id;
          if(data.open) {
            data.open = false;
          } else {
            data.open = true;
            if(data.awb_object.tracking === 'completed'){
              if(data.awb_object.mawb){
                return TrackService.getTrackingDetail(data.awb_object.mawb).then(function (response){
                    data.events = response.data.events;
                    data.isAvailableTracking = response.data.tracking;
                }, function(err){
                    data.isAvailableTracking = 'error';
                    $log.error(err);
                });
              }else{
                data.isAvailableTracking = 'NOT AVAILABLE';
              }
            }

          }
      }

      function getEachMilestone() {

        // vm.shipmentList.forEach(function(i) {
        //   if(i.awb_object.tracking !== 'completed' && !i.events){
        //     if(i.awb_object.mawb) {
        //       TrackService.getTrackingDetail(i.awb_object.mawb).then(function (response){
        //           i.events = response.data.events || null;
        //           i.tracking = response.data.tracking;
        //       }, function(err){
        //           i.tracking = 'NOT AVAILABLE';
        //           $log.error(err);
        //       });
        //     } else {
        //         i.tracking = 'NOT AVAILABLE';
        //     }
        //   }

        // });

        var numbersToTrack = [];

        vm.shipmentList.forEach(function(i) {
          if(i.awb_object.mawb && !i.isAvailableTracking) {
            i.showLoading = true;
            numbersToTrack.push(i.awb_object.mawb);
          } else {
            i.events = null;
            i.isAvailableTracking = 'No Data Available';
          }
         });

         if(!numbersToTrack.length){
          return;
        }

         var data = {
           'data': {
            'tracking_numbers' : numbersToTrack
           }
         };
        TrackService.getEachTrackingDetail(data).then(function (response){
          response.data.forEach(function(i) {
            vm.shipmentList.forEach(function(j) {
              if(i.tracking_number === j.awb_object.mawb) {
                j.events = i.events || null;
                j.isAvailableTracking = i.tracking;
                j.showLoading = false;
              } else if(j.awb_object.mawb===null){
                j.events = null;
                j.isAvailableTracking = 'No Data Available';
                j.showLoading = false;
              }
            });
          });
        }, function(err){
          vm.shipmentList.forEach(function(j) {
              j.events = null;
              j.isAvailableTracking = 'No Data Available';
          });
          $log.error(err);
        });
      }

      function refreshMilestone(data) {
        if(data.awb_object.mawb){
          if(vm.refreshMilestoneCall){
            return;
          }
          vm.refreshMilestoneCall = true;
          return TrackService.getTrackingDetail(data.awb_object.mawb).then(function (response){
              data.events = response.data.events;
              data.isAvailableTracking = response.data.tracking;
              vm.refreshMilestoneCall = false;
          }, function(err){
            vm.refreshMilestoneCall = false;
              data.isAvailableTracking = 'error';
              $log.error(err);
          });
        } else {
          data.isAvailableTracking = 'NOT AVAILABLE';
        }
      }

      //function to scroll milestone div
      function scrollDiv(side,index){
          if(side === 'left'){
              angular.element("div.scroll_milestone_"+index).animate({scrollLeft: angular.element("div.scroll_milestone_"+index).scrollLeft() - 300}, 400);
          }
          if(side === 'right'){
              angular.element("div.scroll_milestone_"+index).animate({scrollLeft: angular.element("div.scroll_milestone_"+index).scrollLeft() + 300}, 400);
          }
      }

      // function to open add milestone modal
      function openAddMilestoneModal(shipment,ev){
          if(!shipment.awb_object.mawb){
              util.showToast('Please add AWB Number first!');
              return;
          }

          vm.getShipmentsTrackingData(shipment.awb_object.mawb,'AVAILABLE',shipment,ev);


          // vm.currentEventList = shipment.events;
          // var milestones = {
          //     'weight': {
          //     'UOM': 'KG'
          //         },
          //     'time_stamp_actual': null,
          //     'time_stamp_planned': null
          // };
          // vm.milestoneData = angular.copy(milestones);
          // $mdDialog.show({
          //     templateUrl        : 'app/main/track-n-trace/dialogs/add-milestone/add-milestone.html',
          //     targetEvent        : ev,
          //     clickOutsideToClose: true,
          //     controllerAs: 'ctrl',
          //     controller: function() { this.parent = vm }
          // });
      }

      //function to submit milestone
      function submitMilestone(milestoneEvent){
          milestoneEvent.time_stamp_actual = $filter('date')(milestoneEvent.time_stamp_actual, 'yyyy-MM-dd');
          milestoneEvent.time_stamp_planned = $filter('date')(milestoneEvent.time_stamp_planned, 'yyyy-MM-dd');
          var postData = vm.currentEventList;
          postData.push(milestoneEvent);
          var postMilestoneData = {
              'data' : vm.currentEventList
          };
          TrackService.updateMilestones(postMilestoneData,vm.tracking_id).then(function(response){
              vm.currentEventList = response.data;
              util.showToast('Milestones Added Successfully');
          },function(error){
              $log.error(error);
          });
      }

      //function to close modal
      function closeDialog(){
          $mdDialog.hide();
      }

      /**
       *  get the list of ports from api
       *  @param searchText
       */
      // function getPort(searchText,mode){
      //     searchText = $sanitize(searchText);
      //     return util.getPorts(searchText, mode).then(function(response){
      //         return response.data.data.port;
      //     },function(error){
      //         $log.log(error.data);
      //         return [];
      //     });
      // }

      /**
       * function to apply the filter
       */
      function applyFilter() {
        vm.isDataLoaded = false;
        if(vm.service || vm.selected_shipper || vm.dash_selectedairline || vm.air_selected_destination_port || vm.air_selected_origin_port){
          if(vm.air_selected_destination_port && vm.air_selected_origin_port) {
            if (vm.air_selected_destination_port.port_code === vm.air_selected_origin_port.port_code) {
              util.showToast('Origin and Destination port can not be same!');
              return;
            }
          }
          vm.appliedService = vm.service;
          vm.appliedSelected_shipper = vm.selected_shipper;
          vm.appliedDash_selectedairline = vm.dash_selectedairline;
          vm.appliedAir_selected_destination_port = vm.air_selected_destination_port;
          vm.appliedAir_selected_origin_port = vm.air_selected_origin_port;
          vm.isShipmentListLoading = true;
          TrackService.offset = 0;
          var payload = vm.getUrlParamsForShipment();
          TrackService.getManulalShipments(payload).then(function(response){
              vm.shipmentList =  response.shipments;
              vm.shipmentListCount = response.count;
              vm.resetSelectedShipmentList();
              vm.isDataLoaded = true;
              // TrackService.shipmentList = angular.copy(vm.shipmentList);
              vm.isShipmentListLoading = false;
              vm.getEachMilestone();
          },function(err){
              vm.isShipmentListLoading = false;
              $log.log(err);
          });
        } else {
          util.showToast('Nothing to filter!');
        }
      }

      function searchShipments() {
        if(vm.searchStatus.length === 0) {
          vm.shipmentList = TrackService.shipmentList;
        } else if(vm.searchStatus.length < 2) {
          return;
        }
        vm.isDataLoaded = false;
        TrackService.offset = 0;
        vm.isShipmentListLoading = true;
        var payload = vm.getUrlParamsForShipment();
        TrackService.getManulalShipments(payload).then(function(response){
            vm.isDataLoaded = true;
            vm.shipmentList =  response.shipments;
            vm.shipmentListCount = response.count;
            // TrackService.shipmentList = angular.copy(vm.shipmentList);
            vm.isShipmentListLoading = false;
            vm.getEachMilestone();
        },function(err){
            vm.isShipmentListLoading = false;
            $log.log(err);
        });
      }


      /**
       * function to clear the filter data
       */
      function clearFilter(){
          TrackService.offset = 0;
          vm.isShipmentListLoading = true;
          vm.isDataLoaded = false;
          vm.service = null;
          vm.range = null;
          vm.selected_shipper = null;
          vm.dash_selectedairline =  null;
          vm.air_selected_destination_port = null;
          vm.air_selected_origin_port =  null;
          vm.shipmentList = TrackService.shipmentList;
          vm.resetSelectedShipmentList();
          vm.applyButtonVisible = false;
          vm.appliedService = null;
          vm.appliedSelected_shipper = null;
          vm.appliedDash_selectedairline = null;
          vm.appliedAir_selected_destination_port = null;
          vm.appliedAir_selected_origin_port = null;
          vm.isShipmentListLoading = false;
          vm.getEachMilestone();
      }

      function hideApplyButton() {
        if((vm.service && vm.service.length) || vm.selected_shipper || (vm.dash_selectedairline && vm.dash_selectedairline.length) || vm.air_selected_destination_port || vm.air_selected_origin_port) {
          vm.applyButtonVisible = true;
        } else {
          vm.applyButtonVisible = false;
        }
      }

      function selectShipment(shipment){
          event.stopPropagation();
          if(!shipment.selected){
              vm.selectedShipmentList.push(shipment);
          }else{
              if(vm.selectedShipmentList.length > 0){
                  var index = vm.selectedShipmentList.findIndex(function(item){
                      return item._id === shipment._id;
                  });
                  vm.selectedShipmentList.splice(index, 1);
              }
          }
      }

      function clearAllEdit() {
        vm.shipmentEditData.load = [{
          'load_number': '',
          'pallet_no': '',
          'qty': '',
          'gross_weight': '',
          'gross_weight_unit': 'KG',
          'chargeable_weight': '',
          'chargeable_weight_unit': 'KG',
          'remarks': ''
        }];
      }

      function exportShipments(list) {
        if(vm.apiCalled === true){
          return;
        }
        var idString = '';
        list.forEach(function(i, k){
          if(k === 0){
            idString += i.shipment_id;
          } else {
            idString += ',' + i.shipment_id;
          }
        });
        vm.apiCalled = true;
        TrackService.exportShipments(idString).then(function(response){
            window.location = util.sanitizeQueryParams(response.data); 
            vm.resetSelectedShipmentList();
            // vm.shipment List =  response.data;
            // TrackService.shipmentList = angular.copy(vm.shipmentList);
            vm.apiCalled = false;
        },function(err){
            vm.apiCalled = false;
            $log.log(err);
        });
      }

      function editShipment(data, index) {
          vm.editIndex = index;
          vm.shipmentEditData = angular.copy(data);
          vm.shipmentEditData.load = vm.shipmentEditData.load_data.load_details_value[0].load_metrics;
          vm.shipmentEditData.pol.portcode_portname = vm.shipmentEditData.pol.port_code + '/' + (vm.shipmentEditData.pol.name || vm.shipmentEditData.pol.portname);
          if (vm.shipmentEditData.pol.name) {
            vm.shipmentEditData.pol.portname = vm.shipmentEditData.pol.name;
          }
          vm.shipmentEditData.pod.portcode_portname = vm.shipmentEditData.pod.port_code + '/' + (vm.shipmentEditData.pod.name || vm.shipmentEditData.pod.portname);
          if (vm.shipmentEditData.pod.name) {
            vm.shipmentEditData.pod.portname = vm.shipmentEditData.pod.name;
          }
          vm.shipmentEditData.service = vm.shipmentEditData.airline.service;
          vm.shipmentEditData.airlineData = vm.airLineData.find(function(i) {
            return vm.shipmentEditData.airline.prefix === i.prefix;
          });

          $mdDialog.show({
              templateUrl        : 'app/main/track-n-trace/dialogs/edit-track-shipment/edit-track-shipment.html',
              // targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm }
          });
      }

      function updateShipmentCall(shipmentData) {
         if(!shipmentData.pol) {
          util.showToast('Enter valid origin port');
          return;
        } else if(!shipmentData.pod) {
          util.showToast('Enter valid destination port');
          return;
        } else if (shipmentData.pol.port_code === shipmentData.pod.port_code) {
          util.showToast('Origin and Destination port can not be same!');
          return;
        } else if(!shipmentData.cargo_ready_date) {
          util.showToast('Dont leave pickup date empty');
          return;
        } else if(!shipmentData.arrival_date) {
          util.showToast('Dont leave ETD empty');
          return;
        } else if(!shipmentData.departure_date) {
          util.showToast('Dont leave ETA empty');
          return;
        }

        if(shipmentData.awb_object.mawb === undefined){
          util.showToast('Please enter a vaild MAWB');
          return;
        }

        var blockCalll = false;
        shipmentData.load.some(function(i){
          if(!i.load_number) {
            util.showToast("Don't leave load number empty!");
            blockCalll = true;
            return true;
          } else if(!i.pallet_no) {
            util.showToast("Don't leave pallet number empty!");
            blockCalll = true;
            return true;
          } else if(!i.qty) {
            util.showToast("Don't leave quantity empty!");
            blockCalll = true;
            return true;
          } else if(!i.gross_weight){
            util.showToast("Don't leave gross weight empty!");
            blockCalll = true;
            return true;
          } else if(!i.chargeable_weight) {
            util.showToast("Don't leave chargeable weight empty!");
            blockCalll = true;
            return true;
          }
        });

        if(blockCalll) {
          return;
        }

          var data = {
              'data': {
                'shipment_meta': {
                  'cargo_ready_date': shipmentData.cargo_ready_date,
                  'pol': {
                    'name': shipmentData.pol.portname,
                    'port_code': shipmentData.pol.port_code,
                    'portcode_portname' : shipmentData.pol.portcode_portname
                  },
                  'pod': {
                    'name': shipmentData.pod.portname,
                    'port_code': shipmentData.pod.port_code,
                    'portcode_portname' : shipmentData.pod.portcode_portname
                  },
                  'manual': true,
                  'carrier_info': {
                    "name": shipmentData.airlineData ? shipmentData.airlineData.name : null,
                    "voyage": shipmentData.carrier_info.voyage,
                    "vessel": null,
                    "carrier_code": null
                  },
                  'departure_date': shipmentData.departure_date,
                  'arrival_date': shipmentData.arrival_date,
                  'awb_object': {
                    'mawb': shipmentData.awb_object.mawb || null,
                    'hawb': shipmentData.awb_object.hawb || null
                  },
                  'airline': {
                    'name': shipmentData.airlineData ? shipmentData.airlineData.name : null,
                    'code': shipmentData.airlineData ? shipmentData.airlineData.code : null,
                    'prefix': shipmentData.airlineData ? shipmentData.airlineData.prefix : null,
                    'service': shipmentData.service || null
                  }
                },
                'load_data': {
                  '_id': shipmentData.load_data._id,
                  'load_details_value': [
                    {
                      'load_metrics': shipmentData.load,
                    }
                  ],
                  'load_type': 'load',
                  'load_meta': {
                    'gross_weight': shipmentData.load.map(function(item){
                        return item.gross_weight;
                    }).reduce(function(total,item){ return (parseFloat(total) + parseFloat(item));}),
                    'chargeable_weight': shipmentData.load.map(function(item){
                      return item.chargeable_weight;
                  }).reduce(function(total,item){ return (parseFloat(total) + parseFloat(item));}),
                    'qty': shipmentData.load.map(function(item){
                      return item.qty;
                  }).reduce(function(total,item){ return (parseInt(total) + parseInt(item));}),
                    'gross_weight_unit': 'KG',
                    'chargeable_weight_unit': 'KG'
                  }
                }
              }
            };

            util.isCallingApi = true;
            TrackService.editShipment(data, shipmentData.shipment_id).then(function(response){
                if(response.status === 'success'){
                  util.isCallingApi = false;
                  if(vm.shipmentEditData.airlineData) {
                    vm.shipmentEditData.airline = vm.shipmentEditData.airlineData;
                    vm.shipmentEditData.airline.service = vm.shipmentEditData.service;
                    vm.shipmentList[vm.editIndex] = vm.shipmentEditData;
                    vm.getEachMilestone();
                  }
                  vm.cancelDialog();
                  util.showToast('Shipment edited successfully!');
                }
                $log(response);
            },function(err){
                util.showToast(err.data.message);
                util.isCallingApi = false;
                $log.error(err);
            });
      }

      //function to get more shipment list while scrolling div
      function loadMoreRecords(index) {
          if(vm.shipmentListCount !== vm.shipmentList.length) {
              if(!vm.callingApi) {
                  util.isCallingApi = true;
                  TrackService.offset = index;
                  vm.callingApi = true;
                  var payload = vm.getUrlParamsForShipment();
                  TrackService.getManulalShipments(payload).then(function(response){
                      if(response.count!=0) {
                          vm.shipmentList = vm.shipmentList.concat(response.shipments);
                          vm.getEachMilestone();
                          TrackService.shipmentList = TrackService.shipmentList.concat(angular.copy(vm.shipmentList));
                      }
                      vm.shipmentListCount = response.count;
                      vm.callingApi = false;
                      util.isCallingApi = false;
                  },function(error) {
                      util.isCallingApi = false;
                      vm.callingApi = false;
                      $log.log(error);
                  });
              }

          }
      }

      /**
       * function used to get the list of recent shipment data
       */
      function getRecentShipments(){
          vm.isDataLoaded = false;
          if (vm.spinRefreshShipIcon === true) {
              return;
          }
          vm.spinRefreshShipIcon = true;
          TrackService.offset = 0;
          vm.isShipmentListLoading = true;
          var payload = vm.getUrlParamsForShipment();
          TrackService.getManulalShipments(payload).then(function(response) {
              vm.spinRefreshShipIcon = false;
              vm.shipmentList =  response.shipments;
              vm.isDataLoaded = true;
              vm.shipmentListCount = response.count;
              TrackService.shipmentList = angular.copy(vm.shipmentList);
              vm.resetSelectedShipmentList();
              vm.isShipmentListLoading = false;
              vm.getEachMilestone();
          },function(error) {
              vm.spinRefreshShipIcon = false;
              vm.isShipmentListLoading = false;
              $log.error(error);
          });
      }

      //function to generate url params
      function getUrlParamsForShipment() {

        var data = {};
        data.manual = true;
        data.mode = ["AIR"];
        data.offset = TrackService.offset;
        data.count  = 10;
        if(vm.appliedService) {
          data.airline_service = vm.service;
        }

        if(vm.appliedSelected_shipper) {
          data.shipper_company = [{'id': vm.selected_shipper, 'type': 'shipper_user'}];
        }

        if(vm.appliedDash_selectedairline) {
          data.airline_code = vm.dash_selectedairline;
        }

        if(vm.appliedAir_selected_destination_port) {
          data.destination_port = [vm.air_selected_destination_port.port_code];
        }

        if(vm.appliedAir_selected_origin_port) {
          data.origin_port = [vm.air_selected_origin_port.port_code];
        }

        if(vm.searchStatus) {
          data.search = vm.searchStatus;
        }
        return data;
      }

      //function to reset selected shipments list
      function resetSelectedShipmentList(){
          vm.selectedShipmentList = [];
          vm.shipmentList.forEach(function(i){
              if(i.selected){
              i.selected = false;
              }
          });
      }

      //function to get module permission
      function getModulePermission(){
          var moduleData = vm.util.get_nav.find(function(i){
              return i.code === 'TRACK';
          });
          vm.trackPermission = util.splitIntoArray(moduleData.permissions);
      }

      //function to open module for air-track delete
      function deleteTrack(ev, index,id){
          vm.deleteIndex = index;
          vm.permanentDelete = false;
          vm.showPermanentDiv = true;
          vm.deleteId = id;
          $mdDialog.show({
              templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
              targetEvent: ev,
              clickOutsideToClose: true,
              controllerAs: 'ctrl',
              controller: function () {
              this.parent = vm;
              }
          });
      }

      //function to delete the track
      function fnDeleteData(){
          vm.deleteBtn = true;

          var data = {
              "data" : {
                  "permanent_delete": vm.permanentDelete
              }
          }
          TrackService.deleteTrackData(vm.deleteId, data).then(function(){
              vm.recentTrackings.splice(vm.deleteIndex,1);
              util.showToast('Deleted Successfully');
              vm.deleteBtn = false;
              vm.closeDialog();
          },function(error){
              vm.closeDialog();
              vm.deleteBtn = false;
              util.showToast(error.data.message);
              $log.log(error);
          });
      }

      //function to toggle side navbar
      function toggleSidenav(sidenavId) {
        $mdSidenav(sidenavId).toggle();
      }

      //function to open module for sea-track delete
      function openDeleteSeaTrack(container_number, subscription_id, is_deleted){
        vm.fnTrackAnalytics('TT-TrackListData-Delete-Click');
        if(is_deleted == true){
          return true;
        }
        vm.deleteSeaData = {
          "container_id" : container_number !== 'null' ? angular.copy(container_number) : null,
          "subscription_id" : angular.copy(subscription_id)
        }
        // vm.container_number = angular.copy(container_number);
        $mdDialog.show({
            templateUrl: 'app/main/track-n-trace/dialogs/confirm-sea-delete/confirm-sea-delete.html',
            // targetEvent: ev,
            clickOutsideToClose: true,
            controllerAs: 'ctrl',
            controller: function () {
            this.parent = vm;
            }
        });
      }

      // function to delete sea track
      function deleteSeaTrack(deleteSeaData) {
        vm.seaFilterData.is_file = false;
        var data = deleteSeaData;
        util.isCallingApi = true;
        TrackService.editSeaContainer(data).then(function(response){
          util.isCallingApi = false;
          $mdDialog.hide();
          vm.dtSeaInstanceCallback.rerender();
        },function(error){
          $log.error(error);
          util.isCallingApi = false;
        });
      }

      // function to edit sea track
      function editSeaTrack(liner_code, type, container_number, subscription_id, is_deleted) {
        if(is_deleted == true){
          return true;
        }

        var subvendor = vm.subvendorList.find(function(i) {
          return i.carrier_code === liner_code;
        });

        vm.EditContainerData = {
          "container_id_old" : angular.copy(container_number),
          "carrier_pref": subvendor,
          "sea_track_type" : angular.copy(type),
          "container_no" : angular.copy(container_number),
          "subscription_id" : angular.copy(subscription_id),
          "is_archive" : false
        }
        $mdDialog.show({
            templateUrl        : 'app/main/track-n-trace/dialogs/edit-sea-track/edit-sea-track.html',
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
        });
      }

      function showCustomToast() {
        $mdToast.show({
          hideDelay: false,
          position: 'top',
          controllerAs: 'ctrl',
          controller: function () {
            this.parent = vm
          },
          templateUrl: 'app/main/track-n-trace/dialogs/toast.html'
        });
      }

      function closeToast() {
        $mdToast
          .hide()
          .then(function() {

          });
      }

      function getSubvendor(){
        vm.subvendorList = [];
          TrackService.getTrackSubVendor().then(function (response) {
            angular.forEach(response.data.subvendor_data, function (item) {
              if (item.carrier_code != null && item.carrier_code != "") {
                vm.subvendorList.push({
                  'carrier_name': item.name,
                  'carrier_code': item.carrier_code,
                  "id"  : item.id
                });
              }
            });
          }, function (error) {
            $log.error(error);
            vm.subvendorList = [];
        });
      }

      function uploadFile() {
        angular.element(document.querySelector('#uploadFile')).click();
      }

    function submitSeaTracking(createTrackData, action) {  

      if(action != 'edit' && vm.upload_document){
        util.isCallingApi = true;
        vm.trackBtn = true;

        var form = new FormData();
        form.append("file", vm.upload_document);
        form.append("sample_file", false);

        TrackService.createByFileSeaTracking(form).then(function (response) {
          var success_msg = JSON.parse(response);
          util.isCallingApi = false;
          vm.trackBtn = false;
          vm.upload_document = null;
          vm.dtSeaInstanceCallback.rerender();
          util.showToast(success_msg.data);
        }, function (error) {
          util.isCallingApi = false;
          $log.error(error);
          util.showToast(util.displayValidationError(error));
          vm.editTrackBtn = false;
        });
        vm.fnTrackAnalytics('TT-TrackSubmit-Click',{'value':vm.upload_document,'type':'File upload'});
      }
      else{
      // select liner validation
      if(!createTrackData.carrier_pref) {
        if(action == 'edit'){
          vm.editLinerValidationError = true;
          document.querySelector('#editLiner').focus();
          vm.editLinerValidationMsg = 'Please select liner.';
        }else{
          vm.selectLinerValidationError = true;
          document.querySelector('#selectLiner').focus();
          vm.selectLinerValidationMsg = 'Please select liner.';
        }

        vm.fnTrackAnalytics('TT-TrackSubmit-Click',{'validation':'Liner invalid'});
        return true;
      }
        

        createTrackData.is_file = false;


        if(vm.createTrackData.sea_track_type === 'container'){
          
          // container number validation
          if(createTrackData.trackingNum == null || createTrackData.trackingNum == "") {
            if(action == 'edit'){
              vm.editContainerNumValidationError = true;
              document.querySelector('#editContainer').focus();
              vm.editContainerNumValidationMsg = 'Container number is required.';
            }else{
              vm.containerNumValidationError = true;
              document.querySelector('#trackingNum').focus();
              vm.containerNumValidationMsg = 'Container number is required.';
            }
            vm.fnTrackAnalytics('TT-TrackSubmit-Click',{'validation':'Container number invalid'});
            return true;
          }
          // minlength validation
          else if(createTrackData.trackingNum.length != 11) {
            if(action == 'edit'){
              vm.editContainerNumValidationError = true;
              document.querySelector('#editContainer').focus();
              vm.editContainerNumValidationMsg = 'Container number should be 11 digits.';
            }else{
              vm.containerNumValidationError = true;
              document.querySelector('#trackingNum').focus();
              vm.containerNumValidationMsg = 'Container number should be 11 digits.';
            }
            vm.fnTrackAnalytics('TT-TrackSubmit-Click',{'validation':'Container number invalid'});
            return true;
          }
          // numeric validation
          else if( /[*|\":<>[\]{}`\\()';@&$]/.test(createTrackData.trackingNum) || !/[0-9]/.test(createTrackData.trackingNum) || !/[A-Za-z]/.test(createTrackData.trackingNum) ) {
            if(action == 'edit'){
              vm.editContainerNumValidationError = true;
              document.querySelector('#editContainer').focus();
              vm.editContainerNumValidationMsg = 'Container number must contain atleast one letter, one digit & avoid special character';
            }else{
              vm.containerNumValidationError = true;
              document.querySelector('#trackingNum').focus();
              vm.containerNumValidationMsg = 'Container number must contain atleast one letter, one digit & avoid special character';
            }
            vm.fnTrackAnalytics('TT-TrackSubmit-Click',{'validation':'Container number invalid'});
            return true;
        }
      } 
      vm.fnTrackAnalytics('TT-TrackSubmit-Click',{'value':createTrackData,'type':'Form upload'});
        util.isCallingApi = true;

        if(action == 'edit'){
          var data = {
            "container_id_old" : createTrackData.container_id_old,
            "container_id" : createTrackData.container_no,
            "type" : createTrackData.sea_track_type,
            "request_carrier_code": createTrackData.carrier_pref.carrier_code,
            "request_carrier_name": createTrackData.carrier_pref.carrier_name,
            "subscription_id" : createTrackData.subscription_id,
            "is_archive" : createTrackData.is_archive
          }
          vm.editTrackBtn = true;
          TrackService.editSeaContainer(data).then(function(response){
            util.isCallingApi = false;
            vm.editTrackBtn = false;
            $mdDialog.hide();
            util.showToast('Tracking will be available within the next 30 minutes.');
            vm.dtSeaInstanceCallback.rerender();
          },function(error){
            util.isCallingApi = false;
            vm.editTrackBtn = false;
            $log.error(error);
            util.showToast(error.data.message);
          });
        }
        else{
          var data = {
            "tracking_type": createTrackData.sea_track_type,
            "number" : createTrackData.trackingNum,
            "type" : 'Export',
            "liner" : createTrackData.carrier_pref.carrier_code,
            "linername" : createTrackData.carrier_pref.carrier_name
          };
          vm.trackBtn = true;
          TrackService.getBlContainerTracking(data).then(function(response){
            util.isCallingApi = false;
            vm.trackBtn = false;
            vm.createTrackData =  angular.copy(vm.tempTrackData);
            if($rootScope.domainData.domain_info.TRACK_VERSION === 'V2' && response.data.message){
              util.showToast(response.data.message);
            } else if($rootScope.domainData.domain_info.TRACK_VERSION === 'V1') {
             util.showToast("Tracking will be available within the next 30 minutes.");
            }
            vm.dtSeaInstanceCallback.rerender();
          },function(error){
            $log.error(error);
            util.isCallingApi = false;
            vm.trackBtn = false;
            util.showToast(error.data.message);
          });
        }
      }
    }

    function applySeaFilter(action,formValue) {
      vm.seaFilterData.is_file = false;
      if(action == 'apply') {
        vm.seaFilterData.offset = 0;
        if(angular.equals(vm.seaFilterData, vm.tempFilterData)){
          vm.fnTrackAnalytics('TT-FilterBy-ApplyFilter-Click',{'validation':'no filter data selected'});
          util.showToast('Please select atleast one filter.');
          return true;
        }
        if(formValue.createdFrom.$touched){
          if(!formValue.createdFrom.$valid){
            vm.fnTrackAnalytics('TT-FilterBy-ApplyFilter-Click',{'validation':'created from invalid'});
            return true;
          }
        }
        if(formValue.createdTo.$touched){
          if(!formValue.createdTo.$valid){
            vm.fnTrackAnalytics('TT-FilterBy-ApplyFilter-Click',{'validation':'created to invalid'});
            return true;
          }
        }
        var validationObj = {
          'liner' : vm.seaFilterData.filter_by.liner,
          'status' : vm.seaFilterData.filter_by.status,
          'createdFrom' : $filter('date')(vm.seaFilterData.filter_by.from_date,'yyyy-MM-dd'),
          'createdTo' : $filter('date')(vm.seaFilterData.filter_by.to_date,'yyyy-MM-dd')
        };
        vm.fnTrackAnalytics('TT-FilterBy-ApplyFilter-Click',{'value':validationObj});
      }
      else if(action == 'refresh') {
        // spinner
        vm.spinRefreshIcon = true;
        vm.fnTrackAnalytics('TT-Refresh-Click');

      }
      else {
        vm.fnTrackAnalytics('TT-FilterBy-ClearAll-Click');
        vm.seaFilterData = angular.copy(vm.tempFilterData);
        formValue.$setUntouched();
      }
      // loader
      vm.isSeaDataLoading = true;
      util.isCallingApi = true;
      vm.dtSeaInstanceCallback.rerender();
    }

    function checkStatus(statusColor, isDeleted) {
      var statusColor;
      if(isDeleted == true){
        statusColor = "grey-fg";
      }else{
        switch(statusColor) {
          case 'Fetching':
          statusColor = "orange-700-fg";
          break;

          case 'Available':
          statusColor = "green-fg";
          break;

          case 'Not Available':
          statusColor = "red-fg";
          break;

          case 'Completed':
          statusColor = "md-primary-fg";
          break;

          case 'Archived':
          statusColor = "grey-fg";
          break;

          default:
          statusColor = "red-fg";
        }
      }
      return statusColor;
    }

    function initContainerTable() {

      vm.dtSeaOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', function (data, callback, settings) {
          vm.seaFilterData.count = settings._iDisplayLength;
          vm.seaFilterData.offset = settings._iDisplayStart;
          vm.seaFilterData.filter_by.container_id = data.search.value;

          var tempFilter = angular.copy(vm.seaFilterData);
          if(tempFilter.filter_by.liner.length){
            var liner = [];
            for(var i = 0 ; i < tempFilter.filter_by.liner.length; i++){
              liner.push(tempFilter.filter_by.liner[i].carrier_code);
            }
            tempFilter.filter_by.liner = liner;
          }

          if(vm.seaFilterData.filter_by.origin) {
            tempFilter.filter_by.origin = vm.seaFilterData.filter_by.origin.portcode_portname;
          }

          if(vm.seaFilterData.filter_by.destination) {
            tempFilter.filter_by.destination = vm.seaFilterData.filter_by.destination.portcode_portname;
          }
          if(!data.search.value){
            vm.isSeaDataLoading = true;
          }

          TrackService.filterShipments(tempFilter).then(function(response){
              var recordsTotal = response.count !== null ? response.count : 0;
              vm.containerListData = angular.copy(recordsTotal);
              var new_res = formatResponse(response.data); //form response with table structure
              var table_data = {
                  'data': new_res,
                  'recordsTotal': recordsTotal,
                  'recordsFiltered': recordsTotal
              };

              util.isCallingApi = false;
              vm.isSeaDataLoading = false;
              vm.spinRefreshIcon = false;
              $mdSidenav('right').close();
              callback(table_data);
            },function(error){
                $log.error(error);
                util.isCallingApi = false;
                vm.spinRefreshIcon = false;
                vm.isSeaDataLoading = false;
            });
          })
        .withDataProp('data')
        .withOption('responsive', true)
        .withDOM('<"top left"f>ti<"bottom"lp><"clear">')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withDisplayLength(10)
        .withPaginationType('simple')
        .withOption('lengthMenu',[5,10, 20, 30, 50, 100])
        .withOption('language', {lengthMenu: "Show entries _MENU_"})
        .withOption('createdRow', function (row, data, dataIndex) {
          if(data.row_span > 1){ // if grouping bl contianer apply rowspan
            var border_bottom = dataIndex + data.row_span >= vm.seaFilterData.count ? 'border-bottom' : ''; 
            angular.element(row).find('td:eq(0)').attr('rowspan', data.row_span).addClass('row-span-text '+border_bottom+' ');
          }
          if(data.row_span === null){ // if rowspan applied remove table bl column
            angular.element(row).find('td:eq(0)').addClass('td-hide');
          }
          // Recompiling so we can bind Angular directive to the DT
          $compile(angular.element(row).contents())($scope);
        });

        vm.getDtColumnsData();//get dtcolumn data

    }
    

    // form dtColumns data for datatables
    function getDtColumnsData(){

        vm.dtSeaColumns = [
            DTColumnBuilder.newColumn(null).withClass('table_row border-right').renderWith(function (data) {
              return '<td ng-non-bindable>'+ $sanitize(data.bl_number) +'</td>' }).withTitle('BL. No'),
            DTColumnBuilder.newColumn(null).withClass('table_row').withTitle('Container Number')
            .renderWith(function (data, type, full, meta) {
              var containerRender = data.container_number !== null ? '<a class="md-link-fg" ng-class="{\'no-cursor\' : '+data.is_deleted+', \'pointer\' : '+!data.is_deleted+' }" ng-click="vm.getMilestoneData(\''+data.container_number+'\',\''+data.subscription_id+'\',\''+data.status+'\',$event);" ng-show="data.container_number !== null">'+data.container_number+'</a>' : '<p class="m-0"> - </p>';

              return containerRender+
              '<p class="grey-fg font-size-12 m-0">'+$sanitize(data.liner_name)+'</p>'
          }),
            DTColumnBuilder.newColumn(null).withClass('table_row').withTitle('Route')
            .renderWith(function(data, type, full, meta) {

              return   data.origin || data.destination ?

                     ('<div>'+
                    '<span ng-non-bindable>'+ $sanitize(data.origin) +'</span>' +
                      ( data.destination && data.origin ? '<span class="text-lowercase"> to </span><span ng-non-bindable>' : ' ' )  +  $sanitize(data.destination) + '</span>' +
                    '</div>' )   :

                    ('<div>'+
                    '<span> - </span>' +

                    '</div>' )


            }),
            DTColumnBuilder.newColumn(null).withClass('table_row').withTitle('Created by').renderWith(function (data) {
              return '<td ng-non-bindable>'+ $sanitize(data.created_by) +'</td>' }).withOption('name', 'created_by'),
            DTColumnBuilder.newColumn('updated_at').withClass('table_row').withTitle('Updated On').renderWith(function (data) {
              return '<td ng-non-bindable>'+ $sanitize(data.updated_at) +'</td>' }).withOption('name', 'updated_at'),

            DTColumnBuilder.newColumn(null).withClass('table_row').withTitle('Milestone')
            .renderWith(function(data, type, full, meta) {
              return '<div class="text-truncate">'+'<span ng-non-bindable>'+$sanitize(data.milestone_message) + '<span>' +
                        '<md-tooltip style="height: fit-content; opacity: 1; word-wrap: break-word; white-space: unset; line-height: 15px; text-align: center; padding: 5px; font-size: 14px;">' + (data.milestone_message == 'N/A' ? 'Not Available' : (data.milestone_message+' at '+data.milestone)) +
                        '</md-tooltip>'+
                        '</md-tooltip>'+
                      '</div>';
            }),

            DTColumnBuilder.newColumn(null).withClass('table_row').withTitle('Status')
            .renderWith(function(data, type, full, meta) {
              var html = '<span ng-non-bindable>'+ $sanitize(data.status) +'</span>';
              return '<span ng-class="vm.checkStatus(\''+data.status+'\',\''+data.is_deleted+'\');"><md-icon ng-class="vm.checkStatus(\''+data.status+'\',\''+data.is_deleted+'\');" class="icon bullet-icon" md-font-icon="icon-checkbox-blank-circle" aria-label="icon-checkbox-blank-circle"> </md-icon>'+ (data.is_deleted == true ? 'Archived' : (!data.status ? 'Not Available' : html) )+ '</span>';
            })
          ];

        vm.dtSeaColumns.push(DTColumnBuilder.newColumn(null).withClass('all').withTitle('Action')
          .renderWith(function (data, type, full, meta) {
          return  '<span >'+
          '<span class="ph-10" ng-if="!vm.util.navPermission.TRACK_SEA[2] || (\''+data.is_deleted+'\' == \''+true+'\' ) || ((\''+data.status+'\' != \'Fetching\') && (\''+data.status+'\' != \'Not Available\'))">-</span>'+
          '<span class="ph-10" ng-if="!vm.util.navPermission.TRACK_SEA[3] || (\''+data.is_deleted+'\' == \''+true+'\' )">-</span>'+
            '<md-icon ng-if="vm.util.navPermission.TRACK_SEA[3] && (\''+data.is_deleted+'\' == \''+undefined+'\' || \''+data.is_deleted+'\' == \''+false+'\' )" md-svg-icon="assets/icons/custom/delete-icon.svg" class="w-15 h-15 pointer" ng-click="vm.openDeleteSeaTrack(\''+data.container_number+'\',\''+data.subscription_id+'\',\''+data.is_deleted+'\')" ></md-icon>'+
            '</span>';
          }));

          ///'<md-icon ng-if="vm.util.navPermission.TRACK_SEA[2] && (\''+data.is_deleted+'\' == \''+undefined+'\' || \''+data.is_deleted+'\' == \''+false+'\' ) && ((\''+data.status+'\' == \'Fetching\') || (\''+data.status+'\' == \'Not Available\'))" md-svg-icon="assets/icons/custom/edit-icon.svg" class="w-15 h-15 pointer mr-10" ng-click="vm.editSeaTrack(\''+
          //  data.liner_code+'\',\''+data.type+'\',\''+data.container_number+'\',\''+data.subscription_id+'\',\''+data.is_deleted+'\')" ></md-icon>'

        vm.dtSeaInstanceCallback = {};
    }

    //form response with table structure
    function formatResponse(res_data){
        vm.containerDetailsTemp = res_data;
        var new_res = [];
        var row_obj = {
          "bl_number" : '',
          "container_number" : '',
          "liner_name" : '',
          "liner_code" : '',
          "origin" : '',
          "destination" : '',
          "created_by" : '',
          "updated_at" : '',
          "milestone" : '',
          "milestone_message" : '',
          "status" : '',
          "subscription_id" : '',
          "is_deleted" : '',
          "row_span": null
        };

        if(res_data === null){
          return row_obj;
        } 
          res_data.forEach(function (row) {
            row.containers.forEach(function (container,index) {
              var new_row = angular.copy(row_obj);
              new_row.bl_number = row.bl_number ? row.bl_number : '-' ;
              new_row.container_number = container.container_shipment_id;
              new_row.liner_name = container.request_carrier_name;
              new_row.liner_code = container.request_carrier_code;
              new_row.origin = container.origin_port ? container.origin_port.name : '';
              new_row.destination = container.destination_port.name ? container.destination_port.name : '';
              new_row.created_by = (container.created_by ? container.created_by.user_first_name + ' '+ container.created_by.user_last_name : 'N/A')+'<br/>'+moment.utc(new Date(container.created)).format("DD MMM YYYY") ;
              new_row.updated_at = moment.utc(new Date(container.modified)).format("DD MMM YYYY");
              new_row.milestone = container.current_milestone ? container.current_milestone.location_name : 'N/A';
              new_row.milestone_message = container.current_milestone ? container.current_milestone.name : 'N/A';
              new_row.status = container.tracking;
              new_row.subscription_id = container.subscription_id;
              new_row.is_deleted = container.is_deleted;
              new_row.row_span = index === 0 ? row.containers.length : null;
              new_res.push(new_row);
            });
          });
        return new_res;
    }

    function selectFile() {
      angular.element(document.querySelector('#uploadFile')).click();
    };

    function setFile(){
      vm.selectLinerValidationError= false;
      vm.containerNumValidationError = false;
      vm.createTrackData.carrier_pref = null;
    }

    function changeWaypoints(markers, pathData, currentVessel) {
      vm.currentVessel = currentVessel;
      vm.markers = markers;
      vm.wayPoints = [];
      vm.pathTobeCompleted = [];
      if (pathData.length !== 0) {
        var markerList = pathData.slice();
        vm.currentMarker = markerList[markerList.length - 1];
        vm.pathTobeCompleted.push([vm.currentMarker.latitude, vm.currentMarker.longitude]);
        markerList.forEach(function (arrayItem) {
          vm.wayPoints.push([arrayItem.latitude, arrayItem.longitude]);
        });
      }

      markers.forEach(function (arrayItem) {
        if (arrayItem.key == 'POD') {
          vm.pathTobeCompleted.push([arrayItem.latitude, arrayItem.longitude]);
        }
      });
    }

    function getMilestoneData(container_number,subscription_id, tracking, ev) {
      vm.fnTrackAnalytics('TT-TrackDetails-Click',{'id':container_number});
      vm.mode = 'SEA';
      if(tracking == "undefined" || tracking === 'Not Available'){
        $mdDialog.show({
            templateUrl        : 'app/main/track-n-trace/dialogs/tracking-unavailable.html',
            targetEvent        : ev,
            clickOutsideToClose: true,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
        });
        return;
      }
      else if(tracking === 'Fetching'){
        $mdDialog.show({
            templateUrl        : 'app/main/track-n-trace/dialogs/tracking-request-submit.html',
            targetEvent        : ev,
            clickOutsideToClose: true,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
        });
      }
      else{
        vm.isMilestoneLoading = true;
        TrackService.getSeaMilestones(subscription_id).then(function(response){

          vm.containerList = response.data.data;
          if(vm.containerList.container_shipments.length > 0){
            vm.containerList.container_shipments.map(function(container){ if(container.container_shipment_id === container_number){ vm.shipmentList = container } }); // maping to container list records
            vm.milestoneData =  vm.shipmentList.milestones;
            vm.changeWaypoints( vm.shipmentList.track_markers, vm.shipmentList.track_waypoints,  vm.shipmentList.container_shipment_id);
            vm.getData = true;
            vm.noData = false;
            vm.isMilestoneLoading = false;
          } else {
            vm.containerList = null;
            vm.milestoneData = [];
            vm.showNoData = vm.containerList.message;
            vm.isMilestoneLoading = false;
          }
        },function(error){
            $log.error(error);
            vm.containerList = [];
            util.showToast(error.data.message);
            vm.isMilestoneLoading = false;
        });

        // NgMap.getMap({
        //   id: 'my-map-modal'
        // }).then(function (map) {
        //   vm.map1 = map;
        //   map.setZoom(4);
        // });

        $mdDialog.show({
          templateUrl: 'app/main/track-n-trace/dialogs/tracking-dialog/trackingDialog.html',
          clickOutsideToClose: true,
          controllerAs: 'ctrl',
          controller: function () {
            this.parent = vm;
          }
        });
      }
    }

    function downloadFile() {
      vm.fnTrackAnalytics('TT-Export-Click');
      vm.seaFilterData.is_file = true;
      util.isCallingApi = true;

      var filterdata = angular.copy(vm.seaFilterData);
      if(filterdata.filter_by.liner.length){
        var liner = [];
        for(var i = 0 ; i < filterdata.filter_by.liner.length; i++){
          liner.push(filterdata.filter_by.liner[i].carrier_code);
        }
        filterdata.filter_by.liner = liner;
      }

      if(vm.seaFilterData.filter_by.origin) {
        tempFilter.filter_by.origin = vm.seaFilterData.filter_by.origin.portcode_portname;
      }

      if(vm.seaFilterData.filter_by.destination) {
        tempFilter.filter_by.destination = vm.seaFilterData.filter_by.destination.portcode_portname;
      }

      TrackService.filterShipments(filterdata).then(function(response) {
        util.isCallingApi = false;
        vm.seaFilterData.is_file = false;
        $window.open(util.sanitizeQueryParams(response.data));
      },
      function(error){
        util.isCallingApi = false;
        vm.seaFilterData.is_file = false;
        util.showToast(error.data.message);
        $log.error(error);
      });
    }

    vm.openFilter = openFilter;
    vm.closeFilter = closeFilter
    function openFilter(){
      vm.fnTrackAnalytics('TT-FilterBy-Click');
      vm.PreviousFilterData = angular.copy(vm.seaFilterData);
      $mdSidenav('right').open();
    }

    function closeFilter(){
      vm.fnTrackAnalytics('TT-FilterBy-CloseIcon-Click');
      vm.seaFilterData = angular.copy(vm.PreviousFilterData);
      $mdSidenav('right').close();
    }

    function viewSampleFile() {
      vm.fnTrackAnalytics('TT-ViewSampleDocument-Click');
      var form = new FormData();
      form.append("csv_file", null);
      form.append("sample_file", true);

        TrackService.createByFileSeaTracking(form).then(function (response) {
          var file_url = JSON.parse(response);
          vm.sampleFile = file_url.message;
          util.showToast('Sample file downloaded successfully!');
          $window.open(util.sanitizeQueryParams(file_url.message));
        }, function (error) {
          $log.error(error);
          util.showToast(util.displayValidationError(error));
        });
    }
    function fnTrackAnalytics(event, param){
      if(!param)
      {
        param={};
      }
      util.callMixpanel(event, param);
    }
    $scope.$watch('vm.isSidenavOpen', function(isSidenavOpen) {
      var scrollDiv = angular.element('#content');
      isSidenavOpen === true ? scrollDiv.addClass('div-disable-scroll') : scrollDiv.removeClass('div-disable-scroll');
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.tariffHeader', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.tariffHeader', {
                url    : '/tariff/headers',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/tariff-management/tariffHeader.html',
                        controller : 'tariffHeaderController as vm'
                    },
                    data : { pageTitle: 'Tariff Management' }
                },
                resolve : {},
                bodyClass: 'tariff-management-page'
            })
            .state('app.tariffDetails', {
                url  : '/tariff/headers/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/tariff-management/tariffHeader.html',
                        controller : 'tariffDetailsController as vm'
                    },
                    data : { pageTitle: 'Tariff Details' }
                },
                resolve: {},
                bodyClass: 'tariff-details-page'
            });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.tariffHeader')
        .controller('tariffHeaderController', tariffHeaderController);

    /** @ngInject */
    function tariffHeaderController(util, iframeService, $timeout, $state, $rootScope) {
              // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();

      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        util.isCallingApi = false  
        window.removeEventListener("message", getIframeRequest, true);
      });
  
      function init() {
        util.isCallingApi = true;
        
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.tariffHeader && util.navPermission.tariffHeader[1])){
            $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();

      $rootScope.$on('app.tariffHeader', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('tariff/headers');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&permissionDataAccess=true&parentUrl="+ window.location.origin);
        document.getElementById("tariff-management").src = vm.iframeUrl;
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'tariff-pages'){
          $timeout(function () {
            util.isCallingApi = false;
          },10);
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
            if(event.origin === targetOrigin){
                document.getElementById('tariff-management').contentWindow.postMessage({ navPermission: util.navPermission,dataSource:'permissionModule'},targetOrigin);
            }
        }
        if(event.data.source == 'tariffHeaderList'){
            $state.go('app.tariffDetails',{ id: event.data.reqData._id });
        }
        if(event.data.source === 'redirectToHome'){
          $state.go(util.isEfpEnabled ? "app.searchV2Module" : "app.search");

        }
        
      }
  
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.tariffHeader')
        .controller('tariffDetailsController', tariffDetailsController);

    /** @ngInject */
    function tariffDetailsController(util, iframeService, $timeout, $state, $stateParams, $rootScope) {
              // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();

      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        window.removeEventListener("message", getIframeRequest, true);
      });
  

      function init() {
        util.isCallingApi = true;

        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.tariffHeader && util.navPermission.tariffHeader[1])){
          util.isCallingApi = false
            $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();
  
      // get iframe url
      function formIframeUrl() {
        var tariffId =  $stateParams.id;
        vm.iframeUrl = iframeService.fnGetIframeUrl('tariff/headers/'+tariffId);
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&permissionDataAccess=true&parentUrl="+ window.location.origin);
        document.getElementById("tariff-management").src = vm.iframeUrl;
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'tariff-pages'){
          $timeout(function () {
            util.isCallingApi = false;
          },10);
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
            if(event.origin === targetOrigin){
                document.getElementById('tariff-management').contentWindow.postMessage({ navPermission: util.navPermission,dataSource:'permissionModule'},targetOrigin);
            }
        }

        if(event.data.source === 'redirectToHome'){
                    $state.go(util.isEfpEnabled ? "app.searchV2Module" : "app.search");

        }
        if(event.data.source === 'tariffList'){
          $state.go('app.tariffHeader')
        }
      }
  
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.standardQuotation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.standardQuotation', {
                url    : '/standard-quotation',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/standard-quotation/standard-quotation.html',
                        controller : 'StandardQuotationController as vm'
                    },
                    data : { pageTitle: 'standard-quotation' }
                },
                resolve : {
                    standardaQuoteData :function($window,util){
                        if(!util.standardQuotationData){
                            $window.history.back();
                        }
                    }
                },
                bodyClass: 'standard-quotation-page'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/shipments');

        // Api
        // msApiProvider.register('shipments', ['app/data/shipments/shipments.json']);
        // msApiProvider.register('shipmentDetails', ['app/data/shipments/shipmentDetails.json']);

        // msNavigationServiceProvider.saveItem('fuse.currencySetting', {
        //     title    : 'Currency Setting',
        //     icon     : 'icon-airplane',
        //     state    : 'app.currencySetting',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     // translate: 'SHIPMENTS.SHIPMENTS_NAV',
        //     weight   : 1
        // });
    }


})();

(function () {
    "use strict";
  
    angular.module("app.standardQuotation").controller("StandardQuotationController", StandardQuotationController);
  
    /** @ngInject */
    function StandardQuotationController(util, iframeService, $timeout, $state, $rootScope, $window,StandardQuotationService) {
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;
      vm.standardQuotationService = StandardQuotationService
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();
  
      function init() {
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();

      $rootScope.$on('app.standardQuotation', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('standard-quotation');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&reqAccessData=1&parentUrl="+ window.location.origin);
        document.getElementById("standard-quotation-iframe").src = vm.iframeUrl
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'standard-quotation'){
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
            if(event.origin === targetOrigin){
                document.getElementById('standard-quotation-iframe').contentWindow.postMessage({ quoteData: util.standardQuotationData,dataSource:'standard-quotation'},targetOrigin);
            }
        }
        if(event.data.source === 'genrate-standard-quotation'){
          vm.standardQuotationService.standardQuoationData = event.data.quoteData;
          
          if(event.data.quoteData.source === 'result'){
            var pageState = $rootScope.domainData.domain_info.ALLOW_RESULT_POLLING ? 'app.search.fclV2Rates' :  'app.search.result';
            $state.go(pageState,{ id: event.data.sourceId });
          }else{
            var statePage = event.data.quoteData.source === 'inquiry' ? 'app.inquiry.inquiryDetails' : 'app.quotes.quotesDetails';
            $state.go(statePage,{ id: event.data.sourceId });
          }
          
        }
      }
  
    }
  })();
  
  
(function () {
    'use strict';

    angular
      .module('app.specialRates')
      .controller('specialRatesController', specialRatesController);

    /** @ngInject */
    function specialRatesController(SpecialRatesService, SearchService, SpecialRatesData, SearchParam, $log,$q, $mdToast, util, api, $timeout, $mdDialog, $scope, $filter, $state) {

        var vm = this;
        vm.util = util;

        vm.specialRatesData = SpecialRatesData.data;
        vm.search_param_fcl = angular.copy(SearchParam.data.search_param_fcl);
        vm.getAvailableLanes = getAvailableLanes;
        vm.fnScrollBtn = fnScrollBtn;
        vm.laneList = [];
        vm.sortedSpecialCard = [];
        vm.fnSpecialRateResult = fnSpecialRateResult;
        vm.selectedLane = [];

        function init(){
            vm.specialRatesData = SpecialRatesService.getRatesExpiry(vm.specialRatesData);
            vm.getAvailableLanes();

        }
        init();

        function getAvailableLanes(){
            SpecialRatesService.getLanes().then(function(response){
                vm.laneList = response.data;
                vm.sortedSpecialCard = SpecialRatesService.fnSortLane(vm.laneList,vm.specialRatesData);
            },function(error){
                $log.log(error);
            });
        }

        function fnSpecialRateResult(item, load,parentIndex,childIndex){
            vm.cardIndex = item.lane_code+'_'+parentIndex+'_'+childIndex;

            vm.search_param_fcl.cargo_ready_date = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
            vm.search_param_fcl.origin_location = item.origin_location ? item.origin_location : item.origin_port;
            vm.search_param_fcl.destination_location = item.destination_location ? item.destination_location : item.destination_port;
            vm.search_param_fcl.inco_term = null;

            vm.search_param_fcl.search_name = vm.search_param_fcl.origin_location.location + ' to '+ vm.search_param_fcl.destination_location.location +' / '+ $filter('date')(vm.search_param_fcl.cargo_ready_date, 'd MMM yyyy');

            var loadData = [{"type" : load.container_type ,"count":1 }];

            vm.search_param_fcl.load_data = util.formFclSearchData(vm.search_param_fcl.load_data,loadData);

            if( vm.search_param_fcl.origin_location.place_type == 'Door' ){
              vm.search_param_fcl.pickup = vm.search_param_fcl.origin_location;
              vm.search_param_fcl.pickup_selected = true;
              vm.search_param_fcl.origin_charges = true;
                vm.search_param_fcl.origin_customs = true;
            }
            if( vm.search_param_fcl.destination_location.place_type == 'Door' ){
              vm.search_param_fcl.delivery = vm.search_param_fcl.destination_location;
              vm.search_param_fcl.destination_charges = true;
              vm.search_param_fcl.destination_customs = true;
              vm.search_param_fcl.delivery_selected = true;
            }

            vm.search_param_fcl["search_type"] = (vm.search_param_fcl.pickup ? 'D' : 'P') + '2' + (vm.search_param_fcl.delivery ? 'D' : 'P');

            var data =  {
                "search_param" : vm.search_param_fcl
            }
            vm.loadButton = true;
            SearchService.postSearchData(data).then(function(response){
                SearchService.FclResult =  response.data.data;
                SearchService.isNewSearch = true;
                vm.loadButton = false;
                $state.go('app.search.result',{ id: SearchService.FclResult._id });
            },function(error){
                util.showToast(error.data.message);
                vm.loadButton = false;
                $log.log(error);
            });

        }

        function fnScrollBtn(level,side,index){
            if(level == 'child'){
                if(side == 'left'){
                    angular.element('div.scroll_container_'+index).animate({scrollLeft: angular.element('div.scroll_container_'+index).scrollLeft() - 100}, 400);
                }else if(side == 'right'){
                    angular.element('div.scroll_container_'+index).animate({scrollLeft: angular.element('div.scroll_container_'+index).scrollLeft() + 100}, 400);
                }
            }
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.shipments')
    .controller('ShipmentsController', ShipmentsController);

  /** @ngInject */
  function ShipmentsController($mdSidenav, util, $scope, $rootScope, $rootElement, ShipmentService, $q, NotificationService, $log, RoleService, $state, $mdDialog, appCache,$filter,$timeout) {

    var vm = this;
    vm.util = util;
    vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER)
    vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
    vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
    vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';

    vm.util.screenTitle = "Shipments";
    vm.timelineOptions = {
      scrollEl: '#content'
    };
    vm.filterStatus = [];
    vm.filterForwarder = [];
    vm.filterMode = [];
    vm.filter_ship_specialist = [];
    vm.getMode = getMode;
    vm.getStatus = getStatus;
    vm.getForwarder = getForwarder;
    vm.getShipmentSpecialist = getShipmentSpecialist;
    vm.toggleSidenav = toggleSidenav;
    vm.formContainerType = formContainerType;
    vm.filterShipment = filterShipment;
    vm.getParty = getParty;
    vm.loadMoreRecords = loadMoreRecords;
    vm.updatedList = updatedList;
    vm.callShipmentApi = callShipmentApi;
    vm.bindShipmentSpecialist = bindShipmentSpecialist;
    vm.trackMixpanel = trackMixpanel;
    vm.setDatePicker = setDatePicker;
    vm.shipmentListCount = 0;
    vm.isResetFilter = false;
    vm.fnCutOffDateSortBy = fnCutOffDateSortBy;
    NotificationService.shipment_active_tab = '';
    vm.getShipmentByForwarder = getShipmentByForwarder;
    vm.shipmentShimmer = true;
    vm.openCreateShipmentModal = openCreateShipmentModal;
    vm.cancelDialog = cancelDialog;
    vm.selectShipment = selectShipment;
    vm.selectedShipmentList = [];
    vm.clearAll = clearAll;
    vm.deleteShipments = deleteShipments;
    vm.fnShowDeleteCard = fnShowDeleteCard;
    vm.fnConfirmDeleteCard = fnConfirmDeleteCard;
    vm.goToSearchPage = goToSearchPage;
    vm.getDomainData = getDomainData;
    vm.getFilterData = getFilterData;
    vm.initFilterData = initFilterData,
      vm.emptyFilterData = emptyFilterData;
    vm.resetFilter = resetFilter;
    vm.clearDatePicker = clearDatePicker;
    vm.filterItemtoggle = filterItemtoggle;
    vm.filterItemExists = filterItemExists;
    vm.callBackCustomer = callBackCustomer;
    vm.callBackPortDetails = callBackPortDetails;
    vm.filterStructure = null;
    vm.storeFilterObject = null;
    vm.customerDetailsObjectSlice = customerDetailsObjectSlice;
    vm.fnTrackAnalytics = fnTrackAnalytics;
    vm.date_range = {
      "from": new Date(new Date().setDate(new Date().getDate() - 30)),
      "to": new Date()
    }
    vm.customerFilterConditions = {
      'listLoader':false,
      'selectedOptions': [],
      'placeholder': 'Search Customer Details',
      'isGroupOptions' : true,
      'groupList' : {'user':{groupTitle:'User Name',keyTitle:'first_name',subKeyTitle:'email'},'company':{groupTitle:'Customer Company',keyTitle:'name',subKeyTitle:''}},
      'selectedCount' : 0
  }

    vm.incoTermsConditions = {
      'listLoader':false,
      'selectedOptions': [],
      'placeholder': 'Search Incoterms',
      'isGroupOptions' : false,
      'groupList' : {groupTitle:'',keyTitle:'code',subKeyTitle:'description'},
      'selectedCount' : 0,
      'isUpperCase' : true,
      'mixpanelPageSource':'SL'
   }

    vm.originFilterConditions = {
      'listLoader':false,
      'selectedOptions': [],
      'placeholder': 'Search by Port/Country',
      'isGroupOptions' : false,
      'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:'country'},
      'selectedCount' : 0
    }

    vm.destinationFilterConditions = {
      'listLoader':false,
      'selectedOptions': [],
      'placeholder': 'Search by Port/Country',
      'isGroupOptions' : false,
      'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:'country'},
      'selectedCount' : 0
    }

    vm.linerFilterConditions = {
      'listLoader':false,
      'selectedOptions': [],
      'placeholder': 'Search Liner / Carrier',
      'isGroupOptions' : false,
      'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
      'selectedCount' : 0
    }

    vm.transporterFilterConditions = {
      'listLoader':false,
      'selectedOptions': [],
      'placeholder': 'Search Transporter',
      'isGroupOptions' : false,
      'groupList' : {groupTitle:'',keyTitle:'name',subKeyTitle:''},
      'selectedCount' : 0
    }

    if (appCache.get('filterData') && !ShipmentService.toolbarSearchText) {
      vm.filterData = angular.copy(appCache.get('filterData'));
      $scope.pickerModel = {
        dateStart: vm.filterData.from,
        dateEnd: vm.filterData.to
      };
      vm.filteringData = true;
    } else {
      vm.emptyFilterData();
      vm.filteringData = false;
    }
    vm.collapseIt = collapseIt;
    vm.resizeScreenSize = resizeScreenSize;
    vm.filterData.deviceName = '';
    function resizeScreenSize() {
      vm.filterData.deviceName = util.resizeScreen(vm.filterData.deviceName);
    }
    window.onresize = vm.resizeScreenSize;
    vm.scrollTop = scrollTop;
    vm.onScrollAction = onScrollAction;
    vm.fnLinkRedirection = fnLinkRedirection;
    vm.btnNavClick = btnNavClick;
    vm.modeList = [{"mode" : "FCL", "isActive": false},{"mode" : "LCL", "isActive": false},{"mode" : "AIR", "isActive": true}];
    vm.openMenu = openMenu;
    vm.manualShipment = false;
    vm.trackTrace = false;
    vm.trackEvent=trackEvent
    function openMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }
    vm.getShipmentFilters = getShipmentFilters;
    vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED;

    // vm.initShipperListExists = false;

    /**
     * init function to get updated shipment list
     */
    function init() {
      util.isModulePaid('shipments');
      vm.isUnpaidModule = (!util.paidModuleList.length || (util.paidModuleList.indexOf('track-n-trace') == -1));
      vm.getDomainData();
      if(!(util.navPermission.shipments && util.navPermission.shipments[1]) ){
        $state.go('app.pages_share_error');
      }

      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";
     
      vm.emptyFilterData();
      //mixpanel code
      // analytics.track("Shipments");
      vm.shipment_list = [];
      vm.shipmentShimmer = true;
      if (!util.isFreightbro) {
        // util.isCallingApi = true;
        ShipmentService.getShipmentList(vm.filterData).then(function (response) {
          ShipmentService.shipmentList = response.data;
          vm.shipment_list = ShipmentService.shipmentList.data.shipments;
          vm.shipmentListCount = ShipmentService.shipmentList.data.count;

          if (ShipmentService.fromChild) {
            appCache.put('shippmentFilterOn', true);
            vm.callShipmentApi();
          }else{
            vm.shipmentShimmer = false;
          }
          ShipmentService.fromChild = 0;
          vm.updatedList(vm.shipment_list);
          // util.isCallingApi = false;
          calculateMaxHeight();
        }, function (error) {
          // util.isCallingApi = false;
          $state.go(util.redirectIfError(error));
          calculateMaxHeight();
        });
      } else {
        if (appCache.get('filterStructure')) {
          vm.filterStructure = angular.copy(appCache.get('filterStructure'));
        }

        if (appCache.get('filterData')) {
          vm.filterData = angular.copy(appCache.get('filterData'));
          $scope.pickerModel = {
            dateStart: vm.filterData.from,
            dateEnd: vm.filterData.to
          };
          vm.filteringData = true;
        } else {
          vm.emptyFilterData();
          vm.filteringData = false;
        }
        vm.getShipmentByForwarder($rootScope.forwarder_id);
        // util.isCallingApi = false;
        ShipmentService.shipmentList = [];
        // calculateMaxHeight();
      }
      if (ShipmentService.toolbarSearchText) {
        vm.filteringData = true;
      }

      vm.getFilterData();

      if ($state.current.name === 'app.shipments_create') {
        vm.openCreateShipmentModal(event);
      }
      vm.leftFilterTopMargin = {'position' : 'sticky','top':'0px'};
      angular.element(document.querySelector('#shipments-page')).bind('scroll', function(){
        vm.onScrollAction();
        if(!util.isMobileDevice && vm.leftFilterTopMargin){
          if($('#shipments-page').height() < $('.filter-container').height()){
            vm.leftFilterTopMargin.top = $('#shipments-page').height()-$('.filter-container').height()+'px';
          }
        }
      });
      vm.resizeScreenSize();

      // check track-n-trace and create shipment permissions
      if( (util.navPermission["createShipment"] != undefined && util.navPermission["createShipment"][0])){
        vm.manualShipment = true;
      }
      
      if( (util.navPermission["TRACK_AIR"] != undefined && util.navPermission["TRACK_AIR"][1]) || (util.navPermission["TRACK_SEA"] != undefined && util.navPermission["TRACK_SEA"][1]) ){
        vm.trackTrace = true;
      }
    }
    init();

    function calculateMaxHeight(){
      vm.maxHeight = util.getModuleMaxHeight(vm.maxHeight,'list');
      vm.maxFilterHeight = util.getModuleMaxHeight(vm.maxFilterHeight,'shipmentFilter',-45);
    }

    function filterItemtoggle(item, list, entity) {
      
  
      if (!list[entity]) {
        list[entity] = [];
      }
      var idx = list[entity].indexOf(item);
      if (idx > -1) {
        list[entity].splice(idx, 1);
      } else {
        list[entity].push(item);
      }
      vm.filterShipment();
    };

    function filterItemExists(item, list, entity) {
      if (!list[entity]) {
        return
      };
      return list[entity].indexOf(item) > -1;
    };

    function setDatePicker(data) {
      vm.filterData.from = $filter('date')(data.start_date, 'yyyy-MM-dd');
      vm.filterData.to =  $filter('date')(data.end_date, 'yyyy-MM-dd');
      vm.filterShipment();
    }

    function clearDatePicker() {
      vm.filterData.from = null;
      vm.filterData.to = null;
      $scope.pickerModel = {
        dateStart: null
      };
    }

    $rootScope.$on('app.shipments', function (event, args) {
      init();
    });

    function getFilterData() {
      if (appCache.get('filterStructure')) {
        vm.filterStructure = appCache.get('filterStructure');
      } else {
        vm.getShipmentFilters();
      }
    }

    function getShipmentFilters(searchShipperCompanyText) {

      vm.isFilterAvl = true;
      ShipmentService.getShipmentFilters({
        "data": {
          "limit" : 30,
          "offset" : 0,
          "query" : searchShipperCompanyText ? searchShipperCompanyText : ""
        }
      }).then(function (response) {
        vm.isFilterAvl = false;
        vm.filterStructure = response.data.data;
        vm.storeFilterObject = angular.copy(response.data.data);
        vm.customerDetailsObjectSlice(vm.filterStructure.customer_details);
      }, function (error) {
        vm.isFilterAvl = false;
        $state.go(util.redirectIfError(error));
      });
    }

    function initFilterData(resData) {
      vm.getMode(resData.mode);
      vm.getStatus(resData.status);
      vm.getForwarder(resData.forwarders);
      vm.getShipmentSpecialist(resData.shipment_expert);
    }

    function getDomainData() {
      if (!Object.keys($rootScope.domainData.domain_info).length) {
        util.getDomainData().then(function () {
          vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
        }, function (error) {
          $log.log(error.data);
        });
      } else {
        vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
      }
    }


    function emptyFilterData() {
      vm.filterData = {
        'order_by': 'created_at',
        'mode': null,
        'status': null,
        'search': ShipmentService.toolbarSearchText,
        'customer_success_manager': null,
        'shipment_expert': null,
        'document_expert': null,
        "from": ShipmentService.toolbarSearchText ? null : vm.date_range.from,
        "to":  ShipmentService.toolbarSearchText ? null : vm.date_range.to,
        'carrier': null,
        'origin_port': null,
        'destination_port': null,
        'pol': null,
        'pod': null,
        'transporter': null,
        'shipper_company': null,
        'vendor_id': null,
        'count': 30,
        'offset': 0,
        'customer_details':[],
        'sort_by_type': 'ASC'
      }
      vm.customerFilterConditions.selectedOptions = [];
      vm.incoTermsConditions.selectedOptions = [];
      vm.originFilterConditions.selectedOptions = [];
      vm.destinationFilterConditions.selectedOptions = [];
      vm.linerFilterConditions.selectedOptions = [];
      vm.transporterFilterConditions.selectedOptions = [];
      vm.customerFilterConditions.selectedCount = 0;
      vm.incoTermsConditions.selectedCount = 0;
      vm.date_range = {
        "from": new Date(new Date().setDate(new Date().getDate() - 30)),
        "to": new Date()
      }
      vm.isResetFilter = true;
    }

    function resetFilter() {
      if (appCache.get('shippmentFilterOn')) {
        appCache.put('shippmentFilterOn', false);
        ShipmentService.toolbarSearchText = '';
        vm.callShipmentApi('viewAll');
      } else {
        vm.filterData.search = null;
        ShipmentService.toolbarSearchText = "";
        vm.emptyFilterData();
        vm.callShipmentApi();
      }
      vm.resizeScreenSize();
    }

    // get updated list for display consignee
    function updatedList(item) {
      if (item) {
        for (var i = 0; i < item.length; i++) {
          item[i].consignee = vm.getParty("consignee", item[i].parties);
          item[i].shipper = vm.getParty("shipper", item[i].parties);
        }
      }
    }

    function getParty(category, parties) {
      var list = [];
      if (parties != null) {
        for (var i = 0; i < parties.length; i++) {
          if ((parties[i].category == category) && (parties[i].name != "")) {
            list.push(parties[i].name);
          }
        }
      }
      return list;
    }

    /**
     * get possible shipment mode
     * @param {*} shipmentMode
     */
    function getMode(shipmentMode) {
      vm.filterMode = [];
      angular.forEach(shipmentMode, function (item) {
        var modeObj = {
          "mode": item,
          "selected": false
        };
        vm.filterMode.push(modeObj);
      });
    }

    /**
     * get possible shipment status
     * @param {*} shipmentStatus
     */
    function getStatus(shipmentStatus) {
      vm.filterStatus = [];
      angular.forEach(shipmentStatus, function (item) {
        if (item) {
          var statusObj = {
            "status": item,
            "selected": false
          };
          vm.filterStatus.push(statusObj);
        }
      });
    }

    function getForwarder(shipmentForwarder) {
      vm.filterForwarder = [];
      angular.forEach(shipmentForwarder, function (item) {
        if (item) {
          var statusObj = {
            "forwarder": item,
            "selected": false
          };
          vm.filterForwarder.push(statusObj);
        }
      });
    }

    /**
     * get possible shipment specialist
     * @param {*} shipmentStatus
     */
    function getShipmentSpecialist(shipmentSpecialist) {
      vm.filter_ship_specialist = [];
      angular.forEach(shipmentSpecialist, function (item) {
        if (item) {
          var ship_specialist_obj = {
            "name": item.name,
            "id": item.id,
            "selected": false
          };
          vm.filter_ship_specialist.push(ship_specialist_obj);
        }
      });
    }

    function loadMoreRecords(index) {

      if (!vm.callShipmentListApi && vm.shipment_list.length && vm.shipmentListCount > vm.shipment_list.length  ) {

        vm.filterData.offset = index;
        // util.isCallingApi = true;
        vm.listLoader = true;
        vm.callShipmentListApi = true;
        ShipmentService.getShipmentList(vm.filterData).then(function (response) {
          if (response.data.count != 0) {
            vm.updatedList(response.data.data.shipments);
            vm.shipment_list = vm.shipment_list.concat(response.data.data.shipments);
          }
          // util.isCallingApi = false;
          vm.listLoader = false;
          vm.callShipmentListApi = false;
        }, function (error) {
          // util.isCallingApi = false;
          vm.listLoader = false;
          vm.callShipmentListApi = false;
          $log.log(error);
        });
      }
    }

    /**
     * open & close filter panal
     * @param {*} sidenavId
     */
    function toggleSidenav(sidenavId) {
      vm.search_ship_forwarder = '';
      vm.search_ship_status = '';
      vm.search_ship_specialist = '';

      $mdSidenav(sidenavId).toggle();
    }

    /**
     * function to form load details
     * @param {*} loadDetails
     */
    function formContainerType(mode, loadDetails, page, list) {
      if (loadDetails == null)
        return;

      var result = '';
      if (mode == 'SEA-FCL') {
        result = util.formLoadDetails(loadDetails, list);
      } else if (mode != 'SEA-FCL') {
        result = util.formAirLoadDetails(loadDetails, mode, page);
      }
      return result;
    }

    // call getShipmentList api
    function callShipmentApi(param) {
      var deferred = $q.defer();
      if (param === 'viewAll' || vm.filterData.search) {
        vm.emptyFilterData();
        $rootScope.$broadcast('emptySearchBox', {
          any: ''
        });
      }
      // util.isCallingApi = true;
      vm.shipment_list = [];
      if(!vm.shipmentShimmer){
        vm.scrollTop();
      }
      vm.shipmentShimmer = true;
      vm.listLoader = true;
      ShipmentService.getShipmentList(vm.filterData).then(function (response) {
        if (vm.filterData.search) {
          vm.filterData.search = null;
          ShipmentService.toolbarSearchText = "";
        }
        appCache.put('filterData', angular.copy(vm.filterData));
        vm.shipment_list = response.data.data.shipments;
        vm.shipmentListCount = response.data.data.count;
        vm.updatedList(vm.shipment_list);
        // vm.scrollTop();
        deferred.resolve(response.data.data);
        // util.isCallingApi = false;
        vm.listLoader = false;
        vm.shipmentShimmer = false;
        vm.resizeScreenSize();
      }, function (error) {
        // util.isCallingApi = false;
        vm.listLoader = false;
        vm.shipmentShimmer = false;
        util.showToast(error.message, 'top right', 3000);
        $log.log(error);
        deferred.reject(error);
      });
      return deferred.promise;
    }

    /**
     * oncheck push data in array for filter
     * @param {*} mode
     * @param {*} status
     * @param {*} consignee
     */
    function filterShipment(fromSort) {
      if (angular.equals(vm.filterData, appCache.get('filterData'))) {
        util.showToast('No changes !');
        return;
      }
      if (vm.filterData.search || vm.filterData.search === '') {
        vm.filterData.search = null;
      }
      vm.filterData.offset = 0;
      appCache.put('shippmentFilterOn', true);
      vm.callShipmentApi();
      vm.filteringData = true;
      if (!fromSort && vm.filterData.deviceName !== 'laptop') {
        vm.toggleSidenav('right');
      }
    }

        // search shipment result
        var myListener = $rootScope.$on('shipmentListWithSearch', function () {
            vm.callShipmentApi('viewAll');
            vm.filteringData = true;
        });
        $scope.$on('$destroy', myListener);

        // banner listner
        var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
            calculateMaxHeight();
        });
        $scope.$on('$destroy', bannerListener);

        // scroll to top
        function scrollTop(){
            angular.element("#shipments-page").animate({
                scrollTop: 0
            }, 600);
            return false;
        }

        // show/hide scroll btn on scroll
        function onScrollAction() {
          var raw = document.querySelector('#shipments-page');
          if (raw.scrollTop > 50) {
            document.querySelector('#shipment-return-to-top') ? document.querySelector('#shipment-return-to-top').classList.remove('hide') : '';
          }else{
            document.querySelector("#shipment-return-to-top") ? document.querySelector('#shipment-return-to-top').classList.add('hide') : '';
          }
        }

    function getShipmentByForwarder() {
      ShipmentService.getShipmentList(vm.filterData).then(function (response) {
        ShipmentService.shipmentList = response.data;
        vm.shipment_list = ShipmentService.shipmentList.data.shipments;
        vm.shipmentListCount = ShipmentService.shipmentList.data.count;

        vm.updatedList(vm.shipment_list);
        calculateMaxHeight();
        vm.shipmentShimmer = false;
      }, function (error) {
        calculateMaxHeight();
        $state.go(util.redirectIfError(error));
        $log.log(error);
      });
    }

    //function to select Shipments
    function selectShipment(event, shipment) {
      event.stopPropagation();
      if (!shipment.selected) {
        vm.selectedShipmentList.push(shipment);
      } else {
        if (vm.selectedShipmentList.length > 0) {
          var index = vm.selectedShipmentList.findIndex(function (item) {
            return item._id === shipment._id;
          });
          vm.selectedShipmentList.splice(index, 1);
        }
      }
    }

    function fnShowDeleteCard(ev, shipment) {
      ev.stopPropagation();
      vm.deleteShipment = angular.copy(shipment);
      vm.deleteData = {
        "title": "Booking",
        "deleteCard_id": [shipment.shipment_id],
        "source_title1": "Searches",
        "source_id1": "",
        "source_title2": "Quotes",
        "source_id2": "",
        "source_title3": "Inquiry",
        "source_id3": "",
        "deleteSources": false,
        "permanentDelete": false
      };

      var data = {
        "data": {
          "shipment_ids": vm.deleteData.deleteCard_id
        }
      }
      util.isCallingApi = true;
      util.delecteAssociates('shipments', data).then(function (response) {
        vm.associatesResponse = angular.copy(response.data.data);

        vm.deleteData.source_id1 = response.data.data.search_ids && response.data.data.search_ids.length ? Array.prototype.map.call(response.data.data.search_ids, function (item) {
          return item.search_name;
        }).join(",") : '';

        vm.deleteData.source_id2 = response.data.data.quote_ids && response.data.data.quote_ids.length ? Array.prototype.map.call(response.data.data.quote_ids, function (item) {
          return item.quote_id;
        }).join(",") : '';

        vm.deleteData.source_id3 = response.data.data.inquiry_ids && response.data.data.inquiry_ids.length ? Array.prototype.map.call(response.data.data.inquiry_ids, function (item) {
          return item.inquiry_id;
        }).join(",") : '';

        $mdDialog.show({
          templateUrl: 'app/main/shipments/dialogs/delete-confirmation/deleteConfirmation.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          controllerAs: 'ctrl',
          controller: function () {
            this.parent = vm;
          }
        });
        util.isCallingApi = false;

      }, function (error) {
        util.isCallingApi = false;
        util.showToast(error.message, 'top right', 3000);
        $log.log(error);
      });
    }

    function fnConfirmDeleteCard() {
      var data = {
        "data": {
          "data": {
            "shipment_ids": vm.deleteData.deleteCard_id,
            "permanent_delete": vm.deleteData.permanentDelete,
            "associate_delete": vm.deleteData.deleteSources
          }
        }
      }
      util.isCallingApi = true;
      util.delecteCardsOnId('shipments', data).then(function (response) {
        var obj = vm.shipment_list.find(function (obj) {
          return obj._id === vm.deleteShipment._id;
        });
        var index = vm.shipment_list.indexOf(obj);
        vm.shipment_list.splice(index, 1);
        vm.shipmentListCount--;
        util.isCallingApi = false;
        $mdDialog.hide();
        util.showToast('Booking Deleted Successfully.');
      }, function (error) {
        util.isCallingApi = false;
        util.showToast(error.message, 'top right', 3000);
        $log.log(error);
      });
    }

    function fnLinkRedirection(id, action){
      $mdDialog.hide().then(function() {
        if(action == 'quote'){
          util.showToast(util.displayValidationError('Redirecting to quote detail page.'));
          $state.go('app.quotes.quotesDetails', { id: id });
        }else if(action == 'inquiry'){
          util.showToast(util.displayValidationError('Redirecting to inquiry detail page.'));
          $state.go('app.inquiry.inquiryDetails', { id: id });
        }
      });
    }

    //function to clear selected shipments
    function clearAll() {
      angular.forEach(vm.selectedShipmentList, function (item) {
        item.selected = false;
      });
      vm.resizeScreenSize();
    }

    //function to delete selected shipments
    function deleteShipments() {
      var deleteData = {
        'data': {
          'data': {
            'shipment_ids': [],
            'delete_type': util.isFreightbro ? 'hard_delete' : 'soft_delete'
          }
        }
      };
      angular.forEach(vm.selectedShipmentList, function (item) {
        deleteData.data.data.shipment_ids.push(item.shipment_id);
      });
      vm.disabledDeleteBtn = true;
      ShipmentService.deleteShipments(deleteData).then(function () {
        angular.forEach(vm.selectedShipmentList, function (item) {
          var index = vm.shipment_list.findIndex(function (ship) {
            return item._id === ship._id;
          });
          vm.shipment_list.splice(index, 1);
        });
        vm.selectedShipmentList = [];
        vm.disabledDeleteBtn = false;
        $mdDialog.hide();
        util.showToast('Booking Deleted Successfully!!');
      }, function (error) {
        vm.disabledDeleteBtn = false;
        util.showToast(error.message, 'top right', 3000);
        $log.log(error);
      });
    }

    function openCreateShipmentModal(ev) {
      $mdDialog.show({
        templateUrl: 'app/main/shipments/dialogs/create-shipment/create-shipment.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        controllerAs: 'ctrl',
        controller: function () {
          this.parent = vm;
        }
      });
    }

    function cancelDialog() {
      $mdDialog.hide();
    }

    // Get shipment specialist name
    function bindShipmentSpecialist(management) {
      if (!management) {
        return;
      }
      var obj = management.find(function (obj) {
        return obj.type === "shipment_expert";
      });
      return obj ? obj.name : "Not Added";
    }

    function trackMixpanel(id) {
      util.pageOpenNewTab('app.shipments.shipment_details',{id: id});
      /*$state.go('app.shipments.shipment_details', {
        id: id
      });*/
      //mixpanel code
    }

    function goToSearchPage() {
      $state.go(util.isEfpEnabled ? "app.searchV2Module" : "app.search");
    }

    //function to expand and collapse div
    function collapseIt(id, e) {
      angular.element('#' + id).slideToggle();
    }

    // function to redirect to track-n-trcae and create shipment
    function btnNavClick(action) {
      if(action === 'track') {
        $state.go('app.track-n-trace');

      }
      // if(action === 'create_shipment-fcl') {
      //   $state.go('app.createShipment.fcl');
      // }
      if(action === 'create_shipment') {
        $state.go('app.createShipment');

      }

    }

    function trackEvent(type,value) {
      if(value==="showAll"){
        util.callMixpanel(type);
      }
      else{
        util.callMixpanel(type,{
          "Mode": vm.mode,
          "value":value
        });
      }
      }      
    function fnCutOffDateSortBy(action){
      vm.filterData.sort_by_type = action === 'ASC' ? 'DESC' : 'ASC';
      // analytics.track("shipment-Cut-Off-Date-Sort-By", {
      //   "sortByType": vm.filterData.sort_by_type
      // });
      vm.filterShipment();
    }
    
    function callBackCustomer(payload){

      if(payload.searchText || payload.searchText === ''){ // search result 
          vm.customerFilterConditions.filterLoader = true;
          var searchString = payload.searchText.toLowerCase();
          var searchResult = {};
          angular.forEach(vm.storeFilterObject.customer_details, function (item,key) {
            searchResult[key] = $filter('filter')(item, {$: searchString}, false);
          });
          $timeout(function (){
            vm.filterStructure.customer_details = searchResult;
            vm.customerFilterConditions.filterLoader = false;
            vm.customerDetailsObjectSlice(vm.filterStructure.customer_details);
          },100);   
      }
      if(payload.selectedOptions){ // selected options
        if(vm.customerFilterConditions.selectedCount !== 0){
          vm.filterData.customer_details = {
            'user' : [],
            'company': []
          }
          vm.customerFilterConditions.selectedOptions = payload.selectedOptions;
          angular.forEach(payload.selectedOptions,function(item,key){
            var paramPush = item.groupType === 'user' ? {first_name:item.first_name,company_id:item.company_id} : {id:item.id}
            vm.filterData.customer_details[item.groupType].push(paramPush)
          });
        }else{
          vm.filterData.customer_details = [];
        }
        vm.filterShipment();
      }
    }

    function callBackPortDetails(payload,source){

      var columnName = vm.originFilterConditions;
      var filterColumn = 'port_code';
      if(source === 'destination_port'){
        columnName = vm.destinationFilterConditions;
      }else if(source === 'carrier'){
        columnName = vm.linerFilterConditions;
        filterColumn = 'carrier_code';
      }else if(source === 'transporter'){
        columnName = vm.transporterFilterConditions;
        filterColumn = 'carrier_code';
      }else if(source === 'incoterms'){
        columnName = vm.incoTermsConditions;
        filterColumn = 'code';
      }

      if(payload.searchText || payload.searchText === ''){ // search result 
        columnName.filterLoader = true;
          var searchString = payload.searchText.toLowerCase();
          var searchResult = $filter('filter')(vm.storeFilterObject[source], {$: searchString}, false);
          $timeout(function (){
            vm.filterStructure[source] = searchResult;
            columnName.filterLoader = false;
          },100);   
      }
      if(payload.selectedOptions){ // selected options
        if(columnName.selectedCount !== 0){
          vm.filterData[source] = [];
          columnName.selectedOptions = payload.selectedOptions;
          angular.forEach(payload.selectedOptions,function(item,key){
            vm.filterData[source].push(item[filterColumn])
          });
        }else{
          vm.filterData[source] = [];
        }
        vm.filterShipment();
      }
    }


    function customerDetailsObjectSlice(sliceObject){
      sliceObject.company = vm.filterStructure.customer_details.company.slice(0, 40);
      sliceObject.user = vm.filterStructure.customer_details.user.slice(0, 40);
    }
    function fnTrackAnalytics(eventName,param){
      if(!param){
        param = {};
      }
      util.callMixpanel(eventName,param);
    }

  }
})();

(function () {
  "use strict";

  angular.module("app.searchV2Module", []).config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider.state("app.searchV2Module", {
      url: "/search",
      views: {
        "content@app": {
          templateUrl: "app/main/search-v2/search-v2.html",
          controller: "SearchV2Controller as vm",
        },
        data: { pageTitle: "search" },
      },
      resolve: {},
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("app.searchV2Module")
    .controller("SearchV2Controller", SearchV2Controller);

  /** @ngInject */
  function SearchV2Controller(
    util,
    iframeService,
    $timeout,
    $state,
    ScheduleSearchService,
    $scope,
    $rootScope
  ) {
    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;
    vm.util = util;
    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.getIframeRequest = getIframeRequest;

    var listenerAttached = false;

    init();

    $rootScope.$on("app.searchV2Module", function () {
      // Refresh iframe URL on forwarder switch; do not re-attach message listener
      formIframeUrl();
    });

    $scope.$on("$destroy", function () {
      if (window.removeEventListener) {
        window.removeEventListener("message", getNewRatesObj, true);
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", getNewRatesObj);
      }
      listenerAttached = false;
    });

    function init() {
      util.isModulePaid("search");
      vm.minHeight = vm.iframeService.iframeHeight;
      if (
        !(
          util.navPermission.search &&
          util.navPermission.search[1] &&
          util.isEfpEnabled
        )
      ) {
        $state.go("app.pages_share_error");
      }

      formIframeUrl();
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

      if (!listenerAttached) {
        if (window.addEventListener) {
          window.addEventListener("message", getNewRatesObj, true);
        } else if (window.attachEvent) {
          window.attachEvent("onmessage", getNewRatesObj, true);
        }
        listenerAttached = true;
      }

      $timeout(function () {
        var windowHeight =
          document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
      }, 1000);
    }

    function formIframeUrl() {
      if ($rootScope.disableEfpSearchUi) {
        return;
      }
      vm.iframeUrl = iframeService.fnGetIframeUrl("search", "", "web");
      vm.iframeUrl = iframeService.appendQuery(
        vm.iframeUrl,
        "&parentUrl=" +
          encodeURIComponent(window.location.origin) +
          "&permissionDataAccess=true"
      );
      var iframe = document.getElementById("search-v2-iframe");
      if (iframe) {
        iframe.src = vm.iframeUrl;
      } else {
        $timeout(function () {
          var el = document.getElementById("search-v2-iframe");
          if (el) {
            el.src = vm.iframeUrl;
          }
        }, 0);
      }
    }

    $scope.$watch(
      function () {
        return $rootScope.disableEfpSearchUi;
      },
      function (disabled, previous) {
        if (disabled === previous) {
          return;
        }
        if (!disabled) {
          formIframeUrl();
        }
      }
    );

    function getIframeRequest(event) {
      if (event.data && event.data.source === "polling") {
        var targetOrigin = new URL(vm.iframeUrl).origin;
        if (event.origin === targetOrigin) {
          document
            .getElementById("result-v2-iframe")
            .contentWindow.postMessage(
              { navPermission: util.navPermission, dataSource: "polling" },
              targetOrigin
            );
        }
      }
    }

    function navigateToResult(statePage, resultId) {
      if (!statePage || !resultId) {
        return;
      }
      $state.go(statePage, { id: resultId });
    }

    function getNewRatesObj(event) {
      var data = event && event.data;
      // Ignore Chrome extension / non-object payloads (detect_angular_bundle.js etc.)
      if (
        !data ||
        typeof data !== "object" ||
        Array.isArray(data) ||
        !data.source
      ) {
        return;
      }
      if (data.source === "standard-quotation" || data.source === "polling") {
        return;
      }

      if (data.reqData === "permissionDataAccess") {
        if (!vm.iframeUrl) {
          return;
        }
        var permissionTargetOrigin = new URL(vm.iframeUrl).origin;
        if (event.origin === permissionTargetOrigin) {
          var searchIframe = document.getElementById("search-v2-iframe");
          if (searchIframe && searchIframe.contentWindow) {
            searchIframe.contentWindow.postMessage(
              { navPermission: util.navPermission, dataSource: "permissionModule" },
              permissionTargetOrigin
            );
          }
        }
        return;
      }

      switch (data.source) {
        case "fcl-v2-result":
          util.oneQuoteData.pageSource = data.pageSource;
          navigateToResult("app.searchV2Module.fclEfpRates", data.resultId);
          break;
        case "lcl-v2-result":
          util.oneQuoteData.pageSource = data.pageSource;
          navigateToResult("app.searchV2Module.lclEfpRates", data.resultId);
          break;
        case "air-v2-result":
          util.oneQuoteData.pageSource = data.pageSource;
          navigateToResult("app.searchV2Module.airEfpRates", data.resultId);
          break;
        case "fcl-schedule-loading":
          $timeout(function () {
            util.isCallingApi = !!data.loading;
          });
          break;
        case "fcl-schedule":
          ScheduleSearchService.scheduleData =
            data.schedule && data.schedule.data ? data.schedule.data : [];
          ScheduleSearchService.scheduleLinerList =
            data.schedule && data.schedule.liner_schedule_count;
          ScheduleSearchService.originPort =
            data.schedule && data.schedule.originPort;
          ScheduleSearchService.destinationPort =
            data.schedule && data.schedule.destinationPort;
          $timeout(function () {
            util.isCallingApi = false;
            $state.go("app.scheduleSearch");
          });
          break;
        default:
          // Unknown sources must not navigate (prevents abstract state '')
          return;
      }
    }
  }
  })();

(function ()
{
    'use strict';

    angular
        .module('app.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController($state, $log, $filter, SearchParam, util, fcmService, SearchService, ScheduleSearchService, SpecialRatesService,$rootScope, ToolbarSerivice,$scope,analytics, ShipmentService, resultService, localStorageService, $mdDialog, appCache)
    {
      var vm = this;
      vm.util = util;
      vm.domain_name = $rootScope.domainData.host_name;
      vm.util.screenTitle = "Instant Rates";
      vm.lastSearchArray = [];
      vm.fclSearchBtn = false;
      vm.cargoMinDate = new Date();
      vm.advanceContainerType = [];
      vm.fclComponent = false;
      vm.modeImg= $rootScope.domainData.domain_info.BACKGROUND_INSTANT_RATES
      SearchService.emptySearchParam = angular.copy(SearchParam.data);
      vm.search_param_fcl = angular.copy(SearchParam.data.search_param_fcl);
      vm.quote_search_fcl = angular.copy(SearchParam.data.search_param_fcl);
      vm.searchPostData = angular.copy(SearchParam.data.search_param_fcl);
      vm.container_type = angular.copy(util.fclLoadObj());
      vm.insuranceCurrency = 'USD';
      vm.IMCO_CodeList = util.imcoCodeList();
      vm.allSalesPersonsData = null;
      vm.isLoadingApi = {
        "allSalesPerson":false
      }
      vm.currencyList = [];
      vm.load_bl_qty = 1;
      vm.load_sbl_qty = 1;
      util.salesPersonList = [];
      vm.resultFtlSearch=resultFtlSearch;
      vm.loadObj = {
          'type': '',
          'count': 1,
          'bl_qty': 1, 'sbl_qty' : 1,
          'max_weight': '',
          'weight_qty': 20000,
          'weight_unit': 'KGs',
          'max_volume': ''
      };
      vm.showAllSearches = {
        'SEA-FCL': false,
        'SEA-LCL': false,
        'AIR': false,
        'FTL':false
      };
      vm.quoteSearch = quoteSearch;
      // Tab data
      vm.tabs = [
        {
          name: 'FCL',
          permission: 'FCL',
          mode: 'SEA-FCL',
          activeTabKey: 'active_tab'
        },
        {
          name: 'LCL',
          permission: 'LCL',
          mode: 'SEA-LCL',
          activeTabKey: 'lclActive_tab',
        },
        {
          name: 'AIR',
          permission: 'AIR',
          mode: 'AIR',
          activeTabKey: 'airActive_tab',
        },
        {
          name: 'LAND',
          permission: 'FTL',
          mode: 'FTL',
          activeTabKey: 'LandActive_tab',
        }
      ];


      // air data
      vm.search_param_air = angular.copy(SearchParam.data.search_param_air);
      vm.quote_search_air = angular.copy(SearchParam.data.search_param_air);
      vm.air_inco = vm.search_param_air.inco_term;

      // air data
      vm.search_param_lcl = angular.copy(SearchParam.data.search_param_lcl);
      vm.quote_search_lcl = angular.copy(SearchParam.data.search_param_lcl);

      //ftl data
      vm.search_param_ftl = angular.copy(SearchParam.data.search_param_inland_ftl);
      vm.quote_search_ftl = angular.copy(SearchParam.data.search_param_inland_ftl);
      //// special rates
      vm.specialRates = [];
      vm.loadTypeArr = [];
      vm.userProfile = {};

      vm.fnScrollBtn = fnScrollBtn;
      vm.fnSpecialRateResult = fnSpecialRateResult;
      vm.getUserProfile = getUserProfile;
      vm.getAllSalesPersonList = getAllSalesPersonList;

      vm.searchAddLoadData = searchAddLoadData;
      // vm.getSpecialRatesAndLoadList = getSpecialRatesAndLoadList;
      vm.getSearchHistory = getSearchHistory;
      vm.getAdvancedLoadStructure = getAdvancedLoadStructure;

      angular.element('md-virtual-repeat-container').addClass('custom-container');
      vm.cancelDialog = cancelDialog;
      vm.showAll = showAll;
      vm.currentState = $state.current.name;
      vm.goBackToSearch = goBackToSearch;
      vm.showCardLimit = showCardLimit;
      vm.searchConfig = $rootScope.domainData.domain_info["SEARCH_CONFIG"];
      vm.submitSearch = submitSearch;
      vm.prefilledSearch = prefilledSearch;
      // vm.active_tab = true;
      vm.setThreeNumberDecimal = SearchService.setThreeNumberDecimal;
      vm.prefilledCardSearch = false;
      vm.fnSetShipperDetails = fnSetShipperDetails;
      vm.originPortLimit = $rootScope.domainData.domain_info["MAX_POL_POD"] ? $rootScope.domainData.domain_info["MAX_POL_POD"].origin : 1;
      vm.destinationPortLimit =  $rootScope.domainData.domain_info["MAX_POL_POD"] ?$rootScope.domainData.domain_info["MAX_POL_POD"].destination :1;
      vm.submitLandSearch=submitLandSearch;
      vm.originNearbyPortLimit =  1;
      vm.destinationNearbyPortLimit =  1;
      vm.grayOutTabs = grayOutTabs;
      ///////////

      function storeRateTypeFilterOption(){
        SearchService.getResultFilter().then(function (response){
          SearchService.rateTypeFilter = response;
        });
      }



      function init(){
         util.isModulePaid('search');
         if(!(util.navPermission.search && util.navPermission.search[1] && !util.isEfpEnabled)){
              $state.go('app.pages_share_error');
        }
         vm.grayOutTabs(vm.tabs);
          storeRateTypeFilterOption(); // call rateTypeFilter api and store value in service

          fcmService.callFcmToken('afterlogin');
          util.isCallingApi = true;

          if(!Object.keys($rootScope.domainData.domain_info).length){
              util.getDomainData().then(function(response){
                  fnSearchMeta();
              },function(error){
                  $log.log(error.data);
              });
          }else{
              fnSearchMeta();
          }


          function fnSearchMeta(){
            var searchOrder = $rootScope.domainData.domain_info['SEARCH_TAB_ORDER'] || {FCL: 1, LCL: 2, AIR: 3, FTL: 4};
            vm.tabs = vm.tabs.sort(function(a, b) {
              return (searchOrder[a.permission] || 0) - (searchOrder[b.permission] || 0);
            });
            vm[vm.tabs[0].activeTabKey] = true;
            
              vm.fclComponent = true;
              vm.getUserProfile();
              vm.getAllSalesPersonList();
              // vm.getSpecialRatesAndLoadList();
              vm.getSearchHistory();

              vm.noSearchHistory = false;
              vm.SearchHistoryReceived = false;
              vm.searchHistoryStored = SearchService.searchHistoryData;
              vm.search_param_fcl.stuffing = $rootScope.domainData.domain_info["DEFAULT_STUFFING"];

              if(!util.currencyList.length){
                  util.getCurrencyList().then(function(response){
                      vm.currencyList = util.currencyList;
                  },function(error){
                      vm.currencyList = [];
                      $log.log(error);
                  });
              }else{
                  vm.currencyList = util.currencyList;
              }
          }
          analytics.track('Instant Rates');
      }
      init();


      $rootScope.$on('app.search', function(event, args) {
          init();
      });
      function submitLandSearch(payload){
        var data = payload;

        util.isCallingApi = true;
        delete payload.id
        SearchService.FtlResult=payload
        util.isCallingApi = false;
        
        SearchService.postSearchFtlData(data).then(function(response){
            SearchService.FtlResult =  response.data.data;
            $state.go('app.search.ftlResult',{ id: SearchService.FtlResult._id });
        util.isCallingApi = false;

          });
        }


      // get user profile
      function getUserProfile(){
          if(!util.userProfile.user){
              util.getProfile().then(function(response){
                  vm.userProfile = response.user;
                  vm.searchType = response.user.advanced_search;
                  vm.searchType = 0; //show normal search by default -Ankita
                  if(vm.searchType){
                      vm.getAdvancedLoadStructure();
                  }


                  util.isCallingApi = false;
              },function(error){
                  $log.log(error.data);
                  util.isCallingApi = false;
              });
          }
          else{
              vm.userProfile = util.userProfile.user;
              vm.searchType = util.userProfile.user.advanced_search;
              vm.searchType = 0; //show normal search by default -Ankita
              if(vm.searchType){
                  vm.getAdvancedLoadStructure();
              }
              util.isCallingApi = false;
          }
      }
      function getAllSalesPersonList(){
        vm.isLoadingApi.allSalesPerson = true;
        resultService.getSalesPersonList(util.userProfile.user.id,'').then(function (response) {
          vm.allSalesPersonsData = response;
          vm.isLoadingApi.allSalesPerson = false;
        })
      }

      // function getSpecialRatesAndLoadList(){
      //     SpecialRatesService.getSpecialRates().then(function(response){
      //         vm.specialRates =   response.data ? response.data.data : [];
      //         vm.specialRates = SpecialRatesService.getRatesExpiry(vm.specialRates);
      //         if(!vm.searchParamForComponent){
      //           vm.prefilledSearch();
      //         }
      //     },function(error){
      //         vm.specialRates = [];
      //         $log.log(error.data);
      //     });
      // }

      function getSearchHistory(mode){
        if(!mode){
          return;
        }


          SearchService.activeModeTab = vm.active_tab ? 'SEA-FCL' : (vm.lclActive_tab ? 'SEA-LCL' : (vm.airActive_tab ? 'AIR' : 'FTL'));
          vm.activeSearchTab = SearchService.activeModeTab;

          if(getDataFromCache(SearchService.activeModeTab)) {
            return;
          }

          SearchService.searchHistoryData = [];
          vm.lastSearchArray = [];
          vm.SearchHistoryReceived = false;
          prepDataForComponent();

          // empty sales and shipper details if domain search config not available
          vm.fnSetShipperDetails(vm.searchParamForComponent);
          if(vm.util.navPermission.search && vm.util.navPermission.search[1] && SearchService.activeModeTab!=='FTL'){
          SearchService.getLatestSearch(0).then(function(response){
              if(response.data.data.searches.length === 0 || (response.data.data.searches[0].result_meta.search_param.mode === SearchService.activeModeTab)) {
                  var searchList = vm.searchAddLoadData(angular.copy(response.data.data.searches));
                  SearchService.searchHistoryData = searchList;
                  vm.lastSearchArray = searchList;
                  vm.prefilledSearch();

                  if(response.data.data.searches.length) {
                      appCache.put('historyOf'+ response.data.data.searches[0].result_meta.search_param.mode, searchList);
                  }
                  vm.SearchHistoryReceived = true;
              }
          },function(error){
              $log.log(error.data);
              vm.noSearchHistory = true;
          });
          }
          else if(vm.util.navPermission.search && vm.util.navPermission.search[1]){
            SearchService.getLatestFtlSearch(0).then(function(response){
              if(response.data.data.length === 0 || (response.data.data[0].mode === SearchService.activeModeTab)) {
                  SearchService.searchHistoryData = response.data.data;
                  vm.lastSearchArray = response.data.data;
                  vm.prefilledSearch();
                  vm.SearchHistoryReceived = true;
                  if(response.data.data.searches.length) {
                      appCache.put(
                        "historyOf" + response.data.data[0].mode,
                        response.data.data
                      );
                  }
              }
          },function(error){
              $log.log(error.data);
              vm.noSearchHistory = true;
          });

            }
      }

      function getDataFromCache(mode) {
        if(appCache.get('historyOf'+ mode)) {
          SearchService.searchHistoryData = appCache.get('historyOf'+ mode);
          vm.lastSearchArray = appCache.get('historyOf'+ mode);
          vm.prefilledSearch();
          return true;
        }
      }

      function prepDataForComponent() {
       if(vm.lastSearchArray.length) {
          vm.searchParamForComponent = SearchService.activeModeTab!='FTL' ? angular.copy(vm.lastSearchArray[0].result_meta.search_param): angular.copy(vm.lastSearchArray[0]);
          if(SearchService.activeModeTab!='FTL' && !vm.searchParamForComponent.search_currency){
            vm.searchParamForComponent["search_currency"]=util.userProfile.user.user_base_currency;
          }
          if(SearchService.activeModeTab=='FTL' && !vm.searchParamForComponent.searchCurrency){
            vm.searchParamForComponent["searchCurrency"]=util.userProfile.user.user_base_currency;
          }
          if(SearchService.activeModeTab!='FTL' && !vm.searchParamForComponent.enable_co2e){
            vm.searchParamForComponent["enable_co2e"]=false;
          }
          if(SearchService.activeModeTab=='FTL' && !vm.searchParamForComponent.enable_co2e){
            vm.searchParamForComponent["enable_co2e"]=false;
          }
          if(vm.searchParamForComponent.hasOwnProperty('enable_co2e')){
            vm.searchParamForComponent["enable_co2e"] = $rootScope.domainData.domain_info['ENABLE_CO2E'] && vm.searchParamForComponent["enable_co2e"];
          }

          if(SearchService.activeModeTab=='SEA-FCL' || SearchService.activeModeTab=='SEA-LCL'){
            vm.searchParamForComponent["fetch_nearby_origin"] = vm.searchParamForComponent.fetch_nearby_origin ? vm.searchParamForComponent.fetch_nearby_origin : false;
            vm.searchParamForComponent["fetch_nearby_destination"] = vm.searchParamForComponent.fetch_nearby_destination ? vm.searchParamForComponent.fetch_nearby_destination : false;
          }
        } else {
          vm.searchParamForComponent = getEmptyObjectOfMode();
          if(SearchService.activeModeTab=='FTL'){
            vm.searchParamForComponent.origin = [];
            vm.searchParamForComponent.destination = [];
            if(!vm.searchParamForComponent.searchCurrency){
              vm.searchParamForComponent["searchCurrency"]=util.userProfile.user.user_base_currency;
            }
            if(!vm.searchParamForComponent.enable_co2e){
              vm.searchParamForComponent["enable_co2e"]=false;
            }
          }
          else{
            vm.searchParamForComponent.origin_location = null;
            vm.searchParamForComponent.destination_location = null;
            if(!vm.searchParamForComponent.search_currency){
              vm.searchParamForComponent["search_currency"]=util.userProfile.user.user_base_currency;
            }
            if(!vm.searchParamForComponent.enable_co2e){
              vm.searchParamForComponent["enable_co2e"]=false;
            }
          }
         
        }
      }

      // empty sales and shipper details if domain search config not available
      function fnSetShipperDetails(searchParam){
        if(!vm.searchConfig || !vm.searchConfig.sales_person || util.isShipper){
          searchParam.sales_user = null;

          if(!vm.searchConfig || !vm.searchConfig.shipper_email){
            searchParam.shipper_user = null;
            searchParam.shipper_user_id = null;
          }
        }
      }

      function getEmptyObjectOfMode() {
        var emptyParam = null;
        if(SearchService.activeModeTab === 'SEA-FCL') {
          emptyParam = angular.copy(SearchParam.data.search_param_fcl);
          emptyParam.load_data.load_details_value = [{
            bl_qty: 1,
            qty: 1,
            sbl_qty: 1,
            type: "20GP",
            load_metrics : [{
              volume_qty: 0,
              volume_unit: "CBM",
              weight_qty: 20000,
              weight_unit: "KGs"
            }]
          }];
          emptyParam.stuffing =  $rootScope.domainData.domain_info['DEFAULT_STUFFING'];
        } else if(SearchService.activeModeTab === 'SEA-LCL') {
          emptyParam = angular.copy(SearchParam.data.search_param_lcl);
        } else if(SearchService.activeModeTab === 'AIR'){
          emptyParam = angular.copy(SearchParam.data.search_param_air);
        }
        else{
          emptyParam = angular.copy(SearchParam.data.search_param_inland_ftl);
          emptyParam.loads= [
            {
              loadType: "container",
              type: "20GP",
              qty: 1,
              weightQty: 10000,
              weightUnit: "KGs",
            }
          ]
        emptyParam.stuffing =  $rootScope.domainData.domain_info['DEFAULT_STUFFING']=='F'?'FACTORY':'DOCK';
      }
      return emptyParam;
    }

      function prefilledSearch(){
        if(($rootScope.previousState === 'app.search.recentSearch' && SearchService.historyparam)){
          vm.searchParamForComponent = angular.copy(SearchService.historyparam);
          vm.selectedIndex = 0;
          angular.element('#origin-input').focus();
          angular.element( document.querySelector( '#inquire_btn' ) ).addClass('btn_blink');
          SearchService.historyparam = '';
        }else if(($rootScope.previousState === 'app.search.offerCards' && SearchService.specialparam)){
          vm.searchParamForComponent = angular.copy(SearchService.specialparam);
          vm.selectedIndex = 0;
          angular.element('#origin-input').focus();
          angular.element( document.querySelector( '#inquire_btn' ) ).addClass('btn_blink');
          SearchService.specialparam = '';
        }else{
          prepDataForComponent();
        }

        // empty sales and shipper details if domain search config not available
        vm.fnSetShipperDetails(vm.searchParamForComponent);
      }

      function submitSearch(payload) {
        if($rootScope.domainData.domain_info.ALLOW_RESULT_POLLING && payload.mode == "SEA-FCL"){
          payload["fetchType"] = "pooling";
        }
        var data = { search_param : payload };
        util.isCallingApi = true;
        SearchService.postSearchData(data).then(function(response){
          if(response.data.data.result_meta.search_param.mode == "SEA-FCL"){
            SearchService.FclResult =  response.data.data;
            SearchService.isNewSearch = true;
            var pageState = $rootScope.domainData.domain_info
              .ALLOW_RESULT_POLLING
              ? "app.search.fclV2Rates"
              : "app.search.result";
            $state.go(pageState,{ id: SearchService.FclResult._id });
          }
          else if(response.data.data.result_meta.search_param.mode == "AIR"){
            SearchService.AirResult =  response.data.data;
            SearchService.isNewSearch = true;
            var pageState = "app.search.airResult"; ///$rootScope.domainData.domain_info.ALLOW_RESULT_POLLING ? 'app.search.airV2Rates' :  'app.search.airResult';
            $state.go(pageState,{ id: SearchService.AirResult._id });
          }
          else if(response.data.data.result_meta.search_param.mode == "SEA-LCL"){
            SearchService.LclResult =  response.data.data;
            SearchService.isNewSearch = true;
            var pageState = "app.search.lclResult";//$rootScope.domainData.domain_info.ALLOW_RESULT_POLLING ? 'app.search.lclV2Rates' :  'app.search.lclResult';
            $state.go(pageState,{ id: SearchService.LclResult._id });
          }

          util.isCallingApi = false;
      },function(error){
          util.isCallingApi = false;
          util.showToast(error.data.message);
          $log.log(error);
      });
      }

       //function for latest quote use search
      function quoteSearch(searchData,index){
        
        vm.cardIndex = index+1;
        var key;
        var data;
        vm.prefilledCardSearch = false;
        vm.isMultiDoor =  $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] &&  searchData.result_meta.search_param.mode=='SEA-FCL' ? true : false;
        if($rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][searchData.result_meta.search_param.mode] && $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][searchData.result_meta.search_param.mode].includes('*')){
          var portLimitList = $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][searchData.result_meta.search_param.mode].split('*')
           vm.originMultiPortPairLimit = portLimitList[0];
           vm.destinationMultiPortPairLimit = portLimitList[1];
           vm.is_nXn_search = true;
         }else{
           vm.multiPortPairLimit =  $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][searchData.result_meta.search_param.mode];
           vm.is_nXn_search = false;
         }
         if($rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][searchData.result_meta.search_param.mode] && searchData.result_meta.search_param.mode=='SEA-FCL'){
          if($rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][searchData.result_meta.search_param.mode] && $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][searchData.result_meta.search_param.mode].includes('*')){
            var portLimitList = $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][searchData.result_meta.search_param.mode].split('*')
             vm.originMultiDoorLimit= portLimitList[0];
             vm.destinationMultiDoorLimit = portLimitList[1];
             vm.is_door_nXn_search = true;
           }else{
             vm.multiDoorLimit =  $rootScope.domainData.domain_info["MULTI_DOOR_LIMIT"][searchData.result_meta.search_param.mode];
             vm.is_door_nXn_search = false;
           }
         }
        if(!searchData.result_meta.search_param.hasOwnProperty('freight_charges')){
          searchData.result_meta.search_param['freight_charges'] = true;
        }
        vm.isMultiPort =  $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] && ((vm.multiPortPairLimit > 1) || (vm.originMultiPortPairLimit > 1 || vm.destinationMultiPortPairLimit > 1)) ? true : false;   
        vm.originNearbyPortLimit = vm.isMultiPort  ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] : 1 :$rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] ? $rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] : 1;
        vm.destinationNearbyPortLimit =  vm.isMultiPort  ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] ? $rootScope.domainData.domain_info['MULTI_PORT_PAIR_NEARBY_LIMIT'] : 1 :$rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] ? $rootScope.domainData.domain_info["MAX_NEARBY_PORTS"] : 1;
        if(searchData.result_meta.search_param.mode == 'SEA-FCL'){

            if(vm.searchConfig &&
              (vm.searchConfig.stuffing.required && !searchData.result_meta.search_param.sales_user) ||
              (vm.searchConfig.shipper_company && vm.searchConfig.shipper_company.required && !searchData.result_meta.search_param.shipper_user) ||
              (vm.searchConfig.shipper_email && vm.searchConfig.shipper_email.required && !searchData.result_meta.search_param.shipper_user) ){
              vm.prefilledCardSearch = true;
            }

            if(new Date().setHours(0,0,0) > new Date(searchData.result_meta.search_param.cargo_ready_date)){
                vm.quote_search_fcl.cargo_ready_date = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
            }else{
                vm.quote_search_fcl.cargo_ready_date = searchData.result_meta.search_param.cargo_ready_date;
            }

           // checking data type is array or not if not convert into array - md-chip working with array only 
          if(searchData.result_meta.search_param.user_nearby_origin && !Array.isArray(searchData.result_meta.search_param.user_nearby_origin)){
               searchData.result_meta.search_param.user_nearby_origin = [searchData.result_meta.search_param.user_nearby_origin]
          }
          if(searchData.result_meta.search_param.user_nearby_origin && !Array.isArray(searchData.result_meta.search_param.user_nearby_destination)){
               searchData.result_meta.search_param.user_nearby_destination = [searchData.result_meta.search_param.user_nearby_destination]
          }
          vm.nearby_origin=searchData.result_meta.search_param.user_nearby_origin.filter(function(item){
            return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
          });
          vm.nearby_destination=searchData.result_meta.search_param.user_nearby_destination.filter(function(item){
            return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
          });
          vm.origin_alias=searchData.result_meta.search_param.user_nearby_origin.filter(function(item){
            return (item.input_type == 'alias');
          });
    
          vm.destination_alias=searchData.result_meta.search_param.user_nearby_destination.filter(function(item){
            return (item.input_type == 'alias');
          });
          searchData.result_meta.search_param.user_nearby_origin =  searchData.result_meta.search_param.user_nearby_origin.filter(function(item){
            return (item.input_type == 'user' || !item.input_type);
          });
          searchData.result_meta.search_param.user_nearby_destination =  searchData.result_meta.search_param.user_nearby_destination.filter(function(item){
            return (item.input_type == 'user' || !item.input_type);
          });
         searchData.result_meta.search_param.user_nearby_origin.forEach(function(value){
          if(!value.input_type){
           value['input_type']='user'
          }
         })
         searchData.result_meta.search_param.user_nearby_destination.forEach(function(value){
          if(!value.input_type){
           value['input_type']='user'
          }
         })
            vm.quote_search_fcl.origin_location = searchData.result_meta.search_param.origin_location;
            vm.quote_search_fcl.destination_location = searchData.result_meta.search_param.destination_location;
            vm.quote_search_fcl.origin_input_text = searchData.result_meta.search_param.origin_input_text;
            vm.quote_search_fcl.destination_input_text = searchData.result_meta.search_param.destination_input_text;

            // var loadData;
            

            // vm.quote_search_fcl.load_data = util.formFclSearchData(searchData.result_meta.search_param.load_data,loadData);

            // New design Code
            vm.quote_search_fcl.load_data = searchData.result_meta.search_param.load_data;
            // New design Code End

            vm.quote_search_fcl["stuffing"] = searchData.result_meta.search_param.stuffing ? searchData.result_meta.search_param.stuffing : $rootScope.domainData.domain_info["DEFAULT_STUFFING"];
            vm.quote_search_fcl.inco_term = searchData.result_meta.search_param.inco_term;
            vm.quote_search_fcl.impo_expo = searchData.result_meta.search_param.impo_expo;

            vm.quote_search_fcl.shipper_user = searchData.result_meta.search_param.shipper_user;
            vm.quote_search_fcl.sales_user = searchData.result_meta.search_param.sales_user;
            vm.quote_search_fcl.destination_charges = searchData.result_meta.search_param.destination_charges;
            vm.quote_search_fcl.destination_customs = searchData.result_meta.search_param.destination_customs;
            vm.quote_search_fcl.origin_charges = searchData.result_meta.search_param.origin_charges;
            vm.quote_search_fcl.origin_customs = searchData.result_meta.search_param.origin_customs;
            vm.quote_search_fcl.freight_charges = searchData.result_meta.search_param.freight_charges;
            vm.quote_search_fcl.fetch_nearby_destination = searchData.result_meta.search_param.fetch_nearby_destination ? searchData.result_meta.search_param.fetch_nearby_destination : false;
            vm.quote_search_fcl.fetch_nearby_origin = searchData.result_meta.search_param.fetch_nearby_origin ? searchData.result_meta.search_param.fetch_nearby_origin : false;
            vm.quote_search_fcl.stuffing = searchData.result_meta.search_param.stuffing;
            vm.quote_search_fcl.user_nearby_origin = searchData.result_meta.search_param.user_nearby_origin;
            vm.quote_search_fcl.user_nearby_destination = searchData.result_meta.search_param.user_nearby_destination;
            vm.quote_search_fcl.search_currency = searchData.result_meta.search_param.search_currency ? searchData.result_meta.search_param.search_currency : util.userProfile.user.user_base_currency;
            vm.quote_search_fcl.selected_carrier = searchData.result_meta.search_param.selected_carrier ? searchData.result_meta.search_param.selected_carrier : vm.quote_search_fcl.selected_carrier;
            vm.quote_search_fcl["user_pol"] = searchData.result_meta.search_param["user_pol"];
            vm.quote_search_fcl["user_pod"] = searchData.result_meta.search_param["user_pod"];
            vm.quote_search_fcl["origin_service_mode"] =
              searchData.result_meta.search_param["origin_service_mode"];
            vm.quote_search_fcl["enable_co2e"] =
              $rootScope.domainData.domain_info["ENABLE_CO2E"] &&
              searchData.result_meta.search_param["enable_co2e"];
            vm.quote_search_fcl["destination_service_mode"] =
              searchData.result_meta.search_param["destination_service_mode"];
            //  checking multi port allowed or not
            // if multi port limit is less than port count then taking first set of ports based on port limit
            if(vm.quote_search_fcl.user_nearby_origin && vm.quote_search_fcl.user_nearby_origin.length && vm.quote_search_fcl.user_nearby_origin[0].place_type == 'Door' && vm.isMultiDoor){
              var originLimit = vm.is_door_nXn_search ? vm.originMultiDoorLimit : vm.multiDoorLimit;
              var destinationLimit = vm.is_door_nXn_search ? vm.destinationMultiDoorLimit : vm.multiDoorLimit;
              vm.quote_search_fcl.user_nearby_origin =  (vm.quote_search_fcl.user_nearby_origin ? (vm.quote_search_fcl.user_nearby_origin.length > originLimit ? vm.quote_search_fcl.user_nearby_origin.slice(0,originLimit)  :vm.quote_search_fcl.user_nearby_origin ) : []);
              vm.quote_search_fcl.user_nearby_destination =  (vm.quote_search_fcl.user_nearby_destination ?  (vm.quote_search_fcl.user_nearby_destination.length > destinationLimit ? vm.quote_search_fcl.user_nearby_destination.slice(0,destinationLimit) : vm.quote_search_fcl.user_nearby_destination) : []);
          }
          else if(vm.quote_search_fcl.user_nearby_origin && vm.quote_search_fcl.user_nearby_origin.length && vm.quote_search_fcl.user_nearby_origin[0].place_type == 'Port' && $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"]){
              var originLimit = vm.is_nXn_search ? vm.originMultiPortPairLimit : vm.multiPortPairLimit;
              var destinationLimit = vm.is_nXn_search ? vm.destinationMultiPortPairLimit : vm.multiPortPairLimit;
              vm.quote_search_fcl.user_nearby_origin = (vm.quote_search_fcl.user_nearby_origin && vm.quote_search_fcl.user_nearby_origin.length > originLimit) ? vm.quote_search_fcl.user_nearby_origin.slice(0,originLimit): vm.quote_search_fcl.user_nearby_origin;
              vm.quote_search_fcl.user_nearby_destination = (vm.quote_search_fcl.user_nearby_destination && vm.quote_search_fcl.user_nearby_destination.length > destinationLimit) ? vm.quote_search_fcl.user_nearby_destination.slice(0,destinationLimit): vm.quote_search_fcl.user_nearby_destination;
             //  if current search is 1*N but previous search is N*N then taking single data from n*n
             if(!vm.is_nXn_search && vm.quote_search_fcl.user_nearby_origin && vm.quote_search_fcl.user_nearby_origin.length > 1 && vm.quote_search_fcl.user_nearby_destination.length >1){
                vm.quote_search_fcl.user_nearby_origin =  vm.quote_search_fcl.user_nearby_origin.slice(0,1);
                vm.quote_search_fcl.user_nearby_destination = vm.quote_search_fcl.user_nearby_destination.slice(0,1);
             }
            }
            // multi port not allowed then take first port from multi port data
            else{
              vm.quote_search_fcl.user_nearby_origin = vm.quote_search_fcl.user_nearby_origin.length ? vm.quote_search_fcl.user_nearby_origin.slice(0,1) : [] ;
              vm.quote_search_fcl.user_nearby_destination = vm.quote_search_fcl.user_nearby_destination.length  ? vm.quote_search_fcl.user_nearby_destination.slice(0,1) : [] ;
            }
            if($rootScope.domainData.domain_info["ENABLED_POL_POD"]){
              // checking pol/pod count is greater than pol/pod limit or not
              vm.quote_search_fcl["user_pol"] = (vm.quote_search_fcl.user_pol ? (vm.quote_search_fcl.user_pol.length > vm.originPortLimit ? vm.quote_search_fcl.user_pol.slice(0,vm.originPortLimit)  :vm.quote_search_fcl.user_pol ) : []);
              vm.quote_search_fcl["user_pod"] = (vm.quote_search_fcl.user_pod ? (vm.quote_search_fcl.user_pod.length > vm.destinationPortLimit ? vm.quote_search_fcl.user_pod.slice(0,vm.destinationPortLimit)  :vm.quote_search_fcl.user_pod ) : []);
            }else{
              // making pol/pod data as empty if config is off
              vm.quote_search_fcl["user_pol"] = [];
              vm.quote_search_fcl["user_pod"] = [];
            }
            if($rootScope.domainData.domain_info["GET_NEARBY_PORT_RESULT"]){
              vm.nearby_origin= (vm.nearby_origin ? (vm.nearby_origin.length > vm.originNearbyPortLimit ? vm.nearby_origin.slice(0,vm.originNearbyPortLimit)  :vm.nearby_origin ) : []);
              vm.nearby_destination = (vm.nearby_destination ? (vm.nearby_destination.length > vm.destinationNearbyPortLimit ? vm.nearby_destination.slice(0,vm.destinationNearbyPortLimit)  :vm.nearby_destination ) : []);
            }
            else{
              vm.nearby_origin=[]
              vm.nearby_destination=[]
              vm.quote_search_fcl.fetch_nearby_destination=false;
              vm.quote_search_fcl.fetch_nearby_origin=false;
            }
            if(vm.nearby_origin.length){
 
              vm.quote_search_fcl.user_nearby_origin=vm.quote_search_fcl.user_nearby_origin.concat(vm.nearby_origin)
              
            }
            if(vm.nearby_destination.length ){
              vm.quote_search_fcl.user_nearby_destination=vm.quote_search_fcl.user_nearby_destination.concat(vm.nearby_destination)
            }
            // if(vm.origin_alias.length){
            //   vm.quote_search_fcl.user_nearby_origin=vm.quote_search_fcl.user_nearby_origin.concat(vm.origin_alias)
            // }
            // if(vm.destination_alias.length){
            //   vm.quote_search_fcl.user_nearby_destination= vm.quote_search_fcl.user_nearby_destination.concat(destination_alias)
            // }

            if (!vm.prefilledCardSearch) {
              if($rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] || $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"]){
                if(vm.quote_search_fcl['user_nearby_origin'].length==0 && vm.quote_search_fcl.origin_location){
                  vm.quote_search_fcl.origin_location['input_type']='user'
                  vm.quote_search_fcl.destination_location['input_type']='user'
                  vm.quote_search_fcl['user_nearby_origin'].push(vm.quote_search_fcl.origin_location);
                  vm.quote_search_fcl['user_nearby_destination'].push(vm.quote_search_fcl.destination_location);
                }
                 var searchStr = '';
                 var originPorts=  ScheduleSearchService.getCommaSeparatedData(vm.quote_search_fcl.user_nearby_origin,'location');
                 var destinationPorts=  ScheduleSearchService.getCommaSeparatedData(vm.quote_search_fcl.user_nearby_destination,'location');
                 searchStr =  originPorts+' to '+destinationPorts;
                 vm.quote_search_fcl.search_name = searchStr.trim()+ ' / ' + $filter('date')(vm.quote_search_fcl.cargo_ready_date, 'd MMM yyyy');
              }
              else{
                vm.quote_search_fcl.search_name = searchData.result_meta.search_param.origin_location.location + ' to ' + searchData.result_meta.search_param.destination_location.location + ' / ' + $filter('date')(searchData.result_meta.search_param.cargo_ready_date, 'd MMM yyyy');
              }
            }

            // empty sales and shipper details if domain search config not available
            vm.fnSetShipperDetails(vm.quote_search_fcl);

            data =  {
                "search_param" : vm.quote_search_fcl
            }

            vm.fclLoadData = SearchService.getFclLoadDetails(data.search_param.load_data.load_details_value);
            //mixpanel code
            var recentSearchDetails = {
                "Mode":data.search_param.mode,
                "CardIndex": vm.cardIndex,
                "Cargo Ready Date":data.search_param.cargo_ready_date,
                "Search Name":data.search_param.search_name,
                "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
                "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + vm.fclLoadData.loadtype,
                "Origin Port":data.search_param.origin_location.portcode_portname,
                "Destination Port":data.search_param.destination_location.portcode_portname,
                "Load Details":vm.fclLoadData.loadtype,
                "Load In TEUs":vm.fclLoadData.typexqty,
                "Origin Charges":data.search_param.origin_charges,
                "Origin Custom":data.search_param.origin_customs,
                "Destination Charges":data.search_param.destination_charges,
                "Destination Customs":data.search_param.destination_customs,
                "MultiPort Enabled" : $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] || $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"]
            };

             

            if( $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] || $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"]){
              recentSearchDetails["Origin Port Count"] = data.search_param.user_nearby_origin.length;
              recentSearchDetails["Destination Port Count"] = data.search_param.user_nearby_destination.length;
            }


            if (vm.prefilledCardSearch) {
                vm.searchParamForComponent = angular.copy(vm.quote_search_fcl);
                vm.selectedIndex = 0;
                angular.element('#origin-input').focus();
                angular.element( document.querySelector( '#inquire_btn' ) ).addClass('btn_blink');

            }else{
                vm.fclSearchBtn = true;
                vm.searchLoadBtn = true;
                vm.loadButton = true;
                util.isCallingApi = true;

                if( data.search_param.origin_location.place_type == 'Door' ){
                    data.search_param.pickup = data.search_param.origin_location;
                    data.search_param.pickup_selected = true;
                    data.search_param.origin_charges = true;
                    data.search_param.origin_customs = true;
                }
                if( data.search_param.destination_location.place_type == 'Door' ){
                    data.search_param.delivery = data.search_param.destination_location;
                    data.search_param.destination_charges = true;
                    data.search_param.destination_customs = true;
                    data.search_param.delivery_selected = true;
                }

                data.search_param["search_type"] = (data.search_param.pickup ? 'D' : 'P') + '2' + (data.search_param.delivery ? 'D' : 'P');
                if (!data.search_param["origin_service_mode"]) {
                  data.search_param["origin_service_mode"] =
                    data.search_param.pickup ? 'SD':'CY';
                }
                if (!data.search_param["destination_service_mode"]) {
                  data.search_param["destination_service_mode"] = data
                    .search_param.delivery
                    ? "SD"
                    : "CY";
                }
                var pageState = 'app.search.result';
                if($rootScope.domainData.domain_info.ALLOW_RESULT_POLLING){
                  data.search_param["fetchType"] = "pooling";
                  pageState = 'app.search.fclV2Rates'
                }

                SearchService.postSearchData(data).then(function(response){
                    SearchService.searchHistoryData = [];
                    SearchService.FclResult =  response.data.data;
                    SearchService.isNewSearch = true;
                    $state.go(pageState,{ id: SearchService.FclResult._id});
                    vm.fclSearchBtn = false;
                    vm.searchLoadBtn = false;
                    vm.loadButton = false;
                    util.isCallingApi = false;
                },function(error){
                    util.isCallingApi = false;
                    vm.fclSearchBtn = false;
                    vm.searchLoadBtn = false;
                    vm.loadButton = false;
                    util.showToast(error.data.message);
                    $log.log(error);
                });
            }
        }
        else if(searchData.result_meta.search_param.mode == 'AIR'){

            for (key in vm.quote_search_air) {
                if(vm.quote_search_air.hasOwnProperty(key) && searchData.result_meta.search_param.hasOwnProperty(key)) {
                    vm.quote_search_air[key] = searchData.result_meta.search_param[key];
                }
            }

            if(new Date().setHours(0,0,0) > new Date(vm.quote_search_air.cargo_ready_date)){
                vm.quote_search_air.cargo_ready_date = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
            }

            vm.quote_search_air.search_name = searchData.result_meta.search_param.search_name;

            if( vm.quote_search_air.origin_location.place_type == 'Door' ){
                vm.quote_search_air.pickup = vm.quote_search_air.origin_location;
                vm.quote_search_air.pickup_selected = true;
                vm.quote_search_air.origin_charges = true;
                vm.quote_search_air.origin_customs = true;
            }
            if( vm.quote_search_air.destination_location.place_type == 'Door' ){
                vm.quote_search_air.delivery = vm.quote_search_air.destination_location;
                vm.quote_search_air.destination_charges = true;
                vm.quote_search_air.destination_customs = true;
                vm.quote_search_air.delivery_selected = true;
            }
            vm.quote_search_air.shipment_insurance = false;
            vm.quote_search_air.insurance_leg_cost = null;
            vm.quote_search_air.insurance_currency = null;

            // empty sales and shipper details if domain search config not available
            vm.fnSetShipperDetails(vm.quote_search_air);

            data =  {
                "search_param" : vm.quote_search_air
            }
            //mixpanel code
            util.callMixpanel("IR-RecentSearch-Suggestion-Click",{
                "Mode":data.search_param.mode,
                "CardIndex": vm.cardIndex,
                "Cargo Ready Date":data.search_param.cargo_ready_date,
                "Search Name":data.search_param.search_name,
                "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
                "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                "Origin Port":data.search_param.origin_location.portcode_portname,
                "Destination Port":data.search_param.destination_location.portcode_portname,
                "Load Details":data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                "Origin Charges":data.search_param.origin_charges,
                "Origin Custom":data.search_param.origin_customs,
                "Destination Charges":data.search_param.destination_charges,
                "Destination Customs":data.search_param.destination_customs
            });
            util.isCallingApi = true;
            SearchService.postSearchData(data).then(function(response){
              SearchService.searchHistoryData = [];
              SearchService.AirResult =  response.data.data;
              SearchService.isNewSearch = true;
                $state.go('app.search.airResult',{ id: SearchService.AirResult._id });
                util.isCallingApi = false;

            },function(error){
                util.isCallingApi = false;
                $log.log(error);
            });
        }
        else if(searchData.result_meta.search_param.mode == 'SEA-LCL'){
         
             if(!searchData.result_meta.search_param.user_nearby_origin  && searchData.result_meta.search_param.origin_location){
                searchData.result_meta.search_param.origin_location['input_type']='user'
                searchData.result_meta.search_param.destination_location['input_type']='user'
                searchData.result_meta.search_param['user_nearby_origin']=[]
                searchData.result_meta.search_param['user_nearby_origin'].push(searchData.result_meta.search_param.origin_location);
                searchData.result_meta.search_param['user_nearby_destination']=[] 
                searchData.result_meta.search_param['user_nearby_destination'].push(searchData.result_meta.search_param.destination_location);
              }
            
             
            
          vm.nearby_origin=searchData.result_meta.search_param.user_nearby_origin.filter(function(item){
            return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
          });
          vm.nearby_destination=searchData.result_meta.search_param.user_nearby_destination.filter(function(item){
            return (item.input_type == 'nearby_user' || item.input_type === 'nearby_system');
          });
          vm.origin_alias=searchData.result_meta.search_param.user_nearby_origin.filter(function(item){
            return (item.input_type == 'alias');
          });
    
          vm.destination_alias=searchData.result_meta.search_param.user_nearby_destination.filter(function(item){
            return (item.input_type == 'alias');
          });
          searchData.result_meta.search_param.user_nearby_origin =  searchData.result_meta.search_param.user_nearby_origin.filter(function(item){
            return (item.input_type == 'user' || !item.input_type);
          });
          searchData.result_meta.search_param.user_nearby_destination =  searchData.result_meta.search_param.user_nearby_destination.filter(function(item){
            return (item.input_type == 'user' || !item.input_type);
          });
          searchData.result_meta.search_param.user_nearby_origin.forEach(function(value){
            if(!value.input_type){
             value['input_type']='user'
            }
           })
           searchData.result_meta.search_param.user_nearby_destination.forEach(function(value){
            if(!value.input_type){
             value['input_type']='user'
            }
           })
           if($rootScope.domainData.domain_info["GET_NEARBY_PORT_RESULT"]){
            vm.nearby_origin= (vm.nearby_origin ? (vm.nearby_origin.length > vm.originNearbyPortLimit ? vm.nearby_origin.slice(0,vm.originNearbyPortLimit)  :vm.nearby_origin ) : []);
            vm.nearby_destination = (vm.nearby_destination ? (vm.nearby_destination.length > vm.destinationNearbyPortLimit ? vm.nearby_destination.slice(0,vm.destinationNearbyPortLimit)  :vm.nearby_destination ) : []);
          }
          else{
            vm.nearby_origin=[]
            vm.nearby_destination=[]
            searchData.result_meta.search_param.fetch_nearby_destination=false;
            searchData.result_meta.search_param.fetch_nearby_origin=false;
          }
         
          if( searchData.result_meta.search_param.user_nearby_origin &&  searchData.result_meta.search_param.user_nearby_origin.length &&  searchData.result_meta.search_param.user_nearby_origin[0].place_type == 'Door' && vm.isMultiDoor){
            var originLimit = vm.is_door_nXn_search ? vm.originMultiDoorLimit : vm.multiDoorLimit;
            var destinationLimit = vm.is_door_nXn_search ? vm.destinationMultiDoorLimit : vm.multiDoorLimit;
            searchData.result_meta.search_param.user_nearby_origin =  ( searchData.result_meta.search_param.user_nearby_origin ? ( searchData.result_meta.search_param.user_nearby_origin.length > originLimit ?  searchData.result_meta.search_param.user_nearby_origin.slice(0,originLimit)  : searchData.result_meta.search_param.user_nearby_origin ) : []);
            searchData.result_meta.search_param.user_nearby_destination =  ( searchData.result_meta.search_param.user_nearby_destination ?  ( searchData.result_meta.search_param.user_nearby_destination.length > destinationLimit ?  searchData.result_meta.search_param.user_nearby_destination.slice(0,destinationLimit) :  searchData.result_meta.search_param.user_nearby_destination) : []);
        }
        else if( searchData.result_meta.search_param.user_nearby_origin &&  searchData.result_meta.search_param.user_nearby_origin.length &&  searchData.result_meta.search_param.user_nearby_origin[0].place_type == 'Port' && $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"]){
            var originLimit = vm.is_nXn_search ? vm.originMultiPortPairLimit : vm.multiPortPairLimit;
            var destinationLimit = vm.is_nXn_search ? vm.destinationMultiPortPairLimit : vm.multiPortPairLimit;
            searchData.result_meta.search_param.user_nearby_origin = ( searchData.result_meta.search_param.user_nearby_origin &&  searchData.result_meta.search_param.user_nearby_origin.length > originLimit) ?  searchData.result_meta.search_param.user_nearby_origin.slice(0,originLimit):  searchData.result_meta.search_param.user_nearby_origin;
            searchData.result_meta.search_param.user_nearby_destination = ( searchData.result_meta.search_param.user_nearby_destination &&  searchData.result_meta.search_param.user_nearby_destination.length > destinationLimit) ?  searchData.result_meta.search_param.user_nearby_destination.slice(0,destinationLimit):  searchData.result_meta.search_param.user_nearby_destination;
           //  if current search is 1*N but previous search is N*N then taking single data from n*n
           if(!vm.is_nXn_search &&  searchData.result_meta.search_param.user_nearby_origin &&  searchData.result_meta.search_param.user_nearby_origin.length > 1 &&  searchData.result_meta.search_param.user_nearby_destination.length >1){
            searchData.result_meta.search_param.user_nearby_origin =   searchData.result_meta.search_param.user_nearby_origin.slice(0,1);
            searchData.result_meta.search_param.user_nearby_destination =  searchData.result_meta.search_param.user_nearby_destination.slice(0,1);
           }
          }
          // multi port not allowed then take first port from multi port data
          else{
            searchData.result_meta.search_param.user_nearby_origin =  searchData.result_meta.search_param.user_nearby_origin.length ?  searchData.result_meta.search_param.user_nearby_origin.slice(0,1) : [] ;
            searchData.result_meta.search_param.user_nearby_destination =  searchData.result_meta.search_param.user_nearby_destination.length  ? searchData.result_meta.search_param.user_nearby_destination.slice(0,1) : [] ;
          }
          if(vm.nearby_origin.length){

            searchData.result_meta.search_param.user_nearby_origin=searchData.result_meta.search_param.user_nearby_origin.concat(vm.nearby_origin)
            
          }
          if(vm.nearby_destination.length ){
            searchData.result_meta.search_param.user_nearby_destination=searchData.result_meta.search_param.user_nearby_destination.concat(vm.nearby_destination)
          }
            for (key in vm.quote_search_lcl) {
                if(vm.quote_search_lcl.hasOwnProperty(key) && searchData.result_meta.search_param.hasOwnProperty(key)) {
                    vm.quote_search_lcl[key] = searchData.result_meta.search_param[key];
                }
            }

            if(new Date().setHours(0,0,0) > new Date(vm.quote_search_lcl.cargo_ready_date)){
                vm.quote_search_lcl.cargo_ready_date = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
            }
          
            vm.quote_search_lcl.search_name = searchData.result_meta.search_param.search_name;

            if( vm.quote_search_lcl.origin_location.place_type == 'Door' ){
                vm.quote_search_lcl.pickup = vm.quote_search_lcl.origin_location;
                vm.quote_search_lcl.pickup_selected = true;
                vm.quote_search_lcl.origin_charges = true;
                vm.quote_search_lcl.origin_customs = true;
            }
            if( vm.quote_search_lcl.destination_location.place_type == 'Door' ){
                vm.quote_search_lcl.delivery = vm.quote_search_lcl.destination_location;
                vm.quote_search_lcl.destination_charges = true;
                vm.quote_search_lcl.destination_customs = true;
                vm.quote_search_lcl.delivery_selected = true;
            }

            vm.quote_search_lcl.shipment_insurance = false;
            vm.quote_search_lcl.insurance_leg_cost = null;
            vm.quote_search_lcl.insurance_currency = null;

            // empty sales and shipper details if domain search config not available
            vm.fnSetShipperDetails(vm.quote_search_lcl);

            data =  {
                "search_param" : vm.quote_search_lcl
            }

            //mixpanel code
             util.callMixpanel("IR-RecentSearch-Suggestion-Click",{
                "Mode":data.search_param.mode,
                "CardIndex": vm.cardIndex,
                "Cargo Ready Date":data.search_param.cargo_ready_date,
                "Search Name":data.search_param.search_name,
                "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
                "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                "Origin Port":data.search_param.origin_location.portcode_portname,
                "Destination Port":data.search_param.destination_location.portcode_portname,
                "Load Details":data.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
                "Origin Charges":data.search_param.origin_charges,
                "Origin Custom":data.search_param.origin_customs,
                "Destination Charges":data.search_param.destination_charges,
                "Destination Customs":data.search_param.destination_customs
                // "Load Container Type": load.container_type
              });

            util.isCallingApi = true;
            SearchService.postSearchData(data).then(function(response){
              SearchService.searchHistoryData = [];
              SearchService.LclResult =  response.data.data;
              SearchService.isNewSearch = true;
            // var loadData = [{"type" : load.container_type ,"count":1 }];

                $state.go('app.search.lclResult',{ id: SearchService.LclResult._id });
                util.isCallingApi = false;
            },function(error){
                util.isCallingApi = false;
                $log.log(error);
            });

        }
      }

      function resultFtlSearch(searchData,index){
        //console.log("searchData", searchData);
        var key;
            var data;
            vm.prefilledCardSearch = false;
  
                if(vm.searchConfig && 
                  (vm.searchConfig.stuffing.required && !searchData.salesUser) || 
                  (vm.searchConfig.shipper_company && vm.searchConfig.shipper_company.required && !searchData.customer) || 
                  (vm.searchConfig.shipper_email && vm.searchConfig.shipper_email.required && !searchData.customer) ){
                  vm.prefilledCardSearch = true;
                }
  
                if(new Date().setHours(0,0,0) > new Date(searchData.cargoReadyDate)){
              
                    vm.quote_search_ftl.cargoReadyDate = $filter('date')(new Date(Date.now()+(7*24*60*60*1000)), 'yyyy-MM-dd');
                }else{
                    vm.quote_search_ftl.cargoReadyDate = searchData.cargoReadyDate;
                }
  
                vm.quote_search_ftl.origin = searchData.origin;
                vm.quote_search_ftl.destination = searchData.destination;
                vm.quote_search_ftl.salesUser = searchData.salesUser;
                vm.quote_search_ftl.customer = searchData.customer;
                vm.quote_search_ftl.user= searchData.user
                if (!vm.prefilledCardSearch) {
                  vm.quote_search_ftl.referenceText = searchData.origin[0].location + ' to ' + searchData.destination[0].location + ' / ' + $filter('date')(searchData.cargoReadyDate, 'd MMM yyyy');

                }
  
                vm.quote_search_ftl.loads = searchData.loads;
                vm.quote_search_ftl.requestedLegs = ["LANDFREIGHT"];
                vm.quote_search_ftl.carrierPreferenceUI = [];
                vm.quote_search_ftl["stuffing"] = searchData.stuffing ? searchData.stuffing : $rootScope.domainData.domain_info["DEFAULT_STUFFING"];
            
  
                vm.quote_search_ftl.customer = null
                vm.quote_search_ftl.searchCurrency=searchData.searchCurrency
                vm.quote_search_ftl.filters=searchData.filters
                
                
                data =  vm.quote_search_ftl;
  
  
                if (vm.prefilledCardSearch) {
                  
                  vm.searchParamForComponent = angular.copy(vm.quote_search_ftl);
                  vm.selectedIndex = 3;
                  angular.element('#ftl-origin-input').focus();
                  angular.element( document.querySelector( '#inquire_btn' ) ).addClass('btn_blink');
  
                }else{
                    util.isCallingApi = true;
                    data["searchType"]=data.origin[0].placeType==='port'?'P':'D' + '2' + data.destination[0].placeType==='port'?'P':'D'
                        data.salesUser = {
                          _id: data.salesUser.id,
                        };
                        if (data.customer) {
                          data.customer = {
                            _id: data.customer.id,
                          };
                        }
                        if (util.userProfile.user) {
                         data.user = {
                            _id: data.user.id,
                          };
                        }
                    SearchService.postSearchFtlData(data).then(function(response){
                        SearchService.searchHistoryData = [];
                        SearchService.FtlResult =  response.data.data;
                    $state.go("app.search.ftlResult", {
                      id: SearchService.FtlResult._id,
                    });
                        util.isCallingApi = false;
                    },function(error){
                        util.isCallingApi = false;
                        $log.log(error);
                    });
                }

      }
      // ****** special rates **************
      function fnScrollBtn(level,side,index,section){
        if(level == 'child'){
            if(side == 'left'){
                if(section == "searchHistory"){
                    angular.element('div.scroll_container_'+index+'searchHistory').animate({scrollLeft: angular.element('div.scroll_container_'+index+'searchHistory').scrollLeft() - 100}, 400);
                }else if(section == "specialRates"){
                    angular.element('div.scroll_container_'+index).animate({scrollLeft: angular.element('div.scroll_container_'+index).scrollLeft() - 100}, 400);
                }
            }else if(side == 'right'){
                if(section == "searchHistory"){
                    angular.element('div.scroll_container_'+index+'searchHistory').animate({scrollLeft: angular.element('div.scroll_container_'+index+'searchHistory').scrollLeft() + 100}, 400);
                }else if(section == "specialRates"){
                    angular.element('div.scroll_container_'+index).animate({scrollLeft: angular.element('div.scroll_container_'+index).scrollLeft() + 100}, 400);
                }
            }
        }
        else if(level == 'parent'){
            if(side == 'left'){
                if(section == "searchHistory"){
                  angular.element("div.searchHistory").animate({scrollLeft: angular.element('div.searchHistory').scrollLeft() - 300}, 400);
                }if(section == "superOffers"){
                  angular.element("div.superOffers").animate({scrollLeft: angular.element('div.superOffers').scrollLeft() - 300}, 400);
                }
                else if(section == "specialRates"){
                  angular.element("div.specialRates").animate({scrollLeft: angular.element('div.specialRates').scrollLeft() - 300}, 400);
                }
            }else if(side == 'right'){
                if(section == "searchHistory"){
                  angular.element("div.searchHistory").animate({scrollLeft: angular.element('div.searchHistory').scrollLeft() + 300}, 400);
                }if(section == "superOffers"){
                  angular.element("div.superOffers").animate({scrollLeft: angular.element('div.superOffers').scrollLeft() + 300}, 400);
                }
                else if(section == "specialRates"){
                  angular.element("div.specialRates").animate({scrollLeft: angular.element('div.specialRates').scrollLeft() + 300}, 400);
                }

            }
        }
      }

      function fnSpecialRateResult(item, load,parentIndex,childIndex){

        vm.cardIndex = 'special_'+parentIndex+'_'+childIndex;

        vm.searchPostData.cargo_ready_date = $filter('date')(new Date(), 'yyyy-MM-dd');
        vm.searchPostData.origin_location = item.origin_location ? item.origin_location : item.origin_port;
        vm.searchPostData.destination_location = item.destination_location ? item.destination_location : item.destination_port;
        vm.searchPostData.inco_term = null;
        var loadData = [{"type" : load.container_type ,"count":1 }];

        vm.prefilledCardSearch=false;
        //If customers details is mandatory then prefilled search otherwise redirect to result page
        if(vm.searchConfig && (vm.searchConfig.stuffing.required || (vm.searchConfig.shipper_company && vm.searchConfig.shipper_company.required) || (vm.searchConfig.shipper_email && vm.searchConfig.shipper_email.required))){
          vm.prefilledCardSearch = true;
        }

        if (!vm.prefilledCardSearch) {
            vm.searchPostData.search_name = vm.searchPostData.origin_location.location + ' to '+ vm.searchPostData.destination_location.location +' / '+ $filter('date')(vm.searchPostData.cargo_ready_date, 'd MMM yyyy');
        }

        vm.searchPostData.load_data = util.formFclSearchData(vm.searchPostData.load_data,loadData);

        vm.searchPostData["stuffing"] = $rootScope.domainData.domain_info["DEFAULT_STUFFING"];

        if( vm.searchPostData.origin_location.place_type == 'Door' ){
            vm.searchPostData.pickup = vm.searchPostData.origin_location;
            vm.searchPostData.pickup_selected = true;
            vm.searchPostData.origin_charges = true;
            vm.searchPostData.origin_customs = true;
        }
        if( vm.searchPostData.destination_location.place_type == 'Door' ){
            vm.searchPostData.delivery = vm.searchPostData.destination_location;
            vm.searchPostData.destination_charges = true;
            vm.searchPostData.destination_customs = true;
            vm.searchPostData.delivery_selected = true;
        }

        // empty sales and shipper details if domain search config not available
        vm.fnSetShipperDetails(vm.searchPostData);

        var data =  {
            "search_param" : vm.searchPostData
        }

        vm.fclLoadData = SearchService.getFclLoadDetails(data.search_param.load_data.load_details_value);

        //mixpanel code only for fcl
        analytics.track("Rates from Special Rates",{
            "Mode":data.search_param.mode,
            "Cargo Ready Date":data.search_param.cargo_ready_date,
            "Search Name":data.search_param.search_name,
            "Port-Pair":data.search_param.origin_location.location + ' to ' + data.search_param.destination_location.location,
            "Search Param" : data.search_param.origin_location.location + ' to '+ data.search_param.destination_location.location +' / '+ $filter('date')(data.search_param.cargo_ready_date, 'd MMM yyyy') + ' / ' + vm.fclLoadData.loadtype,
            "Origin Port":data.search_param.origin_location.portcode_portname,
            "Destination Port":data.search_param.destination_location.portcode_portname,
            "Load Details":vm.fclLoadData.loadtype,
            "Load In TEUs": vm.fclLoadData.typexqty,
            "Origin Charges":data.search_param.origin_charges,
            "Origin Custom":data.search_param.origin_customs,
            "Destination Charges":data.search_param.destination_charges,
            "Destination Customs":data.search_param.destination_customs
        });
        if (vm.prefilledCardSearch) {

            vm.searchParamForComponent = angular.copy(vm.searchPostData);
            vm.selectedIndex = 0;
            angular.element('#origin-input').focus();
            angular.element( document.querySelector( '#inquire_btn' ) ).addClass('btn_blink');

        }else{
            vm.fclSearchBtn = true;  vm.loadButton = true; vm.searchLoadBtn = true;
            util.isCallingApi = true;

            data.search_param.origin_charges = true;
            data.search_param.origin_customs = true;
            data.search_param.destination_charges = true;
            data.search_param.destination_customs = true;

            if( data.search_param.origin_location.place_type == 'Door' ){
            data.search_param.pickup = data.search_param.origin_location;
            data.search_param.pickup_selected = true;
            }
            if( data.search_param.destination_location.place_type == 'Door' ){
            data.search_param.delivery = data.search_param.destination_location;
            data.search_param.delivery_selected = true;
            }

            data.search_param["search_type"] = (data.search_param.pickup ? 'D' : 'P') + '2' + (data.search_param.delivery ? 'D' : 'P');

            SearchService.postSearchData(data).then(function(response){
                SearchService.FclResult =  response.data.data;
                vm.fclSearchBtn = false;  vm.loadButton = false; vm.searchLoadBtn = false;
                SearchService.isNewSearch = true;
                $state.go('app.search.result',{ id: SearchService.FclResult._id});
                util.isCallingApi = false;
            },function(error){
                util.isCallingApi = false;
                util.showToast(error.data.message);
                vm.fclSearchBtn = false;  vm.loadButton = false; vm.searchLoadBtn = false;
                $log.log(error);
            });
        }

    }

      function searchAddLoadData(searchHistory){

          searchHistory.forEach(function(searchItem){
              var obj = [];
              if(searchItem.result_meta.search_param.mode == 'SEA-FCL'){
                  for(var i = 0; i < searchItem.result_meta.search_param.load_data.load_details_value.length; i++){
                      var data = {  "container_type" :  searchItem.result_meta.search_param.load_data.load_details_value[i].type  };
                      obj.push(data);
                  }
                  searchItem.newLoadData = obj;
              }
          })
          return searchHistory;
      }

      // ************************ Advanced Search ******************************

      //get load structure for advance search
      function getAdvancedLoadStructure(){

          vm.adv_load_Arr = [
              {'qty' : 1,
              'bl_qty': 1, 'sbl_qty': 1,
              'type' : ''}
          ]
          vm.fcl_origin_location =  {
              "lat": 18.9690,
              "lng": 72.8205
          };
          vm.fcl_destination_location =  {
              "lat": 24.4539,
              "lng": 54.3773
          };
          vm.air_origin_location =  angular.copy(vm.fcl_origin_location);
          vm.air_destination_location =  angular.copy(vm.fcl_destination_location);
          vm.lcl_origin_location =  angular.copy(vm.fcl_origin_location);
          vm.lcl_destination_location =  angular.copy(vm.fcl_destination_location);
      }

      // ****************************** Air Search functions***************************//

      //calculate load data
      $scope.$watch('vm.search_param_air.load_data', function () {
        vm.search_param_air.load_data = SearchService.calculateAirLoad(vm.search_param_air.load_data);
      },true);

      // ****************************** Lcl Search functions***************************//
      //calculate load data
      $scope.$watch('vm.search_param_lcl.load_data', function () {
        vm.search_param_lcl.load_data = SearchService.calculateLclLoad(vm.search_param_lcl.load_data);
      },true);

      function cancelDialog(){
        $mdDialog.hide();
      }

      function showAll(module){
        if(module=="offers"){
          vm.showAllOffers = true;
        }
        if(module=="recent_searches"){
          vm.showAllSearches[vm.activeSearchTab] = true;
        }
      }

      function goBackToSearch(module){
        // $state.go('app.search');
        if(module=="recent_searches"){
          vm.showAllSearches[vm.activeSearchTab]=false;
        }
        if(module=="offers"){
          vm.showAllOffers = false;
        }
        // angular.element("#content").animate({
        //   scrollTop: 0
        // }, 600);

      }

      function showCardLimit(){
        var limit = 3;
        var width = $(window).width();
        if(width<1264 && width>835){
          limit = 2;
        }
        else if(width<835){
          limit = 1;
        }
        return limit;
      }

      $scope.$on('$destroy', function iVeBeenDismissed() {
        // say goodbye to your controller here
        // release resources, cancel request...
        appCache.remove('historyOfSEA-FCL');
        appCache.remove('historyOfSEA-LCL');
        appCache.remove('historyOfAIR');
      })


      function grayOutTabs(tabs) {
        for (var index = 0; index < tabs.length; index++) {

          var result = vm.util.get_nav.find(function (obj) {
            return obj.name === tabs[index].mode;
          });

          if(result){
            tabs[index]["is_paid"] = result.is_paid;
          }
        }
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.scheduleSearch')
        .controller('ScheduleSearchController', ScheduleSearchController);

    /** @ngInject */
    function ScheduleSearchController($mdSidenav ,$log, $filter, util, ScheduleSearchService,analytics,$window,$state,exportToFile,$timeout,$location,$rootScope)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.getPort = util.getPorts;
        vm.submitSearch = submitSearch;
        vm.toggleSidenav = toggleSidenav;
        vm.departure_time = '';
        vm.arrival_time = '';
        vm.sortBy = 'transit_time';
        vm.filterDataBylinersAndTransit = filterDataBylinersAndTransit;
        vm.Liners = [];
        vm.getLinersList = getLinersList;
        // vm.getLinersList();
        vm.filterTranshipment = [{ 'transit': 'Direct', 'selected': false },
        { 'transit': 'Transhipment', 'selected': false }];
        //schedule list pagination -pankaj
        vm.fnPaginateScheduleList = fnPaginateScheduleList;
        vm.scheduleList = [];
        vm.offset = 0;
        vm.offsetLower = 0;
        vm.count = 5;
        vm.via_route_filter = "";
        vm.scheduleListFullFiltered = [];
        vm.range = 2;
        vm.fnSortList = fnSortList;
        vm.fnLinersFilter = fnLinersFilter;
        vm.cardFilterViaDirect = cardFilterViaDirect;
        vm.getCarrierNameByCode = getCarrierNameByCode;
        vm.copyFilteredArray = [];
        vm.getScheduleLinerName =getScheduleLinerName;
        vm.formScheduleData = formScheduleData;
        vm.shareScheduleList = [];
        vm.selectSchedule = selectSchedule;
        vm.generatePdf = generatePdf;
        vm.scheduleInit = scheduleInit;
        vm.fcl_selected_origin_port = ScheduleSearchService.originPort;
        vm.fcl_selected_destination_port = ScheduleSearchService.destinationPort;
        vm.init = init;
        vm.init();
        vm.entries="5";
        vm.entriesList=entriesList;
        vm.collapseDiv = collapseDiv;
        vm.updateSearch = updateSearch;
        vm.clearAll = clearAll;
        vm.resizeScreenSize = resizeScreenSize;
        vm.exportToCsvFormat = exportToCsvFormat;

        vm.scheduleLinerList.deviceName = util.resizeScreen(vm.scheduleLinerList.deviceName);
        window.onresize = vm.resizeScreenSize;
        vm.user_nearby_origin = ScheduleSearchService.originPort && ScheduleSearchService.originPort.length ? ScheduleSearchService.originPort : [];
        vm.user_nearby_destination = ScheduleSearchService.destinationPort && ScheduleSearchService.destinationPort.length ? ScheduleSearchService.destinationPort : [];
        vm.checkExistingPort = null;
        vm.checkOtherPort = null; 
        vm.checkForDuplicatePorts = checkForDuplicatePorts;
        vm.formSubmit = false;
        vm.mode = 'SEA-FCL';

        function resizeScreenSize() {
            vm.scheduleLinerList.deviceName = util.resizeScreen(vm.scheduleLinerList.deviceName);
        }

        function checkForDuplicatePorts(chips,source){
            if(chips){
              var nearByPortType = source === 'origin' ? vm.user_nearby_origin : vm.user_nearby_destination;
              if(nearByPortType.length <= $rootScope.domainData.domain_info["MULTI_PORT_PAIR_LIMIT"][vm.mode]){
                var checkDuplicatePort = nearByPortType.findIndex(function (item) {
                  return item.portcode_portname === chips.portcode_portname;
                });
      
                var checkDuplicateOtherPort = (source === 'origin' ? vm.user_nearby_destination : vm.user_nearby_origin).findIndex(function (item) {
                  return item.portcode_portname === chips.portcode_portname;
                });
                $timeout(function () {
                  vm.checkExistingPort = null;
                  vm.checkOtherPort = null;
                },3000)
                if(checkDuplicatePort >= 0){
                  vm.checkExistingPort = source;
                  return null;
                }
                if(checkDuplicateOtherPort >= 0){
                  vm.checkOtherPort = source === 'origin' ? 'destination' : 'origin';
                  return null;
                }
              }
            }
        }

        function init(){
           util.isModulePaid('scheduleSearch');                   
          if(!(util.navPermission["scheduleSearch"] && util.navPermission["scheduleSearch"][1])){
            $state.go('app.pages_share_error');
            resizeScreenSize();
          }
          vm.scheduleInit();

          window.onbeforeunload = function(e) {
            if ($location.url().indexOf('Schedule-Search') !== -1) {
                return false;
            };
          };

        }

        $rootScope.$on('app.scheduleSearch', function(event, args) {
            init();
          });


        function scheduleInit() {
          vm.scheduleData = ScheduleSearchService.scheduleData;
          // vm.formScheduleData();
          vm.scheduleLinerList = ScheduleSearchService.scheduleLinerList;
          vm.scheduleListFull = vm.scheduleData;
          vm.scheduleListFullFiltered = angular.copy(vm.scheduleListFull);
          vm.fnSortList('transit_time');
          vm.getLinersList();
          if(vm.fcl_selected_origin_port) {
            vm.search_param = {
              'mode':'SEA',
              'origin_port_code':vm.fcl_selected_origin_port.global_port_code,
              'destination_port_code':vm.fcl_selected_destination_port.global_port_code,
              'no_of_weeks':vm.range,
              'origin_port_name': vm.fcl_selected_origin_port.portcode_portname,
              'destination_port_name': vm.fcl_selected_destination_port.portcode_portname
            };
          }
          resizeScreenSize();

          vm.selectedScheduleList = [];
          vm.shareScheduleList = [];
          vm.selectedSchedulesCount = 0;
          vm.formScheduleData();
        }
        function entriesList(entriesCount){
            if(entriesCount=='5'){
                vm.count=5;
            }
            if(entriesCount=='10'){
                vm.count=10;
            }
            if(entriesCount=='15'){
                vm.count=15;
            }
            if(entriesCount=='20'){
                vm.count=20;
            }
            if(entriesCount=='25'){
                vm.count=25;
            }
            vm.offset=0;
            vm.fnPaginateScheduleList();
        }

        //function to search schedule by submitting origin port destination port,range -ankita
        function submitSearch(){
            vm.formSubmit = true;
            var origin='';
            var destination='';
            vm.isMultiPort = $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] || $rootScope.domainData.domain_info["IS_EFP_DOMAIN"];
            // multiport code
            if(vm.isMultiPort){
                if(!vm.user_nearby_origin.length || !vm.user_nearby_destination.length){
                    return false;
                }
                origin = ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_origin,'global_port_code');
                destination = ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_destination,'global_port_code');
            }else{
                validateForm();
                origin = vm.fcl_selected_origin_port.global_port_code;
                destination = vm.fcl_selected_destination_port.global_port_code;
            }
           
            var todayDate = $filter('date')(new Date(), 'yyyy-MM-dd');
            var page = "Schedule-Search";
            util.isCallingApi = true;
            return ScheduleSearchService.getScheduleSearch(origin, destination, todayDate, vm.range, page).then(function(response){
                ScheduleSearchService.scheduleData = response.data;
                ScheduleSearchService.scheduleLinerList = response.liner_schedule_count;
                vm.scheduleInit();
                //mixpanel code
                analytics.track("Schedule Search Used",{
                  "Origin Port": vm.isMultiPort ? ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_origin,'global_port_code') : vm.fcl_selected_origin_port.portcode_portname,
                  "Destination Port":vm.isMultiPort ? ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_destination,'global_port_code') : vm.fcl_selected_destination_port.portcode_portname,
                  "Duration in Weeks":vm.range,
                  "Total Available Schedules":vm.scheduleListFull.length,
                  "Liner List For Schedule": vm.getScheduleLinerName(vm.scheduleLinerList),
                  "Liner Count":vm.scheduleLinerList.length
                });
                util.isCallingApi = false;
                if(vm.via_route_filter != ""){
                    vm.cardFilterViaDirect(vm.via_route_filter);
                }
                vm.resizeScreenSize();


            },function(error){
                util.isCallingApi = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });

        }

        // validation for single port
        function validateForm(){
            if(vm.fcl_selected_origin_port == null){
                util.showToast('Please select the valid origin port.');
                return false;
            }
            if(vm.fcl_selected_destination_port == null){
                util.showToast('Please select the valid destination port.');
                return false;
            }
            if(vm.fcl_selected_origin_port.global_port_code === vm.fcl_selected_destination_port.global_port_code){
                util.showToast('Origin and Destination port can not be same!');
                return false;
            }
        }

        //form schedule data structure
        function formScheduleData(){
            vm.scheduleData.forEach(function (i) {
                i.selected = false;
            });
        }

        //function to open sidenav -ankita
        function toggleSidenav(sidenavId) {
            if(vm.copyFilteredArray.length > 0){
                vm.filterLinersList = angular.copy(vm.copyFilteredArray); //assign copy of filtered liner list array
            }
            else{
                vm.getLinersList(); //reset filter if sidenav get closed without clicking apply button
            }
            vm.resizeScreenSize();
            $mdSidenav(sidenavId).toggle();
        }

        //function to get liner list
        function getLinersList(){
            vm.linersList = vm.scheduleLinerList;
            vm.filterLinersList = [];
            angular.forEach(vm.scheduleLinerList, function (item){
                var LinerObj = { "carrier_code": item.carrier_code, "official_name" : item.carrier_name,"selected": false,"count":item.count };
                vm.filterLinersList.push(LinerObj);
            });
        }

        //function to filter schedules - ankita
        function filterDataBylinersAndTransit(liners,transit) {
            vm.copyFilteredArray = angular.copy(liners);
            vm.Liners = [];
            for (var i = 0; i < liners.length; i++) {
                if (liners[i].selected) {
                    vm.Liners.push(liners[i].carrier_code);
                }
            }

            vm.fnLinersFilter(vm.Liners);
            if(vm.scheduleList.deviceName !== 'laptop'){
                vm.toggleSidenav('right');
                resizeScreenSize();

              }
        }        

        //function to liners filter- pankaj
        function fnLinersFilter(liners){
            var newList = [];
            if(liners.length > 0){
                vm.scheduleData.forEach(function(item){
                    if(liners.indexOf(item.carrier_code) != -1){
                        newList.push(item);
                    }
                });
                vm.scheduleListFull = newList;
                vm.scheduleListFullFiltered = angular.copy(vm.scheduleListFull);
            }else{
                vm.scheduleListFull = angular.copy(vm.scheduleData);
                vm.scheduleListFullFiltered = angular.copy(vm.scheduleListFull);
            }
            vm.offset = 0;
            if(vm.via_route_filter != ""){
                vm.cardFilterViaDirect(vm.via_route_filter);
            }
            vm.fnSortList(vm.sortBy);
            resizeScreenSize();

        }

        //function to pagination list- pankaj
        function fnPaginateScheduleList(level){
            if(vm.scheduleListFull.length  == 0){
                vm.scheduleList = [];
            }else{
                var newList = [];
                var start = 0;
                if(level == "prev"){
                    // previous btn clicked on first page
                    if(vm.offsetLower - vm.count <= 0){
                        vm.firstPage = true;
                        start = 0;
                        vm.offsetLower = start;
                        vm.offset = start + vm.count;
                    }else {
                        start = vm.offsetLower - vm.count;
                        vm.offsetLower = start;
                        vm.offset = start + vm.count;
                    }
                }else if(level == "next"){
                    vm.lastPageCount = 0;
                    vm.lastPage = false;
                    start = vm.offset;
                    if(vm.scheduleListFull.length - start < vm.count){
                        vm.lastPageCount = vm.scheduleListFull.length - start;
                        vm.lastPage = true;
                        vm.offset = vm.offset + vm.lastPageCount;
                    }
                }
                if(vm.lastPage){
                    var end = start + vm.lastPageCount;
                    for(var i = start; i < end; i++){
                        newList.push(vm.scheduleListFull[i]);
                    }
                    vm.lastPage = false;
                }else if(vm.firstPage){
                    var end = start + vm.count;
                    for(var i = start; i < end; i++){
                        newList.push(vm.scheduleListFull[i]);
                    }
                    vm.firstPage = false;
                }else{
                    if(vm.offset + vm.count - vm.scheduleListFull.length > 0){
                        var end = start + (vm.scheduleListFull.length - vm.offset);
                    }else{
                        var end = start + vm.count;
                    }
                    for(var i = start; i < end; i++){
                        newList.push(vm.scheduleListFull[i]);
                    }
                    if(level != "prev"){
                        vm.offsetLower = vm.offset;
                        vm.offset = vm.offset + vm.count;
                    }
                }
                vm.scheduleList = newList;

            }
            resizeScreenSize();
        }

        //function to sort list- pankaj
        function fnSortList(sortOn){
            if(sortOn == "arrival_time"){
                vm.scheduleListFull.sort(function(item1, item2){
                    var dateA = moment(item1.arrival_time).toDate();
                    var dateB = moment(item2.arrival_time).toDate();
                    return dateA - dateB;
                })
            }else if(sortOn == "departure_time"){
                vm.scheduleListFull.sort(function(item1, item2){
                    var dateA =  moment(item1.departure_time).toDate();
                    var dateB =  moment(item2.departure_time).toDate();
                    return dateA - dateB;
                })
            }else if(sortOn == "transit_time"){
                vm.scheduleListFull.sort(function(item1, item2){
                    var nameA = item1.transit_time.toLowerCase();
                    var nameB = item2.transit_time.toLowerCase();
                    if (nameA < nameB)
                        return -1;
                    if (nameA > nameB)
                        return 1;
                    return 0;
                })
            }
            vm.offset = 0;
            vm.fnPaginateScheduleList();
        }

        //function to show only direct routes- pankaj
        function cardFilterViaDirect(via){
            var newList = [];
            if(via == "Direct"){
                    vm.scheduleListFullFiltered.forEach(function(item){
                        if(item.via_port == "Direct"){
                            newList.push(item);
                        }
                    })
            }else {
                    newList =  vm.scheduleListFullFiltered;
            }
            vm.scheduleListFull = newList;
            vm.offset = 0;
            vm.fnSortList(vm.sortBy);
        }

        function getCarrierNameByCode(code){
            var carrier = vm.filterLinersList.find(function(item){
                return item.carrier_code === code;
            });
            var carrNameWithCode = (carrier.official_name ? carrier.official_name : '')+ ' - ' + carrier.carrier_code;
            return carrNameWithCode;
        }

        function getScheduleLinerName(linerList){

          ScheduleSearchService.getScheduleLinerName(linerList);
            // var result = [];
            // angular.forEach(linerList, function (item){
            //     result.push(item.carrier_name);
            // });
            // return result.toString();
        }
        vm.selectedSchedulesCount = 0;
        vm.fnGetSelectedScheduleList = fnGetSelectedScheduleList;
        vm.selectedScheduleList = [];

        //function to select schedule
        function selectSchedule(event,schedule){
            event.stopPropagation();
            if(!schedule.selected){
                vm.selectedScheduleList.push(schedule);
                vm.selectedSchedulesCount =  vm.selectedSchedulesCount + 1 ;
            }else{
                if(vm.selectedScheduleList.length > 0){
                    var index = vm.selectedScheduleList.findIndex(function(item){
                        return item.carrier_code === schedule.carrier_code;
                    });
                    vm.selectedScheduleList.splice(index, 1);
                }
                vm.selectedSchedulesCount = vm.selectedSchedulesCount - 1 ;
            }
        }

        //function to call generate pdf api
        function generatePdf(){
            vm.shareScheduleList = [];
            vm.shareScheduleList = vm.fnGetSelectedScheduleList();
            vm.shareScheduleList.forEach(function(item){
                delete item.code;
            });
            if($rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] || $rootScope.domainData.domain_info["IS_EFP_DOMAIN"]){
                vm.search_param.origin_port_code = vm.user_nearby_origin[0].global_port_code;
                vm.search_param.destination_port_code = vm.user_nearby_destination[0].global_port_code;
                vm.search_param.origin_port_name = ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_origin,'portname');
                vm.search_param.destination_port_name = ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_destination,'portname');
            }
            var data = {
                'data':{
                    'schedules' : vm.shareScheduleList,
                    'search_param' : vm.search_param
                }
            };
            util.isCallingApi = true;
            return ScheduleSearchService.generatePdf(data).then(function(response){
                $window.open(util.sanitizeQueryParams(response.data.data.pdf_link));
                util.showToast('PDF Generated Successfully!!');
                vm.selectedScheduleList = [];
                vm.shareScheduleList = [];
                vm.selectedSchedulesCount = 0;
                vm.formScheduleData();
                util.isCallingApi = false;
            },function(error){
                util.isCallingApi = false;
                $log.log(error.data);
                util.showToast(util.displayValidationError(error));
                return [];
            });
        }

        //function to get selected schedules list
        function fnGetSelectedScheduleList(){
            angular.forEach(vm.selectedScheduleList, function (item){
                // if(item.selected){
                    var selectedSchedule = {};
                    var selectedCarrier = vm.filterLinersList.find(function(liner_item){ //get carrier name by carrier code
                        return liner_item.carrier_code === item.carrier_code;
                    });
                    var schedule_track = {
                        'schedule_track' : item.schedule_track,
                        'transit_time' : item.transit_time
                    };
                    var alreadyExistSchedule = {};
                    alreadyExistSchedule = vm.shareScheduleList.find(function(item){ // check if liner already present
                        return Object.keys(item)[0] === selectedCarrier.official_name;
                    });
                    if(!alreadyExistSchedule){
                        selectedSchedule[selectedCarrier.official_name] = [];
                        selectedSchedule[selectedCarrier.official_name].push(schedule_track);
                        selectedSchedule.code =  item.carrier_code;
                        vm.shareScheduleList.push(selectedSchedule);
                    }else{
                        alreadyExistSchedule[selectedCarrier.official_name].push(schedule_track);
                    }
                // }
            });
            return vm.shareScheduleList;
        }
        function clearAll() {
            angular.forEach(vm.filterLinersList, function (item) {
              item.selected = false;
            });
            vm.filterDataBylinersAndTransit(vm.filterLinersList);
            vm.via_route_filter="Transhipment"
            if(vm.via_route_filter != ""){
                vm.cardFilterViaDirect(vm.via_route_filter);
            }
            resizeScreenSize();
        
          }
          function collapseDiv(id, e){
            angular.element('#'+id).slideToggle();
          }

          function updateSearch(e){
            e.stopPropagation();
        }

        function exportToCsvFormat(){
            vm.util.isCallingApi = true;
            var columnsHeaders = {
                origin : "Origin",
                destination : "Destination",
                shippingLine : "Shipping Line",
                vessel : "Vessel",
                voyageRef : "Voyage ref",
                estDeparture : "Est.Departure",
                estTransit : "Est.Transit",
                estArrival : "Est.Arrival",
                serviceType : "ServiceType",
                vgmCutoff : "VGM Cutoff",
                portCutoff : "Port Cutoff",
                RouteDetails : "Route details",
                viaPolPort :  "Via  Pol",
                viaPolDeparture :  "Via Pol Departure ",
                viaPolVgmCutoff :  "Via Pol VGM Cutoff",
                viaPolPortCutoff :  "Via Pol Port Cutoff",
                viaPolService :  "Via Pol Service",
                viaPolVessel :  "Via Pol Vessel",
                viaPolVoyageRef :  "Via Pol Voyage ref",
            };
            var exportScheduleData = [];
            var scheduleListObject = vm.selectedScheduleList.length !== 0 ? vm.selectedScheduleList : vm.scheduleListFull;
            angular.forEach(scheduleListObject, function (schedules) {
                var scheduleObj = {
                    origin : schedules.origin_port_name+' / '+schedules.origin_port,
                    destination : schedules.destination_port_name+' / '+schedules.destination_port,
                    shippingLine : vm.getCarrierNameByCode(schedules.carrier_code),
                    vessel : schedules.vessel && schedules.vessel !== 'N/A' ? schedules.vessel : '-',
                    voyageRef : schedules.voyage ? schedules.voyage : '-',
                    estDeparture :  schedules.departure_time ? $filter('UTCToLocal')(schedules.departure_time, 'dd-MM-yyyy') : '-',
                    estTransit : schedules.transit_time,
                    estArrival : schedules.arrival_time ? $filter('UTCToLocal')(schedules.arrival_time, 'dd-MM-yyyy') : '-',
                    serviceType : schedules.service_name ? schedules.service_name : '-',
                    vgmCutoff : schedules.vgm_cutoff ? schedules.vgm_cutoff : '-',
                    portCutoff : schedules.port_cutoff ? schedules.port_cutoff : '-',
                    RouteDetails : schedules.via_port ? schedules.via_port : '-'
                };
                var trackIndex = '';
                if(schedules.schedule_track.length > 2){
                    angular.forEach(schedules.schedule_track, function (scheduleTrack, scheduleIndex) {
                        //skip 0 and last array of index..
                        if(scheduleIndex !== 0 && scheduleIndex !== (schedules.schedule_track.length - 1)){
                            trackIndex = scheduleIndex === 1 ? 'Pol' : scheduleIndex - 1;
                            
                            // schedule Track columns header inti
                            if(!columnsHeaders["via"+trackIndex+"Port"]){ 
                                //it's inti via port header column.
                                columnsHeaders["via"+trackIndex+"Port"] = scheduleIndex === 1 ? "Via "+trackIndex : "Via "+trackIndex+" Port";
                                columnsHeaders["via"+trackIndex+"Departure"] = "Via "+trackIndex+" Departure ";
                                columnsHeaders["via"+trackIndex+"VgmCutoff"] = "Via "+trackIndex+" VGM Cutoff";
                                columnsHeaders["via"+trackIndex+"PortCutoff"] = "Via "+trackIndex+" Port Cutoff";
                                columnsHeaders["via"+trackIndex+"Service"] = "Via "+trackIndex+" Service";
                                columnsHeaders["via"+trackIndex+"Vessel"] = "Via "+trackIndex+" Vessel";
                                columnsHeaders["via"+trackIndex+"VoyageRef"] = "Via "+trackIndex+" Voyage ref";
                            }

                            // schedule Track columns inti
                            scheduleObj["via"+trackIndex+"Port"] = scheduleTrack.port_name+' / '+scheduleTrack.port_code
                            scheduleObj["via"+trackIndex+"Departure"] = scheduleTrack.departure_time ? $filter('UTCToLocal')(scheduleTrack.departure_time, 'dd-MM-yyyy') : '-';
                            scheduleObj["via"+trackIndex+"VgmCutoff"] = scheduleTrack.vgm_cutoff ? scheduleTrack.vgm_cutoff : '-',
                            scheduleObj["via"+trackIndex+"PortCutoff"] = scheduleTrack.port_cutoff ? scheduleTrack.port_cutoff : '-',
                            scheduleObj["via"+trackIndex+"Service"] = scheduleTrack.service_name ? scheduleTrack.service_name : '-',
                            scheduleObj["via"+trackIndex+"Vessel"] = scheduleTrack.vessel ? scheduleTrack.vessel : '-',
                            scheduleObj["via"+trackIndex+"VoyageRef"] = scheduleTrack.voyage ? scheduleTrack.voyage : '-';
                        }
                    });
                }
                exportScheduleData.push(scheduleObj);
            });   
            //Testing purpose
            // exportScheduleData = exportScheduleData.concat(exportScheduleData);
            // exportScheduleData = exportScheduleData.concat(exportScheduleData);
            exportToFile.exportToCsvFormat(columnsHeaders,exportScheduleData,'Schedules_'+$filter('date')(new Date(), 'dd-MM-yyyy')).then(function (response) {
                $timeout(function () { vm.util.isCallingApi = false; },50);
            });
            
            //mixpanel track event
            analytics.track("schedule-serach-export-click",{
                "Origin Port": $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] || $rootScope.domainData.domain_info["IS_EFP_DOMAIN"] ? ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_origin,'global_port_code') : vm.fcl_selected_origin_port.portcode_portname,
                "Destination Port":$rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"] || $rootScope.domainData.domain_info["IS_EFP_DOMAIN"] ? ScheduleSearchService.getCommaSeparatedData(vm.user_nearby_destination,'global_port_code') : vm.fcl_selected_destination_port.portcode_portname,
                "No of record": vm.selectedScheduleList.length,  
                "Duration in Weeks": vm.range
            });
        }
       

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.rules', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.rules', {
                url    : '/rules',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/rules/rules.html',
                        controller : 'RulesController as vm'
                    },
                    data : { pageTitle: 'Rules' }
                },
                resolve: {},
                bodyClass: 'rules'
            });
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/rules');

        // msNavigationServiceProvider.saveItem('My Company.rules', {
        //     title    : 'Rules',
        //     icon     : 'icon-file-document-box',
        //     state    : 'app.rules',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'RULES.RULES_NAV',
        //     weight   : 1
        // });

    }


})();


(function () {
  "use strict";

  angular.module("app.rules").controller("RulesController", RulesController);

  /** @ngInject */
  function RulesController(util, iframeService, $timeout, $state, $rootScope) {
    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;

    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;

    // if god user changed forwarder refresh data
    $rootScope.$on('app.rules', function (event, args) {
      vm.init();
    });

    function init() {
      util.isModulePaid('rules');
      vm.minHeight = vm.iframeService.iframeHeight;
      if(!(util.navPermission.rules && util.navPermission.rules[1])){
        $state.go('app.pages_share_error');
      }

      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

       $timeout(function () {

        // var powered_by_height = ($rootScope.domainData.domain_info.POWERED_BY && $rootScope.domainData.domain_info.POWERED_BY.logo_solid) ? 28 : 0;

        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        vm.formIframeUrl();
       }, 400);

    }
    vm.init();

    function formIframeUrl() {

      vm.iframeUrl = iframeService.fnGetIframeUrl('groups');
      vm.iframeUrl+= "&maxHeight="+vm.minHeight["max-height"];
      document.getElementById("rule-iframe").src = vm.iframeUrl
      // document.getElementById("rule-iframe").contentWindow.location.href = vm.iframeUrl
    }
  }
})();


(function ()
{
    'use strict';

    angular
        .module('app.result')
        .controller('LclResultController', LclResultController);

    /** @ngInject */
    function LclResultController($mdToast,$state, $mdSidenav, $scope, $log, $mdDialog, $filter, $window, resultService,util, localStorageService,$rootScope, SearchService, $timeout,api,$location, shareQuoteService,analytics,$rootElement, appCache , DashboardService)
    {
      var vm = this;
      vm.util = util;
      vm.deleteType="";
      vm.ShipperMaskLiner=$rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER;
      vm.maskLiner=(util.isShipper && vm.ShipperMaskLiner);
      vm.resultService = resultService;
      vm.shareQuoteService = shareQuoteService;
      util.isCallingApi = false;
      $rootScope.loadingDetails = false;
      vm.mainFreightNameChange = $rootScope.isJeenaDomain;
      vm.mainFreightName = 'Main Freight';
      vm.isAddNewRateLoaded=false;
      vm.isStikyFilter = false;
      vm.shipperSearchLimitError  = "";
      vm.DashboardFilterData = [];
      // result meta
      vm.result_id = SearchService.LclResult._id;
      vm.search_param = SearchService.LclResult.result_meta.search_param;
      vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
      vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';

      vm.isNetworkRates = vm.search_param.fetch_network_rates;
      vm.isNearbyPorts = vm.search_param.fetch_nearby_port_data;
      vm.isMultiPort = $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"];
      vm.resultCardFilter = {
        'currency_conversion_rates' : SearchService.LclResult.result_meta.currency_conversion_rates,
        'hideBookBtn' : false,
        'deviceName' : 'laptop',
        'generateQuoteBtn' : false,
        'ratesLoading' : false,
        'countApiCard' : 0,
        'isSearchUpdate' : false,
        'total_cost' : 'card_total_cost',
        'buyOrSell' : 'sell_rates',
        'co2eApiCalled' : false,
        'co2eResponse' : null,
      };
      vm.rfqComponentObj = {
          "isBetterRates" : false,
          "id" : SearchService.LclResult._id,
          "search_param" : null,
          "rfqObj" : null,
          "show_rfqForm" : true
      };
      vm.initial_search_param = {}; // search param to store save data
      vm.initial_filterConfig = {};
      vm.currentCard = {};
      vm.l3_leg = 'l3_lcl';
      vm.l1_leg = 'l1_lcl';
      vm.l5_leg = 'l5_lcl';
      vm.filterConfig =  {
        'inco_term' : '',
        'search_name' : '',
        "insurance_currency" : vm.search_param.user.user_base_currency,
        "value_of_good" : 0
      };
      vm.onlyFbRates = false;
      vm.searchCount = 0;
      vm.sortByList = [
        {"name" : "Lowest_Freight" , "value" : "select"},
        {"name" : "Lowest_Total" , "value" : "meta.card_total_cost"},
        {"name" : "Fastest_Transit" , "value" : "meta.selected_schedule.transit_time"}
      ];
      vm.validationObj={
        "expiryValidation":false,
        "loadingPortValidation":false,
        "linerValidation":false,
        "dischargePortValidation":false,
        "dischargeSamePortValidation":false,
        "chargeNameValidation":false,
        "chargeBasicValidation":false,
        "chargeUnitValidation":false,
        "chargeMinimumValidation":false,
        "chargeCurrencyValidation":false,
        };
      vm.resultCardArray = [];
      vm.resultCardArrayObj = [];
      vm.allRatesArray = [];
      vm.allRatesArrayCopy = [];
      vm.userVendorID = parseInt(localStorageService.get('authToken').value.vendor_id);
      vm.isEdit = false;
      vm.resultService.user_base_currency = vm.search_param.user.user_base_currency;
      vm.apiProgressValue = 1;
      vm.viewMode = 'card';
      vm.isCardChanges = false;
      vm.oldapiErrMsgList = [];
      vm.apiErrMsgList = [];
      vm.visibleColumnList = {
        columnsList : [],
        columnsHide : 0
      };
      vm.mdVirtiualHeight = '1200';
      vm.all_in_quote_setting = util.all_in_quote;
      vm.util.co2ApiLoaded = true;
      vm.hideRatesOptions = [{label:"Hide Empty Cards",value:'hideEmptyRates'},{label:"Show Empty Cards",value:'showEmptyCards'}];
      vm.hideRates = 'showEmptyCards';
      vm.emptyRatesFilter   = emptyRatesFilter;

      // method  
      vm.makeDetailBoxString=makeDetailBoxString;
      vm.toggleSidenav = toggleSidenav;
      vm.openSidenav = openSidenav;
      vm.requestToBook =  requestToBook;
      vm.getOnlyPort = util.getPorts;
      vm.generateQuoteModal = generateQuoteModal;
      vm.removeFromQuote = removeFromQuote;
      vm.fnFilCardLegObj = fnFilCardLegObj;
      vm.fnCardSorting = fnCardSorting;
      vm.fnCreateLink = fnCreateLink;
      vm.fnGetRatesCount = fnGetRatesCount;
      vm.fnCallRatesApi = fnCallRatesApi;
      vm.showFilterBottomSheet = showFilterBottomSheet;
      vm.resizeScreenSize = resizeScreenSize;
      vm.fnSetResultMixpanel = fnSetResultMixpanel;
      vm.showConfirm = showConfirm;
      vm.checkToUpdate = checkToUpdate;
      vm.fndownloadQuote=fndownloadQuote;
      vm.fnOpenMatchRatesModal = fnOpenMatchRatesModal;
      vm.fnFindBetterRates = fnFindBetterRates;
      vm.rfqCallBack = rfqCallBack;
      vm.fnOpenRFQModal = fnOpenRFQModal;
      vm.fnCancelQuote = fnCancelQuote;
      vm.submitSearch = submitSearch;
      vm.updateSearchResult = updateSearchResult;
      vm.showQuoteProceedDiv = showQuoteProceedDiv;
      vm.cardFilterViaDirect = cardFilterViaDirect;
      vm.closeToast = closeToast;
      vm.fnSetRatesArray = fnSetRatesArray;
      vm.fnCardFilter = fnCardFilter;
      // decimal point handling
      vm.setThreeNumberDecimal = SearchService.setThreeNumberDecimal;
      vm.onScrollAction = onScrollAction;
      vm.removeErrorMessage = removeErrorMessage;
      vm.fnScrollBtn = fnScrollBtn;
      vm.trackAnalytics = trackAnalytics;
      vm.fnDialogSwitchToRateCard = fnDialogSwitchToRateCard;
      vm.fnSwitchMode = fnSwitchMode;
      vm.fnRateCardTable = fnRateCardTable;
      vm.trackEvent = trackEvent;
      vm.selectAllColumn = selectAllColumn;
      vm.fnOpenFreightIndex = fnOpenFreightIndex;
      vm.fnCloseFreightIndex = fnCloseFreightIndex;
      vm.FreightIndex = false;


      /**
       * function to initialize the data
       */
      function resultInit(){
        util.isModulePaid('SEA-LCL');
         if(util.isEfpEnabled){
            $state.go('app.pages_share_error');
      }
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
        document.getElementById("inner-content").style.position = "relative";
        vm.resultCardFilter.countApiCard = 0;
        vm.resultCardFilter.isSearchUpdate = false;
        vm.cardsCount = 0;
        vm.selectedFilterCount = 0;
        vm.fnSetRatesArray();
        vm.fnCardSorting('init');

        vm.viewDirectFilter = false;
        vm.quoteArray = [];
        vm.selectedCard = [];
        $rootScope.loadingDetails = false;
        vm.networks = [];
        vm.rfqComponentObj.isBetterRates = false;
        vm.resultCardFilter.ratesLoading = false;
        vm.FreightIndex = $rootScope.domainData.domain_info.ENABLE_FREIGHT_INDEX['LCL'] && vm.search_param.search_type ===  "P2P";
        vm.listOfFilterObj = {
          "linerList" : [],
          "airLineList" : [],
          "originTransporterList" : [],
          "destinationTransporterList" : [],
          "originPortList" : [],
          "destinationPortList" : [],
          "loadingPortList" : [],
          "dischargePortList" : [],
          "pickupTransporterList" : [],
          "deliveryTransporterList" : [],
          "agentList" : [],
          "commodityList" : [],
          "cargoTypeList" : ["All"],
          "ratesType":[{
            "label":"All",
            "value":"All"
          }],
          "contractId" : [],
          "cardStatus" : [],
        };
        vm.selected_filter_obj = {
          "selected_liners" : [],
          "selected_airlines" : [],
          "selected_originPort" : [],
          "selected_destinationPort" : [],
          "selected_loadingPort" : [],
          "selected_dischargePort" : [],
          "selected_originHaulage" : [],
          "selected_destinationHaulage" : [],
          "selected_originTransporter" : [],
          "selected_destinationTransporter" : [],
          "selected_pickupTransporter" : [],
          "selected_deliveryTransporter" : [],
          "rollable" : false,
          "via_route_filter" : "Transhipment",
          "selected_agent" : [],
          "selected_commodity" : [],
          "selected_cargoType" : "All",
          "selected_cardStatus" : "All",
          "selected_rateType" : "All",
          "selected_contractId" : [],
          "selected_depoContainerPickup" : [],
          "selected_depoContainerDrop" : [],
          "no_rates_filter" : false
        };

        vm.currentCard = {};
        vm.sortBySelcted = 1;

        vm.initial_search_param = angular.copy(vm.search_param); // storing the initial search param data;
        vm.searchUser = vm.search_param.user;

        if(SearchService.ratesTypeFilter){
          angular.forEach(SearchService.ratesTypeFilter.filter_option,function(filterOption){
            vm.listOfFilterObj.ratesType.push(filterOption);
          })
        }
        else{
            SearchService.getResultFilter().then( function (response) { 
            SearchService.ratesTypeFilter = response;   
            angular.forEach(SearchService.ratesTypeFilter.filter_option,function(filterOption){
              vm.listOfFilterObj.ratesType.push(filterOption);
            })
          })
        }

        resultService.setLegModeWise(vm.search_param.mode, vm.filterConfig);
        resultService.setLegFilter( vm.filterConfig, vm.search_param );

        vm.filterConfig.search_name = vm.search_param.search_name;
        if(vm.search_param.shipment_insurance){
          vm.filterConfig.value_of_good =  vm.search_param.insurance_leg_cost;
          vm.filterConfig.insurance_currency =  vm.search_param.insurance_currency;
        }

        vm.initial_filterConfig = angular.copy(vm.filterConfig);
        vm.resultCardFilter.getDataSchedule = false;
        var legType = vm.fnCreateLink(vm.filterConfig);

        if(vm.allRatesArrayCopy.length){
          angular.forEach(vm.allRatesArrayCopy, function(rates){

            if( !rates.data.cards.length ){
              vm.fnCallRatesApi(rates, legType);
            }else if( rates.data.cards.length ){
                vm.viewDirectFilter = true;
                vm.fnFilCardLegObj(rates);
            }else{
              vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
              vm.resultCardFilter.countApiCard--;
              vm.fnSetResultMixpanel();
            }
          });
        }

        vm.rfqComponentObj.search_param = angular.copy(vm.search_param);
        vm.rfqComponentObj.rfqObj = resultService.fnSetRfqObj(vm.rfqComponentObj.search_param);
        // vm.fnGetRatesCount();
        vm.onlyFbRates = true;
        vm.search_param["enable_co2e"] = !vm.search_param.hasOwnProperty('enable_co2e') ? false: ($rootScope.domainData.domain_info["ENABLE_CO2E"] && vm.search_param["enable_co2e"]);
        if(vm.isMultiPort && vm.search_param.user_nearby_origin.length > 1 || vm.search_param.user_nearby_destination.length > 1){
          vm.FreightIndex = false;
        } 
        if(!util.ResultPageDataBrainReport.length && vm.FreightIndex){
          DashboardService.getReportsData("Result").then(function (response) {
          util.ResultPageDataBrainReport = response.data.reports;
          }, function (error) {
            util.isCallingApi = false;
          });
        }
        vm.resizeScreenSize();
      }
      function fndownloadQuote(){

        util.callMixpanel("RR-DowanloadRates-Click",{
          "Mode": vm.search_param.mode
        });

       resultService.dwnloadpdf(vm.search_param,vm.selectedCard);
       }
      function getInitData(){
        // vm.getSubvendor = [];
        if(util.isAdmin || util.isFreightbro){

          resultService.getTermsConditions('lcl','true').then(function(response){
              vm.stdTermsAndConditions = util.decodeValue(response.data.terms);
              util.stdTermsAndConditions = vm.stdTermsAndConditions;
          },function(error){
              vm.stdTermsAndConditions = "";
              util.stdTermsAndConditions = "";
          });

          resultService.getTermsConditions('lcl','false').then(function(response){
              vm.termsAndConditions = util.decodeValue(response.data.terms);
          },function(error){
              vm.termsAndConditions = "";
          });

          // if(!util.getSubvendor.length){
          //     resultService.getSubVendor().then(function(response){
          //         angular.forEach(response.data.subvendor_data, function(item){
          //             if(item.carrier_code != null && item.carrier_code != ""){
          //                 vm.getSubvendor.push(item);
          //                 util.getSubvendor = angular.copy(vm.getSubvendor);
          //             }
          //         });
          //     },function(error){
          //         vm.getSubvendor = [];
          //         util.getSubvendor = [];
          //     });
          // }else{
          //     vm.getSubvendor = angular.copy(util.getSubvendor);
          // }
        }
      }
      resultInit();
      getInitData();

      function fnSetRatesArray(){
        vm.msrCardRates = [{
          'data' : SearchService.LclResult.result_data.msr_rates.data,
          'url' : SearchService.LclResult.result_data.msr_rates.url,
          'type' : 'msr_rates'
        }];

        // if(vm.isNetworkRates){
          vm.networkCardRates = [{
            'data' : SearchService.LclResult.result_data.network_rates.data,
            'url' : SearchService.LclResult.result_data.network_rates.url,
            'type' : 'network_rates'
          }]
        // }else{
        //   vm.networkCardRates = [];
        // }

        vm.allRatesArrayCopy = angular.copy([].concat(vm.msrCardRates, vm.networkCardRates));

        if(SearchService.LclResult.result_data.msr_rates.spot.length){
          angular.forEach(SearchService.LclResult.result_data.msr_rates.spot, function(spot){
            spot["type"] = 'msr_spot';
            vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(spot));
          });
        }

        if(SearchService.LclResult.result_data.network_rates.spot.length){
          angular.forEach(SearchService.LclResult.result_data.network_rates.spot, function(spot){
            spot["type"] = 'network_spot';
            vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(spot));
          });
        }

        // if nearby rates true
        if(vm.isNearbyPorts){
          // iterate nearby rates and store in allRatesArrayCopy
          angular.forEach(SearchService.LclResult.result_data.nearby_port_rates, function(item){
            if(item.length){
              angular.forEach(item, function(rates){
                vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(rates));
              })
            }
          });
        }
      }

      // if multiple leg required make link for additional leg
      function fnCreateLink(filterConfig){
        var legType = "&leg_type=l3_lcl,";
        angular.forEach(filterConfig,function(value,key){
          if( !(key =='inco_term' || key == 'search_name' || key == 'l3_lcl' || key == 'value_of_good' || key == 'insurance_currency') ){
              if(value.is_selected ){
                legType += key +',';
              }
          }
        });

        legType = legType.length ? legType.slice(0, -1) : legType;

        if(legType.includes('ins_lcl') && !legType.includes('-ins_lcl') ){
          legType += '&value_of_good='+filterConfig.value_of_good+'&currency='+filterConfig.insurance_currency;
        }
        return legType;
      }

      // get cards and rates object from DB
      function fnCallRatesApi(ratesObj, legType){

        if( ratesObj.data.cards.length ){
          vm.viewDirectFilter = true;
          vm.fnFilCardLegObj(ratesObj);
        }else if(ratesObj.url && SearchService.isNewSearch){
          if(vm.apiProgressValue==1 && vm.resultCardFilter.countApiCard){ startApiLoader() }
          var url = ratesObj.url + legType;
          resultService.getDataMsrFromUrl(url).then(function(response){

            if (response.data.data) {
              ratesObj.data = response.data.data;
              // store currency conversion
              vm.resultCardFilter.currency_conversion_rates = vm.resultCardFilter.currency_conversion_rates.concat(response.data.currency_conversion_rates);
            }

            if (response.data.message) {
              vm.showApiError = true;
              vm.oldapiErrMsgList.push(response.data.message);
              vm.apiErrMsgList = vm.oldapiErrMsgList.filter(function(item, index, array){
                return array.indexOf(item) === index;
              });
            }

            if(Object.keys(ratesObj.data).length && ratesObj.data.cards.length){
              vm.viewDirectFilter = true;
              vm.fnFilCardLegObj(ratesObj);
            }else{
              vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
              vm.resultCardFilter.countApiCard--;
              vm.fnSetResultMixpanel();
            }
            stopApiLoader();
          },function(error){
            vm.resultCardFilter.countApiCard--;
            stopApiLoader();
            $log.error(error);
          });
        }else{
          vm.resultCardFilter.countApiCard--;
        }
      }
      
      
      // Set timer for api loader once rates api started
    function startApiLoader(){
      
      if(vm.apiProgressValue<10){
        vm.showApiLoader = true;
        vm.autoApiUpdate = setTimeout(startApiLoader, 500);
        if(vm.apiProgressValue<9){
          vm.apiProgressValue+= 0.5;
        }
      }  
    }

    // Hide loader and clear timer once all rates api completed
    function stopApiLoader(){
      if(vm.resultCardFilter.countApiCard==0){
        vm.apiProgressValue = 10;
        clearInterval(vm.autoApiUpdate);
        $timeout(function () {
          vm.showApiLoader = false;
          vm.apiProgressValue = 1;
        }, 1000);
      }
    }

      function fnFilCardLegObj(ratesObj, type, callFrom){

        resultService.formRateCardMsr(ratesObj.data.rates, ratesObj.data.cards, vm.resultCardFilter.currency_conversion_rates,vm.search_param);

        vm.resultCardArray = vm.resultCardArray.concat( ratesObj.data.cards );
        vm.cardsCount = vm.resultCardArray.length;

        resultService.fnCallScheduleUrl( ratesObj.data.cards, 'l3_lcl').then(function(response){
          vm.resultCardFilter.countApiCard--;
          vm.fnSetResultMixpanel();
          vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
        },function(error){
            $log.error(error);
        });
      }

      function fnCardSorting(action){
        var cardArray = [];
        angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
          if(action != 'init' && allRatesArray.data.cards.length){
            cardArray = cardArray.concat(allRatesArray.data.cards);
            vm.resultCardArray = (resultService.getLowestCard( [].concat( cardArray ) ) ).reverse();
            vm.resultCardArrayObj = vm.resultCardArray;
          }
          else if(action == 'init'){
            vm.resultCardFilter.countApiCard ++;
          }
        });
      }

      // get rates card count from DB
      function fnGetRatesCount(){
        resultService.searchCount( vm.search_param.origin_location.location, vm.search_param.destination_location.location).then(function(response){
          vm.searchCount = response.data.data.count;
        },function(error){
            $log.error(error);
        });
      }

      // result with new POL POD
      function submitSearch(payload){
        vm.apiProgressValue = 1;
        var data = { "search_param" : payload };
          data.search_param.origin_port = null;
          data.search_param.destination_port = null;
          vm.shipperSearchLimitError = "";
          SearchService.postSearchData(data).then(function(response){
              SearchService.LclResult =  response.data.data;
              SearchService.isNewSearch = true;
              if(appCache.get('verificationsearchParam')) {
                appCache.put('verificationsearchParam', angular.copy(SearchService.LclResult.result_meta.search_param));
              }
              $state.go('app.search.lclResult',{ id: SearchService.LclResult._id });
              util.isCallingApi = false;
          },function(error){
              vm.resultCardFilter["countApiCard"] = 0;
              util.isCallingApi = false;
              util.showToast(error.data.message);
              if(error.status === 429 && error.data.message){
                vm.shipperSearchLimitError  = error.data.message;
              }
              $log.log(error);
          });
      }

      // update result
      function updateSearchResult() {
        vm.search_param = SearchService.LclResult.result_meta.search_param;
        vm.resultCardFilter.currency_conversion_rates = [];

        angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
          allRatesArray.data.cards = [];
        });

        vm.isEdit = true;
        resultService.scheduleResponse = [];
        vm.resultCardArray = [];
        resultInit();
      }

      // mixpanel for result
      function fnSetResultMixpanel(){
        if(!vm.resultCardFilter.countApiCard){
          SearchService.isNewSearch = false;
          var resultCard = vm.resultCardArray;
          var totalCards = angular.copy(resultCard);
          var customCargoType = [];
          angular.forEach(totalCards, function(item){

            // Storing all pickup transporter name in vm.listOfFilterObj.pickupTransporterList
            if( (item.data.buy_rates.l1_lcl && item.data.buy_rates.l1_lcl.rate_obj && item.data.buy_rates.l1_lcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.pickupTransporterList.indexOf(item.data.buy_rates.l1_lcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.pickupTransporterList.push(item.data.buy_rates.l1_lcl.rate_obj.sub_vendor.sub_vendor_name);
            }

            // Storing all origin transporter name in vm.listOfFilterObj.originTransporterList
            if( (item.data.buy_rates.l2_lcl && item.data.buy_rates.l2_lcl.rate_obj && item.data.buy_rates.l2_lcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.originTransporterList.indexOf(item.data.buy_rates.l2_lcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.originTransporterList.push(item.data.buy_rates.l2_lcl.rate_obj.sub_vendor.sub_vendor_name);
            }

            // Storing all liner name in vm.listOfFilterObj.linerList
            if( item.data.buy_rates.l3_lcl.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.linerList.indexOf(item.data.buy_rates.l3_lcl.rate_obj.sub_vendor.sub_vendor_name) == -1 ){
              vm.listOfFilterObj.linerList.push(item.data.buy_rates.l3_lcl.rate_obj.sub_vendor.sub_vendor_name);
            }

            // Storing all destination transporter name in vm.listOfFilterObj.destinationTransporterList
            if( (item.data.buy_rates.l4_lcl && item.data.buy_rates.l4_lcl.rate_obj && item.data.buy_rates.l4_lcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.destinationTransporterList.indexOf(item.data.buy_rates.l4_lcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.destinationTransporterList.push(item.data.buy_rates.l4_lcl.rate_obj.sub_vendor.sub_vendor_name);
            }

            // Storing all delivery transporter name in vm.listOfFilterObj.deliveryTransporterList
            if( (item.data.buy_rates.l5_lcl && item.data.buy_rates.l5_lcl.rate_obj && item.data.buy_rates.l5_lcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.deliveryTransporterList.indexOf(item.data.buy_rates.l5_lcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.deliveryTransporterList.push(item.data.buy_rates.l5_lcl.rate_obj.sub_vendor.sub_vendor_name);
            }

            // Storing all via pol name in vm.listOfFilterObj.loadingPortList
            if(item.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(item.meta.via_pol) == -1){
              vm.listOfFilterObj.loadingPortList.push(item.meta.via_pol);
            }else if(!item.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(item.meta.port_data.origin_port_code) == -1){
              vm.listOfFilterObj.loadingPortList.push(item.meta.port_data.origin_port_code);
            }

            // Storing all via pod name in vm.listOfFilterObj.dischargePortList
            if(item.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(item.meta.via_pod) == -1){
                vm.listOfFilterObj.dischargePortList.push(item.meta.via_pod);
            }else if(!item.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(item.meta.port_data.destination_port_code) == -1){
              vm.listOfFilterObj.dischargePortList.push(item.meta.port_data.destination_port_code);
            }

            // Storing all origin port in vm.listOfFilterObj.originPortList
            if(item.meta.via_pol && vm.listOfFilterObj.originPortList.indexOf(item.meta.port_data.origin_port_code) == -1){
              vm.listOfFilterObj.originPortList.push(item.meta.port_data.origin_port_code);
            }

            // Storing all destination port in vm.listOfFilterObj.destinationPortList
            if(item.meta.via_pod && vm.listOfFilterObj.destinationPortList.indexOf(item.meta.port_data.destination_port_code) == -1){
              vm.listOfFilterObj.destinationPortList.push(item.meta.port_data.destination_port_code);
            }

            // Storing all agent name in vm.listOfFilterObj.agentList
            if(item.data.buy_rates.l3_lcl.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(item.data.buy_rates.l3_lcl.rate_obj.agent.agent_name) == -1){
              vm.listOfFilterObj.agentList.push(item.data.buy_rates.l3_lcl.rate_obj.agent.agent_name);
            }

            // Storing all cargo type name in vm.listOfFilterObj.cargoTypeList
            if(item.data.buy_rates.l3_lcl.rate_obj.cargo_type_data && vm.listOfFilterObj.cargoTypeList.indexOf(item.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name) == -1){

              //custom order list apply
              if(resultService.getCargoTypeFixedOrder().indexOf(item.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name) >= 0){
                vm.listOfFilterObj.cargoTypeList[resultService.getCargoTypeFixedOrder().indexOf(item.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name)] = item.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name;

              }else if(customCargoType.indexOf(item.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name) < 0){
                customCargoType.push(item.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name);
              }
            }

            // Storing all commodity name in vm.listOfFilterObj.commodityList
            if(item.data.buy_rates.l3_lcl.rate_obj.commodity_data && item.data.buy_rates.l3_lcl.rate_obj.commodity_data.length){

              angular.forEach(item.data.buy_rates.l3_lcl.rate_obj.commodity_data, function(commodity){
                if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                  vm.listOfFilterObj.commodityList.push(commodity);
                }
              });
            }
            // convert leg currency in USD for MixPanel
            if(item.data.buy_rates.l3_lcl.rate_obj.leg_currency != 'USD'){
              item.data.buy_rates.l3_lcl.rate_obj.leg_currency_cost = ((item.data.buy_rates.l3_lcl.rate_obj.leg_currency_cost) * (item.meta.conversionRate['USD'])) / item.meta.conversionRate[item.data.buy_rates.l3_lcl.rate_obj.leg_currency];
              item.data.buy_rates.l3_lcl.rate_obj.leg_currency = 'USD';
            }

          });

          //console.log(vm.listOfFilterObj.linerList);
          // empty value remove from array
          vm.listOfFilterObj.cargoTypeList = [].concat(vm.listOfFilterObj.cargoTypeList, customCargoType).filter(function(){return true;});

          if( vm.listOfFilterObj.loadingPortList.indexOf('N/A') == -1 ){
            vm.listOfFilterObj.loadingPortList.push('N/A');
          }
          if( vm.listOfFilterObj.dischargePortList.indexOf('N/A') == -1 ){
            vm.listOfFilterObj.dischargePortList.push('N/A');
          }

          if( vm.listOfFilterObj.commodityList.indexOf('NOT AVAILABLE') == -1 ){
            vm.listOfFilterObj.commodityList.push('NOT AVAILABLE');
          }

          if($state.current.name == 'app.search.lclResult' && vm.resultCardArray.length){
            util.isCallingApi = true;
            util.ratesUpdating = "New Rates Updating...";
            vm.fnCardSorting();
            vm.fnCardFilter();
            $timeout(function () {
              util.isCallingApi = false;
              util.ratesUpdating = '';
            }, 500);
          }

          var mainTotal = totalCards.sort(function(a, b) {
              return b.data.buy_rates.l3_lcl.rate_obj.leg_currency_cost - a.data.buy_rates.l3_lcl.rate_obj.leg_currency_cost;
          })

          var searchName = vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location + ' / ' + $filter('date')(vm.search_param.cargo_ready_date, 'd MMM yyyy')+ '/' +vm.search_param.load_data.load_meta.chargeable_weight +' Kgs';
          if(!vm.isEdit){
            var rateDetails = {
              "Mode":vm.search_param.mode,
              "Search Name":vm.search_param.search_name,
              "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
              "Search Param": searchName,
              "Origin Port":vm.search_param.origin_location.portcode_portname,
              "Destination Port":vm.search_param.destination_location.portcode_portname,
              "Load Details" : vm.search_param.load_data.load_meta.chargeable_weight +' Kgs',
              "Gross Weight": vm.search_param.load_data.load_meta.gross_weight + ' Kgs',
              "Volumetric Weight": vm.search_param.load_data.load_meta.volumetric_weight + ' Kgs',
              "Carrier List" : totalCards.length ? shareQuoteService.getSelectedCardSubvendor(totalCards, 'liner') : 'No Rates Available',
              "No. of rate card": totalCards.length,
              "Highest rate" : totalCards.length ? totalCards[0].meta.card_total_cost :'No Rates Available',
              "Highest rate by" : totalCards.length ? totalCards[0].data.buy_rates.l3_lcl.rate_obj.sub_vendor.sub_vendor_name :'No Rates Available',
              "Lowest rate" : totalCards.length ? totalCards[totalCards.length-1].meta.card_total_cost :'No Rates Available',
              "Lowest rate by" : totalCards.length ? totalCards[totalCards.length-1].data.buy_rates.l3_lcl.rate_obj.sub_vendor.sub_vendor_name :'No Rates Available',
              "Currency" : vm.search_param.user.user_base_currency,
              "Highest Main Freight Cost":mainTotal.length ? mainTotal[0].data.buy_rates.l3_lcl.rate_obj.leg_currency_cost + " " + mainTotal[0].data.buy_rates.l3_lcl.rate_obj.leg_currency :'No Rates Available',
              "Lowest Main Freight Cost": mainTotal.length ? mainTotal[mainTotal.length-1].data.buy_rates.l3_lcl.rate_obj.leg_currency_cost + " " + mainTotal[mainTotal.length-1].data.buy_rates.l3_lcl.rate_obj.leg_currency :'No Rates Available',
              "Origin Text Input":vm.search_param.origin_input_text,
              "Destination Text input":vm.search_param.destination_input_text,
            };
            util.callMixpanel("Rate-Result", rateDetails);
          }
          $timeout(function () {
            if(vm.resultCardFilter.deviceName === 'laptop' && $('.filter-container').height() > vm.mdVirtiualHeight){
              vm.mdVirtiualHeight = Math.round($('.filter-container').height() + 100);
            }
          }, 500);
        }
      }

        // function to show bottom sheet on filter select
        function showFilterBottomSheet(){
          $mdSidenav('right')
            .open()
            .then(function () {
              $mdSidenav('right').onClose();
            });
        };

        vm.fnApplyCardFilter = fnApplyCardFilter;
        function fnApplyCardFilter(selectedFilterObj){
          vm.selected_filter_obj = angular.copy(selectedFilterObj);
          vm.scrollTop();
          vm.cardFilterViaDirect();
        }


        // via route filter
        function cardFilterViaDirect(){
          if(vm.selected_filter_obj.via_route_filter == 'Direct'){
            if(!vm.isMsrDirect ){
              angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
                if(allRatesArray.data.cards.length){
                  resultService.getObjViaDirect(allRatesArray.data.cards, 'l3_lcl');
                }
              });
              vm.isMsrDirect = true;
            }
            else {
              angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
                if(allRatesArray.data.cards.length){
                  fnSelectedSchedule(allRatesArray.data.cards, 'Direct');
                }
              });
            }
          }else {
            angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
              if(allRatesArray.data.cards.length){
                fnSelectedSchedule(allRatesArray.data.cards, 'Transhipment');
              }
            });
          }


          function fnSelectedSchedule(cardArray, action){
            angular.forEach(cardArray, function (card) {
              if ( action == 'Direct' && resultService.fnScheduleDisplayConfig(card,vm.l3_leg)) {
                // card.meta.selected_schedule = (card.data.buy_rates.l3_lcl.rate_obj.schedule.direct &&card.data.buy_rates.l3_lcl.rate_obj.schedule.direct.length) ? card.data.buy_rates.l3_lcl.rate_obj.schedule.direct[0] : null;
              }else{
                // var selectedScheduleIndex = card.data.buy_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(card, vm.l3_leg) : 0;
                // card.meta.selected_schedule = card.data.buy_rates.l3_lcl.rate_obj.schedule.data.length && selectedScheduleIndex !== null && resultService.fnScheduleDisplayConfig(card) ? card.data.buy_rates.l3_lcl.rate_obj.schedule.data[selectedScheduleIndex] : null;
              }
              card.meta["transit_time"] = card.meta.selected_schedule ? card.meta.selected_schedule.transit_time : card.data.buy_rates["l3_lcl"].rate_obj.transit_time ;
            });
          }

          vm.fnCardFilter();
        }

       // card filter
        function fnCardFilter(){
          var result = resultService.fnCardFilter('lcl', vm.resultCardArrayObj, vm.selected_filter_obj);
          vm.resultCardArray = result.filterRatesCard.length === 0 && result.selectedFilterCount === 0 ? vm.resultCardArrayObj : result.filterRatesCard;
          vm.cardsCount = result.cardsCount;
          vm.selectedFilterCount = result.selectedFilterCount;
        }

        //confirmation to discard result changes
        function showConfirm(ev,action){
          var confirm = $mdDialog.confirm()
                // .title('Warning')
                .textContent('All your changes will be lost, do you want to continue?')
                .ariaLabel('discard')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

          $mdDialog.show(confirm).then(function() {
              if(action == 'betterRates'){
                vm.fnFindBetterRates()
              }
          }, function() {
            return true;
          });
        }

        //check update search or additional services
        function checkToUpdate(ev,action){
          if (vm.curr_vas_leg_arr.length) {
            var confirm = $mdDialog.confirm()
              // .title('Warning')
              .textContent('Any changes you have made will be lost, do you want to continue?') //add msg
              .ariaLabel('discard')
              .targetEvent(ev)
              .ok('Yes')
              .cancel('No');

            $mdDialog.show(confirm).then(function () {
                // vm.isVasApplied = false;
              if (vm.quoteArray.length) {
                if (action == 'betterRates') {
                  vm.showConfirm(ev, 'betterRates');
                }
              } else {
                if (action == 'betterRates') {
                  vm.fnFindBetterRates()
                }
              }
            }, function () {
              return;
            });
          } else {
            if (vm.quoteArray.length) {
              if (action == 'betterRates') {
                vm.showConfirm(ev, 'betterRates');
              }
            } else {
              if (action == 'betterRates') {
                vm.fnFindBetterRates()
              }
            }
          }

        }

        // remove card from quote creation
        function removeFromQuote(card) {
          var index = vm.quoteArray.indexOf(card._id);
          if (index > -1) {
            vm.quoteArray.splice(index, 1);
            card.meta.is_selected = false;
            card.data.sell_rates = null;
            var selectId = vm.selectedCard.find(function(item){ return item._id === card._id; });
            var selectIndex = vm.selectedCard.indexOf(selectId);
            vm.selectedCard.splice(selectIndex, 1);

            for(var i = 0; i < vm.allRatesArray.length; i++){
                var tempId = vm.allRatesArray[i].data.cards.find(function(item){ return item._id === card._id; });
                if(tempId){
                  var tempScheduleList = card.data.buy_rates["l3_lcl"].rate_obj.schedule.data;
                  var tempDirectScheduleList = card.data.buy_rates["l3_lcl"].rate_obj.schedule.direct;
                  card.data.buy_rates = tempId.data.buy_rates;
                  card.data.sell_rates = tempId.data.sell_rates;
                  card.data.buy_rates["l3_lcl"].rate_obj.schedule.data = tempScheduleList ;
                  card.data.buy_rates["l3_lcl"].rate_obj.schedule.direct = tempDirectScheduleList
                  break;
                }
            }

            if(vm.isVasApplied){
                var rate_card  = [card];
                resultService.applyVASLegToCard( rate_card,  vm.vasDetails.legList , 'result');
            }else{
                card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
                card.meta['card_total_cost'] = resultService.calCardTotal(card.data.sell_rates);
            }
          }
        }

        // remove al card from quote
        function fnCancelQuote(ev){
          angular.forEach(vm.allRatesArray, function(allRatesArray){
            if(allRatesArray.data.cards.length){
              angular.forEach(allRatesArray.data.cards, function(card){
                card.meta.is_selected = false;
              });
            }
          });
          util.callMixpanel("RR-RemoveAll-Click",{
            "Mode": vm.search_param.mode
          });
          vm.allRatesArrayCopy = angular.copy(vm.allRatesArray);
          vm.fnCardSorting();
          vm.fnCardFilter();
          vm.quoteArray = [];
          vm.selectedCard = [];
          vm.resultCardFilter.hideBookBtn = false;
          vm.resizeScreenSize();
        }

        //Open Modal to fill new card details
        function generateQuoteModal(ev){

          vm.quoteDetails = shareQuoteService.fnInitializeQuoteDetails(vm.filterConfig.l2_lcl_cha.is_selected, vm.filterConfig.l4_lcl_cha.is_selected);
          vm.quoteDetails.terms = vm.termsAndConditions;
          vm.quoteDetails.incoterms = (vm.search_param.inco_term) ? vm.search_param.inco_term : null;
          vm.quoteDetails.hazardous = vm.search_param.hazardous_material;
          vm.quoteDetails.all_in_quote_setting = vm.all_in_quote_setting;

          vm.shareQuoteObj = {
              'quoteDetails' : vm.quoteDetails,
              'termsAndConditions' : vm.termsAndConditions,
              'stdTermsAndConditions' : vm.stdTermsAndConditions,
              'selectedCard' : vm.selectedCard,
              'search_param' : vm.search_param,
              'generateQuoteBtn' : vm.resultCardFilter.generateQuoteBtn,
              'currency_conversion_rates' : vm.resultCardFilter.currency_conversion_rates,
              'fclLoadData' : null,
              'result_id' : vm.result_id,
              'vas_details' : vm.vasDetails,
              'sales_user' : vm.search_param.sales_user,
              'shipper_user' : vm.search_param.shipper_user,
              'quoteFrom': 'Search',
              'exchangeRateId': vm.result_id
          }

          $mdDialog.show({
              template : '<md-dialog id="share-quotation" class="dialobox" ng-cloak><md-dialog-content class="p-0"><share-quotation sharequoteobj="ctrl.parent.shareQuoteObj"></share-quotation></md-dialog-content></md-dialog>',
              // templateUrl        : 'app/main/result/Dialogs/share-quotation/share-quotation.html',
              targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm },
              onRemoving: function (event, removePromise) {
                for(var name in CKEDITOR.instances)
                {
                    CKEDITOR.instances[name].destroy()
                } 
              }
              // onRemoving : vm.resetSendQuote()
          });
          //mixpanel code
          var generateQuote = {
            "Mode":vm.search_param.mode,
            "Search Name":vm.search_param.search_name,
            "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
            "No. of rate card":vm.quoteArray.length
          };
        }

        //function to request tyhe booking data
        function requestToBook(currCard,index){
          vm.booked_leg_type = [];

          angular.forEach(currCard.data.sell_rates,function(value){
                if(value.rate_obj){
                    vm.booked_leg_type.push(value.leg_code);
                }
          });

          var cards = angular.copy(currCard);
          cards.meta["card_total_cost"] = resultService.calCardTotal(cards.data.sell_rates);
          delete cards.meta['buy_leg_total'];

            var booking_data = {
                "search_param" : vm.search_param,
                "card_item" : angular.copy(cards),
                "id" : vm.result_id,
                "booked_leg_type" : vm.booked_leg_type,
                "buyOrSell": !vm.util.isShipper ? 'sell_rates' : vm.resultCardFilter.buyOrSell,
                "user" : vm.search_param.user,
                "page" : "search",
                "create_for" : util.userProfile.user,
                "shipper" : util.isShipper ? util.userProfile.user : (vm.search_param.shipper_user ? vm.search_param.shipper_user : null), //DEV-3744
                "send_mail" : vm.search_param.shipper_user ? true : false,
                "cardIndex":index,
                "all_in_quote_setting" : util.all_in_quote
            }

            resultService.requestToBookData = booking_data;

            //mixpanel code
            analytics.track("Book Now",{
                "Mode":vm.search_param.mode,
                "Search Name":vm.search_param.search_name,
                "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location
            // "Card Details":cards
            });
            
            $timeout(function(){
              vm.util.isCallingApi = false;
              if(util.isSharedQuote()) {
                  $state.go('app.resultSharedBookShipment');
              } else {
                  $state.go('app.resultBookShipment', {mode : 'lcl'});
              }
            }, 200)
        }

        //function to open sidenav
        function openSidenav(componentId){
            $mdSidenav(componentId)
            .open()
            .then(function(){
                $mdSidenav(componentId).onClose(function () {
                    vm.filterConfig = angular.copy(vm.initial_filterConfig);
                  });
            });
        }

        //toggling the sidenav for add services asection
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function closeToast () {
          $mdToast.hide();
        }

        //get only port
        // function getOnlyPort(searchText, mode){
        //     searchText = $sanitize(searchText);
        //     return util.getPorts(searchText, mode).then(function(response){
        //         return response.data.data.port;
        //     },function(error){
        //         $log.log(error.data);
        //         return [];
        //     });
        // }

        // match rates module ***********
        vm.matchRatesObj = {
          "search_param" : SearchService.LclResult.result_meta.search_param,
          "id" : SearchService.LclResult._id,
          "match_rates" : SearchService.LclResult.match_rates,
          "additional_charges" : {
              "selected" : [],
              "available" : []
          }
        }

        function fnOpenMatchRatesModal(ev){

            $mdDialog.show({
            template: '<md-dialog id="wls-match-rates" class="popup-md"><match-rates matchratesparam="ctrl.parent.matchRatesObj" callback="ctrl.parent.fnMatchRatesCall()"></match-rates></md-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            parent: $rootElement,
            scope: $scope,
            preserveScope: true,
            controller: function () { this.parent = vm },
            controllerAs: 'ctrl',
            });
        }

        // RFQ module **********
        function fnFindBetterRates(){
          vm.allRatesArrayCopy = angular.copy(vm.allRatesArray);
          vm.fnCardSorting();
          vm.fnCardFilter();
          vm.quoteArray = [];
          vm.selectedCard = [];
          vm.resultCardFilter.hideBookBtn = false;
          // $timeout(function ( ) {
          vm.rfqComponentObj.isBetterRates = true;
          // vm.viewDirectFilter = false;
          // }, 50);
          vm.fnOpenRFQModal();
        }
        function makeDetailBoxString(initial_search_param) {
          vm.detailBoxString = ((initial_search_param.origin_charges ? 'Origin, ' : '') + (initial_search_param.origin_customs ? 'Origin Custom, ' : '') +(initial_search_param.destination_charges ? 'Destination, ' : '') + (initial_search_param.destination_customs ? 'Destination Custom, ' : '') ) || 'Select Charges';
    
          vm.rfqComponentObj.rfqObj.detailBoxTooltip = ((initial_search_param.origin_charges ? 'Origin\n' : '') + (initial_search_param.origin_customs ? 'Origin Custom\n' : '')+(initial_search_param.destination_charges ? 'Destination\n' : '') + (initial_search_param.destination_customs ? 'Destination Custom\n' : '') ) || 'Select Charges';
    
          vm.rfqComponentObj.rfqObj.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;
    
        }
        // Funtion to open RFQ form modal
        function fnOpenRFQModal(ev){
          vm.makeDetailBoxString(vm.initial_search_param);
          vm.tempRfqObj = angular.copy(vm.rfqObj);
          $mdDialog.show({
            template: '<md-dialog id="nwls-request-for-quote" class="popup-md"><nwls-request-for-quote class="dialog-height" rfqdata="ctrl.parent.rfqComponentObj" callback="ctrl.parent.rfqCallBack(action)"></nwls-request-for-quote></md-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            parent: $rootElement,
            scope: $scope,
            preserveScope: true,
            controller: function () { this.parent = vm },
            controllerAs: 'ctrl',
          });
        }

        function rfqCallBack(action){
            if(action == 'closeRfq'){
              vm.rfqComponentObj.isBetterRates = false;
              vm.viewDirectFilter = true;
            }
        }

        //callback function from card component
        function showQuoteProceedDiv(item){
          vm.isCardChanges = true;
            if(item.action == 'addInToQuote'){
                if (!vm.quoteArray.includes(item.currentCard._id)) {
                    vm.quoteArray.push(item.currentCard._id);
                    vm.selectedCard.push(item.currentCard);
                } else {
                    var replaceCard = $filter('filter')(vm.selectedCard, { '_id': item.currentCard._id }, true);
                    var index = vm.selectedCard.indexOf(replaceCard[0]);
                    vm.selectedCard[index] = item.currentCard;
                }
                vm.resultCardFilter.hideBookBtn = true;
                vm.resizeScreenSize();
            }
            else if(item.action == 'removeFromQuote'){
            vm.removeFromQuote(item.currentCard);

            if(!vm.quoteArray.length){
                vm.resultCardFilter.hideBookBtn = false;
                vm.resizeScreenSize();
            }
            }
            else if( item.action == 'bookingRequest'){
            vm.requestToBook(item.currentCard,item.index);
            }
            else if( item.action == 'deleteCharge' ){
            var index = vm.quoteArray.indexOf(item.currentCard._id);
            if (index > -1) {
                vm.quoteArray.splice(index, 1);
                item.currentCard.meta.is_selected = false;
                item.currentCard.data.sell_rates = null;
                vm.selectedCard.pop(item.currentCard);
            }
            }
            else if( item.action == 'scheduleSelect'){
                $timeout(function(){ item.currentCard.meta.isScheduleCall = true; },100);
                var cardObj = $filter('filter')(vm.selectedCard, { '_id': item.currentCard._id }, true);

                if (cardObj.length) {
                    cardObj[0].meta.selected_schedule = item.currentCard.meta.selected_schedule;
                    cardObj[0].meta.multi_schedule_list = item.currentCard.meta.multi_schedule_list || [];
                }
                // item.currentCard.meta.sailing_date = item.currentCard.meta.selected_schedule.departure_time;
            }else if( item.action == 'manualCardDelete'){
              vm.openDeleteCard(item.currentCard);
            }else if( item.action == 'manualCardEdit' ){
              vm.openEditCardModal(item.currentCard);
            }
            else if( item.action == "addRate" ){
              vm.fnSubmitLegData(item.currentCard, 'addLeg');
            }
            else if( item.action == "editRate" ){
              vm.fnSubmitLegData(item.currentCard, 'editLeg');
            }

        }

        // ********** create new card feature ************

        vm.newCardModal = newCardModal;
        vm.fnSubmitLegData = fnSubmitLegData;
        vm.openEditCardModal = openEditCardModal;
        vm.updateCardDetails = updateCardDetails;
        vm.openDeleteCard = openDeleteCard;
        vm.fnDeleteData = fnDeleteData;
        vm.main_charge_list = [];
        vm.showCardRemoveFromQuote = showCardRemoveFromQuote;
        vm.cancelDialog = cancelDialog;
        vm.curr_vas_leg_arr = [];
        vm.currencyList = util.currencyList;

        vm.pageInfo = {
          "pageId": SearchService.LclResult._id,
          "pageType":'Search',
          "activityId": null
        };

        //Open Modal to fill new card details
        function newCardModal(ev){
          vm.footerObj = { 
            "doneBtnDisable" : false,
            "buyTotalWithConv" : 0,
            "buyTotalBaseCurr" : 0,
            "sellTotalBaseCurr" : 0,
            "profit" : 0,
            "rateExpired":false
          }
          vm.pageSource = 'newCardSearch';

          $mdDialog.show({
            template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" result-card-filter="ctrl.parent.resultCardFilter" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" footer-obj="ctrl.parent.footerObj" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
            targetEvent        : ev,
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm },
            onRemoving: function (event, removePromise) {
              for (var name in CKEDITOR.instances) {
                CKEDITOR.instances[name].destroy();
              }
            }
          });
        }

        // close dialog function
        function cancelDialog(value,action){
          vm.validationObj={
          "expiryValidation":false,
          "loadingPortValidation":false,
          "linerValidation":false,
          "dischargePortValidation":false,
          "dischargeSamePortValidation":false,
          "chargeNameValidation":false,
          "chargeBasicValidation":false,
          "chargeUnitValidation":false,
          "chargeMinimumValidation":false,
          "chargeCurrencyValidation":false,
          }
          $mdDialog.hide();
        }


        //Submit leg Details
        function fnSubmitLegData(currentCard, action){
          var leg_data = currentCard.data.sell_rates[vm.l3_leg].rate_obj;
 
          vm.disableFrm = true;

          var cargo_date = $filter('date')(new Date(vm.search_param.cargo_ready_date), 'yyyy-MM-dd');

          leg_data.schedule.url = api.baseUrl + '/api/schedules?from_port='+vm.search_param.origin_location.location+'&to_port='+vm.search_param.destination_location.location+'&carrier_code='+leg_data.sub_vendor.schedule_provider_code+'&from_date='+cargo_date+'&mode='+vm.search_param.mode;

          if(leg_data.via_pol){
            leg_data.schedule.url += '&via_pol='+leg_data.via_pol;
          }
          if(leg_data.via_pod){
            leg_data.schedule.url += '&via_pod='+leg_data.via_pod;
          }
          resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,currentCard);
          if(action == 'addLeg'){
            currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);        
            currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);        
            currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);
            delete leg_data["_id"];
            var data = {
              'cards' : [currentCard]
            };
            $rootScope.loadingDetails = true;
            util.isCallingApi = true;
            resultService.fnCreateRates(data, vm.result_id, action).then(function(response){
              vm.disableFrm = false;
              var newCardData = response.data.data;
              newCardData.card = newCardData.cards[0];

              resultService.formRateCardMsr(newCardData.rates, [newCardData.card], vm.resultCardFilter.currency_conversion_rates,vm.search_param);

              angular.forEach(newCardData.card.data.buy_rates, function (leg_value, leg_key) {

                if (leg_key == 'l2_lcl')  {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.originTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.originTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if (leg_key == 'l4_lcl')  {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.destinationTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.destinationTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if (leg_key == 'l1_lcl')  {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.pickupTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.pickupTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if (leg_key == 'l5_lcl')  {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.deliveryTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.deliveryTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if(leg_key == 'l3_lcl') {
                    if( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.linerList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1 ){
                      vm.listOfFilterObj.linerList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                    }

                    if(leg_value.rate_obj.schedule.url){
                      resultService.getScheduleResponse(newCardData.card, 'l3_lcl').then(function(){
                      },function(error){
                        resultService.fnSetTransitTime(newCardData.card, leg_key);
                        leg_value.rate_obj.schedule.data = [];
                      });

                      vm.isMsrDirect = false;
                    }else{
                      resultService.fnSetTransitTime(newCardData.card, leg_key);
                      newCardData.card.meta["isScheduleCall"] = true;
                    }
                }else{
                  newCardData.card.meta["isScheduleCall"] = true;
                }
              });

              if(newCardData.card.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(newCardData.card.meta.via_pol) == -1){
                vm.listOfFilterObj.loadingPortList.push(newCardData.card.meta.via_pol);
              }

              if(newCardData.card.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(newCardData.card.meta.via_pod) == -1){
                vm.listOfFilterObj.dischargePortList.push(newCardData.card.meta.via_pod);
              }

              // Storing origin port in vm.listOfFilterObj.originPortList
              if(newCardData.card.meta.via_pol && vm.listOfFilterObj.originPortList.indexOf(newCardData.card.meta.port_data.origin_port_code) == -1){
                vm.listOfFilterObj.originPortList.push(newCardData.card.meta.port_data.origin_port_code);
              }

              // Storing destination port in vm.listOfFilterObj.destinationPortList
              if(newCardData.card.meta.via_pod && vm.listOfFilterObj.destinationPortList.indexOf(newCardData.card.meta.port_data.destination_port_code) == -1){
                vm.listOfFilterObj.destinationPortList.push(newCardData.card.meta.port_data.destination_port_code);
              }

              // Storing agent name in vm.listOfFilterObj.agentList
              if(newCardData.card.data.buy_rates.l3_lcl.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(newCardData.card.data.buy_rates.l3_lcl.rate_obj.agent.agent_name) == -1){
                vm.listOfFilterObj.agentList.push(newCardData.card.data.buy_rates.l3_lcl.rate_obj.agent.agent_name);
              }

              // Storing cargo type name in vm.listOfFilterObj.cargoTypeList
              if(newCardData.card.data.buy_rates.l3_lcl.rate_obj.cargo_type_data && newCardData.card.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name && vm.listOfFilterObj.cargoTypeList.indexOf(newCardData.card.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name) == -1){
                vm.listOfFilterObj.cargoTypeList.push(newCardData.card.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name);
              }

              // Storing all commodity name in vm.listOfFilterObj.commodityList
              if(newCardData.card.data.buy_rates.l3_lcl.rate_obj.commodity_data && newCardData.card.data.buy_rates.l3_lcl.rate_obj.commodity_data.length){

                angular.forEach(newCardData.card.data.buy_rates.l3_lcl.rate_obj.commodity_data, function(commodity){
                  if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                    vm.listOfFilterObj.commodityList.push(commodity);
                  }
                });
              }

              // adding vas leg if its applied vm.vasDetails
              if(vm.isVasApplied){
                  var rate_card  = [newCardData.card];
                  resultService.applyVASLegToCard( rate_card,  vm.vasDetails.legList , 'result');
              }

              var newCardTemp = angular.copy(newCardData.card);
              vm.allRatesArray[0].data.rates = angular.copy(newCardData.rates);
              vm.allRatesArray[0].data.cards.push(newCardTemp);

              vm.allRatesArrayCopy[0].data.rates = angular.copy(newCardData.rates);
              vm.allRatesArrayCopy[0].data.cards.push(newCardData.card);

              vm.resultCardArray.unshift(newCardData.card);
              vm.viewDirectFilter = true;
              $rootScope.loadingDetails = false;
              util.isCallingApi = false;
              vm.cancelDialog();
              vm.fnCardSorting();
              vm.fnCardFilter();
              util.showToast('Card added successfully');
            },function(error){
              util.isCallingApi = false;
              $rootScope.loadingDetails = false;
              vm.disableFrm = false;
              $log.log(error);
              util.showToast(util.displayValidationError(error));
            });
          }
          else if(action == 'editLeg'){
            vm.editCard = angular.copy(currentCard);
            vm.updateCardDetails(vm.editCard);
          }

          //mixpanel code
          util.callMixpanel("New Rate Card Added",{
              "Mode": vm.search_param.mode,
              "Carrier List": leg_data.sub_vendor.sub_vendor_name
          });
            
        }

        function showCardRemoveFromQuote(ev,index, cardData,action){
            var confirm = $mdDialog.confirm()
                  // .title('Warning')
                  .textContent('This change will remove card from your quote section, do you want to continue?') //add msg
                  .ariaLabel('discard')
                  .targetEvent(ev)
                  .ok('Yes')
                  .cancel('No');

            $mdDialog.show(confirm).then(function() {
                if(action == 'editCard'){
                    vm.removeFromQuote(cardData);
                    vm.openEditCardModal(cardData, ev, index);
                }else if(action == 'deleteCard'){
                    vm.removeFromQuote(cardData);
                    vm.fnDeleteData();
                }
            }, function() {
              return true;
            });
        }

        //open edit card modal -ankita
        function openEditCardModal(cardData, ev , index){
         
          if(vm.resultCardFilter.countApiCard){
            return;
          }
            shareQuoteService.isQuoteOrNewcard = 'newCard';
            if(vm.quoteArray.length && vm.quoteArray.includes(cardData._id)){
                vm.showCardRemoveFromQuote(ev,index, cardData,'editCard');
                return;
            }

            if(!vm.quoteArray.length){
              vm.resultCardFilter.hideBookBtn = false;
            }
            
            vm.tempEditCard = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === cardData._id; });
            vm.editCard = angular.copy(vm.tempEditCard);

            vm.footerObj = { 
              "doneBtnDisable" : false,
              "buyTotalWithConv" : 0,
              "buyTotalBaseCurr" : 0,
              "sellTotalBaseCurr" : 0,
              "profit" : 0,
              "rateExpired":false
            };

            vm.pageSource = 'editCardSearch';

            $mdDialog.show({
              template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" result-card-filter="ctrl.parent.resultCardFilter" card-data="ctrl.parent.editCard" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" footer-obj="ctrl.parent.footerObj" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
              targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm },
              onRemoving: function (event, removePromise) {
                for (var name in CKEDITOR.instances) {
                  CKEDITOR.instances[name].destroy();
                }
              }
            });
        }


         //function to update card - ankita - 23/5/18
        function updateCardDetails(currentCard){

            var data = {
              'cards' : [ currentCard ]
            }
            $rootScope.loadingDetails = true;
            util.isCallingApi = true;
            vm.editCard.meta["isScheduleCall"] = false;

            resultService.fnUpdateRates(data, vm.result_id).then(function(response){
                vm.editCard.meta["conversionRate"] = resultService.fnGetConversionRates(vm.resultCardFilter.currency_conversion_rates, vm.editCard.meta.vendor_id , vm.search_param.mode);
                vm.editCard.meta['buy_leg_total'] = resultService.calCardTotal(vm.editCard.data.buy_rates);
                vm.editCard.meta['card_total_cost'] = resultService.calCardTotal(vm.editCard.data.sell_rates);

                if(vm.editCard.data.buy_rates.l3_lcl.rate_obj.schedule.url && !vm.editCard.data.buy_rates.l3_lcl.rate_obj.schedule.data.length){
                    resultService.getScheduleResponse(vm.editCard, 'l3_lcl').then(function(){
                      fnReplaceOldCard();
                    },function(error){
                      resultService.fnSetTransitTime(vm.editCard, 'l3_lcl');
                      vm.editCard.data.buy_rates.l3_lcl.rate_obj.schedule.data = [];
                      fnReplaceOldCard();
                    });
                }else{
                    resultService.fnSetTransitTime(vm.editCard, 'l3_lcl');
                    vm.editCard.meta["isScheduleCall"] = true;
                    // addSchedule();
                }

                if( vm.editCard.data.buy_rates["l2_lcl"] && vm.editCard.data.buy_rates["l2_lcl"].rate_obj && vm.editCard.data.buy_rates["l2_lcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.originTransporterList.indexOf(vm.editCard.data.buy_rates["l2_lcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
                  vm.listOfFilterObj.originTransporterList.push(vm.editCard.data.buy_rates["l2_lcl"].rate_obj.sub_vendor.sub_vendor_name);
                }

                if( vm.editCard.data.buy_rates["l4_lcl"] && vm.editCard.data.buy_rates["l4_lcl"].rate_obj && vm.editCard.data.buy_rates["l4_lcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.destinationTransporterList.indexOf(vm.editCard.data.buy_rates["l4_lcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
                  vm.listOfFilterObj.destinationTransporterList.push(vm.editCard.data.buy_rates["l4_lcl"].rate_obj.sub_vendor.sub_vendor_name);
                }

                if( vm.editCard.data.buy_rates["l1_lcl"] && vm.editCard.data.buy_rates["l1_lcl"].rate_obj && vm.editCard.data.buy_rates["l1_lcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.pickupTransporterList.indexOf(vm.editCard.data.buy_rates["l1_lcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
                  vm.listOfFilterObj.pickupTransporterList.push(vm.editCard.data.buy_rates["l1_lcl"].rate_obj.sub_vendor.sub_vendor_name);
                }

                if( vm.editCard.data.buy_rates["l5_lcl"] && vm.editCard.data.buy_rates["l5_lcl"].rate_obj && vm.editCard.data.buy_rates["l5_lcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.deliveryTransporterList.indexOf(vm.editCard.data.buy_rates["l5_lcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
                  vm.listOfFilterObj.deliveryTransporterList.push(vm.editCard.data.buy_rates["l5_lcl"].rate_obj.sub_vendor.sub_vendor_name);
                }

                if(vm.editCard.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(vm.editCard.meta.via_pol) == -1){
                  vm.listOfFilterObj.loadingPortList.push(vm.editCard.meta.via_pol);
                }

                if(vm.editCard.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(vm.editCard.meta.via_pod) == -1){
                  vm.listOfFilterObj.dischargePortList.push(vm.editCard.meta.via_pod);
                }

                // Storing origin port in vm.listOfFilterObj.originPortList
                if(vm.editCard.meta.via_pol && vm.listOfFilterObj.originPortList.indexOf(vm.editCard.meta.port_data.origin_port_code) == -1){
                  vm.listOfFilterObj.originPortList.push(vm.editCard.meta.port_data.origin_port_code);
                }

                // Storing destination port in vm.listOfFilterObj.destinationPortList
                if(vm.editCard.meta.via_pod && vm.listOfFilterObj.destinationPortList.indexOf(vm.editCard.meta.port_data.destination_port_code) == -1){
                  vm.listOfFilterObj.destinationPortList.push(vm.editCard.meta.port_data.destination_port_code);
                }

                // Storing agent name in vm.listOfFilterObj.agentList
                if(vm.editCard.data.buy_rates.l3_lcl.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(vm.editCard.data.buy_rates.l3_lcl.rate_obj.agent.agent_name) == -1){
                  vm.listOfFilterObj.agentList.push(vm.editCard.data.buy_rates.l3_lcl.rate_obj.agent.agent_name);
                }

                 // Storing cargo type name in vm.listOfFilterObj.cargoTypeList
                if(vm.editCard.data.buy_rates.l3_lcl.rate_obj.cargo_type_data && vm.editCard.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name && vm.listOfFilterObj.cargoTypeList.indexOf(vm.editCard.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name) == -1){
                  vm.listOfFilterObj.cargoTypeList.push(vm.editCard.data.buy_rates.l3_lcl.rate_obj.cargo_type_data.name);
                }

                // Storing all commodity name in vm.listOfFilterObj.commodityList
                if(vm.editCard.data.buy_rates.l3_lcl.rate_obj.commodity_data && vm.editCard.data.buy_rates.l3_lcl.rate_obj.commodity_data.length){

                  angular.forEach(vm.editCard.data.buy_rates.l3_lcl.rate_obj.commodity_data, function(commodity){
                    if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                      vm.listOfFilterObj.commodityList.push(commodity);
                    }
                  });
                }

                fnReplaceOldCard();

              function fnReplaceOldCard(){
                var card = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === vm.editCard._id; });
                if(card){
                  var cardIndex = vm.allRatesArray[0].data.cards.indexOf(card);
                  vm.allRatesArray[0].data.cards[cardIndex] = angular.copy(vm.editCard);
                  vm.allRatesArrayCopy[0].data.cards[cardIndex] = angular.copy(vm.editCard);
                }

                var rates = vm.allRatesArray[0].data.rates[vm.editCard.data.buy_rates.l3_lcl.rate_obj._id];
                if(rates){
                  vm.allRatesArray[0].data.rates[vm.editCard.data.buy_rates.l3_lcl.rate_obj._id] = angular.copy(vm.editCard.data.buy_rates.l3_lcl.rate_obj);
                  vm.allRatesArrayCopy[0].data.rates[vm.editCard.data.buy_rates.l3_lcl.rate_obj._id] = angular.copy(vm.editCard.data.buy_rates.l3_lcl.rate_obj);
                }

                var msrCard = vm.resultCardArray.find(function (obj) { return obj._id === vm.editCard._id; });
                if(msrCard){
                    var msrCardIndex = vm.resultCardArray.indexOf(msrCard);
                    vm.editCard.meta.showCard = angular.copy(vm.resultCardArray[msrCardIndex].meta.showCard);
                    vm.resultCardArray[msrCardIndex] = angular.copy(vm.editCard);
                }
                var selectId = vm.resultCardArrayObj.findIndex(function(item){ return item._id === vm.editCard._id; });
                vm.resultCardArrayObj[selectId] = angular.copy(vm.editCard);
              }

                $rootScope.loadingDetails = false;
                util.isCallingApi = false;
                vm.cancelDialog();
                vm.fnCardFilter();
                util.showToast('Card updated successfully');
            },function(error){
                util.isCallingApi = false;
                $rootScope.loadingDetails = false;
                util.showToast(util.displayValidationError(error));
                $log.log(error);
            });
        }

        //open delete card modal -ankita
        function openDeleteCard(card, ev, index){

            vm.deleteLeg = card;
            vm.deletedIndex = index;

            if(vm.quoteArray.length && vm.quoteArray.includes(card._id)){
                vm.showCardRemoveFromQuote(ev,index, card,'deleteCard');
                return;
            }
            vm.deleteType="Rate Card"
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        //function to delete card - ankita - 23/5/18
        function fnDeleteData(){
          vm.deleteBtn = true;
          util.isCallingApi = true;
            resultService.deleteCard(vm.result_id,vm.deleteLeg._id).then(function(response){
              var msrIndex = vm.allRatesArrayCopy[0].data.cards.indexOf(vm.deleteLeg);
              vm.allRatesArrayCopy[0].data.cards.splice(msrIndex, 1);

              var resultIndex = vm.resultCardArray.indexOf(vm.deleteLeg);
              vm.resultCardArray.splice(resultIndex, 1);

              var card = vm.resultCardArrayObj.find(function (obj) { return obj._id === vm.deleteLeg._id; });
              if(card){
                var cardIndex = vm.resultCardArrayObj.indexOf(card);
                vm.resultCardArrayObj.splice(cardIndex, 1);
              }

              var card = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === vm.deleteLeg._id; });
              if(card){
                var cardIndex = vm.allRatesArray[0].data.cards.indexOf(card);
                vm.allRatesArray[0].data.cards.splice(cardIndex, 1);
              }

              var rates = vm.allRatesArray[0].data.rates[vm.deleteLeg.data.buy_rates.l3_lcl.rate_obj._id];
              if(rates){
                delete vm.allRatesArray[0].data.rates[vm.deleteLeg.data.buy_rates.l3_lcl.rate_obj._id];
              }

              util.showToast('Card deleted successfully');
              vm.deleteBtn = false;
              vm.cancelDialog();

              var viewFilter = 0;
              angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
                if(allRatesArray.data.cards.length){
                  viewFilter ++;
                }
              });

              vm.fnCardFilter();

              if(!viewFilter){
                vm.viewDirectFilter = false;
              }
                util.isCallingApi = false;
            },function(error){
                $log.log(error);
                util.showToast(util.displayValidationError(error));
                vm.deleteBtn = false;
                util.isCallingApi = false;
            });
        }

        // on screen size hide list view
        function resizeScreenSize() {
          vm.resultCardFilter.deviceName = util.resizeScreen(vm.resultCardFilter.deviceName);

          $timeout(function(){
            if(angular.element(document.querySelector('.search-edit-div'))[0]){
              var searchDivHeight = angular.element(document.querySelector('.search-edit-div'))[0].offsetHeight;
              vm.extraDivHeight = searchDivHeight;

              vm.countMarginTop = { 'top' : searchDivHeight + 'px'};
              vm.leftFilterTopMargin = { 'position' : 'sticky', 'top' : searchDivHeight + 'px' };
              if(vm.extraDivHeight == 0){
                vm.isStikyFilter = true;
              }
              // var countBarHeight = angular.element(document.querySelector('.result_count_bar'))[0].offsetHeight;
              // var quotefooterHeight = angular.element(document.querySelector('#footer-content'))[0] ? angular.element(document.querySelector('#footer-content'))[0].offsetHeight : 0;
            }
          }, 200)
        }

        window.onresize = vm.resizeScreenSize;

        // page scroll upto top
        vm.scrollTop = scrollTop;
        function scrollTop(){
          angular.element("#content").animate({
            scrollTop: 0
          }, 300);
          return false;
        }

        // hide toolbar on scroll
        function onScrollAction() {
          if(vm.isStikyFilter == true){
              vm.resizeScreenSize();
              vm.isStikyFilter = false;
          }
          if(vm.isDestroy !== true ){

            var raw = document.querySelector('#content');
            if (raw.scrollTop > document.getElementById("toolbar-navigation-container").offsetHeight) {
              document.querySelector('#result-return-to-top') ? document.querySelector('#result-return-to-top').classList.remove('hide') : '';
              // document.querySelector('#toolbar-navigation-container').classList.add('hide');
            }else{
              document.querySelector("#result-return-to-top") ? document.querySelector('#result-return-to-top').classList.add('hide') : '';
              // document.querySelector('#toolbar-navigation-container').classList.remove('hide');
            }
          }
        };

        this.$onInit = function() {
          vm.isScrollBind = true;
          document.querySelectorAll("#toolbar-navigation-container")[0].style.top = 'auto';
          angular.element(document.querySelector('#content')).bind('scroll', function(){
            vm.onScrollAction();
            if(!util.isMobileDevice && vm.leftFilterTopMargin){
              if($('#content').height() < $('.filter-container').height()){
              vm.leftFilterTopMargin.top = $('#content').height()-$('.filter-container').height()+'px';
            }
            }
          })
        }

        $scope.$on('$destroy', function() {
          document.querySelectorAll("#toolbar-navigation-container")[0].style.top = 0;
          // if(document.querySelector('#toolbar-navigation-container').classList.contains('hide')){
          //   document.querySelector('#toolbar-navigation-container').classList.remove('hide');
          // }
          vm.isDestroy = true;
          vm.scrollTop();

        });

        // event to bind for unload
        $window.onbeforeunload = function (e){
            if($location.url().indexOf('result') !== -1 ){
                return false;
            };
        }

        // error scroll functions
        function fnScrollBtn(side, index){
          if(side == 'left'){
            angular.element("div.apiErrSect").animate({scrollLeft: angular.element('div.apiErrSect').scrollLeft() - 300}, 400);
          }else if(side == 'right'){
            angular.element("div.apiErrSect").animate({scrollLeft: angular.element('div.apiErrSect').scrollLeft() + 300}, 400);
          }
        }

        function removeErrorMessage(index) {
          var tempObj = vm.apiErrMsgList;
          tempObj.splice(index, 1);
        }

        function trackAnalytics(type, item) {
          if(type === "AllInQuote") {
            analytics.track("RR-Allin-Change",{
              "QuoteType" : item
            });
          }
        }

      function fnDialogSwitchToRateCard(ev) {
          if(vm.viewMode === ev){
            return;
          }
          if(!vm.isCardChanges){
            vm.fnSwitchMode(ev)
            return;
          }
          vm.leaveType = "rateCardViewSwitch";
          vm.modeChanges = ev;
          $mdDialog.show({
              templateUrl        : 'app/main/component/rate-card-table/confirm-leave/confirm-leave.html',
              targetEvent        : ev,
              clickOutsideToClose: true,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm }
          });
      }
      function fnSwitchMode(viewMode){
        vm.fnCancelQuote();
        vm.isCardChanges = false;
        vm.viewMode = viewMode;
        $mdDialog.hide();
      }
  
      function fnRateCardTable(payload){
        vm.showQuoteProceedDiv({'currentCard' :payload.currentCard, 'action' : payload.action });
      }
      function selectAllColumn(){
        vm.visibleColumnList.columnsList.forEach(function(column){
          if(!column.isActive){
            column.isActive = true;
            resultService.triggerDatatableButton('.buttons-columnVisibility',column);
          }
        })
        vm.visibleColumnList.columnsHide = 0;
      }
      function emptyRatesFilter(){
        $rootScope.$emit('emptyRates', vm.hideRates);

      }
      function trackEvent(event,mixpanelObj){
      util.callMixpanel(event,mixpanelObj);
    }

    function fnOpenFreightIndex(ev){
      util.callMixpanel("RR-FreightIndex-Click",{ "Mode": vm.search_param.mode });
      if(vm.isMultiPort){
        vm.search_param.user_nearby_origin.forEach(function(item){
          vm.search_param.user_nearby_destination.forEach(function(item1){
            vm.DashboardFilterData.push(item.global_port_code+"_"+item1.global_port_code);
          })
        })
      }
      else{
        var origin = vm.search_param.origin_location.global_port_code;
        var destination = vm.search_param.destination_location.global_port_code;
        vm.DashboardFilterData = [origin+"_"+destination];
      }
      $mdDialog.show({
        template: '<md-dialog class="ViewModal popup-lg"> <md-dialog-content> <databrain-component dashboard-name="Freightify Freight Index" dashboard-id="Index_contract" dashboard-filter-data="ctrl.parent.DashboardFilterData"></databrain-component> </md-dialog-content><md-dialog-actions><div class="footer freight-index-footer"> <div><div class="edit_btn h-40 brad-5 p-15 pointer md-accent-btn with-icon" layout="row" ng-click="ctrl.parent.fnCloseFreightIndex()" layout-align="center center">Close</div></div></div></md-dialog-actions></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm },
      });
    }

    function fnCloseFreightIndex(){
      $mdDialog.hide();
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.result')
        .controller('FtlResultController', FtlResultController);

    /** @ngInject */
    function FtlResultController(util, iframeService, $timeout, $state, $rootScope,SearchService,$stateParams) {

        // data
        var vm = this;
        vm.todaysDate = Date.now();
        vm.iframeService = iframeService;
        vm.searchService=SearchService
        // method
        vm.init = init;
        vm.formIframeUrl = formIframeUrl;
        vm.util=util;
        // if god user changed forwarder refresh data
        $rootScope.$on('app.search.ftlResult', function (event, args) {
          vm.init();
        });
    
        function init() {
          //util.isModulePaid('myRates');
          vm.minHeight = vm.iframeService.iframeHeight;
        //   if(!(util.navPermission.addRate && util.navPermission.addRate[0])){
        //     $state.go('app.pages_share_error');
        //   }
    
          vm.formIframeUrl(); // Get Iframe src url
          document.getElementById("inner-content").style.maxWidth = "100%";
          document.getElementById("inner-content").style.padding = "0";

          $timeout(function () {
            var windowHeight = document.getElementById("content-container").offsetHeight + 7;   
            vm.minHeight = iframeService.calculateMaxHeight(windowHeight); 
          },800);
    
          //  $timeout(function () {
          //   var windowHeight = document.getElementById("content-container").offsetHeight;
          //   vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
          //  }, 50);
    
          // document.getElementById('ftl-result-iframe').onload = function() {
          //   var postParam = {
          //       'parentOrigin': window.location.origin,
          //       'requestObj': iframeService.requestObj
          //   }
    
          //   var targetOrigin = (new URL(vm.iframeUrl)).origin;
          //   document.getElementById('ftl-result-iframe').contentWindow.postMessage(postParam,targetOrigin);
          //   iframeService.requestObj = {
          //     searchParam:vm.searchService.FtlResult,
          //     source:'search'
          //   }
          // };
    
          if(window.addEventListener) {
            window.addEventListener("message", getNewRatesObj, true);        
          } 
          else if (window.attachEvent) {
            window.attachEvent("onmessage", getNewRatesObj, true);
          }
        }
        vm.init();
    
        // get add-rates iframe url
        function formIframeUrl() {
          var ftlResultIframe = document.getElementById('ftl-result-iframe');
          vm.iframeUrl = iframeService.fnGetIframeUrl('FtlResult');
          vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&searchId=" + $stateParams.id);
          ftlResultIframe.src = vm.iframeUrl
          util.isCallingApi = true;
          ftlResultIframe.onload = function() {
            $timeout(function () {
              // var targetOrigin = (new URL(vm.iframeUrl)).origin;
              //  ftlResultIframe.contentWindow.postMessage({ searchParam: vm.searchService.FtlResult,dataSource:'fbShipper-ftlSearch'}, targetOrigin);
               util.isCallingApi = false;
            });
          };
        }


    
        function getNewRatesObj(event){
          var statePage = '';
          //standard-quotation should not run redirect navigation 
          if(!event.data.source || iframeService.notAllowIframeLink.includes(event.data.source)){
            return;
          }
          if (event.target === window) {
              window.removeEventListener("message", getNewRatesObj, true);
          }
          if(event.origin.indexOf(vm.util.iframeOrigin)){
          switch(event.data.source){

            case 'ftl-result':
              statePage = 'app.search.ftlResult'
            break;
    
            default :
            statePage = vm.util.isEfpEnabled ? 'app.searchV2Module' : 'app.search';
          }
    
          $state.go(statePage,{ id: event.data.resultId });

        }
        }
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.result')
        .controller('ResultController', ResultController);

    /** @ngInject */
    function ResultController($rootScope,api,QuotesService, ShipmentService,$scope,$log,$mdSidenav,$window,$mdDialog,$state,localStorageService, $filter,$mdToast,SearchService,resultService, util, $sanitize, $location, shareQuoteService,analytics, $rootElement, appCache, $timeout, DTOptionsBuilder,DTColumnBuilder,DashboardService, constObj)
    {
        var vm = this;
        vm.util = util;
        vm.deleteType="";
        vm.ShipperMaskLiner=$rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER;
        vm.maskLiner=(util.isShipper && vm.ShipperMaskLiner);
        vm.resultService = resultService;
        vm.shareQuoteService = shareQuoteService;
        util.isCallingApi = false;
        $rootScope.loadingDetails = false;
        vm.mainFreightNameChange = $rootScope.isJeenaDomain;
        vm.mainFreightName = 'Main Freight';
        vm.isAddNewRateLoaded=false;
        vm.shipperSearchLimitError = "";
        vm.constObj = constObj;
        vm.getUidata=getUidata;
        
        //result meta
        vm.result_id = SearchService.FclResult._id;
        vm.search_param = SearchService.FclResult.result_meta.search_param;
        vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT) ? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
        vm.maskv2=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT_V2 : '';
        vm.isNetworkRates = vm.search_param.fetch_network_rates;
        vm.isNearbyPorts = vm.search_param.fetch_nearby_port_data;
        vm.isMultiPort = $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"];
        vm.isMultiDoor = $rootScope.domainData.domain_info["ALLOW_MULTI_DOOR"];
        vm.resultCardFilter = {
          'currency_conversion_rates' : SearchService.FclResult.result_meta.currency_conversion_rates,
          'hideBookBtn' : false,
          'deviceName' : '',
          'generateQuoteBtn' : false,
          'ratesLoading' : false,
          'countApiCard' : !util.isShipper ? 3 : 2, // default co2 and status api count, xeneta rate indexadded
          'isSearchUpdate' : false,
          'total_cost' : 'card_total_cost',
          'buyOrSell' : 'sell_rates',
          'co2eApiCalled' : true,
          'co2eResponse' : null
        };
        vm.rfqComponentObj = {
          "isBetterRates" : false,
          "id" : SearchService.FclResult._id,
          "search_param" : null,
          "rfqObj" : null,
          "show_rfqForm" : true
        };
        vm.initial_search_param = {}; // search param to store save data
        vm.initial_filterConfig = {};
        vm.currentCard = {};
        vm.l3_leg = 'l3_fcl';
        vm.l1_leg = 'l1_fcl';
        vm.l5_leg = 'l5_fcl';
        vm.filterConfig =  {
            'inco_term' : '',
            'search_name' : '',
            "insurance_currency" : vm.search_param.user.user_base_currency,
            "value_of_good" : 0
        };
        vm.validationObj={
          "expiryValidation":false,
          "loadingPortValidation":false,
          "linerValidation":false,
          "dischargePortValidation":false,
          "dischargeSamePortValidation":false,
          "chargeNameValidation":false,
          "chargeBasicValidation":false,
          "chargeUnitValidation":false,
          "chargeContainerValidation":false,
          "chargeCurrencyValidation":false,
          };
        vm.onlyFbRates = false;
        vm.searchCount = 0;
        vm.sortByList = [
          // {"name" : "Lowest_Freight" , "value" : "select"},
          {"name" : "Lowest_Total" , "value" : "meta.card_total_cost"},
          {"name" : "Fastest_Transit" , "value" : "meta.transit_time"},
          {"name" : "Sailing Date" , "value" : "meta.sailing_date"},
          {"name" : "Lowest Emission" , "value" : "meta.co2eData.co2e.total"},
          {"name" : "Highest Emission" , "value" : "-meta.co2eData.co2e.total"}
        ];
        vm.resultCardArray = [];
        vm.resultCardArrayObj = [];
        vm.allRatesArray = [];
        vm.allRatesArrayCopy = [];
        vm.userVendorID = parseInt(localStorageService.get('authToken').value.vendor_id);
        vm.isEdit = false;
        vm.displayPollingInfo = false;
        vm.currencyList = util.currencyList;
        vm.buyTotalBaseCurr = 0;
        vm.sellTotalBaseCurr = 0;
        vm.profit = 0;
        vm.oldapiErrMsgList = [];
        vm.apiErrMsgList = [];
        vm.resultService.user_base_currency = vm.search_param.user.user_base_currency;
        vm.isStikyFilter = false;
        vm.toggleNoExportClass = false;
        vm.waitingListCount = 0;
        vm.main_charge_list = [];
        vm.isCardChanges = false;
        vm.curr_vas_leg_arr = [];
        vm.viewMode = 'card';
        vm.visibleColumnList = {
          columnsList : [],
          columnsHide : 0
        };
        vm.apiProgressValue = 1;
        vm.filterEnterpriseTable = {
          'polObject' : [],
          'podObject' : [],
          'rateBy' : []
        }
        vm.mdVirtiualHeight = '1200';
        vm.tableDisplayMode = 'colspan';
        vm.all_in_quote_setting = util.all_in_quote;
        vm.searchFromQuote = vm.search_param.mode==='SEA-FCL' && (vm.search_param.source=='quote' || vm.search_param.source=='create_quote' || vm.search_param.source=='copy_quote');
        vm.generate_quote_type = 'default'
        vm.showQuoteTypeToggle =  vm.search_param.mode === 'SEA-FCL' &&  !vm.util.isShipper  && !vm.searchFromQuote && $rootScope.domainData.domain_info.ENABLE_STANDARD_QUOTATION;
        vm.hideRatesOptions = [{label:"Hide Empty Cards",value:'hideEmptyRates'},{label:"Show Empty Cards",value:'showEmptyCards'}];
        vm.hideRates = 'showEmptyCards';
        vm.emptyRatesFilter =emptyRatesFilter;

        /// Methods
        vm.removeErrorMessage = removeErrorMessage;
        vm.fnScrollBtn = fnScrollBtn;
        vm.toggleSidenav = toggleSidenav;
        vm.openSidenav = openSidenav;
        vm.cancelDialog = cancelDialog;
        vm.updateSearchResult = updateSearchResult;
        vm.requestToBook =  requestToBook;
        vm.getOnlyPort = util.getPorts;
        vm.generateQuoteModal = generateQuoteModal;
        vm.cardFilterViaDirect = cardFilterViaDirect;
        vm.removeFromQuote = removeFromQuote;
        vm.getIncompleteSchedule = getIncompleteSchedule;
        vm.showQuoteProceedDiv = showQuoteProceedDiv;
        vm.fnSetResultMixpanel = fnSetResultMixpanel;
        vm.closeDialog = closeDialog;
        vm.newCardModal = newCardModal;
        vm.fnSubmitLegData = fnSubmitLegData;
        vm.openEditCardModal = openEditCardModal;
        vm.updateCardDetails = updateCardDetails;
        vm.openDeleteCard = openDeleteCard;
        vm.fnDeleteData = fnDeleteData;
        vm.showCardRemoveFromQuote = showCardRemoveFromQuote;
        vm.showFilterBottomSheet = showFilterBottomSheet;
        vm.fnOpenRFQModal = fnOpenRFQModal;
        vm.fnOpenMatchRatesModal = fnOpenMatchRatesModal;
        vm.resizeScreenSize = resizeScreenSize;
        vm.fnFindBetterRates = fnFindBetterRates;
        vm.rfqCallBack = rfqCallBack;
        vm.fnGetPoolingData = fnGetPoolingData;
        vm.fnCallRatesApi = fnCallRatesApi;
        vm.fnFilCardLegObj = fnFilCardLegObj;
        vm.fnGetRatesCount = fnGetRatesCount;
        vm.fnCreateLink = fnCreateLink;
        vm.confirmDeleteCharge = confirmDeleteCharge;
        vm.fnDeleteNewCharge = fnDeleteNewCharge;
        vm.fnCardSorting = fnCardSorting;
        vm.fnSetRatesArray = fnSetRatesArray;
        vm.submitSearch = submitSearch;
        vm.fnCancelQuote = fnCancelQuote;
        vm.fnSetSortByList = fnSetSortByList;
        vm.showConfirm = showConfirm;
        vm.checkToUpdate = checkToUpdate;
        vm.closeToast = closeToast;
        vm.fnCardFilter = fnCardFilter;
        vm.onScrollAction = onScrollAction;
        vm.fndownloadQuote=fndownloadQuote;
        vm.trackEvent = trackEvent;
        vm.viewMode = 'card';
        vm.fnDialogSwitchToRateCard = fnDialogSwitchToRateCard;
        vm.fnSwitchMode = fnSwitchMode;
        vm.exportExcelEl = exportExcelEl;
        vm.getSelectedText = getSelectedText;
        vm.expandEnterpriseTable = expandEnterpriseTable;
        vm.fnChangeTableMode = fnChangeTableMode;
        vm.makeDetailBoxString=makeDetailBoxString;
        vm.fnRateCardTable = fnRateCardTable;
        vm.selectAllColumn = selectAllColumn;
        vm.co2Init = co2Init;
        vm.fnCallCo2Api = fnCallCo2Api;
        vm.fnSetCo2InCard = fnSetCo2InCard;
        vm.fnGetNoRates = fnGetNoRates;
        vm.setInAllRatesArray = setInAllRatesArray;
        // vm.fnSheduleCo2 = fnSheduleCo2;
        vm.trackAnalytics = trackAnalytics;
        vm.fnOpenFreightIndex = fnOpenFreightIndex;
        vm.fnCloseFreightIndex = fnCloseFreightIndex;
        vm.FreightIndex = false;
        vm.DashboardFilterData = [];
        vm.RateIndexInit = RateIndexInit;
        vm.setXenetaInCardMeta = setXenetaInCardMeta;
        vm.fnGetAverage = fnGetAverage;
        vm.xenetaRateIndexResponse = null;

        if(util.activatedTheme === 'transpost'){
          vm.sortByList.unshift({"name" : "Delivery_Time" , "value" : "meta.selected_schedule.arrival_time"});
          vm.sortBy = "Delivery_Time";
        }
        

    /**
     * function to initialize the data
     */
   

    function resultInit(){

      util.isModulePaid('SEA-FCL');
      if(util.isEfpEnabled){
            $state.go('app.pages_share_error');
      }
      if($rootScope.domainData.domain_info.THEME_CONFIG &&  $rootScope.domainData.domain_info.THEME_CONFIG.rate_card_version && $rootScope.domainData.domain_info.THEME_CONFIG.rate_card_version.toLowerCase() === 'walmart'){
        vm.customFeilds=resultService.getCustomFeilds();
      }
     
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";
      document.getElementById("inner-content").style.position = "relative";
      vm.FreightIndex = $rootScope.domainData.domain_info.ENABLE_FREIGHT_INDEX['FCL'] && vm.search_param.origin_service_mode === 'CY' && vm.search_param.destination_service_mode === 'CY';
        if(vm.search_param.freight_charges){
          vm.sortByList.unshift( {"name" : "Lowest_Freight" , "value" : "select"});
        }
        // if(vm.isMultiPort && vm.search_param.user_nearby_origin.length > 1 || vm.search_param.user_nearby_destination.length > 1){
        //   vm.FreightIndex = false;
        // } 

        // if(!util.ResultPageDataBrainReport.length && vm.FreightIndex){
        //   DashboardService.getReportsData("Result").then(function (response) {
        //   util.ResultPageDataBrainReport = response.data.reports;
        //   }, function (error) {
        //     util.isCallingApi = false;
        //   });
        // }
        vm.resultCardFilter.countApiCard = !util.isShipper ? 3 : 2;
        vm.resultCardFilter.isSearchUpdate = false;
        vm.cardsCount = 0;
        vm.selectedFilterCount = 0;
        vm.fnSetRatesArray();

        vm.fnCardSorting('init');

        vm.isMsrDirect = false;
        vm.viewDirectFilter = false;
        vm.quoteArray = [];
        vm.selectedCard = [];
        $rootScope.loadingDetails = false;
        vm.networks = [];
        vm.rfqComponentObj.isBetterRates = false;
        vm.resultCardFilter.ratesLoading = false;
        vm.resultCardFilter.hideBookBtn = false;
        vm.showNoPrefferdLinerDiv = false;
        

        vm.listOfFilterObj = {
          "linerList" : [],
          "airLineList" : [],
          "originTransporterList" : [],
          "destinationTransporterList" : [],
          "originPortList" : [],
          "destinationPortList" : [],
          "loadingPortList" : [],
          "dischargePortList" : [],
          "pickupTransporterList" : [],
          "deliveryTransporterList" : [],
          "agentList" : [],
          "commodityList" : [],
          "cargoTypeList" : ["All"],
          "ratesType" : [{
            "label":"All",
            "value":"All"
          }],
          "cardStatus" : [],
          "contractId" : [],
          "depoContainerPickupList" : [],
          "depoContainerDropList" : [],
          "originServiceMode" : [],
          "destinationServiceMode" : []
        };
        vm.selected_filter_obj = {
          "selected_liners" : [],
          "selected_airlines" : [],
          "selected_originPort" : [],
          "selected_destinationPort" : [],
          "selected_loadingPort" : [],
          "selected_dischargePort" : [],
          "selected_originHaulage" : [],
          "selected_destinationHaulage" : [],
          "selected_originTransporter" : [],
          "selected_destinationTransporter" : [],
          "selected_pickupTransporter" : [],
          "selected_deliveryTransporter" : [],
          "selected_originServiceMode" : [],
          "selected_destinationServiceMode" : [],
          "rollable" : false,
          "via_route_filter" : "Transhipment",
          "selected_agent" : [],
          "selected_commodity" : [],
          "selected_cargoType" : "All",
          "selected_rateType" : "All",
          "selected_cardStatus" : "All",
          "selected_contractId" : [],
          "selected_depoContainerPickup" : [],
          "selected_depoContainerDrop" : [],
          "no_rates_filter" : false
        }
        vm.currentCard = {};
        vm.sortBySelcted = 1;

        if(SearchService.ratesTypeFilter){
          angular.forEach(SearchService.ratesTypeFilter.filter_option,function(filterOption){
            vm.listOfFilterObj.ratesType.push(filterOption);
          })
        }
        else{
            SearchService.getResultFilter().then( function (response) { 
            SearchService.ratesTypeFilter = response;   
            angular.forEach(SearchService.ratesTypeFilter.filter_option,function(filterOption){
              vm.listOfFilterObj.ratesType.push(filterOption);
            })
          })
        }

        if($rootScope.domainData.domain_info && util.isAdmin ){
          vm.listOfFilterObj.cardStatus=[{
            "label":"All",
            "value":"All"
          },
          {
            "label":"Active",
            "value":"Active"
          },
          {
            "label":"Expired",
            "value":"Expired"
          }]
        }
        vm.search_param["enable_co2e"] = !vm.search_param.hasOwnProperty('enable_co2e') ? false: ($rootScope.domainData.domain_info["ENABLE_CO2E"] && vm.search_param["enable_co2e"]);
        vm.initial_search_param = angular.copy(vm.search_param); // storing the initial search param data;
        resultService.setLegModeWise(vm.search_param.mode, vm.filterConfig);
        resultService.setLegFilter( vm.filterConfig, vm.search_param );

        resultService.searchLoadState = [];
        // extract load state from meta search
        angular.forEach(vm.search_param.load_data.load_details_value, function (loadStateValue) {
          resultService.searchLoadState.push(loadStateValue.type);
        });
        vm.co2Init();

        vm.filterConfig.search_name = vm.search_param.search_name;
        if(vm.search_param.shipment_insurance){
          vm.filterConfig.value_of_good =  vm.search_param.insurance_leg_cost;
          vm.filterConfig.insurance_currency =  vm.search_param.insurance_currency;
        }

        vm.initial_filterConfig = angular.copy(vm.filterConfig);

        // load data for mixpanel
        vm.fclLoadData = SearchService.getFclLoadDetails(vm.search_param.load_data.load_details_value);
        var legType = vm.fnCreateLink(vm.filterConfig);
        if(vm.allRatesArrayCopy.length){
          angular.forEach(vm.allRatesArrayCopy, function(rates){

            if( !rates.data.cards.length ){
              vm.fnCallRatesApi(rates, legType);
            }else if( rates.data.cards.length ){
                vm.viewDirectFilter = true;
                vm.fnFilCardLegObj(rates);
            }else{
              vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
              vm.resultCardFilter.countApiCard--;
              stopApiLoader();
              vm.fnSetResultMixpanel();
            }

          // if(rates.data.delta.url){
          //   resultService.getDelta(rates.data.rates,rates.data.delta);
          // }
          });

        }

        vm.rfqComponentObj.search_param = angular.copy(vm.search_param);
        vm.rfqComponentObj.rfqObj = resultService.fnSetRfqObj(vm.rfqComponentObj.search_param);
        // if(util.solution_type != 'WLS'){
          // vm.fnGetRatesCount();
          vm.onlyFbRates = true;
          // }

        if(util.userProfile.user.auto_inquiry_fcl){
          $timeout(function () {
            vm.fnGetPoolingData();
          }, 20000);
        }

        if(!Object.keys($rootScope.domainData.domain_info).length){
          util.getDomainData().then(function(response){
            vm.displayPollingInfo = $rootScope.domainData.domain_info["INTEGRATION_AVAILABLE"] ? true : false;
          },function(error){
            vm.displayPollingInfo = false;
            $log.log(error.data);
          });
        }else{
          vm.displayPollingInfo = $rootScope.domainData.domain_info["INTEGRATION_AVAILABLE"] ? true : false;
        }

        vm.resizeScreenSize();
        if(vm.viewMode === 'enterprise'){
          util.isCallingApi =  true;
        }
        vm.isExpandElTable = false;
        fnExpandContainer('removeClass');
        if($rootScope.domainData.domain_info.TMS_ENABLED){
          vm.getUidata();
        }
    }

    function getInitData(){
      vm.getSubvendor = [];
      if(util.isAdmin || util.isFreightbro){
        
        resultService.getTermsConditions('fcl','true').then(function(response){
            vm.stdTermsAndConditions = util.decodeValue(response.data.terms);
        },function(error){
            vm.stdTermsAndConditions = "";
        });

          resultService.getTermsConditions('fcl','false').then(function(response){
              vm.termsAndConditions = util.decodeValue(response.data.terms);
              util.termsAndConditions = vm.termsAndConditions;
          },function(error){
              vm.termsAndConditions = "";
          });
      }
    // vm.getUidata();

      // if(!util.getSubvendor.length){
      //   resultService.getSubVendor().then(function(response){
      //       angular.forEach(response.data.subvendor_data, function(item){
      //           if(item.carrier_code != null && item.carrier_code != ""){
      //               vm.getSubvendor.push(item);
      //               util.getSubvendor = angular.copy(vm.getSubvendor);
      //           }
      //       });
      //   },function(error){
      //       vm.getSubvendor = [];
      //   });
      // }else{
      //   vm.getSubvendor = angular.copy(util.getSubvendor);
      // }
    }

    resultInit();
    getInitData();
   

    function getSelectedText(){
      $rootScope.$broadcast('rateType',vm.selected_filter_obj.selected_rateType);
    }



    function fnSetRatesArray(){
      vm.msrCardRates = [{
        'data' : SearchService.FclResult.result_data.msr_rates.data,
        'url' : SearchService.FclResult.result_data.msr_rates.url,
        'type' : 'msr_rates'
      }];

      // if(vm.isNetworkRates){
        vm.networkCardRates = [{
          'data' : SearchService.FclResult.result_data.network_rates.data,
          'url' : SearchService.FclResult.result_data.network_rates.url,
          'type' : 'network_rates'
        }]
      // }else{
      //   vm.networkCardRates = [];
      // }

      vm.allRatesArrayCopy = angular.copy([].concat(vm.msrCardRates, vm.networkCardRates));

      // msr spot rates
      if(SearchService.FclResult.result_data.msr_rates.spot.length){
        angular.forEach(SearchService.FclResult.result_data.msr_rates.spot, function(spot){
          spot["type"] = 'msr_spot';
          vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(spot));
        });
      }

      // network spot rates
      if(SearchService.FclResult.result_data.network_rates.spot.length){
        angular.forEach(SearchService.FclResult.result_data.network_rates.spot, function(spot){
          spot["type"] = 'network_spot';
          vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(spot));
        });
      }

      // if nearby rates true
      if(vm.isNearbyPorts){
        // iterate nearby rates and store in allRatesArrayCopy
        angular.forEach(SearchService.FclResult.result_data.nearby_port_rates, function(item){
          if(item.length){
            angular.forEach(item, function(rates){
              vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(rates));
            })
          }
        });
      }
    }
    function makeDetailBoxString(initial_search_param) {
      vm.detailBoxString = ((initial_search_param.origin_charges ? 'Origin, ' : '') + (initial_search_param.origin_customs ? 'Origin Custom, ' : '') +(initial_search_param.destination_charges ? 'Destination, ' : '') + (initial_search_param.destination_customs ? 'Destination Custom, ' : '') ) || 'Select Charges';

      vm.rfqComponentObj.rfqObj.detailBoxTooltip = ((initial_search_param.origin_charges ? 'Origin\n' : '') + (initial_search_param.origin_customs ? 'Origin Custom\n' : '')+(initial_search_param.destination_charges ? 'Destination\n' : '') + (initial_search_param.destination_customs ? 'Destination Custom\n' : '') ) || 'Select Charges';

      vm.rfqComponentObj.rfqObj.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;

    }
    // if multiple leg required make link for additional leg
    function fnCreateLink(filterConfig){
      var legType = "&leg_type=l3_fcl,";
      angular.forEach(filterConfig,function(value,key){
        if( !(key =='inco_term' || key == 'search_name' || key == 'l3_fcl' || key == 'value_of_good' || key == 'insurance_currency') ){
            if(value.is_selected ){
              legType += key +',';
            }
        }
      });

      legType = legType.length ? legType.slice(0, -1) : legType;

      if(legType.includes('ins_fcl') && !legType.includes('-ins_fcl') ){
        legType += '&value_of_good='+filterConfig.value_of_good+'&currency='+filterConfig.insurance_currency;
      }
      return legType;
    }
    function getUidata(){
      vm.syncShimmer=true;
      ShipmentService.getSyncUiData(SearchService.FclResult._id,'rate','rate').then(function(response){
        vm.uiData = response.data.uiData;
        // var checkData =( vm.quote_result.result_data.created_for.company.external_reference_id);
        // vm.uiData.integrationComponentOptions.menu.isEnabled = checkData ? vm.uiData.integrationComponentOptions.menu.isEnabled : false;
        // vm.uiData.integrationComponentOptions.menu['tooltipText']= checkData ? "" : "This customer is not a part of cargowise";
        vm.syncShimmer=false;
      },function(error){
        vm.uiData =[];
        vm.syncShimmer=false
        $log.log(error);
      });
    }
    // get cards and rates object from DB
    function fnCallRatesApi(ratesObj, legType){

      if( ratesObj.data.cards.length ){
        vm.viewDirectFilter = true;
        vm.fnFilCardLegObj(ratesObj);
      }else if(ratesObj.url && SearchService.isNewSearch){
        if(vm.apiProgressValue==1 && vm.resultCardFilter.countApiCard){ startApiLoader() }
        var url = ratesObj.url + legType;
        resultService.getDataMsrFromUrl(url).then(function(response){

          if (response.data.data) {
            ratesObj.data = response.data.data;
            // store currency conversion
            vm.resultCardFilter.currency_conversion_rates = vm.resultCardFilter.currency_conversion_rates.concat(response.data.currency_conversion_rates);
          }

          if (response.data.message) {
            vm.showApiError = true;
            vm.oldapiErrMsgList.push(response.data.message);
            vm.apiErrMsgList = vm.oldapiErrMsgList.filter(function(item, index, array){
              return array.indexOf(item) === index;
            });
          }
         
          if(Object.keys(ratesObj.data).length && ratesObj.data.cards.length){
            vm.viewDirectFilter = true;
            vm.fnFilCardLegObj(ratesObj);
          }else{
            vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
            vm.resultCardFilter.countApiCard--;
            vm.fnSetResultMixpanel();
          }
        
          stopApiLoader();

        },function(error){
          vm.resultCardFilter.countApiCard--;
          stopApiLoader();
          $log.error(error);
        });
        
      }else{
        vm.resultCardFilter.countApiCard--;
        stopApiLoader();
      }
    }


    function fnGetNoRates(){
      vm.noRateLoaded = false;
      resultService.getNoRatesList(SearchService.FclResult._id).then(function(response){
        var result = resultService.fnSetNoRates(response.data.data.cards, vm.allRatesArrayCopy, vm.resultCardArray , "l3_fcl");
        vm.allRatesArrayCopy = result.allRatesArrayCopy;
        vm.resultCardArray = result.resultCardArray;
        vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
        vm.noRateLoaded = true;
        vm.resultCardFilter.countApiCard--;
         vm.fnSetResultMixpanel();
      },function(error){
        vm.noRateLoaded = true;
        vm.resultCardFilter.countApiCard--;
        vm.fnSetResultMixpanel();
        $log.error(error);
      });
    }

    // Set timer for api loader once rates api started
    function startApiLoader(){
      if(vm.apiProgressValue<10){
        vm.showApiLoader = true;
        vm.autoApiUpdate = setTimeout(startApiLoader, 500);
        if(vm.apiProgressValue<9){
          vm.apiProgressValue+= 0.5;
        }
      }  
    }

    // Hide loader and clear timer once all rates api completed
    function stopApiLoader(){
      if(vm.resultCardFilter.countApiCard==3){
        vm.fnCallCo2Api(); //call co2 api
        vm.RateIndexInit(); // hit Xeneta rate index api

        if(!vm.util.isShipper){
          vm.fnGetNoRates()
        }
        vm.apiProgressValue = 10;
        clearInterval(vm.autoApiUpdate);
        $timeout(function () {
          vm.showApiLoader = false;
          vm.apiProgressValue = 1;
        }, 1000);
      }
    }

    // match and bind rates into cards leg object
    function fnFilCardLegObj(ratesObj, callFrom){
     
      resultService.formRateCardMsr( ratesObj.data.rates, ratesObj.data.cards, vm.resultCardFilter.currency_conversion_rates, vm.search_param, vm.co2Payload);

      vm.resultCardArray = vm.resultCardArray.concat( ratesObj.data.cards );
      vm.cardsCount = vm.resultCardArray.length;
      resultService.fnCallScheduleUrl( ratesObj.data.cards, 'l3_fcl').then(function(response){
        vm.resultCardFilter.countApiCard--;
        stopApiLoader();
        vm.fnSetResultMixpanel();
        vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);

        if(callFrom == 'additionalLeg'){
          vm.removeAfterUpdateLeg(ratesObj);
        }
      },function(error){
        $log.error(error);
      });
    }

    function fnCardSorting(action){
      var cardArray = [];
      angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
        if(action != 'init' && allRatesArray.data.cards.length){
          cardArray = cardArray.concat(allRatesArray.data.cards);
          vm.resultCardArray = (resultService.getLowestCard( [].concat( cardArray ) ) ).reverse();
          vm.resultCardArrayObj = vm.resultCardArray;
        }
        else if(action == 'init'){
          vm.resultCardFilter.countApiCard ++;
        }
      });
    }

    // get rates card count from DB
    function fnGetRatesCount(){
      resultService.searchCount( vm.search_param.origin_location.location, vm.search_param.destination_location.location).then(function(response){
        vm.searchCount = response.data.data.count;
      },function(error){
          $log.error(error);
      });
    }

    // function to update the search result
    function submitSearch(payload){
    
      vm.apiProgressValue = 1;
      var data = { "search_param" : payload };
      data.search_param.origin_port = null;
      data.search_param.destination_port = null;
      vm.shipperSearchLimitError = ""; 
      SearchService.postSearchData(data).then(function(response){
          SearchService.FclResult =  response.data.data;
          SearchService.isNewSearch = true;
          if(appCache.get('verificationsearchParam')) {
            appCache.put('verificationsearchParam', angular.copy(SearchService.FclResult.result_meta.search_param));
          }
          $state.go('app.search.result',{ id: SearchService.FclResult._id });
          util.isCallingApi = false;
      },function(error){
          vm.resultCardFilter["countApiCard"] = 0;
          util.isCallingApi = false;
          util.showToast(error.data.message);
          if(error.status === 429 && error.data.message){
            vm.shipperSearchLimitError  = error.data.message;
          }
          $log.log(error);
      });
    }

    function updateSearchResult() {
      vm.search_param = SearchService.FclResult.result_meta.search_param;
      vm.resultCardFilter.currency_conversion_rates = [];

      angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
        allRatesArray.data.cards = [];
      });

      vm.isEdit = true;
      resultService.scheduleResponse = [];
      vm.resultCardArray = [];
      resultInit();
    }

    // $scope.$watchGroup([], function(newValues, oldValues, scope) {
    function fnSetResultMixpanel(){
      // check all get api  + co2 api has called
      if(!vm.resultCardFilter.countApiCard){
        
        SearchService.isNewSearch = false;
        var totalCards = angular.copy(vm.resultCardArray);
        var freightbroCardsLength = 0;
        var roadFreightOriginExists = false;
        var roadFreightDestinationExists = false;
        var sailingDateExists = false;
        var customCargoType = [];
        

        angular.forEach(totalCards, function(item, key){

          // To store Co2 data
          if( !item.meta.isError){
              vm.fnSetCo2InCard(vm.resultCardArray[key].data.buy_rates.l3_fcl.rate_obj, vm.resultCardArray[key].meta, vm.resultCardArray[key].meta.port_data.origin_port_code, vm.resultCardArray[key].meta.port_data.destination_port_code);

          }
          vm.setXenetaInCardMeta(vm.resultCardArray[key].meta, vm.resultCardArray[key].data.buy_rates);


          // Storing all pickup transporter name in vm.listOfFilterObj.pickupTransporterList
          if( (item.data.buy_rates.l1_fcl && item.data.buy_rates.l1_fcl.rate_obj && item.data.buy_rates.l1_fcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.pickupTransporterList.indexOf(item.data.buy_rates.l1_fcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
            vm.listOfFilterObj.pickupTransporterList.push(item.data.buy_rates.l1_fcl.rate_obj.sub_vendor.sub_vendor_name);
          }

          // Storing all origin transporter name in vm.listOfFilterObj.originTransporterList
          if( (item.data.buy_rates.l2_fcl && item.data.buy_rates.l2_fcl.rate_obj && item.data.buy_rates.l2_fcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.originTransporterList.indexOf(item.data.buy_rates.l2_fcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
            vm.listOfFilterObj.originTransporterList.push(item.data.buy_rates.l2_fcl.rate_obj.sub_vendor.sub_vendor_name);
          }

          // Storing all liner name in vm.listOfFilterObj.linerList
          if( item.data.buy_rates.l3_fcl.rate_obj.sub_vendor.sub_vendor_name &&
            vm.listOfFilterObj.linerList.indexOf(item.data.buy_rates.l3_fcl.rate_obj.sub_vendor.sub_vendor_name) == -1 ){
            vm.listOfFilterObj.linerList.push(item.data.buy_rates.l3_fcl.rate_obj.sub_vendor.sub_vendor_name);
          }

          // Storing all destination transporter name in vm.listOfFilterObj.destinationTransporterList
          if( (item.data.buy_rates.l4_fcl && item.data.buy_rates.l4_fcl.rate_obj && item.data.buy_rates.l4_fcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.destinationTransporterList.indexOf(item.data.buy_rates.l4_fcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
            vm.listOfFilterObj.destinationTransporterList.push(item.data.buy_rates.l4_fcl.rate_obj.sub_vendor.sub_vendor_name);
          }

          // Storing all delivery transporter name in vm.listOfFilterObj.deliveryTransporterList
          if( (item.data.buy_rates.l5_fcl && item.data.buy_rates.l5_fcl.rate_obj && item.data.buy_rates.l5_fcl.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.deliveryTransporterList.indexOf(item.data.buy_rates.l5_fcl.rate_obj.sub_vendor.sub_vendor_name) == -1) {
            vm.listOfFilterObj.deliveryTransporterList.push(item.data.buy_rates.l5_fcl.rate_obj.sub_vendor.sub_vendor_name);
          }

          // Storing all via pol name in vm.listOfFilterObj.loadingPortList
          if(item.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(item.meta.via_pol) == -1){
            vm.listOfFilterObj.loadingPortList.push(item.meta.via_pol);
          }else if(!item.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(item.meta.port_data.origin_port_code) == -1){
            vm.listOfFilterObj.loadingPortList.push(item.meta.port_data.origin_port_code);
          }

          // Storing all via pod name in vm.listOfFilterObj.dischargePortList
          if(item.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(item.meta.via_pod) == -1){
            vm.listOfFilterObj.dischargePortList.push(item.meta.via_pod);
          }else if(!item.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(item.meta.port_data.destination_port_code) == -1){
            vm.listOfFilterObj.dischargePortList.push(item.meta.port_data.destination_port_code);
          }

          // Storing all container pickup name in vm.listOfFilterObj.depoContainerPickupList
          if(item.meta.port_data.empty_container_pickup && vm.listOfFilterObj.depoContainerPickupList.indexOf(item.meta.port_data.empty_container_pickup.port_code) == -1){
            vm.listOfFilterObj.depoContainerPickupList.push(item.meta.port_data.empty_container_pickup.port_code);
          }
          
          // Storing all container drop name in vm.listOfFilterObj.depoContainerDropList
          if(item.meta.port_data.empty_container_drop && vm.listOfFilterObj.depoContainerDropList.indexOf(item.meta.port_data.empty_container_drop.port_code) == -1){
            vm.listOfFilterObj.depoContainerDropList.push(item.meta.port_data.empty_container_drop.port_code);
          }
          
          // Storing all origin port in vm.listOfFilterObj.originPortList
          if(item.meta.via_pol && vm.listOfFilterObj.originPortList.indexOf(item.meta.port_data.origin_port_code) == -1){
            vm.listOfFilterObj.originPortList.push(item.meta.port_data.origin_port_code);
          }

          // Storing all destination port in vm.listOfFilterObj.destinationPortList
          if(item.meta.via_pod && vm.listOfFilterObj.destinationPortList.indexOf(item.meta.port_data.destination_port_code) == -1){
            vm.listOfFilterObj.destinationPortList.push(item.meta.port_data.destination_port_code);
          }

          // Storing all agent name in vm.listOfFilterObj.agentList
          if(item.data.buy_rates.l3_fcl.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(item.data.buy_rates.l3_fcl.rate_obj.agent.agent_name) == -1){
            vm.listOfFilterObj.agentList.push(item.data.buy_rates.l3_fcl.rate_obj.agent.agent_name);
          }

          // Storing all cargo type name in vm.listOfFilterObj.cargoTypeList
          if(item.data.buy_rates.l3_fcl.rate_obj.cargo_type_data && vm.listOfFilterObj.cargoTypeList.indexOf(item.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name) == -1){

            //custom order list apply
            if(resultService.getCargoTypeFixedOrder().indexOf(item.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name) >= 0){
              vm.listOfFilterObj.cargoTypeList[resultService.getCargoTypeFixedOrder().indexOf(item.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name)] = item.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name;

            }else if(customCargoType.indexOf(item.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name) < 0){
              customCargoType.push(item.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name);
            }
          }

          // Storing all commodity name in vm.listOfFilterObj.commodityList
          if(item.data.buy_rates.l3_fcl.rate_obj.commodity_data && item.data.buy_rates.l3_fcl.rate_obj.commodity_data.length){

            angular.forEach(item.data.buy_rates.l3_fcl.rate_obj.commodity_data, function(commodity){
              if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                vm.listOfFilterObj.commodityList.push(commodity);
              }
            });
          }
          if(item.data.buy_rates.l3_fcl.rate_obj.contract_number && ( !vm.util.isShipper || (vm.util.isShipper && $rootScope.domainData.domain_info.SHOW_CONTRACT_NUMBER_TO_SHIPPER) ) && (!item.meta.type.includes('network')  || $rootScope.domainData.domain_info.SHOW_CONTRACTID_ON_SHARED_RATES)){
            var isDuplicate=vm.listOfFilterObj.contractId.some(function(contractObj){
              return contractObj.id.toLowerCase() == item.data.buy_rates.l3_fcl.rate_obj.contract_number.toLowerCase()
            })
            if(!isDuplicate){
              vm.listOfFilterObj.contractId.push({"id" :item.data.buy_rates.l3_fcl.rate_obj.contract_number});
            }
          }

          if(item.data.buy_rates.l3_fcl.rate_obj.origin_service_mode){
            var isDuplicate=vm.listOfFilterObj.originServiceMode.some(function(serviceMode){
              return serviceMode.id.toLowerCase() == item.data.buy_rates.l3_fcl.rate_obj.origin_service_mode.toLowerCase()
            })
            if(!isDuplicate){
              vm.listOfFilterObj.originServiceMode.push({
                "id": item.data.buy_rates.l3_fcl.rate_obj.origin_service_mode
              });
            }
          }

          if(item.data.buy_rates.l3_fcl.rate_obj.destination_service_mode){
            var isDuplicate=vm.listOfFilterObj.destinationServiceMode.some(function(serviceMode){
              return serviceMode.id.toLowerCase() == item.data.buy_rates.l3_fcl.rate_obj.destination_service_mode.toLowerCase()
            })
            if(!isDuplicate){
              vm.listOfFilterObj.destinationServiceMode.push({"id" :item.data.buy_rates.l3_fcl.rate_obj.destination_service_mode});
            }
          }

          // convert leg currency in USD for MixPanel
          if(item.data.buy_rates.l3_fcl.rate_obj.leg_currency != 'USD' && !item.meta.isError){
            item.data.buy_rates.l3_fcl.rate_obj.leg_currency_cost = ((item.data.buy_rates.l3_fcl.rate_obj.leg_currency_cost) * (item.meta.conversionRate['USD'])) / item.meta.conversionRate[item.data.buy_rates.l3_fcl.rate_obj.leg_currency];
            item.data.buy_rates.l3_fcl.rate_obj.leg_currency = 'USD';
          }

          // count of total freightbro rates
          if( item.meta.vendor_id == '104' ){
            freightbroCardsLength++;
          }

          if(!roadFreightOriginExists && item.data.buy_rates["l1_fcl"] && item.data.buy_rates["l1_fcl"]["rate_obj"] && item.data.buy_rates["l1_fcl"]["rate_obj"]["leg_total_cost"]) {
            roadFreightOriginExists = true;
          } else if (!roadFreightDestinationExists && item.data.buy_rates["l5_fcl"] && item.data.buy_rates["l5_fcl"]["rate_obj"] && item.data.buy_rates["l5_fcl"]["rate_obj"]["leg_total_cost"]) {
            roadFreightDestinationExists = true;
          }

          // if(item.meta.selected_schedule != null){ // DEV-7597 schedule date not checking
          //   if(!sailingDateExists && item.meta.selected_schedule.departure_time )  {
          //    sailingDateExists = true;
          //   }
          // }
        });

        vm.resultCardFilter["co2eApiCalled"] = false;

        // empty value remove from array
        vm.listOfFilterObj.cargoTypeList = [].concat(vm.listOfFilterObj.cargoTypeList, customCargoType).filter(function(){return true;});

        if( vm.listOfFilterObj.loadingPortList.indexOf('N/A') == -1 ){
          vm.listOfFilterObj.loadingPortList.push('N/A');
        }
        if( vm.listOfFilterObj.dischargePortList.indexOf('N/A') == -1 ){
          vm.listOfFilterObj.dischargePortList.push('N/A');
        }
        if( vm.listOfFilterObj.commodityList.indexOf('NOT AVAILABLE') == -1 ){
          vm.listOfFilterObj.commodityList.push('NOT AVAILABLE');
        }

       vm.fnSetSortByList(sailingDateExists,roadFreightOriginExists,roadFreightDestinationExists);
        var cargoWeight=''
        if($state.current.name == 'app.search.result' && vm.resultCardArray.length){
          util.isCallingApi = true;
          
          util.ratesUpdating = "New Rates Updating...";
          vm.fnCardSorting();
          vm.fnCardFilter();
          
          $timeout(function () {
            util.isCallingApi = false;
            util.ratesUpdating = '';
          }, 500);
        }

        var mainTotal = totalCards.sort(function(a, b) {
          return b.data.buy_rates.l3_fcl.rate_obj.leg_currency_cost - a.data.buy_rates.l3_fcl.rate_obj.leg_currency_cost;
        })

        var searchName = vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location + ' / ' + $filter('date')(vm.search_param.cargo_ready_date, 'd MMM yyyy') + '/' +vm.fclLoadData.loadtype;
        vm.search_param.load_data.load_details_value.forEach(function (i, k) {
          if (i.type) {
             cargoWeight=cargoWeight+(cargoWeight ===''?'':', ') + i.type +'-' + (i.load_metrics[0].weight_qty)
          }
        });
        if(!vm.isEdit){
          var rateDetails = {
            "Mode":vm.search_param.mode,
            "Search Name":vm.search_param.search_name,
            "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
            "Search Param": searchName,
            "Origin Port":vm.search_param.origin_location.portcode_portname,
            "Destination Port":vm.search_param.destination_location.portcode_portname,
            "Load Details":vm.fclLoadData.loadtype,
            "Cargo Weight":cargoWeight,
            "Load In TEUs": vm.fclLoadData.typexqty,
            "Carrier List" :totalCards.length ? shareQuoteService.getSelectedCardSubvendor(totalCards, 'liner') : 'No Rates Available',
            "No. of rate card" :totalCards.length,
            "Highest rate" : totalCards.length ? totalCards[0].meta.card_total_cost : 'No Rates Available',
            "Highest rate by" : totalCards.length ? totalCards[0].data.buy_rates.l3_fcl.rate_obj.sub_vendor.sub_vendor_name : 'No Rates Available',
            "Lowest rate" : totalCards.length ? totalCards[totalCards.length-1].meta.card_total_cost : 'No Rates Available',
            "Lowest rate by" : totalCards.length ? totalCards[totalCards.length-1].data.buy_rates.l3_fcl.rate_obj.sub_vendor.sub_vendor_name : 'No Rates Available',
            "Currency" : vm.search_param.user.user_base_currency,
            "Highest Main Freight Cost":mainTotal.length ? mainTotal[0].data.buy_rates.l3_fcl.rate_obj.leg_currency_cost + " " + mainTotal[0].data.buy_rates.l3_fcl.rate_obj.leg_currency : 'No Rates Available',
            "Lowest Main Freight Cost": mainTotal.length ? mainTotal[mainTotal.length-1].data.buy_rates.l3_fcl.rate_obj.leg_currency_cost + " " + mainTotal[mainTotal.length-1].data.buy_rates.l3_fcl.rate_obj.leg_currency : 'No Rates Available',
            "No. of Schedule Not Available" : totalCards.length ? vm.getIncompleteSchedule(totalCards, 'schedule') : 0,
            "No. of Rates Missing" : totalCards.length ? vm.getIncompleteSchedule(totalCards, 'rateMissing') : 0,
            "No. of Freightbro Rates" : freightbroCardsLength,
            "Origin Text Input":vm.search_param.origin_input_text,
            "Destination Text input":vm.search_param.destination_input_text,
            "MultiPort Enabled": vm.isMultiPort || vm.isMultiDoor
          };
          if(vm.isMultiPort || vm.isMultiDoor ){
            rateDetails["Origin Port Count"]= vm.search_param.user_nearby_origin.length;
            rateDetails["Destination Port Count"]= vm.search_param.user_nearby_destination.length;
          }
          util.callMixpanel("Rate-Result", rateDetails);
        }
        $timeout(function () {
          if(vm.resultCardFilter.deviceName === 'laptop' && $('.filter-container').height() > vm.mdVirtiualHeight){
            vm.mdVirtiualHeight = Math.round($('.filter-container').height() + 100);
          }
        }, 500);
      }
    }

    function fnSetSortByList(sailingDateExists,roadFreightOriginExists,roadFreightDestinationExists){
      // sailing date option in sort by // DEV-7597 schedule date not checking
      // if(sailingDateExists) {
      //   if (!vm.sortByList.some(function (entry) { return 'Sailing Date' == entry.name; }) ){
      //     vm.sortByList.push({"name" : "Sailing Date" , "value" : "meta.selected_schedule.departure_time"});
      //   }
      // } else {
      //   if (vm.sortByList.some(function (entry) { return 'Sailing Date' == entry.name; }) ){
      //     vm.sortByList.pop({"name" : "Sailing Date" , "value" : "meta.selected_schedule.departure_time"});
      //   }
      // }

      // Lowest Haulage (Origin) option in sort by
      if(roadFreightOriginExists) {
        if (!vm.sortByList.some(function (entry) { return 'Lowest Haulage (Origin)' == entry.name; }) ){
          vm.sortByList.push({"name" : "Lowest Haulage (Origin)" , "value" : "data.buy_rates.l1_fcl.rate_obj.leg_total_cost"});
        }
      } else {
        if (vm.sortByList.some(function (entry) { return 'Lowest Haulage (Origin)' == entry.name; }) ){
          vm.sortByList.pop({"name" : "Lowest Haulage (Origin)" , "value" : "data.buy_rates.l1_fcl.rate_obj.leg_total_cost"});
        }
      }

      // Lowest Haulage (Destination) option in sort by
      if(roadFreightDestinationExists) {
        if (!vm.sortByList.some(function (entry) { return 'Lowest Haulage (Destination)' == entry.name; }) ){
          vm.sortByList.push({"name" : "Lowest Haulage (Destination)" , "value" : "data.buy_rates.l5_fcl.rate_obj.leg_total_cost"});
        }
      } else {
        if (vm.sortByList.some(function (entry) { return 'Lowest Haulage (Destination)' == entry.name; }) ){
          vm.sortByList.pop({"name" : "Lowest Haulage (Destination)" , "value" : "data.buy_rates.l5_fcl.rate_obj.leg_total_cost"});
        }
      }
    }

    // code for mixpanel -- schedule not available count
    function getIncompleteSchedule(cards, action){
      var incompleteCards = 0;
      cards.map(function(card){

        if(action == 'schedule' && card.meta.selected_schedule == null){
          incompleteCards++;
        }
        else if(action == 'rateMissing' && resultService.isLegLoadMissing(card.data.buy_rates, 'CARDOBJ')){
          incompleteCards++;
        }

      });
      return incompleteCards;
    }

    // function to show bottom sheet on filter select
    function showFilterBottomSheet(){

      $mdSidenav('right')
        .open()
        .then(function () {
          $mdSidenav('right').onClose();
        });
    };

    vm.fnApplyCardFilter = fnApplyCardFilter;
    function fnApplyCardFilter(selectedFilterObj){
      vm.selected_filter_obj = angular.copy(selectedFilterObj);
      vm.scrollTop();
      vm.cardFilterViaDirect();
      vm.isCardChanges = true;
    }

    // via route filter
    function cardFilterViaDirect() {
      if (vm.selected_filter_obj.via_route_filter == 'Direct') {

        if (!vm.isMsrDirect) {
          angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
            if(allRatesArray.data.cards.length){
              resultService.getObjViaDirect(allRatesArray.data.cards, 'l3_fcl');
            }
          });
          vm.isMsrDirect = true;
        }
        else{
          angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
            if(allRatesArray.data.cards.length){
              fnSelectedSchedule(allRatesArray.data.cards, 'Direct');
            }
          });
        }
      }
      else {
        angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
          if(allRatesArray.data.cards.length){
            fnSelectedSchedule(allRatesArray.data.cards, 'Transhipment');
          }
        });
      }

      function fnSelectedSchedule(cardArray, action){
        angular.forEach(cardArray, function (card) {
          if ( action == 'Direct' && resultService.fnScheduleDisplayConfig(card,vm.l3_leg)) {
            // card.meta.selected_schedule = (card.data.buy_rates.l3_fcl.rate_obj.schedule.direct && card.data.buy_rates.l3_fcl.rate_obj.schedule.direct.length) ? card.data.buy_rates.l3_fcl.rate_obj.schedule.direct[0] : null;
          }else{
            // var selectedScheduleIndex = card.data.buy_rates[vm.l3_leg].rate_obj.sailing_date ? resultService.getScheduleSelectIndex(card, vm.l3_leg) : 0;

            // card.meta.selected_schedule = card.data.buy_rates.l3_fcl.rate_obj.schedule.data.length && selectedScheduleIndex !== null && resultService.fnScheduleDisplayConfig(card) ? card.data.buy_rates.l3_fcl.rate_obj.schedule.data[selectedScheduleIndex] : null;
          }
          card.meta["transit_time"] = card.meta.selected_schedule ? card.meta.selected_schedule.transit_time : card.data.buy_rates["l3_fcl"].rate_obj.transit_time ;
        });
      }

      vm.fnCardFilter();
    }

    // card filter
    function fnCardFilter(){
      var result = resultService.fnCardFilter('fcl', vm.resultCardArrayObj, vm.selected_filter_obj);
      vm.resultCardArray = result.filterRatesCard.length === 0 && result.selectedFilterCount === 0 ? vm.resultCardArrayObj : result.filterRatesCard;
      vm.cardsCount = result.cardsCount;
      vm.selectedFilterCount = result.selectedFilterCount;
    }

    // function to open sidenav
    function openSidenav(componentId) {
      $mdSidenav(componentId)
        .open()
        .then(function () {
          $mdSidenav(componentId).onClose(function () {
            vm.filterConfig = angular.copy(vm.initial_filterConfig);
          });
        });
    }

    // toggling the sidenav for add services asection
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function closeToast() {
      $mdToast.hide();
    }

    // close dialog function
    function cancelDialog(value,action) {
      vm.validationObj={
      "expiryValidation":false,
      "loadingPortValidation":false,
      "linerValidation":false,
      "dischargePortValidation":false,
      "dischargeSamePortValidation":false,
      "chargeNameValidation":false,
      "chargeBasicValidation":false,
      "chargeUnitValidation":false,
      "chargeContainerValidation":false,
      "chargeCurrencyValidation":false,
      }
      $mdDialog.hide();
    }

    function closeDialog() {
      return $mdDialog.hide();
    }

    // remove card from quote creation
    function removeFromQuote(card) {
      var index = vm.quoteArray.indexOf(card._id);
      if (index > -1) {
        vm.quoteArray.splice(index, 1);
        card.meta.is_selected = false;
        card.data.sell_rates = null;
        var selectId = vm.selectedCard.find(function(item){ return item._id === card._id; });
        var selectIndex = vm.selectedCard.indexOf(selectId);
        vm.selectedCard.splice(selectIndex,1);
        if(card.data.buy_rates.l3_fcl.rate_obj.booking_status && card.data.buy_rates.l3_fcl.rate_obj.booking_status.code == 1002){
          vm.waitingListCount--;
        }

        for(var i = 0; i < vm.allRatesArray.length; i++){
          var tempId = vm.allRatesArray[i].data.cards.find(function(item){ return item._id === card._id; });
          if(tempId){
            var tempScheduleList = card.data.buy_rates["l3_fcl"].rate_obj.schedule.data;
            var tempDirectScheduleList = card.data.buy_rates["l3_fcl"].rate_obj.schedule.direct;
            card.data.buy_rates = tempId.data.buy_rates;
            card.data.sell_rates = tempId.data.sell_rates;
            card.meta["co2eData"] = tempId.meta["co2eData"];
            card.data.buy_rates["l3_fcl"].rate_obj.schedule.data = tempScheduleList ;
            card.data.buy_rates["l3_fcl"].rate_obj.schedule.direct = tempDirectScheduleList
            break;
          }
        }

        if(vm.isVasApplied){
          var rate_card  = [card];
          resultService.applyVASLegToCard( rate_card,  vm.vasDetails.legList , 'result');
        }else{
          card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
          card.meta['card_total_cost'] = resultService.calCardTotal(card.data.sell_rates);
        }
      }
      // removing footer selection values if all selected card removed 
      if(vm.quoteArray.length == 0){
        vm.generate_quote_type = '';
        vm.all_in_quote_setting = 'default';
      }
    }

    function fnCancelQuote(ev){
      angular.forEach(vm.allRatesArray, function(allRatesArray){
        if(allRatesArray.data.cards.length){
          angular.forEach(allRatesArray.data.cards, function(card){
            card.meta.is_selected = false;
          });
        }
      });
      util.callMixpanel("RR-RemoveAll-Click",{
        "Mode": vm.search_param.mode
      });
      vm.allRatesArrayCopy = angular.copy(vm.allRatesArray);
      vm.fnCardSorting();
      vm.fnCardFilter();
      vm.quoteArray = [];
      vm.selectedCard = [];
      vm.resultCardFilter.hideBookBtn = false;
      vm.resizeScreenSize();
      $scope.$broadcast('updateRateTable',{'action':'removeCard'});
      vm.generate_quote_type = 'default';
      vm.all_in_quote_setting = 'default';
    }

    //Open Modal to fill new card details
    function generateQuoteModal(ev) {

      vm.quoteDetails = shareQuoteService.fnInitializeQuoteDetails(vm.filterConfig.l2_fcl_cha.is_selected, vm.filterConfig.l4_fcl_cha.is_selected);
      vm.quoteDetails.terms = vm.termsAndConditions;
      vm.quoteDetails.incoterms = (vm.search_param.inco_term) ? vm.search_param.inco_term : null;
      vm.quoteDetails.impo_expo = (vm.search_param.impo_expo) ? vm.search_param.impo_expo : null;
      vm.quoteDetails.hazardous = vm.search_param.hazardous_material;
      vm.quoteDetails.all_in_quote_setting = vm.all_in_quote_setting;
      vm.quoteDetails.generate_quote_type = vm.generate_quote_type ? vm.generate_quote_type : 'default';;
      vm.shareQuoteObj = {
        'quoteDetails' : vm.quoteDetails,
        'termsAndConditions' : vm.termsAndConditions,
        'stdTermsAndConditions' : vm.stdTermsAndConditions,
        'selectedCard' : vm.selectedCard,
        'search_param' : vm.search_param,
        'generateQuoteBtn' : vm.resultCardFilter.generateQuoteBtn,
        'currency_conversion_rates' : vm.resultCardFilter.currency_conversion_rates,
        'fclLoadData' : vm.fclLoadData,
        'result_id' : vm.result_id,
        'vas_details' : vm.vasDetails,
        'sales_user' : vm.search_param.sales_user,
        'shipper_user' : vm.search_param.shipper_user,
        'quoteFrom': 'Search',
        'exchangeRateId': vm.result_id
      }

      //mixpanel code
      var generateQuote = {
        "Mode":vm.search_param.mode,
        "Search Name":vm.search_param.search_name,
        "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
        "No. of rate card":vm.quoteArray.length
      };

      $mdDialog.show({
        template : '<md-dialog id="share-quotation" class="dialobox" ng-cloak><md-dialog-content class="p-0"><share-quotation sharequoteobj="ctrl.parent.shareQuoteObj"></share-quotation></md-dialog-content></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm },
        onRemoving: function (event, removePromise) {
          for(var name in CKEDITOR.instances)
          {
              CKEDITOR.instances[name].destroy()
          } 
        }
        // onRemoving: vm.resetSendQuote
      });
    }

    // function to request tyhe booking data
    function requestToBook(currCard,index) {
      vm.booked_leg_type = [];
      var count = 1;
      if (currCard.data.buy_rates.l3_fcl.rate_obj.is_special && currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment != null) {

        for (var j in currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment) {
          for (var i = 0; i < vm.search_param.load_data.load_details_value.length; i++) {
            if (vm.search_param.load_data.load_details_value[i].type == j && vm.search_param.load_data.load_details_value[i].qty > currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment[j]) {
              util.showToast("Max quantity allowed for " + j + " is " + currCard.data.buy_rates.l3_fcl.rate_obj.special_meta.max_qty_per_shipment[j]);
              count = 0;
              break;
            }
          }
          if (count === 0) {
            break;
          }
        }

        if (count === 0) {
          return;
        }
      }

      angular.forEach(currCard.data.sell_rates, function (value) {
        if (value.rate_obj) {
          vm.booked_leg_type.push(value.leg_code);
        }
      });

      var cards = angular.copy(currCard);
      cards.meta["card_total_cost"] = resultService.calCardTotal(cards.data.sell_rates);
      delete cards.meta['buy_leg_total'];

      var booking_data = {
        "search_param": angular.copy(vm.search_param),
        "card_item": angular.copy(cards),
        "id": vm.result_id,
        "booked_leg_type": angular.copy(vm.booked_leg_type),
        "buyOrSell": !vm.util.isShipper ? 'sell_rates' : vm.resultCardFilter.buyOrSell,
        "user": vm.search_param.user,
        "page": "search",
        "create_for" : util.userProfile.user,
        "shipper" : util.isShipper ? util.userProfile.user : (vm.search_param.shipper_user ? vm.search_param.shipper_user : null), //DEV-3744
        "send_mail" : vm.search_param.shipper_user ? true : false,
        "cardIndex":index,
        "all_in_quote_setting" : util.all_in_quote
      }

      resultService.requestToBookData = booking_data;
      //mixpanel code
      analytics.track("Book Now",{
        "Mode":vm.search_param.mode,
        "Search Name":vm.search_param.search_name,
        "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
       // "Card Details":cards
      });

      $timeout(function(){
        vm.util.isCallingApi = false;
        if (util.isSharedQuote()) {
          $state.go('app.resultSharedBookShipment');
        } else {
          $state.go('app.resultBookShipment', { mode: 'fcl' });
        }
      }, 200)
    }

  // ********** create new card feature ************

  vm.pageInfo = {
    "pageId": SearchService.FclResult._id,
    "pageType":'Search',
    "activityId": null
  }

    // set new card obj
    function newCardModal(ev) {

      vm.footerObj = { 
        "doneBtnDisable" : false,
        "buyTotalWithConv" : 0,
        "buyTotalBaseCurr" : 0,
        "sellTotalBaseCurr" : 0,
        "profit" : 0,
        "rateExpired":false
      }
      vm.pageSource = 'newCardSearch';

      $mdDialog.show({
        template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" result-card-filter="ctrl.parent.resultCardFilter" footer-obj="ctrl.parent.footerObj" co2e-response="ctrl.parent.resultCardFilter.co2eResponse" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        }
      });
    }

    //Submit leg Details
    function fnSubmitLegData(currentCard, action) {
        var leg_data = currentCard.data.sell_rates[vm.l3_leg].rate_obj;
      
        // vm.disableFrm = true;

        var cargo_date = $filter('date')(new Date(vm.search_param.cargo_ready_date), 'yyyy-MM-dd');
        
        leg_data.schedule.url = api.baseUrl + '/api/schedules?from_port='+vm.search_param.origin_location.location+'&to_port='+vm.search_param.destination_location.location+'&carrier_code='+leg_data.sub_vendor.schedule_provider_code+'&from_date='+cargo_date+'&mode='+vm.search_param.mode;

        if(leg_data.via_pol){
           leg_data.schedule.url += '&via_pol='+leg_data.via_pol;
        }
        if(leg_data.via_pod){
           leg_data.schedule.url += '&via_pod='+leg_data.via_pod;
        }
        resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,currentCard);
        if (action == 'addLeg') {
          delete leg_data["_id"];
          currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);        
          currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);        
          currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);
          var data = {
              'cards' : [currentCard]
          };
          $rootScope.loadingDetails = true;
          util.isCallingApi = true;
          resultService.fnCreateRates(data, vm.result_id, action).then(function (response) {
            // vm.disableFrm = false;
            var newCardData = response.data.data; //response.data.data;
            newCardData.card = newCardData.cards[0];

            resultService.formRateCardMsr(newCardData.rates, [newCardData.card], vm.resultCardFilter.currency_conversion_rates,vm.search_param, vm.co2Payload);

            angular.forEach(newCardData.card.data.buy_rates, function (leg_value, leg_key) {

                if (leg_key == 'l2_fcl') {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.originTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.originTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if (leg_key == 'l4_fcl') {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.destinationTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.destinationTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if (leg_key == 'l1_fcl') {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.pickupTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.pickupTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if (leg_key == 'l5_fcl') {
                  if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.deliveryTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.deliveryTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }
                }

                if (leg_key == 'l3_fcl') {
                  if ((leg_value.rate_obj.sub_vendor.sub_vendor_name != null && leg_value.rate_obj.sub_vendor.sub_vendor_name != '') && vm.listOfFilterObj.linerList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                    vm.listOfFilterObj.linerList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                  }

                  if (leg_value.rate_obj.schedule.url) {
                    resultService.getScheduleResponse(newCardData.card, 'l3_fcl').then(function (respopnse) {
                      
                      var newCardObject = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === respopnse['_id']; });
                      if(newCardObject){
                        newCardObject.meta["isScheduleCall"] = respopnse.meta["isScheduleCall"];
                        newCardObject.data.buy_rates['l3_fcl'].rate_obj.schedule.data = respopnse.data.buy_rates['l3_fcl'].rate_obj.schedule.data;
                      }
                      
                      var newCardObjectCopy = vm.allRatesArrayCopy[0].data.cards.find(function (obj) { return obj._id === respopnse['_id']; });
                      if(newCardObjectCopy){
                        newCardObjectCopy.meta["isScheduleCall"] = respopnse.meta["isScheduleCall"];
                        newCardObjectCopy.data.buy_rates['l3_fcl'].rate_obj.schedule.data = respopnse.data.buy_rates['l3_fcl'].rate_obj.schedule.data;
                      }
                    }, function (error) {
                      resultService.fnSetTransitTime(newCardData.card, leg_key);
                      leg_value.rate_obj.schedule.data = [];
                    });

                    vm.isMsrDirect = false;
                  }else{
                    resultService.fnSetTransitTime(newCardData.card, leg_key);
                    newCardData.card.meta["isScheduleCall"] = true;
                  }
                }else{
                  newCardData.card.meta["isScheduleCall"] = true;
                }

            });

              if(newCardData.card.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(newCardData.card.meta.via_pol) == -1){
                vm.listOfFilterObj.loadingPortList.push(newCardData.card.meta.via_pol);
              }

              if(newCardData.card.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(newCardData.card.meta.via_pod) == -1){
                vm.listOfFilterObj.dischargePortList.push(newCardData.card.meta.via_pod);
              }

              // Storing origin port in vm.listOfFilterObj.originPortList
              if(newCardData.card.meta.via_pol && vm.listOfFilterObj.originPortList.indexOf(newCardData.card.meta.port_data.origin_port_code) == -1){
                vm.listOfFilterObj.originPortList.push(newCardData.card.meta.port_data.origin_port_code);
              }

              // Storing destination port in vm.listOfFilterObj.destinationPortList
              if(newCardData.card.meta.via_pod && vm.listOfFilterObj.destinationPortList.indexOf(newCardData.card.meta.port_data.destination_port_code) == -1){
                vm.listOfFilterObj.destinationPortList.push(newCardData.card.meta.port_data.destination_port_code);
              }

              // Storing agent name in vm.listOfFilterObj.agentList
              if(newCardData.card.data.buy_rates.l3_fcl.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(newCardData.card.data.buy_rates.l3_fcl.rate_obj.agent.agent_name) == -1){
                vm.listOfFilterObj.agentList.push(newCardData.card.data.buy_rates.l3_fcl.rate_obj.agent.agent_name);
              }

              // Storing cargo type name in vm.listOfFilterObj.cargoTypeList
              if(newCardData.card.data.buy_rates.l3_fcl.rate_obj.cargo_type_data && newCardData.card.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name && vm.listOfFilterObj.cargoTypeList.indexOf(newCardData.card.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name) == -1){
                vm.listOfFilterObj.cargoTypeList.push(newCardData.card.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name);
              }

              // storing container pickup
              if(newCardData.card.meta.port_data.empty_container_pickup && vm.listOfFilterObj.depoContainerPickupList.indexOf(newCardData.card.meta.port_data.empty_container_pickup) == -1){
                vm.listOfFilterObj.depoContainerPickupList.push(newCardData.card.meta.port_data.empty_container_pickup);
              }

              // storing container drop
              if(newCardData.card.meta.port_data.empty_container_drop && vm.listOfFilterObj.depoContainerDropList.indexOf(newCardData.card.meta.port_data.empty_container_drop) == -1){
                vm.listOfFilterObj.depoContainerDropList.push(newCardData.card.meta.port_data.empty_container_drop);
              }

              // Storing all commodity name in vm.listOfFilterObj.commodityList
              if(newCardData.card.data.buy_rates.l3_fcl.rate_obj.commodity_data && newCardData.card.data.buy_rates.l3_fcl.rate_obj.commodity_data.length){

                angular.forEach(newCardData.card.data.buy_rates.l3_fcl.rate_obj.commodity_data, function(commodity){
                  if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                    vm.listOfFilterObj.commodityList.push(commodity);
                  }
                });
              }

            // adding vas leg if its applied vm.vasDetails
            if(vm.isVasApplied){
              var rate_card  = [newCardData.card];
              resultService.applyVASLegToCard( rate_card,  vm.vasDetails.legList , 'result');
            }

            var newCardTemp = angular.copy(newCardData.card);
            vm.allRatesArray[0].data.rates = angular.copy(newCardData.rates);
            vm.allRatesArray[0].data.cards.push(newCardTemp);

            vm.allRatesArrayCopy[0].data.rates = angular.copy(newCardData.rates);
            vm.allRatesArrayCopy[0].data.cards.push(newCardData.card);

            vm.resultCardArray.unshift(newCardData.card);
            $scope.$broadcast('updateRateTable',{'cardData':newCardData.card,'action':'addNewCard'});
            vm.viewDirectFilter = true;
            $rootScope.loadingDetails = false;
            util.isCallingApi = false;
            vm.cancelDialog();
            vm.fnCardSorting();
            vm.fnCardFilter();
            util.showToast('Card added successfully');
          }, function (error) {
            util.isCallingApi = false;
            $rootScope.loadingDetails = false;
            // vm.disableFrm = false;
            $log.log(error);
            util.showToast(util.displayValidationError(error));
          });
        }
        else if (action == 'editLeg') {
          vm.editCard = angular.copy(currentCard);
          vm.updateCardDetails(vm.editCard);
        }
        
        //mixpanel code
        util.callMixpanel("New Rate Card Added",{
          "Mode":vm.search_param.mode,
          "Carrier List": leg_data.sub_vendor.sub_vendor_name
        });
    }

    //open edit card modal -ankita
    function openEditCardModal(cardData, ev) {

      if(vm.resultCardFilter.countApiCard){
        return;
      }

      if (vm.quoteArray.length && vm.quoteArray.includes(cardData._id)) {
        vm.showCardRemoveFromQuote(ev, cardData, 'editCard');
        return;
      }

      if(!vm.quoteArray.length){
        vm.resultCardFilter.hideBookBtn = false;
      }

      vm.tempEditCard = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === cardData._id; });
      vm.editCard = angular.copy(vm.tempEditCard);

      vm.footerObj = { 
        "doneBtnDisable" : false,
        "buyTotalWithConv" : 0,
        "buyTotalBaseCurr" : 0,
        "sellTotalBaseCurr" : 0,
        "profit" : 0,
        "rateExpired":false
      }
      vm.pageSource = 'editCardSearch';

      $mdDialog.show({
        template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded"result-card-filter="ctrl.parent.resultCardFilter" card-data="ctrl.parent.editCard" footer-obj="ctrl.parent.footerObj" co2e-response="ctrl.parent.resultCardFilter.co2eResponse" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm },
        onRemoving: function (event, removePromise) {
          for (var name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy();
          }
        }
      });
    }

    //function to update card - ankita - 23/5/18
    function updateCardDetails(currentCard) {
      var data = {
        'cards' : [ currentCard ]
      }
      $rootScope.loadingDetails = true;
      util.isCallingApi = true;
      vm.editCard.meta["isScheduleCall"] = false;

      resultService.fnUpdateRates(data, vm.result_id).then(function (response) {
        
        vm.editCard.meta["conversionRate"] = resultService.fnGetConversionRates(vm.resultCardFilter.currency_conversion_rates, vm.editCard.meta.vendor_id , vm.search_param.mode);
        vm.editCard.meta['buy_leg_total'] = resultService.calCardTotal(vm.editCard.data.buy_rates);
        vm.editCard.meta['card_total_cost'] = resultService.calCardTotal(vm.editCard.data.sell_rates);

        var freightString = vm.editCard.meta.missingFlag.find(function (obj) { return obj.includes("Freight"); });
        vm.editCard.meta.missingFlag.splice(vm.editCard.meta.missingFlag.indexOf(freightString), 1);

        // update remarks & inclusion
        angular.forEach(vm.editCard.data.buy_rates, function (leg_value, leg_key) {
          if(leg_value.rate_obj){
            resultService.fnMissingFlag(leg_value, vm.editCard.meta);
          }
        });

        if(vm.editCard.data.buy_rates.l3_fcl.rate_obj.schedule.url && !vm.editCard.data.buy_rates.l3_fcl.rate_obj.schedule.data.length){
          resultService.getScheduleResponse(vm.editCard, 'l3_fcl').then(function(){
            fnReplaceOldCard();
          },function(error){
            resultService.fnSetTransitTime(vm.editCard, 'l3_fcl');
            vm.editCard.data.buy_rates.l3_fcl.rate_obj.schedule.data = [];
            fnReplaceOldCard();
          });
        }else{
            resultService.fnSetTransitTime(vm.editCard, 'l3_fcl');
            vm.editCard.meta["isScheduleCall"] = true;
        }

        if( vm.editCard.data.buy_rates["l2_fcl"] && vm.editCard.data.buy_rates["l2_fcl"].rate_obj && vm.editCard.data.buy_rates["l2_fcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.originTransporterList.indexOf(vm.editCard.data.buy_rates["l2_fcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
          vm.listOfFilterObj.originTransporterList.push(vm.editCard.data.buy_rates["l2_fcl"].rate_obj.sub_vendor.sub_vendor_name);
        }

        if( vm.editCard.data.buy_rates["l4_fcl"] && vm.editCard.data.buy_rates["l4_fcl"].rate_obj && vm.editCard.data.buy_rates["l4_fcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.destinationTransporterList.indexOf(vm.editCard.data.buy_rates["l4_fcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
          vm.listOfFilterObj.destinationTransporterList.push(vm.editCard.data.buy_rates["l4_fcl"].rate_obj.sub_vendor.sub_vendor_name);
        }

        if( vm.editCard.data.buy_rates["l1_fcl"] && vm.editCard.data.buy_rates["l1_fcl"].rate_obj && vm.editCard.data.buy_rates["l1_fcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.pickupTransporterList.indexOf(vm.editCard.data.buy_rates["l1_fcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
          vm.listOfFilterObj.pickupTransporterList.push(vm.editCard.data.buy_rates["l1_fcl"].rate_obj.sub_vendor.sub_vendor_name);
        }

        if( vm.editCard.data.buy_rates["l5_fcl"] && vm.editCard.data.buy_rates["l5_fcl"].rate_obj && vm.editCard.data.buy_rates["l5_fcl"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.deliveryTransporterList.indexOf(vm.editCard.data.buy_rates["l5_fcl"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
          vm.listOfFilterObj.deliveryTransporterList.push(vm.editCard.data.buy_rates["l5_fcl"].rate_obj.sub_vendor.sub_vendor_name);
        }

        if(vm.editCard.meta.via_pol && vm.listOfFilterObj.loadingPortList.indexOf(vm.editCard.meta.via_pol) == -1){
          vm.listOfFilterObj.loadingPortList.push(vm.editCard.meta.via_pol);
        }

        if(vm.editCard.meta.via_pod && vm.listOfFilterObj.dischargePortList.indexOf(vm.editCard.meta.via_pod) == -1){
          vm.listOfFilterObj.dischargePortList.push(vm.editCard.meta.via_pod);
        }

        // Storing origin port in vm.listOfFilterObj.originPortList
        if(vm.editCard.meta.via_pol && vm.listOfFilterObj.originPortList.indexOf(vm.editCard.meta.port_data.origin_port_code) == -1){
          vm.listOfFilterObj.originPortList.push(vm.editCard.meta.port_data.origin_port_code);
        }

        // Storing destination port in vm.listOfFilterObj.destinationPortList
        if(vm.editCard.meta.via_pod && vm.listOfFilterObj.destinationPortList.indexOf(vm.editCard.meta.port_data.destination_port_code) == -1){
          vm.listOfFilterObj.destinationPortList.push(vm.editCard.meta.port_data.destination_port_code);
        }

        // storing container pickup
        if(vm.editCard.meta.port_data.empty_container_pickup && vm.listOfFilterObj.depoContainerPickupList.indexOf(vm.editCard.meta.port_data.empty_container_pickup) == -1){
          vm.listOfFilterObj.depoContainerPickupList.push(vm.editCard.meta.port_data.empty_container_pickup);
        }

        // storing container drop
        if(vm.editCard.meta.port_data.empty_container_drop && vm.listOfFilterObj.depoContainerDropList.indexOf(vm.editCard.meta.port_data.empty_container_drop) == -1){
          vm.listOfFilterObj.depoContainerDropList.push(vm.editCard.meta.port_data.empty_container_drop);
        }
        
        // Storing agent name in vm.listOfFilterObj.agentList
        if(vm.editCard.data.buy_rates.l3_fcl.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(vm.editCard.data.buy_rates.l3_fcl.rate_obj.agent.agent_name) == -1){
          vm.listOfFilterObj.agentList.push(vm.editCard.data.buy_rates.l3_fcl.rate_obj.agent.agent_name);
        }

        // Storing cargo type name in vm.listOfFilterObj.cargoTypeList
        if(vm.editCard.data.buy_rates.l3_fcl.rate_obj.cargo_type_data && vm.editCard.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name && vm.listOfFilterObj.cargoTypeList.indexOf(vm.editCard.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name) == -1){
          vm.listOfFilterObj.cargoTypeList.push(vm.editCard.data.buy_rates.l3_fcl.rate_obj.cargo_type_data.name);
        }

        // Storing all commodity name in vm.listOfFilterObj.commodityList
        if(vm.editCard.data.buy_rates.l3_fcl.rate_obj.commodity_data && vm.editCard.data.buy_rates.l3_fcl.rate_obj.commodity_data.length){

          angular.forEach(vm.editCard.data.buy_rates.l3_fcl.rate_obj.commodity_data, function(commodity){
            if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
              vm.listOfFilterObj.commodityList.push(commodity);
            }
          });
        }

        fnReplaceOldCard();

        function fnReplaceOldCard(){

          var card = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === vm.editCard._id; });
          if(card){
            var cardIndex = vm.allRatesArray[0].data.cards.indexOf(card);
            vm.allRatesArray[0].data.cards[cardIndex] = angular.copy(vm.editCard);
            vm.allRatesArrayCopy[0].data.cards[cardIndex] = angular.copy(vm.editCard);
          }

          var rates = vm.allRatesArray[0].data.rates[vm.editCard.data.buy_rates.l3_fcl.rate_obj._id];
          if(rates){
            vm.allRatesArray[0].data.rates[vm.editCard.data.buy_rates.l3_fcl.rate_obj._id] = angular.copy(vm.editCard.data.buy_rates.l3_fcl.rate_obj);
            vm.allRatesArrayCopy[0].data.rates[vm.editCard.data.buy_rates.l3_fcl.rate_obj._id] = angular.copy(vm.editCard.data.buy_rates.l3_fcl.rate_obj);
          }

          var msrCard = vm.resultCardArray.find(function (obj) { return obj._id === vm.editCard._id; });
          if(msrCard){
            var msrCardIndex = vm.resultCardArray.indexOf(msrCard);
            vm.editCard.meta.showCard = angular.copy(vm.resultCardArray[msrCardIndex].meta.showCard);
            vm.resultCardArray[msrCardIndex] = angular.copy(vm.editCard);
          }
          var selectId = vm.resultCardArrayObj.findIndex(function(item){ return item._id === vm.editCard._id; });
          vm.resultCardArrayObj[selectId] = angular.copy(vm.editCard);
        }

        $rootScope.loadingDetails = false;
        util.isCallingApi = false;
        vm.cancelDialog();
        vm.fnCardFilter();
        util.showToast('Card updated successfully');
      }, function (error) {
        $rootScope.loadingDetails = false;
        util.isCallingApi = false;
        util.showToast(util.displayValidationError(error));
        $log.log(error);
      });
    }

    // confirmation if card is in quote
    function showCardRemoveFromQuote(ev, cardData, action) {
      var confirm = $mdDialog.confirm()
        // .title('Warning')
        .textContent('This change will remove card from your quote section, do you want to continue?') //add msg
        .ariaLabel('discard')
        .targetEvent(ev)
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        if (action == 'editCard') {
          vm.removeFromQuote(cardData);
          vm.openEditCardModal(cardData, ev);
        } else if (action == 'deleteCard') {
          vm.removeFromQuote(cardData);
          vm.fnDeleteData();
        }
      }, function () {
        return true;
      });
    }

    //open delete card modal -ankita
    function openDeleteCard(card, ev) {
      vm.deleteLeg = card;
      if (vm.quoteArray.length && vm.quoteArray.includes(card._id)) {
        vm.showCardRemoveFromQuote(ev, card, 'deleteCard');
        return;
      }
      vm.deleteType="Rate Card"
      $mdDialog.show({
        templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm }
      });
    }

    //function to delete card - ankita - 23/5/18
    function fnDeleteData() {
      vm.deleteBtn = true;
      util.isCallingApi = true;
      if(!vm.quoteArray.length){
        vm.resultCardFilter.hideBookBtn = false;
      }
      resultService.deleteCard(vm.result_id, vm.deleteLeg._id).then(function (response) {

        var msrIndex = vm.allRatesArrayCopy[0].data.cards.indexOf(vm.deleteLeg);
        vm.allRatesArrayCopy[0].data.cards.splice(msrIndex, 1);

        var resultIndex = vm.resultCardArray.indexOf(vm.deleteLeg);
        vm.resultCardArray.splice(resultIndex, 1);

        var card = vm.resultCardArrayObj.find(function (obj) { return obj._id === vm.deleteLeg._id; });
        if(card){
          var cardIndex = vm.resultCardArrayObj.indexOf(card);
          vm.resultCardArrayObj.splice(cardIndex, 1);
        }

        var card = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === vm.deleteLeg._id; });
        if(card){
          var cardIndex = vm.allRatesArray[0].data.cards.indexOf(card);
          vm.allRatesArray[0].data.cards.splice(cardIndex, 1);
        }

        var rates = vm.allRatesArray[0].data.rates[vm.deleteLeg.data.buy_rates.l3_fcl.rate_obj._id];
        if(rates){
          delete vm.allRatesArray[0].data.rates[vm.deleteLeg.data.buy_rates.l3_fcl.rate_obj._id];
        }

        util.showToast('Card deleted successfully');
        vm.deleteBtn = false;
        vm.cancelDialog();

        var viewFilter = 0;
        angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
          if(allRatesArray.data.cards.length){
            viewFilter ++;
          }
        });

        vm.fnCardFilter();

        if(!viewFilter){
          vm.viewDirectFilter = false;
        }
        util.isCallingApi = false;

      }, function (error) {
        $log.log(error);
        util.showToast(util.displayValidationError(error));
        vm.deleteBtn = false;
        util.isCallingApi = false;
      });
    }

    function confirmDeleteCharge(sellKey, sellRate, index, action) {
      vm.chargeDelete = true;
      vm.legDelete = false;
      vm.deleteChargeBtn = false;

      vm.legKeyName = sellKey;
      vm.deleteChargeLeg = sellRate;
      vm.chargeIndex = index;

      vm.deleteChargeLineObj = vm.deleteChargeLeg.charges[index];
      vm.isQuoteOrCard = action;
      if ((vm.deleteChargeLeg.charges[index].charge_name == null || vm.deleteChargeLeg.charges[index].charge_name == "") && sellKey != 'l3_fcl' && vm.deleteChargeLeg.charges.length != 1) {
        vm.fnDeleteNewCharge();
      }
      else {
        vm.currentPage = 'result';
        $mdToast.show({
          hideDelay: false,
          position: 'top right',
          controllerAs: 'ctrl',
          controller: function () { this.parent = vm },
          templateUrl: 'app/main/result/Dialogs/delete-charge/delete-charge.html'
        });
      }
    }

    //function to delete charge
    function fnDeleteNewCharge() {
      vm.validationObj={
        "chargeNameValidation":false,
        "chargeBasicValidation":false,
        "chargeUnitValidation":false,
        "chargeContainerValidation":false,
        "chargeCurrencyValidation":false,
        };
      vm.deleteChargeBtn = true;
      var sellObj = vm.deleteChargeLeg;
      var index = vm.chargeIndex;
      sellObj.leg_currency_cost -= sellObj.charges[index].leg_currency_cost;
      sellObj.leg_total_cost -= sellObj.charges[index].customer_currency_cost;
      sellObj.charges.splice(index, 1);

      if (vm.is_delete_l3_leg) {
        $mdToast.hide();

        index = vm.quoteArray.indexOf(vm.ScheduleCard._id);
        if (index > -1) {
          vm.quoteArray.splice(index, 1);
          vm.ScheduleCard.meta.is_selected = false;
          vm.ScheduleCard.data.sell_rates = null;
          vm.selectedCard.pop(vm.ScheduleCard);
        }

        $mdDialog.hide();
        return;
      }
      $mdToast.hide();
    }

  // ********** End create new card feature ************

  // ************ match rates/RFQ module *************
    vm.matchRatesObj = {
      "search_param" : SearchService.FclResult.result_meta.search_param,
      "id" : SearchService.FclResult._id,
      "match_rates" : SearchService.FclResult.match_rates,
      "additional_charges" : {
            "selected" : [],
            "available" : []
      }
    }

    // Funtion to open RFQ form modal
    function fnOpenMatchRatesModal(ev){

      $mdDialog.show({
        template: '<md-dialog id="wls-match-rates" class="popup-md"><match-rates matchratesparam="ctrl.parent.matchRatesObj" callback="ctrl.parent.fnMatchRatesCall()"></match-rates></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () { this.parent = vm },
        controllerAs: 'ctrl',
      });
    }

    // Funtion to open RFQ form modal
    function fnOpenRFQModal(ev){
      vm.makeDetailBoxString(vm.initial_search_param);
      vm.tempRfqObj = angular.copy(vm.rfqObj);
      $mdDialog.show({
        template: '<md-dialog id="nwls-request-for-quote" class="popup-md"><nwls-request-for-quote class="dialog-height" rfqdata="ctrl.parent.rfqComponentObj" callback="ctrl.parent.rfqCallBack(action)"></nwls-request-for-quote></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        parent: $rootElement,
        scope: $scope,
        preserveScope: true,
        controller: function () { this.parent = vm },
        controllerAs: 'ctrl',
      });
    }

    // check update search or additional services
    function checkToUpdate(ev, action) {
      if (vm.curr_vas_leg_arr.length) {
        var confirm = $mdDialog.confirm()
          // .title('Warning')
          .textContent('Any changes you have made will be lost, do you want to continue?') //add msg
          .ariaLabel('discard')
          .targetEvent(ev)
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function () {
          // vm.isVasApplied = false;
          if (vm.quoteArray.length) {
            if (action == 'betterRates') {
              vm.showConfirm(ev, 'betterRates');
            }
          } else {
            if (action == 'betterRates') {
              vm.fnFindBetterRates()
            }
          }
        }, function () {
          return;
        });
      } else {
        if (vm.quoteArray.length) {
           if (action == 'betterRates') {
            vm.showConfirm(ev, 'betterRates');
          }
        } else {
          if (action == 'betterRates') {
            vm.fnFindBetterRates()
          }
        }
      }

    }

    // confirmation to discard result changes
    function showConfirm(ev, action) {
      var confirm = $mdDialog.confirm()
        // .title('Warning')
        .textContent('Any changes you have made will be lost, do you want to continue?')
        .ariaLabel('discard')
        .targetEvent(ev)
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        if(action == 'betterRates'){
          vm.fnFindBetterRates()
        }
      }, function () {
        return true;
      });
    }

    function fnFindBetterRates(){
      vm.allRatesArrayCopy = angular.copy(vm.allRatesArray);
      vm.fnCardSorting();
      vm.fnCardFilter();
      vm.quoteArray = [];
      vm.selectedCard = [];
      vm.resultCardFilter.hideBookBtn = false;
      // $timeout(function ( ) {
      vm.rfqComponentObj.isBetterRates = true;
      // vm.viewDirectFilter = false;
      // }, 50);

      vm.fnOpenRFQModal();
    }

    function rfqCallBack(action){
      if(action == 'closeRfq'){
        vm.rfqComponentObj.isBetterRates = false;
        vm.viewDirectFilter = true;
      }
    }

  // ************ End match rates/RFQ module *************

    //callback function from card component
    function showQuoteProceedDiv(item){
      vm.isCardChanges = true;
      if(item.action == 'addInToQuote'){
        if (!vm.quoteArray.includes(item.currentCard._id)) {
          if(item.currentCard.data.buy_rates.l3_fcl.rate_obj.booking_status && item.currentCard.data.buy_rates.l3_fcl.rate_obj.booking_status.code == 1002){
            vm.waitingListCount++;
        }
          vm.quoteArray.push(item.currentCard._id);
          vm.selectedCard.push(item.currentCard);
        } else {
          var replaceCard = vm.selectedCard.find(function(card){ return card._id === item.currentCard._id; });
          if(replaceCard){
            var index = vm.selectedCard.indexOf(replaceCard);
            vm.selectedCard[index] = item.currentCard;
          }
        }
        vm.resultCardFilter.hideBookBtn = true;
        vm.resizeScreenSize();
      }
      else if(item.action == 'removeFromQuote'){
        vm.removeFromQuote(item.currentCard);

        if(!vm.quoteArray.length){
          vm.resultCardFilter.hideBookBtn = false;
          vm.resizeScreenSize();
        }
      }
      else if( item.action == 'bookingRequest'){
        vm.requestToBook(item.currentCard,item.index);
      }
      else if( item.action == 'deleteCharge' ){
        var index = vm.quoteArray.indexOf(item.currentCard._id);
        if (index > -1) {
          vm.quoteArray.splice(index, 1);
          item.currentCard.meta.is_selected = false;
          item.currentCard.data.sell_rates = null;
          vm.selectedCard.pop(item.currentCard);
        }
      }
      else if( item.action == 'scheduleSelect'){
        $timeout(function(){ item.currentCard.meta.isScheduleCall = true; },100);
        var cardObj = vm.selectedCard.find(function(card){ return card._id === item.currentCard._id; });
        if (cardObj) {
          cardObj.meta.selected_schedule = item.currentCard.meta.selected_schedule;
          cardObj.meta.multi_schedule_list = item.currentCard.meta.multi_schedule_list || [];
        }
        // co2e for selected schedule
        // vm.fnSheduleCo2(item.currentCard.data.buy_rates.l3_fcl.rate_obj, item.currentCard.meta);
        // item.currentCard.meta.sailing_date = item.currentCard.meta.selected_schedule.departure_time;
      }
      else if( item.action == 'manualCardDelete'){
        vm.openDeleteCard(item.currentCard);
      }
      else if( item.action == 'manualCardEdit' ){
        vm.openEditCardModal(item.currentCard);
      }
      else if( item.action == "addRate" ){
        vm.fnSubmitLegData(item.currentCard, 'addLeg');
      }
      else if( item.action == "editRate" ){
        vm.fnSubmitLegData(item.currentCard, 'editLeg');
      }
    }
   
  function fndownloadQuote(){
    util.callMixpanel("RR-DowanloadRates-Click",{
      "Mode": vm.search_param.mode
    });
      resultService.dwnloadpdf(vm.search_param,vm.selectedCard);
  }
  
   //return respons
    // on screen size hide list view
    function resizeScreenSize() {
      vm.resultCardFilter.deviceName = util.resizeScreen(vm.resultCardFilter.deviceName);
      $timeout(function(){
        if(angular.element(document.querySelector('.search-edit-div'))[0]){
          var searchDivHeight = angular.element(document.querySelector('.search-edit-div'))[0].offsetHeight;
          vm.extraDivHeight = searchDivHeight;

          vm.countMarginTop = { 'top' : searchDivHeight + 'px'};
          vm.leftFilterTopMargin = { 'position' : 'sticky', 'top' : searchDivHeight + 'px' };
          if(vm.extraDivHeight == 0){
            vm.isStikyFilter = true;
          }
        }
      }, 200)
    }
    window.onresize = vm.resizeScreenSize;

    // page scroll upto top
    vm.scrollTop = scrollTop;
    function scrollTop(){
      angular.element("#content").animate({
        scrollTop: 0
      }, 300);
      return false;
    }

    // hide toolbar on scroll
    function onScrollAction() {
      if(vm.isStikyFilter == true){
          vm.resizeScreenSize();
          vm.isStikyFilter = false;
      }
      if(vm.isDestroy !== true ){

        var raw = document.querySelector('#content');
        if (raw.scrollTop > document.getElementById("toolbar-navigation-container").offsetHeight) {
          document.querySelector('#result-return-to-top') ? document.querySelector('#result-return-to-top').classList.remove('hide') : '';
          // document.querySelector('#toolbar-navigation-container').classList.add('hide');
        }else{
          document.querySelector('#result-return-to-top') ? document.querySelector('#result-return-to-top').classList.add('hide') : '';
          // document.querySelector('#toolbar-navigation-container').classList.remove('hide');
        }
      }
    };

    this.$onInit = function() {
      vm.isScrollBind = true;
      document.querySelectorAll("#toolbar-navigation-container")[0].style.top = 'auto';
      angular.element(document.querySelector('#content')).bind('scroll', function(){
        vm.onScrollAction();
        if(!util.isMobileDevice && vm.leftFilterTopMargin){
          if($('#content').height() < $('.filter-container').height()){
            vm.leftFilterTopMargin.top = $('#content').height()-$('.filter-container').height()+'px';
          }
        }
      })

      //for zoom detection
      // window.visualViewport.addEventListener("resize", viewportHandler);
      // function viewportHandler(event) {
      //   var browserZoomLevel = Math.round((window.devicePixelRatio * 100)/2);
      //   vm.mdVirtiualHeight = Math.round($('.filter-container').height() + 100);
      // }
    }

    $scope.$on('$destroy', function() {
      document.querySelectorAll("#toolbar-navigation-container")[0].style.top = 0;
      // if(document.querySelector('#toolbar-navigation-container').classList.contains('hide')){
      //   document.querySelector('#toolbar-navigation-container').classList.remove('hide');
      // }
      vm.isDestroy = true;
      vm.scrollTop();
    });

    // event to bind for unload
    $window.onbeforeunload = function (e) {
      if ($location.url().indexOf('result') !== -1) {
        return false;
      };
    }

    vm.inquiry_number = "";
    vm.reference_number = "";
    vm.inquiry_id = "";
    vm.isInquiryCreated = false;
    function fnGetPoolingData(){
      resultService.getPoolingData('search', vm.result_id).then(function (response) {
        vm.poolingData = response.data;
        vm.inquiry_number = vm.poolingData.inquiry_number;
        vm.reference_number = vm.poolingData.reference_number;
        vm.inquiry_id =  vm.poolingData._id;
        if(vm.inquiry_number) {
          clearInterval(vm.autoUpdate);
          vm.isInquiryCreated = true;
          util.showToast('INQUIRY - '+vm.inquiry_number+' has been created for your Search');
        }else if($state.current.name != 'app.search.result'){
          clearInterval(vm.autoUpdate);
        }else{
          vm.autoUpdate = $timeout(fnGetPoolingData, 10000);
        }

      }, function (error) {
        vm.isInquiryCreated = true;
        $log.error(error);
      });
    }

    // error scroll functions
    function fnScrollBtn(side, index){
      if(side == 'left'){
        angular.element("div.apiErrSect").animate({scrollLeft: angular.element('div.apiErrSect').scrollLeft() - 300}, 400);
      }else if(side == 'right'){
        angular.element("div.apiErrSect").animate({scrollLeft: angular.element('div.apiErrSect').scrollLeft() + 300}, 400);
      }
    }

    function removeErrorMessage(index) {
      var tempObj = vm.apiErrMsgList;
      tempObj.splice(index, 1);
    }

    function trackAnalytics(type, item) {
      if(type === "AllInQuote") {
        util.callMixpanel("RR-Allin-Change",{
          "QuoteType" : item
        });
      }
    }
    function fnDialogSwitchToRateCard(ev) {
        if(vm.viewMode === ev){
        return;
        }
        if(!vm.isCardChanges){
          vm.fnSwitchMode(ev)
          return;
        }
        vm.leaveType = "rateCardViewSwitch";
        vm.modeChanges = ev;
        $mdDialog.show({
            templateUrl        : 'app/main/component/rate-card-table/confirm-leave/confirm-leave.html',
            targetEvent        : ev,
            clickOutsideToClose: true,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
        });
    }
    function fnSwitchMode(viewMode){
      util.isCallingApi = true;
      if(vm.isCardChanges){
        vm.fnCancelQuote();
        $scope.$broadcast('clearCardFilter');
      }
      vm.isCardChanges = false;
      if(vm.viewMode === 'enterprise'){
        vm.selected_filter_obj.selected_rateType = "All";
        vm.resultService.triggerDatatableButton('resetFilter', null)
      }
      $timeout(function () {
        $mdDialog.hide();
        vm.viewMode = viewMode;
        if(vm.viewMode === 'card'){
          util.isCallingApi = false;
          vm.isExpandElTable = false;
          fnExpandContainer('removeClass');
        }
      },20);
    }

    function fnRateCardTable(payload){
      if(payload.linerFilterChange){
        vm.selected_filter_obj.selected_rateType = "All";
      }
      if(payload.action === 'filterUpdate' || payload.action === 'selectRow'){
        vm.isCardChanges = true;
      }else{
        vm.showQuoteProceedDiv({'currentCard' :payload.currentCard, 'action' : payload.action });
      }
    }
      
    function fnChangeTableMode(tableType){
      util.isCallingApi = true;
      $timeout(function () {
        vm.tableDisplayMode = tableType;
        util.isCallingApi = false;
      },100);
    }

    function trackEvent(event,mixpanelObj){
      util.callMixpanel(event,mixpanelObj);
    }

    function exportExcelEl(buttonClass){
      util.isCallingApi = true;
      $timeout(function () {
        vm.resultService.triggerDatatableButton(buttonClass, null);
      });  
    }
    function expandEnterpriseTable(){
      vm.isExpandElTable =  vm.isExpandElTable === false ? true : false;
      fnExpandContainer(vm.isExpandElTable === true ? 'addClass' : 'removeClass');
    }

    function fnExpandContainer(actionClass){
      angular.element('#result-page .layout-styles:first')[actionClass]('expand-layout-styles');
      angular.element('#result-page .search_meta')[actionClass]('hide');
   }
    function selectAllColumn(){
      vm.visibleColumnList.columnsList.forEach(function(column){
        if(!column.isActive){
          column.isActive = true;
          resultService.triggerDatatableButton('.buttons-columnVisibility',column);
        }
      })
      vm.visibleColumnList.columnsHide = 0;
    }

    // **** CO2E feature start ******
    function co2Init(){
      vm.co2Payload = {
        "containers": resultService.searchLoadState,
        "routesData": []
      }

      vm.resultCardFilter.co2eResponse = {};
      vm.util.co2ApiLoaded = $rootScope.domainData.domain_info.ENABLE_CO2E && vm.search_param.search_type =='P2P' && vm.search_param.enable_co2e? false : true; // co2e data get only if domain key is true
    }

    function fnCallCo2Api(){
      if(!$rootScope.domainData.domain_info.ENABLE_CO2E || vm.search_param.search_type !='P2P' || !vm.search_param.enable_co2e){
        vm.resultCardFilter.countApiCard--;
        return true;
      }
      
      vm.util.co2ApiLoaded = false;
      var payloadObj = {
        "data" : vm.co2Payload
      };
      resultService.fnCo2ApiCall(payloadObj,vm.search_param.mode).then(function (response) {
        vm.resultCardFilter.co2eResponse = response.data;
        // calculate container wise total and co2e total
        resultService.fnCalculateCo2Total(vm.resultCardFilter.co2eResponse, vm.search_param.load_data.load_details_value);
        vm.util.co2ApiLoaded = true;
        vm.resultCardFilter.countApiCard--;
        vm.setInAllRatesArray();
        vm.fnSetResultMixpanel();

      },function(error){
        vm.util.co2ApiLoaded = true;
        vm.resultCardFilter.countApiCard--;
        vm.fnSetResultMixpanel();
        $log.log(error.data);
      });
    }

    // set co2e in respective card meta
    function fnSetCo2InCard(rate_obj, meta, origin , destination){
      if(!vm.resultCardFilter.co2eResponse || !Object.keys(vm.resultCardFilter.co2eResponse).length ){
        return;
      }
         var carrierCode = rate_obj.provider && rate_obj.provider.carrier_code ? rate_obj.provider.carrier_code : rate_obj.sub_vendor.carrier_code;
         var co2ForCarrier = vm.resultCardFilter.co2eResponse[carrierCode];
         if(co2ForCarrier && co2ForCarrier.length){
          for(var i = 0; i < co2ForCarrier.length; i++){
            if((co2ForCarrier[i].origin === origin ) && (co2ForCarrier[i].destination === destination) && co2ForCarrier[i].container_emissions.length){
              meta["co2eData"] = angular.copy(co2ForCarrier[i]);
            }
          }
        }
    }

    // function fnSheduleCo2(rate_obj, meta){

    //   if(!meta.selected_schedule){ return; }

    //     meta["co2eData"] = null;
    //     vm.fnSetCo2InCard(rate_obj, meta, meta.selected_schedule.origin_port, meta.selected_schedule.destination_port);

    //     if(!meta["co2eData"]){
    //       // empty routesData for schedule payload
    //       vm.co2Payload.routesData = [];
    //       var porPair = {
    //         "origin" : meta.selected_schedule.origin_port,
    //         "destination" : meta.selected_schedule.destination_port
    //       }
    //       resultService.fnSetCo2Payload(rate_obj, porPair, vm.co2Payload);


    //       var payloadObj = {
    //         "data" : vm.co2Payload
    //       };
    //       resultService.fnCo2ApiCall(payloadObj,vm.search_param.mode).then(function (response) {
    //         var co2eData = response.data;
    //         if(!co2eData || !co2eData[rate_obj.sub_vendor.carrier_code].length){
    //           return;
    //         }

    //         if(vm.resultCardFilter.co2eResponse && Object.keys(vm.resultCardFilter.co2eResponse).length){
    //           Object.assign(vm.resultCardFilter.co2eResponse,co2eData);
    //         }else{
    //           vm.resultCardFilter.co2eResponse = co2eData;
    //         }
            
    //         // calculate container wise total and co2e total
    //         resultService.fnCalculateCo2Total(co2eData, vm.search_param.load_data.load_details_value);
            
    //         vm.fnSetCo2InCard(rate_obj, meta, meta.selected_schedule.origin_port, meta.selected_schedule.destination_port);
    //       },function(error){
    //         $log.log(error.data);
    //       });
    //     }

    // }
    // **** CO2E feature end ******
 
    function setInAllRatesArray(){
      angular.forEach(vm.allRatesArray, function(allRatesArray){
        if(allRatesArray.data.cards.length){
          angular.forEach(allRatesArray.data.cards, function(card){
            vm.fnSetCo2InCard(card.data.buy_rates.l3_fcl.rate_obj, card.meta, card.meta.port_data.origin_port_code, card.meta.port_data.destination_port_code);
            vm.setXenetaInCardMeta(card.meta, card.data.buy_rates);
          });
        }
      });
    }

    vm.redirectToQuote = redirectToQuote;
    vm.redirectToStandardQuotation = redirectToStandardQuotation;
    function emptyRatesFilter(){
      $rootScope.$emit('emptyRates', vm.hideRates);
    }
    function redirectToQuote(selectedCards){
      if(selectedCards && selectedCards.length){
        resultService.refreshQuoteData.selectedCards = selectedCards;
      }
      resultService.refreshQuoteData.from_quote_search_param=vm.search_param;
      resultService.refreshQuoteData.quote_id = vm.search_param.quote_id;
      resultService.refreshQuoteData.quote_number = vm.search_param.quote_number;
      if(vm.search_param.source=='quote'){
        $state.go("app.quotes.quotesDetails", {
          id: vm.search_param.quote_id,
        });
      }else if(vm.search_param.source=='copy_quote'){
        $state.go('app.CopyQuoteDetailsController',{ id: vm.search_param.quote_id});
      }else if(vm.search_param.source=='create_quote'){
        $state.go("app.CreateQuotesController",
        { 
          mode: vm.search_param.mode,
          id: vm.search_param.quote_id
        });
      }
      
    }

    function redirectToStandardQuotation(){
      vm.quoteDetails = shareQuoteService.fnInitializeQuoteDetails(vm.filterConfig.l2_fcl_cha.is_selected, vm.filterConfig.l4_fcl_cha.is_selected);
      var data= {
          "source":'result',
          "cards": vm.selectedCard,
          "currency_conversion_rates": vm.resultCardFilter.currency_conversion_rates,
          "search_param": vm.search_param,
          "search_id": vm.result_id,
          "start_date": vm.quoteDetails.start_date,
          "expiry_date": util.dateReplace(shareQuoteService.fnValidateExpiryDate(vm.selectedCard,vm.search_param.cargo_ready_date, vm.l3_leg)),
          "customs": vm.quoteDetails.customs,
          "perishable": vm.quoteDetails.perishable,
          "cc_emails" : vm.quoteDetails.cc_emails,
          "hazardous": vm.quoteDetails.hazardous,
          "send_mail": vm.quoteDetails.send_mail,
          "co2e" : vm.quoteDetails.co2e,
          "generate_pdf": vm.quoteDetails.generate_pdf,
          "print_schedule" : vm.quoteDetails.print_schedule,
          "show_zero_sell_rates" : vm.quoteDetails.show_zero_sell_rates,
          "carrier_mask_for_shipper": $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER && $rootScope.domainData.domain_info.MASKING_CHECK_BOX.checked_state,
          "incoterms": vm.search_param.incoterms ? vm.search_param.incoterms : null,
          "pdf_preferred_language": "en",
          "impo_expo": vm.search_param.impo_expo ? vm.search_param.impo_expo : null,
          "terms": vm.termsAndConditions,
          "all_in_quote_setting": vm.all_in_quote_setting,
          "is_duplicate_quote": false,
          "parent_quote_id": null,
          "generate_quote_type": vm.generate_quote_type,
          "number_formats":$rootScope.number_format,
          "activity" : [
            {
            "message": 'Quotation Created' ,
            "type": "quote_created",
            "timestamp": new Date(),
            "user_id": util.userProfile.user.id,
            "user_name": util.userProfile.user.user_first_name + ' '+ util.userProfile.user.user_last_name,
            "activity_data": {}
            }
          ],
          "additional_charges" : {
              "selected" : vm.vas_details ? vm.vas_details.legList : [],
              "available" : vm.vas_details ? vm.vas_details.value_added_charges : []
          }
      }
      util.standardQuotationData = data;
      $state.go('app.standardQuotation');
    } 

    function fnOpenFreightIndex(ev){
      util.callMixpanel("RR-FreightIndex-Click",{ "Mode": vm.search_param.mode });
      if(vm.isMultiPort){
        vm.search_param.user_nearby_origin.forEach(function(item){
          vm.search_param.user_nearby_destination.forEach(function(item1){
            vm.DashboardFilterData.push(item.global_port_code+"_"+item1.global_port_code);
          })
        })
      }
      else{
        var origin = vm.search_param.origin_location.global_port_code;
        var destination = vm.search_param.destination_location.global_port_code;
        vm.DashboardFilterData = [origin+"_"+destination];
      }
      $mdDialog.show({
        template: '<md-dialog class="ViewModal popup-lg"> <md-dialog-content flex="100"> <databrain-component dashboard-name="Freightify Freight Index" dashboard-id="Index_contract" dashboard-filter-data="ctrl.parent.DashboardFilterData"></databrain-component> </md-dialog-content><md-dialog-actions><div class="footer freight-index-footer"> <div><div class="edit_btn h-40 brad-5 p-15 pointer md-accent-btn with-icon" layout="row" ng-click="ctrl.parent.fnCloseFreightIndex()" layout-align="center center">Close</div></div></div></md-dialog-actions></md-dialog>',
        targetEvent: ev,
        clickOutsideToClose: false,
        controllerAs: 'ctrl',
        controller: function () { this.parent = vm },
      });
    }

    function fnCloseFreightIndex(){
      $mdDialog.hide();
    }

    // **** Xeneta rate index start ******
    function RateIndexInit(){

      if(vm.isMultiPort && vm.search_param.user_nearby_origin.length > 1 && vm.search_param.user_nearby_destination.length > 1){
        vm.FreightIndex = false;
      } 

      if(util.isShipper || !vm.FreightIndex || !vm.resultCardArray.length){
        vm.resultCardFilter.countApiCard--;
        return true;
      }

      var to = new Date(vm.search_param.cargo_ready_date) > new Date() ? moment(new Date()).format('YYYY-MM-DD') : vm.search_param.cargo_ready_date;
      var from = moment(to).subtract(30, 'day').format('YYYY-MM-DD');

      vm.rateIndexPayload = {
        "containers": resultService.searchLoadState,
        "routes": [],
        "from": from,
        "to": to, // 30 days back from cargo date
        "thcMethodology": "meth" 
      }

      if(vm.isMultiPort){
        vm.search_param.user_nearby_origin.forEach(function(item){
          vm.search_param.user_nearby_destination.forEach(function(item1){
            vm.rateIndexPayload.routes.push({"origin":item.global_port_code,"destination":item1.global_port_code});
          })
        })
      }
      else{
        var origin = vm.search_param.origin_location.global_port_code;
        var destination = vm.search_param.destination_location.global_port_code;
        vm.rateIndexPayload.routes = [{"origin":origin,"destination":destination}];
      }

      var payloadObj = {
        "data" : vm.rateIndexPayload
      };

      resultService.fnXenetaRateCall(payloadObj, vm.userVendorID, vm.result_id, 'both').then(function (response) {
        vm.xenetaRateIndexResponse = response.data;
        vm.resultCardFilter.countApiCard--;
        vm.setInAllRatesArray();
        vm.fnSetResultMixpanel();

      },function(error){
        vm.resultCardFilter.countApiCard--;
        vm.fnSetResultMixpanel();
        $log.log(error.data);
      });
    }

     // match origin_port, destination_port, rate_type and if charge has basic_ocean_freight preference 20 GP
    function setXenetaInCardMeta(cardMeta, buyRates){
      if(!vm.xenetaRateIndexResponse || !Object.keys(vm.xenetaRateIndexResponse).length ){
        return;
      }

      // check bbasis which has container type ennabled
      var equipmetBaseBasis = ['per equipment', 'per kg', 'per ton', 'per kg', vm.constObj.PICKUP_BASIS, vm.constObj.DELIVERY_BASIS, vm.constObj.FREIGHT_BASIS];
      var consideredLegs = ['l3_fcl', 'l2_fcl', 'l4_fcl']; // consider only l3_fcl, l2_fcl and l4_fcl leg to calculate xeneta rate 
      var rateType = cardMeta.type.includes('spot') ? 'spot' : 'contract';
      var totalContainerChargesCost = 0;
      var rateCount = 0;
                var xenetaRateArray = [];

      if(!cardMeta.isError){
      var legCode = buyRates.l3_fcl && buyRates.l3_fcl.rate_obj && buyRates.l3_fcl.rate_obj.charges.length ? 'l3_fcl' : 
        (buyRates.l2_fcl && buyRates.l2_fcl.rate_obj && buyRates.l2_fcl.rate_obj.charges.length ? 'l2_fcl' : 
        (buyRates.l4_fcl && buyRates.l4_fcl.rate_obj && buyRates.l4_fcl.rate_obj.charges.length ? 'l4_fcl' : ''));

      var containerType = legCode && Object.keys(buyRates[legCode].rate_obj.load_stat).find(function(key){ 
        return buyRates[legCode].rate_obj.load_stat[key] === 1;
      });

      // Currency conversion setting code
      shareQuoteService.setCurrencyConvSetting(vm.search_param.user.user_base_currency, cardMeta.conversionRate.markup, cardMeta.conversionRate.directCurrencyMapping, cardMeta.conversionRate.curr_data);

      if(rateType && containerType){

        angular.forEach(buyRates, function (buy_value, buy_key) {
          if(consideredLegs.includes(buy_key) && buy_value.rate_obj && buy_value.rate_obj.charges.length){

            angular.forEach(buy_value.rate_obj.charges, function (childValue) {
              if(equipmetBaseBasis.includes(childValue.charge_basis.toLowerCase()) && childValue.container_type === containerType){
                rateCount ++;
                totalContainerChargesCost += vm.shareQuoteService.currencyConverter.convert(parseFloat(childValue.charge_cost),childValue.charge_currency, 'USD', false);
              }
            });
          }
        });
      

        if(rateCount && vm.xenetaRateIndexResponse[rateType] && vm.xenetaRateIndexResponse[rateType].length){
          for(var i = 0; i < vm.xenetaRateIndexResponse[rateType].length; i++){
            
            var rateIndexMeta = vm.xenetaRateIndexResponse[rateType][i].meta;

            if( (cardMeta.port_data.origin_port_code === rateIndexMeta.actual_origin.location && cardMeta.port_data.destination_port_code === rateIndexMeta.actual_destination.location) || 
               (cardMeta.port_data.origin_port_code === rateIndexMeta.asked_origin.location && cardMeta.port_data.destination_port_code === rateIndexMeta.asked_destination.location) ){

                xenetaRateArray.push(vm.xenetaRateIndexResponse[rateType][i]);

                if(vm.xenetaRateIndexResponse[rateType][i].container_type === containerType && !cardMeta.isError){
                  var xenetaRateAverage = {};

                  xenetaRateAverage["containerType"] = containerType;
                  // calculate Average of mean array
                  xenetaRateAverage["value"] = vm.fnGetAverage(vm.xenetaRateIndexResponse[rateType][i].market_rates_by_day["mean"]);

                  // calculate % of Average = ( (sum of L2/L3/L4 container charge cost (USD conversion) - XenetaMean)/XenetaMean) * 100
                  xenetaRateAverage["percentage"] = ( ((totalContainerChargesCost - xenetaRateAverage.value) / xenetaRateAverage.value) *100).toFixed(2);

                  xenetaRateAverage["displayText"] = Math.abs(xenetaRateAverage.percentage) +'% '+ (xenetaRateAverage.percentage > 0 ? "Higher" : "Lower") +' than Market';

                  xenetaRateAverage["textColor"] = xenetaRateAverage.percentage > 0 ? "#F43F5E" : "#10B981";

                  xenetaRateAverage["bgColor"] = xenetaRateAverage.percentage > 0 ? "#FFE4E6" : "#D1FAE5";

                  cardMeta["xenetaRateAverage"] = angular.copy(xenetaRateAverage);
                }
            }
          }
        }
        
      }
    }
      else{
           var xenetaRateArray = [];
           var totalMean = 0;
            if(vm.xenetaRateIndexResponse[rateType] && vm.xenetaRateIndexResponse[rateType].length){

            for (var i = 0; i < vm.xenetaRateIndexResponse[rateType].length; i++) {
              var rateItem = vm.xenetaRateIndexResponse[rateType][i];
              var rateIndexMeta = rateItem.meta;

              var isMatch =
                (cardMeta.port_data.origin_port_code === rateIndexMeta.actual_origin.location &&
                cardMeta.port_data.destination_port_code === rateIndexMeta.actual_destination.location) ||
                (cardMeta.port_data.origin_port_code === rateIndexMeta.asked_origin.location &&
                cardMeta.port_data.destination_port_code === rateIndexMeta.asked_destination.location);

              if (isMatch) {
                xenetaRateArray.push(rateItem);

                // Accumulate mean average values
                totalMean += vm.fnGetAverage(rateItem.market_rates_by_day["mean"]);
              }
            }

            if (xenetaRateArray.length > 0) {
              var xenetaRateAverage = {};

              xenetaRateAverage["containerType"] = "";
              xenetaRateAverage["value"] = totalMean / xenetaRateArray.length;
              xenetaRateAverage["displayText"] = 'Average: USD ' + Math.abs(xenetaRateAverage.value).toFixed(2);
              xenetaRateAverage["textColor"] = "#4B5563";
              xenetaRateAverage["bgColor"] = "#F3F4F6";

              cardMeta["xenetaRateAverage"] = angular.copy(xenetaRateAverage);
            }

                  
          }
    }
              cardMeta["xenetaRateArray"] = angular.copy(xenetaRateArray);

  }

    // calculate Average
    function fnGetAverage(meanArray){
      var result = 0;
      var validCount = 0;
      for(var i = 0; i < meanArray.length; i++){ 
        if(meanArray[i].value !== null && meanArray[i].value !== undefined && meanArray[i].value !== ''){
          result += parseInt(meanArray[i].value);
          validCount++;
        }
      }

      var average = validCount > 0 ? result / validCount : 0;
      average = parseFloat(average.toFixed(5));
      return average;
    }


  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.result')
        .controller('AirResultController', AirResultController);

    /** @ngInject */
    function AirResultController($mdToast,$state, $mdSidenav, $log, $mdDialog, $filter, $window, resultService,util, localStorageService,$rootScope, SearchService, $timeout,$location, shareQuoteService, $scope,analytics,$rootElement, appCache , DashboardService)
    {
      var vm = this;
      vm.util = util;
      vm.deleteType="";
      vm.ShipperMaskLiner=$rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER;
      vm.maskLiner=(util.isShipper && vm.ShipperMaskLiner)
      vm.resultService = resultService;
      vm.shareQuoteService = shareQuoteService;
      util.isCallingApi = false;
      vm.isAddNewRateLoaded=false;
      $rootScope.loadingDetails = false;
      vm.mainFreightNameChange = $rootScope.isJeenaDomain;
      vm.mainFreightName = 'Main Freight';
      vm.isStikyFilter = false;
      vm.shipperSearchLimitError = "";
      vm.result_id = SearchService.AirResult._id;
      vm.search_param = SearchService.AirResult.result_meta.search_param;
      vm.maskLinerText=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_TEXT : "";
      vm.maskAirline=(vm.maskLiner && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR)? $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER_LOGO_AIR : '';
      vm.isMultiPort = $rootScope.domainData.domain_info["ALLOW_MULTI_PORT_PAIR"];
      vm.isNetworkRates = vm.search_param.fetch_network_rates;
      vm.isNearbyPorts = vm.search_param.fetch_nearby_port_data;
      vm.hideRatesOptions = [{label:"Hide Empty Cards",value:'hideEmptyRates'},{label:"Show Empty Cards",value:'showEmptyCards'}];
      vm.hideRates = 'showEmptyCards';
      vm.emptyRatesFilter =emptyRatesFilter;
      vm.resultCardFilter = {
        'currency_conversion_rates' : SearchService.AirResult.result_meta.currency_conversion_rates,
        'hideBookBtn' : false,
        'deviceName' : 'laptop',
        'generateQuoteBtn' : false,
        'ratesLoading' : false,
        'countApiCard' : 0,
        'isSearchUpdate' : false,
        'total_cost' : 'card_total_cost',
        'buyOrSell' : 'sell_rates',
        'co2eApiCalled' : false,
        'co2eResponse' : null,
      };
      vm.rfqComponentObj = {
        "isBetterRates" : false,
        "id" : SearchService.AirResult._id,
        "search_param" : null,
        "rfqObj" : null,
        "show_rfqForm" : true
      };
      vm.initial_search_param = {}; // search param to store save data
      vm.initial_filterConfig = {};
      vm.currentCard = {};
      vm.l3_leg = 'l3_air';
      vm.l1_leg = 'l1_air';
      vm.filterConfig =  {
          'inco_term' : '',
          'search_name' : '',
          "insurance_currency" : vm.search_param.user.user_base_currency,
          "value_of_good" : 0
      };
      vm.onlyFbRates = false;
      vm.buyOrSell = 'buy_rates';
      vm.searchCount = 0;
      vm.sortByList = [
        {"name" : "Lowest_Freight" , "value" : "select"},
        {"name" : "Lowest_Total" , "value" : "meta.card_total_cost"},
        {"name" : "Fastest_Transit" , "value" : "meta.transit_time"}
      ];
      vm.validationObj={
        "airlinerValidation":false,
        "expiryValidation":false,
        "chargeNameValidation":false,
        "chargeBasicValidation":false,
        "chargeUnitValidation":false,
        "chargeMinimumValidation":false,
        "chargeCurrencyValidation":false,
        };
      vm.resultCardArray = [];
      vm.resultCardArrayObj = [];
      vm.allRatesArray = [];
      vm.allRatesArrayCopy = [];
      vm.userVendorID = parseInt(localStorageService.get('authToken').value.vendor_id);
      vm.isEdit = false;
      vm.getAirline = [];
      vm.resultService.user_base_currency = vm.search_param.user.user_base_currency;
      vm.apiProgressValue = 1;
      vm.visibleColumnList = {
        columnsList : [],
        columnsHide : 0
      };
      vm.mdVirtiualHeight = '1200';
      vm.all_in_quote_setting = util.all_in_quote;
      vm.setThreeNumberDecimal = SearchService.setThreeNumberDecimal;   // decimal points handling
      vm.util.co2ApiLoaded = true;
      vm.DashboardFilterData = []
      // Method
      vm.fndownloadQuote=fndownloadQuote;
      vm.toggleSidenav = toggleSidenav;
      vm.openSidenav = openSidenav;
      vm.requestToBook =  requestToBook;
      vm.getOnlyPort = util.getPorts;
      vm.generateQuoteModal = generateQuoteModal;
      vm.removeFromQuote = removeFromQuote;
      vm.fnFilCardLegObj = fnFilCardLegObj;
      vm.fnCardSorting = fnCardSorting;
      vm.fnCreateLink = fnCreateLink;
      vm.fnGetRatesCount = fnGetRatesCount;
      vm.fnCallRatesApi = fnCallRatesApi;
      vm.showFilterBottomSheet = showFilterBottomSheet;
      vm.resizeScreenSize = resizeScreenSize;
      vm.fnSetResultMixpanel = fnSetResultMixpanel;
      vm.showConfirm = showConfirm;
      vm.checkToUpdate = checkToUpdate;
      vm.fnOpenMatchRatesModal = fnOpenMatchRatesModal;
      vm.fnFindBetterRates = fnFindBetterRates;
      vm.rfqCallBack = rfqCallBack;
      vm.fnOpenRFQModal = fnOpenRFQModal;
      vm.fnCancelQuote = fnCancelQuote;
      vm.submitSearch = submitSearch;
      vm.updateSearchResult = updateSearchResult;
      vm.showQuoteProceedDiv = showQuoteProceedDiv;
      vm.closeToast = closeToast;
      vm.fnSetRatesArray = fnSetRatesArray;
      vm.fnCardFilter = fnCardFilter;
      vm.onScrollAction = onScrollAction;
      vm.trackAnalytics = trackAnalytics;
      vm.selectAllColumn = selectAllColumn;
      vm.makeDetailBoxString=makeDetailBoxString;
      vm.fnApplyCardFilter = fnApplyCardFilter;
      vm.scrollTop = scrollTop;
      vm.trackEvent = trackEvent;
      vm.fnOpenFreightIndex = fnOpenFreightIndex;
      vm.fnCloseFreightIndex = fnCloseFreightIndex;
      vm.FreightIndex = false;
      //function to initialize the data
      function resultInit(){
        util.isModulePaid('AIR');
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
        document.getElementById("inner-content").style.position = "relative";
        vm.resultCardFilter.countApiCard = 0;
        vm.resultCardFilter.isSearchUpdate = false;
        vm.cardsCount = 0;
        vm.selectedFilterCount = 0;
        vm.FreightIndex = $rootScope.domainData.domain_info.ENABLE_FREIGHT_INDEX['AIR'] && vm.search_param.search_type ===  "P2P";
        vm.fnSetRatesArray();
        vm.fnCardSorting('init');

        vm.viewDirectFilter = false;
        vm.quoteArray = [];
        vm.selectedCard = [];
        $rootScope.loadingDetails = false;
        vm.networks = [];

        vm.rfqComponentObj.isBetterRates = false;
        vm.resultCardFilter.ratesLoading = false;

        vm.TransporterList = [];
        vm.listOfFilterObj = {
          "linerList" : [],
          "airLineList" : [],
          "originTransporterList" : [],
          "destinationTransporterList" : [],
          "originPortList" : [],
          "destinationPortList" : [],
          "loadingPortList" : [],
          "dischargePortList" : [],
          "pickupTransporterList" : [],
          "deliveryTransporterList" : [],
          "agentList" : [],
          "commodityList" : [],
          "cargoTypeList" : ["All"],
          "contractId" : [],
          "ratesType" : [{
            "label":"All",
            "value":"All"
          }],
          "cardStatus" : [],
        };
        vm.selected_filter_obj = {
          "selected_liners" : [],
          "selected_airlines" : [],
          "selected_originPort" : [],
          "selected_destinationPort" : [],
          "selected_loadingPort" : [],
          "selected_dischargePort" : [],
          "selected_originHaulage" : [],
          "selected_destinationHaulage" : [],
          "selected_originTransporter" : [],
          "selected_destinationTransporter" : [],
          "selected_pickupTransporter" : [],
          "selected_deliveryTransporter" : [],
          "rollable" : false,
          "via_route_filter" : "Transhipment",
          "selected_agent" : [],
          "selected_commodity" : [],
          "selected_cargoType" : "All",
          "selected_rateType" : "All",
          "selected_cardStatus" : "All",
          "selected_contractId" : [],
          "selected_depoContainerPickup" : [],
          "selected_depoContainerDrop" : [],
          "no_rates_filter" : false
        };
        vm.currentCard = {};
        vm.sortBySelcted = 1;

        vm.viewMode = 'card';
        vm.fnDialogSwitchToRateCard = fnDialogSwitchToRateCard;
        vm.fnSwitchMode = fnSwitchMode;
        vm.isCardChanges = false;
        vm.fnRateCardTable = fnRateCardTable;

        if(SearchService.ratesTypeFilter){
          angular.forEach(SearchService.ratesTypeFilter.air_filter_option,function(filterOption){
            vm.listOfFilterObj.ratesType.push(filterOption);
          })
        }
        else{
            SearchService.getResultFilter().then( function (response) { 
            SearchService.ratesTypeFilter = response;   
            angular.forEach(SearchService.ratesTypeFilter.air_filter_option,function(filterOption){
              vm.listOfFilterObj.ratesType.push(filterOption);
            })
          })
        }

        vm.initial_search_param = angular.copy(vm.search_param); // storing the initial search param data;
        resultService.setLegModeWise(vm.search_param.mode, vm.filterConfig);
        resultService.setLegFilter( vm.filterConfig, vm.search_param );

        vm.filterConfig.search_name = vm.search_param.search_name;
        if(vm.search_param.shipment_insurance){
          vm.filterConfig.value_of_good =  vm.search_param.insurance_leg_cost;
          vm.filterConfig.insurance_currency =  vm.search_param.insurance_currency;
        }

        vm.initial_filterConfig = angular.copy(vm.filterConfig);
        var legType = vm.fnCreateLink(vm.filterConfig);

        if(vm.allRatesArrayCopy.length){
          angular.forEach(vm.allRatesArrayCopy, function(rates){

            if( !rates.data.cards.length ){
              vm.fnCallRatesApi(rates, legType);
            }else if( rates.data.cards.length ){
                vm.viewDirectFilter = true;
                vm.fnFilCardLegObj(rates);
            }else{
              vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
              vm.resultCardFilter.countApiCard--;
              vm.fnSetResultMixpanel();
            }
          });
        }

        vm.rfqComponentObj.search_param = angular.copy(vm.search_param);
        vm.rfqComponentObj.rfqObj = resultService.fnSetRfqObj(vm.rfqComponentObj.search_param);
        // vm.fnGetRatesCount();
        vm.onlyFbRates = true;
        vm.search_param["enable_co2e"] = !vm.search_param.hasOwnProperty('enable_co2e') ? false: ($rootScope.domainData.domain_info["ENABLE_CO2E"] && vm.search_param["enable_co2e"]);
        if(vm.isMultiPort && vm.search_param.user_nearby_origin.length > 1 || vm.search_param.user_nearby_destination.length > 1){
          vm.FreightIndex = false;
        } 
        if(!util.ResultPageDataBrainReport.length && vm.FreightIndex){
          DashboardService.getReportsData("Result").then(function (response) {
          util.ResultPageDataBrainReport = response.data.reports;
          }, function (error) {
            util.isCallingApi = false;
          });
        }
        vm.resizeScreenSize();
      }

      function getInitData(){
        vm.getSubvendor = [];
        if(util.isAdmin || util.isFreightbro){
          
          resultService.getTermsConditions('air','true').then(function(response){
              vm.stdTermsAndConditions = util.decodeValue(response.data.terms);
          },function(error){
              vm.stdTermsAndConditions = "";
          });

          resultService.getTermsConditions('air','false').then(function(response){
              vm.termsAndConditions = util.decodeValue(response.data.terms);
          },function(error){
              vm.termsAndConditions = "";
          });

          // if(!util.getSubvendor.length){
          //     resultService.getSubVendor().then(function(response){
          //         angular.forEach(response.data.subvendor_data, function(item){
          //             if(item.carrier_code != null && item.carrier_code != ""){
          //                 vm.getSubvendor.push(item);
          //                 util.getSubvendor = angular.copy(vm.getSubvendor);
          //             }
          //         });
          //     },function(error){
          //         vm.getSubvendor = [];
          //         util.getSubvendor = [];
          //     });
          // }else{
          //     vm.getSubvendor = angular.copy(util.getSubvendor);
          // }

          if(!util.getAirline.length){
            resultService.getAirlineData().then(function(response){
                vm.getAirline = response.data.data;
                util.getAirline = angular.copy(vm.getAirline);
            },function(error){
                vm.getAirline = [];
                util.getAirline = [];
            });
          }else{
              vm.getAirline = angular.copy(util.getAirline);
          }

        }
      }

      resultInit();
      getInitData();

      function fnSetRatesArray(){
        vm.msrCardRates = [{
          'data' : SearchService.AirResult.result_data.msr_rates.data,
          'url' : SearchService.AirResult.result_data.msr_rates.url,
          'type' : 'msr_rates'
        }];

        vm.iataCardRates = [{
          'data' : SearchService.AirResult.result_data.iata_rates.data,
          'url' : SearchService.AirResult.result_data.iata_rates.url,
          'type' : 'iata_rates'
        }];

        // if(vm.isNetworkRates){
          vm.networkCardRates = [{
            'data' : SearchService.AirResult.result_data.network_rates.data,
            'url' : SearchService.AirResult.result_data.network_rates.url,
            'type' : 'network_rates'
          }]
        // }else{
        //   vm.networkCardRates = [];
        // }

        vm.allRatesArrayCopy = angular.copy([].concat(vm.msrCardRates, vm.iataCardRates, vm.networkCardRates));

        if(SearchService.AirResult.result_data.msr_rates.spot.length){
          angular.forEach(SearchService.AirResult.result_data.msr_rates.spot, function(spot){
            spot["type"] = 'msr_spot';
            vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(spot));
          });
        }

        if(SearchService.AirResult.result_data.network_rates.spot.length){
          angular.forEach(SearchService.AirResult.result_data.network_rates.spot, function(spot){
            spot["type"] = 'network_spot';
            vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(spot));
          });
        }

        // if nearby rates true
        if(vm.isNearbyPorts){
          // iterate nearby rates and store in allRatesArrayCopy
          angular.forEach(SearchService.AirResult.result_data.nearby_port_rates, function(item){
            if(item.length){
              angular.forEach(item, function(rates){
                vm.allRatesArrayCopy = angular.copy(vm.allRatesArrayCopy.concat(rates));
              })
            }
          });
        }
      }

      function makeDetailBoxString(initial_search_param) {
        vm.detailBoxString = ((initial_search_param.origin_charges ? 'Origin, ' : '') + (initial_search_param.origin_customs ? 'Origin Custom, ' : '') +(initial_search_param.destination_charges ? 'Destination, ' : '') + (initial_search_param.destination_customs ? 'Destination Custom, ' : '') ) || 'Select Charges';
  
        vm.rfqComponentObj.rfqObj.detailBoxTooltip = ((initial_search_param.origin_charges ? 'Origin\n' : '') + (initial_search_param.origin_customs ? 'Origin Custom\n' : '')+(initial_search_param.destination_charges ? 'Destination\n' : '') + (initial_search_param.destination_customs ? 'Destination Custom\n' : '') ) || 'Select Charges';
  
        vm.rfqComponentObj.rfqObj.detailBoxString = vm.detailBoxString.charAt(vm.detailBoxString.length - 2) === ',' ? vm.detailBoxString.slice(0, -2) : vm.detailBoxString;
  
      }

      // if multiple leg required make link for additional leg
      function fnCreateLink(filterConfig){
        var legType = "&leg_type=l3_air,";
        angular.forEach(filterConfig,function(value,key){
          if( !(key =='inco_term' || key == 'search_name' || key == 'l3_air' || key == 'value_of_good' || key == 'insurance_currency') ){
              if(value.is_selected ){
                legType += key +',';
              }
          }
        });

        legType = legType.length ? legType.slice(0, -1) : legType;

        if(legType.includes('ins_air') && !legType.includes('-ins_air') ){
          legType += '&value_of_good='+filterConfig.value_of_good+'&currency='+filterConfig.insurance_currency;
        }
        return legType;
      }

      function fndownloadQuote(){
        util.callMixpanel("RR-DowanloadRates-Click",{
          "Mode": vm.search_param.mode
        });
        resultService.dwnloadpdf(vm.search_param,vm.selectedCard);
      }

      // get rates card count from DB
      function fnGetRatesCount(){
        resultService.searchCount( vm.search_param.origin_location.location, vm.search_param.destination_location.location).then(function(response){
          vm.searchCount = response.data.data.count;
        },function(error){
            $log.error(error);
        });
      }

      // get cards and rates object from DB
      function fnCallRatesApi(ratesObj, legType){

        if( ratesObj.data.cards.length ){
          vm.viewDirectFilter = true;
          vm.fnFilCardLegObj(ratesObj);
        }else if(ratesObj.url && SearchService.isNewSearch){
          if(vm.apiProgressValue==1 && vm.resultCardFilter.countApiCard){ startApiLoader() }
          var url = ratesObj.url + legType;
          resultService.getDataMsrFromUrl(url).then(function(response){

            if (response.data.data) {
              ratesObj.data = response.data.data;
              // store currency conversion
              vm.resultCardFilter.currency_conversion_rates = vm.resultCardFilter.currency_conversion_rates.concat(response.data.currency_conversion_rates);
              // store airline list
              if (response.data.airlines) {
                resultService.airlinesList = response.data.airlines;
              }
            }

            if(Object.keys(ratesObj.data).length && ratesObj.data.cards.length){
              vm.viewDirectFilter = true;
              vm.fnFilCardLegObj(ratesObj);
            }else{
              vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
              vm.resultCardFilter.countApiCard--;
              vm.fnSetResultMixpanel();
            }
            stopApiLoader();
          },function(error){
            vm.resultCardFilter.countApiCard--;
            stopApiLoader();
            $log.error(error);
          });
        }else{
          vm.resultCardFilter.countApiCard--;
        }
      }

     

      // Set timer for api loader once rates api started
      function startApiLoader(){
        if(vm.apiProgressValue<10){
          vm.showApiLoader = true;
          vm.autoApiUpdate = setTimeout(startApiLoader, 500);
          if(vm.apiProgressValue<9){
            vm.apiProgressValue+= 0.5;
          }
        }  
      }

      // Hide loader and clear timer once all rates api completed
      function stopApiLoader(){
        if(vm.resultCardFilter.countApiCard==0){
          vm.apiProgressValue = 10;
          clearInterval(vm.autoApiUpdate);
          $timeout(function () {
            vm.showApiLoader = false;
            vm.apiProgressValue = 1;
          }, 1000);
        }
      }

      function fnFilCardLegObj(ratesObj, type, callFrom){

        resultService.formRateCardMsr(ratesObj.data.rates, ratesObj.data.cards, vm.resultCardFilter.currency_conversion_rates,vm.search_param);

        vm.resultCardArray = vm.resultCardArray.concat( ratesObj.data.cards );
        vm.cardsCount = vm.resultCardArray.length;

        resultService.fnCallScheduleUrl( ratesObj.data.cards, 'l3_air').then(function(response){
          vm.resultCardFilter.countApiCard--;
          vm.fnSetResultMixpanel();
          vm.allRatesArray = angular.copy(vm.allRatesArrayCopy);
        },function(error){
            $log.error(error);
        });
      }

      function fnCardSorting(action){
        var cardArray = [];
        angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
          if(action != 'init' && allRatesArray.data.cards.length){
            cardArray = cardArray.concat(allRatesArray.data.cards);
            vm.resultCardArray = (resultService.getLowestCard( [].concat( cardArray ) ) ).reverse();
            vm.resultCardArrayObj = vm.resultCardArray;
          }
          else if(action == 'init'){
            vm.resultCardFilter.countApiCard ++;
          }
        });
      }

      // result with new POL POD
      function submitSearch(payload){
        vm.apiProgressValue = 1;
        var data = { "search_param" : payload };
  
          data.search_param.origin_port = null;
          data.search_param.destination_port = null;
          vm.shipperSearchLimitError = "";
          SearchService.postSearchData(data).then(function(response){
              SearchService.AirResult =  response.data.data;
              SearchService.isNewSearch = true;
              if(appCache.get('verificationsearchParam')) {
                appCache.put('verificationsearchParam', angular.copy(SearchService.AirResult.result_meta.search_param));
              }
              $state.go('app.search.airResult',{ id: SearchService.AirResult._id });
              util.isCallingApi = false;
          },function(error){
              vm.resultCardFilter["countApiCard"] = 0;
              util.isCallingApi = false;
              util.showToast(error.data.message);
              if(error.status === 429 && error.data.message){
                vm.shipperSearchLimitError  = error.data.message;
              }
              $log.log(error);
          });
      }

      // update result
      function updateSearchResult() {
        vm.search_param = SearchService.AirResult.result_meta.search_param;
        vm.resultCardFilter.currency_conversion_rates = [];

        angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
          allRatesArray.data.cards = [];
        });

        vm.isEdit = true;
        resultService.scheduleResponse = [];
        vm.resultCardArray = [];
        resultInit();
      }

      // mixpanel for result
      function fnSetResultMixpanel(){
        if(!vm.resultCardFilter.countApiCard){

          SearchService.isNewSearch = false;
          var resultCard = vm.resultCardArray;
          var totalCards = angular.copy(resultCard);
          var customCargoType = [];
          angular.forEach(totalCards, function(item){
            var airline = vm.listOfFilterObj.airLineList.filter(function (entry) { return entry.airline_code == item.data.buy_rates.l3_air.rate_obj.airline.airline_code; })

            if( item.data.buy_rates.l3_air.rate_obj.airline.airline_code && !airline.length ){
              vm.listOfFilterObj.airLineList.push(item.data.buy_rates.l3_air.rate_obj.airline);
            }

            // Storing all pickup transporter name in vm.listOfFilterObj.pickupTransporterList
            if( (item.data.buy_rates.l1_air && item.data.buy_rates.l1_air.rate_obj && item.data.buy_rates.l1_air.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.pickupTransporterList.indexOf(item.data.buy_rates.l1_air.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.pickupTransporterList.push(item.data.buy_rates.l1_air.rate_obj.sub_vendor.sub_vendor_name);
            }

            // Storing all origin transporter name in vm.listOfFilterObj.originTransporterList
            if( (item.data.buy_rates.l2_air && item.data.buy_rates.l2_air.rate_obj && item.data.buy_rates.l2_air.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.originTransporterList.indexOf(item.data.buy_rates.l2_air.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.originTransporterList.push(item.data.buy_rates.l2_air.rate_obj.sub_vendor.sub_vendor_name);
            }

             // Storing all destination transporter name in vm.listOfFilterObj.destinationTransporterList
            if( (item.data.buy_rates.l4_air && item.data.buy_rates.l4_air.rate_obj && item.data.buy_rates.l4_air.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.destinationTransporterList.indexOf(item.data.buy_rates.l4_air.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.destinationTransporterList.push(item.data.buy_rates.l4_air.rate_obj.sub_vendor.sub_vendor_name);
            }

            // Storing all delivery transporter name in vm.listOfFilterObj.deliveryTransporterList
            if( (item.data.buy_rates.l5_air && item.data.buy_rates.l5_air.rate_obj && item.data.buy_rates.l5_air.rate_obj.sub_vendor.sub_vendor_name) && vm.listOfFilterObj.deliveryTransporterList.indexOf(item.data.buy_rates.l5_air.rate_obj.sub_vendor.sub_vendor_name) == -1) {
              vm.listOfFilterObj.deliveryTransporterList.push(item.data.buy_rates.l5_air.rate_obj.sub_vendor.sub_vendor_name);
            }

             // Storing all origin port name in vm.listOfFilterObj.loadingPortList
            if(vm.listOfFilterObj.loadingPortList.indexOf(item.meta.port_data.origin_port_code) == -1){
              vm.listOfFilterObj.loadingPortList.push(item.meta.port_data.origin_port_code);
            }

            // Storing all destination port name in vm.listOfFilterObj.dischargePortList
            if(vm.listOfFilterObj.dischargePortList.indexOf(item.meta.port_data.destination_port_code) == -1){
              vm.listOfFilterObj.dischargePortList.push(item.meta.port_data.destination_port_code);
            }

            // Storing all agent name in vm.listOfFilterObj.agentList
            if(item.data.buy_rates.l3_air.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(item.data.buy_rates.l3_air.rate_obj.agent.agent_name) == -1){
              vm.listOfFilterObj.agentList.push(item.data.buy_rates.l3_air.rate_obj.agent.agent_name);
            }

            // Storing all cargo type name in vm.listOfFilterObj.cargoTypeList
            if(item.data.buy_rates.l3_air.rate_obj.cargo_type_data && vm.listOfFilterObj.cargoTypeList.indexOf(item.data.buy_rates.l3_air.rate_obj.cargo_type_data.name) == -1){
              //vm.listOfFilterObj.cargoTypeList.push(item.data.buy_rates.l3_air.rate_obj.cargo_type_data.name);
              //custom order list apply
              if(resultService.getCargoTypeFixedOrder().indexOf(item.data.buy_rates.l3_air.rate_obj.cargo_type_data.name) >= 0){
                vm.listOfFilterObj.cargoTypeList[resultService.getCargoTypeFixedOrder().indexOf(item.data.buy_rates.l3_air.rate_obj.cargo_type_data.name)] = item.data.buy_rates.l3_air.rate_obj.cargo_type_data.name;

              }else if(customCargoType.indexOf(item.data.buy_rates.l3_air.rate_obj.cargo_type_data.name) < 0){
                customCargoType.push(item.data.buy_rates.l3_air.rate_obj.cargo_type_data.name);
              }

            }

            // Storing all commodity name in vm.listOfFilterObj.commodityList
            if(item.data.buy_rates.l3_air.rate_obj.commodity_data && item.data.buy_rates.l3_air.rate_obj.commodity_data.length){

              angular.forEach(item.data.buy_rates.l3_air.rate_obj.commodity_data, function(commodity){
                if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                  vm.listOfFilterObj.commodityList.push(commodity);
                }
              });
            }

            if(item.data.buy_rates.l3_air.rate_obj.leg_currency != 'USD'  ){
              item.data.buy_rates.l3_air.rate_obj.leg_currency_cost = ((item.data.buy_rates.l3_air.rate_obj.leg_currency_cost) * (item.meta.conversionRate['USD'])) / item.meta.conversionRate[item.data.buy_rates.l3_air.rate_obj.leg_currency];
              item.data.buy_rates.l3_air.rate_obj.leg_currency = 'USD';
            }
          });

          // empty value remove from array
          vm.listOfFilterObj.cargoTypeList = [].concat(vm.listOfFilterObj.cargoTypeList, customCargoType).filter(function(){return true;});

          if( vm.listOfFilterObj.commodityList.indexOf('NOT AVAILABLE') == -1 ){
            vm.listOfFilterObj.commodityList.push('NOT AVAILABLE');
          }

          if($state.current.name == 'app.search.airResult' && vm.resultCardArray.length){
            util.isCallingApi = true;
            util.ratesUpdating = "New Rates Updating...";
            vm.fnCardSorting();
            vm.fnCardFilter();
            $timeout(function () {
              util.isCallingApi = false;
              util.ratesUpdating = '';
            }, 500);
          }

          var mainTotal = totalCards.sort(function(a, b) {
            return b.data.buy_rates.l3_air.rate_obj.leg_currency_cost - a.data.buy_rates.l3_air.rate_obj.leg_currency_cost;
          })

          var searchName = vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location + ' / ' + $filter('date')(vm.search_param.cargo_ready_date, 'd MMM yyyy') + '/' +vm.search_param.load_data.load_meta.chargeable_weight + ' Kgs';
          if(!vm.isEdit){
            var rateDetails = {
              "Mode":vm.search_param.mode,
              "Search Name":vm.search_param.search_name,
              "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
              "Search Param": searchName,
              "Origin Port":vm.search_param.origin_location.portcode_portname,
              "Destination Port":vm.search_param.destination_location.portcode_portname,
              "Load Details" : vm.search_param.load_data.load_meta.chargeable_weight + ' Kgs',
              "Gross Weight": vm.search_param.load_data.load_meta.gross_weight + ' Kgs',
              "Volumetric Weight": vm.search_param.load_data.load_meta.volumetric_weight + ' Kgs',
              "Carrier List" : totalCards.length ? shareQuoteService.getAirlineName(resultService.airlinesList) : 'No Rate Cards Available',
              "No. of rate card" : totalCards.length,
              "Highest rate" : totalCards.length ? totalCards[0].meta.card_total_cost : 'No Rates Available',
              "Highest rate by" : totalCards.length ? totalCards[0].data.buy_rates.l3_air.rate_obj.airline.air_line_name : 'No Rates Available',
              "Lowest rate" :  totalCards.length ? totalCards[totalCards.length-1].meta.card_total_cost : 'No Rates Available',
              "Lowest rate by" : totalCards.length ? totalCards[totalCards.length-1].data.buy_rates.l3_air.rate_obj.airline.air_line_name : 'No Rates Available',
              "Currency" : vm.search_param.user.user_base_currency,
              "Highest Main Freight Cost":mainTotal.length ? mainTotal[0].data.buy_rates.l3_air.rate_obj.leg_currency_cost + " " + mainTotal[0].data.buy_rates.l3_air.rate_obj.leg_currency : 'No Rates Available',
              "Lowest Main Freight Cost":mainTotal.length ? mainTotal[mainTotal.length-1].data.buy_rates.l3_air.rate_obj.leg_currency_cost + " " + mainTotal[mainTotal.length-1].data.buy_rates.l3_air.rate_obj.leg_currency : 'No Rates Available',
              "Origin Text Input":vm.search_param.origin_input_text,
              "Destination Text input":vm.search_param.destination_input_text,
            };
            util.callMixpanel("Rate-Result", rateDetails);
          }
          $timeout(function () {
            if(vm.resultCardFilter.deviceName === 'laptop' && $('.filter-container').height() > vm.mdVirtiualHeight){
              vm.mdVirtiualHeight = Math.round($('.filter-container').height() + 100);
            }
          }, 500);
        }
      }

      // function to show bottom sheet on filter select
      function showFilterBottomSheet(){

        $mdSidenav('right')
          .open()
          .then(function () {
            $mdSidenav('right').onClose();
          });
      };

      function fnApplyCardFilter(selectedFilterObj){
        vm.selected_filter_obj = angular.copy(selectedFilterObj);
        vm.scrollTop();
        vm.fnCardFilter();
      }

      // card filter
      function fnCardFilter(){
        var result = resultService.fnCardFilter('air', vm.resultCardArrayObj, vm.selected_filter_obj);
        vm.resultCardArray = result.filterRatesCard.length === 0 && result.selectedFilterCount === 0 ? vm.resultCardArrayObj : result.filterRatesCard;
        vm.cardsCount = result.cardsCount;
        vm.selectedFilterCount = result.selectedFilterCount;
      }

      //confirmation to discard result changes
      function showConfirm(ev,action){
          var confirm = $mdDialog.confirm()
                // .title('Warning')
                .textContent('All your changes will be lost, do you want to continue?')
                .ariaLabel('discard')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

          $mdDialog.show(confirm).then(function() {
              if(action == 'betterRates'){
                vm.fnFindBetterRates()
              }
          }, function() {
            return true;
          });
      }

      //check update search or additional services
      function checkToUpdate(ev,action){
        if (vm.curr_vas_leg_arr.length) {
          var confirm = $mdDialog.confirm()
            // .title('Warning')
            .textContent('Any changes you have made will be lost, do you want to continue?') //add msg
            .ariaLabel('discard')
            .targetEvent(ev)
            .ok('Yes')
            .cancel('No');

          $mdDialog.show(confirm).then(function () {
            // vm.isVasApplied = false;
            if (vm.quoteArray.length) {
              if (action == 'betterRates') {
                vm.showConfirm(ev, 'betterRates');
              }
            } else {
              if (action == 'betterRates') {
                vm.fnFindBetterRates()
              }
            }
          }, function () {
            return;
          });
        } else {
          if (vm.quoteArray.length) {
            if (action == 'betterRates') {
              vm.showConfirm(ev, 'betterRates');
            }
          } else {
            if (action == 'betterRates') {
              vm.fnFindBetterRates()
            }
          }
        }

      }

      // remove card from quote creation
      function removeFromQuote(card) {
        var index = vm.quoteArray.indexOf(card._id);
        if (index > -1) {
          vm.quoteArray.splice(index, 1);
          card.meta.is_selected = false;
          card.data.sell_rates = null;
          var selectId = vm.selectedCard.find(function(item){ return item._id === card._id; });
          var selectIndex = vm.selectedCard.indexOf(selectId);
            vm.selectedCard.splice(selectIndex, 1);

          for(var i = 0; i < vm.allRatesArray.length; i++){
            var tempId = vm.allRatesArray[i].data.cards.find(function(item){ return item._id === card._id; });
            if(tempId){
              card.data.buy_rates = tempId.data.buy_rates;
              card.data.sell_rates = tempId.data.sell_rates;
              break;
            }
          };

          if(vm.isVasApplied){
            var rate_card  = [card];
            resultService.applyVASLegToCard( rate_card,  vm.vasDetails.legList , 'result');
          }else{
            card.meta.buy_leg_total = resultService.calCardTotal(card.data.buy_rates);
            card.meta['card_total_cost'] = resultService.calCardTotal(card.data.sell_rates);
          }
        }
      }

      // remove al card from quote
      function fnCancelQuote(ev){
        angular.forEach(vm.allRatesArray, function(allRatesArray){
          if(allRatesArray.data.cards.length){
            angular.forEach(allRatesArray.data.cards, function(card){
              card.meta.is_selected = false;
            });
          }
        });
        util.callMixpanel("RR-RemoveAll-Click",{
          "Mode": vm.search_param.mode
        });
        vm.allRatesArrayCopy = angular.copy(vm.allRatesArray);
        vm.fnCardSorting();
        vm.fnCardFilter();
        vm.quoteArray = [];
        vm.selectedCard = [];
        vm.resultCardFilter.hideBookBtn = false;
        vm.resizeScreenSize();
      }

      //Open Modal to fill new card details
      function generateQuoteModal(ev){
          vm.quoteDetails = shareQuoteService.fnInitializeQuoteDetails(vm.filterConfig.l2_air_cha.is_selected, vm.filterConfig.l4_air_cha.is_selected);
          vm.quoteDetails.terms = vm.termsAndConditions;
          vm.quoteDetails.incoterms = (vm.search_param.inco_term) ? vm.search_param.inco_term : null;
          vm.quoteDetails.hazardous = vm.search_param.hazardous_material;
          vm.quoteDetails.all_in_quote_setting = vm.all_in_quote_setting;

          vm.shareQuoteObj = {
            'quoteDetails' : vm.quoteDetails,
            'termsAndConditions' : vm.termsAndConditions,
            'stdTermsAndConditions' : vm.stdTermsAndConditions,
            'selectedCard' : vm.selectedCard,
            'search_param' : vm.search_param,
            'generateQuoteBtn' : vm.resultCardFilter.generateQuoteBtn,
            'currency_conversion_rates' : vm.resultCardFilter.currency_conversion_rates,
            'fclLoadData' : null,
            'result_id' : vm.result_id,
            'vas_details' : vm.vasDetails,
            'sales_user' : vm.search_param.sales_user,
            'shipper_user' : vm.search_param.shipper_user,
            'quoteFrom': 'Search',
            'exchangeRateId': vm.result_id
          }

          $mdDialog.show({
            template : '<md-dialog id="share-quotation" class="dialobox" ng-cloak><md-dialog-content class="p-0"><share-quotation sharequoteobj="ctrl.parent.shareQuoteObj"></share-quotation></md-dialog-content></md-dialog>',
              // templateUrl        : 'app/main/result/Dialogs/share-quotation/share-quotation.html',
              targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm },
              onRemoving: function (event, removePromise) {
                for(var name in CKEDITOR.instances)
                {
                    CKEDITOR.instances[name].destroy()
                } 
              }
              // onRemoving : vm.resetSendQuote()
          });

          

          //mixpanel code
          var generateQuote = {
            "Mode":vm.search_param.mode,
            "Search Name":vm.search_param.search_name,
            "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location,
            "No. of rate card":vm.quoteArray.length
          };
      }

      //function to request tyhe booking data
      function requestToBook(currCard,index){
        vm.booked_leg_type = [];
        angular.forEach(currCard.data.sell_rates,function(value){
            if(value.rate_obj){
                vm.booked_leg_type.push(value.leg_code);
            }
        });

        var card = angular.copy(currCard);
        card.meta["card_total_cost"] = resultService.calCardTotal(card.data.sell_rates);
        delete card.meta['buy_leg_total'];
        delete card.meta["slabPersentage"];
        delete card.meta["selectedLeg"];
        if(!!card.data.buy_rates){
        delete card.data.buy_rates[vm.l3_leg]["rate_obj_1"];
        delete card.data.buy_rates[vm.l3_leg]["rate_obj_2"];
        }
        else if(!!card.data.sell_rates){
          delete card.data.sell_rates[vm.l3_leg]["rate_obj_1"];
          delete card.data.sell_rates[vm.l3_leg]["rate_obj_2"];
        }

        var booking_data = {
            "search_param" : vm.search_param,
            "card_item" : angular.copy(card),
            "id" : vm.result_id,
            "booked_leg_type" : vm.booked_leg_type,
            "buyOrSell": !vm.util.isShipper ? 'sell_rates' : vm.resultCardFilter.buyOrSell,
            "user" : vm.search_param.user,
            "page" : "search",
            "create_for" : util.userProfile.user,
            "shipper" : util.isShipper ? util.userProfile.user : (vm.search_param.shipper_user ? vm.search_param.shipper_user : null),  //DEV-3744
            "send_mail" : vm.search_param.shipper_user ? true : false,
            "cardIndex":index,
            "all_in_quote_setting" : util.all_in_quote
        }

        resultService.requestToBookData = booking_data;

        //mixpanel code
        analytics.track("Book Now",{
          "Mode":vm.search_param.mode,
          "Search Name":vm.search_param.search_name,
          "Port-Pair":vm.search_param.origin_location.location + ' to ' + vm.search_param.destination_location.location
        });

        $timeout(function(){
          vm.util.isCallingApi = false;
          if(util.isSharedQuote()) {
              $state.go('app.resultSharedBookShipment');
          } else {
              $state.go('app.resultBookShipment', {mode : 'air'});
          }
        }, 200)
      }

      //function to open sidenav
      function openSidenav(componentId){
        $mdSidenav(componentId)
        .open()
        .then(function(){
            $mdSidenav(componentId).onClose(function () {
                vm.filterConfig = angular.copy(vm.initial_filterConfig);
              });
        });
      }

      //toggling the sidenav for add services asection
      function toggleSidenav(sidenavId) {
          $mdSidenav(sidenavId).toggle();
      }

      function closeToast () {
        $mdToast.hide();
      }
      
      // match rates module ***********
      vm.matchRatesObj = {
        "search_param" : SearchService.AirResult.result_meta.search_param,
        "id" : SearchService.AirResult._id,
        "match_rates" : SearchService.AirResult.match_rates,
        "additional_charges" : {
            "selected" : [],
            "available" : []
        }
      }

      function fnOpenMatchRatesModal(ev){

        $mdDialog.show({
          template: '<md-dialog id="wls-match-rates" class="popup-md"><match-rates matchratesparam="ctrl.parent.matchRatesObj" callback="ctrl.parent.fnMatchRatesCall()"></match-rates></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          parent: $rootElement,
          scope: $scope,
          preserveScope: true,
          controller: function () { this.parent = vm },
          controllerAs: 'ctrl',
        });
      }

      // RFQ module **********
      function fnFindBetterRates(){
        vm.allRatesArrayCopy = angular.copy(vm.allRatesArray);
        vm.fnCardSorting();
        vm.fnCardFilter();
        vm.quoteArray = [];
        vm.selectedCard = [];
        vm.resultCardFilter.hideBookBtn = false;
        // $timeout(function ( ) {
        vm.rfqComponentObj.isBetterRates = true;
        // vm.viewDirectFilter = false;
        // }, 50);
        vm.fnOpenRFQModal();
      }

      // Funtion to open RFQ form modal
      function fnOpenRFQModal(ev){
        vm.makeDetailBoxString(vm.initial_search_param);
        vm.tempRfqObj = angular.copy(vm.rfqObj);
        $mdDialog.show({
          template:'<md-dialog id="nwls-request-for-quote" class="popup-md"><nwls-request-for-quote class="dialog-height" rfqdata="ctrl.parent.rfqComponentObj" callback="ctrl.parent.rfqCallBack(action)"></nwls-request-for-quote></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          parent: $rootElement,
          scope: $scope,
          preserveScope: true,
          controller: function () { this.parent = vm },
          controllerAs: 'ctrl',
        });
      }

      function rfqCallBack(action){
        if(action == 'closeRfq'){
          vm.rfqComponentObj.isBetterRates = false;
          vm.viewDirectFilter = true;
        }
      }

      //callback function from card component
      function showQuoteProceedDiv(item){
        vm.isCardChanges = false;
        if(item.action == 'addInToQuote'){
          if (!vm.quoteArray.includes(item.currentCard._id)) {
            vm.quoteArray.push(item.currentCard._id);
            vm.selectedCard.push(item.currentCard);
          } else {
            var replaceCard = $filter('filter')(vm.selectedCard, { '_id': item.currentCard._id }, true);
            var index = vm.selectedCard.indexOf(replaceCard[0]);
            vm.selectedCard[index] = item.currentCard;
          }
          vm.resultCardFilter.hideBookBtn = true;
          vm.resizeScreenSize();
        }
        else if(item.action == 'removeFromQuote'){
          vm.removeFromQuote(item.currentCard);

          if(!vm.quoteArray.length){
            vm.resultCardFilter.hideBookBtn = false;
            vm.resizeScreenSize();
          }
        }
        else if( item.action == 'bookingRequest'){
          vm.requestToBook(item.currentCard,item.index);
        }
        else if( item.action == 'deleteCharge' ){
          var index = vm.quoteArray.indexOf(item.currentCard._id);
          if (index > -1) {
            vm.quoteArray.splice(index, 1);
            item.currentCard.meta.is_selected = false;
            item.currentCard.data.sell_rates = null;
            vm.selectedCard.pop(item.currentCard);
          }
        }
        else if( item.action == 'scheduleSelect'){
          $timeout(function(){ item.currentCard.meta.isScheduleCall = true; },100);
          var cardObj = $filter('filter')(vm.selectedCard, { '_id': item.currentCard._id }, true);

          if (cardObj.length) {
            cardObj[0].meta.selected_schedule = item.currentCard.meta.selected_schedule;
          }
          item.currentCard.meta.sailing_date = item.currentCard.meta.selected_schedule.departure_time;
        }else if( item.action == 'manualCardDelete'){
          vm.openDeleteCard(item.currentCard);
        }else if( item.action == 'manualCardEdit' ){
          vm.openEditCardModal(item.currentCard);
        }
        else if( item.action == "addRate" ){
          vm.fnSubmitLegData(item.currentCard, 'addLeg');
        }
        else if( item.action == "editRate" ){
          vm.fnSubmitLegData(item.currentCard, 'editLeg');
        }
      }

      // ********** create new card feature ************

      vm.newCardModal = newCardModal;
      vm.cancelDialog = cancelDialog;
      vm.fnSubmitLegData = fnSubmitLegData;
      vm.openEditCardModal = openEditCardModal;
      vm.updateCardDetails = updateCardDetails;
      vm.openDeleteCard = openDeleteCard;
      vm.fnDeleteData = fnDeleteData;
      vm.rateTotalCustomCurr = rateTotalCustomCurr;
      vm.showCardRemoveFromQuote = showCardRemoveFromQuote;
      vm.main_charge_list = [];
      vm.currencyList = util.currencyList;
      vm.curr_vas_leg_arr = [];
      vm.pageInfo = {
        "pageId": SearchService.AirResult._id,
        "pageType":'Search',
        "activityId": null
      };

      //Open Modal to fill new card details
      function newCardModal(ev){
        
        vm.footerObj = { 
          "doneBtnDisable" : false,
          "buyTotalWithConv" : 0,
          "buyTotalBaseCurr" : 0,
          "sellTotalBaseCurr" : 0,
          "profit" : 0,
          "rateExpired":false
        }
        vm.pageSource = 'newCardSearch';

        $mdDialog.show({
          template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" result-card-filter="ctrl.parent.resultCardFilter" footer-obj="ctrl.parent.footerObj" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
            targetEvent        : ev,
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm },
            onRemoving: function (event, removePromise) {
              for (var name in CKEDITOR.instances) {
                CKEDITOR.instances[name].destroy();
              }
            }
        });
      }

      // close dialog function
      function cancelDialog(value,action){
        vm.validationObj={
        "airlinerValidation":false,
        "expiryValidation":false,
        "chargeNameValidation":false,
        "chargeBasicValidation":false,
        "chargeUnitValidation":false,
        "chargeMinimumValidation":false,
        "chargeCurrencyValidation":false,
        }
        $mdDialog.hide();
      }

      //Submit leg Details
      function fnSubmitLegData(currentCard, action){
        var leg_data = currentCard.data.sell_rates[vm.l3_leg].rate_obj;
        vm.disableFrm = true;
        resultService.calculateChargeSummary(vm.search_param.load_data,vm.search_param.mode,currentCard);
        if(action == 'addLeg'){
          currentCard.meta.remarks = util.encodeValue(currentCard.meta.remarks);        
          currentCard.meta.inclusions = util.encodeValue(currentCard.meta.inclusions);        
          currentCard.meta.internal_remarks = util.encodeValue(currentCard.meta.internal_remarks);
          delete leg_data["_id"];
          var data = {
            'cards' : [currentCard]
          };
          $rootScope.loadingDetails = true;
          util.isCallingApi = true;
          resultService.fnCreateRates(data, vm.result_id, action).then(function(response){
            vm.disableFrm = false;
            var newCardData = response.data.data;
            newCardData.card = newCardData.cards[0];

            resultService.formRateCardMsr(newCardData.rates, [newCardData.card], vm.resultCardFilter.currency_conversion_rates,vm.search_param);

            angular.forEach(newCardData.card.data.buy_rates,function(leg_value, leg_key){

              if (leg_key == 'l2_air')  {
                if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.originTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                  vm.listOfFilterObj.originTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                }
              }

              if (leg_key == 'l4_air')  {
                if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.destinationTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                  vm.listOfFilterObj.destinationTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                }
              }

              if (leg_key == 'l1_air')  {
                if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.pickupTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                  vm.listOfFilterObj.pickupTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                }
              }

              if (leg_key == 'l5_air')  {
                if ( leg_value.rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.deliveryTransporterList.indexOf(leg_value.rate_obj.sub_vendor.sub_vendor_name) == -1) {

                  vm.listOfFilterObj.deliveryTransporterList.push(leg_value.rate_obj.sub_vendor.sub_vendor_name);
                }
              }

              if(leg_key == 'l3_air') {
                var airline = vm.listOfFilterObj.airLineList.filter(function (entry) { return entry.airline_code == leg_value.rate_obj.airline.airline_code; })

                if( leg_value.rate_obj.airline.airline_code && !airline.length ){
                  vm.listOfFilterObj.airLineList.push(leg_value.rate_obj.airline);
                }

                if(leg_value.rate_obj.schedule.url){
                  resultService.getScheduleResponse(newCardData.card, 'l3_air').then(function(){
                  },function(error){
                    resultService.fnSetTransitTime(newCardData.card, leg_key);
                    leg_value.rate_obj.schedule.data = [];
                  });

                  vm.isMsrDirect = false;
                }else{
                  resultService.fnSetTransitTime(newCardData.card, leg_key);
                  newCardData.card.meta["isScheduleCall"] = true;
                }
              }else{
                newCardData.card.meta["isScheduleCall"] = true;
              }

            });

            // Storing agent name in vm.listOfFilterObj.agentList
            if(newCardData.card.data.buy_rates.l3_air.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(newCardData.card.data.buy_rates.l3_air.rate_obj.agent.agent_name) == -1){
              vm.listOfFilterObj.agentList.push(newCardData.card.data.buy_rates.l3_air.rate_obj.agent.agent_name);
            }

            // Storing cargo type name in vm.listOfFilterObj.cargoTypeList
            if(newCardData.card.data.buy_rates.l3_air.rate_obj.cargo_type_data && newCardData.card.data.buy_rates.l3_air.rate_obj.cargo_type_data.name && vm.listOfFilterObj.cargoTypeList.indexOf(newCardData.card.data.buy_rates.l3_air.rate_obj.cargo_type_data.name) == -1){
              vm.listOfFilterObj.cargoTypeList.push(newCardData.card.data.buy_rates.l3_air.rate_obj.cargo_type_data.name);
            }

            // Storing all commodity name in vm.listOfFilterObj.commodityList
            if(newCardData.card.data.buy_rates.l3_air.rate_obj.commodity_data && newCardData.card.data.buy_rates.l3_air.rate_obj.commodity_data.length){

              angular.forEach(newCardData.card.data.buy_rates.l3_air.rate_obj.commodity_data, function(commodity){
                if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                  vm.listOfFilterObj.commodityList.push(commodity);
                }
              });
            }

            // adding vas leg if its applied vm.vasDetails
            if(vm.isVasApplied){
              var rate_card  = [newCardData.card];
              resultService.applyVASLegToCard( rate_card,  vm.vasDetails.legList , 'result');
            }

            var newCardTemp = angular.copy(newCardData.card);
            vm.allRatesArray[0].data.rates = angular.copy(newCardData.rates);
            vm.allRatesArray[0].data.cards.push(newCardTemp);

            vm.allRatesArrayCopy[0].data.rates = angular.copy(newCardData.rates);
            vm.allRatesArrayCopy[0].data.cards.push(newCardData.card);

            vm.resultCardArray.unshift(newCardData.card);
            vm.viewDirectFilter = true;
            $rootScope.loadingDetails = false;
            util.isCallingApi = false;
            vm.cancelDialog();
            vm.fnCardSorting();
            vm.fnCardFilter();
            util.showToast('Card added successfully');
          },function(error){
            util.isCallingApi = false;
            $rootScope.loadingDetails = false;
            vm.disableFrm = false;
            $log.log(error);
            util.showToast(util.displayValidationError(error));
          });
        }
        else if(action == 'editLeg'){
          vm.editCard = angular.copy(currentCard);
          vm.updateCardDetails(vm.editCard);
        }

        //mixpanel code
        util.callMixpanel("New Rate Card Added",{
          "Mode":vm.search_param.mode,
          "Carrier List":leg_data.airline.air_line_name
        });
      }

      //open edit card modal -ankita
      function openEditCardModal(cardData, ev , index){

        if(vm.resultCardFilter.countApiCard){
          return;
        }

        shareQuoteService.isQuoteOrNewcard = 'newCard';
        if(vm.quoteArray.length && vm.quoteArray.includes(cardData._id)){
            vm.showCardRemoveFromQuote(ev,index, cardData,'editCard');
            return;
        }

        if(!vm.quoteArray.length){
          vm.resultCardFilter.hideBookBtn = false;
        }
        
        vm.tempEditCard = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === cardData._id; });
        vm.editCard = angular.copy(vm.tempEditCard);

        vm.footerObj = { 
          "doneBtnDisable" : false,
          "buyTotalWithConv" : 0,
          "buyTotalBaseCurr" : 0,
          "sellTotalBaseCurr" : 0,
          "profit" : 0,
          "rateExpired":false
        };

        vm.pageSource = 'editCardSearch';


        $mdDialog.show({
          template: '<md-dialog id="add-new-rate" class="ViewModal popup-lg"><add-new-rate page-source="ctrl.parent.pageSource" search-param="ctrl.parent.search_param" page-info="ctrl.parent.pageInfo" result-card-filter="ctrl.parent.resultCardFilter" is-add-new-rate-loaded="ctrl.parent.isAddNewRateLoaded" card-data="ctrl.parent.editCard" footer-obj="ctrl.parent.footerObj" callback="ctrl.parent.showQuoteProceedDiv(item)"></add-new-rate><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded" class="mb-20-percent"></div><div shimmer-effect width="100%" height="100%" ng-if="!ctrl.parent.isAddNewRateLoaded"></div></md-dialog>',
            targetEvent        : ev,
            clickOutsideToClose: false,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm },
            onRemoving: function (event, removePromise) {
              for (var name in CKEDITOR.instances) {
                CKEDITOR.instances[name].destroy();
              }
            }
        });
      }

      //function to update card 
      function updateCardDetails(currentCard){

        var data = {
          'cards' : [ currentCard ]
        }
        $rootScope.loadingDetails = true;
        util.isCallingApi = true;
        vm.editCard.meta["isScheduleCall"] = false;

        resultService.fnUpdateRates(data, vm.result_id).then(function(response){

          vm.editCard.meta["conversionRate"] = resultService.fnGetConversionRates(vm.resultCardFilter.currency_conversion_rates, vm.editCard.meta.vendor_id,vm.search_param.mode);
          vm.editCard.meta['buy_leg_total'] = resultService.calCardTotal(vm.editCard.data.buy_rates);
          vm.editCard.meta['card_total_cost'] = resultService.calCardTotal(vm.editCard.data.sell_rates);
          vm.editCard.meta["isScheduleCall"] = true;
          resultService.fnSetTransitTime(vm.editCard, 'l3_air');

          if( vm.editCard.data.buy_rates["l2_air"] && vm.editCard.data.buy_rates["l2_air"].rate_obj && vm.editCard.data.buy_rates["l2_air"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.originTransporterList.indexOf(vm.editCard.data.buy_rates["l2_air"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
            vm.listOfFilterObj.originTransporterList.push(vm.editCard.data.buy_rates["l2_air"].rate_obj.sub_vendor.sub_vendor_name);
          }

          if( vm.editCard.data.buy_rates["l4_air"] && vm.editCard.data.buy_rates["l4_air"].rate_obj && vm.editCard.data.buy_rates["l4_air"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.destinationTransporterList.indexOf(vm.editCard.data.buy_rates["l4_air"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
            vm.listOfFilterObj.destinationTransporterList.push(vm.editCard.data.buy_rates["l4_air"].rate_obj.sub_vendor.sub_vendor_name);
          }

          if( vm.editCard.data.buy_rates["l1_air"] && vm.editCard.data.buy_rates["l1_air"].rate_obj && vm.editCard.data.buy_rates["l1_air"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.pickupTransporterList.indexOf(vm.editCard.data.buy_rates["l1_air"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
            vm.listOfFilterObj.pickupTransporterList.push(vm.editCard.data.buy_rates["l1_air"].rate_obj.sub_vendor.sub_vendor_name);
          }

          if( vm.editCard.data.buy_rates["l5_air"] && vm.editCard.data.buy_rates["l5_air"].rate_obj && vm.editCard.data.buy_rates["l5_air"].rate_obj.sub_vendor.sub_vendor_name && vm.listOfFilterObj.deliveryTransporterList.indexOf(vm.editCard.data.buy_rates["l5_air"].rate_obj.sub_vendor.sub_vendor_name) == -1 ) {
            vm.listOfFilterObj.deliveryTransporterList.push(vm.editCard.data.buy_rates["l5_air"].rate_obj.sub_vendor.sub_vendor_name);
          }

          // Storing agent name in vm.listOfFilterObj.agentList
          if(vm.editCard.data.buy_rates.l3_air.rate_obj.agent && vm.listOfFilterObj.agentList.indexOf(vm.editCard.data.buy_rates.l3_air.rate_obj.agent.agent_name) == -1){
            vm.listOfFilterObj.agentList.push(vm.editCard.data.buy_rates.l3_air.rate_obj.agent.agent_name);
          }

          // Storing cargo type name in vm.listOfFilterObj.cargoTypeList
          if(vm.editCard.data.buy_rates.l3_air.rate_obj.cargo_type_data && vm.editCard.data.buy_rates.l3_air.rate_obj.cargo_type_data.name && vm.listOfFilterObj.cargoTypeList.indexOf(vm.editCard.data.buy_rates.l3_air.rate_obj.cargo_type_data.name) == -1){
            vm.listOfFilterObj.cargoTypeList.push(vm.editCard.data.buy_rates.l3_air.rate_obj.cargo_type_data.name);
          }

          // Storing all commodity name in vm.listOfFilterObj.commodityList
          if(vm.editCard.data.buy_rates.l3_air.rate_obj.commodity_data && vm.editCard.data.buy_rates.l3_air.rate_obj.commodity_data.length){

            angular.forEach(vm.editCard.data.buy_rates.l3_air.rate_obj.commodity_data, function(commodity){
              if(vm.listOfFilterObj.commodityList.indexOf(commodity) == -1){
                vm.listOfFilterObj.commodityList.push(commodity);
              }
            });
          }


          var card = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === vm.editCard._id; });
          if(card){
            var cardIndex = vm.allRatesArray[0].data.cards.indexOf(card);
            vm.allRatesArray[0].data.cards[cardIndex] = angular.copy(vm.editCard);
            vm.allRatesArrayCopy[0].data.cards[cardIndex] = angular.copy(vm.editCard);
          }

          var rates = vm.allRatesArray[0].data.rates[vm.editCard.data.buy_rates.l3_air.rate_obj._id];
          if(rates){
            vm.allRatesArray[0].data.rates[vm.editCard.data.buy_rates.l3_air.rate_obj._id] = angular.copy(vm.editCard.data.buy_rates.l3_air.rate_obj);
            vm.allRatesArrayCopy[0].data.rates[vm.editCard.data.buy_rates.l3_air.rate_obj._id] = angular.copy(vm.editCard.data.buy_rates.l3_air.rate_obj);
          }

          var msrCard = vm.resultCardArray.find(function (obj) { return obj._id === vm.editCard._id; });
          if(msrCard){
            var msrCardIndex = vm.resultCardArray.indexOf(msrCard);
            vm.editCard.meta.showCard = angular.copy(vm.resultCardArray[msrCardIndex].meta.showCard);
            vm.resultCardArray[msrCardIndex] = angular.copy(vm.editCard);
          }

          var selectId = vm.resultCardArrayObj.findIndex(function(item){ return item._id === vm.editCard._id; });
          vm.resultCardArrayObj[selectId] = angular.copy(vm.editCard);

          $rootScope.loadingDetails = false;
          util.isCallingApi = false;
          vm.cancelDialog();
          util.showToast('Card updated successfully');
        },function(error){
          util.isCallingApi = false;
          $rootScope.loadingDetails = false;
          util.showToast(util.displayValidationError(error));
          $log.log(error);
        });
      }

      // get card leg user base currency total
      function rateTotalCustomCurr(cards){
        var convertTotal = 0;
        angular.forEach(cards,function(value){
            if(value.rate_obj){
                convertTotal += parseFloat(value.rate_obj.leg_total_cost);
            }
        });
        if($rootScope &&$rootScope.precision_decimals){
          convertTotal = $filter('number')(convertTotal, $rootScope.precision_decimals);
          }else{
            convertTotal = $filter('number')(convertTotal, 2);
          }
        convertTotal = Number(convertTotal.split(',').join(''));
        return convertTotal;
      }

      function showCardRemoveFromQuote(ev,index, cardData,action){
          var confirm = $mdDialog.confirm()
                // .title('Warning')
                .textContent('This change will remove card from your quote section, do you want to continue?') //add msg
                .ariaLabel('discard')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

          $mdDialog.show(confirm).then(function() {
              if(action == 'editCard'){
                  vm.removeFromQuote(cardData);
                  vm.openEditCardModal(cardData, ev, index);
              }else if(action == 'deleteCard'){
                  vm.removeFromQuote(cardData);
                  vm.fnDeleteData();
              }
          }, function() {
            return true;
          });
      }

      //open delete card modal -ankita
      function openDeleteCard(card, ev, index){

          vm.deleteLeg = card;
          vm.deletedIndex = index;

          if(vm.quoteArray.length && vm.quoteArray.includes(card._id)){
              vm.showCardRemoveFromQuote(ev,index, card,'deleteCard');
              return;
          }
          vm.deleteType="Rate Card"
          $mdDialog.show({
              templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
              targetEvent        : ev,
              clickOutsideToClose: true,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm }
          });
      }

      //function to delete card - ankita - 23/5/18
      function fnDeleteData(){
        vm.deleteBtn = true;
        util.isCallingApi = true;
        resultService.deleteCard(vm.result_id,vm.deleteLeg._id).then(function(response){
          var msrIndex = vm.allRatesArrayCopy[0].data.cards.indexOf(vm.deleteLeg);
          vm.allRatesArrayCopy[0].data.cards.splice(msrIndex, 1);

          var resultIndex = vm.resultCardArray.indexOf(vm.deleteLeg);
          vm.resultCardArray.splice(resultIndex, 1);


          var card = vm.resultCardArrayObj.find(function (obj) { return obj._id === vm.deleteLeg._id; });
          if(card){
            var cardIndex = vm.resultCardArrayObj.indexOf(card);
            vm.resultCardArrayObj.splice(cardIndex, 1);
          }

          var card = vm.allRatesArray[0].data.cards.find(function (obj) { return obj._id === vm.deleteLeg._id; });
          if(card){
            var cardIndex = vm.allRatesArray[0].data.cards.indexOf(card);
            vm.allRatesArray[0].data.cards.splice(cardIndex, 1);
          }

          var rates = vm.allRatesArray[0].data.rates[vm.deleteLeg.data.buy_rates.l3_air.rate_obj._id];
          if(rates){
            delete vm.allRatesArray[0].data.rates[vm.deleteLeg.data.buy_rates.l3_air.rate_obj._id];
          }

          util.showToast('Card deleted successfully');
          vm.deleteBtn = false;
          vm.cancelDialog();

          var viewFilter = 0;
          angular.forEach(vm.allRatesArrayCopy, function(allRatesArray){
            if(allRatesArray.data.cards.length){
              viewFilter ++;
            }
          });

          vm.fnCardFilter();

          if(!viewFilter){
            vm.viewDirectFilter = false;
          }
          util.isCallingApi = false;
        },function(error){
          $log.log(error);
          util.showToast(util.displayValidationError(error));
          vm.deleteBtn = false;
          util.isCallingApi = false;
        });
      }

      // on screen size hide list view
      function resizeScreenSize() {
        vm.resultCardFilter.deviceName = util.resizeScreen(vm.resultCardFilter.deviceName);

        $timeout(function(){
          if(angular.element(document.querySelector('.search-edit-div'))[0]){
            var searchDivHeight = angular.element(document.querySelector('.search-edit-div'))[0].offsetHeight;
            vm.extraDivHeight = searchDivHeight;

            vm.countMarginTop = { 'top' : searchDivHeight + 'px'};
            vm.leftFilterTopMargin = { 'position' : 'sticky', 'top' : searchDivHeight + 'px' };
            if(vm.extraDivHeight == 0){
              vm.isStikyFilter = true;
            }
            // var countBarHeight = angular.element(document.querySelector('.result_count_bar'))[0].offsetHeight;
            // var quotefooterHeight = angular.element(document.querySelector('#footer-content'))[0] ? angular.element(document.querySelector('#footer-content'))[0].offsetHeight : 0;
          }
        }, 200)
      }

      window.onresize = vm.resizeScreenSize;

      // page scroll upto top
      
      function scrollTop(){
        angular.element("#content").animate({
          scrollTop: 0
        }, 300);
        return false;
      }

      // hide toolbar on scroll
      function onScrollAction() {
        if(vm.isStikyFilter == true){
            vm.resizeScreenSize();
            vm.isStikyFilter = false;
        }
        if(vm.isDestroy !== true ){

          var raw = document.querySelector('#content');
          if (raw.scrollTop > document.getElementById("toolbar-navigation-container").offsetHeight) {
            document.querySelector('#result-return-to-top') ? document.querySelector('#result-return-to-top').classList.remove('hide') : '';
            // document.querySelector('#toolbar-navigation-container').classList.add('hide');
          }else{
            document.querySelector("#result-return-to-top") ? document.querySelector('#result-return-to-top').classList.add('hide') : '';
            // document.querySelector('#toolbar-navigation-container').classList.remove('hide');
          }
        }
      };

      this.$onInit = function() {
        vm.isScrollBind = true;
        document.querySelectorAll("#toolbar-navigation-container")[0].style.top = 'auto';
        angular.element(document.querySelector('#content')).bind('scroll', function(){
          vm.onScrollAction();
          if(!util.isMobileDevice && vm.leftFilterTopMargin){
            if($('#content').height() < $('.filter-container').height()){
              vm.leftFilterTopMargin.top = $('#content').height()-$('.filter-container').height()+'px';
            }
          }
        })
      }

      $scope.$on('$destroy', function() {
        document.querySelectorAll("#toolbar-navigation-container")[0].style.top = 0;
        // if(document.querySelector('#toolbar-navigation-container').classList.contains('hide')){
        //   document.querySelector('#toolbar-navigation-container').classList.remove('hide');
        // }
        vm.isDestroy = true;
        vm.scrollTop();

      });

      // event to bind for unload
      $window.onbeforeunload = function (e){
        if($location.url().indexOf('result') !== -1 ){
            return false;
        };
      }

      function trackAnalytics(type, item) {
        if(type === "AllInQuote") {
          util.callMixpanel("RR-Allin-Change",{
            "QuoteType" : item
          });
        }
      }

      function fnDialogSwitchToRateCard(ev) {
        if(vm.viewMode === ev){
          return;
        }
        if(!vm.isCardChanges){
          vm.fnSwitchMode(ev)
          return;
        }
        vm.leaveType = "rateCardViewSwitch";
        vm.modeChanges = ev;
        $mdDialog.show({
            templateUrl        : 'app/main/component/rate-card-table/confirm-leave/confirm-leave.html',
            targetEvent        : ev,
            clickOutsideToClose: true,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm }
        });
      }
      function selectAllColumn(){
        vm.visibleColumnList.columnsList.forEach(function(column){
          if(!column.isActive){
            column.isActive = true;
            resultService.triggerDatatableButton('.buttons-columnVisibility',column);
          }
        })
        vm.visibleColumnList.columnsHide = 0;
      }
      function fnSwitchMode(viewMode){
        vm.fnCancelQuote();
        vm.isCardChanges = false;
        vm.viewMode = viewMode;
        $mdDialog.hide();
      }

      function trackEvent(event,mixpanelObj) {
        util.callMixpanel(event,mixpanelObj);
      }

      function fnRateCardTable(payload){
        vm.showQuoteProceedDiv({'currentCard' :payload.currentCard, 'action' : payload.action });
      }
      function emptyRatesFilter(){
        $rootScope.$emit('emptyRates', vm.hideRates);

      }

      function fnOpenFreightIndex(ev){
        util.callMixpanel("RR-FreightIndex-Click",{ "Mode": vm.search_param.mode });
        if(vm.isMultiPort){
          vm.search_param.user_nearby_origin.forEach(function(item){
            vm.search_param.user_nearby_destination.forEach(function(item1){
              vm.DashboardFilterData.push(item.global_port_code+"_"+item1.global_port_code);
            })
          })
        }
        else{
          var origin = vm.search_param.origin_location.global_port_code;
          var destination = vm.search_param.destination_location.global_port_code;
          vm.DashboardFilterData = [origin+"_"+destination];
        }
        $mdDialog.show({
          template: '<md-dialog class="ViewModal popup-lg"> <md-dialog-content> <databrain-component dashboard-name="Freightify Freight Index" dashboard-id="Index_contract" dashboard-filter-data="ctrl.parent.DashboardFilterData"></databrain-component> </md-dialog-content><md-dialog-actions><div class="footer freight-index-footer"> <div><div class="edit_btn h-40 brad-5 p-15 pointer md-accent-btn with-icon" layout="row" ng-click="ctrl.parent.fnCloseFreightIndex()" layout-align="center center">Close</div></div></div></md-dialog-actions></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          controllerAs: 'ctrl',
          controller: function () { this.parent = vm },
        });
      }
  
      function fnCloseFreightIndex(){
        $mdDialog.hide();
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quotes')
        .controller('QuotesController', QuotesController);

    /** @ngInject */
    function QuotesController(QuotesService,util, SearchService, $state,$filter, $log, $scope, localStorageService, $sanitize,$mdSidenav,RoleService, $rootScope,$mdDialog, $mdPanel)
    {
        var vm = this;
        vm.util = util;
        vm.maskLiner=(util.isShipper && $rootScope.domainData.domain_info.SHIPPER_MASK_CARRIER)
        vm.scrollTop = scrollTop;
        vm.QuotesService = QuotesService;
        vm.util.screenTitle="Quotes";
        vm.quoteStatusArray = [];
        vm.activeCount = '';
        vm.expCount = '';
        vm.vendor_id = localStorageService.get('authToken').value.vendor_id;
        vm.viewCopyQuoteDetails=viewCopyQuoteDetails;
        vm.showQuoteInList = true;
        vm.showQuoteInCard = false;
        vm.statusExpiryObj = null;
        vm.statusActiveObj = null;
        vm.isGridCardAvailable = false;
        vm.activeTab = 'active';
        vm.showData = true;
        vm.showCardData = false;
        vm.filterMode = [
            {"mode":"SEA-FCL","selected":false},
            {"mode":"SEA-LCL","selected":false},
            {"mode":"AIR","selected":false}
        ];
        vm.filterObject = {
            "data": {
              "limit": 30,
              "offset": 0,
              "status": [
                "All"
              ],
              "mode": [],
              "date_range": {
                "from": new Date(new Date().setDate(new Date().getDate() - 30)),
                "to": new Date()
              },
              "created_by": {
                "data": []
              },
              "customer_details": {
                "data": {
                  "user": [],
                  "company": []
                }
              },
              "incoterms": [],
              "origin": [],
              "destination": [],
              "load_types": [],
              "sort_by": "created_on",
              "sort_by_type": "DESC",
              "templates": []
            }
          }
          vm.defaultFilterObjStore = angular.copy(vm.filterObject.data); // store deafult filter Object
          vm.quoteParam = {
            'deviceName' : '',
            'createdBySelected' : [],
            'customerSelected' : [],
            'originSelected' : [],
            'destSelected' : [],
            'loadTypeSelected' : [],
            'templateSelectedValue' : [],
            'incoTermsSelected': [],
            'isResetFilter' : false
          };
        vm.filterCreatedBy = [];
        vm.filterCreatedFor = [];
        vm.filterCustomerCompany=[];
        // for new filter design
        vm.filter_mode_list = [];
        vm.created_by = [];
        vm.created_for = [];
        vm.shipper_companies=[];
        vm.tabWiseQuotes = [];
        vm.isLoadMoreActive = false;
        vm.disableSetReminder = false;
        vm.isLoadFilterComponent = false; // it's used for god user account

        // method
        //vm.getQuoteByStatus = getQuoteByStatus;
        //vm.getActiveTabQuoteData = getActiveTabQuoteData;
        //vm.formStatusListArr = formStatusListArr;
        vm.showResetBtn = showResetBtn;
        //vm.showApplyBtn = showApplyBtn;
        //vm.resetFilter = resetFilter;
        //vm.updateSearch = updateSearch;
        vm.fnCallStatusChangeApi = fnCallStatusChangeApi;
        vm.cancelDialog = cancelDialog;
        vm.getActiveTabIndex = getActiveTabIndex;
        vm.isStatusLoading = true;
        vm.fnShowDeleteCard = fnShowDeleteCard;
        vm.fnConfirmDeleteCard = fnConfirmDeleteCard;
        //vm.selectMode = selectMode;
        vm.openSelectBox = openSelectBox;
        vm.viewQuoteDetails = viewQuoteDetails;
        vm.formContainerType = formContainerType;
        vm.fnChangeStatus = fnChangeStatus;
        vm.toggleSideNav = toggleSideNav;
        //vm.getUsersListForFilter = getUsersListForFilter;
        //vm.getCreatedForList = getCreatedForList;
        //vm.getCustomerCompanyList=getCustomerCompanyList;
        //vm.filterQuotes = filterQuotes;
        //vm.collapseIt = collapseIt;
        //vm.filterItemtoggle = filterItemtoggle;
        //vm.filterItemExists = filterItemExists;
        vm.onScrollAction = onScrollAction;
        vm.getDomainData = getDomainData;
        vm.resizeScreenSize = resizeScreenSize;
        //vm.trackEvent = trackEvent;
        vm.getQuotesList = getQuotesList;
        vm.submitFilter = submitFilter;
        vm.loadMoreRecords = loadMoreRecords;
        vm.fnCutOffDateSortBy = fnCutOffDateSortBy;
        vm.fnOpenStatusChangePanel = fnOpenStatusChangePanel;
        vm.fnSearchQuote = fnSearchQuote;

        QuotesService.filterParams.deviceName = '';
        function resizeScreenSize() {
          QuotesService.filterParams.deviceName = util.resizeScreen(QuotesService.filterParams.deviceName);
          vm.quoteParam.deviceName = QuotesService.filterParams.deviceName;
        }
        window.onresize = vm.resizeScreenSize;

        // search Quotes result
        var myListener = $rootScope.$on('quotesListWithSearch', function () {
            //vm.getQuoteByStatus(true);
            init()
        });
        $scope.$on('$destroy', myListener);


        // banner listner
        var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
          calculateMaxHeight();
        });
        $scope.$on('$destroy', bannerListener);

        $rootScope.$on('app.quotes', function(event, args) {
            //vm.getQuoteByStatus(true);
            vm.isLoadFilterComponent = true;
            init();
        });

        // decimal points handling
        vm.setThreeNumberDecimal = SearchService.setThreeNumberDecimal;

        function init(){
        
            util.isModulePaid('quotes');
            if(!(util.navPermission.quotes && util.navPermission.quotes[1])){
              $state.go('app.pages_share_error');
            }

            vm.getDomainData();

            document.getElementById("inner-content").style.maxWidth = "100%";
            document.getElementById("inner-content").style.padding = "0";
            vm.filterObject.data.search = QuotesService.filterParams.search; // global search quote filter
            vm.dataNotAvailable = false;
            vm.created_by = [];
            vm.created_for = [];
            vm.shipper_companies=[];
            vm.filterObject.data.offset = 0;
            vm.isLoadMoreActive = false;
            util.isCallingApi = true;
                vm.quoteData = {
                  quotesList : null,
                  quotesCount: null,
                  shimmer : true
                }
            if(!util.isFreightbro ){
                vm.getQuotesList();             
                /*
                QuotesService.getQuoteList(true).then(function(response){
                    vm.quoteListData = response.data.data.status_data;
                    vm.quotesTotalCount = response.data.data.ids.length;

                    // For All quotes data
                    var allQuotes = {'status' : 'All', 'count' : vm.quotesTotalCount,'ids': response.data.data.ids};
                    vm.quoteListData.unshift(allQuotes);

                    util.isCallingApi = false;
                    if(vm.quoteListData){
                      vm.filterStatus = vm.quoteListData[0];
                        if(vm.filterStatus.quotesList) {
                            vm.getQuoteByStatus();
                        }else{
                            vm.isStatusLoading = true;
                            vm.filterStatus.quotesCount = vm.filterStatus.count;
                            vm.filterStatus = vm.filterStatus;
                            vm.getActiveTabQuoteData(vm.filterStatus,30,0);
                            vm.getActiveTabIndex(); // activate tab which is having filtered data
                        }
                    }else{
                        vm.formStatusListArr(vm.quoteListData);
                    }
                    calculateMaxHeight();
                },function(error){
                    util.isCallingApi = false;
                    $state.go(util.redirectIfError(error));
                    calculateMaxHeight();
                });*/
            }else{
                // util.isCallingApi = true;
                RoleService.getForwarder().then(function(response){
                    vm.forwarderList = response.data.data;
                    if(vm.forwarderList.length > 0){
                        vm.filterForwarderId = vm.forwarderList[0].id;
                        //vm.getQuoteByStatus();
                        if(!vm.isLoadFilterComponent){ // it's used for god user account
                          vm.getQuotesList(); // get list of Quotes
                        }
                        vm.isLoadFilterComponent = false;
                    }

                    // util.isCallingApi = false;
                    vm.quoteListData = [];
                    vm.isStatusLoading = false;
                    calculateMaxHeight()
                    return vm.forwarderList;
                },function(error){
                //   util.isCallingApi = false;
                  vm.quoteListData = [];
                  vm.isStatusLoading = false;
                  calculateMaxHeight();
                    $log.log(error);
                    $state.go(util.redirectIfError(error));
                });
            }

            QuotesService.filterParams = {
                'mode' : '',
                'status' : '',
                'created_by' : '',
                'created_for' : '',
                'search' : QuotesService.filterParams.search,
                'isBooked' : '',
                'shipper_companies':''
            };
            // analytics.track("Quotes"); //mixpanel code
            vm.leftFilterTopMargin = {'position' : 'sticky','top':'0px'};
            angular.element(document.querySelector('#quotes-page-new')).bind('scroll', function(){
              vm.onScrollAction();
              if(!util.isMobileDevice && vm.leftFilterTopMargin){
                if($('#quotes-page-new').height() < $('.filter-container').height()){
                  vm.leftFilterTopMargin.top = $('#quotes-page-new').height()-$('.filter-container').height()+'px';
                }
              }
            });
            vm.resizeScreenSize();
          }
          
        init();

        function calculateMaxHeight(){
          vm.maxHeight = util.getModuleMaxHeight(vm.maxHeight,'list');
          vm.maxFilterHeight = util.getModuleMaxHeight(vm.maxFilterHeight,'quotesFilter');
          vm.quoteParam.maxHeight = vm.maxHeight;
        }


        function getDomainData(){
          if(!Object.keys($rootScope.domainData.domain_info).length){
            util.getDomainData().then(function(){
              vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
            },function(error){
                $log.log(error.data);
            });
          }else{
              vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
          }
        }


        
        /*function filterItemtoggle(item, list, type) {

          if(!type) {
            if (!list) {
              list = [];
            }

            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            } else {
              list.push(item);
            }
          } else {
            vm.filterStatus = angular.copy(item);
          }
        };

        function filterItemExists(item, list, type) {
          if(!type) {
            if (!list) {
              return
            };
            return list.indexOf(item) > -1;
          } else {
            return vm.filterStatus.status === item.status ? true : false;
          }
          
        };*/

        /**
         * function to form load details
         * @param {*} loadDetails
         */
        function formContainerType(mode, loadDetails, list){
            var result = '';
            if(loadDetails != null){
                if(mode == 'SEA-FCL'){
                    result =  util.formLoadDetails(loadDetails, list);
                }
                else if(mode != 'SEA-FCL'){
                    result =  util.formAirLoadDetails(loadDetails, mode);
                }
            }
            return result;
        }
        function viewCopyQuoteDetails(id,ev){
          ev.stopPropagation();
          util.showToast("Please wait while we redirect you to the copy quote page you requested");
          $state.go('app.CopyQuoteDetailsController',{ id: id});
        }

        function viewQuoteDetails(shipment, id,type,ev){
            // if(shipment.mode == 'SEA-FCL'){
               
                //$state.go('app.quotes.quotesDetails',{ id: id});
            // }
            // else if(shipment.mode == 'AIR'){
            //     $state.go('app.quotes.airQuotesDetails',{ id: id});
            // }
              ev.stopPropagation();
              util.pageOpenNewTab('app.quotes.quotesDetails',{ id: id});
             
        }

        //Quote status change
        function fnChangeStatus(quote, statusData, ev){
            vm.followupValidation=false;
            vm.disableSetReminder=false;
                vm.oldReminder=null;
            if(quote.reminder.length >0 && quote.reminder[0].reminder_date){
                vm.disableSetReminder = (quote.reminder[0].created_by.id != util.userProfile.user.id) ? true:false;
                 vm.oldReminder = angular.copy(quote.reminder[0].reminder_date) ;
                 statusData.reminder_date=util.dateReplace(quote.reminder[0].reminder_date);
            }
            ev.stopPropagation();
            if(statusData.comment_required){
                statusData.comment = '';
                var date = new Date();
                // add a day
                date.setDate(date.getDate() + 1);
                
                vm.status_change_obj = {
                    'statusData' : statusData,
                    'quote' : quote,
                    'End_date': angular.copy( new Date(quote.expiry_date)) ,
                    'Start_date':date,
                }
                $mdDialog.show({
                    templateUrl        : 'app/main/quotes/dialogs/quote-status-change/quote-status-change.html',
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    controllerAs: 'ctrl',
                    controller: function() { this.parent = vm }
                });
            }else{
                vm.fnCallStatusChangeApi(quote, statusData);
            }

        }

        function fnCallStatusChangeApi(quote, statusData,form){
          
          if(vm.status_change_obj && !vm.status_change_obj.statusData.comment && !form.comment.$invalid){
            vm.followupValidation=true;
            if(vm.status_change_obj.statusData.status==='Lost'){
              util.callMixpanel('QL-Lost-Done-Click',{
                validations : {
                  Required : "Enter the reason to Lost"
                }
              });
            }
            return;
          }
        if(form && form.$invalid){
            return;
        };
            vm.disabledStatusSubmit = true;
            var data = QuotesService.fnSetActivityList(quote , statusData,vm.oldReminder)
            QuotesService.statusQuoteChange(data,quote.status).then(function(){
                vm.disabledStatusSubmit = false;
                vm.listLoader = true;
                vm.isLoadMoreActive = false;
                vm.quoteData.quotesList = [];
                vm.filterObject.data.offset = 0;
                vm.getQuotesList();
                util.showToast('Status Changed Successfully.');
                vm.cancelDialog();
            },function(error){
                vm.disabledStatusSubmit = false;
                util.showToast(util.displayValidationError(error));
                $log.log(error);
            });
        }

        function toggleSideNav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /*function getUsersListForFilter(type,serach_text){
            vm.filterLoader = true;
            QuotesService.getUsersListForFilter('quote_filter',type,serach_text).then(function(response){
                if(type=='SHIPPER'){
                    vm.filterCreatedFor=response.SHIPPER;
                }
               if (type=='FORWARDER'){
                vm.filterCreatedBy=response.FORWARDER;
              
               }
              if(type=='SHIPPERCOMPANY'){
                vm.filterCustomerCompany=response.SHIPPERCOMPANY;
              }
              vm.filterLoader = false;
            },function(error){
                $log.log(error);
            });
        }
        function filterQuotes(mode,created_by,created_for,shipper_companies) {
            util.callMixpanel("Quote-filter-Apply");
            if(mode.length == 0 && created_by.length == 0 && created_for.length == 0 && shipper_companies ==0 && !vm.filterByBooking && !vm.filterForwarderId){
                return false;
            }
            vm.modeFilter = [];
            vm.created_by_filter = [];
            vm.created_for_filter = [];
            vm.shipper_companies_filter=[];
            var i;

            for (i = 0; i < mode.length; i++) {
                if(mode[i].selected){
                    vm.modeFilter.push(mode[i].mode);
                }
            }

            for (i = 0; i < created_by.length; i++) {
                 vm.created_by_filter.push(created_by[i].id);
            }

            for (i = 0; i < created_for.length; i++) {
                vm.created_for_filter.push(created_for[i].id);
               
            }
            for (i = 0; i < shipper_companies.length; i++) {
                vm.shipper_companies_filter.push(shipper_companies[i].id);
            }

            QuotesService.filterParams.mode = vm.modeFilter;
            QuotesService.filterParams.created_by = vm.created_by_filter;
            QuotesService.filterParams.created_for = vm.created_for_filter;
            QuotesService.filterParams.isBooked = vm.filterByBooking;
            QuotesService.filterParams.shipper_companies=vm.shipper_companies_filter;
            vm.getQuoteByStatus(true);

        }*/

        //function to get status array and its quotes id list
       /* function getQuoteByStatus(filter){

            if(util.isFreightbro){ QuotesService.filterParams.company_id = $rootScope.forwarder_id; };  //assign forwarder id if god user
            // vm.filterForwarderId

            if(filter){ vm.tabWiseQuotes = []; }; //empty tab array while filtering data
            // util.isCallingApi = true;
            vm.listLoader = true;
            vm.isStatusLoading = true;
            //vm.util.isCallingApi = true;
            QuotesService.getQuoteList().then(function(response){ //get quote list
                vm.quoteListData = response.data.data.status_data;
                vm.quotesTotalCount = response.data.data.ids.length;
                // For All quotes data
                var allQuotes = {'status' : 'All', 'count' : vm.quotesTotalCount,'ids': response.data.data.ids};
                vm.quoteListData.unshift(allQuotes);

                if(!vm.filterStatus){
                  vm.filterStatus = vm.quoteListData[0];
                }else{
                  vm.quoteListData.forEach(function(i) {
                    if(i.status === vm.filterStatus.status) {
                      vm.filterStatus = i;
                    }
                  });
                }

                if(vm.quoteListData == undefined || !vm.quoteListData.length){
                    vm.quoteListData = [];
                    vm.dataNotAvailable = true;
                    vm.isStatusLoading = false;
                    // util.isCallingApi = false;
                    vm.listLoader = false;
                    return true;
                }
                if(vm.filterStatus){  //get quote list data for first status
                    vm.filterStatus.quotesCount = vm.filterStatus.count;
                    vm.getActiveTabQuoteData(vm.filterStatus,30,0);
                }else{
                  vm.formStatusListArr(vm.quoteListData)
                };
                util.isCallingApi = false;
                // vm.listLoader = false;
                vm.getActiveTabIndex(); // activate tab which is having filtered data

                vm.isStatusLoading = false;
            },function(error){
                vm.isStatusLoading = false;
                util.isCallingApi = false;
                vm.listLoader = false;
                $log.log(error);
            });
        }*/

        function getActiveTabIndex(){
            // if(QuotesService.filterParams.search){
            //     var isCheckingStatus = 1;
            //     for(var i=0 ; i < vm.quoteListData.length; i++){
            //         if(vm.quoteListData[i].count && isCheckingStatus){
            //             vm.activeTabIndex = i;
            //             isCheckingStatus = 0;
            //         }
            //     }
            // }else{
                vm.activeTabIndex = 0;
            // }

        }

        //function to call quote data api
        /*function getActiveTabQuoteData(quoteData,count,offset,lazyLoad){
            if(!quoteData) {
              return;
            }
            if(offset === 0){
                vm.scrollTop();
            }
            quoteData.quotesList = !(quoteData && quoteData.quotesList) ? [] : quoteData.quotesList;
            //call api if quotes count is not equal to current quote list count and its ids count is not 0
            if(quoteData.quotesCount !== quoteData.quotesList.length && quoteData.ids.length!==0 && !vm.callQuotesApi){
                // if(offset >= quoteData.quotesList.length){ //if quotes already loaded then dont call api
                    var data = {
                        "ids" : quoteData.ids,
                        "count" : count,
                        "offset" : offset
                    }
                    vm.callQuotesApi = true;

                    if(lazyLoad){ //set offset while lazy loading
                        data.offset = quoteData.quotesList.length;
                    }else{
                        quoteData.quotesList = [];
                        quoteData.shimmer = true;
                    }
                    // util.isCallingApi = true;
                    vm.listLoader = true;
                    QuotesService.getQuoteData(data).then(function(response){
                        if(lazyLoad){ //add response if scrolling else assign to list
                            quoteData.quotesList = quoteData.quotesList.concat(response.quotes);
                        }else{
                            quoteData.quotesList = response.quotes;
                            quoteData.shimmer = false;
                        }
                        if(vm.tabWiseQuotes.length == 0){ //form tab status obj at first time or array is empty
                            vm.formStatusListArr(vm.quoteListData);
                            quoteData.shimmer = false;
                        }
                        // util.isCallingApi = false;
                        vm.listLoader = false;
                        vm.isStatusLoading = false
                        vm.callQuotesApi = false;
                    },function(error){
                        // util.isCallingApi = false;
                        vm.listLoader = false;
                        quoteData.shimmer = false;
                        vm.callQuotesApi = false;
                        $log.log(error);
                    });
                // }
            }

            if(quoteData.ids.length===0 && vm.tabWiseQuotes.length == 0){
                vm.formStatusListArr(vm.quoteListData);
            }

            // util.callMixpanel("Quo-"+quoteData.status);  //mixpanel code
        }*/

        // function to form final tabs structure
        /*function formStatusListArr(statusList){
            vm.isStatusLoading = false;
            // angular.forEach(statusList, function (item){
                var statusObj = {'status' : vm.filterStatus.status, 'quotesCount' : vm.filterStatus.count,'quotesList':vm.filterStatus.quotesList,'ids': vm.filterStatus.ids,'count': 30 , 'offset' : 0,'shimmer':false,'available_status': vm.filterStatus.available_status};
                vm.tabWiseQuotes.push(statusObj);
            // });
            vm.listLoader = false;
        }*/

        // function to show reset button
        function showResetBtn(){
            if(!QuotesService.filterParams.mode && (QuotesService.filterParams.mode.length == 0) && (QuotesService.filterParams.created_by.length == 0) && (QuotesService.filterParams.created_for.length == 0) && !QuotesService.filterParams.search && !QuotesService.filterParams.isBooked){
                return false;
            }else return true;
        }

        //function to show apply button
       /* function showApplyBtn(){

            if((vm.created_by.length == 0) && (vm.created_for.length == 0) && !vm.filterForwarderId && !vm.filterByBooking && !vm.filterMode[0].selected && !vm.filterMode[1].selected && !vm.filterMode[2].selected){
                return false;
            }else return true;
        }

        // function to reset filter
        function resetFilter(){
            // vm.filter_mode_list = "";
            util.callMixpanel("Quote-filter-ClearAll");
            vm.filterStatus = vm.quoteListData[0];
            vm.filterMode = [
                
                {"mode":"SEA-FCL","selected":false},
                {"mode":"SEA-LCL","selected":false},
                {"mode":"AIR","selected":false}
               
            ];
            vm.created_by = [];
            vm.created_for = [];
            vm.shipper_companies=[];
            vm.filterByBooking = false;

            if(!QuotesService.filterParams.mode && (QuotesService.filterParams.mode.length == 0) &&  (QuotesService.filterParams.shipper_companies.length == 0) && (QuotesService.filterParams.created_by.length == 0) && (QuotesService.filterParams.created_for.length == 0) && !QuotesService.filterParams.search){
              return;
            };

            QuotesService.filterParams = {
                'mode' : '',
                'status' : '',
                'created_by' : '',
                'created_for' : '',
                'search' : '',
                'isBooked' : '',
                'shipper_companies':''

            };
            vm.getQuoteByStatus(true);
            $rootScope.$broadcast('emptyQuoteSearchBox', { any: '' });
            vm.resizeScreenSize();
        }

        function updateSearch(e){
          e.stopPropagation();
        }*/

        //close modal
        function cancelDialog(type){
          if(vm.disabledStatusSubmit){
            return;
          }
            $mdDialog.hide();
            if(type==='Cancel' || type==='Close'){
              util.callMixpanel('QL-QuoteCard-'+vm.status_change_obj.statusData.status+'-'+type+'-Click');
            }
        }

        // scroll to top
        function scrollTop(mode){
          angular.element("#quotes-page-new").animate({
            scrollTop: 0
          }, 300);
          return false;
        }

        // show/hide scroll btn on scroll
        function onScrollAction() {
          var raw = document.querySelector('#quotes-page-new');
          if (raw.scrollTop > 50) {
            document.querySelector('#quote-return-to-top') ? document.querySelector('#quote-return-to-top').classList.remove('hide') : '';
          }else{
            document.querySelector("#quote-return-to-top") ? document.querySelector('#quote-return-to-top').classList.add('hide') : '';
          }
        };

        /*function selectMode(mode){
            mode.selected = mode.selected ? false : true;
        }*/

        function openSelectBox(id){
            angular.element('#'+id).triggerHandler('click');
        }

        function fnShowDeleteCard(ev, quote){
            vm.deleteQuote = angular.copy(quote);
            vm.deleteData = {
                "title" : "Quote",
                "deleteCard_id" : [quote._id],
                "source_title1" : "Searches",
                "source_id1" : "",
                "source_title2" : "Shipments",
                "source_id2" : "",
                "deleteSources" : false,
                "permanentDelete" : false
            };

            var data = {
                "data": {
                    "quote_ids":  vm.deleteData.deleteCard_id
                }
            }
            util.isCallingApi = true;
            util.delecteAssociates('quotes',data).then(function(response){
                vm.deleteData.source_id1 = response.data.data.search_ids.length ? Array.prototype.map.call(response.data.data.search_ids, function(item) { return item.search_name; }).join(",") : '';

                vm.deleteData.source_id2 = response.data.data.shipment_ids.length ? Array.prototype.map.call(response.data.data.shipment_ids, function(item) { return item.shipment_id; }).join(",") : '';

                $mdDialog.show({
                    templateUrl        : 'app/main/shipments/dialogs/delete-confirmation/deleteConfirmation.html',
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    controllerAs: 'ctrl',
                    controller: function() { this.parent = vm; }
                });
                util.isCallingApi = false;
            },function(error){
                util.isCallingApi = false;
                util.showToast(error.message,'top right', 3000);
                $log.log(error);
            });
        }
  
        function fnConfirmDeleteCard(){
            var data = {
                "data" : {
                    "data": {
                        "quote_ids": vm.deleteData.deleteCard_id,
                        "permanent_delete": vm.deleteData.permanentDelete,
                        "associate_delete": vm.deleteData.deleteSources
                    }
                }
            }
            util.isCallingApi = true;
            util.delecteCardsOnId('quotes',data).then(function(response){

                var getStatusList = $filter('filter')(vm.tabWiseQuotes, { 'status': vm.deleteQuote.status.status_list[vm.deleteQuote.status.status_list.length-1].status }, true);

                if(getStatusList.length){
                    var obj = getStatusList[0].quotesList.find(function (obj) { return obj._id === vm.deleteQuote._id; });

                    var index = getStatusList[0].quotesList.indexOf(obj);
                    getStatusList[0].quotesList.splice(index, 1);
                }
                util.isCallingApi = false;
                $mdDialog.hide();
                util.showToast('Quote Delete Successfully.');
            },function(error){
                util.isCallingApi = false;
                util.showToast(error.message,'top right', 3000);
                $log.log(error);
            });
        }

          function getQuotesList(){
            if(!vm.isLoadMoreActive){
              vm.scrollTop();
              vm.quoteData.shimmer = true;
            }
            if(vm.filterObject.data.search){
              vm.filterObject.data.date_range=null;
            }

            QuotesService.getQuotesList(vm.filterObject).then(function(response){
              angular.forEach(response.data.quotes,function(card){
                if(!card.search_param.hasOwnProperty('freight_charges')){
                  card.search_param['freight_charges'] = true;
                }
              });
              if(!vm.isLoadMoreActive){ // it's running initial binding Quotes List
                vm.quoteData.quotesCount = response.data.count;
                vm.quoteData.quotesList = response.data.quotes;
                vm.quoteData.shimmer = false;
                vm.isStatusLoading = false;
                util.isCallingApi = false;
                vm.resizeScreenSize();
                calculateMaxHeight();
              }else{ // it's on load more binding Inquries List 
                vm.quoteData.quotesList = vm.quoteData.quotesList.concat(response.data.quotes);//add response if scrolling else assign to list
              }  
              vm.listLoader = false;
              vm.isLoadMoreActive = false;

              // Quotes result greater then 30 records then active load more
              if(response.data.quotes.length >= vm.filterObject.data.limit){
                vm.isLoadMoreActive = true;
                vm.callQuotesApi = false;
              }
            },function(error){
                util.isCallingApi = false;
                //$state.go(util.redirectIfError(error));
                util.showToast(util.displayValidationError(error));
                calculateMaxHeight();
            });
          }

          function submitFilter(){
            if(vm.quoteParam.isResetFilter){
              angular.element('#globalSearchText').val('');
              QuotesService.filterParams.search = '';
              vm.filterObject.data = angular.copy(vm.defaultFilterObjStore)
            }
            vm.quoteData.quotesCount = 0;
            vm.listLoader = true;
            vm.isLoadMoreActive = false;
            vm.quoteData.quotesList = [];
            vm.filterObject.data.offset = 0;
            vm.getQuotesList(); // get list of quotes
          }

          // lazy loading function
        function loadMoreRecords(offset){
          if(offset === 0 || vm.isLoadMoreActive == false) {
            //vm.scrollTop();
            return;
          }
          if(offset !== 0 && !vm.callQuotesApi){ 
            vm.filterObject.data.offset =  offset;
            vm.listLoader = true;
            vm.callQuotesApi = true;
            vm.getQuotesList();
          }
        }

        // created sort by filter
        function fnCutOffDateSortBy(action){
          vm.filterObject.data.sort_by_type = action === 'ASC' ? 'DESC' : 'ASC';
          vm.listLoader = true;
          vm.isLoadMoreActive = false;
          vm.quoteData.quotesList = [];
          vm.filterObject.data.offset = 0;
          vm.getQuotesList(); // get list of inquiry
        }

        // status change
        function fnOpenStatusChangePanel(ev , quoteInfo){
          vm.quoteInfo = quoteInfo;
          if(quoteInfo.available_status.length <= 0 || vm.util.isShipper){
            return
          }
          ev.stopPropagation();
          var dropDownPosition = 'quote-'+quoteInfo.quote_id ;
         
            var position = $mdPanel.newPanelPosition()
            .relativeTo('.'+ dropDownPosition)
            .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
      
          var config = {
            templateUrl:
              "app/main/component/status-change-panel/status-change-panel.html",
            controllerAs: "ctrl",
            controller: "statusChangePanelController",
            position: position,
            openFrom: ev,
            trapFocus: true,
            zIndex: 1501,
            clickOutsideToClose: true,
            escapeToClose: false,
            focusOnOpen: true,
            locals: {
              quoteInfo : quoteInfo
            },
            onRemoving: function (event) {
              if(event.config.scope.ctrl.selectedStatus){
                vm.fnChangeStatus(quoteInfo ,event.config.scope.ctrl.selectedStatus ,ev);
              }
            }
          };
          $mdPanel.open(config);
      
        }

        
        function fnSearchQuote(text,$event){

            if(text.length < 3){
                return;
            }
            var keyCode = $event ? ( $event.which || $event.keyCode ) : 13;
            if ((keyCode === 13 || keyCode === 1)) {
               //Validate TextBox value against the Regex.
              var regex = /^[A-Za-z0-9|-]+$/;
              var isValid = regex.test(text);
              if (!isValid && text) {
                util.showToast('Special characters are not allowed.');
                return;
              }
              if(QuotesService.filterParams.search !== text){
                  QuotesService.filterParams.search = text;
                  QuotesService.filterParams.offset = 0;
                  init();
              }
            }
        }

    }

})();


(function () {
    "use strict";
  
    angular.module("app.quoteListModule").controller("QuoteListController", QuoteListController);
  
    /** @ngInject */
    function QuoteListController(util, iframeService, $timeout, $state,$scope, $window, $rootScope) {
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();
      $scope.$on('$destroy', function () {
        if (window.removeEventListener) {
          window.removeEventListener("message", getQuoteListIframeRequest, true);
        } else if (window.detachEvent) {
          window.detachEvent("onmessage", getQuoteListIframeRequest);
        }
      });
  
      function init() {
        // util.isModulePaid('oneQuote');
        vm.minHeight = vm.iframeService.iframeHeight;

        if(!(util.navPermission.quotes && util.navPermission.quotes[1] && util.isEfpEnabled)){
          $state.go('app.pages_share_error');
        }
        
        util.callMixpanel("EFP-Quotes-list");
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
          vm.formIframeUrl();
        }, 400);

        if(window.addEventListener) {
          window.addEventListener("message", getQuoteListIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getQuoteListIframeRequest, true);
        }

  
      }

      $rootScope.$on('app.quoteListModule', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('quote-list','','web');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&reqAccessV2QuoteList=1&maxHeight="+vm.minHeight["max-height"]);        
        console.log(vm.iframeUrl);
        document.getElementById("quote-list-iframe").src = vm.iframeUrl;

      }

      
      function getQuoteListIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if(event.origin.indexOf(util.iframeOrigin) && document.getElementById('quote-list-iframe')){
          if(event.data.source === 'quotes'){
            $state.go("app.quoteListModule.quoteDetailsModule",{ id: event.data.id });
          }
          if(event.data.source === 'old-quotes'){
            // const href = $state.href('app.quoteDetailsModule');
            $window.open('/quotes', '_blank');
          }
          if(event.data.source === 'one-quote'){
            util.redirectToOneQuote(event);
           }
        }
        if(event.data.source === 'redirectToHome'){
            $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
        }
      }
  
    }
  })();
  
  
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(AccountData,ProfileService,util,$mdDialog,$log,ToolbarSerivice,$state,$rootScope,loginSerivice,$timeout)
    {
        // Data
        var vm = this;
        vm.util = util;
        vm.util.screenTitle = "Profile";
        vm.user_data = AccountData.user;
        vm.decimalPlaces = [2,3];
        vm.pass_Error = false;
        vm.submit_user =  submit_user;
        vm.openChangePasswordModal = openChangePasswordModal;
        vm.submitUpdatedPassword = submitUpdatedPassword;
        vm.cancelDialog = cancelDialog;
        vm.logout = logout;
        vm.showPassErr = showPassErr;
        vm.validatePassword = validatePassword;
        vm.togglePassword = togglePassword;
        vm.showCurrentPassword = false;
        vm.showNewPassword = false;
        vm.showConfirmPassword = false;
        vm.currencyList = [];
        vm.validateEmail = validateEmail;
        vm.user_data.cc_email = !vm.user_data.cc_email ? [] : vm.user_data.cc_email;
        vm.units = vm.util.matricNumberObj.unit_measurements;
        vm.number_formates = vm.util.matricNumberObj.number_formats;
        vm.tms_enabled=$rootScope.domainData.domain_info.TMS_ENABLED;
        vm.tmsBranchOptions = [];
        vm.tmsDepartmentOptions = [];
        vm.tmsCompanyOptions = [];
        vm.tmsSuggest = { open: null, filtered: [] };
        vm.openTmsSuggestions = openTmsSuggestions;
        vm.closeTmsSuggestions = closeTmsSuggestions;
        vm.selectTmsSuggestion = selectTmsSuggestion;
        vm.onTmsFieldInput = onTmsFieldInput;
        vm.init = init;
        vm.user_data.email_signature = util.decodeValue(vm.user_data.email_signature);
        vm.fnOnlineCarrierSelectionChange = fnOnlineCarrierSelectionChange;
        
        vm.init();
        //vm.measurementsytem=$rootScope.loadunit;
      //  vm.unitsytem=$rootScope.userlang;
        CKEDITOR.config.image_previewText = CKEDITOR.tools.repeat( ' ', 1 );
        CKEDITOR.on('dialogDefinition', function( ev )
            {
                var dialogName = ev.data.name;
                var dialogDefinition = ev.data.definition;

                switch (dialogName) {
                case 'image': //Image Properties dialog
                dialogDefinition.removeContents('Link');
                dialogDefinition.removeContents('advanced');
                break;
                case 'link': //image Properties dialog
                dialogDefinition.removeContents('advanced');
                break;
            }
        });

        var tmsFieldConfig = {
            branch: {
                model: 'branch_id',
                options: 'tmsBranchOptions',
                domainKey: 'tms_branch',
                mixpanel: 'MP-BranchId-Change'
            },
            department: {
                model: 'department',
                options: 'tmsDepartmentOptions',
                domainKey: 'tms_department',
                mixpanel: 'MP-department-Change'
            },
            company: {
                model: 'tms_company',
                options: 'tmsCompanyOptions',
                domainKey: 'tms_company',
                mixpanel: 'MP-TMSCompany-Change'
            }
        };
        var tmsSuggestClosePromise = null;

        function init(){
       
          if(!util.currencyList.length){
            util.getCurrencyList().then(function(){
              vm.currencyList = util.currencyList;
            },function(error){
                vm.currencyList = [];
              $log.log(error);
            });
          }else{
            vm.currencyList = util.currencyList;
          }

          loadTmsIntegrationOptions();
        }

        function loadTmsIntegrationOptions() {
            vm.tmsBranchOptions = util.filterTmsIntegrationOptions('', 'tms_branch');
            vm.tmsDepartmentOptions = util.filterTmsIntegrationOptions('', 'tms_department');
            vm.tmsCompanyOptions = util.filterTmsIntegrationOptions('', 'tms_company');
        }

        function cancelTmsSuggestClose() {
            if (tmsSuggestClosePromise) {
                $timeout.cancel(tmsSuggestClosePromise);
                tmsSuggestClosePromise = null;
            }
        }

        function refreshTmsFiltered(fieldKey) {
            var config = tmsFieldConfig[fieldKey];
            if (!config) {
                vm.tmsSuggest.filtered = [];
                return;
            }
            vm.tmsSuggest.filtered = util.filterTmsIntegrationOptions(
                vm.user_data[config.model],
                config.domainKey
            );
        }

        function openTmsSuggestions(fieldKey) {
            // Cancel any pending blur-close so a new focus doesn't flash open then shut
            cancelTmsSuggestClose();
            vm.tmsSuggest.open = fieldKey;
            refreshTmsFiltered(fieldKey);
        }

        function closeTmsSuggestions(fieldKey) {
            cancelTmsSuggestClose();
            tmsSuggestClosePromise = $timeout(function () {
                tmsSuggestClosePromise = null;

                // If focus is still on a TMS suggest input, a spurious blur fired
                // (common when the list mounts) — keep the menu open.
                var active = document.activeElement;
                var activeName = active && active.getAttribute ? active.getAttribute('name') : '';
                if (activeName === 'branch_id' || activeName === 'department' || activeName === 'tms_company') {
                    return;
                }

                // Only close if this field is still the one that was open
                if (!fieldKey || vm.tmsSuggest.open === fieldKey) {
                    vm.tmsSuggest.open = null;
                    vm.tmsSuggest.filtered = [];
                }
            }, 200);
        }

        function onTmsFieldInput(fieldKey) {
            var config = tmsFieldConfig[fieldKey];
            if (!config) {
                return;
            }
            cancelTmsSuggestClose();
            vm.tmsSuggest.open = fieldKey;
            refreshTmsFiltered(fieldKey);
            util.callMixpanel(config.mixpanel, { Value: vm.user_data[config.model] });
        }

        function selectTmsSuggestion(fieldKey, option) {
            var config = tmsFieldConfig[fieldKey];
            if (!config) {
                return;
            }
            cancelTmsSuggestClose();
            vm.user_data[config.model] = option;
            vm.tmsSuggest.open = null;
            vm.tmsSuggest.filtered = [];
            util.callMixpanel(config.mixpanel, { Value: option });
        }

        $rootScope.$on('app.profile', function(event, args) {
            init();
          });

        // function to validate email in chips
        function validateEmail(emails, userInput){
          util.validateEmail(emails, userInput);
          if(util.invalidEmail) {
            $('.profile-invalidErrorMsg').show().delay(1000).fadeOut();
          }
          else if(util.duplicateEmail) {
            $('.profile-duplicateErrorMsg').show().delay(1000).fadeOut();
          }
          else{
            util.callMixpanel('MP-CCMail-Change',{"Value" : userInput })
          }
        }

        // Methods
        function submit_user(user_data){

            if(user_data.password != user_data.user_confirm_password){
                vm.pass_Error = true;
                return false;
            }
            else{
                vm.pass_Error = false;
                user_data.password === angular.isUndefined(user_data.password) ? "" : user_data.password;
                var data =
                    {
                    "data" : {
                        'id' : vm.user_data.id,
                        'user_first_name' : user_data.user_first_name,
                        'user_last_name' : user_data.user_last_name,
                        'email' : user_data.email,
                        'user_mobile' : user_data.user_mobile,
                        'user_mobile_code': user_data.user_mobile_code,
                        'user_mobile_country': user_data.user_mobile_country,
                        'password' : user_data.password,
                        'personal_email_id' : user_data.personal_email_id,
                        'cc_email' : user_data.cc_email ? user_data.cc_email : null,
                        'user_base_currency' : user_data.user_base_currency,
                        'email_signature' : util.encodeValue(user_data.email_signature),
                        'allow_personal_email' : user_data.allow_personal_email,
                        'send_cc' : user_data.send_cc,
                        'metric_system':user_data.metric_system,
                        'number_format':user_data.number_format,
                        'email_signature_required' : user_data.email_signature_required,
                        'use_recent_searches_on_search_ui' : user_data.use_recent_searches_on_search_ui,
                        'precision_decimals' : user_data.precision_decimals,
                        'reference_id':user_data.reference_id,
                        'branch_id':user_data.branch_id,
                        'department':user_data.department,
                        'tms_company':user_data.tms_company,
                        'tms_owner':user_data.tms_owner
                    }
                };
                var mixpanelObj = {
                    'FirstName' : user_data.user_first_name,
                    'LastName' : user_data.user_last_name,
                    'PhoneNumber' : user_data.user_mobile,
                    'Currency' : user_data.user_base_currency,
                    'EmailId' : vm.user_data.email,
                    'UseBusinessEmail' : vm.user_data.allow_personal_email,
                    'PersonalEmailId' : user_data.personal_email_id,
                    'SendCC' : user_data.send_cc,
                    'CCMail' : user_data.cc_email ,
                    'EmailSignatureRequired' :  user_data.email_signature_required,
                    'EmailSignature' : user_data.email_signature
                }

                ProfileService.updateUser(data ,vm.user_data.id).then(function(){
                    util.callMixpanel("MP-Update-MyProfile-Click",mixpanelObj)
                    ToolbarSerivice.userFirstName = user_data.user_first_name;
                    util.userProfile.user.user_base_currency = user_data.user_base_currency;
                    util.userProfile.user.user_first_name = data.data.user_first_name;
                    util.userProfile.user.user_last_name = data.data.user_last_name;
                    util.userProfile.user.use_recent_searches_on_search_ui = data.data.use_recent_searches_on_search_ui;
                    $rootScope.metric_system = data.data.metric_system;
                    $rootScope.number_format = data.data.number_format;
                    $rootScope.precision_decimals = data.data.precision_decimals;
                    util.showToast('Profile Updated Successfully!','top right', 3000);
                },function(error){
                    $log.log(error);
                });
            }
        }

        function openChangePasswordModal(ev){
            vm.currentPasswordValidation=false;
            vm.PasswordValidation=false; 
            vm.confirmPasswordValidation=false;
            vm.checkCurrentPasswordValidation=false;
            vm.changePassword = {
                "current_password" : '',
                "password" : '',
                "confirm_password" : ''
            }
            vm.error_msg = '';
            $mdDialog.show({
                templateUrl        : 'app/main/profile/dialogs/changePassword/changePassword.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
            util.callMixpanel("MP-ChangePassword-Click");
        }

        function submitUpdatedPassword(passwordData){
            var PasswordValidations = {
                'Current Password':'',
                'New Password' :'',
                'Confirm Password' :''
            }
            if(!vm.changePassword.current_password){
                vm.currentPasswordValidation=true;
                PasswordValidations["Current Password"] = "Required";
            }
            if(!vm.changePassword.password){
                vm.PasswordValidation=true;
                PasswordValidations["New Password"] = "Required";
            }
            if(!vm.changePassword.confirm_password){
                vm.confirmPasswordValidation=true;
                PasswordValidations["Confirm Password"] = "Required";
            }
            if(vm.currentPasswordValidation || vm.PasswordValidation || vm.confirmPasswordValidation  ){
                util.callMixpanel('MP-ChangePassword-Submit-Click',{'Validation': PasswordValidations});
                return
            }
            if(passwordData.password !== passwordData.confirm_password){
                PasswordValidations["Confirm Password"] = "Invalid";
                vm.error_msg = 'Your Password confirmation did not match your password.';
                util.callMixpanel('MP-ChangePassword-Submit-Click',{'Validation': PasswordValidations});
            }
            else if(passwordData.password === passwordData.current_password){
                PasswordValidations["New Password"] = "Reused";
                vm.error_msg = 'You cannot reuse a recent password. Choose a different password.';
                util.callMixpanel('MP-ChangePassword-Submit-Click',{'Validation': PasswordValidations});
            }
            else{
                vm.passwordFrm = true;
                vm.error_msg = '';
                var data = {
                    'data' : {
                        'current_password': passwordData.current_password,
                        'password': passwordData.password
                    }
                };
                ProfileService.updateUser(data ,vm.user_data.id).then(function(response){
                    vm.passwordFrm = false;
                    if(response.data.data.status === 'error'){
                        vm.error_msg = response.data.data.message;
                    }
                    else{
                        util.showToast('Password updated Successfully!','top right', 2000);
                        vm.cancelDialog();
                        vm.logout();
                    }
                },function(error){
                    vm.passwordFrm = false;
                    if(error.data && error.data.message == 'Please Enter Your Valid Current Password'){
                          vm.checkCurrentPasswordValidation = true;
                          PasswordValidations["Current Password"] = "Invalid";
                           util.callMixpanel('MP-ChangePassword-Submit-Click',{'Validation': PasswordValidations});
                    }
                    else if(error.data && error.data.message){
                        vm.error_msg = error.data.message;
                    }
                    else{
                        util.showToast(util.displayValidationError(error));
                    }
                    $log.log(error);
                });
            }
        }

        /**
         * Logout Function
         */
        function logout()
        {
            // Do logout here..
            loginSerivice.logout().then(function(response){
                $state.go('app.pages_auth_login-v2');
                $rootScope.redirectUrl = null;
            },function(error){
                $log.log(error);
            })
        }

        function cancelDialog(event){
            util.callMixpanel("MP-ChangePassword-Close-Click", {"Event" :event})
            $mdDialog.hide();
        }

        function showPassErr(type){
            document.getElementById('message').style.display = type === 'focus' ? 'block' : 'none';
        }

        function validatePassword(){
            var myInput = document.getElementById('new_pass');
            var special = document.getElementById('special');
            var number = document.getElementById('number');
            var length = document.getElementById('length');

            // Validate capital letters
            var upperCaseLetters = /[!@#\$%\^&\*]/g;
            if(myInput.value.match(upperCaseLetters)) {
                special.classList.remove('passInvalid');
                special.classList.add('passValid');
            } else {
                special.classList.remove('passValid');
                special.classList.add('passInvalid');
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if(myInput.value.match(numbers)) {
                number.classList.remove('passInvalid');
                number.classList.add('passValid');
            } else {
                number.classList.remove('passValid');
                number.classList.add('passInvalid');
            }

            // Validate length
            if(myInput.value.length >= 8) {
                length.classList.remove('passInvalid');
                length.classList.add('passValid');
            } else {
                length.classList.remove('passValid');
                length.classList.add('passInvalid');
            }
        }

        function togglePassword(input_name){
            if(input_name === 'curr_pass'){
                vm.showCurrentPassword = vm.showCurrentPassword === false ? true : false;
            }
            if(input_name === 'new_pass'){
                vm.showNewPassword = vm.showNewPassword === false ? true : false;
            }
            if(input_name === 'confirm_pass'){
                vm.showConfirmPassword = vm.showConfirmPassword === false ? true : false;
            }
        }

        function fnOnlineCarrierSelectionChange(){
            if(vm.user_data.use_recent_searches_on_search_ui === 'true'){
                util.callMixpanel('MP-ClearOnlineSelection-Change',{"value": "All Cleared"});
            }
            else if(vm.user_data.use_recent_searches_on_search_ui === 'default'){
                util.callMixpanel('MP-ClearOnlineSelection-Change',{"value": "All Selected"});
            }
            else if(vm.user_data.use_recent_searches_on_search_ui === 'false'){
                util.callMixpanel('MP-ClearOnlineSelection-Change',{"value": "Keep Previous Selection"});
            }
        }



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pricingRules', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.pricingRules', {
                url    : '/pricing-rules',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pricingRules/pricing-rules.html',
                        controller : 'PricingRulesController as vm'
                    },
                    data : { pageTitle: 'Pricing Rules' }
                },
                resolve: {},
                bodyClass: 'pricing-rules'
            });
    }

})();

(function () {
  'use strict';

  angular.module('app.pricingRules').controller('PricingRulesController', PricingRulesController);

  /** @ngInject */
  function PricingRulesController(util, iframeService, $timeout, $state, $rootScope) {
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;

    vm.init = init;
    vm.formIframeUrl = formIframeUrl;

    // refresh when god user switches forwarder
    $rootScope.$on('app.pricingRules', function (event, args) {
      vm.init();
    });

    function init() {
      util.isModulePaid('pricingRules');
      vm.minHeight = vm.iframeService.iframeHeight;

      // guard: redirect if user has no read permission
      // TODO: uncomment once backend returns pricingRules module for this user
      if (!(util.navPermission.pricingRules && util.navPermission.pricingRules[1])) {
        $state.go('app.pages_share_error');
      }

      document.getElementById('inner-content').style.maxWidth = '100%';
      document.getElementById('inner-content').style.padding = '0';

      $timeout(function () {
        var windowHeight = document.getElementById('content-container').offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        vm.formIframeUrl();
      }, 400);
    }
    vm.init();

    function formIframeUrl() {
      // 'rules'        → path in freightify-web (web.freightify.com/rules/shared?...)
      // 'pricingRules' → key used to look up navPermission['pricingRules'] → passed as module_permission
      // 'web'          → routes to web.freightify.com instead of rules.freightbro.com
      vm.iframeUrl = iframeService.fnGetIframeUrl('rules', 'pricingRules', 'web');
      vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, '&maxHeight=' + vm.minHeight['max-height']);
      document.getElementById('pricing-rule-iframe').src = vm.iframeUrl;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.partnerRateManagement', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.partnerRateManagement', {
                url: '/partner-rate-management',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/partner-rate-management/partner-rate-management.html',
                        controller: 'PartnerRateManagementController as vm',
                    },
                },
                bodyClass: 'partner-rate-management-page',
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.partnerRateManagement')
        .controller('PartnerRateManagementController', PartnerRateManagementController);

    /** @ngInject */
    function PartnerRateManagementController(RoleService, util, $state, $scope, $q, $mdToast, $timeout, $mdSelect, $mdDialog) {
        var vm = this;
        var searchDebounce = null;
        var listLoadSeq = 0;
        var providerLoadSeq = 0;

        vm.util = util;
        vm.util.screenTitle = 'Manage Rate Sharing';
        vm.permission = util.navPermission.partnerRateManagement || [0, 0, 0, 0];

        vm.relationshipTab = 'suppliers';
        vm.modeTab = 'fcl';
        vm.searchText = '';
        vm.assignments = [];
        vm.totalCount = 0;
        vm.selected = null;
        vm.draft = emptyModeDraft();
        vm.isListLoading = false;
        vm.isSaving = false;
        vm.airlineMaster = [];
        vm.airlinesLoaded = false;
        vm.providerOptions = [];
        vm.providerPanelSearch = '';
        vm.providerSelectionCodes = [];
        vm.isLoadingProviders = false;
        vm._providerCache = {};
        vm.supplierTabCount = 0;
        vm.recipientTabCount = 0;
        vm.pageSize = 10;
        vm.pageIndex = 0;
        vm.vendorIsFfc = false;

        vm.init = init;
        vm.onRelationshipTabChange = onRelationshipTabChange;
        vm.onSearchChange = onSearchChange;
        vm.selectAssignment = selectAssignment;
        vm.save = save;
        vm.currentCarrierValues = currentCarrierValues;
        vm.currentAllowAll = currentAllowAll;
        vm.setAllowAll = setAllowAll;
        vm.isSupplierPerspective = isSupplierPerspective;
        vm.counterpartName = counterpartName;
        vm.counterpartDomain = counterpartDomain;
        vm.counterpartDomainSubscriberId = counterpartDomainSubscriberId;
        vm.counterpartIsFfc = counterpartIsFfc;
        vm.isFfcSupplierLock = isFfcSupplierLock;
        vm.isLoggedInCompanyFfc = isLoggedInCompanyFfc;
        vm.isFfcRecipientLock = isFfcRecipientLock;
        vm.isFfcOptionsLock = isFfcOptionsLock;
        vm.setRelTab = setRelTab;
        vm.setModeTab = setModeTab;
        vm.refreshAllowAllProxy = refreshAllowAllProxy;
        vm.loadAllProvidersForMode = loadAllProvidersForMode;
        vm.filteredPanelProviders = filteredPanelProviders;
        vm.onProviderSelectOpen = onProviderSelectOpen;
        vm.onProviderSelectClose = onProviderSelectClose;
        vm.syncProviderSelectionToDraft = syncProviderSelectionToDraft;
        vm.selectAllFilteredProviders = selectAllFilteredProviders;
        vm.clearProvidersSelection = clearProvidersSelection;
        vm.closeProviderSelect = closeProviderSelect;
        vm.providerSummaryText = providerSummaryText;
        vm.serviceProviderBadgeCount = serviceProviderBadgeCount;
        vm.totalPages = totalPages;
        vm.rangeStart = rangeStart;
        vm.rangeEnd = rangeEnd;
        vm.canPrev = canPrev;
        vm.canNext = canNext;
        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.triggerSearchNow = triggerSearchNow;
        vm.discardChanges = discardChanges;
        vm.isDraftDirty = isDraftDirty;
        vm.providerSelectedHtml = providerSelectedHtml;
        vm.selectAllProvidersInSection = selectAllProvidersInSection;

        vm.relTabIndex = 0;
        vm.modeTabIndex = 0;
        vm.allowAllProxy = false;
        vm._draftSnapshot = null;

        init();

        $scope.$on('$destroy', function () {
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
                searchDebounce = null;
            }
        });

        $scope.$on('app.partnerRateManagement', function () {
            init();
        });

        function setRelTab(idx, ev) {
            if (idx === 0 && isLoggedInCompanyFfc()) {
                return;
            }
            var next = idx === 0 ? 'suppliers' : 'recipients';
            if (vm.relationshipTab === next) {
                vm.relTabIndex = idx;
                return;
            }
            if (vm.selected && isDraftDirty()) {
                showUnsavedDiscardDialog(ev).then(function () {
                    vm.relTabIndex = idx;
                    vm.relationshipTab = next;
                    onRelationshipTabChange();
                });
                return;
            }
            vm.relTabIndex = idx;
            vm.relationshipTab = next;
            onRelationshipTabChange();
        }

        function setModeTab(idx, key) {
            vm.modeTabIndex = idx;
            vm.modeTab = key;
            vm.providerPanelSearch = '';
            refreshAllowAllProxy();
            syncProviderSelectionFromDraft();
            if (!vm.currentAllowAll()) {
                loadAllProvidersForMode();
            }
        }

        function refreshAllowAllProxy() {
            vm.allowAllProxy = vm.currentAllowAll();
        }

        function init() {
            util.isModulePaid('partnerRateManagement');
            if (!(vm.permission[1])) {
                $state.go('app.pages_share_error');
                return;
            }
            if (isLoggedInCompanyFfc()) {
                vm.relationshipTab = 'recipients';
                vm.relTabIndex = 1;
            }
            vm.pageIndex = 0;
            loadAssignments();
        }

        function emptyLeg() {
            return {
                isEnabledFromSupplier: false,
                isEnabledFromReceiver: false,
                allowedCarriersFromSupplier: { allowAll: false, values: [] },
                allowedCarriersFromReceiver: { allowAll: false, values: [] },
                showUploadRateSheetFromSupplier: false,
                showContractNumberFromSupplier: false,
                showUploadRateSheetOnReceiverSide: false,
                showContractNumberOnReceiverSide: false,
                allowRateRequestFromSupplier: false,
                allowRateRequestFromReceiver: false,
            };
        }

        function emptyModeDraft() {
            return {
                fcl: emptyLeg(),
                lcl: emptyLeg(),
                air: emptyLeg(),
            };
        }

        function mergeLeg(fromApi) {
            var base = emptyLeg();
            if (!fromApi || typeof fromApi !== 'object') {
                return base;
            }
            angular.extend(base, fromApi);
            base.allowedCarriersFromSupplier = angular.extend(
                { allowAll: false, values: [] },
                fromApi.allowedCarriersFromSupplier || {}
            );
            base.allowedCarriersFromSupplier.values = angular.copy(
                base.allowedCarriersFromSupplier.values || []
            );
            base.allowedCarriersFromReceiver = angular.extend(
                { allowAll: false, values: [] },
                fromApi.allowedCarriersFromReceiver || {}
            );
            base.allowedCarriersFromReceiver.values = angular.copy(
                base.allowedCarriersFromReceiver.values || []
            );
            return base;
        }

        function cloneModeFromAssignment(mode) {
            var src = mode || {};
            return {
                fcl: mergeLeg(src.fcl),
                lcl: mergeLeg(src.lcl),
                air: mergeLeg(src.air),
            };
        }

        function extractSubvendorCarrierRows(res) {
            var body = res && res.data ? res.data : {};
            var rows = body.data;
            if (angular.isArray(rows)) {
                return rows;
            }
            if (rows && angular.isArray(rows.data)) {
                return rows.data;
            }
            return [];
        }

        function buildSubvendorProviderOptionsFromRows(rows) {
            var seen = {};
            var options = [];
            angular.forEach(rows, function (r) {
                if (!r || r.id === undefined || r.id === null || r.id === '') {
                    return;
                }
                var idStr = String(r.id);
                if (seen[idStr]) {
                    return;
                }
                seen[idStr] = true;
                var code = r.code != null && r.code !== '' ? String(r.code) : '';
                var suffix = r.sub_type || r.source || r.vendor_type || r.integration_type || 'API';
                options.push({
                    value: idStr,
                    code: code,
                    display: ((r.name || code || idStr) + ' | ' + suffix).trim(),
                });
            });
            return options;
        }

        function setSeaSubvendorProviderCaches(options) {
            vm._providerCache.fcl = options;
            vm._providerCache.lcl = options;
        }

        function ensureSeaSubvendorProviderCaches() {
            if (vm._providerCache.fcl && vm._providerCache.fcl.length) {
                vm._providerCache.lcl = vm._providerCache.fcl;
                return $q.when();
            }
            if (vm._providerCache.lcl && vm._providerCache.lcl.length) {
                vm._providerCache.fcl = vm._providerCache.lcl;
                return $q.when();
            }
            return RoleService.getV2Carriers({
                type: 'subvendor',
                source: 'common',
                limit: 500,
                offset: 0,
                query: '',
            }).then(function (res) {
                var opts = buildSubvendorProviderOptionsFromRows(extractSubvendorCarrierRows(res));
                setSeaSubvendorProviderCaches(opts);
            });
        }

        function normalizeSubvendorValuesForPatch(values) {
            var opts = vm._providerCache.fcl || vm._providerCache.lcl || [];
            if (!opts.length) {
                return angular.copy(values || []);
            }
            var out = [];
            angular.forEach(values || [], function (v) {
                var s = String(v);
                var i;
                var mapped = null;
                for (i = 0; i < opts.length; i++) {
                    if (String(opts[i].value) === s) {
                        mapped = String(opts[i].value);
                        break;
                    }
                }
                if (mapped === null) {
                    for (i = 0; i < opts.length; i++) {
                        if (opts[i].code && String(opts[i].code) === s) {
                            mapped = String(opts[i].value);
                            break;
                        }
                    }
                }
                out.push(mapped !== null ? mapped : s);
            });
            return out;
        }

        function remapProviderSelectionToIds(selection) {
            var opts = vm.providerOptions || [];
            if (!opts.length) {
                return selection;
            }
            var out = [];
            var seen = {};
            angular.forEach(selection || [], function (v) {
                var s = String(v);
                var i;
                var idStr = null;
                for (i = 0; i < opts.length; i++) {
                    if (String(opts[i].value) === s) {
                        idStr = String(opts[i].value);
                        break;
                    }
                }
                if (idStr === null) {
                    for (i = 0; i < opts.length; i++) {
                        if (opts[i].code && String(opts[i].code) === s) {
                            idStr = String(opts[i].value);
                            break;
                        }
                    }
                }
                var pick = idStr !== null ? idStr : s;
                if (!seen[pick]) {
                    seen[pick] = true;
                    out.push(pick);
                }
            });
            return out;
        }

        function normalizeAirlineValuesForPatch(values) {
            var opts = vm._providerCache.air || [];
            if (!opts.length) {
                return angular.copy(values || []);
            }
            var out = [];
            angular.forEach(values || [], function (v) {
                var s = String(v);
                var i;
                var mapped = null;
                for (i = 0; i < opts.length; i++) {
                    if (String(opts[i].value) === s) {
                        mapped = String(opts[i].value);
                        break;
                    }
                }
                if (mapped === null) {
                    for (i = 0; i < opts.length; i++) {
                        if (opts[i].code && String(opts[i].code) === s) {
                            mapped = String(opts[i].value);
                            break;
                        }
                    }
                }
                out.push(mapped !== null ? mapped : s);
            });
            return out;
        }

        function listRoleParam() {
            return vm.relationshipTab === 'recipients' ? 'supplier' : 'receiver';
        }

        function perspectiveParam() {
            return vm.relationshipTab === 'recipients' ? 'supplier' : 'receiver';
        }

        function isSupplierPerspective() {
            return vm.relationshipTab === 'recipients';
        }

        function counterpartName(row) {
            if (!row) return '';
            if (vm.relationshipTab === 'recipients') {
                return row.receiverDomainSubscriberName || row.receiverDomainSubscriberId;
            }
            return row.supplierDomainSubscriberName || row.supplierDomainSubscriberId;
        }

        function counterpartDomain(row) {
            if (!row) return null;
            if (vm.relationshipTab === 'recipients') {
                return row.receiverDomain || null;
            }
            return row.supplierDomain || null;
        }

        function counterpartDomainSubscriberId(row) {
            if (!row) return null;
            if (vm.relationshipTab === 'recipients') {
                return row.receiverDomainSubscriberId || null;
            }
            return row.supplierDomainSubscriberId || null;
        }

        function counterpartIsFfc(row) {
            if (!row) return false;
            if (vm.relationshipTab === 'recipients') {
                return !!row.receiverIsFfc;
            }
            return !!row.supplierIsFfc;
        }

        function isFfcSupplierLock() {
            return vm.relationshipTab === 'suppliers' && counterpartIsFfc(vm.selected);
        }

        function isLoggedInCompanyFfc() {
            if (vm.vendorIsFfc === true) {
                return true;
            }
            var company = util.userProfile && util.userProfile.user && util.userProfile.user.company;
            var flag = company && company.is_ffc;
            return flag === true || flag === 1 || flag === '1';
        }

        function isFfcRecipientLock() {
            return vm.relationshipTab === 'recipients' && isLoggedInCompanyFfc();
        }

        function isFfcOptionsLock() {
            return isFfcSupplierLock() || isFfcRecipientLock();
        }

        function loadAssignments() {
            var mySeq = ++listLoadSeq;
            vm.isListLoading = true;
            RoleService.listPartnerRateAssignments({
                role: listRoleParam(),
                query: vm.searchText,
                limit: vm.pageSize,
                offset: vm.pageIndex * vm.pageSize,
            }).then(
                function (response) {
                    if (mySeq !== listLoadSeq) {
                        return;
                    }
                    var payload = response && response.data ? response.data.data : {};
                    if (payload && typeof payload.vendorIsFfc === 'boolean') {
                        vm.vendorIsFfc = payload.vendorIsFfc;
                    }
                    if (isLoggedInCompanyFfc() && vm.relationshipTab === 'suppliers') {
                        vm.relationshipTab = 'recipients';
                        vm.relTabIndex = 1;
                        vm.pageIndex = 0;
                        vm.isListLoading = false;
                        loadAssignments();
                        return;
                    }
                    vm.assignments = (payload && angular.isArray(payload.assignments)) ? payload.assignments : [];
                    vm.totalCount = payload && typeof payload.count === 'number' ? payload.count : vm.assignments.length;
                    if (payload && typeof payload.supplierCount === 'number') {
                        vm.supplierTabCount = payload.supplierCount;
                    } else if (vm.relationshipTab === 'suppliers') {
                        vm.supplierTabCount = vm.totalCount;
                    }
                    if (payload && typeof payload.recipientCount === 'number') {
                        vm.recipientTabCount = payload.recipientCount;
                    } else if (vm.relationshipTab === 'recipients') {
                        vm.recipientTabCount = vm.totalCount;
                    }

                    if (!vm.assignments.length && vm.pageIndex > 0) {
                        vm.pageIndex = Math.max(0, vm.pageIndex - 1);
                        vm.isListLoading = false;
                        loadAssignments();
                        return;
                    }

                    var previousId = vm.selected ? vm.selected._id : null;
                    var match = null;
                    if (previousId) {
                        var j;
                        for (j = 0; j < vm.assignments.length; j++) {
                            if (vm.assignments[j]._id === previousId) {
                                match = vm.assignments[j];
                                break;
                            }
                        }
                    }
                    if (match) {
                        applySelectAssignment(match);
                    } else if (vm.assignments.length) {
                        applySelectAssignment(vm.assignments[0]);
                    } else {
                        vm.selected = null;
                        vm._draftSnapshot = null;
                        vm.draft = emptyModeDraft();
                    }
                    vm.isListLoading = false;
                },
                function () {
                    if (mySeq !== listLoadSeq) {
                        return;
                    }
                    vm.assignments = [];
                    vm.totalCount = 0;
                    vm.supplierTabCount = 0;
                    vm.recipientTabCount = 0;
                    vm.selected = null;
                    vm._draftSnapshot = null;
                    vm.draft = emptyModeDraft();
                    vm.isListLoading = false;
                    $mdToast.show($mdToast.simple().textContent('Unable to load partner assignments').hideDelay(4000));
                }
            );
        }

        function onRelationshipTabChange() {
            vm.searchText = '';
            vm.pageIndex = 0;
            vm.selected = null;
            vm._draftSnapshot = null;
            vm.draft = emptyModeDraft();
            vm.assignments = [];
            vm.totalCount = 0;
            providerLoadSeq += 1;
            vm.isLoadingProviders = false;
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
                searchDebounce = null;
            }
            loadAssignments();
        }

        function onSearchChange() {
            vm.pageIndex = 0;
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
            }
            searchDebounce = $timeout(function () {
                searchDebounce = null;
                loadAssignments();
            }, 300);
        }

        function triggerSearchNow() {
            vm.pageIndex = 0;
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
                searchDebounce = null;
            }
            loadAssignments();
        }

        function totalPages() {
            return Math.max(1, Math.ceil(vm.totalCount / vm.pageSize));
        }

        function rangeStart() {
            return vm.totalCount ? vm.pageIndex * vm.pageSize + 1 : 0;
        }

        function rangeEnd() {
            return Math.min(vm.totalCount, (vm.pageIndex + 1) * vm.pageSize);
        }

        function canPrev() {
            return vm.pageIndex > 0;
        }

        function canNext() {
            return vm.pageIndex + 1 < totalPages();
        }

        function prevPage() {
            if (canPrev()) {
                vm.pageIndex -= 1;
                loadAssignments();
            }
        }

        function nextPage() {
            if (canNext()) {
                vm.pageIndex += 1;
                loadAssignments();
            }
        }

        function sortCarrierBucketValues(leg, key) {
            var bucket = leg[key];
            if (!bucket || !angular.isArray(bucket.values)) {
                return;
            }
            bucket.values = bucket.values.map(String).slice().sort();
        }

        function normalizeDraftForCompare(src) {
            if (!src) {
                return null;
            }
            var d = angular.copy(src);
            ['fcl', 'lcl', 'air'].forEach(function (mKey) {
                var leg = d[mKey];
                if (!leg) {
                    return;
                }
                sortCarrierBucketValues(leg, 'allowedCarriersFromSupplier');
                sortCarrierBucketValues(leg, 'allowedCarriersFromReceiver');
            });
            return d;
        }

        function captureDraftSnapshot() {
            vm._draftSnapshot = normalizeDraftForCompare(vm.draft);
        }

        function isDraftDirty() {
            if (!vm.selected || vm._draftSnapshot === null) {
                return false;
            }
            return !angular.equals(normalizeDraftForCompare(vm.draft), vm._draftSnapshot);
        }

        function syncProviderSelectionFromDraft() {
            if (vm.currentAllowAll()) {
                vm.providerSelectionCodes = [];
                return;
            }
            vm.providerSelectionCodes = angular.copy((vm.currentCarrierValues() || []).map(String));
        }

        function discardChanges() {
            if (!isDraftDirty() || vm._draftSnapshot === null) {
                return;
            }
            vm.draft = angular.copy(vm._draftSnapshot);
            vm.providerPanelSearch = '';
            refreshAllowAllProxy();
            syncProviderSelectionFromDraft();
        }

        function shortLabelForCarrier(code) {
            var full = labelForCarrierCode(code);
            var pipeIdx = full.indexOf(' | ');
            if (pipeIdx > 0) {
                return full.substring(0, pipeIdx).trim();
            }
            var parenIdx = full.indexOf(' (');
            if (parenIdx > 0) {
                return full.substring(0, parenIdx).trim();
            }
            return full;
        }

        function escapeHtml(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        function providerSummaryChips() {
            var vals = vm.currentCarrierValues() || [];
            if (!vals.length) {
                return [];
            }
            var maxVisible = 3;
            var chips = [];
            var i;
            for (i = 0; i < vals.length && i < maxVisible; i++) {
                chips.push({
                    label: shortLabelForCarrier(vals[i]),
                    value: vals[i],
                });
            }
            if (vals.length > maxVisible) {
                chips.push({ overflow: vals.length - maxVisible });
            }
            return chips;
        }

        function providerSelectedHtml() {
            if (vm.currentAllowAll()) {
                return '<span class="prm-select-placeholder">All carriers</span>';
            }
            var chips = providerSummaryChips();
            if (!chips.length) {
                return '<span class="prm-select-placeholder">Select Carriers</span>';
            }
            var html = '<span class="prm-chip-row">';
            chips.forEach(function (chip) {
                if (chip.overflow) {
                    html += '<span class="prm-chip prm-chip--more">+' + chip.overflow + ' More</span>';
                } else {
                    html += '<span class="prm-chip">' + escapeHtml(chip.label) + '</span>';
                }
            });
            html += '</span>';
            return html;
        }

        function selectAllProvidersInSection(ev) {
            if (ev) {
                ev.stopPropagation();
            }
            if (vm.currentAllowAll() || isFfcOptionsLock()) {
                return;
            }
            loadAllProvidersForMode().then(function (applied) {
                if (!applied) {
                    return;
                }
                var codes = [];
                angular.forEach(vm.providerOptions || [], function (p) {
                    if (p && p.value != null && p.value !== '') {
                        codes.push(String(p.value));
                    }
                });
                vm.providerSelectionCodes = codes;
                syncProviderSelectionToDraft();
            });
        }

        function showUnsavedDiscardDialog(ev) {
            return $mdDialog.show({
                templateUrl: 'app/main/partner-rate-management/confirm-discard-unsaved.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                controller: function ($scope, $mdDialog) {
                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                    $scope.proceed = function () {
                        $mdDialog.hide(true);
                    };
                },
            });
        }

        function showUnsavedSwitchDialog(ev, targetRow) {
            showUnsavedDiscardDialog(ev).then(function () {
                applySelectAssignment(targetRow);
            });
        }

        function applySelectAssignment(row) {
            vm.selected = row;
            vm.draft = cloneModeFromAssignment(row.mode);
            vm.modeTab = 'fcl';
            vm.modeTabIndex = 0;
            vm.providerPanelSearch = '';
            refreshAllowAllProxy();
            captureDraftSnapshot();
            syncProviderSelectionFromDraft();
            if (!vm.currentAllowAll()) {
                loadAllProvidersForMode();
            }
        }

        function selectAssignment(row, ev) {
            if (!row) {
                return;
            }
            if (vm.selected && vm.selected._id === row._id) {
                return;
            }
            if (vm.selected && isDraftDirty()) {
                showUnsavedSwitchDialog(ev, row);
                return;
            }
            applySelectAssignment(row);
        }

        function ensureAirlinesLoaded() {
            if (vm.airlinesLoaded) {
                return $q.when();
            }
            return RoleService.getAirlinesList().then(function (res) {
                var body = res && res.data ? res.data : {};
                vm.airlineMaster = angular.isArray(body.data) ? body.data : [];
                vm.airlinesLoaded = true;
            });
        }

        function loadAllProvidersForMode() {
            var mySeq = ++providerLoadSeq;
            vm.isLoadingProviders = true;
            var cacheKey = vm.modeTab;
            if (vm.modeTab === 'air' && vm._providerCache.air && vm._providerCache.air.length) {
                if (mySeq !== providerLoadSeq) {
                    return $q.when(false);
                }
                vm.providerOptions = vm._providerCache.air;
                vm.isLoadingProviders = false;
                return $q.when(true);
            }
            if ((vm.modeTab === 'fcl' || vm.modeTab === 'lcl') && vm._providerCache.fcl && vm._providerCache.fcl.length) {
                if (mySeq !== providerLoadSeq) {
                    return $q.when(false);
                }
                vm.providerOptions = vm._providerCache.fcl;
                vm._providerCache.lcl = vm._providerCache.fcl;
                vm._providerCache[cacheKey] = vm._providerCache.fcl;
                vm.isLoadingProviders = false;
                return $q.when(true);
            }
            if (vm.modeTab === 'air') {
                return ensureAirlinesLoaded().then(
                    function () {
                        if (mySeq !== providerLoadSeq) {
                            return false;
                        }
                        var seen = {};
                        vm.providerOptions = [];
                        angular.forEach(vm.airlineMaster, function (a) {
                            var rawId = a.id != null && a.id !== '' ? a.id : (a._id != null && a._id !== '' ? a._id : null);
                            if (rawId === undefined || rawId === null || rawId === '') {
                                return;
                            }
                            var idStr = String(rawId);
                            if (seen[idStr]) {
                                return;
                            }
                            seen[idStr] = true;
                            var code = a.airline_code || a.code || a.iata_code;
                            var codeStr = code != null && code !== '' ? String(code) : '';
                            var iata = a.iata_code != null && a.iata_code !== '' ? String(a.iata_code) : '';
                            var carrierName = (
                                a.air_line_name ||
                                a.airline_name ||
                                a.name ||
                                a.liner_name ||
                                ''
                            ).trim();
                            if (!carrierName && iata) {
                                carrierName = iata;
                            }
                            if (!carrierName && codeStr) {
                                carrierName = codeStr;
                            }
                            if (!carrierName) {
                                carrierName = 'Airline';
                            }
                            var codeForMeta = iata || codeStr;
                            var display =
                                codeForMeta && codeForMeta !== carrierName
                                    ? (carrierName + ' (' + codeForMeta + ')')
                                    : carrierName;
                            vm.providerOptions.push({
                                value: idStr,
                                code: codeStr,
                                carrierName: carrierName,
                                carrierCode: codeForMeta || codeStr,
                                display: display,
                            });
                        });
                        vm._providerCache[cacheKey] = vm.providerOptions;
                        vm.isLoadingProviders = false;
                        return true;
                    },
                    function () {
                        if (mySeq !== providerLoadSeq) {
                            return false;
                        }
                        vm.providerOptions = [];
                        vm.isLoadingProviders = false;
                        return false;
                    }
                );
            }
            return RoleService.getV2Carriers({
                type: 'subvendor',
                source: 'common',
                limit: 500,
                offset: 0,
                query: '',
            }).then(
                function (res) {
                    if (mySeq !== providerLoadSeq) {
                        return false;
                    }
                    vm.providerOptions = buildSubvendorProviderOptionsFromRows(extractSubvendorCarrierRows(res));
                    vm._providerCache[cacheKey] = vm.providerOptions;
                    setSeaSubvendorProviderCaches(vm.providerOptions);
                    vm.isLoadingProviders = false;
                    return true;
                },
                function () {
                    if (mySeq !== providerLoadSeq) {
                        return false;
                    }
                    vm.providerOptions = [];
                    vm.isLoadingProviders = false;
                    return false;
                }
            );
        }

        function filteredPanelProviders() {
            var q = (vm.providerPanelSearch || '').toLowerCase();
            var list = vm.providerOptions || [];
            if (!q) {
                return list;
            }
            return list.filter(function (p) {
                var d = (p.display || '').toLowerCase();
                var c = String(p.code || '').toLowerCase();
                var v = String(p.value != null ? p.value : '').toLowerCase();
                var cn = String(p.carrierName || '').toLowerCase();
                return (
                    d.indexOf(q) !== -1 ||
                    c.indexOf(q) !== -1 ||
                    v.indexOf(q) !== -1 ||
                    cn.indexOf(q) !== -1
                );
            });
        }

        function onProviderSelectOpen() {
            if (isFfcOptionsLock()) {
                return;
            }
            vm.providerPanelSearch = '';
            vm.providerSelectionCodes = angular.copy((vm.currentCarrierValues() || []).map(String));
            loadAllProvidersForMode().then(function (applied) {
                if (!applied) {
                    return;
                }
                vm.providerSelectionCodes = remapProviderSelectionToIds(vm.providerSelectionCodes);
            });
        }

        function onProviderSelectClose() {
            vm.providerPanelSearch = '';
            syncProviderSelectionToDraft();
        }

        function syncProviderSelectionToDraft() {
            if (vm.currentAllowAll() || isFfcOptionsLock()) {
                return;
            }
            var leg = currentLeg();
            var bucket = vm.isSupplierPerspective()
                ? leg.allowedCarriersFromSupplier
                : leg.allowedCarriersFromReceiver;
            bucket.values = bucket.values || [];
            bucket.values.length = 0;
            angular.forEach(vm.providerSelectionCodes || [], function (code) {
                bucket.values.push(String(code));
            });
        }

        function closeProviderSelect() {
            $mdSelect.hide();
        }

        function selectAllFilteredProviders(ev) {
            if (ev) {
                ev.stopPropagation();
            }
            if (vm.currentAllowAll()) {
                return;
            }
            var map = {};
            angular.forEach(vm.providerSelectionCodes || [], function (c) {
                map[String(c)] = true;
            });
            filteredPanelProviders().forEach(function (p) {
                var key = p.value != null ? String(p.value) : String(p.code || '');
                if (key) {
                    map[key] = true;
                }
            });
            vm.providerSelectionCodes = Object.keys(map);
            syncProviderSelectionToDraft();
        }

        function clearProvidersSelection(ev) {
            if (ev) {
                ev.stopPropagation();
            }
            if (vm.currentAllowAll()) {
                return;
            }
            vm.providerSelectionCodes = [];
            syncProviderSelectionToDraft();
        }

        function labelForCarrierCode(code) {
            var needle = String(code);
            var list = vm.providerOptions || [];
            var i;
            for (i = 0; i < list.length; i++) {
                if (String(list[i].value) === needle) {
                    if (vm.modeTab === 'air' && list[i].carrierName) {
                        var ac = list[i].carrierCode;
                        return ac && String(ac) !== String(list[i].carrierName)
                            ? (list[i].carrierName + ' (' + ac + ')')
                            : list[i].carrierName;
                    }
                    return list[i].display;
                }
            }
            for (i = 0; i < list.length; i++) {
                if (list[i].code && String(list[i].code) === needle) {
                    if (vm.modeTab === 'air' && list[i].carrierName) {
                        var ac2 = list[i].carrierCode;
                        return ac2 && String(ac2) !== String(list[i].carrierName)
                            ? (list[i].carrierName + ' (' + ac2 + ')')
                            : list[i].carrierName;
                    }
                    return list[i].display;
                }
            }
            var cached = vm._providerCache[vm.modeTab];
            if (cached) {
                for (i = 0; i < cached.length; i++) {
                    if (String(cached[i].value) === needle) {
                        if (vm.modeTab === 'air' && cached[i].carrierName) {
                            var acc = cached[i].carrierCode;
                            return acc && String(acc) !== String(cached[i].carrierName)
                                ? (cached[i].carrierName + ' (' + acc + ')')
                                : cached[i].carrierName;
                        }
                        return cached[i].display;
                    }
                }
                for (i = 0; i < cached.length; i++) {
                    if (cached[i].code && String(cached[i].code) === needle) {
                        if (vm.modeTab === 'air' && cached[i].carrierName) {
                            var acc2 = cached[i].carrierCode;
                            return acc2 && String(acc2) !== String(cached[i].carrierName)
                                ? (cached[i].carrierName + ' (' + acc2 + ')')
                                : cached[i].carrierName;
                        }
                        return cached[i].display;
                    }
                }
            }
            return code;
        }

        function providerSummaryText() {
            if (vm.currentAllowAll()) {
                return 'All carriers';
            }
            var vals = vm.currentCarrierValues();
            if (!vals || !vals.length) {
                return 'Select Carriers';
            }
            var labels = vals.map(labelForCarrierCode);
            if (labels.length === 1) {
                return labels[0];
            }
            if (labels.length === 2) {
                return labels[0] + ', ' + labels[1];
            }
            return vals.length + ' carriers selected';
        }

        function serviceProviderBadgeCount() {
            if (vm.currentAllowAll()) {
                return 'All';
            }
            return vm.currentCarrierValues().length;
        }

        function currentLeg() {
            return vm.draft[vm.modeTab] || emptyLeg();
        }

        function currentCarrierValues() {
            var leg = currentLeg();
            if (vm.isSupplierPerspective()) {
                return leg.allowedCarriersFromSupplier.values;
            }
            return leg.allowedCarriersFromReceiver.values;
        }

        function currentAllowAll() {
            var leg = currentLeg();
            if (vm.isSupplierPerspective()) {
                return !!leg.allowedCarriersFromSupplier.allowAll;
            }
            return !!leg.allowedCarriersFromReceiver.allowAll;
        }

        function setAllowAll(val) {
            if (isFfcOptionsLock()) {
                vm.allowAllProxy = currentAllowAll();
                return;
            }
            var leg = currentLeg();
            if (vm.isSupplierPerspective()) {
                leg.allowedCarriersFromSupplier.allowAll = !!val;
            } else {
                leg.allowedCarriersFromReceiver.allowAll = !!val;
            }
            if (val) {
                vm.providerSelectionCodes = [];
            } else {
                syncProviderSelectionFromDraft();
            }
            refreshAllowAllProxy();
        }

        function buildPatchMode() {
            var perspective = perspectiveParam();
            var out = {};
            ['fcl', 'lcl', 'air'].forEach(function (mKey) {
                var leg = vm.draft[mKey];
                if (!leg) {
                    return;
                }
                var slice = {};
                if (perspective === 'supplier') {
                    if (isFfcRecipientLock()) {
                        slice.isEnabledFromSupplier = !!leg.isEnabledFromSupplier;
                    } else {
                    slice.isEnabledFromSupplier = !!leg.isEnabledFromSupplier;
                    slice.allowRateRequestFromSupplier = !!leg.allowRateRequestFromSupplier;
                    slice.showUploadRateSheetFromSupplier = !!leg.showUploadRateSheetFromSupplier;
                    slice.showContractNumberFromSupplier = !!leg.showContractNumberFromSupplier;
                    slice.allowedCarriersFromSupplier = {
                        allowAll: !!(leg.allowedCarriersFromSupplier && leg.allowedCarriersFromSupplier.allowAll),
                        values: (mKey === 'fcl' || mKey === 'lcl')
                            ? normalizeSubvendorValuesForPatch(
                                (leg.allowedCarriersFromSupplier && leg.allowedCarriersFromSupplier.values) || []
                            )
                            : (mKey === 'air'
                                ? normalizeAirlineValuesForPatch(
                                    (leg.allowedCarriersFromSupplier && leg.allowedCarriersFromSupplier.values) || []
                                )
                                : angular.copy((leg.allowedCarriersFromSupplier && leg.allowedCarriersFromSupplier.values) || [])),
                    };
                    }
                } else if (isFfcSupplierLock()) {
                    slice.isEnabledFromReceiver = !!leg.isEnabledFromReceiver;
                } else {
                    slice.isEnabledFromReceiver = !!leg.isEnabledFromReceiver;
                    slice.allowRateRequestFromReceiver = !!leg.allowRateRequestFromReceiver;
                    slice.showUploadRateSheetOnReceiverSide = !!leg.showUploadRateSheetOnReceiverSide;
                    slice.showContractNumberOnReceiverSide = !!leg.showContractNumberOnReceiverSide;
                    slice.allowedCarriersFromReceiver = {
                        allowAll: !!(leg.allowedCarriersFromReceiver && leg.allowedCarriersFromReceiver.allowAll),
                        values: (mKey === 'fcl' || mKey === 'lcl')
                            ? normalizeSubvendorValuesForPatch(
                                (leg.allowedCarriersFromReceiver && leg.allowedCarriersFromReceiver.values) || []
                            )
                            : (mKey === 'air'
                                ? normalizeAirlineValuesForPatch(
                                    (leg.allowedCarriersFromReceiver && leg.allowedCarriersFromReceiver.values) || []
                                )
                                : angular.copy((leg.allowedCarriersFromReceiver && leg.allowedCarriersFromReceiver.values) || [])),
                    };
                }
                out[mKey] = slice;
            });
            return out;
        }

        function save() {
            if (!vm.selected || !vm.selected._id) {
                return;
            }
            if (!(vm.permission[2])) {
                $mdToast.show($mdToast.simple().textContent('You do not have edit permission').hideDelay(4000));
                return;
            }
            vm.isSaving = true;
            $q.all([
                ensureSeaSubvendorProviderCaches().catch(function () {
                    return $q.when();
                }),
                ensureAirlinesLoaded().catch(function () {
                    return $q.when();
                }),
            ]).then(function () {
                    return RoleService.patchPartnerRateAssignment(vm.selected._id, {
                        perspective: perspectiveParam(),
                        mode: buildPatchMode(),
                    });
                })
                .then(
                function (res) {
                    vm.isSaving = false;
                    var updated = res && res.data && res.data.data ? res.data.data : null;
                    if (updated && updated._id) {
                        angular.extend(vm.selected, { mode: updated.mode || vm.selected.mode });
                        vm.draft = cloneModeFromAssignment(vm.selected.mode);
                        captureDraftSnapshot();
                    }
                    $mdToast.show($mdToast.simple().textContent('Saved').hideDelay(2500));
                },
                function () {
                    vm.isSaving = false;
                    $mdToast.show($mdToast.simple().textContent('Save failed').hideDelay(4000));
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.oneQuoteModule', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.oneQuoteModule', {
                url    : '/one-quote?source',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/one-quote/one-quote.html',
                        controller : 'OneQuoteController as vm'
                    },
                    data : { pageTitle: 'oneQuote' }
                },
                resolve : {
                    QuoteData :function(util,$window){
                        if(!Object.keys(util.oneQuoteData).length){
                            $window.history.back();
                        }
                    }
                }
                
            });
    }


})();


(function () {
    "use strict";
  
    angular.module("app.oneQuoteModule").controller("OneQuoteController", OneQuoteController);
  
    /** @ngInject */
    function OneQuoteController(util, iframeService, $timeout, $state,$rootScope,$scope) {
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();
      $scope.$on('$destroy', function () {
        if (window.removeEventListener) {
          window.removeEventListener("message", getIframeRequest, true);
        } else if (window.detachEvent) {
          window.detachEvent("onmessage", getIframeRequest);
        }
      });
      function init() {
        // util.isModulePaid('oneQuote');
        vm.minHeight = vm.iframeService.iframeHeight;
        // if(!(util.navPermission.oneQuote && util.navPermission.oneQuote[1])){
        //     $state.go('app.pages_share_error');
        // }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }

  
      }
      vm.init();

      $rootScope.$on('app.oneQuoteModule', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('one-quote','','web');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&oneQuoteAccessData=1&parentUrl="+ window.location.origin);
        document.getElementById("oneQuote-iframe").src = vm.iframeUrl;
      }

      function getIframeRequest(event){

        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
    
        // Same origin gate as quote-details / customer / contact (truthy indexOf).
        if(event.origin.indexOf(util.iframeOrigin)){
          var targetOrigin = (new URL(vm.iframeUrl)).origin; 
          if(event.data.source === 'one-quote' && event.origin === targetOrigin &&  document.getElementById('oneQuote-iframe')){
            var data=[]; 
            var selectedCard = util.oneQuoteData && util.oneQuoteData.selectedCard || [];
            var refreshRate = util.oneQuoteData && util.oneQuoteData.refreshRate || [];
            data = selectedCard.concat(refreshRate);          
              document.getElementById('oneQuote-iframe').contentWindow.postMessage(
              { selectedCard: data,
                quoteData: util.oneQuoteData.quoteData,
                pageSource: util.oneQuoteData.pageSource,
                dataSource:'one-quote',
                currencyConversion:util.oneQuoteData.currencyConversion,
                searchParam : util.oneQuoteData.searchParam ,
                from : util.oneQuoteData.from,
                searchId: util.oneQuoteData.searchId,
                basketCardId : util.oneQuoteData.basketCardId,
                enquiryId : util.oneQuoteData.enquiryId
              }, targetOrigin
            );
            util.redirectToOneQuote(event);
            return;
          }      
          if(event.data.source === 'fcl-v2-result'){
              util.oneQuoteData.selectedCard = event.data.selectedCard;
              util.oneQuoteData.currencyConversion = event.data.currencyConversion;
              util.oneQuoteData.pageSource = event.data.pageSource;
              util.oneQuoteData.searchParam = event.data.searchParam;
              util.oneQuoteData.quoteData = event.data.quoteData;
              util.oneQuoteData.from = event.data.from;
              util.oneQuoteData.searchId = event.data.searchId;

              $state.go("app.searchV2Module.fclEfpRates",{ id: event.data.resultId });
          }
          if(event.data.source === 'lcl-v2-result'){
             util.oneQuoteData.selectedCard = event.data.selectedCard;
              util.oneQuoteData.currencyConversion = event.data.currencyConversion;
              util.oneQuoteData.pageSource = event.data.pageSource;
              util.oneQuoteData.searchParam = event.data.searchParam;
              util.oneQuoteData.quoteData = event.data.quoteData;
              util.oneQuoteData.from = event.data.from;
             util.oneQuoteData.searchId = event.data.searchId;
            $state.go("app.searchV2Module.lclEfpRates",{ id: event.data.resultId });

          }
          if(event.data.source === 'air-v2-result'){
             util.oneQuoteData.selectedCard = event.data.selectedCard;
              util.oneQuoteData.currencyConversion = event.data.currencyConversion;
              util.oneQuoteData.pageSource = event.data.pageSource;
              util.oneQuoteData.searchParam = event.data.searchParam;
              util.oneQuoteData.quoteData = event.data.quoteData;
              util.oneQuoteData.from = event.data.from;
             util.oneQuoteData.searchId = event.data.searchId;
            $state.go("app.searchV2Module.airEfpRates",{ id: event.data.resultId });

          }
          if(event.data.source ==="goToBasket"){
              util.oneQuoteData.selectedCard = event.data.selectedCard;
              util.oneQuoteData.currencyConversion = event.data.currencyConversion;
              util.oneQuoteData.pageSource = event.data.pageSource;
              util.oneQuoteData.searchParam = event.data.searchParam;
              util.oneQuoteData.quoteData = event.data.quoteData;
              util.oneQuoteData.from = event.data.from;
              util.oneQuoteData.searchId = event.data.searchId;
            $state.go("app.basketModule");
          }
          if(event.data.source === 'quotes'){
            $state.go("app.quoteListModule.quoteDetailsModule",{ id: event.data.id });
          }
          if(event.data.source === 'result'){
            $state.go("app.searchV2Module.fclEfpRates",{ id: event.data.data });
          }
          if(event.data.source === 'customer'){
            var targetUrl = $state.href('app.shippers', {}, { absolute: true }); 
            window.open(targetUrl, '_blank');
          }
          if(event.data.source === 'contact'){
            var targetUrl = $state.href('app.users', {}, { absolute: true }); 
            window.open(targetUrl, '_blank');
          }

          // Always open a new tab (do not use pageOpenNewTab — it can $state.go when TARGET_LIST_BLANK is off).
          if(event.data.source === 'pdfConfigurations'){
            var pdfConfigUrl = $state.href('app.pdfConfigurations', {
              entity: event.data.entity
            }, { absolute: true });
            window.open(util.sanitizeQueryParams(pdfConfigUrl), '_blank', 'noopener');
          }

          if(event.data.source === 'cancelQuote'){
            $state.go($rootScope.previousState, $rootScope.previousParams, { reload: true });
          }
          if(event.data.source === 'tariffHeaderList' && event.data.reqData && event.data.reqData._id){
            var tariffUrl = $state.href('app.tariffDetails', { id: event.data.reqData._id });
            window.open(util.sanitizeQueryParams(tariffUrl), '_blank', 'noopener');
          }
            
        }
      }
  
    }
  })();
  
  
(function ()
{
    'use strict';

    angular
        .module('app.notification')
        .controller('NotificationController', NotificationController);

    /** @ngInject */
    function NotificationController(ToolbarSerivice, $state, $log, NotificationService, $location)
    {
        // Data
        var vm = this;
        vm.notificationService = NotificationService;
        vm.notificationData = NotificationService.notificationData.notifications;
        vm.getUnreadCount = NotificationService.unReadNotificationCount;
        vm.backToPreviousTab = backToPreviousTab;
        vm.viewNotification = viewNotification;
        vm.loadMoreRecordsNotification = loadMoreRecordsNotification;
        vm.getData = getData;
        var windowHeight = angular.element(window).height(); //set max height for notification list scroll
        vm.maxHeight = {
            'max-height' : windowHeight
        };
        //function to go privious state
        function backToPreviousTab(){
            window.history.back();
        }

        function getData() {
          NotificationService.getNotificationData(0,10);
        }

        //function to view notification details and make read to true
        function viewNotification(notification) {
            $log.log(notification);
            if(notification.item.link) {
                if(notification.item.link.type === 'internal') {
                    if (notification.item.link.url.split('tab=')[1] !== '' &&
                    notification.item.link.url.split('tab=')[1] !== '/' &&
                    angular.isDefined(notification.item.link.url.split('tab=')[1])
                    ) {
                        NotificationService.shipment_active_tab = decodeURI(notification.item.link.url.split('tab=')[1]);
                        var url = notification.item.link.url.split('?tab=')[0];
                        $location.path(url);
                    } else {
                        $location.path(url);
                    }
                } else {
                    $location.path(url.split('/#!')[1]);
                }
            }
            // $state.go('app.shipments.shipment_details', {id: notification.item.shipment_id});
            if(!notification.read){
                var post_data = {
                    'data': {
                      'read': true
                    }
                };
                NotificationService.updateNotificationData(post_data,notification._id).then(function(){
                    notification.read = true;
                    vm.getUnreadCount = vm.getUnreadCount - 1 ;//request post
                },function(error){
                    $log.log(error);
                });
            }
        }

        //function to load more notification on scroll
        function loadMoreRecordsNotification(notificationLength){
            if(notificationLength !== NotificationService.totalNotificationCount) {
                NotificationService.getNotificationData(notificationLength,10).then(function(response) {
                    vm.notificationData = vm.notificationData.concat(response.notificationData.notifications);
                    vm.getUnreadCount = response.unreadNotificationCount;
                },function(error){
                    $log.log(error);
                });
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.myRatesV2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.myRatesV2', {
                url    : '/tariff/files',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/upload-rates-v2/uploadRatesV2.html',
                        controller : 'myRatesV2Controller as vm'
                    },
                    data : { pageTitle: 'My Rates' }
                },
                resolve : {},
                bodyClass: 'tariff-files'
            });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.myRatesV2')
        .controller('myRatesV2Controller', myRatesV2Controller);

    /** @ngInject */
    function myRatesV2Controller(util, iframeService, $timeout, $state, $rootScope) {
              // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();

      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        window.removeEventListener("message", getIframeRequest, true);
      });
  
      function init() {
        util.isCallingApi = true;
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.myRatesV2 && util.navPermission.myRatesV2[1])){
            util.isCallingApi = false;
            $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();

      $rootScope.$on('app.myRatesV2', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('tariff/my-files');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&permissionDataAccess=true&parentUrl="+ window.location.origin);
        document.getElementById("upload-rates-v2").src = vm.iframeUrl;
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'tariff-pages'){
          $timeout(function () {
            util.isCallingApi = false;
          },10);
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
            if(event.origin === targetOrigin){
                document.getElementById('upload-rates-v2').contentWindow.postMessage({ navPermission: util.navPermission,dataSource:'permissionModule'},targetOrigin);
            }
        }
        if(event.data.source == 'fileList'){
          if(event.data.action === 'add'){
            $state.go('app.uploadRatesV2',{  id: event.data.reqData._id });
            return;
          }
          util.uploadRatesAction = event.data.action;
          $state.go('app.uploadRatesDetails',{  id: event.data.reqData._id });
        }
        if(event.data.source == 'tariffHeaderList'){

          var url = $state.href('app.tariffDetails', { id: event.data.reqData.tariffHeader._id });
          window.open(util.sanitizeQueryParams(url), "_blank", "noopener");
          // $state.go('app.tariffDetails',{ id: event.data.reqData.tariffHeader._id });
      }
        if(event.data.source === 'redirectToHome'){
          $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
        }
        
      }
  
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.myRates', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.myRates', {
                url    : '/my-rates',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/my-rates/my-rates.html',
                        controller : 'MyRatesController as vm'
                    },
                    data : { pageTitle: 'My Rate Files' }
                },
                resolve: {},
                bodyClass: 'my-rates'
            });

    }


})();

(function () {
  "use strict";

  angular.module("app.myRates").controller("MyRatesController", MyRatesController);

  /** @ngInject */
  function MyRatesController(util, iframeService, $timeout, $state, $rootScope) {

    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;

    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;

    // if god user changed forwarder refresh data
    $rootScope.$on('app.myRates', function (event, args) {
      vm.init();
    });

    function init() {
      util.isModulePaid('myRates');
      vm.minHeight = vm.iframeService.iframeHeight;
      if(!(util.navPermission.myRates && util.navPermission.myRates[1])){
        $state.go('app.pages_share_error');
      }

      
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

       $timeout(function () {
        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        vm.formIframeUrl(); // Get Iframe src url
       }, 50);

    }
    vm.init();

    // get my-rates iframe url
    function formIframeUrl() {

      vm.iframeUrl = iframeService.fnGetIframeUrl('myRates');
      vm.iframeUrl+= "&maxHeight="+vm.minHeight["max-height"];
      document.getElementById("my-rates-iframe").src = vm.iframeUrl
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.manageRates', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.manageRates', {
                url    : '/manage-rates',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/manage-rates/manage-rates.html',
                        controller : 'ManageRatesController as vm'
                    },
                    data : { pageTitle: 'Manage Rates' }
                },
                resolve: {},
                bodyClass: 'manage-rates'
            });

    }


})();



(function () {
  "use strict";

  angular.module("app.manageRates").controller("ManageRatesController", ManageRatesController);

  /** @ngInject */
  function ManageRatesController(util, iframeService, $timeout, $state, $rootScope) {

    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;

    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;

    // if god user changed forwarder refresh data
    $rootScope.$on('app.manageRates', function (event, args) {
      vm.init();
    });

    function init() {
      util.isModulePaid('manageRates');
      vm.minHeight = vm.iframeService.iframeHeight;
      if(!(util.navPermission.manageRates && util.navPermission.manageRates[1])){
        $state.go('app.pages_share_error');
      }

      vm.formIframeUrl(); // Get Iframe src url
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

       $timeout(function () {
        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
       }, 50);

    }
    vm.init();

    // get manage-rates iframe url
    function formIframeUrl() {

      vm.iframeUrl = iframeService.fnGetIframeUrl('manageRates');
      document.getElementById("manage-rates-iframe").src = vm.iframeUrl
    }
  }
})();


(function ()
{
    'use strict';

    angular
        .module('app.manageNotification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.manageNotification', {
                url    : '/manage-notification/admin',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/manage-notification/manage-notification.html',
                        controller : 'ManageNotificationController as vm'
                    },
                    data : { pageTitle: 'Manage Notification' }
                },
                resolve: {},
            });
        // State
        $stateProvider
            .state('app.profile.manageNotification', {
                url    : '/manage-notification/user',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/manage-notification/manage-notification.html',
                        controller : 'ManageNotificationController as vm'
                    },
                    data : { pageTitle: 'Manage Notification' }
                },
                params: {
                    place: 'profile' // Default value for place
                },
                resolve: {},
            });

    }


})();

(function () {
    "use strict";
  
    angular.module("app.manageNotification").controller("ManageNotificationController", ManageNotificationController);
  
    /** @ngInject */
    function ManageNotificationController(util, iframeService, $timeout, $state, $rootScope,$stateParams) {
  
      // data
      var vm = this;
      vm.iframeService = iframeService;
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.getIframeHeight = getIframeHeight;
      vm.getDomainData = getDomainData;
      vm.checkVisiblity = checkVisiblity;
    
    
      // if god user changed forwarder refresh data
      $rootScope.$on('app.manageNotification', function (event, args) {
        vm.init();
      });
  
      function init() {
       vm.getDomainData();
     
      }
      vm.init();
      function getDomainData(){
        if (!Object.keys($rootScope.domainData.domain_info).length) {
          util.getDomainData().then(
            function () {
              vm.checkVisiblity();
            },
            function (error) {
              $log.log(error.data);
            }
          );
        } else {
          vm.checkVisiblity();
        }
      }
      function checkVisiblity(){

        util.isModulePaid('manageNotification');
        if((!((util.navPermission.manageNotification && util.navPermission.manageNotification[1]) || ($stateParams.place && $stateParams.place.includes('profile')))) || $rootScope.domainData.domain_info.NOTIFICATION_VERSION == 'v1'){ 
          $state.go('app.pages_share_error');
        }else if(util.isShipper && ($stateParams.place && $stateParams.place.includes('profile'))){
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
        vm.getIframeHeight();
        window.addEventListener('resize', function () {
        vm.getIframeHeight();
        });
      }
      function getIframeHeight(){
            var h1Element = document.getElementById('notification');
            var h1Bottom = h1Element.offsetTop + h1Element.offsetHeight;
            var windowHeight = window.innerHeight;
            var heightToBottom = windowHeight - h1Bottom - 50;
            vm.minHeight = { 'height': heightToBottom + 'px' };
      }
         
 
      function formIframeUrl() {  
        var param = $stateParams.place + 'manageNotification';
        vm.iframeUrl = iframeService.getIntegrationUrl(param);
        document.getElementById("manageNotification-iframe").src = vm.iframeUrl
      }

  
    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.lclMatrixView', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.lclMatrixView', {
                url    : '/lcl-matrix-view',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/lcl-pricing-management/lclMatrixView.html',
                        controller : 'lclMatrixViewController as vm'
                    },
                    data : { pageTitle: 'Lcl Pricing Management' }
                },
                resolve : {},
                bodyClass: 'lcl-matrix-page'
            });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.lclMatrixView')
        .controller('lclMatrixViewController', lclMatrixViewController);

    /** @ngInject */
    function lclMatrixViewController(util, iframeService, $timeout, $state,$rootScope) {
              // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();
      
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        util.isCallingApi = false 
        window.removeEventListener("message", getIframeRequest, true);
    });
  
      function init() {
        util.isCallingApi = true;
        document.documentElement.style.overscrollBehaviorX = 'none';
        
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.lclMatrixView && util.navPermission.lclMatrixView[1])){
            $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();

      $rootScope.$on('app.lclMatrixView', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('lcl-matrix-view');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&reqAccessLclMatrixView=1&parentUrl="+ window.location.origin);
        if(util.navPermission.LCL_MATRIX_VIEW){
          vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&access="+ util.navPermission.LCL_MATRIX_VIEW.join(','));
        }
        if(util.navPermission.MANAGE_TARGET_RATES){
          vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&manageTargetRates="+ util.navPermission.MANAGE_TARGET_RATES.join(','));
        }
        
        document.getElementById("lcl-pricing-iframe").src = vm.iframeUrl;
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'lclMatrixView'){
          $timeout(function () {
            util.isCallingApi = false;
          },200)
          var targetOrigin = (new URL(vm.iframeUrl)).origin;
            if(event.origin === targetOrigin){
                document.getElementById('lcl-pricing-iframe').contentWindow.postMessage({ navPermission: util.navPermission,dataSource:'lclMatrixView'},targetOrigin);
            }
        }
        
      }
  
      }
    })();
    
(function ()
{
    'use strict';

    angular
        .module('app.forwarderAssignment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.forwarderAssignment', {
                url    : '/forwarder-assignment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/forwarder-assignment/forwarder-assignment.html',
                        controller : 'ForwarderAssignmentController as vm'
                    }
                },
                bodyClass: 'forwarder-assignment-page'
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.forwarderAssignment')
        .controller('ForwarderAssignmentController', ForwarderAssignmentController);

    /** @ngInject */
    function ForwarderAssignmentController(RoleService, util, $mdDialog, $log, $scope, $timeout, $state)
    {
        var vm = this;
        var supplierSearchDebounce = null;
        var receiverSearchDebounce = null;
        var receiverRequestToken = 0;

        vm.util = util;
        vm.util.screenTitle = 'Forwarder Assignment';
        vm.permission = util.navPermission.forwarderAssignment || [0, 0, 0, 0];
        vm.isGodLogin = util.isFreightbro;

        vm.supplierList = [];
        vm.selectedSupplier = null;
        vm.receiverList = [];

        vm.searchText = '';
        vm.receiverSearchText = '';

        vm.isDataLoading = false;
        vm.isReceiverLoading = false;
        vm.submit_disabled = false;
        vm.deleteInProgress = false;
        vm.deletingKey = null;

        vm.pageSize = 10;
        vm.pageIndex = 0;
        vm.totalSuppliers = 0;

        vm.receiverPageSize = 10;
        vm.receiverPageIndex = 0;
        vm.pagedReceiverList = [];

        vm.init = init;
        vm.loadSuppliers = loadSuppliers;
        vm.selectSupplier = selectSupplier;
        vm.loadReceivers = loadReceivers;
        vm.openAssignDialog = openAssignDialog;
        vm.confirmUnassign = confirmUnassign;
        vm.cancelDialog = cancelDialog;
        vm.onSearchChange = onSearchChange;
        vm.onReceiverSearchChange = onReceiverSearchChange;
        vm.triggerSearchNow = triggerSearchNow;
        vm.triggerReceiverSearchNow = triggerReceiverSearchNow;
        vm.searchAvailableForwarders = searchAvailableForwarders;
        vm.selectAvailableForwarder = selectAvailableForwarder;
        vm.clearAssignValidation = clearAssignValidation;
        vm.submitAssignment = submitAssignment;
        vm.totalPages = totalPages;
        vm.rangeStart = rangeStart;
        vm.rangeEnd = rangeEnd;
        vm.canPrev = canPrev;
        vm.canNext = canNext;
        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.receiverTotalPages = receiverTotalPages;
        vm.receiverRangeStart = receiverRangeStart;
        vm.receiverRangeEnd = receiverRangeEnd;
        vm.canReceiverPrev = canReceiverPrev;
        vm.canReceiverNext = canReceiverNext;
        vm.receiverPrevPage = receiverPrevPage;
        vm.receiverNextPage = receiverNextPage;
        vm.getSupplierKey = getSupplierKey;
        vm.getReceiverKey = getReceiverKey;
        vm.isSelected = isSelected;

        init();

        $scope.$on('app.forwarderAssignment', function () {
            vm.selectedSupplier = null;
            init();
        });

        function init()
        {
            util.isModulePaid('forwarderAssignment');
            if (!vm.permission[1]) {
                return;
            }
            loadSuppliers();
        }

        function loadSuppliers()
        {
            vm.isDataLoading = true;
            RoleService.listForwarderAssignments({
                query: vm.searchText,
                limit: vm.pageSize,
                offset: vm.pageIndex * vm.pageSize
            }).then(function (response) {
                var payload = response && response.data ? response.data.data : {};
                vm.supplierList = (payload && angular.isArray(payload.forwarders)) ? payload.forwarders : [];
                vm.totalSuppliers = (payload && typeof payload.count === 'number') ? payload.count : vm.supplierList.length;

                if (!vm.supplierList.length && vm.pageIndex > 0) {
                    vm.pageIndex = Math.max(0, vm.pageIndex - 1);
                    vm.isDataLoading = false;
                    loadSuppliers();
                    return;
                }

                if (vm.selectedSupplier && !findSupplierByKey(getSupplierKey(vm.selectedSupplier))) {
                    vm.selectedSupplier = null;
                    vm.receiverList = [];
                }
                if (vm.supplierList.length && !vm.selectedSupplier) {
                    selectSupplier(vm.supplierList[0]);
                }
                vm.isDataLoading = false;
            }, function (error) {
                vm.supplierList = [];
                vm.totalSuppliers = 0;
                vm.isDataLoading = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        }

        function selectSupplier(supplier)
        {
            vm.selectedSupplier = supplier;
            vm.receiverSearchText = '';
            vm.receiverPageIndex = 0;
            loadReceivers();
        }

        function loadReceivers()
        {
            if (!vm.selectedSupplier) {
                receiverRequestToken += 1;
                vm.receiverList = [];
                vm.availableForReceivers = [];
                vm.pagedReceiverList = [];
                vm.isReceiverLoading = false;
                return;
            }
            receiverRequestToken += 1;
            var requestToken = receiverRequestToken;
            var requestSupplierKey = getSupplierKey(vm.selectedSupplier);
            vm.isReceiverLoading = true;
            RoleService.listAssignedReceivers({
                supplierDomainSubscriberId: requestSupplierKey,
                query: vm.receiverSearchText,
                limit: 100,
                offset: 0
            }).then(function (response) {
                if (requestToken !== receiverRequestToken ||
                    requestSupplierKey !== getSupplierKey(vm.selectedSupplier)) {
                    return;
                }
                var payload = response && response.data ? response.data.data : {};
                var receivers = (payload && angular.isArray(payload.receivers)) ? payload.receivers : [];
                vm.receiverList = receivers;
                vm.availableForReceivers = [];
                applyReceiverPagination();
                vm.isReceiverLoading = false;
            }, function (error) {
                if (requestToken !== receiverRequestToken ||
                    requestSupplierKey !== getSupplierKey(vm.selectedSupplier)) {
                    return;
                }
                vm.receiverList = [];
                vm.availableForReceivers = [];
                vm.pagedReceiverList = [];
                vm.isReceiverLoading = false;
                util.showToast(util.displayValidationError(error));
                $log.error(error);
            });
        }

        function isSelected(supplier)
        {
            return vm.selectedSupplier && getSupplierKey(vm.selectedSupplier) === getSupplierKey(supplier);
        }

        function getSupplierKey(supplier)
        {
            return supplier ? supplier.domainSubscriberId : null;
        }

        function getReceiverKey(receiver)
        {
            return receiver ? receiver.domainSubscriberId : null;
        }

        function findSupplierByKey(key)
        {
            for (var i = 0; i < vm.supplierList.length; i++) {
                if (getSupplierKey(vm.supplierList[i]) === key) {
                    return vm.supplierList[i];
                }
            }
            return null;
        }

        function openAssignDialog(ev)
        {
            if (!vm.selectedSupplier) {
                util.showToast('Select a forwarder first');
                return;
            }
            vm.assignForm = {
                supplier: vm.selectedSupplier,
                searchText: '',
                selectedReceiver: null
            };
            vm.assignValidation = {};

            $mdDialog.show({
                templateUrl: 'app/main/forwarder-assignment/forwarder-assignment-form.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                escapeToClose: false,
                controllerAs: 'ctrl',
                controller: function () { this.parent = vm; }
            });
        }

        function searchAvailableForwarders(searchText)
        {
            if (!vm.selectedSupplier || !searchText || searchText.length < 1) {
                return [];
            }
            return RoleService.listForwarderAssignments({
                query: searchText,
                limit: 30,
                offset: 0
            }).then(function (response) {
                var payload = response && response.data ? response.data.data : {};
                var forwarders = (payload && angular.isArray(payload.forwarders)) ? payload.forwarders : [];
                var supplierKey = getSupplierKey(vm.selectedSupplier);
                var assignedKeys = {};
                (vm.receiverList || []).forEach(function (r) {
                    var key = getReceiverKey(r);
                    if (key) {
                        assignedKeys[key] = true;
                    }
                });
                return forwarders.filter(function (item) {
                    if (!item) return false;
                    var key = getReceiverKey(item);
                    return key && key !== supplierKey && !assignedKeys[key];
                });
            }, function (error) {
                $log.error(error);
                return [];
            });
        }

        function selectAvailableForwarder(receiver)
        {
            if (!receiver) {
                return;
            }
            vm.assignForm.selectedReceiver = receiver;
            clearAssignValidation();
        }

        function clearAssignValidation()
        {
            vm.assignValidation.receiver = false;
            vm.assignValidation.duplicate = false;
        }

        function submitAssignment()
        {
            vm.assignValidation = {};
            if (!vm.assignForm || !vm.assignForm.selectedReceiver) {
                vm.assignValidation.receiver = true;
                return;
            }

            var payload = {
                supplierDomainSubscriberId: getSupplierKey(vm.assignForm.supplier),
                receiverDomainSubscriberId: getReceiverKey(vm.assignForm.selectedReceiver)
            };

            vm.submit_disabled = true;
            RoleService.createForwarderAssignment(payload).then(function () {
                vm.submit_disabled = false;
                util.showToast('Forwarder assignment created successfully');
                cancelDialog();
                loadReceivers();
                loadSuppliers();
            }, function (error) {
                vm.submit_disabled = false;
                if (error && error.status === 409) {
                    vm.assignValidation.duplicate = true;
                    return;
                }
                util.showToast(extractServerMessage(error) || util.displayValidationError(error) || 'Something went wrong. Please try again.');
                $log.error(error);
            });
        }

        function extractServerMessage(error)
        {
            if (!error || !error.data) {
                return '';
            }
            if (typeof error.data.message === 'string' && error.data.message) {
                return error.data.message;
            }
            if (error.data.data && typeof error.data.data.message === 'string') {
                return error.data.data.message;
            }
            return '';
        }

        function confirmUnassign(receiver, ev)
        {
            if (!vm.selectedSupplier || !receiver) {
                return;
            }
            var supplierName = vm.selectedSupplier.name || vm.selectedSupplier.domain || '';
            var receiverName = receiver.name || receiver.domain || '';

            var confirm = $mdDialog.confirm()
                .title('Unassign ' + receiverName + '?')
                .textContent('This will remove ' + receiverName + ' as a receiver for ' + supplierName + '.')
                .ariaLabel('Unassign Receiver')
                .targetEvent(ev)
                .ok('Unassign')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                vm.deleteInProgress = true;
                vm.deletingKey = getReceiverKey(receiver);
                var payload = {
                    supplierDomainSubscriberId: getSupplierKey(vm.selectedSupplier),
                    receiverDomainSubscriberId: getReceiverKey(receiver)
                };
                RoleService.deleteForwarderAssignment(payload).then(function () {
                    vm.deleteInProgress = false;
                    vm.deletingKey = null;
                    util.showToast('Forwarder assignment removed successfully');
                    loadReceivers();
                    loadSuppliers();
                }, function (error) {
                    vm.deleteInProgress = false;
                    vm.deletingKey = null;
                    util.showToast(extractServerMessage(error) || util.displayValidationError(error));
                    $log.error(error);
                });
            });
        }

        function cancelDialog()
        {
            $mdDialog.cancel();
        }

        function onSearchChange()
        {
            vm.pageIndex = 0;
            if (supplierSearchDebounce) {
                $timeout.cancel(supplierSearchDebounce);
            }
            supplierSearchDebounce = $timeout(function () {
                supplierSearchDebounce = null;
                loadSuppliers();
            }, 300);
        }

        function triggerSearchNow()
        {
            vm.pageIndex = 0;
            if (supplierSearchDebounce) {
                $timeout.cancel(supplierSearchDebounce);
                supplierSearchDebounce = null;
            }
            loadSuppliers();
        }

        function onReceiverSearchChange()
        {
            if (receiverSearchDebounce) {
                $timeout.cancel(receiverSearchDebounce);
            }
            receiverSearchDebounce = $timeout(function () {
                receiverSearchDebounce = null;
                vm.receiverPageIndex = 0;
                loadReceivers();
            }, 300);
        }

        function triggerReceiverSearchNow()
        {
            if (receiverSearchDebounce) {
                $timeout.cancel(receiverSearchDebounce);
                receiverSearchDebounce = null;
            }
            vm.receiverPageIndex = 0;
            loadReceivers();
        }

        function applyReceiverPagination()
        {
            var total = vm.receiverList.length;
            var maxIndex = Math.max(0, Math.ceil(total / vm.receiverPageSize) - 1);
            if (vm.receiverPageIndex > maxIndex) {
                vm.receiverPageIndex = maxIndex;
            }
            var start = vm.receiverPageIndex * vm.receiverPageSize;
            vm.pagedReceiverList = vm.receiverList.slice(start, start + vm.receiverPageSize);
        }

        function receiverTotalPages()
        {
            return Math.max(1, Math.ceil(vm.receiverList.length / vm.receiverPageSize));
        }

        function receiverRangeStart()
        {
            return vm.receiverList.length ? vm.receiverPageIndex * vm.receiverPageSize + 1 : 0;
        }

        function receiverRangeEnd()
        {
            return Math.min(vm.receiverList.length, (vm.receiverPageIndex + 1) * vm.receiverPageSize);
        }

        function canReceiverPrev()
        {
            return vm.receiverPageIndex > 0;
        }

        function canReceiverNext()
        {
            return vm.receiverPageIndex + 1 < receiverTotalPages();
        }

        function receiverPrevPage()
        {
            if (canReceiverPrev()) {
                vm.receiverPageIndex -= 1;
                applyReceiverPagination();
            }
        }

        function receiverNextPage()
        {
            if (canReceiverNext()) {
                vm.receiverPageIndex += 1;
                applyReceiverPagination();
            }
        }

        function totalPages()
        {
            return Math.max(1, Math.ceil(vm.totalSuppliers / vm.pageSize));
        }

        function rangeStart()
        {
            return vm.totalSuppliers ? vm.pageIndex * vm.pageSize + 1 : 0;
        }

        function rangeEnd()
        {
            return Math.min(vm.totalSuppliers, (vm.pageIndex + 1) * vm.pageSize);
        }

        function canPrev()
        {
            return vm.pageIndex > 0;
        }

        function canNext()
        {
            return vm.pageIndex + 1 < totalPages();
        }

        function prevPage()
        {
            if (canPrev()) {
                vm.pageIndex -= 1;
                loadSuppliers();
            }
        }

        function nextPage()
        {
            if (canNext()) {
                vm.pageIndex += 1;
                loadSuppliers();
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.enquiry')
        .controller('EnquiryListController', EnquiryListController);

    /** @ngInject */
    function EnquiryListController(util, $state, iframeService , $scope,$rootScope,$timeout,$window)
    {
        // Variables
        var vm = this;
        vm.util = util;

        vm.todaysDate = Date.now();
        vm.iframeService = iframeService;
        vm.init = init;
        vm.formIframeUrl = formIframeUrl;
        vm.init();

        $scope.$on('$destroy', function () {
            if (window.removeEventListener) {
            window.removeEventListener("message", getEnquiryListIframeRequest, true);
            } else if (window.detachEvent) {
            window.detachEvent("onmessage", getEnquiryListIframeRequest);
            }
        });
    
      function init() {
        // util.isModulePaid('oneQuote');
        vm.minHeight = vm.iframeService.iframeHeight;

        if(!(util.navPermission.inquiry && util.navPermission.inquiry[1] && util.isEfpEnabled)){
          $state.go('app.pages_share_error');
        }
        
        util.callMixpanel("EFP-Enquiry-list");
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
          vm.formIframeUrl();
        }, 400);

        if(window.addEventListener) {
          window.addEventListener("message", getEnquiryListIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getEnquiryListIframeRequest, true);
        }

  
      }

      $rootScope.$on('app.enquiry', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('enquiry','','web');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&reqAccessV2QuoteList=1&maxHeight="+vm.minHeight["max-height"]);  
        document.getElementById("enquiry-list-iframe").src = vm.iframeUrl;

      }

      
      function getEnquiryListIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if(event.origin.indexOf(util.iframeOrigin) && document.getElementById('enquiry-list-iframe')){
          if(event.data.source === 'enquiry'){
            $state.go("app.enquiry.enquiryDetails",{ id: event.data.id });
          }
          if(event.data.source === 'old-enquiry'){
            // const href = $state.href('app.quoteDetailsModule');
            $window.open('/inquiry', '_blank');
          }
          if(event.data.source === 'one-quote'){
            util.redirectToOneQuote(event);
           }
        }
        if(event.data.source === 'redirectToHome'){
            $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
        }
      }
   
        
      }
})();

// @flow
(function () {
  "use strict";

  angular
    .module("app.rates")
    .controller("CustomRatesController", CustomRatesController);

  /** @ngInject */
  function CustomRatesController($rootScope, SearchService, resultService, customRatesService, $log, util, $element, localStorageService, $mdDialog, $timeout,constObj) {
    var vm = this;
    vm.constObj = constObj;

    // Variables

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
    vm.selectedMode = "SEA-FCL";
    vm.selectedTab = "1";
    vm.saveTabIndex = vm.selectedTab;
    vm.currentLeg = 'MAIN FREIGHT';
    vm.selectedTableMode = 'fcl';
    vm.selectedRateLeg = 'MAIN FREIGHT';
    vm.ratesDataLoad = true;
    vm.saveRatesBtn = false;
    vm.todayDate = new Date();
    vm.util = util;
    vm.forwarder_id = $rootScope.forwarder_id;
    // vm.load = "";
    // vm.currentLeg = '';
    // vm.legCode = '';

    // vm.showPortDetails = false;
    vm.portDetailsForMainFreight = false;
    vm.portDetailsForOrigin = false;
    vm.portDetailsForDestination = false;
    vm.showTable = false;
    vm.showRemoveBtn = false;
    vm.showForm = false;
    vm.indexOfmodalChargesToRemove = [];
    vm.air_basis = ["gross_weight", "volumetric_weight", "chargeable_weight", "chargable_weight", "per_shipment", "per_hawb", "per_bl", "per_kg", constObj.AIR_FREIGHT_BASIS];
    vm.airlinesCharges = ['Air Freight'];
    vm.selectedAirlineCharge = 'Air Freight';

    vm.allColHeaders = ['ORIGIN', 'DESTINATION', 'EQUIPMENT TYPE', 'LINER NAME', 'SERVICE TYPE', 'FROM', 'TO', 'VIA PORT', 'TRANSIT TIME', 'CONTRACT ID', 'REMARKS', 'INCLUSIONS'];
    vm.allColWidths = [100, 100, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100];
    vm.allColumns = [{
        type: 'autocomplete',
        source: vm.originPorts, readOnly: true
      },
      {
        type: 'autocomplete',
        source: vm.destinationPorts, readOnly: true
      },
      {
        type: 'autocomplete',
        source: vm.loadDropDown, readOnly: true
      },
      {
        type: 'autocomplete',
        source: vm.subvendorList, readOnly: true
      },
      {
        type: 'text'
      },
      {
        type: 'calendar',
        options: {
          format: 'DD/MM/YYYY'
        }
      },
      {
        type: 'calendar',
        options: {
          format: 'DD/MM/YYYY'
        }
      },
      {
        type: 'text'
      },
      {
        type: 'text'
      },
      {
        type: 'text'
      },
      {
        type: 'text'
      },
      {
        type: 'text'
      }
    ];

    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: true,
      searching: false,
      order: [],
      responsive: true,
      lengthMenu: [5, 10, 20, 30, 50, 100],
      pageLength: 5
    };

    vm.data = [];
    vm.air_freight_obj = {};
    vm.countries = [];
    vm.selectedOriginPorts = [];
    vm.selectedDestinationPorts = [];
    vm.selectedLoadTypes = [];
    vm.selectedLiner = [];
    vm.modes = ["SEA-FCL", "AIR", "LCL"];
    vm.legs = ["main freight", "origin charges", "destination charges"];

    vm.colProperties = [];
    vm.colProperties.colWidths = [100, 100];
    vm.colProperties.colHeaders = ['COST', 'CURRENCY'];
    vm.destinationPorts = [];
    vm.originPorts = [];
    vm.airlines = [];
    vm.ratesData =  [];

    // Functions
    vm.addNewColumn = addNewColumn;
    vm.getChargeList = getChargeList;
    vm.getRateChargeList = getRateChargeList;
    vm.generateLoadArray = generateLoadArray;
    vm.init = init;
    vm.getLoadList = getLoadList;
    vm.fnSelectLeg = fnSelectLeg;
    vm.populateTable = populateTable;
    vm.populateRows = populateRows;
    vm.fnChangeMode = fnChangeMode;
    vm.fnSaveRates = fnSaveRates;
    vm.fnAddNewColumnToTable = fnAddNewColumnToTable;
    vm.saveRates = saveRates;
    // vm.jexcelTableInit = jexcelTableInit;
    vm.isOdd = isOdd;
    vm.getCountryList = getCountryList;
    vm.getOriginCountryPorts = getOriginCountryPorts;
    vm.getDestinationCountryPorts = getDestinationCountryPorts;
    vm.prepDataToPost = prepDataToPost;
    vm.getAirlines = getAirlines;
    vm.removeNewColumn = removeNewColumn;
    vm.swapPlaces = swapPlaces;
    vm.changeTab = changeTab;
    vm.cancelDialog = cancelDialog;
    vm.tabSwitchConfirmed = tabSwitchConfirmed;
    vm.tabChange = tabChange;
    vm.viewRateModal = viewRateModal;
    vm.resetRateForm = resetRateForm;
    vm.changeRateTableMode = changeRateTableMode;
    vm.findInChargeList = findInChargeList;
    vm.saveRatesBtnForm = saveRatesBtnForm;
    vm.addCharge = addCharge;
    vm.removeChargeFromList = removeChargeFromList;
    vm.deleteRate = deleteRate;
    vm.fnDeleteData = fnDeleteData;
    vm.getPort = getPort;
    vm.getEachRateType = getEachRateType;
    vm.clearPortFields = clearPortFields;
    vm.removeChargesFromModal = removeChargesFromModal;
    vm.getRateType = getRateType;
    // vm.openConfirmModal = openConfirmModal;
    vm.mainFreightNameChange = $rootScope.isJeenaDomain;

    function getPort(searchText,mode){
      return util.getPorts(searchText, mode).then(function(response){
          return response.data.data.port;
      },function(error){
          $log.log(error.data);
          return [];
      });
  }

    if (!util.currencyList.length) {
      util.getCurrencyList().then(function (response) {
        vm.currencyList = util.currencyList;
        vm.colProperties.columns = [{
            type: 'number'
          },
          {
            type: 'autocomplete',
            source: vm.currencyList
          }
        ]
      }, function (error) {
        vm.currencyList = [];
        $log.log(error);
      });
    } else {
      vm.currencyList = util.currencyList;
      vm.colProperties.columns = [{
          type: 'number'
        },
        {
          type: 'autocomplete',
          source: vm.currencyList
        }
      ]
    }

    //////////////////////////////////////////////////////////

    //function to initioanlize api calls needed
    function init() {
      vm.getCountryList();
      vm.subvendorList = [];

      if(!util.getSubvendor.length){
        resultService.getSubVendor().then(function(response){
            angular.forEach(response.data.subvendor_data, function(item){
                if(item.carrier_code != null && item.carrier_code != ""){
                    vm.subvendorList.push(item);
                    util.getSubvendor = angular.copy(vm.subvendorList);
                }
            });
        },function(error){
            vm.subvendorList = [];
            util.getSubvendor = [];
        });
      }else{
        vm.subvendorList = angular.copy(util.getSubvendor);
      }

      vm.getLoadList();
      vm.getAirlines();

      // $('#default-click').click();
    }
    vm.init();

    $rootScope.$on('app.rates', function(event, args) {
      init();
    });

    function findInChargeList(query) {
      return query ? vm.chargeList.filter(createFilterForChargeList(query)) : vm.chargeList;
    }

    function deleteRate(data) {
      vm.deleteName = data;
      $mdDialog.show({
        templateUrl: 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
        clickOutsideToClose: true,
        controllerAs: 'ctrl',
        controller: function () {
          this.parent = vm;
        }
      });
    }

    function fnDeleteData() {
      vm.deleteBtn = true;
      var id;
      if(vm.selectedRateLeg==="MAIN FREIGHT"){
        id = vm.deleteName.custom_identity;
      } else {
        id = vm.deleteName.id;
      }

      var modeToSend;
      if (vm.selectedRateLeg === 'ORIGIN CUSTOMS') {
        if (vm.selectedTableMode === 'fcl') {
          modeToSend = 'l2_fcl_cha';
        } else if (vm.selectedTableMode === 'lcl') {
          modeToSend = 'l2_lcl_cha';
        } else if (vm.selectedTableMode === 'air') {
          modeToSend = 'l2_air_cha';
        }
      } else if (vm.selectedRateLeg === 'MAIN FREIGHT') {
        if (vm.selectedTableMode === 'fcl') {
          modeToSend = 'fcl';
        } else if (vm.selectedTableMode === 'lcl') {
          modeToSend = 'lcl';
        } else if (vm.selectedTableMode === 'air') {
          modeToSend = 'air';
        }
      } else if (vm.selectedRateLeg === 'DESTINATION CUSTOMS') {
        if (vm.selectedTableMode === 'fcl') {
          modeToSend = 'l4_fcl_cha';
        } else if (vm.selectedTableMode === 'lcl') {
          modeToSend = 'l4_lcl_cha';
        } else if (vm.selectedTableMode === 'air') {
          modeToSend = 'l4_air_cha';
        }
      }


          customRatesService.deleteUploadedData(id, modeToSend).then(function (response) {
            vm.deleteBtn = false;
            var i = vm.ratesData.indexOf(vm.deleteName);
            vm.ratesData.splice(i, 1);
            util.showToast(response.data.message)
            vm.cancelDialog();
          }, function (error) {
            vm.deleteBtn = false;
            util.showToast(util.displayValidationError(error));
            $log.error(error);
          });

    }

    function createFilterForChargeList(query) {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(state) {
        var search = state.charge_name.toLowerCase();
        return (search.indexOf(lowercaseQuery) === 0);
      };

    }

    function addCharge(charge) {
      var chargeToAdd = {
        'charge_cost': null,
        'charge_currency': "USD",
        'charge_id': charge.charge_id,
        'charge_name': charge.charge_name,
        'charge_code' : charge.charge_code
      }
      vm.currentRateData.charges[vm.currentRateData.charges.length] = chargeToAdd;
    }

    function saveRatesBtnForm() {
      var mode, currentRateDataTemp, data;
      var nocharge = false;

      if(vm.currentRateData.charges.length) {
        vm.currentRateData.charges.some(function(i) {
          if(i.charge_currency && !i.charge_cost) {
            nocharge = true;
            util.showToast("Don't leave charge cost or currency empty");
            return true;
          }
        });
      } else {
        util.showToast("Add charge to upload");
        nocharge = true;
      }

      if(nocharge){
        return;
      }

      if(vm.currentRateData.origin_port_view) {
        vm.currentRateData.origin_port = vm.currentRateData.origin_port_view.global_port_code || '';
      } else {
        vm.currentRateData.origin_port = '';
      }

      if(vm.currentRateData.destination_port_view) {
        vm.currentRateData.destination_port = vm.currentRateData.destination_port_view.global_port_code || '';
      } else {
        vm.currentRateData.destination_port = '';
      }

      if (vm.currentRateData.origin_port === vm.currentRateData.destination_port) {
        util.showToast('Origin and Destination port can not be same!');
        return;
      }

      if(vm.selectedTableMode === 'fcl') {
        mode = 'SEA-FCL';
        vm.currentRateData.via_port = vm.currentRateData.via_port || "";
        vm.currentRateData.transit_time = vm.currentRateData.transit_time || "";
        vm.currentRateData.contract = vm.currentRateData.contract || "";
        vm.currentRateData.route_code = vm.currentRateData.route_code || "";
        vm.currentRateData.other_charge = vm.currentRateData.other_charge || "";
        vm.currentRateData.If_applicable_charges = vm.currentRateData.If_applicable_charges || "";
        vm.currentRateData.remarks = vm.currentRateData.remarks || "";
        vm.currentRateData.inclusions = vm.currentRateData.inclusions || "";
        if(vm.currentRateData.cfs_stuffing !== 1){
          vm.currentRateData.cfs_stuffing = 0;
        }
        vm.currentRateData.service_type = vm.currentRateData.service_type || "";

        if (util.isFreightbro) {
          vm.forwarder_id = $rootScope.forwarder_id;
        } else {
          vm.forwarder_id = localStorageService.get('authToken').value.vendor_id;
        }

        data = {
          'data': {
            'leg_code': vm.tableMeta.leg_code,
            'mode': mode,
            'vendor_id': vm.forwarder_id,
            'rate_obj': [
              vm.currentRateData
            ]
          }
        }
      } else if (vm.selectedTableMode === 'lcl') {
        mode = 'SEA-LCL';
        currentRateDataTemp = angular.copy(vm.currentRateData);
        currentRateDataTemp.charges.forEach(function(i,k){
          var obj = {};
          obj[i.charge_name] = i.charge_cost;
          obj[i.charge_name + '_basis'] = i.charge_basis;
          obj[i.charge_name + '_min'] = i.charge_min;
          currentRateDataTemp.charges[k] = obj;
        });

        data = {
          'data': {
            'leg_code': vm.tableMeta.leg_code,
          'mode': mode,
          'vendor_id': vm.tableMeta.vendor_id,
          'rate_obj': [
            currentRateDataTemp
          ]
          }
        }
      } else if (vm.selectedTableMode === 'air') {
        mode = 'AIR';
        currentRateDataTemp = angular.copy(vm.currentRateData);
        currentRateDataTemp.charges.forEach(function(i,k){
          var obj = {};
          obj[i.charge_name] = i.charge_cost;
          obj[i.charge_name + '_basis'] = i.charge_basis;
          obj[i.charge_name + '_min'] = i.charge_min;
          currentRateDataTemp.charges[k] = obj;
        });

        if (util.isFreightbro) {
          vm.forwarder_id = $rootScope.forwarder_id;
        } else {
          vm.forwarder_id = localStorageService.get('authToken').value.vendor_id;
        }

        data = {
          'data': {
            'leg_code': vm.tableMeta.leg_code,
          'mode': mode,
          'vendor_id': vm.forwarder_id,
          'rate_obj': [
            currentRateDataTemp
          ]
          }
        }
      }

      console.log(vm.currentRateData);
      util.isCallingApi = true;
      customRatesService.putUploadedData(data).then(function (response) {
        vm.cancelDialog();
        if(vm.indexOfmodalChargesToRemove.length){
          vm.removeChargesFromModal();
        }

        vm.ratesData[vm.ratesDataCurrentIndex] = angular.copy(vm.currentRateData);
        // vm.tempRateData = angular.copy(vm.currentRateData);
        util.showToast(response.data.message);
        util.isCallingApi = false;
      }, function (error) {
        util.isCallingApi = false;
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }

    function removeChargesFromModal() {
      vm.indexOfmodalChargesToRemove.forEach(function(index){
        vm.currentRateData.charges.splice(index, 1);
      });
      vm.indexOfmodalChargesToRemove.length = 0;
    }

    function removeChargeFromList(rate) {
      var index = vm.currentRateData.charges.indexOf(rate);
      vm.indexOfmodalChargesToRemove.push(index);
      vm.currentRateData.charges[index].charge_cost = "";
      vm.currentRateData.charges[index].charge_currency = "";
    }

    function viewRateModal(data, index) {

      if(data.leg_code === 'fcl'){
        vm.selectedMode ='SEA-FCL';
        vm.legCode = 'l2_l3_l4_fcl';
      }

      vm.getRateChargeList(data, index);
    }

    function resetRateForm() {
      vm.currentRateData = angular.copy(vm.tempRateData);
    }

    function changeRateTableMode(leg) {
      vm.selectedRateLeg = leg;
      var modeToSend='';
      if (vm.selectedRateLeg === 'ORIGIN CUSTOMS') {
        if (vm.selectedTableMode === 'fcl') {
          modeToSend = 'l2_fcl_cha';
        } else if (vm.selectedTableMode === 'lcl') {
          modeToSend = 'l2_lcl_cha';
        } else if (vm.selectedTableMode === 'air') {
          modeToSend = 'l2_air_cha';
        }
      } else if (vm.selectedRateLeg === 'MAIN FREIGHT') {
        if (vm.selectedTableMode === 'fcl') {
          modeToSend = 'fcl';
        } else if (vm.selectedTableMode === 'lcl') {
          modeToSend = 'lcl';
        } else if (vm.selectedTableMode === 'air') {
          modeToSend = 'air';
        }
      } else if (vm.selectedRateLeg === 'DESTINATION CUSTOMS') {
        if (vm.selectedTableMode === 'fcl') {
          modeToSend = 'l4_fcl_cha';
        } else if (vm.selectedTableMode === 'lcl') {
          modeToSend = 'l4_lcl_cha';
        } else if (vm.selectedTableMode === 'air') {
          modeToSend = 'l4_air_cha';
        }
      }


      vm.ratesDataLoad = true;

      if (util.isFreightbro) {
        vm.forwarder_id = $rootScope.forwarder_id;
      } else {
        vm.forwarder_id = localStorageService.get('authToken').value.vendor_id;
      }

      util.isCallingApi = true;
      customRatesService.getUploadedData(modeToSend, vm.forwarder_id).then(function (response) {
        vm.ratesDataLoad = false;

        if(vm.selectedTableMode === 'lcl' || vm.selectedTableMode === 'air') {
          response.data.data.rate_obj.forEach(function(j) {
            j.charges.forEach(function(i){
              Object.keys(i).forEach(function(j){
                if(j.indexOf('_basis') !== -1){
                  i.charge_basis = i[j];
                } else if(j.indexOf('_min') !== -1){
                  i.charge_min = i[j];
                } else {
                  i.charge_name = j.split('_').join(' ');
                  i.charge_cost = i[j];
                }
              });
              i.charge_currency = response.data.data.rate_obj.currency;
            });

            // if(vm.selectedRateLeg === 'MAIN FREIGHT') {
            //   j.rate_type = vm.getRateType(j.charges);
            // } else if(vm.selectedRateLeg === 'ORIGIN CUSTOMS') {
            //   j.rate_type = 'Origin Customs';
            // } else if(vm.selectedRateLeg === 'DESTINATION CUSTOMS') {
            //   j.rate_type = 'Destination Customs';
            // }

          });

        }
        // else {
        //     response.data.data.rate_obj.forEach(function(j) {
        //       if(vm.selectedRateLeg === 'MAIN FREIGHT') {
        //         j.rate_type = vm.getRateType(j.charges);
        //       } else if(vm.selectedRateLeg === 'ORIGIN CUSTOMS') {
        //         j.rate_type = 'Origin Customs';
        //       } else if(vm.selectedRateLeg === 'DESTINATION CUSTOMS') {
        //         j.rate_type = 'Destination Customs';
        //       }
        //     });
        // }

        vm.ratesData = response.data.data.rate_obj;

        vm.tableMeta = response.data.data;
        util.isCallingApi = false;
      }, function (error) {
        vm.ratesDataLoad = false;
        util.isCallingApi = false;
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }

    function getRateType(arr) {
      var returnText = '';
      arr.forEach(function(i, k) {
        if(i.charge_id.substring(0, 2) === '20' && returnText.indexOf('Origin') === -1){
          returnText = returnText + 'Origin';
          if(arr.length !== k+1) {
            returnText = returnText + ', ';
          }
        } else if(i.charge_id.substring(0, 2) === '30' && returnText.indexOf('Main Freight') === -1){
          returnText = returnText + 'Main Freight';
          if(arr.length !== k+1) {
            returnText = returnText + ', ';
          }
        } else if(i.charge_id.substring(0, 2) === '40' && returnText.indexOf('Destination') === -1){
          returnText = returnText + 'Destination';
          if(arr.length !== k+1) {
            returnText = returnText + ', ';
          }
        } else if (i.charge_id.substring(0, 2) === '25' && returnText.indexOf('Origin Customs') === -1) {
          returnText = returnText + 'Origin Customs';
          if (arr.length !== k+1) {
            // returnText = returnText + ' | ';
          }
        } else if (i.charge_id.substring(0, 2) === '45' && returnText.indexOf('Destination Customs') === -1) {
          returnText = returnText + 'Destination Customs';
          if (arr.length !== k+1) {
            // returnText = returnText + ' | ';
          }
        }
      });
      return returnText;
    }

    function getEachRateType(charge) {
      if(charge.charge_id.substring(0, 2) === '20'){
        return 'Origin';
      } else if(charge.charge_id.substring(0, 2) === '30'){
        return 'Main Freight';
      } else if(charge.charge_id.substring(0, 2) === '40'){
        return 'Destination';
      } else if(charge.charge_id.substring(0, 2) === '25'){
        return 'Origin Customs';
      } else if(charge.charge_id.substring(0, 2) === '45'){
        return 'Destination Customs';
      }
    }

    function tabChange() {
      vm.changeRateTableMode(vm.selectedRateLeg);
    }

    function swapPlaces() {
      var tempA, tempAports, portList;
      tempA = vm.selectedOriginCountry;
      tempAports = vm.selectedOriginPorts;
      portList = vm.originPorts;
      vm.originPorts = vm.destinationPorts;
      vm.destinationPorts = portList;
      vm.selectedOriginCountry = vm.selectedDestinationCountry;
      vm.selectedOriginPorts = vm.selectedDestinationPorts;
      vm.selectedDestinationCountry = tempA;
      vm.selectedDestinationPorts = tempAports;
    }

    function getAirlines() {
      resultService.getAirlineData().then(function (response) {
        console.log('response: ', response);
        response.data.data.forEach(function (i) {
          vm.airlines.push({
            'id': i.airline_code,
            'name': i.air_line_name
          });
        });
      }, function (error) {
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }

    function getCountryList() {
      customRatesService.getCountries().then(function (response) {
        vm.countries = response.data.countries;
      }, function (error) {
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }

    function getOriginCountryPorts() {
      var mode = '';
      if (vm.selectedMode === 'SEA-FCL') {
        mode = 'sea';
      } else if (vm.selectedMode === 'SEA-LCL') {
        mode = 'sea';
      } else if (vm.selectedMode === 'AIR') {
        mode = 'air';
      }
      vm.originPorts.length = 0;
      vm.selectedOriginPorts.length = 0;
      var data = {
        "country_code": vm.selectedOriginCountry,
        "mode": mode
      }
      customRatesService.getPortsOfCountry(data).then(function (response) {
        response.data.ports.forEach(function (i) {
          vm.originPorts.push({
            'id': i.port_code,
            'name': i.port_code,
            'portcode_portname': i.port_code+'/'+i.portname
          });
        });
      }, function (error) {
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }

    function getDestinationCountryPorts() {
      var mode = '';
      if (vm.selectedMode === 'SEA-FCL') {
        mode = 'sea';
      } else if (vm.selectedMode === 'SEA-LCL') {
        mode = 'sea';
      } else if (vm.selectedMode === 'AIR') {
        mode = 'air';
      }
      vm.destinationPorts.length = 0;
      vm.selectedDestinationPorts.length = 0;
      var data = {
        "country_code": vm.selectedDestinationCountry,
        "mode": mode
      }
      customRatesService.getPortsOfCountry(data).then(function (response) {
        response.data.ports.forEach(function (i) {
          vm.destinationPorts.push({
            'id': i.port_code,
            'name': i.port_code,
            'portcode_portname': i.port_code + '/' + i.portname
          });
        });
      }, function (error) {
        util.showToast(util.displayValidationError(error));
        $log.error(error);
      });
    }

    // function jexcelTableInit() {
    //   $('#my').jexcel({
    //     data: vm.data,
    //     colHeaders: vm.allColHeaders,
    //     colWidths: vm.allColWidths,
    //     columns: vm.allColumns
    //   });

    //   $('#my').find('thead').before(
    //     '<thead class="jexcel_label">' +
    //     '<tr>' +
    //     '<td class="jexcel_label" width="30"></td>' +
    //     '<td colspan="2" width="200" align="center">PORT DETAILS</td>' +
    //     '<td width="320" align="center"></td>' +
    //     '<td width="200" align="center">VALIDITY</td>' +
    //     '<td width="500" align="center"></td>' +
    //     '</tr>' +
    //     '</thead>');
    // }


    function generateLoadArray(i) {
      vm.loadDropDown = [];
      i.forEach(function (j) {
        vm.loadDropDown.push(j.load_code);
      });
    }

    function addNewColumn() {

      vm.fnAddNewColumnToTable();
    }
    //functions related to table - charge add header table- end

    function getChargeList() {
      util.isCallingApi = true;
      customRatesService.getChargeList(vm.selectedMode, vm.legCode).then(function (response) {
        vm.chargeList = response.data;
        util.isCallingApi = false;
      }, function (error) {
          util.isCallingApi = false;
          util.showToast(util.displayValidationError(error));
          $log.error(error);
        });

    }

    function getRateChargeList(data, index) {
      vm.ratesDataCurrentIndex = index;
      switch (vm.selectedRateLeg) {
        case 'ORIGIN':
          if (vm.selectedMode === 'SEA-FCL') {
            vm.legCode = 'l2_l3_l4_fcl';
          } else if (vm.selectedMode === 'SEA-LCL') {
            vm.legCode = 'l2_l3_l4_lcl';
          } else if (vm.selectedMode === 'AIR') {
            vm.legCode = 'l2_air';
          }
          break;
        case 'ORIGIN CUSTOMS':
          if (vm.selectedMode === 'SEA-FCL') {
            vm.legCode = 'l2_fcl_cha';
          } else if (vm.selectedMode === 'SEA-LCL') {
            vm.legCode = 'l2_lcl_cha';
          } else if (vm.selectedMode === 'AIR') {
            vm.legCode = 'l2_air_cha';
          }
          break;
        case 'MAIN FREIGHT':
          if (vm.selectedMode === 'SEA-FCL') {
            vm.legCode = 'l2_l3_l4_fcl';
          } else if (vm.selectedMode === 'SEA-LCL') {
            vm.legCode = 'l2_l3_l4_lcl';
          } else if (vm.selectedMode === 'AIR') {
            vm.legCode = 'l2_l3_l4_air';
          }
          break;
        case 'DESTINATION':
          if (vm.selectedMode === 'SEA-FCL') {
            vm.legCode = 'l4_fcl_cha';
          } else if (vm.selectedMode === 'SEA-LCL') {
            vm.legCode = 'l4_lcl_cha';
          } else if (vm.selectedMode === 'AIR') {
            vm.legCode = 'l4_air_cha';
          }
          break;
        case 'DESTINATION CUSTOMS':
          if (vm.selectedMode === 'SEA-FCL') {
            vm.legCode = 'l4_fcl_cha';
          } else if (vm.selectedMode === 'SEA-LCL') {
            vm.legCode = 'l4_lcl_cha';
          } else if (vm.selectedMode === 'AIR') {
            vm.legCode = 'l4_air_cha';
          }
          break;
      }

      customRatesService.getChargeList(vm.selectedMode, vm.legCode).then(function (response) {
        vm.chargeList = response.data;
        vm.currentRateData = angular.copy(data);
        vm.tempRateData = angular.copy(data);
        if(vm.currentRateData.sub_vendor.sv_id) {
          vm.currentRateData.sub_vendor.id = vm.currentRateData.sub_vendor.sv_id;
        }
        if(vm.currentRateData.sub_vendor.sv_name) {
          vm.currentRateData.sub_vendor.name = vm.currentRateData.sub_vendor.sv_name;
        }

        if(vm.currentRateData.origin_port) {
          vm.currentRateData.origin_port_view = {
            'global_port_code': vm.currentRateData.origin_port
          }
        }

        if(vm.currentRateData.destination_port) {
          vm.currentRateData.destination_port_view = {
            'global_port_code': vm.currentRateData.destination_port
          }
        }

        $mdDialog.show({
          templateUrl: 'app/main/customRates/dialogs/viewRates.html',
          // targetEvent: ev,
          clickOutsideToClose: true,
          controllerAs: 'ctrl',
          onRemoving: vm.resetRateForm,
          controller: function () {
            this.parent = vm
          }
        });
      }, function (error) {
          util.showToast(util.displayValidationError(error));
          $log.error(error);
        });
    }

    function cancelDialog() {
      $mdDialog.hide();
    }

    function changeTab(ev, value, name) {
      if (vm.selectedOriginPorts.length || vm.selectedDestinationPorts.length || vm.selectedLoadTypes.length) {
        if(vm.saveTabIndex === vm.selectedTab) {
          return;
        }
        vm.dialogValue = value;
        vm.dialogName = name;
        $mdDialog.show({
          templateUrl: 'app/main/customRates/dialogs/confirm-switch.html',
          targetEvent: ev,
          clickOutsideToClose: false,
          controllerAs: 'ctrl',
          controller: function () {
            this.parent = vm
          }
        });
      } else {
        vm.fnSelectLeg(value, name);
      }
    }

    function tabSwitchConfirmed() {
      vm.fnSelectLeg(vm.dialogValue, vm.dialogName);

      // vm.selectedTab = vm.currentLeg;
      vm.cancelDialog();
    }

    function fnSelectLeg(value, name) {
      vm.saveTabIndex = vm.selectedTab;
      vm.legCode = '';

      vm.currentLeg = name;
      vm.selectedOriginCountry = null;
      vm.selectedOriginPorts = []
      vm.selectedDestinationCountry = null;
      vm.selectedDestinationPorts = [];
      vm.selectedLiner = [];
      vm.selectedLoadTypes = [];

      if (vm.currentLeg === 'ORIGIN') {
        if (vm.selectedMode === 'SEA-FCL') {
          vm.legCode = 'l2_l3_l4_fcl';
        } else if (vm.selectedMode === 'SEA-LCL') {
          vm.legCode = 'l2_l3_l4_lcl';
        } else if (vm.selectedMode === 'AIR') {
          vm.legCode = 'l2_air';
        }
      } else if (vm.currentLeg === 'ORIGIN CUSTOMS') {
        if (vm.selectedMode === 'SEA-FCL') {
          vm.legCode = 'l2_fcl_cha';
        } else if (vm.selectedMode === 'SEA-LCL') {
          vm.legCode = 'l2_lcl_cha';
        } else if (vm.selectedMode === 'AIR') {
          vm.legCode = 'l2_air_cha';
        }
      } else if (vm.currentLeg === 'MAIN FREIGHT') {
        if (vm.selectedMode === 'SEA-FCL') {
          vm.legCode = 'l2_l3_l4_fcl';
        } else if (vm.selectedMode === 'SEA-LCL') {
          vm.legCode = 'l2_l3_l4_lcl';
        } else if (vm.selectedMode === 'AIR') {
          vm.legCode = 'l2_l3_l4_air';
        }
      } else if (vm.currentLeg === 'DESTINATION') {
        if (vm.selectedMode === 'SEA-FCL') {
          vm.legCode = 'l4_fcl_cha';
        } else if (vm.selectedMode === 'SEA-LCL') {
          vm.legCode = 'l4_lcl_cha';
        } else if (vm.selectedMode === 'AIR') {
          vm.legCode = 'l4_air_cha';
        }
      } else if (vm.currentLeg === 'DESTINATION CUSTOMS') {
        if (vm.selectedMode === 'SEA-FCL') {
          vm.legCode = 'l4_fcl_cha';
        } else if (vm.selectedMode === 'SEA-LCL') {
          vm.legCode = 'l4_lcl_cha';
        } else if (vm.selectedMode === 'AIR') {
          vm.legCode = 'l4_air_cha';
        }
      }

      vm.getChargeList();

      vm.showTable = false;


      var tablinks = document.getElementsByClassName("tablinks");
      for (var i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      vm.selectedLeg = value;
      vm.showForm = true;
      if (value == "main_freight") {
        vm.portDetailsForMainFreight = true;
        vm.portDetailsForDestination = false;
        vm.portDetailsForOrigin = false;
      } else if (value == "origin_part") {
        vm.portDetailsForOrigin = true;
        vm.portDetailsForMainFreight = false;
        vm.portDetailsForDestination = false;
      } else if (value == "destination_part") {
        vm.portDetailsForOrigin = false;
        vm.portDetailsForMainFreight = false;
        vm.portDetailsForDestination = true;
      }
    }

    function populateTable(form) {
      vm.populatedTableForm = form;
      if (vm.selectedDestinationPorts.length && angular.equals(vm.selectedDestinationPorts, vm.selectedOriginPorts)) {
        util.showToast('Origin and destination ports cannot be same!');
        return;
      }
      vm.populateRows();
    }
    // function to populate the rows based on source ports, destination ports and load types
    function populateRows() {
      var rows = [];
      var emptyRow = {
        origin_port: "",
        destination_port: "",
        container_type: "",
        sub_vendor: "",
        service_type: "service_type",
        start: "",
        expiry: "",
        via_route: "",
        transit_time: "",
        contract_id: "contract_id",
        remarks: "remarks",
        inclusions: "inclusions",
        // charges: []
      };
      if (vm.selectedMode === 'SEA-FCL' && !(((vm.selectedOriginCountry &&
              (vm.selectedOriginPorts && vm.selectedOriginPorts.length)) ||
            (vm.selectedDestinationCountry &&
              (vm.selectedDestinationPorts && vm.selectedDestinationPorts.length))) &&
          (vm.selectedLiner && vm.selectedLiner.length) &&
          (vm.selectedLoadTypes && vm.selectedLoadTypes.length))) {

        util.showToast('Please fill the required fields!');
        return;

      } else if (vm.selectedMode !== 'SEA-FCL' && !(((vm.selectedOriginCountry &&
              (vm.selectedOriginPorts && vm.selectedOriginPorts.length)) ||
            (vm.selectedDestinationCountry &&
              (vm.selectedDestinationPorts && vm.selectedDestinationPorts.length))) &&
              (vm.selectedLiner && vm.selectedLiner.length))) {

        util.showToast('Please fill the required fields!');
        return;

      }

      // if(vm.selectedMode === 'AIR' && vm.currentLeg === 'MAIN FREIGHT'){
      //   if(!vm.selectedAirline) {
      //     util.showToast('Please fill airline fields!');
      //     return;
      //   }
      // }

      if (vm.selectedMode !== 'SEA-FCL') {
        vm.selectedLoadTypes = ['20GP'];
      }

      if (vm.selectedLeg == "main_freight") {
        var originPorts = vm.selectedOriginPorts.length;
        var destinationPorts = vm.selectedDestinationPorts.length;
        var loadTypes = vm.selectedLoadTypes.length;
        var liner = vm.selectedLiner.length;
        while (originPorts) {
          var newRow = angular.copy(emptyRow);
          newRow.origin_port = vm.selectedOriginPorts[originPorts - 1];
          var destinationPortsInner = destinationPorts;
          while (destinationPortsInner) {
            newRow = angular.copy(newRow)
            newRow.destination_port = vm.selectedDestinationPorts[destinationPortsInner - 1];
            var loadTypesInner = loadTypes;
            while (loadTypesInner) {
              newRow = angular.copy(newRow);
              newRow.container_type = vm.selectedLoadTypes[loadTypesInner - 1].load_code;
              var linerInner = liner;
              while (linerInner) {
                newRow = angular.copy(newRow);
                newRow.sub_vendor = vm.selectedLiner[linerInner - 1];
                rows.push(newRow);

                linerInner--;
              }

              loadTypesInner--;
            }
            destinationPortsInner--;
          }
          originPorts--;
        }
      } else if (vm.selectedLeg == "origin_part") {
        var originPorts = vm.selectedOriginPorts.length;
        var loadTypes = vm.selectedLoadTypes.length;
        var liner = vm.selectedLiner.length;
        while (originPorts) {
          var newRow = angular.copy(emptyRow);
          newRow.origin_port = vm.selectedOriginPorts[originPorts - 1];
          var loadTypesInner = loadTypes;
          while (loadTypesInner) {
            newRow = angular.copy(newRow);
            newRow.container_type = vm.selectedLoadTypes[loadTypesInner - 1].load_code;
            var linerInner = liner;
              while (linerInner) {
                newRow = angular.copy(newRow);
                newRow.sub_vendor = vm.selectedLiner[linerInner - 1];
                rows.push(newRow);

                linerInner--;
              }

            loadTypesInner--;
          }
          originPorts--;

        }
      } else if (vm.selectedLeg == "destination_part") {
        var destinationPorts = vm.selectedDestinationPorts.length;
        var loadTypes = vm.selectedLoadTypes.length;
        var liner = vm.selectedLiner.length;
        while (destinationPorts) {
          var newRow = angular.copy(emptyRow);
          newRow.destination_port = vm.selectedDestinationPorts[destinationPorts - 1];
          var loadTypesInner = loadTypes;
          while (loadTypesInner) {
            newRow = angular.copy(newRow);
            newRow.container_type = vm.selectedLoadTypes[loadTypesInner - 1].load_code;
            var linerInner = liner;
              while (linerInner) {
                newRow = angular.copy(newRow);
                newRow.sub_vendor = vm.selectedLiner[linerInner - 1];
                rows.push(newRow);

                linerInner--;
              }

            loadTypesInner--;
          }
          destinationPorts--;

        }
      }

      vm.populatedRows = rows;
      var dataToSet = [];
      if((vm.selectedMode === 'SEA-LCL' || vm.selectedMode === 'AIR') && (vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS')){
        angular.forEach(vm.populatedRows, function (value, key) {
          dataToSet.push([value.origin_port, value.destination_port, value.container_type, value.sub_vendor.id, '', '', '', '']);
        });
      } else {
        angular.forEach(vm.populatedRows, function (value, key) {
          dataToSet.push([value.origin_port, value.destination_port, value.container_type, value.sub_vendor.id, '', '', '', value.via_route, value.transit_time, '', '', '']);
        });
      }

      if (vm.populatedRows.length) {
        vm.showTable = true;
      } else {
        vm.showTable = false;
      }

      // vm.data = dataToSet;
      if (vm.selectedMode !== 'SEA-FCL') {
        if (vm.selectedMode === 'AIR' && vm.currentLeg === 'MAIN FREIGHT') {
          $('#my').jexcel({
            data: dataToSet,
            colHeaders: ['ORIGIN', 'DESTINATION', 'CURRENCY', 'LINER NAME', 'SERVICE TYPE', 'FROM', 'TO', 'VIA PORT', 'TRANSIT TIME', 'AIRLINE', 'REMARKS', 'INCLUSIONS', 'BASIS', 'MIN', 'FLAT', '+0', '+45', '+100', '+250', '+500', '+1000'],
            colWidths: [100, 100, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 50, 50, 50, 50, 50, 50, 50, 50],
            columns: [{
                type: 'autocomplete',
                source: vm.originPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.destinationPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.currencyList
              },
              {
                type: 'autocomplete',
                source: vm.subvendorList, readOnly: true
              },
              {
                type: 'text'
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'autocomplete',
                source: vm.airlines
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'autocomplete',
                source: vm.air_basis
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              }
            ]
          });

          $('#my').jexcel('updateSettings', {
            table: function (instance, cell, col, row, val, id) {

              if (col >= 13 && col <= 21) {
                // Get text
                var txt = $(cell).text();
                // Format text
                txt = txt.replace(/[^0-9.]/g, "");
                // Update cell value
                $(cell).html(txt);
              }
            }
          });
        }

        else if (vm.selectedMode === 'SEA-LCL' && vm.currentLeg === 'MAIN FREIGHT') {
          $('#my').jexcel({
            data: dataToSet,
            colHeaders: ['ORIGIN', 'DESTINATION', 'CURRENCY', 'LINER NAME', 'SERVICE TYPE', 'FROM', 'TO', 'VIA PORT', 'TRANSIT TIME', 'CONTRACT ID', 'REMARKS', 'INCLUSIONS'],
            colWidths: [100, 100, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100],
            columns: [{
                type: 'autocomplete',
                source: vm.originPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.destinationPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.currencyList
              },
              {
                type: 'autocomplete',
                source: vm.subvendorList, readOnly: true
              },
              {
                type: 'text'
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              }
            ]
          });
        } else if ((vm.selectedMode === 'SEA-LCL' || vm.selectedMode === 'AIR') && (vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS')) {
          $('#my').jexcel({
            data: dataToSet,
            colHeaders: ['ORIGIN', 'DESTINATION', 'CURRENCY', 'LINER NAME', 'FROM', 'TO', 'REMARKS', 'INCLUSIONS'],
            colWidths: [100, 100, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100],
            columns: [{
                type: 'autocomplete',
                source: vm.originPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.destinationPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.currencyList
              },
              {
                type: 'autocomplete',
                source: vm.subvendorList, readOnly: true
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              // {
              //   type: 'text'
              // },
              // {
              //   type: 'text'
              // },
              // {
              //   type: 'text'
              // },
              {
                type: 'text'
              },
              {
                type: 'text'
              }
            ]
          });
        } else {
          $('#my').jexcel({
            data: dataToSet,
            colHeaders: ['ORIGIN', 'DESTINATION', 'CURRENCY', 'LINER NAME', 'SERVICE TYPE', 'FROM', 'TO', 'VIA PORT', 'TRANSIT TIME', 'CONTRACT ID', 'REMARKS', 'INCLUSIONS'],
            colWidths: [100, 100, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100],
            columns: [{
                type: 'autocomplete',
                source: vm.originPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.destinationPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.currencyList
              },
              {
                type: 'autocomplete',
                source: vm.subvendorList, readOnly: true
              },
              {
                type: 'text'
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              }
            ]
          });
        }

      } else {
        if(vm.currentLeg === 'MAIN FREIGHT') {
          $('#my').jexcel({
            data: dataToSet,
            colHeaders: ['ORIGIN', 'DESTINATION', 'EQUIPMENT TYPE', 'LINER NAME', 'SERVICE TYPE', 'FROM', 'TO', 'VIA PORT', 'TRANSIT TIME', 'CONTRACT ID', 'REMARKS', 'INCLUSIONS'],
            colWidths: [100, 100, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100],
            columns: [{
                type: 'autocomplete',
                source: vm.originPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.destinationPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.loadDropDown, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.subvendorList, readOnly: true
              },
              {
                type: 'text'
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              }
            ]
          });
        } else {
          $('#my').jexcel({
            data: dataToSet,
            colHeaders: ['ORIGIN', 'DESTINATION', 'EQUIPMENT TYPE', 'LINER NAME', 'CFS STUFFING', 'FROM', 'TO', 'ROUTE CODE', 'OTHER CHARGES', 'APPLICABLE CHARGE', 'REMARKS', 'INCLUSIONS'],
            colWidths: [100, 100, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100],
            columns: [{
                type: 'autocomplete',
                source: vm.originPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.destinationPorts, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.loadDropDown, readOnly: true
              },
              {
                type: 'autocomplete',
                source: vm.subvendorList, readOnly: true
              },
              {
                type: 'text'
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'calendar',
                options: {
                  format: 'DD/MM/YYYY'
                }
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              },
              {
                type: 'text'
              }
            ]
          });
        }

      }


      if (vm.currentLeg !== 'MAIN FREIGHT') {
        if (vm.currentLeg === 'ORIGIN' || vm.currentLeg === 'ORIGIN CUSTOMS') {
          $('#my').jexcel('deleteColumn', 1);
        } else {
          $('#my').jexcel('deleteColumn', 0);
        }
      }

      if(vm.selectedMode === 'SEA-FCL' && (vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS')){
        $('#my').find('thead').before(
          '<thead class="jexcel_label">' +
          '<tr>' +
          '<td class="jexcel_label" width="30"></td>' +
          '<td colspan="2" width="220" align="center">PORT DETAILS</td>' +
          '<td width="200" align="center"></td>' +
          '<td width="200" align="center">VALIDITY</td>' +
          '<td width="500" align="center"></td>' +
          '</tr>' +
          '</thead>');
      } else {
        if (vm.selectedMode === 'AIR') {
          if(vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS') {
            $('#my').find('thead').before(
              '<thead class="jexcel_label">' +
              '<tr>' +
              '<td class="jexcel_label" width="30"></td>' +
              '<td colspan="2" width="100" align="center">PORT DETAILS</td>' +
              '<td width="220" align="center"></td>' +
              '<td width="200" align="center">VALIDITY</td>' +
              '<td width="200" align="center"></td>' +
              '</tr>' +
              '</thead>');
          } else {
            $('#my').find('thead').before(
              '<thead class="jexcel_label">' +
              '<tr>' +
              '<td class="jexcel_label" width="30"></td>' +
              '<td colspan="2" width="200" align="center">PORT DETAILS</td>' +
              '<td width="320" align="center"></td>' +
              '<td width="200" align="center">VALIDITY</td>' +
              '<td width="1000" align="center"></td>' +
              '</tr>' +
              '</thead>');
          }

        } else if (vm.selectedMode === 'SEA-LCL' && (vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS')) {
          $('#my').find('thead').before(
            '<thead class="jexcel_label">' +
            '<tr>' +
            '<td class="jexcel_label" width="30"></td>' +
            '<td colspan="2" width="100" align="center">PORT DETAILS</td>' +
            '<td width="220" align="center"></td>' +
            '<td width="200" align="center">VALIDITY</td>' +
            '<td width="200" align="center"></td>' +
            '</tr>' +
            '</thead>');
        } else {
          $('#my').find('thead').before(
            '<thead class="jexcel_label">' +
            '<tr>' +
            '<td class="jexcel_label" width="30"></td>' +
            '<td colspan="2" width="200" align="center">PORT DETAILS</td>' +
            '<td width="320" align="center"></td>' +
            '<td width="200" align="center">VALIDITY</td>' +
            '<td width="500" align="center"></td>' +
            '</tr>' +
            '</thead>');
        }

      }

      console.log("populatedRows", vm.populatedRows)
      $timeout(function () {
          $('#content').scrollTop($('#content')[0].scrollHeight);
      }, 200);

    }

    //geting load type list
    function getLoadList() {
      if (customRatesService.loadTypeArr.length == 0) {
        SearchService.getAllLoadList().then(
          function (response) {
            customRatesService.loadTypeArr = response;
            vm.loadTypeArr = response;
            vm.generateLoadArray(vm.loadTypeArr);
          },
          function (error) {
            $log.log(error.data);
          }
        );
      } else {
        vm.loadTypeArr = customRatesService.loadTypeArr;
        vm.generateLoadArray(vm.loadTypeArr);
      }
    }

    function fnChangeMode() {
      if (vm.currentLeg !== '' && vm.currentLeg !== null && vm.currentLeg !== undefined) {
        // vm.getChargeList();
        if (vm.currentLeg === 'ORIGIN') {
          vm.fnSelectLeg('origin_part', 'ORIGIN');
        } else if (vm.currentLeg === 'ORIGIN CUSTOMS') {
          vm.fnSelectLeg('origin_part', 'ORIGIN CUSTOMS');
        } else if (vm.currentLeg === 'MAIN FREIGHT') {
          vm.fnSelectLeg('main_freight', 'MAIN FREIGHT');
        } else if (vm.currentLeg === 'DESTINATION CUSTOMS') {
          vm.fnSelectLeg('destination_part', 'DESTINATION CUSTOMS');
        } else if (vm.currentLeg === 'DESTINATION') {
          vm.fnSelectLeg('destination_part', 'DESTINATION');
        }
        vm.showTable = false;
      }
    }

    function removeNewColumn() {
      var noOfColumns, lastColumn;

      if (vm.selectedMode !== 'SEA-FCL') {
        noOfColumns = 3;
      } else {
        noOfColumns = 2;
      }

      if (vm.currentLeg === 'MAIN FREIGHT') {
        if (vm.selectedMode === 'AIR') {
          lastColumn = 21;
        } else {
          lastColumn = 12;
        }
      } else {
        if(vm.selectedMode === 'SEA-LCL'){
          lastColumn = 7;
        } else {
          lastColumn = 11;
        }
      }

      var store = $('#my').jexcel('getData', false);

      var filtered = store[0].filter(function (el) {
        return el !== null;
      });

      if ($('#my').find('tr:first td:last').hasClass("addedColumn")) {
        $('#my').jexcel('deleteColumn', filtered.length - 2, noOfColumns);
        $('#my').find('tr:first td:last').remove();
        if ($('#my').find('tr:first td:last').hasClass("addedColumn")) {
          vm.showRemoveBtn = true;
        } else {
          vm.showRemoveBtn = false;
        }
      }

    }

    //add new column to handsontable
    function fnAddNewColumnToTable() {
      var options = '';
      if (vm.selectedMode === 'SEA-FCL') {
        vm.chargeList.forEach(function (i) {
          options += '<option value="' + i.charge_id + '=>' + i.charge_name + '">' + i.charge_name + '</option>';
        });
      } else {
        vm.chargeList.forEach(function (i) {
          options += '<option value="' + i.charge_id + '=>' + i.charge_name + '=>' + i.leg + '">' + i.charge_name + '</option>';
        });
      }

      if (vm.selectedMode === "SEA-FCL") {
        $('#my').jexcel('insertColumn', 2, vm.colProperties, null);
        $('#my').find('tr:first td:last').after('<td width="200" class="addedColumn" align="center">' +
          '<select class="getCharge tableChargeList" style="border:none;max-width:175px;font-size:14px;">' + options +
          // '<option ng-repeat="charge in vm.chargeList" ng-value="charge.charge_name">{{charge.charge_name}}</option>'+
          // '<option value="saab">Saab</option>'+
          // '<option value="mercedes">Mercedes</option>'+
          // '<option value="audi">Audi</option>'+
          '</select> ' +
          '</td>');

        $('#my').jexcel('updateSettings', {
          table: function (instance, cell, col, row, val, id) {
            if (vm.currentLeg !== 'MAIN FREIGHT') {
              if (col >= 11 && vm.isOdd(col)) {
                // Get text
                var txt = $(cell).text();
                // Format text
                txt = txt.replace(/[^0-9.]/g, "");
                // Update cell value
                $(cell).html(txt);
              }
            } else {
              if (col >= 12 && !vm.isOdd(col)) {
                // Get text
                var txt = $(cell).text();
                // Format text
                txt = txt.replace(/[^0-9.]/g, "");
                // Update cell value
                $(cell).html(txt);
              }
            }
          }
        });
      } else {
        var colProperties = [];
        colProperties.colWidths = [100, 100, 100];
        colProperties.colHeaders = ['COST', 'MIN', 'BASIS'];
        colProperties.columns = [{
            type: 'number'
          },
          {
            type: 'number'
          },
          {
            type: 'autocomplete',
            source: ["gross_weight", "per_cbm", "per_w/m", "per_shipment", "per_hbl", "per_bl", "flat", "per shipping bill", "per_ton", "per_quintal", "per_doc", "per_lbs"]
          }
        ]
        $('#my').jexcel('insertColumn', 3, colProperties, null);
        $('#my').find('tr:first td:last').after('<td width="300" class="addedColumn" align="center">' +
          '<select class="getCharge tableChargeList" style="border:none;max-width:175px;font-size:14px;">' + options +
          // '<option ng-repeat="charge in vm.chargeList" ng-value="charge.charge_name">{{charge.charge_name}}</option>'+
          // '<option value="saab">Saab</option>'+
          // '<option value="mercedes">Mercedes</option>'+
          // '<option value="audi">Audi</option>'+
          '</select> ' +
          '</td>');

        // var firstCol = true;
      }

      $(function () {
        $(".tableChargeList").select2();
      });


      vm.showRemoveBtn = true;
      var left = $('#my-container').width();
      $('#my-container').scrollLeft(left);
    }

    function isOdd(num) {
      return num % 2;
    }

    function fnSaveRates() {
      var postData = true;
      var charges = [];
      var pieces, cell;
      if (vm.currentLeg === 'MAIN FREIGHT') {
        cell = 0;
      } else {
        cell = -1;
      }

      $(".getCharge").each(function () {
        pieces = $(this).val().split("=>");
        if(vm.selectedLeg !== 'SEA-FCL'){
          charges.push({
            'id': pieces[0],
            'name': pieces[1],
            'leg': pieces[2]
          });
        } else {
          charges.push({
            'id': pieces[0],
            'name': pieces[1]
          });
        }
      });

      var store = $('#my').jexcel('getData', false);
      var rate_obj = [];
      var rate, startDate, endDate;
      var subVendor = null;
      store.some(function (row) {
        row = row.filter(function (el) {
          return el != null;
        });
        rate = {};
        startDate = null;
        endDate = null;

        if((vm.selectedMode === 'SEA-LCL' || vm.selectedMode === 'AIR') && (vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS')) {
          if (vm.currentLeg === 'ORIGIN' || vm.currentLeg === 'ORIGIN CUSTOMS') {
            rate.origin_port = row[0] || '';
            rate.destination_port = 0;
          } else if (vm.currentLeg === 'DESTINATION' || vm.currentLeg === 'DESTINATION CUSTOMS') {
            rate.origin_port = 0;
            rate.destination_port = row[0] || '';
          }

          if (row[1] === '') {
            util.showToast("Don't leave currency fields empty!");
            postData = false;
            return true;
          }
          rate.currency = row[1] || '';

          vm.subvendorList.forEach(function (i) {
            if (i.id === Number(row[2])) {
              subVendor = i;
            }
          });
          rate.sub_vendor = subVendor;

          if (row[3] && row[3] !== "") {
            startDate = new Date(row[3]);
            startDate.setHours('23');
            startDate.setMinutes('59');
            startDate = startDate.toISOString();
          } else {
            startDate = '';
            util.showToast("Don't leave start date empty!");
            postData = false;
            return true;
          }
          rate.start = startDate;

          if (row[4] && row[4] !== "") {
            endDate = new Date(row[4]);
            endDate.setHours('23');
            endDate.setMinutes('59');
            endDate = endDate.toISOString();
          } else {
            endDate = '';
            util.showToast("Don't leave expiry date empty!");
            postData = false;
            return true;
          }
          rate.expiry = endDate;

          rate.remarks = row[5] || '';
          rate.inclusions = row[6] || '';
          rate.charges = [];
          if (row.length > 7 && charges.length) {
            for (var i = 0, j = 7; i < charges.length; i++) {
              if (row[j] === '' || row[j + 1] === '' || row[j + 2] === '') {
                util.showToast("Don't leave cost or currency or basis fields empty!");
                postData = false;
                return true;
              } else {
                var obj = {};
                obj[charges[i].id] = row[j];
                obj[charges[i].id + '_min'] = row[j + 1];
                obj[charges[i].id + '_basis'] = row[j + 2];
                if(vm.selectedLeg !== 'SEA-FCL'){
                  if(vm.currentLeg === 'MAIN FREIGHT'){
                    obj.leg = charges[i].leg;
                  }
                }

                rate.charges.push(obj);
                j = j + 3;
              }
            }
          } else {
            util.showToast('Add some charges first!');
            postData = false;
            return true;
          }

        } else {
          if (vm.currentLeg === 'MAIN FREIGHT') {
            rate.origin_port = row[0] || '';
            rate.destination_port = row[1] || '';
          } else if (vm.currentLeg === 'ORIGIN' || vm.currentLeg === 'ORIGIN CUSTOMS') {
            rate.origin_port = row[0] || '';
            rate.destination_port = 0;
          } else if (vm.currentLeg === 'DESTINATION' || vm.currentLeg === 'DESTINATION CUSTOMS') {
            rate.origin_port = 0;
            rate.destination_port = row[0] || '';
          }

          if (vm.selectedMode !== 'SEA-FCL') {
            if (row[cell + 2] === '') {
              util.showToast("Don't leave currency fields empty!");
              postData = false;
              return true;
            }
            rate.currency = row[cell + 2] || '';
          } else {
            rate.load_type = row[cell + 2] || '';
          }

          vm.subvendorList.forEach(function (i) {
            if (i.id === Number(row[cell + 3])) {
              subVendor = i;
            }
          });
          rate.sub_vendor = subVendor;
          // if(row[cell + 4] === '' && vm.currentLeg === 'MAIN FREIGHT'){
          //   util.showToast("Don't leave service type empty!");
          //     postData = false;
          //     return true;
          // } else {
          if(vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS'){
            if(row[cell + 4] === '1'){
              rate.cfs_stuffing = 1;
            } else {
              rate.cfs_stuffing = 0;
            }
          } else {
            rate.service_type = row[cell + 4] || '';
          }
          // }

          if (row[cell + 5] && row[cell + 5] !== "") {
            startDate = new Date(row[cell + 5]);
            startDate.setHours('23');
            startDate.setMinutes('59');
            startDate = startDate.toISOString();
          } else {
            startDate = '';
            util.showToast("Don't leave start date empty!");
            postData = false;
            return true;
          }
          rate.start = startDate;

          if (row[cell + 6] && row[cell + 6] !== "") {
            endDate = new Date(row[cell + 6]);
            endDate.setHours('23');
            endDate.setMinutes('59');
            endDate = endDate.toISOString();
          } else {
            endDate = '';
            util.showToast("Don't leave expiry date empty!");
            postData = false;
            return true;
          }
          rate.expiry = endDate;

          if(vm.currentLeg === 'DESTINATION CUSTOMS' || vm.currentLeg === 'ORIGIN CUSTOMS'){
            rate.route_code = row[cell + 7] || '';
            rate.other_charges = row[cell + 8] || '';
            rate.If_applicable_charges = row[cell + 9] || '';

          } else {
            if(vm.selectedMode === 'SEA-LCL' || vm.selectedMode === 'SEA-FCL') {
              rate.via_port = row[cell + 7] || '';
            }
            // else {
            //   rate.via_route = row[cell + 7] || '';
            // }
            rate.transit_time = row[cell + 8] || '';
            rate.contract = row[cell + 9] || '';

          }

          rate.remarks = row[cell + 10] || '';
          rate.inclusions = row[cell + 11] || '';
          if (vm.selectedMode === 'AIR' && vm.currentLeg === 'MAIN FREIGHT') {
            if (row[cell + 12] === '') {
              util.showToast("Don't leave basis fields empty!");
              postData = false;
              return true;
            }
            vm.air_freight_obj.basis = row[cell + 12] || '';
          }
          rate.charges = [];
          if (vm.selectedMode === 'SEA-FCL') {
            if (row.length > 12 && charges.length) {
              for (var i = 0, j = 12; i < charges.length; i++) {
                if (row[cell + j] === '' || row[cell + j + 1] === '') {
                  util.showToast("Don't leave cost or currency or basis fields empty!");
                  postData = false;
                  return true;
                } else {
                  rate.charges.push({
                    'charge_name': charges[i].name,
                    'charge_cost': row[cell + j],
                    'charge_currency': row[cell + j + 1],
                    'charge_id': charges[i].id
                  });
                  j = j + 2;
                }
              }
            } else {
              util.showToast('Add some charges first!');
              postData = false;
              return true;
            }
          } else {
            if (vm.selectedMode === 'AIR' && vm.currentLeg === 'MAIN FREIGHT') {
              if (row[cell + 15] === '' && row[cell + 16] === '' && row[cell + 17] === '' && row[cell + 18] === '' && row[cell + 19] === '' && row[cell + 20] === '') {
                util.showToast('Add some slab first!');
                postData = false;
                return true;
              }
              vm.air_freight_obj.min = row[cell + 13] || 0;
              vm.air_freight_obj.flat = row[cell + 14] || 0;
              vm.air_freight_obj["0-44"] = row[cell + 15] || 0;
              vm.air_freight_obj["45-99"] = row[cell + 16] || 0;
              vm.air_freight_obj["100-249"] = row[cell + 17] || 0;
              vm.air_freight_obj["250-299"] = row[cell + 18] || 0;
              vm.air_freight_obj["500-999"] = row[cell + 19] || 0;
              vm.air_freight_obj["1000+"] = row[cell + 20] || 0;
              if (row.length > 21 && charges.length) {
                for (var i = 0, j = 21; i < charges.length; i++) {
                  if (row[cell + j] === '' || row[cell + j + 1] === '' || row[cell + j + 2] === '') {
                    util.showToast("Don't leave cost or currency or basis fields empty!");
                    postData = false;
                    return true;
                  } else {
                    var obj = {};
                    if (charges[i].id === 'fsc') {
                      vm.isFscCharge = true;
                    } else {
                      vm.isFscCharge = false;
                    }
                    obj[charges[i].id] = row[cell + j];
                    obj[charges[i].id + '_min'] = row[cell + j + 1];
                    obj[charges[i].id + '_basis'] = row[cell + j + 2];
                    obj.leg = charges[i].leg;

                    rate.charges.push(obj);
                    j = j + 3;
                  }
                }
                if (!vm.isFscCharge) {
                  util.showToast("Add Fuel surcharge first!");
                  postData = false;
                  return true;
                }
                console.log('rate.charges: ', rate.charges);
                // rate.charges.air_freight = vm.air_freight_obj;
                rate.charges.push({
                  "air_freight": vm.air_freight_obj,
                  "leg": 'l3'
                });
              } else {
                util.showToast('Add some charges first!');
                postData = false;
                return true;
              }
            } else {
              if (row.length > 12 && charges.length) {
                for (var i = 0, j = 12; i < charges.length; i++) {
                  if (row[cell + j] === '' || row[cell + j + 1] === '' || row[cell + j + 2] === '') {
                    util.showToast("Don't leave cost or currency or basis fields empty!");
                    postData = false;
                    return true;
                  } else {
                    var obj = {};
                    obj[charges[i].id] = row[cell + j];
                    obj[charges[i].id + '_min'] = row[cell + j + 1];
                    obj[charges[i].id + '_basis'] = row[cell + j + 2];
                    if(vm.selectedLeg !== 'SEA-FCL'){
                      if(vm.currentLeg === 'MAIN FREIGHT'){
                        obj.leg = charges[i].leg;
                      }
                    }

                    rate.charges.push(obj);
                    j = j + 3;
                  }
                }
              } else {
                util.showToast('Add some charges first!');
                postData = false;
                return true;
              }
            }

          }
        }
        var valueArr = rate.charges.map(function (item) { return item.charge_id });
        var isDuplicate = valueArr.some(function (item, idx) {
          return valueArr.indexOf(item) != idx
        });

        if(isDuplicate){
          postData = false;
          util.showToast('Please remove duplicate charge');
          return true;
        }

        rate_obj.push(rate);
      });
      if (postData === true) {
        vm.prepDataToPost(rate_obj);
      }
    }

    function prepDataToPost(rate_obj) {
      if (vm.currentLeg === 'MAIN FREIGHT') {
        rate_obj.forEach(function (a) {
          a.start_date = a.start
          delete a.start
          // a.start_date = ''
          // a.via_port = ''
          a.route = ''
          // a.transit_time = ''
          // a.contract_id = ''
          a.route_code = ''
          a.other_charges = ''
          a.If_applicable_charges = ''
          // a.remarks = ''
          // a.inclusions = ''
          if (vm.selectedMode === 'AIR') {
            a.airline = a.contract;
            a.contract = '';
            a.via_route = '';
          }
          a.uploaded_by = '';
          a.cfs_stuffing = 0;
          // a.transit_time = ''
          // a.expiry = ''
        })
      }
      if (vm.currentLeg === 'ORIGIN') {
        rate_obj.forEach(function (a) {
          if (vm.selectedMode === 'SEA-FCL' || vm.selectedMode === 'SEA-LCL') {
            delete a.service_type
          }
          delete a.destination_port;
          // a.cfs_stuffing = '';
          // delete a.service_type
          a.start_date = a.start
          // a.start_date = ''
          // a.expiry = ''
          delete a.via_route
          delete a.transit_time
          delete a.contract_id
          delete a.start
          // a.route_code = ''
          a.If_applicable_charges = ''
          a.uploaded_by = ''
          a.other_charges = ''
          // a.inclusions = ''
          // a.remarks = ''
        })
      }
      if (vm.currentLeg === 'ORIGIN CUSTOMS') {
        rate_obj.forEach(function (a) {
          delete a.destination_port;
          // a.cfs_stuffing = 0;
          delete a.service_type
          a.start_date = a.start
          // a.start_date = ''
          // a.load_type = a.container_type
          delete a.container_type
          delete a.via_route
          delete a.transit_time
          delete a.contract_id
          delete a.start
          // a.route_code = ""
          a.via_port = ""
          // a.If_applicable_charges = ""
          a.uploaded_by = ""
          // a.other_charges = ''
          if (vm.selectedMode === 'AIR') {
            a.airline = a.contract;
            a.contract = '';
          }
          // a.inclusions = ''
          // a.expiry = ''
          // a.remarks = ''
        })
      }
      if (vm.currentLeg === 'DESTINATION') {
        rate_obj.forEach(function (a) {
          if (vm.selectedMode === 'SEA-FCL') {
            delete a.service_type
          }
          delete a.origin_port;
          // a.cfs_stuffing = '';

          a.start_date = a.start
          // a.start_date = ''
          // a.expiry = ''
          a.load_type = a.container_type
          delete a.container_type
          delete a.via_route
          delete a.transit_time
          delete a.contract_id
          delete a.start
          // a.route_code = ""
          a.If_applicable_charges = ""
          a.uploaded_by = ""
          a.other_charges = 0
          if (vm.selectedMode === 'AIR') {
            a.airline = a.contract;
            a.contract = '';
          }
          // a.remarks = ''
          // a.inclusions = ''
        })
      }
      if (vm.currentLeg === 'DESTINATION CUSTOMS') {
        rate_obj.forEach(function (a) {
          if (vm.selectedMode === 'SEA-FCL') {
            delete a.service_type
          }
          delete a.origin_port;
          // a.cfs_stuffing = 0;

          a.start_date = a.start
          // a.start_date = ''
          // a.load_type = a.container_type
          delete a.container_type
          delete a.via_route
          delete a.transit_time
          delete a.contract_id
          delete a.start
          a.via_port = ""
          // a.route_code = ""
          // a.inclusions = ''
          // a.remarks = ''
          // a.If_applicable_charges = ""
          a.uploaded_by = ""
          // a.other_charges = 0
          // a.expiry = ''
        })
      }

      var modeToSend='';
      if (vm.currentLeg === 'ORIGIN CUSTOMS') {
        if (vm.selectedMode === 'SEA-FCL') {
          modeToSend = 'l2_fcl_cha';
        } else if (vm.selectedMode === 'SEA-LCL') {
          modeToSend = 'l2_lcl_cha';
        } else if (vm.selectedMode === 'AIR') {
          modeToSend = 'l2_air_cha';
        }
      } else if (vm.currentLeg === 'MAIN FREIGHT') {
        if (vm.selectedMode === 'SEA-FCL') {
          modeToSend = 'fcl';
        } else if (vm.selectedMode === 'SEA-LCL') {
          modeToSend = 'lcl';
        } else if (vm.selectedMode === 'AIR') {
          modeToSend = 'air';
        }
      } else if (vm.currentLeg === 'DESTINATION CUSTOMS') {
        if (vm.selectedMode === 'SEA-FCL') {
          modeToSend = 'l4_fcl_cha';
        } else if (vm.selectedMode === 'SEA-LCL') {
          modeToSend = 'l4_lcl_cha';
        } else if (vm.selectedMode === 'AIR') {
          modeToSend = 'l4_air_cha';
        }
      }

      if (util.isFreightbro) {
        vm.forwarder_id = $rootScope.forwarder_id;
      } else {
        vm.forwarder_id = localStorageService.get('authToken').value.vendor_id;
      }

      var data = {
        'data': {
          'leg_name': vm.currentLeg.toLowerCase(),
          'mode': vm.selectedMode,
          'leg_code': modeToSend,
          'vendor_id': vm.forwarder_id,
          'rate_obj': rate_obj
        }
      }


      // console.log(data);
      // return;

      util.isCallingApi = true;
      customRatesService.submitRates(data).then(function (response) {
        util.showToast('Rates added successfully!');
        // $('#my').jexcel('destroy');
        vm.populatedTableForm.$setPristine();
        vm.populatedTableForm.$setUntouched();
        // vm.showForm = false;
        vm.showTable = false
        util.isCallingApi = false;
        vm.clearPortFields();
        // vm.fnSelectLeg('', vm.currentLeg, vm.selectedLeg);

      }, function (error) {
        util.showToast(util.displayValidationError(error));
        $log.error(error);
        util.isCallingApi = false;
      });
    }

    function saveRates() {
      console.log("populatedRows", vm.populatedRows);
      // console.log("table data ", data1);
    }

    function clearPortFields() {
      vm.selectedOriginCountry = null;
      vm.selectedOriginPorts = [];
      vm.selectedDestinationCountry = null;
      vm.selectedDestinationPorts = [];
      vm.selectedLiner = [];
      vm.selectedLoadTypes = [];
      vm.destinationPorts = [];
      vm.originPorts = [];
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.currencySetting', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.currencySetting', {
                url    : '/currency-setting',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/currency-setting/currency-setting.html',
                        controller : 'CurrencySettingController as vm'
                    },
                    data : { pageTitle: 'Currency-Setting' }
                },

                bodyClass: 'currency-setting-page'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/shipments');

        // Api
        // msApiProvider.register('shipments', ['app/data/shipments/shipments.json']);
        // msApiProvider.register('shipmentDetails', ['app/data/shipments/shipmentDetails.json']);

        // msNavigationServiceProvider.saveItem('fuse.currencySetting', {
        //     title    : 'Currency Setting',
        //     icon     : 'icon-airplane',
        //     state    : 'app.currencySetting',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     // translate: 'SHIPMENTS.SHIPMENTS_NAV',
        //     weight   : 1
        // });
    }


})();

(function () {
  "use strict";

  angular.module("app.currencySetting").controller("CurrencySettingController", CurrencySettingController);

  /** @ngInject */
  function CurrencySettingController(util, iframeService, $timeout, $state, $rootScope) {
    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;

    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;

    // if god user changed forwarder refresh data
    $rootScope.$on('app.currencySetting', function (event, args) {
      vm.init();
    });

    // vm.minHeight = vm.util.iframeHeight;
    function init() {
      util.isModulePaid('currencySetting');
      if(!(util.navPermission.currencySetting && util.navPermission.currencySetting[1])){
        $state.go('app.pages_share_error');
        return;
      }

      vm.formIframeUrl(); // Get Iframe src url
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

      $timeout(function () {
        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
      }, 1000);
    }
    vm.init();

    // get manage-rates iframe url
    function formIframeUrl() {

      vm.iframeUrl = iframeService.fnGetIframeUrl('currencySetting');

      document.getElementById("currency-iframe").src = vm.iframeUrl;
    }
  }
})();


(function () {
    'use strict';

    angular
        .module('app.createShipment')
        .controller('CreateShipmentsController', ShipmentsController);

    /** @ngInject */
    function ShipmentsController(util, $mdDialog, $log, TrackService, ShipmentService, $location, $window,analytics,$state) {

        var vm = this;
        vm.util = util;
        vm.airLineData = [];
        vm.todayDate = new Date();
        vm.tomorrowDate = new Date();
        vm.tomorrowDate.setDate(vm.todayDate.getDate()+1);
        // Data variable
        vm.shipperList =  [];
        vm.shipment = {
            'eta' : null,
            'etd' : null,
            'manual': true,
            'cargo_ready_date' : null,
            'hawb': null,
            'mawb': null

        };

        vm.shipment.load = [{
            'pallet_no': '',
            'gross_weight': '',
            'chargeable_weight': '',
            'qty': '',
            'gross_weight_unit': 'KG',
            'chargeable_weight_unit': 'KG',
            'remarks': '',
            // 'volumetric_weight': '',
            // 'volumetric_weight_unit': 'KG',
            'load_number': ''
        }];


        vm.openCreateShipmentModal = openCreateShipmentModal;
        vm.openSuccessModal = openSuccessModal;
        vm.closeDialog = closeDialog;
        vm.getShipperList =  getShipperList;
        vm.getPort =  util.getPorts;
        vm.submitShipment = submitShipment;
        vm.addLoad = addLoad;
        vm.removeLoad = removeLoad;
        vm.clearForm = clearForm;
        vm.goToCreatedShipment = goToCreatedShipment;
        vm.clearAllLoad = clearAllLoad;


        function init(){
          util.isModulePaid('createShipment');
          if(!(util.navPermission["createShipment"] && util.navPermission["createShipment"][0])){
            $state.go('app.pages_share_error');
          }
          analytics.track('Create-Shipment');
          if(!TrackService.airLineData.length){ // calling the airline list
              getAirLineList();
          } else{
              vm.airLineData = TrackService.airLineData;
          }
        }

        init();

        function openCreateShipmentModal(ev) {
            $mdDialog.show({
                templateUrl        : 'app/main/shipments/dialogs/create-shipment/create-shipment.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm; }
            });
        }

        function openSuccessModal(ev) {
          $mdDialog.show({
              templateUrl        : 'app/main/create-shipment/dialogs/create-shipment-success.html',
              targetEvent        : ev,
              clickOutsideToClose: true,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm; }
          });
      }


        /**
         * function to add Load in load structure
         */
        function addLoad(index){
            vm.shipment.load.push({
                'pallet_no': '',
                'gross_weight': '',
                'chargeable_weight': '',
                'qty': '',
                'gross_weight_unit': 'KG',
                'chargeable_weight_unit': 'KG',
                'remarks': '',
                // 'volumetric_weight': '',
                // 'volumetric_weight_unit': 'KG',
                'load_number':  vm.shipment.load[index].load_number
            });
        }

        /**
         * function to remove load
         */
        function removeLoad(index){
            vm.shipment.load.splice(index,1);
        }


         /**
         * function used to get the AirLine list of data
         */
        function getAirLineList(){
            TrackService.getAIrlineData().then(function(response){
                vm.airLineData =  response.data;
                TrackService.airLineData = angular.copy(vm.airLineData);
            },function(error){
                $log.log(error);
            });
        }

        /**
         * function to create shipments
         */
        function submitShipment() {

          if(!vm.shipment.selected_shipper) {
            util.showToast('Dont leave shipper company empty');
            return;
          } else if(!vm.shipment.air_selected_origin_port) {
            util.showToast('Enter valid origin port');
            return;
          } else if(!vm.shipment.air_selected_destination_port) {
            util.showToast('Enter valid destination port');
            return;
          } else if (vm.shipment.air_selected_origin_port.port_code === vm.shipment.air_selected_destination_port.port_code) {
            util.showToast('Origin and Destination port can not be same!');
            return;
          } else if(!vm.shipment.cargo_ready_date) {
            util.showToast('Dont leave pickup date empty');
            return;
          } else if(!vm.shipment.etd) {
            util.showToast('Dont leave ETD empty');
            return;
          } else if(!vm.shipment.eta) {
            util.showToast('Dont leave ETA empty');
            return;
          }

          if(vm.shipment.mawb === undefined){
            util.showToast('Please enter a vaild MAWB');
            return;
          }

          if(vm.shipment.cargo_ready_date > vm.shipment.eta) {
            util.showToast('Pick date should be before ETA');
            return;
          }

          var blockCalll = false;
          vm.shipment.load.some(function(i){

            
            if(!i.load_number) {
              util.showToast("Don't leave load number empty!");
              blockCalll = true;
              return true;
            } else if(!i.pallet_no) {
              util.showToast("Don't leave pallet number empty!");
              blockCalll = true;
              return true;
            } else if(!i.qty) {
              util.showToast("Don't leave quantity empty!");
              blockCalll = true;
              return true;
            } else if(!i.gross_weight){
              util.showToast("Don't leave gross weight empty!");
              blockCalll = true;
              return true;
            } else if(!i.chargeable_weight) {
              util.showToast("Don't leave chargeable weight empty!");
              blockCalll = true;
              return true;
            }
          });

          if(blockCalll){
            return;
          }

          var current_date = moment().format('YYYY-MM-DD hh:mm');
            var data = {
                'data': {
                  'company_id':  vm.shipment.selected_shipper,
                  'cargo_ready_date': vm.shipment.cargo_ready_date,
                  'pol': {
                    'name': vm.shipment.air_selected_origin_port.portname,
                    'port_code': vm.shipment.air_selected_origin_port.port_code,
                  },
                  'pod': {
                    'name': vm.shipment.air_selected_destination_port.portname,
                    'port_code': vm.shipment.air_selected_destination_port.port_code,
                  },
                  'manual': true,
                  'carrier_info': {
                    "name": vm.shipment.selectedairline ? vm.shipment.selectedairline.name : null,
                    "voyage": vm.shipment.flight_number,
                    "vessel": null,
                    "carrier_code": null
                  },
                  'departure_date': vm.shipment.etd,
                  'arrival_date': vm.shipment.eta,
                  'awb_object': {
                    'mawb': vm.shipment.mawb || null,
                    'hawb': vm.shipment.hawb || null,
                    'tracking': 'NA'
                  },
                  'airline': {
                    'name': vm.shipment.selectedairline ? vm.shipment.selectedairline.name : null,
                    'code': vm.shipment.selectedairline ? vm.shipment.selectedairline.code : null,
                    'prefix': vm.shipment.selectedairline ? vm.shipment.selectedairline.prefix : null,
                    'service': vm.shipment.service || null
                  },
                  'load': {
                    'load_details_value': [
                      {
                        'load_metrics': vm.shipment.load,
                      }
                    ],
                    'load_type': 'load',
                    'load_meta': {
                      'gross_weight': vm.shipment.load.map(function(item){
                          return item.gross_weight;
                      }).reduce(function(total,item){ return (parseFloat(total) + parseFloat(item));}),
                      'chargeable_weight': vm.shipment.load.map(function(item){
                        return item.chargeable_weight;
                    }).reduce(function(total,item){ return (parseFloat(total) + parseFloat(item));}),
                      'qty': vm.shipment.load.map(function(item){
                        return item.qty;
                    }).reduce(function(total,item){ return (parseInt(total) + parseInt(item));}),
                      'gross_weight_unit': 'KG',
                      'chargeable_weight_unit': 'KG'
                    }
                  },
                  'milestone_date' : current_date ? current_date : null,
                  'milestone_date_offset' : moment(current_date).zone() ? moment(current_date).zone() : 0,
                }
              };

              util.isCallingApi = true;
              ShipmentService.createShipment(data).then(function(response){
                  if(response.status === 'success'){
                    util.isCallingApi = false;
                    vm.shipmentIdSuccess = response.shipment_id;
                    vm.clearForm();
                    // open success modal
                    vm.openSuccessModal();
                  }
                  //mixpanel code
                  analytics.track("Shipment Created Manually");
                  $log(response);
              },function(err){
                  util.showToast(err.data.message);
                  util.isCallingApi = false;
                  $log.error(err);
              });

        }

        function clearAllLoad() {
          vm.shipment.load = [{
              'pallet_no': '',
              'gross_weight': '',
              'chargeable_weight': '',
              'qty': '',
              'gross_weight_unit': 'KG',
              'chargeable_weight_unit': 'KG',
              'remarks': '',
              'volumetric_weight': '',
              'volumetric_weight_unit': 'KG',
              'load_number': ''
          }];
        }

        function goToCreatedShipment() {
          // $state.go('app.shipments.shipment_details', { id: id });
          $window.location.href = util.sanitizeQueryParams('/shipments/' + vm.shipmentIdSuccess);
          // $location.url('/shipments/' + vm.shipmentIdSuccess);
        }

        function clearForm() {
          vm.shipment.selected_shipper = null;
          vm.shipment.service = null;
          vm.shipment.cargo_ready_date = null;
          vm.shipment.etd = null;
          vm.shipment.eta = null;
          vm.shipment.mawb = null;
          vm.shipment.hawb = null;
          vm.shipment.awb = null;
          vm.shipment.selectedairline = null;
          vm.shipment.flight_number = null;
          vm.shipment.air_selected_origin_port = null;
          vm.shipment.air_selected_destination_port = null;

          // load details
          vm.shipment.load = [{
            "pallet_no": "",
            "gross_weight": null,
            "chargeable_weight": null,
            "qty": "",
            "gross_weight_unit": "KG",
            "chargeable_weight_unit": "KG",
            "remarks": "",
            // "volumetric_weight": "",
            // "volumetric_weight_unit": "KG",
            "load_number": ""
          }];

        }


         /**
         * function to get the all shipper data
         */
        function getShipperList(){
            if(vm.shipperList.length){
                return  vm.shipperList;
            }
            return util.getShipperList().then(function (response){
                vm.shipperList =  response.data.data;
                return response.data.data;
            }, function(err){
                $log.error(err);
            });
        }


        /**
         *  get the list of ports from api
         *  @param searchText
         */
        // function getPort(searchText,mode){
        //     searchText = $sanitize(searchText);
        //     // var url =  api.baseUrl + '/api/port';
        //     // var data =  {'data' :  {'mode': mode,'search_query' : searchText }};
        //     return util.getPorts(searchText, mode).then(function(response){
        //         return response.data.data.port;
        //     },function(error){
        //         $log.log(error.data);
        //         return [];
        //     });
        // }

        function closeDialog(){
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('CreateQuotesController', CreateQuotesController);

    /** @ngInject */
    function CreateQuotesController(CreateQuoteModeData,$rootScope,QuoteDetailsData,SearchService,localStorageService,SearchParam,util,resultService,shareQuoteService)
    {
        var vm = this;
        vm.is_manual=QuoteDetailsData ? false :true;
        SearchService.emptySearchParam = angular.copy(SearchParam.data);
        vm.search_param_fcl = angular.copy(SearchParam.data.search_param_fcl);
        vm.search_param_lcl = angular.copy(SearchParam.data.search_param_lcl);
        vm.search_param_air = angular.copy(SearchParam.data.search_param_air);
        vm.initData=initData;
        vm.fnGetCurrencyconversion=fnGetCurrencyconversion;
        
        // if(Object.keys(QuotesService.FclQuote).length !== 0 ){
        //     vm.quoteDetails = QuotesService.FclQuote
        // }
        // else{
           
        // }

        function init() {
         vm.initData();
        }
          init();

          function initData(){
            //with template name
            if(QuoteDetailsData){
                vm.quoteDetails= angular.copy(QuoteDetailsData);
            }
            //manual creation
            else{
               var quoteDetails = {
                    "result_meta": {
                        "search_param":null
                    },
                    "result_data": {
                        "available_status": [],
                        "is_booked": false,
                        "shipment_id": null,
                        "pdf_link": "",
                        "sales_coordinator": util.userProfile.user.is_sales_cordinator == 1 ? util.userProfile.user : null,
                        "generate_pdf": false,
                        "send_mail": false,
                        "customs": false,
                        "perishable": false,
                        "revised": false,
                        "hazardous": false,
                        "print_schedule": false,
                        "deleted_by": null,
                        "deleted_at": null,
                        "is_deleted": false,
                        "cc_emails": [],
                        "co2e": false,
                        "match_rates": null,
                        "erp_data": null,
                        "inquiry_number": "",
                        "reference_number": null,
                        "pdfmonkey_document_id": null,
                        "show_zero_sell_rates":  $rootScope.domainData.domain_info["ENABLE_ZERO_SELL_RATES_ON_PDF_CHECKBOX"] ? false : true,
                        "is_duplicate_quote": false,
                        "parent_quote_id": null,
                        "_id": "",
                        "cards": [],
                        "load_data":{
                            "load_details_value": [
                                {
                                    "qty": 1,
                                    "bl_qty": 1,
                                    "sbl_qty": 1,
                                    "type": "20GP",
                                    "load_metrics": [
                                        {
                                            "weight_qty": 25000,
                                            "weight_unit": "KGs",
                                            "volume_qty": 0,
                                            "volume_unit": "CBM"
                                        }
                                    ],
                                    "teu": 1
                                }
                            ],
                            "load_type": "container",
                            "load_meta": null,
                            "ltl_load_details": null
                        },
                        "currency_conversion_rates": [ ],
                        "search_id": "",
                        "start_date": "",
                        "expiry_date": "",
                        "incoterms": null,
                        "terms": "",
                        "activity": {},
                        "additional_charges": {
                            "selected": [],
                            "available": []
                        },
                        "created_by":  util.userProfile.user,
                        "created_for": {},
                        "quote_id": "",
                        "uuid": "",
                        "status": {
                            "_id": "",
                            "status_list": [
                                {
                                    "sms": false,
                                    "email": true,
                                    "fcm": false,
                                    "whatsapp": false,
                                    "sms_id": null,
                                    "comment": null,
                                    "comment_required": false,
                                    "_id": "",
                                    "status": "Active",
                                    "description": null,
                                    "vendor_id": 252,
                                    "quote_id": "",
                                    "created_on": ""
                                }
                            ],
                            "__v": 0
                        },
                        "created_on": "",
                        "pdfmonkey_last_request_time": "",
                        "__v": 0,
                        "inquiry_id": "",
                        "reminder": null,
                        "company": {
                            "company_name": null,
                            "company_address": null
                        },
                        "user": {
                            "id": null,
                            "user_first_name": null,
                            "user_last_name": null,
                            "email": null,
                            "user_mobile": null
                        }
                    }
                }
                if(CreateQuoteModeData =='SEA-FCL'){
                    quoteDetails.result_meta.search_param=angular.copy(vm.search_param_fcl);
                }
                else if(CreateQuoteModeData =='SEA-LCL'){
                    quoteDetails.result_meta.search_param=angular.copy(vm.search_param_lcl);
                }
                else if(CreateQuoteModeData =='AIR'){
                    quoteDetails.result_meta.search_param=angular.copy(vm.search_param_air);
                }
                quoteDetails.result_meta.search_param.origin_location=null;
                quoteDetails.result_meta.search_param.destination_location=null;
                //vm.quoteDetails.result_data.currency_conversion_rates=
                //console.log(vm.quoteDetails);
                var vendor_id = localStorageService.get('authToken').value.vendor_id
                vm.fnGetCurrencyconversion(quoteDetails.result_data.created_by.user_base_currency,vendor_id)
                vm.quoteDetails= angular.copy(quoteDetails);
            }
          }
           // call conversion rates api
    function fnGetCurrencyconversion(user_base_currency, vendor_id, action) {
        vm.callingConversionApi = true;
        return resultService
          .getCurrencyConversionForVendor(user_base_currency, vendor_id,CreateQuoteModeData,true)
          .then(
            function (response) {
              vm.currencyObj = response.data;
              vm.quoteDetails.result_data.currency_conversion_rates.push(vm.currencyObj);
              vm.callingConversionApi = false;
              vm.currency_rates = vm.currencyObj.curr_data;
              // Currency conversion setting code
              shareQuoteService.setCurrencyConvSetting(
                vm.quote_result.result_data.created_by.user_base_currency,
                vm.currencyObj.markup,
                vm.currencyObj.directCurrencyMapping,
                vm.currency_rates
              );
            },
            function (error) {
              // Currency conversion setting code
              shareQuoteService.setCurrencyConvSetting(
                vm.quote_result.result_data.created_by.user_base_currency,
                null,
                [],
                vm.currency_rates
              );
              vm.callingConversionApi = false;
              $log.log(error.data);
              util.showToast(util.displayValidationError(error));
            }
          );
      }
         
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cdmDownloadContracts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cdmDownloadContracts', {
                url    : '/cdm-download',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cdm-download/cdm-download.html',
                        controller : 'CdmDownloadController as vm'
                    },
                    data : { pageTitle: 'Download Contracts' }
                },
                resolve: {},
                bodyClass: 'cdm-download'
            });

    }


})();
(function () {
    "use strict";
  
    angular.module("app.cdmDownloadContracts")
    .controller("CdmDownloadController", CdmDownloadController);
  
    /** @ngInject */
    function CdmDownloadController(util, iframeService, $timeout, $state, $rootScope) {
  
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;
  
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
  
      // if god user changed forwarder refresh data
      $rootScope.$on('app.cdmDownloadContracts', function (event, args) {
        vm.init();
      });
  
      function init() {
        util.isModulePaid('contractManager');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.cdmDownloadContracts && util.navPermission.cdmDownloadContracts[1])){
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
         $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
         }, 50);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }

      }
      vm.init();
  
      // get cdm-audit-trail iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('cdm-download');
        document.getElementById("cdm-download-iframe").src = vm.iframeUrl
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'contractManager'){
          $state.go('app.contractManager');
        }
      }

    }
  })();
(function ()
{
    'use strict';

    angular
        .module('app.cdmAuditTrail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cdmAuditTrail', {
                url    : '/cdm-audit-trail',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cdm-audit-trail/cdm-audit-trail.html',
                        controller : 'CdmAuditTrailController as vm'
                    },
                    data : { pageTitle: 'Cdm Audit Trail' }
                },
                resolve: {},
                bodyClass: 'cdm-audit-trail'
            });

    }


})();

(function () {
    "use strict";
  
    angular.module("app.cdmAuditTrail")
    .controller("CdmAuditTrailController", CdmAuditTrailController);
  
    /** @ngInject */
    function CdmAuditTrailController(util, iframeService, $timeout, $state, $rootScope) {
  
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;
  
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
  
      // if god user changed forwarder refresh data
      $rootScope.$on('app.cdmAuditTrail', function (event, args) {
        vm.init();
      });
  
      function init() {
        util.isModulePaid('cdmAuditTrail');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.cdmAuditTrail && util.navPermission.cdmAuditTrail[1])){
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
         $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
         }, 50);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }

      }
      vm.init();
  
      // get cdm-audit-trail iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('cdm-audit-trail');
        document.getElementById("cdm-audit-trail-iframe").src = vm.iframeUrl
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'cdmAuditTrail'){
          $state.go('app.contractManager');
        }
      }

    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.contractManager', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.contractManager', {
                url    : '/cdm',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cdm/cdm.html',
                        controller : 'CdmController as vm'
                    },
                    data : { pageTitle: 'cdm' }
                },
                resolve : {},
                bodyClass: 'cdm-page'
            });
    }


})();


(function () {
    "use strict";
  
    angular.module("app.contractManager").controller("CdmController", CdmController);
  
    /** @ngInject */
    function CdmController(util, iframeService, $timeout, $state, $rootScope) {
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();
  
      function init() {
        util.isModulePaid('contractManager');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.contractManager && util.navPermission.contractManager[1])){
            $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }
  
      }
      vm.init();

      $rootScope.$on('app.contractManager', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('cdm');
        document.getElementById("cdm-iframe").src = vm.iframeUrl
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'cdmAuditTrail'){
          $state.go('app.cdmAuditTrail');
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'cdmDownloadContracts'){
          $state.go('app.cdmDownloadContracts');
        }
      }
  
    }
  })();
  
  
(function ()
{
    'use strict';

    angular
        .module('app.carrierIntegration', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.carrierIntegration', {
                url    : '/carrier-integration',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/carrier-integration/carrier-integration.html',
                        controller : 'CarrierIntegrationController as vm'
                    },
                    data : { pageTitle: 'Carrier Integration' }
                },
                resolve: {},
                bodyClass: 'carrier-integration'
            });

    }


})();


(function () {
    "use strict";
  
    angular.module("app.carrierIntegration")
    .controller("CarrierIntegrationController", CarrierIntegrationController);
  
    /** @ngInject */
    function CarrierIntegrationController(util, iframeService, $timeout, $state, $rootScope) {
  
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;
  
      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
  
      // if god user changed forwarder refresh data
      $rootScope.$on('app.carrierIntegration', function (event, args) {
        vm.init();
      });
  
      function init() {
        util.isModulePaid('carrierIntegration');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(!(util.navPermission.carrierIntegration && util.navPermission.carrierIntegration[1])){
          $state.go('app.pages_share_error');
        }
  
        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
         $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
         }, 50);

        if(window.addEventListener) {
          window.addEventListener("message", getIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getIframeRequest, true);
        }

      }
      vm.init();
  
      // get carrierIntegration iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('carrier-integration', 'carrierIntegration');
        document.getElementById("carrier-integration-iframe").src = vm.iframeUrl;
      }

      function getIframeRequest(event){
        if(!event.data.source){
          return;
        }
        if (event.target === window) {
            // window.removeEventListener("message", getIframeRequest, true);
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'carrierIntegration'){
          $state.go('app.carrierIntegration');
        }
      }

    }
  })();
  

(function ()
{
    'use strict';

    angular
        .module('app.basketModule', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.basketModule', {
                url    : '/basket',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/basket/basket.html',
                        controller : 'BasketController as vm'
                    },
                    data : { pageTitle: 'Basket' }
                },
                resolve : {},
            });
    }


})();


(function () {
    "use strict";
  
    angular.module("app.basketModule").controller("BasketController", BasketController);
  
    /** @ngInject */
    function BasketController(util, iframeService, $timeout, $state,$scope,$rootScope) {
      // data
      var vm = this;
      vm.todaysDate = Date.now();
      vm.iframeService = iframeService;

      // method
      vm.init = init;
      vm.formIframeUrl = formIframeUrl;
      vm.init();
      vm.util = util;
      $scope.$on('$destroy', function () {
        if (window.removeEventListener) {
          window.removeEventListener("message", getBasketIframeRequest, true);
        } else if (window.detachEvent) {
          window.detachEvent("onmessage", getBasketIframeRequest);
        }
      });
  
      function init() {
        // util.isModulePaid('oneQuote');
        vm.minHeight = vm.iframeService.iframeHeight;
        if(util.isShipper || !util.isEfpEnabled){
          $state.go('app.pages_share_error');
        }

        vm.formIframeUrl(); // Get Iframe src url
        document.getElementById("inner-content").style.maxWidth = "100%";
        document.getElementById("inner-content").style.padding = "0";
  
        $timeout(function () {
          var windowHeight = document.getElementById("content-container").offsetHeight;
          vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
        }, 1000);

        if(window.addEventListener) {
          window.addEventListener("message", getBasketIframeRequest, true);        
        } 
        else if (window.attachEvent) {
          window.attachEvent("onmessage", getBasketIframeRequest, true);
        }

  
      }

      $rootScope.$on('app.basketModule', function(event, args) {
        init();
      });
  
      // get iframe url
      function formIframeUrl() {
        vm.iframeUrl = iframeService.fnGetIframeUrl('basket','','web');
        vm.iframeUrl = iframeService.appendQuery(vm.iframeUrl, "&basketAccessData=1&parentUrl="+ window.location.origin+"&quotePermission="+util.navPermission["quotes"]);
        document.getElementById("basket-iframe").src = vm.iframeUrl;
      }

      function getBasketIframeRequest(event){
                var targetOrigin = new URL(vm.iframeUrl).origin;
        if(!event.data.source){
          return;
        }
       if (event.data.source === "create-bookingv2") {
         vm.util.redirectToBooking(event);
         return;
       }
       if (event.data.source === "goToBasket") {
         var basketCards = util.bookingData.cards && util.bookingData.cards.length
           ? util.bookingData.cards
           : (event.data.cards && event.data.cards.length
             ? event.data.cards
             : (util.oneQuoteData.selectedCard || []));
         document.getElementById("basket-iframe").contentWindow.postMessage(
           {
             selectedCard: util.oneQuoteData.selectedCard,
             quoteData: util.oneQuoteData.quoteData,
             pageSource: util.oneQuoteData.pageSource,
             dataSource: "goToBasket",
             currencyConversion: util.oneQuoteData.currencyConversion,
             searchParam: util.oneQuoteData.searchParam,
             from: util.oneQuoteData.from,
             searchId: util.oneQuoteData.searchId,
             card: basketCards[0],
             cards: basketCards,
             bookingData: util.bookingData,
             resumeChargeDetails: !!util.bookingData.resumeChargeDetails,
             headerFormValue: util.bookingData.headerFormValue || null,
             existingCardCountForBasket: util.bookingData.existingCardCountForBasket || 0
           },
           targetOrigin
         );
         $state.go("app.basketModule");
       }
        if(event.data.source === 'redirectToSearch'){
          $state.go('app.searchV2Module');
        }
        if(event.data.source === "one-quote"){
          vm.util.redirectToOneQuote(event);
          return;
        }
        if(event.origin.indexOf(util.iframeOrigin) && event.data.source === 'one-quote' && event.data.from === 'basket'){
          util.redirectToOneQuote(event);
        }
        if(event.data.source === 'moveBack'){
          $state.go($rootScope.previousState, $rootScope.previousParams, { reload: true });
        }
        if(event.data.source === 'tariffHeaderList' && event.data.reqData && event.data.reqData._id){
          var tariffUrl = $state.href('app.tariffDetails', { id: event.data.reqData._id });
          window.open(util.sanitizeQueryParams(tariffUrl), '_blank', 'noopener');
        }
      }
  
    }
  })();
  
  
(function ()
 {
    'use strict';
  
    angular.module('app.bannerBroadcast')
    .controller('BannerController', BannerController);
  
    /** @ngInject */
    function BannerController(BannerService, $state ,$mdSidenav, $mdDialog ,$mdToast ,$log, $filter, util, $sanitize, $rootScope, DTOptionsBuilder, DTColumnBuilder, $http,$compile, $scope, api,$timeout) {
  
      // data
      var vm = this;
      vm.util = util;
      vm.getDomainData = getDomainData;
      vm.fnSortBy=fnSortBy;
      vm.checkVisiblity = checkVisiblity;
      vm.create_banner=create_banner;
      vm.view_banner=view_banner;
      vm.cancelDialog=cancelDialog;
      vm.searchTable=searchTable;
      vm.initBannerTable=initBannerTable;
      vm.formBannerApiUrl=formBannerApiUrl;
       vm.getDtColumnsData=getDtColumnsData;
      vm.submit_banner=submit_banner;
      vm.fnTrackEvent=fnTrackEvent;
      vm.getDomainList=getDomainList;
      vm.getBannerIconList=getBannerIconList;
      vm.delete_banner=delete_banner;
      vm.createBanner=createBanner;
      vm.updateBanner=updateBanner;
      vm.formatResponse=formatResponse;
      vm.fnDeleteData=fnDeleteData;
      vm.formatDate=formatDate;
      vm.todayDate = new Date ();
     vm.showPreview=false;
     vm.domainList=[];
     vm.iconList=[];
     vm.filterListObject = {  
      "sort_by_type":'DESC',
      "sort_by":'',
    };
    vm.sortType={
      'created_at':'DESC',
      'end_date':'DESC'
    }
    vm.searchName='';
    
      vm.dtOptions = {
        dom       : '<"top"lf>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          autoWidth : false,
          responsive: true,
          lengthMenu  : [5, 10, 20, 30, 50, 100],
          pageLength  : 5
      };
     
      function init() {
       vm.getDomainData();
       vm.initBannerTable();
       vm.getDomainList();
       vm.getBannerIconList();
      
      }
      init();

      $rootScope.$on('app.bannerBroadcast', function(event, args) {
        init();
    });

      function getDomainData(){
        if (!Object.keys($rootScope.domainData.domain_info).length) {
          util.getDomainData().then(
            function () {
              vm.checkVisiblity();
            },
            function (error) {
              $log.log(error.data);
            }
          );
        } else {
          vm.checkVisiblity();
        }
      }
      function checkVisiblity(){

        util.isModulePaid('bannerBroadcast');
        if(!(util.navPermission.bannerBroadcast && util.navPermission.bannerBroadcast[1]) || util.isShipper) { 
          $state.go('app.pages_share_error');
        }
  
       
       
      }
    
         
     function view_banner(id,type,ev){
      vm.showPreview=false;
        vm.bannerNameValidation=false;
        vm.expiryValidation=false;
        vm.bannerDescriptionValidation=false;
        vm.domainValidation=false;
        vm.userTypeValidation=false;
        vm.iconValidation=false;
        vm.bannerTitleValidation=false
        vm.bannerFontValidation=false;
        vm.bannerBackgroundValidation=false;
        vm.bannerMessageValidation=false;
      
      var data = vm.bannerDetailsTemp.find(function (i) {
        return i.id == id;
     });
      var selectedData={
        "active":data.active,
        "data":data.data[0],
        "description":data.description,
        "domain":data.domain,
        "end_date":data.end_date ? util.dateReplace(data.end_date) : data.end_date,
        "start_date":data.start_date ?util.dateReplace( data.start_date) : data.start_date,
        "id":data.id,
        "name":data.name,
        "user_type":data.user_type,
        "type":data.type
      }
      util.callMixpanel("Banner-"+type+"Banner-Open-Click");
        vm.bannerInfo = {
          "updateView" : false,
          "viewBanner" : type === 'View' ? true : false,
          "form_heading" : type,
          "button_type" :  type === 'Edit' && data.active ? 'Unpublish' : 'Publish' ,
          "sec_button_type" : 'Save',
          "selectedData": selectedData
          
      };
        
          $mdDialog.show({
              templateUrl        : 'app/main/banner/dialogs/bannerForm/banner_form.html',
              targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm }
          });
     }

     function searchTable(){
       vm.dtInstanceCallback.rerender();
     }
   
      function initBannerTable(){

       vm.dtOptions = DTOptionsBuilder.newOptions()
       .withOption('headerCallback', function(thead) {
        // Add click for 'Customer Name' header
        $(thead).find('th').eq(1).html('Created On'+'<md-icon md-svg-src="assets/icons/custom/sort-icon.svg" class="s16 pl-5 pointer" ng-click="vm.fnSortBy(\'created_at\')"></md-icon>');

        // Add click for 'Last Updated On' header
        $(thead).find('th').eq(2).html('Expiry Date'+'<md-icon md-svg-src="assets/icons/custom/sort-icon.svg" class="s16 pl-5 pointer" ng-click="vm.fnSortBy(\'end_date\')"></md-icon>');
             
        // Compile the header to bind AngularJS directives
        $compile(thead)($scope);
    })
       .withOption('ajax', function (data, callback, settings) {

              var url = vm.formBannerApiUrl(settings);  //get url
             $http.get(url).then(function (response) {
         
                vm.bannerData = angular.copy(response.data.data);
                var new_res = formatResponse(angular.copy(vm.bannerData)); //form response with table structure
                var table_data = {
                    'data':  new_res,
                    'recordsTotal': response.data.count,
                    'recordsFiltered': response.data.count
                };
                vm.bannerLength = response.data.count;
                
                callback(angular.copy(table_data));
            
                vm.dtOptions.lengthChange= vm.bannerLength>0 ?true : false;
               },
               function (error) {
                 vm.dtOptions.lengthChange= vm.bannerLength>0 ?true : false;
               util.showToast(error.message, 'top right', 3000);
             
               });
           })
           .withDataProp('data')
           .withOption('responsive', true)
           .withOption('serverSide', false)
           .withOption('processing', false)
           .withDisplayLength(10)
           .withPaginationType('simple')
           .withOption('aaSorting', [])
           .withOption('lengthChange',false)
           .withOption('language', { lengthMenu: "Show entries _MENU_"})
           .withOption('createdRow', function (row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);





           });
vm.getDtColumnsData();
          

      }
      function getDtColumnsData(){

        vm.dtColumns = [
                // 1
                DTColumnBuilder.newColumn(null).withTitle('Reference Name').withOption('name', 'name').renderWith(function (data) {
                  var html = '<span ng-non-bindable>'+ $sanitize(data.name)+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                     .withClass('ellipsis-text').notSortable(),
                // 2
                DTColumnBuilder.newColumn(null).withTitle('Created On').withOption('name', 'created_at').renderWith(function (data) {
                  var html = '<span ng-non-bindable>'+$sanitize(data.created_at)+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' })
                      .withClass('ellipsis-text').notSortable(),
               //3
                DTColumnBuilder.newColumn(null).withTitle(' Expiry Date').withOption('name', 'end_date').renderWith(function (data) {
                 
                  var html = '<span ng-non-bindable>'+$sanitize(data.end_date)+'</span>';
                  return '<td>'+ html +'<md-tooltip  md-direction="top">'+html+'</md-tooltip>'+'</td>' }).notSortable(),
                // 4
                DTColumnBuilder.newColumn(null).withTitle('Status').withOption('name', 'active').renderWith(function (data) {
                  var expiry = data.end_date !='NA' ? new Date(data.end_date).toISOString().split("T")[0]: '';
                  var today = new Date().toISOString().split("T")[0];
                  if(expiry && (expiry < today)){
                    return '<span class="un-published cursor"> Expired </span>';
                  }
                  else if(data.active){
                    return '<span class="published cursor"> Published </span>';
                }else{
                    return '<span class="un-published cursor"> UnPublished </span>';
                } }).notSortable(),
               
        ];

       

        vm.dtColumns.push(DTColumnBuilder.newColumn(null).withClass('all').withTitle('Action')
            .renderWith(function (data, type, full, meta) {
           
            return '<span>' +
            '<md-icon ng-if="vm.util.navPermission.bannerBroadcast[2]" md-svg-src="assets/icons/custom/edit-icon.svg" class="cursor ml-10 simple-table-container-icon" ng-click="vm.view_banner(\'' + data.id + '\',\'Edit\','+'$event)"></md-icon>'+
            '<md-icon ng-if="vm.util.navPermission.bannerBroadcast[1]" md-font-icon="icon-eye" class="cursor ml-10 mb-10 simple-table-container-icon view_icon" title="View" ng-click="vm.view_banner(\'' + data.id + '\',\'View\','+'$event)" class="green-fg mh-5"></md-icon>'+
            '<md-icon ng-if="vm.util.navPermission.bannerBroadcast[3]" md-svg-src="assets/icons/custom/delete-icon.svg" ng-click="vm.delete_banner(\'' + data.id + '\','+meta.row+','+'$event)" class="simple-table-container-icon red-fg cursor"></md-icon>'+
          
            '</span>';
        }).notSortable());

        vm.dtInstanceCallback = {};
      }

      function formBannerApiUrl(settings){

        
        var url = api.baseUrl + '/api/v1/notices?limit='+ settings._iDisplayLength + '&offset='+ settings._iDisplayStart;
        if(vm.searchName){
       url +='&name'+'='+vm.searchName;
        }
        url +='&sort_by='+vm.filterListObject.sort_by+'&sort_by_type='+vm.filterListObject.sort_by_type+'';
        return url;
      }
 function fnSortBy(type,action){
  vm.filterListObject.sort_by=type
  vm.sortType[type]= vm.sortType[type]  === 'DESC' ? 'ASC' : 'DESC'
  vm.filterListObject.sort_by_type = vm.sortType[type];
  util.callMixpanel("Banner-SortBy-Click", {
    "sortByType":  vm.filterListObject.sort_by_type,
    "sortBy":  vm.filterListObject.sort_by
  });
  vm.listLoader = true;
  vm.dtInstanceCallback.rerender()
 }
 function formatResponse(res_data){
  vm.bannerDetailsTemp = res_data;

  var new_res = [];
  var row_obj = {
    "active":null,
    "data":null,
    "description":null,
    "domain":null,
    "end_date":null,
    "start_date":null,
    "id":null,
    "name":null,
    
    "user_type":null,
    "created_at":null,
  };

  res_data.forEach(function (row) {
    var new_row = angular.copy(row_obj);
    new_row.id = row.id;
    new_row.active = row.active;
    new_row.data = row.data;
    new_row.description = row.description ;
    new_row.domain = row.domain;
    new_row.end_date = row.end_date ? $filter('date')(row.end_date.replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z/, "T00:00:00.000Z"), 'yyyy-MM-dd') : 'NA';
    new_row.start_date = row.start_date;
    new_row.name = row.name ? row.name : 'NA';
    new_row.created_at = row.created_at ?  $filter('date')(row.created_at, 'yyyy-MM-dd') : 'NA' ;
   
    new_row.user_type = row.user_type;

    new_res.push(angular.copy(new_row));
  });

  return new_res;
}
      function create_banner(ev){
        vm.showPreview=false;
        vm.bannerNameValidation=false;
        vm.expiryValidation=false;
        vm.bannerDescriptionValidation=false;
        vm.domainValidation=false;
        vm.userTypeValidation=false;
        vm.iconValidation=false;
        vm.bannerTitleValidation=false
        vm.bannerFontValidation=false;
        vm.bannerBackgroundValidation=false;
        vm.bannerMessageValidation=false;
        vm.startDateValidation=false;
        vm.expiryDateValidation = false
        var selectedData={
            "active":false,
            "data":{
              "action": {
                  "background": "",
                  "text": "",
                  "text_color": "",
                  "type": "launch_url",
                  "url": ""
              },
              "description": "",
              "theme": {
                  "background": "",
                  "icon": {
                      "app_class": "",
                      "font_class": "",
                      "url": "",
                    
                  },
                  "text_color": "",
                  "type": "general"
              },
              "title": ""
          },
            "description":null,
            "domain":null,
            "end_date":null,
            "start_date":null,
            "id":null,
            "name":null,
            "user_type":null,
            "type":'specific'
          }
        util.callMixpanel("Banner-CreateBanner-Open-Click");
        vm.bannerInfo = {
          "updateView" : false,
          "viewBanner" : false,
          "form_heading" : "Create",
          "button_type" : "Publish",
          "sec_button_type" : "Save",
          "selectedData": selectedData
          
      };
        
          $mdDialog.show({
              templateUrl        : 'app/main/banner/dialogs/bannerForm/banner_form.html',
              targetEvent        : ev,
              clickOutsideToClose: false,
              controllerAs: 'ctrl',
              controller: function() { this.parent = vm }
          });

      }
     

      function cancelDialog(event , deleteEvent){
        if(event){
          util.callMixpanel("Banner-Close-Click", {'Event':event , 'Source':vm.bannerInfo.form_heading});
        }
       if(deleteEvent){
          util.callMixpanel("Banner-DeleteBanner-Cancel-Click");
       }
          $mdDialog.hide();
      }
      function fnTrackEvent(eventName ,source , searchQuery){
        util.callMixpanel(eventName, {
           "Source":source,
           "Search Query":searchQuery,
          });
    }
    function getDomainList(){
        util.getDomainList().then(function(response){
            try {
                vm.domainList = response.data.data;
            } catch (e) {
                vm.domainList = [];
                $log.error(e);
            }
        },function(err){
            vm.rolesList = [];
            $log.log(err);
        });
    
    }

    function getBannerIconList(){
      BannerService.getBannerIconList().then(function(response){
            try {
                vm.iconList = response.data.data.map(function(item){
                  return {
                    "app_class":item.app_class,
                    "font_class":item.font_class,
                    "url": item.url,
                    "name": item.name,
                  }})
                 
              ;
            } catch (e) {
                vm.iconList = [];
                $log.error(e);
            }
        },function(err){
            vm.iconList = [];
            $log.log(err);
        });
       
    }
  
    function submit_banner(form, bannerData, button){
  

      vm.bannerNameValidation=false;
      vm.bannerDescriptionValidation=false;
      vm.domainValidation=false;
      vm.userTypeValidation=false;
      vm.iconValidation=false;
      vm.bannerTitleValidation=false
      vm.bannerFontValidation=false;
      vm.bannerBackgroundValidation=false;
      vm.bannerMessageValidation=false;
      vm.startDateValidation=false;
      vm.expiryValidation=false;
      // if(form.$invalid){
      //   util.callMixpanel("Banner-Submit-Click");
      //   return
      // }
     
      if(!vm.bannerInfo.selectedData.name){
        vm.bannerNameValidation=true;

      }
      if(!vm.bannerInfo.selectedData.description){
        vm.bannerDescriptionValidation=true;

      }
      if(!vm.bannerInfo.selectedData.domain){
        vm.domainValidation=true;
      }
      if(!vm.bannerInfo.selectedData.user_type){
        vm.userTypeValidation=true;
      }
      if(!vm.bannerInfo.selectedData.data.title){
        vm.bannerTitleValidation=true;

      }
      if(!vm.bannerInfo.selectedData.data.description){
        vm.bannerMessageValidation=true;
        
      }
        if(!vm.bannerInfo.selectedData.data.theme.icon.font_class){
          vm.iconValidation=true;
          
        }
        if(!vm.bannerInfo.selectedData.data.theme.background){
          vm.bannerBackgroundValidation=true;
          
        }
        if(!vm.bannerInfo.selectedData.data.theme.text_color){
          vm.bannerFontValidation=true;
          
        }
        if(!vm.bannerInfo.selectedData.start_date ){
          vm.startDateValidation=true;
        }
        if(!vm.bannerInfo.selectedData.end_date){
          vm.expiryValidation=true;
        }
        var expiry = vm.bannerInfo.selectedData.end_date  ? new Date(vm.bannerInfo.selectedData.end_date).toISOString().split("T")[0]: vm.bannerInfo.selectedData.end_date;
        var start = vm.bannerInfo.selectedData.start_date ? new Date(vm.bannerInfo.selectedData.start_date).toISOString().split("T")[0]: vm.bannerInfo.selectedData.start_date;
        if(expiry && start && (expiry < start)){
          vm.expiryValidation=true;
        }
        
        if(vm.bannerNameValidation || vm.bannerDescriptionValidation || vm.domainValidation || vm.userTypeValidation || vm.iconValidation || vm.bannerTitleValidation || vm.bannerFontValidation || vm.bannerBackgroundValidation || vm.bannerMessageValidation || vm.startDateValidation || vm.expiryValidation ){
          util.callMixpanel("Banner-Submit-Click");
          return
        }
        switch (button) {
          case 'Save':
            vm.bannerInfo.selectedData.active =  vm.bannerInfo.selectedData.active
              break;
          case 'Unpublish':
            vm.bannerInfo.selectedData.active = false
              break;

          case 'Publish':
            vm.bannerInfo.selectedData.active = true            
            break;
          
      }
      
      
     

        util.callMixpanel("Banner-Submit-Click");
     
         vm.bannerInfo.form_heading =='Create' ? vm.createBanner(vm.bannerInfo.selectedData) : vm.updateBanner(vm.bannerInfo.selectedData) ;

        
       
      }
      function delete_banner(id,index,ev){
        vm.deleteType="Banner";
        
        vm.deleteId = id;
        vm.deleteIndex = index;
        vm.deleteBtn = false;
        util.callMixpanel("Banner-DeleteBanner-Click",{'Name':vm.deletedCompanyName})
        $mdDialog.show({
            templateUrl        : 'app/main/shipments/dialogs/confirm-delete/confirm-delete.html',
            targetEvent        : ev,
            clickOutsideToClose: true,
            controllerAs: 'ctrl',
            controller: function() { this.parent = vm; }
        });

      }
      function fnDeleteData(){
        util.callMixpanel("Banner-DeleteBanner-Proceed-Click" , {'Name':vm.deletedCompanyName});
        vm.deleteBtn = true;
        BannerService.deleteBanner(vm.deleteId).then(function(response){

            vm.dtInstanceCallback.rerender(); //Refersh user table with latest data

            util.showToast('Banner deleted successfully.');
            vm.deleteBtn = false;
            $mdDialog.hide();

         },function(error){
            vm.deleteBtn = false;
            $log.log(error);
            util.showToast(util.displayValidationError(error));
         });
      }
      function createBanner(selectedData){
      
  
           var data = {
             "active": selectedData.active,
             "description": selectedData.description,
             "domain":selectedData.domain,
             "end_date": selectedData.end_date ? selectedData.end_date.replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z?$/, "T23:59:00.000Z") : selectedData.end_date,
             "data": [selectedData.data],
             "start_date": selectedData.start_date ? selectedData.start_date.replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z?$/, "T00:00:00.000Z") : selectedData.start_date,
             "id": selectedData.id,
             "user_type": selectedData.user_type,
             "name": selectedData.name,
             "type":selectedData.type
       
           }
  
           util.isCallingApi = true;
           BannerService.createBanner(data).then(function(response){
        
                 vm.dtInstanceCallback.rerender();
                 util.showToast('Submitted Successfully!!','top right', 3000);
                 
                 vm.cancelDialog();
                 util.isCallingApi = false;
             },function(error){
              
                util.isCallingApi = false;
                 $log.log(error);
                 util.showToast(error.message);
                
             });
   }
   function updateBanner(selectedData){

     var data = {
     "active": selectedData.active,
     "description":selectedData.description,
     "domain": selectedData.domain,
     "end_date":selectedData.end_date ? selectedData.end_date.replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z?$/, "T23:59:00.000Z") : selectedData.end_date,
     "data": [selectedData.data],
     "start_date":selectedData.start_date ? selectedData.start_date.replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z?$/, "T00:00:00.000Z") : selectedData.start_date,
     "id": selectedData.id,
     "user_type":selectedData.user_type,
     "name": selectedData.name,
     "type":selectedData.type
  
   }
   util.isCallingApi = true;
   BannerService.updateBanner(data,selectedData.id)
   .then(function(response){
    
       vm.dtInstanceCallback.rerender();
       util.showToast('Updated Successfully!!','top right', 3000);
     
       vm.cancelDialog();
      util.isCallingApi = false;
   },function(error){
    vm.dtInstanceCallback.rerender();
       util.isCallingApi = false;
       $log.log(error);
       util.showToast(util.displayValidationError(error));
      
   });
   }
   function formatDate(value,key){
    var localDate = new Date(value);
var utcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), 0, 0, 0)); 
    vm.bannerInfo.selectedData[key] = utcDate.toISOString();
   
   }
    }
 

   
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.addRate', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.addRate', {
                url    : '/add-rates',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/add-rates/add-rates.html',
                        controller : 'AddRatesController as vm'
                    },
                    data : { pageTitle: 'Add Rates' }
                },
                resolve: {},
                bodyClass: 'add-rates'
            });

    }


})();

(function () {
  "use strict";

  angular.module("app.addRate")
  .controller("AddRatesController", AddRatesController);

  /** @ngInject */
  function AddRatesController(util, iframeService, $timeout, $state, $rootScope) {

    // data
    var vm = this;
    vm.todaysDate = Date.now();
    vm.iframeService = iframeService;

    // method
    vm.init = init;
    vm.formIframeUrl = formIframeUrl;
    vm.util=util;

    // if god user changed forwarder refresh data
    $rootScope.$on('app.addRate', function (event, args) {
      vm.init();
    });

    function init() {
      util.isModulePaid('myRates');
      vm.minHeight = vm.iframeService.iframeHeight;
      if(!(util.navPermission.addRate && util.navPermission.addRate[0])){
        $state.go('app.pages_share_error');
      }

      vm.formIframeUrl(); // Get Iframe src url
      document.getElementById("inner-content").style.maxWidth = "100%";
      document.getElementById("inner-content").style.padding = "0";

       $timeout(function () {
        var windowHeight = document.getElementById("content-container").offsetHeight;
        vm.minHeight = iframeService.calculateMaxHeight(windowHeight);
       }, 50);

      document.getElementById('add-rates-iframe').onload = function() {
        var postParam = {
            'parentOrigin': util.sanitizeUrl(window.location.origin),
            'requestObj': iframeService.requestObj
        }

        var targetOrigin = (new URL(vm.iframeUrl)).origin;
        document.getElementById('add-rates-iframe').contentWindow.postMessage(postParam,targetOrigin);
        iframeService.requestObj = {
          searchParam:null,
          source:null
        }
      };

      if(window.addEventListener) {
        window.addEventListener("message", getNewRatesObj, true);        
      } 
      else if (window.attachEvent) {
        window.attachEvent("onmessage", getNewRatesObj, true);
      }
    }
    vm.init();

    // get add-rates iframe url
    function formIframeUrl() {
      vm.iframeUrl = iframeService.fnGetIframeUrl('addRate');
      document.getElementById("add-rates-iframe").src = vm.iframeUrl
    }

    function getNewRatesObj(event){
      iframeService.newRatsResponseObj = event.data.newRateCardObj;
      var statePage = '';
      //standard-quotation should not run redirect navigation 
      if(!event.data.source || iframeService.notAllowIframeLink.includes(event.data.source)){
        return;
      }
      if(event.origin.indexOf(vm.util.iframeOrigin)){
      switch(event.data.source){
        case 'result-page':
        statePage = 'app.search.result'
        break;

        case 'lcl-result-page':
        statePage = 'app.search.lclResult'
        break;

        case 'air-result-page':
        statePage = 'app.search.airResult'
        break;

        case 'quote-page':
        statePage = 'app.quotes.quotesDetails'
        break;

        case 'app.quotes.quotesDetails':
        statePage = 'app.inquiry.inquiryDetails'
        break;

        case 'my-rates':
        statePage = 'app.myRates'
        break;

        default :
        statePage = 'app.addRate';
      }

      $state.go(statePage,{ id: event.data.stateId });
    }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.rateProvider')
        .controller('RateProviderController', RateProviderController);

    /** @ngInject */
    function RateProviderController($log,$mdDialog,vendorData,providerData,customCurrencyService,localStorageService, util)
    {
        var vm = this;
        vm.vendorData = vendorData.vendor_data;


        vm.fnSubmitProviderData = fnSubmitProviderData;
        vm.fnAddProvider = fnAddProvider;
        vm.fnViewConversionRate = fnViewConversionRate;
        vm.addCurrency = addCurrency;
        vm.removeCurrency= removeCurrency;
        vm.cancelDialog= cancelDialog;
        vm.fnSubmitCurrency = fnSubmitCurrency;
        vm.currencyChange = currencyChange;
        vm.fnValidateVendor = fnValidateVendor;

        vm.currencyList = util.currencyList;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 10
        };

        vm.rateProvider = providerData.rate_providers;

        //open rate provider form modal
        function fnAddProvider(ev) {
            vm.providerData = {
                'vendor_id' : "",
                'margin' : ""
            };
            $mdDialog.show({
                templateUrl        : 'app/main/RateProvider/dialogs/addRateProvider.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        //view conversion rate modal
        function fnViewConversionRate(currencyData,ev,updateIndex){
            vm.vendor_index = updateIndex;
            vm.currencyRates = angular.copy(currencyData);
            vm.baseCurrency = "USD";
            $mdDialog.show({
                templateUrl        : 'app/main/RateProvider/dialogs/editConversionRate.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                controllerAs: 'ctrl',
                controller: function() { this.parent = vm }
            });
        }

        function fnValidateVendor(vendor_id){
            for (var i = 0; i < vm.rateProvider.length; i++) {
                if(vm.rateProvider[i].vendor_id == vendor_id){
                    vm.providerData.vendor_id = "";
                    util.showToast('This Vendor is already exist! Please select another Vendor.');
                }
            }
        }

        //submit rate provider form
        function fnSubmitProviderData(providerdata){
            var data = {
                'rate_provider' : providerdata
            };
            customCurrencyService.submitProvider(data).then(function(response){
                vm.rateProvider.push(response.data.rate_provider);
                cancelDialog();

            },function(error){
                $log.log(error);
            });
        }

        //add row to currency table
        function addCurrency(){
            if(vm.currencyRates.custom_currency_rates == null){
                vm.currencyRates.custom_currency_rates = [];
            }
            vm.currencyRates.custom_currency_rates.push({
                'currency_code': "",
                'rate': "",
                'base_currency' :'USD'
            });
        }

        //Remove row from currency table
        function removeCurrency(currencyData){
            var index = vm.currencyRates.custom_currency_rates.findIndex(function(item){
              return item.currency_code === currencyData.currency_code;
            });

            vm.currencyRates.custom_currency_rates.splice(index, 1);
        }

        //function to display error after selecting existing currency
        function currencyChange(){

            var keys = [];
            angular.forEach(vm.currencyRates.custom_currency_rates, function(item) {
                 // we check to see whether our object exists
                  var key = item.currency_code;
                  // if it's not already part of our keys array
                  if(keys.indexOf(key) === -1) {
                      // add it to our keys array
                      keys.push(key);
                  }
                  else{
                    util.showToast(key+' Currency already exist! Please select another currency');
                    item.currency_code = "";
                  }
            });

        }

        //Submit new currency
        function fnSubmitCurrency(currency_data){

            var data = {
               'rate_provider' : currency_data
            };
            customCurrencyService.submitCurrency(data).then(function(response){
                vm.rateProvider[vm.vendor_index] = response.data.rate_provider;
                cancelDialog();
                return response.data;

            },function(error){
                $log.log(error);
            });

        }

        function cancelDialog(){
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.inquiry')
        .controller('InquiryController', InquiryController);

    /** @ngInject */
    function InquiryController(util, $state, InquiryService , $scope,$rootScope,$mdSidenav,$window)
    {
        // Variables
        var vm = this;
        vm.util = util;
        vm.viewInquiryDetails = viewInquiryDetails;
        vm.formContainerType = formContainerType;
        vm.initInquiryList = initInquiryList;
        vm.submitFilter = submitFilter;
   
        var fromDate = new Date(new Date().setDate(new Date().getDate() - 30));
        vm.filterObj =  {
          "data" : {
              "limit": 30,
              "offset":0,
              "status": [
                  "All"
              ],
              "mode": [],
              "integrations": [],
              "date_range": {
                  "from": fromDate,
                  "to": new Date()
              },
              "created_by": {
                "data": {
                  "internal_user" : [],
                  "customer_user" : []
                }
            },
            "customer_details": {
                  "data": {
                      "user": [],
                      "company": []
                  }
            },
             "incoterms": [],
            "sort_by": "created_at",
            "sort_by_type": "DESC",
            "search" : ''
          }
        }
        vm.defaultFilterObjStore = angular.copy(vm.filterObj.data); // store deafult filter Object
        vm.inquiryParam = {
          'deviceName' : '',
          'createdBySelected' : [],
          'customerSelected' : [],
          'incoTermsSelected' : [],
          'isResetFilter' : false
        };
        vm.isLoadFilterComponent = false;
        vm.loadMoreRecords = loadMoreRecords;
        vm.scrollTop = scrollTop;
        vm.toggleSidenav = toggleSidenav;
        vm.goToSearchPage = goToSearchPage;
        vm.viewDetails = viewDetails;
        vm.getDomainData = getDomainData;
        vm.onScrollAction = onScrollAction;
        vm.resizeScreenSize = resizeScreenSize;
        vm.inquiryTotalCount = 0;
        vm.listLoader = true;
        vm.isLoadMoreActive = false;
        vm.pageLoader = true;
        vm.fnCreatedSortBy = fnCreatedSortBy;

        function resizeScreenSize() {
          vm.inquiryParam.deviceName = util.resizeScreen(vm.inquiryParam.deviceName);
        }
        window.onresize = vm.resizeScreenSize;

        // search Inquiry result
        var myListener = $rootScope.$on('inquiryListWithSearch', function () {
            InquiryService.activeInquiryTab = '';
            init();
        });
        $scope.$on('$destroy', myListener);

        // banner listner
        var bannerListener = $rootScope.$on('calculateMaxHeight', function () {
            calculateMaxHeight();
        });
        $scope.$on('$destroy', bannerListener);

        $rootScope.$on('resetServiceVaribles', function () {
          InquiryService.activeInquiryTab = '';
          InquiryService.filterParams = {
            'users' : '',
            'customer' : '',
            'customer_company' : '',
            'mode' : '',
            'search' : InquiryService.filterParams.search,
            'start_date' : '',
            'end_date' : ''
          };
        });
        // if god user changed forwarder refresh data
        $rootScope.$on('app.inquiry', function (event, args) {
          vm.isLoadFilterComponent = true;
          init();
        });

        vm.maxHeight = util.getModuleMaxHeight(vm.maxHeight,'list');

        function init() {
          util.isModulePaid('inquiry');
          if( !util.navPermission.inquiry || !util.navPermission.inquiry[1]){
            $state.go('app.pages_share_error');
          }
          vm.getDomainData();

             vm.listLoader = true;
             vm.isLoadMoreActive = false;
             vm.inquiryListToRender = {
               inquiryList : [],
               shimmer : true
             }
             vm.filterObj.data.offset = 0;
             vm.filterObj.data.search = InquiryService.filterParams.search; // global search inquiry filter-DEV-6112
             if(!vm.isLoadFilterComponent){
               vm.initInquiryList(); // get list of inquiry
             }
  
          if(vm.maxHeight.height > 0){
            vm.pageLoader = false;
          }
          document.getElementById("inner-content").style.maxWidth = "100%";
          document.getElementById("inner-content").style.padding = "0";
          
          vm.leftFilterTopMargin = {'position' : 'sticky','top':'0px'};
          angular.element(document.querySelector('#inquiry-management')).bind('scroll', function(){
            vm.onScrollAction();
            if(!util.isMobileDevice && vm.leftFilterTopMargin){
              if($('#inquiry-management').height() < $('.filter-container').height()){
                vm.leftFilterTopMargin.top = $('#inquiry-management').height()-$('.filter-container').height()+'px';
              }
            }
          });
          vm.resizeScreenSize();
        }
        init();

        function calculateMaxHeight(){
          vm.maxHeight = util.getModuleMaxHeight(vm.maxHeight,'list');
          vm.inquiryParam.maxHeight = vm.maxHeight;
        }

        function getDomainData(){
          if(!Object.keys($rootScope.domainData.domain_info).length){
            util.getDomainData().then(function(){
              vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
            },function(error){
                $log.log(error.data);
            });
          }else{
              vm.showReferenceNumber = $rootScope.domainData.domain_info.INTEGRATION_AVAILABLE;
          }
        }

        // get list of inquiry
        function initInquiryList(){
          if(!vm.isLoadMoreActive){
            vm.scrollTop();
            vm.inquiryListToRender.shimmer = true;
          }
          if(vm.filterObj.data.search){
            vm.filterObj.data.date_range=null
          }
          //mixpanel code
          // analytics.track("Inq-"+vm.inquiryListToRender.status);
          //vm.is_sales_user = (!util.userProfile.user.is_sales_cordinator && !util.userProfile.user.is_pricing_user && util.userProfile.user.company.type=='FORWARDER');
          InquiryService.getInquriesList(vm.filterObj).then(function(response){
            if(!vm.isLoadMoreActive){ // it's running initial binding Inquries List
              vm.inquiryTotalCount = response.data.count;
              vm.inquiryListToRender.inquiryList = response.data.inquiries;
              vm.inquiryListToRender.shimmer = false;
              vm.resizeScreenSize();
              calculateMaxHeight();
            }else{ // it's on load more binding Inquries List 
              vm.inquiryListToRender.inquiryList = vm.inquiryListToRender.inquiryList.concat(response.data.inquiries);//add response if scrolling else assign to list
              vm.callInquiryApi = false;
            }
            vm.listLoader = false;
            vm.pageLoader = false;
            vm.isLoadMoreActive = false;

            // Inquiry result greater then 30 records then active load more
            if(response.data.inquiries.length >= vm.filterObj.data.limit){
              vm.isLoadMoreActive = true;
              vm.callInquiryApi = false; 
            }
          },function(error){
              vm.inquiryListToRender.shimmer = false;
              vm.listLoader = false;
              vm.callInquiryApi = false;
              vm.isLoadMoreActive = false;
              $log.log(error);
              vm.resizeScreenSize();
          });
        }

        function formContainerType(mode, loadDetails, list) {
          var result = '';
          if (mode == 'SEA-FCL') {
            result = util.formLoadDetails(loadDetails, list);
          } else if (mode != 'SEA-FCL') {
            result = util.formAirLoadDetails(loadDetails, mode);
          }
          return result;
        }

        function viewInquiryDetails(id){
          if(id != null){
            if(!$rootScope.domainData.domain_info.TARGET_LIST_BLANK){
              util.isCallingApi = true;
              InquiryService.activeInquiryTab = vm.selected_tab_name;
            }
            util.pageOpenNewTab('app.inquiry.inquiryDetails',{ id: id});
            //$state.go('app.inquiry.inquiryDetails',{ id: id});
          }
        }

        function submitFilter(){
          InquiryService.activeInquiryTab = '';
          if(vm.inquiryParam.isResetFilter){
            angular.element('#globalSearchText').val('');
            InquiryService.filterParams.search = '';
            vm.filterObj.data = angular.copy(vm.defaultFilterObjStore)
          }
          vm.isLoadFilterComponent = false;
          vm.inquiryTotalCount = 0;
          vm.listLoader = true;
          vm.isLoadMoreActive = false;
          vm.inquiryListToRender.inquiryList = [];
          vm.inquiryListToRender.shimmer = true
          vm.filterObj.data.offset = 0;
          vm.initInquiryList(); // get list of inquiry
        }

        // lazy loading function
        function loadMoreRecords(offset){
          if(offset === 0 || vm.isLoadMoreActive == false) {
            //vm.scrollTop();
            return;
          }
          if(offset !== 0 && !vm.callInquiryApi){ 
            vm.filterObj.data.offset =  offset;
            vm.listLoader = true;
            vm.callInquiryApi = true;
            vm.initInquiryList();
          }
        }

        // scroll to top
        function scrollTop(){
          angular.element("#inquiry-management").animate({
            scrollTop: 0
          }, 300);
          return false;
        }

        // show/hide scroll btn on scroll
        function onScrollAction() {
          var raw = document.querySelector('#inquiry-management');
          if (raw.scrollTop > 50) {
            document.querySelector('#inquiry-return-to-top') ? document.querySelector('#inquiry-return-to-top').classList.remove('hide') : '';
          }else{
            document.querySelector("#inquiry-return-to-top") ? document.querySelector('#inquiry-return-to-top').classList.add('hide') : '';
          }
        }

        // open and close sidenav
        function toggleSidenav(sidenavId) {
          $mdSidenav(sidenavId).toggle();
        }

        // Go to search page
        function goToSearchPage(){
          $state.go(util.isEfpEnabled ? 'app.searchV2Module' : 'app.search');
        }

       
        //navigate to quote details
        function viewDetails(id,module){
          if(id){
            event.stopPropagation();
            if(module=='Quote'){
              $state.go('app.quotes.quotesDetails',{ id : id});
            }else{
              $state.go('app.shipments.shipment_details',{ id: id});
            }
          }
        }

        // created sort by filter
        function fnCreatedSortBy(action){
          vm.filterObj.data.sort_by_type = action === 'ASC' ? 'DESC' : 'ASC';
          vm.listLoader = true;
          vm.isLoadMoreActive = false;
          vm.inquiryListToRender.inquiryList = [];
          vm.inquiryListToRender.shimmer = true;
          vm.filterObj.data.offset = 0;
          vm.initInquiryList(); // get list of inquiry
        }
      }
})();

(function ()
{
    'use strict';

    var themeStyle = {
        'default' : {
            'borderRadius' : '',
            'fontFamily' : 'Lato',
            'gradient' : '',
            'activeTabColor' : '',
            'domainList' : []
        },
        'custom' : {
          'borderRadius' : '',
          'fontFamily' : 'Lato',
          'gradient' : '',
          'activeTabColor' : '',
          'domainList' : []
        },
        'transpost'  : {
            'borderRadius' : '16px',
            'fontFamily' : 'Montserrat',
            'gradient' : 'linear-gradient(184deg, #019688 7%, #21D9B3 100%)',
            'activeTabColor' : 'rgb(255, 255, 255)',
            'domainList' : ['transpost.stagingship.freightbro.com','transpost.devship.freightbro.com','transpost.freightbro.com','transpost.qaship.freightbro.com']
        },
        'pinkTheme' : {
            'borderRadius' : '20px',
            'fontFamily' : 'Gilroy',
            'gradient' : '',
            'activeTabColor' : '',
            'domainList' : []
        }
    };

    angular
        .module('app.core')
        .constant('themeStyle', themeStyle);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            },
            activatedTheme : ''
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes,$provide)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        var primaryPalette = $cookies.getObject('primaryPalette', primaryPalette);
        var secondaryPalette =  $cookies.getObject('secondaryPalette', secondaryPalette);

        if ( customTheme && primaryPalette && secondaryPalette )
        {
            fuseThemes['custom'] = customTheme;
            fusePalettes.push(primaryPalette);
            fusePalettes.push(secondaryPalette);
        }else{
            $cookies.remove('customTheme');
            $cookies.remove('selectedTheme');
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        $mdThemingProvider.theme('custom-dark') .dark();

        $provide.value('themeProvider', $mdThemingProvider);

    }

})();

(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'cerulean-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'amber',
                hues: {
                    'default': '700',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'fuse-ghost-white',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'transpost'  : {
            primary   : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '200',
                    'hue-3'  : '50',
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '800',
                    'hue-2'  : '200',
                    'hue-3'  : '50'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'fuse-ghost-white',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'cerulean-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#4a5bb7',
                '600': '#2e62b1',
                '700': '#233669',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#233669',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-ghost-white',
            options: {
                '50': '#fcfcff',
                '100': '#e3e3e6',
                '200': '#eeeeee',
                '300': '#e0e0e0',
                '400': '#bdbdbd',
                '500': '#9e9e9e',
                '600': '#757575',
                '700': '#616161',
                '800': '#424242',
                '900': '#212121',
                'A100': '#ffffff',
                'A200': '#000000',
                'A400': '#303030',
                'A700': '#656566',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming,themeStyle)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba,
            getContrast: getContrast
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme, selected border radius and font family.
            var selectedTheme = $cookies.get('selectedTheme');
            if ( selectedTheme )
            {
              fuseTheming.activatedTheme = selectedTheme;
            }
            else {
              if(themeStyle['transpost'].domainList.indexOf(window.location.host) !== -1)
              {
                fuseTheming.activatedTheme = 'transpost';
              }
              else {
                  fuseTheming.activatedTheme = 'default';
              }
            }

            var activetheme = themeStyle[fuseTheming.activatedTheme];

            var activeTabColor = activetheme.activeTabColor ? activetheme.activeTabColor : themes[fuseTheming.activatedTheme].accent.color;

            //  activate theme
            fuseTheming.setActiveTheme(fuseTheming.activatedTheme);

            //  Creating css variable w.r.t theme type
             document.documentElement.style.setProperty('--fb-primary', themes[fuseTheming.activatedTheme].primary.color);
             document.documentElement.style.setProperty('--fb-accent', themes[fuseTheming.activatedTheme].accent.color);
             document.documentElement.style.setProperty('--fb-accent-text-color', getContrast(themes[fuseTheming.activatedTheme].accent.color));

            //  For Accent Hover effect
             var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());
             var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
             document.documentElement.style.setProperty('--fb-accent-btn-hover', rgba(registeredPalettes[registeredThemes[fuseTheming.activatedTheme].colors["accent"].name]['800'].value));

            //  css variables
             document.documentElement.style.setProperty('--gradient-bg',activetheme.gradient);
             document.documentElement.style.setProperty('--fb-border-radius',activetheme.borderRadius);
             document.documentElement.style.setProperty('--fb-font-family',activetheme.fontFamily);
             document.documentElement.style.setProperty('--fb-font-family-regular',activetheme.fontFamily + '-Regular');
             document.documentElement.style.setProperty('--fb-font-family-bold',activetheme.fontFamily + '-Bold');
             document.documentElement.style.setProperty('--fb-font-family-extrabold',activetheme.fontFamily + '-ExtraBold');
             document.documentElement.style.setProperty('--active-tab',activeTabColor);
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        /**
         * For deciding forecolor based on background color.
         * @param {string} hexcolor
         * @returns
         */
        function getContrast(hexcolor, isHexcolor) {

            try {

              if(isHexcolor){
                // If a leading # is provided, remove it
                if (hexcolor.slice(0, 1) === '#') {
                  hexcolor = hexcolor.slice(1);
                }

                var r = parseInt(hexcolor.substr(0, 2), 16);
                var g = parseInt(hexcolor.substr(2, 2), 16);
                var b = parseInt(hexcolor.substr(4, 2), 16);
              }
              else{
                var rgb = hexcolor.match(/(\d+)/g);
                var r = parseInt(rgb[0]);
                var g = parseInt(rgb[1]);
                var b = parseInt(rgb[2]);
              }

              // Get YIQ ratio
              var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

              // Check contrast
              return (yiq >= 128) ? 'black' : 'white';
            } catch (err) {
                console.error(err);
                return 'white';
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('customTheming', customThemingService);

    /** @ngInject */
    function customThemingService($cookies, $rootScope, fuseGenerator, fuseThemes, themeProvider, fuseTheming)
    {

        var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
        var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
        var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');

        var customThemingService = {
          isCustomThemePresent : isCustomThemePresent,
          applyTheme : applyTheme,
          validateThemeObj : validateThemeObj,
          generateCustomTheme : generateCustomTheme,
          computeColors : computeColors,
          calcPalette : calcPalette,
          multiply : multiply,
          sanitizePalette : sanitizePalette,
        };

        return customThemingService;

        // To check if custom theme present in cookies
        function isCustomThemePresent()
        {
            return $cookies.getObject('customTheme');
        }

        // Apply theme if custom present
        function applyTheme()
        {
          if(customThemingService.isCustomThemePresent() && !$rootScope.ifVersionUpdate )
          {
            fuseGenerator.generate();
          }
        }

        function validateThemeObj(){
          if(!$rootScope.domainData.domain_info.THEME_CONFIG){
            // generate default theme
            $cookies.remove('customTheme');
            $cookies.remove('selectedTheme');
            fuseGenerator.generate();
          }else{
            // Generate custom theme if colors difference/custom present/version change
            var isPrimaryDifferent = fuseTheming.activatedTheme ? $cookies.getObject('primaryPalette').options['500'].toLowerCase() !== $rootScope.domainData.domain_info.THEME_CONFIG.primary_color.toLowerCase() : true;
            var isSecondaryDifferent = fuseTheming.activatedTheme ? $cookies.getObject('secondaryPalette').options['500'].toLowerCase() !== $rootScope.domainData.domain_info.THEME_CONFIG.secondary_color.toLowerCase() : true;
            if(isPrimaryDifferent || isSecondaryDifferent || !customThemingService.isCustomThemePresent() || $rootScope.ifVersionUpdate )
            {
              customThemingService.generateCustomTheme($rootScope.domainData.domain_info.THEME_CONFIG.primary_color,$rootScope.domainData.domain_info.THEME_CONFIG.secondary_color);
            }
          }
        }

        // Generate custom theme after api responce and store in cookies
        function generateCustomTheme(primary,secondary){

          // get palette  by hex code
          var primaryPalette = customThemingService.calcPalette(primary,'custom-primary');
          var secondaryPalette = customThemingService.calcPalette(secondary,'custom-accent');

          var theme = {"primary":{"name":primaryPalette.name,"hues":{"default":"500","hue-1":"100","hue-2":"600","hue-3":"A100"}},"accent":{"name":secondaryPalette.name,"hues":{"default":"500","hue-1":"100","hue-2":"600","hue-3":"A100"}},"warn":{"name":"blue","hues":{"default":"500","hue-1":"300","hue-2":"800","hue-3":"A100"}},"background":{"name":"fuse-ghost-white","hues":{"default":"A100","hue-1":"A100","hue-2":"50","hue-3":"300"}}};

          // Inject Cookies Service
          var $cookies;

          angular.injector(['ngCookies']).invoke([
              '$cookies', function (_$cookies)
              {
                  $cookies = _$cookies;
              }
          ]);

          // Store in cookies
          $cookies.putObject('customTheme', theme);
          $cookies.put('selectedTheme', 'custom');
          $cookies.putObject('primaryPalette', primaryPalette);
          $cookies.putObject('secondaryPalette', secondaryPalette);

          // form palette options
          primaryPalette.options = customThemingService.sanitizePalette(primaryPalette.options,primaryPalette.name);
          secondaryPalette.options = customThemingService.sanitizePalette(secondaryPalette.options,secondaryPalette.name);

          // Define pelette
          themeProvider.definePalette(primaryPalette.name, primaryPalette.options);
          themeProvider.definePalette(secondaryPalette.name, secondaryPalette.options);

          // Define theme
          themeProvider.theme('custom')
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);

          // Store theme in fuse theme
          fuseThemes['custom'] = theme;

          // generate theme again
          fuseGenerator.generate();

        }

        // Form palatte structure
        function computeColors(hex)
	      {
          var baseLight = tinycolor('#ffffff');
          var baseDark = customThemingService.multiply(tinycolor(hex).toRgb(), tinycolor(hex).toRgb());
          var baseTriad = tinycolor(hex).tetrad();
          return [
            getColorObject(tinycolor.mix(baseLight, hex, 12), '50'),
            getColorObject(tinycolor.mix(baseLight, hex, 30), '100'),
            getColorObject(tinycolor.mix(baseLight, hex, 50), '200'),
            getColorObject(tinycolor.mix(baseLight, hex, 70), '300'),
            getColorObject(tinycolor.mix(baseLight, hex, 85), '400'),
            getColorObject(tinycolor.mix(baseLight, hex, 100), '500'),
            getColorObject(tinycolor.mix(baseDark, hex, 87), '600'),
            getColorObject(tinycolor.mix(baseDark, hex, 70), '700'),
            getColorObject(tinycolor.mix(baseDark, hex, 54), '800'),
            getColorObject(tinycolor.mix(baseDark, hex, 25), '900'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(80).lighten(65), 'A100'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(80).lighten(55), 'A200'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(100).lighten(45), 'A400'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(100).lighten(40), 'A700')
				];
        };

        // Calculate pallete
        function calcPalette(hex, color_name)
        {
          var computedColors = customThemingService.computeColors(hex);
          var palette = {
            name: color_name,
            options: {
                '50': computedColors[0].hex,
                '100': computedColors[1].hex,
                '200': computedColors[2].hex,
                '300': computedColors[3].hex,
                '400': computedColors[4].hex,
                '500': computedColors[5].hex,
                '600': computedColors[6].hex,
                '700': computedColors[7].hex,
                '800': computedColors[8].hex,
                '900': computedColors[9].hex,
                'A100': computedColors[10].hex,
                'A200': computedColors[11].hex,
                'A400': computedColors[12].hex,
                'A700': computedColors[13].hex,
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
          }
          return palette;
        }

        // Utility function to combine two rgb objects via Multiply
        function multiply(rgb1, rgb2)
        {
          rgb1.b = Math.floor(rgb1.b * rgb2.b / 255);
          rgb1.g = Math.floor(rgb1.g * rgb2.g / 255);
          rgb1.r = Math.floor(rgb1.r * rgb2.r / 255);
          return tinycolor('rgb ' + rgb1.r + ' ' + rgb1.g + ' ' + rgb1.b);
        };

        // Get color name,hex and contract object
        function getColorObject(value, name)
        {
          var c = tinycolor(value);
          return {
            name: name,
            hex: c.toHexString(),
            darkContrast: c.isLight()
          };
        }

        // material function to form palete obj needed while defining theme palette
        function sanitizePalette(palette, name) {
          var defaultContrast = palette.contrastDefaultColor;
          var lightColors = palette.contrastLightColors || [];
          var strongLightColors = palette.contrastStrongLightColors || [];
          var darkColors = palette.contrastDarkColors || [];

          // These colors are provided as space-separated lists
          if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
          if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
          if (typeof darkColors === 'string') darkColors = darkColors.split(' ');

          // Cleanup after ourselves
          delete palette.contrastDefaultColor;
          delete palette.contrastLightColors;
          delete palette.contrastStrongLightColors;
          delete palette.contrastDarkColors;

          // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
          angular.forEach(palette, function(hueValue, hueName) {
            if (angular.isObject(hueValue)) return; // Already converted
            // Map everything to rgb colors
            var rgbValue = colorToRgbaArray(hueValue);
            if (!rgbValue) {
              throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
                              .replace('%1', hueValue)
                              .replace('%2', palette.name)
                              .replace('%3', hueName));
            }

            palette[hueName] = {
              hex: palette[hueName],
              value: rgbValue,
              contrast: getContrastColor()
            };

            function getContrastColor() {
              if (defaultContrast === 'light') {
                if (darkColors.indexOf(hueName) > -1) {
                  return DARK_CONTRAST_COLOR;
                } else {
                  return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
                    : LIGHT_CONTRAST_COLOR;
                }
              } else {
                if (lightColors.indexOf(hueName) > -1) {
                  return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
                    : LIGHT_CONTRAST_COLOR;
                } else {
                  return DARK_CONTRAST_COLOR;
                }
              }
            }

          });

          return palette;
        }

        // get rgba values for palette
        function colorToRgbaArray(clr) {
          if (angular.isArray(clr) && clr.length == 3) return clr;
          if (/^rgb/.test(clr)) {
            return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
              return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
            });
          }
          if (clr.charAt(0) == '#') clr = clr.substring(1);
          if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;

          var dig = clr.length / 3;
          var red = clr.substr(0, dig);
          var grn = clr.substr(dig, dig);
          var blu = clr.substr(dig * 2);
          if (dig === 1) {
            red += red;
            grn += grn;
            blu += blu;
          }
          return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function(){
 'use strict';

    angular
        .module('app.core')
        .factory('localStorageService', localStorageService );

        /** @ngInject */
        function localStorageService($log){


            var service = {
                expireAfter: 1,
                get : get,
                set : set,
                remove : remove,
                clear : clear,
                isValid : isValid,
                otp: ''
            }

            return service;

            /////

            /**
            * Retrieve value under given key from local storage.
		    * @param  {string} key
		    * @return mixed
            */
            function get(key,defaultValue){
                var value = JSON.parse(localStorage.getItem(key));
                
                if ( ! value || ! service.isValid(value.time) && value == 'authToken') {
                    return defaultValue;
                }

                if ( ! value ) {
                    return defaultValue;
                }
    
                return value;  // value.value
            }

            /**
             * Store Value into browser local Storage
             * @param {string} key
             * @param {*} value
             * @param {boolean} append
             */
            function set(key,value,append){
                var data = { value: value, time: new Date().getTime() };
                
                //if append flag is true and old value exists and
                //is array, push new value inside that array and store it
                if (append) {
                    var old = service.get(key);
    
                    //if old value doesn't exist and new value isn't array
                    //turn it into array now so we can push into later
                    if ( ! angular.isArray(value)) {
                        data.value = [value];
                    }
    
                    if (angular.isArray(old)) {
                        old.push(value);
                        data.value = old;
                    }
                }
    
                return localStorage.setItem(key, JSON.stringify(data));
            }

            /**
             * Remove item from local storage.
             *
             * @param key
             * @returns {*}
             */
            function remove(key) {
                return localStorage.removeItem(key);
            }

            /**
             * Whether or not cache with given time is considered expired.
             * 
             * @param  string  time
             * @return {Boolean}
             */
            function isValid(time) {
                var days = (new Date().getTime() - new Date(time).getTime())/(1000*60*60*24);
                return days < service.expireAfter;
            }

            function clear(){
                return localStorage.clear();
            }



        }




})();
(function(){
 'use strict';

    angular
        .module('app.core')
        .factory('exportToFile', exportToFile);

        /** @ngInject */
        function exportToFile($log,$q){

            var service = {
                exportToCsvFormat : exportToCsvFormat
            }
            return service;


            function exportToCsvFormat(headersColumns, bodyColumns, fileTitle){
                var deferred = $q.defer();
                if (headersColumns) {
                    bodyColumns.unshift(headersColumns);
                }
                var csv = convertToCSV(bodyColumns);
                var exportedFileName = fileTitle + '.csv' || 'export.csv';
                
                var blob = new Blob([decodeURIComponent(encodeURI(csv))], { type: 'text/csv;charset=utf-8;' });
                if (navigator.msSaveBlob) { // IE 10+
                    navigator.msSaveBlob(blob, exportedFileName);
                } else {
                    var link = document.createElement("a");
                    if (link.download !== undefined) { // feature detection
                        // Browsers that support HTML5 download attribute
                        var url = URL.createObjectURL(blob);
                        link.setAttribute("href", url);
                        link.setAttribute("class", 'schedule-export');
                        link.setAttribute("download", exportedFileName);
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
                deferred.resolve(csv);
                return deferred.promise;
            }

            // json converted into csv format
            function convertToCSV(bodyColumns) {
                var firstArrayKey = Object.keys(bodyColumns[0])
                var isValuePresent = function(key, columnValue) { return columnValue && columnValue !== 'N/A' ? columnValue : '-' } 
                var csvObject = bodyColumns.map(function(bodyRow){
                    return firstArrayKey.map(function(columnsName){
                        //it's converted into string fromat.
                        return JSON.stringify(bodyRow[columnsName],isValuePresent)
                    }).join(',')
                })
                csvObject = csvObject.join('\r\n');
                return csvObject;
            }
        }

})();
(function () {
  "use strict";

  angular
    .module("app.core")
    .factory("appCache", ["$cacheFactory",
      function ($cacheFactory) {
        return $cacheFactory("app-cache");
      }
    ]);

})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            // 'app.quick-panel',

            // Sample
            'app.search',

            // apps
            'app.pages',

            // result
            'app.result',

            //specialRates
            'app.specialRates',

            // quotes
            'app.quotes',

            // shipments
            'app.shipments',

            //create shipment
            'app.createShipment',

            //shipper And users
            'app.userRoles',

            //Rate Provider
            'app.rateProvider',

            //Search Stats
            // 'app.searchStats',

            // setting
            'app.profile',

            //Dashboard
            'app.dashboard',

            //Reports
            'app.reports',

            //notification
            'app.notification',

            //shipments-stats
            // 'app.shipmentStats',

            //Schedule -search
            'app.scheduleSearch',

            //custom rates
            'app.rates',

            //Track-n-trace
            'app.track-n-trace',

            //Inquiry Managemnt
            'app.inquiry',

            // Rules
            'app.rules',

            // Pricing Rules
            'app.pricingRules',

            // Currency setting
            'app.currencySetting',

            // Manage rates
            'app.manageRates',

            // Forwarder Assignment (god-only)
            'app.forwarderAssignment',

            // Partner rate management
            'app.partnerRateManagement',

            // Add rates
            'app.addRate',

            // upload rates
            'app.uploadRateSheet',

            // My rates
            'app.myRates',

            // Setting
            'app.settings',

            // Dau
            'app.dauFclLeg',

            // Bulk update
            'app.bulkUpdate',

            // Audit trail
            'app.auditTrail',

            //notification
            'app.manageNotification',

            //banner broadcast
            'app.bannerBroadcast',

            
            // Standard quotation
            'app.standardQuotation',

            // CDM 
            'app.contractManager',

            //CDM Audit Trail
            'app.cdmAuditTrail',

            //CDM Download
            'app.cdmDownloadContracts',


             // oneQuoteDefiniton
            'app.oneQuoteModule',

             // basket
            'app.basketModule',

            // quote-list
            'app.quoteListModule',

            //search-v2
            'app.searchV2Module',
            
            //carrier integration
            'app.carrierIntegration',

            // Lcl Pricing Management
            'app.lclMatrixView',

            //upload rates v2
            'app.uploadRatesV2',

            //upload rates v2
            'app.myRatesV2',

            //upload rates v2
            'app.tariffHeader',

            //charges 
            'app.charges',
            //Inquiry V2 Managemnt
            'app.enquiry',

            //Booking V2 Management
            'app.bookingv2',

            //Booking Form V2
            'app.bookingFormV2',
            
            //charges 
            'app.charges',

            'app.pdfConfigurations'

        ]);
})();

(function()
{

    'use strict';

    angular
        .module('fuse')
        .factory('basisCalculation', basisCalculation);

    /** @ngInject */
    function basisCalculation(constObj){
        var basisCalculation =  {
            freightTotal :{sellFreightTotal:null,buyFreightTotal:null},
            basisOnTotalObj:{},
            currencyConverter:{},
            addCharge:addCharge,
            removeCharge:removeCharge,
            removeParent:removeParent,
            setTotalUnits:setTotalUnits,
            setTotalUnitsForBasisOnCharge:setTotalUnitsForBasisOnCharge,
            deleteLeg:deleteLeg,
            deleteParent:deleteParent,
            deleteParentLoad : deleteParentLoad,
            changeLegcode:changeLegcode,
            totalUnitsCurrencyConversion:totalUnitsCurrencyConversion,
            getLegData:getLegData,
            setTotalUnitsOnBillingInfo:setTotalUnitsOnBillingInfo,
            isParent:isParent,
            getChildBasis:getChildBasis
        };
        return basisCalculation;
     

    function addCharge(legCode, sellCharge, buyCharge,basis){   
            basisCalculation.basisOnTotalObj[basis] = basisCalculation.basisOnTotalObj[basis] || {};
            basisCalculation.basisOnTotalObj[basis][legCode] = basisCalculation.basisOnTotalObj[basis][legCode] || [];
            const chargeObj = {
              buyCharge : buyCharge,
              sellCharge : sellCharge
            }
            basisCalculation.basisOnTotalObj[basis][legCode].push(chargeObj);
          }
    function removeCharge(legCode, chargeObj){
      Object.keys(basisCalculation.basisOnTotalObj).forEach(function(basis){
        if(basisCalculation.basisOnTotalObj[basis][legCode]){      
          basisCalculation.basisOnTotalObj[basis][legCode] = basisCalculation.basisOnTotalObj[basis][legCode].filter(function(item){ return item.sellCharge !== chargeObj });
          if(basisCalculation.basisOnTotalObj[basis][legCode].length === 0){
            basisCalculation.deleteLeg(legCode,basis);
          }
        }
      })
       
      }
      function removeParent(chargeObj,mode){
        var targetLoad = null;
        var targetBasis = null;

        if(basisCalculation.basisOnTotalObj){
          Object.keys(basisCalculation.basisOnTotalObj).forEach(function(basis){
        if(basisCalculation.basisOnTotalObj[basis] && basisCalculation.basisOnTotalObj[basis]['parent']){
          Object.keys(basisCalculation.basisOnTotalObj[basis]['parent']).forEach(function(load){
              if(basisCalculation.basisOnTotalObj[basis]['parent'][load].sell == chargeObj ){
                targetLoad = load;
                targetBasis = basis;
              }
          })
          
          
        }
        });
        if(targetLoad != null){
            if(!mode.toLowerCase().includes('fcl') && (chargeObj.charge_basis && chargeObj.charge_basis.includes('%'))){
              basisCalculation.basisOnTotalObj[targetBasis]['parent'] = {}
            }else if(mode.toLowerCase().includes('fcl') && chargeObj.charge_basis !== 'per equipment'){
            basisCalculation.basisOnTotalObj[targetBasis]['parent'][targetLoad]= {};

            }else if(mode.toLowerCase().includes('fcl')){
          basisCalculation.basisOnTotalObj[targetBasis]['parent'][chargeObj.container_type ? chargeObj.container_type : 'N/A'] = {};
           basisCalculation.basisOnTotalObj[targetBasis]['parent'][chargeObj.container_type ? chargeObj.container_type : 'N/A'].sell = basisCalculation.basisOnTotalObj[targetBasis]['parent'][targetLoad].sell;
           basisCalculation.basisOnTotalObj[targetBasis]['parent'][chargeObj.container_type ? chargeObj.container_type : 'N/A'].buy = basisCalculation.basisOnTotalObj[targetBasis]['parent'][targetLoad].buy;
           delete basisCalculation.basisOnTotalObj[targetBasis]['parent'][targetLoad] 
         }
         return targetBasis;
        }
        return targetBasis;
      }
         
        }
    
    function  setTotalUnits(l3LegKey,currentCard){
        Object.keys(basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS]).forEach(function(legcode) {
          var buyConvertedQuantity = null;
          var sellConvertedQuantity = null;
          if(l3LegKey){
            buyConvertedQuantity = basisCalculation.currencyConverter.convert(parseFloat(basisCalculation.freightTotal.buyFreightTotal),currentCard.data.sell_rates[l3LegKey].rate_obj.leg_currency,currentCard.data.sell_rates[legcode].rate_obj.leg_currency);
            sellConvertedQuantity = basisCalculation.currencyConverter.convert(parseFloat(basisCalculation.freightTotal.sellFreightTotal),currentCard.data.sell_rates[l3LegKey].rate_obj.leg_currency,currentCard.data.sell_rates[legcode].rate_obj.leg_currency);
          }
          basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][legcode].forEach(function(chargeObj){
            chargeObj.sellCharge['total_units'] = sellConvertedQuantity;
            if(chargeObj.buyCharge){
              chargeObj.buyCharge['total_units'] = buyConvertedQuantity;
            }
        });
        });
      }
      function  setTotalUnitsForBasisOnCharge(basis){
      if(basisCalculation.basisOnTotalObj[basis]){
        Object.keys(basisCalculation.basisOnTotalObj[basis]).forEach(function(legcode) {
          if(legcode !== "parent"){
            basisCalculation.basisOnTotalObj[basis][legcode].forEach(function(chargeObj){
              chargeObj.sellCharge['total_units'] = basisCalculation.basisOnTotalObj[basis].parent ?  basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'] ?basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'].sell.leg_currency_cost :null:null:null;
              if(chargeObj.buyCharge){
                chargeObj.buyCharge['total_units'] = basisCalculation.basisOnTotalObj[basis].parent ?  basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'] ? basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'].buy  ? basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'].buy.leg_currency_cost :null :null : null;
              }else{
                chargeObj.sellCharge.buy['total_units'] = basisCalculation.basisOnTotalObj[basis].parent ?  basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'] ?basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'].sell ? basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'].sell.buy ? basisCalculation.basisOnTotalObj[basis].parent[chargeObj.sellCharge.container_type ? chargeObj.sellCharge.container_type : 'N/A'].sell.buy.leg_currency_cost :null:null:null:null;
              }
          });
          }

        });
      }
      }
      function  setTotalUnitsOnBillingInfo(l3LegData,bill_rates){
        Object.keys(basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS]).forEach(function(legcode) {
          var buyConvertedQuantity = null;
          var sellConvertedQuantity = null;
          var legData = basisCalculation.getLegData(bill_rates,legcode);
          if(l3LegData){
            buyConvertedQuantity = basisCalculation.currencyConverter.convert(parseFloat(basisCalculation.freightTotal.buyFreightTotal),l3LegData.leg_currency,legData.leg_currency);
            sellConvertedQuantity = basisCalculation.currencyConverter.convert(parseFloat(basisCalculation.freightTotal.sellFreightTotal),l3LegData.leg_currency,legData.leg_currency);
          }
          basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][legcode].forEach(function(chargeObj){
            chargeObj.sellCharge['total_units'] = sellConvertedQuantity;
            if(chargeObj.sellCharge.buy){
              chargeObj.sellCharge.buy['total_units'] = buyConvertedQuantity;
            }
        });
        });
      }
      function deleteLeg(legCode,basis){
        if(basisCalculation.basisOnTotalObj[basis]){
          delete basisCalculation.basisOnTotalObj[basis][legCode];
        }
      }
      function deleteParent(basis){
        if(basisCalculation.basisOnTotalObj[basis]){
          delete basisCalculation.basisOnTotalObj[basis].parent;
        }
      }
      function deleteParentLoad(basis,load){
        if(basisCalculation.basisOnTotalObj[basis] && basisCalculation.basisOnTotalObj[basis].parent){
          delete basisCalculation.basisOnTotalObj[basis].parent[load ? load : 'N/A' ];
        }
      }
      
      function changeLegcode(oldLegcode,newLegcode){
        if(basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][oldLegcode]){
          basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][newLegcode]=basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][oldLegcode];
          delete basisCalculation.basisOnTotalObj[constObj.FREIGHT_TOTAL_BASIS][oldLegcode];
        }
      }
      function totalUnitsCurrencyConversion(quantity,l3LegCurrency,currentLegCurrency){
        return basisCalculation.currencyConverter.convert(parseFloat(quantity),l3LegCurrency, currentLegCurrency);
      }
      //return l3 leg key
      function getLegData(rates,legCode){
        var l3LegData = null;
        if(rates.length){
          l3LegData = rates.find(function(leg){
          return leg.leg_code.includes(legCode) && leg.leg_status !=="REMOVED"
        })
        }
        return l3LegData;
      }
      function isParent(currentCharge,mode){
        if(!mode){
          return
        }
    if (mode.toLowerCase().includes("fcl")) {
      // there may be cases where charge code is missing
      // for scenario like a % charge basis is there other than % on 30001 but chargeCode is missing then in that case the charge will not be defined
     if( currentCharge.charge_code &&(
         currentCharge.charge_code.toLowerCase() === "pickup" || currentCharge.charge_code.toLowerCase() === "delivery" || currentCharge.charge_code.toLowerCase() === "freight")){
      return true;
     }
       if (
        
        (currentCharge.charge_id && ((currentCharge.charge_id.toString() === '30001') ||
          (currentCharge.charge_id.toString() === '10001') ||
          (currentCharge.charge_id.toString() === '50155') ||
          ( currentCharge.charge_id.toString() === '50001')))
      ) {
        return true;
      }
    } else if (mode.toLowerCase().includes("lcl")) {
      // the 1st condition is to handle current scenario where for lcl basis is constObj.FREIGHT_BASIS instead of % on ocean_freight. will remove in future when no charge exists with this basis
      return (
        currentCharge.charge_id &&( (currentCharge.charge_id.toLowerCase() === 'ocean_freight') ||
        currentCharge.charge_id.toLowerCase() === "pickup" || currentCharge.charge_id.toLowerCase() === "delivery" || currentCharge.charge_id.toLowerCase() === "freight")
      );
    } else
     if (mode.toLowerCase().includes('air')) {
      // the 1st condition is to handle current scenario where for air basis is constObj.AIR_FREIGHT_BASIS instead of % on air_freight
      
      return (
        currentCharge.charge_id && (
        (currentCharge.charge_id.toLowerCase() === 'air_freight') ||
        currentCharge.charge_id.toLowerCase() === "pickup" || currentCharge.charge_id.toLowerCase() === "delivery" || currentCharge.charge_id.toLowerCase() === "freight")
      );
    }
    return false;

      }
      function getChildBasis(currentCharge,mode){
        if( mode.toLowerCase().includes('air') && currentCharge.charge_id&&(currentCharge.charge_id && ((currentCharge.charge_id.toLowerCase() === 'air_freight') || currentCharge.charge_id.toLowerCase().includes('freight')))){
          return constObj.AIR_FREIGHT_BASIS;
        }else if( ((mode.toLowerCase().includes("lcl") || mode.toLowerCase().includes("fcl")) && (currentCharge.charge_id &&(currentCharge.charge_id.toLowerCase() === 'ocean_freight' || currentCharge.charge_id.toLowerCase().includes('freight') || currentCharge.charge_id.toString() === '30001'))) || mode.toLowerCase().includes("fcl") && currentCharge.charge_code && currentCharge.charge_code==='freight'){
          return constObj.FREIGHT_BASIS;
        }else if((currentCharge.charge_id &&(currentCharge.charge_id.toString() === '10001') || currentCharge.charge_id.toLowerCase() === 'pickup') || mode.toLowerCase().includes("fcl") && currentCharge.charge_code && currentCharge.charge_code==='pickup'){
          return constObj.PICKUP_BASIS;
        }else if(currentCharge.charge_id &&(currentCharge.charge_id.toLowerCase() === 'delivery' || currentCharge.charge_id.toString() === '50001' || currentCharge.charge_id.toString() === '50155') || mode.toLowerCase().includes("fcl") && currentCharge.charge_code && currentCharge.charge_code==='delivery'){
          return constObj.DELIVERY_BASIS;
        }
      }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate, $parse,$sanitize) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        var cleanAttr = $sanitize(attr.code);
                        code = $parse(cleanAttr)(scope);
                    }
                    var shouldInterpolate = $parse(attr.shouldInterpolate)(scope);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    var navModuleList = {

        'analytics' : {
          'parent_title' : '',
          'weight' : 1
        },
        'dashboard' : {
          'parent_title' : 'Analytics',
          'weight' : 1
        },
        'reports' : {
          'parent_title' : 'Analytics',
          'weight' : 1
        },
        'search' : {
          'parent_title' : '',
          'weight' : 1
        },
        'inquiry' : {
          'parent_title' : '',
          'weight' : 1
        },
        'uploadRatesV2': {
          'parent_title' : '',
          'weight' : 1
        },
        'quotes' : {
          'parent_title' : '',
          'weight' : 1
        },
        'shipments' : {
          'parent_title' : '',
          'weight' : 1
        },
        'lclMatrixView' : {
          'parent_title' : '',
          'weight' : 1
        },
        'rateManagement' : {
          'parent_title' : '',
          'weight' : 1
        },
        'contractRates' : {
          'parent_title' : 'Manage Rates',
          'weight' : 1
        },
        'myRatesV2' : { // Manage Contracts
          'parent_title' : 'Manage Rates.Contract Rates',
          'weight' : 1
        },
        'tariffHeader' : { // Manage Contracts
          'parent_title' : 'Manage Rates.Contract Rates',
          'weight' : 1
        },
        'contractManager' : { // Manage Contracts
          'parent_title' : 'Manage Rates.Contract Rates.Contract Manager',
          'weight' : 1
        },
        'cdmAuditTrail' : { // Audit Managed Contracts
          'parent_title' : 'Manage Rates.Contract Rates.Contract Manager',
          'weight' : 1
        },
        'cdmDownloadContracts' : { // Download Managed Contracts
          'parent_title' : 'Manage Rates.Contract Rates.Contract Manager',
          'weight' : 1
        },
        'myRates' : {
          'parent_title' : 'Manage Rates.Contract Rates',
          'weight' : 2
        },
        'modifyRates' : {
          'parent_title' : 'Manage Rates.Contract Rates',
          'weight' : 1
        },
        'dauFclLeg' : {
          'parent_title' : 'Manage Rates.Contract Rates.Maintain Rates',
          'weight' : 9
        },
        'bulkUpdate' : {
          'parent_title' : 'Manage Rates.Contract Rates.Maintain Rates',
          'weight' : 9
        },
        'auditTrail' : {
          'parent_title' : 'Manage Rates.Contract Rates.Maintain Rates',
          'weight' : 9
        },
        'rules' : {
          'parent_title' : 'Manage Rates',
          'weight' : 10
        },
        'pricingRules' : {
          'parent_title' : 'Manage Rates',
          'weight' : 10
        },
        'manageRates' : {
          'parent_title' : 'Manage Rates',
          'weight' : 11
        },
        /* Partner rate management: directly below Shared Rates (manageRates); nav sorts by parseInt(weight) */
        'partnerRateManagement' : {
          'parent_title' : 'Manage Rates',
          'weight' : 12
        },
        'forwarderAssignment' : {
          'parent_title' : 'Manage Rates',
          'weight' : 13
        },
        'currencySetting' : {
          'parent_title' : 'Manage Rates',
          'weight' : 14
        },
        'charges': {
          'parent_title' : 'Manage Rates',
          'weight' : 15
        },
        'rates' : {
          'parent_title' : 'Manage Rates',
          'weight' : 13
        },
        'forwarders' : {
          'parent_title' : 'My Company',
          'weight' : 5
        },
        'forwarderOffices' : {
          'parent_title' : 'My Company',
          'weight' : 6
        },
        'groups' : {
          'parent_title' : 'My Company',
          'weight' : 6
        },
        'shippers' : {
          'parent_title' : 'My Company',
          'weight' : 12
        },
        'users' : {
          'parent_title' : 'My Company',
          'weight' : 14
        },
        'agents' : {
          'parent_title' : 'My Company',
          'weight' : 13
        },
        'addRate' : {
          'parent_title' : 'Create.Add Rate',
          'weight' : 15
        },
        'uploadRateSheet' : {
          'parent_title' : 'Create.Add Rate',
          'weight' : 15
        },
        'createShipment' : {
          'parent_title' : 'Create',
          'weight' : 15
        },
        'createQuote' : {
          'parent_title' : 'Create',
          'weight' : 15
        },
        'configuration' : {
          'parent_title' : 'My Company.Settings',
          'weight' : 3
        },
        'roles': {
          'parent_title' : 'My Company.Settings',
          'weight' : 2
        },
        'teams': {
          'parent_title' : 'My Company.Settings',
          'weight' : 3
        },
        'companyGroups': {
          'parent_title' : 'My Company.Settings',
          'weight' : 4
        },
        'tags': {
          'parent_title' : 'My Company.Settings',
          'weight' : 6
        },
        'assignShippers': {
          'parent_title' : 'My Company.Settings',
          'weight' : 4
        },
        'pdfConfigurations': {
          'parent_title' : 'My Company.Settings',
          'weight' : 7
        },
        'manageNotification': {
          'parent_title' : 'My Company',
          'weight' : 4
        },
        'bannerBroadcast': {
          'parent_title' : 'My Company',
          'weight' : 5
        },
        'carrierIntegration': {
          'parent_title' : 'My Company',
          'weight' : 15
        }

        // 'track-n-trace' : {
        //   'parent_title' : 'More'
        // },
        // 'UploadRates' : {
        //   'parent_title' : 'More'
        // },
        // 'scheduleSearch' : {
        //   'parent_title' : 'More'
        // },
        // 'createShipment' : {
        //     'parent_title' : 'More'
        // },

    };

    angular
        .module('app.core')
        .constant('navModuleList', navModuleList);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope,$scope,$mdDialog,$rootElement, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, $log, msNavigationService, loginSerivice, SearchService,ToolbarSerivice, localStorageService,ShipmentService,NotificationService,util,analytics,QuotesService,InquiryService, appCache, navModuleList,$window)
    {
        var vm = this;
        vm.util = util;
        vm.ToolbarSerivice = ToolbarSerivice;
        vm.notificationService = NotificationService;
        vm.currencyList = [];
        vm.type = 'Shipments';
        vm.getSearchPlaceholder = getSearchPlaceholder;
        vm.fnopenCreateQuote=fnopenCreateQuote;
        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        vm.accountList = [];
        var account_list  = localStorageService.get('accountList');
        if(account_list !=  null  && !!account_list.value){
          vm.accountList = account_list.value;
        }

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.updateCurrency = updateCurrency;
        vm.getUserCurrency = getUserCurrency;
        vm.userCurrency = "";
        vm.reloadResultPage = reloadResultPage;
        vm.fnSearchShipment = fnSearchShipment;
        vm.getNotificationData = getNotificationData;
        vm.openNotification = openNotification;
        vm.shipmentSearchUsed = shipmentSearchUsed;
        vm.updateSearchValue = updateSearchValue;
        vm.toggleSearch = toggleSearch;
        vm.trackEvent = trackEvent;
        vm.getDomainData = getDomainData;
        vm.createMenu = [];
        vm.getCreateShipmentMenu = getCreateShipmentMenu;
        vm.hideSpace = false;
        vm.redirectToBasket = redirectToBasket;
        // vm.isMultiDoamin = loginSerivice.isMultiDoamin;
        // vm.uuid = loginSerivice.aid;
        //////////

        init();

        /**
         * Initialize
         */
        function init(){
           
            if(!util.createMenuList.length){
                vm.getCreateShipmentMenu();
            }
            else{
                vm.createMenu = util.createMenuList;
            }

             //get user currency
            if(!util.currencyList.length){
              util.getCurrencyList().then(function(response){
                vm.currencyList = util.currencyList;
              },function(error){
                  vm.currencyList = [];
                $log.log(error);
              });
            }else{
              vm.currencyList = util.currencyList;
            }

            vm.getUserCurrency();
            // vm.getNotificationData();
            vm.getDomainData()

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        function toggleSearch(e){
          e.preventDefault();
          $("#searchbar").toggleClass("collapsed");
          vm.hideNavbar = vm.hideNavbar ? false : true ;
          vm.hideButton = vm.hideButton ? false : true ;
          vm.hideSpace = !vm.hideSpace;
          window.addEventListener('resize',function () {
              if(vm.hideSpace){
                vm.hideNavbar = true;
                $scope.$apply();
              }
          })
          $scope.shipmentSearch = '';
        }

        function getDomainData(){
            if(!Object.keys($rootScope.domainData.domain_info).length){
                util.getDomainData().then(function(){
                    vm.log_url = $rootScope.domainData.logo;
                    vm.log_alt = $rootScope.domainData.domain_name;
                },function(error){
                    $log.log(error.data);
            });
            }else{
                vm.log_url = $rootScope.domainData.logo;
                vm.log_alt = $rootScope.domainData.domain_name;
            }
        }

        function getUserCurrency(){
            util.getProfile().then(function(){
                ToolbarSerivice.userFirstName = util.userProfile.user.user_first_name;
                vm.userData = util.userProfile.user;
                vm.userCurrency = vm.userData.user_base_currency;
            },function(error){
                $log.log(error);
            });
        }

        function getNotificationData(){
            NotificationService.getNotificationData(0,10);
        }

        function updateCurrency(curr){

          vm.user_id = localStorageService.get('authToken').value.user_id;

            var userInfo ={
                "data":{
                    "user_base_currency": curr
                }
            };

            $rootScope.loadingDetails = true;
            util.isCallingApi = true;
            ToolbarSerivice.updateCurrency(userInfo, vm.user_id).then(function(response){
                util.userProfile["user"] = response.data.data;
                if(($state.current.name == 'app.search.result' || $state.current.name == 'app.resultBookShipment')  && SearchService.FclResult.result_meta != undefined && SearchService.FclResult.result_meta.search_param != undefined){
                    vm.reloadResultPage(SearchService.FclResult._id,'FCL');
                }
                else if(($state.current.name == 'app.search.airResult' || $state.current.name == 'app.resultBookShipment') && SearchService.AirResult.result_meta != undefined && SearchService.AirResult.result_meta.search_param != undefined){
                    vm.reloadResultPage(SearchService.AirResult._id,'AIR');
                }
                else if(($state.current.name == 'app.search.lclResult' || $state.current.name == 'app.resultBookShipment') && SearchService.LclResult.result_meta != undefined && SearchService.LclResult.result_meta.search_param != undefined){
                    vm.reloadResultPage(SearchService.LclResult._id,'LCL');
                }
                else if (
                  $state.current.name == "app.searchV2Module" || $state.current.name == "app.search" ||
                  $state.current.name == "app.search.specialRates"
                ) {
                  $state.reload();
                  $rootScope.loadingDetails = false;
                } else {
                  $rootScope.loadingDetails = false;
                  util.isCallingApi = false;
                }
            },function(error){
                $log.log(error);
                $rootScope.loadingDetails = false;
                util.isCallingApi = false;
            });
        }

        function reloadResultPage(id,mode){
            var isPolling =  (mode === 'FCL' && $rootScope.domainData.domain_info.ALLOW_RESULT_POLLING) ? true : false;

            ToolbarSerivice.reloadResultPage(id,isPolling).then(function(response){
                if(response.data.data.result_meta.search_param.mode == 'SEA-FCL'){
                    SearchService.FclResult = response.data.data;
                }else if(response.data.data.result_meta.search_param.mode == 'AIR'){
                    SearchService.AirResult = response.data.data;
                }else if(response.data.data.result_meta.search_param.mode == 'SEA-LCL'){
                    SearchService.LclResult = response.data.data;
                }
                SearchService.isNewSearch = true;

                $state.reload();
                $rootScope.loadingDetails = false;
            },function(error){
                $log.log(error);
                $rootScope.loadingDetails = false;
                util.isCallingApi = false;
            });
        }

        function fnSearchShipment(text,$event,isMobile){
          //mixpanel code
        //   analytics.track("Shipment Search");
 

            if(isMobile && text.length < 3){
                return;
            }
            var keyCode = $event ? ( $event.which || $event.keyCode ) : 13;
            if ((keyCode === 13 || keyCode === 1)) {
               //Validate TextBox value against the Regex.
              var regex = /^[A-Za-z0-9|-]+$/;
              var isValid = regex.test(text);
              if (!isValid && text) {
                util.showToast('Special characters are not allowed.');
                return;
              }

                if(vm.type === 'Shipments' && (text || ShipmentService.toolbarSearchText)){
                    if($state.current.name != 'app.shipments' && text != ""){
                        ShipmentService.toolbarSearchText = text;
                        ToolbarSerivice.filterApplied = true;
                        // if($state.current.name == 'app.shipments.shipment_details'){
                        //     ShipmentService.fromChild = 1;
                        // }
                        // ShipmentService.fromToolbar = 1;
                            $state.go('app.shipments');
                    }
                    else{
                        if(ShipmentService.toolbarSearchText != text){
                            ShipmentService.toolbarSearchText = text;
                            $rootScope.$emit('shipmentListWithSearch');
                        }
                    }
                }
                if(vm.type === 'Quotes' && (text || QuotesService.filterParams.search)){
                    // ShipmentService.toolbarSearchText = text;
                    if($state.current.name != 'app.quotes' && text != ""){
                        QuotesService.filterParams = {
                            'mode' : '',
                            'status' : '',
                            'created_by' : '',
                            'created_for' : '',
                            'search' : text,
                            'company_id' : '',
                            'isBooked' : ''
                        };
                        ToolbarSerivice.filterApplied = true;
                        $state.go('app.quotes');
                    }
                    else{
                        if(QuotesService.filterParams.search !== text){
                            QuotesService.filterParams.search = text;
                            QuotesService.filterParams.offset = 0;
                            $rootScope.$emit('quotesListWithSearch');
                        }
                    }
                }
                if(vm.type === 'Inquiry' && (text || InquiryService.filterParams.search)){
                    // ShipmentService.toolbarSearchText = text;
                    if($state.current.name != 'app.inquiry' && text != ""){
                        InquiryService.filterParams = {
                            'users' : '',
                            'customer' : '',
                            'customer_company' : '',
                            'mode' : '',
                            'search' : text,
                            'start_date' : null,
                            'end_date' : new Date()
                        };
                        ToolbarSerivice.filterApplied = true;
                        $state.go('app.inquiry');
                    }
                    else{
                        if(InquiryService.filterParams.search !== text){
                            InquiryService.filterParams.search = text;
                            InquiryService.filterParams.offset = 0;
                            $rootScope.$emit('inquiryListWithSearch');
                        }
                    }
                }
                // || (keyCode === 8 && ShipmentService.toolbarSearchText != "" && text == "" )

            }
        }

        $rootScope.$on('emptySearchBox', function(event, args) {
            if(!$scope.shipmentSearch){
                InquiryService.filterParams.search = "";
                QuotesService.filterParams.search = "";
            }
            if(!ToolbarSerivice.filterApplied) {
                ShipmentService.toolbarSearchText = "";
                $scope.shipmentSearch = args.any;
            }
            ToolbarSerivice.filterApplied = false;
        });

        $rootScope.$on('emptyQuoteSearchBox', function(event, args) {
            if(!$scope.shipmentSearch){
                ShipmentService.toolbarSearchText = "";
            }
            if(!ToolbarSerivice.filterApplied) {
                $scope.shipmentSearch = args.any;
                QuotesService.filterParams.search = "";
            }
            ToolbarSerivice.filterApplied = false;
        });

        $rootScope.$on('emptyInquirySearchBox', function(event, args) {
            if(!$scope.shipmentSearch){
                ShipmentService.toolbarSearchText = "";
            }
            if(!ToolbarSerivice.filterApplied) {
                $scope.shipmentSearch = args.any;
                InquiryService.filterParams.search = "";
            }
            ToolbarSerivice.filterApplied = false;
        });

        //mixpanel tacking Shipment Search Used
        function shipmentSearchUsed(type,text){
            if(text){
                //mixpanel code
                analytics.track("Shipment Search Used",{
                    "Search Type": type,
                    "Search Text": text
                });
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout()
        {
          vm.isMultiDomain = vm.accountList.length > 1 ? true : false ;  //loginSerivice.isMultiDomain;
          var uuid = '';
          var vendorName = localStorageService.get('authToken').value.vendor_name;
          if(vm.isMultiDomain){
            for(var i = 0; i < vm.accountList.length; i++){
                if(vm.accountList[i].vendor_name === vendorName){
                    uuid = vm.accountList[i].uuid;
                    break;
                }
            }
          }
          
            loginSerivice.logout(vm.isMultiDomain, uuid).then(function(){

                msNavigationService.clearNavigation();
                localStorageService.remove('authToken'); // removing the auth token in local storage.
                localStorageService.remove('currencyList');
                localStorageService.remove('erpIntegrationList');
                util.createMenuList = [];
                util.solution_type = '';
                if( vm.isMultiDomain){
                  localStorageService.remove('accountList');
                }
                appCache.removeAll();
                $state.go('app.pages_auth_login-v2');
                $rootScope.redirectUrl = null;
                localStorageService.remove('rateToasterStatus');
                localStorageService.remove('showBannerStatus');
                localStorageService.remove('prevBannerUpdate');
                localStorageService.remove('forwarder');
            },function(error){
                $log.log(error);
            });
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( item.title.toLowerCase().search(query.toLowerCase()) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }

        function openNotification(){
            ToolbarSerivice.currentState = $state.current.name;
            if(NotificationService.unSeenNotificationCount!=0){
                var post_data = {
                    'data' : {
                        'happened_at' : NotificationService.notificationData.notifications[0].item.happened_at
                    }
                };
                NotificationService.markSeenNotificationData(post_data).then(function(response){
                    vm.unSeenNotificationCount = 0;
                },function(error){
                    $log.log(error);
                });
            }
            $state.go('app.notification');
        }

        function getSearchPlaceholder(searchType){
            if(searchType == 'Shipments'){
                return 'Enter Booking ID, Reference ID, Order ID';
            }else if(searchType == 'Quotes'){
                return 'Enter Quotation Number';
            }else {
                return 'Enter Inquiry Number';
            }
        }

        function updateSearchValue(type){
          switch(type){
            case 'Shipments' :
                InquiryService.filterParams.search = "";
                QuotesService.filterParams.search = "";
                break;
            case 'Quotes' :
                ShipmentService.toolbarSearchText = "";
                InquiryService.filterParams.search = "";
                break;
            case 'Inquiry' :
                ShipmentService.toolbarSearchText = "";
                QuotesService.filterParams.search = "";
                break;
          }
        }

        // track mixpanel events
        function trackEvent(type) {
            if(type === "notification") {
                analytics.track("Global Notification");
            }

            if(type === "userIcon") {
                analytics.track("Global User Icon");
            }

            if(type === "profile") {
                analytics.track("My Profile");
            }

            if(type === "logout") {
                analytics.track("Logout");
            }
            if(type === "Bookings" && util.isEfpEnabled) {
                analytics.track("EFP-Nav-RequestBooking", {
                    mode: '',
                    source: "Manual"
                });
            }
        }

        function fnopenCreateQuote(ev , menu) {
            var isUnPaidModule = true;
         isUnPaidModule = util.fnDisableModule(ev ,menu );
         if(!isUnPaidModule ){
            $mdDialog.show({
              template:
              '<md-dialog  id="md-custom-light"  class="popup-sm md-custom-light-theme-dialog"><create-quote-dialog></create-quote-dialog></md-dialog> ',
              // '<md-dialog id="copy-quote" class="popup-sm create-template"> <create-template page-title="vm.pageTitle" type="vm.quoteType" template-name="vm.TemplateName" callback="vm.fnSaveTemplateName(data)"> </create-template> </md-dialog>',
              targetEvent: ev,
              clickOutsideToClose: true,
              parent: $rootElement,
              scope: $scope,
              preserveScope: true,
              controller: function () {
                this.parent = vm;
              },
              controllerAs: "ctrl",
            });
          }
          }

        function getCreateShipmentMenu(){
            var add_rate_menu = {
                label: 'Rates',
                subtext: '',
                svg_icon: 'assets/icons/custom/ic_local_atm_24px.svg',
                items: []
            }

            if((util.navPermission.addRate && util.navPermission.addRate[0]) || (util.navPermission.uploadRateSheet && util.navPermission.uploadRateSheet[0])){
                var isAddRates = (util.navPermission.addRate && util.navPermission.addRate[0]) ? 'Add rates' : '';
                var isUploadRates = (util.navPermission.addRate && util.navPermission.addRate[0]) ? 'upload sheets' : '';

                add_rate_menu.subtext += (isAddRates ? isAddRates : '') + (isAddRates && isUploadRates ? ' and ' : ' ') + (isUploadRates ? isUploadRates : '') + ' on the platform.';
                vm.createMenu.push(add_rate_menu);
            }

            if(util.navPermission.addRate && util.navPermission.addRate[0]){
                vm.createMenu[0].items.push({
                    label: 'Ratecard',
                    uisref: 'app.addRate',
                    name: 'addRate',
                    parent: navModuleList['addRate'].parent_title,
                    code: 'MY_RATES',
                    is_paid : util.createMenuNavList['myRates']
                });
            }
            if(util.navPermission.uploadRateSheet && util.navPermission.uploadRateSheet[0]){
                vm.createMenu[0].items.push({
                    label: 'Ratesheet',
                    uisref: 'app.uploadRateSheet',
                    name: 'uploadRateSheet',
                    parent: navModuleList['uploadRateSheet'].parent_title,
                    code: 'UPLOAD_RATE_SHEET',
                    is_paid : util.createMenuNavList['uploadRateSheet']
                })
            }
            if(util.navPermission.uploadRatesV2 && util.navPermission.uploadRatesV2[0]){
                vm.uploadRateFileBtn = { 
                    label: 'Upload Rate File',
                    uisref: 'app.uploadRatesV2',
                    svg_icon: 'assets/icons/custom/ic_local_atm_24px.svg',
                    name: "uploadRatesV2",
                    parent: navModuleList['uploadRatesV2'].parent_title,
                    code: "UPLOAD_RATES_V2",
                    is_paid: util.navPermission.uploadRatesV2
                };
            }
            if(util.navPermission.quotes && util.navPermission.quotes[0] && !util.isShipper){
                vm.createMenu.push( {
                    label: 'Quote',
                    svg_icon: 'assets/icons/custom/ic_description_24px.svg',
                    name: 'createQuote',
                    parent: navModuleList['createQuote'].parent_title,
                    code: 'QUOTES',
                    is_paid : util.createMenuNavList['quotes']
                })
            }
            if(util.navPermission.createShipment && util.navPermission.createShipment[0]){
                vm.createMenu.push({
                  label: "Booking",
                  uisref: !util.isEfpEnabled ? 'app.createShipment': 'app.createBooking',
                  svg_icon: "assets/icons/custom/ic_directions_boat_24px.svg",
                  name: "createShipment",
                  parent: navModuleList["createShipment"].parent_title,
                  code: "CREATE_SHIPMENT",
                  is_paid: util.createMenuNavList["createShipment"],
                });
            }
            
            vm.createMenu.forEach(function (obj,index) {
                if(obj.items && obj.items.length==1){
                    vm.createMenu[index] = obj.items[0];
                }
            })
            util.createMenuList = vm.createMenu;
            // return vm.createMenu;
            
        }

        function redirectToBasket(){
            var url = $state.href('app.basketModule');
            $window.open(url, '_blank');
        }
    }
 

})();

(function () {
  "use strict";

  angular.module("fuse").factory("util", utilService);

  /** @ngInject */
  function utilService(
    $mdToast,
    msNavigationService,
    localStorageService,
    $http,
    $location,
    $rootScope,
    $log,
    api,
    msUtils,
    local_host_name,
    $filter,
    analytics,
    $sanitize,
    $mdMedia,
    $state,
    navModuleList,
    customTheming,
    $interval,
    $mdPanel,
    $sce,
    $q
  ) {
    // Promise cache for getDomainData to prevent multiple simultaneous calls
    var domainDataPromise = null;
    var domainDataLoaded = false;
    var impersonatedDomainRequestId = 0;

    var util_service = {
      showToast: showToast,
      formLoadDetails: formLoadDetails,
      formAirLoadDetails: formAirLoadDetails,
      reduceContainerSize: reduceContainerSize,
      increaseContainerSize: increaseContainerSize,
      formFclSearchData: formFclSearchData,
      isObjectEmpty: isObjectEmpty,
      calTerminalDays: calTerminalDays,
      getStatus: getStatus,
      getCountries: getCountries,
      getProfile: getProfile,
      isSharedPage: isSharedPage,
      isSharedQuote: isSharedQuote,
      isResetPage: isResetPage,
      isWebView: isWebView,
      getQueryStringValue: getQueryStringValue,
      fclLoadObj: fclLoadObj,
      limitObj: [],
      ftlLimitObj: [],
      splitIntoArray: splitIntoArray,
      getStatusData: getStatusData,
      addLoad: addLoad,
      addLoadMaxKey: addLoadMaxKey,
      setLoadMaxValue: setLoadMaxValue,
      fnRemoveMaxKey: fnRemoveMaxKey,
      dateReplace: dateReplace,
      isIsoDate: isIsoDate,
      doorDropdownData: doorDropdownData,
      subDoorDropdownData: subDoorDropdownData,
      doorSelectedData: doorSelectedData,
      portSelectedData: portSelectedData,
      doorDropdownDataFtl: doorDropdownDataFtl,
      subDoorDropdownDataFtl: subDoorDropdownDataFtl,
      doorSelectedDataFtl: doorSelectedDataFtl,
      portSelectedDataFtl: portSelectedDataFtl,
      setWebViewAuthToken: setWebViewAuthToken,
      dateFormat: "yyyy-MM-dd",
      utcDateFormat: "YYYY-MM-DD HH:mm:ss",
      getNavList: getNavList,
      get_nav: [],
      state: [],
      checkState: checkState,
      isAdmin: false, //true if user type if admin 40
      isShipper: false, //true if user type if admin 11
      isFreightbro: false,
      navPermission: {},
      fnSetNavPermission: fnSetNavPermission,
      displayValidationError: displayValidationError,
      validateAnalyticData: validateAnalyticData,
      getRatesByLoad: getRatesByLoad,
      getCurrencyList: getCurrencyList,
      truncateText: truncateText,
      filterArrayOfString: filterArrayOfString,
      isMobileApp: false,
      isMobileDevice: msUtils.isMobile() != null,
      screenTitle: "Freightbro",
      isEfpEnabled:false,
      getDomainData: getDomainData,
      setImpersonatedDomain: setImpersonatedDomain,
      getDomainFlag: getDomainFlag,
      filterTmsIntegrationOptions: filterTmsIntegrationOptions,
      fnConvertQtyRem: fnConvertQtyRem,
      userProfile: {},
      user_id: "",
      redirectIfError: redirectIfError,
      redirectToErrorPage: redirectToErrorPage,
      currencyList: [],
      getBulletPontOnInput: getBulletPontOnInput,
      checkUserExit: checkUserExit,
      setMixpanelUser: setMixpanelUser,
      identifyMixpanel: identifyMixpanel,
      callMixpanel: callMixpanel,
      createUserData: createUserData,
      mixpanelUserData: {},
      fnGetColorBuStatusName: fnGetColorBuStatusName,
      textTruncate: textTruncate,
      forwarderCompany: "",
      fnGetForwarderIdApi: fnGetForwarderIdApi,
      getShipperList: getShipperList,
      getPorts: getPorts,
      delecteAssociates: delecteAssociates,
      delecteCardsOnId: delecteCardsOnId,
      imcoCodeList: imcoCodeList,
      getSubvendor: [],
      getAgents: [],
      getAirline: [],
      salesPersonList: [],
      stdTermsAndConditions: "",
      termsAndConditions: "",
      getProfitValue: getProfitValue,
      sanitizeText: sanitizeText,
      haulageList: ["rail", "road", "barge","truck", "unspecified", "not available"],
      sortSelectBox: sortSelectBox,
      isCallingApi: false,
      ratesUpdating: "",
      isXSScreen: $mdMedia("xs"),
      activatedTheme: "",
      solution_type: "",
      checkLocalStorageAuthToken: checkLocalStorageAuthToken,
      getLoadArrayFromParam: getLoadArrayFromParam,
      updateIfNotPresent: updateIfNotPresent,
      removeIfPresent: removeIfPresent,
      resizeScreen: resizeScreen,
      getStatusColor: getStatusColor,
      userLocation: {},
      getUserLocationData: getUserLocationData,
      getModuleMaxHeight: getModuleMaxHeight,
      shipperList: [],
      selectedSalesPerson: {},
      fnUserCategory: fnUserCategory,
      callerpIntegrationApi: callerpIntegrationApi,
      postErpIntegration: postErpIntegration,
      mappingCurrencyList: [],
      getMappingCurrencyList: getMappingCurrencyList,
      iframeHeight: {
        height: 600,
        "max-height": 600,
      },
      validateEmail: validateEmail,
      invalidEmail: false,
      duplicateEmail: false,
      // getCountries : [],
      rolesListObj: [],
      shipperCompanyObj: [],
      trackEvent: trackEvent,
      searchTextOption: searchTextOption,
      fnRestrictPageHeight: fnRestrictPageHeight,
      isModulePresent: isModulePresent,
      isGtmPushed: false,
      webViewObj: {},
      isDataPushed: false,
      pushGtm: pushGtm,
      pageOpenNewTab: pageOpenNewTab,
      searchHighlight: searchHighlight,
      formatLCLAIRLoad: formatLCLAIRLoad,
      cargowiseIntegration: cargowiseIntegration,
      mapPortData: mapPortData,
      getPincode: getPincode,
      redirectToExchangeRatesLink: redirectToExchangeRatesLink,
      removeBasis: removeBasis,
      formFtlSearchData: formFtlSearchData,
      redirectToBooking:redirectToBooking,
      createMenuList: [],
      nonSpecialCharacterRegex: "[a-zA-Z0-9()_+&/ -]", //it is customized special character restriction regExp. It will allow  ) , ( , - , _
      emailRegex:
        /^\w+(?:[._%+-][a-zA-Z0-9_]+)*@[a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z0-9-]{2,}$/,
      commonEmailRegex: /^[a-zA-Z0-9][a-zA-Z0-9._%+-]+$/,
      iframeOrigin: "rules", //while working on global create shipment/rate card/upload please change the "rules" string  to "localhost" for redirection purpose
      ckEditorConfig: {
        removePlugins: "iframe,flash,smiley,elementspath,maximize",
        removeButtons:
          "About,Image,Styles,Subscript,Superscript,Scayt,Source,Format,Strike,RemoveFormat,Blockquote,Cut,Copy,Paste,PasteText,PasteFromWord,Anchor,Table,HorizontalRule,SpecialChar",
        extraPlugins: "justify",
        versionCheck : false
      },
      TnCRemoveButtons:
        "About,Image,Styles,Subscript,Superscript,Scayt,Source,Format,Strike,RemoveFormat,Blockquote,Cut,Copy,Paste,PasteText,PasteFromWord,Anchor,HorizontalRule,SpecialChar",
      allInQuoteOptions: {
        all_in_total: "All in",
        legwise_total: "Leg Totals",
        default: "Default",
        default_without_total: "Details without Total",
        default_without_subtotal: "Details without Sub/Totals",
      },
      fnSetPanelPosition: fnSetPanelPosition,
      getIncotermList: getIncotermList,
      metricSystemConversion: metricSystemConversion,
      matricNumberObj: {
        unit_measurements: ["metric", "US", "UK"],
        number_formats: {
          "de-DE": {
            number_mask: "1.000.000,00 (German)",
          },
          "en-US": {
            number_mask: "1,000,000.00 (English)",
          },
          "en-IN": {
            number_mask: "1,00,00,000.00 (India)",
          },
        },
        units: {
          fcl: null,
          "SEA-LCL": {
            gross_weight: {
              US: {
                unit: "ST",
                conversionRate: 1.102,
              },
              UK: {
                unit: "LT",
                conversionRate: 0.984,
              },
              metric: {
                unit: "MT",
                conversionRate: 1,
              },
            },
            volumetric_weight: {
              US: {
                unit: "CFT",
                conversionRate: 35.3147,
              },
              UK: {
                unit: "CFT",
                conversionRate: 35.3147,
              },
              metric: {
                unit: "CBM",
                conversionRate: 1,
              },
            },
            chargeable_weight: {
              US: {
                unit: "W/M",
                conversionRate: 1,
              },
              UK: {
                unit: "W/M",
                conversionRate: 1,
              },
              metric: {
                unit: "W/M",
                conversionRate: 1,
              },
            },
          },
          AIR: {
            gross_weight: {
              US: {
                unit: "LB",
                conversionRate: 2.2046,
              },
              UK: {
                unit: "LB",
                conversionRate: 2.2046,
              },
              metric: {
                unit: "KG",
                conversionRate: 1,
              },
            },
            volumetric_weight: {
              US: {
                unit: "LB",
                conversionRate: 2.2046,
              },
              UK: {
                unit: "LB",
                conversionRate: 2.2046,
              },
              metric: {
                unit: "KG",
                conversionRate: 1,
              },
            },
            chargeable_weight: {
              US: {
                unit: "KG",
                conversionRate: 1,
              },
              UK: {
                unit: "KG",
                conversionRate: 1,
              },
              metric: {
                unit: "KG",
                conversionRate: 1,
              },
            },
          },
        },
      },
      // getMatricJson: getMatricJson,
      // matricNumberObj : null,
      v2IncotermList: [],

      // setting allin quote value as "default"
      all_in_quote: "default",
      fnDisableModule: fnDisableModule,
      futureNav: [],
      paidModuleState: [],
      paidModuleList: [],
      isModulePaid: isModulePaid,
      fnLoopNavigation: fnLoopNavigation,
      fnReDirectToHome: fnReDirectToHome,
      isString: isString,
      matchArray: [],
      grossWeightUnit: {
        AIR: "KG",
        "SEA-LCL": "MT",
      },
      volumetricWeightUnit: {
        AIR: "KG",
        "SEA-LCL": "CBM",
      },
      chargeableUnit: {
        AIR: "KG",
        "SEA-LCL": "W/M",
      },
      co2ApiLoaded: true,
      fnFreeDaysValidation: fnFreeDaysValidation,
      routeKeys: ["origin", "destination"],
      freeDaysKeys: [
        "detention",
        "demurrage",
        "combined",
        "storage",
        "demurageAndStorage",
        "combinedAndStorage",
      ],
      fnCheckLoadExpiryLength: fnCheckLoadExpiryLength,
      storeOldData: storeOldData,
      fnSetFreeDays: fnSetFreeDays,
      getFreeDaysValue: getFreeDaysValue,
      getFormatedData: getFormatedData,
      fillLoadArray: fillLoadArray,
      isFreeDaysEmpty: isFreeDaysEmpty,
      fnGetPolPod: fnGetPolPod,
      fnGetNearby:fnGetNearby,
      standardQuotationData: null,
      isOwnVendorRate: isOwnVendorRate,
      fnOpenCommentPanel: fnOpenCommentPanel,
      chargeMapping: chargeMapping,
      getChargeMappingList: getChargeMappingList,
      getAgentsData: getAgentsData,
      getDomainList : getDomainList,
    

      agentList: [],
      _mdPanel: $mdPanel,
      carrierData: {
        mode: "",
        data: [],
      },
      airlineData: {
        data: [],
      },
      fnOpenStatusChangePanel: fnOpenStatusChangePanel,
      fnSetStatusColor: fnSetStatusColor,
      colorCodeObj: {
        Active: {
          color: "#1E40AF",
          "bg-color": "#BFDBFE",
          "border-color": "#1E40AF",
        },
        "Follow-up Required": {
          color: "#92400E",
          "bg-color": "#FDE68A",
          "border-color": "#F59E0B",
        },
        Lost: {
          color: "#6B7280",
          "bg-color": "#E5E7EB",
          "border-color": "#9CA3AF",
        },

        Won: {
          color: "#065F46",
          "bg-color": "#A7F3D0",
          "border-color": "#10B981",
        },
        Expired: {
          color: "#9F1239",
          "bg-color": "#FECDD3",
          "border-color": "#F43F5E",
        },
        "Booking Placed": {
          color: "#065F46",
          "bg-color": "#A7F3D0",
          "border-color": "#10B981",
        },
      },
      disableParentOnSelfOnboarding : ["Manage Rates" , "Contract Rates", "Contract Manager","Maintain Rates","Rates"],
      addPackageModule : addPackageModule,
      getOrigin:getOrigin,
      getDestination:getDestination,
      oneQuoteData:{},
      bookingData:{},
      applyBookingBridgePayload:applyBookingBridgePayload,
      redirectToOneQuote:redirectToOneQuote,
      getSearchParamOrigin:getSearchParamOrigin,
      getSearchParamDestination:getSearchParamDestination,
      ResultPageDataBrainReport : [],
      fnCopyID:fnCopyID ,
      uploadRatesAction : '',
      escapeHtml: escapeHtml,
      sanitizeUrl:sanitizeUrl,
      sanitizeQueryParams:sanitizeQueryParams,
      decodeValue: decodeValue,
      encodeValue: encodeValue,
      showRateIdForContract:showRateIdForContract,
      checkKeyPresent:checkKeyPresent
    };
    $rootScope.getDomainFlag = getDomainFlag;
    return util_service;

    /**
     * function to show toast message
     * @param {*} message
     * @param {*} position
     */
    function showToast(message, position, delay) {
      position = position || "top right";
      delay = delay || 3000;

      $mdToast.show(
        $mdToast
          .simple()
          .textContent(message)
          .position(position)
          .hideDelay(delay)
      );
    }



    function textTruncate(string, length) {
      var myTruncatedString = string.substring(0, length);
      return myTruncatedString + "...";
    }

    function getUserLocationData() {
      var settings = {
        async: true,
        url: "https://ipapi.co/json/",
        method: "GET",
      };
      return $.ajax(settings)
        .done(function (response) {
          util_service.userLocation = response;
        })
        .fail(function (error) {
          util_service.userLocation.country = "IN";
          $log.error(error);
        });
    }


    function isIsoDate(str) {
      if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) {
        return true;
      }else {
        return false;
      }
    }
    // ** make sure to pass date+time format to following function
    function dateReplace(data) {
      var result = data;
      // if(util_service.isIsoDate(data)){
      if(/Z$/.test(result)){
        result = new Date(data).toISOString().replace('Z', '');
      }
      return result;
    }

    // set the fcl load
    function formFclSearchData(search_param_load, container) {
      search_param_load.load_details_value = [];
      angular.forEach(container, function (value, key) {
        value.count = value.qty ? value.qty : value.count;
        var temp_unit = angular.copy(value.weight_qty);
        if (value.count > 0) {
          var load_obj = {
            qty: value.count,
            bl_qty: value.bl_qty ? value.bl_qty : 1,
            sbl_qty: value.sbl_qty ? value.sbl_qty : 1,
            type: value.type,
            teu: value.teu ? value.teu : 1,
            load_metrics: Array(value.count).fill({
              // dynamically initializing array metrics with fixed value
              weight_qty: temp_unit ? temp_unit : 20000,
              weight_unit: temp_unit ? value.weight_unit : "KGs",
              volume_qty: 0,
              volume_unit: "CBM",
            }),
          };
          search_param_load.load_details_value.push(load_obj);
        }
      });
      return search_param_load;
    }

    function formFtlSearchData(loads,containerLoad){
          loads.forEach(function(data){
            if (containerLoad.type=== data.code) {
               containerLoad['teu']=data.teu;
               containerLoad['sequence']=data.sequence
            }
          });  
          return containerLoad;
    }

    function getLoadArrayFromParam(loadData) {
      var loadArray = [];
      loadData.forEach(function (load) {
        loadArray[loadArray.length] = {
          type: load.type,
          count: load.qty,
          bl_qty: load.bl_qty,
          sbl_qty: load.sbl_qty,
          max_weight: "",
          weight_qty: load.load_metrics[0].weight_qty,
          weight_unit: "KGs",
          max_volume: "",
        };
      });
      return loadArray;
    }

    //object for fcl Load container add/remove
    function fclLoadObj(loadConfig) {
      var fcl_load_param = [];
      if (loadConfig && loadConfig.length) {
        angular.forEach(loadConfig, function (item) {
          var loadObj = {
            type_alias: item.load_description,
            type: item.load_code,
            count: 0,
            max_weight: "",
            max_volume: "",
            weight_qty: 0,
            weight_unit: "Tons",
          };
          fcl_load_param.push(loadObj);
        });
      } else {
        fcl_load_param = [
          {
            type_alias: "20",
            type: "20GP",
            count: 0,
            max_weight: "",
            max_volume: "",
            weight_qty: 0,
            weight_unit: "Tons",
          },
          {
            type_alias: "40",
            type: "40GP",
            count: 0,
            max_weight: "",
            max_volume: "",
            weight_qty: 0,
            weight_unit: "Tons",
          },
          {
            type_alias: "40HC",
            type: "40HC",
            count: 0,
            max_weight: "",
            max_volume: "",
            weight_qty: 0,
            weight_unit: "Tons",
          },
          {
            type_alias: "45HC",
            type: "45HC",
            count: 0,
            max_weight: "",
            max_volume: "",
            weight_qty: 0,
            weight_unit: "Tons",
          },
        ];
      }
      return fcl_load_param;
    }

    function isSharedPage() {
      var url = sanitizeQueryParams(window.location.href);

      if (
        url.split("uuid")[1] !== "" &&
        url.split("uuid")[1] !== "/" &&
        url.split("uuid")[1] !== undefined
      ) {
        return true;
      } else {
        return false;
      }
    }

    function isResetPage() {
      var url = sanitizeQueryParams(window.location.href);

      if (
        (url.split("password/reset")[1] !== "" &&
          url.split("password/reset")[1] !== "/" &&
          url.split("password/reset")[1] !== undefined) ||
        (url.split("password/generate")[1] !== "" &&
          url.split("password/generate")[1] !== "/" &&
          url.split("password/generate")[1] !== undefined)
      ) {
        return true;
      } else {
        return false;
      }
    }

    function isSharedQuote() {
      var url = sanitizeQueryParams(window.location.href);

      if (
        url.split("shared/")[1] !== "" &&
        url.split("shared/")[1] !== "/" &&
        url.split("shared/")[1] !== undefined
      ) {
        return true;
      } else {
        return false;
      }
    }

    function getQueryStringValue(key) {
      return decodeURIComponent(
        window.location.search.replace(
          new RegExp(
            "^(?:.*[&\\?]" +
              encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
              "(?:\\=([^&]*))?)?.*$",
            "i"
          ),
          "$1"
        )
      );
    }

    function isWebView() {
      var url = sanitizeQueryParams(window.location.href);

      if (
        url.split("web_view")[1] !== "" &&
        url.split("web_view")[1] !== "/" &&
        url.split("web_view")[1] !== undefined
      ) {
        return true;
      } else {
        return false;
      }
    }

    function addLoadMaxKey(load_details_value) {
      for (var i = 0; i < load_details_value.length; i++) {
        angular.forEach(
          load_details_value[i].load_metrics,
          function (item, index) {
            item["max_volume_cbm"] = null;
            item["max_volume_cft"] = null;
            item["max_weight_kgs"] = null;
            item["max_weight_ton"] = null;

            util_service.setLoadMaxValue(
              load_details_value[i],
              index,
              "volume"
            );
            util_service.setLoadMaxValue(
              load_details_value[i],
              index,
              "weight"
            );
          }
        );
      }
      return load_details_value;
    }

    function addLoad(data) {
      var loadObj = {
        weight_qty: 0,
        weight_unit: "KGs",
        volume_qty: 0,
        volume_unit: "CBM",
        max_volume_cbm: null,
        max_volume_cft: null,
        max_weight_kgs: null,
        max_weight_ton: null,
      };

      data.load_metrics.push(loadObj);
      data.qty = parseInt(data.qty) + 1;

      util_service.setLoadMaxValue(
        data,
        data.load_metrics.length - 1,
        "volume"
      );
      util_service.setLoadMaxValue(
        data,
        data.load_metrics.length - 1,
        "weight"
      );
      return data;
    }

    function setLoadMaxValue(item, index, checkName) {
      var matrixObj = item.load_metrics[index];
      var result = util_service.limitObj.find(function (limit) {
        return limit.load_code === item.type;
      });

      if (checkName === "volume") {
        matrixObj.max_volume_cbm = result ? result["CBM"] : "";
        matrixObj.max_volume_cft = result ? result["CFT"] : "";
      } else {
        matrixObj.max_weight_kgs = result ? result["KGS"] : "";
        matrixObj.max_weight_ton = result ? result["TON"] : "";
      }
    }

    function fnRemoveMaxKey(tempLoad) {
      var load = angular.copy(tempLoad);
      for (var i = 0; i < load.load_details_value.length; i++) {
        delete load.load_details_value[i]["$$hashKey"];
        for (
          var j = 0;
          j < load.load_details_value[i].load_metrics.length;
          j++
        ) {
          delete load.load_details_value[i].load_metrics[j]["max_volume_cbm"];
          delete load.load_details_value[i].load_metrics[j]["max_volume_cft"];
          delete load.load_details_value[i].load_metrics[j]["max_weight_kgs"];
          delete load.load_details_value[i].load_metrics[j]["max_weight_ton"];
        }
      }
      return load;
    }

    //string to array convert
    function splitIntoArray(data) {
      var numberArray = [];
      for (var i = 0; i < data.length; i++) {
        numberArray.push(parseInt(data.charAt(i)));
      }
      return numberArray;
    }

    /**
     * function to form load details
     * @param {*} fcl_loadDetails
     */
    function formLoadDetails(load_data, list) {
      var response = "";
      if (load_data != null) {
        var length = load_data.load_details_value.length;
        if (length > 0 && list !== "listPage") {
          load_data.load_details_value.map(function (item, index) {
            response +=
              item.type +
              " x " +
              item.qty +
              (length - 1 === index ? " " : " , ");

            // response +=  item.type + ' x ' + item.qty + ' - ' + ( item.load_metrics[0].weight_qty * item.qty ) + item.load_metrics[0].weight_unit + ( (length-1) === index ? ' ' : ' | '  );
          });
        } else {
          response =
            load_data.load_details_value[0].type +
            " x" +
            (load_data.load_details_value[0].qty || 0) +
            (load_data.load_details_value.length > 1
              ? "  +" + (load_data.load_details_value.length - 1)
              : "");
        }
      }
      return response;
    }

    //function to form air/lcl load details
    function formAirLoadDetails(loadDetails, mode, page) {
      // get matric base conversion
      var convertedLoad = util_service.metricSystemConversion(mode, loadDetails);

      var response =
        "Gross Wt : " +
        (loadDetails.load_meta.gross_weight != null

          ?          $filter("currencyMask")($filter("weightUnit")(loadDetails.load_meta.gross_weight, 'gross_weight',mode),2)

          : "N/A") +
          " " +
        (mode == "AIR" || ( mode == 'SEA-LCL' && $rootScope.domainData.domain_info.WEIGHT_UNIT &&$rootScope.domainData.domain_info.WEIGHT_UNIT[mode] &&$rootScope.domainData.domain_info.WEIGHT_UNIT[mode].gross_weight.toLowerCase() == 'kg') ? 'KG' : 'MT') +
        ($rootScope.metric_system!='metric' ? ' / '+ $filter("currencyMask")(convertedLoad.gross_weight.value, 2) + " " + (convertedLoad.gross_weight.unit) : "") +
          
        " | Volumetric Wt : " +
        (loadDetails.load_meta.volumetric_weight != null
          ? $filter("currencyMask")(loadDetails.load_meta.volumetric_weight, 2)
          : "N/A") +
        " " +
        (mode == "AIR" ? 'KG': 'CBM') +
        ($rootScope.metric_system!='metric' ? ' / '+ $filter("currencyMask")(convertedLoad.volumetric_weight.value, 2) + " " + (convertedLoad.volumetric_weight.unit) : "");

      var chargeable_Weight =
        " | Chargeable Wt : " +
        (loadDetails.load_meta.chargeable_weight != null
          ? $filter("currencyMask")(loadDetails.load_meta.chargeable_weight, 2)
          : "N/A") +
        " " + 
        (mode == "AIR" ? 'KG': 'W/M');
        

      response += mode == "AIR" && page != "shipment" ? "" : chargeable_Weight;

      return response;
    }

    // DEV-7844 user base matric system conversion
    function metricSystemConversion(mode, load){
      var loadDetails = angular.copy(load);
      if(mode==='SEA-FCL'){
        return;
      }
      var gross_weight = loadDetails.load_meta.gross_weight * util_service.matricNumberObj.units[mode].gross_weight[$rootScope.metric_system].conversionRate;
      var result = {
        'gross_weight': {
            'unit' : util_service.matricNumberObj.units[mode].gross_weight[$rootScope.metric_system].unit,
            'value' : mode == 'SEA-LCL' && $rootScope.domainData.domain_info.WEIGHT_UNIT && $rootScope.domainData.domain_info.WEIGHT_UNIT[mode] && $rootScope.domainData.domain_info.WEIGHT_UNIT[mode].gross_weight.toLowerCase() == 'kg'  ? gross_weight / 1000:  gross_weight ,
        },
        'volumetric_weight': {
            'unit' : util_service.matricNumberObj.units[mode].volumetric_weight[$rootScope.metric_system].unit,
            'value' : loadDetails.load_meta.volumetric_weight * util_service.matricNumberObj.units[mode].volumetric_weight[$rootScope.metric_system].conversionRate,
        },
        'chargeable_weight': {
            'unit' : util_service.matricNumberObj.units[mode].chargeable_weight[$rootScope.metric_system].unit,
            'value' : loadDetails.load_meta.chargeable_weight * util_service.matricNumberObj.units[mode].chargeable_weight[$rootScope.metric_system].conversionRate,
        }
      }

      return result;
  }


    // start edit fcl search modal
    function reduceContainerSize(fcl_load_details, type) {
      for (var i = 0; i < fcl_load_details.length; i++) {
        if (fcl_load_details[i].type === type) {
          if (fcl_load_details[i].count > 0) {
            fcl_load_details[i].count = fcl_load_details[i].count - 1;
          }
        }
      }
      return fcl_load_details;
    }

    //increase conatiner size
    function increaseContainerSize(fcl_load_details, type) {
      for (var i = 0; i < fcl_load_details.length; i++) {
        if (fcl_load_details[i].type === type) {
          if (fcl_load_details[i].count < 100) {
            fcl_load_details[i].count = fcl_load_details[i].count + 1;
          }
        }
      }
      return fcl_load_details;
    }

    /**
     * check object not empty
     * @param {*} carr_schedule
     */
    function isObjectEmpty(carr_schedule) {
      if (Object.keys(carr_schedule).length) {
        return true;
      } else {
        return false;
      }
    }

    /**
     * function to calculate schedule track days between port
     */
    function calTerminalDays(departure, arrival) {
      if (!departure || !arrival) {
        return;
      }

      var a = moment(moment.utc(arrival).local());
      var b = moment(moment.utc(departure).local());
      var diffDays = a.diff(b, "days"); // 1
      return diffDays;
    }

    /**
     * get min special remaining qty
     * @param {*} item
     */
    function fnConvertQtyRem(item) {
      var qtyRem = angular.copy(item);
      if (qtyRem != null && typeof qtyRem !== "string") {
        angular.forEach(qtyRem, function (value, key) {
          if (value == 0) {
            delete qtyRem[key];
          }
        });

        if (Object.keys(qtyRem).length) {
          var arr = Object.keys(qtyRem).map(function (key) {
            return qtyRem[key];
          });
          var min = Math.min.apply(null, arr);
          return min;
        } else {
          return 0;
        }
      } else {
        return null;
      }
    }

    /**
     * function to get the ststus of card used in quote searched result
     * @param {*} expiryDate
     */
    function getStatus(quoteData) {
      var expiry = new Date(quoteData.expiry);
      var todays = new Date().setHours(0, 0, 0);
      var statusResult = "";

      if (todays <= expiry) {
        if (
          quoteData.leg_code == "l3_fcl" &&
          quoteData.is_special &&
          util_service.fnConvertQtyRem(
            quoteData.special_meta.special_qty_rem
          ) != null &&
          util_service.fnConvertQtyRem(
            quoteData.special_meta.special_qty_rem
          ) <= 0
        ) {
          statusResult = "expired-bg expired-fg";
        } else {
          if (quoteData.manual == 1) {
            statusResult = "new-bg new-fg";
          } else {
            statusResult = "active-bg active-fg";
          }
        }
      } else {
        statusResult = "expired-bg expired-fg";
      }
      return statusResult;
    }

    /**
     * function to set the expiry date
     * @param {*} expiryDate
     */
    function getStatusData(quoteData) {
      var expiry = quoteData.expiry ? new Date(util_service.dateReplace(quoteData.expiry)):new Date().setHours(0,0,0,0) ;
     // var expiry = new Date(quoteData.expiry);
       var todays = new Date().setHours(0,0,0,0)
      var statusResult = "";

      if (todays <= expiry) {
        if (quoteData.leg_code == "l3_fcl" && quoteData.is_special && 
        util_service.fnConvertQtyRem(quoteData.special_meta.special_qty_rem) != null && 
        util_service.fnConvertQtyRem(quoteData.special_meta.special_qty_rem) <= 0) {
          statusResult = "EXPIRED";
        } else {
          if (quoteData.manual == 1) {
            statusResult = "NEW";
          } else {
            statusResult = "ACTIVE";
          }
        }
      } else {
        statusResult = "EXPIRED";
      }
      return statusResult;
    }

    function getProfile() {
      var getProfileUrl = "";
      var token = localStorageService.get("authToken");
     
      var user_modules = token && token.value.user_modules ? token.value.user_modules : "";
      if (isSharedPage()) {
                var url = sanitizeQueryParams(window.location.href);
        var uuid = url.split("uuid")[1];
        getProfileUrl =
          api.baseUrl +
          "/shared/" +
          uuid.split("/")[1] +
          "/profile/" +
          uuid.split("/")[3];
        return $http.get(getProfileUrl).then(
          function (response) {
            util_service.userProfile = response.data.data;
            
               // for settinng unit and metric in rootscope
               $rootScope.metric_system=  response.data.data.user.metric_system?response.data.data.user.metric_system:$rootScope.metric_system;
               $rootScope.number_format=response.data.data.user.number_format?response.data.data.user.number_format:$rootScope.number_format;
               $rootScope.precision_decimals=response.data.data.user.precision_decimals?response.data.data.user.precision_decimals:$rootScope.precision_decimals;
            util_service.solution_type =
              util_service.userProfile.user["solution_type"] || "";
            if (
              util_service.userProfile.user.type &&
              util_service.userProfile.user.type.user_category
            ) {
              util_service.fnUserCategory(
                util_service.userProfile.user.type.user_category
              );
              mappingUserInfo(user_modules, util_service.userProfile);
            }
            return response.data.data;
          },
          function (error) {
            $log.error(error);
          }
        );
      } else if (isWebView()) {
        getProfileUrl = api.baseUrl + "/api/profile/" + util_service.user_id;
        return $http.get(getProfileUrl).then(
          function (response) {
               // for settinng unit and metric in rootscope
               
               $rootScope.metric_system=  response.data.user.metric_system?response.data.user.metric_system:$rootScope.metric_system;
               $rootScope.number_format=response.data.user.number_format?response.data.user.number_format:$rootScope.number_format;
               $rootScope.precision_decimals=response.data.user.precision_decimals?response.data.user.precision_decimals:$rootScope.precision_decimals;
            util_service.userProfile = response.data;
            util_service.solution_type =
              util_service.userProfile.user.solution_type;
            util_service.fnUserCategory(
              util_service.userProfile.user.type.user_category
            );
            mappingUserInfo(user_modules, util_service.userProfile);
            return response.data;
          },
          function (error) {
            $log.error(error);
          }
        );
      } else {
        if (token != null && !!token.value) {
          util_service.solution_type =
            localStorageService.get("authToken").value.SOLUTION_TYPE;
          getProfileUrl =
            api.baseUrl +
            "/api/profile/" +
            localStorageService.get("authToken").value.user_id;
          return $http.get(getProfileUrl).then(
            function (response) {
              util_service.userProfile = response.data;
  
              // for settinng unit and metric in rootscope
              $rootScope.metric_system=  response.data.user.metric_system?response.data.user.metric_system:$rootScope.metric_system;
              $rootScope.number_format=response.data.user.number_format?response.data.user.number_format:$rootScope.number_format;
              $rootScope.precision_decimals=response.data.user.precision_decimals?response.data.user.precision_decimals:$rootScope.precision_decimals;
              util_service.solution_type =
                util_service.userProfile.user.solution_type;
              mappingUserInfo(user_modules, util_service.userProfile);
              return response.data;
            },
            function (error) {
              $log.error(error);
            }
          );
        } else {
          $state.go("app.pages_auth_login-v2");
        }
      }
    }

    function fnSetNavPermission(name, permissions) {
      util_service.navPermission[name] = util_service.splitIntoArray(permissions);
    }

    //create dynamic navigation menu
    function getNavList(user_category) {
      util_service.state = [];
      util_service.createMenuNavList = [];
      var shipperList = [
        "search",
        "uploadRatesV2",
        "quotes",
        "shipments",
        "profile",
        "users",
        "inquiry",
        "dashboard",
        "rules",
        "pricingRules",
        "currencySetting",
        "manageRates",
        "teams",
        "tags",
        "companyInformation",
        "assignShippers",
        "roles",
        "myRates",
        "reports",
        "lclMatrixView",
        "myRatesV2",
        "tariffHeader"
       
      ];
      var forwarderList = [
        "search",
        "uploadRatesV2",
        "myRatesV2",
        "tariffHeader",
        "quotes",
        "shipments",
        "shippers",
        "agents",
        "users",
        "profile",
        "dashboard",
        "rates",
        "inquiry",
        "rules",
        "pricingRules",
        "currencySetting",
        "manageRates",
        "teams",
        "companyGroups",
        "tags",
        "companyInformation",
        "assignShippers",
        "roles",
        "configuration",
        "contractManager",
        "myRates",
        "dauFclLeg",
        "bulkUpdate",
        "auditTrail",
        "reports",
        "manageNotification",
        "bannerBroadcast",
        "cdmAuditTrail",
        "cdmDownloadContracts",
        "carrierIntegration",
        "lclMatrixView",
        "charges",
        "partnerRateManagement",
        "pdfConfigurations"
      ];
      var freightbroList = [
        "search",
        "uploadRatesV2",
        "myRatesV2",
        "tariffHeader",
        "quotes",
        "shipments",
        "forwarders",
        "forwarderOffices",
        "shippers",
        "agents",
        "users",
        "profile",
        "dashboard",
        "rates",
        "inquiry",
        "rules",
        "pricingRules",
        "currencySetting",
        "manageRates",
        "teams",
        "companyGroups",
        "tags",
        "companyInformation",
        "assignShippers",
        "roles",
        "configuration",
        "contractManager",
        "myRates",
        "dauFclLeg",
        "bulkUpdate",
        "auditTrail",
        "reports",
        "manageNotification",
        "bannerBroadcast",
        "cdmAuditTrail",
        "cdmDownloadContracts",
        "carrierIntegration",
        "lclMatrixView",
        "forwarderAssignment",
        "partnerRateManagement",
        "pdfConfigurations"
      ];
      
      util_service.get_nav = localStorageService.get("authToken").value.user_modules;
      util_service.fnUserCategory(user_category);

      util_service.navPermission["FCL"] = [0, 0, 0, 0];
      util_service.navPermission["LCL"] = [0, 0, 0, 0];
      util_service.navPermission["AIR"] = [0, 0, 0, 0];
      util_service.navPermission["TRACK_SEA"] = [0, 0, 0, 0];
      util_service.navPermission["TRACK_AIR"] = [0, 0, 0, 0];
      util_service.navPermission["track-n-trace"] = [0, 0, 0, 0];
      util_service.navPermission["createShipment"] = [0, 0, 0, 0];
      util_service.navPermission["scheduleSearch"] = [0, 0, 0, 0];
      util_service.navPermission["IMPORT_USERS"] = [0, 0, 0, 0];
      util_service.navPermission["IMPORT_SHIPPERS"] = [0, 0, 0, 0];
      util_service.navPermission["LCL_MATRIX_VIEW"] = [0, 0, 0, 0];
      util_service.navPermission["tariffAmendment"] = [0, 0, 0, 0];
      util_service.navPermission["EXPORT_USERS"] = [0, 0, 0, 0];
      util_service.navPermission["EXPORT_SHIPPERS"] = [0, 0, 0, 0];
      util_service.navPermission["MANAGE_TARGET_RATES"] = [0, 0, 0, 0];
      util_service.navPermission["partnerRateManagement"] = [0, 0, 0, 0];

      util_service.futureNav =[];
      if (util_service.isShipper) {
        util_service.futureNav = shipperList;
      } else if (util_service.isFreightbro) {
        util_service.futureNav = freightbroList;
      } else if (util_service.isAdmin) {
        util_service.futureNav = forwarderList;
      }

      util_service.matchArray = [];
      var moduleArray = ['addRate','cdmAuditTrail','cdmDownloadContracts'];
      util_service.addPackageModule(moduleArray);
      
      util_service.fnLoopNavigation();

    }

    function addPackageModule(moduleArray){
     

      var presentedModule = util_service.get_nav.filter(function (item) {
        return (moduleArray.includes(item.name));
      });
      
      if(presentedModule && presentedModule.length){
        angular.forEach(presentedModule, function (value) {
          var indexRate = util_service.get_nav.indexOf(value);
          util_service.get_nav.splice(indexRate, 1);
        });
      }

      var newModuleName = [];
      var newModuleArray = [];
      for (var i = 0; i < util_service.get_nav.length; i++) {

        if (util_service.get_nav[i].name == "myRates" && util_service.splitIntoArray(util_service.get_nav[i].permissions)[0] == 1 ) {
          util_service.fnSetNavPermission('addRate', util_service.get_nav[i].permissions);
          newModuleName.push('addRates');
        }
        if ( util_service.get_nav[i].name == "contractManager" && util_service.splitIntoArray(util_service.get_nav[i].permissions)[0] == 1 ) {
          util_service.fnSetNavPermission('cdmAuditTrail', util_service.get_nav[i].permissions);
          newModuleArray.push({ 
            "code": "CDM_AUDIT_TRAIL",
            "icon": null,
            "name": "cdmAuditTrail",
            "permissions": util_service.get_nav[i].permissions,
            "title": "Audit Managed Contracts",
            "is_paid": util_service.get_nav[i].is_paid
          });
          newModuleName.push('cdmAuditTrail');
          util_service.fnSetNavPermission('cdmDownloadContracts', util_service.get_nav[i].permissions);
          newModuleArray.push({ 
            "code": "CDM_DOWNLOAD_CONTRACT",
            "icon": null,
            "name": "cdmDownloadContracts",
            "permissions": util_service.get_nav[i].permissions,
            "title": "Download Contracts",
            "is_paid": util_service.get_nav[i].is_paid
          });
          newModuleName.push('cdmDownloadContracts');
        }
          if(util_service.get_nav[i].name == "tariffFile" ){
            util_service.fnSetNavPermission('uploadRatesV2', util_service.get_nav[i].permissions);
            util_service.fnSetNavPermission('myRatesV2', util_service.get_nav[i].permissions);
            newModuleArray.push({ 
              "code": "MY_RATES_V2",
              "icon": null,
              "name": "myRatesV2",
              "permissions": util_service.get_nav[i].permissions,
              "title": "My Rate Files",
              "is_paid": util_service.get_nav[i].is_paid
            });
            newModuleName.push('myRatesV2');
        }
        

        if (util_service.futureNav.indexOf(util_service.get_nav[i].name) !== -1) {
          util_service.matchArray.push(util_service.get_nav[i].name);
        }
      }

      if (newModuleName.length) {
        util_service.get_nav = util_service.get_nav.concat(newModuleArray);
        util_service.matchArray = util_service.matchArray.concat(newModuleName);

        var NewAuthValue = localStorageService.get("authToken").value;
        NewAuthValue.user_modules = util_service.get_nav;
        localStorageService.set("authToken", NewAuthValue);
      }
    }


    function fnLoopNavigation(){
      util_service.paidModuleState = [];
      util_service.paidModuleList = [];

      // Form arrays from predefined list items
      var companyArray = [];
      var rateArray = [];
      var settingArray = [];
      var modifyRatesArray = [];
      var contractArray = [];
      var cdmArray = [];
      for (var i = 0; i < util_service.matchArray.length; i++) {
        // Form My company array from matched array list
        if (util_service.matchArray[i] === "forwarders" ||
          util_service.matchArray[i] === "forwarderOffices" ||
          util_service.matchArray[i] === "shippers" ||
          util_service.matchArray[i] === "users" ||  util_service.matchArray[i] === "agents" ||
          util_service.matchArray[i] === "manageNotification" ||   util_service.matchArray[i] === "bannerBroadcast" ||
          util_service.matchArray[i] === "carrierIntegration") {
          companyArray.push(util_service.matchArray[i]);
        }
        // Form Manage Rates array from matched array list
        if ( util_service.matchArray[i] === "currencySetting" ||
          util_service.matchArray[i] === "manageRates" ||
          util_service.matchArray[i] === "rates" ||
          util_service.matchArray[i] === "rules" ||
          util_service.matchArray[i] === "forwarderAssignment" ||
          util_service.matchArray[i] === "partnerRateManagement") {
          rateArray.push(util_service.matchArray[i]);
        }
        // Form Settings array from matched array list
        if ( util_service.matchArray[i] === "configuration" ||
          util_service.matchArray[i] === "teams" ||
          util_service.matchArray[i] === "tags" ||
          util_service.matchArray[i] === "assignShippers" ||
          util_service.matchArray[i] === "roles" ) {
          settingArray.push(util_service.matchArray[i]);
        }
        if( util_service.matchArray[i] === "dauFclLeg" ||
          util_service.matchArray[i] === "bulkUpdate" || 
          util_service.matchArray[i] === "auditTrail" ){
          modifyRatesArray.push(util_service.matchArray[i]);
        }
        if( util_service.matchArray[i] === "contractManager" ){
          cdmArray.push(util_service.matchArray[i]);
        }
        if(util_service.matchArray[i] === "myRates"|| util_service.matchArray[i] === "myRatesV2" || util_service.matchArray[i] === "tariffHeader")
        {
          contractArray.push(util_service.matchArray[i]);
        }
      }

      if (settingArray.length || rateArray.length) {
        companyArray.length += settingArray.length && rateArray.length ? 2 : 1;
      }
      angular.forEach(util_service.get_nav, function (value) {

        if(util_service.get_nav[0].hasOwnProperty('is_paid') && value.is_paid == true){
          util_service.paidModuleList.push(value.name);
        }
       
        if ( value.name != null && value.name !== "" && util_service.futureNav.includes(value.name) && value.name !== "profile" ) {
          // Adding pages to redirect
          if(util_service.get_nav[0].hasOwnProperty('is_paid') && value.is_paid == true){
            util_service.paidModuleState.push(value.name);
          }
          
          util_service.state.push(value.name);
          util_service.fnSetNavPermission(value.name, value.permissions);
          var parent_title = navModuleList[value.name] ? (navModuleList[value.name].parent_title ? navModuleList[value.name].parent_title + "." : "") : value.parent_title;
          var nav_weight = navModuleList[value.name] ? navModuleList[value.name].weight : 2;

          // var displayTitle = value.title;
          // if (value.name === 'charges') {
          //   displayTitle = 'Charge Management';
          // }

          // if parent title matches My Company & Rate mgmt
          if ( parent_title === "My Company.Settings." || parent_title === "My Company." ) {
            switch (true) {
              case settingArray.length == 1:
                parent_title = "My Company.";
                break;

              case (settingArray.length == 1) && companyArray.length == 1:
                parent_title = "";
                break;

              case settingArray.length == 1 && parent_title === "My Company.Settings.":
                parent_title = "My Company.";

              case settingArray.length >= 1 && parent_title === "My Company.Settings.":
                if (companyArray.length == 1) {
                  parent_title = "Settings.";
                }

                break;
            }
          }
          //if Manage Rates menu have only one submenu
          if(parent_title=="Manage Rates." && rateArray.length==1 && contractArray.length == 0 && modifyRatesArray.length == 0){
            parent_title="";
          }
          //if Maintain Rates menu have only one submenu
          if(parent_title=="Manage Rates.Contract Rates." && contractArray.length == 1 && modifyRatesArray.length == 0){
            if(rateArray.length==0){
              parent_title = "";
            }else{
              parent_title = "Manage Rates.";
            }
          }
          if(parent_title=="Manage Rates.Contract Rates.Maintain Rates." && modifyRatesArray.length == 1){
            if(contractArray.length == 0){
              if(rateArray.length==0){
                parent_title = "";
              }else{
                parent_title = "Manage Rates.";
              }
            }
            else{
              parent_title = "Manage Rates.Contract Rates."
            }
          }
          if (value.name == "configuration") {
            if (settingArray.length == 1) {
              parent_title += "Settings.";
            }
            msNavigationService.saveItem(parent_title + "companyInformation", {
              title: "Company Information",
              icon: "",
              state: "app.companyInformation",
              translate: "",
              weight: 1,
              code : value.code,
              is_paid : value.is_paid
            });
            msNavigationService.saveItem(parent_title + "shipmentStatus", {
              title: "Booking Status",
              icon: "",
              state: "app.shipmentStatus",
              translate: "",
              weight: 5,
              code : value.code,
              is_paid : value.is_paid
            });
          }
         else if (value.name == "quotes") {
            msNavigationService.saveItem(parent_title + "" + value.name, {
              title: value.title,
              icon: value.icon,
              state: util_service.isEfpEnabled ? "app.quoteListModule" : "app.quotes",
              translate: "",
              weight: nav_weight,
              code : value.code,
              is_paid : value.is_paid
            });
          }
         else if (value.name == "search") {
            msNavigationService.saveItem(parent_title + "" + value.name, {
              title: value.title,
              icon: value.icon,
              state: util_service.isEfpEnabled ? "app.searchV2Module" : "app.search",
              translate: "",
              weight: nav_weight,
              code : value.code,
              is_paid : value.is_paid
            });
          }
        //  else if (value.name == "charges") {
        //     msNavigationService.saveItem(parent_title + "" + value.name, {
        //       title: displayTitle,
        //       icon: value.icon,
        //       state: "app." + value.name,
        //       translate: "",
        //       weight: nav_weight,
        //       code : value.code,
        //       is_paid : value.is_paid
        //     });
        //   }
          else if (value.name === 'pdfConfigurations' || value.name === 'pdf') {
            msNavigationService.saveItem(parent_title + "" + value.name, {
              title: "PDF Configurations",
              icon: value.icon,
              weight: nav_weight,
              code : value.code,
              is_paid : value.is_paid
            });
            msNavigationService.saveItem(parent_title + "" + value.name + ".quote", {
              title: "Quote",
              state: "app.pdfConfigurations",
              stateParams: { entity: "quote" },
              weight: 1,
              code : value.code,
              is_paid : value.is_paid
            });
            msNavigationService.saveItem(parent_title + "" + value.name + ".booking", {
              title: "Booking",
              state: "app.pdfConfigurations",
              stateParams: { entity: "booking" },
              weight: 2,
              code : value.code,
              is_paid : value.is_paid
            });
          }
          else {
            // Push items in navigation service
            msNavigationService.saveItem(parent_title + "" + value.name, {
              title: value.title,
              icon: value.icon,
              state: "app." + value.name,
              translate: "",
              weight: nav_weight,
              code : value.code,
              is_paid : value.is_paid
            });
          }

          // if parent title exists, assign nav weight to Manage Rates and slice appended '.'
          if (!!parent_title) {
            msNavigationService.saveItem(parent_title.slice(0, -1), {
              weight:
                parent_title === "Manage Rates." ||
                parent_title === "Settings."
                  ? 7
                  : nav_weight,
            });
          }
        }

        if (value.name == "createShipment" && util_service.splitIntoArray(value.permissions)[0] == 0) {
          var index = util_service.futureNav.indexOf("createShipment");
          if (index > -1) {
            util_service.futureNav.splice(index, 1);
          }
        }

        if (value.name == "uploadRateSheet") {
          util_service.createMenuNavList["uploadRateSheet"] = value.is_paid;
          util_service.fnSetNavPermission(value.name, value.permissions);
        }

        if (value.code == "INSTANT_RATES_AIR") {
          util_service.navPermission["AIR"] = util_service.splitIntoArray(value.permissions);
        }
        else if (value.code == "INSTANT_RATES_FTL") {
          util_service.navPermission["FTL"] = util_service.splitIntoArray(
            value.permissions
          );
        }
         else if (value.code == "INSTANT_RATES_FCL") {
          util_service.navPermission["FCL"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "INSTANT_RATES_LCL") {
          util_service.navPermission["LCL"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "TRACK-SEA") {
          util_service.navPermission["TRACK_SEA"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "TRACK-AIR") {
          util_service.navPermission["TRACK_AIR"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "TRACK") {
          util_service.navPermission["track-n-trace"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "CREATE_SHIPMENT") {
          util_service.navPermission["createShipment"] = util_service.splitIntoArray(value.permissions);
          util_service.createMenuNavList["createShipment"] = value.is_paid;
        } else if (value.code == "SCHEDULE_SEARCH") {
          util_service.navPermission["scheduleSearch"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "IMPORT_USERS") {
          util_service.navPermission["IMPORT_USERS"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "IMPORT_SHIPPERS") {
          util_service.navPermission["IMPORT_SHIPPERS"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "QUOTES") {
          util_service.createMenuNavList[value.name] = value.is_paid;
        } else if (value.code == "MY_RATES") {
          util_service.createMenuNavList[value.name] = value.is_paid;
        }else if(value.code == "LCL_MATRIX_VIEW"){
          util_service.navPermission["LCL_MATRIX_VIEW"] = util_service.splitIntoArray(value.permissions);
        }else if(value.code == "TARIFF_AMENDMENT"){
          util_service.navPermission["tariffAmendment"] = util_service.splitIntoArray(value.permissions);
        }else if (value.code == "EXPORT_USERS") {
          util_service.navPermission["EXPORT_USERS"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "EXPORT_SHIPPERS") {
          util_service.navPermission["EXPORT_SHIPPERS"] = util_service.splitIntoArray(value.permissions);
        }else if(value.code == "MANAGE_TARGET_RATES"){
          util_service.navPermission["MANAGE_TARGET_RATES"] = util_service.splitIntoArray(value.permissions);
        } else if (value.code == "PARTNER_RATE_MANAGEMENT") {
          util_service.navPermission["partnerRateManagement"] = util_service.splitIntoArray(value.permissions);
        }

      });

      util_service.state.push(
        "pages",
        "core",
        "navigation",
        "toolbar",
        "shared_shipment_details",
        "pages_share_error",
        "login_with_uuid",
        "exchangeRates"
      );
    }

    function checkState(state) {
      if (!util_service.state.length) {
        var user_category = localStorageService.get("authToken").value.user_category;
        var efpDomain = localStorageService.get("IsEfpEnabled");
        util_service.isEfpEnabled = efpDomain ? ($rootScope.domainData ? $rootScope.domainData.domain_info.IS_EFP_DOMAIN : efpDomain.value) : false;
        util_service.getNavList(user_category);
      }
      var i = 0;
      angular.forEach(util_service.state, function (item) {
        if (state.includes(item)) {
          i++;
        }
      });
      if (i > 0) {
        return true;
      } else {
        return false;
      }
    }

    function displayValidationError(error) {
      var viewError = "";
      if (error.status === 422) {
        if (error.data && error.data.data) {
          viewError = error.data.data.message;
          return viewError;
        } else if (error.data) {
          viewError = error.data.message;
          return viewError;
        }

        if (error.responseText) {
          var resError = angular.fromJson(error.responseText);
          viewError = resError.message;
        } else if (!Array.isArray(error.data.data)) {
          viewError = error.data.data.message;
        } else {
          angular.forEach(error.data, function (value) {
            viewError += value[0] + " ";
          });
        }
      } else if (error.status === 500) {
        viewError = error.statusText;
      } 
      else if (error.status === 503) {
        viewError = error.data.message;
      }else if (error.status === 403) {
        viewError = error.data.message;
      } else if (error.status === 404) {
        viewError = error.responseJSON.message;
      } else if (error.status === 400) {
        if (error.responseText) {
          var resError = angular.fromJson(error.responseText);
          viewError = resError.message
            ? resError.message
            : resError.errors.data[0];
        } else {
          viewError = error.data.message.message
            ? error.data.message.message
            : error.data.message;
        }
      } else if (error.data) {
        viewError = error.data.message;
      } else if (angular.isString(error)) {
        viewError = error;
      } else {
        viewError = error.message;
      }
      return viewError;
    }
    function isString(data) {
      if(typeof data === 'string') {
        return true;
      } else {
        return false;
      }
    }
    function redirectIfError(error) {
      var stateName = "";
     
       if (error.status === 500) {
        stateName = "app.pages_errors_error-500";
      }else if (error.status === 503) {
        stateName = "app.pages_errors_error-503";
      }else if (error.status === 403) {
        stateName = "app.pages_share_error";
      } else if (error.status === 401) {
        localStorageService.set("authToken", {});
        stateName = "app.pages_auth_login-v2";
      } else {
        stateName = util_service.isEfpEnabled ? "app.searchV2Module" : "app.search";
      }
      return stateName;
    }


    function redirectToErrorPage(errorStatusCode) {
      var stateName = "";
      if (errorStatusCode === 500) {
        stateName = "app.pages_errors_error-500";
      }else if (errorStatusCode === 503) {
        stateName = "app.pages_errors_error-503";
      }else if (errorStatusCode === 403) {
        stateName = "app.pages_share_error";
      } else if (errorStatusCode === 401) {
        localStorageService.set("authToken", {});
        stateName = "app.pages_auth_login-v2";
      }
      if(stateName){
        $state.go(stateName);
      }
    }

    // show graph if rate history of all load type is not empty -ankita
    function validateAnalyticData(analytics) {
      var is_empty = true;
      if (analytics.rate_data.length > 0) {
        angular.forEach(analytics.rate_data, function (item) {
          if (item.rate_history.length > 0) {
            is_empty = false;
          }
        });
      }
      return is_empty;
    }

    // form structure needed for graph -ankita
    function getRatesByLoad(data, axis, totalLoads, columnsData) {
      if (data.rate_history.length > 0) {
        var xAxisData = [axis];
        var YAxisValue = [data.type];
        totalLoads.push(data.type);
        for (var i = 0; i < data.rate_history.length; i++) {
          xAxisData.push(data.rate_history[i].date);
          YAxisValue.push(data.rate_history[i].rate);
        }
        columnsData.push(xAxisData);
        columnsData.push(YAxisValue);
      }
    }

    // get currency list and store in localStorage
    function getCurrencyList() {
      var currencyUrl = api.baseUrl + "/api/v2/currency-list";
      return $http.get(currencyUrl).then(
        function (response) {
          util_service.currencyList = [];
          response.data.currencies.forEach(function (item) {
            if (util_service.currencyList.indexOf(item.code) == -1) {
              util_service.currencyList.push(item.code);
            }
          });
          return util_service.currencyList;
        },
        function (error) {
          $log.error(error);
        }
      );
    }
  

    // get IMCO Code List
    function imcoCodeList() {
      var IMCO_CodeList = [
        {
          class_number: 1,
          class_name: "Class 1 – Explosives",
          list: ["1.1; 1.2; 1.3; 1.4; 1.4s; 1.5"],
        },
        {
          class_number: 2,
          class_name: "Class 2 – Gases",
          list: [
            "2.1 Flammable gas",
            "2.2 Non-Flammable Gas",
            "2.3 Poisonous or harmful gas",
          ],
        },
        {
          class_number: 3,
          class_name: "Class 3 – Flammable Liquids",
          list: [
            "3.1 Flashpoint from 0 to minus 18 C",
            "3.2 Flashpoint from 0 to plus 23 C",
            "3.3       Flashpoint from plus 23 C to plus 60 C",
          ],
        },
        {
          class_number: 4,
          class_name: "Class 4 – Flammable Solids",
          list: [
            "4.1 Flammable solids",
            "4.2 Solids liable to spontaneously combust",
            "4.3 Solids that become unstable when wet",
          ],
        },
        {
          class_number: 5,
          class_name: "Class 5 – Oxidising Agents",
          list: ["5.1 Oxidising agents", "5.2 Organic agents or peroxides"],
        },
        {
          class_number: 6,
          class_name: "Class 6 – Poison / Harmful Substances",
          list: ["6.1 Solid or liquid poisons", "6.2 Biohazardous cargo"],
        },
        {
          class_number: 7,
          class_name: "Class 7 – Radioactive Cargo",
          list: [],
        },
        {
          class_number: 8,
          class_name: "Class 8 – Corrosive Cargo",
          list: [],
        },
        {
          class_number: 9,
          class_name: "Class 9 – Other Dangerous Cargos",
          list: [],
        },
      ];
      return IMCO_CodeList;
    }

    // function to get the domain data with promise caching to prevent infinite loops
    function getDomainData() {
      // Return existing promise if already in progress
      if (domainDataPromise) {
        return domainDataPromise;
      }
      
      // Return resolved promise if data already loaded
      if (domainDataLoaded && $rootScope.domainData && $rootScope.domainData.domain_info) {
        return $q.resolve($rootScope.domainData);
      }

      var host_name = window.location.hostname
        .replace("http://", "")
        .replace("https://", "")
        .replace("www.", "")
        .split(/[/?#]/)[0];
      host_name = host_name.indexOf("localhost") > -1 ? local_host_name : host_name;
      var url = api.baseUrl + "/domain-data?domain_name=" + host_name;
      
      // Cache the promise to prevent multiple simultaneous calls
      domainDataPromise = $http.get(url).then(
        function (res) {
          $rootScope.domainData.domain_info = res.data.data;
          $rootScope.domainData.domain_name = $rootScope.domainData.domain_info.domain_title ? $rootScope.domainData.domain_info.domain_title : $rootScope.domainData.domain_name;
          $rootScope.domainData.logo = $rootScope.domainData.domain_info.LOGO;
          util_service.isEfpEnabled =
            $rootScope.domainData.domain_info.IS_EFP_DOMAIN ? true : false;
          
          // Mark as loaded
          domainDataLoaded = true;
          
          // Theming
          customTheming.validateThemeObj();
         
          return $rootScope.domainData;
        },
        function (err) {
          $log.error(err);
          $rootScope.domainData.domain_info = {};
          // Reset promise cache on error to allow retry
          domainDataPromise = null;
          throw err;
        }
      );
      
      return domainDataPromise;
    }

    // God user acting as a forwarder: load that forwarder's domain config so
    // per-domain display flags (e.g. SHOW_AGENT_NAME) follow the impersonated domain.
    function setImpersonatedDomain(forwarder) {
      var domain = forwarder && !forwarder.is_own ? forwarder.domain : null;
      var requestId = ++impersonatedDomainRequestId;

      if (!domain) {
        $rootScope.impersonatedDomainInfo = null;
        $rootScope.impersonatedDomainName = null;
        return $q.resolve(null);
      }

      if ($rootScope.impersonatedDomainInfo && $rootScope.impersonatedDomainName === domain) {
        return $q.resolve($rootScope.impersonatedDomainInfo);
      }

      $rootScope.impersonatedDomainInfo = null;
      $rootScope.impersonatedDomainName = null;
      var url = api.baseUrl + "/domain-data?domain_name=" + encodeURIComponent(domain);

      return $http.get(url).then(
        function (res) {
          if (requestId !== impersonatedDomainRequestId) {
            return null;
          }
          $rootScope.impersonatedDomainInfo = (res.data && res.data.data) || null;
          $rootScope.impersonatedDomainName = domain;
          return $rootScope.impersonatedDomainInfo;
        },
        function (err) {
          $log.error(err);
          return null;
        }
      );
    }

    function getDomainFlag(key) {
      var impersonated = $rootScope.impersonatedDomainInfo;
      if (impersonated && Object.prototype.hasOwnProperty.call(impersonated, key)) {
        return impersonated[key];
      }
      var domainInfo = $rootScope.domainData && $rootScope.domainData.domain_info;
      return domainInfo ? domainInfo[key] : undefined;
    }

    function getTmsIntegrationConfig() {
      var domainInfo = $rootScope.domainData && $rootScope.domainData.domain_info;
      if (!domainInfo || !domainInfo.TMS_USER_INTEGRATION_DETAILS) {
        return null;
      }

      var config = domainInfo.TMS_USER_INTEGRATION_DETAILS;
      if (angular.isString(config)) {
        try {
          config = JSON.parse(config);
        } catch (error) {
          return null;
        }
      }

      return angular.isObject(config) ? config : null;
    }

    function filterTmsIntegrationOptions(searchText, fieldName) {
      var config = getTmsIntegrationConfig();
      var options = config && angular.isArray(config[fieldName]) ? config[fieldName] : [];
      var normalizedSearch = angular.isString(searchText) ? searchText.trim().toLowerCase() : '';

      if (!normalizedSearch) {
        return options;
      }

      return options.filter(function (option) {
        return String(option).toLowerCase().indexOf(normalizedSearch) !== -1;
      });
    }

    //function to show bullet points in textarea on key enter - ankita
    function getBulletPontOnInput(event, inputClass) {
      var keycode = event.keyCode ? event.keyCode : event.which;
      if (keycode === "13") {
        document.getElementById(inputClass).value += "• ";
      }
      var txtval = document.getElementById(inputClass).value;
      if (txtval.substr(txtval.length - 1) === "/\r|\n/") {
        document.getElementById(inputClass).value = txtval.substring(
          0,
          txtval.length - 1
        );
      }
    }

    //mixpanel identify user
    function checkUserExit(action, mixPanelToken) {
      if (sanitizeQueryParams(window.location.href).indexOf("ship.xyzforwarder.com") !== -1) {
        mixpanel.init("7001400b12eb4731a744ca4ba72395b4", {
          persistence: "localStorage",
        });
      } else {
        mixpanel.init(mixPanelToken, { persistence: "localStorage" });
      }

      return util_service.getProfile().then(
        function (response) {
          var user = {
            User_Category: util_service.userProfile.user.type.user_category,
            Vendor_Name: localStorageService.get("authToken").value.vendor_name,
            Company_ID: util_service.userProfile.user.company.id,
            User_ID: util_service.userProfile.user.id,
            User_Type: util_service.userProfile.user.user_type,
            Vendor_ID: localStorageService.get("authToken").value.vendor_id,
            User_Mobile: util_service.userProfile.user.user_mobile,
            User_Email: util_service.userProfile.user.email,
            User_Name: util_service.userProfile.user.user_first_name,
            Product_Category: util_service.userProfile.user.solution_type,
          };

          if (action == "fromLogin") {
            util_service.setMixpanelUser(user);
          } else if (action == "fromController") {
            util_service.identifyMixpanel(user);
          }
        },
        function (error) {
          $log.error(error);
        }
      );
    }

    function setMixpanelUser(user, page) {
      mixpanel.register({
        "User category": user.User_Category,
        "Vendor Name": user.Vendor_Name,
        "Company ID": user.Company_ID,
        "User ID": user.User_ID,
        "User Type": user.User_Type,
        "Vendor ID": user.Vendor_ID,
        "User Mobile": user.User_Mobile,
        "User Email": user.User_Email,
        "User Name": user.User_Name,
        "Product category": user.Product_Category,
      });

      if (page != "shipment" && page != "quote") {
        mixpanel.track("Logged In", {
          "User category": user.User_Category,
          "Vendor Name": user.Vendor_Name,
          "Company ID": user.Company_ID,
          "User ID": user.User_ID,
          "User Type": user.User_Type,
          "Vendor ID": user.Vendor_ID,
          "User Mobile": user.User_Mobile,
          "User Email": user.User_Email,
          "User Name": user.User_Name,
          "Product category": user.Product_Category,
        });
      }

      util_service.identifyMixpanel(user);
    }

    function identifyMixpanel(user) {
      var host_name = window.location.hostname
      .replace("http://", "")
      .replace("https://", "")
      .replace("www.", "")
      .split(/[/?#]/)[0];
    host_name = host_name.indexOf("localhost") > -1 ? local_host_name : host_name;
      mixpanel.identify(user.User_ID);

      mixpanel.people.set({
        $name: user.User_Name,
        $last_login: new Date(),
        Day: moment(new Date()).format("dddd"),
        $email: user.User_Email,
        Plan: user.Product_Category,
        "User Type": user.User_Category,
        Company: user.Vendor_Name,
        "User Mobile": user.User_Mobile,
        "Last Activity": new Date(),
        Domain: host_name,
      });
    }
   
    function callMixpanel(event,mixpanelObj){
      // console.log("event",event)
      analytics.track(event,mixpanelObj);

    }
    function createUserData(shareData, id, page, mixPanelToken) {
      if (page == "shipment") {
        if (shareData.created_by.domain == "ship.xyzforwarder.com") {
          mixpanel.init("7001400b12eb4731a744ca4ba72395b4", {
            persistence: "localStorage",
          });
        } else {
          mixpanel.init(mixPanelToken, { persistence: "localStorage" });
        }

        var result = shareData.parties.filter(function (item) {
          if (item.uuid === id) {
            return item;
          }
        });

        if (!result.length) {
          $state.go("app.pages_share_error");
        }

        analytics.track("Shared Shipments");
        var user = {
          User_Category: result[0].category,
          Vendor_Name: "",
          Company_ID: "",
          User_Type: "",
          User_ID: result[0].uuid,
          Vendor_ID: shareData.vendor_id,
          User_Mobile: result[0].contact,
          User_Email: result[0].email,
          User_Name: result[0].name,
          Product_Category: "",
        };

        util_service.setMixpanelUser(user, page);
      } else if (page == "quote") {
        if (shareData.domain == "ship.xyzforwarder.com") {
          mixpanel.init("7001400b12eb4731a744ca4ba72395b4", {
            persistence: "localStorage",
          });
        } else {
          mixpanel.init(mixPanelToken, { persistence: "localStorage" });
        }

        analytics.track("Shared Quotes");
        var user = {
          User_Category: shareData.company.type,
          Vendor_Name: shareData.company.company_name,
          Company_ID: shareData.company.id,
          User_Type: shareData.user_type,
          User_ID: shareData.id,
          Vendor_ID: shareData.company.vendor_id,
          User_Mobile: shareData.user_mobile,
          User_Email: shareData.email,
          User_Name: shareData.user_first_name + "" + shareData.user_last_name,
          Product_Category: "",
        };

        util_service.setMixpanelUser(user, page);
      }
    }

    function fnGetColorBuStatusName(status) {
      var color = "";
      switch (status) {
        case "Won":
          color = "#7ED321";
          break;

        case "Lost":
          color = "#F25F5F";
          break;

        case "Expired":
          color = "#FFA728";
          break;

        case "Follow-up Required":
          color = "#139BFE";
          break;

        case "Approval Pending":
          color = "#8F84FD";
          break;

        case "Active":
          color = "#27e527";
          break;

        case "Revision Required":
          color = "#D0AB75";
          break;
      }
      var statusColor = {
        color: color,
      };
      return statusColor;
    }

    function fnGetForwarderIdApi(text) {
      var result = "";
      if (
        localStorageService.get("forwarder") &&
        localStorageService.get("forwarder").value
      ) {
        $rootScope.forwarder_id = localStorageService.get("forwarder").value.id;
      }
      if (util_service.isFreightbro && $rootScope.forwarder_id) {
        result += text + "forwarder_company_id=" + $rootScope.forwarder_id;
      }
      return result;
    }

    function getShipperList() {
      var url = "";
      // if (user === 'god') {
      //     url = api.baseUrl + '/api/get-shippers?id=' + id;
      // } else {
      url = api.baseUrl + "/api/shipper-company-list";
      // }
      return $http.get(url);
    }
    
    function getCountries() {
      var url = api.baseUrl + "/countries";
      return $http.get(url).then(function(response) {
        if (response && response.data && response.data.data && response.data.data.countries) {
          return {
            data: {
              data: {
                countries: response.data.data.countries
              }
            }
          };
        }
        return response;
      });
    }

    //function to get the list of all ports
    // function getPorts(searchText,mode){
    //     var url;
    //     var data = {"data" :  {'mode': mode,'search_query' : searchText }};
    //     if(util_service.isSharedPage()){
    //       url = api.baseMockUrl + '/port';
    //     } else {
    //       url =  api.baseUrl + '/api/port';
    //     }
    //     return $http.post(url,data);
    // }

    function getPorts(searchText, mode, input_type, search_type) {
      // angular.element('md-virtual-repeat-container').addClass('custom-container');
      var url;
      var data = {
        data: {
          input_type: input_type || "origin",
          mode: mode,
          search_query: searchText || null,
          search_type:search_type ? search_type : "P2P",
          vendor_id: localStorageService.get("authToken")
            ? localStorageService.get("authToken").value.vendor_id
            : "",
        },
      };

      if (util_service.isSharedPage()) {
        url = api.baseMockUrl + "/places";
      } else {
        url = api.baseUrl + "/api/places";
      }

      return $http.post(url, data).then(
        function (response) {
          return response.data.data.location;
        },
        function (error) {
          $log.log(error.data);
          return [];
        }
      );
    }

    function delecteAssociates(deleteUrl, data) {
      var url = api.baseMockUrl + "/" + deleteUrl + "-associates";
      return $http.post(url, data);
    }

    function delecteCardsOnId(deleteUrl, data) {
      var url = api.baseMockUrl + "/" + deleteUrl;
      return $http.delete(url, data);
    }

    function getProfitValue(SP, CP) {
      var result = ((SP - CP) / CP) * 100;

      if (Math.abs(result) == Infinity || isNaN(result)) {
        result = "N/A";
      } else {
        result = $filter("currencyMask")(result, 2) + " %";
      }
      return result;
    }


    function sanitizeText(value) {
      return $sanitize(value).replace(/&amp;/g, "&");
    }

    function sortSelectBox(selectedlist, actulaList) {
      for (var i = 0; i < actulaList.length; i++) {
        if (selectedlist.length || selectedlist) {
          var isPresent = selectedlist.some(function (el) {
            return el === actulaList[i].id;
          });
          if (isPresent) {
            var tempObj = actulaList[i];
            actulaList.splice(i, 1);
            actulaList.unshift(tempObj);
          }
        }
      }
    }

    // Check if auth token present in localstorage
    function checkLocalStorageAuthToken() {
      var url = sanitizeQueryParams(window.location.href);
      if ( !util_service.isSharedPage() && !util_service.isSharedQuote() && !util_service.isResetPage() && !util_service.isWebView() &&
        url.indexOf("login") == -1 && url.indexOf("signup") == -1 && url.indexOf("account") == -1 && url.indexOf("exchange-rates") == -1 ) {
        var token = localStorageService.get("authToken");
        if (token != null && !!token.value) {
          return true;
        } else {
          if (url.indexOf("access") === -1) {
            $location.path("/login");
          }
          // $state.go('app.pages_auth_login-v2');
        }
      }
    }

    // on screen size hide list view
    function resizeScreen(deviceName) {
      if (window.innerWidth > 1024) {
        deviceName = "laptop";
      } else if (window.innerWidth > 768) {
        deviceName = "tablet";
      } else {
        deviceName = "mobile";
      }
      return deviceName;
    }

    // Get Status Color for quotes and shipments
    function getStatusColor(color) {
      color = color ? color : "#00AEFC";
      if ($mdMedia("xs")) {
        var statusColor = {
          color: "#FFFFFF",
          "background-color": color,
        };
      } else {
        var statusColor = {
          color: color,
          "background-color": color + "30",
          border: "1px solid " + color,
        };
      }
      return statusColor;
    }

    function fnSetStatusColor(colorCodeObj , type){
      var statusColor = {
        color: colorCodeObj["color"],
        "background-color": colorCodeObj["bg-color"],
        border: type ? 'none' : "1px solid " + colorCodeObj["border-color"]
      };
    return statusColor;

    }

    // Set maxheight for list and sidenav w.r.t screen size
    function getModuleMaxHeight(maxHeight, module, size) {
      var powered_by_height = document.getElementById("powered_by")
        ? document.getElementById("powered_by").offsetHeight
        : 0;
      var windowHeight =
        document.getElementById("content-container").offsetHeight; //set max height for quote list scroll
      // If module is list or filter
      if (module == "list") {
        var minusheight = 70;
        if (powered_by_height && powered_by_height !== 0) {
          minusheight = 47;
        }
        maxHeight = {
          "max-height":
            windowHeight - minusheight - powered_by_height - (size ? size : 0),
          height:
            windowHeight - minusheight - powered_by_height - (size ? size : 0),
        };
      } else if (module == "filter" && size != undefined) {
        maxHeight = {
          "max-height": windowHeight - 168 - powered_by_height,
        };
        if (util_service.isMobileDevice || util_service.isMobileApp) {
          maxHeight = {
            overflow: "auto",
          };
        }
      } else if (
        module == "inquiryFilter" ||
        module == "quotesFilter" ||
        module == "shipmentFilter"
      ) {
        maxHeight = {
          "max-height":
            windowHeight -
            (powered_by_height && powered_by_height !== 0 ? 240 : 266) -
            powered_by_height -
            (size ? size : 0),
        };
        if (util_service.isMobileDevice || util_service.isMobileApp) {
          maxHeight = {
            "max-height": windowHeight - 120 - powered_by_height,
            overflow: "auto",
          };
        }
      } else {
        if (util_service.isMobileDevice || util_service.isMobileApp) {
          maxHeight = {
            "max-height": windowHeight - 190 - powered_by_height,
            height: windowHeight - 190 - powered_by_height,
            overflow: "auto",
          };
        } else {
          maxHeight = {
            "max-height":
              windowHeight - 280 - powered_by_height - (size ? size : 0),
            height: windowHeight - 280 - powered_by_height - (size ? size : 0),
          };
        }
      }
      return maxHeight;
    }

    function fnUserCategory(user_category) {
      util_service.isAdmin = user_category === "FORWARDER" ? true : false;
      util_service.isShipper = user_category === "SHIPPER" ? true : false;
      util_service.isFreightbro = user_category === "FREIGHTBRO" ? true : false;
    }

    function getMappingCurrencyList() {
      var currencyUrl = api.baseUrl + "/api/v2/currency-list";
      return $http.get(currencyUrl).then(
        function (response) {
          util_service.mappingCurrencyList = response.data.currencies;
          return util_service.mappingCurrencyList;
        },
        function (error) {
          $log.error(error);
        }
      );
    }

    function callerpIntegrationApi() {
      var erpIntegrationApiUrl = api.baseUrl + "/api/erp-integration";
      return $http.get(erpIntegrationApiUrl).then(
        function (response) {
          if (response.data.data) {
            localStorageService.set("erpIntegrationList", response.data.data); // setting the integration list.
          }
        },
        function (error) {
          $log.error(error);
        }
      );
    }

    function postErpIntegration(reqData) {
      var url = api.baseUrl + "/api/erp-integration";
      return $http.post(url, reqData).then(
        function (response) {
          return response.data;
        },
        function (error) {
          $log.log(error.data);
          return [];
        }
      );
    }
    function cargowiseIntegration(config){
      config.url = api.baseUrl+config.url;
      return  $http(config).then(
          function (response) {
            return response;
          },
          function (error) {
            //console.log(error)
            $log.log(error.data);
            return error;
          }
    );
    }

    function chargeMapping(shipmentId,partner){
      var url = api.baseUrl + '/api/v2/sync/partner/charge/mapping?shipmentId='+shipmentId+'&partnerId='+partner;
      return $http.get(url).then(
        function (response) {
          return response.data;
        },
        function (error) {
          $log.log(error.data);
          return error.data;
        }
      );
    }

    function getChargeMappingList(query,mode,subVendorID,partner){
      var url = api.baseUrl + '/api/v2/search/partner/charge/mapping?query='+query+'&mode='+mode+'&subVendor='+subVendorID+'&linerMappingId='+partner;
      return $http.get(url).then(
        function (response) {
          return response.data;
        },
        function (error) {
          $log.log(error.data);
          return error.data;
        }
      );
    }

    function getAgentsData(query){
      query = query ? query : '';
      var url=api.baseUrl+'/api/v2/agents'+'?vendor_id=' +localStorageService.get('authToken').value.vendor_id+'&query='+query+'&limit=100';
      return $http.get(url);
    }

    // function to validate email in chips
    function validateEmail(emails, userInput) {
      if (emails && emails.length !== 0 && userInput !== "") {
        //check email validation
        
        if (!userInput.match(util_service.emailRegex)) {
          util_service.invalidEmail = true;
          emails.pop();
        } else {
          util_service.invalidEmail = false;
        }

        var arrayLowercase = [];
        //check duplicate value
        if (!util_service.invalidEmail) {
          emails.pop();
          for (var i = 0; i < emails.length; i++) {
            if (emails.length) {
              arrayLowercase.push(emails[i].toLowerCase());

              if (
                angular.isDefined(arrayLowercase[i]) &&
                arrayLowercase[i].indexOf(userInput.toLowerCase()) !== -1
              ) {
                util_service.duplicateEmail = true;
                return emails;
              } else {
                util_service.duplicateEmail = false;
              }
            }
          }
          if (!util_service.duplicateEmail) {
            emails.push(userInput);
          }
        } else {
          util_service.duplicateEmail = false;
        }
      } else {
        util_service.invalidEmail = false;
        util_service.duplicateEmail = false;
      }
    }

    //   function to track navigation in mixpanel
    function trackEvent(moduleName ,moduleType) {
      if ( moduleName == "Manage Rates" ||
        moduleName == "Currency Setting" ||
        moduleName == "Manage Customer Rates" ||
        moduleName == "Manage Shared Rates")
       {
        analytics.track(moduleName, {"Module Type": moduleType});
      }
    }

    function searchTextOption(result, group, searchString, toFilterStr) {
      if (toFilterStr.toLowerCase().indexOf(searchString) >= 0) {
        result.push(group);
      }
    }
    // fixed inner-content div height with device height
    function fnRestrictPageHeight() {
      // get device height
      var innerContainerDiv = angular.element(
        document.querySelector("#inner-content")
      )[0];
      var viewportwidth = null;
      var viewportheight = null;

      // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
      if (typeof window.innerWidth != "undefined") {
        viewportwidth = window.innerWidth;
        viewportheight = window.innerHeight;
      }

      // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
      else if (
        typeof document.documentElement != "undefined" &&
        typeof document.documentElement.clientWidth != "undefined" &&
        document.documentElement.clientWidth != 0
      ) {
        viewportwidth = document.documentElement.clientWidth;
        viewportheight = document.documentElement.clientHeight;
      }

      // older versions of IE
      else {
        viewportwidth = angular.element(document.querySelector("body"))[0]
          .clientWidth;
        viewportheight = angular.element(document.querySelector("body"))[0]
          .clientHeight;
      }

      var toolbarDivHeight = angular.element(
        document.querySelector("#toolbar-navigation-container")
      )[0].offsetHeight;
      var notificationDivHeight = angular.element(
        document.querySelector("#notification-bar")
      )[0].offsetHeight;

      var finalHeight =
        viewportheight - (toolbarDivHeight + notificationDivHeight + 30);
      innerContainerDiv.style =
        "height :" + finalHeight + "px !important;overflow:auto !important";
    }

    function isModulePresent(module) {
      return (
        util_service.navPermission[module] &&
        util_service.navPermission[module][1]
      );
    }
    
    //User info push to GTM
    function pushGtm(gtmDataLayer) {
      if (!util_service.isGtmPushed) {
        util_service.isGtmPushed = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(gtmDataLayer);
      }
    }

    function mappingUserInfo(user_modules,userInfo){
        var userObject = {
            'user_info' : {
                'name': userInfo.user.user_first_name+' '+userInfo.user.user_last_name,
                'user_first_name' : userInfo.user.user_first_name,
                'user_last_name' : userInfo.user.user_last_name,
                'user_mobile': userInfo.user.user_mobile,
                'user_mobile_code' : userInfo.user.user_mobile_code,
                'email': userInfo.user.email,
                'domain' : userInfo.user.domain,
                'company_name' : userInfo.user.company ? userInfo.user.company.company_name : '',
                'user_category' : userInfo.user.type.user_category,
                'user_type_name': userInfo.user.type.user_type_name,
                'role' : userInfo.user.role.name,
                'is_pricing_user' : userInfo.user.is_pricing_user,
                'is_sales_cordinator' : userInfo.user.is_sales_cordinator,
                'vendor_id': userInfo.user.company ? userInfo.user.company.vendor_id : '',
                'company_email' : userInfo.user.company ? userInfo.user.company.company_email : '',
                'user_modules' : user_modules,
                'user_id':userInfo.user.id,
                'created_at': userInfo.user.created_at,
                'ONBOARDING_TAG' : $rootScope.domainData.domain_info.ONBOARDING_TAG ? $rootScope.domainData.domain_info.ONBOARDING_TAG : '',
            }   
        }
        util_service.pushGtm(userObject);
        appCuesTracking(userObject);
    }

    function pageOpenNewTab(pageUrl, param) {
      if ($rootScope.domainData.domain_info.TARGET_LIST_BLANK) {
        var url = $state.href(pageUrl, param);
        window.open(util_service.sanitizeQueryParams(url), "_blank", "noopener");
      } else {
        $state.go(pageUrl, param);
      }
    }
    
     // it's search text highlight from options list 
    function searchHighlight(optionValue,searchText) {
      if(searchText && searchText.length && optionValue){
        optionValue = util_service.escapeHtml(optionValue)
        optionValue = optionValue.replace(new RegExp(searchText.replace(/[.*)+?}^{$(|[\]\\]/g, "\\$&"), 'gi'), '<span class="highlightedText">$&</span>');
      }
      return optionValue;
    }

    function doorDropdownData(optionValue, searchText) {
      var data = [];
      if (optionValue.city) {
        data.push(optionValue.city);
      } else {
        if (optionValue.pin_code_ui){
          var text =
            "Postalcode: " +
            optionValue.country_code +
            "-" +
            optionValue.pin_code_ui;
          data.push(text);
        }
      }

      if (optionValue.location) {
        data.push(optionValue.location);
      }
      return data;
    }

    function doorDropdownDataFtl(optionValue, searchText) {
      var data = [];
      if (optionValue.city) {
        data.push(optionValue.city);
      } else {
        if (optionValue.pincodeUi){
          var text =
            "Postalcode: " +
            optionValue.countryCode +
            "-" +
            optionValue.pincodeUi;
            data.push(text);

        }
      }

      if (optionValue.location) {
        data.push(optionValue.location);
      }
      return data;
    }

    function subDoorDropdownData(optionValue,searchText,isTooltip){
      var data=[]
      if (optionValue.location_alias && optionValue.location_alias.length) {
        var locationString = optionValue.location_alias.join(", ");
            if (isTooltip) {
              data.push(locationString);
            } else {
              data.push(this.truncateText(locationString, 40));
            }  
        }
       if (optionValue.state) {
         if (isTooltip) {
           data.push(optionValue.state);
         } else {
           data.push(this.truncateText(optionValue.state, 20));
         }
       }
      if (optionValue.country) {
        data.push(optionValue.country);
      }
      return data;
    }

    function subDoorDropdownDataFtl(optionValue, searchText,isTooltip) {
      var data = [];
      if (optionValue.locationAlias && optionValue.locationAlias.length) {
        var locationString = optionValue.locationAlias.join(", ");
          if (isTooltip) {
            data.push(locationString);
          } else {
            data.push(this.truncateText(locationString, 40));
          }     
       }
      if (optionValue.state) {
        if (isTooltip){
          data.push(optionValue.state);
        }
        else{
          data.push(this.truncateText(optionValue.state, 20));
        }
      }
      if (optionValue.countryName) {
        data.push(optionValue.countryName);
      }
      return data;
    }

    function truncateText(text, maxLength) {
      if (text.length > maxLength && !text.includes("Postalcode")) {
        return text.substring(0, maxLength - 3) + "...";
      }
      return text;
    }

    function doorSelectedData(optionValue,isTooltip) {

      var data=[];
      if(optionValue){
        if (optionValue.pin_code_ui){
          var postcode =
            optionValue.country_code + "-" + optionValue.pin_code_ui;
                data.push(postcode);
        }
      if (optionValue.city) {
        data.push(optionValue.city);
      } else {
        if (optionValue.location_alias && optionValue.location_alias.length) {
          var locationString = optionValue.location_alias.join(", ");
          if (isTooltip) {
            data.push(locationString);
          } else {
            data.push(this.truncateText(locationString, 40));
          }
        }
       }
      }
      if(optionValue.state){
        if(isTooltip){
          data.push(optionValue.state);
        }
        else{
          data.push(this.truncateText(optionValue.state, 20));
        }
      }
      return data;

    }

    function doorSelectedDataFtl(optionValue, isTooltip) {
      var data = [];
      if (optionValue.pincodeUi){
              var postcode = optionValue.countryCode + "-" + optionValue.pincodeUi;
            data.push(postcode);
      }
      if (optionValue.city) {
        data.push(optionValue.city);
      } else {
        if (optionValue.locationAlias && optionValue.locationAlias.length) {
          var locationString = optionValue.locationAlias.join(", ");
          if (isTooltip) {
            data.push(locationString);
          } else {
            data.push(this.truncateText(locationString, 40));
          }
        }
      }
      if (optionValue.state) {
        if (isTooltip) {
          data.push(optionValue.state);
        } else {
          data.push(this.truncateText(optionValue.state, 20));
        }
      }
      return data;
    }

    function portSelectedData(optionValue,isTooltip) {
      var data=[];
      if(optionValue){
          if(optionValue.portname){
              data.push(optionValue.portname);
          }
          if(optionValue.city && isTooltip){
            data.push(optionValue.city)
          }
          if (optionValue.city && !isTooltip) {
            data.push(this.truncateText(optionValue.city,20));
          }
          data.push(optionValue.global_port_code);
    }
      return data;
    }

    function portSelectedDataFtl(optionValue, isTooltip) {
      var data = [];
      if(optionValue){
      data.push(optionValue.location);
      if (optionValue.city && isTooltip) {
        data.push(optionValue.city);
      data.push(optionValue.portname);
      if(optionValue.city && isTooltip){
        data.push(optionValue.city)
      }
      if (optionValue.city && !isTooltip) {
        data.push(this.truncateText(optionValue.city, 20));
      }
      data.push(optionValue.globalPortCode);
    }
      }
      return data;
    }
    
    function appCuesTracking(userObject){
      var counter = 1;
      var isLoadedAppcuse = $interval(function(){
          if(window.Appcues) {
            counter = 10;
            window.Appcues.identify(userObject.user_info.user_id, {
                'username' : userObject.user_info.name ,
                'domain' : userObject.user_info.domain ,
                'Role' : userObject.user_info.role,
                'user_category'  : userObject.user_info.user_category,
                'Vendor_id' : userObject.user_info.vendor_id,  
                'Email' : userObject.user_info.email
            });
          }
          if(counter === 10){
            $interval.cancel(isLoadedAppcuse);
          }
          counter++;
      },500);
    }

    function formatLCLAIRLoad(load){

      for(var i = 0; i < load.load_details_value.length; i++){         
          load.load_details_value[i].qty = load.load_details_value[i].qty || 1; // unit load qty can not be less than 1 
          if(load.load_details_value[i]['$$hashKey']){
              delete load.load_details_value[i]['$$hashKey'];
          }
      }
      return load;
    }


    // get port object 
    function mapPortData(nearbyPort, portData, portCode){
      var portDataCopy = angular.copy(portData);
      if(nearbyPort.length){
        var temptOrg = nearbyPort;
        temptOrg.push(portData);
        var codeData = temptOrg.find(function(element) {
          return portCode === element.global_port_code;
        });
        portData = codeData;
      }
      return portData ? portData : portDataCopy;
    }

    // function to check if key present in object
    function getPincode(searchParam){
      if(searchParam.hasOwnProperty('pin_code_ui')){
        return searchParam['pin_code_ui'];
      }else{
        return searchParam['pin_code'];
      }
    }
    // Redirct to exchange rates page
    function redirectToExchangeRatesLink(resultType, resultId, cardVendorId, mixpanelAction, mixpanelParams, activityId) {
      var url = sanitizeQueryParams(window.location.origin) +"/exchange-rates?type=" +resultType +"&id=" +resultId +"&identity=" +cardVendorId;
      if (resultType == "Inquiry") {
        url = url + "&activityid=" + activityId;
      }
      window.open(sanitizeQueryParams(url), "_blank", "noopener");
      //mixpanel
      if(mixpanelAction){
        analytics.track(mixpanelAction, mixpanelParams);
      }
    }

    // function to get version 2 incoterm list
    function getIncotermList(){
      var url = api.baseMockUrl + "/v2/incoterms";
      return $http.get(url);
    }

     // Function to set md-select panel styles
     function fnSetPanelPosition(class_name, container_class,Panel_width,panelFrom){
      if(container_class == 'pdf-language'){
        var containerTop = $("."+class_name).offset().top -72 + "px";
      }else if(container_class == 'all_in_selection'){
        var containerTop =  "704px";
      }
      else{
        var containerTop = $("."+class_name).offset().top - 20 + "px";
      }

      // setting md-panel position with dynamic classes
      if(panelFrom == 'freeDays'){
          setTimeout(function(){
             $("."+container_class).css({'top':containerTop,'margin-top':57 + "px", 'margin-left':8 + "px"});
         }, 50);
       }else{
        // setting md-panel position with static classes
          setTimeout(function(){
             $("."+container_class).css({'top':containerTop,'max-width':Panel_width + "px", 'min-width':Panel_width + "px"});
          }, 50);
     }
  }
  /**
   * SEC-3835: prefer fragment (#token= / #access_token=), then query/state (legacy mobile),
   * then existing localStorage for in-app web_view navigations.
   */
  function readWebViewAccessToken($stateParams) {
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (hash) {
      try {
        var hashParams = new URLSearchParams(hash);
        var hashToken = hashParams.get('token') || hashParams.get('access_token');
        if (hashToken) {
          return hashToken;
        }
      } catch (e) { /* fall through */ }
    }
    if ($stateParams && $stateParams.access_token) {
      return $stateParams.access_token;
    }
    var search = $location.search() || {};
    if (search.access_token || search.token) {
      return search.access_token || search.token;
    }
    var existing = localStorageService.get('authToken');
    return existing && existing.value && existing.value.access_token
      ? existing.value.access_token
      : '';
  }

  function stripWebViewAccessTokenFromUrl() {
    if (!window.history || !window.history.replaceState) {
      return;
    }
    try {
      var url = new URL(window.location.href);
      var hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
      var hadQuery =
        url.searchParams.has('access_token') || url.searchParams.has('token');
      var hadHash =
        hashParams.has('access_token') || hashParams.has('token');
      if (!hadQuery && !hadHash) {
        return;
      }
      url.searchParams.delete('access_token');
      url.searchParams.delete('token');
      hashParams.delete('access_token');
      hashParams.delete('token');
      var remainingHash = hashParams.toString();
      var next =
        url.pathname + url.search + (remainingHash ? '#' + remainingHash : '');
      if (
        next !==
        window.location.pathname + window.location.search + window.location.hash
      ) {
        window.history.replaceState(null, '', next);
      }
    } catch (e) { /* no-op */ }
  }

  function setWebViewAuthToken($stateParams){
    var accessToken = readWebViewAccessToken($stateParams);
    localStorageService.set('authToken', {});
    util_service.user_id = $stateParams.user_id;
    // Kept in memory for $state.go; no longer a URL query param.
    util_service.webViewObj={
        access_token: accessToken,
        web_view:'web_view',
        user_id:$stateParams.user_id,
        permissionInquiry:$stateParams.permissionInquiry,
        permissionQuote:$stateParams.permissionQuote,
        permissionShipment:$stateParams.permissionShipment,
        vendor_id:$stateParams.vendor_id,
        expires_in:$stateParams.expires_in,
        user_category:$stateParams.user_category,
        vendor_name:$stateParams.vendor_name
    }
    localStorageService.set('authToken', {
        'access_token': accessToken,
        'token_type': 'Bearer',
        'vendor_id': $stateParams.vendor_id,
        'expires_in':$stateParams.expires_in,
        'user_category':$stateParams.user_category,
        'vendor_name':$stateParams.vendor_name
    });
    stripWebViewAccessTokenFromUrl();
    var inquiry = $stateParams.permissionInquiry.split('').map(function(item) {
        return parseInt(item, 10);
    });

    var quote = $stateParams.permissionQuote.split('').map(function(item) {
        return parseInt(item, 10);
    });

    var shipment = $stateParams.permissionShipment.split('').map(function(item) {
        return parseInt(item, 10);
    });
    util_service.navPermission.inquiry = inquiry;
    util_service.navPermission.quotes = quote;
    util_service.navPermission.shipments = shipment;
    util_service.getProfile();
      if(!util_service.currencyList.length){
        util_service.getCurrencyList();
      }
  }

    

   


    function fnDisableModule(event, moduleData){
      console.log(event,moduleData)
       // checking unpaid module
       var disableModule = false;
       if(!moduleData.is_paid){
         analytics.track(moduleData.title,{"Module Type":'UnPaid'});
         disableModule = true;
         event.preventDefault();
         if($rootScope.domainData.domain_info.ONBOARDING_TAG !== 'self'){
          $state.go('app.pages_unpaid_module_error');
         }
       }
       return disableModule
    }

    function isModulePaid(name){
      var isLoginUrl = (!util_service.isSharedPage() && !util_service.isSharedQuote() && !util_service.isWebView());
      if(isLoginUrl && (!util_service.paidModuleList.length || (util_service.paidModuleList.indexOf(name) == -1))){
        analytics.track(name , {'ModuleType': 'UnPaid'});
        $state.go('app.pages_unpaid_module_error');
      }
      else{
        analytics.track(name , {'ModuleType': 'Paid'});
      }
    }

    function filterArrayOfString(array){
      var result = "";
      if(array){
        var filtered = array.filter(function (el) {
          return el != null && el != "";
        });
        result = filtered.join(",");
      }
      
      return result
    }

     // checking if the module is paid and having read permission then redirect
     function fnReDirectToHome(){
     if(util_service.paidModuleState.indexOf("search") > -1 && (util_service.navPermission['search'] && util_service.navPermission.search[1])){
          $state.go(util_service.isEfpEnabled ? "app.searchV2Module" : "app.search");
       }else{
           for(var i=0 ; i < util_service.paidModuleState.length ; i++){
               if(util_service.navPermission[util_service.paidModuleState[i]] && util_service.navPermission[util_service.paidModuleState[i]][1]){
                    $state.go('app.'+util_service.paidModuleState[i]);
                    break;
                 }
            }
       }
     }
     function removeBasis(basisList){
      return basisList.filter(function(item){ return !item.basis_name.includes('dim')});
     }
     

    function fnFreeDaysValidation(loadWiseFreeDaysList){
      var isError = false ;
      var isFreedaysExist = false;

      loadWiseFreeDaysList.forEach(function(freeDaysObj){
         isFreedaysExist = false;
         // freedays min & max validation
         util_service.freeDaysKeys.forEach(function(key){
          util_service.routeKeys.forEach(function(route){
            if((freeDaysObj[route][key]['freeDays'] > 99 || freeDaysObj[route][key]['freeDays']<1) && freeDaysObj[route][key]['freeDays']!=null){
              isError = true;
            }else{
              if(freeDaysObj[route][key]['freeDays']){
                isFreedaysExist = true;
              }
            }
          });
        });
        // Adding error when load have value but frredays are null / freedays have value but loadtype is null      
        if(!isError && ((!isFreedaysExist && freeDaysObj.loadType) ||  (isFreedaysExist && !freeDaysObj.loadType))){
              angular.element('.' + freeDaysObj.id  +'_loadErrorBorder').addClass("error-border");
              angular.element('.' + freeDaysObj.id  +'_loadErrorText').addClass("error-text");  
              isError = true;
         }
      });
      return isError;
    }

    //  matching detailed_effective_load loadtype with search param load type
    function fnCheckLoadExpiryLength(detailed_effective_load , searchLoad){
       var isLoadExist = false ;
       var loadArray = [];
       angular.forEach( searchLoad , function(load){
          loadArray.push(load.type)
       });
       angular.forEach(detailed_effective_load, function(periodValue , periodKey){
        if (loadArray.includes(periodKey)){
            isLoadExist = true ;
         }
       });
       return isLoadExist;

    }

    function storeOldData(rate_obj , search_param){
      if(!rate_obj.hasOwnProperty('combined_details')){
            var origin_combined_free_days = rate_obj.origin_combined_free_days ;
            var destination_combined_free_days = rate_obj.destination_combined_free_days
             if(search_param.mode != 'SEA-FCL'){
              rate_obj['combined_details']={
                'origin':origin_combined_free_days ?  [{'free_days': origin_combined_free_days,'container_type':null}] : [],
                'destination':destination_combined_free_days ? [{'free_days': destination_combined_free_days,'container_type':null}] : [] 
              }
            }
             else{
              rate_obj['combined_details']={
                'origin' : [] ,
                'destination': []
              }

              search_param.load_data.load_details_value.forEach(function(load){
                var freeDays = {
                  "free_days" : null,
                  "container_type" : null
                }
                if(origin_combined_free_days){
                  freeDays.free_days = origin_combined_free_days,
                  freeDays.container_type = load.type
                  rate_obj['combined_details'].origin.push(freeDays);
                }
                if(destination_combined_free_days){
                  freeDays.free_days = destination_combined_free_days,
                  freeDays.container_type = load.type
                  rate_obj['combined_details'].destination.push(freeDays);
                }
              });
              
             }
       }else{
         if(!rate_obj.combined_details){
          rate_obj.combined_details = {
            'origin':[],
            'destination':[]
          }
         }
       }

          if(search_param.mode == 'SEA-FCL'){
            // Adding containerType to old data - detention & demurrage
            var DnDObj =[
              'detention_details',
              'demurrage_details'
            ]
            if(!rate_obj.detention_details){
              rate_obj.detention_details = {
                'origin':[],
                'destination':[]
              }
             }
             if(!rate_obj.demurrage_details){
              rate_obj.demurrage_details = {
                'origin':[],
                'destination':[]
              }
             }
            DnDObj.forEach(function(DnDKey){
              util_service.routeKeys.forEach(function(route){
                if(rate_obj[DnDKey] && rate_obj[DnDKey][route] && rate_obj[DnDKey][route].length){
                  rate_obj[DnDKey][route].forEach(function(freeDaysObj){
                    if(!freeDaysObj.container_type){
                      rate_obj[DnDKey][route] = [];
                      search_param.load_data.load_details_value.forEach(function(load){
                        rate_obj[DnDKey][route].push({
                          "free_days" : freeDaysObj.free_days ,
                          "container_type" : load.type
                        });
                      })
                    }
                  });
                }
              });
            });
          }
             return rate_obj ;

    }

 
  function getFreeDaysValue(freeDaysObj,loadType){
    var result = {
        'freeDays': null,
        'freeDaysType': null
      };
    freeDaysObj.forEach(function(freeDays){
      if(freeDays.container_type === loadType){
        result.freeDays = freeDays.free_days;
        result.freeDaysType = freeDays.free_days_type;
      }});
      return result;

  }
  function getFormatedData(defaultObj,freeDaysObj,loadType){
    defaultObj.loadType = loadType;
    defaultObj.id = (Math.floor(Math.random() * 90000) + 10000);
    util_service.routeKeys.forEach(function(route){
     util_service.freeDaysKeys.forEach(function(key){
          defaultObj[route][key] = util_service.getFreeDaysValue(freeDaysObj[route][key],loadType);
      });
    });
    return defaultObj;
  }
  function fillLoadArray(rateObj,pageSource,loadArray){
    util_service.freeDaysKeys.forEach(function(key){
      util_service.routeKeys.forEach(function(route){
        if(rateObj['freeDays'] && rateObj['freeDays'][route] && rateObj['freeDays'][route][key] && rateObj['freeDays'][route][key].length){
          rateObj['freeDays'][route][key].forEach(function(DnDObj){
            if(pageSource != 'EL' && !loadArray.includes(DnDObj.container_type) ){
              loadArray.push(DnDObj.container_type);
            }
          });
        }
      });
    });
  }
  function isFreeDaysEmpty(formatedData){
    var isEmpty = true;
    util_service.routeKeys.forEach(function(route){
      util_service.freeDaysKeys.forEach(function(key){
        if(formatedData[route][key]["freeDays"]){
          isEmpty = false;
        }
      });
    });
    return isEmpty;
  }
function fnSetFreeDays(rateObj , loadWiseFreeDaysList , defaultObj , loadArray , pageSource){
  loadWiseFreeDaysList = [];
  //if load type removed and still free days have data for load type then we have to add it in load array
  util_service.fillLoadArray(rateObj,pageSource,loadArray);
  loadArray.forEach(function(loadType){
    var formatedData = util_service.getFormatedData(angular.copy(defaultObj),rateObj["freeDays"],loadType);
    var isEmpty = util_service.isFreeDaysEmpty(formatedData);
    if(!isEmpty){
      loadWiseFreeDaysList.push(formatedData);
    }
  });
  if(loadWiseFreeDaysList.length === 0){
    loadWiseFreeDaysList.push(angular.copy(defaultObj));
  }
  var structuredFreeDays ={
    'loadWiseFreeDaysList':loadWiseFreeDaysList,
    'loadArray':loadArray
  }
  return structuredFreeDays;
}
    //  function getMatricJson(){
    //   setTimeout(() => {
    //     $http.get('app/data/search/matric-number.json').then(function(response) {
    //       util_service.matricNumberObj = response.data.data;
    //       console.log(util_service.matricNumberObj);
    //    });
    //   }, 200);
    // //   $http.get('app/data/search/matric-number.json').then(function(response) {
    // //     util_service.matricNumberObj = response.data.data;
    // //     console.log(util_service.matricNumberObj);
    // //  });
    // }
    
    function updateIfNotPresent(valuesToCheck, objectToUpdate, searchKey){
      valuesToCheck.forEach(function(value){
        var objFound = objectToUpdate.find(function(data){
          if(data[searchKey] === value[searchKey]){
            return data
          }
        })
        if(!objFound){
          objectToUpdate.push(value)
        }
      });
    }

    function removeIfPresent(valuesToCheck, objectToUpdate, searchKey){
      valuesToCheck.forEach(function(value) {
        var index = objectToUpdate.findIndex(function(data) { return data.id === value.id; });
        if (index !== -1) {
          objectToUpdate.splice(index, 1);
        }
      });
    }

    function fnGetPolPod(selectedDoor , leg_code , mode){
      var url = (api.baseUrl + '/api/v1/door-port-lookup?country_code='+selectedDoor.country_code+'&pincode='+selectedDoor.pin_code+'&location_name='+selectedDoor.location_string+'&leg_code='+leg_code +'&mode='+mode);
      return $http.get(url)
    }





function getDomainList(){
  var url = api.baseUrl + '/api/v1/domain-groups/getDomainGroups';
  return $http.get(url);
}


    function fnGetNearby(data){
      var url = (api.baseUrl + '/api/v2/ports/nearby')
      return $http.post(url,data)
    }

    function isOwnVendorRate(vendor_id){
      return vendor_id == util_service.userProfile.user.company.vendor_id
    }

    function fnOpenCommentPanel(ev,locals){
        
      var position = util_service._mdPanel
      .newPanelPosition()
      .absolute()
      .center();

    var config = {
      templateUrl:
        "app/main/component/charge-level-comments/charge-level-comments.html",
      controllerAs: "ctrl",
      controller: "chargeLevelCommentsController",
      position: position,
      openFrom: ev,
      trapFocus: true,
      zIndex: 1501,
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: true,
      locals: locals,
    };
    util_service._mdPanel.open(config);
    }

    function fnOpenStatusChangePanel(ev ,locals , dropDownPosition){
      var position = $mdPanel.newPanelPosition()
      .relativeTo('.'+ dropDownPosition)
      .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);

    var config = {
      templateUrl:
        "app/main/component/status-change-panel/status-change-panel.html",
      controllerAs: "ctrl",
      controller: "statusChangePanelController",
      position: position,
      openFrom: ev,
      trapFocus: true,
      zIndex: 1501,
      clickOutsideToClose: true,
      escapeToClose: false,
      focusOnOpen: true,
      locals: locals
    };
    util_service._mdPanel.open(config);

    }

    function getOrigin(mode,cards){

      var originPorts = [];
      cards.forEach(function (card){
        var  location = '';
        var  is_major_port = '';
        var  portData = card.meta.port_data;
        var icon = mode == 'AIR'  ? 'assets/icons/custom/search-bar/air_pod.svg':'';
        if(!icon){
          if(portData.pickup_location || portData.pickup_pincode_ui){
             icon = 'assets/icons/custom/search-bar/door.svg';
          }else{
            if(portData.is_icd_port_origin){
              icon = 'assets/icons/custom/search-bar/icd.svg';
            }else{
             icon = 'assets/icons/custom/search-bar/port.svg';
            }
          }
        }
        if(portData.pickup_location || portData.pickup_pincode_ui){
          location = [portData.pickup_location ,portData.pickup_pincode_ui,portData.pickup_country_name].filter(function(element) {if(element){return element}}).join(', ');
        }else{
          location = [portData.origin_port_code,portData.origin_portname,portData.origin_region].filter(function(element) {if(element){return element}}).join(', ');
        }
        var isDublicate = originPorts.findIndex(function(port){return port.location_string ==  location}) != -1;
        if(!isDublicate){
          originPorts.push({'location_string':location,'is_major_port':is_major_port,'is_icd_port':portData.is_icd_port_origin,'icon':icon});
        }
      });
      return originPorts;
    }

    function getDestination(mode,cards){
    var destinationPorts = [];
    cards.forEach(function (card){
      var  location = '';
      var  is_major_port = '';
      var  portData = card.meta.port_data;
      var icon = mode == 'AIR'  ? 'assets/icons/custom/search-bar/air_pod.svg':'';
      if(!icon){
        if(portData.delivery_location || portData.delivery_pincode_ui){
           icon = 'assets/icons/custom/search-bar/door.svg';
        }else{
          if(portData.is_icd_port_destination){
            icon = 'assets/icons/custom/search-bar/icd.svg';
          }else{
            icon = 'assets/icons/custom/search-bar/port.svg';
          }
        }
      }
      if(portData.delivery_location || portData.delivery_pincode_ui){
        location = [portData.delivery_location ,portData.delivery_pincode_ui,portData.delivery_country_name].filter(function(element) {if(element){return element}}).join(', ');
      }else{
        location = [portData.destination_port_code,portData.destination_portname,portData.destination_region].filter(function(element) {if(element){return element}}).join(', ');
      }
      var isDublicate = destinationPorts.findIndex(function(port){return port.location_string ==  location}) != -1;
      if(!isDublicate){
        destinationPorts.push({'location_string':location,'is_major_port':is_major_port,'is_icd_port':portData.is_icd_port_destination,'icon':icon});
      }
    });
    return destinationPorts;
    }
    function getSearchParamOrigin(search_param){
      var originPorts = []
      search_param.user_nearby_origin.forEach(function(port){
        var icon =  search_param.mode !== 'AIR' ? (port.place_type !== 'Door' ? 
           ((!search_param.is_icd_port && search_param.is_major_port) || (search_param.is_icd_port && search_param.is_major_port) || (!search_param.is_icd_port && !search_param.is_major_port) ? 'assets/icons/custom/search-bar/port.svg' : 'assets/icons/custom/search-bar/icd.svg') : 'assets/icons/custom/search-bar/door.svg') : 'assets/icons/custom/search-bar/air_pod.svg';
         originPorts.push({'location_string':port.location_string,'is_major_port':port.is_major_port,'is_icd_port':port.is_icd_port,'icon':icon});
         
       });
       return originPorts;
    }

    function bookingCardsFromPayload(data) {
      if (!data) {
        return [];
      }
      if (angular.isArray(data.cards) && data.cards.length) {
        return data.cards;
      }
      if (data.card) {
        return [data.card];
      }
      return [];
    }

    function applyBookingBridgePayload(data) {
      var cards = bookingCardsFromPayload(data);
      util_service.bookingData.card = cards[0] || data.card;
      util_service.bookingData.cards = cards;
      util_service.bookingData.bookingData = data.bookingData;
      util_service.bookingData.source = data.source;
      util_service.bookingData.mode = data.mode;
      util_service.bookingData.pageSource = data.pageSource;
      util_service.bookingData.from = data.from;
      util_service.bookingData.bookingId = data.bookingId;
      util_service.bookingData.termsAndCondition = data.termsAndCondition || null;
      util_service.bookingData.resumeChargeDetails = !!data.resumeChargeDetails;
      util_service.bookingData.headerFormValue = data.headerFormValue || null;
      util_service.bookingData.existingCardCountForBasket = data.existingCardCountForBasket != null ? data.existingCardCountForBasket : 0;
    }

    function redirectToBooking(event){
      applyBookingBridgePayload(event.data);

      if (event.data.source === "create-bookingv2" || event.data.source === "editBookingV2") {
                $state.go("app.createBooking", {
                source: event.data.from
        });
     }
    }

    function redirectToOneQuote(event){
        if(event.data && event.data.selectedCard){
              if (
                event.data.pageSource === "rateRefresh" ||
                event.data.pageSource === "basketQuote"
              ) {
                util_service.oneQuoteData.refreshRate = event.data.selectedCard;
                util_service.oneQuoteData.pageSource = event.data.pageSource;
                if(event.data.pageSource === "basketQuote"){
                  angular.forEach(event.data.selectedCard,function(value){
                    if(!util_service.oneQuoteData.basketCardId){
                      util_service.oneQuoteData.basketCardId = []
                    }
                    util_service.oneQuoteData.basketCardId.push(value.cardDetails._id)
                  })
                }
              } else {
                util_service.oneQuoteData.selectedCard =
                  event.data.selectedCard;
                util_service.oneQuoteData.currencyConversion =
                  event.data.currencyConversion;
                util_service.oneQuoteData.refreshRate = [];
              }
            util_service.oneQuoteData.pageSource = event.data.pageSource;
            util_service.oneQuoteData.searchParam = event.data.searchParam;
            util_service.oneQuoteData.quoteData = event.data.quoteData;
            util_service.oneQuoteData.from = event.data.from;
              util_service.oneQuoteData.searchId = event.data.searchId;
              util_service.oneQuoteData.enquiryId = event.data.enquiryId;
            if (event.data.source === "one-quote") {
                $state.go("app.oneQuoteModule", {
                source: event.data.from
                });
            }
          }
    }

    function getSearchParamDestination(search_param){
      var destinationPorts = [];
      search_param.user_nearby_destination.forEach(function(port){
        var icon =  search_param.mode !== 'AIR' ? (port.place_type !== 'Door' ? 
          ((!search_param.is_icd_port && search_param.is_major_port) || (search_param.is_icd_port && search_param.is_major_port) || (!search_param.is_icd_port && !search_param.is_major_port) ? 'assets/icons/custom/search-bar/port.svg' : 'assets/icons/custom/search-bar/icd.svg') : 'assets/icons/custom/search-bar/door.svg') : 'assets/icons/custom/search-bar/air_pod.svg';
        destinationPorts.push({'location_string':port.location_string,'is_major_port':port.is_major_port,'is_icd_port':port.is_icd_port,'icon':icon});
      });
      return destinationPorts;
    }

    function fnCopyID(copyedText){
      util_service.callMixpanel('ContractId-Copy-Click');
      var temp_input = $("<input>");
      $("body").append(temp_input);
      temp_input.id = 'tempCopyToClipboard';
      temp_input.val(copyedText).select();
      document.execCommand("copy");
      temp_input.remove();
      util_service.showToast('Contract Number Copied!' , '','');
    }

    function escapeHtml(unsafe) {      
      if(unsafe){
      return unsafe
        .replace(/constructor\s*\./g, '')
        .replace(/\blocation\s*=/g, '')
        .replace(/javascript\s*:/g, '')
        .replace(/onerror\s*=/g, '')
        .replace(/\$eval\(/g, '')
        .replace(/{{/g, '')
        .replace(/}}/g, '')
        .replace(/\{\{([^}]*)(constructor|prototype|__proto__|window|localStorage|sessionStorage)([^}]*)\}\}/g, '')
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      }
      else {
        return unsafe
      }
    }

    function sanitizeUrl(unsafe) {
      if(unsafe){
        return escapeHtml(unsafe).replace(/"/g, "&;").replace(/'/g, "&#x27;"); 
      }else{
        return unsafe
      }
    }

    function sanitizeQueryParams(url) {
        if(!url){
          return;
        }
        var urlParts = url.split('?');
        if (urlParts.length < 2) {
          return sanitizeUrl(url); // No query parameters to sanitize
        }

        var baseUrl = urlParts[0];
        var queryString = urlParts[1];
        var sanitizedParams = queryString.split('&').map(function (param) {
            var parts = param.split('=');
            var key = parts[0];
            var value = parts[1] ? encodeURIComponent(sanitizeUrl(decodeURIComponent(parts[1]))) : '';
            return key + '=' + value;
        });
        return baseUrl + '?' + sanitizedParams.join('&');
    }

    function decodeValue(value) {
      var decodedString = value;
      if (value) {
        try {
            var tempDecoded = decodeURIComponent(decodeURIComponent(value));
            
            // Check if further decoding is possible
            if (tempDecoded !== value) {
                return decodeValue(tempDecoded); // Recursively decode if needed
            }
            
            decodedString = tempDecoded;
        } catch (e) {
            // If decoding fails, return original value
            decodedString = value;
        }
    }
      return decodedString;
    }

    function encodeValue(value) {
      return value ? encodeURIComponent(encodeURIComponent(angular.copy(value))) : '';
    }

    function showRateIdForContract(tags) {
      var isContractPresent;
      if(tags && tags.length){
        isContractPresent = tags.some(function(tag) {
          return tag.tag_type === "contract";
        });
      }
      return !(isContractPresent && $rootScope.domainData.domain_info.HIDE_CONTRACT_API_RATE_ID);
    }

    function checkKeyPresent(data, category, mode) {
      // Ensure the category and mode exist before accessing them
      if (!data || typeof data !== 'object' || !data[category] || !data[category][mode]) {
          return null;
      }
      return data[category][mode]; // Return the array of values
    }
  }
})();

(function()
{

    'use strict';

    angular
        .module('fuse')
        .factory('iframeService', iframeService);

    /** @ngInject */
    function iframeService(localStorageService, local_host_name, apiUrl,dauUrl, $rootScope, util,environment ,mixPanelToken, notificationUrl ){
        var iframe_service =  {
            fnGetIframeUrl : fnGetIframeUrl,
            calculateMaxHeight : calculateMaxHeight,
            getIntegrationUrl : getIntegrationUrl,
            appendQuery : appendQuery,
            authvalue :  localStorageService.get("authToken").value,
            iframeHeight : {
                'height': 600,
                'max-height': 600
            },
            notAllowIframeLink : ['standard-quotation','polling','fcl-result','generate-quotation','create-booking','RFQ','add-to-quote','lclMatrixView','tariff-pages','tariffHeaderList','uploadRatesV2','redirectToHome','tariffList','fileList','fcl-v2-result','lcl-v2-result','air-v2-result','one-quote','quotes']
        };
        return iframe_service;

        function appendQuery(url, extra) {
            if (!url || !extra) {
                return url;
            }
            var hashIndex = url.indexOf('#');
            if (hashIndex === -1) {
                return url + extra;
            }
            return url.slice(0, hashIndex) + extra + url.slice(hashIndex);
        }

        function getIntegrationUrl(appName){
            var authvalue = localStorageService.get("authToken").value;
            var iframeUrl ="";
            var type = appName.includes("manageNotification") ? "manageNotification": appName;
            switch (type) {
              case 'dauFclLeg':
                iframeUrl = dauUrl+"/fcl"; 
                break;
              case 'bulkUpdate':
                iframeUrl = dauUrl+"/task-executor";
                break;
              case 'manageNotification':
               iframeUrl = notificationUrl+"/subscription-v2"
               break;
              default:
                iframeUrl = dauUrl+"/audit-trail";
            }

            iframeUrl += "?source=platform";
            if(type === "manageNotification"){
              iframeUrl += "&level=" + (appName.includes('profile') ? "self" : "admin");
               if(appName.includes('profile')){
                iframeUrl += "&userId="+authvalue.user_id;
               }
            }
            iframeUrl += authvalue.vendor_id ? "&vendorId="+ authvalue.vendor_id : "";
            iframeUrl += authvalue.vendor_name ? "&vendorName="+ authvalue.vendor_name : "";
            iframeUrl +=$rootScope.domainData.host_name?"&refererDomain="+$rootScope.domainData.host_name : "";
            iframeUrl += "&fb-primary="+document.documentElement.style.getPropertyValue('--fb-primary')+
             "&fb-accent="+document.documentElement.style.getPropertyValue('--fb-accent')+
             "&fb-font-family="+document.documentElement.style.getPropertyValue('--fb-font-family')+
             "&fb-font-family-regular="+document.documentElement.style.getPropertyValue('--fb-font-family-regular')+
             "&fb-font-family-bold="+document.documentElement.style.getPropertyValue('--fb-font-family-bold')+
             "&fb-font-family-extrabold="+document.documentElement.style.getPropertyValue('--fb-font-family-extrabold')+
             "&fb-accent-text-color="+document.documentElement.style.getPropertyValue('--fb-accent-text-color')+
             "&fb-accent-btn-hover="+document.documentElement.style.getPropertyValue('--fb-accent-btn-hover');
            iframeUrl += "&var=25032021" + new Date().getHours();
            iframeUrl += "#token=" + encodeURIComponent(authvalue.access_token);
          return iframeUrl;
        }
        function fnGetIframeUrl(appName, moduleName,projectName){
          var authvalue = localStorageService.get("authToken").value;
          var forwarderStorage = localStorageService.get("forwarder") && localStorageService.get("forwarder").value ? localStorageService.get("forwarder").value : null;
          var forwarderId = forwarderStorage ? forwarderStorage.id : null;
          var effectiveVendorId = null;
          var effectiveVendorName = null;
          if (util.isFreightbro && forwarderStorage && forwarderStorage.vendor_id && forwarderId !== authvalue.user_company_id) {
            effectiveVendorId = forwarderStorage.vendor_id;
            effectiveVendorName = forwarderStorage.vendor_name || forwarderStorage.company_name || authvalue.vendor_name;
          } else if ($rootScope.vendor_id) {
            effectiveVendorId = $rootScope.vendor_id;
            effectiveVendorName = authvalue.vendor_name;
          } else {
            effectiveVendorId = authvalue.vendor_id;
            effectiveVendorName = authvalue.vendor_name;
          }


          // var iframeUrl = "http://localhost:4200/";
          var iframeUrl = (appName === 'FtlResult' || appName === 'standard-quotation' || appName === 'cdm' || appName == 'cdm-audit-trail' || appName == 'cdm-download' ||  appName.includes("rates/") || appName === 'databrain' || appName === 'carrier-integration' || appName === 'my-rates' || appName.includes('tariff/files') || appName.includes('tariff') ||  appName.includes('tariff/headers') || appName === 'lcl-matrix-view' || projectName === 'web') ? "https://client.freightify.com/" : "https://rules.freightbro.com/";

          var host_name =  window.location.hostname.replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/)[0];
          host_name = ((host_name.indexOf('localhost')) > -1 || (host_name.indexOf('192.168')) > -1) ? local_host_name : host_name;

          var module_permission = util.navPermission[moduleName ? moduleName : appName];

          iframeUrl += "" + appName + "/shared?localHostName=" +host_name+ "&serverUrl="+ apiUrl +"&environment="+environment+  "&userCompany="+ authvalue.user_company_id + "&user_category=" + authvalue.user_category + "&module_permission=" + module_permission + "&user_id="+authvalue.user_id+ "&mixpanel_token="+mixPanelToken;
          iframeUrl += forwarderId ? '&forwarder_id='+ forwarderId : "";
          if (util.isFreightbro && forwarderStorage && !forwarderStorage.is_own && forwarderStorage.domain && forwarderId !== authvalue.user_company_id) {
            iframeUrl += "&forwarder_domain=" + encodeURIComponent(forwarderStorage.domain);
          }
          iframeUrl += effectiveVendorId ? "&vendor_id="+  effectiveVendorId : "";
          iframeUrl += effectiveVendorName ? "&vendor_name="+  util.escapeHtml(effectiveVendorName) : "";
          iframeUrl +=  "&id="+ authvalue.user_id;
          iframeUrl += "&var=25032021" + new Date().getHours();
          iframeUrl += "#token=" + encodeURIComponent(authvalue.access_token);
          return iframeUrl;
        }
        // set iframe height
        function calculateMaxHeight(windowHeight){
            iframeService.iframeHeight = {
              "max-height" : windowHeight-58-28,
              "height" : windowHeight-58-28
            };
            
            return iframeService.iframeHeight;
        }

    }

})();
(function () {

  'use strict';

  angular
    .module('fuse')
    .factory('fcmService', fcmService);

  /** @ngInject */
  function fcmService() {
    return {
      callFcmToken: callFcmToken
    };

    function callFcmToken() {
      // Push notifications via Firebase are disabled.
    }
  }

})();

(function()
{

    'use strict';

    angular
        .module('fuse')
        .factory('analytics', analyticsService);

    /** @ngInject */
    function analyticsService($filter){
        var analytics_service =  {
          track : track,
          identifyUser : _identify,
          peopleProperties :_people,
          returnCode: null,
          url : sanitizeQueryParams(window.location.href),
          setSharableFlags : setSharableFlags,
          //search.controller.js
          // trackingFclRateSearched : trackingFclRateSearched,
          // trackingLclRateSearched : trackingLclRateSearched,
          // trackingAirRateSearched : trackingAirRateSearched,
          // trackingSpecialRateSearched : trackingSpecialRateSearched,
          // trackingSearchHistorySearched : trackingSearchHistorySearched,
          // trackingAdvancedSearchUsed : trackingAdvancedSearchUsed,
          // //resultcontroller.js
          // trackingRateCardDetailsBookNowScreen : trackingRateCardDetailsBookNowScreen,
          // trackingRateDetailsTabQuoteDetailsPage : trackingRateDetailsTabQuoteDetailsPage,
          // trackingFclRateCardDetails : trackingFclRateCardDetails,
          // trackingFclRateDetailsTab : trackingFclRateDetailsTab,
          // trackingFclSceduleTab : trackingFclSceduleTab,
          // trackingFclAnalyticsTab : trackingFclAnalyticsTab,
          // trackingFclQuotationTab : trackingFclQuotationTab,
          // trackingFclAddNewLeg : trackingFclAddNewLeg,
          // //quoteDetails.controller.js
          // trackingBookNow : trackingBookNow,
          // getResultData : getResultData


        };
        return analytics_service;

        function track(event, obj) {
            if(typeof analytics_service.returnCode !== 'boolean') {
              analytics_service.setSharableFlags();
            }
            if(!analytics_service.returnCode) {
              mixpanel.track(event, obj);
            }

        }
        function _identify(event){
          mixpanel.identify(event);
        }
        function _people(obj){
          mixpanel.people.set(obj);
        }

        function setSharableFlags() {
          if (analytics_service.url.split('uuid')[1] !== '' &&
                analytics_service.url.split('uuid')[1] !== '/' &&
                analytics_service.url.split('uuid')[1] !== undefined
            ) {
              analytics_service.returnCode = true;
            } else if(analytics_service.url.split('shared/')[1] !== '' &&
            analytics_service.url.split('shared/')[1] !== '/' &&
            analytics_service.url.split('shared/')[1] !== undefined) {
              analytics_service.returnCode = true;
            } else if(analytics_service.url.split('web_view')[1] !== '' &&
            analytics_service.url.split('web_view')[1] !== '/' &&
            analytics_service.url.split('web_view')[1] !== undefined) {
              analytics_service.returnCode = true;
            } else {
              analytics_service.returnCode = false;
            }
        }


        // function getResultData(type,subvendor,cards){
        //   analytics.track("Rates details",{
        //     "Rate type" : type,
        //     "Liner list" : subvendor,
        //     "No. of rate card" :cards.length,
            // "highest rates" : $filter('orderBy')(cards, 'meta.buy_leg_total'),
            // "lowesr rates" : $filter('orderBy')(cards, '-meta.buy_leg_total')
          // });
        // }
        //search.contoller.js

        // function trackingFclRateSearched(event,event_prop_obj){
        //   analytics_service.track("FclRateSearched",event_prop_obj);
        // }
        // function trackingLclRateSearched(event,event_prop_obj){
        //   analytics_service.track("LclRateSearched",event_prop_obj);
        // }
        // function trackingAirRateSearched(event,event_prop_obj){
        //   analytics_service.track("AirRateSearched",event_prop_obj);
        // }
        // function trackingSpecialRateSearched(event,event_prop_obj){
        //   analytics_service.track("SpecialRateSearched",event_prop_obj);
        // }
        // function trackingSearchHistorySearched(event,event_prop_obj){
        //   analytics_service.track("SearchHistorySearched",event_prop_obj);
        // }
        // function trackingAdvancedSearchUsed(event){
        //   analytics_service.track("AdvancedSearchUsed");
        // }
        // //quoteDetails.controller.js

        // function trackingRateDetailsTabQuoteDetailsPage (event){
        //   analytics_service.track("Rate Details tab, Quote Details Page")
        // }
        // function trackingBookNow (event){
        //   analytics_service.track("Book Now-Quote Details Screen")
        // }
        // //result.contoller,js
        // function trackingFclRateCardDetails (event){
        //   analytics_service.track("Fcl-Rate Card Details")
        // }
        // function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }
        // function trackingFclSceduleTab (event){
        //   analytics_service.track("Fcl-Schedule Tab")
        // }
        // //
        // function trackingFclAnalyticsTab (event){
        //   analytics_service.track("Fcl-Analytics Tab")
        // }
        // function trackingFclQuotationTab (event){
        //   analytics_service.track("Fcl-Quotation Tab")
        // }
        // function trackingFclAddNewLeg (event){
        //   analytics_service.track("Fcl-Add New leg")
        // }

        // function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }function trackingFclRateDetailsTab (event){
        //   analytics_service.track("Fcl-Rate Details Tab")
        // }


      function sanitizeUrl(unsafe) {
          return unsafe
          .replace(/constructor\s*\./g, '')               // Remove constructor accesses
          .replace(/\blocation\s*=/g, '')                  // Remove location assignment
          .replace(/javascript\s*:/g, '')                  // Prevent javascript URIs
          .replace(/onerror\s*=/g, '')                     // Remove 'onerror' attributes (XSS risk)
          .replace(/\$eval\(/g, '')                        // Remove AngularJS $eval (Angular-specific XSS)
          .replace(/{{/g, '')                              // Remove AngularJS template expressions (must be handled with Angular $sanitize)
          .replace(/}}/g, '')                              // Remove AngularJS template expressions
          .replace(/\{\{([^}]*)(constructor|prototype|__proto__|window|localStorage|sessionStorage)([^}]*)\}\}/g, '') // Strip dangerous code
          .replace(/&/g, "&amp;")                          // Escape ampersand to prevent HTML entity injection
          .replace(/</g, "&lt;")                           // Escape less-than sign to prevent HTML injection
          .replace(/>/g, "&gt;")                           // Escape greater-than sign to prevent HTML injection
          .replace(/"/g, "&quot;")                         // Escape double quotes
          .replace(/'/g, "&#x27;"); 
      }

      function sanitizeQueryParams(url) {
        if(!url){
          return;
        }
        var urlParts = url.split('?');
        if (urlParts.length < 2) {
          return sanitizeUrl(url); // No query parameters to sanitize
        }

        var baseUrl = urlParts[0];
        var queryString = urlParts[1];
        var sanitizedParams = queryString.split('&').map(function (param) {
            var parts = param.split('=');
            var key = parts[0];
            var value = parts[1] ? encodeURIComponent(sanitizeUrl(decodeURIComponent(parts[1]))) : '';
            return key + '=' + value;
        });
        return baseUrl + '?' + sanitizedParams.join('&');
      }


    }




  }
)();


(function ()
{
    'use strict';

    angular.module('fuse')
    .factory('apiInterceptor',  apiInterceptorService)

    /** @ngInject */
    function apiInterceptorService(localStorageService,$q,$rootScope,apiUrl, efpUrl, $log, $window,local_host_name, $location , environment , airbrakeId ,airbrakeKey ){
        var service = {
            request : request,
            // requestError : requestError ,
            response : response,
            responseError : responseError,
            // getHostName : getHostName
        }
        return service;

        /**
         *
         * @param {*} config
         */
        function request(config){
            $rootScope.loadingProgress = true;
            var host_name =  window.location.hostname.replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/)[0];
            host_name = ((host_name.indexOf('localhost')) > -1 || (host_name.indexOf('192.168')) > -1) ? local_host_name : host_name;
            config.headers['referer-domain'] = host_name;

            if((config.url.includes('/api/shipments/') || config.url.includes('users-list')) && $rootScope.forwarder_id){
                config.url += '?forwarder_company_id='+ $rootScope.forwarder_id;
            }

            var token  = localStorageService.get('authToken');

            if(config.url.indexOf(apiUrl) > -1 && config.url.indexOf(apiUrl +'/oauth/token') < 0 ){

                var url = config.url.split("?")[0];

                if(url.indexOf('shared') > -1 && (config.method !=='GET' || url.indexOf('document-zip') > -1 )) {
                    var otp  = localStorage.getItem('otp');
                    if(otp !==  null && otp !== undefined){
                        config.headers['otp'] =  localStorageService.otp;
                    }
                } else if(!(url.indexOf('shared') > -1)) {
                    if(token !=  null && !!token.value){
                        config.headers['Authorization'] =  token.value.token_type + ' ' + token.value.access_token;
                    }
                }
            }

            if(config.url.indexOf(efpUrl) > -1){
                if(token !=  null && !!token.value){
                    config.headers['authorization'] =  token.value.token_type + ' ' + token.value.access_token;
                }
            }
            
            var firstQuestionMarkIndex = config.url.indexOf('?');
            if(firstQuestionMarkIndex > -1){
                var path = config.url.slice(0, firstQuestionMarkIndex);
                var queryString = config.url.slice(firstQuestionMarkIndex + 1);
                var parts = queryString.split('&');
                var fixedParts = [];
                
                for(var i = 0; i < parts.length; i++) {
                    var part = parts[i];
                    if(part.indexOf('=') > -1) {
                        var param = part;
                        
                        while(i + 1 < parts.length && parts[i + 1].indexOf('=') === -1) {
                            param += '&' + parts[++i];
                        }
                        
                        var keyValue = param.split('=');
                        var key = keyValue[0];
                        var value = keyValue.slice(1).join('=');
                        
                        if(key.length > 0) fixedParts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
                    }
                }
                
                config.url = path + (fixedParts.length > 0 ? '?' + fixedParts.join('&') : '');
            }
              return config;
        }

        /**
         *
         * @param {*} rejection
         */
        function responseError(rejection){
            // passing response errors to Airbrake
              var airbrake = new airbrakeJs.Client({
                projectId: airbrakeId ,
                projectKey: airbrakeKey
              });
                airbrake.addFilter(function (notice) {
                notice.context.environment = environment;
                // notice.context.ERROR_TYPE = 'API Error';
                return notice;
              });

                 var host_name =  window.location.hostname.replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/)[0];
                 var is_sent = !((host_name.indexOf('localhost')) > -1 || (host_name.indexOf('192.168')) > -1);
                 var url = new URL(rejection.config.url);
                 var end_point = url.pathname;
                 var error_msg = 'API Error: API request' +'(' + end_point +')'+ ' failed with status ' +  rejection.status
               //  remove this condition to check locally  
                if(is_sent){
                     airbrake.notify({error: error_msg,context: { ERROR_TYPE: 'API Error',PROJECT_NAME:'fb-shipper-frontend' }, params: {error_object : rejection }});
                 }
              // **** Airbrake End ****

            if(rejection.data && rejection.data.status === 'redirect'){
                alert('This Link has been updated. Redirecting to the updated link.');
                  // $timeout(function () {
                    window.location = sanitizeQueryParams(rejection.data.url);
                  // }, 1000);
                }
            $rootScope.loadingProgress = false;

            if(!navigator.onLine ){
                $rootScope.state.go('app.pages_errors_error-internet');
            }

            if(rejection.status === 500){
                if(rejection.config.method == 'GET' && rejection.config.url.indexOf('api') == -1 && rejection.config.url.indexOf('shared') == -1){
                    $rootScope.state.go('app.pages_errors_error-500');
                }
            }
            if(rejection.status === 503){
                if((rejection.config.method == 'GET' || rejection.config.method == 'POST' )&& rejection.config.url.indexOf('shared') == -1){
                    $rootScope.message_503=rejection.data.Error.message;
                    $rootScope.state.go('app.pages_errors_error-503');
                }
            }
            if(rejection.status === 403){
                // shipment details shared api access otp expired..
                if(rejection.data.message === 'OTP Expired'){
                    $rootScope.$broadcast('apiResponseOtpExpired');
                }

                if(rejection.config.method == 'GET' && rejection.config.url.indexOf('api') == -1 && rejection.config.url.indexOf('shared') == -1){
                    $rootScope.state.go('app.pages_share_error');
                }
            }

            if (rejection.status === 401) {
                localStorageService.set('authToken', {});
                // $location.path('/login');
                if(!$rootScope.state){
                   $location.path('/login');
                } else {
                  $rootScope.state.go('app.pages_auth_login-v2');
                }
            }

            return $q.reject(rejection);
            // return response;
        }

        /**
         *
         * @param {*} config
         */
        // function requestError(config){

        // }

        /**
         *
         * @param {*} config
         */
        function response(response){
          $rootScope.loadingProgress = false;

          if(!$rootScope.firstLoad && response.headers('frontend_app_version')){
            localStorageService.set('appVersion', response.headers('frontend_app_version'));
            $rootScope.firstLoad = true;
          }

          if(response.headers('frontend_app_version') != null && (localStorageService.get('appVersion') == undefined || response.headers('frontend_app_version') != localStorageService.get('appVersion').value)){
            // console.log(response.headers('frontend_app_version'));
            $rootScope.domainData["version"] = response.headers('frontend_app_version');
            $rootScope.ifVersionUpdate = true;

          }
          return response;
        }

        function sanitizeUrl(unsafe) {
            return unsafe
            .replace(/constructor\s*\./g, '')               // Remove constructor accesses
            .replace(/\blocation\s*=/g, '')                  // Remove location assignment
            .replace(/javascript\s*:/g, '')                  // Prevent javascript URIs
            .replace(/onerror\s*=/g, '')                     // Remove 'onerror' attributes (XSS risk)
            .replace(/\$eval\(/g, '')                        // Remove AngularJS $eval (Angular-specific XSS)
            .replace(/{{/g, '')                              // Remove AngularJS template expressions (must be handled with Angular $sanitize)
            .replace(/}}/g, '')                              // Remove AngularJS template expressions
            .replace(/\{\{([^}]*)(constructor|prototype|__proto__|window|localStorage|sessionStorage)([^}]*)\}\}/g, '') // Strip dangerous code
            .replace(/&/g, "&amp;")                          // Escape ampersand to prevent HTML entity injection
            .replace(/</g, "&lt;")                           // Escape less-than sign to prevent HTML injection
            .replace(/>/g, "&gt;")                           // Escape greater-than sign to prevent HTML injection
            .replace(/"/g, "&quot;")                         // Escape double quotes
            .replace(/'/g, "&#x27;"); 
        }
    
        function sanitizeQueryParams(url) {
          if(!url){
            return;
          }
          var urlParts = url.split('?');
          if (urlParts.length < 2) {
            return sanitizeUrl(url); // No query parameters to sanitize
          }
    
          var baseUrl = urlParts[0];
          var queryString = urlParts[1];
          var sanitizedParams = queryString.split('&').map(function (param) {
              var parts = param.split('=');
              var key = parts[0];
              var value = parts[1] ? encodeURIComponent(sanitizeUrl(decodeURIComponent(parts[1]))) : '';
              return key + '=' + value;
          });
          return baseUrl + '?' + sanitizedParams.join('&');
        }


    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope,loginSerivice, util)
    {
        // Data
        //////////
        var vm = this;
        vm.util = util;
        vm.isPublicPage = util.sanitizeUrl(window.location.pathname)=='/exchange-rates' && !loginSerivice.isLogin();
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope, loginSerivice, $location,$transitions,util) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = true;
    vm.util = util;
    // if(util.activatedTheme==='transpost')
    // {
    //   document.getElementById("vertical-navigation").style.background = "linear-gradient(184deg, #019688 0%, #21D9B3 100%)";
    // }

    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $transitions.onStart({}, function() {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }

})();

(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyConverter = void 0;
var InvalidArgumentError_1 = require("../exceptions/InvalidArgumentError");
var CurrencyConverter = /** @class */ (function () {
    function CurrencyConverter(currencySetting) {
        if (currencySetting == null) {
            throw new InvalidArgumentError_1.InvalidArgumentError('currencySetting is required.');
        }
        this.currencySetting = currencySetting;
    }
    /**
     * Returns instance of the class by accepting currency setting input.
     * @param currencySetting
     * @returns
     */
    CurrencyConverter.getInstance = function (currencySetting) {
        return new CurrencyConverter(currencySetting);
    };
    /**
     * Converts the currency value based on from and to rates.
     * @param amount
     * @param fromCurrency
     * @param toCurrency
     * @returns
     */
    CurrencyConverter.prototype.convert = function (amount, fromCurrency, toCurrency, applyMarkup) {
        if (applyMarkup === void 0) { applyMarkup = true; }
        if (fromCurrency === toCurrency) {
            return amount;
        }
        var rate = this.currencySetting.rate(fromCurrency, toCurrency, applyMarkup);
        if (this.currencySetting.isDirectRate(fromCurrency, toCurrency) || !this.currencySetting.markup || !applyMarkup) {
            return amount * rate;
        }
        return amount * (rate * (1 + (this.currencySetting.markup || 0)));
        // return Math.abs(amount * rate * this.currencySetting.markup) + amount * rate;
    };
    return CurrencyConverter;
}());
exports.CurrencyConverter = CurrencyConverter;

},{"../exceptions/InvalidArgumentError":9}],2:[function(require,module,exports){
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hashtree = void 0;
var Utils_1 = require("./Utils");
// For making data property as private within hashtree
var data = Symbol();
// const wildKeys = Symbol();
/**
 * Hashtree datastructure implementation. This implementation is done based on
 * Composite Design Pattern.
 *
 * Use Cases:
 * 1. Can be used for storing configuration in hierarchical structure.
 * 2. Can be used for finding duplicate keys from heirarchical data based on its set function boolean result.
 * 3. Advance conflicts detection using wildcard
 *
 * @author Karthik Elayaperumal
 * @since v1.0.0
 */
var Hashtree = /** @class */ (function () {
    /**
     * Default constructor of the class.
     * @param {String} delimiter Default value would be .(dot). Delimiter for building hashtree
     */
    function Hashtree(delimiter, wildcard) {
        if (delimiter === void 0) { delimiter = '.'; }
        if (wildcard === void 0) { wildcard = '*'; }
        this.delimiter = delimiter;
        this.wildcard = wildcard;
        this[data] = {};
        // (this as any)[wildKeys] = [];
        this.wildCardMap = new Map();
    }
    /**
     * Sets value in hashtree
     * @param {String} key String for building the heirarchy with delimiters.
     * @param {Object} value Scalar value which needs to be stored against hash tree.
     * @param {Boolean} overwrite Scalar value which needs to be stored against hash tree.
     * @returns {Boolean} If value is set in hashtree then true will be returned else false will be returned.
     */
    Hashtree.prototype.set = function (key, value, overwrite) {
        var _a;
        if (overwrite === void 0) { overwrite = false; }
        if (key === undefined || value === undefined) {
            return false;
        }
        var keys = key.split(this.delimiter);
        var lastKey = (_a = keys.pop()) !== null && _a !== void 0 ? _a : '';
        var self = this;
        var tmp = self[data];
        // the below loop does not checks in last key
        var isWildCardPresent = lastKey === this.wildcard;
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            if (k === this.wildcard)
                isWildCardPresent = true;
            if (tmp[k] && !Utils_1.Utils.isObject(tmp[k])) {
                return false;
            }
            if (!tmp[k]) {
                tmp[k] = {};
            }
            if (hasOwnProperty.call(tmp, k)) {
                tmp = tmp[k];
            }
        }
        if (!overwrite && !Utils_1.Utils.isObject(value) && (Utils_1.Utils.isScalar(tmp[lastKey]) || Utils_1.Utils.isObject(tmp[lastKey]))) {
            return false;
        }
        tmp[lastKey] = value;
        if (isWildCardPresent && !this.wildCardMap.has(key)) {
            this.wildCardMap.set(key, true);
        }
        return true;
    };
    /**
     * Retrieves value from hashtree for specified key.
     * @param {String} key
     * @returns {Object} Either value or subtree.
     */
    Hashtree.prototype.get = function (key) {
        var keys = key.split(this.delimiter);
        if (keys === undefined) {
            return null;
        }
        var self = this;
        var tmp = self[data];
        for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
            var k = keys_2[_i];
            if (Utils_1.Utils.isObject(tmp)) {
                tmp = tmp[k];
            }
            else {
                tmp = undefined;
                break;
            }
        }
        if (tmp && Utils_1.Utils.isObject(tmp)) {
            var subTree = new Hashtree(this.delimiter);
            subTree[data] = tmp;
            return subTree;
        }
        return tmp;
    };
    /**
     * Return the container data from the config.
     */
    Hashtree.prototype.getData = function () {
        return this[data];
    };
    /**
     * Retrieves value from hashtree for specified key.
     * @param {String} key
     * @returns {boolean} Boolean If exist true else false will be returned.
     */
    Hashtree.prototype.hasKey = function (key) {
        var keys = key.split(this.delimiter);
        if (keys === undefined) {
            return null;
        }
        var self = this;
        var tmp = self[data];
        for (var _i = 0, keys_3 = keys; _i < keys_3.length; _i++) {
            var k = keys_3[_i];
            if (Utils_1.Utils.isObject(tmp)) {
                tmp = tmp[k];
            }
            else {
                tmp = undefined;
                break;
            }
        }
        return tmp !== undefined;
    };
    /**
     * Removes the key from hashtree
     * @param {String} key Key to be removed from hashtree.
     * @returns {Boolean} If element removed from hashtree then true will be returned else false.
     */
    Hashtree.prototype.remove = function (key) {
        var _a;
        var keys = key.split(this.delimiter);
        if (!keys) {
            return false;
        }
        var self = this;
        var lastKey = (_a = keys.pop()) !== null && _a !== void 0 ? _a : '';
        var tmp = this.get(keys.join(this.delimiter));
        if (tmp && tmp[data][lastKey]) {
            delete tmp[data][lastKey];
            return true;
        }
        else if (self[data][key]) {
            delete self[data][key];
            return true;
        }
        return false;
    };
    /**
     * Retrieves values based on priority match.
     */
    Hashtree.prototype.priorityGet = function (key) {
        var keys = key.split(this.delimiter);
        if (keys === undefined) {
            return null;
        }
        var self = this;
        var tmp = self[data];
        for (var _i = 0, keys_4 = keys; _i < keys_4.length; _i++) {
            var k = keys_4[_i];
            if (Utils_1.Utils.isObject(tmp) && hasOwnProperty.call(tmp, k)) {
                tmp = tmp[k];
            }
            else if (hasOwnProperty.call(tmp, this.wildcard)) {
                tmp = tmp[this.wildcard];
            }
            else {
                tmp = undefined;
                break;
            }
        }
        if (tmp && Utils_1.Utils.isObject(tmp)) {
            var subTree = new Hashtree(this.delimiter);
            subTree[data] = tmp;
            return subTree;
        }
        return tmp;
    };
    /**
     * Retrieves conflicting keys based on wildcards in its tree path.
     * The result would be two dimensional array.
     */
    Hashtree.prototype.conflicts = function () {
        var _this = this;
        var result = [];
        if (!this.wildCardMap.size) {
            return result;
        }
        this.wildCardMap.forEach(function (val, wk) {
            var wkKeys = wk.split(_this.delimiter);
            var baseKeyLastIndex = wk.indexOf(_this.wildcard) - 1;
            var baseKey = wk.substring(0, baseKeyLastIndex);
            var baseLevel = baseKey.split(_this.delimiter).length;
            var subTree = _this.get(baseKey);
            if (subTree) {
                var keys = Object.keys(subTree[data]);
                for (var _i = 0, keys_5 = keys; _i < keys_5.length; _i++) {
                    var key = keys_5[_i];
                    var tempSubTree = void 0;
                    tempSubTree = subTree.get(key);
                    if (Utils_1.Utils.isObject(tempSubTree)) {
                        var q = [tempSubTree];
                        var levels = [baseLevel];
                        // let level = baseLevel;
                        var baseKeys = [key];
                        while (q.length > 0) {
                            var childTree = q.shift();
                            var level = levels.shift();
                            var levelNext = level + 1;
                            var baseKey2 = baseKeys.shift();
                            var keys2 = Object.keys(childTree[data]);
                            for (var _a = 0, keys2_1 = keys2; _a < keys2_1.length; _a++) {
                                var key2 = keys2_1[_a];
                                if (wkKeys[levelNext] !== _this.wildcard && wkKeys[levelNext] !== key2 && key2 !== _this.wildcard) {
                                    continue;
                                }
                                var tempChildTree = void 0;
                                tempChildTree = childTree.get(key2);
                                if (Utils_1.Utils.isScalar(tempChildTree) &&
                                    (wkKeys[levelNext] === _this.wildcard || wkKeys[levelNext] === key2)) {
                                    var leafKey = "".concat(baseKey).concat(_this.delimiter).concat(baseKey2).concat(_this.delimiter).concat(key2);
                                    if (wk !== leafKey) {
                                        result.push([wk, leafKey]);
                                    }
                                }
                                else if (Utils_1.Utils.isObject(tempChildTree)) {
                                    levels.push(levelNext);
                                    q.push(tempChildTree);
                                    baseKeys.push("".concat(baseKey2).concat(_this.delimiter).concat(key2));
                                }
                            }
                        }
                    }
                    else {
                        if (key !== _this.wildcard &&
                            Utils_1.Utils.isScalar(tempSubTree) &&
                            (wkKeys[baseLevel] === _this.wildcard || wkKeys[baseLevel] === key)) {
                            result.push([wk, "".concat(baseKey).concat(_this.delimiter).concat(key)]);
                        }
                    }
                }
            }
        });
        return result;
    };
    return Hashtree;
}());
exports.Hashtree = Hashtree;
/**
 * Function short hand reference
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;

},{"./Utils":3}],3:[function(require,module,exports){
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var scalarDir = {
    string: 1,
    number: 1,
    boolean: 1,
};
/**
 * Utility functions.
 */
var Utils = /** @class */ (function () {
    function Utils() {
    }
    /**
     * Checks if given parameter type is object or not.
     * If argument type is object true is returned else false.
     * @param {Object} o
     * @returns {Boolean} True if argument type is object else false.
     */
    Utils.isObject = function (o) {
        return typeof o === 'object';
    };
    /**
     * Checks if given parameter type is scalar type (string, number, boolean).
     * If argument type is scalar true will be returned else false.
     * @param {*} o
     * @returns {Boolean} True if argument type is scalar value else false.
     */
    Utils.isScalar = function (o) {
        return typeof o in scalarDir;
    };
    return Utils;
}());
exports.Utils = Utils;

},{}],4:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyConversion = void 0;
var CurrencyConversion = /** @class */ (function () {
    function CurrencyConversion(baseCurrency, liveRates, markup, directMapping) {
        if (markup === void 0) { markup = null; }
        if (directMapping === void 0) { directMapping = []; }
        this.baseCurrency = baseCurrency;
        this.liveRates = liveRates;
        this.markup = markup;
        this.directMapping = directMapping;
        this.convertedRates = {};
        this.init();
    }
    /*
     * This method will initialize convertedRates of base currency.
     */
    CurrencyConversion.prototype.init = function () {
        this._calculateConversionRates(this.baseCurrency);
    };
    /*
     * This method will return the markedup exchange rates of specified currency.
     *
     * @param currency
     */
    CurrencyConversion.prototype.get = function (currency) {
        if (!this.convertedRates[currency])
            this._calculateConversionRates(currency);
        return this.convertedRates[currency];
    };
    /*
     * This method will convert live rates in specified currency and apply markup and mapping to each currency if available.
     *
     * @param currency
     */
    CurrencyConversion.prototype._calculateConversionRates = function (currency) {
        var mappingObj = this._getMappingObj(currency);
        var ratesInBaseCurrency = this._convertToBaseCurrency(currency);
        var ratesWithPositiveMarkup = this._applyMarkupMapping(ratesInBaseCurrency, mappingObj, false, currency);
        var ratesWithNegativeMarkup = this._applyMarkupMapping(ratesInBaseCurrency, mappingObj, true, currency);
        this.convertedRates[currency] = { ratesWithPositiveMarkup: ratesWithPositiveMarkup, ratesWithNegativeMarkup: ratesWithNegativeMarkup };
    };
    /*
     * This method will return converted value of cost.
     *
     * @param cost
     * @param fromCurrency
     * @param toCurrency
     */
    CurrencyConversion.prototype.convert = function (cost, fromCurrency, toCurrency) {
        if (!this.convertedRates[toCurrency])
            this._calculateConversionRates(toCurrency);
        var conversionObj = cost < 0
            ? this.convertedRates[toCurrency].ratesWithNegativeMarkup
            : this.convertedRates[toCurrency].ratesWithPositiveMarkup;
        return (cost * conversionObj[toCurrency]) / conversionObj[fromCurrency];
    };
    /*
     * This method will return convert live rates to currency specified.
     *
     * @param targetCurrency
     */
    CurrencyConversion.prototype._convertToBaseCurrency = function (targetCurrency) {
        var convertedRates = {};
        for (var _i = 0, _a = Object.keys(this.liveRates); _i < _a.length; _i++) {
            var currency = _a[_i];
            convertedRates[currency] = this.liveRates[currency] / this.liveRates[targetCurrency];
        }
        return convertedRates;
    };
    /*
     * This method will return mapped (markup or direct mapping) values against each currency in ratesInBaseCurrency.
     *
     * @param ratesInBaseCurrency
     * @param mappingObj
     * @param isNegative
     * @param currency
     */
    CurrencyConversion.prototype._applyMarkupMapping = function (ratesInBaseCurrency, mappingObj, isNegative, currency) {
        var mappedRates = __assign({}, ratesInBaseCurrency);
        for (var currencyCode in ratesInBaseCurrency) {
            // dont apply markup or mapping to base currency
            if (currencyCode === currency)
                continue;
            if (mappingObj[currencyCode]) {
                mappedRates[currencyCode] = mappingObj[currencyCode];
            }
            else if (this.markup) {
                // markup is always in percentage
                var calculatedMarkup = isNegative ? 1 - this.markup / 100 : 1 + this.markup / 100;
                mappedRates[currencyCode] = ratesInBaseCurrency[currencyCode] / calculatedMarkup;
            }
        }
        return mappedRates;
    };
    /*
     * This method will return object containing the direct mapping against the specified currency.
     *
     * @param currency
     */
    CurrencyConversion.prototype._getMappingObj = function (currency) {
        if (!this.directMapping)
            return {};
        var mappedRates = {};
        this.directMapping
            .filter(function (x) { return x.sourceCurrency.code === currency || x.targetCurrency.code === currency; })
            .forEach(function (mappingObject) {
            var currencyCode = mappingObject.sourceCurrency.code === currency
                ? mappingObject.targetCurrency.code
                : mappingObject.sourceCurrency.code;
            var value = mappingObject.sourceCurrency.code === currency
                ? mappingObject.targetCurrency.value
                : mappingObject.sourceCurrency.value / mappingObject.targetCurrency.value;
            mappedRates[currencyCode] = value;
        });
        return mappedRates;
    };
    return CurrencyConversion;
}());
exports.CurrencyConversion = CurrencyConversion;

},{}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Basis = void 0;
exports.Basis = {
    PerContainer: 'per container',
    PerTeu: 'per teu',
    PerEquipment: 'per equipment',
    PerVehicle: 'per vehicle',
    ContainerBasedBasis: ['per container', 'per teu', 'per equipment', 'per vehicle'],
};

},{}],6:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainChargeIdSet = void 0;
exports.MainChargeIdSet = ['10001', '20001', '30001', '40001', '50001', '25001', '45001'];

},{}],7:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mode = void 0;
var Mode;
(function (Mode) {
    Mode["FCL"] = "SEA-FCL";
    Mode["AIR"] = "AIR";
    Mode["LCL"] = "SEA-LCL";
})(Mode = exports.Mode || (exports.Mode = {}));

},{}],8:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeDays = exports.LoadDetailsValue = exports.LoadData = exports.LegData = exports.FclLoadData = exports.FclLoadObject = exports.FclChargeSummaryModel = exports.FclChargeSummary = exports.EquipmentBasedTotal = exports.ChargeTotal = exports.Charge = exports.ChargeSummaryFactory = exports.Hashtree = exports.ExchangeRate = exports.DirectRate = exports.CurrencySetting = exports.CurrencyRate = exports.CurrencyConverter = exports.CurrencyConversion = exports.ConversionRate = void 0;
// For Frontend
var CurrencyConversion_1 = require("./common/currencyConversion/CurrencyConversion");
Object.defineProperty(exports, "CurrencyConversion", { enumerable: true, get: function () { return CurrencyConversion_1.CurrencyConversion; } });
var CurrencyConverter_1 = require("./common/CurrencyConverter");
Object.defineProperty(exports, "CurrencyConverter", { enumerable: true, get: function () { return CurrencyConverter_1.CurrencyConverter; } });
var Hashtree_1 = require("./common/Hashtree");
Object.defineProperty(exports, "Hashtree", { enumerable: true, get: function () { return Hashtree_1.Hashtree; } });
var ConversionRate_1 = require("./models/ConversionRate");
Object.defineProperty(exports, "ConversionRate", { enumerable: true, get: function () { return ConversionRate_1.ConversionRate; } });
var CurrencyRate_1 = require("./models/CurrencyRate");
Object.defineProperty(exports, "CurrencyRate", { enumerable: true, get: function () { return CurrencyRate_1.CurrencyRate; } });
var CurrencySetting_1 = require("./models/CurrencySetting");
Object.defineProperty(exports, "CurrencySetting", { enumerable: true, get: function () { return CurrencySetting_1.CurrencySetting; } });
var DirectRate_1 = require("./models/DirectRate");
Object.defineProperty(exports, "DirectRate", { enumerable: true, get: function () { return DirectRate_1.DirectRate; } });
var ExchangeRate_1 = require("./models/ExchangeRate");
Object.defineProperty(exports, "ExchangeRate", { enumerable: true, get: function () { return ExchangeRate_1.ExchangeRate; } });
var ChargeSummaryFactory_1 = require("./factories/ChargeSummaryFactory");
Object.defineProperty(exports, "ChargeSummaryFactory", { enumerable: true, get: function () { return ChargeSummaryFactory_1.ChargeSummaryFactory; } });
var FclChargeSummary_1 = require("./services/FclChargeSummary");
Object.defineProperty(exports, "FclChargeSummary", { enumerable: true, get: function () { return FclChargeSummary_1.FclChargeSummary; } });
var Charge_1 = require("./models/Charge");
Object.defineProperty(exports, "Charge", { enumerable: true, get: function () { return Charge_1.Charge; } });
var ChargeTotal_1 = require("./models/ChargeTotal");
Object.defineProperty(exports, "ChargeTotal", { enumerable: true, get: function () { return ChargeTotal_1.ChargeTotal; } });
var EquipmentBasedTotal_1 = require("./models/EquipmentBasedTotal");
Object.defineProperty(exports, "EquipmentBasedTotal", { enumerable: true, get: function () { return EquipmentBasedTotal_1.EquipmentBasedTotal; } });
var FclChargeSummary_2 = require("./models/FclChargeSummary");
Object.defineProperty(exports, "FclChargeSummaryModel", { enumerable: true, get: function () { return FclChargeSummary_2.FclChargeSummary; } });
var FclLoadObject_1 = require("./models/FclLoadObject");
Object.defineProperty(exports, "FclLoadObject", { enumerable: true, get: function () { return FclLoadObject_1.FclLoadObject; } });
var FclLoadData_1 = require("./models/FclLoadData");
Object.defineProperty(exports, "FclLoadData", { enumerable: true, get: function () { return FclLoadData_1.FclLoadData; } });
var LegData_1 = require("./models/LegData");
Object.defineProperty(exports, "LegData", { enumerable: true, get: function () { return LegData_1.LegData; } });
var LoadData_1 = require("./models/LoadData");
Object.defineProperty(exports, "LoadData", { enumerable: true, get: function () { return LoadData_1.LoadData; } });
var LoadDetailsValue_1 = require("./models/LoadDetailsValue");
Object.defineProperty(exports, "LoadDetailsValue", { enumerable: true, get: function () { return LoadDetailsValue_1.LoadDetailsValue; } });
var FreeDays_1 = require("./services/FreeDays");
Object.defineProperty(exports, "FreeDays", { enumerable: true, get: function () { return FreeDays_1.FreeDays; } });
var fbUtils = window.fbUtils || {};
fbUtils.ConversionRate = ConversionRate_1.ConversionRate;
fbUtils.CurrencyConversion = CurrencyConversion_1.CurrencyConversion;
fbUtils.CurrencyConverter = CurrencyConverter_1.CurrencyConverter;
fbUtils.CurrencyRate = CurrencyRate_1.CurrencyRate;
fbUtils.CurrencySetting = CurrencySetting_1.CurrencySetting;
fbUtils.DirectRate = DirectRate_1.DirectRate;
fbUtils.ExchangeRate = ExchangeRate_1.ExchangeRate;
fbUtils.Hashtree = Hashtree_1.Hashtree;
fbUtils.ChargeSummaryFactory = ChargeSummaryFactory_1.ChargeSummaryFactory;
fbUtils.FclChargeSummary = FclChargeSummary_1.FclChargeSummary;
fbUtils.Charge = Charge_1.Charge;
fbUtils.ChargeTotal = ChargeTotal_1.ChargeTotal;
fbUtils.EquipmentBasedTotal = EquipmentBasedTotal_1.EquipmentBasedTotal;
fbUtils.FclChargeSummaryModel = FclChargeSummary_2.FclChargeSummary;
fbUtils.FclLoadObject = FclLoadObject_1.FclLoadObject;
fbUtils.FclLoadData = FclLoadData_1.FclLoadData;
fbUtils.LegData = LegData_1.LegData;
fbUtils.LoadData = LoadData_1.LoadData;
fbUtils.LoadDetailsValue = LoadDetailsValue_1.LoadDetailsValue;
fbUtils.FreeDays = FreeDays_1.FreeDays;
window.fbUtils = fbUtils;

},{"./common/CurrencyConverter":1,"./common/Hashtree":2,"./common/currencyConversion/CurrencyConversion":4,"./factories/ChargeSummaryFactory":10,"./models/Charge":11,"./models/ChargeTotal":12,"./models/ConversionRate":13,"./models/CurrencyRate":14,"./models/CurrencySetting":15,"./models/DirectRate":16,"./models/EquipmentBasedTotal":17,"./models/ExchangeRate":18,"./models/FclChargeSummary":19,"./models/FclLoadData":20,"./models/FclLoadObject":21,"./models/LegData":22,"./models/LoadData":23,"./models/LoadDetailsValue":24,"./services/FclChargeSummary":25,"./services/FreeDays":26}],9:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidArgumentError = void 0;
var InvalidArgumentError = /** @class */ (function (_super) {
    __extends(InvalidArgumentError, _super);
    function InvalidArgumentError(message) {
        return _super.call(this, message) || this;
    }
    return InvalidArgumentError;
}(Error));
exports.InvalidArgumentError = InvalidArgumentError;

},{}],10:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeSummaryFactory = void 0;
var InvalidArgumentError_1 = require("../exceptions/InvalidArgumentError");
var FclLoadData_1 = require("../models/FclLoadData");
var FclChargeSummary_1 = require("../services/FclChargeSummary");
var Mode_1 = require("../constants/Mode");
var ChargeSummaryFactory = /** @class */ (function () {
    function ChargeSummaryFactory() {
    }
    ChargeSummaryFactory.getInstance = function (loadData, mode) {
        if (mode === Mode_1.Mode.FCL) {
            if (!loadData) {
                throw new InvalidArgumentError_1.InvalidArgumentError('LoadData is required.');
            }
            var loadObject = FclLoadData_1.FclLoadData.toObject(loadData);
            return new FclChargeSummary_1.FclChargeSummary(loadObject);
        }
        throw new InvalidArgumentError_1.InvalidArgumentError("Invalid mode '".concat(mode, "' for charge summary."));
    };
    return ChargeSummaryFactory;
}());
exports.ChargeSummaryFactory = ChargeSummaryFactory;

},{"../constants/Mode":7,"../exceptions/InvalidArgumentError":9,"../models/FclLoadData":20,"../services/FclChargeSummary":25}],11:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Charge = void 0;
// since the input will be in snake case to avoid the unnecessary iteration of converting snakecase to camelcase we are disabling this rule.
/* tslint:disable:  variable-name */
var Charge = /** @class */ (function () {
    function Charge() {
    }
    return Charge;
}());
exports.Charge = Charge;

},{}],12:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeTotal = void 0;
var ChargeTotal = /** @class */ (function () {
    function ChargeTotal() {
    }
    return ChargeTotal;
}());
exports.ChargeTotal = ChargeTotal;

},{}],13:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversionRate = void 0;
var ConversionRate = /** @class */ (function () {
    function ConversionRate() {
    }
    return ConversionRate;
}());
exports.ConversionRate = ConversionRate;

},{}],14:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyRate = void 0;
var CurrencyRate = /** @class */ (function () {
    function CurrencyRate(code, value) {
        this.code = code;
        this.value = value;
    }
    return CurrencyRate;
}());
exports.CurrencyRate = CurrencyRate;

},{}],15:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySetting = void 0;
var ConversionRate_1 = require("./ConversionRate");
var InvalidArgumentError_1 = require("../exceptions/InvalidArgumentError");
var DELIMITER = '.';
var CurrencySetting = /** @class */ (function () {
    /**
     * Default constructor of the class
     * @param markup number
     * @param exchangeRate ExchangeRate
     * @param directRates DirectRate[]
     */
    function CurrencySetting(markup, exchangeRate, directRates) {
        var _this = this;
        /**
         * Derived direct conversion rates.
         */
        this.derivedDirectRates = new ConversionRate_1.ConversionRate();
        this.markup = !markup ? null : markup / 100;
        this.exchangeRate = exchangeRate;
        this.derivedRate = exchangeRate.clone();
        this.directRates = directRates;
        this.valid();
        // Override exchangeRate with directRates for calculating derivedRate
        this.directRates.forEach(function (directRate) {
            var sourceCurrency = directRate.sourceCurrency.code;
            var targetCurrency = directRate.targetCurrency.code;
            _this.derivedDirectRates[sourceCurrency + DELIMITER + targetCurrency] =
                directRate.sourceCurrency.value / directRate.targetCurrency.value;
            _this.derivedDirectRates[targetCurrency + DELIMITER + sourceCurrency] =
                directRate.targetCurrency.value / directRate.sourceCurrency.value;
            if (_this.derivedRate.baseCurrency === sourceCurrency) {
                _this.derivedRate.conversionRates[targetCurrency] = directRate.targetCurrency.value;
            }
            else if (_this.derivedRate.baseCurrency === targetCurrency) {
                _this.derivedRate.conversionRates[sourceCurrency] =
                    directRate.sourceCurrency.value / directRate.targetCurrency.value;
            }
        });
    }
    CurrencySetting.prototype.isDirectRate = function (fromCurrency, toCurrency) {
        return fromCurrency + DELIMITER + toCurrency in this.derivedDirectRates;
    };
    /**
     * Validates the currency instance.
     */
    CurrencySetting.prototype.valid = function () {
        this.validateDirectRates();
    };
    CurrencySetting.prototype.rate = function (fromCurrency, toCurrency, applyMarkup) {
        // Return raw exchange rate without markup when applyMarkup is false
        // Note: This condition must remain first in sequence as markup check takes precedence over direct/derived rates
        if (!applyMarkup) {
            return this.calculateExchangeRate(this.exchangeRate.conversionRates[fromCurrency], this.exchangeRate.conversionRates[toCurrency]);
        }
        // If there is direct rate (direct mapping) then return it
        if (this.isDirectRate(fromCurrency, toCurrency)) {
            return 1 / this.derivedDirectRates[fromCurrency + DELIMITER + toCurrency];
        }
        // if both currencies are not from exchange rate base currency then use original exchange rate instead of derived.
        if (![fromCurrency, toCurrency].includes(this.exchangeRate.baseCurrency)) {
            return this.calculateExchangeRate(this.exchangeRate.conversionRates[fromCurrency], this.exchangeRate.conversionRates[toCurrency]);
        }
        return this.calculateExchangeRate(this.derivedRate.conversionRates[fromCurrency], this.derivedRate.conversionRates[toCurrency]);
    };
    /**
     * Returns exchange rates based on .
     * @param currency
     * @returns Original exchange rates.
     */
    CurrencySetting.prototype.rates = function (currency) {
        var exchangeRate = this.derivedRate.clone();
        exchangeRate.baseCurrency = currency;
        // Iterate over each conversion rate
        for (var _i = 0, _a = Object.keys(exchangeRate.conversionRates); _i < _a.length; _i++) {
            var key = _a[_i];
            // Skip if the key is a direct rate or the same as the base currency
            if (this.isDirectRate(exchangeRate.baseCurrency, key) || key === exchangeRate.baseCurrency)
                continue;
            var baseRate = exchangeRate.conversionRates[currency];
            var targetRate = exchangeRate.conversionRates[key];
            // convert rate from base currency to target currency as we need to apply markup on target currency
            var rateInTargetCurrency = baseRate / targetRate;
            var markedupRate = rateInTargetCurrency * (1 + (this.markup || 0));
            // convert rate from target currency to base currency again as we need to show it in base currency
            exchangeRate.conversionRates[key] = 1 / markedupRate;
        }
        return exchangeRate;
    };
    CurrencySetting.prototype.validateDirectRates = function () {
        // check if direct mapping has zero values
        this.directRates.forEach(function (directRate, index) {
            if (directRate.sourceCurrency.value === 0 || directRate.targetCurrency.value === 0) {
                throw new InvalidArgumentError_1.InvalidArgumentError("Value in direct mapping for sourceCurrency or targetCurrency is zero at index : ".concat(index, "."));
            }
        });
    };
    CurrencySetting.prototype.calculateExchangeRate = function (sourceRate, targetRate) {
        return 1 / (sourceRate / targetRate);
    };
    return CurrencySetting;
}());
exports.CurrencySetting = CurrencySetting;

},{"../exceptions/InvalidArgumentError":9,"./ConversionRate":13}],16:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectRate = void 0;
var DirectRate = /** @class */ (function () {
    function DirectRate(sourceCurrency, targetCurrency) {
        this.sourceCurrency = sourceCurrency;
        this.targetCurrency = targetCurrency;
    }
    return DirectRate;
}());
exports.DirectRate = DirectRate;

},{}],17:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentBasedTotal = void 0;
var EquipmentBasedTotal = /** @class */ (function () {
    function EquipmentBasedTotal() {
    }
    return EquipmentBasedTotal;
}());
exports.EquipmentBasedTotal = EquipmentBasedTotal;

},{}],18:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRate = void 0;
var InvalidArgumentError_1 = require("../exceptions/InvalidArgumentError");
var ExchangeRate = /** @class */ (function () {
    function ExchangeRate(baseCurrency, conversionRates) {
        this.baseCurrency = baseCurrency;
        this.conversionRates = this.convertToBaseCurrency(conversionRates);
        this.validateExchangeRates();
    }
    ExchangeRate.prototype.clone = function () {
        return new ExchangeRate(this.baseCurrency, __assign({}, this.conversionRates));
    };
    ExchangeRate.prototype.convertToBaseCurrency = function (conversionRates) {
        var baseValue = conversionRates[this.baseCurrency];
        if (baseValue === 1)
            return conversionRates;
        for (var _i = 0, _a = Object.keys(conversionRates); _i < _a.length; _i++) {
            var currency = _a[_i];
            conversionRates[currency] = conversionRates[currency] / baseValue;
        }
        return conversionRates;
    };
    ExchangeRate.prototype.validateExchangeRates = function () {
        // check if exchange rates has zero values
        var conversionRates = this.conversionRates;
        for (var _i = 0, _a = Object.keys(conversionRates); _i < _a.length; _i++) {
            var key = _a[_i];
            if (conversionRates[key] === 0) {
                throw new InvalidArgumentError_1.InvalidArgumentError("Exchange rates contains zero value for currency : ".concat(key, "."));
            }
        }
    };
    return ExchangeRate;
}());
exports.ExchangeRate = ExchangeRate;

},{"../exceptions/InvalidArgumentError":9}],19:[function(require,module,exports){
"use strict";
// since the input will be in snake case to avoid the unnecessary iteration of converting snakecase to camelcase we are disabling this rule.
/* tslint:disable:  variable-name */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FclChargeSummary = void 0;
var FclChargeSummary = /** @class */ (function () {
    function FclChargeSummary() {
        this.leg_total = null;
        this.per_equipment_total = null;
        this.per_unit_total = null;
        this.main_charge_total = null;
        this.other_charge_total = null;
    }
    return FclChargeSummary;
}());
exports.FclChargeSummary = FclChargeSummary;

},{}],20:[function(require,module,exports){
"use strict";
// since the input will be in snake case to avoid the unnecessary iteration of converting snakecase to camelcase we are disabling this rule.
/* tslint:disable:  variable-name */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FclLoadData = void 0;
var FclLoadObject_1 = require("./FclLoadObject");
var FclLoadData = /** @class */ (function () {
    function FclLoadData() {
    }
    FclLoadData.toObject = function (loadData) {
        var loadObject = new FclLoadObject_1.FclLoadObject();
        var containerQty = 0;
        loadData.load_details_value.forEach(function (load) {
            loadObject.loadDetails[load.type] = {
                teu: load.teu || 1,
                qty: load.qty,
                teuQty: (load.teu || 1) * load.qty,
            };
            loadObject.loadTypes.push(load.type);
            containerQty++;
        });
        loadObject.containerQty = containerQty;
        return loadObject;
    };
    return FclLoadData;
}());
exports.FclLoadData = FclLoadData;

},{"./FclLoadObject":21}],21:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FclLoadObject = void 0;
var FclLoadObject = /** @class */ (function () {
    function FclLoadObject() {
        this.loadDetails = {};
        this.loadTypes = [];
    }
    return FclLoadObject;
}());
exports.FclLoadObject = FclLoadObject;

},{}],22:[function(require,module,exports){
"use strict";
// since the input will be in snake case to avoid the unnecessary iteration of converting snakecase to camelcase we are disabling this rule.
/* tslint:disable:  variable-name */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegData = void 0;
var LegData = /** @class */ (function () {
    function LegData() {
    }
    return LegData;
}());
exports.LegData = LegData;

},{}],23:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadData = void 0;
var LoadData = /** @class */ (function () {
    function LoadData() {
    }
    return LoadData;
}());
exports.LoadData = LoadData;

},{}],24:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadDetailsValue = void 0;
var LoadDetailsValue = /** @class */ (function () {
    function LoadDetailsValue() {
    }
    return LoadDetailsValue;
}());
exports.LoadDetailsValue = LoadDetailsValue;

},{}],25:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FclChargeSummary = void 0;
var Basis_1 = require("../constants/Basis");
var ChargeId_1 = require("../constants/ChargeId");
var FclChargeSummary_1 = require("../models/FclChargeSummary");
var FclChargeSummary = /** @class */ (function () {
    function FclChargeSummary(loadData) {
        this.loadDetails = loadData.loadDetails;
        this.loadTypes = loadData.loadTypes;
    }
    FclChargeSummary.prototype.calculate = function (legData) {
        // return null in case of missing legs
        if (!legData || !legData.charges.length) {
            return null;
        }
        this.totals = new FclChargeSummary_1.FclChargeSummary();
        this.computeTotals(legData);
        // add currency for each total
        for (var _i = 0, _a = Object.keys(this.totals); _i < _a.length; _i++) {
            var key = _a[_i];
            var total = this.totals[key];
            if (total) {
                total.currency = legData.leg_currency;
            }
        }
        return this.totals;
    };
    FclChargeSummary.prototype.computeTotals = function (legData) {
        for (var _i = 0, _a = legData.charges; _i < _a.length; _i++) {
            var charge = _a[_i];
            // if (charge.total_units === 0) {
            //   continue;
            // }
            // check if basis is per teu/per container/per equipment
            var isContainerBased = this.isContainerBasedBasis(charge.charge_basis);
            if (!isContainerBased) {
                this.addOtherChargeTotals(charge);
                continue;
            }
            if (charge.container_type) {
                var chargeLoadType = charge.container_type;
                this.addContainerBasedTotals(charge, chargeLoadType);
                continue;
            }
            // per teu / per container will not have container type and should be calculated for all load types
            for (var _b = 0, _c = this.loadTypes; _b < _c.length; _b++) {
                var loadType = _c[_b];
                this.addContainerBasedTotals(charge, loadType);
            }
        }
        // assign leg total
        this.totals.leg_total = {
            cost: legData.leg_currency_cost,
        };
    };
    FclChargeSummary.prototype.isContainerBasedBasis = function (basis) {
        return Basis_1.Basis.ContainerBasedBasis.includes(basis);
    };
    FclChargeSummary.prototype.addOtherChargeTotals = function (charge) {
        this.totals.other_charge_total = this.totals.other_charge_total || {};
        this.totals.other_charge_total.cost = this.totals.other_charge_total.cost || 0;
        this.totals.other_charge_total.cost += charge.leg_currency_cost;
    };
    FclChargeSummary.prototype.addContainerBasedTotals = function (charge, loadType) {
        this.addEquipmentCost(charge, loadType);
        this.addUnitCost(charge, loadType);
        // check if main charge present in leg
        if (ChargeId_1.MainChargeIdSet.includes(charge.charge_id)) {
            this.addMainChargeTotal(charge, loadType);
        }
    };
    FclChargeSummary.prototype.addMainChargeTotal = function (charge, loadType) {
        this.totals.main_charge_total = this.totals.main_charge_total || {};
        this.totals.main_charge_total[loadType] = this.totals.main_charge_total[loadType] || 0;
        this.totals.main_charge_total[loadType] += this.computeUnitCost(charge.charge_basis, charge.leg_currency_cost, charge.total_units, loadType);
    };
    FclChargeSummary.prototype.addEquipmentCost = function (charge, loadType) {
        this.totals.per_equipment_total = this.totals.per_equipment_total || {};
        this.totals.per_equipment_total[loadType] = this.totals.per_equipment_total[loadType] || 0;
        this.totals.per_equipment_total[loadType] += this.computeEquipmentCost(charge.charge_basis, charge.leg_currency_cost, charge.total_units, loadType);
    };
    FclChargeSummary.prototype.addUnitCost = function (charge, loadType) {
        this.totals.per_unit_total = this.totals.per_unit_total || {};
        this.totals.per_unit_total[loadType] = this.totals.per_unit_total[loadType] || 0;
        this.totals.per_unit_total[loadType] += this.computeUnitCost(charge.charge_basis, charge.leg_currency_cost, charge.total_units, loadType);
    };
    FclChargeSummary.prototype.computeEquipmentCost = function (basis, legCurrencyCost, totalUnits, loadType) {
        var cost = 0;
        var legCurrencyPerUnit = this.getLegCurrencyPerUnit(legCurrencyCost, totalUnits);
        switch (basis) {
            case Basis_1.Basis.PerContainer:
                cost = legCurrencyPerUnit * this.loadDetails[loadType].qty;
                break;
            case Basis_1.Basis.PerTeu:
                cost = legCurrencyPerUnit * this.loadDetails[loadType].teuQty;
                break;
            default:
                cost = legCurrencyCost;
                break;
        }
        return cost;
    };
    FclChargeSummary.prototype.computeUnitCost = function (basis, legCurrencyCost, totalUnits, loadType) {
        var legCurrencyPerUnit = this.getLegCurrencyPerUnit(legCurrencyCost, totalUnits);
        var cost = legCurrencyPerUnit;
        if (basis === Basis_1.Basis.PerTeu) {
            cost = cost * this.loadDetails[loadType].teu;
        }
        return cost;
    };
    FclChargeSummary.prototype.getLegCurrencyPerUnit = function (legCurrencyCost, totalUnits) {
        if (!totalUnits)
            return 0;
        return legCurrencyCost / totalUnits;
    };
    return FclChargeSummary;
}());
exports.FclChargeSummary = FclChargeSummary;

},{"../constants/Basis":5,"../constants/ChargeId":6,"../models/FclChargeSummary":19}],26:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeDays = void 0;
var FreeDays = /** @class */ (function () {
    function FreeDays() {
    }
    // Transforms Old FreeDays Object to NewFreeDays Object
    FreeDays.transformOldtoNew = function (details) {
        if (!Array.isArray(details) || details.length === 0) {
            return [];
        }
        return details.map(function (detail) { return (__assign(__assign({}, detail), { free_days_type: '' })); });
    };
    FreeDays.transform = function (input) {
        var defaultChargeStructure = {
            demurrage: [],
            detention: [],
            combined: [],
            storage: [],
            demurageAndStorage: [],
            combinedAndStorage: [],
        };
        if (!input) {
            return {
                freeDays: {
                    destination: defaultChargeStructure,
                    origin: defaultChargeStructure,
                },
            };
        }
        return {
            freeDays: {
                origin: __assign(__assign({}, defaultChargeStructure), { demurrage: input.demurrage_details ? FreeDays.transformOldtoNew(input.demurrage_details.origin) : [], detention: input.detention_details ? FreeDays.transformOldtoNew(input.detention_details.origin) : [], combined: input.combined_details ? FreeDays.transformOldtoNew(input.combined_details.origin) : [] }),
                destination: __assign(__assign({}, defaultChargeStructure), { demurrage: input.demurrage_details ? FreeDays.transformOldtoNew(input.demurrage_details.destination) : [], detention: input.detention_details ? FreeDays.transformOldtoNew(input.detention_details.destination) : [], combined: input.combined_details ? FreeDays.transformOldtoNew(input.combined_details.destination) : [] }),
            },
        };
    };
    return FreeDays;
}());
exports.FreeDays = FreeDays;

},{}]},{},[8]);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, customTheming, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        customTheming.applyTheme();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope,$window,$transitions,$timeout,$state,$cookies,$location,loginSerivice,util,localStorageService,api,$mdDialog, $http , $mdPanel )
    {
        // Store state in the root scope for easy access
        $rootScope.state = $state;
        // Activate loading indicator
        var stateChangeStartEvent = $transitions.onStart({},function (transition)
        {
            var fromState = transition.from();
            var toState = transition.to();
            var fromParams = transition.params('from')
            
            if ($window.Appcues) {
              $window.Appcues.page();
            }
            if(angular.element(document).find('md-dialog').length > 0) {
              // closing panel if any opened inside popup
              if(document.getElementsByClassName('md-panel').length > 0 && $mdPanel._config.scope.ctrl && $mdPanel._config.scope.ctrl.mdPanelRef) {
                $mdPanel._config.scope.ctrl.mdPanelRef.close(); 
              }
                // event.preventDefault(); // Prevent route from changing
                $mdDialog.cancel();  // Cancel the active dialog
                // return true;
            }
             // Check if there is a panel active
            if(document.getElementsByClassName('md-panel').length > 0 && $mdPanel._config.scope.ctrl && $mdPanel._config.scope.ctrl.mdPanelRef) {
              $mdPanel._config.scope.ctrl.mdPanelRef.close();  
            }

            $rootScope.loadingProgress = true;
            $rootScope.previousState = fromState.name;
            if (fromState.name) {
              $rootScope.previousUrl = $state.href(fromState.name, fromParams, { absolute: false });
            }
            if($state.current.name !== '' ){
              if(!loginSerivice.isLogin() && fromState.name ==='app.quoteSharedConfirmShipment' && toState.name ===  'quoteSharedBookShipment' ) {
                $rootScope.loadingProgress = false;
                $location.path('/login');
                return false;

              } else if (
                !loginSerivice.isLogin() &&
                fromState.name === "app.pages_auth_login-v2" &&
                (toState.name === "app.searchV2Module" || toState.name === "app.search")
              ) {
                $rootScope.loadingProgress = false;
                $location.path("/login");
                return false;
              }

              if(fromState.name === 'app.rates' && $('#my').jexcel('getData', false).length){
                $('#my').jexcel('destroy');
              }

            }

            if($state.current.name !== 'app.shipments' && toState.name !== 'app.shipments'){
              $timeout(function () { $rootScope.$broadcast('emptySearchBox', { any: '' }); });
            }
            if($state.current.name !== 'app.quotes' && toState.name !== 'app.quotes'){
              $timeout(function () { $rootScope.$broadcast('emptyQuoteSearchBox', { any: '' }); });
            }
            if($state.current.name !== 'app.inquiry' && toState.name !== 'app.inquiry'){
              $timeout(function () {  $rootScope.$broadcast('emptyInquirySearchBox', { any: '' }); });
            }
            if(toState.name !== 'app.inquiry' && toState.name !== 'app.inquiry.inquiryDetails'){
              $rootScope.$broadcast('resetServiceVaribles', { any: '' });
            }
            if($state.current.name === 'app.currencySetting'){
              util.getDomainData();
            }
        });

        $transitions.onBefore({}, function(transition) {
          var fromState = transition.from();
          var fromParams = transition.params('from');
          if (fromState && fromState.name) {
            $rootScope.previousState = fromState;
            $rootScope.previousParams = fromParams;
            var fullUrl = $state.href(fromState.name, fromParams);
            $rootScope.previousUrl = fullUrl;
          }
        });

        //check if user can access this state
        if(util.isSharedPage()) { // if sharable link then redirect to shared state
          // return;
        } else if(util.isWebView()) {
          // return;
        } else if(util.isSharedQuote()) {
          // return;
        } else if(util.isResetPage()) {
          // return;
        } else if(util.sanitizeUrl(window.location.pathname) =='/exchange-rates' && !loginSerivice.isLogin()) {
          //return
        } else if (!loginSerivice.isLogin()) {
            var currentUrl = util.sanitizeUrl(window.location.pathname);
            if(currentUrl !== '/signup'){
              if(currentUrl.indexOf('login') === -1) {
                $rootScope.redirectUrl = currentUrl;
              }
              if(currentUrl.indexOf('access') === -1){
                  $location.path('/login');
              }
            }
            
            // $state.go('app.pages_auth_login-v2');
        }
        else {
            if( !util.checkState($state.current.name)){  //$state.current.name != '' &&
                var windowHref = util.sanitizeQueryParams(window.location.href);
                if ( (performance.navigation.type === 1 || performance.navigation.type === 0) && (windowHref.substr(windowHref.lastIndexOf('/') + 1) != "" ) && (windowHref.indexOf('login') === -1 ) && (windowHref.indexOf('signup') === -1 ) ) {
                    return;
                }else {
                if(util.state.includes('search')){
                            setTimeout(function () { //swivel soft reg timer
                                return util.getDomainData().then(function() {
                                      $location.path(util.isEfpEnabled ? '/search' : '/rates');
                                });
                               },10);

                }else if(util.state[0] == 'configuration'){
                  $location.path('/status');
                }else if(util.state[0] == 'scheduleSearch'){
                  $location.path('/Schedule-Search');
                }else{
                  $location.path('/'+util.state[0]);
                }
                }
            }
        }

        // app related code
        var platform = util.getQueryStringValue("platform");
        if(localStorageService.get('platform')){
            platform = localStorageService.get('platform').value;
        }

        if(platform == "mobile-app"){
            util.isMobileApp = true;
            $cookies.put('layoutStyle','verticalNavigationApp');
            localStorageService.set('platform' , 'mobile-app');
        }



        // De-activate loading indicator
        var stateChangeSuccessEvent =  $transitions.onStart({},function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
                if($state.current.name !== '' ){
                  if(loginSerivice.isLogin() && $state.current.name ===  'app.pages_auth_login-v2' ){
                        if(util.state.includes('search')){
                            return util.getDomainData().then(function() {
                                $location.path(util.isEfpEnabled ? '/search' : '/rates');
                            });
                        }else if(util.state[0] == 'configuration'){
                          $location.path('/status');
                        }else if(util.state[0] == 'scheduleSearch'){
                          $location.path('/Schedule-Search');
                        }else{
                          $location.path('/'+util.state[0]);
                        }
                    }
                }
                if($location.url().indexOf('result') === -1 ){
                    $window.onbeforeunload = undefined;
                }
            });


        });

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        // Close dialog box on back button  - ankita
        $rootScope.$on('$locationChangeStart', function(event) {
            // Check if there is a dialog active
            if(angular.element(document).find('md-dialog').length > 0) {
               // closing panel if any opened inside popup
              if(document.getElementsByClassName('md-panel').length > 0 && $mdPanel._config.scope.ctrl && $mdPanel._config.scope.ctrl.mdPanelRef) {
                $mdPanel._config.scope.ctrl.mdPanelRef.close();  
              }
                // event.preventDefault(); // Prevent route from changing
                $mdDialog.cancel();  // Cancel the active dialog
            }

             // Check if there is a panel active
            if(document.getElementsByClassName('md-panel').length > 0 && $mdPanel._config.scope.ctrl && $mdPanel._config.scope.ctrl.mdPanelRef) {
              $mdPanel._config.scope.ctrl.mdPanelRef.close();  // Close the active panel  
            }
        });

        // Same 401 → login as api-interceptor, for freightify-web iframe posts
        window.addEventListener('message', function (event) {
            if (
                event.data &&
                event.data.source === 'error' &&
                Number(event.data.errorStatusCode) === 401
            ) {
                util.redirectToErrorPage(401);
            }
        });

    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {

        // var url = window.location.href;
        // if (
        //     url.split('uuid')[1] !== '' &&
        //     url.split('uuid')[1] !== '/' &&
        //     url.split('uuid')[1] !== undefined
        // ) {
        // $locationProvider.html5Mode(true);
        // }
        // else{
            $locationProvider.html5Mode(true);
        // }
            $urlRouterProvider.otherwise(function ($injector, $location) {
            var util = $injector.get('util');
            var $state = $injector.get('$state');

            // Get domain data first, then redirect based on EFP flag
            util.getDomainData().then(function () {
                var targetState = util.isEfpEnabled ? 'app.searchV2Module' : 'app.search';
                $state.go(targetState);
            });

            // Prevent default redirect
            return null;
        });
        // $urlRouterProvider.otherwise('/rates');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // checking the current url to set the layout of the site
        var layoutStyle ='';
        // var url = window.location.href;

        layoutStyle = $cookies.get('layoutStyle') || 'horizontalNavigation';

        // Get active layout


        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationApp  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigationApp/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                    // 'quickPanel@app': {
                    //     templateUrl: 'app/quick-panel/quick-panel.html',
                    //     controller : 'QuickPanelController as vm'
                    // }
                }
            });
    }

})();


(function ()
{
    'use strict';

    angular
        .module('fuse')

        .filter('modeCard', function() {
            return function(quote_result, mode_filter) {
              if(quote_result != undefined ){

                  if( Object.keys(mode_filter).length <= 0 ){
                      return quote_result;
                  }
                  else{
                       return quote_result.filter(function (el) {
                          return ( mode_filter.indexOf(el.mode) >= 0 );
                      });
                  }
              }
             };
        })

        .filter('statusCard', function() {
            return function(quote_result, status_filter) {
              if(quote_result != undefined ){
                  if( Object.keys(status_filter).length <= 0 ){
                      return quote_result;
                  }
                  else{
                      return quote_result.filter(function (el) {
                          return ( status_filter.indexOf(el.current_status.status) >= 0 );
                      });
                  }
              }
            };
        })

        .filter('scheduleFilter', function() {
            return function(card_result, schedule_filter, l3_leg) {
              if(card_result != undefined ){

                  if( schedule_filter != 'Direct' ){
                      return card_result;
                  }
                  else{
                      return card_result.filter(function (el) {
                        return ( el.data.buy_rates[l3_leg].rate_obj.schedule.direct != undefined || (el.data.buy_rates[l3_leg].via_port != null && el.data.buy_rates[l3_leg].via_port != '' &&el.data.buy_rates[l3_leg].via_port.toLowerCase().trim() === 'direct') );
                      });
                  }
              }
            };
        })

        .filter('filterSpecialRatesCard', function() {
            return function(card_result, lanes_filter) {
              if(card_result != undefined ){

                  if( Object.keys(lanes_filter).length <= 0 ){
                      return card_result;
                  }
                  else{
                      return card_result.filter(function (el) {
                          return ( lanes_filter.indexOf(el.lane.lane_code) >= 0 );
                      });
                  }
              }
            };
        })

        .filter('consigneeCard', function() {
            return function(quote_result, consignee_filter) {
              if(quote_result != undefined ){

                  if( Object.keys(consignee_filter).length <= 0 ){
                      return quote_result;
                  }
                  else{
                      return quote_result.filter(function (el) {
                          return ( consignee_filter.indexOf(el.shipment_consignee[0].company) >= 0 );
                      });
                  }
              }
            };
        })

        .filter('customeSplit', function() {
            return function(input, splitChar, splitIndex) {
                // do some bounds checking here to ensure it has that index
                return input.split(splitChar)[splitIndex];
            }
        })

        .filter('splitSubstring', function() {
            return function(string, splitChar, splitIndex, subStringIndex) {
                return string.split(splitChar)[splitIndex].substring(subStringIndex);
            }
        })

        .filter('UTCToLocal', function ($filter) {
            return function (utcDateString, format) {
                // return if input date is null or undefined
                if (!utcDateString) { return;  }

                // var local_date = moment.utc(utcDateString).local();
                //.format('YYYY-MM-DD HH:mm:ss');

                var local_date = moment(utcDateString).toDate();

                // convert and format date using the built in angularjs date filter
                return $filter('date')(local_date, format);  // format are passed as per angularjs date filter format
            };
        })

        .filter('NoTimeZone', function ($filter) {
          return function (utcDateString, format) {
              // return if input date is null or undefined
              if (!utcDateString) { return;  }

              var local_date = utcDateString.indexOf('Z') !== -1 ? utcDateString.slice(0,-1) : utcDateString; //moment(utcDateString).toDate();

              // convert and format date using the built in angularjs date filter
              return $filter('date')(local_date, format);  // format are passed as per angularjs date filter format
          };
        })

        .filter('abs', function () {
            return function(val) {
              return Math.abs(val);
            }
        })

        .filter('datediff',function(){
            return function(dep_date){
                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1; //January is 0!
                    var yyyy = today.getFullYear();
                    if (dd < 10) {
                      dd = '0' + dd
                    }
                    if (mm < 10) {
                      mm = '0' + mm
                    }
                    today = yyyy + '/' + mm + '/' + dd;

                    var date2 = new Date(today);
                    var date1 = new Date(moment.utc(dep_date).local());
                    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
                    // var dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24 * 7)) - 1;
                    var dayDifference = Math.floor(timeDiff / (1000 * 3600 * 24 * 7))
                    return dayDifference;
                  }
        })

        .filter('linersName', function() {
            return function(scheduleData, lines_filter) {
              if(scheduleData != undefined ){
                  if( Object.keys(lines_filter).length <= 0 ){
                      return scheduleData;
                  }
                  else{
                      return scheduleData.filter(function (el) {
                          return ( lines_filter.indexOf(el.carrier_code) >= 0 );
                      });
                  }
              }
            };
        })

        .filter('transitFilter', function() {
            return function(scheduleData, transit_filter) {
              if(scheduleData != undefined ){
                  if( Object.keys(transit_filter).length <= 0 ){
                      return scheduleData;
                  }
                  else{
                    if(transit_filter ==  'Direct'){
                        return scheduleData.filter(function (el) {
                            return ( el.via_port == 'Direct' );
                        });
                    }
                    if(transit_filter == 'Transhipment'){
                        return scheduleData.filter(function (el) {
                            return ( el.via_port != 'Direct' );
                        });
                    }
                }
              }
            };
        })

        // text truncate filter
        .filter('truncate', function () {
            return function (text, length, end) {
                if(text){
                    if (isNaN(length))
                        length = 6;
        
                    if (end === undefined)
                        end = "..";
        
                    if (text.length <= length || text.length - end.length <= length) {
                        return text;
                    }
                    else {
                        return String(text).substring(0, length-end.length) + end;
                    }
                }
     
            };
        })

        // enterprice Datatable data-search
        .filter('enterpriceTextTransform', function(){
            return function(value, replaceValues) {
                var result = value;
                var escapedreplaceValues='';
                if(replaceValues.length === 1) {
                    escapedreplaceValues=replaceValues.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    result=result.replace(new RegExp(escapedreplaceValues, 'g'), ', ');
                } else {
                    angular.forEach(replaceValues, function(x){
                        escapedreplaceValues=x.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                        result=result.replace(new RegExp(escapedreplaceValues, 'g'), '');
                    });
                }
                return result.toLowerCase().trim();
            }
        })
        //Multiple key filter
        .filter('multipleKey' , function() {
            return function(input, searchValue, searchKey) {
                if(searchValue) {
                    input = input.filter(function (item){
                        var fullString = '';
                        Object.keys(searchKey).forEach(function (key){
                            if(item[key]){
                              fullString+=item[key].toLowerCase()+" ";
                            }
                        });
                        return fullString.indexOf(searchValue.toLowerCase()) != -1
                      });
                }
                 return  input
            }
        })


        //  char ellipsis
        .filter('charlengthEllipsis', function () {
            return function (text, length) {
                if (text && text.length > length) {
                    return text.substr(0, length) + "... ";
                }
                return text;
            }
        })

        .filter('currencyMask',function($rootScope){
            
            return function (text,decimalvalue) {
                var prefferedNumber = $rootScope.number_format;
                var roudingvalue = ($rootScope.precision_decimals !== undefined && $rootScope.precision_decimals !== null) ? $rootScope.precision_decimals : 2;
                if(text !== undefined && text !== null && typeof text !== 'string'){
                    return new Intl.NumberFormat(prefferedNumber,{ minimumFractionDigits: roudingvalue,maximumFractionDigits: roudingvalue }).format(text);
                }else{
                    return text || '-';
                }
            }
        })
        .filter('numberMask',function($rootScope){
            return function (text,minDecimal,maxDecimal) {
                var prefferedNumber = $rootScope.number_format;
                if(text != "" && text !== undefined && text !== null && (typeof text !== 'string' || ( typeof text == 'string' && !isNaN(text)))){
                    if(( typeof text == 'string' && !isNaN(text))){
                        text = parseFloat(text);
                    }
                    return new Intl.NumberFormat(prefferedNumber,{ minimumFractionDigits: minDecimal,maximumFractionDigits: maxDecimal }).format(text);
                }else{
                    return text || '-';
                } 
            }
        })
        .filter('weightUnit',function($rootScope){
            
            return function (text,type,mode) {
                if(( typeof text == 'string' && !isNaN(text))){
                    text = parseFloat(text);
                }
               if(type == 'gross_weight' && mode == 'SEA-LCL'){
                   return $rootScope.domainData.domain_info &&
                   $rootScope.domainData.domain_info.WEIGHT_UNIT && 
                   $rootScope.domainData.domain_info.WEIGHT_UNIT[mode] && $rootScope.domainData.domain_info.WEIGHT_UNIT[mode].gross_weight == 'kg' ? parseFloat(text)*1000 : parseFloat(text);
               }else{
                   return text;
               }
            }
        })
        .directive('whenScrolled', function() {
            return function(scope, elm, attr) {
                var raw = elm[0];
                elm.bind('scroll', function() {
                    if (raw.scrollTop + raw.offsetHeight + 1>= raw.scrollHeight) {
                        scope.$apply(attr.whenScrolled);
                    }
                });
            };
        })

        .directive('onScroll', function() {
            return function(scope, elm, attr) {
                var raw = elm[0].children;
                var scrollId = raw[0].id;
                elm.bind('scroll', function() {
                    if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
                        $('#'+scrollId).fadeIn(200);    // Fade in the arrow
                    } else {
                        $('#'+scrollId).fadeOut(200);   // Else fade out the arrow
                    }
                });
            };
        })

        .directive('whenScrollEnds', function() {
            return {
                restrict: "A",
                link: function(scope, element, attrs) {

                  var container = element.find('md-content');
                  container.css('height','300px');
                  var visibleHeight = 300;
                  var threshold = 100;

                  container.scroll(function() {
                    var scrollableHeight = container.prop('scrollHeight');
                    var hiddenContentHeight = scrollableHeight - visibleHeight;

                    if (hiddenContentHeight - container.scrollTop() <= threshold) {
                        // Scroll is almost at the bottom. Loading more rows
                        scope.$apply(attrs.whenScrollEnds);
                    }
                  });
                }
            };
        })

        .directive('focusMe', function($timeout, $parse) {
            return {
              link: function(scope, element, attrs) {
                var model = $parse(attrs.focusMe);
                scope.$watch(model, function(value) {
                  if(value === true) {
                    $timeout(function() {
                      element[0].focus();
                    });
                  }
                });
              }
            };
        })

        .directive("limitToMax", function() {
            return {
              link: function(scope, element, attributes) {
                element.on("keydown keyup", function(e) {
                if (Number(element.val()) > Number(attributes.max) && e.keyCode != 46 // delete
                    && e.keyCode != 8 // backspace
                ) {
                    e.preventDefault();
                    element.val(attributes.max);
                }
                });
              }
            };
        })

        .directive('dynamicController', ['$controller','$parse','$sanitize', function($controller,$parse,$sanitize) {
            return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, element, attrs) {

                        var locals = {
                            $scope: scope,
                            $element: element,
                            $attrs: attrs
                        };
                        var cleanAttr = $sanitize(attrs.dynamicController);
                        element.data('$Controller', $controller($parse(cleanAttr)(scope), locals));
                    }
            };
        }])

        .directive('shimmerEffect',function(){
            return {
                template:
                ' <div style="height:{{height}}; width:{{width}}; "  >'+
                            ' <div  class="animationLoading shimmer" style="height:30px; width:{{width}}-10%;  margin: 40px 5% ; "></div>'+
                            ' <div  class="animationLoading shimmer" style="height:30px; width:{{width}}-10%; margin: 40px 5% ;"></div>'+
                            ' <div  class="animationLoading shimmer" style="height:30px; width:{{width}}-10%; margin: 40px 5%;"></div>'+
                ' </div>'
                ,
                scope : {
                    height : '@',
                    width : '@',
                    name : '@'
                }
            }
        })

        .directive('shimmerEffectFull',function(){
            return {
                template:
                ' <div style="height:{{height}}; width:{{width}}; "  >'+
                    ' <div  class="animationLoading shimmer" style="height:{{height}}; width:{{width}};  margin: {{mv}} {{mh}} ;"></div>'+
                ' </div>'
                ,
                scope : {
                    height : '@',
                    width : '@',
                    name : '@',
                    mh: '@'
                }
            }
        })

        //directive for to covert string into number
        .directive('stringToNumber', function() {
            return {
              require: 'ngModel',
              link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(value) {
                  return '' + value;
                });
                ngModel.$formatters.push(function(value) {
                  return parseFloat(value);
                });
              }
            };
        })

        .directive('myIframe', function(){
            var linkFn = function(scope, element, attrs) {
                element.find('iframe').bind('load', function (event) {
                  event.target.contentWindow.scrollTo(0,400);
                });
            };
            return {
              restrict: 'EA',
              scope: {
                src:'@src',
                height: '@height',
                width: '@width',
                scrolling: '@scrolling'
              },
              template: '<iframe class="frame" height="{{height}}" width="{{width}}" frameborder="0" border="0" marginwidth="0" marginheight="0" scrolling="{{scrolling}}" src="{{src}}"></iframe>',
              link : linkFn
            };
        })

        .directive('lowercase', function() {
            return {
              require: 'ngModel',
              link: function(scope, element, attrs, modelCtrl) {
                var lowercase = function(inputValue) {
                  if (inputValue == undefined) inputValue = '';
                  var lowercased = inputValue.toLowerCase();
                  if (lowercased !== inputValue) {
                    // see where the cursor is before the update so that we can set it back
                    var selection = element[0].selectionStart;
                    modelCtrl.$setViewValue(lowercased);
                    modelCtrl.$render();
                    // set back the cursor after rendering
                    if(element[0].selectionStart && element[0].selectionEnd){
                      element[0].selectionStart = selection;
                      element[0].selectionEnd = selection;
                    }
                  }
                  return lowercased;
                }
                modelCtrl.$parsers.push(lowercase);
                lowercase(scope[attrs.ngModel]); // capitalize initial value
              }
            }
        })

        .config(['$provide', function($provide) {
            $provide.decorator('$log', ['$delegate', function($delegate) {
                var vishleSana = localStorage.getItem('vishleSana');
                if(!vishleSana || vishleSana=="false"){
                    // Suppress '$log.error', `console.log` and `console.warn`
                    $delegate.error = function() {};
                    console.log = function() {};
                    console.warn = function() {};
                }
                return $delegate;
        }]);
        }])

        .config(['$qProvider', function ($qProvider) {
            $qProvider.errorOnUnhandledRejections(false);
        }]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController)
        .factory('$exceptionHandler' , $exceptionHandler);

    /** @ngInject */
    function IndexController(fuseTheming,localStorageService,$log, fcmService,util,loginSerivice,$rootScope,local_host_name,mixPanelToken,$cookies)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;
        vm.get_nav = {};
        vm.user_category = '';
        vm.loadingProgress = $rootScope.loadingProgress;
        vm.loadingDetails = $rootScope.loadingDetails;
        vm.util = util;
        vm.util.themes = vm.themes;
        vm.util.activatedTheme = fuseTheming.activatedTheme;
        vm.util.isCallingApi =  false;
        vm.deleteAllCookies = deleteAllCookies;

        $rootScope.domainData =  {}; // domain data to rootscope level
        $rootScope.ifVersionUpdate = false;
        vm.getDomainData = getDomainData;
        vm.getMatricJson = getMatricJson;

        var host_name =  window.location.hostname.replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/)[0];
        host_name = ( (host_name.indexOf('localhost')) > -1 ) || (host_name.indexOf('192.168')) > -1 ? local_host_name : host_name;
        var domain_name = host_name.split('.')[host_name.split('.').length -2];

        $rootScope.domainData = {
            'version' : '14112018170',
            'host_name' : host_name,
            'domain_info' : {},
            'domain_name' : (host_name.indexOf('localhost')) > -1 ? 'FreightBro' : '',
            'is_freightbro' : (host_name.indexOf('freightbro') > -1 ) ? true : false,
            // 'logo' : 'https://s3.ap-south-1.amazonaws.com/ship-development-data/domain-data/'+ host_name.replace(/\./g , '_') +'.png' ,
            'logo' : '',
            'white_logo' : 'https://s3.ap-south-1.amazonaws.com/ship-development-data/domain-data/'+ host_name.replace(/\./g , '_') +'_white.png' ,
            'favicon' : 'https://s3.ap-south-1.amazonaws.com/ship-development-data/domain-data/'+ host_name.replace(/\./g , '_') +'.ico'
        }; // setting rootscope variable

        

        // for main freight text view
        $rootScope.isJeenaDomain = ($rootScope.domainData.host_name == 'ship.jeena.com') ? true : false;

        function init(){
          // mixpanel.init(mixPanelToken);
          //mixpanel code ends here
          fcmService.callFcmToken('beforelogin');
          util.getDomainData();
          util.checkLocalStorageAuthToken();
          //util.getUserLocationData(); 

          if(!util.currencyList.length && loginSerivice.isLogin()){
            if(!util.isSharedPage() && !util.isSharedQuote() && !util.isWebView()){
              util.checkUserExit('fromController', mixPanelToken);
            }

            if(util.isResetPage()){
              mixpanel.init(mixPanelToken);
            }

            util.getCurrencyList().then(function(response){
              vm.currencyList = util.currencyList;
            },function(error){
              vm.currencyList = [];
              $log.log(error);
            });
          }
          showToastWheninPotrait();
          window.addEventListener("orientationchange", function() {
            showToastWheninPotrait();
          }, false);

          vm.getDomainData();
          vm.getMatricJson();
          
          // Listen for postMessage from party modal to navigate to shippers page
          window.addEventListener('message', function(event) {
            if (event.data.from === 'shipment-details' && ['customer', 'consignee', 'consignor'].indexOf(event.data.source) !== -1) {
              window.open('/shippers', '_blank');
            }
          });
        }
        init();

        function getDomainData(){
            if(!Object.keys($rootScope.domainData.domain_info).length){
              util.getDomainData().then(function(){
                $rootScope.domainData.logo = $rootScope.domainData.domain_info.LOGO;
                localStorageService.set('IsEfpEnabled', $rootScope.domainData.domain_info['IS_EFP_DOMAIN']);
              },function(error){
                  $log.log(error.data);
              });
            }
            else {
                $rootScope.domainData.logo = $rootScope.domainData.domain_info.LOGO;
            }
          }

        function showToastWheninPotrait() {
          if(window.orientation === 0 || window.orientation === 180){
            util.showToast('For optimal user experience, please turn your device horizontally to landscape mode.');
          }
        }

        $rootScope.fnForceRefresh = function() {
          localStorageService.remove('erpIntegrationList');
          vm.deleteAllCookies();
          location.reload();
          localStorageService.set('appVersion', $rootScope.domainData['version']);
          $rootScope.ifVersionUpdate = false;
        };

        function deleteAllCookies() {
          var selectedTheme = $cookies.get('selectedTheme');
          if(selectedTheme){
            $cookies.remove('selectedTheme');
          }
        }

        $rootScope.closeForceRefresh = function() {
          $rootScope.ifVersionUpdateUserDisable = true;
        };

        function getMatricJson(){
          // set default matric and number format
          $rootScope.metric_system='metric';
          $rootScope.number_format='en-US';
          // get matric-number json and store in util
          // util.getMatricJson();
        }

    }

    function $exceptionHandler($log, environment , airbrakeId , airbrakeKey){
      var airbrake = new airbrakeJs.Client({
        projectId: airbrakeId,
        projectKey: airbrakeKey
      });

      airbrake.addFilter(function (notice) {
        notice.context.environment = environment;
        return notice;
      });

      var host_name =  window.location.hostname.replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/)[0];

      return function (exception, cause) {
        $log.error(exception);

        var is_sent = !((host_name.indexOf('localhost')) > -1 || (host_name.indexOf('192.168')) > -1);
        if(is_sent){
          airbrake.notify({error: exception, params: {angular_cause: cause} , context:{PROJECT_NAME:'fb-shipper-frontend'}});
        }

      };
    }


})();

(function (){
"use strict";
angular.module("fuse")
.constant("apiUrl", "https://api.freightify.io")
.constant("efpUrl","https://api.freightify.com")
.constant("local_host_name","xyz.ship.freightbro.com")
.constant("environment","production")
.constant("mixPanelToken","1712ac974d4b6c0d72a4105e7428a0ef")
.constant("dauUrl","https://dauplatform.freightify.com")
.constant("notificationUrl","https://subscription-platform.freightify.in")
.constant("iamUrl","https://api.freightify.com")
.constant("airbrakeKey","42513e9d6744b148277e901aa6988985")
.constant("airbrakeId","200620")
.constant("captchaKey","6LdiBYkpAAAAAJ8A1aWf8rsIitwdfoBBAxfKqCay")
.constant("cdnTemplateUrl","https://cdn.freightbro.in/production/templates")
.constant("clientId","1")
.constant("clientId2","2")
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider,$mdDateLocaleProvider , $httpProvider,$mdAriaProvider)
    {
        // Put your common app configurations here
        $mdAriaProvider.disableWarnings();

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        $mdDateLocaleProvider.formatDate = function(date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
          };

           // Example uses moment.js to parse and format dates.
          $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          };

          $httpProvider.interceptors.push('apiInterceptor');
          $httpProvider.defaults.headers.delete = { "Content-Type": "application/json;charset=utf-8" };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, apiUrl)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *devapi
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         *
         *
         * // Custom Example to undesrstand all api calls method
         *
         *  //Getting All Data
         *  api.shipment.loads.get({'shipment_id':'ABCD124123'},
         *  function(res){
         *      console.log("Get no id = ", res);
         *      },function(err){
         *      console.log(err);
         *      }
         *   );
         *
         *  // Get data by ID
         *  api.shipment.loads.get({'shipment_id':'ABCD124123','id' : 'l123' },
         *      function(res){
         *         console.log("GET ID = ",res);
         *         load.$save({'shipment_id':'ABCD124123'},function(resi){
         *          console.log("Save Instance= ", resi);
         *        });
         *       },function(err){
         *           console.log(err);
         *        }
         *   );
         *
         *  // Save  the Data
         *  var postdata = {
         *           "data":{
         *                       "load_type": "container",
         *                      "load_loads_value": {
         *                           "qty": 2,
         *                           "bl_qty": 1,
         *                           "type": "20GP",
         *                           "load_metrics": [
         *                               {
         *                                   "weight_qty": 0,
         *                                   "weight_unit": "KGS",
         *                                   "volume_qty": 9.7,
         *                                   "volume_unit": "CBM"
         *                               },
         *                               {
         *                                   "weight_qty": 0,
         *                                   "weight_unit": "KGS",
         *                                   "volume_qty": 9.7,
         *                                   "volume_unit": "CBM"
         *                               }
         *                           ]
         *                       }
         *              }
         *       }
         *
         *       api.shipment.loads.save({'shipment_id':'ABCD124123'},postdata,
         *           function(res){
         *               console.log("Save= ", res);
         *           },function(err){
         *               console.log(err);
         *           }
         *      );
         *
         *  //Update the Data
         *  api.shipment.loads.update({'shipment_id':'ABCD124123','id' : 'l123' }, postdata,
         *           function(res){
         *               console.log("Update = " , res);
         *
         *           },function(err){
         *               console.log(err);
         *           }
         *      );
         *
         *  // Remove The data
         *
         *  api.shipment.loads.remove( {'shipment_id':'ABCD124123','id' : 'l123' },
         *       function(res){
         *           console.log("Remove = " , res);
         *       },function(err){
         *           console.log(err);
         *       }
         *   );
         *
         *
         *
         *
         */

        var api = {};

        var url = sanitizeQueryParams(window.location.href);

        if (
            url.split('uuid')[1] !== '' &&
            url.split('uuid')[1] !== '/' &&
            url.split('uuid')[1] !== undefined
        ) {
            var uuid = url.split('uuid')[1];
            api.baseMockUrl = apiUrl +'/shared/' + uuid.split('/')[1];
        } else {
            api.baseMockUrl = apiUrl +'/api';
        }


        //Shipments API List;
        api.shipment = {

            //Shipment list
            shipment_info : $resource(api.baseMockUrl+'/shipments/:shipment_id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            //Feed Tab APi Calls
            activity_feed : $resource(api.baseMockUrl+'/shipments/:shipment_id/feeds/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            status : $resource(api.baseMockUrl+'/shipments/:shipment_id/status/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            carrier_booking : $resource(api.baseMockUrl+'/v2/shipments/:shipment_id/carrier/billing/:id',
            {id : '@id'},
            {
                update : {method:'GET'}
            }),
            // Details Tab Api Call Here
            schedule : $resource(api.baseMockUrl+'/shipments/:shipment_id/schedules/:id',
            {id : '@id'},
            {
                save : {method:'POST'},
                update : {method:'PUT'},
                remove : {method:'DELETE'}
            }),
            scheduleList : $resource(api.baseMockUrl+'/shipments/:shipment_id/schedule-list/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            scheduleTrack: $resource(api.baseMockUrl+'/shipments/:shipment_id/schedules/:id/tracks/:track_id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            load_data : $resource(api.baseMockUrl+'/shipments/:shipment_id/loads/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            commodity : $resource(api.baseMockUrl+'/shipments/:shipment_id/commodities/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            parties : $resource(api.baseMockUrl+'/shipments/:shipment_id/parties/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            // Quotes Tab Api Calls Here
            quote : $resource(api.baseMockUrl+'/shipments/:shipment_id/quotes/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
                // save : {headers: { "mimeType": "multipart/form-data","async": true,"crossDomain": true,"processData": false, "contentType": false, }}
            }),

            // Billing Info Tab Api calls here
            rate : $resource(api.baseMockUrl+'/v2/shipments/:shipment_id/rates',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            invoice : $resource(api.baseMockUrl+'/shipments/:shipment_id/invoices/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            // Billing Info Tab Api calls here
            rateProviderBilling : $resource(api.baseMockUrl+'/v2/shipments/:shipment_id/provider/billing',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            // Docuemnt Api Calls
            documents : $resource(api.baseMockUrl+'/shipments/:shipment_id/documents/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            // Product Api Calls Here
            product : $resource(api.baseMockUrl+'/shipments/:shipment_id/products/:id',
            {id : '@id'},
            {
                update : {method:'PUT'},
                savelist: {method:'POST', isArray:true}
            }),

            //Container Tab api calls here
            container : $resource(api.baseMockUrl+'/shipments/:shipment_id/containers/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            // Tracking
            tracking : $resource(api.baseMockUrl+'/shipments/:shipment_id/tracks/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            // Management
            source : $resource(api.baseMockUrl+'/shipments/:shipment_id/sources/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            management : $resource(api.baseMockUrl+'/shipments/:shipment_id/management/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            feedbacks : $resource(api.baseMockUrl+'/shipments/:shipment_id/feedbacks/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            //user roles
            userRoles : $resource(api.baseMockUrl+'/shipment-role/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            //user list
            userList : $resource(api.baseMockUrl+'/users-list/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),

            //OTP calls
            shared_link : $resource(api.baseMockUrl+'/otp/:shipment_id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            })
        };

        api.management = {
             //forwarder
             forwarder : $resource(api.baseMockUrl+'/forwarder/:forwarder_id',
             {id : '@id'},
             {
                 update : {method:'PUT'}
             }),

             //shipper
             shipper : $resource(api.baseMockUrl+'/shipper/:shipper_id',
             {id : '@id'},
             {
                 update : {method:'PUT'}
             }),

             //user
             user : $resource(api.baseMockUrl+'/user/:user_id',
             {id : '@id'},
             {
                 update : {method:'PUT'}
             })
        };

        api.userManagement = {
            department : $resource(api.baseMockUrl+'/department/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            designation : $resource(api.baseMockUrl+'/designation/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            tag : $resource(api.baseMockUrl+'/tag/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            team : $resource(api.baseMockUrl+'/team/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            companyGroup : $resource(api.baseMockUrl+'/company-groups/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            role : $resource(api.baseMockUrl+'/roles/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            location : $resource(api.baseMockUrl+'/location/:id',
            {id : '@id'},
            {
                update : {method:'PUT'}
            }),
            pricingLevels : $resource(api.baseMockUrl+'/pricing-levels')
        };

        // Base Url
        api.baseUrl = apiUrl; //'http://192.168.201.148:8000';  //'https://devapi.freightbro.com'; //'http://api.shipper.localhost';

        return api;
    }

    function sanitizeUrl(unsafe) {
        return unsafe
        .replace(/constructor\s*\./g, '')               // Remove constructor accesses
        .replace(/\blocation\s*=/g, '')                  // Remove location assignment
        .replace(/javascript\s*:/g, '')                  // Prevent javascript URIs
        .replace(/onerror\s*=/g, '')                     // Remove 'onerror' attributes (XSS risk)
        .replace(/\$eval\(/g, '')                        // Remove AngularJS $eval (Angular-specific XSS)
        .replace(/{{/g, '')                              // Remove AngularJS template expressions (must be handled with Angular $sanitize)
        .replace(/}}/g, '')                              // Remove AngularJS template expressions
        .replace(/\{\{([^}]*)(constructor|prototype|__proto__|window|localStorage|sessionStorage)([^}]*)\}\}/g, '') // Strip dangerous code
        .replace(/&/g, "&amp;")                          // Escape ampersand to prevent HTML entity injection
        .replace(/</g, "&lt;")                           // Escape less-than sign to prevent HTML injection
        .replace(/>/g, "&gt;")                           // Escape greater-than sign to prevent HTML injection
        .replace(/"/g, "&quot;")                         // Escape double quotes
        .replace(/'/g, "&#x27;"); 
    }

    function sanitizeQueryParams(url) {
      if(!url){
        return;
      }
      var urlParts = url.split('?');
      if (urlParts.length < 2) {
        return sanitizeUrl(url); // No query parameters to sanitize
      }

      var baseUrl = urlParts[0];
      var queryString = urlParts[1];
      var sanitizedParams = queryString.split('&').map(function (param) {
          var parts = param.split('=');
          var key = parts[0];
          var value = parts[1] ? encodeURIComponent(sanitizeUrl(decodeURIComponent(parts[1]))) : '';
          return key + '=' + value;
      });
      return baseUrl + '?' + sanitizedParams.join('&');
    }

})();

(function (){
"use strict";
var constData = {  
    PICKUP_BASIS:'% on pickup',
    AIR_FREIGHT_BASIS:'% on air freight',
    FREIGHT_BASIS:'% on freight',
    DELIVERY_BASIS: '% on delivery',
    FREIGHT_TOTAL_BASIS: '% on freight total'
}
angular.module("app.core")
.constant("constObj", constData);
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-503', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-503', {
            // url      : '/pages/errors/error-503',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-503': {
                    templateUrl: 'app/main/pages/errors/503/error-503.html',
                    controller : 'Error503Controller as vm'
                }
            },
            bodyClass: 'error-503'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors.error-500', {
        //     title : '500',
        //     state : 'app.pages_errors_error-500',
        //     weight: 2
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            // url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors.error-500', {
        //     title : '500',
        //     state : 'app.pages_errors_error-500',
        //     weight: 2
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login-v2',
            'app.pages.auth.account',
            'app.pages.auth.sso-switch-account',
            'app.pages.auth.signup',
            'app.pages.auth.reset-password',
                'app.pages.error-500',
                'app.pages.error-internet',
                'app.pages.error-503',
                'app.pages.share-error',
                'app.pages.exchangeRates',
                'app.pages.unpaid-module-error'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('pages', {
        //     title : 'PAGES',
        //     group : true,
        //     weight: 2
        // });
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nng-class=\"{\'login-content\': $root.state.current.name == \'app.pages_auth_login-v2\' || $root.state.current.name == \'app.account\' || $root.state.current.name == \'app.signup\' || $root.state.current.name ==\'app.webViewExchangeRates\'}\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><notification-bar \nng-if=\"!vm.isPublicPage\"></notification-bar><div id=\"horizontal-navigation\" \nmd-theme=\"{{$root.domainData.domain_info.THEME_CONFIG.dark_mode ? \'custom-dark\' : \'\'}}\" ui-view=\"navigation\" \nlayout=\"row\" layout-align=\"start end\" flex hide show-xs show-sm></div><div \nstyle=\"z-index: 1;display: block; width: 100%; position: absolute;bottom: 0;background-color: rgb(244, 244, 244) ;display: inline-flex;padding-top: 5px;padding-bottom: 5px\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"$root.domainData.domain_info.POWERED_BY.logo_solid\" id=\"powered_by\">\n<div style=\"color: rgba(74, 74, 74, 0.58);margin-right: 5px;font-weight: 600\">Powered by</div><div><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.POWERED_BY.text_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img ng-src=\"{{ vm.util.sanitizeQueryParams($root.domainData.domain_info.POWERED_BY.logo_solid) }}\" \nwidth=\"55px\" class=\"pointer\"></a></div></div><div id=\"content-container\" flex layout=\"column\" \nng-class=\"{\'mb-30\' : $root.domainData.domain_info.POWERED_BY.logo_solid}\"><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll flex><div id=\"toolbar-navigation-container\" \nmd-theme=\"{{$root.domainData.domain_info.THEME_CONFIG.dark_mode ? \'custom-dark\' : \'\'}}\" class=\"md-whiteframe-1dp\" \nlayout=\"column\" layout-align=\"space-between start\"><md-toolbar ng-if=\"!vm.isPublicPage\" id=\"toolbar\" \nmd-theme=\"{{$root.domainData.domain_info.THEME_CONFIG.dark_mode ? \'custom-dark\' : \'\'}}\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar></div><div id=\"inner-content\" class=\"mt-50\" \nui-view=\"content\"></div></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nstyle=\"z-index: 1; margin: 2px 2px 10px; padding: 10px; border: 2px solid #bce8f1; border-radius: 0px; font-size: 15px; color: #856404; background-color: #fff3cd; border-color: #ffeeba;text-align: center\" \nng-if=\"$root.ifVersionUpdate && !$root.ifVersionUpdateUserDisable\">New updates are available. Please <a class=\"link\" \nstyle=\"cursor: pointer\" ng-click=\"$root.fnForceRefresh()\">refresh</a> for a smooth experience.<div style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\" ng-click=\"$root.closeForceRefresh()\" class=\"s24 pointer mb-5\"></md-icon></div></div>\n<div \nstyle=\"z-index: 1;display: block; width: 100%; position: absolute;bottom: 0;background-color: rgb(244, 244, 244) ;display: inline-flex;padding-top: 5px;padding-bottom: 5px\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"$root.domainData.domain_info.POWERED_BY.logo_solid\"><div \nstyle=\"color: rgba(74, 74, 74, 0.58);margin-right: 5px;font-weight: 600\">Powered by</div><div><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.POWERED_BY.text_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img ng-src=\"{{ vm.util.sanitizeQueryParams($root.domainData.domain_info.POWERED_BY.logo_solid) }}\" \nwidth=\"55px\" class=\"pointer\"></a></div></div><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","");
$templateCache.put("app/main/Inquiry/inquiry.html","<div><md-sidenav ng-if=\"vm.inquiryParam.deviceName != \'laptop\'\" class=\"md-sidenav-right sidenav-bg no-scroll\" \nmd-component-id=\"right\" ms-sidenav-helper><inquiry-filter callback=\"vm.submitFilter()\" filterobj=\"vm.filterObj.data\" \ninquiry-data=\"vm.inquiryParam\"></inquiry-filter></md-sidenav><div id=\"inquiry-management\" \nwhen-scrolled=\"vm.loadMoreRecords(vm.inquiryListToRender.inquiryList.length)\" ng-style=\"vm.maxHeight\"><div \nclass=\"layout-styles\"><div class=\"pv-20 inquiry-sticky-div\" layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" flex-gt-xs=\"100\" ng-if=\"!vm.isStatusLoading\"><div><div class=\"header_and_subheader\" layout=\"column\" \nlayout-align=\"space-between\" layout-wrap=\"wrap\"><span class=\"page_title\">Enquiries</span> <span>\nManage all your searches</span></div></div><div ng-if=\"vm.inquiryParam.deviceName != \'laptop\'\" \nclass=\"b md-primary-border brad-4 p-5 mh-10 pointer float-filter\" ng-click=\"vm.toggleSidenav(\'right\')\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon\"></md-icon></div></div><div flex \nlayout=\"row\"><div ng-if=\"vm.inquiryParam.deviceName == \'laptop\'\" class=\"w-230\"><div class=\"filter-container\" \nng-style=\"vm.leftFilterTopMargin\"><md-sidenav class=\"md-white-bg mr-10\" ms-sidenav-helper \nmd-is-locked-open=\"vm.inquiryParam.deviceName == \'laptop\'\"><inquiry-filter callback=\"vm.submitFilter()\" \nfilterobj=\"vm.filterObj.data\" inquiry-data=\"vm.inquiryParam\" is-load-component=\"vm.isLoadFilterComponent\">\n</inquiry-filter></md-sidenav></div></div><div flex><div layout=\"row\" layout-align=\"space-between\" \nclass=\"inquiry-count-sort-div\"><div ng-if=\"!vm.util.isCallingApi\" class=\"list_count\">\n{{vm.inquiryTotalCount}} Results Found</div><div layout-align=\"end center\"><div ng-show=\"vm.inquiryTotalCount !== 0\" \nclass=\"pt-10 pointer\" layout-align=\"end center\" ng-click=\"vm.fnCreatedSortBy(vm.filterObj.data.sort_by_type)\"><md-icon \nng-if=\"vm.filterObj.data.sort_by_type == \'ASC\'\" md-svg-src=\"assets/icons/custom/desc.svg\" \nclass=\"w-15 h-15 filter-icon\"></md-icon><md-icon ng-if=\"vm.filterObj.data.sort_by_type == \'DESC\'\" \nmd-svg-src=\"assets/icons/custom/asc.svg\" class=\"w-15 h-15 filter-icon\"></md-icon></div><md-tooltip md-direction=\"top\" \nclass=\"font-size-13\">Sort by: Created on</md-tooltip></div></div><md-content id=\"inquiryList\" class=\"inquiryData\" \nms-scroll><div class=\"card-list p-0 pointer\" layout-xs=\"column\" layout=\"row\" flex=\"100\" \nng-repeat=\"inquiry_obj in vm.inquiryListToRender.inquiryList track by $index\" layout-padding layout-wrap \nng-click=\"vm.viewInquiryDetails(inquiry_obj._id)\"><div class=\"card-list-view\" show-gt-sm flex><div layout=\"row\" \nlayout-xs=\"column\" class=\"list_view_div md-brad\"><div class=\"status-sect\" layout-align=\"center center\" \nlayout-gt-xs=\"row\" layout-align-xs=\"start start\"><div layout=\"column\" layout-align=\"center center\" layout-xs=\"row\" \nlayout-align-xs=\"space-between\" class=\"p-5\"><div class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\">\n{{inquiry_obj.inquiry_number}}</div><div class=\"status-bg\" \nng-style=\"vm.util.getStatusColor(inquiry_obj.current_status.color_code)\" \nng-bind=\"inquiry_obj.current_status.status_alias ? inquiry_obj.current_status.status_alias : inquiry_obj.current_status.status\">\n</div></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div layout=\"column\" flex=\"100\">\n<port-traveller-ui details=\"inquiry_obj.search_data\" ng-show=\"inquiry_obj\" class=\"ph-16 pt-10\"></port-traveller-ui><div\n ng-show=\"!inquiry_obj\" class=\"loader\"></div><div layout=\"row\" flex=\"100\" layout-wrap layout-padding \nng-class=\"{\'bt\' : !$ctrl.util.isMobileDevice}\"><div class=\"pv-5\"><div class=\"font-size-11 fg-AAA8AD\">Mode</div><div \nng-show=\"inquiry_obj.search_data\" class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\">\n{{inquiry_obj.search_data.mode ? inquiry_obj.search_data.mode : \'-\' }}</div><div ng-show=\"!inquiry_obj.search_data\" \nclass=\"loader\"></div></div><div class=\"pv-5\"><div class=\"font-size-11 fg-AAA8AD\">Cut Off Date</div><div \nng-show=\"inquiry_obj.search_data\" class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\" \ntitle=\"{{inquiry_obj.search_data.cargo_ready_date | UTCToLocal : \'d MMM yyyy\'}}\"><span \nng-bind=\"inquiry_obj.search_data.cargo_ready_date ? (inquiry_obj.search_data.cargo_ready_date | UTCToLocal : \'d MMM yyyy\') : \'-\'\">\n</span></div><div ng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div class=\"pv-5\" \nng-if=\"inquiry_obj.search_data.mode==\'SEA-FCL\'\"><div class=\"font-size-11 fg-AAA8AD\">Load Details</div><div \nng-show=\"inquiry_obj.search_data\" class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\">\n{{vm.formContainerType(inquiry_obj.search_data.mode, inquiry_obj.search_data.load_data, \'listPage\')}}<md-tooltip \nmd-direction=\"bottom\" class=\"font-size-12\">\n{{vm.formContainerType(inquiry_obj.search_data.mode, inquiry_obj.search_data.load_data)}}</md-tooltip></div><div \nng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div class=\"pv-5\" \nng-if=\"inquiry_obj.search_data.mode!=\'SEA-FCL\'\"><div class=\"font-size-11 fg-AAA8AD\">Load Details</div><div \nng-show=\"inquiry_obj.search_data\" class=\"font-size-13 text-center fg-333333 font-weight-600 ellipsis-name\"><div \nng-if=\"inquiry_obj.search_data.load_data.load_meta.chargeable_weight\">\n{{inquiry_obj.search_data.load_data.load_meta.chargeable_weight | currencyMask}} {{vm.util.chargeableUnit[inquiry_obj.search_data.mode]}}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-12\">\n{{inquiry_obj.search_data.load_data.load_meta.chargeable_weight ? (inquiry_obj.search_data.load_data.load_meta.chargeable_weight | currencyMask): \'-\'}} {{vm.util.chargeableUnit[inquiry_obj.search_data.mode]}}\n</md-tooltip></div><div ng-if=\"!inquiry_obj.search_data.load_data.load_meta.chargeable_weight\">-</div></div><div \nng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div class=\"pv-5\"><div class=\"font-size-11 fg-AAA8AD\">\nCreated On</div><div ng-show=\"inquiry_obj.search_data\" class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\" \ntitle=\"{{inquiry_obj.created_at | UTCToLocal : \'d MMM yyyy\'}}\"><span \nng-bind=\"inquiry_obj.created_at ? (inquiry_obj.created_at | UTCToLocal : \'d MMM yyyy\') : \'-\'\"></span></div><div \nng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div class=\"pv-5\"><div class=\"font-size-11 fg-AAA8AD\">\nCreated By</div><div ng-show=\"inquiry_obj.search_data\" class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\" \ntitle=\"{{inquiry_obj.user.user_first_name}} {{inquiry_obj.user.user_last_name}}\"><span \nng-bind=\"inquiry_obj.user ? inquiry_obj.user.user_first_name+ \' \' +inquiry_obj.user.user_last_name : \'-\'\"></span></div>\n<div ng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div class=\"pv-5\"><div \nclass=\"font-size-11 fg-AAA8AD\">Incoterms</div><div ng-show=\"inquiry_obj.search_data\" \nclass=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\" layout=\"row\" \ntitle=\"{{inquiry_obj.search_data.inco_term}} {{inquiry_obj.search_data.impo_expo}}\"><div \nng-bind=\"inquiry_obj.search_data.inco_term ? inquiry_obj.search_data.inco_term : \'N/A\'\"></div><div \nng-if=\"inquiry_obj.search_data.impo_expo && inquiry_obj.search_data.inco_term\">- {{inquiry_obj.search_data.impo_expo}}\n</div></div><div ng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div class=\"pv-5\" \nng-if=\"vm.util.userProfile.user.is_sales_cordinator || vm.util.isShipper\"><div class=\"font-size-11 fg-AAA8AD\">\nSales Person</div><div ng-show=\"inquiry_obj.search_data\" class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\" \ntitle=\"{{inquiry_obj.sales_user.user_first_name}} {{inquiry_obj.sales_user.user_last_name}}\"><span \nng-bind=\"inquiry_obj.sales_user ? inquiry_obj.sales_user.user_first_name+ \' \' +inquiry_obj.sales_user.user_last_name : \'-\'\">\n</span></div><div ng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div class=\"pv-5\" \nng-if=\"vm.util.userProfile.user.is_sales_cordinator || vm.is_sales_user\"><div class=\"font-size-11 fg-AAA8AD\">Customer\n</div><div class=\"font-size-13 fg-333333 font-weight-600 ellipsis-name\" \ntitle=\"{{inquiry_obj.shipper_user.company.company_name}}\"><span ng-if=\"inquiry_obj.shipper_user.company.company_name\">\n{{inquiry_obj.shipper_user.user_first_name}} {{inquiry_obj.shipper_user.user_last_name}} <span class=\"font-size-11\">\n{{inquiry_obj.shipper_user.company.company_name}}</span><md-tooltip md-direction=\"bottom\" class=\"font-size-10\">\n{{inquiry_obj.shipper_user.user_first_name}} {{inquiry_obj.shipper_user.user_last_name}} {{inquiry_obj.shipper_user.company.company_name}}\n</md-tooltip></span><span class=\"grey-400-fg\" ng-if=\"!inquiry_obj.shipper_user.company.company_name\">N/A</span></div>\n<div ng-show=\"!inquiry_obj.search_data\" class=\"loader\"></div></div><div flex layout=\"row\" layout-align=\"end end\"><div \nlayout=\"row\" class=\"tms-status mr-5 text-truncate\" ng-if=\"inquiry_obj.sync_status && !vm.util.isShipper\" \ntitle=\"{{inquiry_obj.sync_status}}\"><span class=\"pb-8 pr-5\">{{inquiry_obj.sync_status}}</span></div></div></div></div>\n</div></div></div></div></md-content><div layout=\"row\" layout-align=\"center center\" layout-wrap \nclass=\"pt-20 white-bg min-height-600 h-100-p\" ng-show=\"vm.inquiryTotalCount==0 && !vm.inquiryListToRender.shimmer\" \nclass=\"inquiryData\"><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div class=\"font-size-18 pb-8\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-svg-icon=\"assets/icons/custom/empty_quotes.svg\" \nclass=\"w-300 h-150\"></md-icon><div class=\"font-size-20 grey-600-fg\">No Enquiries Found</div><div \nclass=\"font-size-14 grey-fg pt-5\">No new Enquiries was created</div></div></div></div><div layout=\"column\" flex=\"100\" \nlayout-wrap layout-align=\"center center\" ng-if=\"vm.listLoader\" class=\"mv-20 pt-10\"><md-progress-circular>\n</md-progress-circular></div></div></div></div><div class=\"layout-styles\"><button \nclass=\"md-fab md-fab-bottom-right md-button white-bg scrollTopBtn hide pointer\" type=\"button\" \nng-click=\"vm.scrollTop();\" id=\"inquiry-return-to-top\"><md-icon md-font-icon=\"icon-arrow-up\" role=\"img\" \nclass=\"s25 fg-AAA8AD\"></md-icon><md-tooltip md-direction=\"top\">Go to Top</md-tooltip></button></div></div><div \nlayout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"vm.pageLoader\" class=\"mv-20 pt-10\">\n<md-progress-circular></md-progress-circular></div></div>");
$templateCache.put("app/main/RateProvider/customCurrency.html","<div id=\"rateProvider\"><div layout=\"column\"><div class=\"pl-25 pt-20 font-size-18 md-primary-fg\">Rate Provider</div>\n</div><div layout=\"column\" layout-align=\"end end\" class=\"pb-5 mr-15\"><md-button md-no-ink class=\"md-accent-btn\" \nng-click=\"vm.fnAddProvider($event)\">+ Add Rate Provider</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"pt-20\" ng-if=\"vm.rateProvider.length <= 0\"><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-size-18 pb-8\">Data Not Available!</div></div></div><div \nclass=\"simple-table-container m-25\" ng-if=\"vm.rateProvider.length > 0\"><div \nclass=\"white-bg md-whiteframe-4dp rate_table\"><table class=\"dataTable row-border hover text-center\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"border-right\"><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Sr No.</span></div></th><th class=\"border-right\"><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Vendor id</span></div></th><th class=\"border-right\"><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Margin</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Conversion Rate</span></div></th></tr></thead><tbody><tr \nng-repeat=\"provider in vm.rateProvider track by $index\"><td class=\"border-right\">{{$index+1}}.</td><td \nclass=\"border-right\">{{provider.vendor_id}}</td><td class=\"border-right\">\n{{provider.margin !=\'\' ? provider.margin : \'N/A\'}}</td><td><md-button md-no-ink \nclass=\"md-primary edit_btn md-raised md-hue-2 border m-5\" ng-click=\"vm.fnViewConversionRate(provider,$event,$index)\">\nEdit rate</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/add-rates/add-rates.html","<div id=\"add-rates\"><iframe id=\"add-rates-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/banner/banner.html","<div id=\"banners-page\" class=\"simple-table-container\"><div><div layout=\"row\" layout-padding flex=\"100\"><div \nlayout-align=\"start center\" class=\"pt-15\" flex=\"70\" flex-xs=\"70\">{{vm.bannerLength}} Banners Found</div><div \nlayout-align=\"end center\" layout=\"row\" flex=\"30\" flex-xs=\"30\"><md-input-container \nclass=\"search-content max-w-350 mr-10\" md-no-float flex=\"70\"><input id=\"banner-name\" class=\"border-0 panel-select\" \nng-model=\"vm.searchName\" name=\"banner_name\" placeholder=\"{{vm.searchName ? \'N/A\' : \'Enter Banner name\' }} \" \nng-change=\"vm.fnTrackEvent(\'Banner-SearchName-Change\' );vm.searchTable()\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></md-input-container><div class=\"text-end\"><md-button \nflex=\"30\" md-no-ink layout-align=\"end center\" class=\"md-accent-btn m-0 ml-auto min-w-105\" \nng-click=\"vm.create_banner($event)\">+ Create Banner</md-button></div></div></div><div \nclass=\"m-10 simple-table-container\"><table datatable=\"\" class=\"dataTable row-border hover b\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" id=\"banner_table\"></table></div></div></div>");
$templateCache.put("app/main/basket/basket.html","<div class=\"basket\"><iframe resize-handler id=\"basket-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/carrier-integration/carrier-integration.html","<div id=\"carrier-integration\"><iframe id=\"carrier-integration-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/cdm/cdm.html","<div class=\"cdm\"><iframe id=\"cdm-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" \nstyle=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/cdm-audit-trail/cdm-audit-trail.html","<div id=\"cdm-audit-trail\"><iframe id=\"cdm-audit-trail-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/cdm-download/cdm-download.html","<div id=\"cdm-download\"><iframe id=\"cdm-download-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/create-quote/create-quote.html","<quote-modification quote-value=\"vm.quoteDetails\" page-title=\"\'create-quote\'\" is-manual=\"vm.is_manual\">\n</quote-modification>");
$templateCache.put("app/main/currency-setting/currency-setting.html","<div class=\"currency-setting\"><iframe id=\"currency-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/create-shipment/create-shipment.html","<div id=\"shipment-create\" class=\"mb-20\"><form name=\"taskForm\" class=\"md-inline-form\" ng-submit=\"vm.submitShipment();\" \nnovalidate><div class=\"page_title mv-20\">Create Shipment</div><div class=\"div_shadow p-10 white-bg\" layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex=\"100\" layout-padding layout-wrap><div flex=\"20\" flex-xs=\"100\" flex-sm=\"100\">\n<div class=\"font-weight-600 font-size-16 mb-15\">GENERAL</div><div layout-xs=\"column\"><md-input-container md-no-float \nclass=\"mb-15 m-0\" title=\"Shipper Company\"><md-select ng-model=\"vm.shipment.selected_shipper\" name=\"shipper_company\" \nclass=\"b brad-5 h-35 pl-10\" placeholder=\"Select Shipper Company*\" md-on-open=\"vm.getShipperList();\" \nmd-on-close=\"searchShipper = \'\'\"><md-select-header><input ng-model=\"searchShipper\" type=\"search\" \nplaceholder=\"Search Company\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"\"><md-option \nng-repeat=\"shipper in vm.shipperList | filter:{ \'company_name\':  searchShipper}\" ng-value=\"shipper.id\">\n{{shipper.company_name }}</md-option><div \nng-if=\"vm.shipperList.length && (vm.shipperList | filter:{ \'company_name\':  searchShipper}).length === 0\"><div \nclass=\"p-20 grey-fg font-size-13 font-weight-600\">No Shipper Company found</div></div></md-optgroup></md-select>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container md-no-float \nclass=\"m-0\" flex flex-xs=\"100\" title=\"Service\"><md-select name=\"service\" ng-model=\"vm.shipment.service\" \nplaceholder=\"Select Service\" class=\"b brad-5 h-35 pl-10\"><md-option value=\"express\">Express</md-option><md-option \nvalue=\"normal\">Normal</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"mb-15 mh-5 mt-0 pt-5 pickup-date\" flex flex-xs=\"100\" title=\"Pickup Date\"><md-datepicker \nng-model=\"vm.shipment.cargo_ready_date\" md-placeholder=\"Pickup Date*\" md-hide-icons=\"calendar\" md-open-on-focus flex \nclass=\"pv-8 b brad-5\" onkeydown=\"return false\"></md-datepicker></md-input-container></div></div><div flex=\"55\" \nflex-xs=\"100\" flex-sm=\"100\"><div class=\"font-weight-600 font-size-16 mb-15\">ROUTE DETAILS</div><div layout=\"row\" \nflex=\"100\" layout-xs=\"column\"><div flex class=\"pt-2 mr-15\"><div><md-input-container md-no-float \nclass=\"mb-15 m-0 b brad-5 white-bg\" layout=\"row\" \ntitle=\"Origin port: {{vm.shipment.air_selected_origin_port.portcode_portname}}\"><div class=\"port-label red-500-fg\">A\n</div><md-autocomplete required md-input-name=\"air_origin_port\" \nmd-selected-item=\"vm.shipment.air_selected_origin_port\" md-search-text=\"vm.air_originSearchText\" \nmd-items=\"item in vm.getPort(vm.air_originSearchText,\'AIR\', \'origin\')\" md-item-text=\"item.portcode_portname\" \nmd-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" md-require-match=\"true\" placeholder=\"Select Origin Port*\" \nmd-menu-class=\"autocomplete-custom-template\" md-clear-button=\"false\"><md-item-template><span class=\"item-metadata\">\n{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{vm.air_originSearchText}}\" were found.</md-not-found><div \nng-messages=\"searchForm.air_origin_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></md-input-container></div><div><md-input-container md-no-float class=\"mb-15 m-0 pt-5\" flex \nflex-xs=\"100\" title=\"ETD\"><md-datepicker ng-model=\"vm.shipment.etd\" md-placeholder=\"Select ETD*\" \nmd-hide-icons=\"calendar\" md-open-on-focus flex class=\"pv-8 b brad-5\" onkeydown=\"return false\"></md-datepicker>\n</md-input-container></div></div><div flex class=\"pt-2 mr-15\"><div><md-input-container md-no-float \nclass=\"b mb-15 m-0 brad-5 white-bg\" layout=\"row\" \ntitle=\"Destination port: {{vm.shipment.air_selected_destination_port.portcode_portname}}\"><div \nclass=\"port-label green-300-fg\">B</div><md-autocomplete required md-input-name=\"air_destination_port\" \nmd-selected-item=\"vm.shipment.air_selected_destination_port\" md-search-text=\"vm.air_destinationSearchText\" \nmd-items=\"item in vm.getPort(vm.air_destinationSearchText,\'AIR\', \'destination\')\" md-item-text=\"item.portcode_portname\" \nmd-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" md-require-match=\"true\" placeholder=\"Select Destination Port*\" \nmd-menu-class=\"autocomplete-custom-template\" md-clear-button=\"false\"><md-item-template><span class=\"item-metadata\">\n{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{vm.air_destinationSearchText}}\" were found.</md-not-found><div \nng-messages=\"searchForm.air_destination_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></md-input-container></div><div><md-input-container md-no-float class=\"mb-15 m-0 pt-5\" flex \nflex-xs=\"100\" title=\"ETA\"><md-datepicker ng-model=\"vm.shipment.eta\" md-placeholder=\"Select ETA*\" \nmd-hide-icons=\"calendar\" md-open-on-focus flex class=\"pv-8 b brad-5\" onkeydown=\"return false\"></md-datepicker>\n</md-input-container></div></div><div flex><div><md-input-container md-no-float class=\"mb-15 m-0\" title=\"Airline\">\n<md-select ng-model=\"vm.shipment.selectedairline\" placeholder=\"Select Airline\" class=\"selectBox m-0 b brad-5 pl-5\" \nmd-on-close=\"searchAirline = \'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchAirline\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Search Airline Name (IATA Code / Airline Prefix Code)\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-option ng-repeat=\"airline in vm.airLineData | filter : searchAirline\" \nng-value=\"airline\" title=\"{{airline.name}}\">\n{{airline.name}} ({{airline.code ? airline.code : \'-\'}} / {{airline.prefix ? airline.prefix : \'-\'}})</md-option><div \nng-if=\"vm.airLineData.length && (vm.airLineData | filter:searchAirline).length === 0\"><div \nclass=\"p-20 grey-fg font-size-13 font-weight-600\">No Airline found</div></div></md-select></md-input-container></div>\n<div><md-input-container md-no-float class=\"mb-15 m-0\" title=\"Flight Number\"><input class=\"input_box\" \nng-model=\"vm.shipment.flight_number\" placeholder=\"Enter Flight Number\"></md-input-container></div></div></div></div>\n<div flex><div class=\"font-weight-600 font-size-16 mb-15\">AIRLINE DETAILS</div><div><md-input-container md-no-float \nclass=\"mb-15 m-0\" title=\"MAWB Number\"><input class=\"input_box\" ng-model=\"vm.shipment.mawb\" name=\"mawb\" \nplaceholder=\"Enter MAWB\" type=\"text\" maxlength=\"11\" minlength=\"11\" ng-pattern=\"/^[0-9]*$/\"><div \nng-messages=\"taskForm.mawb.$error\"><div ng-message=\"pattern\"><span>Please Enter Number Only.</span></div></div>\n</md-input-container></div><div><md-input-container md-no-float class=\"mb-15 m-0\" title=\"HAWB\"><input \nclass=\"input_box\" ng-model=\"vm.shipment.hawb\" placeholder=\"Enter HAWB\" maxlength=\"32\"></md-input-container></div></div>\n</div><div class=\"div_shadow white-bg mt-15 pb-20\"><div class=\"p-25 bb\" layout=\"row\" layout-align=\"space-between\"><div \nclass=\"font-weight-600 font-size-16\">LOAD DETAILS</div><div class=\"md-link-fg font-weight-600 font-size-16 pointer\" \nng-click=\"vm.clearAllLoad()\">CLEAR ALL</div></div><div class=\"MobileTableView\"><table class=\"load-table\"><thead><tr>\n<th>Load No.</th><th>Unit/Pallets No.</th><th>Qty</th><th>Gross. Wt.</th><th>Charge. Wt.</th><th>Remarks</th><th></th>\n</tr></thead><tbody><tr ng-repeat=\"load in vm.shipment.load track by $index\"><td><md-input-container md-no-float \nclass=\"p-0 m-0\" flex><input class=\"input_box\" ng-model=\"load.load_number\" placeholder=\"Enter Load No.\" type=\"text\" \nmaxlength=\"32\"></md-input-container></td><td><md-input-container md-no-float class=\"p-0 m-0\" flex><input \nclass=\"input_box\" ng-model=\"load.pallet_no\" placeholder=\"Unit/Pallets No.\" type=\"text\" maxlength=\"32\">\n</md-input-container></td><td><md-input-container md-no-float class=\"p-0 m-0\" flex><input class=\"input_box\" \nng-model=\"load.qty\" placeholder=\"Qty\" type=\"number\" onkeypress=\"return event.charCode >= 48\" min=\"1\">\n</md-input-container></td><td><div layout=\"row\" flex=\"100\" class=\"flex\"><md-input-container md-no-float \nclass=\"h-35 b pieces-border-radius p-0 m-0\"><input class=\"border-none ml-0\" type=\"number\" \nonkeypress=\"return event.charCode >= 48\" min=\"1\" ng-model=\"load.gross_weight\" name=\"length\" placeholder=\"Gross Wt.\">\n</md-input-container><md-input-container class=\"bb bt br h-35 kgs-radius p-0 m-0\" md-no-float><md-select \nname=\"Gross Wt unit\" ng-model=\"load.gross_weight_unit\" placeholder=\"Kgs\" required><md-option value=\"KG\">KG</md-option>\n</md-select></md-input-container></div></td><td><div layout=\"row\" flex=\"100\" class=\"flex\"><md-input-container \nmd-no-float class=\"h-35 b pieces-border-radius p-0 m-0\"><input class=\"border-none ml-0\" type=\"number\" \nonkeypress=\"return event.charCode >= 48\" min=\"1\" ng-model=\"load.chargeable_weight\" name=\"length\" \nplaceholder=\"Chargable Wt.\"></md-input-container><md-input-container class=\"bb bt br h-35 kgs-radius p-0 m-0\" \nmd-no-float><md-select name=\"Chargeable Weight Unit\" ng-model=\"load.chargeable_weight_unit\" placeholder=\"KG\" required>\n<md-option value=\"KG\">KG</md-option></md-select></md-input-container></div></td><td><md-input-container md-no-float \nclass=\"p-0 m-0 remark_input\" flex><input class=\"input_box\" ng-model=\"load.remarks\" placeholder=\"Remarks\">\n</md-input-container></td><td><md-icon md-font-icon=\"icon-plus-circle\" ng-click=\"vm.addLoad($index);\" \nclass=\"green-fg pointer\" ng-if=\"$first\"></md-icon><md-icon md-font-icon=\"icon-minus-circle\" \nng-click=\"vm.removeLoad($index);\" class=\"red-fg pointer\" ng-if=\"!$first\"></md-icon></td></tr></tbody></table></div>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"create_shipment_btn\"><md-button md-no-ink type=\"submit\" \nclass=\"md-accent-btn ph-20\">Create Shipment</md-button></div></form></div>");
$templateCache.put("app/main/customRates/customRates.html","<div id=\"custom-rates\" flex-xs=\"100\"><md-tabs md-dynamic-height md-border-bottom flex><md-tab label=\"Custom Rates\" \nstyle=\"overflow-y: scroll\"><div class=\"selectmode mt-20 mb-20 font-size-17 font-weight-600\" layout=\"row\" \nlayout-align=\"center center\" layout-xs=\"column\" layout-align-xs=\"start center\">Select Mode<md-radio-group \nng-model=\"vm.selectedMode\" class=\"radio ml-25\" layout=\"row\" layout-xs=\"row\" ng-change=\"vm.fnChangeMode()\">\n<md-radio-button md-no-ink value=\"SEA-FCL\">SEA-FCL</md-radio-button><md-radio-button md-no-ink value=\"SEA-LCL\" \nclass=\"false-color\" ng-disabled=\"true\">SEA-LCL</md-radio-button><md-radio-button md-no-ink value=\"AIR\" \nclass=\"false-color\" ng-disabled=\"true\">AIR</md-radio-button></md-radio-group></div><div class=\"\" layout=\"column\" \nlayout-align=\"center center\"><md-tabs class=\"mdtabs\" md-selected=\"vm.selectedTab\" md-no-ink-bar=\"true\" \nmd-stretch-tabs=\"always\" md-swipe-content md-enable-disconnect=\"true\"><md-tab \nng-click=\"portDetailsForm.$setPristine(); portDetailsForm.$setUntouched();\" label=\"ORIGIN CUSTOMS\" \nmd-on-select=\"vm.changeTab($event,\'origin_part\', \'ORIGIN CUSTOMS\')\"></md-tab><md-tab \nng-click=\"portDetailsForm.$setPristine(); portDetailsForm.$setUntouched();\" \nlabel=\"{{ vm.mainFreightNameChange ? \'FREIGHT\' : \'FREIGHT\' }}\" \nmd-on-select=\"vm.changeTab($event,\'main_freight\', \'MAIN FREIGHT\')\"></md-tab><md-tab \nng-click=\"portDetailsForm.$setPristine(); portDetailsForm.$setUntouched();\" label=\"DESTINATION CUSTOMS\" \nmd-on-select=\"vm.changeTab($event,\'destination_part\', \'DESTINATION CUSTOMS\')\"></md-tab></md-tabs><div class=\"\" \nlayout=\"row\" ng-if=\"vm.showForm\"><form name=\"portDetailsForm\" ng-submit=\"vm.populateTable(portDetailsForm)\" \nclass=\"font-size-14\" ng-pristine><div layout=\"row\" layout-xs=\"column\" flex=\"50\" flex-xs=\"100\" class=\"mt-20\" \nng-show=\"vm.portDetailsForMainFreight\"><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"input mh-5 w-200\"><label class=\"\" translate=\"SELECT_ORIGIN_COUNTRY\">Select Origin Country</label><md-select \nname=\"selectOrigin\" ng-model=\"vm.selectedOriginCountry\" md-on-close=\"selectOriginsearchTerm = \'\'\" \nng-change=\"vm.getOriginCountryPorts()\" placeholder=\"Select Origin Country\" required \ndata-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input \nstyle=\"z-index:999999999\" ng-model=\"selectOriginsearchTerm\" type=\"search\" placeholder=\"Search for a country..\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"countries\"><md-option ng-value=\"country.country_code\" \nng-repeat=\"country in vm.countries |\n                          filter:selectOriginsearchTerm\">{{country.country_code}}\n</md-option></md-optgroup></md-select><div ng-messages=\"portDetailsForm.selectOrigin.$error\"><div \nng-message=\"required\" translate=\"REQUIRED_ORIGIN_COUNTRY\">Origin country is required</div></div></md-input-container>\n<md-input-container class=\"input mh-5 w-200\"><label class=\"\" translate=\"SELECT_ORIGIN_PORTS\">Select Origin Ports\n</label><md-select name=\"originPorts\" ng-disabled=\"!vm.originPorts.length\" ng-model=\"vm.selectedOriginPorts\" \nmd-on-close=\"originPortssearchTerm = \'\'\" data-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"originPortssearchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" placeholder=\"Search for a port..\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"ports\"><md-option ng-value=\"port.id\" \nng-repeat=\"port in vm.originPorts |\n                                                  filter:originPortssearchTerm\">\n{{port.portcode_portname}}</md-option></md-optgroup></md-select><div ng-messages=\"portDetailsForm.originPorts.$error\">\n<div ng-message=\"required\" translate=\"REQUIRED_ORIGIN_PORTS\">Origin port is required</div></div></md-input-container>\n</div><div ng-click=\"vm.swapPlaces()\" class=\"box mh-15 pointer\" layout=\"row\" layout-xs=\"column\"><md-icon \nmd-svg-src=\"assets/icons/custom/exchange.svg\" class=\"exchangearrow\"></md-icon></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"input mh-5 w-200\" md-no-float><label \ntranslate=\"SELECT_DESTINATION_COUNTRY\">Select Destination Country</label><md-select name=\"destinationCountry\" \nng-model=\"vm.selectedDestinationCountry\" md-on-close=\"destinationCountrysearchTerm = \'\'\" \nng-change=\"vm.getDestinationCountryPorts()\" data-md-container-class=\"selectdemoSelectHeader\" \nplaceholder=\"Select Destination Country\" required><md-select-header class=\"demo-select-header\"><input \nstyle=\"z-index:999999999\" ng-model=\"destinationCountrysearchTerm\" type=\"search\" placeholder=\"Search for a country..\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"countries\"><md-option ng-value=\"country.country_code\" \nng-repeat=\"country in vm.countries |\n                        filter:destinationCountrysearchTerm\">\n{{country.country_code}}</md-option></md-optgroup></md-select><div \nng-messages=\"portDetailsForm.destinationCountry.$error\"><div ng-message=\"required\" \ntranslate=\"REQUIRED_DESTINATION_COUNTRY\">Destination country is required</div></div></md-input-container>\n<md-input-container class=\"input mh-5 w-200\"><label class=\"\" translate=\"SELECT_DESTINATION_PORTS\">\nSelect Destination Ports</label><md-select name=\"destinationPorts\" ng-disabled=\"!vm.destinationPorts.length\" \nng-model=\"vm.selectedDestinationPorts\" md-on-close=\"destinationPortssearchTerm = \'\'\" \ndata-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"destinationPortssearchTerm\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\" placeholder=\"Search for a port..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"ports\"><md-option ng-value=\"port.id\" \nng-repeat=\"port in vm.destinationPorts |\n                                                filter:destinationPortssearchTerm\">\n{{port.portcode_portname}}</md-option></md-optgroup></md-select><div \nng-messages=\"portDetailsForm.destinationPorts.$error\"><div ng-message=\"required\" translate=\"REQUIRED_DESTINATION_PORT\">\nDestination port is required</div></div></md-input-container></div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-20\" ng-show=\"vm.portDetailsForOrigin\"><div layout=\"row\" layout-xs=\"column\" \nflex-xs=\"100\"><md-input-container class=\"input mr-10 w-200\" md-no-float><label translate=\"SELECT_ORIGIN_COUNTRY\">\nSelect Origin Country</label><md-select name=\"selectOriginCountry\" ng-model=\"vm.selectedOriginCountry\" \nmd-on-close=\"selectOriginCountrysearchTerm = \'\'\" ng-change=\"vm.getOriginCountryPorts()\" \ndata-md-container-class=\"selectdemoSelectHeader\" placeholder=\"Select Origin Country\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"selectOriginCountrysearchTerm\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\" placeholder=\"Search for a country..\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup label=\"countries\"><md-option ng-value=\"country.country_code\" \nng-repeat=\"country in vm.countries |\n                        filter:selectOriginCountrysearchTerm\">\n{{country.country_code}}</md-option></md-optgroup></md-select><div \nng-messages=\"portDetailsForm.selectOriginCountry.$error\"><div ng-message=\"required\" \ntranslate=\"REQUIRED_ORIGIN_COUNTRY\">Origin country is required</div></div></md-input-container><md-input-container \nclass=\"input mr-10 w-200\"><label class=\"\" translate=\"SELECT_ORIGIN_PORTS\">Select Origin Ports</label><md-select \nname=\"selectOriginPorts\" ng-disabled=\"!vm.originPorts.length\" ng-model=\"vm.selectedOriginPorts\" \nmd-on-close=\"selectOriginPortssearchTerm = \'\'\" data-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"selectOriginPortssearchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" placeholder=\"Select for a port..\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"ports\"><md-option ng-value=\"port.id\" \nng-repeat=\"port in vm.originPorts |\n                                                filter:selectOriginPortssearchTerm\">\n{{port.portcode_portname}}</md-option></md-optgroup></md-select><div \nng-messages=\"portDetailsForm.selectOriginPorts.$error\"><div ng-message=\"required\" translate=\"REQUIRED_ORIGIN_PORTS\">\nOrigin port is required</div></div></md-input-container></div></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"mt-20\" ng-show=\"vm.portDetailsForDestination\"><div layout=\"row\" layout-xs=\"column\" flex-xs=\"100\">\n<md-input-container class=\"input mr-10 w-200\" md-no-float><label translate=\"SELECT_DESTINATION_COUNTRY\">\nSelect Destination Country</label><md-select name=\"selectDestinationCountry\" ng-model=\"vm.selectedDestinationCountry\" \nmd-on-close=\" selectDestinationsearchTerm = \'\'\" ng-change=\"vm.getDestinationCountryPorts()\" \ndata-md-container-class=\"selectdemoSelectHeader\" placeholder=\"Select Destination Country\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\" selectDestinationsearchTerm\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\" placeholder=\"Search for a country..\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup label=\"countries\"><md-option ng-value=\"country.country_code\" \nng-repeat=\"country in vm.countries |\n                        filter: selectDestinationsearchTerm\">\n{{country.country_code}}</md-option></md-optgroup></md-select><div \nng-messages=\"portDetailsForm.selectDestinationCountry.$error\"><div ng-message=\"required\" \ntranslate=\"REQUIRED_DESTINATION_COUNTRY\">Destination country is required</div></div></md-input-container>\n<md-input-container class=\"input mr-10 w-200\"><label class=\"\" translate=\"SELECT_DESTINATION_PORTS\">\nSelect Destination Ports</label><md-select name=\"selectDestinationPorts\" ng-disabled=\"!vm.destinationPorts.length\" \nng-model=\"vm.selectedDestinationPorts\" md-on-close=\"selectDestiantionPortsearchTerm = \'\'\" \ndata-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"selectDestiantionPortsearchTerm\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\" placeholder=\"Search for a port..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"ports\"><md-option ng-value=\"port.id\" \nng-repeat=\"port in vm.destinationPorts |\n                                              filter:selectDestiantionPortsearchTerm\">\n{{port.portcode_portname}}</md-option></md-optgroup></md-select><div \nng-messages=\"portDetailsForm.selectDestinationPorts.$error\"><div ng-message=\"required\" \ntranslate=\"REQUIRED_DESTINATION_PORT\">Destination port is required</div></div></md-input-container></div></div><div \nlayout=\"column\" layout-align=\"center center\" flex-xs=\"100\" class=\"mt-10 additionalDetails\"><div \nclass=\"additionalDetailsText font-size-20 font-weight-600\" translate=\"ADDITIONAL_DETAILS\">Additional Details</div><div \nclass=\"mv-5\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"mh-5 w-200\" md-no-float><label \ntranslate=\"SELECT_LINER\">Select Liner</label><md-select name=\"selectLiner\" ng-model=\"vm.selectedLiner\" \nmd-on-close=\"selectLinersearchTerm = \'\'\" data-md-container-class=\"selectdemoSelectHeader\" placeholder=\"Select Liner\" \nmultiple=\"multiple\" required><md-select-header class=\"demo-select-header\"><input ng-model=\"selectLinersearchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" placeholder=\"Search for a liner..\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"liners\"><md-option ng-value=\"liner\" \nng-repeat=\"liner in vm.subvendorList |\n                        filter:selectLinersearchTerm\">{{liner.name}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"portDetailsForm.selectLiner.$error\"><div ng-message=\"required\" \ntranslate=\"REQUIRED_LINER\">Liner is required</div></div></md-input-container><md-input-container \nng-if=\"vm.selectedMode === \'SEA-FCL\'\" class=\"w-200\"><label translate=\"SELECT_LOAD\">Select Load Types</label><md-select \nname=\"loadTypes\" ng-model=\"vm.selectedLoadTypes\" md-on-close=\"loadTypessearchTerm = \'\'\" \ndata-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"loadTypessearchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Search for a load..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"loads\">\n<md-option ng-value=\"load\" \nng-repeat=\"load in vm.loadTypeArr |\n                                                      filter:loadTypessearchTerm\">\n{{load.load_code}}</md-option></md-optgroup></md-select><div ng-messages=\"portDetailsForm.loadTypes.$error\"><div \nng-message=\"required\" translate=\"REQUIRED_LOAD_TYPE\">Load types is required</div></div></md-input-container></div><div \nclass=\"populatetable\" layout-xs=\"column\" layout-align-xs=\"start center\"><md-button md-no-ink class=\"md-accent-btn\" \ntype=\"submit\" ng-disabled=\"0\" translate=\"POPULATE_TABLE\">POPULATE TABLE</md-button></div></div></form></div></div><div \nng-show=\"vm.showTable\" class=\"ml-40\"><div id=\"my-container-parent\" layout=\"row\" layout-align=\"center center\"><div \nid=\"my-container\" class=\"columnHeader mt-16\" layout=\"column\"><div id=\"my\"></div></div><div layout=\"column\"><div \nclass=\"plusdiv\" layout=\"column\" layout-align=\"center center\" style=\"cursor: pointer\" ng-click=\"vm.addNewColumn()\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\" style=\"color:#ffffff\"></md-icon></div><div ng-if=\"vm.showRemoveBtn\" \nclass=\"minusdiv\" layout=\"column\" layout-align=\"center center\" style=\"cursor: pointer\" ng-click=\"vm.removeNewColumn()\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" style=\"color:#ffffff\"></md-icon></div></div></div><div class=\"mt-10\" \nng-if=\"vm.util.isFreightbro\" layout=\" row\" layout-align=\"{{$root.forwarder_id ? \'end center\' : \'space between\'}}\"><div \nng-if=\"!$root.forwarder_id\" class=\"alert\">Please select other forwarder from the dropdown.</div><div><md-button \nmd-no-ink class=\"md-accent-btn\" ng-disabled=\"!$root.forwarder_id\" ng-click=\"vm.fnSaveRates()\" translate=\"SAVE_RATES\">\nSave Rates</md-button></div></div><div class=\"mt-10\" layout layout-align=\"end center\" ng-if=\"!vm.util.isFreightbro\">\n<md-button md-no-ink class=\"md-accent-btn\" ng-click=\"vm.fnSaveRates()\" translate=\"SAVE_RATES\">Save Rates</md-button>\n</div></div></md-tab><md-tab label=\"My Rates\" ng-click=\"vm.tabChange()\"><div \nclass=\"selectmode mt-40 mb-40 font-size-17 font-weight-600\" layout=\"row\" layout-align=\"center center\" \nlayout-xs=\"column\" layout-align-xs=\"start center\">Select Mode<md-radio-group ng-model=\"vm.selectedTableMode\" \nclass=\"radio ml-25\" layout=\"row\" layout-xs=\"row\" ng-change=\"vm.changeRateTableMode(vm.selectedRateLeg)\">\n<md-radio-button md-no-ink value=\"fcl\">SEA-FCL</md-radio-button><md-radio-button md-no-ink value=\"lcl\" \nclass=\"false-color\" ng-disabled=\"true\">SEA-LCL</md-radio-button><md-radio-button md-no-ink value=\"air\" \nclass=\"false-color\" ng-disabled=\"true\">AIR</md-radio-button></md-radio-group></div><div class=\"\" layout=\"column\" \nlayout-align=\"center center\"><md-tabs class=\"mdtabs\" md-selected=\"vm.selectedRateTab\" md-no-ink-bar=\"true\" \nmd-stretch-tabs=\"always\" md-swipe-content md-enable-disconnect=\"true\"><md-tab label=\"ORIGIN CUSTOMS\" \nmd-on-select=\"vm.changeRateTableMode(\'ORIGIN CUSTOMS\')\"></md-tab><md-tab \nlabel=\"{{ vm.mainFreightNameChange ? \'FREIGHT\' : \'FREIGHT\' }}\" md-on-select=\"vm.changeRateTableMode(\'MAIN FREIGHT\')\">\n</md-tab><md-tab label=\"DESTINATION CUSTOMS\" md-on-select=\"vm.changeRateTableMode(\'DESTINATION CUSTOMS\')\"></md-tab>\n</md-tabs></div><div class=\"m-20 b\"><div class=\"simple-table-container\" \nng-if=\"vm.ratesData.length && !vm.ratesDataLoad\" id=\"lane-table\"><div class=\"search_table\"><table id=\"ratesDataTable\" \nclass=\"dataTable row-border hover text-center\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th><div \nclass=\"table-header\"><span class=\"file_heading column-title\">Sr No.</span></div></th><th><div class=\"table-header\">\n<span class=\"file_heading column-title\" translate=\"DATE\">Date</span></div></th><th \nng-if=\"vm.selectedRateLeg===\'MAIN FREIGHT\' || vm.selectedRateLeg===\'ORIGIN CUSTOMS\'\"><div class=\"table-header\"><span \nclass=\"file_heading column-title\" translate=\"ORIGIN\">Origin</span></div></th><th \nng-if=\"vm.selectedRateLeg===\'MAIN FREIGHT\' || vm.selectedRateLeg===\'DESTINATION CUSTOMS\'\"><div class=\"table-header\">\n<span class=\"file_heading column-title\" translate=\"DESTINATION\">Destination</span></div></th><th><div \nclass=\"table-header\"><span class=\"file_heading column-title\" translate=\"RATE_TYPE\">Rate type</span></div></th><th><div \nclass=\"table-header\"><span class=\"file_heading column-title\" translate=\"LINER\">Liner</span></div></th><th \nng-if=\"vm.selectedTableMode===\'fcl\'\"><div class=\"table-header\"><span class=\"file_heading column-title\" \ntranslate=\"LOAD\">Load</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"file_heading column-title\" translate=\"ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"data in vm.ratesData track by $index\"><td class=\"pl-10\">{{$index+1}}</td><td \nng-if=\"vm.selectedTableMode===\'fcl\'\" class=\"wrap-div\">{{data.time | UTCToLocal : \'d MMM, yyyy\' || \'-\'}}</td><td \nng-if=\"vm.selectedTableMode!==\'fcl\'\" class=\"wrap-div\">{{data.uploaded_at | UTCToLocal : \'d MMM, yyyy\' || \'-\'}}</td><td \nng-if=\"vm.selectedRateLeg===\'MAIN FREIGHT\' || vm.selectedRateLeg===\'ORIGIN CUSTOMS\'\" class=\"wrap-div\">\n{{data.origin_port || \'-\'}}</td><td \nng-if=\"vm.selectedRateLeg===\'MAIN FREIGHT\' || vm.selectedRateLeg===\'DESTINATION CUSTOMS\'\" class=\"wrap-div\">\n{{data.destination_port || \'-\'}}</td><td class=\"wrap-div\">{{vm.getRateType(data.charges)}}</td><td class=\"wrap-div\">\n{{data.sub_vendor.sv_name?data.sub_vendor.sv_name:data.sub_vendor.name || \'-\'}}</td><td \nng-if=\"vm.selectedTableMode===\'fcl\'\" class=\"wrap-div\">{{data.load_type || \'-\'}}</td><td><md-icon \nmd-font-icon=\"icon-pencil\" class=\"icon md-primary-fg pointer\" ng-click=\"vm.viewRateModal(data, $index)\"></md-icon>\n<md-icon md-font-icon=\"icon-delete\" class=\"icon md-primary-fg pointer\" ng-click=\"vm.deleteRate(data)\"></md-icon></td>\n</tr></tbody></table></div></div><div ng-if=\"!vm.ratesData.length && !vm.ratesDataLoad\" class=\"text-center\"><h1 \ntranslate=\"NO_DATA\">No Data Available!</h1></div><div shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"vm.ratesDataLoad\" class=\"b white-bg mt-20\"></div></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/enquiry-v2/enquiry-list.html","<div class=\"enquiry-list\"><iframe resize-handler id=\"enquiry-list-iframe\" name=\"{{vm.todaysDate}}\" \nng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/forwarder-assignment/forwarder-assignment-form.html","<md-dialog class=\"forwarder-assignment-dialog popup-sm\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div>Assign Receiver</div>\n<md-button md-no-ink class=\"md-icon-button\" ng-disabled=\"ctrl.parent.submit_disabled\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"body\"><form name=\"forwarderAssignmentFrm\" class=\"font-size-13\"><div \nclass=\"mb-15\"><span><label>Supplier Forwarder</label></span><div class=\"font-size-14 grey-700-fg mt-5\">\n{{ctrl.parent.assignForm.supplier.name}}</div><div class=\"font-size-11 grey-500-fg\">\n{{ctrl.parent.assignForm.supplier.domain}}</div></div><div><span><label>Receiver Forwarder</label></span>\n<md-input-container class=\"md-block pt-6-imp\" md-no-float><md-autocomplete md-input-name=\"receiverForwarder\" \nmd-selected-item=\"ctrl.parent.assignForm.selectedReceiver\" \nmd-selected-item-change=\"ctrl.parent.selectAvailableForwarder(ctrl.parent.assignForm.selectedReceiver)\" \nmd-search-text=\"ctrl.parent.assignForm.searchText\" md-search-text-change=\"ctrl.parent.clearAssignValidation()\" \nmd-items=\"item in ctrl.parent.searchAvailableForwarders(ctrl.parent.assignForm.searchText)\" md-item-text=\"item.name\" \nmd-min-length=\"1\" md-delay=\"300\" md-no-cache=\"true\" md-clear-button=\"false\" \nmd-menu-class=\"forwarder-assignment-autocomplete-menu\" \nng-class=\"{\'validation-error\': ctrl.parent.assignValidation.receiver || ctrl.parent.assignValidation.duplicate}\" \nclass=\"panel-select forwarder-assignment-receiver-search\" placeholder=\"Search by forwarder name or domain\">\n<md-item-template><span class=\"forwarder-assignment-search-result\"><span class=\"font-size-13 text-truncate\" \ntitle=\"{{item.name}}\">{{item.name}} </span><span class=\"font-size-11 grey-500-fg text-truncate\" \ntitle=\"{{item.domain}}\">Domain: {{item.domain}} </span><span class=\"font-size-11 grey-500-fg text-truncate\" \nng-if=\"item.domainSubscriberId\">Domain Subscriber ID: {{item.domainSubscriberId}}</span></span></md-item-template>\n<md-not-found>No forwarder matching \"{{ctrl.parent.assignForm.searchText}}\" found.</md-not-found></md-autocomplete><div\n ng-if=\"ctrl.parent.assignValidation.receiver\" class=\"validation-error-text\"><span>Select a receiver forwarder</span>\n</div><div ng-if=\"ctrl.parent.assignValidation.duplicate\" class=\"validation-error-text\"><span>\nThis forwarder is already assigned</span></div></md-input-container></div></form></md-dialog-content><md-dialog-actions\n layout=\"row\" layout-align=\"end center\" class=\"white-bg footer\" layout-wrap flex-xs=\"100\"><div class=\"mv-10\"><md-button\n md-no-ink class=\"md-primary-btn mr-10\" ng-disabled=\"ctrl.parent.submit_disabled\" \nng-click=\"ctrl.parent.cancelDialog()\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10 save1\" \nng-click=\"ctrl.parent.submitAssignment()\" ng-disabled=\"ctrl.parent.submit_disabled\">Assign</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/forwarder-assignment/forwarder-assignment.html","<div id=\"forwarder-assignment-page\" class=\"demo-content forwarder-assignment pv-20\"><div layout=\"row\" \nclass=\"pb-15 pv-20 bb-header\" layout-align=\"space-between start\" layout-xs=\"column\"><div layout-align=\"start center\" \nclass=\"fa-page-heading\" ng-class=\"{ hide : vm.util.isMobileApp }\"><h1 class=\"fa-page-title\">Forwarder Assignment</h1>\n<div class=\"fa-page-subtitle\">Assign receiver forwarders to supplier forwarders</div></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"pt-20\" ng-if=\"!vm.permission[1]\"><div class=\"font-size-18 pb-8\">\nYou don\'t have permission to access this section.</div></div><div ng-if=\"vm.permission[1]\" class=\"fa-page-body\"><div \nclass=\"white-bg brad-3 fa-card fa-shell\" ng-class=\"{\'fa-shell-loading\': vm.isDataLoading}\"><div class=\"fa-card-body\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"30\" flex-sm=\"40\" flex-xs=\"100\" class=\"fa-left\"><div class=\"fa-search-row\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"fa-search-icon s20 grey-600-fg\"></md-icon><md-input-container \nclass=\"md-block m-0 fa-search-field\" md-no-float><input ng-model=\"vm.searchText\" ng-change=\"vm.onSearchChange()\" \nng-keydown=\"($event.which || $event.keyCode) === 13 && vm.triggerSearchNow()\" name=\"forwarderAssignmentSearch\" \nplaceholder=\"Search by forwarder name or domain\" aria-label=\"Search by forwarder name or domain\"></md-input-container>\n</div><md-list class=\"fa-forwarder-list m-0 p-0\"><md-list-item \nng-repeat=\"supplier in vm.supplierList track by vm.getSupplierKey(supplier)\" class=\"fa-list-item p-0\" \nng-class=\"{\'selected\': vm.isSelected(supplier)}\"><div class=\"md-list-item-text pointer fa-list-hit\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"vm.selectSupplier(supplier)\"><div class=\"fa-list-item-main\" flex><div \nclass=\"fa-forwarder-name text-truncate\">{{supplier.name}}</div><div class=\"fa-forwarder-sub grey-500-fg text-truncate\">\n{{supplier.domain}}</div><div class=\"fa-forwarder-sub grey-500-fg text-truncate\">\nFFC Domain: {{supplier.isFfc ? \'Yes\' : \'No\'}}</div></div><span class=\"fa-count-badge\" \nng-if=\"supplier.receiverCount !== undefined\" ng-class=\"{\'fa-count-badge--muted\': !vm.isSelected(supplier)}\">\n{{supplier.receiverCount}}</span></div></md-list-item></md-list><div ng-if=\"vm.totalSuppliers\" layout=\"row\" \nlayout-align=\"space-between center\" class=\"fa-pagination\"><div class=\"font-size-12 grey-600-fg\"><span \nng-if=\"vm.totalPages() === 1\">Showing {{vm.totalSuppliers}} of {{vm.totalSuppliers}}</span> <span \nng-if=\"vm.totalPages() !== 1\">Showing {{vm.rangeStart()}}-{{vm.rangeEnd()}} of {{vm.totalSuppliers}}</span></div><div \nlayout=\"row\" layout-align=\"end center\" class=\"fa-pagination-controls\"><md-button md-no-ink \nclass=\"md-icon-button m-0 fa-page-btn\" ng-disabled=\"!vm.canPrev() || vm.isDataLoading\" ng-click=\"vm.prevPage()\" \naria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s20 grey-600-fg\"></md-icon></md-button>\n<md-progress-circular ng-if=\"vm.isDataLoading\" md-mode=\"indeterminate\" md-diameter=\"14\" class=\"fa-pagination-spinner\">\n</md-progress-circular><md-button md-no-ink class=\"md-icon-button m-0 fa-page-btn\" \nng-disabled=\"!vm.canNext() || vm.isDataLoading\" ng-click=\"vm.nextPage()\" aria-label=\"Next\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s20 grey-600-fg\"></md-icon></md-button></div></div><div \nng-if=\"!vm.isDataLoading && !vm.supplierList.length\" class=\"grey-500-fg font-size-13 pv-15 text-center\"><span \nng-if=\"vm.searchText\">No forwarders found for your search.</span> <span ng-if=\"!vm.searchText\">No forwarders found.\n</span></div></div><div flex flex-xs=\"100\" class=\"fa-main\" ng-if=\"vm.selectedSupplier\"><div class=\"fa-detail-panel\">\n<div class=\"fa-detail-hero\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div \nclass=\"fa-detail-hero-main\" flex><h2 class=\"fa-partner-title text-truncate\">{{vm.selectedSupplier.name}}</h2><div \nclass=\"fa-partner-domain text-truncate\" title=\"{{vm.selectedSupplier.domain}}\">{{vm.selectedSupplier.domain}}</div>\n</div><md-button md-no-ink class=\"md-accent-btn fa-action-btn\" ng-if=\"vm.permission[0]\" \nng-click=\"vm.openAssignDialog($event)\">+ Assign Receiver</md-button></div><div class=\"fa-stat-cards\" layout=\"row\" \nlayout-wrap><div class=\"fa-stat-card\" flex=\"50\" flex-xs=\"100\"><div class=\"fa-stat-label\">Domain Subscriber ID</div><div\n class=\"fa-stat-value\">{{vm.selectedSupplier.domainSubscriberId || \'—\'}}</div></div><div class=\"fa-stat-card\" \nflex=\"50\" flex-xs=\"100\"><div class=\"fa-stat-label\">Assigned Receivers</div><div class=\"fa-stat-value\">\n{{vm.receiverList.length}}</div></div></div><div class=\"fa-section\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"fa-section-header\"><span class=\"fa-section-label\">Assigned Receivers</span> <span class=\"fa-section-badge\">\n{{vm.receiverList.length}}</span></div><div class=\"fa-search-row fa-receiver-search-row\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"fa-search-icon s20 grey-600-fg\"></md-icon><md-input-container \nclass=\"md-block m-0 fa-search-field\" md-no-float><input ng-model=\"vm.receiverSearchText\" \nng-change=\"vm.onReceiverSearchChange()\" \nng-keydown=\"($event.which || $event.keyCode) === 13 && vm.triggerReceiverSearchNow()\" name=\"receiverSearch\" \nplaceholder=\"Search receivers by name or domain\" aria-label=\"Search receivers by name or domain\"></md-input-container>\n</div><div ng-if=\"vm.isReceiverLoading\" layout=\"row\" layout-align=\"center center\" class=\"fa-receiver-loading pv-20\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></div><div \nng-if=\"!vm.isReceiverLoading && !vm.receiverList.length\" class=\"fa-empty-receivers grey-500-fg\">\nNo receivers assigned yet. Use + Assign Receiver to link a receiver forwarder.</div><md-list \nclass=\"fa-receiver-list m-0 p-0\" ng-if=\"!vm.isReceiverLoading && vm.receiverList.length\"><md-list-item \nng-repeat=\"receiver in vm.pagedReceiverList track by vm.getReceiverKey(receiver)\" class=\"fa-receiver-item p-0\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"fa-receiver-hit\"><div class=\"fa-receiver-main\" flex>\n<div class=\"fa-receiver-name text-truncate\" title=\"{{receiver.name}}\">{{receiver.name}}</div><div \nclass=\"fa-receiver-sub grey-500-fg text-truncate\" ng-if=\"receiver.domain\" title=\"{{receiver.domain}}\">\nDomain: {{receiver.domain}}</div><div class=\"fa-receiver-sub grey-500-fg text-truncate\" \nng-if=\"receiver.domainSubscriberId\" title=\"{{receiver.domainSubscriberId}}\">\nDomain Subscriber ID: {{receiver.domainSubscriberId}}</div></div><md-button md-no-ink \nclass=\"fa-action-btn fa-action-btn--unassign\" ng-if=\"vm.permission[3]\" \nng-disabled=\"vm.deleteInProgress && vm.deletingKey === vm.getReceiverKey(receiver)\" \nng-click=\"vm.confirmUnassign(receiver, $event)\"><span layout=\"row\" layout-align=\"center center\"><md-progress-circular \nng-if=\"vm.deleteInProgress && vm.deletingKey === vm.getReceiverKey(receiver)\" md-mode=\"indeterminate\" md-diameter=\"16\" \nclass=\"mr-8\"></md-progress-circular><span>\n{{(vm.deleteInProgress && vm.deletingKey === vm.getReceiverKey(receiver)) ? \'Removing...\' : \'Unassign\'}}</span></span>\n</md-button></div></md-list-item></md-list><div ng-if=\"!vm.isReceiverLoading && vm.receiverList.length\" layout=\"row\" \nlayout-align=\"space-between center\" class=\"fa-pagination fa-receiver-pagination\"><div class=\"font-size-12 grey-600-fg\">\n<span ng-if=\"vm.receiverTotalPages() === 1\">Showing {{vm.receiverList.length}} of {{vm.receiverList.length}}</span> \n<span ng-if=\"vm.receiverTotalPages() !== 1\">\nShowing {{vm.receiverRangeStart()}}-{{vm.receiverRangeEnd()}} of {{vm.receiverList.length}}</span></div><div \nlayout=\"row\" layout-align=\"end center\" class=\"fa-pagination-controls\"><md-button md-no-ink \nclass=\"md-icon-button m-0 fa-page-btn\" ng-disabled=\"!vm.canReceiverPrev() || vm.isReceiverLoading\" \nng-click=\"vm.receiverPrevPage()\" aria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"s20 grey-600-fg\"></md-icon></md-button><md-progress-circular ng-if=\"vm.isReceiverLoading\" \nmd-mode=\"indeterminate\" md-diameter=\"14\" class=\"fa-pagination-spinner\"></md-progress-circular><md-button md-no-ink \nclass=\"md-icon-button m-0 fa-page-btn\" ng-disabled=\"!vm.canReceiverNext() || vm.isReceiverLoading\" \nng-click=\"vm.receiverNextPage()\" aria-label=\"Next\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s20 grey-600-fg\">\n</md-icon></md-button></div></div></div></div></div><div flex flex-xs=\"100\" class=\"pv-40 ph-20 fa-right-loading\" \nng-if=\"!vm.selectedSupplier && vm.isDataLoading\" layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular></div><div flex flex-xs=\"100\" \nclass=\"pv-40 ph-20 grey-500-fg fa-empty-main\" ng-if=\"!vm.selectedSupplier && !vm.isDataLoading\">\nSelect a forwarder to view assigned receivers.</div></div></div></div></div>");
$templateCache.put("app/main/lcl-pricing-management/lclMatrixView.html","<div id=\"lcl-pricing\"><iframe resize-handler id=\"lcl-pricing-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/manage-notification/manage-notification.html","<div id=\"manageNotification\"><div class=\"font-size-24 font-bold pb-15\" id=\"notification\">Notification Settings</div>\n<iframe id=\"manageNotification-iframe\" ng-style=\"vm.minHeight\" width=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/manage-rates/manage-rates.html","<div id=\"manage-rates\"><iframe id=\"manage-rates-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/my-rates/my-rates.html","<div id=\"my-rates\"><iframe id=\"my-rates-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/my-rates-v2/myRatesV2.html","<div id=\"uploadRatesV2\"><iframe resize-handler id=\"upload-rates-v2\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/notification/notification.html","<div id=\"notification-page\"><div class=\"m-25 ph-5\"><div class=\"gray-500-fg\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"back_icon mr-10 pointer\" ng-click=\"vm.backToPreviousTab()\"></md-icon><span class=\"font-size-14 pointer\" \nng-click=\"vm.backToPreviousTab()\">BACK</span><md-button md-no-ink class=\"md-icon-button float-right\" \nng-click=\"vm.backToPreviousTab()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"font-size-18 pb-8 pt-10 fg-333333\">Notifications</div><div class=\"gray-500-fg\" \nng-if=\"vm.notificationData.length>0\">{{vm.notificationService.unReadNotificationCount}} unread</div><md-content \nclass=\"b mv-20 white-bg\" when-scrolled=\"vm.loadMoreRecordsNotification(vm.notificationData.length)\" ms-scroll \nng-style=\"vm.maxHeight\" id=\"notificationList\" ng-if=\"vm.notificationData.length>0\"><div class=\"pointer\" \nng-class=\"{\'read_div\' : notification.read == false, \'white-bg\' : notification.read == true, \'mb-5\' : !$last}\" \nng-repeat=\"notification in vm.notificationData as notificationObj track by $index\"><div \ncompile-html=\"notification.item.html\" ng-click=\"vm.viewNotification(notification)\"></div></div></md-content><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\" ng-if=\"vm.notificationData.length<=0\"><div \nclass=\"font-size-18 pb-8\">Data Not Available!</div></div></div></div>");
$templateCache.put("app/main/one-quote/one-quote.html","<div class=\"oneQuote\"><iframe resize-handler id=\"oneQuote-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/partner-rate-management/confirm-discard-unsaved.dialog.html","<md-dialog class=\"prm-unsaved-dialog\" aria-label=\"Unsaved changes\"><md-dialog-content \nclass=\"prm-unsaved-dialog__content md-dialog-content\"><p class=\"prm-unsaved-dialog__message\">\nUnsaved changes will be lost. Proceed anyway?</p></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\" class=\"prm-unsaved-dialog__actions\"><md-button class=\"prm-unsaved-dialog__btn-cancel\" \nng-click=\"cancel()\" type=\"button\">No, Cancel</md-button><md-button \nclass=\"prm-unsaved-dialog__btn-proceed md-primary md-confirm-button\" ng-click=\"proceed()\" type=\"button\">Yes, Proceed\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partner-rate-management/partner-rate-management.html","<div id=\"partner-rate-management-page\" class=\"demo-content partner-rate-management pv-20\"><div layout=\"row\" \nclass=\"pb-15 pv-20 bb-header\" layout-align=\"space-between start\" layout-xs=\"column\"><div layout-align=\"start center\" \nclass=\"prm-page-heading\" ng-class=\"{ hide : vm.util.isMobileApp }\"><h1 class=\"prm-page-title\">Manage Rate Sharing</h1>\n<div class=\"prm-page-subtitle\">Configure shared rates with partner forwarders</div></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"pt-20\" ng-if=\"!vm.permission[1]\"><div class=\"font-size-18 pb-8\">\nYou don\'t have permission to access this section.</div></div><div ng-if=\"vm.permission[1]\" class=\"prm-page-body\"><div \nclass=\"white-bg brad-3 prm-card prm-shell\" ng-class=\"{\'prm-shell-loading\': vm.isListLoading}\"><div \nclass=\"prm-card-body\" layout=\"row\" layout-xs=\"column\"><div flex=\"30\" flex-sm=\"40\" flex-xs=\"100\" class=\"prm-left\"><div \nclass=\"prm-relationship-tabs\" layout=\"row\" layout-xs=\"column\" layout-align=\"stretch stretch\"><div class=\"prm-rel-tab\" \nflex ng-class=\"{\'active\': vm.relationshipTab === \'suppliers\', \'prm-rel-tab--disabled\': vm.isLoggedInCompanyFfc()}\" \nng-click=\"!vm.isLoggedInCompanyFfc() && vm.setRelTab(0, $event)\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"prm-rel-tab-head\"><span class=\"prm-rel-tab-icon\" \nng-class=\"{\'prm-rel-tab-icon--active\': vm.relationshipTab === \'suppliers\'}\"></span> <span class=\"prm-rel-tab-title\">\nRate Suppliers</span> <span class=\"prm-count-badge\" \nng-class=\"{\'prm-count-badge--muted\': vm.relationshipTab !== \'suppliers\'}\">{{ vm.supplierTabCount }}</span></div><div \nclass=\"prm-rel-tab-sub grey-600-fg\">External rates received</div></div><span class=\"prm-rel-tab-divider\" hide-xs \naria-hidden=\"true\"></span><div class=\"prm-rel-tab\" flex ng-class=\"{\'active\': vm.relationshipTab === \'recipients\'}\" \nng-click=\"vm.setRelTab(1, $event)\"><div layout=\"row\" layout-align=\"start center\" class=\"prm-rel-tab-head\"><span \nclass=\"prm-rel-tab-icon\" ng-class=\"{\'prm-rel-tab-icon--active\': vm.relationshipTab === \'recipients\'}\"></span> <span \nclass=\"prm-rel-tab-title\">Rate Recipients</span> <span class=\"prm-count-badge\" \nng-class=\"{\'prm-count-badge--muted\': vm.relationshipTab !== \'recipients\'}\">{{ vm.recipientTabCount }}</span></div><div \nclass=\"prm-rel-tab-sub grey-600-fg\">My shared rates</div></div></div><div class=\"prm-search-row\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"prm-search-icon s20 grey-600-fg\"></md-icon><md-input-container \nclass=\"md-block m-0 prm-search-field\" md-no-float><input ng-model=\"vm.searchText\" ng-change=\"vm.onSearchChange()\" \nng-keydown=\"($event.which || $event.keyCode) === 13 && vm.triggerSearchNow()\" placeholder=\"Search Forwarder name\" \naria-label=\"Search Forwarder name\"></md-input-container></div><md-list class=\"prm-forwarder-list m-0 p-0\"><md-list-item\n ng-repeat=\"row in vm.assignments track by row._id\" class=\"prm-list-item p-0\" \nng-class=\"{\'selected\': vm.selected && vm.selected._id === row._id}\"><div \nclass=\"md-list-item-text pointer prm-list-hit\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"vm.selectAssignment(row, $event)\"><div class=\"prm-list-item-main\" flex><div \nclass=\"prm-forwarder-name text-truncate\" title=\"{{ vm.counterpartName(row) }}\">{{ vm.counterpartName(row) }}</div><div \nclass=\"prm-forwarder-sub grey-500-fg text-truncate\" ng-if=\"vm.counterpartDomain(row)\" \ntitle=\"{{ vm.counterpartDomain(row) }}\">Domain: {{ vm.counterpartDomain(row) }}</div><div \nclass=\"prm-forwarder-sub grey-500-fg text-truncate\" ng-if=\"vm.counterpartDomainSubscriberId(row)\" \ntitle=\"{{ vm.counterpartDomainSubscriberId(row) }}\">Domain Subscriber ID: {{ vm.counterpartDomainSubscriberId(row) }}\n</div><div class=\"prm-forwarder-sub grey-500-fg text-truncate\">\nFFC Domain: {{ vm.counterpartIsFfc(row) ? \'Yes\' : \'No\' }}</div></div></div></md-list-item></md-list><div \nng-if=\"vm.totalCount\" layout=\"row\" layout-align=\"space-between center\" class=\"prm-pagination\"><div \nclass=\"font-size-12 grey-600-fg\"><span ng-if=\"vm.totalPages() === 1\">Showing {{ vm.totalCount }} of {{ vm.totalCount }}\n</span> <span ng-if=\"vm.totalPages() !== 1\">Showing {{ vm.rangeStart() }}-{{ vm.rangeEnd() }} of {{ vm.totalCount }}\n</span></div><div layout=\"row\" layout-align=\"end center\" class=\"prm-pagination-controls\"><md-button md-no-ink \nclass=\"md-icon-button m-0 prm-page-btn\" ng-disabled=\"!vm.canPrev() || vm.isListLoading\" ng-click=\"vm.prevPage()\" \naria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s20 grey-600-fg\"></md-icon></md-button>\n<md-progress-circular ng-if=\"vm.isListLoading\" md-mode=\"indeterminate\" md-diameter=\"14\" class=\"prm-pagination-spinner\">\n</md-progress-circular><md-button md-no-ink class=\"md-icon-button m-0 prm-page-btn\" \nng-disabled=\"!vm.canNext() || vm.isListLoading\" ng-click=\"vm.nextPage()\" aria-label=\"Next\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s20 grey-600-fg\"></md-icon></md-button></div></div><div \nng-if=\"!vm.isListLoading && !vm.assignments.length\" class=\"grey-500-fg font-size-13 pv-15 text-center\">\nNo partners found.</div></div><div flex flex-xs=\"100\" class=\"prm-main\" ng-if=\"vm.selected\"><div \nclass=\"prm-partner-header\" layout=\"row\" layout-align=\"start center\"><span class=\"prm-partner-title text-truncate\">\n{{ vm.counterpartName(vm.selected) }}</span></div><div class=\"prm-mode-tabs\"><button type=\"button\" \nclass=\"prm-mode-tab\" ng-class=\"{\'active\': vm.modeTab === \'fcl\'}\" ng-click=\"vm.setModeTab(0, \'fcl\')\">FCL</button> \n<button type=\"button\" class=\"prm-mode-tab\" ng-class=\"{\'active\': vm.modeTab === \'lcl\'}\" \nng-click=\"vm.setModeTab(1, \'lcl\')\">LCL</button> <button type=\"button\" class=\"prm-mode-tab\" \nng-class=\"{\'active\': vm.modeTab === \'air\'}\" ng-click=\"vm.setModeTab(2, \'air\')\">AIR</button></div><h2 \nclass=\"prm-section-label\">VISIBILITY CONTROLS</h2><div class=\"prm-vis-cards\"><div class=\"prm-vis-card\" \nng-if=\"vm.isSupplierPerspective()\"><span class=\"prm-vis-card-icon\" aria-hidden=\"true\"><md-icon \nmd-font-icon=\"icon-cloud-upload\" class=\"s22 grey-600-fg\"></md-icon></span><div class=\"prm-vis-card-body\" flex><div \nclass=\"prm-vis-card-title\">{{ vm.isFfcRecipientLock() ? \'Enable FFC Rates\' : \'Enable Sharing Rates\' }}</div><div \nclass=\"prm-vis-card-desc grey-600-fg\">Allow this partner to receive rates from your dashboard.</div></div><md-checkbox \nng-model=\"vm.draft[vm.modeTab].isEnabledFromSupplier\" class=\"md-primary prm-vis-card-cb\" \naria-label=\"{{ vm.isFfcRecipientLock() ? \'Enable FFC Rates\' : \'Enable Sharing Rates\' }}\"></md-checkbox></div><div \nclass=\"prm-vis-card\" ng-if=\"vm.isSupplierPerspective()\" ng-class=\"{\'prm-vis-card--readonly\': vm.isFfcRecipientLock()}\">\n<span class=\"prm-vis-card-icon\" aria-hidden=\"true\"><md-icon md-font-icon=\"icon-email\" class=\"s22 grey-600-fg\">\n</md-icon></span><div class=\"prm-vis-card-body\" flex><div class=\"prm-vis-card-title\">Enable Receiving Rate Requests\n</div><div class=\"prm-vis-card-desc grey-600-fg\">Allows receivers to send rate inquiries to you</div></div><md-checkbox\n ng-model=\"vm.draft[vm.modeTab].allowRateRequestFromSupplier\" ng-disabled=\"vm.isFfcRecipientLock()\" \nclass=\"md-primary prm-vis-card-cb\" aria-label=\"Enable Receiving Rate Requests\"></md-checkbox></div><div \nclass=\"prm-vis-card\" ng-if=\"!vm.isSupplierPerspective()\"><span class=\"prm-vis-card-icon\" aria-hidden=\"true\"><md-icon \nmd-font-icon=\"icon-cloud-download\" class=\"s22 grey-600-fg\"></md-icon></span><div class=\"prm-vis-card-body\" flex><div \nclass=\"prm-vis-card-title\">{{ vm.isFfcSupplierLock() ? \'Enable Receiving Rates\' : \'Enable Receiving Shared Rates\' }}\n</div><div class=\"prm-vis-card-desc grey-600-fg\">Allow this partner to transmit rates to your dashboard.</div></div>\n<md-checkbox ng-model=\"vm.draft[vm.modeTab].isEnabledFromReceiver\" class=\"md-primary prm-vis-card-cb\" \naria-label=\"{{ vm.isFfcSupplierLock() ? \'Enable Receiving Rates\' : \'Enable Receiving Shared Rates\' }}\"></md-checkbox>\n</div><div class=\"prm-vis-card\" ng-if=\"!vm.isSupplierPerspective()\" \nng-class=\"{\'prm-vis-card--readonly\': vm.isFfcSupplierLock()}\"><span class=\"prm-vis-card-icon\" aria-hidden=\"true\">\n<md-icon md-font-icon=\"icon-email\" class=\"s22 grey-600-fg\"></md-icon></span><div class=\"prm-vis-card-body\" flex><div \nclass=\"prm-vis-card-title\">Enable Rate Requests to Supplier</div><div class=\"prm-vis-card-desc grey-600-fg\">\nAllows to send rate inquiries to suppliers</div></div><md-checkbox \nng-model=\"vm.draft[vm.modeTab].allowRateRequestFromReceiver\" ng-disabled=\"vm.isFfcSupplierLock()\" \nclass=\"md-primary prm-vis-card-cb\" aria-label=\"Enable Rate Requests to Supplier\"></md-checkbox></div><div \nclass=\"prm-vis-card\" ng-if=\"vm.isSupplierPerspective()\" ng-class=\"{\'prm-vis-card--readonly\': vm.isFfcRecipientLock()}\">\n<span class=\"prm-vis-card-icon\" aria-hidden=\"true\"><md-icon md-font-icon=\"icon-file-document\" class=\"s22 grey-600-fg\">\n</md-icon></span><div class=\"prm-vis-card-body\" flex><div class=\"prm-vis-card-title\">Show Uploaded Rate Sheet</div><div\n class=\"prm-vis-card-desc grey-600-fg\">Expose the raw PDF/Excel documents attached to rates.</div></div><md-checkbox \nng-model=\"vm.draft[vm.modeTab].showUploadRateSheetFromSupplier\" ng-disabled=\"vm.isFfcRecipientLock()\" \nclass=\"md-primary prm-vis-card-cb\" aria-label=\"Show Uploaded Rate Sheet\"></md-checkbox></div><div class=\"prm-vis-card\" \nng-if=\"!vm.isSupplierPerspective()\" ng-class=\"{\'prm-vis-card--readonly\': vm.isFfcSupplierLock()}\"><span \nclass=\"prm-vis-card-icon\" aria-hidden=\"true\"><md-icon md-font-icon=\"icon-file-document\" class=\"s22 grey-600-fg\">\n</md-icon></span><div class=\"prm-vis-card-body\" flex><div class=\"prm-vis-card-title\">Show Uploaded Rate Sheet</div><div\n class=\"prm-vis-card-desc grey-600-fg\">Expose the raw PDF/Excel documents attached to rates.</div></div><md-checkbox \nng-model=\"vm.draft[vm.modeTab].showUploadRateSheetOnReceiverSide\" ng-disabled=\"vm.isFfcSupplierLock()\" \nclass=\"md-primary prm-vis-card-cb\" aria-label=\"Show Uploaded Rate Sheet\"></md-checkbox></div><div class=\"prm-vis-card\" \nng-if=\"vm.isSupplierPerspective()\" ng-class=\"{\'prm-vis-card--readonly\': vm.isFfcRecipientLock()}\"><span \nclass=\"prm-vis-card-icon\" aria-hidden=\"true\"><md-icon md-font-icon=\"icon-pound\" class=\"s22 grey-600-fg\"></md-icon>\n</span><div class=\"prm-vis-card-body\" flex><div class=\"prm-vis-card-title\">Show Contract Number</div><div \nclass=\"prm-vis-card-desc grey-600-fg\">Include partner-specific contract identifiers in search results.</div></div>\n<md-checkbox ng-model=\"vm.draft[vm.modeTab].showContractNumberFromSupplier\" ng-disabled=\"vm.isFfcRecipientLock()\" \nclass=\"md-primary prm-vis-card-cb\" aria-label=\"Show Contract Number\"></md-checkbox></div><div class=\"prm-vis-card\" \nng-if=\"!vm.isSupplierPerspective()\" ng-class=\"{\'prm-vis-card--readonly\': vm.isFfcSupplierLock()}\"><span \nclass=\"prm-vis-card-icon\" aria-hidden=\"true\"><md-icon md-font-icon=\"icon-pound\" class=\"s22 grey-600-fg\"></md-icon>\n</span><div class=\"prm-vis-card-body\" flex><div class=\"prm-vis-card-title\">Show Contract Number</div><div \nclass=\"prm-vis-card-desc grey-600-fg\">Include partner-specific contract identifiers in search results.</div></div>\n<md-checkbox ng-model=\"vm.draft[vm.modeTab].showContractNumberOnReceiverSide\" ng-disabled=\"vm.isFfcSupplierLock()\" \nclass=\"md-primary prm-vis-card-cb\" aria-label=\"Show Contract Number\"></md-checkbox></div><div class=\"prm-vis-card\" \nng-class=\"{\'prm-vis-card--readonly\': vm.isFfcOptionsLock()}\"><span class=\"prm-vis-card-icon\" aria-hidden=\"true\">\n<md-icon md-font-icon=\"icon-check-all\" class=\"s22 grey-600-fg\"></md-icon></span><div class=\"prm-vis-card-body\" flex>\n<div class=\"prm-vis-card-title\">Allow All Carriers</div><div class=\"prm-vis-card-desc grey-600-fg\">\n{{ vm.isSupplierPerspective() ? \'Bypass manual mapping and permit all carriers for this partner.\' : \'Bypass manual mapping and permit all carriers from this partner.\' }}\n</div></div><md-checkbox ng-model=\"vm.allowAllProxy\" ng-change=\"vm.setAllowAll(vm.allowAllProxy)\" \nng-disabled=\"vm.isFfcOptionsLock()\" class=\"md-primary prm-vis-card-cb\" aria-label=\"Allow All Carriers\"></md-checkbox>\n</div></div><div class=\"prm-carriers-section\" \nng-class=\"{\'prm-carriers-section--disabled\': vm.currentAllowAll() || vm.isFfcOptionsLock()}\"><div \nclass=\"prm-carriers-header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"prm-section-label prm-section-label--inline\">CARRIERS</span> <span \nclass=\"prm-carriers-badge\">{{ vm.serviceProviderBadgeCount() }}</span> <span class=\"prm-sp-info-wrap\" tabindex=\"0\" \naria-label=\"Carriers help\"><md-icon md-font-icon=\"icon-information-outline\" class=\"prm-sp-info s18 grey-600-fg\">\n</md-icon><span class=\"prm-sp-info-tooltip\" role=\"tooltip\">\nChoose which carriers apply for this mode. Search and multi-select in the list.</span></span></div><button \ntype=\"button\" class=\"prm-select-all-link\" ng-if=\"!vm.currentAllowAll()\" \nng-disabled=\"vm.isLoadingProviders || vm.isFfcOptionsLock()\" ng-click=\"vm.selectAllProvidersInSection($event)\">\nSelect All</button></div><div class=\"prm-provider-all-note grey-600-fg\" ng-if=\"vm.currentAllowAll()\">\nAll carriers are allowed for this mode.</div><md-select ng-if=\"!vm.currentAllowAll()\" multiple=\"multiple\" \nclass=\"prm-provider-md-select md-no-underline\" ng-model=\"vm.providerSelectionCodes\" \nng-model-options=\"{trackBy: \'$value\'}\" md-selected-html=\"vm.providerSelectedHtml()\" \nmd-on-open=\"vm.onProviderSelectOpen()\" md-on-close=\"vm.onProviderSelectClose()\" \nng-change=\"vm.syncProviderSelectionToDraft()\" ng-disabled=\"vm.isFfcOptionsLock()\" \nmd-container-class=\"prm-provider-select-panel\" aria-label=\"Select carriers\"><md-select-header \nclass=\"prm-provider-select-header\"><div class=\"prm-provider-header-inner\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"prm-provider-filter-bar\"><span class=\"prm-provider-filter-label\">Filter\n</span><div layout=\"row\" layout-align=\"end center\" class=\"prm-provider-filter-actions\"><button type=\"button\" \nclass=\"prm-provider-link-btn\" ng-click=\"vm.clearProvidersSelection($event)\">Clear</button> <button type=\"button\" \nclass=\"prm-provider-link-btn prm-provider-link-btn--pad\" ng-click=\"vm.selectAllFilteredProviders($event)\">Select all\n</button></div></div><div class=\"prm-provider-search-wrap\"><input type=\"search\" ng-model=\"vm.providerPanelSearch\" \nng-model-options=\"{ debounce: 250 }\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search name or code\" \nclass=\"prm-provider-search-input\" md-select-on-focus=\"\" aria-label=\"Filter carriers\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"prm-provider-search-icon fg-AAA8AD\"></md-icon></div><div \nclass=\"prm-provider-header-loading\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.isLoadingProviders\">\n<md-progress-circular md-diameter=\"24\"></md-progress-circular></div></div></md-select-header><md-option \nng-value=\"item.value\" ng-repeat=\"item in vm.filteredPanelProviders() track by item.value\"><span \nng-if=\"vm.modeTab !== \'air\'\" class=\"prm-provider-option-text\">{{ item.display }}</span> <span \nng-if=\"vm.modeTab === \'air\'\" class=\"prm-provider-option-text prm-air-carrier-option\"><span \nclass=\"prm-air-carrier-name\">{{ item.carrierName }}</span> <span \nng-if=\"item.carrierCode && item.carrierCode !== item.carrierName\" class=\"prm-air-carrier-code\">{{ item.carrierCode }}\n</span></span></md-option><div class=\"prm-provider-empty-msg\" \nng-if=\"!vm.isLoadingProviders && vm.providerOptions.length && !vm.filteredPanelProviders().length\">\nNo results match your search.</div><div class=\"prm-provider-empty-msg\" \nng-if=\"!vm.isLoadingProviders && !vm.providerOptions.length\">No carriers available for this mode.</div><div \nclass=\"prm-provider-panel-footer\" layout=\"row\" layout-align=\"end center\"><md-button md-no-ink type=\"button\" \nclass=\"prm-provider-done md-primary md-confirm-button m-0\" ng-click=\"vm.closeProviderSelect()\">Done</md-button></div>\n</md-select></div><div layout=\"row\" layout-align=\"end center\" class=\"prm-footer\"><md-button md-no-ink type=\"button\" \nclass=\"prm-discard-btn\" ng-disabled=\"!vm.isDraftDirty() || vm.isSaving\" ng-click=\"vm.discardChanges()\">Discard Changes\n</md-button><md-button md-no-ink type=\"button\" class=\"md-accent-btn with-icon prm-save-btn\" \nng-disabled=\"vm.isSaving || !vm.permission[2]\" ng-click=\"vm.save()\">Save Configuration<md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s18\"></md-icon></md-button></div></div><div flex flex-xs=\"100\" \nclass=\"pv-40 ph-20 prm-right-loading\" ng-if=\"!vm.selected && vm.isListLoading\" layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular>\n</div><div flex flex-xs=\"100\" class=\"pv-40 ph-20 grey-500-fg prm-empty-main\" ng-if=\"!vm.selected && !vm.isListLoading\">\nSelect a partner to edit settings.</div></div></div></div></div>");
$templateCache.put("app/main/pricingRules/pricing-rules.html","<div id=\"pricing-rules\"><iframe id=\"pricing-rule-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/profile/profile.html","<div id=\"setting-profile\"><md-content class=\"border brad-5 user_form\"><div \nclass=\"font-weight-600 create_text bb user_details b-width-2\"><md-icon md-font-icon=\"icon-account-circle\" \nclass=\"s32 mr-5\"></md-icon>Profile Details</div><form name=\"user_form\"><md-tabs md-border-bottom md-dynamic-height \nmd-selected=\"ctrl.parent.selectedIndex\"><md-tab label=\"General\"><div class=\"user_details\"><div layout=\"row\" \nclass=\"mb-40\" layout-xs=\"column\"><div flex layout=\"row\"><label class=\"font-weight-600\">User Role:</label><div \nclass=\"pl-10\">{{vm.user_data.role.name}}</div></div><div flex layout=\"row\"><label class=\"font-weight-600\">Company:\n</label><div class=\"pl-10\">{{vm.user_data.company.company_name}}</div></div></div><div layout=\"row\" layout-xs=\"column\">\n<div layout=\"column\" flex class=\"mr-20\"><label class=\"font-weight-600\">First Name<span class=\"error\">*</span></label>\n<md-input-container class=\"input_container\" md-no-float><input ng-model=\"vm.user_data.user_first_name\" \nng-change=\"vm.util.callMixpanel(\'MP-FirstName-Change\',{\'Value\' : vm.user_data.user_first_name})\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nname=\"user_first_name\" ng-maxlength=\"25\" placeholder=\"First Name\" required><div \nng-messages=\"user_form.user_first_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nFirst Name field is required.</span></div><div ng-message=\"maxlength\"><span>First Name must not exceed 25 characters.\n</span></div></div></md-input-container></div><div layout=\"column\" flex class=\"mr-20\"><label class=\"font-weight-600\">\nLast Name<span class=\"error\">*</span></label><md-input-container class=\"input_container\" md-no-float><input \nng-model=\"vm.user_data.user_last_name\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"vm.util.callMixpanel(\'MP-LastName-Change\', {\'Value\':vm.user_data.user_last_name})\" name=\"user_last_name\" \nng-maxlength=\"25\" placeholder=\"Last Name\" required><div ng-messages=\"user_form.user_last_name.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Last Name field is required.</span></div><div ng-message=\"maxlength\"><span>\nLast Name must not exceed 25 characters.</span></div></div></md-input-container></div></div><div layout=\"row\" \nlayout-xs=\"column\"><div layout=\"column\" flex class=\"mr-20\"><label class=\"font-weight-600\">Phone Number</label>\n<md-input-container class=\"input_container custom-w-50\" md-no-float><input class=\"tel-input\" type=\"tel\" \nng-model=\"vm.user_data.user_mobile\" placeholder=\"Phone Number\" name=\"user_mobile\" ng-maxlength=\"40\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"vm.util.callMixpanel(\'MP-PhoneNumber-Change\',{\'Value\':vm.user_data.user_mobile})\"><div \nng-messages=\"user_form.user_mobile.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container></div></div><div layout=\"row\" \nlayout-xs=\"column\" class=\"mb-20\" ng-if=\"!vm.util.isShipper\"><div layout=\"column\" flex class=\"mr-20 gap-10\"><label \nclass=\"font-weight-600\">Online Carrier Selection<md-icon md-font-icon=\"icon-information-outline\" class=\"s16 mb-2 ml-5\">\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">All Cleared :</span>\n Deselects all online carriers by default.</div><div class=\"mb-10\"><span class=\"font-bold\">All Selected : </span>\nSelects all online carriers by default.</div><div class=\"mb-10\"><span class=\"font-bold\">Keep Previous Selection :\n</span> Retains the carrier selection from the previous search.</div></md-tooltip></md-icon></label><div flex \nlayout=\"row\" layout-align=\"start center\"><md-radio-group ng-model=\"vm.user_data.use_recent_searches_on_search_ui\" \nng-change=\"vm.fnOnlineCarrierSelectionChange()\" aria-label=\"Yes\"><md-radio-button value=\"true\">All Cleared\n</md-radio-button><md-radio-button value=\"default\">All Selected</md-radio-button><md-radio-button value=\"false\">\nKeep Previous Selection</md-radio-button></md-radio-group></div></div></div><div layout=\"row\" class=\"mb-40\" \nlayout-xs=\"column\"><div class=\"mr-40\" layout=\"column\" flex=\"50\"><label class=\"font-weight-600 font-size-13 fg-333333\">\nUser Currency</label><div><div class=\"mt-10\"><currency-dropdown class=\"w-100-p\" full-border=\"true\" \nfield-value=\"vm.user_data.user_base_currency\" page-source=\"\'MP\'\"></currency-dropdown></div></div></div></div><div \nlayout=\"row\" flex=\"100\" class=\"row-spacing\" layout-wrap layout-xs=\"column\"><div><div layout=\"column\" flex \nclass=\"mr-20\"><div layout=\"column\" flex><label class=\"font-weight-600\">Number Format</label><span class=\"font-size-11\">\nSelect your number display format</span></div><md-input-container class=\"input_container\" md-no-float><md-select \nid=\"input_container_padding\" class=\"profile_border_inputs\" ng-model=\"vm.user_data.number_format\" \nng-change=\"vm.util.callMixpanel(\'MP-NumberFormat-Change\',{\'Value\':vm.number_formates[vm.user_data.number_format].number_mask})\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-option ng-value=\"optkey\" ng-repeat=\"(optkey,optvalue) in vm.number_formates\">{{optvalue.number_mask}}</md-option>\n</md-select></md-input-container></div></div><div><div layout=\"column\" flex class=\"mr-20\"><div layout=\"column\" flex>\n<label class=\"font-weight-600\">Measurement System</label><span class=\"font-size-11\">\nSelect your measurement unit display format</span></div><md-input-container class=\"input_container\" md-no-float>\n<md-select id=\"input_container_padding\" class=\"profile_border_inputs\" ng-model=\"vm.user_data.metric_system\" \nng-change=\"vm.util.callMixpanel(\'MP-Measurement-Change\',{\'Value\':vm.user_data.metric_system})\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-option id=\"profile_selectopt\" ng-value=\"opt\" ng-repeat=\"opt in vm.units\">{{opt}}</md-option></md-select>\n</md-input-container></div></div><div><div layout=\"column\" flex><div layout=\"column\" flex><label \nclass=\"font-weight-600\">Decimal Places</label><span class=\"font-size-11\">\nSelect the number of decimals for displaying and calculating rates</span></div><md-input-container \nclass=\"input_container\" md-no-float><md-select id=\"input_container_padding\" class=\"profile_border_inputs\" \nng-model=\"vm.user_data.precision_decimals\" \nng-change=\"vm.util.callMixpanel(\'MP-precision_decimals-Change\',{\'Value\':vm.user_data.precision_decimals})\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-option id=\"profile_selectopt\" ng-value=\"opt\" \nng-selected=\"vm.user_data.precision_decimals ? opt ==vm.user_data.precision_decimals : opt==2\" \nng-repeat=\"opt in vm.decimalPlaces\">{{opt}}</md-option></md-select></md-input-container></div></div></div><div \nlayout=\"column\" flex><label class=\"font-weight-600\">Email</label><div class=\"pt-15 pb-35\" ng-bind=\"vm.user_data.email\">\n</div></div><div ng-if=\"vm.user_data.type.user_category == \'FORWARDER\' && vm.user_data.solution_type == \'WLS\'\"><div \nlayout=\"row\" flex=\"100\"><div flex=\"80\" flex-sm=\"90\" class=\"pt-5 font-weight-600\">Use Business Email :<md-icon \nmd-font-icon=\"icon-question-mark-circle\" class=\"s16 mb-2\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg black-bg font-size-14\">Notification will be sent from this email Id</md-tooltip></md-icon><br><span \nclass=\"font-size-12 hide\">( From my email )</span></div><div layout=\"row\" flex><md-checkbox md-no-ink \nclass=\"mt-5 md-primary\" ng-model=\"vm.user_data.allow_personal_email\" \nng-change=\"vm.util.callMixpanel(\'MP-UseBusinessEmail-Click\',{\'Value\':vm.user_data.allow_personal_email})\" \naria-label=\"Checkbox 1\" ng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" ng-if=\"vm.user_data.allow_personal_email\"><label class=\"pt-20 pr-20 font-weight-600\">\nPersonal email id<span class=\"error\">*</span>:</label><div layout=\"row\" flex><md-input-container \nclass=\"input_container md-block\" md-no-float flex><input ng-model=\"vm.user_data.personal_email_id\" \nname=\"personal_email_id\" placeholder=\"Personal email id\" ng-pattern=\"vm.util.commonEmailRegex\" required \nng-change=\"vm.util.callMixpanel(\'MP-PersonalEmailId-Change\',{\'Value\':vm.user_data.personal_email_id})\"><div \nng-messages=\"user_form.personal_email_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email id is required.\n</span></div><div ng-message=\"pattern\"><span>Only {{vm.user_data.mailgun_domain}} domain email allowed.</span></div>\n</div></md-input-container><span class=\"pt-25 ph-15\" flex=\"50\">@{{vm.user_data.mailgun_domain}}</span></div></div><div \nlayout=\"row\" flex=\"100\"><div flex=\"80\" flex-sm=\"90\" class=\"pt-5 font-weight-600\">Send CC :</div><div layout=\"row\" flex>\n<md-checkbox md-no-ink class=\"mt-5 md-primary\" ng-model=\"vm.user_data.send_cc\" aria-label=\"Checkbox 1\" \nng-change=\"vm.util.callMixpanel(\'MP-SendCC-Click\',{\'Value\':vm.user_data.send_cc})\" ng-true-value=\"1\" \nng-false-value=\"0\"></md-checkbox></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nng-if=\"vm.user_data.send_cc\"><label class=\"pt-20 pr-20 font-weight-600\">CC Email<span class=\"error\">*</span> :</label>\n<md-input-container class=\"input_container md-block\" md-no-float flex=\"80\"><md-chips class=\"email-chip\" \nng-model=\"vm.user_data.cc_email\" name=\"cc_email\" placeholder=\"Write email then Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"vm.validateEmail(vm.user_data.cc_email, $chip)\" md-add-on-blur=\"true\" ng-required=\"true\"><md-chip-template>\n<strong>{{$chip}}</strong></md-chip-template></md-chips><div class=\"errors\" ng-messages=\"user_form.cc_email.$error\" \nrole=\"alert\"><div class=\"profile-invalidErrorMsg\" hide>Invalid email address!! We removed it.</div><div \nclass=\"profile-duplicateErrorMsg\" hide>Duplicate email address!! We removed it.</div></div></md-input-container></div>\n<div layout=\"row\" flex=\"100\"><div flex=\"80\" id=\"boom\" flex-sm=\"90\" class=\"pt-5 font-weight-600\">\nEmail signature required :</div><div layout=\"row\" flex><md-checkbox md-no-ink class=\"mt-5 md-primary\" \nng-model=\"vm.user_data.email_signature_required\" \nng-change=\"vm.util.callMixpanel(\'MP-EmailSignatureRequired-Click\',{\'Value\':vm.user_data.email_signature_required})\" \naria-label=\"Checkbox 1\" ng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox></div></div><div layout=\"column\" flex=\"100\" \nng-if=\"vm.user_data.email_signature_required\"><label id=\"boom\" class=\"pv-10 pr-20 font-weight-600\">Email signature<span\n class=\"error\">*</span> :<md-icon md-font-icon=\"icon-question-mark-circle\" class=\"s18\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg black-bg font-size-14\">You can copy your signature from anywhere or create one.</md-tooltip></md-icon>\n</label><textarea ng-change=\"vm.util.callMixpanel(\'MP-EmailSignature-Change\',{\'Value\':vm.user_data.email_signature})\" \nng-model=\"vm.user_data.email_signature\" id=\"editor1\" ckeditor></textarea></div></div><div \nclass=\"md-link-fg pointer mb-10 pt-15\"><span ng-click=\"vm.openChangePasswordModal($event)\">Change Your Password</span>\n</div></div></md-tab><md-tab label=\"Integration Details\" ng-if=\"vm.tms_enabled\"><div class=\"user_details\"><div \nlayout=\"column\" layout-xs=\"column\" layout-wrap ng-if=\"vm.tms_enabled\"><div layout=\"row\" flex=\"100\" class=\"mr-10\"><label\n flex=\"30\" class=\"font-weight-600 mt-10 mr-30\">TMS Branch</label><div flex=\"60\" class=\"profile-tms-suggest\">\n<md-input-container class=\"mt-0\" md-no-float><input ng-model=\"vm.user_data.branch_id\" \nng-change=\"vm.onTmsFieldInput(\'branch\')\" ng-keyup=\"vm.openTmsSuggestions(\'branch\')\" \nng-focus=\"vm.openTmsSuggestions(\'branch\')\" ng-blur=\"vm.closeTmsSuggestions(\'branch\')\" name=\"branch_id\" \nng-maxlength=\"256\" placeholder=\"TMS Branch\" autocomplete=\"off\"></md-input-container><ul \nclass=\"profile-tms-suggest-menu\" ng-show=\"vm.tmsSuggest.open === \'branch\'\" ng-mousedown=\"$event.preventDefault()\"><li \nng-repeat=\"opt in vm.tmsSuggest.filtered track by opt\" ng-mousedown=\"vm.selectTmsSuggestion(\'branch\', opt)\">{{opt}}\n</li><li class=\"profile-tms-suggest-empty\" ng-if=\"!vm.tmsSuggest.filtered.length\">No results found</li></ul></div>\n</div><div layout=\"row\" flex=\"100\" class=\"mr-10\"><label flex=\"30\" class=\"font-weight-600 mt-10 mr-30\">TMS Department\n</label><div flex=\"60\" class=\"profile-tms-suggest\"><md-input-container class=\"mt-0\" md-no-float><input \nng-model=\"vm.user_data.department\" ng-change=\"vm.onTmsFieldInput(\'department\')\" \nng-keyup=\"vm.openTmsSuggestions(\'department\')\" ng-focus=\"vm.openTmsSuggestions(\'department\')\" \nng-blur=\"vm.closeTmsSuggestions(\'department\')\" name=\"department\" ng-maxlength=\"256\" placeholder=\"TMS Department\" \nautocomplete=\"off\"></md-input-container><ul class=\"profile-tms-suggest-menu\" \nng-show=\"vm.tmsSuggest.open === \'department\'\" ng-mousedown=\"$event.preventDefault()\"><li \nng-repeat=\"opt in vm.tmsSuggest.filtered track by opt\" ng-mousedown=\"vm.selectTmsSuggestion(\'department\', opt)\">{{opt}}\n</li><li class=\"profile-tms-suggest-empty\" ng-if=\"!vm.tmsSuggest.filtered.length\">No results found</li></ul></div>\n</div><div layout=\"row\" flex=\"100\" class=\"mr-10\"><label flex=\"30\" class=\"font-weight-600 mt-10 mr-30\">TMS Company\n</label><div flex=\"60\" class=\"profile-tms-suggest\"><md-input-container class=\"mt-0\" md-no-float><input \nng-model=\"vm.user_data.tms_company\" ng-change=\"vm.onTmsFieldInput(\'company\')\" \nng-keyup=\"vm.openTmsSuggestions(\'company\')\" ng-focus=\"vm.openTmsSuggestions(\'company\')\" \nng-blur=\"vm.closeTmsSuggestions(\'company\')\" name=\"tms_company\" ng-maxlength=\"256\" placeholder=\"TMS Company\" \nautocomplete=\"off\"></md-input-container><ul class=\"profile-tms-suggest-menu\" \nng-show=\"vm.tmsSuggest.open === \'company\'\" ng-mousedown=\"$event.preventDefault()\"><li \nng-repeat=\"opt in vm.tmsSuggest.filtered track by opt\" ng-mousedown=\"vm.selectTmsSuggestion(\'company\', opt)\">{{opt}}\n</li><li class=\"profile-tms-suggest-empty\" ng-if=\"!vm.tmsSuggest.filtered.length\">No results found</li></ul></div>\n</div><div layout=\"row\" flex=\"100\" class=\"mr-10\"><div layout=\"row\" flex=\"30\" class=\"mt-10 mr-30\"><label \nclass=\"font-weight-600\">TMS User Reference Code<md-icon id=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" \nclass=\"mr-5\"><md-tooltip md-autohide=\"true\" md-direction=\"top\">Reference number of the customer in Source system\n</md-tooltip></md-icon></label></div><md-input-container flex=\"60\" class=\"mt-0\" md-no-float><input \nng-model=\"vm.user_data.reference_id\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"vm.util.callMixpanel(\'MP-Referenceid-Change\', {\'Value\':vm.user_data.reference_id})\" name=\"reference_id\" \nng-maxlength=\"256\" placeholder=\"TMS Reference Id\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nclass=\"mr-10\"><div layout=\"row\" flex=\"30\" class=\"mt-10 mr-30\"><label class=\"font-weight-600\">TMS Owner<md-icon \nid=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" class=\"mr-5\"><md-tooltip md-autohide=\"true\" \nmd-direction=\"top\">Owner Company Code of the data in Source system</md-tooltip></md-icon></label></div>\n<md-input-container flex=\"60\" class=\"mt-0\" md-no-float><input ng-model=\"vm.user_data.tms_owner\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"vm.util.callMixpanel(\'MP-TMSOwner-Change\', {\'Value\':vm.user_data.tms_owner})\" name=\"tms_owner\" \nng-maxlength=\"256\" placeholder=\"TMS Owner Code\"></md-input-container></div></div></div></md-tab></md-tabs><div \nlayout=\"row\" class=\"pb-15 bt user_details b-width-2\" layout-xs=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"vm.user_data.is_sales_cordinator || vm.user_data.is_pricing_user\"><div \nclass=\"font-weight-600\">Marked As</div><div><span ng-if=\"vm.user_data.is_sales_cordinator\">Sales Co-ordinator <span \nng-if=\"vm.user_data.is_pricing_user\">,</span></span> <span ng-if=\"vm.user_data.is_pricing_user\">Pricing Team</span>\n</div></div></div><md-button md-no-ink class=\"md-accent-btn\" ng-click=\"vm.submit_user(vm.user_data)\" \nng-disabled=\"user_form.$invalid\">Update</md-button></div></form></md-content></div>");
$templateCache.put("app/main/quotes/quotes.html","<div><md-sidenav ng-if=\"vm.QuotesService.filterParams.deviceName != \'laptop\'\" \nclass=\"md-sidenav-right sidenav-bg no-scroll\" md-component-id=\"quoteRight\" ms-sidenav-helper><quote-filter \ncallback=\"vm.submitFilter()\" filterobj=\"vm.filterObject.data\" quote-data=\"vm.quoteParam\" \nis-load-component=\"vm.isLoadFilterComponent\"></quote-filter></md-sidenav><div id=\"quotes-page-new\" \nng-style=\"vm.maxHeight\" when-scrolled=\"vm.loadMoreRecords(vm.quoteData.quotesList.length)\"><div class=\"layout-styles\">\n<div class=\"pv-20 quote-sticky-div\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" flex-gt-xs=\"100\"><div>\n<div class=\"header_and_subheader\" layout=\"column\" layout-align=\"space-between\" layout-wrap=\"wrap\"><span \nclass=\"page_title\">Quotes</span> <span>Manage all your quotes</span></div></div><div layout=\"row\" \nlayout-align=\"space-between\" layout-wrap=\"wrap\"><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"search-container-div\" layout=\"row\"><input class=\"h-35 p-5 border-none fg-333333 input-searchbar\" \nng-model=\"quoteSearch\" placeholder=\"Enter Quote ID\" ng-keypress=\"vm.fnSearchQuote(quoteSearch,$event)\" flex> <span \nlayout=\"row\" layout-align=\"end center\" class=\"md-accent-btn with-icon ph-5 pointer br-3\" \nng-click=\"vm.fnSearchQuote(quoteSearch,$event)\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-fg search-icon\">\n</md-icon></span></div></div><div ng-click=\"vm.toggleSideNav(\'quoteRight\')\" \nng-if=\"vm.QuotesService.filterParams.deviceName != \'laptop\'\" class=\"mobile-filter\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 mobile-filter-icon\"></md-icon></div></div></div><div \nlayout=\"row\"><div ng-if=\"vm.QuotesService.filterParams.deviceName == \'laptop\'\" class=\"w-230\"><div \nclass=\"filter-container\" ng-style=\"vm.leftFilterTopMargin\"><md-sidenav class=\"sidenav-bg no-scroll mr-10\" \nmd-is-locked-open=\"vm.QuotesService.filterParams.deviceName == \'laptop\'\" ms-sidenav-helper><quote-filter \ncallback=\"vm.submitFilter()\" filterobj=\"vm.filterObject.data\" is-load-component=\"vm.isLoadFilterComponent\" \nquote-data=\"vm.quoteParam\"></quote-filter></md-sidenav></div></div><div flex><div layout=\"row\" \nlayout-align=\"space-between\" class=\"quote-count-sort-div\"><div ng-if=\"!vm.isStatusLoading\" class=\"list_count\">\n{{vm.quoteData.quotesCount}} Results Found</div><div layout-align=\"end center\"><div \nng-show=\"vm.quoteData.quotesCount !== 0\" class=\"pt-10 pointer\" layout-align=\"end center\" \nng-click=\"vm.fnCutOffDateSortBy(vm.filterObject.data.sort_by_type)\"><md-icon \nng-if=\"vm.filterObject.data.sort_by_type == \'ASC\'\" md-svg-src=\"assets/icons/custom/desc.svg\" \nclass=\"w-15 h-15 filter-icon\"></md-icon><md-icon ng-if=\"vm.filterObject.data.sort_by_type == \'DESC\'\" \nmd-svg-src=\"assets/icons/custom/asc.svg\" class=\"w-15 h-15 filter-icon\"></md-icon></div><md-tooltip md-direction=\"top\" \nclass=\"font-size-13\">Sort by: Created On</md-tooltip></div></div><div layout=\"row\" layout-align=\"center center\" \nlayout-wrap class=\"h-100-p empty-state m-0\" ng-show=\"vm.quoteData.quotesCount === 0 && !vm.listLoader\"><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\"><div class=\"font-size-18\"><md-icon \nmd-svg-icon=\"assets/icons/custom/empty_quotes.svg\" class=\"w-300 h-150\"></md-icon><div class=\"font-size-20 text-center\">\nNo Quotes Found</div></div></div></div><md-content id=\"activeQuotes\" class=\"pb-5\" ng-if=\"vm.showQuoteInList\"><div \nclass=\"shipment-card pointer mb-10\" layout=\"row\" \nng-repeat=\"shipment in vm.quoteData.quotesList as filteredActiveQuotes track by $index\" flex=\"100\" layout-xs=\"column\" \nng-click=\"vm.viewQuoteDetails(shipment.search_param,shipment._id,\'card\',$event);$event.stopPropagation()\"><div \nclass=\"status-sect\" layout-align=\"center center\" layout-gt-xs=\"row\" layout-align-xs=\"start start\"><div layout=\"column\" \nlayout-align=\"center center\" layout-xs=\"row\" layout-align-xs=\"space-between\"><span>\n{{shipment.quote_id ? shipment.quote_id : \'N/A\'}}</span><div class=\"template-div mt-5\" \nng-if=\"shipment.template_data && vm.util.navPermission.quotes && vm.util.navPermission.quotes[2] && !vm.util.isShipper\">\n<span class=\"template-name\" title=\"{{shipment.template_data.name}}\">{{ shipment.template_data.name}}</span></div></div>\n</div><div flex layout=\"column\"><div layout=\"row\" layout-align=\"space-between\"><port-traveller-ui \ndetails=\"shipment.search_param\" class=\"ph-16 pt-10\" style=\"width: 100%\"></port-traveller-ui><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"!vm.util.isShipper\" class=\"ph-5 status_btns\"><md-button \nclass=\"md-primary-btn with-icon w-40 icon-width\" \nng-if=\"vm.util.navPermission.quotes && vm.util.navPermission.quotes[0]\" \nng-click=\"vm.viewCopyQuoteDetails(shipment._id,$event);$event.stopPropagation()\"><md-icon class=\"icon-width\" \nmd-svg-icon=\"assets/icons/custom/copyQuote.svg\"></md-icon><md-tooltip md-direction=\"top\" class=\"font-size-12\">\nCopy Quote</md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"space-between\" layout-wrap class=\"bt\">\n<div layout=\"row\" layout-wrap layout-padding class=\"pv-5 flex-100\"><div layout=\"column\"><span class=\"title\">Mode</span>\n <span class=\"value text-truncate\" title=\"{{shipment.search_param.mode}}\">{{shipment.search_param.mode}}</span></div>\n<div layout=\"column\"><span class=\"title\">Load Details</span> <span class=\"value text-truncate\" \nng-if=\"shipment.search_param.mode==\'SEA-FCL\'\">\n{{ vm.formContainerType(shipment.search_param.mode, shipment.search_param.load_data, \'listPage\') }}<md-tooltip \nmd-direction=\"bottom\" class=\"font-size-12\">\n{{ vm.formContainerType(shipment.search_param.mode, shipment.search_param.load_data) }}</md-tooltip></span><span \nclass=\"value text-truncate\" ng-if=\"shipment.search_param.mode!=\'SEA-FCL\'\"><span \nng-if=\"shipment.search_param.load_data.load_meta.chargeable_weight\">\n{{ shipment.search_param.load_data.load_meta.chargeable_weight | currencyMask }} {{vm.util.chargeableUnit[shipment.search_param.mode]}}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-12\">\n{{ shipment.search_param.load_data.load_meta.chargeable_weight | currencyMask }} {{vm.util.chargeableUnit[shipment.search_param.mode]}}\n</md-tooltip></span><span ng-if=\"!shipment.search_param.load_data.load_meta.chargeable_weight\">-</span></span></div>\n<div layout=\"column\"><span class=\"title\">Cut Off Date</span> <span class=\"value text-truncate\" \ntitle=\"{{ shipment.search_param.cargo_ready_date | NoTimeZone : \'d MMM yyyy\' }}\">\n{{ shipment.search_param.cargo_ready_date | NoTimeZone : \'d MMM yyyy\' }}</span></div><div layout=\"column\"><span \nclass=\"title\">Created On</span> <span class=\"value text-truncate\" \ntitle=\"{{ shipment.created_on | UTCToLocal : \'d MMM yyyy\' }}\">{{ shipment.created_on | UTCToLocal : \'d MMM yyyy\' }}\n</span></div><div layout=\"column\"><span class=\"title\">Created By</span> <span class=\"value text-truncate\" \ntitle=\"{{shipment.created_by.user_first_name}} {{shipment.created_by.user_last_name}}\">\n{{shipment.created_by.user_first_name}} {{shipment.created_by.user_last_name}}</span></div><div layout=\"column\"><span \nclass=\"title\">Incoterms</span> <span class=\"value text-truncate\"><div layout=\"row\" \ntitle=\"{{shipment.incoterms}} {{shipment.impo_expo}}\"><div ng-bind=\"shipment.incoterms ? shipment.incoterms : \'N/A\'\">\n</div><div ng-if=\"shipment.impo_expo && shipment.incoterms\">- {{shipment.impo_expo}}</div></div></span></div><div \nlayout=\"column\" ng-if=\"shipment.created_for\"><span class=\"title\">Customer</span> <span class=\"value text-truncate\" \ntitle=\"{{shipment.created_for.user_first_name}} {{shipment.created_for.user_last_name}} {{shipment.created_for.company.company_name ? shipment.created_for.company.company_name : \'N/A\'}}\">\n{{shipment.created_for.user_first_name}} {{shipment.created_for.user_last_name}} <span class=\"font-size-11\">\n{{shipment.created_for.company.company_name ? shipment.created_for.company.company_name : \'N/A\'}}</span></span></div>\n<div layout=\"column\" ng-if=\"shipment.created_for && shipment.created_for.company.external_reference_id\"><span \nclass=\"title\">External Reference</span> <span class=\"value text-truncate\" \ntitle=\"{{shipment.created_for.company.external_reference_id}}\">{{shipment.created_for.company.external_reference_id}}\n</span></div><div layout=\"row\" layout-align=\"end center\" class=\"ph-5 status_btns\"><div layout=\"row\" \nclass=\"shipment-status border-staus mr-5\" ng-if=\"shipment.tms_status && !vm.util.isShipper\" \ntitle=\"{{shipment.tms_status}}\"><span class=\"pb-8 pr-5\">{{shipment.tms_status}}</span></div><div layout=\"row\" \nclass=\"shipment-status quote-{{shipment.quote_id}}\" title=\"{{shipment.current_status.status}}\" \nng-style=\"vm.util.fnSetStatusColor(vm.util.colorCodeObj[shipment.current_status.status])\" \nng-click=\"vm.fnOpenStatusChangePanel($event , shipment)\"><span class=\"pb-8 pr-5\">{{shipment.current_status.status}}\n</span><md-icon ng-if=\"shipment.available_status.length > 0 && !vm.util.isShipper\" md-font-icon=\"icon-chevron-down\" \nng-style=\"vm.util.fnSetStatusColor(vm.util.colorCodeObj[shipment.current_status.status] , \'icon\')\" \nclass=\"down-arrow-icon icon-height-11\"></md-icon><md-tooltip \nng-if=\"shipment.available_status.length > 0 && !vm.util.isShipper\" md-direction=\"top\">Change Status Here</md-tooltip>\n</div></div></div></div></div></div><div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" \nng-if=\"vm.listLoader\" class=\"mv-20 pt-10\"><md-progress-circular></md-progress-circular></div></md-content></div></div>\n</div><div class=\"layout-styles\"><button \nclass=\"md-fab md-fab-bottom-right md-button white-bg scrollTopBtn hide pointer\" type=\"button\" \nng-click=\"vm.scrollTop(\'goto\')\" id=\"quote-return-to-top\"><md-icon md-font-icon=\"icon-arrow-up\" role=\"img\" \nclass=\"s25 fg-AAA8AD\"></md-icon><md-tooltip md-direction=\"top\">Go to Top</md-tooltip></button></div></div></div>");
$templateCache.put("app/main/quote-list/quote-list.html","<div class=\"quote-list\"><iframe resize-handler id=\"quote-list-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/result/ftlResult.html","<div id=\"ftl-result\"><iframe id=\"ftl-result-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/result/result.html","<md-sidenav class=\"md-sidenav-right md-white-bg\" md-component-id=\"right\" ms-sidenav-helper><filter-panel \nlistoffilterobj=\"vm.listOfFilterObj\" selectedfilterobj=\"vm.selected_filter_obj\" side=\"\'right\'\" \nmode=\"vm.search_param.mode\" callback=\"vm.fnApplyCardFilter(selectedFilterObj)\" \nshowshimmer=\"vm.resultCardFilter.countApiCard\"></filter-panel></md-sidenav><div id=\"result-page\" class=\"Font-Regular\">\n<div class=\"search_meta pointer-event-none\"><div \nclass=\"white-bg box-style search_meta pointer-event-all tranpost-border search-edit-div\"><search-bar \nsearch-param-input=\"vm.initial_search_param\" search-from-quote=\"vm.searchFromQuote\" \nresultcardfilter=\"vm.resultCardFilter\" callback=\"vm.submitSearch(payload)\" mode=\"{{vm.initial_search_param.mode}}\">\n</search-bar></div><span ng-hide=\"!vm.resultCardFilter.countApiCard\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.apiProgressValue*10}}\" ng-if=\"vm.showApiLoader\"></md-progress-linear></span></div><div \nclass=\"layout-styles pos-footer\" ng-if=\"!vm.resultCardFilter.isSearchUpdate\"><div layout=\"row\" \nlayout-align=\"space-between end\" layout-wrap class=\"mv-20 result_count_bar\" ng-style=\"vm.countMarginTop\"><div \nlayout=\"column\" layout-align=\"center start\" layout-sm=\"column\" layout-align-sm=\"start start\" layout-wrap class=\"pl-10\">\n<div layout=\"row\" class=\"page_title\" ng-if=\"!vm.searchFromQuote\">Instant Rates</div><div \nclass=\"font-bold font-size-22 pointer\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.searchFromQuote\" \nng-click=\"vm.redirectToQuote()\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-5 mt-5 pointer black-fg\"></md-icon>\n<span ng-if=\"vm.searchFromQuote\">{{vm.search_param.quote_number}}</span> <span \nng-if=\"vm.search_param.source==\'copy_quote\'\">Copy Quote</span> <span ng-if=\"vm.search_param.source==\'create_quote\'\">\nCreate Quote</span></div><div layout=\"row\" class=\"page_subtitle\"><span ng-show=\"!vm.resultCardFilter.countApiCard\">\n{{vm.cardsCount == 0 ? \'No\' : vm.cardsCount}} Results Found </span><span ng-show=\"vm.resultCardFilter.countApiCard\" \nshimmer-effect-full width=\"50px\" height=\"15px\" class=\"inline-block mr-10 mt-8\"></span></div></div><div layout=\"row\" \nflex layout-align=\"end center\" layout-wrap><div \nng-if=\"!vm.util.isShipper && vm.viewMode === \'enterprise\' && !vm.searchFromQuote \" class=\"ratefilter\"><md-select \nng-model=\"vm.selected_filter_obj.selected_rateType\" ng-change=\"vm.getSelectedText()\"><md-option \nng-repeat=\"item in vm.listOfFilterObj.ratesType\" ng-value=\"item.value\">{{item.label}}</md-option></md-select></div><div\n ng-if=\"!vm.util.isShipper && vm.viewMode === \'enterprise\' && !vm.searchFromQuote \" class=\"ratefilter pl-10\"><md-select\n ng-model=\"vm.hideRates\" ng-change=\"vm.emptyRatesFilter()\"><md-option ng-repeat=\"item in vm.hideRatesOptions\" \nng-value=\"item.value\">{{item.label}}</md-option></md-select></div><div \nng-if=\"vm.FreightIndex && vm.search_param.mode !== \'SEA-FCL\'\"><md-button \nclass=\"md-primary-btn Font-Bold mb-0 freight-index-button\" ng-click=\"vm.fnOpenFreightIndex($event)\" \nng-disabled=\"vm.resultCardFilter.countApiCard || vm.resultCardFilter.generateQuoteBtn\"><div><svg \nxmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 19 19\" fill=\"currenctColor\"><path \nd=\"M0.703125 18.5956V16.5938L2.70312 14.592V18.5956H0.703125ZM4.70312 18.5956V12.5902L6.70312 10.5884V18.5956H4.70312ZM8.70312 18.5956V10.5884L10.7031 12.6152V18.5956H8.70312ZM12.7031 18.5956V12.6152L14.7031 10.6134V18.5956H12.7031ZM16.7031 18.5956V8.58664L18.7031 6.58485V18.5956H16.7031ZM0.703125 13.4159V10.5884L7.70312 3.58217L11.7031 7.58574L18.7031 0.579498V3.40702L11.7031 10.4133L7.70312 6.4097L0.703125 13.4159Z\" \nfill=\"currentColor\"/></svg></div>Freight Index</md-button></div><div \nng-if=\"vm.search_param.freight_charges && vm.resultCardFilter.deviceName != \'mobile\' && !vm.util.isShipper && (!vm.initial_search_param.pickup_selected && !vm.initial_search_param.delivery_selected) && vm.viewMode !== \'enterprise\' && !vm.searchFromQuote  && !vm.search_param.historical_search\">\n<md-button md-no-ink class=\"md-primary-btn Font-Bold w-110 mb-0\" ng-click=\"vm.newCardModal($event);\">+ Add New Rate\n</md-button></div><div \nng-if=\"vm.resultCardFilter.deviceName != \'mobile\' && !vm.util.isShipper && vm.viewDirectFilter && !vm.searchFromQuote  && !vm.search_param.historical_search && vm.util.navPermission.inquiry[0]\">\n<md-button md-no-ink class=\"md-primary-btn Font-Bold w-140 mb-0\" ng-click=\"vm.checkToUpdate($event,\'betterRates\')\" \nng-disabled=\"vm.resultCardFilter.countApiCard || vm.resultCardFilter.generateQuoteBtn\">Request Better Rates</md-button>\n</div><div \nng-if=\"vm.resultCardFilter.deviceName != \'mobile\' && vm.util.isShipper && vm.viewDirectFilter && !vm.ShipperMaskLiner && !vm.searchFromQuote && vm.util.navPermission.inquiry[0]\">\n<md-button md-no-ink class=\"md-primary-btn Font-Bold w-100 mb-0\" ng-click=\"vm.fnOpenMatchRatesModal($event)\" \nng-disabled=\"vm.resultCardFilter.countApiCard || vm.resultCardFilter.generateQuoteBtn\">Match Rates</md-button></div>\n<div class=\"pl-10 max-width-130\" ng-if=\"vm.viewMode === \'card\'\" ng-class=\"{\'pr-20\' : vm.searchFromQuote}\"><div \nclass=\"font-weight-600 font-size-9 grey-fg\" style=\"margin-bottom: -4px\">Sort by</div><md-input-container \nclass=\"filer_input m-0 p-0 nwls-filter\" md-no-float><md-select name=\"type\" ng-model=\"vm.sortBy\" placeholder=\"Select\" \nng-disabled=\"vm.resultCardFilter.countApiCard\" class=\"fg-333333 sort-dropdwn font-weight-600 font-size-13\" \nng-model-options=\"{ debounce: 500 }\" md-on-open=\"vm.trackAnalytics(\'sortOpen\', vm.sortBy);\"><md-option \nng-value=\"item.value\" ng-repeat=\"(index,item) in vm.sortByList\" ng-selected=\"index == vm.sortBySelcted\" \nng-click=\"vm.trackAnalytics(\'sortChange\', item.name);\"><span translate=\"{{item.name}}\"></span></md-option></md-select>\n</md-input-container></div><div \nng-if=\"$root.domainData.domain_info.ENABLE_ENTERPRISE_VIEW_FOR_RESULT && vm.viewMode == \'enterprise\' && !vm.util.isShipper && vm.resultCardArray.length && !vm.resultCardFilter.countApiCard && !vm.searchFromQuote\" \nng-class=\"{\'mb-15\' : vm.util.isMobileDevice}\" layout-xs=\"row\" layout-align-xs=\"end end\"><div \nclass=\"tableColumnController\"><span class=\"datatable-column-hide-count md-component-bg white-fg\">\n{{vm.visibleColumnList.columnsList.length - vm.visibleColumnList.columnsHide}}</span><md-menu \nmd-position-mode=\"left bottom\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-primary-btn with-icon Font-Bold mb-0 pt-2\"><span class=\"pt-2\">Column Customise</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon></md-button><md-menu-content width=\"3\" class=\"rate-filter-column-visiblity\">\n<div class=\"sticky-header\"><p ng-click=\"vm.selectAllColumn();\" md-prevent-menu-close=\"md-prevent-menu-close\" \nclass=\"pr-20 blue-600-fg font-size-11 cursor\">Select All</p></div><md-menu-item \nng-repeat=\"column in vm.visibleColumnList.columnsList track by $index\"><div \nmd-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"column.isActive = !column.isActive;vm.resultService.triggerDatatableButton(\'.buttons-columnVisibility\', column); vm.visibleColumnList.columnsHide = !column.isActive ? vm.visibleColumnList.columnsHide + 1:vm.visibleColumnList.columnsHide - 1;\">\n<div layout=\"column\"><md-checkbox md-no-ink ng-checked=\"column.isActive\">{{column.column}}</md-checkbox></div></div>\n</md-menu-item></md-menu-content></md-menu></div><md-button md-no-ink class=\"md-primary-btn Font-Bold w-72 mb-0\" \nng-disabled=\"!vm.cardsCount\" ng-click=\"vm.exportExcelEl(\'.buttons-excel\');vm.trackEvent(\'Instant-EnpLayout-Export\');\">\nExport</md-button><md-button md-no-ink class=\"md-primary-btn with-icon w-36 Font-Bold mb-0 p-0\" \nng-click=\"vm.expandEnterpriseTable(true);\"><md-icon ng-if=\"!vm.isExpandElTable\" class=\"s36 pointer lh-32\" \nmd-font-icon=\"icon-fullscreen\"></md-icon><md-icon ng-if=\"vm.isExpandElTable\" class=\"s36 pointer lh-32\" \nmd-font-icon=\"icon-fullscreen-exit\"></md-icon><md-tooltip md-direction=\"top\">\n{{ !vm.isExpandElTable ? \'Expand\' : \'Shorten\' }}</md-tooltip></md-button><md-button md-no-ink \nclass=\"md-primary-btn Font-Bold w-83 mb-0\" \nng-click=\"vm.resultService.triggerDatatableButton(\'.resetFilter\', null);vm.selected_filter_obj.selected_rateType = \'All\';vm.hideRates=\'showEmptyCards\'\">\nReset Filter</md-button></div><div class=\"ml-10 mt-5 mr-10\" \nng-if=\"$root.domainData.domain_info.ENABLE_ENTERPRISE_VIEW_FOR_RESULT && !vm.util.isShipper && vm.search_param.mode === \'SEA-FCL\' && vm.resultCardArray.length && !vm.searchFromQuote && !vm.search_param.historical_search\">\n<span ng-show=\"vm.resultCardFilter.countApiCard\" shimmer-effect-full width=\"50px\" height=\"15px\" \nclass=\"inline-block mr-10 mt-8\"></span><div class=\"group-button\" ng-if=\"!vm.resultCardFilter.countApiCard\"><md-icon \nclass=\"tab-icon-button\" ng-class=\"{\'tab-active\': vm.viewMode == \'card\'}\" \nng-click=\"vm.fnDialogSwitchToRateCard(\'card\');\" md-font-icon=\"icon-format-list-bulleted\"></md-icon><md-icon \nclass=\"tab-icon-button\" ng-class=\"{\'tab-active\': vm.viewMode == \'enterprise\'}\" \nng-click=\"vm.fnDialogSwitchToRateCard(\'enterprise\');\" md-font-icon=\"icon-table-large\"></md-icon></div></div><div \nlayout-align=\"end center\" class=\"grey-fg font-size-14 font-weight-600 pointer ph-10\" \nng-if=\"vm.viewDirectFilter && vm.resultCardFilter.deviceName != \'laptop\' && !vm.resultCardFilter.countApiCard\" \nng-click=\"vm.showFilterBottomSheet();vm.trackEvent(\'RR-FilterToggle-Click\')\"><div ng-show=\"vm.selectedFilterCount > 0\" \nclass=\"filterCount\">{{vm.selectedFilterCount}}</div><div class=\"filter-div\"><md-icon \nmd-svg-src=\"assets/icons/custom/tune-24px.svg\" class=\"s18 md-primary-fg pointer\"></md-icon></div></div></div></div><div\n layout=\"column\" \nng-if=\"vm.viewMode === \'enterprise\' && $root.domainData.domain_info.ENABLE_ENTERPRISE_VIEW_FOR_RESULT && vm.resultCardArray.length && !vm.resultCardFilter.countApiCard\" \nlayout-xs=\"column\" layout=\"100\"><rate-card-table dtinstance=\"vm.dtInstanceCallback\" \nlistoffilterobj=\"vm.listOfFilterObj\" mode=\"vm.search_param.mode\" resultcardfilter=\"vm.resultCardFilter\" \nresultfilter=\"$ctrl.resultfilter\" columnsvisible=\"vm.visibleColumnList\" resultcardarray=\"vm.resultCardArray\" \ncallback=\"vm.fnRateCardTable(payload)\" cardscount=\"vm.cardsCount\" tabledisplaymode=\"vm.tableDisplayMode\" \nsort-by=\"vm.sortBy\" filterenterprisetable=\"vm.filterEnterpriseTable\" searchparam=\"vm.search_param\"></rate-card-table>\n</div><div layout=\"row\" class=\"rate-card-container\" ng-show=\"vm.viewMode === \'card\'\" layout-xs=\"column\" layout=\"100\">\n<div layout=\"row\" layout-wrap layout-align=\"start start\" class=\"z-index-2\" \nng-if=\"vm.resultCardFilter.deviceName == \'laptop\'\"><div class=\"filter-container\" ng-style=\"vm.leftFilterTopMargin\"><div\n class=\"hidden-div\">Rates loading</div><md-sidenav class=\"md-sidenav-right sidenav-bg result-sidenav\" \nmd-is-locked-open=\"vm.resultCardFilter.deviceName == \'laptop\'\" ms-sidenav-helper><filter-panel \nlistoffilterobj=\"vm.listOfFilterObj\" selectedfilterobj=\"vm.selected_filter_obj\" side=\"\'left\'\" \nmode=\"vm.search_param.mode\" searchheight=\"vm.extraDivHeight\" callback=\"vm.fnApplyCardFilter(selectedFilterObj)\" \nshowshimmer=\"vm.resultCardFilter.countApiCard\"></filter-panel></md-sidenav></div></div><div flex layout=\"row\" \nlayout-wrap layout-align=\"center start\"><div style=\"visibility: hidden\">rates loading</div><div \nclass=\"apiErrSect mt-10 mb-30\" ng-if=\"vm.showApiError && vm.apiErrMsgList.length && !vm.maskLiner\" layout=\"row\" \nlayout-align=\"start start\" flex=\"100\"><div layout=\"row\" layout-align=\"center center\" class=\"w-30 h-30\" flex=\"10\" \nng-if=\"vm.apiErrMsgList.length > 3\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s28 arrow-icon pointer\" \nng-click=\"vm.fnScrollBtn(\'left\', $index)\"></md-icon></div><div layout=\"row\" layout-align=\"start start\" flex=\"80\" \nflex-xs=\"85\"><div layout=\"row\" layout-align=\"space-around center\" class=\"api-error-sect mh-5 p-5\" \nng-repeat=\"message in vm.apiErrMsgList track by $index\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"s18 icon-information-outline\" class=\"mr-5 info-icon\"></md-icon><span>{{message}}</span></div><div>\n<md-icon md-font-icon=\"icon-close\" class=\"s18 pointer cross-icon\" flex=\"10\" ng-click=\"vm.removeErrorMessage($index)\">\n</md-icon></div></div></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.apiErrMsgList.length > 3\" \nclass=\"w-30 h-30 ml-auto\" flex=\"10\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s28 arrow-icon pointer\" \nng-click=\"vm.fnScrollBtn(\'right\', $index)\"></md-icon></div></div><div flex=\"100\" ng-repeat=\"cardShimmer in [0,1,2]\" \nng-show=\"!vm.resultCardArray.length && vm.resultCardFilter.countApiCard\"><card-list-result index=\"$index\" \nsearchparam=\"vm.search_param\" carddata=\"card_item\" resultfilter=\"vm.resultCardFilter\" parent-page=\"\'result\'\" \nmixpanel-sorce=\"\'RR\'\" callback=\"vm.showQuoteProceedDiv(card)\" showshimmer=\"true\"></card-list-result></div>\n<md-virtual-repeat-container ng-style=\"{\'height\': vm.mdVirtiualHeight+\'px\'}\" class=\"virtualHeight\" \nng-show=\"vm.resultCardArray.length && vm.cardsCount\" md-top-index=\"vm.topIndexRecords\"><div \nmd-virtual-repeat=\"card_item in vm.resultCardArray | orderBy:[vm.sortBy, \'-meta.isError\']\" md-item-size=\"145\" \nclass=\"repeated-item\" flex=\"100\"><card-list-result index=\"$index\" searchparam=\"vm.search_param\" carddata=\"card_item\" \nresultfilter=\"vm.resultCardFilter\" parent-page=\"\'result\'\" mixpanel-sorce=\"\'RR\'\" uidata=\"vm.uiData\" \ncallback=\"vm.showQuoteProceedDiv(card)\"></card-list-result></div></md-virtual-repeat-container><div class=\"hidden-div\">\nRates loading</div><div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" \nng-if=\"vm.resultCardFilter.countApiCard\" class=\"pt-10\"><md-progress-circular></md-progress-circular></div><div \nlayout=\"row\" flex-xs=\"80\" flex-sm=\"80\" flex=\"100\" \nng-show=\"vm.resultCardArray.length && !vm.cardsCount && !vm.resultCardFilter.countApiCard\" \nlayout-align=\"center center\" class=\"p-20 mt-20\"><h2>No rates are available for the selected Filter.</h2></div><div \nclass=\"mh-8\" layout=\"column\" flex=\"100\" layout-wrap \nng-include=\"\'app/main/result/request-for-quote/request-for-quote.html\'\" \nng-show=\"vm.rfqComponentObj.show_rfqForm && !vm.resultCardArray.length && !vm.cardsCount && !vm.resultCardFilter.countApiCard\">\n</div></div></div></div><div class=\"layout-styles footer-content\" ng-if=\"!vm.resultCardFilter.isSearchUpdate\"><div \nid=\"footer-content\" class=\"md-primary-bg white-fg bg-535353\" \nng-class=\"{\'mb-67\' : vm.resultCardFilter.deviceName == \'mobile\', \'ml-220\': vm.resultCardFilter.deviceName == \'laptop\' && vm.viewMode === \'card\'}\">\n<div ng-if=\"vm.quoteArray.length\" layout=\"row\" flex=\"100\" class=\"card_shadow p-10\" layout-wrap><div flex=\"30\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"added-quote-count\">{{vm.quoteArray.length}}</div><div \nclass=\"pl-10 font-size-16 font-weight-600\">Rate Card Selected</div></div><div layout=\"row\" flex=\"70\" \nlayout-align=\"end center\" layout-wrap><div layout=\"row\" ng-if=\"vm.showQuoteTypeToggle\"><span \nclass=\"font-size-13 fg-ffffff\">Standard Quotation : </span><span class=\"pr-20 pl-10 fg-ffffff\">No</span><md-switch \nmd-no-ink ng-model=\"vm.generate_quote_type\" md-invert class=\"m-0 h-20\" ng-true-value=\"\'standard\'\" \nng-false-value=\"\'default\'\" ng-change=\"vm.trackEvent(\'RR-StandardQuotation-Click\',{\'Value\':vm.generate_quote_type})\">\n<span class=\"font-weight-600 font-size-13\"></span></md-switch><span class=\"pl-20 fg-ffffff\">Yes</span></div><md-button \nmd-no-ink class=\"remove-btn mr-10 w-100\" title=\"Remove\" ng-disabled=\"vm.resultCardFilter.generateQuoteBtn\" \nng-click=\"vm.fnCancelQuote($event)\">Remove All</md-button><md-button md-no-ink class=\"download-btn mr-10 w-150\" \ntitle=\"Download\" ng-if=\"!vm.resultService.isDownloadRatesLoader && !vm.searchFromQuote\" \nng-click=\"vm.fndownloadQuote()\">Download Rates</md-button><md-button md-no-ink class=\"download-btn mr-10 w-120\" \ntitle=\"Cancel\" ng-if=\"vm.searchFromQuote\" ng-click=\"vm.redirectToQuote()\">Cancel</md-button><div layout=\"row\" \nflex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"vm.resultService.isDownloadRatesLoader\" \nclass=\"w-150 mv-6 ml-8 mr-10\"><md-progress-circular md-diameter=\"25\"></md-progress-circular></div><md-button md-no-ink \nng-if=\"!vm.searchFromQuote && !vm.util.isShipper\" class=\"md-accent-btn ml-10 w-170\" title=\"Proceed\" \nng-disabled=\"vm.resultCardFilter.generateQuoteBtn\" \nng-click=\"vm.generate_quote_type == \'standard\' ?  vm.redirectToStandardQuotation() : vm.generateQuoteModal($event) \">\n<md-icon ng-if=\"vm.waitingListCount > 0\" md-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" \nclass=\"icon-class-16 glasshour\"></md-icon>Provide Quote Details<md-tooltip md-direction=\"top\" \nng-if=\"vm.waitingListCount > 0\" class=\"font-size-12 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">The booking for this rate is not live yet and it is on a waiting list .<br>\nPlease check with carrier before booking in this rate or check out the alternative rates.</md-tooltip></md-button>\n<md-button ng-if=\"vm.searchFromQuote\" class=\"md-accent-btn ml-10 w-120\" title=\"Add to Quote\" \nng-click=\"vm.redirectToQuote(vm.selectedCard)\">Add to Quote<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\nThis will be added to the {{vm.search_param.quote_number}} quote detail page</md-tooltip></md-button></div></div></div>\n<div class=\"new_card_footer\" ng-show=\"vm.resultCardFilter.deviceName == \'mobile\'\"><div layout=\"row\" flex=\"100\" \nclass=\"pv-15\"><div layout=\"column\" flex layout-align=\"center start\"><div \nng-if=\"!vm.util.isShipper && vm.viewDirectFilter\" class=\"w-100p\"><md-button md-no-ink \nclass=\"md-primary-btn Font-Bold w-100p-mob mb-15 && vm.util.navPermission.inquiry[0]\" \nng-click=\"vm.checkToUpdate($event,\'betterRates\')\" \nng-disabled=\"vm.resultCardFilter.countApiCard || vm.resultCardFilter.generateQuoteBtn\">Request Better Rate</md-button>\n</div><div ng-if=\"vm.util.isShipper && vm.viewDirectFilter && vm.util.navPermission.inquiry[0]\" class=\"w-100p\">\n<md-button md-no-ink class=\"md-primary-btn Font-Bold w-100p-mob mb-15\" ng-click=\"vm.fnOpenMatchRatesModal($event)\" \nng-disabled=\"vm.resultCardFilter.countApiCard || vm.resultCardFilter.generateQuoteBtn\">Match Rates</md-button></div>\n</div></div></div><button id=\"result-return-to-top\" \nclass=\"md-fab md-fab-bottom-right md-button footer scrollTopBtn hide\" type=\"button\" \nng-click=\"vm.scrollTop();vm.trackAnalytics(\'goTop\');vm.topIndexRecords = 0;\"><md-icon md-font-icon=\"icon-arrow-up\" \nrole=\"img\" class=\"s25 scroll-icon\"></md-icon><md-tooltip md-direction=\"top\">Go to Top</md-tooltip></button></div><div \nlayout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"vm.resultCardFilter.isSearchUpdate\" \nclass=\"pt-30\"><md-progress-circular ng-show=\"vm.resultCardFilter.countApiCard\"></md-progress-circular><div \nng-show=\"!vm.resultCardFilter.countApiCard && !vm.shipperSearchLimitError\" class=\"font-size-20 p-25 error\">\nSomething went wrong</div><div ng-if=\"vm.shipperSearchLimitError\" class=\"font-size-20 p-25 error\">\n{{vm.shipperSearchLimitError}}</div></div></div>");
$templateCache.put("app/main/rules/rules.html","<div id=\"rules\"><iframe id=\"rule-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" \nstyle=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/schedulesSearch/schedulesSearch.html","<md-sidenav class=\"md-sidenav-right md-white-bg\" md-component-id=\"right\" ms-sidenav-helper \nng-if=\"vm.scheduleLinerList.deviceName != \'laptop\'\" \nng-include=\"\'app/main/schedulesSearch/filterSchedule/filterSchedule.html\'\"></md-sidenav><div id=\"schedule-search-page\">\n<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"vm.toggleSidenav(\'right\')\" \nng-if=\"vm.scheduleData.length > 0 && vm.scheduleLinerList.deviceName != \'laptop\'\"><md-icon \nmd-font-icon=\"icon-filter-outline\" class=\"white-text\"></md-icon></div><div class=\"mb-25\"><div class=\"page_title mv-15\">\nSchedule Search</div><div class=\"b p-10 white-bg font-size-14\" layout=\"column\" flex=\"100\"><form name=\"searchForm\" \nclass=\"form-container\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\" layout-padding class=\"pv-0\"><div \nng-if=\"$root.domainData.domain_info.ALLOW_MULTI_PORT_PAIR && ($root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT && $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] > 1) || ($root.domainData.domain_info.IS_EFP_DOMAIN)\" \nflex=\"30\"><span class=\"font-weight-600 font-size-11 form-title\">Origin</span><br><md-chips md-chip-append-delay=\"3\" \nname=\"user_nearby_origin\" ng-model=\"vm.user_nearby_origin\" md-no-float class=\"panel-select ph-10 pb-5\" \nng-mouseenter=\"focused=true\" md-max-chips=\"{{$root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] + 1}}\" \nmd-require-match=\"true\" \nng-class=\"{\'red-border\':((vm.formSubmit && !vm.user_nearby_origin.length ) || vm.searchForm.$error.samePortError), \'b-focus\': originFocused}\" \nmd-transform-chip=\"vm.checkForDuplicatePorts($chip,\'origin\')\" layout=\"row\"><md-autocomplete \nng-hide=\"vm.user_nearby_origin.length && (vm.user_nearby_destination.length>1 || (vm.user_nearby_destination.length && vm.user_nearby_destination[0].place_type!==\'Port\') || vm.user_nearby_origin[0].place_type!==\'Port\') || vm.user_nearby_origin.length >= $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode]\" \nclass=\"auto-complete-style port-autocomplete mobile_input\" class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"vm.checkForSamePorts(\'origin\');\" \nng-focus=\"focused=true; vm.isStateResult ? (!vm.searchFromClose ? vm.toggleFormForResult() : return) : return; vm.formIsPristine=false;originFocused=true\" \nng-blur=\"originFocused=false\" id=\"multi-origin-input\" md-input-name=\"fcl_origin_port\" \nmd-search-text=\"fcl_originSearchText\" md-items=\"item in vm.getPort(fcl_originSearchText, \'SEA-FCL\', \'origin\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Select Origin Port\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"80\" \nstyle=\"pointer-events: none\"><div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"vm.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"80\" \nstyle=\"pointer-events: none\"><div ng-show=\"fcl_originSearchText.length >= 2 && !item.is_primary \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div \nng-if=\"fcl_originSearchText.length >= 2 && item.is_primary\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/primary_location.svg\')\" class=\"icon-bg\"></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-14\" compile-html=\"vm.util.searchHighlight(item.location,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-12\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-icon \nclass=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                            ($chip.place_type !== \'Door\' ?\n                            ((!$chip.is_icd_port && $chip.is_major_port) || ($chip.is_icd_port && $chip.is_major_port) || (!$chip.is_icd_port && !$chip.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!$chip.is_primary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' )) :\n                            \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!((vm.searchForm.fcl_origin_port.$error.required || vm.searchForm.fcl_origin_port.$error[\'md-require-match\'] || vm.searchForm.$error.samePortError) && (vm.searchForm.fcl_origin_port.$dirty || vm.formSubmit) && !focused)) && vm.mode!==\'AIR\'\">\n</md-icon>{{$chip.portname ? $chip.portname: $chip.location_string}}</div></span></md-chip-template></md-chips><div \nclass=\"errors font-size-11\" ng-messages=\"vm.searchForm.user_nearby_origin.$error\"><div ng-message=\"md-max-chips\">\nYou can search multi port up to {{($root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] || \'\').toString().split(\'*\')[0] ? $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().split(\'*\')[0].trim() :$root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().trim() }}.\n</div></div><div class=\"errors font-size-11\" ng-if=\"vm.checkExistingPort === \'origin\'\"><div>This port already used.\n</div></div><div class=\"errors font-size-11\" ng-if=\"vm.checkOtherPort === \'destination\'\"><div>\nThis port already used in destination port.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nng-if=\"vm.user_nearby_destination.length>1\">You may only enter one port</div><div layout=\"row\" flex \nlayout-align=\"end end\" \nng-hide=\"vm.user_nearby_origin[0].place_type==\'Door\' || (vm.user_nearby_destination.length > 1) || vm.user_nearby_destination[0].place_type==\'Door\'\">\n{{vm.user_nearby_origin.length}}/ {{ ($root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] || \'\').toString().split(\'*\')[0] ? $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().split(\'*\')[0].trim() : $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().trim() }}\n</div></div></div><div \nng-if=\"$root.domainData.domain_info.ALLOW_MULTI_PORT_PAIR && ($root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT && $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] > 1) || ($root.domainData.domain_info.IS_EFP_DOMAIN)\" \nflex=\"30\"><span class=\"font-weight-600 font-size-11 form-title\">Destination</span><br><md-chips \nmd-chip-append-delay=\"3\" name=\"user_nearby_destination\" ng-model=\"vm.user_nearby_destination\" md-no-float \nclass=\"panel-select ph-10 pb-5\" md-max-chips=\"{{$root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] + 1}}\" \nmd-transform-chip=\"vm.checkForDuplicatePorts($chip,\'destination\')\" ng-mouseenter=\"focused=true\" \nmd-require-match=\"true\" \nng-class=\"{\'red-border\':((vm.formSubmit && !vm.user_nearby_destination.length ) || vm.searchForm.$error.samePortError), \'b-focus\': destinationFocused}\" \nlayout=\"row\"><md-autocomplete \nng-hide=\"vm.user_nearby_destination.length && (vm.user_nearby_origin.length>1 || (vm.user_nearby_origin.length && vm.user_nearby_origin[0].place_type===\'Door\') || vm.user_nearby_destination[0].place_type!==\'Port\') || vm.user_nearby_destination.length >= $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode]\" \nclass=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"vm.checkForSamePorts(\'destination\');\" ng-blur=\"destinationFocused=false\" \nid=\"multi-destinatiomn-input\" md-input-name=\"fcl_destination_port\" md-search-text=\"fcl_destinationSearchText\" \nmd-items=\"item in vm.getPort(fcl_destinationSearchText, \'SEA-FCL\', \'destination\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Select Destination Port\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"80\" \nstyle=\"pointer-events: none\"><div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"vm.util.searchHighlight(item.portname,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"80\" \nlayout-align=\"start center\" style=\"pointer-events: none\"><div \nng-show=\"fcl_destinationSearchText.length >= 2 && !item.is_primary \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div \nng-if=\"fcl_destinationSearchText.length >= 2 && item.is_primary\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/primary_location.svg\')\" class=\"icon-bg\"></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-14\" compile-html=\"vm.util.searchHighlight( item.location,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-12\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-icon \nclass=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                            ($chip.place_type !== \'Door\' ?\n                            ((!$chip.is_icd_port && $chip.is_major_port) || ($chip.is_icd_port && $chip.is_major_port) || (!$chip.is_icd_port && !$chip.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!$chip.is_primary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' )) :\n                            \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!((vm.searchForm.fcl_destination_port.$error.required || vm.searchForm.fcl_destination_port.$error[\'md-require-match\'] || vm.searchForm.$error.samePortError) && (vm.searchForm.fcl_destination_port.$dirty || vm.formSubmit) && !focused)) && vm.mode!==\'AIR\'\">\n</md-icon>{{$chip.portname ? $chip.portname: $chip.location_string}}</div></span></md-chip-template></md-chips><div \nclass=\"errors\" ng-messages=\"vm.searchForm.user_nearby_destination.$error\"><div ng-message=\"md-max-chips\" \nclass=\"font-size-11\">\nYou can search multi port up to {{ ($root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] || \'\').toString().split(\'*\')[1] ? $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().split(\'*\')[1].trim() : $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().trim() }}.\n</div></div><div class=\"errors\" ng-if=\"vm.checkExistingPort === \'destination\'\"><div class=\"font-size-11\">\nThis port already used.</div></div><div class=\"errors\" ng-if=\"vm.checkOtherPort === \'origin\'\"><div \nclass=\"font-size-11\">This port already used in origin port.</div></div><div layout=\"row\" \nclass=\"md-link-fg font-size-11\"><div ng-if=\"vm.user_nearby_origin.length > 1\">You may only enter one port</div><div \nlayout=\"row\" flex layout-align=\"end end\" \nng-hide=\"vm.user_nearby_destination[0].place_type===\'Door\' || vm.user_nearby_origin.length > 1 || vm.user_nearby_origin[0].place_type===\'Door\'\">\n{{vm.user_nearby_destination.length}}/{{ ($root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] || \'\').toString().split(\'*\')[1] ? $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().split(\'*\')[1].trim() : $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode].toString().trim() }}\n</div></div></div><div \nng-if=\"!($root.domainData.domain_info.ALLOW_MULTI_PORT_PAIR && $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT  && $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] >1) && !($root.domainData.domain_info.IS_EFP_DOMAIN)\" \nflex=\"100\" class=\"w-265 mobile_input\"><div>Origin Port<span class=\"red-500-fg\">*</span></div><md-input-container \nmd-no-float class=\"panel-select p-0 m-0 ph-10 pl-35\" layout=\"row\" layout-align=\"start center\" \nng-mouseleave=\"focused=false\" ng-mouseenter=\"focused=true\"><md-icon class=\"mh-5 icon-size-autocomplete mt-2\" \nng-class=\"{\'icon-size-12 mt-5\' : ( vm.fcl_selected_origin_port.place_type !== \'Door\' && !vm.fcl_selected_origin_port.is_major_port && !vm.fcl_selected_origin_port.is_icd_port), \'icon-size-10 mt-6\' : !vm.fcl_selected_origin_port}\" \nmd-svg-src=\"{{ vm.fcl_selected_origin_port ?\n                                    (vm.fcl_selected_origin_port.place_type !== \'Door\' ?\n                                    ((!vm.fcl_selected_origin_port.is_icd_port && vm.fcl_selected_origin_port.is_major_port) || (vm.fcl_selected_origin_port.is_icd_port && vm.fcl_selected_origin_port.is_major_port) || (!vm.fcl_selected_origin_port.is_icd_port && !vm.fcl_selected_origin_port.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') :\n                                    \'assets/icons/custom/search-bar/door.svg\') :\n                                    \'assets/icons/custom/search-bar/empty.svg\' }}\">\n</md-icon><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" required \nmd-input-name=\"fcl_origin_port\" md-selected-item=\"vm.fcl_selected_origin_port\" \nmd-search-text=\"vm.fcl_originSearchText\" md-items=\"item in vm.getPort(vm.fcl_originSearchText,\'SEA-FCL\', \'origin\')\" \nmd-item-text=\"item.portname || item.location_string\" placeholder=\"Select Origin Port\" md-min-length=\"0\" \nmd-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\"><div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && vm.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && vm.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && vm.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && vm.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && vm.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.fcl_originSearchText || vm.fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\"><div \nclass=\"black-fg font-size-13\" compile-html=\"vm.util.searchHighlight(item.portname,vm.fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">\n{{item.global_port_code}}</span></div></div></span><span class=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div \nclass=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"center center\" style=\"pointer-events: none\"><div ng-show=\"vm.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.fcl_originSearchText || vm.fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\"><div \nclass=\"black-fg font-size-14\" compile-html=\"vm.util.searchHighlight( item.location,vm.fcl_originSearchText)\"></div><div\n class=\"grey-fg font-size-12\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found><div layout=\"row\" layout-align=\"center center\" class=\"font-size-14 mt-15\">\nNo ports matching <b>\"{{vm.fcl_originSearchText}}\"</b> were found.</div></md-not-found></md-autocomplete><div \nng-if=\"vm.fcl_selected_origin_port && vm.fcl_selected_origin_port.place_type!==\'Door\' && !focused \" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{vm.fcl_selected_origin_port.global_port_code || vm.fcl_selected_origin_port.portcode_portname}}</div><div \nng-if=\"vm.fcl_selected_origin_port && vm.fcl_selected_origin_port.place_type===\'Door\' && vm.fcl_selected_origin_port.pin_code_ui && !focused\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{vm.fcl_selected_origin_port.pin_code_ui}}</span></div></md-input-container></div><div \nng-if=\"!($root.domainData.domain_info.ALLOW_MULTI_PORT_PAIR && $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT && $root.domainData.domain_info.MULTI_PORT_PAIR_LIMIT[vm.mode] > 1 ) && !($root.domainData.domain_info.IS_EFP_DOMAIN)\" \nflex=\"100\" class=\"w-265 mobile_input\"><div>Destination Port<span class=\"red-500-fg\">*</span></div><md-input-container \nmd-no-float class=\"panel-select p-0 m-0 ph-10 pl-35\" layout=\"row\" layout-align=\"start center\" \nng-mouseleave=\"focusedDestination=false\" ng-mouseenter=\"focusedDestination=true\"><md-icon \nclass=\"mh-5 icon-size-autocomplete mt-2\" \nng-class=\"{\'icon-size-12 mt-5\' : ( vm.fcl_selected_destination_port.place_type !== \'Door\' && !vm.fcl_selected_destination_port.is_major_port && !vm.fcl_selected_destination_port.is_icd_port), \'icon-size-10 mt-6\' : !vm.fcl_selected_destination_port}\" \nmd-svg-src=\"{{ vm.fcl_selected_destination_port ?\n                                      (vm.fcl_selected_destination_port.place_type !== \'Door\' ?\n                                      ((!vm.fcl_selected_destination_port.is_icd_port && vm.fcl_selected_destination_port.is_major_port) || (vm.fcl_selected_destination_port.is_icd_port && vm.fcl_selected_destination_port.is_major_port) || (!vm.fcl_selected_destination_port.is_icd_port && !vm.fcl_selected_destination_port.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') :\n                                      \'assets/icons/custom/search-bar/door.svg\') :\n                                      \'assets/icons/custom/search-bar/empty.svg\' }}\">\n</md-icon><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" required \nmd-input-name=\"fcl_destination_port\" md-selected-item=\"vm.fcl_selected_destination_port\" \nmd-search-text=\"vm.fcl_destinationSearchText\" \nmd-items=\"item in vm.getPort(vm.fcl_destinationSearchText,\'SEA-FCL\', \'destination\')\" \nmd-item-text=\"item.portname || item.location_string\" placeholder=\"Select Destination Port\" md-min-length=\"0\" \nmd-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" \nmd-clear-button=\"focusedDestination\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\"><div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && vm.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && vm.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && vm.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && vm.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && vm.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!vm.fcl_destinationSearchText || vm.fcl_destinationSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\">\n<div class=\"black-fg font-size-13\" compile-html=\"vm.util.searchHighlight( item.portname,vm.fcl_destinationSearchText)\">\n</div><div class=\"grey-fg font-size-11\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">\n{{item.global_port_code}}</span></div></div></span><span class=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div \nclass=\"font-weight-600 font-size-12 p-10 port-hover-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\"><div \nng-show=\"vm.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.fcl_destinationSearchText || vm.fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\"><div \nclass=\"black-fg font-size-14\" compile-html=\"vm.util.searchHighlight( item.location,vm.fcl_destinationSearchText)\">\n</div><div class=\"grey-fg font-size-12\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found><div layout=\"row\" layout-align=\"center center\" class=\"font-size-14 mt-15\">\nNo ports matching <b>\"{{vm.fcl_destinationSearchText}}\"</b> were found.</div></md-not-found></md-autocomplete><div \nng-if=\"vm.fcl_selected_destination_port && vm.fcl_selected_destination_port.place_type!==\'Door\' && !focusedDestination \" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{vm.fcl_selected_destination_port.global_port_code || vm.fcl_selected_destination_port.portcode_portname}}</div><div \nng-if=\"vm.fcl_selected_destination_port && vm.fcl_selected_destination_port.place_type===\'Door\' && vm.fcl_selected_destination_port.pin_code_ui && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{vm.fcl_selected_destination_port.pin_code_ui}}</span></div></md-input-container></div><div flex><div>Select Range\n</div><md-input-container md-no-float class=\"select-input m-0 mt-8\"><md-select name=\"range\" ng-model=\"vm.range\" \nplaceholder=\"Select Range\"><md-option value=\"2\">2 Weeks</md-option><md-option value=\"4\">4 Weeks</md-option><md-option \nvalue=\"6\">6 Weeks</md-option></md-select></md-input-container></div><div layout=\"row\" layout-sm=\"column\" \nclass=\"m-0 mt-20\" layout-align=\"end center\" flex><md-button class=\"md-accent-btn\" ng-click=\"vm.submitSearch()\" \ntype=\"submit\">Search</md-button></div></div></form></div><div layout=\"column\" flex=\"100\" \nng-if=\"vm.scheduleData.length>0\"><div layout=\"row\" class=\"pv-20 bb-header\" layout-align=\"space-between end\"><div \nng-class=\"{ hide : vm.scheduleLinerList.deviceName != \'laptop\' }\"><div class=\"schedule_filter\">\n{{vm.scheduleListFull.length}} Results Found</div></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"mb-10 mt-10\" layout-wrap><div layout=\"row\"><div \nclass=\"font-size-14 font-weight-400 mr-5\" style=\"margin-bottom: -5px\">Show Entries</div><md-input-container \nclass=\"filter-entries category_filter m-0 p-0\" flex md-no-float><select name=\"type\" ng-model=\"vm.entries\" \nplaceholder=\"select\" ng-change=\"vm.entriesList(vm.entries)\" class=\"select_entries category_filter\"><option value=\"5\">5\n</option><option value=\"10\">10</option><option value=\"15\">15</option><option value=\"20\">20</option><option value=\"25\">\n25</option></select></md-input-container></div><div layout=\"row\" ng-if=\"scheduleFilterObj.length>0\"><md-button \nmd-no-ink class=\"md-primary-btn export-btn Font-Bold w-100 m-0 p-0 md-button ex\" ng-click=\"vm.exportToCsvFormat();\">\nExport</md-button><div layout=\"column\" layout-align=\"center start\" layout-wrap class=\"category_filter\" flex=\"100\"><div \nclass=\"font-weight-600 font-size-9 grey-fg\" style=\"margin-bottom: -4px\">Sort by</div><md-input-container \nclass=\"filter-input m-0 p-0\" flex md-no-float><md-select name=\"type\" ng-model=\"vm.sortBy\" placeholder=\"Select\">\n<md-option value=\"transit_time\" ng-click=\"vm.fnSortList(\'transit_time\')\">Transit</md-option><md-option \nvalue=\"departure_time\" ng-click=\"vm.fnSortList(\'departure_time\')\">Departure Time</md-option><md-option \nvalue=\"arrival_time\" ng-click=\"vm.fnSortList(\'arrival_time\')\">Arrival Time</md-option></md-select></md-input-container>\n</div></div></div><div flex layout=\"row\"><div ng-if=\"vm.scheduleLinerList.deviceName == \'laptop\'\"><div \nclass=\"sticky-filter\"><md-sidenav class=\"md-white-bg mr-10\" ms-sidenav-helper \nmd-is-locked-open=\"vm.scheduleLinerList.deviceName == \'laptop\'\" \nng-include=\"\'app/main/schedulesSearch/filterSchedule/filterSchedule.html\'\"></md-sidenav></div></div><div flex><div \nclass=\"b p-20 pl-50 white-bg font-size-16 font-weight-600\" layout=\"row\" flex=\"100\" ng-if=\"scheduleFilterObj.length>0\" \nlayout-wrap><div flex=\"5\" flex-xs=\"100\"></div><div flex=\"15\" flex-xs=\"100\">From - To</div><div flex=\"15\" flex-xs=\"100\">\nShipping Line</div><div flex=\"10\" flex-xs=\"100\" class=\"ml-10\">Vessel</div><div flex flex-xs=\"45\">Est.Departure</div>\n<div flex flex-xs=\"45\" class=\"ml-30\">Est.Transit</div><div flex flex-xs=\"45\" class=\"ml-10\">Est.Arrival</div><div flex \nflex-xs=\"45\" class=\"ml-10\">Via Port</div><div flex flex-xs=\"85\">ServiceType</div><div flex class=\"ml-5 mr-10\"></div>\n</div><md-expansion-panel md-component-id=\"shipperInfo\" \nng-repeat=\"schedules in vm.scheduleList as scheduleFilterObj track by $index\"><md-expansion-panel-collapsed \nclass=\"pl-40 pt-20\"><div layout=\"row\" flex=\"100\" layout-wrap><md-checkbox md-no-ink flex=\"5\" flex-xs=\"100\" \nng-show=\"!vm.isSharing\" ng-model=\"schedules.selected\" ng-click=\"vm.selectSchedule($event,schedules)\"></md-checkbox><div\n flex=\"15\" flex-xs=\"100\" title=\"\" class=\"text-truncate\">{{ schedules.origin_port }} - {{ schedules.destination_port }}\n<md-tooltip md-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{schedules.origin_port_name}} / {{ schedules.origin_port }}<br>\n{{schedules.destination_port_name}} / {{ schedules.destination_port }}</md-tooltip></div><div flex=\"15\" flex-xs=\"100\" \nng-bind=\"vm.getCarrierNameByCode(schedules.carrier_code)\" title=\"{{vm.getCarrierNameByCode(schedules.carrier_code)}}\" \nclass=\"text-truncate\"></div><div flex=\"10\" class=\"text-truncate ml-10\" title=\"{{schedules.vessel}}\" flex-xs=\"100\">\n{{schedules.vessel}}</div><div flex class=\"ml-10\" title=\"{{schedules.departure_time}}\" flex-xs=\"45\">\n{{schedules.departure_time | UTCToLocal : \'d MMM, y\'}}</div><div flex class=\"ml-30 text-truncate\" \ntitle=\"{{schedules.transit_time}}\" flex-xs=\"45\">{{schedules.transit_time}}</div><div flex class=\"ml-10\" \ntitle=\"{{schedules.arrival_time}}\" flex-xs=\"45\">{{schedules.arrival_time | UTCToLocal : \'d MMM, y\'}}</div><div flex \nclass=\"ml-5 text-truncate\" title=\"{{schedules.via_port}}\" flex-xs=\"45\">{{schedules.via_port}}</div><div flex \nclass=\"text-truncate ml-5\" title=\"{{schedules.service_name}}\" flex-xs=\"85\">{{schedules.service_name}}</div><div flex \nclass=\"text-center\"><md-icon class=\"mr-5\" md-font-icon=\"icon-chevron-double-down md-link-fg\"></md-icon></div></div>\n</md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header ng-click=\"$panel.collapse()\" \nclass=\"cursor\"><div layout=\"row\" flex=\"100\" class=\"pv-5\" layout-wrap><md-checkbox md-no-ink flex=\"5\" flex-xs=\"100\" \nng-show=\"!vm.isSharing\" ng-model=\"schedules.selected\" ng-click=\"vm.selectSchedule($event,schedules)\"></md-checkbox><div\n flex=\"15\" flex-xs=\"100\" title=\"\" class=\"text-truncate\">{{ schedules.origin_port }} - {{ schedules.destination_port }}\n<md-tooltip md-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{schedules.origin_port_name}} / {{ schedules.origin_port }}<br>\n{{schedules.destination_port_name}} / {{ schedules.destination_port }}</md-tooltip></div><div flex=\"15\" flex-xs=\"100\" \nclass=\"pl-15 text-truncate\" ng-bind=\"vm.getCarrierNameByCode(schedules.carrier_code)\" \ntitle=\"{{vm.getCarrierNameByCode(schedules.carrier_code)}}\"></div><div flex=\"10\" flex-xs=\"100\" \nclass=\"text-truncate ml-25\" title=\"{{schedules.vessel}}\">{{schedules.vessel}}</div><div flex flex-xs=\"45\" \nclass=\"ml-10\" title=\"{{schedules.departure_time}}\">{{schedules.departure_time | UTCToLocal : \'d MMM, y\'}}</div><div \nflex flex-xs=\"45\" class=\"ml-10\" title=\"{{schedules.transit_time}}\">{{schedules.transit_time}}</div><div flex \nflex-xs=\"45\" class=\"ml-10\" title=\"{{schedules.arrival_time}}\">{{schedules.arrival_time | UTCToLocal : \'d MMM, y\'}}\n</div><div flex flex-xs=\"45\" class=\"ml-10 text-truncate\" title=\"{{schedules.via_port}}\">{{schedules.via_port}}</div>\n<div flex flex-xs=\"85\" class=\"text-truncate ml-10\" title=\"{{schedules.service_name}}\">{{schedules.service_name}}</div>\n<div class=\"text-center\"><md-icon class=\"mr-20\" md-font-icon=\"icon-chevron-double-up md-link-fg\" \nng-click=\"$panel.collapse()\"></md-icon></div></div></md-expansion-panel-header><md-expansion-panel-content \nclass=\"font-size-14 opacity\" ng-class=\"{\'p-5\' : !vm.util.isMobileDevice,\'pv-5\':vm.util.isMobileDevice}\"><div \nclass=\"white-bg schedule_route mh-25\"><div layout=\"column\" ng-class=\"{\'pr-10 ml-20\' : !vm.util.isMobileDevice}\" \nng-repeat=\"schedule_track in schedules.schedule_track track by $index\"><div layout=\"column\"><div layout=\"row\" \nclass=\"show_schedule\" ng-if=\"$first || $last\"><div flex-gt-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nng-class=\"{\'pr-10\' : !vm.util.isMobileDevice}\" class=\"w-80\" ng-class=\"{\'mt-12\':!$first}\" ng-if=\"!$last\"><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p \nclass=\"font-size-10 mv-5 mh-0 grey-fg text-end\">{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}\n</p></div><div flex-gt-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 mt-12\" ng-if=\"$last\"><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p \nclass=\"font-size-10 mv-5 mh-0 grey-fg text-end\">{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p>\n</div><div flex-gt-md=\"50\" flex-sm=\"80\" flex-xs=\"80\" class=\"ship_schedule_sect\" \nng-class=\"{\'border-left\' : !$last,\'mt-10\': $first}\"><p class=\"card_text_bold source_name pl-15\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot font-size-25 mr-10\"></md-icon><span><md-icon class=\"mr-5\" \nmd-svg-src=\"assets/icons/custom/icon-ship.svg\"></md-icon></span><span class=\"port-name\" \ntitle=\"schedule_track.port_name\">{{ schedule_track.port_name }}</span></p><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\" class=\"edit_schedule pointer\" ng-if=\"!$last && vm.permission.schedule[2]\"><md-icon class=\"mh-5 w-15 h-15\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" ng-click=\"vm.fnOpenScheduleEdit(schedule_track,$index,\'Edit\')\" \ntitle=\"Edit Details\"></md-icon></div><div layout=\"column\" ng-if=\"!$last\" class=\"mb-20 pl-10\"><div layout=\"row\"><div \nclass=\"track_text\" flex>VGM Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.vgm_cutoff ? (schedule_track.vgm_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\' }}</div></div><div \nlayout=\"row\"><div class=\"track_text\" flex>Port Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.port_cutoff ? (schedule_track.port_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\'}}</div></div><div\n layout=\"row\"><div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.service_name ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.vessel ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" flex>\nVoyage Ref.</div><div class=\"track_text eta_div\" flex>{{ schedule_track.voyage ? schedule_track.voyage : \'NA\'}}</div>\n</div></div></div></div><div layout=\"row\" class=\"show_schedule\" ng-class=\"{\'pv-20\' : !vm.util.isMobileDevice}\" \nng-if=\"(!$first && !$last)\"><div flex-gt-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 mt-12\"><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p \nclass=\"font-size-10 mv-5 mh-0 grey-fg text-end\">{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p>\n</div><div flex-gt-md=\"50\" flex-sm=\"80\" flex-xs=\"80\" class=\"ship_schedule_sect border-left\"><p \nclass=\"card_text_bold source_name pl-15\"><md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot font-size-25 mr-10\">\n</md-icon><span><md-icon class=\"mr-5\" md-svg-src=\"assets/icons/custom/icon-ship.svg\"></md-icon></span><span \nclass=\"port-name\" title=\"schedule_track.port_name\">{{ schedule_track.port_name }} </span><span>(Arrival)</span></p>\n</div></div><div layout=\"row\" class=\"show_schedule\" ng-if=\"(!$first && !$last)\"><div flex-gt-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" ng-class=\"{\'pr-10\' : !vm.util.isMobileDevice}\" class=\"w-80 mt-12\"><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p \nclass=\"font-size-10 mv-5 mh-0 grey-fg text-end\">{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}\n</p></div><div flex-gt-md=\"50\" flex-sm=\"80\" flex-xs=\"80\" class=\"ship_schedule_sect border-left\"><p \nclass=\"card_text_bold source_name pl-15\"><md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot font-size-25 mr-10\">\n</md-icon><span><md-icon class=\"mr-5\" md-svg-src=\"assets/icons/custom/icon-ship.svg\"></md-icon></span><span \nclass=\"port-name\" title=\"schedule_track.port_name\">{{ schedule_track.port_name }} </span><span>(Departure)</span></p>\n<div layout=\"row\" layout-align=\"end end\" flex=\"100\" class=\"edit_schedule pointer\" \nng-if=\"!$last && vm.permission.schedule[2]\"><md-icon class=\"mh-5 w-15 h-15\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" ng-click=\"vm.fnOpenScheduleEdit(schedule_track,$index,\'Edit\')\" \ntitle=\"Edit Details\"></md-icon></div><div layout=\"column\" class=\"mb-20 pl-10\"><div layout=\"row\"><div \nclass=\"track_text\" flex>VGM Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.vgm_cutoff ? (schedule_track.vgm_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\' }}</div></div><div \nlayout=\"row\"><div class=\"track_text\" flex>Port Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.port_cutoff ? (schedule_track.port_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\'}}</div></div><div\n layout=\"row\"><div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.service_name ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.vessel ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" flex>\nVoyage Ref.</div><div class=\"track_text eta_div\" flex>{{ schedule_track.voyage ? schedule_track.voyage : \'NA\'}}</div>\n</div></div></div></div></div></div><div layout=\"row\" layout-align=\"end end\" flex=\"100\" \nng-if=\"vm.schedule && vm.permission.schedule[0]\"><span class=\"green-fg pointer\" \nng-click=\"vm.fnOpenScheduleEdit(\'\',\'\',\'Add\')\" title=\"Add shipment leg\"><md-icon \nmd-font-icon=\"icon-plus-circle green-fg schedule-icon\"></md-icon><u class=\"pl-5\">Add Schedule Leg</u></span></div>\n</div></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><div layout=\"column\" \nlayout-align=\"center center\" layout-wrap class=\"ph-20 mt-70\" ng-if=\"scheduleFilterObj.length<=0\"><div \nclass=\"font-size-22\">No Results Found</div></div></div></div></div><div layout=\"column\" layout-align=\"center center\" \nlayout-wrap class=\"ph-20 mt-70\" ng-if=\"vm.scheduleData.length<=0\"><div class=\"font-size-22\">No Results Found</div>\n</div><div flex=\"100\" layout=\"row\" ng-if=\"vm.scheduleList.length>0\" class=\"mt-10\"><div layout=\"column\" \nlayout-align=\"end end\" flex=\"100\" class=\"mr-0\"><div layout=\"row\" flex-xs=\"100\" flex-sm=\"40\" flex-gt-md=\"55\"><div \nclass=\"schedule_count\">\nShowing {{vm.scheduleListFull.length == 0 ? vm.offset : (vm.offset - vm.count)+1}} to {{vm.scheduleListFull.length > vm.count ? vm.offset : vm.scheduleListFull.length}} of {{vm.scheduleListFull.length}} entries\n</div></div><div class=\"pagination\"><button ng-click=\"vm.fnPaginateScheduleList(\'prev\',\'5\')\" \nng-disabled=\"vm.offset - vm.count <= 0\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s20 arrow-icon active\" \nng-class=\"{\'inactive\': vm.offset - vm.count <= 0}\" ng-style=\"{\'color\': bannerData.theme.text_color}\"></md-icon><span \nclass=\"arrow-icon mr-5 active\" ng-class=\"{\'inactive\': vm.offset - vm.count <= 0}\">Previous</span></button> <button \nng-click=\"vm.fnPaginateScheduleList(\'next\',\'5\')\" ng-disabled=\"vm.offset >= vm.scheduleListFull.length\"><span \nclass=\"arrow-icon active\" ng-class=\"{\'inactive\': vm.offset >= vm.scheduleListFull.length}\">Next</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s20 arrow-icon active\" \nng-class=\"{\'inactive\': vm.offset >= vm.scheduleListFull.length}\" ng-style=\"{\'color\': bannerData.theme.text_color}\">\n</md-icon></button></div></div></div></div><div class=\"sticky-bottom ph-40\" id=\"footer\" layout=\"row\" flex=\"100\" \nlayout-wrap layout-align=\"space-between center\" ng-show=\"vm.selectedSchedulesCount != 0\"><div \nclass=\"font-weight-600 font-size-18\">{{vm.selectedSchedulesCount}} <span><span ng-if=\"vm.selectedSchedulesCount <=1\">\nSchedule</span> <span ng-if=\"vm.selectedSchedulesCount > 1\">Schedules</span> Selected</span></div><div><md-button \nmd-no-ink class=\"md-primary-btn\" ng-click=\"vm.exportToCsvFormat();\">Export CSV</md-button><md-button md-no-ink \nclass=\"md-accent-btn\" ng-click=\"vm.generatePdf(vm.shareScheduleList)\">Generate PDF</md-button></div></div></div>");
$templateCache.put("app/main/search/search.html","<div id=\"instant-rate\" layout=\"column\"><div class=\"mode-img\"><img \nng-src=\"{{vm.modeImg && vm.modeImg.FCL ? vm.modeImg.FCL : \'assets/icons/custom/new-FCL.png\'}}\" ng-show=\"vm.active_tab\" \nwidth=\"100%\" hide-xs> <img \nng-src=\"{{vm.modeImg && vm.modeImg.LCL ? vm.modeImg.LCL : \'assets/icons/custom/new-LCL.png\'}}\" \nng-show=\"vm.lclActive_tab\" width=\"100%\" hide-xs> <img \nng-src=\"{{vm.modeImg && vm.modeImg.AIR ? vm.modeImg.AIR : \'assets/icons/custom/new-AIR.png\'}}\" \nng-show=\"vm.airActive_tab\" width=\"100%\" hide-xs> <img \nng-src=\"{{vm.modeImg && vm.modeImg.FTL ? vm.modeImg.FTL : \'assets/icons/custom/new_ftl.svg\'}}\" \nng-show=\"vm.LandActive_tab\" width=\"100%\" hide-xs></div><div class=\"center z-index-1 pt-0\" flex \nng-class=\'{ \"padding-0\": vm.util.isMobileApp }\'><ms-widget layout=\"row\" flex=\"100\" \nclass=\"padding-bottom-0 width-search-card mt-0\" ng-class=\"{ \'padding-0\': vm.util.isMobileApp}\"><ms-widget-front \nclass=\"white-bg mode-panel box-style b brad-5\"><md-tabs md-dynamic-height md-border-bottom md-no-ink md-dynamic-height \nclass=\"p-0\" md-selected=\"vm.selectedIndex\"><md-tab ng-repeat=\"tab in vm.tabs\" \nmd-on-select=\"vm[tab.activeTabKey] = true; vm.getSearchHistory(tab.name)\" \nmd-on-deselect=\"vm[tab.activeTabKey] = false\" ng-disabled=\"!vm.util.navPermission[tab.permission][1] || !tab.is_paid\">\n<md-tab-label ng-click=\"vm[tab.activeTabKey] = true\"><md-icon ng-if=\"tab.name==\'FCL\'\" \nmd-svg-src=\"assets/icons/custom/fcl-deactive.svg\" ng-class=\"{\'active-tab-icon\':vm.active_tab}\" class=\"mr-5 h-15\">\n</md-icon><md-icon ng-if=\"tab.name==\'LCL\'\" md-svg-src=\"assets/icons/custom/lcl-deactive.svg\" class=\"mr-5 h-15\" \nng-class=\"{\'active-tab-icon\':vm.lclActive_tab}\"></md-icon><md-icon ng-if=\"tab.name==\'AIR\'\" class=\"mr-5 h-15 icon-air\" \nmd-font-icon=\"icon-airplane\"></md-icon><span ng-if=\"tab.name==\'LAND\'\"><md-icon ng-show=\"!vm.LandActive_tab\" \nmd-svg-src=\"assets/icons/custom/land_icon_default.svg\" class=\"mr-5 land-tab h-30\"></md-icon><md-icon \nng-show=\"vm.LandActive_tab\" md-svg-src=\"assets/icons/custom/land_icon_active.svg\" class=\"mr-5 land-tab h-30\"></md-icon>\n</span>{{tab.name}}</md-tab-label><md-tab-body><div class=\"search-bar-wrapper\"><div \nng-if=\"vm[tab.activeTabKey] && tab.name!==\'LAND\'\"><search-bar search-param-input=\"vm.searchParamForComponent\" \nuserselectedparam=\"vm.prefilledCardSearch\" callback=\"vm.submitSearch(payload)\" mode=\"{{tab.mode}}\" \nis-loading-api=\"vm.isLoadingApi;\" all-sales-persons-data=\"vm.allSalesPersonsData\"></search-bar></div><div \nng-if=\"vm[tab.activeTabKey] && tab.name==\'LAND\'\"><search-bar-inland search-param-input=\"vm.searchParamForComponent\" \nuserselectedparam=\"true\" mode=\"FTL\" callback=\"vm.submitLandSearch(payload)\"></search-bar-inland></div></div>\n</md-tab-body></md-tab></md-tabs></ms-widget-front></ms-widget><div class=\"pt-10\" \nng-include=\"\'app/main/search/views/search-history/search-history.html\'\" ng-if=\"vm.util.navPermission.search[1]\"></div>\n</div></div>");
$templateCache.put("app/main/search-v2/search-v2.html","<div class=\"search-v2\"><div class=\"search-v2-disabled\" ng-if=\"$root.disableEfpSearchUi\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"search-v2-disabled__title\">EFP search disabled for Non EFP forwarders</div>\n<div class=\"search-v2-disabled__message\">Select an EFP forwarder from the forwarders dropdown menu to use EFP search.\n</div></div><iframe id=\"search-v2-iframe\" name=\"{{vm.todaysDate}}\" ng-if=\"!$root.disableEfpSearchUi\" \nng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/shipments/shipments.html","<md-sidenav ng-if=\"vm.filterData.deviceName != \'laptop\'\" class=\"md-sidenav-right sidenav-bg no-scroll\" \nmd-component-id=\"right\" ms-sidenav-helper ng-include=\"\'app/main/shipments/filter-shipment/filter_shipment.html\'\">\n</md-sidenav><div id=\"shipments-page\" when-scrolled=\"vm.loadMoreRecords(vm.shipment_list.length)\" \nng-style=\"vm.maxHeight\"><div class=\"layout-styles\"><div class=\"pv-20 shipments-sticky-div\" \nng-class=\"{\'pb-0\' : vm.util.isMobileDevice || vm.util.isMobileApp}\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"header_and_subheader\" layout=\"column\" \nlayout-align=\"space-between\" layout-wrap=\"wrap\"><span class=\"page_title\">Bookings</span> <span>\nManage all your Won quotes and Bookings</span></div></div><div class=\"mr-10\" layout=\"row\" \nlayout-align=\"space-between center\" ng-class=\"{\'mr-0\' : vm.util.isMobileDevice || vm.util.isMobileApp}\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"hide-xs\"><md-button ng-if=\"vm.trackTrace\" \nclass=\"md-primary-btn with-icon mb-0 pointer\" ng-class=\"{\'un-paid-btn\':vm.isUnpaidModule}\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.btnNavClick(\'track\');\"><md-icon class=\"mr-5 s14 m-0\" \nmd-font-icon=\"icon-map-marker\"></md-icon>Track and Trace</md-button></div><div \nng-if=\"!(vm.shipment_list.length <= 0 && !vm.shipmentShimmer && !vm.filteringData)\" layout=\"column\" \nlayout-align=\"center start\"><span class=\"font-size-10 Font-Bold grey-fg sort_by\">Sort by</span><md-select \nng-model=\"vm.filterData.order_by\" ng-change=\"vm.filterShipment(true);\" \nclass=\"md-no-underline sort-dropdwn m-0 Font-Bold grey-600-fg\" md-container-class=\"mySelect\"><md-option \nvalue=\"created_at\">Created at</md-option><md-option value=\"sailing_date\">Sailing date</md-option></md-select></div><div\n ng-if=\"vm.filterData.deviceName != \'laptop\'\" ng-click=\"vm.toggleSidenav(\'right\')\" class=\"mobile-filter mr-0\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 mobile-filter-icon\"></md-icon></div></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap class=\"hide-gt-xs pt-10\"><md-button ng-if=\"vm.trackTrace\" \nclass=\"md-primary-btn with-icon mb-0 pointer ml-0\" ng-class=\"{\'un-paid-btn\':vm.isUnpaidModule}\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.btnNavClick(\'track\')\"><md-icon class=\"mr-5 s14 m-0\" \nmd-font-icon=\"icon-map-marker\"></md-icon>Track and Trace</md-button></div></div><div layout=\"row\"><div \nng-if=\"vm.filterData.deviceName == \'laptop\'\" class=\"w-230\"><div class=\"filter-container\" \nng-style=\"vm.leftFilterTopMargin\"><md-sidenav class=\"sidenav-bg no-scroll\" \nmd-is-locked-open=\"vm.filterData.deviceName == \'laptop\'\" ms-sidenav-helper \nng-include=\"\'app/main/shipments/filter-shipment/filter_shipment.html\'\"></md-sidenav><div ng-if=\"vm.isFilterAvl\"><div \nlayout=\"column\" layout-align=\"start start\" class=\"w-280\" shimmer-effect-full width=\"88%\" height=\"30px\" \nstyle=\"margin: 20px 0\" ng-repeat=\"shimmer in [1,2,3,4,5,6]\"></div></div></div></div><div layout=\"row\" flex=\"100\" \nng-show=\"(!vm.shipment_list.length && !vm.shipmentShimmer && vm.filteringData) || (vm.shipment_list.length <= 0 && !vm.shipmentShimmer && !vm.filteringData)\" \nlayout-align=\"center center\" class=\"height-100-p\" \nng-class=\"{\'margin-top-5-p\':(vm.shipment_list.length <= 0 && !vm.shipmentShimmer && !vm.filteringData),\'empty-state m-0\':(!vm.shipment_list.length && !vm.shipmentShimmer && vm.filteringData)}\">\n<div><md-icon md-svg-icon=\"assets/icons/custom/empty_shipments.svg\" class=\"w-300 h-165\"></md-icon><div \nclass=\"font-size-20 text-center\">No Booking(s) Found</div></div></div><div flex><div layout=\"row\" \nlayout-align=\"space-between\" class=\"ph-5 shipments-count-sort-div\" ng-if=\"vm.shipment_list.length !== 0\"><div \nng-if=\"!vm.util.isCallingApi\" class=\"list_count\">{{vm.shipmentListCount}} Results Found</div><div \nlayout-align=\"end center\"></div></div><div ng-show=\"vm.shipment_list.length\"><div flex><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"pt-20\" ng-show=\"shipmentFilterObj.length <= 0 && !vm.shipmentShimmer\">\n<div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div class=\"font-size-18 pb-8\"><md-icon \nmd-svg-icon=\"assets/icons/custom/empty_shipments.svg\" class=\"w-300 h-165\"></md-icon><div \nclass=\"font-size-20 text-center\">No Shipment(s) Found</div></div></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\" ng-hide=\"!vm.filterData.mode && !vm.filterData.status && !vm.filterData.search\"><div \nclass=\"font-size-16 pb-8\"><a ng-click=\"vm.callShipmentApi(\'viewAll\')\" class=\"border-bottom pointer md-link-fg\">\nView all shipments</a></div></div></div><md-content id=\"shipmentList\" ms-scroll><div \nclass=\"shipment-card pointer hover-card\" ng-click=\"vm.trackMixpanel(shipmentList.shipment_id)\" layout=\"row\" \nng-repeat=\"shipmentList in vm.shipment_list as shipmentFilterObj track by $index\" flex=\"100\" layout-xs=\"column\"><div \nclass=\"status-sect\" layout-align=\"center center\" layout-gt-xs=\"row\" layout-align-xs=\"start start\"><div layout=\"column\" \nlayout-align=\"center center\" layout-xs=\"row\" layout-align-xs=\"space-between\"><span>{{shipmentList.shipment_id}}</span> \n<span class=\"shipment-status text-truncate\" title=\"{{shipmentList.current_status.status}}\" \nng-style=\"vm.util.getStatusColor(shipmentList.current_status.color_code)\">{{shipmentList.current_status.status}}</span>\n</div></div><div flex layout=\"column\"><div class=\"bb pv-5 ph-0\" \nng-class=\"{\'ph-20\' : vm.util.isMobileDevice || vm.util.isMobileApp}\" layout=\"column\" layout-padding><port-traveller \ndetails=\"shipmentList\" class=\"traveller p-0 pt-10\" style=\"width: 100%\"></port-traveller></div><div layout=\"row\" \nlayout-wrap layout-padding class=\"pv-0\"><div layout=\"column\" class=\"pr-20\" ng-if=\"!vm.maskLiner\"><span class=\"title\">\nLiner</span> <span class=\"value text-truncate\" \ntitle=\"{{shipmentList.carrier_info.name == null || \'\' ? \'N/A\' : shipmentList.carrier_info.name}}\">\n{{shipmentList.carrier_info.name == null || \'\' ? \'N/A\' : shipmentList.carrier_info.name}}</span></div><div \nlayout=\"column\" class=\"pr-20\"><span class=\"title\">Mode</span> <span class=\"value text-truncate\" \ntitle=\"{{shipmentList.mode}}\">{{shipmentList.mode}}</span></div><div layout=\"column\" class=\"pr-20\"><span class=\"title\">\nLoad Details</span> <span class=\"value text-truncate\" ng-if=\"shipmentList.mode==\'SEA-FCL\'\">\n{{ vm.formContainerType(shipmentList.mode, shipmentList.load_data , \'shipment\', \'listPage\') }}<md-tooltip \nmd-direction=\"bottom\" class=\"font-size-12\">\n{{ vm.formContainerType(shipmentList.mode, shipmentList.load_data , \'shipment\') }}</md-tooltip></span><span \nclass=\"value text-truncate\" ng-if=\"shipmentList.mode!=\'SEA-FCL\'\"><span \nng-if=\"shipmentList.load_data.load_meta.chargeable_weight\">\n{{shipmentList.load_data.load_meta.chargeable_weight | currencyMask}} {{vm.util.chargeableUnit[shipmentList.mode]}}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-12\">\n{{shipmentList.load_data.load_meta.chargeable_weight | currencyMask}} {{vm.util.chargeableUnit[shipmentList.mode]}}\n</md-tooltip></span><span ng-if=\"!shipmentList.load_data.load_meta.chargeable_weight\">-</span></span></div><div \nlayout=\"column\" class=\"pr-20\"><span class=\"title\">Sailing Date</span> <span class=\"value text-truncate\" \ntitle=\"{{ shipmentList.departure_date ?  (shipmentList.departure_date | NoTimeZone : \'d MMM yyyy\') : \'N/A\' }}\">\n{{ shipmentList.departure_date ? (shipmentList.departure_date | NoTimeZone : \'d MMM yyyy\') : \'N/A\' }}</span></div><div \nlayout=\"column\" ng-if=\"shipmentList.shipper_user\" class=\"pr-20\"><span class=\"title\">Created On</span> <span \nclass=\"value text-truncate\" title=\"{{shipmentList.shipper_user.company.company_name}}\">\n{{shipmentList.shipper_user.company.company_name}}</span></div><div layout=\"column\"><span class=\"title\">\nBooking Specialist</span> <span class=\"value text-truncate\" \ntitle=\"{{vm.bindShipmentSpecialist(shipmentList.management)}}\">{{vm.bindShipmentSpecialist(shipmentList.management)}}\n</span></div><div layout=\"column\"><span class=\"title\">Customer</span> <span class=\"value text-truncate\" \ntitle=\"{{ shipmentList.parties[0].company_name }}\" ng-if=\"shipmentList.parties.length>0\"><span class=\"font-size-11\">\n{{ shipmentList.parties[0].company_name }}</span></span><div class=\"sub-heading\" ng-if=\"!shipmentList.parties.length\">\nN/A</div></div><div layout=\"column\"><span class=\"title\">Incoterms</span> <span class=\"value text-truncate\" \ntitle=\"{{shipmentList.incoterm}} {{shipmentList.impo_expo}}\"><div layout=\"row\"><div \nng-bind=\"shipmentList.incoterm ? shipmentList.incoterm : \'N/A\'\"></div><div \nng-if=\"shipmentList.impo_expo && shipmentList.incoterm\">- {{shipmentList.impo_expo}}</div></div></span></div><div \nlayout=\"column\"><span class=\"title\">Created By</span> <span class=\"value text-truncate\" \ntitle=\"{{ shipmentList.created_by.user_first_name }} {{ shipmentList.created_by.user_last_name }}\">\n{{ shipmentList.created_by.user_first_name }} <span class=\"font-size-11\">{{ shipmentList.created_by.user_last_name }}\n</span></span><div class=\"sub-heading\" ng-if=\"!shipmentList.created_by\">N/A</div></div><div layout=\"column\"><span \nclass=\"title\">External Reference</span> <span class=\"value text-truncate\" \ntitle=\"{{ shipmentList.parties[0].external_reference_id }} \">\n{{ shipmentList.parties[0].external_reference_id ? shipmentList.parties[0].external_reference_id : \'N/A\' }}</span>\n</div><div layout=\"column\" layout-align=\"center end\" flex ng-if=\"shipmentList.documents.length>0\"><div \nclass=\"attachment-sect\"><md-icon md-font-icon=\"icon-attachment\" class=\"attachment-icon s16\"></md-icon>\n{{shipmentList.documents.length}}</div></div><div layout=\"row\" flex layout-align=\"end center\" class=\"pl-15\"><div \nclass=\"tms-status border-staus mh-5\" title=\"{{shipmentList.tms_status}}\" \nng-if=\"shipmentList.tms_status && !vm.util.isShipper\"><span class=\"pb-8 pr-5\">{{shipmentList.tms_status}}</span></div>\n<div \nng-if=\"(vm.util.isFreightbro || (vm.util.isAdmin && vm.util.userProfile.user.role.name == \'ADMIN\')) && !shipmentList.is_deleted && vm.util.navPermission.shipments[3]\">\n<md-icon class=\"cursor m-10 red-600-fg s20\" md-font-icon=\"icon-delete\n                              \" \nng-click=\"vm.fnShowDeleteCard($event,shipmentList);\"></md-icon></div></div></div></div></div></md-content></div><div \nclass=\"sticky-bottom ph-40\" id=\"footer\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-betwee\n                n center\" ng-show=\"vm.selectedShipmentList.length\"><div \nclass=\"font-weight-600 font-size-18\">{{vm.selectedShipmentList.length}} <span><span \nng-if=\"vm.selectedShipmentList.length <=1\">Shipment</span> <span ng-if=\"vm.selectedShipmentList.length > 1\">Shipments\n</span> Selected</span></div><div><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"vm.clearAll(vm.selectedShipmentList)\" ng-disabled=\"vm.disabledDeleteBtn\">Clear All</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" ng-click=\"vm.deleteShipments(vm.selectedShipmentList)\" \nng-disabled=\"vm.disabledDeleteBtn\">Delete</md-button></div></div></div><div layout=\"column\" flex=\"100\" layout-wrap \nlayout-align=\"center center\" ng-if=\"vm.listLoader || vm.shipmentShimmer\" class=\"mv-20 pt-10\"><md-progress-circular>\n</md-progress-circular></div></div></div></div><div class=\"layout-styles\"><button \nclass=\"md-fab md-fab-bottom-right md-button white-bg scrollTopBtn hide pointer\" type=\"button\" \nng-click=\"vm.scrollTop();\" id=\"shipment-return-to-top\"><md-icon md-font-icon=\"icon-arrow-up\" role=\"img\" \nclass=\"s25 fg-AAA8AD\"></md-icon><md-tooltip md-direction=\"top\">Go to Top</md-tooltip></button></div></div>");
$templateCache.put("app/main/specialRates/specialRates.html","<div id=\"special-rates\"><div class=\"center\" flex><div layout=\"row\" layout-align=\"start center\" layout-wrap \nclass=\"pt-20\"><div class=\"pl-20\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"40\"><div \nclass=\"font-size-18 pb-8 freight-fg letter-spacing-0-5\">Special Rates</div></div><div class=\"ph-10\" layout=\"row\" \nlayout-align=\"end center\" flex=\"100\" flex-gt-xs=\"60\"><md-input-container class=\"m-0 font-size-14 fg-black w-220\" \nmd-no-float><md-select ng-model=\"vm.selectedLane\" placeholder=\"All Available Lanes Selected\" multiple=\"multiple\">\n<md-option ng-value=\"lane.lane_code\" ng-repeat=\"lane in vm.laneList track by $index\">{{lane.lane_name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap class=\"pt-20\" \nng-show=\"!filterspecialRates.length\"><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div \nclass=\"font-size-18 pb-8\">Data Not Available!</div></div></div><md-content ms-scroll id=\"specialRatesList\" \nclass=\"pl-10\"><div layout=\"row\" layout-align=\"start start\" layout-wrap \nng-repeat=\"specialRates in vm.sortedSpecialCard  | filterSpecialRatesCard : vm.selectedLane as filterspecialRates track by $index\" \nng-if=\"specialRates.ratesCard.length\"><div layout=\"row\" layout-align=\"start start\" flex=\"100\"><div \nclass=\"font-size-16 font-weight-600 pt-20 p-10\"><span>{{specialRates.lane.lane_name}}</span></div></div><div \nlayout=\"row\" class=\"specialRates\" layout-wrap><div class=\"mr-20\" layout=\"column\" \nng-repeat=\"ratesCard in specialRates.ratesCard track by $index\"><div \nclass=\"white-bg mb-20 w-320 border-radius-5 special-card\"><div layout=\"row\" flex=\"100\" class=\"border-bottom-979797\">\n<div class=\"font-size-14 p-10 fg-4a4a4a\" layout=\"row\" layout-align=\"start center\" flex><span>\n{{ratesCard.carrier_info.name}}</span></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"font-size-12 text-italic p-10 fg-2e2e2e\" flex>Expires: {{ratesCard.cardExpiry | UTCToLocal : \'d MMM yyyy\' }}\n</div></div><div layout=\"row\" flex=\"100\"><div class=\"font-size-14 pt-15 ph-10 pb-5 fg-4a4a4a\" layout=\"row\" \nlayout-align=\"start center\" flex><span><md-icon md-svg-src=\"assets/icons/custom/origin-port-icon-color.svg\" \nclass=\"icon-class\"></md-icon>{{ratesCard.origin_location.location}}<md-tooltip md-direction=\"top\">\n{{ratesCard.origin_location.location}}</md-tooltip></span></div><div class=\"font-size-14 pt-15 ph-10 pb-5 fg-4a4a4a\" \nlayout=\"row\" layout-align=\"end center\" flex><span><md-icon \nmd-svg-src=\"assets/icons/custom/destination-port-icon-color.svg\" class=\"icon-class\"></md-icon>\n{{ratesCard.destination_location.location}}<md-tooltip md-direction=\"top\">{{ratesCard.destination_location.location}}\n</md-tooltip></span></div></div><div layout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"30\" \nclass=\"font-size-12 pl-10\" flex><span class=\"fg-4a4a4a-05 text-truncate\">{{ratesCard.origin_location.location_string}}\n<md-tooltip md-direction=\"bottom\">{{ratesCard.origin_location.location_string}}</md-tooltip></span></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"horizontal-line mh-10\" flex></div><div layout=\"row\" \nlayout-align=\"end center\" flex=\"30\" class=\"font-size-12 pr-10\" flex><span class=\"fg-4a4a4a-05 text-truncate\">\n{{ratesCard.destination_location.location_string}}<md-tooltip md-direction=\"bottom\">\n{{ratesCard.destination_location.location_string}}</md-tooltip></span></div></div><div layout=\"row\" \nclass=\"black-fg total-bg pv-15 mt-5\"><div layout=\"column\" flex=\"10\" flex-gt-xs=\"10\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-chevron-left\" ng-click=\"vm.fnScrollBtn(\'child\',\'left\',$index)\" \nng-if=\"ratesCard.rates.length > 2\" class=\"s26 pointer grey-400-fg zoom\"></md-icon></div><div layout=\"column\" flex=\"80\" \nflex-gt-xs=\"80\" layout-align=\"start center\" layout-nowrap><div class=\"scroll_container\" \nng-class=\"\'scroll_container_\'+{{$index}}\"><md-button md-no-ink \nclass=\"mh-10 w-90 border-radius-5 bg-f8f8f8 border-e6e6e6\" ng-repeat=\"rates in ratesCard.rates track by $index\" \nng-class=\"{\'border-3649af fg-3649af bg-f8f8f8\' : (vm.cardIndex == ratesCard.lane_code+\'_\'+$parent.$index+\'_\'+$index)}\" \nng-disabled=\"vm.loadButton\" ng-click=\"vm.fnSpecialRateResult(ratesCard,rates,$parent.$index,$index)\"><div \nclass=\"font-size-12 fg-black font-weight-600 h-30 text-truncate\">\n{{rates.total_cost_currency}} {{rates.total_cost | currencyMask : 2}}<md-tooltip md-direction=\"top\">\n{{rates.total_cost_currency}} {{rates.total_cost | currencyMask : 2}}</md-tooltip></div><div \nclass=\"font-size-12 border-radius-10 border-d0d0d0 fg-4a4a4a-05 line-height-btn-text w-50 load-margin\" \nng-class=\"{\'border-3649af fg-3649af \' : (vm.cardIndex == ratesCard.lane_code+\'_\'+$parent.$parent.$index+\'_\'+$index)}\">\n{{rates.container_type}}</div></md-button></div></div><div layout=\"column\" flex=\"10\" flex-gt-xs=\"10\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-chevron-right\" ng-click=\"vm.fnScrollBtn(\'child\',\'right\',$index)\" \nng-if=\"ratesCard.rates.length > 2\" class=\"s26 pointer grey-400-fg zoom\"></md-icon></div></div></div></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/standard-quotation/standard-quotation.html","<div class=\"standard-quotation\"><iframe id=\"standard-quotation-iframe\" name=\"{{vm.todaysDate}}\" \nng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/tariff-management/tariffHeader.html","<div id=\"tariffHeader\"><iframe resize-handler id=\"tariff-management\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/track-n-trace/track-n-trace.html","<div id=\"track-n-trace\"><md-sidenav class=\"md-sidenav-right md-white-bg\" md-component-id=\"right\" \nmd-is-open=\"vm.isSidenavOpen\" ms-sidenav-helper ng-include=\"\'app/main/track-n-trace/filter-track/filter-track.html\'\">\n</md-sidenav><div class=\"pb-10\"><md-tabs md-dynamic-height md-border-bottom class=\"m-0\"><md-tab label=\"SEA\" \nmd-active=\"vm.seaTabActive\" ng-if=\"vm.util.navPermission.TRACK_SEA[1]\"><div class=\"p-0 sea-tab\"><div layout=\"row\" \nclass=\"page_title mv-20\" flex>Track and Trace</div><div class=\"search-div container-div mb-20\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><form id=\"seaTrackForm\" name=\"seaForm\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\" layout-align=\"start center\" flex=\"100\" ng-submit=\"vm.submitSeaTracking(vm.createTrackData)\"><div \nclass=\"left-sec\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" flex=\"80\" \nflex-sm=\"100\" flex-xs=\"100\"><div class=\"first-column\" flex=\"45\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"row\" \nlayout-xs=\"column\" class=\"b brad-5 p-0 mt-5\" ng-class=\"{\'disable-input\': vm.upload_document.name}\" \nlayout-align-xs=\"start\" flex=\"100\"><div layout=\"row\" class=\"pv-10 pl-15 pr-5 h-48\" layout-align=\"start center\" \nng-class=\"{\'border-red\': vm.selectLinerValidationError}\" flex=\"50\" flex-xs=\"100\"><md-icon \nmd-svg-icon=\"assets/icons/custom/boat-from-front-view.svg\" class=\"m-0\"></md-icon><md-select id=\"selectLiner\" \nclass=\"select-liner full-width pl-15 m-0\" name=\"filterLiner\" ng-model=\"vm.createTrackData.carrier_pref\" \nmd-on-close=\"selectLinersearchTerm=\'\'\" placeholder=\"Select Liner\" ng-change=\"vm.selectLinerValidationError = false\" \nng-model-options=\"{\n                                                    updateOn: \'default blur onchange\',\n                                                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                                  }\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"selectLinersearchTerm\" \nng-keydown=\"$event.stopPropagation()\" \nng-change=\"vm.fnTrackAnalytics(\'TT-SelectLiner-Search-Change\',{\'query\':selectLinersearchTerm})\" \nng-model-options=\"{\n                                                    updateOn: \'default blur onchange\',\n                                                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                                  }\" \ntype=\"search\" placeholder=\"Search for a liner..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"liners\"><md-option ng-value=\"liner\" \nng-repeat=\"liner in vm.subvendorList\n                                                    | filter:selectLinersearchTerm track by liner.id\">\n{{liner.carrier_name}}</md-option></md-optgroup></md-select></div><div layout=\"row\" layout-align=\"center center\" \nlayout-align-xs=\"space-between center\" flex class=\"ph-15 h-48 border-responsive\" flex=\"50\"><span \nclass=\"text-switch pr-10\" \nng-class=\"{\'active\':vm.createTrackData.sea_track_type==\'bl\', \'grey-fg\':vm.createTrackData.sea_track_type!=\'bl\'}\">BL NO.\n</span><md-switch md-no-ink ng-model=\"vm.createTrackData.sea_track_type\" aria-label=\"Switch 1\" class=\"m-0\" \nng-true-value=\"\'container\'\" \nng-change=\"vm.containerNumValidationError = false;vm.fnTrackAnalytics(\'TT-BL-Container-Toggle-Change\')\" \nng-false-value=\"\'bl\'\"></md-switch><span class=\"text-switch pl-10\" \nng-class=\"{\'active\':vm.createTrackData.sea_track_type==\'container\', \'grey-fg\':vm.createTrackData.sea_track_type!=\'container\'}\">\nCONTAINER</span></div></div><div ng-if=\"vm.selectLinerValidationError\" class=\"red-fg\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span>{{ vm.selectLinerValidationMsg }}\n</span></div><div layout=\"row\" flex=\"100\" flex-xs=\"100\" class=\"b brad-5 mt-10 h-48\" \nng-class=\"{\'disable-input\': vm.upload_document.name, \'red-400-border\': vm.containerNumValidationError}\"><div \nlayout=\"row\" flex class=\"m-0 p-0 h-48\" layout-align=\"start center\"><div class=\"pv-10 pl-15 pr-5\"><md-icon \nmd-svg-icon=\"assets/icons/custom/container-new.svg\" class=\"w-22 h-22\"></md-icon></div><md-input-container md-no-float \nclass=\"m-0 h-40 full-width pl-15\"><input type=\"text\" id=\"trackingNum\" class=\"border-none sea-container-input pt-6\" \nng-model=\"vm.createTrackData.trackingNum\" maxlength=\"30\" name=\"trackingNum\" \nplaceholder=\"{{ vm.createTrackData.sea_track_type === \'bl\' ? \'Enter BL Number\': \'Enter Container Number\' }}\" \nng-keyup=\"vm.containerNumValidationError=false;inputNumberType=vm.createTrackData.sea_track_type === \'bl\' ? \'BLNumber\': \'ContainerNumber\';vm.fnTrackAnalytics(\'TT-\'+inputNumberType+\'-Change\')\">\n</md-input-container></div></div><div ng-if=\"vm.containerNumValidationError\" class=\"red-fg\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span>{{ vm.containerNumValidationMsg }}\n</span></div><div layout=\"row\" layout-align=\"start\" flex-sm=\"100\" flex-xs=\"100\" class=\"mt-10\" id=\"infoText\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"info-icon\"></md-icon><div class=\"info-text\"><i \nclass=\"info-text font-weight-600\">\nPlease type {{ vm.createTrackData.sea_track_type === \'bl\' ? \'BL number\': \'container number\' }} carefully.</i>\n Once the request is sent, it might take upto 30 mins to retrieve the tracking status</div></div></div><div \nclass=\"wrapper\" ng-class=\"{\'hide\' : !vm.customScreen, \'show\' : vm.customScreen}\" flex=\"10\" flex-sm=\"100\" flex-xs=\"100\">\n<div class=\"line\"><div class=\"wordwrapper\"><div class=\"word\">OR</div></div></div></div><hr class=\"hr-text\" \ndata-content=\"OR\" ng-class=\"{\'show\' : !vm.customScreen, \'hide\' : vm.customScreen}\" flex=\"100\" flex-sm=\"10\" \nflex-xs=\"100\"><div class=\"second-column full-width\" flex=\"45\" flex-sm=\"100\" flex-xs=\"100\"><div \nclass=\"upload-container b brad-3 pt-10\" layout=\"column\" layout-align=\"center center\"><div class=\"upload-header\" \nlayout=\"column\" layout-align=\"center center\"><md-button md-no-ink ng-if=\"!vm.upload_document\" \nclass=\"md-link-btn h-35 with-icon w-150\" ng-click=\"vm.selectFile(\'uploadFile\')\" \nng-class=\"{\'btn-disable\': (vm.createTrackData.trackingNum)}\" ng-disabled=\"vm.createTrackData.trackingNum\" \nng-model=\"vm.upload_btn\"><md-icon class=\"s20\" md-font-icon=\"icon-cloud-upload\"></md-icon><span class=\"ml-10\">\nUpload File</span></md-button><input type=\"file\" id=\"uploadFile\" ngf-select ng-model=\"vm.upload_document\" \nname=\"upload_doc\" ng-change=\"vm.setFile();vm.fnTrackAnalytics(\'TT-UploadFile-Change\')\" ngf-max-size=\"2MB\" \nngf-pattern=\"\'.xlsx\'\" ngf-model-invalid=\"errorFile\" accept=\".xlsx\" hide \nng-model-options=\"{\n                                                    updateOn: \'default blur onchange\',\n                                                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                                  }\">\n<div ng-if=\"vm.upload_document\"><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"font-weight-600 text-truncate max-width-120\">{{ vm.upload_document.name }}</span> <span \nng-click=\"vm.upload_document = null;vm.trackBtn=false;vm.fnTrackAnalytics(\'TT-UploadFile-Cancel-Click\')\" \nng-show=\"vm.upload_document\" class=\"grey-fg pointer cancel_icon mh-5 mv-3 h-20 w-15 text-center\">x</span></div></div>\n<md-list layout=\"row\" class=\"p-0 mt-10\"><md-list-item class=\"m-0 p-0\"><md-icon class=\"grey-fg icon bullet-icon\" \nmd-font-icon=\"icon-checkbox-blank-circle\" aria-label=\"icon-checkbox-blank-circle\"></md-icon><p class=\"m-0 grey-fg\">\nMax. file size is <b class=\"grey-fg\">2MB</b></p></md-list-item><md-list-item class=\"m-0 p-0\"><md-icon \nclass=\"grey-fg icon bullet-icon\" md-font-icon=\"icon-checkbox-blank-circle\" aria-label=\"icon-checkbox-blank-circle\">\n</md-icon><p class=\"grey-fg m-0\">.xlsx file format accepted</p></md-list-item></md-list></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"upload-footer bt\"><a class=\"pointer\" ng-click=\"vm.viewSampleFile();\" \ntarget=\"_blank\" style=\"text-decoration: none\" rel=\"noopener\"><md-icon class=\"md-link-fg mr-5 icon view-icon\" \nmd-font-icon=\"icon-eye\" aria-label=\"icon-eye\"></md-icon><span class=\"font-size-12 font-weight-700 md-link-fg\">\nView Sample Document</span></a></div></div></div></div><div class=\"right-sec\" ng-class=\"{\'mt-30\' : !vm.customScreen}\" \nlayout=\"row\" layout-align=\"center center\" layout-align-xl=\"start center\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\">\n<md-button md-no-ink class=\"md-accent-btn\" ng-class=\"{\'mt-20\': vm.util.isMobileDevice || vm.util.isMobileApp}\" \ntype=\"submit\" id=\"trackBtn\" ng-disabled=\"vm.trackBtn\">Track</md-button></div></form></div><div \nclass=\"refresh-container mt-20\" layout=\"row\" layout-align=\"end center\" flex=\"100\"><div \nclass=\"font-size-18 font-weight-700\" flex>Recently Tracked</div><div class=\"pointer md-primary-fg\" layout=\"row\" \nlayout-align=\"end start\" flex><md-button md-no-ink ng-click=\"vm.applySeaFilter(\'refresh\');\" \nclass=\"md-link-btn with-icon\"><md-icon md-font-icon=\"icon-sync\" class=\"s16\" ng-class=\"{\'fa-spin\': vm.spinRefreshIcon}\">\n</md-icon><span class=\"pl-5\"><b>Refresh</b></span></md-button></div></div><div shimmer-effect-full width=\"100%\" \nheight=\"30px\" mh=\"10px\" class=\"mv-20\" ng-show=\"vm.isSeaDataLoading\"></div><div class=\"content mt-10\" \nng-show=\"!vm.isSeaDataLoading\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"right-sec-table\" layout=\"row\" \nlayout-align=\"center center\"><md-button md-no-ink type=\"button\" class=\"md-primary-btn with-icon\" \nng-click=\"vm.downloadFile()\" layout=\"row\" layout-align=\"center center\" ng-model=\"vm.seaFilterData.is_file\" \nng-if=\"vm.containerListData\"><md-icon class=\"s16 m-5\" md-font-icon=\"icon-download\"></md-icon><span>Export</span>\n</md-button><md-button md-no-ink type=\"button\" class=\"md-primary-btn with-icon\" ng-click=\"vm.openFilter()\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-filter\" class=\"s16\"></md-icon><span>Filter By\n</span></md-button></div><table class=\"dataTable row-border hover\" id=\"container_table\" datatable=\"\" \ndt-options=\"vm.dtSeaOptions\" dt-columns=\"vm.dtSeaColumns\" dt-instance=\"vm.dtSeaInstanceCallback\"></table></div></div>\n</div></md-tab></md-tabs></div><div class=\"sticky-bottom ph-40\" id=\"footer\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\" ng-if=\"vm.selectedShipmentList.length && vm.activeTab  === \'DASHBOARD\'\"><div \nclass=\"md-primary-fg font-weight-600 font-size-18\"><span class=\"grey-fg\">You have selected</span> <span \nclass=\"selectedTrackCount\">{{vm.selectedShipmentList.length}}</span> <span class=\"font-weight-600 md-primary-fg\" \nng-if=\"vm.selectedShipmentList.length == 1\">Shipment</span></div></div></div>");
$templateCache.put("app/main/upload-rates/upload-rates.html","<div id=\"upload-rates\"><iframe id=\"upload-rates-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/upload-rates-v2/uploadRatesV2.html","<div id=\"uploadRatesV2\"><iframe id=\"upload-rates-v2\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" width=\"100%\" \nheight=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal \nmd-theme=\"{{$root.domainData.domain_info.THEME_CONFIG.dark_mode? \'custom-dark\' : \'\'}}\"></ms-navigation-horizontal>\n</div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.util.isMobileApp\"><h1>FreightBro</h1></div><md-icon \nclass=\"fold-toggle w-25 h-25\" md-svg-src=\"assets/icons/custom/menu-icon.svg\" hide show-gt-sm></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation><div \nlayout=\"column\" layout-align=\"center center\" \nng-if=\"$root.domainData.domain_info.POWERED_BY.logo_transparent && vm.util.activatedTheme === \'transpost\'\"><div \nclass=\"powered_by\"><md-divider class=\"mb-8 white-border opacity-78\"></md-divider><div \nclass=\"font-size-8 white-fg text-center pb-5 opacity-78\">Powered By</div><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.POWERED_BY.text_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img \nng-src=\"{{ vm.util.sanitizeQueryParams($root.domainData.domain_info.POWERED_BY.logo_transparent) }}\" width=\"55px\" \nclass=\"pointer\"></a></div></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/Inquiry/Dialogs/inquryLostModal.html","<md-dialog id=\"inquiry-lost\" class=\"popup-sm\" ng-cloak><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nflex=\"90\" flex-xs=\"90\" class=\"p-0\">Lost</div><div layout=\"row\" class=\"p-0\" layout-align=\"end end\" flex=\"10\" \nflex-xs=\"10\" class=\"icon_size\"><md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div><form name=\"lostInquiry_form\" \nng-submit=\"ctrl.parent.fnLostInquiry(lostInquiry_form)\"><md-dialog-content class=\"body\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\">Write a comment for this status change</div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"pt-5 pb-5\"><md-input-container md-no-float class=\"height-container inputwidth100\">\n<textarea name=\"comment\" ng-model=\"ctrl.parent.lostReason\" ng-keyup=\"ctrl.parent.lostValidation=false\" \nng-class=\"{\'validation-error\':ctrl.parent.lostValidation}\" md-maxlength=\"180\" class=\"border text-container\" \nplaceholder=\"Enter the reason for marking as Lost…\" ng-change=\"ctrl.parent.trackEvent(\'InqDetLostReason\');\" rows=\"3\" \nmax-rows=\"6\"></textarea><div ng-messages=\"lostInquiry_form.comment.$error\"><div ng-message=\"md-maxlength\">\nThat\'s too long!!</div></div><div ng-if=\"ctrl.parent.lostValidation\" class=\"validation-error-text\"><span>\nEnter the reason to Lost</span></div><div layout=\"row\" layout-align=\"center center\" flex flex-xs=\"100\"></div>\n</md-input-container></div><div layout=\"row\" flex=\"100\" layout-align=\"start center\" flex flex-xs=\"100\" class=\"pt-10\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s16 m-0\"></md-icon><div \nclass=\"pl-5 fg-AAA8AD font-weight-600 font-size-11\">Note - Inquiry will be marked \"LOST\" this cannot be undone</div>\n</div></md-dialog-content><md-dialog-actions class=\"footer\"><div class=\"white-bg mv-10\" layout=\"row\" hide show-xs>\n<md-button md-no-ink class=\"md-primary-btn mr-10\" title=\"Cancel\" ng-click=\"ctrl.parent.closeDialog(\'lost\')\">No\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" \nng-disabled=\"ctrl.parent.lostBtn\">Yes</md-button></div><div layout=\"row\" hide-xs class=\"mv-10\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" title=\"Cancel\" ng-click=\"ctrl.parent.closeDialog(\'lost\')\">No</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" ng-disabled=\"ctrl.parent.lostBtn\">Yes</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Inquiry/inquiryDetails/inquiryDetails.html","<div id=\"inquiry-details\"><div class=\"details\"><div class=\"mv-20\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between end\" layout-align-xs=\"space-between start\" flex=\"100\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"font-size-12 md-link-fg ml-30 pointer\" ng-click=\"vm.goBack()\" \nng-if=\"!vm.isWebView\">Enquiries /</div><div layout=\"row\"><div ng-click=\"vm.goBack()\" ng-if=\"!vm.isWebView\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"mr-5 mt-5 pointer\"></md-icon></div><div \nng-bind=\"vm.inquiryDetails.inquiry_number\" class=\"page_title\"></div><div><div class=\"status_meta_div\" \nng-bind=\"vm.inquiryDetails.current_status.status\" \nng-style=\"vm.util.getStatusColor(vm.inquiryDetails.current_status.color_code)\"></div></div></div></div><div \nlayout=\"row\" layout-padding class=\"p-0\" layout-wrap><md-button md-no-ink \nclass=\"md-primary-btn with-img-icon hide mb-0\" layout=\"row\" layout-align=\"center center\" \nng-if=\"(vm.inquiryDetails.current_status.status == \'Rates available\') && (!util.userProfile.user.is_pricing_user) && (vm.util.solution_type === \'WLS\')\" \nng-click=\"vm.fnOpenVASModal($event)\" ng-disabled=\"!vm.responseTrue\"><md-icon class=\"w-15 h-15 mr-5 m-0\" \nmd-svg-icon=\"assets/icons/custom/VAS.svg\"></md-icon>VAS Charges</md-button><download-pdf class=\"p-0\" \nquoteid=\"vm.inquiryDetails.quote_id\" \nng-if=\"vm.inquiryDetails.current_status.status == \'Quoted\' && !vm.util.userProfile.user.is_pricing_user\" \nresult_type=\"vm.resultType\" mode=\"vm.search_param.mode\"></download-pdf><md-button md-no-ink \nclass=\"md-primary-btn with-img-icon mb-0\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.util.userProfile.user.is_pricing_user && vm.inquiryDetails.current_status.status != vm.statusCondition\" \nng-hide=\"vm.freezInquiry\" ng-click=\"vm.fnOpenMatchRatesModal($event)\"><span><md-icon class=\"w-15 h-15 mr-5 m-0\" \nmd-svg-icon=\"assets/icons/custom/RBR.svg\"></md-icon>\n{{(vm.util.solution_type === \'WLS\' && vm.util.isAdmin) ? \'Request Better Rates\' : \'Match Rates\'}}</span></md-button>\n<md-button md-no-ink class=\"md-primary-btn with-icon mb-0\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.inquiryRefreash()\"><md-icon class=\"mr-5 s16 m-0\" md-font-icon=\"icon-refresh\" \nng-class=\"{\'fa-spin\': vm.spinRefreshIcon}\"></md-icon>Refresh</md-button><md-button md-no-ink \nclass=\"md-primary-btn with-checkbox mb-0\" ng-hide=\"vm.freezInquiry\"><md-checkbox md-no-ink class=\"m-0 md-primary\" \nlayout=\"row\" layout-align=\"center center\" ng-model=\"vm.inquiryLost\" ng-change=\"vm.fnMakeInquiryLost($event)\" \nng-disabled=\"vm.freezInquiry\" ng-true-value=\"true\" ng-false-value=\"false\">Mark as Lost</md-checkbox></md-button></div>\n</div><inquiry-meta-component metadetail=\"vm.inquiryDetails\" search-param=\"vm.search_param\"></inquiry-meta-component>\n<div class=\"white-bg card_shadow mt-15 empty_rates\" ng-if=\"vm.displayGoBackDiv\"><div layout=\"row\" \nlayout-align=\"center center\" layout-xs=\"column\"><div><img src=\"assets/icons/custom/analyze_finance.png\" \nclass=\"w-120 h-90 rfq_icon\"></div><div class=\"ml-20 pt-5\"><div class=\"fg-333333 font-size-18 font-weight-600\">\nWe’ve Got Your Back !</div><div class=\"font-size-12 grey-400-fg font-weight-600\">\nOur Pricing Team will get back to you at the earliest</div><div class=\"mt-15 grey-400-fg font-weight-600 font-size-10\">\nPS : You will be notified once the rates are updated</div></div></div></div><div class=\"white-bg card_shadow mt-20\" \nng-if=\"vm.displayAddRatesDiv && vm.responseTrue && vm.search_param.freight_charges\"><div class=\"new_card_div ml-5\" \nlayout=\"row\" layout-wrap><ms-widget layout=\"column\" flex class=\"custom-rate-card rate_card mr-10 mb-5\" flex-gt-md=\"25\">\n<new-card-view class=\"white-bg card_shadow\" searchparam=\"vm.search_param\" carddata=\"card_item\" \nresultfilter=\"vm.resultCardFilter\" inquiryid=\"vm.inquiryDetails\" callback=\"vm.showQuoteProceedDiv(card)\">\n</new-card-view></ms-widget><ms-widget layout=\"column\" flex class=\"w-320 mr-10 mb-10\" ng-if=\"vm.newCardArray.length\" \nng-repeat=\"card_item in vm.newCardArray track by $index\"><inquiry-card-view class=\"white-bg box_shadow\" \nsearchparam=\"vm.search_param\" carddata=\"card_item\" resultfilter=\"vm.resultCardFilter\" pricingiscopy=\"false\" \ninquiryid=\"vm.inquiryDetails\" activity-id=\"vm.newCardArray[$index]._id\" \ninquiryactivityid=\"vm.inquiryDetails.activity._id\" co2e-response=\"ctrl.parent.co2eResponse\" \ncallback=\"vm.showQuoteProceedDiv(card)\"></inquiry-card-view></ms-widget><div layout=\"row\" layout-align=\"start end\" \nflex hide-xs ng-if=\"!vm.newCardArray.length\"><img src=\"assets/icons/custom/Illustration.png\"></div></div><div \nclass=\"bt ph-20 pv-10 font-size-12\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\">Total Cards <span class=\"card_count ml-5\">\n{{vm.newCardArray.length ? (vm.newCardArray.length) : \'00\'}}</span></div><div class=\"grey-400-fg\" \nng-if=\"!vm.newCardArray.length\">NOTE : Tap on <b>“Add Rates”</b> for adding new rates to the Inquiry</div><md-button \nmd-no-ink class=\"md-accent-btn with-icon\" ng-if=\"vm.newCardArray.length\" ng-click=\"vm.fnConfirmSendCard($event)\" \nng-disabled=\"vm.resultCardFilter.sendRatesBtn\"><md-icon md-font-icon=\"icon-send\" class=\"white-fg s20 send_rates\">\n</md-icon>Send Rates</md-button></div></div><div ng-repeat=\"iteration in vm.inquiryIterations track by $index\" \nng-init=\"outerIndex=$index\" class=\"mv-30\"><div shimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" \nng-if=\"iteration.view == undefined\" ng-repeat=\"shimmer in [1,2]\"></div><div \nclass=\"iteration_shadow white-bg ph-20 mv-15\" ng-if=\"iteration.view != undefined\"><div layout=\"row\" \nclass=\"iteration_padding\" layout-align=\"space-between\" ng-class=\"{\'dotted_bb\' : iteration.view }\"><div \nclass=\"font-weight-600 font-size-12\" layout=\"row\"><div><ng-avatar string=\"{{iteration.data.user.user_first_name}}\" \nfont-weight=\"500\" width=\"20\" round-shape=\"true\" bg-color=\"#dfe2f3\" text-color=\"#3549af\"></ng-avatar></div><div \nclass=\"pt-2 pl-8\"><span>{{ iteration.data.user.user_first_name }} {{ iteration.data.user.user_last_name }}</span> <span\n ng-if=\"iteration.data.activity_type != \'LOST\'\" class=\"grey-400-fg pr-5\">{{ iteration.data.message }} </span><span \nng-if=\"iteration.data.activity_type == \'LOST\'\"><span class=\"grey-400-fg pr-5\">has marked this Inquiry </span><span \nclass=\"red-fg\">LOST</span></span></div></div><div class=\"text-truncate font-size-12 font-weight-600 w-400\" flex=\"40\" \nng-if=\"iteration.data.activity_type == \'LOST\' && iteration.data.comment\"><span class=\"grey-400-fg\">Reason <span \nclass=\"grey-700-fg pl-10\" title=\"{{iteration.data.comment}}\">{{iteration.data.comment}}</span></span></div><div \nclass=\"font-size-12 font-weight-600 pt-2\"><span class=\"pointer md-link-btn\" \nng-click=\"vm.collapseIt(($index + \'_iteration\'),iteration, $event)\" ng-if=\"iteration.data.cards.length\">\n{{!iteration.view ? \'View\' : \'Hide\'}} Rates</span><md-icon md-font-icon=\"icon-clock\" class=\"s16 mr-5 mb-4\"></md-icon>\n{{iteration.data.timestamp | UTCToLocal : \'d MMM yyyy\'}}<md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s6 mb-2 mh-5\"></md-icon>{{iteration.data.timestamp | UTCToLocal : \'hh:mm a\'}}</div></div><div \nid=\"{{$index + \'_iteration\'}}\" class=\"font-size-12\" \nng-class=\"{\'hide-at-start\' : (outerIndex != 0 && (iteration.data.activity_type != \'MMR\' && iteration.data.activity_type != \'RFQ\' && iteration.data.activity_type != \'BETTER_RATE\')) }\">\n<div layout=\"row\" layout-wrap ng-if=\"iteration.data.cards.length\" class=\"iteration_padding\"><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"30\" flex-gt-md=\"25\" class=\"w-320\" \nng-repeat=\"card_item in iteration.data.cards track by $index\"><inquiry-card-view class=\"white-bg box_shadow\" \nsearchparam=\"vm.search_param\" carddata=\"card_item\" resultfilter=\"vm.resultCardFilter\" islastactivity=\"outerIndex == 0\" \nactivitytype=\"iteration.data.activity_type\" inquiryid=\"vm.inquiryDetails\" pricingiscopy=\"vm.displayAddRatesDiv\" \nco2e-response=\"ctrl.parent.co2eResponse\" callback=\"vm.showQuoteProceedDiv(card)\" \nng-style=\"{ \'border\' : (outerIndex == 0 && (card_item.meta.is_selected || card_item.meta.is_booked))  ? \'1px solid rgb(66, 165, 245)\' : \'collapse\' }\" \nactivity-id=\"iteration.data._id\" inquiryactivityid=\"vm.inquiryDetails.activity._id\"></inquiry-card-view></ms-widget>\n</div><div layout=\"row\" layout-wrap class=\"font-size-12 font-weight-600 iteration_padding\" layout-wrap \nng-if=\"iteration.data.activity_type == \'MMR\' || iteration.data.activity_type == \'RFQ\' || iteration.data.activity_type == \'BETTER_RATE\'\">\n<div class=\"text-truncate mr-30\" ng-if=\"vm.inquiryDetails.search_data.mode == \'SEA-FCL\'\"><span \nclass=\"grey-400-fg pr-5\">Preferred Liner</span> <span \ntitle=\"{{ vm.fnCarrierName(iteration.data.meta.carrier_preference) }}\">\n{{ vm.fnCarrierName(iteration.data.meta.carrier_preference) }}</span></div><div class=\"text-truncate mr-30\" \nng-if=\"vm.inquiryDetails.search_data.mode == \'AIR\'\"><span class=\"grey-400-fg pr-5\">Preferred Airlines </span><span \ntitle=\"{{ vm.fnCarrierName(iteration.data.meta.airline_preference) }}\">\n{{ vm.fnCarrierName(iteration.data.meta.airline_preference) }}</span></div><div class=\"mr-30\"><span \nclass=\"grey-400-fg\">Expected Rate</span> <span \nng-repeat=\"load in iteration.data.meta.target_load_data.load_details_value track by $index\" class=\"ph-5\" \nng-if=\"vm.inquiryDetails.search_data.mode == \'SEA-FCL\'\"><span ng-if=\"load.target_rate\"><span class=\"md-primary-fg\">\n{{load.target_rate_currency}} {{load.target_rate | currencyMask : 2}} </span>| {{load.type}} </span><span \nng-if=\"!load.target_rate\" ng-show=\"$first\">- </span></span><span class=\"ph-5\" \nng-if=\"vm.inquiryDetails.search_data.mode != \'SEA-FCL\'\"><span \nng-if=\"iteration.data.meta.target_load_data.load_meta.target_rate\"><span class=\"md-primary-fg\">\n{{iteration.data.meta.target_load_data.load_meta.target_rate_currency}} {{iteration.data.meta.target_load_data.load_meta.target_rate | currencyMask : 2}} \n</span>\n| {{ (iteration.data.meta.target_load_data.load_meta.target_rate_basis == \'per_W/M\') ? \'per W/M\' : (iteration.data.meta.target_load_data.load_meta.target_rate_basis == \'per_KGs\' ? \'per KGs\' : \'-\' ) }} \n</span><span ng-if=\"!iteration.data.meta.target_load_data.load_meta.target_rate\">-</span></span></div><div \nng-if=\"iteration.data.meta.reason_for_revising\" class=\"w-400 text-truncate\"><span class=\"grey-400-fg\">Reason </span>\n<span class=\"grey-700-fg pl-10\" title=\"{{iteration.data.meta.reason_for_revising}}\">\n{{iteration.data.meta.reason_for_revising}}</span></div><div layout=\"row\" layout-align=\"end start\" flex><span \nclass=\"grey-400-fg pr-20\">Sailing Date</span> <span>\n{{ iteration.data.meta.preferred_sailing_date ? (iteration.data.meta.preferred_sailing_date | UTCToLocal : \'d MMM yyyy\') : \'N/A\' }}\n</span></div></div></div></div></div><div class=\"white-bg iteration_shadow\" hide><div layout=\"row\" \nclass=\"iteration_padding ph-20\" layout-align=\"space-between\" ng-class=\"{\'dotted_bb\' : iteration.view }\"><div \nclass=\"font-weight-600 font-size-12\" layout=\"row\"><div><ng-avatar string=\"Ayush\" font-weight=\"500\" width=\"20\" \nround-shape=\"true\" bg-color=\"#dfe2f3\" text-color=\"#3549af\"></ng-avatar></div><div class=\"pt-2 pl-8\"><span>Ayush S\n</span> <span class=\"grey-400-fg pr-5\">has marked this Inquiry </span><span class=\"red-fg\">LOST</span></div></div><div \nclass=\"text-truncate font-size-12 font-weight-600\" flex=\"40\"><span class=\"grey-400-fg\">Reason <span \nclass=\"grey-700-fg pl-10\" \ntitle=\"Customer not happy with the rates Customer not happy with the rates Customer not happy with the rates Customer not happy with the rates\">\nCustomer not happy with the rates Customer not happy with the rates Customer not happy with the rates Customer not happy with the rates\n</span></span></div><div class=\"md-primary-fg font-size-12 font-weight-600 pt-2\"><md-icon md-font-icon=\"icon-clock\" \nclass=\"md-primary-fg s16 mr-5 mb-4\"></md-icon>02 May 2019<md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s6 md-primary-fg mb-2 mr-5\"></md-icon>09.30AM</div></div></div></div><div class=\"footer-content z-index-0 h-60\" \nlayout=\"row\" layout-align=\"center center\" \nng-if=\"vm.inquiryDetails.quote_number && !vm.inquiryDetails.shipment_number && vm.inquiryDetails.current_status.status != \'Booking Placed\'\">\n<p><span>This Inquiry has been used to create Quote <a class=\"md-link-fg pointer\" ng-click=\"vm.goToQuoteDetail()\">\n{{vm.inquiryDetails.quote_number}}</a></span></p></div><div class=\"footer-content z-index-0 h-60\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.inquiryDetails.shipment_number\"><p><span>\nThis Inquiry has been used to place a Booking <a class=\"md-link-fg pointer\" ng-click=\"vm.goToShipmentDetail()\">\n{{vm.inquiryDetails.shipment_number}}</a></span></p></div><div class=\"footer-content z-index-0 h-60\" layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"vm.inquiryDetails.current_status.status == \'Booking Placed\' && !vm.inquiryDetails.shipment_number\"><p><span>\nThis Inquiry has been used in Quote that is manually converted to won</span></p></div><div \nclass=\"bg-535353 ph-40 z-index-10\" id=\"shared-footer-quote\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\" ng-if=\"vm.quoteArray.length && vm.inquiryDetails.quote_id\"><div layout=\"row\" \nlayout-align=\"start center\" flex-xs=\"100\" flex-sm=\"50\" flex=\"40\" class=\"font-size-14 white-fg pv-5\"><b class=\"pr-5\">\nQuote #{{vm.inquiryDetails.quote_number}}</b> will be modified</div><div layout=\"row\" flex-xs=\"100\" flex-sm=\"50\" \nflex=\"35\" layout-align=\" start center\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"font-weight-600 grey-600-fg white-fg pr-20\"><div layout=\"row\" class=\"mr-5 white-fg font-size-14\">Revision :\n</div><div class=\"pr-20 pl-10 font-size-13\">No</div><md-switch md-no-ink id=\"revise-toggle\" ng-model=\"vm.revise_quote\">\n</md-switch><div class=\"pl-20 font-size-13\">Yes</div></div><div layout=\"column\" \nclass=\"font-weight-600 pl-20 version-box\" ng-show=\"vm.revise_quote\"><div flex layout-align=\"start center\" \nclass=\"mr-5 white-fg font-size-14\">After Revision</div><div flex layout-align=\"start center\" class=\"mr-5 font-size-16\">\n<span class=\"fb-979797\">v{{vm.getQuoteVersion(vm.inquiryDetails.quote_number)}} ----</span> <span class=\"white-fg\">\nv{{vm.nextVersionChar(vm.getQuoteVersion(vm.inquiryDetails.quote_number))}}</span></div></div></div><div layout=\"row\" \nflex-xs=\"100\" flex-sm=\"100\" flex=\"25\" layout-align=\"end end\" class=\"w-250\"><md-button md-no-ink class=\"md-primary-btn\" \nng-disabled=\"vm.modifyBtn\" ng-click=\"vm.fnUndoChanges()\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn\" \nng-disabled=\"vm.modifyBtn\" ng-click=\"vm.fnQuoteModify()\">Apply</md-button></div></div><div class=\"footer-content\" \nng-if=\"!vm.inquiryDetails.quote_id && vm.quoteArray.length\"><div class=\"card_shadow\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\" layout-wrap><div flex=\"30\" layout=\"row\" layout-align=\"start start\" flex-xs=\"100\" class=\"pt-10 ml-15\"><div \nclass=\"added-quote-count\">{{vm.quoteArray.length}}</div><p class=\"pl-10 font-size-14 font-weight-600\">\nRate Card Added To Quote</p></div><div flex layout=\"row\" layout-align=\"end start\" flex-xs=\"100\" layout-wrap><md-button \nmd-no-ink class=\"md-accent-btn m-10 ph-10 w-150 pv-5\" title=\"Provide Quote Details\" \nng-disabled=\"vm.resultCardFilter.generateQuoteBtn\" ng-click=\"vm.generateQuoteModal($event)\">Provide Quote Details\n</md-button></div></div></div></div></div>");
$templateCache.put("app/main/RateProvider/dialogs/addRateProvider.html","<md-dialog id=\"add-vendor-provider\"><md-toolbar class=\"modal_title\"><div class=\"md-toolbar-tools\"><h2>Add Rate provider\n</h2><span flex></span><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><form \nname=\"provider_Form\"><div layout=\"row\"><div flex=\"30\" class=\"font-weight-600\">Select Vendor :<span class=\"red-500-fg\">*\n</span></div><div flex><md-input-container md-no-float class=\"selectbox\"><md-select \nng-model=\"ctrl.parent.providerData.vendor_id\" class=\"m-0 select_box\" placeholder=\"Select Vendor\" name=\"vendor_id\" \nng-change=\"ctrl.parent.fnValidateVendor(ctrl.parent.providerData.vendor_id)\" required><md-option \nng-repeat=\"vendor in ctrl.parent.vendorData track by $index\" ng-value=\"vendor.id\">{{vendor.name}}</md-option>\n</md-select><div ng-messages=\"provider_Form.vendor_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSelect Vendor</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"mt-5\"><div flex=\"30\" \nclass=\"pt-10 font-weight-600\">Margin :</div><div flex><md-input-container md-no-float class=\"m-0\"><input \nng-model=\"ctrl.parent.providerData.margin\" step=\"any\" type=\"number\" placeholder=\"Enter Margin\"></md-input-container>\n</div></div><div layout=\"column\" layout-align=\"end end\" class=\"mr-15\"><md-button md-no-ink type=\"submit\" \nclass=\"md-accent-btn\" ng-disabled=\"provider_Form.$invalid\" \nng-click=\"ctrl.parent.fnSubmitProviderData(ctrl.parent.providerData)\">Submit</md-button></div></form></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/RateProvider/dialogs/editConversionRate.html","<md-dialog id=\"edit-rate\"><md-toolbar class=\"modal_title\"><div class=\"md-toolbar-tools\"><h2>\nCustom Currency Conversion Rate</h2><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\" layout-align=\"end end\" class=\"mr-15\"><md-button md-no-ink \nclass=\"add_button border\" ng-click=\"ctrl.parent.addCurrency()\">+ Add Currency</md-button></div><div layout=\"column\" \nclass=\"pb-5 ml-30 font-weight-600 font-size-14\">Base Currency: {{ctrl.parent.baseCurrency}}*</div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"pt-20\" \nng-if=\"(ctrl.parent.currencyRates.custom_currency_rates == null) || (ctrl.parent.currencyRates.custom_currency_rates.length <= 0)\">\n<div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div class=\"font-size-18 pb-8\">Data Not Available!</div>\n</div></div><form name=\"customCurrFrom\"><div class=\"simple-table-container m-25\" \nng-if=\"ctrl.parent.currencyRates.custom_currency_rates.length > 0\"><div class=\"white-bg md-whiteframe-4dp rate_table\">\n<table class=\"simple text-center\" ms-responsive-table><thead><tr><th class=\"border-right\"><div class=\"table-header\">\n<span class=\"file_heading\">Currency</span></div></th><th class=\"border-right\"><div class=\"table-header\"><span \nclass=\"file_heading\">Rates</span></div></th><th><div class=\"table-header\"><span class=\"file_heading\">Action</span>\n</div></th></tr></thead><tbody><tr \nng-repeat=\"currencyData in ctrl.parent.currencyRates.custom_currency_rates track by $index\"><td class=\"border-right\">\n<md-input-container md-no-float class=\"selectbox\"><md-select ng-model=\"currencyData.currency_code\" \nname=\"currency_code\" class=\"m-0 select_box\" placeholder=\"Select Currency\" ng-change=\"ctrl.parent.currencyChange()\" \nrequired><md-option ng-repeat=\"currency in ctrl.parent.currencyList track by $index\" ng-value=\"currency\">{{currency}}\n</md-option></md-select></md-input-container></td><td class=\"border-right\"><md-input-container md-no-float><input \nng-model=\"currencyData.rate\" name=\"rate\" type=\"number\" min=\"0\" placeholder=\"Rate\" required></md-input-container></td>\n<td><md-icon class=\"cursor\" md-font-icon=\"icon-minus-circle\" title=\"Delete\" \nng-click=\"ctrl.parent.removeCurrency(currencyData)\"></md-icon></td></tr></tbody></table></div></div><div \nlayout=\"column\" layout-align=\"end end\" class=\"pt-15 mr-15\"><md-button md-no-ink class=\"md-accent-btn\" \nng-click=\"ctrl.parent.fnSubmitCurrency(ctrl.parent.currencyRates)\" ng-disabled=\"customCurrFrom.$invalid\">Submit\n</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analytics/dashboard/dashboard.html","<div id=\"dashboard-page\"><iframe id=\"dashboard\" ng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" \nstyle=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/analytics/reports/reports.html","<div id=\"dashboard-page\"><md-tabs md-dynamic-height md-border-bottom id=\"dashboard-tabs\" class=\"pt-20\" \nng-if=\"(vm.util.activatedTheme !== \'transpost\' || (vm.util.activatedTheme === \'transpost\' && vm.util.isAdmin))\"><md-tab\n ng-repeat=\"report in vm.reportTabArray track by $index\" md-on-select=\"vm.trackMixpanel(\'Dash-\'+report.name, report);\">\n<md-tab-label><div layout=\"column\"><div class=\"font-size-14\">{{report.name}}</div></div></md-tab-label><md-tab-body>\n<div ng-if=\"report.isLoaded\"><div id=\"prices_container\"><div ng-if=\"vm.lastUpdateUrl\" class=\"refresh-container mt-20\" \nlayout=\"row\" layout-align=\"end center\" flex=\"100\"><span class=\"grey-600-fg font-size-10 last-update\">\nLast Updated at {{vm.lastUpdateUrl}}</span><span class=\"font-size-16 grey-600-fg ph-5\">|</span><md-button \nng-disabled=\"vm.isLoading\" md-no-ink ng-click=\"vm.getAnalyticsUrl(\'refresh\',report.external_report_id,report.url)\" \nclass=\"md-primary-btn with-img-icon\"><md-icon md-svg-icon=\"assets/icons/custom/refresh.svg\" \nng-class=\"{\'fa-spin\': vm.spinRefreshIcon}\" class=\"refresh-icon\"></md-icon><span class=\"font-size-12 pl-5\"><b>Refresh\n</b></span></md-button></div><div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" \nng-if=\"vm.isLoading\" class=\"pt-10\"><md-progress-circular></md-progress-circular></div><div><iframe \nid=\"{{\'metabase-iframe-\'+report.external_report_id}}\" src=\"{{vm.metabaseUrl}}\" frameborder=\"0\" width=\"100%\" \nheight=\"700\" title=\"{{report.name+\' Details\'}}\" allowtransparency></iframe></div></div></div></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.dataBrainList.length\"><md-tab-label><div layout=\"column\"><div class=\"font-size-14\">REPORTS</div>\n</div></md-tab-label><md-tab-body><iframe id=\"liveReports\" ng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" \nstyle=\"border-width: 0\"></iframe></md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/main/booking-v2/booking-details-v2/booking-details-v2.html","<div id=\"booking-details-v2\" class=\"page-layout simple fullwidth\" layout=\"column\"><div><div><iframe \nid=\"booking-details-v2-iframe\" ng-style=\"vm.minHeight\" frameborder=\"0\" scrolling=\"yes\" width=\"100%\"></iframe></div>\n</div></div>");
$templateCache.put("app/main/booking-v2/booking-form-v2/booking-form-v2.html","<div class=\"bookingform\"><iframe resize-handler id=\"booking-form-v2-iframe\" name=\"{{vm.todaysDate}}\" \nng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/booking-v2/booking-v2-list/booking-v2-list.html","<div id=\"booking-list-v2\" class=\"page-layout simple fullwidth\" layout=\"column\"><div><div class=\"content-card\"><iframe \nid=\"booking-list-v2-iframe\" ng-style=\"vm.minHeight\" frameborder=\"0\" scrolling=\"no\" width=\"100%\"></iframe></div></div>\n</div>");
$templateCache.put("app/main/component/billing-info-charges/billing-info-charges.html","<div ng-if=\"$ctrl.userData.type.user_category!=\'SHIPPER\'\" class=\"pt-10\"><div layout=\"row\" layout-wrap \nlayout-align=\"space-between center\" class=\"mb-15 ph-20\" ng-repeat=\"shipmentRates in $ctrl.billRates track by $index\" \nng-if=\"shipmentRates != undefined \"><div class=\"font-size-14 font-weight-600 black-fg pt-10\" layout=\"row\" \nlayout-align=\"start center\" flex=\"50\" flex-gt-xs=\"50\" flex-xs=\"100\"><md-icon \nng-if=\"shipmentRates.leg_code != null && $ctrl.avblLegIcon.includes(shipmentRates.global_leg_id) &&\n                  shipmentRates.leg_code !== \'additional_services\' && shipmentRates.leg_code !== \'other_charges_fcl\'\" \nclass=\"icon-class\" md-svg-src=\"{{\'assets/icons/custom/\' + shipmentRates.leg_code +\'_card.svg\'}}\"></md-icon><md-icon \nng-if=\"shipmentRates.leg_code == null || !$ctrl.avblLegIcon.includes(shipmentRates.global_leg_id)&&\n                shipmentRates.leg_code !== \'additional_services\' && shipmentRates.leg_code !== \'other_charges_fcl\'\" \nclass=\"icon-class\" \nmd-svg-src=\"{{$ctrl.ShipmentsDetails.mode != \'AIR\'? \'assets/icons/custom/l3_fcl_card.svg\':\'assets/icons/custom/l3_air_card.svg\'}}\">\n</md-icon><md-icon \nng-if=\"shipmentRates.leg_code == \'additional_services\' || shipmentRates.leg_code == \'other_charges_fcl\'\" \nclass=\"icon-class\" md-svg-src=\"{{\'assets/icons/custom/l3_fcl-icon.svg\'}}\"></md-icon><span \nng-class=\"{strikedRow:shipmentRates.leg_status==\'REMOVED\'}\">\n{{ (shipmentRates.leg_name == \'Main Freight\' ) ? \'Freight\' : shipmentRates.leg_name }}</span><div layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"($ctrl.isOwnVendorRate) && shipmentRates.leg_status!=\'REMOVED\' && $ctrl.sourceData && shipmentRates.batchcode\">\n<button ng-repeat=\"batchcode in shipmentRates.batchcode track by $index\"><div \nng-if=\"$ctrl.sourceData[batchcode].sourceFileUrl\"><div ng-click=\"$ctrl.sourceLinkDownload(batchcode)\"><div><div \nclass=\"m-10 h-16 blue-600-fg Font-Bold pointer\" layout=\"row\" layout-align=\"center center\"><div class=\"mr-5\"><md-icon \nclass=\"cursor blue-600-fg s16\" md-font-icon=\"icon-download\"></md-icon></div><div>Download Source {{$index+1}}</div>\n</div></div></div></div></button></div></div><div layout=\"column\" layout-align=\"end end\" flex=\"25\" flex-gt-xs=\"25\" \nflex-xs=\"100\"><label ng-if=\"shipmentRates.buy\" class=\"font-size-12 grey-600-fg\">Buy Rates</label><div \nclass=\"font-weight-600 black-fg pb-5\" layout=\"row\" ng-class=\"{strikedRow:shipmentRates.leg_status==\'REMOVED\'}\">\n{{shipmentRates.buy.leg_currency}} {{(shipmentRates.buy.leg_currency_cost| currencyMask: 2)}}</div></div><div \nlayout=\"column\" layout-align=\"end end\" flex=\"25\" flex-gt-xs=\"25\" flex-xs=\"100\" \nng-if=\"$ctrl.pageSource!=\'rateProvider\'\"><label ng-if=\"shipmentRates.buy\" class=\"font-size-12 grey-600-fg\">Sell Rates\n</label><div class=\"font-weight-600 pb-5\" layout=\"row\" ng-class=\"{strikedRow:shipmentRates.leg_status==\'REMOVED\'}\">\n{{shipmentRates.leg_currency}} {{(shipmentRates.leg_currency_cost| currencyMask: 2)}}</div></div><div \nclass=\"rate_charge_table charge_tables ml-30 font-size-12 pr-8\"><table class=\"tableFullWidth\"><tr \nng-repeat=\"chg_array in shipmentRates.charges track by $index\" ng-if=\"shipmentRates.leg_status!=\'REMOVED\'\"><td \nwidth=\"50%\" class=\"\"><span ng-class=\"{strikedRow:chg_array.status==\'REMOVED\'}\">\n{{ chg_array.charge_name }}{{chg_array.container_type}} <span \nng-if=\"chg_array.charge_type===\'SLAB\' && chg_array.calculated_slab && chg_array.calculated_slab.length\" \nclass=\"font-size-11\">\n{{chg_array.calculated_slab[0].from}} {{(chg_array.calculated_slab[0].from == null || chg_array.calculated_slab[0].from == undefined) ? \'0\' : (chg_array.slab_basis ? (chg_array.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \')+ \' to \'}} {{chg_array.calculated_slab[0].to}} {{(chg_array.calculated_slab[0].to ? (chg_array.slab_basis ? (chg_array.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \') : \'∞\')}}\n<md-icon class=\"s12\" position=\"bottom\" md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nWeight Range Charge</md-tooltip></md-icon></span></span><div class=\"dim-charge-sect\" \nng-if=\"chg_array.charge_basis.includes(\'dim\')\">DIM Charge</div><div class=\"dim-charge-sect\" \nng-if=\"chg_array.charge_category && chg_array.charge_category !== null\" ng-bind=\"chg_array.charge_category\"></div><span\n ng-if=\"chg_array.status==\'NEW\' && chg_array.buy.status==\'NEW\'\" \nclass=\"brad-2 ph-10 ml-10 font-size-10 pv-2 font-weight-600 status_tag border newStatus green-700-fg green-border green-50-bg\">\nNEW</span> <span ng-if=\"(chg_array.status==\'UPDATED\' || chg_array.buy.status==\'UPDATED\')\" \nclass=\"brad-2 ph-10 ml-10 font-size-10 pv-2 font-weight-600 status_tag border updatedStatus\">EDITED</span> <span \nng-if=\"(chg_array.status==\'REMOVED\' && chg_array.buy.status==\'REMOVED\')\" \nclass=\"brad-2 ph-10 ml-10 font-size-10 pv-2 font-weight-600 status_tag border removedStatus\">DELETED</span></td><td \nwidth=\"25%\" class=\"pb-10 text-right grey-600-fg\" ng-class=\"{striked:(chg_array.buy.status==\'REMOVED\')}\"><span \nclass=\"striked pr-10\" \nng-if=\"(chg_array.buy.status==\'UPDATED\' && chg_array.buy.prev_charge_cost) &&\n                            !$ctrl.isString(chg_array.buy.prev_charge_cost)\">\n{{chg_array.buy.charge_currency + \' \' + (chg_array.buy.prev_charge_cost | currencyMask: 2)}}</span> <span \nclass=\"striked pr-10\" \nng-if=\"(chg_array.buy.status==\'UPDATED\' && chg_array.buy.prev_charge_cost) &&\n                              $ctrl.isString(chg_array.buy.prev_charge_cost)\">\n{{(chg_array.buy.prev_charge_cost | currencyMask: 2)}}</span> <span ng-if=\"!$ctrl.isString(chg_array.buy.charge_cost)\">\n{{chg_array.buy.charge_currency + \' \' + (chg_array.buy.charge_cost | currencyMask:2) }} </span><span \nng-if=\"$ctrl.isString(chg_array.buy.charge_cost)\">{{chg_array.buy.charge_cost}}</span></td><td width=\"25%\" \nclass=\"pb-10 text-right grey-600-fg\" ng-class=\"{striked:(chg_array.status==\'REMOVED\')}\" \nng-if=\"$ctrl.pageSource!=\'rateProvider\'\"><span class=\"striked pr-10\" \nng-if=\"(chg_array.status==\'UPDATED\' && chg_array.prev_charge_cost) &&\n                            !$ctrl.isString(chg_array.prev_charge_cost)\">\n{{chg_array.charge_currency + \' \' + (chg_array.prev_charge_cost | currencyMask: 2)}}</span> <span \nclass=\"striked pr-10\" \nng-if=\"(chg_array.status==\'UPDATED\' && chg_array.prev_charge_cost) &&\n                              $ctrl.isString(chg_array.prev_charge_cost)\">\n{{(chg_array.prev_charge_cost | currencyMask: 2)}}</span> <span ng-if=\"!$ctrl.isString(chg_array.charge_cost)\">\n{{chg_array.charge_currency + \' \' + (chg_array.charge_cost | currencyMask:2) }} </span><span \nng-if=\"$ctrl.isString(chg_array.charge_cost)\">{{chg_array.charge_cost | currencyMask: 2}}</span></td></tr></table>\n</div></div></div><div ng-if=\"$ctrl.userData.type.user_category==\'SHIPPER\'\"><div layout=\"row\" layout-wrap \nclass=\"font-weight-600 total-bg bb h-45\"><div class=\"pl-20 pt-12-imp text-truncate font-size-13\" layout=\"row\" \nlayout-align=\"start center\">Total</div><div class=\"pr-20 font-size-16\" layout=\"row\" layout-align=\"end center\" flex \nflex-gt-xs>{{ $ctrl.billRates[0].leg_total_currency + \' \' + ($ctrl.calulateRateTotal() | currencyMask : 2) }}</div>\n</div><div layout=\"row\" layout-wrap class=\"pb-5 ph-20 mt-15 mb-10\" \nng-repeat=\"shipmentRates in $ctrl.billRates track by $index\" \nng-if=\"shipmentRates.leg_status != \'REMOVED\' && ($ctrl.allInQuoteSetting !== \'all_in_total\' )\"><div \nclass=\"font-size-13 text-truncate black-fg\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" \nng-class=\"{\'font-weight-600\': $ctrl.allInQuoteSetting !== \'legwise_total\' }\"><md-icon \nng-if=\"shipmentRates.leg_code != null && $ctrl.avblLegIcon.includes(shipmentRates.global_leg_id) &&\n                  shipmentRates.leg_code !== \'additional_services\' && shipmentRates.leg_code !== \'other_charges_fcl\' && $ctrl.allInQuoteSetting !== \'legwise_total\'\" \nclass=\"icon-class\" md-svg-src=\"{{\'assets/icons/custom/\' + shipmentRates.leg_code +\'_card.svg\'}}\"></md-icon><md-icon \nng-if=\"shipmentRates.leg_code == null || !$ctrl.avblLegIcon.includes(shipmentRates.global_leg_id) &&\n                shipmentRates.leg_code !== \'additional_services\' && shipmentRates.leg_code !== \'other_charges_fcl\' && $ctrl.allInQuoteSetting !== \'legwise_total\'\" \nclass=\"icon-class\" \nmd-svg-src=\"{{$ctrl.ShipmentsDetails.mode != \'AIR\'? \'assets/icons/custom/l3_fcl_card.svg\':\'assets/icons/custom/l3_air_card.svg\'}}\">\n</md-icon><md-icon \nng-if=\"shipmentRates.leg_code == \'additional_services\' || shipmentRates.leg_code == \'other_charges_fcl\' && $ctrl.allInQuoteSetting !== \'legwise_total\'\" \nclass=\"icon-class\" md-svg-src=\"{{\'assets/icons/custom/l3_fcl-icon.svg\'}}\"></md-icon><span>\n{{ (shipmentRates.leg_name == \'Main Freight\' ) ? \'Freight\' : shipmentRates.leg_name }}</span></div><div \nclass=\"black-fg pb-5 font-size-13\" ng-class=\"{\'font-weight-600\': $ctrl.allInQuoteSetting !== \'legwise_total\' }\" \nlayout=\"row\" layout-align=\"end center\" flex=\"40\" flex-gt-xs=\"40\">\n{{shipmentRates.leg_currency}} {{(shipmentRates.leg_currency_cost| currencyMask: 2)}}</div><div \nclass=\"rate_charge_table charge_tables ml-30 font-size-12\" ng-if=\"$ctrl.allInQuoteSetting !== \'legwise_total\'\"><table \nclass=\"tableFullWidth\"><tr ng-repeat=\"chg_array in shipmentRates.charges track by $index\" \nng-if=\"chg_array.status != \'REMOVED\'\"><td class=\"text-truncate\">\n{{ chg_array.charge_name }} {{chg_array.container_type}} <span \nng-if=\"chg_array.charge_type===\'SLAB\' && chg_array.calculated_slab && chg_array.calculated_slab.length\" \nclass=\"font-size-11\">\n{{chg_array.calculated_slab[0].from}} {{(chg_array.calculated_slab[0].from == null || chg_array.calculated_slab[0].from == undefined) ? \'0\' : (chg_array.slab_basis ? (chg_array.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \')+ \' to \'}} {{chg_array.calculated_slab[0].to}} {{(chg_array.calculated_slab[0].to ? (chg_array.slab_basis ? (chg_array.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \') : \'∞\')}}\n<md-icon class=\"s12\" position=\"bottom\" md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nWeight Range Charge</md-tooltip></md-icon></span><div class=\"dim-charge-sect\" \nng-if=\"chg_array.charge_basis.includes(\'dim\')\">DIM Charge</div><div class=\"dim-charge-sect\" \nng-if=\"chg_array.charge_category && chg_array.charge_category !== null\" ng-bind=\"chg_array.charge_category\"></div><span\n ng-if=\"chg_array.status==\'NEW\'\" \nclass=\"brad-2 ph-10 ml-10 font-size-10 pv-2 font-weight-600 status_tag border newStatus green-700-fg green-border green-50-bg\">\nNEW</span> <span ng-if=\"(chg_array.status==\'UPDATED\')\" \nclass=\"brad-2 ph-10 ml-10 font-size-10 pv-2 font-weight-600 status_tag border updatedStatus\">EDITED</span></td><td \nclass=\"text-right pb-10\">{{chg_array.charge_currency + \' \' + (chg_array.charge_cost | currencyMask:2) }} <span \nng-if=\"chg_array.external_comments\"><md-icon class=\"cursor view-comment\" \nmd-svg-src=\"assets/icons/custom/edit_comment.svg\" title=\"Edit\" ng-click=\"$ctrl.fnOpenCommentPanel($event , chg_array)\">\n</md-icon></span></td></tr></table></div></div></div><div ng-if=\"$ctrl.buyRateExists && $ctrl.calulateBuyRateTotal()\" \nlayout=\"row\" layout-wrap class=\"font-size-14 font-weight-600 black-fg total-bg pv-10 mt-10\"><div \nclass=\"pl-20 text-truncate\" layout=\"row\" layout-align=\"start center\" \nflex=\"{{$ctrl.userData.type.user_category==\'SHIPPER\'? 75:50}}\" \nflex-gt-xs=\"{{$ctrl.userData.type.user_category==\'SHIPPER\'? 75:50}}\">Total</div><div class=\"pr-20\" layout=\"row\" \nlayout-align=\"end center\" flex flex-gt-xs>\n{{ $ctrl.billRates[$ctrl.buyRateIndex].buy.leg_total_currency + \' \' + ($ctrl.calulateBuyRateTotal() | currencyMask: 2) }}\n</div><div class=\"pr-20\" layout=\"row\" layout-align=\"end end\" flex flex-gt-xs>\n{{ $ctrl.billRates[0].leg_total_currency + \' \' + ($ctrl.calulateRateTotal() | currencyMask: 2) }}</div></div><div \nng-if=\"$ctrl.pageSource!=\'rateProvider\' && $ctrl.buyRateExists && $ctrl.calulateBuyRateTotal()\" layout=\"row\" \nlayout-wrap class=\"pv-10\"><div layout=\"column\" layout-align=\"center start\" flex=\"60\" flex-gt-xs=\"60\" class=\"pl-20\"><div\n class=\"text-truncate font-size-14 font-weight-600 black-fg\">Gross Profit</div><div ng-if=\"$ctrl.showExchangeRates\"><a \nclass=\"pointer md-link-fg Font-Bold font-size-12\" \nng-click=\"$ctrl.util.redirectToExchangeRatesLink(\'Shipment\', $ctrl.resultId, $ctrl.cardVendorId, \'SD-View exchange Rates\', { \'Mode\': $ctrl.ShipmentsDetails.mode })\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s16 ml-5\"></md-icon></a></div></div><div \nng-if=\"$ctrl.calulateProfit($ctrl.calulateBuyRateTotal(), $ctrl.calulateRateTotal()) >= 0\" class=\"pr-20\" layout=\"row\" \nlayout-align=\"end center\" flex=\"40\" flex-gt-xs=\"40\"><div layout=\"column\" layout-align=\"end end\" \nclass=\"font-size-12 font-weight-600\"><div layout=\"row\"><md-icon md-font-icon=\"icon-trending-up\" class=\"s16 ml-16 mr-5\">\n</md-icon>\n{{ $ctrl.billRates[0].leg_total_currency + \' \' + ($ctrl.calulateProfit($ctrl.calulateBuyRateTotal(), $ctrl.calulateRateTotal()) | currencyMask: 2) }}\n</div><div class=\"font-size-10 font-weight-500 grey-fg\">{{($ctrl.profitPercentage | currencyMask : 2)}}% Profit</div>\n</div></div><div ng-if=\"$ctrl.calulateProfit($ctrl.calulateBuyRateTotal(), $ctrl.calulateRateTotal()) < 0\" \nclass=\"pr-20\" layout=\"row\" layout-align=\"end center\" flex=\"40\" flex-gt-xs=\"40\"><div layout=\"column\" \nlayout-align=\"end end\" class=\"red-fg font-size-12 font-weight-600\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-trending-down\" class=\"s16 ml-16 red-fg mr-5\"></md-icon>\n{{ $ctrl.billRates[0].leg_total_currency + \' \' + ($ctrl.calulateProfit($ctrl.calulateBuyRateTotal(), $ctrl.calulateRateTotal()) | currencyMask: 2) }}\n</div><div class=\"font-size-10 font-weight-500 grey-fg\">{{(($ctrl.profitPercentage | currencyMask : 2)*-1)}}% Loss\n</div></div></div></div>");
$templateCache.put("app/main/component/cargo-type-selection/cargo-type-selection.html","<md-select ng-class=\"{\'full-border\' : $ctrl.fullBorder, \'validation-error\' : $ctrl.isValid}\" \nng-model=\"$ctrl.cargoTypeData\" ng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"$ctrl.changeCargoType();\" \nplaceholder=\"Select Cargo type\" ng-required=\"$ctrl.isRequired\" md-on-close=\"searchCargoType = \'\'\" \nmd-on-open=\"$ctrl.isValid=false\" class=\"selectbox m-0 pr-4\" ng-if=\"!$ctrl.isDisabled\"><md-select-header><input \nng-model=\"searchCargoType\" ng-keypress=\"$ctrl.searchText(\'CargoType\',$event)\" type=\"search\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nplaceholder=\"Search Cargo Type\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"cargo_type in $ctrl.cargoTypeList | filter : searchCargoType track by cargo_type.code\" \nng-value=\"cargo_type\">{{cargo_type.name}}</md-option></md-select><div class=\"font-size-12 fg-AAA8AD h-30\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"$ctrl.isDisabled\">{{$ctrl.cargoTypeData.name}}</div>");
$templateCache.put("app/main/component/cargo-commodity-view/cargo-commodity-view.html","<div class=\"arrow-up\"></div><div id=\"cargo-commodity-view-panel\" class=\"font-size-10 p-10 mb-25\"><div \nclass=\"font-size-12 fg-333333 Font-Bold\"><div class=\"pr-5 white-fg text-capitalize\" ng-if=\"ctrl.cargo_type_data\"><span>\n{{ ctrl.cargo_type_data.name }}</span> <span ng-show=\"ctrl.commodity_data.length\">|</span></div><div \nclass=\"pr-5 white-fg text-capitalize\" ng-if=\"ctrl.commodity_data.length\" \nng-repeat=\"commodity in ctrl.commodity_data track by $index\"><span>{{ commodity.toLowerCase() }}</span> <span \nng-show=\"ctrl.commodity_data.length -1 > $index\">,</span></div></div></div>");
$templateCache.put("app/main/component/charge-level-comments/charge-level-comments.html","<div id=\"charge-level-comments\"><div class=\"header-section\" layout=\"row\" flex=\"100\"><span \nclass=\"Font-Bold font-size-20\" flex=\"100\">Comments</span><div layout=\"row\" class=\"p-0\" layout-align=\"end end\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD m-0 pointer\" ng-click=\"ctrl.closePanel(\'CloseByIcon\')\"></md-icon></div></div><div \nclass=\"panel-body\" layout=\"column\"><div ng-if=\"!ctrl.util.isShipper && !ctrl.isShared && !ctrl.hide_internal_comments\">\n<div class=\"Font-Bold pb-8\">Internal Comments<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mr-10 ml-10 mb-8 grey-fg pointer pt-2 info-icon\"><div class=\"tooltip white-fg bg-343434 font-size-12\">\nThis comments only visible for internal user and will not be printed on Quote PDF</div></md-icon></div><div \nclass=\"quote-editor mb-10\"><ng-ckeditor ng-model=\"ctrl.copyOfChargeObj.internal_comments\" \nng-config=\"ctrl.commentsCkEditorConfig\"></ng-ckeditor></div></div><div><div class=\"Font-Bold pb-8\" \nng-if=\"!ctrl.util.isShipper\">External Comments</div><div class=\"quote-editor\"><ng-ckeditor \nng-model=\"ctrl.copyOfChargeObj.external_comments\" ng-config=\"ctrl.commentsCkEditorConfig\"></ng-ckeditor></div></div>\n</div><div class=\"footer-section\" layout=\"row\" layout-align=\"end end\"><md-button md-no-ink \nclass=\"md-accent-btn w-70 Font-Bold\" title=\"Done\" ng-click=\"ctrl.fnSubmitComments()\">Done</md-button></div></div>");
$templateCache.put("app/main/component/charge-selector/charge-select.html","<div id=\"charge-select\" class=\"black-fg pt-20\"><div \nng-if=\"ctrl.searchParam.mode===\'SEA-FCL\' && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !ctrl.util.isShipper\" \nclass=\"ph-20\"><span class=\"Font-Bold\">Incoterms</span><incoterm-select incoterm=\"ctrl.searchParam.inco_term\" \nimpo-expo=\"ctrl.searchParam.impo_expo\" mixpanel-source=\"ctrl.pageSource\" full-border=\"true\" select-panel-width=\"\'295\'\">\n</incoterm-select><div class=\"text-center font-size-12 mt-10\">(Or)</div></div><div class=\"pb-10 ph-20\" \nng-if=\"ctrl.searchMode!=\'FTL\'\" ng-class=\"{\'pt-20\':ctrl.searchParam.mode!==\'SEA-FCL\'}\"><span class=\"Font-Bold\">\nLocals and Customs</span><md-select placeholder=\"Select Locals and Customs\" \nmd-on-open=\"ctrl.util.fnSetPanelPosition(\'locals-md-select\' , \'md_select_position_locals\')\" \nng-disabled=\"ctrl.searchParam.inco_term && ctrl.searchParam.impo_expo && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !ctrl.util.isShipper\" \nng-class=\"{\'disabled-select\':ctrl.searchParam.inco_term && ctrl.searchParam.impo_expo && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !ctrl.util.isShipper}\" \nng-model=\"ctrl.selectedlegs\" md-on-close=\"ctrl.getSelectedLegs()\" \nmd-container-class=\"multi-select w-295 md_select_position_locals\" \nclass=\"md-no-underline b brad-5 mt-5 mb-0 h-35 pl-5 locals-md-select\" multiple=\"multiple\"><md-select-header \nclass=\"h-35\"><div layout=\"row\" layout-align=\"end center\" class=\"filter-controler h-35\"><div class=\"clear-all pr-15\" \nng-click=\"ctrl.clearAllLC();\">Clear All</div><div class=\"select-all\" ng-click=\"ctrl.selectAllLC()\">Select All</div>\n</div></md-select-header><md-option \nng-disabled=\"((ctrl.searchParam.mode==\'AIR\') && optionVal.leg_key===\'freight_charges\') || ((ctrl.searchParam.mode!=\'AIR\') && $root.domainData.domain_info.ENABLE_DEFAULT_FREIGHT_SELECTION && optionVal.leg_key===\'freight_charges\') || (optionVal.leg_key===\'pickup_selected\' || optionVal.leg_key===\'delivery_selected\')\" \nng-value=\"optionVal\" ng-selected=\"ctrl.searchParam[optionVal.leg_key]\" ng-repeat=\"optionVal in ctrl.legList\" \nng-click=\"ctrl.trackEvent(\'locals and customs\')\">\n{{ (optionVal.leg_name == \'Main Freight\' ) ? \'Freight\' : optionVal.leg_name }}</md-option><div \nng-if=\"ctrl.legList !== null\" layout=\"row\" layout-align=\"center center\" class=\"save-selected-button\" \nng-click=\"ctrl.mdSelect.hide()\">Done</div></md-select></div><div \nng-if=\"(ctrl.searchParam.mode===\'SEA-FCL\' || ctrl.searchMode===\'FTL\' )&& $root.domainData.domain_info.SEARCH_CONFIG && $root.domainData.domain_info.SEARCH_CONFIG.stuffing\" \nclass=\"pt-8 ph-20\"><span class=\"Font-Bold\">Stuffing</span><md-radio-group ng-model=\"ctrl.searchParam.stuffing\" \nng-change=\"ctrl.trackEvent(\'stuffing\');\" layout=\"row\" class=\"mv-15\"><md-radio-button md-no-ink value=\"F\" \nclass=\"md-primary checkbox-margin\">Factory</md-radio-button><md-radio-button md-no-ink value=\"D\" class=\"md-primary\">\nDock</md-radio-button></md-radio-group></div><md-divider \nng-if=\"ctrl.searchParam.mode===\'SEA-FCL\' || ctrl.searchMode===\'FTL\'\"></md-divider><div class=\"pt-20 pb-25 ph-20\"><span \nclass=\"Font-Bold\">Other Details</span><div layout=\"row\" class=\"mt-15\"><div class=\"mr-20\"><span class=\"mb-6\">\n{{ctrl.searchMode === \'AIR\' ? \'No.of AWB\' : \'No. Of B/L\'}}</span><br><input ng-if=\"ctrl.searchMode ===\'SEA-FCL\'\" \nclass=\"charge-inputs w-110 mt-5\" restrict-to=\"[0-9]\" min=\"0\" max=\"100\" type=\"number\" \nng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_details_value[0].bl_qty}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.searchParam.load_data.load_details_value[0].bl_qty\" placeholder=\"No. Of B/L\"> <input \nng-if=\"ctrl.searchMode ===\'SEA-LCL\' || ctrl.searchMode ===\'AIR\'\" class=\"charge-inputs w-110 mt-5\" restrict-to=\"[0-9]\" \nmin=\"0\" max=\"100\" type=\"number\" ng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_meta.total_bl}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.searchParam.load_data.load_meta.total_bl\" placeholder=\"No. Of B/L\" \nng-change=\"ctrl.getChangedValue(\'otherDetails\',(ctrl.searchMode === \'AIR\' ? \'-AWB\' :\'-BL\' ) +\'-Change\',ctrl.searchParam.load_data.load_meta.total_bl);\">\n <input ng-if=\"ctrl.searchMode ===\'FTL\'\" class=\"charge-inputs w-110 mt-5\" restrict-to=\"[0-9]\" min=\"0\" max=\"100\" \ntype=\"number\" ng-class=\"{\'red-border\': !ctrl.searchParam.units.bl}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.searchParam.units.bl\" placeholder=\"No. Of B/L\"></div><div><span class=\"mb-6\">No. Of Shipping Bill</span>\n<br><input ng-if=\"ctrl.searchMode ===\'SEA-FCL\'\" class=\"charge-inputs w-170 mt-5\" restrict-to=\"[0-9]\" min=\"0\" max=\"100\" \ntype=\"number\" ng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_details_value[0].sbl_qty}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.searchParam.load_data.load_details_value[0].sbl_qty\" placeholder=\"No. Of Shipping Bill\"> <input \nng-if=\"ctrl.searchMode ===\'SEA-LCL\' || ctrl.searchMode ===\'AIR\'\" class=\"charge-inputs w-170 mt-5\" restrict-to=\"[0-9]\" \nmin=\"0\" max=\"100\" type=\"number\" ng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_meta.total_sbl}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.searchParam.load_data.load_meta.total_sbl\" placeholder=\"No. Of Shipping Bill\"> <input \nng-if=\"ctrl.searchMode ===\'FTL\'\" class=\"charge-inputs w-110 mt-5\" restrict-to=\"[0-9]\" min=\"0\" max=\"100\" type=\"number\" \nng-class=\"{\'red-border\': !ctrl.searchParam.units.sbl}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.searchParam.units.sbl\" placeholder=\"No. Of Shipping Bill\"></div></div><div layout=\"row\" class=\"mt-15\" \nng-if=\"ctrl.searchMode ===\'SEA-LCL\'\"><div><span class=\"mb-6\">No. Of Pallets</span><br><input \nclass=\"charge-inputs w-170 mt-5\" restrict-to=\"[0-9]\" min=\"0\" max=\"100\" type=\"number\" \nng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_meta.total_pallets}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.searchParam.load_data.load_meta.total_pallets\" placeholder=\"No. Of Pallets\" \nng-change=\"ctrl.trackEvent(\'otherDetails\',\'-Pallets-Change\');\"></div></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-align=\"end center\" class=\"p-10\"><md-button md-no-ink class=\"md-primary-btn w-70\" title=\"Done\" \nng-if=\"ctrl.searchMode !==\'FTL\'\" ng-click=\"ctrl.resetPanel()\">Reset</md-button><md-button md-no-ink \nclass=\"md-accent-btn w-70\" title=\"Done\" ng-click=\"ctrl.closePanel()\">Done</md-button></div></div>");
$templateCache.put("app/main/component/charges-display/charges-display.html","<div layout=\"row\" id=\"charges-display\" layout-wrap class=\"simple-table-container\"><table flex=\"100\" \nclass=\"table-border simple\" ms-responsive-table><thead><tr class=\"tablehead\"><th class=\"left-align\">Charges</th><th>\nBasis</th><th ng-if=\"$ctrl.mode == \'SEA-FCL\'\">Equipment Type</th><th>Quantity</th><th>Unit Price</th><th \nng-if=\"$ctrl.mode != \'SEA-FCL\'\">Min</th><th ng-if=\"$ctrl.mode != \'SEA-FCL\'\">Max</th><th>Amount</th></tr></thead><tbody \nng-repeat=\"rates in $ctrl.chargesData track by $index\" ng-if=\"rates != undefined\"><tr class=\"leg\"><td \nng-if=\"$ctrl.pageSource == \'rateProviderBilling\'\" colspan=\"{{$ctrl.mode != \'SEA-FCL\' ? 7 : 6}}\" class=\"left-align\">\n<span layout=\"row\"><span>{{ (rates.leg_name == \'Main Freight\' ) ? \'Freight\' : rates.leg_name }}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"h-22 pl-10\" \nng-if=\"(rates.show_upload_rate_sheet) && $ctrl.sourceData && $ctrl.sourceData!={} && rates.batchcode\"><button \nng-repeat=\"batchcode in rates.batchcode track by $index\"><div ng-if=\"$ctrl.sourceData[batchcode].sourceFileUrl\"><div \nng-click=\"$ctrl.sourceDownload(batchcode)\"><div class=\"h-16 blue-600-fg Font-Bold pointer\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"mr-5\"><md-icon class=\"cursor blue-600-fg s16\" md-font-icon=\"icon-download\">\n</md-icon></div><div>Download Source {{$index+1}}</div><md-tooltip md-direction=\"top\" \nng-if=\"!$ctrl.util.isMobileDevice\">Download original source rate sheet</md-tooltip></div></div></div></button></div>\n</span></td><td ng-if=\"$ctrl.pageSource != \'rateProviderBilling\'\" class=\"left-align\">\n{{ (rates.leg_name == \'Main Freight\' ) ? \'Freight\' : rates.leg_name }}</td><td \nng-if=\"$ctrl.pageSource != \'rateProviderBilling\'\"></td><td \nng-if=\"$ctrl.mode == \'SEA-FCL\' && $ctrl.pageSource != \'rateProviderBilling\'\"></td><td \nng-if=\"$ctrl.pageSource != \'rateProviderBilling\'\"></td><td ng-if=\"$ctrl.pageSource != \'rateProviderBilling\'\"></td><td \nng-if=\"$ctrl.mode != \'SEA-FCL\' && $ctrl.pageSource != \'rateProviderBilling\'\"></td><td \nng-if=\"$ctrl.mode != \'SEA-FCL\' && $ctrl.pageSource != \'rateProviderBilling\'\"></td><td \nng-if=\"$ctrl.pageSource != \'rateProviderBilling\'\"></td></tr><tr class=\"charge\" \nng-repeat=\"chg_array in rates.charges track by $index\"><td class=\"left-align p-10\">{{chg_array.charge_name}} <span \nng-if=\"chg_array.charge_type===\'SLAB\' && chg_array.calculated_slab && chg_array.calculated_slab.length\" \nclass=\"font-size-11\">\n{{chg_array.calculated_slab[0].from}} {{(chg_array.calculated_slab[0].from == null || chg_array.calculated_slab[0].from == undefined) ? \'0\' : (chg_array.slab_basis ? (chg_array.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \')+ \' to \'}} {{chg_array.calculated_slab[0].to}} {{(chg_array.calculated_slab[0].to ? (chg_array.slab_basis ? (chg_array.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \') : \'∞\')}}\n<md-icon class=\"s12\" position=\"bottom\" md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nWeight Range Charge</md-tooltip></md-icon></span><div class=\"dim-charge-sect\" \nng-if=\"chg_array.charge_basis.includes(\'dim\')\">DIM Charge</div><div class=\"dim-charge-sect\" \nng-if=\"chg_array.charge_category && chg_array.charge_category !== null\" ng-bind=\"chg_array.charge_category\"></div></td>\n<td class=\"p-10\">{{chg_array.charge_basis}}</td><td ng-if=\"$ctrl.mode == \'SEA-FCL\'\">\n{{chg_array.container_type?chg_array.container_type:\'N/A\' }}</td><td>{{chg_array.total_units | currencyMask}}</td><td>\n<div>{{chg_array.charge_currency + \' \' + (chg_array.per_unit_rate | numberMask:2:20) }}</div></td><td \nng-if=\"$ctrl.mode != \'SEA-FCL\'\">{{chg_array.minimum_charge_cost| numberMask:2:20 }}</td><td \nng-if=\"$ctrl.mode != \'SEA-FCL\'\">{{chg_array.maximum_charge_cost| numberMask:2:20 }}</td><td><span \nng-if=\"!$ctrl.isString(chg_array.buy.charge_cost)\">\n{{chg_array.charge_currency + \' \' + (chg_array.charge_cost | currencyMask:2) }}</span><span \nng-if=\"chg_array.external_comments && $ctrl.pageSource == \'rateProviderBilling\'\"><md-icon class=\"cursor view-comment\" \nmd-svg-src=\"assets/icons/custom/edit_comment.svg\" title=\"Edit\" ng-click=\"$ctrl.fnOpenCommentPanel($event , chg_array)\">\n</md-icon></span></td></tr></tbody></table></div>");
$templateCache.put("app/main/component/charges-view/charges-view.html","<div class=\"arrow-up\"></div><div id=\"charges-view-panel\" class=\"pv-10 mb-25\"><table flex=\"100\" \nlayout-align=\"start center\" class=\"font-size-11 fg-F8F9FA Font-Regular pv-5\"><tr class=\"bb-grey\"><th \nclass=\"pt-5 pb-10 ph-10\">Charges</th><th class=\"text-center pt-5 pb-10 ph-10\" \nng-repeat=\"(key, value) in ctrl.containerObj track by $index\">{{key}}</th></tr><tr \nng-repeat=\"(key, value) in ctrl.cardLegCostArray\"><td class=\"pv-5 ph-10\"><div class=\"ellipsis-100\">{{value.leg_name}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11\">{{value.leg_name}}</md-tooltip></div></td><td class=\"pv-5 ph-10\" \nng-repeat=\"(childKey, childValue) in value.container\"><div class=\"ellipsis-80 text-center\">\n{{ childValue.legCurrencyTotal ? value.leg_currency + \' \' + (childValue.legCurrencyTotal | currencyMask:2) : \'-\' }}\n<md-tooltip md-direction=\"top\" class=\"font-size-11\">\n{{ childValue.legCurrencyTotal ? value.leg_currency + \' \' + (childValue.legCurrencyTotal | currencyMask:2) : \'-\' }}\n</md-tooltip></div></td></tr><tr class=\"bt-grey\"><td class=\"pv-5 ph-10\">Total Equipment Charges</td><td \nclass=\"pv-5 ph-10\" ng-repeat=\"(key, value) in ctrl.CustomerCurrCostObj track by $index\"><div \nclass=\"ellipsis-80 text-center\">\n{{ value.customerCurrencyTotal ? ctrl.userbasecurrency + \' \' + ( value.customerCurrencyTotal | currencyMask: 2 ) : \'-\' }} {{ value.customerCurrencyTotal > 0 ? \'*\' : \'\' }}\n<md-tooltip md-direction=\"top\" class=\"font-size-11\">\n{{ value.customerCurrencyTotal ? ctrl.userbasecurrency + \' \' + ( value.customerCurrencyTotal | currencyMask: 2 ) : \'-\' }} {{ value.customerCurrencyTotal > 0 ? \'*\' : \'\' }}\n</md-tooltip></div></td></tr></table><div class=\"font-size-9 fg-F8F9FA pv-5 ph-10\">\n* The charge shown here is based on the equipment type and container type only.</div></div>");
$templateCache.put("app/main/component/commodity-chips/commodity-chips.html","<div style=\"border-radius: 4px\" ng-class=\"{\'validation-error-chips\':$ctrl.isValid}\" ng-keyup=\"$ctrl.isValid=false\">\n<md-chips ng-model=\"$ctrl.commodityArray\" md-add-on-blur=\"true\" md-on-remove=\"$ctrl.fnRemoveChips($chip);\">\n<md-autocomplete md-min-length=\"2\" md-input-id=\"{{$ctrl.mdInputId}}\" md-selected-item=\"$ctrl.selectedCommodityItem\" \nmd-search-text=\"$ctrl.commoditySearchText\" md-items=\"item in $ctrl.getCommodityList($ctrl.commoditySearchText)\" \nmd-item-text=\"item.commodity_title\" placeholder=\"Search Commodity\"><span md-highlight-text=\"$ctrl.commoditySearchText\" \nng-attr-title=\"{{item.commodity_title}}\">{{item.commodity_title}}</span><md-not-found>\nNo commodity matching \"{{$ctrl.commoditySearchText}}\" were found.</md-not-found></md-autocomplete><md-chip-template>\n<span>{{$chip.commodity_title ? $chip.commodity_title : $chip}}<md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$chip.commodity_title ? $chip.commodity_title : $chip}}</md-tooltip></span></md-chip-template></md-chips></div>");
$templateCache.put("app/main/component/co2-emission/co2-emission-panel.html","<div class=\"arrow-up\"></div><div id=\"co2-view-panel\" class=\"pv-10 mb-25\"><table flex=\"100\" layout-align=\"start center\" \nclass=\"font-size-11 fg-F8F9FA Font-Regular pv-5\"><tr class=\"bb-grey\"><th class=\"pt-5 pb-10 ph-10\">Co<sub>2</sub> Value\n</th><th class=\"text-center pt-5 pb-10 ph-10\" ng-repeat=\"loadtypeValue in ctrl.co2e.container_emissions\">\n{{loadtypeValue.load_type}}</th></tr><tr ng-repeat=\"(key,value) in ctrl.rowTitle track by $index\" \nclass=\"font-semibold\"><td class=\"pv-5 ph-10\"><div class=\"ellipsis-100\">{{value.title}}<md-tooltip md-direction=\"top\" \nclass=\"font-size-11\">{{value.title}}</md-tooltip></div></td><td class=\"pv-5 ph-10\" \nng-repeat=\"containerValue in ctrl.co2e.container_emissions\"><div class=\"ellipsis-80 margin-auto text-center\">\n{{containerValue.co2e[value.key] ? (containerValue.co2e[value.key] | currencyMask: 2) : \'-\'}} <span><sub>\n{{containerValue.co2e[value.key]? value.metrics : \'\'}}</sub></span><md-tooltip md-direction=\"top\" class=\"font-size-11\">\n{{containerValue.co2e[value.key] ? (containerValue.co2e[value.key] | currencyMask: 2) : \'-\'}} <span><sub>\n{{containerValue.co2e[value.key] ? value.metrics : \'\'}}</sub></span></md-tooltip></div></td></tr></table></div>");
$templateCache.put("app/main/component/cost-view/cost-view.html","<div class=\"arrow-up\"></div><div id=\"cost-view-panel\" class=\"font-size-10 pv-10 mb-25\"><div \nng-repeat=\"(leg_key,leg_value) in ctrl.card.data[ctrl.buyOrSell] track by $index\" \nng-if=\"leg_value.rate_obj && leg_value.rate_obj.charges.length\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"white-fg Font-Bold pv-5 ph-18\"><div>\n{{ ( leg_value.rate_obj.leg_code == ctrl.l3_leg && leg_value.leg_name == ctrl.mainFreightName ) ? \'Freight\' : leg_value.leg_name }}\n</div><div>{{leg_value.rate_obj.leg_currency}} {{(leg_value.rate_obj.leg_currency_cost| currencyMask: 2)}}</div></div>\n</div><div layout=\"row\" layout-align=\"space-between\" class=\"Font-Bold pv-10 mt-5 bt-white\"><div class=\"pl-18 white-fg\">\nTotal Amount</div><div class=\"pr-18 white-fg\">{{ ctrl.userbasecurrency }} {{ ctrl.totalCost | currencyMask: 2 }}</div>\n</div></div>");
$templateCache.put("app/main/component/currency-dropdown/currency-dropdown.html","<div ng-if=\"!$ctrl.isCurrencyListLoaded\"><div shimmer-effect-full width=\"100%\" height=\"40px\" class=\"mt-4\"></div></div>\n<div ng-if=\"$ctrl.isCurrencyListLoaded\" \nng-class=\"{\'panel-select\':$ctrl.isSearchBar,\'ph-10\':$ctrl.isSearchBar, \'m-0\':$ctrl.isSearchBar , \'search-currency\':$ctrl.isSearchBar}\" \nlayout=\"row\" layout-align=\"start center\"><div id=\"currency-menu\"><md-select md-no-asterisk \nng-change=\"$ctrl.trackEvent(searchCurrency)\" \nng-class=\"{\'full-border\' : $ctrl.fullBorder,\'panel-select-disabled\':$ctrl.isDisabled}\" \nmd-on-open=\"$ctrl.util.fnSetPanelPosition(\'currency-md-select\' , \'md_select_position_currency\')\" \nng-disabled=\"$ctrl.isDisabled\" class=\"m-0 locals-md-currency\" md-on-close=\"searchCurrency = \'\'\" \nng-model=\"$ctrl.fieldValue\" name=\"fieldValue\" placeholder=\"Select Currency\" md-selected-text=\"$ctrl.fieldValue\" \nng-required=\"$ctrl.isRequired\" md-container-class=\"currency-select md_select_position_currency\"><md-select-header><div \nclass=\"search-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchCurrency\" \nautocomplete=\"off\" placeholder=\"Search by Currency/ Country/ Symbol\" class=\"md-text search-input\" \nmd-select-on-focus=\"\"><md-icon flex=\"10\" md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon>\n</div></md-select-header><md-optgroup><md-option \nng-repeat=\"curr in currencyListFiltered = ($ctrl.currencyList |  multipleKey :searchCurrency:{code:\'code\',name:\'name\',currencySymbol:\'currencySymbol\'})\" \nng-value=\"curr.code\"><span compile-html=\"curr.symbol\"></span> {{curr.code}}<div>{{curr.name}}</div></md-option><div \nng-if=\"currencyListFiltered.length==0\" class=\"ph-10 pb-10 fg-AAA8AD\">No Result Match Found</div></md-optgroup>\n</md-select></div></div>");
$templateCache.put("app/main/component/databrain/databrain.html","<div class=\"pl-15 databrain-loader\" ng-if=\"$ctrl.loader\"><md-progress-circular class=\"md-primary\" md-diameter=\"57\">\n</md-progress-circular></div><div class=\"databrain\"><iframe id=\"databrain-iframe\" name=\"{{$ctrl.todaysDate}}\" \nng-style=\"$ctrl.minHeight\" width=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/component/date-picker/date-picker.html","<div ng-click=\"$ctrl.fnOpenDatePicker() \" id=\"{{$ctrl.mdInputId}}\" class=\"date-picker-div\" \nng-class=\"{\'panel-select-disabled\':$ctrl.isDisabled,\'date-error\':($ctrl.isValidate && !$ctrl.fullBorder),\'validation-error\':($ctrl.isValidate && $ctrl.fullBorder),\'date-focus\':($ctrl.isValid && $ctrl.fullBorder),\'date-focus-bottom\':($ctrl.isValid && !$ctrl.fullBorder),\'date-full-border\':$ctrl.fullBorder,\'date-border-bottom\':!$ctrl.fullBorder}\">\n<div style=\"background-image: url(\'assets/icons/custom/search-bar/date.svg\')\" class=\"icon-bg\"></div><md-datepicker \nng-model=\"$ctrl.modelValue\" md-hide-icons=\"all\" md-min-date=\"$ctrl.minLimit\" md-max-date=\"$ctrl.maxLimit\" \nmd-is-open=\"$ctrl.isOpen\" name=\"{{$ctrl.inputName}}\" ng-focus=\"$ctrl.onFocus()\" \nmd-placeholder=\"{{$ctrl.datePlaceholder}}\" ng-keydown=\"$ctrl.Check($event)\" ng-blur=\"$ctrl.onBlur() \" \nng-change=\"$ctrl.fndateChange()\" ng-required=\"{{$ctrl.isDisabled === true ? false : $ctrl.inputRequired }}\" \nng-disabled=\"$ctrl.isDisabled\"></md-datepicker></div>");
$templateCache.put("app/main/component/date-range-picker/date-range-picker.html","<div id=\"date-range-picker\"><md-date-range id=\"{{$ctrl.mdInputId}}\" ng-model=\"pickerModel\" \nclass=\"date-range-picker mt-10\" placeholder=\"\" md-on-select=\"$ctrl.fnSetDatePicker(pickerModel)\" format=\"format\" \none-panel=\"false\" auto-confirm=\"true\" show-template=\"false\" custom-templates=\"customTemplates\" \nselected-template=\"calendarModel.selectedTemplate\" first-day-of-week=\"firstDayOfWeek\"></md-date-range></div>");
$templateCache.put("app/main/component/delete-popup/delete-popup.html","<div layout=\"row\"><md-dialog-content class=\"body\"><div layout=\"column\" layout-align=\"center start \"><p>\nAre you sure you want to delete this {{$ctrl.pageSource}} ?</p></div></md-dialog-content></div><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary-btn ml-10\" title=\"CANCEL\" ng-click=\"$ctrl.cancelPanel(\'cancel\')\">No,Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" \nng-click=\"$ctrl.deleteData($event,\'submit\')\">Yes,Proceed</md-button></md-dialog-actions>");
$templateCache.put("app/main/component/donwload-pdf/download-pdf.html","<div id=\"download-pdf\"><md-button md-no-ink class=\"md-primary-btn with-icon mb-0\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!$ctrl.isPdfGenerated && $ctrl.resultType!=\'Quote\'\" \nng-disabled=\"$ctrl.isPdfFailed || $ctrl.isPdfErrOccured; $ctrl.btnDisable=true;\"><span><md-icon class=\"mr-5 s16 m-0\" \nmd-font-icon=\"icon-refresh\" \nng-class=\"{\'fa-spin\': !$ctrl.isPdfFailed && (!$ctrl.isPdfFailed && !$ctrl.isPdfErrOccured)}\"></md-icon></span>\nDownload Quote</md-button><md-tooltip class=\"white-fg bg-343434 font-size-12 text-left p-5\" \nstyle=\"display: table;opacity: 1\" position=\"bottom\" ng-if=\"!$ctrl.isPdfGenerated && $ctrl.resultType!=\'Quote\'\">\n{{$ctrl.btnDisable ? \'Quote PDF is not available at this time\' : \'\'}}</md-tooltip><md-button md-no-ink \nclass=\"md-primary-btn with-icon mb-0\" layout=\"row\" layout-align=\"center center\" ng-click=\"$ctrl.downloadPdf()\" \nng-if=\"$ctrl.isPdfGenerated && $ctrl.resultType!=\'Quote\'\"><span><md-icon class=\"s14 mr-5 m-0\" \nmd-font-icon=\"icon-download\"></md-icon></span>Download Quote</md-button><div layout=\"row\" clas=\"icon-size\" \nng-if=\"!$ctrl.isPdfGenerated && $ctrl.resultType==\'Quote\'\" \nng-disabled=\"$ctrl.isPdfFailed || $ctrl.isPdfErrOccured; $ctrl.btnDisable=true;\"><span><md-icon \nclass=\"mr-5 s16 m-0 mt-10\" md-font-icon=\"icon-refresh\" \nng-class=\"{\'fa-spin\': !$ctrl.isPdfFailed && (!$ctrl.isPdfFailed && !$ctrl.isPdfErrOccured)}\"></md-icon></span></div>\n<md-tooltip ng-if=\"!$ctrl.isPdfGenerated && $ctrl.resultType==\'Quote\' && $ctrl.btnDisable\" md-direction=\"top\" \nclass=\"font-size-12\">Quote PDF is not available at this time</md-tooltip><div layout=\"row\" clas=\"icon-size\" \nng-click=\"$ctrl.downloadPdf()\" ng-if=\"$ctrl.isPdfGenerated && $ctrl.resultType==\'Quote\'\"><span><md-icon \nclass=\"h-15 spacing-icon pt-2 icon-size\" md-font-icon=\"icon-download\"></md-icon></span><div \nclass=\"icon-text spacing-icon\">Download Quote</div></div></div>");
$templateCache.put("app/main/component/door-address/door-address.html","<div class=\"door-address-card\"><div layout=\"row\" layout-xs=\"column\" class=\"mb-20\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"mr-15 mb-xs-15\"><div class=\"field-label\">Company Name</div><input type=\"text\" class=\"address-input\" \nng-model=\"$ctrl.addressData.company_name\" placeholder=\"Enter company name\"></div><div flex=\"50\" flex-xs=\"100\"><div \nclass=\"field-label\">Contact Email</div><input type=\"email\" class=\"address-input\" \nng-model=\"$ctrl.addressData.contact_email\" placeholder=\"Enter Contact Email\"></div></div><div class=\"mb-20\"><div \nclass=\"field-label\">Street Address</div><input type=\"text\" class=\"address-input\" \nng-model=\"$ctrl.addressData.street_address\" placeholder=\"Enter street address\"></div><div class=\"mb-20\"><div \nclass=\"field-label\">City</div><input type=\"text\" class=\"address-input\" ng-model=\"$ctrl.addressData.city\" \nplaceholder=\"City name\"></div><div layout=\"row\" layout-xs=\"column\" class=\"mb-20\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"mr-15 mb-xs-15\"><div class=\"field-label\">Country</div><md-select class=\"m-0 panel-select\" \nng-model=\"$ctrl.addressData.country\" placeholder=\"Select Country\"><md-option ng-repeat=\"state in $ctrl.countryList\" \nng-value=\"state.country_name\">{{state.country_name}}</md-option></md-select></div><div flex=\"50\" flex-xs=\"100\"><div \nclass=\"field-label\">Postal Code</div><input type=\"text\" class=\"address-input\" ng-model=\"$ctrl.addressData.postal_code\" \nplaceholder=\"Enter Postal Code\"></div></div><div><div class=\"field-label\">\n{{$ctrl.label == \'Pick Up\' ? \'Pickup Reference & Time\' : \'Delivery Reference & Time\'}}</div><input type=\"text\" \nclass=\"address-input\" ng-model=\"$ctrl.addressData.note\" \nplaceholder=\"Enter {{$ctrl.label == \'Pick Up\' ? \'pickup\' : \'delivery\'}} reference\"></div></div>");
$templateCache.put("app/main/component/effective-period-panel/effective-period-panel.html","<div class=\"arrow-up\"></div><div id=\"effective-period-panel\"><table flex=\"100\" layout-align=\"start center\" \nclass=\"font-size-11 fg-FFFFFF Font-Regular\"><thead><tr><th>Load Type</th><th>Effective Period</th></tr></thead><tbody>\n<tr ng-repeat=\"(loadType,period) in ctrl.effectivePeriod track by $index\" class=\"text-center font-size-10\"><td><div \nclass=\"pv-5 ph-10\" ng-repeat=\"load in ctrl.search_load_details\" ng-if=\"load.type == loadType\">{{loadType}}</div></td>\n<td><div class=\"pv-5 ph-10\" ng-if=\"load.type == loadType\" ng-repeat=\"load in ctrl.search_load_details\"><div \nng-if=\"period.expiry_date\"><span ng-if=\"period.start_date\">\n{{ period.start_date | NoTimeZone: \"dd MMM yyyy\" }} - {{ period.expiry_date | NoTimeZone: \"dd MMM yyyy\"}}</span> <span \nng-if=\"!period.start_date\">Till {{ period.expiry_date | NoTimeZone: \"dd MMM yyyy\"}}</span></div><div \nng-if=\"!period.expiry_date\"><span ng-if=\"period.start_date\">From {{ period.start_date | NoTimeZone: \"dd MMM yyyy\"}}\n</span></div></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/component/file-drag-and-drop/file-drag-and-drop.html","<form name=\"myForm\" enctype=\"multipart/form-data\"><div id=\"file-drag-drop\" class=\"dragDropSection\" ngf-drop \nng-model=\"$ctrl.picFile\" flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"column\" class=\"browser-box\" \nlayout-align=\"start center\" flex=\"100\" layout-margin layout-wrap><div layout-align=\"center center\" layout=\"column\" \nflex=\"100\" ng-if=\"!$ctrl.picFile\" class=\"uploadfile\"><div class=\"font-size-15 font-color-black Font-Bold\">\nDrag & Drop Files here</div><div class=\"text-or pv-15\">or</div><md-button md-no-ink class=\"md-link-btn mv-0 Font-Bold\" \nng-click=\"$ctrl.selectFile();$ctrl.trackEvent(\'BrowseFiles-Click\');\" title=\"BROWSE FILES\">Browse Files</md-button><div \nclass=\"font-size-11 pv-10 opacity\">Max. 1 File at a time</div><input name=\"file_doc\" type=\"file\" \nid=\"fileInput_document\" ng-change=\"$ctrl.uploadFile($ctrl.picFile)\" ngf-select ng-model=\"$ctrl.picFile\" required \nngf-model-invalid=\"errorFile\" hide><br></div><div layout=\"column\" flex=\"100\" ng-show=\"$ctrl.progressCircle\" \nclass=\"ph-20 pt-15 progressbar\"><md-progress-linear md-mode=\"indeterminate\" class=\"p-15\"></md-progress-linear><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><span class=\"text-center font-weight-800 font-style-italic\" \nflex=\"100\"><i class=\"font-size-16\">Processing...</i></span></div></div><div layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" ng-if=\"$ctrl.picFile\" class=\"uploadfile\"><md-icon class=\"h-40\" \nmd-svg-src=\"assets/icons/custom/file-icon.svg\"></md-icon><span class=\"pt-15 file-upload-name\" \nng-class=\"{\'text-truncate\' : !$ctrl.util.isMobileDevice}\">{{$ctrl.picFile.name}}</span><br><span \nng-show=\"$ctrl.fileSizeError\" class=\"font-size-14 red-fg\" ng-bind=\"$ctrl.fileSizeErrorMessage\"></span> <span \nng-show=\"$ctrl.fileTypeError\" class=\"font-size-14 red-fg\" ng-bind=\"$ctrl.fileTypeErrorMesssage\"></span><br><button \nng-click=\"$ctrl.picFile = null; $ctrl.removeFile($ctrl.picFile);$ctrl.trackEvent(\'RemoveFile-Click\')\" id=\"remove_doc\" \nng-show=\"$ctrl.picFile\" class=\"border-bottom opacity\">Remove</button></div></div><div layout=\"column\" flex=\"100\" \nng-show=\"$ctrl.onSelect\" class=\"ph-20 pt-15\"><md-progress-linear md-mode=\"indeterminate\" class=\"p-15\">\n</md-progress-linear><div layout=\"row\" layout-padding flex=\"100\"><span \nclass=\"text-left font-weight-800 font-style-italic\" flex=\"100\"><i class=\"font-size-12\">1 File/s Uploading</i></span> \n<span class=\"text-right opacity\" hide flex=\"50\"><u>CANCEL UPLOAD</u></span></div><span ng-show=\"$ctrl.picFile.result\">\nUpload Successful</span> <span class=\"err\" ng-show=\"$ctrl.errorMsg\">{{$ctrl.errorMsg}}</span><br></div></div></form>");
$templateCache.put("app/main/component/filter-panel/filter-panel.html","<div id=\"filter-panel\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon mr-10\"></md-icon><span \nclass=\"font-size-16 Font-Bold grey-fg\" flex>Filters </span><span \nclass=\"font-size-13 pointer md-link-fg font-weight-600 pointer\" ng-click=\"$ctrl.clearFilter()\">Clear All</span><md-icon\n md-font-icon=\"icon-close-circle-outline\" class=\"s22 pointer ml-5 md-link-fg cancel-icon\" \nng-click=\"$ctrl.toggleSidenav(\'right\')\"></md-icon></div><md-divider></md-divider><div class=\"content no-padding\">\n<md-list class=\"no-padding\"><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"!$ctrl.maskLiner\"><div layout=\"column\" flex class=\"ph-20 pv-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div><span class=\"font-size-14 font-weight-600\">\n{{ $ctrl.mode !== \'AIR\' ? \'Liners\' : \'AirLines\'}} </span><span \nng-if=\"$ctrl.selected_filter_obj[$ctrl.linerMode].length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj[$ctrl.linerMode].length}}</span></div></div><div><div \nng-if=\"!$ctrl.showshimmer && $ctrl.linerObject !== null\"><multi-select-chips md-input-id=\"\'liner-filter\'\" \noptions-data-obj=\"$ctrl.linerObject\" query-conditions=\"$ctrl.linerFilterConditions\" \ncallback=\"$ctrl.callBackLiner(payload)\"></multi-select-chips></div><div ng-if=\"$ctrl.showshimmer\"><div \nshimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"!$ctrl.util.isShipper\"><div layout=\"column\" \nflex class=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div \nclass=\"font-size-14 font-weight-600\">Rates Type</div></div><div><div ng-if=\"$ctrl.showshimmer\"><div \nshimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div><div ng-if=\"!$ctrl.showshimmer\">\n<md-radio-group ng-model=\"$ctrl.selected_filter_obj.selected_rateType\" ng-change=\"$ctrl.fnRateTypeChange()\">\n<md-radio-button md-no-ink ng-repeat=\"rateType in $ctrl.listOfFilterObj.ratesType\" ng-value=\"rateType.value\" \nclass=\"md-primary checkbox-margin\">{{rateType.label}}</md-radio-button></md-radio-group></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.listOfFilterObj.cardStatus.length\"><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-15\"><div class=\"font-size-14 font-weight-600\">Card Status</div>\n</div><div><div ng-if=\"$ctrl.showshimmer\"><div shimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div>\n</div><div ng-if=\"!$ctrl.showshimmer\"><md-radio-group ng-model=\"$ctrl.selected_filter_obj.selected_cardStatus\" \nng-change=\"$ctrl.fnCardStatusChange()\"><md-radio-button md-no-ink \nng-repeat=\"cardStatus in $ctrl.listOfFilterObj.cardStatus\" ng-value=\"cardStatus.value\" \nclass=\"md-primary checkbox-margin\">{{cardStatus.label}}</md-radio-button></md-radio-group></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.mode ==\'SEA-FCL\' && !$ctrl.util.isShipper\"><div layout=\"column\" flex class=\"ph-20 pv-15 bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div><span class=\"font-size-14 font-weight-600\">Contract</span> \n<span ng-if=\"$ctrl.selected_filter_obj[\'selected_contractId\'].length\" \nclass=\"filter-count md-component-bg white-fg ml-5\">{{$ctrl.selected_filter_obj[\'selected_contractId\'].length}}</span>\n</div></div><div ng-if=\"!$ctrl.showshimmer\"><multi-select-chips md-input-id=\"\'contract-filter\'\" \noptions-data-obj=\"$ctrl.listOfFilterObj.contractId\" query-conditions=\"$ctrl.contractIdFilterConditions\" \ncallback=\"$ctrl.callBackContractId(payload)\"></multi-select-chips></div><div ng-if=\"$ctrl.showshimmer\"><div \nshimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></md-list-item><md-list-item md-no-ink \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"$ctrl.mode == \'SEA-FCL\'\"><div layout=\"column\" \nflex class=\"ph-20 pt-15 bb\"><div layout=\"column\" flex class=\"mb-15\"><div layout=\"column\"><span \nclass=\"font-size-14 font-weight-600 pb-10\">Direct Route</span></div><div layout=\"row\"><span class=\"pr-20 toggle-text\">\nNo</span><md-switch md-no-ink ng-model=\"$ctrl.selected_filter_obj.via_route_filter\" md-invert class=\"m-0 h-20\" \nng-true-value=\"\'Direct\'\" ng-false-value=\"\'Transhipment\'\" ng-disabled=\"$ctrl.showshimmer\" \nng-change=\"$ctrl.fnDirectRoute($ctrl.selected_filter_obj.via_route_filter);$ctrl.trackEvent(\'directRoute\');\"><span \nclass=\"font-weight-600 fg-333333 font-size-13\"></span></md-switch><span class=\"pl-20 toggle-text\">Yes</span></div>\n</div></div></md-list-item><md-list-item ng-if=\"$ctrl.mode == \'SEA-FCL\'\" md-no-ink class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"column\" flex \nclass=\"mb-15\"><div layout=\"column\"><span class=\"font-size-14 font-weight-600 pb-10\">Hide Empty Cards<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 mb-3 ml-2 grey-fg pointer\"><md-tooltip md-direction=\"top\" \nmd-delay=\"300\">Activate this filter to exclude rate cards without rates.</md-tooltip></md-icon></span></div><div \nlayout=\"row\"><span class=\"pr-20 toggle-text\">No</span><md-switch md-no-ink \nng-model=\"$ctrl.selected_filter_obj.no_rates_filter\" md-invert class=\"m-0 h-20\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-change=\"$ctrl.fnToHideErrorRates($ctrl.selected_filter_obj.no_rates_filter)\" \nng-disabled=\"$ctrl.showshimmer\"><span class=\"font-weight-600 fg-333333 font-size-13\"></span></md-switch><span \nclass=\"pl-20 toggle-text\">Yes</span></div></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-15\"><div class=\"font-size-14 font-weight-600\">Cargo Type</div></div>\n<div><md-radio-group ng-model=\"$ctrl.selected_filter_obj.selected_cargoType\" ng-change=\"$ctrl.fnCargoChange()\">\n<md-radio-button md-no-ink ng-repeat=\"cargoType in $ctrl.listOfFilterObj.cargoTypeList track by $index\" \nng-value=\"cargoType\" class=\"md-primary checkbox-margin\">{{cargoType}}</md-radio-button></md-radio-group></div></div>\n</md-list-item><md-list-item ng-if=\"$ctrl.listOfFilterObj.depoContainerPickupList.length\" class=\"no-padding\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 full-width bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">\nContainer Pickup</span> <span ng-if=\"$ctrl.selected_filter_obj.selected_depoContainerPickup.length\" \nclass=\"filter-count md-component-bg white-fg ml-5\">{{$ctrl.selected_filter_obj.selected_depoContainerPickup.length}}\n</span></div></div><div><div ng-if=\"!$ctrl.showshimmer\"><div layout=\"row\" layout-align=\"space-between center\" flex \nclass=\"mb-20 searchbox-outline\" ng-if=\"$ctrl.listOfFilterObj.depoContainerPickupList.length > 3\"><input \nng-model=\"$ctrl.depoContainerPickup\" type=\"search\" placeholder=\"Search Container Pickup\" \nclass=\"font-size-12 font-primary-fg input-search\" flex=\"100\" ng-keydown=\"$event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nng-repeat=\"containerPickup in $ctrl.listOfFilterObj.depoContainerPickupList | filter: $ctrl.depoContainerPickup | limitTo: (showAllPickup ? $ctrl.listOfFilterObj.depoContainerPickupList.length : 3)\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_depoContainerPickup[containerPickup]\" \nng-click=\"$ctrl.fnSelectDepoContainerPickup(containerPickup)\">{{ containerPickup }}</md-checkbox></div><md-button \nmd-no-ink class=\"md-link-btn button-height-30 m-0 w-100p mb-10\" \nng-click=\"showAllPickup = !showAllPickup;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.depoContainerPickupList|filter: $ctrl.depoContainerPickup).length > 3\">\n{{showAllPickup ? \'- show less\' : \'+ show all\'}}</md-button></div><div ng-if=\"$ctrl.showshimmer\"><div \nshimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div></md-list-item><md-list-item \nng-if=\"$ctrl.listOfFilterObj.depoContainerDropList.length\" class=\"no-padding\" layout=\"row\" layout-align=\"start center\" \nflex><div layout=\"column\" flex class=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" \nflex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">Container Drop</span> <span \nng-if=\"$ctrl.selected_filter_obj.selected_depoContainerDrop.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_depoContainerDrop.length}}</span></div></div><div><div ng-if=\"!$ctrl.showshimmer\">\n<div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.depoContainerDropList.length > 3\"><input ng-model=\"$ctrl.depoContainerDrop\" type=\"search\" \nplaceholder=\"Search Container Drop\" class=\"font-size-12 font-primary-fg input-search\" flex=\"100\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div \nng-repeat=\"containerDrop in $ctrl.listOfFilterObj.depoContainerDropList | filter: $ctrl.depoContainerDrop | limitTo: (showAllDrop ? $ctrl.listOfFilterObj.depoContainerDropList.length : 3)\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_depoContainerDrop[containerDrop]\" \nng-click=\"$ctrl.fnSelectDepoContainerDrop(containerDrop)\">{{ containerDrop }}</md-checkbox></div><md-button md-no-ink \nclass=\"md-link-btn button-height-30 m-0 w-100p mb-10\" ng-click=\"showAllDrop = !showAllDrop;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.depoContainerDropList|filter: $ctrl.depoContainerDrop).length > 3\">\n{{showAllDrop ? \'- show less\' : \'+ show all\'}}</md-button></div><div ng-if=\"$ctrl.showshimmer\"><div \nshimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex \nclass=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span \nclass=\"font-size-14 font-weight-600\">Commodity</span> <span md-no-ink \nng-if=\"$ctrl.selected_filter_obj.selected_commodity.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_commodity.length}}</span></div></div><div><div ng-if=\"!$ctrl.showshimmer\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-show=\"$ctrl.listOfFilterObj.commodityList.length > 3\"><input ng-model=\"$ctrl.commoditySearch\" type=\"search\" \nplaceholder=\"Search Commodity\" class=\"font-size-12 font-primary-fg input-search\" flex=\"100\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div class=\"text-truncate\" \nng-repeat=\"commodity in $ctrl.listOfFilterObj.commodityList | filter: $ctrl.commoditySearch | limitTo: (showAllCommodity ? $ctrl.listOfFilterObj.commodityList.length : 3) |  orderBy\">\n<md-checkbox md-no-ink class=\"commodity-options\" layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_commodity[commodity]\" ng-click=\"$ctrl.fnSelectCommodity(commodity)\">\n{{ commodity.toLowerCase() }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 p-10 tooltip-width-control pointer-events-none\" style=\"display:table;opacity:1\">\n<div class=\"tooltip-width-control\">{{ commodity.toLowerCase() }}</div></md-tooltip></md-checkbox></div><md-button \nmd-no-ink class=\"md-link-btn button-height-30 m-0 w-100p mb-10\" \nng-click=\"showAllCommodity = !showAllCommodity;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.commodityList|filter: $ctrl.commoditySearch).length > 3\">\n{{showAllCommodity ? \'- show less\' : \'+ show all\'}}</md-button></div><div ng-if=\"$ctrl.showshimmer\"><div \nshimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"$ctrl.mode ==\'SEA-FCL\'\"><div layout=\"column\" \nflex class=\"ph-20 pv-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Origin Service Mode </span><span \nng-if=\"$ctrl.selected_filter_obj.selected_originServiceMode.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_originServiceMode.length}}</span></div></div><div><div ng-if=\"!$ctrl.showshimmer\">\n<multi-select-chips md-input-id=\"\'origin-service-mode-filter\'\" \noptions-data-obj=\"$ctrl.listOfFilterObj.originServiceMode\" query-conditions=\"$ctrl.originServiceModeFilterConditions\" \ncallback=\"$ctrl.callBackOriginServiceModeFilter(payload)\"></multi-select-chips></div><div ng-if=\"$ctrl.showshimmer\">\n<div shimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div></md-list-item><md-list-item\n class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"$ctrl.mode ==\'SEA-FCL\'\"><div layout=\"column\" \nflex class=\"ph-20 pv-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Destination Service Mode </span><span \nng-if=\"$ctrl.selected_filter_obj.selected_destinationServiceMode.length\" \nclass=\"filter-count md-component-bg white-fg ml-5\">{{$ctrl.selected_filter_obj.selected_destinationServiceMode.length}}\n</span></div></div><div><div ng-if=\"!$ctrl.showshimmer\"><multi-select-chips \nmd-input-id=\"\'destination-service-mode-filter\'\" options-data-obj=\"$ctrl.listOfFilterObj.destinationServiceMode\" \nquery-conditions=\"$ctrl.destinationServiceModeFilterConditions\" \ncallback=\"$ctrl.callBackDestinationServiceModeFilter(payload)\"></multi-select-chips></div><div \nng-if=\"$ctrl.showshimmer\"><div shimmer-effect-full width=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" \nflex class=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div>\n<span class=\"font-size-14 font-weight-600\">Port of Loading</span> <span \nng-if=\"$ctrl.selected_filter_obj.selected_loadingPort.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_loadingPort.length}}</span></div></div><div><div ng-if=\"!$ctrl.showshimmer\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.loadingPortList.length > 3\"><input ng-model=\"loadingSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'pol\',loadingSearch)\" type=\"search\" placeholder=\"Search Loading Port\" \nclass=\"font-size-12 font-primary-fg input-search\" flex=\"100\" ng-keydown=\"$event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nng-repeat=\"loadingPort in $ctrl.listOfFilterObj.loadingPortList | filter: $ctrl.loadingSearch | limitTo: (showAllPol ? $ctrl.listOfFilterObj.loadingPortList.length : 3)\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_loadingPort[loadingPort]\" ng-click=\"$ctrl.fnSelectLoading(loadingPort)\">\n{{ loadingPort }}</md-checkbox></div><md-button md-no-ink class=\"md-link-btn button-height-30 m-0 w-100p mb-10\" \nng-click=\"showAllPol = !showAllPol;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.loadingPortList|filter: $ctrl.loadingSearch).length > 3\">\n{{showAllPol ? \'- show less\' : \'+ show all\'}}</md-button></div><div ng-if=\"$ctrl.showshimmer\"><div shimmer-effect-full \nwidth=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div></md-list-item><md-list-item class=\"no-padding\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 full-width bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">\nPort of Discharge</span> <span ng-if=\"$ctrl.selected_filter_obj.selected_dischargePort.length\" \nclass=\"filter-count md-component-bg white-fg ml-5\">{{$ctrl.selected_filter_obj.selected_dischargePort.length}}</span>\n</div></div><div><div ng-if=\"!$ctrl.showshimmer\"><div layout=\"row\" layout-align=\"space-between center\" flex \nclass=\"mb-20 searchbox-outline\" ng-if=\"$ctrl.listOfFilterObj.dischargePortList.length > 3\"><input \nng-model=\"dischargeSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'pod\',dischargeSearch)\" type=\"search\" placeholder=\"Search Discharge Port\" \nclass=\"font-size-12 font-primary-fg input-search\" flex=\"100\" ng-keydown=\"$event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nng-repeat=\"dischargePort in $ctrl.listOfFilterObj.dischargePortList | filter: $ctrl.dischargeSearch  | limitTo: (showAllPod ? $ctrl.listOfFilterObj.dischargePortList.length : 3)\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_dischargePort[dischargePort]\" \nng-click=\"$ctrl.fnSelectDischarge(dischargePort)\">{{dischargePort}}</md-checkbox></div><md-button md-no-ink \nclass=\"md-link-btn button-height-30 m-0 w-100p mb-10\" ng-click=\"showAllPod = !showAllPod;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.dischargePortList|filter: $ctrl.dischargeSearch).length > 3\">\n{{showAllPod ? \'- show less\' : \'+ show all\'}}</md-button></div><div ng-if=\"$ctrl.showshimmer\"><div shimmer-effect-full \nwidth=\"170px\" height=\"20px\" class=\"mb-10\"></div></div></div></div></md-list-item><md-list-item class=\"no-padding\" \nlayout=\"row\" layout-align=\"start center\" flex ng-if=\"$ctrl.listOfFilterObj.originPortList.length\"><div layout=\"column\" \nflex class=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div>\n<span class=\"font-size-14 font-weight-600\">Origin</span> <span \nng-if=\"$ctrl.selected_filter_obj.selected_originPort.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_originPort.length}}</span></div></div><div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.originPortList.length > 3\"><input ng-model=\"originSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'origin\',originSearch)\" type=\"search\" placeholder=\"Search Origin Port\" \nclass=\"font-size-12 font-primary-fg input-search\" flex=\"100\" ng-keydown=\"$event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nng-repeat=\"originPort in $ctrl.listOfFilterObj.originPortList | filter: $ctrl.originSearch\"><md-checkbox md-no-ink \nlayout=\"row\" layout-align=\"start center\" ng-model=\"$ctrl.selected_filter_obj.selected_originPort[originPort]\" \nng-click=\"$ctrl.fnSelectOrigin(originPort)\">{{ originPort }}</md-checkbox></div></div></div></md-list-item>\n<md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.listOfFilterObj.destinationPortList.length\"><div layout=\"column\" flex class=\"ph-20 pt-15 full-width bb\">\n<div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span \nclass=\"font-size-14 font-weight-600\">Destination</span> <span \nng-if=\"$ctrl.selected_filter_obj.selected_destinationPort.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_destinationPort.length}}</span></div></div><div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.destinationPortList.length > 3\"><input ng-model=\"destinationSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'destinationSearch\',destinationSearch)\" type=\"search\" \nplaceholder=\"Search Destination Port\" class=\"font-size-12 font-primary-fg input-search\" flex=\"100\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div \nng-repeat=\"destinationPort in $ctrl.listOfFilterObj.destinationPortList | filter: $ctrl.destinationSearch\"><md-checkbox\n md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_destinationPort[destinationPort]\" \nng-click=\"$ctrl.fnSelectDestination(destinationPort)\">{{destinationPort}}</md-checkbox></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.listOfFilterObj.pickupTransporterList.length\"><div layout=\"column\" flex class=\"ph-20 pt-15 full-width bb\">\n<div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span \nclass=\"font-size-14 font-weight-600\">Pickup Transporter </span><span \nng-if=\"$ctrl.selected_filter_obj.selected_pickupTransporter.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_pickupTransporter.length}}</span></div></div><div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.pickupTransporterList.length > 3\"><input ng-model=\"pickupTransporterSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'pickupTransporterSearch\',pickupTransporterSearch)\" type=\"search\" \nplaceholder=\"Search Pickup Transporter\" class=\"font-size-12 font-primary-fg input-search\" flex=\"100\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div \nng-repeat=\"pickupTransporter in $ctrl.listOfFilterObj.pickupTransporterList | filter: $ctrl.pickupTransporterSearch | limitTo: (showAllPickupTran ? $ctrl.listOfFilterObj.pickupTransporterList.length : 3)\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_pickupTransporter[pickupTransporter]\" \nng-click=\"$ctrl.fnSelectPickupTransporter(pickupTransporter)\">{{pickupTransporter}}</md-checkbox></div><md-button \nmd-no-ink class=\"md-link-btn button-height-30 m-0 w-100p mb-10\" \nng-click=\"showAllPickupTran = !showAllPickupTran;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.pickupTransporterList|filter: $ctrl.pickupTransporterSearch).length > 3\">\n{{showAllPickupTran ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.listOfFilterObj.deliveryTransporterList.length\"><div layout=\"column\" flex \nclass=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span \nclass=\"font-size-14 font-weight-600\">Delivery Transporter </span><span \nng-if=\"$ctrl.selected_filter_obj.selected_deliveryTransporter.length\" \nclass=\"filter-count md-component-bg white-fg ml-5\">{{$ctrl.selected_filter_obj.selected_deliveryTransporter.length}}\n</span></div></div><div><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.deliveryTransporterList.length > 3\"><input ng-model=\"deliveryTransporterSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'deliveryTransporterSearch\',deliveryTransporterSearch)\" type=\"search\" \nplaceholder=\"Search Delivery Transporter\" class=\"font-size-12 font-primary-fg input-search\" flex=\"100\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div \nng-repeat=\"deliveryTransporter in $ctrl.listOfFilterObj.deliveryTransporterList | filter: $ctrl.deliveryTransporterSearch | limitTo: (showAllDeliveryTran ? $ctrl.listOfFilterObj.deliveryTransporterList.length : 3)\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_deliveryTransporter[deliveryTransporter]\" \nng-click=\"$ctrl.fnSelectDeliveryTransporter(deliveryTransporter)\">{{deliveryTransporter}}</md-checkbox></div><md-button\n md-no-ink class=\"md-link-btn button-height-30 m-0 w-100p mb-10\" \nng-click=\"showAllDeliveryTran = !showAllDeliveryTran;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.deliveryTransporterList|filter: $ctrl.deliveryTransporterSearch).length > 3\">\n{{showAllDeliveryTran ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.listOfFilterObj.originTransporterList.length\" hide><div layout=\"column\" flex \nclass=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span \nclass=\"font-size-14 font-weight-600\">Origin Carrier </span><span \nng-if=\"$ctrl.selected_filter_obj.selected_originTransporter.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_originTransporter.length}}</span></div></div><div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.originTransporterList.length > 3\"><input ng-model=\"originTransporterSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'originTransporterSearch\',originTransporterSearch)\" type=\"search\" \nplaceholder=\"Search Origin Carrier\" class=\"font-size-12 font-primary-fg input-search\" flex=\"100\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div \nng-repeat=\"originTransporter in $ctrl.listOfFilterObj.originTransporterList | filter: $ctrl.originTransporterSearch\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_originTransporter[originTransporter]\" \nng-click=\"$ctrl.fnSelectOriginTransporter(originTransporter)\">{{originTransporter}}</md-checkbox></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.listOfFilterObj.destinationTransporterList.length\" hide><div layout=\"column\" flex \nclass=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span \nclass=\"font-size-14 font-weight-600\">Destination Carrier </span><span \nng-if=\"$ctrl.selected_filter_obj.selected_destinationTransporter.length\" \nclass=\"filter-count md-component-bg white-fg ml-5\">{{$ctrl.selected_filter_obj.selected_destinationTransporter.length}}\n</span></div></div><div><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.destinationTransporterList.length > 3\"><input ng-model=\"destinationTransporterSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'destinationTransporterSearch\',destinationTransporterSearch)\" type=\"search\" \nplaceholder=\"Search Destination Carrier\" class=\"font-size-12 font-primary-fg input-search\" flex=\"100\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div \nng-repeat=\"destinationTransporter in $ctrl.listOfFilterObj.destinationTransporterList | filter: $ctrl.destinationTransporterSearch\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_destinationTransporter[destinationTransporter]\" \nng-click=\"$ctrl.fnSelectDestinationTransporter(destinationTransporter)\">{{destinationTransporter}}</md-checkbox></div>\n</div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"!$ctrl.util.isShipper && !$ctrl.util.isSharedQuote() && $root.getDomainFlag(\'SHOW_AGENT_NAME\') && $ctrl.listOfFilterObj.agentList.length\">\n<div layout=\"column\" flex class=\"ph-20 pt-15 full-width bb\"><div layout=\"row\" layout-align=\"space-between center\" flex \nclass=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">Agents </span><span \nng-if=\"$ctrl.selected_filter_obj.selected_agent.length\" class=\"filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.selected_filter_obj.selected_agent.length}}</span></div></div><div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-20 searchbox-outline\" \nng-if=\"$ctrl.listOfFilterObj.agentList.length > 3\"><input ng-model=\"agentSearch\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-change=\"$ctrl.trackMixpanel(\'agentSearch\',agentSearch)\" type=\"search\" placeholder=\"Search Agent\" \nclass=\"font-size-12 font-primary-fg input-search\" flex=\"100\" ng-keydown=\"$event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nng-repeat=\"agent in $ctrl.listOfFilterObj.agentList | filter: $ctrl.agentSearch | limitTo: (showAllAgent ? $ctrl.listOfFilterObj.agentList.length : 3)\">\n<md-checkbox md-no-ink layout=\"row\" layout-align=\"start center\" \nng-model=\"$ctrl.selected_filter_obj.selected_agent[agent]\" ng-click=\"$ctrl.fnSelectAgent(agent)\">{{ agent }}\n</md-checkbox></div><md-button md-no-ink class=\"md-link-btn button-height-30 m-0 w-100p mb-10\" \nng-click=\"showAllAgent = !showAllAgent;$ctrl.fnSetCardHeight()\" \nng-show=\"($ctrl.listOfFilterObj.agentList|filter: $ctrl.agentSearch).length > 3\">\n{{showAllAgent ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item></md-list></div></div>");
$templateCache.put("app/main/component/footer-strip/footer-strip.html","<div class=\"bg-535353 footer-strip p-10\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex-sm=\"100\" class=\"font-size-13 white-fg\"><span \nclass=\"ph-8 text-color ml-15\">{{$ctrl.quoteData.length}}</span> <span class=\"pl-10\">Rate Cards</span></div><div \nlayout=\"row\" flex-xs=\"100\" flex-sm=\"100\" layout-align=\"start center\" class=\"generate-quote\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"white-fg pr-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.quoteDetails.result_data.send_mail\" class=\"md-primary mb-0\">Send Notification to Customer</md-checkbox>\n<md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.quoteDetails.result_data.print_schedule\" \nclass=\"md-primary mb-0\">Print schedule on PDF</md-checkbox><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-if=\"$ctrl.searchParam.mode === \'SEA-FCL\' && $ctrl.hasCo2eData\" ng-model=\"$ctrl.quoteDetails.result_data.co2e\" \nng-click=\"$ctrl.trackEvent(\'QC-Co2emission-Click\')\" class=\"md-primary mb-0\">Print co2 emissions in PDF</md-checkbox>\n<md-checkbox ng-if=\"$ctrl.enable_zero_sell_rates_on_pdf_checkbox\" md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.quoteDetails.result_data.show_zero_sell_rates\" \nng-disabled=\"$ctrl.disable_zero_sell_rates_on_pdf_checkbox\" \nng-click=\"$ctrl.trackEvent(\'QC-SelecteZeroSellRates-Click\')\" class=\"md-primary mb-0\">Print charges with “Zero” in PDF\n</md-checkbox><md-checkbox ng-if=\"$ctrl.linerMaskCheckBox\" md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.quoteDetails.result_data.carrier_mask_for_shipper\" \nng-change=\"$ctrl.trackEvent(\'QC-Carrier-Masking-In-Pdf-Click\')\" class=\"md-primary mb-0\">Hide Carrier name in Quote PDF\n</md-checkbox></div><div layout=\"row\" layout-align=\"start end\" flex-xs=\"100\" flex-sm=\"100\" class=\"white-fg\"><md-select \nng-model=\"$ctrl.quoteDetails.result_data.all_in_quote_setting\" \nng-if=\"$root.domainData.domain_info.ALL_IN_QUOTE_SETTING_FWD_ENABLED && !$ctrl.util.isShipper && $ctrl.allInQuoteOptions && $ctrl.allInQuoteOptions != {}\" \nng-change=\"$ctrl.fnCheckZeroSellRates($ctrl.quoteDetails.result_data.all_in_quote_setting) ; $ctrl.trackEvent(\'QC-AllInQuote-Click\',$ctrl.quoteDetails.result_data.all_in_quote_setting)\" \nmd-on-open=\"$ctrl.util.fnSetPanelPosition(\'primary_select\' , \'all_in_selection\')\" \nclass=\"panel-selct allin-width md-primary-btn primary_select m-10\" md-container-class=\"all_in_selection allin-width\">\n<md-option ng-repeat=\"(all_in_key , all_in_value) in $ctrl.allInQuoteOptions\" value=\"{{all_in_key}}\">{{all_in_value}}\n</md-option></md-select><md-select ng-model=\"$ctrl.quoteDetails.result_data.pdf_preferred_language\" \nng-if=\"$root.domainData.domain_info.ENABLE_MULTILINGUAL_OPTION_FOR_QUOTE_PDF\" \nclass=\"panel-selct w-150 md-primary-btn primary_select m-10 ph-8 pdf_preferred_language\" \nmd-container-class=\"pdf-language w-150\" \nmd-on-open=\"$ctrl.util.fnSetPanelPosition(\'pdf_preferred_language\' , \'pdf-language\')\" \nng-change=\" $ctrl.trackEvent(\'QC-PDFLanguage-Click\',$ctrl.quoteDetails.result_data.pdf_preferred_language)\"><md-option \nng-repeat=\"(language_key , language_value) in $ctrl.quote_pdf_languages\" ng-selected=\"language_key == \'en\'\" \nvalue=\"{{language_key}}\">{{language_value}}</md-option></md-select><md-button md-no-ink class=\"md-accent-btn m-10\" \nng-click=\"$ctrl.generateQuote($event);$ctrl.trackEvent(\'QC-GenerateQuotation-Click\')\">Generate Quote</md-button></div>\n</div></div>");
$templateCache.put("app/main/component/free-days/free-days-panel.html","<div class=\"arrow-up\"></div><div id=\"free-days-panel\" ng-if=\"(ctrl.mode === \'SEA-FCL\')\"><table flex=\"100\" \nlayout-align=\"start center\" class=\"font-size-11 fg-FFFFFF Font-Regular\"><thead><tr><th>Freedays</th><th \nng-repeat=\"loadTypeValue in ctrl.loadType\"><div>{{loadTypeValue}}</div></th></tr></thead><tbody \nng-repeat=\"routeData in ctrl.tableData.route track by $index\"><tr class=\"text-center font-size-11 font-bold\"><td \nclass=\"pt-15 pb-5 pr-24 pl-15\">{{routeData.title}}</td></tr><tr \nng-repeat=\"DnDValue in ctrl.tableData.DnD track by $index\" class=\"text-center font-size-10\"><td \nclass=\"pv-5 pr-24 pl-20\">{{DnDValue.title}}</td><td class=\"pv-5 font-semibold freeDaysCell\" \nng-repeat=\"loadTypeValue in ctrl.loadType track by $index\"><div \nng-repeat=\"freeDaysDetail in ctrl.freedaysdata[routeData.key][DnDValue.key]\"><span \nng-if=\"freeDaysDetail.free_days &&  freeDaysDetail.container_type == loadTypeValue\">\n{{freeDaysDetail.free_days+\' Days\'}}{{freeDaysDetail.free_days_type.charAt(0) ? \'(\'+freeDaysDetail.free_days_type.charAt(0)+\')\':\'\'}}\n</span></div></td></tr></tbody></table><div class=\"font-size-11 fg-FFFFFF Font-Regular pv-10 ph-10 bt\">\nNote: B - Business Days, C - Calendar Days</div></div>");
$templateCache.put("app/main/component/free-days/free-days.html","<div id=\"free-days\" ng-class=\"{\'ph-15 pv-5 fd-col\' : $ctrl.type === \'card\'}\" layout=\"row\" layout-align=\"space-between\">\n<div class=\"key w-80\" ng-if=\"$ctrl.type !== \'list-nwls\'\">Free Days</div><div \nng-show=\"!$ctrl.showNotAvailable && ($ctrl.mode === \'SEA-FCL\') \" class=\"free-{{$ctrl.cardid}} view-text-style\" \nng-click=\"$ctrl.showFreeDays($event, $ctrl.cardid)\">View<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer\"></md-icon></div><div ng-class=\"{\'value text-truncate\' : $ctrl.type === \'card\'}\" \nng-show=\"$ctrl.showNotAvailable\">-</div></div>");
$templateCache.put("app/main/component/free-days-box/free-days-box.html","<div class=\"free-days-box\"><div layout=\"row\" class=\"p-20\"><div layout=\"column\"><span class=\"heading\">Origin</span><div \nlayout=\"row\"><div layout=\"column\" class=\"pb-25 pr-20\"><span class=\"sub-head\">Detention</span><div \nng-click=\"$ctrl.disableOriginCombined()\"><span class=\"w-140 panel-select focus\" layout=\"row\" \nng-class=\"{\'disableField\': $ctrl.originDisabled,\'error-border\':$ctrl.validationObj.originDetentionValidation}\"><input \nng-model=\"$ctrl.freeDays.origin.detention\" ng-change=\"$ctrl.dndValidation(\'originDetention\')\" type=\"number\" \nng-class=\"{\'disableField\': $ctrl.originDisabled}\" placeholder=\"Enter Days\" class=\"w-92 border-left panel-select\"> <span\n class=\"w-50 days-style\">Days</span> </span><span ng-if=\"$ctrl.validationObj.originDetentionValidation\" \nclass=\"error-text\">Enter between 1 and 99 days</span></div></div><div layout=\"column\" class=\"pb-25 pr-20\"><span \nclass=\"sub-head\">Demurrage</span><div ng-click=\"$ctrl.disableOriginCombined()\"><span class=\"w-140 panel-select\" \nlayout=\"row\" \nng-class=\"{\'disableField\': $ctrl.originDisabled,\'error-border\':$ctrl.validationObj.originDemurrageValidation}\"><input \nng-model=\"$ctrl.freeDays.origin.demurrage\" ng-change=\"$ctrl.dndValidation(\'originDemurrage\')\" type=\"number\" \nng-class=\"{\'disableField\': $ctrl.originDisabled}\" placeholder=\"Enter Days\" class=\"w-92 border-left panel-select\"> <span\n class=\"w-50 days-style\">Days</span></span></div><span ng-if=\"$ctrl.validationObj.originDemurrageValidation\" \nclass=\"error-text\">Enter between 1 and 99 days</span></div></div><span class=\"heading\">Destination</span><div \nlayout=\"row\"><div layout=\"column\" class=\"pr-20\"><span class=\"sub-head\">Detention</span><div \nng-click=\"$ctrl.disableDestinationCombined()\"><span class=\"w-140 panel-select\" layout=\"row\" \nng-class=\"{\'disableField\': $ctrl.destinationDisabled,\'error-border\':$ctrl.validationObj.destinationDetentionValidation}\">\n<input ng-model=\"$ctrl.freeDays.destination.detention\" ng-change=\"$ctrl.dndValidation(\'destinationDetention\')\" \ntype=\"number\" ng-class=\"{\'disableField\': $ctrl.destinationDisabled}\" placeholder=\"Enter Days\" \nclass=\"w-92 border-left panel-select\"> <span class=\"w-50 days-style\">Days</span> </span><span \nng-if=\"$ctrl.validationObj.destinationDetentionValidation\" class=\"error-text\">Enter between 1 and 99 days</span></div>\n</div><div layout=\"column\" class=\"pr-20\"><span class=\"sub-head\">Demurrage</span><div \nng-click=\"$ctrl.disableDestinationCombined()\"><span class=\"w-140 panel-select\" layout=\"row\" \nng-class=\"{\'disableField\': $ctrl.destinationDisabled,\'error-border\':$ctrl.validationObj.destinationDemurageValidation}\">\n<input ng-model=\"$ctrl.freeDays.destination.demurrage\" ng-change=\"$ctrl.dndValidation(\'destinationDemurrage\')\" \ntype=\"number\" ng-class=\"{\'disableField\': $ctrl.destinationDisabled}\" placeholder=\"Enter Days\" \nclass=\"w-92 border-left panel-select\"> <span class=\"w-50 days-style\">Days</span> </span><span \nng-if=\"$ctrl.validationObj.destinationDemurageValidation\" class=\"error-text\">Enter between 1 and 99 days</span></div>\n</div></div></div><div class=\"divider\"></div><div layout=\"column\"><div class=\"clear-all-style heading w-80\" \nng-click=\"$ctrl.clearAll(\'origin\')\" layout-align=\"end center\">Clear All</div><div layout=\"column\" class=\"ph-20 pb-25\">\n<span class=\"sub-head\">Combined</span><div ng-click=\"$ctrl.disableOrigin()\"><span class=\"w-140 panel-select\" \nlayout=\"row\" \nng-class=\"{\'disableField\': $ctrl.combinedOriginDisabled,\'error-border\':$ctrl.validationObj.originCombinedValidation}\">\n<input type=\"number\" class=\"w-92 border-left panel-select\" ng-class=\"{\'disableField\': $ctrl.combinedOriginDisabled}\" \nplaceholder=\"Enter Days\" ng-change=\"$ctrl.dndValidation(\'originCombined\')\" \nng-model=\"$ctrl.freeDays.origin.combinedDays\"> <span class=\"w-50 days-style\">Days</span> </span><span \nng-if=\"$ctrl.validationObj.originCombinedValidation\" class=\"error-text\">Enter between 1 and 99 days</span></div></div>\n<div class=\"clear-all-style heading w-80\" ng-click=\"$ctrl.clearAll(\'destination\')\">Clear All</div><div layout=\"column\" \nclass=\"ph-20\"><span class=\"sub-head\">Combined</span><div ng-click=\"$ctrl.disableDestination()\"><span \nclass=\"w-140 panel-select\" layout=\"row\" \nng-class=\"{\'disableField\': $ctrl.combinedDestinationDisabled,\'error-border\':$ctrl.validationObj.destinationCombinedValidation}\">\n<input type=\"number\" ng-class=\"{\'disableField\': $ctrl.combinedDestinationDisabled}\" placeholder=\"Enter Days\" \nng-change=\"$ctrl.dndValidation(\'destinationCombined\')\" ng-model=\"$ctrl.freeDays.destination.combinedDays\" \nclass=\"w-92 border-left panel-select\"> <span class=\"w-50 days-style\">Days</span> </span><span \nng-if=\"$ctrl.validationObj.destinationCombinedValidation\" class=\"error-text\">Enter between 1 and 99 days</span></div>\n</div></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"end center\" class=\"p-20\"><md-button \nmd-no-ink class=\"md-accent-btn w-80 m-0\" title=\"Done\" ng-click=\"$ctrl.closePanel($event)\">Done</md-button></div></div>");
$templateCache.put("app/main/component/incoterm-select/incoterm-select.html","<div id=\"incoterm-select\"><md-select name=\"selectedIncoTerm\" md-on-close=\"$ctrl.fnBindIncoterm()\" \nmd-on-open=\"$ctrl.util.fnSetPanelPosition(\'incoterm-md-select\' , \'md_select_position_incoterm\', $ctrl.selectPanelWidth)\" \nng-model=\"$ctrl.selectedIncoTerm\" placeholder=\"Select Incoterms\" \nmd-container-class=\"multi-select  md_select_position_incoterm\" \nng-class=\"{\'b brad-5\':$ctrl.fullBorder, \'bb\':!$ctrl.fullBorder}\" \nclass=\"md-no-underline mt-5 mb-0 h-36 pl-5 incoterm-md-select\" ng-change=\"$ctrl.changeIncoterm()\"><md-select-header \nclass=\"h-40\"><div style=\"width: 96%\" class=\"mt-5\"><div class=\"search-header\"><input \nng-model-options=\"{debounce : 1000}\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"$ctrl.searchtext\" \nclass=\"md-text search-input\"><md-icon flex=\"10\" md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div></div></md-select-header><md-option ng-value=\"optionVal\" \nng-repeat=\"optionVal in $ctrl.incotermList | filter:$ctrl.searchtext\"><div class=\"option-content\"><div \nclass=\"Font-Bold font-size-13\">{{optionVal.code}} - {{optionVal.mode}}</div><div class=\"font-size-11\">\n{{optionVal.description}}</div></div></md-option><div \nng-if=\"$ctrl.incotermList.length && ($ctrl.incotermList | filter:$ctrl.searchtext).length === 0\" class=\"pl-5 p-5\">\nNo Incoterms found.</div></md-select></div>");
$templateCache.put("app/main/component/load-alias/load-alias.html","<div id=\"panel-load-alias\"><table class=\"p-10 fg-F8F9FA\"><tr class=\"font-size-13 font-bold\"><th>Load Type</th><th \nclass=\"header-container\" layout=\"row\"><div flex=\"70\">Also known as</div><a flex=\"30\" class=\"md-link-fg text-right\" \nng-href=\"{{ctrl.util.sanitizeQueryParams(ctrl.learMoreUrl)}}\" ng-click=\"ctrl.trackEvent(\'learn-more\')\" target=\"_blank\" \nrel=\"noopener\">Learn More</a></th></tr><tr ng-repeat=\"(key, value) in ctrl.load_type_alias\"><td>{{key}}</td><td>\n{{value}}</td></tr></table><div class=\"p-10 fg-F8F9FA\">Note: Select multiple load types to view rates</div></div>");
$templateCache.put("app/main/component/load-detail-selector/load-detail-selector.html","<div id=\"load-detail-select\" class=\"black-fg\"><div class=\"load-detail-select-container\"><div class=\"p-20\"><div \nlayout=\"row\" flex=\"100\" class=\"w-260 h-40 twin-btn mb-20\"><md-button md-no-ink class=\"load-type-btn\" \nng-click=\"ctrl.searchParam.load_data.load_type = \'total_shipment\';\" \nng-class=\"{\'active_load\' : ctrl.searchParam.load_data.load_type === \'total_shipment\' }\">Total Shipment</md-button>\n<md-button md-no-ink class=\"load-type-btn\" ng-click=\"ctrl.searchParam.load_data.load_type = \'units\';\" \nng-class=\"{\'active_load\' : ctrl.searchParam.load_data.load_type === \'units\' }\">Units</md-button></div><div \nclass=\"landscape-width\"><div ng-if=\"ctrl.searchParam.load_data.load_type === \'total_shipment\'\"><div layout=\"row\" \nclass=\"mt-15\"><div class=\"mr-20\"><span class=\"font-size-12 Font-Bold\">Quantity</span><br><input \nclass=\"charge-inputs pl-10 mt-5 w-65\" restrict-to=\"[0-9]\" min=\"1\" type=\"number\" \nng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_meta.total_qty}\" \nng-model=\"ctrl.searchParam.load_data.load_meta.total_qty\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Qty\"></div><div class=\"mr-20\"><span class=\"font-size-12 Font-Bold\">Total Shipment Volume</span><br><div \nclass=\"charge-inputs pl-10 mt-5 w-140\" \nng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_meta.total_volume && ctrl.searchForm.$error.loadDetailError}\" \nlayout=\"row\" flex=\"100\" layou-align=\"space-between\"><input class=\"w-80 border-none\" min=\"0.001\" step=\"any\" \nng-keyup=\"ctrl.decimalFormatter($event);\" type=\"number\" ng-model=\"ctrl.searchParam.load_data.load_meta.total_volume\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Enter volume\"><md-select class=\"border-none m-0\" \nng-model=\"ctrl.searchParam.load_data.load_meta.volume_unit\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-option value=\"CBM\">CBM</md-option><md-option value=\"CFT\">CFT</md-option><md-option \nng-if=\"ctrl.searchParam.mode === \'AIR\'\" value=\"KG\">KG</md-option><md-option ng-if=\"ctrl.searchParam.mode === \'AIR\'\" \nvalue=\"LBS\">LB</md-option></md-select></div></div><div class=\"mr-20\"><span class=\"font-size-12 Font-Bold\">\nTotal Shipment Weight</span><br><div class=\"charge-inputs pl-10 mt-5 w-140\" \nng-class=\"{\'red-border\': !ctrl.searchParam.load_data.load_meta.total_weight && ctrl.searchForm.$error.loadDetailError}\" \nlayout=\"row\" flex=\"100\" layou-align=\"space-between\"><input class=\"w-80 border-none\" min=\"0.001\" step=\"any\" \nng-keyup=\"ctrl.decimalFormatter($event);\" type=\"number\" ng-model=\"ctrl.searchParam.load_data.load_meta.total_weight\" \nplaceholder=\"Enter weight\"><md-select class=\"border-none m-0\" \nng-model=\"ctrl.searchParam.load_data.load_meta.input_weight_unit\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-option value=\"KGs\">KG</md-option><md-option value=\"LBs\">LB</md-option></md-select></div></div></div></div><div \nng-if=\"ctrl.searchParam.load_data.load_type === \'units\'\" class=\"load-units\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"w-100-p\"><div class=\"font-size-12 Font-Bold w-65\">Quantity</div><div \nclass=\"font-size-12 Font-Bold w-265\">Unit Dimension</div><div class=\"font-size-12 Font-Bold w-210\">Total Unit Weight\n</div></div><div layout=\"row\" layout-align=\"space-between\" class=\"w-100-p mt-5 font-size-14\" \nng-repeat=\"load in ctrl.searchParam.load_data.load_details_value track by $index\" ng-class=\"{\'mb-10\': !$last}\"><div>\n<input class=\"charge-inputs pl-10 w-65\" restrict-to=\"[0-9]\" min=\"1\" type=\"number\" ng-class=\"{\'red-border\': !load.qty}\" \nng-model=\"load.qty\" \nng-change=\"ctrl.util.callMixpanel(ctrl.pageSource + \'-Units-Quantity-Change\',{\'mode\': ctrl.searchParam.mode})\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Qty\"></div><div><div class=\"charge-inputs w-265\" \nng-class=\"{\'red-border\': (!load.length || !load.breadth || !load.height) && ctrl.searchForm.$error.loadDetailError}\" \nlayout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"center center\" class=\"pl-10 w-65 border-right\"><input \nclass=\"border-none\" min=\"0.001\" step=\"any\" ng-keyup=\"ctrl.decimalFormatter($event);\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \ntype=\"number\" ng-model=\"load.length\" placeholder=\"L\"></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"pl-10 w-65 border-right\"><input class=\"border-none\" min=\"0.001\" step=\"any\" \nng-keyup=\"ctrl.decimalFormatter($event);\" type=\"number\" ng-model=\"load.breadth\" placeholder=\"W\"></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"pl-10 w-65 border-right\"><input class=\"border-none\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.decimalFormatter($event);\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \ntype=\"number\" ng-model=\"load.height\" placeholder=\"H\"></div><md-select class=\"border-none m-0 pl-10 min-width-50\" \nng-model=\"ctrl.searchParam.load_data.load_meta.dimension_unit\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-option value=\"CMS\">CMS</md-option><md-option value=\"Inches\">Inches</md-option></md-select></div></div><div \nlayout=\"row\" class=\"w-210\"><div class=\"charge-inputs pl-10 w-140 mr-10\" layout=\"row\" flex=\"100\" \nlayou-align=\"space-between\" ng-class=\"{\'red-border\': !load.weight && ctrl.searchForm.$error.loadDetailError}\"><input \nclass=\"w-80 border-none\" min=\"0.001\" step=\"any\" ng-keyup=\"ctrl.decimalFormatter($event);\" type=\"number\" \nng-model=\"load.weight\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Enter weight\"><md-select class=\"border-none m-0\" \nng-model=\"ctrl.searchParam.load_data.load_meta.input_weight_unit\"><md-option value=\"KGs\">KG</md-option><md-option \nvalue=\"LBs\">LB</md-option></md-select></div><div layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-minus-circle-outline\" class=\"s24 red-fg zoom pointer mr-6\" \nng-class=\"{\'disable-opacity\': ctrl.searchParam.load_data.load_details_value.length === 1}\" \nng-click=\"ctrl.searchParam.load_data.load_details_value.length === 1 ? return : ctrl.removeLoad($index, ctrl.searchParam.load_data.load_details_value);ctrl.util.callMixpanel(ctrl.pageSource + \'-Load-Remove-Click\',{\'mode\': ctrl.searchParam.mode})\">\n</md-icon><md-icon \nng-show=\"ctrl.searchParam.load_data.load_details_value.length<25 && (ctrl.searchParam.load_data.load_details_value.length-1 === $index)\" \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s24 green-fg zoom pointer\" \nng-click=\"ctrl.addLoad(ctrl.searchParam.load_data.load_details_value);ctrl.util.callMixpanel(ctrl.pageSource + \'-Load-Add-Click\',{\'mode\': ctrl.searchParam.mode})\">\n</md-icon></div></div></div></div></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"space-between\" \nclass=\"pl-25\"><div layout=\"row\" layout-align=\"center center\"><div class=\"mr-20\"><div class=\"font-size-11\">Gross Weight\n</div><div class=\"font-size-13 Font-Bold\">\n{{ (ctrl.searchParam.load_data.load_meta.gross_weight | weightUnit:\'gross_weight\':ctrl.searchParam.mode | currencyMask: 4) }} {{ctrl.searchParam.mode === \'AIR\' || (ctrl.searchParam.mode == \'SEA-LCL\' && ctrl.weightUnit[ctrl.searchParam.mode] && ctrl.weightUnit[ctrl.searchParam.mode].gross_weight.toLowerCase() == \'kg\') ? \'KG\' : \'MT\' }}\n <span ng-if=\"ctrl.measurementSystem != \'metric\'\">\n/ {{ ctrl.convertedLoad.gross_weight.value | currencyMask: 4}} {{ctrl.convertedLoad.gross_weight.unit}}</span></div>\n</div><div class=\"mr-20\"><div class=\"font-size-11\">Volumetric Weight</div><div class=\"font-size-13 Font-Bold\">\n{{ (ctrl.searchParam.load_data.load_meta.volumetric_weight | currencyMask: 4)}} {{ctrl.searchParam.mode === \'AIR\' ? \'KG\' : \'CBM\' }}\n <span ng-if=\"ctrl.measurementSystem!=\'metric\'\">\n/ {{ ctrl.convertedLoad.volumetric_weight.value | currencyMask: 4}} {{ctrl.convertedLoad.volumetric_weight.unit}}\n</span></div></div><div class=\"mr-20\"><div class=\"font-size-11\">Chargeable Weight</div><div \nclass=\"font-size-13 Font-Bold\">\n{{ (ctrl.searchParam.load_data.load_meta.chargeable_weight | currencyMask: 4) }} {{ctrl.searchParam.mode === \'AIR\' ? \'KG\' : \'W/M\' }}\n</div></div></div><div layout=\"row\" layout-align=\"end center\" class=\"p-10\"><md-button md-no-ink \nclass=\"md-primary-btn w-70 m-0 mr-20\" title=\"Done\" ng-click=\"ctrl.closePanel(\'cancel\')\" \nng-if=\"ctrl.page == \'shipment\'\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn w-70 m-0\" title=\"Done\" \nng-click=\"ctrl.closePanel(\'done\')\">Done</md-button></div></div><div class=\"p-5 pl-25 font-size-11 error-color\" \nng-if=\"ctrl.page == \'shipment\'\">\nNote: Whenever there is a change in the quantity, please update the charges manually in the billing info section.</div>\n</div></div>");
$templateCache.put("app/main/component/load-selector/load-select-wrapper.html","<div style=\"width: 450px\"><load-select ng-if=\"!ctrl.loadDataFactory.panelClosed\" reset-load-obj=\"ctrl.resetLoad()\" \nloadobjects=\"ctrl.loadArray\" callback=\"ctrl.closePanel()\" loadlist=\"ctrl.loadTypeArr\" mode=\"ctrl.mode\" \ntype=\"ctrl.type\"></load-select></div>");
$templateCache.put("app/main/component/load-selector/load-select.html","<div id=\"load-select\"><div class=\"table-wrapper\"><table><tr class=\"border_bottom\"><th class=\"w-90 pl-20 pv-5\">Load Type\n</th><th class=\"w-45 pl-20 pv-5\">Quantity</th><th class=\"pv-5 w-100\"><div>Cargo Weight</div></th><th class=\"w-70\"></th>\n</tr><tr ng-repeat=\"load in $ctrl.loadobjects track by $index\" class=\"vertical-align-top\"><td><md-input-container \nmd-no-float class=\"p-0 m-0\"><md-select ng-model=\"load.type\" name=\"type\" ng-change=\"util.callMixpanel()\" \nmd-selected-text=\"load.type? load.type:\'Choose\'\" placeholder=\"Choose\" \nng-class=\"{\'red-border error-font-load\':!load.type, \'value-placeholder\' : load.type}\" class=\"blue-border-clr w-90\">\n<md-option ng-repeat=\"loadType in $ctrl.loadlist\" ng-disabled=\"$ctrl.loadFilter(loadType, load.type)\" \nng-value=\"$ctrl.mode==\'SEA-FCL\'?loadType.load_code:loadType.code\">\n{{$ctrl.mode==\'SEA-FCL\' ?loadType.load_code:loadType.code}}</md-option></md-select></md-input-container></td><td \nclass=\"pl-2\"><md-input-container md-no-float class=\"p-0 m-0 h-36\"><input restrict-to=\"[0-9]\" min=\"0\" max=\"100\" \ntype=\"number\" ng-model=\"load.count\" ng-class=\"{\'red-border\':!load.count}\" class=\"border-none blue-border-clr w-50\" \nplaceholder=\"Qty\" autocomplete=\"off\"></md-input-container></td><td><div \nclass=\"charge-inputs pl-10 blue-border-clr w-170\" layout=\"row\" layou-align=\"space-between\" \nng-class=\"{\'red-border\':!load.weight_qty}\"><input name=\"cargo-weight\" ng-model=\"load.weight_qty\" restrict-to=\"[0-9.]\" \nmin=\"0\" max=\"{{$ctrl.showLoadMaxErr ? $ctrl.loadTypeObject[load.type].KGS : \'\'}}\" type=\"number\" \nplaceholder=\"Enter Weight\" class=\"border-none w-80\"><md-select class=\"border-left m-0 border-left pl-8\" \nng-model=\"load.weight_unit\"><md-option value=\"KGs\">KG</md-option></md-select><br></div><div \nclass=\"font-size-10 red-fg\" \nng-if=\"$ctrl.showLoadMaxErr && load.type && !(load.weight_qty <= $ctrl.loadTypeObject[load.type].KGS)\">\nEnter cargo weight less than {{$ctrl.loadTypeObject[load.type].KGS}}</div></td><td class=\"icon-td w-70 pt-24\"><md-icon \nmd-font-icon=\"icon-minus-circle-outline\" class=\"s24 red-fg zoom pointer\" \nng-class=\"{\'disable-opacity\': $ctrl.loadobjects.length === 1}\" ng-click=\"$ctrl.removeLoad($index)\"></md-icon><md-icon \nng-show=\"$ctrl.loadobjects.length<4 && ($ctrl.loadobjects.length-1 === $index)\" \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s24 green-fg zoom pointer\" ng-click=\"$ctrl.addLoad()\"></md-icon></td>\n</tr></table><div class=\"max-load-message\" ng-show=\"$ctrl.loadobjects.length===4\"><span>\nLoad type addition is restricted to 4</span></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"end center\" class=\"p-10\"><md-button md-no-ink class=\"md-primary-btn w-70\" title=\"Reset\" \nng-click=\"$ctrl.resetLoad()\">Reset</md-button><md-button md-no-ink class=\"md-accent-btn w-70\" title=\"Done\" \nng-click=\"$ctrl.closePanel($ctrl.loadobjects)\">Done</md-button></div></div>");
$templateCache.put("app/main/component/load-wise-free-days/load-wise-free-days.html","<div id=\"loadWiseFreeDays\" layout=\"row\" ng-if=\"!$ctrl.showNotAvailable\" class=\"pb-30\" \nng-class=\"{\'pb-50\': ! $ctrl.isEdit}\" ng-repeat=\"freeDaysData in $ctrl.loadWiseFreeDaysList track by $index\"><div \nlayout=\"row\"><div layout=\"column\"><span class=\"header-style mb-5\">Load Type</span><md-input-container \nng-if=\"$ctrl.isEdit\" md-no-float class=\"p-0 m-0 panel-select {{freeDaysData.id + \'_loadErrorBorder\'}}\"><md-select \nng-model=\"freeDaysData.loadType\" name=\"type\" md-selected-text=\"freeDaysData.loadType? freeDaysData.loadType:\'Choose\'\" \nplaceholder=\"Choose\" ng-change=\"$ctrl.fnRemoveLoadError(freeDaysData.id);\" \nng-class=\"{\'value-placeholder\' :freeDaysData.loadType}\" \nmd-on-open=\"$ctrl.util.fnSetPanelPosition(\'load-select\'+$index , \'load-type-md-panel\'+$index , \'\' ,\'freeDays\')\" \nclass=\"w-120 m-0 {{\'load-select\'+$index}}\" md-container-class=\"{{\'load-type-md-panel\'+$index}} load-panel-width\">\n<md-option ng-repeat=\"load in $ctrl.loadArray\" ng-disabled=\"$ctrl.loadFilter(load,freeDaysData.loadType)\" \nng-value=\"load\">{{load}}</md-option></md-select></md-input-container><div ng-if=\"!$ctrl.isEdit\" class=\"w-120 mt-10\">\n{{freeDaysData.loadType}}</div><span ng-if=\"$ctrl.isEdit\" \nclass=\"w-122 init-hide {{freeDaysData.id + \'_loadErrorText\'}}\">Please enter the free days</span></div><div \nclass=\"s20 ml-10\" ng-if=\"$ctrl.isEdit\"><md-icon class=\"s20 cursor\" md-font-icon=\"icon-minus-circle-outline red-400-fg\" \ntitle=\"Remove\" ng-click=\"$ctrl.fnRemoveLoad($index , freeDaysData.id)\"></md-icon></div><div class=\"s20 ml-5 mr-10\" \nng-if=\"$ctrl.isEdit\"><md-icon \nng-class=\"{\'disable-opacity\': freeDaysData.loadType == \'All\' || $ctrl.loadArray.length == 1 || $ctrl.disableAddIcon}\" \nclass=\"s20 cursor\" md-font-icon=\"icon-plus-circle-outline green-400-fg\" title=\"Add\" \nng-click=\"$ctrl.fnAddLoad(freeDaysData.loadType)\" ng-if=\"$last \"></md-icon></div></div><div class=\"pl-40\" \nng-class=\"{\'ml-40\':!$ctrl.isEdit}\"><div layout=\"row\" class=\"origin-section\" flex=\"100\"><div \nclass=\"header-style text-left origin-align pr-10\" flex=\"20\" layout=\"row\">Origin</div><div class=\"mb-8\" \nng-repeat=\"tableData in $ctrl.DnD track by $index\"><div class=\"header-style\">{{tableData.title}}</div><div \nng-if=\"$ctrl.isEdit\" class=\"mt-5\"><div class=\"w-170\"><div class=\"w-140 panel-select padding-left\" \nng-class=\"{\'error-border\' :$ctrl.dndValidation(freeDaysData[\'origin\'][tableData.key][\'freeDays\']) }\" layout=\"row\">\n<input ng-model=\"freeDaysData[\'origin\'][tableData.key][\'freeDays\']\" \nng-change=\"$ctrl.fnRemoveLoadError(freeDaysData.id);$ctrl.formatFreeDaysEvent(\'Origin\',tableData.key,\'Days\',freeDaysData[\'origin\'][tableData.key][\'freeDays\'])\" \nng-disabled=\"!freeDaysData.loadType\" type=\"number\" restrict-to=\"[0-9]\" placeholder=\"Enter days\" \nclass=\"w-70 border-left panel-select {{freeDaysData.id + \'_originDnD\'}}\"><div class=\"w-60\"><md-select \nng-model=\"freeDaysData[\'origin\'][tableData.key][\'freeDaysType\']\" class=\"m-0 w-40 free-days-type\" \nmd-selected-text=\"freeDaysData[\'origin\'][tableData.key][\'freeDaysType\'].charAt(0) || \'Type\'\" \nng-change=\"$ctrl.formatFreeDaysEvent(\'Origin\',tableData.key,\'Type\',freeDaysData[\'origin\'][tableData.key][\'freeDaysType\'])\" \nselected=\"\'\'\" name=\"freeDaysTypes\"><md-option ng-repeat=\"type in $ctrl.freeDaysTypeOptions\" ng-value=\"type.value\">\n{{type.name}}</md-option></md-select></div></div></div><span \nng-if=\"$ctrl.dndValidation(freeDaysData[\'origin\'][tableData.key][\'freeDays\'])\" class=\"error-text\">\nEnter between 1 and 99 days</span></div><div layout=\"row\" class=\"w-170\"><div ng-if=\"!$ctrl.isEdit\" class=\"mt-10\">\n{{ freeDaysData[\'origin\'][tableData.key][\'freeDays\'] ? (freeDaysData[\'origin\'][tableData.key][\'freeDays\']) + \' Days\' : \'-\'}}\n</div><div ng-if=\"!$ctrl.isEdit\" class=\"mt-10\">\n{{ freeDaysData[\'origin\'][tableData.key][\'freeDaysType\'] ? \'(\'+freeDaysData[\'origin\'][tableData.key][\'freeDaysType\'].charAt(0)+\')\':\'\'}}\n</div></div></div></div><div layout=\"row\" class=\"destination-section\" flex=\"100\"><div \nclass=\"header-style text-left pr-12 destination-align\" flex=\"20\" layout=\"row\">Destination</div><div \nng-repeat=\"tableData in $ctrl.DnD track by $index\"><div ng-if=\"$ctrl.isEdit\"><div class=\"w-170\"><div \nclass=\"w-140 panel-select padding-left\" \nng-class=\"{\'error-border\' :$ctrl.dndValidation(freeDaysData[\'destination\'][tableData.key][\'freeDays\']) }\" layout=\"row\">\n<input ng-model=\"freeDaysData[\'destination\'][tableData.key][\'freeDays\']\" \nng-change=\"$ctrl.fnRemoveLoadError(freeDaysData.id);$ctrl.formatFreeDaysEvent(\'Destination\',tableData.key,\'Days\',freeDaysData[\'destination\'][tableData.key][\'freeDays\'])\" \nng-disabled=\"!freeDaysData.loadType\" type=\"number\" restrict-to=\"[0-9]\" placeholder=\"Enter days\" \nclass=\"w-70 border-left panel-select {{freeDaysData.id + \'_destinationDnD\'}}\"><div class=\"w-60\"><md-select \nng-model=\"freeDaysData[\'destination\'][tableData.key][\'freeDaysType\']\" class=\"m-0 w-40 free-days-type\" \nng-change=\"$ctrl.formatFreeDaysEvent(\'Destination\',tableData.key,\'Type\',freeDaysData[\'destination\'][tableData.key][\'freeDaysType\'])\" \nmd-selected-text=\"freeDaysData[\'destination\'][tableData.key][\'freeDaysType\'].charAt(0) || \'Type\'\" selected=\"\'\'\" \nname=\"freeDaysTypes\"><md-option ng-repeat=\"type in $ctrl.freeDaysTypeOptions\" ng-value=\"type.value\">{{type.name}}\n</md-option></md-select></div></div></div><span \nng-if=\"$ctrl.dndValidation(freeDaysData[\'destination\'][tableData.key][\'freeDays\'])\" class=\"error-text\">\nEnter between 1 and 99 days</span></div><div layout=\"row\" class=\"w-170\"><div ng-if=\"!$ctrl.isEdit\">\n{{freeDaysData[\'destination\'][tableData.key][\'freeDays\'] ? (freeDaysData[\'destination\'][tableData.key][\'freeDays\']) + \' Days\' :\'-\'}}\n</div><div ng-if=\"!$ctrl.isEdit\">\n{{ freeDaysData[\'destination\'][tableData.key][\'freeDaysType\'] ? \'(\'+freeDaysData[\'destination\'][tableData.key][\'freeDaysType\'].charAt(0)+\')\':\'\'}}\n</div></div></div></div></div></div><div ng-if=\"$ctrl.showNotAvailable && !$ctrl.isEdit\" class=\"ph-20\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><h2>Free days not available</h2></div>");
$templateCache.put("app/main/component/match-my-rates/match-rates.html","<div ng-show=\"!$ctrl.showSuccessMsg && !$ctrl.showErrorMsg \"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div>Request Better Rate</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"$ctrl.closeDialog();$ctrl.fnTrackAnalytics(\'Close-Click\')\"><md-icon class=\"fg-AAA8AD cursor\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form \nname=\"matchRates_form\" ng-submit=\"$ctrl.submitMatchRates(matchRates_form)\"><div layout=\"row\" class=\"dialog-content\" \nflex><md-dialog-content><div layout=\"row\"><div layout-align=\"start start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'/assets/icons/custom/ic_chat_bubble_24px.svg\')\" class=\"icon-rbr\"></div></div><div \nflex=\"94\" layout-align=\"start center\"><div layout=\"column\" flex=\"100\"><label class=\"mb-6\">Reason</label>\n<md-input-container md-no-float class=\"height-container inputwidth100\"><textarea id=\"reason\" rows=\"2\" cols=\"70\" \nng-model=\"$ctrl.matchRatesObj.data.reason_for_revising\" name=\"reason\" placeholder=\"Enter the reason here\" \nng-keyup=\"$ctrl.validationObj.reasonValidation=false;\" class=\"textarea-border\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.reasonValidation}\"></textarea></md-input-container><div \nng-if=\"$ctrl.validationObj.reasonValidation\" class=\"validation-error-text\"><span>\nEnter the relevant reason for Requesting Better Rates.</span></div></div></div></div><div layout=\"row\" \nclass=\"row-spacing\"><div layout-align=\"start start\" class=\"pr-15\"><div \nstyle=\"background-image: url(\'assets/images/fb_shipper/Image 279.png\')\" class=\"icon-rbr-big\"></div></div><div \nflex=\"94\" class=\"inputwidth100\"><div layout=\"column\" flex=\"100\"><label class=\"mb-6\">Commodity Details</label><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container flex=\"40\" flex-xs=\"100\" class=\"feild-spacing\" flex md-no-float>\n<cargo-type-selection full-border=\"true\" cargo-type-data=\"$ctrl.matchRatesObj.data.req_cargo_type_data\" \nis-required=\"false\" page-source=\"$ctrl.pageSource\" is-valid=\"false\" \nhazardous-value=\"$ctrl.matchratesparam.search_param.hazardous_material\" category=\"\'RBR\'\" mode=\"$ctrl.mode\">\n</cargo-type-selection></md-input-container><div class=\"feild-spacing custom-spacing mobile-spacing\">\n<md-input-container class=\"commodity_input\" flex=\"60\" flex-xs=\"100\" md-no-float><commodity-chips \nmd-input-id=\"\'commodity_id_rfq\'\" category=\"\'RBR\'\" commodity-array=\"$ctrl.matchRatesObj.data.req_commodity_data\" \npage-source=\"$ctrl.pageSource\" is-valid=\"false\"></commodity-chips></md-input-container></div></div></div></div></div>\n<div layout=\"row\" class=\"row-spacing mb-20\" ng-if=\"$ctrl.matchratesparam.search_param.hazardous_material\"><div \nlayout-align=\"start start\" class=\"pr-15\"><div style=\"background-image: url(\'assets/images/fb_shipper/Image 286.png\')\" \nclass=\"icon-rbr-big\"></div></div><div flex=\"94\" class=\"inputwidth100\"><div layout=\"column\" flex=\"100\"><label \nclass=\"mb-6\">Hazardous Cargo Details</label><div layout=\"row\" layout-xs=\"column\"><div layout=\"column\"><md-select \nng-change=\"$ctrl.validationObj.imcoValidationError=false;\" name=\"type\" ng-model=\"$ctrl.matchRatesObj.data.imco_code\" \nclass=\"code-box mt-0 w-160 panel-select feild-spacing multiselectBox imco_div\" placeholder=\"IMCO Code\" \nng-disabled=\"!$ctrl.matchratesparam.search_param.hazardous_material\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.imcoValidationError}\"><md-option class=\"mb-10\" style=\"height:100%\" \nng-value=\"0\">Select IMCO code</md-option><md-option class=\"mb-10\" style=\"height:100%\" \nng-repeat=\"imcoCode in $ctrl.IMCO_CodeList track by $index\" ng-value=\"imcoCode.class_number\"><span \nclass=\"font-weight-600\">{{imcoCode.class_name}}</span><br><span class=\"gray-fg font-size-12\" \nng-repeat=\"list in imcoCode.list track by $index\">{{list}}<br></span></md-option></md-select><div \nng-if=\"$ctrl.validationObj.imcoValidationError\" class=\"pt-5 validation-error-text\"><span class=\"error\">\nPlease select imco code</span></div></div><div class=\"feild-spacing custom-spacing mobile-spacing\"><md-input-container \nmd-no-float class=\"p-0 m-0 panel-select search_select_box\" title=\"UN Number\"><input type=\"number\" min=\"0\" \nrestrict-to=\"[0-9]\" ng-model=\"$ctrl.matchRatesObj.data.un_num\" class=\"border-none font-size-12 font-weight-600\" \nplaceholder=\"Enter UN Number\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n</md-input-container></div><div class=\"mobile-spacing\"><div class=\"w-120\"><div \nng-if=\"!$ctrl.msds_document && !$ctrl.msdsProgress\"><md-button md-no-ink class=\"md-link-btn ph-15 h-36\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.msdsValidationError}\" \nng-click=\"$ctrl.selectFile(\'msds\');$ctrl.validationObj.msdsValidationError = false\">Upload MSDS</md-button><input \nname=\"msds_file\" type=\"file\" id=\"fileInput_msds\" ng-change=\"$ctrl.setFile($ctrl.msds_document,\'msds\');\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nngf-select ng-model=\"$ctrl.msds_document\" ngf-max-size=\"5MB\" \naccept=\".xls,.doc,.docx,application/pdf,application/vnd.ms-excel,image/*\" \nngf-pattern=\"\'.pdf,.xls,.csv,.xlsx,.doc,.docx,image/*\'\" ngf-model-invalid=\"errorFile\" hide><br><span \nng-show=\"matchRates_form.msds_file.$error.maxSize\" class=\"validation-error-text\">\nThis file is too large, maximum file size is 5MB.</span> <span ng-show=\"matchRates_form.msds_file.$error.pattern\" \nclass=\"validation-error-text\">Please upload only pdf format files.</span> <span \nng-show=\"$ctrl.validationObj.msdsValidationError && (!matchRates_form.msds_file.$error.maxSize && !matchRates_form.msds_file.$error.pattern)\" \nclass=\"validation-error-text\"><span>Please upload MSDS file</span></span></div><div \nng-if=\"$ctrl.msds_document && !$ctrl.msdsProgress\"><div class=\"grey-fg font-size-11\">MSDS Document</div><div \nlayout=\"row\"><span class=\"font-weight-600 text-trunacte fg-3B82F6 max-width-120 text-ellipsis\">\n{{$ctrl.msds_document.name}}</span><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"s16 remove-icon\" \nng-click=\"$ctrl.msds_document = null; $ctrl.setFile($ctrl.msds_document,\'msds\');\" ng-show=\"$ctrl.msds_document\">\n</md-icon></div></div><div ng-if=\"$ctrl.msdsProgress\"><div class=\"grey-fg font-size-12\">MSDS Document</div>\n<md-progress-linear md-mode=\"indeterminate\" class=\"p-15 mt-5\"></md-progress-linear></div></div></div></div></div></div>\n</div><div layout=\"row\" ng-class=\"{\'row-spacing\':!$ctrl.matchratesparam.search_param.hazardous_material}\"><div \nlayout-align=\"start start\" class=\"pr-20\"><div style=\"background-image: url(\'assets/icons/custom/atm_24px.svg\')\" \nclass=\"icon-rbr\"></div></div><div flex=\"94\" layout-align=\"start center\" ng-if=\"$ctrl.mode == \'SEA-FCL\'\"><div \nlayout=\"column\" flex=\"100\"><div layout=\"row\" class=\"w-450 mb-6\" layout-align=\"space-between\"><label>\nEnter Your Expectations</label><label layout-align=\"end center\">Cargo Wt. (Per Container)</label></div><div \nlayout=\"row\" flex=\"100\" ng-repeat=\"load in $ctrl.matchRatesObj.data.target_load_data.load_details_value\" \nng-class=\"{\'row-spacing\':$index>0}\"><md-input-container flex=\"20\" class=\"load-disabled\" flex md-no-float><span>\n{{load.type}}</span></md-input-container><div layout-align=\"center center\" layout=\"row\" flex=\"100\" \nclass=\"border load_div h-36 pl-0 ml-20 mr-20 w-210 target_rate_div\"><input name=\"target_rate\" type=\"number\" min=\"-99\" \nmax=\"99999\" step=\"any\" ng-model=\"load.target_rate\" placeholder=\"Enter Target Rate\" \nclass=\"border-none font-size-12 w-110 pb-0\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\"><div\n layout=\"row\" layout-align=\"center center\"><md-select \nclass=\"m-0 currency-border border-left w-100 pr-8 pl-5 h-36 pt-3 select-class\" ng-model=\"load.target_rate_currency\" \nplaceholder=\"INR\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n<md-option ng-repeat=\"curr in $ctrl.currencyList track by $index\" ng-value=\"curr\">{{curr}}</md-option></md-select>\n</div></div><div layout=\"column\" flex=\"100\" class=\"feild-spacing h-36\"><div layout-align=\"center center\" layout=\"row\" \nflex=\"100\"><div class=\"border load_div w-200 target_rate_div\" layout=\"row\" layout-align=\"center center\">\n<md-input-container md-no-float class=\"p-0 mt-0 mb-0 w-100 mh-0 h-36\"><input name=\"target_rate\" type=\"number\" \nmin=\"-99\" max=\"99999\" step=\"any\" ng-model=\"load.load_metrics.weight_qty\" placeholder=\"Enter Weight\" \nclass=\"border-none font-size-12 h-36\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n</md-input-container><div layout=\"row\" layout-align=\"center center\"><md-select \nclass=\"m-0 border-left w-100 pr-8 pl-5 h-36 pt-3 select-class\" ng-model=\"load.load_metrics.weight_unit\" \nng-change=\"$ctrl.fnTrackAnalytics(\'Cargo-Unit-Change\')\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n<md-option value=\"KGs\" selected=\"selected\" class=\"cargo_option border-none\">KG</md-option><md-option value=\"Tons\" \nclass=\"cargo_option\">MT</md-option></md-select></div></div></div></div></div></div></div><div flex=\"94\" \nlayout=\"column\" ng-if=\"$ctrl.mode !== \'SEA-FCL\' && $ctrl.matchRatesObj.data.target_load_data.load_type != \'units\'\"><div\n layout=\"row\"><div layout=\"column\"><label class=\"mb-6\">Total Shipment Volume</label><div layout=\"row\" \nclass=\"target_rate_div\"><div layout=\"row\" class=\"load_border_clr w-150 brad-5 p-2 panel-select-disabled h-26\">\n<md-input-container md-no-float class=\"m-0 p-0 h-30\"><div class=\"total-input-div\">\n{{$ctrl.matchRatesObj.data.target_load_data.load_meta.total_volume | currencyMask : 2}}</div></md-input-container>\n<md-select name=\"volume_unit\" class=\"m-0 load_border_clr border-left ph-5\" \nng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.volume_unit\" required ng-disabled=\"true\"><md-option \nvalue=\"CBM\" selected=\"selected\">CBM</md-option><md-option value=\"CFT\">CFT</md-option></md-select></div></div></div><div\n layout=\"column\" class=\"ml-20 mr-20\"><label class=\"mb-6\">Total Shipment Wt.</label><div layout=\"row\" \nlayout-align=\"center center\" class=\"target_rate_div\"><div layout=\"row\" \nclass=\"load_border_clr p-2 w-150 panel-select-disabled brad-5 h-26\"><md-input-container md-no-float \nclass=\"m-0 p-0 h-30\"><div class=\"total-input-div\">\n{{$ctrl.matchRatesObj.data.target_load_data.load_meta.total_weight | currencyMask : 2}}</div></md-input-container>\n<md-select name=\"input_weight_unit\" class=\"m-0 load_border_clr border-left ph-5\" \nng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.input_weight_unit\" required ng-disabled=\"true\"><md-option\n value=\"KGs\">KG</md-option><md-option value=\"LBs\">LB</md-option></md-select></div></div></div></div><div \nlayout=\"column\" class=\"row-spacing\"><label class=\"mb-6\">Target Rate <span ng-if=\"$ctrl.mode === \'AIR\'\">(per KG)</span> \n<span ng-if=\"$ctrl.mode === \'SEA-LCL\'\">(per W/M)</span></label><div class=\"target_rate_div\" layout=\"column\"><div \nlayout=\"row\" class=\"load_div w-150 brad-5 b h-36\" ng-class=\"{\'validation-error\':$ctrl.validationObj.targetValidation}\">\n<md-input-container md-no-float class=\"m-0 p-0 h-30\"><input name=\"target_rate\" type=\"number\" min=\"-99\" max=\"99999\" \nng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.target_rate\" placeholder=\"Target Rate\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nclass=\"checkbox_input border-none insurance_input h-36\" ng-keyup=\"$ctrl.validationObj.targetValidation=false\">\n</md-input-container><md-select class=\"m-0 border-left ph-5 curr-select pr-4\" \nng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.target_rate_currency\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nrequired><md-option ng-repeat=\"curr in $ctrl.currencyList | filter : searchCurr track by $index\" ng-value=\"curr\">\n{{curr}}</md-option></md-select></div><div ng-if=\"$ctrl.validationObj.targetValidation\" class=\"validation-error-text\">\nEnter Target Rate</div></div></div></div><div flex=\"94\" layout=\"column\" \nng-if=\"$ctrl.mode !== \'SEA-FCL\' && $ctrl.matchRatesObj.data.target_load_data.load_type == \'units\'\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"100\" \nng-repeat=\"load in $ctrl.matchRatesObj.data.target_load_data.load_details_value track by $index\" \nng-class=\"{\'row-spacing\':$index>0}\"><div layout=\"column\" class=\"mr-20\"><label ng-if=\"$index==0\" class=\"mb-6\">\nUnit Dimensions</label><div layout-align=\"center center\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex=\"100\" \nclass=\"flex w-240 brad-5 panel-select-disabled h-36 load_border_clr dimension_div\"><md-input-container md-no-float \nclass=\"br load_border_clr\"><div class=\"unit-input-div\">{{load.length | currencyMask : 2}}<md-tooltip \nmd-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{load.length | currencyMask : 2}}</span>\n</md-tooltip></div></md-input-container><md-input-container md-no-float class=\"br load_border_clr\"><div \nclass=\"unit-input-div\">{{load.breadth | currencyMask : 2}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{load.breadth | currencyMask : 2}}</span>\n</md-tooltip></div></md-input-container><md-input-container md-no-float class=\"br load_border_clr\"><div \nclass=\"unit-input-div\">{{load.height | currencyMask : 2}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{load.height | currencyMask : 2}}</span>\n</md-tooltip></div></md-input-container><md-input-container class=\"p-5 target_rate_div\" md-no-float><md-select \nname=\"dimension_unit\" ng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.dimension_unit\" \nclass=\"pr-5 h-36 pl-4 checkbox_input\" required ng-disabled=\"true\"><md-option value=\"CMS\" selected=\"selected\">CMS\n</md-option><md-option value=\"Inches\">Inches</md-option></md-select></md-input-container></div></div></div><div \nlayout=\"column\"><label ng-if=\"$index==0\" class=\"mb-6\">Unit Gross Wt.</label><div layout-align=\"center center\" \nlayout=\"row\" flex=\"100\" class=\"target_rate_div\"><div layout=\"row\" \nclass=\"panel-select-disabled load_border_clr w-110 brad-4 h-36\"><md-input-container md-no-float class=\"m-0 p-0\"><div \nclass=\"unit-input-div\">{{load.weight | currencyMask : 2}}</div></md-input-container><md-select name=\"weight_unit\" \nng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.input_weight_unit\" \nclass=\"m-0 load_border_clr border-left\" required ng-disabled=\"true\"><md-option value=\"KGs\">KG</md-option><md-option \nvalue=\"LBs\">LB</md-option></md-select></div></div></div></div><div layout=\"column\" class=\"row-spacing\"><label \nclass=\"mb-6\">Target Rate <span ng-if=\"$ctrl.mode === \'AIR\'\">(per KG)</span> <span ng-if=\"$ctrl.mode === \'SEA-LCL\'\">\n(per W/M)</span></label><div class=\"target_rate_div\" layout=\"column\"><div layout=\"row\" \nclass=\"load_div w-130 brad-4 b h-36\" ng-class=\"{\'validation-error\':$ctrl.validationObj.targetValidation}\">\n<md-input-container md-no-float class=\"m-0 p-0\"><input name=\"target_rate\" type=\"number\" min=\"-99\" max=\"99999\" \nng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.target_rate\" placeholder=\"Target Rate\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nclass=\"checkbox_input h-36 border-none insurance_input h-26\" ng-keyup=\"$ctrl.validationObj.targetValidation=false\">\n</md-input-container><md-select class=\"m-0 pl-4 pr-4 border-left curr-select\" \nng-model=\"$ctrl.matchRatesObj.data.target_load_data.load_meta.target_rate_currency\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nrequired><md-option ng-repeat=\"curr in $ctrl.currencyList | filter : searchCurr track by $index\" ng-value=\"curr\">\n{{curr}}</md-option></md-select></div><div ng-if=\"$ctrl.validationObj.targetValidation\" class=\"validation-error-text\">\nEnter Target Rate</div></div></div></div></div><div layout=\"row\" class=\"row-spacing\"><div layout-align=\"start start\" \nclass=\"pr-20\"><md-icon md-svg-icon=\"assets/icons/custom/ship-fill.svg\" class=\"fg-333333 icon-rbr\" \nng-show=\"$ctrl.mode != \'AIR\'\"></md-icon><div ng-show=\"$ctrl.mode == \'AIR\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"grey-fg icon-rbr\"></div></div><div \nflex=\"94\" layout=\"row\" layout-xs=\"column\"><div layout=\"column\" flex-xs=\"100\" ng-if=\"$ctrl.mode != \'AIR\'\" \nclass=\"w-200 feild-spacing\"><label class=\"mb-6\">Preferred Liner Name</label><md-input-container md-no-float \nclass=\"select-pt-0 mt-6 mb-0 mh-0 panel-select\"><md-select class=\"mt-3 pr-4 multi-select-width\" name=\"selectLiner\" \nng-model=\"$ctrl.matchRatesObj.data.carrier_preference\" md-on-close=\"searchCarrier=\'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"Select Liner Preference\" \nng-click=\"$ctrl.trackEvent(\'RBR-POP-Liner\',$ctrl.matchRatesObj.data.carrier_preference)\" multiple=\"multiple\">\n<md-select-header><input class=\"demo-select-header\" ng-model=\"searchCarrier\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\" placeholder=\"Search for a liner..\" class=\"demo-header-searchbox md-text\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n</md-select-header><md-optgroup label=\"liners\"><md-option \nng-repeat=\"subvendor in $ctrl.getSubvendor |\n                                filter: {\'name\': searchCarrier } track by subvendor.id\" \nng-value=\"subvendor\" title=\"{{subvendor.name}}\">{{subvendor.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" ng-if=\"$ctrl.mode == \'AIR\'\" flex-xs=\"100\" class=\"w-200 feild-spacing\">\n<label class=\"mb-6\">Preferred Airline Name</label><md-input-container md-no-float \nclass=\"select-pt-0 max-width liner-select pr-4 mt-6 mb-0 mh-0 panel-select\"><md-select \nng-model=\"$ctrl.matchRatesObj.data.airline_preference\" name=\"airline_preference\" \nplaceholder=\"Select Airline Name Here\" class=\"pt-1 m-0 h-36 multi-select-width\" multiple=\"multiple\"><md-select-header>\n<input ng-model=\"searchAirline\" type=\"search\" placeholder=\"Search Airline\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n</md-select-header><md-option \nng-repeat=\"airline in $ctrl.getAirline | orderBy:\'name\' | filter : {\'air_line_name\':searchAirline } \" \nng-value=\"airline\" title=\"{{airline.air_line_name}}\">{{airline.air_line_name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" class=\"feild-spacing mobile-spacing\" flex-xs=\"100\"><label>\nPreferred Sailing Date</label><date-picker md-input-id=\"\'cargo_date\'\" \nis-validate=\"(($ctrl.validationObj.sailingValidation) || (rfqForm.cargo_date.$touched && rfqForm.cargo_date.$error.valid))\" \nmodel-value=\"$ctrl.matchRatesObj.data.preferred_sailing_date\" is-editable=\"true\" is-disabled=\"false\" \nfull-border=\"true\" input-required=\"true\" input-name=\"\'cargo_date\'\" full-border=\"true\" date-placeholder=\"\'Enter date\'\" \ndate-format=\"true\" min-date-value=\"$ctrl.startDateStart\" \ncallback=\"$ctrl.matchRatesObj.data.preferred_sailing_date= value;$ctrl.validationObj.sailingValidation=false\">\n</date-picker><div \nng-messages=\"!$ctrl.validationObj.sailingValidation && (rfqForm.cargo_date.$touched && rfqForm.cargo_date.$error)\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"$ctrl.validationObj.sailingValidation\" class=\"validation-error-text\">Select Preferred Sailing Date</div></div>\n<div layout=\"column\" class=\"feild-spacing mobile-spacing\" flex-xs=\"100\"><label class=\"mb-6\">Free Days</label><input \ntype=\"number\" min=\"0\" max=\"99\" restrict-to=\"[0-9]\" ng-model=\"$ctrl.matchRatesObj.data.demurrage_detention\" \nclass=\"panel-select font-size-12\" placeholder=\"Detention Days\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n</div></div></div><div layout=\"row\" class=\"row-spacing\"><div layout-align=\"start start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/charges.svg\')\" class=\"icon-rbr\"></div></div><div \nflex=\"94\" layout-align=\"start center\"><div layout=\"column\" flex=\"100\"><label class=\"mb-6\">Locals & Custom Charges\n</label><md-menu md-position-mode=\"left bottom\"><div><md-input-container md-no-float class=\"p-0 m-0\"><div \nclass=\"panel-select w-150 panelSelect-charge pointer mobile_input\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"$mdMenu.open()\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"80\"><div \ntruncate=\"{{$ctrl.detailBoxString}}\" class=\"mt-2 pv-5 hide-overflow text-truncate\">{{$ctrl.detailBoxString}}<md-tooltip\n md-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.detailBoxTooltip}}</span>\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\"></md-icon></div>\n</md-input-container></div><md-menu-content class=\"p-10\"><md-menu-item><md-checkbox md-no-ink \nng-model=\"$ctrl.matchRatesObj.data.origin_charges\" ng-change=\"$ctrl.fnStuffingEnable();$ctrl.fnStuffingEnable();\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nclass=\"w-250\"><span class=\"checkbox_text font-size-12\" \nng-class=\"{\'black-fg\' : $ctrl.matchRatesObj.data.origin_charges}\">Origin Charges</span></md-checkbox></md-menu-item>\n<md-menu-item><md-checkbox md-no-ink ng-model=\"$ctrl.matchRatesObj.data.origin_customs\" class=\"w-250\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n<span class=\"checkbox_text checkbox_text font-size-12\" \nng-class=\"{\'black-fg\' : $ctrl.matchRatesObj.data.origin_customs}\">Origin Customs Clearance</span></md-checkbox>\n</md-menu-item><md-menu-item><md-checkbox md-no-ink ng-model=\"$ctrl.matchRatesObj.data.destination_charges\" \nclass=\"w-250\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n<span class=\"checkbox_text font-size-12\" ng-class=\"{\'black-fg\' : $ctrl.matchRatesObj.data.destination_charges}\">\nDestination Charges</span></md-checkbox></md-menu-item><md-menu-item><md-checkbox md-no-ink \nng-model=\"$ctrl.matchRatesObj.data.destination_customs\" class=\"w-250\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n<span class=\"checkbox_text font-size-12\" ng-class=\"{\'black-fg\' : $ctrl.matchRatesObj.data.destination_customs}\">\nDestination Customs Clearance</span></md-checkbox></md-menu-item></md-menu-content></md-menu></div></div></div>\n</md-dialog-content></div><md-dialog-actions layout=\"row\"><div layout-align=\"end center\" class=\"mv-10\"><md-button \nmd-no-ink class=\"md-primary-btn mr-10\" ng-click=\"$ctrl.closeDialog();$ctrl.fnTrackAnalytics(\'Cancel-Click\')\" \ntitle=\"Cancel\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Confirm\" \nng-disabled=\"$ctrl.matchBtn\">Send Request</md-button></div></md-dialog-actions></form></div><div \nng-show=\"$ctrl.showSuccessMsg\"><div layout=\"row\" layout-align=\"end end\" class=\"p-8\" hide-xs><div><md-icon \nmd-font-icon=\"icon-close\" class=\"grey-fg pointer\" ng-click=\"$ctrl.fnSuccessDone()\"></md-icon></div></div><div \nlayout=\"column\" layout-padding class=\"pt-20 ph-30 pb-30\"><div layout=\"column\" layout-align=\"center center\"><md-icon \nmd-svg-icon=\"assets/icons/custom/approved-signal.svg\" class=\"w-100 h-100 match_icon\"></md-icon><div \nclass=\"font-size-16 font-weight-600 green-fg mv-15\">Inquiry Received !</div><div \nclass=\"font-size-14 font-weight-600 grey-fg\">You shall receive competitive rates at the</div><div \nclass=\"font-size-14 font-weight-600 grey-fg\">earliest from pricing team</div></div></div><div \nclass=\"font-weight-600 font-size-14 footer_sec\"><div layout=\"row\" flex=\"100\"><md-button md-no-ink flex \nclass=\"white-fg m-0 font-weight-600 success_btn brad-1 h-55\" ng-click=\"$ctrl.fnSuccessDone()\" title=\"Cancel\" flex=\"50\">\nDone</md-button></div></div></div><div ng-show=\"$ctrl.showErrorMsg \"><div layout=\"row\" layout-align=\"end end\" \nclass=\"p-8\"><div><md-icon md-font-icon=\"icon-close\" class=\"grey-fg pointer\" ng-click=\"$ctrl.closeDialog()\"></md-icon>\n</div></div><div layout=\"column\" layout-padding class=\"pt-5 ph-30 pb-30\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-svg-icon=\"assets/icons/custom/req-error.svg\" class=\"w-95 h-95\"></md-icon><div \nclass=\"font-size-16 font-weight-600 red-300-fg mt-15 mb-5\">OUCH ! YOUR REQUEST FAILED</div><div \nclass=\"font-size-14 font-weight-600 grey-fg\">Ooops , the request you made didn’t reach us.</div><div \nclass=\"font-size-14 font-weight-600 grey-fg\">We are looking into the issue !</div></div></div><div \nclass=\"font-weight-600 font-size-14 footer_sec\"><div layout=\"row\" flex=\"100\"><md-button md-no-ink flex \nclass=\"white-fg m-0 font-weight-600 try_again_btn brad-1 h-55\" \nng-click=\"$ctrl.showSuccessMsg = false; $ctrl.showErrorMsg = false;\" title=\"Cancel\" flex=\"50\">TRY AGAIN</md-button>\n</div></div></div>");
$templateCache.put("app/main/component/multi-select/multi-select.html","<div id=\"multi-select\"><md-select md-selected-html=\"\'\'\" ng-model=\"$ctrl.queryConditions.selectedOptions\" \nng-model-options=\"{trackBy: \'$value.id ? $value.id : $value.port_code ? $value.port_code : $value.carrier_code ? $value.carrier_code : $value.name\'}\" \nid=\"{{$ctrl.mdInputId}}\" md-on-close=\"$ctrl.fnSaveSelectedOptions()\" md-container-class=\"multi-select w-255 pb-0 mb-0\" \nclass=\"md-no-underline\" multiple=\"multiple\"><md-select-header class=\"row\"><div layout=\"row\" class=\"filter-controler\">\n<div flex=\"33\">Filter</div><div flex=\"66\" class=\"text-right\"><div class=\"clear-all mr-5\" \nng-click=\"$ctrl.fnClearFilter()\">Clear</div><div class=\"select-all ml-2\" ng-click=\"$ctrl.fnSelectAll()\">Select All\n</div></div></div><div style=\"width: 96%\"><div class=\"search-header\"><input ng-model-options=\"{debounce : 1000}\" \ntype=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"$ctrl.searchtext\" \nng-change=\"$ctrl.getListBySearch($ctrl.searchtext);\" placeholder=\"{{$ctrl.queryConditions.placeholder}}\" \nclass=\"md-text search-input\" md-select-on-focus=\"\"><md-icon flex=\"10\" md-font-icon=\"icon-magnify\" \nclass=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div></div></md-select-header><div layout=\"column\" flex=\"100\" \nlayout-wrap layout-align=\"center center\" ng-if=\"$ctrl.queryConditions.filterLoader\" class=\"mv-20 pt-10\">\n<md-progress-circular></md-progress-circular></div><div \nng-repeat=\"(key, listDataObj) in $ctrl.optionsListData track by $index\"><div \nng-if=\"listDataObj.length !== 0 && listDataObj !== null && $ctrl.groupsObj[key]\"><div class=\"sticky-header\" \nng-if=\"key !== \'customIndex\' && $ctrl.groupsObj[key].groupTitle \">{{ $ctrl.groupsObj[key].groupTitle | lowercase }}\n</div><md-option ng-value=\"optionVal\" ng-click=\"$ctrl.isUpdateState = true;\" ng-repeat=\"optionVal in listDataObj\"><span\n ng-if=\"key !== \'customIndex\'\" ng-hide=\"true\">{{ optionVal.groupType = key }}</span><div \nng-if=\"optionVal.type && optionVal.type === \'Airport\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg port-icon\"></div><div \nng-if=\"optionVal.type && optionVal.type === \'Port\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg port-icon\"></div><div \nng-if=\"optionVal.port_code\" class=\"port_code\">{{ optionVal.port_code }}</div><div \nng-class=\"{\'is-port-icon\': optionVal.type === \'Airport\' || optionVal.type === \'Port\'}\"><div class=\"title-text\" \nng-if=\"!$ctrl.queryConditions.isUpperCase\" \nng-bind-html=\"$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle]  | lowercase,optionVal)\"></div><div \nclass=\"title-text\" ng-if=\"$ctrl.queryConditions.isUpperCase\" \nng-bind-html=\"$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle]  | uppercase,optionVal)\"></div><small\n \nng-bind-html=\"optionVal[$ctrl.groupsObj[key].subKeyTitle] !== \'\' ? $ctrl.util.searchHighlight(optionVal[$ctrl.groupsObj[key].subKeyTitle] | lowercase ,$ctrl.searchtext) : \'\' \">\n</small> <small \nng-bind-html=\"key === \'user\' ? \' | \' + $ctrl.util.searchHighlight(optionVal.company_name | lowercase,$ctrl.searchtext ) : \'\'\">\n</small></div></md-option></div></div><div ng-if=\"$ctrl.optionsListData !== null && $ctrl.totalListCount === 0\" \nclass=\"ph-10 pb-10 fg-AAA8AD\">No Result Match Found</div><div \nng-if=\"$ctrl.optionsListData !== null && $ctrl.totalListCount !== 0\" layout=\"row\" layout-align=\"center center\" \nclass=\"save-selected-button\" ng-click=\"$ctrl.mdSelect.hide()\">Done</div></md-select></div>");
$templateCache.put("app/main/component/multi-select-chips/multi-select-chips.html","<div id=\"multi-select-chip\"><md-select md-selected-html=\"$ctrl.queryConditions.placeholder\" \nng-model=\"$ctrl.queryConditions.selectedOptions\" \nng-model-options=\"{trackBy: \'$value.id ? $value.id : $value.port_code ? $value.port_code : $value.quote_id ? $value.quote_id : $value.code? $value.code : ($value.carrier_code?$value.carrier_code:$value.agent_id)\'}\" \nid=\"{{$ctrl.mdInputId}}\" md-on-close=\"$ctrl.fnSaveSelectedOptions()\" \nmd-container-class=\"multi-select-chip w-255 pb-0 mb-0\" multiple=\"multiple\"><md-select-header><div \nclass=\"search-header\"><input ng-model-options=\"{debounce : 1000}\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"$ctrl.searchtext\" ng-change=\"$ctrl.getListBySearch($ctrl.searchtext);\" \nplaceholder=\"{{$ctrl.queryConditions.placeholder}}\" class=\"md-text search-input\" md-select-on-focus=\"\"><md-icon \nflex=\"10\" md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div></md-select-header><div \nlayout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"$ctrl.queryConditions.filterLoader\" \nclass=\"mv-20 pt-10\"><md-progress-circular></md-progress-circular></div><div \nng-repeat=\"(key, listDataObj) in $ctrl.optionsListData track by $index\"><div \nng-if=\"listDataObj.length !== 0 && listDataObj !== null && $ctrl.groupsObj[key]\"><div class=\"sticky-header\" \nng-if=\"key !== \'customIndex\' && $ctrl.groupsObj[key].groupTitle \">{{ $ctrl.groupsObj[key].groupTitle | lowercase }}\n</div><md-option ng-value=\"optionVal\" ng-click=\"$ctrl.isUpdateState = true;\" ng-repeat=\"optionVal in listDataObj\"><span\n ng-if=\"key !== \'customIndex\'\" ng-hide=\"true\">{{ optionVal.groupType = key }}</span><div \nng-if=\"optionVal.type && optionVal.type === \'Airport\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg port-icon\"></div><div \nng-if=\"optionVal.type && optionVal.type === \'Port\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg port-icon\"></div><div \nng-if=\"optionVal.port_code\" class=\"port_code\" title=\"{{optionVal.port_code}}\">{{ optionVal.port_code }}</div><div \nng-class=\"{\'is-port-icon\': optionVal.type === \'Airport\' || optionVal.type === \'Port\'}\"><div class=\"title-text\" \nng-if=\"!$ctrl.queryConditions.isUpperCase && !$ctrl.queryConditions.ignoreCaseChange\" \ntitle=\"{{$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle]  | lowercase,optionVal)}}\" \nng-bind-html=\"$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle] | lowercase,optionVal)\"></div><div \nclass=\"title-text\" ng-if=\"!$ctrl.queryConditions.isUpperCase && $ctrl.queryConditions.ignoreCaseChange\" \ntitle=\"{{$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle],optionVal)}}\" \nng-bind-html=\"$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle],optionVal)\"></div><div \nclass=\"title-text\" ng-if=\"$ctrl.queryConditions.isUpperCase\" \ntitle=\"{{$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle]  | uppercase,optionVal)}}\" \nng-bind-html=\"$ctrl.searchTitleHighlight(optionVal[$ctrl.groupsObj[key].keyTitle]  | uppercase,optionVal)\"></div><small\n \nng-bind-html=\"optionVal[$ctrl.groupsObj[key].subKeyTitle] !== \'\' ? $ctrl.util.searchHighlight(optionVal[$ctrl.groupsObj[key].subKeyTitle] | lowercase ,$ctrl.searchtext) : \'\' \">\n</small> <small \nng-bind-html=\"key === \'user\' ? \' | \' + $ctrl.util.searchHighlight(optionVal.company_name | lowercase ,$ctrl.searchtext ) : \'\'\">\n</small> <small compile-html=\"optionVal.quote_id ? \' | \' + (optionVal.created_at | date : \'dd MMM yyyy\'): \'\'\"></small>\n</div></md-option></div></div><div ng-if=\"$ctrl.optionsListData !== null && $ctrl.totalListCount === 0\" \nclass=\"ph-10 pb-10 fg-AAA8AD\">No Result Match Found</div><div \nng-if=\"$ctrl.optionsListData !== null && $ctrl.totalListCount !== 0\" layout=\"row\" layout-align=\"center center\" \nclass=\"save-selected-button\" ng-click=\"$ctrl.mdSelect.hide();\">Done</div></md-select><md-chips \nng-model=\"$ctrl.queryConditions.selectedOptions\" md-on-remove=\"$ctrl.fnRemoveChips($chip);\" readonly=\"true\" \nmd-removable=\"true\"><md-chip-template><div ng-if=\"$chip.type === \'Airport\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg tag-port-icon\"></div><div \nng-if=\"$chip.type === \'Port\'\" style=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" \nclass=\"icon-bg tag-port-icon\"></div><span \nng-if=\"!$ctrl.queryConditions.isUpperCase && !$ctrl.queryConditions.ignoreCaseChange\">\n{{ $chip[$ctrl.groupsObj[$chip.groupType ? $chip.groupType : \'customIndex\'].keyTitle] | lowercase }} {{ $chip.last_name ? $chip.last_name : \'\' | lowercase }} \n</span><span ng-if=\"!$ctrl.queryConditions.isUpperCase && $ctrl.queryConditions.ignoreCaseChange\">\n{{ $chip[$ctrl.groupsObj[$chip.groupType ? $chip.groupType : \'customIndex\'].keyTitle]}} {{ $chip.last_name ? $chip.last_name : \'\'}} \n</span><span ng-if=\"$ctrl.queryConditions.isUpperCase\">\n{{ $chip[$ctrl.groupsObj[$chip.groupType ? $chip.groupType : \'customIndex\'].keyTitle] | uppercase }}</span>\n</md-chip-template></md-chips></div>");
$templateCache.put("app/main/component/multi-select-group/multi-select-group.html","<div ng-if=\"$ctrl.carrierShimmer\"><div shimmer-effect-full width=\"170px\" height=\"40px\" class=\"mt-4\"></div></div><div \nng-if=\"!$ctrl.carrierShimmer\" id=\"multi-select-group-container\"><md-select ng-model=\"$ctrl.selectedOptions\" \nng-class=\"{\'disabled\':$ctrl.isDisabled,\'invalid\':$ctrl.isError}\" \nmd-on-open=\"$ctrl.util.fnSetPanelPosition(\'multi-select-group\',\'md-select-group-container\');\" \nmd-selected-text=\"$ctrl.getSelectedText()\" ng-model-options=\"{trackBy: \'$value.uniqueId\'}\" id=\"{{$ctrl.mdInputId}}\" \nmd-on-close=\"$ctrl.fnSaveSelectedOptions()\" class=\"multi-select-group\" \nmd-container-class=\"md-select-group-container w-255 pb-0 mb-0\" multiple=\"multiple\"><md-select-header><div \nclass=\"search-header\"><input ng-model-options=\"{debounce : 1000}\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"$ctrl.searchtext\" ng-change=\"$ctrl.getListBySearch($ctrl.searchtext);\" \nplaceholder=\"{{$ctrl.queryConditions.placeholder}}\" class=\"md-text search-input\" md-select-on-focus=\"\"><md-icon \nflex=\"10\" md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div></md-select-header><div \nng-repeat=\"(key, listDataObj) in $ctrl.optionList\"><div class=\"header\"><div class=\"header-container\"><div \nclass=\"pr-5 Font-Bold\">{{listDataObj.label}}</div><div class=\"selectedCount\">{{listDataObj.selectedCount}}</div></div>\n<div><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"listDataObj.selectAll\" \nng-change=\"$ctrl.selectAllClicked(key , listDataObj.selectAll ,listDataObj.label )\" class=\"md-primary mb-0 Font-Bold\">\nAll <span class=\"totalCount\">({{listDataObj.totalCount}})</span></md-checkbox></div></div><div \nng-if=\"listDataObj.data.length !== 0 && listDataObj !== null && !$ctrl.filterLoader\" \nng-mouseover=\"$ctrl.showTooltip=true\"><md-option ng-disabled=\"optionVal.disabled\" ng-title=\"optionVal.name\" \nng-value=\"optionVal\" ng-click=\"optionVal.disabled ? \'\' : $ctrl.valueChanged(key,optionVal ,listDataObj.label )\" \nng-repeat=\"optionVal in listDataObj.data track by optionVal.uniqueId\">{{optionVal.name}}<md-tooltip \nng-if=\"!optionVal.disabled && $ctrl.showTooltip\" md-autohide=\"true\" md-direction=\"top\">{{optionVal.name}}</md-tooltip>\n<md-icon ng-if=\"optionVal.disabled\" id=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" class=\"mr-5\"><md-tooltip\n ng-if=\"(optionVal.disabled && $ctrl.showTooltip)\" md-autohide=\"true\" md-direction=\"top\">\nThis carrier is not available for your domain, Please contact admin to enable it</md-tooltip></md-icon></md-option>\n</div><div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"$ctrl.filterLoader\" \nclass=\"mv-20 pt-10\"><md-progress-circular></md-progress-circular></div><div \nng-if=\"listDataObj.data.length === 0 && !$ctrl.filterLoader\" class=\"ph-10 pb-10 fg-AAA8AD\">No Result Match Found</div>\n</div><div ng-if=\"listDataObj.data.length !== 0\" layout=\"row\" layout-align=\"center center\" \nclass=\"save-selected-button\" ng-click=\"$ctrl.sumbitData();\">Done</div></md-select></div>");
$templateCache.put("app/main/component/no-rates-info/no-rates-info.html","<div class=\"arrow-up\"></div><div class=\"noRatesMessage\">{{ctrl.errorMessage}}</div>");
$templateCache.put("app/main/component/notification-bar/notification-bar.html","<div id=\"notification-bar\"><div class=\"forwarder-context-bar grey-bg forwarder-sect\" ng-if=\"$ctrl.util.isFreightbro\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"forwarder-context-bar__inner\"><div \nclass=\"forwarder-context-bar__left\"><span class=\"forwarder-context-label white-fg\">Acting as</span></div><div \nclass=\"forwarder-context-bar__center white-fg\" ng-if=\"$ctrl.getSelectedForwarder()\"><div \nclass=\"forwarder-context-meta\"><span class=\"forwarder-context-meta__label\">Domain</span> <span \nclass=\"forwarder-context-meta__value\" title=\"{{ $ctrl.getSelectedForwarder().domain }}\">\n{{ $ctrl.getSelectedForwarder().domain || \'—\' }}</span></div><div class=\"forwarder-context-meta\"><span \nclass=\"forwarder-context-meta__label\">Domain Subscriber ID</span> <span \nclass=\"forwarder-context-meta__value forwarder-context-meta__vendor-id\">\n{{ $ctrl.getSelectedForwarder().vendor_id || \'—\' }}</span></div></div><div class=\"forwarder-context-bar__right\">\n<md-select ng-model=\"$ctrl.filterForwarder\" placeholder=\"Select forwarder\" \nclass=\"forwarder-context-select md-no-underline m-0\" md-selected-text=\"$ctrl.getForwarderSelectedText()\" \nng-change=\"$ctrl.getAllByForwarder($ctrl.filterForwarder)\" md-on-open=\"$ctrl.onForwarderSelectOpen()\" \nmd-on-close=\"$ctrl.onForwarderSelectClose()\" md-container-class=\"forwarder-select-panel\"><md-select-header \nclass=\"forwarder-select-header\"><div class=\"forwarder-select-header-inner\" layout=\"column\"><div \nclass=\"forwarder-select-search\"><input ng-model=\"searchForwarder\" type=\"search\" placeholder=\"Search forwarder\" \nclass=\"forwarder-select-search__input\" ng-keydown=\"$event.stopPropagation()\" ng-model-options=\"{debounce: 500}\" \nng-change=\"$ctrl.fnSearchForwarder(searchForwarder)\" md-select-on-focus=\"\" autocomplete=\"off\" \naria-label=\"Search forwarder\"><md-icon md-font-icon=\"icon-magnify\" class=\"forwarder-select-search__icon\"></md-icon>\n</div><div class=\"forwarder-select-header-loading\" layout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.listLoader\">\n<md-progress-circular md-diameter=\"24\"></md-progress-circular></div></div></md-select-header><div \nng-if=\"!$ctrl.listLoader && !$ctrl.forwarderSearchEmpty\"><div \nng-repeat=\"vendor in $ctrl.forwarderList track by vendor.id\"><md-option ng-value=\"vendor.id\" \nclass=\"forwarder-select-option\" ng-disabled=\"$ctrl.shouldDisableForwarderOption(vendor)\"><span \nclass=\"forwarder-option-text\"><span class=\"forwarder-option-efp-hint\" \nng-if=\"$ctrl.shouldDisableForwarderOption(vendor)\">Only EFP forwarders allowed for search page </span><span \nclass=\"forwarder-option__title\" title=\"{{ vendor.company_name }}\">{{ vendor.company_name }} <span \nclass=\"forwarder-option__badge\" ng-if=\"vendor.is_own\">Default</span> <span \nclass=\"forwarder-option__badge forwarder-option__badge--efp\" ng-if=\"!vendor.is_own && vendor.is_efp\">EFP </span></span>\n<span class=\"forwarder-option__line\"><span class=\"forwarder-option__label\">Domain</span> <span \nclass=\"forwarder-option__value\" title=\"{{ vendor.domain }}\">{{ vendor.domain || \'—\' }}</span> </span><span \nclass=\"forwarder-option__line\"><span class=\"forwarder-option__label\">Domain Subscriber Id</span> <span \nclass=\"forwarder-option__value forwarder-option__vendor-id\">{{ vendor.vendor_id || \'—\' }}</span> </span><span \nclass=\"forwarder-option__line\"><span class=\"forwarder-option__label\">EFP Forwarder</span> <span \nclass=\"forwarder-option__value\">{{ $ctrl.getForwarderEfpLabel(vendor) }}</span></span></span></md-option></div></div>\n<div class=\"forwarder-option__empty-msg\" ng-if=\"!$ctrl.listLoader && $ctrl.forwarderSearchEmpty\">No forwarders found\n</div></md-select></div></div></div><div class=\"portal-update\" \nng-if=\"$root.ifVersionUpdate && !$root.ifVersionUpdateUserDisable\"><div class=\"content-size\">\nNew updates are available. Please <a class=\"link md-link-fg\" style=\"cursor: pointer\" ng-click=\"$root.fnForceRefresh()\">\nrefresh</a> for a smooth experience.<div style=\"float:right\"><md-icon md-font-icon=\"icon-close\" \nng-click=\"$root.closeForceRefresh()\" class=\"s24 pointer mb-5\"></md-icon></div></div></div><div id=\"promotion-banner\" \nng-if=\"$ctrl.showBanner\" ng-repeat=\"bannerData in $ctrl.bannerList track by $index\" ng-init=\"parentIndex = $index\"><div\n ng-if=\"$ctrl.currentPageIndex == parentIndex\"><div ng-repeat=\"bannerChildData in bannerData.data track by $index\" \nng-init=\"childIndex = $index\"><div ng-style=\"{\'background-color\': bannerChildData.theme.background}\" \nng-if=\"$ctrl.currentChildPageIndex ==  childIndex\"><div class=\"banner-campaign\" flex=\"100\"><div \nclass=\"content-left w-100p-mob mb-10-mob\"><div class=\"icon-section w-35 h-35\" \nng-style=\"{\'background-color\': bannerChildData.theme.text_color}\"><md-icon \nmd-font-icon=\"{{bannerChildData.theme.icon.font_class}}\" class=\"s20 icon\" \nng-style=\"{\'color\': (bannerChildData.theme.type == \'general\' || bannerChildData.theme.type ==  \'promotion\') ? bannerChildData.theme.background : \'white\' }\">\n</md-icon></div><div ng-style=\"{\'color\': bannerChildData.theme.text_color}\" class=\"w-full\"><div layout=\"row\" \nlayout-align=\"start end\" layout-align-xs=\"start center\" class=\"title-section\"><div class=\"title Font-Bold\">\n{{ bannerChildData.title }}<md-tooltip md-direction=\"top\">{{ bannerChildData.title }}</md-tooltip></div><div \nclass=\"steps-number\" ng-if=\"$ctrl.bannerList.length > 1\">{{$ctrl.currentPageIndex+1}}/{{$ctrl.bannerList.length}}</div>\n</div><div class=\"description Font-Regular\">{{ bannerChildData.description }}<md-tooltip md-direction=\"top\">\n{{ bannerChildData.description }}</md-tooltip></div></div></div><div class=\"content-right\"><div class=\"button-space\">\n<button class=\"action-btn\" ng-if=\"bannerChildData.action.text\" aria-label=\"{{ bannerChildData.action.text }}\" \nng-click=\"$ctrl.callToAction(bannerChildData.action.type, parentIndex,childIndex)\" \nng-style=\"{\'background-color\': bannerChildData.action.background,\'border-color\': bannerChildData.action.text_color}\">\n<span class=\"btn-text Font-Bold\" ng-style=\"{\'color\': bannerChildData.action.text_color}\">\n{{ bannerChildData.action.text }}</span><md-tooltip md-direction=\"top\">\n{{ ctrl.parent.bannerInfo.selectedData.data.action.text }}</md-tooltip></button></div><div class=\"pagination\" \nng-if=\"bannerData.data.length > 1\"><button ng-click=\"$ctrl.prevChildBanner()\" \nng-disabled=\"$ctrl.prevChildButtonDisabled\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s18 arrow-icon mr-5 active\" \nng-class=\"{\'inactive\': $ctrl.prevChildButtonDisabled}\" ng-style=\"{\'color\': bannerChildData.theme.text_color}\">\n</md-icon></button> <button ng-click=\"$ctrl.nextChildBanner()\" ng-disabled=\"$ctrl.nextChildButtonDisabled\"><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"s18 arrow-icon active\" ng-class=\"{\'inactive\': $ctrl.nextChildButtonDisabled}\" \nng-style=\"{\'color\': bannerChildData.theme.text_color}\"></md-icon></button></div></div><button \nng-if=\"bannerChildData.theme.type.toLowerCase() == \'general\'\" ng-click=\"$ctrl.callToAction(\'dismiss\', parentIndex )\" \nclass=\"close-icon\"><md-icon md-font-icon=\"icon-close-circle\" class=\"s20\" \nng-style=\"{\'color\': bannerChildData.action.text_color}\"></md-icon></button></div></div></div></div></div></div>");
$templateCache.put("app/main/component/penalty-fees/penalty-fees.html","<div layout=\"row\" layout-xs=\"column\"><div flex><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools p-20\"><div>Fee details</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"$ctrl.closeDialog()\"><md-icon class=\"fg-AAA8AD cursor\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"m-0\"><div layout=\"column\" class=\"font-size-16\"><div \nclass=\"simple-table-container\"><md-content class=\"bb\"><table class=\"simple text-center\" ms-responsive-table><thead><tr>\n<th class=\"br border-vertical\"><div class=\"\"><span class=\"font-weight-600 black-fg font-size-16\">Penalty Name</span>\n</div></th><th class=\"br border-vertical\"><div class=\"text-center\"><span class=\"font-weight-600 black-fg font-size-16\">\nPenalty</span></div></th><th class=\"border-vertical\"><div class=\"text-center\"><span \nclass=\"font-weight-600 black-fg font-size-16\">Container Type</span></div></th></tr></thead><tbody><tr \nng-repeat=\"penaltyFee in $ctrl.penaltyfeesArray track by $index\"><td class=\"br\"><span class=\"font-size-16\">\n{{ penaltyFee.charge_name }}</span></td><td class=\"br text-center\"><span class=\"font-size-16\">\n{{ penaltyFee.charge_currency }} {{ penaltyFee.buy_rate | currencyMask }}</span></td><td class=\"text-center\"><span \nclass=\"font-size-16\">{{ penaltyFee.load_type }}</span></td></tr></tbody></table></md-content></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"white-bg footer\" layout-wrap \nlayout-align=\"space-between center\"><div class=\"font-weight-600 font-size-16 rules-regulations p-10\"><div layout=\"row\" \nflex=\"100\">Maersk rules & regulations</div></div></md-dialog-actions></div></div>");
$templateCache.put("app/main/component/pol-to-pod/pol-to-pod.html","<div id=\"port-to-port\"><div class=\"steps\"><ul class=\"steps-list\" ng-if=\"!$ctrl.isScheduleVia\"><li \nclass=\"steps-list-item\" ng-if=\"$ctrl.card.meta.port_data.empty_container_pickup\"><span class=\"hrLine\"></span><div \nclass=\"li-div\"><div class=\"port-text\">{{$ctrl.card.meta.port_data.empty_container_pickup.port_code}}</div><div \nclass=\"city-text\">{{$ctrl.card.meta.port_data.empty_container_pickup.port_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nEmpty Container Pickup</div><div class=\"Font-Bold\">{{$ctrl.card.meta.port_data.empty_container_pickup.port_name}}</div>\n</md-tooltip></div></li><li class=\"steps-list-item\" \nng-if=\"$ctrl.card.meta.port_data.pickup_location || $ctrl.card.meta.port_data.pickup_pincode_ui\"><div layout=\"row\" \nclass=\"steps-list-item-timeline\" layout-align=\"center center\"><span \nng-repeat=\"transport in $ctrl.pickupTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mb-10 mr-10 h-10\">\n</span><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434\" style=\"display:table;opacity: 1\"><table><tr \nclass=\"font-size-11\"><td class=\"w-80\">Pickup Mode</td><td>Service Type</td></tr><tr class=\"font-size-13\"><td><span \nng-repeat=\"transport in $ctrl.pickupTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mt-10 mr-5 h-10\"> \n<span ng-if=\"!transport.icon\" class=\"mt-10 mr-5 font-size-11\" ng-bind=\"transport.value\"></span></span></td><td \nclass=\"tooltip-width-control\">{{$ctrl.card.meta[\"pickup_service\"] ? $ctrl.card.meta[\"pickup_service\"] : \'-\'}}</td></tr>\n</table></md-tooltip></div><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.card.meta.port_data.pickup_location\">{{ $ctrl.card.meta.port_data.pickup_location }} <span \nng-if=\" $ctrl.card.meta.port_data.pickup_location && $ctrl.card.meta.port_data.pickup_pincode_ui\">| </span></span><span\n ng-if=\"$ctrl.card.meta.port_data.pickup_pincode_ui\">{{ $ctrl.card.meta.port_data.pickup_pincode_ui }}</span></div><div\n class=\"city-text\">{{ $ctrl.card.meta.port_data.pickup_country_name}}</div><div \nclass=\"transporter-text city-text pt-4\" ng-if=\"$ctrl.card.meta[\'pickup_sub_vendor\']\">\n{{$ctrl.card.meta.pickup_sub_vendor.sub_vendor_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Pickup\n</div><div class=\"Font-Bold\"><span ng-if=\"$ctrl.card.meta.port_data.pickup_location\">\n{{ $ctrl.card.meta.port_data.pickup_location }} <span \nng-if=\"$ctrl.card.meta.port_data.pickup_location && $ctrl.card.meta.port_data.pickup_pincode_ui\">| </span></span><span \nng-if=\"$ctrl.card.meta.port_data.pickup_pincode_ui\">{{ $ctrl.card.meta.port_data.pickup_pincode_ui }}</span></div><div \nclass=\"Font-Bold\">{{ $ctrl.card.meta.port_data.pickup_country_name}}</div></md-tooltip></div></li><li \nclass=\"steps-list-item\" ng-if=\"$ctrl.card.meta.via_pol\"><span class=\"hrLine\"></span><div class=\"li-div\"><div \nclass=\"port-text\">{{ $ctrl.card.meta.port_data.origin_port_code }}</div><div class=\"city-text\">\n{{ $ctrl.card.meta.port_data.origin_portname }}</div><div class=\"terminal-text\" \nng-class=\"{\'top-13\': !$ctrl.card.meta.port_data.origin_portname }\">\n{{$ctrl.card.meta.port_data.is_icd_port_origin ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_origin ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_origin : \'\': $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.origin_terminal ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.origin_terminal :\'\'}}\n</div><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Port of Origin</div><div class=\"Font-Bold\">\n{{ $ctrl.card.meta.port_data.origin_portname }}</div></md-tooltip></div></li><li class=\"steps-list-item\"><div \nlayout=\"row\" class=\"steps-list-item-timeline\" layout-align=\"center center\" \nng-class=\"{ \'ml-full\' : $ctrl.isViaAvailable && !$ctrl.isMultipleVia, \'isViaMargin\' : $ctrl.isViaAvailable && $ctrl.isMultipleVia}\">\n<md-icon md-svg-icon=\"assets/icons/custom/ship-fill.svg\" class=\"mb-10 mh-0 h-10\" ng-show=\"$ctrl.mode != \'AIR\'\">\n</md-icon><md-icon md-svg-icon=\"assets/icons/custom/roll-o-plane.svg\" class=\"mb-10 mh-0 h-10\" \nng-show=\"$ctrl.mode == \'AIR\'\"></md-icon></div><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\">\n{{ $ctrl.card.meta.via_pol ? $ctrl.card.meta.via_pol : $ctrl.card.meta.port_data.origin_port_code }}</div><div \nclass=\"city-text\">{{ $ctrl.card.meta.via_pol ? \'\' : $ctrl.card.meta.port_data.origin_portname }}</div><div \nclass=\"terminal-text\" ng-class=\"{\'top-13\': $ctrl.card.meta.via_pol }\" ng-if=\"!$ctrl.card.meta.via_pol\">\n{{$ctrl.card.meta.port_data.is_icd_port_origin ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_origin ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_origin : \'\': $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.origin_terminal ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.origin_terminal :\'\'}}\n</div><div class=\"terminal-text\" ng-class=\"{\'top-13\': $ctrl.card.meta.via_pol}\" ng-if=\"$ctrl.card.meta.via_pol\">\n{{$ctrl.card.meta.port_data.is_icd_port_origin ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.origin_terminal ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.origin_terminal :\'\' :\'\'}}\n</div><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Port of Loading</div><div class=\"Font-Bold\">\n{{ $ctrl.card.meta.via_pol ? $ctrl.card.meta.via_pol : $ctrl.card.meta.port_data.origin_portname }}</div></md-tooltip>\n</div></li><li class=\"steps-list-item\" ng-if=\"$ctrl.isViaAvailable && !$ctrl.card.meta.selected_schedule\"><span \nclass=\"hrLine\"></span><div class=\"li-div\"><div class=\"via-text\">\n{{ $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.via_route }}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">T/S\n</div><div class=\"Font-Bold tooltip-width-control\">\n{{ $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.via_route }}</div></md-tooltip></div></li><li \nclass=\"steps-list-item\"><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\">\n{{ $ctrl.card.meta.via_pod ? $ctrl.card.meta.via_pod : $ctrl.card.meta.port_data.destination_port_code }}</div><div \nclass=\"city-text\">{{ $ctrl.card.meta.via_pod ? \'\' : $ctrl.card.meta.port_data.destination_portname}}</div><div \nclass=\"terminal-text\" ng-class=\"{\'top-13\': $ctrl.card.meta.via_pod}\" ng-if=\"!$ctrl.card.meta.via_pod\">\n{{$ctrl.card.meta.port_data.is_icd_port_destination ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_destination ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_destination : \'\': $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.destination_terminal ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.destination_terminal :\'\'}}\n</div><div class=\"terminal-text\" ng-class=\"{\'top-13\': $ctrl.card.meta.via_pod}\" ng-if=\"$ctrl.card.meta.via_pod\">\n{{$ctrl.card.meta.port_data.is_icd_port_destination ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.destination_terminal ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.destination_terminal :\'\' :\'\'}}\n</div><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Port of Discharge</div><div class=\"Font-Bold\">\n{{ $ctrl.card.meta.via_pod ? $ctrl.card.meta.via_pod : $ctrl.card.meta.port_data.destination_portname }}</div>\n</md-tooltip></div></li><li class=\"steps-list-item\" ng-if=\"$ctrl.card.meta.via_pod\"><span class=\"hrLine\"></span><div \nclass=\"li-div\"><div class=\"port-text\">{{ $ctrl.card.meta.port_data.destination_port_code }}</div><div \nclass=\"city-text\">{{ $ctrl.card.meta.port_data.destination_portname }}</div><div class=\"terminal-text\" \nng-class=\"{\'top-13\': !$ctrl.card.meta.port_data.destination_portname }\">\n{{$ctrl.card.meta.port_data.is_icd_port_destination ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_destination ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.inland_terminal_destination : \'\': $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.destination_terminal ? $ctrl.card.data[$ctrl.buyorsell][$ctrl.l3_leg].rate_obj.destination_terminal :\'\'}}\n</div><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Port of Destination</div><div class=\"Font-Bold\">\n{{ $ctrl.card.meta.port_data.destination_portname }}</div></md-tooltip></div></li><li class=\"steps-list-item\" \nng-if=\"$ctrl.card.meta.port_data.delivery_location || $ctrl.card.meta.port_data.delivery_pincode_ui\"><div layout=\"row\" \nclass=\"steps-list-item-timeline ml--50\" layout-align=\"center center\"><span \nng-repeat=\"transport in $ctrl.deliveryTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mb-10 mr-10 h-10\">\n</span><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434\" style=\"display:table;opacity: 1\"><table><tr \nclass=\"font-size-11\"><td class=\"w-80\">Delivery Mode</td><td>Service Type</td></tr><tr class=\"font-size-13\"><td><span \nng-repeat=\"transport in $ctrl.deliveryTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mt-10 mr-5 h-10\"> \n<span ng-if=\"!transport.icon\" class=\"mt-10 mr-5 font-size-11\" ng-bind=\"transport.value\"></span></span></td><td \nclass=\"tooltip-width-control\">{{$ctrl.card.meta[\"delivery_service\"] ? $ctrl.card.meta[\"delivery_service\"] : \'-\'}}</td>\n</tr></table></md-tooltip></div><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.card.meta.port_data.delivery_location\">{{ $ctrl.card.meta.port_data.delivery_location }} <span \nng-if=\"$ctrl.card.meta.port_data.delivery_pincode_ui && $ctrl.card.meta.port_data.delivery_location\">| </span></span>\n<span ng-if=\"$ctrl.card.meta.port_data.delivery_pincode_ui\">{{ $ctrl.card.meta.port_data.delivery_pincode_ui }}</span>\n</div><div class=\"city-text\">{{ $ctrl.card.meta.port_data.delivery_country_name}}</div><div \nclass=\"transporter-text city-text pt-4\" ng-if=\"$ctrl.card.meta[\'delivery_sub_vendor\']\">\n{{$ctrl.card.meta.delivery_sub_vendor.sub_vendor_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nDelivery</div><div class=\"Font-Bold\"><span ng-if=\"$ctrl.card.meta.port_data.delivery_location\">\n{{ $ctrl.card.meta.port_data.delivery_location }} <span \nng-if=\"$ctrl.card.meta.port_data.delivery_pincode_ui && $ctrl.card.meta.port_data.delivery_location\">| </span></span>\n<span ng-if=\"$ctrl.card.meta.port_data.delivery_pincode_ui\">{{ $ctrl.card.meta.port_data.delivery_pincode_ui }}</span>\n</div><div class=\"Font-Bold\">{{ $ctrl.card.meta.port_data.delivery_country_name}}</div></md-tooltip></div></li><li \nclass=\"steps-list-item\" ng-if=\"$ctrl.card.meta.port_data.empty_container_drop\"><span class=\"hrLine\"></span><div \nclass=\"li-div\"><div class=\"port-text\">{{$ctrl.card.meta.port_data.empty_container_drop.port_code}}</div><div \nclass=\"city-text\">{{$ctrl.card.meta.port_data.empty_container_drop.port_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nEmpty Container Drop</div><div class=\"Font-Bold\">{{$ctrl.card.meta.port_data.empty_container_drop.port_name}}</div>\n</md-tooltip></div></li></ul><ul class=\"steps-list\" ng-if=\"$ctrl.isScheduleVia\"><li class=\"steps-list-item\" \nng-if=\"$ctrl.card.meta.port_data.empty_container_pickup\"><span class=\"hrLine\"></span><div class=\"li-div\"><div \nclass=\"port-text\">{{$ctrl.card.meta.port_data.empty_container_pickup.port_code}}</div><div class=\"city-text\">\n{{$ctrl.card.meta.port_data.empty_container_pickup.port_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nEmpty Container Pickup</div><div class=\"Font-Bold\">{{$ctrl.card.meta.port_data.empty_container_pickup.port_name}}</div>\n</md-tooltip></div></li><li class=\"steps-list-item\" \nng-if=\"$ctrl.card.meta.port_data.pickup_location || $ctrl.card.meta.port_data.pickup_pincode_ui\"><div layout=\"row\" \nclass=\"steps-list-item-timeline\" layout-align=\"center center\"><span \nng-repeat=\"transport in $ctrl.pickupTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mb-10 mr-10 h-10\">\n</span><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434\" style=\"display:table;opacity: 1\"><table><tr \nclass=\"font-size-11\"><td class=\"w-80\">Pickup Mode</td><td>Service Type</td></tr><tr class=\"font-size-13\"><td><span \nng-repeat=\"transport in $ctrl.pickupTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mt-10 mr-5 h-10\"> \n<span ng-if=\"!transport.icon\" class=\"mt-10 mr-5 font-size-11\" ng-bind=\"transport.value\"></span></span></td><td \nclass=\"tooltip-width-control\">{{$ctrl.card.meta[\"pickup_service\"] ? $ctrl.card.meta[\"pickup_service\"] : \'-\'}}</td></tr>\n</table></md-tooltip></div><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.card.meta.port_data.pickup_location\">{{ $ctrl.card.meta.port_data.pickup_location }} <span \nng-if=\"$ctrl.card.meta.port_data.pickup_pincode_ui && $ctrl.card.meta.port_data.pickup_location\">| </span></span><span \nng-if=\"$ctrl.card.meta.port_data.pickup_pincode_ui\">{{ $ctrl.card.meta.port_data.pickup_pincode_ui }}</span></div><div \nclass=\"city-text\">{{ $ctrl.card.meta.port_data.pickup_country_name}}</div><div class=\"transporter-text city-text pt-4\" \nng-if=\"$ctrl.card.meta[\'pickup_sub_vendor\']\">{{$ctrl.card.meta.pickup_sub_vendor.sub_vendor_name}}</div><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nclass=\"Font-Medium\">Pickup</div><div class=\"Font-Bold\"><span ng-if=\"$ctrl.card.meta.port_data.pickup_location\">\n{{ $ctrl.card.meta.port_data.pickup_location }} <span \nng-if=\"$ctrl.card.meta.port_data.pickup_pincode_ui && $ctrl.card.meta.port_data.pickup_location\">| </span></span><span \nng-if=\"$ctrl.card.meta.port_data.pickup_pincode_ui\">{{ $ctrl.card.meta.port_data.pickup_pincode_ui }}</span></div><div \nclass=\"Font-Bold\">{{ $ctrl.card.meta.port_data.pickup_country_name}}</div></md-tooltip></div></li><li \nclass=\"steps-list-item\" ng-repeat=\"item in $ctrl.card.meta.selected_schedule.schedule_track track by $index\"><div \nlayout=\"row\" class=\"steps-list-item-timeline via_port_line\" layout-align=\"center center\" \nng-if=\"$ctrl.fnLength() == $index\" \nng-class=\"{ \'ml-full\' : $ctrl.card.meta.selected_schedule.schedule_track.length % 2 != 0 , \'align-icon-left\' : $ctrl.card.meta.selected_schedule.schedule_track.length >=3 }\">\n<md-icon md-svg-icon=\"assets/icons/custom/ship-fill.svg\" class=\"mb-10 mh-0 h-10\" ng-show=\"$ctrl.mode != \'AIR\'\">\n</md-icon><md-icon md-svg-icon=\"assets/icons/custom/roll-o-plane.svg\" class=\"mb-10 mh-0 h-10\" \nng-show=\"$ctrl.mode == \'AIR\'\"></md-icon></div><span class=\"hrLine\" ng-class=\"{ \'via-vertical-line\' : $middle}\"></span>\n<div class=\"li-div\"><div class=\"port-text\">{{ item.port_code}}</div><div class=\"city-text\">{{ item.port_name}}</div>\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\n<div class=\"Font-Medium\">{{ $first ? \'Port of Origin\' : $last ? \'Port of Destination\' : \'T/S\'}}</div><div \nclass=\"Font-Bold\">{{ item.port_name }}</div></md-tooltip></div></li><li class=\"steps-list-item\" \nng-if=\"$ctrl.card.meta.port_data.delivery_location || $ctrl.card.meta.port_data.delivery_pincode_ui\"><div layout=\"row\" \nclass=\"steps-list-item-timeline ml--50\" layout-align=\"center center\"><span \nng-repeat=\"transport in $ctrl.deliveryTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mb-10 mr-10 h-10\">\n</span><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434\" style=\"display:table;opacity: 1\"><table><tr \nclass=\"font-size-11\"><td class=\"w-80\">Delivery Mode</td><td>Service Type</td></tr><tr class=\"font-size-13\"><td><span \nng-repeat=\"transport in $ctrl.deliveryTransport track by $index\"><img ng-if=\"transport.icon\" \nng-src=\"{{\'assets/icons/custom/\'+transport.icon+\'_haulage.svg\'}}\" alt=\"{{transport.value}}\" class=\"mt-10 mr-5 h-10\"> \n<span ng-if=\"!transport.icon\" class=\"mt-10 mr-5 font-size-11\" ng-bind=\"transport.value\"></span></span></td><td \nclass=\"tooltip-width-control\">{{$ctrl.card.meta[\"delivery_service\"] ? $ctrl.card.meta[\"delivery_service\"] : \'-\'}}</td>\n</tr></table></md-tooltip></div><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.card.meta.port_data.delivery_location\">{{ $ctrl.card.meta.port_data.delivery_location }} <span \nng-if=\"$ctrl.card.meta.port_data.delivery_location && $ctrl.card.meta.port_data.delivery_pincode_ui \">| </span></span>\n<span ng-if=\"$ctrl.card.meta.port_data.delivery_pincode_ui\">{{ $ctrl.card.meta.port_data.delivery_pincode_ui }}</span>\n</div><div class=\"city-text\">{{ $ctrl.card.meta.port_data.delivery_country_name}}</div><div \nclass=\"transporter-text city-text pt-4\" ng-if=\"$ctrl.card.meta[\'delivery_sub_vendor\']\">\n{{$ctrl.card.meta.delivery_sub_vendor.sub_vendor_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nDelivery</div><div class=\"Font-Bold\"><span ng-if=\"$ctrl.card.meta.port_data.delivery_location\">\n{{ $ctrl.card.meta.port_data.delivery_location }} <span \nng-if=\"$ctrl.card.meta.port_data.delivery_location && $ctrl.card.meta.port_data.delivery_pincode_ui\">| </span></span>\n<span ng-if=\"$ctrl.card.meta.port_data.delivery_pincode_ui\">{{ $ctrl.card.meta.port_data.delivery_pincode_ui }}</span>\n</div><div class=\"Font-Bold\">{{ $ctrl.card.meta.port_data.delivery_country_name}}</div></md-tooltip></div></li><li \nclass=\"steps-list-item\" ng-if=\"$ctrl.card.meta.port_data.empty_container_drop\"><span class=\"hrLine\"></span><div \nclass=\"li-div\"><div class=\"port-text\">{{$ctrl.card.meta.port_data.empty_container_drop.port_code}}</div><div \nclass=\"city-text\">{{$ctrl.card.meta.port_data.empty_container_drop.port_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nEmpty Container Drop</div><div class=\"Font-Bold\">{{$ctrl.card.meta.port_data.empty_container_drop.port_name}}</div>\n</md-tooltip></div></li></ul></div></div>");
$templateCache.put("app/main/component/quote-internal-details/quote-internal-details.html","<div id=\"internal-deatils\" class=\"mt-20 ml-10\"><div class=\"heading p-20\">Internal Details</div><md-divider>\n</md-divider><div layout=\"column\" class=\"p-20\"><div layout=\"row\" class=\"pb-20\"><md-icon \nmd-svg-src=\"assets/icons/custom/document.svg\" class=\"m-0 h-20\"></md-icon><div layout=\"column\" class=\"pl-5\"><span \nclass=\"sub-head pb-5\">Inquiry Number</span><div layout-align=\"start center\" \nclass=\"panel-select-style panel-height disabled-panel\"><span \nng-bind=\"$ctrl.internalDetails.inquiry_number? $ctrl.internalDetails.inquiry_number : \'-\' \"></span></div></div></div>\n<div layout=\"row\" class=\"pb-20\"><md-icon md-svg-src=\"assets/icons/custom/search-bar/search_reference_icon.svg\" \nclass=\"m-0\"></md-icon><div layout=\"column\" class=\"pl-5\"><span class=\"sub-head pb-5\">Search Reference</span> <input \nclass=\"panel-select-style panel-height\" placeholder=\"Enter search reference\" \nng-model=\"$ctrl.internalDetails.search_reference\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"></div>\n</div><div layout=\"row\" class=\"pb-20\"><md-icon md-svg-src=\"assets/icons/custom/search-bar/customer_details_icon.svg\" \nclass=\"m-0\"></md-icon><div layout=\"column\" class=\"pl-5 customer-data\"><div layout=\"row\"><span class=\"sub-head pb-5\" \nflex=\"50\">Customer Details</span> <span flex=\"50\" class=\"pb-5 pl-10 add-new-text\" ng-click=\"$ctrl.addShipper($event)\">\n+ Add New Customer</span></div><form name=\"$ctrl.cutomerData\"><md-input-container class=\"panel-select-style h-50\" \nng-class=\"{\'error-border\':($ctrl.validationObj.customerDataValidation || $ctrl.cutomerData.EmailAddress.$error[\'md-require-match\'])}\" \nng-mouseleave=\"focusedCust=false\" ng-mouseenter=\"focusedCust=true\"><md-autocomplete \nng-model-options=\"{debounce : 500}\" placeholder=\"Enter Customer Details\" md-input-name=\"EmailAddress\" \nclass=\"auto-complete-style mb-3 port-min-width mobile_input\" md-selected-item=\"$ctrl.selectedEmail\" md-min-length=\"3\" \nmd-search-text=\"shipperText\" md-search-text-change=\"$ctrl.searchTextChange($ctrl.selectedEmail)\" \nmd-selected-item-change=\"$ctrl.selectedToChange($ctrl.selectedEmail);$ctrl.validationObj.customerDataValidation=false;\" \nmd-items=\"item in $ctrl.filterStringList(shipperText,generatequoteForm)\" \nmd-item-text=\"(item ? (item.company.company_name + \', \' + item.user_first_name + \' \' + item.user_last_name + \', \' + item.email):\'\')\" \nmd-clear-button=\"focusedCust\" required md-menu-class=\"autocomplete-custom-template-search\" \nmd-menu-container-class=\"container-height\" md-require-match=\"true\" md-select-on-match=\"true\" md-no-cache=\"true\" \nmd-delay=\"300\" ng-keyup=\"$ctrl.validationObj.customerDataValidation=false\"><md-item-template><span \nclass=\"item-metadata\"><div layout=\"row\" layout-align=\"space-between\" class=\"p-10 white-bg\"><div layout=\"column\" \nstyle=\"pointer-events: none\"><div class=\"text-truncate\"><span class=\"capitalize-first-letter\" \ncompile-html=\"(item.user_first_name + \' \' + item.user_last_name)  !== \'\' ? $ctrl.util.searchHighlight(item.user_first_name + \' \' + item.user_last_name,shipperText ) : \'\' \">\n</span></div><div class=\"text-truncate mailIdStyle\"><span ng-if=\"item.email\" \ncompile-html=\"$ctrl.util.searchHighlight(item.email,shipperText )\"></span> <span \nng-bind=\"item.user_company_name ? \' | \' : \' \' \"></span> <span ng-if=\"item.user_company_name\" \ncompile-html=\"$ctrl.util.searchHighlight(item.user_company_name,shipperText )\"></span> <span>\n&nbsp; {{item.company.external_reference_id ?\' | \':\'\'}} &nbsp;</span> <span class=\"text-truncate\" \ncompile-html=\"item.company.external_reference_id ? $ctrl.util.searchHighlight(item.company.external_reference_id,shipperText ) : \'\' \">\n</span></div></div></div></span></md-item-template><md-not-found><div class=\"pt-10\">No matches found.</div>\n</md-not-found></md-autocomplete></md-input-container></form><span ng-if=\"$ctrl.validationObj.customerDataValidation\" \nclass=\"error-text\">Select Customer Details</span></div></div><div layout=\"row\"><md-icon \nmd-svg-src=\"assets/icons/custom/mail.svg\" class=\"m-0\"></md-icon><div layout=\"column\" class=\"pl-5\"><span \nclass=\"sub-head pb-5\">CC Email</span><md-chips ng-model=\"$ctrl.internalDetails.cc_email\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nclass=\"panel-select-style chip-height\" placeholder=\"Type Email ID and click Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"$ctrl.fnMultiEmailValidation($ctrl.internalDetails.cc_email, $chip)\" md-add-on-blur=\"true\">\n<md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips><div class=\"quote-invalidErrorMsg pt-8\" hide>\nInvalid email address!! We removed it.</div><div class=\"quote-duplicateErrorMsg pt-8\" hide>\nDuplicate email address!! We removed it.</div></div></div></div></div>");
$templateCache.put("app/main/component/quote-modification/quote-modification-details.html","<div id=\"copy-quote-details\"><div flex ms-scroll ng-if=\"!$ctrl.dataErr\"><div class=\"center\"><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"mv-20\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between end\" layout-align-xs=\"space-between start\" flex=\"100\"><div layout=\"column\" \nlayout-align=\"center start\"><div><span class=\"font-size-11 md-link-fg ml-30 pointer font-bold\" \nng-if=\"!$ctrl.quotePreview && !($ctrl.isWebView || $ctrl.isShared) && $ctrl.pageTitle ==\'copy-quote\'\" \nng-click=\"$ctrl.fnViewQuoteList(\'link\')\">Quotes /</span><span class=\"font-size-11 font-bold\">\n {{$ctrl.search_param.mode}}</span></div><div layout=\"row\" ng-if=\"!$ctrl.quotePreview\"><div \nng-click=\"$ctrl.fnViewQuoteList(\'back\')\" \nng-if=\"!($ctrl.isWebView || $ctrl.isShared) && $ctrl.pageTitle ==\'copy-quote\'\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"mr-5 mt-5 pointer\"></md-icon></div><div class=\"copy_title font-bold\">\n{{$ctrl.pageTitle ==\'create-quote\' ? \"Create Quote\":\"Copy Quote\" }}</div><div></div></div></div></div></div><div \nflex=\"100\" id=\"copy-quote-meta\" layout-xs=\"column\" layout=\"row\"><md-card flex=\"100\" flex-sm=\"100\" flex-xs=\"100\" \nclass=\"brad-4 m-0 pt-20\"><md-card-content class=\"p-0\"><div layout=\"row\" layout-padding layout-wrap \nclass=\"p-0 ph-20 font-size-16 font-bold pb-10\">Quote Details</div><md-divider></md-divider><div \nclass=\"ph-10 form-container\"><div ng-include=\"\'app/main/component/quote-modification/quote-modification-meta.html\'\">\n</div></div></md-card-content></md-card></div><div layout=\"column\" layout-wrap><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\"><div flex=\"100\" layout-wrap class=\"mv-10 mt-20\"><div layout=\"row\" layout-align=\"end end\" \nng-if=\"$ctrl.refreshRates\"><md-button ng-disabled=\"$ctrl.disableRefreshRates || $ctrl.newResultCard.length\" md-no-ink \nng-click=\"$ctrl.fnOpenRefreshRatesPopup($event)\" class=\"md-accent-btn with-icon\"><md-icon class=\"s18 white-fg\" \nmd-font-icon=\"icon-refresh\"></md-icon><span class=\"font-size-12\"><b>Refresh Rates</b></span></md-button></div><div \nclass=\"newCardBtn mb-10 mr-10 ml-2\" ng-click=\"$ctrl.fnAddOrEditCard(\'\', \'newCardCopyQuote\', $event)\"><span>\n+ Add New Rate Card</span></div><div \nng-repeat=\"card_item in $ctrl.quote_CardData | orderBy:$ctrl.sortBy track by $index\" \nng-show=\"$ctrl.isActive ? $ctrl.isActiveFunction(card_item) : true\"><div \nng-if=\"$ctrl.newResultCard && $ctrl.newResultCard.length && ($ctrl.newResultCard.length===$index)\" class=\"old_card\">\nOld cards</div><card-list-result index=\"$index\" searchparam=\"$ctrl.search_param\" carddata=\"card_item\" \nresultfilter=\"$ctrl.resultCardFilter\" copyquoted=\"$ctrl.copyquoted\" quote-type=\"\'copyQuote\'\" mixpanel-sorce=\"\'QC\'\" \nproceedduplicate=\"$ctrl.proceedDuplicate\" showeditbtn=\"$ctrl.showEditBtn\" showbookbtn=\"$ctrl.showBookBtn\" \nparent-page=\"\'quotes\'\" isquotemodify=\"$ctrl.isQuoteModify\" quoteresult=\"$ctrl.quote_result\" \niscopyquote=\"$ctrl.isDuplicateQuote\" callback=\"$ctrl.showQuoteProceedDiv(card)\"></card-list-result></div></div><div>\n<internal-details search-param=\"$ctrl.search_param\" validation-obj=\"$ctrl.customerValidationObj\" \nedit-party=\"$ctrl.newUserData\" cutomer-data=\"$ctrl.cutomerData\" internal-details=\"$ctrl.internalDetails\">\n</internal-details></div></div></div></div></div><div class=\"footer-content z-index-0\" ng-if=\"!$ctrl.dataErr\">\n<footer-strip ng-if=\"$ctrl.quote_CardData.length\" quote-data=\"$ctrl.quote_CardData\" search-param=\"$ctrl.search_param\" \nquote-details=\"$ctrl.quote_result\" page-title=\"$ctrl.pageTitle\" callback=\"$ctrl.generateQuote($event)\"></footer-strip>\n<div ng-if=\"$ctrl.quote_result.result_data.is_booked && $ctrl.quote_result.result_data.shipment_id\"><div layout=\"row\" \nflex=\"100\" class=\"ph-10 pv-0\" layout-align=\"center start\" layout-wrap><p class=\"pl-10 fb-black font-size-16\">\nThis quote has been converted to a Booking <span><a ng-if=\"!$ctrl.isShared\" class=\"md-link-fg shipment_id pointer\" \nng-click=\"$ctrl.goToShipmentDetail()\">{{ $ctrl.quote_result.result_data.shipment_id }}</a></span></p></div></div><div \nng-if=\"$ctrl.quote_result.result_data.revised\"><div layout=\"row\" flex=\"100\" class=\"ph-10 pv-0\" \nlayout-align=\"center start\" layout-wrap><p class=\"pl-10 fb-black font-size-18\">This quote has been revised.</p></div>\n</div><div id=\"shared-footer-quote\" ng-if=\"$ctrl.showSharedFooter && !$ctrl.quote_result.result_data.is_booked\" \nclass=\"shared-footer bg-535353\"><div class=\"footer\">\nThis window is currently in view only mode. If you want to edit this page, generate OTP by clicking <span \nng-click=\"$ctrl.isClickEnable && $ctrl.generateOtp()\" class=\"otp-click pl-5\">here</span></div></div><div \nng-if=\"$ctrl.quote_result.result_data.is_booked && !$ctrl.quote_result.result_data.shipment_id\"><div layout=\"row\" \nflex=\"100\" class=\"ph-10 pv-0\" layout-align=\"center start\" layout-wrap><p class=\"pl-10 fb-black font-size-18\">\nThis quote has been manually converted to won and no Booking is created.</p></div></div></div><div \nng-show=\"$ctrl.dataErr\" class=\"center-err\"><h1>Page not available!</h1></div></div>");
$templateCache.put("app/main/component/quote-modification/quote-modification-meta.html","<form name=\"$ctrl.copyQuoteForm\" class=\"search-form\" \nng-class=\"{\'mobile-form-style\': $ctrl.isStateResult && $ctrl.editSearch}\"><div layout=\"row\" layout-padding flex=\"100\" \nlayout-xs=\"column\" layout-xm=\"column\" layout-wrap class=\"ph-0\"><div class=\"mobile_input\" flex=\"50\" flex-xs=\"100\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult,\'result_multiport_div\':$ctrl.isStateResult}\"><span \nclass=\"form-title\">Origin</span><br><md-input-container md-no-float class=\"p-0 m-0 panel-select ph-10 origin\" \nng-class=\"{\'red-border pl-35\':(( ( $ctrl.copyQuoteForm.fcl_origin_port.$error.required && $ctrl.isCreateQuoteOriginValueChange ) || $ctrl.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.copyQuoteForm.fcl_origin_port.$error.touched || $ctrl.copyQuoteForm.$error.samePortError ) && !focused), \'pl-35\': $ctrl.search_param.mode!==\'AIR\', \'b-focus\': originFocused}\" \nlayout=\"row\" layout-align=\"start center\" ng-mouseleave=\"focused=false\" ng-mouseenter=\"focused=true\"><md-icon \nng-if=\"((  ( $ctrl.copyQuoteForm.fcl_origin_port.$error.required && $ctrl.isCreateQuoteOriginValueChange ) || $ctrl.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.copyQuoteForm.fcl_origin_port.$error.touched ||  $ctrl.copyQuoteForm.$error.samePortError) && !focused )\" \nmdprefix class=\"mh-5 h-15 w-15 mt-2 ml-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-autocomplete ml-2\" \nng-class=\"{  \'icon-size-10 margin-top-6\' : !$ctrl.search_param.origin_location ,\'h-24 w-24\' : $ctrl.search_param.origin_location.place_type===\'Door\'}\" \nmd-svg-src=\"{{ $ctrl.search_param.origin_location ?\n               ($ctrl.search_param.origin_location.place_type !== \'Door\' ?\n                    ($ctrl.search_param.mode===\'SEA-FCL\' ? ($ctrl.search_param.origin_location.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!((( $ctrl.copyQuoteForm.fcl_origin_port.$error.required && $ctrl.isCreateQuoteOriginValueChange ) || $ctrl.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.copyQuoteForm.$error.samePortError) && !focused )) && $ctrl.search_param.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\" \nng-if=\"(\n              !( \n              ( \n              \n                  ( $ctrl.copyQuoteForm.fcl_origin_port.$error.required  && $ctrl.isCreateQuoteOriginValueChange ) \n                  || $ctrl.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] \n                  || $ctrl.copyQuoteForm.$error.samePortError\n              ) \n              && !focused\n              ) \n          ) && $ctrl.search_param.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin\',$event,oldvalue);$ctrl.isCreateQuoteOriginValueChange = true;\" \nng-init=\"oldvalue=null\" \nng-focus=\"focused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;originFocused=true ;$ctrl.search_param.origin_location ? oldvalue = $ctrl.search_param.origin_location : return \" \nng-blur=\"originFocused=false\" \nng-class=\"{\'placeholder-error\':(( ($ctrl.copyQuoteForm.fcl_origin_port.$error.required && $ctrl.isCreateQuoteOriginValueChange ) || $ctrl.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.copyQuoteForm.$error.samePortError) && ($ctrl.copyQuoteForm.fcl_origin_port.$dirty || $ctrl.formSubmit))}\" \nrequired id=\"origin-input\" md-input-name=\"fcl_origin_port\" md-selected-item=\"$ctrl.search_param.origin_location\" \nmd-search-text=\"fcl_originSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_originSearchText, $ctrl.search_param.mode, \'origin\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nmd-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{  $ctrl.search_param.mode===\'AIR\' ?\'Search by Door/Airport\':\'Search by Door/Port\'}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div \nng-show=\"$ctrl.search_param.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.search_param.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.search_param.mode===\'SEA-LCL\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_originSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                               track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                   track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span> \n<span class=\"grey-fg font-size-12\" ng-if=\"!$last\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip \nmd-direction=\"top\" class=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"mt-15\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" \nng-if=\"$ctrl.search_param.origin_location\"><div>\n{{$ctrl.search_param.origin_location.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.search_param.origin_location, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.search_param.origin_location, true).join(\',\'):$ctrl.search_param.origin_location.location)}}\n</div></md-tooltip></md-input-container></div><div class=\"mobile_input\" flex=\"50\" flex-xs=\"100\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult,\'result_multiport_div\':$ctrl.isStateResult}\"><span \nclass=\"form-title\">Destination</span><br><md-input-container md-no-float \nclass=\"p-0 m-0 panel-select ph-10 destination\" \nng-class=\"{\'red-border pl-35\':((( $ctrl.copyQuoteForm.fcl_destination_port.$error.required && $ctrl.isCreateQuoteDesValueChange ) || $ctrl.copyQuoteForm.fcl_destination_port.$error.touched || $ctrl.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.copyQuoteForm.$error.samePortError ) && !destfocused ), \'pl-35\': $ctrl.search_param.mode!==\'AIR\', \'b-focus\': destinationFocused}\" \nlayout=\"row\" layout-align=\"start center\" ng-mouseleave=\"destfocused=false\" ng-mouseenter=\"destfocused=true\"><md-icon \nng-if=\"(( ( $ctrl.copyQuoteForm.fcl_destination_port.$error.required && $ctrl.isCreateQuoteDesValueChange ) || $ctrl.copyQuoteForm.fcl_destination_port.$error.touched || $ctrl.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.copyQuoteForm.$error.samePortError ) && !destfocused )\" \nmdprefix class=\"mh-5 h-15 w-15 mt-2 ml-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-autocomplete ml-2\" \nng-class=\"{  \'icon-size-10 margin-top-6\' : !$ctrl.search_param.destination_location ,\'h-24 w-24\' : $ctrl.search_param.destination_location.place_type===\'Door\'}\" \nmd-svg-src=\"{{ $ctrl.search_param.destination_location ?\n               ($ctrl.search_param.destination_location.place_type !== \'Door\' ?\n                    ($ctrl.search_param.mode===\'SEA-FCL\' ? ($ctrl.search_param.destination_location.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"( !( (\n                          ( $ctrl.copyQuoteForm.fcl_destination_port.$error.required && $ctrl.isCreateQuoteDesValueChange )\n                          || $ctrl.copyQuoteForm.fcl_destination_port.$error.touched \n                          || $ctrl.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] \n                          || $ctrl.copyQuoteForm.$error.samePortError \n                      )\n                      && !destfocused \n                  )\n              )  && $ctrl.search_param.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\" \nng-if=\"( !( (\n              ( $ctrl.copyQuoteForm.fcl_destination_port.$error.required && $ctrl.isCreateQuoteDesValueChange )\n                          || $ctrl.copyQuoteForm.fcl_destination_port.$error.touched \n                          || $ctrl.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] \n                          || $ctrl.copyQuoteForm.$error.samePortError \n                      )\n                      && !destfocused \n                  )\n              )   && $ctrl.search_param.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'destination\',$event,oldDestValue);$ctrl.isCreateQuoteDesValueChange = true\" \nng-init=\"oldDestValue=null\" \nng-focus=\"$ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;destinationFocused=true;$ctrl.search_param.destination_location ? oldDestValue=$ctrl.search_param.destination_location : return\" \nng-blur=\"destinationFocused=false\" \nng-class=\"{\'placeholder-error\':(( ( $ctrl.copyQuoteForm.fcl_destination_port.$error.required && $ctrl.isCreateQuoteDesValueChange ) || $ctrl.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.copyQuoteForm.$error.samePortError) && ($ctrl.copyQuoteForm.fcl_destination_port.$dirty || $ctrl.formSubmit))}\" \nrequired id=\"destination-input\" md-input-name=\"fcl_destination_port\" \nmd-selected-item=\"$ctrl.search_param.destination_location\" md-search-text=\"fcl_destinationSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_destinationSearchText, $ctrl.search_param.mode, \'destination\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nmd-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{  $ctrl.search_param.mode===\'AIR\' ?\'Search by Door/Airport\':\'Search by Door/Port\'}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"destfocused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div \nng-show=\"$ctrl.search_param.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.search_param.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.search_param.mode===\'SEA-LCL\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_destinationSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_destinationSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_destinationSearchText); \n                                                                         track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_destinationSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_destinationSearchText,false); \n                                                                                                track by $index\">\n<span class=\"grey-fg font-size-12 ellipsis-sub-location\" \ncompile-html=\"$ctrl.util.searchHighlight(location,fcl_destinationSearchText)\"></span><span \nclass=\"grey-fg font-size-12\" ng-if=\"$last\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_destinationSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_destinationSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"mt-15\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" \nng-if=\"$ctrl.search_param.destination_location\"><div>\n{{$ctrl.search_param.destination_location.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.search_param.destination_location, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.search_param.destination_location, true).join(\',\'):$ctrl.search_param.destination_location.location)}}\n</div></md-tooltip></md-input-container></div></div><div layout=\"row\" layout-padding flex=\"100\" layout-xs=\"column\" \nlayout-xm=\"column\" layout-wrap class=\"ph-0\"><div ng-if=\"$ctrl.search_param.mode ===\'SEA-FCL\'\"><span class=\"form-title\">\nLoad Type<md-icon md-font-icon=\"icon-information-outline\" class=\"s16 ml-5 pointer load-alias grey-400-fg\" \nng-mouseover=\"$ctrl.showLoadAlias($event)\"></md-icon></span><br><md-input-container md-no-float class=\"p-0 m-0\"><div \nclass=\"w-150 panel-select panel-select-load pointer mobile_input\" ng-click=\"$ctrl.showLoadPanel($event)\" \nng-class=\"{\'red-border red-fg\': $ctrl.copyQuoteForm.$error.loadError}\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"80\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/load_type.svg\')\" class=\"icon-bg\" \nng-if=\"!($ctrl.copyQuoteForm.$error.loadError)\"></div><md-icon ng-if=\"$ctrl.copyQuoteForm.$error.loadError\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div \ntruncate=\"{{$ctrl.LoadBoxString}}\" class=\"mt-2 pv-5 hide-overflow text-truncate\" \nng-class=\"{\'margin-remove\': $ctrl.LoadBoxString===\'\'}\">{{$ctrl.LoadBoxString}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.LoadTooltipString}}</span>\n</md-tooltip></div><div ng-if=\"$ctrl.LoadBoxString===\'\'\" class=\"mh-10 pv-5\" \nng-class=\"{\'margin-remove\':$ctrl.copyQuoteForm.$error.loadError}\">Select Load</div></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\" flex=\"20\"></md-icon></div></md-input-container></div><div \nng-if=\"$ctrl.search_param.mode !==\'SEA-FCL\'\"><span class=\"form-title\">Load Details<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">Chargeable Weight</md-tooltip></md-icon></span><br><md-input-container md-no-float \nclass=\"p-0 m-0\"><div class=\"w-150 panel-select panel-select-load-detail pointer mobile_input\" \nng-click=\"$ctrl.showLoadDetailPanel($event)\" \nng-class=\"{\'red-border red-fg\': $ctrl.copyQuoteForm.$error.loadDetailError}\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"85\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/load_detail.svg\')\" class=\"icon-bg\" \nng-if=\"!($ctrl.copyQuoteForm.$error.loadDetailError)\"></div><md-icon \nng-if=\"$ctrl.copyQuoteForm.$error.loadDetailError\" class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pv-5 text-truncate mt-2\">\nCharged Wt: {{$ctrl.search_param.load_data.load_meta.chargeable_weight || 0 | currencyMask: 2}} {{$ctrl.util.chargeableUnit[$ctrl.search_param.mode]}}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-12\">\nCharged Wt: {{$ctrl.search_param.load_data.load_meta.chargeable_weight || 0 | currencyMask: 2}} {{$ctrl.util.chargeableUnit[$ctrl.search_param.mode]}}\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\" flex=\"20\"></md-icon></div>\n</md-input-container></div><div><span class=\"form-title\">Cut Off Date</span><br><date-picker \nmd-input-id=\"\'cargo_ready_date\'\" \nis-validate=\"($ctrl.copyQuoteForm.cargo_ready_date.$error.required || $ctrl.copyQuoteForm.cargo_ready_date.$error.mindate ||  ( $ctrl.copyQuoteForm.cargo_ready_date.$error.required && $ctrl.isCreateQuote ) ) && ($ctrl.copyQuoteForm.cargo_ready_date.$dirty || $ctrl.formSubmit || ( $ctrl.copyQuoteForm.cargo_ready_date.$error.required && $ctrl.isCreateQuote ) )\" \nis-editable=\"false\" is-disabled=\"false\" input-required=\"true\" input-name=\"\'cargo_ready_date\'\" full-border=\"true\" \ndate-placeholder=\"\'Select\'\" date-format=\"true\" full-border=\"true\" min-date-value=\"$ctrl.todayDate\" \nmax-date-value=\"$ctrl.cutoffMaxDate\" model-value=\"$ctrl.search_param.cargo_ready_date\" \ncallback=\"$ctrl.fetchNearby($ctrl.search_param.destination_location , $ctrl.search_param.mode, \'cargo_date\', $ctrl.search_param.cargo_ready_date, $ctrl.search_param.destination_location);$ctrl.quotePeriodDateSet();\">\n</date-picker></div><div><span class=\"form-title\">Incoterms</span><br><div><incoterm-select \nincoterm=\"$ctrl.search_param.inco_term\" impo-expo=\"$ctrl.search_param.impo_expo\" select-panel-width=\"\'260\'\" \ncallback=\"$ctrl.incotermsWarning=true;\" full-border=\"true\"></incoterm-select></div></div><div \nng-if=\"$ctrl.search_param.mode===\'SEA-FCL\' &&  $ctrl.searchConfig &&  $ctrl.searchConfig.stuffing\"><span \nclass=\"font-size-13 Font-Bold\">Stuffing</span><div><md-input-container md-no-float class=\"p-0 w-110 m-0\"><md-select \nng-model=\"$ctrl.search_param.stuffing\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nclass=\"panel-select\" placeholder=\"Select Stuffing\"><md-option md-no-ink value=\"F\" class=\"md-primary checkbox-margin\">\nFactory</md-option><md-option md-no-ink value=\"D\" class=\"md-primary\">Dock</md-option></md-select></md-input-container>\n</div></div><div><span class=\"form-title\">Customs</span><div><md-input-container md-no-float class=\"p-0 w-110 m-0\">\n<md-select ng-model=\"$ctrl.search_param.customs\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Select Customs\" class=\"panel-select\"><md-option md-no-ink ng-value=\"true\" \nclass=\"md-primary checkbox-margin\">Yes</md-option><md-option md-no-ink ng-value=\"false\" class=\"md-primary\">No\n</md-option></md-select></md-input-container></div></div><div><span class=\"form-title\">Quote Period</span><div><div \nlayout=\"row\" layout-align=\"space-between\" class=\"pointer font-size-12 panel-select w-190 mb-15\" \nng-class=\"{\'validation-error red-fg\': $ctrl.dateRangeError}\"><md-icon ng-if=\"!$ctrl.dateRangeError\" \nmd-font-icon=\"icon-calendar\" class=\"s24 pointer fg-A8A8A8-imp mr-5 pl-5\"></md-icon><md-icon \nng-if=\"$ctrl.dateRangeError\" class=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon>\n<md-date-range ng-model=\"$ctrl.pickerModel\" ng-class=\"{\'placeholder-text\':!$ctrl.pickerModel.dateStart}\" \nclass=\"date-range-picker\" placeholder=\"Select quote period\" md-on-select=\"$ctrl.setDatePicker($ctrl.pickerModel);\" \none-panel=\"true\" auto-confirm=\"true\" show-template=\"false\"></md-date-range></div></div></div><div><span \nclass=\"form-title\">Currency</span><currency-dropdown class=\"w-100-p pointer mt-4 mb-15\" \ncallback=\"$ctrl.searchCurrencyChange(selectedValue)\" layout=\"row\" layout-align=\"space-between\" full-border=\"true\" \nfield-value=\"$ctrl.currency\"></currency-dropdown></div><div><span class=\"form-title\">Terms and Conditions</span><div \nlayout=\"column\" class=\"font-size-13 pointer md-link-fg link-btn pt-2\" ng-click=\"$ctrl.fnopenTermsCondition($event);\">\n{{ $ctrl.quote_result.result_data.terms.length ? \'Edit/Delete\' : \'+ Add Terms and Condition\' }}</div></div></div>\n</form>");
$templateCache.put("app/main/component/quote-modification/quote-modification-quotation.html","<md-dialog id=\"share-quotation\" class=\"dialobox\" ng-cloak><md-dialog-content class=\"p-0\"><md-toolbar \nid=\"share_quotation_Toolbar\" class=\"font-size-21\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex=\"70\"><span class=\"toolbarHeading font-weight-600 p-0\">Generate Quotation\n</span></div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor m-0\" ng-click=\"$ctrl.closeShareDialog(\'quote\')\" \nng-disabled=\"$ctrl.PdfQuoteBtn || $ctrl.shareQuoteBtn\"></md-icon></div></div></md-toolbar><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"mt-25\"><div layout=\"row\" flex=\"100\" class=\"w-50 h-50\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"w-50 h-50 tick_success\"></md-icon></div><div layout=\"column\" \nflex=\"100\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" class=\"mt-20 mb-10 send-msg\">\n{{ $ctrl.shareQuoteResponse.message }}</div><div layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"mb-15 mt-8 inquiry-id-container\" ng-if=\"!$ctrl.shareQuoteResponse.inquiry_id\">Quote ID : <span \nclass=\"inquiry-id ml-5\" ng-click=\"$ctrl.closeShareDialog(\'quote\')\">{{ $ctrl.shareQuoteResponse.quote_id }}</span></div>\n<div layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"mb-15 mt-8 inquiry-id-container\" \nng-if=\"$ctrl.shareQuoteResponse.inquiry_id\">Inquiry ID : <span class=\"inquiry-id pl-5\" \nng-click=\"$ctrl.closeShareDialog(\'inquiry\')\">{{ $ctrl.shareQuoteResponse.inquiry_number }}</span></div><div \nlayout=\"column\" flex=\"100\" layout-align=\"center center\" class=\"Font-Bold font-size-12 mb-15\" \nng-show=\"!$ctrl.quoteDetails.send_mail\"><div class=\"successNote\">\n{{ ($ctrl.isPdfFailed || $ctrl.isPdfErrOccured) ? \'Note: Email to the customer will be shared after PDF generation\' : \'Note: Email not sent to customer\'}}\n</div><div ng-if=\"$ctrl.isPdfFailed || $ctrl.isPdfErrOccured\" class=\"grey-fg Font-Regular mt-8\">\nYou can try again in Inquiry or quote details</div></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"quote-footer p-10\" layout-wrap><div layout=\"column\" \nlayout-align=\"center start\" flex-xs=\"100\" class=\"mt-8 pl-10\"><div ng-if=\"!$ctrl.isPdfFailed\" \nng-bind=\"!$ctrl.isPdfGenerated ? \'We are generating a downloadable quotation(PDF Format).\':\'Downloadable quotation(PDF Format) is ready\'\" \nclass=\"mb-5\"></div><div ng-if=\"$ctrl.isPdfFailed\" class=\"red-300-fg font-size-12 mb-5\">\nAn error has occurred while creating the PDF, please <span class=\"text-underline md-link-fg Font-Bold pointer\" \nng-click=\"$ctrl.fnGetPdfLink();$ctrl.trackEvent(\'GQ-QuoteID-DownloadPDF-TryAgain-Click\')\"><u>try again</u></span></div>\n<div ng-if=\"$ctrl.isPdfErrOccured\" class=\"red-300-fg font-size-12 mb-5\">\nOur system is down, we aren’t able to generate the PDF. Please try again later.</div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!$ctrl.isPdfFailed && !$ctrl.isPdfErrOccured\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-5\"><progress max=\"100\" value=\"{{$ctrl.downloadProgressValue*20}}\"></progress>\n</div><div ng-if=\"!$ctrl.isPdfFailed && !$ctrl.isPdfErrOccured\" class=\"text-italic font-size-11 black-fg\">\n{{$ctrl.isPdfGenerated || $ctrl.downloadProgressValue >= 5 ? \'100\' : $ctrl.downloadProgressValue*20}} %</div></div>\n</div><div layout=\"row\" layout-align=\"end center\" class=\"m-10 h-35\" flex-xs=\"100\"><md-button md-no-ink \nclass=\"md-primary-btn with-icon mr-10\" title=\"View Quote\" ng-click=\"$ctrl.closeShareDialog(\'quote\')\" \nng-if=\"$ctrl.shareQuoteResponse.quote_id\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon>View Quote</md-button>\n<md-button md-no-ink class=\"md-accent-btn with-icon ml-10\" title=\"Download\" \nng-disabled=\"!$ctrl.isPdfGenerated || $ctrl.isPdfFailed\" ng-click=\"$ctrl.downloadPdf()\"><span><md-icon \nmd-font-icon=\"icon-download\" class=\"s16\"></md-icon></span>Download PDF</md-button></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/component/quote-sync-button/quote-sync-button.html","<div ng-if=\"$ctrl.integrationoptions.menu.isVisible\"><md-menu-bar id=\"quote-sync-button\" class=\"p-0\"><md-menu>\n<md-button md-no-ink aria-label=\"Open sync menu\" \nng-disabled=\"!$ctrl.integrationoptions.menu.isEnabled ||  $ctrl.quotemodify\" class=\"md-primary-btn with-icon mb-0\" \nlayout=\"row\" layout-align=\"center center\" ng-click=\"$ctrl.openSendToMenu($mdMenu, $event)\"><md-icon \nclass=\"icon-share-16 m-0\" md-svg-src=\"assets/icons/custom/ios_share_black_24dp.svg\"></md-icon><span \nclass=\"pl-2 pr-2 pg-color\">{{$ctrl.integrationoptions.menu.label}}</span><md-icon class=\"s18 m-0\" \nmd-font-icon=\"icon-chevron-down\" ng-if=\"!$ctrl.showloader\"></md-icon><div ng-if=\"$ctrl.showloader\"><md-icon \nmd-font-icon=\"icon-refresh\" class=\"fa-spins\"></md-icon><span>Loading...</span></div><md-tooltip \nng-if=\"$ctrl.integrationoptions.menu.tooltipText\" md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\n{{$ctrl.integrationoptions.menu.tooltipText}}</md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item \nclass=\"create-menu-item\" ng-class=\"{\'bb\': !$last}\" \nng-repeat=\"child in $ctrl.integrationoptions.menu.childrens track by $index\" \nng-if=\"child.isVisible && child.isChildren\"><md-menu class=\"create-content\"><md-button \nng-click=\"$ctrl.openSendToMenu($mdMenu, $event)\" class=\"h-45\" ng-disabled=\"!child.isEnabled\"><div layout=\"row\"><div \nlayout=\"column\" flex=\"90\" class=\"ml-5 h-60\"><span flex=\"30\" class=\"font-size-13 fg-333333\" ng-bind=\"child.label\">\n</span></div></div></md-button><md-menu-content width=\"3\" ng-class=\"{\'hide\' : !child.isEnabled}\"><div \nng-repeat=\"submenus in child.componentOptions\"><md-menu-item class=\"create-menu-item bg-transparent\" \nng-class=\"{\'bb\': !$last}\" ng-if=\"submenus.isVisible\"><md-button ng-disabled=\"!submenus.isEnabled\" \nng-click=\"$ctrl.fnSendto(submenus)\" class=\"h-45\"><span>{{submenus.label}}</span></md-button></md-menu-item></div>\n</md-menu-content></md-menu></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>");
$templateCache.put("app/main/component/rate-card-table/rate-card-table.html","<div id=\"rate-card-table\" style=\"width:100%\" ng-if=\"$ctrl.resultCardObject && $ctrl.isUpdated\" \nng-show=\"$ctrl.isShowTable\"><table datatable ng-if=\"$ctrl.tabledisplaymode === \'colspan\'\" dt-options=\"$ctrl.dtOptions\" \ndt-instance=\"$ctrl.dtInstanceCallback\" \nclass=\"table-icon-align-filter dataTable row-border1 result-table hover stripe cell-border display compact\" \nstyle=\"width:100%\" id=\"result-table\"><thead><tr><th class=\"th-width-checkbox no-sort Font-Bold noExport\" \ndata-name=\"checkBox\" rowspan=\"3\"><input type=\"checkbox\" class=\"select-all\" ng-click=\"$ctrl.tableRowSelect();\"></th><th \nclass=\"th-width no-sort Font-Bold th-liners\" data-name=\"Liners\" rowspan=\"3\">Liners <span \nng-if=\"$ctrl.linerFilterConditions.selectedCount\" class=\"datatable-filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.linerFilterConditions.selectedCount}}</span><multi-select md-input-id=\"\'liner-filter-table\'\" \noptions-data-obj=\"$ctrl.linerObject\" query-conditions=\"$ctrl.linerFilterConditions\" \ncallback=\"$ctrl.linerObject = $ctrl.callBackFilter(\'Liners\',\'linerFilterConditions\',payload,\'linerObject\')\">\n</multi-select></th><th class=\"th-width no-sort Font-Bold th-origin\" \nng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\" data-name=\"Origin Door\" rowspan=\"3\">Origin Door</th><th\n class=\"th-width no-sort Font-Bold th-place-of-receipt\" data-name=\"Place of receipt\" rowspan=\"3\">Place of receipt</th>\n<th class=\"th-width no-sort Font-Bold th-pol\" data-name=\"POL\" rowspan=\"3\">POL <span \nng-if=\"$ctrl.polFilterConditions.selectedCount\" class=\"datatable-filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.polFilterConditions.selectedCount}}</span><multi-select md-input-id=\"\'pol-filter-table\'\" \noptions-data-obj=\"$ctrl.polObject\" query-conditions=\"$ctrl.polFilterConditions\" \ncallback=\"$ctrl.callBackFilter(\'POL\',\'polFilterConditions\',payload,\'polObject\')\"></multi-select></th><th \nclass=\"th-width no-sort Font-Bold th-pickupmode\" data-name=\"Pickup Mode\" \nng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\" rowspan=\"3\">Pickup Mode</th><th \nclass=\"th-width no-sort Font-Bold th-pickupmode\" data-name=\"Pickup Service Type\" \nng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\" rowspan=\"3\">Pickup Service Type</th><th \nclass=\"th-width no-sort Font-Bold th-via-port\" data-name=\"Via Port\" rowspan=\"3\">Via Port</th><th \nclass=\"th-width no-sort Font-Bold th-pod\" data-name=\"POD\" rowspan=\"3\">POD <span \nng-if=\"$ctrl.podFilterConditions.selectedCount\" class=\"datatable-filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.podFilterConditions.selectedCount}}</span><multi-select md-input-id=\"\'pod-filter-table\'\" \noptions-data-obj=\"$ctrl.podObject\" query-conditions=\"$ctrl.podFilterConditions\" \ncallback=\"$ctrl.callBackFilter(\'POD\',\'podFilterConditions\',payload,\'podObject\')\"></multi-select></th><th \nclass=\"th-width no-sort Font-Bold th-final-destination\" data-name=\"Final Destination\" rowspan=\"3\">Final Destination\n</th><th class=\"th-width no-sort Font-Bold th-final-destination hide\" data-name=\"Total Buy Rates\" \nng-if=\"$root.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL\" rowspan=\"3\">Total Buy Rates</th><th \nclass=\"th-width no-sort Font-Bold th-destination-door\" data-name=\"Destination Door\" rowspan=\"3\" \nng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">Destination Door</th><th \nclass=\"th-width no-sort Font-Bold th-deliverymode\" data-name=\"Delivery Mode\" rowspan=\"3\" \nng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">Delivery Mode</th><th \nclass=\"th-width no-sort Font-Bold th-deliverymode\" data-name=\"Delivery Service Type\" rowspan=\"3\" \nng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">Delivery Service Type</th><th \nclass=\"th-width no-sort Font-Bold text-center leg-width\" data-name=\"{{value.title}}\" \ncolspan=\"{{ $ctrl.searchparam.load_data.load_details_value.length*2 + 2}}\" ng-repeat=\"(key, value) in $ctrl.legList\">\n{{value.title}}</th><th class=\"th-width Font-Bold th-origin-custom\" data-name=\"Origin custom\" rowspan=\"3\">Origin<br>\nCustom Total<md-icon class=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th \nclass=\"th-width Font-Bold th-destination-custom\" data-name=\"Destination custom\" rowspan=\"3\">Destination<br>Custom Total\n<md-icon class=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th \nclass=\"th-width Font-Bold th-sailing-date\" data-name=\"Sailing Date\" rowspan=\"3\">Sailing Date<md-icon \nclass=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th \nclass=\"th-width Font-Bold th-transit-time\" data-name=\"Transit Time\" rowspan=\"3\">Transit Time<md-icon \nclass=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th \nclass=\"th-width Font-Bold th-start-date\" data-name=\"Start Date\" rowspan=\"3\">Start Date<md-icon \nclass=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th \nclass=\"th-width Font-Bold th-expiry-date\" data-name=\"Expiry Date\" rowspan=\"3\">Expiry Date<md-icon \nclass=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th \nclass=\"th-width no-sort Font-Bold th-cargo-type\" data-name=\"Cargo Type\" rowspan=\"3\">Cargo Type<div \nclass=\"cargo-type-filter\"><span ng-if=\"$ctrl.cargoFilterConditions.selectedCount\" \nclass=\"datatable-filter-count md-component-bg white-fg ml-5\">{{$ctrl.cargoFilterConditions.selectedCount}}</span>\n<multi-select md-input-id=\"\'cargo-filter-table\'\" options-data-obj=\"$ctrl.cargoTypeObject\" \nquery-conditions=\"$ctrl.cargoFilterConditions\" \ncallback=\"$ctrl.callBackFilter(\'Cargo Type\',\'cargoFilterConditions\',payload,\'cargoTypeObject\')\"></multi-select></div>\n</th><th class=\"th-width no-sort Font-Bold th-commodity\" data-name=\"Commodity\" rowspan=\"3\">Commodity <span \nng-if=\"$ctrl.commodityFilterConditions.selectedCount\" class=\"datatable-filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.commodityFilterConditions.selectedCount}}</span><div class=\"comodity\"><multi-select \nmd-input-id=\"\'commodity-filter-table\'\" options-data-obj=\"$ctrl.commodityTypeObject\" \nquery-conditions=\"$ctrl.commodityFilterConditions\" \ncallback=\"$ctrl.callBackFilter(\'Commodity\',\'commodityFilterConditions\',payload,\'commodityTypeObject\')\"></multi-select>\n</div></th><th class=\"th-width no-sort Font-Bold th-service-type\" data-name=\"Service Type\" rowspan=\"3\">Service Type\n</th><th class=\"th-width no-sort Font-Bold th-free-days noExport\" data-name=\"Free Days\" rowspan=\"3\">Free Days</th><th \nclass=\"th-width no-sort Font-Bold th-rate-by\" data-name=\"Rate By\" rowspan=\"3\">Rate By <span \nng-if=\"$ctrl.rateByFilterConditions.selectedCount\" class=\"datatable-filter-count md-component-bg white-fg ml-5\">\n{{$ctrl.rateByFilterConditions.selectedCount}}</span><multi-select md-input-id=\"\'rateBy-filter-table\'\" \noptions-data-obj=\"$ctrl.rateByFilterData\" query-conditions=\"$ctrl.rateByFilterConditions\" \ncallback=\"$ctrl.callBackFilter(\'Rate By\',\'rateByFilterConditions\',payload,\'rateByFilterData\')\"></multi-select></th><th \nclass=\"th-width no-sort Font-Bold th-rate-id\" data-name=\"Rate ID for spot / Contract ID\" rowspan=\"3\">Rate ID for spot\n<br>/ Contract ID</th><th class=\"fixed-th-width Font-Bold th-total-cost\" data-name=\"Total Cost\" rowspan=\"3\">Total Cost\n<md-icon class=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th \nclass=\"fixed-th-width no-sort Font-Bold noExport text-center th-action\" data-name=\"Action\" rowspan=\"3\">Action</th></tr>\n<tr><th ng-if=\"$ctrl.legList[$ctrl.l3_leg]\" \nng-class=\"{\'th-line-break\': [\'Other Fixed Charge\'].includes(header),\'text-center\': header!==\'Other Fixed Charge\' && header!==\'Freight Total\'}\" \ncolspan=\"{{header==\'Freight Total\' || header==\'Other Fixed Charge\' ? 1 : $ctrl.searchparam.load_data.load_details_value.length }}\" \nrowspan=\"{{header==\'Freight Total\' || header==\'Other Fixed Charge\' ? 2 : 1 }}\" \nclass=\"th-width colspan Font-Bold th-freight-cost\" data-parent-column=\"{{$ctrl.legList[$ctrl.l3_leg].title}}\" \ndata-name=\"{{header === \'Other Fixed Charge\' ? $ctrl.legList[$ctrl.l3_leg].title + \' - \' : \'\'}} {{header}}\" \nng-repeat=\"header in $ctrl.legList[$ctrl.l3_leg].summeryheader\">{{header}}<md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">{{header}}</md-tooltip><md-icon \nng-if=\"header==\'Freight Total\' || header==\'Other Fixed Charge\'\" class=\"icon-class sort-icon\" \nmd-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th><th ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" \nng-class=\"{\'th-line-break\': [\'Pickup Total\',\'Other Fixed Charge\',\'Pickup Charge\'].includes(header),\'text-center\': header!==\'Pickup Total\' && header!==\'Other Fixed Charge\'}\" \ncolspan=\"{{header==\'Pickup Total\' || header==\'Other Fixed Charge\' ? 1 : $ctrl.searchparam.load_data.load_details_value.length }}\" \nrowspan=\"{{header==\'Pickup Total\' || header==\'Other Fixed Charge\' ? 2 : 1 }}\" \nclass=\"th-width colspan Font-Bold th-freight-cost\" data-parent-column=\"{{$ctrl.legList[$ctrl.l1_leg].title}}\" \ndata-name=\"{{header === \'Other Fixed Charge\' ? $ctrl.legList[$ctrl.l1_leg].title + \' - \' : \'\'}} {{header}}\" \nng-repeat=\"header in $ctrl.legList[$ctrl.l1_leg].summeryheader\">{{header}}<md-icon \nng-if=\"header==\'Pickup Total\' || header==\'Other Fixed Charge\'\" class=\"icon-class sort-icon\" \nmd-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">{{header}}</md-tooltip></th><th \nng-if=\"$ctrl.legList[$ctrl.l2_leg]\" \nng-class=\"{\'th-line-break\': [\'Other Fixed Charge\'].includes(header),\'text-center\': header!==\'Other Fixed Charge\' && header!==\'Origin Total\'}\" \ncolspan=\"{{header==\'Origin Total\' || header==\'Other Fixed Charge\' ? 1 : $ctrl.searchparam.load_data.load_details_value.length }}\" \nrowspan=\"{{header==\'Origin Total\' || header==\'Other Fixed Charge\' ? 2 : 1 }}\" \nclass=\"th-width colspan Font-Bold th-freight-cost\" data-parent-column=\"{{$ctrl.legList[$ctrl.l2_leg].title}}\" \ndata-name=\"{{header === \'Other Fixed Charge\' ? $ctrl.legList[$ctrl.l2_leg].title + \' - \' : \'\'}} {{header}}\" \nng-repeat=\"header in $ctrl.legList[$ctrl.l2_leg].summeryheader\">{{header}}<md-icon \nng-if=\"header==\'Origin Total\' || header==\'Other Fixed Charge\'\" class=\"icon-class sort-icon\" \nmd-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">{{header}}</md-tooltip></th><th \nng-if=\"$ctrl.legList[$ctrl.l4_leg]\" \nng-class=\"{\'th-line-break\': [\'Destination Total\',\'Other Fixed Charge\'].includes(header),\'text-center\': header!==\'Destination Total\' && header!==\'Other Fixed Charge\'}\" \ncolspan=\"{{header==\'Destination Total\' || header==\'Other Fixed Charge\' ? 1 : $ctrl.searchparam.load_data.load_details_value.length }}\" \nrowspan=\"{{header==\'Destination Total\' || header==\'Other Fixed Charge\' ? 2 : 1 }}\" \nclass=\"th-width colspan Font-Bold th-freight-cost\" data-parent-column=\"{{$ctrl.legList[$ctrl.l4_leg].title}}\" \ndata-name=\"{{header === \'Other Fixed Charge\' ? $ctrl.legList[$ctrl.l4_leg].title + \' - \' : \'\'}} {{header}}\" \nng-repeat=\"header in $ctrl.legList[$ctrl.l4_leg].summeryheader\">{{header}}<md-icon \nng-if=\"header==\'Destination Total\' || header==\'Other Fixed Charge\'\" class=\"icon-class sort-icon\" \nmd-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">{{header}}</md-tooltip></th><th \nng-if=\"$ctrl.legList[$ctrl.l5_leg]\" \nng-class=\"{\'th-line-break\': [\'Delivery Total\',\'Other Fixed Charge\',\'Delivery Charge\'].includes(header) || header==\'Other Fixed Charge\',\'text-center\': header!==\'Delivery Total\' && header!==\'Other Fixed Charge\'}\" \ncolspan=\"{{header==\'Delivery Total\' || header==\'Other Fixed Charge\' ? 1 : $ctrl.searchparam.load_data.load_details_value.length }}\" \nrowspan=\"{{header==\'Delivery Total\' || header==\'Other Fixed Charge\' ? 2 : 1 }}\" \nclass=\"th-width colspan Font-Bold th-freight-cost\" data-parent-column=\"{{$ctrl.legList[$ctrl.l5_leg].title}}\" \ndata-name=\"{{header === \'Other Fixed Charge\' ? $ctrl.legList[$ctrl.l5_leg].title + \' - \' : \'\'}} {{header}}\" \nng-repeat=\"header in $ctrl.legList[$ctrl.l5_leg].summeryheader\">{{header}}<md-icon \nng-if=\"header==\'Delivery Total\' || header==\'Other Fixed Charge\'\" class=\"icon-class sort-icon\" \nmd-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">{{header}}</md-tooltip></th>\n</tr><tr><th class=\"th-width Font-Bold w-100 load_type\" data-parent-column=\"{{load.leg}}\" \ndata-name=\"{{load.leg}} {{load.basis}} {{load.type}}\" ng-repeat=\"load in $ctrl.loadList track by $index\">{{load.type }}\n<md-icon class=\"icon-class sort-icon\" md-svg-src=\"assets/icons/custom/sort-icon.svg\"></md-icon></th></tr></thead>\n<tbody><tr data-meta-iserror=\"{{card_item.meta.isError}}\" class=\"enterprise_view_div\" \nid=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_id}}\" \nng-repeat=\"card_item in $ctrl.resultCardObject | orderBy:[$ctrl.sortBy, \'-meta.isError\'] track by $index\"><td \nclass=\"td-width-checkbox\"><input type=\"checkbox\" ng-disabled=\"card_item.meta.isError\" class=\"selecte-row\"></td><td \nclass=\"td-width td-liners\" data-card-index=\"{{$index}}\" \ndata-search=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code}}\"><div \nng-show=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\"><img \nclass=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams(card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{$card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div>\n<div class=\"empty_logo text-truncate\" \ntitle=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\" \nng-show=\"!card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\">\n{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div><md-tooltip\n md-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</md-tooltip>\n</td><td class=\"td-width td-origin\" ng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\">\n{{card_item.meta.port_data.pickup_location ? card_item.meta.port_data.pickup_location : \'\'}} {{card_item.meta.port_data.pickup_pincode_ui ? card_item.meta.port_data.pickup_pincode_ui : \'\'}} {{!card_item.meta.port_data.pickup_pincode_ui && !card_item.meta.port_data.pickup_location ? \'-\' : \'\'}}\n<md-tooltip ng-if=\"card_item.meta.port_data.pickup_location\" md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.meta.port_data.pickup_location}} {{card_item.meta.port_data.pickup_pincode_ui}}</md-tooltip></td><td \nclass=\"td-width td-place-of-receipt\">\n{{card_item.meta.via_pol ? card_item.meta.port_data.origin_portname +\' / \'+ card_item.meta.port_data.origin_port_code : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"card_item.meta.via_pol\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{card_item.meta.port_data.origin_portname +\' / \'+ card_item.meta.port_data.origin_port_code}}</md-tooltip></td><td \nclass=\"td-width td-pol\">\n{{ card_item.meta.via_pol ? card_item.meta.via_pol : card_item.meta.port_data.origin_portname + \' / \' + card_item.meta.port_data.origin_port_code}}\n<md-tooltip md-direction=\"top\" ng-if=\"(card_item.meta.via_pol) || (card_item.meta.port_data.origin_portname)\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.meta.via_pol ? card_item.meta.via_pol : card_item.meta.port_data.origin_portname +\' / \'+ card_item.meta.port_data.origin_port_code}}\n</md-tooltip></td><td class=\"td-width td-pickupmode\" ng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\">\n{{card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode ? card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode}}</md-tooltip></td><td class=\"td-width td-pickupmode\" \nng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\">\n{{card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type ? card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type}}</md-tooltip></td><td class=\"td-width td-via-port\">\n{{ card_item.meta.selected_schedule ? card_item.meta.selected_schedule.via_port !== \"Direct\" ? card_item.meta.selected_schedule.via_port : \'-\' : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route : \'-\'}}\n<md-tooltip md-direction=\"top\" \nng-if=\"(card_item.meta.selected_schedule && card_item.meta.selected_schedule.via_port !== \'Direct\') || card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.meta.selected_schedule ? card_item.meta.selected_schedule.via_port !== \"Direct\" ? card_item.meta.selected_schedule.via_port : \'-\' : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route : \'-\'}}\n</md-tooltip></td><td class=\"td-width th-pod\">\n{{ card_item.meta.via_pod ? card_item.meta.via_pod : card_item.meta.port_data.destination_portname +\' / \'+ card_item.meta.port_data.destination_port_code }}\n<md-tooltip md-direction=\"top\" ng-if=\"card_item.meta.via_pod || card_item.meta.port_data.destination_portname\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.meta.via_pod ? card_item.meta.via_pod : card_item.meta.port_data.destination_portname +\' / \'+ card_item.meta.port_data.destination_port_code }}\n</md-tooltip></td><td class=\"td-width td-final-destination\">\n{{ card_item.meta.via_pod ? card_item.meta.port_data.destination_portname +\' / \'+ card_item.meta.port_data.destination_port_code : \'-\' }}\n<md-tooltip md-direction=\"top\" ng-if=\"card_item.meta.via_pod\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{card_item.meta.port_data.destination_portname +\' / \'+ card_item.meta.port_data.destination_port_code}}</md-tooltip>\n</td><td class=\"td-width td-final-destination hide\" ng-if=\"$root.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL\">\n{{ $ctrl.searchparam.user.user_base_currency }} {{ card_item.meta.buy_leg_total | currencyMask: 2 }}</td><td \nclass=\"td-width td-destination-door\" ng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">\n{{card_item.meta.port_data.delivery_location ? card_item.meta.port_data.delivery_location : \'\'}} {{card_item.meta.port_data.delivery_pincode_ui ? card_item.meta.port_data.delivery_pincode_ui : \'\'}} {{!card_item.meta.port_data.delivery_pincode_ui && !card_item.meta.port_data.delivery_location ? \'-\' : \'\'}}\n<md-tooltip ng-if=\"card_item.meta.port_data.delivery_location\" md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.meta.port_data.delivery_location}} {{card_item.meta.port_data.delivery_pincode_ui}}</md-tooltip></td><td \nclass=\"td-width td-deliverymode\" ng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">\n{{card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode ? card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode}}</md-tooltip></td><td \nclass=\"td-width td-deliverymode\" ng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">\n{{card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type ? card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type}}</md-tooltip></td><td \nclass=\"td-width text-right td-freight-cost\" style=\"width: 90px  !important\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost}}\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-freight-cost\" style=\"width: 90px  !important\" \nng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type]}}\">\n<span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-freight-cost\" style=\"width: 90px  !important\" \nng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type]}}\">\n<span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-freight-cost\" style=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type]}}\">\n<span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type]}}\">\n<span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type]}}\">\n<span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type]}}\">\n<span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\" \ndata-order=\"“{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type]}}”\">\n<span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type] ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px  !important\"><span \nng-bind=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-origin-custom\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost : \'-\'}}\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost| currencyMask:2) : \"-\"}}\n<md-tooltip ng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost|currencyMask:2) }}\n</md-tooltip></td><td class=\"td-width text-right td-destination-custom\" \ndata-order=\"{{  card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost : \'-\'}}\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost| currencyMask:2) : \"-\"}}\n<md-tooltip ng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency +\' \'+ (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost| currencyMask:2) }}\n</md-tooltip></td><td class=\"td-width text-center td-sailing-date\" \ndata-order=\"{{ card_item.meta.selected_schedule === null && !card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date ? \'-\' : (card_item.meta.selected_schedule.departure_time ? card_item.meta.selected_schedule.departure_time : card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date)}}\">\n{{ card_item.meta.selected_schedule === null && !card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date ? \'-\' : (card_item.meta.selected_schedule.departure_time ? card_item.meta.selected_schedule.departure_time : card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\')}}\n</td><td class=\"td-width text-center td-transit-time\" \ndata-order=\"{{ card_item.meta.selected_schedule ? (!card_item.meta.selected_schedule.transit_time ? \'-\' : card_item.meta.selected_schedule.transit_time) : (!card_item.data[$ctrl.resultCardFilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'-\' : card_item.data[$ctrl.resultCardFilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\">\n{{ card_item.meta.selected_schedule ?(!card_item.meta.selected_schedule.transit_time ? \'-\' : card_item.meta.selected_schedule.transit_time) : (!card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'-\' : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n</td><td class=\"td-width text-center td-start-date\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.start_date}}\">\n{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.start_date ? (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.start_date| NoTimeZone : \'d MMM yyyy\'):\"-\" }}\n</td><td class=\"td-width text-center td-expiry-date\" \ndata-order=\"{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.expiry}}\">\n{{card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.expiry ? (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.expiry| NoTimeZone : \'d MMM yyyy\'):\"-\" }}\n</td><td class=\"td-width td-cargo-type\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data.name ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data.name : \"-\" }}\n</td><td class=\"td-width td-commodity\" \ndata-search=\"{{ !card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity.length ? \'-\' : (card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity | enterpriceTextTransform : \' ;,.()\') }}\">\n<span class=\"commodity-text\">\n{{ !card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length ? \'-\' : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity }}\n</span><md-icon ng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length\" \nmd-font-icon=\"icon-chevron-down\" class=\"s14 fg-3F3851 pointer cargo-{{card_item._id}}\" \nng-click=\"$ctrl.showCargoCommodity($event, card_item._id, card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg],\'etl-result\', $ctrl.searchparam.mode)\">\n</md-icon></td><td class=\"td-width td-service-type\">\n{{ !card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }} {{ !card_item.meta.selected_schedule.service_name ? \'\' : \' | \' + card_item.meta.selected_schedule.service_name }}\n<md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type || card_item.meta.selected_schedule.service_name\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ !card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }} {{ !card_item.meta.selected_schedule.service_name ? \'\' : \' | \' + card_item.meta.selected_schedule.service_name }}\n</md-tooltip></td><td class=\"td-width text-center td-free-days\"><free-days \nfreedaysdata=\"{\n            demurrage_details : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.demurrage_details,\n            detention_details : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.detention_details,\n            combined_details : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.combined_details,\n            freeDays : card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.freeDays,\n            pageSource : \'EL\'\n          }\" \ntype=\"\'list-nwls\'\" cardid=\"card_item._id\" mode=\"$ctrl.searchparam.mode\" \nsearch-load-data=\"$ctrl.searchparam.load_data.load_details_value\"></free-days></td><td class=\"td-width td-rate-by\">\n{{!card_item.meta.isError ? (card_item.meta.type !== \'msr_spot\' && card_item.meta.type !== \'network_spot\' ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\') ? \'Agent -\' + card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : \'Forwarder -\'+ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name: \'-\') : \'-\' }}\n<md-tooltip \nng-if=\"card_item.meta.type !== \'msr_spot\' && card_item.meta.type !== \'network_spot\' && card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.meta.type !== \'msr_spot\' && card_item.meta.type !== \'network_spot\' ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\') ? \'Agent -\' + card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : \'Forwarder -\'+card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name : \'-\' }}\n</md-tooltip></td><td class=\"td-width td-rate-id\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id+\' / \' : \'\' }} {{ (!$ctrl.card_item.meta.type.includes(\'network\') || card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.show_contract_number) && card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number : \'-\' }}\n<md-tooltip \nng-if=\"card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id || ((!$ctrl.card_item.meta.type.includes(\'network\')  ||  card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.show_contract_number) && card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number)\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id+\' / \' : \'\' }} {{ (!$ctrl.card_item.meta.type.includes(\'network\') || card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.show_contract_number) && card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number ? card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number : \'-\' }}\n</div></md-tooltip></td><td class=\"fixed-td-width text-right td-total-cost\" \nng-class=\"{\'card-selected\':card_item.meta.is_selected}\" \ndata-order=\"{{card_item.meta[$ctrl.resultcardfilter.total_cost] | number:0}}\"><span class=\"totalCost{{$index}}\" \nng-if=\"!card_item.meta.isError\">\n{{ $ctrl.searchparam.user.user_base_currency ? $ctrl.searchparam.user.user_base_currency : \"-\" }} {{ card_item.meta[$ctrl.resultcardfilter.total_cost] ? (card_item.meta[$ctrl.resultcardfilter.total_cost] | currencyMask: 2) : 0 }}\n</span> <span ng-if=\"!card_item.meta.isError\" class=\"shimmerUpdateTd{{$index}} hide\" shimmer-effect-full width=\"100px\" \nheight=\"22px\" class=\"inline-block mr-10 mt-8\"></span><span ng-if=\"card_item.meta.isError\">N/A</span><md-tooltip \nng-if=\"card_item.meta[$ctrl.resultcardfilter.total_cost]\" md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.searchparam.user.user_base_currency ? $ctrl.searchparam.user.user_base_currency : \"-\" }} {{ card_item.meta[$ctrl.resultcardfilter.total_cost] ? (card_item.meta[$ctrl.resultcardfilter.total_cost]) : 0 | currencyMask: 2}}\n</md-tooltip></td><td class=\"fixed-td-width text-center td-action\" data-name=\"action\" \nng-class=\"{\'card-selected\':card_item.meta.is_selected}\"><button-result-card index=\"$index\" \nsearchparam=\"$ctrl.searchparam\" carddata=\"card_item\" mixpanel-sorce=\"\'RR\'\" resultfilter=\"$ctrl.resultcardfilter\" \nparent-page=\"\'result\'\" callback=\"$ctrl.fnCardCallback(card, $index)\"></button-result-card></td></tr></tbody></table>\n<div class=\"instance_tr_componant_container hide\"></div></div><div layout=\"column\" class=\"mt-6\" flex=\"100\" layout-wrap \nlayout-align=\"center center\" ng-show=\"!$ctrl.isShowTable\"><md-progress-circular></md-progress-circular></div>");
$templateCache.put("app/main/component/rate-card-table/remarks-inclusions-dailog.html","<md-dialog class=\"popup-md\"><md-toolbar class=\"white-bg black-fg bb\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"font-size-14 Font-Bold\">{{ctrl.parent.header}}</div><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md-primary-fg s20\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"body\"><div layout=\"row\" class=\"pb-15\" compile-html=\"ctrl.parent.contents\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/component/rate-card-table/table-row.html","<td class=\"td-width-checkbox\" data-column=\"checkbox\"><input type=\"checkbox\" class=\"selecte-row\"></td><td \nclass=\"td-width td-liner\" data-column=\"liner_name\"><div class=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\">\n{{$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div></td>\n<td class=\"td-width td-origin\" ng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\">\n{{$ctrl.card_item.meta.port_data.pickup_location ? $ctrl.card_item.meta.port_data.pickup_location : \'\'}} {{$ctrl.card_item.meta.port_data.pickup_pincode_ui ? $ctrl.card_item.meta.port_data.pickup_pincode_ui : \'\'}} {{!$ctrl.card_item.meta.port_data.pickup_pincode_ui && !$ctrl.card_item.meta.port_data.pickup_location ? \'-\' : \'\'}}\n<md-tooltip ng-if=\"$ctrl.card_item.meta.port_data.pickup_location\" md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.meta.port_data.pickup_location}} {{$ctrl.card_item.meta.port_data.pickup_pincode_ui}}</md-tooltip>\n</td><td class=\"td-width td-place-of-receipt\">\n{{$ctrl.card_item.meta.via_pol ? $ctrl.card_item.meta.port_data.origin_portname +\' / \'+ $ctrl.card_item.meta.port_data.origin_port_code : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.card_item.meta.via_pol\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.meta.port_data.origin_portname +\' / \'+ $ctrl.card_item.meta.port_data.origin_port_code}}</md-tooltip>\n</td><td class=\"td-width td-pol\">\n{{$ctrl.card_item.meta.via_pol ? $ctrl.card_item.meta.via_pol : $ctrl.card_item.meta.port_data.origin_portname + \' / \' + $ctrl.card_item.meta.port_data.origin_port_code}}\n<md-tooltip md-direction=\"top\" ng-if=\" $ctrl.card_item.meta.via_pol || $ctrl.card_item.meta.port_data.origin_portname\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.meta.via_pol ? $ctrl.card_item.meta.via_pol : $ctrl.card_item.meta.port_data.origin_portname +\' / \'+ $ctrl.card_item.meta.port_data.origin_port_code}}\n</md-tooltip></td><td class=\"td-width td-pickupmode\" ng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode ? $ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.transport_mode}}</md-tooltip></td><td \nclass=\"td-width td-pickupmode\" ng-if=\"$ctrl.searchparam.origin_location.place_type === \'Door\'\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type ? $ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l1_leg].rate_obj.service_type}}</md-tooltip></td><td \nclass=\"td-width td-via-port\">\n{{ $ctrl.card_item.meta.selected_schedule ? $ctrl.card_item.meta.selected_schedule.via_port !== \'Direct\' ? $ctrl.card_item.meta.selected_schedule.via_port : \'-\' : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route : \'-\'}}\n<md-tooltip md-direction=\"top\" \nng-if=\"($ctrl.card_item.meta.selected_schedule && $ctrl.card_item.meta.selected_schedule.via_port !== \'Direct\') || $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.meta.selected_schedule ? $ctrl.card_item.meta.selected_schedule.via_port :$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.via_route}}\n</md-tooltip></td><td class=\"td-width th-pod\">\n{{ $ctrl.card_item.meta.via_pod ? $ctrl.card_item.meta.via_pod : $ctrl.card_item.meta.port_data.destination_portname +\' / \'+ $ctrl.card_item.meta.port_data.destination_port_code }}\n<md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.card_item.meta.via_pod || $ctrl.card_item.meta.port_data.destination_portname\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.meta.via_pod ? $ctrl.card_item.meta.via_pod : $ctrl.card_item.meta.port_data.destination_portname +\' / \'+ $ctrl.card_item.meta.port_data.destination_port_code }}\n</md-tooltip></td><td class=\"td-width td-final-destination\">\n{{ $ctrl.card_item.meta.via_pod ? $ctrl.card_item.meta.port_data.destination_portname +\' / \'+ $ctrl.card_item.meta.port_data.destination_port_code : \'-\' }}\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.card_item.meta.via_pod\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.meta.port_data.destination_portname +\' / \'+ $ctrl.card_item.meta.port_data.destination_port_code}}\n</md-tooltip></td><td class=\"td-width td-final-destination hide\" \nng-if=\"$root.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL\">\n{{ $ctrl.searchparam.user.user_base_currency }} {{ $ctrl.card_item.meta.buy_leg_total | currencyMask: 2 }}</td><td \nclass=\"td-width td-destination-door\" ng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">\n{{$ctrl.card_item.meta.port_data.delivery_location ? $ctrl.card_item.meta.port_data.delivery_location : \'\'}} {{$ctrl.card_item.meta.port_data.delivery_pincode_ui ? $ctrl.card_item.meta.port_data.delivery_pincode_ui : \'\'}} {{!$ctrl.card_item.meta.port_data.delivery_pincode_ui && !$ctrl.card_item.meta.port_data.delivery_location ? \'-\' : \'\'}}\n<md-tooltip ng-if=\"$ctrl.card_item.meta.port_data.delivery_location\" md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.meta.port_data.delivery_location}} {{$ctrl.card_item.meta.port_data.delivery_pincode_ui}}\n</md-tooltip></td><td class=\"td-width td-deliverymode\" \nng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode ? $ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.transport_mode}}</md-tooltip></td><td \nclass=\"td-width td-deliverymode\" ng-if=\"$ctrl.searchparam.destination_location.place_type === \'Door\'\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type ? $ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type : \'-\'}}\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.card_item.data.buy_rates[$ctrl.l5_leg].rate_obj.service_type}}</md-tooltip></td><td \nclass=\"td-width text-right td-freight-cost\" style=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-freight-cost\" style=\"width: 90px !important\" \nng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type] ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-freight-cost\" style=\"width: 90px !important\" \nng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type] ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-freight-cost\" style=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type] ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type] ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l1_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l1_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type] ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type] ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l2_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type] ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type] ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type] \" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l4_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.leg_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type] ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.per_unit_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\" ng-repeat=\"load in $ctrl.searchparam.load_data.load_details_value\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type] ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type]  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type]\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.main_charge_total[load.type] | currencyMask: 2) }}\n</md-tooltip></td><td ng-if=\"$ctrl.legList[$ctrl.l5_leg]\" class=\"td-width text-right td-freight-cost\" \nstyle=\"width: 90px !important\"><span \nng-bind=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost ?  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost  | currencyMask: 2) : \'-\'\">\n</span><md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l5_leg].charge_summary.other_charge_total.cost | currencyMask: 2) }}\n</md-tooltip></td><td class=\"td-width text-right td-origin-custom\" \ndata-order=\"{{  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost : \'-\'}}\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost|currencyMask:2) : \"-\"}}\n<md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l2_leg_cha].rate_obj.leg_currency_cost|currencyMask:2) }}\n</md-tooltip></td><td class=\"td-width text-right td-destination-custom\" \ndata-order=\'{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost : \"-\" }}\'>\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost|currencyMask:2) : \"-\"}}\n<md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency +\' \'+ ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l4_leg_cha].rate_obj.leg_currency_cost|currencyMask:2) }}\n</md-tooltip></td><td class=\"td-width text-center td-sailing-date\" \ndata-order=\"{{ $ctrl.card_item.meta.selected_schedule === null && !$ctrl.card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date ? \'-\' : ($ctrl.card_item.meta.selected_schedule.departure_time ? $ctrl.card_item.meta.selected_schedule.departure_time : $ctrl.card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date)}}\">\n{{ $ctrl.card_item.meta.selected_schedule === null && !$ctrl.card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date ? \'-\' : ($ctrl.card_item.meta.selected_schedule.departure_time ? $ctrl.card_item.meta.selected_schedule.departure_time : $ctrl.card_item.data.buy_rates[$ctrl.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\')}}\n</td><td class=\"td-width text-center td-transit-time\" \ndata-order=\"{{ $ctrl.card_item.meta.selected_schedule ? (!$ctrl.card_item.meta.selected_schedule.transit_time ? \'-\' : $ctrl.card_item.meta.selected_schedule.transit_time) : (!$ctrl.card_item.data[$ctrl.resultCardFilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'-\' : $ctrl.card_item.data[$ctrl.resultCardFilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\">\n{{ $ctrl.card_item.meta.selected_schedule ?(!$ctrl.card_item.meta.selected_schedule.transit_time ? \'-\' : $ctrl.card_item.meta.selected_schedule.transit_time) : (!$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'-\' : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n</td><td class=\"td-width text-center td-start-date\" \ndata-order=\"{{$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.start_date}}\">\n{{$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.start_date ? ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.start_date| NoTimeZone : \'d MMM yyyy\'):\"-\" }}\n</td><td class=\"td-width text-center td-expiry-date\" \ndata-order=\"{{$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.expiry}}\">\n{{$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.expiry ? ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.expiry| NoTimeZone : \'d MMM yyyy\'):\"-\" }}\n</td><td class=\"td-width td-cargo-type\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data.name ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data.name : \"-\" }}\n</td><td class=\"td-width td-commodity\" data-column=\"commodity\" \ndata-search=\"{{ !$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity ? \'-\' : ($ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity | enterpriceTextTransform : \' ;,.()\') }}\">\n{{ !$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity ? \'-\' : ( $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity | enterpriceTextTransform : \';\') }}\n<md-tooltip ng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table; opacity: 1;text-transform: capitalize\">\n{{ !$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity ? \'-\' : ( $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.commodity | enterpriceTextTransform : \';\') }}\n</md-tooltip></td><td class=\"td-width td-service-type\">\n{{ !$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }} {{ !$ctrl.card_item.meta.selected_schedule.service_name ? \'\' : \' | \' + $ctrl.card_item.meta.selected_schedule.service_name }}\n<md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type || $ctrl.card_item.meta.selected_schedule.service_name\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ !$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }} {{ !$ctrl.card_item.meta.selected_schedule.service_name ? \'\' : \' | \' + $ctrl.card_item.meta.selected_schedule.service_name }}\n</md-tooltip></td><td data-column=\"free_days\" class=\"td-width text-center td-free-days\"><free-days \nfreedaysdata=\"{\n      demurrage_details : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.demurrage_details,\n      detention_details : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.detention_details,\n      combined_details : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.combined_details,\n      freeDays : $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.freeDays,\n      pageSource : \'EL\'\n\n    }\" \ntype=\"\'list-nwls\'\" cardid=\"$ctrl.card_item._id\" mode=\"$ctrl.searchparam.mode\" \nsearch-load-data=\"$ctrl.searchparam.load_data.load_details_value\"></free-days></td><td class=\"td-width td-rate-by\">\n{{ $ctrl.card_item.meta.type !== \'msr_spot\' && $ctrl.card_item.meta.type !== \'network_spot\' ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\') ? \'Agent -\' + $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : \'Forwarder -\'+ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name: \'-\' }}\n<md-tooltip \nng-if=\"$ctrl.card_item.meta.type !== \'msr_spot\' && $ctrl.card_item.meta.type !== \'network_spot\' && $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.meta.type !== \'msr_spot\' && $ctrl.card_item.meta.type !== \'network_spot\' ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\') ? \'Agent -\' + $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : \'Forwarder -\'+$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name : \'-\' }}\n</md-tooltip></td><td class=\"td-width td-rate-id\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id+\' / \' : \'\' }} {{ (!$ctrl.card_item.meta.type.includes(\'network\') || $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.show_contract_number) && $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number : \'-\' }}\n<md-tooltip \nng-if=\"$ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id || ((!$ctrl.card_item.meta.type.includes(\'network\')  ||  $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.show_contract_number) && $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number)\" \nmd-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.price_id+\' / \' : \'\' }} {{ (!$ctrl.card_item.meta.type.includes(\'network\') || $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.show_contract_number) && $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number ? $ctrl.card_item.data[$ctrl.resultcardfilter.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number : \'-\' }}\n</md-tooltip></td><td class=\"fixed-td-width text-right td-total-cost\" \nng-class=\"{\'card-selected\':$ctrl.card_item.meta.is_selected}\" \ndata-order=\"{{$ctrl.card_item.meta[$ctrl.resultcardfilter.total_cost]|currencyMask:0}}\"><span \nclass=\"totalCost{{$ctrl.index}}\">\n{{ $ctrl.searchparam.user.user_base_currency ? $ctrl.searchparam.user.user_base_currency : \"-\" }} {{ $ctrl.card_item.meta[$ctrl.resultcardfilter.total_cost] ? ($ctrl.card_item.meta[$ctrl.resultcardfilter.total_cost] | currencyMask: 2) : 0 }}\n</span> <span class=\"shimmerUpdateTd{{$ctrl.index}} hide\" shimmer-effect-full width=\"90px\" height=\"22px\" \nclass=\"inline-block mr-10 mt-8\"></span><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.searchparam.user.user_base_currency ? $ctrl.searchparam.user.user_base_currency : \"-\" }} {{ $ctrl.card_item.meta[$ctrl.resultcardfilter.total_cost] ? ($ctrl.card_item.meta[$ctrl.resultcardfilter.total_cost] | currencyMask: 2) : 0 }}\n</md-tooltip></td><td class=\"fixed-td-width text-center td-action\" data-column=\"action\" \nng-class=\"{\'card-selected\':$ctrl.card_item.meta.is_selected}\"><button-result-card index=\"$ctrl.index\" \nsearchparam=\"$ctrl.searchparam\" carddata=\"$ctrl.card_item\" resultfilter=\"$ctrl.resultcardfilter\" \nparent-page=\"\'result\'\" mixpanel-sorce=\"\'RR\'\" callback=\"$ctrl.fnCardCallback(card, $ctrl.index)\"></button-result-card>\n</td>");
$templateCache.put("app/main/component/rate-display/rate-display.html","<div flex=\"100\" id=\"rates-display\"><md-expansion-panel><md-expansion-panel-collapsed \nng-click=\"$ctrl.isPanelOpened = !$ctrl.isPanelOpened\"><div shimmer-effect class=\"shimmerLoad\" ng-if=\"$ctrl.dataLoaded\">\n</div><div flex=\"100\" class=\"pd-0\" ng-include=\"\'app/main/component/rate-display/rate-meta.html\'\" \nonload=\"$ctrl.finishLoading()\"></div></md-expansion-panel-collapsed><md-expansion-panel-expanded>\n<md-expansion-panel-header ng-click=\"$ctrl.panelExpansion(); $panel.collapse();\"><div flex=\"100\" \nng-include=\"\'app/main/component/rate-display/rate-meta.html\'\"></div></md-expansion-panel-header>\n<md-expansion-panel-content class=\"font-size-14 opacity\"><charges-display flex=\"100\" \ncharges-data=\"$ctrl.currentCard.leg\" mode=\"$ctrl.mode\"></charges-display></md-expansion-panel-content>\n</md-expansion-panel-expanded></md-expansion-panel></div>");
$templateCache.put("app/main/component/rate-display/rate-meta.html","<div id=\"rate-card-meta\"><div class=\"rate-meta\" layout=\"row\" layout-align=\"space-between\" layout-wrap=\"wrap\"><div \nclass=\"meta-data\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"wrap\"><div ng-if=\"$ctrl.rateType==\'new\'\">\n<md-checkbox md-no-ink=\"true\" class=\"radio-checkbox checkbox\" ng-checked=\" $ctrl.currentCard.meta.is_selected\" \nng-click=\"$ctrl.filterItemtoggle($event,$ctrl.currentCard)\"></md-checkbox></div><div class=\"meta-data\"><div \nng-if=\"$ctrl.currentCard.leg[$ctrl.l3_leg].sub_vendor.sub_vendor_name && $ctrl.mode!==\'AIR\'\"><div class=\"heading\">\nLiner/Carrier</div><div class=\"meta-content text-truncate\" \nng-bind=\"$ctrl.currentCard.leg[$ctrl.l3_leg].sub_vendor.sub_vendor_name\"></div><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display: table; opacity: 1\">\n{{$ctrl.currentCard.leg[$ctrl.l3_leg].sub_vendor.sub_vendor_name}}</md-tooltip></div><div ng-if=\"$ctrl.mode==\'AIR\'\" \nclass=\"air-liner\"><div class=\"heading\">Air Liner</div><div class=\"meta-content text-truncate\"><span>\n{{ $ctrl.currentCard.leg.l3_air.airline.air_line_name }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display: table; opacity: 1\">\n{{ $ctrl.currentCard.leg.l3_air.airline.air_line_name}}</md-tooltip></span></div></div><div class=\"service-type\"><div \nclass=\"heading\">Service Type</div><div class=\"meta-content text-truncate\"><span>\n{{ !$ctrl.currentCard.leg[$ctrl.l3_leg].service_type ? \'\' : $ctrl.currentCard.leg[$ctrl.l3_leg].service_type}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display: table; opacity: 1\">\n{{ !$ctrl.currentCard.leg[$ctrl.l3_leg].service_type ? \'\' : $ctrl.currentCard.leg[$ctrl.l3_leg].service_type }}\n</md-tooltip></span><span \nng-if=\"($ctrl.currentCard.meta.selected_schedule && $ctrl.currentCard.meta.selected_schedule.service_name) && $ctrl.currentCard.leg[$ctrl.l3_leg].service_type\">\n| </span><span ng-if=\"$ctrl.mode!=\'AIR\' && $ctrl.currentCard.meta.selected_schedule\">\n{{ !$ctrl.currentCard.meta.selected_schedule.service_name ? \'\' : $ctrl.currentCard.meta.selected_schedule.service_name }}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display: table; opacity: 1\">\n{{ !$ctrl.currentCard.meta.selected_schedule.service_name ? \'\' : $ctrl.currentCard.meta.selected_schedule.service_name }}\n</md-tooltip></span><span \nng-if=\"!(($ctrl.currentCard.meta.selected_schedule && $ctrl.currentCard.leg[$ctrl.l3_leg].service_type) ||$ctrl.currentCard.leg[$ctrl.l3_leg].service_type)\">\nN/A</span></div></div><div ng-if=\"$ctrl.mode==\'AIR\'\" class=\"etd\"><div class=\"heading\">ETD</div><div \nclass=\"meta-content text-truncate\"><div class=\"font-size-12 fg-333333 Font-Bold meta-content text-truncate\"><md-tooltip\n md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display: table; opacity: 1\">\n{{$ctrl.currentCard.meta.selected_schedule ? ($ctrl.currentCard.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}}\n</md-tooltip><span ng-if=\"$ctrl.currentCard.meta.selected_schedule\">\n{{$ctrl.currentCard.meta.selected_schedule ? ($ctrl.currentCard.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}} \n</span><span ng-if=\"!$ctrl.currentCard.meta.selected_schedule\">\n{{$ctrl.currentCard.leg[$ctrl.l3_leg].rate_obj.departure_time ? ($ctrl.currentCard.leg[$ctrl.l3_leg].rate_obj.departure_time | UTCToLocal : \'d MMM yyyy\') : \'-\'}}\n</span></div></div></div><div ng-if=\"$ctrl.mode==\'AIR\'\" class=\"eta\"><div class=\"heading\">ETA</div><div \nclass=\"font-size-12 fg-333333 Font-Bold meta-content text-truncate\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display: table; opacity: 1\">\n{{$ctrl.currentCard.meta.selected_schedule ? ($ctrl.currentCard.meta.selected_schedule.arrival_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}}\n</md-tooltip><span ng-if=\"$ctrl.currentCard.meta.selected_schedule\">\n{{$ctrl.currentCard.meta.selected_schedule ? ($ctrl.currentCard.meta.selected_schedule.arrival_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}} \n</span><span ng-if=\"!$ctrl.currentCard.meta.selected_schedule\">\n{{$ctrl.currentCard.leg[$ctrl.l3_leg].rate_obj.arrival_time ? ($ctrl.currentCard.leg[$ctrl.l3_leg].rate_obj.arrival_time | UTCToLocal : \'d MMM yyyy\') : \'-\'}}\n</span></div></div><div ng-if=\"$ctrl.mode==\'AIR\'\" class=\"rates-by-forwarder\"><div class=\"heading\">Rates By Forwareder\n</div><div class=\"meta-content text-truncate\"><span>{{ $ctrl.currentCard.leg.l3_air.vendor.vendor_name }}<md-tooltip \nmd-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display: table; opacity: 1\">\n{{$ctrl.currentCard.leg.l3_air.vendor.vendor_name}}</md-tooltip></span></div></div><div ng-if=\"$ctrl.mode==\'AIR\'\" \nclass=\"effective-period\"><div class=\"heading\">Effective Period</div><div class=\"meta-content text-truncate\" \nlayout=\"row\"><div ng-if=\"$ctrl.currentCard.leg[$ctrl.l3_leg].start_date && $ctrl.currentCard.leg[$ctrl.l3_leg].expiry\">\n<span>\n{{ ($ctrl.currentCard.leg[$ctrl.l3_leg].start_date | NoTimeZone: \"dd MMM yyyy\") + \" - \" + ($ctrl.currentCard.leg[$ctrl.l3_leg].expiry | NoTimeZone: \"dd MMM yyyy\") }}\n</span><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ ($ctrl.currentCard.leg[$ctrl.l3_leg].start_date | NoTimeZone: \"dd MMM yyyy\") + \" - \" + ($ctrl.currentCard.leg[$ctrl.l3_leg].expiry | NoTimeZone: \"dd MMM yyyy\") }}\n</md-tooltip></div><div \nng-if=\"!$ctrl.currentCard.leg[$ctrl.l3_leg].start_date && $ctrl.currentCard.leg[$ctrl.l3_leg].expiry\"><span>\n{{ \"Till \" + ($ctrl.currentCard.leg[$ctrl.l3_leg].expiry | NoTimeZone: \"dd MMM yyyy\")}}</span><md-tooltip \nmd-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ \"Till \" + ($ctrl.currentCard.leg[$ctrl.l3_leg].expiry | NoTimeZone: \"dd MMM yyyy\")}}</md-tooltip></div><div \nng-if=\"$ctrl.currentCard.leg[$ctrl.l3_leg].start_date && !$ctrl.currentCard.leg[$ctrl.l3_leg].expiry\"><span>\n{{ \"From \" + ($ctrl.currentCard.leg[$ctrl.l3_leg].start_date | NoTimeZone: \"dd MMM yyyy\")}}</span><md-tooltip \nmd-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ \"From \" + ($ctrl.currentCard.leg[$ctrl.l3_leg].start_date | NoTimeZone: \"dd MMM yyyy\")}}</md-tooltip></div></div>\n</div><div \nng-if=\"$ctrl.currentCard.leg[$ctrl.l3_leg].contract_number && !$ctrl.currentCard.meta.type.includes(\'network\') && $ctrl.mode!==\'AIR\'\">\n<div class=\"heading\">Contract ID<md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control\" style=\"display:table;opacity: 1\">\nContract / Rate Agreement / Tariff / Spot Pricing Reference Number</md-tooltip></div><div \nclass=\"meta-content text-truncate\" ng-bind=\"$ctrl.currentCard.leg[$ctrl.l3_leg].contract_number\"></div><md-tooltip \nmd-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center widthControl\" style=\"opacity: 1\">\n{{ $ctrl.currentCard.leg[$ctrl.l3_leg].contract_number}}</md-tooltip></div><div class=\"w-200\" \nng-if=\"$ctrl.currentCard.leg[$ctrl.l3_leg].price_id && $ctrl.mode!==\'AIR\'\"><div class=\"heading\">Rate ID</div><div \nclass=\"meta-content text-truncate\" ng-bind=\"$ctrl.currentCard.leg[$ctrl.l3_leg].price_id\"></div><md-tooltip \nmd-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control pointer-events-none\" \nstyle=\"opacity: 1\"><div class=\"tooltip-width-control\">{{$ctrl.currentCard.leg[$ctrl.l3_leg].price_id}}</div>\n</md-tooltip></div><div class=\"max-width-100 spacing-content\" ng-if=\"$ctrl.rateType !=\'new\' && $ctrl.mode!==\'AIR\'\"><div\n class=\"heading\">Sailing Date</div><div class=\"meta-content text-truncate\" \nng-bind=\"($ctrl.currentCard.meta.selected_schedule === null && !$ctrl.currentCard.leg[$ctrl.l3_leg].sailing_date) ? \'-\' : ($ctrl.currentCard.meta.selected_schedule.departure_time ? $ctrl.currentCard.meta.selected_schedule.departure_time : $ctrl.currentCard.leg[$ctrl.l3_leg].sailing_date | UTCToLocal : \'d MMM yyyy\')\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{$ctrl.currentCard.meta.selected_schedule === null && !$ctrl.currentCard.leg[$ctrl.l3_leg].sailing_date ? \'-\' : ($ctrl.currentCard.meta.selected_schedule.departure_time ? $ctrl.currentCard.meta.selected_schedule.departure_time : $ctrl.currentCard.leg[$ctrl.l3_leg].sailing_date | UTCToLocal : \'d MMM yyyy\') }}\n</md-tooltip></div></div><div class=\"max-width-100 spacing-content\" \nng-if=\"$ctrl.rateType ==\'new\' && $ctrl.mode!==\'AIR\'\"><div class=\"heading\">Sailing Date</div><md-select \nng-model=\"$ctrl.selectedSailing\" ng-click=\"$event.stopPropagation()\" ng-change=\"$ctrl.scheduleSelection()\" \nname=\"sailing_date\" placeholder=\"Select Sailing date\" class=\"Font-Bold h-20 m-0 p-0\"><md-option class=\"mb-10\" \nng-repeat=\"sailingDate in $ctrl.currentCard.leg[$ctrl.l3_leg].schedule.data track by $index\" ng-value=\"sailingDate\">\n{{sailingDate.departure_time | UTCToLocal : \'d MMM yyyy\'}}</md-option></md-select></div><div class=\"transit-time\" \nng-if=\"$ctrl.mode!==\'AIR\'\"><div class=\"heading\">Transit Time</div><div class=\"meta-content text-truncate\" \nng-bind=\"$ctrl.currentCard.meta.selected_schedule ?(!$ctrl.currentCard.meta.selected_schedule.transit_time ? \'-\' : $ctrl.currentCard.meta.selected_schedule.transit_time) : (!$ctrl.currentCard.leg[$ctrl.l3_leg].transit_time ? \'-\' : $ctrl.currentCard.leg[$ctrl.l3_leg].transit_time )\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display: table; opacity: 1\">\n{{ $ctrl.currentCard.meta.selected_schedule ?(!$ctrl.currentCard.meta.selected_schedule.transit_time ? \'-\' : $ctrl.currentCard.meta.selected_schedule.transit_time) : (!$ctrl.currentCard.leg[$ctrl.l3_leg].transit_time ? \'-\' : $ctrl.currentCard.leg[$ctrl.l3_leg].transit_time ) }}\n</md-tooltip></div></div><div class=\"max-width-100 spacing-content\" ng-if=\"$ctrl.mode!==\'AIR\'\"><div class=\"heading\">\nFree Days</div><div class=\"meta-content text-truncate\"><free-days \nfreedaysdata=\"{\n                demurrage_details : $ctrl.currentCard.leg[$ctrl.l3_leg].demurrage_details,\n                detention_details : $ctrl.currentCard.leg[$ctrl.l3_leg].detention_details,\n                combined_details : $ctrl.currentCard.leg[$ctrl.l3_leg].combined_details,\n                freeDays : $ctrl.currentCard.leg[$ctrl.l3_leg].freeDays,\n                pageSource : \'SD-Carrier-Booking\'\n              }\" \ntype=\"\'list-nwls\'\" cardid=\"\'meta-\'+$ctrl.currentCard.meta._id\" mode=\"$ctrl.mode\" \nsearch-load-data=\"$ctrl.loadData.load_details_value\"></free-days></div></div><div \nng-if=\"$ctrl.card.leg[$ctrl.l3_leg].expiry\"><div class=\"heading\">Expiry Date</div><div \nclass=\"meta-content expires_days text-truncate\" \nng-bind=\"$ctrl.card.leg[$ctrl.l3_leg].expiry| NoTimeZone : \'d MMM yyyy\'\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display: table; opacity: 1\">\n{{ $ctrl.card.leg[$ctrl.l3_leg].expiry | NoTimeZone : \'d MMM yyyy\' }}</md-tooltip></div></div></div></div><div \nclass=\"meta-data-right\" layout-align=\"center\"><div class=\"schedule\"><port-to-port class=\"full-width pt-10\" \ncard=\"$ctrl.currentCard\" buyorsell=\"$ctrl.buyOrSell\" mode=\"$ctrl.mode\"></port-to-port></div><div><div \nclass=\"currency-total text-truncate pt-10\">\n{{$ctrl.currentCard.meta.card_total.currency }} {{$ctrl.currentCard.meta.card_total.cost| currencyMask:2 }}<md-tooltip \nmd-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display: table; opacity: 1\">\n{{$ctrl.currentCard.meta.card_total.currency }} {{$ctrl.currentCard.meta.card_total.cost | currencyMask:2 }}\n</md-tooltip></div></div><div class=\"accordian-icon cursor\" layout-align=\"center\"><md-icon \nmd-font-icon=\"{{$ctrl.isPanelOpened ? \'icon-chevron-up\' : \'icon-chevron-down\'}}\" layout=\"row\" layout-align=\"center\">\n</md-icon></div></div></div></div>");
$templateCache.put("app/main/component/rate-modification/air-lcl-rate-modification.html","<div ng-if=\"$ctrl.util.isShipper || $ctrl.isShared\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\" \nclass=\"mt-20 fixed-total-leg p-5 font-size-23\" layout-wrap><div layout-align=\"start center\" \nclass=\"p-5 Font-Bold font-size-16\">Total</div><div layout=\"row\" layout-align=\"end center\" layout-wrap><div \nclass=\"total_div layout-row\" layout=\"row\"><div class=\"p-5 Font-Bold\">{{$ctrl.searchUser.user_base_currency}}</div><div \nclass=\"p-5 Font-Bold\">{{$ctrl.footerObj.sellTotalBaseCurr | currencyMask: 2}}</div></div></div></div><div \nng-class=\"{\'mt-20\':!($ctrl.util.isShipper || $ctrl.isShared),\'border-shipper\':$ctrl.util.isShipper || $ctrl.isShared}\" \nclass=\"pt-0 quotes-table position-relative\" \nng-repeat=\"(sell_key, sell_value) in $ctrl.currentCard.data.sell_rates track by $index\" \nng-if=\"sell_value.rate_obj  && sell_value.rate_obj.charges.length && $ctrl.checkDefaultKey\"><div layout=\"row\" \nflex=\"100\" layout-align=\"space-between center\" class=\"p-5 quotation-leg\" layout-wrap \nng-class=\"{\'leg-border-bottom\' :$ctrl.util.isShipper || $ctrl.isShared}\"><div layout-align=\"start center\" class=\"ph-5\">\n<div flex=\"100\" \nng-if=\"($ctrl.searchParam.mode === \'AIR\' && sell_value.rate_obj.leg_code == $ctrl.l3_leg) || !$ctrl.quoteEdit || sell_value.rate_obj.leg_code.includes(\'sop\')\" \nclass=\"font-size-16 font-weight-600 fg-333333\" \nng-bind=\"( sell_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : sell_value.leg_name\"></div><md-input-container \nmd-no-float class=\"panel-select leg-name\" \nng-if=\"($ctrl.searchParam.mode === \'SEA-LCL\' || ($ctrl.searchParam.mode === \'AIR\' && sell_value.rate_obj.leg_code !== $ctrl.l3_leg)) && $ctrl.quoteEdit && !sell_value.rate_obj.leg_code.includes(\'sop\')\" \nid=\"{{sell_key + \'_leg\'}}\" ng-keyup=\"$ctrl.fnLegNameChange(sell_key,$event)\"><md-autocomplete md-input-name=\"legName\" \nmd-selected-item=\"selectedLeg\" md-search-text=\"sell_value.leg_name\" md-search-text-change=\"$ctrl.fnCheckOverlay();\" \nmd-selected-item-change=\"$ctrl.fnLegSelected(selectedLeg,sell_value,sell_key)\" md-input-id=\"{{sell_key}}\" \nmd-items=\"item in $ctrl.fnGetLegList(sell_value.leg_name)\" md-item-text=\"item.leg_name\" md-min-length=\"3\" \nmd-select-on-match=\"false\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"300\" placeholder=\"Leg Name\" \nng-required=\"true\" class=\"leg-name-class\" restrict-to=\"{{$ctrl.util.nonSpecialCharacterRegex}}\"><md-item-template><span\n md-highlight-text=\"sell_value.leg_name\" md-highlight-flags=\"^i\">{{item.leg_name}}</span><md-not-found>\nNo Charges matching \"<span> {{sell_value.leg_name}} </span>\" were found.</md-not-found></md-item-template>\n</md-autocomplete></md-input-container><span class=\"legError\" id=\"{{sell_key + \'_text\'}}\">Please enter leg name</span> \n<span class=\"legError\" id=\"{{sell_key + \'_duplicateText\'}}\">Leg Name Already Exists</span></div><div layout=\"row\" \nlayout-align=\"end center\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nng-if=\"(!$ctrl.currentCard.meta.type.includes(\'network\') || sell_value.rate_obj.show_upload_rate_sheet ) &&$ctrl.sourceRate && $ctrl.sourceRate!={} && sell_value.rate_obj && sell_value.rate_obj.batchcode \">\n<button ng-repeat=\"batchcode in sell_value.rate_obj.batchcode track by $index\"><div \nng-if=\"$ctrl.sourceRate[batchcode].sourceFileUrl\"><div ng-click=\"$ctrl.sourceDownload(batchcode)\"><div \nclass=\"m-10 h-16 blue-600-fg Font-Bold pointer\" layout=\"row\" layout-align=\"center center\"><div class=\"mr-5\"><md-icon \nclass=\"cursor blue-600-fg s16\" md-font-icon=\"icon-download\"></md-icon></div><div>Download Source {{$index+1}}</div>\n<md-tooltip md-direction=\"top\" ng-if=\"!$ctrl.util.isMobileDevice\">Download original source rate sheet</md-tooltip>\n</div></div></div></button></div><div ng-if=\"$ctrl.quoteEdit\" layout=\"row\" layout-align=\"start center\"><button \nlayout=\"row\" layout-align=\"center center\" class=\"m-10 h-16 red-600-fg\" \nng-disabled=\"!$ctrl.quoteEdit || (!sell_value.rate_obj.charges[0].manual && !$ctrl.inquiryPricing)\" \nng-if=\"$ctrl.quoteEdit && (sell_value.rate_obj.charges[0].manual || $ctrl.inquiryPricing)\" \nng-click=\"$ctrl.fnDeleteLegConfirmation(sell_key,sell_value)\"><div class=\"mr-5\"><md-icon class=\"cursor red-600-fg s20\" \nmd-font-icon=\"icon-delete\"></md-icon></div><div>Delete Leg</div></button></div><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"m-10 fg-333333\">Sub Total</div><div class=\"total_div\" \nlayout=\"row\"><div class=\"p-5\" ng-if=\"!$ctrl.quoteEdit\" ng-bind=\"sell_value.rate_obj.leg_currency\"></div><select \nng-if=\"$ctrl.quoteEdit\" ng-model=\"sell_value.rate_obj.leg_currency\" placeholder=\"Currency\" \nclass=\"m-0 leg_curr_select border-left select_currency select_box\" \nng-change=\"$ctrl.fnLegCurrencyChange(sell_key,sell_value.rate_obj.leg_currency);$ctrl.fnTrackAnalytics(\'RateCard-LegCurrency-Change\')\" \nng-model-options=\"{\n                    updateOn: \'default blur onchange\',\n                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                  }\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><div class=\"total-disabled\" \nng-bind=\"sell_value.rate_obj.leg_currency_cost | currencyMask: 2\"></div></div></div></div></div><div \nclass=\"simple-table-container\" id=\"charges-table\"><md-content><table class=\"simple\" ms-responsive-table><thead \nng-class=\"{\'shipper-header\':!$ctrl.isShowBuyCol}\"><tr><th class=\"w-220\" rowspan=\"2\"><div \nclass=\"table-header text-left column-title font-weight-600\">Charges</div></th><th class=\"w-80\" rowspan=\"2\" \nng-if=\"sell_value.leg_code==\'additional_services\'\"><div class=\"table-header column-title font-weight-600\">Type</div>\n</th><th class=\"w-100\" rowspan=\"2\"><div class=\"table-header column-title font-weight-600\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\">Basis</div></th><th class=\"w-90\" \nng-class=\"{\'w-120\':!$ctrl.isShowBuyCol}\" rowspan=\"2\"><div \nclass=\"table-header text-center column-title font-weight-600\">Quantity<br ng-if=\"$ctrl.isShowBuyCol\">\n&nbsp;&nbsp;&nbsp;&nbsp;|<span ng-if=\"!$ctrl.isShowBuyCol\" class=\"pl-5\">&nbsp;</span> Slab</div></th><th colspan=\"4\" \nng-if=\"$ctrl.isShowBuyCol\" class=\"rates-bg\"><div class=\"table-header text-center column-title font-weight-600\">\nBuy Rates</div></th><th colspan=\"4\" ng-if=\"$ctrl.isShowBuyCol\"><div \nclass=\"table-header text-center column-title font-weight-600\">Sell Rates</div></th><th class=\"w-130\" \nng-if=\"!$ctrl.isShowBuyCol\"><div class=\"table-header text-center column-title font-weight-600\">Unit Price</div></th><th\n class=\"w-90\" ng-if=\"!$ctrl.isShowBuyCol\"><div class=\"table-header text-center column-title font-weight-600\">Min</div>\n</th><th class=\"w-90\" ng-if=\"!$ctrl.isShowBuyCol\"><div class=\"table-header text-center column-title font-weight-600\">\nMax</div></th><th class=\"w-120\" ng-if=\"!$ctrl.isShowBuyCol\"><div \nclass=\"table-header text-center column-title font-weight-600\">Amount</div></th><th rowspan=\"2\" class=\"w-80\">Comments\n</th><th rowspan=\"2\" class=\"w-10\" ng-if=\"$ctrl.quoteEdit\">Action</th></tr><tr ng-if=\"$ctrl.isShowBuyCol\"><th \nclass=\"rates-bg w-130 text-center\">Unit Price</th><th class=\"rates-bg w-90 text-center\">Min</th><th \nclass=\"rates-bg w-90 text-center\">Max</th><th class=\"rates-bg w-120 text-center\">Amount</th><th \nclass=\"w-130 text-center\">Unit Price</th><th class=\"w-90 text-center\">Min</th><th class=\"w-90 text-center\">Max</th><th \nclass=\"w-120 text-center\">Amount</th></tr></thead><tbody class=\"b-bottom\"><tr id=\"{{sell_key +\'_\'+ $index+\'_row\'}}\" \nng-class=\"{\'user-charge-class\':!sell_value.rate_obj.charges.charge_id}\" \nng-repeat-start=\"(key, charge) in sell_value.rate_obj.charges track by $index\" class=\"bg_row\"><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nclass=\"chargeName pos-relative w-220\"><div class=\"content-border text-left\" id=\"{{sell_key +\'_\'+ $index+\'_charge\'}}\">\n<div ng-if=\"!$ctrl.quoteEdit || (!charge.manual && !$ctrl.inquiryPricing)\" layout=\"row\" layout-align=\"start\" \nflex=\"100\" class=\"p-8 remove-cursor\"><div layout=\"row\"><span ng-bind=\"charge.charge_name\" class=\"ellipsis-120\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11\">{{charge.charge_name}}</md-tooltip></span><div \nng-bind=\"charge.container_type\"></div></div><div layout=\"row\" flex layout-align=\"end center\"><span \nclass=\"dim-charge-sect\" ng-if=\"charge.charge_basis.includes(\'dim\')\">DIM Charge<md-tooltip ng-if=\"$ctrl.dimLegList\" \nmd-direction=\"top\" class=\"tooltip-height\"><div ng-repeat=\"legList in $ctrl.dimLegList\">\n{{legList.leg_name}} - {{legList.cbm}} KG / CBM</div></md-tooltip></span><div class=\"dim-charge-sect dim-charge-width\" \nng-if=\"charge.charge_category && charge.charge_category !== null\" ng-bind=\"charge.charge_category\"></div></div></div>\n<md-input-container md-no-float class=\"inline-flex\" ng-if=\"$ctrl.quoteEdit && (charge.manual || $ctrl.inquiryPricing)\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'charge\');$ctrl.fnChargeTextChange(charge, key, sell_key, $event);\" \ntitle=\"{{charge.charge_name}}\"><md-autocomplete ng-disabled=\"!sell_value.leg_name\" class=\"pl-8\" \nmd-input-name=\"chargeName\" md-selected-item=\"selectedCharge\" md-search-text=\"charge.charge_name\" \nmd-selected-item-change=\"$ctrl.fnChargeSelection(selectedCharge,charge,sell_value.rate_obj,$index, sell_key)\" \nmd-items=\"item in $ctrl.getChargeList(charge.charge_name, sell_value, charge)\" md-item-text=\"item.charge_name\" \nmd-min-length=\"3\" md-input-id=\"{{sell_key +\'_\'+ $index}}\" md-select-on-match=\"false\" md-clear-button=\"false\" \nmd-no-cache=\"false\" md-delay=\"300\" placeholder=\"Charge Name\" restrict-to=\"{{$ctrl.util.nonSpecialCharacterRegex}}\" \nng-required=\"true\"><md-item-template><span md-highlight-text=\"charge.charge_name\" md-highlight-flags=\"^i\" \ntitle=\"{{item.name_alias}}\">{{item.name_alias}}</span></md-item-template></md-autocomplete><div \nng-class=\"{\'sticky-charge-sect-tag\': $ctrl.quoteEdit && (charge.manual || $ctrl.inquiryPricing) }\" \nclass=\"dim-charge-sect\" ng-if=\"charge.charge_category && charge.charge_category !== null\" \nng-bind=\"charge.charge_category\"></div></md-input-container></div><div layout=\"row\" \nclass=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_name && charge.charge_name.length<=2 && !charge.charge_id\">Enter the first three letter to search\n</div><div layout=\"row\" class=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_name.length> 2 && !charge.charge_id \">Adding a user defined charge</div><div layout=\"row\" \nclass=\"fg-333333 font-size-13 user-charge-class\" ng-if=\"charge.charge_id && charge.charge_id.includes(\'UD\')\">\nUser defined charge</div><span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_chargeError\'}}\">Please Enter\n</span> <span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index +\'_duplicateCharge\'}}\">Already Exists</span></td>\n<td class=\"chargeName\" ng-if=\"sell_value.leg_code==\'additional_services\'\"><span \nng-repeat=\"leg in charge.leg track by $index\"><span ng-bind=\"leg.name\"></span> <span ng-if=\"!$last\">,</span></span>\n</td><td rowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol,\'basis-error-border\':$ctrl.basisArray.includes(charge.charge_basis) && (charge.total_units === null) || (!$ctrl.l3LegKey && charge.charge_basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS)}\" \nid=\"{{sell_key +\'_\'+ $index+\'_chargeBasis\'}}\"><div class=\"pt-7 pl-5 pr-2 remove-cursor\" \nng-if=\"!$ctrl.quoteEdit ||  (!charge.manual && !$ctrl.inquiryPricing)\"><span ng-bind=\"charge.charge_basis\" \nclass=\"ellipsis-120 basis-ellipsis-100\"><md-tooltip md-direction=\"top\" class=\"font-size-11\">{{charge.charge_basis}}\n</md-tooltip></span></div><md-input-container md-no-float class=\"inline-flex\" \nng-if=\"$ctrl.quoteEdit && (charge.manual || $ctrl.inquiryPricing)\"><select \nclass=\"custom_select full-width mr-10 h-32 pl-8\" ng-model=\"charge.charge_basis\" placeholder=\"Basis\" \ntitle=\"{{charge.charge_basis}}\" class=\"m-0 select_currency rate_select_box\" \nng-change=\"$ctrl.fnGetContainerQty(sell_value.rate_obj, charge, \'quote\', $index, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, \'basis\',sell_key ) ; $ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'basis\');\">\n<option ng-repeat=\"basis in $ctrl.viewBasis\" value=\"{{basis}}\" \nng-if=\"(basis != $ctrl.constObj.FREIGHT_TOTAL_BASIS || (((sell_value.leg_code.includes(\'l2_\') || sell_value.leg_code.includes(\'l4_\')) && !sell_value.leg_code.includes(\'cha\')) && basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS)) && (basis != $ctrl.constObj.AIR_FREIGHT_BASIS || ((basis === $ctrl.constObj.AIR_FREIGHT_BASIS) && sell_value.leg_code.includes(\'l3_\') && $ctrl.searchParam.mode === \'AIR\')) && (basis != $ctrl.constObj.PICKUP_BASIS ||  ((basis === $ctrl.constObj.PICKUP_BASIS) && sell_value.leg_code.includes(\'l1_\'))) && (basis != $ctrl.constObj.DELIVERY_BASIS || (((basis === $ctrl.constObj.DELIVERY_BASIS) && sell_value.leg_code.includes(\'l5_\')))) && (basis != $ctrl.constObj.FREIGHT_BASIS || (((basis === $ctrl.constObj.FREIGHT_BASIS) && sell_value.leg_code.includes(\'l3_\') && $ctrl.searchParam.mode === \'SEA-LCL\')))\">\n{{basis}}</option></select></md-input-container></div><span \nng-show=\"$ctrl.basisArray.includes(charge.charge_basis) && (charge.total_units === null) || (!$ctrl.l3LegKey && charge.charge_basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS)\" \nclass=\"error\">{{charge.charge_basis}} can not applied for this charge.</span> <span class=\"error-text-position\" \nid=\"{{sell_key +\'_\'+ $index+\'_basisError\'}}\">Please Select</span></td><td><div \nng-if=\"!charge.is_qty_editable || !$ctrl.quoteEdit\" class=\"content-border p-8 remove-cursor text-center\"><span \nng-if=\"charge.charge_type==\'SLAB\'\"><span \nng-bind=\"(charge.total_units == null || !charge.charge_basis) ? \'-\' : ($ctrl.calculateQtyRange(charge, 0)| currencyMask)\">\n</span> | {{charge.slab[0].from}} - {{charge.slab[0].to}}<md-tooltip md-direction=\"top\">\n{{((charge.total_units == null || !charge.charge_basis) ? \'-\' : ($ctrl.calculateQtyRange(charge, 0) | currencyMask) )}}| {{charge.slab[0].from}} - {{charge.slab[0].to}}\n</md-tooltip></span><span ng-if=\"!charge.charge_type || charge.charge_type==\'FIXED\'\" \nng-bind=\"(charge.total_units == null || !charge.charge_basis) ? \'-\' : ( charge.total_units % 1 != 0 ? (charge.total_units | currencyMask) : (charge.total_units | currencyMask) ) \">\n<md-tooltip md-direction=\"top\">\n{{(charge.total_units == null || !charge.charge_basis) ? \'-\' : ( charge.total_units % 1 != 0 ? (charge.total_units | currencyMask) : (charge.total_units | currencyMask) )}}\n</md-tooltip></span><md-icon md-font-icon=\"icon-information-outline\" class=\"s14 ml-2 mb-3\" \nid=\"{{\'charge_\'+sell_value.rate_obj.global_leg_id+\'_\'+key}}\" \nng-if=\"$ctrl.currentCard.meta.ltl_load_details && (sell_value.rate_obj.global_leg_id == \'l1\' || sell_value.rate_obj.global_leg_id == \'l5\') && charge.charge_basis == \'per_w/m\'\">\n<md-tooltip md-direction=\"bottom\" class=\"black-bg p-10 white-fg\" \nstyle=\"display:table;opacity:1;line-height:1.3; box-shadow: 0px 0px 20px #00000014\" class=\"font-size-10\"><div \nng-if=\"sell_value.rate_obj.global_leg_id == \'l1\'\"><table><tr><td>Gross Weight</td><td>\n{{$ctrl.currentCard.meta.ltl_load_details.origin.gross_weight | numberMask: 2:20}} {{$ctrl.currentCard.meta.ltl_load_details.origin.gross_weight_unit}}\n</td></tr><tr><td>Dimensional Weight</td><td>\n{{$ctrl.currentCard.meta.ltl_load_details.origin.dimensional_weight | numberMask: 2:20}} {{$ctrl.currentCard.meta.ltl_load_details.origin.dimensional_unit}}\n</td></tr><tr><td>Chargeable Weight</td><td>\n{{$ctrl.currentCard.meta.ltl_load_details.origin.chargeable_weight | numberMask: 2:20}} {{$ctrl.currentCard.meta.ltl_load_details.origin.chargeable_unit}}\n</td></tr></table></div><div ng-if=\"sell_value.rate_obj.global_leg_id == \'l5\'\"><table><tr><td>Gross Weight</td><td>\n{{$ctrl.currentCard.meta.ltl_load_details.destination.gross_weight | numberMask: 2:20}} {{$ctrl.currentCard.meta.ltl_load_details.destination.gross_weight_unit}}\n</td></tr><tr><td>Dimensional Weight</td><td>\n{{$ctrl.currentCard.meta.ltl_load_details.destination.dimensional_weight | numberMask: 2:20}} {{$ctrl.currentCard.meta.ltl_load_details.destination.dimensional_unit}}\n</td></tr><tr><td>Chargeable Weight</td><td>\n{{$ctrl.currentCard.meta.ltl_load_details.destination.chargeable_weight | numberMask: 2:20}} {{$ctrl.currentCard.meta.ltl_load_details.destination.chargeable_unit}}\n</td></tr></table></div></md-tooltip></md-icon></div><md-input-container md-no-float \nclass=\"inline-flex content-border\" ng-if=\"charge.is_qty_editable && $ctrl.quoteEdit\" \nid=\"{{sell_key +\'_\'+ $index+\'_quantity\'}}\"><input ng-model=\"charge.total_units\" ng-model-options=\"{ debounce: 100 }\" \ntype=\"number\" step=\"any\" placeholder=\"Quantity\" name=\"quantity\" class=\"m-0 pl-7 select_box bottom-border text-center\" \nid=\"{{sell_key +\'_\'+ $index+\'_quantty\'}}\" ng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge)\" \nng-change=\"$ctrl.fnGetContainerQty(sell_value.rate_obj, charge, \'quote\', $index, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, \'quantity\',sell_key );$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'quantity\');\">\n</md-input-container><span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_quantityError\'}}\">Please Enter\n</span> <span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index + \'_quantityCharacter\'}}\">Invalid Input</span>\n</td><td class=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg\" \nng-if=\"$ctrl.isShowBuyCol && (!$ctrl.editBuyRate || (!charge.manual && !$ctrl.isBuyRateEditable))\"><div \nclass=\"content-border p-8 rates-width remove-cursor\"><span class=\"line-height-17\" \nng-if=\"!$ctrl.isString($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate)\"><span \nclass=\"pr-20\" ng-if=\"!(charge.charge_basis.includes(\'%\'))\" \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].charge_currency\"></span> <span \nclass=\"ph-17\" ng-if=\"charge.charge_basis.includes(\'%\')\">%</span> </span><span \nng-bind=\"$ctrl.fnCheckIsNaN($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], \'per_unit_rate\')\">\n</span></div></td><td ng-if=\"$ctrl.isShowBuyCol && $ctrl.editBuyRate && (charge.manual || $ctrl.isBuyRateEditable)\" \nclass=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg\"><md-input-container md-no-float \nclass=\"inline-flex content-border rates-width\" id=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\"><select \nclass=\"currency-align custom_select\" ng-if=\"!(charge.charge_basis.includes(\'%\'))\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].charge_currency\" placeholder=\"Currency\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, $index, sell_key, \'buy_currency\')\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><div class=\"mh-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"charge.charge_basis.includes(\'%\')\">%</div><input \nng-if=\"charge.charge_type!=\'SLAB\'  || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate\" \ntitle=\"{{$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate}}\" \nng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 ph-0 select_box bottom-border pt-4\" id=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'buyUnit\')\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj,$index,sell_key)\">\n <input ng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type===\'INCREMENTAL\'\" \nng-readonly=\"!$ctrl.calculateQtyRange(charge, 0)\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].slab[0].cost\" \nng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 ph-0 select_box bottom-border pt-4\" id=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'buyUnit\')\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj,$index,sell_key);\">\n</md-input-container><span class=\"error-text-position pl-5\" id=\"{{sell_key +\'_\'+ $index + \'_buyUnitError\'}}\">\nPlease Enter</span> <span class=\"error-text-position pl-5\" id=\"{{sell_key +\'_\'+ $index + \'_buyUnitCharacter\'}}\">\nInvalid Input</span></td><td \nng-if=\"$ctrl.isShowBuyCol && (!$ctrl.editBuyRate || (!charge.manual && !$ctrl.isBuyRateEditable))\" \nclass=\"rates-bg remove-cursor {{sell_key + $index+\'remove-rates-bg\'}}\"><div \nclass=\"content-border text-center pl-5 p-8 line-height-17\"><span \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].minimum_charge_cost | numberMask:2:20\">\n</span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.isShowBuyCol && $ctrl.editBuyRate && (charge.manual ||  $ctrl.isBuyRateEditable)\" \nclass=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg\"><md-input-container md-no-float \nclass=\"inline-flex content-border\" id=\"{{sell_key +\'_\'+ $index+\'_buyMinimum\'}}\"><input \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].minimum_charge_cost\" \nng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'buyMinimum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Minimum Amount\" name=\"min_amount\" class=\"m-0 text-center select_box bottom-border pt-4\" \nid=\"{{sell_key +\'_\'+ $index+\'_buy_min_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj,$index,sell_key);\">\n</md-input-container><span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_buyMinimumError\'}}\">Please Enter\n</span> <span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index + \'_buyMinimumCharacter\'}}\">Invalid Input</span>\n</td><td ng-if=\"$ctrl.isShowBuyCol && (!$ctrl.editBuyRate || (!charge.manual && !$ctrl.isBuyRateEditable))\" \nclass=\"rates-bg remove-cursor {{sell_key + $index+\'remove-rates-bg\'}}\"><div \nclass=\"content-border text-center pl-5 p-8 line-height-17\"><span \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].maximum_charge_cost | numberMask :2:20\">\n</span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.isShowBuyCol && $ctrl.editBuyRate && (charge.manual || $ctrl.isBuyRateEditable)\" \nclass=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg\"><md-input-container md-no-float \nclass=\"inline-flex content-border\" id=\"{{sell_key +\'_\'+ $index+\'_buyMaximum\'}}\"><input \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].maximum_charge_cost\" \nng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'buyMaximum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Maximum Amount\" name=\"max_amount\" class=\"m-0 text-center select_box bottom-border pt-4\" \nid=\"{{sell_key +\'_\'+ $index+\'_buy_max_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj,$index,sell_key);\">\n</md-input-container><span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_buyMaximumError\'}}\">\nMaximum must be greater than Minimum</span> <span class=\"error-text-position\" \nid=\"{{sell_key +\'_\'+ $index + \'_buyMaximumCharacter\'}}\">Invalid Input</span></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.isShowBuyCol\" class=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg\"><div \nclass=\"content-border p-8 remove-cursor\"><span class=\"pr-3 line-height-17\" \nng-if=\"!$ctrl.isString($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].charge_cost) || $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].min_flag || $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].max_flag\" \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.leg_currency\"></span> <span \nng-bind=\"$ctrl.fnCheckIsNaN($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index])\"></span> <sup \nclass=\"green-fg\" ng-if=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].min_flag\">*<md-tooltip \nmd-direction=\"top\" class=\"font-size-10\">Minimum amount</md-tooltip></sup><sup class=\"green-fg\" \nng-if=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].max_flag\">*<md-tooltip md-direction=\"top\" \nclass=\"font-size-10\">Maximum amount</md-tooltip></sup></div></td><td ng-if=\"!$ctrl.quoteEdit\"><div \nclass=\"content-border p-8 remove-cursor\" ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\"><span \nng-class=\"{\'pr-5\':!$ctrl.isShowBuyCol, \'pr-20\':$ctrl.isShowBuyCol}\" ng-if=\"!$ctrl.isString(charge.per_unit_rate)\" \nng-bind=\"charge.charge_basis.includes(\'%\') ? \'%\' : charge.charge_currency\"></span> <span \nng-bind=\"$ctrl.fnCheckIsNaN(charge, \'per_unit_rate\')\"></span></div></td><td ng-if=\"$ctrl.quoteEdit\"><md-input-container\n md-no-float class=\"inline-flex content-border\" id=\"{{sell_key +\'_\'+ $index+\'_sellUnit\'}}\"><select \nclass=\"custom_select currency-align font-size-13\" ng-if=\"!(charge.charge_basis.includes(\'%\'))\" \nng-model=\"charge.charge_currency\" placeholder=\"Currency\" class=\"m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index,sell_key, \'sell_currency\')\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><div class=\"mh-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"charge.charge_basis.includes(\'%\')\">%</div><input \nng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" ng-model=\"charge.per_unit_rate\" \ntitle=\"{{charge.per_unit_rate}}\" ng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" \nname=\"unit_price\" class=\"m-0 ph-0 select_box bottom-border font-size-13 pt-4\" id=\"{{sell_key +\'_\'+ $index+\'_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj,$index,sell_key )\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'sellUnit\')\"> <input \nng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type===\'INCREMENTAL\'\" \nng-readonly=\"!$ctrl.calculateQtyRange(charge, 0)\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].slab[0].cost\" \ntitle=\"{{$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].slab[0].cost}}\" \nng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 ph-0 select_box bottom-border pt-4\" id=\"{{sell_key +\'_\'+ $index+\'_unit\'}}\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'sellUnit\')\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index],\n                        $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, $index,sell_key);\">\n</md-input-container><span class=\"error-text-position pl-5\" id=\"{{sell_key +\'_\'+ $index + \'_sellUnitError\'}}\">\nPlease Enter</span> <span class=\"error-text-position pl-5\" id=\"{{sell_key +\'_\'+ $index+\'_sellUnitCharacter\'}}\">\nInvalid Input</span></td><td ng-if=\"!$ctrl.quoteEdit\"><div class=\"content-border text-center p-8 remove-cursor\"><span \nng-bind=\"charge.minimum_charge_cost  | numberMask:2:20\"></span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.quoteEdit\"><md-input-container md-no-float class=\"inline-flex content-border\" \nid=\"{{sell_key +\'_\'+ $index+\'_sellMinimum\'}}\"><input ng-model=\"charge.minimum_charge_cost\" \nng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'sellMinimum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Minimum Amount\" name=\"min_amount\" class=\"m-0 select_box bottom-border text-center pt-4\" \nid=\"{{sell_key +\'_\'+ $index+\'_min_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj,$index,sell_key);\"></md-input-container><span \nclass=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_sellMinimumError\'}}\">Please Enter</span> <span \nclass=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_sellMinimumCharacter\'}}\">Invalid Input</span></td><td \nng-if=\"!$ctrl.quoteEdit\"><div class=\"content-border text-center p-8 remove-cursor\"><span \nng-bind=\"charge.maximum_charge_cost  | numberMask:2:20\"></span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.quoteEdit\"><md-input-container md-no-float class=\"inline-flex content-border\" \nid=\"{{sell_key +\'_\'+ $index+\'_sellMaximum\'}}\"><input ng-model=\"charge.maximum_charge_cost\" \nng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'sellMaximum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Maximum Amount\" name=\"max_amount\" class=\"m-0 select_box bottom-border text-center pt-4\" \nid=\"{{sell_key +\'_\'+ $index+\'_max_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj,$index,sell_key)\"></md-input-container><span \nclass=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_sellMaximumError\'}}\">Maximum must be greater than Minimum\n</span></td><td rowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\">\n<div class=\"content-border p-8 remove-cursor\" ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\"><span \nng-class=\"{\'pr-5\':!$ctrl.isShowBuyCol}\" \nng-if=\"!$ctrl.isString(charge.charge_cost) || charge.min_flag || charge.max_flag\" class=\"line-height-17\" \nng-bind=\"sell_value.rate_obj.leg_currency\"></span> <span ng-bind=\"$ctrl.fnCheckIsNaN(charge)\"></span> <sup \nclass=\"green-fg\" ng-if=\"charge.min_flag\">*<md-tooltip md-direction=\"top\" class=\"font-size-10\">Minimum amount\n</md-tooltip></sup><sup class=\"green-fg\" ng-if=\"charge.max_flag\">*<md-tooltip md-direction=\"top\" class=\"font-size-10\">\nMaximum amount</md-tooltip></sup></div></td><td class=\"text-center\" ng-if=\"!$ctrl.util.isShipper\"><div \nng-if=\"!(charge.internal_comments || charge.external_comments)\"><md-icon class=\"comments-icon cursor\" \nmd-svg-src=\"assets/icons/custom/add_comment.svg\" title=\"Add\" \nng-click=\"$ctrl.fnOpenCommentPanel($event , charge,$ctrl.quoteEdit , $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index])\">\n</md-icon></div><div ng-if=\"(charge.internal_comments || charge.external_comments)\"><md-icon \nclass=\"comments-icon cursor\" md-svg-src=\"assets/icons/custom/edit_comment.svg\" title=\"Edit\" \nng-click=\"$ctrl.fnOpenCommentPanel($event , charge,$ctrl.quoteEdit , $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index])\">\n</md-icon></div></td><td ng-if=\"$ctrl.util.isShipper\"><div><md-icon class=\"comments-icon cursor\" \nmd-svg-src=\"assets/icons/custom/edit_comment.svg\" ng-class=\"{\'disable-state\':(!charge.external_comments )}\" \nng-click=\"$ctrl.fnOpenCommentPanel($event , charge,$ctrl.quoteEdit)\"></md-icon><md-tooltip md-direction=\"top\" \nng-if=\"!charge.external_comments \">No Comments Available</md-tooltip></div></td><td ng-if=\"$ctrl.quoteEdit\"><div \nlayout=\"row\"><div><md-icon class=\"s20 cursor\" md-font-icon=\"icon-minus-circle-outline red-400-fg pt-7\" \ntitle=\"Remove charge\" ng-click=\"$ctrl.confirmDeleteCharge(sell_key,sell_value.rate_obj,$index, \'quote\')\" \nng-if=\"$ctrl.quoteEdit\" ng-class=\"{\'disable-state\':$ctrl.footerObj.rateExpired}\"></md-icon><md-tooltip \nmd-direction=\"top\" ng-if=\"$ctrl.footerObj.rateExpired\">This Rate is expired</md-tooltip></div><div><md-icon \nng-if=\"$last\" class=\"s20 cursor ml-7 pt-7\" md-font-icon=\"icon-plus-circle-outline green-400-fg\" title=\"Add charge\" \nng-class=\"{\'disable-state\':$ctrl.footerObj.rateExpired}\" ng-click=\"$ctrl.fnAddNewCharge(sell_key,sell_value)\" \nng-if=\"$ctrl.quoteEdit\"></md-icon><md-tooltip md-direction=\"top\" ng-if=\"$ctrl.footerObj.rateExpired\">\nThis Rate is expired</md-tooltip></div></div></td></tr><tr id=\"{{sell_key +\'_\'+ $index+\'_row\'}}\" \nng-repeat-end=\"(child_key, value) in charge.slab\" \nng-if=\"charge.charge_type===\'SLAB\' && charge.slab[child_key+1] && (charge.slab_type===\'INCREMENTAL\' )\"><td><span><span \nng-bind=\"charge.total_units == \'\' ? \'-\' : $ctrl.calculateQtyRange(charge, child_key+1) | currencyMask: 2\"></span>\n | {{charge.slab[child_key+1].from}} - {{charge.slab[child_key+1].to}}</span></td><td class=\"br\" \nng-if=\"!$ctrl.editBuyRate || (!charge.manual && !$ctrl.inquiryPricing)\"><span class=\"pr-5\" \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].charge_currency\"></span> <span \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].slab[child_key+1].cost | currencyMask:2\">\n</span></td><td ng-if=\"!$ctrl.quoteEdit\" class=\"br\"><span><span class=\"pr-5\" ng-bind=\"charge.charge_currency\"></span> \n<span ng-bind=\"charge.slab[child_key+1].cost | currencyMask:2\"></span></span></td><td class=\"br\" \nng-if=\"$ctrl.editBuyRate && (charge.manual || $ctrl.inquiryPricing)\"><md-input-container md-no-float \nclass=\"inline-flex\"><span class=\"mt-5 pr-3\"><select class=\"custom_select\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].charge_currency\" placeholder=\"Currency\" \nclass=\"m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, key,sell_key, \'currency\')\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select></span><md-input-container md-no-float class=\"inline-flex\">\n<input ng-readonly=\"!$ctrl.calculateQtyRange(charge,\n                            child_key+1)\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].slab[child_key+1].cost\" \nng-model-options=\"{ debounce: 100 }\" type=\"number\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 select_box bottom-border\" id=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, key,sell_key)\">\n</md-input-container></md-input-container></td><td class=\"br\" ng-if=\"$ctrl.quoteEdit\"><md-input-container md-no-float \nclass=\"inline-flex\"><span class=\"mt-5 pr-3\"><select class=\"custom_select\" ng-model=\"charge.charge_currency\" \nplaceholder=\"Currency\" class=\"m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, $ctrl.currentCard.data.sell_rates[sell_key].rate_obj, key,sell_key, \'currency\')\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select></span><md-input-container md-no-float class=\"inline-flex\">\n<input ng-readonly=\"!$ctrl.calculateQtyRange(charge, child_key+1)\" ng-model=\"charge.slab[child_key+1].cost\" \nng-model-options=\"{ debounce: 100 }\" type=\"number\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 select_box bottom-border\" id=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, $ctrl.currentCard.data.sell_rates[sell_key].rate_obj, key,sell_key)\">\n</md-input-container></md-input-container></td></tr></tbody></table></md-content></div><div class=\"overlayLeg hide\" \nid=\"{{sell_key+\'_askDeleteLeg\'}}\"><div class=\"delete-confirmation-div\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"$ctrl.chargeDelete\"><p ng-if=\"!$ctrl.is_delete_l3_leg\">Delete this {{$ctrl.deleteChargeLineObj.charge_name}} ?\n</p><p ng-if=\"$ctrl.is_delete_l3_leg && $ctrl.currentPage == \'result\'\">\nDeleting this charge will remove this rate card from quotation.</p><p \nng-if=\"$ctrl.is_delete_l3_leg && $ctrl.currentPage == \'quote\'\">You can not delete this charge.</p></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.legDelete\"><p ng-if=\"!$ctrl.is_delete_l3_leg\">\nDelete this {{$ctrl.deleteLegObj.leg_name}} ?</p><p ng-if=\"$ctrl.is_delete_l3_leg && $ctrl.currentPage == \'result\'\">\nDeleting this leg will remove this rate card from quotation.</p><p \nng-if=\"$ctrl.is_delete_l3_leg && $ctrl.currentPage == \'quote\'\">You can not delete this leg.</p></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button md-no-ink class=\"md-primary-btn mr-10\" ng-click=\"$ctrl.cancelDelete(sell_key)\">\nClose</md-button><md-button md-no-ink ng-if=\"$ctrl.chargeDelete\" class=\"md-accent-btn ml-10\" \nng-disabled=\"$ctrl.deleteChargeBtn\" ng-click=\"$ctrl.fnDeleteNewCharge(sell_key)\">Yes, Delete</md-button><md-button \nmd-no-ink ng-if=\"$ctrl.legDelete\" class=\"md-accent-btn ml-10\" ng-disabled=\"$ctrl.deleteChargeBtn\" \nng-click=\"$ctrl.fnDeleteLeg(sell_key)\">Yes, Delete</md-button></div></div></div><div class=\"overlayLeg hide\" \nid=\"{{sell_key+\'_reloadCurrency\'}}\"><div class=\"replay-icon-div text-center\"><md-icon md-font-icon=\"icon-replay\" \nclass=\"s50 grey-400-fg\"></md-icon></div></div></div><div layout=\"row\" layout-align=\"start center\" class=\"mt-20\" \nflex=\"100\" ng-if=\"$ctrl.quoteEdit\"><md-button layout=\"row\" md-no-ink class=\"md-link-btn m-0\" title=\"Add Leg\" \nng-click=\"$ctrl.fnAddNewLeg($ctrl.currentCard)\" ng-disabled=\"$ctrl.footerObj.rateExpired\"><div><md-icon \nmd-font-icon=\"icon-plus md-link-fg s20\" placeholder=\"Add leg\"></md-icon></div><div class=\"font-size-13\">Add Leg</div>\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.footerObj.rateExpired\">This Rate is expired</md-tooltip></md-button></div>\n<div class=\"border-shipper leg-border-bottom\" \nng-if=\"($ctrl.util.isShipper || $ctrl.isShared) && $ctrl.allInQuote ==\'legwise_total\'\"><div \nng-repeat=\"(sell_key, sell_value) in $ctrl.currentCard.data.sell_rates track by $index\" \nng-if=\"sell_value.rate_obj && sell_value.rate_obj.charges.length\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"p-5 height-46\" layout-wrap><div class=\"font-size-13 p-5\" \nng-bind=\"( sell_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : sell_value.leg_name\"></div><div layout=\"row\" \nlayout-align=\"end center\" layout-wrap><div class=\"p-5\" ng-bind=\"sell_value.rate_obj.leg_currency\"></div><div \nclass=\"p-5\" ng-bind=\"sell_value.rate_obj.leg_currency_cost | currencyMask : 2\"></div></div></div></div></div>");
$templateCache.put("app/main/component/rate-modification/rate-modification.html","<div ng-if=\"$ctrl.util.isShipper || $ctrl.isShared\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\" \nclass=\"mt-20 fixed-total-leg p-5 font-size-23\" layout-wrap><div layout-align=\"start center\" \nclass=\"p-5 Font-Bold font-size-16\">Total</div><div layout=\"row\" layout-align=\"end center\" layout-wrap><div \nclass=\"total_div layout-row\" layout=\"row\"><div class=\"p-5 Font-Bold\">{{$ctrl.searchUser.user_base_currency}}</div><div \nclass=\"p-5 Font-Bold\">{{$ctrl.footerObj.sellTotalBaseCurr | currencyMask: 2}}</div></div></div></div><div \nng-class=\"{\'mt-20\':!($ctrl.util.isShipper || $ctrl.isShared),\'border-shipper\':$ctrl.util.isShipper || $ctrl.isShared}\" \nclass=\"pt-0 quotes-table position-relative\" \nng-repeat=\"(sell_key, sell_value) in $ctrl.currentCard.data.sell_rates track by $index\" \nng-if=\"sell_value.rate_obj && sell_value.rate_obj.charges.length &&  $ctrl.checkDefaultKey\" \nid=\"{{sell_key+\'_cardLeg\'}}\"><div layout=\"row\" flex=\"100\" layout-align=\"space-between center\" \nclass=\"p-5 quotation-leg\" layout-wrap ng-class=\"{\'leg-border-bottom\' :$ctrl.util.isShipper || $ctrl.isShared}\"><div \nlayout-align=\"start center\" class=\"ph-5\"><div ng-if=\"!$ctrl.quoteEdit || sell_value.rate_obj.leg_code.includes(\'sop\')\" \nclass=\"font-size-16 font-weight-600 fg-333333\" \nng-bind=\"( sell_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : sell_value.leg_name\"></div><md-input-container \nmd-no-float class=\"leg-name panel-select\" ng-keyup=\"$ctrl.fnLegNameChange(sell_key,$event)\" \nng-if=\"$ctrl.quoteEdit && !sell_value.rate_obj.leg_code.includes(\'sop\')\" id=\"{{sell_key + \'_leg\'}}\" \nrestrict-to=\"{{$ctrl.util.nonSpecialCharacterRegex}}\"><md-autocomplete md-input-name=\"legName\" \nmd-selected-item=\"selectedLeg\" md-search-text=\"sell_value.leg_name\" \nmd-selected-item-change=\"$ctrl.fnLegSelected(selectedLeg,sell_value,sell_key)\" md-input-id=\"{{sell_key}}\" \nmd-items=\"item in $ctrl.fnGetLegList(sell_value.leg_name)\" md-item-text=\"item.leg_name\" md-min-length=\"3\" \nmd-select-on-match=\"false\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"300\" placeholder=\"Leg Name\" \nng-required=\"true\" class=\"leg-name-class\"><md-item-template><span md-highlight-text=\"sell_value.leg_name\" \nmd-highlight-flags=\"^i\">{{item.leg_name}}</span></md-item-template></md-autocomplete></md-input-container><span \nclass=\"legError\" id=\"{{sell_key + \'_text\'}}\">Please enter leg name</span> <span class=\"legError\" \nid=\"{{sell_key + \'_duplicateText\'}}\">Leg Name Already Exists</span></div><div layout=\"row\" layout-align=\"end center\" \nlayout-wrap><div layout=\"row\" layout-align=\"start center\" \nng-if=\"(!$ctrl.currentCard.meta.type.includes(\'network\') || sell_value.rate_obj.show_upload_rate_sheet ) && $ctrl.sourceRate && $ctrl.sourceRate!={} && sell_value.rate_obj && sell_value.rate_obj.batchcode\">\n<button ng-repeat=\"batchcode in sell_value.rate_obj.batchcode track by $index\"><div \nng-if=\"$ctrl.sourceRate[batchcode].sourceFileUrl\"><div ng-click=\"$ctrl.sourceDownload(batchcode)\"><div \nclass=\"m-10 h-16 blue-600-fg Font-Bold pointer\" layout=\"row\" layout-align=\"center center\"><div class=\"mr-5\"><md-icon \nclass=\"cursor blue-600-fg s16\" md-font-icon=\"icon-download\"></md-icon></div><div>Download Source {{$index+1}}</div>\n<md-tooltip md-direction=\"top\" ng-if=\"!$ctrl.util.isMobileDevice\">Download original source rate sheet</md-tooltip>\n</div></div></div></button></div><div layout=\"row\" layout-align=\"start center\"><button layout=\"row\" \nlayout-align=\"center center\" class=\"m-10 h-16 red-600-fg\" ng-if=\"$ctrl.quoteEdit || $ctrl.inquiryPricing\" \nng-click=\"$ctrl.fnDeleteLegConfirmation(sell_key,sell_value)\"><div class=\"mr-5\"><md-icon class=\"cursor red-600-fg s20\" \nmd-font-icon=\"icon-delete\"></md-icon></div><div>Delete Leg</div></button></div><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"m-10 fg-333333\">Sub Total</div><div class=\"total_div\" \nlayout=\"row\"><div class=\"p-5\" ng-if=\"!$ctrl.quoteEdit\" ng-bind=\"sell_value.rate_obj.leg_currency\"></div><select \nng-if=\"$ctrl.quoteEdit\" ng-model=\"sell_value.rate_obj.leg_currency\" placeholder=\"Currency\" \nclass=\"m-0 leg_curr_select border-left select_currency select_box\" \nng-change=\"$ctrl.fnLegCurrencyChange(sell_key,sell_value.rate_obj.leg_currency);$ctrl.fnTrackAnalytics(\'RateCard-LegCurrency-Change\')\" \nng-model-options=\"{\n              updateOn: \'default blur onchange\',\n              debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n            }\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><div class=\"total-disabled\" \nng-bind=\"sell_value.rate_obj.leg_currency_cost | currencyMask: 2\"></div></div></div></div></div><div \nclass=\"simple-table-container\" id=\"charges-table\"><md-content><table class=\"simple\" ms-responsive-table><thead \nng-class=\"{\'shipper-header\':!$ctrl.isShowBuyCol}\"><tr><th class=\"w-250\" rowspan=\"2\"><div \nclass=\"table-header column-title font-weight-600 text-left\">Charges</div></th><th class=\"w-100\" rowspan=\"2\" \nng-if=\"sell_value.leg_code==\'additional_services\'\"><div class=\"table-header column-title font-weight-600\">Type</div>\n</th><th class=\"w-120\" rowspan=\"2\"><div class=\"table-header column-title font-weight-600 text-left\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\">Basis</div></th><th class=\"w-100 text-center\" \nng-class=\"{\'w-125 p-15\':!$ctrl.isShowBuyCol}\" rowspan=\"2\"><div class=\"table-header column-title font-weight-600\">\nEquipment<br ng-if=\"$ctrl.isShowBuyCol\">Type</div></th><th class=\"text-center w-90\" rowspan=\"2\"><div \nclass=\"table-header column-title font-weight-600\">Quantity</div></th><th colspan=\"2\" ng-if=\"$ctrl.isShowBuyCol\" \nclass=\"rates-bg\"><div class=\"table-header text-center column-title font-weight-600\">Buy Rates</div></th><th \ncolspan=\"2\" ng-if=\"$ctrl.isShowBuyCol\"><div class=\"table-header text-center column-title font-weight-600\">Sell Rates\n</div></th><th class=\"text-center w-90\" rowspan=\"2\" ng-if=\"!$ctrl.isShowBuyCol\"><div \nclass=\"table-header column-title font-weight-600\">Unit Price</div></th><th class=\"text-center w-90\" rowspan=\"2\" \nng-if=\"!$ctrl.isShowBuyCol\"><div class=\"table-header column-title font-weight-600\">Amount</div></th><th rowspan=\"2\" \nclass=\"w-80\">Comments</th><th rowspan=\"2\" class=\"w-10\" ng-if=\"$ctrl.quoteEdit\">Action</th></tr><tr \nng-if=\"$ctrl.isShowBuyCol\"><th class=\"w-140 rates-bg text-center\">Unit Price</th><th \nclass=\"w-140 rates-bg text-center\">Amount</th><th class=\"w-140 text-center\">Unit Price</th><th \nclass=\"w-140 text-center\">Amount</th></tr></thead><tbody><tr id=\"{{sell_key +\'_\'+ $index+\'_row\'}}\" \nng-class=\"{\'user-charge-class\':!sell_value.rate_obj.charges.charge_id}\" \nng-repeat-start=\"(key, charge) in sell_value.rate_obj.charges track by $index\" class=\"bg_row\"><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nclass=\"chargeName w-250\"><div class=\"content-border text-left\" id=\"{{sell_key +\'_\'+ $index+\'_charge\'}}\"><div \nng-if=\"!$ctrl.quoteEdit || (!charge.manual && !$ctrl.inquiryPricing) \" layout=\"row\" flex=\"100\" \nclass=\"ph-8 remove-cursor pb-5\"><div layout-align=\"left center\" flex=\"75\" class=\"text-left\"><div layout=\"row\" \nclass=\"pt-9\"><span ng-bind=\"charge.charge_name\" class=\"ellipsis-120\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11\">{{charge.charge_name}}</md-tooltip></span><span class=\"pl-5\" ng-bind=\"charge.container_type\">\n</span></div><span class=\"font-size-11\" \nng-if=\"charge.charge_type===\'SLAB\' && charge.calculated_slab && charge.calculated_slab.length\">\n{{charge.calculated_slab[0].from}} {{ (charge.calculated_slab[0].from == null || charge.calculated_slab[0].from == undefined) ? \'0\' : (charge.slab_basis ? (charge.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \')+ \' to \' }} {{charge.calculated_slab[0].to}} {{ (charge.calculated_slab[0].to ? (charge.slab_basis ? (charge.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \') : \'∞\')}}\n<md-icon class=\"s12\" position=\"bottom\" md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nWeight Range Charge</md-tooltip></md-icon></span></div><div layout=\"row\" flex=\"25\" layout-align=\"end center\" \nclass=\"pt-4\"><span class=\"dim-charge-sect\" ng-if=\"charge.charge_basis.includes(\'dim\')\">DIM Charge<md-tooltip \nng-if=\"$ctrl.dimLegList\" md-direction=\"top\" class=\"tooltip-height\"><div ng-repeat=\"legList in $ctrl.dimLegList\">\n{{legList.leg_name}} - {{legList.cbm}} KG / CBM</div></md-tooltip></span><span \nclass=\"dim-charge-sect dim-charge-width\" ng-if=\"charge.charge_category && charge.charge_category !== null\" \nng-bind=\"charge.charge_category\"></span></div></div><md-input-container md-no-float class=\"inline-flex\" \nng-if=\"$ctrl.quoteEdit && (charge.manual || $ctrl.inquiryPricing)\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'charge\');$ctrl.fnChargeTextChange(charge, key, sell_key,$event);\" \nrestrict-to=\"{{$ctrl.util.nonSpecialCharacterRegex}}\" title=\"{{charge.charge_name}}\"><md-autocomplete \nng-disabled=\"!sell_value.leg_name\" class=\"pl-8\" md-input-name=\"chargeName\" md-selected-item=\"selectedCharge\" \nmd-search-text=\"charge.charge_name\" \nmd-selected-item-change=\"$ctrl.fnChargeSelection(selectedCharge,charge, sell_value, $index, sell_key)\" \nmd-items=\"item in $ctrl.getChargeList(charge.charge_name,sell_value, charge )\" md-item-text=\"item.charge_name\" \nmd-min-length=\"3\" md-input-id=\"{{sell_key +\'_\'+ $index}}\" md-select-on-match=\"false\" md-clear-button=\"false\" \nmd-no-cache=\"false\" md-delay=\"300\" placeholder=\"Charge Name\" ng-required=\"true\"><md-item-template><span \nmd-highlight-text=\"charge.charge_name\" md-highlight-flags=\"^i\" title=\"{{item.name_alias}}\">{{item.name_alias}}</span>\n</md-item-template></md-autocomplete><div class=\"sticky-charge-sect-tag dim-charge-sect pb-5\" \nng-if=\"charge.charge_category && charge.charge_category !== null\" ng-bind=\"charge.charge_category\"></div>\n</md-input-container></div><div class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_chargeError\'}}\">Please Enter\n</div><div class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_userDefinedChargeError\'}}\">\nUser Defined Charges Cannot Be Published</div><div layout=\"row\" class=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_name && charge.charge_name.length<=2 && !charge.charge_id\">Enter the first three letter to search\n</div><div layout=\"row\" class=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_name.length> 2 && !charge.charge_id && !$ctrl.shareQuoteService.userDefinedChargeValidation\">\nAdding a user defined charge</div><div layout=\"row\" class=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_id && charge.charge_id.includes(\'UD\') && !$ctrl.shareQuoteService.userDefinedChargeValidation\">\nUser defined charge</div></td><td class=\"chargeName\" ng-if=\"sell_value.leg_code==\'additional_services\'\"><span \nng-repeat=\"leg in charge.leg track by $index\"><span ng-bind=\"leg.name\"></span> <span ng-if=\"!$last\">,</span></span>\n</td><td rowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol,\'basis-error-border\':$ctrl.basisArray.includes(charge.charge_basis) && (charge.total_units === null)  || (!$ctrl.l3LegKey && charge.charge_basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS)}\" \nid=\"{{sell_key +\'_\'+ $index+\'_chargeBasis\'}}\"><div class=\"pt-8 pl-5 remove-cursor ellipsis-120 basis-ellipsis-100\" \nng-class=\"{\'w-basis\':charge.charge_basis===\'per teu\'}\" \nng-if=\"!$ctrl.quoteEdit || (!charge.manual && !$ctrl.inquiryPricing) || ($ctrl.fromInquiry && charge.charge_id && sell_value.rate_obj.leg_code == \'l3_fcl\')\" \nng-bind=\"charge.charge_basis\"><md-tooltip md-direction=\"top\" class=\"font-size-11\">{{charge.charge_basis}}</md-tooltip>\n</div><md-input-container md-no-float class=\"inline-flex full-width\" \nng-class=\"{\'w-basis\':charge.charge_basis===\'per teu\'}\" \nng-if=\"$ctrl.quoteEdit && (charge.manual || $ctrl.inquiryPricing) && (!$ctrl.fromInquiry || !charge.charge_id || sell_value.rate_obj.leg_code != \'l3_fcl\')\">\n<select class=\"custom_select full-width h-32\" id=\"{{sell_key +\'_\'+ $index+\'_chargeBasis\'}}\" \nng-model=\"charge.charge_basis\" placeholder=\"Basis\" title=\"{{charge.charge_basis}}\" \nclass=\"m-0 select_currency rate_select_box\" \nng-change=\"$ctrl.fnChangeBasis(charge, sell_value, $index, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key], \'basis\',sell_key); $ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'basis\');\">\n<option ng-repeat=\"basis in $ctrl.viewBasis\" value=\"{{basis}}\" \nng-if=\"(basis != $ctrl.constObj.FREIGHT_TOTAL_BASIS || (((sell_value.leg_code.includes(\'l2_\') || sell_value.leg_code.includes(\'l4_\')) && !sell_value.leg_code.includes(\'cha\')) && basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS)) && (basis != $ctrl.constObj.FREIGHT_BASIS || ((basis === $ctrl.constObj.FREIGHT_BASIS) && sell_value.leg_code.includes(\'l3_\'))) && (basis != $ctrl.constObj.PICKUP_BASIS ||  ((basis === $ctrl.constObj.PICKUP_BASIS) && sell_value.leg_code.includes(\'l1_\'))) && (basis != $ctrl.constObj.DELIVERY_BASIS || (((basis === $ctrl.constObj.DELIVERY_BASIS) && sell_value.leg_code.includes(\'l5_\'))))\">\n{{basis}}</option></select></md-input-container><md-icon ng-if=\"charge.charge_basis===\'per teu\'\" class=\"s12\" \nposition=\"bottom\" ng-class=\"{\'mb-5\':!$ctrl.quoteEdit || (!charge.manual && !$ctrl.inquiryPricing) }\" \nmd-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\" class=\"tooltip-height\"><div>\n20 GP/RE/NR/OT/FR - 1 TEU</div><div>40 GP/HC/RE/HR/NR/OT/FR - 2 TEU</div><div>45HC - 2.25 TEU</div><div>53HC - 2.65 TEU\n</div></md-tooltip></md-icon></div><span \nng-show=\"$ctrl.basisArray.includes(charge.charge_basis) && (charge.total_units === null)  || (!$ctrl.l3LegKey && charge.charge_basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS)\" \nclass=\"error\">{{charge.charge_basis}} can not applied for this charge.</span> <span class=\"error-text-position\" \nid=\"{{sell_key +\'_\'+ $index+\'_basisError\'}}\">Please Select</span> <span class=\"error-text-position\" \nid=\"{{sell_key +\'_\'+ $index+\'_duplicateBasis\'}}\">Already exist</span></td><td \nng-if=\"!$ctrl.quoteEdit || (!charge.manual && !$ctrl.inquiryPricing)\" \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border text-center p-8 remove-cursor\"><span ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\" \nclass=\"line-height-17\" \nng-bind=\"(charge.charge_basis === \'per equipment\' || charge.charge_basis === \'per kg\' || charge.charge_basis === \'per ton\' || charge.charge_basis === $ctrl.constObj.PICKUP_BASIS || charge.charge_basis === $ctrl.constObj.DELIVERY_BASIS || charge.charge_basis === $ctrl.constObj.FREIGHT_BASIS) ? charge.container_type : \'N/A\'\">\n</span></div></td><td ng-if=\"$ctrl.quoteEdit && (charge.manual || $ctrl.inquiryPricing)\" \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border text-center\" id=\"{{sell_key +\'_\'+ $index+\'_equipmentType\'}}\"><div \nng-if=\"charge.charge_basis !== \'per equipment\' && charge.charge_basis !== \'per kg\'  && charge.charge_basis !== \'per ton\' && charge.charge_basis !== $ctrl.constObj.PICKUP_BASIS && charge.charge_basis !== $ctrl.constObj.DELIVERY_BASIS && charge.charge_basis !== $ctrl.constObj.FREIGHT_BASIS\" \nclass=\"p-8\">N/A</div><md-input-container md-no-float \nng-if=\"charge.charge_basis === \'per equipment\' || charge.charge_basis === \'per kg\'  || charge.charge_basis === \'per ton\' || charge.charge_basis === $ctrl.constObj.PICKUP_BASIS || charge.charge_basis === $ctrl.constObj.DELIVERY_BASIS || charge.charge_basis === $ctrl.constObj.FREIGHT_BASIS\" \nclass=\"inline-flex full-width\"><select class=\"custom_select text-center mt-3 full-width\" \nng-model=\"charge.container_type\" placeholder=\"Equipment Type\" class=\"m-0 p-8 select_currency rate_select_box\" \nng-change=\"$ctrl.fnChangeBasis(charge, sell_value,\n                $index, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index],\n                $ctrl.currentCard.data.buy_rates[sell_key], \'container\',sell_key) ; $ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'container\');\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n<option ng-repeat=\"item in $ctrl.searchParam.load_data.load_details_value\" value=\"{{item.type}}\">{{item.type}}</option>\n</select></md-input-container></div><span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_equipmentError\'}}\">\nPlease Select</span> <span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_duplicateEquipment\'}}\">\nAlready exists</span></td><td><div ng-if=\"!charge.is_qty_editable || !$ctrl.quoteEdit\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\" class=\"content-border text-center p-8 remove-cursor\"><span \nclass=\"line-height-17\" ng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type===\'INCREMENTAL\'\">\n{{charge.total_units == \'\' ? \'-\' : $ctrl.calculateQtyRange(charge, 0) | currencyMask }} | {{charge.slab[0].from}} - {{charge.slab[0].to}}\n<md-tooltip md-direction=\"top\">\n{{charge.total_units == \'\' ? \'-\' : $ctrl.calculateQtyRange(charge, 0) | currencyMask }} | {{charge.slab[0].from}} - {{charge.slab[0].to}}\n</md-tooltip></span><span class=\"line-height-17\" \nng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-bind=\"charge.total_units == \'\' ? \'-\' : (charge.total_units | currencyMask)\"><md-tooltip md-direction=\"top\">\n{{charge.total_units == \'\' ? \'-\' : (charge.total_units | currencyMask)}}</md-tooltip></span></div><md-input-container \nmd-no-float class=\"inline-flex content-border\" id=\"{{sell_key +\'_\'+ $index+\'_quantity\'}}\" \nng-if=\"charge.is_qty_editable && $ctrl.quoteEdit\"><input ng-model=\"charge.total_units\" \nng-model-options=\"{ debounce: 100 }\" type=\"number\" step=\"any\" placeholder=\"Quantity\" name=\"quantity\" \nclass=\"m-0 select_box bottom-border text-center\" id=\"{{sell_key +\'_\'+ $index+\'_quantity\'}}\" \nng-change=\"$ctrl.fnChangeBasis(charge, sell_value, $index, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key], \'quantity\',sell_key); $ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'quantity\');\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n</md-input-container><span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_quantityError\'}}\">Please Enter\n</span> <span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index + \'_quantityCharacter\'}}\">Invalid Input</span>\n</td><td ng-if=\"$ctrl.isShowBuyCol && (!$ctrl.editBuyRate || (!charge.manual && !$ctrl.isBuyRateEditable))\" \nclass=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg remove-cursor\"><div class=\"content-border p-8\"><span \nclass=\"pr-20 line-height-17\" \nng-class=\"{\'pl-37\':charge.charge_basis === \' $ctrl.constObj.PICKUP_BASIS\' || charge.charge_basis === $ctrl.constObj.DELIVERY_BASIS || charge.charge_basis === $ctrl.constObj.FREIGHT_BASIS}\" \nng-if=\"!$ctrl.isString($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate)\" \nng-bind=\"charge.charge_basis.includes(\'%\') ? \'%\' : $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].charge_currency\">\n</span> <span ng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-bind=\"$ctrl.fnCheckIsNaN($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], \'per_unit_rate\')\">\n</span> <span ng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type.toUpperCase()!==\'DIRECT\'\" \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].slab[0].cost\"></span></div></td><td \nng-if=\"$ctrl.isShowBuyCol && $ctrl.editBuyRate && (charge.manual || $ctrl.isBuyRateEditable)\" \nclass=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg w-90\"><md-input-container md-no-float \nclass=\"inline-flex content-border pl-5\" id=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\"><span class=\"mt-5 currency-align\">\n<select ng-if=\"!(charge.charge_basis.includes(\'%\'))\" class=\"custom_select text-center\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].charge_currency\" placeholder=\"Currency\" \nclass=\"m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, $index,sell_key, \'buy_currency\');\" \nng-options=\"curr for curr in $ctrl.currencyList\" \nng-model-options=\"{\n                      updateOn: \'default blur onchange\',\n                      debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                    }\">\n</select></span><div class=\"mh-10\" layout=\"row\" layout-align=\"center center\" ng-if=\"charge.charge_basis.includes(\'%\')\">\n%</div><md-input-container md-no-float class=\"inline-flex\"><input \nng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate\" \ntitle=\"{{$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate}}\" \nng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 select_box bottom-border pt-4\" id=\"{{sell_key +\'_\'+$index+\'_buyUnit\'}}\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'buyUnit\')\" \nng-change=\"$ctrl.fnChangeBasis(charge, sell_value, $index, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key], \'quantity\',sell_key);\" \nng-model-options=\"{\n                      updateOn: \'default blur onchange\',\n                      debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                    }\">\n <input ng-readonly=\"!$ctrl.calculateQtyRange(charge, 0)\" \nng-if=\"charge.charge_type==\'SLAB\' &&\n                        charge.slab_type.toUpperCase()!==\'DIRECT\'\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].slab[0].cost\" \ntitle=\"{{$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].slab[0].cost}}\" \nng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 select_box bottom-border pt-4\" id=\"{{sell_key +\'_\'+$index+\'_0_buyUnit\'}}\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'buyUnit\')\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, $index, sell_key)\">\n</md-input-container></md-input-container><span class=\"error-text-position\" \nid=\"{{sell_key +\'_\'+ $index + \'_buyUnitError\'}}\">Please Enter</span> <span class=\"error-text-position\" \nid=\"{{sell_key +\'_\'+ $index + \'_buyUnitCharacter\'}}\">Invalid Input</span></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.isShowBuyCol\" class=\"{{sell_key + $index+\'remove-rates-bg\'}} rates-bg remove-cursor\"><div \nclass=\"content-border p-8\"><span class=\"pr-20 line-height-17\" \nng-if=\"!$ctrl.isString($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].charge_cost) || $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].min_flag || $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index].max_flag\" \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.leg_currency \"></span> <span \nng-bind=\"$ctrl.fnCheckIsNaN($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index])\"></span></div></td><td\n ng-if=\"!$ctrl.quoteEdit\"><div class=\"content-border p-8 remove-cursor\" ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\">\n<span class=\"line-height-17\" ng-class=\"{\'pr-5\':!$ctrl.isShowBuyCol, \'pr-20\':$ctrl.isShowBuyCol}\" \nng-if=\"!$ctrl.isString(charge.per_unit_rate)\" \nng-bind=\"charge.charge_basis.includes(\'%\') ? \'%\' : charge.charge_currency\"></span> <span \nng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-bind=\"$ctrl.fnCheckIsNaN(charge, \'per_unit_rate\')\"></span> <span \nng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type.toUpperCase()!==\'DIRECT\'\" ng-bind=\"charge.slab[0].cost\"></span>\n</div></td><td ng-if=\"$ctrl.quoteEdit\"><md-input-container md-no-float class=\"inline-flex content-border h-36\" \nid=\"{{sell_key +\'_\'+ $index+\'_sellUnit\'}}\"><span ng-if=\"!charge.charge_basis.includes(\'%\')\"><select \nclass=\"font-size-13 custom_select currency-align text-center\" ng-model=\"charge.charge_currency\" placeholder=\"Currency\" \nclass=\"m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index, sell_key, \'sell_currency\');$ctrl.fnTrackAnalytics(\'RateCard-SellRates-Currency-Change\')\" \nng-options=\"curr for curr in $ctrl.currencyList\" \nng-model-options=\"{\n                    updateOn: \'default blur onchange\',\n                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                  }\">\n</select></span><div class=\"mh-10\" layout=\"row\" layout-align=\"center center\" ng-if=\"charge.charge_basis.includes(\'%\')\">\n%</div><md-input-container md-no-float class=\"inline-flex\" \nng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\"><input ng-model=\"charge.per_unit_rate\" \ntitle=\"{{charge.per_unit_rate}}\" ng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'sellUnit\')\" type=\"text\" step=\"any\" \nplaceholder=\"Unit Price\" name=\"unit_price\" class=\"m-0 select_box bottom-border font-size-13 pt-4\" \nid=\"{{sell_key +\'_\'+ $index+\'_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index, sell_key);\" \nng-model-options=\"{\n                    updateOn: \'default blur onchange\',\n                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                  }\">\n</md-input-container><md-input-container md-no-float class=\"inline-flex\" \nng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type.toUpperCase()!==\'DIRECT\'\"><input \nng-readonly=\"!$ctrl.calculateQtyRange(charge, 0)\" \nng-keyup=\"$ctrl.fnChargeValidation(sell_key,sell_value, $index,charge,\'sellUnit\')\" ng-model=\"charge.slab[0].cost\" \ntitle=\"{{charge.slab[0].cost}}\" ng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" \nname=\"unit_price\" class=\"m-0 select_box bottom-border font-size-13 pt-4\" id=\"{{sell_key +\'_\'+$index+\'_0_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index, sell_key);\"></md-input-container>\n</md-input-container><span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_sellUnitError\'}}\">Please Enter\n</span> <span class=\"error-text-position\" id=\"{{sell_key +\'_\'+ $index+\'_sellUnitCharacter\'}}\">Invalid Input</span></td>\n<td rowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border p-8 remove-cursor\" ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\"><span \nng-class=\"{\'pr-5\':!$ctrl.isShowBuyCol, \'pr-20\':$ctrl.isShowBuyCol}\" class=\"line-height-17\" \nng-if=\"!$ctrl.isString(charge.charge_cost) || charge.min_flag || charge.max_flag\" \nng-bind=\"sell_value.rate_obj.leg_currency\"></span> <span ng-bind=\"$ctrl.fnCheckIsNaN(charge)\"></span></div></td><td \nclass=\"text-center\" ng-if=\"!$ctrl.util.isShipper\"><div ng-if=\"!(charge.internal_comments || charge.external_comments)\">\n<md-icon class=\"comments-icon cursor\" md-svg-src=\"assets/icons/custom/add_comment.svg\" title=\"Add\" \nng-click=\"$ctrl.fnOpenCommentPanel($event , charge , $ctrl.quoteEdit , $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index])\">\n</md-icon></div><div ng-if=\"(charge.internal_comments || charge.external_comments)\"><md-icon \nclass=\"comments-icon cursor\" md-svg-src=\"assets/icons/custom/edit_comment.svg\" title=\"Edit\" \nng-click=\"$ctrl.fnOpenCommentPanel($event , charge , $ctrl.quoteEdit, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index])\">\n</md-icon></div></td><td ng-if=\"$ctrl.util.isShipper\"><div><md-icon class=\"comments-icon cursor\" \nmd-svg-src=\"assets/icons/custom/edit_comment.svg\" ng-class=\"{\'disable-state\':(!charge.external_comments )}\" \nng-click=\"$ctrl.fnOpenCommentPanel($event , charge,$ctrl.quoteEdit)\"></md-icon><md-tooltip md-direction=\"top\" \nng-if=\"!charge.external_comments \">No Comments Available</md-tooltip></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.quoteEdit\"><div layout=\"row\"><div><md-icon class=\"s20 cursor pt-7\" \nmd-font-icon=\"icon-minus-circle-outline red-400-fg\" title=\"Remove charge\" \nng-class=\"{\'disable-state\':$ctrl.footerObj.rateExpired}\" \nng-click=\"$ctrl.confirmDeleteCharge(sell_key,sell_value.rate_obj,$index, \'quote\')\" ng-if=\"$ctrl.quoteEdit\"></md-icon>\n<md-tooltip md-direction=\"top\" ng-if=\"$ctrl.footerObj.rateExpired\">This Rate is expired</md-tooltip></div><div><md-icon\n ng-if=\"$last\" class=\"s20 cursor ml-7 pt-7\" md-font-icon=\"icon-plus-circle-outline green-400-fg\" \nng-class=\"{\'disable-state\':$ctrl.footerObj.rateExpired}\" title=\"Add charge\" \nng-click=\"$ctrl.fnAddNewCharge(sell_key,sell_value)\" ng-if=\"$ctrl.quoteEdit\"></md-icon><md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.footerObj.rateExpired\">This Rate is expired</md-tooltip></div></div></td></tr><tr \nid=\"{{sell_key +\'_\'+ $index+\'_row\'}}\" ng-repeat-end=\"(child_key, value) in charge.slab\" \nng-if=\"charge.charge_type===\'SLAB\' && charge.slab[child_key+1] && (charge.slab_type===\'INCREMENTAL\')\"><td><span \nng-if=\"!charge.is_qty_editable\">\n{{charge.total_units == \'\' ? \'-\' : $ctrl.calculateQtyRange(charge, child_key+1) | currencyMask : 2}} | {{charge.slab[child_key+1].from}} - {{charge.slab[child_key+1].to}}\n</span><md-input-container md-no-float class=\"inline-flex bb\" ng-if=\"charge.is_qty_editable\"><input \nng-model=\"charge.total_units\" ng-model-options=\"{ debounce: 100 }\" type=\"number\" step=\"any\" placeholder=\"Quantity\" \nname=\"quantity\" class=\"m-0 select_box bottom-border\" id=\"{{sell_key +\'_\'+ $index+\'_quantity\'}}\" \nng-change=\"$ctrl.fnChangeBasis(charge, sell_value, $index, $ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.currentCard.data.buy_rates[sell_key], \'quantity\',sell_key)\">\n</md-input-container></td><td ng-if=\"!$ctrl.editBuyRate\"><span class=\"pr-20\" \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].charge_currency\"></span> <span \nng-bind=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].slab[child_key+1].cost | currencyMask:2\">\n</span></td><td ng-if=\"$ctrl.editBuyRate\"><md-input-container md-no-float class=\"inline-flex bb\"><span \nclass=\"mt-5 pr-5\"><select class=\"custom_select\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].charge_currency\" placeholder=\"Currency\" \nclass=\"m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key],\n                      $ctrl.currentCard.data.buy_rates[sell_key].rate_obj,\n                      key,sell_key, \'currency\')\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select></span><md-input-container md-no-float class=\"inline-flex\">\n<input ng-readonly=\"!$ctrl.calculateQtyRange(charge, child_key+1)\" \nng-model=\"$ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key].slab[child_key+1].cost\" \nng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 select_box bottom-border\" id=\"{{sell_key +\'_\'+ $parent.$index +\'_\'+ (child_key+1)+\'_buyUnit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.currentCard.data.buy_rates[sell_key].rate_obj.charges[key], $ctrl.currentCard.data.buy_rates[sell_key].rate_obj, key,sell_key)\">\n</md-input-container></md-input-container></td><td ng-if=\"$ctrl.quoteEdit\"><md-input-container md-no-float \nclass=\"inline-flex bb\"><span class=\"mt-5 pr-5\"><select class=\"custom_select\" ng-model=\"charge.charge_currency\" \nplaceholder=\"Currency\" class=\"m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange(charge,\n                      $ctrl.currentCard.data.sell_rates[sell_key].rate_obj,\n                      key,sell_key, \'currency\')\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select></span><md-input-container md-no-float class=\"inline-flex\">\n<input ng-readonly=\"!$ctrl.calculateQtyRange(charge,\n                      child_key+1)\" \nng-model=\"charge.slab[child_key+1].cost\" ng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" \nplaceholder=\"Unit Price\" name=\"unit_price\" class=\"m-0 select_box bottom-border\" \nid=\"{{sell_key +\'_\'+ $parent.$index +\'_\'+ (child_key+1)+\'_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge,\n                      $ctrl.currentCard.data.sell_rates[sell_key].rate_obj,$index\n                      sell_key)\">\n</md-input-container></md-input-container></td></tr></tbody></table></md-content></div><div class=\"overlayLeg hide\" \nid=\"{{sell_key+\'_askDeleteLeg\'}}\"><div class=\"delete-confirmation-div text-center\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"$ctrl.chargeDelete\"><p \nng-if=\"(!$ctrl.is_delete_l3_leg || ($ctrl.is_delete_l3_leg && !$ctrl.search_param.freight_charges))\">\nDelete this {{$ctrl.deleteChargeLineObj.charge_name}} ?</p><p \nng-if=\"$ctrl.is_delete_l3_leg && $ctrl.search_param.freight_charges && $ctrl.currentPage == \'result\'\">\nDeleting this charge will remove this rate card from quotation.</p><p \nng-if=\"$ctrl.is_delete_l3_leg && $ctrl.search_param.freight_charges && $ctrl.currentPage == \'quote\'\">\nYou can not delete this charge.</p></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.legDelete\"><p \nng-if=\"(!$ctrl.is_delete_l3_leg  || ($ctrl.is_delete_l3_leg && !$ctrl.search_param.freight_charges))\">\nDelete this {{$ctrl.deleteLegObj.leg_name}} ?</p><p \nng-if=\"$ctrl.is_delete_l3_leg && $ctrl.search_param.freight_charges && $ctrl.currentPage == \'result\'\">\nDeleting this leg will remove this rate card from quotation.</p><p \nng-if=\"$ctrl.is_delete_l3_leg && $ctrl.search_param.freight_charges &&  $ctrl.currentPage == \'quote\'\">\nYou can not delete this leg.</p></div><div layout=\"row\" layout-align=\"center center\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" \nng-click=\"$ctrl.cancelDelete(sell_key);$ctrl.fnTrackAnalytics(\'RateCard-DeleteLeg-Confirm-No-Click\')\">Close</md-button>\n<md-button md-no-ink ng-if=\"$ctrl.chargeDelete\" class=\"md-accent-btn ml-10\" ng-disabled=\"$ctrl.deleteChargeBtn\" \nng-click=\"$ctrl.fnDeleteNewCharge(sell_key);\">Yes, Delete</md-button><md-button md-no-ink ng-if=\"$ctrl.legDelete\" \nclass=\"md-accent-btn ml-10\" ng-disabled=\"$ctrl.deleteChargeBtn\" \nng-click=\"$ctrl.fnDeleteLeg(sell_key);$ctrl.fnTrackAnalytics(\'RateCard-DeleteLeg-Confirm-Yes-Click\')\">Yes, Delete\n</md-button></div></div></div><div class=\"overlayLeg hide\" id=\"{{sell_key+\'_reloadCurrency\'}}\"><div \nclass=\"replay-icon-div text-center\"><md-icon md-font-icon=\"icon-replay\" class=\"s50 grey-400-fg\"></md-icon></div></div>\n</div><div layout=\"row\" layout-align=\"start center\" ng-if=\"$ctrl.quoteEdit\" class=\"mt-20\" flex=\"100\"><md-button \nlayout=\"row\" md-no-ink class=\"md-link-btn m-0\" title=\"Add Leg\" ng-disabled=\"$ctrl.footerObj.rateExpired\" \nng-click=\"$ctrl.fnAddNewLeg($ctrl.currentCard)\"><div><md-icon md-font-icon=\"icon-plus md-link-fg s20\" \nplaceholder=\"Add leg\"></md-icon></div><div class=\"font-size-13\">Add Leg</div><md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.footerObj.rateExpired\">This Rate is expired</md-tooltip></md-button></div><div \nclass=\"border-shipper leg-border-bottom\" \nng-if=\"($ctrl.util.isShipper || $ctrl.isShared) && $ctrl.allInQuote ==\'legwise_total\'\"><div \nng-repeat=\"(sell_key, sell_value) in $ctrl.currentCard.data.sell_rates track by $index\" \nng-if=\"sell_value.rate_obj && sell_value.rate_obj.charges.length\" id=\"{{sell_key+\'_cardLeg\'}}\"><div layout=\"row\" \nflex=\"100\" layout-align=\"space-between center\" class=\"p-5 height-46\" layout-wrap><div class=\"font-size-13 p-5\" \nng-bind=\"( sell_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : sell_value.leg_name\"></div><div layout=\"row\" \nlayout-align=\"end center\" layout-wrap><div class=\"p-5\" ng-bind=\"sell_value.rate_obj.leg_currency\"></div><div \nclass=\"p-5\" ng-bind=\"sell_value.rate_obj.leg_currency_cost | currencyMask : 2\"></div></div></div></div></div>");
$templateCache.put("app/main/component/refresh-rates/refresh-rates.html","<div layout=\"row\" layout-xs=\"column\"><div flex><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools p-20\"><div>Want to proceed search with this inputs?</div><span flex></span><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"$ctrl.closeDialog();$ctrl.trackEvent(\'Close\')\"><md-icon \nclass=\"fg-AAA8AD cursor\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"m-0\"><form name=\"$ctrl.refreshForm\"><div layout=\"column\" class=\"font-size-16 pr-20 pl-20\">\n<div ng-if=\"$ctrl.isMultiPort || $ctrl.isMultiDoor\" class=\"pb-20\"><div layout=\"row\" class=\"mb-12 h-20\"><span \nclass=\"font-weight-600 font-size-13 form-title mr-12\">Origin</span> <span class=\"margin-t-2 mr-12 font-size-13\"><div \nclass=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\"><button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" ng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'origin\');\">DOOR</button> <button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'origin\');\">\n{{$ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button>\n</div></span><span ng-if=\"$ctrl.viewToggleOrigin==\'port\' && $ctrl.searchParamData.mode==\'SEA-FCL\'\" \nclass=\"checkbox-margin\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.includeSdOrigin\" \nclass=\"md-primary\">Carrier SD Services</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Search for CY (Container Yard) services for all selected carriers.</div><div><span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleOrigin==\'port\'   && $ctrl.searchParamData.mode !=\'AIR\' && $ctrl.enabled_nearby\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParamData.fetch_nearby_origin\" ng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyOrigin\')\" \nclass=\"md-primary\">Include Nearby</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Ignores neighbouring ports when fetching rates.</div><div><span class=\"font-bold\">Checked : </span>\nIncludes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span></div><div \nclass=\"container-wrap serive-mode-origin\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParamData.user_nearby_origin.length ) || $ctrl.refreshForm.$error.samePortError || $ctrl.refreshForm.user_nearby_origin.$error.maxchips), \'b-focus\': originFocused,}\">\n<md-chips md-chip-append-delay=\"3\" name=\"user_nearby_origin\" ng-model=\"$ctrl.searchParamData.user_nearby_origin\" \nmd-no-float class=\"panel-select ph-10 pb-5\" ng-mouseenter=\"focused=true\" \nmd-max-chips=\"{{ $ctrl.is_nXn_search ? $ctrl.originMultiPortPairLimit+1 : $ctrl.multiPortPairLimit + 1}}\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'origin\')\" md-require-match=\"true\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParamData.user_nearby_origin.length ) || $ctrl.refreshForm.$error.samePortError || $ctrl.refreshForm.user_nearby_origin.$error.maxchips), \'b-focus\': originFocused}\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'origin\',destination)\" layout=\"row\"><md-autocomplete \nng-hide=\"$ctrl.isStopOriginPortInput()\" class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin\');$ctrl.trackEvent(\'origin\',fcl_originSearchText)\" \nng-focus=\"focused=true;\n                $ctrl.formIsPristine=false;originFocused=true\" ng-blur=\"originFocused=false\" \nid=\"multi-origin-input\" md-input-name=\"fcl_origin_port\" md-search-text=\"fcl_originSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_originSearchText, $ctrl.searchParamData.mode, \'origin\',\'user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"false\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{($ctrl.viewToggleOrigin==\'door\'? \'Search by Door\' : ($ctrl.searchParamData.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\'))}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"break-word\" flex=\"70\" style=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div ng-show=\"fcl_originSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                         track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span>\n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleOrigin != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParamData.user_nearby_origin.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                ($chip.place_type !== \'Door\' ?\n                ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.searchParamData.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"($ctrl.refreshForm.user_nearby_origin.$error.maxchips)\">\nYou can search multi port up to {{$ctrl.is_nXn_search ? $ctrl.originMultiPortPairLimit : $ctrl.multiPortPairLimit }}.\n</div><div class=\"errors font-size-11\" ng-if=\"$ctrl.checkExistingPort === \'origin\'\"><div>This port already used.</div>\n</div><div class=\"errors font-size-11\" ng-if=\"$ctrl.checkExistingDoor === \'origin\'\"><div>This door already used.</div>\n</div><div class=\"errors font-size-11\" ng-if=\"$ctrl.checkOtherPort === \'origin\'\"><div>\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nng-if=\"$ctrl.viewToggleOrigin ==\'port\' && $ctrl.searchParamData.user_nearby_destination.length>1 && !$ctrl.is_nXn_search  && $ctrl.viewToggleDestination !=\'door\' \">\nYou may only enter one port</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"($ctrl.viewToggleOrigin ==\'port\' && !$ctrl.isMultiPort) || $ctrl.viewToggleOrigin ==\'door\' ||  (($ctrl.searchParamData.user_nearby_destination.length > 1 && !$ctrl.is_nXn_search && $ctrl.viewToggleDestination == \'port\') || $ctrl.viewToggleOrigin == \'door\')\">\n{{$ctrl.searchParamData.user_nearby_origin.length}}/{{$ctrl.is_nXn_search ? $ctrl.originMultiPortPairLimit : $ctrl.multiPortPairLimit }}\n</div><div layout=\"row\" flex layout-align=\"end end\" ng-if=\"$ctrl.viewToggleOrigin ==\'port\' && !$ctrl.isMultiPort\">\n{{$ctrl.searchParamData.user_nearby_origin.length}}/1</div><div \nng-if=\"$ctrl.viewToggleOrigin ==\'door\' && $ctrl.searchParamData.user_nearby_destination.length>1 && !$ctrl.is_door_nXn_search &&  $ctrl.viewToggleDestination !=\'port\' \">\nYou may only enter one port</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"!$ctrl.viewToggleOrigin ==\'door\' || ($ctrl.viewToggleOrigin ==\'door\' && !$ctrl.isMultiDoor) || $ctrl.viewToggleOrigin ==\'port\' ||  (($ctrl.searchParamData.user_nearby_destination.length > 1 && !$ctrl.is_door_nXn_search && $ctrl.viewToggleDestination == \'door\') || $ctrl.viewToggleOrigin == \'port\')\">\n{{$ctrl.searchParamData.user_nearby_origin.length}}/{{$ctrl.is_door_nXn_search ? $ctrl.originMultiDoorLimit : $ctrl.multiDoorLimit }}\n</div><div layout=\"row\" flex layout-align=\"end end\" ng-if=\"$ctrl.viewToggleOrigin ==\'door\' && !$ctrl.isMultiDoor\">\n{{$ctrl.searchParamData.user_nearby_origin.length}}/1</div></div></div><div class=\"mobile_input pb-20\" \nng-if=\"!$ctrl.isMultiPort  && !$ctrl.isMultiDoor\"><div layout=\"row\" class=\"mb-12 h-20\"><span \nclass=\"font-weight-600 font-size-13 form-title mr-12\">Origin</span> <span class=\"margin-t-2 mr-12 font-size-13\"><div \nclass=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\"><button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" ng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'origin\');\">DOOR</button> <button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'origin\');\">\n{{$ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button>\n</div></span><span ng-if=\"$ctrl.viewToggleOrigin==\'port\' && $ctrl.searchParamData.mode==\'SEA-FCL\'\" \nclass=\"checkbox-margin\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.includeSdOrigin\" \nclass=\"md-primary\">Carrier SD Services</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Search for CY (Container Yard) services for all selected carriers.</div><div><span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleOrigin==\'port\'   && $ctrl.searchParamData.mode !=\'AIR\' && $ctrl.enabled_nearby\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParamData.fetch_nearby_origin\" ng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyOrigin\')\" \nclass=\"md-primary\">Include Nearby</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Ignores neighbouring ports when fetching rates.</div><div><span class=\"font-bold\">Checked : </span>\nIncludes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span></div><div \nclass=\"container-wrap serive-mode-origin\" \nng-class=\"{\'red-border\':(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError  || $ctrl.duplicatePortValidation == \'origin_location\') && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused),\'b-focus\': originFocused}\">\n<md-input-container md-no-float class=\"p-0 m-0 panel-select ph-10\" ng-mouseleave=\"focused=false\" \nng-mouseenter=\"focused=true\" md-input-id=\"originLocation\" \nng-class=\"{\'red-border pl-35\':(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError || $ctrl.duplicatePortValidation == \'origin_location\') && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused), \'pl-35\': $ctrl.searchParamData.mode!==\'AIR\', \'b-focus\': originFocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)\" \nmdprefix class=\"mh-5 h-15 w-15 mt-2 ml-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-10 margin-top-6\" \nng-if=\"!$ctrl.searchParamData.origin_location && !(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-icon class=\"icon-size-autocomplete ml-2\" \nmd-svg-src=\"{{ $ctrl.searchParamData.origin_location ?\n               ($ctrl.searchParamData.origin_location.place_type !== \'Door\' ?\n                    ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($ctrl.searchParamData.origin_location.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"$ctrl.searchParamData.origin_location && (!(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.searchParamData.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\" \nng-if=\"(!(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.searchParamData.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin_location\');$ctrl.trackEvent(\'origin\',fcl_originSearchText)\" \nng-focus=\"focused=true; $ctrl.formIsPristine=false;originFocused=true\" ng-blur=\"originFocused=false\" \nng-class=\"{\'placeholder-error\':(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError || $ctrl.duplicatePortValidation == \'origin_location\') && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused),\'disabled\' : $ctrl.searchFromQuote}\" \nrequired id=\"origin-input\" md-input-name=\"fcl_origin_port\" md-selected-item=\"$ctrl.searchParamData.origin_location\" \nmd-search-text=\"fcl_originSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_originSearchText, $ctrl.searchParamData.mode, \'origin\',\'user\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nmd-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{$ctrl.viewToggleOrigin==\'door\'? \'Search by Door\' : ($ctrl.searchParamData.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\')}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_originSearchText.length >=2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                               track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                      track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span>\n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleOrigin != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParamData.origin_location\">\n<div>\n{{$ctrl.searchParamData.origin_location.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.searchParamData.origin_location, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.searchParamData.origin_location, true).join(\', \'):$ctrl.searchParamData.origin_location.location)}}\n</div></md-tooltip><div \nng-if=\"$ctrl.searchParamData.origin_location && $ctrl.searchParamData.origin_location.place_type!==\'Door\' && !focused\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{$ctrl.searchParamData.origin_location.global_port_code || $ctrl.searchParamData.origin_location.portcode_portname}}\n</div><div \nng-if=\"$ctrl.searchParamData.origin_location && $ctrl.searchParamData.origin_location.place_type===\'Door\' && $ctrl.searchParamData.origin_location.pin_code_ui && !focused\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{$ctrl.searchParamData.origin_location.country_code}} - {{$ctrl.searchParamData.origin_location.pin_code_ui}}</span>\n</div></md-input-container></div><div class=\"errors\" ng-if=\"$ctrl.duplicatePortValidation == \'origin_location\'\"><div \nclass=\"font-size-11\">This port already used in destination port.</div></div></div><div ng-if=\"$ctrl.show_origin_port\">\n<span class=\"font-weight-600 font-size-13 form-title\">Origin CY</span><br><div \nclass=\"container-wrap serive-mode-origin-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.polValidation ) || $ctrl.refreshForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_origin_ports\" ng-model=\"$ctrl.searchParamData.user_pol\" md-no-float \nclass=\"panel-select ph-10 pb-5\" ng-mouseenter=\"focused=true;\" md-require-match=\"true\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'origin_location\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.polValidation ) || $ctrl.refreshForm.$error.samePortError), \'b-focus\': originFocused,\'disabled\' : $ctrl.searchFromQuote }\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'originPort\',\'destination port\')\" layout=\"row\"><md-autocomplete \nclass=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin\');$ctrl.trackEvent(\'pol\',fcl_originPortSearchText)\" \nng-focus=\"focused=true; $ctrl.formIsPristine=false;\" ng-blur=\"originFocused=false\" id=\"multi-origin-port-input\" \nmd-input-name=\"origin_port\" md-search-text=\"fcl_originPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(fcl_originPortSearchText, $ctrl.searchParamData.mode, \'origin\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"false\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search by Port\" md-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" \nmd-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originPortSearchText || fcl_originPortSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originPortSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParamData.user_pol.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                  ($chip.place_type !== \'Door\' ?\n                  ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                  \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.searchParamData.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.checkExistingPort === \'originPort\'\"><div>This port already used.</div></div><div \nclass=\"errors font-size-11\" ng-if=\"$ctrl.checkOtherPort === \'originPort\'\"><div>\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\"><div class=\"errors font-size-11\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"($ctrl.refreshForm.nearby_origin_ports.$error.maxchips)\"><md-icon \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">\nNumber of Ports reached maximum limit</div></div><div class=\"md-link-fg font-size-11\" layout=\"row\" flex \nlayout-align=\"end end\"><div ng-class=\"{\'errors\':$ctrl.refreshForm.nearby_origin_ports.$error.maxchips}\">\n{{$ctrl.searchParamData.user_pol.length}}/{{$ctrl.originPortLimit}}</div></div></div></div><div \nng-if=\"$ctrl.searchParamData.fetch_nearby_origin\"><span class=\"font-weight-600 font-size-13 form-title\">\nOrigin Nearby CY</span><br><div class=\"container-wrap serive-mode-origin-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByOriginValidation ) || $ctrl.refreshForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_origin\" ng-model=\"$ctrl.searchParamData.nearby_origin\" md-no-float \nclass=\"panel-select ph-10 pb-5\" ng-mouseenter=\"focused=true;\" md-require-match=\"true\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'nearby_origin\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByOriginValidation ) || $ctrl.refreshForm.$error.samePortError), \'b-focus\': nearByOriginfocused,\'disabled\' : $ctrl.searchFromQuote }\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'nearbyOrigin\',\'nearbyDestination\')\" layout=\"row\">\n<md-autocomplete class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.trackEvent(\'narby_origin\',nearby_originPortSearchText)\" \nng-focus=\"nearByOriginfocused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;\" \nng-blur=\"nearByOriginfocused=false\" id=\"multi-origin-port-input\" md-input-name=\"nearby_origin\" \nmd-search-text=\"nearby_originPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(nearby_originPortSearchText, $ctrl.mode, \'origin\',\'nearby_user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search nearby Port\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"nearByOriginfocused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originPortSearchText || fcl_originPortSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originPortSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParamData.nearby_origin.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                      ($chip.place_type !== \'Door\' ?\n                      ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                      \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.refreshForm.nearby_origin.$error.required || $ctrl.refreshForm.nearby_origin.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.nearby_origin.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.checkExistingPort === \'nearbyOrigin\'\"><div>This port already used.</div></div><div \nclass=\"errors font-size-11\" ng-if=\"$ctrl.checkOtherPort === \'nearbyOrigin\'\"><div>\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\"><div class=\"errors font-size-11\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"($ctrl.refreshForm.nearby_origin.$error.maxchips)\"><md-icon \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">\nNumber of Ports reached maximum limit</div></div><div class=\"md-link-fg font-size-11\" layout=\"row\" flex \nlayout-align=\"end end\"><div ng-class=\"{\'errors\':$ctrl.refreshForm.nearby_origin.$error.maxchips}\">\n{{$ctrl.searchParamData.nearby_origin.length}}/{{$ctrl.originNearbyPortLimit}}</div></div></div></div><div \nng-if=\"$ctrl.isMultiPort || $ctrl.isMultiDoor\" class=\"pb-20\"><div layout=\"row\" class=\"mb-12 h-20\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Destination</span> <span class=\"pl-5 margin-t-2 font-size-13 mr-8\"><div\n class=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\"><button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'destination\');\">\n{{$ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button> \n<button class=\"search-tab-icon-button\" ng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'destination\');\">DOOR</button></div></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\'  && $ctrl.searchParamData.mode==\'SEA-FCL\'\" \nclass=\"checkbox-margin font-size-11\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.includeSdDestination\" class=\"md-primary\">Carrier SD Services</md-checkbox><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\">\n<span class=\"font-bold\">Unchecked:</span> Search for CY (Container Yard) services for all selected carriers.</div><div>\n<span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\' && $ctrl.searchParamData.mode !=\'AIR\' && $ctrl.enabled_nearby\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParamData.fetch_nearby_destination\" \nng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyDestination\')\" class=\"md-primary\">Include Nearby</md-checkbox>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\">\n<span class=\"font-bold\">Unchecked:</span> Ignores neighbouring ports when fetching rates.</div><div><span \nclass=\"font-bold\">Checked : </span>Includes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span>\n</div><div class=\"container-wrap serive-mode-destination\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParamData.user_nearby_destination.length ) || $ctrl.refreshForm.$error.samePortError  || $ctrl.refreshForm.user_nearby_destination.$error.maxchips), \'b-focus\': destinationFocused,}\">\n<md-chips md-chip-append-delay=\"3\" name=\"user_nearby_destination\" \nng-model=\"$ctrl.searchParamData.user_nearby_destination\" md-no-float class=\"panel-select ph-10 pb-5\" \nmd-max-chips=\"{{ $ctrl.is_nXn_search ? $ctrl.destinationMultiPortPairLimit+1 : $ctrl.multiPortPairLimit + 1}}\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'destination\',\'origin\')\" ng-mouseenter=\"focused=true\" \nmd-require-match=\"true\" md-on-remove=\"$ctrl.fnRemovePortChip($chip , \'destination\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParamData.user_nearby_destination.length ) || $ctrl.refreshForm.$error.samePortError  || $ctrl.refreshForm.user_nearby_destination.$error.maxchips), \'b-focus\': destinationFocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\"><md-autocomplete ng-hide=\"$ctrl.isStopDestinationPortInput()\" \nclass=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'destination\');$ctrl.trackEvent(\'destination\',fcl_destinationSearchText)\" \nng-focus=\"focused=true;  $ctrl.formIsPristine=false;destinationFocused=true\" ng-blur=\"destinationFocused=false\" \nid=\"multi-destinatiomn-input\" md-input-name=\"fcl_destination_port\" md-search-text=\"fcl_destinationSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_destinationSearchText, $ctrl.searchParamData.mode, \'destination\',\'user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"false\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{($ctrl.viewToggleDestination==\'door\'? \'Search by Door\' : ($ctrl.searchParamData.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\'))}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"break-word\" flex=\"70\" style=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nlayout-align=\"start center\" style=\"pointer-events: none\"><div ng-show=\"fcl_destinationSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                                 track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                        track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_destinationSearchText)\">\n</span><span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleDestination != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParamData.user_nearby_destination.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                            ($chip.place_type !== \'Door\' ?\n                            ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                            \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.searchParamData.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.refreshForm.user_nearby_destination.$error.maxchips\">\nYou can search multi port up to {{($ctrl.is_nXn_search ? $ctrl.destinationMultiPortPairLimit : $ctrl.multiPortPairLimit)}}.\n</div><div class=\"errors\" ng-if=\"$ctrl.checkExistingPort === \'destination\'\"><div class=\"font-size-11\">\nThis port already used.</div></div><div class=\"errors font-size-11\" ng-if=\"$ctrl.checkExistingDoor === \'destination\'\">\n<div>This door already used.</div></div><div class=\"errors\" ng-if=\"$ctrl.checkOtherPort === \'destination\'\"><div \nclass=\"font-size-11\">This port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" \nclass=\"md-link-fg font-size-11\" \nng-class=\"{\'mb-20\':($ctrl.viewToggleDestination == \'door\' ||( $ctrl.searchParamData.user_nearby_destination[0].place_type===\'Door\' || ($ctrl.searchParamData.user_nearby_origin.length > 1 && !$ctrl.is_nXn_search) || $ctrl.searchParamData.user_nearby_origin[0].place_type===\'Door\')) && !$ctrl.show_destination_port}\">\n<div \nng-if=\"$ctrl.viewToggleDestination ==\'port\' && $ctrl.searchParamData.user_nearby_origin.length > 1 && !$ctrl.is_nXn_search && $ctrl.viewToggleOrigin !=\'door\'  && $ctrl.viewToggleDestination !=\'door\' \">\nYou may only enter one port</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"!$ctrl.viewToggleDestination ==\'port\' || ($ctrl.viewToggleDestination ==\'port\'&& !$ctrl.isMultiPort)||$ctrl.viewToggleDestination ==\'door\' || (($ctrl.searchParamData.user_nearby_origin.length > 1 && !$ctrl.is_nXn_search &&  $ctrl.viewToggleOrigin == \'port\') || $ctrl.viewToggleDestination == \'door\')\">\n{{$ctrl.searchParamData.user_nearby_destination.length}}/{{($ctrl.is_nXn_search ? $ctrl.destinationMultiPortPairLimit : $ctrl.multiPortPairLimit)}}\n</div><div \nng-if=\"$ctrl.viewToggleDestination ==\'door\' &&$ctrl.searchParamData.user_nearby_origin.length > 1 && !$ctrl.is_door_nXn_search && $ctrl.viewToggleOrigin !=\'port\' \">\nYou may only enter one port</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"!$ctrl.viewToggleDestination ==\'door\' ||($ctrl.viewToggleDestination ==\'door\'&& !$ctrl.isMultiDoor)||$ctrl.viewToggleDestination ==\'port\' || (($ctrl.searchParamData.user_nearby_origin.length > 1 && !$ctrl.is_door_nXn_search &&  $ctrl.viewToggleOrigin == \'door\') || $ctrl.viewToggleDestination == \'port\')\">\n{{$ctrl.searchParamData.user_nearby_destination.length}}/{{($ctrl.is_door_nXn_search ? $ctrl.destinationMultiDoorLimit : $ctrl.multiDoorLimit)}}\n</div><div layout=\"row\" flex layout-align=\"end end\" \nng-if=\"$ctrl.viewToggleDestination ==\'port\'&& !$ctrl.isMultiPort && $ctrl.viewToggleDestination ==\'port\'\">\n{{$ctrl.searchParamData.user_nearby_destination.length}}/1</div><div layout=\"row\" flex layout-align=\"end end\" \nng-if=\"$ctrl.viewToggleDestination ==\'door\'&& !$ctrl.isMultiDoor && $ctrl.viewToggleDestination ==\'door\'\">\n{{$ctrl.searchParamData.user_nearby_destination.length}}/1</div></div></div><div class=\"mobile_input pb-20\" \nng-if=\"!$ctrl.isMultiPort  && !$ctrl.isMultiDoor\"><div layout=\"row\" class=\"mb-12 h-20\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Destination</span> <span class=\"pl-5 margin-t-2 mr-8\"><div \nclass=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\"><button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'destination\');\">\n{{$ctrl.searchParamData.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParamData.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button> \n<button class=\"search-tab-icon-button\" ng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'destination\');\">DOOR</button></div></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\'  && $ctrl.searchParamData.mode==\'SEA-FCL\'\" class=\"checkbox-margin\">\n<md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.includeSdDestination\" class=\"md-primary\">\nCarrier SD Services</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" class=\"s16 ml-4 grey-400-fg\">\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Search for CY (Container Yard) services for all selected carriers.</div><div><span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\' && $ctrl.searchParamData.mode !=\'AIR\' && $ctrl.enabled_nearby\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParamData.fetch_nearby_destination\" \nng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyDestination\')\" class=\"md-primary\">Include Nearby</md-checkbox>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\">\n<span class=\"font-bold\">Unchecked:</span> Ignores neighbouring ports when fetching rates.</div><div><span \nclass=\"font-bold\">Checked : </span>Includes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span>\n</div><div class=\"container-wrap serive-mode-destination\" \nng-class=\"{\'red-border\':(($ctrl.refreshForm.fcl_destination_port.$error.required || $ctrl.refreshForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError || $ctrl.duplicatePortValidation == \'destination_location\') && ($ctrl.refreshForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination),\'b-focus\': destinationFocused}\">\n<md-input-container md-no-float class=\"p-0 m-0 panel-select ph-10\" layout=\"row\" layout-align=\"start center\" \nng-mouseleave=\"focusedDestination=false\" ng-mouseenter=\"focusedDestination=true\" \nng-class=\"{\'red-border pl-35\':(($ctrl.refreshForm.fcl_destination_port.$error.required || $ctrl.refreshForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError || $ctrl.duplicatePortValidation == \'destination_location\') && ($ctrl.refreshForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination), \'pl-35\': $ctrl.searchParamData.mode!==\'AIR\', \'b-focus\': destinationFocused,\'disabled\' : $ctrl.searchFromQuote}\">\n<md-icon \nng-if=\"(($ctrl.refreshForm.fcl_destination_port.$error.required || $ctrl.refreshForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)\" \nmdprefix class=\"mh-5 h-15 w-15 ml-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-10 margin-top-6\" \nng-if=\"!$ctrl.searchParamData.destination_location && !(($ctrl.refreshForm.fcl_destination_port.$error.required || $ctrl.refreshForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-icon class=\"icon-size-autocomplete ml-2\" \nmd-svg-src=\"{{ $ctrl.searchParamData.destination_location ?\n                     ($ctrl.searchParamData.destination_location.place_type !== \'Door\' ?\n                      ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($ctrl.searchParamData.destination_location.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) : \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"$ctrl.searchParamData.destination_location && (!(($ctrl.refreshForm.fcl_destination_port.$error.required || $ctrl.refreshForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)) && $ctrl.searchParamData.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\" \nng-if=\"(!(($ctrl.refreshForm.fcl_destination_port.$error.required || $ctrl.refreshForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)) && $ctrl.searchParamData.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" required \nid=\"destination-input\" ng-focus=\"focusedDestination=true; $ctrl.formIsPristine=false;destinationFocused=true\" \nng-blur=\"destinationFocused=false\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'destination_location\');$ctrl.trackEvent(\'destination\',fcl_destinationSearchText)\" \nmd-input-name=\"fcl_destination_port\" md-selected-item=\"$ctrl.searchParamData.destination_location\" \nng-class=\"{\'placeholder-error\':(($ctrl.refreshForm.fcl_destination_port.$error.required || $ctrl.refreshForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError || $ctrl.duplicatePortValidation == \'destination_location\') && ($ctrl.refreshForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination),\'disabled\' : $ctrl.searchFromQuote}\" \nmd-search-text=\"fcl_destinationSearchText\" md-input-id=\"destinationLocation\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_destinationSearchText, $ctrl.searchParamData.mode, \'destination\',\'user\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nplaceholder=\"{{$ctrl.viewToggleDestination==\'door\'? \'Search by Door\' : ($ctrl.searchParamData.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\')}}\" \nmd-menu-class=\"autocomplete-custom-template-search\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"focusedDestination\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port  && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_destinationSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                               track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                      track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_destinationSearchText)\">\n</span><span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleDestination != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" \nng-if=\"$ctrl.searchParamData.destination_location\"><div>\n{{$ctrl.searchParamData.destination_location.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.searchParamData.destination_location, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.searchParamData.destination_location, true).join(\',\'):$ctrl.searchParamData.destination_location.location)}}\n</div></md-tooltip><div \nng-if=\"$ctrl.searchParamData.destination_location && $ctrl.searchParamData.destination_location.place_type!==\'Door\' && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{$ctrl.searchParamData.destination_location.global_port_code || $ctrl.searchParamData.destination_location.portcode_portname}}\n</div><div \nng-if=\"$ctrl.searchParamData.destination_location && $ctrl.searchParamData.destination_location.place_type===\'Door\' && $ctrl.searchParamData.destination_location.pin_code_ui && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{$ctrl.searchParamData.destination_location.country_code}} - {{$ctrl.searchParamData.destination_location.pin_code_ui}}\n</span></div></md-input-container></div><div class=\"errors\" \nng-if=\"$ctrl.duplicatePortValidation == \'destination_location\'\"><div class=\"font-size-11\">\nThis port already used in origin port.</div></div></div><div ng-if=\"$ctrl.show_destination_port\"><span \nclass=\"font-weight-600 font-size-11 form-title\">Destination CY</span><br><div \nclass=\"container-wrap serive-mode-destination-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.podValidation ) || $ctrl.refreshForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_destination_ports\" ng-model=\"$ctrl.searchParamData.user_pod\" \nmd-no-float class=\"panel-select ph-10 pb-5\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'destinationPort\' , \'origin port\')\" ng-mouseenter=\"focused=true\" \nmd-require-match=\"true\" md-on-remove=\"$ctrl.fnRemovePortChip($chip , \'destination_location\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.podValidation ) || $ctrl.refreshForm.$error.samePortError), \'b-focus\': destinationFocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\"><md-autocomplete class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'destination\');$ctrl.trackEvent(\'pod\',fcl_destinationPortSearchText)\" \nng-focus=\"focused=true; $ctrl.formIsPristine=false;\" ng-blur=\"destinationFocused=false\" id=\"multi-destinatiomn-input\" \nmd-input-name=\"destination_port\" md-search-text=\"fcl_destinationPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(fcl_destinationPortSearchText, $ctrl.searchParamData.mode, \'destination\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"false\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search by Port\" md-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" \nmd-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port &&  fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\'  && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationPortSearchText || fcl_destinationPortSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationPortSearchText)\">\n</div><div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}\n</div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span>\n</div></div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.\n</div></md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip \nmd-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParamData.user_pod.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                      ($chip.place_type !== \'Door\' ?\n                      ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                      \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.refreshForm.fcl_origin_port.$error.required || $ctrl.refreshForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.searchParamData.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.refreshForm.user_nearby_destination.$error.maxchips\">\nYou can search multi port up to {{$ctrl.multiPortPairLimit}}.</div><div class=\"errors\" \nng-if=\"$ctrl.checkExistingPort === \'destinationPort\'\"><div class=\"font-size-11\">This port already used.</div></div><div\n class=\"errors\" ng-if=\"$ctrl.checkOtherPort === \'destinationPort\'\"><div class=\"font-size-11\">\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nclass=\"errors font-size-11\" layout=\"row\" layout-align=\"center center\" \nng-if=\"($ctrl.refreshForm.nearby_destination_ports.$error.maxchips)\"><md-icon class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">Number of Ports reached maximum limit\n</div></div><div layout=\"row\" flex layout-align=\"end end\" \nng-class=\"{\'errors\':$ctrl.refreshForm.nearby_destination_ports.$error.maxchips}\">\n{{$ctrl.searchParamData.user_pod.length}}/{{$ctrl.destinationPortLimit}}</div></div></div><div \nng-if=\"$ctrl.searchParamData.fetch_nearby_destination\"><span class=\"font-weight-600 font-size-11 form-title\">\nDestination Nearby CY</span><br><div class=\"container-wrap serive-mode-destination-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByDestinationValidation ) || $ctrl.refreshForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_destination\" ng-model=\"$ctrl.searchParamData.nearby_destination\" \nmd-no-float class=\"panel-select ph-10 pb-5\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'nearbyDestination\' , \'nearbyOrigin\')\" \nng-mouseenter=\"nearByDestinationfocused=true\" md-require-match=\"true\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'nearby_destination\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByDestinationValidation ) || $ctrl.refreshForm.$error.samePortError), \'b-focus\': nearByDestinationfocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\"><md-autocomplete class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.trackEvent(\'pod\',nearby_destinationPortSearchText)\" \nng-focus=\"nearByDestinationfocused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;\" \nng-blur=\"nearByDestinationfocused=false\" id=\"multi-destinatiomn-input\" md-input-name=\"nearby_destination\" \nmd-search-text=\"nearby_destinationPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(nearby_destinationPortSearchText, $ctrl.mode, \'destination\',\'nearby_user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search nearby Port\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port &&  fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParamData.mode===\'SEA-LCL\'  && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationPortSearchText || fcl_destinationPortSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationPortSearchText)\">\n</div><div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}\n</div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span>\n</div></div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.\n</div></md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip \nmd-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParamData.nearby_destination.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                       ($chip.place_type !== \'Door\' ?\n                       ($ctrl.searchParamData.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                       \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.refreshForm.nearby_destination.$error.required || $ctrl.refreshForm.nearby_destination.$error[\'md-require-match\'] || $ctrl.refreshForm.$error.samePortError) && ($ctrl.refreshForm.nearby_destination.$dirty || $ctrl.formSubmit) && !nearByDestinationfocused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.refreshForm.nearby_destination.$error.maxchips\">\nYou can search multi port up to {{$ctrl.destinationNearbyPortLimit}}.</div><div class=\"errors\" \nng-if=\"$ctrl.checkExistingPort === \'nearbyDestination\'\"><div class=\"font-size-11\">This port already used.</div></div>\n<div class=\"errors\" ng-if=\"$ctrl.checkOtherPort === \'nearbyDestination\'\"><div class=\"font-size-11\">\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nclass=\"errors font-size-11\" layout=\"row\" layout-align=\"center center\" \nng-if=\"($ctrl.refreshForm.nearby_destination.$error.maxchips)\"><md-icon class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">Number of Ports reached maximum limit\n</div></div><div layout=\"row\" flex layout-align=\"end end\" \nng-class=\"{\'errors\':$ctrl.refreshForm.nearby_destination.$error.maxchips}\">\n{{$ctrl.searchParamData.nearby_destination.length}}/{{$ctrl.destinationNearbyPortLimit}}</div></div></div><div \nclass=\"pb-20\" layout=\"row\" layout-align=\"start between start\" layout-wrap><div class=\"pr-10 flex-35\"><span \nclass=\"font-weight-600 font-size-14\">Cut Off Date</span><br><div class=\"h-36\"><div \nclass=\"panel-select pointer mobile_input\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'red-border\':(!$ctrl.searchParamData.cargo_ready_date && !$ctrl.minDate) || $ctrl.cargoDateValidation  }\" \nng-click=\"$ctrl.openDatePicker=true\"><div style=\"background-image: url(\'assets/icons/custom/search-bar/date.svg\')\" \nclass=\"icon-bg\" ng-if=\"$ctrl.searchParamData.cargo_ready_date || $ctrl.minDate\"></div><md-icon class=\"mh-10 h-15 w-15\" \nng-if=\"!$ctrl.searchParamData.cargo_ready_date && !$ctrl.minDate \" md-svg-src=\"assets/icons/custom/warning-icon.svg\">\n</md-icon><md-datepicker id=\"date-picker-search\" name=\"cargo_ready_date\" md-min-date=\"$ctrl.minDate\" \nng-init=\"$ctrl.searchParamData.cargo_ready_date = $ctrl.searchParamData.cargo_ready_date || $ctrl.minDate\" \nng-model=\"$ctrl.searchParamData.cargo_ready_date\" md-placeholder=\"Select a Date\" md-is-open=\"$ctrl.openDatePicker\" \nonkeydown=\"return false\" md-open-on-focus md-hide-icons=\"all\" class=\"pl-5 pt-5 font-size-13 text-truncate\" required \nng-change=\"$ctrl.trackEvent(\'RR-CutOffChange\');$ctrl.cargoDateValidation = false \"></md-datepicker><md-tooltip \nmd-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><span>\n{{$ctrl.searchParamData.cargo_ready_date ? ($ctrl.searchParamData.cargo_ready_date | date : \'dd MMM yyyy\' ): ($ctrl.minDate | date : \'dd MMM yyyy\')}}\n</span></md-tooltip></div><span ng-if=\"$ctrl.cargoDateValidation\" class=\"validation-error-text\">\nIt should be later than today\'s date</span></div></div><div class=\"pr-10 flex-30\"><span \nclass=\"font-weight-600 font-size-14\">Load Type<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s18 ml-5 pointer load-alias grey-400-fg\" ng-mouseover=\"$ctrl.showLoadAlias($event);$ctrl.trackEvent(\'panel\')\">\n</md-icon></span><br><div class=\"h-36 disabled\"><div class=\"panel-select panel-select-load pointer mobile_input\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/load_type.svg\')\" class=\"icon-bg\" \nng-if=\"!($ctrl.refreshForm.$error.loadError)\"></div><div truncate=\"{{$ctrl.loadString}}\" \nclass=\"mt-2 font-size-13 pv-5 hide-overflow text-truncate\">{{$ctrl.loadString}}<md-tooltip ng-if=\"$ctrl.loadString\" \nmd-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><span>{{$ctrl.loadString}}</span></md-tooltip></div></div></div></div>\n</div><div class=\"flex-35\"><span class=\"font-weight-600 font-size-14\">Sales Person</span><br><div \nclass=\"h-36 disabled\"><div class=\"panel-select ph-10\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/sales_person_icon.svg\')\" class=\"icon-bg h-35\" \nng-if=\"!($ctrl.refreshForm.salesperson.$error.required)\"></div><div class=\"text-capitalize text-truncate font-size-13\" \nng-value=\"$ctrl.searchParamData.sales_user\">\n{{$ctrl.searchParamData.sales_user.user_first_name ? $ctrl.searchParamData.sales_user.user_first_name : \'N/A\'}} {{$ctrl.searchParamData.sales_user.user_last_name ? $ctrl.searchParamData.sales_user.user_last_name : \'\'}}\n<md-tooltip ng-if=\"$ctrl.searchParamData.sales_user\" md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><span>\n{{$ctrl.searchParamData.sales_user.user_first_name ? $ctrl.searchParamData.sales_user.user_first_name : \'N/A\'}} {{$ctrl.searchParamData.sales_user.user_last_name ? $ctrl.searchParamData.sales_user.user_last_name : \'\'}}\n</span></md-tooltip></div></div></div></div></div></div><div class=\"pb-20\" layout=\"row\" \nlayout-align=\"space-between-center\" layout-wrap><div class=\"pr-10 flex-65 mt-0\"><span \nclass=\"font-weight-600 font-size-14\">Locals & Custom Charges / Incoterms</span><br><md-input-container md-no-float \nclass=\"w-100-p panel-select\"><div class=\"disabled\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nlayout=\"row\" layout-align=\"start center\" flex=\"80\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/charges.svg\')\" class=\"icon-bg\"></div><div \ntruncate=\"{{$ctrl.detailBoxString}}\" class=\"pv-5 hide-overflow text-truncate font-size-13\">\n{{$ctrl.detailBoxString ? $ctrl.detailBoxString : \'Locals & Custom Charges\'}}<md-tooltip ng-if=\"$ctrl.detailBoxString\" \nmd-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.detailBoxTooltip}}</span>\n</md-tooltip></div></div></div></md-input-container></div><div class=\"flex-35\"><span \nclass=\"font-weight-600 font-size-14\">Customer Details</span><br><div class=\"disabled radius-border h-36\">\n<md-input-container ng-mouseleave=\"focusedCust=false\" ng-mouseenter=\"focusedCust=true\" md-no-float \nclass=\"panel-select hide-overflow\" flex=\"100\" layout=\"row\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/customer_details_icon.svg\')\" class=\"icon-bg h-35\" \nng-if=\"!($ctrl.refreshForm.shipperName.$error.required)\"></div><div class=\"font-size-13 pt-10 pb-5\"><div \nclass=\"ellipsis-150 text-capitalize\" ng-if=\"$ctrl.searchParamData.shipper_user\" \ntitle=\"{{$ctrl.searchParamData.shipper_user.user_first_name}} {{$ctrl.searchParamData.shipper_user.user_last_name}}\">\n{{$ctrl.searchParamData.shipper_user.company.company_name}}, {{$ctrl.searchParamData.shipper_user.user_first_name}} {{$ctrl.searchParamData.shipper_user.user_last_name}}\n<md-tooltip ng-if=\"$ctrl.searchParamData.shipper_user\" md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><span>\n<span class=\"font-size-11\">{{$ctrl.searchParamData.shipper_user.company.company_name}} , </span>\n{{$ctrl.searchParamData.shipper_user.user_first_name}} {{$ctrl.searchParamData.shipper_user.user_last_name}}</span>\n</md-tooltip></div><div class=\"sub-heading\" ng-if=\"!$ctrl.searchParamData.shipper_user\">N/A</div></div>\n</md-input-container></div></div></div><div layout=\"row\" layout-align=\"space-between-start\" layout-wrap><div \nclass=\"pr-10 flex-65\"><span class=\"font-weight-600 font-size-14 form-title\">Search Reference Name<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">Your search will be saved by the below given name</md-tooltip></md-icon></span><br>\n<md-input-container md-no-float class=\"p-0 m-0 panel-select disabled\" layout=\"row\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/search_reference_icon.svg\')\" class=\"icon-bg h-35 ml-5\" \nng-if=\"!($ctrl.refreshForm.search_name.$error.required)\"></div><span class=\"pt-10 pl-5 text-truncate\">\n{{$ctrl.searchParamData.search_name ? $ctrl.searchParamData.search_name : \'Search Reference Name\'}}</span><md-tooltip \nng-if=\"$ctrl.searchParamData.search_name\" md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><span>\n{{$ctrl.searchParamData.search_name}}</span></md-tooltip></md-input-container></div><div class=\"flex-35\"><span \nclass=\"font-weight-600 font-size-14\">Search Currency</span><br><div class=\"radius-border\"><md-input-container \nmd-no-float class=\"w-100-p panel-select disabled\"><div truncate=\"{{$ctrl.searchParamData.search_currency}}\" \nclass=\"pv-5 pl-20 mt-5 hide-overflow text-truncate font-size-13\">{{$ctrl.searchParamData.search_currency}}<md-tooltip \nng-if=\"$ctrl.searchParamData.search_currency\" md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><span>\n{{$ctrl.searchParamData.search_currency}}</span></md-tooltip></div></md-input-container></div></div></div></div></form>\n</md-dialog-content><md-dialog-actions class=\"footer\"><div layout=\"row\" layout-align=\"end end\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"$ctrl.closeDialog();$ctrl.trackEvent(\'Cancel\')\" title=\"Cancel\">No, Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" title=\"Yes, Send\" \nng-click=\"$ctrl.rateRefresh();$ctrl.trackEvent(\'Proceed\')\">Proceed</md-button></div></md-dialog-actions></div></div>");
$templateCache.put("app/main/component/result-card/button-result-card.html","<div md-no-ink class=\"md-link-fg link-button Font-Bold mh-0\" \nng-if=\"!$ctrl.carddata.meta.is_selected && !$ctrl.resultfilter.hideBookBtn && !$ctrl.carddata.meta.isError\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'quotation\', $ctrl.carddata.meta.type,false)\">View Details\n</div><div ng-if=\"!$ctrl.carddata.meta.is_selected && !$ctrl.resultfilter.hideBookBtn && $ctrl.carddata.meta.isError\" \nlayout=\"row\"><div class=\"disabled-btn\">View Detail</div><md-icon md-font-icon=\"icon-alert\" \nng-click=\"$ctrl.ShowNoRatesInfo($event, $ctrl.carddata._id, $ctrl.carddata.meta.error)\" \nclass=\"s14 pl-5 pr-5 orange-400-fg noRates-{{$ctrl.carddata._id}}\"></md-icon></div><div md-no-ink \nclass=\"md-link-fg link-button Font-Bold mh-0\" \nng-if=\"$ctrl.util.navPermission.quotes[0] && !$ctrl.carddata.meta.is_selected && $ctrl.resultfilter.hideBookBtn && !$ctrl.carddata.meta.isError\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type,false)\">+ Add to quote\n</div><div \nng-if=\"$ctrl.util.navPermission.quotes[0] && !$ctrl.carddata.meta.is_selected && $ctrl.resultfilter.hideBookBtn && $ctrl.carddata.meta.isError\" \nclass=\"disabled-btn\">+ Add to quote</div><md-button title=\"Edit Quote\" md-no-ink \nclass=\"edit-md-accent-btn with-icon w-35 h-35 m-0\" aria-label=\"Edit\" ng-if=\"$ctrl.carddata.meta.is_selected\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s15 m-0 mr-3\"></md-icon></md-button><md-button title=\"Delete Quote\" md-no-ink \nclass=\"delete-md-btn remove_card_btn w-35 h-35 mr-0\" aria-label=\"Delete\" ng-if=\"$ctrl.carddata.meta.is_selected\" \nng-click=\"$ctrl.showRemoveConfirmationPopup($ctrl.carddata, $event)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s15 remove-icon m-0 mr-3\"></md-icon></md-button>");
$templateCache.put("app/main/component/result-card/customCard.html","<ms-widget class=\"card-list w-300\" flippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front \nng-style=\"{\'min-height\' : $ctrl.getWidgetHeight()}\"><div class=\"card-view m-5 white-bg p-20\" layout=\"column\" \nlayout-align=\"center center\"><img src=\"assets/icons/custom/files_and_folder.jpg\" class=\"mv-25 w-130\"><div \nclass=\"text-center\"><div class=\"font-weight-900 get_own_rates mt-15 mb-8\">Got your own Rates ?</div><div \nclass=\"grey-fg font-weight-600 font-size-12 mb-20\">Create your own personalised rate cards by <b>adding rates manually\n</b></div><div class=\"font-size-12 font-weight-900 margin-gap\">What are you waiting for ?</div><div class=\"mt-8 mb-35\">\n<span class=\"get_started\" ng-click=\"$ctrl.fnAddNewCard();flipWidget()\">GET STARTED</span></div></div></div>\n</ms-widget-front><ms-widget-back ng-if=\"vm.util.solution_type == \'WLS\'\"><div class=\"custom-add-back new_card_back\">\n<div layout=\"row\" flex=\"100\" class=\"white-bg fg-333333\"><div class=\"font-size-16 p-10\" flex=\"80\">ADD <b>NEW</b> RATE\n</div><div layout=\"row\" flex=\"20\" layout-align=\"end center\"><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></md-button>\n</div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10\"><div class=\"grey-fg mr-5\" layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"$ctrl.search_param.mode != \'AIR\'\">Liner</span><span \nng-if=\"$ctrl.search_param.mode == \'AIR\'\">Airline</span> Name <span class=\"red-fg\">*</span></div><div flex layout=\"row\" \nlayout-align=\"end end\"><md-input-container class=\"sort_input m-0 text-truncate\" md-no-float><md-select \nclass=\"liner_dropdown\" ng-if=\"$ctrl.search_param.mode != \'AIR\'\" \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor_id\" name=\"sub_vendor_id\" \nplaceholder=\"Select Liner Name\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.quoteNewCard.meta, $ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)\" \nmd-on-close=\"searchLiner = \'\'\"><md-select-header><input ng-model=\"searchLiner\" type=\"search\" \nplaceholder=\"Search Liner\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"subvendor in $ctrl.getSubvendor | orderBy:\'name\' | filter : searchLiner \" ng-value=\"subvendor.id\">\n{{subvendor.name}}</md-option></md-select><md-select class=\"liner_dropdown\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\" \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline_code\" name=\"airline_code\" \nplaceholder=\"Select Airline Name\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.quoteNewCard.meta,$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)\" \nmd-on-close=\"search_airline_liner = \'\'\"><md-select-header><input ng-model=\"search_airline_liner\" type=\"search\" \nplaceholder=\"Search Liner\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"airline in $ctrl.getAirline | orderBy:\'air_line_name\' | filter : search_airline_liner\" \nng-value=\"airline.airline_code\">{{airline.air_line_name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"font-weight-600 mr-10 ph-10 mt-5\"><div flex=\"50\" class=\"grey-fg\" layout=\"row\" \nlayout-align=\"start center\">Expiry Date <span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"exp_date\"><md-datepicker id=\"cardDatePicker\" name=\"expiryDate\" \nmd-min-date=\"$ctrl.expMaxDate\" ng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\" \nmd-placeholder=\"Expiry Date\" md-is-open=\"$ctrl.openDatePicker\" onkeydown=\"return false\" md-open-on-focus \nmd-hide-icons=\"all\" flex class=\"pv-5 pl-15\"></md-datepicker><div class=\"expiry-date font-weight-600 grey-500-fg\" \nng-class=\"{\'black-fg\' : $ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry}\" \nng-bind=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry ? ($ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry  |  date : \'dd/MM/yyyy\') : \'Expiry Date\'\" \nng-click=\"$ctrl.openDatePicker=true\"></div><md-icon md-font-icon=\"icon-menu-down\" class=\"s16 pointer font-weight-600\" \nng-click=\"$ctrl.openDatePicker=true\"></md-icon></div></div><div \nng-if=\"$ctrl.search_param.mode != \'AIR\' && ($ctrl.quoteNewCard.meta.port_data.is_icd_port_origin || $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination)\">\n<div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mv-5\" \nng-if=\"$ctrl.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" class=\"grey-fg\" layout=\"row\" \nlayout-align=\"start center\">Port of Loading<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"card-autocomplete\"><md-autocomplete required md-input-name=\"card_origin_port\" \nmd-selected-item=\"$ctrl.quoteNewCard.meta.via_pol\" md-search-text=\"$ctrl.card_originSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originSearchText, $ctrl.search_param.mode != \'AIR\' ? \'SEA\': \'AIR\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter Loading Port\" md-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span \nclass=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_originSearchText}}\" were found.</md-not-found><div \nng-messages=\"card_origin_port.$error\"><div ng-message=\"required\">This field is required</div></div></md-autocomplete>\n</div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mb-5\" \nng-if=\"$ctrl.quoteNewCard.meta.port_data.is_icd_port_destination\"><div flex=\"50\" class=\"grey-fg\" layout=\"row\" \nlayout-align=\"start center\">Port of Discharge<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"card-autocomplete\"><md-autocomplete required md-input-name=\"card_destination_port\" \nmd-selected-item=\"$ctrl.quoteNewCard.meta.via_pod\" md-search-text=\"$ctrl.card_destinationSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationSearchText,$ctrl.search_param.mode != \'AIR\' ? \'SEA\': \'AIR\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter Destination Port\" md-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span \nclass=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_destinationSearchText}}\" were found.</md-not-found><div \nng-messages=\"cardSearchForm.card_destination_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mb-5\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" \nclass=\"grey-fg\" layout=\"row\" layout-align=\"start center\">Mode of Origin Haulage<span class=\"red-fg\">*</span></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end end\"><md-select class=\"liner_dropdown m-0\" \nng-model=\"$ctrl.quoteNewCard.meta.haulage\" name=\"haulage\" placeholder=\"Select Origin Haulage\"><md-option \nng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></div></div><div \nlayout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mb-5\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination\"><div \nflex=\"50\" class=\"grey-fg\" layout=\"row\" layout-align=\"start center\">Mode of Destination Haulage<span class=\"red-fg\">*\n</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-select class=\"liner_dropdown m-0\" \nng-model=\"$ctrl.quoteNewCard.meta.destination_haulage\" name=\"haulage\" placeholder=\"Select Destination Haulage\">\n<md-option ng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></div>\n</div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 grey-200-bg mt-8 pt-8\"><div flex=\"50\" \nclass=\"grey-fg pl-10\" layout=\"row\" layout-align=\"start center\">Rates By</div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"pr-20\">\n{{$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name}}</div></div><div layout=\"row\" \nflex=\"100\" class=\"font-weight-600 grey-200-bg\"><div flex=\"50\" class=\"grey-fg pl-10\" layout=\"row\" \nlayout-align=\"start center\">Service Type</div><div flex=\"50\" layout=\"row\" layout-align=\"end end\" class=\"pr-10\">\n<md-input-container class=\"sort_input m-0 h-45\" md-no-float><input \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type\" placeholder=\"Service Type\">\n</md-input-container></div></div><div layout=\"column\" flex=\"100\" class=\"p-10\" ng-if=\"!$ctrl.sell_rates_display\"><div \nlayout=\"row\" flex=\"100\" class=\"mb-10\"><div flex=\"35\" class=\"grey-fg font-weight-600\">Rates</div><div layout=\"row\" flex \nlayout-align=\"end end\" class=\"grey-fg font-size-11\">Change this at any instance</div></div><md-button md-no-ink \nclass=\"md-link-btn\" flex=\"100\" ng-click=\"$ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'addNewQuote\',\'msr_rates\')\">\nAdd Rates</md-button></div><div ng-if=\"$ctrl.sell_rates_display\"><div layout=\"row\" layout-wrap class=\"pv-8 ph-15\" \nng-repeat=\"(leg_key,leg_value) in $ctrl.quoteNewCard.data[$ctrl.buyOrSell]\" \nng-class=\"{\'h-50\' : leg_key == $ctrl.l3_leg }\"><div layout=\"column\" layout-align=\"center start\" flex=\"60\" \nflex-gt-xs=\"60\" ng-class=\"{\'text-truncate\' : leg_key != $ctrl.l3_leg}\"><span class=\"font-size-14 pr-2\" \nng-class=\"{\'text-truncate\' : leg_key == $ctrl.l3_leg}\"><md-icon class=\"icon-class\" \nmd-svg-src=\"{{ ( leg_key == $ctrl.l1_leg || leg_key == $ctrl.l2_leg || leg_key == $ctrl.l2_leg_cha || leg_key == $ctrl.l3_leg || leg_key == $ctrl.l4_leg || leg_key == $ctrl.l4_leg_cha || leg_key == $ctrl.l5_leg || leg_key == $ctrl.ins_leg ) ? \'assets/icons/custom/\' + leg_key +\'_card.svg\' : \'assets/icons/custom/l3_fcl-icon.svg\' }}\">\n</md-icon>\n{{ ( leg_key == $ctrl.l3_leg && leg_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : leg_value.leg_name }} <span\n \nng-if=\"leg_key == $ctrl.l3_leg && leg_value.rate_obj.is_special && (leg_value.rate_obj.special_meta.normal_rate_total != undefined)\">\n<md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></span></span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"40\" flex-gt-xs=\"40\"><span \nclass=\"leg-cost-right text-truncate pr-2 font-size-14 font-weight-600 grey-800-fg\" \nng-class=\"{\'red-600-fg\' : (!leg_value.rate_obj), \'freight-fg\' : (leg_key == $ctrl.l3_leg), \'grey-800-fg\' : (leg_key != $ctrl.l3_leg)}\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask : 2) ) : \'N/A\' }}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask : 2) ) : \'NA\' }}\n</md-tooltip></span><span class=\"leg-cost-right pr-2 grey-500-fg font-weight-500 font-size-12 text-truncate\" \nng-if=\"leg_key == $ctrl.l3_leg && leg_value.rate_obj.is_special && (leg_value.rate_obj.special_meta.normal_rate_total != undefined)\">\n<strike>{{leg_value.rate_obj.leg_currency}} {{leg_value.rate_obj.special_meta.normal_rate_total | currencyMask : 2}}\n</strike></span></div></div></div><md-divider class=\"m-8\"></md-divider><div ng-show=\"$ctrl.search_param.mode == \'AIR\'\">\n<div layout=\"row\" layout-wrap class=\"pv-20\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\"><div \nclass=\"pl-15 font-size-16 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\"><p \ntitle=\"Schedule not available\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\" class=\"grey-fg mv-4\">\nSchedule not available.</p></div></div></div><div ng-show=\"$ctrl.search_param.mode !=\'AIR\'\"><div layout=\"column\" \nflex=\"100\" class=\"p-10\" ng-if=\"!$ctrl.schedule_display\"><div layout=\"row\" flex=\"100\" class=\"mb-10\"><div flex=\"30\" \nclass=\"grey-fg font-weight-600\">Schedule</div><div layout=\"row\" flex layout-align=\"end end\" \nclass=\"grey-fg font-size-11\">Always stay on time</div></div><md-button md-no-ink class=\"md-link-btn\" flex=\"100\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'schedule\',\'msr_rates\')\">Add Schedule</md-button></div><div \nng-if=\"$ctrl.schedule_display\"><div layout=\"row\" layout-wrap class=\"pv-8\" \nng-if=\"$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\"><div class=\"font-size-14\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\"><span class=\"ph-15 text-truncate\"><md-icon \nmd-svg-src=\"assets/icons/custom/shipping-details-icon.svg\" class=\"icon-class\" title=\"Routing\"></md-icon><span>\n{{$ctrl.quoteNewCard.meta.selected_schedule.via_port != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{$ctrl.quoteNewCard.meta.selected_schedule.via_port != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n</md-tooltip></span></span></div><div class=\"pr-15 font-size-14\" layout=\"row\" layout-align=\"end center\" flex=\"40\" \nflex-gt-xs=\"40\"><span class=\"text-truncate\"><md-icon md-svg-src=\"assets/icons/custom/valid-icon.svg\" \nclass=\"icon-class\" title=\"Transit Time\"></md-icon>\n{{ $ctrl.quoteNewCard.meta.selected_schedule.transit_time != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.transit_time : \'N/A\' }}\n</span></div></div><div layout=\"row\" layout-wrap class=\"pv-8\" \nng-if=\"$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\"><div \nclass=\"pl-15 font-size-14 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"40\" flex-gt-xs=\"40\"><span \nclass=\"font-size-14\">Next sailing on</span></div><div class=\"font-size-14\" layout=\"row\" layout-align=\"end center\" \nflex=\"60\" flex-gt-xs=\"60\"><span title=\"Departure Time\" class=\"pr-15 text-truncate\">\n{{$ctrl.quoteNewCard.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy\'}}</span></div></div><div \nlayout=\"row\" layout-wrap class=\"pv-20\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\">\n<div class=\"pl-15 font-size-16 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\"><p \ntitle=\"Schedule not available\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\" class=\"grey-fg mv-4\">\nSchedule not available.</p></div></div></div></div><div layout=\"row\" layout-wrap class=\"black-fg total-bg pv-10 mt-10\" \nng-if=\"$ctrl.sell_rates_display\"><div class=\"pl-15 font-size-14 font-weight-600 text-truncate\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\">Total Cost</div><div class=\"font-size-14 font-weight-600\" \nlayout=\"row\" layout-align=\"end center\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"text-truncate pr-15\">\n{{ $ctrl.searchUser.user_base_currency + \' \' + ( $ctrl.quoteNewCard.meta.card_total_cost | currencyMask : 2 ) }}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{ $ctrl.searchUser.user_base_currency + \' \' + ( $ctrl.quoteNewCard.meta.card_total_cost | currencyMask : 2 ) }}\n</md-tooltip></span></div></div><div layout=\"row\" layout-wrap class=\"white-fg add_to_quote_div\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"50\" flex-gt-xs=\"50\" class=\"font-size-14 font-weight-600\"><md-button md-no-ink \nclass=\"card-button details-button white-fg p-5\" ng-disabled=\"!$ctrl.quoteNewCard.meta.is_selected\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'addNewQuote\',\'msr_rates\')\" title=\"View details\">DETAILS\n</md-button></div><div layout=\"row\" layout-align=\"end\" flex=\"50\" flex-gt-xs=\"50\" class=\"font-size-14 font-weight-600\">\n<md-button md-no-ink class=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-disabled=\"!$ctrl.quoteNewCard.meta.is_selected\" \nng-click=\"$ctrl.addInQuote($ctrl.quoteNewCard,\'newCard\');flipWidget()\" title=\"Remove\">DONE</md-button></div></div>\n</div></ms-widget-back><ms-widget-back ng-if=\"vm.util.solution_type != \'WLS\'\"><div class=\"card-view m-5 white-bg\" \nlayout=\"column\"><div class=\"bb font-size-12 grey-fg Font-ExtraBold pv-10 ph-5 pointer\" ng-click=\"flipWidget()\"><md-icon\n md-font-icon=\"icon-chevron-left\" class=\"grey-fg s20\"></md-icon>BACK</div><div layout=\"row\" flex=\"100\" \nclass=\"card-padding mt-10\"><div flex=\"50\" class=\"card_label\" layout=\"row\" layout-align=\"start center\"><span \nng-if=\"$ctrl.search_param.mode != \'AIR\'\">LINER</span><span ng-if=\"$ctrl.search_param.mode == \'AIR\'\">AIRLINE</span>\n NAME <span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-input-container \nclass=\"sort_input m-0\" md-no-float><md-select class=\"liner_dropdown Font-ExtraBold font-size-12\" \nng-if=\"$ctrl.search_param.mode != \'AIR\'\" \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor_id\" name=\"sub_vendor_id\" \nplaceholder=\"Select Liner Name\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.quoteNewCard.meta, $ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)\" \nmd-on-close=\"searchLiner = \'\'\"><md-select-header><input ng-model=\"searchLiner\" type=\"search\" \nplaceholder=\"Search Liner\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"subvendor in $ctrl.getSubvendor | orderBy:\'name\' | filter : searchLiner\" ng-value=\"subvendor.id\">\n{{subvendor.name}}</md-option></md-select><md-select class=\"liner_dropdown Font-ExtraBold font-size-12\" \nng-if=\"$ctrl.search_param.mode == \'AIR\'\" \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline_code\" name=\"airline_code\" \nplaceholder=\"Select Airline Name\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.quoteNewCard.meta,$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)\" \nmd-on-close=\"search_airline_liner = \'\'\"><md-select-header><input ng-model=\"search_airline_liner\" type=\"search\" \nplaceholder=\"Search Airline\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"airline in $ctrl.getAirline | orderBy:\'air_line_name\' | filter : search_airline_liner\" \nng-value=\"airline.airline_code\">{{airline.air_line_name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"card-padding\"><div flex=\"50\" class=\"card_label\" layout=\"row\" \nlayout-align=\"start center\">EXPIRY DATE <span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\"><md-datepicker class=\"Font-ExtraBold font-size-12\" \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\" md-open-on-focus \nmd-placeholder=\"Expiry Date\" md-min-date=\"$ctrl.expMaxDate\" onkeydown=\"return false\" md-hide-icons=\"calendar\" \nng-required=\"true\"></md-datepicker></div></div><div \nng-if=\"$ctrl.search_param.mode != \'AIR\' && ($ctrl.quoteNewCard.meta.port_data.is_icd_port_origin || $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination)\" \nclass=\"pl-5\"><div layout=\"row\" flex=\"100\" class=\"Font-Bold ph-10 mv-5\" \nng-if=\"$ctrl.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" class=\"grey-fg\" layout=\"row\" \nlayout-align=\"start center\">Port of Loading<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"card-autocomplete\"><md-autocomplete required md-input-name=\"card_origin_port\" \nmd-selected-item=\"$ctrl.quoteNewCard.meta.via_pol\" md-search-text=\"$ctrl.card_originSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originSearchText,$ctrl.search_param.mode != \'AIR\' ? \'SEA\': \'AIR\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter Loading Port\" md-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span \nclass=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_originSearchText}}\" were found.</md-not-found><div \nng-messages=\"card_origin_port.$error\"><div ng-message=\"required\">This field is required</div></div></md-autocomplete>\n</div></div><div layout=\"row\" flex=\"100\" class=\"Font-Bold ph-10 mb-5\" \nng-if=\"$ctrl.quoteNewCard.meta.port_data.is_icd_port_destination\"><div flex=\"50\" class=\"grey-fg\" layout=\"row\" \nlayout-align=\"start center\">Port of Discharge<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"card-autocomplete\"><md-autocomplete required md-input-name=\"card_destination_port\" \nmd-selected-item=\"$ctrl.quoteNewCard.meta.via_pod\" md-search-text=\"$ctrl.card_destinationSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationSearchText,$ctrl.search_param.mode != \'AIR\' ? \'SEA\': \'AIR\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter Destination Port\" md-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span \nclass=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_destinationSearchText}}\" were found.</md-not-found><div \nng-messages=\"cardSearchForm.card_destination_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></div></div><div layout=\"row\" flex=\"100\" class=\"Font-Bold ph-10 mb-5\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" \nclass=\"grey-fg\" layout=\"row\" layout-align=\"start center\">Mode of Origin Haulage<span class=\"red-fg\">*</span></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end end\"><md-select class=\"liner_dropdown m-0\" \nng-model=\"$ctrl.quoteNewCard.meta.haulage\" name=\"haulage\" placeholder=\"Select Origin Haulage\"><md-option \nng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></div></div><div \nlayout=\"row\" flex=\"100\" class=\"Font-Bold ph-10 mb-5\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination\"><div \nflex=\"50\" class=\"grey-fg\" layout=\"row\" layout-align=\"start center\">Mode of Destination Haulage<span class=\"red-fg\">*\n</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-select class=\"liner_dropdown m-0\" \nng-model=\"$ctrl.quoteNewCard.meta.destination_haulage\" name=\"haulage\" placeholder=\"Select Destination Haulage\">\n<md-option ng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></div>\n</div></div><div layout=\"row\" flex=\"100\" class=\"card-padding\"><div flex=\"50\" class=\"card_label\" layout=\"row\" \nlayout-align=\"start center\">SERVICE TYPE</div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-input-container \nclass=\"sort_input m-0 h-35\" md-no-float><input \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type\" placeholder=\"Service Type\" \nclass=\"font-size-12 Font-ExtraBold\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"card-padding mb-15\"><div flex=\"50\" class=\"card_label\" layout=\"row\" layout-align=\"start center\">RATES BY</div>\n<div flex=\"50\" layout=\"row\" layout-align=\"end end\" class=\"font-size-12 black-fg Font-ExtraBold\">\n{{ $ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}</div></div><div \nlayout=\"column\" class=\"bb bt\"><div class=\"ph-15 pt-15 pb-10\" layout=\"row\" layout-align=\"space-between\" \nng-if=\"!$ctrl.sell_rates_display\"><div class=\"grey-600-fg font-size-12 Font-ExtraBold\"><md-icon \nmd-svg-icon=\"assets/icons/custom/coins.svg\" class=\"w-15 h-15 mr-5\"></md-icon>CUSTOM RATES</div><div \nclass=\"font-size-12 Font-ExtraBold md-primary-fg pointer\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'addNewQuote\',\'msr_rates\')\">ADD</div></div><div \nng-if=\"$ctrl.sell_rates_display\"><div layout=\"row\" layout-wrap class=\"pv-8 ph-15\" \nng-repeat=\"(leg_key,leg_value) in $ctrl.quoteNewCard.data[$ctrl.buyOrSell]\" \nng-class=\"{\'h-50\' : leg_key == $ctrl.l3_leg }\"><div layout=\"column\" layout-align=\"center start\" flex=\"60\" \nflex-gt-xs=\"60\" ng-class=\"{\'text-truncate\' : leg_key != $ctrl.l3_leg}\"><span class=\"font-size-14 pr-2\" \nng-class=\"{\'text-truncate\' : leg_key == $ctrl.l3_leg}\"><md-icon class=\"icon-class\" \nmd-svg-src=\"{{ ( leg_key == $ctrl.l1_leg || leg_key == $ctrl.l2_leg || leg_key == $ctrl.l2_leg_cha || leg_key == $ctrl.l3_leg || leg_key == $ctrl.l4_leg || leg_key == $ctrl.l4_leg_cha || leg_key == $ctrl.l5_leg || leg_key == $ctrl.ins_leg ) ? \'assets/icons/custom/\' + leg_key +\'_card.svg\' : \'assets/icons/custom/l3_fcl-icon.svg\' }}\">\n</md-icon>\n{{ ( leg_key == $ctrl.l3_leg && leg_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : leg_value.leg_name }} <span\n \nng-if=\"leg_key == $ctrl.l3_leg && leg_value.rate_obj.is_special && (leg_value.rate_obj.special_meta.normal_rate_total != undefined)\">\n<md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></span></span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"40\" flex-gt-xs=\"40\"><span \nclass=\"leg-cost-right text-truncate pr-2 font-size-14 grey-800-fg Font-Bold\" \nng-class=\"{\'red-600-fg\' : (!leg_value.rate_obj), \'freight-fg\' : (leg_key == $ctrl.l3_leg), \'grey-800-fg\' : (leg_key != $ctrl.l3_leg)}\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask : 2) ) : \'N/A\' }}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask : 2) ) : \'NA\' }}\n</md-tooltip></span><span class=\"leg-cost-right pr-2 grey-500-fg font-size-12 text-truncate Font-Bold\" \nng-if=\"leg_key == $ctrl.l3_leg && leg_value.rate_obj.is_special && (leg_value.rate_obj.special_meta.normal_rate_total != undefined)\">\n<strike>{{leg_value.rate_obj.leg_currency}} {{leg_value.rate_obj.special_meta.normal_rate_total | currencyMask : 2}}\n</strike></span></div></div></div><div ng-show=\"$ctrl.search_param.mode == \'AIR\'\"><div layout=\"row\" layout-wrap \nclass=\"pv-20\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\"><div class=\"pl-15 font-size-16 text-truncate\" \nlayout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\"><p title=\"Schedule not available\" \nng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\" class=\"grey-fg mv-4\">Schedule not available.</p></div></div></div>\n<div ng-show=\"$ctrl.search_param.mode !=\'AIR\'\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"ph-15 pt-10 pb-15\" ng-if=\"!$ctrl.schedule_display\"><div class=\"grey-600-fg font-size-12 Font-ExtraBold\"><md-icon\n md-svg-icon=\"assets/icons/custom/stop.svg\" class=\"w-15 h-15 mr-5\"></md-icon>SCHEDULES</div><div \nclass=\"font-size-12 Font-ExtraBold md-primary-fg pointer\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'schedule\',\'msr_rates\')\">ADD</div></div><div \nng-if=\"$ctrl.schedule_display\"><div layout=\"row\" layout-wrap class=\"pv-8\" \nng-if=\"$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\"><div class=\"font-size-14\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\"><span class=\"ph-15 text-truncate\"><md-icon \nmd-svg-src=\"assets/icons/custom/shipping-details-icon.svg\" class=\"icon-class\" title=\"Routing\"></md-icon><span>\n{{$ctrl.quoteNewCard.meta.selected_schedule.via_port != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{$ctrl.quoteNewCard.meta.selected_schedule.via_port != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n</md-tooltip></span></span></div><div class=\"pr-15 font-size-14\" layout=\"row\" layout-align=\"end center\" flex=\"40\" \nflex-gt-xs=\"40\"><span class=\"text-truncate\"><md-icon md-svg-src=\"assets/icons/custom/valid-icon.svg\" \nclass=\"icon-class\" title=\"Transit Time\"></md-icon>\n{{ $ctrl.quoteNewCard.meta.selected_schedule.transit_time != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.transit_time : \'N/A\' }}\n</span></div></div><div layout=\"row\" layout-wrap class=\"pv-8\" \nng-if=\"$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\"><div \nclass=\"pl-15 font-size-14 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"40\" flex-gt-xs=\"40\"><span \nclass=\"font-size-14\">Next sailing on</span></div><div class=\"font-size-14\" layout=\"row\" layout-align=\"end center\" \nflex=\"60\" flex-gt-xs=\"60\"><span title=\"Departure Time\" class=\"pr-15 text-truncate\">\n{{$ctrl.quoteNewCard.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy\'}}</span></div></div><div \nlayout=\"row\" layout-wrap class=\"pv-20\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\">\n<div class=\"pl-15 font-size-16 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\"><p \ntitle=\"Schedule not available\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\" class=\"grey-fg mv-4\">\nSchedule not available.</p></div></div></div></div></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"pv-15\"><div class=\"font-size-12 Font-ExtraBold grey-fg\">TOTAL COST</div><div class=\"Font-ExtraBold black-fg\">\n{{ $ctrl.searchUser.user_base_currency }} <span class=\"font-size-38\">\n{{ $ctrl.quoteNewCard.meta.card_total_cost | currencyMask : 2 }} </span></div></div><md-button md-no-ink \nclass=\"md-accent-btn Font-ExtraBold\" ng-click=\"$ctrl.addInQuote($ctrl.quoteNewCard,\'newCard\');flipWidget()\">\nCREATE RATE CARD</md-button></div></ms-widget-back></ms-widget>");
$templateCache.put("app/main/component/result-card/rate-card-desktop.html","<div id=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_id}}\" layout=\"row\" layout-xs=\"column\" layout-wrap \nclass=\"list_view_div md-brad\" \nng-class=\"{ \'rate_card_selected\': $ctrl.parentPage===\'result\' && $ctrl.carddata.meta.is_selected, \'rate_card_expiry\': $ctrl.parentPage == \'result\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry  && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')}\">\n<div layout=\"column\" flex=\"15\" flex-xs=\"100\" layout-align=\"space-around center\" class=\"w-60 p-5 br\" \nng-if=\"$ctrl.proceedduplicate && !$ctrl.copyquoted &&(!($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') || $ctrl.carddata.meta.type.includes(\'spot\'))\">\n<md-checkbox md-no-ink ng-click=\"$ctrl.selectedDuplicateQuote($ctrl.carddata)\"></md-checkbox></div><div \nlayout=\"column\" flex=\"15\" flex-xs=\"100\" layout-align=\"center center\" class=\"w-180 p-5 br\"><div \nclass=\"fg-AAA8AD Font-Bold font-size-9 mv-5\" layout=\"row\" \nng-if=\"($ctrl.carddata.data.buy_rates[$ctrl.l3_leg].rate_obj.show_contract_number || ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number  && !$ctrl.carddata.meta.type.includes(\'network\')) && (!$ctrl.util.isShipper || ($ctrl.util.isShipper && $ctrl.showContractShipper)))\">\n<span class=\"fg-333333 pl-5 Font-Bold contractIdTruncate\" style=\"-webkit-box-orient: vertical\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number }}</span><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 p-10 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\nContract / Rate Agreement / Tariff / Spot Pricing Reference Number: {{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number? \'\' :$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number}}\n</div></md-tooltip></div><div class=\"grey-fg font-size-11 mv-5\" layout=\"row\" \nng-show=\"!$ctrl.maskLiner && $ctrl.util.showRateIdForContract($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.tags)\">\n<span ng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id\">Rate:</span><div \nclass=\"fg-343434 Font-Bold pl-5 ellipsis-80 pointer\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 p-10 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id? \'\' :$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id}}\n</div></md-tooltip></div><span class=\"solid-bb pointer mh-8 fg-343434 Font-Bold\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'tnc\', $ctrl.carddata.meta.type);\" \nng-if=\"$ctrl.carddata.meta.type.includes(\'spot\') && ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.data || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.url)\">\nT&C</span></div><div class=\"grey-fg font-size-11 mv-5\" layout=\"row\" ng-show=\"!$ctrl.maskLiner\"><span \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.origin_service_mode || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.destination_service_mode\">\nService:</span><div class=\"fg-343434 Font-Bold pl-5 ellipsis-80 pointer\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.origin_service_mode || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.destination_service_mode\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.origin_service_mode }} / {{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.destination_service_mode }}\n<md-tooltip md-direction=\"top\" class=\"font-size-12 white-fg bg-343434 p-10 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.origin_service_mode }} / {{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.destination_service_mode }}\n</div></md-tooltip></div></div><div layout=\"column\"><div layout=\"row\" layout-align=\"center start\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && !$ctrl.maskLiner\"><div \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\" \nng-show=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div></div><div \nclass=\"contract\" ng-if=\"!$ctrl.util.isShipper && $ctrl.carddata.meta.xenetaRateAverage && $ctrl.carddata.meta.isError\">\n{{$ctrl.carddata.meta.type.includes(\'spot\') ? \'SHORT CONTRACT\' : \'LONG CONTRACT\'}}</div><div layout=\"row\" \nlayout-align=\"center start\" ng-if=\"$ctrl.search_param.mode == \'AIR\' && !$ctrl.maskLiner\"><div \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\"></div><div \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\" class=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}</div></div><div layout=\"row\" \nlayout-align=\"center start\" ng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.maskLiner\"><div \nng-if=\"$ctrl.maskv2 && $ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code]\">\n<div ng-if=\"$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].logo\">\n<img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].logo)}}\" \nalt=\"{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name}}\"></div>\n<div class=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name ? $ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name: $ctrl.maskLinerText}}\" \nng-if=\"!$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].logo && $ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name\">\n{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name}}<md-tooltip \nmd-direction=\"top\">\n{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name}}</md-tooltip>\n</div></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name && $ctrl.maskLinerText\">\n<span layout-align=\"space-around center\">{{$ctrl.maskLinerText}}<md-tooltip md-direction=\"top\">{{$ctrl.maskLinerText}}\n</md-tooltip></span></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskLinerText && !$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code]\">\n<div ng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"empty_logo text-truncate\" ng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\" \nlayout-align=\"space-around center\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}<md-tooltip \nmd-direction=\"top\">{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\n</md-tooltip></div></div></div><div layout=\"row\" layout-align=\"center start\" \nng-if=\"$ctrl.search_param.mode == \'AIR\' && $ctrl.maskLiner\"><div \nng-if=\"$ctrl.maskAirline && $ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code]\">\n<div ng-if=\"$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].logo\">\n<img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].logo)}}\" \nalt=\"{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name}}\">\n</div><div class=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name ? $ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name: $ctrl.maskLinerText}}\" \nng-if=\"!$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].logo && $ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name\">\n{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name}}<md-tooltip\n md-direction=\"top\">\n{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name}}\n</md-tooltip></div></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name && $ctrl.maskLinerText\">\n<span layout-align=\"space-around center\">{{$ctrl.maskLinerText}}<md-tooltip md-direction=\"top\">{{$ctrl.maskLinerText}}\n</md-tooltip></span></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskLinerText && !$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code]\">\n<div ng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\"></div><div \nclass=\"empty_logo text-truncate\" ng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\" \nlayout-align=\"space-around center\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}<md-tooltip md-direction=\"top\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}</md-tooltip></div></div></div>\n<div layout=\"row\" layout-align=\"center start\" ng-if=\"!$ctrl.maskLiner && !$ctrl.carddata.meta.isError\"><span \nclass=\"font-size-10 ellipsis-80 mt-5 pointer\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n<md-tooltip md-direction=\"top\" class=\"font-size-12 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n</md-tooltip></span><span class=\"font-size-10 ellipsis-80 mt-5 pointer\" \nng-if=\"$ctrl.search_param.mode === \'AIR\' && $ctrl.carddata.meta.selected_schedule.flight_number\"><span \nclass=\"ph-3 mt-5 font-size-10\">| </span>{{ $ctrl.carddata.meta.selected_schedule.flight_number }}<md-tooltip \nmd-direction=\"top\" class=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ $ctrl.carddata.meta.selected_schedule.flight_number }}</md-tooltip></span><span class=\"ph-3 mt-5 font-size-10\" \nng-if=\"($ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.service_name) && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type\">\n| </span><span class=\"font-size-10 ellipsis-80 mt-5 pointer\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\' && $ctrl.carddata.meta.selected_schedule\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n<md-tooltip md-direction=\"top\" class=\"font-size-12 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n</md-tooltip></span></div></div><div div-slide-show><div layout=\"row\" class=\"mv-5\" \nng-repeat=\"tag in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.tags\" \nng-if=\"tag.show_tag  && !$ctrl.maskLiner\"><img ng-src=\"{{$ctrl.util.sanitizeQueryParams(tag.tag_ribbon_url)}}\">\n<md-tooltip md-direction=\"top\" style=\"display:table;opacity: 1\" \nclass=\"font-size-14 pv-5 text-center white-fg bg-343434 Font-Bold\" \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.rollable_available\"><div>Rollable available</div>\n</md-tooltip></div></div><div class=\"mv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.rate_structure\"><div \nclass=\"font-size-11 Font-Bold added-by-tag\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.rate_structure}}</div></div><div class=\"mv-5\" \nng-show=\"$ctrl.parentPage===\'result\' && ($ctrl.util.isAdmin || $ctrl.util.isFreightbro) && ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.manual && $ctrl.search_param.freight_charges)\">\n<div class=\"font-size-11 Font-Bold added-by-tag\">added by you</div></div><div class=\"h-25\" \nng-show=\"$ctrl.parentPage===\'result\' && ($ctrl.util.isAdmin || $ctrl.util.isFreightbro) && ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.manual && $ctrl.search_param.freight_charges)\">\n<span class=\"pr-8 mr-5\" ng-click=\"$ctrl.openEditCardModal($event,$ctrl.carddata)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s20 black-fg h-15 pointer\" title=\"Edit\"></md-icon></span><span class=\"pl-5 ml-5\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata, $index)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s20 black-fg h-15 pointer\" title=\"Delete\"></md-icon></span></div><div \nclass=\"fg-3F3851 font-size-11 Font-Bold m-5\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions.length  && !$ctrl.maskLiner\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"fg-0ABF54 s14 mb-2\"></md-icon><span \nng-repeat=\"promotion in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions track by $index\">\n{{$first ? \'\' : \', \'}} {{promotion.name}}</span></div></div><div layout=\"row\" flex flex-xs=\"100\" \nlayout-align=\"start center\"><div layout=\"column\" flex=\"100\" class=\"pv-5\"><div layout=\"row\" flex=\"100\" class=\"bb pb-5\">\n<port-to-port class=\"full-width\" card=\"$ctrl.carddata\" buyorsell=\"$ctrl.buyOrSell\" mode=\"$ctrl.search_param.mode\" \nng-if=\"$ctrl.carddata.meta.isScheduleCall\"></port-to-port><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" \nshimmer-effect-full width=\"120px\" height=\"30px\" width=\"120px\" height=\"30px\" class=\"mb-10 pl-10\"></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap ng-if=\"!$ctrl.carddata.meta.isError\"><div class=\"ph-10 pv-5\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.resultfilter.deviceName == \'laptop\'\"><div \nclass=\"font-size-11 fg-AAA8AD\">Sailing Date<md-icon md-svg-src=\"assets/icons/custom/event_available.svg\" \nclass=\"w-15 h-15 ml-2 schedule_available_icon\" \nng-if=\"$ctrl.carddata.data.buy_rates[$ctrl.l3_leg].rate_obj.schedule.is_schedule_available_in_cache\"><md-tooltip \nclass=\"white-fg bg-343434 font-size-11\" md-direction=\"top\">Schedules Available</md-tooltip></md-icon></div><div \nclass=\"font-size-12 fg-333333 Font-Bold ellipsis-name\" ng-show=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule === null && !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sailing_date ? \'-\' : ($ctrl.carddata.meta.selected_schedule.departure_time ? $ctrl.carddata.meta.selected_schedule.departure_time : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\')}}\n</div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div></div>\n<div class=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\"><div class=\"font-size-11 fg-AAA8AD\">ETD<md-icon \nclass=\"pl-5 s12 fg-AAA8AD\" md-font-icon=\"icon-information-outline\"><md-tooltip class=\"white-fg bg-343434 font-size-11\" \nmd-direction=\"top\">Estimated Time Of Departure</md-tooltip></md-icon></div><div \nclass=\"font-size-12 fg-333333 Font-Bold\" ng-show=\"$ctrl.carddata.meta.isScheduleCall\"><span \nng-if=\"$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.meta.selected_schedule ? ($ctrl.carddata.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}} \n</span><span ng-if=\"!$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.departure_time ? ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.departure_time | UTCToLocal : \'d MMM yyyy\') : \'-\'}}\n</span></div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div>\n</div><div class=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\"><div class=\"font-size-11 fg-AAA8AD\">ETA<md-icon \nclass=\"pl-5 s12 fg-AAA8AD\" md-font-icon=\"icon-information-outline\"><md-tooltip class=\"white-fg bg-343434 font-size-11\" \nmd-direction=\"top\">Estimated Time Of Arrival</md-tooltip></md-icon></div><div class=\"font-size-12 fg-333333 Font-Bold\" \nng-show=\"$ctrl.carddata.meta.isScheduleCall\"><span ng-if=\"$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.meta.selected_schedule ? ($ctrl.carddata.meta.selected_schedule.arrival_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}} \n</span><span ng-if=\"!$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.arrival_time ? ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.arrival_time | UTCToLocal : \'d MMM yyyy\') : \'-\'}}\n</span></div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div>\n</div><div class=\"ph-10 pv-5\"><div class=\"font-size-11 fg-AAA8AD\">Transit Time</div><div \nclass=\"font-size-12 fg-333333 Font-Bold ellipsis-name\" ng-class=\"{\'max-width-125\' : $ctrl.search_param.mode == \'AIR\'}\" \nng-show=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule ?(!$ctrl.carddata.meta.selected_schedule.transit_time ? \'-\' : $ctrl.carddata.meta.selected_schedule.transit_time) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'-\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n</div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div></div>\n<div class=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.mode != \'AIR\'\"><div class=\"font-size-11 fg-AAA8AD\">Free Days</div>\n<div class=\"font-size-12 fg-333333 Font-Bold ellipsis-name\"><free-days \nfreedaysdata=\"{\n                demurrage_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.demurrage_details,\n                detention_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detention_details,\n                combined_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.combined_details,\n                freeDays : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.freeDays,\n                pageSource : $ctrl.parentPage+$ctrl.quoteType+\'RateCard\'\n              }\" \ntype=\"\'list-nwls\'\" cardid=\"$ctrl.carddata._id\" mode=\"$ctrl.search_param.mode\" \nsearch-load-data=\"$ctrl.search_param.load_data.load_details_value\"></free-days></div></div><div class=\"ph-5 pv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length\">\n<div class=\"font-size-11 fg-AAA8AD\">Cargo</div><div class=\"font-size-12 fg-333333 Font-Bold\" layout=\"row\"><div \nclass=\"ellipsis-name text-capitalize\"><span \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data.name }} <span \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length\">|</span> </span>\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data[0].toLowerCase() }}</div><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer cargo-{{$ctrl.carddata._id}}\" \nng-click=\"$ctrl.shareQuoteService.showCargoCommodity($event, $ctrl.carddata._id, $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg],\'result\', $ctrl.search_param.mode);\">\n</md-icon></div></div></div><div class=\"ph-10 pv-5\" \nng-if=\"(( $ctrl.isWalmart || !$ctrl.util.isShipper) && !$ctrl.util.isSharedQuote()) && !$ctrl.carddata.meta.type.includes(\'spot\') \">\n<div class=\"font-size-11 fg-AAA8AD\">\nRates by {{ !$ctrl.isWalmart ? ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? \'Agent \' : \'Forwarder \' : \'\' }}\n</div><div class=\"font-size-12 fg-333333 Font-Bold ellipsis-name\" \nng-class=\"{\'max-width-125\' : $ctrl.search_param.mode == \'AIR\'}\"><span>\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n</span><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n</md-tooltip></div></div><div class=\"ph-10 pv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code\"><div \nclass=\"font-size-11 fg-AAA8AD\">Named Account Code</div><div \nclass=\"font-size-12 fg-333333 Font-Bold line-height-12 text-truncate max-width-155\" layout=\"row\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code}}</div><md-tooltip \nmd-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code}}</md-tooltip></div><div \nclass=\"ph-10 pv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n<div class=\"font-size-11 fg-AAA8AD\" layout=\"row\">Effective Period <span \nng-if=\"$ctrl.parentPage == \'result\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')\" \nclass=\"expired-status text-truncate\" \ntitle=\"{{$ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)}}\">\n{{$ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)}}</span></div><div \nclass=\"font-size-12 fg-333333 Font-Bold ellipsis-name max-width-155\" \nng-class=\"{\'fg-F43F5E\': $ctrl.parentPage == \'result\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')}\" \nlayout=\"row\"><div \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n<span>\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\") + \" - \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone: \"dd MMM yyyy\") }}\n</span><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\") + \" - \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone: \"dd MMM yyyy\") }}\n</md-tooltip></div><div \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n<span>{{ \"Till \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone: \"dd MMM yyyy\")}}\n</span><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ \"Till \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone: \"dd MMM yyyy\")}}\n</md-tooltip></div><div \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date && !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n<span>\n{{ \"From \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\")}}\n</span><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ \"From \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\")}}\n</md-tooltip></div><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer effective-period-{{$ctrl.carddata._id}}\" \nng-if=\"$ctrl.util.fnCheckLoadExpiryLength($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detailed_effective_load , $ctrl.search_param.load_data.load_details_value) && $ctrl.search_param.mode === \'SEA-FCL\' \" \nng-click=\"$ctrl.shareQuoteService.showEffectivePeriodPanel($event,$ctrl.carddata._id,$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detailed_effective_load , $ctrl.search_param.load_data.load_details_value)\">\n</md-icon></div></div><div ng-if=\"$ctrl.customFeilds\" ng-repeat=\"feilds in $ctrl.customFeilds track by $index\"><div \nclass=\"ph-10 pv-5\" ng-if=\"feilds.value && feilds.uiLocation.includes(\'RATECARD\')\"><div class=\"font-size-11 fg-AAA8AD\">\n{{feilds.label}}</div><div class=\"font-size-12 fg-333333 Font-Bold line-height-12 text-truncate max-width-155\" \nlayout=\"row\">{{feilds.value}}</div><md-tooltip md-direction=\"bottom\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">{{feilds.value}}</md-tooltip>\n</div></div><div class=\"ph-10 pv-5\" ng-if=\"$ctrl.util.co2ApiLoaded && $ctrl.carddata.meta.co2eData\"><div \nclass=\"font-size-11 fg-AAA8AD\"><md-icon md-svg-src=\"assets/icons/custom/co2-icon.svg\" class=\"icon-class-10 mr-5\">\n</md-icon>CO<sub>2</sub> emission</div><div class=\"font-size-12 fg-333333 Font-Bold line-height-12\" layout=\"row\"><div \nclass=\"ellipsis-name\">{{($ctrl.carddata.meta.co2eData.co2e.total | currencyMask: 2) +\' \' +\'g\'}}</div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s14 fg-3F3851 pointer co2e-{{$ctrl.carddata._id}}\" \nng-click=\"$ctrl.shareQuoteService.showCo2ContainerData($event, $ctrl.carddata._id, $ctrl.carddata.meta.co2eData)\">\n</md-icon></div></div><div class=\"ph-10 mt-15\" ng-if=\"!$ctrl.util.co2ApiLoaded\" shimmer-effect-full width=\"40px\" \nheight=\"20px\"></div><div class=\"ph-10 pv-5\" \nng-if=\"$ctrl.search_param.mode == \'AIR\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.frequency\"><div \nclass=\"font-size-11 fg-AAA8AD\">Frequency</div><div class=\"font-size-12 fg-333333 Font-Bold\" \nng-show=\"$ctrl.carddata.meta.isScheduleCall\">{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.frequency}}\n</div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div></div>\n<div class=\"ph-5 pv-5 center-align ml-auto\" ng-if=\"$ctrl.carddata.partner_reference_id && !$ctrl.util.isShipper\" \nlayout=\"row\"><span class=\"font-size-11 intergration-code\">CW Quotation No</span><div \nclass=\"font-size-12 fg-333333 Font-Bold\" layout=\"row\"><div class=\"ellipsis-name text-capitalize pl-5\">\n{{$ctrl.carddata.partner_reference_id}}</div><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s16 pl-5 pointer content-copy z-2\" ng-if=\"$ctrl.carddata.partner_reference_id\" \nng-click=\"$ctrl.fnCopyID( $ctrl.carddata.partner_reference_id)\"><md-tooltip md-direction=\"top\">{{$ctrl.isIdCopied}}\n</md-tooltip></md-icon></div></div><div class=\"ph-5 pv-5 center-align pointer\" \nng-if=\"$ctrl.carddata.partner_reference_id && !$ctrl.util.isShipper\" layout=\"row\"><div \nclass=\"font-size-12 intergration-code-failed Font-Bold pointer\" \nng-if=\"$ctrl.carddata.document_details.sync_status.toLowerCase() === \'failed\'\" layout=\"row\" \nng-click=\"$ctrl.reSyncTmsData($ctrl.carddata)\"><div class=\"ellipsis-name text-capitalize pl-5\"><md-icon \nmd-font-icon=\"icon-sync\" class=\"s16 fg-F43F5E\"></md-icon>Sync PDF Again</div></div><div \nclass=\"font-size-12 intergration-code-success Font-Bold\" \nng-if=\"$ctrl.carddata.document_details.sync_status.toLowerCase() === \'success\'\" layout=\"row\"><div \nclass=\"ellipsis-name text-capitalize pr-5\">PDF Synced</div></div></div></div><div ng-if=\"$ctrl.carddata.meta.isError\" \nclass=\"pt-10\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"alert-icon ml-15 orange-400-fg\"></md-icon><div class=\"message-style\" \nng-bind-html=\"$ctrl.util.escapeHtml($ctrl.carddata.meta.error) | charlengthEllipsis: 35\"></div><div \nclass=\"link-style font-size-11 noRates-{{$ctrl.carddata._id}}\" ng-if=\"$ctrl.carddata.meta.error.length > 35\" \nng-click=\"$ctrl.ShowNoRatesInfo($event, $ctrl.carddata._id, $ctrl.carddata.meta.error)\">Show More</div></div></div>\n</div><div layout=\"column\" flex=\"25\" flex-xs=\"100\" class=\"w-262 p-5 ph-0 bl\" \nng-class=\"{\'w-310\' : (($ctrl.search_param.mode == \'AIR\' && $root.domainData.domain_info.RESULT_CONFIG.SHOW_LANDING_COST &&  ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 && !$ctrl.carddata.meta.is_selected)) || ($ctrl.parentPage==\'quotes\' && !$ctrl.iscopyquote))}\">\n<div layout=\"row\" flex=\"60\" layout-align=\"start end\" class=\"align-self\" ng-if=\"!$ctrl.all_in_rates.length\" \nng-class=\"{\'mt-40\' :($ctrl.proceedduplicate)}\"><div layout=\"row\" flex=\"100\" class=\"ph-15 mt-10 Font-Bold\"><div \nng-if=\"$ctrl.search_param.mode ==\'AIR\' && $root.domainData.domain_info.RESULT_CONFIG.SHOW_FREIGHT_COST\"><div \nlayout=\"row\" class=\"h-50 Font-Bold font-size-10\" flex=\"100\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 && !$ctrl.carddata.meta.is_selected\"><div \nng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_1\'}\" class=\"w-90 pointer\" flex layout=\"column\" \nlayout-align=\"center center\" ng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_1\')\"><div class=\"fg-AAA8AD\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab }} slab</div><div \nclass=\"md-link-fg max-width-100 over-flow-break-word\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_currency }} {{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_cost / ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} /kg\n</div></div><div ng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_2\'}\" class=\"w-90 pointer\" flex \nlayout=\"column\" layout-align=\"center center\" ng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_2\')\"><div \nclass=\"fg-AAA8AD\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab }} slab</div><div \nclass=\"grey-fg max-width-100 over-flow-break-word\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_currency }} {{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} /kg\n</div></div></div><div class=\"Font-Bold text-center\" \nng-if=\"!$ctrl.carddata.meta.isError && (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 || $ctrl.carddata.meta.is_selected)\">\n<div class=\"font-size-10 fg-AAA8AD\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab }} slab</div>\n<div class=\"font-size-14 fg-3F3851 ml-5 max-width-100 over-flow-break-word\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_currency }} {{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} /kg\n</div></div></div><div \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.search_param.freight_charges && $root.domainData.domain_info.RESULT_CONFIG.SHOW_FREIGHT_COST && !$ctrl.hideLegTotal && (!$root.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL || $ctrl.util.isShipper || $ctrl.isShared)\">\n<div class=\"font-size-10 grey-fg line-height-unset letter-spacing-0-33\">Freight <span \nng-if=\"!$ctrl.util.isShipper && !$ctrl.isShared\">Sell</span> Rate</div><div \nclass=\"font-size-14 fg-3F3851 max-width-100 over-flow-break-word\" ng-if=\"!$ctrl.carddata.meta.isError\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_currency}} {{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_currency_cost | currencyMask: 2 }}\n</div><div class=\"font-size-16 w-80\" ng-if=\"$ctrl.carddata.meta.isError\">N/A</div></div><div \nng-if=\"$ctrl.search_param.mode != \'AIR\' && ($root.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL && !$ctrl.util.isShipper && !$ctrl.isShared)\">\n<div class=\"font-size-10 grey-fg line-height-unset letter-spacing-0-33\">Total Buy Rate</div><div \nclass=\"font-size-17 fg-3F3851 pt-2 max-width-100 over-flow-break-word\" ng-if=\"!$ctrl.carddata.meta.isError\">\n{{ $ctrl.searchparam.user.user_base_currency }} {{ $ctrl.carddata.meta.buy_leg_total | currencyMask: 2 }}<md-icon \nng-if=\"!$ctrl.hideLegTotal\" md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer card-{{$ctrl.carddata._id}}-buy\" \nng-click=\"$ctrl.showCostBreakdown($ctrl.carddata, $event, \'buy_rates\')\"></md-icon></div><div class=\"font-size-16 w-80\" \nng-if=\"$ctrl.carddata.meta.isError\">N/A</div></div><div \nng-class=\"{\'ml-20\' : $root.domainData.domain_info.RESULT_CONFIG.SHOW_FREIGHT_COST}\" \nng-if=\"$root.domainData.domain_info.RESULT_CONFIG.SHOW_LANDING_COST\"><div \nclass=\"font-size-10 grey-fg line-height-unset\">Total <span ng-if=\"!$ctrl.util.isShipper && !$ctrl.isShared\">Sell</span>\n Rate<md-button md-no-ink class=\"m-0 p-0 line-height-unset cost-icon\" ng-if=\"!$ctrl.carddata.meta.isError\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s12 mb-2 ml-2 grey-fg pointer\" \nng-if=\"$ctrl.carddata.meta.type.includes(\'spot\')\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold\" style=\"display:table;opacity: 1\">\nSpot Rates are dynamic & can fluctuate with time</md-tooltip></md-button><span \nng-switch=\"$ctrl.carddata.meta.partialRate\" class=\"pointer\"><span ng-switch-when=\"rmk-inc\"><span class=\"ml-2\">*</span>\n<md-tooltip md-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold\" style=\"display:table;opacity: 1\">\nSubject to Remarks</md-tooltip></span></span><span ng-if=\"$ctrl.carddata.meta.missingFlag.length\" class=\"pointer\">\n<md-button md-no-ink class=\"m-0 p-0 line-height-unset cost-icon\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s12 mb-2 ml-2 orange-400-fg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold\" style=\"display:table;opacity: 1\"><span \nng-repeat=\"flag in $ctrl.carddata.meta.missingFlag\">{{ flag }}<br></span></md-tooltip></md-button></span></div><div>\n<div class=\"font-size-17 fg-3F3851 max-width-100 over-flow-break-word\" ng-if=\"!$ctrl.carddata.meta.isError\">\n{{$ctrl.searchparam.user.user_base_currency}} {{ $ctrl.carddata.meta[$ctrl.resultfilter.total_cost] | currencyMask: 2 }}\n<md-icon ng-if=\"!$ctrl.hideLegTotal\" md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer card-{{$ctrl.carddata._id}}-sell\" \nng-click=\"$ctrl.showCostBreakdown($ctrl.carddata, $event)\"></md-icon></div><div class=\"font-size-17\" \nng-if=\"$ctrl.carddata.meta.isError\">N/A</div></div></div></div></div><div layout=\"row\" flex=\"60\" \nng-class=\"{\'mt-40\' :($ctrl.proceedduplicate)}\" ng-if=\"$ctrl.all_in_rates.length\"><div layout=\"row\" flex=\"100\"><table \nclass=\"all_in_rates_table tableFullWidth\"><thead><th class=\"justify-items-center\"><div class=\"currency-class\">\n{{ $ctrl.all_in_rates[0].currency }}</div></th><th ng-repeat=\"typeValue in $ctrl.all_in_rates\">\n{{typeValue.container_type}}</th></thead><tbody><tr><td class=\"label-class\">All in rates per Equipment</td><td \nng-repeat=\"typeValue in $ctrl.all_in_rates\" class=\"ellipsis-50\">{{typeValue.rates.per_equipment | currencyMask: 2}}\n<md-tooltip md-direction=\"top\">{{typeValue.rates.per_equipment | currencyMask: 2}}</md-tooltip></td></tr><tr><td \nclass=\"label-class\">All in rates per B/L</td><td ng-repeat=\"typeValue in $ctrl.all_in_rates\" class=\"ellipsis-50\">\n{{typeValue.rates.per_bl | currencyMask: 2}}<md-tooltip md-direction=\"top\">{{typeValue.rates.per_bl | currencyMask: 2}}\n</md-tooltip></td></tr></tbody></table></div></div><div \nclass=\"font-size-8 letter-spacing-0-33 fg-AAA8AD ph-15 ml-auto\" \nng-if=\"(!!$ctrl.carddata.meta.remarks || !!$ctrl.carddata.meta.inclusions)\">Remark and Inclusion included</div><div \nlayout=\"row\" flex=\"40\" layout-align=\"end\" class=\"mb-5 mt-10 ph-15 button-group\" ng-if=\"$ctrl.parentPage!==\'quotes\' \">\n<div layout=\"row\" layout-align=\"start start\" ng-if=\"!$ctrl.util.isShipper && $ctrl.carddata.meta.xenetaRateAverage\">\n<div class=\"Font-Regular mb-10 pv-2 ph-8 font-size-10 border-radius-10\" \nng-style=\"{\'color\': $ctrl.carddata.meta.xenetaRateAverage.textColor, \'background\': $ctrl.carddata.meta.xenetaRateAverage.bgColor, \'border\': \'1px solid \' + $ctrl.carddata.meta.xenetaRateAverage.textColor}\">\n{{$ctrl.carddata.meta.xenetaRateAverage.displayText}}<md-icon md-font-icon=\"icon-chevron-down\" \nng-style=\"{\'color\': $ctrl.carddata.meta.xenetaRateAverage.textColor}\" \nclass=\"s14 pointer xeneta-{{$ctrl.carddata._id}}\" ng-click=\"$ctrl.showXenetaGraph($event, $ctrl.carddata)\"></md-icon>\n</div></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"!$ctrl.util.isShipper\"><md-button md-no-ink \nclass=\"md-accent-btn Font-Bold mh-0 ml-15 mb-15 w-120\" ng-disabled=\"$ctrl.carddata.meta.isError\" \nng-if=\" (!$ctrl.carddata.meta.is_selected && !$ctrl.resultfilter.hideBookBtn) || ($ctrl.parentPage == \'result\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\'))\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type,false);\"><md-icon \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon><span>View Details\n</span><md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip></md-button>\n<md-button md-no-ink class=\"md-accent-btn Font-Bold mh-0 mb-15 w-120\" ng-disabled=\"$ctrl.carddata.meta.isError\" \nng-if=\"$ctrl.util.navPermission.quotes[0] && !$ctrl.carddata.meta.is_selected && $ctrl.resultfilter.hideBookBtn && !($ctrl.parentPage == \'result\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\'))\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type,false);\"><md-icon \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>Add to quote\n<md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip></md-button>\n<md-button md-no-ink layout=\"row\" layout-align=\"center center\" class=\"margin-card-btn remove_card_btn w-35\" \nng-if=\"$ctrl.carddata.meta.is_selected\" ng-click=\"$ctrl.removeCard($ctrl.carddata)\"><md-icon \nmd-font-icon=\"icon-minus-circle-outline\" class=\"s18 remove-icon\"></md-icon></md-button><md-button md-no-ink \nlayout=\"row\" layout-align=\"center center\" class=\"margin-card-btn md-accent-btn with-icon w-100\" \nng-if=\"$ctrl.carddata.meta.is_selected\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type);\"><md-icon \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>Edit Charge\n<md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip></md-button>\n</div><div layout=\"row\" layout-align=\"start start\" ng-if=\"$ctrl.util.isShipper\"><md-button md-no-ink \nclass=\"md-primary-btn Font-Bold mh-0 mb-15 w-120\" ng-disabled=\"$ctrl.carddata.meta.isError\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'quotation\', $ctrl.carddata.meta.type)\">View Details\n</md-button><md-button ng-if=\"$ctrl.util.navPermission.shipments[0]\" md-no-ink \nclass=\"md-accent-btn Font-Bold mh-0 ml-15 mb-15 w-95\" ng-disabled=\"$ctrl.carddata.meta.isError\" \nng-click=\"$ctrl.requestToBook($ctrl.carddata, \'fromCard\')\" \nng-disabled=\"!$ctrl.util.navPermission.shipments[0] || $ctrl.generateQuoteBtn || !$ctrl.carddata.meta.isScheduleCall\">\nProceed</md-button></div></div><div layout=\"row\" flex=\"40\" layout-align=\"end\" class=\"mb-5 mt-10 ph-15\" \nng-if=\"$ctrl.parentPage===\'quotes\' \"><div layout=\"row\" layout-align=\"start start\" \nng-if=\"$ctrl.quoteType!==\'copyQuote\'\"><div \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry || $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) !== \'EXPIRED\'\">\n<md-button ng-disabled=\"$ctrl.ratecardselection\" \nng-if=\"(!$ctrl.showeditbtn && !$ctrl.iscopyquote && !$ctrl.proceedduplicate) || $ctrl.util.isShipper || $ctrl.util.isEfpEnabled\" \nmd-no-ink class=\"md-primary-btn Font-Bold mh-0 mb-15 w-120\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotation\')\">View Details</md-button><div layout=\"row\" \nlayout-align=\"start start\" \nng-if=\"!$ctrl.util.isShipper && !$ctrl.util.isEfpEnabled && ($ctrl.showeditbtn || $ctrl.iscopyquote) && !$ctrl.standardquote\" \nclass=\"mt-5\"><md-button md-no-ink layout=\"row\" layout-align=\"center center\" \nclass=\"margin-card-btn remove_card_btn w-70\" ng-disabled=\"$ctrl.ratecardselection\" \nng-if=\"$ctrl.util.navPermission.quotes[3] && !$ctrl.proceedduplicate\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata, $ctrl.index)\">Delete</md-button><md-button md-no-ink \nlayout=\"row\" layout-align=\"center center\" class=\"margin-card-btn md-primary-btn with-icon w-70\" \nng-disabled=\"$ctrl.ratecardselection\" ng-if=\"$ctrl.util.navPermission.quotes[2] && !$ctrl.proceedduplicate\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotationEdit\',$ctrl.carddata.meta.type)\">Edit</md-button>\n</div></div><div layout=\"row\" layout-align=\"start start\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\'\" \nclass=\"mt-5\"><md-button md-no-ink layout=\"row\" layout-align=\"center center\" class=\"margin-card-btn expired_view_btn\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotation\')\"><md-icon md-font-icon=\"icon-eye\" class=\"eye-icon\">\n</md-icon></md-button></div><div layout=\"row\" class=\"ml-15\" \nng-if=\"($ctrl.util.navPermission.shipments[0] && $ctrl.showbookbtn && !$ctrl.util.isEfpEnabled) || $ctrl.isShared\">\n<md-button md-no-ink class=\"md-accent-btn Font-Bold mh-0 mb-15 w-100\" \nng-class=\"{ \'w-125\': $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) !== \'EXPIRED\')}\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && !$ctrl.copyquoted && !$ctrl.proceedduplicate\" \nng-disabled=\"$ctrl.ratecardselection || !$ctrl.isWebView && ( $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) == \'EXPIRED\' || $ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.isquotemodify || $ctrl.quoteresult.result_data.revised || $ctrl.isLost || $ctrl.isExpired)\" \nng-style=\"{ \'cursor\' : (($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') || $ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.quoteresult.result_data.revised || $ctrl.isquotemodify || $ctrl.isLost || $ctrl.isExpired)  ? \'not-allowed\' : \'pointer\' }\" \nng-click=\"$ctrl.requestToBook($ctrl.carddata)\"><md-icon \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) !== \'EXPIRED\')\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon><md-tooltip \nmd-direction=\"top\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip>\n{{($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') ? \'Expired\' : \'Confirm Quote\'}}\n</md-button><md-button md-no-ink class=\"md-accent-btn Font-Bold mh-0 mb-15 w-100\" \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && !$ctrl.copyquoted && !$ctrl.proceedduplicate\" \nng-disabled=\"$ctrl.ratecardselection || !$ctrl.isWebView && ( $ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.isquotemodify || $ctrl.quoteresult.result_data.revised || $ctrl.isLost || $ctrl.isExpired)\" \nng-style=\"{ \'cursor\' : ($ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.quoteresult.result_data.revised || $ctrl.isquotemodify || $ctrl.isLost || $ctrl.isExpired)  ? \'not-allowed\' : \'pointer\' }\" \ntitle=\"Confirm Quote\" ng-click=\"$ctrl.requestToBook($ctrl.carddata)\">Confirm Quote</md-button></div></div><div \nlayout=\"row\" layout-align=\"start start\" ng-if=\"$ctrl.quoteType===\'copyQuote\'\"><div layout=\"row\" \nlayout-align=\"start start\" ng-if=\"!$ctrl.util.isShipper\" class=\"mt-5\"><md-button md-no-ink \nclass=\"md-primary-btn with-icon w-40 icon-width\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'newCopyQuote\',$ctrl.carddata.meta.type)\"><md-icon \nmd-svg-icon=\"assets/icons/custom/copyQuote.svg\"></md-icon><md-tooltip md-direction=\"top\">Copy</md-tooltip></md-button>\n<md-button md-no-ink layout=\"row\" layout-align=\"center center\" class=\"md-primary-btn with-icon w-40 icon-width\" \nng-if=\"$ctrl.util.navPermission.quotes[3] && !$ctrl.proceedduplicate\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata, $ctrl.index,\'copyQuote\')\"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon class=\"icon-width\" md-font-icon=\"icon-delete\"></md-icon></md-button><md-button md-no-ink \nlayout=\"row\" layout-align=\"center center\" class=\"md-primary-btn with-icon w-40 icon-width\" \nng-if=\"$ctrl.util.navPermission.quotes[2] && !$ctrl.proceedduplicate\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotationEdit\',$ctrl.carddata.meta.type)\"><md-tooltip \nmd-direction=\"top\">Edit</md-tooltip><md-icon class=\"icon-width\" md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</div></div></div><div class=\"overlay_expire\" \nng-if=\"!($ctrl.parentPage == \'result\') && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')\">\n</div><div class=\"overlayCard hide\" ng-style=\"$ctrl.getCardHeight($ctrl.carddata._id + \'_card\')\" \nid=\"{{$ctrl.carddata._id +\'_\'+ $ctrl.index + \'_askDeletecard\'}}\"><div class=\"viewDetails text-center\"><md-icon \nmd-svg-src=\"assets/icons/custom/delete-card.svg\" class=\"w-105 h-45\"></md-icon><div \nclass=\"font-size-13 font-weight-bold mv-10\">Do you want to delete this rate card ?</div><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"s40 red-fg\" \nng-click=\"$ctrl.cancelDeleteCard($event,$ctrl.carddata._id, $ctrl.index)\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\n          \" class=\"s40 green-fg\" \nng-click=\"$ctrl.removeCardFromQuote($event,$ctrl.carddata, $ctrl.index)\"></md-icon></div></div></div><div \nclass=\"overlayCard hide\" ng-style=\"$ctrl.getCardHeight($ctrl.carddata._id + \'_card\')\" \nid=\"{{$ctrl.carddata._id +\'_\'+ $ctrl.index + \'_deletecard\'}}\"><div class=\"viewDetails text-center\"><md-icon \nmd-font-icon=\"icon-replay\" class=\"s40 grey-400-fg\" ng-click=\"$ctrl.undoDeleteCard($event,$ctrl.carddata, $ctrl.index)\">\n</md-icon><div class=\"grey-fg font-size-16 pt-10\" ng-click=\"$ctrl.undoDeleteCard($event,$ctrl.carddata, $ctrl.index)\">\nTap to Undo Delete</div></div></div></div>");
$templateCache.put("app/main/component/result-card/rate-card-mobile.html","<div id=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_id}}\" layout=\"row\" layout-wrap \nclass=\"list_view_div md-brad\" \nng-class=\"{ \'rate_card_selected\': $ctrl.parentPage===\'result\' && $ctrl.carddata.meta.is_selected, \'rate_card_expiry\': $ctrl.parentPage == \'result\' && $ctrl.search_param.mode === \'SEA-FCL\'  && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')}\">\n<div layout=\"row\" flex=\"100\" layout-align=\"space-around center\" class=\"pt-15 ph-15 pb-5 br\" \nng-if=\"$ctrl.proceedduplicate && !ctrl.copyquoted && (!($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') || $ctrl.carddata.meta.type.includes(\'spot\'))\">\n<div layout=\"column\" flex=\"100\" layout-align=\"start start\"><md-checkbox class=\"w-50\" md-no-ink \nng-click=\"$ctrl.selectedDuplicateQuote($ctrl.carddata)\"></md-checkbox></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-around center\" class=\"pt-15 ph-15 pb-5 br\"><div layout=\"column\" flex=\"100\" \nlayout-align=\"start start\"><div ng-if=\"$ctrl.search_param.mode != \'AIR\' && !$ctrl.maskLiner\"><div \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\" \nng-show=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"$ctrl.search_param.mode == \'AIR\' && !$ctrl.maskLiner\"><div \nclass=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}</div></div><div layout=\"row\" \nlayout-align=\"center start\" ng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.maskLiner\"><div \nng-if=\"$ctrl.maskv2 && $ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code]\">\n<div ng-if=\"$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].logo\">\n<img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].logo)}}\" \nalt=\"{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name}}\"></div>\n<div class=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name  ?  $ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name: $ctrl.maskLinerText}}\" \nng-if=\"!$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].logo && $ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name\">\n{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name}}<md-tooltip \nmd-direction=\"top\">\n{{$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name}}</md-tooltip>\n</div></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name && $ctrl.maskLinerText\">\n<span layout-align=\"space-around center\">{{$ctrl.maskLinerText}}<md-tooltip md-direction=\"top\">{{$ctrl.maskLinerText}}\n</md-tooltip></span></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskLinerText && !$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code]\">\n<div ng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"empty_logo text-truncate\" ng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\" \nlayout-align=\"space-around center\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}<md-tooltip \nmd-direction=\"top\">{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\n</md-tooltip></div></div></div><div layout=\"row\" layout-align=\"center start\" \nng-if=\"$ctrl.search_param.mode == \'AIR\' && $ctrl.maskLiner\"><div \nng-if=\"$ctrl.maskAirline && $ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code]\">\n<div ng-if=\"$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].logo\">\n<img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].logo)}}\" \nalt=\"{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name}}\">\n</div><div class=\"empty_logo text-truncate\" \ntitle=\"{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name ? $ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name: $ctrl.maskLinerText}}\" \nng-if=\"!$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].logo && $ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name\">\n{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name}}<md-tooltip\n md-direction=\"top\">\n{{$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name}}\n</md-tooltip></div></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code].name && $ctrl.maskLinerText\">\n<span layout-align=\"space-around center\">{{$ctrl.maskLinerText}}<md-tooltip md-direction=\"top\">{{$ctrl.maskLinerText}}\n</md-tooltip></span></div><div class=\"empty_logo text-truncate\" \nng-if=\"!$ctrl.maskLinerText && !$ctrl.maskAirline[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.airline_code]\">\n<div ng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\"></div><div \nclass=\"empty_logo text-truncate\" ng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\" \nlayout-align=\"space-around center\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}<md-tooltip md-direction=\"top\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}</md-tooltip></div></div></div>\n<div layout=\"row\" layout-align=\"start start\" class=\"mv-2\" ng-if=\"!$ctrl.carddata.meta.isError\"><span \nclass=\"ellipsis-80 font-size-8 pointer\" ng-if=\"!$ctrl.maskLiner\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n</md-tooltip></span><span class=\"ph-3 font-size-8\" \nng-if=\"($ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.service_name) && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type\">\n|</span><span class=\"ellipsis-80 font-size-8 pointer\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\' && $ctrl.carddata.meta.selected_schedule && !$ctrl.maskLiner\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n</md-tooltip></span><span class=\"ellipsis-80 font-size-8 pointer mv-5\" \nng-if=\"!(($ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.service_name)   && !$ctrl.maskLiner || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type)\">\nN/A</span><div class=\"fg-AAA8AD Font-Bold font-size-9 mv-5\" layout=\"row\" \nng-if=\"($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number  && (!$ctrl.carddata.meta.type.includes(\'network\')  ||  $ctrl.carddata.data.buy_rates[$ctrl.l3_leg].rate_obj.show_contract_number) && (!$ctrl.util.isShipper || ($ctrl.util.isShipper && $ctrl.showContractShipper)))\">\n<span class=\"fg-333333 pl-5 Font-Bold contractIdTruncate\" style=\"-webkit-box-orient: vertical\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number }}</span></div><div \nclass=\"grey-fg font-size-8 ml-10\" layout=\"row\" \nng-show=\"!$ctrl.maskLiner && $ctrl.util.showRateIdForContract($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.tags)\">\n<span ng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id \">Rate ID</span><div \nclass=\"fg-343434 pl-5 Font-Bold ellipsis-80 pointer\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id \">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 p-10 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id? \'\' :$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id}}\n</div></md-tooltip></div><span class=\"solid-bb pointer mh-8 fg-343434 Font-Bold\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'tnc\', $ctrl.carddata.meta.type);$ctrl.trackEvent(\'tnc\')\" \nng-if=\"$ctrl.carddata.meta.type.includes(\'spot\') && ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.data || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.url)\">\nT&C</span></div></div></div><div layout=\"column\" flex=\"100\" layout-align=\"center end \"><div div-slide-show><div \nlayout=\"row\" class=\"mv-5\" ng-repeat=\"tag in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.tags\" \nng-if=\"tag.show_tag  && !$ctrl.maskLiner\"><img ng-src=\"{{$ctrl.util.sanitizeQueryParams(tag.tag_ribbon_url)}}\">\n<md-tooltip md-direction=\"top\" style=\"display:table;opacity: 1\" \nclass=\"white-fg bg-343434 font-size-14 pv-5 text-center Font-Bold\" \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.rollable_available\"><div>Rollable available</div>\n</md-tooltip></div></div><div class=\"mv-5\" \nng-show=\"$ctrl.parentPage===\'result\' && ($ctrl.util.isAdmin || $ctrl.util.isFreightbro) && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.manual && $ctrl.search_param.freight_charges\">\n<div class=\"font-size-10 Font-Bold added-by-tag w-100\">added by you</div></div><div class=\"h-25\" \nng-show=\"$ctrl.parentPage===\'result\' && ($ctrl.util.isAdmin || $ctrl.util.isFreightbro) && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.manual && $ctrl.search_param.freight_charges\">\n<span class=\"pr-8 mr-5\" ng-click=\"$ctrl.openEditCardModal($event,$ctrl.carddata)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 black-fg h-15 pointer\" title=\"Edit\"></md-icon></span><span class=\"pl-5 ml-5\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata, $index)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s16 black-fg h-15 pointer\" title=\"Delete\"></md-icon></span></div><div \nclass=\"fg-3F3851 font-size-10 Font-Bold mv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions.length  && !$ctrl.maskLiner\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"fg-0ABF54 s14 mb-2\"></md-icon><span \nng-repeat=\"promotion in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions track by $index\">\n{{$first ? \'\' : \', \'}} {{promotion.name}}</span></div></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-around center\" class=\"pv-5 ph-10 br\"><div layout=\"column\" \nflex=\"{{$ctrl.search_param.mode ==\'AIR\' ? 75 : 100}}\" layout-align=\"start start\"><port-to-port \nclass=\"width-percent-70\" card=\"$ctrl.carddata\" buyorsell=\"$ctrl.buyOrSell\" mode=\"$ctrl.search_param.mode\" \nng-if=\"$ctrl.carddata.meta.isScheduleCall\"></port-to-port><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" \nshimmer-effect-full width=\"60px\" height=\"30px\" class=\"pl-10\"></div></div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center start\" \nng-if=\"$ctrl.search_param.mode ==\'AIR\' && $root.domainData.domain_info.RESULT_CONFIG.SHOW_FREIGHT_COST && (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 || $ctrl.carddata.meta.is_selected) && !$ctrl.carddata.meta.isError\">\n<div class=\"ph-10 Font-Bold text-center\"><div class=\"font-size-10 fg-AAA8AD\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab }} slab</div><div \nclass=\"font-size-10 fg-3F3851 ml-5\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_currency }} {{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} /kg\n</div></div></div><div layout=\"column\" flex=\"100\" layout-align=\"center start\" \nng-if=\"$ctrl.search_param.mode ==\'AIR\' && $root.domainData.domain_info.RESULT_CONFIG.SHOW_FREIGHT_COST && ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 && !$ctrl.carddata.meta.is_selected)\">\n<div layout=\"row\" class=\"h-50 Font-Bold font-size-10\" flex=\"100\"><div \nng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_1\'}\" class=\"w-80 pointer\" flex layout=\"column\" \nlayout-align=\"center center\" ng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_1\')\"><div class=\"fg-AAA8AD\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab }} slab</div><div class=\"md-link-fg\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_currency }} {{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_cost / ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} /kg\n</div></div><div ng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_2\'}\" class=\"w-80 pointer\" flex \nlayout=\"column\" layout-align=\"center center\" ng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_2\')\"><div \nclass=\"fg-AAA8AD\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab }} slab</div><div \nclass=\"grey-fg\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_currency }} {{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} /kg\n</div></div></div></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start center\" layout-wrap class=\"ph-5 br\"><div\n layout=\"row\" flex=\"75\" layout-align=\"start start\" layout-wrap ng-if=\"!$ctrl.carddata.meta.isError\"><div \nclass=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.mode == \'SEA-FCL\'\"><div class=\"font-size-8 fg-3F3851\">Sailing Date<md-icon\n md-svg-src=\"assets/icons/custom/event_available.svg\" class=\"w-15 h-15 ml-2 schedule_available_icon\" \nng-if=\"$ctrl.carddata.data.buy_rates[$ctrl.l3_leg].rate_obj.schedule.is_schedule_available_in_cache\"><md-tooltip \nclass=\"white-fg bg-343434 font-size-11\" md-direction=\"top\">Schedules Available</md-tooltip></md-icon></div><div \nclass=\"font-size-10 fg-333333 Font-Bold ellipsis-name\" ng-show=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule === null && !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sailing_date ? \'-\' : ($ctrl.carddata.meta.selected_schedule.departure_time ? $ctrl.carddata.meta.selected_schedule.departure_time : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\')}}\n</div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div></div>\n<div class=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\"><div class=\"font-size-8 fg-3F3851\">ETD<md-icon \nclass=\"pl-5 s12 fg-AAA8AD\" md-font-icon=\"icon-information-outline\"><md-tooltip class=\"white-fg bg-343434 font-size-11\" \nmd-direction=\"top\">Estimated Time Of Departure</md-tooltip></md-icon></div><div \nclass=\"font-size-10 fg-333333 Font-Bold\" ng-show=\"$ctrl.carddata.meta.isScheduleCall\"><span \nng-if=\"$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.meta.selected_schedule ? ($ctrl.carddata.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}} \n</span><span ng-if=\"!$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.departure_time ? ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.departure_time | UTCToLocal : \'d MMM yyyy\') : \'-\'}}\n</span></div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div>\n</div><div class=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\"><div class=\"font-size-8 fg-3F3851\">ETA<md-icon \nclass=\"pl-5 s12 fg-AAA8AD\" md-font-icon=\"icon-information-outline\"><md-tooltip class=\"white-fg bg-343434 font-size-11\" \nmd-direction=\"top\">Estimated Time Of Arrival</md-tooltip></md-icon></div><div class=\"font-size-10 fg-333333 Font-Bold\" \nng-show=\"$ctrl.carddata.meta.isScheduleCall\"><span ng-if=\"$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.meta.selected_schedule ? ($ctrl.carddata.meta.selected_schedule.arrival_time | UTCToLocal : \'d MMM yyyy | HH:mm\') : \'-\'}} \n</span><span ng-if=\"!$ctrl.carddata.meta.selected_schedule\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.arrival_time ? ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.arrival_time | UTCToLocal : \'d MMM yyyy\') : \'-\'}}\n</span></div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div>\n</div><div class=\"ph-10 pv-5\"><div class=\"font-size-8 fg-3F3851\">Transit Time</div><div \nclass=\"font-size-10 fg-333333 Font-Bold ellipsis-name\" ng-show=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule ?(!$ctrl.carddata.meta.selected_schedule.transit_time ? \'-\' : $ctrl.carddata.meta.selected_schedule.transit_time) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'-\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n</div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div></div>\n<div class=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.mode != \'AIR\'\"><div class=\"font-size-8 fg-3F3851\">Free Days</div><div\n class=\"font-size-10 fg-333333 Font-Bold ellipsis-name\"><free-days \nfreedaysdata=\"{\n              demurrage_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.demurrage_details,\n              detention_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detention_details,\n              combined_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.combined_details,\n              freeDays : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.freeDays,\n              pageSource : $ctrl.parentPage+$ctrl.quoteType+\'RateCard\'\n\n            }\" \ntype=\"\'list-nwls\'\" cardid=\"$ctrl.carddata._id\" mode=\"$ctrl.search_param.mode\" \nsearch-load-data=\"$ctrl.search_param.load_data.load_details_value\"></free-days></div></div><div class=\"ph-5 pv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length\">\n<div class=\"font-size-8 fg-3F3851\">Cargo</div><div class=\"font-size-10 fg-333333 Font-Bold\" layout=\"row\"><div \nclass=\"ellipsis-name text-capitalize\"><span \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data.name }} <span \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length\">|</span> </span>\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data[0].toLowerCase() }}</div><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer cargo-{{$ctrl.carddata._id}}\" \nng-click=\"$ctrl.shareQuoteService.showCargoCommodity($event, $ctrl.carddata._id, $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg],\'result\', $ctrl.search_param.mode);$ctrl.trackEvent(\'cargoHover\')\">\n</md-icon></div></div></div><div class=\"ph-5 pv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code\"><div \nclass=\"font-size-8 fg-3F3851\">Named Account Code</div><div class=\"font-size-10 fg-333333 Font-Bold\" layout=\"row\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code}}</div></div><div class=\"ph-5 pv-5\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n<div class=\"font-size-8 fg-3F3851\" layout=\"row\">Effective Period <span \nng-if=\"$ctrl.parentPage == \'result\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')\" \nclass=\"expired-status text-truncate\" \ntitle=\"{{$ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)}}\">\n{{$ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)}}</span></div><div \nlayout=\"row\" class=\"font-size-10 fg-333333 Font-Bold\" \nng-class=\"{\'fg-F43F5E\': $ctrl.parentPage == \'result\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')}\">\n<div \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n{{($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date | NoTimeZone : \'d MMM yyyy\') + \" - \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\')}}\n</div><div \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n{{\"Till \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\')}}</div>\n<div \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.start_date && !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\">\n{{\"From \" + ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\')}}</div>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"s14 fg-3F3851 pointer effective-period-{{$ctrl.carddata._id}}\" \nng-if=\"$ctrl.util.fnCheckLoadExpiryLength($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detailed_effective_load , $ctrl.search_param.load_data.load_details_value) &&  $ctrl.search_param.mode === \'SEA-FCL\' \" \nng-click=\"$ctrl.shareQuoteService.showEffectivePeriodPanel($event,$ctrl.carddata._id,$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detailed_effective_load , $ctrl.search_param.load_data.load_details_value)\">\n</md-icon></div></div><div class=\"ph-10 pv-5\" \nng-if=\"$ctrl.search_param.mode == \'AIR\' && (!$ctrl.util.isShipper && !$ctrl.util.isSharedQuote()) && ($ctrl.carddata.meta.type != \'msr_spot\' && $ctrl.carddata.meta.type != \'network_spot\') \">\n<div class=\"font-size-8 fg-3F3851\">\nRates by {{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? \'Agent \' : \'Forwarder \' }}\n</div><div class=\"font-size-10 fg-333333 Font-Bold ellipsis-name\"><span>\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n</span><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n</md-tooltip></div></div><div class=\"ph-10 pv-5\" \nng-if=\"$ctrl.search_param.mode == \'AIR\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.frequency\"><div \nclass=\"font-size-11 fg-AAA8AD\">Frequency</div><div class=\"font-size-12 fg-333333 Font-Bold\" \nng-show=\"$ctrl.carddata.meta.isScheduleCall\">{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.frequency}}\n</div><div ng-show=\"!$ctrl.carddata.meta.isScheduleCall\" shimmer-effect-full width=\"40px\" height=\"20px\"></div></div>\n<div ng-repeat=\"feilds in $ctrl.customFeilds track by $index\"><div class=\"ph-10 pv-5\" \nng-if=\"feilds.value && feilds.uiLocation.includes (\'RATECARD\')\"><div class=\"font-size-11 fg-AAA8AD\">{{feilds.label}}\n</div><div class=\"font-size-12 fg-333333 Font-Bold line-height-12 text-truncate max-width-155\" layout=\"row\">\n{{feilds.value}}</div><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">{{feilds.value}}</md-tooltip></div></div><div class=\"ph-10 pv-5\" \nng-if=\"$ctrl.carddata.meta.co2eData\"><div class=\"font-size-8 fg-3F3851\"><md-icon \nmd-svg-src=\"assets/icons/custom/co2-icon.svg\" class=\"icon-class-10 mr-5\"></md-icon>CO<sub>2</sub> emission</div><div \nclass=\"font-size-10 fg-333333 Font-Bold\" layout=\"row\"><div class=\"ellipsis-name\">\n{{($ctrl.carddata.meta.co2eData.co2e.total | currencyMask: 2) +\' \' +\'g\'}}</div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s14 fg-3F3851 pointer co2e-{{$ctrl.carddata._id}}\" \nng-click=\"$ctrl.shareQuoteService.showCo2ContainerData($event, $ctrl.carddata._id, $ctrl.carddata.meta.co2eData)\">\n</md-icon></div></div><div class=\"ph-10 pv-5 ml-auto\" \nng-if=\"$ctrl.carddata.partner_reference_id && !$ctrl.util.isShipper\"><div \nclass=\"font-size-8 fg-3F3851 intergration-code\">CW Quotation No</div><div layout=\"row\"><div \nclass=\"font-size-10 fg-333333 Font-Bold ellipsis-name\">{{$ctrl.carddata.partner_reference_id}}</div><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s16 pl-5 pointer content-copy z-2\" ng-if=\"$ctrl.carddata.partner_reference_id\" \nng-click=\"$ctrl.fnCopyID( $ctrl.carddata.partner_reference_id)\"><md-tooltip md-direction=\"top\">{{$ctrl.isIdCopied}}\n</md-tooltip></md-icon></div></div><div class=\"ph-5 pv-5 center-align\" \nng-if=\"$ctrl.carddata.partner_reference_id && !$ctrl.util.isShipper\" layout=\"row\"><div \nclass=\"font-size-12 intergration-code-failed Font-Bold pointer\" \nng-if=\"$ctrl.carddata.document_details.sync_status.toLowerCase() === \'failed\'\" layout=\"row\" \nng-click=\"$ctrl.reSyncTmsData($ctrl.carddata)\"><div class=\"ellipsis-name text-capitalize pl-5\"><md-icon \nmd-font-icon=\"icon-sync\" class=\"s16 fg-F43F5E\"></md-icon>Sync PDF Again</div></div><div \nclass=\"font-size-12 intergration-code-success Font-Bold\" \nng-if=\"$ctrl.carddata.document_details.sync_status.toLowerCase() === \'success\'\" layout=\"row\"><div \nclass=\"ellipsis-name text-capitalize pl-5\">PDF Synced</div></div></div></div><div ng-if=\"$ctrl.carddata.meta.isError\" \nclass=\"pt-10 pb-10\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"alert-icon ml-15 orange-400-fg\"></md-icon><div class=\"message-style\" \nng-bind-html=\"$ctrl.util.escapeHtml($ctrl.carddata.meta.error) | charlengthEllipsis: 35\"></div><div \nclass=\"link-style font-size-11 noRates-{{$ctrl.carddata._id}}\" ng-if=\"$ctrl.carddata.meta.error.length > 35\" \nng-click=\"$ctrl.ShowNoRatesInfo($event, $ctrl.carddata._id, $ctrl.carddata.meta.error)\">Show More</div></div><div \nlayout=\"row\" layout-align=\"start start\" ng-if=\"!$ctrl.all_in_rates.length\" \nflex=\"{{$root.domainData.domain_info.RESULT_CONFIG.SHOW_LANDING_COST && $root.domainData.domain_info.RESULT_CONFIG.SHOW_FREIGHT_COST ? 100 : 25}}\">\n<div layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"$ctrl.search_param.mode !=\'AIR\' && $root.domainData.domain_info.RESULT_CONFIG.SHOW_FREIGHT_COST && !$ctrl.hideLegTotal && (!$root.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL || $ctrl.util.isShipper || $ctrl.isShared)\">\n<div class=\"ph-10 pv-5\" ng-if=\"$ctrl.search_param.freight_charges\"><div class=\"font-size-8 fg-3F3851\">Freight <span \nng-if=\"!$ctrl.util.isShipper && !$ctrl.isShared\">Sell</span> Rate</div><div \nclass=\"font-size-10 fg-333333 Font-Bold ellipsis-name\" ng-if=\"!$ctrl.carddata.meta.isError\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_currency}} {{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_currency_cost | currencyMask: 2 }}\n</div><div ng-if=\"$ctrl.carddata.meta.isError\">N/A</div></div></div><div \nng-if=\"$ctrl.search_param.mode != \'AIR\' && ($root.domainData.domain_info.RESULT_CONFIG.SHOW_BUY_TOTAL && !$ctrl.util.isShipper && !$ctrl.isShared)\">\n<div class=\"font-size-8 fg-3F3851 line-height-unset letter-spacing-0-33\">Total Buy Rate</div><div \nclass=\"font-size-10 fg-333333 pt-2 Font-Bold ellipsis-name\" ng-if=\"!$ctrl.carddata.meta.isError\">\n{{ $ctrl.searchparam.user.user_base_currency }} {{ $ctrl.carddata.meta.buy_leg_total | currencyMask: 2 }}<md-icon \nng-if=\"!$ctrl.hideLegTotal\" md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer card-{{$ctrl.carddata._id}}-buy\" \nng-click=\"$ctrl.showCostBreakdown($ctrl.carddata, $event, \'buy_rates\')\"></md-icon></div><div class=\"font-size-16 w-80\" \nng-if=\"$ctrl.carddata.meta.isError\">N/A</div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"$root.domainData.domain_info.RESULT_CONFIG.SHOW_LANDING_COST\"><div class=\"ph-10 pv-5\"><div \nclass=\"font-size-8 fg-3F3851\">Total <span ng-if=\"!$ctrl.util.isShipper && !$ctrl.isShared\">Sell</span> Rate<md-button \nmd-no-ink class=\"m-0 p-0 line-height-unset cost-icon\" ng-click=\"$ctrl.trackEvent(\'spotHover\')\" \nng-if=\"!$ctrl.carddata.meta.isError\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s10 mb-2 grey-fg pointer\" \nng-if=\"$ctrl.carddata.meta.type.includes(\'spot\')\"></md-icon><md-tooltip md-direction=\"bottom\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-10\" style=\"display:table;opacity: 1\">Spot Rates are dynamic & can\n<br>fluctuate with time</md-tooltip></md-button><span ng-switch=\"$ctrl.carddata.meta.partialRate\" class=\"pointer\"><span\n ng-switch-when=\"rmk-inc\">*<md-tooltip md-direction=\"top\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-10\" \nstyle=\"display:table;opacity: 1\">Subject to Remarks</md-tooltip></span></span><span \nng-if=\"$ctrl.carddata.meta.missingFlag.length\" class=\"pointer\"><md-button md-no-ink \nclass=\"m-0 p-0 line-height-unset cost-icon\" ng-click=\"$ctrl.trackEvent(\'missingHover\')\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s12 mb-2 ml-2 orange-400-fg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold\" style=\"display:table;opacity: 1\"><span \nng-repeat=\"flag in $ctrl.carddata.meta.missingFlag\">{{ flag }}<br></span></md-tooltip></md-button></span></div><div \nclass=\"font-size-10 fg-333333 Font-Bold ellipsis-name\" ng-if=\"!$ctrl.carddata.meta.isError\">\n{{ $ctrl.searchparam.user.user_base_currency }} {{ $ctrl.carddata.meta[$ctrl.resultfilter.total_cost] | currencyMask: 2 }}\n</div><div ng-if=\"$ctrl.carddata.meta.isError\">N/A</div></div></div></div><div layout=\"row\" flex=\"100\" \nng-class=\"{\'mt-40\' :($ctrl.proceedduplicate)}\" ng-if=\"$ctrl.all_in_rates.length\"><div layout=\"row\" flex=\"100\"><table \nclass=\"all_in_rates_table tableFullWidth\"><thead><th class=\"justify-items-center bt-1\"><div class=\"currency-class\">\n{{ $ctrl.all_in_rates[0].currency }}</div></th><th ng-repeat=\"typeValue in $ctrl.all_in_rates\" class=\"bt-1\">\n{{typeValue.container_type}}</th></thead><tbody><tr><td class=\"label-class\">All in rates per Equipment</td><td \nng-repeat=\"typeValue in $ctrl.all_in_rates\" class=\"ellipsis-50\">{{typeValue.rates.per_equipment | currencyMask: 2}}\n<md-tooltip md-direction=\"top\">{{typeValue.rates.per_equipment | currencyMask: 2}}</md-tooltip></td></tr><tr><td \nclass=\"label-class\">All in rates per B/L</td><td ng-repeat=\"typeValue in $ctrl.all_in_rates\" class=\"ellipsis-50\">\n{{typeValue.rates.per_bl | currencyMask: 2}}<md-tooltip md-direction=\"top\">{{typeValue.rates.per_bl | currencyMask: 2}}\n</md-tooltip></td></tr></tbody></table></div></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start center\" \nlayout-wrap class=\"pt-5 pb-15 ph-15 br\"><div layout=\"row\" flex layout-align=\"start start\" layout-wrap><div \nlayout=\"row\" layout-align=\"start start\" ng-if=\"$ctrl.parentPage===\'quotes\' && $ctrl.quoteType!==\'copyQuote\'\"><div \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry || $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) !== \'EXPIRED\'\">\n<md-button ng-if=\"(!$ctrl.showeditbtn && !$ctrl.iscopyquote && !$ctrl.proceedduplicate) || $ctrl.util.isShipper\" \nng-disabled=\"$ctrl.ratecardselection\" md-no-ink class=\"md-primary-btn Font-Bold mh-0 mb-15 w-120\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotation\')\">View Details</md-button><div layout=\"row\" \nlayout-align=\"space-between start\" ng-if=\"($ctrl.showeditbtn || $ctrl.iscopyquote) && !$ctrl.standardquote \" \nclass=\"mt-5\"><md-button md-no-ink layout=\"row\" layout-align=\"center center\" \nclass=\"margin-card-btn remove_card_btn w-70 mr-3\" \nng-if=\"$ctrl.util.navPermission.quotes[3] && !$ctrl.proceedduplicate\" ng-disabled=\"$ctrl.ratecardselection\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata, $ctrl.index)\">Delete</md-button><md-button md-no-ink \nlayout=\"row\" layout-align=\"center center\" class=\"margin-card-btn md-primary-btn with-icon w-70\" \nng-if=\"$ctrl.util.navPermission.quotes[2] && !$ctrl.proceedduplicate\" ng-disabled=\"$ctrl.ratecardselection\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotationEdit\',$ctrl.carddata.meta.type)\">Edit</md-button>\n</div></div><div layout=\"row\" layout-align=\"start start\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\'\" \nclass=\"mt-5\"><md-button md-no-ink layout=\"row\" layout-align=\"center center\" class=\"margin-card-btn expired_view_btn\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotation\')\"><md-icon md-font-icon=\"icon-eye\" class=\"eye-icon\">\n</md-icon></md-button></div></div><div layout=\"row\" layout-align=\"start start\" \nng-if=\"$ctrl.parentPage===\'quotes\' && $ctrl.quoteType===\'copyQuote\'\"><md-button \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'newCopyQuote\',$ctrl.carddata.meta.type)\" md-no-ink \nclass=\"md-primary-btn with-icon w-40 icon-width\"><md-icon md-svg-icon=\"assets/icons/custom/copyQuote.svg\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"$ctrl.parentPage!=\'quotes\'\"><md-button md-no-ink \nng-if=\"$ctrl.util.isShipper\" ng-disabled=\"$ctrl.carddata.meta.isError\" class=\"md-accent-btn Font-Bold mh-0 mb-15 w-95\" \nng-click=\"$ctrl.requestToBook($ctrl.carddata, \'fromCard\')\" \nng-disabled=\"!$ctrl.util.navPermission.shipments[0] || $ctrl.generateQuoteBtn || !$ctrl.carddata.meta.isScheduleCall\">\nProceed</md-button><md-button md-no-ink layout=\"row\" layout-align=\"center center\" \nclass=\"margin-card-btn remove_card_btn w-90\" ng-if=\"!$ctrl.util.isShipper && $ctrl.carddata.meta.is_selected\" \nng-click=\"$ctrl.removeCard($ctrl.carddata)\"><md-icon md-font-icon=\"icon-delete\" class=\"s14 remove-icon m-0 mr-3\">\n</md-icon>Remove</md-button></div></div><div layout=\"row\" flex layout-align=\"end start\" layout-wrap \nng-if=\"$ctrl.quoteType!==\'copyQuote\'\"><div layout=\"row\" class=\"ml-10\" \nng-if=\"($ctrl.util.navPermission.shipments[0] && $ctrl.showbookbtn && $ctrl.parentPage===\'quotes\') || $ctrl.isShared \">\n<md-button md-no-ink class=\"md-accent-btn Font-Bold mh-0 mb-15 w-100\" \nng-class=\"{ \'w-125\': $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) !== \'EXPIRED\')}\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && !$ctrl.iscopyquote\" \nng-disabled=\"( $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) == \'EXPIRED\' || $ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.isquotemodify || $ctrl.quoteresult.result_data.revised || $ctrl.isLost || $ctrl.isExpired || $ctrl.ratecardselection )\" \nng-style=\"{ \'cursor\' : (($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') || $ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.quoteresult.result_data.revised || $ctrl.isquotemodify || $ctrl.isLost || $ctrl.isExpired )  ? \'not-allowed\' : \'pointer\' }\" \nng-click=\"$ctrl.requestToBook($ctrl.carddata)\"><md-icon \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) !== \'EXPIRED\')\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon><md-tooltip \nmd-direction=\"top\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip>\n{{($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') ? \'Expired\' : \'Confirm Quote\'}}\n</md-button><md-button md-no-ink class=\"md-accent-btn Font-Bold mh-0 mb-15 w-100\" \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && !$ctrl.iscopyquote\" \nng-disabled=\"( $ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.isquotemodify || $ctrl.quoteresult.result_data.revised || $ctrl.isLost || $ctrl.isExpired || $ctrl.ratecardselection )\" \nng-style=\"{ \'cursor\' : ($ctrl.quotePreview || $ctrl.quoteresult.result_data.is_booked || $ctrl.quoteresult.result_data.revised || $ctrl.isquotemodify || $ctrl.isLost || $ctrl.isExpired )  ? \'not-allowed\' : \'pointer\' }\" \ntitle=\"Confirm Quote\" ng-click=\"$ctrl.requestToBook($ctrl.carddata)\">Confirm Quote</md-button></div><div \nng-if=\"$ctrl.parentPage!==\'quotes\'\"><md-button md-no-ink layout=\"row\" layout-align=\"center center\" \nclass=\"margin-card-btn md-accent-btn with-icon w-100\" ng-if=\"$ctrl.carddata.meta.is_selected\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type)\"><md-icon \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>Edit Charge\n<md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip></md-button>\n<md-button md-no-ink ng-disabled=\"$ctrl.carddata.meta.isError\" \nng-class=\"{\'md-primary-btn\': $ctrl.util.isShipper, \'md-accent-btn\' : !$ctrl.util.isShipper}\" \nclass=\"Font-Bold mh-0 mb-15 w-115\" ng-if=\"!$ctrl.carddata.meta.is_selected && !$ctrl.resultfilter.hideBookBtn\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type,false);$ctrl.trackEvent(\'createQuote\')\">\n<md-icon \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>View Details\n<md-tooltip md-direction=\"top\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.code == 1002 && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip></md-button>\n<md-button md-no-ink class=\"md-accent-btn Font-Bold mh-0 mb-15 w-100\" ng-disabled=\"$ctrl.carddata.meta.isError\" \nng-if=\"$ctrl.util.navPermission.quotes[0] && !$ctrl.carddata.meta.is_selected && $ctrl.resultfilter.hideBookBtn\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type,false);\">Add to quote\n</md-button></div></div><div layout=\"row\" flex layout-align=\"end start\" \nng-if=\"($ctrl.parentPage===\'quotes\' && $ctrl.quoteType===\'copyQuote\')\" class=\"mt-5\"><md-button md-no-ink layout=\"row\" \nlayout-align=\"center center\" class=\"md-primary-btn with-icon w-40 icon-width\" \nng-if=\"$ctrl.util.navPermission.quotes[3] && !$ctrl.proceedduplicate\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata, $ctrl.index,\'copyQuote\')\"><md-icon class=\"icon-width\" \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-button md-no-ink layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary-btn with-icon w-40 icon-width\" ng-if=\"$ctrl.util.navPermission.quotes[2] && !$ctrl.proceedduplicate\" \nng-click=\"$ctrl.viewQuoteDetails($ctrl.carddata,$event,\'quotationEdit\',$ctrl.carddata.meta.type)\"><md-icon \nclass=\"icon-width\" md-font-icon=\"icon-pencil\"></md-icon></md-button></div></div><div class=\"overlay_expire\" \nng-if=\"!($ctrl.parentPage == \'result\' && $ctrl.search_param.mode === \'SEA-FCL\') && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && ($ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\')\">\n</div><div class=\"overlayCard hide\" ng-style=\"$ctrl.getCardHeight($ctrl.carddata._id + \'_card\')\" \nid=\"{{$ctrl.carddata._id +\'_\'+ $ctrl.index + \'_askDeletecard\'}}\"><div class=\"viewDetails text-center\"><md-icon \nmd-svg-src=\"assets/icons/custom/delete-card.svg\" class=\"w-105 h-45\"></md-icon><div \nclass=\"font-size-13 font-weight-bold mv-10\">Do you want to delete this rate card ?</div><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"s40 red-fg\" \nng-click=\"$ctrl.cancelDeleteCard($event,$ctrl.carddata._id, $ctrl.index)\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\n            \" class=\"s40 green-fg\" \nng-click=\"$ctrl.removeCardFromQuote($event,$ctrl.carddata, $ctrl.index)\"></md-icon></div></div></div><div \nclass=\"overlayCard hide\" ng-style=\"$ctrl.getCardHeight($ctrl.carddata._id + \'_card\')\" \nid=\"{{$ctrl.carddata._id +\'_\'+ $ctrl.index + \'_deletecard\'}}\"><div class=\"viewDetails text-center\"><md-icon \nmd-font-icon=\"icon-replay\" class=\"s40 grey-400-fg\" ng-click=\"$ctrl.undoDeleteCard($event,$ctrl.carddata, $ctrl.index)\">\n</md-icon><div class=\"grey-fg font-size-16 pt-10\" ng-click=\"$ctrl.undoDeleteCard($event,$ctrl.carddata, $ctrl.index)\">\nTap to Undo Delete</div></div></div></div>");
$templateCache.put("app/main/component/result-card/rate-card-shimmer.html","<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-wrap class=\"list_view_div md-brad\"><div hide-sm hide-xs \nlayout=\"column\" flex=\"15\" flex-xs=\"100\" flex-sm=\"100\" layout-align=\"space-around center\" class=\"w-180 p-5 br\"><div \nshimmer-effect-full width=\"135px\" height=\"15px\"></div><div layout=\"column\"><div shimmer-effect-full width=\"105px\" \nheight=\"50px\"></div></div><div shimmer-effect-full width=\"135px\" height=\"15px\"></div></div><div layout=\"row\" flex \nflex-xs=\"100\" flex-sm=\"100\"><div layout=\"column\" flex=\"100\" class=\"pv-5\"><div layout=\"row\" flex=\"100\" class=\"bb p-10\">\n<div shimmer-effect-full width=\"160px\" height=\"35px\"></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div \nshimmer-effect-full width=\"60px\" height=\"25px\" class=\"mh-10 mt-8\"></div><div shimmer-effect-full width=\"60px\" \nheight=\"25px\" class=\"mt-8\"></div><div shimmer-effect-full width=\"50px\" height=\"25px\" class=\"ml-10 mt-8\"></div><div \nshimmer-effect-full width=\"40px\" height=\"25px\" class=\"ml-10 mt-8\"></div><div shimmer-effect-full width=\"100px\" \nheight=\"25px\" class=\"mh-10 mt-8\"></div></div></div></div><div layout=\"column\" flex=\"25\" flex-xs=\"100\" flex-sm=\"100\" \nlayout-align=\"space-between end\" ng-class=\"{\'w-262\' : !$ctrl.util.isMobileDevice}\" class=\"p-5 ph-15 bl\"><div hide-sm \nhide-xs layout=\"row\" flex=\"50\" layout-align=\"start end\" class=\"mv-5 Font-Bold\"><div layout=\"row\" flex=\"100\"><div \nshimmer-effect-full width=\"60px\" height=\"30px\" class=\"mh-10 mt-8\"></div><div shimmer-effect-full width=\"60px\" \nheight=\"30px\" class=\"mh-10 mt-8\"></div></div></div><div layout=\"row\" flex=\"50\" layout-align=\"end\" class=\"mb-5 mt-10\">\n<div layout=\"row\" layout-align=\"start start\" ng-if=\"$ctrl.util.isShipper\"><md-button md-no-ink \nclass=\"md-primary-btn mh-0 mb-15 w-95\"></md-button></div><md-button md-no-ink \nclass=\"md-accent-btn mh-0 ml-15 mb-15 w-120\"></md-button></div></div></div>");
$templateCache.put("app/main/component/result-card/result-horizontal-card.html","<div class=\"card-list\" id=\"resultHorizontal\"><div class=\"card-list-view\" \nng-if=\"$ctrl.resultfilter.deviceName == \'mobile\' && !$ctrl.showshimmer\"><div \nng-include=\"\'app/main/component/result-card/rate-card-mobile.html\'\"></div></div><div class=\"card-list-view\" \nng-if=\"$ctrl.resultfilter.deviceName != \'mobile\' && !$ctrl.showshimmer\"><div \nng-include=\"\'app/main/component/result-card/rate-card-desktop.html\'\"></div></div><div class=\"card-list-view\" \nng-if=\"$ctrl.showshimmer\"><div ng-include=\"\'app/main/component/result-card/rate-card-shimmer.html\'\"></div></div></div>");
$templateCache.put("app/main/component/result-card/result-vertical-card.html","<div id=\"wlsCardListView\"><div div-slide-show><div layout=\"row\" class=\"fb_rates_png\" \nng-repeat=\"tag in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.tags\" ng-if=\"tag.show_tag\"><img \nng-src=\"{{$ctrl.util.sanitizeQueryParams(tag.tag_ribbon_url)}}\"><md-tooltip md-direction=\"top\" \nstyle=\"display:table;opacity: 1\" class=\"font-size-14 pv-5 text-center font-weight-600\" \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.rollable_available\"><div>Rollable available</div>\n</md-tooltip></div><div layout=\"row\" class=\"fb_rates_png\" \nng-if=\"$ctrl.carddata.meta.type == \'network_rates\' && $ctrl.carddata.meta.vendor_id == 104 && $ctrl.user_category == \'FORWARDER\'\">\n<img src=\"assets/icons/custom/ribbon.png\"></div></div><md-icon class=\"md-link-fg\" \nmd-font-icon=\"icon-checkbox-marked-circle\" ng-if=\"$ctrl.carddata.meta.is_selected\" \nstyle=\"position:absolute;right:0px;top:0px\"></md-icon><div layout=\"row\" layout-align=\"space-between\" flex=\"100\"><div \nclass=\"card_tag\" flex=\"100\"></div><div layout=\"row\" layout-align=\"end start\" flex=\"100\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.manual\"><div class=\"pt-8 pr-10 display-content\">\n<span class=\"pr-8 mr-5 br mt-5\" ng-click=\"$ctrl.openEditCardModal($event,$ctrl.carddata)\" \nng-if=\"$ctrl.util.isAdmin || $ctrl.util.isFreightbro\"><md-icon md-svg-icon=\"assets/icons/custom/edit-icon.svg\" \nclass=\"w-15 h-15 icon_opacity pointer\" title=\"Edit\"></md-icon></span><span class=\"mt-5\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata)\" ng-if=\"$ctrl.util.isAdmin || $ctrl.util.isFreightbro\"><md-icon \nmd-svg-icon=\"assets/icons/custom/delete-icon.svg\" class=\"w-15 h-15 icon_opacity pointer\" title=\"Delete\"></md-icon>\n</span></div></div></div><div layout=\"row\" layout-align=\"space-between\" flex=\"100\"><div class=\"liner_logo\" \nng-if=\"$ctrl.search_param.mode != \'AIR\'\"><div \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"comp_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"text-truncate empty_logo comp_logo\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\" \nng-show=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div></div><div \nclass=\"liner_logo\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\"><div class=\"text-truncate empty_logo comp_logo\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}</div></div><div class=\"pr-15\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"font-size-10\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id\">RATE ID <span class=\"blue-400-fg\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id}}</span></span> <span \nclass=\"font-size-8 dotted-border-bottom pointer\" \nng-if=\"$ctrl.carddata.meta.type.includes(\'spot\') && ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.data || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.url)\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'tnc\', $ctrl.carddata.meta.type)\">T&C applicable<md-tooltip \nmd-direction=\"bottom\" class=\"md-whiteframe-2dp white-bg font-size-12 h-50 pt-5 text-center grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\"><div>Get Guaranteed Slot Upon</div><div>Booking Confirmation</div></md-tooltip></span>\n</div><div class=\"pr-15 font-size-10\" layout=\"column\" layout-align=\"center end\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\"><span class=\"key\">Expiry Date</span> <span \nclass=\"font-weight-bold red-400-fg\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | date : \'d MMM yyyy\'}}</span></div></div><div \nclass=\"blue-bg-fg font-size-10 brad-4 mh-15 mb-8\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions.length\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"blue-600-fg s14 mb-2 ml-5\"></md-icon><span \nng-repeat=\"promotion in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions track by $index\">\n{{$first ? \'\' : \', \'}} {{promotion.name}}</span></div><div layout=\"row\" class=\"ph-15 pt-10 pb-8\" flex=\"100\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\'\"><div flex layout=\"column\" layout-align=\"center start\"><div \nclass=\"grey-fg font-size-10\">Port of Loading</div><div \nclass=\"font-size-14 grey-700-fg font-weight-600 text-truncate mw-100\">\n{{ $ctrl.carddata.meta.via_pol ? $ctrl.carddata.meta.via_pol : $ctrl.carddata.meta.port_data.origin_port_code }} <span \nng-if=\"$ctrl.carddata.meta.via_pol || $ctrl.carddata.meta.port_data.pickup_location\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s16 black-fg\"></md-icon><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 p-10\" \nng-show=\"$ctrl.carddata.meta.via_pol || $ctrl.carddata.meta.port_data.pickup_location\" \nstyle=\"display:table;opacity: 1\"><div ng-if=\"$ctrl.carddata.meta.port_data.pickup_location\"><div class=\"grey-fg\">Pickup\n</div><div class=\"grey-800-fg Font-Bold text-truncate\">{{$ctrl.carddata.meta.port_data.pickup_location}}</div></div>\n<div class=\"grey-fg\">Port of {{ $ctrl.carddata.meta.via_pol ? \'Origin\' : \'Loading\' }}</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-truncate\">{{$ctrl.carddata.meta.port_data.origin_port_code}}</div><div \nng-if=\"$ctrl.carddata.meta.via_pol\"><div class=\"grey-fg\">Port of Loading</div><div \nclass=\"grey-800-fg font-weight-600 text-truncate\">{{$ctrl.carddata.meta.via_pol}}</div></div></md-tooltip></span></div>\n</div><div layout=\"column\" layout-align=\"center center\" class=\"h-42\"><div layout=\"row\"><div \nclass=\"grey-fg font-size-20\">. . .</div><div \nclass=\"grey-700-fg font-size-12 font-weight-600 pt-12 ph-5 text-truncate max-width-60\" \nng-if=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule ?(!$ctrl.carddata.meta.selected_schedule.transit_time ? \'N/A\' : $ctrl.carddata.meta.selected_schedule.transit_time) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'N/A\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg font-size-12 p-10\" style=\"display:table;opacity: 1\">\n<div class=\"grey-fg text-center\">Transit Time</div><div class=\"grey-fg font-weight-600 text-center\">\n{{ $ctrl.carddata.meta.selected_schedule ? (!$ctrl.carddata.meta.selected_schedule.transit_time ? \'Not Available\' : $ctrl.carddata.meta.selected_schedule.transit_time) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'Not Available\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n</div></md-tooltip></div><div ng-if=\"!$ctrl.carddata.meta.isScheduleCall\" class=\"loader\" \nstyle=\"margin-top: 12px !important\"></div><div class=\"grey-fg font-size-20\">. . .</div></div><div \nclass=\"font-size-10 font-weight-700 text-center text-truncate w-90\" ng-if=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule ? ($ctrl.carddata.meta.selected_schedule.schedule_track.length-2 > 1 ? $ctrl.carddata.meta.selected_schedule.schedule_track.length-2 + \'via Ports\' : ($ctrl.carddata.meta.selected_schedule.via_port == \'Direct\' ? \'Direct\' : \'via Port\' )) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ? \'N/A\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ) }}\n<md-tooltip md-direction=\"Bottom\" class=\"md-whiteframe-2dp white-bg font-size-12 p-10\" \nstyle=\"display:table;opacity: 1\" \nng-show=\"$ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.via_port != \'Direct\'\"><div \nclass=\"grey-fg text-center\">via Port</div><div class=\"grey-fg font-weight-600 text-center\" \nng-repeat=\"track in $ctrl.carddata.meta.selected_schedule.schedule_track track by $index\" ng-show=\"!$first && !$last\">\n{{ track.port_name }}</div></md-tooltip><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 p-10\" style=\"display:table;opacity: 1\" \nng-show=\"!$ctrl.carddata.meta.selected_schedule\"><div class=\"grey-fg text-center\">via Port</div><div \nclass=\"grey-fg font-weight-600 text-center\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route : \'Not Available\'}}\n</div></md-tooltip></div></div><div layout=\"column\" layout-align=\"center end\" flex><div class=\"grey-fg font-size-10\">\nPort of Discharge</div><div class=\"font-size-14 grey-700-fg font-weight-600 text-truncate mw-100\">\n{{ $ctrl.carddata.meta.via_pod ? $ctrl.carddata.meta.via_pod : $ctrl.carddata.meta.port_data.destination_port_code }} \n<span ng-if=\"$ctrl.carddata.meta.via_pod || $ctrl.carddata.meta.port_data.delivery_location\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s16 black-fg\"></md-icon><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 p-10\" \nng-show=\"$ctrl.carddata.meta.via_pod || $ctrl.carddata.meta.port_data.delivery_location\" \nstyle=\"display:table;opacity: 1\"><div ng-if=\"$ctrl.carddata.meta.via_pod\"><div class=\"grey-fg text-right\">\nPort of Discharge</div><div class=\"grey-800-fg font-weight-600 text-right text-truncate\">\n{{$ctrl.carddata.meta.via_pod}}</div></div><div class=\"grey-fg text-right\">\nPort of {{ $ctrl.carddata.meta.via_pod ? \'Destination\' : \'Discharge\' }}</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-right text-truncate\">\n{{$ctrl.carddata.meta.port_data.destination_port_code}}</div><div \nng-if=\"$ctrl.carddata.meta.port_data.delivery_location\"><div class=\"grey-fg text-right\">Delivery</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-right text-truncate\">{{$ctrl.carddata.meta.port_data.delivery_location}}\n</div></div></md-tooltip></span></div></div></div><div layout=\"row\" flex=\"100\" class=\"ph-15\"><div flex layout=\"column\" \nlayout-align=\"start start\" \nng-if=\"(!$ctrl.util.isShipper && !$ctrl.util.isSharedQuote()) && ($ctrl.carddata.meta.type != \'msr_spot\' && $ctrl.carddata.meta.type != \'network_spot\') \" \nclass=\"mb-10\"><div class=\"font-size-10 grey-fg\">Rates By <span>\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? \'Agent \':\'Forwarder \'}}\n</span></div><div class=\"font-size-12 font-weight-600 text-truncate w-200\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n</md-tooltip></div></div><div flex layout=\"column\" layout-align=\"start start\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code\" class=\"mb-10\"><div \nclass=\"font-size-10 grey-fg\">Named Account Code</div><div class=\"font-size-12 font-weight-600 text-truncate w-200\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code}}<md-tooltip md-direction=\"bottom\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code }}</md-tooltip></div></div></div><div\n class=\"haualge_div pv-10\" \nng-if=\"($ctrl.search_param.origin_location.place_type==\'Door\' || $ctrl.search_param.destination_location.place_type==\'Door\')\">\n<div class=\"ph-15 pv-5\" layout=\"row\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.origin_location.place_type==\'Door\'\"><div class=\"key\">Pickup by</div><div class=\"value\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l1_leg].rate_obj.sub_vendor.sub_vendor_name ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l1_leg].rate_obj.sub_vendor.sub_vendor_name : \'N/A\' }}\n</div></div><div class=\"ph-15 pv-5\" layout=\"row\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.destination_location.place_type==\'Door\'\"><div class=\"key\">Delivery by</div><div \nclass=\"value\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l5_leg].rate_obj.sub_vendor.sub_vendor_name ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l5_leg].rate_obj.sub_vendor.sub_vendor_name : \'N/A\' }}\n</div></div></div><div class=\"haualge_div pv-10\" layout=\"row\" layout-wrap><div shimmer-effect-full width=\"97%\" \nheight=\"30px\" mh=\"10px\" mv=\"5px\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\' && !$ctrl.carddata.meta.selected_schedule && !$ctrl.carddata.meta.isScheduleCall\">\n</div><div class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\' && $ctrl.carddata.meta.isScheduleCall\"><div class=\"key\">Next Sailing On</div><div\n class=\"value mw-150 text-truncate\">\n{{ $ctrl.carddata.meta.selected_schedule ? ($ctrl.carddata.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy\') : \'N/A\' }}\n</div></div><free-days \nfreedaysdata=\"{\n            demurrage_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.demurrage_details,\n            detention_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detention_details,\n            origin_free_day : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.origin_free_days,\n            destination_free_day : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.destination_free_days,\n            combined_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.combined_details,\n            freeDays : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.freeDays,\n            pageSource : \'RateCard\'\n          }\" \ntype=\"\'card\'\" cardid=\"$ctrl.carddata._id\"></free-days><div class=\"ph-15 pv-5\" layout=\"column\" \nlayout-align=\"space-between\" ng-show=\"$ctrl.carddata.meta.isScheduleCall\"><div class=\"key w-80\">Service Type</div><div \nclass=\"value\" layout=\"row\"><span class=\"value mw-130 text-truncate\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n</md-tooltip></span><span class=\"ph-3\" \nng-if=\"($ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.service_name) && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type\">\n| </span><span class=\"value mw-130 text-truncate\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\' && $ctrl.carddata.meta.selected_schedule\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n</md-tooltip></span><span \nng-if=\"!(($ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.service_name) || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type)\">\nN/A</span></div></div><div class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.carddata.meta.via_pol\"><div class=\"key\" layout=\"row\" \nlayout-align=\"start center\">Origin Haulage</div><div class=\"value mw-150 text-truncate\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" ng-if=\"!$ctrl.carddata.meta.haulage\"></md-icon>\n{{$ctrl.carddata.meta.haulage ? $ctrl.carddata.meta.haulage : \'Not Available\'}}</div></div><div class=\"ph-15 pv-5\" \nlayout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.carddata.meta.via_pod\"><div class=\"key\" layout=\"row\" \nlayout-align=\"start center\">Destination Haulage</div><div class=\"value mw-150 text-truncate\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" ng-if=\"!$ctrl.carddata.meta.destination_haulage\">\n</md-icon>{{$ctrl.carddata.meta.destination_haulage ? $ctrl.carddata.meta.destination_haulage : \'Not Available\'}}</div>\n</div></div><div ng-if=\"$ctrl.search_param.mode ==\'AIR\'\"><div layout=\"row\" class=\"bt mv-20 h-55\" flex=\"100\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 && !$ctrl.carddata.meta.is_selected\"><div \nng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_1\',\'inactive_slab\':$ctrl.carddata.meta.selectedLeg != \'rate_obj_1\'}\" \nclass=\"pointer\" flex layout=\"column\" layout-align=\"center center\" \nng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_1\')\"><div class=\"red-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab && $ctrl.carddata.meta.slabPersentage < 0\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s12 mb-5 red-400-fg\"></md-icon>\nExtra {{ ($ctrl.fnCalAirSlab($ctrl.carddata.meta.slabPersentage)) | currencyMask: 2 }} % on Freight</div><div \nclass=\"green-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab && $ctrl.carddata.meta.slabPersentage > 0\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s12 mb-1 green-400-fg\"></md-icon>Save <span \nclass=\"font-size-12 font-weight-600\">{{ $ctrl.carddata.meta.slabPersentage | currencyMask: 2 }}%</span> on Freight\n</div><div class=\"font-size-10\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab }} slab</div><div\n class=\"md-primary-fg font-size-11\"><span class=\"font-weight-600\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_currency }}</span> <span \nclass=\"font-weight-600 font-size-14\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_cost / ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} \n</span><span class=\"font-size-8\">per KG</span></div></div><div \nng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_2\',\'inactive_slab\':$ctrl.carddata.meta.selectedLeg != \'rate_obj_2\'}\" \nclass=\"pointer\" flex layout=\"column\" layout-align=\"center center\" \nng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_2\')\"><div class=\"red-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab && $ctrl.carddata.meta.slabPersentage < 0\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s12 mb-5 red-400-fg\"></md-icon>\nExtra {{ ($ctrl.fnCalAirSlab($ctrl.carddata.meta.slabPersentage)) | currencyMask: 2 }} % on Freight</div><div \nclass=\"green-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab && $ctrl.carddata.meta.slabPersentage > 0\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s12 mb-1 green-400-fg\"></md-icon>Save <span \nclass=\"font-size-12 font-weight-600\">{{ $ctrl.carddata.meta.slabPersentage | currencyMask: 2 }} %</span> on Freight\n</div><div class=\"font-size-10\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab }} slab</div><div\n class=\"grey-fg font-size-11\"><span class=\"font-weight-600\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_currency }}</span> <span \nclass=\"font-weight-600 font-size-14\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} \n</span><span class=\"font-size-8\">per KG</span></div></div></div><div class=\"inactive_slab h-55 bt mv-20\" \nlayout=\"column\" flex=\"100\" layout-align=\"center center\" \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 || $ctrl.carddata.meta.is_selected\"><div \nclass=\"shadow_div\"></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div class=\"font-size-12\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab }} slab</div><div \nclass=\"md-primary-fg font-size-12 ml-5\"><span class=\"font-weight-600\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_currency }} </span><span \nclass=\"font-weight-600 font-size-14\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} \n</span><span class=\"font-size-8\">per KG</span></div></div></div></div><div shimmer-effect-full width=\"97%\" \nheight=\"30px\" mh=\"10px\" ng-if=\"$ctrl.resultfilter.ratesLoading\"></div><div shimmer-effect-full width=\"97%\" \nheight=\"30px\" mh=\"10px\" ng-if=\"$ctrl.resultfilter.ratesLoading\"></div><div ng-if=\"!$ctrl.resultfilter.ratesLoading\">\n<div layout=\"row\" layout-wrap class=\"pv-5 ph-15\" \nng-repeat=\"(leg_key,leg_value) in $ctrl.carddata.data[$ctrl.buyOrSell] track by leg_value.leg_code\" \nng-class=\"{\'h-35 main-freight-div mv-5\' : (leg_key == $ctrl.l3_leg), \'mersk-spot\' : (leg_key == $ctrl.l3_leg && ($ctrl.carddata.meta.type == \'msr_spot\' || $ctrl.carddata.meta.type == \'network_spot\')) }\">\n<div layout=\"column\" layout-align=\"center start\" flex=\"60\" flex-gt-xs=\"60\" \nng-class=\"{\'text-truncate\': leg_key != $ctrl.l3_leg }\"><span class=\"key pr-2\" \nng-class=\"{\'white-fg text-truncate font-size-14\' : leg_key == $ctrl.l3_leg }\"><md-icon \nmd-font-icon=\"icon-information-outline\n                        \" class=\"s16 mb-5 pointer\" \nng-if=\"(leg_key == $ctrl.l3_leg && ($ctrl.carddata.meta.type == \'msr_spot\' || $ctrl.carddata.meta.type == \'network_spot\'))\">\n<md-tooltip md-direction=\"bottom\" class=\"md-whiteframe-2dp white-bg grey-fg font-size-12 p-10 Gilroy-Bold\" \nstyle=\"display:table;opacity:1\">Spot Rates are dynamic &<br>can fluctuate with time</md-tooltip></md-icon>\n{{ ( leg_key == $ctrl.l3_leg && leg_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : leg_value.leg_name }} <span\n \nng-if=\"leg_key == $ctrl.l3_leg && $ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.is_special && ($ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total != undefined)\">\n<md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></span></span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"leg-cost-right pr-2 value text-truncate\" \nng-class=\"{\'red-600-fg\' : (leg_key != $ctrl.l3_leg &&!leg_value.rate_obj), \'white-fg font-size-14\' : (leg_key == $ctrl.l3_leg), \'grey-700-fg\' : (leg_key != $ctrl.l3_leg)}\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask: 2) ) : \'N/A\' }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask: 2) ) : \'NA\' }}\n</md-tooltip></span><span class=\"leg-cost-right pr-2 grey-500-fg font-weight-500 font-size-12 text-truncate\" \nng-if=\"leg_key == $ctrl.l3_leg && $ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.is_special && ($ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total != undefined)\">\n<strike>\n{{$ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.leg_currency}} {{$ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total | currencyMask: 2}}\n</strike></span></div></div></div><div class=\"md-primary-fg Font-Bold ph-15 pt-5\" \nng-if=\"(!!$ctrl.carddata.meta.remarks || !!$ctrl.carddata.meta.inclusions)\"><div layout=\"row\" class=\"pointer\" \nlayout-align=\"space-between\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'rates\', $ctrl.carddata.meta.type)\"><div>\nRemarks and Inclusions</div><div><md-icon md-font-icon=\"icon-chevron-right\" class=\"md-primary-fg s20 pointer\">\n</md-icon></div></div></div><div layout=\"row\" layout-wrap class=\"black-fg pv-10 mt-10\"><div \nclass=\"pl-15 font-size-14 font-weight-600 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"40\" \nflex-gt-xs=\"40\"><div class=\"tooltip\">Total Cost</div></div><div class=\"font-size-14 font-weight-600\" layout=\"row\" \nlayout-align=\"end center\" flex=\"60\" flex-gt-xs=\"60\"><span class=\"pr-15\" style=\"display:inline-flex\"><span \nclass=\"text-truncate\">\n{{ $ctrl.search_param.user.user_base_currency + \' \' + ( $ctrl.carddata.meta.buy_leg_total | currencyMask: 2 ) }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg ph-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ $ctrl.search_param.user.user_base_currency + \' \' + ( $ctrl.carddata.meta.buy_leg_total | currencyMask: 2 ) }}\n</md-tooltip></span><span ng-switch=\"$ctrl.carddata.meta.partialRate\"><span ng-switch-when=\"rmk-inc\">*<md-tooltip \nmd-direction=\"top\" class=\"md-whiteframe-2dp black-bg font-size-10\" style=\"opacity: 1\">Subject to Remarks</md-tooltip>\n</span><span ng-switch-when=\"charge\"><md-icon md-font-icon=\"icon-alert\" class=\"orange-400-fg mb-5 s16\"></md-icon>\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp black-bg font-size-10\" style=\"opacity: 1\">\nFew charges are not available</md-tooltip></span></span></span></div></div><div layout=\"row\" layout-wrap \nclass=\"white-fg\"><div layout=\"row\" layout-align=\"start center\" flex=\"50\" flex-gt-xs=\"50\" \nclass=\"font-size-14 font-weight-600\"><md-button md-no-ink class=\"card-button details-button white-fg p-5\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'rates\', $ctrl.carddata.meta.type)\" \nng-disabled=\"$ctrl.generateQuoteBtn || !$ctrl.carddata.meta.isScheduleCall\" title=\"View details\" \ntranslate=\"VIEW DETAILS\">VIEW DETAILS</md-button></div><div layout=\"row\" layout-align=\"end\" flex=\"50\" flex-gt-xs=\"50\" \nclass=\"font-size-14 font-weight-600\" \nng-if=\"(!$ctrl.carddata.meta.is_selected) || $ctrl.currentState == \'app.quotes.quotesDetails\'\"><md-button md-no-ink \nclass=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-if=\"!$ctrl.util.isAdmin && !$ctrl.util.isFreightbro\" \nng-disabled=\"!$ctrl.util.navPermission.shipments[0] || !$ctrl.carddata.meta.isScheduleCall\" \nng-click=\"$ctrl.requestToBook($ctrl.carddata)\" title=\"Confirm Quote\" translate=\"BOOK_NOW\">CONFIRM QUOTE</md-button>\n<md-button md-no-ink class=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-if=\"$ctrl.util.isAdmin || $ctrl.util.isFreightbro\" \nng-disabled=\"!$ctrl.util.navPermission.quotes[0] || $ctrl.generateQuoteBtn || !$ctrl.carddata.meta.isScheduleCall\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata, $event, \'quotation\', $ctrl.carddata.meta.type)\" title=\"Add to quote\" \ntranslate=\"ADD_TO_QUOTE\">ADD TO QUOTE</md-button></div><div layout=\"row\" layout-align=\"end\" flex=\"50\" flex-gt-xs=\"50\" \nclass=\"font-size-14 font-weight-600\" \nng-if=\"($ctrl.carddata.meta.is_selected) && ($ctrl.currentState != \'app.quotes.quotesDetails\')\"><md-button md-no-ink \nclass=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-disabled=\"!$ctrl.util.navPermission.quotes[0] || $ctrl.generateQuoteBtn\" \nng-click=\"$ctrl.removeCard($ctrl.carddata)\" title=\"Remove\" translate=\"REMOVE\">REMOVE</md-button></div></div></div>");
$templateCache.put("app/main/component/search-bar/load-detail.html","<div layout=\"row\" layout-xs=\"column\" flex=\"100\" layout-wrap><div class=\"mr-20 bottom-align\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Cut Off Date</span><br><md-input-container md-no-float class=\"p-0 m-0\">\n<div class=\"w-120 panel-select pointer mobile_input\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'red-border\':($ctrl.searchBarForm.cargo_ready_date.$error.required || $ctrl.searchBarForm.cargo_ready_date.$error.mindate) && ($ctrl.searchBarForm.cargo_ready_date.$dirty || $ctrl.formSubmit),\'disabled\' : $ctrl.searchFromQuote}\" \nng-click=\"$ctrl.openDatePicker=true\"><div style=\"background-image: url(\'assets/icons/custom/search-bar/date.svg\')\" \nclass=\"icon-bg\" \nng-if=\"!(($ctrl.searchBarForm.cargo_ready_date.$error.required || $ctrl.searchBarForm.cargo_ready_date.$error.mindate) && ($ctrl.searchBarForm.cargo_ready_date.$dirty || $ctrl.formSubmit))\">\n</div><md-icon \nng-if=\"($ctrl.searchBarForm.cargo_ready_date.$error.required || $ctrl.searchBarForm.cargo_ready_date.$error.mindate) && ($ctrl.searchBarForm.cargo_ready_date.$dirty || $ctrl.formSubmit)\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"mt-2\" \nng-class=\"{\'red-fg remove-pl mt-2\':($ctrl.searchBarForm.cargo_ready_date.$error.required || $ctrl.searchBarForm.cargo_ready_date.$error.mindate) && ($ctrl.searchBarForm.cargo_ready_date.$dirty || $ctrl.formSubmit)}\" \nng-bind=\"$ctrl.searchParam.cargo_ready_date ? ($ctrl.searchParam.cargo_ready_date  |  date : \'dd MMM yyyy\') : \'Select Date\'\">\n</div></div><md-datepicker id=\"date-picker-search\" name=\"cargo_ready_date\" md-min-date=\"$ctrl.cargoMinDate\" \nng-model=\"$ctrl.searchParam.cargo_ready_date\" md-placeholder=\"Select\" md-is-open=\"$ctrl.openDatePicker\" \nonkeydown=\"return false\" md-open-on-focus md-hide-icons=\"all\" class=\"pv-5 pl-15\" required \nng-focus=\"$ctrl.formIsPristine=false;\" ng-blur=\"$ctrl.focusElem()\" ng-change=\"$ctrl.trackEvent(\'Cut off date\')\">\n</md-datepicker></md-input-container></div><div ng-if=\"$ctrl.mode ===\'SEA-FCL\'\" class=\"mr-20 mb-20\"><span \nng-if=\"$ctrl.isload_type_alias\" class=\"font-weight-600 font-size-13 form-title\">Load Type<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 pointer load-alias grey-400-fg\" \nng-mouseover=\"$ctrl.showLoadAlias($event);$ctrl.trackEvent(\'panel\')\"></md-icon></span><span \nng-if=\"!$ctrl.isload_type_alias\" class=\"font-weight-600 font-size-13 form-title\">Load Type<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 pointer load-alias grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">Select multiple loads to view rates</md-tooltip></md-icon></span><br><md-input-container \nmd-no-float class=\"p-0 m-0\"><div class=\"w-170 panel-select panel-select-load pointer mobile_input\" \nng-click=\"!($ctrl.searchFromQuote) && $ctrl.showLoadPanel($event)\" \nng-class=\"{\'red-border red-fg\': $ctrl.searchBarForm.$error.loadError,\'disabled-icon\' : $ctrl.searchFromQuote}\" \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"80\">\n<div style=\"background-image: url(\'assets/icons/custom/search-bar/load_type.svg\')\" class=\"icon-bg\" \nng-if=\"!($ctrl.searchBarForm.$error.loadError)\"></div><md-icon ng-if=\"$ctrl.searchBarForm.$error.loadError\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div \ntruncate=\"{{$ctrl.LoadBoxString}}\" class=\"mt-2 pv-5 hide-overflow text-truncate\" \nng-class=\"{\'margin-remove\': $ctrl.LoadBoxString===\'\'}\">{{$ctrl.LoadBoxString}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.LoadTooltipString}}</span>\n</md-tooltip></div><div ng-if=\"$ctrl.LoadBoxString===\'\'\" class=\"mh-10 pv-5\" \nng-class=\"{\'margin-remove\':$ctrl.searchBarForm.$error.loadError}\">Select Load</div></div><md-icon \nmd-font-icon=\"icon-chevron-down\" ng-class=\"{\'disabled\' : $ctrl.searchFromQuote}\" class=\"search-arrow-icon\" flex=\"20\">\n</md-icon></div></md-input-container></div><div ng-if=\"$ctrl.mode !==\'SEA-FCL\'\" class=\"mr-20 mb-20\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Load Details<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-5 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"font-size-12\">Chargeable Weight</md-tooltip>\n</md-icon></span><br><md-input-container md-no-float class=\"p-0 m-0\"><div \nclass=\"w-205 panel-select panel-select-load-detail pointer mobile_input\" ng-click=\"$ctrl.showLoadDetailPanel($event)\" \nng-class=\"{\'red-border red-fg\': $ctrl.searchBarForm.$error.loadDetailError}\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"85\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/load_detail.svg\')\" class=\"icon-bg\" \nng-if=\"!($ctrl.searchBarForm.$error.loadDetailError)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.$error.loadDetailError\" class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pv-5 text-truncate mt-2\">\nCharged Wt: {{$ctrl.searchParam.load_data.load_meta.chargeable_weight | currencyMask: 4 || 0}} {{$ctrl.util.chargeableUnit[$ctrl.mode]}}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-12\">\nCharged Wt: {{$ctrl.searchParam.load_data.load_meta.chargeable_weight | currencyMask: 4 || 0}} {{$ctrl.util.chargeableUnit[$ctrl.mode]}}\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\"></md-icon></div>\n</md-input-container></div><div class=\"mr-20 mb-20\" \nng-if=\"!$ctrl.isShipper && $ctrl.mode===\'SEA-FCL\' && $ctrl.isCarrierSelection\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Carrier<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-5 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-center pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><div>\nThe selected Trucker/Carrier</div><div class=\"mb-20\">will be displayed in the rate results</div><div>\nIf the rates are from another forwarder, then this<br>field would not be applicable</div></md-tooltip></md-icon></span>\n<br><div ng-if=\"$ctrl.carrierShimmer\"><div shimmer-effect-full width=\"170px\" height=\"40px\" class=\"mt-4\"></div></div>\n<multi-select-group ng-if=\"!$ctrl.carrierShimmer\" filter-loader=\"$ctrl.carrierFilter\" page-source=\"$ctrl.pageSource\" \nis-error=\"$ctrl.carrierSelectionError\" placeholder-text=\"\'select carrier\'\" is-disabled=\"$ctrl.searchFromQuote\" \noption-list=\"$ctrl.carrierList.data.carrier_mappings.FCL\" selected-options=\"$ctrl.selectedCarrierOption\" \ncallback=\"$ctrl.carrierCallBack(payload)\"></multi-select-group></div><div class=\"mobile_input panel_alignment\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Locals & Custom Charges<span \nng-if=\"$ctrl.mode===\'SEA-FCL\' && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !$ctrl.util.isShipper\">\n/ Incoterms</span></span><br><md-input-container md-no-float class=\"p-0 m-0\"><div \nclass=\"panel-select panel-select-charge pointer mobile_input\" \nng-class=\"{\'red-border red-fg\': $ctrl.searchBarForm.$error.chargeError || (!$ctrl.validateLC() && $ctrl.formSubmit), \'w-270\': $ctrl.mode===\'SEA-FCL\', \'w-160\': $ctrl.mode!==\'SEA-FCL\',\'disabled-icon\' : $ctrl.searchFromQuote}\" \nng-click=\"!($ctrl.searchFromQuote) && $ctrl.showChargePanel($event)\" layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"80\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/charges.svg\')\" class=\"icon-bg\" \nng-if=\"!($ctrl.searchBarForm.$error.chargeError)\"></div><md-icon ng-if=\"$ctrl.searchBarForm.$error.chargeError\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div \ntruncate=\"{{$ctrl.detailBoxString}}\" class=\"mt-2 pv-5 hide-overflow text-truncate\">{{$ctrl.detailBoxString}}<md-tooltip\n ng-if=\"$ctrl.detailBoxTooltip\" md-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.detailBoxTooltip}}</span>\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" ng-class=\"{\'disabled\' : $ctrl.searchFromQuote}\" \nclass=\"search-arrow-icon\"></md-icon></div><div ng-if=\"(!$ctrl.validateLC() && $ctrl.formSubmit)\" \nclass=\"font-size-11 red-fg mt-2\"><span ng-if=\"$ctrl.is_independent_search_error\">{{$ctrl.is_independent_search_error}}\n</span> <span ng-if=\"!$ctrl.is_independent_search_error\">Please select any option in Locals and customs<span \nng-if=\"$root.domainData.domain_info.ENABLE_INCOTERM_SEARCH && !$ctrl.util.isShipper\">/incoterms</span></span></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/component/search-bar/search-bar.html","<div id=\"search-bar\"><div class=\"form-container\" \nng-class=\"{\'overlay-class\': $ctrl.isStateResult && $ctrl.searchFromClose, \'ph-20\': $ctrl.isStateResult}\" \nng-click=\"$ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return\"><form \nname=\"$ctrl.searchBarForm\" class=\"search-form\" \nng-class=\"{\'mobile-form-style\': $ctrl.isStateResult && $ctrl.editSearch}\"><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" layout-wrap layout-padding class=\"pb-0 pr-5\" ng-class=\"{\'pt-20\': !$ctrl.isStateResult}\" \nng-if=\"$ctrl.resultcardfilter.deviceName != \'mobile\' || $ctrl.editSearch\"><div \nng-class=\"{\'result_multiport_div\':$ctrl.isStateResult}\"><div ng-if=\"$ctrl.isMultiPort || $ctrl.isMultiDoor\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult}\"><div layout=\"row\" class=\"mb-12 h-20\"><span \nclass=\"font-weight-600 font-size-13 form-title mr-12\">Origin </span><span class=\"margin-t-2 mr-12 font-size-13\"><div \nclass=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\"><button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" ng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'origin\');\">DOOR</button> <button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'origin\');\">\n{{$ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button></div>\n</span><span \nng-if=\"$ctrl.viewToggleOrigin==\'port\' && $ctrl.searchParam.mode==\'SEA-FCL\' && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.includeSdOrigin\" \nclass=\"md-primary\">Carrier SD Services</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Search for CY (Container Yard) services for all selected carriers.</div><div><span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleOrigin==\'port\'   && $ctrl.searchParam.mode !=\'AIR\' && $ctrl.enabled_nearby && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParam.fetch_nearby_origin\" ng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyOrigin\')\" \nclass=\"md-primary\">Include Nearby</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Ignores neighbouring ports when fetching rates.</div><div><span class=\"font-bold\">Checked : </span>\nIncludes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span></div><div \nclass=\"container-wrap serive-mode-origin\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParam.user_nearby_origin.length ) || $ctrl.searchBarForm.$error.samePortError || $ctrl.searchBarForm.user_nearby_origin.$error.maxchips), \'b-focus\': originFocused,}\">\n<md-chips md-chip-append-delay=\"3\" name=\"user_nearby_origin\" ng-model=\"$ctrl.searchParam.user_nearby_origin\" \nmd-no-float class=\"panel-select ph-10 pb-5\" ng-mouseenter=\"focused=true\" \nmd-max-chips=\"{{ $ctrl.is_nXn_search ? $ctrl.originMultiPortPairLimit+1 : $ctrl.multiPortPairLimit + 1}}\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'origin\')\" md-require-match=\"true\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParam.user_nearby_origin.length ) || $ctrl.searchBarForm.$error.samePortError || $ctrl.searchBarForm.user_nearby_origin.$error.maxchips), \'b-focus\': originFocused,\'disabled\' : $ctrl.searchFromQuote }\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'origin\',destination)\" layout=\"row\"><md-autocomplete \nng-hide=\"$ctrl.isStopOriginPortInput()\" class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin\');$ctrl.trackEvent(\'origin\',fcl_originSearchText)\" \nng-focus=\"focused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return;\n                $ctrl.formIsPristine=false;originFocused=true\" \nng-blur=\"originFocused=false\" id=\"multi-origin-input\" md-input-name=\"fcl_origin_port\" \nmd-search-text=\"fcl_originSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_originSearchText, $ctrl.mode, \'origin\',\'user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{($ctrl.viewToggleOrigin==\'door\'? \'Search by Door\' : ($ctrl.searchParam.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\'))}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"break-word\" flex=\"70\" style=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div ng-show=\"fcl_originSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                         track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span>\n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleOrigin != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParam.user_nearby_origin.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                ($chip.place_type !== \'Door\' ?\n                ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"($ctrl.searchBarForm.user_nearby_origin.$error.maxchips)\">\nYou can search multi port up to {{$ctrl.is_nXn_search ? $ctrl.originMultiPortPairLimit : $ctrl.multiPortPairLimit }}.\n</div><div class=\"errors font-size-11\" ng-if=\"$ctrl.checkExistingPort === \'origin\'\"><div>This port already used.</div>\n</div><div class=\"errors font-size-11\" ng-if=\"$ctrl.checkExistingDoor === \'origin\'\"><div>This door already used.</div>\n</div><div class=\"errors font-size-11\" ng-if=\"$ctrl.checkOtherPort === \'origin\'\"><div>\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nng-if=\"$ctrl.viewToggleOrigin ==\'port\' && $ctrl.searchParam.user_nearby_destination.length>1 && !$ctrl.is_nXn_search  && $ctrl.viewToggleDestination !=\'door\' \">\nYou may only enter one port</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"($ctrl.viewToggleOrigin ==\'port\' && !$ctrl.isMultiPort) || $ctrl.viewToggleOrigin ==\'door\' ||  (($ctrl.searchParam.user_nearby_destination.length > 1 && !$ctrl.is_nXn_search && $ctrl.viewToggleDestination == \'port\') || $ctrl.viewToggleOrigin == \'door\')\">\n{{$ctrl.searchParam.user_nearby_origin.length}}/{{$ctrl.is_nXn_search ? $ctrl.originMultiPortPairLimit : $ctrl.multiPortPairLimit }}\n</div><div layout=\"row\" flex layout-align=\"end end\" ng-if=\"$ctrl.viewToggleOrigin ==\'port\' && !$ctrl.isMultiPort\">\n{{$ctrl.searchParam.user_nearby_origin.length}}/1</div><div \nng-if=\"$ctrl.viewToggleOrigin ==\'door\' && $ctrl.searchParam.user_nearby_destination.length>1 && !$ctrl.is_door_nXn_search &&  $ctrl.viewToggleDestination !=\'port\' \">\nYou may only enter one door</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"!$ctrl.viewToggleOrigin ==\'door\' || ($ctrl.viewToggleOrigin ==\'door\' && !$ctrl.isMultiDoor) || $ctrl.viewToggleOrigin ==\'port\' ||  (($ctrl.searchParam.user_nearby_destination.length > 1 && !$ctrl.is_door_nXn_search && $ctrl.viewToggleDestination == \'door\') || $ctrl.viewToggleOrigin == \'port\')\">\n{{$ctrl.searchParam.user_nearby_origin.length}}/{{$ctrl.is_door_nXn_search ? $ctrl.originMultiDoorLimit : $ctrl.multiDoorLimit }}\n</div><div layout=\"row\" flex layout-align=\"end end\" ng-if=\"$ctrl.viewToggleOrigin ==\'door\' && !$ctrl.isMultiDoor\">\n{{$ctrl.searchParam.user_nearby_origin.length}}/1</div></div></div><div class=\"mobile_input\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult}\" ng-if=\"!$ctrl.isMultiPort && !$ctrl.isMultiDoor\"><div \nlayout=\"row\" class=\"mb-12 h-20\"><span class=\"font-weight-600 font-size-13 form-title mr-12\">Origin</span> <span \nclass=\"margin-t-2 mr-12 font-size-13\"><div class=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\"><button \nng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" class=\"search-tab-icon-button\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'origin\');\">DOOR</button> <button \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nclass=\"search-tab-icon-button\" ng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'origin\');\">\n{{$ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button></div>\n</span><span \nng-if=\"$ctrl.viewToggleOrigin==\'port\' && $ctrl.searchParam.mode==\'SEA-FCL\' && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.includeSdOrigin\" \nclass=\"md-primary\">Carrier SD Services</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Search for CY (Container Yard) services for all selected carriers.</div><div><span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleOrigin==\'port\' && $ctrl.searchParam.mode !=\'AIR\' && $ctrl.enabled_nearby && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParam.fetch_nearby_origin\" ng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyOrigin\')\" \nclass=\"md-primary\">Include Nearby</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Ignores neighbouring ports when fetching rates.</div><div><span class=\"font-bold\">Checked : </span>\nIncludes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span></div><div \nclass=\"container-wrap serive-mode-origin\" \nng-class=\"{\'red-border\':(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError  || $ctrl.duplicatePortValidation == \'origin_location\') && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused),\'b-focus\': originFocused}\">\n<md-input-container md-no-float class=\"p-0 m-0 panel-select ph-10\" ng-mouseleave=\"focused=false\" \nng-mouseenter=\"focused=true\" md-input-id=\"originLocation\" \nng-class=\"{\'red-border pl-35\':(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError || $ctrl.duplicatePortValidation == \'origin_location\') && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused), \'pl-35\': $ctrl.mode!==\'AIR\', \'b-focus\': originFocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)\" \nmdprefix class=\"mh-5 h-15 w-15 mt-2 ml-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-10 margin-top-6\" \nng-if=\"!$ctrl.searchParam.origin_location && !(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused) && $ctrl.mode!==\'AIR\'\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-icon class=\"icon-size-autocomplete ml-2\" \nmd-svg-src=\"{{ $ctrl.searchParam.origin_location ?\n               ($ctrl.searchParam.origin_location.place_type !== \'Door\' ?\n                    ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($ctrl.searchParam.origin_location.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"$ctrl.searchParam.origin_location && (!(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\" \nng-if=\"(!(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin_location\');$ctrl.trackEvent(\'origin\',fcl_originSearchText)\" \nng-focus=\"focused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;originFocused=true\" \nng-blur=\"originFocused=false\" \nng-class=\"{\'placeholder-error\':(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError || $ctrl.duplicatePortValidation == \'origin_location\') && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused),\'disabled\' : $ctrl.searchFromQuote}\" \nrequired id=\"origin-input\" md-input-name=\"fcl_origin_port\" md-selected-item=\"$ctrl.searchParam.origin_location\" \nmd-search-text=\"fcl_originSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_originSearchText, $ctrl.mode, \'origin\',\'user\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nmd-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{$ctrl.viewToggleOrigin==\'door\'? \'Search by Door\' : ($ctrl.searchParam.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\')}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_originSearchText.length >=2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                               track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                      track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span>\n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleOrigin != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParam.origin_location\"><div>\n{{$ctrl.searchParam.origin_location.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.searchParam.origin_location, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.searchParam.origin_location, true).join(\', \'):$ctrl.searchParam.origin_location.location)}}\n</div></md-tooltip><div \nng-if=\"$ctrl.searchParam.origin_location && $ctrl.searchParam.origin_location.place_type!==\'Door\' && !focused\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{$ctrl.searchParam.origin_location.global_port_code || $ctrl.searchParam.origin_location.portcode_portname}}</div><div\n \nng-if=\"$ctrl.searchParam.origin_location && $ctrl.searchParam.origin_location.place_type===\'Door\' && $ctrl.searchParam.origin_location.pin_code_ui && !focused\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{$ctrl.searchParam.origin_location.country_code}} - {{$ctrl.searchParam.origin_location.pin_code_ui}}</span></div>\n</md-input-container></div><div class=\"errors\" ng-if=\"$ctrl.duplicatePortValidation == \'origin_location\'\"><div \nclass=\"font-size-11\">This port already used in destination port.</div></div></div><div \nng-if=\"$ctrl.show_origin_port && ($ctrl.searchFromClose || !$ctrl.isStateResult)\" class=\"pt-20\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult}\"><span class=\"font-weight-600 font-size-13 form-title\">\nOrigin CY</span><br><div class=\"container-wrap serive-mode-origin-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.polValidation ) || $ctrl.searchBarForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_origin_ports\" ng-model=\"$ctrl.searchParam.user_pol\" md-no-float \nclass=\"panel-select ph-10 pb-5\" ng-mouseenter=\"focused=true;\" md-require-match=\"true\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'origin_location\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.polValidation ) || $ctrl.searchBarForm.$error.samePortError), \'b-focus\': originFocused,\'disabled\' : $ctrl.searchFromQuote }\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'originPort\',\'destination port\')\" layout=\"row\"><md-autocomplete \nclass=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin\');$ctrl.trackEvent(\'pol\',fcl_originPortSearchText)\" \nng-focus=\"focused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;\" \nng-blur=\"originFocused=false\" id=\"multi-origin-port-input\" md-input-name=\"origin_port\" \nmd-search-text=\"fcl_originPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(fcl_originPortSearchText, $ctrl.mode, \'origin\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search by Port\" md-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" \nmd-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originPortSearchText || fcl_originPortSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originPortSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParam.user_pol.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                    ($chip.place_type !== \'Door\' ?\n                    ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.checkExistingPort === \'originPort\'\"><div>This port already used.</div></div><div \nclass=\"errors font-size-11\" ng-if=\"$ctrl.checkOtherPort === \'originPort\'\"><div>\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\"><div class=\"errors font-size-11\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"($ctrl.searchBarForm.nearby_origin_ports.$error.maxchips)\"><md-icon \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">\nNumber of Ports reached maximum limit</div></div><div class=\"md-link-fg font-size-11\" layout=\"row\" flex \nlayout-align=\"end end\"><div ng-class=\"{\'errors\':$ctrl.searchBarForm.nearby_origin_ports.$error.maxchips}\">\n{{$ctrl.searchParam.user_pol.length}}/{{$ctrl.originPortLimit}}</div></div></div></div><div \nng-if=\"$ctrl.searchParam.fetch_nearby_origin && ($ctrl.searchFromClose || !$ctrl.isStateResult)\" class=\"pt-20\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult}\"><span class=\"font-weight-600 font-size-13 form-title\">\nOrigin Nearby CY</span><br><div class=\"container-wrap serive-mode-origin-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByOriginValidation ) || $ctrl.searchBarForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_origin\" ng-model=\"$ctrl.searchParam.nearby_origin\" md-no-float \nclass=\"panel-select ph-10 pb-5\" ng-mouseenter=\"focused=true;\" md-require-match=\"true\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'nearby_origin\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByOriginValidation ) || $ctrl.searchBarForm.$error.samePortError), \'b-focus\': nearByOriginfocused,\'disabled\' : $ctrl.searchFromQuote }\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'nearbyOrigin\',\'nearbyDestination\')\" layout=\"row\">\n<md-autocomplete class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.trackEvent(\'narby_origin\',nearby_originPortSearchText)\" \nng-focus=\"nearByOriginfocused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;\" \nng-blur=\"nearByOriginfocused=false\" id=\"multi-origin-port-input\" md-input-name=\"nearby_origin\" \nmd-search-text=\"nearby_originPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(nearby_originPortSearchText, $ctrl.mode, \'origin\',\'nearby_user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search nearby Port\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"nearByOriginfocused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originPortSearchText || fcl_originPortSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originPortSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParam.nearby_origin.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                      ($chip.place_type !== \'Door\' ?\n                      ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                      \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.searchBarForm.nearby_origin.$error.required || $ctrl.searchBarForm.nearby_origin.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.nearby_origin.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.checkExistingPort === \'nearbyOrigin\'\"><div>This port already used.</div></div><div \nclass=\"errors font-size-11\" ng-if=\"$ctrl.checkOtherPort === \'nearbyOrigin\'\"><div>\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\"><div class=\"errors font-size-11\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"($ctrl.searchBarForm.nearby_origin.$error.maxchips)\"><md-icon \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">\nNumber of Ports reached maximum limit</div></div><div class=\"md-link-fg font-size-11\" layout=\"row\" flex \nlayout-align=\"end end\"><div ng-class=\"{\'errors\':$ctrl.searchBarForm.nearby_origin.$error.maxchips}\">\n{{$ctrl.searchParam.nearby_origin.length}}/{{$ctrl.originNearbyPortLimit}}</div></div></div></div></div><div \nng-class=\"{\'result_multiport_div\':$ctrl.isStateResult}\"><div ng-if=\"$ctrl.isMultiPort || $ctrl.isMultiDoor\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult}\"><div layout=\"row\" class=\"mb-12 h-20\"><span \nclass=\"font-weight-600 font-size-13 form-title mr-12\">Destination</span> <span \nclass=\"pl-8 margin-t-2 font-size-13 mr-12\"><div class=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\">\n<button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'destination\');\">\n{{$ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button> <button \nclass=\"search-tab-icon-button\" ng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'destination\');\">DOOR</button></div></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\'  && $ctrl.searchParam.mode==\'SEA-FCL\' && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.includeSdDestination\" \nclass=\"md-primary\">Carrier SD Services</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Search for CY (Container Yard) services for all selected carriers.</div><div><span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\' && $ctrl.searchParam.mode !=\'AIR\' && $ctrl.enabled_nearby && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParam.fetch_nearby_destination\" \nng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyDestination\')\" class=\"md-primary\">Include Nearby</md-checkbox>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\">\n<span class=\"font-bold\">Unchecked:</span> Ignores neighbouring ports when fetching rates.</div><div><span \nclass=\"font-bold\">Checked : </span>Includes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span>\n</div><div class=\"container-wrap serive-mode-destination\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParam.user_nearby_destination.length ) || $ctrl.searchBarForm.$error.samePortError  || $ctrl.searchBarForm.user_nearby_destination.$error.maxchips), \'b-focus\': destinationFocused,}\">\n<md-chips md-chip-append-delay=\"3\" name=\"user_nearby_destination\" ng-model=\"$ctrl.searchParam.user_nearby_destination\" \nmd-no-float class=\"panel-select ph-10 pb-5\" \nmd-max-chips=\"{{ $ctrl.is_nXn_search ? $ctrl.destinationMultiPortPairLimit+1 : $ctrl.multiPortPairLimit + 1}}\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'destination\',\'origin\')\" ng-mouseenter=\"focused=true\" \nmd-require-match=\"true\" md-on-remove=\"$ctrl.fnRemovePortChip($chip , \'destination\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && !$ctrl.searchParam.user_nearby_destination.length ) || $ctrl.searchBarForm.$error.samePortError  || $ctrl.searchBarForm.user_nearby_destination.$error.maxchips), \'b-focus\': destinationFocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\"><md-autocomplete ng-hide=\"$ctrl.isStopDestinationPortInput()\" \nclass=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'destination\');$ctrl.trackEvent(\'destination\',fcl_destinationSearchText)\" \nng-focus=\"focused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;destinationFocused=true\" \nng-blur=\"destinationFocused=false\" id=\"multi-destinatiomn-input\" md-input-name=\"fcl_destination_port\" \nmd-search-text=\"fcl_destinationSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_destinationSearchText, $ctrl.mode, \'destination\',\'user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{($ctrl.viewToggleDestination==\'door\'? \'Search by Door\' : ($ctrl.searchParam.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\'))}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"break-word\" flex=\"70\" style=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nlayout-align=\"start center\" style=\"pointer-events: none\"><div ng-show=\"fcl_destinationSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                               track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                      track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_destinationSearchText)\">\n</span><span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleDestination != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.searchParam.user_nearby_destination.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                          ($chip.place_type !== \'Door\' ?\n                          ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                          \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.searchBarForm.user_nearby_destination.$error.maxchips\">\nYou can search multi port up to {{($ctrl.is_nXn_search ? $ctrl.destinationMultiPortPairLimit : $ctrl.multiPortPairLimit)}}.\n</div><div class=\"errors\" ng-if=\"$ctrl.checkExistingPort === \'destination\'\"><div class=\"font-size-11\">\nThis port already used.</div></div><div class=\"errors\" ng-if=\"$ctrl.checkExistingDoor === \'destination\'\"><div \nclass=\"font-size-11\">This door already used.</div></div><div class=\"errors\" \nng-if=\"$ctrl.checkOtherPort === \'destination\'\"><div class=\"font-size-11\">\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nng-if=\"$ctrl.viewToggleDestination ==\'port\' && $ctrl.searchParam.user_nearby_origin.length > 1 && !$ctrl.is_nXn_search && $ctrl.viewToggleOrigin !=\'door\'  && $ctrl.viewToggleDestination !=\'door\' \">\nYou may only enter one port</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"!$ctrl.viewToggleDestination ==\'port\' || ($ctrl.viewToggleDestination ==\'port\'&& !$ctrl.isMultiPort)||$ctrl.viewToggleDestination ==\'door\' || (($ctrl.searchParam.user_nearby_origin.length > 1 && !$ctrl.is_nXn_search &&  $ctrl.viewToggleOrigin == \'port\') || $ctrl.viewToggleDestination == \'door\')\">\n{{$ctrl.searchParam.user_nearby_destination.length}}/{{($ctrl.is_nXn_search ? $ctrl.destinationMultiPortPairLimit : $ctrl.multiPortPairLimit)}}\n</div><div \nng-if=\"$ctrl.viewToggleDestination ==\'door\' &&$ctrl.searchParam.user_nearby_origin.length > 1 && !$ctrl.is_door_nXn_search && $ctrl.viewToggleOrigin !=\'port\' \">\nYou may only enter one door</div><div layout=\"row\" flex layout-align=\"end end\" \nng-hide=\"!$ctrl.viewToggleDestination ==\'door\' ||($ctrl.viewToggleDestination ==\'door\'&& !$ctrl.isMultiDoor)||$ctrl.viewToggleDestination ==\'port\' || (($ctrl.searchParam.user_nearby_origin.length > 1 && !$ctrl.is_door_nXn_search &&  $ctrl.viewToggleOrigin == \'door\') || $ctrl.viewToggleDestination == \'port\')\">\n{{$ctrl.searchParam.user_nearby_destination.length}}/{{($ctrl.is_door_nXn_search ? $ctrl.destinationMultiDoorLimit : $ctrl.multiDoorLimit)}}\n</div><div layout=\"row\" flex layout-align=\"end end\" \nng-if=\"$ctrl.viewToggleDestination ==\'port\'&& !$ctrl.isMultiPort && $ctrl.viewToggleDestination ==\'port\'\">\n{{$ctrl.searchParam.user_nearby_destination.length}}/1</div><div layout=\"row\" flex layout-align=\"end end\" \nng-if=\"$ctrl.viewToggleDestination ==\'door\'&& !$ctrl.isMultiDoor && $ctrl.viewToggleDestination ==\'door\'\">\n{{$ctrl.searchParam.user_nearby_destination.length}}/1</div></div></div><div class=\"mobile_input\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult}\" ng-if=\"!$ctrl.isMultiPort && !$ctrl.isMultiDoor\"><div \nlayout=\"row\" class=\"mb-12 h-20\"><span class=\"font-weight-600 font-size-13 form-title mr-12\">Destination</span> <span \nclass=\"pl-8 margin-t-2 mr-12\"><div class=\"search-group-button\" ng-show=\"!$ctrl.isLoadingServiceMode\"><button \nclass=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes($ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\'))\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'destination\');\">\n{{$ctrl.searchParam.mode==\'SEA-LCL\' ? \'CFS\' :( $ctrl.searchParam.mode==\'AIR\' ? \'AIRPORT\' : \'CY\')}}</button> <button \nclass=\"search-tab-icon-button\" ng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'destination\');\">DOOR</button></div></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\'  && $ctrl.searchParam.mode==\'SEA-FCL\' && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.includeSdDestination\" \nclass=\"md-primary\">Carrier SD Services</md-checkbox><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\"><span class=\"font-bold\">Unchecked:</span>\n Search for CY (Container Yard) services for all selected carriers.</div><div><span class=\"font-bold\">Checked : </span>\nSearch for SD (Store Door) services for Maersk, Hapag-Lloyd and myMSC; CY services for all other selected carriers.\n</div></md-tooltip></md-icon></span><span \nng-if=\"$ctrl.viewToggleDestination==\'port\'  && $ctrl.searchParam.mode !=\'AIR\' && $ctrl.enabled_nearby && !$ctrl.isLoadingServiceMode\" \nclass=\"checkbox-margin ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.searchParam.fetch_nearby_destination\" \nng-change=\"$ctrl.fnPrefillNearbyPortData(\'\',\'nearbyDestination\')\" class=\"md-primary\">Include Nearby</md-checkbox>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s16 ml-4 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\"><div class=\"mb-10\">\n<span class=\"font-bold\">Unchecked:</span> Ignores neighbouring ports when fetching rates.</div><div><span \nclass=\"font-bold\">Checked : </span>Includes neighbouring ports when fetching rates.</div></md-tooltip></md-icon></span>\n</div><div class=\"container-wrap serive-mode-destination\" \nng-class=\"{\'red-border\':(($ctrl.searchBarForm.fcl_destination_port.$error.required || $ctrl.searchBarForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError || $ctrl.duplicatePortValidation == \'destination_location\') && ($ctrl.searchBarForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination),\'b-focus\': destinationFocused}\">\n<md-input-container md-no-float class=\"p-0 m-0 panel-select ph-10\" layout=\"row\" layout-align=\"start center\" \nng-mouseleave=\"focusedDestination=false\" ng-mouseenter=\"focusedDestination=true\" \nng-class=\"{\'red-border pl-35\':(($ctrl.searchBarForm.fcl_destination_port.$error.required || $ctrl.searchBarForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError || $ctrl.duplicatePortValidation == \'destination_location\') && ($ctrl.searchBarForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination), \'pl-35\': $ctrl.mode!==\'AIR\', \'b-focus\': destinationFocused,\'disabled\' : $ctrl.searchFromQuote}\">\n<md-icon \nng-if=\"(($ctrl.searchBarForm.fcl_destination_port.$error.required || $ctrl.searchBarForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)\" \nmdprefix class=\"mh-5 h-15 w-15 ml-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-10 margin-top-6\" \nng-if=\"!$ctrl.searchParam.destination_location && !(($ctrl.searchBarForm.fcl_destination_port.$error.required || $ctrl.searchBarForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination) && $ctrl.mode!==\'AIR\'\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-icon class=\"icon-size-autocomplete ml-2\" \nmd-svg-src=\"{{ $ctrl.searchParam.destination_location ?\n                   ($ctrl.searchParam.destination_location.place_type !== \'Door\' ?\n                    ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($ctrl.searchParam.destination_location.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) : \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"$ctrl.searchParam.destination_location && (!(($ctrl.searchBarForm.fcl_destination_port.$error.required || $ctrl.searchBarForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)) && $ctrl.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\" \nng-if=\"(!(($ctrl.searchBarForm.fcl_destination_port.$error.required || $ctrl.searchBarForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)) && $ctrl.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" required \nid=\"destination-input\" \nng-focus=\"focusedDestination=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;destinationFocused=true\" \nng-blur=\"destinationFocused=false\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'destination_location\');$ctrl.trackEvent(\'destination\',fcl_destinationSearchText)\" \nmd-input-name=\"fcl_destination_port\" md-selected-item=\"$ctrl.searchParam.destination_location\" \nng-class=\"{\'placeholder-error\':(($ctrl.searchBarForm.fcl_destination_port.$error.required || $ctrl.searchBarForm.fcl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError || $ctrl.duplicatePortValidation == \'destination_location\') && ($ctrl.searchBarForm.fcl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination),\'disabled\' : $ctrl.searchFromQuote}\" \nmd-search-text=\"fcl_destinationSearchText\" md-input-id=\"destinationLocation\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_destinationSearchText, $ctrl.mode, \'destination\',\'user\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nplaceholder=\"{{$ctrl.viewToggleDestination==\'door\'? \'Search by Door\' : ($ctrl.searchParam.mode===\'AIR\' ?\'Search by Airport\' : \'Search by Port\')}}\" \nmd-menu-class=\"autocomplete-custom-template-search\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"focusedDestination\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port  && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_destinationSearchText.length >=2 \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                             track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                    track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_destinationSearchText)\">\n</span><span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.country_code}}-{{item.pin_code_ui}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleDestination != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParam.destination_location\">\n<div>\n{{$ctrl.searchParam.destination_location.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.searchParam.destination_location, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.searchParam.destination_location, true).join(\',\'):$ctrl.searchParam.destination_location.location)}}\n</div></md-tooltip><div \nng-if=\"$ctrl.searchParam.destination_location && $ctrl.searchParam.destination_location.place_type!==\'Door\' && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{$ctrl.searchParam.destination_location.global_port_code || $ctrl.searchParam.destination_location.portcode_portname}}\n</div><div \nng-if=\"$ctrl.searchParam.destination_location && $ctrl.searchParam.destination_location.place_type===\'Door\' && $ctrl.searchParam.destination_location.pin_code_ui && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{$ctrl.searchParam.destination_location.country_code}} - {{$ctrl.searchParam.destination_location.pin_code_ui}}</span>\n</div></md-input-container></div><div class=\"errors\" ng-if=\"$ctrl.duplicatePortValidation == \'destination_location\'\">\n<div class=\"font-size-11\">This port already used in origin port.</div></div></div><div \nng-if=\"$ctrl.show_destination_port && ($ctrl.searchFromClose || !$ctrl.isStateResult)\" class=\"pt-20\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult }\"><span class=\"font-weight-600 font-size-11 form-title\">\nDestination CY</span><br><div class=\"container-wrap serive-mode-destination-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.podValidation ) || $ctrl.searchBarForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_destination_ports\" ng-model=\"$ctrl.searchParam.user_pod\" md-no-float \nclass=\"panel-select ph-10 pb-5\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'destinationPort\' , \'origin port\')\" ng-mouseenter=\"focused=true\" \nmd-require-match=\"true\" md-on-remove=\"$ctrl.fnRemovePortChip($chip , \'destination_location\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.podValidation ) || $ctrl.searchBarForm.$error.samePortError), \'b-focus\': destinationFocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\"><md-autocomplete class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'destination\');$ctrl.trackEvent(\'pod\',fcl_destinationPortSearchText)\" \nng-focus=\"focused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;\" \nng-blur=\"destinationFocused=false\" id=\"multi-destinatiomn-input\" md-input-name=\"destination_port\" \nmd-search-text=\"fcl_destinationPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(fcl_destinationPortSearchText, $ctrl.mode, \'destination\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search by Port\" md-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" \nmd-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port &&  fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\'  && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationPortSearchText || fcl_destinationPortSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationPortSearchText)\">\n</div><div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}\n</div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span>\n</div></div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.\n</div></md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip \nmd-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParam.user_pod.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                    ($chip.place_type !== \'Door\' ?\n                    ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.searchBarForm.fcl_origin_port.$error.required || $ctrl.searchBarForm.fcl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.fcl_origin_port.$dirty || $ctrl.formSubmit) && !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors font-size-11\" \nng-if=\"$ctrl.searchBarForm.user_nearby_destination.$error.maxchips\">\nYou can search multi port up to {{$ctrl.multiPortPairLimit}}.</div><div class=\"errors\" \nng-if=\"$ctrl.checkExistingPort === \'destinationPort\'\"><div class=\"font-size-11\">This port already used.</div></div><div\n class=\"errors\" ng-if=\"$ctrl.checkOtherPort === \'destinationPort\'\"><div class=\"font-size-11\">\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nclass=\"errors font-size-11\" layout=\"row\" layout-align=\"center center\" \nng-if=\"($ctrl.searchBarForm.nearby_destination_ports.$error.maxchips)\"><md-icon class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">Number of Ports reached maximum limit\n</div></div><div layout=\"row\" flex layout-align=\"end end\" \nng-class=\"{\'errors\':$ctrl.searchBarForm.nearby_destination_ports.$error.maxchips}\">\n{{$ctrl.searchParam.user_pod.length}}/{{$ctrl.destinationPortLimit}}</div></div></div><div \nng-if=\"$ctrl.searchParam.fetch_nearby_destination && ($ctrl.searchFromClose || !$ctrl.isStateResult)\" class=\"pt-20\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult }\"><span class=\"font-weight-600 font-size-11 form-title\">\nDestination Nearby CY</span><br><div class=\"container-wrap serive-mode-destination-port\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByDestinationValidation ) || $ctrl.searchBarForm.$error.samePortError)}\">\n<md-chips md-chip-append-delay=\"3\" name=\"nearby_destination\" ng-model=\"$ctrl.searchParam.nearby_destination\" \nmd-no-float class=\"panel-select ph-10 pb-5\" \nmd-transform-chip=\"$ctrl.checkForDuplicatePorts($chip,\'nearbyDestination\' , \'nearbyOrigin\')\" \nng-mouseenter=\"nearByDestinationfocused=true\" md-require-match=\"true\" \nmd-on-remove=\"$ctrl.fnRemovePortChip($chip , \'nearby_destination\')\" \nng-class=\"{\'red-border\':(($ctrl.formSubmit && $ctrl.nearByDestinationValidation ) || $ctrl.searchBarForm.$error.samePortError), \'b-focus\': nearByDestinationfocused,\'disabled\' : $ctrl.searchFromQuote}\" \nlayout=\"row\"><md-autocomplete class=\"auto-complete-style port-autocomplete mobile_input\" \nmd-selected-item-change=\"$ctrl.trackEvent(\'pod\',nearby_destinationPortSearchText)\" \nng-focus=\"nearByDestinationfocused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;\" \nng-blur=\"nearByDestinationfocused=false\" id=\"multi-destinatiomn-input\" md-input-name=\"nearby_destination\" \nmd-search-text=\"nearby_destinationPortSearchText\" \nmd-items=\"item in $ctrl.getPolPodLocation(nearby_destinationPortSearchText, $ctrl.mode, \'destination\',\'nearby_user\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-autofocus=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"Search nearby Port\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"focused\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"break-word\" flex=\"70\" \nstyle=\"pointer-events: none\"><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && !item.is_icd_port && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-FCL\' && item.place_type===\'Port\' && item.is_icd_port &&  fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"$ctrl.searchParam.mode===\'SEA-LCL\'  && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/lcl_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationPortSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationPortSearchText || fcl_destinationPortSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_destinationPortSearchText)\">\n</div><div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}\n</div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span>\n</div></div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.\n</div></md-not-found></md-autocomplete><md-chip-template><span><div class=\"font-size-11\"><md-tooltip \nmd-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParam.nearby_destination.length\"><div>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, true).join(\', \'):$chip.location)}}\n</div></md-tooltip><md-icon class=\"chip-icon-size-autocomplete mr-4\" \nmd-svg-src=\"{{ $chip ?\n                     ($chip.place_type !== \'Door\' ?\n                     ($ctrl.searchParam.mode===\'SEA-FCL\' ? ($chip.is_icd_port  ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/lcl_port.svg\'): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                     \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!(($ctrl.searchBarForm.nearby_destination.$error.required || $ctrl.searchBarForm.nearby_destination.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.nearby_destination.$dirty || $ctrl.formSubmit) && !nearByDestinationfocused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon>\n{{$chip.place_type !== \'Door\' ? $ctrl.util.portSelectedData($chip, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($chip, false).join(\', \'):$chip.location)}}\n</div></span></md-chip-template></md-chips></div><div class=\"errors\" \nng-if=\"$ctrl.checkExistingPort === \'nearbyDestination\'\"><div class=\"font-size-11\">This port already used.</div></div>\n<div class=\"errors\" ng-if=\"$ctrl.checkOtherPort === \'nearbyDestination\'\"><div class=\"font-size-11\">\nThis port already used in {{$ctrl.portExistIn}}.</div></div><div layout=\"row\" class=\"md-link-fg font-size-11\"><div \nclass=\"errors font-size-11\" layout=\"row\" layout-align=\"center center\" \nng-if=\"($ctrl.searchBarForm.nearby_destination.$error.maxchips)\"><md-icon class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"pt-4\">Number of Ports reached maximum limit\n</div></div><div layout=\"row\" flex layout-align=\"end end\" \nng-class=\"{\'errors\':$ctrl.searchBarForm.nearby_destination.$error.maxchips}\">\n{{$ctrl.searchParam.nearby_destination.length}}/{{$ctrl.destinationNearbyPortLimit}}</div></div></div></div><div \nng-if=\"($ctrl.isStateResult && !ctrl.isMobileDevice) && !$ctrl.searchFromClose\" layout=\"column\" \nlayout-align=\"start end\" layout-align-xs=\"center center\" flex class=\"pr-0 mt-25 mb-15 edit-btn-container\"><div \nclass=\"edit_btn h-40 brad-5 pr-5 pointer md-accent-btn with-icon\" ng-class=\"{\'disabled\': $ctrl.searchFromQuote}\" \nng-click=\"$ctrl.toggleFormForResult();$ctrl.trackEvent(\'edit\');\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"white-fg mr-5 s14 m-0\"></md-icon>Edit</div></div></div><div id=\"search-open-form\" \nflex ng-class=\"{\'hide-at-start\': $ctrl.isStateResult && !ctrl.isMobileDevice}\"><div layout=\"row\" layout-xs=\"column\" \nflex=\"100\" layout-wrap layout-padding class=\"pt-0\"><div ng-include=\"\'app/main/component/search-bar/load-detail.html\'\" \nlayout=\"row\"></div><div ng-if=\"$ctrl.searchConfig && $ctrl.searchConfig.sales_person && !$ctrl.isShipper\" \nclass=\"w-175 mobile_input\"><span class=\"font-weight-600 font-size-13 form-title\">Sales Person</span><br><div \nclass=\"panel-select ph-10\" layout=\"row\" layout-align=\"space-between center\" \nng-class=\"{\'red-border md-placeholder-red\': $ctrl.searchBarForm.salesperson.$error.required && ($ctrl.searchBarForm.salesperson.$dirty || $ctrl.formSubmit),\'disabled\' : $ctrl.searchFromQuote}\">\n<div layout=\"row\" layout-align=\"start center\" flex=\"80\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/sales_person_icon.svg\')\" class=\"icon-bg h-35\" \nng-if=\"!($ctrl.searchBarForm.salesperson.$error.required)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.salesperson.$error.required\" class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-select id=\"sale_person\" class=\"m-0 sales-person\" \nname=\"salesperson\" md-on-close=\"searchSalesPerson = \'\';$ctrl.getSalesPersonList(\'\')\" \nng-focus=\"$ctrl.formIsPristine=false;\" ng-model=\"$ctrl.searchParam.sales_user\" \nng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"Sales Person\" md-no-asterisk=\"true\" \nng-change=\"$ctrl.fnchangeSalesPerson()\" ng-required=\"$ctrl.searchConfig.sales_person.required\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchSalesPerson\" ng-model-options=\"{debounce: 500}\" \nng-change=\"$ctrl.getSalesPersonList(searchSalesPerson)\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Search Sales Person\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.isSalesApiLoading\"><md-progress-circular md-diameter=\"25\">\n</md-progress-circular></div><md-optgroup ng-show=\"!$ctrl.isSalesApiLoading\"><md-option ng-if=\"!searchSalesPerson\" \nng-value=\"null\">Select Sales Person</md-option><md-option class=\"text-capitalize\" \nng-repeat=\"salesPerson in $ctrl.salesPersonList\" ng-value=\"salesPerson\">\n{{ salesPerson.user_first_name }} {{ salesPerson.user_last_name }}</md-option></md-optgroup><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!$ctrl.salesPersonList.length && !$ctrl.isSalesApiLoading\" \nclass=\"font-size-12 pv-10\">No results found</div></md-select></div></div></div><div class=\"w-220 mobile_input\" \nng-if=\"$ctrl.searchConfig && $ctrl.searchConfig.sales_person && !$ctrl.isShipper\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Customer Details</span><br><div ng-if=\"$ctrl.selectListShow\"><div \nshimmer-effect-full width=\"100%\" height=\"40px\" class=\"mt-4\"></div></div><div \nng-if=\"!$ctrl.selectListShow && $ctrl.searchConfig.shipper_email\" \nng-class=\"{\'disabled radius-border\' : $ctrl.searchFromQuote}\"><md-input-container ng-mouseleave=\"focusedCust=false\" \nng-mouseenter=\"focusedCust=true\" md-no-float class=\"p-0 m-0 panel-select ph-10 mobile_input port-autocomplete\" \nflex=\"100\" layout=\"row\" \nng-class=\"{\'red-border\':($ctrl.searchBarForm.shipperName.$error.required || $ctrl.searchBarForm.shipperName.$error[\'md-require-match\']) && ($ctrl.searchBarForm.shipperName.$dirty || $ctrl.formSubmit), \'b-focus\': focusCustomer}\">\n<div style=\"background-image: url(\'assets/icons/custom/search-bar/customer_details_icon.svg\')\" class=\"icon-bg h-35\" \nng-if=\"!($ctrl.searchBarForm.shipperName.$error.required)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.shipperName.$error.required\" class=\"mh-10 h-15 w-15 mt-2 mr-5\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-autocomplete ng-model-options=\"{ debounce: 500 }\" \nclass=\"mt-2 w-150 auto-complete-style customer-email\" \nng-class=\"{\'placeholder-error\':($ctrl.searchBarForm.shipperName.$error.required || $ctrl.searchBarForm.shipperName.$error[\'md-require-match\']) && ($ctrl.searchBarForm.shipperName.$dirty || $ctrl.formSubmit),\'disabled\' : $ctrl.searchFromQuote}\" \nmd-input-id=\"customer_email_id\" md-input-name=\"shipperName\" ng-focus=\"$ctrl.formIsPristine=false;focusCustomer=true\" \nng-blur=\"focusCustomer=false\" md-selected-item=\"$ctrl.searchParam.shipper_user\" md-search-text=\"shipperText\" \nmd-items=\"item in $ctrl.getShipperCompany(shipperText)\" \nmd-item-text=\"item.company.company_name + \', \' + item.user_first_name + \' \' + item.user_last_name + \', \' + item.email\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"150\" md-require-match=\"true\" placeholder=\"Enter Customer Details\" \nmd-menu-class=\"autocomplete-custom-template-search\" md-clear-button=\"focusedCust\" \nmd-menu-container-class=\"custom-container search-autocomplete-customer\" \nng-required=\"$ctrl.searchConfig.shipper_email.required\"><md-item-template><span class=\"item-metadata\"><div \nlayout=\"row\" layout-align=\"space-between\" class=\"p-10 white-bg\"><div layout=\"column\" style=\"pointer-events: none\"><div \nclass=\"nameStyle text-truncate\"><span class=\"capitalize-first-letter\" \ncompile-html=\"(item.user_first_name + \' \' + item.user_last_name)!== \'\' ? $ctrl.util.searchHighlight(item.user_first_name + \' \' + item.user_last_name,shipperText ) : \'\' \">\n</span>&nbsp;</div><div class=\"mailIdStyle text-truncate\"><span class=\"pr-10\" \ncompile-html=\"item.email !== \'\' ? $ctrl.util.searchHighlight(item.email,shipperText) : \'\' \"></span>\n{{item.user_company_name ?\' | \':\'\'}} &nbsp;&nbsp; <span \ncompile-html=\"item.company.company_name !== \'\' ? $ctrl.util.searchHighlight(item.company.company_name,shipperText) : \'\' \">\n</span> <span>&nbsp; {{item.company.external_reference_id ?\' | \':\'\'}} &nbsp;</span> <span class=\"text-truncate\" \ncompile-html=\"item.company.external_reference_id  ? $ctrl.util.searchHighlight(item.company.external_reference_id,shipperText ) : \'\' \">\n</span></div></div></div></span></md-item-template></md-autocomplete></md-input-container></div></div><div \nclass=\"w-265 mobile_input\"><span class=\"font-weight-600 font-size-13 form-title\">Search Reference Name<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">Your search will be saved by the below given name</md-tooltip></md-icon></span><br>\n<md-input-container md-no-float class=\"p-0 m-0 panel-select\" layout=\"row\" \nng-class=\"{\'b-focus\': focusSearchRef,\'disabled\' : $ctrl.searchFromQuote}\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/search_reference_icon.svg\')\" class=\"icon-bg h-35 ml-5\" \nng-if=\"!($ctrl.searchBarForm.search_name.$error.required)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.search_name.$error.required\" class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><input id=\"ref-name-search\" type=\"text\" \nng-focus=\"focusSearchRef=true\" ng-blur=\"focusSearchRef=false\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"$ctrl.searchParam.search_name\" class=\"panel-select-input font-weight-400\" \nplaceholder=\"Search Reference Name\" ng-focus=\"$ctrl.formIsPristine=false;\" ng-change=\"$ctrl.trackEvent(\'reference\');\" \nautocomplete=\"off\"></md-input-container></div><div class=\"w-120 mobile_input\"><span \nclass=\"font-weight-600 font-size-11 form-title\">Search Currency</span><div \nng-class=\"{\'disabled radius-border\' : $ctrl.searchFromQuote}\"><currency-dropdown class=\"w-100-p\" is-search-bar=\"true\" \nfield-value=\"$ctrl.searchParam.search_currency\" page-source=\"$ctrl.pageSource\"></currency-dropdown></div></div><div \nclass=\"w-120 mobile_input\" ng-if=\"$ctrl.co2eToggleVisible && $ctrl.mode===\'SEA-FCL\'\"><span \nclass=\"font-weight-600 font-size-11 form-title\">Enable CO2</span><div \nng-class=\"{\'disabled radius-border\' : $ctrl.searchFromQuote}\" class=\"pt-10\"><md-switch md-no-ink \nng-model=\"$ctrl.searchParam.enable_co2e\" md-invert class=\"m-0 h-20\" \nng-change=\"vm.trackEvent(\'Enable-CO2-Toggle-Click\',\'\',\'common\')\"><span class=\"font-weight-600 font-size-13\"></span>\n</md-switch></div></div><div class=\"bt\" flex=\"100\" layout=\"row\" layout-align=\"start\" ng-if=\"$ctrl.isStateResult\"><div \nclass=\"md-link-fg with-icon font-weight-600 font-size-12 mt-32 pointer\" ng-click=\"$ctrl.refreshSearchRates()\"><md-icon \nclass=\"s18 mb-2\" md-font-icon=\"icon-refresh\"></md-icon><span class=\"font-size-14\">Reset</span></div><div \nng-if=\"$ctrl.isStateResult\" flex layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"end center\" \nlayout-align-xs=\"end center\" layout-align-sm=\"end end\" class=\"search_btn_section\" \nng-class=\"{\'min-width-270\':$ctrl.isStateResult && $ctrl.searchFromClose}\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"hide-search\" layout-align-xs=\"center end\" layout-align-sm=\"center end\" \nng-if=\"$ctrl.isStateResult && $ctrl.searchFromClose\"><div \nclass=\"md-link-fg with-icon font-size-13 text-capitalize Font-Bold pointer mt-15 mr-20\" \nng-click=\"$ctrl.toggleFormForResult($event);$ctrl.trackEvent(\'hide\');\">hide details<md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"s18\"></md-icon></div></div><div layout=\"row\" layout-align=\"end center\" \nlayout-align-xs=\"end end\" layout-align-sm=\"end end\"><md-button md-no-ink \nclass=\"md-accent-btn with-icon w-120 search-btn-margin\" \nng-class=\"{\'search-btn-mobile\': !$ctrl.isStateResult,\'disabled\' : $ctrl.searchFromQuote}\" \nng-click=\"$ctrl.submitSearchForm($event)\" title=\"SEARCH\" \nng-disabled=\"$ctrl.isStateResult && $ctrl.resultcardfilter.countApiCard\"><span ng-if=\"!$ctrl.isStateResult\">\nSearch Rates<md-icon class=\"white-fg ml-5 s14\" md-font-icon=\"icon-arrow-right\"></md-icon></span><span \nng-if=\"$ctrl.isStateResult\" ng-click=\"$ctrl.trackEvent(\'search\');\"><md-icon class=\"white-fg mr-5 s16\" \nmd-font-icon=\"icon-magnify\"></md-icon>Search Now</span></md-button></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"bt ml-10\" flex=\"100\" layout=\"row\" layout-align=\"start\" \nng-if=\"!$ctrl.isStateResult\"><div class=\"md-link-fg with-icon font-weight-600 font-size-12 mt-32 pointer\" \nng-click=\"$ctrl.refreshSearchRates()\"><md-icon class=\"s18 mb-2\" md-font-icon=\"icon-refresh\"></md-icon><span \nclass=\"font-size-14\">Reset</span></div></div><div class=\"bt mt-10 pv-10\" flex=\"100\" layout=\"row\" \nlayout-align=\"end end\" ng-if=\"!$ctrl.isStateResult\"><md-button md-no-ink \nclass=\"md-primary-btn w-120 search-btn-margin\" ng-class=\"{\'mr-10\' : $ctrl.mode===\'SEA-FCL\'}\" \nng-click=\"$ctrl.submitScheduleForm($ctrl.searchParam.origin_location, $ctrl.searchParam.destination_location)\" \nng-if=\"!$ctrl.isStateResult && $ctrl.mode===\'SEA-FCL\' && $ctrl.scheduleSearch\" \nng-disabled=\"($ctrl.isMultiPort && $ctrl.is_nXn_search)\">Schedule Search<md-tooltip md-direction=\"top\" \ndata-html=\"true\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\nNote: By default Schedule search will only consider<br>origin ports, destination ports and cut off date of two weeks.\n</md-tooltip></md-button><md-button md-no-ink class=\"md-accent-btn with-icon w-120 mr-10\" \nng-click=\"$ctrl.submitSearchForm($event)\" title=\"SEARCH\" \nng-disabled=\"$ctrl.isStateResult && $ctrl.resultcardfilter.countApiCard\"><span>Search Rates<md-icon \nclass=\"white-fg ml-5 s14\" md-font-icon=\"icon-arrow-right\"></md-icon></span></md-button></div></div></div></form></div>\n<div class=\"overlay\" ng-if=\"$ctrl.isStateResult && $ctrl.searchFromClose\" ng-click=\"$ctrl.toggleFormForResult()\"></div>\n<div layout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"md-link-fg h-50\" \nng-if=\"$ctrl.resultcardfilter.deviceName == \'mobile\' && !$ctrl.editSearch\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"ml-20\"><div class=\"ml-10 mr-15 Font-Bold\"><md-icon ng-click=\"$ctrl.goBack()\" \nmd-font-icon=\"icon-arrow-left\" class=\"s18 pointer md-link-fg\"></md-icon></div><div><div class=\"font-size-14 Font-Bold\">\n{{ $ctrl.searchParam.origin_location.location }} - {{ $ctrl.searchParam.destination_location.location }}</div><div \nclass=\"font-size-12\">{{ $ctrl.LoadBoxString }}</div></div></div><div layout=\"column\" layout-align=\"start center\"><span \nclass=\"pr-8 mr-5 Font-Bold\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18 md-link-fg pointer\" \nng-click=\"$ctrl.fnEditSearch()\" title=\"Edit\"></md-icon></span></div></div></div>");
$templateCache.put("app/main/component/search-bar-inland/search-bar-inland.html","<div id=\"search-bar-inland\"><div class=\"form-container\"><form name=\"$ctrl.searchBarForm\" class=\"search-form\"><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" layout-wrap layout-padding class=\"pb-0 pr-5\"><div \nclass=\"mobile_input w-665\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult,\'result_multiport_div\':$ctrl.isStateResult}\" \nng-if=\"!$ctrl.isMultiPort\"><div layout=\"row\" class=\"mb-12\"><span class=\"font-weight-600 font-size-13 form-title mr-10\">\nOrigin</span> <span class=\"pl-8 margin-t-2 font-size-13\"><div class=\"search-group-button\" \nng-show=\"!vm.isLoadingServiceMode\"><button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" ng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'origin\');\">DOOR</button> <button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes(\'CY\')\" ng-class=\"{\'search-tab-active\': $ctrl.viewToggleOrigin == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'origin\');\">CY</button></div></span></div><md-input-container \nmd-no-float class=\"p-0 m-0 panel-select ph-10\" ng-mouseleave=\"focused=false\" ng-mouseenter=\"focused=true\" \nng-class=\"{\'red-border pl-35\':(($ctrl.searchBarForm.ftl_origin_port.$error.required || $ctrl.searchBarForm.ftl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_origin_port.$dirty || $ctrl.formSubmit) && !focused), \'pl-35\': $ctrl.mode!==\'AIR\', \'b-focus\': originFocused}\" \nlayout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"(($ctrl.searchBarForm.ftl_origin_port.$error.required || $ctrl.searchBarForm.ftl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_origin_port.$dirty || $ctrl.formSubmit) && !focused)\" \nmdprefix class=\"mh-5 h-15 w-15 mt-2 ml-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-autocomplete ml-2\" \nng-class=\"{  \'icon-size-10 margin-top-6\' : !$ctrl.searchParam.origin[0] ,\'h-24 w-24\' : $ctrl.searchParam.origin[0].placeType===\'Door\'}\" \nmd-svg-src=\"{{ $ctrl.searchParam.origin[0] ?\n               ($ctrl.searchParam.origin[0].placeType !== \'Door\' ?\n                    ( (!$ctrl.searchParam.origin[0].isIcdPort  ? \'assets/icons/custom/search-bar/port_fcl.svg\' : \'assets/icons/custom/search-bar/icd_port.svg\')): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"($ctrl.searchParam.origin[0] && !(($ctrl.searchBarForm.ftl_origin_port.$error.required || $ctrl.searchBarForm.ftl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_origin_port.$dirty || $ctrl.formSubmit)&& !focused)) && $ctrl.mode!==\'AIR\'\">\n</md-icon><md-icon class=\"mh-5 icon-size-autocomplete mt-2\" \nng-class=\"{\'icon-size-10 mt-6\' : !$ctrl.searchParam.origin[0]}\" md-svg-src=\"assets/icons/custom/search-bar/empty.svg\" \nng-if=\"(!$ctrl.searchParam.origin[0] &&  !(($ctrl.searchBarForm.ftl_origin_port.$error.required || $ctrl.searchBarForm.ftl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_origin_port.$dirty || $ctrl.formSubmit)&& !focused))\">\n</md-icon><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" \nmd-selected-item-change=\"$ctrl.checkForSamePorts(\'origin\');\" \nng-focus=\"focused=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;originFocused=true\" \nng-blur=\"originFocused=false\" \nng-class=\"{\'placeholder-error\':(($ctrl.searchBarForm.ftl_origin_port.$error.required || $ctrl.searchBarForm.ftl_origin_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_origin_port.$dirty || $ctrl.formSubmit) && !focused)}\" \nrequired id=\"ftl-origin-input\" md-input-name=\"ftl_origin_port\" md-selected-item=\"$ctrl.searchParam.origin[0]\" \nmd-search-text=\"fcl_originSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(fcl_originSearchText, $ctrl.mode, \'origin\')\" \nmd-item-text=\"item.placeType !== \'Door\' ? $ctrl.util.portSelectedDataFtl(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedDataFtl(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nmd-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{$ctrl.viewToggleOrigin==\'door\'? \'Search by Door\' : \'Search by Port\'}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"focused\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.placeType===\'Port\' || item.placeType===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div \nng-show=\"item.placeType===\'Port\' && !item.isIcdPort && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.placeType===\'Port\' && item.isIcdPort && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.placeType===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.countryName\">, </span>{{item.countryName}}\n</div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nng-if=\"item.globalPortCode\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.globalPortCode}}</span></div>\n</div></span><span class=\"item-metadata\" ng-if=\"item.placeType==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div ng-show=\"fcl_originSearchText.length >=2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownDataFtl(item, fcl_originSearchText); \n                                                                                                                     track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\">\n<span \nng-repeat=\"location in $ctrl.util.subDoorDropdownDataFtl(item, fcl_originSearchText,false); \n                                                                                                                                            track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span>\n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownDataFtl(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownDataFtl(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pincode\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.countryCode}}-{{item.pincode}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleOrigin != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParam.origin[0]\"><div>\n{{$ctrl.searchParam.origin[0].placeType !== \'Door\' ? $ctrl.util.portSelectedDataFtl($ctrl.searchParam.origin[0], true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedDataFtl($ctrl.searchParam.origin[0], true).join(\',\'):$ctrl.searchParam.origin[0].location)}}\n</div></md-tooltip><div \nng-if=\"$ctrl.searchParam.origin[0] && $ctrl.searchParam.origin[0].placeType!==\'Door\' && !focused\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{$ctrl.searchParam.origin[0].globalPortCode || $ctrl.searchParam.origin[0].portcode_portname}}</div><div \nng-if=\"$ctrl.searchParam.origin[0] && $ctrl.searchParam.origin[0].placeType===\'Door\' && $ctrl.searchParam.origin[0].pincode && !focused\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{$ctrl.searchParam.origin[0].countryCode}}-{{$ctrl.searchParam.origin[0].pincode}}</span></div></md-input-container>\n</div><div class=\"mobile_input w-665\" \nng-class=\"{\'search_multiport_div\':!$ctrl.isStateResult,\'result_multiport_div\':$ctrl.isStateResult}\" \nng-if=\"!$ctrl.isMultiPort\"><div layout=\"row\" class=\"mb-12\"><span class=\"font-weight-600 font-size-13 form-title mr-10\">\nDestination</span> <span class=\"pl-8 margin-t-2 font-size-13\"><div class=\"search-group-button\" \nng-show=\"!vm.isLoadingServiceMode\"><button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes(\'CY\')\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'port\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'port\',\'destination\');\">CY</button> <button class=\"search-tab-icon-button\" \nng-if=\"$ctrl.showLocationToggle.includes(\'DOOR\')\" \nng-class=\"{\'search-tab-active\': $ctrl.viewToggleDestination == \'door\'}\" \nng-click=\"$ctrl.fnDialogSwitchToDoorPort(\'door\',\'destination\');\">DOOR</button></div></span></div><md-input-container \nmd-no-float class=\"p-0 m-0 panel-select ph-10\" layout=\"row\" layout-align=\"start center\" \nng-mouseleave=\"focusedDestination=false\" ng-mouseenter=\"focusedDestination=true\" \nng-class=\"{\'red-border pl-35\':(($ctrl.searchBarForm.ftl_destination_port.$error.required || $ctrl.searchBarForm.ftl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination), \'pl-35\': $ctrl.mode!==\'AIR\', \'b-focus\': destinationFocused}\">\n<md-icon \nng-if=\"(($ctrl.searchBarForm.ftl_destination_port.$error.required || $ctrl.searchBarForm.ftl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)\" \nmdprefix class=\"mh-5 h-15 w-15 mt-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"icon-size-autocomplete ml-2\" \nng-class=\"{  \'icon-size-10 margin-top-6\' : !$ctrl.searchParam.destination[0] ,\'h-24 w-24\' : $ctrl.searchParam.destination[0].placeType===\'Door\'}\" \nmd-svg-src=\"{{ $ctrl.searchParam.destination[0] ?\n               ($ctrl.searchParam.destination[0].placeType !== \'Door\' ?\n                    ( (!$ctrl.searchParam.destination[0].isIcdPort  ? \'assets/icons/custom/search-bar/port_fcl.svg\' : \'assets/icons/custom/search-bar/icd_port.svg\')): (\'assets/icons/custom/search-bar/door_img.svg\' )) :\n                    \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"($ctrl.searchParam.destination[0] && !(($ctrl.searchBarForm.ftl_destination_port.$error.required || $ctrl.searchBarForm.ftl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)) && $ctrl.mode!==\'AIR\'\">\n</md-icon><md-icon class=\"mh-5 icon-size-autocomplete mt-2\" \nng-class=\"{\'icon-size-10 mt-6\' : !$ctrl.searchParam.destination[0]}\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\" \nng-if=\"(!$ctrl.searchParam.destination[0] &&  !(($ctrl.searchBarForm.ftl_destination_port.$error.required || $ctrl.searchBarForm.ftl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination))\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\" \nng-if=\"(!(($ctrl.searchBarForm.ftl_destination_port.$error.required || $ctrl.searchBarForm.ftl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)) && $ctrl.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" required \nid=\"destination-input\" \nng-focus=\"focusedDestination=true; $ctrl.isStateResult ? (!$ctrl.searchFromClose ? $ctrl.toggleFormForResult() : return) : return; $ctrl.formIsPristine=false;destinationFocused=true\" \nng-blur=\"destinationFocused=false\" md-selected-item-change=\"$ctrl.checkForSamePorts(\'destination\');\" \nmd-input-name=\"ftl_destination_port\" md-selected-item=\"$ctrl.searchParam.destination[0]\" \nng-class=\"{\'placeholder-error\':(($ctrl.searchBarForm.ftl_destination_port.$error.required || $ctrl.searchBarForm.ftl_destination_port.$error[\'md-require-match\'] || $ctrl.searchBarForm.$error.samePortError) && ($ctrl.searchBarForm.ftl_destination_port.$dirty || $ctrl.formSubmit)&& !focusedDestination)}\" \nmd-search-text=\"ftl_destinationSearchText\" \nmd-items=\"item in $ctrl.getPortsLocation(ftl_destinationSearchText, $ctrl.mode, \'destination\')\" \nmd-item-text=\"item.placeType !== \'Door\' ? $ctrl.util.portSelectedDataFtl(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedDataFtl(item, false).join(\', \'):item.location)\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" md-require-match=\"true\" \nplaceholder=\"{{$ctrl.viewToggleDestination==\'door\'? \'Search by Door\' : \'Search by Port\'}}\" \nmd-menu-class=\"autocomplete-custom-template-search\" md-menu-container-class=\"custom-container search-autocomplete\" \nmd-select-on-focus=\"true\" md-clear-button=\"focusedDestination\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.placeType===\'Port\' || item.placeType===\'Airport\'\"><div class=\"font-size-12 p-10\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div \nng-show=\"item.placeType===\'Port\' && !item.isIcdPort && ftl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port_fcl.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.placeType===\'Port\' && item.isIcdPort && ftl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.placeType===\'Airport\' && ftl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!ftl_destinationSearchText || ftl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.location,ftl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.countryName\">, </span>\n{{item.countryName}}</div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nng-if=\"item.globalPortCode\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.globalPortCode}}</span></div>\n</div></span><span class=\"item-metadata\" ng-if=\"item.placeType==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"ftl_destinationSearchText.length >=2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door_img.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!ftl_destinationSearchText || ftl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div layout=\"column\" \nclass=\"pl-8\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" class=\"tooltip-container\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownDataFtl(item, ftl_destinationSearchText); \n                                                                                                                                         track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" class=\"tooltip-container\">\n<span \nng-repeat=\"location in $ctrl.util.subDoorDropdownDataFtl(item, ftl_destinationSearchText,false); \n                                                                                                                                                                track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,ftl_destinationSearchText)\">\n</span><span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownDataFtl(item, ftl_destinationSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownDataFtl(item, ftl_destinationSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" class=\"pl-8 margin-top-6\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,ftl_destinationSearchText)\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"item.pincode\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.countryCode}}-{{item.pincode}}</span></div>\n</div></span></md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">\nNo {{ $ctrl.viewToggleDestination != \'door\' ? \'ports\' : \'doors\'}} matching were found.</div></md-not-found>\n</md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.searchParam.destination[0]\"><div>\n{{$ctrl.searchParam.destination[0].placeType !== \'Door\' ? $ctrl.util.portSelectedDataFtl($ctrl.searchParam.destination[0], true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedDataFtl($ctrl.searchParam.destination[0], true).join(\',\'):$ctrl.searchParam.destination[0].location)}}\n</div></md-tooltip><div \nng-if=\"$ctrl.searchParam.destination[0] && $ctrl.searchParam.destination[0].placeType!==\'Door\' && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{$ctrl.searchParam.destination[0].globalPortCode || $ctrl.searchParam.destination[0].location}}</div><div \nng-if=\"$ctrl.searchParam.destination[0] && $ctrl.searchParam.destination[0].placeType===\'Door\' && $ctrl.searchParam.destination[0].pincode && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{$ctrl.searchParam.destination[0].countryCode}}-{{$ctrl.searchParam.destination[0].pincode}}</span></div>\n</md-input-container></div></div><div id=\"search-open-form\"><div layout=\"row\" layout-xs=\"column\" flex=\"100\" \nlayout-wrap layout-padding class=\"pt-0\"><div class=\"mode-select-wrapper\"><div \nclass=\"font-weight-600 font-size-13 form-title\">Mode</div><md-input-container md-no-float \nclass=\"selectbox b brad-3 p-0 mt-8 h-36 w-135 md-no-underline\"><md-icon md-svg-src=\"assets/icons/custom/truck_ftl.svg\" \nclass=\"mh-5 icon-size-autocomplete mode-icon mt-2\"></md-icon><md-select ng-model=\"$ctrl.searchParam.mode\" \nid=\"search-icon\" class=\"md-no-underline mode-select\" ng-disabled=\"true\"><md-option ng-value=\"\'FTL\'\">Inland-FCL\n</md-option></md-select></md-input-container></div><div class=\"bottom-align\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Cut Off Date</span><br><md-input-container md-no-float class=\"p-0 m-0\">\n<div class=\"w-120 panel-select pointer mobile_input\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'red-border\':($ctrl.searchBarForm.cargoReadyDate.$error.required || $ctrl.searchBarForm.cargoReadyDate.$error.mindate) && ($ctrl.searchBarForm.cargoReadyDate.$dirty || $ctrl.formSubmit)}\" \nng-click=\"$ctrl.openDatePicker=true\"><div style=\"background-image: url(\'assets/icons/custom/search-bar/date.svg\')\" \nclass=\"icon-bg\" \nng-if=\"!(($ctrl.searchBarForm.cargoReadyDate.$error.required || $ctrl.searchBarForm.cargoReadyDate.$error.mindate) && ($ctrl.searchBarForm.cargoReadyDate.$dirty || $ctrl.formSubmit))\">\n</div><md-icon \nng-if=\"($ctrl.searchBarForm.cargoReadyDate.$error.required || $ctrl.searchBarForm.cargoReadyDate.$error.mindate) && ($ctrl.searchBarForm.cargoReadyDate.$dirty || $ctrl.formSubmit)\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"mt-2\" \nng-class=\"{\'red-fg remove-pl mt-2\':($ctrl.searchBarForm.cargoReadyDate.$error.required || $ctrl.searchBarForm.cargoReadyDate.$error.mindate) && ($ctrl.searchBarForm.cargoReadyDate.$dirty || $ctrl.formSubmit)}\" \nng-bind=\"$ctrl.searchParam.cargoReadyDate ? ($ctrl.searchParam.cargoReadyDate  |  date : \'dd MMM yyyy\') : \'Select Date\'\">\n</div></div><md-datepicker id=\"date-picker-search\" name=\"cargoReadyDate\" md-min-date=\"$ctrl.cargoMinDate\" \nng-model=\"$ctrl.searchParam.cargoReadyDate\" md-placeholder=\"Select\" md-is-open=\"$ctrl.openDatePicker\" \nonkeydown=\"return false\" md-open-on-focus md-hide-icons=\"all\" class=\"pv-5 pl-15\" required \nng-focus=\"$ctrl.formIsPristine=false;\" ng-blur=\"$ctrl.focusElem()\"></md-datepicker></md-input-container></div><div>\n<span ng-if=\"$ctrl.isload_type_alias\" class=\"font-weight-600 font-size-13 form-title\">Load Type<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 pointer load-alias grey-400-fg\" \nng-mouseover=\"$ctrl.showLoadAlias($event);$ctrl.trackEvent(\'panel\')\"></md-icon></span><span \nng-if=\"!$ctrl.isload_type_alias\" class=\"font-weight-600 font-size-13 form-title\">Load Type<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 pointer load-alias grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">Select multiple loads to view rates</md-tooltip></md-icon></span><br><md-input-container \nmd-no-float class=\"p-0 m-0\"><div class=\"w-170 panel-select panel-select-load pointer mobile_input\" \nng-click=\"$ctrl.showLoadPanel($event)\" ng-class=\"{\'red-border red-fg\': $ctrl.searchBarForm.$error.loadError}\" \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"80\">\n<div style=\"background-image: url(\'assets/icons/custom/search-bar/load_type.svg\')\" class=\"icon-bg\" \nng-if=\"!($ctrl.searchBarForm.$error.loadError)\"></div><md-icon ng-if=\"$ctrl.searchBarForm.$error.loadError\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div \ntruncate=\"{{$ctrl.LoadBoxString}}\" class=\"mt-2 pv-5 hide-overflow text-truncate\" \nng-class=\"{\'margin-remove\': $ctrl.LoadBoxString===\'\'}\">{{$ctrl.LoadBoxString}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.LoadTooltipString}}</span>\n</md-tooltip></div><div ng-if=\"$ctrl.LoadBoxString===\'\'\" class=\"mh-10 pv-5\" \nng-class=\"{\'margin-remove\':$ctrl.searchBarForm.$error.loadError}\">Select Load</div></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\" flex=\"20\"></md-icon></div></md-input-container></div><div \nclass=\"mobile_input panel_alignment\"><span class=\"font-weight-600 font-size-13 form-title\">Stuffing</span><br>\n<md-input-container md-no-float class=\"p-0 m-0\"><div class=\"panel-select panel-select-charge pointer mobile_input\" \nng-class=\"{\'red-border red-fg\': $ctrl.searchBarForm.$error.chargeError , \'w-270\': $ctrl.mode===\'SEA-FCL\', \'w-160\': $ctrl.mode!==\'SEA-FCL\'}\" \nng-click=\"$ctrl.showChargePanel($event)\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"80\"><div style=\"background-image: url(\'assets/icons/custom/search-bar/charges.svg\')\" \nclass=\"icon-bg\" ng-if=\"!($ctrl.searchBarForm.$error.chargeError)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.$error.chargeError\" class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div truncate=\"{{$ctrl.detailBoxString}}\" \nclass=\"mt-2 pv-5 hide-overflow text-truncate\">{{$ctrl.detailBoxString}}<md-tooltip ng-if=\"$ctrl.detailBoxTooltip\" \nmd-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.detailBoxTooltip}}</span>\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\"></md-icon></div>\n</md-input-container></div><div ng-if=\"$ctrl.searchConfig && $ctrl.searchConfig.sales_person && !$ctrl.isShipper\" \nclass=\"w-175 mobile_input\"><span class=\"font-weight-600 font-size-13 form-title\">Sales Person</span><br><div \nclass=\"panel-select ph-10\" layout=\"row\" layout-align=\"space-between center\" \nng-class=\"{\'red-border md-placeholder-red\': $ctrl.searchBarForm.salesperson.$error.required && ($ctrl.searchBarForm.salesperson.$dirty || $ctrl.formSubmit)}\">\n<div layout=\"row\" layout-align=\"start center\" flex=\"80\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/sales_person_icon.svg\')\" class=\"icon-bg h-35\" \nng-if=\"!($ctrl.searchBarForm.sales_person.$error.required)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.sales_person.$error.required\" class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-select id=\"sale_person\" \nclass=\"m-0 sales-person sales-md-select\" name=\"salesperson\" \nmd-on-open=\"ctrl.util.fnSetPanelPosition(\'sales-md-select\' , \'md_select_position_sales\')\" \nmd-container-class=\"md_select_position_sales\" md-on-close=\"searchSalesPerson = \'\';$ctrl.getSalesPersonList(\'\')\" \nng-focus=\"$ctrl.formIsPristine=false;\" ng-model=\"$ctrl.searchParam.salesUser\" \nng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"Sales Person\" md-no-asterisk=\"true\" \nng-change=\"$ctrl.fnchangeSalesPerson(\'\',searchSalesPerson)\" ng-required=\"$ctrl.searchConfig.sales_person.required\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchSalesPerson\" ng-model-options=\"{debounce: 500}\" \nng-change=\"$ctrl.getSalesPersonList(searchSalesPerson)\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Search Sales Person\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.isSalesApiLoading\"><md-progress-circular md-diameter=\"25\">\n</md-progress-circular></div><md-optgroup ng-show=\"!$ctrl.isSalesApiLoading\"><md-option ng-if=\"!searchSalesPerson\" \nng-value=\"null\">Select Sales Person</md-option><md-option class=\"text-capitalize\" \nng-repeat=\"salesPerson in $ctrl.salesPersonList\" ng-value=\"salesPerson\">\n{{ salesPerson.userFirstName }} {{ salesPerson.userLastName }}</md-option></md-optgroup><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!$ctrl.salesPersonList.length && !$ctrl.isSalesApiLoading\" \nclass=\"font-size-12 pv-10\">No results found</div></md-select></div></div></div><div class=\"w-220 mobile_input\" \nng-if=\"$ctrl.searchConfig && $ctrl.searchConfig.sales_person && !$ctrl.isShipper\"><span \nclass=\"font-weight-600 font-size-13 form-title\">Customer Details</span><br><div ng-if=\"$ctrl.selectListShow\"><div \nshimmer-effect-full width=\"100%\" height=\"40px\" class=\"mt-4\"></div></div><div \nng-if=\"!$ctrl.selectListShow && $ctrl.searchConfig.shipper_email\"><md-input-container \nng-mouseleave=\"focusedCust=false\" ng-mouseenter=\"focusedCust=true\" md-no-float \nclass=\"p-0 m-0 panel-select ph-10 mobile_input port-autocomplete\" flex=\"100\" layout=\"row\" \nng-class=\"{\'red-border\':($ctrl.searchBarForm.shipperName.$error.required || $ctrl.searchBarForm.shipperName.$error[\'md-require-match\']) && ($ctrl.searchBarForm.shipperName.$dirty || $ctrl.formSubmit), \'b-focus\': focusCustomer}\">\n<div style=\"background-image: url(\'assets/icons/custom/search-bar/customer_details_icon.svg\')\" class=\"icon-bg h-35\" \nng-if=\"!($ctrl.searchBarForm.shipperName.$error.required)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.shipperName.$error.required\" class=\"mh-10 h-15 w-15 mt-2 mr-5\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-autocomplete ng-model-options=\"{ debounce: 500 }\" \nclass=\"mt-2 w-150 auto-complete-style customer-email\" \nng-class=\"{\'placeholder-error\':($ctrl.searchBarForm.shipperName.$error.required || $ctrl.searchBarForm.shipperName.$error[\'md-require-match\']) && ($ctrl.searchBarForm.shipperName.$dirty || $ctrl.formSubmit)}\" \nmd-input-id=\"customer_email_id\" md-input-name=\"shipperName\" ng-focus=\"$ctrl.formIsPristine=false;focusCustomer=true\" \nng-blur=\"focusCustomer=false\" md-selected-item=\"$ctrl.searchParam.customer\" md-search-text=\"shipperText\" \nmd-items=\"item in $ctrl.getShipperCompany(shipperText)\" \nmd-item-text=\"item.userCompanyName + \', \' + item.userFirstName + \' \' + item.userLasttName + \', \' + item.email\" \nmd-min-length=\"0\" md-no-cache=\"true\" md-delay=\"150\" md-require-match=\"true\" placeholder=\"Enter Customer Details\" \nmd-menu-class=\"autocomplete-custom-template-search\" md-clear-button=\"focusedCust\" \nmd-menu-container-class=\"custom-container search-autocomplete-customer\" \nng-required=\"$ctrl.searchConfig.shipper_email.required\"><md-item-template><span class=\"item-metadata\"><div \nlayout=\"row\" layout-align=\"space-between\" class=\"p-10 white-bg\"><div layout=\"column\" style=\"pointer-events: none\"><div \nclass=\"nameStyle text-truncate\"><span class=\"capitalize-first-letter\" \ncompile-html=\"(item.userFirstName + \' \' + item.userLasttName)!== \'\' ? $ctrl.util.searchHighlight(item.userFirstName + \' \' + item.userLasttName,shipperText ) : \'\' \">\n</span>&nbsp;</div><div class=\"mailIdStyle text-truncate\"><span class=\"pr-10\" \ncompile-html=\"item.email !== \'\' ? $ctrl.util.searchHighlight(item.email,shipperText) : \'\' \"></span>\n{{item.userCompanyName ?\' | \':\'\'}} &nbsp;&nbsp; <span \ncompile-html=\"item.userCompanyName !== \'\' ? $ctrl.util.searchHighlight(item.userCompanyName,shipperText) : \'\' \"></span>\n</div></div></div></span></md-item-template></md-autocomplete></md-input-container></div></div><div \nclass=\"w-265 mobile_input\"><span class=\"font-weight-600 font-size-13 form-title\">Search Reference Name<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">Your search will be saved by the below given name</md-tooltip></md-icon></span><br>\n<md-input-container md-no-float class=\"p-0 m-0 panel-select\" layout=\"row\" ng-class=\"{\'b-focus\': focusSearchRef}\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/search_reference_icon.svg\')\" class=\"icon-bg h-35 ml-5\" \nng-if=\"!($ctrl.searchBarForm.referenceText.$error.required)\"></div><md-icon \nng-if=\"$ctrl.searchBarForm.referenceText.$error.required\" class=\"mh-10 h-15 w-15\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><input id=\"ref-name-search\" type=\"text\" \nng-focus=\"focusSearchRef=true\" ng-blur=\"focusSearchRef=false\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"$ctrl.searchParam.referenceText\" class=\"panel-select-input font-weight-400\" \nplaceholder=\"Search Reference Name\" ng-focus=\"$ctrl.formIsPristine=false;\" autocomplete=\"off\"></md-input-container>\n</div><div class=\"w-180 pb-10 ph-20 mobile_input\"><span class=\"font-weight-600 font-size-13 form-title\">Trucker/Carrier\n</span><div ng-if=\"$ctrl.selectedtruckerLoading &&  $ctrl.truckerListLoading\"><div shimmer-effect-full width=\"100%\" \nheight=\"40px\" class=\"mt-4\"></div></div><md-select placeholder=\"Select Trucker/Carrier\" \nng-model=\"$ctrl.selectedtrucker\" ng-if=\"!$ctrl.selectedtruckerLoading &&  !$ctrl.truckerListLoading\" \nmd-on-open=\"$ctrl.util.fnSetPanelPosition(\'locals-md-select\' , \'md_select_position_trucker\')\" \nng-model-options=\"{trackBy : \'$value.name\'}\" md-on-close=\"$ctrl.searchtext =\'\'\" \nng-change=\"$ctrl.searchtext =\'\';$ctrl.trackEvent(\'IR-Trucker-Change\')\" \nmd-container-class=\"multi-select w-220 md_select_position_trucker\" id=\"search-icon\" \nclass=\"md-no-underline b brad-5 mt-5 mb-0 h-40 ellipsis locals-md-select\" multiple=\"multiple\"><md-tooltip \nng-if=\"$ctrl.selectedtrucker.length\" md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><div \nng-repeat=\"option in $ctrl.selectedtrucker\">{{option.name}}</div></md-tooltip><md-select-header><div \nstyle=\"width: 96%\" class=\"mt-5\"><div class=\"search-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"$ctrl.searchtext\" class=\"md-text search-input\" \nng-change=\"$ctrl.trackEvent(\'IR-Trucker-Search\',$ctrl.searchtext)\"><md-icon flex=\"10\" md-font-icon=\"icon-magnify\" \nclass=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"filter-controler h-35 mt-5\"><div><span class=\"font-size-12 pr-2\">Trucker/Carrier</span><span \nclass=\"filter-count md-component-bg white-fg\" ng-if=\"$ctrl.selectedtrucker.length>0\">{{$ctrl.selectedtrucker.length}}\n</span></div></div></md-select-header><md-option ng-value=\"optionVal\" \nng-repeat=\"optionVal in $ctrl.truckerList | filter:$ctrl.searchtext\">{{optionVal.name}}</md-option><div \nng-if=\"$ctrl.truckerList.length && ($ctrl.truckerList | filter:$ctrl.searchtext).length === 0\" \nclass=\"ph-20 mt-5 pb-10 fg-AAA8AD\">No Result Match Found</div><div layout=\"row\" layout-align=\"center center\" \nclass=\"save-selected-button\" ng-click=\"$ctrl.mdSelect.hide()\">Done</div></md-select></div><div \nclass=\"w-120 mobile_input\"><span class=\"font-weight-600 font-size-11 form-title\">Search Currency</span>\n<currency-dropdown class=\"w-100-p\" is-search-bar=\"true\" field-value=\"$ctrl.searchParam.searchCurrency\" \npage-source=\"\'IR\'\"></currency-dropdown></div></div><div class=\"bt mt-10 pv-10\" flex=\"100\" layout=\"row\" \nlayout-align=\"end end\"><md-button md-no-ink class=\"md-accent-btn with-icon w-120 mr-10\" \nng-click=\"$ctrl.submitSearchForm($event)\" title=\"SEARCH\"><span>Search Rates<md-icon class=\"white-fg ml-5 s14\" \nmd-font-icon=\"icon-arrow-right\"></md-icon></span></md-button></div></div></form></div></div>");
$templateCache.put("app/main/component/service-panel/service-mode.html","<div ng-click=\"$ctrl.isDisabled ? \'\' : $ctrl.showServiceModelPanel($event)\" class=\"pl-10 service-mode\" \nng-class=\"{\'service-mode-disabled\':$ctrl.isDisabled}\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" style=\"display: table;opacity: 1; height: auto\">\nSelect {{$ctrl.title}}</md-tooltip><span class=\"Font-Bold\">{{$ctrl.selectedValue }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\"></md-icon></div>");
$templateCache.put("app/main/component/service-panel/service-panel.html","<div class=\"servicePanel\"><div class=\"panel-title Font-Bold\">{{ctrl.parent.title}}</div><div><md-radio-group \nng-model=\"ctrl.parent.selectedValue\"><div class=\"radio-group\"><md-radio-button \nng-repeat=\"service in ctrl.parent.serviceList\" ng-value=\"service.value\" md-no-ink class=\"md-primary checkbox-margin\" \nflex>{{service.value}}</md-radio-button></div></md-radio-group></div></div>");
$templateCache.put("app/main/component/share-quotation/share-quotation.html","<md-toolbar id=\"share_quotation_Toolbar\" class=\"font-size-21\"><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex=\"70\"><span class=\"toolbarHeading font-weight-600 p-0\">\nGenerate Quotation</span></div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor m-0\" ng-click=\"$ctrl.cancelDialog(\'quote\')\" \nng-disabled=\"$ctrl.PdfQuoteBtn || $ctrl.shareQuoteBtn\"></md-icon></div></div></md-toolbar><div layout=\"column\" \nflex=\"100\" class=\"stepper-head\"><div layout=\"row\" flex=\"100\" class=\"stepper-bar-container h-90\"><ul \nclass=\"stepper-bar\" layout=\"row\" flex=\"100\"><li class=\"active\" ng-click=\"$ctrl.fnGotoFirstScreen()\">QUOTE DETAILS</li>\n<li>CUSTOMER DETAILS</li><li>QUOTE ID</li></ul></div><div layout=\"row\" flex=\"100\" class=\"screens-container\"><div \nlayout=\"column\" flex=\"100\" ng-show=\"$ctrl.showScreen == 1\"><form name=\"quoteDetailsScreenForm\" novalidate \nng-submit=\"$ctrl.fnSendQuotation(quoteDetailsScreenForm)\"><div layout=\"column\" layout-xs=\"column\" flex=\"100\" \nclass=\"m-20\"><div layout=\"row\" layout-xs=\"column\" class=\"mb-25\" flex=\"100\" flex-xs=\"100\" \nlayout-align=\"space-between center\"><div layout=\"column\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\" class=\"head-name\"><p class=\"mt-0 mb-0\">Start Date</p><date-picker \nmd-input-id=\"\'start_date\'\" \nis-validate=\"(($ctrl.validationObj.startDateValidation) || (quoteDetailsScreenForm.start_date.$touched && quoteDetailsScreenForm.start_date.$error.valid))\" \nis-editable=\"true\" is-disabled=\"false\" input-required=\"false\" input-name=\"\'start_date\'\" \ndate-placeholder=\"\'Start date\'\" date-format=\"true\" full-border=\"false\" min-date-value=\"$ctrl.startDateStart\" \nmax-date-value=\"$ctrl.quoteDetails.expiry_date\" model-value=\"$ctrl.quoteDetails.start_date\" \ncallback=\"$ctrl.quoteDetails.start_date=value;$ctrl.validationObj.startDateValidation=false;$ctrl.getExpiryMaxDate($ctrl.quoteDetails.start_date)\">\n</date-picker><div ng-if=\"$ctrl.validationObj.startDateValidation\" class=\"validation-error-text\">Select Start Date\n</div><div \nng-messages=\"!$ctrl.validationObj.startDateValidation && (quoteDetailsScreenForm.start_date.$touched && quoteDetailsScreenForm.start_date.$error)\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div></div><div \nlayout=\"column\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"start start\" class=\"head-name\" \nng-class=\"{\'mt-15\' : $ctrl.validationObj.showDateNote}\"><p class=\"mt-0 mb-0\" \nng-class=\"{\'mb-4\' : $ctrl.validationObj.showDateNote}\">Expiry Date</p><div><date-picker md-input-id=\"\'expiry_date\'\" \nis-validate=\"($ctrl.validationObj.expiryDateValidation|| (quoteDetailsScreenForm.expiry_date.$touched && quoteDetailsScreenForm.expiry_date.$error.valid))\" \nis-editable=\"true\" is-disabled=\"false\" input-required=\"false\" input-name=\"\'expiry_date\'\" \ndate-placeholder=\"\'Expiry date\'\" date-format=\"true\" full-border=\"false\" min-date-value=\"$ctrl.quoteDetails.start_date\" \nmax-date-value=\"$ctrl.expiryMaxDate\" model-value=\"$ctrl.quoteDetails.expiry_date\" \ncallback=\"$ctrl.quoteDetails.expiry_date=value;$ctrl.validateExpirydate($ctrl.quoteDetails.expiry_date);$ctrl.validationObj.expiryDateValidation=false\">\n</date-picker></div><div ng-if=\"$ctrl.validationObj.expiryDateValidation\" class=\"validation-error-text\">\nSelect Expiry Date</div><div ng-if=\"$ctrl.validationObj.showDateNote\" class=\"font-size-11 fg-333333 Font-Regular pt-5\">\n<md-icon md-font-icon=\"icon-alert\" class=\"orange-400-fg mr-5 s12\"></md-icon>Exceeds expiry date of rates</div></div>\n<div \nng-messages=\"(!$ctrl.validationObj.expiryDateValidation && !$ctrl.validationObj.showDateNote && quoteDetailsScreenForm.expiry_date.$touched && quoteDetailsScreenForm.expiry_date.$error)\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div><div \nlayout=\"column\" flex=\"20\" flex-xs=\"100\" class=\"head-name inco_term\"><span class=\"mb-6\" \nng-class=\"{\'pt-20\':$ctrl.incotermsWarning && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH}\">Incoterms</span>\n<incoterm-select incoterm=\"$ctrl.quoteDetails.incoterms\" impo-expo=\"$ctrl.quoteDetails.impo_expo\" full-border=\"false\" \nis-required=\"true\" select-panel-width=\"\'222\'\" \ncallback=\"$ctrl.validationObj.incotermsError = false;$ctrl.incotermsWarning = true\"></incoterm-select><div \nng-if=\"$ctrl.validationObj.incotermsError\" class=\"validation-error-text\"><div>Incoterms is required.</div></div><div \nclass=\"inco-note-text\" ng-if=\"$ctrl.incotermsWarning && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH\"><div>\nThe charges will not modify automatically according to the selected incoterms. Please check and modify.</div></div>\n</div><div layout=\"column\" flex=\"20\" flex-xs=\"100\" class=\"head-name\" ng-if=\"$ctrl.isCommodity\"><span class=\"mb-6\">\nCommodity</span><md-input-container md-no-float class=\"mv-0 commodity_input\"><commodity-chips is-valid=\"false\" \nmd-input-id=\"\'commodity_id_web\'\" commodity-array=\"$ctrl.commodityValue\" category=\"\'QuoteGenerate\'\"></commodity-chips>\n</md-input-container></div><div layout=\"column\" flex=\"20\" flex-xs=\"100\" class=\"head-name language\"><div \nng-if=\"$root.domainData.domain_info.ENABLE_MULTILINGUAL_OPTION_FOR_QUOTE_PDF\"><span class=\"mb-6\">Language</span>\n<md-select name=\"type\" class=\"m-0 h-30 ph-5\" \nng-change=\"$ctrl.trackEvent(\'language\',$ctrl.quoteDetails.pdf_preferred_language);\" \nng-model=\"$ctrl.quoteDetails.pdf_preferred_language\"><md-option \nng-repeat=\"(language_key , language_value) in $ctrl.quote_pdf_languages\" ng-selected=\"language_key == \'en\'\" \nvalue=\"{{language_key}}\">{{language_value}}</md-option></md-select></div></div></div><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex=\"100\"><div layout=\"row\" flex=\"100\"><div flex=\"50\" class=\"font-weight-600 head-name pb-8\">\nTerms & Conditions</div></div><div class=\"quote-editor\"><ng-ckeditor ng-model=\"$ctrl.quoteDetails.terms\" \nid=\"termsConditions\" ng-config=\"$ctrl.termsConditionCkEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" \nlayout-xs=\"column\" class=\"mt-25 checkbox_div\"><div layout=\"row\" layout=\"column\" flex=\"100\" class=\"gap-40\" \nflex-xs=\"100\" layout-wrap><div class=\"font-weight-600 head-name\" ng-if=\"$ctrl.search_param.mode != \'SEA-LCL\'\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"font-size-14 pv-5 mt-12\"><md-checkbox md-no-ink \nng-model=\"$ctrl.quoteDetails.print_schedule\" class=\"ph-5 mv-5\"><span class=\"ml-10\">Print schedule on PDF</span>\n</md-checkbox></div></div><div class=\"font-weight-600 head-name\" \nng-if=\"$ctrl.search_param.mode === \'SEA-FCL\' && $ctrl.search_param.enable_co2e\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-size-14 pv-5 mt-12\"><md-checkbox md-no-ink ng-model=\"$ctrl.quoteDetails.co2e\" \nng-click=\"$ctrl.trackEvent(\'GQ-QuoteDetails-PrintCo2\')\" class=\"ph-5 mv-5\"><span class=\"ml-10\">\nPrint co2 emissions in PDF</span></md-checkbox></div></div><div class=\"font-weight-600 head-name\" \nng-if=\"$ctrl.enable_zero_sell_rates_on_pdf_checkbox\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-size-14 pv-5 mt-12\"><md-checkbox md-no-ink ng-model=\"$ctrl.quoteDetails.show_zero_sell_rates\" \nng-disabled=\"$ctrl.disable_zero_sell_rates_on_pdf_checkbox\" \nng-click=\"$ctrl.trackEvent(\'GQ-QuoteDetails-Selectedcharges\')\" class=\"ph-5 mv-5\">Print charges with “Zero” in PDF\n</md-checkbox></div></div><div class=\"font-weight-600 head-name\" ng-if=\"$ctrl.linerMaskCheckBox\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-size-14 pv-5 mt-12\"><md-checkbox md-no-ink \nng-model=\"$ctrl.quoteDetails.carrier_mask_for_shipper\" ng-change=\"$ctrl.trackEvent(\'GQ-Carrier-Masking-In-Pdf\')\" \nclass=\"ph-5 mv-5\"><span class=\"ml-10\">Hide Carrier name in Quote PDF</span></md-checkbox></div></div><div \nclass=\"head-name\"><div layout=\"row\" layout-align=\"center center\" class=\"font-size-14 pv-2\"><span \nclass=\"pr-15 font-weight-600\">Customs : </span><span class=\"pr-20 toggle-text\">No</span><md-switch md-no-ink \nng-model=\"$ctrl.quoteDetails.customs\" aria-label=\"Switch 1\" class=\"mv-5\"></md-switch><span class=\"pl-20 toggle-text\">\nYes</span></div></div><div layout=\"row\" layout-align=\"start center\" class=\"font-size-14 pv-2 head-name\" \nng-if=\"$root.domainData.domain_info.ALL_IN_QUOTE_SETTING_FWD_ENABLED && $ctrl.allInQuoteOptions && $ctrl.allInQuoteOptions != {}\">\n<span class=\"pr-15 font-weight-600\">Quote type :</span><md-select name=\"type\" class=\"m-0 h-30 ph-5 w-185\" \nng-change=\"$ctrl.fnChangeQuoteType()\" ng-model=\"$ctrl.quoteDetails.all_in_quote_setting\"><md-option \nng-repeat=\"(all_in_key , all_in_value) in $ctrl.allInQuoteOptions\" value=\"{{all_in_key}}\">{{all_in_value}}</md-option>\n</md-select></div></div></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\" class=\"mt-25\" ng-hide=\"true\"><div \nlayout=\"row\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nclass=\"font-weight-600 head-name\">Perishable<div layout=\"row\" layout-align=\"start center\" flex=\"50\" \nclass=\"font-size-14 pv-5 mt-12\">NO<md-switch md-no-ink ng-model=\"$ctrl.quoteDetails.perishable\" ng-change=\"\" \naria-label=\"Switch 1\" class=\"ph-5 mv-5\">YES</md-switch></div></div></div><div layout=\"row\" layout=\"column\" flex=\"50\" \nflex-xs=\"100\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"font-weight-600 head-name inco_term\">Hazardous<div \nlayout=\"row\" layout-align=\"start center\" flex=\"50\" class=\"font-size-14 pv-5 mt-12\">NO<md-switch md-no-ink \nng-model=\"$ctrl.quoteDetails.hazardous\" ng-change=\"\" aria-label=\"Switch 1\" class=\"ph-5 mv-5\">YES</md-switch></div>\n</div></div></div></div><div layout=\"row\" layout-align=\"end end\" class=\"sticky-bottom p-10\"><div \nlayout-align=\"end end\" class=\"h-55\" layout-wrap><md-button md-no-ink class=\"md-primary-btn m-10\" title=\"Cancel\" \nng-click=\"$ctrl.cancelDialog()\">Cancel</md-button><md-button md-no-ink type=\"submit\" class=\"md-accent-btn m-10\" \nng-disabled=\"quoteDetailsScreenForm.$invalid || (quoteDetailsScreenForm.$pristine && $ctrl.shareQuoteBtn) || $ctrl.shareQuoteBtn\" \ntitle=\"NEXT\">Next</md-button></div></div></form></div><div layout=\"column\" class=\"quoteDetails\" flex=\"100\" \nng-show=\"$ctrl.showScreen == 2\"><form name=\"generatequoteForm\" novalidate \nng-submit=\"$ctrl.fnCustomerDetailsSave(generatequoteForm)\"><div layout=\"row\" class=\"input_div\" flex=\"100\" \nlayout-xs=\"column\" layout-wrap><div flex=\"50\" flex-xs=\"100\" ng-if=\"$ctrl.util.solution_type === \'WLS\'\" class=\"pr-40\">\n<md-input-container class=\"input_text ml-20 mt-5 sales_person_input\" md-no-float><span class=\"head-name\"><p \nclass=\"mt-0 mb-0\">Sales Person</p></span><md-select ng-model=\"$ctrl.salesPerson\" name=\"searchSalesPerson\" \nplaceholder=\"Select Assigned Sales Person\" md-on-close=\"searchSalesPerson = \'\';$ctrl.getSalesPersonList(\'\')\" \nmd-no-asterisk=\"true\" class=\"mt-4\" ng-if=\"!$ctrl.util.isShipper && (!$ctrl.sales_user || $ctrl.is_duplicate_quote)\" \nng-change=\"$ctrl.wlsGetCustomerList($ctrl.salesPerson.id)\" \nng-class=\"{\'validation-bottom\':$ctrl.validationObj.salesValidation}\" \nng-keyup=\"$ctrl.validationObj.salesValidation=false\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchSalesPerson\" ng-model-options=\"{debounce: 500}\" \nng-change=\"$ctrl.getSalesPersonList(searchSalesPerson)\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Search Sales Person\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.isSalesApiLoading\"><md-progress-circular md-diameter=\"25\">\n</md-progress-circular></div><md-optgroup><md-option ng-value=\"salesPerson\" \nng-repeat=\"salesPerson in $ctrl.salesPersonList\">{{ salesPerson.user_first_name }} {{ salesPerson.user_last_name }}\n</md-option></md-optgroup><div layout=\"row\" layout-align=\"center center\" \nng-if=\"!$ctrl.salesPersonList.length && !$ctrl.isSalesApiLoading\" class=\"font-size-12 pv-10\">No results found</div>\n</md-select><div class=\"pt-10\" ng-if=\"$ctrl.sales_user && !$ctrl.is_duplicate_quote\">\n{{ $ctrl.salesPerson.user_first_name }} {{ $ctrl.salesPerson.user_last_name }}</div><div \nng-if=\"$ctrl.validationObj.salesValidation\" class=\"validation-error-text\">Select Sales Person.</div>\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"pr-20\" ng-if=\"$ctrl.util.solution_type === \'WLS\'\">\n<md-input-container md-no-float class=\"input_text pl-20 mt-5\"><span class=\"head-name\"><p class=\"mt-0 mb-0\">Company</p>\n</span><md-autocomplete ng-model-options=\"{debounce : 500}\" ng-if=\"!$ctrl.selectListShow\" md-input-name=\"companyName\" \nplaceholder=\"Company Name\" md-selected-item=\"selectedCompany\" md-search-text=\"$ctrl.company.company_name\" \nmd-selected-item-change=\"$ctrl.selectedToChange(selectedCompany,\'company\')\" \nmd-search-text-change=\"$ctrl.searchTextChange(selectedCompany,\'company\')\" \nmd-items=\"item in $ctrl.getShipperCompany($ctrl.company.company_name)\" md-item-text=\"item.company_name\" \nmd-min-length=\"3\" md-select-on-match=\"true\" md-clear-button=\"false\" md-no-cache=\"true\" md-delay=\"300\" \nmd-menu-class=\"autocomplete-custom-template-search\" ng-required=\"false\" \nng-class=\"{\'validation-bottom\':$ctrl.validationObj.companyValidation}\" \nng-keyup=\"$ctrl.validationObj.companyValidation=false\" md-match-case-insensitive><md-item-template><div layout=\"row\" \nlayout-align=\"space-between\" class=\"p-10 white-bg\"><span class=\"black-fg font-size-14\" \nmd-highlight-text=\"$ctrl.company.company_name\" md-highlight-flags=\"^i\">{{ item.company_name }}</span></div>\n</md-item-template></md-autocomplete><div shimmer-effect-full width=\"97%\" height=\"20px\" class=\"mt-20\" \nng-if=\"$ctrl.selectListShow\"></div><div ng-if=\"$ctrl.validationObj.companyValidation\" \nclass=\"mt-3 validation-error-text\">Enter Company Name</div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"pr-35\"><md-input-container md-no-float class=\"input_text ml-20 mt-5\"><span class=\"head-name\"><p \nclass=\"mt-0 mb-0\">Customer Email</p></span><md-autocomplete ng-model-options=\"{debounce : 500}\" \nng-if=\"!$ctrl.selectListShow\" class=\"mb-3\" md-input-name=\"EmailAddress\" \nclass=\"auto-complete-style port-autocomplete port-min-width mobile_input\" md-selected-item=\"selectedEmail\" \nmd-search-text=\"$ctrl.user.email\" md-search-text-change=\"$ctrl.searchTextChange(selectedCompany,\'email\')\" \nmd-selected-item-change=\"$ctrl.selectedToChange(selectedEmail);$ctrl.validationObj.emailValidation=false;$ctrl.validationObj.emailPatternValidation=false;$ctrl.validationObj.firstNameValidation=false;$ctrl.validationObj.lastNameValidation=false;$ctrl.validationObj.companyValidation=false\" \nmd-items=\"item in $ctrl.filterStringList($ctrl.user.email,generatequoteForm)\" md-item-text=\"item.email\" \nmd-min-length=\"$ctrl.cust_min_length\" placeholder=\"Search by Customer Name/Email Id/Company\" md-clear-button=\"false\" \nmd-menu-class=\"autocomplete-custom-template-search\" md-no-cache=\"true\" md-delay=\"300\" \nng-class=\"{\'validation-bottom\':($ctrl.validationObj.emailValidation|| $ctrl.validationObj.emailPatternValidation)}\" \nng-keyup=\"$ctrl.validationObj.emailValidation=false;$ctrl.validationObj.emailPatternValidation=false;$ctrl.validationObj.firstNameValidation=false;$ctrl.validationObj.lastNameValidation=false;$ctrl.validationObj.companyValidation=false\">\n<md-item-template><div class=\"item-metadata\"><div layout=\"row\" layout-align=\"space-between\" class=\"p-10 white-bg\"><div \nlayout=\"column\" style=\"pointer-events: none\"><div class=\"text-truncate\"><span class=\"capitalize-first-letter\" \ncompile-html=\"(item.user_first_name + \' \' + item.user_last_name)  !== \'\' ? $ctrl.util.searchHighlight(item.user_first_name + \' \' + item.user_last_name,$ctrl.user.email ) : \'\' \">\n</span></div><div class=\"text-truncate mailIdStyle\"><span \ncompile-html=\"item.email !== \'\' ? $ctrl.util.searchHighlight(item.email,$ctrl.user.email ) : \'\' \"></span>\n &nbsp; {{item.user_company_name ?\' | \':\'\'}} &nbsp; <span \ncompile-html=\"item.user_company_name !== \'\' ? $ctrl.util.searchHighlight(item.user_company_name,$ctrl.user.email ) : \'\' \">\n</span> <span>&nbsp; {{item.company.external_reference_id ?\' | \':\'\'}} &nbsp;</span> <span class=\"text-truncate\" \ncompile-html=\"item.company.external_reference_id ? $ctrl.util.searchHighlight(item.company.external_reference_id,$ctrl.user.email ) : \'\' \">\n</span></div></div></div></div></md-item-template></md-autocomplete><div shimmer-effect-full width=\"97%\" height=\"20px\" \nclass=\"mt-20\" ng-if=\"$ctrl.selectListShow\"></div><div \nng-if=\"($ctrl.validationObj.emailValidation || $ctrl.validationObj.emailPatternValidation )\" \nclass=\"validation-error-text\">Enter a valid Email Id</div></md-input-container></div><div layout=\"column\" \nlayout-xs=\"column\" flex=\"50\" flex-xs=\"100\" class=\"mt-7\"><span class=\"name_input head-name\"><p class=\"mt-0 mb-0\">Name\n</p></span><div layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-xs=\"100\" class=\"pr-25\"><div flex=\"50\" flex-xs=\"100\">\n<md-input-container md-no-float class=\"input_text pl-20\"><input ng-if=\"!$ctrl.selectListShow\" name=\"FirstName\" \nplaceholder=\"First Name\" class=\"mb-3\" ng-model=\"$ctrl.user.user_first_name\" \nng-change=\"$ctrl.trackEvent(\'GQ-CustomerDetails-Firstname\')\" \nng-class=\"{\'validation-bottom\':$ctrl.validationObj.firstNameValidation}\" \nng-keyup=\"$ctrl.validationObj.firstNameValidation=false\"><div shimmer-effect-full width=\"97%\" height=\"20px\" \nclass=\"mt-20\" ng-if=\"$ctrl.selectListShow\"></div><div ng-if=\" $ctrl.validationObj.firstNameValidation\" \nclass=\"validation-error-text\"><span>Enter First Name</span></div></md-input-container></div><div flex=\"50\" \nflex-xs=\"100\"><md-input-container md-no-float class=\"input_text pl-20\"><input ng-if=\"!$ctrl.selectListShow\" \nname=\"LastName\" placeholder=\"Last Name\" class=\"mb-3\" ng-model=\"$ctrl.user.user_last_name\" \nng-change=\"$ctrl.trackEvent(\'GQ-CustomerDetails-Lastname\')\" \nng-class=\"{\'validation-bottom\':$ctrl.validationObj.lastNameValidation}\" \nng-keyup=\"$ctrl.validationObj.lastNameValidation=false\"><div shimmer-effect-full width=\"97%\" height=\"20px\" \nclass=\"mt-20\" ng-if=\"$ctrl.selectListShow\"></div><div ng-if=\" $ctrl.validationObj.lastNameValidation\" \nclass=\"validation-error-text\"><span>Enter last Name</span></div></md-input-container></div></div></div><div flex=\"50\" \nflex-xs=\"100\"><md-input-container md-no-float class=\"input_text pl-20 pr-20\"><span class=\"head-name\"><p \nclass=\"mt-0 mb-0\">Contact</p></span><div ng-if=\"!$ctrl.selectListShow\"><input id=\"customer_phone_number\" \nclass=\"tel-input\" ng-if=\"!$ctrl.selectListShow\" type=\"tel\" ng-model=\"$ctrl.user.user_mobile\" \nplaceholder=\"Contact Number\" name=\"PhoneNumber\" ng-change=\"$ctrl.trackEvent(\'GQ-CustomerDetails-ContactNumber\')\" \nng-keyup=\"$ctrl.phoneValidation=false;\" ng-maxlength=\"40\"></div><div shimmer-effect-full width=\"97%\" height=\"20px\" \nclass=\"mt-20\" ng-if=\"$ctrl.selectListShow\"></div><div ng-messages=\"generatequoteForm.PhoneNumber.$error\" \nclass=\"intl-err\"><div ng-message=\"maxlength\">Phone number must not exceed 40 characters</div></div>\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"pr-20\" ng-if=\"$ctrl.util.solution_type !== \'WLS\'\">\n<md-input-container md-no-float class=\"input_text pl-20 pr-20 mt-5\"><span class=\"head-name\"><p class=\"mt-0 mb-0\">\nCompany</p></span><md-autocomplete ng-model-options=\"{debounce : 500}\" ng-if=\"!$ctrl.selectListShow\" \nmd-input-name=\"companyName\" md-selected-item=\"selectedCompany\" md-search-text=\"$ctrl.company.company_name\" \nmd-selected-item-change=\"$ctrl.changeCompany(selectedCompany)\" \nmd-items=\"item in $ctrl.getShipperCompany($ctrl.company.company_name)\" md-item-text=\"item.company_name\" \nmd-min-length=\"3\" placeholder=\"Company Name\" md-select-on-match=\"true\" md-clear-button=\"false\" md-no-cache=\"false\" \nmd-delay=\"300\" md-menu-class=\"autocomplete-custom-template\" ng-keyup=\"$ctrl.validationObj.companyValidation=false\" \nng-class=\"{\'validation-bottom\':$ctrl.validationObj.companyValidation}\"><md-item-template><span \nmd-highlight-text=\"$ctrl.company.company_name\" md-highlight-flags=\"^i\">{{ item.company_name }}</span> <span>\n&nbsp; {{item.external_reference_id ?\' | \':\'\'}} &nbsp;</span> <span>{{item.external_reference_id }}</span>\n</md-item-template></md-autocomplete><div shimmer-effect-full width=\"97%\" height=\"20px\" class=\"mt-20\" \nng-if=\"$ctrl.selectListShow\"></div><div ng-if=\"$ctrl.validationObj.companyValidation\" \nclass=\"mt-3 validation-error-text\">Enter Company Name</div></md-input-container></div><div layout=\"column\" \nlayout-xs=\"column\" flex=\"50\" flex-xs=\"100\" class=\"pr-16\"><md-input-container md-no-float class=\"input_text pl-20\"><span\n class=\"head-name\">Customer Address </span><input ng-if=\"!$ctrl.selectListShow\" name=\"CustomerAddress\" \nplaceholder=\"Customer Address\" ng-model=\"$ctrl.company.company_address\" \nng-change=\"$ctrl.trackEvent(\'GQ-CustomerDetails-CustomerAddress\')\"><div shimmer-effect-full width=\"97%\" height=\"20px\" \nclass=\"mt-20\" ng-if=\"$ctrl.selectListShow\"></div></md-input-container></div><div flex=\"100\" class=\"pr-20\">\n<md-input-container md-no-float class=\"input_text pl-20 pr-20 mt-5\"><span class=\"head-name\"><p class=\"mt-0 mb-8\">\nCC Emails</p></span><md-chips ng-if=\"!$ctrl.selectListShow\" ng-model=\"$ctrl.quoteDetails.cc_emails\" name=\"cc_mails\" \nplaceholder=\"Write email and Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"$ctrl.fnMultiEmailValidation($ctrl.quoteDetails.cc_emails, $chip)\" md-add-on-blur=\"true\"><md-chip-template>\n<strong>{{$chip}}</strong></md-chip-template></md-chips><div shimmer-effect-full width=\"97%\" height=\"20px\" \nclass=\"mt-20\" ng-if=\"$ctrl.selectListShow\"></div><div class=\"errors\" ng-messages=\"generatequoteForm.cc_mails.$error\" \nrole=\"alert\"><div class=\"quote-invalidErrorMsg pt-8\" hide>Invalid email address!! We removed it.</div><div \nclass=\"quote-duplicateErrorMsg pt-8\" hide>Duplicate email address!! We removed it.</div></div></md-input-container>\n</div><div flex=\"100\" class=\"pl-20 pr-20 mt-20 fg-4a4a4a Font-Bold notification-check\"><md-checkbox md-no-ink \naria-label=\"Checkbox No Ink\" ng-model=\"$ctrl.quoteDetails.send_mail\" \nng-change=\"$ctrl.trackEvent(\'GQ-CustomerDetails-SendNotification\')\" class=\"md-primary\">Send Notification to Customer\n</md-checkbox></div></div><div class=\"sticky-bottom\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"100\" layout \nlayout-align=\"end center\" class=\"m-10 h-55\"><md-button md-no-ink class=\"md-primary-btn with-icon m-10\" \ntitle=\"Preview Quote\" ng-click=\"$ctrl.previewQuotes()\" ng-disabled=\"$ctrl.PdfQuoteBtn || $ctrl.shareQuoteBtn\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16\"></md-icon>Preview Quote</md-button><md-button md-no-ink type=\"submit\" \nclass=\"md-accent-btn m-10\" ng-disabled=\"$ctrl.shareQuoteBtn\" title=\"Generate Quotation\">Generate Quotation</md-button>\n</div></div></form></div><div layout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"mt-25\" \nng-show=\"$ctrl.showScreen == 3\"><div layout=\"row\" flex=\"100\" class=\"w-50 h-50\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"w-50 h-50 tick_success\"></md-icon></div><div layout=\"column\" \nflex=\"100\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" class=\"mt-20 mb-10 send-msg\">\n{{ $ctrl.shareQuoteResponse.message }}</div><div layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"mb-15 mt-8 inquiry-id-container\" ng-if=\"!$ctrl.shareQuoteResponse.inquiry_id\">Quote ID : <span \nclass=\"inquiry-id ml-5\" ng-click=\"$ctrl.cancelDialog(\'quote\')\">{{ $ctrl.shareQuoteResponse.quote_id }}</span></div><div\n layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"mb-15 mt-8 inquiry-id-container\" \nng-if=\"$ctrl.shareQuoteResponse.inquiry_id\">Inquiry ID : <span class=\"inquiry-id pl-5\" \nng-click=\"$ctrl.cancelDialog(\'inquiry\')\">{{ $ctrl.shareQuoteResponse.inquiry_number }}</span></div><div \nlayout=\"column\" flex=\"100\" layout-align=\"center center\" class=\"Font-Bold font-size-12 mb-15\" \nng-show=\"!$ctrl.quoteDetails.send_mail\"><div class=\"successNote\">\n{{ ($ctrl.isPdfFailed || $ctrl.isPdfErrOccured) ? \'Note: Email to the customer will be shared after PDF generation\' : \'Note: Email not sent to customer\'}}\n</div><div ng-if=\"$ctrl.isPdfFailed || $ctrl.isPdfErrOccured\" class=\"grey-fg Font-Regular mt-8\">\nYou can try again in Inquiry or quote details</div></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"quote-footer p-10\" layout-wrap><div layout=\"column\" \nlayout-align=\"center start\" flex-xs=\"100\" class=\"mt-8 pl-10\"><div ng-if=\"!$ctrl.isPdfFailed\" \nng-bind=\"!$ctrl.isPdfGenerated ? \'We are generating a downloadable quotation(PDF Format).\':\'Downloadable quotation(PDF Format) is ready\'\" \nclass=\"mb-5\"></div><div ng-if=\"$ctrl.isPdfFailed\" class=\"red-300-fg font-size-12 mb-5\">\nAn error has occurred while creating the PDF, please <span class=\"text-underline md-link-fg Font-Bold pointer\" \nng-click=\"$ctrl.fnGetPdfLink();$ctrl.trackEvent(\'GQ-QuoteID-DownloadPDF-TryAgain\')\"><u>try again</u></span></div><div \nng-if=\"$ctrl.isPdfErrOccured\" class=\"red-300-fg font-size-12 mb-5\">\nOur system is down, we aren’t able to generate the PDF. Please try again later.</div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!$ctrl.isPdfFailed && !$ctrl.isPdfErrOccured\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-5\"><progress max=\"100\" value=\"{{$ctrl.downloadProgressValue*20}}\"></progress>\n</div><div ng-if=\"!$ctrl.isPdfFailed && !$ctrl.isPdfErrOccured\" class=\"text-italic font-size-11 black-fg\">\n{{$ctrl.isPdfGenerated || $ctrl.downloadProgressValue >= 5 ? \'100\' : $ctrl.downloadProgressValue*20}} %</div></div>\n</div><div layout=\"row\" layout-align=\"end center\" class=\"m-10 h-35\" flex-xs=\"100\"><md-button md-no-ink \nclass=\"md-primary-btn with-icon mr-10\" title=\"View Quote\" ng-click=\"$ctrl.cancelDialog(\'quote\')\" \nng-if=\"$ctrl.shareQuoteResponse.quote_id\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon>View Quote</md-button>\n<md-button md-no-ink class=\"md-accent-btn with-icon ml-10\" title=\"Download\" \nng-disabled=\"!$ctrl.isPdfGenerated || $ctrl.isPdfFailed\" ng-click=\"$ctrl.downloadPdf()\"><span><md-icon \nmd-font-icon=\"icon-download\" class=\"s16\"></md-icon></span>Download PDF</md-button></div></div></div></div></div>");
$templateCache.put("app/main/component/status-change-panel/status-change-panel.html","<div class=\"status-change-panel\"><div ng-repeat=\"statusObj in ctrl.quoteInfo.available_status\"><span \nclass=\"status-ui text-truncate\" title=\"{{shipment.current_status.status}}\" \nng-style=\"ctrl.util.fnSetStatusColor(ctrl.util.colorCodeObj[statusObj.status])\" \nng-click=\"ctrl.fnChangeStatus(statusObj)\">{{statusObj.status}}</span></div></div>");
$templateCache.put("app/main/component/sync-button/sync-button.html","<div ng-if=\"$ctrl.integrationList.length\"><md-menu-bar id=\"sync-button\" class=\"p-0\"><md-menu><md-button md-no-ink \naria-label=\"Open demo menu\" class=\"md-primary-btn with-icon mb-0\" layout=\"row\" layout-align=\"center center\" \nng-click=\"$ctrl.openSendToMenu($mdMenu, $event)\"><md-icon class=\"icon-share-16 m-0\" \nmd-svg-src=\"assets/icons/custom/ios_share_black_24dp.svg\" ng-if=\"!$ctrl.showloader\"></md-icon><span \nclass=\"pl-2 pr-2 pg-color\" ng-if=\"!$ctrl.showloader\">Send To</span><md-icon class=\"s18 m-0\" \nmd-font-icon=\"icon-chevron-down\" ng-if=\"!$ctrl.showloader\"></md-icon><div ng-if=\"$ctrl.showloader\"><md-icon \nmd-font-icon=\"icon-refresh\" class=\"fa-spins\"></md-icon><span>Loading...</span></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"create-menu-item\" ng-class=\"{\'bb\': !$last}\" \nng-repeat=\"company in $ctrl.integrationList track by $index\" \nng-if=\"(company.sub_menus.booking  && company.sub_menus.booking.length) || (company.sub_menus.shipment  && company.sub_menus.shipment.length)\">\n<md-menu class=\"create-content\"><md-button ng-click=\"$mdMenu.open()\" class=\"h-45\" ng-disabled=\"company.isDisabled\"><div\n layout=\"row\"><div flex=\"10\" class=\"pt-5\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"grey-fg s14 ml-2\" \nng-if=\"!company.status_code\"></md-icon><md-icon md-font-icon=\"icon-no\" class=\"red-fg s20\" \nng-if=\"company.status_code==401\"></md-icon><md-icon md-font-icon=\"icon-alert\" class=\"orange-fg s20\" \nng-if=\"company.status_code==422\"></md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"fg-7CB765 s14\" \nng-if=\"company.status_code==200\"></md-icon></div><div layout=\"column\" flex=\"90\" class=\"ml-5 h-60\"><span flex=\"30\" \nclass=\"font-size-12 fg-333333\" ng-bind=\"company.name\"></span><div flex class=\"font-size-9 fg-707070 text-italic\">\n{{company.status_code==200 ? \'Last synced on \' : company.message}}{{company.sync_time ? (company.sync_time | date : \'dd MMM yyyy\') :\"\"}}\n</div></div><div ng-if=\"company.sub_menus.booking.length || company.sub_menus.shipment.length\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"fg-333333\"></md-icon></div></div></md-button><md-menu-content width=\"3\" \nng-class=\"{\'hide\' : company.isDisabled}\"><div ng-repeat=\"submenus in company.sub_menus.booking\"><md-menu-item \nclass=\"create-menu-item bb bg-transparent\" ng-if=\"submenus.displayName\"><md-button ng-disabled=\"submenus.isDisabled\" \nng-click=\"$ctrl.fnCargowiseSendto(submenus,$index,$event,company.erp_code,\'booking\',company.is_charge_mapping_required)\" \nclass=\"h-45\"><span>{{submenus.displayName}}</span></md-button></md-menu-item></div><div \nng-repeat=\"submenus in company.sub_menus.shipment\"><md-menu-item class=\"create-menu-item bg-transparent\" \nng-class=\"{\'bb\': !$last}\" ng-if=\"submenus.displayName\"><md-button ng-disabled=\"submenus.isDisabled\" \nng-click=\"$ctrl.fnCargowiseSendto(submenus,$index,$event,company.erp_code,\'shipment\',company.is_charge_mapping_required\n              )\" \nclass=\"h-45\"><span>{{submenus.displayName}}</span></md-button></md-menu-item></div></md-menu-content></md-menu>\n</md-menu-item><md-menu-item class=\"create-menu-item\" ng-repeat=\"company in $ctrl.integrationList track by $index\" \nng-if=\"!((company.sub_menus.booking  && company.sub_menus.booking.length) || (company.sub_menus.shipment  && company.sub_menus.shipment.length) )\">\n<md-button ng-click=\"$ctrl.fnShipmentSendTo(company,$index,$event)\"><div layout=\"row\"><div flex=\"10\" class=\"pt-5\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"grey-fg s14 ml-2\" ng-if=\"!company.status_code\"></md-icon>\n<md-icon md-font-icon=\"icon-no\" class=\"red-fg s20\" ng-if=\"company.status_code==401\"></md-icon><md-icon \nmd-font-icon=\"icon-alert\" class=\"orange-fg s20\" ng-if=\"company.status_code==422\"></md-icon><md-icon \nmd-font-icon=\"icon-rotate-3d\" class=\"green-fg s20\" ng-if=\"company.status_code==200\"></md-icon></div><div \nlayout=\"column\" flex=\"90\" class=\"ml-5 h-60\"><span flex=\"30\" class=\"font-size-12 fg-333333\" ng-bind=\"company.name\">\n</span> <span flex class=\"font-size-9 fg-707070 text-italic\">\n{{company.status_code==200 ? \'Last synced\' : company.message}} <span ng-if=\"company.sync_time\">\n{{ company.sync_time | date : \'dd MMM yyyy\'}}</span></span></div></div></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div>");
$templateCache.put("app/main/component/warning-panel/warning-panel.html","<div id=\"charge-mapping-confirmation\"><div layout=\"column\" layout-align=\"center center\" \nclass=\"body pb-5 panel-body font-size-16 font-bold\">Any changes you have made will be lost, do you want to continue?\n</div><div class=\"footer-section\" layout=\"row\" layout-align=\"end end\"><md-button \nng-click=\"ctrl.fnConfirmationCancel(\'proceed\')\" md-no-ink class=\"md-primary-btn mr-10 font-Bold\">Yes, Proceed\n</md-button><md-button ng-click=\"ctrl.fnConfirmationCancel(\'\')\" md-no-ink class=\"md-accent-btn ml-10 font-Bold\">\nNo, Cancel</md-button></div></div>");
$templateCache.put("app/main/component/xeneta-rate-index/xeneta-rate-index.html","<div id=\"xeneta-rate-index\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"m-20 border border-radius-4\" \nlayout-wrap layout-padding><div class=\"w-200\"><span class=\"font-weight-600 font-size-13 form-title\">Origin </span><br>\n<md-input-container md-no-float class=\"panel-select-disabled mv-5 mh-0\" layout=\"row\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg h-35 ml-5\"></div><input \ntype=\"text\" ng-model=\"$ctrl.originPort\" title=\"{{$ctrl.originPort}}\" \nclass=\"panel-select-input text-truncate font-weight-400 border-none\" placeholder=\"Origin\" ng-disabled=\"true\">\n</md-input-container></div><div class=\"w-200\"><span class=\"font-weight-600 font-size-13 form-title\">Destination </span>\n<br><md-input-container md-no-float class=\"panel-select-disabled mv-5 mh-0\" layout=\"row\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg h-35 ml-5\"></div><input \ntype=\"text\" ng-model=\"$ctrl.destinationPort\" title=\"{{$ctrl.destinationPort}}\" \nclass=\"panel-select-input text-truncate font-weight-400 border-none\" placeholder=\"Destination\" ng-disabled=\"true\">\n</md-input-container></div><div class=\"w-200\"><span class=\"font-weight-600 font-size-13 form-title\">Market </span><br>\n<md-input-container md-no-float class=\"panel-select-disabled mv-5 mh-0\" layout=\"row\"><input type=\"text\" \nng-model=\"$ctrl.marketInput\" class=\"panel-select-input font-weight-400 border-none\" placeholder=\"Market\" \nng-disabled=\"true\"></md-input-container></div><div class=\"w-200\"><span class=\"font-weight-600 font-size-13 form-title\">\nEquipment Type </span><br><md-input-container md-no-float class=\"w-150 mv-5 mh-0 panel-select\"><md-select \nclass=\"mt-3 pr-4 multi-select-width\" ng-model=\"$ctrl.selectedEquipment\" placeholder=\"Select Equipment Type\" \nng-change=\"$ctrl.displayGraph=true;$ctrl.fnDrawChart()\" multiple=\"multiple\"><md-option \nng-repeat=\"item in $ctrl.equipmentList track by $index\" ng-value=\"item\" title=\"{{item}}\">{{item}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-wrap layout-align=\"end center\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s20 mh-5 info-icon\"></md-icon><div \nclass=\"font-size-14 font-regular grey-400-fg\">The chart shows data for 30 days within<br>\nthe scope of the selected parameters.</div></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nclass=\"m-20 border border border-radius-4\" layout-wrap layout-padding ng-hide=\"$ctrl.displayGraph\"><canvas \nid=\"dueAmountOverTimeChart\" width=\"400\" height=\"200\"></canvas></div><div layout=\"row\" layout-wrap \nlayout-align=\"end end\" class=\"mh-20 mv-5\"><span class=\"font-regular font-size-14\">Powered by <img \nsrc=\"assets/icons/custom/xeneta_logo-dark.svg\" lass=\"mb-10 mr-10 h-10\"></span></div></div>");
$templateCache.put("app/main/component/xeneta-view/xeneta-view.html","<div class=\"arrow-up\"></div><div id=\"xeneta-view-panel\" width=\"400\" height=\"200\"><div layout=\"row\" layout-wrap \nlayout-align=\"start\" class=\"mt-5 mb-10\"><span class=\"contract\">\n{{ ctrl.card.meta.type.includes(\'spot\') ? \'Short Contract - Port to Port - \' + ctrl.card.meta.xenetaRateAverage[\'containerType\'] : \'Long Contract - Port to Port - \' + ctrl.card.meta.xenetaRateAverage[\'containerType\'] }}\n</span></div><canvas id=\"xenetaLieChart\" width=\"400\" height=\"200\"></canvas><div layout=\"row\" layout-wrap \nlayout-align=\"end end\" class=\"mt-5\"><span class=\"powered_by\">Powered by <img \nsrc=\"assets/icons/custom/xeneta_logo-dark.svg\" lass=\"mb-10 mr-10 h-10\" width=\"60\"></span></div></div>");
$templateCache.put("app/main/create-shipment/dialogs/create-shipment-success.html","<md-dialog id=\"create-shipment-success\"><div layout=\"row\" layout-align=\"end end\"><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"column\" layout-align=\"center center\"><md-icon \nmd-svg-icon=\"assets/icons/custom/tick-large.svg\" class=\"w-100 h-100\"></md-icon><div \nclass=\"font-size-12 grey-fg pv-8 font-weight-600\">UNIQUE AIR SHIPMENT NO.</div><md-button md-no-ink \nclass=\"shipment_id mb-25\" ng-click=\"ctrl.parent.goToCreatedShipment(ctrl.parent.shipmentIdSuccess);\">\n{{ctrl.parent.shipmentIdSuccess}}</md-button></div><div class=\"grey-300-bg pv-15\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-14 grey-fg font-weight-600\">Shipment has been created successfully\n</div></div></md-dialog>");
$templateCache.put("app/main/create-shipment/fcl-create-shipment/fcl-create-shipment.html","<div id=\"fcl-create-shipment\"><iframe id=\"fcl-create-shipment-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/customRates/dialogs/confirm-switch.html","<md-dialog id=\"confirm-switch\"><div layout=\"row\" layout-padding class=\"border-bottom mh-15 mt-10 mb-0 pl-0\" flex=\"100\">\n<div class=\"font-size-16 font-weight-600 pl-10 pb-5\" flex=\"80\" flex-xs=\"90\" translate=\"CONFIRM_SWITCH\">CONFIRM SWITCH\n</div><div layout=\"row\" layout-align=\"end end\" flex=\"20\" flex-xs=\"10\"><md-icon md-font-icon=\"icon-close\" \nclass=\"mr-5 pointer\" ng-click=\"ctrl.parent.cancelDialog(); ctrl.parent.selectedTab = ctrl.parent.saveTabIndex;\">\n</md-icon></div></div><md-dialog-content><div class=\"font-size-16\" translate=\"SWITCH_CONFIRM_MESSAGE\"><center>\nAre you sure you want to switch tab? Be aware, if you press \"OK\" now, ALL your changes will be lost! Press OK to continue, or Cancel to stay on the current tab.\n</center></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"ctrl.parent.cancelDialog(); ctrl.parent.selectedTab = ctrl.parent.saveTabIndex;\" title=\"Cancel\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn\" type=\"submit\" ng-click=\"ctrl.parent.tabSwitchConfirmed()\" \ntitle=\"OK\">OK</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/customRates/dialogs/viewRates.html","<md-dialog id=\"view-rate\"><form name=\"viewRateForm\" ng-submit=\"ctrl.parent.saveRatesBtnForm()\"><md-toolbar \nclass=\"modal_title\"><div class=\"md-toolbar-tools border-bottom\"><span class=\"font-size-16 font-weight-600\">\n{{ctrl.parent.currentRateData.origin_port}} to {{ctrl.parent.currentRateData.destination_port}}</span> <span flex>\n</span><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"black-fg cursor\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"font-size-14\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"mb-10\"><div\n flex=\"50\" flex-xs=\"100\" class=\"display-input\" \nng-if=\"ctrl.parent.selectedRateLeg===\'MAIN FREIGHT\' || ctrl.parent.selectedRateLeg===\'ORIGIN CUSTOMS\'\"><span \nclass=\"font-weight-600\">Origin Port<sup class=\"red-fg\" ng-if=\"ctrl.parent.selectedRateLeg===\'ORIGIN CUSTOMS\'\">*</sup>\n</span><br><md-input-container md-no-float class=\"input_text\"><md-autocomplete \nng-required=\"ctrl.parent.selectedRateLeg===\'ORIGIN CUSTOMS\'\" md-input-name=\"fcl_origin_port\" \nmd-selected-item=\"ctrl.parent.currentRateData.origin_port_view\" md-search-text=\"ctrl.parent.fcl_originSearchText\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.fcl_originSearchText,\'SEA\')\" md-item-text=\"item.global_port_code\" \nmd-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" md-require-match=\"true\" placeholder=\"Select Origin Port\" \nmd-menu-class=\"autocomplete-custom-template\"><md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}\n</span></md-item-template><md-not-found>No ports matching \"{{ctrl.parent.fcl_originSearchText}}\" were found.\n</md-not-found><div ng-messages=\"fclSearchForm.fcl_origin_port.$error\"><div ng-message=\"required\">\nThis field is required</div></div></md-autocomplete></md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"\" \nng-if=\"ctrl.parent.selectedRateLeg===\'MAIN FREIGHT\' || ctrl.parent.selectedRateLeg===\'DESTINATION CUSTOMS\'\"><span \nclass=\"font-weight-600\">Destination Port<sup class=\"red-fg\" \nng-if=\"ctrl.parent.selectedRateLeg===\'DESTINATION CUSTOMS\'\">*</sup></span><br><md-input-container md-no-float \nclass=\"input_text\"><md-autocomplete ng-required=\"ctrl.parent.selectedRateLeg===\'DESTINATION CUSTOMS\'\" \nmd-input-name=\"fcl_destination_port\" md-selected-item=\"ctrl.parent.currentRateData.destination_port_view\" \nmd-search-text=\"ctrl.parent.fcl_destinationSearchText\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.fcl_destinationSearchText,\'SEA\')\" \nmd-item-text=\"item.global_port_code\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" md-require-match=\"true\" \nplaceholder=\"Select Destination Port\" md-menu-class=\"autocomplete-custom-template\"><md-item-template><span \nclass=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{ctrl.parent.fcl_destinationSearchText}}\" were found.</md-not-found><div \nng-messages=\"fclSearchForm.fcl_destination_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" \nflex-xs=\"100\" class=\"display-input\" ng-if=\"ctrl.parent.selectedTableMode === \'fcl\'\"><span class=\"font-weight-600\">\nEquipment Type<sup class=\"red-fg\">*</sup></span><br><md-input-container md-no-float class=\"input_text\" \nng-if=\"ctrl.parent.currentRateData.Type\"><md-select name=\"container\" ng-model=\"ctrl.parent.currentRateData.Type\" \nclass=\"\"><md-option ng-value=\"load\" ng-repeat=\"load in ctrl.parent.loadDropDown\">{{load}}</md-option></md-select><div \nng-messages=\"viewRateForm.container.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SELECT_CONTAINER_TYPE\">Please select Equipment Type.</span></div></div></md-input-container>\n<md-input-container md-no-float class=\"input_box mt-5 mv-0\" ng-if=\"ctrl.parent.currentRateData.load_type\"><md-select \nname=\"container\" ng-model=\"ctrl.parent.currentRateData.load_type\"><md-option ng-value=\"load\" \nng-repeat=\"load in ctrl.parent.loadDropDown\">{{load}}</md-option></md-select><div \nng-messages=\"viewRateForm.container.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SELECT_CONTAINER_TYPE\">Please select Equipment Type.</span></div></div></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" \nng-if=\"(ctrl.parent.selectedRateLeg===\'MAIN FREIGHT\' && ctrl.parent.selectedTableMode===\'fcl\')\"><span \nclass=\"font-weight-600\">Service Type</span><br><md-input-container md-no-float class=\"input_text\"><input \nname=\"service_type\" ng-model=\"ctrl.parent.currentRateData.service_type\" placeholder=\"Service Type\"><div \nng-messages=\"viewRateForm.service_type.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REQUIRED_SERVICE_TYPE\">Service type is required.</span></div></div></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" \nng-if=\"(ctrl.parent.selectedRateLeg===\'ORIGIN CUSTOMS\' && ctrl.parent.selectedTableMode===\'fcl\') || (ctrl.parent.selectedRateLeg===\'DESTINATION CUSTOMS\' && ctrl.parent.selectedTableMode===\'fcl\')\">\n<span class=\"font-weight-600\">CFS Stuffing</span><br><md-input-container md-no-float class=\"input_text\"><input \nname=\"cfs_stuffing\" ng-model=\"ctrl.parent.currentRateData.cfs_stuffing\" placeholder=\"CFS Stuffing\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"display-input\"><span class=\"font-weight-600\">Liner Name<sup class=\"red-fg\">*</sup></span><br><md-input-container\n md-no-float class=\"input_text\"><md-select name=\"liner\" ng-model=\"ctrl.parent.currentRateData.sub_vendor\" \nng-model-options=\"{trackBy: \'$value.id\'}\" class=\"multiselectBox\"><md-option ng-value=\"liner\" title=\"{{liner.name}}\" \nng-repeat=\"liner in ctrl.parent.subvendorList track by liner.id\">{{liner.name}}</md-option></md-select><div \nng-messages=\"viewRateForm.liner.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_LINER_NAME\">\nPlease Select Liner Name.</span></div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nng-if=\"ctrl.parent.selectedRateLeg===\'MAIN FREIGHT\'\"><span class=\"font-weight-600\">Via Port</span><br>\n<md-input-container md-no-float class=\"input_text\"><input name=\"via_port\" \nng-model=\"ctrl.parent.currentRateData.via_port\" placeholder=\"Via Port\"></md-input-container></div><div flex=\"50\" \nflex-xs=\"100\" \nng-if=\"ctrl.parent.selectedRateLeg===\'ORIGIN CUSTOMS\' || ctrl.parent.selectedRateLeg===\'DESTINATION CUSTOMS\'\"><span \nclass=\"font-weight-600\">Route Code</span><br><md-input-container md-no-float class=\"input_text\"><input \nname=\"route_code\" ng-model=\"ctrl.parent.currentRateData.route_code\" placeholder=\"Route Code\"></md-input-container>\n</div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" class=\"display-input\" \nng-if=\"(ctrl.parent.selectedRateLeg===\'MAIN FREIGHT\' && ctrl.parent.selectedTableMode===\'fcl\')\"><span \nclass=\"font-weight-600\" translate=\"TRANSIT_TIME\">Transit Time</span><br><md-input-container md-no-float \nclass=\"input_text\"><input name=\"transit_time\" ng-model=\"ctrl.parent.currentRateData.transit_time\" \nplaceholder=\"Transit Time\"></md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"display-input\" \nng-if=\"(ctrl.parent.selectedRateLeg===\'ORIGIN CUSTOMS\' && ctrl.parent.selectedTableMode===\'fcl\') || (ctrl.parent.selectedRateLeg===\'DESTINATION CUSTOMS\' && ctrl.parent.selectedTableMode===\'fcl\')\">\n<span class=\"font-weight-600\">Other Charges</span><br><md-input-container md-no-float class=\"input_text\"><input \nname=\"transit_time\" ng-model=\"ctrl.parent.currentRateData.other_charges\" placeholder=\"Transit Time\">\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"display-input\" \nng-if=\"(ctrl.parent.selectedRateLeg===\'MAIN FREIGHT\' && ctrl.parent.selectedTableMode===\'fcl\')\"><span \nclass=\"font-weight-600\" translate=\"Contract_ID\">Contract ID</span><br><md-input-container md-no-float \nclass=\"input_text\"><input name=\"contract\" ng-model=\"ctrl.parent.currentRateData.contract\" placeholder=\"Contract ID\">\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nng-if=\"(ctrl.parent.selectedRateLeg===\'ORIGIN CUSTOMS\' && ctrl.parent.selectedTableMode===\'fcl\') || (ctrl.parent.selectedRateLeg===\'DESTINATION CUSTOMS\' && ctrl.parent.selectedTableMode===\'fcl\')\">\n<span class=\"font-weight-600\">If Applicable Charges</span><br><md-input-container md-no-float class=\"input_text\"><input\n name=\"contract\" ng-model=\"ctrl.parent.currentRateData.If_applicable_charges\" placeholder=\"Contract ID\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"display-input\"><span class=\"font-weight-600\" translate=\"REMARKS\">Remarks</span><br><md-input-container \nmd-no-float class=\"input_text\"><input name=\"remarks\" ng-model=\"ctrl.parent.currentRateData.remarks\" \nplaceholder=\"Remarks\"></md-input-container></div><div flex=\"50\" flex-xs=\"100\"><span class=\"font-weight-600\" \ntranslate=\"INCLUSIONS\">Inclusions</span><br><md-input-container md-no-float class=\"input_text\"><input \nname=\"inclusions\" ng-model=\"ctrl.parent.currentRateData.inclusions\" placeholder=\"Inclusions\"></md-input-container>\n</div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" class=\"display-input\"><span \nclass=\"font-weight-600\">Start Date<sup class=\"red-fg\">*</sup></span><br><md-datepicker \nng-model=\"ctrl.parent.currentRateData.start_date\" md-placeholder=\"Start Date\" md-hide-icons=\"calendar\" name=\"start\" \nng-required=\"true\"></md-datepicker></div><div flex=\"50\" flex-xs=\"100\"><span class=\"font-weight-600\">Expiry Date<sup \nclass=\"red-fg\">*</sup></span><br><md-datepicker ng-model=\"ctrl.parent.currentRateData.expiry\" \nmd-placeholder=\"Expiry Date\" md-hide-icons=\"calendar\" name=\"expiry\" ng-required=\"true\"></md-datepicker></div></div><div\n class=\"mt-40\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex=\"100\" flex-xs=\"100\" flex-sm=\"100\"><div \nflex=\"45\" flex-xs=\"100\" class=\"\"><span class=\"font-weight-600\" translate=\"SELECT_CHARGE\">Select Charge</span><br>\n<md-select class=\"mt-0\" name=\"selectCharge\" ng-model=\"ctrl.parent.selectedChargeForTable\" \nmd-on-close=\"selectChargesearchTerm = \'\'\" placeholder=\"Select Charge\" data-md-container-class=\"selectdemoSelectHeader\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"selectChargesearchTerm\" type=\"search\" \nplaceholder=\"Search for a charge..\" class=\"demo-header-searchbox\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"charges\"><md-option ng-value=\"item\" \nng-repeat=\"item in ctrl.parent.chargeList |\n                    filter:selectChargesearchTerm\">{{item.charge_name}}\n</md-option></md-optgroup></md-select></div><div flex=\"55\" flex-xs=\"100\" class=\"display-input mt-5\"><div \nclass=\"mt-5 ml-10\"><md-button md-no-ink class=\"md-icon-button add-button-charge\" \nng-click=\"ctrl.parent.addCharge(ctrl.parent.selectedChargeForTable)\" translate=\"ADD_CHARGE\">Add Charge</md-button>\n</div></div></div><div ng-if=\"ctrl.parent.currentRateData.charges.length\" class=\"simple-table-container\" \nid=\"rate-table\"><div class=\"search_table\"><table id=\"ratessDatables\" \nclass=\"dataTable row-border hover text-center charge-table\" datatable=\"ng\" dt-options=\"ctrl.parent.dtOptions\"><thead>\n<tr><th><div class=\"table-header\"><span class=\"file_heading column-title\" translate=\"SR_NO\">Sr No.</span></div></th><th\n class=\"charge-name\"><div class=\"table-header\"><span class=\"file_heading column-title\" translate=\"NAME\">Name</span>\n</div></th><th><div class=\"table-header\"><span class=\"file_heading column-title\" translate=\"LEG\">Leg</span></div></th>\n<th><div class=\"table-header\"><span class=\"file_heading column-title\" translate=\"CURRENCY\">Currency</span></div></th>\n<th class=\"all\"><div class=\"table-header\"><span class=\"file_heading column-title\" translate=\"VALUE\">Value</span></div>\n</th><th class=\"all\"><div class=\"table-header\"><span class=\"file_heading column-title\" translate=\"ACTION\">Action</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"(key, data) in ctrl.parent.currentRateData.charges track by $index\" \nng-hide=\"data.charge_cost===\'\'\"><td class=\"pl-10\">{{$index+1}}</td><td class=\"charge-name\">{{data.charge_name}}</td><td\n class=\"text-lowercase\">{{ctrl.parent.getEachRateType(data)}}</td><td><select ng-model=\"data.charge_currency\" \nplaceholder=\"Currency\" class=\"m-0 select_currency select_box\" ng-options=\"curr for curr in ctrl.parent.currencyList\">\n</select></td><td><md-input-container md-no-float class=\"rate-value mt-8 table-value\"><input name=\"value\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\" ng-model=\"data.charge_cost\" maxlength=\"14\" placeholder=\"Value\" \nng-required=\"data.charge_currency\"></md-input-container></td><td><md-icon md-font-icon=\"icon-delete\" \nclass=\"icon pointer\" ng-click=\"ctrl.parent.removeChargeFromList(data); viewRateForm.$setDirty()\"></md-icon></td></tr>\n<tr ng-repeat=\"(key, data) in ctrl.parent.currentRateData.charges track by $index\" \nng-if=\"vm.selectedTableMode === \'lcl\'\"><td class=\"pl-10\">{{$index+1}}</td><td class=\"charge-name\">{{data.charge_name}}\n</td><td class=\"text-lowercase\">{{ctrl.parent.selectedRateTab}}</td><td><select ng-model=\"data.charge_currency\" \nplaceholder=\"Currency\" class=\"m-0 select_currency select_box\" ng-options=\"curr for curr in ctrl.parent.currencyList\">\n</select></td><td><md-input-container md-no-float class=\"rate-value mt-8 table-value\"><input name=\"value\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\" ng-model=\"data.charge_cost\" maxlength=\"14\" placeholder=\"Value\" required></md-input-container>\n</td><td><md-icon md-font-icon=\"icon-delete\" class=\"icon pointer\" ng-click=\"ctrl.parent.removeChargeFromList(data)\">\n</md-icon></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nmd-no-ink class=\"md-primary-btn\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\">Cancel</md-button><md-button\n md-no-ink class=\"md-accent-btn\" type=\"submit\" ng-disabled=\"viewRateForm.$invalid || viewRateForm.$pristine\" \ntitle=\"SAVE\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/enquiry-v2/enquiry-details/enquiry-details.html","<div class=\"enquiry-details\"><iframe resize-handler id=\"enquiry-details-iframe\" name=\"{{vm.todaysDate}}\" \nng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/groups/dialogs/assignForwarder.html","<md-dialog id=\"group-add\" class=\"modal\"><div layout=\"row\" layout-align=\"end end\" flex=\"20\"><md-icon \nmd-font-icon=\"icon-close\" class=\"mr-5 s16 pointer\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div>\n<md-dialog-content class=\"p-0\"><div class=\"wrapper\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\" \nflex-gt-xs=\"60\"><div class=\"font-size-22\">{{ctrl.parent.modalType}}</div></div><div class=\"pt-15\" layout=\"row\" \nflex=\"100\" layout-sm=\"column\" layout-xs=\"column\"><div layout=\"column\" flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><form><div\n class=\"ph-20 pb-20\" layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" class=\"display-input\">\n<span>Select Forwarder<sup class=\"red-fg\">*</sup></span><br><md-input-container md-no-float class=\"m-0 font-size-14\">\n<input class=\"capital\" ng-if=\"ctrl.parent.modalType === \'Edit Forwarder\'\" name=\"owner\" \nng-model=\"ctrl.parent.ownerSelected.companyName\" placeholder=\"Select Owner\" readonly=\"readonly\"><md-select \nng-if=\"ctrl.parent.modalType !== \'Edit Forwarder\'\" ng-model=\"ctrl.parent.ownerSelected\" class=\"typeSelect\"><md-option \nclass=\"options\" ng-repeat=\"type in ctrl.parent.forwarderList track by $index\" ng-value=\"type\">{{type.companyName}}\n</md-option></md-select></md-input-container></div></div><div class=\"ph-20\" flex=\"100\" flex-xs=\"100\" layout-wrap \nclass=\"display-input\"><span>Add Members<sup class=\"red-fg\">*</sup></span><br><md-contact-chips \nng-click=\"ctrl.parent.focusInput($event)\" ng-model=\"ctrl.parent.asyncContacts\" \nmd-contacts=\"ctrl.parent.delayedQuerySearch($query)\" md-contact-name=\"companyName\" md-require-match=\"true\" \nmd-highlight-flags=\"^i\" placeholder=\"Add Members\"></md-contact-chips></div><div class=\"ph-20 pt-20\" flex=\"100\" \nflex-xs=\"100\" layout=\"row\" layout-align=\"end end\"><md-button md-no-ink class=\"md-accent-btn mr-16\" \nng-disabled=\"ctrl.parent.disableForwarderButton\" ng-click=\"ctrl.parent.addForwarder()\">\n{{ctrl.parent.modalType === \'Add Forwarder\'? \'Submit\' : \'Update\'}}</md-button></div></form></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/modify-rates/audit-trail/auditTrail.html","<div id=\"audit-trail\"><iframe id=\"audit-trail-iframe\" ng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" \nstyle=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/modify-rates/bulk-update/bulkUpdate.html","<div id=\"bulk-update\"><iframe id=\"bulk-update-iframe\" ng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" \nstyle=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/modify-rates/dau-fcl-leg/dauFclLeg.html","<div id=\"dauFclLeg\"><iframe id=\"dauFclLeg-iframe\" ng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" \nstyle=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/quotes/copyQuoteDetails/copy-quote-details.html","<quote-modification quote-value=\"vm.quote_result\" page-title=\"\'copy-quote\'\" is-manual=\"vm.is_manual\">\n</quote-modification>");
$templateCache.put("app/main/quotes/copyQuoteDetails/copy-quote-expiryChange-Info.html","<md-dialog class=\"popup-sm\"><div layout=\"row\" class=\"header\" flex=\"100\"><div class=\"p-0 heading-text\" flex=\"90\" \nflex-xs=\"90\">Information</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size p-0\">\n<md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.closePanel()\"></md-icon></div></div><div \nlayout=\"row\"><md-dialog-content class=\"body\" flex=\"100\"><div layout=\"row\" class=\"mb-20\"><div><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"mb-2 ml-2 mr-10 grey-fg pointer\"></md-icon></div><div layout=\"column\">\n<div class=\"font-size-13\">We have updated the expiry date of all the expired rate cards to <span class=\"font-bold\">\n\" {{ctrl.parent.quote_result.result_data.expiry_date | date: \"dd MMM yyyy\" }} \"</span></div></div></div>\n</md-dialog-content></div></md-dialog>");
$templateCache.put("app/main/quotes/copyQuoteDetails/copy-quote-expiryChange-info.html","<md-dialog class=\"popup-sm\"><div layout=\"row\" class=\"header\" flex=\"100\"><div class=\"p-0 heading-text\" flex=\"90\" \nflex-xs=\"90\">Information</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size p-0\">\n<md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.closePanel()\"></md-icon></div></div><div \nlayout=\"row\"><md-dialog-content class=\"body\" flex=\"100\"><div layout=\"row\" class=\"mb-20\"><div><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"mb-2 ml-2 mr-10 grey-fg pointer\"></md-icon></div><div layout=\"column\">\n<div class=\"font-size-13\">We have updated the expiry date of all the expired rate cards to <span class=\"font-bold\">\n\" {{ctrl.parent.quote_result.result_data.expiry_date | date: \"dd MMM yyyy\" }} \"</span></div></div></div>\n</md-dialog-content></div></md-dialog>");
$templateCache.put("app/main/quotes/copyQuoteDetails/copy-quote-meta.html","<form name=\"vm.copyQuoteForm\" class=\"search-form\" ng-class=\"{\'mobile-form-style\': vm.isStateResult && vm.editSearch}\">\n<div layout=\"row\" layout-padding flex=\"100\" layout-xs=\"column\" layout-xm=\"column\" layout-wrap class=\"ph-0\"><div \nclass=\"mobile_input\" flex=\"50\" flex-xs=\"100\" \nng-class=\"{\'search_multiport_div\':!vm.isStateResult,\'result_multiport_div\':vm.isStateResult}\"><span \nclass=\"font-weight-600 font-size-11 form-title\">Origin</span><br><md-input-container md-no-float \nclass=\"p-0 m-0 panel-select ph-10\" ng-mouseleave=\"focused=false\" ng-mouseenter=\"focused=true\" \nng-class=\"{\'red-border pl-35\':((vm.copyQuoteForm.fcl_origin_port.$error.required || vm.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && !focused), \'pl-35\': vm.search_param.mode!==\'AIR\', \'b-focus\': originFocused}\" \nlayout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"((vm.copyQuoteForm.fcl_origin_port.$error.required || vm.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && !focused)\" \nmdprefix class=\"mh-5 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"mh-5 icon-size-autocomplete\" \nng-class=\"{\'icon-size-12 mt-2\' : ( vm.search_param.origin_location.place_type !== \'Door\' && !vm.search_param.origin_location.is_major_port  && !vm.search_param.origin_location.is_icd_port), \'icon-size-10 mt-6\' : !vm.search_param.origin_location, \'h-15 w-15 mt-2\' : vm.search_param.origin_location.is_primary}\" \nmd-svg-src=\"{{ vm.search_param.origin_location ?\n                (vm.search_param.origin_location.place_type !== \'Door\' ?\n                ((!vm.search_param.origin_location.is_icd_port && vm.search_param.origin_location.is_major_port) || (vm.search_param.origin_location.is_icd_port && vm.search_param.origin_location.is_major_port) || (!vm.search_param.origin_location.is_icd_port && !vm.search_param.origin_location.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!vm.search_param.origin_location.is_primary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' )) :\n                \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!((vm.copyQuoteForm.fcl_origin_port.$error.required || vm.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && !focused)) && vm.search_param.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\" \nng-if=\"(!((vm.copyQuoteForm.fcl_origin_port.$error.required || vm.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && (vm.copyQuoteForm.fcl_origin_port.$dirty || vm.formSubmit) && !focused)) && vm.search_param.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" \nmd-selected-item-change=\"vm.checkForSamePorts(\'origin\',$event);\" \nng-focus=\"focused=true; vm.isStateResult ? (!vm.searchFromClose ? vm.toggleFormForResult() : return) : return; vm.formIsPristine=false;originFocused=true\" \nng-blur=\"originFocused=false\" \nng-class=\"{\'placeholder-error\':((vm.copyQuoteForm.fcl_origin_port.$error.required || vm.copyQuoteForm.fcl_origin_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && (vm.copyQuoteForm.fcl_origin_port.$dirty || vm.formSubmit) && !focused)}\" \nrequired id=\"origin-input\" md-input-name=\"fcl_origin_port\" md-selected-item=\"vm.search_param.origin_location\" \nmd-search-text=\"fcl_originSearchText\" \nmd-items=\"item in vm.getPortsLocation(fcl_originSearchText, vm.search_param.mode, \'origin\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{$ctrl.search_param.mode===\'AIR\' ?\'Search by Door/Airport\':\'Search by Door/Port\'}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"false\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"vm.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_originSearchText.length >= 2 && !item.is_primary \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div \nng-if=\"fcl_originSearchText.length >= 2 && item.is_primary\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/primary_location.svg\')\" class=\"icon-bg\"></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!fcl_originSearchText || fcl_originSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-14\" compile-html=\"vm.util.searchHighlight(item.location,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-12\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</div><div layout=\"row\" layout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete></md-input-container></div><div class=\"mobile_input\" flex=\"50\" flex-xs=\"100\" \nng-class=\"{\'search_multiport_div\':!vm.isStateResult,\'result_multiport_div\':vm.isStateResult}\"><span \nclass=\"font-weight-600 font-size-11 form-title\">Destination</span><br><md-input-container md-no-float \nclass=\"p-0 m-0 panel-select ph-10\" ng-mouseleave=\"destfocused=false\" ng-mouseenter=\"destfocused=true\" \nng-class=\"{\'red-border pl-35\':((vm.copyQuoteForm.fcl_destination_port.$error.required || vm.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && !destfocused), \'pl-35\': vm.search_param.mode!==\'AIR\', \'b-focus\': destinationFocused}\" \nlayout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"((vm.copyQuoteForm.fcl_destination_port.$error.required || vm.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) &&  !destfocused)\" \nmdprefix class=\"mh-5 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nclass=\"mh-5 icon-size-autocomplete\" \nng-class=\"{\'icon-size-12 mt-2\' : ( vm.search_param.destination_location.place_type !== \'Door\' && !vm.search_param.destination_location.is_major_port  && !vm.search_param.destination_location.is_icd_port), \'icon-size-10 mt-6\' : !vm.search_param.destination_location, \'h-15 w-15 mt-2\' : vm.search_param.destination_location.is_primary}\" \nmd-svg-src=\"{{ vm.search_param.destination_location ?\n                (vm.search_param.destination_location.place_type !== \'Door\' ?\n                ((!vm.search_param.destination_location.is_icd_port && vm.search_param.destination_location.is_major_port) || (vm.search_param.destination_location.is_icd_port && vm.search_param.destination_location.is_major_port) || (!vm.search_param.destination_location.is_icd_port && !vm.search_param.destination_location.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!vm.search_param.destination_location.is_primary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' )) :\n                \'assets/icons/custom/search-bar/empty.svg\' }}\" \nng-if=\"(!((vm.copyQuoteForm.fcl_destination_port.$error.required || vm.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && !destfocused)) && vm.search_param.mode!==\'AIR\'\">\n</md-icon><div style=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\" \nng-if=\"(!((vm.copyQuoteForm.fcl_destination_port.$error.required || vm.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && (vm.copyQuoteForm.fcl_destination_port.$dirty || vm.formSubmit) && !destfocused)) && vm.search_param.mode===\'AIR\'\">\n</div><md-autocomplete class=\"auto-complete-style port-autocomplete port-min-width mobile_input\" \nmd-selected-item-change=\"vm.checkForSamePorts(\'destination\',$event);\" \nng-focus=\"destfocused=true; vm.isStateResult ? (!vm.searchFromClose ? vm.toggleFormForResult() : return) : return; vm.formIsPristine=false;destinationFocused=true\" \nng-blur=\"destinationFocused=false\" \nng-class=\"{\'placeholder-error\':((vm.copyQuoteForm.fcl_destination_port.$error.required || vm.copyQuoteForm.fcl_destination_port.$error[\'md-require-match\'] || vm.copyQuoteForm.$error.samePortError) && (vm.copyQuoteForm.fcl_destination_port.$dirty || vm.formSubmit) && !destfocused)}\" \nrequired id=\"destination-input\" md-input-name=\"fcl_destination_port\" \nmd-selected-item=\"vm.search_param.destination_location\" md-search-text=\"fcl_destinationSearchText\" \nmd-items=\"item in vm.getPortsLocation(fcl_destinationSearchText, vm.search_param.mode, \'destination\')\" \nmd-item-text=\"item.portname || item.location_string\" md-min-length=\"0\" md-no-cache=\"true\" md-delay=\"300\" \nmd-require-match=\"true\" md-menu-class=\"autocomplete-custom-template-search\" \nplaceholder=\"{{$ctrl.search_param.mode===\'AIR\' ?\'Search by Door/Airport\':\'Search by Door/Port\'}}\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-select-on-focus=\"true\" md-clear-button=\"false\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" class=\"dropdown-data\"><div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pol.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-13\" compile-html=\"vm.util.searchHighlight(item.portname,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" ng-if=\"item.global_port_code\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">{{item.global_port_code}}</span></div></div></span><span \nclass=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div class=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\" \nclass=\"dropdown-data\"><div ng-show=\"fcl_destinationSearchText.length >= 2 && !item.is_primary \" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div \nng-if=\"fcl_destinationSearchText.length >= 2 && item.is_primary\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/primary_location.svg\')\" class=\"icon-bg\"></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!fcl_destinationSearchText || fcl_destinationSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8\"><div \nclass=\"black-fg font-size-14\" compile-html=\"vm.util.searchHighlight(item.location,fcl_destinationSearchText)\"></div>\n<div class=\"grey-fg font-size-12\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" ng-show=\"item.pin_code_ui\" style=\"pointer-events: none\">\n<span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found><div class=\"font-size-14 mt-15 pl-5\">No ports matching were found.</div>\n</md-not-found></md-autocomplete></md-input-container></div></div><div layout=\"row\" layout-padding flex=\"100\" \nlayout-xs=\"column\" layout-xm=\"column\" layout-wrap class=\"ph-0\"><div ng-if=\"vm.search_param.mode ===\'SEA-FCL\'\"><span \nng-if=\"vm.isload_type_alias\" class=\"font-weight-600 font-size-11 form-title\">Load Type<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 pointer load-alias grey-400-fg\" \nng-mouseover=\"vm.showLoadAlias($event);vm.trackEvent(\'panel\')\"></md-icon></span><span ng-if=\"!vm.isload_type_alias\" \nclass=\"font-weight-600 font-size-11 form-title\">Load Type<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 ml-5 pointer load-alias grey-400-fg\"><md-tooltip md-direction=\"top\" class=\"font-size-12\">\nSelect multiple loads to view rates</md-tooltip></md-icon></span><br><md-input-container md-no-float class=\"p-0 m-0\">\n<div class=\"w-150 panel-select panel-select-load pointer mobile_input\" ng-click=\"vm.showLoadPanel($event)\" \nng-class=\"{\'red-border red-fg\': vm.copyQuoteForm.$error.loadError}\" layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"80\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/load_type.svg\')\" class=\"icon-bg\" \nng-if=\"!(vm.copyQuoteForm.$error.loadError)\"></div><md-icon ng-if=\"vm.copyQuoteForm.$error.loadError\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div \ntruncate=\"{{vm.LoadBoxString}}\" class=\"mt-2 pv-5 hide-overflow text-truncate\" \nng-class=\"{\'margin-remove\': vm.LoadBoxString===\'\'}\">{{vm.LoadBoxString}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{vm.LoadTooltipString}}</span>\n</md-tooltip></div><div ng-if=\"vm.LoadBoxString===\'\'\" class=\"mh-10 pv-5\" \nng-class=\"{\'margin-remove\':vm.copyQuoteForm.$error.loadError}\">Select Load</div></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\" flex=\"20\"></md-icon></div></md-input-container></div><div \nng-if=\"vm.search_param.mode !==\'SEA-FCL\'\"><span class=\"font-size-13 Font-Bold\">Load Details<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 ml-5 grey-400-fg\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">Chargeable Weight</md-tooltip></md-icon></span><br><md-input-container md-no-float \nclass=\"p-0 m-0\"><div class=\"w-150 panel-select panel-select-load-detail pointer mobile_input\" \nng-click=\"vm.showLoadDetailPanel($event)\" ng-class=\"{\'red-border red-fg\': vm.copyQuoteForm.$error.loadDetailError}\" \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"85\">\n<div style=\"background-image: url(\'assets/icons/custom/search-bar/load_detail.svg\')\" class=\"icon-bg\" \nng-if=\"!(vm.copyQuoteForm.$error.loadDetailError)\"></div><md-icon ng-if=\"vm.copyQuoteForm.$error.loadDetailError\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div \nclass=\"pv-5 text-truncate mt-2\">\nCharged Wt: {{vm.search_param.load_data.load_meta.chargeable_weight | currencyMask: 2 || 0}} {{vm.util.chargeableUnit[vm.search_param.mode]}}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-12\">\nCharged Wt: {{vm.search_param.load_data.load_meta.chargeable_weight | currencyMask: 2 || 0}} {{vm.util.chargeableUnit[vm.search_param.mode]}}\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\" flex=\"20\"></md-icon></div>\n</md-input-container></div><div><span class=\"font-size-13 Font-Bold\">Cut Off Date</span><br><md-input-container \nmd-no-float class=\"w-140 h-40 p-0 m-0\"><div class=\"panel-select pointer mobile_input\" layout=\"row\" \nlayout-align=\"start center\" \nng-class=\"{\'red-border\':(vm.copyQuoteForm.cargo_ready_date.$error.required || vm.copyQuoteForm.cargo_ready_date.$error.mindate) && (vm.copyQuoteForm.cargo_ready_date.$dirty || vm.formSubmit)}\" \nng-click=\"vm.openDatePicker=true\"><div style=\"background-image: url(\'assets/icons/custom/search-bar/date.svg\')\" \nclass=\"icon-bg\" \nng-if=\"!((vm.copyQuoteForm.cargo_ready_date.$error.required || vm.copyQuoteForm.cargo_ready_date.$error.mindate) && (vm.copyQuoteForm.cargo_ready_date.$dirty || vm.formSubmit))\">\n</div><md-icon \nng-if=\"(vm.copyQuoteForm.cargo_ready_date.$error.required || vm.copyQuoteForm.cargo_ready_date.$error.mindate) && (vm.copyQuoteForm.cargo_ready_date.$dirty || vm.formSubmit)\" \nclass=\"mh-10 h-15 w-15\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><div class=\"mt-2\" \nng-class=\"{\'red-fg remove-pl mt-2\':(vm.copyQuoteForm.cargo_ready_date.$error.required || vm.copyQuoteForm.cargo_ready_date.$error.mindate) && (vm.copyQuoteForm.cargo_ready_date.$dirty || vm.formSubmit)}\" \nng-bind=\"vm.search_param.cargo_ready_date ? (vm.search_param.cargo_ready_date  |  date : \'dd MMM yyyy\') : \'Select Date\'\">\n</div></div><md-datepicker id=\"date-picker-search\" name=\"cargo_ready_date\" md-min-date=\"vm.todayDate\" \nmd-max-date=\"vm.cutoffMaxDate\" ng-model=\"vm.search_param.cargo_ready_date\" md-placeholder=\"Select\" \nmd-is-open=\"vm.openDatePicker\" onkeydown=\"return false\" md-open-on-focus md-hide-icons=\"all\" class=\"pv-5 pl-15\" \nrequired ng-focus=\"vm.formIsPristine=false;\" ng-blur=\"vm.focusElem()\" ng-change=\"vm.trackEvent(\'Cut off date\')\">\n</md-datepicker></md-input-container></div><div><span class=\"font-size-13 Font-Bold\">Incoterms</span><br><div>\n<incoterm-select incoterm=\"vm.search_param.inco_term\" select-panel-width=\"\'260\'\" impo-expo=\"vm.search_param.impo_expo\" \nfull-border=\"true\"></incoterm-select></div></div><div \nng-if=\"vm.search_param.mode===\'SEA-FCL\' &&  vm.searchConfig &&  vm.searchConfig.stuffing\"><span \nclass=\"font-size-13 Font-Bold\">Stuffing</span><div><md-input-container md-no-float class=\"p-0 w-80 m-0\"><md-select \nng-model=\"vm.search_param.stuffing\" class=\"panel-select\"><md-option md-no-ink value=\"F\" \nclass=\"md-primary checkbox-margin\">Factory</md-option><md-option md-no-ink value=\"D\" class=\"md-primary\">Dock\n</md-option></md-select></md-input-container></div></div><div><span class=\"font-size-13 Font-Bold\">Customs</span><div>\n<md-input-container md-no-float class=\"p-0 w-80 m-0\"><md-select ng-model=\"vm.search_param.customs\" \nclass=\"panel-select\"><md-option md-no-ink value=\"true\" class=\"md-primary checkbox-margin\">Yes</md-option><md-option \nmd-no-ink value=\"false\" class=\"md-primary\">No</md-option></md-select></md-input-container></div></div><div><span \nclass=\"font-size-13 Font-Bold\">Quote Period</span><div><div layout=\"row\" layout-align=\"space-between\" \nclass=\"pointer font-size-12 panel-select w-190 mb-15\"><md-icon md-font-icon=\"icon-calendar\" class=\"s24 pointer\">\n</md-icon><md-date-range ng-model=\"vm.pickerModel\" class=\"date-range-picker\" placeholder=\"Select dates\" \nmd-on-select=\"vm.setDatePicker(vm.pickerModel)\" one-panel=\"true\" auto-confirm=\"true\" show-template=\"false\">\n</md-date-range></div></div></div><div><span class=\"font-size-13 Font-Bold\">Terms and Conditions</span><div \nlayout=\"column\" layout-align=\"end center\" class=\"font-size-13 pointer md-link-fg link-btn\" \nng-click=\"vm.fnopenTermsCondition($event)\">\n&nbsp; &nbsp; {{ vm.quote_result.result_data.terms.length ? \'Edit/Delete\' : \'+ Add Terms and Condition\' }}</div></div>\n</div></form>");
$templateCache.put("app/main/quotes/copyQuoteDetails/copy-share-quotation.html","<md-dialog id=\"share-quotation\" class=\"dialobox\" ng-cloak><md-dialog-content class=\"p-0\"><md-toolbar \nid=\"share_quotation_Toolbar\" class=\"font-size-21\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex=\"70\"><span class=\"toolbarHeading font-weight-600 p-0\">Generate Quotation\n</span></div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor m-0\" ng-click=\"vm.closeShareDialog(\'quote\')\" \nng-disabled=\"vm.PdfQuoteBtn || vm.shareQuoteBtn\"></md-icon></div></div></md-toolbar><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"mt-25\"><div layout=\"row\" flex=\"100\" class=\"w-50 h-50\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"w-50 h-50 tick_success\"></md-icon></div><div layout=\"column\" \nflex=\"100\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" class=\"mt-20 mb-10 send-msg\">\n{{ vm.shareQuoteResponse.message }}</div><div layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"mb-15 mt-8 inquiry-id-container\" ng-if=\"!vm.shareQuoteResponse.inquiry_id\">Quote ID : <span \nclass=\"inquiry-id ml-5\" ng-click=\"vm.closeShareDialog(\'quote\')\">{{ vm.shareQuoteResponse.quote_id }}</span></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"mb-15 mt-8 inquiry-id-container\" \nng-if=\"vm.shareQuoteResponse.inquiry_id\">Inquiry ID : <span class=\"inquiry-id pl-5\" \nng-click=\"vm.closeShareDialog(\'inquiry\')\">{{ vm.shareQuoteResponse.inquiry_number }}</span></div><div layout=\"column\" \nflex=\"100\" layout-align=\"center center\" class=\"Font-Bold font-size-12 mb-15\" ng-show=\"!vm.quoteDetails.send_mail\"><div \nclass=\"successNote\">\n{{ (vm.isPdfFailed || vm.isPdfErrOccured) ? \'Note: Email to the customer will be shared after PDF generation\' : \'Note: Email not sent to customer\'}}\n</div><div ng-if=\"vm.isPdfFailed || vm.isPdfErrOccured\" class=\"grey-fg Font-Regular mt-8\">\nYou can try again in Inquiry or quote details</div></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"quote-footer p-10\" layout-wrap><div layout=\"column\" \nlayout-align=\"center start\" flex-xs=\"100\" class=\"mt-8 pl-10\"><div ng-if=\"!vm.isPdfFailed\" \nng-bind=\"!vm.isPdfGenerated ? \'We are generating a downloadable quotation(PDF Format).\':\'Downloadable quotation(PDF Format) is ready\'\" \nclass=\"mb-5\"></div><div ng-if=\"vm.isPdfFailed\" class=\"red-300-fg font-size-12 mb-5\">\nAn error has occurred while creating the PDF, please <span class=\"text-underline md-link-fg Font-Bold pointer\" \nng-click=\"vm.fnGetPdfLink();vm.trackEvent(\'GQ-QuoteID-DownloadPDF-TryAgain\')\"><u>try again</u></span></div><div \nng-if=\"vm.isPdfErrOccured\" class=\"red-300-fg font-size-12 mb-5\">\nOur system is down, we aren’t able to generate the PDF. Please try again later.</div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.isPdfFailed && !vm.isPdfErrOccured\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-5\"><progress max=\"100\" value=\"{{vm.downloadProgressValue*20}}\"></progress></div>\n<div ng-if=\"!vm.isPdfFailed && !vm.isPdfErrOccured\" class=\"text-italic font-size-11 black-fg\">\n{{vm.isPdfGenerated || vm.downloadProgressValue >= 5 ? \'100\' : vm.downloadProgressValue*20}} %</div></div></div><div \nlayout=\"row\" layout-align=\"end center\" class=\"m-10 h-35\" flex-xs=\"100\"><md-button md-no-ink \nclass=\"md-primary-btn with-icon mr-10\" title=\"View Quote\" ng-click=\"vm.closeShareDialog(\'quote\')\" \nng-if=\"vm.shareQuoteResponse.quote_id\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon>View Quote</md-button>\n<md-button md-no-ink class=\"md-accent-btn with-icon ml-10\" title=\"Download\" \nng-disabled=\"!vm.isPdfGenerated || vm.isPdfFailed\" ng-click=\"vm.downloadPdf()\"><span><md-icon \nmd-font-icon=\"icon-download\" class=\"s16\"></md-icon></span>Download PDF</md-button></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/quotes/copyQuoteDetails/expiry-change-confirmation.html","<md-dialog class=\"popup-sm\"><div layout=\"row\" class=\"header\" flex=\"100\"><div class=\"p-0 heading-text\" flex=\"90\" \nflex-xs=\"90\">Confirmation</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size p-0\">\n<md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.fnExpiryDateChanged(\'close\')\"></md-icon>\n</div></div><div><div layout=\"row\"><md-dialog-content class=\"body\" flex=\"100\"><div class=\"font-size-13 mb-20\">\nDo you want to update effective period?</div><div layout=\"row\" class=\"mb-20\"><div><md-checkbox md-no-ink \naria-label=\"Checkbox No Ink\" ng-model=\"ctrl.parent.includeRateCards\" class=\"md-primary\"></md-checkbox></div><div \nlayout=\"column\"><div class=\"font-size-13\">Include all Expired Rate Cards</div><div class=\"font-size-11 fg-AFAFAF\">\nBy checking this checkbox will reflect in all rate card</div></div></div></md-dialog-content></div><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary-btn ml-10\" title=\"CANCEL\" ng-click=\"ctrl.parent.fnExpiryDateChanged(\'close\')\">No\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" \nng-click=\"ctrl.parent.fnExpiryDateChanged(\'submit\')\">Yes,Proceed</md-button></md-dialog-actions></div></md-dialog>");
$templateCache.put("app/main/quotes/quotesDetails/fcl-quote-details.html","<div id=\"fcl-quote-details\"><md-sidenav md-is-locked-open class=\"md-sidenav-right md-white-bg\" md-component-id=\"right\" \nms-sidenav-helper ng-include=\"\'app/main/quotes/sidenav/activity-monitor/activity-monitor.html\'\"></md-sidenav><div flex \nms-scroll ng-if=\"!vm.dataErr\"><div class=\"center\"><import-file-status-bar importstatusobj=\"vm.responseStatusData\" \ncallback=\"vm.removeResponse(\'\',index)\"></import-file-status-bar><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"mv-20\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between end\" \nlayout-align-xs=\"space-between start\" flex=\"100\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"font-size-11 md-link-fg ml-30 pointer font-bold\" ng-if=\"!vm.quotePreview && !(vm.isWebView || vm.isShared)\" \nng-click=\"vm.fnViewQuoteList()\">Quotes / <span class=\"modeStyle\">{{vm.search_param.mode}}</span></div><div \nlayout=\"row\" ng-if=\"!vm.quotePreview\"><div ng-click=\"vm.fnViewQuoteList()\" ng-if=\"!(vm.isWebView || vm.isShared)\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-5 mt-5 pointer\"></md-icon></div><div \nng-bind=\"vm.quote_result.result_data.quote_id\" ng-if=\"vm.quote_result.result_data.quote_id\" class=\"page_title\"></div>\n<div class=\"ph-5\" ng-click=\"vm.fnOpenStatusChangePanel( vm.quote_result.result_data , $event )\" \nng-class=\"{\'cursor\': !vm.hideStatusChange }\"><div class=\"quote-status-panel\" \nng-class=\"{\'min-width-75\': !vm.hideStatusChange }\" \nng-style=\"vm.util.fnSetStatusColor(vm.util.colorCodeObj[vm.quote_Status])\"><span class=\"pb-8 pr-5\">{{vm.quote_Status}}\n</span><md-icon ng-if=\"!vm.hideStatusChange\" \nng-style=\"vm.util.fnSetStatusColor(vm.util.colorCodeObj[vm.quote_Status] , \'icon\')\" md-font-icon=\"icon-chevron-down\" \nclass=\"down-arrow-icon icon-height-11\"></md-icon><md-tooltip ng-if=\"!vm.hideStatusChange\" md-direction=\"top\">\nChange Status Here</md-tooltip></div></div><div><div class=\"status_meta_div allinquote-tag-color\" \nng-if=\"vm.quote_result.result_data.all_in_quote_setting && !(vm.util.isShipper || vm.isShared || vm.util.isEfpEnabled)\" \nng-bind=\"vm.quote_result.result_data.all_in_quote_setting ? vm.util.allInQuoteOptions[vm.quote_result.result_data.all_in_quote_setting] : \'Default\'\">\n</div></div></div></div><div layout=\"row\" class=\"action-button-div\" ng-if=\"!vm.quotePreview\"><div \nng-if=\"!vm.isDuplicateQuote\" class=\"action-inside-div hover-icon\"><download-pdf \nquoteid=\"vm.quote_result.result_data._id\" result_type=\"\'Quote\'\"></download-pdf></div><ng-container \nng-if=\"!vm.checkTemplate  && !(vm.isShared  || vm.isQuoteModify  || vm.util.isShipper || vm.quote_result.result_data.revised || vm.util.isEfpEnabled ) && vm.util.navPermission.quotes && vm.util.navPermission.quotes[2]\" \nclass=\"meta-container-height\"><div class=\"action-inside-div hover-icon\" \nng-click=\"vm.fnopenCreateTemplate($event,\'New\')\"><md-tooltip md-direction=\"top\" class=\"font-size-12\">Save As Template\n</md-tooltip><md-icon md-svg-src=\"assets/icons/custom/ic_save_24px.svg\" class=\"h-15\"></md-icon><div class=\"icon-text\">\nSave As Template</div></div></ng-container><ng-container \nng-if=\"vm.checkTemplate && !( vm.isShared  || vm.isQuoteModify  || vm.util.isShipper || vm.quote_result.result_data.revised ) && vm.util.navPermission.quotes && vm.util.navPermission.quotes[1] && !(vm.util.navPermission.quotes[2] || vm.util.navPermission.quotes[3] || vm.util.isEfpEnabled)\" \nclass=\"meta-container-height\"><div class=\"action-inside-div disable-state hover-icon\"><md-icon \nmd-svg-src=\"assets/icons/custom/ic_bookmark_24px.svg\" class=\"h-15 edit-actions template-actions-view\"></md-icon><div \nclass=\"disable-icon-text template-reference\">Saved Template</div><md-tooltip md-direction=\"top\" class=\"font-size-12\">\n{{ vm.quote_result.result_data.template_data.name}}</md-tooltip></div></ng-container><ng-container \nng-if=\"vm.checkTemplate && !( vm.isShared  || vm.isQuoteModify  || vm.util.isShipper || vm.quote_result.result_data.revised ) &&  vm.util.navPermission.quotes && (vm.util.navPermission.quotes[2] || vm.util.navPermission.quotes[3] || vm.util.isEfpEnabled) \" \nclass=\"meta-container-height\"><div class=\"action-inside-div hover-icon active-state\" \nng-click=\"vm.showTemplateAction($event)\"><md-icon md-svg-src=\"assets/icons/custom/ic_bookmark_24px.svg\" \nclass=\"h-15 edit-actions template-actions-view\"></md-icon><div class=\"icon-text template-reference\">Saved Template\n</div></div></ng-container><div class=\"action-inside-div hover-icon\" ng-click=\"vm.fnopenCopyQuotewalkthrough($event)\" \nng-hide=\"vm.isShared  || vm.isQuoteModify  || vm.util.isShipper || vm.util.isEfpEnabled || !(vm.util.navPermission.quotes && vm.util.navPermission.quotes[0])\">\n<md-icon md-svg-src=\"assets/icons/custom/quote_copy.svg\" class=\"h-15\"></md-icon><div class=\"icon-text\">Copy Quote</div>\n</div><div class=\"action-inside-div hover-icon\" \nng-class=\"{\'disable-state\':vm.disableSetReminder,\'active-state\':!vm.disableSetReminder && vm.quote_result.result_data.reminder.reminder_date }\" \nng-if=\"!vm.util.isShipper && vm.dateExpired  && !vm.isShared && !vm.isDuplicateQuote && !vm.util.isEfpEnabled\" \nng-click=\"vm.fnOpenSetReminderModal($event)\"><md-tooltip md-direction=\"bottom\" class=\"font-size-12\"><p \nng-if=\"vm.disableSetReminder\" class=\"m-0\">\nCreated by {{vm.quote_result.result_data.reminder.created_by.user_first_name+\' \'+vm.quote_result.result_data.reminder.created_by.user_last_name}}\n</p><p ng-if=\"!vm.disableSetReminder && vm.quote_result.result_data.reminder.reminder_date\" class=\"m-0\">Tap to edit</p>\n<p ng-if=\"!vm.quote_result.result_data.reminder\" class=\"m-0\">\nSet reminders for your quotes,and we will duly remind you via email.</p></md-tooltip><md-icon \nmd-svg-src=\"assets/icons/custom/quote_alarm.svg\" class=\"h-15\"></md-icon><div \nng-class=\"{\'icon-text\':!vm.disableSetReminder,\'disable-icon-text\':vm.disableSetReminder}\">\n{{vm.quote_result.result_data.reminder.reminder_date ? ( vm.quote_result.result_data.reminder.reminder_date | date : \'d MMM yyyy\'):\'Set Reminder\'}}\n</div></div><div class=\"action-inside-div hover-icon\" \nng-show=\"!vm.maskLiner && ! ( vm.isShared || vm.quote_result.result_data.is_booked || vm.quote_result.result_data.revised || vm.isQuoteModify || vm.isLost || vm.isExpired || vm.isDuplicateQuote || vm.util.isEfpEnabled )\" \nng-click=\"vm.fnOpenMatchRatesModal($event)\"><md-icon md-svg-src=\"assets/icons/custom/quote_dollar.svg\" class=\"h-15\">\n</md-icon><div class=\"icon-text\">{{ vm.util.isAdmin ? \'Request Better Rates\' : \'Match Rates\'}}</div></div><div \nclass=\"action-inside-div hover-icon\" ng-if=\"!vm.util.isShipper && !vm.isShared && !vm.isDuplicateQuote\" \nng-click=\"vm.toggleSideNav(\'right\')\"><md-icon md-svg-src=\"assets/icons/custom/view_activity.svg\" \nclass=\"view-icon h-15\"></md-icon><div class=\"icon-text\">View Activity</div></div><div \nclass=\"action-inside-div hover-icon\" \nng-if=\"vm.util.navPermission.quotes[2] && !vm.quote_result.result_data.is_booked && !vm.isShared && !vm.quote_result.result_data.revised && !vm.isLost && !vm.isDuplicateQuote && !vm.util.isEfpEnabled\" \nng-click=\"vm.fnOpenEditQuoteModal($event)\"><md-icon md-svg-src=\"assets/icons/custom/quote_edit.svg\" class=\"h-15\">\n</md-icon><div class=\"icon-text\">Edit</div></div></div></div></div><div flex=\"100\" layout-xs=\"column\" layout=\"row\">\n<md-card flex=\"100\" flex-sm=\"100\" flex-xs=\"100\" class=\"brad-4 m-0\"><md-card-content class=\"pv-0 ph-15\"><div \nclass=\"ph-8\"><div class=\"pv-15\"><div class=\"heading\">Origin</div><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div ng-repeat=\"port in vm.originPorts\"><div class=\"sub-heading text-truncate pr-5\" \ntitle=\"{{ port.location_string}}\"><md-icon class=\"w-10 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( port.place_type !== \'Door\' && !port.is_major_port && !port.is_icd_port) }\" \nmd-svg-src=\"{{port.icon}}\"></md-icon><span>{{ port.location_string }}</span></div></div></div></div><div><div \nclass=\"heading\">Destination</div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nng-repeat=\"port in vm.destinationPorts\"><div class=\"sub-heading text-truncate pr-5\" title=\"{{ port.location_string}}\">\n<md-icon class=\"w-10 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( port.place_type !== \'Door\' && !port.is_major_port && !port.is_icd_port) }\" \nmd-svg-src=\"{{port.icon}}\"></md-icon>{{ port.location_string}}</div></div></div></div></div><div layout=\"row\" \nlayout-padding layout-wrap class=\"ph-0 pb-10\"><div class=\"max-width-180\"><div class=\"heading\">Load Details</div><div \nclass=\"sub-heading text-truncate\">{{vm.loadDispaly}}<md-tooltip ng-if=\"vm.loadDispaly\" md-direction=\"top\" \nclass=\"font-size-12 tooltip-height\"><div compile-html=\"vm.loadTooltip\"></div></md-tooltip></div></div><div><div \nclass=\"heading\">Cargo Type</div><div class=\"sub-heading\" \nng-if=\"!vm.quote_result.result_data.hazardous && !vm.quote_result.result_data.perishable\">N/A</div><div \nclass=\"text-truncate sub-heading\" \nng-if=\"vm.quote_result.result_data.hazardous || vm.quote_result.result_data.perishable\"><span><span \nng-show=\"vm.quote_result.result_data.hazardous\" class=\"ph-5\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"dot_icon\"></md-icon>Hazardous</span> <span ng-show=\"vm.quote_result.result_data.perishable\" class=\"ph-5\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"dot_icon\"></md-icon>Perishable</span></span></div></div><div>\n<div class=\"heading\">Incoterms</div><div layout=\"row\" class=\"sub-heading\"><div \ntitle=\"{{ vm.quote_result.result_data.incoterms ? vm.quote_result.result_data.incoterms : \'N/A\' }}\" \nng-bind=\"vm.quote_result.result_data.incoterms ? vm.quote_result.result_data.incoterms : \'N/A\'\"></div><div \nng-if=\"vm.quote_result.result_data.impo_expo && vm.quote_result.result_data.incoterms\">\n- {{vm.quote_result.result_data.impo_expo}}</div></div></div><div><div class=\"heading\">Customs</div><div \nclass=\"sub-heading\" title=\"{{vm.quote_result.result_data.customs ? \'Yes\' : \'No\'}}\">\n{{vm.quote_result.result_data.customs ? \'Yes\' : \'No\'}}</div></div><div><div class=\"heading\">Stuffing</div><div \nclass=\"sub-heading\" title=\"{{ vm.search_param.stuffing == \'F\' ? \'Factory Stuffing\' : \'Dock Stuffing\' }}\">\n{{ vm.search_param.stuffing == \'F\' ? \'Factory\' : \'Dock\' }}</div></div><div class=\"max-width-180\"><div class=\"heading\">\nPeriod</div><div class=\"sub-heading text-truncate\" \ntitle=\"{{vm.quote_result.result_data.expiry_date | NoTimeZone : \'d MMM yyyy\'}}\">\n{{vm.quote_result.result_data.start_date | NoTimeZone : \'d MMM yyyy\'}}-{{vm.quote_result.result_data.expiry_date | NoTimeZone : \'d MMM yyyy\'}}\n</div></div><div class=\"max-width-180\"><div class=\"heading\">Sales Coordinator</div><div \nclass=\"sub-heading text-truncate\" ng-if=\"vm.quote_result.result_data.sales_coordinator.user_first_name\" \ntitle=\"{{vm.quote_result.result_data.sales_coordinator.user_first_name}} {{vm.quote_result.result_data.sales_coordinator.user_last_name}}\">\n{{vm.quote_result.result_data.sales_coordinator.user_first_name}} {{vm.quote_result.result_data.sales_coordinator.user_last_name}}\n</div><div class=\"sub-heading\" ng-if=\"!vm.quote_result.result_data.sales_coordinator.user_first_name\">N/A</div></div>\n<div><div class=\"heading\">Terms and Condition</div><div layout=\"column\" ng-if=\"vm.quote_result.result_data.terms\" \nclass=\"font-size-13 pointer md-link-fg link-btn pl-2\" ng-click=\"vm.fnopenTermsCondition($event)\">View</div><div \nclass=\"sub-heading\" ng-if=\"!vm.quote_result.result_data.terms\">N/A</div></div><div ng-if=\"vm.isCommodity\"><div \nclass=\"heading\">Commodity</div><div class=\"sub-heading text-truncate max-width-300\" \ntitle=\"{{vm.commodityValue.length ? vm.commodityValue.toString() : \'-\'}}\">\n{{ vm.commodityValue.length ? vm.commodityValue.toString() : \'-\'}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-padding layout-wrap class=\"ph-0 pv-10\"><div class=\"max-width-180\"><div class=\"heading\">Created On\n</div><div class=\"sub-heading text-truncate\" ng-if=\"vm.quote_result.result_data.created_on\" \ntitle=\"{{vm.quote_result.result_data.created_on | UTCToLocal : \'d MMM yyyy\'}}\">\n{{vm.quote_result.result_data.created_on | UTCToLocal : \'d MMM yyyy\'}}</div><span class=\"sub-heading\" \nng-if=\"!vm.quote_result.result_data.created_on\">N/A</span></div><div class=\"max-width-180\"><div class=\"heading\">\nSales Person <span class=\"creator\" ng-if=\"vm.quote_result.result_data.created_by.user_first_name\">Creator</span></div>\n<div class=\"text-truncate sub-heading\" ng-if=\"vm.quote_result.result_data.created_by.user_first_name\" \ntitle=\"{{vm.quote_result.result_data.created_by.user_first_name}} {{vm.quote_result.result_data.created_by.user_last_name}}\">\n{{vm.quote_result.result_data.created_by.user_first_name}} {{vm.quote_result.result_data.created_by.user_last_name}}\n</div><div class=\"sub-heading\" ng-if=\"!vm.quote_result.result_data.created_by.user_first_name\">N/A</div></div><div \nclass=\"max-width-180\"><div class=\"heading\">Customer</div><div class=\"sub-heading text-truncate\" \nng-if=\"vm.quote_result.result_data.created_for.user_first_name\" \ntitle=\"{{vm.quote_result.result_data.created_for.user_first_name}} {{vm.quote_result.result_data.created_for.user_last_name}}\">\n{{vm.quote_result.result_data.created_for.user_first_name}} {{vm.quote_result.result_data.created_for.user_last_name}} \n<span class=\"font-size-11\">{{vm.quote_result.result_data.created_for.company.company_name}}</span></div><div \nclass=\"sub-heading\" ng-if=\"!vm.quote_result.result_data.created_for.user_first_name\">N/A</div></div><div \nclass=\"max-width-180\"><div class=\"heading\">External Reference</div><div class=\"sub-heading text-truncate\" \nng-if=\"vm.quote_result.result_data.created_for.company.external_reference_id\" \ntitle=\"  {{vm.quote_result.result_data.created_for.company.external_reference_id}} \">\n{{vm.quote_result.result_data.created_for.company.external_reference_id}}</div><div class=\"sub-heading\" \nng-if=\"!vm.quote_result.result_data.created_for.company.external_reference_id\">N/A</div></div><div \nclass=\"max-width-220\"><div class=\"heading\">Address</div><div class=\"sub-heading text-truncate\" \nng-if=\"vm.quote_result.result_data.created_for.company.company_address\" \ntitle=\" {{vm.quote_result.result_data.created_for.company.company_address}}\">\n{{vm.quote_result.result_data.created_for.company.company_address}}</div><div class=\"sub-heading\" \nng-if=\"!vm.quote_result.result_data.created_for.company.company_address\">N/A</div></div><div class=\"max-width-180\"><div\n class=\"heading\">Inquiry No.</div><div class=\"sub-heading text-truncate md-link-fg\" \nng-if=\"vm.quote_result.result_data.inquiry_number\" ng-class=\"{\'pointer\' : !vm.util.isShipper && !vm.isShared}\" \nng-click=\"vm.viewInquiryDetails(vm.quote_result.result_data.inquiry_id)\">{{vm.quote_result.result_data.inquiry_number}}\n</div><div ng-if=\"!vm.quote_result.result_data.inquiry_number\" class=\"sub-heading\">N/A</div></div><div \nclass=\"max-width-180\"><div class=\"heading\">Search Reference</div><div class=\"sub-heading text-truncate\" \ntitle=\"{{ vm.search_param.search_name }}\">{{ vm.search_param.search_name ? vm.search_param.search_name : \'N/A\' }}</div>\n</div><div><div class=\"heading\">CC Email</div><div class=\"sub-heading text-truncate\">\n{{ vm.quote_result.result_data.cc_emails[0] ? vm.quote_result.result_data.cc_emails[0] :\'N/A\'}}<md-tooltip \nng-if=\"vm.quote_result.result_data.cc_emails.length\" md-direction=\"top\" class=\"font-size-12 tooltip-height\"><div \nng-repeat=\"ccMail in vm.quote_result.result_data.cc_emails\">{{ccMail}}</div></md-tooltip></div></div><div><div \nclass=\"heading\">Search Currency</div><div class=\"sub-heading\">\n{{ vm.quote_result.result_meta.search_param.search_currency ? vm.quote_result.result_meta.search_param.search_currency : vm.quote_result.result_meta.search_param.user.user_base_currency}}\n</div></div></div></md-card-content></md-card></div><div layout=\"column\" layout-wrap><div layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" layout-align=\"space-between center\" class=\"mb-5 ml-8 pv-8\"><div \nclass=\"font-size-16 mt-10\" layout=\"row\"><div><span class=\"total_quote_count ph-8\">{{vm.quote_CardData.length}}</span> \n<span class=\"font-weight-600\">Rates</span> Shared</div><div class=\"red-200-fg ml-15 font-size-14\" \nng-if=\"!vm.util.isWebView() && !vm.refreshRates && (vm.refreshQuoteId === vm.quote_result.result_data._id)\"><md-icon \nmd-font-icon=\"icon-block-helper\" class=\"s14 red-200-fg\"></md-icon>\nUnable to refresh the rate as the card has {{vm.quote_Status}}<span></span></div></div><div layout=\"row\" \nng-if=\"!vm.util.isEfpEnabled\"><div ng-if=\"vm.syncShimmer\"><div shimmer-effect-full width=\"140px\" height=\"40px\" \nclass=\"mt-4\"></div></div><div ng-if=\"vm.uiData.integrationStatus && !vm.syncShimmer\"><quote-sync-button \nintegrationoptions=\"vm.uiData.integrationComponentOptions\" quotemodify=\"vm.isQuoteModify && !vm.isDuplicateQuote\" \ncallback=\"vm.syncData(submenus  )\"></quote-sync-button></div><md-button md-no-ink \nng-click=\"vm.fnOpenRefreshRatesPopup($event)\" class=\"md-accent-btn with-icon\" ng-if=\"vm.refreshRates\" \nng-disabled=\"vm.newResultCard.length || vm.isQuoteModify || vm.rateCardSelection\"><md-icon class=\"s18 white-fg\" \nmd-font-icon=\"icon-refresh\"></md-icon><span class=\"font-size-12\"><b>Refresh Rates</b></span></md-button><md-button \nmd-no-ink ng-click=\"vm.editStandardQuotation()\" class=\"md-accent-btn with-icon\" ng-if=\"vm.standardQuoteBtn\" \nng-disabled=\" vm.rateCardSelection\"><md-icon class=\"s18 white-fg\" md-font-icon=\"icon-pencil\"></md-icon><span \nclass=\"font-size-12\"><b>Edit Standard Quotation</b></span></md-button></div></div><md-divider class=\"mh-10\">\n</md-divider><div layout=\"column\" \nng-if=\"vm.util.navPermission.quotes[2] && (!vm.quote_result.result_data.is_booked || vm.isDuplicateQuote ) && !vm.isShared && !vm.quote_result.result_data.revised && !vm.quotePreview && (!vm.isLost || vm.isDuplicateQuote)  && vm.search_param.freight_charges && !vm.standardQuoteBtn && !vm.util.isEfpEnabled\">\n<md-button class=\"new_Card_Btn mt-10\" layout-align=\"center center\" class=\"custom-rate-card rate_card mr-10 mb-5\" \nng-click=\"vm.fnAddOrEditCard(\'\', \'newCardQuote\', $event)\" ng-disabled=\"vm.rateCardSelection\">+ Add New Rate Card\n</md-button></div><div class=\"bg-535353 ph-40\" id=\"shared-footer-quote\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\" ng-if=\"vm.rateCardSelection\"><div layout=\"row\" layout-align=\"start center\" \nflex-xs=\"100\" flex-sm=\"50\" flex=\"40\" class=\"font-size-14 white-fg pv-5\"><b class=\"pr-5\">{{ vm.selectedSyncCard.length}}\n</b>Rate Card(s) Selected</div><div layout=\"row\" flex-xs=\"100\" flex-sm=\"100\" flex=\"25\" layout-align=\"end end\" \nclass=\"w-250\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"vm.rateCardSelection=false;vm.uiData.integrationComponentOptions.menu.isEnabled=true\">Cancel</md-button>\n<md-button md-no-ink class=\"md-accent-btn\" ng-disabled=\"vm.selectedSyncCard.length==0\" \nng-click=\"vm.fetchSyncData($event);vm.rateCardSelection=false\">Proceed</md-button></div></div><div flex=\"100\" \nlayout-wrap class=\"mv-10\"><div ng-repeat=\"card_item in vm.quote_CardData | orderBy:vm.sortBy track by $index\" \nng-show=\"vm.isActive ? vm.isActiveFunction(card_item) : true\"><div \nng-if=\"vm.newResultCard && vm.newResultCard.length && vm.newResultCard.length===$index\" class=\"old_card\">Old cards\n</div><div layout=\"row\" flex=\"100\"><div flex=\"10\" class=\"w-60 p-5\" ng-if=\"vm.rateCardSelection\" \nlayout-align=\"space-around center\"><md-checkbox md-no-ink ng-model=\"card_item.checked\" \nng-click=\"vm.toggleCheckbox($event,card_item)\" ng-change=\"vm.cardSelection(card_item)\"></md-checkbox></div>\n<card-list-result flex=\"100\" index=\"$index\" searchparam=\"vm.search_param\" carddata=\"card_item\" \nresultfilter=\"vm.resultCardFilter\" copyquoted=\"vm.copyquoted\" proceedduplicate=\"vm.proceedDuplicate\" \nshoweditbtn=\"vm.showEditBtn\" showbookbtn=\"vm.showBookBtn\" parent-page=\"\'quotes\'\" mixpanel-sorce=\"\'QD\'\" \nisquotemodify=\"vm.isQuoteModify\" quoteresult=\"vm.quote_result\" standardquote=\"vm.standardQuoteBtn\" \niscopyquote=\"vm.isDuplicateQuote\" ratecardselection=\"vm.rateCardSelection\" callback=\"vm.showQuoteProceedDiv(card)\">\n</card-list-result></div></div></div></div></div></div></div><div class=\"footer-content z-index-0\" ng-if=\"!vm.dataErr\">\n<div ng-if=\"vm.quote_result.result_data.is_booked && vm.quote_result.result_data.shipment_id\"><div layout=\"row\" \nflex=\"100\" class=\"ph-10 pv-0\" layout-align=\"center start\" layout-wrap><p class=\"pl-10 fb-black font-size-16\">\nThis quote has been converted to a Booking <span><a ng-if=\"!vm.isShared\" class=\"md-link-fg shipment_id pointer\" \nng-click=\"vm.goToShipmentDetail()\">{{ vm.quote_result.result_data.shipment_id }}</a></span></p></div></div><div \nng-if=\"vm.quote_result.result_data.revised\"><div layout=\"row\" flex=\"100\" class=\"ph-10 pv-0\" \nlayout-align=\"center start\" layout-wrap><p class=\"pl-10 fb-black font-size-18\">This quote has been revised.</p></div>\n</div><div id=\"shared-footer-quote\" ng-if=\"vm.showSharedFooter && !vm.quote_result.result_data.is_booked\" \nclass=\"shared-footer bg-535353\"><div class=\"footer\">\nThis window is currently in view only mode. If you want to edit this page, generate OTP by clicking <span \nng-click=\"vm.isClickEnable && vm.generateOtp()\" class=\"otp-click pl-5\">here</span></div></div><div \nng-if=\"vm.quote_result.result_data.is_booked && !vm.quote_result.result_data.shipment_id\"><div layout=\"row\" flex=\"100\" \nclass=\"ph-10 pv-0\" layout-align=\"center start\" layout-wrap><p class=\"pl-10 fb-black font-size-18\">\nThis quote has been manually converted to won and no Booking is created.</p></div></div></div><div \nng-show=\"vm.dataErr\" class=\"center-err\"><h1>Page not available!</h1></div><div id=\"shared-footer-quote\" flex=\"100\" \nlayout-wrap layout-align=\"space-between center\"><div layout=\"column\" flex-xs=\"100\" class=\"new_card_div\">\n<duplicate-quote-footer selectedduplicatecard=\"vm.selectedDuplicateCard\" isduplicatequote=\"vm.isDuplicateQuote\" \ncopyquoted=\"vm.copyquoted\" callback=\"vm.proceedCopyQuote(action, $event)\" linerdata=\"vm.linerData\">\n</duplicate-quote-footer></div></div><div class=\"bg-535353 ph-40\" id=\"shared-footer-quote\" layout=\"row\" flex=\"100\" \nlayout-wrap layout-align=\"space-between center\" ng-if=\"vm.isQuoteModify && !vm.isDuplicateQuote\"><div layout=\"row\" \nlayout-align=\"start center\" flex-xs=\"100\" flex-sm=\"50\" flex=\"40\" class=\"font-size-14 white-fg pv-5\"><b class=\"pr-5\">\nQuote #{{ vm.quote_result.result_data.quote_id }}</b> has been modified</div><div layout=\"row\" flex-xs=\"100\" \nflex-sm=\"50\" flex=\"35\" layout-align=\" start center\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"font-weight-600 grey-600-fg white-fg pr-20\"><div layout=\"row\" class=\"mr-5 white-fg font-size-14\">Revision :\n</div><div class=\"pr-20 pl-10 font-size-13\">No</div><md-switch md-no-ink id=\"revise-toggle\" ng-model=\"vm.revise_quote\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-switch><div class=\"pl-20 font-size-13\">Yes</div></div><div layout=\"column\" \nclass=\"font-weight-600 pl-20 version-box\" ng-show=\"vm.revise_quote\"><div flex layout-align=\"start center\" \nclass=\"mr-5 white-fg font-size-14\">After Revision</div><div flex layout-align=\"start center\" class=\"mr-5 font-size-16\">\n<span class=\"fb-979797\">v{{vm.getQuoteVersion(vm.quote_result.result_data.quote_id)}} ----</span> <span \nclass=\"white-fg\">v{{vm.nextVersionChar(vm.getQuoteVersion(vm.quote_result.result_data.quote_id))}}</span></div></div>\n</div><div layout=\"row\" flex-xs=\"100\" flex-sm=\"100\" flex=\"25\" layout-align=\"end end\" class=\"w-250\"><md-button \nmd-no-ink class=\"md-primary-btn\" ng-disabled=\"vm.modifyBtn\" ng-click=\"vm.fnUndoChanges();\">Cancel</md-button><md-button\n md-no-ink class=\"md-accent-btn\" ng-disabled=\"vm.modifyBtn\" ng-click=\"vm.fnQuoteModify()\">Apply</md-button></div></div>");
$templateCache.put("app/main/quotes/quotesDetails/quote-new-card.html","<ms-widget flippable=\"true\" layout=\"column\" flex class=\"custom-rate-front w-250\" \nng-class=\"{\'mr-20\' : !vm.util.isMobileDevice}\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"custom-rate-front dotted-border\"><div layout=\"column\" layout-align=\"center center\" class=\"margin-auto\"><md-icon \nclass=\"custom-add-icon pointer\" ng-click=\"vm.fnAddOrEditCard(\'\', \'newCardQuote\', $event)\" \nmd-font-icon=\"icon-plus-circle-outline\n            \"></md-icon><p class=\"add-rates\"><span>Add </span><span \nclass=\"font-weight-600\">RATES</span></p></div></ms-widget-front><ms-widget-back><div class=\"custom-add-back white-bg\">\n<div layout=\"row\" flex=\"100\" class=\"white-bg fg-333333\"><div class=\"font-size-16 p-10\" flex=\"80\">ADD <b>NEW</b> RATE\n</div><div layout=\"row\" flex=\"20\" layout-align=\"end center\"><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></md-button>\n</div></div><div layout=\"column\" flex=\"100\" class=\"mb-5 ph-10\"><div flex=\"50\" class=\"fg-333333\" layout=\"row\" \nlayout-align=\"start center\">Liner Name <span class=\"red-fg\">*</span></div><div flex=\"50\"><div ng-if=\"!vm.addCardData\" \nclass=\"loader\" style=\"margin-top: 12px !important; margin-right: 20px\"></div><md-input-container \nng-if=\"vm.addCardData\" class=\"sort_input m-0 w-200\" md-no-float><md-select class=\"input-search\" \nng-if=\"vm.search_param.mode != \'AIR\'\" ng-model=\"vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.sub_vendor_id\" \nname=\"sub_vendor_id\" placeholder=\"Select Liner Name\" \nng-change=\"vm.fngetSubVendorDetails(vm.quoteNewCard.meta, vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj)\" \nmd-on-close=\"searchLiner = \'\'\"><md-select-header><input ng-model=\"searchLiner\" type=\"search\" \nplaceholder=\"Search Liner\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"subvendor in vm.getSubvendor | orderBy:\'name\' | filter : {\'name\':searchLiner}\" ng-value=\"subvendor.id\" \ntitle=\"{{subvendor.name}}\">{{subvendor.name}}</md-option></md-select><md-select class=\"input-search\" \nng-if=\"vm.search_param.mode == \'AIR\'\" ng-model=\"vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.airline_code\" \nname=\"airline_code\" placeholder=\"Select Airline Name\" \nng-change=\"vm.fngetSubVendorDetails(vm.quoteNewCard.meta,vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj)\" \nmd-on-close=\"search_airline_liner = \'\'\"><md-select-header><input ng-model=\"search_airline_liner\" type=\"search\" \nplaceholder=\"Search Airline Name (IATA Code / Airline Prefix Code)\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"airline in vm.getAirline | orderBy:\'air_line_name\' | multipleKey :search_airline_liner:{air_line_name:\'air_line_name\',airline_prefix:\'airline_prefix\',iata_code:\'iata_code\'}\" \nng-value=\"airline.airline_code\" title=\"{{airline.air_line_name}}\">\n{{airline.air_line_name}} ({{airline.iata_code ? airline.iata_code : \'-\'}} / {{airline.airline_prefix ? airline.airline_prefix : \'-\'}})\n</md-option></md-select></md-input-container></div></div><div flex=\"100\" class=\"mr-10 ph-10 mb-5\"><div flex=\"50\" \nclass=\"fg-333333\" layout=\"row\" layout-align=\"start center\">Expiry Date <span class=\"red-fg\">*</span></div><div \nflex=\"50\" class=\"w-200\"><date-picker is-editable=\"true\" is-disabled=\"false\" input-required=\"true\" \ndate-placeholder=\"\'Expiry Date\'\" date-format=\"true\" full-border=\"true\" max-date-value=\"ctrl.parent.expiryEdit\" \nmin-date-value=\"vm.expMaxDate\" model-value=\"vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry\" \ncallback=\"vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.expiry=value\"></date-picker></div></div><div \nlayout=\"column\" flex=\"100\" class=\"ph-10 mb-5\"><div flex=\"50\" class=\"fg-333333\" layout=\"row\" \nlayout-align=\"start center\">Port of {{ vm.quoteNewCard.meta.port_data.is_icd_port_origin ? \'Origin\' : \'Loading\'}} <span\n class=\"red-fg\">*</span></div><div flex=\"50\"><md-autocomplete required md-input-name=\"card_origin_wet_port\" \nmd-selected-item=\"vm.quoteNewCard.meta.port_data.origin_port_code\" md-search-text=\"vm.card_originWetPortSearchText\" \nmd-items=\"item in vm.getPort(vm.card_originWetPortSearchText,vm.search_param.mode, \'origin\')\" \nmd-item-text=\"item.portcode_portname\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Select {{ vm.quoteNewCard.meta.port_data.is_icd_port_origin ? \'Origin\' : \'Loading\'}} Port\" \nmd-menu-class=\"autocomplete-custom-template\" class=\"input-search\"><md-item-template><span \nclass=\"item-metadata template\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{vm.card_originWetPortSearchText}}\" were found.</md-not-found><div \nng-messages=\"card_origin_wet_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></div></div><div layout=\"column\" flex=\"100\" class=\"ph-10 mb-5\" \nng-if=\"vm.search_param.mode == \'SEA-FCL\' && vm.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" \nclass=\"fg-333333\" layout=\"row\" layout-align=\"start center\">Mode of Origin Haulage<span class=\"red-fg\">*</span></div>\n<div flex=\"50\" layout=\"row\"><md-select class=\"input-search w-200 m-0\" ng-model=\"vm.quoteNewCard.meta.haulage\" \nname=\"haulage\" placeholder=\"Select Origin Haulage\"><md-option ng-repeat=\"haulage in vm.util.haulageList\" \nng-value=\"haulage\">{{haulage}}</md-option></md-select></div></div><div layout=\"column\" flex=\"100\" \nclass=\"ph-10 mv-10 mb-5\" ng-if=\"vm.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" class=\"fg-333333\" \nlayout=\"row\" layout-align=\"start center\">Port of Loading<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\"><md-autocomplete required md-input-name=\"card_origin_port\" \nmd-selected-item=\"vm.quoteNewCard.meta.via_pol\" md-search-text=\"vm.card_originSearchText\" \nmd-items=\"item in vm.getPort(vm.card_originSearchText,vm.search_param.mode, \'origin\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Select Loading Port\" md-menu-class=\"autocomplete-custom-template\" class=\"input-search bb\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{vm.card_originSearchText}}\" were found.</md-not-found><div ng-messages=\"card_origin_port.$error\">\n<div ng-message=\"required\">This field is required</div></div></md-autocomplete></div></div><div layout=\"column\" \nflex=\"100\" class=\"ph-10 mb-5\" ng-if=\"vm.quoteNewCard.meta.port_data.is_icd_port_destination\"><div flex=\"50\" \nclass=\"fg-333333\" layout=\"row\" layout-align=\"start center\">Port of Discharge<span class=\"red-fg\">*</span></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end end\"><md-autocomplete required md-input-name=\"card_destination_port\" \nmd-selected-item=\"vm.quoteNewCard.meta.via_pod\" md-search-text=\"vm.card_destinationSearchText\" \nmd-items=\"item in vm.getPort(vm.card_destinationSearchText,vm.search_param.mode, \'destination\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Select Discharge Port\" md-menu-class=\"autocomplete-custom-template\" class=\"bb input-search\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{vm.card_destinationSearchText}}\" were found.</md-not-found><div \nng-messages=\"cardSearchForm.card_destination_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></div></div><div layout=\"column\" flex=\"100\" class=\"ph-10 mb-5\" \nng-if=\"vm.search_param.mode == \'SEA-FCL\' && vm.quoteNewCard.meta.port_data.is_icd_port_destination\"><div flex=\"50\" \nclass=\"fg-333333\" layout=\"row\" layout-align=\"start center\">Mode of Destination Haulage<span class=\"red-fg\">*</span>\n</div><div flex=\"50\" layout=\"row\"><md-select class=\"input-search w-200 m-0\" \nng-model=\"vm.quoteNewCard.meta.destination_haulage\" name=\"haulage\" placeholder=\"Select Destination Haulage\"><md-option \nng-repeat=\"haulage in vm.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></div></div><div \nlayout=\"column\" flex=\"100\" class=\"ph-10 mb-5\"><div flex=\"50\" class=\"fg-333333\" layout=\"row\" \nlayout-align=\"start center\">\nPort of {{ vm.quoteNewCard.meta.port_data.is_icd_port_destination ? \'Destination\' : \'Discharge\'}} <span class=\"red-fg\">\n*</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-autocomplete required \nmd-input-name=\"card_destination_wet_port\" md-selected-item=\"vm.quoteNewCard.meta.port_data.destination_port_code\" \nmd-search-text=\"vm.card_destinationWetSearchText\" \nmd-items=\"item in vm.getPort(vm.card_destinationWetSearchText,vm.search_param.mode, \'destination\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Select {{ vm.quoteNewCard.meta.port_data.is_icd_port_destination ? \'Destination\' : \'Discharge\'}} Port\" \nmd-menu-class=\"autocomplete-custom-template\" class=\"bb input-search\"><md-item-template><span class=\"item-metadata\">\n{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{vm.card_destinationWetSearchText}}\" were found.</md-not-found><div \nng-messages=\"cardSearchForm.card_destination_wet_port.$error\"><div ng-message=\"required\">This field is required</div>\n</div></md-autocomplete></div></div><div layout=\"column\" flex=\"100\" class=\"mt-8 ph-10 mb-5\"><div flex=\"50\" \nlayout=\"row\" class=\"fg-333333\" layout-align=\"start center\">Rates By</div><div flex=\"50\" \nclass=\"input-search grey-200-bg w-200 pr-20\">{{vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.vendor.vendor_name}}\n</div></div><div layout=\"column\" flex=\"100\" class=\"mb-5\"><div flex=\"50\" class=\"fg-333333 pl-10\" layout=\"row\" \nlayout-align=\"start center\">Service Type</div><div flex=\"50\" class=\"ph-10\"><md-input-container \nclass=\"input-search w-200 m-0\" md-no-float><input \nng-model=\"vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.service_type\" placeholder=\"Service Type\">\n</md-input-container></div></div><div layout=\"column\" flex=\"100\" class=\"mb-5 ph-10\"><div flex=\"50\" \nclass=\"fg-333333 pl-5\" layout=\"row\" layout-align=\"start center\">Cargo Type</div><div flex=\"50\"><md-input-container \nclass=\"w-200 input-search m-0\" md-no-float><cargo-type-selection \ncargo-type-data=\"vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.cargo_type_data\" is-required=\"false\" \nis-valid=\"false\" mode=\"vm.search_param.mode\"></cargo-type-selection></md-input-container></div></div><div \nlayout=\"column\" flex=\"100\" class=\"mb-5\"><div flex=\"50\" class=\"fg-333333 pl-10\" layout=\"row\" \nlayout-align=\"start center\">Commodity</div><div flex=\"50\" class=\"ph-10\"><md-input-container \nclass=\"w-100p mv-0 commodity_input\" md-no-float><commodity-chips md-input-id=\"\'commodity_id_new-card\'\" \ncommodity-array=\"vm.quoteNewCard.data.sell_rates[vm.l3_leg].rate_obj.commodity_data\" full-border=\"true\" \nis-valid=\"false\"></commodity-chips></md-input-container></div></div><div layout=\"column\" flex=\"100\" class=\"p-10\" \nng-if=\"!vm.sell_rates_display\"><md-button md-no-ink class=\"md-link-btn\" flex=\"100\" \nng-click=\"vm.viewDetailsModal(vm.quoteNewCard,$event,\'addNewQuote\',\'msr_rates\')\">Add Rates</md-button></div><div \nlayout=\"column\" layout-wrap class=\"pv-10 mt-10\" ng-if=\"vm.sell_rates_display\"><div class=\"font-size-14\" layout=\"row\" \nlayout-align=\"center center\" flex-gt-xs=\"60\">Total Cost <sup \nng-if=\"vm.showAsterix(vm.quoteNewCard.data[vm.buyOrSell])\">**</sup><md-tooltip \nng-if=\"vm.showAsterix(vm.quoteNewCard.data[vm.buyOrSell])\" md-direction=\"right\" class=\"font-size-10\">\nInclusive of fixed charges only</md-tooltip></div><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"font-size-14 font-weight-600\" layout=\"row\"><span class=\"text-truncate\">\n{{ vm.searchUser.user_base_currency + \' \' + ( vm.quoteNewCard.meta.card_total_cost | currencyMask: 2 ) }}<md-tooltip \nmd-direction=\"top\" class=\"font-size-10\">\n{{ vm.searchUser.user_base_currency + \' \' + ( vm.quoteNewCard.meta.card_total_cost | currencyMask: 2 ) }}</md-tooltip>\n</span></div><div layout=\"row\"><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer quote-newCard-{{vm.quoteNewCard._id}}\" \nng-click=\"vm.showCostBreakdown(vm.quoteNewCard, $event)\"></md-icon></div></div></div><div \nng-show=\"vm.search_param.mode !=\'AIR\'\"><div layout=\"column\" flex=\"100\" class=\"p-10\" ng-if=\"!vm.schedule_display\">\n<md-button md-no-ink class=\"md-link-btn\" flex=\"100\" \nng-click=\"vm.viewDetailsModal(vm.quoteNewCard,$event,\'schedule\',\'msr_rates\')\">Add Schedule</md-button></div><div \nng-if=\"vm.schedule_display\"><md-divider \nng-if=\"vm.search_param.mode !=\'AIR\' && !vm.quoteNewCard.meta.selected_schedule\"></md-divider><div layout=\"row\" \nlayout-wrap class=\"pv-8\" ng-if=\"vm.quoteNewCard.meta.selected_schedule && vm.l3_leg != \'l3_air\'\"><div \nclass=\"font-size-14\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\"><span \nclass=\"ph-15 text-truncate\"><md-icon md-svg-src=\"assets/icons/custom/shipping-details-icon.svg\" class=\"icon-class\" \ntitle=\"Routing\"></md-icon><span>\n{{vm.quoteNewCard.meta.selected_schedule.via_port != \'\' ? vm.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{vm.quoteNewCard.meta.selected_schedule.via_port != \'\' ? vm.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n</md-tooltip></span></span></div><div class=\"pr-15 font-size-14\" layout=\"row\" layout-align=\"end center\" flex=\"40\" \nflex-gt-xs=\"40\"><span class=\"text-truncate\"><md-icon md-svg-src=\"assets/icons/custom/valid-icon.svg\" \nclass=\"icon-class\" title=\"Transit Time\"></md-icon>\n{{ vm.quoteNewCard.meta.selected_schedule.transit_time != \'\' ? vm.quoteNewCard.meta.selected_schedule.transit_time : \'N/A\' }}\n</span></div></div><div layout=\"row\" layout-wrap class=\"pv-8\" \nng-if=\"vm.quoteNewCard.meta.selected_schedule && vm.l3_leg != \'l3_air\'\"><div class=\"pl-15 font-size-14 text-truncate\" \nlayout=\"row\" layout-align=\"start center\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"font-size-14\">Next sailing on</span>\n</div><div class=\"font-size-14\" layout=\"row\" layout-align=\"end center\" flex=\"60\" flex-gt-xs=\"60\"><span \ntitle=\"Departure Time\" class=\"pr-15 text-truncate\">\n{{vm.quoteNewCard.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy\'}}</span></div></div><div \nlayout=\"row\" ng-show=\"vm.getData\" layout-wrap ng-if=\"!vm.quoteNewCard.meta.selected_schedule && vm.l3_leg != \'l3_air\'\">\n<div class=\"pl-15 font-size-16 text-truncate\" layout=\"row\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"100\"><p \ntitle=\"Schedule not available\" ng-if=\"!vm.quoteNewCard.meta.selected_schedule\" class=\"grey-fg mv-4\">\nSchedule not available.</p></div></div><md-divider \nng-if=\"vm.search_param.mode !=\'AIR\' && !vm.quoteNewCard.meta.selected_schedule\"></md-divider></div></div><div \nlayout=\"column\" layout-wrap ng-if=\"vm.quoteNewCard.meta.is_selected\"><div layout=\"row\" layout-align=\"center center\" \nflex-gt-xs=\"50\" class=\"font-size-14 pv-10\"><md-button class=\"md-primary-btn w-200 card_box_shadow\" \nng-disabled=\"!vm.quoteNewCard.meta.is_selected\" \nng-click=\"vm.viewDetailsModal(vm.quoteNewCard,$event,\'addNewQuote\',\'msr_rates\')\" title=\"View details\">DETAILS\n</md-button></div><div layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"50\" \nclass=\"font-size-14 font-weight-600 pv-10\"><md-button class=\"md-accent-btn w-200\" \nng-disabled=\"!vm.quoteNewCard.meta.is_selected\" ng-click=\"vm.addInQuote(vm.quoteNewCard,\'newCard\');flipWidget()\" \ntitle=\"Remove\">DONE</md-button></div></div></div></ms-widget-back></ms-widget>");
$templateCache.put("app/main/quote-list/quote-details/quote-details.html","<div class=\"quote-details\"></div><iframe resize-handler id=\"quote-details-iframe\" name=\"{{vm.todaysDate}}\" \nng-style=\"vm.minHeight\" width=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe>");
$templateCache.put("app/main/result/bookShipment/bookShipmentFcl.html","<div id=\"book-shipment-fcl-new\"><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" class=\"custom_scroll\"><div \nlayout=\"column\" flex flex-sm=\"100\" flex-xs=\"100\" class=\"bg-white-mobile\"><div \nclass=\"black-500-fg pv-15 ph-20 layout-card\" flex=\"100\"><div class=\"font-size-16 text-uppercase mb-20 w-270\" \nlayout=\"row\"><md-icon ng-click=\"vm.goBack()\" md-font-icon=\"icon-arrow-left\" class=\"s26 mb-5 back-icon\"></md-icon><div \nclass=\"pt-3 w-200\"><span class=\"ml-30 Font-Bold\">booking</span> details</div><div \nclass=\"page-label ml-10 h-25 Font-Bold\" hide-xs>{{vm.booking_data.search_param.mode}}</div></div><div layout=\"row\" \nlayout-align=\"space-between\" class=\"font-size-22 Font-Bold p-10\" flex=\"100\" hide-gt-xs><div \nng-if=\"vm.booking_data.search_param.mode != \'AIR\' && !vm.maskLiner\"><img class=\"comp_logo\" \nng-if=\"vm.bookingRates[0].sub_vendor.logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.bookingRates[0].sub_vendor.logo)}}\" \nalt=\"{{ vm.bookingRates[0].sub_vendor.sub_vendor_name }}\"> <span ng-if=\"!vm.bookingRates[0].sub_vendor.logo\" \nclass=\"text-truncate\">{{vm.bookingRates[0].sub_vendor.sub_vendor_name}}</span><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.bookingRates[0].sub_vendor.sub_vendor_name }}</md-tooltip></div><div \nng-if=\"vm.booking_data.search_param.mode == \'AIR\' && !vm.maskLiner\"><span class=\"text-truncate\">\n{{vm.bookingRates[0].airline.air_line_name}}</span><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.bookingRates[0].airline.air_line_name }}</md-tooltip></div><div \nng-if=\"vm.booking_data.search_param.mode != \'AIR\' && vm.maskLiner\"><div \nng-if=\"vm.maskv2 && vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code]\"><div \nng-if=\"vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo\"><img class=\"list_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo)}}\" \nalt=\"{{vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name}}\"></div><div class=\"empty_logo text-truncate\" \ntitle=\"{{vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name}}\" \nng-if=\"!vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo && vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name\">\n{{vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name}}<md-tooltip md-direction=\"top\">\n{{vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name}}</md-tooltip></div></div><div \nclass=\"empty_logo text-truncate\" \nng-if=\"!vm.maskv2[vm.bookingRates[0].sub_vendor.sub_vendor.carrier_code].name && $vm.maskLinerText\"><span \nclass=\"text-truncate\">{{vm.maskLinerText }}<md-tooltip md-direction=\"top\">{{vm.maskLinerText}}</md-tooltip></span>\n</div><div class=\"empty_logo text-truncate\" \nng-if=\"!$vm.maskLinerText && !vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code]\"><div \nng-if=\"vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo\"><img class=\"list_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo)}}\" \nalt=\"{{vm.bookingRates[0].sub_vendor.sub_vendor_name}}\"></div><div class=\"empty_logo text-truncate\" \nng-if=\"!vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo\" layout-align=\"space-around center\">\n{{vm.bookingRates[0].sub_vendor.sub_vendor_name}}<md-tooltip md-direction=\"top\">\n{{vm.bookingRates[0].sub_vendor.sub_vendor_name}}</md-tooltip></div></div></div><div \nng-if=\"vm.booking_data.search_param.mode == \'AIR\' && vm.maskLiner\"><div \nng-if=\"vm.maskAirline && vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code]\"><div \nng-if=\"vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code].logo\"><img class=\"list_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code].logo)}}\" \nalt=\"{{vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code].name}}\"></div><div class=\"empty_logo text-truncate\" \ntitle=\"{{vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code].name}}\" \nng-if=\"!vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code].logo && vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code].name\">\n{{vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code].name}}</div></div><div class=\"empty_logo text-truncate\" \nng-if=\"!vm.maskAirline[vm.bookingRates[0].sub_vendor.sub_vendor.airline_code].name && $vm.maskLinerText\"><span \nclass=\"text-truncate\">{{vm.maskLinerText }}<md-tooltip md-direction=\"top\">{{vm.maskLinerText}}</md-tooltip></span>\n</div><div class=\"empty_logo text-truncate\" \nng-if=\"!$vm.maskLinerText && !vm.maskAirline[vm.bookingRates[0].sub_vendor.airline_code]\"><div \nclass=\"empty_logo text-truncate\" ng-if=\"vm.bookingRates[0].airline.air_line_name\" layout-align=\"space-around center\">\n{{vm.bookingRates[0].airline.air_line_name}}<md-tooltip md-direction=\"top\">{{vm.bookingRates[0].airline.air_line_name}}\n</md-tooltip></div></div></div><div><span class=\"page-label font-size-14\">{{vm.booking_data.search_param.mode}}</span>\n</div></div><md-divider class=\"mt-15 mb-20\" hide-gt-xs></md-divider><div layout=\"row\" layout-xs=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"row\" layout-align=\"start center\" class=\"font-size-24 xs-bot-space Font-Bold\" flex=\"15\" \nflex-xs=\"100\" hide-xs ng-if=\"vm.booking_data.search_param.mode != \'AIR\' && !vm.maskLiner \"><img class=\"comp_logo\" \nng-if=\"vm.bookingRates[0].sub_vendor.logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.bookingRates[0].sub_vendor.logo)}}\" \nalt=\"{{ vm.bookingRates[0].sub_vendor.sub_vendor_name }}\"> <span ng-if=\"!vm.bookingRates[0].sub_vendor.logo\" \nclass=\"text-truncate\">{{vm.bookingRates[0].sub_vendor.sub_vendor_name}}</span><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.bookingRates[0].sub_vendor.sub_vendor_name }}</md-tooltip></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-size-24 xs-bot-space Font-Bold\" flex=\"15\" flex-xs=\"100\" hide-xs \nng-if=\"vm.booking_data.search_param.mode == \'AIR\' && !vm.maskLiner\"><span class=\"text-truncate\">\n{{vm.bookingRates[0].airline.air_line_name}}</span><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.bookingRates[0].airline.air_line_name }}</md-tooltip></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-size-24 xs-bot-space Font-Bold\" flex=\"15\" flex-xs=\"100\" hide-xs ng-if=\"vm.maskLiner\"><div \nng-if=\"vm.maskv2 && vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code]\"><div \nng-if=\"vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo\"><img class=\"list_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo)}}\" \nalt=\"{{vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name}}\"></div><div class=\"text-truncate\" \ntitle=\"{{vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name ?  vm.maskv2[vm.bookingRates[0].sub_vendor.sub_vendor.carrier_code].name: vm.maskLinerText}}\" \nng-if=\"!vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].logo\">\n{{vm.maskv2[vm.bookingRates[0].sub_vendor.carrier_code].name ? vm.maskv2[vm.bookingRates[0].sub_vendor.sub_vendor.carrier_code].name: vm.maskLinerText}}\n</div></div><div class=\"empty_logo text-truncate\" \nng-if=\"!vm.maskv2[vm.bookingRates[0].sub_vendor.sub_vendor.carrier_code]\"><span class=\"text-truncate\">\n{{vm.maskLinerText }}<md-tooltip md-direction=\"top\">{{vm.maskLinerText}}</md-tooltip></span></div></div><div \nclass=\"pl-10 xs-bot-space\" flex=\"20\" flex-xs=\"50\"><div \nclass=\"font-size-12 xs-font-10 text-uppercase grey-500-fg Font-Bold\">origin</div><div \nclass=\"font-size-22 xs-font-20 Font-Bold text-truncate\">{{ vm.booking_data.search_param.origin_location.location }}\n<md-tooltip md-direction=\"top\" class=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" \nstyle=\"display:table;opacity:1\">{{ vm.booking_data.search_param.origin_location.location }}</md-tooltip></div><div \nclass=\"font-size-10 xs-font-10 text-uppercase black-500-fg text-truncate Font-Bold\">\n{{ vm.booking_data.search_param.origin_location.location_string }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.booking_data.search_param.origin_location.location_string }}</md-tooltip></div></div><div \nclass=\"pl-10 pr-5 xs-bot-space xs-destination\" flex=\"20\" flex-xs=\"50\"><div \nclass=\"font-size-12 xs-font-10 text-uppercase grey-500-fg Font-Bold\">destination</div><div \nclass=\"font-size-22 xs-font-20 Font-Bold text-truncate\">\n{{ vm.booking_data.search_param.destination_location.location }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.booking_data.search_param.destination_location.location }}</md-tooltip></div><div \nclass=\"font-size-10 xs-font-10 text-uppercase black-500-fg text-truncate Font-Bold\">\n{{ vm.booking_data.search_param.destination_location.location_string }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.booking_data.search_param.destination_location.location_string }}</md-tooltip></div></div><div \nclass=\"border-left pl-20 xs-bot-space xs-via\" flex=\"25\" flex-xs=\"50\" layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.booking_data.card_item.meta.via_pol || vm.booking_data.card_item.meta.via_pod\"><div layout=\"column\" \nflex=\"50\" class=\"pr-10\"><span class=\"font-size-12 xs-font-12 grey-500-fg Font-Bold pv-2\" \nng-if=\"vm.booking_data.card_item.meta.via_pol\">Port of Loading</span> <span \nclass=\"font-size-12 xs-font-12 grey-500-fg Font-Bold pv-2\" ng-if=\"vm.booking_data.card_item.meta.via_pod\">\nPort of Discharge</span></div><div layout=\"column\" flex=\"50\"><span ng-if=\"vm.booking_data.card_item.meta.via_pol\"><span\n class=\"font-size-14 xs-font-12 black-500-fg Font-Bold text-truncate pv-2 text-truncate\" \nng-if=\"vm.booking_data.card_item.meta.via_pol\">{{ vm.booking_data.card_item.meta.via_pol }} </span><span \nclass=\"font-size-14 xs-font-12 grey-400-fg Font-Bold text-truncate pv-2\" \nng-if=\"!vm.booking_data.card_item.meta.via_pol\">N/A </span></span><span ng-if=\"vm.booking_data.card_item.meta.via_pod\">\n<span class=\"font-size-14 xs-font-12 black-500-fg Font-Bold pv-2 text-truncate\" \nng-if=\"vm.booking_data.card_item.meta.via_pod\">{{ vm.booking_data.card_item.meta.via_pod }} </span><span \nclass=\"font-size-14 xs-font-12 grey-400-fg Font-Bold pv-2\" ng-if=\"!vm.booking_data.card_item.meta.via_pod\">N/A</span>\n</span></div></div><div class=\"border-left pl-20 xs-bot-space xs-via\" flex=\"20\" flex-xs=\"50\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"column\" flex=\"50\" class=\"pr-10\"><span \nclass=\"font-size-12 xs-font-12 grey-500-fg Font-Bold pv-2\">via Port</span> <span \nclass=\"font-size-12 xs-font-12 grey-500-fg Font-Bold pv-2\">Transit Time</span> <span \nclass=\"font-size-12 xs-font-12 grey-500-fg Font-Bold pv-2\" \nng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\' && vm.booking_data.card_item.meta.via_pol || vm.booking_data.card_item.meta.via_pod\">\nHaulage Mode</span></div><div layout=\"column\" flex=\"50\"><span \nclass=\"font-size-14 xs-font-12 black-500-fg Font-Bold text-truncate pv-2\" \nng-if=\"vm.booking_data.card_item.meta.selected_schedule\">\n{{ vm.booking_data.card_item.meta.selected_schedule.via_port }} </span><span \nclass=\"font-size-14 xs-font-12 grey-400-fg Font-Bold text-truncate pv-2\" \nng-if=\"vm.booking_data.search_param.mode == \'AIR\' ||!vm.booking_data.card_item.meta.selected_schedule\">\n{{ !vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.via_route ? \'N/A\' : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.via_route }} \n</span><span class=\"font-size-14 xs-font-12 black-500-fg Font-Bold pv-2 text-truncate\" \nng-if=\"vm.booking_data.card_item.meta.selected_schedule\">\n{{ vm.booking_data.card_item.meta.selected_schedule.transit_time }}<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.booking_data.card_item.meta.selected_schedule.transit_time }}</md-tooltip></span><span \nclass=\"font-size-14 xs-font-12 grey-400-fg Font-Bold pv-2 text-truncate\" \nng-if=\"vm.booking_data.search_param.mode == \'AIR\' || !vm.booking_data.card_item.meta.selected_schedule\">\n{{vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time ? vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time : \'N/A\'}}\n<md-tooltip md-direction=\"top\" class=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" \nstyle=\"display:table;opacity:1\">\n{{vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time ? vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time : \'N/A\'}}\n</md-tooltip></span><span \nng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\' && vm.booking_data.card_item.meta.via_pol || vm.booking_data.card_item.meta.via_pod\">\n<span class=\"font-size-14 xs-font-12 black-500-fg Font-Bold pv-2 text-truncate\" \nng-if=\"vm.booking_data.card_item.meta.haulage\">{{ vm.booking_data.card_item.meta.haulage }} </span><span \nclass=\"font-size-14 xs-font-12 grey-400-fg bold pv-2\" ng-if=\"!vm.booking_data.card_item.meta.haulage\">N/A</span></span>\n</div></div></div><md-divider class=\"mt-20 mb-10\" hide-xs></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" hide-xs><div ng-class=\"{\'w-160\' : vm.booking_data.search_param.mode == \'SEA-LCL\'}\">\n<span class=\"font-size-14 text-uppercase pr-20\" ng-class=\"{\'border-right\' : !vm.hideEditBtn}\"><span class=\"Font-Bold\">\nload</span> details</span> <span ng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\'\" \nng-repeat=\"loadDetail in vm.booking_data.search_param.load_data.load_details_value\"><span \nclass=\"font-size-14 pl-20 grey-500-fg Font-Bold\" ng-if=\"!vm.hideEditBtn\">{{loadDetail.type }} x {{loadDetail.qty}}\n</span> </span><span ng-if=\"vm.booking_data.search_param.mode == \'AIR\'\"><span \nclass=\"font-size-14 pl-20 grey-500-fg Font-Bold\">\n{{ vm.formContainerType(vm.booking_data.search_param.mode,vm.booking_data.search_param.load_data ) }}</span></span>\n</div><div layout=\"row\" layout-align=\"start center\" layout-wrap flex=\"100\" \nng-if=\"vm.booking_data.search_param.mode == \'SEA-LCL\'\"><div layout=\"column\" ng-repeat=\"loadDetail in vm.lclLoadArray\" \nng-if=\"loadDetail.value != \'N/A\'\" class=\"w-190 mb-10\"><div class=\"load_name\">{{ loadDetail.name }} :</div><div \nclass=\"load_value\">{{ loadDetail.value }}</div></div></div><div \nclass=\"font-size-12 md-link-fg with-icon Font-Bold pointer\" ng-click=\"vm.collapseIt($event)\" \nng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\' && (!vm.hideEditBtn || vm.isShared)\"><span ng-if=\"!vm.isShared\">\nEDIT </span>LOAD DETAILS<md-icon md-font-icon=\"icon-chevron-down s24 mb-5\"></md-icon></div></div><div id=\"edit-load\" \nng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\'\" layout=\"column\" layout-align=\"center center\" \nclass=\"hide-at-start pt-5 Font-Bold\"><div layout=\"row\" class=\"font-size-14 grey-500-fg Font-Bold pv-10 text-uppercase\" \nlayout-wrap><div flex=\"15\" flex-sm=\"20\" flex-md=\"20\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"font-size-12\">load type</div></div><div flex=\"10\" flex-sm=\"10\" flex-md=\"10\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-12\">qty</div></div><div flex=\"25\" flex-sm=\"35\" flex-md=\"35\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"font-size-12\">total shipment volume</div></div><div flex=\"25\" \nflex-sm=\"35\" flex-md=\"35\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-12\">total shipment weight\n</div></div></div><form name=\"loadSubmit\" ng-submit=\"vm.fnSaveLoadQty($event)\" class=\"nwls-load-div\"><div layout=\"row\" \nclass=\"font-size-14 grey-500-fg Font-Bold pv-10 text-uppercase load_scroll\" layout-wrap \nng-repeat=\"loadDetail in vm.booking_data.search_param.load_data.load_details_value\" ng-class=\"{\'mb-20\' : !$last}\"><div \nflex=\"15\" flex-sm=\"20\" flex-md=\"20\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"black-500-fg font-size-20 Font-Bold mt-4\">{{ loadDetail.type }}</div></div><div flex=\"10\" flex-sm=\"10\" \nflex-md=\"10\" layout=\"column\" layout-align=\"start center\"><div class=\"black-500-fg font-size-18 Font-Bold\">\n<md-input-container md-no-float class=\"input_box mv-0 input_container_width load-input-container\" ng-if=\"!vm.isShared\">\n<input class=\"load-input\" placeholder=\"Qty\" type=\"number\" restrict-to=\"[0-9]\" min=\"1\" max=\"100\" \nng-model=\"loadDetail.qty\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.fnChangeQty(loadDetail)\">\n</md-input-container><div ng-if=\"vm.isShared\">{{ loadDetail.qty }}</div></div></div><div flex=\"50\" flex-sm=\"70\" \nflex-md=\"70\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" \nng-repeat=\"loadMetrics in loadDetail.load_metrics track by $index\" class=\"min-width-100\"><div flex><div \nclass=\"black-500-fg font-size-18 Font-Bold ph-10\" layout=\"row\" layout-align=\"center center\"><md-input-container \nmd-no-float class=\"input_box mv-0 input_container_width load-input-container\" ng-if=\"!vm.isShared\"><input \ntype=\"number\" step=\"any\" min=\"0\" class=\"load-input select-input\" placeholder=\"volume\" \nng-model=\"loadMetrics.volume_qty\" ng-click=\"vm.trackEvent(\'BookingDetails-EditLoadVolume\')\"></md-input-container>\n<md-select class=\"ml-10 pb-20 select-load-input\" ng-model=\"loadMetrics.volume_unit\" \nng-change=\"vm.trackEvent(\'BookingDetails-EditLoadVolumeUnit\')\" placeholder=\"CBM\" ng-if=\"!vm.isShared\"><md-option \nvalue=\"CBM\">CBM</md-option><md-option value=\"CFT\">CFT</md-option></md-select><div ng-if=\"vm.isShared\">\n{{loadMetrics.volume_qty}} {{loadMetrics.volume_unit}}</div></div></div><div flex><div \nclass=\"black-500-fg font-size-18 Font-Bold ph-10\" layout=\"row\" layout-align=\"center center\"><md-input-container \nmd-no-float class=\"input_box mv-0 input_container_width load-input-container\" ng-if=\"!vm.isShared\"><input \ntype=\"number\" step=\"any\" min=\"0\" class=\"load-input select-input\" placeholder=\"weight\" \nng-model=\"loadMetrics.weight_qty\" ng-click=\"vm.trackEvent(\'BookingDetails-EditLoadWeight\')\"></md-input-container>\n<md-select class=\"ml-10 pb-20 select-load-input\" ng-model=\"loadMetrics.weight_unit\" \nng-change=\"vm.trackEvent(\'BookingDetails-EditLoadWeightUnit\')\" placeholder=\"KG\" ng-if=\"!vm.isShared\"><md-option \nvalue=\"KGs\">KG</md-option><md-option value=\"Tons\">MT</md-option></md-select><div ng-if=\"vm.isShared\">\n{{loadMetrics.weight_qty}} {{loadMetrics.weight_unit}}</div></div></div></div></div></div><div flex=\"100\" \nflex-sm=\"100\" flex-md=\"100\" class=\"Font-Bold font-size-16 pb-20\" layout=\"row\" layout-align=\"end center\" \nng-if=\"!vm.isShared\"><md-button md-no-ink ng-click=\"vm.collapseIt($event); vm.resetLoad()\" \nclass=\"md-primary-btn mr-10\" type=\"button\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" \ntype=\"submit\" ng-click=\"vm.trackEvent(\'BookingDetails-EditSave\')\" ng-disabled=\"vm.loadBtn\">Save</md-button></div>\n</form></div></div><md-divider hide-gt-xs></md-divider><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"load-accordian\" hide-gt-xs ng-click=\"vm.collapseIt($event, \'mobile\')\"><div><span \nclass=\"font-size-16 text-uppercase pr-20\"><span class=\"Font-Bold\">load</span> details</span></div><div \nclass=\"font-size-12 md-link-fg with-icon Font-Bold pointer\"><md-icon \nmd-font-icon=\"icon-chevron-double-down ml-10 s26 chevron\" ng-class=\"{\'chevron-rotate\': vm.hideEditBtn}\"></md-icon>\n</div></div><div id=\"edit-load-mobile\" layout=\"column\" layout-align=\"center center\" \nclass=\"white-bg ph-20 hide-at-start\"><div layout=\"column\" \nclass=\"font-size-8 grey-500-fg Font-Bold pv-10 text-uppercase\" layout-wrap \nng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\'\"><form name=\"loadSubmit\" ng-submit=\"vm.fnSaveLoadQty($event)\">\n<div layout=\"row\" class=\"load_scroll\" \nng-repeat=\"loadDetail in vm.booking_data.search_param.load_data.load_details_value\"><div layout=\"row\" flex=\"30\"><div \nlayout=\"column\" flex=\"50\" layout-align=\"start center\"><div class=\"pb-5\">load type</div><div \nclass=\"pt-10 black-500-fg font-size-16 Font-Bold\">{{ loadDetail.type }}</div></div><div layout=\"column\" flex=\"50\" \nlayout-align=\"start center\"><div class=\"pb-5\">qty</div><div class=\"black-500-fg font-size-12 Font-Bold\">\n<md-input-container md-no-float class=\"input_box mv-0 input_container_width load-input-container\" ng-if=\"!vm.isShared\">\n<input class=\"load-input\" placeholder=\"Qty\" type=\"number\" restrict-to=\"[0-9]\" min=\"1\" max=\"100\" \nng-model=\"loadDetail.qty\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.fnChangeQty(loadDetail)\">\n</md-input-container><div class=\"pt-10\" ng-if=\"vm.isShared\">{{ loadDetail.qty }}</div></div></div></div><div \nlayout=\"column\" flex=\"70\"><div layout=\"row\" layout-align=\"start start\"><div class=\"pl-10 pb-5\" flex>\ntotal shipment volume</div><div class=\"pl-10 pb-5\" flex>total shipment Weight</div></div><div layout=\"row\" \nng-repeat=\"loadMetrics in loadDetail.load_metrics track by $index\"><div flex><div \nclass=\"black-500-fg font-size-14 Font-Bold ph-10\" layout=\"row\" layout-align=\"center center\"><div ng-if=\"!vm.isShared\">\n<md-input-container md-no-float class=\"input_box mv-0 input_container_width load-input-container\"><input \nclass=\"load-input select-input\" type=\"number\" min=\"0\" placeholder=\"volume\" ng-model=\"loadMetrics.volume_qty\" \nng-click=\"vm.trackEvent(\'BookingDetails-EditLoadVolume\')\"></md-input-container><md-select \nclass=\"ml-10 pb-20 select-load-input\" ng-model=\"loadMetrics.volume_unit\" placeholder=\"CBM\" \nng-change=\"vm.trackEvent(\'BookingDetails-EditLoadVolumeUnit\')\"><md-option value=\"CBM\">CBM</md-option><md-option \nvalue=\"CFT\">CFT</md-option></md-select></div><div ng-if=\"vm.isShared\">\n{{loadMetrics.volume_qty}} {{loadMetrics.volume_unit}}</div></div></div><div flex><div \nclass=\"black-500-fg font-size-14 Font-Bold ph-10\" layout=\"row\" layout-align=\"center center\"><div ng-if=\"!vm.isShared\">\n<md-input-container md-no-float class=\"input_box mv-0 input_container_width load-input-container\"><input \nclass=\"load-input select-input\" type=\"number\" min=\"0\" placeholder=\"weight\" ng-model=\"loadMetrics.weight_qty\" \nng-click=\"vm.trackEvent(\'BookingDetails-EditLoadWeight\')\"></md-input-container><md-select \nclass=\"ml-10 pb-20 select-load-input\" ng-model=\"loadMetrics.weight_unit\" \nng-change=\"vm.trackEvent(\'BookingDetails-EditLoadWeightUnit\')\" placeholder=\"KG\"><md-option value=\"KGs\">KG</md-option>\n<md-option value=\"Tons\">MT</md-option></md-select></div><div ng-if=\"vm.isShared\">\n{{loadMetrics.weight_qty}} {{loadMetrics.weight_unit}}</div></div></div></div></div></div><div class=\"pb-20\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!vm.isShared\"><div flex=\"50\" layout=\"row\" \nlayout-align=\"center center\" class=\"pointer mr-10\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"vm.collapseIt($event, \'mobile\'); vm.resetLoad()\" type=\"button\">Cancel</md-button></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"center center\" class=\"pointer ml-10\"><md-button md-no-ink class=\"md-accent-btn\" \ntype=\"submit\" ng-click=\"vm.trackEvent(\'BookingDetails-EditSave\')\" ng-disabled=\"vm.loadBtn\">Save</md-button></div></div>\n</form></div><div layout=\"column\" class=\"font-size-8 grey-500-fg Font-Bold pv-10 text-uppercase\" layout-wrap \nng-if=\"vm.booking_data.search_param.mode == \'AIR\'\"><div class=\"grey-500-fg font-size-14 Font-Bold ph-10\">\n{{ vm.formContainerType(vm.booking_data.search_param.mode,vm.booking_data.search_param.load_data ) }}</div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap flex=\"100\" ng-if=\"vm.booking_data.search_param.mode == \'SEA-LCL\'\">\n<div layout=\"column\" ng-repeat=\"loadDetail in vm.lclLoadArray\" ng-if=\"loadDetail.value != \'N/A\'\" class=\"w-190 mb-10\">\n<div class=\"load_name\">{{ loadDetail.name }} :</div><div class=\"load_value\">{{ loadDetail.value }}</div></div></div>\n</div><div class=\"black-500-fg pt-15 ph-20 layout-card\" flex=\"100\" hide-xs><div \nclass=\"font-size-14 text-uppercase mb-10 Font-Regular\"><span class=\"Font-ExtraBold\">commodity</span> details</div>\n<md-divider></md-divider><div layout=\"row\" layout=\"row\" layout-wrap><div flex-xs=\"50\" flex=\"25\" \nclass=\"pt-20 pr-10 w-140\"><div class=\"Font-Bold font-size-12\">Cargo Type <span class=\"red-fg\">*</span></div><div \nclass=\"Font-Bold pt-3\" \nng-class=\"{\'input_color\' : !vm.booking_data.commodity.cargo_type, \'border-bottom\' : !vm.isCargoTypeDisabled}\">\n<cargo-type-selection id=\"book-cargo-type\" cargo-type-data=\"vm.booking_data.commodity.cargo_type\" is-required=\"true\" \nhazardous-value=\"vm.booking_data.commodity.hazardous\" ng-keyup=\"vm.cargoValidationError= false;\" \nis-disabled=\"vm.isCargoTypeDisabled\" is-valid=\"false\" category=\"\'booking\'\" mode=\"vm.booking_data.search_param.mode\">\n</cargo-type-selection></div><div ng-if=\"vm.cargoValidationError\" class=\"validation-error-advance\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span class=\"Font-ExtraBold\">\nPlease select cargo type</span></div></div><div flex-xs=\"50\" flex class=\"pt-20\"><div class=\"Font-Bold font-size-12\">\nCommodity <span class=\"red-fg\">*</span></div><md-input-container md-no-float class=\"mv-0 commodity_input\" \nng-keyup=\"vm.requiredCommodity=false;\"><commodity-chips required md-input-id=\"\'commodity_id_web\'\" \ncommodity-array=\"vm.booking_data.commodity.commodity_data\" is-valid=\"false\" category=\"\'booking\'\"></commodity-chips>\n</md-input-container><div ng-if=\"vm.requiredCommodity\" class=\"validation-error-advance\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span class=\"Font-ExtraBold\">\nCommodity is required</span></div></div></div><div layout=\"row\" layout=\"row\" layout-wrap><div flex-xs=\"50\" flex=\"25\" \nclass=\"pt-20 pr-10 w-140\"><span class=\"Font-Bold font-size-12\">HS Code</span><br><md-input-container md-no-float \nclass=\"input_box mv-0 pt-3 input_container_width\"><input name=\"hs_code\" class=\"Font-ExtraBold\" \nng-model=\"vm.booking_data.commodity.hs_code\" ng-click=\"vm.trackEvent(\'BookingDetails-HSCode\')\" \nplaceholder=\"Enter HS CODE\"></md-input-container></div><div flex-xs=\"50\" flex class=\"pt-20 w-200 font-size-12\" \nng-if=\"vm.booking_data.commodity.hazardous\"><div class=\"font-weight-500 Font-Bold\">IMCO CODE <sup \nclass=\"font-size-12 red-fg\">*</sup></div><div class=\"border-bottom Font-Bold\" \nng-class=\"{\'input_color\' : !vm.booking_data.commodity.imco_code}\"><md-select class=\"ml-10\" id=\"book-imco-code\" \nng-change=\"vm.imcoValidationError=false;vm.trackEvent(\'BookingDetails-IMCOCode\')\" \nng-model=\"vm.booking_data.commodity.imco_code\" placeholder=\"Select IMCO Code\" \nmd-selected-html=\"vm.getImcoCodeText(vm.booking_data.commodity.imco_code)\" \nng-disabled=\"!vm.booking_data.commodity.hazardous\"><md-option class=\"mb-10\" style=\"height:100%\" ng-value=\"0\">\nSelect IMCO code</md-option><md-option class=\"mb-10\" style=\"height:100%\" \nng-repeat=\"imcoCode in vm.IMCO_CodeList track by $index\" ng-value=\"imcoCode.class_number\"><span \nclass=\"font-weight-600\">{{imcoCode.class_name}}</span><br><span class=\"gray-fg font-size-12\" \nng-repeat=\"list in imcoCode.list track by $index\">{{list}}<br></span></md-option></md-select></div><div \nng-if=\"vm.imcoValidationError\" class=\"validation-error-advance\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span class=\"Font-ExtraBold\">\nPlease select imco code</span></div></div></div></div><md-divider hide-gt-xs></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"load-accordian\" hide-gt-xs \nng-click=\"vm.collapseIt($event, \'commodity-mobile\')\"><div><span class=\"font-size-16 text-uppercase pr-20\"><span \nclass=\"Font-Bold\">commodity</span> details</span></div><div \nclass=\"font-size-12 md-link-fg with-icon Font-Bold pointer\"><md-icon \nmd-font-icon=\"icon-chevron-double-down ml-10 s26 chevron\" ng-class=\"{\'chevron-rotate\': vm.hideCommodityBtn}\"></md-icon>\n</div></div><div id=\"commodity-mobile\" layout=\"column\" layout-align=\"center center\" \nclass=\"white-bg ph-20 pb-30 hide-at-start\"><div layout=\"column\"><div class=\"pt-20\"><span \nclass=\"Font-Bold font-size-10\">Cargo Type <span class=\"red-fg\">*</span></span><br><div class=\"Font-Bold\" \nng-class=\"{\'input_color\' : !vm.booking_data.commodity.cargo_type, \'border-bottom\' : !vm.isCargoTypeDisabled}\">\n<cargo-type-selection cargo-type-data=\"vm.booking_data.commodity.cargo_type\" is-required=\"true\" \nhazardous-value=\"vm.booking_data.commodity.hazardous\" ng-keyup=\"vm.cargoValidationError= false;\" \nis-disabled=\"vm.isCargoTypeDisabled\" is-valid=\"false\" category=\"\'booking\'\" mode=\"vm.booking_data.search_param.mode\">\n</cargo-type-selection></div><div ng-if=\"vm.cargoValidationError\" class=\"validation-error-advance\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span class=\"Font-ExtraBold\">\nPlease select cargo type</span></div></div><div class=\"pt-20\"><span class=\"Font-Bold font-size-10\">Commodity <span \nclass=\"red-fg\">*</span></span><br><md-input-container md-no-float class=\"mv-0 commodity_input\" \nng-keyup=\"vm.requiredCommodity=false;\"><commodity-chips required md-input-id=\"\'commodity_id_mobile\'\" \ncommodity-array=\"vm.booking_data.commodity.commodity_data\" is-valid=\"false\" category=\"\'booking\'\"></commodity-chips>\n</md-input-container><div ng-if=\"vm.requiredCommodity\" class=\"validation-error-advance\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span class=\"Font-ExtraBold\">\nCommodity is required</span></div></div><div class=\"pt-20\"><span class=\"Font-Bold font-size-10\">HS Code</span><br>\n<md-input-container md-no-float class=\"input_box mv-0 input_container_width_mobile font-size-14\"><input name=\"hs_code\" \nclass=\"Font-ExtraBold\" ng-model=\"vm.booking_data.commodity.hs_code\" ng-click=\"vm.trackEvent(\'BookingDetails-HSCode\')\" \nplaceholder=\"Enter HS CODE\"></md-input-container></div><div class=\"\" ng-if=\"vm.booking_data.commodity.hazardous\"><span \nclass=\"font-weight-500 Font-Bold font-size-10\">IMCO CODE</span><br><div class=\"border-bottom\"><md-select \nclass=\"ml-10 font-size-14\" id=\"book-imco-code\" \nng-change=\"vm.imcoValidationError=false;vm.trackEvent(\'BookingDetails-IMCOCode\')\" \nng-model=\"vm.booking_data.commodity.imco_code\" placeholder=\"Select IMCO Code\" \nmd-selected-html=\"vm.getImcoCodeText(vm.booking_data.commodity.imco_code)\" \nng-disabled=\"!vm.booking_data.commodity.hazardous\"><md-option class=\"mb-10\" style=\"height:100%\" ng-value=\"0\">\nSelect IMCO code</md-option><md-option class=\"mb-10\" style=\"height:100%\" \nng-repeat=\"imcoCode in vm.IMCO_CodeList track by $index\" ng-value=\"imcoCode.class_number\"><span \nclass=\"font-weight-600\">{{imcoCode.class_name}}</span><br><span class=\"gray-fg font-size-12\" \nng-repeat=\"list in imcoCode.list track by $index\">{{list}}<br></span></md-option></md-select></div><div \nng-if=\"vm.imcoValidationError\" class=\"validation-error-advance\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span class=\"Font-ExtraBold\">\nPlease select imco code</span></div></div></div></div><div class=\"layout-card\" hide-xs><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"br pl-20 pr-10\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"font-size-14 text-uppercase parties-cont Font-Regular\"><span class=\"Font-ExtraBold\">PARTIES</span><br>INVOLVED\n</div></div><div class=\"br pv-10\" layout-align=\"center center\" layout=\"column\" flex ng-if=\"!vm.util.isShipper\"><div \nlayout=\"column\" layout-align=\"center center\" ng-if=\"!vm.partyView.shipper\"><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"h-30 w-30 mb-10 pointer\" src=\"assets/icons/custom/plus-icon-circle.svg\" \nng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'customer\')\"></div><div class=\"Font-Bold font-size-14\">SHIPPER</div></div><div \nng-if=\"vm.partyView.shipper\" class=\"parties-detail-container\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"pb-10\"><div class=\"font-size-12 Font-Bold mt-5\">SHIPPER</div><button class=\"md-link-btn Font-Bold\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'shipper\')\">EDIT</button></div><div layout=\"column\" layout-xs=\"column\" \nlayout-wrap><div class=\"font-size-12 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.shipper.name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/add-friend.svg\">{{vm.shipper.name}}</div><div \nclass=\"font-size-12 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.shipper.company_name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/visitor.svg\">{{vm.shipper.company_name}}</div><div layout=\"row\" \nlayout-align=\"space-between\" layout-xs=\"column\" layout-wrap flex=\"100\"><div flex \nclass=\"font-size-12 Font-Bold grey-500-fg notify-details text-truncate\" title=\"{{vm.shipper.email}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/close-envelope.svg\">{{vm.shipper.email}}</div><div \nclass=\"view-detailed md-link-fg Font-Bold\" flex ng-click=\"vm.fnOpenNewPartyModal(\'View\', \'shipper\')\" layout=\"row\" \nlayout-align=\"end center\">VIEW DETAILED</div></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"parties_checkbox Font-Bold\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.shipper.send_notification\" class=\"md-primary\" ng-click=\"vm.fnNotificationToggle(vm.shipper)\">\nSend Notification</md-checkbox></div></div></div><div class=\"br pv-10\" layout-align=\"center center\" layout=\"column\" \nflex><div layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.partyView.consignee\"><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"h-30 w-30 mb-10 pointer\" src=\"assets/icons/custom/plus-icon-circle.svg\" \nng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'consignee\')\"></div><div class=\"Font-Bold font-size-14\">CONSIGNEE</div></div>\n<div ng-if=\"vm.partyView.consignee\" class=\"parties-detail-container\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"pb-10\"><div class=\"font-size-12 Font-Bold mt-5\">CONSIGNEE</div><button class=\"md-link-btn Font-Bold\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'consignee\')\">EDIT</button></div><div layout=\"column\" layout-xs=\"column\" \nlayout-wrap><div class=\"font-size-12 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.consignee.name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/add-friend.svg\">{{vm.consignee.name}}</div><div \nclass=\"font-size-12 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.consignee.company_name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/visitor.svg\">{{vm.consignee.company_name}}</div><div \nlayout=\"row\" layout-align=\"space-between\" layout-xs=\"column\" layout-wrap flex=\"100\"><div \nclass=\"font-size-12 Font-Bold grey-500-fg notify-details text-truncate\" flex title=\"{{vm.consignee.email}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/close-envelope.svg\">{{vm.consignee.email}}</div><div \nclass=\"view-detailed md-link-fg Font-Bold\" layout=\"row\" flex layout-align=\"end center\" \nng-click=\"vm.fnOpenNewPartyModal(\'View\', \'consignee\')\">VIEW DETAILED</div></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"parties_checkbox Font-Bold\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.consignee.send_notification\" class=\"md-primary\" ng-click=\"vm.fnNotificationToggle(vm.consignee)\">\nSend Notification</md-checkbox></div></div></div><div class=\"pv-10\" layout-align=\"center center\" layout=\"column\" flex>\n<div layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.partyView.notifyParty\"><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"h-30 w-30 mb-10 pointer\" src=\"assets/icons/custom/plus-icon-circle.svg\" \nng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'notify_party\')\"></div><div class=\"Font-Bold font-size-14\">NOTIFY PARTY</div>\n</div><div ng-if=\"vm.partyView.notifyParty\" class=\"parties-detail-container\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"pb-10\"><div class=\"font-size-12 Font-Bold mt-5\">NOTIFY PARTY</div><button \nclass=\"md-link-btn Font-Bold\" ng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'notify_party\')\">EDIT</button></div><div \nlayout=\"column\" layout-xs=\"column\" layout-wrap><div class=\"font-size-12 Font-Bold grey-500-fg notify-details truncate\" \ntitle=\"{{vm.notifyParty.name}}\"><img class=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/add-friend.svg\">\n{{vm.notifyParty.name}}</div><div class=\"font-size-12 Font-Bold grey-500-fg notify-details truncate\" \ntitle=\"{{vm.notifyParty.company_name}}\"><img class=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/visitor.svg\">\n{{vm.notifyParty.company_name}}</div><div layout=\"row\" layout-align=\"space-between\" layout-xs=\"column\" layout-wrap \nflex=\"100\"><div class=\"font-size-12 Font-Bold grey-500-fg notify-details text-truncate\" flex \ntitle=\"{{vm.notifyParty.email}}\"><img class=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/close-envelope.svg\">\n{{vm.notifyParty.email}}</div><div class=\"view-detailed md-link-fg Font-Bold\" layout=\"row\" flex \nlayout-align=\"end center\" ng-click=\"vm.fnOpenNewPartyModal(\'View\', \'notify_party\')\">VIEW DETAILED</div></div></div><div\n layout=\"row\" layout-align=\"start center\" class=\"parties_checkbox Font-Bold\"><md-checkbox md-no-ink \naria-label=\"Checkbox No Ink\" ng-model=\"vm.notifyParty.send_notification\" class=\"md-primary\" \nng-click=\"vm.fnNotificationToggle(vm.notifyParty)\">Send Notification</md-checkbox></div></div></div></div></div>\n<md-divider hide-gt-xs></md-divider><div layout=\"row\" layout-align=\"space-between center\" class=\"load-accordian\" \nhide-gt-xs ng-click=\"vm.collapseIt($event, \'parties-mobile\')\"><div><span class=\"font-size-16 text-uppercase pr-20\">\n<span class=\"Font-Bold\">PARTIES</span> INVOLVED</span></div><div \nclass=\"font-size-12 md-link-fg with-icon Font-Bold pointer\"><md-icon \nmd-font-icon=\"icon-chevron-double-down ml-10 s26 chevron\" ng-class=\"{\'chevron-rotate\': vm.hidePartiesBtn}\"></md-icon>\n</div></div><div id=\"parties-mobile\" layout=\"column\" layout-align=\"center center\" \nclass=\"white-bg ph-20 pb-30 hide-at-start\"><div layout=\"row\" flex=\"100\" layout-wrap><div flex=\"33\" \nclass=\"p-10 mobile-parties-container\" layout=\"column\" layout-align=\"center none\"><div class=\"p-10 mobile-parties\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"!vm.partyView.shipper\"><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"h-35 w-35 mb-10 pointer\" src=\"assets/icons/custom/plus-icon-circle.svg\" \nng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'shipper\')\"></div><div class=\"Font-Bold font-size-12\">SHIPPER</div></div><div \nclass=\"p-10 mobile-parties\" ng-if=\"vm.partyView.shipper\" class=\"parties-detail-container\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"pb-10\"><div class=\"font-size-10 Font-Bold mt-5\">SHIPPER</div><button \nclass=\"md-link-btn Font-Bold\" ng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'shipper\')\">EDIT</button></div><div \nlayout=\"column\" layout-xs=\"column\" layout-wrap><div class=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" \ntitle=\"{{vm.shipper.name}}\"><img class=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/add-friend.svg\">\n{{vm.shipper.name}}</div><div class=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" \ntitle=\"{{vm.shipper.company_name}}\"><img class=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/visitor.svg\">\n{{vm.shipper.company_name}}</div><div class=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" \ntitle=\"{{vm.shipper.email}}\"><img class=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/close-envelope.svg\">\n{{vm.shipper.email}}</div></div><div layout=\"row\" layout-align=\"end end\" class=\"pb-10\"><div \nclass=\"view-detailed md-link-fg Font-Bold\" ng-click=\"vm.fnOpenNewPartyModal(\'View\', \'shipper\')\">VIEW DETAILED</div>\n</div></div></div><div flex=\"33\" class=\"p-10 mobile-parties-container\" layout=\"column\" layout-align=\"center none\"><div \nclass=\"p-10 mobile-parties\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.partyView.consignee\"><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"h-35 w-35 mb-10 pointer\" \nsrc=\"assets/icons/custom/plus-icon-circle.svg\" ng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'consignee\')\"></div><div \nclass=\"Font-Bold font-size-12\">CONSIGNEE</div></div><div class=\"p-10 mobile-parties\" ng-if=\"vm.partyView.consignee\" \nclass=\"parties-detail-container\"><div layout=\"row\" layout-align=\"space-between\" class=\"pb-10\"><div \nclass=\"font-size-10 Font-Bold mt-5\">CONSIGNEE</div><button class=\"md-link-btn Font-Bold\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'consignee\')\">EDIT</button></div><div layout=\"row\" \nlayout-align=\"space-between\" layout-xs=\"column\" layout-wrap><div \nclass=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.consignee.name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/add-friend.svg\">{{vm.consignee.name}}</div><div \nclass=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.consignee.company_name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/visitor.svg\">{{vm.consignee.company_name}}</div><div \nclass=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.consignee.email}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/close-envelope.svg\">{{vm.consignee.email}}</div></div><div \nlayout=\"row\" layout-align=\"end end\" class=\"pb-10\"><div class=\"view-detailed md-link-fg Font-Bold\" \nng-click=\"vm.fnOpenNewPartyModal(\'View\', \'consignee\')\">VIEW DETAILED</div></div></div></div><div flex=\"33\" \nclass=\"p-10 mobile-parties-container\" layout=\"column\" layout-align=\"center none\"><div class=\"p-10 mobile-parties\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"!vm.partyView.notifyParty\"><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"h-35 w-35 mb-10 pointer\" src=\"assets/icons/custom/plus-icon-circle.svg\" \nng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'notify_party\')\"></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"Font-Bold font-size-12\">NOTIFY PARTY</div></div><div class=\"p-10 mobile-parties\" \nng-if=\"vm.partyView.notifyParty\" class=\"parties-detail-container\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"pb-10\"><div class=\"font-size-10 Font-Bold mt-5\">NOTIFY PARTY</div><button class=\"md-link-btn Font-Bold\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'notify_party\')\">EDIT</button></div><div layout=\"row\" \nlayout-align=\"space-between\" layout-xs=\"column\" layout-wrap><div \nclass=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.notifyParty.name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/add-friend.svg\">{{vm.notifyParty.name}}</div><div \nclass=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.notifyParty.company_name}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/visitor.svg\">{{vm.notifyParty.company_name}}</div><div \nclass=\"font-size-10 Font-Bold grey-500-fg notify-details truncate\" title=\"{{vm.notifyParty.email}}\"><img \nclass=\"h-10 w-10 small-icons\" src=\"assets/icons/custom/close-envelope.svg\">{{vm.notifyParty.email}}</div></div><div \nlayout=\"row\" layout-align=\"end end\" class=\"pb-10\"><div class=\"view-detailed md-link-fg Font-Bold\" \nng-click=\"vm.fnOpenNewPartyModal(\'View\', \'notify_party\')\">VIEW DETAILED</div></div></div></div></div></div><md-divider \nhide-gt-xs></md-divider><div class=\"black-500-fg pv-15 mb-30 ph-20 layout-card\"><div flex=\"100\" layout=\"row\" \nlayout-xs=\"column\"><div layout=\"row\" layout-align=\"start start\" class=\"w-100\"><div layout=\"column\" layout-xs=\"row\" \nclass=\"comment-container\"><div class=\"font-size-14 text-uppercase\"><span class=\"Font-Bold\">COMMENTS</span></div><div \nclass=\"grey-400-fg optional-mobile font-size-12 Font-Bold\">(optional)</div></div></div><div layout=\"row\" flex><textarea\n class=\"text-area p-10 mb-0\" ng-click=\"vm.trackEvent(\'BookingDetails-Comments\')\" ng-model=\"vm.booking_data.comments\">\n</textarea></div></div></div><br hide show-gt-sm><br hide show-gt-sm><br hide show-gt-sm></div><div flex-sm=\"100\" \nflex-xs=\"100\" class=\"rate-summary-size\"><div class=\"layout-card\" flex=\"100\" layout=\"column\"><div layout-sm=\"row\"><div \nclass=\"p-20\" flex-sm=\"60\" flex-xs=\"100\"><div class=\"font-size-14 text-uppercase mb-20 Font-Regular\"><span \nclass=\"Font-ExtraBold\">RATE</span> SUMMARY</div><div class=\"rate-container\"><div layout=\"column\" class=\"mb-25\" \nng-repeat=\"(key, leg_value) in vm.bookingRates track by $index\" ng-if=\"leg_value.leg_code != \'other_charges_fcl\' \"><div\n layout=\"row\" layout-align=\"space-between\"><div class=\"mb-10 font-size-12 black-500-fg Font-Bold mr-5\">\n{{leg_value.leg_code == vm.l3_leg && leg_value.leg_name == vm.mainFreightName ? \'Freight\' : leg_value.leg_name }}\n<md-icon md-font-icon=\"icon-alert-circle\n                      \" class=\"s16 mb-3 indigo-100-fg pointer\" \nng-if=\"leg_value.leg_code == vm.l3_leg && leg_value.rate_type.includes(\'spot\')\"><md-tooltip md-direction=\"right\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10 Font-Bold\" style=\"display:table;opacity:1\">Spot Rates are dynamic &\n<br>can fluctuate with time</md-tooltip></md-icon><span hide-gt-xs class=\"hide-view\" ng-if=\"leg_value.selected\" \nng-click=\"vm.toggleChargeList($event, leg_value)\">hide</span> <span hide-gt-xs ng-if=\"!leg_value.selected\" \nclass=\"hide-view\" ng-click=\"vm.toggleChargeList($event, leg_value)\">view</span></div><div \nclass=\"mb-10 font-size-12 black-500-fg Font-Bold w-75 text-right\">\n{{ leg_value.leg_currency + \' \' + (leg_value.leg_currency_cost | currencyMask: 2) }}</div></div><div hide-xs><div \nlayout=\"row\" layout-align=\"space-between\" ng-repeat=\"(childKey, charge_obj) in leg_value.charges track by $index\"><div \nclass=\"mb-10 font-size-12 grey-500-fg\">{{ charge_obj.charge_name }} {{charge_obj.container_type}}<span \nclass=\"dim-charge-sect\" ng-if=\"charge_obj.charge_basis.includes(\'dim\') && vm.util.isAdmin\">DIM Charge</span><div \nclass=\"dim-charge-sect\" ng-if=\"charge_obj.charge_category && charge_obj.charge_category !== null\" \nng-bind=\"charge_obj.charge_category\"></div></div><div class=\"mb-10 font-size-12 grey-500-fg w-75 text-right\"><span \nclass=\"text-strike\" ng-if=\"(key === vm.legKey) && (childKey === vm.chargeKey)\">\n{{ ( !charge_obj.min_flag && vm.isString(charge_obj.charge_cost) ) ? \'\' : leg_value.leg_currency }} {{vm.couponData.chargeCost}}\n<br></span>\n{{ ( !charge_obj.min_flag && vm.isString(charge_obj.charge_cost) ) ? \'\' : leg_value.leg_currency }} {{ vm.fnCheckIsNaN(charge_obj) }}\n</div></div></div></div></div><div ng-if=\"vm.showExchangeRates\"><a class=\"pointer md-link-fg Font-Bold\" \nng-click=\"vm.util.redirectToExchangeRatesLink(vm.resultType ,vm.booking_data.id, vm.booking_data.card_item.meta.vendor_id, \'BookingDetails-ViewExchangeRate\', {\'Mode\':vm.booking_data.search_param.mode})\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div><div \nclass=\"p-20 bt bb mt-20\" ng-show=\"!vm.showSpotLoader\" \nng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\' && vm.booking_data.card_item.meta.additional_charges.data\"><div \nlayout=\"row\" layout-align=\"space-between\"><div class=\"font-size-12\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s12 mr-5 pointer\"><md-tooltip md-direction=\"left\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10 Font-Bold\" \nstyle=\"display:table;opacity:1;max-width: 20%; word-wrap: break-word; white-space: unset\">\nConvenience Fee includes operations, credit & platform cost</md-tooltip></md-icon>\n{{vm.bookingRates[vm.convenienceIndex].leg_name}}</div><div><div class=\"red-fg bold\">\n{{vm.bookingRates[vm.convenienceIndex].charges[0].charge_currency}} {{vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost | currencyMask: 2 }}\n</div><div class=\"grey-fg font-size-10\" ng-if=\"vm.couponData.chargeCost\"><strike>\n{{vm.bookingRates[vm.convenienceIndex].charges[0].charge_currency}} {{vm.couponData.chargeCost}}</strike></div></div>\n</div></div><div layout=\"row\" class=\"mt-20\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"30\" ng-show=\"vm.showSpotLoader\"></md-progress-circular></div></div><div class=\"p-20\" flex-sm=\"40\" \nflex-xs=\"100\"><div layout=\"column\"><div ng-if=\"!$root.domainData.domain_info.HIDE_BOOKING_COUPON\"><div \nclass=\"Font-Bold mv-10 font-size-12\">\n{{(vm.prevLegCost || vm.couponData.chargeCost) ? \'APPLIED COUPON\' : \'ENTER COUPON CODE\'}}</div><div flex=\"100\" \nlayout=\"row\" class=\"pv-10 ph-10 border mb-10 coupon-code\" ng-if=\"!vm.prevLegCost && !vm.couponData.chargeCost\"><div \nflex=\"80\" layout=\"row\" layout-align=\"start center\"><input ng-keyup=\"vm.cleanInput()\" name=\"hs_code Font-ExtraBold\" \nclass=\"borderless Font-ExtraBold\" ng-model=\"vm.codeToSend\" placeholder=\"Enter coupon code\"></div><div flex=\"20\" \nlayout=\"row\" layout-align=\"end end\"><div ng-show=\"!vm.appliedCode\" \nclass=\"md-primary-fg font-size-12 text-uppercase Font-Bold pointer\" ng-click=\"vm.applyCoupon(vm.codeToSend);\">APPLY\n</div><md-progress-circular ng-show=\"vm.appliedCode\" md-mode=\"indeterminate\" md-diameter=\"19.5px\">\n</md-progress-circular></div></div><div ng-if=\"vm.codeSuccess\" class=\"mb-20\" layout=\"row\" layout-align=\"space-between\">\n<div layout=\"row\"><div class=\"second-color font-size-14 Font-Bold\"><img class=\"h-20 w-20 mr-10\" \nsrc=\"assets/icons/custom/approved-signal.svg\"></div><div class=\"second-color font-size-14 Font-Bold\">{{vm.codeMessage}}\n</div></div><div class=\"red-500-fg pl-5 font-size-14 Font-Bold pointer\" ng-click=\"vm.resetCoupon()\">remove</div></div>\n<div ng-if=\"vm.codeSuccess === false\" class=\"red-500-fg font-size-14 Font-Bold mb-20\" layout=\"row\" \nlayout-align=\"center center\">{{vm.codeMessage}}</div></div><div class=\"font-size-12 grey-500-fg Font-Bold\" \nlayout=\"row\" layout-align=\"center center\">TOTAL AMOUNT</div><div \nclass=\"font-size-18 black-500-fg text-uppercase Font-Bold\" layout=\"row\" layout-align=\"center center\">\n{{ vm.booking_data.user.user_base_currency }} <span class=\"font-size-30 mb-5 ml-2\">\n{{ (vm.booking_data.card_item.meta.card_total_cost | currencyMask: 2) }}</span></div></div></div></div><div \nlayout=\"row\" layout-align=\"space-between\" class=\"pt-15 ph-15 pb-5\" \nng-if=\"vm.booking_data.card_item.meta.applied_special_meta\"><div class=\"light-blue-400-fg font-size-16 Font-Bold mr-8\">\n<span ng-if=\"vm.bookingL3_rates[0].promotions.length\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"light-blue-400-fg s18 mb-2 mr-5\"></md-icon><span \nng-repeat=\"promotion in vm.bookingL3_rates[0].promotions track by $index\">{{$first ? \'\' : \', \'}} {{promotion.name}}\n</span></span></div><div class=\"red-fg font-size-16 Font-Bold\"><md-icon md-font-icon=\"icon-fire\" \nclass=\"red-fg s18 mb-2 mr-5\"></md-icon>\nOnly {{vm.booking_data.card_item.meta.applied_special_meta.special_qty_rem.TEUs}} Left</div></div><div layout=\"row\" \nlayout-align=\"center\" class=\"mb-10 font-size-12\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details\"><span \nclass=\"grey-500-fg Font-Bold\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details.penalty_fees.length\">\n{{vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details.penalty_message}} \n</span><a class=\"md-link-fg ml-5 pointer\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details.penalty_fees.length\" \nng-click=\"vm.fnDisplayPenalty($event)\">Learn more</a></div><div class=\"font-size-14 bt ph-20 pv-5\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"(!!vm.remarks || !!vm.inclusions)\"><span class=\"pt-15\"><md-checkbox md-no-ink \nng-model=\"vm.checkRemarksIncl\" ng-click=\"vm.trackEvent(\'BookingDetails-Inclusion\')\" class=\"md-primary mt-5\">\n</md-checkbox></span>Subject to <span class=\"md-link-fg Font-Bold pl-5 pointer\">Remarks and inclusions<md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 p-10 font-size-14\" \nstyle=\"opacity: 1;max-width: 328px;height: unset;line-height: 1.8\"><div class=\"Font-Bold\">REMARKS</div><div \nclass=\"font-size-12\" style=\"white-space: pre-wrap\" compile-html=\"vm.remarks ? vm.remarks : \' - \'\"></div><div \nclass=\"Font-Bold pt-5\">INCLUSIONS</div><div class=\"font-size-12\" style=\"white-space: pre-wrap\" \ncompile-html=\"vm.inclusions ? vm.inclusions : \'-\'\"></div></md-tooltip></span></div><md-button md-no-ink \nclass=\"md-accent-btn Font-Bold h-50\" ng-click=\"vm.confirmBooking()\" ng-disabled=\"vm.confirm_btn || vm.showSpotLoader\" \nng-style=\"{ \'cursor\' : (vm.confirm_btn == true)  ? \'not-allowed\' : \'pointer\' }\"><md-icon \nng-if=\"vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status && vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>Request Booking\n<md-tooltip md-direction=\"top\" \nng-if=\"vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status && vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.code == 1002 && vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip>\n</md-button></div></div></div></div>");
$templateCache.put("app/main/result/bookShipment/booking-shipment.html","<div id=\"book-shipment\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"mt-20\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between end\" layout-align-xs=\"space-between start\" flex=\"100\"><div \nlayout=\"column\" layout-align=\"center start\"><div><span class=\"md-link-fg ml-30 pointer\" ng-click=\"vm.goBack()\">\n{{vm.booking_data.page ==\'quote\' ? \'Quotes\': \'Instant Rates\'}}</span><span> / {{vm.booking_data.search_param.mode}}\n</span></div><div layout=\"row\"><div ng-click=\"vm.goBack()\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"mr-5 mt-5 back-icon pointer\"></md-icon></div><div class=\"page_title fg-333333\">Booking Summary</div></div></div>\n</div></div><div layout=\"row\" class=\"custom_scroll\" layout-sm=\"column\" layout-xs=\"column\"><div layout=\"column\" \nflex=\"70\" flex-sm=\"100\" flex-xs=\"100\" class=\"fg-333333\"><div class=\"layout-card booking-spacing-responsive\" flex=\"100\">\n<div class=\"font-size-16 p-20 bb\" layout=\"row\"><div class=\"pt-3\"><span class=\"Font-Bold\">Booking Details </span></div>\n</div><div class=\"p-20\"><div layout=\"row\" class=\"mr-20\"><div layout-align=\"start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'/assets/icons/custom/port-aaa8ad.svg\')\" class=\"icon-bs\"></div></div><div layout=\"row\" \nlayout-xs=\"column\" flex=\"94\" class=\"w-full\"><div layout=\"column\" class=\"w-full mb-2 pr-20\" flex><label>Origin</label>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"port-details input_box mt-5\"><md-icon \nclass=\"mh-5 icon-size-autocomplete\" md-svg-src=\"{{  vm.displayPortName.originIcon }}\"></md-icon><div \nclass=\"w-full text-truncate\"><span ng-bind=\"vm.displayPortName.origin\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.displayPortName.origin }}</md-tooltip></span></div><div \nng-if=\"vm.booking_data.card_item.meta.port_data.origin_port_code && !vm.booking_data.card_item.meta.port_data.pickup_location  && !focused \" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{vm.booking_data.card_item.meta.port_data.origin_port_code}}</div><div \nng-if=\"vm.booking_data.card_item.meta.port_data.pickup_pincode_ui && vm.booking_data.card_item.meta.port_data.pickup_location\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\" \nng-bind=\"vm.booking_data.card_item.meta.port_data.pickup_pincode_ui\"></span></div></div></div><div layout=\"column\" \nclass=\"w-full mobile-spacing pr-20\" flex><label>Destination</label><div layout=\"row\" \nlayout-align=\"space-between center\" md-no-float class=\"port-details input_box mt-5\"><md-icon \nclass=\"mh-5 icon-size-autocomplete\" md-svg-src=\"{{ vm.displayPortName.deliverIcon }}\"></md-icon><div \nclass=\"w-full text-truncate\"><span ng-bind=\"vm.displayPortName.destination\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.displayPortName.destination }}</md-tooltip></span></div><div \nng-if=\"vm.booking_data.card_item.meta.port_data.destination_port_code && !vm.booking_data.card_item.meta.port_data.delivery_location\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{vm.booking_data.card_item.meta.port_data.destination_port_code}}</div><div \nng-if=\"vm.booking_data.card_item.meta.port_data.delivery_pincode_ui && vm.booking_data.card_item.meta.port_data.delivery_location\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\" \nng-bind=\"vm.booking_data.card_item.meta.port_data.delivery_pincode_ui\"></span></div></div></div></div></div><div \nlayout=\"row\" flex=\"100\" class=\"ml-50 mt-20\" \nng-if=\"vm.booking_data.card_item.meta.via_pod || vm.booking_data.card_item.meta.via_pol \"><div layout=\"column\" \nng-if=\"vm.booking_data.card_item.meta.via_pol\" flex=\"50\" class=\"ml-20 pr-20\"><label layout=\"row\" class=\"mb-6\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bs\"></div>POL</label><div \nlayout=\"row\" layout-align=\"start center\" class=\"panel-select-disabled input_box mt-5\"><div class=\"pl-10 text-truncate\">\n{{vm.booking_data.card_item.meta.via_pol}}</div></div></div><div layout=\"column\" flex=\"50\" \nng-if=\"vm.booking_data.card_item.meta.via_pod\" class=\"pr-20\"><label layout=\"row\" class=\"mb-6\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bs\"></div>POD</label><div \nlayout=\"row\" layout-align=\"start center\" class=\"panel-select-disabled input_box mt-5\"><div class=\"pl-10 text-truncate\">\n{{vm.booking_data.card_item.meta.via_pod}}</div></div></div></div><div layout=\"row\" flex=\"100\" class=\"mt-20\" \nng-if=\"!vm.maskLiner\"><div layout-align=\"start start\" class=\"pr-20\"><md-icon \nmd-svg-icon=\"/assets/icons/custom/liner-aaa8ad.svg\" class=\"fg-333333 icon-bs\" \nng-show=\"vm.booking_data.search_param.mode != \'AIR\'\"></md-icon><div ng-if=\"vm.booking_data.search_param.mode == \'AIR\'\">\n<md-icon class=\"fg-333333 icon-bs\" md-font-icon=\"icon-airplane\"></md-icon></div></div><div flex=\"94\" layout=\"row\" \nlayout-xs=\"column\" class=\"w-full\"><div layout=\"column\" flex=\"40\" flex-xs=\"100\" class=\"pr-20\" \nng-if=\"vm.booking_data.search_param.mode != \'AIR\'\"><label class=\"mb-6\">Liner/Carrier</label><div><img \nclass=\"comp_logo\" ng-if=\"vm.bookingRates[0].sub_vendor.logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.bookingRates[0].sub_vendor.logo)}}\" \nalt=\"{{ vm.bookingRates[0].sub_vendor.sub_vendor_name }}\"> <span ng-if=\"!vm.bookingRates[0].sub_vendor.logo\" \nclass=\"text-truncate font-size-20\">{{vm.bookingRates[0].sub_vendor.sub_vendor_name}}</span><md-tooltip \nmd-direction=\"top\" class=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.bookingRates[0].sub_vendor.sub_vendor_name }}</md-tooltip></div></div><div layout=\"column\" flex=\"40\" \nflex-xs=\"100\" class=\"pr-20\" ng-if=\"vm.booking_data.search_param.mode == \'AIR\'\"><label class=\"mb-6\">Airline</label><div>\n<span class=\"text-truncate font-size-20\">{{vm.bookingRates[0].airline.air_line_name}}</span><md-tooltip \nmd-direction=\"top\" class=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\n{{ vm.bookingRates[0].airline.air_line_name }}</md-tooltip></div></div><div layout=\"column\" flex=\"30\" \nclass=\"mobile-spacing pr-20\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.price_id && vm.util.showRateIdForContract(vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.tags)\">\n<label>Rate ID</label><div layout=\"row\" layout-align=\"start center\" class=\"panel-select-disabled input_box mt-5\"><div>\n<input class=\"custom-input pl-5\" name=\"fcl_destination_port\" \nng-model=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.price_id\" \nplaceholder=\"Destination Port\" readonly=\"readonly\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity:1\"><div class=\"tooltip-width-control\">\n{{ vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.price_id }}</div></md-tooltip></div>\n</div></div><div layout=\"column\" flex=\"30\" class=\"mobile-spacing pr-20\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.contract_number && !vm.util.isShipper && (!vm.booking_data.card_item.meta.type.includes(\'network\') || vm.showContractId)\">\n<label>Contract ID<md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control\" style=\"display:table;opacity: 1\">\nContract / Rate Agreement / Tariff / Spot Pricing Reference Number</md-tooltip></label><div layout=\"row\" \nlayout-align=\"start center\" class=\"panel-select-disabled input_box mt-5\"><div><input class=\"custom-input pl-5\" \nng-model=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.contract_number\" \nreadonly=\"readonly\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10 tooltip-width-control\" style=\"display:table;opacity:1\"><div\n class=\"tooltip-width-control\">\n{{ vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.contract_number }}</div></md-tooltip>\n</div></div></div></div></div><div layout=\"row\" flex=\"100\" class=\"mt-20\" \nng-if=\"vm.booking_data.search_param.mode != \'AIR\'\"><div layout-align=\"start start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'/assets/icons/custom/Schedule icon filled.svg\')\" class=\"icon-bs\"></div></div><div \nlayout=\"row\" layout-xs=\"column\" flex=\"94\" class=\"w-full\"><div layout=\"column\" flex=\"40\" flex-xs=\"100\" class=\"pr-20\">\n<label class=\"mb-6\">Schedule</label><port-to-port class=\"full-width\" card=\"vm.booking_data.card_item\" \nbuyorsell=\"vm.booking_data.buyOrSell\" mode=\"vm.booking_data.search_param.mode\" \nng-if=\"vm.booking_data.card_item.meta.selected_schedule && vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.schedule.data.length\">\n</port-to-port><div \nng-if=\"!vm.booking_data.card_item.meta.selected_schedule && vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.schedule.data.length\" \nclass=\"Font-Bold\">Schedule not selected.</div><div \nng-if=\"!vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.schedule.data.length\" \nclass=\"Font-Bold\">Schedules not available.</div></div><div layout=\"column\" flex=\"15\" flex-xs=\"100\" class=\"pr-20\" \nng-class=\"{\' pt-35\': vm.booking_data.card_item.meta.selected_schedule}\" \nng-if=\"vm.booking_data.card_item.meta.selected_schedule.departure_time || vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.sailing_date\">\n<label class=\"sub-label\">Sailing Date</label><div class=\"sub-heading text-truncate Font-Bold\" \nng-bind=\"(vm.booking_data.card_item.meta.selected_schedule.departure_time ? vm.booking_data.card_item.meta.selected_schedule.departure_time : vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\')\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{vm.booking_data.card_item.meta.selected_schedule.departure_time ? vm.booking_data.card_item.meta.selected_schedule.departure_time : vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\' }}\n</md-tooltip></div></div><div layout=\"column\" flex=\"15\" flex-xs=\"100\" class=\"pr-20\" \nng-class=\"{\' pt-35\': vm.booking_data.card_item.meta.selected_schedule}\" \nng-if=\"vm.booking_data.card_item.meta.selected_schedule.transit_time ||  vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time \">\n<label class=\"sub-label\">Transit Time</label><div class=\"sub-heading text-truncate Font-Bold\" \nng-bind=\"vm.booking_data.card_item.meta.selected_schedule ?(!vm.booking_data.card_item.meta.selected_schedule.transit_time ? \'-\' : vm.booking_data.card_item.meta.selected_schedule.transit_time) : (!vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time ? \'-\' :  vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time )\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{vm.booking_data.card_item.meta.selected_schedule ?(!vm.booking_data.card_item.meta.selected_schedule.transit_time ? \'-\' : vm.booking_data.card_item.meta.selected_schedule.transit_time) : (!vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time ? \'-\' : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.transit_time )}}\n</md-tooltip></div></div><div layout=\"column\" flex=\"15\" flex-xs=\"100\" class=\"pr-20\" \nng-class=\"{\' pt-35\': vm.booking_data.card_item.meta.selected_schedule}\" \nng-if=\"vm.booking_data.search_param.mode != \'AIR\'\"><label class=\"sub-label\">Free Days</label><div \nclass=\"sub-heading text-truncate Font-Bold\"><free-days \nfreedaysdata=\"{\n              demurrage_details : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.demurrage_details,\n              detention_details :vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.detention_details,\n              combined_details :  vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.combined_details,\n              freeDays : vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.freeDays,\n              pageSource : \'BS\'\n            }\" \ntype=\"\'list-nwls\'\" cardid=\"\'meta-\'+vm.booking_data.card_item._id\" mode=\"vm.booking_data.search_param.mode\" \nsearch-load-data=\"vm.booking_data.search_param.load_data.load_details_value\"></free-days></div></div><div \nlayout=\"column\" ng-class=\"{\' pt-35\': vm.booking_data.card_item.meta.selected_schedule}\" \nng-if=\"vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date || vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry\" \nflex=\"20\" flex-xs=\"100\" class=\"pr-20\"><label class=\"sub-label\">Effective Period</label><div layout=\"row\"><div \nclass=\"sub-heading Font-Bold text-truncate\" \nng-if=\"vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry && vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\"}} - {{vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry| NoTimeZone: \"dd MMM yyyy\"}}\n</md-tooltip>\n{{vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\"}} - {{vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry | NoTimeZone: \"dd MMM yyyy\"}}\n</div><div class=\"sub-heading Font-Bold text-truncate\" \nng-if=\"vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry && !vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ \"Till \" + (vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry | NoTimeZone: \"dd MMM yyyy\")}}\n</md-tooltip>\n{{ \"Till \" + (vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry | NoTimeZone: \"dd MMM yyyy\")}}</div>\n<div class=\"sub-heading Font-Bold text-truncate\" \nng-if=\"!vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.expiry && vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ \"From \" + (vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\")}}\n</md-tooltip>\n{{ \"From \" + (vm.booking_data.card_item.data.buy_rates[vm.l3_leg].rate_obj.start_date | NoTimeZone: \"dd MMM yyyy\")}}\n</div><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer effective-period-{{vm.booking_data.card_item._id}}\" \nng-if=\"vm.util.fnCheckLoadExpiryLength(vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.detailed_effective_load , vm.booking_data.search_param.load_data.load_details_value) && vm.booking_data.search_param.mode === \'SEA-FCL\' \" \nng-click=\"vm.shareQuoteService.showEffectivePeriodPanel($event,vm.booking_data.card_item._id,vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.detailed_effective_load , vm.booking_data.search_param.load_data.load_details_value)\">\n</md-icon></div></div><div layout=\"column\" flex=\"20\" flex-xs=\"100\" class=\"pr-20\" \nng-class=\"{\'pt-35\': vm.booking_data.card_item.meta.selected_schedule}\" ng-if=\"vm.booking_data.card_item.meta.co2eData\">\n<label class=\"sub-label\"><md-icon md-svg-src=\"assets/icons/custom/co2-icon.svg\" class=\"icon-class-10 mr-5\"></md-icon>CO\n<sub>2</sub> emission</label><div class=\"sub-heading Font-Bold line-height-12\" layout=\"row\"><div class=\"text-truncate\">\n{{(vm.booking_data.card_item.meta.co2eData.co2e.total | currencyMask: 2) +\' \' +\'g\'}}</div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s14 margin-dropdown fg-3F3851 pointer co2e-{{vm.booking_data.card_item._id}}\" \nng-click=\"vm.shareQuoteService.showCo2ContainerData($event, vm.booking_data.card_item._id, vm.booking_data.card_item.meta.co2eData)\">\n</md-icon></div></div></div></div><div class=\"mt-20\" \nng-if=\"vm.booking_data.card_item.meta.port_data.pickup_pincode_ui || vm.booking_data.card_item.meta.port_data.delivery_pincode_ui\">\n<div layout=\"row\" flex=\"100\"><div layout-align=\"start start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'assets/icons/custom/address-2-aaa8ad.svg\')\" class=\"icon-bs address-icon\"></div></div><div\n flex=\"94\" layout=\"column\"><label class=\"mb-6\">Address Details</label></div></div><div layout=\"row\" layout-xs=\"column\" \nflex=\"100\" class=\"ml-45 address-cards-container\"><div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"mr-15 mb-xs-20\" \nng-if=\"vm.booking_data.card_item.meta.port_data.pickup_pincode_ui\"><div class=\"address-card\"><div \nclass=\"card-title p-10 mb-10 bb\" layout=\"row\" layout-align=\"space-between center\"><div>Pick Up</div><div \nclass=\"pointer md-link-fg\" ng-click=\"vm.clearAdresses(\'origin_address\')\">Clear</div></div><div \nclass=\"address-form-content p-10\"><door-address address-data=\"vm.booking_data.origin_address\" label=\"Pick Up\">\n</door-address></div></div></div><div flex=\"50\" flex-xs=\"100\" layout=\"column\" \nng-if=\"vm.booking_data.card_item.meta.port_data.delivery_pincode_ui\"><div class=\"address-card\"><div \nclass=\"card-title p-10 mb-10 bb\" layout=\"row\" layout-align=\"space-between center\"><div>Delivery</div><div \nclass=\"pointer md-link-fg\" ng-click=\"vm.clearAdresses(\'destination_address\')\">Clear</div></div><div \nclass=\"address-form-content p-10\"><door-address address-data=\"vm.booking_data.destination_address\" label=\"Delivery\">\n</door-address></div></div></div></div></div><div class=\"mt-20\" \nng-if=\"vm.booking_data.card_item.meta.port_data.pickup_pincode_ui || vm.booking_data.card_item.meta.port_data.delivery_pincode_ui\">\n<div layout=\"row\" flex=\"100\"><div layout-align=\"start start\" class=\"pr-20\"><md-icon \nmd-svg-src=\"assets/icons/custom/map-pin.svg\"></md-icon></div><div flex=\"94\" layout=\"row\"><label class=\"mb-6\">\nTransportation</label></div></div><div layout=\"row\" flex=\"100\" class=\"pb-5\"><div layout-align=\"start start\" \nclass=\"w-45\"></div><div flex=\"94\" layout=\"row\" layout-wrap><div class=\"pr-20\" \nng-if=\"vm.booking_data.card_item.meta.port_data.pickup_pincode_ui\"><label class=\"sub-label pb-4\">Pickup Haulage</label>\n<div class=\"Font-Bold\"><md-icon class=\"haulage-icon\" \nng-if=\"vm.booking_data.card_item.meta.pickup_transport_mode && (vm.booking_data.card_item.meta.pickup_transport_mode.toLowerCase() == \'road\' ||vm.booking_data.card_item.meta.pickup_transport_mode.toLowerCase() == \'barge\' || vm.booking_data.card_item.meta.pickup_transport_mode.toLowerCase() == \'rail\' || vm.booking_data.card_item.meta.pickup_transport_mode.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+vm.booking_data.card_item.meta.pickup_transport_mode.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon>\n{{vm.booking_data.card_item.meta.pickup_transport_mode ? vm.booking_data.card_item.meta.pickup_transport_mode : \'-\'}}\n</div></div><div class=\"pr-20\" ng-if=\"vm.booking_data.card_item.meta.port_data.pickup_pincode_ui\"><label \nclass=\"sub-label pb-4\">Pickup Transporter</label><div class=\"sub-heading text-truncate Font-Bold w-150\"><md-icon \nmd-svg-src=\"assets/icons/custom/user-icon.svg\" class=\"icon-align\" \nng-if=\"vm.booking_data.card_item.meta.pickup_sub_vendor\"></md-icon>\n{{vm.booking_data.card_item.meta.pickup_sub_vendor ? vm.booking_data.card_item.meta.pickup_sub_vendor.sub_vendor_name : \'-\'}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{vm.booking_data.card_item.meta.pickup_sub_vendor ? vm.booking_data.card_item.meta.pickup_sub_vendor.sub_vendor_name : \'-\'}}\n</md-tooltip></div></div><div class=\"pr-20\" ng-if=\"vm.booking_data.card_item.meta.port_data.delivery_pincode_ui\"><label\n class=\"sub-label pb-4\">Delivery Haulage</label><div class=\"Font-Bold\"><md-icon class=\"haulage-icon\" \nng-if=\"vm.booking_data.card_item.meta.delivery_transport_mode && (vm.booking_data.card_item.meta. delivery_transport_mode.toLowerCase() == \'road\' ||vm.booking_data.card_item.meta. delivery_transport_mode.toLowerCase() == \'barge\' || vm.booking_data.card_item.meta. delivery_transport_mode.toLowerCase() == \'rail\' || vm.booking_data.card_item.meta. delivery_transport_mode.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+vm.booking_data.card_item.meta. delivery_transport_mode.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon>\n{{vm.booking_data.card_item.meta.delivery_transport_mode ? vm.booking_data.card_item.meta.delivery_transport_mode : \'-\'}}\n</div></div><div class=\"pr-20\" ng-if=\"vm.booking_data.card_item.meta.port_data.delivery_pincode_ui\"><label \nclass=\"sub-label pb-4\">Delivery Transporter</label><div class=\"sub-heading text-truncate Font-Bold w-150\"><md-icon \nmd-svg-src=\"assets/icons/custom/user-icon.svg\" class=\"icon-align\" \nng-if=\"vm.booking_data.card_item.meta.delivery_sub_vendor\"></md-icon>\n{{vm.booking_data.card_item.meta.delivery_sub_vendor ? vm.booking_data.card_item.meta.delivery_sub_vendor.sub_vendor_name : \'-\'}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{vm.booking_data.card_item.meta.delivery_sub_vendor ? vm.booking_data.card_item.meta.delivery_sub_vendor.sub_vendor_name : \'-\'}}\n</md-tooltip></div></div></div></div></div><div layout=\"row\" flex=\"100\" class=\"mt-20\"><div layout-align=\"start start\" \nclass=\"pr-20\"><div ng-show=\"vm.booking_data.search_param.mode == \'SEA-FCL\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/load_type.svg\')\" class=\"icon-bs\"></div><div \nng-if=\"vm.booking_data.search_param.mode != \'SEA-FCL\'\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/load_detail.svg\')\" class=\"icon-bs\"></div></div><div \nflex=\"94\" layout=\"row\" ng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\'\" id=\"edit-load\" class=\"w-full\"><div><div \nlayout=\"row\" layout-wrap><div flex=\"25\" flex-sm=\"20\" flex-md=\"20\" class=\"pr-20\" layout=\"column\" \nlayout-align=\"start start\"><div>Load Type</div></div><div flex=\"20\" flex-sm=\"15\" flex-md=\"15\" layout=\"column\" \nclass=\"pr-20\" layout-align=\"start start\"><div>QTY</div></div><div flex=\"35\" flex-sm=\"35\" flex-md=\"35\" layout=\"column\" \nlayout-align=\"start start \"><div>Total Shipment Weight</div></div></div><form name=\"loadSubmit\" \nng-submit=\"vm.fnSaveLoadQty($event)\" class=\"nwls-load-div\"><div layout=\"row\" layout-wrap \nng-repeat=\"loadDetail in vm.booking_data.search_param.load_data.load_details_value track by $index\" \nng-init=\"loadTypeLast = $last\"><div flex=\"25\" flex-sm=\"20\" flex-md=\"20\" layout=\"column\" layout-align=\"start center\" \nclass=\"pr-20\"><md-input-container md-no-float class=\"panel-select-disabled input_box input_box_disabled mv-0\"><input \nname=\"load_type\" class=\"pl-5 mt-2\" ng-model=\"loadDetail.type\" placeholder=\"Load Type\" readonly=\"readonly\">\n</md-input-container></div><div flex=\"20\" flex-sm=\"15\" flex-md=\"15\" layout=\"column\" layout-align=\"start center\" \nclass=\"pr-20\"><div><md-input-container md-no-float class=\"mt-5 mv-0\" ng-if=\"!vm.isShared\"><input class=\"load-qty\" \nplaceholder=\"Qty\" type=\"number\" restrict-to=\"[0-9]\" min=\"1\" max=\"100\" ng-model=\"loadDetail.qty\" \nng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.fnChangeQty(loadDetail);vm.loadBtnDisplay=true\">\n</md-input-container><md-input-container ng-if=\"vm.isShared\" md-no-float \nclass=\"panel-select-disabled input_box input_box_disabled mv-0\"><input name=\"load_qty\" class=\"pl-5 mt-2\" \nng-model=\"loadDetail.qty\" placeholder=\"Load Qty\" readonly=\"readonly\"></md-input-container></div></div><div flex=\"45\" \nflex-sm=\"60\" flex-md=\"60\" layout=\"column\" layout-align=\"start center\" class=\"pr-20\"><div layout=\"row\" \nng-repeat=\"loadMetrics in loadDetail.load_metrics track by $index\" \nng-class=\"{\'mt-10\' :  $index>=1 ,\'mt-6\': $index==0,\'mb-20\' : $last}\" class=\"min-width-100\"><div><div layout=\"row\" \nlayout-align=\"start start\" class=\"responsive_div\"><div layout=\"row\" \nclass=\"load_div p-2 panel-select w-145 brad-5 h-26\" ng-if=\"!vm.isShared\"><md-input-container md-no-float \nclass=\"m-0 p-0 h-30\"><input name=\"total_weight\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"loadMetrics.weight_qty\" \nplaceholder=\"Weight\" class=\"bb-0 insurance_input h-26\" ng-change=\"vm.loadBtnDisplay=true;vm.checkLoad=true\">\n</md-input-container><md-select name=\"input_weight_unit\" class=\"m-0 load_border_clr ph-5\" \nng-model=\"loadMetrics.weight_unit\" ng-change=\"vm.loadBtnDisplay=true;vm.checkLoad=true\"><md-option value=\"KGs\">KG\n</md-option></md-select></div><div layout=\"row\" class=\"p-2 panel-select-disabled w-145 brad-5 h-26\" \nng-if=\"vm.isShared\"><md-input-container md-no-float class=\"m-0 p-0 h-30\"><input name=\"total_weight\" type=\"number\" \nng-model=\"loadMetrics.weight_qty\" placeholder=\"Weight\" class=\"bb-0 pl-5 insurance_input h-26\" readonly=\"readonly\">\n</md-input-container><md-input-container md-no-float class=\"m-0 p-0 h-30\"><input name=\"total_weight_unit\" \nng-model=\"loadMetrics.weight_unit\" class=\"bb-0 insurance_input h-26\" readonly=\"readonly\"></md-input-container></div>\n<div class=\"responsive_div\"><div ng-if=\"vm.loadBtnDisplay\" hide-xs layout=\"row\"><md-button \nng-if=\"$last && loadTypeLast && !vm.isShared && !(vm.saveBtnDisplay && !vm.loadBtnDisplay)\" md-no-ink \nng-click=\"vm.resetLoad();\" class=\"md-primary-btn mv-0 ml-20\" type=\"button\">Cancel</md-button><md-button \nng-if=\"$last && loadTypeLast && !vm.isShared\" md-no-ink class=\"md-accent-btn ml-10 mv-0\" type=\"submit\" \nng-disabled=\"vm.loadBtn\">Save<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\nSave changes made to all the load types</md-tooltip></md-button></div><div \nng-if=\"vm.saveBtnDisplay && !vm.loadBtnDisplay\" class=\"mt-10\"><div ng-if=\"$last && loadTypeLast && !vm.isShared\" \nclass=\"alert-success\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"mh-5 s16\"></md-icon>Saved</div></div>\n</div></div></div></div></div><div><div ng-if=\"vm.loadBtnDisplay\" layout-align=\"center center\" class=\"wrap mb-20\" hide \nshow-xs layout=\"row\"><md-button \nng-if=\"$last && loadTypeLast && !vm.isShared && !(vm.saveBtnDisplay && !vm.loadBtnDisplay)\" md-no-ink \nng-click=\"vm.resetLoad()\" class=\"md-primary-btn mv-0 mt-10\" type=\"button\">Cancel</md-button><md-button \nng-if=\"$last && loadTypeLast && !vm.isShared\" ng-click=\"vm.trackEvent(\'BookingDetails-EditSave\')\" md-no-ink \nclass=\"md-accent-btn ml-10 mv-0 mt-10\" type=\"submit\" ng-disabled=\"vm.loadBtn\">Save<md-tooltip md-direction=\"top\" \nclass=\"font-size-12 white-fg bg-343434 Font-Bold pv-5 ph-10\" style=\"display:table;opacity:1\">\nSave changes made to all the load types</md-tooltip></md-button></div></div></div></form></div></div><div flex=\"94\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap flex=\"100\" \nng-if=\"vm.booking_data.search_param.mode == \'SEA-LCL\'\"><div ng-repeat=\"loadDetail in vm.lclLoadArray\" \nng-if=\"loadDetail.value != \'N/A\'\" class=\"w-190 mb-20 mr-20\"><label>{{ loadDetail.name }}</label><md-input-container \nmd-no-float class=\"input_box mv-0 panel-select-disabled\"><input name=\" {{ loadDetail.name }} \" class=\"bb-0\" \nng-model=\"loadDetail.value\" readonly=\"readonly\"></md-input-container></div></div><div flex=\"94\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\" layout-wrap flex=\"100\" \nng-if=\"vm.booking_data.search_param.mode == \'AIR\'\"><div ng-repeat=\"loadDetail in vm.airLoadArray\" \nng-if=\"loadDetail.value != \'N/A\'\" class=\"w-190 mb-20 mr-20\"><label>{{ loadDetail.name }}</label><md-input-container \nmd-no-float class=\"input_box mv-0 panel-select-disabled\"><input name=\" {{ loadDetail.name }} \" class=\"bb-0\" \nng-model=\"loadDetail.value\" readonly=\"readonly\"></md-input-container></div></div></div><div layout=\"row\" flex=\"100\">\n<div layout-align=\"start start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'assets/images/fb_shipper/Image 279.png\')\" class=\"icon-bs-big\"></div></div><div \nlayout=\"row\" layout-xs=\"column\" class=\"w-full\"><div layout=\"column\" flex=\"25\" flex-xs=\"100\" class=\"pr-20\"><label \nclass=\"mb-6\">Cargo Type</label><div><cargo-type-selection id=\"book-cargo-type\" \ncargo-type-data=\"vm.booking_data.commodity.cargo_type\" callback=\"vm.cargoTypeChange()\" full-border=\"true\" \nis-required=\"true\" hazardous-value=\"vm.booking_data.commodity.hazardous\" ng-keyup=\"vm.cargoValidationError= false;\" \nng-if=\"!vm.isCargoTypeDisabled\" category=\"\'booking\'\" page-source=\"\'BS\'\" is-valid=\"false\" \nmode=\"vm.booking_data.search_param.mode\"></cargo-type-selection><md-input-container md-no-float \nclass=\"w-full mv-0 panel-select-disabled\" ng-if=\"vm.isCargoTypeDisabled\"><input name=\"cargo_type\" class=\"bb-0\" \nng-model=\"vm.booking_data.commodity.cargo_type.name\" readonly=\"readonly\"></md-input-container></div></div><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"mobile-spacing pr-20\"><label class=\"mb-9\">Commodity</label>\n<md-input-container md-no-float class=\"mv-0 commodity_input\" ng-class=\"{\'validation-error-auto\':vm.requiredCommodity}\" \nng-keyup=\"vm.requiredCommodity=false;\"><commodity-chips is-valid=\"vm.requiredCommodity\" \nmd-input-id=\"\'commodity_id_web\'\" commodity-array=\"vm.booking_data.commodity.commodity_data\" category=\"\'booking\'\">\n</commodity-chips><div ng-if=\"vm.requiredCommodity\" class=\"validation-error-text\"><span>Enter the Commodity to proceed\n</span></div></md-input-container></div><div layout=\"column\" flex=\"25\" flex-xs=\"100\" class=\"mobile-spacing pr-20\">\n<label>HS Code</label><md-input-container md-no-float class=\"input_box mv-0 panel-select\"><input name=\"hs_code\" \nclass=\"bb-0\" ng-model=\"vm.booking_data.commodity.hs_code\" placeholder=\"Enter HS Code\"></md-input-container></div></div>\n</div><div flex-xs=\"50\" flex class=\"w-200 mt-20 ml-45 font-size-12\" ng-if=\"vm.booking_data.commodity.hazardous\"><div \nclass=\"mb-6\">IMCO Code</div><div ng-class=\"{\'input_color\' : !vm.booking_data.commodity.imco_code}\"><md-select \nclass=\"ml-10 panel-select placeholder-text\" id=\"book-imco-code\" ng-class=\"{\'validation-error\':vm.imcoValidationError}\" \nng-change=\"vm.imcoValidationError=false;\" ng-model=\"vm.booking_data.commodity.imco_code\" \nplaceholder=\"Select IMCO Code\" md-selected-html=\"vm.getImcoCodeText(vm.booking_data.commodity.imco_code)\" \nng-disabled=\"!vm.booking_data.commodity.hazardous\"><md-option class=\"mb-10\" style=\"height:100%\" ng-value=\"0\">\nSelect IMCO code</md-option><md-option class=\"mb-10\" style=\"height:100%\" \nng-repeat=\"imcoCode in vm.IMCO_CodeList track by $index\" ng-value=\"imcoCode.class_number\"><span \nclass=\"font-weight-600\">{{imcoCode.class_name}}</span><br><span class=\"gray-fg font-size-12\" \nng-repeat=\"list in imcoCode.list track by $index\">{{list}}<br></span></md-option></md-select></div><div \nng-if=\"vm.imcoValidationError\" class=\"validation-error-text\"><span>Please select imco code</span></div></div><div \nclass=\"mt-20\"><div layout=\"row\" flex=\"100\"><div layout-align=\"start start\" class=\"pr-20\"><md-icon \nmd-svg-src=\"assets/icons/custom/references.svg\" class=\"icon-bs\"></md-icon></div><div flex=\"94\" layout=\"column\" \nclass=\"w-full\"><label class=\"mb-6\">References</label><div class=\"sub_text mb-10\">Add reference details for the shipment\n</div></div></div><div class=\"ml-45 w-full\"><div class=\"references-table-container\"><table class=\"references-table\">\n<thead><tr><th>Name</th><th>Value</th><th>Internal Remarks (not processed)</th></tr></thead><tbody><tr \nng-repeat=\"reference in vm.booking_data.references track by $index\"><td><input type=\"text\" class=\"reference-input\" \nng-model=\"reference.reference_label\" placeholder=\"Enter label\" \nng-change=\"vm.updateReference($index, \'reference_label\', reference.reference_label)\" disabled=\"disabled\"></td><td>\n<input type=\"text\" class=\"reference-input\" ng-model=\"reference.reference_value\" placeholder=\"Enter value\" \nng-change=\"vm.updateReference($index, \'reference_value\', reference.reference_value)\"></td><td><input type=\"text\" \nclass=\"reference-input\" ng-model=\"reference.comment\" placeholder=\"Enter Internal Remarks\" \nng-change=\"vm.updateReference($index, \'comment\', reference.comment)\"></td></tr></tbody></table></div></div></div></div>\n</div><div><div class=\"layout-card booking-spacing-responsive\" flex-sm=\"100\" flex-xs=\"100\"><div \nng-include=\"\'app/main/result/bookShipment/parties-involved.html\'\"></div></div></div><br hide show-gt-sm><br hide \nshow-gt-sm><br hide show-gt-sm></div><div flex-sm=\"100\" flex=\"30\" flex-xs=\"100\" class=\"fg-333333 rate-summary-size\">\n<div class=\"layout-card rate-spacing-responsive\" flex=\"100\" layout=\"column\"><div><div class=\"pb-20\"><div \nclass=\"font-size-16 mb-10 Font-Bold bb\"><div class=\"p-20\">Rate Summary</div></div><div class=\"p-20\" \nng-if=\"!(vm.booking_data.all_in_quote_setting == \'all_in_total\' && vm.util.isShipper)\"><div layout=\"column\" \nclass=\"mb-5\" ng-repeat=\"(key, leg_value) in vm.bookingRates track by $index\" \nng-hide=\"leg_value.leg_code == \'other_charges_fcl\' || (leg_value.leg_code == vm.l3_leg && (!vm.booking_data.search_param.freight_charges || !leg_value.charges.length))\">\n<div layout=\"row\" layout-align=\"space-between\"><div class=\"mb-5 font-size-13 mr-5\">\n{{leg_value.leg_code == vm.l3_leg && leg_value.leg_name == vm.mainFreightName ? \'Freight\' : leg_value.leg_name }}\n<md-icon md-font-icon=\"icon-information-outline\n                        \" class=\"s12 mb-3 indigo-100-fg pointer\" \nng-if=\"leg_value.leg_code == vm.l3_leg && leg_value.rate_type.includes(\'spot\')\"><md-tooltip md-direction=\"right\" \nclass=\"white-fg bg-343434 font-size-12 pv-5 ph-10 Font-Bold\" style=\"display:table;opacity:1\">Spot Rates are dynamic &\n<br>can fluctuate with time</md-tooltip></md-icon></div><div class=\"mb-5 font-size-13 Font-Bold text-right\">\n{{ leg_value.leg_currency + \' \' + (leg_value.leg_currency_cost | currencyMask: 2) }}</div></div></div></div><div><a \nclass=\"pointer p-20 md-link-fg Font-Bold\" \nng-click=\"vm.util.redirectToExchangeRatesLink(vm.resultType, vm.booking_data.id, vm.booking_data.card_item.meta.vendor_id, \'\', {\'Mode\':vm.booking_data.search_param.mode,\'pageSource\':vm.booking_data.page ==\'quote\' ? \'Quotes\': \'Instant Rates\'})\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div><div \nclass=\"p-20 bt bb mt-20\" ng-show=\"!vm.showSpotLoader\" \nng-if=\"vm.booking_data.search_param.mode == \'SEA-FCL\' && vm.booking_data.card_item.meta.additional_charges.data\"><div \nlayout=\"row\" layout-align=\"space-between\"><div class=\"font-size-13\" layout=\"row\" layout-align=\"center center\">\n{{vm.bookingRates[vm.convenienceIndex].leg_name}}<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s12 mh-5 pointer\"><md-tooltip md-direction=\"left\" class=\"white-fg bg-343434 font-size-12 pv-5 ph-10 Font-Bold\" \nstyle=\"display:table;opacity:1;max-width: 20%; word-wrap: break-word; white-space: unset\">\nConvenience Fee includes operations, credit & platform cost</md-tooltip></md-icon></div><div><div \nclass=\"red-fg-fee Font-Bold\">\n{{vm.bookingRates[vm.convenienceIndex].charges[0].charge_currency}} {{vm.bookingRates[vm.convenienceIndex].charges[0].leg_currency_cost | currencyMask: 2 }}\n</div><div class=\"grey-fg font-size-10\" ng-if=\"vm.couponData.chargeCost\"><strike>\n{{vm.bookingRates[vm.convenienceIndex].charges[0].charge_currency}} {{vm.couponData.chargeCost}}</strike></div></div>\n</div></div><div layout=\"row\" class=\"mt-20\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"30\" ng-show=\"vm.showSpotLoader\"></md-progress-circular></div></div><div class=\"p-20\"><div layout=\"column\">\n<div ng-if=\"!$root.domainData.domain_info.HIDE_BOOKING_COUPON\"><div class=\"Font-Bold mv-10 font-size-12\">\n{{(vm.prevLegCost || vm.couponData.chargeCost) ? \'APPLIED COUPON\' : \'ENTER COUPON CODE\'}}</div><div flex=\"100\" \nlayout=\"row\" class=\"pv-10 ph-10 border mb-10 coupon-code\" ng-if=\"!vm.prevLegCost && !vm.couponData.chargeCost\"><div \nflex=\"80\" layout=\"row\" layout-align=\"start center\"><input ng-keyup=\"vm.cleanInput()\" name=\"hs_code Font-ExtraBold\" \nclass=\"borderless Font-ExtraBold\" ng-model=\"vm.codeToSend\" placeholder=\"Enter coupon code\"></div><div flex=\"20\" \nlayout=\"row\" layout-align=\"end end\"><div ng-show=\"!vm.appliedCode\" \nclass=\"md-primary-fg font-size-12 text-uppercase Font-Bold pointer\" ng-click=\"vm.applyCoupon(vm.codeToSend);\">APPLY\n</div><md-progress-circular ng-show=\"vm.appliedCode\" md-mode=\"indeterminate\" md-diameter=\"19.5px\">\n</md-progress-circular></div></div><div ng-if=\"vm.codeSuccess\" class=\"mb-20\" layout=\"row\" layout-align=\"space-between\">\n<div layout=\"row\"><div class=\"second-color font-size-14 Font-Bold\"><img class=\"h-20 w-20 mr-10\" \nsrc=\"assets/icons/custom/approved-signal.svg\"></div><div class=\"second-color font-size-14 Font-Bold\">{{vm.codeMessage}}\n</div></div><div class=\"red-500-fg pl-5 font-size-14 Font-Bold pointer\" ng-click=\"vm.resetCoupon()\">remove</div></div>\n<div ng-if=\"vm.codeSuccess === false\" class=\"red-500-fg font-size-14 Font-Bold mb-20\" layout=\"row\" \nlayout-align=\"center center\">{{vm.codeMessage}}</div></div><div class=\"font-size-13 Font-Bold\" layout=\"row\" \nlayout-align=\"center center\">Total Charges</div><div class=\"font-size-17 text-uppercase Font-Bold\" layout=\"row\" \nlayout-align=\"center center\">{{ vm.booking_data.user.user_base_currency }} <span class=\"ml-5\">\n{{ (vm.booking_data.card_item.meta.card_total_cost | currencyMask: 2) }}</span></div></div></div></div><div \nlayout=\"row\" layout-align=\"space-between\" class=\"pt-15 ph-15 pb-5\" \nng-if=\"vm.booking_data.card_item.meta.applied_special_meta\"><div class=\"light-blue-400-fg font-size-16 Font-Bold mr-8\">\n<span ng-if=\"vm.bookingL3_rates[0].promotions.length\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"light-blue-400-fg s18 mb-2 mr-5\"></md-icon><span \nng-repeat=\"promotion in vm.bookingL3_rates[0].promotions track by $index\">{{$first ? \'\' : \', \'}} {{promotion.name}}\n</span></span></div><div class=\"red-fg font-size-16 Font-Bold\"><md-icon md-font-icon=\"icon-fire\" \nclass=\"red-fg s18 mb-2 mr-5\"></md-icon>\nOnly {{vm.booking_data.card_item.meta.applied_special_meta.special_qty_rem.TEUs}} Left</div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-10 pl-20 font-size-11\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details\"><span \nclass=\"fg-333333 word-break\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details.penalty_fees.length\">\n{{vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details.penalty_message}} \n</span><a class=\"md-link-fg ml-5 pointer Font-Bold\" \nng-if=\"vm.booking_data.card_item.data[vm.booking_data.buyOrSell][vm.l3_leg].rate_obj.penalty_details.penalty_fees.length\" \nng-click=\"vm.fnDisplayPenalty($event)\">Learn more</a></div><div class=\"font-size-13 ph-20 pv-5\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"(!!vm.remarks || !!vm.inclusions)\"><span><md-checkbox md-no-ink \nng-model=\"vm.checkRemarksIncl\" ng-click=\"vm.remarksValidation=false\" class=\"md-primary s18 m-0\"></md-checkbox></span>\n<div class=\"pl-10\"><span>Subject to</span> <span class=\"md-link-fg Font-Bold pl-5 pointer\">Remarks and inclusions\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 p-10 font-size-14\" \nstyle=\"opacity: 1;max-width: 328px;height: unset;line-height: 1.8\"><div class=\"Font-Bold\">REMARKS</div><div \nclass=\"font-size-12\" style=\"white-space: pre-wrap\" compile-html=\"vm.remarks ? vm.util.decodeValue(vm.remarks) : \' - \'\">\n</div><div class=\"Font-Bold pt-5\">INCLUSIONS</div><div class=\"font-size-12\" style=\"white-space: pre-wrap\" \ncompile-html=\"vm.inclusions ? vm.util.decodeValue(vm.inclusions) : \'-\'\"></div></md-tooltip></span></div></div><div \nlayout-align=\"center center\" ng-if=\"vm.remarksValidation\" class=\"pl-50 validation-error-text\"><span>\nPlease agree to Remarks & Inclusions</span></div><md-button md-no-ink class=\"md-accent-btn m-20 Font-Bold\" \nng-click=\"vm.confirmBooking()\" ng-disabled=\"vm.confirm_btn || vm.showSpotLoader\" \nng-style=\"{ \'cursor\' : (vm.confirm_btn == true)  ? \'not-allowed\' : \'pointer\' }\"><md-icon \nng-if=\"vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status && vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>Request Booking\n<md-tooltip md-direction=\"top\" \nng-if=\"vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status && vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.code == 1002 && vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{vm.booking_data.card_item.data.sell_rates[vm.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip>\n</md-button></div></div></div></div>");
$templateCache.put("app/main/result/bookShipment/confirm_booking.html","<div id=\"confirm-booking\"><div class=\"p-20 white-bg toolbar\" layout=\"row\"><div class=\"bookShipmentHeading\" flex=\"95\">\nBooking Confirmed</div><div layout=\"row\" layout-align=\"end end\" flex=\"20\"><md-icon md-font-icon=\"icon-close\" \nclass=\"mr-5 s16 pointer\" ng-click=\"vm.redirectOnClose()\"></md-icon></div></div><md-divider></md-divider><md-content \nclass=\"confirm-shiment\"><div layout=\"column\" layout-align=\"center center\" class=\"p-100\"><md-icon class=\"tick_mark\" \nmd-svg-src=\"assets/icons/custom/tick-mark-icon.svg\"></md-icon><p class=\"font-size-20 text-bold text-center\">\nCongratulations ! Your Booking ID \" <a ng-if=\"!vm.quoteShare\" class=\"shipment_id md-link-fg pointer\" \nng-click=\"vm.goToShipmentDetail()\">{{ vm.bookResponseData.shipment_id }} </a><a ng-if=\"vm.quoteShare\" \nclass=\"shipment_id\">{{ vm.bookResponseData.shipment_id }} </a>\" has been requested successfully</p><p \nclass=\"text-center\">You shall receive a call from our team within 24 Hours</p><p class=\"m-0 text-center\">\nto verify & process your Booking further</p><a ng-if=\"!vm.quoteShare\" class=\"return_to md-link-fg text-center pointer\" \nng-click=\"vm.goToShipmentDetail()\"><u>View Booking here</u></a></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"$root.domainData.domain_info.TOLL_FREE_CONTACT.length > 0\"><p class=\"need_ast\">\nNeed assistance? Call: {{$root.domainData.domain_info.TOLL_FREE_CONTACT}}</p></div></md-content></div>");
$templateCache.put("app/main/result/bookShipment/parties-involved.html","<div id=\"parties-involved-Shipment\" class=\"fg-333333\"><div class=\"font-size-16 p-20 bb\" layout=\"row\"><div class=\"pt-3\">\n<span>Parties Involved Details </span></div></div><div class=\"ph-20\" layout-xs=\"column\" layout=\"row\"><div flex-xs \nflex-gt-xs=\"100\" layout=\"column\"><div><md-content class=\"border charge_table mv-20\"><table class=\"simple\" \nms-responsive-table><thead class=\"table-header-bg\"><tr><th class=\"br\" width=\"35%\"><div class=\"column-title\">\nParties Involved</div></th><th width=\"65%\"><div class=\"column-title pl-10\">Details</div></th></tr></thead><tbody><tr \nng-if=\"!vm.util.isShipper\"><td class=\"br parties-value bv-0 pl-30\" rowspan=\"1\">Customer</td><td class=\"bv-0 pr-10\"><div\n layout=\"row\" ng-if=\"vm.partyView.shipper\"><div>{{vm.shipper.name}}<br><span class=\"parties-sub-value pr-20\">\n{{vm.shipper.email}} | {{vm.shipper.company_name}}</span></div><div class=\"p-15 parties-link\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'shipper\')\">Edit</div><span class=\"p-15 parties-link\" \nng-click=\"vm.fnDeleteNewPartyModal(\'shipper\')\">Clear</span></div><div layout=\"row\" ng-if=\"!vm.partyView.shipper\"><div \nclass=\"p-15 parties-link\" ng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'shipper\')\">Add Details</div></div></td></tr><tr \nclass=\"pt-3\"><td class=\"br bv-0 parties-value pt-3\" rowspan=\"1\">Consignee</td><td class=\"bv-0 pt-3\" rowspan=\"1\"><div \nlayout=\"row\" ng-if=\"vm.partyView.consignee\"><div>{{vm.consignee.name}}<br><span class=\"parties-sub-value pr-20\">\n{{vm.consignee.email}} | {{vm.consignee.company_name}}</span></div><div class=\"p-15 parties-link\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'consignee\')\">Edit</div><span class=\"p-15 parties-link\" \nng-click=\"vm.fnDeleteNewPartyModal(\'consignee\')\">Clear</span></div><div layout=\"row\" ng-if=\"!vm.partyView.consignee\">\n<div class=\"p-15 parties-link\" ng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'consignee\')\">Add Details</div></div></td></tr>\n<tr class=\"pt-3\"><td class=\"br bv-0 parties-value pt-3\" rowspan=\"1\">Consignor</td><td class=\"bv-0 pt-3\" rowspan=\"1\">\n<div layout=\"row\" ng-if=\"vm.partyView.consignor\"><div>{{vm.consignor.name}}<br><span class=\"parties-sub-value pr-20\">\n{{vm.consignor.email}} | {{vm.consignor.company_name}}</span></div><div class=\"p-15 parties-link\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'consignor\')\">Edit</div><span class=\"p-15 parties-link\" \nng-click=\"vm.fnDeleteNewPartyModal(\'consignor\')\">Clear</span></div><div layout=\"row\" ng-if=\"!vm.partyView.consignor\">\n<div class=\"p-15 parties-link\" ng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'consignor\')\">Add Details</div></div></td></tr>\n<tr class=\"pt-3\"><td class=\"br parties-value pt-3\" ng-class=\"{\'bv-0\': vm.showShippersInParties}\" rowspan=\"1\">\nNotify party</td><td class=\"pt-3\" rowspan=\"1\" ng-class=\"{\'bv-0\': vm.showShippersInParties}\"><div layout=\"row\" \nng-if=\"vm.partyView.notifyParty\"><div>{{vm.notifyParty.name}}<br><span class=\"parties-sub-value pr-20\">\n{{vm.notifyParty.email}} | {{vm.notifyParty.company_name}} </span></div><div class=\"p-15 parties-link\" \nng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'notify_party\')\">Edit</div><span class=\"p-15 parties-link\" \nng-click=\"vm.fnDeleteNewPartyModal(\'notify_party\')\">Clear</span></div><div layout=\"row\" \nng-if=\"!vm.partyView.notifyParty\"><div class=\"p-15 parties-link\" \nng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'notify_party\')\">Add Details</div></div></td></tr><tr class=\"pt-3\" \nng-if=\"vm.showShippersInParties\"><td class=\"br parties-value pt-3\" rowspan=\"1\">Shippers</td><td class=\"pt-3\" \nrowspan=\"1\"><div layout=\"row\" ng-if=\"vm.partyView.shippers\"><div>{{vm.shippersData.name}}<br><span \nclass=\"parties-sub-value pr-20\">{{vm.shippersData.email}} | {{vm.shippersData.company_name}} </span></div><div \nclass=\"p-15 parties-link\" ng-click=\"vm.fnOpenNewPartyModal(\'Edit\', \'shippers\')\">Edit</div><span \nclass=\"p-15 parties-link\" ng-click=\"vm.fnDeleteNewPartyModal(\'shippers\')\">Clear</span></div><div layout=\"row\" \nng-if=\"!vm.partyView.shippers\"><div class=\"p-15 parties-link\" ng-click=\"vm.fnOpenNewPartyModal(\'Add\', \'shippers\')\">\nAdd Details</div></div></td></tr></tbody></table></md-content></div></div></div></div>");
$templateCache.put("app/main/result/polling-result/pollingResult.html","<div id=\"polling-result\"><iframe id=\"polling-result-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/result/request-for-quote/request-for-quote.html","<div id=\"request-for-quote\" class=\"mt-10\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"list_view_div pt-50\"><div class=\"mh-10\" layout=\"column\" layout-align=\"center center\"><img \nsrc=\"assets/icons/custom/norateimg.svg\" class=\"w-300\"></div><div class=\"w-200 text-center mt-30 mh-10\"><div \nclass=\"font-size-20 fg-3F3851 Font-Bold mv-5\">No Rates Available</div><div class=\"font-size-15 fg-AAA8AD\">\nNo rates are available for this search.</div><div class=\"mv-20\"><md-button md-no-ink class=\"md-accent-btn w-120 mb-15\" \nng-click=\"vm.fnOpenRFQModal($event)\" ng-if=\"!vm.searchFromQuote\">Send Request</md-button><md-button md-no-ink \nclass=\"md-accent-btn w-200 mb-15\" ng-click=\"vm.redirectToQuote()\" ng-if=\"vm.searchFromQuote\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"pointer white-fg\"></md-icon>Navigate to Quote page</md-button></div></div></div>\n</div>");
$templateCache.put("app/main/result/request-for-quote/request-popup.html","<md-toolbar class=\"modal_title white-bg black-fg\"><div class=\"md-toolbar-tools\"><div>Request Better Rate</div><span \nflex></span><md-button md-no-ink class=\"md-icon-button\" ng-click=\"$ctrl.cancelDialog();\"><md-icon \nclass=\"fg-AAA8AD cursor\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<form name=\"rfqForm\" ng-submit=\"$ctrl.fnSendRFQ(rfqForm)\"><div layout=\"row\" class=\"dialog-content\" flex>\n<md-dialog-content><div layout=\"row\"><div layout-align=\"start start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'/assets/icons/custom/ic_chat_bubble_24px.svg\')\" class=\"icon-rbr\"></div></div><div \nflex=\"94\" layout-align=\"start center\"><div layout=\"column\" flex=\"100\"><label class=\"mb-6\">Reason</label><div \nclass=\"feild-spacing\"><md-input-container md-no-float class=\"height-container inputwidth100\"><textarea id=\"reason\" \nrows=\"2\" cols=\"70\" ng-model=\"$ctrl.rfqObj.reason_for_revising\" name=\"reason\" placeholder=\"Enter the reason here\" \nng-keyup=\"$ctrl.validationObj.reasonValidation=false;\" class=\"textarea-border\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.reasonValidation}\"></textarea></md-input-container></div><div \nng-if=\"$ctrl.validationObj.reasonValidation\" class=\"validation-error-text\"><span>\nEnter the relevant reason for Requesting Better Rates.</span></div></div></div></div><div layout=\"row\" \nclass=\"row-spacing\"><div layout-align=\"start start\" class=\"pr-15\"><div \nstyle=\"background-image: url(\'assets/images/fb_shipper/Image 279.png\')\" class=\"icon-rbr-big\"></div></div><div \nflex=\"94\" class=\"inputwidth100\"><div layout=\"column\" flex=\"100\"><label class=\"mb-6\">Commodity Details</label><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container flex=\"40\" flex-xs=\"100\" class=\"feild-spacing\" flex md-no-float>\n<cargo-type-selection full-border=\"true\" cargo-type-data=\"$ctrl.rfqObj.req_cargo_type_data\" is-valid=\"false\" \nis-required=\"false\" hazardous-value=\"$ctrl.rfqObj.hazardous_material\" category=\"\'RR\'\" mode=\"$ctrl.mode\">\n</cargo-type-selection></md-input-container><div class=\"feild-spacing custom-spacing mobile-spacing\">\n<md-input-container class=\"commodity_input\" flex=\"60\" flex-xs=\"100\" md-no-float><commodity-chips \nmd-input-id=\"\'commodity_id_rfq\'\" category=\"\'RBR\'\" commodity-array=\"$ctrl.rfqObj.req_commodity_data\" is-valid=\"false\">\n</commodity-chips></md-input-container></div></div></div></div></div><div layout=\"row\" class=\"row-spacing mb-20\" \nng-if=\"$ctrl.rfqObj.hazardous_material\"><div layout-align=\"start start\" class=\"pr-15\"><div \nstyle=\"background-image: url(\'assets/images/fb_shipper/Image 286.png\')\" class=\"icon-rbr-big\"></div></div><div \nflex=\"94\" class=\"inputwidth100\"><div layout=\"column\" flex=\"100\"><label class=\"mb-6\">Hazardous Cargo Details</label><div\n layout=\"row\" layout-xs=\"column\"><div layout=\"column\"><md-select \nng-change=\"$ctrl.validationObj.imcoValidationError=false;\" name=\"type\" ng-model=\"$ctrl.rfqObj.imco_code\" \nclass=\"code-box mt-0 w-160 panel-select feild-spacing multiselectBox imco_div\" placeholder=\"IMCO Code\" \nng-disabled=\"!$ctrl.rfqObj.hazardous_material\" ng-class=\"{\'validation-error\':$ctrl.validationObj.imcoValidationError}\">\n<md-option class=\"mb-10\" style=\"height:100%\" ng-value=\"0\">Select IMCO code</md-option><md-option class=\"mb-10\" \nstyle=\"height:100%\" ng-repeat=\"imcoCode in $ctrl.IMCO_CodeList track by $index\" ng-value=\"imcoCode.class_number\"><span \nclass=\"font-weight-600\">{{imcoCode.class_name}}</span><br><span class=\"gray-fg font-size-12\" \nng-repeat=\"list in imcoCode.list track by $index\">{{list}}<br></span></md-option></md-select><div \nng-if=\"$ctrl.validationObj.imcoValidationError\" class=\"pt-5 validation-error-text\"><span class=\"error\">\nPlease select imco code</span></div></div><div class=\"feild-spacing custom-spacing mobile-spacing\"><md-input-container \nmd-no-float class=\"p-0 m-0 panel-select search_select_box\" title=\"UN Number\"><input type=\"number\" min=\"0\" \nrestrict-to=\"[0-9]\" ng-model=\"$ctrl.rfqObj.un_num\" class=\"border-none font-size-12 font-weight-600\" \nplaceholder=\"Enter UN Number\"></md-input-container></div><div class=\"mobile-spacing\"><div class=\"w-120\"><div \nng-if=\"!$ctrl.msds_document && !$ctrl.msdsProgress\"><md-button md-no-ink class=\"md-link-btn ph-15 h-36\" \nng-click=\"$ctrl.selectFile(\'msds\');$ctrl.validationObj.msdsValidationError = false\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.msdsValidationError}\">Upload MSDS</md-button><input name=\"msds_file\" \ntype=\"file\" id=\"fileInput_msds\" ng-change=\"$ctrl.setFile($ctrl.msds_document,\'msds\')\" ngf-select \nng-model=\"$ctrl.msds_document\" ngf-max-size=\"5MB\" \naccept=\".xls,.doc,.docx,application/pdf,application/vnd.ms-excel,image/*\" \nngf-pattern=\"\'.pdf,.xls,.csv,.xlsx,.doc,.docx,image/*\'\" ngf-model-invalid=\"errorFile\" hide><br><span \nng-show=\"rfqForm.msds_file.$error.maxSize\" class=\"validation-error-text\">\nThis file is too large, maximum file size is 5MB.</span> <span ng-show=\"rfqForm.msds_file.$error.pattern\" \nclass=\"validation-error-text\">Please upload only pdf format files.</span> <span \nng-show=\"$ctrl.validationObj.msdsValidationError && (!rfqForm.msds_file.$error.maxSize && !rfqForm.msds_file.$error.pattern)\" \nclass=\"validation-error-text\"><span class=\"error\">Please upload MSDS file</span></span></div><div \nng-if=\"$ctrl.msds_document && !$ctrl.msdsProgress\"><div class=\"grey-fg font-size-11\">MSDS Document</div><div \nlayout=\"row\"><span class=\"font-weight-600 text-trunacte fg-3B82F6 max-width-120 text-ellipsis\">\n{{$ctrl.msds_document.name}}</span><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"s16 remove-icon\" \nng-click=\"$ctrl.msds_document = null; $ctrl.setFile($ctrl.msds_document,\'msds\');\" ng-show=\"$ctrl.msds_document\">\n</md-icon></div></div><div ng-if=\"$ctrl.msdsProgress\"><div class=\"grey-fg font-size-12\">MSDS Document</div>\n<md-progress-linear md-mode=\"indeterminate\" class=\"p-15 mt-5\"></md-progress-linear></div></div></div></div></div></div>\n</div><div layout=\"row\" ng-class=\"{\'row-spacing\':!$ctrl.rfqObj.hazardous_material}\"><div layout-align=\"start start\" \nclass=\"pr-20\"><div style=\"background-image: url(\'assets/icons/custom/atm_24px.svg\')\" class=\"icon-rbr\"></div></div><div \nflex=\"94\" layout-align=\"start center\" ng-if=\"$ctrl.mode === \'SEA-FCL\'\"><div layout=\"column\" flex=\"100\"><div \nlayout=\"row\" class=\"w-450 mb-6\" layout-align=\"space-between\"><label>Enter Your Expectations</label><label \nlayout-align=\"end center\">Cargo Wt. (Per Container)</label></div><div layout=\"row\" flex=\"100\" \nng-repeat=\"load in $ctrl.advanceContainerType track by $index\" ng-class=\"{\'row-spacing\':$index>0}\"><md-input-container \nflex=\"20\" class=\"load-disabled\" flex md-no-float><span>{{load.type}}</span></md-input-container><div \nlayout-align=\"center center\" layout=\"row\" flex=\"100\" \nclass=\"border load_div h-36 pl-0 ml-20 mr-20 w-210 target_rate_div\"><input name=\"target_rate\" type=\"number\" min=\"-99\" \nmax=\"99999\" step=\"any\" ng-model=\"load.target_rate\" placeholder=\"Enter Target Rate\" \nclass=\"border-none font-size-12 w-110 pb-0\"><div layout=\"row\" layout-align=\"center center\"><md-select \nclass=\"m-0 currency-border border-left w-100 pl-5 pr-8 h-36 pt-3 select-class\" ng-model=\"load.target_rate_currency\" \nplaceholder=\"INR\"><md-option ng-repeat=\"curr in $ctrl.currencyList track by $index\" ng-value=\"curr\">{{curr}}\n</md-option></md-select></div></div><div layout=\"column\" flex=\"100\" class=\"feild-spacing h-36\"><div \nlayout-align=\"center center\" layout=\"row\" flex=\"100\"><div class=\"border w-200 load_div target_rate_div\" layout=\"row\" \nlayout-align=\"center center\"><md-input-container md-no-float class=\"p-0 mt-0 mb-0 w-100 mh-0 h-36\"><input \nname=\"target_rate\" type=\"number\" min=\"-99\" max=\"99999\" step=\"any\" ng-model=\"load.weight_qty\" \nplaceholder=\"Enter Weight\" class=\"border-none font-size-12 h-36\"></md-input-container><div \nclass=\"grey-400-fg font-size-14\" layout=\"row\" layout-align=\"center center\"><md-select \nclass=\"m-0 border-left w-100 pl-5 pr-8 h-36 pt-3 select-class\" ng-model=\"load.weight_unit\" placeholder=\"KG\"><md-option \nvalue=\"KGs\" class=\"cargo_option border-none\">KG</md-option><md-option value=\"Tons\" class=\"cargo_option\">MT</md-option>\n</md-select></div></div></div></div></div></div></div><div flex=\"94\" layout=\"column\" \nng-if=\"$ctrl.mode !== \'SEA-FCL\' && $ctrl.rfqObj.target_load_data.load_type != \'units\'\"><div layout=\"row\"><div \nlayout=\"column\"><label class=\"mb-6\">Total Shipment Volume</label><div layout-align=\"center center\" layout=\"row\" \nflex=\"100\" class=\"target_rate_div\"><div layout=\"row\" \nclass=\"load_border_clr w-150 brad-5 p-2 panel-select-disabled h-26\"><md-input-container md-no-float \nclass=\"m-0 p-0 h-30\"><div class=\"total-input-div\">\n{{$ctrl.rfqObj.target_load_data.load_meta.total_volume | currencyMask : 2}}</div></md-input-container><md-select \nname=\"volume_unit\" class=\"m-0 load_border_clr border-left ph-5\" \nng-model=\"$ctrl.rfqObj.target_load_data.load_meta.volume_unit\" required ng-disabled=\"true\"><md-option value=\"CBM\" \nselected=\"selected\">CBM</md-option><md-option value=\"CFT\">CFT</md-option></md-select></div></div></div><div \nlayout=\"column\" class=\"ml-20 mr-20\"><label class=\"mb-6\">Total Shipment Wt.</label><div layout-align=\"center center\" \nlayout=\"row\" flex=\"100\" class=\"target_rate_div\"><div layout=\"row\" \nclass=\"load_border_clr p-2 panel-select-disabled w-150 brad-5 h-26\"><md-input-container md-no-float \nclass=\"m-0 p-0 h-30\"><div class=\"total-input-div\">\n{{$ctrl.rfqObj.target_load_data.load_meta.total_weight | currencyMask : 2}}</div></md-input-container><md-select \nname=\"input_weight_unit\" class=\"m-0 load_border_clr border-left ph-5\" \nng-model=\"$ctrl.rfqObj.target_load_data.load_meta.input_weight_unit\" required ng-disabled=\"true\"><md-option \nvalue=\"KGs\">KG</md-option><md-option value=\"LBs\">LB</md-option></md-select></div></div></div></div><div \nlayout=\"column\" class=\"row-spacing\"><label class=\"mb-6\">Target Rate <span ng-if=\"$ctrl.mode === \'AIR\'\">(per KG)</span> \n<span ng-if=\"$ctrl.mode === \'SEA-LCL\'\">(per W/M)</span></label><div class=\"target_rate_div\" layout=\"column\"><div \nlayout=\"row\" class=\"load_div w-150 brad-4 b h-36\" ng-class=\"{\'validation-error\':$ctrl.validationObj.targetValidation}\">\n<md-input-container md-no-float class=\"m-0 p-0 h-30\"><input name=\"target_rate\" type=\"number\" min=\"-99\" max=\"99999\" \nng-model=\"$ctrl.rfqObj.target_load_data.load_meta.target_rate\" placeholder=\"Target Rate\" \nclass=\"checkbox_input border-none insurance_input h-36\" ng-change=\"$ctrl.validationObj.targetValidation=false;\">\n</md-input-container><md-select id=\"air_currency_rate\" class=\"m-0 load_border_clr border-left ph-5 pr-4\" \nng-model=\"$ctrl.rfqObj.target_load_data.load_meta.target_rate_currency\" required><md-option \nng-repeat=\"curr in $ctrl.currencyList | filter : searchCurr track by $index\" ng-value=\"curr\">{{curr}}</md-option>\n</md-select></div><div ng-if=\"$ctrl.validationObj.targetValidation\" class=\"validation-error-text\">Enter Target Rate\n</div></div></div></div><div flex=\"94\" layout=\"column\" \nng-if=\"$ctrl.mode !== \'SEA-FCL\' && $ctrl.rfqObj.target_load_data.load_type == \'units\'\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"load in $ctrl.rfqObj.target_load_data.load_details_value track by $index\" \nng-class=\"{\'row-spacing\':$index>0}\"><div layout=\"column\" class=\"mr-10\"><label ng-if=\"$index==0\" class=\"mb-6\">\nUnit Dimensions</label><div layout-align=\"center center\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex=\"100\" \nclass=\"flex w-240 brad-5 panel-select-disabled h-36 load_border_clr dimension_div\"><md-input-container md-no-float \nclass=\"br load_border_clr\"><div class=\"unit-input-div\">{{load.length | currencyMask : 2}}<md-tooltip \nmd-direction=\"bottom\" class=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{load.length | currencyMask : 2}}</span>\n</md-tooltip></div></md-input-container><md-input-container md-no-float class=\"br load_border_clr\"><div \nclass=\"unit-input-div\">{{load.breadth | currencyMask : 2}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{load.breadth | currencyMask : 2}}</span>\n</md-tooltip></div></md-input-container><md-input-container md-no-float class=\"br load_border_clr\"><div \nclass=\"unit-input-div\">{{load.height | currencyMask : 2}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{load.height | currencyMask : 2}}</span>\n</md-tooltip></div></md-input-container><md-input-container class=\"p-5 target_rate_div\" md-no-float><md-select \nname=\"dimension_unit\" ng-model=\"$ctrl.rfqObj.target_load_data.load_meta.dimension_unit\" \nclass=\"pr-5 pl-5 h-36 checkbox_input\" required ng-disabled=\"true\"><md-option value=\"CMS\" selected=\"selected\">CMS\n</md-option><md-option value=\"Inches\">Inches</md-option></md-select></md-input-container></div></div></div><div \nlayout=\"column\"><label ng-if=\"$index==0\" class=\"mb-6\">Unit Gross Wt.</label><div layout-align=\"center center\" \nlayout=\"row\" flex=\"100\" class=\"target_rate_div\"><div layout=\"row\" \nclass=\"panel-select-disabled load_border_clr w-110 brad-5 h-36\"><md-input-container md-no-float class=\"m-0 p-0\"><div \nclass=\"unit-input-div\">{{load.weight | currencyMask : 2}}</div></md-input-container><md-select name=\"weight_unit\" \nng-model=\"$ctrl.rfqObj.target_load_data.load_meta.input_weight_unit\" class=\"m-0 pl-5 load_border_clr border-left\" \nrequired ng-disabled=\"true\"><md-option value=\"KGs\">KG</md-option><md-option value=\"LBs\">LB</md-option></md-select>\n</div></div></div></div><div layout=\"column\" class=\"row-spacing\"><label class=\"mb-6\">Target Rate <span \nng-if=\"$ctrl.mode === \'AIR\'\">(per KG)</span> <span ng-if=\"$ctrl.mode === \'SEA-LCL\'\">(per W/M)</span></label><div \nclass=\"target_rate_div\" layout=\"column\"><div layout=\"row\" class=\"load_div w-130 brad-4 b h-36\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.targetValidation}\"><md-input-container md-no-float class=\"m-0 p-0\">\n<input name=\"target_rate\" type=\"number\" min=\"-99\" max=\"99999\" \nng-model=\"$ctrl.rfqObj.target_load_data.load_meta.target_rate\" placeholder=\"Target Rate\" \nclass=\"checkbox_input h-36 border-none insurance_input h-26\" ng-keyup=\"$ctrl.validationObj.targetValidation=false\">\n</md-input-container><md-select id=\"air_currency_rate\" class=\"m-0 pl-5 load_border_clr border-left\" \nng-model=\"$ctrl.rfqObj.target_load_data.load_meta.target_rate_currency\" required><md-option \nng-repeat=\"curr in $ctrl.currencyList | filter : searchCurr track by $index\" ng-value=\"curr\">{{curr}}</md-option>\n</md-select></div><div ng-if=\"$ctrl.validationObj.targetValidation\" class=\"validation-error-text\">Enter Target Rate\n</div></div></div></div></div><div layout=\"row\" class=\"row-spacing\"><div layout-align=\"start start\" class=\"pr-20\">\n<md-icon md-svg-icon=\"assets/icons/custom/ship-fill.svg\" class=\"fg-333333 icon-rbr\" ng-show=\"$ctrl.mode != \'AIR\'\">\n</md-icon><div ng-if=\"$ctrl.mode == \'AIR\'\" style=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" \nclass=\"fg-333333 icon-rbr\"></div></div><div flex=\"94\" layout=\"row\" layout-xs=\"column\"><div layout=\"column\" \nng-if=\"$ctrl.mode != \'AIR\'\" class=\"w-200 feild-spacing\"><label class=\"mb-6\">Preferred Liner Name</label>\n<md-input-container md-no-float class=\"select-pt-0 liner-select mt-6 mb-0 mh-0 panel-select\"><md-select \nclass=\"mt-3 pr-4 multi-select-width\" name=\"selectLiner\" ng-model=\"$ctrl.rfqObj.carrier_preference\" \nmd-on-close=\"searchCarrier=\'\'\" ng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"Select Liner Preference\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchCarrier\" \nng-model-options=\"{debounce: 500}\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nng-change=\"$ctrl.getSubVendorList(searchCarrier)\" placeholder=\"Search for a liner..\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"liners\"><md-option ng-value=\"subvendor\" \nng-repeat=\"subvendor in $ctrl.getSubvendor track by subvendor.id\" title=\"{{subvendor.name}}\">{{subvendor.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" ng-if=\"$ctrl.mode == \'AIR\'\" \nflex-xs=\"100\" class=\"w-200 feild-spacing\"><label class=\"mb-6\">Preferred Airline Name</label><md-input-container \nmd-no-float class=\"select-pt-0 pr-4 max-width liner-select mt-6 mb-0 mh-0 panel-select\"><md-select \nng-model=\"$ctrl.rfqObj.airline_preference\" name=\"airline_preference\" placeholder=\"Select Airline Name Here\" \nclass=\"pt-1 m-0 h-36 multi-select-width\" ng-class=\"$ctrl.fontBold\" md-on-close=\"searchAirline = \'\'\" \nmultiple=\"multiple\"><md-select-header><input ng-model=\"searchAirline\" type=\"search\" placeholder=\"Search Airline\" \nclass=\"demo-header-searchbox _md-text\" ng-model-options=\"{debounce: 500}\" \nng-change=\"$ctrl.getSubVendorList(searchAirline)\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\">\n</md-select-header><md-option ng-repeat=\"airline in $ctrl.getSubvendor | orderBy:\'name\'\" ng-value=\"airline\" \ntitle=\"{{airline.name}}\">{{airline.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nclass=\"feild-spacing mobile-spacing\"><label>Preferred Sailing Date</label><date-picker md-input-id=\"\'cargo_date\'\" \nis-editable=\"true\" \nis-validate=\"($ctrl.validationObj.sailingDateValidation || ( rfqForm.cargo_date.$touched && rfqForm.cargo_date.$error.valid))\" \nis-disabled=\"false\" input-required=\"true\" input-name=\"\'cargo_date\'\" full-border=\"true\" date-placeholder=\"\'Enter date\'\" \nfull-border=\"true\" date-format=\"true\" model-value=\"$ctrl.rfqObj.preferred_sailing_date\" \nmin-date-value=\"$ctrl.startDateStart\" \ncallback=\"$ctrl.rfqObj.preferred_sailing_date = value;$ctrl.validationObj.sailingDateValidation=false;\"></date-picker>\n<div \nng-messages=\"!$ctrl.validationObj.sailingDateValidation && rfqForm.cargo_date.$touched && rfqForm.cargo_date.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"$ctrl.validationObj.sailingDateValidation\" class=\"validation-error-text\">Select Preferred Sailing Date</div>\n</div><div layout=\"column\" class=\"feild-spacing mobile-spacing\"><label class=\"mb-6\">Free Days</label><input \ntype=\"number\" min=\"0\" max=\"99\" restrict-to=\"[0-9]\" ng-model=\"$ctrl.rfqObj.demurrage_detention\" \nclass=\"panel-select font-size-12\" placeholder=\"Detention Days\"></div></div></div><div layout=\"row\" class=\"row-spacing\">\n<div layout-align=\"start start\" class=\"pr-20\"><div \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/charges.svg\')\" class=\"fg-333333 icon-rbr\"></div></div><div\n flex=\"94\" layout-align=\"start center\"><div layout=\"column\" flex=\"100\"><label class=\"mb-6\">Locals & Custom Charges\n</label><md-menu md-position-mode=\"left bottom\"><div><md-input-container md-no-float class=\"dropdown p-0 m-0\"><div \nclass=\"panel-select load_div panelSelect-charge pointer mobile_input\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"$mdMenu.open()\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"80\"><div \ntruncate=\"{{$ctrl.rfqObj.detailBoxString}}\" class=\"mt-2 pv-5 hide-overflow text-truncate\">\n{{$ctrl.rfqObj.detailBoxString}}<md-tooltip md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{$ctrl.rfqObj.detailBoxTooltip}}</span>\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\"></md-icon></div>\n</md-input-container></div><md-menu-content class=\"p-10\"><md-menu-item><md-checkbox md-no-ink \nng-model=\"$ctrl.rfqObj.origin_charges\" ng-change=\"$ctrl.fnStuffingEnable();\" class=\"w-250\"><span \nclass=\"checkbox_text font-size-12\" ng-class=\"{\'black-fg\' : $ctrl.rfqObj.origin_charges}\">Origin Charges</span>\n</md-checkbox></md-menu-item><md-menu-item><md-checkbox md-no-ink ng-model=\"$ctrl.rfqObj.origin_customs\" class=\"w-250\">\n<span class=\"checkbox_text checkbox_text font-size-12\" ng-class=\"{\'black-fg\' : $ctrl.rfqObj.origin_customs}\">\nOrigin Customs Clearance</span></md-checkbox></md-menu-item><md-menu-item><md-checkbox md-no-ink \nng-model=\"$ctrl.rfqObj.destination_charges\" class=\"w-250\"><span class=\"checkbox_text font-size-12\" \nng-class=\"{\'black-fg\' : $ctrl.rfqObj.destination_charges}\">Destination Charges</span></md-checkbox></md-menu-item>\n<md-menu-item><md-checkbox md-no-ink ng-model=\"$ctrl.rfqObj.destination_customs\" class=\"w-250\"><span \nclass=\"checkbox_text font-size-12\" ng-class=\"{\'black-fg\' : $ctrl.rfqObj.destination_customs}\">\nDestination Customs Clearance</span></md-checkbox></md-menu-item></md-menu-content></md-menu></div></div></div>\n</md-dialog-content></div><md-dialog-actions layout=\"row\"><div layout-align=\"end center\" class=\"mv-10\"><md-button \nmd-no-ink class=\"md-primary-btn mr-10\" ng-click=\"$ctrl.cancelDialog();\" title=\"Cancel\">Cancel</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Confirm\">Send Request</md-button></div></md-dialog-actions>\n</form>");
$templateCache.put("app/main/result/result-v2/result-v2.html","<div id=\"result-v2\"><iframe resize-handler id=\"result-v2-iframe\" name=\"{{vm.todaysDate}}\" ng-style=\"vm.minHeight\" \nwidth=\"100%\" height=\"100%\" style=\"border-width: 0\"></iframe></div>");
$templateCache.put("app/main/roles/agents/agents.html","<md-sidenav ng-if=\"vm.agentfilterdata.deviceName != \'laptop\'\" class=\"md-sidenav-right sidenav-bg no-scroll\" \nmd-component-id=\"right\" ms-sidenav-helper ng-include=\"\'app/main/roles/agents/filter-agent/filter-agent.html\'\" \nms-sidenav-helper></md-sidenav><div id=\"agents-page\"><div class=\"pb-20 agent_details pt-10\"><div layout=\"row\" \nclass=\"pv-20 bb-header\" layout-align=\"space-between end\"><div><div class=\"page_title font-bold\">Agents</div></div><div \nlayout=\"row\" flex=\"\" layout-align=\"end center\"><md-button md-no-ink class=\"md-accent-btn m-0\" \nng-click=\"vm.create_agent_popup($event)\" ng-if=\"vm.util.navPermission.agents && vm.util.navPermission.agents[0]\">\n+ Add Agent</md-button></div><div ng-if=\"vm.agentfilterdata.deviceName != \'laptop\'\" \nclass=\"b md-primary-border brad-4 p-5 mb-3 mh-10 pointer float-filter\" ng-click=\"vm.toggleSidenav(\'right\')\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon\"></md-icon></div></div></div><div \nlayout=\"row\"><div class=\"w-230\" ng-if=\"vm.agentfilterdata.deviceName == \'laptop\'\"><div class=\"sticky-filter\">\n<md-sidenav class=\"sidenav-bg no-scroll mt-10 mr-10\" md-is-locked-open=\"vm.agentfilterdata.deviceName == \'laptop\'\" \nms-sidenav-helper ng-include=\"\'app/main/roles/agents/filter-agent/filter-agent.html\'\"></md-sidenav></div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" layout-wrap class=\"pt-20\" \nng-if=\"vm.util.navPermission.agents && !vm.util.navPermission.agents[1]\"><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-size-18 pb-8\">\nYou don\'t have permission to access this section.</div></div></div><div class=\"simple-table-container\" \nng-show=\"vm.util.navPermission.agents && vm.util.navPermission.agents[1]\"><div><div layout=\"row\" layout-padding \nflex=\"100\"><div layout-align=\"start center\" class=\"pt-15 page_content\" flex=\"95\" flex-xs=\"9\">\n{{vm.agentLength}} Agents Found</div><div layout-align=\"end center\" class=\"sort_padding\" flex=\"5\" flex-xs=\"5\" \nng-click=\"vm.fnCreatedSortBy( vm.filterListObject.sort_by_type)\"><md-icon \nng-if=\"vm.filterListObject.sort_by_type ==\'ASC\'\" md-svg-src=\"assets/icons/custom/desc.svg\" \nclass=\"w-15 pointer h-15 filter-icon\"></md-icon><md-icon ng-if=\"vm.filterListObject.sort_by_type == \'DESC\'\" \nmd-svg-src=\"assets/icons/custom/asc.svg\" class=\"w-15 h-15 pointer filter-icon\"></md-icon><md-tooltip \nmd-direction=\"top\" class=\"font-size-13 mt-0\">Sort by: Created on</md-tooltip></div></div><table \nclass=\"dataTable row-border hover\" id=\"agent_tables\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \ndt-instance=\"vm.dtInstanceCallback\"></table></div></div></div></div>");
$templateCache.put("app/main/roles/charges/charges.html","<md-sidenav ng-if=\"vm.chargefilterdata.deviceName != \'laptop\'\" class=\"md-sidenav-right sidenav-bg no-scroll\" \nmd-component-id=\"right\" ms-sidenav-helper ng-include=\"\'app/main/roles/charges/filter-charge/filter-charge.html\'\">\n</md-sidenav><div id=\"charges-page\"><div class=\"pb-5 charge_details pt-5\"><div layout=\"row\" class=\"pv-10 bb-header\" \nlayout-align=\"space-between end\"><div><div class=\"page_title font-bold\">Charges</div></div><div layout=\"row\" flex=\"\" \nlayout-align=\"end center\"><md-button md-no-ink class=\"md-accent-btn m-0\" ng-click=\"vm.create_charge_popup($event)\" \nng-if=\"vm.util.navPermission.charges && vm.util.navPermission.charges[0]\">+ Add Charge</md-button></div><div \nng-if=\"vm.chargefilterdata.deviceName != \'laptop\'\" \nclass=\"b md-primary-border brad-4 p-5 mb-3 mh-10 pointer float-filter\" ng-click=\"vm.toggleSidenav(\'right\')\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon\"></md-icon></div></div></div><div \nlayout=\"row\"><div class=\"w-230\" ng-if=\"vm.chargefilterdata.deviceName == \'laptop\'\"><div class=\"sticky-filter\">\n<md-sidenav class=\"sidenav-bg no-scroll mt-10 mr-10\" md-is-locked-open=\"vm.chargefilterdata.deviceName == \'laptop\'\" \nms-sidenav-helper ng-include=\"\'app/main/roles/charges/filter-charge/filter-charge.html\'\"></md-sidenav></div></div><div \nclass=\"simple-table-container\" ng-show=\"vm.util.navPermission.charges && vm.util.navPermission.charges[1]\" flex><div>\n<div layout=\"row\" layout-padding flex=\"100\"><div layout-align=\"start center\" class=\"pt-15 page_content\" flex=\"95\" \nflex-xs=\"9\">{{vm.chargeLength}} Charges Found</div><div layout-align=\"end center\" class=\"sort_padding\" flex=\"5\" \nflex-xs=\"5\" ng-click=\"vm.fnCreatedSortBy( vm.filterListObject.sort_by_type)\"><md-icon \nng-if=\"vm.filterListObject.sort_by_type ==\'ASC\'\" md-svg-src=\"assets/icons/custom/desc.svg\" \nclass=\"w-15 pointer h-15 filter-icon\"></md-icon><md-icon ng-if=\"vm.filterListObject.sort_by_type == \'DESC\'\" \nmd-svg-src=\"assets/icons/custom/asc.svg\" class=\"w-15 h-15 pointer filter-icon\"></md-icon><md-tooltip \nmd-direction=\"top\" class=\"font-size-13 mt-0\">Sort by: Created on</md-tooltip></div></div><table \nclass=\"dataTable row-border hover\" id=\"charge_tables\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \ndt-instance=\"vm.dtInstanceCallback\" ms-responsive-table></table></div></div></div></div>");
$templateCache.put("app/main/roles/forwarder/forwarders.html","<div id=\"forwarders-page\"><div class=\"pv-20 forwarder_details\"><div layout=\"row\" class=\"pb-15 pv-20 bb-header\" \nlayout-align=\"space-between\" layout-xs=\"column\"><div layout-align=\"start center\" class=\"font-size-18\" \nng-class=\"{ hide : vm.util.isMobileApp }\">Forwarder<div class=\"page_subtitle\">{{vm.forwarderLength}} Forwarder Found\n</div></div><md-button md-no-ink class=\"md-accent-btn\" ng-if=\"vm.util.navPermission.forwarders[0]\" \nng-click=\"vm.create_forwarder($event)\">+ Add Forwarder</md-button></div><div layout=\"row\" layout-align=\"center center\" \nlayout-wrap class=\"pt-20\" ng-if=\"!vm.util.navPermission.forwarders[1]\"><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><div class=\"font-size-18 pb-8\">You don\'t have permission to access this section.</div></div></div><div \nclass=\"simple-table-container\" ng-if=\"vm.util.navPermission.forwarders[1]\"><div class=\"forwarder_table\"><table \nclass=\"dataTable row-border hover\" id=\"forwarders_table\" datatable=\"\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\"></table></div></div></div></div>");
$templateCache.put("app/main/roles/forwarder-offices/forwarder-office-form.html","<md-dialog class=\"forwarder-office-dialog popup-sm\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{ctrl.parent.button_name === \'Add\' ? \'Create Forwarder Office\' : \'Edit Forwarder Office\'}}</div><md-button md-no-ink \nclass=\"md-icon-button\" ng-disabled=\"ctrl.parent.submit_disabled\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"body\"><form \nname=\"forwarderOfficeFrm\" class=\"font-size-13\"><div ng-if=\"ctrl.parent.officeForm.parentName\" class=\"mb-15\"><span>\n<label>Parent Office</label></span><div class=\"font-size-14 grey-700-fg mt-5\">{{ctrl.parent.officeForm.parentName}}\n</div></div><div><span><label>Domain</label></span><md-input-container class=\"md-block pt-6-imp\" md-no-float>\n<md-autocomplete ng-if=\"ctrl.parent.isGodLogin\" md-input-name=\"officeDomain\" \nmd-selected-item=\"ctrl.parent.officeForm.selectedOffice\" \nmd-selected-item-change=\"ctrl.parent.selectForwarderOfficeResult(ctrl.parent.officeForm.selectedOffice)\" \nmd-search-text=\"ctrl.parent.officeForm.domain\" md-search-text-change=\"ctrl.parent.clearOfficeDomainValidation()\" \nmd-items=\"item in ctrl.parent.searchForwarderOfficeResults(ctrl.parent.officeForm.domain)\" md-item-text=\"item.domain\" \nmd-min-length=\"1\" md-delay=\"300\" md-no-cache=\"true\" md-clear-button=\"false\" \nmd-menu-class=\"forwarder-office-autocomplete-menu\" \nng-class=\"{\'validation-error\': ctrl.parent.officeValidation.domain || ctrl.parent.officeValidation.duplicateDomain}\" \nclass=\"panel-select forwarder-office-domain-search\" placeholder=\"Search by domain, subscriber ID, or company name\">\n<md-item-template><span class=\"forwarder-office-search-result\"><span class=\"font-size-13 text-truncate\" \ntitle=\"{{item.name}}\">{{item.name}} </span><span class=\"font-size-11 grey-500-fg text-truncate\" \ntitle=\"{{item.domain}}\">Domain: {{item.domain}} </span><span class=\"font-size-11 grey-500-fg text-truncate\" \nng-if=\"item.domainSubscriberId || item.vendorId\">Domain Subscriber ID: {{item.domainSubscriberId || item.vendorId}}\n</span></span></md-item-template><md-not-found>No forwarder office matching \"{{ctrl.parent.officeForm.domain}}\" found.\n</md-not-found></md-autocomplete><input ng-if=\"!ctrl.parent.isGodLogin\" ng-model=\"ctrl.parent.officeForm.domain\" \nng-class=\"{\'validation-error\': ctrl.parent.officeValidation.domain || ctrl.parent.officeValidation.duplicateDomain}\" \nclass=\"panel-select\" name=\"officeDomain\" placeholder=\"Enter Office Domain\" autocomplete=\"off\" \nng-keyup=\"ctrl.parent.clearOfficeDomainValidation()\"><div ng-if=\"ctrl.parent.officeValidation.domain\" \nclass=\"validation-error-text\"><span>Enter the office domain</span></div><div \nng-if=\"ctrl.parent.officeValidation.duplicateDomain\" class=\"validation-error-text\"><span>Domain already exists</span>\n</div></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" \nclass=\"white-bg footer\" layout-wrap flex-xs=\"100\"><div class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-disabled=\"ctrl.parent.submit_disabled\" ng-click=\"ctrl.parent.cancelDialog()\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10 save1\" ng-click=\"ctrl.parent.submitOffice()\" ng-disabled=\"ctrl.parent.submit_disabled\">\n{{ctrl.parent.button_name}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/roles/forwarder-offices/forwarder-offices.html","<div id=\"forwarder-offices-page\" class=\"demo-content forwarder-offices pv-20\"><div layout=\"row\" \nclass=\"pb-15 pv-20 bb-header\" layout-align=\"space-between start\" layout-xs=\"column\"><div layout-align=\"start center\" \nclass=\"fo-page-heading\" ng-class=\"{ hide : vm.util.isMobileApp }\"><h1 class=\"fo-page-title\">Forwarder Offices</h1><div \nclass=\"fo-page-subtitle\">Manage forwarder office hierarchy</div></div><md-button md-no-ink class=\"md-accent-btn\" \nng-if=\"vm.permission[0] && vm.permission[1]\" ng-click=\"vm.openAddRoot($event)\">+ Add Office</md-button></div><div \nlayout=\"row\" layout-align=\"center center\" layout-wrap class=\"pt-20\" ng-if=\"!vm.permission[1]\"><div \nclass=\"font-size-18 pb-8\">You don\'t have permission to access this section.</div></div><div ng-if=\"vm.permission[1]\" \nclass=\"fo-page-body\"><div class=\"white-bg brad-3 fo-card fo-shell\" ng-class=\"{\'fo-shell-loading\': vm.isDataLoading}\">\n<div class=\"fo-card-body\" layout=\"row\" layout-xs=\"column\"><div flex=\"30\" flex-sm=\"40\" flex-xs=\"100\" class=\"fo-left\">\n<div class=\"fo-search-row\"><md-icon md-font-icon=\"icon-magnify\" class=\"fo-search-icon s20 grey-600-fg\"></md-icon>\n<md-input-container class=\"md-block m-0 fo-search-field\" md-no-float><input ng-model=\"vm.searchText\" \nng-change=\"vm.onSearchChange()\" ng-keydown=\"($event.which || $event.keyCode) === 13 && vm.triggerSearchNow()\" \nname=\"forwarderOfficeSearch\" placeholder=\"Search by name, domain, or subscriber ID\" \naria-label=\"Search by name, domain, or subscriber ID\"></md-input-container></div><md-list \nclass=\"fo-office-tree m-0 p-0\" ng-if=\"!vm.isDataLoading && vm.visibleOffices.length\"><md-list-item \nng-repeat=\"item in vm.visibleOffices track by vm.getOfficeId(item.office)\" class=\"fo-list-item p-0\" \nng-class=\"{\'selected\': vm.isSelected(item.office)}\"><div class=\"md-list-item-text pointer fo-list-hit\" layout=\"row\" \nlayout-align=\"start center\" ng-style=\"{\'padding-left\': (10 + (item.depth * 16)) + \'px\'}\" \nng-click=\"vm.selectOffice(item.office)\"><div flex=\"10\" layout=\"row\" layout-align=\"center center\" \nclass=\"fo-office-toggle\" ng-click=\"vm.toggleOffice(item.office, $event)\"><md-icon \nng-if=\"item.hasChildren && !vm.expanded[vm.getOfficeId(item.office)] && !vm.searchText\" \nmd-font-icon=\"icon-chevron-right\" class=\"s18 grey-500-fg\"></md-icon><md-icon \nng-if=\"item.hasChildren && (vm.expanded[vm.getOfficeId(item.office)] || vm.searchText)\" \nmd-font-icon=\"icon-chevron-down\" class=\"s18 grey-500-fg\"></md-icon><md-icon ng-if=\"!item.hasChildren\" \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"s8 grey-400-fg\"></md-icon></div><div class=\"fo-list-item-main\" flex>\n<div class=\"fo-office-name text-truncate\">{{vm.getOfficeName(item.office)}}</div><div \nclass=\"fo-office-sub grey-500-fg text-truncate\">{{vm.getOfficeDomain(item.office)}}</div></div></div></md-list-item>\n</md-list><div ng-if=\"vm.totalRoots\" layout=\"row\" layout-align=\"space-between center\" class=\"fo-pagination\"><div \nclass=\"font-size-12 grey-600-fg\"><span ng-if=\"vm.totalPages() === 1\">Showing {{vm.totalRoots}} of {{vm.totalRoots}}\n</span> <span ng-if=\"vm.totalPages() !== 1\">Showing {{vm.rangeStart()}}-{{vm.rangeEnd()}} of {{vm.totalRoots}}</span>\n</div><div layout=\"row\" layout-align=\"end center\" class=\"fo-pagination-controls\"><md-button md-no-ink \nclass=\"md-icon-button m-0 fo-page-btn\" ng-disabled=\"!vm.canPrev() || vm.isDataLoading\" ng-click=\"vm.prevPage()\" \naria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s20 grey-600-fg\"></md-icon></md-button>\n<md-progress-circular ng-if=\"vm.isDataLoading\" md-mode=\"indeterminate\" md-diameter=\"14\" class=\"fo-pagination-spinner\">\n</md-progress-circular><md-button md-no-ink class=\"md-icon-button m-0 fo-page-btn\" \nng-disabled=\"!vm.canNext() || vm.isDataLoading\" ng-click=\"vm.nextPage()\" aria-label=\"Next\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s20 grey-600-fg\"></md-icon></md-button></div></div><div \nng-if=\"!vm.isDataLoading && vm.hasLoadedOnce && !vm.visibleOffices.length\" \nclass=\"grey-500-fg font-size-13 pv-15 text-center fo-empty-list\"><span ng-if=\"vm.hasActiveSearch()\">\nNo offices found for your search.</span> <span ng-if=\"!vm.hasActiveSearch()\">No forwarder offices found.</span><div \nng-if=\"vm.permission[0] && !vm.hasActiveSearch()\" class=\"mt-10\"><md-button md-no-ink class=\"md-accent-btn\" \nng-click=\"vm.openAddRoot($event)\">+ Add Office</md-button></div></div></div><div flex flex-xs=\"100\" class=\"fo-main\" \nng-if=\"vm.selectedOffice\"><div class=\"fo-detail-panel\"><div class=\"fo-detail-hero\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"fo-detail-hero-main\" flex><h2 class=\"fo-partner-title text-truncate\">\n{{vm.getOfficeName(vm.selectedOffice)}}</h2><div class=\"fo-partner-domain text-truncate\" \ntitle=\"{{vm.getOfficeDomain(vm.selectedOffice)}}\">{{vm.getOfficeDomain(vm.selectedOffice)}}</div></div><div \nlayout=\"row\" layout-align=\"end center\" layout-wrap class=\"fo-detail-actions\"><md-button md-no-ink \nclass=\"md-accent-btn fo-action-btn\" \nng-if=\"vm.permission[0] && !vm.getParent(vm.selectedOffice) && vm.getDepth(vm.selectedOffice) < 2\" \nng-click=\"vm.openAddChild(vm.selectedOffice, $event)\">+ Add Child</md-button><md-button md-no-ink \nclass=\"fo-action-btn fo-action-btn--delete\" ng-if=\"vm.permission[3]\" ng-disabled=\"vm.deleteInProgress\" \nng-click=\"vm.confirmDelete(vm.selectedOffice, $event)\"><span layout=\"row\" layout-align=\"center center\">\n<md-progress-circular ng-if=\"vm.deleteInProgress\" md-mode=\"indeterminate\" md-diameter=\"16\" class=\"mr-8\">\n</md-progress-circular><span>{{vm.deleteInProgress ? \'Deleting...\' : \'Delete\'}}</span></span></md-button></div></div>\n<div class=\"fo-stat-cards\" layout=\"row\" layout-wrap><div class=\"fo-stat-card\" flex=\"33\" flex-sm=\"50\" flex-xs=\"100\"><div\n class=\"fo-stat-label\">Domain Subscriber ID</div><div class=\"fo-stat-value\">\n{{vm.getOfficeDomainSubscriberId(vm.selectedOffice) || \'—\'}}</div></div><div class=\"fo-stat-card\" flex=\"33\" \nflex-sm=\"50\" flex-xs=\"100\"><div class=\"fo-stat-label\">Parent Office</div><div class=\"fo-stat-value\" \nng-if=\"vm.getParent(vm.selectedOffice)\"><button type=\"button\" class=\"fo-parent-link\" \nng-click=\"vm.selectOffice(vm.getParent(vm.selectedOffice))\">{{vm.getOfficeName(vm.getParent(vm.selectedOffice))}}\n</button></div><div class=\"fo-stat-value\" ng-if=\"!vm.getParent(vm.selectedOffice)\">Root office</div></div><div \nclass=\"fo-stat-card\" flex=\"33\" flex-sm=\"50\" flex-xs=\"100\"><div class=\"fo-stat-label\">Child Offices</div><div \nclass=\"fo-stat-value\">{{vm.getChildren(vm.getOfficeId(vm.selectedOffice)).length}}</div></div></div><div \nclass=\"fo-section\" ng-if=\"!vm.getParent(vm.selectedOffice)\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"fo-section-header\"><span class=\"fo-section-label\">Child Offices</span> <span class=\"fo-section-badge\">\n{{vm.getChildren(vm.getOfficeId(vm.selectedOffice)).length}}</span></div><div \nng-if=\"!vm.getChildren(vm.getOfficeId(vm.selectedOffice)).length\" class=\"fo-empty-children grey-500-fg\">\nNo child offices yet. Add a child office to extend this hierarchy.</div><md-list class=\"fo-child-list m-0 p-0\" \nng-if=\"vm.getChildren(vm.getOfficeId(vm.selectedOffice)).length\"><md-list-item \nng-repeat=\"child in vm.getChildren(vm.getOfficeId(vm.selectedOffice)) track by vm.getOfficeId(child)\" \nclass=\"fo-child-item p-0 pointer\" ng-click=\"vm.selectOffice(child)\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"fo-child-hit\"><div class=\"fo-child-main text-truncate\" flex><div \nclass=\"fo-child-name\">{{vm.getOfficeName(child)}}</div><div class=\"fo-child-sub grey-500-fg\">\n{{vm.getOfficeDomain(child)}}</div></div><md-icon md-font-icon=\"icon-chevron-right\" class=\"s18 grey-500-fg\"></md-icon>\n</div></md-list-item></md-list></div></div></div><div flex flex-xs=\"100\" class=\"pv-40 ph-20 fo-right-loading\" \nng-if=\"!vm.selectedOffice && vm.isDataLoading\" layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular></div><div flex flex-xs=\"100\" \nclass=\"pv-40 ph-20 grey-500-fg fo-empty-main\" ng-if=\"!vm.selectedOffice && !vm.isDataLoading\">\nSelect an office to view details.</div></div></div></div></div>");
$templateCache.put("app/main/roles/shipper/shippers.html","<md-sidenav ng-if=\"vm.shipperfilterdata.deviceName != \'laptop\'\" class=\"md-sidenav-right sidenav-bg no-scroll\" \nmd-component-id=\"right\" ms-sidenav-helper ng-include=\"\'app/main/roles/shipper/filter-shipper/filter-shipper.html\'\" \nms-sidenav-helper></md-sidenav><div id=\"shippers-page\"><div class=\"pb-20 shipper_details pt-10\"><import-file-status-bar\n callback=\"vm.fnRemoveFileStatus(requestId,index)\" importstatusobj=\"vm.shipperUserStatusData\"></import-file-status-bar>\n<div ng-include=\"\'app/main/roles/component/import-file-status-bar/import-file-success-message.html\'\"></div><div \nlayout=\"row\" class=\"pv-20 bb-header\" layout-align=\"space-between end\"><div ng-class=\"{ hide : vm.util.isMobileApp }\">\n<div class=\"page_title\">Company</div></div><div layout=\"row\" flex=\"\" layout-align=\"end center\"><md-button md-no-ink \nclass=\"md-link-btn with-icon h-36\" ng-click=\"vm.importShipper($event)\" \nng-if=\"vm.util.navPermission.IMPORT_SHIPPERS[0]\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon>Import</md-button>\n<md-button md-no-ink layout-align=\"shipp\" class=\"md-accent-btn m-0\" ng-click=\"vm.create_shipper($event)\" \nng-if=\"vm.util.navPermission.shippers[0]\">+ Add Company</md-button></div><div \nng-if=\"vm.shipperfilterdata.deviceName != \'laptop\'\" \nclass=\"b md-primary-border brad-4 p-5 mb-3 mh-10 pointer float-filter\" ng-click=\"vm.toggleSidenav(\'right\')\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon\"></md-icon></div></div><div layout=\"row\">\n<div ng-if=\"vm.shipperfilterdata.deviceName == \'laptop\'\" class=\"w-230\"><div class=\"sticky-filter\"><md-sidenav \nclass=\"sidenav-bg no-scroll mt-10 mr-10\" md-is-locked-open=\"vm.shipperfilterdata.deviceName == \'laptop\'\" \nms-sidenav-helper ng-include=\"\'app/main/roles/shipper/filter-shipper/filter-shipper.html\'\"></md-sidenav></div></div>\n<div layout=\"row\" flex=\"100\" layout-align=\"center center\" layout-wrap class=\"pt-20\" \nng-if=\"!vm.util.navPermission.shippers[1]\"><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div \nclass=\"font-size-18 pb-8\">You don\'t have permission to access this section.</div></div></div><div \nclass=\"simple-table-container\" ng-show=\"vm.util.navPermission.shippers[1]\"><div class=\"shipper_table\"><div \nlayout=\"row\" layout-padding flex=\"100\"><div layout-align=\"start center\" class=\"pt-15 page_content\" flex=\"90\" \nflex-xs=\"90\">{{vm.shipperLength}} Companies Found</div><div layout-align=\"end center\" ng-if=\"vm.shipperLength\" \nflex=\"10\" flex-xs=\"10\"><md-button md-no-ink class=\"md-link-btn with-icon h-36 ml-0\" \nng-click=\"vm.exportShipper($event)\" ng-if=\"vm.util.navPermission.EXPORT_SHIPPERS[0]\"><md-icon class=\"h-25\" \nmd-font-icon=\"icon-arrow-up\"></md-icon>Export</md-button></div></div><table class=\"dataTable row-border hover\" \nid=\"shipper_tables\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \ndt-instance=\"vm.dtInstanceCallback\"></table></div></div></div></div></div>");
$templateCache.put("app/main/roles/user/shipperusers.html","<md-sidenav ng-if=\"vm.userData.deviceName != \'laptop\'\" class=\"md-sidenav-right sidenav-bg no-scroll\" \nmd-component-id=\"right\" ms-sidenav-helper \nng-include=\"\'app/main/roles/user/filter-shipperusers/filter-shipperusers.html\'\" ms-sidenav-helper></md-sidenav><div \nid=\"Users-page\"><div class=\"pb-20 shipper_details pt-10\"><import-file-status-bar \ncallback=\"vm.fnRemoveFileStatus(requestId,index)\" importstatusobj=\"vm.importUserStatusData\"></import-file-status-bar>\n<div ng-include=\"\'app/main/roles/component/import-file-status-bar/import-file-success-message.html\'\"></div><div \nlayout=\"row\" class=\"pv-20 bb-header\" layout-align=\"space-between end\"><div ng-class=\"{ hide : vm.util.isMobileApp }\">\n<div class=\"page_title\">Users</div></div><div layout=\"row\" flex=\"\" layout-align=\"end center\"><md-button \nclass=\"md-link-btn with-icon h-36\" ng-click=\"vm.importShipper($event)\" ng-if=\"vm.util.navPermission.IMPORT_USERS[0]\">\n<md-icon md-font-icon=\"icon-arrow-down\"></md-icon>Import</md-button><md-button md-no-ink class=\"md-accent-btn m-0\" \nng-click=\"vm.create_shipper($event)\" ng-if=\"vm.util.navPermission.users[0]\">+ Create New User</md-button></div><div \nng-if=\"vm.userData.deviceName != \'laptop\'\" class=\"b md-primary-border brad-4 p-5 mb-3 mh-10 pointer float-filter\" \nng-click=\"vm.toggleSidenav(\'right\')\"><md-icon md-svg-src=\"assets/icons/custom/filter-new.svg\" \nclass=\"w-20 h-20 filter-icon\"></md-icon></div></div><div layout=\"row\"><div ng-if=\"vm.userData.deviceName == \'laptop\'\" \nclass=\"w-230\"><div class=\"sticky-filter\"><md-sidenav class=\"sidenav-bg no-scroll mt-10 mr-10\" \nmd-is-locked-open=\"vm.userData.deviceName == \'laptop\'\" ms-sidenav-helper \nng-include=\"\'app/main/roles/user/filter-shipperusers/filter-shipperusers.html\'\"></md-sidenav></div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" layout-wrap class=\"pt-20\" ng-if=\"!vm.util.navPermission.users[1]\">\n<div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div class=\"font-size-18 pb-8\">\nYou don\'t have permission to access this section.</div></div></div><div class=\"simple-table-container\" \nng-show=\"vm.util.navPermission.users[1]\"><div class=\"shipper_table\"><div layout=\"row\" layout-padding flex=\"100\"><div \nlayout-align=\"start center\" class=\"pt-15 page_content\" flex=\"90\" flex-xs=\"90\">{{vm.userLength}} Users Found</div><div \nlayout-align=\"end center\" flex=\"10\" flex-xs=\"10\" ng-if=\"vm.userLength\"><md-button md-no-ink \nclass=\"md-link-btn with-icon h-36 ml-0\" ng-click=\"vm.exportShipper($event)\" \nng-if=\"vm.util.navPermission.EXPORT_USERS[0]\"><md-icon class=\"h-25\" md-font-icon=\"icon-arrow-up\"></md-icon>Export\n</md-button></div></div><table class=\"dataTable row-border hover\" id=\"user_tables\" datatable=\"\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\"></table></div></div></div>\n</div></div>");
$templateCache.put("app/main/schedulesSearch/filterSchedule/filterSchedule.html","<div id=\"schedule-search-page\"><div class=\"w-100p\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/custom/filter-new.svg\" \nclass=\"w-20 h-20 filter-icon mr-10\"></md-icon><span class=\"font-size-16 Font-Bold fg-AAA8AD\" flex>Filters </span><a \nclass=\"font-size-13 pointer md-link-fg font-weight-600 clear-btn\" ng-click=\"vm.clearAll()\">Clear All</a><md-icon \nng-if=\"vm.scheduleLinerList.deviceName != \'laptop\'\" md-font-icon=\"icon-close-circle-outline\" \nclass=\"s20 cursor ml-5 md-link-fg\" ng-click=\"vm.toggleSidenav(\'right\')\"></md-icon></div><md-divider></md-divider></div>\n<div class=\"content\"><div layout=\"column\" class=\"p-15 bb\"><div layout=\"row\" flex layout-align=\"space-between center\" \nclass=\"pointer mb-15\" ng-click=\"vm.collapseDiv(\'sched_carrier\',$event);sched_carrier=!sched_carrier\"><div><span \nclass=\"font-size-14 font-weight-600\">Carrier</span> <span \nng-if=\"(vm.filterLinersList | filter:{selected: true }).length\" class=\"filtered-count md-component-bg white-fg\">\n{{( vm.filterLinersList | filter:{selected: true }).length}}</span></div><div><md-icon md-font-icon=\"icon-chevron-up\" \nclass=\"icon-arrow s18\" ng-class=\"{\'chevron-rotate\': sched_carrier}\"></md-icon></div></div><div id=\"sched_carrier\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-15\"><input type=\"search\" \nng-model=\"searchText\" placeholder=\"Search by carrier name\" class=\"font-size-12 font-primary-fg inputSearch\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"iconed-search w-15 h-15 fg-AAA8AD\"></md-icon></div><md-list-item class=\"mt-10\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"scroll-list\" ms-scroll layout=\"column\" flex><div \nclass=\"font-size-14 black-fg\" \nng-repeat=\"liner in vm.filterLinersList | filter : searchText as linersData track by $index\"><md-checkbox md-no-ink \nng-model=\"liner.selected\" aria-label=\"\" ng-if=\"vm.scheduleLinerList.deviceName == \'laptop\'\" \nng-change=\"vm.filterDataBylinersAndTransit(vm.filterLinersList)\"><span ng-if=\"liner && liner.official_name\" \nng-bind=\"liner.official_name\" class=\"mr-5\"></span>(<span class=\"\" ng-bind=\"liner.count\"></span>)</md-checkbox>\n<md-checkbox md-no-ink ng-model=\"liner.selected\" aria-label=\"\" ng-if=\"vm.scheduleLinerList.deviceName != \'laptop\'\">\n<span ng-if=\"liner && liner.official_name\" ng-bind=\"liner.official_name\" class=\"mr-5\"></span>(<span class=\"\" \nng-bind=\"liner.count\"></span>)</md-checkbox></div></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\" \nng-if=\"linersData.length<=0\">No search found.</div></md-list-item></div></div><div layout=\"column\" flex class=\"p-15\">\n<div layout=\"column\" flex class=\"font-size-14\"><span class=\"pb-10\">Direct Routes</span><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"pr-20 toggle-text\">No</span><md-switch md-no-ink \nng-model=\"vm.via_route_filter\" md-invert ng-true-value=\"\'Direct\'\" ng-false-value=\"\'Transhipment\'\" \nng-change=\"vm.cardFilterViaDirect(vm.via_route_filter)\" aria-label=\"Switch 1\" class=\"ph-5 mv-5\"></md-switch><span \nclass=\"pl-20 toggle-text\">Yes</span></div></div></div></div><div layout=\"row\" flex=\"100\" class=\"p-10 bottomBtn\" \nng-if=\"linersData.length > 0 && vm.scheduleLinerList.deviceName != \'laptop\'\"><div layout=\"column\" \nclass=\"font-size-14 font-weight-600\" flex><md-button class=\"inco-button md-accent-btn\" \nng-click=\"vm.filterDataBylinersAndTransit(vm.filterLinersList)\">Apply Search</md-button></div></div></div>");
$templateCache.put("app/main/settings/assign-shipper/assign-shipper.html","<div class=\"demo-content assign-forwarder\"><div layout=\"row\" class=\"mv-15\"><div class=\"font-size-20 heading pr-10\">\nAssign Customers</div></div><div ng-if=\"!vm.isDataLoading\" layout=\"row\" layout-xs=\"column\" class=\"white-bg brad-3\"><div\n flex=\"30\" flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.forwarderList.length\"><md-button md-no-ink \nclass=\"md-icon-button sidenav-toggle mb-5 select_forwarder\" ng-click=\"vm.toggleSidenav(\'assign-shipper\')\" hide-gt-xs \naria-label=\"Toggle left sidenav\"><div layout=\"row\"><md-icon md-font-icon=\"icon-person-plus\" class=\"icon mr-5\">\n</md-icon>Select Forwarder</div></md-button><md-sidenav class=\"sidenav pv-20 ph-5\" \nmd-is-locked-open=\"$mdMedia(\'gt-xs\')\" md-component-id=\"assign-shipper\" ms-scroll ms-sidenav-helper><div layout=\"row\" \nflex=\"100\" class=\"close-button-mobile\"><div layout=\"row\" layout-align=\"end center\" flex=\"100\"><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'assign-shipper\')\"><md-icon md-font-icon=\"icon-close black-fg\">\n</md-icon></md-button></div></div><div layout=\"row\" flex=\"100\"><div class=\"font-size-18 grey-600-fg\" layout=\"row\" \nlayout-align=\"start center\" flex=\"100\"><b><span title=\"Users will be assigned to shippers\">Select User</span></b></div>\n</div><div class=\"mt-25 pr-10\" ng-if=\"vm.forwarderList.length > 0\"><md-input-container class=\"md-block m-0 p-0\" \nmd-no-float><input ng-model=\"vm.forwarder_name\" onkeyup=\"this.value = this.value.toUpperCase()\" name=\"forwarder_name\" \nplaceholder=\"Search Forwarder User\" required></md-input-container></div><md-list class=\"list-forwarder\"><md-list-item \nng-class=\"{\'grey-200-bg\':vm.fwd_active_tab == forwarder.id}\" \nng-repeat=\"forwarder in vm.forwarderList | filter : vm.forwarder_name track by $index\" \nclass=\"no-padding mt-10 pointer\" ng-click=\"vm.getShippers(forwarder)\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" ng-class=\"{\'assigned\': forwarder.isAssigned === true}\"><div \nclass=\"avatar-wrapper\" flex=\"10\" layout=\"row\"><div ng-if=\"forwarder.isAssigned\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"s10 green-400-fg mr-10\"></md-icon></div><div \nng-if=\"!forwarder.isAssigned\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s10 red-400-fg mr-10\">\n</md-icon></div></div><div flex class=\"text-truncate\"><div class=\"font-size-14 h-20 ml-5 display-table\" \nng-class=\"{\'md-link-fg\':vm.fwd_active_tab == forwarder.id, \'mb-20\': !vm.util.isFreightbro}\">\n{{forwarder.user_first_name}} {{forwarder.user_last_name}}</div><div class=\"font-size-10 ml-5\" \nng-class=\"{\'md-link-fg\':vm.fwd_active_tab == forwarder.id}\"><span ng-if=\"vm.util.isFreightbro\">\n{{forwarder.company.company_name}}</span></div></div><div flex=\"10\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"icon s46 grey-300-fg\" ng-class=\"{\'md-link-fg\':vm.fwd_active_tab == forwarder.id}\"></md-icon></div></div>\n</md-list-item></md-list></md-sidenav></div><div ng-if=\"vm.groupedShipperList.length\" flex flex-xs=\"100\" \nclass=\"pv-20 shipper-list-mobile\"><div layout=\"row\" flex=\"100\" class=\"mb-20\"><div class=\"font-size-18 grey-600-fg\" \nlayout=\"row\" layout-align=\"start center\" flex=\"50\"><b><span translate=\"Assigned\">Assigned</span></b>&nbsp;<span \ntranslate=\"Customers\">Customers</span></div><div class=\"forwarder-count mt-10\" layout=\"row\" layout-align=\"end center\" \nflex=\"50\"><span class=\"count-bg\">{{vm.assignedShipperLength}}</span></div></div><div><md-input-container \nclass=\"md-block m-0 p-0\" md-no-float><input ng-model=\"vm.search_shipper\" name=\"search_shipper\" \nplaceholder=\"Search customer\"></md-input-container></div><md-expansion-panel md-component-id=\"permissionInfo\" \nng-repeat=\"shipper in vm.groupedShipperList | filter : vm.search_shipper track by $index\"><md-expansion-panel-collapsed\n class=\"cursor\"><div><md-checkbox md-no-ink ng-model=\"shipper.isChecked\" \nng-click=\"vm.masterCheck($event, shipper.isChecked, shipper.users);\"></md-checkbox></div><div layout=\"row\" \nlayout-align=\"space-between start\" flex=\"100\"><div class=\"font-size-16 grey-600-fg\"><b>\n{{shipper.company.company_name}} <span ng-if=\"shipper.isChecked\" class=\"total_quote_count ph-8\">\n{{ vm.showAssignedCount(shipper.users) }}</span></b></div><div class=\"font-size-14 grey-600-fg\">\n{{shipper.users.length}} <span translate=\"Users\">Users</span><md-icon \nmd-font-icon=\"icon-chevron-down ml-10 grey-fg s30\"></md-icon></div></div></md-expansion-panel-collapsed>\n<md-expansion-panel-expanded><md-expansion-panel-header ng-click=\"$panel.collapse()\" class=\"cursor\"><div class=\"mt-15\">\n<md-checkbox md-no-ink ng-model=\"shipper.isChecked\" \nng-click=\"vm.masterCheck($event, shipper.isChecked, shipper.users);\"></md-checkbox></div><div layout=\"row\" \nlayout-align=\"space-between start\" flex=\"100\"><div class=\"font-size-16 grey-600-fg\"><b>\n{{shipper.company.company_name}} <span ng-if=\"shipper.isChecked\" class=\"total_quote_count ph-8\">\n{{ vm.showAssignedCount(shipper.users) }}</span></b></div><div class=\"font-size-14 grey-600-fg\">\n{{shipper.users.length}} <span translate=\"Users\">Users</span><md-icon md-font-icon=\"icon-chevron-up ml-10 grey-fg s30\">\n</md-icon></div></div></md-expansion-panel-header><md-expansion-panel-content class=\"font-size-14 opacity\"><div \nng-repeat=\"user in shipper.users track by $index\" layout=\"row\" layout-align=\"space-between start\" flex=\"100\"><div \nclass=\"font-size-14 grey-500-fg\">{{user.first}} {{user.last}}</div><div><md-checkbox md-no-ink ng-model=\"user.checked\" \nng-change=\"vm.checkIfParentClick(shipper); vm.countTrack(user.checked);\"></md-checkbox></div></div>\n</md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel></div><div \nng-if=\"vm.groupedShipperList.length==0 && vm.forwarderClick && !vm.shipperListLoading\" layout-align=\"center center\" \nlayout=\"column\" class=\"text-center font-size-18 font-weight-600 grey-600-fg h-150\"><em>Data Not Found !</em></div>\n</div><div ng-if=\"vm.groupedShipperList.length\" layout=\"row\" class=\"save_btn_div\" layout-align=\"end center\" flex=\"100\">\n<md-button md-no-ink class=\"md-accent-btn\" ng-disabled=\"vm.disableBtn\" ng-click=\"vm.saveShippers($event)\" \ntranslate=\"Save\">Save</md-button></div><div shimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" \nng-if=\"vm.isDataLoading\" ng-repeat=\"shimmer in [1,2,3,4]\"></div><div \nng-if=\"vm.forwarderList.length==0 && !vm.isDataLoading\" layout-align=\"center center\" layout=\"column\" \nclass=\"text-center font-size-18 font-weight-600 grey-600-fg mt-10\"><md-icon \nmd-svg-icon=\"assets/icons/custom/triangular-warning-sign.svg\" class=\"w-115 h-100\"></md-icon><div class=\"grey-fg mt-20\" \nng-if=\"!vm.permissionErr\">NO DATA FOUND</div></div><div class=\"grey-fg mt-20 font-size-24 text-center\" \nng-if=\"vm.permissionErr\"><em>Sorry, You don\'t have permission to access this section.</em></div></div>");
$templateCache.put("app/main/settings/company-groups/company-groups.html","<div class=\"demo-content company-groups pv-20\" ng-style=\"vm.configurations.screenHeight\"><div><div class=\"pb-10 bb\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" \nng-if=\"!vm.isDataLoading && vm.companyGroupList.length\"><div><span class=\"font-size-24\">Company Groups</span><br><span \nclass=\"grey-500-fg\">{{vm.companyGroupList.length}} Company Groups Available</span></div><div><md-button \nclass=\"md-accent-btn\" ng-click=\"vm.fnCreateCompanyGroup($event)\" ng-if=\"vm.companyGroupPermission[0]\">\n+ Create New Company Group</md-button></div></div><div shimmer-effect-full width=\"100%\" height=\"30px\" mh=\"10px\" \nclass=\"mv-20\" ng-if=\"vm.isDataLoading\" ng-repeat=\"shimmer in [1,2,3,4]\"></div><div ng-if=\"!vm.isDataLoading\"><div \nng-if=\"vm.companyGroupList.length==0\" layout-align=\"center center\" layout=\"column\" \nclass=\"text-center font-size-18 font-weight-600 grey-600-fg\"><md-icon \nmd-svg-icon=\"assets/icons/custom/triangular-warning-sign.svg\" class=\"w-115 h-100\"></md-icon><div class=\"grey-fg mt-10\">\nNO COMPANY GROUPS FOUND</div></div><div ng-if=\"vm.companyGroupList.length == 0 && vm.companyGroupPermission[0]\" \nlayout-align=\"center center\" layout=\"column\" class=\"mt-20\"><md-button md-no-ink class=\"md-accent-btn mt-10\" \nng-click=\"vm.fnCreateCompanyGroup($event)\" translate=\"Create_New\">Create New</md-button></div></div><div \nclass=\"simple-table-container\" ng-if=\"!vm.isDataLoading && vm.companyGroupList.length\"><div class=\"shipper_table\">\n<table class=\"dataTable row-border hover\" id=\"company_groups_table\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th><div class=\"table-header\"><span class=\"file_heading column-title ml-15\">Group Name</span></div></th><th><div \nclass=\"table-header\"><span class=\"file_heading column-title\">Company Type</span></div></th><th><div \nclass=\"table-header\"><span class=\"file_heading column-title\">Companies</span></div></th><th><div class=\"table-header\">\n<span class=\"file_heading column-title\">Created Date</span></div></th><th class=\"all text-center\"><div \nclass=\"table-header\"><span class=\"file_heading column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"companyGroup in vm.companyGroupList track by $index\"><td>\n{{(!companyGroup.groupName ? \'N/A\' : companyGroup.groupName)}}</td><td>\n{{companyGroup.companyType === \'SHIPPER\' ? \'Customer\' : companyGroup.companyType}}</td><td><div \nclass=\"text-truncate sub-heading\" ng-if=\"companyGroup.companies.length>0\">{{companyGroup.companies[0].company_name}} \n<span ng-show=\"companyGroup.companies.length>1\">+{{companyGroup.companies.length-1}}</span><md-tooltip \nmd-direction=\"Bottom\" class=\"md-whiteframe-2dp white-bg black-fg font-size-12\" style=\"height: fit-content\"><span \nng-repeat=\"company in companyGroup.companies track by $index\"><span>{{company.company_name}}</span><br></span>\n</md-tooltip></div><span ng-if=\"companyGroup.companies.length == 0\">No Companies</span></td><td>\n{{companyGroup.createdAt | date:\'dd/MM/yyyy\'}}</td><td class=\"text-center\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"pointer mh-5 s18 black-fg\" ng-click=\"vm.fnEditCompanyGroup(companyGroup,$index,$event)\" \nng-if=\"vm.companyGroupPermission[2]\"></md-icon><md-icon md-font-icon=\"icon-eye\" \nclass=\"s18 black-fg eye_icon mr-8 pointer\" ng-click=\"vm.fnViewCompanyGroup(companyGroup,$event)\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" class=\"pointer s18 black-fg\" ng-click=\"vm.fnOpenConfirmDeleteModal(companyGroup,$event)\" \nng-if=\"vm.companyGroupPermission[3]\"></md-icon></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/settings/company-information/company-information.html","<div class=\"demo-content company-profile\"><div layout=\"row\" class=\"mv-15\"><div class=\"font-size-20 heading pr-10\">\nSettings</div></div><div shimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" ng-repeat=\"shimmer in [1,2,3,4]\" \nng-if=\"vm.isDataLoading\"></div><md-tabs md-no-ink md-dynamic-height md-border-bottom ng-if=\"!vm.isDataLoading\" \nclass=\"tab-card brad-3 white-bg mv-10\"><md-tab label=\"General\" \nmd-on-select=\"vm.util.callMixpanel(\'CI-Settings-Click\',{\'Tab Name\':\'General\'})\"><md-content class=\"md-padding\"><form \nname=\"vm.generalFrm\" ng-submit=\"vm.updateCompanyProfile(\'General\')\"><div layout=\"column\" \nclass=\"ph-10 pt-5 md-inline-form\"><div layout=\"row\" layout-xs=\"column\" layout-wrap><div flex class=\"mr-25\"><span \nclass=\"label\" translate=\"Company_Name\">Company Name</span> <span class=\"red-fg\">*</span><md-input-container \nclass=\"md-block mt-8 p-0\" md-no-float><input ng-model=\"vm.companyProfile.company_name\" name=\"company_name\" \nplaceholder=\"Enter Company name\" required \nng-change=\"vm.util.callMixpanel(\'CI-CompanyName-Change\',{\'Value\':vm.companyProfile.company_name})\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"vm.generalFrm.company_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container></div><div flex class=\"mr-20\"><span class=\"label\" translate=\"Company_Email_ID\">\nCompany Email ID</span> <span class=\"red-fg\">*</span><md-input-container class=\"md-block mt-8 p-0\" md-no-float><input \nng-model=\"vm.companyProfile.company_email\" type=\"email\" name=\"company_email\" placeholder=\"Enter Email ID\" \nng-change=\"vm.util.callMixpanel(\'CI-CompanyEmail-Change\' ,{\'Value\':vm.companyProfile.company_email});\" \nng-pattern=\"vm.util.emailRegex\" required><div ng-messages=\"vm.generalFrm.company_email.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company Email is required.</span></div><div ng-message=\"pattern\"><span>\nEnter a valid Email Id</span></div></div></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nlayout-wrap><div flex class=\"mr-25\"><div><span class=\"label\" translate=\"Company_Website\">Company Website</span><span \nclass=\"red-fg\">*</span><md-input-container class=\"md-block mt-8 p-0\" md-no-float><input \nng-model=\"vm.companyProfile.domain_data.company_website_url\" name=\"company_website_url\" \nplaceholder=\"Enter Company Website\" required \nng-change=\"vm.util.callMixpanel(\'CI-CompanyWebsite-Change\' ,{\'Value\':vm.companyProfile.domain_data.company_website_url});\">\n<div ng-messages=\"vm.generalFrm.company_website_url.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInvalid Company Website.</span></div></div></md-input-container></div><div><span class=\"label\" \ntranslate=\"Company_Tracking_URL\">Company Tracking URL</span><md-input-container class=\"md-block mt-8 p-0\" md-no-float>\n<input ng-model=\"vm.companyProfile.domain_data.company_tracking_url\" name=\"company_tracking_url\" \nplaceholder=\"Enter Company Tracking URL\" \nng-change=\"vm.util.callMixpanel(\'CI-CompanyTrackingURL-Change\' ,{\'Value\':vm.companyProfile.domain_data.company_tracking_url});\">\n</md-input-container></div><div><span class=\"label\" translate=\"Phone_Number\">Phone Number</span><md-input-container \nclass=\"md-block mt-8 p-0\" md-no-float><input class=\"tel-input bb h-30\" type=\"tel\" \nng-model=\"vm.companyProfile.company_phone_number\" placeholder=\"Phone Number\" name=\"company_mobile\" ng-maxlength=\"40\" \nng-change=\"vm.util.callMixpanel(\'CI-PhoneNumber-Change\' ,{\'Value\':vm.companyProfile.company_phone_number});\"><div \nng-messages=\"vm.generalFrm.company_mobile.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container></div></div><div flex><span class=\"label\" \ntranslate=\"Company_Address\">Street Address</span><br><span class=\"font-size-12\">\nThe below address will be print in the Quotation PDF.</span><md-input-container class=\"md-block mt-8 p-0\" md-no-float>\n<ng-ckeditor ng-config=\"vm.util.ckEditorConfig\" class=\"company_address\" ng-model=\"vm.companyProfile.company_address\" \nname=\"company_address\" placeholder=\"Street address\" rows=\"5\" \nng-mouseleave=\"vm.util.callMixpanel(\'CI-CompanyAddress-Change\' ,{\'Value\':vm.companyProfile.company_address});\">\n</ng-ckeditor></md-input-container><div class=\"mt-20\"><span class=\"label\" translate=\"City\">City</span>\n<md-input-container class=\"md-block mt-8 p-0\" md-no-float><input ng-model=\"vm.companyProfile.city\" name=\"city\" \nplaceholder=\"Enter City\" ng-change=\"vm.util.callMixpanel(\'CI-City-Change\' ,{\'Value\':vm.companyProfile.city});\">\n</md-input-container></div></div></div><div flex class=\"mr-10 file_div\" layout=\"column\"><span class=\"label pb-5\" \ntranslate=\"Company_Logo\">Company Logo</span> <span class=\"font-size-10\" ng-if=\"!vm.isPreview && !vm.isOrigLogo\">\n.png, .jpg, .jpeg file | Upto 10MB</span><div class=\"input-box mt-15\" ng-if=\"!vm.isPreview && !vm.isOrigLogo\"><input \nname=\"company_logo\" type=\"file\" id=\"fileInput_company_logo\" ng-change=\"vm.util.callMixpanel(\'CI-CompanyLogo-Change\');\" \nngf-select=\"vm.fnLogoValidation(\'init\', vm.company_logo, $event)\" ng-model=\"vm.company_logo\" ngf-max-size=\"10MB\" \nng-model-options=\"{\n                                        updateOn: \'default blur onchange\',\n                                        debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                      }\" \naccept=\".png, .jpg, .jpeg\"></div><div ng-if=\"vm.generalFrm.company_logo.$error.maxSize\" \nclass=\"font-size-14 red-fg mt-10\">This file is too large, maximum file size is 10MB.</div><input name=\"company_logo\" \ntype=\"file\" hide id=\"fileEdit_company_logo\" ngf-select=\"vm.fnLogoValidation(\'init\', vm.company_logo, $event)\" \nng-model=\"vm.company_logo\" ngf-max-size=\"10MB\" accept=\".png, .jpg, .jpeg\"><div class=\"cropped-imgBox mt-15\" \nlayout=\"column\" layout-align=\"center center\" \nng-class=\"{\'square\': vm.logoStyle==\'square\', \'rectangle\': vm.logoStyle!=\'square\', \'hide\' : !vm.isPreview && !vm.isOrigLogo}\">\n<img class=\"cropped-img\" src=\"\"><md-menu md-position-mode=\"left bottom\"><div class=\"overlay\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon class=\"img-icon\" md-font-icon=\"icon-camera\" class=\"mr-5 s18\">\n</md-icon><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left\" \nstyle=\"display:table;opacity: 1\">Click to view/edit logo</md-tooltip></div><md-menu-content><md-menu-item><md-button \nmd-no-ink class=\"fg-333333 font-size-14\" ng-click=\"vm.fnLogoValidation(\'edit\')\"><md-icon md-font-icon=\"icon-pencil\" \nmd-menu-align-target class=\"s16 fg-333333\"></md-icon>Edit</md-button></md-menu-item><md-menu-item><md-button md-no-ink \nclass=\"fg-333333 font-size-14\" ng-click=\"vm.fnReplaceLogo()\"><md-icon md-font-icon=\"icon-reply\" class=\"s16 fg-333333\">\n</md-icon>Replace</md-button></md-menu-item><md-menu-item ng-if=\"!vm.companyProfileCopy.original_logo\"><md-button \nmd-no-ink class=\"fg-333333 font-size-14\" ng-click=\"vm.fnResetLogo();\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s16 fg-333333\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"pt-40 bt\"><div class=\"font-size-14 grey-700-fg\">\nFFC Domain: {{ vm.isFfcDomain() ? \'Yes\' : \'No\' }}</div><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" \nng-disabled=\"vm.generalFrm.$invalid\" translate=\"APPLY_CHANGES\">Apply Changes</md-button></div></form></md-content>\n</md-tab><md-tab label=\"Terms And Conditions\" \nmd-on-select=\"vm.util.callMixpanel(\'CI-Settings-Click\',{\'Tab Name\':\'Terms And Conditions\'}) ; loadTermsEditor=true;\">\n<md-content class=\"md-padding\" ng-if=\"loadTermsEditor\"><form name=\"configFrm\" \nng-submit=\"vm.updateCompanyProfile(\'Terms And Conditions\')\"><div flex=\"100\" layout=\"row\"><div flex flex-xs=\"100\" \nlayout=\"column\" layout-align=\"start start\"><span class=\"label\" translate=\"Terms_And_Condition_Link\">\nTerms & Conditions Link</span><md-input-container class=\"md-block mt-8 mb-0 p-0 full-width\" md-no-float><input \ntype=\"url\" ng-model=\"vm.companyProfile.domain_data.terms_and_condtion\" name=\"terms_and_condtion\" \nplaceholder=\"Enter Terms and condition link\" \nng-change=\"vm.util.callMixpanel(\'CI-T&C-Link-Change\' ,{\'Value\':vm.companyProfile.domain_data.terms_and_condtion})\" \nng-model-options=\"{\n                                    updateOn: \'default blur onchange\',\n                                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                }\">\n<div ng-messages=\"configFrm.terms_and_condtion.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Invalid link.\n</span></div></div></md-input-container></div><div flex=\"20\" flex-xs=\"100\" layout=\"column\" layout-align=\"start end\">\n<div layout=\"column\"><label class=\"pb-5\">Language</label><div shimmer-effect-full width=\"100%\" height=\"30px\" \nclass=\"mt-15\" ng-if=\"vm.languageLoading\" ng-repeat=\"shimmer in [1]\"></div><md-input-container \nclass=\"input_container border w-120\" md-no-float ng-if=\"!vm.languageLoading\"><md-select class=\"panel-select\" \nng-model=\"vm.companyProfile.language\" placeholder=\"Select Language\" md-on-close=\"searchLanguage = \'\'\" \nname=\"fcl_default_language\" ng-change=\"vm.languageChanged()\"><md-select-header><input ng-model=\"searchLanguage\" \ntype=\"search\" placeholder=\"Search Language\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"language in vm.languageList | orderBy:\'name\' | filter : {name : searchLanguage}\" ng-value=\"language.code\">\n{{language.name}}</md-option></md-select></md-input-container></div></div></div><md-expansion-panel \nmd-component-id=\"fcl-tnc\"><md-expansion-panel-collapsed class=\"cursor bb\"><div layout=\"row\" \nlayout-align=\"space-between start\" flex=\"100\"><div class=\"label\" layout=\"row\">FCL</div><div \nclass=\"font-size-14 grey-600-fg\"><md-icon md-font-icon=\"icon-chevron-down ml-10 grey-fg s30\"></md-icon></div></div>\n</md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header ng-click=\"$panel.collapse()\" \nclass=\"cursor\"><div layout=\"row\" layout-align=\"space-between start\" flex=\"100\"><div class=\"label\" layout=\"row\">FCL\n</div><div class=\"font-size-14 grey-600-fg\"><md-icon md-font-icon=\"icon-chevron-up ml-10 grey-fg s30\"></md-icon></div>\n</div></md-expansion-panel-header><md-expansion-panel-content><div shimmer-effect-full width=\"97%\" height=\"20px\" \nmh=\"10px\" ng-repeat=\"shimmer in [1, 2, 3, 4, 5]\" ng-if=\"vm.isTermsLoading\"></div><div class=\"quote-editor\" \nng-if=\"!vm.isTermsLoading\"><ng-ckeditor ng-model=\"vm.companyProfile.tnc_fcl\" id=\"termsConditions\" \nng-config=\"vm.termsConditionCkEditorConfig\" \nng-mouseleave=\"vm.util.callMixpanel(\'CI-T&C-Change\' ,{\'Value\':vm.companyProfile.tnc_fcl,\'Mode\':\'FCL\'})\"></ng-ckeditor>\n</div></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><md-expansion-panel \nmd-component-id=\"lcl-tnc\"><md-expansion-panel-collapsed class=\"cursor bb\"><div layout=\"row\" \nlayout-align=\"space-between start\" flex=\"100\"><div class=\"label\" layout=\"row\">LCL</div><div \nclass=\"font-size-14 grey-600-fg\"><md-icon md-font-icon=\"icon-chevron-down ml-10 grey-fg s30\"></md-icon></div></div>\n</md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header ng-click=\"$panel.collapse()\" \nclass=\"cursor\"><div layout=\"row\" layout-align=\"space-between start\" flex=\"100\"><div class=\"label\" layout=\"row\">LCL\n</div><div class=\"font-size-14 grey-600-fg\"><md-icon md-font-icon=\"icon-chevron-up ml-10 grey-fg s30\"></md-icon></div>\n</div></md-expansion-panel-header><md-expansion-panel-content><div shimmer-effect-full width=\"97%\" height=\"20px\" \nmh=\"10px\" ng-repeat=\"shimmer in [1, 2, 3, 4, 5]\" ng-if=\"vm.isTermsLoading\"></div><div class=\"quote-editor\" \nng-if=\"!vm.isTermsLoading\"><ng-ckeditor ng-model=\"vm.companyProfile.tnc_lcl\" id=\"termsConditions\" \nng-config=\"vm.termsConditionCkEditorConfig\" \nng-mouseleave=\"vm.util.callMixpanel(\'CI-T&C-Change\' ,{\'Value\':vm.companyProfile.tnc_lcl,\'Mode\':\'LCL\'})\"></ng-ckeditor>\n</div></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><md-expansion-panel \nmd-component-id=\"air-tnc\"><md-expansion-panel-collapsed class=\"cursor bb\"><div layout=\"row\" \nlayout-align=\"space-between start\" flex=\"100\"><div class=\"label\" layout=\"row\">AIR</div><div \nclass=\"font-size-14 grey-600-fg\"><md-icon md-font-icon=\"icon-chevron-down ml-10 grey-fg s30\"></md-icon></div></div>\n</md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header ng-click=\"$panel.collapse()\" \nclass=\"cursor\"><div layout=\"row\" layout-align=\"space-between start\" flex=\"100\"><div class=\"label\" layout=\"row\">AIR\n</div><div class=\"font-size-14 grey-600-fg\"><md-icon md-font-icon=\"icon-chevron-up ml-10 grey-fg s30\"></md-icon></div>\n</div></md-expansion-panel-header><md-expansion-panel-content><div shimmer-effect-full width=\"97%\" height=\"20px\" \nmh=\"10px\" ng-repeat=\"shimmer in [1, 2, 3, 4, 5]\" ng-if=\"vm.isTermsLoading\"></div><div class=\"quote-editor\" \nng-if=\"!vm.isTermsLoading\"><ng-ckeditor ng-model=\"vm.companyProfile.tnc_air\" id=\"termsConditions\" \nng-config=\"vm.termsConditionCkEditorConfig\" \nng-mouseleave=\"vm.util.callMixpanel(\'CI-T&C-Change\' ,{\'Value\':vm.companyProfile.tnc_air,\'Mode\':\'AIR\'})\"></ng-ckeditor>\n</div></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><div layout=\"row\" \nlayout-align=\"end end\" class=\"mt-20 pt-20\"><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" \nng-disabled=\"configFrm.$invalid\" translate=\"APPLY_CHANGES\">Apply Changes</md-button></div></form></md-content></md-tab>\n<md-tab label=\"Communication Email\" \nmd-on-select=\"vm.util.callMixpanel(\'CI-Settings-Click\',{\'Tab Name\':\'Communication Email\'})\"><md-content \nclass=\"md-padding\"><form name=\"domainFrm\" ng-submit=\"vm.updateCompanyProfile(\'Communication Email\')\"><div \nclass=\"mb-15\" layout=\"row\" layout-xs=\"column\" layout-wrap><div flex layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"Document_Submit_Required\">Document Submit Required</span><div class=\"pr-20 pl-20 toggle-text\">No</div>\n<md-switch md-no-ink ng-model=\"vm.companyProfile.domain_data.document_submit_required\" name=\"document_submit_required\" \nng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" \nng-change=\"vm.util.callMixpanel(\'CI-DocumentSubmit-Click\',{\'Value\':vm.companyProfile.domain_data.document_submit_required})\">\n</md-switch><div class=\"pl-20 toggle-text\">Yes</div></div><div flex layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"Shipment_Notification_From_Specialist\">Booking Notification From Specialist</span><div \nclass=\"pr-20 pl-20 toggle-text\">No</div><md-switch md-no-ink \nng-model=\"vm.companyProfile.domain_data.shipment_notification_from_specialist\" \nname=\"shipment_notification_from_specialist\" aria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" \nng-change=\"vm.util.callMixpanel(\'CI-ShipmentNotification-Click\',{\'Value\':vm.companyProfile.domain_data.shipment_notification_from_specialist})\">\n</md-switch><div class=\"pl-20 toggle-text\">Yes</div></div></div><div layout=\"row\" layout-xs=\"column\" layout-wrap><div \nflex class=\"mr-25\" ng-if=\"vm.companyProfile.domain_data.document_submit_required == \'true\'\"><span class=\"label\" \ntranslate=\"Document_Submit_Email\">Document Submit Email</span><span class=\"red-fg\">*</span><md-input-container \nclass=\"md-block mt-8 p-0\" md-no-float><input ng-model=\"vm.companyProfile.domain_data.document_submit_email\" \ntype=\"email\" name=\"document_submit_email\" placeholder=\"Document submit email\" ng-pattern=\"vm.util.emailRegex\" \nng-change=\"vm.util.callMixpanel(\'CI-DocumentSubmitEmail-Change\',{\'Value\':vm.companyProfile.domain_data.document_submit_email})\" \nrequired \nng-model-options=\"{\n                                    updateOn: \'default blur onchange\',\n                                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                  }\">\n<div ng-messages=\"domainFrm.document_submit_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDocument submit email is required.</span></div><div ng-message=\"pattern\"><span>Enter a valid Email Id</span></div>\n</div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" flex-sm=\"100\" \nng-if=\"vm.companyProfile.domain_data.solution_type == \'WLS\'\"><span class=\"label\" \ntranslate=\"Send_Shipment_Booking_Confirmation\">Send Booking Confirmation to</span><div layout=\"row\"><md-input-container\n class=\"md-block mt-8 p-0\" md-no-float flex><input \nng-model=\"vm.companyProfile.domain_data.send_shipment_booking_confirmation\" name=\"send_shipment_booking_confirmation\" \nplaceholder=\"Enter booking confirmation\" \nng-change=\"vm.util.callMixpanel(\'CI-ShipmentBookingConfirmation-Change\',{\'Value\':vm.companyProfile.domain_data.send_shipment_booking_confirmation})\" \nng-pattern=\"vm.util.commonEmailRegex\" \nng-model-options=\"{\n                                            updateOn: \'default blur onchange\',\n                                            debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                          }\">\n<div ng-messages=\"domainFrm.send_shipment_booking_confirmation.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nValid mail is required.</span></div></div></md-input-container><span class=\"pt-15\" \nng-if=\"vm.companyProfile.domain_data.mailgun_domain\">@{{vm.companyProfile.domain_data.mailgun_domain}}</span></div>\n</div></div><div layout=\"row\" layout-xs=\"column\" layout-wrap><div flex class=\"mr-20\"><span class=\"label\" \ntranslate=\"Common_Email\">Common Email</span><span class=\"red-fg\">*</span><div layout=\"row\"><md-input-container \nclass=\"md-block mt-8 p-0\" md-no-float flex><input ng-model=\"vm.companyProfile.domain_data.common_email\" \nname=\"common_email\" placeholder=\"Common email\" \nng-change=\"vm.util.callMixpanel(\'CI-CommonEmail-Change\',{\'Value\':vm.companyProfile.domain_data.common_email})\" \nng-pattern=\"vm.util.commonEmailRegex\" required \nng-model-options=\"{\n                                            updateOn: \'default blur onchange\',\n                                            debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                          }\">\n<div ng-messages=\"domainFrm.common_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCommon email is required.</span></div><div ng-message=\"pattern\"><span>Valid email is required.</span></div></div>\n</md-input-container><span class=\"pt-15\" ng-if=\"vm.companyProfile.domain_data.mailgun_domain\">\n@{{vm.companyProfile.domain_data.mailgun_domain}}</span></div></div><div flex><span class=\"label\" \ntranslate=\"Sender_Name\">Sender Name</span><span class=\"red-fg\">*</span><md-input-container class=\"md-block mt-8 p-0\" \nmd-no-float><input ng-model=\"vm.companyProfile.domain_data.mail_from_name\" name=\"mail_from_name\" \nplaceholder=\"Mail From Name\" required \nng-change=\"vm.util.callMixpanel(\'CI-SenderName-Change\',{\'Value\':vm.companyProfile.domain_data.mail_from_name})\" \nng-model-options=\"{\n                                    updateOn: \'default blur onchange\',\n                                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                  }\">\n<div ng-messages=\"domainFrm.mail_from_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name is required.\n</span></div></div></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" layout-wrap><div flex \nclass=\"mr-25\"><span class=\"label\" translate=\"Shared_Rate_Receivers\">Shared Rate Receivers</span><md-input-container \nclass=\"md-block m-0 p-0\" md-no-float><md-chips ng-model=\"vm.companyProfile.domain_data.shared_rate_receivers\" \nname=\"shared_rate_receivers\" placeholder=\"Write email then Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"vm.validateEmail(vm.companyProfile.domain_data.shared_rate_receivers, $chip)\" md-add-on-blur=\"true\">\n<md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips><div class=\"errors\" \nng-messages=\"domainFrm.shared_rate_receivers.$error\" role=\"alert\"><div class=\"comp-invalidErrorMsg\" hide>\nInvalid email address!! We removed it.</div><div class=\"comp-duplicateErrorMsg\" hide>\nDuplicate email address!! We removed it.</div></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"end end\" class=\"mt-20 pt-20\"><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" \nng-disabled=\"domainFrm.$invalid\" translate=\"Apply\">Apply Changes</md-button></div></form></md-content></md-tab>\n</md-tabs></div>");
$templateCache.put("app/main/settings/pdf-configuration/pdf-configuration.html","<div class=\"demo-content pdf-configuration-container\"><div class=\"tab-card brad-3 white-bg mv-10\"><iframe \nclass=\"pdf-config-iframe\" ng-src=\"{{vm.iframeUrl}}\" ng-style=\"vm.iframeHeight\" frameborder=\"0\" scrolling=\"yes\">\n</iframe></div></div>");
$templateCache.put("app/main/settings/roles/roles.html","<div class=\"demo-content roles pv-20 custom_scroll\" ng-style=\"vm.configurations.screenHeight\"><div class=\"pb-10 bb\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" ng-if=\"!vm.isDataLoading && vm.rolesList.length\">\n<div><span class=\"font-size-24\">Roles</span><br><span class=\"grey-500-fg\">{{vm.rolesList.length}} Roles Available\n</span></div><div><md-button class=\"md-accent-btn\" ng-click=\"vm.fnCreateRole($event)\" ng-if=\"vm.rolePermission[0]\">\n+ Create New Role</md-button></div></div><div shimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" \nng-if=\"vm.isDataLoading\" ng-repeat=\"shimmer in [1,2,3,4]\"></div><div class=\"simple-table-container\" \nng-if=\"!vm.isDataLoading && vm.rolesList.length\"><div class=\"shipper_table\"><table class=\"dataTable row-border hover\" \nid=\"role_tables\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th><div class=\"table-header\"><span \nclass=\"file_heading column-title ml-15\">Role Name</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Target User</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Role Type</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">No. of Modules</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"roles in vm.rolesList track by $index\"><td>{{roles.name}}</td><td>\n{{roles.created_for === \'SHIPPER\' ? \'CUSTOMER\' : roles.created_for}}</td><td><span ng-show=\"roles.type == \'GLOBAL\'\" \nclass=\"global_role_select\">Global</span> <span ng-show=\"roles.type == \'USER_DEFINED\'\" class=\"user_role_select\">\nUser Defined</span></td><td>{{vm.getModulesCount(roles.modules)}}</td><td><md-icon md-font-icon=\"icon-pencil\" \nclass=\"pointer mh-5 s18 black-fg\" ng-click=\"vm.fnEditRole(roles,$index,$event)\" \nng-if=\"vm.rolePermission[2] && (roles.type === \'GLOBAL\'&& vm.util.isFreightbro || roles.type !== \'GLOBAL\')\"></md-icon>\n<md-icon md-font-icon=\"icon-eye\" class=\"cursor ml-10 mb-10 s18 black-fg\" \nng-if=\"!(vm.rolePermission[2] && (roles.type === \'GLOBAL\'&& vm.util.isFreightbro || roles.type !== \'GLOBAL\'))\" \nng-click=\"vm.fnEditRole(roles,$index,$event)\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nclass=\"pointer s18 black-fg\" \nng-if=\"(roles.type === \'GLOBAL\'&& vm.util.isFreightbro || roles.type !== \'GLOBAL\') && vm.rolePermission[3]\" \nng-click=\"vm.openRoleDeleteConfirmModal(roles,$event)\"></md-icon></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/shipment-status/shipment-status.html","<div id=\"setting-shipment-status\"><div class=\"status-management\" layout=\"column\"><div \nng-if=\"vm.forwarderStatus.length == 0  && !vm.isDataLoading\" layout-align=\"center center\" layout=\"column\" \nclass=\"text-center font-size-18 font-weight-600 grey-600-fg\"><md-icon \nmd-svg-icon=\"assets/icons/custom/triangular-warning-sign.svg\" class=\"w-115 h-100\"></md-icon><div class=\"grey-fg mt-5\" \ntranslate=\"No_Status_Found\">NO STATUS FOUND</div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap \nclass=\"pt-20\" ng-if=\"!vm.configurationPermission[1] && !vm.isDataLoading\"><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-size-18 pb-8\">\nYou don\'t have permission to access this section.</div></div></div><div layout=\"column\" class=\"mb-5\" \nng-if=\"vm.forwarderStatus.length\"><div><span class=\"font-size-24\">Booking Status</span><br><span class=\"grey-500-fg\">\n{{vm.forwarderStatus.length}} Status Available</span></div></div><div shimmer-effect-full width=\"97%\" height=\"30px\" \nmh=\"10px\" ng-if=\"vm.isDataLoading\" ng-repeat=\"shimmer in [1,2,3,4]\"></div><div \nng-if=\"vm.configurationPermission[1] && vm.forwarderStatus.length && !vm.isDataLoading\"><div \nclass=\"simple-table-container\" ng-if=\"vm.forwarderStatus.length\"><div class=\"shipper_table\"><table \nclass=\"dataTable row-border hover\" id=\"shipment_status_tables\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th>\n<div class=\"table-header\"><span class=\"file_heading column-title ml-15\">Status Name</span></div></th><th><div \nclass=\"table-header\"><span class=\"file_heading column-title\">FCL</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">LCL</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">AIR</span></div></th></tr></thead><tbody><tr \nng-repeat=\"statusData in vm.forwarderStatus track by $index\"><td><div class=\"font-size-14 Font-Regular pb-3\">\n{{statusData.status}}</div><div class=\"font-size-12 grey-fg\" ng-if=\"statusData.max_alloted_hrs\">\nAllotted for {{statusData.max_alloted_hrs}} Hours</div><div class=\"font-size-12 grey-fg\" \nng-if=\"!statusData.max_alloted_hrs\">N/A</div></td><td><md-icon md-font-icon=\"icon-check\" \nng-class=\"{\'md-link-fg\' : statusData.is_first_fcl}\" ng-if=\"statusData.fcl\"><md-tooltip ng-if=\"statusData.is_first_fcl\">\nThis status is the default for this mode</md-tooltip><md-tooltip ng-if=\"!statusData.is_first_fcl\">\nThis status applies to this mode</md-tooltip></md-icon></td><td><md-icon md-font-icon=\"icon-check\" \nng-class=\"{\'md-link-fg\' : statusData.is_first_lcl}\" ng-if=\"statusData.lcl\"><md-tooltip ng-if=\"statusData.is_first_lcl\">\nThis status is the default for this mode</md-tooltip><md-tooltip ng-if=\"!statusData.is_first_lcl\">\nThis status applies to this mode</md-tooltip></md-icon></td><td><md-icon md-font-icon=\"icon-check\" \nng-class=\"{\'md-link-fg\' : statusData.is_first_air}\" ng-if=\"statusData.air\"><md-tooltip ng-if=\"statusData.is_first_air\">\nThis status is the default for this mode</md-tooltip><md-tooltip ng-if=\"!statusData.is_first_air\">\nThis status applies to this mode</md-tooltip></md-icon></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/settings/tags/tags.html","<div class=\"demo-content tags pv-20\"><div><div class=\"pb-10 bb\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" ng-if=\"!vm.isDataLoading && vm.tagList.length\"><div><span class=\"font-size-24\">Tags\n</span><br><span class=\"grey-500-fg\">{{vm.tagList.length}} Tags Available</span></div><div><md-button \nclass=\"md-accent-btn\" ng-if=\"vm.tagPermission[0]\" ng-click=\"vm.fnCreateTag($event)\">+ Create New Tag</md-button></div>\n</div><div shimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" ng-if=\"vm.isDataLoading\" \nng-repeat=\"shimmer in [1,2,3,4]\"></div><div ng-if=\"!vm.isDataLoading && !vm.tagList.length\"><div \nlayout-align=\"center center\" layout=\"column\" class=\"text-center font-size-18 font-weight-600 grey-600-fg\"><md-icon \nmd-svg-icon=\"assets/icons/custom/triangular-warning-sign.svg\" class=\"w-115 h-100\"></md-icon><div class=\"grey-fg mt-10\">\nNO TAGS FOUND</div></div><div layout-align=\"center center\" layout=\"column\" class=\"mt-20 grey-500-fg\"><md-button \nmd-no-ink ng-if=\"vm.tagPermission[0]\" class=\"md-accent-btn mt-10\" ng-click=\"vm.fnCreateTag($event)\">Create New\n</md-button><div class=\"font-weight-600 font-size-18 mt-25\">What are Tags?</div><div \nclass=\"font-size-14 mt-5 text-center\">Tags let you label any shipment , quote , schedule etc.<br>\nand act as a filter just when you need them</div></div></div><div class=\"simple-table-container\" \nng-if=\"!vm.isDataLoading && vm.tagList.length\"><div class=\"shipper_table\"><table class=\"dataTable row-border hover\" \nid=\"tag_tables\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"w-180\"><div class=\"table-header\"><span \nclass=\"file_heading column-title ml-15\">Tag Name</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Tag Color</span></div></th><th class=\"all text-right\"><div class=\"table-header\"><span\n class=\"file_heading column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"tag in vm.tagList track by $index\"><td class=\"w-180\">{{(!tag.name ? \'N/A\' : tag.name)}}</td><td><md-icon \nmd-font-icon=\"icon-tag-text-outline\" class=\"{{tag.tag_color}} pointer s18 mr-5\"></md-icon></td><td class=\"text-right\">\n<md-icon md-font-icon=\"icon-delete\" class=\"pointer s18 black-fg mr-8\" \nng-click=\"vm.fnOpenConfirmDeleteModal(tag,$event)\" ng-if=\"vm.tagPermission[3]\"></md-icon></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/settings/teams/teams.html","<div class=\"demo-content teams pv-20\" ng-style=\"vm.configurations.screenHeight\"><div><div class=\"pb-10 bb\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" ng-if=\"!vm.isDataLoading && vm.teamList.length\">\n<div><span class=\"font-size-24\">Teams</span><br><span class=\"grey-500-fg\">{{vm.teamList.length}} Teams Available</span>\n</div><div><md-button class=\"md-accent-btn\" ng-click=\"vm.fnCreateTeam($event)\" ng-if=\"vm.teamPermission[0]\">\n+ Create New Team</md-button></div></div><div shimmer-effect-full width=\"100%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" \nng-if=\"vm.isDataLoading\" ng-repeat=\"shimmer in [1,2,3,4]\"></div><div ng-if=\"!vm.isDataLoading\"><div \nng-if=\"vm.teamList.length==0\" layout-align=\"center center\" layout=\"column\" \nclass=\"text-center font-size-18 font-weight-600 grey-600-fg\"><md-icon \nmd-svg-icon=\"assets/icons/custom/triangular-warning-sign.svg\" class=\"w-115 h-100\"></md-icon><div class=\"grey-fg mt-10\">\nNO TEAMS FOUND</div></div><div ng-if=\"vm.teamList.length == 0 && vm.teamPermission[0]\" layout-align=\"center center\" \nlayout=\"column\" class=\"mt-20\"><md-button md-no-ink class=\"md-accent-btn mt-10\" ng-click=\"vm.fnCreateTeam($event)\" \ntranslate=\"Create_New\">Create New</md-button></div></div><div class=\"simple-table-container\" \nng-if=\"!vm.isDataLoading && vm.teamList.length\"><div class=\"shipper_table\"><table class=\"dataTable row-border hover\" \nid=\"teams_tables\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th><div class=\"table-header\"><span \nclass=\"file_heading column-title ml-15\">Team Name</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Manager</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Members</span></div></th><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Parent Team</span></div></th><th class=\"all text-center\"><div class=\"table-header\">\n<span class=\"file_heading column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"team in vm.teamList track by $index\"><td>{{(!team.name ? \'N/A\' : team.name)}}</td><td><div \nclass=\"text-truncate sub-heading\" ng-if=\"team.managers.length>0\">\n{{team.managers[0].user_first_name}} {{team.managers[0].user_last_name}} <span ng-show=\"team.managers.length>1\">\n+{{team.managers.length-1}}</span><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg black-fg font-size-12\" style=\"height: fit-content\"><span \nng-repeat=\"manager in team.managers track by $index\"><span>{{manager.user_first_name}} {{manager.user_last_name}}\n</span><br></span></md-tooltip></div><span ng-if=\"team.managers.length == 0\">N/A</span></td><td><div \nclass=\"text-truncate sub-heading\" ng-if=\"team.members.length>0\">\n{{team.members[0].user_first_name}} {{team.members[0].user_last_name}} <span ng-show=\"team.members.length>1\">\n+{{team.members.length-1}}</span><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg black-fg font-size-12\" style=\"height: fit-content\"><span \nng-repeat=\"member in team.members track by $index\"><span>{{member.user_first_name}} {{member.user_last_name}}</span>\n<br></span></md-tooltip></div><span ng-if=\"team.members.length == 0\">N/A</span></td><td>\n{{(!team.parent.name ? \'N/A\' : team.parent.name)}}</td><td class=\"text-center\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"pointer mh-5 s18 black-fg\" ng-click=\"vm.fnEditTeam(team,$index,$event)\" ng-if=\"vm.teamPermission[2]\"></md-icon>\n<md-icon md-font-icon=\"icon-eye\" class=\"s18 black-fg eye_icon mr-8\" ng-click=\"vm.fnViewTeam(team,$event)\"></md-icon>\n<md-icon md-font-icon=\"icon-delete\" class=\"pointer s18 black-fg\" ng-click=\"vm.fnOpenConfirmDeleteModal(team,$event)\" \nng-if=\"vm.teamPermission[3]\"></md-icon></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/shipments/dialogs/trackingDialog.html","<md-dialog id=\"milestone_modal\" class=\"popup-lg\"><div class=\"modal_title\"><div class=\"md-toolbar-tools\"><div \nclass=\"pl-10 pb-5\" flex=\"90\">Track & Trace</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" \nclass=\"icon_size fg-AAA8AD\"><md-icon md-font-icon=\"icon-close m-10 fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div></div><md-dialog-content class=\"body\"><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between center\" layout-align-xs=\"start start\" flex=\"100\"><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between\" class=\"ml-15 pv-10 pr-50 responsive\" flex=\"70\" flex-xs=\"100\"><div \nng-if=\"ctrl.parent.trackMode !== \'SEA-LCL\'\" class=\"font-size-14 pb-mob font-weight-600\"><span class=\"grey-fg\">\nContainer Number </span><br>\n{{ctrl.parent.milestoneMeta.container_shipment_id ? ctrl.parent.milestoneMeta.container_shipment_id: \'--\'}}<md-tooltip \nmd-direction=\"bottom\">\n{{ctrl.parent.milestoneMeta.container_shipment_id? ctrl.parent.milestoneMeta.container_shipment_id: \'--\'}}</md-tooltip>\n</div><div ng-if=\"ctrl.parent.trackMode === \'SEA-LCL\'\" class=\"font-size-14 pb-mob font-weight-600\"><span \nclass=\"grey-fg\">Reference Number </span><br>\n{{ctrl.parent.milestoneMeta.request_key ? ctrl.parent.milestoneMeta.request_key: \'--\'}}<md-tooltip \nmd-direction=\"bottom\">{{ctrl.parent.milestoneMeta.request_key ? ctrl.parent.milestoneMeta.request_key: \'--\'}}\n</md-tooltip></div><div class=\"font-size-14 pb-mob font-weight-600 text-truncate\"><span class=\"grey-fg\">POL </span><br>\n{{ctrl.parent.milestoneMeta.pol_loc.name ? ctrl.parent.milestoneMeta.pol_loc.name: \'N/A\'}}<md-tooltip \nmd-direction=\"bottom\">{{ctrl.parent.milestoneMeta.pol_loc.name ? ctrl.parent.milestoneMeta.pol_loc.name: \'N/A\'}}\n</md-tooltip></div><div class=\"font-size-14 pb-mob font-weight-600 text-truncate\"><span class=\"grey-fg\">POD </span><br>\n{{ctrl.parent.milestoneMeta.pod_loc.name ? ctrl.parent.milestoneMeta.pod_loc.name: \'N/A\'}}<md-tooltip \nmd-direction=\"bottom\">{{ctrl.parent.milestoneMeta.pod_loc.name ? ctrl.parent.milestoneMeta.pod_loc.name: \'N/A\'}}\n</md-tooltip></div><div class=\"font-size-14 pb-mob font-weight-600\"><span class=\"grey-fg\">ETA </span><br>\n{{ctrl.parent.milestoneMeta.pod_vslarrival_planned_last ?(ctrl.parent.milestoneMeta.pod_vslarrival_planned_last | date :\'dd-MMM-yyyy\' : \'UTC\'):\'N/A\'}}\n<md-tooltip md-direction=\"bottom\">\n{{ctrl.parent.milestoneMeta.pod_vslarrival_planned_last ?(ctrl.parent.milestoneMeta.pod_vslarrival_planned_last | date :\'dd-MMM-yyyy\' : \'UTC\'):\'N/A\'}}\n</md-tooltip></div><div class=\"font-size-14 pb-mob font-weight-600\"><span class=\"grey-fg\">Departure date </span><br>\n{{ctrl.parent.milestoneMeta.pol_vsldeparture_planned_last ?(ctrl.parent.milestoneMeta.pol_vsldeparture_planned_last | date :\'dd-MMM-yyyy\' : \'UTC\') : \'N/A\'}}\n<md-tooltip md-direction=\"bottom\">\n{{ctrl.parent.milestoneMeta.pol_vsldeparture_planned_last ?(ctrl.parent.milestoneMeta.pol_vsldeparture_planned_last | date :\'dd-MMM-yyyy\' : \'UTC\') : \'N/A\'}}\n</md-tooltip></div></div></div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Milestone\"><md-content><div \nclass=\"simple-table-container\"><div class=\"white-bg md-whiteframe-4dp shipper_table m-15\"><table \nclass=\"simple text-center\" ms-responsive-table><thead><tr><th class=\"border-right\"><div class=\"table-header\"><span \nclass=\"file_heading\">Milestones</span></div></th><th class=\"border-right\"><div class=\"table-header\"><span \nclass=\"file_heading\">Location</span></div></th><th class=\"border-right\"><div class=\"table-header\"><span \nclass=\"file_heading\">Vessel</span></div></th><th class=\"border-right\" ng-if=\"ctrl.parent.trackMode !== \'SEA-LCL\'\"><div \nclass=\"table-header\"><span class=\"file_heading\">Planned date</span></div></th><th \nng-class=\"{\'border-right\' : ctrl.parent.trackMode === \'SEA-LCL\'}\"><div class=\"table-header\"><span class=\"file_heading\" \nng-if=\"ctrl.parent.trackMode !== \'SEA-LCL\'\">Actual Date</span> <span class=\"file_heading\" \nng-if=\"ctrl.parent.trackMode === \'SEA-LCL\'\">Date</span></div></th><th ng-if=\"ctrl.parent.trackMode === \'SEA-LCL\'\"><div \nclass=\"table-header\"><span class=\"file_heading\">Comment</span></div></th></tr></thead><tbody><tr \nng-repeat=\"x in ctrl.parent.milestonedata\"><td class=\"border-right\">{{x.name ? x.name : \'N/A\'}}</td><td \nclass=\"border-right\"><span>{{x.location_name ? x.location_name : \'N/A\'}}</span></td><td class=\"border-right\"><span>\n{{x.vessel ? x.vessel : \'-\'}}</span></td><td class=\"border-right\" ng-if=\"ctrl.parent.trackMode !== \'SEA-LCL\'\">\n{{x.planned_date!=null ? (x.planned_date | date :\'dd-MMM-yyyy h:mm a\' : \'UTC\') : \'-\'}}</td><td \nng-class=\"{\'border-right\' : ctrl.parent.trackMode === \'SEA-LCL\'}\">\n{{x.actual_date!=null ? (x.actual_date | date :\'dd-MMM-yyyy h:mm a\' : \'UTC\') : \'-\'}}</td><td class=\"font-size-11\" \nng-if=\"ctrl.parent.trackMode === \'SEA-LCL\'\">{{x.comment ? x.comment : \'-\'}}</td></tr></tbody></table></div></div>\n</md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions class=\"footer\"></md-dialog-actions></md-dialog>\n<script id=\"custom-cached-info-window-template.html\" type=\"text/ng-template\">\n<div ng-non-bindable=\"\">\n		{{ctrl.parent.iwModal.key}}: {{ctrl.parent.iwModal.name}}<br/>\n		{{ctrl.parent.iwModal.timezone}}\n	</div>\n</script><script id=\"custom-cached-info-window-current-template.html\" type=\"text/ng-template\">\n<div ng-non-bindable=\"\">\n			{{ctrl.parent.currentMarker.pos_name}}<br/>\n			{{ctrl.parent.currentMarker.pos_datetime}}\n	</div>\n</script>");
$templateCache.put("app/main/shipments/filter-shipment/filter_shipment.html","<div id=\"shipment-filter\" ng-hide=\"!vm.filterStructure\"><div class=\"w-100p\"><div class=\"pt-20 ph-20 pb-15\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/custom/filter-new.svg\" \nclass=\"w-20 h-20 filter-icon mr-10\"></md-icon><span class=\"font-size-16 Font-Bold fg-AAA8AD\" flex>Filters </span><a \nclass=\"font-size-13 pointer md-link-fg font-weight-600 clear-btn\" ng-click=\"vm.resetFilter();\">Clear All</a><md-icon \nng-if=\"vm.filterData.deviceName != \'laptop\'\" md-font-icon=\"icon-close-circle-outline\" \nclass=\"s20 pointer ml-5 md-link-fg\" ng-click=\"vm.toggleSidenav(\'right\')\"></md-icon></div><md-divider></md-divider><div \nclass=\"content\"><md-list><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.filterStructure.status.length > 0\"><div layout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div \nlayout=\"row\" layout-align=\"space-between\" flex ng-click=\"search_ship_status=\'\';\" class=\"mb-5\"><div><span \nclass=\"font-size-14 font-weight-600\">Booking Status</span> <span ng-if=\"vm.filterData.status.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.filterData.status.length}}</span></div></div><div class=\"mt-5\" \nid=\"ship_status\"><div layout=\"row\" layout-align=\"space-between center\" class=\"mb-20 searchbox-outline\"><input \nclass=\"font-size-12 font-primary-fg input-search\" ng-model-options=\"{debounce : 500}\" ng-model=\"search_ship_status\" \nng-model-options=\"{\n                    updateOn: \'default blur onchange\',\n                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                  }\" \ntype=\"search\" placeholder=\"Search Booking Status\" ng-keydown=\"$event.stopPropagation()\"><md-icon flex=\"10\" \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div class=\"text-truncate w-200\" \nng-repeat=\"filterStatus in vm.filterStructure.status | filter : search_ship_status\"><md-checkbox md-no-ink=\"true\" \nclass=\"md-primary\" ng-checked=\"vm.filterItemExists(filterStatus, vm.filterData, \'status\');\" \nng-click=\"vm.filterItemtoggle(filterStatus, vm.filterData, \'status\');\" \nng-model-options=\"{\n                      updateOn: \'default blur onchange\',\n                      debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                    }\">\n{{filterStatus}}<md-tooltip md-direction=\"right\" md-delay=\"300\">{{filterStatus}}</md-tooltip></md-checkbox></div></div>\n</div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.filterStructure.mode.length > 0 && vm.util.activatedTheme!==\'transpost\'\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Mode</span> <span ng-if=\"vm.filterData.mode.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.filterData.mode.length}}</span></div></div><div class=\"mt-8\" \nid=\"ship_mode\"><div ng-repeat=\"filterMode in vm.filterStructure.mode\"><md-checkbox md-no-ink=\"true\" class=\"md-primary\" \nng-checked=\"vm.filterItemExists(filterMode, vm.filterData, \'mode\');\" \nng-click=\"vm.filterItemtoggle(filterMode, vm.filterData, \'mode\');\">{{filterMode}}</md-checkbox></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.filterStructure.integrations.length > 0 && vm.tms_enabled\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">TMS</span> <span ng-if=\"vm.filterData.integrations.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.filterData.integrations.length}}</span></div></div><div \nclass=\"mt-8\" id=\"ship_mode\"><div ng-repeat=\"status in vm.filterStructure.integrations\"><md-checkbox md-no-ink=\"true\" \nclass=\"md-primary\" ng-checked=\"vm.filterItemExists(status, vm.filterData, \'integrations\');\" \nng-click=\"vm.filterItemtoggle(status, vm.filterData, \'integrations\');vm.fnTrackAnalytics(\'SL-Filter-TMS-Change\',{\'value\':status})\">\n{{status}}</md-checkbox></div></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex ng-if=\"vm.util.activatedTheme!==\'transpost\'\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Date Range</span><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mb-2 grey-fg pointer\"><md-tooltip md-direction=\"right\" md-delay=\"300\">Created On</md-tooltip></md-icon><span\n ng-if=\"vm.date_range.from || vm.date_range.to\" class=\"filter-count font-size-10 white-fg ml-5\">1</span></div></div>\n<div class=\"pt-5\" id=\"ship_created_on\"><date-range-picker md-input-id=\"\'shipment_date_range\'\" \ncallback=\"vm.setDatePicker(date);\" date-range-value=\"vm.date_range\" is-reset-date-picker=\"vm.isResetFilter\">\n</date-range-picker></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex ng-if=\"vm.util.activatedTheme!==\'transpost\'\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex ng-click=\"search_shipper=\'\';\">\n<div><span class=\"font-size-14 font-weight-600\">Customer details</span> <span \nng-if=\"vm.customerFilterConditions.selectedCount\" class=\"filter-count font-size-10 white-fg ml-5\">\n{{vm.customerFilterConditions.selectedCount}}</span></div></div><div class=\"mt-1\" id=\"ship_shipp_comp\"><div \nng-if=\"!vm.isFilterAvl\"><multi-select-chips md-input-id=\"\'customer-details-filter\'\" page-source=\"\'\'\" \noptions-data-obj=\"vm.filterStructure.customer_details\" query-conditions=\"vm.customerFilterConditions\" \ncallback=\"vm.callBackCustomer(payload)\"></multi-select-chips></div></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"!vm.util.isShipper\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Incoterms</span> <span ng-if=\"vm.incoTermsConditions.selectedCount\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.incoTermsConditions.selectedCount}}</span></div></div><div \nclass=\"mt-1\" id=\"inco_terms\"><multi-select-chips md-input-id=\"\'inco-terms-filter\'\" page-source=\"\'\'\" \noptions-data-obj=\"vm.filterStructure.incoterms\" query-conditions=\"vm.incoTermsConditions\" \ncallback=\"vm.callBackPortDetails(payload,\'incoterms\')\"></multi-select-chips></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.util.activatedTheme!==\'transpost\'\"><div \nlayout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex \nng-click=\"search_origin_port=\'\';\"><div><span class=\"font-size-14 font-weight-600\">Origin</span> <span \nng-if=\"vm.filterData.origin_port.length\" class=\"filter-count font-size-10 white-fg ml-5\">\n{{vm.filterData.origin_port.length}}</span></div></div><div class=\"mt-1\" id=\"ship_origin\"><multi-select-chips \nmd-input-id=\"\'origin-filter\'\" page-source=\"\'\'\" options-data-obj=\"vm.filterStructure.origin_port\" \nquery-conditions=\"vm.originFilterConditions\" callback=\"vm.callBackPortDetails(payload,\'origin_port\')\">\n</multi-select-chips></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex ng-if=\"vm.util.activatedTheme!==\'transpost\'\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex \nng-click=\"search_destination_port=\'\';\"><div><span class=\"font-size-14 font-weight-600\">Destination</span> <span \nng-if=\"vm.filterData.destination_port.length\" class=\"filter-count font-size-10 white-fg ml-5\">\n{{vm.filterData.destination_port.length}}</span></div></div><div class=\"mt-1\" id=\"ship_destination\"><multi-select-chips\n md-input-id=\"\'destination-filter\'\" page-source=\"\'\'\" options-data-obj=\"vm.filterStructure.destination_port\" \nquery-conditions=\"vm.destinationFilterConditions\" callback=\"vm.callBackPortDetails(payload,\'destination_port\'); \">\n</multi-select-chips></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex \nng-if=\"vm.filterStructure.forwarders.length > 0 && vm.util.activatedTheme!==\'transpost\' && vm.util.isAdmin\"><div \nlayout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex \nng-click=\"search_forwarder=\'\';\"><div><span class=\"font-size-14 font-weight-600\">Forwarder</span> <span \nng-if=\"vm.filterData.vendor_id.length\" class=\"filter-count font-size-10 white-fg ml-5\">\n{{vm.filterData.vendor_id.length}}</span></div></div><div class=\"mt-1\" id=\"ship_forwarder\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-20 searchbox-outline\"><input \nclass=\"font-size-12 font-primary-fg input-search\" ng-model=\"search_forwarder\" type=\"search\" \nplaceholder=\"Search Freight Forwarder\" ng-keydown=\"$event.stopPropagation()\"><md-icon flex=\"10\" \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div class=\"text-truncate w-200\" \nng-repeat=\"forwraders in vm.filterStructure.forwarders | filter : search_forwarder | limitTo: (showAllForwarder ? vm.filterStructure.forwarders.length : 3)\">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary\" \nng-checked=\"vm.filterItemExists(forwraders.vendor_id, vm.filterData, \'vendor_id\')\" \nng-click=\"vm.filterItemtoggle(forwraders.vendor_id, vm.filterData, \'vendor_id\')\">{{forwraders.company_name}}<md-tooltip\n md-direction=\"right\" md-delay=\"300\">{{forwraders.company_name}}</md-tooltip></md-checkbox></div><md-button md-no-ink \nclass=\"md-link-btn m-0 w-100p\" ng-click=\"showAllForwarder = !showAllForwarder\" \nng-show=\"(vm.filterStructure.forwarders|filter: search_forwarder).length > 3\">\n{{showAllForwarder ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.filterStructure.shipment_expert.length > 0 && vm.util.activatedTheme!==\'transpost\'\"><div layout=\"column\" \nflex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex class=\"pointer\" \nng-click=\"showAllSpecialist = false;search_ship_specialist=\'\';\"><div><span class=\"font-size-14 font-weight-600\">\nBooking Specialist</span> <span ng-if=\"vm.filterData.shipment_expert.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.filterData.shipment_expert.length}}</span></div></div><div \nclass=\"mt-1\" id=\"ship_ship_specialist\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"mb-20 searchbox-outline\"><input class=\"font-size-12 font-primary-fg input-search\" \nng-model=\"search_ship_specialist\" type=\"search\" placeholder=\"Search Booking Specialist\" \nng-keydown=\"$event.stopPropagation()\"><md-icon flex=\"10\" md-font-icon=\"icon-magnify\" \nclass=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div class=\"text-truncate w-200\" \nng-repeat=\"shipment_expert in vm.filterStructure.shipment_expert | filter : search_ship_specialist | limitTo: (showAllSpecialist ? vm.filterStructure.shipment_expert.length : 3)\">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary\" \nng-checked=\"vm.filterItemExists(shipment_expert.id, vm.filterData, \'shipment_expert\')\" \nng-click=\"vm.filterItemtoggle(shipment_expert.id, vm.filterData, \'shipment_expert\')\">{{shipment_expert.name}}\n<md-tooltip md-direction=\"right\" md-delay=\"300\">{{shipment_expert.name}}</md-tooltip></md-checkbox></div><md-button \nmd-no-ink class=\"md-link-btn m-0 w-100p\" ng-click=\"showAllSpecialist = !showAllSpecialist\" \nng-show=\"(vm.filterStructure.shipment_expert|filter: search_ship_specialist).length > 3\">\n{{showAllSpecialist ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.util.activatedTheme!==\'transpost\' && !vm.maskLiner\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex ng-click=\"search_liner=\'\';\">\n<div><span class=\"font-size-14 font-weight-600\">Liners / Carrier</span> <span ng-if=\"vm.filterData.carrier.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.filterData.carrier.length}}</span></div></div><div class=\"mt-1\" \nid=\"ship_liner\"><multi-select-chips md-input-id=\"\'carrier-filter\'\" page-source=\"\'\'\" \noptions-data-obj=\"vm.filterStructure.carrier\" query-conditions=\"vm.linerFilterConditions\" \ncallback=\"vm.callBackPortDetails(payload,\'carrier\'); \"></multi-select-chips></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.util.activatedTheme!==\'transpost\'\"><div \nlayout=\"column\" flex class=\"ph-20 pv-15 filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex \nng-click=\"search_transporter=\'\'\"><div><span class=\"font-size-14 font-weight-600\">Rail/Road Transporter</span> <span \nng-if=\"vm.filterData.transporter.length\" class=\"filter-count font-size-10 white-fg ml-5\">\n{{vm.filterData.transporter.length}}</span></div></div><div class=\"mt-1\" id=\"ship_transporter\"><multi-select-chips \nmd-input-id=\"\'transpoter-filter\'\" page-source=\"\'\'\" options-data-obj=\"vm.filterStructure.transporter\" \nquery-conditions=\"vm.transporterFilterConditions\" callback=\"vm.callBackPortDetails(payload,\'transporter\');\">\n</multi-select-chips></div></div></md-list-item></md-list></div></div></div>");
$templateCache.put("app/main/shipments/port-traveller/port-traveller.html","<div id=\"port-to-port\"><div class=\"steps\"><ul class=\"steps-list\"><li class=\"steps-list-item\" \nng-if=\"$ctrl.portDetails.port_data.empty_container_pickup\"><span class=\"hrLine\"></span><div class=\"li-div\"><div \nclass=\"port-text\">{{$ctrl.portDetails.port_data.empty_container_pickup.port_code}} <span \nng-if=\"$ctrl.portDetails.port_data.empty_container_pickup.port_name\">| </span>\n{{$ctrl.portDetails.port_data.empty_container_pickup.port_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nEmpty Container Pickup</div><div class=\"Font-Bold\">{{$ctrl.portDetails.port_data.empty_container_pickup.port_name}}\n</div></md-tooltip></div></li><li class=\"steps-list-item\" \nng-if=\"$ctrl.portDetails.port_data.pickup_location || $ctrl.portDetails.port_data.pickup_pincode_ui\"><span \nclass=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.portDetails.port_data.pickup_location\">{{ $ctrl.portDetails.port_data.pickup_location }} <span \nng-if=\"$ctrl.portDetails.port_data.pickup_pincode_ui\">| </span></span><span \nng-if=\"$ctrl.portDetails.port_data.pickup_pincode_ui\">{{ $ctrl.portDetails.port_data.pickup_pincode_ui }}</span></div>\n<div class=\"city-text\">{{ $ctrl.portDetails.port_data.pickup_country_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Pickup\n</div><div class=\"Font-Bold\">{{ $ctrl.portDetails.port_data.pickup_country_name}}</div></md-tooltip></div></li><li \nclass=\"steps-list-item\" ng-if=\"$ctrl.portDetails.via_pol\"><span class=\"hrLine\"></span><div class=\"li-div\"><div \nclass=\"port-text\">{{ $ctrl.portDetails.port_data.origin_port_code }} <span \nng-if=\"$ctrl.portDetails.port_data.origin_city\">| </span>{{ $ctrl.portDetails.port_data.origin_city }}</div><md-tooltip\n md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nclass=\"Font-Medium\">Port of Origin</div><div class=\"Font-Bold\">{{ $ctrl.portDetails.port_data.origin_portname }}</div>\n</md-tooltip></div></li><li class=\"steps-list-item\"><div layout=\"row\" class=\"steps-list-item-timeline\" \nlayout-align=\"center center\" \nng-class=\"{ \'\n            ml-full\' : $ctrl.isViaAvailable && !$ctrl.isMultipleVia, \n            \'isViaMargin\' : $ctrl.isViaAvailable && $ctrl.isMultipleVia}\">\n<md-icon md-svg-icon=\"assets/icons/custom/ship-fill.svg\" class=\"mb-10 mh-0 h-10\" ng-show=\"$ctrl.details.mode != \'AIR\'\">\n</md-icon><md-icon md-svg-icon=\"assets/icons/custom/roll-o-plane.svg\" class=\"mb-10 mh-0 h-10\" \nng-show=\"$ctrl.details.mode == \'AIR\'\"></md-icon></div><span class=\"hrLine\"></span><div class=\"li-div\"><div \nclass=\"port-text\">\n{{ $ctrl.portDetails.via_pol ? $ctrl.portDetails.via_pol : $ctrl.portDetails.port_data.origin_city ? $ctrl.portDetails.port_data.origin_port_code+\" | \"+$ctrl.portDetails.port_data.origin_city : $ctrl.portDetails.port_data.origin_port_code}}\n</div><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Port of Loading</div><div class=\"Font-Bold\">\n{{ $ctrl.portDetails.via_pol ? \'\' : $ctrl.portDetails.port_data.origin_city }}</div></md-tooltip></div></li><li \nclass=\"steps-list-item\"><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\">\n{{ $ctrl.portDetails.via_pod ? $ctrl.portDetails.via_pod : $ctrl.portDetails.port_data.destination_city ? $ctrl.portDetails.port_data.destination_port_code+\" | \"+$ctrl.portDetails.port_data.destination_city : $ctrl.portDetails.port_data.destination_port_code}}\n</div><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display:table;opacity: 1\"><div class=\"Font-Medium\">Port of Discharge</div><div class=\"Font-Bold\">\n{{ $ctrl.portDetails.via_pod ? $ctrl.portDetails.via_pod : $ctrl.portDetails.port_data.destination_portname }}</div>\n</md-tooltip></div></li><li class=\"steps-list-item\" ng-if=\"$ctrl.portDetails.via_pod\"><span class=\"hrLine\"></span><div \nclass=\"li-div\"><div class=\"port-text\">{{ $ctrl.portDetails.port_data.destination_port_code }} <span \nng-if=\"$ctrl.portDetails.port_data.destination_city\">| </span>{{ $ctrl.portDetails.port_data.destination_city }}</div>\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\n<div class=\"Font-Medium\">Port of Destination</div><div class=\"Font-Bold\">\n{{ $ctrl.portDetails.port_data.destination_portname }}</div></md-tooltip></div></li><li class=\"steps-list-item\" \nng-if=\"$ctrl.portDetails.port_data.delivery_location || $ctrl.portDetails.port_data.delivery_pincode_ui\"><span \nclass=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.portDetails.port_data.delivery_location\">{{ $ctrl.portDetails.port_data.delivery_location }} <span \nng-if=\"$ctrl.portDetails.port_data.delivery_pincode_ui\">| </span></span><span \nng-if=\"$ctrl.portDetails.port_data.delivery_pincode_ui\">{{ $ctrl.portDetails.port_data.delivery_pincode_ui }}</span>\n</div><div class=\"city-text\">{{ $ctrl.portDetails.port_data.delivery_country_name}}</div><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nclass=\"Font-Medium\">Delivery</div><div class=\"Font-Bold\">{{ $ctrl.portDetails.port_data.delivery_country_name}}</div>\n</md-tooltip></div></li><li class=\"steps-list-item\" ng-if=\"$ctrl.portDetails.port_data.empty_container_drop\"><span \nclass=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\">\n{{$ctrl.portDetails.port_data.empty_container_drop.port_code}} <span \nng-if=\"$ctrl.portDetails.port_data.empty_container_drop.port_name\">| </span>\n{{$ctrl.portDetails.port_data.empty_container_drop.port_name}}</div><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div class=\"Font-Medium\">\nEmpty Container Drop</div><div class=\"Font-Bold\">{{$ctrl.portDetails.port_data.empty_container_drop.port_name}}</div>\n</md-tooltip></div></li></ul></div></div>");
$templateCache.put("app/main/shipments/shipment_details/shipment_details.html","<div id=\"shipment-details-page\" class=\"mb-50\"><div layout-gt-sm=\"row\" layout=\"column\" class=\"page_margin\"><div \nflex-gt-sm=\"100\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" class=\"penalty-div\" \nng-if=\"vm.shipment_meta.penalty_details\">{{vm.shipment_meta.penalty_details.penalty_message}} <a \nclass=\"ml-5 learn-more font-weight-600 pointer\" ng-if=\"vm.shipment_meta.penalty_details.penalty_fees.length\" \nng-click=\"vm.fnDisplayPenalty($event)\">Learn more</a></div><div \nng-include=\"\'app/main/shipments/shipment_details/shipment-meta/shipment-meta.html\'\"></div><div ng-if=\"vm.showTab\" \nshimmer-effect></div><md-tabs md-dynamic-height=\"true\" md-selected=\"vm.selectedTab\" md-autoselect \nstyle=\"min-height: auto; height: auto\" ng-if=\"!vm.showTab\"><md-tab ng-repeat=\"tab in vm.dynamicNav \" \nmd-on-select=\"vm.onTabSelected(tab)\" md-on-deselect=\"vm.announceDeselected(tab)\" ng-disabled=\"tab.disabled\">\n<md-tab-label>{{tab.title}}</md-tab-label><md-tab-body><div class=\"today-tab scrollable\" ms-scroll \nng-include=\"tab.template\" dynamic-controller=\"tab.controller\"></div></md-tab-body></md-tab></md-tabs></div></div></div>\n<footer id=\"shared-footer\" ng-if=\"vm.showSharedFooter;\" class=\"shared-footer\"><div class=\"footer\">\nThis window is currently in view only mode. If you want to edit this page, generate OTP by clicking <span \nng-click=\"vm.generateOtp()\" class=\"otp-click pl-5\">here</span></div></footer>");
$templateCache.put("app/main/track-n-trace/dialogs/toast.html","<md-toast><span class=\"md-toast-text\" flex>Hi there</span><md-button md-no-ink ng-click=\"ctrl.parent.closeToast()\">x\n</md-button></md-toast>");
$templateCache.put("app/main/track-n-trace/dialogs/tracking-request-submit.html","<div class=\"tracking-request-submit\"><div class=\"header h-100\" ng-if=\"vm.trackingStatus != \'FETCHING\'\"><div \nlayout=\"row\" layout-align=\"end end\" class=\"pt-10 pr-10\"><md-icon md-font-icon=\"icon-close\" class=\"mr-5 cursor grey-fg\" \nng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div><div layout=\"row\" layout-align=\"center center\"><md-icon \nmd-svg-icon=\"assets/icons/custom/track-fetching.svg\" class=\"w-130 h-130\"></md-icon></div><div layout=\"column\" \nclass=\"m-10 mb-35 font-weight-600 text-center\"><div class=\"grey-600-fg font-size-18 pt-10\">Request Submitted</div><div \nclass=\"grey-400-fg font-size-14\"><div>We are fetching tracking details from Airline.</div><div>\nThis may take few minutes.</div><div class=\"pt-20\">You can close this popup and</div><div>make a new request</div>\n</div></div></div>");
$templateCache.put("app/main/track-n-trace/dialogs/tracking-unavailable.html","<div class=\"tracking-request-submit m-20\"><div layout=\"row\" layout-align=\"end end\" class=\"pt-10 pr-10\"><md-icon \nmd-font-icon=\"icon-close\" class=\"mr-5 cursor grey-fg\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div><div \nlayout=\"row\" layout-align=\"center center\"><md-icon md-svg-icon=\"assets/icons/custom/empty-track.svg\" \nclass=\"w-130 h-130\"></md-icon></div><div layout=\"column\" class=\"text-center\" flex=\"100\"><div \nclass=\"font-size-20 grey-600-fg font-weight-600\">Sorry</div><div class=\"pt-10 pb-15 grey-fg font-weight-600\">\nWe could not find tracking data for<br>the entered <span class=\"md-link-fg font-weight-600\">\n{{ctrl.parent.mode == \'SEA\' ?\'Container\':\'AWB\'}} number</span></div></div></div>");
$templateCache.put("app/main/track-n-trace/filter-track/filter-track.html","<div id=\"sideFilter\"><md-list><md-list-item class=\"mb-5\" layout=\"row\" layout-align=\"start center\" flex><span \nclass=\"font-size-16\" flex>Filter By</span><md-icon md-font-icon=\"icon-close\" class=\"s20 pointer\" \nng-click=\"vm.closeFilter();\"></md-icon></md-list-item><md-divider></md-divider></md-list><div class=\"content\"><md-list>\n<md-list-item class=\"m-0\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex><div \nclass=\"font-size-12 font-weight-700 mt-20 filter-heading\">Liner name</div><md-input-container md-no-float \nclass=\"h-40 p-0 m0 search_select_box mt-5 mb-0\"><md-select class=\"selectLiner b brad-3 pl-10\" name=\"filterLiner\" \nng-model=\"vm.seaFilterData.filter_by.liner\" md-on-close=\"selectLinersearchTerm=\'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"Filter By Liner\" multiple=\"multiple\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"selectLinersearchTerm\" ng-keydown=\"$event.stopPropagation()\" \nng-change=\"vm.fnTrackAnalytics(\'TT-FilterBy-LinerName-Search-Change\',{\'query\':selectLinersearchTerm})\" type=\"search\" \nplaceholder=\"Search for a liner..\" class=\"demo-header-searchbox md-text\" \nng-model-options=\"{\n                                    updateOn: \'default blur onchange\',\n                                    debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                  }\">\n</md-select-header><md-optgroup label=\"liners\"><md-option ng-value=\"liner\" \nng-repeat=\"liner in vm.subvendorList\n                                | filter:selectLinersearchTerm track by liner.id\">\n{{liner.carrier_name}}</md-option></md-optgroup></md-select></md-input-container></div></md-list-item><md-list-item \nclass=\"m-0\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex><div \nclass=\"font-size-12 font-weight-700 mt-20 filter-heading\">Status</div><md-input-container md-no-float \nclass=\"h-40 p-0 mt-5 mb-0 mh-0 search_select_box\"><md-select class=\"b brad-3 pl-10\" name=\"filterStatus\" \nng-model=\"vm.seaFilterData.filter_by.status\" ng-change=\"vm.fnTrackAnalytics(\'TT-FilterBy-Status-Change\')\" \nng-model-options=\"{\n                            updateOn: \'default blur onchange\',\n                            debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                          }\" \nplaceholder=\"Filter By Status\" multiple=\"multiple\"><md-optgroup label=\"status\"><md-option \nng-repeat=\"status in vm.statusList track by status.id\" ng-value=\"status.name\">{{status.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></md-list-item><md-list-item class=\"m-0\" layout=\"row\" \nlayout-align=\"start center\" flex><form name=\"dateForm\"><div layout=\"column\" flex=\"100\" class=\"mr-20\"><div \nclass=\"font-size-12 font-weight-700 mt-20 filter-heading\">Created On</div><div class=\"h-32 mt-5\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div flex=\"45\" layout=\"row\" flex class=\"filter-datePicker\"><date-picker \nmodel-value=\"vm.seaFilterData.filter_by.from_date\" md-input-id=\"\'createdFrom\'\" \nis-validate=\"dateForm.createdFrom.$error.valid && dateForm.createdFrom.$touched\" is-editable=\"true\" \nis-disabled=\"false\" input-required=\"false\" input-name=\"\'createdFrom\'\" date-placeholder=\"\'Enter date\'\" \nfull-border=\"true\" date-format=\"true\" max-date-value=\"vm.seaFilterData.filter_by.to_date || vm.todayDate\" \ncallback=\"vm.seaFilterData.filter_by.from_date = value;vm.fnTrackAnalytics(\'TT-FilterBy-CreatedOn-Change\')\">\n</date-picker></div><div flex=\"45\" layout=\"row\" flex class=\"filter-datePicker\"><date-picker md-input-id=\"\'createdTo\'\" \nis-editable=\"true\" is-validate=\"dateForm.createdTo.$error.valid && dateForm.createdTo.$touched\" is-disabled=\"false\" \ninput-required=\"false\" input-name=\"\'createdTo\'\" date-placeholder=\"\'Enter date\'\" full-border=\"true\" date-format=\"true\" \nmin-date-value=\"vm.seaFilterData.filter_by.from_date\" max-date-value=\"vm.todayDate\" \nmodel-value=\"vm.seaFilterData.filter_by.to_date\" \ncallback=\"vm.seaFilterData.filter_by.to_date = value;vm.fnTrackAnalytics(\'TT-FilterBy-CreatedOn-Change\')\">\n</date-picker></div></div><div \nng-if=\"dateForm.createdFrom.$touched && dateForm.createdFrom.$error.valid || dateForm.createdTo.$touched && dateForm.createdTo.$error.valid\" \nclass=\"h-25 mt-5\" layout=\"row\" layout-align=\"space-between center\" flex><div \nng-messages=\"dateForm.createdFrom.$touched && dateForm.createdFrom.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-messages=\"dateForm.createdTo.$touched && dateForm.createdTo.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div></div></div></form></md-list-item></md-list></div><div \nlayout=\"row\" class=\"p-10 btn-sec\" flex><md-button md-no-ink type=\"button\" class=\"md-primary-btn mr-10\" \nng-click=\"vm.applySeaFilter(\'clear\',dateForm);\">Clear All</md-button><md-button md-no-ink type=\"button\" \nclass=\"md-accent-btn ml-10\" ng-click=\"vm.applySeaFilter(\'apply\',dateForm);\">Apply Filter</md-button></div></div>");
$templateCache.put("app/main/track-n-trace/track-list/track-list.html","<div class=\"track-list\"><div ng-repeat=\"shipment in vm.shipmentList track by $index\" class=\"mb-20\"><div \nclass=\"white-bg b pointer track-collapsed\" layout=\"row\" flex=\"100\" layout-padding \nng-click=\"vm.collapseIt($index, $event, shipment)\" layout-wrap><div \nclass=\"font-size-14 font-weight-600 div_margin w-160\" layout=\"row\"><div class=\"mr-5\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"s14 yellow-700-fg\"></md-icon></div><div><div class=\"font-size-12\">\n<span class=\"grey-700-fg\">MAWB </span><span class=\"md-link-fg\" \nng-bind=\"shipment.awb_object.mawb ? shipment.awb_object.mawb : \'N/A\'\" \nng-click=\"vm.getShipmentsTrackingData(shipment.awb_object.mawb,\'AVAILABLE\', shipment, $event)\"></span></div><div \nclass=\"font-size-12\"><span class=\"grey-700-fg\">HAWB </span><span class=\"md-link-fg\" \nng-bind=\"shipment.awb_object.hawb ? shipment.awb_object.hawb : \'N/A\'\"></span></div></div></div><div class=\"div_margin\">\n<div class=\"text-center\"><span class=\"font-size-12 grey-700-fg font-weight-600\">{{shipment.pol.port_code}}</span>\n<md-icon md-svg-icon=\"assets/icons/custom/flight.svg\"></md-icon><span class=\"font-size-12 grey-700-fg font-weight-600\">\n{{shipment.pod.port_code}}</span></div><div class=\"grey-fg font-size-12 text-center\">{{shipment.airline.name}}</div>\n</div><div class=\"font-weight-600 div_margin\" flex=\"10\" flex-sm=\"15\" flex-xs=\"35\"><div class=\"grey-fg\">Status</div><div\n shimmer-effect-full class=\"mt-5\" width=\"85%\" height=\"15px\" mt=\"10px\" ng-repeat=\"shimmer in [1]\" \nng-if=\"shipment.showLoading && shipment.awb_object.mawb\"></div><div class=\"grey-700-fg text-truncate\" \ntitle=\"{{shipment.events[0].details ? shipment.events[0].details : shipment.events[0].code_desc}}\" \nng-bind=\"shipment.events[0].details ? shipment.events[0].details : shipment.events[0].code_desc\" \nng-show=\"shipment.events && shipment.events.length\"></div><div class=\"grey-700-fg text-truncate\" \ntitle=\"{{shipment.isAvailableTracking ? shipment.isAvailableTracking : \'N/A\'}}\" \nng-bind=\"shipment.isAvailableTracking ? shipment.isAvailableTracking : \'N/A\'\" ng-show=\"shipment.events===null\"></div>\n</div><div class=\"font-weight-600 div_margin\"><div class=\"grey-fg\">Pickup Date</div><div \nclass=\"grey-700-fg text-center\">{{shipment.cargo_ready_date | date : \"d MMM yyyy\" }}</div></div><div \nclass=\"font-weight-600 div_margin\"><div class=\"grey-fg\">Created for</div><div class=\"grey-700-fg text-center\" \nng-bind=\"shipment.quote_created_for ? shipment.quote_created_for.company.company_name : \'N/A\'\"></div></div><div \nclass=\"font-weight-600 div_margin\" layout=\"row\" layout-align=\"center center\" title=\"ETD\"><md-icon \nmd-svg-icon=\"assets/icons/custom/departures.svg\" class=\"mr-8\"></md-icon><span>\n{{shipment.departure_date | date : \"d MMMM yyyy\"}}</span></div><div class=\"font-weight-600 div_margin\" layout=\"row\" \nlayout-align=\"center center\" title=\"ETA\"><md-icon md-svg-icon=\"assets/icons/custom/arrival.svg\" class=\"mr-8\"></md-icon>\n<span>{{shipment.arrival_date | date : \"d MMMM yyyy\"}}</span></div><div class=\"font-weight-600\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"premium ph-8 pv-5\" \nng-bind=\"shipment.airline.service ? shipment.airline.service : \'N/A\'\"></div></div><div layout=\"row\" \nlayout-align=\"end end\" flex flex-xs=\"100\" class=\"shipment_btn ml-20\"><div class=\"w-130\"><md-checkbox md-no-ink \nng-click=\"vm.selectShipment(shipment)\" ng-model=\"shipment.selected\"></md-checkbox><md-icon \nmd-font-icon=\"icon-chevron-double-down ml-10 md-link-fg s30 chevron\" ng-class=\"{\'chevron-rotate\': shipment.open}\">\n</md-icon><md-menu ng-if=\"!vm.util.isShipper\"><md-button md-no-ink aria-label=\"Open phone interactions menu\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\" class=\"grey-fg\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button md-no-ink class=\"grey-fg font-size-14\" ng-click=\"vm.editShipment(shipment, $index)\"><md-icon \nmd-font-icon=\"icon-pencil\" md-menu-align-target class=\"s16 grey-fg\"></md-icon>Edit</md-button></md-menu-item>\n<md-menu-item hide><md-button md-no-ink class=\"grey-fg font-size-14\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s16 grey-fg\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nclass=\"bb br bl white-bg hide-at-start\"><div layout=\"row\" layout-align=\"space-between\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex=\"50\" flex-xs=\"100\" flex-sm=\"100\" class=\"br\"><div class=\"MobileTableView\"><table \nclass=\"load-table\"><thead class=\"grey-200-bg\"><tr><th>Load No.</th><th>Unit/Pallets No.</th><th>Qty</th><th>Gross. Wt.\n</th><th>Charge. Wt.</th><th>Remarks</th></tr></thead><tbody><tr \nng-repeat=\"load in  shipment.load_data.load_details_value[0].load_metrics track by $index\"><td class=\"font-weight-600\">\n{{load.load_number}}</td><td>{{load.pallet_no}}</td><td>{{load.qty}}</td><td>\n{{load.gross_weight ? load.gross_weight +\' \'+ load.gross_weight_unit : \'N/A\'}}</td><td>\n{{load.chargeable_weight ? load.chargeable_weight +\' \'+ load.chargeable_weight_unit : \'N/A\'}}</td><td>\n{{load.remarks ? load.remarks : \'N/A\'}}</td></tr></tbody></table></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"center center\" class=\"mv-20\" ng-if=\"shipment.isAvailableTracking===\'FETCHING\'\"><div layout=\"row\"><div>\n<md-icon md-svg-icon=\"assets/icons/custom/fetching.svg\" class=\"w-30 h-35 mr-5\"></md-icon></div><div flex><div><span \nclass=\"font-size-14 font-weight-600\">Fetching Milestones</span> <span class=\"fetching-dots\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"s8 ml-5\"></md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s8 mh-5\"></md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s8\"></md-icon></span></div><div \nclass=\"grey-fg font-size-12\">Please be patient , this may take a while</div></div></div></div><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"mv-20\" ng-if=\"shipment.isAvailableTracking===\'NOT AVAILABLE\'\"><div \nclass=\"font-size-16 grey-400-fg font-weight-600 pt-8\"><md-icon md-font-icon=\"icon-block-helper\" \nclass=\"grey-400-fg s22 mb-5 mr-5\"></md-icon>Tracking Data Not Available</div><md-button md-no-ink \nclass=\"md-accent-btn\" ng-click=\"vm.openAddMilestoneModal(shipment,$event)\" ng-if=\"!vm.util.isShipper\">Add Milestone\n</md-button></div><div flex layout=\"column\" layout-align=\"center center\" class=\"mv-20\" \nng-if=\"shipment.isAvailableTracking===\'No Data Available\'\"><div class=\"font-size-16 grey-400-fg font-weight-600 pt-8\">\n<md-icon md-font-icon=\"icon-block-helper\" class=\"grey-400-fg s22 mb-5 mr-5\"></md-icon>Add MAWB number for tracking!\n</div></div><div flex=\"50\" flex-xs=\"100\" flex-sm=\"100\" class=\"mv-20\" ng-if=\"shipment.events.length\"><div \nclass=\"text-center grey-fg font-weight-600\"><md-icon md-font-icon=\"icon-map-marker\" class=\"s20 grey-400-fg mt-5 mb-10\">\n</md-icon>AIR FREIGHT MILESTONES</div><div layout=\"row\" class=\"mb-10\"><div><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"s40 grey-fg pointer\" ng-click=\"vm.scrollDiv(\'left\',$index)\"></md-icon></div><div class=\"scroll_milestone\" \nng-class=\"\'scroll_milestone_\'+{{$index}}\" layout=\"row\"><div layout=\"row\"><div class=\"pt-10\" layout=\"row\" flex \nng-repeat=\"tracks in shipment.events track by $index\"><div class=\"milestone\"><div class=\"milestone-text\">\n{{tracks.code}}</div><div class=\"pt-5 font-weight-600 float-left font-size-12\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon>{{tracks.port_code}}</div><md-tooltip md-direction=\"bottom\" \nclass=\"white-bg black-fg h-90 w-190 md-whiteframe-2dp\"><div layout=\"column\" flex=\"100\" class=\"font-size-12\"><div \nclass=\"bb\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-fg\">Flight</div><div \nclass=\"grey-600-fg font-weight-600\" ng-bind=\"tracks.flight_number ? tracks.flight_number : \'N/A\'\"></div></div><div \nclass=\"bb\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-fg\">Date / Time</div><div \nclass=\"grey-600-fg font-weight-600\">\n{{tracks.time_stamp_actual | date : \"d MMM\"}} | {{tracks.time_stamp_actual | date : \'h:mma\'}}</div></div><div \nclass=\"bb\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-fg\">Pieces</div><div \nclass=\"grey-600-fg font-weight-600\">{{tracks.no_of_pieces}}</div></div><div class=\"bb\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"grey-fg\">Weight</div><div class=\"grey-600-fg font-weight-600\">\n{{tracks.weight.value}} {{tracks.weight.UOM}}</div></div><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"grey-fg\">Detail</div><div class=\"grey-600-fg font-weight-600\">{{tracks.code_desc}}</div></div></div>\n</md-tooltip></div><div class=\"milestone-line\"></div><div class=\"milestone\" ng-if=\"$last && shipment.is_completed\"><div\n class=\"milestone-text transparent-bg end_milestone\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"green-dot\"></md-icon></div></div></div></div></div><div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s40 grey-fg pointer\" ng-click=\"vm.scrollDiv(\'right\',$index)\"></md-icon></div></div></div><div flex=\"50\" \nflex-xs=\"100\" flex-sm=\"100\" class=\"mv-20\" \nng-if=\"shipment.isAvailableTracking===\'available\' && shipment.events.length===0\"><div \nclass=\"text-center font-weight-600 font-size-18\">Milestones will be available in a while<div \nclass=\"text-center grey-fg font-weight-600 font-size-14\">Check this space in 2-3 hours</div><md-button md-no-ink \nclass=\"md-primary-btn with-img-icon mt-10\" ng-click=\"vm.refreshMilestone(shipment);\"><md-icon \nmd-svg-icon=\"assets/icons/custom/refresh.svg\" class=\"s18\" ng-class=\"{\'fa-spin\': vm.refreshMilestoneCall}\"></md-icon>\n<span class=\"pl-5\"><b>Refresh Now</b></span></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/track-n-trace/track-n-trace-details/track-n-trace-details.html","<div class=\"track-n-trace-details m-30\"><div layout=\"row\" class=\"font-weight-600\" \nng-if=\"vm.trackingDetail && !vm.fromShipmentTracking\" \nng-class=\"{\'w-250\' : vm.trackingNumber,\'w-120\' : !vm.trackingNumber}\"><md-icon ng-click=\"vm.goBack()\" \nmd-font-icon=\"icon-arrow-left\" class=\"s20 cursor grey-500-fg\"></md-icon><div ng-click=\"vm.goBack()\" \nclass=\"font-size-12 grey-500-fg pt-4 cursor\">{{vm.FromPage}}</div><md-icon class=\"grey-500-fg\" \nmd-font-icon=\"icon-chevron-right\" ng-if=\"vm.trackingNumber\"></md-icon><span class=\"font-size-12 grey-500-fg pt-4\">\n{{vm.trackingNumber}}</span></div><div shimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" \nng-if=\"vm.trackAirShimmer\" ng-repeat=\"shimmer in [1,2,3,4]\"></div><div \nng-if=\"vm.trackingDetail && !vm.trackAirShimmer\"><div class=\"search-div mb-5\" layout=\"row\" layout-padding layout-wrap \nng-if=\"!vm.fromShipmentTracking\"><div class=\"mr-20\"><div class=\"Airline-Name\" \nng-bind=\"vm.trackingDetail.airline_details.name ? vm.trackingDetail.airline_details.name : \'N/A\'\"></div><div \nclass=\"grey-fg font-size-12\">AWB NO. <span class=\"font-weight-600\" \nng-bind=\"vm.trackingDetail.tracking_number ? vm.trackingDetail.tracking_number : \'N/A\'\"></span></div></div><div \nlayout=\"row\" class=\"mr-30\"><md-icon md-svg-icon=\"assets/icons/custom/departures.svg\" class=\"opacity w-35 h-35 mr-15\">\n</md-icon><div class=\"font-weight-600\"><div class=\"grey-fg font-size-12\">DEPARTURE</div><div class=\"grey-600-fg\"><span \nclass=\"font-size-16 pr-5\" \nng-bind=\"vm.trackingDetail.origin.global_portcode ? vm.trackingDetail.origin.global_portcode : \'N/A\'\"></span></div>\n</div></div><div layout=\"row\" class=\"mr-30\"><md-icon md-svg-icon=\"assets/icons/custom/arrival.svg\" \nclass=\"opacity w-35 h-35 mr-15\"></md-icon><div class=\"font-weight-600\"><div class=\"grey-fg font-size-12\">ARRIVAL</div>\n<div class=\"grey-600-fg\"><span class=\"font-size-16 pr-5\" \nng-bind=\"vm.trackingDetail.destination.global_portcode ? vm.trackingDetail.destination.global_portcode : \'N/A\'\"></span>\n</div></div></div><div class=\"font-weight-600 mr-30\"><div class=\"grey-fg font-size-12\">PRODUCT</div><div \nclass=\"grey-600-fg\"><span class=\"font-size-16\" \nng-bind=\"vm.trackingDetail.commodities.name ? vm.trackingDetail.commodities.name : \'N/A\'\"></span></div></div><div \nclass=\"font-weight-600 mr-30\"><div class=\"grey-fg font-size-12\">PIECES</div><div class=\"grey-600-fg\"><span \nclass=\"font-size-16\" ng-bind=\"vm.trackingDetail.load.no_of_pieces ? vm.trackingDetail.load.no_of_pieces : \'N/A\'\">\n</span></div></div><div class=\"font-weight-600 mr-30\"><div class=\"grey-fg font-size-12\">ACTUAL WEIGHT</div><div \nclass=\"grey-600-fg\"><span class=\"font-size-16\" \nng-bind=\"vm.trackingDetail.load.weight.value ? vm.trackingDetail.load.weight.value+\' \'+vm.trackingDetail.load.weight.UOM : \'N/A\'\">\n</span></div></div></div><div class=\"search-div mb-5\" ng-if=\"vm.currentShipment.load_data\"><div \nclass=\"font-size-16 font-weight-600 mb-10\">Load Details</div><div class=\"MobileTableView\" layout=\"row\" flex=\"100\">\n<table class=\"load-table grey-500-fg\" flex=\"60\" flex-sm=\"100\" flex-xs=\"100\"><thead><tr><th>Load No.</th><th>\nUnit/Pallets No.</th><th>Qty</th><th>Gross. Wt.</th><th>Charge. Wt.</th><th>Remarks</th></tr></thead><tbody><tr \nng-repeat=\"load in  vm.currentShipment.load_data.load_details_value[0].load_metrics track by $index\"><td \nclass=\"font-weight-600\">{{load.load_number}}</td><td>{{load.pallet_no}}</td><td>{{load.qty}}</td><td>\n{{load.gross_weight +\' \'+ load.gross_weight_unit}}</td><td>{{load.chargeable_weight +\' \'+ load.chargeable_weight_unit}}\n</td><td>{{load.remarks ? load.remarks : \'NA\'}}</td></tr></tbody></table></div></div><div \nclass=\"search-div mb-5 ph-10\" ng-if=\"vm.trackingDetail.tracking !== \'FETCHING\' \"><div \nclass=\"font-size-16 font-weight-600 mb-10\">Mile</div><div class=\"mb-20 pv-10\" layout=\"row\" layout-xs=\"column\" \nlayout-align-xs=\"center center\"><div layout=\"row\" class=\"milestone_div\" flex><div layout=\"row\" class=\"ml-25\" \nlayout-xs=\"column\"><div layout=\"row\" flex layout-xs=\"column\" \nng-repeat=\"tracks in vm.trackingDetail.events track by $index\"><div class=\"milestone\" layout-xs=\"row\"><div \nclass=\"milestone-text\">{{tracks.code}}</div><div class=\"pt-5 font-weight-600 float-left\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon>{{tracks.port_code ? tracks.port_code : \'N/A\'}}</div><md-tooltip \nmd-direction=\"bottom\" class=\"white-bg black-fg h-90 w-190 md-whiteframe-2dp\"><div layout=\"column\" flex=\"100\" \nclass=\"font-size-12\"><div class=\"bb\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-fg\">Flight</div>\n<div class=\"grey-600-fg font-weight-600\" ng-bind=\"tracks.flight_number ? tracks.flight_number : \'N/A\'\"></div></div><div\n class=\"bb\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-fg\">Date / Time</div><div \nclass=\"grey-600-fg font-weight-600\">\n{{tracks.time_stamp_actual | date : \"d MMM\"}} | {{tracks.time_stamp_actual | date : \'h:mma\'}}</div></div><div \nclass=\"bb\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-fg\">Pieces</div><div \nclass=\"grey-600-fg font-weight-600\">{{tracks.no_of_pieces}}</div></div><div class=\"bb\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"grey-fg\">Weight</div><div class=\"grey-600-fg font-weight-600\">\n{{tracks.weight.value}} {{tracks.weight.UOM}}</div></div><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"grey-fg\">Detail</div><div class=\"grey-600-fg font-weight-600\">{{tracks.code_desc}}</div></div></div>\n</md-tooltip></div><div class=\"milestone-line\" ng-if=\"!$last\"></div></div></div></div><div class=\"w-250\" layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"vm.trackingDetail.tracking === \'NOT AVAILABLE\' || (vm.trackingDetail.tracking === \'AVAILABLE\' && vm.trackingDetail.source === \'manual\' ) \">\n<md-button md-no-ink class=\"md-accent-btn\" ng-click=\"vm.openAddMilestoneModal(vm.trackingDetail.events,$event)\">\nAdd Milestone</md-button></div></div></div><div class=\"simple-table-container md-whiteframe-4dp\" \nng-if=\"vm.trackingDetail.events.length\"><table class=\"simple\" ms-responsive-table><thead><tr><th>EVENT</th><th>STATION\n</th><th>FLIGHT NO.</th><th>PIECES / WEIGHT</th><th>ACTUAL TIME</th><th>PLANNED TIME</th><th>DESCRIPTION</th><th \nng-if=\"!vm.util.isShipper &&  (vm.trackingDetail.tracking === \'NOT AVAILABLE\' || (vm.trackingDetail.tracking === \'AVAILABLE\' && vm.trackingDetail.source === \'manual\' ) )  \">\nActions</th></tr></thead><tbody><tr ng-repeat=\"tracks in vm.trackingDetail.events track by $index\"><td>\n{{tracks.code_desc}} ({{tracks.code}})</td><td ng-bind=\"tracks.port_code ? tracks.port_code : \'N/A\'\"></td><td \nng-bind=\"tracks.flight_number ? tracks.flight_number : \'N/A\'\"></td><td><span \nng-bind=\"tracks.no_of_pieces ? tracks.no_of_pieces : \'--\'\"></span> / <span \nng-bind=\"tracks.weight.value ? tracks.weight.value+\' \'+tracks.weight.UOM : \'--\'\"></span></td><td><span \nng-if=\"tracks.time_stamp_actual\">{{tracks.time_stamp_actual | date : \"d MMM yyyy\"}} <span class=\"grey-fg\">\n{{tracks.time_stamp_actual | date : \'h:mma\'}}</span></span> <span ng-if=\"!tracks.time_stamp_actual\">N/A</span></td><td>\n<span ng-if=\"tracks.time_stamp_planned\">{{tracks.time_stamp_planned | date : \"d MMM yyyy\"}} <span class=\"grey-fg\">\n{{tracks.time_stamp_planned | date : \'h:mma\'}}</span></span> <span ng-if=\"!tracks.time_stamp_planned\">N/A</span></td>\n<td ng-bind=\"tracks.details ? tracks.details : \'N/A\'\"></td><td \nng-if=\"!vm.util.isShipper && vm.trackingDetail.tracking === \'NOT AVAILABLE\' || (vm.trackingDetail.tracking === \'AVAILABLE\' && vm.trackingDetail.source === \'manual\' )\">\n<span><md-icon md-svg-icon=\"assets/icons/custom/edit-icon.svg\" class=\"h-15 w-15 opacity mr-8 pointer\" \nng-click=\"vm.openEditMilestoneModal(vm.trackingDetail.events,tracks,$index,$events)\"></md-icon></span><span><md-icon \nmd-svg-icon=\"assets/icons/custom/delete-icon.svg\" \nng-click=\"vm.deleteMilestone(vm.trackingDetail.events,$index,$events)\" class=\"h-15 w-15 opacity pointer\"></md-icon>\n</span></td></tr></tbody></table></div><div \nng-if=\"(vm.trackingDetail.events.length == 0 || vm.currentShipment.awb_object.mawb !== null) && vm.trackingStatus === \'NOT AVAILABLE\'\">\n<div layout=\"row\" layout-align=\"center center\"><md-icon md-svg-icon=\"assets/icons/custom/empty-track.svg\" \nclass=\"w-180 h-180\"></md-icon></div><div layout=\"column\" class=\"text-center\" flex=\"100\"><div \nclass=\"font-size-20 grey-600-fg font-weight-600\">Sorry</div><div class=\"pv-5 font-size-14\">No Tracking Data Available\n<br>the entered <span class=\"font-weight-600\">AWB Number</span></div></div></div><div \nng-if=\"vm.currentShipment.awb_object.mawb === null\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"tracking-request-submit m-20\"><div layout=\"row\" layout-align=\"center center\"><md-icon \nmd-svg-icon=\"assets/icons/custom/empty-track.svg\" class=\"w-130 h-130\"></md-icon></div><div layout=\"column\" \nclass=\"text-center\" flex=\"100\"><div class=\"font-size-20 grey-600-fg font-weight-600\">Sorry</div><div \nclass=\"pt-10 pb-15 grey-fg font-weight-600\">We could not find tracking data for<br>the entered <span \nclass=\"md-link-fg font-weight-600\">AWB Number</span></div></div></div></div><div \nng-if=\"vm.trackingStatus == \'FETCHING\'\" layout=\"column\" layout-align=\"center center\"><div \nng-include=\"\'app/main/track-n-trace/dialogs/tracking-request-submit.html\'\"></div></div></div><div \nng-if=\"!vm.trackingDetail && !vm.trackAirShimmer\" class=\"mt-30\"><div layout=\"row\" layout-align=\"center center\"><md-icon\n md-svg-icon=\"assets/icons/custom/empty-track.svg\" class=\"w-180 h-180\"></md-icon></div><div layout=\"column\" \nclass=\"text-center\" flex=\"100\"><div class=\"font-size-20 grey-600-fg font-weight-600\">Sorry</div><div \nclass=\"pv-5 font-size-14\">We could not find tracking data for<br>the entered <span class=\"md-link-fg font-weight-600\">\nAWB Number<md-tooltip md-direction=\"right\" class=\"white-bg black-fg h-80 w-230 md-whiteframe-2dp font-size-12\"><div \nclass=\"grey-800-fg font-weight-600 pt-5\">AWB NO. | AIRWAY BILL NUMBER</div><div class=\"grey-500-fg\">\nThe Airway Bill Number is used to track<br>shipment and show its delivery status.</div></md-tooltip></span></div><div \nlayout=\"row\" flex layout-align=\"center center\" class=\"mt-10\" ng-if=\"!vm.fromShipmentTracking\"><md-button md-no-ink \nclass=\"md-warn-bg brad-5 white-fg font-weight-600\" ng-click=\"vm.goBack()\">Search Again</md-button></div></div></div>\n</div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"flag fblogo\" ng-src=\"assets/images/fb_shipper/fblogo.png\"></div>\n<div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"navigation-toolbar h-64\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\" class=\"web-padding\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"center center\" class=\"mr-25\"><div class=\"comp_logo\"><img \nid=\"domain-comp-logo\" class=\"logo-img\" ng-src=\"{{ vm.util.sanitizeQueryParams(vm.log_url)}}\"></div></div><div flex \nlayout=\"row\"><div layout-wrap layout=\"row\" layout-align=\"center center\"><div hide-xs hide-sm ng-if=\"!vm.hideNavbar\" \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start center\" flex></div></div></div><div \nlayout=\"row\" layout-align=\"end end\" class=\"create-menu\" layout-wrap flex-xs flex-sm><md-menu-bar layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.hideButton\"><md-menu md-position-mode=\"target-right bottom\" \nclass=\"create-menu\" ng-if=\"vm.createMenu.length > 1 || (vm.createMenu.length==1 && vm.createMenu[0].items.length)\">\n<button ng-click=\"$mdMenu.open()\" class=\"add-rate-btn mb-10\" \nng-class=\"{\'md-custom-dark-theme\' : $root.domainData.domain_info.THEME_CONFIG.dark_mode , \'disabled-create-btn\' : $root.domainData.domain_info.ONBOARDING_TAG === \'self\'}\">\n<span class=\"button-content\"><md-icon id=\"plus-icon\" md-font-icon=\"icon-plus 400-fg\"></md-icon>New<md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon></span></button><md-menu-content width=\"3\" id=\"md-custom-light\" \nclass=\"md-custom-light-theme\"><md-menu-item class=\"create-menu-item\" ng-repeat=\"menu in vm.createMenu\"><md-menu \nclass=\"create-content\" ng-if=\"menu.items.length\"><md-button ng-click=\"$mdMenu.open()\" \nclass=\"h-65 line-height-none create-menu-button\"><div layout=\"row\" class=\"h-50\" \nng-click=\"vm.util.fnDisableModule($event ,menu )\" ui-sref=\"{{menu.uisref}}\" ng-if=\"menu.uisref\" \nng-class=\"{\'disabled-create-menu-list\' : !menu.is_paid }\"><div flex=\"15\" class=\"pt-5\"><md-icon \nmd-font-icon=\"{{ menu.icon}}\" md-svg-src=\"{{menu.svg_icon}}\"></md-icon></div><div layout=\"column align-self-center\" \nflex=\"60\" class=\"ml-10\"><span flex=\"30\" class=\"font-size-14\">{{menu.label}}</span></div><div flex \nclass=\"align-self-center\" ng-if=\"menu.items.length\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div>\n<div layout=\"row\" class=\"h-50\" ng-if=\"!menu.uisref\" \nng-class=\"{\'disabled-create-menu-list\' : $root.domainData.domain_info.ONBOARDING_TAG === \'self\' && vm.util.disableParentOnSelfOnboarding.includes(menu.label) }\">\n<div flex=\"15\" class=\"pt-5\"><md-icon md-font-icon=\"{{menu.icon}}\" md-svg-src=\"{{menu.svg_icon}}\" \nng-if=\"menu.icon || menu.svg_icon\"></md-icon></div><div layout=\"column  align-self-center\" layout-align=\"start center\" \nflex=\"60\" class=\"ml-10\"><span flex=\"30\" class=\"font-size-14\">{{menu.label}}</span></div><div flex \nng-if=\"menu.items.length\" class=\"align-self-center\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div>\n</md-button><md-menu-content width=\"3\" id=\"md-custom-light\" class=\"md-custom-light-theme\"><md-menu-item \nng-repeat=\"submenu in menu.items\" ng-if=\"menu.items.length\" class=\"create-menu-item\"><md-button \nclass=\"h-65 line-height-none create-menu-button\"><div layout=\"row\" class=\"h-50\" ui-sref=\"{{submenu.uisref}}\" \nng-click=\"vm.util.fnDisableModule($event ,submenu )\" ng-class=\"{\'disabled-create-menu-list\' : !submenu.is_paid }\" \nng-if=\"submenu.uisref\"><div layout=\"column align-self-center\" flex=\"60\" class=\"ml-10\"><span flex=\"30\" \nclass=\"font-size-14\">{{submenu.label}}</span></div><div flex ng-if=\"submenu.items.length\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></div></div><div layout=\"row\" class=\"h-50\" ng-if=\"!submenu.uisref\"><div \nlayout=\"column align-self-center\" flex=\"60\" class=\"ml-10\"><span flex=\"30\" class=\"font-size-14\">{{submenu.label}}</span>\n</div><div flex ng-if=\"submenu.items.length\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"h-65 line-height-none create-menu-button\" \nng-if=\"!menu.items.length\"><div layout=\"row\" class=\"h-50\" ui-sref=\"{{menu.uisref}}\" ng-if=\"menu.uisref\" \nng-click=\"vm.util.fnDisableModule($event ,menu ); vm.trackEvent(menu.label)\" \nng-class=\"{\'disabled-create-menu-list\' : !menu.is_paid }\"><div flex=\"15\" class=\"pt-5\"><md-icon \nmd-font-icon=\"{{menu.label==\'Ratecard\' || menu.label==\'Ratesheet\' ? \'assets/icons/custom/ic_local_atm_24px.svg\' : menu.icon}}\" \nmd-svg-src=\"{{ menu.label==\'Ratecard\' || menu.label==\'Ratesheet\' ? \'assets/icons/custom/ic_local_atm_24px.svg\' : menu.svg_icon}}\">\n</md-icon></div><div layout=\"column align-self-center\" flex=\"60\" class=\"ml-10\"><span flex=\"30\" class=\"font-size-14\">\n{{menu.label}}</span></div></div><div layout=\"row\" class=\"h-50\" ng-if=\"!menu.uisref\" \nng-click=\"vm.fnopenCreateQuote($event , menu) \" ng-class=\"{\'disabled-create-menu-list\' : !menu.is_paid }\"><div \nflex=\"15\" class=\"pt-5\"><md-icon \nmd-font-icon=\"{{menu.label==\'Ratecard\' || menu.label==\'Ratesheet\' ? \'assets/icons/custom/ic_local_atm_24px.svg\' : menu.icon}}\" \nmd-svg-src=\"{{ menu.label==\'Ratecard\' || menu.label==\'Ratesheet\' ? \'assets/icons/custom/ic_local_atm_24px.svg\' : menu.svg_icon}}\">\n</md-icon></div><div layout=\"column align-self-center\" flex=\"60\" class=\"ml-10\"><span flex=\"30\" class=\"font-size-14\">\n{{menu.label}}</span></div></div></md-button></md-menu-item></md-menu-content></md-menu><button \nng-if=\"vm.uploadRateFileBtn\" class=\"add-rate-btn mb-10 ml-10\" \nng-class=\"{\'md-custom-dark-theme\' : $root.domainData.domain_info.THEME_CONFIG.dark_mode , \'disabled-create-btn\' : $root.domainData.domain_info.ONBOARDING_TAG === \'self\'}\" \nui-sref=\"{{vm.uploadRateFileBtn.uisref}}\" ng-click=\"vm.util.fnDisableModule($event, vm.uploadRateFileBtn)\"><span \nclass=\"button-content\"><md-icon md-font-icon=\"icon-upload\"></md-icon>{{vm.uploadRateFileBtn.label}}</span></button> \n<button ng-if=\"vm.createMenu.length==1 && !vm.createMenu[0].items.length && vm.createMenu[0].uisref\" \nclass=\"add-rate-btn mb-10\" ng-class=\"{\'md-custom-dark-theme\' : $root.domainData.domain_info.THEME_CONFIG.dark_mode}\" \nui-sref=\"{{vm.createMenu[0].uisref}}\" ng-click=\"vm.util.fnDisableModule($event ,vm.createMenu[0] )\"><md-icon \nid=\"plus-icon\" md-font-icon=\"icon-plus 400-fg\"></md-icon>Create {{vm.createMenu[0].label}}</button> <button \nng-if=\"vm.createMenu.length==1 && !vm.createMenu[0].items.length && !vm.createMenu[0].uisref\" \nclass=\"add-rate-btn mb-10\" ng-class=\"{\'md-custom-dark-theme\' : $root.domainData.domain_info.THEME_CONFIG.dark_mode}\" \nng-click=\"vm.fnopenCreateQuote($event , vm.createMenu[0])\"><md-icon id=\"plus-icon\" md-font-icon=\"icon-plus 400-fg\">\n</md-icon>Create {{vm.createMenu[0].label}}</button></md-menu-bar><div ng-hide=\"vm.hideSpace\" class=\"empty_div\"></div>\n<div flex layout=\"row\" layout-align=\"end end\" class=\"user-menu\"><div id=\"searchbar\" \nng-if=\"(vm.util.navPermission.shipments && vm.util.navPermission.shipments[1] || vm.util.navPermission.quotes && vm.util.navPermission.quotes[1] || vm.util.navPermission.inquiry && vm.util.navPermission.inquiry[1]) && !vm.util.isEfpEnabled\" \nclass=\"collapsed\" layout=\"row\" hide-xs><div id=\"search-box\" layout=\"row\" layout-align=\"end center\"><div \nid=\"sliding-panel-outer\" layout=\"row\"><span class=\"pr-10 pointer\" ng-click=\"vm.toggleSearch($event)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icon s22\"></md-icon></span><div class=\"mb-10 search-container-div\" \nid=\"sliding-panel-inner\" layout=\"row\"><select name=\"type\" class=\"search-select pointer pl-10\" ng-model=\"vm.type\" \nflex=\"15\" flex-sm=\"25\"><option value=\"Shipments\" \nng-if=\"vm.util.navPermission.shipments && vm.util.navPermission.shipments[1]\">Bookings</option><option value=\"Quotes\" \nng-if=\"vm.util.navPermission.quotes && vm.util.navPermission.quotes[1]\">Quotes</option><option value=\"Inquiry\" \nng-if=\"vm.util.navPermission.inquiry && vm.util.navPermission.inquiry[1]\">Enquiries</option></select><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon icon-down s16\" role=\"img\" aria-label=\"icon-chevron-down\"></md-icon><input \nclass=\"h-35 p-5 border-none fg-333333 input-searchbar\" ng-model=\"shipmentSearch\" \nplaceholder=\"{{ vm.getSearchPlaceholder(vm.type) }}\" \nng-keypress=\"vm.fnSearchShipment(shipmentSearch,$event,false,vm.type)\" flex id=\"globalSearchText\"> <span layout=\"row\" \nlayout-align=\"end center\" class=\"md-accent-btn with-icon ph-5 pointer br-3\" \nng-click=\"vm.fnSearchShipment(shipmentSearch,$event,false,vm.type);vm.shipmentSearchUsed(vm.type,shipmentSearch)\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-fg search-icon\"></md-icon></span></div></div><div \nclass=\"search-label mb-10 pb-8\" ng-click=\"vm.toggleSearch($event)\" layout=\"row\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon-magnify icon h-35 input-group-addon pointer s22\"></md-icon></div></div></div><div class=\"basket-icon\" \nng-if=\"!vm.util.isShipper && vm.util.isEfpEnabled\" ng-click=\"vm.redirectToBasket()\"><md-icon \nmd-svg-src=\"assets/icons/custom/shopping_cart.svg\" class=\"icon mr-10\"></md-icon></div><md-menu-bar id=\"user-menu\" \nmd-theme=\"{{$root.domainData.domain_info.THEME_CONFIG.dark_mode ? \'custom-dark\' : \'\'}}\"><md-menu \nmd-position-mode=\"left bottom\"><div ng-click=\"$mdOpenMenu();vm.trackEvent(\'userIcon\')\" class=\"pointer mt-15 mr-5\" \nlayout=\"row\" layout-align=\"center center\" title=\"{{vm.ToolbarSerivice.userFirstName}}\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"profile-image\">{{vm.ToolbarSerivice.userFirstName.charAt(0)}}</div></div>\n<md-menu-content width=\"1\"><md-menu-item class=\"md-indent\" ui-sref=\"app.profile\" ng-click=\"vm.trackEvent(\'profile\')\">\n<md-button md-no-ink ng-class=\"{\'fg-333333\':!$root.domainData.domain_info.THEME_CONFIG.dark_mode}\" \nclass=\"button-profile\">My Profile</md-button></md-menu-item><md-menu-item \nng-if=\"$root.domainData.domain_info.SHOW_SSO && $root.domainData.domain_info.SHOW_LOGIN_OPTIONS\" class=\"md-indent\" \nui-sref=\"app.sso-switch-account\"><md-button md-no-ink \nng-class=\"{\'fg-333333\': !$root.domainData.domain_info.THEME_CONFIG.dark_mode}\" class=\"button-profile\">Switch Account\n</md-button></md-menu-item><md-menu-item ng-if=\"!$root.domainData.domain_info.SHOW_SSO && vm.accountList.length > 1\" \nclass=\"md-indent\" ui-sref=\"app.account\"><md-button md-no-ink \nng-class=\"{\'fg-333333\': !$root.domainData.domain_info.THEME_CONFIG.dark_mode}\" class=\"button-profile\">Switch Account\n</md-button></md-menu-item><md-menu-item class=\"md-indent with-border\" \nng-class=\"{\'white-border\':$root.domainData.domain_info.THEME_CONFIG.dark_mode}\"><md-button md-no-ink \nng-class=\"{\'fg-333333\':!$root.domainData.domain_info.THEME_CONFIG.dark_mode}\" class=\"button-profile\" \nng-click=\"vm.logout();vm.trackEvent(\'logout\')\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"15\" \nflex-xs=\"50\" flex-sm=\"30\"><md-button md-no-ink id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div class=\"comp_logo\" ng-style=\"{\'background-image\': \'url(\' + vm.log_url + \')\'}\">\n</div></div><div layout=\"row\" layout-align=\"end center\" layout-wrap flex=\"85\"><div \nclass=\"pr-20 mr-15 border-left border-top border-bottom border-right search_div\" layout=\"row\" flex=\"60\" flex-sm=\"50\" \nhide-xs hide-sm><select name=\"type\" class=\"type-tool pointer pl-10\" ng-model=\"vm.type\" flex=\"15\" flex-sm=\"25\" \nng-change=\"vm.updateSearchValue(vm.type)\"><option value=\"Shipments\">Shipments</option><option value=\"Quotes\">Quotes\n</option><option value=\"Inquiry\">Enquiries</option></select><input class=\"h-35 font-size-14 p-5 search_input\" \nng-model=\"shipmentSearch\" placeholder=\"{{ vm.getSearchPlaceholder(vm.type) }}\" \nng-keypress=\"vm.fnSearchShipment(shipmentSearch,$event,false,vm.type)\" flex id=\"globalSearchText\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon h-35 input-group-addon pt-5 pl-10 border-left pointer\" \nng-click=\"vm.fnSearchShipment(shipmentSearch,$event,false,vm.type);vm.shipmentSearchUsed(vm.type,shipmentSearch)\" \nflex=\"3\"></md-icon></div><ms-search-bar \non-search=\"vm.fnSearchShipment(query,$event,true);vm.shipmentSearchUsed(vm.type,shipmentSearch)\" hide-gt-sm \ntitle=\"Search\" debounce=\"400\"></ms-search-bar><div flex=\"10\" flex-xs=\"15\" flex-sm=\"15\" layout=\"row\" \nclass=\"mr-10 currency_div\" layout-align=\"end end\"><md-select class=\"font-size-14 pt-5 mr-15 ml-15 currency_sect pr-5\" \nng-model=\"vm.userCurrency\" ng-change=\"vm.updateCurrency(vm.userCurrency)\" title=\"currency\" \nmd-on-close=\"searchCurrency = \'\'\"><md-select-header><input ng-model=\"searchCurrency\" type=\"search\" \nplaceholder=\"Search Currency\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option ng-repeat=\"curr in vm.currencyList | filter : searchCurrency\" \nng-value=\"curr\">{{curr}}</md-option></md-select></div><div flex=\"10\" flex-xs=\"20\" flex-sm=\"15\" layout=\"row\" \nclass=\"mr-5 currency_div font-size-14\" layout-align=\"end end\" ng-if=\"vm.util.isFreightbro\"><md-select \nng-model=\"vm.filterForwarder\" placeholder=\"Select forwarder\" class=\"md-no-underline m-0 ellipsis-name\" \nng-change=\"vm.getAllByForwarder(vm.filterForwarder)\" md-on-close=\"searchForwarder = \'\'\"><md-select-header><input \nng-model=\"searchForwarder\" type=\"search\" placeholder=\"Search Forwarder\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"vendor in vm.forwarderList | filter : searchForwarder \" ng-value=\"vendor.id\"><md-icon class=\"s20 m-5\" \nmd-font-icon=\"icon-hospital-building\"></md-icon><span class=\"forwarder_option\">{{vendor.company_name}}</span>\n</md-option></md-select></div><div flex layout=\"row\" layout-align=\"end end\"><md-button md-no-ink \naria-label=\"Open phone interactions menu\" class=\"md-icon-button notification_btn\" ng-click=\"vm.openNotification()\" \nhide-md hide-sm hide-xs><div layout=\"row\" flex class=\"display-inline\"><md-icon \nmd-svg-src=\"assets/icons/custom/fill-11-copy.svg\"></md-icon><div class=\"font-size-14 white-fg notification_number\" \nng-if=\"vm.notificationService.unSeenNotificationCount!=0\">{{vm.notificationService.unSeenNotificationCount}}</div>\n</div><md-tooltip md-direction=\"bottom\">Notification</md-tooltip></md-button><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button md-no-ink class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\"><div layout=\"row\" layout-align=\"space-between center\" \ntitle=\"{{vm.ToolbarSerivice.userFirstName}}\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><span class=\"username text-capitalize\" hide show-gt-sm>\n{{vm.ToolbarSerivice.userFirstName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button md-no-ink>My Profile</md-button></md-menu-item>\n<md-menu-item class=\"md-indent\" ng-click=\"vm.openNotification()\" hide-gt-md><md-icon \nmd-svg-src=\"assets/icons/custom/fill-11-copy.svg\"></md-icon><md-button md-no-ink>Notification</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.profile.manageNotification({place:\'profile\'})\" \nng-if=\"$root.domainData.domain_info.NOTIFICATION_VERSION.toLowerCase() === \'v2\' && !vm.util.isShipper\" \nng-click=\"vm.trackEvent(\'notification\')\"><md-button md-no-ink \nng-class=\"{\'fg-333333\':!$root.domainData.domain_info.THEME_CONFIG.dark_mode}\" class=\"button-profile\">Notification\n</md-button></md-menu-item><md-menu-item \nng-if=\"$root.domainData.domain_info.SHOW_SSO && $root.domainData.domain_info.SHOW_LOGIN_OPTIONS\" class=\"md-indent\" \nui-sref=\"app.sso-switch-account\"><md-icon md-font-icon=\"icon-account-switch\"></md-icon><md-button md-no-ink>\nSwitch Account</md-button></md-menu-item><md-menu-item \nng-if=\"!$root.domainData.domain_info.SHOW_SSO && vm.accountList.length > 1\" class=\"md-indent\" ui-sref=\"app.account\">\n<md-icon md-font-icon=\"icon-account-switch\"></md-icon><md-button md-no-ink>Switch Account</md-button></md-menu-item>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button md-no-ink \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div \nng-click=\"vm.logout()\" class=\"ml-15 mr-20 cursor\" hide><md-icon md-font-icon=\"icon-power\" class=\"icon cursor\">\n</md-icon><md-tooltip md-direction=\"bottom\">Logout</md-tooltip></div><div layout=\"row\" layout-align=\"end end\" \nclass=\"w-30\" hide><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide-gt-xs show-xs\"><md-button md-no-ink \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">More\n</md-tooltip></md-button><md-menu-content><md-button md-no-ink ng-click=\"vm.logout()\"><md-icon \nmd-font-icon=\"icon-power\" class=\"icon\"></md-icon>Logout</md-button></md-menu-content></md-menu></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigationApp/toolbar.html","<div layout=\"row\" layout-align=\"start center\" style=\"background-color:#303e9f\"><div layout=\"row\" \nlayout-align=\"start center\" flex><md-button md-no-ink id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\" style=\"color:#ffffff\"></md-icon></md-button><h2 style=\"color:white;margin:12px\">{{vm.util.screenTitle}}\n</h2></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal horizontalNav\" ng-class=\"{\'dark_theme\' : $root.domainData.domain_info.THEME_CONFIG.dark_mode}\"><li \nng-repeat=\"node in vm.navigation \" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" \nng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" \nid=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active\': vm.isActive}\" ng-click=\"vm.util.trackEvent(node.title)\">\n            <span hide show-xs show-sm ><i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\" ></i> </span>\n            <span class=\"title\" ng-class=\"{\'childTitle\' : vm.hasChildren , disableParent: $root.domainData.domain_info.ONBOARDING_TAG === \'self\' && vm.util.disableParentOnSelfOnboarding.includes(node.title)}\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-down s18 arrow\" ng-if=\"vm.hasChildren\" ng-class=\"{disableParent:$root.domainData.domain_info.ONBOARDING_TAG === \'self\' && vm.util.disableParentOnSelfOnboarding.includes(node.title)}\"></i>\n        </div>\n        <a class=\"ms-navigation-horizontal-button\" ng-attr-ui-sref=\"{{vm.util.isEfpEnabled ? (node.uisref==\'app.search\' ? \'app.searchV2Module\':  node.uisref == \'app.quotes\' \n            ? \'app.quoteListModule\' \n            : node.uisref == \'app.inquiry\' \n            ? \'app.enquiry\' \n            : node.uisref == \'app.shipments\'  ?\'app.bookingv2\' :node.uisref) :node.uisref }}\" ui-sref-active=\"active \"\n           ng-class=\"{\'active \': vm.isActive ,\'disabledStyle\':!node.is_paid}\"\n           ng-if=\"node.uisref && node.title\"\n           ng-click=\"vm.util.fnDisableModule($event ,node)\">\n           <!-- <span ng-if=\"node.title == \'Add Rate\'\" class=\"pl-8\">Add Rate</span> -->\n           <span ng-if=\"node.title !== \'Add Rate\'\">\n            <span hide show-xs show-sm ><i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\" ></i> </span>\n            <span class=\"title\" ng-class=\"{\'childTitle\' : vm.hasChildren}\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n           </span>\n            \n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"\n            ng-if=\"node.title !== \'Notification\' || (node.title == \'Notification\' && $root.domainData.domain_info.NOTIFICATION_VERSION.toLowerCase() === \'v2\')\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s20 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg font-weight-600\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s20 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"((node.uisref && node.title)&&(node.title!=\'Profile\'))\">\n            <i class=\"icon s20 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg font-weight-600\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s20 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"\n            ng-if=\"node.title !== \'Notification\' || (node.title == \'Notification\' && $root.domainData.domain_info.NOTIFICATION_VERSION.toLowerCase() === \'v2\')\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/Inquiry/Dialogs/global-rates-popup/global-rates-confirmation.html","<md-dialog class=\"global-rate-modal popup-xs\"><md-dialog-content class=\"body\"><section class=\"pv-5\" \nng-if=\"ctrl.parent.fromInquiry && ctrl.parent.search_param.mode == \'SEA-FCL\'\"><div layout=\"column\" \nlayout-align=\"start start\" class=\"pl-20 pr-30\" ng-if=\"ctrl.parent.confirmationRates.length\"><div layout=\"row\">\nYou are about to publish rates of below carriers to the search. Send anyway?</div><div layout=\"row\" \nclass=\"ph-10 pt-10\" ng-repeat=\"subvendor in ctrl.parent.confirmationRates track by $index\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"light-blue-400-fg s18 mb-2 mr-5\"></md-icon><span>{{subvendor}}</span>\n</div></div><div layout=\"column\" layout-align=\"start start\" ng-if=\"!ctrl.parent.confirmationRates.length\"><div \nlayout=\"row\">You haven\'t marked any rates as global. Send anyway?</div></div></section><section class=\"pv-5\" \nng-if=\"!ctrl.parent.fromInquiry || ctrl.parent.search_param.mode != \'SEA-FCL\'\"><div layout=\"column\" \nlayout-align=\"start start\" class=\"font-size-16 font-weight-600 mb-10\"><div layout=\"row\" class=\"mv-5\">\nDo you want to send these rate(s)?</div></div></section></md-dialog-content><md-dialog-actions class=\"footer\"><div \nlayout=\"row\" layout-align=\"end end\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog();\" title=\"Cancel\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" title=\"Yes, Send\" ng-click=\"ctrl.parent.fnSendRates()\">Yes, Send</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Inquiry/Dialogs/global-rates-popup/global-rates-error.html","<md-dialog class=\"global-rate-modal\" class=\"popup-xs\" ng-cloak><md-dialog-content layout=\"column\" class=\"body\"><div>\n<div layout=\"column\" layout-align=\"start start\" ng-if=\"ctrl.parent.sendRatesError.liners_rates_published.length\"><div \nlayout=\"row\">{{ctrl.parent.sendRatesErrorMessage}}</div><div layout=\"row\" class=\"mv-5\">\nFailed to publish below carriers’ rates to Search</div><div layout=\"row\" class=\"ph-10 mv-5\" \nng-repeat=\"liner in ctrl.parent.sendRatesError.liners_rates_published track by $index\"><md-icon \nmd-font-icon=\"icon-brightness-1\" class=\"fg-AAA8AD s18 mb-2 mr-5\"></md-icon><span>{{liner.sub_vendor_name}}</span></div>\n</div><div layout=\"column\" layout-align=\"start start\" \nng-if=\"!ctrl.parent.sendRatesError.liners_rates_published.length\"><div layout=\"row\" class=\"mv-5\">\n{{ctrl.parent.sendRatesErrorMessage}}</div></div><div class=\"font-size-11 fg-AAA8AD pl-20 pr-30 mt-10 mb-10\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16 mr-5 mt-imp\"></md-icon><span>\nPlease try again or contact your Admin team.</span></div></div></md-dialog-content><md-dialog-actions class=\"footer\">\n<div layout=\"row\" layout-align=\"end end\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Close\">Close</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Inquiry/Dialogs/global-rates-popup/global-rates-success.html","<md-dialog class=\"global-rate-modal popup-xs\" ng-cloak><md-dialog-content class=\"body\"><div class=\"pv-5\"><div \nlayout=\"column\" layout-align=\"start start\" class=\"pl-20 pr-30 mt-5 mb-10\" \nng-if=\"ctrl.parent.sendRatesResponse.liners_rates_published.length\"><div layout=\"row\" class=\"mv-5\">\nThe rate(s) you added are published to Search as well.</div><div layout=\"row\" class=\"ph-10 mv-5\" \nng-repeat=\"liner in ctrl.parent.sendRatesResponse.liners_rates_published track by $index\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"green-400-fg s18 mb-2 mr-5\"></md-icon><span>{{liner.sub_vendor_name}}\n</span></div></div><div layout=\"column\" layout-align=\"start start\" class=\"pl-20 pr-30 mt-5 mb-10\" \nng-if=\"ctrl.parent.sendRatesResponse.liners_rates_published_to_inquiry.length\"><div layout=\"row\" class=\"mv-5\">\nThe rate(s) you added are exclusive to this inquiry only.</div><div layout=\"row\" class=\"ph-10 mv-5\" \nng-repeat=\"liner in ctrl.parent.sendRatesResponse.liners_rates_published_to_inquiry track by $index\"><md-icon \nmd-font-icon=\"icon-brightness-1\" class=\"grey-fg s14 mb-2 mr-5\"></md-icon><span>{{liner.sub_vendor_name}}</span></div>\n</div></div></md-dialog-content><md-dialog-actions class=\"footer\"><div layout=\"row\" layout-align=\"end end\"><md-button \nmd-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"close\">Close</md-button><md-button \nmd-no-ink class=\"md-accent-btn mv-15 ml-20\" title=\"View Inquiry\" ng-click=\"ctrl.parent.inquiryRefreash();\">View Inquiry\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Inquiry/components/inquiry-card/inquiryCard.html","<div id=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_id}}\"><div id=\"inquiryCardView\"><md-icon \nclass=\"md-link-fg\" md-font-icon=\"icon-checkbox-marked-circle\" \nng-if=\"$ctrl.islastactivity && ($ctrl.carddata.meta.is_selected || $ctrl.carddata.meta.is_booked)\" \nstyle=\"position:absolute;right:5px;top:5px\"></md-icon><div layout=\"row\" layout-align=\"space-between\" \nclass=\"min-height-25\" flex=\"100\"><div class=\"card_tag\" layout-align=\"start center\" flex=\"50\"><div class=\"liner_logo\" \nng-if=\"$ctrl.search_param.mode != \'AIR\'\"><div \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"comp_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"text-truncate empty_logo comp_logo\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\" \nng-show=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.logo\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div></div><div \nclass=\"liner_logo\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\"><div \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\"><img class=\"list_logo\" \nng-src=\"{{$ctrl.util.sanitizeQueryParams($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo)}}\" \nalt=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\"></div><div \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.logo\" \nclass=\"text-truncate empty_logo comp_logo\" \ntitle=\"{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}}</div></div></div><div \nlayout=\"column\" layout-align=\"center end\" flex=\"100\" class=\"mr-15\" \nng-if=\"$ctrl.carddata.partner_reference_id && !$ctrl.util.isShipper\"><span class=\"font-size-11 intergration-code\">\nCW Quotation No.</span><div class=\"font-size-12 fg-333333 Font-Bold\" layout=\"row\"><div \nclass=\"ellipsis-name text-capitalize pl-5 text-truncate max-width-120\">{{$ctrl.carddata.partner_reference_id}}\n<md-tooltip md-direction=\"top\">{{$ctrl.carddata.partner_reference_id}}</md-tooltip></div><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s16 pl-5 pointer content-copy z-2\" ng-if=\"$ctrl.carddata.partner_reference_id\" \nng-click=\"$ctrl.fnCopyID( $ctrl.carddata.partner_reference_id)\"><md-tooltip md-direction=\"top\">{{$ctrl.isIdCopied}}\n</md-tooltip></md-icon></div></div><div layout=\"row\" layout-align=\"end start\" flex=\"100\" \nng-if=\"$ctrl.util.userProfile.user.is_pricing_user\"><div class=\"pt-8 pr-10 display-content\"><span class=\"mt-5 mr-5\" \nng-click=\"$ctrl.copyCard = true; $ctrl.fnAddOrEditCard($ctrl.carddata,\'newCardInquiry\', $event, \'CopyRateCard\');\" \nng-if=\"$ctrl.islastactivity != undefined && $ctrl.pricingiscopy && ($ctrl.inquiryid.current_status.status ==  $ctrl.statusCondition || $ctrl.inquiryid.current_status.status == \'Quoted\' || $ctrl.inquiryid.current_status.status == \'Rates available\')\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"w-15 h-15 icon_opacity pointer icon-size-20\" \ntitle=\"Add to current list\"></md-icon></span><span class=\"pr-8 mr-5 br mt-5\" \nng-click=\"$ctrl.fnAddOrEditCard($ctrl.carddata,\'editCardInquiry\', $event, \'EditRateCard\');\" \nng-if=\"$ctrl.islastactivity == undefined\"><md-icon md-svg-icon=\"assets/icons/custom/edit-icon.svg\" \nclass=\"w-15 h-15 icon_opacity pointer\" title=\"Edit\"></md-icon></span><span class=\"mt-5\" \nng-click=\"$ctrl.openDeleteCard($event,$ctrl.carddata, $index, \'DeleteRateCard\')\" \nng-if=\"$ctrl.islastactivity == undefined\"><md-icon md-svg-icon=\"assets/icons/custom/delete-icon.svg\" \nclass=\"w-15 h-15 icon_opacity pointer\" title=\"Delete\"></md-icon></span></div></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div div-slide-show><div layout=\"row\" \nng-repeat=\"tag in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.tags\" class=\"mv-5 ml-15\" \nng-if=\"tag.show_tag\"><img class=\"w-60\" ng-src=\"{{$ctrl.util.sanitizeQueryParams(tag.tag_ribbon_url)}}\"><md-tooltip \nmd-direction=\"top\" style=\"display:table;opacity: 1\" class=\"font-size-14 pv-5 text-center font-weight-600\" \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.rollable_available\"><div>Rollable available</div>\n</md-tooltip></div></div><div flex=\"100\" layout=\"row\" layout-align=\"end end\"><div class=\"pr-15\" layout=\"column\" \nlayout-align=\"start end\" flex=\"{{!$ctrl.card_item.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry ? \'\' : \'none\'}}\">\n<div layout=\"row\" ng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id\"><span \nclass=\"pr-5 font-size-10\">RATE ID</span><div class=\"blue-400-fg ellipsis-80 pointer font-size-10\" \nng-class=\"{\'ellipsis-100\' : ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry)}\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id}}<md-tooltip md-direction=\"top\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 pt-5 text-center grey-fg font-weight-600 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.price_id}}</div></md-tooltip></div></div><span \nclass=\"font-size-8 dotted-border-bottom pointer\" \nng-if=\"$ctrl.carddata.meta.type.includes(\'spot\') && ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.data || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.terms_and_condition.url)\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'tnc\',$ctrl.carddata.meta.type, null, \'T&C\')\">T&C applicable\n<md-tooltip md-direction=\"bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 h-50 pt-5 text-center grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\"><div>Get Guaranteed Slot Upon</div><div>Booking Confirmation</div></md-tooltip></span>\n</div><div class=\"pr-15 font-size-11 min-width-60\" layout=\"column\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number && !$ctrl.util.isShipper && (!$ctrl.carddata.meta.type.includes(\'network\')  ||  $ctrl.showContractId)\">\n<span class=\"fg-8D8D8D Font-Bold\">Contract ID<md-tooltip md-direction=\"top\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 pt-5 text-center grey-fg font-weight-600 tooltip-width-control\" \nstyle=\"display:table;opacity: 1\">Contract / Rate Agreement / Tariff / Spot Pricing Reference Number</md-tooltip></span>\n<span class=\"Font-Bold fg-333333 ellipsis-100\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number}}</span><md-tooltip md-direction=\"top\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 pt-5 text-center grey-fg font-weight-600 tooltip-width-control\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.contract_number}}</div></md-tooltip></div><div \nclass=\"pr-15 font-size-10 min-width-60\" layout=\"column\" layout-align=\"end end\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\"><span class=\"key\">Expiry Date</span> <span \nclass=\"font-weight-bold red-400-fg\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\'}}</span></div></div>\n</div><div class=\"blue-bg-fg font-size-10 brad-4 mh-15 mt-8\" layput=\"row\" layout-align=\"start center\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions.length\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"blue-600-fg s14 ml-5 mr-0\"></md-icon><span \nng-repeat=\"promotion in $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.promotions track by $index\">\n{{$first ? \'\' : \', \'}} {{promotion.name}}</span></div><div layout=\"row\" class=\"ph-15 pv-5\" flex=\"100\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\'\"><div flex layout=\"column\" layout-align=\"center start\"><div \nclass=\"grey-fg font-size-10 text-truncate\">Port of Loading</div><div \nclass=\"font-size-14 grey-700-fg font-weight-600 text-truncate mw-100\">\n{{ $ctrl.carddata.meta.via_pol ? $ctrl.carddata.meta.via_pol : $ctrl.carddata.meta.port_data.origin_port_code }} <span \nng-if=\"$ctrl.carddata.meta.via_pol || $ctrl.carddata.meta.port_data.pickup_location\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s16 black-fg\"></md-icon><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 p-10\" \nng-show=\"$ctrl.carddata.meta.via_pol || $ctrl.carddata.meta.port_data.pickup_location\" \nstyle=\"display:table;opacity: 1\"><div ng-if=\"$ctrl.carddata.meta.port_data.pickup_location\"><div class=\"grey-fg\">Pickup\n</div><div class=\"grey-800-fg font-weight-600 text-truncate\">{{$ctrl.carddata.meta.port_data.pickup_location}}</div>\n</div><div class=\"grey-fg\">Port of {{ $ctrl.carddata.meta.via_pol ? \'Origin\' : \'Loading\' }}</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-truncate\">{{$ctrl.carddata.meta.port_data.origin_port_code}}</div><div \nng-if=\"$ctrl.carddata.meta.via_pol\"><div class=\"grey-fg\">Port of Loading</div><div \nclass=\"grey-800-fg font-weight-600 text-truncate\">{{$ctrl.carddata.meta.via_pol}}</div></div></md-tooltip></span></div>\n</div><div layout=\"column\" layout-align=\"center center\" class=\"h-42\"><div layout=\"row\"><div \nclass=\"grey-fg font-size-20\">. . .</div><div \nclass=\"grey-700-fg font-size-12 font-weight-600 pt-12 ph-5 text-truncate max-width-60\" \nng-if=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule ?(!$ctrl.carddata.meta.selected_schedule.transit_time ? \'N/A\' : $ctrl.carddata.meta.selected_schedule.transit_time) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'N/A\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg font-size-12 p-10\" style=\"display:table;opacity: 1\">\n<div class=\"grey-fg text-center\">Transit Time</div><div class=\"grey-fg font-weight-600 text-center\">\n{{ $ctrl.carddata.meta.selected_schedule ?(!$ctrl.carddata.meta.selected_schedule.transit_time ? \'Not Available\' : $ctrl.carddata.meta.selected_schedule.transit_time) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ? \'Not Available\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.transit_time ) }}\n</div></md-tooltip></div><div ng-if=\"!$ctrl.carddata.meta.isScheduleCall\" class=\"loader\" \nstyle=\"margin-top: 12px !important\"></div><div class=\"grey-fg font-size-20\">. . .</div></div><div \nclass=\"font-size-10 font-weight-700 text-center text-truncate w-90\" ng-if=\"$ctrl.carddata.meta.isScheduleCall\">\n{{ $ctrl.carddata.meta.selected_schedule ? ($ctrl.carddata.meta.selected_schedule.schedule_track.length-2 > 1 ? $ctrl.carddata.meta.selected_schedule.schedule_track.length-2 + \'via Ports\' : ($ctrl.carddata.meta.selected_schedule.via_port == \'Direct\' ? \'Direct\' : \'via Port\' )) : (!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ? \'N/A\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ) }}\n<md-tooltip md-direction=\"Bottom\" class=\"md-whiteframe-2dp white-bg font-size-12 p-10\" \nstyle=\"display:table;opacity: 1\" \nng-show=\"$ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.via_port != \'Direct\'\"><div \nclass=\"grey-fg text-center\">via Port</div><div class=\"grey-fg font-weight-600 text-center\" \nng-repeat=\"track in $ctrl.carddata.meta.selected_schedule.schedule_track track by $index\" ng-show=\"!$first && !$last\">\n{{ track.port_name }}</div></md-tooltip><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 p-10\" style=\"display:table;opacity: 1\" \nng-show=\"!$ctrl.carddata.meta.selected_schedule\"><div class=\"grey-fg text-center\">via Port</div><div \nclass=\"grey-fg font-weight-600 text-center tooltip-width-control\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.via_route : \'Not Available\'}}\n</div></md-tooltip></div></div><div layout=\"column\" layout-align=\"center end\" flex><div \nclass=\"grey-fg font-size-10 text-truncate\">Port of Discharge</div><div \nclass=\"font-size-14 grey-700-fg font-weight-600 text-truncate mw-100\">\n{{ $ctrl.carddata.meta.via_pod ? $ctrl.carddata.meta.via_pod : $ctrl.carddata.meta.port_data.destination_port_code }} \n<span ng-if=\"$ctrl.carddata.meta.via_pod || $ctrl.carddata.meta.port_data.delivery_location\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s16 black-fg\"></md-icon><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 p-10\" \nng-show=\"$ctrl.carddata.meta.via_pod || $ctrl.carddata.meta.port_data.delivery_location\" \nstyle=\"display:table;opacity: 1\"><div ng-if=\"$ctrl.carddata.meta.via_pod\"><div class=\"grey-fg text-right\">\nPort of Discharge</div><div class=\"grey-800-fg font-weight-600 text-right text-truncate\">\n{{$ctrl.carddata.meta.via_pod}}</div></div><div class=\"grey-fg text-right\">\nPort of {{ $ctrl.carddata.meta.via_pod ? \'Destination\' : \'Discharge\' }}</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-right text-truncate\">\n{{$ctrl.carddata.meta.port_data.destination_port_code}}</div><div \nng-if=\"$ctrl.carddata.meta.port_data.delivery_location\"><div class=\"grey-fg text-right\">Delivery</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-right text-truncate\">{{$ctrl.carddata.meta.port_data.delivery_location}}\n</div></div></md-tooltip></span></div></div></div><div layout=\"row\" flex=\"100\" class=\"ph-15\"><div flex layout=\"column\" \nlayout-align=\"start start\" \nng-if=\"(!$ctrl.util.isShipper && !$ctrl.util.isSharedQuote()) && ($ctrl.carddata.meta.type != \'msr_spot\' && $ctrl.carddata.meta.type != \'network_spot\') \" \nclass=\"mb-10\"><div class=\"font-size-10 grey-fg\">Rates By <span>\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? \'Agent \':\'Forwarder \'}}\n</span></div><div class=\"font-size-12 font-weight-600 text-truncate w-200\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.agent.agent_name : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name }}\n</md-tooltip></div></div><div flex layout=\"column\" layout-align=\"start start\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code\" class=\"mb-10\"><div \nclass=\"font-size-10 grey-fg\">Named Account Code</div><div class=\"font-size-12 font-weight-600 text-truncate w-200\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code}}<md-tooltip md-direction=\"bottom\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.named_account_code}}</md-tooltip></div></div></div><div \nclass=\"haualge_div pv-10\" \nng-if=\"($ctrl.search_param.origin_location.place_type==\'Door\' || $ctrl.search_param.destination_location.place_type==\'Door\')\">\n<div class=\"ph-15 pv-5\" layout=\"row\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.origin_location.place_type==\'Door\'\"><div class=\"key\">Pickup by</div><div class=\"value\">\n{{ $ctrl.carddata.meta.pickup_sub_vendor ? $ctrl.carddata.meta.pickup_sub_vendor.sub_vendor_name : \'N/A\' }}</div></div>\n<div class=\"ph-15 pv-5\" layout=\"row\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.destination_location.place_type==\'Door\'\"><div class=\"key\">Delivery by</div><div \nclass=\"value\">\n{{ $ctrl.carddata.meta.delivery_sub_vendor ? $ctrl.carddata.meta.delivery_sub_vendor.sub_vendor_name : \'N/A\' }}</div>\n</div></div><div class=\"haualge_div pv-10\" layout=\"row\" layout-wrap><div class=\"ph-15 pv-5\" layout=\"column\" \nlayout-align=\"space-between\" ng-if=\"$ctrl.search_param.mode!=\'AIR\'\"><div class=\"key\">Next Sailing On</div><div \nclass=\"value mw-150 text-truncate\">\n{{ $ctrl.carddata.meta.selected_schedule || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sailing_date ? ($ctrl.carddata.meta.selected_schedule.departure_time ? $ctrl.carddata.meta.selected_schedule.departure_time : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\') : \'N/A\' }}\n</div></div><div ng-if=\"$ctrl.search_param.mode != \'AIR\' \"><free-days \nfreedaysdata=\"{\n              demurrage_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.demurrage_details,\n              detention_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.detention_details,\n              combined_details : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.combined_details,\n              freeDays : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.freeDays,\n              pageSource : \'inquiry\',\n            }\" \ntype=\"\'card\'\" cardid=\"$ctrl.carddata._id\" mode=\"$ctrl.search_param.mode\" \nsearch-load-data=\"$ctrl.search_param.load_data.load_details_value\"></free-days></div><div flex=\"100\" \nclass=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length\">\n<div class=\"key\">Cargo</div><div layout=\"row\"><div class=\"value mw-150 text-truncate text-capitalize\"><span \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data.name }} <span \nng-show=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data.length\">|</span> </span>\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data[0].toLowerCase() }}</div><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer cargo-{{$ctrl.carddata._id}}\" \nng-click=\"$ctrl.shareQuoteService.showCargoCommodity($event, $ctrl.carddata._id, $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg]);$ctrl.fnTrackAnalytics(\'ID-RateCard-cargoDetails-Hover\')\">\n</md-icon></div></div></div><div class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\"><div class=\"key w-80\">\nService Type</div><div class=\"value\" layout=\"row\"><span class=\"value mw-130 text-truncate\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type ? \'\' : $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type }}\n</md-tooltip></span><span class=\"value mw-130 text-truncate\" \nng-if=\"$ctrl.search_param.mode === \'AIR\' && $ctrl.carddata.meta.selected_schedule.flight_number\"><span class=\"ph-3\">| \n</span>{{ $ctrl.carddata.meta.selected_schedule.flight_number }}<md-tooltip md-direction=\"top\" \nclass=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" style=\"display:table;opacity: 1\">\n{{ $ctrl.carddata.meta.selected_schedule.flight_number }}</md-tooltip></span><span class=\"ph-3\" \nng-if=\"($ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.service_name) && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type\">\n| </span><span class=\"value mw-130 text-truncate\" \nng-if=\"$ctrl.search_param.mode!=\'AIR\' && $ctrl.carddata.meta.selected_schedule\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ !$ctrl.carddata.meta.selected_schedule.service_name ? \'\' : $ctrl.carddata.meta.selected_schedule.service_name }}\n</md-tooltip></span><span \nng-if=\"!(($ctrl.carddata.meta.selected_schedule && $ctrl.carddata.meta.selected_schedule.service_name) || $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type)\">\nN/A</span></div></div><div class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.carddata.meta.co2eData\"><div class=\"key\"><md-icon md-svg-src=\"assets/icons/custom/co2-icon.svg\" \nclass=\"icon-class-10 mv-0 ml-0 mr-5\"></md-icon>CO<sub>2</sub> emission</div><div class=\"value mw-150\" layout=\"row\"><div\n class=\"text-truncate\">{{($ctrl.carddata.meta.co2eData.co2e.total | currencyMask: 2) +\' \' +\'g\'}}</div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s14 fg-3F3851 pointer co2e-{{$ctrl.carddata._id}}\" \nng-click=\"$ctrl.shareQuoteService.showCo2ContainerData($event, $ctrl.carddata._id, $ctrl.carddata.meta.co2eData)\">\n</md-icon></div></div><div class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l1_leg] && $ctrl.carddata.meta.pickup_transport_mode\">\n<div class=\"key\" layout=\"row\" layout-align=\"start center\">Pickup Haulage</div><div class=\"value mw-150 text-truncate\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" \nng-if=\"!$ctrl.carddata.meta.pickup_transport_mode\"></md-icon>\n{{$ctrl.carddata.meta.pickup_transport_mode ? $ctrl.carddata.meta.pickup_transport_mode : \'Not Available\'}}</div></div>\n<div class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.carddata.meta.via_pol\"><div class=\"key\" layout=\"row\" \nlayout-align=\"start center\">Origin Haulage</div><div class=\"value mw-150 text-truncate\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" ng-if=\"!$ctrl.carddata.meta.haulage\"></md-icon>\n{{$ctrl.carddata.meta.haulage ? $ctrl.carddata.meta.haulage : \'Not Available\'}}</div></div><div class=\"ph-15 pv-5\" \nlayout=\"column\" layout-align=\"space-between\" ng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.carddata.meta.via_pod\">\n<div class=\"key\" layout=\"row\" layout-align=\"start center\">Destination Haulage</div><div \nclass=\"value mw-150 text-truncate\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" \nng-if=\"!$ctrl.carddata.meta.destination_haulage\"></md-icon>\n{{$ctrl.carddata.meta.destination_haulage ? $ctrl.carddata.meta.destination_haulage : \'Not Available\'}}</div></div><div\n class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l5_leg] && $ctrl.carddata.meta.delivery_transport_mode\">\n<div class=\"key\" layout=\"row\" layout-align=\"start center\">Delivery Haulage</div><div \nclass=\"value mw-150 text-truncate\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" \nng-if=\"!$ctrl.carddata.meta.delivery_transport_mode\"></md-icon>\n{{$ctrl.carddata.meta.delivery_transport_mode ? $ctrl.carddata.meta.delivery_transport_mode : \'Not Available\'}}</div>\n</div></div><div ng-if=\"$ctrl.search_param.mode ==\'AIR\'\"><div layout=\"row\" class=\"bt mv-20 h-55\" flex=\"100\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 && !$ctrl.carddata.meta.is_selected\"><div \nng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_1\',\'inactive_slab\':$ctrl.carddata.meta.selectedLeg != \'rate_obj_1\'}\" \nclass=\"pointer\" flex layout=\"column\" layout-align=\"center center\" \nng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_1\')\"><div class=\"red-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab && $ctrl.carddata.meta.slabPersentage < 0\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s12 mb-5 red-400-fg\"></md-icon>\nExtra {{ ($ctrl.fnCalAirSlab($ctrl.carddata.meta.slabPersentage)) | currencyMask: 2 }} % on Freight</div><div \nclass=\"green-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab && $ctrl.carddata.meta.slabPersentage > 0\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s12 mb-1 green-400-fg\"></md-icon>Save <span \nclass=\"font-size-12 font-weight-600\">{{ $ctrl.carddata.meta.slabPersentage | currencyMask: 2 }}%</span> on Freight\n</div><div class=\"font-size-10\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab }} slab</div><div\n class=\"font-size-11\"><span class=\"font-weight-600\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_currency }}</span> <span \nclass=\"font-weight-600 font-size-14\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} \n</span><span class=\"font-size-8\">per KG</span></div></div><div \nng-class=\"{\'active_slab\':$ctrl.carddata.meta.selectedLeg == \'rate_obj_2\',\'inactive_slab\':$ctrl.carddata.meta.selectedLeg != \'rate_obj_2\'}\" \nclass=\"pointer\" flex layout=\"column\" layout-align=\"center center\" \nng-click=\"$ctrl.fnSwitchRates($ctrl.carddata, \'rate_obj_2\')\"><div class=\"red-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab && $ctrl.carddata.meta.slabPersentage < 0\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s12 mb-5 red-400-fg\"></md-icon>\nExtra {{ ($ctrl.fnCalAirSlab($ctrl.carddata.meta.slabPersentage)) | currencyMask: 2 }} % on Freight</div><div \nclass=\"green-400-fg font-size-9\" \nng-if=\"$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab && $ctrl.carddata.meta.slabPersentage > 0\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s12 mb-1 green-400-fg\"></md-icon>Save <span \nclass=\"font-size-12 font-weight-600\">{{ $ctrl.carddata.meta.slabPersentage | currencyMask: 2 }} %</span> on Freight\n</div><div class=\"font-size-10\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab }} slab</div><div\n class=\"grey-fg font-size-11\"><span class=\"font-weight-600\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_currency }}</span> <span \nclass=\"font-weight-600 font-size-14\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_2.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} \n</span><span class=\"font-size-8\">per KG</span></div></div></div><div class=\"inactive_slab h-55 bt mv-20\" \nlayout=\"column\" flex=\"100\" layout-align=\"center center\" \nng-if=\"!$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj_1 || $ctrl.carddata.meta.is_selected\"><div \nclass=\"shadow_div\"></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div class=\"font-size-12\">\n{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab }} slab</div><div class=\"font-size-12 ml-5\"><span \nclass=\"font-weight-600\">{{ $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_currency }}</span> \n<span class=\"font-weight-600 font-size-14\">\n{{ ($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.leg_total_cost / ( $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.is_higher_slab ? $ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.slab : $ctrl.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} \n</span><span class=\"font-size-8\">per KG</span></div></div></div></div><div shimmer-effect-full width=\"97%\" \nheight=\"30px\" mh=\"10px\" ng-if=\"$ctrl.carddata.meta.shimmer\"></div><div shimmer-effect-full width=\"97%\" height=\"30px\" \nmh=\"10px\" ng-if=\"$ctrl.carddata.meta.shimmer\"></div><div ng-if=\"!$ctrl.carddata.meta.shimmer\"><div layout=\"row\" \nlayout-wrap class=\"pv-5 ph-15\" \nng-repeat=\"(leg_key,leg_value) in $ctrl.carddata.data[$ctrl.buyOrSell] track by leg_value.leg_code\" \nng-class=\"{\'h-35 main-freight-div mv-5\' : leg_key == $ctrl.l3_leg, \'mersk-spot\' : (leg_key == $ctrl.l3_leg && ($ctrl.carddata.meta.type == \'msr_spot\' || $ctrl.carddata.meta.type == \'network_spot\')) }\" \nng-hide=\"leg_key == $ctrl.l3_leg && !$ctrl.searchparam.freight_charges\"><div layout=\"column\" \nlayout-align=\"center start\" flex=\"60\" flex-gt-xs=\"60\" ng-class=\"{\'text-truncate\': leg_key != $ctrl.l3_leg }\"><span \nclass=\"key pr-2\" ng-class=\"{\'white-fg text-truncate\' : leg_key == $ctrl.l3_leg }\"><md-icon \nmd-font-icon=\"icon-information-outline\n                      \" class=\"s16 mb-5 pointer\" \nng-if=\"(leg_key == $ctrl.l3_leg && !$ctrl.carddata.meta.isLinerChanged && ($ctrl.carddata.meta.type == \'msr_spot\' || $ctrl.carddata.meta.type == \'network_spot\'))\">\n<md-tooltip md-direction=\"bottom\" class=\"md-whiteframe-2dp white-bg grey-fg font-size-12 p-10 Gilroy-Bold\" \nstyle=\"display:table;opacity:1\">Spot Rates are dynamic &<br>can fluctuate with time</md-tooltip></md-icon>\n{{ ( leg_key == $ctrl.l3_leg && leg_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : leg_value.leg_name }} <span\n \nng-if=\"leg_key == $ctrl.l3_leg && $ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.is_special && ($ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total != undefined)\">\n<md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></span></span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"leg-cost-right pr-2 value text-truncate\" \nng-class=\"{\'red-600-fg\' : (leg_key != $ctrl.l3_leg &&!leg_value.rate_obj), \'white-fg \' : (leg_key == $ctrl.l3_leg), \'grey-800-fg\' : (leg_key != $ctrl.l3_leg)}\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask: 2) ) : \'N/A\' }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask: 2) ) : \'NA\' }}\n</md-tooltip></span><span class=\"leg-cost-right pr-2 grey-500-fg font-weight-500 font-size-12 text-truncate\" \nng-if=\"leg_key == $ctrl.l3_leg && $ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.is_special && ($ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total != undefined)\">\n<strike>\n{{$ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.leg_currency}} {{$ctrl.carddata.data[$ctrl.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total | currencyMask: 2}}\n</strike></span></div></div></div><div layout=\"row\" layout-wrap class=\"black-fg pv-10 mt-10\"><div \nclass=\"pl-15 font-size-12 font-weight-600 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"60\" \nflex-gt-xs=\"60\"><div>Total Cost <sup ng-if=\"$ctrl.showAsterix($ctrl.carddata.data[$ctrl.buyOrSell])\">**</sup>\n<md-tooltip ng-if=\"$ctrl.showAsterix($ctrl.carddata.data[$ctrl.buyOrSell])\" md-direction=\"right\" \nclass=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" style=\"display:table;opacity: 1\">\nInclusive of fixed charges only</md-tooltip></div></div><div class=\"font-size-12 font-weight-600\" layout=\"row\" \nlayout-align=\"end center\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"pr-15 text-truncate\">\n{{ $ctrl.search_param.user.user_base_currency + \' \' + ( $ctrl.carddata.meta.card_total_cost | currencyMask: 2 ) }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ $ctrl.search_param.user.user_base_currency + \' \' + ( $ctrl.carddata.meta.card_total_cost | currencyMask: 2 ) }}\n</md-tooltip></span></div></div><div layout=\"row\" layout-wrap class=\"white-fg\"><div layout=\"row\" \nlayout-align=\"start center\" \nflex=\"{{ ((!$ctrl.util.userProfile.user.is_pricing_user && (!$ctrl.islastactivity || $ctrl.inquiryid.current_status.status ==  $ctrl.statusCondition) ) || $ctrl.util.userProfile.user.is_pricing_user || $ctrl.activitytype == \'BOOKING\' || $ctrl.util.isShipper) ? 100: 50}}\" \nclass=\"font-size-14 font-weight-600\"><md-button md-no-ink class=\"card-button details-button white-fg p-5\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event,\'quotation\',$ctrl.carddata.meta.type,$index,\'ViewDetails\')\" \ntitle=\"View details\" translate=\"VIEW DETAILS\">VIEW DETAILS</md-button></div><div layout=\"row\" layout-align=\"end\" \nflex=\"50\" flex-gt-xs=\"50\" class=\"font-size-14 font-weight-600\" \nng-if=\"!$ctrl.util.userProfile.user.is_pricing_user && ($ctrl.inquiryid.current_status.status != $ctrl.statusCondition && $ctrl.islastactivity) && !$ctrl.carddata.meta.is_selected && $ctrl.activitytype != \'BOOKING\' && !$ctrl.util.isShipper\">\n<md-button md-no-ink class=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-if=\"!$ctrl.util.isAdmin && !$ctrl.util.isFreightbro\" \nng-disabled=\"($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') || !$ctrl.util.navPermission.shipments[0] || $ctrl.resultfilter.generateQuoteBtn\" \nng-click=\"$ctrl.requestToBook($ctrl.carddata)\" title=\"Confirm Quote\" translate=\"BOOK_NOW\">CONFIRM QUOTE</md-button>\n<md-button md-no-ink class=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-if=\"$ctrl.util.isAdmin || $ctrl.util.isFreightbro\" \nng-disabled=\"($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') || !$ctrl.util.navPermission.quotes[0] || $ctrl.resultfilter.generateQuoteBtn\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.carddata,$event, \'quotation\', $ctrl.carddata.meta.type, null, \'AddToQuote\');\">\n{{($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry && $ctrl.util.getStatusData($ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj) === \'EXPIRED\') ? \'EXPIRED\' : \'ADD TO QUOTE\' }}\n</md-button></div><div layout=\"row\" layout-align=\"end\" flex=\"50\" flex-gt-xs=\"50\" class=\"font-size-14 font-weight-600\" \nng-if=\"((!$ctrl.util.userProfile.user.is_pricing_user && $ctrl.islastactivity) && $ctrl.carddata.meta.is_selected)\">\n<md-button md-no-ink class=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-disabled=\"!$ctrl.util.navPermission.quotes[0] || $ctrl.resultfilter.generateQuoteBtn\" \nng-click=\"$ctrl.removeCard($ctrl.carddata)\" title=\"Remove\" translate=\"REMOVE\">REMOVE</md-button></div></div></div>\n</div>");
$templateCache.put("app/main/Inquiry/components/inquiry-card/new-card.html","<ms-widget-front class=\"custom-rate-front dotted-border\" ng-style=\"{\'min-height\' : $ctrl.getWidgetHeight()}\"><div \nlayout=\"column\" layout-align=\"center center\" class=\"margin-auto\"><md-icon class=\"custom-add-icon pointer\" \nng-click=\"$ctrl.fnAddOrEditCard(\'\', \'newCardInquiry\', $event,\'AddNewRate\')\" \nmd-font-icon=\"icon-plus-circle-outline\n                            \"></md-icon><p class=\"add-rates\"><span>Add </span>\n<span class=\"font-weight-600\">RATES</span></p></div></ms-widget-front><ms-widget-back><div \nclass=\"custom-add-back new_card_back\"><div layout=\"row\" flex=\"100\" class=\"white-bg fg-333333\"><div \nclass=\"font-size-16 p-10\" flex=\"80\">ADD <b>NEW</b> RATE</div><div layout=\"row\" flex=\"20\" layout-align=\"end center\">\n<md-button md-no-ink class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s20\"></md-icon></md-button></div></div><div layout=\"row\" flex=\"100\" \nclass=\"font-weight-600 ph-10\"><div class=\"grey-fg mr-5\" layout=\"row\" layout-align=\"start center\">Liner Name <span \nclass=\"red-fg\">*</span></div><div flex layout=\"row\" layout-align=\"end end\"><div ng-if=\"!$ctrl.addCardData\" \nclass=\"loader\" style=\"margin-top: 12px !important; margin-right: 20px\"></div><md-input-container \nng-if=\"$ctrl.addCardData\" class=\"sort_input m-0 text-truncate\" md-no-float><md-select class=\"liner_dropdown bb\" \nng-if=\"$ctrl.search_param.mode != \'AIR\'\" \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor_id\" name=\"sub_vendor_id\" \nplaceholder=\"Select Liner Name\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.quoteNewCard.meta, $ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)\" \nmd-on-close=\"searchLiner = \'\'\"><md-select-header><input ng-model=\"searchLiner\" type=\"search\" \nplaceholder=\"Search Liner\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"subvendor in $ctrl.getSubvendor | orderBy:\'name\' | filter : {\'name\' : searchLiner} \" \nng-value=\"subvendor.id\" title=\"{{subvendor.name}}\">{{subvendor.name}}</md-option></md-select><md-select \nclass=\"liner_dropdown bb\" ng-if=\"$ctrl.search_param.mode == \'AIR\'\" \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline_code\" name=\"airline_code\" \nplaceholder=\"Select Airline Name\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.quoteNewCard.meta,$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj)\" \nmd-on-close=\"search_airline_liner = \'\'\"><md-select-header><input ng-model=\"search_airline_liner\" type=\"search\" \nplaceholder=\"Search Airline Name (IATA Code / Airline Prefix Code)\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"airline in $ctrl.getAirline | orderBy:\'air_line_name\' | multipleKey :search_airline_liner:{air_line_name:\'air_line_name\',airline_prefix:\'airline_prefix\',iata_code:\'iata_code\'}\" \nng-value=\"airline.airline_code\">\n{{airline.air_line_name}} ({{airline.iata_code ? airline.iata_code : \'-\'}} / {{airline.airline_prefix ? airline.airline_prefix : \'-\'}})\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"font-weight-600 ph-10 mt-5\"><div flex=\"50\" class=\"grey-fg\" layout=\"row\" layout-align=\"start center\">Expiry Date \n<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\" class=\"exp_date\"><date-picker \nflex class=\"date-filter\" is-editable=\"true\" is-disabled=\"false\" input-required=\"true\" input-name=\"\'expiryDate\'\" \ndate-placeholder=\"\'End Date\'\" full-border=\"false\" date-format=\"true\" min-date-value=\"$ctrl.expMaxDate\" \nmodel-value=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry\" \ncallback=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.expiry = value\"></date-picker></div></div>\n<div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mv-5\"><div flex=\"50\" class=\"grey-fg\" layout=\"row\" \nlayout-align=\"start center\">\nPort of {{ $ctrl.search_param.mode != \'AIR\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_origin ? \'Origin\' : \'Loading\' }}\n<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-autocomplete required \nmd-input-name=\"card_origin_wet_port\" md-selected-item=\"$ctrl.quoteNewCard.meta.port_data.origin_port_code\" \nmd-search-text=\"$ctrl.card_originWetPortSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originWetPortSearchText, $ctrl.search_param.mode, \'origin\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter {{ $ctrl.search_param.mode != \'AIR\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_origin ? \'Origin\' : \'Loading\' }} Port\" \nmd-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span class=\"item-metadata\">\n{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_originWetPortSearchText}}\" were found.</md-not-found><div \nng-messages=\"card_origin_wet_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mb-5\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" \nclass=\"grey-fg\" layout=\"row\" layout-align=\"start center\"><span>Mode of Origin Haulage<span class=\"red-fg\">*</span>\n</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-select class=\"liner_dropdown m-0 bb\" \nng-model=\"$ctrl.quoteNewCard.meta.haulage\" name=\"haulage\" placeholder=\"Select Origin Haulage\"><md-option \nng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></div></div><div \nlayout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mv-5\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_origin\"><div flex=\"50\" \nclass=\"grey-fg\" layout=\"row\" layout-align=\"start center\">Port of Loading<span class=\"red-fg\">*</span></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end end\"><md-autocomplete required md-input-name=\"card_origin_port\" \nmd-selected-item=\"$ctrl.quoteNewCard.meta.via_pol\" md-search-text=\"$ctrl.card_originSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originSearchText,$ctrl.search_param.mode, \'origin\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter Loading Port\" md-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span \nclass=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_originSearchText}}\" were found.</md-not-found><div \nng-messages=\"card_origin_port.$error\"><div ng-message=\"required\">This field is required</div></div></md-autocomplete>\n</div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mb-5\" \nng-if=\"$ctrl.search_param.mode != \'AIR\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination\"><div flex=\"50\" \nclass=\"grey-fg\" layout=\"row\" layout-align=\"start center\">Port of Discharge<span class=\"red-fg\">*</span></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end end\"><md-autocomplete required md-input-name=\"card_destination_port\" \nmd-selected-item=\"$ctrl.quoteNewCard.meta.via_pod\" md-search-text=\"$ctrl.card_destinationSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationSearchText,$ctrl.search_param.mode, \'destination\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter Discharge Port\" md-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span \nclass=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_destinationSearchText}}\" were found.</md-not-found><div \nng-messages=\"cardSearchForm.card_destination_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mb-5\" \nng-if=\"$ctrl.search_param.mode == \'SEA-FCL\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination\"><div \nflex=\"50\" class=\"grey-fg\" layout=\"row\" layout-align=\"start center\"><span>Mode of Destination Haulage<span \nclass=\"red-fg\">*</span></span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-select \nclass=\"liner_dropdown m-0 bb\" ng-model=\"$ctrl.quoteNewCard.meta.destination_haulage\" name=\"haulage\" \nplaceholder=\"Select Destination Haulage\"><md-option ng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">\n{{haulage}}</md-option></md-select></div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 ph-10 mb-5\"><div \nflex=\"50\" class=\"grey-fg\" layout=\"row\" layout-align=\"start center\">\nPort of {{ $ctrl.search_param.mode != \'AIR\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination ? \'Destination\' : \'Discharge\'}}\n<span class=\"red-fg\">*</span></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><md-autocomplete required \nmd-input-name=\"card_destination_wet_port\" md-selected-item=\"$ctrl.quoteNewCard.meta.port_data.destination_port_code\" \nmd-search-text=\"$ctrl.card_destinationWetSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationWetSearchText,$ctrl.search_param.mode, \'destination\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter {{ $ctrl.search_param.mode != \'AIR\' && $ctrl.quoteNewCard.meta.port_data.is_icd_port_destination ? \'Destination\' : \'Discharge\'}} Port\" \nmd-menu-class=\"autocomplete-custom-template\" class=\"bb\"><md-item-template><span class=\"item-metadata\">\n{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_destinationWetSearchText}}\" were found.</md-not-found><div \nng-messages=\"cardSearchForm.card_destination_wet_port.$error\"><div ng-message=\"required\">This field is required</div>\n</div></md-autocomplete></div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600 grey-200-bg mt-8 pt-8\"><div \nflex=\"50\" class=\"grey-fg pl-10\" layout=\"row\" layout-align=\"start center\">Rates By</div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"pr-20\">\n{{$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.vendor.vendor_name}}</div></div><div layout=\"row\" \nflex=\"100\" class=\"font-weight-600 grey-200-bg\"><div flex=\"50\" class=\"grey-fg pl-10\" layout=\"row\" \nlayout-align=\"start center\">Service Type</div><div flex=\"50\" layout=\"row\" layout-align=\"end end\" class=\"pr-10\">\n<md-input-container class=\"sort_input m-0 h-45\" md-no-float><input \nng-model=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.service_type\" placeholder=\"Service Type\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"font-weight-600\"><div flex=\"50\" \nclass=\"grey-fg pl-10\" layout=\"row\" layout-align=\"start center\">Cargo Type</div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end end\" class=\"pr-10\"><md-input-container class=\"m-0\" md-no-float><cargo-type-selection \ncargo-type-data=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.cargo_type_data\" is-required=\"false\" \nis-valid=\"false\" mode=\"$ctrl.search_param.mode\"></cargo-type-selection></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"font-weight-600\"><div flex=\"50\" class=\"grey-fg pl-10\" layout=\"row\" \nlayout-align=\"start center\">Commodity</div><div flex=\"50\" layout=\"row\" layout-align=\"end end\" class=\"pr-10\">\n<md-input-container class=\"m-0 full-width\" md-no-float><commodity-chips md-input-id=\"\'commodity_id_new-card\'\" \ncommodity-array=\"$ctrl.quoteNewCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.commodity_data\" is-valid=\"false\">\n</commodity-chips></md-input-container></div></div><div layout=\"column\" flex=\"100\" class=\"p-10\" \nng-if=\"!$ctrl.sell_rates_display\"><div layout=\"row\" flex=\"100\" class=\"mb-10\"><div flex=\"35\" \nclass=\"grey-fg font-weight-600\">Rates</div><div layout=\"row\" flex layout-align=\"end end\" class=\"grey-fg font-size-11\">\nChange this at any instance</div></div><md-button md-no-ink class=\"md-link-btn\" flex=\"100\" \nng-click=\"$ctrl.copyCard = false; $ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'addNewQuote\',\'msr_rates\')\">\nAdd Rates</md-button></div><div ng-if=\"$ctrl.sell_rates_display\"><div layout=\"row\" layout-wrap class=\"pv-8 ph-15\" \nng-repeat=\"(leg_key,leg_value) in $ctrl.quoteNewCard.data[$ctrl.buyOrSell]\" \nng-class=\"{\'h-50\' : leg_key == $ctrl.l3_leg }\"><div layout=\"column\" layout-align=\"center start\" flex=\"60\" \nflex-gt-xs=\"60\" ng-class=\"{\'text-truncate\' : leg_key != $ctrl.l3_leg}\"><span class=\"font-size-14 pr-2\" \nng-class=\"{\'text-truncate\' : leg_key == $ctrl.l3_leg}\"><md-icon class=\"icon-class\" \nmd-svg-src=\"{{ ( leg_key == $ctrl.l1_leg || leg_key == $ctrl.l2_leg || leg_key == $ctrl.l2_leg_cha || leg_key == $ctrl.l3_leg || leg_key == $ctrl.l4_leg || leg_key == $ctrl.l4_leg_cha || leg_key == $ctrl.l5_leg || leg_key == $ctrl.ins_leg ) ? \'assets/icons/custom/\' + leg_key +\'_card.svg\' : \'assets/icons/custom/l3_fcl-icon.svg\' }}\">\n</md-icon>\n{{ ( leg_key == $ctrl.l3_leg && leg_value.leg_name == $ctrl.mainFreightName ) ? \'Freight\' : leg_value.leg_name }} <span\n \nng-if=\"leg_key == $ctrl.l3_leg && leg_value.rate_obj.is_special && (leg_value.rate_obj.special_meta.normal_rate_total != undefined)\">\n<md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></span></span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"40\" flex-gt-xs=\"40\"><span \nclass=\"leg-cost-right text-truncate pr-2 font-size-14 font-weight-600 grey-800-fg\" \nng-class=\"{\'red-600-fg\' : (!leg_value.rate_obj), \'freight-fg\' : (leg_key == $ctrl.l3_leg), \'grey-800-fg\' : (leg_key != $ctrl.l3_leg)}\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask : 2) ) : \'N/A\' }}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask : 2) ) : \'NA\' }}\n</md-tooltip></span><span class=\"leg-cost-right pr-2 grey-500-fg font-weight-500 font-size-12 text-truncate\" \nng-if=\"leg_key == $ctrl.l3_leg && leg_value.rate_obj.is_special && (leg_value.rate_obj.special_meta.normal_rate_total != undefined)\">\n<strike>{{leg_value.rate_obj.leg_currency}} {{leg_value.rate_obj.special_meta.normal_rate_total | currencyMask : 2}}\n</strike></span></div></div></div><md-divider class=\"m-8\"></md-divider><div ng-show=\"$ctrl.search_param.mode == \'AIR\'\">\n<div layout=\"row\" layout-wrap class=\"pv-20\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\"><div \nclass=\"pl-15 font-size-16 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\"><p \ntitle=\"Schedule not available\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\" class=\"grey-fg mv-4\">\nSchedule not available.</p></div></div></div><div ng-show=\"$ctrl.search_param.mode !=\'AIR\'\"><div layout=\"column\" \nflex=\"100\" class=\"p-10\" ng-if=\"!$ctrl.schedule_display\"><div layout=\"row\" flex=\"100\" class=\"mb-10\"><div flex=\"30\" \nclass=\"grey-fg font-weight-600\">Schedule</div><div layout=\"row\" flex layout-align=\"end end\" \nclass=\"grey-fg font-size-11\">Always stay on time</div></div><md-button md-no-ink class=\"md-link-btn\" flex=\"100\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'schedule\',\'msr_rates\')\">Add Schedule</md-button></div><div \nng-if=\"$ctrl.schedule_display\"><div layout=\"row\" layout-wrap class=\"pv-8\" \nng-if=\"$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\"><div class=\"font-size-14\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\"><span class=\"ph-15 text-truncate\"><md-icon \nmd-svg-src=\"assets/icons/custom/shipping-details-icon.svg\" class=\"icon-class\" title=\"Routing\"></md-icon><span>\n{{$ctrl.quoteNewCard.meta.selected_schedule.via_port != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{$ctrl.quoteNewCard.meta.selected_schedule.via_port != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.via_port : \'N/A\'}}\n</md-tooltip></span></span></div><div class=\"pr-15 font-size-14\" layout=\"row\" layout-align=\"end center\" flex=\"40\" \nflex-gt-xs=\"40\"><span class=\"text-truncate\"><md-icon md-svg-src=\"assets/icons/custom/valid-icon.svg\" \nclass=\"icon-class\" title=\"Transit Time\"></md-icon>\n{{ $ctrl.quoteNewCard.meta.selected_schedule.transit_time != \'\' ? $ctrl.quoteNewCard.meta.selected_schedule.transit_time : \'N/A\' }}\n</span></div></div><div layout=\"row\" layout-wrap class=\"pv-8\" \nng-if=\"$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\"><div \nclass=\"pl-15 font-size-14 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"40\" flex-gt-xs=\"40\"><span \nclass=\"font-size-14\">Next sailing on</span></div><div class=\"font-size-14\" layout=\"row\" layout-align=\"end center\" \nflex=\"60\" flex-gt-xs=\"60\"><span title=\"Departure Time\" class=\"pr-15 text-truncate\">\n{{$ctrl.quoteNewCard.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy\'}}</span></div></div><div \nlayout=\"row\" layout-wrap class=\"pv-20\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule && $ctrl.l3_leg != \'l3_air\'\">\n<div class=\"pl-15 font-size-16 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\"><p \ntitle=\"Schedule not available\" ng-if=\"!$ctrl.quoteNewCard.meta.selected_schedule\" class=\"grey-fg mv-4\">\nSchedule not available.</p></div></div></div></div><div layout=\"row\" layout-wrap class=\"black-fg total-bg pv-10 mt-10\" \nng-if=\"$ctrl.sell_rates_display\"><div class=\"pl-15 font-size-14 font-weight-600 text-truncate\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\">Total Cost</div><div class=\"font-size-14 font-weight-600\" \nlayout=\"row\" layout-align=\"end center\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"text-truncate pr-15\">\n{{ $ctrl.searchUser.user_base_currency + \' \' + ( $ctrl.quoteNewCard.meta.card_total_cost | currencyMask : 2 ) }}\n<md-tooltip md-direction=\"top\" class=\"font-size-10\">\n{{ $ctrl.searchUser.user_base_currency + \' \' + ( $ctrl.quoteNewCard.meta.card_total_cost | currencyMask : 2 ) }}\n</md-tooltip></span></div></div><div layout=\"row\" layout-wrap class=\"white-fg add_to_quote_div\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"50\" flex-gt-xs=\"50\" class=\"font-size-14 font-weight-600\"><md-button md-no-ink \nclass=\"card-button details-button white-fg p-5\" ng-disabled=\"!$ctrl.quoteNewCard.meta.is_selected\" \nng-click=\"$ctrl.viewDetailsModal($ctrl.quoteNewCard,$event,\'addNewQuote\',\'msr_rates\')\" title=\"View details\">DETAILS\n</md-button></div><div layout=\"row\" layout-align=\"end\" flex=\"50\" flex-gt-xs=\"50\" class=\"font-size-14 font-weight-600\">\n<md-button md-no-ink class=\"card-button book-button md-accent-bg md-hue-1 white-fg p-5\" \nng-disabled=\"!$ctrl.quoteNewCard.meta.is_selected\" \nng-click=\"$ctrl.addInQuote($ctrl.quoteNewCard,\'newCard\');flipWidget()\" title=\"Remove\">DONE</md-button></div></div>\n</div></ms-widget-back>");
$templateCache.put("app/main/Inquiry/components/inquiry-filter/inquiryFilter.html","<div id=\"inquiry-filter\" layout=\"column\" layout-align=\"space-between center\"><div class=\"w-100p\"><div \nclass=\"pt-20 ph-20 pb-15\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon mr-10\"></md-icon><span \nclass=\"font-size-16 Font-Bold fg-AAA8AD\" flex>Filters </span><a \nclass=\"font-size-13 pointer md-link-fg font-weight-600 clear-btn\" ng-if=\"!$ctrl.filterLoader\" \nng-click=\"$ctrl.resetFilter();\">Clear All</a><md-icon ng-if=\"$ctrl.inquiryData.deviceName != \'laptop\'\" \nmd-font-icon=\"icon-close-circle-outline\" class=\"s20 pointer ml-5 md-link-fg\" ng-click=\"$ctrl.toggleSidenav(\'right\')\">\n</md-icon></div><md-divider></md-divider><div class=\"content no-padding\"><div shimmer-effect-full width=\"95%\" \nheight=\"30px\" mh=\"10px\" class=\"mv-20\" ng-if=\"$ctrl.filterLoader\" ng-repeat=\"shimmer in [1,2,3,4,5,6,7,8,9]\"></div>\n<md-list ng-if=\"!$ctrl.filterLoader\" class=\"no-padding\"><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb filter-width\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-10\"><div><span class=\"font-size-14 font-weight-600\">Status</span> \n<span ng-if=\"$ctrl.filterobj.status\" class=\"filter-count md-component-bg white-fg\">1</span></div></div><div \nid=\"inq_status\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><input \nng-model=\"searchStatus\" type=\"search\" ng-model-options=\"{debounce : 1000}\" placeholder=\"Search status\" \nclass=\"font-size-12 font-primary-fg input-search\" ng-keydown=\"$event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nclass=\"text-truncate status-label\" ng-repeat=\"status in $ctrl.filterListObject.status | filter: searchStatus\">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary radio-checkbox text-capitalize\" flex \nng-checked=\"$ctrl.filterobj.status.indexOf(status.status) > -1\" \nng-click=\"$ctrl.filterItemtoggle(status, $ctrl.filterobj, \'status\', \'radio\')\">{{status.status}}<md-tooltip \nmd-direction=\"right\" md-delay=\"300\" class=\"text-capitalize\">{{status.status}}</md-tooltip></md-checkbox></div></div>\n</div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.filterListObject.mode.length > 0\"><div layout=\"column\" flex class=\"ph-20 pt-15 bb filter-width\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">\nMode</span> <span ng-if=\"$ctrl.filterobj.mode.length\" class=\"filter-count md-component-bg white-fg\">\n{{$ctrl.filterobj.mode.length}}</span></div></div><div id=\"inq_mode\"><div class=\"font-size-14 black-fg\" \nng-repeat=\"mode in $ctrl.filterListObject.mode\"><md-checkbox md-no-ink=\"true\" class=\"md-primary\" \nng-checked=\"$ctrl.filterobj.mode.indexOf(mode) > -1\" \nng-click=\"$ctrl.filterItemtoggle(mode, $ctrl.filterobj, \'mode\', \'\')\">{{mode}}</md-checkbox></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.filterListObject.integrations.length > 0 && $ctrl.tms_enabled\"><div layout=\"column\" flex \nclass=\"ph-20 pt-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span\n class=\"font-size-14 font-weight-600\">TMS</span> <span ng-if=\"$ctrl.filterobj.integrations.length\" \nclass=\"filter-count md-component-bg white-fg\">{{$ctrl.filterobj.integrations.length}}</span></div></div><div \nid=\"inq_mode\"><div class=\"font-size-14 black-fg\" ng-repeat=\"status in $ctrl.filterListObject.integrations\"><md-checkbox\n md-no-ink=\"true\" class=\"md-primary\" ng-checked=\"$ctrl.filterobj.integrations.indexOf(status) > -1\" \nng-click=\"$ctrl.filterItemtoggle(status, $ctrl.filterobj, \'integrations\', \'\')\">{{status}}</md-checkbox></div></div>\n</div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span\n class=\"font-size-14 font-weight-600\">Date Range</span><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mb-2 grey-fg pointer\"><md-tooltip md-direction=\"right\" md-delay=\"300\">Created On</md-tooltip></md-icon><span\n ng-if=\"$ctrl.filterobj.date_range.from || $ctrl.filterobj.date_range.to\" \nclass=\"filter-count md-component-bg white-fg\">1</span></div></div><div id=\"inq_created\"><date-range-picker \nmd-input-id=\"\'inquiry_date_range\'\" callback=\"$ctrl.setDatePicker(date)\" date-range-value=\"$ctrl.filterobj.date_range\" \nis-reset-date-picker=\"$ctrl.inquiryData.isResetFilter\"></date-range-picker></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Created By</span> <span ng-if=\"$ctrl.createdByFilterConditions.selectedCount\" \nclass=\"filter-count md-component-bg white-fg\">{{$ctrl.createdByFilterConditions.selectedCount}}</span></div></div><div \nid=\"created_by\"><multi-select-chips md-input-id=\"\'created-by-filter\'\" page-source=\"\'IL-Filter-CreatedBy\'\" \noptions-data-obj=\"$ctrl.filterListObject.created_by\" query-conditions=\"$ctrl.createdByFilterConditions\" \ncallback=\"$ctrl.callBackCreatedBy(payload)\"></multi-select-chips></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"$ctrl.filterListObject.incoterms !== null\"><div\n layout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div>\n<span class=\"font-size-14 font-weight-600\">Incoterms</span> <span \nng-if=\"$ctrl.incoTermsFilterConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{$ctrl.incoTermsFilterConditions.selectedCount}}</span></div></div><div id=\"created_by\"><multi-select-chips \nmd-input-id=\"\'inco-terms-filter\'\" page-source=\"\'IL-Filter-IncoTerms\'\" \noptions-data-obj=\"$ctrl.filterListObject.incoterms\" query-conditions=\"$ctrl.incoTermsFilterConditions\" \ncallback=\"$ctrl.callBackIncoTerms(payload)\"></multi-select-chips></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.filterListObject.customer_details !== null\"><div layout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\">\n<div layout=\"row\" layout-align=\"space-between\" flex><div><span class=\"font-size-14 font-weight-600\">Customer Details\n</span> <span ng-if=\"$ctrl.customerFilterConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{$ctrl.customerFilterConditions.selectedCount}}</span></div></div><div id=\"customer_details\"><multi-select-chips \nmd-input-id=\"\'customer-details-filter\'\" page-source=\"\'IL-Filter-CustomerDetails\'\" \noptions-data-obj=\"$ctrl.filterListObject.customer_details\" query-conditions=\"$ctrl.customerFilterConditions\" \ncallback=\"$ctrl.callBackCustomer(payload)\"></multi-select-chips></div></div></md-list-item></md-list></div></div></div>");
$templateCache.put("app/main/Inquiry/components/inquiry-meta/inquiryMeta.html","<div id=\"inquiry-meta\" class=\"white-bg card_shadow ph-10\"><div class=\"pv-10\"><div class=\"p-8\"><div class=\"pl-10\"><div \nclass=\"heading pb-10\">Origin</div><div layout=\"row\" layout-wrap><div class=\"sub-heading text-truncate pr-5\" \nng-repeat=\"port in $ctrl.originPorts track by $index\"><md-icon class=\"w-10 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( port.place_type !== \'Door\' && !port.is_major_port && !port.is_icd_port) }\" \nmd-svg-src=\"{{port.icon}}\"></md-icon>{{port.location_string}}</div></div></div></div><div class=\"p-8\"><div \nclass=\"pl-10\"><div class=\"heading pb-10\">Destination</div><div layout=\"row\" layout-wrap><span \nclass=\"sub-heading text-truncate pr-5\" ng-repeat=\"port in $ctrl.destinationPorts track by $index\"><md-icon \nclass=\"w-10 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( port.place_type !== \'Door\' && !port.is_major_port && !port.is_icd_port) }\" \nmd-svg-src=\"{{port.icon}}\"></md-icon>{{port.location_string}}</span></div></div></div></div><div layout=\"row\" \nlayout-padding layout-wrap class=\"pv-10\"><div class=\"max-width-180\"><div class=\"heading\">Load Details</div><div \nclass=\"sub-heading text-truncate\">{{$ctrl.loadDispaly}}<md-tooltip ng-if=\"$ctrl.loadDispaly\" md-direction=\"top\" \nclass=\"font-size-12 tooltip-height\"><div compile-html=\"$ctrl.loadTooltip\"></div></md-tooltip></div></div><div \nclass=\"max-width-180\"><div class=\"heading\">Cut Off Date</div><div class=\"sub-heading text-truncate\" \ntitle=\"{{ $ctrl.metadetail.search_data.cargo_ready_date | NoTimeZone : \'d MMM yyyy\'}}\">\n{{ $ctrl.metadetail.search_data.cargo_ready_date | NoTimeZone : \'d MMM yyyy\'}}</div></div><div class=\"max-width-180\">\n<div class=\"heading\">Created On</div><div class=\"sub-heading text-truncate\" ng-if=\"$ctrl.metadetail.created_at\" \ntitle=\"{{$ctrl.metadetail.created_at | UTCToLocal : \'d MMM yyyy\'}}\">\n{{$ctrl.metadetail.created_at | UTCToLocal : \'d MMM yyyy\'}}</div><span class=\"sub-heading\" \nng-if=\"!$ctrl.metadetail.created_at\">N/A</span></div><div class=\"max-width-180\"><div class=\"heading\">Expires On</div>\n<div class=\"sub-heading red-300-fg text-truncate\" \ntitle=\"{{$ctrl.metadetail.inquiry_expiry_date | NoTimeZone : \'d MMM yyyy\' }}\">\n{{$ctrl.metadetail.inquiry_expiry_date | NoTimeZone : \'d MMM yyyy\' }}</div></div><div layout=\"row\" flex \nlayout-xs=\"column\" layout-align=\"end center\" layout-align-xs=\"end center\" class=\"pt-2\"><div \nclass=\"md-link-fg with-icon font-weight-600 font-size-12 mt-5 pointer\" ng-click=\"$ctrl.toggleViewMore()\">\n{{$ctrl.isViewMoreExpanded? \'View Less\':\'View More\'}}<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s18 margin-bottom-4 chevron\" ng-class=\"{\'chevron-rotate\': $ctrl.isViewMoreExpanded}\"></md-icon></div></div>\n</div><div class=\"hide-at-start\" id=\"view-more-div\" flex=\"100\"><div \nng-include=\"\'app/main/Inquiry/components/inquiry-meta/viewMore.html\'\"></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-padding layout-wrap class=\"pv-10\"><div><div class=\"heading\">Sales Person <span class=\"creator\" \nng-if=\"$ctrl.metadetail.user.id==$ctrl.metadetail.sales_user.id\">Creator</span></div><div \nclass=\"text-truncate sub-heading\" ng-if=\"$ctrl.metadetail.sales_user\" \ntitle=\"{{$ctrl.metadetail.sales_user.user_first_name}} {{$ctrl.metadetail.sales_user.user_last_name}}\">\n{{$ctrl.metadetail.sales_user.user_first_name}} {{$ctrl.metadetail.sales_user.user_last_name}}</div><div \nclass=\"sub-heading\" ng-if=\"!$ctrl.metadetail.sales_user\">N/A</div></div><div><div class=\"heading\">Customer<span \nclass=\"creator\" ng-if=\"$ctrl.metadetail.user.id==$ctrl.metadetail.shipper_user.id\">Customer name</span></div><div \nclass=\"sub-heading text-truncate\" \nng-if=\"$ctrl.metadetail.shipper_user && $ctrl.metadetail.shipper_user.user_first_name\">\n{{$ctrl.metadetail.shipper_user.user_first_name}} {{$ctrl.metadetail.shipper_user.user_last_name}} <span \nclass=\"font-size-11\">{{$ctrl.metadetail.shipper_user.company.company_name}}</span></div><div class=\"sub-heading\" \nng-if=\"!$ctrl.metadetail.shipper_user || !$ctrl.metadetail.shipper_user.user_first_name\">N/A</div></div><div><div \nclass=\"heading\">Search Reference</div><div class=\"sub-heading\" title=\"{{ $ctrl.metadetail.search_data.search_name }}\">\n{{ $ctrl.metadetail.search_data.search_name ? $ctrl.metadetail.search_data.search_name : \'N/A\' }}</div></div><div><div \nclass=\"heading\">Mode</div><div class=\"sub-heading\" title=\"{{$ctrl.metadetail.search_data.mode}}\">\n{{$ctrl.metadetail.search_data.mode}}</div></div><div><div class=\"heading\">Search Currency</div><div \nclass=\"sub-heading\" title=\"{{$ctrl.metadetail.search_data.search_currency }}\">\n{{$ctrl.metadetail.search_data.search_currency ? $ctrl.metadetail.search_data.search_currency : $ctrl.metadetail.search_data.user.user_base_currency}}\n</div></div></div></div>");
$templateCache.put("app/main/Inquiry/components/inquiry-meta/viewMore.html","<div id=\"view-more-inquiry-deatil-page\"><section><div layout=\"row\" class=\"ml-5 p-0\" layout-wrap layout-padding><div \nclass=\"w-170 black-fg text-bold\">Origin Services</div><div class=\"w-175 color-grey relative\" \nng-class=\"{\'inactive_clr\': !$ctrl.metadetail.search_data.origin_charges}\"><md-icon md-font-icon=\"icon-check\" \nclass=\"check-icon color-green\" ng-if=\"$ctrl.metadetail.search_data.origin_charges\"></md-icon><md-icon \nmd-font-icon=\"icon-close\" class=\"check-icon color-red\" ng-if=\"!$ctrl.metadetail.search_data.origin_charges\"></md-icon>\n<span ng-class=\"{\'text-bold\': $ctrl.metadetail.search_data.origin_charges}\">Origin Charges</span></div><div \nclass=\"w-240 color-grey relative\" ng-class=\"{\'inactive_clr\': !$ctrl.metadetail.search_data.origin_customs}\"><md-icon \nmd-font-icon=\"icon-check\" class=\"check-icon color-green\" ng-if=\"$ctrl.metadetail.search_data.origin_customs\"></md-icon>\n<md-icon md-font-icon=\"icon-close\" class=\"check-icon color-red\" ng-if=\"!$ctrl.metadetail.search_data.origin_customs\">\n</md-icon><span ng-class=\"{\'text-bold\': $ctrl.metadetail.search_data.origin_customs}\">Origin Customs Clearance</span>\n</div></div><div layout=\"row\" class=\"ml-5 p-0\" layout-wrap layout-padding><div class=\"w-170 black-fg text-bold\">\nDestination Services</div><div class=\"w-175 color-grey\" \nng-class=\"{\'inactive_clr\': !$ctrl.metadetail.search_data.destination_charges}\"><md-icon md-font-icon=\"icon-check\" \nclass=\"check-icon color-green\" ng-if=\"$ctrl.metadetail.search_data.destination_charges\"></md-icon><md-icon \nmd-font-icon=\"icon-close\" class=\"check-icon color-red\" ng-if=\"!$ctrl.metadetail.search_data.destination_charges\">\n</md-icon><span ng-class=\"{\'text-bold\': $ctrl.metadetail.search_data.destination_charges}\">Destination Charges</span>\n</div><div class=\"w-240 color-grey\" ng-class=\"{\'inactive_clr\': !$ctrl.metadetail.search_data.destination_customs}\">\n<md-icon md-font-icon=\"icon-check\" class=\"check-icon color-green\" \nng-if=\"$ctrl.metadetail.search_data.destination_customs\"></md-icon><md-icon md-font-icon=\"icon-close\" \nclass=\"check-icon color-red\" ng-if=\"!$ctrl.metadetail.search_data.destination_customs\"></md-icon><span \nng-class=\"{\'text-bold\': $ctrl.metadetail.search_data.destination_customs}\">Destination Customs Clearance</span></div>\n</div><div class=\"section-border\"></div></section><section><div layout=\"row\" flex=\"100\" class=\"ph-15\" layout-wrap><div \nlayout=\"column\" flex=\"70\" class=\"border-right\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"row\" layout-xs=\"column\" \nflex=\"100\"><div layout=\"column\" flex-gt-xs=\"20\" class=\"border-right\" layout-align=\"center\" \nng-if=\"$ctrl.metadetail.search_data.mode != \'SEA-LCL\'\"><div class=\"heading mb-5\">\nPreferred {{ $ctrl.metadetail.search_data.mode == \'AIR\' ? \'Airlines\' : \'Liners\' }}</div><div \nng-if=\"$ctrl.metadetail.search_data.mode == \'SEA-FCL\' && $ctrl.metadetail.search_data.carrier_preference.length\" \nclass=\"sub-heading\"><span ng-repeat=\"(key, data) in $ctrl.metadetail.search_data.carrier_preference track by $index\">\n{{data.name}} {{$ctrl.metadetail.search_data.carrier_preference.length===key+1?\'\':\', \'}}</span></div><div \nng-if=\"$ctrl.metadetail.search_data.mode == \'AIR\' && $ctrl.metadetail.search_data.airline_preference.length\" \nclass=\"sub-heading\"><span ng-repeat=\"(key, data) in $ctrl.metadetail.search_data.airline_preference track by $index\">\n{{data.air_line_name}} {{$ctrl.metadetail.search_data.airline_preference.length===key+1?\'\':\', \'}}</span></div><div>\n<span class=\"sub-heading\" \nng-if=\"$ctrl.metadetail.search_data.mode == \'SEA-FCL\' && !$ctrl.metadetail.search_data.carrier_preference.length\">N/A\n</span> <span class=\"sub-heading\" \nng-if=\"$ctrl.metadetail.search_data.mode == \'AIR\' && !$ctrl.metadetail.search_data.airline_preference.length\">N/A\n</span></div></div><div layout=\"row\" flex-gt-xs=\"70\" class=\"border-right pl-10\" layout-wrap layout-padding><div \nlayout=\"column\" flex=\"30\"><div class=\"mb-5 heading\">Cargo Type</div><div class=\"text-truncate sub-heading\" \ntitle=\" {{ $ctrl.metadetail.search_data.req_cargo_type_data.name }}\">\n{{ $ctrl.metadetail.search_data.req_cargo_type_data ? $ctrl.metadetail.search_data.req_cargo_type_data.name : \'NA\' }}\n</div></div><div layout=\"column\" flex><div class=\"mb-5 heading\">Commodity Name</div><div class=\"sub-heading\" \nng-if=\"$ctrl.metadetail.search_data.req_commodity_data.length\"><span class=\"font-size-12\" \nng-repeat=\"commodity in $ctrl.metadetail.search_data.req_commodity_data track by $index\">{{ commodity }} <span \nng-show=\"$ctrl.metadetail.search_data.req_commodity_data.length -1 > $index\">,</span></span></div><div \nng-if=\"!$ctrl.metadetail.search_data.req_commodity_data.length\" class=\"sub-heading\">N/A</div></div><div \nlayout=\"column\" flex=\"20\"><div class=\"mb-5 heading\">HS Code</div><div class=\"text-truncate sub-heading\" \ntitle=\"{{$ctrl.metadetail.search_data.hs_code?$ctrl.metadetail.search_data.hs_code:\'NA\'}}\">\n{{$ctrl.metadetail.search_data.hs_code?$ctrl.metadetail.search_data.hs_code:\'NA\'}}</div></div><div layout=\"column\" \nflex=\"15\" ng-if=\"$ctrl.metadetail.search_data.hazardous_material\"><div class=\"mb-5 heading\">IMCO Code</div><div \nng-if=\"$ctrl.hazardousImco\" class=\"text-truncate sub-heading\"><span class=\"font-weight-600\">\n{{$ctrl.hazardousImco.class_name}}</span><br><span class=\"gray-fg font-size-12\" \nng-repeat=\"list in $ctrl.hazardousImco.list track by $index\">{{list}}<br></span></div></div></div><div layout=\"row\" \nflex-gt-xs=\"20\" class=\"pl-20\" layout-wrap layout-padding><div layout=\"column\"><div class=\"mb-5 heading\">Insurance</div>\n<div class=\"sub-heading\" ng-if=\"$ctrl.metadetail.search_data.insurance_leg_cost\">\n{{$ctrl.metadetail.search_data.insurance_currency}} {{$ctrl.metadetail.search_data.insurance_leg_cost}}</div><div \nclass=\"sub-heading\" ng-if=\"!$ctrl.metadetail.search_data.insurance_leg_cost\">NA</div></div></div></div></div><div \nlayout=\"row\" layout-wrap layout-padding flex=\"30\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"column\" \nng-if=\"$ctrl.metadetail.search_data.hazardous_material\" flex-sm><div class=\"mb-5 heading\">MSDS Document</div><div \nclass=\"text-truncate\" \ntitle=\"{{$ctrl.metadetail.search_data.files[0].ref_name===\'MSDS\'?$ctrl.metadetail.search_data.files[0].file_name:$ctrl.metadetail.search_data.files[1].file_name}}\">\n<a \nng-href=\"{{$ctrl.util.sanitizeQueryParams($ctrl.metadetail.search_data.files[0].ref_name===\'MSDS\'?$ctrl.metadetail.search_data.files[0].url:$ctrl.metadetail.search_data.files[1].url)}}\" \nng-if=\"$ctrl.metadetail.search_data.files[0].ref_name===\'MSDS\'?$ctrl.metadetail.search_data.files[0].url:$ctrl.metadetail.search_data.files[1].url\" \ndownload target=\"_blank\" class=\"md-link-fg\" rel=\"noopener\">View MSDS Document </a><span class=\"sub-heading\" \nng-if=\"$ctrl.metadetail.search_data.files[0].ref_name===\'MSDS\'?!$ctrl.metadetail.search_data.files[0].url:!$ctrl.metadetail.search_data.files[1].url\">\nNA</span></div></div><div layout=\"column\" flex-sm><div class=\"mb-5 heading\">Other Documents</div><div \nclass=\"text-truncate\" \ntitle=\"{{$ctrl.metadetail.search_data.files[0].ref_name===\'other\'?$ctrl.metadetail.search_data.files[0].file_name:$ctrl.metadetail.search_data.files[1].file_name}}\">\n<a \nng-if=\"$ctrl.metadetail.search_data.files[0].ref_name===\'other\'?$ctrl.metadetail.search_data.files[0].url:$ctrl.metadetail.search_data.files[1].url\" \nng-href=\"{{$ctrl.util.sanitizeQueryParams($ctrl.metadetail.search_data.files[0].ref_name===\'other\'?$ctrl.metadetail.search_data.files[0].url:$ctrl.metadetail.search_data.files[1].url)}}\" \ndownload target=\"_blank\" rel=\"noopener\" class=\"md-link-fg\"><span>View Other Documents</span> </a><span \nclass=\"sub-heading\" \nng-if=\"$ctrl.metadetail.search_data.files[0].ref_name===\'other\'?!$ctrl.metadetail.search_data.files[0].url:!$ctrl.metadetail.search_data.files[1].url\">\nNA</span></div></div></div></div><div class=\"section-border\"></div></section><section><div layout=\"row\" layout-padding \nlayout-wrap class=\"pv-10\"><div><div class=\"heading\">Email</div><div class=\"text-truncate sub-heading\" \nng-if=\"$ctrl.metadetail.shipper_user.email\" title=\"{{$ctrl.metadetail.shipper_user.email}}\" \nng-bind=\"$ctrl.metadetail.shipper_user ? $ctrl.metadetail.shipper_user.email : \'NA\'\"></div><div class=\"sub-heading\" \nng-if=\"!$ctrl.metadetail.shipper_user.email\">NA</div></div><div><div class=\"heading\">Contact Number</div><div \nng-if=\"$ctrl.metadetail.shipper_user.user_mobile\" class=\"text-truncate sub-heading\" \ntitle=\"{{$ctrl.metadetail.shipper_user.user_mobile}}\" \nng-bind=\"$ctrl.metadetail.shipper_user ? $ctrl.metadetail.shipper_user.user_mobile : \'NA\'\"></div><div \nclass=\"sub-heading\" ng-if=\"!$ctrl.metadetail.shipper_user.user_mobile\">NA</div></div><div><div class=\"heading\">\nSales Coordinator</div><div class=\"sub-heading\" ng-if=\"$ctrl.metadetail.sales_coordinator\" \ntitle=\"{{$ctrl.metadetail.sales_coordinator.user_first_name}} {{$ctrl.metadetail.sales_coordinator.user_last_name}}\">\n{{$ctrl.metadetail.sales_coordinator.user_first_name}} {{$ctrl.metadetail.sales_coordinator.user_last_name}}</div><div \nclass=\"sub-heading\" ng-if=\"!$ctrl.metadetail.sales_coordinator\">N/A</div></div><div><div class=\"heading\">Incoterms\n</div><div layout=\"row\" class=\"sub-heading\"><div \ntitle=\"{{ $ctrl.metadetail.search_data.inco_term ? $ctrl.metadetail.search_data.inco_term : \'N/A\' }}\" \nng-bind=\"$ctrl.metadetail.search_data.inco_term ? $ctrl.metadetail.search_data.inco_term : \'N/A\'\"></div><div \nng-if=\"$ctrl.metadetail.search_data.impo_expo && $ctrl.metadetail.search_data.inco_term\">\n- {{$ctrl.metadetail.search_data.impo_expo}}</div></div></div><div><div class=\"heading\">Stuffing</div><div \nclass=\"sub-heading\" ng-if=\"$ctrl.metadetail.search_data.stuffing\" \ntitle=\"{{$ctrl.metadetail.search_data.stuffing == \'D\' ? \'Dock\' : \'Factory\' }}\">\n{{$ctrl.metadetail.search_data.stuffing == \'D\' ? \'Dock\' : \'Factory\' }}</div><div class=\"sub-heading\" \nng-if=\"!$ctrl.metadetail.search_data.stuffing\">N/A</div></div><div><div class=\"heading\">Detention Free Days</div><div \nclass=\"sub-heading\" \ntitle=\"{{$ctrl.metadetail.rfq_data.demurrage_detention ? ($ctrl.metadetail.rfq_data.demurrage_detention+ \' Days\') : \'N/A\'}}\">\n{{$ctrl.metadetail.rfq_data.demurrage_detention ? ($ctrl.metadetail.rfq_data.demurrage_detention+ \' Days\') : \'N/A\'}}\n</div></div></div></section></div>");
$templateCache.put("app/main/Inquiry/components/portTravellerUi/portTravellerUi.html","<div id=\"port-to-port\"><div class=\"steps\"><ul class=\"steps-list\"><li class=\"steps-list-item\"><div layout=\"row\" \nclass=\"steps-list-item-timeline\" layout-align=\"center center\"><md-icon md-svg-icon=\"assets/icons/custom/ship-fill.svg\" \nclass=\"mb-10 mh-0 h-10\" ng-show=\"$ctrl.portDetails.mode != \'AIR\'\"></md-icon><md-icon \nmd-svg-icon=\"assets/icons/custom/roll-o-plane.svg\" class=\"mb-10 mh-0 h-10\" ng-show=\"$ctrl.portDetails.mode == \'AIR\'\">\n</md-icon></div><span class=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.portDetails.origin_port.global_port_code\">{{ $ctrl.portDetails.origin_port.global_port_code }} <span \nng-if=\"$ctrl.portDetails.origin_port.portname\">| </span>{{$ctrl.portDetails.origin_port.portname}} <span \nng-if=\"$ctrl.portDetails.origin_port.pickup_pincode_ui\">| </span></span><span \nng-if=\"$ctrl.portDetails.origin_port.pickup_pincode_ui\">{{ $ctrl.portDetails.origin_port.pickup_pincode_ui }}</span>\n</div><div class=\"city-text\"><span ng-if=\"$ctrl.portDetails.origin_port.city\">{{$ctrl.portDetails.origin_port.city }} \n<span ng-if=\"$ctrl.portDetails.origin_port.country\">, </span></span><span \nng-if=\"$ctrl.portDetails.origin_port.country\">{{ $ctrl.portDetails.origin_port.country }}</span></div><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nclass=\"Font-Medium\">Origin</div><div class=\"Font-Bold\">{{$ctrl.portDetails.origin_port.portname}} <span \nng-if=\"$ctrl.portDetails.origin_port.country\">{{ $ctrl.portDetails.origin_port.country }}</span></div></md-tooltip>\n</div></li><li class=\"steps-list-item\" \nng-if=\"!$ctrl.portDetails.delivery.delivery_location && !$ctrl.portDetails.delivery.delivery_pincode_ui\"><span \nclass=\"hrLine\"></span><div class=\"li-div\"><div class=\"port-text\"><span \nng-if=\"$ctrl.portDetails.destination_port.global_port_code\">{{ $ctrl.portDetails.destination_port.global_port_code }}\n<span ng-if=\"$ctrl.portDetails.destination_port.portname\"> | </span>{{$ctrl.portDetails.destination_port.portname}} \n<span ng-if=\"$ctrl.portDetails.destination_port.delivery_pincode_ui\">| </span></span><span \nng-if=\"$ctrl.portDetails.destination_port.delivery_pincode_ui\">\n{{ $ctrl.portDetails.destination_port.delivery_pincode_ui }}</span></div><div class=\"city-text\"><span \nng-if=\"$ctrl.portDetails.destination_port.city\">{{$ctrl.portDetails.destination_port.city }} <span \nng-if=\"$ctrl.portDetails.destination_port.country\">, </span></span><span \nng-if=\"$ctrl.portDetails.destination_port.country\">{{ $ctrl.portDetails.destination_port.country }}</span></div>\n<md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\n<div class=\"Font-Medium\">Destination</div><div class=\"Font-Bold\">{{$ctrl.portDetails.destination_port.portname}} <span \nng-if=\"$ctrl.portDetails.destination_port.country\">{{ $ctrl.portDetails.destination_port.country }}</span></div>\n</md-tooltip></div></li></ul></div></div>");
$templateCache.put("app/main/Inquiry/sidenav/activity-monitor/activity-monitor.html","<md-list><md-list-item class=\"mb-5 activity_monitor\" layout=\"row\" layout-align=\"start center\" flex><span flex \nclass=\"font-size-16 pt-5\"><img src=\"assets/icons/custom/sharing-connections.jpg\" width=\"20\" height=\"20\" \nclass=\"mt-5 mr-15\"><b>ACTIVITY </b>MONITOR</span><md-icon md-font-icon=\"icon-close\" class=\"s22 pointer\" \nng-click=\"vm.toggleSideNav(\'right\')\"></md-icon></md-list-item></md-list><div class=\"content pt-20\"><md-list ms-scroll>\n<md-list-item layout=\"row\" flex><div layout=\"column\" flex=\"100\" class=\"activity_list\"><div layout=\"column\" flex=\"100\" \nng-repeat=\"activity in [1,2,3] track by $index\"><div layout=\"row\" flex=\"100\"><div flex=\"15\" layout=\"column\" \nlayout-align=\"start center\" class=\"pt-2\"><span class=\"circle small\"></span> <span class=\"line-height-20\" \nng-if=\"!$last\"></span></div><div flex layout=\"column\"><span class=\"font-size-12 text-truncate\"><span \nclass=\"md-primary-fg font-weight-600\">#JNC2839</span> Status changed to “Quoted”<md-tooltip md-direction=\"top\" \nclass=\"font-size-12\">#JNC2839 Status changed to “Quoted”</md-tooltip></span><span \nclass=\"font-weight-500 grey-600-fg font-size-10 mt-5\"><span><md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s8 purple-fg\"></md-icon><span class=\"purple-fg\">Quoted</span> </span><span class=\"ml-8 pl-8 bl\">20 mins</span>\n</span></div></div></div></div></md-list-item></md-list></div>");
$templateCache.put("app/main/analytics/views/dashboard-shipment/dashboard-shipment.html","<div id=\"shipments-tab\" layout=\"column\" class=\"dashboard-card\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\" layout-align-xs=\"start start\" class=\"grey-600-fg p-20\" layout-padding><div \nclass=\"font-size-18 text-capitalize\"><b>quick</b> filter</div><div layout=\"row\" layout-align=\"end center\" \nlayout-align-xs=\"start center\"><div flex-gt-sm class=\"date-picker-row\"><label>From</label><date-picker flex \nclass=\"date-filter mt-10\" md-input-id=\"\'start shipment\'\" is-editable=\"false\" is-disabled=\"false\" \ninput-required=\"false\" input-name=\"\'start shipment\'\" date-placeholder=\"\'Start Date\'\" full-border=\"false\" \ndate-format=\"true\" max-date-value=\"vm.amChartShipmentEndDate || vm.defaultMaxDate\" \nmodel-value=\"vm.amChartShipmentStartDate\" callback=\"vm.amChartShipmentStartDate = value;vm.datechangeStartShipment()\">\n</date-picker></div><div flex-gt-sm class=\"date-picker-row ml-20\"><label>To</label><date-picker flex \nclass=\"date-filter mt-10\" md-input-id=\"\'end shipment\'\" is-editable=\"false\" is-disabled=\"false\" input-required=\"false\" \ninput-name=\"\'end shipment\'\" date-placeholder=\"\'End Date\'\" full-border=\"false\" date-format=\"true\" \nmin-date-value=\"vm.amChartShipmentStartDate\" max-date-value=\"vm.defaultMaxDate\" \nmodel-value=\"vm.amChartShipmentEndDate\" callback=\"vm.amChartShipmentEndDate = value;vm.datechangeStartShipment()\">\n</date-picker></div></div></div><md-divider></md-divider><div layout=\"row\" layout-xs=\"column\" class=\"filter-wrapper\">\n<div layout=\"row\" flex layout-wrap><md-select ng-if=\"vm.userList && vm.userList.length\" \nmd-on-close=\"vm.filterShipmentOnClose()\" ng-model=\"vm.selectedShipmentUser\" placeholder=\"Employees\" \nmd-on-close=\"userSearchTerm = \'\'\" class=\"dashboard-select pl-10 pr-5 ml-20 h-36\" \ndata-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"userSearchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" placeholder=\"Search User\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"user\"><md-option ng-value=\"user.id\" \nng-repeat=\"user in vm.userList | filter: {\'name\':userSearchTerm}\">{{user.name}}</md-option></md-optgroup></md-select>\n<md-select ng-model-options=\"{debounce : 500}\" ng-if=\"vm.shipmentCompanyList\" \nmd-on-close=\"vm.filterShipmentOnClose();\" ng-model=\"vm.selectedShipmentCompany\" placeholder=\"Customers\" \nclass=\"dashboard-select pl-10 pr-5 ml-20\" data-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"companySearchTerm\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\" placeholder=\"Search Customer\" class=\"demo-header-searchbox md-text\" \nng-change=\"vm.getCompanyList(companySearchTerm,\'SHIPMENT\')\"></md-select-header><div layout=\"column\" flex=\"100\" \nlayout-wrap layout-align=\"center center\" class=\"mv-20 pt-10\" ng-if=\"vm.listLoader\"><md-progress-circular>\n</md-progress-circular></div><md-optgroup label=\"company\" ng-hide=\"vm.listLoader\"><md-option ng-value=\"company.id\" \nng-repeat=\"company in vm.shipmentCompanyList\">{{company.company_name}}</md-option></md-optgroup></md-select><md-select \nng-if=\"vm.teamList && vm.teamList.length\" md-on-close=\"vm.filterShipmentOnClose()\" ng-model=\"vm.selectedShipmentTeam\" \nplaceholder=\"Team\" md-on-close=\"teamSearchTerm = \'\'\" class=\"dashboard-select pl-10 pr-5 ml-20\" \ndata-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"teamSearchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" placeholder=\"Search Team\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"team\"><md-option ng-value=\"team._id\" \nng-repeat=\"team in vm.teamList | filter: {\'name\':teamSearchTerm}\">{{team.name}}</md-option></md-optgroup></md-select>\n<md-select ng-if=\"vm.tagList && vm.tagList.length\" md-on-close=\"vm.filterShipmentOnClose()\" \nng-model=\"vm.selectedShipmentTag\" placeholder=\"Tag\" md-on-close=\"tagSearchTerm = \'\'\" \nclass=\"dashboard-select pl-10 pr-5 ml-20\" data-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"tagSearchTerm\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\" placeholder=\"Search Tag\" class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"tag\"><md-option ng-value=\"tag._id\" ng-repeat=\"tag in vm.tagList | filter: {\'name\':tagSearchTerm}\">{{tag.name}}\n</md-option></md-optgroup></md-select><md-select md-on-close=\"vm.filterShipmentOnClose()\" \nng-model=\"vm.selectedModeShipment\" placeholder=\"Mode\" class=\"dashboard-select pl-10 pr-5 ml-20\" multiple=\"multiple\">\n<md-option value=\"SEA-FCL\">SEA-FCL</md-option><md-option value=\"SEA-LCL\">SEA-LCL</md-option><md-option value=\"AIR\">AIR\n</md-option></md-select></div></div></div><div layout-sm=\"column\" layout-xs=\"column\" layout=\"row\" \nclass=\"dashboard-card custom_scroll\"><div flex=\"25\" class=\"grey-500-fg analytics-menu\"><div \nclass=\"font-size-12 mt-40 ml-40 grey-600-fg text-capitalize\"><b>analytics</b></div><div layout-sm=\"row\" \nlayout-xs=\"row\" class=\"small-screen-menu-container\"><div layout-xs=\"row\" layout-sm=\"row\" \nclass=\"ml-40 small-screen-menu mt-20 font-weight-600 font-size-16 pointer\" \nng-click=\"vm.shipmentActiveAnalyticsTab = \'breakdown\'; vm.updateTable(\'breakdownShipment\');\" \nng-class=\"{\'active-color\': vm.shipmentActiveAnalyticsTab === \'breakdown\'}\"><md-icon md-font-icon=\"icon-restore\" \nclass=\"s24 grey-500-fg mr-10\" ng-class=\"{\'md-link-fg\': vm.shipmentActiveAnalyticsTab === \'breakdown\'}\"></md-icon><span>\nBreakdown</span></div><div layout-xs=\"row\" layout-sm=\"row\" \nclass=\"ml-40 small-screen-menu mt-20 font-weight-600 font-size-16 pointer\" \nng-click=\"vm.shipmentActiveAnalyticsTab = \'insights\'; vm.updateTable(\'insightsShipment\');\" \nng-class=\"{\'active-color\': vm.shipmentActiveAnalyticsTab === \'insights\'}\"><md-icon md-font-icon=\"icon-equal-box\" \nclass=\"s24 grey-500-fg mr-10\" ng-class=\"{\'md-link-fg\': vm.shipmentActiveAnalyticsTab === \'insights\'}\"></md-icon><span>\nInsights</span></div><div layout-xs=\"row\" layout-sm=\"row\" \nclass=\"ml-40 small-screen-menu mt-20 font-weight-600 font-size-16 pointer\" \nng-click=\"vm.shipmentActiveAnalyticsTab = \'performance\'; vm.updateTable(\'performanceShipment\');\" \nng-class=\"{\'active-color\': vm.shipmentActiveAnalyticsTab === \'performance\'}\"><md-icon \nmd-font-icon=\"icon-chart-histogram\" class=\"s24 grey-500-fg mr-10\" \nng-class=\"{\'md-link-fg\': vm.shipmentActiveAnalyticsTab === \'performance\'}\"></md-icon><span>Performance</span></div>\n</div></div><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"80\" flex-sm=\"100\" \nflex-xs=\"100\"><div ng-if=\"!vm.noDataShipmentError\" id=\"shipmentchartdiv\" style=\"height: 320px\" flex=\"50\" flex-md=\"70\" \nflex-sm=\"70\" flex-xs=\"70\" ng-show=\"vm.shipmentActiveAnalyticsTab === \'breakdown\' && vm.shipmentStatsData.length\"></div>\n<div class=\"y-scroll\" flex=\"50\" flex-md=\"90\" flex-sm=\"90\" flex-xs=\"90\" \nng-show=\"vm.shipmentActiveAnalyticsTab === \'breakdown\' && vm.shipmentStatsData.length && !vm.shipmentStatusShimmer\">\n<div class=\"grey-500-fg font-size-24 mt-20 ml-40 mb-10 text-center text-capitalize\"><b>breakdown</b> data</div><div \nid=\"shipmentlegenddiv\" class=\"shipmentlegenddiv\"></div></div><div flex=\"100\" flex-md=\"90\" flex-sm=\"90\" flex-xs=\"90\" \nshimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"vm.shipmentActiveAnalyticsTab === \'breakdown\' && vm.shipmentStatusShimmer\" class=\"b white-bg mt-20\"></div><div\n flex=\"70\" ng-if=\"vm.shipmentActiveAnalyticsTab === \'breakdown\' && (vm.shipmentStatusError || vm.noDataShipmentError)\">\n<div class=\"grey-500-fg font-size-24 mt-60 ml-40 mb-10\">No data available!</div></div><div flex=\"70\" flex-md=\"70\" \nflex-sm=\"70\" flex-xs=\"70\" ng-show=\"vm.shipmentActiveAnalyticsTab === \'insights\' && vm.shipmentInsightData.length\"><div \nclass=\"graph-overflow\"><md-radio-group ng-model=\"vm.shipmentDateGroup\" \nclass=\"date-range font-size-13 pt-25 pl-5 ml-15\" layout=\"row\" layout-align=\"center end\" flex \nng-change=\"vm.shipmentDateGroupChange(vm.shipmentDateGroup)\"><md-radio-button md-no-ink value=\"daily\" \nclass=\"md-primary font-size-13 radio-btn\">Daily</md-radio-button><md-radio-button md-no-ink value=\"weekly\" \nclass=\"md-primary font-size-13 radio-btn\">Weekly</md-radio-button><md-radio-button md-no-ink value=\"monthly\" \nclass=\"md-primary font-size-13 radio-btn\">Monthly</md-radio-button><md-radio-button md-no-ink value=\"quaterly\" \nclass=\"md-primary font-size-13 radio-btn\">Quaterly</md-radio-button></md-radio-group><div \nng-if=\"!vm.noDataShipmentError\" id=\"shipmentbarchartdiv\" class=\"mt-65\"></div></div></div><div class=\"y-scroll\" \nflex=\"30\" flex-md=\"30\" flex-sm=\"90\" flex-xs=\"90\" \nng-show=\"vm.shipmentActiveAnalyticsTab === \'insights\' && vm.shipmentInsightData.length && !vm.shipmentInsightsShimmer\">\n<div class=\"grey-500-fg font-size-24 text-uppercase mt-20 ml-40 mb-10 text-center\"><b>insights</b> data</div><div \nid=\"shipmentbarlegenddiv\" class=\"shipmentbarlegenddiv\"></div></div><div flex=\"100\" flex-md=\"90\" flex-sm=\"90\" \nflex-xs=\"90\" shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"vm.shipmentActiveAnalyticsTab === \'insights\' && vm.shipmentInsightsShimmer\" class=\"b white-bg mt-20\"></div>\n<div flex=\"70\" \nng-if=\"vm.shipmentActiveAnalyticsTab === \'insights\' && (vm.shipmentInsightsError || vm.noDataShipmentError) && !vm.shipmentInsightsShimmer\">\n<div class=\"grey-500-fg font-size-24 mt-60 ml-40 mb-10\">No data available!</div></div><div flex=\"70\" flex-md=\"70\" \nflex-sm=\"70\" flex-xs=\"70\" \nng-show=\"vm.shipmentActiveAnalyticsTab === \'performance\' && vm.shipmentPerformanceData.length\"><div \nclass=\"graph-overflow\"><div ng-if=\"!vm.noDataShipmentError\" id=\"shipmentperformancechartdiv\" class=\"mt-45\"></div></div>\n</div><div flex=\"30\" flex-md=\"30\" flex-sm=\"90\" flex-xs=\"90\" \nng-show=\"vm.shipmentActiveAnalyticsTab === \'performance\' && vm.shipmentPerformanceData.length && !vm.shipmentPerformanceShimmer\">\n<div class=\"grey-500-fg font-size-24 text-uppercase mt-60 ml-40 mb-10 text-center\"><b>performance</b> data</div><div \nid=\"shipmentperformancelegenddiv\"></div></div><div flex=\"100\" flex-md=\"90\" flex-sm=\"90\" flex-xs=\"90\" shimmer-effect \nwidth=\"100%\" height=\"100%\" ng-show=\"vm.shipmentActiveAnalyticsTab === \'performance\' && vm.shipmentPerformanceShimmer\" \nclass=\"b white-bg mt-20\"></div><div flex=\"70\" \nng-if=\"vm.shipmentActiveAnalyticsTab === \'performance\' && (vm.shipmentPerformanceError || vm.noDataShipmentError) && !vm.shipmentPerformanceShimmer\">\n<div class=\"grey-500-fg font-size-24 mt-60 ml-40 mb-10\">No data available!</div></div></div></div><div \nclass=\"dashboard-cardui p-25\"><div ng-show=\"!vm.tableShimmer && !vm.tableError && !vm.noDataShipmentError\" \nclass=\"overflow-horizontal-scroll\"><div layout=\"row\" layout-align=\"start center\"><input ng-model=\"searchText\" \nng-change=\"vm.uiTableFilterShipment(searchText)\" class=\"ui-filter-search mb-15\" placeholder=\"Search...\"></div><div \nng-style=\"vm.maxWidth\" layout-align-xs=\"center center\" ui-grid=\"gridOptions2\" class=\"grid overflow-horizontal-scroll\" \nui-grid-pagination></div></div><div shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"vm.tableShimmer && !vm.noDataShipmentError\" class=\"b white-bg mt-20\"></div><div \nng-if=\"vm.tableError && !vm.tableShimmer\" layout=\"row\" layout-align=\"center center\" \nclass=\"grey-500-fg font-size-24 mt-60 ml-40 mb-10\">No data available!</div></div>");
$templateCache.put("app/main/banner/dialogs/bannerForm/banner_form.html","<md-dialog id=\"create-banner\" class=\"shipper popup-lg\"><md-toolbar class=\"modal_title bg-E5E7EB black-fg\"><div \nclass=\"md-toolbar-tools\"><div>{{ctrl.parent.bannerInfo.form_heading}} Banner</div><span flex></span><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog(\'CloseBy Icon\')\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><form name=\"banners_form\" \nautocomplete=\"off\"><md-dialog-content class=\"body\"><div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div \nlayout=\"column\" flex=\"20\" layout-xs=\"column\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label \nclass=\"Font-Bold\">Banner Name</label><md-input-container class=\"input_container max-w-350\" md-no-float><input \nid=\"banner_name\" class=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.bannerNameValidation}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.name\" name=\"banner_name\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.name) ? \'N/A\' : \'Enter Banner name\' }} \" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" ng-keyup=\"ctrl.parent.bannerNameValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-Name-Change\',ctrl.parent.bannerInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"banners_form.banner_name.$error\" role=\"alert\"><div ng-if=\"ctrl.parent.bannerNameValidation\" \nclass=\"validation-error-text\"><span>Enter Banner Name</span></div></div></md-input-container></div><div \nlayout=\"column\" flex=\"20\" layout-xs=\"column\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label \nclass=\"Font-Bold\">Banner Description</label><md-input-container class=\"input_container max-w-350\" md-no-float><input \nid=\"banner_description\" class=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.bannerDescriptionValidation}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.description\" name=\"banner_description\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.description) ? \'N/A\' : \'Enter Banner Description\' }} \" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" ng-keyup=\"ctrl.parent.bannerDescriptionValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-Description-Change\',ctrl.parent.bannerInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"banners_form.banner_description.$error\" role=\"alert\"><div ng-if=\"ctrl.parent.bannerDescriptionValidation\" \nclass=\"validation-error-text\"><span>Enter Banner Description</span></div></div></md-input-container></div><div \nflex=\"20\"></div><div layout=\"column\" flex=\"20\" layout-xs=\"column\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\">\n<label class=\"Font-Bold\">Domain</label><md-input-container class=\"input_container\" md-no-float><md-select \nmultiple=\"multiple\" md-no-asterisk class=\"panel-select\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.domainValidation}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.domain\" name=\"banner_domain\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.domain) ? \'N/A\' : \'Select Domain\' }}\" \nmd-on-close=\"searchDomain = \'\'\" ng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" \nmd-on-open=\"ctrl.parent.domainValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-Domain-Change\',ctrl.parent.bannerInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-select-header><input ng-model=\"searchDomain\" type=\"search\" placeholder=\"Search Domain\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"\"><md-option \nng-repeat=\"domain in ctrl.parent.domainList |  filter : {\'company_name\': searchDomain} | orderBy:\'company_name\'\" \nng-value=\"domain.domain\">{{domain.company_name}}</md-option></md-optgroup></md-select><div \nng-if=\"ctrl.parent.domainValidation\" class=\"validation-error-text\"><span>Select the Domain</span></div>\n</md-input-container></div><div layout=\"column\" flex=\"20\" layout-xs=\"column\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><label class=\"Font-Bold\">User Type</label><md-input-container \nclass=\"input_container\" md-no-float><md-select class=\"panel-select multi-select-width\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.userTypeValidation}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.user_type\" name=\"user_type\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.user_type) ? \'N/A\' : \'Select User Type\' }}\" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-userType-Change\', ctrl.parent.bannerInfo.form_heading)\" \nmd-on-open=\"ctrl.parent.userTypeValidation=false\"><md-option value=\"ALL\">All</md-option><md-option value=\"FORWARDER\">\nInternal</md-option><md-option value=\"SHIPPER\">Customer</md-option></md-select><div \nng-if=\"ctrl.parent.userTypeValidation\" class=\"validation-error-text\"><span>Select the User Type</span></div>\n</md-input-container></div></div><div class=\"info-label\" layout=\"row\" flex=\"100\"><div flex=\"10\">Banner Details</div>\n<div flex=\"90\" class=\"bb\"></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div \nlayout=\"row\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\" layout-align=\"start center\"><label flex=\"20\" \nclass=\"Font-Bold\">Banner Icon</label><md-input-container class=\"input_container\" flex=\"60\" md-no-float><md-select \nmd-no-asterisk class=\"panel-select\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.iconValidation}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.theme.icon\" name=\"banner_icon\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.data.theme.icon) ? \'N/A\' : \'Select Icon\' }}\" \nmd-on-close=\"searchIcon = \'\'\" ng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" \nmd-on-open=\"ctrl.parent.iconValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-Icon-Change\',ctrl.parent.bannerInfo.form_heading )\" \nng-model-options=\"{trackBy: \'$value.font_class\',updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-select-header><input ng-model=\"searchIcon\" type=\"search\" placeholder=\"Search Icon\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"\"><md-option \nng-repeat=\"icon in ctrl.parent.iconList |  filter : {\'name\': searchIcon} | orderBy:\'name\'\" ng-value=\"icon\"><div \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{icon.font_class}}\" class=\"s20 icon\"></md-icon>{{icon.name}}</div>\n</md-option></md-optgroup></md-select><div ng-if=\"ctrl.parent.iconValidation\" class=\"validation-error-text\"><span>\nSelect the Icon</span></div></md-input-container></div><div layout=\"row\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\" \nlayout-align=\"start center\"><label flex=\"20\" class=\"Font-Bold\">Banner Title</label><md-input-container \nclass=\"input_container h-36\" md-no-float flex=\"80\"><input id=\"banner_title\" ng-maxlength=\"150\" name=\"banner_title\" \nclass=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.bannerTitleValidation}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.title\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.data.title) ? \'N/A\' : \'Enter Banner Title\' }} \" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" ng-keyup=\"ctrl.parent.bannerTitleValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-title-Change\',ctrl.parent.bannerInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"banners_form.banner_title.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span>\nBanner Title must not exceed 150 characters.</span></div><div ng-if=\"ctrl.parent.bannerTitleValidation\" \nclass=\"validation-error-text\"><span>Enter Banner Title</span></div></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\"><div layout=\"row\" \nflex=\"40\" class=\"feild-spacing mobile-spacing mb-20\" flex-xs=\"100\" layout-align=\"start center\"><label flex=\"20\" \nclass=\"Font-Bold\">Font color</label><md-input-container class=\"input_container panel-select\" md-no-float flex=\"60\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.bannerFontValidation}\" \nng-keyup=\"ctrl.parent.bannerFontValidation=false\"><div layout=\"row\" flex=\"100\"><input flex=\"10\" \nclass=\"border-0 color-picker\" type=\"color\" ng-model=\"ctrl.parent.bannerInfo.selectedData.data.theme.text_color\" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\"> <input flex=\"90\" class=\"border-0 color-input\" name=\"secondary_color\" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" ng-model=\"ctrl.parent.bannerInfo.selectedData.data.theme.text_color\" \nplaceholder=\"Enter color\" ng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\"></div><div \nng-if=\"ctrl.parent.bannerFontValidation\" class=\"validation-error-text mt-5\"><span>Enter Font Color</span></div>\n</md-input-container></div><div layout=\"row\" flex=\"40\" class=\"feild-spacing mobile-spacing\" flex-xs=\"100\" \nlayout-align=\"start center\"><label flex=\"20\" class=\"Font-Bold\">Background color</label><md-input-container \nclass=\"input_container panel-select\" md-no-float flex=\"60\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.bannerBackgroundValidation}\" \nng-keyup=\"ctrl.parent.bannerBackgroundValidation=false\"><div layout=\"row\" flex=\"100\"><input flex=\"10\" \nclass=\"border-0 color-picker\" type=\"color\" ng-model=\"ctrl.parent.bannerInfo.selectedData.data.theme.background\" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\"> <input flex=\"90\" class=\"border-0 color-input\" name=\"secondary_color\" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" ng-model=\"ctrl.parent.bannerInfo.selectedData.data.theme.background\" \nplaceholder=\"Enter color\" ng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\"></div><div \nng-if=\"ctrl.parent.bannerBackgroundValidation\" class=\"validation-error-text mt-5\"><span>Enter Background Color</span>\n</div></md-input-container></div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\" \nlayout-align=\"start start\"><label flex=\"20\" class=\"Font-Bold mt-8\">Banner Message</label><md-input-container \nclass=\"input_container\" md-no-float flex=\"80\"><textarea name=\"message\" class=\"textarea-class\" rows=\"3\" max-rows=\"3\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.description\" ng-keyup=\"ctrl.parent.bannerMessageValidation=false\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner,\'validation-error\':ctrl.parent.bannerMessageValidation}\" \nng-maxlength=\"400\" ng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-Message-Change\',ctrl.parent.bannerInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</textarea><div ng-if=\"ctrl.parent.bannerMessageValidation\" class=\"validation-error-text\"><span>Enter Banner Message\n</span></div><div ng-messages=\"banners_form.message.$error\" role=\"alert\"><div ng-message=\"maxlength\">\nBanner Message must not exceed 400 characters</div></div></md-input-container></div></div><div \nclass=\"info-label mt-20\" layout=\"row\" flex=\"100\"><div flex=\"15\">Action button (optional)</div><div flex=\"85\" \nclass=\"bb\"></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"row\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\" layout-align=\"start center\"><label flex=\"20\" class=\"Font-Bold\">Button Name</label>\n<md-input-container class=\"input_container h-36\" md-no-float flex=\"60\"><input id=\"button_name\" name=\"button_name\" \nclass=\"panel-select md-input-focused\" ng-maxlength=\"20\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.action.text\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.action.text) ? \'N/A\' : \'Enter Button text\' }} \" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-Action text-Change\',ctrl.parent.bannerInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"banners_form.button_name.$error\" role=\"alert\"><div ng-message=\"maxlength\">\nButton Name must not exceed 20 characters</div></div></md-input-container></div><div layout=\"row\" flex=\"50\" \nclass=\"feild-spacing mobile-spacing\" flex-xs=\"100\" layout-align=\"start center\"><label flex=\"20\" class=\"Font-Bold\">\nFont color</label><md-input-container class=\"input_container panel-select\" md-no-float flex=\"80\"><div layout=\"row\" \nflex=\"100\"><input flex=\"10\" class=\"border-0 color-picker\" type=\"color\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.action.text_color\" ng-disabled=\"ctrl.parent.bannerInfo.viewBanner\"> \n<input flex=\"90\" class=\"border-0 color-input\" ng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" name=\"secondary_color\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.action.text_color\" placeholder=\"Enter color\" \nng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\"></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div layout=\"row\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\" \nlayout-align=\"start center\"><label flex=\"20\" class=\"Font-Bold\">Url</label><md-input-container \nclass=\"input_container h-36\" md-no-float flex=\"60\"><input id=\"reference-name\" class=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.bannerInfo.viewBanner}\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.action.url\" \nplaceholder=\"{{(ctrl.parent.bannerInfo.viewBanner && !ctrl.parent.bannerInfo.selectedData.data.action.url) ? \'N/A\' : \'Enter URL\' }} \" \nng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Banner-URL-Change\',ctrl.parent.bannerInfo.viewBanner)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div layout=\"row\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\" layout-align=\"start center\">\n<label flex=\"20\" class=\"Font-Bold\">Background Color</label><md-input-container class=\"input_container panel-select\" \nmd-no-float flex=\"80\"><div layout=\"row\" flex=\"100\"><input flex=\"10\" class=\"border-0 color-picker\" type=\"color\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.action.background\" ng-disabled=\"ctrl.parent.bannerInfo.viewBanner\"> \n<input flex=\"90\" class=\"border-0 color-input\" ng-disabled=\"ctrl.parent.bannerInfo.viewBanner\" name=\"secondary_color\" \nng-model=\"ctrl.parent.bannerInfo.selectedData.data.action.background\" placeholder=\"Enter color\" \nng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\"></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div layout-align=\"start center\" class=\"info-label\">Banner Preview</div>\n<md-button layout-align=\"end end\" md-no-ink class=\"md-accent-btn ml-auto\" \nng-click=\"ctrl.parent.showPreview= !ctrl.parent.showPreview;ctrl.parent.fnTrackEvent(\'Banner-Preview-Click\',ctrl.parent.bannerInfo.form_heading )\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon>Preview</md-button></div><div class=\"border-class\"><div \nng-show=\"ctrl.parent.showPreview\"><div \nng-style=\"{\'background-color\': ctrl.parent.bannerInfo.selectedData.data.theme.background}\"><div \nclass=\"banner-campaign\" flex=\"100\"><div class=\"content-left w-100p-mob mb-10-mob\"><div class=\"icon-section w-35 h-35\" \nng-style=\"{\'background-color\': ctrl.parent.bannerInfo.selectedData.data.theme.text_color}\"><md-icon \nmd-font-icon=\"{{ctrl.parent.bannerInfo.selectedData.data.theme.icon.font_class}}\" class=\"s20 icon\" \nng-style=\"{\'color\': (ctrl.parent.bannerInfo.selectedData.data.theme.type == \'general\' || ctrl.parent.bannerInfo.selectedData.data.theme.type ==  \'promotion\') ? ctrl.parent.bannerInfo.selectedData.data.theme.background : \'white\' }\">\n</md-icon></div><div ng-style=\"{\'color\': ctrl.parent.bannerInfo.selectedData.data.theme.text_color}\" class=\"w-full\">\n<div layout=\"row\" layout-align=\"start end\" layout-align-xs=\"start center\" class=\"title-section\"><div \nclass=\"title Font-Bold\">{{ ctrl.parent.bannerInfo.selectedData.data.title }}<md-tooltip md-direction=\"top\">\n{{ ctrl.parent.bannerInfo.selectedData.data.title }}</md-tooltip></div><div class=\"steps-number\" \nng-if=\"$ctrl.bannerList.length > 1\">{{$ctrl.currentPageIndex+1}}/{{$ctrl.bannerList.length}}</div></div><div \nclass=\"description Font-Regular\">{{ ctrl.parent.bannerInfo.selectedData.data.description }}<md-tooltip \nmd-direction=\"top\">{{ ctrl.parent.bannerInfo.selectedData.data.description }}</md-tooltip></div></div></div><div \nclass=\"content-right\"><div class=\"button-space\"><button class=\"action-btn\" \nng-if=\"ctrl.parent.bannerInfo.selectedData.data.action.text\" \naria-label=\"{{ ctrl.parent.bannerInfo.selectedData.data.action.text }}\" \nng-style=\"{\'background-color\': ctrl.parent.bannerInfo.selectedData.data.action.background,\'border-color\': ctrl.parent.bannerInfo.selectedData.data.action.text_color}\">\n<span class=\"btn-text Font-Bold\" ng-style=\"{\'color\': ctrl.parent.bannerInfo.selectedData.data.action.text_color}\">\n{{ ctrl.parent.bannerInfo.selectedData.data.action.text }}</span><md-tooltip md-direction=\"top\">\n{{ ctrl.parent.bannerInfo.selectedData.data.action.text }}</md-tooltip></button></div></div><button \nng-if=\"ctrl.parent.bannerInfo.selectedData.data.theme.type.toLowerCase() == \'general\'\" class=\"close-icon\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"s20\" \nng-style=\"{\'color\': ctrl.parent.bannerInfo.selectedData.data.action.text_color}\"></md-icon></button></div></div></div>\n</div></div></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\" flex=\"100\"><div \nlayout-align=\"start center\" flex=\"70\" layout=\"row\"><div layout=\"row\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\" \nlayout-align=\"start center\"><label flex=\"30\" class=\"Font-Bold\">Set Start Date</label><div layout=\"column\" flex=\"50\">\n<date-picker class=\"input_container\" md-no-float flex=\"70\" \nmodel-value=\"ctrl.parent.bannerInfo.selectedData.start_date\" \nis-validate=\"((ctrl.parent.startDateValidation) || (banners_form.start_date.$touched && banners_form.start_date.$error.valid))\" \nmd-input-id=\"\'start_date\'\" is-editable=\"!ctrl.parent.bannerInfo.viewBanner\" input-required=\"true\" \nis-disabled=\"ctrl.parent.bannerInfo.viewBanner\" full-border=\"true\" input-name=\"\'start_date\'\" full-border=\"true\" \ndate-placeholder=\"\'Start Date\'\" date-format=\"true\" min-date-value=\"ctrl.parent.todayDate\" \ncallback=\"ctrl.parent.fnTrackEvent(\'Banner-StartDate-Change\',ctrl.parent.bannerInfo.form_heading );ctrl.parent.formatDate(value,\'start_date\');ctrl.parent.startDateValidation=false\">\n></date-picker><div ng-if=\"ctrl.parent.startDateValidation\" class=\"validation-error-text\"><span>Enter Start Date</span>\n</div></div></div><div layout=\"row\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\" layout-align=\"start center\"><label \nflex=\"30\" class=\"Font-Bold\">Set Expiry Date</label><div layout=\"column\" flex=\"50\"><date-picker class=\"input_container\" \nmd-no-float flex=\"70\" model-value=\"ctrl.parent.bannerInfo.selectedData.end_date\" \nis-validate=\"((ctrl.parent.expiryValidation) || (banners_form.end_date.$touched && banners_form.end_date.$error.valid))\" \nmd-input-id=\"\'end_date\'\" is-editable=\"!ctrl.parent.bannerInfo.viewBanner\" input-required=\"true\" \nis-disabled=\"ctrl.parent.bannerInfo.viewBanner\" full-border=\"true\" input-name=\"\'end_date\'\" full-border=\"true\" \ndate-placeholder=\"\'Expiry Date\'\" date-format=\"true\" min-date-value=\"ctrl.parent.bannerInfo.selectedData.start_date\" \ncallback=\"ctrl.parent.fnTrackEvent(\'Banner-ExpiryDate-Change\',ctrl.parent.bannerInfo.form_heading );ctrl.parent.formatDate(value,\'end_date\');ctrl.parent.expiryValidation=false\">\n></date-picker><div ng-if=\"ctrl.parent.expiryValidation\" class=\"validation-error-text\"><span>Enter Expiry Date</span>\n</div></div></div></div><div class=\"text-end m-10\" flex=\"30\" layout-align=\"end center\" \nng-if=\"!ctrl.parent.bannerInfo.viewBanner\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"ctrl.parent.submit_banner(banners_form, ctrl.parent.bannerInfo , ctrl.parent.bannerInfo.sec_button_type)\" \ntitle=\"{{ctrl.parent.bannerInfo.sec_button_type}}\">{{ctrl.parent.bannerInfo.sec_button_type}}</md-button><md-button \nmd-no-ink class=\"md-accent-btn\" \nng-click=\"ctrl.parent.submit_banner(banners_form, ctrl.parent.bannerInfo , ctrl.parent.bannerInfo.button_type)\">\n{{ctrl.parent.bannerInfo.button_type}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/component/rate-card-table/confirm-leave/confirm-leave.html","<md-dialog id=\"confirm-leave\" class=\"popup-xs\"><md-dialog-content class=\"body\" layout=\"column\"><span class=\"pv-10\">\n<span>By changing view this you will lose the selected cards, Still want to continue ?</span></span><div \nclass=\"pt-10 note-text\" layout-align=\"start center\"></div></md-dialog-content><md-dialog-actions class=\"footer\" \nlayout=\"row\" layout-align=\"end center\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel\">Cancel</md-button><md-button \nng-if=\"ctrl.parent.leaveType == \'rateCardViewSwitch\'\" md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" \nng-click=\"ctrl.parent.fnSwitchMode(ctrl.parent.modeChanges)\" title=\"yes\">Yes</md-button><md-button \nng-if=\"ctrl.parent.leaveType == \'removeCardConfirmation\'\" md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" \nng-click=\"ctrl.parent.confirmLeave(\'yes\',ctrl.parent.removeCurrentCard , $event)\" title=\"yes\">Yes</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/auth/account/account.html","<div id=\"login-v2\" layout=\"column\" class=\"pb-20 account-list-form\" \nng-style=\"{\'background-image\': \'url(\' + $root.domainData.domain_info.LOGIN_BACKGROUND_IMAGE_URL + \')\'}\"><md-toolbar \nclass=\"login-toolbar\"><div layout=\"row\" layout-align=\"space between\" class=\"web-padding\"><div class=\"comp_logo\" \nng-style=\"{\'background-image\': \'url(\' + $root.domainData.logo + \')\'}\"></div></div></md-toolbar><div layout=\"column\" \nlayout-align=\"center center\" flex class=\"account-list-form mt-5\"><div layout=\"row\" layout-align=\"center\" \nclass=\"mobile_view_login\"><div class=\"account-list-wrapper flex-scrollable\" ms-scroll><h1 class=\"form-heading\">\nChoose an account</h1><div class=\"account-list\"><div class=\"account-list-item\" \nng-repeat=\"account in vm.accountList  | filter:{ is_authenticated : true} track by $index\"><a \nng-href=\"{{ vm.util.sanitizeQueryParams(account.redirect_url)}}\" target=\"_blank\" class=\"active-link\" rel=\"noopener\">\n<div class=\"list-left\"><p class=\"heading\">{{account.vendor_name}}</p><p class=\"link\">{{account.domain_url}}</p></div>\n<div class=\"list-right\" ng-if=\"account.domain_url == vm.currentDomain\"><md-button md-no-ink \nclass=\"action-btn md-outline md-disabled\" aria-label=\"Current Account\"><span class=\"action-btn-text\">Current Account\n</span></md-button></div><div class=\"list-right\" ng-if=\"account.domain_url != vm.currentDomain\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"black-fg\"></md-icon></div></a></div></div><div class=\"other-account-sec\" \nng-if=\"vm.otherAccountArray.length > 0\"><div class=\"heading-light\"><p class=\"text\">\nOther accounts associated with this email</p><md-divider class=\"divider\"></md-divider></div><div class=\"account-list\">\n<div class=\"account-list-item\" ng-repeat=\"account in vm.otherAccountArray track by $index\"><div class=\"list-left\"><p \nclass=\"heading\">{{account.vendor_name}}</p><p class=\"link\">{{account.domain_url}}</p></div><a \nng-href=\"{{ vm.util.sanitizeQueryParams(account.redirect_url)}}\" target=\"_blank\" rel=\"noopener\"><div \nclass=\"list-right\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"icon grey-500-fg\"></md-icon></div></a></div></div>\n</div></div></div></div><div layout=\"row\" layout-align=\"start end\" layout-wrap layout-padding class=\"ph-0 web-padding\">\n<div ng-if=\"$root.domainData.domain_info.APP_QR_CODE_IMAGE_URL\"><span><img \nng-src=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_QR_CODE_IMAGE_URL)}}\" width=\"85px\"></span></div>\n<div class=\"mr-10\" ng-if=\"$root.domainData.domain_info.APP_CONFIG.android_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.android_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/google.png\"></a></div><div \nng-if=\"$root.domainData.domain_info.APP_CONFIG.ios_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.ios_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/apple.png\"></a></div><div layout=\"row\" \nlayout-align=\"end end\" flex>Copyright © Freightbro Logistics Pvt Ltd. All Rights Reserved</div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"column\" class=\"pb-20\" \nng-style=\"{\'background-image\': \'url(\' + $root.domainData.domain_info.LOGIN_BACKGROUND_IMAGE_URL + \')\'}\"><md-toolbar \nclass=\"login-toolbar mb-10\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"space between\" \nclass=\"web-padding\"><div layout=\"row\" layout-align=\"center center\"><div class=\"comp_logo\"><img id=\"domain-comp-logo\" \nclass=\"logo-img\" ng-src=\"{{ vm.util.sanitizeQueryParams($root.domainData.logo)}}\"></div></div></div></md-toolbar><div \nlayout=\"column\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" \nclass=\"center-section parent-section login-container\" flex=\"100\"><div ng-if=\"$root.domainData.domain_info.ONLY_SSO\">\n<div layout=\"column\" layout-align=\"center center\" class=\"mv-10 sso-container\"><h2 \nclass=\"md-headline text-center mb-20\">Login with Single Sign-On (SSO)</h2><p class=\"text-center grey-600-fg mb-20\">\nAccess your account securely using your organization\'s SSO service.</p><md-button \nclass=\"md-raised md-primary sso-button\" ng-click=\"vm.handleSSOButtonClick()\"><img src=\"assets/icons/custom/sso.png\" \nalt=\"SSO Icon\" class=\"sso-icon\"> {{ $root.domainData.domain_info.SSO_BUTTON }}</md-button><p \nclass=\"mt-20 text-center grey-600-fg\">If you face any login issues, please contact your administrator.</p></div></div>\n<div ng-if=\"!$root.domainData.domain_info.ONLY_SSO\"><div ng-switch=\"vm.activeScreen\"><div ng-init=\"vm.init()\" \nng-switch-when=\"login-pass\"><div ng-include=\"\'app/main/pages/auth/login-v2/views/login-form.html\'\"></div></div><div \nclass=\"with-otp\" ng-switch-when=\"request-otp\"><div ng-include=\"\'app/main/pages/auth/login-v2/views/login-otp.html\'\">\n</div></div><div class=\"enter-otp-screen\" ng-switch-when=\"login-otp\"><div \nng-include=\"\'app/main/pages/auth/login-v2/views/otp-sent.html\'\"></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"center\" class=\"mv-10\"><md-progress-circular class=\"md-accent\" id=\"login-progress\" \nng-disabled=\"!vm.loginbtndisabled\" md-diameter=\"32\"></md-progress-circular></div></div><div layout=\"row\" \nlayout-align=\"start end\" layout-align-xs=\"center center\" layout-wrap layout-padding class=\"ph-0 web-padding footer\">\n<div ng-if=\"$root.domainData.domain_info.APP_QR_CODE_IMAGE_URL\"><span><img \nng-src=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_QR_CODE_IMAGE_URL)}}\" width=\"85px\"></span></div>\n<div class=\"mr-10\" ng-if=\"$root.domainData.domain_info.APP_CONFIG.android_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.android_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/google.png\"></a></div><div \nng-if=\"$root.domainData.domain_info.APP_CONFIG.ios_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.ios_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/apple.png\"></a></div><div flex-xs=\"100\" \nflex-sm=\"100\" layout=\"row\" layout-align=\"end end\" layout-align-xs=\"center center\" flex>\nCopyright © {{$root.domainData.domain_info.domain_title}}. All Rights Reserved</div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/redirect-access.html","<div id=\"toolbar-progress\" ng-init=\"vm.initAccess()\"><p class=\"rate-updating-text\"><b class=\"redirecting\">Redirecting\n</b></p><div class=\"loadinggif\"><div class=\"loader-spin\"></div></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/generate-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"start center\"><div id=\"reset-password-form\" \nclass=\"md-whiteframe-8dp brad-0 generate-password-form\"><div ng-if=\"vm.form.email\"><div layout=\"row\"><div \nclass=\"initial_name_avtar\"><p ng-bind=\"(vm.form.email).charAt(0)\"></p></div><div class=\"ml-10 text-left\"><div \nclass=\"black-fg font-size-16 font-weight-600\">Set Your Password</div><div class=\"font-size-12\">{{vm.form.email}}</div>\n</div></div><div><form ng-if=\"vm.passwordChange !== true\" name=\"generatePasswordForm\" novalidate \nng-submit=\"vm.resetPassword()\"><md-input-container class=\"md-block mb-0 pb-0\" md-no-float><input \ntype=\"{{vm.showPassword ? \'text\' : \'password\'}}\" id=\"reset_pwd\" name=\"password\" class=\"generate-password\" \nng-model=\"vm.form.password\" placeholder=\"Enter Password\" required \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-pattern=\"/^(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\" ng-keyup=\"vm.validatePassword();vm.clearError()\" \nng-focus=\"vm.showPassErr(\'focus\')\" ng-blur=\"vm.showPassErr(\'blur\')\"><md-icon \nmd-font-icon=\"{{vm.showPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon grey-500-fg pointer generate_pass_icon\" ng-click=\"vm.togglePassword(\'password\')\"></md-icon><div \nng-messages=\"generatePasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><div id=\"message\"><div class=\"indigo-fg\">\nPassword must contain the following:</div><div id=\"special\" class=\"passInvalid\">A <b>special</b> character</div><div \nid=\"number\" class=\"passInvalid\">A <b>number</b></div><div id=\"length\" class=\"passInvalid\">Minimum <b>8 characters</b>\n</div></div><md-input-container class=\"md-block\" md-no-float><input \ntype=\"{{vm.showCurrentPassword ? \'text\' : \'password\'}}\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" \nplaceholder=\"Confirm Password\" required ng-keyup=\"vm.clearError()\" class=\"generate-password\"><md-icon \nmd-font-icon=\"{{vm.showCurrentPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon grey-500-fg pointer generate_pass_icon\" ng-click=\"vm.togglePassword(\'current_password\')\"></md-icon><div\n ng-messages=\"generatePasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nConfirm Password field is required</span></div></div></md-input-container><div id=\"reset-error\" \nng-show=\"vm.resetError.message !== \'\'\"><div class=\"pb-15\"><span>{{vm.resetError.message}}</span></div></div><md-button \nmd-no-ink type=\"submit\" class=\"md-accent-btn\" aria-label=\"UPDATE MY PASSWORD\" \nng-disabled=\"generatePasswordForm.$invalid || vm.disableSubmit\">Set Password</md-button></form><div \nng-if=\"vm.passwordChange === true\"><div><h2>{{vm.reset.message}}</h2></div></div></div></div><div \nng-if=\"!vm.form.email\" class=\"reset-link-expired\"><div class=\"font-size-18 fb-color font-weight-700\">\nPASSWORD LINK EXPIRED</div><div class=\"text-center font-size-12 fb-color opacity pt-10 pb-25\"><span>\nPlease click on the below link to</span><br><span>reset your password</span></div><div><span \nclass=\"go_back_link pb-5 pointer\" ng-click=\"vm.goBackToLogin()\">Go back to reset password</span></div></div></div>\n</div><div><img class=\"flag app_icon bottom_img\" ng-src=\"assets/images/backgrounds/path.png\"> <img \nclass=\"flag app_icon bottom_img\" ng-src=\"assets/images/backgrounds/path-2.png\"></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" \nng-style=\"{\'background-image\': \'url(\' + $root.domainData.domain_info.LOGIN_BACKGROUND_IMAGE_URL + \')\'}\"><div \nid=\"login-v2\" layout=\"column\" class=\"pb-20\"><md-toolbar class=\"login-toolbar mb-10\"><div layout=\"row\" \nlayout-align=\"space between\" class=\"web-padding\"><div class=\"comp_logo\" \nng-style=\"{\'background-image\': \'url(\' + $root.domainData.logo + \')\'}\"></div><div class=\"font-size-14 md-link-fg\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"pointer\" \nng-click=\"vm.loginToggle=\'login\';vm.activeScreen = \'login-pass\';vm.forgotToggle=false;\" \nng-if=\"vm.loginToggle==\'signup\'\">Login</span></div></div></md-toolbar><div layout=\"column\" \nlayout-align=\"center center\" flex id=\"reset-password-form-wrapper\"><div id=\"reset-password-form\" layout=\"column\" \nlayout-align=\"center center\" class=\"center-section parent-section\" flex=\"100\"><div ng-if=\"vm.form.email\"><div \nclass=\"form-title text-center\">\n{{ vm.currentState==\'app.pages_auth_reset-password\' ? \'Set your password\' : \'Create a New Password\'}}</div><form \nng-if=\"vm.passwordChange !== true\" name=\"resetPasswordForm\" novalidate ng-submit=\"vm.resetPassword(resetPasswordForm)\">\n<md-input-container class=\"md-block\" md-no-float><input class=\"custom-input\" type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email address\" ng-pattern=\"vm.util.emailRegex\" required \nng-keyup=\"vm.clearError()\" ng-readonly=\"vm.form.email\"><div ng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"pattern\">\n<span>Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input class=\"custom-input\" type=\"{{vm.showPassword ? \'text\' : \'password\'}}\" id=\"reset_pwd\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-pattern=\"/^(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\" ng-keyup=\"vm.validatePassword();vm.clearError()\" \nng-focus=\"vm.showPassErr(\'focus\')\" ng-blur=\"vm.showPassErr(\'blur\')\"><md-icon \nmd-font-icon=\"{{vm.showPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" class=\"eye-icon grey-500-fg pointer\" \nng-click=\"vm.togglePassword(\'password\')\"></md-icon><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><div id=\"message\"><div \nclass=\"validation-title\">Password must contain the following:</div><div id=\"special\" class=\"passInvalid\">A <b>special\n</b> character</div><div id=\"number\" class=\"passInvalid\">A <b>number</b></div><div id=\"length\" class=\"passInvalid\">\nMinimum <b>8 characters</b></div></div><md-input-container class=\"md-block\" md-no-float><input class=\"custom-input\" \ntype=\"{{vm.showCurrentPassword ? \'text\' : \'password\'}}\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" \nplaceholder=\"Password (Confirm)\" required ng-keyup=\"vm.clearError()\"><md-icon \nmd-font-icon=\"{{vm.showCurrentPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" class=\"eye-icon grey-500-fg pointer\" \nng-click=\"vm.togglePassword(\'current_password\')\"></md-icon><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"red-fg\" id=\"reset-error\" ng-show=\"vm.resetError.message !== \'\'\"><div><span>\n{{vm.resetError.message}}</span></div></div><md-button md-no-ink type=\"submit\" \nclass=\"md-accent-btn with-icon submit-button\" aria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"vm.disableSubmit\">\nReset my password<md-icon class=\"s14 ml-5\" md-font-icon=\"icon-arrow-right\"></md-icon></md-button></form><div \nng-if=\"vm.passwordChange === true\"><div><h2>{{vm.reset.message}}</h2></div></div></div><div ng-if=\"!vm.form.email\" \nclass=\"reset-link-expired\"><div class=\"form-title text-center\">PASSWORD LINK EXPIRED</div><div \nclass=\"text-center font-size-18 pt-10 pb-25\"><span>Please click on the below link to</span><br><span>\nreset your password</span></div><div class=\"text-center\"><span \nclass=\"md-link-fg font-size-16 pointer bb md-link-border\" ng-click=\"vm.goBackToLogin()\">Go back to reset password\n</span></div></div></div></div><div layout=\"row\" layout-align=\"start end\" layout-wrap layout-padding \nclass=\"ph-0 web-padding\"><div ng-if=\"$root.domainData.domain_info.APP_QR_CODE_IMAGE_URL\"><span><img \nng-src=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_QR_CODE_IMAGE_URL)}}\" width=\"85px\"></span></div>\n<div class=\"mr-10\" ng-if=\"$root.domainData.domain_info.APP_CONFIG.android_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.android_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/google.png\"></a></div><div \nng-if=\"$root.domainData.domain_info.APP_CONFIG.ios_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.ios_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/apple.png\"></a></div><div layout=\"row\" \nlayout-align=\"end end\" flex>Copyright © Freightbro Logistics Pvt Ltd. All Rights Reserved</div></div></div></div>");
$templateCache.put("app/main/pages/auth/signup/signup.html","<div id=\"login-v2\" layout=\"column\" class=\"pb-20\" \nng-style=\"{\'background-image\': \'url(\' + $root.domainData.domain_info.LOGIN_BACKGROUND_IMAGE_URL + \')\'}\"><md-toolbar \nclass=\"login-toolbar mb-10\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"space between\" \nclass=\"web-padding\"><div layout=\"row\" layout-align=\"center center\"><div class=\"comp_logo\"><img id=\"domain-comp-logo\" \nclass=\"logo-img\" ng-src=\"{{ $root.domainData.logo}}\"></div></div></div></md-toolbar><div layout=\"column\" \nlayout-align=\"center center\" flex><div ng-include=\"\'app/main/pages/auth/login-v2/views/sign-up.html\'\" \nclass=\"center-section\"></div></div><div layout=\"row\" layout-align=\"start end\" layout-align-xs=\"center center\" \nlayout-wrap layout-padding class=\"ph-0 web-padding\"><div ng-if=\"$root.domainData.domain_info.APP_QR_CODE_IMAGE_URL\">\n<span><img ng-src=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_QR_CODE_IMAGE_URL)}}\" width=\"85px\">\n</span></div><div class=\"mr-10\" ng-if=\"$root.domainData.domain_info.APP_CONFIG.android_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.android_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/google.png\"></a></div><div \nng-if=\"$root.domainData.domain_info.APP_CONFIG.ios_link\"><a \nng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.APP_CONFIG.ios_link)}}\" target=\"_blank\" \nrel=\"noopener\"><img class=\"flag app_icon pointer\" ng-src=\"assets/icons/custom/apple.png\"></a></div><div flex-xs=\"100\" \nflex-sm=\"100\" layout=\"row\" layout-align=\"end end\" layout-align-xs=\"center center\" flex>\nCopyright © {{$root.domainData.domain_info.domain_title}}. All Rights Reserved</div></div></div>");
$templateCache.put("app/main/pages/auth/sso-switch-account/sso-switch-account.html","<div style=\"width: 100%; height:100vh\"><iframe ng-init=\"vm.init()\" width=\"100%\" height=\"100%\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.iframeSrcForMultiDomainViaSSO)}}\"></iframe></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"row\" class=\"error-internet\" layout-sm=\"column\"><div flex-xs=\"100\" flex=\"60 text-center\" \nlayout=\"column\" layout-align=\"center\" layout-padding><div flex><div class=\"white-50-bg\" layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><img class=\"error-img-width\" ng-src=\"assets/images/fb_shipper/404-error.svg\">\n</div></div><div class=\"mh-20 text-center\"><div class=\"text-semibold font-size-23 fg-333333\">\nThe page that you are looking for doesn\'t exist.</div><md-button md-no-ink \nclass=\"md-raised orange-border orange-400-fg white-bg font-size-18 border-radius mv-40\" ng-click=\"vm.goBackHome()\">\nGo back to home</md-button></div></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"row\" class=\"error-internet\" layout-sm=\"column\"><div flex-xs=\"100\" flex=\"60 text-center\" \nlayout=\"column\" layout-align=\"center\" layout-padding><div flex><div class=\"white-50-bg\" layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><img class=\"error-img-width\" ng-src=\"assets/images/fb_shipper/500-error.svg\">\n</div></div><div class=\"mh-20 text-center\"><div class=\"text-semibold font-size-23 fg-333333\">\nWe are currently facing a technical difficulty.</div><br><span class=\"input font-size-23 fg-333333\">\nTry refreshing the page or go back to home.</span><br><md-button md-no-ink class=\"md-primary-btn error-go-to-home-btn\" \nng-click=\"vm.goBackHome()\" title=\"Go back to home\"><span>Go back to home</span></md-button><md-button md-no-ink \nclass=\"md-accent-btn error-refresh-btn mv-40\" ng-click=\"vm.refresh()\" title=\"Refresh Page\"><span>Refresh Page</span>\n</md-button></div></div></div>");
$templateCache.put("app/main/pages/errors/503/error-503.html","<div id=\"error-503\" layout=\"row\" class=\"error-503\" layout-sm=\"column\"><div flex-xs=\"100\" flex=\"60 text-center\" \nlayout=\"column\" layout-align=\"center center\" layout-padding><span class=\"internet_error pt-20\">Under Maintenance !\n</span><div flex><div class=\"white-50-bg\" layout=\"row\" layout-align=\"center center\" flex=\"100\"><img \nclass=\"error-img-width\" ng-src=\"assets/images/fb_shipper/503-error.svg\"></div></div><div \nclass=\"mh-20 pb-20 text-center fg-333333\"><div class=\"text-semibold font-size-23\">\nSorry for the inconvenience, but we are performing some maintenance at the moment.</div><br><span \nclass=\"input font-size-23\">\"We\'ll be back online shortly!\"</span></div></div></div>");
$templateCache.put("app/main/pages/errors/internet/error-internet.html","<div id=\"error-internet\" layout=\"row\" class=\"error-internet\" layout-sm=\"column\"><div flex-xs=\"100\" \nflex=\"60 text-center\" layout=\"column\" layout-align=\"center center\" layout-padding><div flex><div class=\"white-50-bg\" \nlayout=\"row\" layout-align=\"center center\" flex=\"100\"><img class=\"error-img-width\" \nng-src=\"assets/images/fb_shipper/no-internet-error.svg\"></div></div><div class=\"mh-20 text-center\"><div \nclass=\"text-semibold font-size-23 fg-333333\">There is no internet connection</div><br><span \nclass=\"input font-size-23 fg-333333\">Try refreshing this page.</span><br><md-button md-no-ink \nclass=\"md-accent-btn error-refresh-btn mv-40\" ng-click=\"vm.reload()\" title=\"Refresh Page\"><span>Refresh Page</span>\n</md-button></div></div></div>");
$templateCache.put("app/main/pages/errors/share-page-error/share-error.html","<div id=\"share-error\" layout=\"row\" class=\"error-internet\" layout-sm=\"column\"><div flex-xs=\"100\" flex=\"60 text-center\" \nlayout=\"column\" layout-align=\"center center\" layout-padding><div flex><div class=\"white-50-bg\" layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><img class=\"error-img-width\" \nng-src=\"assets/images/fb_shipper/access-denied.svg\"></div></div><div class=\"mh-20 text-center\"><div \nclass=\"text-semibold font-size-23 fg-333333\">You do not have permission to access this module.</div><br><span \nclass=\"input font-size-23\">Please contact your administrator.</span><br><md-button md-no-ink \nclass=\"md-accent-btn error-refresh-btn w-120 mv-40\" ng-click=\"vm.goBackHome()\" title=\"Request Access\"><span>\nGo Back to Home</span></md-button></div></div></div>");
$templateCache.put("app/main/pages/errors/unpaid-module-error/unpaid-module-error.html","<div id=\"unpaid-module-error\" layout=\"row\" class=\"unpaid-module-error\" layout-sm=\"column\"><div flex-xs=\"100\" \nflex=\"60 text-center\" layout=\"column\" layout-align=\"center center\" layout-padding><div flex><div \nclass=\"white-50-bg pt-80 pb-20\" layout=\"row\" layout-align=\"center center\" flex=\"100\"><img \nng-src=\"assets/images/fb_shipper/unpaid-error.svg\"></div></div><div class=\"mh-20 text-center\"><div \nclass=\"text-semibold font-size-23 fg-333333\">Access Denied</div><br><span class=\"input font-size-23\">\nPlease contact your admin!</span><br><md-button md-no-ink class=\"md-accent-btn error-refresh-btn w-120 mv-40\" \nng-click=\"vm.goBackHome()\" title=\"Go Back to Home\"><span>Go Back to Home</span></md-button></div></div></div>");
$templateCache.put("app/main/pages/public-page/exchange-rates/exchange-rates.html","<div class=\"Exchange-Rates\"><md-toolbar class=\"rates-toolbar mb-10\" ng-if=\"!vm.isTokenPresent && !vm.util.isWebView()\">\n<div layout=\"row\" layout-align=\"space between\" class=\"web-padding\"><div class=\"comp_logo\" \nng-style=\"{\'background-image\': \'url(\' + $root.domainData.logo + \')\'}\"></div><div class=\"font-size-14 md-primary-fg\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"pointer md-link-fg mr-5\" ng-click=\"vm.goToLogin()\">Login</span>\n</div></div></md-toolbar><div ng-if=\"!vm.isCaptchaSolved\"><div id=\"exchangeRates\" class=\"g-recaptcha\" \nstyle=\"display: flex; justify-content: center; margin-bottom: 20px; margin-top: 20px\"></div></div><div \nshimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" ng-repeat=\"shimmer in [1,2,3,4]\" \nng-if=\"!vm.showRates\"></div><div class=\"web-padding\" ng-if=\"vm.showRates\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"mt-30 mb-15\" layout-wrap><div><div class=\"Font-Bold font-size-20\">\nExchange Rate List</div><div class=\"font-size-12 grey-fg\" ng-if=\"vm.baseCurrency\">\nLast Update on: {{vm.syncedOn| date : \'dd MMM yyyy hh:mm\'}}</div></div><div layout=\"row\"><div id=\"ratesearchbar\" \nclass=\"collapsed mr-10\" layout=\"row\" hide-xs><div id=\"search-box\" layout=\"row\" layout-align=\"end center\"><div \nid=\"sliding-panel-outer\" layout=\"row\"><span class=\"pr-10 pointer mt-8\" ng-click=\"vm.toggleSearch($event);\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icon s22\"></md-icon></span><div class=\"mb-10 search-container-div\" \nid=\"sliding-panel-inner\" layout=\"row\"><input class=\"h-36 p-5 border-none input-searchbar input-field\" \nng-model=\"vm.currencySearch\" flex placeholder=\"Search currency\"> <span layout=\"row\" layout-align=\"end center\" \nclass=\"md-accent-bg ph-5 pointer icon-border\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-fg search-icon\">\n</md-icon></span></div></div><div class=\"search-label mb-10\" ng-click=\"vm.toggleSearch($event)\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon-magnify icon h-35 input-group-addon pointer s22\"></md-icon></div></div></div>\n<div ng-if=\"vm.baseCurrency && (vm.isTokenPresent && !vm.util.userProfile.user.is_pricing_user && !vm.util.isShipper)\">\n<md-button md-no-ink class=\"pl-5 md-link-btn h-35 ml-0\" ng-click=\"vm.currencyConversionApi()\">\nView today\'s exchange rates</md-button></div></div></div><div hide show-xs><md-input-container \nclass=\"md-block m-0 p-0\" md-no-float><input ng-model=\"vm.currencySearch\" name=\"currencySearch\" placeholder=\"Search\">\n</md-input-container></div><div class=\"mb-10\" ng-if=\"vm.showRates\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th><div class=\"table-header\"><span \nclass=\"file_heading column-title\">Currency</span></div></th><th ng-class=\"{\'w-250\':!vm.util.isMobileDevice}\"><div \nclass=\"table-header\"><span class=\"file_heading column-title\">Exchange Rate</span> <span class=\"font-size-10\">\nCalculated based on {{vm.baseCurrency}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"rate in vm.exchangeRates | filter : vm.currencySearch \"><td><span \nng-class=\"{\'pl-15\': vm.util.isMobileDevice}\">{{rate.code}} <span compile-html=\"rate.symbol\"></span> - {{rate.name}}\n</span></td><td>{{rate.value | numberMask: 2:6}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/profile/dialogs/changePassword/changePassword.html","<md-dialog id=\"change-password\" class=\"popup-sm\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nflex=\"90\" class=\"p-0\" flex-xs=\"90\">Change Password</div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"10\" \nflex-xs=\"10\"><md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog(\'Close By Icon\')\">\n</md-icon></div></div><form name=\"changePassFrm\"><md-dialog-content class=\"body\"><div layout=\"column\" flex=\"100\">\n<label>Current Password</label><md-input-container flex class=\"input_container\" md-no-float><input \ntype=\"{{ctrl.parent.showCurrentPassword ? \'text\' : \'password\'}}\" autocomplete=\"off\" \nng-model=\"ctrl.parent.changePassword.current_password\" class=\"status_input\" \nng-class=\"{\'validation-error\':(ctrl.parent.currentPasswordValidation || ctrl.parent.checkCurrentPasswordValidation)}\" \nname=\"current_password\" placeholder=\"Enter Current Password\" \nng-keyup=\"ctrl.parent.currentPasswordValidation=false ;ctrl.parent.checkCurrentPasswordValidation=false\" \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-change=\"ctrl.parent.util.callMixpanel(\'MP-ChangePassword-CurrentPassword-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"{{ctrl.parent.showCurrentPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon icon-spacing grey-500-fg pointer\" ng-click=\"ctrl.parent.togglePassword(\'curr_pass\')\"></md-icon><div \nng-if=\"ctrl.parent.currentPasswordValidation\" class=\"validation-error-text\">Enter your current Password</div><div \nng-if=\"ctrl.parent.checkCurrentPasswordValidation\" class=\"validation-error-text\">\nPlease Enter Your Valid Current Password</div></md-input-container></div><div layout=\"column\" flex=\"100\"><label>\nNew Password</label><div flex><md-input-container flex class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.changePassword.password\" autocomplete=\"off\" id=\"new_pass\" class=\"status_input\" \ntype=\"{{ctrl.parent.showNewPassword ? \'text\' : \'password\'}}\" name=\"password\" placeholder=\"Enter New Password\" \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-class=\"{\'validation-error\':ctrl.parent.PasswordValidation}\" ng-pattern=\"/^(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\" \nng-keyup=\"ctrl.parent.validatePassword();ctrl.parent.PasswordValidation=false;ctrl.parent.error_msg=false\" \nng-focus=\"ctrl.parent.showPassErr(\'focus\')\" ng-blur=\"ctrl.parent.showPassErr(\'blur\')\" \nng-change=\"ctrl.parent.util.callMixpanel(\'MP-ChangePassword-NewPassword-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"{{ctrl.parent.showNewPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon icon-spacing grey-500-fg pointer\" ng-click=\"ctrl.parent.togglePassword(\'new_pass\')\"></md-icon><div \nng-if=\"ctrl.parent.PasswordValidation\" class=\"validation-error-text\">Enter a Password</div></md-input-container><div \nclass=\"mt-15\" id=\"message\"><div>Password must contain the following:</div><div id=\"special\" class=\"passInvalid\">A <b>\nspecial</b> character</div><div id=\"number\" class=\"passInvalid\">A <b>number</b></div><div id=\"length\" \nclass=\"passInvalid\">Minimum <b>8 characters</b></div></div></div></div><div layout=\"column\" flex=\"100\" \nclass=\"row-spacing\"><label>Confirm Password</label><md-input-container flex class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.changePassword.confirm_password\" autocomplete=\"off\" class=\"status_input\" \ntype=\"{{ctrl.parent.showConfirmPassword ? \'text\' : \'password\'}}\" name=\"confirm_password\" \nplaceholder=\"Confirm Password\" \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-class=\"{\'validation-error\':ctrl.parent.confirmPasswordValidation}\" \nng-keyup=\"ctrl.parent.confirmPasswordValidation=false;ctrl.parent.error_msg=false\" \nng-change=\"ctrl.parent.util.callMixpanel(\'MP-ChangePassword-ConfirmPassword-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"{{ctrl.parent.showConfirmPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon icon-spacing grey-500-fg pointer\" ng-click=\"ctrl.parent.togglePassword(\'confirm_pass\')\"></md-icon><div \nng-if=\"ctrl.parent.confirmPasswordValidation\" class=\"validation-error-text\">Password doesn\'t match</div><div \nng-if=\"ctrl.parent.error_msg\" class=\"validation-error-text mt-5\">{{ctrl.parent.error_msg}}</div></md-input-container>\n</div></md-dialog-content><md-dialog-actions class=\"footer\"><div layout=\"row\" layout-align=\"end end\" class=\"m-10\">\n<md-button md-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog(\'Cancel By Button\')\" \ntitle=\"Cancel edit\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ph-10\" type=\"submit\" \nng-click=\"ctrl.parent.submitUpdatedPassword(ctrl.parent.changePassword)\">Update Password</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/quotes/components/copy-quote/copy-quote-overview-popup.html","<md-dialog id=\"copy-quote\" ng-cloak class=\"popup-sm\"><div layout=\"row\" class=\"header\" flex=\"100\"><div \nclass=\"p-0 heading-text font-size-sm\" flex=\"90\" flex-xs=\"90\">Do you want to copy this quote?</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size p-0\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div><form \nname=\"lostInquiry_form\" ng-submit=\"ctrl.parent.fnProceedDuplicateQuote($event)\"><md-dialog-content class=\"body\"><div \nlayout=\"column\" layout-align=\"start start \" class=\"pb-5\"><div layout=\"row\"><div class=\"Font-Bold w-44\">Step 1 :</div>\n<div>\nModify the existing quote information which includes the Origin port, Destination port, Load type, Cutoff date, Incoterms, Stuffing type, Quote period and T&C, or proceed with the same.\n</div></div><div layout=\"row\"><div class=\"Font-Bold w-44\">Step 2 :</div><div>Add a new rate or edit selected rates\n</div></div><div layout=\"row\"><div class=\"Font-Bold w-44\">Step 3 :</div><div>Add customer details</div></div><div \nlayout=\"row\"><div class=\"Font-Bold w-44\">Step 4 :</div><div>The new quote is ready to be shared.</div></div></div>\n</md-dialog-content><md-dialog-actions><div class=\"white-bg mv-10\" layout=\"row\" hide show-xs><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" title=\"Cancel\" ng-click=\"ctrl.parent.cancelDialog(\'copyquote\');\">No, Cancel</md-button>\n<md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" \nng-click=\"ctrl.parent.cancelDialog(\'copyquote\');\" ng-disabled=\"ctrl.parent.yesBtn\">Yes, Proceed</md-button></div><div \nlayout=\"row\" class=\"mv-10\" hide-xs><md-button md-no-ink class=\"md-primary-btn mr-10\" title=\"Cancel\" \nng-click=\"ctrl.parent.cancelDialog(\'copyquote\');\">No, Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" ng-click=\"ctrl.parent.cancelDialog(\'copyquote\');\" \nng-disabled=\"ctrl.parent.yesBtn\">Yes, Proceed</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/quotes/components/copy-quote-confirmation/copy-quote-confirmation.html","<div layout=\"row\" class=\"header\" flex=\"100\"><div class=\"p-0 heading-text\" flex=\"90\" flex-xs=\"90\">Confirmation</div><div\n layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size p-0\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"$ctrl.closePanel(\'close\')\"></md-icon></div></div><form \nname=\"confirmationForm\" ng-submit=\"$ctrl.submitPanel(\'sumbit\',confirmationForm)\"><div layout=\"row\"><md-dialog-content \nclass=\"body\" flex=\"100\"><div class=\"font-size-13 mb-20\" ng-if=\"$ctrl.type==\'currency\'\">\nDo you want to Change {{$ctrl.sourceCurrency}} to {{$ctrl.targetCurrency}} ?</div><div class=\"font-size-13 mb-20\" \nng-if=\"$ctrl.type==\'load\'\">\nDo you want to Change {{$ctrl.makeLoadBoxString($ctrl.from)}} to {{$ctrl.makeLoadBoxString($ctrl.to)}} ?</div><div \nclass=\"font-size-13 mb-20\" ng-if=\"$ctrl.type==\'location\'\">\nDo you want to Change {{$ctrl.from.location}} to {{$ctrl.to.location}} ?</div><div class=\"font-size-13 mb-20\" \nng-if=\"$ctrl.type==\'load_weight\'\">\nDo you want to Change Charged Wt: {{$ctrl.from.load_meta.chargeable_weight | currencyMask: 2 || 0}} {{$ctrl.from.load_meta.calculated_weight_unit}} to Charged Wt: {{$ctrl.to.load_meta.chargeable_weight | currencyMask: 2 || 0}} {{$ctrl.to.calculated_weight_unit}} ?\n</div><div layout=\"row\" class=\"mb-20\"><div><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"$ctrl.includeRateCards\" ng-disabled=\"$ctrl.type!=\'location\'\" \nng-click=\"$ctrl.validationObj.originPortValidation=false;$ctrl.validationObj.destinationPortValidation=false\" \nclass=\"md-primary\"></md-checkbox></div><div layout=\"column\"><div class=\"font-size-13\">Include Rate Cards</div><div \nclass=\"font-size-11 fg-AFAFAF\">By checking this checkbox will reflect in all rate card</div></div></div><div \nlayout=\"row\" ng-if=\"$ctrl.param==\'origin\' && ($ctrl.isOriginDoor)\"><div class=\"mr-10\"><img \nsrc=\"assets/icons/custom/ic_map_24px.svg\"></div><div layout=\"column\"><div><div class=\"font-size-13\">Place Of Receipt\n</div><md-input-container md-no-float class=\"panel-select\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.originPortValidation}\" \nng-keyup=\"$ctrl.validationObj.originPortValidation=false\"><md-icon ng-if=\"$ctrl.validationObj.originPortValidation\" \nmdprefix class=\"mh-5 h-15 w-15 mt-2\" md-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nng-if=\"$ctrl.originPortdata.place_type == \'Port\' && $ctrl.originPortdata.port_code\" class=\"icon-align\" \nmd-svg-src=\"assets/icons/custom/search-bar/port.svg\"></md-icon><md-icon \nng-if=\"!$ctrl.originPortdata.port_code && !$ctrl.validationObj.originPortValidation\" class=\"empty-circle-icon\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete \nmd-selected-item=\"$ctrl.originPortdata\" md-selected-item-change=\"vm.checkForSamePorts(\'origin\',$ctrl.originPortdata);\" \nmd-input-name=\"card_origin_door\" md-search-text=\"$ctrl.card_originDoorSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originDoorSearchText,$ctrl.searchParam.mode, \'origin\',\'P2P\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" \nmd-require-match=\"true\" placeholder=\"Enter Place Of Receipt\" md-menu-class=\"autocomplete-custom-template\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_originSearchText}}\" were found.</md-not-found></md-autocomplete></md-input-container>\n<div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.originPortValidation\"><span>Enter Place Of Receipt</span>\n</div></div></div></div><div layout=\"row\" ng-if=\"$ctrl.param==\'destination\' && ($ctrl.isDestinationDoor) \"><div \nclass=\"mr-10\"><img src=\"assets/icons/custom/ic_map_24px.svg\"></div><div layout=\"column\"><div \nng-if=\"$ctrl.param==\'destination\'\"><div class=\"font-size-13\">Destination Port</div><md-input-container md-no-float \nclass=\"panel-select\" ng-class=\"{\'validation-error\':($ctrl.validationObj.destinationPortValidation)}\" \nng-keyup=\"$ctrl.validationObj.destinationPortValidation=false\"><md-icon \nng-if=\"$ctrl.validationObj.destinationPortValidation\" mdprefix class=\"mh-5 h-15 w-15 mt-2\" \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\"></md-icon><md-icon \nng-if=\"$ctrl.destinationPortdata.place_type == \'Port\' && $ctrl.destinationPortdata.port_code\" class=\"icon-align\" \nmd-svg-src=\"assets/icons/custom/search-bar/port.svg\"></md-icon><md-icon \nng-if=\"!$ctrl.destinationPortdata.port_code && !$ctrl.validationObj.destinationPortValidation\" \nclass=\"empty-circle-icon\" md-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete \nmd-input-name=\"card_destination_door\" md-selected-item=\"$ctrl.destinationPortdata\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace(\'destination\',$ctrl.destinationPortdata)\" \nmd-search-text=\"$ctrl.card_destinationWetSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationWetSearchText,$ctrl.searchParam.mode, \'destination\',\'P2P\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" \nmd-require-match=\"true\" placeholder=\"Enter Destination Port\" md-menu-class=\"autocomplete-custom-template\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{$ctrl.card_destinationWetSearchText}}\" were found.</md-not-found></md-autocomplete>\n</md-input-container><div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.destinationPortValidation\"><span>\nEnter Destination Port</span></div></div></div></div></md-dialog-content></div><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary-btn ml-10\" title=\"CANCEL\" ng-click=\"$ctrl.closePanel(\'close\')\">No</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" ng-click=\"$ctrl.submitPanel(\'submit\',confirmationForm)\" \nng-disabled=\"ctrl.parent.yesBtn\">Yes,Proceed</md-button></md-dialog-actions></form>");
$templateCache.put("app/main/quotes/components/duplicate-quote-footer/duplicate-quote-footer.html","<div id=\"duplicate-footer\" class=\"footer-content md-primary-bg white-fg bg-535353\"><div \nng-if=\"$ctrl.selectedduplicatecard.length && $ctrl.isduplicatequote\" class=\"card_shadow\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\" layout-wrap><div flex=\"30\" flex-xs=\"100\" layout=\"row\" layout-align=\"start center\" class=\"ml-15 mt-5 h-35\">\n<div class=\"added-quote-count\">{{$ctrl.selectedduplicatecard.length}}</div><div \nclass=\"pl-10 font-size-16 font-weight-600\">Rate Card Selected</div><div class=\"pl-5 font-size-16 font-weight-600\">\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"s22 fg-3F3851 pointer duplicate\"></md-icon><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 p-10\" style=\"display:table;opacity: 1\" \nng-mouseover=\"$ctrl.proceedCopyQuote($event,\'tooltip\')\"><div ng-repeat=\"liner in $ctrl.linerdata\"><div \nclass=\"font-size-13\">{{liner.vendor_name}}</div></div></md-tooltip></div></div><div flex layout=\"row\" \nlayout-align=\"end end\" ng-if=\"!$ctrl.copyquoted\"><md-button md-no-ink class=\"remove-cancel-button mr-10 w-100\" \ntitle=\"Remove\" ng-click=\"$ctrl.proceedCopyQuote($event,\'remove\')\">Remove All</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10 w-100\" title=\"copyQuote\" ng-click=\"$ctrl.proceedCopyQuote($event,\'copyQuote\')\" \nng-disabled=\"!$ctrl.selectedduplicatecard.length\">Copy Quote</md-button></div><div flex layout=\"row\" \nlayout-align=\"end end\" ng-if=\"$ctrl.copyquoted\"><md-button md-no-ink class=\"remove-cancel-button mr-10 w-100\" \ntitle=\"Cancel\" ng-click=\"$ctrl.proceedCopyQuote($event,cancelCopiedQuote)\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10 w-100\" title=\"sendQuote\" ng-click=\"$ctrl.proceedCopyQuote($event, \'generateQuote\')\" \nng-disabled=\"!$ctrl.selectedduplicatecard.length\">Send Quote</md-button></div></div></div></div>");
$templateCache.put("app/main/quotes/components/filter-quote/filter-quote.html","<div id=\"filter-quotes\" layout=\"column\" flex=\"100\"><div class=\"w-100p\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/custom/filter-new.svg\" \nclass=\"w-20 h-20 filter-icon mr-10\"></md-icon><span class=\"font-size-16 Font-Bold fg-AAA8AD\" flex>Filters </span><a \nclass=\"font-size-13 pointer md-link-fg font-weight-600 clear-btn\" ng-if=\"!$ctrl.filterLoader\" \nng-click=\"$ctrl.resetFilter()\">Clear All</a><md-icon ng-if=\"$ctrl.quoteData.deviceName != \'laptop\'\" \nmd-font-icon=\"icon-close-circle-outline\" class=\"s20 pointer ml-5 md-link-fg\" \nng-click=\"$ctrl.toggleSideNav(\'quoteRight\')\"></md-icon></div><md-divider></md-divider><div class=\"content no-padding\">\n<div shimmer-effect-full width=\"95%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" ng-if=\"$ctrl.filterLoader\" \nng-repeat=\"shimmer in [1,2,3,4,5,6,7,8,9]\"></div><md-list ng-if=\"!$ctrl.filterLoader\" class=\"no-padding\"><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex \nclass=\"ph-20 pt-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-10\" \nng-click=\"searchStatus=\'\';\"><div><span class=\"font-size-14 font-weight-600\">Status</span> <span \nng-if=\"$ctrl.filterobj.status\" class=\"filter-count md-component-bg white-fg\">1</span></div></div><div \nid=\"quotes_status\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><input \nng-model=\"searchStatus\" type=\"search\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Search status\" class=\"font-size-12 font-primary-fg input-search\" ng-keydown=\"$event.stopPropagation()\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nclass=\"text-truncate status-label\" ng-repeat=\"status in $ctrl.filterListObject.status | filter: searchStatus\">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary radio-checkbox\" flex \nng-checked=\"$ctrl.filterobj.status.indexOf(status.status) > -1\" \nng-click=\"$ctrl.filterItemtoggle(status, $ctrl.filterobj, \'status\', \'radio\');\">{{status.status}}<md-tooltip \nmd-direction=\"right\" md-delay=\"300\">{{status.status}}</md-tooltip></md-checkbox></div></div></div></md-list-item>\n<md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex \nclass=\"p-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex class=\"mb-15\"><div><span \nclass=\"font-size-14 font-weight-600\">Mode</span> <span ng-if=\"$ctrl.filterobj.mode.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{$ctrl.filterobj.mode.length}}</span></div></div><div \nclass=\"hide-comment\" id=\"quotes_mode\"><div class=\"font-size-14 black-fg\" \nng-repeat=\"mode in $ctrl.filterListObject.mode\"><md-checkbox md-no-ink=\"true\" class=\"md-primary\" \nng-checked=\"$ctrl.filterobj.mode.indexOf(mode) > -1\" \nng-click=\"$ctrl.filterItemtoggle(mode, $ctrl.filterobj, \'mode\', \'\')\">{{mode}}</md-checkbox></div></div></div>\n</md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.filterListObject.integrations.length > 0 && $ctrl.tms_enabled\"><div layout=\"column\" flex \nclass=\"ph-20 pt-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span\n class=\"font-size-14 font-weight-600\">TMS</span> <span ng-if=\"$ctrl.filterobj.integrations.length\" \nclass=\"filter-count md-component-bg white-fg\">{{$ctrl.filterobj.integrations.length}}</span></div></div><div \nid=\"inq_mode\"><div class=\"font-size-14 black-fg\" ng-repeat=\"status in $ctrl.filterListObject.integrations\"><md-checkbox\n md-no-ink=\"true\" class=\"md-primary\" ng-checked=\"$ctrl.filterobj.integrations.indexOf(status) > -1\" \nng-click=\"$ctrl.filterItemtoggle(status, $ctrl.filterobj, \'integrations\', \'\')\">{{status}}</md-checkbox></div></div>\n</div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span\n class=\"font-size-14 font-weight-600\">Date Range</span><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mb-2 grey-fg pointer\"><md-tooltip md-direction=\"right\" md-delay=\"300\">Created On</md-tooltip></md-icon><span\n ng-if=\"$ctrl.filterobj.date_range.from || $ctrl.filterobj.date_range.to\" \nclass=\"filter-count md-component-bg white-fg\">1</span></div></div><div id=\"quote_created\" class=\"hide-comment\">\n<date-range-picker md-input-id=\"\'quote_date_range\'\" callback=\"$ctrl.setDatePicker(date)\" \ndate-range-value=\"$ctrl.filterobj.date_range\" is-reset-date-picker=\"$ctrl.quoteData.isResetFilter\"></date-range-picker>\n</div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.filterListObject.templates !== null && $ctrl.util.navPermission.quotes && $ctrl.util.navPermission.quotes[2] && !$ctrl.util.isShipper\">\n<div layout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div>\n<span class=\"font-size-14 font-weight-600\">Template</span> <span \nng-if=\"$ctrl.templateNameFilterConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{$ctrl.templateNameFilterConditions.selectedCount}}</span></div></div><div id=\"template_name\" class=\"hide-comment\">\n<multi-select-chips md-input-id=\"\'template-filter\'\" options-data-obj=\"$ctrl.filterListObject.templates\" \nquery-conditions=\"$ctrl.templateNameFilterConditions\" page-source=\"\" callback=\"$ctrl.callBackTemplateFilter(payload)\">\n</multi-select-chips></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex ng-if=\"$ctrl.filterListObject.created_by !== null\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Created By</span> <span ng-if=\"$ctrl.createdByFilterConditions.selectedCount\" \nclass=\"filter-count md-component-bg white-fg\">{{$ctrl.createdByFilterConditions.selectedCount}}</span></div></div><div \nid=\"created_by\" class=\"hide-comment\"><multi-select-chips md-input-id=\"\'created-by-filter\'\" \noptions-data-obj=\"$ctrl.filterListObject.created_by\" query-conditions=\"$ctrl.createdByFilterConditions\" \npage-source=\"\'QL-Filter-CreatedBy-Change\'\" callback=\"$ctrl.callBackCreatedBy(payload)\"></multi-select-chips></div>\n</div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.filterListObject.incoterms !== null\"><div layout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div \nlayout=\"row\" layout-align=\"space-between\" flex><div><span class=\"font-size-14 font-weight-600\">Incoterms</span> <span \nng-if=\"$ctrl.incoTermsConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{$ctrl.incoTermsConditions.selectedCount}}</span></div></div><div id=\"inco_terms\" class=\"hide-comment\">\n<multi-select-chips md-input-id=\"\'inco-terms-filter\'\" options-data-obj=\"$ctrl.filterListObject.incoterms\" \nquery-conditions=\"$ctrl.incoTermsConditions\" page-source=\"\" callback=\"$ctrl.callBackIncoTerms(payload)\">\n</multi-select-chips></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex ng-if=\"$ctrl.filterListObject.customer_details !== null\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Customer Details</span> <span \nng-if=\"$ctrl.customerFilterConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{$ctrl.customerFilterConditions.selectedCount}}</span></div></div><div id=\"customer_details\" class=\"hide-comment\">\n<multi-select-chips md-input-id=\"\'customer-details-filter\'\" options-data-obj=\"$ctrl.filterListObject.customer_details\" \nquery-conditions=\"$ctrl.customerFilterConditions\" page-source=\"\" callback=\"$ctrl.callBackCustomer(payload)\">\n</multi-select-chips></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex ng-if=\"$ctrl.filterListObject.origin !== null\"><div layout=\"column\" flex \nclass=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div><span \nclass=\"font-size-14 font-weight-600\">Origin</span> <span ng-if=\"$ctrl.originFilterConditions.selectedCount\" \nclass=\"filter-count md-component-bg white-fg\">{{$ctrl.originFilterConditions.selectedCount}}</span></div></div><div \nid=\"origin\" class=\"hide-comment\"><multi-select-chips md-input-id=\"\'origin-filter\'\" \noptions-data-obj=\"$ctrl.filterListObject.origin\" query-conditions=\"$ctrl.originFilterConditions\" page-source=\"\" \ncallback=\"$ctrl.callBackOrigin(payload)\"></multi-select-chips></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"$ctrl.filterListObject.destination !== null\">\n<div layout=\"column\" flex class=\"ph-20 pv-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex><div>\n<span class=\"font-size-14 font-weight-600\">Destination</span> <span ng-if=\"$ctrl.destFilterConditions.selectedCount\" \nclass=\"filter-count md-component-bg white-fg\">{{$ctrl.destFilterConditions.selectedCount}}</span></div></div><div \nid=\"destination\" class=\"hide-comment\"><multi-select-chips md-input-id=\"\'destination-filter\'\" \noptions-data-obj=\"$ctrl.filterListObject.destination\" query-conditions=\"$ctrl.destFilterConditions\" page-source=\"\" \ncallback=\"$ctrl.callBackDestination(payload)\"></multi-select-chips></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"$ctrl.filterListObject.load_details !== null && ($ctrl.filterobj.mode.indexOf(\'SEA-FCL\') > -1 || $ctrl.filterobj.mode.length === 0)\">\n<div layout=\"column\" flex class=\"p-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex \nclass=\"mb-0\"><div><span class=\"font-size-14 font-weight-600\">Load Details</span> <span \nng-if=\"$ctrl.filterobj.load_types.length\" class=\"filter-count font-size-10 white-fg ml-5\">\n{{$ctrl.filterobj.load_types.length}}</span></div></div><div class=\"hide-comment\" id=\"quotes_load_details\">\n<multi-select-chips md-input-id=\"\'loadType-filter\'\" options-data-obj=\"$ctrl.filterListObject.load_details\" \nquery-conditions=\"$ctrl.loadTypeFilterConditions\" page-source=\"\" callback=\"$ctrl.callBackLoadType(payload)\">\n</multi-select-chips></div></div></md-list-item></md-list></div></div></div>");
$templateCache.put("app/main/quotes/components/terms-condition-popup/terms-condition-popup.html","<div layout=\"row\" class=\"header\" flex=\"100\"><div class=\"p-0 heading-text\" flex=\"90\" flex-xs=\"90\">Terms and Conditions\n</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size p-0\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"$ctrl.cancelDialog(\'cancel\')\"></md-icon></div></div><form><div \nlayout=\"row\"><md-dialog-content class=\"body\" flex=\"100\"><div class=\"quote-editor\"><ng-ckeditor \nng-model=\"$ctrl.termsCondition\" ng-config=\"$ctrl.termsConditionCkEditorConfig\"></ng-ckeditor></div></md-dialog-content>\n</div><md-dialog-actions><md-button ng-if=\"$ctrl.quoteType !=\'quote\'\" md-no-ink class=\"md-accent-btn ml-10\" \ntype=\"submit\" title=\"CONFIRM\" ng-click=\"$ctrl.submitTermsCondition();\">Done</md-button></md-dialog-actions></form>");
$templateCache.put("app/main/quotes/dialogs/add-new-rate/add-new-rate.html","<div layout=\"row\" layout-padding class=\"header\" flex=\"100\" ng-show=\"$ctrl.isAddNewRateLoaded\"><div class=\"p-0\" \nflex=\"100\">{{$ctrl.headingText}}</div><div layout=\"row\" class=\"p-0\" layout-align=\"end end\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD m-0 pointer\" ng-click=\"$ctrl.cancelDialog();\"></md-icon></div></div>\n<md-dialog-content class=\"body\" ng-show=\"$ctrl.isAddNewRateLoaded\"><div ng-show=\"$ctrl.screenNumber == 1\"><form \nname=\"newRateForm\"><div id=\"meta-content\" layout=\"column\" flex=\"100\"><div layout=\"row\" \nng-if=\"$ctrl.addNewCard.meta.port_data.empty_container_pickup\"><md-icon \nmd-svg-src=\"assets/icons/custom/pickup-truck.svg\" class=\"icon-bs\"></md-icon><div layout=\"row\" layout-wrap flex=\"100\">\n<div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label>Empty Container Pickup</label><md-input-container \nmd-no-float class=\"panel-select\" ng-class=\"{\'validation-error\':$ctrl.validationObj.emptyPickupValidation}\" \nng-keyup=\"$ctrl.validationObj.emptyPickupValidation=false\"><md-icon ng-if=\"$ctrl.selectedPickupContainer\" \nclass=\"icon-align\" \nmd-svg-src=\"{{$ctrl.selectedPickupContainer.place_type == \'Door\' ? \'assets/icons/custom/search-bar/door_img.svg\' : ($ctrl.searchParam.mode != \'SEA-LCL\' ? ($ctrl.selectedPickupContainer.is_icd_port ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\'):\'assets/icons/custom/search-bar/lcl_port.svg\') }}\">\n</md-icon><md-icon ng-if=\"!$ctrl.selectedPickupContainer\" class=\"empty-circle-icon\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete \nmd-selected-item=\"$ctrl.selectedPickupContainer\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedPickupContainer, \'Pickup_container\')\" \nmd-input-name=\"card_pickup_container\" md-search-text=\"$ctrl.card_pickupContainerSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_pickupContainerSearchText,$ctrl.searchParam.mode, \'origin\',\'D2D\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Empty Container Pickup\" md-menu-class=\"autocomplete-custom-template-add\" \nmd-menu-container-class=\"custom-container\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"pl-8 p-5\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</span><span class=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div layout=\"column\" class=\"pl-8 p-5\" \nng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" ng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\">\n<span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                                                       track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span> <span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                                              track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span> \n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></span></md-item-template>\n<md-not-found>No ports matching \"{{$ctrl.card_pickupContainerSearchText}}\" were found.</md-not-found></md-autocomplete>\n<md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.selectedPickupContainer\"><div \nng-if=\"$ctrl.selectedPickupContainer && $ctrl.selectedPickupContainer._id\">\n{{$ctrl.selectedPickupContainer.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.selectedPickupContainer, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.selectedPickupContainer, true).join(\',\'):$ctrl.selectedPickupContainer.location)}}\n</div><div ng-if=\"$ctrl.selectedPickupContainer && !$ctrl.selectedPickupContainer._id\">\n{{$ctrl.selectedPickupContainer}}</div></md-tooltip></md-input-container><div class=\"validation-error-text\" \nng-if=\"$ctrl.validationObj.emptyPickupValidation\"><span>{{$ctrl.errorTextObj.emptyPickupErrorText}}</span></div></div>\n</div></div><div layout=\"row\" ng-if=\"$ctrl.searchParam.origin_location.place_type == \'Door\'\"><md-icon \nmd-svg-src=\"assets/icons/custom/search-bar/door.svg\" class=\"icon-bs\"></md-icon><div layout=\"row\" layout-wrap \nflex=\"100\"><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label>Pickup Door</label><md-input-container \nmd-no-float class=\"panel-select\" ng-class=\"{\'validation-error\':$ctrl.validationObj.originDoorValidation}\" \nng-keyup=\"$ctrl.validationObj.originDoorValidation=false\"><md-icon \nng-if=\"($ctrl.addNewCard.meta.port_data.pickup_location || $ctrl.addNewCard.meta.port_data.pickup_pincode_ui)\" \nclass=\"icon-align\" \nmd-svg-src=\"{{$ctrl.selectedOriginDoor && $ctrl.selectedOriginDoor.place_type == \'Port\' ? ($ctrl.selectedOriginDoor.is_icd_port ? \'assets/icons/custom/search-bar/icd.svg\' : \'assets/icons/custom/search-bar/port.svg\') :\'assets/icons/custom/search-bar/door_img.svg\'}}\">\n</md-icon><md-icon \nng-if=\"!($ctrl.addNewCard.meta.port_data.pickup_location || $ctrl.addNewCard.meta.port_data.pickup_pincode_ui)\" \nclass=\"empty-circle-icon\" md-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete \nmd-selected-item=\"$ctrl.selectedOriginDoor\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedOriginDoor, \'origin_door\')\" \nmd-input-name=\"card_origin_door\" md-search-text=\"$ctrl.card_originDoorSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originDoorSearchText,$ctrl.searchParam.mode, \'origin\',\'D2D\')\" \nmd-item-text=\"($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.portcode_portname)\" \nmd-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Pickup Door\" md-menu-class=\"autocomplete-custom-template-add\" md-menu-container-class=\"custom-container\">\n<md-item-template><span class=\"item-metadata\"><div layout=\"column\" class=\"pl-8 p-5\" ng-if=\"$ctrl.isPcmsEnabled\"><div \nlayout=\"row\" ng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                                                                               track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span><span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                                                                      track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span>\n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></span></md-item-template>\n<md-not-found>No ports matching \"{{$ctrl.card_originDoorSearchText}}\" were found.</md-not-found></md-autocomplete>\n<md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.selectedOriginDoor\"><div \nng-if=\"$ctrl.selectedOriginDoor &&  $ctrl.selectedOriginDoor._id\">\n{{$ctrl.selectedOriginDoor.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.selectedOriginDoor, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.selectedOriginDoor, true).join(\',\'):$ctrl.selectedOriginDoor.location)}}\n</div><div ng-if=\"$ctrl.selectedOriginDoor && !$ctrl.selectedOriginDoor._id\">{{$ctrl.selectedOriginDoor}}</div>\n</md-tooltip></md-input-container><div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.originDoorValidation\">\n<span>{{$ctrl.errorTextObj.originDoorErrorText}}</span></div></div><div class=\"feild-spacing min-width-130\" \nflex-xs=\"100\" flex=\"20\"><label>Pickup Service Type</label><md-input-container class=\"panel-select\" md-no-float><input \nng-model=\"$ctrl.addNewCard.meta.pickup_service\" placeholder=\"Enter Service Type\"></md-input-container></div><div \nclass=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label>Pickup Haulage</label><span \nclass=\"panel-select haulage-margin\" layout=\"row\"><md-icon class=\"haulage-icon\" \nng-if=\"$ctrl.addNewCard.meta.pickup_transport_mode && ($ctrl.addNewCard.meta.pickup_transport_mode.toLowerCase() == \'road\' || $ctrl.addNewCard.meta.pickup_transport_mode.toLowerCase() == \'barge\' || $ctrl.addNewCard.meta.pickup_transport_mode.toLowerCase() == \'rail\' || $ctrl.addNewCard.meta.pickup_transport_mode.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+$ctrl.addNewCard.meta.pickup_transport_mode.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon><md-select ng-model=\"$ctrl.addNewCard.meta.pickup_transport_mode\" \nng-change=\"$ctrl.fnTransporterChanged($ctrl.addNewCard.meta.pickup_transport_mode, $ctrl.l1_leg);\" name=\"haulage\" \nplaceholder=\"Select Pickup Haulage\"><md-option ng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">\n{{haulage}}</md-option></md-select></span></div><div class=\"feild-spacing min-width-130\" flex-xs=\"100\" flex=\"20\">\n<label>Pickup Transporter</label><md-input-container md-no-float class=\"panel-select\"><md-icon \nng-if=\"$ctrl.selectedPickupTransporter\" md-svg-src=\"assets/icons/custom/user-icon.svg\" class=\"icon-align\"></md-icon>\n<md-select md-no-asterisk ng-model=\"$ctrl.selectedPickupTransporter\" \nng-class=\"{\'user-icon\':$ctrl.selectedPickupTransporter}\" \nng-change=\"$ctrl.fngetTransporterDetails($ctrl.addNewCard.meta, $ctrl.selectedPickupTransporter, \'pickup_sub_vendor\' , $ctrl.getL1Subvendor)\" \nname=\"l1_sub_vendor_id\" placeholder=\"Pickup Transporter\" md-on-close=\"searchl1SubVendor = \'\'\"><md-select-header><input \nng-model=\"searchl1SubVendor\" type=\"search\" placeholder=\"Pickup Transporter\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\" ng-change=\"$ctrl.fnGetLinerList(searchl1SubVendor , \'l1\');\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n</md-select-header><md-option ng-repeat=\"subvendor in $ctrl.getL1Subvendor | orderBy:\'name\' \" ng-value=\"subvendor.id\" \ntitle=\"{{subvendor.name}}\">{{subvendor.name}}</md-option></md-select></md-input-container></div></div></div><div \nlayout=\"row\"><md-icon md-svg-src=\"assets/icons/custom/port-aaa8ad.svg\" class=\"icon-bs\"></md-icon><div layout=\"row\" \nlayout-wrap flex=\"100\"><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label ng-if=\"$ctrl.isOriginDryPort\">\nPort of Origin</label><label ng-if=\"!$ctrl.isOriginDryPort\">Port of Loading</label><md-input-container md-no-float \nclass=\"panel-select\" ng-class=\"{\'validation-error\':$ctrl.validationObj.originPortValidation}\" \nng-keyup=\"$ctrl.validationObj.originPortValidation=false\"><md-icon \nng-if=\"$ctrl.addNewCard.meta.port_data.origin_port_code\" class=\"icon-align\" \nmd-svg-src=\"{{$ctrl.searchParam.mode != \'AIR\' ? ($ctrl.searchParam.mode != \'SEA-LCL\' ? ($ctrl.selectedOrigin && $ctrl.selectedOrigin.is_icd_port ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\'):\'assets/icons/custom/search-bar/lcl_port.svg\') : \'assets/icons/custom/search-bar/air_pod.svg\'}}\">\n</md-icon><md-icon ng-if=\"!$ctrl.addNewCard.meta.port_data.origin_port_code\" class=\"empty-circle-icon\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete md-input-name=\"card_origin_port\" \nmd-selected-item=\"$ctrl.selectedOrigin\" md-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedOrigin,\'origin\')\" \nmd-search-text=\"$ctrl.card_originSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originSearchText,$ctrl.searchParam.mode, \'origin\')\" \nmd-item-text=\"$ctrl.util.portSelectedData(item, false).join(\', \')\" md-min-length=\"2\" md-clear-button=\"false\" \nmd-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"{{$ctrl.isOriginDryPort ? \'Enter Port of Origin\' : \'Enter Port of Loading\'}}\" \nmd-menu-class=\"autocomplete-custom-template-add\" md-menu-container-class=\"custom-container\"><md-item-template><span \nclass=\"item-metadata\"><div class=\"pl-8 p-5\"><div class=\"black-fg font-size-13\" \ncompile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div class=\"grey-fg font-size-11\">\n{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div></span></md-item-template>\n<md-not-found>No ports matching \"{{$ctrl.card_originSearchText}}\" were found.</md-not-found></md-autocomplete>\n<md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.selectedOrigin\"><div \nng-if=\"$ctrl.selectedOrigin && $ctrl.selectedOrigin._id\">\n{{$ctrl.util.portSelectedData($ctrl.selectedOrigin, true).join(\', \')}}</div><div \nng-if=\"$ctrl.selectedOrigin && !$ctrl.selectedOrigin._id\">{{$ctrl.selectedOrigin}}</div></md-tooltip>\n</md-input-container><div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.originPortValidation\"><span>\n{{$ctrl.errorTextObj.originPortErrorText}}</span></div></div><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\" \nng-if=\"$ctrl.isOriginDryPort\"><label>Origin Haulage</label><span class=\"panel-select haulage-margin\" layout=\"row\">\n<md-icon class=\"haulage-icon\" \nng-if=\"$ctrl.addNewCard.meta.haulage && ($ctrl.addNewCard.meta.haulage.toLowerCase() == \'road\' || $ctrl.addNewCard.meta.haulage.toLowerCase() == \'barge\' ||  $ctrl.addNewCard.meta.haulage.toLowerCase() == \'truck\' || $ctrl.addNewCard.meta.haulage.toLowerCase() == \'rail\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+$ctrl.addNewCard.meta.haulage.toLowerCase()+\'_haulage.svg\'}}\"></md-icon><md-select\n ng-model=\"$ctrl.addNewCard.meta.haulage\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nname=\"haulage\" placeholder=\"Select Origin Haulage\"><md-option ng-repeat=\"haulage in $ctrl.util.haulageList\" \nng-value=\"haulage\">{{haulage}}</md-option></md-select></span></div><div class=\"feild-spacing\" flex-lg=\"20\" \nflex-xs=\"100\" ng-if=\"$ctrl.isOriginDryPort\"><label>Port of Loading</label><md-input-container md-no-float \nclass=\"panel-select\" ng-class=\"{\'validation-error\':$ctrl.validationObj.polValidation}\" \nng-keyup=\"$ctrl.validationObj.polValidation=false\"><md-icon ng-if=\"$ctrl.addNewCard.meta.via_pol\" class=\"icon-align\" \nmd-svg-src=\"{{$ctrl.searchParam.mode != \'AIR\' ?($ctrl.searchParam.mode != \'SEA-LCL\'? ($ctrl.selectedPOL && $ctrl.selectedPOL.is_icd_port ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\'):\'assets/icons/custom/search-bar/lcl_port.svg\') : \'assets/icons/custom/search-bar/air_pod.svg\'}}\">\n</md-icon><md-icon ng-if=\"!$ctrl.addNewCard.meta.via_pol\" class=\"empty-circle-icon\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete md-selected-item=\"$ctrl.selectedPOL\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedPOL, \'pol\')\" md-input-name=\"card_origin_wet_port\" \nmd-search-text=\"$ctrl.card_originWetPortSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_originWetPortSearchText,$ctrl.searchParam.mode, \'origin\')\" \nmd-item-text=\"$ctrl.util.portSelectedData(item, false).join(\', \')\" md-min-length=\"2\" md-clear-button=\"false\" \nmd-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" placeholder=\"Enter Port of Loading\" \nmd-menu-class=\"autocomplete-custom-template-add\" md-menu-container-class=\"custom-container\"><md-item-template><span \nclass=\"item-metadata\"><div class=\"pl-8 p-5\"><div class=\"black-fg font-size-13\" \ncompile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div class=\"grey-fg font-size-11\">\n{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div></span></md-item-template>\n<md-not-found>No ports matching \"{{$ctrl.card_originWetPortSearchText}}\" were found.</md-not-found></md-autocomplete>\n<md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.selectedPOL\"><div \nng-if=\"$ctrl.selectedPOL && $ctrl.selectedPOL._id\">\n{{$ctrl.selectedPOL.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.selectedPOL, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.selectedPOL, true).join(\',\'):$ctrl.selectedPOL.location)}}\n</div><div ng-if=\"$ctrl.selectedPOL && !$ctrl.selectedPOL._id\">{{$ctrl.selectedPOL}}</div></md-tooltip>\n</md-input-container><div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.polValidation\"><span>\n{{$ctrl.errorTextObj.polErrorText}}</span></div></div><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label>T/S\n</label><md-input-container class=\"panel-select viaPort\" md-no-float><input \nng-model=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.via_route\" placeholder=\"Enter T/S\">\n</md-input-container></div></div></div><div layout=\"row\"><md-icon md-svg-src=\"assets/icons/custom/liner-aaa8ad.svg\" \nclass=\"icon-bs\" ng-if=\"$ctrl.searchParam.mode != \'AIR\'\"></md-icon><md-icon \nmd-svg-src=\"assets/icons/custom/roll-o-plane.svg\" class=\"icon-bs icon-rotate\" ng-if=\"$ctrl.searchParam.mode == \'AIR\'\">\n</md-icon><div layout=\"row\" layout-wrap><div class=\"feild-spacing min-width-170\" flex=\"20\" flex-xs=\"100\" \nng-if=\"$ctrl.searchParam.mode != \'AIR\'\"><label>Liner/Carrier</label><md-input-container md-no-float><md-select \nmd-no-asterisk ng-class=\"{\'validation-error\':$ctrl.validationObj.linerValidation}\" class=\"panel-select\" \nmd-on-open=\"$ctrl.validationObj.linerValidation=false\" ng-model=\"$ctrl.selectedLiner\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.addNewCard.meta, $ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj)\" \nname=\"sub_vendor_id\" placeholder=\"Select Liner\" md-on-close=\"searchSubVendor = \'\'\"><md-select-header><input \nng-model=\"searchSubVendor\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \ntype=\"search\" placeholder=\"Select Liner\" ng-change=\"$ctrl.fnGetLinerList(searchSubVendor , \'l3\');\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><div layout=\"column\" flex=\"100\" \nlayout-wrap layout-align=\"center center\" ng-if=\"$ctrl.filterLoader\" class=\"mv-20 pt-10\"><md-progress-circular \nmd-diameter=\"25\"></md-progress-circular></div><md-option ng-repeat=\"subvendor in $ctrl.getSubvendor | orderBy:\'name\'\" \nng-value=\"subvendor.id\" title=\"{{subvendor.name}}\">{{subvendor.name}}</md-option></md-select><div \nclass=\"validation-error-text\" ng-if=\"$ctrl.validationObj.linerValidation\"><span>Select Liner</span></div>\n</md-input-container></div><div flex-xs=\"100\" flex=\"20\" class=\"feild-spacing min-width-170\" \nng-if=\"$ctrl.searchParam.mode == \'AIR\'\"><label>Airline</label><div shimmer-effect-full width=\"180px\" class=\"pt-5\" \nheight=\"35px\" ng-if=\"!$ctrl.loadSlowly\"></div><md-input-container md-no-float ng-if=\"$ctrl.loadSlowly\"><md-select \nmd-no-asterisk class=\"panel-select\" ng-class=\"{\'validation-error\':$ctrl.validationObj.airlinerValidation}\" \nmd-on-open=\"$ctrl.validationObj.airlinerValidation=false\" ng-model=\"$ctrl.selectedAirline\" \nng-change=\"$ctrl.fngetSubVendorDetails($ctrl.addNewCard.meta, $ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj)\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nname=\"airline_code\" placeholder=\"Select Airline\" md-on-close=\"searchAirline = \'\'\"><md-select-header><input \nng-model=\"searchAirline\" type=\"search\" placeholder=\"Select Airline\" ng-change=\"$ctrl.fnGetAirlineData(searchAirline)\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><div layout=\"column\" flex=\"100\" \nlayout-wrap layout-align=\"center center\" ng-if=\"$ctrl.filterLoader\" class=\"mv-20 pt-10\"><md-progress-circular \nmd-diameter=\"25\"></md-progress-circular></div><md-option ng-repeat=\"airline in $ctrl.getSubvendor | orderBy:\'name\'\" \nng-value=\"airline.code\" title=\"{{airline.name}}\">\n{{airline.name}} ({{airline.code ? airline.code : \'-\'}} / {{airline.prefix ? airline.prefix : \'-\'}})</md-option>\n</md-select><div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.airlinerValidation\"><span>Select Airline\n</span></div></md-input-container></div><div class=\"feild-spacing min-width-130\" flex-xs=\"100\" flex=\"10\"><label>\nService Type</label><md-input-container class=\"panel-select\" md-no-float><input \nng-model=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.service_type\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nplaceholder=\"Enter Service Type\"></md-input-container></div><div class=\"feild-spacing min-width-130\" flex-xs=\"100\" \nflex=\"15\" ng-if=\"$ctrl.searchParam.mode == \'SEA-FCL\'\"><label>Origin Service Mode</label>\n{{$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.origin_service_mode}}<md-input-container \nclass=\"panel-select\" md-no-float><md-select \nng-model=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.origin_service_mode\" \nplaceholder=\"Select Origin Service Mode\"><md-option ng-repeat=\"service_mode in $ctrl.serviceModeList\" \nng-value=\"service_mode.code\">{{service_mode.name}}</md-option></md-select></md-input-container></div><div \nclass=\"feild-spacing min-width-130\" flex-xs=\"100\" flex=\"20\" ng-if=\"$ctrl.searchParam.mode == \'SEA-FCL\'\"><label>\nDestination Service Mode</label><md-input-container class=\"panel-select\" md-no-float><md-select \nng-model=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.destination_service_mode\" \nplaceholder=\"Select Destination Service Mode\"><md-option ng-repeat=\"service_mode in $ctrl.serviceModeList\" \nng-value=\"service_mode.code\">{{service_mode.name}}</md-option></md-select></md-input-container></div><div \nclass=\"feild-spacing min-width-100\" flex-xs=\"100\" flex=\"5\"><div><label>Transit Time</label></div><span layout=\"row\" \nclass=\"pt-5\"><input type=\"number\" class=\"panel-select input-panel-padding\" \nng-model=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.transit_time\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nplaceholder=\"0\"></span></div><div class=\"feild-spacing\" flex-xs=\"100\" flex=\"12\" \nng-if=\"$ctrl.searchParam.mode != \'AIR\'\"><label>Sailing Date</label><date-picker \nmodel-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.sailing_date\" \nis-validate=\"((newRateForm.sailing_date.$touched && newRateForm.sailing_date.$error.valid) || $ctrl.validationObj.sailingValidation)\" \nmd-input-id=\"\'sailing_date\'\" is-editable=\"true\" is-disabled=\"false\" input-required=\"false\" full-border=\"true\" \ninput-name=\"\'sailing_date\'\" full-border=\"true\" date-placeholder=\"\'Select Date\'\" date-format=\"true\" \nmin-date-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.start_date\" \ncallback=\"$ctrl.fnDateSelection(value, \'sailing_date\');\"></date-picker><div \nng-messages=\"newRateForm.sailing_date.$touched && newRateForm.sailing_date.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"$ctrl.validationObj.sailingValidation && !newRateForm.sailing_date.$error.valid\" class=\"validation-error-text\">\n<span>Sailing date should be greater than or equal to start date.</span></div></div><div class=\"feild-spacing\" \nflex=\"12\" flex-xs=\"100\"><label>Start Date</label><date-picker \nmodel-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.start_date\" \nis-validate=\"(($ctrl.validationObj.startDateValidation) || (newRateForm.start_date.$touched && newRateForm.start_date.$error.valid))\" \nmd-input-id=\"\'start_date_new\'\" is-editable=\"true\" input-required=\"false\" full-border=\"true\" input-name=\"\'start_date\'\" \nfull-border=\"true\" date-placeholder=\"\'Start Date\'\" date-format=\"true\" \nmax-date-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.expiry\" \ncallback=\"$ctrl.fnDateSelection(value, \'start_date\')\"></date-picker><div \nng-if=\"newRateForm.start_date.$touched && newRateForm.start_date.$error.valid\" class=\"validation-error-text\"><span>\nSelect Valid Date</span></div><div \nng-if=\"$ctrl.validationObj.startDateValidation && !newRateForm.start_date.$error.valid\" class=\"validation-error-text\">\n<span>Start date should be less than or equal to expiry</span></div></div><div class=\"feild-spacing\" flex=\"12\" \nflex-xs=\"100\"><label>Expiry Date</label><date-picker \nmodel-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.expiry\" \nis-validate=\"(($ctrl.validationObj.expiryValidation) || (newRateForm.expiry.$touched && newRateForm.expiry.$error.valid))\" \nmd-input-id=\"\'expiry_new\'\" is-editable=\"$ctrl.addNewCard.meta.type.includes(\'spot\')\" input-required=\"false\" \nfull-border=\"true\" input-name=\"\'expiry\'\" full-border=\"true\" date-placeholder=\"\'Expiry Date\'\" date-format=\"true\" \nmin-date-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.start_date\" \ncallback=\"$ctrl.fnDateSelection(value, \'expiry\')\"></date-picker><div \nng-if=\"$ctrl.validationObj.expiryValidation && !$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.expiry\" \nclass=\"validation-error-text\"><span>Select Expiry Date</span></div><div \nng-messages=\"!$ctrl.validationObj.expiryValidation && newRateForm.expiry.$touched && newRateForm.expiry.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"$ctrl.validationObj.expiryValidation && $ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.expiry  && !newRateForm.expiry.$error.valid\" \nclass=\"validation-error-text\">Expiry should be greater than or equal to start date</div></div><div \nclass=\"feild-spacing\" flex-xs=\"100\" flex=\"18\" ng-if=\"$ctrl.searchParam.mode == \'AIR\'\"><label>ETD</label><date-picker \nmodel-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.departure_time\" \nis-validate=\"(($ctrl.validationObj.departureTimeValidation) || (newRateForm.departure_time.$touched && newRateForm.departure_time.$error.valid))\" \nmd-input-id=\"\'departure_time\'\" is-editable=\"true\" is-disabled=\"false\" input-required=\"false\" full-border=\"true\" \ninput-name=\"\'departure_time\'\" full-border=\"true\" date-placeholder=\"\'Select ETD\'\" date-format=\"true\" \ncallback=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.departure_time=value;$ctrl.validationObj.departureTimeValidation=false;\">\n</date-picker><div ng-messages=\"newRateForm.departure_time.$touched && newRateForm.departure_time.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div><div \nclass=\"feild-spacing\" flex-xs=\"100\" flex=\"18\" ng-if=\"$ctrl.searchParam.mode == \'AIR\'\"><label>ETA</label><date-picker \nmodel-value=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.arrival_time\" \nis-validate=\"(($ctrl.validationObj.arrivalTimeValidation) || (newRateForm.arrival_time.$touched && newRateForm.arrival_time.$error.valid))\" \nmd-input-id=\"\'arrival_time\'\" is-editable=\"true\" is-disabled=\"false\" input-required=\"false\" full-border=\"true\" \ninput-name=\"\'arrival_time\'\" full-border=\"true\" date-placeholder=\"\'Select ETA\'\" date-format=\"true\" \ncallback=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.arrival_time=value;$ctrl.validationObj.arrivalTimeValidation=false;\">\n</date-picker><div ng-messages=\"newRateForm.arrival_time.$touched && newRateForm.arrival_time.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><md-icon md-svg-src=\"assets/icons/custom/port-aaa8ad.svg\" class=\"icon-bs\">\n</md-icon><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\" ng-if=\"$ctrl.isDestinationDryPort\"><label>\nPort of Discharge</label><md-input-container md-no-float class=\"panel-select\" \nng-class=\"{\'validation-error\':($ctrl.validationObj.podValidation)}\" \nng-keyup=\"$ctrl.validationObj.podValidation=false;\"><md-icon ng-if=\"$ctrl.addNewCard.meta.via_pod\" class=\"icon-align\" \nmd-svg-src=\"{{$ctrl.searchParam.mode != \'AIR\' ?($ctrl.searchParam.mode != \'SEA-LCL\'? ($ctrl.selectedPOD && $ctrl.selectedPOD.is_icd_port ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\'):\'assets/icons/custom/search-bar/lcl_port.svg\') : \'assets/icons/custom/search-bar/air_pol.svg\'}}\">\n</md-icon><md-icon ng-if=\"!$ctrl.addNewCard.meta.via_pod\" class=\"empty-circle-icon\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete md-selected-item=\"$ctrl.selectedPOD\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedPOD, \'pod\')\" md-input-name=\"card_destination_wet_port\" \nmd-search-text=\"$ctrl.card_destinationWetSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationWetSearchText,$ctrl.searchParam.mode, \'destination\')\" \nmd-item-text=\"$ctrl.util.portSelectedData(item, false).join(\', \')\" md-min-length=\"2\" md-clear-button=\"false\" \nmd-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" placeholder=\"Enter Port of Discharge\" \nmd-menu-class=\"autocomplete-custom-template-add\" md-menu-container-class=\"custom-container\"><md-item-template><div \nclass=\"pl-8 p-5\"><div class=\"black-fg font-size-13\" \ncompile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div class=\"grey-fg font-size-11\">\n{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div></md-item-template>\n<md-not-found>No ports matching \"{{$ctrl.card_destinationWetSearchText}}\" were found.</md-not-found></md-autocomplete>\n<md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.selectedPOD\"><div \nng-if=\"$ctrl.selectedPOD && $ctrl.selectedPOD._id\">\n{{$ctrl.selectedPOD.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.selectedPOD, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.selectedPOD, true).join(\',\'):$ctrl.selectedPOD.location)}}\n</div><div ng-if=\"$ctrl.selectedPOD && !$ctrl.selectedPOD._id\">{{$ctrl.selectedPOD}}</div></md-tooltip>\n</md-input-container><div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.podValidation\"><span>\n{{$ctrl.errorTextObj.podErrorText}}</span></div></div><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label \nng-if=\"$ctrl.isDestinationDryPort\">Port of Destination</label><label ng-if=\"!$ctrl.isDestinationDryPort\">\nPort of Discharge</label><md-input-container md-no-float class=\"panel-select\" \nng-class=\"{\'validation-error\':($ctrl.validationObj.destinationPortValidation)}\" \nng-keyup=\"$ctrl.validationObj.destinationPortValidation=false;\"><md-icon \nng-if=\"$ctrl.addNewCard.meta.port_data.destination_port_code\" class=\"icon-align\" \nmd-svg-src=\"{{$ctrl.searchParam.mode != \'AIR\' ?($ctrl.searchParam.mode != \'SEA-LCL\' ?  ($ctrl.selectedDestination && $ctrl.selectedDestination.is_icd_port ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\'):\'assets/icons/custom/search-bar/lcl_port.svg\'): \'assets/icons/custom/search-bar/air_pol.svg\'}}\">\n</md-icon><md-icon ng-if=\"!$ctrl.addNewCard.meta.port_data.destination_port_code\" class=\"empty-circle-icon\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete md-input-name=\"card_destination_port\" \nmd-selected-item=\"$ctrl.selectedDestination\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedDestination,\'destination\')\" \nmd-search-text=\"$ctrl.card_destinationSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationSearchText,$ctrl.searchParam.mode, \'destination\')\" \nmd-item-text=\"$ctrl.util.portSelectedData(item, false).join(\', \')\" md-min-length=\"2\" md-clear-button=\"false\" \nmd-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"{{$ctrl.isDestinationDryPort ? \'Enter Port of Destination\' : \'Enter Port of Discharge\'}}\" \nmd-menu-class=\"autocomplete-custom-template-add\" md-menu-container-class=\"custom-container\"><md-item-template><span \nclass=\"item-metadata\"><div class=\"pl-8 p-5\"><div class=\"black-fg font-size-13\" \ncompile-html=\"$ctrl.util.searchHighlight(item.portname,$ctrl.card_destinationSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</span></md-item-template><md-not-found>No ports matching \"{{$ctrl.card_destinationSearchText}}\" were found.\n</md-not-found></md-autocomplete><md-tooltip md-direction=\"top\" class=\"tooltip-height\" \nng-if=\"$ctrl.selectedDestination\"><div ng-if=\"$ctrl.selectedDestination && $ctrl.selectedDestination._id\">\n{{$ctrl.util.portSelectedData($ctrl.selectedDestination, true).join(\', \')}}</div><div \nng-if=\"$ctrl.selectedDestination && !$ctrl.selectedDestination._id\">{{$ctrl.selectedDestination}}</div></md-tooltip>\n</md-input-container><div class=\"validation-error-text\" ng-if=\"$ctrl.validationObj.destinationPortValidation\"><span>\n{{$ctrl.errorTextObj.destinationPortErrorText}}</span></div></div><div class=\"feild-spacing\" flex-lg=\"20\" \nflex-xs=\"100\" ng-if=\"$ctrl.isDestinationDryPort\"><label>Destination Haulage</label><span \nclass=\"panel-select haulage-margin\" layout=\"row\"><md-icon class=\"haulage-icon\" \nng-if=\"$ctrl.addNewCard.meta.destination_haulage && ($ctrl.addNewCard.meta.destination_haulage.toLowerCase() == \'road\' || $ctrl.addNewCard.meta.destination_haulage.toLowerCase() == \'barge\' || $ctrl.addNewCard.meta.destination_haulage.toLowerCase() == \'rail\' || $ctrl.addNewCard.meta.destination_haulage.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+$ctrl.addNewCard.meta.destination_haulage.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon><md-select class=\"mt-2\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-model=\"$ctrl.addNewCard.meta.destination_haulage\" name=\"haulage\" placeholder=\"Select Destination Haulage\"><md-option\n ng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></span></div>\n</div><div layout=\"row\" ng-if=\"$ctrl.searchParam.destination_location.place_type == \'Door\'\"><md-icon \nmd-svg-src=\"assets/icons/custom/search-bar/door.svg\" class=\"icon-bs\"></md-icon><div layout=\"row\" layout-wrap \nflex=\"100\"><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label>Delivery Door</label><md-input-container \nmd-no-float class=\"panel-select\" ng-class=\"{\'validation-error\':($ctrl.validationObj.destinationDoorValidation)}\" \nng-keyup=\"$ctrl.validationObj.destinationDoorValidation=false;\"><md-icon \nng-if=\"($ctrl.addNewCard.meta.port_data.delivery_location || $ctrl.addNewCard.meta.port_data.delivery_pincode_ui)\" \nclass=\"icon-align\" \nmd-svg-src=\"{{$ctrl.selectedDestinationDoor && $ctrl.selectedDestinationDoor.place_type == \'Port\' ? ($ctrl.selectedDestinationDoor.is_icd_port ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\') :\'assets/icons/custom/search-bar/door_img.svg\'}}\">\n</md-icon><md-icon \nng-if=\"!($ctrl.addNewCard.meta.port_data.delivery_location || $ctrl.addNewCard.meta.port_data.delivery_pincode_ui)\" \nclass=\"empty-circle-icon\" md-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete \nmd-selected-item=\"$ctrl.selectedDestinationDoor\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedDestinationDoor, \'destination_door\')\" \nmd-input-name=\"card_destination_port\" md-search-text=\"$ctrl.card_destinationDoorSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_destinationDoorSearchText,$ctrl.searchParam.mode, \'destination\',\'D2D\')\" \nmd-item-text=\"($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Enter Delivery Door\" md-menu-class=\"autocomplete-custom-template-add\" \nmd-menu-container-class=\"custom-container\"><md-item-template><span class=\"item-metadata\"><div layout=\"column\" \nclass=\"pl-8 p-5\" ng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" \nng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                                                                                                     track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span> <span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,false); \n                                                                                                                                                                                            track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span> \n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></span></md-item-template>\n<md-not-found>No ports matching \"{{$ctrl.card_destinationDoorSearchText}}\" were found.</md-not-found></md-autocomplete>\n<md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.selectedDestinationDoor\"><div \nng-if=\"$ctrl.selectedDestinationDoor && $ctrl.selectedDestinationDoor._id\">\n{{$ctrl.selectedDestinationDoor.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.selectedDestinationDoor, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.selectedDestinationDoor, true).join(\',\'):$ctrl.selectedDestinationDoor.location)}}\n</div><div ng-if=\"$ctrl.selectedDestinationDoor && !$ctrl.selectedDestinationDoor._id\">\n{{$ctrl.selectedDestinationDoor}}</div></md-tooltip></md-input-container><div class=\"validation-error-text\" \nng-if=\"$ctrl.validationObj.destinationDoorValidation\"><span>{{$ctrl.errorTextObj.destinationDoorErrorText}}</span>\n</div></div><div class=\"feild-spacing min-width-130\" flex-xs=\"100\" flex=\"20\"><label>Delivery Service Type</label>\n<md-input-container class=\"panel-select\" md-no-float><input ng-model=\"$ctrl.addNewCard.meta.delivery_service\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nplaceholder=\"Enter Service Type\"></md-input-container></div><div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\">\n<label>Delivery Haulage</label><span class=\"panel-select haulage-margin\" layout=\"row\"><md-icon class=\"haulage-icon\" \nng-if=\"$ctrl.addNewCard.meta.delivery_transport_mode && ($ctrl.addNewCard.meta.delivery_transport_mode.toLowerCase() == \'road\' || $ctrl.addNewCard.meta.delivery_transport_mode.toLowerCase() == \'barge\' || $ctrl.addNewCard.meta.delivery_transport_mode.toLowerCase() == \'rail\' ||  $ctrl.addNewCard.meta.delivery_transport_mode.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+$ctrl.addNewCard.meta.delivery_transport_mode.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon><md-select class=\"mt-2\" ng-model=\"$ctrl.addNewCard.meta.delivery_transport_mode\" \nng-change=\"$ctrl.fnTransporterChanged($ctrl.addNewCard.meta.delivery_transport_mode, $ctrl.l5_leg);\" name=\"haulage\" \nplaceholder=\"Select Delivery Haulage\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\">\n<md-option ng-repeat=\"haulage in $ctrl.util.haulageList\" ng-value=\"haulage\">{{haulage}}</md-option></md-select></span>\n</div><div class=\"feild-spacing min-width-130\" flex-xs=\"100\" flex=\"20\"><label>Delivery Transporter</label>\n<md-input-container md-no-float class=\"panel-select\"><md-icon md-svg-src=\"assets/icons/custom/user-icon.svg\" \nng-if=\"$ctrl.selectedDeliveryTransporter\" class=\"icon-align\"></md-icon><md-select md-no-asterisk \nng-class=\"{\'user-icon\':$ctrl.selectedDeliveryTransporter}\" ng-model=\"$ctrl.selectedDeliveryTransporter\" \nng-change=\"$ctrl.fngetTransporterDetails($ctrl.addNewCard.meta, $ctrl.selectedDeliveryTransporter, \'delivery_sub_vendor\' , $ctrl.getL5Subvendor)\" \nname=\"sub_vendor_id\" placeholder=\"Delivery Transporter\" md-on-close=\"searchL5SubVendor = \'\'\"><md-select-header><input \nng-model=\"searchL5SubVendor\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \ntype=\"search\" placeholder=\"Delivery Transporter\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\" \nng-change=\"$ctrl.fnGetLinerList(searchL5SubVendor , \'l5\')\"></md-select-header><md-option \nng-repeat=\"subvendor in $ctrl.getL5Subvendor | orderBy:\'name\'\" title=\"{{subvendor.name}}\" ng-value=\"subvendor.id\">\n{{subvendor.name}}</md-option></md-select></md-input-container></div></div></div><div layout=\"row\" \nng-if=\"$ctrl.addNewCard.meta.port_data.empty_container_drop\"><md-icon \nmd-svg-src=\"assets/icons/custom/road_haulage.svg\" class=\"icon-bs\"></md-icon><div layout=\"row\" layout-wrap flex=\"100\">\n<div class=\"feild-spacing\" flex-lg=\"20\" flex-xs=\"100\"><label>Empty Container Drop</label><md-input-container \nmd-no-float class=\"panel-select\" ng-class=\"{\'validation-error\':$ctrl.validationObj.emptyDropValidation}\" \nng-keyup=\"$ctrl.validationObj.emptyDropValidation=false\"><md-icon ng-if=\"$ctrl.selectedDropContainer\" \nclass=\"icon-align\" \nmd-svg-src=\"{{$ctrl.selectedDropContainer.place_type == \'Door\' ? \'assets/icons/custom/search-bar/door_img.svg\' : ($ctrl.searchParam.mode != \'SEA-LCL\' ? ($ctrl.selectedDropContainer.is_icd_port ? \'assets/icons/custom/search-bar/icd_port.svg\' : \'assets/icons/custom/search-bar/port_fcl.svg\'):\'assets/icons/custom/search-bar/lcl_port.svg\') }}\">\n</md-icon><md-icon ng-if=\"!$ctrl.selectedDropContainer\" class=\"empty-circle-icon\" \nmd-svg-src=\"assets/icons/custom/search-bar/empty.svg\"></md-icon><md-autocomplete \nmd-selected-item=\"$ctrl.selectedDropContainer\" \nmd-selected-item-change=\"$ctrl.fnSelectedPlace($ctrl.selectedDropContainer, \'drop_container\')\" \nmd-input-name=\"card_drop_container\" md-search-text=\"$ctrl.card_dropContainerSearchText\" \nmd-items=\"item in $ctrl.getPort($ctrl.card_dropContainerSearchText,$ctrl.searchParam.mode, \'origin\',\'D2D\')\" \nmd-item-text=\"item.place_type !== \'Door\' ? $ctrl.util.portSelectedData(item, false).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData(item, false).join(\', \'):item.location)\" \nmd-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Empty Container Drop\" md-menu-class=\"autocomplete-custom-template-add\" \nmd-menu-container-class=\"custom-container\"><md-item-template><span class=\"item-metadata\" \nng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"pl-8 p-5\"><div \nclass=\"black-fg font-size-13\" compile-html=\"$ctrl.util.searchHighlight(item.portname,fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}<span ng-if=\"item.city && item.country\">, </span>{{item.country}}</div></div>\n</span><span class=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div layout=\"column\" class=\"pl-8 p-5\" \nng-if=\"$ctrl.isPcmsEnabled\"><div layout=\"row\" ng-if=\"$ctrl.util.doorDropdownData(item, fcl_originSearchText).length\">\n<span \nng-repeat=\"location  in $ctrl.util.doorDropdownData(item, fcl_originSearchText); \n                                                                                                                                               track by $index\">\n<span class=\"black-fg font-size-14\">{{ $ctrl.util.truncateText(location, 20)}}</span> <span \nclass=\"black-fg font-size-14\">{{$last ? \'\' : \', \'}}</span></span></div><div layout=\"row\" \nng-if=\"$ctrl.util.subDoorDropdownData(item, fcl_originSearchText).length\"><span \nng-repeat=\"location in $ctrl.util.subDoorDropdownData(item, fcl_originSearchText),false; \n                                                                                                                                                                      track by $index\">\n<span class=\"grey-fg font-size-12\" compile-html=\"$ctrl.util.searchHighlight(location,fcl_originSearchText)\"></span> \n<span class=\"grey-fg font-size-12\">{{$last ? \'\' : \', \'}}</span></span></div><md-tooltip md-direction=\"top\" \nclass=\"tooltip-height\" ng-if=\"$ctrl.selectedDropContainer\"><div class=\"font-size-12\">\n{{ $ctrl.util.doorDropdownData(item, fcl_originSearchText).join(\', \') }}</div><div class=\"font-size-12\">\n{{ $ctrl.util.subDoorDropdownData(item, fcl_originSearchText,true).join(\', \') }}</div></md-tooltip></div><div \nlayout=\"column\" ng-if=\"!$ctrl.isPcmsEnabled\"><div class=\"black-fg font-size-14 items-center\" \ncompile-html=\"$ctrl.util.searchHighlight(item.location,fcl_originSearchText)\"></div></div></span></md-item-template>\n<md-not-found>No ports matching \"{{$ctrl.card_dropContainerSearchText}}\" were found.</md-not-found></md-autocomplete>\n<md-tooltip md-direction=\"top\" class=\"tooltip-height\" ng-if=\"$ctrl.selectedDropContainer\"><div \nng-if=\"$ctrl.selectedDropContainer && $ctrl.selectedDropContainer._id\">\n{{$ctrl.selectedDropContainer.place_type !== \'Door\' ? $ctrl.util.portSelectedData($ctrl.selectedDropContainer, true).join(\', \') : ($ctrl.isPcmsEnabled ? $ctrl.util.doorSelectedData($ctrl.selectedDropContainer, true).join(\',\'):$ctrl.selectedDropContainer.location)}}\n</div><div ng-if=\"$ctrl.selectedDropContainer && !$ctrl.selectedDropContainer._id\">{{$ctrl.selectedDropContainer}}\n</div></md-tooltip></md-input-container><div class=\"validation-error-text\" \nng-if=\"$ctrl.validationObj.emptyDropValidation\"><span>{{$ctrl.errorTextObj.emptyDropErrorText}}</span></div></div>\n</div></div><div layout=\"row\"><img src=\"assets/icons/custom/search-bar/cargo.png\" class=\"icon-bs\"><div layout=\"row\" \nlayout-wrap flex=\"100\"><div class=\"feild-spacing\" flex-xs=\"100\"><div><label>Cargo Type</label></div><md-input-container\n flex md-no-float><cargo-type-selection page-source=\"$ctrl.pageSource+\'RateCard\'\" mode=\"$ctrl.searchParam.mode\" \nfull-border=\"true\" cargo-type-data=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj.cargo_type_data\" \nis-required=\"false\" is-valid=\"false\" placeholder=\"Enter Cargo Type\"></cargo-type-selection></md-input-container></div>\n<div class=\"feild-spacing\" flex=\"40\" flex-xs=\"100\"><div><label>Commodity</label></div><md-input-container \nclass=\"commodity_input\" md-no-float><commodity-chips page-source=\"$ctrl.pageSource+\'RateCard\'\" \nmode=\"$ctrl.searchParam.mode\" md-input-id=\"\'commodity_id_edit-card\'\" commodity-array=\"$ctrl.commodityArray\" \nis-valid=\"false\"></commodity-chips></md-input-container></div></div></div></div></form><div class=\"note-div\" \nng-if=\"$ctrl.noteBlock\">\nNote: The charges will not modify automatically according to the selected parameter. Please check and modify.</div><div\n class=\"bb\"></div><md-tabs class=\"min-height-500\" md-border-bottom md-selected=\"$ctrl.selectedIndex\" md-dynamic-height>\n<md-tab label=\"Slab\" md-on-select=\"$ctrl.rateTabView()\" ng-if=\"$ctrl.ratesVisible\"><div id=\"slab-fcl\" class=\"mt-20\" \nng-if=\"$ctrl.searchParam.mode == \'SEA-FCL\'\"><div class=\"ph-20\" layout-xs=\"column\" layout=\"row\"><div flex-xs \nflex-gt-xs=\"100\" layout=\"column\"><div><md-content class=\"border mv-20\" \nng-repeat=\"slabData in $ctrl.fclSlab track by $index\"><table class=\"simple\" ms-responsive-table><thead><tr><th \nclass=\"table-header\" colspan=\"2\"><div><div class=\"font-size-11\">{{slabData.leg_name}}</div><span \nclass=\"font-size-16 black-fg\">{{slabData.charge_name}} - {{slabData.load_type}}</span></div></th></tr><tr><th \nclass=\"font-size-13 black-fg br\">Weight Range - KG</th><th class=\"font-size-13 black-fg\">Amount</th></tr></thead><tbody\n ng-repeat=\"slabrange in slabData.slab track by $index\"><tr ng-class=\"{\'selected-color\':slabrange.selected}\"><td \nclass=\"br font-size-11\"><span ng-class=\"{\'pl-20\':(!slabrange.selected)}\"><md-icon ng-if=\"slabrange.selected\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"light-blue-400-fg s12 mb-2 mr-5\"></md-icon></span><span>\n{{slabrange.from | currencyMask: 2}} - {{slabrange.to | currencyMask: 2}}</span></td><td class=\"font-size-11\">\n{{slabData.currency}} {{slabrange.cost | currencyMask: 2}}</td></tr></tbody></table></md-content></div></div></div>\n</div><md-content class=\"scroll_tab\" layout=\"column\" ng-if=\"$ctrl.searchParam.mode == \'AIR\'\"><div><div \nclass=\"pv-10 ph-20\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-repeat=\"(leg_key,leg_value) in $ctrl.rateDetails track by $index\" ng-if=\"leg_value.rate_obj\" class=\"mb-20\">\n<md-content ng-if=\"leg_key == $ctrl.l3_leg && !leg_value.rate_obj.manual\" ms-scroll class=\"border\"><table \nclass=\"custom-table\"><thead><tr class=\"charge_heading\"><th class=\"Charges\">Slab</th><th class=\"Charges\">Slab Amount\n</th></tr></thead><tbody><tr ng-repeat=\"(key, chg_array) in leg_value.rate_obj.slab_rate track by $index\" \nng-class=\"{ \'selected_slab\': (key == leg_value.rate_obj.slab)}\"><td class=\"charges_details w-280\">{{key}}</td><td \nclass=\"charges_details w-280\">\n{{ !chg_array ? \'-\' : leg_value.rate_obj.slab_currency }} {{ !chg_array ? \'-\' : chg_array | currencyMask: 2 }}</td>\n</tr></tbody></table></md-content><div layout=\"row\" layout-align=\"center center\" layout-wrap class=\"p-20 mt-20 border\" \nng-if=\"leg_key == $ctrl.l3_leg && leg_value.rate_obj.manual\"><h2>Sorry, slabs are not available.</h2></div></div></div>\n</div></div></md-content></md-tab><md-tab label=\"Schedules\" md-on-select=\"$ctrl.scheduleTabView()\" \nng-if=\"$ctrl.scheduleVisible\"><schedule-component ng-if=\"$ctrl.getSchedule\" validation-obj=\"$ctrl.validationObj\" \nsearch-param=\"$ctrl.searchParam\" page-source=\"$ctrl.pageSource\" mask-liner=\"$ctrl.maskLiner\" \ncurrent-card=\"$ctrl.addNewCard\" current-schedule=\"$ctrl.currentSchedule\" error-text-obj=\"$ctrl.errorTextObj\">\n</schedule-component></md-tab><md-tab label=\"Airline Schedules\" md-on-select=\"$ctrl.airScheduleTabView()\" \nng-if=\"$ctrl.airScheduleVisible\"><air-schedule-component ng-if=\"$ctrl.getSchedule\" \nvalidation-obj=\"$ctrl.validationObj\" search-param=\"$ctrl.searchParam\" page-source=\"$ctrl.pageSource\" \nmask-liner=\"$ctrl.maskLiner\" current-card=\"$ctrl.addNewCard\" current-schedule=\"$ctrl.currentSchedule\">\n</air-schedule-component></md-tab><md-tab label=\"Analytics\" md-on-select=\"$ctrl.analyticsTabView()\" \nng-if=\"$ctrl.analyticsVisible\"><md-content layout=\"column\"><div ng-if=\"!$ctrl.is_rate_history_empty\" \nclass=\"pt-20 pl-10 analytic-head\"><span class=\"graph-header\">COMPARED AGAINST CURRENTLY AVAILABLE RATES</span><div \nlayout=\"row\" flex=\"100\" class=\"pt-20 pb-20\"><div flex=\"20\" \nng-repeat=\"analytics in $ctrl.analyticsData.rate_data track by $index\"><div class=\"container-head\">\n{{analytics.type}} Container</div><div class=\"pt-10 cheaper container-body\" ng-if=\"analytics.percentile<=40\">\n{{(100 - analytics.percentile)}} % Cheaper</div><div class=\"pt-10 expensive container-body\" \nng-if=\"analytics.percentile>40\">{{analytics.percentile}} % Expensive</div></div></div></div><div \nclass=\"pt-40 pb-10 font-weight-600\" layout=\"row\" layout-align=\"center center\" ng-if=\"!$ctrl.is_rate_history_empty\">\nHISTORICAL RATE DATA FOR PAST 1 YEAR</div><div id=\"chart\" ng-if=\"!$ctrl.is_rate_history_empty\"></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"pt-30 pb-30 graph-container\" ng-if=\"!$ctrl.is_rate_history_empty\"></div><div \nng-if=\"(($ctrl.analyticsData.rate_data.length <= 0)||($ctrl.is_rate_history_empty))\" \nclass=\"text-center font-size-20 font-weight-800 p-30\">Sorry, Analytics Not Available!</div></md-content></md-tab>\n<md-tab label=\"Charges\" md-on-select=\"$ctrl.quotationTabView();\" ng-if=\"$ctrl.quotationVisible\"><div \nng-class=\"{\'scroll_tab\' : !$ctrl.util.isMobileDevice}\" class=\"mb-20\"><md-content class=\"mb-10\" layout=\"column\" \nng-class=\"{\'mb-100\' : $ctrl.util.isMobileDevice}\"><div class=\"mb-20 buy_sell_rates margin_bottom_7per\" layout=\"column\" \nflex=\"100\" ng-if=\"!$ctrl.showData && !$ctrl.callingConversionApi\"><rate-modification \nng-if=\"$ctrl.searchParam.mode == \'SEA-FCL\'\" search-param=\"$ctrl.searchParam\" source-rate=\"$ctrl.sourceRate\" \ncurrent-card=\"$ctrl.addNewCard\" page-source=\"$ctrl.pageSource\" quote-edit=\"$ctrl.quoteEdit\" \ninquiry-pricing=\"$ctrl.inquiryPricing\" from-inquiry=\"$ctrl.fromInquiry\" footer-obj=\"$ctrl.footerObj\" \nedit-buy-rate=\"$ctrl.editBuyRate\" is-add-new-rate-loaded=\"$ctrl.isAddNewRateLoaded\" all-in-quote=\"$ctrl.allInQuote\">\n</rate-modification><air-lcl-rate-modification ng-if=\"$ctrl.searchParam.mode != \'SEA-FCL\'\" \nsearch-param=\"$ctrl.searchParam\" source-rate=\"$ctrl.sourceRate\" current-card=\"$ctrl.addNewCard\" \npage-source=\"$ctrl.pageSource\" quote-edit=\"$ctrl.quoteEdit\" inquiry-pricing=\"$ctrl.inquiryPricing\" \nfrom-inquiry=\"$ctrl.fromInquiry\" footer-obj=\"$ctrl.footerObj\" edit-buy-rate=\"$ctrl.editBuyRate\" \nis-add-new-rate-loaded=\"$ctrl.isAddNewRateLoaded\" all-in-quote=\"$ctrl.allInQuote\"></air-lcl-rate-modification></div>\n<div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" ng-if=\"$ctrl.showData || $ctrl.callingConversionApi\">\n</div></md-content></div></md-tab><md-tab label=\"Remarks & Inclusions\" \nmd-on-select=\"$ctrl.remarksTabView();loadEditor=true;\" ng-if=\"$ctrl.quotationVisible\"><div class=\"mh-20 mb-20\" \nlayout=\"column\" flex=\"100\" ng-if=\"loadEditor\"><div ng-if=\"!$ctrl.util.isShipper && !$ctrl.hideInternalRemarks\"><div \nlayout=\"row\" class=\"mt-25 mb-10 headStyle\">Internal Remarks<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mr-10 ml-10 grey-fg pointer pt-2\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\nThis remarks only visible for internal user and will not be printed on Quote PDF</md-tooltip></md-icon></div><div \nlayout=\"row\"><div class=\"quote-editor\" ng-if=\"$ctrl.quoteEdit && $ctrl.loadSlowly\"><ng-ckeditor \nng-model=\"$ctrl.addNewCard.meta.internal_remarks\" ng-config=\"$ctrl.termsConditionCkEditorConfig\"></ng-ckeditor></div>\n</div></div><div layout=\"row\" class=\"mt-25 mb-10 headStyle\">Remarks</div><div layout=\"row\"><div class=\"quote-editor\" \nng-if=\"$ctrl.quoteEdit && $ctrl.loadSlowly\"><ng-ckeditor ng-model=\"$ctrl.addNewCard.meta.remarks\" \nng-config=\"$ctrl.termsConditionCkEditorConfig\"></ng-ckeditor></div><span class=\"m-0 ff-lato\" ng-if=\"!$ctrl.quoteEdit\" \ncompile-html=\"!$ctrl.addNewCard.meta.remarks ? \'-\' : $ctrl.addNewCard.meta.remarks\"></span></div><div layout=\"row\" \nclass=\"mt-25 mb-15 headStyle\">Inclusions</div><div layout=\"row\" class=\"mb-60\" \nng-class=\"{\'mb-80\' : $ctrl.util.isMobileDevice}\"><div class=\"quote-editor\" ng-if=\"$ctrl.quoteEdit && $ctrl.loadSlowly\">\n<ng-ckeditor ng-model=\"$ctrl.addNewCard.meta.inclusions\" ng-config=\"$ctrl.termsConditionCkEditorConfig\"></ng-ckeditor>\n</div><span class=\"m-0 ff-lato\" ng-if=\"!$ctrl.quoteEdit\" \ncompile-html=\"!$ctrl.addNewCard.meta.inclusions ? \'-\' : $ctrl.addNewCard.meta.inclusions\"></span></div></div></md-tab>\n<md-tab label=\"T&C\" md-on-select=\"$ctrl.termsTabView()\" ng-if=\"$ctrl.termsVisible\"><div id=\"terms-popup\" \nng-if=\"$ctrl.viewActiveTab == \'Terms\'\"><md-content layout=\"column\" class=\"mh-20 mv-30\"><div \nclass=\"font-size-14 font-weight-600 mb-20\">Terms & Conditions</div><div shimmer-effect width=\"100%\" height=\"100%\" \nclass=\"white-bg\" ng-if=\"$ctrl.termsShimmer\"></div><div class=\"border brad-10 pv-20 ph-30 tnc_div font-size-16\" \nng-if=\"!$ctrl.termsShimmer  && $ctrl.termsData\"><div id=\"terms\" class=\"pt-10 pl-30 grey-fg m-0 ff-lato\" \ncompile-html=\"$ctrl.termsData\"></div></div><div flex=\"100\" class=\"text-center Font-Bold\" layout-align=\"center center\" \nng-if=\"!$ctrl.termsShimmer && !$ctrl.termsData\">Sorry, Terms and Conditions are not available.</div></md-content></div>\n</md-tab><md-tab label=\"Free Days\" md-on-select=\"$ctrl.freeDaysTab()\" \nng-if=\"$ctrl.quotationVisible && $ctrl.searchParam.mode === \'SEA-FCL\'\"><div class=\"m-20 margin_bottom_12per overflow\" \nlayout=\"column\" flex=\"100\" ng-if=\"!$ctrl.showData && !$ctrl.callingConversionApi\"><load-wise-free-days class=\"mt-10\" \nrate-obj=\"$ctrl.addNewCard.data.sell_rates[$ctrl.l3_leg].rate_obj\" search-param=\"$ctrl.searchParam\" \nload-wise-free-days-list=\"$ctrl.loadWiseFreeDaysList\" is-edit=\"$ctrl.isFreeDaysEdit\" page-source=\"$ctrl.pageSource\">\n</load-wise-free-days></div><div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" \nng-if=\"$ctrl.showData || $ctrl.callingConversionApi\"></div></md-tab></md-tabs></div><div \nng-show=\"$ctrl.screenNumber == 2\"><get-legs get-leg-options=\"$ctrl.getLegOptions\"></get-legs></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"sticky-bottom card_shadow\" \nng-if=\"$ctrl.screenNumber != 2 && (($ctrl.airScheduleVisible) && $ctrl.viewActiveTab.includes(\'schedule\') && $ctrl.currentSchedule && $ctrl.isAddNewRateLoaded)\">\n<div layout=\"row\" flex=\"100\" layout-wrap ng-if=\"$ctrl.getSchedule\"><div flex=\"50\" flex-xs=\"50\" flex-sm=\"50\" \nlayout-align=\"start center\"><div class=\"schedule_warning\" ng-if=\"$ctrl.ifExpireCross\">\nSelected schedule is after expiry date of shown rates. Actual rates may vary.</div></div><div flex flex-xs=\"50\" \nflex-sm=\"50\" class=\"text-end pr-10\" layout-align=\"end center\"><md-button md-no-ink class=\"md-accent-btn\" \ntitle=\"Select Schedule\" ng-click=\"$ctrl.fnScheduleSubmit($ctrl.currentSchedule,newRateForm)\" \nng-style=\"{ \'cursor\' : ( $ctrl.disableScheduleBtn)  ? \'not-allowed\' : \'pointer\' }\" \nng-disabled=\"$ctrl.disableScheduleBtn\">Select Schedule</md-button></div></div></md-dialog-actions><md-dialog-actions \nlayout=\"row\" class=\"sticky-bottom card_shadow footer-mobile-spacing\" \nng-if=\"$ctrl.screenNumber != 2 && (($ctrl.util.isAdmin || $ctrl.util.isFreightbro) && $ctrl.quotationVisible && ($ctrl.viewActiveTab == \'quotation\' || $ctrl.viewActiveTab == \'remarksInclusion\' || $ctrl.viewActiveTab == \'loadWiseFreeDays\' || ($ctrl.scheduleVisible && $ctrl.viewActiveTab.includes(\'schedule\') && $ctrl.currentSchedule)) && $ctrl.isAddNewRateLoaded)\">\n<div layout=\"row\" flex=\"100\" class=\"pl-10\" layout-wrap ng-if=\"!$ctrl.showData\"><div layout=\"column\" flex=\"15\" \nflex-xs=\"100\" flex-sm=\"25\" class=\"mr-15\" hide-xs hide-sm layout-align=\"center start\" layout-wrap \nng-if=\"$ctrl.dimLegList.length\"><div class=\"pb-10\">DIM Calculation</div><div class=\"font-size-11\">\n{{$ctrl.dimLegList[0].cbm}} KG / CBM for {{$ctrl.dimLegList[0].leg_name}}<span ng-show=\"$ctrl.dimLegList.length>1\">\n,{{$ctrl.dimLegList[1].cbm}} KG / CBM for {{$ctrl.dimLegList[1].leg_name}}</span><span \nng-show=\"$ctrl.dimLegList.length>2\" class=\"md-link-fg\">,+{{$ctrl.dimLegList.length-2}}</span><md-tooltip \nmd-direction=\"top\" class=\"md-whiteframe-2dp white-fg black-bg font-size-10 ph-20 line-height-20 pv-5\" \nstyle=\"height: fit-content\"><span ng-repeat=\"dim in $ctrl.dimLegList track by $index\"><span><span \nng-if=\"$ctrl.dimLegList.length>1\">{{$index+1}}.</span> {{dim.leg_name}}, {{dim.cbm}} KG/CBM</span><br></span>\n</md-tooltip></div></div><div layout=\"column\" flex=\"15\" flex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm \nlayout-align=\"center start\"><div class=\"pb-5\">BUY RATE</div><div class=\"font-weight-600\" layout=\"row\">\n{{$ctrl.searchUser.user_base_currency}} {{($ctrl.footerObj.buyTotalBaseCurr | currencyMask: 2)}}<div class=\"pl-5\" \nng-if=\"$ctrl.searchParam.mode == \'SEA-FCL\' && $ctrl.addNewCard.meta.additional_charges\"><span \nng-if=\"$ctrl.addNewCard.meta.additional_charges.data\">\n+ {{$ctrl.addNewCard.meta.additional_charges.data.leg_currency}} {{$ctrl.addNewCard.meta.additional_charges.data.leg_currency_cost | currencyMask: 2}}\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"s16 mb-3 grey-600-fg\"><md-tooltip class=\"black-bg\" md-direction=\"top\">\nConvenience fee</md-tooltip></md-icon></span></div><div class=\"pl-15\" ng-if=\"$ctrl.footerObj.showConvLoader\">\n<md-progress-circular class=\"md-primary\" md-diameter=\"17\"></md-progress-circular></div></div></div><div \nlayout=\"column\" flex=\"15\" flex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm layout-align=\"center start\"><div \nclass=\"pb-5\">SELL RATE</div><div class=\"font-weight-600\">\n{{$ctrl.searchUser.user_base_currency}} {{$ctrl.footerObj.sellTotalBaseCurr | currencyMask: 2}}</div></div><div \nlayout=\"column\" flex=\"30\" flex-xs=\"20\" flex-sm=\"20\" hide-xs hide-sm layout-align=\"center start\" \nng-class=\"{\'br\' : ($ctrl.fromInquiry && $ctrl.quoteEdit)}\"><div \nng-if=\"$ctrl.footerObj.sellTotalBaseCurr >= $ctrl.footerObj.buyTotalWithConv\"><md-icon md-font-icon=\"icon-trending-up\" \nclass=\"green-fg s20 mr-5\"></md-icon>You earn <span class=\"font-weight-600\">\n{{$ctrl.searchUser.user_base_currency}} {{($ctrl.footerObj.sellTotalBaseCurr - $ctrl.footerObj.buyTotalWithConv | currencyMask: 2)}}\n</span> <span class=\"green-fg mh-5\">{{$ctrl.footerObj.profit}}</span> on this rate</div><div \nng-if=\"$ctrl.footerObj.sellTotalBaseCurr < $ctrl.footerObj.buyTotalWithConv\"><md-icon \nmd-font-icon=\"icon-trending-down\" class=\"red-fg s20\"></md-icon><span class=\"red-fg mh-5\">\n{{$ctrl.footerObj.profit.substr(1)}} Loss</span> <span class=\"font-weight-600\">\n(-{{$ctrl.searchUser.user_base_currency}} {{(($ctrl.footerObj.buyTotalWithConv - $ctrl.footerObj.sellTotalBaseCurr) | currencyMask: 2)}})\n</span> on this rate</div><div \nng-if=\"$ctrl.showExchangeRates && $ctrl.cardData._id && !$ctrl.cardData._id.includes(\'cNew\') && !$ctrl.cardData._id.includes(\'-\')\">\n<a class=\"pointer md-link-fg Font-Bold\" ng-click=\"$ctrl.fnViewExchangeRate();\">View Exchange Rates<md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div></div><div flex=\"30\" flex-xs=\"60\" \nflex-sm=\"30\" class=\"mh-15\" ng-if=\"$ctrl.fromInquiry && $ctrl.quoteEdit && $ctrl.searchParam.mode == \'SEA-FCL\'\"><div>\nPublish rate to the Search<md-icon md-font-icon=\"icon-alert-circle\" class=\"s18 black-fg mb-3\"><md-tooltip \nmd-direction=\"top\" class=\"p-8 font-size-11 white-fg font-weight-600\" \nstyle=\"display:table;opacity: 1; line-height: 1.5\"><div>Rates would be available for other users to</div><div>\nsearch until Expiry</div></md-tooltip></md-icon></div><div class=\"pb-5 font-size-11 grey-500-fg\">\nOnly main freight charge can be published to search</div><div class=\"font-weight-600\"><md-radio-group \nng-model=\"$ctrl.addNewCard.meta.isRateGlobal\" layout=\"row\" flex=\"100\" layout-wrap><md-radio-button md-no-ink \nvalue=\"Yes\" class=\"md-accent\">Yes</md-radio-button><md-radio-button md-no-ink value=\"No\" class=\"md-accent\">No\n</md-radio-button></md-radio-group></div></div><div flex layout=\"column\" layout-align=\"center end\" \nng-if=\"$ctrl.quoteEdit\"><md-button md-no-ink class=\"md-accent-btn\" style=\"margin-right:0px\" \ntitle=\"{{$ctrl.pageSource.includes(\'new\') ? \'Next\'  : \'Done\' }}\" ng-disabled=\"$ctrl.disableDoneBtn\" \nng-click=\"$ctrl.submitRate($ctrl.addNewCard, newRateForm)\">{{$ctrl.pageSource.includes(\'new\') ? \'Next\' : \'Done\' }}\n</md-button></div></div></md-dialog-actions><md-dialog-actions layout=\"row\" \nclass=\"sticky-bottom card_shadow footer-mobile-spacing\" ng-if=\"$ctrl.screenNumber == 2\"><div layout=\"row\" flex=\"100\" \nclass=\"pl-10\" layout-wrap><div layout=\"column\" flex=\"70\" layout-align=\"center start\" \nclass=\"font-size-13 fg-333333 Font-Regular\"><div layout=\"row\"><div class=\"mr-5\">Note:</div><div>\nThe sections/leg charges are available for your origin and destination.<br>\nSelect the appropriate charges combine these with your freight.</div></div></div><div flex layout=\"column\" \nlayout-align=\"center end\"><div><md-button md-no-ink class=\"md-primary-btn\" style=\"margin-right:0px\" title=\"Back\" \nng-click=\"$ctrl.fbGoBack()\">Back</md-button><md-button md-no-ink class=\"md-accent-btn\" style=\"margin-right:0px\" \ntitle=\"Done\" ng-disabled=\"$ctrl.disableFetchBtn\" ng-click=\"$ctrl.fetchRatesSubmit($ctrl.addNewCard)\">Done</md-button>\n</div></div></div></md-dialog-actions>");
$templateCache.put("app/main/quotes/dialogs/create-quote-dialog/create-quote-dialog.html","<div class=\"create-quote-dialog\"><md-toolbar class=\"modal_title white-bg black-fg\" \nng-class=\"{\'efp-header\': $ctrl.isEfpDomain}\"><div class=\"md-toolbar-tools\"><div flex=\"90\">\n{{$ctrl.isEfpDomain ? \'Create New Quote\' : \'Create Quote\'}}</div><md-button flex=\"10\" md-no-ink class=\"md-icon-button\" \nlayout-align=\"end end\" ng-click=\"$ctrl.closeDialog(\'QC-CreateQuote-CancelIcon\')\"><md-icon class=\"fg-AAA8AD cursor\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"column\" class=\"p-20\" layout-align=\"start start \"><div layout=\"row\" class=\"pb-20\"><div><div class=\"label pb-5\">\nMode</div><div layout=\"row\"><md-radio-group ng-model=\"$ctrl.mode\" ng-change=\"$ctrl.modeChange()\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nlayout=\"row\" ng-click=\"$ctrl.modeValidation=false\"><md-radio-button ng-repeat=\"tab in $ctrl.modes\" ng-value=\"tab.mode\" \nclass=\"md-primary\" ng-disabled=\"!$ctrl.util.navPermission[tab.permission][1]\">{{tab.label}}</md-radio-button>\n</md-radio-group></div><div ng-if=\"$ctrl.modeValidation\" class=\"validation-error-text pt-10\"><span>\nSelect a mode for quote creation</span></div></div></div><div layout=\"column\" class=\"pb-20 full-width\" \nng-if=\"!$ctrl.isEfpDomain\"><div class=\"label pb-5\">Quote Type</div><div class=\"new-quote pointer\" \nng-class=\"{\'createQuote-disabled\':$ctrl.templateSelectedOptions.name}\" \nng-click=\"$ctrl.templateSelectedOptions.name ? \'\' : $ctrl.createQuoteRedirection(\'QC-CreateQuote-NewQuote\')\"><p>\n<md-icon mdprefix class=\"mh-5 h-15 w-15 mb-2\" md-svg-src=\"assets/icons/custom/Group 44618.svg\"></md-icon>New Quote</p>\n</div></div><div layout=\"row\" layout-align=\"center start\" class=\"pb-20 full-width\" ng-if=\"!$ctrl.isEfpDomain\"><div>Or\n</div></div><div layout=\"row\" class=\"pb-20 full-width h-45\"><div flex \nng-if=\"$ctrl.panelView && $ctrl.templateFilterLoader\" layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-diameter=\"20\"></md-progress-circular></div><div id=\"template_div\" class=\"hide-comment\" \nng-if=\"!($ctrl.panelView && $ctrl.templateFilterLoader )\"><md-select ng-model=\"$ctrl.templateSelectedOptions\" \nmd-on-close=\"$ctrl.panelView=true;$ctrl.checkValue($event);$ctrl.templateValidationError=false\" \nmd-on-open=\"$ctrl.panelView=false\" placeholder=\"Select template\" \nng-model-options=\"{trackBy: \'$value.quote_id\', updateOn: \'default blur onchange\',\n            debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nid=\"template_select\" md-container-class=\"multi-select w-255 pb-0 mb-0\" class=\"md-no-underline\" \nng-class=\"{\'efp-template-select\': $ctrl.isEfpDomain, \'validation-error-border\': $ctrl.templateValidationError && $ctrl.isEfpDomain}\">\n<md-select-header class=\"row quote-md-select-header\"><div style=\"width: 96%\"><div class=\"search-header\"><input \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \ntype=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"$ctrl.searchText\" \nng-change=\"$ctrl.getListBySearch($ctrl.searchText);\" placeholder=\"Search Template\" class=\"md-text search-input\" \nmd-select-on-focus=\"\"><md-icon flex=\"10\" md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon>\n</div></div></md-select-header><div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" \nstyle=\"background-color: white\" ng-if=\"$ctrl.templateFilterLoader\" class=\"pv-20\"><md-progress-circular>\n</md-progress-circular></div><div ng-if=\"!$ctrl.templateFilterLoader\" ng-repeat=\"listDataObj in $ctrl.templateList\">\n<md-option ng-value=\"listDataObj\" style=\"background-color: white\"><div><div class=\"template-name\">{{listDataObj.name}}\n</div><div class=\"template-other-details\"><span>{{listDataObj.created_by}}</span> | <span>\n{{listDataObj.created_at | date :\"dd MMM yyyy\"}}</span></div></div></md-option></div><div \nng-if=\"!$ctrl.templateFilterLoader && $ctrl.templateListCount==0\" style=\"background-color: white\" \nclass=\"p-10 fg-333333\">No Result Match Found</div><div layout=\"row\" layout-align=\"center center\" \nclass=\"save-selected-button\" \nng-click=\"$ctrl.mdSelect.hide();$ctrl.trackEvent(\'QC-SelectTemplate-Done-Click\',$ctrl.templateSelectedOptions)\">Done\n</div></md-select><div ng-if=\"$ctrl.templateValidationError && $ctrl.isEfpDomain\" class=\"validation-error-text\"><span>\nSelect a template for quote creation</span></div></div></div></div></md-dialog-content><md-dialog-actions><div \nlayout=\"row\" class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" title=\"Cancel\" \nng-click=\"$ctrl.closeDialog(\'QC-CreateQuote-CancelButton\')\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" \nng-click=\"$ctrl.isEfpDomain ? $ctrl.validateAndCreateQuote(\'QC-CreateQuote-Button\') : $ctrl.createQuoteRedirection(\'QC-CreateQuote-Button\')\">\nCreate Quote</md-button></div></md-dialog-actions></div>");
$templateCache.put("app/main/quotes/dialogs/edit-quote/fcl-edit-quote.html","<md-dialog id=\"edit-quote\" class=\"popup-md\"><form name=\"quoteSearchEditFcl\" \nng-submit=\"ctrl.parent.fnSearchMetaEdit(quoteSearchEditFcl)\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div><b>Edit</b> Quotation</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog(\'Close icon-EQ\')\"><md-icon class=\"fg-AAA8AD cursor\" md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"m-0 p-0 body\"><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\"><div layout=\"column\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\"><label \nclass=\"pb-6-imp\">Quote ID</label><md-input-container class=\"input_container\" md-no-float><input \nclass=\"panel-select-disabled md-input-focused\" ng-model=\"ctrl.parent.quote_result.result_data.quote_id\" \nng-disabled=\"ctrl.parent.quote_result.result_data.quote_id\"></md-input-container></div><div layout=\"column\" flex=\"50\" \nflex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label>Incoterms</label><div><incoterm-select \nincoterm=\"ctrl.parent.incotermsEdit\" select-panel-width=\"\'260\'\" impo-expo=\"ctrl.parent.impoExpoEdit\" \nfull-border=\"true\" callback=\"ctrl.incotermsWarning=true;\"></incoterm-select><div class=\"inco-note-text\" \nng-if=\"ctrl.incotermsWarning && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH\"><div>\nThe charges will not modify automatically according to the selected incoterm. Please check and modify.</div></div>\n</div></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label>Cargo Ready Date</label><date-picker md-input-id=\"\'cargo_date\'\" \nis-validate=\"(ctrl.parent.validationObj.cargoDateValiation || (quoteSearchEditFcl.cargo_date.$touched && quoteSearchEditFcl.cargo_date.$error.valid))\" \nis-editable=\"false\" is-disabled=\"false\" input-required=\"false\" input-name=\"\'cargo_date\'\" \ndate-placeholder=\"\'Enter date\'\" full-border=\"true\" date-format=\"true\" full-border=\"true\" \nmin-date-value=\"ctrl.parent.startDateStart\" max-date-value=\"ctrl.parent.expiryEdit\" \nmodel-value=\"ctrl.parent.editQuoteMeta.cargo_ready_date\" \ncallback=\"ctrl.parent.editQuoteMeta.cargo_ready_date=value;ctrl.parent.validationObj.cargoDateValiation=false;\">\n</date-picker><div \nng-messages=\"(!ctrl.parent.validationObj.cargoDateValiation && quoteSearchEditFcl.cargo_date.$touched && quoteSearchEditFcl.cargo_date.$error)\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"ctrl.parent.validationObj.cargoDateValiation\" class=\"validation-error-text\"><span>Select Cargo date</span></div>\n</div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label>Expiry Date</label><div>\n<date-picker md-input-id=\"\'expiry_date\'\" \nis-validate=\"(ctrl.parent.validationObj.expiryValitdation || (quoteSearchEditFcl.expiry_date.$touched && quoteSearchEditFcl.expiry_date.$error.valid))\" \nis-editable=\"false\" is-disabled=\"false\" input-required=\"false\" input-name=\"\'expiry_date\'\" \ndate-placeholder=\"\'Enter date\'\" full-border=\"true\" date-format=\"true\" full-border=\"true\" \nmin-date-value=\"ctrl.parent.editQuoteMeta.cargo_ready_date\" max-date-value=\"ctrl.parent.expiryMaxDate\" \nmodel-value=\"ctrl.parent.expiryEdit\" \ncallback=\"ctrl.parent.expiryEdit=value;ctrl.parent.validationObj.expiryValitdation=false;ctrl.parent.validateExpirydate(ctrl.parent.expiryEdit);\">\n</date-picker><div ng-if=\"ctrl.parent.validationObj.showDateNote\" class=\"font-size-11 Font-Regular pt-5\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"orange-400-fg mr-5 s12\"></md-icon>Exceeds expiry date of rates</div><div \nng-messages=\"!ctrl.parent.validationObj.expiryValitdation && !ctrl.parent.validationObj.showDateNote && quoteSearchEditFcl.expiry_date.$touched && quoteSearchEditFcl.expiry_date.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"ctrl.parent.validationObj.expiryValitdation\" class=\"validation-error-text\"><span>Select Expiry Date</span></div>\n</div></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label class=\"pb-6-imp\">No. Of B/L</label><input restrict-to=\"[0-9]\" min=\"0\" \nmax=\"100\" type=\"number\" ng-model=\"ctrl.parent.load_bl_qty\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.billValidation}\" class=\"panel-select md-input-focused pl-5\" \nng-keyup=\"ctrl.parent.validationObj.billValidation=false\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nname=\"no_bl\" placeholder=\"B/L\" autocomplete=\"off\"><div ng-if=\"ctrl.parent.validationObj.billValidation\" \nclass=\"validation-error-text\"><span>Enter No. of B/L</span></div><div ng-if=\"quoteSearchEditFcl.no_bl.$error.min\" \nclass=\"validation-error-text\">Enter valid B/L</div></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><label class=\"pb-6-imp\">No. Of Shipping Bill</label><div><md-input-container \nmd-no-float class=\"p-0 m-0 inputWidth-100\"><input restrict-to=\"[0-9]\" min=\"0\" max=\"100\" type=\"number\" \nng-model=\"ctrl.parent.load_sbl_qty\" ng-class=\"{\'validation-error\':ctrl.parent.validationObj.shippingBillValidation}\" \nclass=\"panel-select md-input-focused pl-5\" ng-keyup=\"ctrl.parent.validationObj.shippingBillValidation=false\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"B/L\" autocomplete=\"off\" name=\"shipping_bill\"></md-input-container><div \nng-if=\"ctrl.parent.validationObj.shippingBillValidation\" class=\"validation-error-text\"><span>Enter No.of Shipping Bill\n</span></div><div ng-if=\"quoteSearchEditFcl.shipping_bill.$error.min\" class=\"validation-error-text\">\nEnter valid Shipping Bill</div></div></div></div><div layout=\"column\" flex=\"100\" layout-xs=\"column\" \nclass=\"row-spacing\" ng-if=\"ctrl.parent.isCommodity\"><label class=\"pb-6-imp\">Commodity</label><div><md-input-container \nmd-no-float class=\"mv-0 commodity_input\"><commodity-chips is-valid=\"false\" md-input-id=\"\'commodity_id_web\'\" \ncommodity-array=\"ctrl.parent.quote_result.result_data.commodity_data\" category=\"\'QuoteDetails\'\"></commodity-chips>\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" class=\"group-spacing\"><div flex=\"50\" \nflex-xs=\"100\"><div>Load Details</div></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\" \nng-repeat=\"load in ctrl.parent.editLoadType track by $index\"><div layout=\"column\" flex=\"50\" class=\"feild-spacing\" \nflex-xs=\"100\"><label class=\"pb-6-imp\" ng-show=\"$index==0\">Load Type</label><md-input-container md-no-float \nclass=\"p-0 m-0\" ng-class=\"{\'loadtype_font\':load.type}\"><md-select ng-model=\"load.type\" \nng-change=\"ctrl.parent.reloadLoadType();\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nname=\"type\" md-selected-text=\"load.type? load.type:\'Choose\'\" placeholder=\"Choose\" class=\"panel-select\" \nng-class=\"{\'validation-error\':(ctrl.parent.validationObj.typeValidation && !load.type),\'value-placeholder\' : load.type}\" \nmd-on-open=\"ctrl.parent.validationObj.typeValidation=false\"><md-option \nng-repeat=\"loadType in ctrl.parent.container_type | filter: ctrl.parent.loadFilter track\n                        by loadType.load_code\" \nng-value=\"loadType.load_code\">{{loadType.load_code}}</md-option></md-select></md-input-container><div \nng-if=\"(ctrl.parent.validationObj.typeValidation && !load.type)\" class=\"validation-error-text\"><span>Select Load Type\n</span></div></div><div layout=\"column\" flex=\"20\" flex-xs=\"50\" class=\"feild-spacing mobile-spacing\"><label \nng-show=\"$index == 0\" class=\"pb-6-imp\">Quantity</label><div><md-input-container md-no-float class=\"p-0 m-0\"><input \nrestrict-to=\"[0-9]\" min=\"0\" type=\"number\" ng-model=\"load.count\" class=\"panel-select md-input-focused\" \nng-class=\"{\'validation-error\':(ctrl.parent.validationObj.qtyValidation && !load.count)}\" placeholder=\"Qty\" \nautocomplete=\"off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-keyup=\"ctrl.parent.validationObj.qtyValidation=false\" name=\"qty\"></md-input-container><div \nng-if=\"(ctrl.parent.validationObj.qtyValidation  && !load.count)\" class=\"validation-error-text\"><span>\nSelect Valid Load Details Quantity</span></div><div ng-if=\"quoteSearchEditFcl.qty.$error.min && !load.count\" \nclass=\"validation-error-text\">Enter valid Quantity</div></div></div><div layout=\"column\" flex=\"30\" flex-xs=\"50\" \nclass=\"mobile-spacing\"><label class=\"pb-4-imp\" ng-show=\"$index==0\">Cargo Wt.</label><div layout=\"row\" \nclass=\"w-150 panel-select\"><md-input-container md-no-float \nng-class=\"{\'validation-error\':(ctrl.parent.validationObj.weightValidation && ! load.weight_qty)}\"><input \nname=\"target_rate\" type=\"number\" min=\"-99\" max=\"99999\" ng-model=\"load.weight_qty\" placeholder=\"Enter Weight\" \nclass=\"border-none h-36\" ng-keyup=\"ctrl.parent.validationObj.weightValidation=false\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container><md-input-container class=\"border-left\"><md-select class=\"border-none m-0 pl-8 cargo-weight\" \nng-model=\"load.weight_unit\"><md-option value=\"KGs\">KG</md-option></md-select></md-input-container></div><div \nng-if=\"(ctrl.parent.validationObj.weightValidation && ! load.weight_qty)\" class=\"validation-error-text\"><span>\nSelect Load Details Cargo Wt</span></div><div ng-if=\"quoteSearchEditFcl.target_rate.$error.min && ! load.weight_qty\" \nclass=\"validation-error-text\">Enter valid Cargo Wt</div></div><div layout=\"row\" flex=\"10\" flex-xs=\"50\" \nng-class=\"{\'pt-23\':$index < 1,\'mobile-spacing\':$index >0}\"><md-icon class=\"s20 mr-8 ml-0\" \nmd-font-icon=\"icon-minus-circle-outline red-400-fg\" title=\"Remove Load\" \nng-class=\"{\'disable-opacity\': ctrl.parent.editLoadType.length === 1, \'cursor\' : ctrl.parent.editLoadType.length > 1}\" \nng-click=\"ctrl.parent.removeLoad($index); ctrl.parent.searchForm.$setDirty();\"></md-icon><md-icon \nclass=\"s20 ml-2 cursor\" md-font-icon=\"icon-plus-circle-outline green-400-fg\" title=\"Add Load\" \nng-click=\"ctrl.parent.addNewLoad()\" \nng-show=\"ctrl.parent.editLoadType.length<4 && (ctrl.parent.editLoadType.length-1 === $index)\"></md-icon></div></div>\n<div class=\"note_text pt-10\">\nNote : Whenever there is a change in load type and its quantity, please update the charges and free days manually in the rate card & standard-quotation\n</div><div flex=\"100\" class=\"row-spacing\" layout-xs=\"row\"><label class=\"pr-10\">Customs</label><div layout=\"row\" \nclass=\"mt-6\"><div class=\"pr-20\">No</div><md-switch md-no-ink class=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" \nng-model=\"ctrl.parent.customsEdit\"></md-switch><div class=\"pl-20\">Yes</div></div></div><div layout=\"column\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"100\" layout-xs=\"column\"><label class=\"pb-6-imp\">\nTerms And Conditions</label><div class=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.termsEdit\" \nid=\"termsConditions\" ng-config=\"ctrl.parent.util.ckEditorConfig\" \nng-mouseleave=\"ctrl.parent.trackEvent(\'QD-EditQuotation-T&C-Change\')\"></ng-ckeditor></div></div><div layout=\"column\" \nflex=\"100\" layout-xs=\"column\"><md-checkbox md-no-ink class=\"mb-0 mt-10\" \nng-click=\"ctrl.parent.fnDefaultTermsAndConditions();\" ng-model=\"ctrl.parent.showTermsConditions\"><div \nclass=\"mb-2 fg-3B82F6 font-size-13\">Use Standard T&C</div></md-checkbox></div></div><div flex-gt-xs class=\"ph-15 hide\" \nlayout=\"column\" flex-xs=\"100\"><div class=\"font-size-14 mt-15 mb-30 black-400-fg font-weight-600\">ADDITIONAL SERVICES\n</div><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteMeta.origin_charges\" aria-label=\"\"><span class=\"label\">\nOrigin Charges</span></md-checkbox><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteMeta.origin_customs\" \naria-label=\"\"><span class=\"label\">Origin Custom Clearance</span></md-checkbox><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editQuoteMeta.destination_charges\" aria-label=\"\"><span class=\"label\">Destination Charges</span>\n</md-checkbox><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteMeta.destination_customs\" aria-label=\"\"><span \nclass=\"label\">Destination Custom Clearance</span></md-checkbox><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editQuoteMeta.shipment_insurance\" aria-label=\"\"><span class=\"label\">Insurance Charges</span>\n</md-checkbox><div class=\"font-size-14 black-fg\" ng-if=\"ctrl.parent.editQuoteMeta.shipment_insurance\">\n<md-input-container md-no-float class=\"inline-flex m-0\"><span class=\"mt-5 pr-5 opacity\"><md-select \nng-model=\"ctrl.parent.editQuoteMeta.insurance_currency\" placeholder=\"Currency\" class=\"m-0 select_box\" \nname=\"leg_currency\"><md-option ng-repeat=\"curr in ctrl.parent.currencyList track by $index\" ng-value=\"curr\">{{curr}}\n</md-option></md-select></span><md-input-container md-no-float class=\"inline-flex m-0\"><input \nng-model=\"ctrl.parent.editQuoteMeta.insurance_leg_cost\" type=\"number\" min=\"0\" step=\"any\" placeholder=\"Value of good\" \nid=\"value_of_good\" name=\"value_of_good\" class=\"m-0 select_box w-100 mt-2\"></md-input-container></md-input-container>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"white-bg footer\" layout-wrap \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"font-size-12 grey-fg font-weight-600 pr-8 pl-10\">STATUS</div><div class=\"bl\"><span class=\"font-weight-600\">\n<md-icon md-font-icon=\"icon-flickr-after\" ng-style=\"ctrl.parent.fnGetColorByStatusName(ctrl.parent.quote_Status)\" \nclass=\"mb-2 s30\" ng-class=\"{\'mr-10\' : !ctrl.parent.util.isMobileDevice}\"></md-icon>{{ctrl.parent.quote_Status}}</span>\n</div></div><div layout-align=\"end center\" class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(\'Cancel button-EQ\')\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\">Save</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/quotes/dialogs/edit-quote/lcl-edit-quote.html","<md-dialog id=\"edit-quote\" class=\"popup-md\"><form name=\"quoteSearchEditFcl\" \nng-submit=\"ctrl.parent.fnSearchMetaEdit(quoteSearchEditFcl)\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools pl-20\"><div><b>Edit</b> Quotation</div><span flex></span><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog(\'Close icon-EQ\')\"><md-icon class=\"fg-AAA8AD cursor\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"m-0 p-0 body\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div layout=\"column\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label class=\"pb-6-imp\">Quote ID</label><md-input-container \nclass=\"input_container\" md-no-float><input class=\"panel-select-disabled md-input-focused\" \nng-model=\"ctrl.parent.quote_result.result_data.quote_id\" ng-disabled=\"ctrl.parent.quote_result.result_data.quote_id\">\n</md-input-container></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label \nclass=\"pb-6-imp\">Incoterms</label><div><incoterm-select incoterm=\"ctrl.parent.incotermsEdit\" \nimpo-expo=\"ctrl.parent.impoExpoEdit\" full-border=\"true\" select-panel-width=\"\'260\'\"></incoterm-select></div></div></div>\n<div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label class=\"pb-6-imp\">Cargo Ready Date</label><date-picker \nmd-input-id=\"\'cargo_date\'\" \nis-validate=\"(ctrl.parent.validationObj.cargoDateValiation || (quoteSearchEditFcl.cargo_date.$touched && quoteSearchEditFcl.cargo_date.$error.valid))\" \nis-editable=\"false\" is-disabled=\"false\" input-required=\"true\" input-name=\"\'cargo_date\'\" \ndate-placeholder=\"\'Enter date\'\" date-format=\"true\" full-border=\"true\" min-date-value=\"ctrl.parent.startDateStart\" \nmax-date-value=\"ctrl.parent.expiryEdit\" model-value=\"ctrl.parent.editQuoteMeta.cargo_ready_date\" \ncallback=\"ctrl.parent.editQuoteMeta.cargo_ready_date=value;ctrl.parent.validationObj.cargoDateValiation=false;\">\n</date-picker><div \nng-messages=\"!ctrl.parent.validationObj.cargoDateValiation && quoteSearchEditFcl.cargo_date.$touched && quoteSearchEditFcl.cargo_date.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"ctrl.parent.validationObj.cargoDateValiation\" class=\"validation-error-text\"><span>Select Cargo date</span></div>\n</div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label class=\"pb-6-imp\">\nExpiry Date</label><div><date-picker md-input-id=\"\'expiry_date\'\" \nis-validate=\"(ctrl.parent.validationObj.expiryValitdation  || (quoteSearchEditFcl.expiry_date.$touched && quoteSearchEditFcl.expiry_date.$error.valid))\" \nis-editable=\"false\" is-disabled=\"false\" input-required=\"true\" input-name=\"\'expiry_date\'\" \ndate-placeholder=\"\'Enter date\'\" date-format=\"true\" full-border=\"true\" \nmin-date-value=\"ctrl.parent.editQuoteMeta.cargo_ready_date\" max-date-value=\"ctrl.parent.expiryMaxDate\" \nmodel-value=\"ctrl.parent.expiryEdit\" \ncallback=\"ctrl.parent.expiryEdit=value;ctrl.parent.validationObj.expiryValitdation=false;ctrl.parent.validateExpirydate(ctrl.parent.expiryEdit);\">\n</date-picker><div \nng-messages=\"!ctrl.parent.validationObj.expiryValitdation && !ctrl.parent.validationObj.showDateNote && quoteSearchEditFcl.expiry_date.$touched && quoteSearchEditFcl.expiry_date.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"ctrl.parent.validationObj.expiryValitdation\" class=\"validation-error-text\"><span>Select Expiry Date</span></div>\n<div ng-if=\"ctrl.parent.validationObj.showDateNote\" class=\"font-size-11 Font-Regular pt-5\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"orange-400-fg mr-5 s12\"></md-icon>Exceeds expiry date of rates</div></div></div></div>\n<div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label class=\"pb-6-imp\">\n{{ctrl.parent.editQuoteMeta.mode == \'AIR\' ? \'No.of AWB\' : \'No.of B/L\' }}</label><md-input-container md-no-float><input \nrestrict-to=\"[0-9]\" min=\"0\" max=\"100\" type=\"number\" ng-keyup=\"ctrl.parent.validationObj.AWBValidation=false\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.AWBValidation}\" \nng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.total_bl\" class=\"panel-select md-input-focused pl-5\" \nname=\"no_bl\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"B/L\" autocomplete=\"off\" onkeypress=\"return !(event.charCode == 46)\"><div \nng-if=\"ctrl.parent.validationObj.AWBValidation\" class=\"validation-error-text\"><span>\n{{ctrl.parent.editQuoteMeta.mode == \'AIR\' ? \'Enter No.of AWB\' : \'Enter No.of B/L\' }}</span></div><div \nng-if=\"quoteSearchEditFcl.no_bl.$error.min\" class=\"validation-error-text\">\nEnter valid {{ctrl.parent.editQuoteMeta.mode == \'AIR\' ? \'AWB\' : \'B/L\' }}</div></md-input-container></div><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label class=\"pb-6-imp\">\nNo. Of Shipping Bill</label><div><md-input-container md-no-float class=\"p-0 m-0 inputWidth-100\"><input \nrestrict-to=\"[0-9]\" min=\"0\" max=\"100\" type=\"number\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.shippinglclbillValidation}\" \nng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.total_sbl\" class=\"panel-select md-input-focused pl-5\" \nng-keyup=\"ctrl.parent.validationObj.shippinglclbillValidation=false\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"No. Of Shipping Bill\" autocomplete=\"off\" onkeypress=\"return !(event.charCode == 46)\" name=\"shipping_bill\">\n<div ng-if=\"ctrl.parent.validationObj.shippinglclbillValidation\" class=\"validation-error-text\"><span>\nEnter No.of Shipping Bill</span></div><div ng-if=\"quoteSearchEditFcl.shipping_bill.$error.min\" \nclass=\"validation-error-text\">Enter valid Shipping Bill</div></md-input-container></div></div></div><div layout=\"row\" \nflex=\"100\" layout-xs=\"column\" class=\"row-spacing\" ng-if=\"ctrl.parent.editQuoteMeta.mode == \'SEA-LCL\'\"><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label class=\"pb-6-imp\">No. Of Pallets\n</label><div><md-input-container md-no-float class=\"p-0 m-0 inputWidth-100\"><input restrict-to=\"[0-9]\" min=\"0\" \nmax=\"100\" type=\"number\" ng-class=\"{\'validation-error\':ctrl.parent.validationObj.palletsValidation}\" \nng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.total_pallets\" class=\"panel-select md-input-focused pl-5\" \nng-keyup=\"ctrl.parent.validationObj.palletsValidation=false\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-NoOfPallets-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"No. Of Pallets\" autocomplete=\"off\" onkeypress=\"return !(event.charCode == 46)\" name=\"total_pallets\"><div \nng-if=\"ctrl.parent.validationObj.palletsValidation\" class=\"validation-error-text\"><span>Enter No. Of Pallets</span>\n</div><div ng-if=\"quoteSearchEditFcl.total_pallets.$error.min\" class=\"validation-error-text\">\nEnter Valid Number Of Pallets</div></md-input-container></div></div></div><div layout=\"column\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\" ng-if=\"ctrl.parent.isCommodity\"><label class=\"pb-6-imp\">Commodity</label><div>\n<md-input-container md-no-float class=\"mv-0 commodity_input\"><commodity-chips is-valid=\"false\" \nmd-input-id=\"\'commodity_id_web\'\" commodity-array=\"ctrl.parent.quote_result.result_data.commodity_data\" \ncategory=\"\'QuoteDetails\'\"></commodity-chips></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"group-spacing\"><div flex=\"50\" flex-xs=\"100\"><div>Load Details</div></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" ng-if=\"ctrl.parent.editQuoteMeta.load_data.load_type == \'units\'\" class=\"row-spacing\"><table \nclass=\"load-table\" borderless flex=\"100\"><thead><tr><th class=\"label_text\">Units</th><th class=\"label_text pl-15\">\nUnit Dimensions ( l x b x h )</th><th class=\"label_text\">Unit Gross Weight</th><th></th></tr></thead><tbody><tr \nng-repeat=\"load in ctrl.parent.editQuoteMeta.load_data.load_details_value track by $index\"><td class=\"font-size-14\">\n<div layout=\"row\" flex=\"100\" class=\"flex\" ng-class=\"{\'mt-20\':$index >0}\"><md-input-container md-no-float><input \nclass=\"panel-select\" type=\"number\" name=\"qty\" ng-model=\"load.qty\" min=\"1\" max=\"1000\" \nonkeypress=\"return !(event.charCode == 46)\" \nng-class=\"{\'validation-error\': (ctrl.parent.validationObj.unitValidation && !load.qty)}\" \nng-keyup=\"ctrl.parent.validationObj.unitValidation=false;\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-LoadDetails-Units-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-if=\"(ctrl.parent.validationObj.unitValidation && !load.qty)\" class=\"lh-13 validation-error-text\">Enter Units</div>\n<div ng-if=\"quoteSearchEditFcl.qty.$error.min && !load.qty\" class=\"lh-13 validation-error-text\">Enter valid Unit</div>\n</md-input-container></div></td><td class=\"font-size-14 ph-15\"><div layout=\"row\" flex=\"100\" class=\"flex\" \nng-class=\"{\'mt-20\':$index >0}\"><md-input-container md-no-float style=\"margin-right: 5px\"><input \nid=\"lclEditQuoteLength\" class=\"panel-select mb-3\" type=\"number\" ng-model=\"load.length\" name=\"length\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.parent.setThreeNumberDecimal($event);ctrl.parent.validationObj.unitsLengthValidation=false\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-LoadDetails-Length-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"L\" ng-class=\"{\'validation-error\': (ctrl.parent.validationObj.unitsLengthValidation && !load.length)}\"><div\n ng-if=\"(ctrl.parent.validationObj.unitsLengthValidation && !load.length)\" \nclass=\"validation-error-text dimension-height\"><span class=\"pt-3\">Enter length</span></div><div \nng-if=\"quoteSearchEditFcl.length.$error.min && !load.length\" class=\"lh-13 validation-error-text\"><span>\nEnter valid length</span></div></md-input-container><md-input-container md-no-float style=\"margin-right: 5px\"><input \nid=\"lclEditQuoteBreadth\" class=\"panel-select mb-3\" type=\"number\" ng-model=\"load.breadth\" name=\"breadth\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.parent.setThreeNumberDecimal($event);ctrl.parent.validationObj.unitsbreadthValidation=false\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-LoadDetails-Breadth-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"B\" ng-class=\"{\'validation-error\': (ctrl.parent.validationObj.unitsbreadthValidation && !load.breadth)}\">\n<div ng-if=\"(ctrl.parent.validationObj.unitsbreadthValidation && !load.breadth)\" \nclass=\"validation-error-text dimension-height\"><span>Enter breadth</span></div><div \nng-if=\"quoteSearchEditFcl.breadth.$error.min && !load.breadth\" class=\"lh-13 validation-error-text\"><span>\nEnter valid breadth</span></div></md-input-container><md-input-container md-no-float style=\"margin-right: 5px\"><input \nid=\"lclEditQuoteHeight\" class=\"panel-select mb-3\" type=\"number\" ng-model=\"load.height\" name=\"height\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.parent.setThreeNumberDecimal($event);ctrl.parent.validationObj.unitsheightValidation=false\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-LoadDetails-Height-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"H\" ng-class=\"{\'validation-error\': (ctrl.parent.validationObj.unitsheightValidation && !load.height)}\"><div\n ng-if=\"(ctrl.parent.validationObj.unitsheightValidation && !load.height)\" \nclass=\"validation-error-text dimension-height\"><span>Enter height</span></div><div \nng-if=\"quoteSearchEditFcl.height.$error.min && !load.height\" class=\"lh-13 validation-error-text\"><span>\nEnter valid height</span></div></md-input-container><md-input-container md-no-float><md-select class=\"panel-select\" \nname=\"dimension_unit\" ng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.dimension_unit\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-LoadDetails-Dimension-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nrequired><md-option value=\"CMS\">CMS</md-option><md-option value=\"Inches\">Inches</md-option></md-select>\n</md-input-container></div></td><td class=\"font-size-14\"><div layout=\"row\" flex=\"100\" class=\"flex\" \nng-class=\"{\'mt-20\':$index >0}\"><md-input-container md-no-float style=\"margin-right: 5px\"><input \nid=\"lclEditQuoteWeight\" class=\"panel-select mb-3\" type=\"number\" ng-model=\"load.weight\" name=\"weight\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.parent.setThreeNumberDecimal($event);ctrl.parent.validationObj.unitsweightValidation=false\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-LoadDetails-GrossWeight-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Weight\" \nng-class=\"{\'validation-error\': (ctrl.parent.validationObj.unitsweightValidation && !load.height)}\"><div \nng-if=\"(ctrl.parent.validationObj.unitsweightValidation && !load.weight)\" \nclass=\"validation-error-text dimension-height\">Enter weight</div><div \nng-if=\"quoteSearchEditFcl.weight.$error.min && !load.weight\" class=\"lh-13 validation-error-text\"><span>\nEnter valid weight</span></div></md-input-container><md-input-container class=\"panel-select\"><md-select \nname=\"input_weight_unit\" ng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.input_weight_unit\" \nng-change=\"ctrl.parent.trackEvent(\'QD-EditQuotation-LoadDetails-Metrics-Change\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nrequired><md-option value=\"KGs\">KGs</md-option><md-option value=\"LBs\">LBs</md-option></md-select></md-input-container>\n</div></td><td><div layout-align=\"center center\" layout=\"row\" flex=\"100\" ng-class=\"{\'mt-20\':$index >0}\"><md-icon \nclass=\"s20 cursor ml-15\" md-font-icon=\"icon-minus-circle-outline red-400-fg\" title=\"Remove Load\" \nng-click=\"ctrl.parent.rm_lcl_air_load($index,ctrl.parent.editQuoteMeta.load_data)\" ng-show=\"$index!=0\"></md-icon>\n<md-icon class=\"s20 cursor ml-15\" md-font-icon=\"icon-plus-circle-outline green-400-fg\" title=\"Add Load\" \nng-click=\"ctrl.parent.add_lcl_air_load(ctrl.parent.editQuoteMeta.load_data)\" \nng-show=\"ctrl.parent.editQuoteMeta.load_data.load_details_value.length<25 && (ctrl.parent.editQuoteMeta.load_data.load_details_value.length-1 === $index)\">\n</md-icon></div></td></tr></tbody></table></div><div layout=\"row\" flex=\"100\" \nng-if=\"ctrl.parent.editQuoteMeta.load_data.load_type == \'total_shipment\'\" class=\"row-spacing\"><table \nclass=\"load-table\" borderless flex=\"100\"><thead><tr><th class=\"label_text\">Units</th><th class=\"label_text\">\nTotal Shipment Volume</th><th class=\"label_text\">Total Shipment Weight</th></tr></thead><tbody><tr><td \nclass=\"font-size-14\"><div layout=\"row\" flex=\"100\" class=\"flex\"><md-input-container class=\"w-80\" md-no-float><input \nclass=\"panel-select\" type=\"number\" name=\"total_qty\" ng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.total_qty\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.unitValidation}\" \nng-keyup=\"ctrl.parent.validationObj.unitValidation=false\" min=\"1\" max=\"1000\" \nonkeypress=\"return !(event.charCode == 46)\"><div ng-if=\"ctrl.parent.validationObj.unitValidation\" \nclass=\"validation-error-text\"><span>Enter Load Units</span></div><div ng-if=\"quoteSearchEditFcl.total_qty.$error.min\" \nclass=\"validation-error-text\">Enter valid Load Units</div></md-input-container></div></td><td class=\"font-size-14\" \nflex=\"100\"><div layout=\"row\" flex-xs=\"100\" class=\"flex\"><md-input-container style=\"margin-right: 5px\" class=\"w-100\" \nmd-no-float><input id=\"airEditQuoteVolume\" class=\"panel-select\" type=\"number\" \nng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.total_volume\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.TSVolumeValidation}\" name=\"total_volume\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.parent.setThreeNumberDecimal($event);ctrl.parent.validationObj.TSVolumeValidation=false\" \nplaceholder=\"Volume\"><div ng-if=\"ctrl.parent.validationObj.TSVolumeValidation\" class=\"validation-error-text\"><span>\nEnter Total Volume</span></div><div ng-if=\"quoteSearchEditFcl.total_volume.$error.min\" class=\"validation-error-text\">\nEnter valid Volume</div></md-input-container><md-input-container md-no-float><md-select class=\"panel-select\" \nname=\"volume_unit\" ng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.volume_unit\" required><md-option \nvalue=\"CBM\" selected=\"selected\">CBM</md-option><md-option value=\"CFT\">CFT</md-option></md-select></md-input-container>\n</div></td><td class=\"font-size-14\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\" class=\"flex\"><md-input-container \nstyle=\"margin-right: 5px\" class=\"w-100\" md-no-float><input id=\"airEditQuoteWeight\" class=\"panel-select\" type=\"number\" \nng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.total_weight\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.TSWeightValidation}\" name=\"total_weight\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.parent.setThreeNumberDecimal($event); ctrl.parent.validationObj.TSWeightValidation=false\" \nplaceholder=\"Total Weight\"><div ng-if=\"ctrl.parent.validationObj.TSWeightValidation\" class=\"validation-error-text\">\n<span>Enter Total Weight</span></div><div ng-if=\"quoteSearchEditFcl.total_weight.$error.min\" \nclass=\"validation-error-text\">Enter valid Weight</div></md-input-container><md-input-container md-no-float><md-select \nclass=\"panel-select\" name=\"input_weight_unit\" \nng-model=\"ctrl.parent.editQuoteMeta.load_data.load_meta.input_weight_unit\" required><md-option value=\"KGs\">KG\n</md-option><md-option value=\"LBs\">LB</md-option></md-select></md-input-container></div></td></tr></tbody></table>\n</div><div class=\"note_text pt-20\">\nNote : Whenever there is a change in the quantity, please update the charges manually in the rate card.</div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div class=\"mr-20 fg-AAA8AD font-size-13 Font-Bold\">\nUnits<div class=\"fg-333333 font-size-13 pt-5\">{{ctrl.parent.editQuoteMeta.load_data.load_details_value.length}}</div>\n</div><div class=\"mr-20 fg-AAA8AD font-size-13 Font-Bold\">Gross Wt.<div class=\"fg-333333 font-size-13 pt-5\">\n{{ctrl.parent.editQuoteMeta.load_data.load_meta.gross_weight | weightUnit:\'gross_weight\':ctrl.parent.editQuoteMeta.mode| currencyMask: 2}} {{ ctrl.parent.editQuoteMeta.mode == \'SEA-LCL\' ? ctrl.parent.gross_weight_unit:ctrl.parent.util.grossWeightUnit[ctrl.parent.editQuoteMeta.mode] }} \n<span ng-if=\"ctrl.parent.measurementSystem != \'metric\'\">\n/ {{ ctrl.parent.convertedLoad.gross_weight.value | currencyMask: 2}} {{ctrl.parent.convertedLoad.gross_weight.unit}}\n</span></div></div><div class=\"mr-20 fg-AAA8AD font-size-13 Font-Bold\">Volumetric Wt.<div \nclass=\"fg-333333 font-size-13 pt-5\">\n{{ctrl.parent.editQuoteMeta.load_data.load_meta.volumetric_weight | currencyMask: 2}} {{ ctrl.parent.util.volumetricWeightUnit[ctrl.parent.editQuoteMeta.mode] }} \n<span ng-if=\"ctrl.parent.measurementSystem != \'metric\'\">\n/ {{ ctrl.parent.convertedLoad.volumetric_weight.value | currencyMask: 2}} {{ctrl.parent.convertedLoad.volumetric_weight.unit}}\n</span></div></div><div class=\"mr-20 fg-AAA8AD font-size-13 Font-Bold\">Chargeable Wt.<div \nclass=\"fg-333333 font-size-13 pt-5\">\n{{ctrl.parent.editQuoteMeta.load_data.load_meta.chargeable_weight | currencyMask: 2}} {{ctrl.parent.util.chargeableUnit[ctrl.parent.editQuoteMeta.mode]}}\n</div></div></div><div layout=\"row\" layout-xs=\"column\" class=\"group-spacing\"><div flex=\"50\" flex-xs=\"100\"><div>\nOther Details</div></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"33\" \nclass=\"feild-spacing\" flex-xs=\"100\"><div class=\"font-weight-600\">Hazardous</div><div class=\"mt-6\" layout=\"row\"><div \nclass=\"pr-20\">No</div><md-switch md-no-ink class=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" \nng-model=\"ctrl.parent.hazardousEdit\" ng-click=\"ctrl.parent.trackEvent(\'QD-EditQuotation-Hazardous-Change\')\">\n</md-switch><div class=\"pl-20\">Yes</div></div></div><div flex=\"33\" class=\"feild-spacing\" flex-xs=\"100\"><div \nclass=\"font-weight-600\">Customs</div><div class=\"mt-6\" layout=\"row\"><div class=\"pr-20\">No</div><md-switch md-no-ink \nclass=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" ng-model=\"ctrl.parent.customsEdit\"></md-switch><div \nclass=\"pl-20\">Yes</div></div></div><div flex=\"33\" class=\"feild-spacing\" flex-xs=\"100\"><div \nclass=\"font-weight-600 mb-6\">Perishable</div><div class=\"mt-6\" layout=\"row\"><div class=\"pr-20\">No</div><md-switch \nmd-no-ink class=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" ng-model=\"ctrl.parent.perishableEdit\" \nng-click=\"ctrl.parent.trackEvent(\'QD-EditQuotation-Perishable-Change\')\"></md-switch><div class=\"pl-20\">Yes</div></div>\n</div></div><div layout=\"column\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"100\" \nlayout-xs=\"column\"><label class=\"pb-6-imp\">Terms And Conditions</label><div class=\"quote-editor\"><ng-ckeditor \nng-model=\"ctrl.parent.termsEdit\" id=\"termsConditions\" ng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div>\n</div><div layout=\"column\" flex=\"100\" layout-xs=\"column\"><md-checkbox md-no-ink class=\"mb-0 mt-10\" \nng-click=\"ctrl.parent.fnDefaultTermsAndConditions();\" ng-model=\"ctrl.parent.showTermsConditions\"><div \nclass=\"mb-2 fg-3B82F6 font-size-13\">Use Standard T&C</div></md-checkbox></div></div><div flex-gt-xs class=\"ph-15 hide\" \nlayout=\"column\" flex-xs=\"100\"><div class=\"font-size-14 mt-15 mb-30 black-400-fg font-weight-600\">ADDITIONAL SERVICES\n</div><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteMeta.origin_charges\" aria-label=\"\"><span class=\"label\">\nOrigin Charges</span></md-checkbox><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteMeta.origin_customs\" \naria-label=\"\"><span class=\"label\">Origin Custom Clearance</span></md-checkbox><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editQuoteMeta.destination_charges\" aria-label=\"\"><span class=\"label\">Destination Charges</span>\n</md-checkbox><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteMeta.destination_customs\" aria-label=\"\"><span \nclass=\"label\">Destination Custom Clearance</span></md-checkbox><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editQuoteMeta.shipment_insurance\" aria-label=\"\"><span class=\"label\">Insurance Charges</span>\n</md-checkbox><div class=\"font-size-14 black-fg\" ng-if=\"ctrl.parent.editQuoteMeta.shipment_insurance\">\n<md-input-container md-no-float class=\"inline-flex m-0\"><span class=\"mt-5 pr-5 opacity\"><md-select \nng-model=\"ctrl.parent.editQuoteMeta.insurance_currency\" placeholder=\"Currency\" class=\"m-0 select_box\" \nname=\"leg_currency\"><md-option ng-repeat=\"curr in ctrl.parent.currencyList track by $index\" ng-value=\"curr\">{{curr}}\n</md-option></md-select></span><md-input-container md-no-float class=\"inline-flex m-0\"><input \nng-model=\"ctrl.parent.editQuoteMeta.insurance_leg_cost\" type=\"number\" min=\"0\" step=\"any\" placeholder=\"Value of good\" \nid=\"value_of_good\" name=\"value_of_good\" class=\"m-0 select_box w-100 mt-2\"></md-input-container></md-input-container>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"white-bg footer\" layout-wrap \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"font-size-12 grey-fg font-weight-600 pr-8 pl-10\">STATUS</div><div class=\"bl pl-8\"><span class=\"font-weight-600\">\n<md-icon md-font-icon=\"icon-flickr-after\" ng-style=\"ctrl.parent.fnGetColorByStatusName(ctrl.parent.quote_Status)\" \nclass=\"mb-2 mr-10 s30\"></md-icon>{{ctrl.parent.quote_Status}}</span></div></div><div layout-align=\"end center\" \nclass=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(\'Cancel button-EQ\')\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\">Save</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/quotes/dialogs/get-legs/get-legs.html","<div id=\"get-legs\"><div ng-repeat=\"(legKey, legValue) in $ctrl.getLegOptions track by $index\" \nclass=\"b mb-20 brad-radious-top-4\" ng-class=\"{\'mt-20\': !$first}\"><div \nclass=\"font-size-13 font-weight-600 bg-f5f5f5 fg-333333 pv-10 ph-20\">{{legValue.leg_name}}</div><md-expansion-panel \nclass=\"leg-expansion ph-20\" ng-class=\"{\'bb\' : !$last}\" md-component-id=\"legInfo\" \nng-repeat=\"rate in legValue.legs track by $index\"><md-expansion-panel-collapsed class=\"cursor p-0\"><div layout=\"row\" \nflex=\"100\" layout-align=\"space-between center\" class=\"font-size-13 font-weight-600 fg-333333\" layout-wrap><div \nflex-xs=\"100\" layout-align=\"start start\" class=\"text-truncate\"><md-checkbox md-no-ink class=\"mb-0 w-30\" \nng-model=\"rate.selected\" ng-click=\"$event.stopPropagation()\" ng-change=\"$ctrl.selectLeg(legKey, rate)\"></md-checkbox>\n<span class=\"pl-2 pr-8\">{{rate.leg_name}}</span></div><div flex layout=\"row\"><div layout-align=\"start start\" \nclass=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.via_pol\"><span>POL - </span><span class=\"Font-Regular\">{{rate.via_pol}}\n</span></div><div layout-align=\"start start\" class=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.origin_haulage\"><span>\nOrigin Haulage - </span><span class=\"Font-Regular\">{{rate.origin_haulage}}</span></div><div layout-align=\"start start\" \nclass=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.via_pod\"><span>POD - </span><span class=\"Font-Regular\">{{rate.via_pod}}\n</span></div><div layout-align=\"start start\" class=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.destination_haulage\">\n<span>Destination Haulage - </span><span class=\"Font-Regular\">{{rate.destination_haulage}}</span></div><div \nlayout-align=\"space-between start\" class=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.service_type\"><span>Service Type - \n</span><span class=\"Font-Regular\">{{rate.service_type}}</span></div></div><div flex-xs=\"100\" layout-align=\"end center\" \nclass=\"text-truncate\"><span>Total {{rate.leg_currency}} {{rate.leg_currency_cost | currencyMask: 2}}</span><md-icon \nclass=\"w-25 ml-7\" md-font-icon=\"icon-chevron-down\" layout-align=\"end center\" ng-click=\"$panel.collapse()\"></md-icon>\n</div></div></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header \nng-click=\"$panel.collapse()\" class=\"cursor p-0\"><div layout=\"row\" flex=\"100\" layout-align=\"space-between center\" \nclass=\"font-size-13 font-weight-600 fg-333333\" layout-wrap><div flex-xs=\"100\" layout-align=\"start start\" \nclass=\"text-truncate\"><md-checkbox md-no-ink class=\"mb-0 w-30\" ng-model=\"rate.selected\" \nng-click=\"$event.stopPropagation()\" ng-change=\"$ctrl.selectLeg(legKey, rate)\"></md-checkbox><span class=\"pl-2 pr-8\">\n{{rate.leg_name}}</span></div><div flex layout=\"row\"><div layout-align=\"start start\" \nclass=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.via_pol\"><span>POL - </span><span class=\"Font-Regular\">{{rate.via_pol}}\n</span></div><div layout-align=\"start start\" class=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.origin_haulage\"><span>\nOrigin Haulage - </span><span class=\"Font-Regular\">{{rate.origin_haulage}}</span></div><div layout-align=\"start start\" \nclass=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.via_pod\"><span>POD - </span><span class=\"Font-Regular\">{{rate.via_pod}}\n</span></div><div layout-align=\"start start\" class=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.destination_haulage\">\n<span>Destination Haulage - </span><span class=\"Font-Regular\">{{rate.destination_haulage}}</span></div><div \nlayout-align=\"space-between start\" class=\"text-truncate ph-8 maxW-150\" ng-if=\"rate.service_type\"><span>Service Type - \n</span><span class=\"Font-Regular\">{{rate.service_type}}</span></div></div><div flex-xs=\"100\" layout-align=\"end center\" \nclass=\"text-truncate\"><span>Total {{rate.leg_currency}} {{rate.leg_currency_cost | currencyMask: 2}}</span><md-icon \nclass=\"w-25 ml-7\" md-font-icon=\"icon-chevron-up\" layout-align=\"end center\" ng-click=\"$panel.collapse()\"></md-icon>\n</div></div></md-expansion-panel-header><md-expansion-panel-content class=\"opacity ph-35 pv-5\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"font-size-13 fg-333333 pv-5\" \nng-repeat=\"charge in rate.charges track by $index\"><div layout-align=\"start start\" flex-xs=\"100\">\n{{charge.charge_name}} {{charge.container_type}}</div><div layout-align=\"end center\" flex-xs=\"100\">\n{{rate.leg_currency}} {{charge.leg_currency_cost | currencyMask: 2}}</div></div></md-expansion-panel-content>\n</md-expansion-panel-expanded></md-expansion-panel></div></div>");
$templateCache.put("app/main/quotes/dialogs/newCard/newCardEntry.html","<md-dialog class=\"NewCardModal popup-md\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div class=\"p-0\" \nflex=\"90\" flex-xs=\"90\">Create New Card</div><div layout=\"row\" class=\"p-0\" layout-align=\"end end\" flex=\"10\" \nflex-xs=\"10\"><md-icon md-font-icon=\"icon-close fg-AAA8AD m-0 cursor\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon>\n</div></div><form name=\"l3_form\" ng-submit=\"ctrl.parent.fnSubmitLegData(ctrl.parent.leg_data, \'addLeg\',l3_form)\">\n<md-dialog-content class=\"body\"><md-tabs md-dynamic-height md-border-bottom><md-tab class=\"tabs font-size-16\" \nlabel=\"{{ ctrl.parent.mainFreightNameChange ? \'Freight\' : \'Freight\' }}\"><div><div layout=\"row\" flex=\"100\" \nclass=\"row-spacing\" layout-xs=\"column\"><div flex=\"50\" layout=\"column\" flex-xs=\"100\" class=\"feild-spacing\"><label>\nRates By</label><md-input-container md-no-float><input class=\"panel-select-disabled\" \ntitle=\"{{ctrl.parent.leg_data.vendor.vendor_name}}\" disabled=\"disabled\" \nng-model=\"ctrl.parent.leg_data.vendor.vendor_name\" placeholder=\"Rates By\" name=\"rate_by\"></md-input-container></div>\n<div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing mobile-spacing\" \nng-if=\"ctrl.parent.search_param.mode != \'AIR\'\"><label>Select Liner</label><md-input-container md-no-float><md-select \nmd-no-asterisk ng-class=\"{\'validation-error\':ctrl.parent.validationObj.linerValidation}\" class=\"panel-select\" \nmd-on-open=\"ctrl.parent.validationObj.linerValidation=false\" ng-model=\"ctrl.parent.leg_data.sub_vendor_id\" \nname=\"sub_vendor_id\" placeholder=\"Select Liner\" \nng-change=\"ctrl.parent.fngetSubVendorDetails(ctrl.parent.leg_data.sub_vendor_id)\" md-on-close=\"searchSubVendor = \'\'\">\n<md-select-header><input ng-model=\"searchSubVendor\" type=\"search\" placeholder=\"Search Liner\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-option ng-repeat=\"subvendor in ctrl.parent.getSubvendor | orderBy:\'name\' | filter : {\'name\':searchSubVendor}\" \nng-value=\"subvendor.id\">{{subvendor.name}}</md-option></md-select><div class=\"validation-error-text\" \nng-if=\"ctrl.parent.validationObj.linerValidation\"><span>Select Liner</span></div></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" layout-xs=\"column\" class=\"feild-spacing mobile-spacing\" \nng-if=\"ctrl.parent.search_param.mode == \'AIR\'\"><label>Select Airline</label><md-input-container md-no-float><md-select \nmd-no-asterisk class=\"panel-select\" ng-class=\"{\'validation-error\':ctrl.parent.validationObj.airlinerValidation}\" \nmd-on-open=\"ctrl.parent.validationObj.airlinerValidation=false\" ng-model=\"ctrl.parent.leg_data.airline_code\" \nname=\"airline_code\" placeholder=\"Select Airline\" \nng-change=\"ctrl.parent.fngetAirlineDetails(ctrl.parent.leg_data.airline_code)\" md-on-close=\"searchAirline = \'\'\">\n<md-select-header><input ng-model=\"searchAirline\" type=\"search\" \nplaceholder=\"Search Airline Name (IATA Code / Airline Prefix Code)\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"airline in ctrl.parent.getAirline | orderBy:\'air_line_name\' | multipleKey :searchAirline:{air_line_name:\'air_line_name\',airline_prefix:\'airline_prefix\',iata_code:\'iata_code\'}\" \nng-value=\"airline.airline_code\">\n{{airline.air_line_name}} ({{airline.iata_code ? airline.iata_code : \'-\'}} / {{airline.airline_prefix ? airline.airline_prefix : \'-\'}})\n</md-option></md-select><div class=\"validation-error-text\" ng-if=\"ctrl.parent.validationObj.airlinerValidation\"><span>\nSelect Airline</span></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nclass=\"row-spacing\"><div flex=\"50\" layout=\"column\" class=\"feild-spacing\" flex-xs=\"100\"><label>Expiry Date</label>\n<date-picker model-value=\"ctrl.parent.leg_data.expiry\" \nis-validate=\"((ctrl.parent.validationObj.expiryValidation) || (l3_form.expiry.$touched && l3_form.expiry.$error.valid))\" \nmd-input-id=\"\'expiry_new\'\" is-editable=\"true\" is-disabled=\"false\" input-required=\"false\" full-border=\"true\" \ninput-name=\"\'expiry\'\" full-border=\"true\" date-placeholder=\"\'Expiry Date\'\" date-format=\"true\" \nmin-date-value=\"ctrl.parent.expMaxDate\" \ncallback=\"ctrl.parent.leg_data.expiry=value;ctrl.parent.validationObj.expiryValidation=false\"></date-picker><div \nng-if=\"ctrl.parent.validationObj.expiryValidation\" class=\"validation-error-text\"><span>Select Expiry Date</span></div>\n<div ng-messages=\"!ctrl.parent.validationObj.expiryValidation && (l3_form.expiry.$touched && l3_form.expiry.$error)\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div><div flex=\"50\" \nlayout=\"column\" class=\"feild-spacing mobile-spacing\" flex-xs=\"100\" layout-wrap><div><label>Transit Time</label></div>\n<md-input-container md-no-float><input class=\"panel-select\" ng-model=\"ctrl.parent.leg_data.transit_time\" \nplaceholder=\"Transit Time\" name=\"transit_time\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" layout=\"column\" class=\"feild-spacing\" flex-xs=\"100\"><label>\nService Type</label><md-input-container flex md-no-float><input class=\"panel-select\" \nng-model=\"ctrl.parent.leg_data.service_type\" placeholder=\"Service Type\"></md-input-container></div><div flex=\"50\" \nlayout=\"column\" class=\"feild-spacing\" flex-xs=\"100\"><div><label>Via Route</label></div><md-input-container md-no-float>\n<input class=\"panel-select\" ng-model=\"ctrl.parent.leg_data.via_route\" placeholder=\"Via Route\"></md-input-container>\n</div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" layout=\"column\" class=\"feild-spacing\" \nflex-xs=\"100\"><div><label>Cargo Type</label></div><md-input-container flex md-no-float><cargo-type-selection \nfull-border=\"true\" cargo-type-data=\"ctrl.parent.leg_data.cargo_type_data\" is-required=\"false\" is-valid=\"false\" \nmode=\"ctrl.parent.search_param.mode\"></cargo-type-selection></md-input-container></div><div flex=\"50\" layout=\"column\" \nclass=\"feild-spacing mobile-spacing\" flex-xs=\"100\"><div><label>Commodity</label></div><md-input-container \nclass=\"commodity_input\" md-no-float><commodity-chips md-input-id=\"\'commodity_id_new-card\'\" \ncommodity-array=\"ctrl.parent.commodityArray\" is-valid=\"false\"></commodity-chips></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\" ng-if=\"ctrl.parent.search_param.mode!=\'AIR\'\"><div \nflex=\"50\" layout=\"column\" class=\"feild-spacing\" flex-xs=\"100\" \nng-if=\"ctrl.parent.search_param.origin_location.is_icd_port || ctrl.parent.is_nearbyOrigin_icd\"><label>Port of Loading\n<md-input-container flex md-no-float class=\"panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.loadingPortValidation}\" \nng-keyup=\"ctrl.parent.validationObj.loadingPortValidation=false\"><md-autocomplete \nmd-selected-item-change=\"ctrl.parent.selectedPort(ctrl.parent.leg_data);ctrl.parent.validationObj.loadingPortValidation=false\" \nmd-input-name=\"card_origin_port\" md-selected-item=\"ctrl.parent.leg_data.via_pol\" \nmd-search-text=\"ctrl.parent.card_originSearchText\" \nmd-items=\"item in ctrl.parent.getOnlyPort(ctrl.parent.card_originSearchText,ctrl.parent.search_param.mode, \'origin\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" \nmd-require-match=\"true\" placeholder=\"Enter Loading Port\" md-menu-class=\"autocomplete-custom-template\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{ctrl.parent.card_originSearchText}}\" were found.</md-not-found></md-autocomplete>\n</md-input-container><div class=\"validation-error-text\" ng-if=\"ctrl.parent.validationObj.loadingPortValidation\"><span>\nEnter Valid Port of Loading</span></div></label></div><div flex=\"50\" layout=\"column\" class=\"feild-spacing\" \nflex-xs=\"100\" \nng-if=\"ctrl.parent.search_param.destination_location.is_icd_port || ctrl.parent.is_nearbyDestination_icd\"><div><label>\nPort of Discharge</label></div><md-input-container md-no-float class=\"panel-select\" \nng-class=\"{\'validation-error\':(ctrl.parent.validationObj.dischargePortValidation || ctrl.parent.validationObj.dischargeSamePortValidation)}\" \nng-keyup=\"ctrl.parent.validationObj.dischargePortValidation=false;ctrl.parent.validationObj.dischargeSamePortValidation=false\">\n<md-autocomplete \nmd-selected-item-change=\"ctrl.parent.selectedPort(ctrl.parent.leg_data);ctrl.parent.validationObj.dischargePortValidation=false;ctrl.parent.validationObj.dischargeSamePortValidation=false\" \nmd-input-name=\"card_destination_port\" md-selected-item=\"ctrl.parent.leg_data.via_pod\" \nmd-search-text=\"ctrl.parent.card_destinationSearchText\" \nmd-items=\"item in ctrl.parent.getOnlyPort(ctrl.parent.card_destinationSearchText,ctrl.parent.search_param.mode, \'destination\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"150\" \nmd-require-match=\"true\" placeholder=\"Enter Destination Port\" md-menu-class=\"autocomplete-custom-template\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{ctrl.parent.card_destinationSearchText}}\" were found.</md-not-found></md-autocomplete>\n</md-input-container><div class=\"validation-error-text\" ng-if=\"ctrl.parent.validationObj.dischargePortValidation\">\n<span>Enter Valid Port of Discharge</span></div><div class=\"validation-error-text\" \nng-if=\"ctrl.parent.validationObj.dischargeSamePortValidation\"><span>Loading and Discharge port can not be same!</span>\n</div></div></div><div layout=\"column\" flex=\"100\" class=\"row-spacing\"><div><label>Remarks</label></div><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.leg_data.remarks\" ng-config=\"ctrl.parent.util.ckEditorConfig\">\n</ng-ckeditor></div></div><div clayout=\"column\" flex=\"100\" class=\"row-spacing mb-20\"><div><label>Inclusion</label>\n</div><div class=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.leg_data.inclusions\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between\"><div flex>Charges</div><md-button md-no-ink class=\"md-link-btn\" type=\"button\" \nng-click=\"ctrl.parent.addCharge(ctrl.parent.leg_data, ctrl.parent.search_param.mode , \'l3_fcl\')\">+ Add Charge\n</md-button></div><div layout=\"row\" flex=\"100\" class=\"row-spacing\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\">{{ ctrl.parent.mainFreightNameChange ? \'Freight\' : \'Freight\' }}\n</div><div layout=\"row\" layout-align=\"end center\" flex-xs=\"100\" flex-gt-xs=\"40\">TOTAL COST : <span class=\"pl-25\">\n{{ctrl.parent.leg_data.leg_currency}} {{ctrl.parent.leg_data.leg_currency_cost | currencyMask : 2}}</span></div></div>\n<div class=\"simple-table-container row-spacing\" ng-if=\"ctrl.parent.leg_data.charges.length > 0\" \nng-class=\"{\'mobilecss\' : ctrl.parent.display==\'mobile\'}\"><table class=\"simple charge_table font-size-14\" \nms-responsive-table><thead><tr><th class=\"charge_heading border-right\">Action</th><th \nclass=\"charge_heading border-right\">Name</th><th class=\"charge_heading border-right\">Basis</th><th \nclass=\"charge_heading border-right\" ng-if=\"ctrl.parent.search_param.mode == \'SEA-FCL\'\">Equipment Type</th><th \nclass=\"charge_heading border-right\">Quantity</th><th class=\"charge_heading border-right\">Per Unit Rate</th><th \nclass=\"charge_heading border-right\" ng-if=\"ctrl.parent.search_param.mode != \'SEA-FCL\'\">Minimum</th><th \nclass=\"charge_heading border-right\">Charge Currency</th><th class=\"charge_heading border-right\">Charge Cost</th><th \nclass=\"charge_heading border-right\">Customer currency cost</th></tr></thead><tbody><tr \nng-repeat=\"l3_newCharge in ctrl.parent.leg_data.charges track by $index\"><td class=\"border-right text-center\"><md-icon \nclass=\"white-fg delete-icon\" md-font-icon=\"icon-minus\" \nng-click=\"ctrl.parent.confirmDeleteCharge( ctrl.parent.leg_data.leg_code,ctrl.parent.leg_data, $index,\'newCard\')\" \ntitle=\"Remove Charge\"></md-icon></td><td class=\"border-right\"><md-select md-no-asterisk \nng-model=\"l3_newCharge.charge_id\" \nng-class=\"{\'validation-bottom\':ctrl.parent.validationObj.chargeNameValidation && !l3_newCharge.charge_id}\" \nmd-on-open=\"ctrl.parent.validationObj.chargeNameValidation=false\" \nng-change=\"ctrl.parent.addChargeName(l3_newCharge.charge_id,$index)\" placeholder=\"Select Charge Name\" \nclass=\"m-0 select_box\" name=\"charge_id\" md-on-close=\"searchCharge = \'\'\"><md-select-header><input \nng-model=\"searchCharge\" type=\"search\" placeholder=\"Search Charge\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"charge_list in ctrl.parent.main_charge_list | orderBy:\'charge_name\' | filter : searchCharge\" \nng-value=\"charge_list.charge_id\">{{charge_list.charge_name}}</md-option></md-select><div class=\"dim-charge-sect\" \nng-if=\"l3_newCharge.charge_category && l3_newCharge.charge_category !== null\" ng-bind=\"l3_newCharge.charge_category\">\n</div><div ng-if=\"ctrl.parent.validationObj.chargeNameValidation && !l3_newCharge.charge_id\" \nclass=\"validation-error-text\">Enter Charge Name</div></td><td class=\"border-right\"><div layout=\"row\"><md-select \nng-model=\"l3_newCharge.charge_basis\" \nng-class=\"{\'validation-bottom\':ctrl.parent.validationObj.chargeBasicValidation && !l3_newCharge.charge_basis,\'w-basis\':l3_newCharge.charge_basis===\'per teu\'}\" \nmd-on-open=\"ctrl.parent.validationObj.chargeBasicValidation=false\" placeholder=\"Select Basis\" \nclass=\"m-0 select_box full-width\" \nng-change=\"ctrl.parent.fnGetContainerQty(ctrl.parent.leg_data,l3_newCharge, \'newCard\', \'basis\')\" name=\"charge_basis\" \nmd-on-close=\"searchBasis = \'\'\"><md-select-header><input ng-model=\"searchBasis\" type=\"search\" \nplaceholder=\"Search Basis\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"basis in ctrl.parent.view_basis | orderBy:\'charge_basis\' | filter : searchBasis\" ng-value=\"basis\">{{basis}}\n</md-option></md-select><span ng-if=\"l3_newCharge.charge_basis===\'per teu\'\"><md-icon class=\"s12\" position=\"bottom\" \nmd-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\" class=\"tooltip-height\"><div>\n20 GP/RE/NR/OT/FR - 1 TEU</div><div>40 GP/HC/RE/HR/NR/OT/FR - 2 TEU</div><div>45HC - 2.25 TEU</div><div>53HC - 2.65 TEU\n</div></md-tooltip></md-icon></span></div><span \nng-show=\"(l3_newCharge.charge_basis == ctrl.constObj.AIR_FREIGHT_BASIS) && (l3_newCharge.total_units === null)\" \nclass=\"error\">{{l3_newCharge.charge_basis}} can not applied for this charge.</span><div \nng-if=\"ctrl.parent.validationObj.chargeBasicValidation && !l3_newCharge.charge_basis\" class=\"validation-error-text\">\nSelect Charge Basis</div></td><td class=\"border-right\" ng-if=\"ctrl.parent.search_param.mode == \'SEA-FCL\'\"><div \nng-if=\"l3_newCharge.charge_basis !== \'per equipment\' && l3_newCharge.charge_basis !== \'per kg\' && l3_newCharge.charge_basis !== \'per ton\'\" \nclass=\"pt-5\">N/A</div><md-select md-no-asterisk \nng-if=\"l3_newCharge.charge_basis === \'per equipment\' || l3_newCharge.charge_basis === \'per kg\'  || l3_newCharge.charge_basis === \'per ton\'\" \nng-model=\"l3_newCharge.container_type\" \nng-change=\"ctrl.parent.fnGetContainerQty(ctrl.parent.leg_data,l3_newCharge, \'newCard\',\'container\')\" \nplaceholder=\"Equipment Type\" class=\"m-0 select_box\" name=\"container_type\" \nng-class=\"{\'validation-bottom\':ctrl.parent.validationObj.chargeContainerValidation && !l3_newCharge.container_type}\" \nmd-on-open=\"ctrl.parent.validationObj.chargeContainerValidation=false\"><md-option \nng-repeat=\"container in ctrl.parent.search_param.load_data.load_details_value\" ng-value=\"container.type\">\n{{container.type}}</md-option></md-select></td><td class=\"border-right\"><md-input-container md-no-float \nclass=\"m-0 mt-20\" ng-if=\"l3_newCharge.is_qty_editable\"><input type=\"number\" ng-model=\"l3_newCharge.total_units\" \nplaceholder=\"Total Unit\" \nng-change=\"ctrl.parent.fnGetContainerQty(ctrl.parent.leg_data,l3_newCharge, \'newCard\', \'quantity\')\">\n</md-input-container><div ng-if=\"!l3_newCharge.is_qty_editable\" class=\"pl-8 pt-8\">{{l3_newCharge.total_units}}</div>\n</td><td class=\"border-right\"><md-input-container md-no-float class=\"m-0 mt-20\"><input \nng-model=\"l3_newCharge.per_unit_rate\" \nng-class=\"{\'unit_price\':true,\'validation-bottom\':ctrl.parent.validationObj.chargeUnitValidation && !l3_newCharge.per_unit_rate}\" \ntype=\"number\" placeholder=\"per unit rate\" id=\"{{$index+\'_unit\'}}\" \nng-change=\"ctrl.parent.getChargeCost(ctrl.parent.leg_data,l3_newCharge , $index)\" name=\"per_unit_rate\" min=\"0.001\" \nstep=\"any\" ng-keyup=\"ctrl.parent.setThreeNumberDecimal($event);ctrl.parent.validationObj.chargeUnitValidation=false\">\n</md-input-container><div ng-if=\"ctrl.parent.validationObj.chargeUnitValidation && !l3_newCharge.per_unit_rate\" \nclass=\"validation-error-text dimension-height\">Enter the Charge Per Unit</div><div \nng-if=\"l3_form.per_unit_rate.$error.min && !l3_newCharge.per_unit_rate\" class=\"validation-error-text dimension-height\">\nEnter valid Charge Per Unit</div></td><td class=\"border-right\" ng-if=\"ctrl.parent.search_param.mode != \'SEA-FCL\'\">\n<md-input-container md-no-float class=\"m-0 mt-20\"><input ng-model=\"l3_newCharge.minimum_charge_cost\" type=\"number\" \nng-class=\"{\'validation-bottom\':ctrl.parent.validationObj.chargeMinimumValidation && !l3_newCharge.minimum_charge_cost}\" \nplaceholder=\"minimum charge cost\" min=\"0\" \nng-change=\"ctrl.parent.getChargeCost(ctrl.parent.leg_data,l3_newCharge , $index)\" name=\"minimum_charge_cost\" \nstep=\"any\" \nng-keyup=\"ctrl.parent.setThreeNumberDecimal($event);ctrl.parent.validationObj.chargeMinimumValidation=false\">\n</md-input-container><div \nng-if=\"ctrl.parent.validationObj.chargeMinimumValidation && !l3_newCharge.minimum_charge_cost\" \nclass=\"validation-error-text dimension-height\">Enter the Minimum Charge Cost</div><div \nng-if=\"l3_form.minimum_charge_cost.$error.min && !l3_newCharge.minimum_charge_cost\" \nclass=\"validation-error-text dimension-height\">Enter valid Minimum Charge Cost</div></td><td class=\"border-right\">\n<md-select md-no-asterisk ng-model=\"l3_newCharge.charge_currency\" placeholder=\" Select Currency\" \nclass=\"m-0 select_box\" \nng-class=\"{\'validation-bottom\':ctrl.parent.validationObj.chargeCurrencyValidation && !l3_newCharge.charge_currency}\" \nmd-on-open=\"ctrl.parent.validationObj.chargeCurrencyValidation=false\" \nng-change=\"ctrl.parent.getChargeCost(ctrl.parent.leg_data,l3_newCharge , $index)\" name=\"charge_currency\" \nmd-on-close=\"searchCurrency = \'\'\"><md-select-header><input ng-model=\"searchCurrency\" type=\"search\" \nplaceholder=\"Search Currency\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"currency in ctrl.parent.currencyList | orderBy | filter : searchCurrency\" ng-value=\"currency\">{{currency}}\n</md-option></md-select><div \nng-if=\"ctrl.parent.validationObj.chargeCurrencyValidation && !l3_newCharge.charge_currency\" \nclass=\"pt-5 validation-error-text dimension-height\">Select Charge Currency</div></td><td \nclass=\"border-right text-center\"><span class=\"font-size-14\">\n{{l3_newCharge.charge_currency}} {{l3_newCharge.charge_cost}}</span></td><td class=\"border-right text-center\"><span \nclass=\"font-size-14\">\n{{ (ctrl.parent.search_param.user.user_base_currency)+ \' \' +(l3_newCharge.customer_currency_cost | currencyMask : 2) }}\n<sup class=\"green-fg\" ng-if=\"ctrl.parent.search_param.mode != \'SEA-FCL\' && l3_newCharge.min_flag\">*<md-tooltip \nmd-direction=\"top\" class=\"font-size-10\">Minimum cost</md-tooltip></sup></span></td></tr></tbody></table></div></div>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"end end\" class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" title=\"Submit\">Submit</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/quotes/dialogs/quote-status-change/quote-status-change.html","<md-dialog id=\"reject-reason\" class=\"popup-sm\"><div layout=\"row\" class=\"header\" flex=\"100\"><div flex=\"95\" flex-xs=\"95\" \nng-class=\"{\'font-size-20\':ctrl.parent.status_change_obj.statusData.status ==\'Follow-up Required\'}\">\n{{ ctrl.parent.status_change_obj.statusData.status }}</div><div layout=\"row\" layout-align=\"end end\"><md-icon \nmd-font-icon=\"icon-close\" class=\"fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog(\'Close\')\"></md-icon></div></div>\n<form name=\"statusChangeFrm\" \nng-submit=\"ctrl.parent.fnCallStatusChangeApi(ctrl.parent.status_change_obj.quote,ctrl.parent.status_change_obj.statusData,statusChangeFrm)\">\n<md-dialog-content class=\"body\" \nng-class=\"{\'h-235\':ctrl.parent.status_change_obj.statusData.status==\'Follow-up Required\'}\"><div flex=\"100\" \nlayout=\"row\" layout-align=\"start center\">Write a comment for this status change</div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"pt-5 pb-5\"><md-input-container md-no-float class=\"height-container inputwidth100\">\n<textarea name=\"comment\" ng-model=\"ctrl.parent.status_change_obj.statusData.comment\" md-maxlength=\"180\" \nclass=\"border text-container\" ng-class=\"{\'validation-error\':ctrl.parent.followupValidation}\" \nng-keyup=\"ctrl.parent.followupValidation=false;\" placeholder=\"Enter your Comment here\" rows=\"3\" max-rows=\"6\">\n</textarea><div ng-messages=\"statusChangeFrm.comment.$error\"><div ng-message=\"md-maxlength\">That\'s too long!!</div>\n</div><div ng-if=\"ctrl.parent.followupValidation\" class=\"validation-error-text\"><span \nng-if=\"ctrl.parent.status_change_obj.statusData.status==\'Follow-up Required\'\">Enter the reason to Follow-Up</span> \n<span ng-if=\"ctrl.parent.status_change_obj.statusData.status==\'Lost\'\">Enter the reason to Lost</span> <span \nng-if=\"ctrl.parent.status_change_obj.statusData.status==\'Won\'\">Enter the reason to Won</span></div><div layout=\"row\" \nlayout-align=\"center center\" flex flex-xs=\"100\"></div></md-input-container></div><div \nng-if=\"ctrl.parent.status_change_obj.statusData.status==\'Follow-up Required\'\"><div flex=\"30\" layout=\"row\" \nlayout-align=\"start start\"><label>{{ctrl.parent.oldReminder ?\'Edit Reminder\':\'Set Reminder\'}}</label><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16 icon_margin grey-fg pointer\"></md-icon><md-tooltip \nmd-direction=\"top\" class=\"font-size-12\"><p ng-if=\"ctrl.parent.disableSetReminder\" class=\"m-0\">\nCreated by {{ctrl.parent.status_change_obj.quote.reminder[0].created_by.user_first_name+\' \'+ctrl.parent.status_change_obj.quote.reminder[0].created_by.user_last_name}}\n</p><p ng-if=\"!ctrl.parent.disableSetReminder && ctrl.parent.oldReminder\" class=\"m-0\">Tap to edit</p><p \nng-if=\"!ctrl.parent.oldReminder\" class=\"m-0\">Set reminders for your quotes,and we will duly remind you via email.</p>\n</md-tooltip></div><div flex=\"100\" layout=\"column\" layout-align=\"start start\"><date-picker \nmd-input-id=\"\'Set_Reminder\'\" \nis-validate=\"statusChangeFrm.Set_Reminder.$touched && statusChangeFrm.Set_Reminder.$error.valid\" is-editable=\"true\" \nis-disabled=\"ctrl.parent.disableSetReminder\" input-required=\"false\" input-name=\"\'Set_Reminder\'\" \ndate-placeholder=\"\'Set Reminder\'\" date-format=\"true\" full-border=\"true\" \nmin-date-value=\"ctrl.parent.status_change_obj.Start_date\" max-date-value=\"ctrl.parent.status_change_obj.End_date\" \nmodel-value=\"ctrl.parent.status_change_obj.statusData.reminder_date\" \ncallback=\"ctrl.parent.status_change_obj.statusData.reminder_date=value;\"></date-picker><div \nng-messages=\"statusChangeFrm.Set_Reminder.$touched && statusChangeFrm.Set_Reminder.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div></div>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><span flex></span><div class=\"mv-10\"><md-button \nmd-no-ink class=\"md-primary-btn\" ng-click=\"ctrl.parent.cancelDialog(\'Cancel\')\" \nng-disabled=\"ctrl.parent.disabledStatusSubmit\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn\" \nng-disabled=\"ctrl.parent.disabledStatusSubmit\" type=\"submit\" title=\"CONFIRM\">Done</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/quotes/dialogs/quote-sync-mapping/quote-sync-mapping.html","<md-dialog id=\"quote-charge-mapping\" class=\"popup-lg\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\">{{ctrl.parent.configuration.title}}</div><div layout=\"row\" layout-align=\"end end\" class=\"p-0\" flex-xs=\"10\">\n<md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog();ctrl.parent.uiData.integrationComponentOptions.menu.isEnabled=true;\"></md-icon>\n</div></div><md-dialog-content class=\"body\"><div layout=\"column\" flex=\"100\" class=\"stepper-head\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center center\" class=\"stepper-bar-container h-90\"><ul class=\"stepper-bar justify-center\" \nlayout=\"row\" flex=\"100\"><li class=\"active pointer\" \nng-repeat=\"steps in ctrl.parent.configuration.stepper track by $index\" ng-click=\"ctrl.parent.fnPrevScreen($index)\">\n{{steps}}</li><li>Done</li></ul></div></div><div layout=\"row\" flex=\"100\" class=\"stepper-bar-container mt-15\"><div \nlayout=\"column\" flex=\"100\" ng-show=\"ctrl.parent.showScreen == 0\"><form name=\"ctrl.parent.chargeMappingForm\">\n<md-expansion-panel ng-if=\"ctrl.parent.chargeMappingObj.chargeMap\"><md-expansion-panel-collapsed \nng-click=\"$ctrl.panelMappedExpansion()\" class=\"bb pointer\" \nng-style=\"{\'display\': ctrl.parent.isMappedPanelOpened  ? \'none\' : \'flex\' }\">Mapped Charges <span class=\"ml-auto\">\nView Charges<md-icon md-font-icon=\"icon-chevron-down\"></md-icon></span></md-expansion-panel-collapsed>\n<md-expansion-panel-expanded \nng-style=\"{\'display\': !ctrl.parent.isMappedPanelOpened  ? \'none\' : \'block\' ,opacity: !ctrl.parent.isMappedPanelOpened  ? \'0\' : \'1\',\'max-height\' : !ctrl.parent.isMappedPanelOpened  ? \'48px\' : \'fit-content\' }\" \nng-class=\"{\'md-show\':ctrl.parent.isMappedPanelOpened }\"><md-expansion-panel-header class=\"pointer bb\" \nng-click=\"$ctrl.panelMappedExpansion(); $panel.collapse();\">Mapped Charges <span class=\"ml-auto\"><md-icon \nmd-font-icon=\"icon-chevron-up\"></md-icon></span></md-expansion-panel-header><md-expansion-panel-content \nclass=\"font-size-14 opacity bb\"><div layout=\"row\" layout-align=\"start center\" class=\"pb-15\"><div flex=\"45\" \nclass=\"min-width-100 font-bold\">Freightify Charge Code</div><div style=\"visibility: hidden\"><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"mh-10 pointer\"></md-icon></div><div flex=\"45\" \nclass=\"min-width-100 font-bold ml-15\">TMS Charge Code</div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pb-15\" ng-repeat=\"(charge_key, charge_value) in ctrl.parent.mappedCharges track by $index\"><div flex=\"45\" \nclass=\"min-width-100\"><div class=\"charge_name_div\">{{charge_value.platform.chargeName}}<md-tooltip \nng-if=\"charge_value.platform.chargeName\" md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display: table; opacity: 1\">{{charge_value.platform.chargeName}}</md-tooltip></div></div><div><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"mh-10 pointer\"></md-icon></div><div flex=\"45\" class=\"mt-3 ml-15 min-width-100\">\n<md-input-container md-no-float class=\"inline-flex width-100-per m-0\" title=\"{{charge_value.partner.chargeName}}\" \nid=\"{{charge_key + \'_partnerCharge\'}}\" ng-keyup=\"ctrl.parent.removeValidation(charge_key,\'_partnerCharge\')\" \nng-class=\"{\'error-border-auto\' : ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\']}\" \nng-mouseleave=\"focusedCharge=false\" ng-mouseenter=\"focusedCharge=true\"><md-autocomplete \nclass=\"width-100-per min-width-100\" md-selected-item=\"selectedCharge\" md-input-name=\"{{charge_key}}\" \nmd-search-text=\"charge_value.partner.chargeName\" \nmd-selected-item-change=\" ctrl.parent.fnChargeSelection(selectedCharge,charge_key)\" \nmd-items=\"item in  ctrl.parent.getChargeMappingList(charge_value.partner.chargeName)\" md-item-text=\"item.chargeName\" \nmd-min-length=\"3\" md-no-cache=\"false\" md-require-match=\"true\" md-delay=\"300\" md-clear-button=\"focusedCharge\" \nplaceholder=\"Enter Charge name\"><md-item-template><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display: table; opacity: 1\">\n{{item.chargeName}}</md-tooltip><span class=\"text-dropdown\" md-highlight-text=\"charge_value.partner.chargeName\" \nflex=\"80\" md-highlight-flags=\"^i\" title=\"{{item.chargeName}}\">{{item.chargeName}} </span><span class=\"code-color\" \nlayout-align=\"center center\" flex=\"20\" ng-if=\"item.chargeId && item.chargeId !== null\" ng-bind=\"item.chargeId\"></span>\n</div></md-item-template><md-not-found><div>No matches found.</div></md-not-found></md-autocomplete><div \nclass=\"charge_code\" \nng-if=\"charge_value.partner.chargeId && charge_value.partner.chargeId !== null && !focusedCharge && !ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\'] && !ctrl.parent.chargeMappingForm[charge_key].$error[\'required\']\" \nng-bind=\"charge_value.partner.chargeId\"></div></md-input-container></div></div></md-expansion-panel-content>\n</md-expansion-panel-expanded></md-expansion-panel><md-expansion-panel><md-expansion-panel-collapsed \nclass=\"pointer bb\" ng-style=\"{\'display\': ctrl.parent.isPanelOpened  ? \'none\' : \'flex\' }\" \nng-click=\"ctrl.parent.panelExpansion()\" ng-if=\"ctrl.parent.chargeMappingObj.chargeMap\">Unmapped Charges<div \nclass=\"ml-auto\" layout=\"row\" layout-align=\"start center\"><span>View Charges<md-icon md-font-icon=\"icon-chevron-down\">\n</md-icon></span></div></md-expansion-panel-collapsed><md-expansion-panel-expanded \nng-style=\"{\'display\': !ctrl.parent.isPanelOpened  ? \'none\' : \'block\' ,opacity: !ctrl.parent.isPanelOpened  ? \'0\' : \'1\',\'max-height\' : !ctrl.parent.isPanelOpened  ? \'48px\' : \'fit-content\'}\" \nng-class=\"{\'md-show\':ctrl.parent.isPanelOpened }\"><md-expansion-panel-header class=\"pointer\" \nng-click=\"ctrl.parent.panelExpansion(); $panel.collapse();\">Unmapped Charges<div class=\"ml-auto\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"ctrl.parent.chargeMappingObj.chargeMap && ctrl.parent.showUnmappedCharge\"><div flex \nlayout-wrap class=\"mt-10\" layout=\"row\"><div layout=\"column\" class=\"line-height-23 mr-5\">Sync without Unmapped Charges \n<span layout-wrap class=\"font-size-8 line-height-6\"><md-icon id=\"info-icon\" \nmd-font-icon=\"s18 icon-information-outline\" class=\"mr-5 fg-icon-red\"></md-icon>\nThe Unmapped charges will not be transferred to TMS</span></div><md-checkbox md-no-ink \nng-model=\"ctrl.parent.chargeMappingObj.isUnmapped\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"ml-5 mb-0 h-30\" \nng-click=\"ctrl.parent.checkUnmapped($event)\"></md-checkbox></div><span><md-icon md-font-icon=\"icon-chevron-up\">\n</md-icon></span></div></md-expansion-panel-header><md-expansion-panel-content class=\"font-size-14 opacity\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"pb-15\" ng-if=\"ctrl.parent.unmappedList.length\"><div flex=\"45\" \nclass=\"min-width-100 font-bold\">Freightify Charge Code</div><div style=\"visibility: hidden\"><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"mh-10 pointer\"></md-icon></div><div flex=\"45\" \nclass=\"min-width-100 font-bold ml-15\">TMS Charge Code</div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pb-15\" ng-repeat=\"(charge_key, charge_value) in ctrl.parent.unmappedCharges track by $index\" \nng-if=\"ctrl.parent.unmappedList.length\"><div flex=\"45\" class=\"min-width-100\"><div class=\"charge_name_div\">\n{{charge_value.platform.chargeName}}<md-tooltip ng-if=\"charge_value.platform.chargeName\" md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display: table; opacity: 1\">\n{{charge_value.platform.chargeName}}</md-tooltip></div></div><div><md-icon md-font-icon=\"icon-arrow-right\" \nclass=\"mh-10 pointer\"></md-icon></div><div flex=\"45\" class=\"mt-3 ml-15 min-width-100\"><md-input-container md-no-float \nclass=\"inline-flex width-100-per m-0\" title=\"{{charge_value.partner.chargeName}}\" \nid=\"{{charge_key + \'_partnerCharge\'}}\" ng-keyup=\"ctrl.parent.removeValidation(charge_key,\'_partnerCharge\')\" \nng-class=\"{\'error-border-auto\' : ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\']}\" \nng-mouseleave=\"focusedCharge=false\" ng-mouseenter=\"focusedCharge=true\"><md-autocomplete \nclass=\"width-100-per min-width-100\" md-selected-item=\"selectedCharge\" md-input-name=\"{{charge_key}}\" \nmd-search-text=\"charge_value.partner.chargeName\" \nmd-selected-item-change=\" ctrl.parent.fnChargeSelection(selectedCharge,charge_key)\" \nmd-items=\"item in  ctrl.parent.getChargeMappingList(charge_value.partner.chargeName)\" md-item-text=\"item.chargeName\" \nmd-min-length=\"3\" md-no-cache=\"false\" md-require-match=\"true\" md-delay=\"300\" md-clear-button=\"focusedCharge\" \nplaceholder=\"Enter Charge Name\"><md-item-template><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display: table; opacity: 1\">\n{{item.chargeName}}</md-tooltip><span class=\"text-dropdown\" md-highlight-text=\"charge_value.partner.chargeName\" \nflex=\"80\" md-highlight-flags=\"^i\" title=\"{{item.chargeName}}\">{{item.chargeName}} </span><span class=\"code-color\" \nlayout-align=\"center center\" flex=\"20\" ng-if=\"item.chargeId && item.chargeId !== null\" ng-bind=\"item.chargeId\"></span>\n</div></md-item-template><md-not-found><div>No matches found.</div></md-not-found></md-autocomplete><div \nclass=\"charge_code\" \nng-if=\"charge_value.partner.chargeId && charge_value.partner.chargeId !== null && !focusedCharge && !ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\'] && !ctrl.parent.chargeMappingForm[charge_key].$error[\'required\']\" \nng-bind=\"charge_value.partner.chargeId\"></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pb-15 empty-state\" ng-if=\"!ctrl.parent.unmappedList.length\"><span layout-wrap \nclass=\"font-size-16 text-center\"><md-icon id=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" \nclass=\"mr-5 fg-icon-alert\"></md-icon>All charges have been mapped - Validate the charge and click \'Submit\' to proceed\n</span></div></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><div layout=\"row\" \nlayout-align=\"start center\" class=\"pb-15 empty-state\" ng-if=\"!ctrl.parent.chargeMappingObj.chargeMap\">\nNo charge mapping found.</div></form></div><div class=\"h-200\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nng-show=\"ctrl.parent.showScreen == 1\"><div class=\"w-200\" ng-if=\"!ctrl.parent.chargeMappingErr.status\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-20\">Loading...</div></div><div layout=\"row\" flex=\"100\" \nclass=\"w-50 h-50\" ng-if=\"ctrl.parent.chargeMappingErr.status\"><md-icon \nng-if=\"ctrl.parent.chargeMappingErr.status==\'COMPLETED\'\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"w-50 h-50 tick_success\"></md-icon><md-icon md-font-icon=\"icon-close-circle\" \nng-if=\"ctrl.parent.chargeMappingErr.status==\'FAILED\'\" class=\"w-50 h-50 tick_error\"></md-icon></div><div \nclass=\"pb-15 font-size-16\" ng-if=\"ctrl.parent.chargeMappingErr.status==\'FAILED\'\">\n{{ctrl.parent.chargeMappingErr.message}}</div><div class=\"pb-15 text-center\" \nng-if=\"ctrl.parent.chargeMappingErr.status==\'COMPLETED\'\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-20 font-bold pb-5\">Successfully sent</div><div class=\"font-size-14 fg-4B5563\" \nng-if=\"ctrl.parent.chargeMappingErr.responseFrom === \'Quote\'\">Your Quote has been successfully sent to Cargo Wise.\n</div><div class=\"font-size-14 fg-4B5563\" ng-if=\"ctrl.parent.chargeMappingErr.responseFrom === \'Quote\'\">\nYour Quotation Number can be found on the selected Rate Card from the Quote Summary page.</div><div \nclass=\"font-size-14 fg-4B5563\" ng-if=\"ctrl.parent.chargeMappingErr.responseFrom === \'RESULT\'\">\nThe Rate card has been successfully sent to Cargo Wise.</div><div class=\"font-size-14 fg-4B5563\" \nng-if=\"ctrl.parent.chargeMappingErr.responseFrom === \'RESULT\'\">\nYour CargoWise Quotation No. can be found on the Selected Rate Card from the Enquiry Summary Page.</div><div \nclass=\"text-center justify-center mt-2\" layout=\"row\" ng-if=\"ctrl.parent.chargeMappingErr.responseFrom === \'RESULT\'\">\n<span class=\"text-gray-400 text-sm font-bold\">Enquiry ID:</span><span class=\"text-black text-sm font-bold\"></span><div \nclass=\"md-link-fg text-sm font-bold underline pointer\" \nng-click=\"ctrl.parent.redirectToInquiry(ctrl.parent.chargeMappingErr.inquiry_id)\">\n{{ctrl.parent.chargeMappingErr.inquiry_number}}<br></div></div></div></div></div></md-dialog-content><md-dialog-actions\n class=\"footer\" layout=\"row\"><div class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog();ctrl.parent.uiData.integrationComponentOptions.menu.isEnabled=true;\" \ntitle=\"Cancel edit\" ng-disabled=\"!ctrl.parent.chargeMappingErr.status && ctrl.parent.showScreen == 2\">Close</md-button>\n<md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\" \nng-click=\"ctrl.parent.validateCustomerMapping()\" \nng-if=\"ctrl.parent.showScreen < ctrl.parent.configuration.stepper.length - 1\">Next</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\" ng-disabled=\"!ctrl.parent.chargeMappingObj.chargeMap\" \nng-click=\"ctrl.parent.validateChargeMapping(ctrl.parent.chargeMappingForm)\" \nng-if=\"ctrl.parent.showScreen == ctrl.parent.configuration.stepper.length-1\">Submit</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/quotes/dialogs/rate-card/rate-card.html","<div id=\"{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_id}}\"><div id=\"inquiryCardView\"><md-icon class=\"md-link-fg\" \nmd-font-icon=\"icon-checkbox-marked-circle\" ng-if=\"card_item.meta.is_booked\" \nstyle=\"position:absolute;right:5px;top:5px\"></md-icon><div id=\"{{card_item._id + \'_card\'}}\"><div layout=\"row\" \nlayout-align=\"space-between\" flex=\"100\" class=\"min-height-32 pt-10\"><div class=\"liner_logo\" \nng-if=\"vm.search_param.mode != \'AIR\'&& !vm.maskLiner && !vm.sharedMaskLiner\"><div \nng-show=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"comp_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"text-truncate empty_logo comp_logo\" \ntitle=\"{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\" \nng-show=\"!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.logo\">\n{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div></div><div class=\"liner_logo\" \nng-if=\"vm.search_param.mode == \'AIR\' && !vm.maskLiner && !vm.sharedMaskLiner\"><div \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.logo\"><img class=\"comp_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.logo)}}\" \nalt=\"{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.air_line_name}}\"></div><div \nng-if=\"!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.logo\" class=\"text-truncate empty_logo comp_logo\" \ntitle=\"{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.air_line_name}}\">\n{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.air_line_name}}</div></div><div class=\"liner_logo\" \nng-if=\"(vm.maskLiner && vm.search_param.mode != \'AIR\' ) || vm.sharedMaskLiner\"><div \nng-if=\"vm.maskv2 && vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code]\"><div \nng-if=\"vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].logo\"><img \nclass=\"comp_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].logo)}}\" \nalt=\"{{vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].name}}\"></div><div \nclass=\"empty_logo text-truncate comp_logo\" \ntitle=\"{{vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].name}}\" \nng-if=\"!vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].logo && vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].name\">\n{{vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].name}}<md-tooltip \nmd-direction=\"top\">{{vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code].name}}\n</md-tooltip></div></div><div class=\"empty_logo text-truncate comp_logo\" \nng-if=\"!$ctrl.maskv2[$ctrl.carddata.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.sub_vendor.carrier_code].name && vm.maskLinerText\">\n<span layout-align=\"space-around center\">{{vm.maskLinerText}}<md-tooltip md-direction=\"top\">{{vm.maskLinerText}}\n</md-tooltip></span></div><div class=\"empty_logo text-truncate\" \nng-if=\"!vm.maskLinerText && !vm.maskv2[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.carrier_code]\"><div \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.logo\"><img class=\"comp_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.logo)}}\" \nalt=\"{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\"></div><div \nclass=\"empty_logo text-truncate comp_logo\" ng-if=\"!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.logo\" \nlayout-align=\"space-around center\">{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\n<md-tooltip md-direction=\"top\">{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\n</md-tooltip></div></div></div><div class=\"liner_logo\" \nng-if=\"(vm.maskLiner && vm.search_param.mode == \'AIR\' ) || vm.sharedMaskLiner\"><div \nng-if=\"vm.maskAirline && vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code]\"><div \nng-if=\"vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].logo\"><img \nclass=\"comp_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].logo)}}\" \nalt=\"{{vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].name}}\"></div><div \nclass=\"empty_logo text-truncate comp_logo\" \ntitle=\"{{vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].name}}\" \nng-if=\"!vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].logo && vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].name\">\n{{vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].name}}<md-tooltip \nmd-direction=\"top\">{{vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].name}}\n</md-tooltip></div></div><div class=\"empty_logo text-truncate\" \nng-if=\"!vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code].name && vm.maskLinerText\">\n<span layout-align=\"space-around center\">{{vm.maskLinerText}}<md-tooltip md-direction=\"top\">{{vm.maskLinerText}}\n</md-tooltip></span></div><div class=\"empty_logo text-truncate\" \nng-if=\"!vm.maskLinerText && !vm.maskAirline[card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.airline_code]\">\n<div ng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.logo\"><img class=\"comp_logo\" \nng-src=\"{{vm.util.sanitizeQueryParams(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.logo)}}\" \nalt=\"{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.air_line_name}}\"></div><div \nclass=\"empty_logo text-truncate comp_logo\" ng-if=\"!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.logo\" \nlayout-align=\"space-around center\">{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.air_line_name}}\n<md-tooltip md-direction=\"top\">{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.airline.air_line_name}}</md-tooltip>\n</div></div></div><div layout=\"row\" layout-align=\"end start\" flex=\"100\" \nng-if=\"vm.module != \'shipment_quote\' && !vm.isShared && !vm.quote_result.result_data.is_booked && !vm.quote_result.result_data.revised && !vm.quotePreview && !vm.isLost\">\n<div class=\"pt-8 pr-10 display-content\"><span class=\"pr-8 mr-5 br mt-5\" \nng-click=\"vm.viewDetailsModal(card_item,$event,\'quotationEdit\',\'msr_rates\')\" ng-if=\"vm.util.navPermission.quotes[2]\">\n<md-icon md-svg-icon=\"assets/icons/custom/edit-icon.svg\" class=\"w-15 h-15 icon_opacity pointer\" title=\"Edit\"></md-icon>\n</span><span class=\"mt-5\" ng-click=\"vm.openDeleteCard($event,card_item._id, $index)\" \nng-if=\"vm.util.navPermission.quotes[3]\"><md-icon md-svg-icon=\"assets/icons/custom/delete-icon.svg\" \nclass=\"w-15 h-15 icon_opacity pointer\" title=\"Delete\"></md-icon></span></div></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div div-slide-show><div layout=\"row\" \nng-repeat=\"tag in card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.tags\" class=\"mv-5 ml-15\" \nng-if=\"tag.show_tag && !vm.maskLiner && !vm.sharedMaskLiner\"><img class=\"w-60\" \nng-src=\"{{vm.util.sanitizeQueryParams(tag.tag_ribbon_url)}}\"><md-tooltip md-direction=\"top\" \nstyle=\"display:table;opacity: 1\" class=\"font-size-14 pv-5 text-center font-weight-600\" \nng-show=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.rollable_available\"><div>Rollable available</div>\n</md-tooltip></div></div><div flex=\"100\" layout=\"row\" layout-align=\"end end\"><div class=\"pr-15\" \nlayout-align=\"start end\" layout=\"column\" \nflex=\"{{!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry ? \'\' : \'none\'}}\"><div layout=\"row\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.price_id && !vm.maskLiner && !vm.sharedMaskLiner && vm.util.showRateIdForContract(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.tags)\">\n<span class=\"pr-5 font-size-10\">RATE ID</span><div \nng-class=\"{\'ellipsis-100\': (card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.contract_number || card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry)}\" \nclass=\"blue-400-fg font-size-10 pointer ellipsis-80\">{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.price_id}}\n<md-tooltip md-direction=\"top\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 pt-5 text-center grey-fg font-weight-600 tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.price_id}}</div></md-tooltip></div></div><span \nclass=\"font-size-8 dotted-border-bottom pointer\" \nng-if=\"card_item.meta.type.includes(\'spot\') && (card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.data || card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.terms_and_condition.url)\" \nng-click=\"vm.viewDetailsModal(card_item,$event,\'tnc\',card_item.meta.type)\">T&C applicable<md-tooltip \nmd-direction=\"bottom\" class=\"md-whiteframe-2dp white-bg font-size-12 h-50 pt-5 text-center grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\"><div>Get Guaranteed Slot Upon</div><div>Booking Confirmation</div></md-tooltip></span>\n</div><div class=\"pr-15 font-size-11 min-width-60\" layout=\"column\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.contract_number && !vm.util.isShipper && (!card_item.meta.type.includes(\'network\')  ||  card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.show_contract_number)\">\n<span class=\"Font-Bold fg-8D8D8D\">Contract ID<md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control\" style=\"display:table;opacity: 1\">\nContract / Rate Agreement / Tariff / Spot Pricing Reference Number</md-tooltip></span><span \nclass=\"Font-Bold fg-333333 ellipsis-100\">{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.contract_number}}</span>\n<md-tooltip md-direction=\"top\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 pt-5 text-center grey-fg font-weight-600 tooltip-width-control\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.contract_number}}</div></md-tooltip></div><div \nclass=\"pr-15 font-size-10 min-width-60\" layout-align=\"end end\" layout=\"column\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry\"><span class=\"key\">Expiry Date</span> <span \nclass=\"font-weight-bold red-400-fg\">\n{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\'}}</span></div></div></div><div \nclass=\"mv-5 mh-15 blue-bg-fg font-size-10 brad-4\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.promotions.length && !vm.maskLiner && !vm.sharedMaskLiner\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"blue-600-fg s14 mh-5\"></md-icon><span \nng-repeat=\"promotion in card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.promotions track by $index\">\n{{$first ? \'\' : \', \'}} {{promotion.name}}</span></div><div layout=\"row\" class=\"ph-15 pt-10 pb-8\" flex=\"100\" \nng-if=\"vm.search_param.mode!=\'AIR\'\"><div flex layout=\"column\" layout-align=\"center start\"><div \nclass=\"grey-fg font-size-10\">Port of Loading</div><div \nclass=\"font-size-14 grey-700-fg font-weight-600 text-truncate mw-100\">\n{{card_item.meta.via_pol ? card_item.meta.via_pol : card_item.meta.port_data.origin_port_code}} <span \nng-if=\"card_item.meta.via_pol || card_item.meta.port_data.pickup_location\"><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s16 black-fg\"></md-icon><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg black-fg font-size-12 p-10\" \nng-show=\"card_item.meta.via_pol || card_item.meta.port_data.pickup_location\" \nstyle=\"height: fit-content;width: fit-content;opacity: 1\"><div ng-if=\"card_item.meta.port_data.pickup_location\"><div \nclass=\"grey-fg\">Pickup</div><div class=\"grey-800-fg font-weight-600 text-truncate\">\n{{card_item.meta.port_data.pickup_location}}</div></div><div class=\"grey-fg\">\nPort of {{ card_item.meta.via_pol ? \'Origin\' : \'Loading\' }}</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-truncate\">{{card_item.meta.port_data.origin_port_code}}</div><div \nng-if=\"card_item.meta.via_pol\"><div class=\"grey-fg\">Port of Loading</div><div \nclass=\"grey-800-fg font-weight-600 text-truncate\">{{card_item.meta.via_pol}}</div></div></md-tooltip></span></div>\n</div><div layout=\"column\" layout-align=\"center center\" class=\"h-42\"><div layout=\"row\"><div \nclass=\"grey-fg font-size-20\">. . .</div><div \nclass=\"grey-700-fg font-size-12 font-weight-600 pt-12 ph-5 text-truncate max-width-60\">\n{{ card_item.meta.selected_schedule ?(!card_item.meta.selected_schedule.transit_time ? \'N/A\' : card_item.meta.selected_schedule.transit_time) : (!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.transit_time ? \'N/A\' : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.transit_time ) }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg font-size-12 p-10\" style=\"display:table;opacity: 1\">\n<div class=\"grey-fg text-center\">Transit Time</div><div class=\"grey-fg font-weight-600 text-center\">\n{{ card_item.meta.selected_schedule ? (!card_item.meta.selected_schedule.transit_time ? \'Not Available\' : card_item.meta.selected_schedule.transit_time) : (!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.transit_time ? \'Not Available\' : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.transit_time ) }}\n</div></md-tooltip></div><div class=\"grey-fg font-size-20\">. . .</div></div><div \nclass=\"font-size-10 font-weight-700 text-center text-truncate w-90\">\n{{ card_item.meta.selected_schedule ? (card_item.meta.selected_schedule.schedule_track.length-2 > 1 ? card_item.meta.selected_schedule.schedule_track.length-2 + \'via Ports\' : (card_item.meta.selected_schedule.via_port == \'Direct\' ? \'Direct\' : \'via Port\' )) : (!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.via_route ? \'N/A\' : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.via_route ) }}\n<md-tooltip md-direction=\"Bottom\" class=\"md-whiteframe-2dp white-bg font-size-12 p-10\" \nstyle=\"display:table;opacity: 1\" \nng-show=\"card_item.meta.selected_schedule && card_item.meta.selected_schedule.via_port != \'Direct\'\"><div \nclass=\"grey-fg text-center\">via Port</div><div class=\"grey-fg font-weight-600 text-center\" \nng-repeat=\"track in card_item.meta.selected_schedule.schedule_track track by $index\" ng-show=\"!$first && !$last\">\n{{ track.port_name }}</div></md-tooltip><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg font-size-12 p-10\" style=\"display:table;opacity: 1\" \nng-show=\"!card_item.meta.selected_schedule\"><div class=\"grey-fg text-center\">via Port</div><div \nclass=\"grey-fg font-weight-600 text-center tooltip-width-control\">\n{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.via_route ? card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.via_route : \'Not Available\' }}\n</div></md-tooltip></div></div><div layout=\"column\" layout-align=\"center end\" flex><div class=\"grey-fg font-size-10\">\nPort of Discharge</div><div class=\"font-size-14 grey-700-fg font-weight-600 text-truncate mw-100\">\n{{card_item.meta.via_pod ? card_item.meta.via_pod : card_item.meta.port_data.destination_port_code}} <span \nng-if=\"card_item.meta.via_pod || card_item.meta.port_data.delivery_location\"><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s16 black-fg\"></md-icon><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg black-fg font-size-12 p-10\" \nng-show=\"card_item.meta.via_pod || card_item.meta.port_data.delivery_location\" style=\"display:table;opacity: 1\"><div \nng-if=\"card_item.meta.via_pod\"><div class=\"grey-fg text-right\">Port of Discharge</div><div \nclass=\"grey-800-fg font-weight-600 text-right text-truncate\">{{card_item.meta.via_pod}}</div></div><div \nclass=\"grey-fg text-right\">Port of {{ card_item.meta.via_pod ? \'Destination\' : \'Discharge\' }}</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-right text-truncate\">{{card_item.meta.port_data.destination_port_code}}\n</div><div ng-if=\"card_item.meta.port_data.delivery_location\"><div class=\"grey-fg text-right\">Delivery</div><div \nclass=\"grey-800-fg font-weight-600 pb-5 text-right text-truncate\">{{card_item.meta.port_data.delivery_location}}</div>\n</div></md-tooltip></span></div></div></div><div layout=\"row\" flex=\"100\" class=\"ph-15\"><div flex layout=\"column\" \nlayout-align=\"start start\" \nng-if=\"(!vm.util.isShipper && !vm.isShared) && (card_item.meta.type != \'msr_spot\' && card_item.meta.type != \'network_spot\') \" \nclass=\"mb-10\"><div class=\"font-size-10 grey-fg\">Rates By <span>\n{{ (card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? \'Agent \':\'Forwarder \' }}\n</span></div><div class=\"font-size-12 font-weight-600 text-truncate w-200\">\n{{ (card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.agent.agent_name : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.vendor.vendor_name }}\n<md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">\n{{ (card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.agent && $root.getDomainFlag(\'SHOW_AGENT_NAME\')) ? card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.agent.agent_name : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.vendor.vendor_name }}\n</md-tooltip></div></div><div flex layout=\"column\" layout-align=\"start start\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.named_account_code\" class=\"mb-10\"><div \nclass=\"font-size-10 grey-fg\">Named Account Code</div><div class=\"font-size-12 font-weight-600 text-truncate w-200\">\n{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.named_account_code }}<md-tooltip md-direction=\"bottom\" \nclass=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" style=\"display:table;opacity: 1\">\n{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.named_account_code }}</md-tooltip></div></div></div><div \nclass=\"haualge_div pv-10\" \nng-if=\"(vm.search_param.origin_location.place_type==\'Door\' || vm.search_param.destination_location.place_type==\'Door\')\">\n<div class=\"ph-15 pv-5\" layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.search_param.origin_location.place_type==\'Door\'\"><div class=\"key\">Pickup by</div><div class=\"value\">\n{{ card_item.meta.pickup_sub_vendor ? card_item.meta.pickup_sub_vendor.sub_vendor_name : \'N/A\' }}</div></div><div \nclass=\"ph-15 pv-5\" layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.search_param.destination_location.place_type==\'Door\' \"><div class=\"key\">Delivery by</div><div class=\"value\">\n{{ card_item.meta.delivery_sub_vendor ? card_item.meta.delivery_sub_vendor.sub_vendor_name : \'N/A\' }}</div></div></div>\n<div class=\"haualge_div pv-10\" layout=\"row\" layout-wrap><div flex=\"50\" class=\"ph-15 pv-5\" layout=\"column\" \nlayout-align=\"space-between\" ng-if=\"vm.search_param.mode!=\'AIR\'\"><div class=\"key\">Next Sailing On</div><div \nclass=\"value mw-150 text-truncate\">\n{{ card_item.meta.selected_schedule ? (card_item.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy\') : \'N/A\' }}\n</div></div><div ng-if=\"vm.search_param.mode === \'SEA-FCL\' \"><free-days \nfreedaysdata=\"{\n              demurrage_details : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.demurrage_details,\n              detention_details : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.detention_details,\n              combined_details : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.combined_details,\n              freeDays : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.freeDays, \n              pageSource : \'SD-Quotes\'\n            }\" \ntype=\"\'card\'\" cardid=\"card_item._id\" mode=\"vm.search_param.mode\" \nsearch-load-data=\"vm.search_param.load_data.load_details_value\"></free-days></div><div flex=\"100\" class=\"ph-15 pv-5\" \nlayout=\"column\" layout-align=\"space-between\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.cargo_type_data || card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.commodity_data.length\">\n<div class=\"key\">Cargo</div><div layout=\"row\"><div class=\"value mw-150 text-truncate text-capitalize\"><span \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.cargo_type_data\">\n{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.cargo_type_data.name }} <span \nng-show=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.commodity_data.length\">|</span> </span>\n{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.commodity_data[0].toLowerCase() }}</div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer cargo-{{card_item._id}}\" \nng-click=\"vm.shareQuoteService.showCargoCommodity($event, card_item._id, card_item.data[vm.buyOrSell][vm.l3_leg])\">\n</md-icon></div></div></div><div flex=\"50\" class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"!vm.maskLiner && !vm.sharedMaskLiner\"><div class=\"key w-80\">Service Type</div><div class=\"value\" layout=\"row\">\n<span class=\"value mw-130 text-truncate\"><span>\n{{ !card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.service_type ? \'\' : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.service_type }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ !card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.service_type ? \'\' : card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.service_type }}\n</md-tooltip></span></span><span class=\"ph-3\" \nng-if=\"(card_item.meta.selected_schedule &&card_item.meta.selected_schedule.service_name) && card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.service_type\">\n| </span><span class=\"value mw-130 text-truncate\" \nng-if=\"vm.search_param.mode!=\'AIR\' && card_item.meta.selected_schedule\">\n{{ !card_item.meta.selected_schedule.service_name ? \'\' : card_item.meta.selected_schedule.service_name }}<md-tooltip \nmd-direction=\"top\" class=\"md-whiteframe-2dp white-bg p-10 font-size-10 grey-fg font-weight-600\" \nstyle=\"display:table;opacity: 1\">\n{{ !card_item.meta.selected_schedule.service_name ? \'\' : card_item.meta.selected_schedule.service_name }}</md-tooltip>\n</span><span \nng-if=\"!((card_item.meta.selected_schedule && card_item.meta.selected_schedule.service_name) || card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.service_type)\">\nN/A</span></div></div><div flex=\"50\" class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"card_item.meta.co2eData\"><div class=\"key\"><md-icon md-svg-src=\"assets/icons/custom/co2-icon.svg\" \nclass=\"icon-class-10 mr-5\"></md-icon>CO<sub>2</sub> emission</div><div class=\"value\" layout=\"row\"><div \nclass=\"text-truncate\">{{(card_item.meta.co2eData.co2e.total | currencyMask: 2) +\' \' +\'g\'}}</div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s14 fg-3F3851 pointer co2e-{{card_item._id}}\" \nng-click=\"vm.shareQuoteService.showCo2ContainerData($event, card_item._id, card_item.meta.co2eData)\"></md-icon></div>\n</div><div flex=\"50\" class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.origin_service_mode && vm.search_param.mode === \'SEA-FCL\'\"><div\n class=\"key\" layout=\"row\" layout-align=\"start center\">Origin Service Mode</div><div class=\"value mw-150 text-truncate\">\n{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.origin_service_mode}}</div></div><div flex=\"50\" class=\"ph-15 pv-5\" \nlayout=\"column\" layout-align=\"space-between\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.destination_service_mode && vm.search_param.mode === \'SEA-FCL\'\">\n<div class=\"key\" layout=\"row\" layout-align=\"start center\">Destination Service mode</div><div \nclass=\"value mw-150 text-truncate\">{{card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.destination_service_mode}}</div>\n</div><div class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"vm.search_param.mode != \'AIR\' && card_item.data[vm.buyOrSell][vm.l1_leg] && card_item.meta.pickup_transport_mode\">\n<div class=\"key\" layout=\"row\" layout-align=\"start center\">Pickup Haulage</div><div class=\"value mw-150 text-truncate\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" ng-if=\"!card_item.meta.pickup_transport_mode\">\n</md-icon>{{card_item.meta.pickup_transport_mode ? card_item.meta.pickup_transport_mode : \'Not Available\'}}</div></div>\n<div flex=\"50\" class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"vm.search_param.mode != \'AIR\' && card_item.meta.via_pol\"><div class=\"key\" layout=\"row\" \nlayout-align=\"start center\">Origin Haulage</div><div class=\"value mw-150 text-truncate\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" ng-if=\"!card_item.meta.haulage\"></md-icon>\n{{card_item.meta.haulage ? card_item.meta.haulage : \'Not Available\'}}</div></div><div flex=\"50\" class=\"ph-15 pv-5\" \nlayout=\"column\" layout-align=\"space-between\" ng-if=\"vm.search_param.mode != \'AIR\' && card_item.meta.via_pod\"><div \nclass=\"key\" layout=\"row\" layout-align=\"start center\">Destination Haulage</div><div class=\"value mw-150 text-truncate\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" ng-if=\"!card_item.meta.destination_haulage\">\n</md-icon>{{card_item.meta.destination_haulage ? card_item.meta.destination_haulage : \'Not Available\'}}</div></div><div\n class=\"ph-15 pv-5\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"vm.search_param.mode != \'AIR\' && card_item.data[vm.buyOrSell][vm.l5_leg] && card_item.meta.delivery_transport_mode\">\n<div class=\"key\" layout=\"row\" layout-align=\"start center\">Delivery Haulage</div><div \nclass=\"value mw-150 text-truncate\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 mr-5 mb-5 orange-400-fg\" \nng-if=\"!card_item.meta.delivery_transport_mode\"></md-icon>\n{{card_item.meta.delivery_transport_mode ? card_item.meta.delivery_transport_mode : \'Not Available\'}}</div></div></div>\n<div ng-if=\"vm.search_param.mode ==\'AIR\'\"><div class=\"inactive_slab h-55 bt mv-20\" layout=\"column\" flex=\"100\" \nlayout-align=\"center center\"><div class=\"shadow_div\"></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\n<div class=\"font-size-12\">{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab }} slab</div><div \nclass=\"font-size-12 ml-5\"><span class=\"font-weight-600\">\n{{ card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.leg_total_currency }}</span> <span \nclass=\"font-weight-600 font-size-14\">\n{{ (card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.leg_total_cost / ( card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.is_higher_slab ? card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.slab : vm.search_param.load_data.load_meta.chargeable_weight) ) | currencyMask: 2 }} \n</span><span class=\"font-size-8\">per KG</span></div></div></div></div><div shimmer-effect-full width=\"97%\" \nheight=\"30px\" mh=\"10px\" ng-if=\"card_item.meta.shimmer\"></div><div shimmer-effect-full width=\"97%\" height=\"30px\" \nmh=\"10px\" ng-if=\"card_item.meta.shimmer\"></div><div \nng-if=\"!card_item.meta.shimmer && !(vm.all_in_quote == \'all_in_total\' && vm.util.isShipper)\"><div layout=\"row\" \nlayout-wrap class=\"pv-5 ph-15\" \nng-repeat=\"(leg_key,leg_value) in card_item.data[vm.buyOrSell] track by leg_value.leg_code\" \nng-class=\"{\'h-35 main-freight-div mv-5\' : leg_key == vm.l3_leg , \'mersk-spot\' : (leg_key == vm.l3_leg && (card_item.meta.type == \'msr_spot\' || card_item.meta.type == \'network_spot\')) }\" \nng-hide=\"leg_key == vm.l3_leg && !vm.search_param.freight_charges\"><div layout=\"column\" layout-align=\"center start\" \nflex=\"60\" flex-gt-xs=\"60\" ng-class=\"{\'text-truncate\': leg_key != vm.l3_leg }\"><span class=\"key pr-2\" \nng-class=\"{\'white-fg text-truncate font-size-14\' : leg_key == vm.l3_leg }\"><md-icon \nmd-font-icon=\"icon-information-outline\n                        \" class=\"s16 mb-5 pointer\" \nng-if=\"(leg_key == vm.l3_leg && !card_item.meta.isLinerChanged && (card_item.meta.type == \'msr_spot\' || card_item.meta.type == \'network_spot\'))\">\n<md-tooltip md-direction=\"bottom\" class=\"md-whiteframe-2dp white-bg grey-fg font-size-12 p-10 Gilroy-Bold\" \nstyle=\"display:table;opacity:1\">Spot Rates are dynamic &<br>can fluctuate with time</md-tooltip></md-icon>\n{{ ( leg_key == vm.l3_leg && leg_value.leg_name == vm.mainFreightName ) ? \'Freight\' : leg_value.leg_name }} <span \nng-if=\"leg_key == vm.l3_leg && card_item.data[vm.buyOrSell][leg_key].rate_obj.is_special && (card_item.data[vm.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total != undefined)\">\n<md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></span></span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"leg-cost-right pr-2 value text-truncate\" \nng-class=\"{\'red-600-fg\' : (leg_key != vm.l3_leg &&!leg_value.rate_obj), \'white-fg font-size-14\' : (leg_key == vm.l3_leg), \'grey-800-fg\' : (leg_key != vm.l3_leg)}\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask: 2) ) : \'N/A\' }}\n<md-tooltip md-direction=\"top\" class=\"md-whiteframe-2dp white-bg grey-fg font-weight-600 font-size-10 p-10\" \nstyle=\"display:table;opacity: 1\">\n{{ leg_value.rate_obj ? ( leg_value.rate_obj.leg_currency + \' \' + (leg_value.rate_obj.leg_currency_cost | currencyMask: 2) ) : \'NA\' }}\n</md-tooltip></span><span class=\"leg-cost-right pr-2 grey-500-fg font-weight-500 font-size-12 text-truncate\" \nng-if=\"leg_key == vm.l3_leg && card_item.data[vm.buyOrSell][leg_key].rate_obj.is_special && (card_item.data[vm.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total != undefined)\">\n<strike>\n{{card_item.data[vm.buyOrSell][leg_key].rate_obj.leg_currency}} {{card_item.data[vm.buyOrSell][leg_key].rate_obj.special_meta.normal_rate_total | currencyMask: 2}}\n</strike></span></div></div></div><div layout=\"row\" layout-wrap class=\"black-fg pv-10 mt-10\"><div \nclass=\"pl-15 font-size-12 font-weight-600 text-truncate\" layout=\"row\" layout-align=\"start center\" flex=\"60\" \nflex-gt-xs=\"60\"><div>Total Cost <sup ng-if=\"vm.showAsterix(card_item.data[vm.buyOrSell])\">**</sup><md-tooltip \nng-if=\"vm.showAsterix(card_item.data[vm.buyOrSell])\" md-direction=\"right\" \nclass=\"md-whiteframe-2dp white-bg grey-fg font-weight-600 font-size-10 p-10\" style=\"display:table;opacity: 1\">\nInclusive of fixed charges only</md-tooltip></div></div><div class=\"font-size-12 font-weight-600\" layout=\"row\" \nlayout-align=\"end center\" flex=\"40\" flex-gt-xs=\"40\"><span class=\"pr-15 text-truncate\">\n{{ vm.searchUser.user_base_currency + \' \' + ( card_item.meta.card_total_cost | currencyMask: 2 ) }}<md-tooltip \nmd-direction=\"top\" class=\"md-whiteframe-2dp white-bg grey-fg font-weight-600 font-size-10 p-10\" \nstyle=\"display:table;opacity: 1\">\n{{ vm.searchUser.user_base_currency + \' \' + ( card_item.meta.card_total_cost | currencyMask: 2 ) }}</md-tooltip></span>\n</div></div><div layout=\"row\" layout-wrap class=\"white-fg\" ng-if=\"vm.module !== \'shipment_quote\'\"><div layout=\"row\" \nlayout-align=\"start center\" \nflex-gt-xs=\"{{((!vm.util.navPermission.shipments[0] || !vm.showBookBtn) && !vm.isShared) ? 100: 50}}\" \nflex=\"{{((!vm.util.navPermission.shipments[0] || !vm.showBookBtn) && !vm.isShared) ? 100: 50}}\" \nclass=\"font-size-14 font-weight-600\"><md-button md-no-ink class=\"card-button details-button white-fg p-5\" \nng-click=\"vm.viewDetailsModal(card_item,$event,\'quotation\')\" title=\"View details\">VIEW DETAILS</md-button></div><div \nlayout=\"row\" layout-align=\"end\" flex=\"50\" flex-gt-xs=\"50\" class=\"font-size-14 font-weight-600\" \nng-if=\"(vm.util.navPermission.shipments[0] && vm.showBookBtn) || vm.isShared\"><md-button md-no-ink \nclass=\"card-button book-button md-accent-bg white-fg p-5\" \nng-if=\"card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry\" ng-click=\"vm.requestToBook(card_item)\" \nng-style=\"{ \'cursor\' : ((vm.util.getStatusData(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj) === \'EXPIRED\') || vm.quotePreview || vm.quote_result.result_data.is_booked || vm.quote_result.result_data.revised || vm.isQuoteModify || vm.isLost || vm.isExpired)  ? \'not-allowed\' : \'pointer\' }\" \ntitle=\"{{(vm.util.getStatusData(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj) === \'EXPIRED\') ? \'Expired\' : \'Confirm Quote\'}}\" \nng-disabled=\"!vm.isWebView && ( vm.util.getStatusData(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj) == \'EXPIRED\' || vm.quotePreview || vm.quote_result.result_data.is_booked || vm.isQuoteModify || vm.quote_result.result_data.revised || vm.isLost || vm.isExpired)\">\n{{(vm.util.getStatusData(card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj) === \'EXPIRED\') ? \'EXPIRED\' : \'CONFIRM QUOTE\'}}\n</md-button><md-button md-no-ink class=\"card-button book-button md-accent-bg white-fg p-5\" \nng-click=\"vm.requestToBook(card_item)\" ng-if=\"!card_item.data[vm.buyOrSell][vm.l3_leg].rate_obj.expiry\" \nng-style=\"{ \'cursor\' : (vm.quotePreview || vm.quote_result.result_data.is_booked || vm.quote_result.result_data.revised || vm.isQuoteModify || vm.isLost || vm.isExpired)  ? \'not-allowed\' : \'pointer\' }\" \ntitle=\"Confirm Quote\" \nng-disabled=\"!vm.isWebView && ( vm.quotePreview || vm.quote_result.result_data.is_booked || vm.isQuoteModify || vm.quote_result.result_data.revised || vm.isLost || vm.isExpired)\">\nCONFIRM QUOTE</md-button></div></div><div layout=\"row\" layout-wrap class=\"white-fg\" \nng-if=\"vm.module === \'shipment_quote\'\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\" \nclass=\"font-size-14 font-weight-600\"><md-button md-no-ink class=\"card-button details-button white-fg p-5\" \nng-click=\"vm.viewDetailsModal(card_item, $event,\'quotation\')\" title=\"View details\">VIEW DETAILS</md-button></div></div>\n</div><div class=\"overlayCard hide\" ng-style=\"vm.getCardHeight(card_item._id + \'_card\')\" \nid=\"{{card_item._id +\'_\'+ $index + \'_askDeletecard\'}}\"><div class=\"viewDetails text-center\"><md-icon \nmd-svg-src=\"assets/icons/custom/delete-card.svg\" class=\"w-105 h-130\"></md-icon><div \nclass=\"font-size-14 font-weight-bold mv-15\">Do you want to delete this rate card ?</div><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"s60 red-fg\" ng-click=\"vm.cancelDeleteCard($event,card_item._id, $index)\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\n                \" class=\"s60 green-fg\" \nng-click=\"vm.removeCardFromQuote($event,card_item._id, $index)\"></md-icon></div></div></div><div \nclass=\"overlayCard hide\" ng-style=\"vm.getCardHeight(card_item._id + \'_card\')\" \nid=\"{{card_item._id +\'_\'+ $index + \'_deletecard\'}}\"><div class=\"viewDetails text-center\"><md-icon \nmd-font-icon=\"icon-replay\" class=\"s100 grey-400-fg\" ng-click=\"vm.undoDeleteCard($event,card_item._id, $index)\">\n</md-icon><div class=\"grey-fg font-size-16 pt-60\" ng-click=\"vm.undoDeleteCard($event,card_item._id, $index)\">\nTap to Undo Delete</div></div></div></div></div>");
$templateCache.put("app/main/quotes/dialogs/set-Reminder/set-reminder.html","<md-dialog id=\"set-reminder\" class=\"popup-sm\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\" flex=\"95\">Set Reminder</div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"5\"><md-icon \nmd-font-icon=\"icon-close\" class=\"fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog(\'SetReminder\')\"></md-icon></div>\n</div><form name=\"reminderChangeFrm\"><md-dialog-content class=\"body\"><div flex=\"100\" layout=\"column\" \nlayout-align=\"center start\" class=\"pt-20\"><date-picker md-input-id=\"\'Set_Reminder\'\" \nis-validate=\"(ctrl.parent.dateValidation || (reminderChangeFrm.Set_Reminder.$touched && reminderChangeFrm.Set_Reminder.$error.valid))\" \nis-editable=\"true\" is-disabled=\"false\" input-required=\"true\" input-name=\"\'Set_Reminder\'\" \ndate-placeholder=\"\'Enter date\'\" date-format=\"true\" full-border=\"true\" \nmin-date-value=\"ctrl.parent.set_reminder_obj.Start_date\" max-date-value=\"ctrl.parent.set_reminder_obj.End_date\" \nmodel-value=\"ctrl.parent.set_reminder_obj.reminder_date\" \ncallback=\"ctrl.parent.set_reminder_obj.reminder_date=value;ctrl.parent.dateValidation=false;\"></date-picker><div \nng-if=\"ctrl.parent.dateValidation\" class=\"validation-error-text\"><span>Select Reminder Date</span></div><div \nng-messages=\"!ctrl.parent.dateValidation && reminderChangeFrm.Set_Reminder.$touched && reminderChangeFrm.Set_Reminder.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"footer\"><span flex></span><md-button md-no-ink \nclass=\"md-accent-btn ml-10 w-100\" style=\"margin:10px\" \nng-click=\"ctrl.parent.fnSetReminderApi(ctrl.parent.set_reminder_obj.reminder_date,reminderChangeFrm)\">Set Reminder\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/quotes/quotesDetails/create-template/create-template.html","<md-dialog id=\"copy-quote\" class=\"popup-sm create-template\"><div layout=\"row\" class=\"header\" flex=\"100\"><div flex=\"90\" \nflex-xs=\"90\">{{ctrl.parent.quoteTemplateType === \"New\" ? \"Save As Quote Template\" : \"Edit Quote Template Name\" }}</div>\n<div layout=\"row\" layout-align=\"end end\" flex=\"10\"><md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.fnclosePanel();\"></md-icon></div></div><md-dialog-content class=\"body\"><div layout=\"column\" \nlayout-align=\"start start \" class=\"pb-15\"><div layout=\"row\"><div><md-icon \nmd-svg-src=\"assets/icons/custom/Icon metro-insert-template.svg\" class=\"w-20 h-20 filter-icon mr-10\"></md-icon></div>\n<div class=\"w-320\"><div layout=\"row\"><p>Quote Template Name</p><md-icon \nmd-font-icon=\"icon-information-outline info-icon cursor\"><md-tooltip md-direction=\"top\">\nName your quotation template for future reference</md-tooltip></md-icon></div><div><form name=\"templateForm\">\n<md-input-container class=\"panel-select\" \nng-class=\"{\'template-error\': ctrl.parent.templateError || templateForm.templateName.$error[\'md-maxlength\']}\" \nmd-no-float><input ng-keyup=\"vm.templateError = false;\" md-maxlength=\"30\" name=\"templateName\" \nng-change=\"ctrl.parent.templateValueChange=true;\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-model=\"ctrl.parent.templateName\" placeholder=\"Enter the template name\"></md-input-container><div \nng-messages=\"templateForm.templateName.$error\"><div ng-message=\"md-maxlength\">Exceeded maximum length of 30 characters\n</div></div></form><div class=\"validation-error-text\" ng-if=\"ctrl.parent.templateError\"><span>Enter valid template name\n</span></div></div></div></div></div></md-dialog-content><md-dialog-actions><div class=\"white-bg mv-10\" layout=\"row\">\n<md-button md-no-ink class=\"md-primary-btn mr-10\" title=\"Cancel\" ng-click=\"ctrl.parent.fnclosePanel();\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\" \nng-click=\"ctrl.parent.saveQuoteTemplate(ctrl.parent.quoteTemplateType);\" ng-disabled=\"ctrl.parent.yesBtn-Click\">Save\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/quotes/quotesDetails/template-panel/template-panel.html","<div class=\"arrow-up-panel mt-10\"></div><div id=\"saved-template-view-panel\" \nclass=\"margin-positioning font-size-10 p-10 mb-25\"><div class=\"font-size-13 fg-ffffff Font-Bold\"><span>\n{{ ctrl.parent.quote_result.result_data.template_data.name }}</span></div><div class=\"font-size-9 fg-ffffff\" \nng-if=\"ctrl.parent.util.navPermission.quotes && (ctrl.parent.util.navPermission.quotes[2] || ctrl.parent.util.navPermission.quotes[3])\">\nBy using these buttons you can edit / delete the saved templates</div><div layout=\"row\" layout-align=\"end center\" \nclass=\"font-size-13 mt-10\"><div \nng-if=\"ctrl.parent.util.navPermission.quotes && ctrl.parent.util.navPermission.quotes[3]\" \nclass=\"md-link-fg pointer mr-10\" title=\"Cancel\" ng-click=\"ctrl.parent.saveQuoteTemplate(\'Delete\')\">Delete</div><div \nng-if=\"ctrl.parent.util.navPermission.quotes && ctrl.parent.util.navPermission.quotes[2]\" md-ink \nclass=\"md-link-fg pointer ml-10\" type=\"submit\" title=\"CONFIRM\" \nng-click=\"ctrl.parent.fnopenCreateTemplate($event,\'Edit\')\">Edit</div></div></div>");
$templateCache.put("app/main/quotes/sidenav/activity-monitor/activity-monitor.html","<md-list><md-list-item class=\"mb-5 activity_monitor\" layout=\"row\" layout-align=\"start center\" flex><span flex \nclass=\"font-weight-600\"><img src=\"assets/icons/custom/sharing-connections.jpg\" width=\"33\" height=\"33\" class=\"mr-8\" \nng-class=\"{\'mt-8\': !vm.util.isMobileDevice}\">Activity Monitor</span><md-icon md-font-icon=\"icon-close\" \nclass=\"s25 pointer\" ng-click=\"vm.toggleSideNav(\'right\',\'close\')\"></md-icon></md-list-item><md-divider></md-divider>\n</md-list><div class=\"content pt-20\"><md-list ms-scroll><md-list-item layout=\"row\" layout-align=\"start center\" flex>\n<div layout=\"column\" flex=\"100\"><div layout=\"column\" flex=\"100\" \nng-repeat=\"activity in vm.quoteActivity.activity track by $index\"><div layout=\"row\" flex=\"100\"><div \nng-class=\"{\'mt-5\' : $first}\" flex=\"20\" layout=\"column\" layout-align=\"start center\"><span class=\"circle small\"></span> \n<span ng-if=\"!$last\" class=\"line-height-20\"></span> <span ng-if=\"!$last && activity.description\" \nclass=\"line-height-20\"></span> <span ng-if=\"!$last && activity.comment\" class=\"line-height-20\"></span></div><div flex \nlayout=\"column\"><span class=\"font-weight-600 grey-600-fg font-size-16 text-truncate\">{{ activity.message }}<md-tooltip \nmd-direction=\"top\" class=\"font-size-14\">{{ activity.message }}</md-tooltip></span><a class=\"md-link-fg\" \nng-href=\"{{vm.util.sanitizeQueryParams(activity.link.url)}}\" ng-if=\"activity.description && activity.link.url\" \ntarget=\"_blank\" rel=\"noopener\">{{ activity.description }}</a> <span \nclass=\"font-weight-600 grey-600-fg font-size-13 text-truncate\" ng-if=\"activity.description && !activity.link.url\">\n{{ activity.description }} </span><span class=\"font-weight-600 grey-600-fg font-size-13 text-truncate\" \nng-if=\"activity.comment\">{{ activity.comment }} </span><span class=\"font-weight-500 grey-600-fg font-size-12\">\n{{ vm.getTimeStampValue(activity.timestamp) }} ago <span>\n| {{ activity.user_name != \'undefined\' ? activity.user_name : \'-\' }}</span></span></div></div><div layout=\"row\" flex \nng-if=\"!$last\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><span class=\"vertical-line1\"></span></div></div>\n</div></div></md-list-item></md-list></div>");
$templateCache.put("app/main/quotes/sidenav/filter-quote/filter-quote.html","<div id=\"filter-quotes\" layout=\"column\" flex=\"100\"><div class=\"w-100p\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/custom/filter-new.svg\" \nclass=\"w-20 h-20 filter-icon mr-10\"></md-icon><span class=\"font-size-16 Font-Bold fg-AAA8AD\" flex>Filters </span><a \nclass=\"font-size-13 pointer md-link-fg font-weight-600 clear-btn\" ng-click=\"vm.resetFilter()\">Clear All</a><md-icon \nng-if=\"vm.QuotesService.filterParams.deviceName != \'laptop\'\" md-font-icon=\"icon-close-circle-outline\" \nclass=\"s20 pointer ml-5 md-link-fg\" ng-click=\"vm.toggleSideNav(\'quoteRight\')\"></md-icon></div><md-divider></md-divider>\n<div class=\"content\" ms-scroll ng-style=\"vm.maxFilterHeight\"><md-list><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex class=\"p-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between\" flex class=\"pointer\" \nng-click=\"vm.collapseIt(\'quotes_status\',$event); quotes_status=!quotes_status; searchStatus=\'\'\"><div><span \nclass=\"font-size-14 font-weight-600\">Status</span> <span ng-if=\"vm.quoteListData.length\" \nclass=\"filter-count md-component-bg white-fg\">1</span></div><div><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon-arrow s20\" ng-class=\"{\'chevron-rotate\': quotes_status}\"></md-icon></div></div><div \nclass=\"hide-at-start dropdown-container mt-10\" id=\"quotes_status\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-20 searchbox-outline\"><input \nclass=\"font-size-12 font-primary-fg input-search\" ng-model=\"searchStatus\" type=\"search\" placeholder=\"Search status\" \nng-keydown=\"$event.stopPropagation()\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nclass=\"text-truncate status-label\" ng-repeat=\"status in vm.quoteListData | filter : {\'status\':searchStatus} \">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary radio-checkbox\" flex \nng-checked=\"vm.filterItemExists(status, vm.filterStatusModel, \'radio\')\" \nng-click=\"vm.filterItemtoggle(status, vm.filterStatusModel, \'radio\');\" \nng-if=\"!(status.status.toLowerCase() === \'approval pending\' || status.status.toLowerCase() === \'revision required\')\">\n{{status.status}}<md-tooltip md-direction=\"right\" md-delay=\"300\">{{status.status}}</md-tooltip><span ng-if=\"status\" \nclass=\"filter-count-grey grey-bg white-fg\">{{status.count}}</span></md-checkbox></div></div></div></md-list-item>\n<md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex \nclass=\"p-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex class=\"pointer\" \nng-click=\"vm.collapseIt(\'quotes_mode\',$event); quotes_mode=!quotes_mode\"><div><span \nclass=\"font-size-14 font-weight-600\">Mode</span> <span ng-if=\"(vm.filterMode | filter:{selected: true }).length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{(vm.filterMode | filter:{selected: true }).length}}</span></div><div>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"icon-arrow s20\" ng-class=\"{\'chevron-rotate\': quotes_mode}\"></md-icon>\n</div></div><div class=\"hide-at-start pt-10\" id=\"quotes_mode\"><div class=\"font-size-14 black-fg\" \nng-repeat=\"filterMode in vm.filterMode\"><md-checkbox md-no-ink ng-model=\"filterMode.selected\" class=\"md-primary\" flex>\n<span ng-bind=\"filterMode.mode\"></span></md-checkbox></div></div></div></md-list-item><md-list-item class=\"no-padding\" \nlayout=\"row\" layout-align=\"start center\" flex ng-if=\"!vm.util.isShipper\"><div layout=\"column\" flex \nclass=\"p-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex class=\"pointer\" \nng-click=\"vm.collapseIt(\'quotes_created_by\',$event); quotes_created_by=!quotes_created_by;searchCreateBy=\'\'; showCreatedBy=false\">\n<div><span class=\"font-size-14 font-weight-600\">Created By</span> <span ng-if=\"vm.created_by.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.created_by.length}}</span></div><div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon-arrow s20\" ng-class=\"{\'chevron-rotate\': quotes_created_by}\"></md-icon>\n</div></div><div class=\"hide-at-start dropdown-container mt-10\" id=\"quotes_created_by\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-20 searchbox-outline\"><input \nclass=\"font-size-12 font-primary-fg input-search\" ng-model=\"searchCreateBy\" type=\"search\" placeholder=\"Search User\" \nng-change=\"vm.getUsersListForFilter(\'FORWARDER\',searchCreateBy);\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-keydown=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\">\n</md-icon></div><div class=\"text-truncate w-200\" ng-hide=\"vm.filterLoader\" \nng-repeat=\"filterCreatedBy in vm.filterCreatedBy | filter : searchCreateBy | limitTo: (showCreatedBy ? vm.filterCreatedBy.length : 3)\">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary\" flex ng-checked=\"vm.filterItemExists(filterCreatedBy, vm.created_by)\" \nng-click=\"vm.filterItemtoggle(filterCreatedBy, vm.created_by);\">\n{{filterCreatedBy.user_first_name}} {{filterCreatedBy.user_last_name}}<md-tooltip md-direction=\"right\" md-delay=\"300\">\n{{filterCreatedBy.user_first_name}} {{filterCreatedBy.user_last_name}}</md-tooltip></md-checkbox></div><div \nlayout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"vm.filterLoader\" class=\"mv-20 pt-10\">\n<md-progress-circular></md-progress-circular></div><md-button md-no-ink class=\"md-link-btn m-0 w-100p\" \nng-click=\"showCreatedBy = !showCreatedBy\" ng-show=\"(vm.filterCreatedBy | filter : searchCreateBy).length > 3\">\n{{showCreatedBy ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"!vm.util.isShipper\"><div layout=\"column\" flex \nclass=\"p-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex class=\"pointer\" \nng-click=\"vm.collapseIt(\'quotes_created_for\',$event); quotes_created_for=!quotes_created_for; searchCreatedFor=\'\'; showCreatedFor=false\">\n<div><span class=\"font-size-14 font-weight-600\">Customer Name </span><span ng-if=\"vm.created_for.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.created_for.length}}</span></div><div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon-arrow s20\" ng-class=\"{\'chevron-rotate\': quotes_created_for}\"></md-icon>\n</div></div><div class=\"hide-at-start dropdown-container mt-10\" id=\"quotes_created_for\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-20 searchbox-outline\"><input ng-model-options=\"{debounce : 1000}\" \nclass=\"font-size-12 font-primary-fg input-search\" ng-model=\"searchCreatedFor\" type=\"search\" placeholder=\"Search User\" \nng-keydown=\"$event.stopPropagation()\" \nng-change=\"vm.getUsersListForFilter(\'SHIPPER\',searchCreatedFor);vm.trackEvent(\'QL-Filter-CreatedFor-Search-Change\',searchCreatedFor)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nclass=\"text-truncate w-200\" ng-hide=\"vm.filterLoader\" \nng-repeat=\"filterCreatedFor in vm.filterCreatedFor | filter : searchCreatedFor | limitTo: (showCreatedFor ? vm.filterCreatedFor.length : 3)\">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary\" flex \nng-checked=\"vm.filterItemExists(filterCreatedFor, vm.created_for)\" \nng-click=\"vm.filterItemtoggle(filterCreatedFor, vm.created_for);vm.trackEvent(\'QL-Filter-CreatedFor-Option-Change\',filterCreatedFor.name)\">\n{{filterCreatedFor.user_first_name}} {{filterCreatedFor.user_last_name}}<md-tooltip md-direction=\"right\" \nmd-delay=\"300\">{{filterCreatedFor.user_first_name}} {{filterCreatedFor.user_last_name}}</md-tooltip></md-checkbox>\n</div><div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"vm.filterLoader\" \nclass=\"mv-20 pt-10\"><md-progress-circular></md-progress-circular></div><md-button md-no-ink \nclass=\"md-link-btn m-0 w-100p\" \nng-click=\"showCreatedFor = !showCreatedFor;vm.trackEvent(\'QL-Filter-CreatedFor-ShowAll-Click\')\" \nng-show=\"(vm.filterCreatedFor | filter : searchCreatedFor).length > 3\">\n{{showCreatedFor ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"!vm.util.isShipper\"><div layout=\"column\" flex \nclass=\"p-15 bb filter-width\"><div layout=\"row\" layout-align=\"space-between\" flex class=\"pointer\" \nng-click=\"vm.collapseIt(\'quotes_shipper_companies\',$event); quotes_shipper_companies=!quotes_shipper_companies; searchCustomerCompany=\'\'; showCustomerCompany=false\">\n<div><span class=\"font-size-14 font-weight-600\">Customer Company </span><span ng-if=\"vm.shipper_companies.length\" \nclass=\"filter-count font-size-10 white-fg ml-5\">{{vm.shipper_companies.length}}</span></div><div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon-arrow s20\" ng-class=\"{\'chevron-rotate\': quotes_shipper_companies}\">\n</md-icon></div></div><div class=\"hide-at-start dropdown-container mt-10\" id=\"quotes_shipper_companies\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"mb-20 searchbox-outline\"><input \nng-model-options=\"{debounce : 500}\" class=\"font-size-12 font-primary-fg input-search\" ng-model=\"searchCustomerCompany\" \ntype=\"search\" placeholder=\"Search Company\" ng-keydown=\"$event.stopPropagation()\" \nng-change=\"vm.getUsersListForFilter(\'SHIPPERCOMPANY\',searchCustomerCompany)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon-search w-15 h-15 fg-AAA8AD\"></md-icon></div><div \nclass=\"text-truncate w-200\" ng-hide=\"vm.filterLoader\" \nng-repeat=\"filterCustomerCompany in vm.filterCustomerCompany | filter : searchCustomerCompany | limitTo: (showCustomerCompany ? filterCustomerCompany.length : 3)\">\n<md-checkbox md-no-ink=\"true\" class=\"md-primary\" \nng-checked=\"vm.filterItemExists(filterCustomerCompany, vm.shipper_companies)\" \nng-click=\"vm.filterItemtoggle(filterCustomerCompany, vm.shipper_companies)\">{{filterCustomerCompany.company_name}}\n<md-tooltip md-direction=\"right\" md-delay=\"300\">{{filterCustomerCompany.company_name}}</md-tooltip></md-checkbox></div>\n<div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" ng-if=\"vm.filterLoader\" class=\"mv-20 pt-10\">\n<md-progress-circular></md-progress-circular></div><md-button md-no-ink class=\"md-link-btn m-0 w-100p\" \nng-click=\"showCustomerCompany = !showCustomerCompany\" \nng-show=\"(vm.filterCustomerCompany | filter : searchCustomerCompany).length > 3\">\n{{showCustomerCompany ? \'- show less\' : \'+ show all\'}}</md-button></div></div></md-list-item></md-list></div></div><div\n layout=\"row\" class=\"p-10 w-100p\" layout=\"column\" layout-align=\"end end\" flex><div layout=\"column\" flex><md-button \nmd-no-ink class=\"md-accent-btn Font-Bold w-98p\" \nng-click=\"vm.filterQuotes(vm.filterMode,vm.created_by,vm.created_for,vm.shipper_companies)\">Apply Filter</md-button>\n</div></div></div>");
$templateCache.put("app/main/result/Dialogs/addtional-information/addtional-information.html","<div layout=\"row\" flex=\"100\" class=\"p-20\" layout-wrap><div \nng-repeat=\"feilds in ctrl.parent.customFeilds track by $index\"><div class=\"ph-10 pv-5\" \nng-if=\"feilds.value && feilds.uiLocation .includes (\'NEWTAB\')\"><div class=\"font-size-13 fg-AAA8AD\">{{feilds.label}}\n</div><div class=\"font-size-12 fg-333333 Font-Bold line-height-12 text-truncate max-width-155\" layout=\"row\">\n{{feilds.value}}</div><md-tooltip md-direction=\"bottom\" class=\"font-size-10 white-fg bg-343434 Font-Bold p-5\" \nstyle=\"display:table;opacity: 1\">{{feilds.value}}</md-tooltip></div></div></div>");
$templateCache.put("app/main/result/Dialogs/delete-charge/delete-charge.html","<md-toast id=\"deleteConfirmToast\"><div class=\"md-toast-text\" layout=\"column\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"center start\" ng-if=\"ctrl.parent.chargeDelete\"><p \nng-if=\"!ctrl.parent.all_pickup_basis_delete && !ctrl.parent.all_delivery_basis_delete && !ctrl.parent.is_delete_l3_leg && !ctrl.parent.airBasisCharges\" \nclass=\"font-size-16 white-fg\" style=\"letter-spacing: normal\">Are you sure want to delete <strong \nng-bind=\"ctrl.parent.deleteChargeLineObj.charge_name\"></strong> charge?</p><p \nng-if=\"ctrl.parent.is_delete_l3_leg && ctrl.parent.currentPage == \'result\'\" class=\"font-size-16 white-fg\">\nDeleting this charge will remove this rate card from quotation.</p><p \nng-if=\"ctrl.parent.is_delete_l3_leg && ctrl.parent.currentPage == \'quote\'\" class=\"font-size-16 white-fg\">\nYou can not delete this charge.</p><div ng-if=\"ctrl.parent.airBasisCharges\"><p \nstyle=\"font-size: 16px;letter-spacing: normal;color: #ffffff\">Deleting <strong \nng-bind=\"ctrl.parent.deleteChargeLineObj.charge_name\"></strong> charge will also delete</p><strong \nstyle=\"font-size: 16px;letter-spacing: normal;color: #e83305\"><ul \nng-repeat=\"(key, value) in ctrl.parent.airBasisLegCharge \"><li \nng-repeat=\"(charge_key, charge_value) in value.charges \"><span \nng-bind=\"value.leg_name + \' - \' + charge_value.charge_name\"></span></li></ul></strong><p \nstyle=\"font-size: 16px;letter-spacing: normal;color: #ffffff\">do you wish to continue ?</p></div><div \nng-if=\"ctrl.parent.all_pickup_basis_delete\"><p style=\"font-size: 16px;letter-spacing: normal;color: #ffffff\">Deleting \n<strong ng-bind=\"ctrl.parent.deleteChargeLineObj.charge_name\"></strong> charge will also delete</p><strong \nstyle=\"font-size: 16px;letter-spacing: normal;color: #e83305\"><ul \nng-repeat=\"(key, value) in ctrl.parent.pickupBasisLegCharge \"><li \nng-repeat=\"(charge_key, charge_value) in value.charges \"><span \nng-bind=\"value.leg_name + \' - \' + charge_value.charge_name\"></span></li></ul></strong><p \nstyle=\"font-size: 16px;letter-spacing: normal;color: #ffffff\">do you wish to continue ?</p></div><div \nng-if=\"ctrl.parent.all_delivery_basis_delete\"><p style=\"font-size: 16px;letter-spacing: normal;color: #ffffff\">\nDeleting <strong ng-bind=\"ctrl.parent.deleteChargeLineObj.charge_name\"></strong> charge will also delete</p><strong \nstyle=\"font-size: 16px;letter-spacing: normal;color: #e83305\"><ul \nng-repeat=\"(key, value) in ctrl.parent.deliveryBasisLegCharge \"><li \nng-repeat=\"(charge_key, charge_value) in value.charges \"><span \nng-bind=\"value.leg_name + \' - \' + charge_value.charge_name\"></span></li></ul></strong><p \nstyle=\"font-size: 16px;letter-spacing: normal;color: #ffffff\">do you wish to continue ?</p></div></div><div \nlayout=\"row\" layout-align=\"center start\" ng-if=\"ctrl.parent.legDelete\"><p \nng-if=\"!ctrl.parent.all_pickup_basis_delete && !ctrl.parent.all_delivery_basis_delete && !ctrl.parent.is_delete_l3_leg\" \nclass=\"font-size-16 white-fg\" style=\"letter-spacing: normal\">Are you sure want to delete <strong \nng-bind=\"ctrl.parent.deleteLegObj.leg_name\"></strong> leg?</p><p \nng-if=\"ctrl.parent.is_delete_l3_leg && ctrl.parent.currentPage == \'result\'\" class=\"font-size-16 white-fg\">\nDeleting this leg will remove this rate card from quotation.</p><p \nng-if=\"ctrl.parent.is_delete_l3_leg && ctrl.parent.currentPage == \'quote\'\" class=\"font-size-16 white-fg\">\nYou can not delete this leg.</p></div><div layout=\"row\" layout-align=\"end center\"><md-button md-no-ink \nng-click=\"ctrl.parent.closeToast()\">Close</md-button><md-button md-no-ink ng-if=\"ctrl.parent.chargeDelete\" \nclass=\"md-highlight yellow-800-fg\" ng-disabled=\"ctrl.parent.deleteChargeBtn\" \nng-click=\"ctrl.parent.fnDeleteNewCharge($event)\">Confirm</md-button><md-button md-no-ink ng-if=\"ctrl.parent.legDelete\" \nclass=\"md-highlight yellow-800-fg\" ng-disabled=\"ctrl.parent.deleteChargeBtn\" \nng-click=\"ctrl.parent.fnDeleteLeg($event)\">Confirm</md-button></div></div></md-toast>");
$templateCache.put("app/main/result/Dialogs/per_wm_info/per_wm_info.html","<div><div ng-if=\"ctrl.globalid == \'l1\'\"><table><tr><td>Gross Weight</td><td>\n{{ctrl.ltldetails.origin.gross_weight | currencyMask: 2}} {{ctrl.ltldetails.origin.gross_weight_unit}}</td></tr><tr>\n<td>Dimensional Weight</td><td>\n{{ctrl.ltldetails.origin.dimensional_weight | currencyMask: 2}} {{ctrl.ltldetails.origin.dimensional_unit}}</td></tr>\n<tr><td>Chargeable Weight</td><td>\n{{ctrl.ltldetails.origin.chargeable_weight | currencyMask: 2}} {{ctrl.ltldetails.origin.chargeable_unit}}</td></tr>\n</table></div><div ng-if=\"ctrl.globalid == \'l5\'\"><table><tr><td>Gross Weight</td><td>\n{{ctrl.ltldetails.destination.gross_weight | currencyMask: 2}} {{ctrl.ltldetails.destination.gross_weight_unit}}</td>\n</tr><tr><td>Dimensional Weight</td><td>\n{{ctrl.ltldetails.destination.dimensional_weight | currencyMask: 2}} {{ctrl.ltldetails.destination.dimensional_unit}}\n</td></tr><tr><td>Chargeable Weight</td><td>\n{{ctrl.ltldetails.destination.chargeable_weight | currencyMask: 2}} {{ctrl.ltldetails.destination.chargeable_unit}}\n</td></tr></table></div></div>");
$templateCache.put("app/main/result/Dialogs/remarks-inclusion-popup/remarks-inclusion-popup.html","<md-content class=\"mb-80\" layout=\"column\" ng-class=\"{\'mb-100\' : $ctrl.util.isMobileDevice}\"><div class=\"mh-20 mb-20\" \nlayout=\"column\" flex=\"100\"><div layout=\"row\" class=\"mt-25 mb-10 headStyle\">Remarks</div><div layout=\"row\"><div \nclass=\"quote-editor\" ng-if=\"$ctrl.quoteEdit\"><ng-ckeditor ng-model=\"$ctrl.currentCard.meta.remarks\" \nng-config=\"$ctrl.termsConditionCkEditorConfig\"></ng-ckeditor></div><span class=\"m-0 ff-lato\" ng-if=\"!$ctrl.quoteEdit\" \ncompile-html=\"!($ctrl.currentCard.meta.remarks) ? \'-\' : $ctrl.currentCard.meta.remarks\"></span></div><div layout=\"row\" \nclass=\"mt-25 mb-15 headStyle\">Inclusions</div><div layout=\"row\" class=\"mb-60\" \nng-class=\"{\'mb-80\' : $ctrl.util.isMobileDevice}\"><div class=\"quote-editor\" ng-if=\"$ctrl.quoteEdit\"><ng-ckeditor \nng-model=\"$ctrl.currentCard.meta.inclusions\" ng-config=\"$ctrl.termsConditionCkEditorConfig\"></ng-ckeditor></div><span \nclass=\"m-0 ff-lato\" ng-if=\"!$ctrl.quoteEdit\" \ncompile-html=\"!($ctrl.currentCard.meta.inclusions) ? \'-\' : $ctrl.currentCard.meta.inclusions\"></span></div></div>\n</md-content>");
$templateCache.put("app/main/result/Dialogs/schedule-component/air-schedule-component.html","<div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" ng-if=\"!$ctrl.getSchedule\"></div><div \nng-if=\"$ctrl.getSchedule\"><md-content class=\"mb-10\" layout=\"column\"><p class=\"card_text_bold ph-20\" \nng-show=\"$ctrl.scheduleList.length\"><span class=\"vendor_name\"><span>\n{{$ctrl.currentCard.data[$ctrl.buyOrSell][$ctrl.l3_leg].rate_obj.airline.air_line_name}} - </span><span>\n{{ ($ctrl.currentSchedule.departure_time | datediff) == 0 ? \'this week \': ($ctrl.currentSchedule.departure_time | datediff) + (($ctrl.currentSchedule.departure_time | datediff) == 1 ? \' week\' : \' weeks\') + \' from now\' }}\n</span></span></p><div layout=\"row\" layout-wrap class=\"ph-20 mb-30\" ng-if=\"$ctrl.scheduleList.length\"><div \nlayout=\"column\" layout-align=\"start start \" flex=\"100\" flex-gt-xs=\"40\" class=\"p-0 scroll\" \nng-style=\"{\'height\': $ctrl.scheduleDivHeight ? $ctrl.scheduleDivHeight - 250 +\'px\' : \'700px\'}\"><div \nclass=\"outer mv-10 mb-50 pointer\" ng-repeat=\"schedule in  $ctrl.scheduleList track by $index\" \nng-click=\"$ctrl.setCurrentSchedule(schedule, $index)\" \nng-class=\"{\'outer_container_air\' : $ctrl.currentSchedule.id == schedule.id}\"><div layout=\"row\" layout-wrap \nlayout-align=\"center center\" class=\"font-size-14 font-weight-600 pt-15 ph-10\">{{schedule.transit_time}} {{schedule.id}}\n</div><div layout=\"row\" layout-wrap class=\"ph-15 pv-10 font-size-12-mob\"><div layout=\"column\" \nlayout-align=\"center start\" flex=\"30\" flex-gt-xs=\"30\"><p class=\"font-size-14 font-weight-600 mv-5\">\n{{schedule.origin_port}}</p><p class=\"font-size-14 m-0\">{{ schedule.departure_time | UTCToLocal : \'d MMM, yyyy\' }}</p>\n</div><div layout=\"column\" layout-align=\"center center\" flex=\"30\" flex-gt-xs=\"30\" class=\"text-center mh-5\"><p \nclass=\"font-size-12 m-0 pt-10\"><span class=\"grey-fg\" ng-hide=\"schedule.schedule_track.length < 3\">via</span><br><span \nclass=\"font-size-12 md-link-fg\">{{schedule.via_port}}</span></p></div><div layout=\"column\" layout-align=\" center end\" \nflex=\"30\" flex-gt-xs=\"30\"><p class=\"font-size-14 font-weight-600 mv-5\">{{schedule.destination_port}}</p><p \nclass=\"font-size-14 m-0 text-right\">{{ schedule.arrival_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div></div></div>\n</div><div layout=\"column\" flex=\"100\" flex-gt-xs=\"60\"><div class=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" ng-if=\"$ctrl.currentSchedule.schedule_track.length > 0\"><div \nlayout=\"column\" class=\"ph-15\" ng-repeat=\"schedule_track in $ctrl.currentSchedule.schedule_track track by $index\"><div \nlayout=\"row\" class=\"show_schedule\" ng-class=\"{\'pt-5\' : $first}\" ng-if=\"$first || $last\"><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\" ng-if=\"!$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\" ng-if=\"$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" ng-if=\"!$last\" \nmd-svg-src=\"assets/icons/custom/search-bar/air_pod.svg\"></md-icon><md-icon class=\"icon-class\" ng-if=\"$last\" \nmd-svg-src=\"assets/icons/custom/search-bar/air_pol.svg\"></md-icon></span><span>{{ schedule_track.port_name }}</span>\n</p><div layout=\"column\" class=\"pb-20\" ng-if=\"!$last\"><div layout=\"row\"><div class=\"track_text\" flex>Flight Number\n</div><div class=\"track_text eta_div\" flex>{{schedule_track.flight_number != \"\" ? schedule_track.flight_number : \'NA\'}}\n</div></div><div layout=\"row\" ng-repeat=\"info in schedule_track.additional_info\"><div class=\"track_text\" flex>\n{{info.name}}</div><div class=\"track_text eta_div\" flex compile-html=\"info.value\">{{info.value}}</div></div></div>\n</div></div><div layout=\"row\" ng-if=\"(!$first && !$last)\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class icon-rotate\" \nmd-svg-src=\"assets/icons/custom/roll-o-plane.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} \n</span><span>(Arrival)</span></p></div></div><div layout=\"row\" ng-if=\"(!$first && !$last)\"><div flex-md=\"20\" \nflex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class icon-rotate\" \nmd-svg-src=\"assets/icons/custom/roll-o-plane.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} \n</span><span>(Departure)</span></p><div layout=\"column\" class=\"pb-20\" ng-if=\"!$last\"><div layout=\"row\"><div \nclass=\"track_text\" flex>Flight Number</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.flight_number != \"\" ? schedule_track.flight_number : \'NA\'}}</div></div><div layout=\"row\" \nng-repeat=\"info in schedule_track.additional_info\"><div class=\"track_text\" flex>{{info.name}}</div><div \nclass=\"track_text eta_div\" flex compile-html=\"info.value\"></div></div></div></div></div></div></div><div \nclass=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552 grey-100-bg grey-600-fg\" layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" ng-if=\"!$ctrl.currentSchedule.schedule_track\"><div>\nNo schedule has been selected.</div><div>Please select the schedule from the list.</div></div><div layout=\"column\" \nflex=\"100\" hide><md-button md-no-ink class=\"md-primary-btn\" title=\"Done\" \nng-click=\"$ctrl.selectedSchedule($ctrl.currentSchedule);$ctrl.fnTrackAnalytics(\'RateCard-Schedules-add-Click\')\" \nng-disabled=\"$ctrl.disableScheduleBtn\">Add Schedule Track</md-button></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"ph-20\" ng-if=\"!$ctrl.scheduleList.length\"><h2>\nSorry, No schedules available.</h2></div></md-content></div>");
$templateCache.put("app/main/result/Dialogs/schedule-component/schedule-component.html","<div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" ng-if=\"!$ctrl.getSchedule\"></div><div \nng-if=\"$ctrl.getSchedule\"><md-content class=\"mb-10\" layout=\"column\"><p class=\"card_text_bold ph-20\" \nng-show=\"$ctrl.scheduleList.length\"><span class=\"vendor_name\"><span ng-show=\"!$ctrl.maskLiner\">\n{{$ctrl.currentCard.data.sell_rates[$ctrl.l3_leg].rate_obj.sub_vendor.sub_vendor_name}} - </span><span \nng-show=\"$ctrl.maskLiner\">Liner - </span></span><span>\n{{ ($ctrl.currentSchedule.departure_time | datediff) == 0 ? \'this week \': ($ctrl.currentSchedule.departure_time | datediff) + (($ctrl.currentSchedule.departure_time | datediff) == 1 ? \' week\' : \' weeks\') + \' from now\' }} \n</span><span class=\"clear-all ml-30\" ng-if=\"!$ctrl.util.isShipper\" ng-click=\"$ctrl.fnClearAllSchedule()\">Clear All\n</span></p><div layout=\"row\" layout-wrap class=\"ph-20 mb-30\" ng-if=\"$ctrl.scheduleList.length\"><div layout=\"column\" \nlayout-align=\"start start \" flex=\"100\" flex-gt-xs=\"40\" class=\"p-0 scroll\" \nng-style=\"{\'height\': $ctrl.scheduleDivHeight ? $ctrl.scheduleDivHeight - 250 +\'px\' : \'700px\'}\"><div \nng-repeat=\"schedule in  $ctrl.scheduleList track by $index\" class=\"width-96-per\" layout=\"row\"><div \nng-if=\"!$ctrl.util.isShipper\" class=\"mt-10 mr-15 mb-50\" layout=\"column\" layout-align=\"center center \"><input \ntype=\"checkbox\" ng-model=\"schedule.isSelected\" ng-click=\"$ctrl.selectMultiSchedule(schedule)\" class=\"s18\"></div><div \nclass=\"outer mv-10 mb-50 pointer\" ng-click=\"$ctrl.setCurrentSchedule(schedule, $index)\" \nng-class=\"{\'outer_container single-select-bg\' : $ctrl.currentSchedule.id == schedule.id , \'multi-select-bg\': schedule.isSelected}\">\n<div layout=\"row pt-15\"><div layout=\"row\" layout-wrap layout-align=\"center center\" flex=\"90\" \nclass=\"font-size-14 font-weight-600 pt-15 ph-10\">{{schedule.transit_time}} <span ng-if=\"!$ctrl.maskLiner\">\n-{{schedule.service_name}}</span></div><div ng-if=\"$ctrl.currentSchedule.id == schedule.id\" layout=\"row\" layout-wrap \nlayout-align=\"end end\" class=\"mh-5\"><md-icon md-font-icon=\"icon-check\"></md-icon></div></div><div layout=\"row\" \nlayout-wrap class=\"ph-15 pv-10 font-size-12-mob\"><div layout=\"column\" layout-align=\"center start\" flex=\"30\" \nflex-gt-xs=\"30\"><p class=\"font-size-14 font-weight-600 mv-5\">{{schedule.origin_port}}</p><p class=\"font-size-14 m-0\">\n{{ schedule.departure_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div><div layout=\"column\" layout-align=\"center center\" \nflex=\"30\" flex-gt-xs=\"30\" class=\"text-center mh-5\"><p class=\"font-size-12 m-0 pt-10\"><span class=\"grey-fg\" \nng-hide=\"schedule.schedule_track.length < 3\">via</span><br><span class=\"font-size-12 md-link-fg\">{{schedule.via_port}}\n</span></p></div><div layout=\"column\" layout-align=\" center end\" flex=\"30\" flex-gt-xs=\"30\"><p \nclass=\"font-size-14 font-weight-600 mv-5\">{{schedule.destination_port}}</p><p class=\"font-size-14 m-0 text-right\">\n{{ schedule.arrival_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div></div></div></div></div><div layout=\"column\" \nflex=\"100\" flex-gt-xs=\"60\"><div class=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"60\" ng-if=\"$ctrl.currentSchedule.schedule_track.length > 0\"><div layout=\"column\" class=\"ph-15\" \nng-repeat=\"schedule_track in $ctrl.currentSchedule.schedule_track track by $index\"><div layout=\"row\" \nclass=\"show_schedule\" ng-class=\"{\'pt-5\' : $first}\" ng-if=\"$first || $last\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80 schedule_track_margin\" ng-if=\"!$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\" ng-if=\"$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" \nmd-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }}</span>\n</p><div layout=\"column\" class=\"pb-20\" ng-if=\"!$last && !$ctrl.maskLiner\"><div layout=\"row\"><div class=\"track_text\" \nflex>Service</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.service_name != \"\" ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vessel != \"\" ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" \nflex>Voyage Ref.</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.voyage != \"\" ? schedule_track.voyage : \'NA\'}}</div></div></div></div></div><div layout=\"row\" \nng-if=\"(!$first && !$last)\" class=\"mv-20\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" \nmd-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} </span>\n<span>(Arrival)</span></p></div></div><div layout=\"row\" ng-if=\"(!$first && !$last)\"><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" \nmd-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} </span>\n<span>(Departure)</span></p><div layout=\"column\" class=\"pb-20\" ng-if=\"!$last && !$ctrl.maskLiner\"><div layout=\"row\">\n<div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.service_name != \"\" ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vessel != \"\" ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" \nflex>Voyage Ref.</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.voyage != \"\" ? schedule_track.voyage : \'NA\'}}</div></div></div></div></div></div></div><div \nclass=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552 grey-100-bg grey-600-fg\" layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" \nng-if=\"!$ctrl.currentSchedule.schedule_track &&  !$ctrl.multi_schedule_list.length\"><div>No schedule has been selected.\n</div><div>Please select the schedule from the list.</div></div><div \nclass=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552 grey-100-bg grey-600-fg\" layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" \nng-if=\"!$ctrl.currentSchedule.schedule_track && $ctrl.multi_schedule_list.length\"><div class=\"errorMsg\">\nPlease select one schedule from the selected list to proceed further.</div><div layout=\"column\" flex=\"100\" hide>\n<md-button md-no-ink class=\"md-primary-btn\" title=\"Done\" \nng-click=\"$ctrl.selectedSchedule($ctrl.currentSchedule);$ctrl.fnTrackAnalytics(\'RateCard-Schedules-add-Click\')\" \nng-disabled=\"$ctrl.disableScheduleBtn\">Add Schedule Track</md-button></div></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"ph-20\" \nng-if=\"!$ctrl.validationErrorArray.length && !$ctrl.scheduleList.length\"><h2>Sorry, No schedules available.</h2></div>\n<div layout=\"row\" layout-align=\"center center\" layout-wrap class=\"p-20 font-size-16 fg-333333\" \nng-if=\"$ctrl.validationErrorArray.length && !$ctrl.scheduleList.length\">Please Enter &nbsp; <span \nng-repeat=\"name in $ctrl.validationErrorArray track by $index\">{{name}}<span ng-if=\"!$last\">,&nbsp;</span> </span>\n&nbsp; to fetch schedule.</div></md-content></div>");
$templateCache.put("app/main/result/Dialogs/share-quotation/download-quotation.html","<md-dialog id=\"share-quotation\"><md-toolbar id=\"share_quotation_Toolbar\" class=\"border-bottom\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"30\"><div layout=\"row\" layout-align=\"end end\" flex=\"20\"><md-icon \nmd-font-icon=\"icon-close\" class=\"mr-5 s16 pointer\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div>\n</md-toolbar><div><div layout=\"column\" flex=\"100\" layout-align=\"center center\" class=\"quotation_div m-40\"><md-icon \nclass=\"tick_mark\" md-font-icon=\"icon-checkbox-marked-circle\"></md-icon><div \nclass=\"font-weight-600 gray_sentance grey-500-fg mt-35\">Quotation Sent successfully</div><div \nclass=\"font-weight-600 font-size-16 mt-15\">You can download the quotation PDFs by clicking below</div><md-button \nmd-no-ink class=\"md-accent-btn mt-40\" title=\"Send Quotation\" ng-click=\"\">Send Quotation</md-button></div></div>\n</md-dialog>");
$templateCache.put("app/main/result/Dialogs/terms-popup/terms-popup.html","<div id=\"terms-popup\"><md-content layout=\"column\" class=\"mh-20 mv-30\"><div><div \nclass=\"font-size-14 font-weight-600 mb-20\">Terms & Conditions</div><div shimmer-effect width=\"100%\" height=\"100%\" \nclass=\"white-bg\" ng-if=\"ctrl.parent.termsShimmer\"></div><div class=\"border brad-10 pv-20 ph-30 tnc_div font-size-16\" \nng-if=\"!ctrl.parent.termsShimmer && ctrl.parent.termsData\"><div id=\"terms\" class=\"pt-10 pl-30 grey-fg m-0 ff-lato\" \ncompile-html=\"ctrl.parent.termsData\"></div></div><div flex=\"100\" class=\"text-center Font-Bold\" \nlayout-align=\"center center\" ng-if=\"!ctrl.parent.termsShimmer && !ctrl.parent.termsData\">\nSorry, Terms and Conditions are not available.</div></div><div class=\"mt-30\" \nng-if=\"ctrl.parent.search_param.mode == \'SEA-LCL\' && ctrl.parent.pageSource === \'Instant-ViewDetails\'\"><div \nclass=\"font-size-14 font-weight-600 mb-20\">Standard Terms & Conditions</div><div shimmer-effect width=\"100%\" \nheight=\"100%\" class=\"white-bg\" ng-if=\"ctrl.parent.termsShimmer\"></div><div \nclass=\"border brad-10 pv-20 ph-30 tnc_div font-size-16\" \nng-if=\"!ctrl.parent.termsShimmer && ctrl.parent.stdTermsAndConditions\"><div id=\"std-terms\" \nclass=\"pt-10 pl-30 grey-fg m-0 ff-lato\" compile-html=\"ctrl.parent.stdTermsAndConditions\"></div></div><div flex=\"100\" \nclass=\"text-center Font-Bold\" layout-align=\"center center\" \nng-if=\"!ctrl.parent.termsShimmer && !ctrl.parent.stdTermsAndConditions\">\nSorry, Standard Terms and Conditions are not available.</div></div></md-content></div>");
$templateCache.put("app/main/result/Dialogs/vas-charge/vas-charges-modal.html","<md-toolbar class=\"white-bg bb toolbar\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title font-size-16 md-primary-fg\"><b>VAS Charges</b></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"$ctrl.closeDialog()\"><md-icon md-font-icon=\"icon-close-circle-outline\" aria-label=\"Close dialog\" \nclass=\"grey-400-fg\"></md-icon></md-button></div></md-toolbar><md-tabs md-dynamic-height flex class=\"mh-20 mb-20 mt-60\">\n<md-tab ng-repeat=\"(sell_key, sell_value) in $ctrl.legList.sell_rates track by $index\"><md-tab-label><span>\nAdditional Services</span></md-tab-label><md-tab-body flex clas><div layout=\"row\" layout-align=\"space-between\" \nclass=\"mv-20\"><div class=\"black-fg font-size-16 font-weight-600\">{{ sell_value.leg_name }}</div><div \nclass=\"black-fg font-size-16 font-weight-600\">\nTOTAL - {{sell_value.rate_obj.leg_currency}} {{(sell_value.rate_obj.leg_currency_cost| currencyMask: 2)}} <span \nclass=\"font-size-10\" ng-if=\"$ctrl.isStringPresent(sell_value.rate_obj.charges)\">(inclusive of fixed charges only)\n</span></div></div><div ng-if=\"$ctrl.vasdetails.search_param.mode==\'SEA-FCL\'\"><div \nclass=\"tableFixHead vas-table-container mt-5\"><table id=\"tableFcl\" class=\"vas-table\" cellspacing=\"0\" cellpadding=\"0\" \nwidth=\"100%\" align=\"center\"><thead><tr><th class=\"fix-head w-250\" rowspan=\"2\">Charges</th><th class=\"fix-head w-150\" \nrowspan=\"2\">Type</th><th class=\"fix-head w-100\" rowspan=\"2\">Basis</th><th class=\"fix-head w-150\" rowspan=\"2\">\nEquipment Type</th><th class=\"fix-head w-100\" rowspan=\"2\">Qty</th><th class=\"fix-head w-150\" \nng-class=\"{\'w-450\' : $ctrl.editMode}\" colspan=\"{{$ctrl.editMode ? \'2\' : \'1\'}}\">Unit Price</th><th \nclass=\"fix-head w-150\" rowspan=\"2\">Amount</th><th rowspan=\"2\" class=\"fix-head w-150\">Action</th></tr><tr><th \nclass=\"br fix-head fix-head-2\" ng-if=\"$ctrl.editMode\">Buy Price</th><th class=\"br fix-head fix-head-2\" \nng-if=\"$ctrl.editMode\">Sell Price</th></tr></thead><tbody align=\"center\"><tr \nng-if=\"!sell_value.rate_obj.charges.length\" class=\"font-size-12\"><td colspan=\"10\" class=\"pv-30 pb-10\"><span \nclass=\"grey-fg font-weight-600\">No Charges Added Yet</span><br><div layout=\"row\" \nclass=\"black-fg font-weight-600 font-size-12\" layout-align=\"center center\"><span>Click on</span> <button \nclass=\"vas_add_info_icon md-fab md-primary-fg md-hue-3 fab_delete_btn w-20 h-20 md-button md-default-theme p-0 button-close\" \ntype=\"button\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary-fg s14 brad-15 md-default-theme\" role=\"img\" \naria-label=\"icon-delete\"></md-icon></button> <span>to Add Charge(s)</span></div></td></tr><tr \nng-repeat-start=\"(key, charge) in sell_value.rate_obj.charges track by charge._id\"><td class=\"vas-table-cell\" \nrowspan=\"{{charge.slab.length}}\">{{charge.charge_name}}</td><td class=\"vas-table-cell\" \nrowspan=\"{{charge.slab.length}}\"><span ng-repeat=\"leg in charge.leg track by $index\">{{leg.name}} <span ng-if=\"!$last\">\n,</span></span></td><td class=\"vas-table-cell\" rowspan=\"{{charge.slab.length}}\"><md-input-container md-no-float \nclass=\"inline-flex m-0 p-0\" ng-if=\"$ctrl.editMode\"><md-select ng-model=\"charge.charge_basis\" \nplaceholder=\"Select Basis\" \nng-change=\"$ctrl.fnChangeBasis(charge, sell_value, $index, $ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index],$ctrl.legList.buy_rates[sell_key])\" \nid=\"{{sell_key +\'_\'+ $index+\'_bais\'}}\"><md-option ng-value=\"basis\" \nng-repeat=\"basis in $ctrl.view_basis track by $index\">{{basis}}</md-option></md-select></md-input-container><span \nng-if=\"!$ctrl.editMode\">{{charge.charge_basis}}</span></td><td class=\"vas-table-cell\" rowspan=\"{{charge.slab.length}}\">\n<md-input-container md-no-float class=\"inline-flex m-0 p-0\" \nng-if=\"$ctrl.editMode && (charge.charge_basis==\'per equipment\')\"><md-select ng-model=\"charge.container_type\" \nplaceholder=\"Select Equipment\" \nng-change=\"$ctrl.fnChangeBasis(charge, sell_value, $index, $ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index],$ctrl.legList.buy_rates[sell_key])\">\n<md-option ng-value=\"load.type\" \nng-repeat=\"load in\n                                                $ctrl.vasdetails.search_param.load_data.load_details_value track by\n                                                $index\">\n{{load.type}}</md-option></md-select></md-input-container><span \nng-if=\"!$ctrl.editMode && charge.charge_basis==\'per equipment\'\">{{charge.container_type}}</span> <span \nng-if=\"charge.charge_basis!==\'per equipment\'\">N/A</span></td><td class=\"vas-table-cell\"><span>\n{{charge.total_units == \'\' ? \'-\' : charge.total_units | currencyMask : 2 }}</span></td><td class=\"br vas-table-cell\" \nng-if=\"$ctrl.editMode\"><md-input-container md-no-float class=\"inline-flex bb font-size-12 mv-0\"><select \nng-model=\"$ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index].charge_currency\" \nng-if=\"$ctrl.isNumber($ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate)\" \nplaceholder=\"Select Currency\" class=\"font-size-12 custom_select m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.legList.buy_rates[sell_key].rate_obj, $index)\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><input \nng-model=\"$ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate\" \nng-model-options=\"{\n                                                updateOn: \'default blur\',\n                                                debounce: {\n                                                    \'default\': 300,\n                                                    \'blur\': 0\n                                                }\n                                            }\" \nplaceholder=\"Unit Price\" id=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\" class=\"m-0 select_box b-none\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.legList.buy_rates[sell_key].rate_obj, $index)\" \ntype=\"text\" list=\"Buy_UP_list\" autocomplete=\"off\"><datalist id=\"Buy_UP_list\"><option>AT ACTUALS</option><option>\nGeneral Schedule</option><option>Special Schedule</option></datalist></md-input-container></td><td \nclass=\"vas-table-cell\" ng-if=\"$ctrl.editMode\"><md-input-container md-no-float class=\"inline-flex bb font-size-12 mv-0\">\n<select ng-model=\"charge.charge_currency\" placeholder=\"Select Currency\" \nclass=\"font-size-12 custom_select m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index)\" \nng-if=\"$ctrl.isNumber(charge.per_unit_rate)\" ng-options=\"curr for curr in $ctrl.currencyList\"></select><input \ntype=\"text\" placeholder=\"Unit Price\" ng-model=\"charge.per_unit_rate\" id=\"{{sell_key +\'_\'+ $index+\'_unit\'}}\" \nclass=\"m-0 select_box b-none\" \nng-model-options=\"{\n                                                    updateOn: \'default blur\',\n                                                    debounce: {\n                                                        \'default\': 300,\n                                                        \'blur\': 0\n                                                    }\n                                                }\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index)\" list=\"sell_UP_list\" autocomplete=\"off\">\n<datalist id=\"sell_UP_list\"><option>AT ACTUALS</option><option>General Schedule</option><option>Special Schedule\n</option></datalist></md-input-container></td><td class=\"vas-table-cell\" ng-if=\"!$ctrl.editMode\"><span><span \nng-if=\"$ctrl.isNumber(charge.per_unit_rate)\">{{charge.charge_currency}} </span>{{charge.per_unit_rate}}</span></td><td \nclass=\"vas-table-cell\"><span class=\"opacity pr-5\" \nng-if=\"$ctrl.isNumber(charge.charge_cost) || charge.min_flag || charge.max_flag\">{{sell_value.rate_obj.leg_currency}} \n</span><span class=\"black-fg\">{{$ctrl.fnCheckIsNaN(charge) }}</span></td><td class=\"vas-table-cell\" \nrowspan=\"{{charge.slab.length}}\"><button \nclass=\"md-fab red-50-bg fab_delete_btn w-24 h-24 md-button md-default-theme p-0 button-close\" type=\"button\" \nng-click=\"$ctrl.deleteAdditionalCharge(sell_key,sell_value.rate_obj,charge,$index)\"><md-icon md-font-icon=\"icon-close\" \nclass=\"red-500-fg s16 brad-15 md-default-theme\" role=\"img\" aria-label=\"icon-delete\"></md-icon></button></td></tr><tr \nng-repeat-end=\"value in charge.slab\" hide><td class=\"vas-table-cell\">{{value.from}} : {{value.to}}</td><td \nclass=\"vas-table-cell\" ng-if=\"$ctrl.editMode\"><md-input-container md-no-float class=\"inline-flex bb font-size-12 mv-0\">\n<select ng-model=\"charge.charge_currency\" placeholder=\"Select Currency\" \nclass=\"font-size-12 custom_select m-0 select_currency select_box selectpicker\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><input type=\"text\" placeholder=\"At Actuals\" name=\"\" \nclass=\"m-0 select_box b-none text-transform-u\"></md-input-container></td><td class=\"vas-table-cell\" \nng-if=\"!$ctrl.editMode\"><span>USD 456</span></td><td class=\"vas-table-cell\" ng-if=\"$ctrl.editMode\"><md-input-container \nmd-no-float class=\"inline-flex bb font-size-12 mv-0\"><select ng-model=\"charge.charge_currency\" \nplaceholder=\"Select Currency\" class=\"font-size-12 custom_select m-0 select_currency select_box selectpicker\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><input type=\"text\" placeholder=\"At Actuals\" name=\"\" \nclass=\"m-0 select_box b-none text-transform-u\"></md-input-container></td><td class=\"vas-table-cell\" \nng-if=\"!$ctrl.editMode\"><span>USD 456</span></td><td class=\"vas-table-cell\">USD 671</td></tr></tbody></table></div>\n</div><div ng-if=\"$ctrl.vasdetails.search_param.mode!==\'SEA-FCL\'\"><div class=\"tableFixHead vas-table-container mt-5\">\n<table id=\"tableFcl\" class=\"vas-table\" cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" align=\"center\"><thead><tr><th \nclass=\"fix-head w-250\" rowspan=\"2\">Charges</th><th class=\"fix-head w-150\" rowspan=\"2\">Type</th><th \nclass=\"fix-head w-100\" rowspan=\"2\">Basis</th><th class=\"fix-head w-100\" rowspan=\"2\">Quantity</th><th \nclass=\"fix-head w-150\" ng-class=\"{\'w-450\' : $ctrl.editMode}\" colspan=\"{{$ctrl.editMode ? \'3\' : \'1\'}}\">Unit Price</th>\n<th class=\"fix-head w-150\" rowspan=\"2\" ng-if=\"!$ctrl.editMode\">Minimum</th><th class=\"fix-head w-150\" rowspan=\"2\">\nAmount</th><th rowspan=\"2\" class=\"fix-head w-150\">Action</th></tr><tr><th class=\"br fix-head fix-head-2\" \nng-if=\"$ctrl.editMode\">Buy Price</th><th class=\"br fix-head fix-head-2\" ng-if=\"$ctrl.editMode\">Sell Price</th><th \nclass=\"br fix-head fix-head-2\" ng-if=\"$ctrl.editMode\">Minimum</th><div></div></tr></thead><tbody align=\"center\"><tr \nng-if=\"!sell_value.rate_obj.charges.length\" class=\"font-size-12\"><td colspan=\"10\" class=\"pv-30 pb-10\"><span \nclass=\"grey-fg font-weight-600\">No Charges Added Yet</span><br><div layout=\"row\" \nclass=\"black-fg font-weight-600 font-size-12\" layout-align=\"center center\"><span>Click on</span> <button \nclass=\"vas_add_info_icon md-fab md-primary-fg md-hue-3 fab_delete_btn w-20 h-20 md-button md-default-theme p-0 button-close\" \ntype=\"button\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary-fg s14 brad-15 md-default-theme\" role=\"img\" \naria-label=\"icon-delete\"></md-icon></button> <span>to Add Charge(s)</span></div></td></tr><tr \nng-repeat=\"(key, charge) in sell_value.rate_obj.charges  track by charge._id\"><td class=\"vas-table-cell\">\n{{charge.charge_name}}</td><td class=\"vas-table-cell\"><span ng-repeat=\"leg in charge.leg track by $index\">{{leg.name}} \n<span ng-if=\"!$last\">,</span></span></td><td class=\"vas-table-cell\"><md-input-container md-no-float \nclass=\"inline-flex bb font-size-12\" ng-if=\"$ctrl.editMode\"><select class=\"custom_select\" \nng-model=\"charge.charge_basis\" placeholder=\"Basis\" class=\"m-0 select_currency rate_select_box\" \nng-change=\"$ctrl.fnGetContainerQty(sell_value.rate_obj, charge, \'quote\', $index, $ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.legList.buy_rates[sell_key].rate_obj )\" \nng-options=\"basis for basis in $ctrl.view_basis\"></select></md-input-container><span ng-if=\"!$ctrl.editMode\">\n{{charge.charge_basis ? charge.charge_basis : \'N/A\'}}</span></td><td class=\"vas-table-cell\"><span>\n{{charge.total_units == \'\' ? \'-\' : charge.total_units | currencyMask : 2 }}</span></td><td class=\"br vas-table-cell\" \nng-if=\"$ctrl.editMode\"><md-input-container md-no-float class=\"inline-flex bb font-size-12 mv-0\"><select \nng-model=\"$ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index].charge_currency\" placeholder=\"Select Currency\" \nng-if=\"charge.charge_basis != $ctrl.constObj.AIR_FREIGHT_BASIS\" \nclass=\"font-size-12 custom_select m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.legList.buy_rates[sell_key].rate_obj, $index)\" \nng-if=\"$ctrl.isNumber($ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate)\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select><span \nng-if=\"charge.charge_basis == $ctrl.constObj.AIR_FREIGHT_BASIS\">% </span><input \nid=\"{{sell_key +\'_\'+ $index+\'_buyUnit\'}}\" \nng-model=\"$ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index].per_unit_rate\" \nng-model-options=\"{ debounce: 100 }\" placeholder=\"Unit Price\" class=\"m-0 select_box b-none\" \nng-change=\"$ctrl.conversionOnPriceChange($ctrl.legList.buy_rates[sell_key].rate_obj.charges[$index], $ctrl.legList.buy_rates[sell_key].rate_obj, $index)\" \nlist=\"Buy_UP_list\" autocomplete=\"off\"><datalist id=\"Buy_UP_list\"><option>AT ACTUALS</option><option>General Schedule\n</option><option>Special Schedule</option></datalist></md-input-container></td><td class=\"vas-table-cell\">\n<md-input-container md-no-float class=\"inline-flex bb font-size-12 mv-0\" ng-if=\"$ctrl.editMode\"><select \nng-model=\"charge.charge_currency\" placeholder=\"Select Currency\" \nng-if=\"charge.charge_basis != $ctrl.constObj.AIR_FREIGHT_BASIS\" \nclass=\"font-size-12 custom_select m-0 select_currency select_box selectpicker\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index)\" \nng-if=\"$ctrl.isNumber(charge.per_unit_rate)\" ng-options=\"curr for curr in $ctrl.currencyList\"></select><span \nng-if=\"charge.charge_basis == $ctrl.constObj.AIR_FREIGHT_BASIS\">% </span><input type=\"text\" placeholder=\"Unit Price\" \nng-model=\"charge.per_unit_rate\" \nng-model-options=\"{\n                                                updateOn: \'default blur\',\n                                                debounce: {\n                                                    \'default\': 300,\n                                                    \'blur\': 0\n                                                }\n                                            }\" \nid=\"{{sell_key +\'_\'+ $index+\'_unit\'}}\" class=\"m-0 select_box b-none text-transform-u\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj, $index)\" list=\"Sell_UP_list\" autocomplete=\"off\">\n<datalist id=\"Sell_UP_list\"><option>AT ACTUALS</option><option>General Schedule</option><option>Special Schedule\n</option></datalist></md-input-container><span ng-if=\"!$ctrl.editMode\"><span class=\"opacity pr-5 font-size-12\">\n{{ charge.charge_basis == $ctrl.constObj.AIR_FREIGHT_BASIS ? \'%\' : charge.charge_currency}}</span> <span \nclass=\"font-size-12\">{{charge.per_unit_rate}}</span></span></td><td class=\"br vas-table-cell\"><md-input-container \nmd-no-float class=\"inline-flex font-size-12 m-0 p-0\" ng-if=\"$ctrl.editMode\"><input \nng-model=\"charge.minimum_charge_cost\" placeholder=\"Minimum Amount\" name=\"min_amount\" \nid=\"{{sell_key +\'_\'+ $index+\'_min_unit\'}}\" class=\"m-0 select_box\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, sell_value.rate_obj,$index)\" list=\"minimum_price\" autocomplete=\"off\">\n<datalist id=\"minimum_price\"><option>AT ACTUALS</option><option>General Schedule</option><option>Special Schedule\n</option></datalist></md-input-container><span ng-if=\"!$ctrl.editMode\">{{charge.minimum_charge_cost}}</span></td><td \nclass=\"vas-table-cell\"><span class=\"opacity pr-5\" \nng-if=\"$ctrl.isNumber(charge.charge_cost) || charge.min_flag || charge.max_flag\">{{sell_value.rate_obj.leg_currency}}\n</span> <span>{{ $ctrl.fnCheckIsNaN(charge) }} <sup class=\"green-fg\" ng-if=\"charge.min_flag\">*<md-tooltip \nmd-direction=\"top\" class=\"font-size-10\">Minimum amount</md-tooltip></sup></span><span></span></td><td \nclass=\"vas-table-cell\"><button \nclass=\"md-fab red-50-bg fab_delete_btn w-24 h-24 md-button md-default-theme p-0 button-close\" type=\"button\" \nng-click=\"$ctrl.deleteAdditionalCharge(sell_key,sell_value.rate_obj,charge,$index)\"><md-icon md-font-icon=\"icon-close\" \nclass=\"red-500-fg s16 brad-15 md-default-theme\" role=\"img\" aria-label=\"icon-delete\"></md-icon></button></td></tr>\n</tbody></table></div></div><div layout=\"row\" layout-align=\"end end\" ng-if=\"sell_value.rate_obj.charges.length\"><div \nclass=\"font-size-12 pt-5\">*Add <b>Basis & Price</b> in Not Applicable and Special Charges</div></div><div \nclass=\"value_added_charge\" ng-if=\"!$ctrl.loading\"><div layout=\"row\" layout-align=\"space-between\" class=\"mv-10\"><div \nclass=\"black-fg font-size-16 font-weight-600\">Value Added Charges</div></div><div class=\"mb-10\" layout=\"row\" \nlayout-align=\"space-between\" ng-if=\"$ctrl.value_added_charges.length\"><div><md-input-container md-no-float \nclass=\"inline-flex font-size-12 m-0 b h-35 brad-5\"><input type=\"text\" placeholder=\"Search Charges\" \nname=\"search_charges\" ng-model=\"$ctrl.search_charges\" class=\"m-0 select_box w-80 b-none text-transform-u w-200\">\n</md-input-container></div><div layout=\"row\" layout-align=\"end center\" class=\"black-fg font-weight-600 font-size-12\">\nClick on <button \nclass=\"vas_add_info_icon md-fab md-primary-fg md-hue-3 fab_delete_btn w-20 h-20 md-button md-default-theme p-0 button-close\" \ntype=\"button\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary-fg s14 brad-15 md-default-theme\" role=\"img\" \naria-label=\"icon-delete\"></md-icon></button> to Add Charge(s)</div></div><div \nclass=\"tableFixHead vas-table-container mt-5 mb-50\"><table id=\"tableVas\" class=\"vas-table\" cellspacing=\"0\" \ncellpadding=\"0\" width=\"100%\" align=\"center\"><thead><tr><th class=\"fix-head w-50\">Add</th><th class=\"fix-head w-250\">\nCharges</th><th class=\"fix-head w-150\">Type</th><th class=\"fix-head w-100\">Basis</th><th class=\"fix-head w-150\" \nng-if=\"$ctrl.vasdetails.search_param.mode==\'SEA-FCL\'\">Equipment Type</th><th class=\"fix-head w-100\">Qty</th><th \nclass=\"fix-head w-150\">Unit Price</th><th class=\"fix-head w-150\" \nng-if=\"$ctrl.vasdetails.search_param.mode!==\'SEA-FCL\'\">Minimum</th><th class=\"fix-head w-150\">Amount</th></tr></thead>\n<tbody align=\"center\"><tr ng-if=\"!$ctrl.value_added_charges.length\"><td colspan=\"10\" \nclass=\"font-size-14 font-weight-600 pv-30 pb-10\">No Charges Available</td></tr><tr \nng-repeat=\"charge in $ctrl.value_added_charges | filter : $ctrl.search_charges  track by charge._id\"><td \nclass=\"vas-table-cell\" rowspan=\"{{charge.slab.length}}\"><button \nclass=\"md-fab md-primary-fg md-hue-3 fab_delete_btn w-24 h-24 md-button md-default-theme p-0 button-close\" \ntype=\"button\" ng-click=\"$ctrl.addVasCharge(sell_key,charge)\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"md-primary-fg s16 brad-15 md-default-theme\" role=\"img\" aria-label=\"icon-delete\"></md-icon></button></td><td \nclass=\"vas-table-cell\" rowspan=\"{{charge.slab.length}}\">{{charge.charge_name}}</td><td class=\"vas-table-cell\" \nrowspan=\"{{charge.slab.length}}\"><span ng-repeat=\"leg in charge.leg track by $index\">{{leg.name}} <span ng-if=\"!$last\">\n,</span></span></td><td class=\"vas-table-cell\" rowspan=\"{{charge.slab.length}}\">\n{{charge.charge_basis ? charge.charge_basis : \'N/A\'}}</td><td class=\"vas-table-cell\" rowspan=\"{{charge.slab.length}}\" \nng-if=\"$ctrl.vasdetails.search_param.mode==\'SEA-FCL\'\">{{charge.container_type ? charge.container_type : \'N/A\'}}</td><td\n class=\"br vas-table-cell\"><span>{{charge.total_units}}</span></td><td class=\"vas-table-cell\"><span><span \nng-show=\"$ctrl.isNumber(charge.per_unit_rate)\">{{charge.charge_currency}} {{charge.per_unit_rate}}</span> <span \nng-show=\"!$ctrl.isNumber(charge.per_unit_rate)\">{{charge.per_unit_rate}}</span></span></td><td class=\"vas-table-cell\" \nng-if=\"$ctrl.vasdetails.search_param.mode!==\'SEA-FCL\'\"><span>{{charge.minimum_charge_cost}}</span></td><td \nclass=\"vas-table-cell\"><span ng-show=\"$ctrl.isNumber(charge.per_unit_rate)\">\n{{charge.charge_currency}} {{charge.charge_cost | currencyMask : 2}}</span> <span \nng-show=\"!$ctrl.isNumber(charge.per_unit_rate)\">{{charge.charge_cost}}</span></td></tr></tbody></table></div></div><div\n shimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" ng-if=\"$ctrl.loading\" \nng-repeat=\"shimmer in [1,2,3] track by $index\"></div></md-tab-body></md-tab></md-tabs><div layout=\"row\" \nclass=\"sticky-bottom card_shadow mr-10\" flex=\"100\" layout-align=\"end end\"><md-button md-no-ink \nclass=\"yellow-800-bg white-fg font-weight-600 btnBorder font-size-16 ph-40 mv-10\" title=\"APPLY\" \nng-click=\"$ctrl.submitVasDetails()\" \nng-disabled=\"$ctrl.doneBtnDisable || !$ctrl.legList.sell_rates.additional_services.rate_obj.charges.length\">APPLY\n</md-button></div>");
$templateCache.put("app/main/result/Dialogs/view-details/airSchedulePopup.html","<div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" ng-if=\"!ctrl.parent.getSchedule\"></div><div \nng-if=\"ctrl.parent.getSchedule\"><md-content class=\"mb-10\" layout=\"column\"><p class=\"card_text_bold ph-20\" \nng-show=\"ctrl.parent.scheduleList.length\"><span class=\"vendor_name\"><span>\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.airline.air_line_name}} - </span>\n<span>\n{{ (ctrl.parent.current_schedule.departure_time | datediff) == 0 ? \'this week \': (ctrl.parent.current_schedule.departure_time | datediff) + ((ctrl.parent.current_schedule.departure_time | datediff) == 1 ? \' week\' : \' weeks\') + \' from now\' }}\n</span></span></p><div layout=\"row\" layout-wrap class=\"ph-20 mb-30\" ng-if=\"ctrl.parent.scheduleList.length\"><div \nlayout=\"column\" layout-align=\"start start \" flex=\"100\" flex-gt-xs=\"40\" class=\"p-0 scroll\" \nng-style=\"{\'height\': ctrl.parent.scheduleDivHeight ? ctrl.parent.scheduleDivHeight - 250 +\'px\' : \'700px\'}\"><div \nclass=\"outer mv-10 mb-50 pointer\" ng-repeat=\"schedule in  ctrl.parent.scheduleList track by $index\" \nng-click=\"ctrl.parent.setCurrentSchedule(schedule, $index)\" \nng-class=\"{\'outer_container_air\' : ctrl.parent.current_schedule.id == schedule.id}\"><div layout=\"row\" layout-wrap \nlayout-align=\"center center\" class=\"font-size-14 font-weight-600 pt-15 ph-10\">{{schedule.transit_time}}</div><div \nlayout=\"row\" layout-wrap class=\"ph-15 pv-10 font-size-12-mob\"><div layout=\"column\" layout-align=\"center start\" \nflex=\"30\" flex-gt-xs=\"30\"><p class=\"font-size-14 font-weight-600 mv-5\">{{schedule.origin_port}}</p><p \nclass=\"font-size-14 m-0\">{{ schedule.departure_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"30\" flex-gt-xs=\"30\" class=\"text-center mh-5\"><p class=\"font-size-12 m-0 pt-10\"><span\n class=\"grey-fg\" ng-hide=\"schedule.schedule_track.length < 3\">via</span><br><span class=\"font-size-12 md-link-fg\">\n{{schedule.via_port}}</span></p></div><div layout=\"column\" layout-align=\" center end\" flex=\"30\" flex-gt-xs=\"30\"><p \nclass=\"font-size-14 font-weight-600 mv-5\">{{schedule.destination_port}}</p><p class=\"font-size-14 m-0 text-right\">\n{{ schedule.arrival_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div></div></div></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"60\"><div class=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\" \nng-if=\"ctrl.parent.current_schedule.schedule_track.length > 0\"><div layout=\"column\" class=\"ph-15\" \nng-repeat=\"schedule_track in ctrl.parent.current_schedule.schedule_track track by $index\"><div layout=\"row\" \nclass=\"show_schedule\" ng-class=\"{\'pt-5\' : $first}\" ng-if=\"$first || $last\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80 schedule_track_margin\" ng-if=\"!$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\" ng-if=\"$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" ng-if=\"!$last\" \nmd-svg-src=\"assets/icons/custom/search-bar/air_pod.svg\"></md-icon><md-icon class=\"icon-class\" ng-if=\"$last\" \nmd-svg-src=\"assets/icons/custom/search-bar/air_pol.svg\"></md-icon></span><span>{{ schedule_track.port_name }}</span>\n</p><div layout=\"column\" class=\"pb-20\" ng-if=\"!$last\"><div layout=\"row\"><div class=\"track_text\" flex>Flight Number\n</div><div class=\"track_text eta_div\" flex>{{schedule_track.flight_number != \"\" ? schedule_track.flight_number : \'NA\'}}\n</div></div><div layout=\"row\" ng-repeat=\"info in schedule_track.additional_info\"><div class=\"track_text\" flex>\n{{info.name}}</div><div class=\"track_text eta_div\" flex compile-html=\"info.value\"></div></div></div></div></div><div \nlayout=\"row\" ng-if=\"(!$first && !$last)\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class icon-rotate\" \nmd-svg-src=\"assets/icons/custom/roll-o-plane.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} \n</span><span>(Arrival)</span></p></div></div><div layout=\"row\" ng-if=\"(!$first && !$last)\"><div flex-md=\"20\" \nflex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class icon-rotate\" \nmd-svg-src=\"assets/icons/custom/roll-o-plane.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} \n</span><span>(Departure)</span></p><div layout=\"column\" class=\"pb-20\" ng-if=\"!$last\"><div layout=\"row\"><div \nclass=\"track_text\" flex>Flight Number</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.flight_number != \"\" ? schedule_track.flight_number : \'NA\'}}</div></div><div layout=\"row\" \nng-repeat=\"info in schedule_track.additional_info\"><div class=\"track_text\" flex>{{info.name}}</div><div \nclass=\"track_text eta_div\" flex compile-html=\"info.value\"></div></div></div></div></div></div></div><div \nclass=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552 grey-100-bg grey-600-fg\" layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" ng-if=\"!ctrl.parent.current_schedule.schedule_track\"><div>\nNo schedule has been selected.</div><div>Please select the schedule from the list.</div></div><div layout=\"column\" \nflex=\"100\" hide><md-button md-no-ink class=\"md-primary-btn\" title=\"Done\" \nng-click=\"ctrl.parent.selectedSchedule(ctrl.parent.current_schedule)\" ng-disabled=\"ctrl.parent.disableScheduleBtn\">\nAdd Schedule Track</md-button></div></div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap \nclass=\"ph-20\" ng-if=\"!ctrl.parent.scheduleList.length\"><h2>Sorry, No schedules available.</h2></div></md-content></div>");
$templateCache.put("app/main/result/Dialogs/view-details/airViewDetails.html","<md-dialog class=\"ViewModal popup-lg rate-card-detail-modal\"><div layout=\"row\" layout-padding class=\"header\" \nflex=\"100\"><div flex=\"90\" flex-xs=\"90\" class=\"p-0\">{{ctrl.parent.title}}</div><div layout=\"row\" layout-align=\"end end\" \nflex=\"10\" flex-xs=\"10\" class=\"icon_size fg-AAA8AD p-0\"><md-icon md-font-icon=\"icon-close fg-AAA8AD m-0 cursor\" \nng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div><md-dialog-content class=\"p-0\"><div \nng-include=\"\'app/main/result/Dialogs/view-details/card-popup-meta/card-popup-meta.html\'\" onload=\"loaded = true\"></div>\n<div shimmer-effect width=\"100%\" height=\"100%\" ng-if=\"!loaded\"></div><md-tabs class=\"min-height-350\" md-border-bottom \nmd-selected=\"ctrl.parent.selectedIndex\" md-dynamic-height><md-tab label=\"Slab\" \nmd-on-select=\"ctrl.parent.rateTabView()\" ng-if=\"ctrl.parent.ratesVisible\"><md-content class=\"scroll_tab\" \nlayout=\"column\"><div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" ng-if=\"ctrl.parent.showData\"></div><div\n ng-if=\"!ctrl.parent.showData && (ctrl.parent.search_param.mode == \'AIR\')\" \nng-class=\"{ \'mt-50\' : !ctrl.parent.util.isShipper }\"><div class=\"pv-10 ph-20\" layout-xs=\"column\" layout=\"row\"><div \nflex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-repeat=\"(leg_key,leg_value) in ctrl.parent.rateDetails track by $index\" ng-if=\"leg_value.rate_obj\" class=\"mb-20\">\n<md-content ng-if=\"leg_key == ctrl.parent.l3_leg && !leg_value.rate_obj.manual\" ms-scroll class=\"border\"><table \nclass=\"custom-table\"><thead><tr class=\"charge_heading\"><th class=\"Charges\">Slab</th><th class=\"Charges\">Slab Amount\n</th></tr></thead><tbody><tr ng-repeat=\"(key, chg_array) in leg_value.rate_obj.slab_rate track by $index\" \nng-class=\"{ \'selected_slab\': (key == leg_value.rate_obj.slab)}\"><td class=\"charges_details w-280\">{{key}}</td><td \nclass=\"charges_details w-280\">\n{{ !chg_array ? \'-\' : leg_value.rate_obj.slab_currency }} {{ !chg_array ? \'-\' : chg_array | currencyMask: 2}}</td></tr>\n</tbody></table></md-content><div layout=\"row\" layout-align=\"center center\" layout-wrap class=\"p-20 mt-20 border\" \nng-if=\"leg_key == ctrl.parent.l3_leg && leg_value.rate_obj.manual\"><h2>Sorry, slabs are not available.</h2></div></div>\n</div></div></div></md-content></md-tab><md-tab label=\"Schedules\" md-on-select=\"ctrl.parent.scheduleTabView()\" \nng-if=\"ctrl.parent.scheduleVisible\"><div ng-include=\"\'app/main/result/Dialogs/view-details/schedulePopup.html\'\"></div>\n</md-tab><md-tab label=\"Airline Schedules\" md-on-select=\"ctrl.parent.airScheduleTabView()\" \nng-if=\"ctrl.parent.airScheduleVisible\"><div ng-include=\"\'app/main/result/Dialogs/view-details/airSchedulePopup.html\'\">\n</div></md-tab><md-tab label=\"Analytics\" md-on-select=\"ctrl.parent.analyticsTabView()\" \nng-if=\"ctrl.parent.analyticsVisible\"><md-content layout=\"column\"><div ng-if=\"!ctrl.parent.is_rate_history_empty\" \nclass=\"pt-20 pl-10 analytic-head\"><span class=\"graph-header\">COMPARED AGAINST CURRENTLY AVAILABLE RATES</span><div \nlayout=\"row\" flex=\"100\" class=\"pt-20 pb-20\"><div flex=\"20\" \nng-repeat=\"analytics in ctrl.parent.analyticsData.rate_data track by $index\"><div class=\"container-head\">\n{{analytics.type}} Container</div><div class=\"pt-10 cheaper container-body\" ng-if=\"analytics.percentile<=40\">\n{{(100 - analytics.percentile)}} % Cheaper</div><div class=\"pt-10 expensive container-body\" \nng-if=\"analytics.percentile>40\">{{analytics.percentile}} % Expensive</div></div></div></div><div \nclass=\"pt-40 pb-10 font-weight-600\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!ctrl.parent.is_rate_history_empty\">HISTORICAL RATE DATA FOR PAST 1 YEAR</div><div id=\"chart\" \nng-if=\"!ctrl.parent.is_rate_history_empty\"></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"pt-30 pb-30 graph-container\" ng-if=\"!ctrl.parent.is_rate_history_empty\"></div><div \nng-if=\"((ctrl.parent.analyticsData.rate_data.length <= 0)||(ctrl.parent.is_rate_history_empty))\" \nclass=\"text-center font-size-20 font-weight-800 p-30\">Sorry, Analytics Not Available!</div></md-content></md-tab>\n<md-tab label=\"Charges\" md-on-select=\"ctrl.parent.quotationTabView();\" ng-if=\"ctrl.parent.quotationVisible\"><div \nng-include=\"\'app/main/result/Dialogs/view-details/airlclQuotaionPopup.html\'\"></div></md-tab><md-tab \nlabel=\"Remarks & Inclusions\" md-on-select=\"ctrl.parent.remarksTabView();loadEditor=true;\" \nng-if=\"ctrl.parent.quotationVisible\"><div ng-if=\"loadEditor\" \nng-include=\"\'app/main/result/Dialogs/view-details/remarks-inclusion-popup.html\'\"></div></md-tab><md-tab label=\"T&C\" \nmd-on-select=\"ctrl.parent.termsTabView()\" \nng-if=\"ctrl.parent.termsVisible || ctrl.parent.pageSource === \'Instant-ViewDetails\'\"><div \nng-include=\"\'app/main/result/Dialogs/terms-popup/terms-popup.html\'\" ng-if=\"ctrl.parent.viewActiveTab == \'Terms\'\"></div>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" class=\"footer sticky-bottom card_shadow\" \nng-if=\"(ctrl.parent.airScheduleVisible) && [\'airline schedule\',\'schedule\'].includes(ctrl.parent.viewActiveTab) && ctrl.parent.current_schedule\">\n<div layout=\"row\" flex=\"100\" class=\"ml-10\" layout-wrap ng-if=\"ctrl.parent.getSchedule\"><div flex=\"50\" flex-xs=\"50\" \nflex-sm=\"50\" layout-align=\"start center\"><div class=\"schedule_warning\" ng-if=\"ctrl.parent.ifExpireCross\">\nSelected schedule is after expiry date of shown rates. Actual rates may vary.</div></div><div flex flex-xs=\"50\" \nflex-sm=\"50\" class=\"text-end pr-10\" layout-align=\"end center\"><md-button md-no-ink class=\"md-accent-btn w-150\" \ntitle=\"Select schedule\" ng-click=\"ctrl.parent.selectedSchedule(ctrl.parent.current_schedule)\" \nng-style=\"{ \'cursor\' : ( ctrl.parent.disableScheduleBtn)  ? \'not-allowed\' : \'pointer\' }\" \nng-disabled=\"ctrl.parent.disableScheduleBtn\">Select Schedule</md-button></div></div></md-dialog-actions>\n<md-dialog-actions layout=\"row\" class=\"footer-mobile-spacing sticky-bottom card_shadow\" \nng-if=\"(ctrl.parent.util.isAdmin || ctrl.parent.util.isFreightbro) && ctrl.parent.quotationVisible && (ctrl.parent.viewActiveTab == \'quotation\' || ctrl.parent.viewActiveTab == \'remarksInclusion\' || (ctrl.parent.scheduleVisible && ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.current_schedule))\">\n<div layout=\"row\" flex=\"100\" class=\"pl-10\" layout-wrap ng-if=\"!ctrl.parent.showData\"><div layout=\"column\" flex=\"15\" \nflex-xs=\"10\" flex-sm=\"10\" hide-xs hide-sm layout-align=\"center start\" class=\"mr-10 br\" \nng-if=\"!(ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross)\"><div class=\"pb-5\">BUY RATE</div><div \nclass=\"font-weight-600\">\n{{ctrl.parent.searchUser.user_base_currency}} {{ctrl.parent.footerObj.buyTotalBaseCurr | currencyMask: 2}}</div></div>\n<div layout=\"column\" flex=\"15\" flex-xs=\"10\" flex-sm=\"10\" hide-xs hide-sm layout-align=\"center start\" class=\"mr-10 br\" \nng-if=\"!(ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross)\"><div class=\"pb-5\">SELL RATE</div><div \nclass=\"font-weight-600\">\n{{ctrl.parent.searchUser.user_base_currency}} {{ctrl.parent.footerObj.sellTotalBaseCurr | currencyMask: 2}}</div></div>\n<div layout=\"column\" flex hide-xs hide-sm layout-align=\"center start\" \nng-if=\"!(ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross)\"><div \nng-if=\"ctrl.parent.footerObj.sellTotalBaseCurr >= ctrl.parent.footerObj.buyTotalBaseCurr\"><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"green-fg s20 mr-5\"></md-icon>You earn <span class=\"font-weight-600\">\n{{ctrl.parent.searchUser.user_base_currency}} {{(ctrl.parent.footerObj.sellTotalBaseCurr - ctrl.parent.footerObj.buyTotalBaseCurr | currencyMask: 2)}}\n</span> <span class=\"green-fg mh-5\">{{ctrl.parent.footerObj.profit}}</span> on this rate</div><div \nng-if=\"ctrl.parent.footerObj.sellTotalBaseCurr < ctrl.parent.footerObj.buyTotalBaseCurr\"><md-icon \nmd-font-icon=\"icon-trending-down\" class=\"red-fg s20\"></md-icon><span class=\"red-fg mh-5\">\n{{ctrl.parent.footerObj.profit.substr(1)}} Loss</span> <span class=\"font-weight-600\">\n(-{{ctrl.parent.searchUser.user_base_currency}} {{((ctrl.parent.footerObj.buyTotalBaseCurr - ctrl.parent.footerObj.sellTotalBaseCurr) | currencyMask: 2)}})\n</span> on this rate</div><div ng-if=\"ctrl.parent.showExchangeRates\"><a class=\"pointer md-link-fg Font-Bold\" \nng-click=\"ctrl.parent.util.redirectToExchangeRatesLink(ctrl.parent.resultType, ctrl.parent.resultId, ctrl.parent.cardVendorId,\'\',null,ctrl.parent.activityId);\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div></div><div \nflex=\"50\" flex-xs=\"50\" flex-sm=\"50\" layout-align=\"start center\" \nng-if=\"ctrl.parent.getSchedule && ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross\"><div \nclass=\"schedule_warning\">Selected schedule is after expiry date of shown rates. Actual rates may vary.</div></div><div \nflex layout=\"column\" layout-align=\"center end\" ng-if=\"ctrl.parent.quoteEdit\"><md-button \nng-if=\"ctrl.parent.resultfilter.hideBookBtn || ctrl.parent.parentPage !=\'result\'\" md-no-ink class=\"md-accent-btn\" \ntitle=\"Done\" \nng-disabled=\"!ctrl.parent.currentCard.data.sell_rates || ctrl.parent.footerObj.doneBtnDisable || !ctrl.parent.currentCard.meta.isScheduleCall || ctrl.parent.footerObj.rateExpired\" \nng-click=\"ctrl.parent.pushToquoteArray(ctrl.parent.currentCard)\">Done<md-tooltip md-direction=\"top\" \nng-if=\"ctrl.parent.footerObj.rateExpired\">This Rate is expired</md-tooltip></md-button><div \nng-if=\"!ctrl.parent.resultfilter.hideBookBtn && ctrl.parent.parentPage ==\'result\'\"><md-button \nng-if=\"ctrl.parent.util.navPermission.shipments && ctrl.parent.util.navPermission.shipments[0]\" md-no-ink \nclass=\"md-primary-btn mr-10 quote-button\" title=\"Create a Booking\" \nng-disabled=\"!ctrl.parent.currentCard.data.sell_rates || ctrl.parent.footerObj.doneBtnDisable || !ctrl.parent.currentCard.meta.isScheduleCall || ctrl.parent.footerObj.rateExpired\" \nng-click=\"ctrl.parent.pushToquoteArray(ctrl.parent.currentCard, \'bookingRequest\')\">Create a Booking<md-tooltip \nmd-direction=\"top\" ng-if=\"ctrl.parent.footerObj.rateExpired\">This Rate is expired</md-tooltip></md-button><md-button \nng-if=\"ctrl.parent.util.navPermission.quotes[0]\" md-no-ink class=\"md-accent-btn quote-button ml-10\" title=\"Done\" \nstyle=\"margin-right:0px\" \nng-disabled=\"!ctrl.parent.currentCard.data.sell_rates || ctrl.parent.footerObj.doneBtnDisable || !ctrl.parent.currentCard.meta.isScheduleCall || ctrl.parent.footerObj.rateExpired \" \nng-click=\"ctrl.parent.pushToquoteArray(ctrl.parent.currentCard)\">Create a Quote<md-tooltip md-direction=\"top\" \nng-if=\"ctrl.parent.footerObj.rateExpired\">This Rate is expired</md-tooltip></md-button></div></div></div>\n</md-dialog-actions><md-dialog-actions layout=\"row\" class=\"sticky-bottom card_shadow footer-mobile-spacing\" \nng-if=\"ctrl.parent.util.isShipper && ctrl.parent.quotationVisible && (ctrl.parent.viewActiveTab == \'quotation\' || ctrl.parent.viewActiveTab == \'remarksInclusion\' || (ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.search_param.mode != \'AIR\'))\">\n<div layout=\"row\" flex=\"100\" class=\"pl-10\" layout-wrap ng-if=\"!ctrl.parent.showData\"><div layout=\"column\" flex=\"15\" \nflex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm layout-align=\"center start\"><div class=\"pb-10\">TOTAL COST\n</div><div class=\"font-weight-600\" layout=\"row\">\n{{ctrl.parent.searchUser.user_base_currency}} {{ctrl.parent.footerObj.sellTotalBaseCurr | currencyMask: 2}}</div></div>\n<div layout=\"column\" layout-align=\"center start\"><div class=\"grey-fg font-size-11\">\nNOTE: All rates are subject to liner availability</div><div ng-if=\"ctrl.parent.showExchangeRates\"><a \nclass=\"pointer md-link-fg Font-Bold\" \nng-click=\"ctrl.parent.util.redirectToExchangeRatesLink(ctrl.parent.resultType, ctrl.parent.resultId, ctrl.parent.cardVendorId, \'CrtQuote-POP-ViewExchangeRates\',{\'Mode\': ctrl.parent.search_param.mode,\'Type\': ctrl.parent.resultType}, ctrl.parent.activityId)\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div></div><div \nflex layout=\"row\" layout-align=\"end center\" \nng-if=\"ctrl.parent.btnShipperBooking || ctrl.parent.allowDownloadRateForShipper\"><md-button \nng-if=\"ctrl.parent.search_param.mode == \'SEA-LCL\' && ctrl.parent.allowDownloadRateForShipper && ctrl.parent.parentPage === \'result\'\" \nmd-no-ink class=\"md-primary-btn\" title=\"Select Cards\" ng-click=\"ctrl.parent.pushToquoteArray(ctrl.parent.currentCard)\">\nSelect Card<md-tooltip md-direction=\"top\" ng-if=\"ctrl.parent.footerObj.rateExpired\">This Rate is expired</md-tooltip>\n</md-button><div ng-if=\"ctrl.parent.btnShipperBooking\"><md-button md-no-ink class=\"md-accent-btn\" title=\"Done\" \nng-click=\"ctrl.parent.requestToBook(ctrl.parent.currentCard, \'fromModal\')\">Request Booking</md-button></div></div>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/result/Dialogs/view-details/airlclQuotaionPopup.html","<div ng-class=\"{\'scroll_tab\' : !ctrl.parent.util.isMobileDevice}\" class=\"mb-20\"><md-content class=\"mb-10\" \nlayout=\"column\" ng-class=\"{\'mb-100\' : ctrl.parent.util.isMobileDevice}\"><div \nclass=\"mh-20 mb-20 buy_sell_rates margin_bottom_7per\" layout=\"column\" flex=\"100\" \nng-if=\"!ctrl.parent.showData && !ctrl.parent.callingConversionApi\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"mt-15 mb-5\" layout-wrap><div layout=\"row\" flex flex-xs=\"100\" \nlayout-align=\"end center\" layout-align-xs=\"start center\" class=\"mv-5\" ng-if=\"ctrl.parent.airScheduleVisible\">\nChargeable Weight: <span class=\"font-size-14 font-weight-400 mh-10 mv-5\" \nng-bind=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.is_higher_slab ? (ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.slab | currencyMask) : (ctrl.parent.search_param.load_data.load_meta.chargeable_weight | currencyMask) + \' KG\'\">\n</span></div></div><air-lcl-rate-modification search-param=\"ctrl.parent.search_param\" \ncurrent-card=\"ctrl.parent.currentCard\" source-rate=\"ctrl.parent.sourceRate\" page-source=\"ctrl.parent.pageSource\" \nquote-edit=\"ctrl.parent.quoteEdit\" inquiry-pricing=\"ctrl.parent.inquiryPricing\" from-inquiry=\"ctrl.parent.fromInquiry\" \nfooter-obj=\"ctrl.parent.footerObj\" edit-buy-rate=\"ctrl.parent.editBuyRate\" all-in-quote=\"ctrl.parent.all_in_quote\">\n</air-lcl-rate-modification></div><div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" \nng-show=\"ctrl.parent.showData || ctrl.parent.callingConversionApi\"></div></md-content></div>");
$templateCache.put("app/main/result/Dialogs/view-details/cost-breakup.html","<div id=\"Cost-Breakup\"><div ng-repeat=\"(leg_key,leg_value) in ctrl.parent.rateDetails track by $index\" class=\"mb-25\" \nng-if=\"leg_value.rate_obj\"><div class=\"leg_heading Font-Bold pl-30 pr-40 pv-8\" layout=\"row\" \nlayout-align=\"space-between\"><div>\n{{ ( leg_value.rate_obj.leg_code == ctrl.parent.l3_leg && leg_value.leg_name == ctrl.parent.mainFreightName ) ? \'Freight\' : leg_value.leg_name }}\n</div><div>{{leg_value.rate_obj.leg_currency}} {{(leg_value.rate_obj.leg_currency_cost| currencyMask: 2)}}</div></div>\n<div class=\"scroll_charge_table simple-table-container\"><md-content><table ms-responsive-table><tr><th \nclass=\"load_header Font-Bold text-left pl-30\">CHARGES</th><th class=\"load_header Font-Bold text-right\" \nng-if=\"leg_value.leg_code==\'additional_services\'\">Type</th><th class=\"load_header Font-Bold text-right\">UNIT PRICE</th>\n<th class=\"load_header Font-Bold text-center\">QUANTITY</th><th class=\"load_header Font-Bold text-center\" \nng-if=\"ctrl.parent.search_param.mode != \'SEA-FCL\'\">Minimum</th><th class=\"load_header Font-Bold text-center\" \nng-if=\"ctrl.parent.search_param.mode != \'SEA-FCL\'\">Maximum</th><th class=\"load_header Font-Bold text-center\">AMOUNT\n</th></tr><tr ng-repeat=\"(key, chg_array) in leg_value.rate_obj.charges track by $index\"><td \nclass=\"pl-30 charge_name_div\"><div class=\"Font-Bold font-size-16 black-fg\">\n{{chg_array.charge_name == \'\' ? \'-\' : chg_array.charge_name}} <span \nng-show=\"chg_array.container_type && (leg_value.leg_code != \'ins_fcl\')\">- {{chg_array.container_type}} </span><span \nclass=\"dim-charge-sect\" ng-if=\"chg_array.charge_basis.includes(\'dim\')\">DIM Charge</span> <span class=\"dim-charge-sect\" \nng-if=\"chg_array.charge_category && chg_array.charge_category !== null\" ng-bind=\"chg_array.charge_category\"></span>\n</div><div class=\"Font-Bold font-size-12 grey-fg\">{{chg_array.charge_basis == \'\' ? \'-\' : chg_array.charge_basis}}</div>\n</td><td ng-if=\"leg_value.leg_code==\'additional_services\'\"><span ng-repeat=\"leg in chg_array.leg track by $index\">\n{{leg.name}}<span ng-show=\"!$last\">,</span></span></td><td class=\"text-right td-width-180\"><div \nclass=\"Font-Bold font-size-16 grey-fg\"><span \nng-bind=\"!ctrl.parent.basisArray.includes(chg_array.charge_basis) ? ctrl.parent.isString(chg_array.per_unit_rate)? \'\': chg_array.charge_currency : \'%\' \">\n</span> {{ ctrl.parent.fnCheckIsNaN(chg_array, \'per_unit_rate\')}}</div></td><td \nclass=\"text-center td-width-180 qty-width-50\"><div class=\"Font-Bold font-size-16 grey-fg\">\nx {{ chg_array.total_units % 1 != 0 ? (chg_array.total_units | currencyMask : 2) : chg_array.total_units }}<md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s14 ml-2 mb-3\" \nid=\"{{\'charge_\'+leg_value.rate_obj.global_leg_id+\'_\'+key}}\" \nng-if=\"ctrl.parent.currentCard.meta.ltl_load_details && (leg_value.rate_obj.global_leg_id == \'l1\' || leg_value.rate_obj.global_leg_id == \'l5\') && chg_array.charge_basis == \'per_w/m\'\">\n<md-tooltip md-direction=\"bottom\" class=\"black-bg p-10 white-fg\" \nstyle=\"display:table;opacity:1;line-height:1.3; box-shadow: 0px 0px 20px #00000014\" class=\"font-size-10\"><div \nng-if=\"leg_value.rate_obj.global_leg_id == \'l1\'\"><table><tr><td>Gross Weight</td><td>\n{{ctrl.parent.currentCard.meta.ltl_load_details.origin.gross_weight}} {{ctrl.parent.currentCard.meta.ltl_load_details.origin.gross_weight_unit}}\n</td></tr><tr><td>Dimensional Weight</td><td>\n{{ctrl.parent.currentCard.meta.ltl_load_details.origin.dimensional_weight}} {{ctrl.parent.currentCard.meta.ltl_load_details.origin.dimensional_unit}}\n</td></tr><tr><td>Chargeable Weight</td><td>\n{{ctrl.parent.currentCard.meta.ltl_load_details.origin.chargeable_weight}} {{ctrl.parent.currentCard.meta.ltl_load_details.origin.chargeable_unit}}\n</td></tr></table></div><div ng-if=\"leg_value.rate_obj.global_leg_id == \'l5\'\"><table><tr><td>Gross Weight</td><td>\n{{ctrl.parent.currentCard.meta.ltl_load_details.destination.gross_weight}} {{ctrl.parent.currentCard.meta.ltl_load_details.destination.gross_weight_unit}}\n</td></tr><tr><td>Dimensional Weight</td><td>\n{{ctrl.parent.currentCard.meta.ltl_load_details.destination.dimensional_weight}} {{ctrl.parent.currentCard.meta.ltl_load_details.destination.dimensional_unit}}\n</td></tr><tr><td>Chargeable Weight</td><td>\n{{ctrl.parent.currentCard.meta.ltl_load_details.destination.chargeable_weight}} {{ctrl.parent.currentCard.meta.ltl_load_details.destination.chargeable_unit}}\n</td></tr></table></div></md-tooltip></md-icon></div></td><td class=\"text-center td-width-180\" \nng-if=\"ctrl.parent.search_param.mode != \'SEA-FCL\'\"><div class=\"Font-Bold font-size-16 grey-fg\">\n{{chg_array.minimum_charge_cost | currencyMask : 2}}</div></td><td class=\"text-center td-width-180\" \nng-if=\"ctrl.parent.search_param.mode != \'SEA-FCL\'\"><div class=\"Font-Bold font-size-16 grey-fg\">\n{{chg_array.maximum_charge_cost | currencyMask : 2}}</div></td><td class=\"text-center td-width-180\"><div \nclass=\"Font-Bold font-size-16 black-fg\">\n{{leg_value.rate_obj.leg_currency + \' \' + (chg_array.leg_currency_cost | currencyMask: 2) }} <sup class=\"green-fg\" \nng-if=\"chg_array.min_flag\">*<md-tooltip md-direction=\"top\" class=\"font-size-10\">Minimum amount</md-tooltip></sup><sup \nclass=\"green-fg\" ng-if=\"chg_array.max_flag\">*<md-tooltip md-direction=\"top\" class=\"font-size-10\">Maximum amount\n</md-tooltip></sup></div></td></tr></table></md-content></div></div><div class=\"remarks_div Font-Bold pv-10 ph-30\"><div\n class=\"font-size-12 grey-400-fg\">REMARKS</div><div class=\"font-size-16 inclusion-wrap\" \nng-class=\"{\'grey-fg\' : !ctrl.parent.currentCard.meta.remarks}\"><div id=\"remarks\" \ncompile-html=\"ctrl.parent.currentCard.meta.remarks ? ctrl.parent.currentCard.meta.remarks : \' - \'\"></div></div></div>\n<div class=\"bb Font-Bold pv-10 ph-30\"><div class=\"font-size-12 grey-400-fg\">INCLUSIONS</div><div \nclass=\"font-size-16 inclusion-wrap\" ng-class=\"{\'grey-fg\' : !ctrl.parent.currentCard.meta.inclusions}\"><div \nid=\"inclusion\" \ncompile-html=\"ctrl.parent.currentCard.meta.inclusions ? ctrl.parent.currentCard.meta.inclusions : \' - \'\"></div></div>\n</div><div layout=\"row\" class=\"pv-8 ph-30 Font-Bold\" layout-align=\"start center\" layout-wrap><div \nclass=\"mr-30 font-size-13\" layout-wrap ng-if=\"ctrl.parent.dimLegList.length\"><div class=\"pb-5\">DIM Calculation</div>\n<div>{{ctrl.parent.dimLegList[0].cbm}} KG / CBM for {{ctrl.parent.dimLegList[0].leg_name}}<span \nng-show=\"ctrl.parent.dimLegList.length>1\">\n,{{ctrl.parent.dimLegList[1].cbm}} KG / CBM for {{ctrl.parent.dimLegList[1].leg_name}}</span><span \nng-show=\"ctrl.parent.dimLegList.length>2\" class=\"md-link-fg\">,+{{ctrl.parent.dimLegList.length-2}}</span><md-tooltip \nmd-direction=\"top\" class=\"md-whiteframe-2dp white-fg black-bg font-size-10 ph-20 line-height-20 pv-5\" \nstyle=\"height: fit-content\"><span ng-repeat=\"dim in ctrl.parent.dimLegList track by $index\"><span><span \nng-if=\"ctrl.parent.dimLegList.length>1\">{{$index+1}}.</span> {{dim.leg_name}}, {{dim.cbm}} KG/CBM</span><br></span>\n</md-tooltip></div></div><div layout=\"column\" class=\"grey-fg font-size-12\"><div>\nNOTE: All rates are subject to liner availability</div><div ng-if=\"ctrl.parent.showExchangeRates\"><a \nclass=\"pointer md-link-fg Font-Bold\" \nng-click=\"ctrl.parent.util.redirectToExchangeRatesLink(ctrl.parent.resultType, ctrl.parent.resultId, ctrl.parent.cardVendorId, \'CrtQuote-POP-ViewExchangeRates\',{\'Mode\': ctrl.parent.search_param.mode,\'Type\': ctrl.parent.resultType})\">\nView Exchange Rates</a></div></div><div flex flex-sm=\"100\" flex-xs=\"100\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"font-size-12 grey-fg\">TOTAL COST</div><div class=\"font-size-28\">\n{{ctrl.parent.searchUser.user_base_currency}} {{ ctrl.parent.rateTotalCustomCurr(ctrl.parent.rateDetails)| currencyMask: 2}}\n</div><div class=\"font-size-12 Font-Bold\" \nng-if=\"ctrl.parent.search_param.mode == \'SEA-FCL\' && ctrl.parent.currentCard.meta.additional_charges\"><span \nng-if=\"ctrl.parent.currentCard.meta.additional_charges.data\">\n+ {{ctrl.parent.currentCard.meta.additional_charges.data.leg_currency}} {{ctrl.parent.currentCard.meta.additional_charges.data.leg_currency_cost | currencyMask: 2}}\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"s16 mb-3 grey-600-fg\"><md-tooltip class=\"black-bg\" md-direction=\"top\">\nConvenience fee</md-tooltip></md-icon></span><div class=\"pl-15\" layout=\"row\" layout-align=\"center center\" \nng-if=\"ctrl.parent.showConvLoader\"><md-progress-circular class=\"md-primary\" md-diameter=\"17\"></md-progress-circular>\n</div></div></div></div><div layout=\"row\" flex=\"100\" \nng-if=\"(ctrl.parent.currentState == \'app.search.result\' || ctrl.parent.currentState == \'app.search.airResult\' || ctrl.parent.currentState == \'app.search.lclResult\') && !ctrl.parent.resultfilter.hideBookBtn\">\n<md-button md-no-ink class=\"md-accent-btn w-100p Font-Bold\" \nng-disabled=\"!ctrl.parent.util.navPermission.shipments || !ctrl.parent.util.navPermission.shipments[0] || ctrl.parent.generateQuoteBtn || ctrl.parent.resultfilter.countApiCard\" \nng-click=\"ctrl.parent.requestToBook(ctrl.parent.currentCard, \'fromModal\')\">Request Booking</md-button></div></div>");
$templateCache.put("app/main/result/Dialogs/view-details/fclViewDetails.html","<md-dialog class=\"ViewModal popup-lg rate-card-detail-modal\"><div layout=\"row\" layout-padding class=\"header\" \nflex=\"100\"><div flex=\"90\" class=\"p-0\" flex-xs=\"90\">{{ctrl.parent.title}}</div><div layout=\"row\" class=\"p-0\" \nlayout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size fg-AAA8AD\"><md-icon \nmd-font-icon=\"icon-close m-3 fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div>\n<md-dialog-content class=\"p-0\"><div \nng-include=\"\'app/main/result/Dialogs/view-details/card-popup-meta/card-popup-meta.html\'\" onload=\"loaded = true\"></div>\n<div shimmer-effect width=\"100%\" height=\"100%\" ng-if=\"!loaded\"></div><md-tabs class=\"min-height-350\" md-border-bottom \nmd-selected=\"ctrl.parent.selectedIndex\" md-dynamic-height><md-tab label=\"Slab\" \nmd-on-select=\"ctrl.parent.rateTabView()\" ng-if=\"ctrl.parent.ratesVisible\"><div \nng-include=\"\'app/main/result/Dialogs/view-details/slab-fcl.html\'\"></div></md-tab><md-tab label=\"Schedules\" \nmd-on-select=\"ctrl.parent.scheduleTabView()\" ng-if=\"ctrl.parent.scheduleVisible\"><div \nng-include=\"\'app/main/result/Dialogs/view-details/schedulePopup.html\'\"></div></md-tab><md-tab label=\"Analytics\" \nmd-on-select=\"ctrl.parent.analyticsTabView()\" ng-if=\"ctrl.parent.analyticsVisible\"><md-content layout=\"column\"><div \nng-if=\"!ctrl.parent.is_rate_history_empty\" class=\"pt-20 pl-10 analytic-head\"><span class=\"graph-header\">\nCOMPARED AGAINST CURRENTLY AVAILABLE RATES</span><div layout=\"row\" flex=\"100\" class=\"pt-20 pb-20\"><div flex=\"20\" \nng-repeat=\"analytics in ctrl.parent.analyticsData.rate_data track by $index\"><div class=\"container-head\">\n{{analytics.type}} Container</div><div class=\"pt-10 cheaper container-body\" ng-if=\"analytics.percentile<=40\">\n{{(100 - analytics.percentile)}} % Cheaper</div><div class=\"pt-10 expensive container-body\" \nng-if=\"analytics.percentile>40\">{{analytics.percentile}} % Expensive</div></div></div></div><div \nclass=\"pt-40 pb-10 font-weight-600\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!ctrl.parent.is_rate_history_empty\">HISTORICAL RATE DATA FOR PAST 1 YEAR</div><div id=\"chart\" \nng-if=\"!ctrl.parent.is_rate_history_empty\"></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"pt-30 pb-30 graph-container\" ng-if=\"!ctrl.parent.is_rate_history_empty\"></div><div \nng-if=\"((ctrl.parent.analyticsData.rate_data.length <= 0)||(ctrl.parent.is_rate_history_empty))\" \nclass=\"text-center font-size-20 font-weight-800 p-30\">Sorry, Analytics Not Available!</div></md-content></md-tab>\n<md-tab label=\"Charges\" md-on-select=\"ctrl.parent.quotationTabView();\" ng-if=\"ctrl.parent.quotationVisible\"><div \nng-include=\"\'app/main/result/Dialogs/view-details/quotationPopup.html\'\"></div></md-tab><md-tab \nlabel=\"Remarks & Inclusions\" md-on-select=\"ctrl.parent.remarksTabView();loadEditor=true\" \nng-if=\"ctrl.parent.quotationVisible\"><div ng-if=\"loadEditor\" \nng-include=\"\'app/main/result/Dialogs/view-details/remarks-inclusion-popup.html\'\"></div></md-tab><md-tab label=\"T&C\" \nmd-on-select=\"ctrl.parent.termsTabView()\" ng-if=\"ctrl.parent.termsVisible\"><div \nng-include=\"\'app/main/result/Dialogs/terms-popup/terms-popup.html\'\" ng-if=\"ctrl.parent.viewActiveTab == \'Terms\'\"></div>\n</md-tab><md-tab label=\"Free days\" md-on-select=\"ctrl.parent.freeDaysTabView()\"><div \nclass=\"mh-20 mb-20 buy_sell_rates margin_bottom_7per overflow\" layout=\"column\" flex=\"100\" \nng-if=\"!ctrl.parent.showData && !ctrl.parent.callingConversionApi\"><load-wise-free-days class=\"mt-30\" \nrate-obj=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj\" \nsearch-param=\"ctrl.parent.search_param\" load-wise-free-days-list=\"ctrl.parent.loadWiseFreeDaysList\">\n</load-wise-free-days></div><div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" \nng-if=\"ctrl.parent.showData || ctrl.parent.callingConversionApi\"></div></md-tab><md-tab label=\"Additional Information\" \nng-if=\"ctrl.parent.search_param.mode == \'SEA-FCL\' && ctrl.parent.isWalmart\"><div \nng-include=\"\'app/main/result/Dialogs/addtional-information/addtional-information.html\'\"></div></md-tab><md-tab \nlabel=\"Rate Index\" md-on-select=\"ctrl.parent.RateIndexView()\" ng-if=\"ctrl.parent.xenetaVisible\"><xeneta-rate-index \nrate-index-data=\"ctrl.parent.rateIndexData\" ng-if=\"ctrl.parent.showRateIndex\"></xeneta-rate-index></md-tab></md-tabs>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"sticky-bottom card_shadow\" hide><div layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"ctrl.parent.getSchedule\"><div flex=\"50\" flex-xs=\"50\" flex-sm=\"50\" \nlayout-align=\"start center\"><div class=\"schedule_warning\" ng-if=\"ctrl.parent.ifExpireCross\">\nSelected schedule is after expiry date of shown rates. Actual rates may vary.</div></div><div flex flex-xs=\"50\" \nflex-sm=\"50\" class=\"text-end pr-10\" layout-align=\"end center\"><md-button md-no-ink class=\"md-accent-btn\" \ntitle=\"Select Schedule\" ng-click=\"ctrl.parent.selectedSchedule(ctrl.parent.current_schedule)\" \nng-style=\"{ \'cursor\' : ( ctrl.parent.disableScheduleBtn)  ? \'not-allowed\' : \'pointer\' }\" \nng-disabled=\"ctrl.parent.disableScheduleBtn\">Select Schedule</md-button></div></div></md-dialog-actions>\n<md-dialog-actions layout=\"row\" class=\"sticky-bottom card_shadow footer-mobile-spacing\" \nng-if=\"(ctrl.parent.util.isAdmin || ctrl.parent.util.isFreightbro) && ctrl.parent.quotationVisible && (ctrl.parent.viewActiveTab == \'quotation\' || ctrl.parent.viewActiveTab == \'remarksInclusion\' || (ctrl.parent.scheduleVisible && (ctrl.parent.viewActiveTab == \'schedule\') && ctrl.parent.current_schedule) )\">\n<div layout=\"row\" flex=\"100\" class=\"pl-10\" layout-wrap ng-if=\"!ctrl.parent.showData\"><div layout=\"column\" flex=\"15\" \nflex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm layout-align=\"center start\" \nng-if=\"!(ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross)\"><div class=\"pb-5\">BUY RATE</div><div \nclass=\"font-weight-600\" layout=\"row\" layout-wrap><div>\n{{ctrl.parent.searchUser.user_base_currency}} {{ctrl.parent.footerObj.buyTotalBaseCurr | currencyMask: 2}} <span \nclass=\"pl-5\" \nng-if=\"ctrl.parent.currentCard.meta.additional_charges && ctrl.parent.currentCard.meta.additional_charges.data\">\n+ {{ctrl.parent.currentCard.meta.additional_charges.data.leg_currency}} {{ctrl.parent.currentCard.meta.additional_charges.data.leg_currency_cost | currencyMask: 2}}\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"s16 mb-3 grey-600-fg\"><md-tooltip class=\"black-bg\" md-direction=\"top\">\nConvenience fee</md-tooltip></md-icon></span></div><div class=\"pl-15\" ng-if=\"ctrl.parent.footerObj.showConvLoader\">\n<md-progress-circular class=\"md-primary\" md-diameter=\"17\"></md-progress-circular></div></div></div><div \nlayout=\"column\" flex=\"15\" flex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm layout-align=\"center start\" \nng-if=\"!(ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross)\"><div class=\"pb-5\">SELL RATE</div><div \nclass=\"font-weight-600\">\n{{ctrl.parent.searchUser.user_base_currency}} {{ctrl.parent.footerObj.sellTotalBaseCurr | currencyMask: 2}}</div></div>\n<div layout=\"column\" flex hide-xs hide-sm layout-align=\"center start\" \nng-if=\"!(ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross)\"><div \nng-if=\"ctrl.parent.footerObj.sellTotalBaseCurr >= ctrl.parent.footerObj.buyTotalWithConv\"><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"green-fg s20 mr-5\"></md-icon>You earn <span class=\"font-weight-600\">\n{{ctrl.parent.searchUser.user_base_currency}} {{(ctrl.parent.footerObj.sellTotalBaseCurr - ctrl.parent.footerObj.buyTotalWithConv | currencyMask: 2)}}\n</span> <span class=\"green-fg mh-5\">{{ctrl.parent.footerObj.profit}}</span> on this rate</div><div \nng-if=\"ctrl.parent.footerObj.sellTotalBaseCurr < ctrl.parent.footerObj.buyTotalWithConv\"><md-icon \nmd-font-icon=\"icon-trending-down\" class=\"red-fg s20\"></md-icon><span class=\"red-fg mh-5\">\n{{ctrl.parent.footerObj.profit.substr(1)}} Loss</span> <span class=\"font-weight-600\">\n(-{{ctrl.parent.searchUser.user_base_currency}} {{((ctrl.parent.footerObj.buyTotalWithConv - ctrl.parent.footerObj.sellTotalBaseCurr) | currencyMask: 2)}})\n</span> on this rate</div><div ng-if=\"ctrl.parent.showExchangeRates\"><a class=\"pointer md-link-fg Font-Bold\" \nng-click=\"ctrl.parent.util.redirectToExchangeRatesLink(ctrl.parent.resultType, ctrl.parent.resultId, ctrl.parent.cardVendorId,\'\',null, ctrl.parent.activityId);\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div></div><div \nflex=\"30\" flex-xs=\"50\" flex-sm=\"20\" class=\"pl-10 mh-10 bl\" \nng-if=\"ctrl.parent.fromInquiry && ctrl.parent.quoteEdit &&!(ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross)\">\n<div>Publish rate to the Search<md-icon md-font-icon=\"icon-alert-circle\" class=\"s18 black-fg mb-3\"><md-tooltip \nmd-direction=\"top\" class=\"p-8 font-size-11 white-fg font-weight-600\" \nstyle=\"display:table;opacity: 1; line-height: 1.5\"><div>Rates would be available for other users to</div><div>\nsearch until Expiry</div></md-tooltip></md-icon></div><div class=\"pb-5 font-size-11 grey-500-fg\">\nOnly main freight charge can be published to search</div><div class=\"font-weight-600\"><md-radio-group \nng-model=\"ctrl.parent.currentCard.meta.isRateGlobal\" \nng-change=\"ctrl.parent.trackEvent(\'inquiryPublishRates\',ctrl.parent.currentCard.meta.isRateGlobal);\" layout=\"row\" \nflex=\"100\" layout-wrap><md-radio-button md-no-ink value=\"Yes\" class=\"md-accent\">Yes</md-radio-button><md-radio-button \nmd-no-ink value=\"No\" class=\"md-accent\">No</md-radio-button></md-radio-group></div></div><div flex=\"50\" flex-xs=\"50\" \nflex-sm=\"50\" layout-align=\"start center\" \nng-if=\"ctrl.parent.getSchedule && ctrl.parent.viewActiveTab == \'schedule\' && ctrl.parent.ifExpireCross\"><div \nclass=\"schedule_warning\">Selected schedule is after expiry date of shown rates. Actual rates may vary.</div></div><div \nflex layout=\"column\" layout-align=\"center end\" ng-if=\"ctrl.parent.quoteEdit\"><md-button \nng-if=\"ctrl.parent.resultfilter.hideBookBtn || ctrl.parent.parentPage !=\'result\'\" md-no-ink class=\"md-accent-btn\" \nstyle=\"margin-right:0px\" title=\"Done\" \nng-disabled=\"!ctrl.parent.currentCard.data.sell_rates || ctrl.parent.footerObj.doneBtnDisable || !ctrl.parent.currentCard.meta.isScheduleCall || ctrl.parent.resultfilter.co2eApiCalled ||  ctrl.parent.footerObj.rateExpired\" \nng-click=\"ctrl.parent.pushToquoteArray(ctrl.parent.currentCard)\"><md-icon \nng-if=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>Done<md-tooltip \nmd-direction=\"top\" \nng-if=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.code == 1002 && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip>\n<md-tooltip md-direction=\"top\" ng-if=\"ctrl.parent.footerObj.rateExpired\">This Rate is expired</md-tooltip></md-button>\n<div layout=\"row\" ng-if=\"!ctrl.parent.resultfilter.hideBookBtn && ctrl.parent.parentPage ==\'result\'\"><div \nng-if=\"ctrl.parent.uidata && ctrl.parent.uidata.integrationStatus && !ctrl.parent.syncShimmer && ctrl.parent.parentPage ==\'result\'\">\n<quote-sync-button integrationoptions=\"ctrl.parent.uidata.integrationComponentOptions\" \ncallback=\"ctrl.parent.syncData($event,submenus,ctrl.parent.currentCard  )\" source=\"\'result\'\"></quote-sync-button></div>\n<md-button \nng-if=\"ctrl.parent.util.navPermission.shipments && ctrl.parent.util.navPermission.shipments[0] && !ctrl.parent.searchFromQuote\" \nmd-no-ink class=\"md-primary-btn mr-10 text-center quote-button\" title=\"Create a Booking\" \nng-disabled=\"!ctrl.parent.currentCard.data.sell_rates || ctrl.parent.footerObj.rateExpired || ctrl.parent.footerObj.doneBtnDisable || !ctrl.parent.currentCard.meta.isScheduleCall || ctrl.parent.resultfilter.co2eApiCalled\" \nng-click=\"ctrl.parent.pushToquoteArray(ctrl.parent.currentCard, \'bookingRequest\')\"><md-icon \nng-if=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon>Create a Booking\n<md-tooltip md-direction=\"top\" ng-if=\"ctrl.parent.footerObj.rateExpired\">This Rate is expired</md-tooltip><md-tooltip \nmd-direction=\"top\" \nng-if=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.code == 1002 && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip>\n</md-button><md-button ng-if=\"ctrl.parent.util.navPermission.quotes[0]\" md-no-ink \nclass=\"md-accent-btn quote-button mr-10\" style=\"margin-right:0px\" title=\"Done\" \nng-disabled=\"!ctrl.parent.currentCard.data.sell_rates || ctrl.parent.footerObj.rateExpired || ctrl.parent.footerObj.doneBtnDisable || !ctrl.parent.currentCard.meta.isScheduleCall || ctrl.parent.resultfilter.co2eApiCalled\" \nng-click=\"ctrl.parent.pushToquoteArray(ctrl.parent.currentCard)\"><md-icon \nng-if=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.code == 1002\" \nmd-svg-src=\"assets/icons/custom/Icon-hourglass-start.svg\" class=\"icon-class-16 glasshour\"></md-icon><span \nclass=\"btn-height\">{{ctrl.parent.searchFromQuote ? \'Done\': \'Create a Quote\'}}</span><md-tooltip md-direction=\"top\" \nng-if=\"ctrl.parent.footerObj.rateExpired\">This Rate is expired</md-tooltip><md-tooltip md-direction=\"top\" \nng-if=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.code == 1002 && ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.display_message\" \nclass=\"font-size-12 white-fg bg-343434 p-10\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.booking_status.display_message}}</md-tooltip>\n</md-button></div></div></div></md-dialog-actions><md-dialog-actions layout=\"row\" \nclass=\"sticky-bottom card_shadow footer-mobile-spacing\" \nng-if=\"ctrl.parent.util.isShipper && ctrl.parent.quotationVisible && (ctrl.parent.viewActiveTab == \'quotation\' || ctrl.parent.viewActiveTab == \'remarksInclusion\' || ctrl.parent.viewActiveTab == \'schedule\')\">\n<div layout=\"row\" flex=\"100\" class=\"pl-10\" layout-wrap ng-if=\"!ctrl.parent.showData\"><div layout=\"column\" flex=\"15\" \nflex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm layout-align=\"center start\"><div class=\"pb-10\">TOTAL COST\n</div><div class=\"font-weight-600\" layout=\"row\">\n{{ctrl.parent.searchUser.user_base_currency}} {{ctrl.parent.footerObj.sellTotalBaseCurr | currencyMask: 2}}<div \nclass=\"pl-5\" ng-if=\"ctrl.parent.search_param.mode == \'SEA-FCL\' && ctrl.parent.currentCard.meta.additional_charges\">\n<span ng-if=\"ctrl.parent.currentCard.meta.additional_charges.data\">\n+ {{ctrl.parent.currentCard.meta.additional_charges.data.leg_currency}} {{ctrl.parent.currentCard.meta.additional_charges.data.leg_currency_cost | currencyMask: 2}}\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"s16 mb-3 grey-600-fg\"><md-tooltip class=\"black-bg\" md-direction=\"top\">\nConvenience fee</md-tooltip></md-icon></span></div><div class=\"pl-15\" ng-if=\"ctrl.parent.footerObj.showConvLoader\">\n<md-progress-circular class=\"md-primary\" md-diameter=\"17\"></md-progress-circular></div></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"grey-fg font-size-11\">\nNOTE: All rates are subject to liner availability</div><div ng-if=\"ctrl.parent.showExchangeRates\"><a \nclass=\"pointer md-link-fg Font-Bold\" \nng-click=\"ctrl.parent.util.redirectToExchangeRatesLink(ctrl.parent.resultType, ctrl.parent.resultId, ctrl.parent.cardVendorId, \'CrtQuote-POP-ViewExchangeRates\',{\'Mode\': ctrl.parent.search_param.mode,\'Type\': ctrl.parent.resultType}, ctrl.parent.activityId)\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div></div><div \nflex layout=\"column\" layout-align=\"center end\" ng-if=\"ctrl.parent.btnShipperBooking\"><md-button md-no-ink \nclass=\"md-accent-btn mr-10\" title=\"Done\" ng-click=\"ctrl.parent.requestToBook(ctrl.parent.currentCard, \'fromModal\')\">\nRequest Booking</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/result/Dialogs/view-details/quotationPopup.html","<div ng-class=\"{\'scroll_tab\' : !ctrl.parent.util.isMobileDevice}\" class=\"mb-20\"><md-content class=\"mb-10\" \nlayout=\"column\" ng-class=\"{\'mb-100\' : ctrl.parent.util.isMobileDevice}\"><div \nclass=\"mh-20 mb-20 buy_sell_rates margin_bottom_7per\" layout=\"column\" flex=\"100\" \nng-if=\"!ctrl.parent.showData && !ctrl.parent.callingConversionApi\"><rate-modification \nsearch-param=\"ctrl.parent.search_param\" source-rate=\"ctrl.parent.sourceRate\" current-card=\"ctrl.parent.currentCard\" \npage-source=\"ctrl.parent.pageSource\" quote-edit=\"ctrl.parent.quoteEdit\" inquiry-pricing=\"ctrl.parent.inquiryPricing\" \nfrom-inquiry=\"ctrl.parent.fromInquiry\" footer-obj=\"ctrl.parent.footerObj\" edit-buy-rate=\"ctrl.parent.editBuyRate\" \nall-in-quote=\"ctrl.parent.all_in_quote\"></rate-modification></div><div shimmer-effect width=\"100%\" height=\"100%\" \nclass=\"white-bg\" ng-if=\"ctrl.parent.showData || ctrl.parent.callingConversionApi\"></div></md-content></div>");
$templateCache.put("app/main/result/Dialogs/view-details/remarks-inclusion-popup.html","<md-content class=\"mb-80\" layout=\"column\" ng-class=\"{\'mb-100\' : ctrl.parent.util.isMobileDevice}\"><div \nclass=\"mh-20 mb-20\" layout=\"column\" flex=\"100\"><div \nng-if=\"!ctrl.parent.util.isShipper && !ctrl.parent.hideInternalRemarks\"><div layout=\"row\" \nclass=\"mt-25 mb-10 headStyle\">Internal Remarks<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mr-10 ml-10 grey-fg pointer pt-2\"><md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\nThis remarks only visible for internal user and will not be printed on Quote PDF</md-tooltip></md-icon></div><div \nlayout=\"row\"><div class=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.currentCard.meta.internal_remarks\" \nng-config=\"ctrl.parent.remarksInclusionCkEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" \nclass=\"mt-25 mb-10 headStyle\">Remarks</div><div layout=\"row\"><div class=\"quote-editor\"><ng-ckeditor \nng-model=\"ctrl.parent.currentCard.meta.remarks\" ng-config=\"ctrl.parent.remarksInclusionCkEditorConfig\"></ng-ckeditor>\n</div></div><div layout=\"row\" class=\"mt-25 mb-15 headStyle\">Inclusions</div><div layout=\"row\" class=\"mb-60\" \nng-class=\"{\'mb-80\' : ctrl.parent.util.isMobileDevice}\"><div class=\"quote-editor\"><ng-ckeditor \nng-model=\"ctrl.parent.currentCard.meta.inclusions\" ng-config=\"ctrl.parent.remarksInclusionCkEditorConfig\">\n</ng-ckeditor></div></div></div></md-content>");
$templateCache.put("app/main/result/Dialogs/view-details/schedulePopup.html","<div shimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" ng-if=\"!ctrl.parent.getSchedule\"></div><div \nng-if=\"ctrl.parent.getSchedule\"><md-content class=\"mb-10\" layout=\"column\"><p class=\"card_text_bold ph-20\" \nng-show=\"ctrl.parent.scheduleList.length\"><span class=\"vendor_name\"><span ng-show=\"!ctrl.parent.maskLiner\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.sub_vendor.sub_vendor_name}} - \n</span><span ng-show=\"ctrl.parent.maskLiner\">Liner - </span></span><span>\n{{ (ctrl.parent.current_schedule.departure_time | datediff) == 0 ? \'this week \': (ctrl.parent.current_schedule.departure_time | datediff) + ((ctrl.parent.current_schedule.departure_time | datediff) == 1 ? \' week\' : \' weeks\') + \' from now\' }} \n</span><span class=\"clear-all ml-30\" ng-if=\"!ctrl.parent.util.isShipper && !ctrl.parent.disableScheduleBtn\" \nng-click=\"ctrl.parent.fnClearAllSchedule()\">Clear All</span></p><div layout=\"row\" layout-wrap class=\"ph-20 mb-30\" \nng-if=\"ctrl.parent.scheduleList.length\"><div layout=\"column\" layout-align=\"start start \" flex=\"100\" flex-gt-xs=\"40\" \nclass=\"p-0 scroll\" \nng-style=\"{\'height\': ctrl.parent.scheduleDivHeight ? ctrl.parent.scheduleDivHeight - 250 +\'px\' : \'700px\'}\"><div \nng-repeat=\"schedule in  ctrl.parent.scheduleList track by $index\" class=\"width-96-per\" layout=\"row\"><div \nclass=\"mt-10 mr-15 mb-50\" layout=\"column\" layout-align=\"center center \" \nng-if=\"!ctrl.parent.util.isShipper && !ctrl.parent.disableScheduleBtn\"><input type=\"checkbox\" \nng-model=\"schedule.isSelected\" ng-change=\"ctrl.parent.selectMultiSchedule(schedule)\" class=\"s18\"></div><div \nclass=\"outer mv-10 mb-50 pointer\" ng-click=\"ctrl.parent.setCurrentSchedule(schedule, $index)\" \nng-class=\"{\'outer_container single-select-bg\' : ctrl.parent.current_schedule.id == schedule.id , \'multi-select-bg\': schedule.isSelected } \">\n<div layout=\"row pt-15\"><div layout=\"row\" flex=\"90\" layout-wrap layout-align=\"center center\" \nclass=\"font-size-14 font-weight-600 pt-15 ph-10\">{{schedule.transit_time}} <span ng-if=\"!ctrl.parent.maskLiner\">\n-{{schedule.service_name}}</span></div><div ng-if=\"ctrl.parent.current_schedule.id == schedule.id\" layout=\"row\" \nlayout-wrap layout-align=\"end end\" class=\"mh-5\"><md-icon md-font-icon=\"icon-check\"></md-icon></div></div><div \nlayout=\"row\" layout-wrap class=\"ph-15 pv-10 font-size-12-mob\"><div layout=\"column\" layout-align=\"center start\" \nflex=\"30\" flex-gt-xs=\"30\"><p class=\"font-size-14 font-weight-600 mv-5\">{{schedule.origin_port}}</p><p \nclass=\"font-size-14 m-0\">{{ schedule.departure_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"30\" flex-gt-xs=\"30\" class=\"text-center mh-5\"><p class=\"font-size-12 m-0 pt-10\"><span\n class=\"grey-fg\" ng-hide=\"schedule.schedule_track.length < 3\">via</span><br><span class=\"font-size-12 md-link-fg\">\n{{schedule.via_port}}</span></p></div><div layout=\"column\" layout-align=\" center end\" flex=\"30\" flex-gt-xs=\"30\"><p \nclass=\"font-size-14 font-weight-600 mv-5\">{{schedule.destination_port}}</p><p class=\"font-size-14 m-0 text-right\">\n{{ schedule.arrival_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div></div></div></div></div><div layout=\"column\" \nflex=\"100\" flex-gt-xs=\"60\"><div class=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"60\" ng-if=\"ctrl.parent.current_schedule.schedule_track.length > 0\"><div layout=\"column\" class=\"ph-15\" \nng-repeat=\"schedule_track in ctrl.parent.current_schedule.schedule_track track by $index\"><div layout=\"row\" \nclass=\"show_schedule\" ng-class=\"{\'pt-5\' : $first}\" ng-if=\"$first || $last\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80 schedule_track_margin\" ng-if=\"!$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\" ng-if=\"$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></p><div class=\"port-details-responsive\"><span><md-icon \nclass=\"icon-class\" md-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>\n{{ schedule_track.port_name }}</span></div><p></p><div layout=\"column\" class=\"pb-20 port-details-responsive\" \nng-if=\"!$last && !ctrl.parent.maskLiner\"><div layout=\"row\" ng-if=\"ctrl.parent.search_param.mode === \'SEA-LCL\'\"><div \nclass=\"track_text\" flex>CFS Cutoff</div><div class=\"track_text eta_div\" flex><span \nng-repeat=\"deadline in ctrl.parent.current_schedule.deadlines\" ng-if=\"deadline.name === \'CFS Closing\'\">\n{{deadline.date ? (deadline.date | UTCToLocal : \'d MMM, yyyy\') : \'NA\'}}</span></div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.service_name != \"\" ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vessel != \"\" ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" \nflex>Voyage Ref.</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.voyage != \"\" ? schedule_track.voyage : \'NA\'}}</div></div></div></div></div><div layout=\"row\" \nng-if=\"(!$first && !$last)\" class=\"mv-20\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></p><div class=\"port-details-responsive\"><span><md-icon \nclass=\"icon-class\" md-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>\n{{ schedule_track.port_name }} </span><span>(Arrival)</span></div><p></p></div></div><div layout=\"row\" \nng-if=\"(!$first && !$last)\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\"><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p \nclass=\"font-size-12 mv-5 mh-0 text-end\">{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p \nclass=\"font-size-10 mv-5 mh-0 grey-fg text-end\">{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}\n</p></div><div flex-md=\"80\" flex-sm=\"80\" flex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p \nclass=\"card_text_bold source_name\"><md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon></p><div \nclass=\"port-details-responsive\"><span><md-icon class=\"icon-class\" md-svg-src=\"assets/icons/custom/icon-ship.svg\" \nclass=\"\"></md-icon></span><span>{{ schedule_track.port_name }} </span><span>(Departure)</span></div><p></p><div \nlayout=\"column\" class=\"pb-20 port-details-responsive\" ng-if=\"!$last && !ctrl.parent.maskLiner\"><div layout=\"row\" \nng-if=\"ctrl.parent.search_param.mode === \'SEA-LCL\'\"><div class=\"track_text\" flex>CFS Cutoff</div><div \nclass=\"track_text eta_div\" flex><span ng-repeat=\"deadline in ctrl.parent.current_schedule.deadlines\" \nng-if=\"deadline.name === \'CFS Closing\'\">{{deadline.date ? (deadline.date | UTCToLocal : \'d MMM, yyyy\') : \'NA\'}}</span>\n</div></div><div layout=\"row\"><div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.service_name != \"\" ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vessel != \"\" ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" \nflex>Voyage Ref.</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.voyage != \"\" ? schedule_track.voyage : \'NA\'}}</div></div></div></div></div></div></div><div \nclass=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552 grey-100-bg grey-600-fg\" layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" \nng-if=\"!ctrl.parent.current_schedule.schedule_track &&  !ctrl.parent.multi_schedule_list.length\"><div>\nNo schedule has been selected.</div><div>Please select the schedule from the list.</div></div><div \nclass=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552 grey-100-bg grey-600-fg\" layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" \nng-if=\"!ctrl.parent.current_schedule.schedule_track && ctrl.parent.multi_schedule_list.length\"><div class=\"errorMsg\">\nPlease select one schedule from the selected list to proceed further.</div></div><div layout=\"column\" flex=\"100\" hide>\n<md-button md-no-ink class=\"md-primary-btn\" title=\"Done\" \nng-click=\"ctrl.parent.selectedSchedule(ctrl.parent.current_schedule)\" ng-disabled=\"ctrl.parent.disableScheduleBtn\">\nAdd Schedule Track</md-button></div></div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap \nclass=\"ph-20\" ng-if=\"!ctrl.parent.scheduleList.length\"><h2>Sorry, No schedules available.</h2></div></md-content></div>");
$templateCache.put("app/main/result/Dialogs/view-details/slab-fcl.html","<div id=\"slab-fcl\" class=\"mt-20\"><div class=\"ph-20\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" \nlayout=\"column\"><div><md-content class=\"border mv-20\" ng-repeat=\"slabData in ctrl.parent.fclSlab track by $index\">\n<table class=\"simple\" ms-responsive-table><thead><tr><th class=\"table-header\" colspan=\"2\"><div><div \nclass=\"font-size-11\">{{slabData.leg_name}}</div><span class=\"font-size-16 black-fg\">\n{{slabData.charge_name}} - {{slabData.load_type}}</span></div></th></tr><tr><th class=\"font-size-13 black-fg br\">\nWeight Range - KG</th><th class=\"font-size-13 black-fg\">Amount</th></tr></thead><tbody \nng-repeat=\"slabrange in slabData.slab track by $index\"><tr ng-class=\"{\'selected-color\':slabrange.selected}\"><td \nclass=\"br font-size-11\"><span ng-class=\"{\'pl-20\':(!slabrange.selected)}\"><md-icon ng-if=\"slabrange.selected\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"light-blue-400-fg s12 mb-2 mr-5\"></md-icon></span><span>\n{{slabrange.from | currencyMask: 2 }} - {{slabrange.to | currencyMask: 2}}</span></td><td class=\"font-size-11\">\n{{slabData.currency}} {{slabrange.cost | currencyMask: 2}}</td></tr></tbody></table></md-content></div></div></div>\n</div>");
$templateCache.put("app/main/result/Dialogs/view-details/xenetaNoRatesPopup.html","<md-dialog class=\"ViewModal popup-lg rate-card-detail-modal\"><div layout=\"row\" layout-padding class=\"header\" \nflex=\"100\"><div flex=\"90\" class=\"p-0\" flex-xs=\"90\">Rate Index</div><div layout=\"row\" class=\"p-0\" \nlayout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size fg-AAA8AD\"><md-icon \nmd-font-icon=\"icon-close m-3 fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialogXeneta()\"></md-icon></div></div>\n<md-dialog-content class=\"p-0\"><xeneta-rate-index rate-index-data=\"ctrl.parent.xenetadata.meta.xenetaRateArray\">\n</xeneta-rate-index></md-dialog-content></md-dialog>");
$templateCache.put("app/main/result/bookShipment/dialogs/party-modal.html","<md-dialog id=\"party-modal\" class=\"popup-md\"><md-toolbar class=\"white-bg black-fg\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\"><span class=\"text-case\">\n{{ctrl.parent.editPartyModalAction}} {{ctrl.parent.partyTitle}} </span><br></div><md-button md-no-ink \nclass=\"md-icon-button p-o\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"grey-500-fg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"partyForm\">\n<md-dialog-content class=\"body\"><div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><span>Company</span><br><md-input-container md-no-float class=\"w-100p mt-6-imp w-100p mb-20\">\n<md-autocomplete class=\"panel-select\" ng-class=\"{\'validation-error\':ctrl.parent.companyValidationError}\" \nmd-input-name=\"company\" md-selected-item=\"ctrl.parent.searchPartyData\" \nmd-selected-item-change=\"ctrl.parent.setPartyDetails(ctrl.parent.searchPartyData, ctrl.parent.editParty, ctrl.parent.editPartyModalAction, ctrl.parent.booking_data.search_param.mode)\" \nmd-search-text=\"ctrl.parent.editParty.company_name\" \nmd-search-text-change=\"ctrl.parent.onCompanyTextChange(ctrl.parent.editParty.company_name)\" \nmd-items=\"item in ctrl.parent.getCompanyList(ctrl.parent.editParty.company_name, ctrl.parent.editParty.category)\" \nmd-item-text=\"item.company_name\" md-no-cache=\"true\" md-delay=\"300\" md-min-length=\"1\" \nplaceholder=\"{{ctrl.parent.canCreateNewCompany(ctrl.parent.editParty.category) ? \'Type company name or select from dropdown\' : \'Select company from dropdown\'}}\" \nmd-menu-class=\"autocomplete-custom-template\" \nmd-require-match=\"!ctrl.parent.canCreateNewCompany(ctrl.parent.editParty.category)\" md-clear-button=\"false\" \nmd-escape-options=\"blur\" \nng-keyup=\"ctrl.parent.companyValidationError=false;ctrl.parent.emailValidationError=false;ctrl.parent.emailPatternValidation=false\" \nmd-input-id=\"company_name\" ng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\"><md-item-template><span \nclass=\"item-metadata\" title=\"{{item.company_name}}\">{{item.company_name}}</span></md-item-template><md-not-found \nng-if=\"ctrl.parent.canCreateNewCompany(ctrl.parent.editParty.category)\">\nNo company matching \"{{ctrl.parent.editParty.company_name}}\" found. You can continue with this name to create a new company.\n</md-not-found><md-not-found ng-if=\"!ctrl.parent.canCreateNewCompany(ctrl.parent.editParty.category)\">\nNo company matching \"{{ctrl.parent.editParty.company_name}}\" found. Please select from existing companies only.\n</md-not-found></md-autocomplete><div ng-if=\"ctrl.parent.companyValidationError\" class=\"validation-error-text\"><span>\nCompany Name is required.</span></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nclass=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Name</span><br><md-input-container \nmd-no-float class=\"w-100p mt-6-imp input_container_width ph-0\"><input name=\"name\" type=\"text\" \nng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" class=\"panel-select md-input-focused\" \nng-class=\"{\'validation-error\':ctrl.parent.nameValidationError}\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-model=\"ctrl.parent.editParty.name\" placeholder=\"Enter Name\" ng-keyup=\"ctrl.parent.nameValidationError=false\" \nid=\"customer_name\"><div ng-if=\"ctrl.parent.nameValidationError\" class=\"validation-error-text\"><span>Name is required.\n</span></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"mobile-spacing feild-spacing\"><span>\nEmail ID</span><br><md-input-container md-no-float class=\"w-100p mt-6-imp input_container_width ph-0\"><input \nname=\"email\" type=\"email\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \nng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" class=\"panel-select md-input-focused\" \nng-class=\"{\'validation-error\':ctrl.parent.emailValidationError}\" ng-model=\"ctrl.parent.editParty.email\" \nng-pattern=\"ctrl.parent.util.emailRegex\" placeholder=\"Enter Email ID\" \nng-keyup=\"ctrl.parent.emailValidationError=false\" id=\"customer_email\"><div \nng-if=\"ctrl.parent.emailValidationError && !partyForm.email.$error.pattern\" class=\"validation-error-text\"><span>\nEnter a valid Email Id</span></div><div ng-messages=\"partyForm.email.$error\" role=\"alert\"><div ng-message=\"pattern\">\n<span>Enter a valid Email Id</span></div></div></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"group-spacing\"><div flex=\"50\" flex-xs=\"100\"><div>Other Details <span class=\"sub-text\">( optional )</span></div>\n</div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><span>Phone</span><br><md-input-container md-no-float \nclass=\"w-100p mt-6-imp input_container_width ph-0\"><input class=\"tel-input panel-select md-input-focused\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \ntype=\"tel\" ng-model=\"ctrl.parent.editParty.contact\" placeholder=\"Phone Number\" \nng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" name=\"contact\" ng-maxlength=\"40\"><div \nng-messages=\"partyForm.contact.$error\" class=\"validation-error-text\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"mobile-spacing feild-spacing\"><span>Street Address</span><br><md-input-container md-no-float \nclass=\"w-100p mt-6-imp input_container_width ph-0\"><input name=\"address\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \ntype=\"text\" ng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.editParty.address\" placeholder=\"Enter Street Address\"></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"mobile-spacing feild-spacing\"><span>Point of Contact</span><br><md-input-container md-no-float \nclass=\"w-100p mt-6-imp input_container_width ph-0\"><input name=\"point_of_contact\" \nng-model-options=\"{ updateOn: \'default blur onchange\', debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 } }\" \ntype=\"text\" ng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.editParty.point_of_contact\" placeholder=\"Point of Contact\"></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Reference ID</span><br><md-input-container md-no-float \nclass=\"w-100p mt-6-imp input_container_width ph-0\" \nng-class=\"{\'panel-select-disabled\':ctrl.parent.editParty.company_id}\"><input name=\"iec_number\" type=\"text\" \nng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.editParty.iec_number\" placeholder=\"Enter Reference ID\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" \nng-disabled=\"ctrl.parent.editParty.company_id\"><div ng-messages=\"partyForm.iec_number.$error\" role=\"alert\"><div \nng-message=\"pattern\" class=\"validation-error-text\"><span>Reference ID is invalid.</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" \nflex-xs=\"100\" class=\"mobile-spacing feild-spacing\"><span>Country</span><br><div shimmer-effect-full width=\"100%\" \nheight=\"30px\" class=\"mt-15\" ng-if=\"ctrl.parent.isDataLoading\" ng-repeat=\"shimmer in [1]\"></div><md-input-container \nclass=\"full-width\" md-no-float ng-if=\"!ctrl.parent.isDataLoading\"><md-select class=\"panel-select\" \nng-model=\"ctrl.parent.editParty.country\" ng-change=\"ctrl.parent.countrySelected(ctrl.parent.editParty.country)\" \nplaceholder=\"Country\" md-on-close=\"searchCountry = \'\'\"><md-select-header><input ng-model=\"searchCountry\" type=\"search\" \nplaceholder=\"Search Country\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"country in ctrl.parent.countryList  | orderBy:\'country_name\' | filter : {country_name : searchCountry}\" \nng-value=\"country.country_name\">{{country.country_name}}</md-option></md-select></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" class=\"mobile-spacing feild-spacing\"><span>State</span><br><div shimmer-effect-full \nwidth=\"100%\" height=\"30px\" class=\"mt-15\" ng-if=\"$ctrl.isDataLoading\" ng-repeat=\"shimmer in [1]\"></div>\n<md-input-container class=\"full-width\" md-no-float ng-if=\"!$ctrl.isDataLoading\"><md-select class=\"panel-select\" \nng-disabled=\"!ctrl.parent.stateList.length\" ng-class=\"{\'panel-select-disabled\':!ctrl.parent.stateList.length}\" \nng-model=\"ctrl.parent.editParty.state\" placeholder=\"State\" md-on-close=\"searchStates = \'\'\"><md-select-header><input \nng-model=\"searchStates\" type=\"search\" placeholder=\"Search States\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"state in ctrl.parent.stateList | orderBy:\'state_name\' | filter : {state_name : searchStates}\" \nng-value=\"state.state_name\">{{state.state_name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"mobile-spacing feild-spacing\"><span>City</span><br><md-input-container md-no-float \nclass=\"w-100p mt-6-imp input_container_width ph-0\"><input name=\"city\" type=\"text\" \nng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.editParty.city\" placeholder=\"Enter City\"></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><span>Zip Code/ Postal Code</span><br><md-input-container md-no-float \nclass=\"w-100p mt-6-imp input_container_width ph-0\"><input name=\"postal_code\" \nng-pattern=\"/[A-Za-z0-9][A-Za-z0-9\\- ]{0,10}[A-Za-z0-9]$/\" type=\"text\" \nng-readonly=\"ctrl.parent.editPartyModalAction === \'View\'\" class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.editParty.postal_code\" placeholder=\"Enter Postal Code\"></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout-align=\"space-between center\" layout-xs=\"column\"><div \nflex=\"40\" flex-xs=\"100\" layout-align=\"start center\" class=\"ml-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"ctrl.parent.editParty.send_notification\" class=\"md-primary mb-0\" \nng-disabled=\"ctrl.parent.editPartyModalAction === \'View\'\">Send Notification</md-checkbox></div><div layout=\"row\" \nflex=\"60\" flex-xs=\"100\" class=\"mv-10\" layout-align=\"end center\" ng-if=\"ctrl.parent.editPartyModalAction !== \'View\'\">\n<md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(ctrl.parent.editParty.category, ctrl.parent.editPartyModalAction, ctrl.parent.booking_data.search_param.mode)\">\nCancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10 mr-20\" type=\"submit\" \nng-click=\"ctrl.parent.fnSaveParty(partyForm)\">{{ctrl.parent.editPartyModalAction == \'Add\' ? \'Save\' : \'Update\'}}\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/roles/agents/filter-agent/filter-agent.html","<div id=\"filter-agent\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon mr-10\"></md-icon><span \nclass=\"font-size-16 Font-Bold grey-fg\" flex>Filters </span><span \nclass=\"font-size-13 pointer md-link-fg font-weight-600 pointer\" ng-click=\"vm.clearFilter()\">Clear All</span></div>\n<md-divider></md-divider><div class=\"content no-padding\"><div shimmer-effect-full width=\"95%\" height=\"30px\" mh=\"10px\" \nclass=\"mv-20\" ng-if=\"vm.filterLoader\" ng-repeat=\"shimmer in [1,2,3,4,5,6,7,8,9]\"></div><md-list class=\"no-padding\">\n<md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex \nclass=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-10\"><div><span \nclass=\"font-size-14 font-weight-600\">Agent Name </span><span ng-if=\"vm.agentFilterConditions.selectedCount\" \nclass=\"filter-count md-component-bg white-fg\">{{vm.agentFilterConditions.selectedCount}}</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><div id=\"agentDetails\" \nclass=\"w-150-f\"><multi-select-chips md-input-id=\"\'agent_id\'\" options-data-obj=\"vm.filterobj.agent_name\" \nquery-conditions=\"vm.agentFilterConditions\" callback=\"vm.callBackAgentSearch(payload)\"></multi-select-chips></div>\n</div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-5\">\n<div><span class=\"font-size-14 font-weight-600\">Date Range</span><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mb-2 grey-fg pointer\"><md-tooltip md-direction=\"right\" md-delay=\"300\">Created On</md-tooltip></md-icon><span\n ng-if=\"vm.filterobj.date_range.from || vm.filterobj.date_range.to\" class=\"filter-count md-component-bg white-fg\">1\n</span></div></div><div layout-align=\"space-between center\" flex class=\"searchbox-outline mb-15\"><date-range-picker \nmd-input-id=\"\'agent_date_range\'\" callback=\"vm.setDatePicker(date)\" date-range-value=\"vm.filterobj.date_range\" \nis-reset-date-picker=\"vm.agentfilterdata.isResetFilter\"></date-range-picker></div></div></md-list-item></md-list></div>\n</div>");
$templateCache.put("app/main/roles/charges/filter-charge/filter-charge.html","<div id=\"filter-charge\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon mr-10\"></md-icon><span \nclass=\"font-size-16 Font-Bold grey-fg\" flex>Filters </span><span \nclass=\"font-size-13 pointer md-link-fg font-weight-600 pointer\" ng-click=\"vm.clearFilter()\">Clear All</span></div>\n<md-divider></md-divider><div class=\"content no-padding\"><div shimmer-effect-full width=\"95%\" height=\"30px\" mh=\"10px\" \nclass=\"mv-20\" ng-if=\"vm.filterLoader\" ng-repeat=\"shimmer in [1,2,3,4,5,6,7,8,9]\"></div><md-list class=\"no-padding\">\n<md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex \nclass=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-10\"><div><span \nclass=\"font-size-14 font-weight-600\">Charge Name</span> <span ng-if=\"vm.chargeFilterConditions.selectedCount\" \nclass=\"filter-count md-component-bg white-fg\">{{vm.chargeFilterConditions.selectedCount}}</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><div id=\"chargeDetails\" \nclass=\"w-150-f\"><multi-select-chips md-input-id=\"\'charge_id\'\" options-data-obj=\"vm.filterobj.charge_name\" \nquery-conditions=\"vm.chargeFilterConditions\" callback=\"vm.callBackChargeSearch(payload)\"></multi-select-chips></div>\n</div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\">\n<div><span class=\"font-size-14 font-weight-600\">Charge Type</span> <span ng-if=\"vm.selectedChargeType\" \nclass=\"filter-count md-component-bg white-fg\">1</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><md-select ng-model=\"vm.selectedChargeType\" \nplaceholder=\"Select Charge Type\" ng-change=\"vm.setChargeTypeFilter(vm.selectedChargeType)\" class=\"w-100\"><md-option \nng-value=\"null\">All</md-option><md-option ng-repeat=\"option in vm.filterobj.charge_type_options\" \nng-value=\"option.value\">{{option.label}}</md-option></md-select></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">\nCalculation Type</span> <span ng-if=\"vm.selectedCalculationType\" class=\"filter-count md-component-bg white-fg\">1</span>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><md-select \nng-model=\"vm.selectedCalculationType\" placeholder=\"Select Calculation Type\" \nng-change=\"vm.setCalculationTypeFilter(vm.selectedCalculationType)\" class=\"w-100\"><md-option ng-value=\"null\">All\n</md-option><md-option ng-repeat=\"option in vm.filterobj.calculation_type_options\" ng-value=\"option.value\">\n{{option.label}}</md-option></md-select></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">Default Basis\n</span> <span ng-if=\"vm.selectedDefaultBasis\" class=\"filter-count md-component-bg white-fg\">1</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><md-select \nng-model=\"vm.selectedDefaultBasis\" placeholder=\"Select Default Basis\" \nng-change=\"vm.setDefaultBasisFilter(vm.selectedDefaultBasis)\" class=\"w-100\"><md-option ng-value=\"null\">All</md-option>\n<md-option ng-repeat=\"option in vm.filterobj.default_basis_options\" ng-value=\"option.value\">{{option.label}}\n</md-option></md-select></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">Mode</span> \n<span ng-if=\"vm.selectedMode\" class=\"filter-count md-component-bg white-fg\">1</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><md-select ng-model=\"vm.selectedMode\" \nplaceholder=\"Select Mode\" ng-change=\"vm.setModeFilter(vm.selectedMode)\" class=\"w-100\"><md-option ng-value=\"null\">All\n</md-option><md-option ng-repeat=\"option in vm.filterobj.mode_options\" ng-value=\"option.value\">{{option.label}}\n</md-option></md-select></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">Status</span> \n<span ng-if=\"vm.selectedStatus\" class=\"filter-count md-component-bg white-fg\">1</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><md-radio-group ng-model=\"vm.selectedStatus\">\n<md-radio-button ng-click=\"vm.setStatusFilter(\'ACTIVE\')\" ng-value=\"\'ACTIVE\'\" class=\"md-primary checkbox-margin\">Active\n</md-radio-button><md-radio-button ng-click=\"vm.setStatusFilter(\'INACTIVE\')\" ng-value=\"\'INACTIVE\'\" \nclass=\"md-primary checkbox-margin\">Inactive</md-radio-button></md-radio-group></div></div></md-list-item></md-list>\n</div></div>");
$templateCache.put("app/main/roles/component/exportMultiUsers/export-multi-users.html","<md-toolbar class=\"modal_title\"><div layout-align=\"space-between center\" class=\"md-toolbar-tools\"><div>\n{{ $ctrl.exportdata.formHeadTitle }}<div class=\"font-size-11 fg-AAA8AD font-weight-200 h-15\" \nng-if=\"$ctrl.exportdata.formSubTitle\">{{ $ctrl.exportdata.formSubTitle }}</div></div><span flex></span><md-button \nmd-no-ink class=\"md-icon-button import-close-icon\" ng-click=\"$ctrl.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" flex><md-content flex \nclass=\"content p-20\"><div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\"><md-radio-group \nlayout=\"column\" flex flex-xs=\"100\" ng-model=\"$ctrl.limit\"><md-radio-button md-no-ink \nvalue=\"{{$ctrl.exportdata.totalLength}}\" class=\"md-primary\"><div>Entire Set<div class=\"sub-text\">\n({{$ctrl.exportdata.totalLength}} Customers)</div></div></md-radio-button><md-radio-button md-no-ink \nng-disabled=\"$ctrl.exportdata.totalLength == $ctrl.exportdata.count\" \nvalue=\"{{ $ctrl.exportdata.totalLength == $ctrl.exportdata.count ?\n			$ctrl.exportdata.count + 1 : $ctrl.exportdata.count\n			}}\" \nclass=\"md-primary\"><div>As per Filter Scope<div class=\"sub-text\">({{ $ctrl.exportdata.count }} Customers )</div></div>\n</md-radio-button></md-radio-group></div><div flex=\"50\"><div layout=\"row\" layout-align=\"center center\" flex=\"100\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label class=\"mr-10\">File Type</label><md-input-container class=\"input_container\" \nmd-no-float><md-select class=\"panel-select panel-select-disabled\" ng-model=\"$ctrl.exportSelectedType\" \nng-disabled=\"true\"><md-option ng-value=\"option.value\" ng-repeat=\"option in $ctrl.exportTypeList track by $index\">\n{{option.label}}</md-option></md-select></md-input-container></div></div></div></div></md-content></div>\n<md-dialog-actions layout=\"row\" class=\"p-20\"><div layout=\"row\" flex=\"100\"><div layout-align=\"start center\" flex=\"60\" \nlayout-wrap class=\"fg-footer-text\">\nThe data export will run in the background and be saved as per browser configuration. Runtime depends on number of selected data. Please check your download folder.\n</div><div flex=\"40\" layout-align=\"end center \" class=\"end-items-export\" flex><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"$ctrl.cancelDialog();$ctrl.fnTrackAnalytics(\'Cancel-Click\')\" title=\"Cancel\">\nCancel</md-button><button class=\"md-accent-btn import-upload-btn md-button md-custom-theme\" \nng-if=\"!$ctrl.isDownloading\" ng-click=\"$ctrl.fnSendEmportMultiUsers()\" type=\"submit\">Export</button> <button \nclass=\"md-accent-btn md-button md-custom-theme\" ng-if=\"$ctrl.isDownloading\"><md-icon md-font-icon=\"icon-replay\" \nclass=\"file-upload-loader\"></md-icon></button></div></div></md-dialog-actions>");
$templateCache.put("app/main/roles/component/import-file-status-bar/import-file-status-bar.html","<div id=\"import-file-status-bar\"><div ng-repeat=\"fileStatus in  $ctrl.importstatusobj track by $index\"><div \nclass=\"mt-10 alert-success\" ng-if=\"fileStatus.status ==  \'COMPLETED\'\" role=\"alert\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div><strong class=\"mr-5 font-size-10 s15\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></strong><span ng-if=\"!fileStatus.responseFrom\" \nclass=\"font-size-13\">{{fileStatus.count.processed - fileStatus.count.failed}} records has been imported successfully \n<span ng-if=\"fileStatus.count.failed >  0\">and {{fileStatus.count.failed}} records imported has failed </span>from \n<strong>{{ fileStatus.requestFileName }}</strong>. <a \nng-href=\"{{ $ctrl.util.sanitizeQueryParams(fileStatus.responseFileUrl) }}\" download=\"{{ fileStatus.requestFileName }}\" \nclass=\"cursor\" ng-if=\"fileStatus.count.failed >  0\"><u>Download here to view the error records</u>. </a></span><span \nng-if=\"fileStatus.responseFrom ==\'QUOTES\'\" class=\"font-size-13 pt-5\">{{fileStatus.message}}</span></div><div><md-icon \nmd-font-icon=\"icon-close\" ng-click=\"$ctrl.callback({requestId: fileStatus.requestId,index:$index})\" \nclass=\"black-fg cursor\"></md-icon></div></div></div><div class=\"mt-10 alert-danger\" role=\"alert\" \nng-if=\"fileStatus.status ==  \'FAILED\'\"><div flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><strong \nclass=\"mr-5 font-size-10\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon></strong><span \nng-if=\"!fileStatus.responseFrom\" class=\"font-size-13\">{{fileStatus.count.total}} records imported has failed from \n<strong>{{ fileStatus.requestFileName }}. </strong><a \nng-href=\"{{ $ctrl.util.sanitizeQueryParams(fileStatus.responseFileUrl) }}\" download=\"{{ fileStatus.requestFileName }}\" \nclass=\"cursor\"><u>Download the file to view the errors</u>. </a></span><span \nng-if=\"fileStatus.responseFrom ==\'QUOTES\'\" class=\"font-size-13 pt-5\">{{fileStatus.message}}</span></div><div><md-icon \nmd-font-icon=\"icon-close\" ng-click=\"$ctrl.callback({requestId: fileStatus.requestId,index:$index})\" \nclass=\"black-fg cursor\"></md-icon></div></div></div></div></div>");
$templateCache.put("app/main/roles/component/import-file-status-bar/import-file-success-message.html","<div id=\"response-status-bar\"><div class=\"mt-10 alert-success\" ng-if=\"vm.totalRecordsImported != null\" role=\"alert\">\n<div flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><strong class=\"mr-5 font-size-10\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon></strong><span class=\"font-size-13\">{{ vm.totalRecordsImported }}</span></div>\n</div></div></div>");
$templateCache.put("app/main/roles/component/importMultiUsers/import-multi-users.html","<md-toolbar class=\"modal_title\"><div layout-align=\"space-between center\" class=\"md-toolbar-tools\"><div>\n{{ $ctrl.importdata.formHeadTitle }}<div class=\"font-size-11 fg-AAA8AD font-weight-200 h-15\" \nng-if=\"$ctrl.importdata.formSubTitle\">{{ $ctrl.importdata.formSubTitle }}</div></div><span flex></span><md-button \nmd-no-ink class=\"md-icon-button import-close-icon\" ng-click=\"$ctrl.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><form name=\"imuForm\" \nng-submit=\"$ctrl.fnSendImportMultiUsers(imuForm)\"><div layout=\"row\" flex><md-content flex class=\"content p-20\"><div \nlayout=\"column\"><div flex=\"100\" class=\"mt-10 mb-15 m-5\" layout-xs=\"column\" layout-sm=\"column\" \nng-if=\"$ctrl.importdata.importType == \'users\'\"><div flex=\"\" class=\"font-size-13\" layout=\"column\" ng-cloak><label \nclass=\"mb-6-imp font-size-13\">Select User Role</label><md-input-container md-no-float \nclass=\"mt-5 pl-0 md-custom-theme mb-0\"><md-select id=\"user_role\" ng-model=\"$ctrl.imuFormObj.selectRolesList\" \nclass=\"mv-0 w-50-imp panel-select\" name=\"user_role\" ng-class=\"{\'validation-error\':$ctrl.validationObj.roleValidation}\" \nmd-on-open=\"$ctrl.validationObj.roleValidation=false\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-UserRole-Change\',{\'Value\':$ctrl.imuFormObj.selectRolesList ,\'SearchQuery\': searchRole ,})\" \nplaceholder=\"Select Customer\" md-no-asterisk required=\"\"><md-select-header class=\"demo-select-header\"><input \ntype=\"search\" ng-model=\"searchRole\" placeholder=\"Search Customer\" ng-keydown=\"$event.stopPropagation()\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><label class=\"role_type_label\">\nInternal User</label><md-optgroup label=\"Internal User\"><md-option \nng-repeat=\"role in $ctrl.util.rolesListObj.forwarderRoleList | filter:{\'name\':searchRole}\" ng-value=\"role.id\" \nng-click=\"$ctrl.fnImportUserRole(role.created_for)\">{{ role.name }}</md-option></md-optgroup><label \nclass=\"role_type_label\">Customers</label><md-optgroup label=\"Customers\"><md-option \nng-repeat=\"role in $ctrl.util.rolesListObj.shipperRoleList | filter:{\'name\':searchRole}\" ng-value=\"role.id\" \nng-click=\"$ctrl.fnImportUserRole(role.created_for)\">{{ role.name }}</md-option></md-optgroup></md-select>\n</md-input-container><div ng-if=\"$ctrl.validationObj.roleValidation\" class=\"mt-3 validation-error-text\"><span>\nSelect the Role Type</span></div></div><div flex=\"\" class=\"pt-15 font-size-13\" layout=\"column\" \nng-if=\"$ctrl.searchCompanyPanelShow\"><label class=\"mb-6 font-size-13\">Select Customer Company</label>\n<md-input-container md-no-float class=\"mt-5 pl-0 md-custom-theme mb-0\"><md-select id=\"shipper_company\" \nng-model=\"$ctrl.imuFormObj.selectedCompany\" class=\"mv-0 w-50-imp panel-select mt-5\" name=\"shipper_company\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.companyValidation}\" \nmd-on-open=\"$ctrl.validationObj.companyValidation=false\" placeholder=\"Select Shipper Company\" \nng-click=\"$ctrl.fnclickCompany();\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-ShipperCompany-Change\',{\'Value\':$ctrl.imuFormObj.selectedCompany.company_name ,\'SearchQuery\': searchCompany })\" \nmd-no-asterisk><md-select-header><input ng-model=\"searchCompany\" ng-model-options=\"{debounce: 500}\" type=\"search\" \nplaceholder=\"Search Shipper Company\" ng-change=\"$ctrl.getCompanyList(searchCompany)\" \nng-keydown=\"$event.stopPropagation()\" md-min-length=\"2\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><div layout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" class=\"mv-20 pt-10\" \nng-if=\"$ctrl.listLoader\"><md-progress-circular></md-progress-circular></div><md-optgroup label=\"shipperCompanyList\">\n<md-option ng-repeat=\"company in $ctrl.util.shipperCompanyObj | filter:searchCompany\" ng-value=\"company\">\n{{ company.company_name }}</md-option></md-optgroup><div ng-if=\"$ctrl.util.shipperCompanyObj.length === 0\" \nclass=\"no_rsult_found\"><span class=\"font-size-13\">No Result</span></div><div id=\"add-new-company\" class=\"cursor\" \nng-click=\"$ctrl.fnAddNewCompany();$ctrl.util.callMixpanel(\'User-Import-AddShipperCompany-Click\')\"><span \nclass=\"font-size-13 sky-blue-fg font-weight-600\"><md-icon md-font-icon=\"icon-plus\" class=\"sky-blue-fg\"></md-icon>\nAdd new company</span></div></md-select></md-input-container><div ng-if=\"$ctrl.validationObj.companyValidation\" \nclass=\"mt-5 validation-error-text\"><span class=\"pt-3\">Select Company</span></div></div></div><div flex=\"100\" \nclass=\"pt-10 new_compnay_panel font-size-13\" layout-xs=\"column\" layout-sm=\"column\" \nng-if=\"$ctrl.importdata.importType === \'users\' && $ctrl.newCompanyPanelShow\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><label class=\"font-size-13 font-weight-600\">Enter New Company Details</label><label\n class=\"font-size-13 cursor font-weight-600 sky-blue-fg add-new-company-text\" ng-click=\"$ctrl.fnExistingCompany();\">\nSelect from existing list</label></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div \nlayout=\"column\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\"><label class=\"mb-6-imp\">Enter New Company Name</label>\n<md-input-container flex=\"100\" md-no-float=\"\"><input name=\"companyName\" ng-model=\"$ctrl.imuFormObj.companyName\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-AddShipperCompany-ComapnyName-Change\',{\'Value\':$ctrl.imuFormObj.companyName})\" \nplaceholder=\"Enter New Company Name \" class=\"panel-select\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.companyNameValidation}\" \nng-keyup=\"$ctrl.validationObj.companyNameValidation=false\" md-no-asterisk autocomplete=\"off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-if=\"$ctrl.validationObj.companyNameValidation\" class=\"validation-error-text\"><span>Enter Company Name</span></div>\n</md-input-container></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label \nclass=\"mb-6-imp\">Email ID</label><md-input-container flex=\"100\" md-no-float=\"\"><input type=\"email\" \nng-model=\"$ctrl.imuFormObj.emailId\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-AddShipperCompany-EmailID-change\',{\'Value\':$ctrl.imuFormObj.emailId})\" \nname=\"emailId\" placeholder=\"Email id\" class=\"panel-select\" md-no-asterisk \nng-class=\"{\'validation-error\':$ctrl.validationObj.emailValidation}\" \nng-keyup=\"$ctrl.validationObj.emailValidation=false\" ng-pattern=\"$ctrl.util.emailRegex\" autocomplete=\"off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-if=\"$ctrl.validationObj.emailValidation && !imuForm.emailId.$error.pattern\" class=\"validation-error-text\"><span>\nEnter a valid Email Id</span></div><div ng-messages=\"imuForm.emailId.$error\" role=\"alert\"><div ng-message=\"pattern\">\n<span translate=\"Email must be a valid e-mail address\">Email must be a valid e-mail address</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div layout=\"column\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label class=\"mb-6-imp\">Address</label><md-input-container flex=\"100\" \nmd-no-float=\"\"><input name=\"address\" ng-model=\"$ctrl.imuFormObj.address\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-AddShipperCompany-Address-change\',{\'Value\': $ctrl.imuFormObj.address})\" \nplaceholder=\"Address\" class=\"panel-select\" md-no-asterisk \nng-class=\"{\'validation-error\':$ctrl.validationObj.addressValidation}\" \nng-keyup=\"$ctrl.validationObj.addressValidation=false\" autocomplete=\"off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-if=\"$ctrl.validationObj.addressValidation\" class=\"validation-error-text\"><span>Enter Company Address</span></div>\n</md-input-container></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label \nclass=\"mb-6-imp\">Phone number</label><md-input-container flex=\"100\" md-no-float=\"\"><input name=\"phoneNumber\" \nng-model=\"$ctrl.imuFormObj.phoneNumber\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-AddShipperCompany-PhoneNumber-change\',{\'Value\':$ctrl.imuFormObj.phoneNumber})\" \nplaceholder=\"Phone number\" class=\"panel-select\" autocomplete=\"off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div layout=\"column\" flex=\"50\" \nclass=\"feild-spacing\" flex-xs=\"100\"><label class=\"mb-6-imp\">Country</label><md-input-container flex=\"100\" \nmd-no-float=\"\"><input name=\"country\" placeholder=\"Country\" ng-model=\"$ctrl.imuFormObj.country\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-AddShipperCompany-Country-change\',{\'Value\':$ctrl.imuFormObj.country})\" \nclass=\"panel-select\" md-no-asterisk ng-class=\"{\'validation-error\':$ctrl.validationObj.countryValidation}\" \nng-keyup=\"$ctrl.validationObj.countryValidation=false\" autocomplete=\"off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-if=\"$ctrl.validationObj.countryValidation\" class=\"validation-error-text\"><span>Enter Country</span></div>\n</md-input-container></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label \nclass=\"mb-6-imp\">Zipcode/Pincode</label><md-input-container flex=\"100\" md-no-float=\"\"><input name=\"zipcode\" \nng-model=\"$ctrl.imuFormObj.zipcode\" \nng-change=\"$ctrl.util.callMixpanel(\'User-Import-AddShipperCompany-ZipCode-change\',{\'Value\':$ctrl.imuFormObj.zipcode})\" \nplaceholder=\"Zipcode/Pincode\" class=\"panel-select ng-empty ng-invalid\" md-no-asterisk \nng-class=\"{\'validation-error\':$ctrl.validationObj.pincodeValidation}\" \nng-keyup=\"$ctrl.validationObj.pincodeValidation=false\" autocomplete=\"off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-if=\"$ctrl.validationObj.pincodeValidation\" class=\"validation-error-text\"><span>Enter Zipcode</span></div>\n</md-input-container></div></div></div><div flex=\"100\" class=\"mt-10 mb-10 m-5\" layout-xs=\"column\" layout-sm=\"column\">\n<div flex=\"\" layout=\"column\"><label class=\"mb-10 font-size-11 fg-AAA8AD\">\nTo import {{$ctrl.importdata.importType == \'users\' ? \"Users\" : \"Customer Companies or Users\"}}, select an XLSX or Excel file.\n</label><input name=\"import_file\" type=\"file\" id=\"import_file\" ng-model=\"$ctrl.imuFormObj.importFile\" \nngf-max-size=\"10MB\" ngf-select=\"$ctrl.validationObj.fileValidation=false\" accept=\".xlsx\" ngf-pattern=\"\'.xls,.xlsx\'\" \nmd-no-asterisk ngf-model-invalid=\"errorFile\" \nng-change=\"$ctrl.util.callMixpanel($ctrl.importdata.importType == \'users\' ? \'Users\': \'Shipper\' + \'-Import-ChooseFile-Change\')\">\n<div ng-if=\"$ctrl.validationObj.fileValidation\" class=\"validation-error-text\">select a XLSX or Excel file for Import\n</div><span ng-if=\"imuForm.import_file.$error.maxSize\" class=\"validation-error-text\">\nThis file is too large, maximum file size is 10MB.</span> <span ng-if=\"imuForm.import_file.$error.pattern\" \nclass=\"validation-error-text\"><span>Please upload XLSX or Excel file</span> </span><span class=\"validation-error-text\" \nng-if=\"$ctrl.importFileError != \'\'\">{{ $ctrl.importFileError }}</span></div></div></div></md-content></div>\n<md-dialog-actions class=\"p-20\"><div layout-align=\"space-between center\" layout=\"row\" flex=\"100\"><div \nlayout-align=\"start center\" class=\"font-size-13 cursor font-weight-600 download-sample\" \nng-click=\"$ctrl.sampleFileDownload()\"><md-icon md-font-icon=\"icon-download\" class=\"sky-blue-fg\"></md-icon>\nDownload the sample file here</div><button layout-align=\"end center\" \nclass=\"md-accent-btn import-upload-btn md-button md-custom-theme\" ng-if=\"$ctrl.isUploading == false\" type=\"submit\">\nUpload</button> <button class=\"md-accent-btn md-button md-custom-theme\" ng-if=\"$ctrl.isUploading == true\"><md-icon \nmd-font-icon=\"icon-replay\" class=\"file-upload-loader\"></md-icon></button></div></md-dialog-actions></form>");
$templateCache.put("app/main/roles/component/productApiConfig/product-api-config.html","<div id=\"product-api-config\"><div layout=\"{{ $ctrl.displaytype }}\" class=\"mt-5\" \nng-repeat=\"clientDetails in $ctrl.clientdata\"><div flex class=\"{{ $ctrl.displaytype === \'row\' ? \'mr-20\' : \'\'}}\"><span \nclass=\"label\">Customer ID</span><md-input-container class=\"md-block mt-8 mb-2 p-0\" md-no-float><input \nname=\"customer_id\" class=\"disabled-input\" disabled=\"disabled\" value=\"{{clientDetails.clientId}}\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18 pointer content-copy\" \nng-click=\"$ctrl.fnCopyContent(clientDetails.clientId)\"><md-tooltip md-direction=\"top\">{{ $ctrl.isCopied }}</md-tooltip>\n</md-icon></md-input-container></div><div flex class=\"{{ $ctrl.displaytype === \'row\' ? \'mr-20\' : \'\'}}\"><span \nclass=\"label\">Client Secret Key</span><md-input-container class=\"md-block mt-8 mb-2 p-0\" md-no-float><input \nname=\"client_secret_key\" class=\"disabled-input\" disabled=\"disabled\" value=\"{{clientDetails.clientSecret}}\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18 pointer content-copy\" \nng-click=\"$ctrl.fnCopyContent(clientDetails.clientSecret)\"><md-tooltip md-direction=\"top\">{{ $ctrl.isCopied }}\n</md-tooltip></md-icon></md-input-container></div><div flex class=\"{{ $ctrl.displaytype === \'row\' ? \'mr-20\' : \'\'}}\">\n<span class=\"label\">API Key</span><md-input-container class=\"md-block mt-8 mb-2 p-0\" md-no-float><input name=\"api_key\" \ndisabled=\"disabled\" class=\"disabled-input\" value=\"{{clientDetails.apiKey}}\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18 pointer content-copy\" ng-click=\"$ctrl.fnCopyContent(clientDetails.apiKey)\"><md-tooltip md-direction=\"top\">\n{{ $ctrl.isCopied }}</md-tooltip></md-icon></md-input-container></div><div flex \nclass=\"{{ $ctrl.displaytype === \'row\' ? \'mr-20\' : \'\'}}\"><span class=\"label\">Daily Limit</span><md-input-container \nclass=\"md-block mt-8 mb-2 p-0\" md-no-float><input name=\"daily_limit\" disabled=\"disabled\" class=\"disabled-input\" \nvalue=\"{{clientDetails.limit}}\"></md-input-container></div><div flex \nclass=\"{{ $ctrl.displaytype === \'row\' ? \'mr-20\' : \'\'}}\"><span class=\"label\">Expiry Date</span><div class=\"mt-12\" \nng-if=\"$ctrl.iseditable\"><md-datepicker id=\"trialExpiry_date_new\" name=\"trialExpiry_date_new\" \nng-model=\"clientDetails.trialExpiry\" md-placeholder=\"Select\" md-is-open=\"vm.openDatePicker\" onkeydown=\"return false\" \nmd-open-on-focus md-hide-icons=\"all\" class=\"pv-5\" required></md-datepicker></div><md-input-container \nclass=\"md-block mt-8 mb-2 p-0\" md-no-float ng-if=\"!$ctrl.iseditable\"><input name=\"expiry_date\" disabled=\"disabled\" \nclass=\"disabled-input\" value=\"{{clientDetails.trialExpiry | UTCToLocal : \'yyyy-MM-d\'}}\"></md-input-container></div>\n</div></div>");
$templateCache.put("app/main/roles/dialogs/agentForm/agentForm.html","<md-dialog id=\"create-agent\" class=\"popup-xs\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div>{{ctrl.parent.agentInfo.form_heading}} Agent</div><span flex></span><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog(ctrl.parent.agentInfo.form_heading,\'CloseBy Icon\')\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><form name=\"agent_form\" novalidate \nautocomplete=\"off\" ng-submit=\"ctrl.parent.submitAgent(agent_form,ctrl.parent.agentInfo)\"><md-dialog-content \nclass=\"body\"><div flex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mobile-spacing\"><label class=\"pl-5\">Agent Name\n</label><md-input-container class=\"input_container\" md-no-float><input ng-maxlength=\"96\" \nng-class=\"{\'validation-error\':(ctrl.parent.validationObj.agentNameValidation ||ctrl.parent.validationObj.sameNameValidation),\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.agentInfo.viewAgent}\" \nname=\"agent_name\" placeholder=\"Enter agent name\" class=\"md-input-focused panel-select\" \nng-model=\"ctrl.parent.agentInfo.name\" id=\"agent_name\" \nng-keyup=\"ctrl.parent.validationObj.agentNameValidation=false;ctrl.parent.validationObj.sameNameValidation=false\" \nng-disabled=\"ctrl.parent.agentInfo.viewAgent\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"ctrl.parent.trackEvent(\'Agent-AgentName-Change\',ctrl.parent.agentInfo.form_heading)\"><div \nng-if=\"ctrl.parent.validationObj.agentNameValidation && !agent_form.agent_name.$invalid\" class=\"validation-error-text\">\n<span>Enter Agent Name</span></div><div ng-if=\"ctrl.parent.validationObj.sameNameValidation\" \nclass=\"validation-error-text\"><span>{{ctrl.parent.validationErrorName}}</span></div><div class=\"validation-error-text\" \nng-if=\"agent_form.agent_name.$invalid\"><span>Enter between 1 and 96 characters</span></div></md-input-container></div>\n<div flex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mobile-spacing pb-20\"><label class=\"pl-5\">Agent Type</label>\n<md-input-container class=\"input_container\" md-no-float><md-select ng-model=\"ctrl.parent.agentInfo.type\" \nplaceholder=\"Select Agent Type\" class=\"md-input-focused panel-select\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.agentInfo.viewAgent}\" \nng-disabled=\"ctrl.parent.agentInfo.viewAgent\" \nng-change=\"ctrl.parent.trackEvent(\'Agent-AgentType-Change\', ctrl.parent.agentInfo.form_heading)\"><md-option \nng-value=\"\'Forwarder\'\">Forwarder</md-option></md-select></md-input-container></div><div flex=\"100\" flex-xs=\"100\" \nlayout=\"column\" class=\"mobile-spacing\"><label class=\"pl-5\">Email Address</label><md-input-container \nclass=\"input_container\" md-no-float><input id=\"agent_mail\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.emailValidation,\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.agentInfo.viewAgent}\" \nplaceholder=\"Enter email address\" type=\"email\" name=\"agent_email\" class=\"md-input-focused panel-select\" \nng-model=\"ctrl.parent.agentInfo.email\" ng-disabled=\"ctrl.parent.agentInfo.viewAgent\" \nng-pattern=\"ctrl.parent.util.emailRegex\" ng-keyup=\"ctrl.parent.validationObj.emailValidation=false\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"ctrl.parent.trackEvent(\'Agent-EmailId-Change\',ctrl.parent.agentInfo.form_heading)\"><div \nng-messages=\"agent_form.agent_email.$error\" role=\"alert\"><div ng-message=\"pattern\"><span \ntranslate=\"Enter a valid EmailID\">Email must be a valid e-mail address</span></div></div><div \nng-if=\"ctrl.parent.validationObj.sameEmailValidation\" class=\"validation-error-text\"><span>\n{{ctrl.parent.validationErrorEmail}}</span></div><div \nng-if=\"ctrl.parent.validationObj.emailValidation && !agent_form.agent_email.$error.pattern\" \nclass=\"validation-error-text\"><span>Enter EmailID</span></div></md-input-container></div><div flex=\"100\" flex-xs=\"100\" \nlayout=\"column\" class=\"mobile-spacing\"><label class=\"pl-5\">Mobile Number</label><md-input-container \nclass=\"input_container\" md-no-float><input id=\"agent_mobile\" \nng-class=\"{\'validation-error\':(ctrl.parent.validationObj.mobileNumberValidation || ctrl.parent.validationObj.sameMobileValidation),\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.agentInfo.viewAgent}\" \nplaceholder=\"Enter mobile number\" type=\"tel\" name=\"agent_mobile\" class=\"md-input-focused panel-select\" \nng-model=\"ctrl.parent.agentInfo.mobile\" ng-disabled=\"ctrl.parent.agentInfo.viewAgent\" ng-maxlength=\"16\" \nng-keyup=\"ctrl.parent.validationObj.mobileNumberValidation=false;ctrl.parent.validationObj.sameMobileValidation=false\" \nng-change=\"ctrl.parent.trackEvent(\'Agent-PhoneNumber-Change\',ctrl.parent.agentInfo.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"agent_form.agent_mobile.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">Enter between 1 and 16 digits\n</div></div><div ng-if=\"ctrl.parent.validationObj.mobileNumberValidation && !agent_form.agent_mobile.$invalid\" \nclass=\"validation-error-text\"><span>Enter Mobile Number</span></div><div \nng-if=\"ctrl.parent.validationObj.sameMobileValidation\" class=\"validation-error-text\"><span>\n{{ctrl.parent.validationErrorMobile}}</span></div></md-input-container></div></md-dialog-content><md-dialog-actions \nclass=\"footer\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\" ng-if=\"!ctrl.parent.agentInfo.viewAgent\">\n<md-button md-no-ink class=\"md-primary-btn\" title=\"Cancel edit\" \nng-click=\"ctrl.parent.cancelDialog(ctrl.parent.agentInfo.form_heading,\'CancelBy Button\')\">Cancel</md-button><md-button \nmd-no-ink class=\"md-accent-btn\" type=\"submit\" title=\"SAVE\">{{ctrl.parent.agentInfo.button_type}}</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/roles/dialogs/chargeForm/chargeForm.html","<md-dialog id=\"create-charge\" class=\"popup-xs\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div>{{ctrl.parent.chargeInfo.form_heading}} Charge</div><span flex></span><md-button \nmd-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog(ctrl.parent.chargeInfo.form_heading,\'CloseBy Icon\')\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><form name=\"charge_form\" novalidate \nautocomplete=\"off\" ng-submit=\"ctrl.parent.submitCharge(charge_form,ctrl.parent.chargeInfo)\"><md-dialog-content \nclass=\"body\"><div flex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mobile-spacing\"><label class=\"pl-5\">Mode</label>\n<md-input-container class=\"input_container\" md-no-float><md-select ng-model=\"ctrl.parent.chargeInfo.mode\" \nplaceholder=\"Select Mode\" class=\"md-input-focused panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.modeValidation,\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.chargeInfo.viewCharge || ctrl.parent.chargeInfo.updateView}\" \nng-disabled=\"ctrl.parent.chargeInfo.viewCharge || ctrl.parent.chargeInfo.updateView\" \nng-change=\"ctrl.parent.validationObj.modeValidation=false; ctrl.parent.onModeChange(ctrl.parent.chargeInfo.mode);\">\n<md-option ng-value=\"\'FCL\'\">FCL</md-option><md-option ng-value=\"\'LCL\'\">LCL</md-option></md-select><div \nng-if=\"ctrl.parent.validationObj.modeValidation\" class=\"validation-error-text\"><span>Please select mode</span></div>\n</md-input-container></div><div flex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mobile-spacing\"><label class=\"pl-5\">\nName</label><md-input-container class=\"input_container\" md-no-float><input ng-maxlength=\"255\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.chargeNameValidation,\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.chargeInfo.viewCharge}\" \nname=\"charge_name\" placeholder=\"Enter charge name\" class=\"md-input-focused panel-select\" \nng-model=\"ctrl.parent.chargeInfo.name\" id=\"charge_name\" \nng-keyup=\"ctrl.parent.validationObj.chargeNameValidation=false; ctrl.parent.validationObj.sameNameValidation=false\" \nng-disabled=\"ctrl.parent.chargeInfo.viewCharge || ctrl.parent.chargeInfo.updateView\" \nng-change=\"ctrl.parent.chargeInfo.descriptionShort = ctrl.parent.chargeInfo.name; ctrl.parent.chargeInfo.description = ctrl.parent.chargeInfo.name; ctrl.parent.generateChargeCode(); ctrl.parent.trackEvent(\'Charge-ChargeName-Change\',ctrl.parent.chargeInfo.form_heading)\">\n<div ng-if=\"ctrl.parent.validationObj.chargeNameValidation && !charge_form.charge_name.$invalid\" \nclass=\"validation-error-text\"><span>Enter Charge Name</span></div><div \nng-if=\"ctrl.parent.validationObj.sameNameValidation\" class=\"validation-error-text\"><span>\n{{ctrl.parent.validationErrorName}}</span></div></md-input-container></div><div flex=\"100\" flex-xs=\"100\" \nlayout=\"column\" class=\"mobile-spacing\"><label class=\"pl-5\">Code <span ng-if=\"!ctrl.parent.chargeInfo.viewCharge\" \nstyle=\"font-size: 11px; color: #666; font-weight: normal\">(Double-click to edit)</span></label><md-input-container \nclass=\"input_container\" md-no-float><input ng-maxlength=\"50\" \nng-class=\"{\'validation-error\': ctrl.parent.validationObj.codeValidation, \'pt-8 pb-10 panel-select-disabled\': ctrl.parent.chargeInfo.viewCharge || !ctrl.parent.codeEditMode}\" \nname=\"charge_code\" placeholder=\"Auto-generated code (Double-click to edit)\" class=\"md-input-focused panel-select\" \nng-model=\"ctrl.parent.chargeInfo.code\" id=\"charge_code\" ng-disabled=\"ctrl.parent.chargeInfo.viewCharge\" \nng-readonly=\"!ctrl.parent.codeEditMode && !ctrl.parent.chargeInfo.viewCharge\" \nng-dblclick=\"ctrl.parent.enableCodeEdit()\" ng-blur=\"ctrl.parent.disableCodeEdit()\" \nng-change=\"ctrl.parent.validationObj.codeValidation = false; ctrl.parent.validationObj.sameNameValidation = false;\">\n<div ng-if=\"ctrl.parent.validationObj.codeValidation\" class=\"validation-error-text\"><span>Enter valid charge code\n</span></div></md-input-container></div><div flex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mobile-spacing\"><label \nclass=\"pl-5\">Charge Type</label><md-input-container class=\"input_container\" md-no-float><md-select \nng-model=\"ctrl.parent.chargeInfo.chargeType\" placeholder=\"Select Charge Type\" class=\"md-input-focused panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.chargeTypeValidation,\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.chargeInfo.viewCharge}\" \nng-disabled=\"ctrl.parent.chargeInfo.viewCharge\" \nng-change=\"ctrl.parent.validationObj.chargeTypeValidation=false; ctrl.parent.trackEvent(\'Charge-ChargeType-Change\', ctrl.parent.chargeInfo.form_heading)\">\n<md-option ng-value=\"\'SURCHARGE\'\">Surcharge</md-option><md-option ng-value=\"\'LOCAL-CHARGE\'\">Local Charge</md-option>\n<md-option ng-value=\"\'CUSTOMS\'\">Customs</md-option><md-option ng-value=\"\'GRI\'\">GRI</md-option><md-option \nng-value=\"\'MARKUP\'\">Markup</md-option><md-option ng-value=\"\'REBATE\'\">Rebate</md-option></md-select><div \nng-if=\"ctrl.parent.validationObj.chargeTypeValidation\" class=\"validation-error-text\"><span>Please select charge type\n</span></div></md-input-container></div><div flex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mobile-spacing\"><label \nclass=\"pl-5\">Default Calculation Type</label><md-input-container class=\"input_container\" md-no-float><md-select \nng-model=\"ctrl.parent.chargeInfo.defaultCalculationType\" placeholder=\"Select Calculation Type\" \nclass=\"md-input-focused panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.defaultCalculationTypeValidation,\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.chargeInfo.viewCharge}\" \nng-disabled=\"ctrl.parent.chargeInfo.viewCharge\" \nng-change=\"ctrl.parent.validationObj.defaultCalculationTypeValidation=false\"><md-option ng-value=\"\'NOT-APPLICABLE\'\">\nNot Applicable</md-option><md-option ng-value=\"\'INCLUDED\'\">Included</md-option><md-option ng-value=\"\'SUBJECT-TO\'\">\nSubject To</md-option><md-option ng-value=\"\'CONDITIONAL\'\">Conditional</md-option><md-option ng-value=\"\'ON-REQUEST\'\">\nOn Request</md-option></md-select><div ng-if=\"ctrl.parent.validationObj.defaultCalculationTypeValidation\" \nclass=\"validation-error-text\"><span>Please select default calculation type</span></div></md-input-container></div><div \nflex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mobile-spacing\"><label class=\"pl-5\">Default Basis</label>\n<md-input-container class=\"input_container\" md-no-float><md-select ng-model=\"ctrl.parent.chargeInfo.defaultBasis\" \nplaceholder=\"Select Default Basis\" class=\"md-input-focused panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.defaultBasisValidation,\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.chargeInfo.viewCharge}\" \nng-disabled=\"ctrl.parent.chargeInfo.viewCharge\" ng-change=\"ctrl.parent.validationObj.defaultBasisValidation=false\">\n<md-option ng-repeat=\"option in ctrl.parent.formBasisOptions\" ng-value=\"option.value\">{{option.label}}</md-option>\n</md-select><div ng-if=\"ctrl.parent.validationObj.defaultBasisValidation\" class=\"validation-error-text\"><span>\nPlease select default basis</span></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 5px\"><label style=\"margin-right: 12px; min-width: 45px\">Status</label><span \nstyle=\"margin-right: 6px; font-size: 14px; color: #666\">Inactive</span><md-switch \nng-model=\"ctrl.parent.chargeInfo.isActive\" ng-disabled=\"ctrl.parent.chargeInfo.viewCharge\" class=\"md-primary\" \nstyle=\"margin: 0\" aria-label=\"Status Toggle\"></md-switch><span style=\"margin-left: 6px; font-size: 14px; color: #666\">\nActive</span></div><input type=\"hidden\" ng-model=\"ctrl.parent.chargeInfo.descriptionShort\"> <input type=\"hidden\" \nng-model=\"ctrl.parent.chargeInfo.description\"> <input type=\"hidden\" ng-model=\"ctrl.parent.chargeInfo.isGlobal\" \nng-init=\"ctrl.parent.chargeInfo.isGlobal = false\"></md-dialog-content><md-dialog-actions class=\"footer\"><div \nflex=\"100\" layout=\"row\" layout-align=\"end center\" ng-if=\"!ctrl.parent.chargeInfo.viewCharge\"><md-button md-no-ink \nclass=\"md-primary-btn\" title=\"Cancel edit\" \nng-click=\"ctrl.parent.cancelDialog(ctrl.parent.chargeInfo.form_heading,\'CancelBy Button\')\">Cancel</md-button><md-button\n md-no-ink class=\"md-accent-btn\" type=\"submit\" title=\"SAVE\">{{ctrl.parent.chargeInfo.button_type}}</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/roles/dialogs/edit-logo/edit-logo.html","<md-dialog id=\"editLogo\" class=\"edit-logo popup-md\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><div>Edit Logo</div><div \nclass=\"font-size-11 fg-AAA8AD\">logo format (.png, .jpg, .jpeg), size not more like than 10mb.</div></div><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close s16 black-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pv-15 ph-20\"><div flex><span class=\"label\" \ntranslate=\"Select logo style\">Select logo style</span><md-radio-group class=\"mt-5\" layout=\"row\" flex=\"100\" layout-wrap \nng-model=\"ctrl.parent.logoStyle\" ng-change=\"ctrl.parent.fnlogoStyleChange(ctrl.parent.image)\"><md-radio-button \nmd-no-ink value=\"rectangle\" class=\"md-primary\">Rectangle</md-radio-button><md-radio-button md-no-ink value=\"square\" \nclass=\"md-primary\">Square</md-radio-button></md-radio-group></div><div class=\"cropper-box\"><image id=\"image\" \nclass=\"cropper-img\" ng-src=\"{{ctrl.parent.util.sanitizeQueryParams(ctrl.parent.src)}}\"></div></md-dialog-content>\n<md-dialog-actions class=\"sticky-strip bottom-0 card_shadow bt\" layout=\"row\" layout-align=\"end center\" \nclass=\"white-bg bt\" layout-wrap flex-xs=\"100\"><md-button md-no-ink class=\"md-accent-btn ml-10 save1\" \nng-click=\"ctrl.parent.saveImg($event)\" type=\"submit\">Done</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/roles/dialogs/forwarderForm/client-generate-success.html","<md-dialog id=\"success-api-generate\"><md-toolbar class=\"modal_title white-bg black-fg md-custom-theme\"><div \nclass=\"md-toolbar-tools border-bottom\"><div class=\"font-size-16 font-weight-500\">Success! <span \nclass=\"font-size-14 font-weight-400 grey-fg\">({{ ctrl.parent.client[0].environment }})</span></div><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"black-fg cursor\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-xs=\"column\" \nclass=\"pb-5 pt-5 border-bottom\"><product-api-config clientdata=\"ctrl.parent.client\" displaytype=\'\"column\"\' \niseditable=\"false\"></product-api-config></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center \">\n<md-button md-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel\">Close\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/roles/dialogs/forwarderForm/forwarder-add.html","<md-dialog id=\"forwarder-onboard\" class=\"popup-lg\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\" flex=\"80\"><b>FORWARDER</b> Mission Control</div><div layout=\"row\" class=\"p-0\" layout-align=\"end end\" \nflex=\"20\"><md-icon md-font-icon=\"icon-close\" class=\"mr-5 pointer\" ng-click=\"ctrl.parent.cancelDialog(\'close\')\">\n</md-icon></div></div><md-dialog-content class=\"mt-20\"><form name=\"horizontalStepper\" ms-horizontal-stepper \nng-submit=\"ctrl.parent.submit_forwarder(ctrl.parent.forwarderInfo, ctrl.parent.clientsObj, ctrl.parent.forwarderInfo.button_type)\" \nng-model=\"ctrl.parent.horizontalStepper\"><ms-horizontal-stepper-step ng-form=\"ctrl.parent.generalFrm\" step=\"1\" \nstep-title=\"\'GENERAL\'\"><div layout=\"column\" class=\"ph-10 pt-5 md-inline-form\"><div layout=\"row\" layout-xs=\"column\" \nlayout-wrap><div flex class=\"mr-20\"><span class=\"label\">Company Name <span class=\"red-fg\">*</span></span>\n<md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.company_name\" name=\"company_name\" placeholder=\"Enter Company name\" required><div \nng-messages=\"ctrl.parent.generalFrm.company_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Name is required.</span></div></div></md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">\nCompany Email ID <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.company_email\" type=\"email\" \nname=\"company_email\" ng-pattern=\"ctrl.parent.util.emailRegex\" placeholder=\"Enter Email ID\" required><div \nng-messages=\"ctrl.parent.generalFrm.company_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Email is required.</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span>\n</div></div></md-input-container></div><div flex><span class=\"label\">Phone Number</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused tel-input\" type=\"tel\" \nng-model=\"ctrl.parent.forwarderInfo.company_phone_number\" placeholder=\"Phone Number\" name=\"company_phone_number\" \nng-maxlength=\"40\"><div ng-messages=\"ctrl.parent.generalFrm.company_phone_number.$error\" class=\"intl-err\"><div \nng-message=\"maxlength\">Phone number must not exceed 40 characters</div></div></md-input-container></div></div><div \nlayout=\"row\" layout-xs=\"column\" layout-wrap><div flex class=\"mr-25\"><span class=\"label\">No.of Employees</span>\n<md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.number_of_employees\" name=\"number_of_employees\" min=\"1\" type=\"number\" \nplaceholder=\"Enter No.of Employees\"></md-input-container></div><div flex class=\"mr-25 date_input\"><span class=\"label\">\nDate of Establishment</span><date-picker md-input-id=\"\'date_of_establishment\'\" is-editable=\"true\" is-disabled=\"false\" \ninput-required=\"\'false\'\" input-name=\"\'date_of_establishment\'\" date-placeholder=\"\'Enter date\'\" full-border=\"true\" \ndate-format=\"true\" model-value=\"ctrl.parent.forwarderInfo.date_of_establishment\" \nmin-date-value=\"ctrl.parent.forwarderInfo.date_of_establishment\" \ncallback=\"ctrl.parent.forwarderInfo.date_of_establishment= value\"></date-picker><div \nng-messages=\"ctrl.parent.generalFrm.date_of_establishment.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div></div><div flex><span class=\"label\">IATA Commission %\n</span><md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.iata_commission\" name=\"iata_commission\" max=\"100\" maxlength=\"4\" type=\"number\" \nplaceholder=\"Enter IATA Commission %\"></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nlayout-wrap><div flex class=\"mr-25\"><span class=\"label\">Incentive %</span><md-input-container class=\"md-block p-0\" \nmd-no-float><input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.incentive\" \nname=\"incentive\" max=\"100\" maxlength=\"4\" type=\"number\" placeholder=\"Enter Incentive %\"></md-input-container></div><div \nflex class=\"mr-25\"><span class=\"label\">Turnover of the Company Sales (In Rs.)</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.company_turnover\" name=\"company_turnover\" min=\"1\" type=\"number\" \nplaceholder=\"Enter your turnover\"></md-input-container></div><div flex><span class=\"label\">Plan Type<span \nclass=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><md-select class=\"panel-select\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.plan_type\" placeholder=\"Select Plan Type\" name=\"plan_type\" required>\n<md-option value=\"ESSENTIAL\">ESSENTIAL</md-option><md-option value=\"TRANSFORM\">TRANSFORM</md-option><md-option \nvalue=\"ELITE\">ELITE</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nlayout-wrap><div><div class=\"label mb-15\">Base Currency<span class=\"red-fg\">*</span></div><currency-dropdown \nfield-value=\"ctrl.parent.forwarderInfo.domain_data.base_currency\" currency-list=\"ctrl.parent.currencyList\" \nfull-border=\"true\" is-required=\"true\"></currency-dropdown></div><div class=\"ml-20\"><div class=\"label mb-15\">\nTrial Period</div><div layout=\"column\" class=\"panel-select custom-container-datepicker\"><md-date-range \nng-model=\"ctrl.parent.pickerModel\" class=\"date-range-picker\" placeholder=\"Select dates\" \nmd-on-select=\"ctrl.parent.setDatePicker(ctrl.parent.forwarderInfo,ctrl.parent.pickerModel)\" one-panel=\"true\" \nauto-confirm=\"true\" show-template=\"false\" custom-templates=\"customTemplates\" first-day-of-week=\"firstDayOfWeek\">\n</md-date-range><div class=\"warning\" ng-if=\"ctrl.parent.trialErr\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"orange-300-fg s16 mr-5\"></md-icon>{{ctrl.parent.trialErr}}</div></div></div></div><div layout=\"row\" \nlayout-xs=\"column\" layout-wrap layout-padding><div class=\"mr-10 file_div\" layout=\"column\"><span class=\"label pb-3\">\nCompany Logo <span class=\"red-fg\">*</span> </span><span class=\"font-size-12\" \nng-if=\"!ctrl.parent.isPreview && !ctrl.parent.isOrigLogo\">.png, .jpg, .jpeg file | Upto 10MB</span><div \nclass=\"input-box mt-6-imp\" ng-if=\"!ctrl.parent.isPreview && !ctrl.parent.isOrigLogo\"><input \nclass=\"panel-select md-input-focused\" name=\"company_logo\" type=\"file\" id=\"fileInput_company_logo\" \nngf-select=\"ctrl.parent.fnLogoValidation(\'init\', ctrl.parent.company_logo, $event)\" \nng-model=\"ctrl.parent.company_logo\" ngf-max-size=\"10MB\" ng-required=\"true\" required accept=\".png, .jpg, .jpeg\"></div>\n<span ng-if=\"ctrl.parent.generalFrm.company_logo.$error.maxSize\" class=\"font-size-14 red-fg mt-10\">\nThis file is too large, maximum file size is 10MB.</span><input class=\"panel-select md-input-focused\" \nname=\"company_logo\" type=\"file\" hide id=\"fileEdit_company_logo\" \nngf-select=\"ctrl.parent.fnLogoValidation(\'init\', ctrl.parent.company_logo, $event)\" \nng-model=\"ctrl.parent.company_logo\" ngf-max-size=\"10MB\" accept=\".png, .jpg, .jpeg\"><div class=\"cropped-imgBox mt-15\" \nng-class=\"{\'square\': ctrl.parent.logoStyle===\'square\', \'rectangle\': ctrl.parent.logoStyle===\'rectangle\', \'hide\' : !ctrl.parent.isPreview && !ctrl.parent.isOrigLogo}\">\n<img class=\"cropped-img\" src=\"\"><md-menu md-position-mode=\"left bottom\"><div class=\"overlay\" \nng-click=\"ctrl.parent.openMenu($mdMenu, $event)\"><md-icon class=\"img-icon\" md-font-icon=\"icon-camera\" class=\"mr-5 s18\">\n</md-icon><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left\" \nstyle=\"display:table;opacity: 1\">Click to view/edit logo</md-tooltip></div><md-menu-content><md-menu-item><md-button \nmd-no-ink class=\"fg-333333 font-size-14\" ng-click=\"ctrl.parent.fnLogoValidation(\'edit\')\"><md-icon \nmd-font-icon=\"icon-pencil\" md-menu-align-target class=\"s16 fg-333333\"></md-icon>Edit</md-button></md-menu-item>\n<md-menu-item><md-button md-no-ink class=\"fg-333333 font-size-14\" ng-click=\"ctrl.parent.fnReplaceLogo()\"><md-icon \nmd-font-icon=\"icon-reply\" class=\"s16 fg-333333\"></md-icon>Replace</md-button></md-menu-item><md-menu-item><md-button \nmd-no-ink class=\"fg-333333 font-size-14\" ng-click=\"ctrl.parent.fnResetLogo();\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s16 fg-333333\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"file_div\" layout=\"column\"><span class=\"label pb-3\">Favicon</span> <span class=\"font-size-12\">\n(recommended) 42px * 42px | Upto 1MB | .ico file</span> <input class=\"panel-select mt-6-imp md-input-focused\" \nname=\"favicon\" type=\"file\" id=\"fileInput_favicon\" ngf-select ng-model=\"ctrl.parent.favicon\" ngf-max-size=\"10MB\" \naccept=\".ico\" ngf-pattern=\"\'.ico\'\" ngf-model-invalid=\"errorFile\"> <a class=\"mt-5 md-link-fg\" \nng-href=\"{{ctrl.util.sanitizeQueryParams(ctrl.parent.forwarderInfo.favicon)}}\" target=\"_blank\" rel=\"noopener\" \nng-if=\"ctrl.parent.forwarderInfo.favicon\" flex>View Full Image</a> <span \nng-if=\"ctrl.parent.generalFrm.favicon.$error.maxSize\" class=\"font-size-14 red-fg\">\nThis file is too large, maximum file size is 10MB.</span> <span ng-if=\"ctrl.parent.generalFrm.favicon.$error.pattern\" \nclass=\"font-size-14 red-fg\">Please upload only png format files.</span></div><div layout=\"column\" class=\"mt-16-imp\">\n<span class=\"label pb-5\">Primary color</span><div layout=\"row\"><input class=\"panel-select md-input-focused\" \nname=\"secondary_color\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.secondary_color\" \nplaceholder=\"Enter color\" ng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\" class=\"color-picker-input\"> <input \nclass=\"panel-select md-input-focused\" type=\"color\" class=\"color-picker\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.secondary_color\"></div><div \nng-if=\"ctrl.parent.generalFrm.secondary_color.$invalid\"><span class=\"red-fg font-size-12\">Invalid Color Code.</span>\n</div></div><div layout=\"column\" class=\"mt-16-imp\"><span class=\"label pb-5\">Secondary color</span><div layout=\"row\">\n<input class=\"panel-select md-input-focused\" name=\"primary_color\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color\" placeholder=\"Enter color\" \nng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\" class=\"color-picker-input\" \nng-change=\"ctrl.parent.validateSecondaryColor(ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color,ctrl.parent.generalFrm)\">\n <input class=\"panel-select md-input-focused\" type=\"color\" class=\"color-picker\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color\" \nng-change=\"ctrl.parent.validateSecondaryColor(ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color,ctrl.parent.generalFrm)\">\n</div><div ng-if=\"ctrl.parent.generalFrm.primary_color.$invalid\"><span class=\"red-fg font-size-12\">Invalid Color Code.\n</span></div><div ng-if=\"ctrl.parent.generalFrm.$error.constrastClrErr\"><span class=\"red-fg font-size-12\">\nPlease select darker shades.</span></div></div><div layout=\"column\" class=\"mt-16-imp\"><span class=\"label pb-5\">\nDark mode</span><div layout=\"row\" layout-align=\"left center\"><div class=\"pr-20\">No</div><md-switch md-no-ink md-invert \naria-label=\"Switch 7\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.dark_mode\" class=\"dark_mode_switch\">\n</md-switch><div class=\"pl-20\">Yes</div></div></div></div></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"addressFrm\" step=\"2\" step-title=\"\'ADDRESS\'\"><div layout=\"row\" \nclass=\"ph-10 pt-5 md-inline-form\" layout-xs=\"column\"><div flex class=\"pr-20 mr-20\" flex=\"40\"><span class=\"label\">\nCompany Address</span><md-input-container class=\"md-block p-0\" md-no-float><ng-ckeditor \nng-config=\"ctrl.parent.util.ckEditorConfig\" class=\"company_address\" \nng-model=\"ctrl.parent.forwarderInfo.company_address\" name=\"company_address\" placeholder=\"Company address\" rows=\"5\">\n</ng-ckeditor></md-input-container></div><div layout=\"column\" flex><div layout=\"row\"><div flex class=\"mr-25\"><span \nclass=\"label\">Company Website <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float>\n<input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.company_website_url\" \nname=\"company_website_url\" placeholder=\"Enter Company Website\" required><div \nng-messages=\"addressFrm.company_website_url.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInvalid Company Website.</span></div></div></md-input-container></div><div flex><span class=\"label\">\nCompany Tracking URL</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.company_tracking_url\" \nname=\"company_tracking_url\" placeholder=\"Enter Company Tracking URL\"></md-input-container></div></div><div \nlayout=\"row\"><div flex class=\"mr-25\"><span class=\"label\">State</span><md-input-container class=\"md-block p-0\" \nmd-no-float><input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.state\" name=\"state\" \nplaceholder=\"State\"></md-input-container></div><div flex><span class=\"label\">Country</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.country\" name=\"country\" placeholder=\"Country\"></md-input-container></div></div><div\n layout=\"row\"><div flex class=\"mr-25\"><span class=\"label\">Zip Code/Pin Code</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.postal_code\" ng-pattern=\"/[A-Za-z0-9][A-Za-z0-9\\- ]{0,10}[A-Za-z0-9]$/\" \nname=\"postal_code\" placeholder=\"Postal code\"><div ng-messages=\"addressFrm.postal_code.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Invalid code.</span></div></div></md-input-container></div></div></div></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"settingFrm\" step=\"3\" step-title=\"\'SETTINGS\'\"><div \nclass=\"ph-10 pt-5 md-inline-form\"><div layout=\"row\" layout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">\nDomain Name <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain\" name=\"domain\" \nplaceholder=\"Domain name\" ng-change=\"ctrl.parent.getDomainUrl(ctrl.parent.forwarderInfo)\" \nonkeyup=\"this.value = this.value.toLowerCase()\" \nng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.[a-z]{2,10}$/i\" required><div \nng-messages=\"settingFrm.domain.$error\" role=\"alert\"><div ng-message=\"required\"><span>Domain Name is required.</span>\n</div><div class=\"errors\" ng-if=\"settingFrm.domain.$error.pattern\">Invalid domain name.</div></div>\n</md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">Solution Name <span class=\"red-fg\">*</span>\n</span><md-input-container class=\"md-block p-0\" md-no-float><md-select class=\"panel-select\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.solution_type\" placeholder=\"Select Solution Type\" name=\"solution_type\" \nng-change=\"ctrl.parent.getNwlsData(ctrl.parent.forwarderInfo)\" required><md-option value=\"WLS\">WLS</md-option>\n<md-option value=\"NWLS\">NWLS</md-option></md-select><div ng-messages=\"settingFrm.solution_type.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Solution Name is required.</span></div></div></md-input-container></div><div flex><div\n class=\"b font-size-16 brad-10 mh-10 h-50 mt-6\" layout=\"row\" layout-align=\"center center\"><md-switch md-no-ink \nmd-invert aria-label=\"Switch 7\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status\" \nng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" \nng-disabled=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'NWLS\'\">Mail Domain Verified Status</md-switch>\n</div></div></div><div layout=\"row\" layout-xs=\"column\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div class=\"br\" flex-gt-sm=\"40\" \nlayout=\"column\"><md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.document_submit_required\" name=\"document_submit_required\" \naria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\">Document Submit Required</md-checkbox>\n<md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.shipment_notification_from_specialist\" \nname=\"shipment_notification_from_specialist\" aria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\">\nBooking Notification by Specialist</md-checkbox><md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.no_emails_to_admins_in_cc\" name=\"no_emails_to_admins_in_cc\" \naria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\">No Emails to Admin in CC</md-checkbox></div>\n<div flex class=\"ml-20\" layout=\"column\" layout-align=\"center\"><div layout=\"row\" layout-xs=\"column\"><div flex \nclass=\"mr-25\"><span class=\"label\">Mail API Key <span class=\"red-fg\">*</span></span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.mailgun_apikey\" name=\"mailgun_apikey\" placeholder=\"Mail api key\" \nrequired ng-disabled=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'NWLS\'\"><div \nng-messages=\"settingFrm.mailgun_apikey.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMailgun api key is required.</span></div></div></md-input-container></div><div flex><span class=\"label\">Mail Domain \n<span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain\" \nname=\"mailgun_domain\" placeholder=\"Mail domain\" ng-pattern=\"/[\\w\\-~]+(\\.[\\w\\-~]+)+(\\/[\\w\\-~]*)*(#[\\w\\-]*)?(\\?.*)?/\" \nrequired ng-disabled=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'NWLS\'\"><div \nng-messages=\"settingFrm.mailgun_domain.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMailgun domain is required.</span></div><div ng-message=\"pattern\"><span>Valid domain is required.</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\"><div flex class=\"mr-25\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.document_submit_required == \'true\'\"><span class=\"label\">\nDocument Submit Email <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.document_submit_email\" \ntype=\"email\" name=\"document_submit_email\" placeholder=\"Document submit email\" ng-pattern=\"ctrl.parent.util.emailRegex\" \nrequired><div ng-messages=\"settingFrm.document_submit_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDocument submit email is required.</span></div><div ng-message=\"pattern\"><span>Enter a valid Email Id</span></div>\n</div></md-input-container></div><div flex ng-if=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'WLS\'\"><span \nclass=\"label\">Send Booking Confirmation to</span><div layout=\"row\"><md-input-container class=\"md-block p-0\" \nmd-no-float flex><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.send_shipment_booking_confirmation\" \nname=\"send_shipment_booking_confirmation\" placeholder=\"Enter booking confirmation\" \nng-pattern=\"ctrl.parent.util.commonEmailRegex\"><div ng-messages=\"settingFrm.send_shipment_booking_confirmation.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Valid mail is required.</span></div></div></md-input-container><span \nclass=\"pt-15\" ng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain\">\n@{{ctrl.parent.forwarderInfo.domain_data.mailgun_domain}}</span></div></div></div><div \nng-if=\"ctrl.parent.forwarderInfo.domain_data.no_emails_to_admins_in_cc == \'true\'\"><span class=\"label\">Booking CC Emails\n</span><md-input-container class=\"md-block m-0 p-0\" md-no-float><md-chips \nng-model=\"ctrl.parent.forwarderInfo.domain_data.shipment_cc_emails\" name=\"shipment_cc_emails\" \nplaceholder=\"Write email then Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shipment_cc_emails,\'cc_email\')\" \nmd-on-remove=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shipment_cc_emails,\'cc_email\')\" \nmd-add-on-blur=\"true\" ng-required=\"true\"><md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips><div\n class=\"errors\" ng-messages=\"settingFrm.shipment_cc_emails.$error\" role=\"alert\"><div \nng-show=\"ctrl.parent.invalidEmail && ctrl.parent.email_input_name == \'cc_email\'\">Invalid email address!! we removed it.\n</div></div></md-input-container></div></div></div><div layout=\"row\" class=\"mt-20\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div flex class=\"mr-25 pt-5\">\n<span class=\"label\">Sender Name <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block mt-20 p-0\" \nmd-no-float flex><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.mail_from_name\" name=\"mail_from_name\" placeholder=\"Mail From Name\" \nng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div \nng-messages=\"settingFrm.mail_from_name.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Name is required.</span>\n</div></div></md-input-container></div><div flex><span class=\"label\">Shared Rate Receivers</span><md-input-container \nclass=\"md-block m-0 p-0\" md-no-float><md-chips ng-model=\"ctrl.parent.forwarderInfo.domain_data.shared_rate_receivers\" \nname=\"shared_rate_receivers\" placeholder=\"Write email then Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shared_rate_receivers,\'rec_email\')\" \nmd-on-remove=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shared_rate_receivers,\'rec_email\')\" \nmd-add-on-blur=\"true\"><md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips><div class=\"errors\" \nng-messages=\"settingFrm.shared_rate_receivers.$error\" role=\"alert\"><div \nng-show=\"ctrl.parent.invalidEmail && ctrl.parent.email_input_name == \'rec_email\'\">\nInvalid email address!! we removed it.</div></div></md-input-container></div></div></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"webAppFrm\" step=\"4\" step-title=\"\'WEB + APP\'\" \nhide-step=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'false\'\"><div \nclass=\"ph-10 pt-5 md-inline-form\"><div class=\"font-size-18\"><b>WEB</b> Configuration</div><div layout=\"row\" \nlayout-xs=\"column\" class=\"mv-15\"><div flex-gt-sm=\"33\"><div flex class=\"mr-20\"><span class=\"label\">Toll Free Number\n</span><md-input-container class=\"md-block\" md-no-float><textarea class=\"panel-select h-36-imp\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.toll_free_contact\" name=\"toll_free_contact\" \nplaceholder=\"Enter toll free contact\" md-select-on-focus></textarea></md-input-container></div><div flex class=\"mr-20\">\n<span class=\"label\">FrontEnd URL</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.frontend_url\" \nname=\"frontend_url\" placeholder=\"Frontend URL\" readonly=\"readonly\"></md-input-container></div><div flex layout=\"row\" \nclass=\"mr-20\"><div flex class=\"br pr-10 mr-10\"><span class=\"label\">Booking Number Initials <span class=\"red-fg\">*\n</span></span><md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.shipment_initials\" name=\"shipment_initials\" \nplaceholder=\"Booking Initials\" md-maxlength=\"3\" onkeyup=\"this.value = this.value.toUpperCase()\" \nng-pattern=\"/^[a-zA-Z]{3}/\" ng-disabled=\"ctrl.parent.forwarderInfo.updateView\" \nng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div \nng-messages=\"webAppFrm.shipment_initials.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBooking Initials is required.</span></div><div ng-message=\"md-maxlength\"><span>Maximum 3 character is required.</span>\n</div><div ng-message=\"pattern\"><span>Maximum 3 character is required.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-align=\"center start\" flex><md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.shipment_initial_incremental\" name=\"shipment_initial_incremental\" \naria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" \nng-disabled=\"ctrl.parent.forwarderInfo.updateView\">Incremental</md-checkbox><div layout=\"row\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.shipment_initial_incremental == \'true\'\"><label class=\"pr-10 pt-8\" \nflex=\"50\">Length : <span class=\"error\">*</span></label><label class=\"pt-8\" \nng-if=\"ctrl.parent.forwarderInfo.updateView\">{{ctrl.parent.forwarderInfo.domain_data.shipment_initial_length}}</label>\n<md-input-container class=\"p-0 m-0 md-block\" md-no-float ng-if=\"!ctrl.parent.forwarderInfo.updateView\"><input \nclass=\"panel-select md-input-focused\" type=\"number\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.shipment_initial_length\" name=\"shipment_initial_length\" \nplaceholder=\"5-12\" max=\"12\" min=\"5\" \nng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div \nng-messages=\"webAppFrm.shipment_initial_length.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBooking Length is required.</span></div><div ng-message=\"max\"><span>Enter length between 5 to 12.</span></div><div \nng-message=\"min\"><span>Enter length between 5 to 12.</span></div></div></md-input-container></div></div></div></div>\n<div flex><div layout=\"row\" layout-xs=\"column\"><div flex class=\"mr-25\"><span class=\"label\">\nEnter Terms & Conditions Link</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" type=\"url\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.terms_and_condtion\" \nname=\"terms_and_condtion\" placeholder=\"Enter Terms and condition link\"><div \nng-messages=\"webAppFrm.terms_and_condtion.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Invalid link.</span>\n</div></div></md-input-container></div><div flex><span class=\"label\">Common Email <span class=\"red-fg\">*</span></span>\n<div layout=\"row\"><md-input-container class=\"md-block p-0\" md-no-float flex><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.common_email\" \nname=\"common_email\" placeholder=\"Common email\" ng-pattern=\"ctrl.parent.util.commonEmailRegex\" \nng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div \nng-messages=\"webAppFrm.common_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Common email is required.\n</span></div><div ng-message=\"pattern\"><span>Valid email is required.</span></div></div></md-input-container><span \nclass=\"pt-15\" ng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain\">\n@{{ctrl.parent.forwarderInfo.domain_data.mailgun_domain}}</span></div></div></div><div layout=\"row\" layout-xs=\"column\">\n<div flex class=\"mr-25\"><span class=\"label\">Redirect URL</span><md-input-container class=\"md-block p-0\" md-no-float>\n<input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.redirect_base_url\" \nname=\"redirect_base_url\" placeholder=\"Redirect baseurl\" readonly=\"readonly\"></md-input-container></div><div flex><span \nclass=\"label\">SMS Sender ID</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.sms_sender_id\" \nname=\"sms_sender_id\" placeholder=\"SMS sender ID\" onkeyup=\"this.value = this.value.toUpperCase()\" \nng-pattern=\"/^[a-zA-Z_-]*$/\"><div ng-messages=\"webAppFrm.sms_sender_id.$error\" role=\"alert\"><div ng-message=\"pattern\">\n<span>Invalid SMS Sender ID.</span></div></div></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\">\n<div flex layout=\"row\" class=\"mr-25\"><div flex class=\"br pr-10 mr-10\"><span class=\"label\">Quote Number Initials <span \nclass=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.quote_initials\" \nname=\"quote_initials\" placeholder=\"Quote Initials\" onkeyup=\"this.value = this.value.toUpperCase()\" \nng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\" md-maxlength=\"3\" \nng-pattern=\"/^[a-zA-Z]{3}/\" ng-disabled=\"ctrl.parent.forwarderInfo.updateView\"><div \nng-messages=\"webAppFrm.quote_initials.$error\" role=\"alert\"><div ng-message=\"required\"><span>Quote Initials is required.\n</span></div><div ng-message=\"md-maxlength\"><span>Maximum 3 character is required.</span></div><div \nng-message=\"pattern\"><span>Maximum 3 character is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-align=\"center start\" flex><md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.quote_initial_incremental\" name=\"quote_initial_incremental\" \naria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" \nng-disabled=\"ctrl.parent.forwarderInfo.updateView\">Incremental</md-checkbox><div layout=\"row\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.quote_initial_incremental == \'true\'\"><label class=\"pr-10 pt-8\" flex=\"50\">\nLength : <span class=\"error\">*</span></label><label class=\"pt-8\" ng-if=\"ctrl.parent.forwarderInfo.updateView\">\n{{ctrl.parent.forwarderInfo.domain_data.quote_initial_length}}</label><md-input-container class=\"p-0 m-0 md-block\" \nmd-no-float ng-if=\"!ctrl.parent.forwarderInfo.updateView\"><input class=\"panel-select md-input-focused\" type=\"number\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.quote_initial_length\" name=\"quote_initial_length\" placeholder=\"5-12\" \nmax=\"12\" min=\"5\" ng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div \nng-messages=\"webAppFrm.quote_initial_length.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBooking Length is required.</span></div><div ng-message=\"max\"><span>Enter length between 5 to 12.</span></div><div \nng-message=\"min\"><span>Enter length between 5 to 12.</span></div></div></md-input-container></div></div></div><div \nflex><span class=\"label\">Common Email Reply to <span class=\"red-fg\">*</span></span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.reply_to\" name=\"reply_to\" placeholder=\"Common email reply to\" \ntype=\"email\" ng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\" \nng-pattern=\"ctrl.parent.util.emailRegex\"><div ng-messages=\"webAppFrm.reply_to.$error\" role=\"alert\"><div \nng-message=\"required\"><span>email is required.</span></div><div ng-message=\"pattern\"><span>Enter a valid Email Id\n</span></div></div></md-input-container></div></div></div></div><div class=\"font-size-18\"><b>App</b> Configuration\n</div><div layout=\"row\" class=\"mt-15\" layout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">\nMinimum App Version</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.min_version\" \nname=\"min_version\" placeholder=\"Enter version\"></md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">\nMaximum App Version</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.max_version\" \nname=\"max_version\" placeholder=\"Enter version\"></md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">\nAndroid App Link</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" type=\"url\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.android_link\" name=\"android_link\" \nplaceholder=\"Enter android link\"></md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">ios App Link\n</span><md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" type=\"url\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.ios_link\" name=\"ios_link\" placeholder=\"Enter ios link\">\n</md-input-container></div></div><div class=\"font-size-18\"><b>Terms and Conditions</b></div><div layout=\"row\" \nclass=\"mt-15\" layout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Terms and condition for FCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.tnc_fcl\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Standard terms and condition for FCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.std_tnc_fcl\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Terms and condition for LCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.tnc_lcl\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Standard terms and condition for LCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.std_tnc_lcl\" id=\"termsConditions\" \nng-config=\"ctrl.parent.util.ckEditorConfig\" id=\"termsConditions\"></ng-ckeditor></div></div></div><div layout=\"row\" \nclass=\"mt-15\" layout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Terms and condition for AIR</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.tnc_air\" id=\"termsConditions\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Standard terms and condition for AIR</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.std_tnc_air\" id=\"termsConditions\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"adminFrm\" step=\"5\" step-title=\"\'ADD ADMIN\'\"><div class=\"ph-10 pt-5 user_module\">\n<div class=\"font-size-18\"><b>Admin</b> Account <em>(required)</em></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"mt-15\"><div flex class=\"mr-20\"><span class=\"label\">First Name <span class=\"red-fg\">*</span></span>\n<md-input-container class=\"md-block m-0 p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nclass=\"panel-select md-input-focused\" type=\"text\" ng-model=\"ctrl.parent.forwarderInfo.user_data.user_first_name\" \nng-maxlength=\"25\" name=\"user_first_name\" placeholder=\"Enter First Name\" required><div \nng-messages=\"adminFrm.user_first_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name is required.\n</span></div><div ng-message=\"maxlength\"><span>First Name must not exceed 25 characters.</span></div></div>\n</md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">Last Name <span class=\"red-fg\">*</span></span>\n<md-input-container class=\"md-block m-0 p-0\" md-no-float><input class=\"panel-select md-input-focused\" type=\"text\" \nng-model=\"ctrl.parent.forwarderInfo.user_data.user_last_name\" ng-maxlength=\"25\" name=\"user_last_name\" \nplaceholder=\"Enter Last Name\" required><div ng-messages=\"adminFrm.user_last_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Last Name is required.</span></div><div ng-message=\"maxlength\"><span>\nLast Name must not exceed 25 characters.</span></div></div></md-input-container></div><div flex><span class=\"label\">\nEmail <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block m-0 p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" type=\"email\" ng-model=\"ctrl.parent.forwarderInfo.user_data.email\" name=\"email\" \nplaceholder=\"email@email.com\" ng-pattern=\"ctrl.parent.util.emailRegex\" required><div \nng-messages=\"adminFrm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email is required.</span></div><div \nng-message=\"pattern\"><span translate=\"Email must be a valid e-mail address\">Email must be a valid e-mail address</span>\n</div></div></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\"><div flex class=\"mr-20\"><span \nclass=\"label\">Phone Number</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused tel-input\" type=\"tel\" ng-model=\"ctrl.parent.forwarderInfo.user_data.user_mobile\" \nplaceholder=\"Phone Number\" name=\"user_mobile\" ng-maxlength=\"40\"><div ng-messages=\"adminFrm.user_mobile.$error\" \nclass=\"intl-err\"><div ng-message=\"maxlength\">Phone number must not exceed 40 characters</div></div>\n</md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">Password <span class=\"red-fg\">*</span></span>\n<md-input-container class=\"md-block m-0 p-0\" md-no-float><input class=\"panel-select md-input-focused\" \ntype=\"{{ctrl.parent.showPassword ? \'text\' : \'password\'}}\" ng-model=\"ctrl.parent.forwarderInfo.user_data.password\" \nid=\"psw\" name=\"password\" type=\"password\" placeholder=\"Password\" \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-pattern=\"/^(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\" ng-keyup=\"ctrl.parent.validatePassword()\" \nng-focus=\"ctrl.parent.showPassErr(\'focus\')\" ng-blur=\"ctrl.parent.showPassErr(\'blur\')\" autocomplete=\"new-password\">\n<md-icon md-font-icon=\"{{ctrl.parent.showPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon grey-500-fg pointer\" ng-click=\"ctrl.parent.togglePassword(\'password\')\"></md-icon><div \nng-messages=\"adminFrm.password.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Invalid password.</span></div>\n</div></md-input-container><div id=\"message\"><div>Password must contain the following:</div><div id=\"special\" \nclass=\"passInvalid\">A <b>special</b> character</div><div id=\"number\" class=\"passInvalid\">A <b>number</b></div><div \nid=\"length\" class=\"passInvalid\">Minimum <b>8 characters</b></div></div></div><div flex><span class=\"label\">\nConfirm Password <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block m-0 p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" type=\"{{ctrl.parent.showCurrentPassword ? \'text\' : \'password\'}}\" \nng-model=\"ctrl.parent.forwarderInfo.user_data.user_confirm_password\" name=\"user_confirm_password\" type=\"password\" \nplaceholder=\"Confirm password\" \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-pattern=\"/^(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\"><md-icon \nmd-font-icon=\"{{ctrl.parent.showCurrentPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" class=\"eye-icon grey-500-fg pointer\" \nng-click=\"ctrl.parent.togglePassword(\'current_password\')\"></md-icon><div ng-show=\"ctrl.parent.pass_Error\" \nclass=\"error font-size-12 red-fg\">This password do not match. Please try again.</div><div \nng-messages=\"adminFrm.user_confirm_password.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Invalid password.\n</span></div></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"pt-10 pl-5\"><div \nclass=\"pt-5 pr-20 font-size-14\">Deactivate</div><md-switch style=\"width:32px\" md-no-ink \nng-model=\"ctrl.parent.forwarderInfo.user_data.active_status\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"Switch 1\" class=\"m-0 p-0\"></md-switch><div class=\"pt-5 pl-20 font-size-14\">Activate</div></div></div>\n</ms-horizontal-stepper-step><div class=\"red-fg theme_div ml-10 mt-20\">*Please fill all mandatory details.</div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/roles/dialogs/forwarderForm/forwarder-edit.html","<md-dialog id=\"forwarder-onboard\" class=\"popup-lg\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\" flex=\"80\"><b>FORWARDER</b> Mission Control</div><div layout=\"row\" class=\"p-0\" layout-align=\"end end\" \nflex=\"20\"><md-icon md-font-icon=\"icon-close\" class=\"mr-5 pointer\" ng-click=\"ctrl.parent.cancelDialog(\'close\')\">\n</md-icon></div></div><md-dialog-content class=\"mt-20\"><form name=\"horizontalStepper\" ms-horizontal-stepper \nng-submit=\"ctrl.parent.submit_forwarder(ctrl.parent.forwarderInfo , ctrl.parent.clientsObj, ctrl.parent.forwarderInfo.button_type)\" \nng-model=\"ctrl.parent.horizontalStepper\"><ms-horizontal-stepper-step ng-form=\"ctrl.parent.generalFrm\" step=\"1\" \nstep-title=\"\'GENERAL\'\"><div layout=\"column\" class=\"ph-10 pt-5 md-inline-form\"><div layout=\"row\" layout-xs=\"column\" \nlayout-wrap><div flex class=\"mr-20\"><span class=\"label\">Company Name <span class=\"red-fg\">*</span></span>\n<md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.company_name\" name=\"company_name\" placeholder=\"Enter Company name\" required><div \nng-messages=\"ctrl.parent.generalFrm.company_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Name is required.</span></div></div></md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">\nCompany Email ID <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.company_email\" type=\"email\" \nname=\"company_email\" placeholder=\"Enter Email  ID\" ng-pattern=\"ctrl.parent.util.emailRegex\" required><div \nng-messages=\"ctrl.parent.generalFrm.company_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Email is required.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"Email must be a valid e-mail address\">Email must be a valid e-mail address</span></div></div>\n</md-input-container></div><div flex><span class=\"label\">Phone Number</span><md-input-container class=\"md-block p-0\" \nmd-no-float><input class=\"panel-select md-input-focused tel-input\" type=\"tel\" \nng-model=\"ctrl.parent.forwarderInfo.company_phone_number\" placeholder=\"Phone Number\" name=\"company_phone_number\" \nng-maxlength=\"40\"><div ng-messages=\"ctrl.parent.generalFrm.company_phone_number.$error\" class=\"intl-err\"><div \nng-message=\"maxlength\">Phone number must not exceed 40 characters</div></div></md-input-container></div></div><div \nlayout=\"row\" layout-xs=\"column\" layout-wrap><div flex class=\"mr-25\"><span class=\"label\">No.of Employees</span>\n<md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.number_of_employees\" name=\"number_of_employees\" min=\"1\" type=\"number\" \nplaceholder=\"Enter No.of Employees\"></md-input-container></div><div flex class=\"mr-25 date_input\"><span class=\"label\">\nDate of Establishment</span><date-picker md-input-id=\"\'date_of_establishment\'\" is-editable=\"true\" is-disabled=\"false\" \ninput-required=\"false\" input-name=\"\'date_of_establishment\'\" date-placeholder=\"\'Enter date\'\" full-border=\"true\" \ndate-format=\"true\" model-value=\"ctrl.parent.forwarderInfo.date_of_establishment\" \nmin-date-value=\"ctrl.parent.forwarderInfo.date_of_establishment\" \ncallback=\"ctrl.parent.forwarderInfo.date_of_establishment= value\"></date-picker><div \nng-messages=\"ctrl.parent.generalFrm.date_of_establishment.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div></div><div flex><span class=\"label\">IATA Commission %\n</span><md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.iata_commission\" name=\"iata_commission\" max=\"100\" maxlength=\"4\" type=\"number\" \nplaceholder=\"Enter IATA Commission %\"></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nlayout-wrap><div flex class=\"mr-25\"><span class=\"label\">Incentive %</span><md-input-container class=\"md-block p-0\" \nmd-no-float><input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.incentive\" \nname=\"incentive\" max=\"100\" maxlength=\"4\" type=\"number\" placeholder=\"Enter Incentive %\"></md-input-container></div><div \nflex class=\"mr-25\"><span class=\"label\">Turnover of the Company Sales (In Rs.)</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.company_turnover\" name=\"company_turnover\" min=\"1\" type=\"number\" \nplaceholder=\"Enter your turnover\"></md-input-container></div><div flex><span class=\"label\">Plan Type<span \nclass=\"red-fg\">*</span></span><md-input-container class=\"md-block panel-select mt-6 p-0\" md-no-float><md-select \nng-model=\"ctrl.parent.forwarderInfo.domain_data.plan_type\" placeholder=\"Select Plan Type\" name=\"plan_type\" required>\n<md-option value=\"ESSENTIAL\">ESSENTIAL</md-option><md-option value=\"TRANSFORM\">TRANSFORM</md-option><md-option \nvalue=\"ELITE\">ELITE</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nlayout-wrap><div><div class=\"label mb-15\">Base Currency<span class=\"red-fg\">*</span></div><currency-dropdown \nfield-value=\"ctrl.parent.forwarderInfo.domain_data.base_currency\" currency-list=\"ctrl.parent.currencyList\" \nfull-border=\"true\" is-required=\"true\"></currency-dropdown></div><div class=\"ml-20\"><div class=\"label mb-15\">\nTrial Period</div><div layout=\"column\" class=\"panel-select custom-container-datepicker\"><md-date-range \nng-model=\"ctrl.parent.pickerModel\" class=\"date-range-picker\" placeholder=\"Select dates\" \nmd-on-select=\"ctrl.parent.editDatePicker(ctrl.parent.forwarderInfo,ctrl.parent.pickerModel)\" one-panel=\"true\" \nauto-confirm=\"true\" show-template=\"false\" custom-templates=\"customTemplates\" first-day-of-week=\"firstDayOfWeek\">\n</md-date-range><div class=\"warning\" ng-if=\"ctrl.parent.trialErr\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"orange-300-fg s16 mr-5\"></md-icon>{{ctrl.parent.trialErr}}</div></div></div></div><div layout=\"row\" \nlayout-xs=\"column\" layout-wrap layout-padding><div class=\"mr-10 file_div\" layout=\"column\"><span class=\"label pb-5\">\nCompany Logo</span> <span class=\"font-size-12\" ng-if=\"!ctrl.parent.isPreview && !ctrl.parent.isOrigLogo\">\n.png, .jpg, .jpeg file | Upto 10MB</span><div class=\"input-box\" \nng-if=\"!ctrl.parent.isPreview && !ctrl.parent.isOrigLogo\"><input class=\"panel-select md-input-focused\" \nname=\"company_logo\" type=\"file\" id=\"fileInput_company_logo\" \nngf-select=\"ctrl.parent.fnLogoValidation(\'init\', ctrl.parent.company_logo, $event)\" \nng-model=\"ctrl.parent.company_logo\" ngf-max-size=\"10MB\" accept=\".png, .jpg, .jpeg\"></div><span \nng-if=\"ctrl.parent.generalFrm.company_logo.$error.maxSize\" class=\"font-size-14 red-fg mt-10\">\nThis file is too large, maximum file size is 10MB.</span> <input class=\"panel-select md-input-focused\" \nname=\"company_logo\" type=\"file\" hide id=\"fileEdit_company_logo\" \nngf-select=\"ctrl.parent.fnLogoValidation(\'init\', ctrl.parent.company_logo, $event)\" \nng-model=\"ctrl.parent.company_logo\" ngf-max-size=\"10MB\" accept=\".png, .jpg, .jpeg\"><div class=\"cropped-imgBox mt-15\" \nng-class=\"{\'square\': ctrl.parent.logoStyle===\'square\', \'rectangle\': ctrl.parent.logoStyl===\'rectangle\', \'hide\' : !ctrl.parent.isPreview && !ctrl.parent.isOrigLogo}\">\n<img class=\"cropped-img\" src=\"\"><md-menu md-position-mode=\"left bottom\"><div class=\"overlay\" \nng-click=\"ctrl.parent.openMenu($mdMenu, $event)\"><md-icon class=\"img-icon\" md-font-icon=\"icon-camera\" class=\"mr-5 s18\">\n</md-icon><md-tooltip md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left\" \nstyle=\"display:table;opacity: 1\">Click to view/edit logo</md-tooltip></div><md-menu-content><md-menu-item><md-button \nmd-no-ink class=\"fg-333333 font-size-14\" ng-click=\"ctrl.parent.fnLogoValidation(\'edit\')\"><md-icon \nmd-font-icon=\"icon-pencil\" md-menu-align-target class=\"s16 fg-333333\"></md-icon>Edit</md-button></md-menu-item>\n<md-menu-item><md-button md-no-ink class=\"fg-333333 font-size-14\" ng-click=\"ctrl.parent.fnReplaceLogo()\"><md-icon \nmd-font-icon=\"icon-reply\" class=\"s16 fg-333333\"></md-icon>Replace</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"file_div\" layout=\"column\"><span class=\"label pb-3\">Favicon</span> <span \nclass=\"font-size-12\">(recommended) 42px * 42px | Upto 1MB | .ico file</span> <input \nclass=\"panel-select mt-6-imp md-input-focused\" name=\"favicon\" type=\"file\" id=\"fileInput_favicon\" ngf-select \nng-model=\"ctrl.parent.favicon\" ngf-max-size=\"10MB\" accept=\".ico\" ngf-pattern=\"\'.ico\'\" ngf-model-invalid=\"errorFile\"> <a\n class=\"mt-5 md-link-fg\" ng-href=\"{{ctrl.util.sanitizeQueryParams(ctrl.parent.forwarderInfo.favicon)}}\" \ntarget=\"_blank\" ng-if=\"ctrl.parent.forwarderInfo.favicon\" flex rel=\"noopener\">View Full Image</a> <span \nng-if=\"ctrl.parent.generalFrm.favicon.$error.maxSize\" class=\"font-size-14 red-fg\">\nThis file is too large, maximum file size is 10MB.</span> <span ng-if=\"ctrl.parent.generalFrm.favicon.$error.pattern\" \nclass=\"font-size-14 red-fg\">Please upload only png format files.</span></div><div layout=\"column\" class=\"mt-16-imp\">\n<span class=\"label pb-5\">Primary color</span><div layout=\"row\"><input class=\"panel-select md-input-focused\" \nname=\"secondary_color\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.secondary_color\" \nplaceholder=\"Enter color\" ng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\" class=\"color-picker-input\"> <input \nclass=\"panel-select md-input-focused\" type=\"color\" class=\"color-picker\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.secondary_color\"></div><div \nng-if=\"ctrl.parent.generalFrm.secondary_color.$invalid\"><span class=\"red-fg font-size-12\">Invalid Color Code.</span>\n</div></div><div layout=\"column\" class=\"mt-16-imp\"><span class=\"label pb-5\">Secondary color</span><div layout=\"row\">\n<input class=\"panel-select md-input-focused\" name=\"primary_color\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color\" placeholder=\"Enter color\" \nng-pattern=\"/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/\" class=\"color-picker-input\" \nng-change=\"ctrl.parent.validateSecondaryColor(ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color,ctrl.parent.generalFrm)\">\n <input class=\"panel-select md-input-focused\" type=\"color\" class=\"color-picker\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color\" \nng-change=\"ctrl.parent.validateSecondaryColor(ctrl.parent.forwarderInfo.domain_data.theme_config.primary_color,ctrl.parent.generalFrm)\">\n</div><div ng-if=\"ctrl.parent.generalFrm.primary_color.$invalid\"><span class=\"red-fg font-size-12\">Invalid Color Code.\n</span></div><div ng-if=\"ctrl.parent.generalFrm.$error.constrastClrErr\"><span class=\"red-fg font-size-12\">\nPlease select darker shades.</span></div></div><div layout=\"column\" class=\"mt-16-imp\"><span \nclass=\"label margin-spacing pb-5\">Dark mode</span><div layout=\"row\" layout-align=\"left center\"><div class=\"pr-20\">No\n</div><md-switch md-no-ink md-invert aria-label=\"Switch 7\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.theme_config.dark_mode\" class=\"dark_mode_switch\"></md-switch><div \nclass=\"pl-20\">Yes</div></div></div></div></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step \nng-form=\"addressFrm\" step=\"2\" step-title=\"\'ADDRESS\'\"><div layout=\"row\" class=\"ph-10 pt-5 md-inline-form\" \nlayout-xs=\"column\"><div flex class=\"pr-20 mr-20\" flex=\"40\"><span class=\"label\">Company Address</span>\n<md-input-container class=\"md-block p-0\" md-no-float><ng-ckeditor ng-config=\"ctrl.parent.util.ckEditorConfig\" \nclass=\"company_address\" ng-model=\"ctrl.parent.forwarderInfo.company_address\" name=\"company_address\" \nplaceholder=\"Company address\" rows=\"5\"></ng-ckeditor></md-input-container></div><div layout=\"column\" flex><div \nlayout=\"row\"><div flex class=\"mr-25\"><span class=\"label\">Company Website <span class=\"red-fg\">*</span></span>\n<md-input-container class=\"md-block mt-8 p-0\" md-no-float><input type=\"text\" class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.company_website_url\" name=\"company_website_url\" \nplaceholder=\"Enter Company Website\" required><div ng-messages=\"addressFrm.company_website_url.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Invalid Company Website.</span></div></div></md-input-container></div><div flex><span \nclass=\"label\">Company Tracking URL</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.company_tracking_url\" \nname=\"company_tracking_url\" placeholder=\"Enter Company Tracking URL\"></md-input-container></div></div><div \nlayout=\"row\"><div flex class=\"mr-25\"><span class=\"label\">State</span><md-input-container class=\"md-block p-0\" \nmd-no-float><input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.state\" name=\"state\" \nplaceholder=\"State\"></md-input-container></div><div flex><span class=\"label\">Country</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.country\" name=\"country\" placeholder=\"Country\"></md-input-container></div></div><div\n layout=\"row\"><div flex class=\"mr-25\"><span class=\"label\">Zip Code/Pin Code</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.postal_code\" ng-pattern=\"/[A-Za-z0-9][A-Za-z0-9\\- ]{0,10}[A-Za-z0-9]$/\" \nname=\"postal_code\" placeholder=\"Postal code\"><div ng-messages=\"addressFrm.postal_code.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Invalid code.</span></div></div></md-input-container></div></div></div></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"settingFrm\" step=\"3\" step-title=\"\'SETTINGS\'\"><div \nclass=\"ph-10 pt-5 md-inline-form\"><div layout=\"row\" layout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">\nDomain Name <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain\" name=\"domain\" \nplaceholder=\"Domain name\" ng-change=\"ctrl.parent.getDomainUrl(ctrl.parent.forwarderInfo)\" \nonkeyup=\"this.value = this.value.toLowerCase()\" \nng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.[a-z]{2,10}$/i\" required><div \nng-messages=\"settingFrm.domain.$error\" role=\"alert\"><div ng-message=\"required\"><span>Domain Name is required.</span>\n</div><div class=\"errors\" ng-if=\"settingFrm.domain.$error.pattern\">Invalid domain name.</div></div>\n</md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">Solution Name <span class=\"red-fg\">*</span>\n</span><md-input-container class=\"md-block panel-select mt-6 p-0\" md-no-float><md-select \nng-model=\"ctrl.parent.forwarderInfo.domain_data.solution_type\" placeholder=\"Select Solution Type\" name=\"solution_type\" \nng-change=\"ctrl.parent.getNwlsData(ctrl.parent.forwarderInfo)\" required><md-option value=\"WLS\">WLS</md-option>\n<md-option value=\"NWLS\">NWLS</md-option></md-select><div ng-messages=\"settingFrm.solution_type.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Solution Name is required.</span></div></div></md-input-container></div><div flex><div\n class=\"b font-size-16 brad-10 h-50 mt-6\" layout=\"row\" layout-align=\"center center\"><span class=\"pr-10\">\nMail Domain Verified Status</span> <span class=\"pr-20\">No</span><md-switch style=\"width:32px\" md-invert md-no-ink \naria-label=\"Switch 7\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status\" \nng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" \nng-disabled=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'NWLS\'\"></md-switch><span class=\"pl-20\">Yes</span>\n</div></div></div><div layout=\"row\" layout-xs=\"column\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div class=\"br\" flex-gt-sm=\"40\" \nlayout=\"column\"><md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.document_submit_required\" name=\"document_submit_required\" \naria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\">Document Submit Required</md-checkbox>\n<md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.shipment_notification_from_specialist\" \nname=\"shipment_notification_from_specialist\" aria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\">\nBooking Notification by Specialist</md-checkbox><md-checkbox md-no-ink class=\"mt-5\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.no_emails_to_admins_in_cc\" name=\"no_emails_to_admins_in_cc\" \naria-label=\"Checkbox 1\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\">No Emails to Admin in CC</md-checkbox></div>\n<div flex class=\"ml-20\" layout=\"column\" layout-align=\"center\"><div layout=\"row\" layout-xs=\"column\"><div flex \nclass=\"mr-25\"><span class=\"label\">Mail API Key <span class=\"red-fg\">*</span></span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.mailgun_apikey\" name=\"mailgun_apikey\" placeholder=\"Mail api key\" \nrequired ng-disabled=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'NWLS\'\"><div \nng-messages=\"settingFrm.mailgun_apikey.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMailgun api key is required.</span></div></div></md-input-container></div><div flex><span class=\"label\">Mail Domain \n<span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain\" \nname=\"mailgun_domain\" placeholder=\"Mail domain\" ng-pattern=\"/[\\w\\-~]+(\\.[\\w\\-~]+)+(\\/[\\w\\-~]*)*(#[\\w\\-]*)?(\\?.*)?/\" \nrequired ng-disabled=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'NWLS\'\"><div \nng-messages=\"settingFrm.mailgun_domain.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMailgun domain is required.</span></div><div ng-message=\"pattern\"><span>Valid domain is required.</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\"><div flex class=\"mr-25\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.document_submit_required == \'true\'\"><span class=\"label\">\nDocument Submit Email <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.document_submit_email\" \ntype=\"email\" name=\"document_submit_email\" placeholder=\"Document submit email\" ng-pattern=\"ctrl.parent.util.emailRegex\" \nrequired><div ng-messages=\"settingFrm.document_submit_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDocument submit email is required.</span></div><div ng-message=\"pattern\"><span>Enter a valid Email Id</span></div>\n</div></md-input-container></div><div flex ng-if=\"ctrl.parent.forwarderInfo.domain_data.solution_type == \'WLS\'\"><span \nclass=\"label\">Send Booking Confirmation to</span><div layout=\"row\"><md-input-container class=\"md-block p-0\" \nmd-no-float flex><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.send_shipment_booking_confirmation\" \nname=\"send_shipment_booking_confirmation\" placeholder=\"Enter booking confirmation\" \nng-pattern=\"ctrl.parent.util.commonEmailRegex\"><div ng-messages=\"settingFrm.send_shipment_booking_confirmation.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Valid mail is required.</span></div></div></md-input-container><span \nclass=\"pt-15\" ng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain\">\n@{{ctrl.parent.forwarderInfo.domain_data.mailgun_domain}}</span></div></div></div><div \nng-if=\"ctrl.parent.forwarderInfo.domain_data.no_emails_to_admins_in_cc == \'true\'\"><span class=\"label\">Booking CC Emails\n</span><md-input-container class=\"md-block m-0 p-0\" md-no-float><md-chips \nng-model=\"ctrl.parent.forwarderInfo.domain_data.shipment_cc_emails\" name=\"shipment_cc_emails\" \nplaceholder=\"Write email then Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shipment_cc_emails,\'cc_email\')\" \nmd-on-remove=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shipment_cc_emails,\'cc_email\')\" \nmd-add-on-blur=\"true\" ng-required=\"true\"><md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips><div\n class=\"errors\" ng-messages=\"settingFrm.shipment_cc_emails.$error\" role=\"alert\"><div \nng-show=\"ctrl.parent.invalidEmail && ctrl.parent.email_input_name == \'cc_email\'\">Invalid email address!! we removed it.\n</div></div></md-input-container></div></div></div><div layout=\"row\" class=\"mt-20\" \nng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div flex class=\"mr-25 pt-5\">\n<span class=\"label\">Sender Name<span class=\"red-fg\">*</span></span><md-input-container class=\"md-block mt-20 p-0\" \nmd-no-float flex><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.mail_from_name\" name=\"mail_from_name\" placeholder=\"Mail From Name\" \nng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div \nng-messages=\"settingFrm.mail_from_name.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Name is required.</span>\n</div></div></md-input-container></div><div flex><span class=\"label\">Shared Rate Receivers</span><md-input-container \nclass=\"md-block m-0 p-0\" md-no-float><md-chips ng-model=\"ctrl.parent.forwarderInfo.domain_data.shared_rate_receivers\" \nname=\"shared_rate_receivers\" placeholder=\"Write email then Enter\" secondary-placeholder=\"+Email\" \nmd-on-add=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shared_rate_receivers,\'rec_email\')\" \nmd-on-remove=\"ctrl.parent.validateEmail(ctrl.parent.forwarderInfo.domain_data.shared_rate_receivers,\'rec_email\')\" \nmd-add-on-blur=\"true\"><md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips><div class=\"errors\" \nng-messages=\"settingFrm.shared_rate_receivers.$error\" role=\"alert\"><div \nng-show=\"ctrl.parent.invalidEmail && ctrl.parent.email_input_name == \'rec_email\'\">\nInvalid email address!! we removed it.</div></div></md-input-container></div></div></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"webAppFrm\" step=\"4\" step-title=\"\'WEB + APP\'\"><div \nclass=\"ph-10 pt-5 md-inline-form\"><div class=\"font-size-18\"><b>WEB</b> Configuration</div><div layout=\"row\" \nlayout-xs=\"column\" class=\"mv-15\"><div flex-gt-sm=\"33\"><div flex class=\"mr-20\"><span class=\"label\">Toll Free Number\n</span><md-input-container class=\"md-block p-0\" md-no-float><textarea class=\"panel-select h-36-imp\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.toll_free_contact\" name=\"toll_free_contact\" \nplaceholder=\"Enter toll free contact\" style=\"height: 36px\" md-select-on-focus></textarea></md-input-container></div>\n<div flex class=\"mr-20\"><span class=\"label\">FrontEnd URL</span><md-input-container class=\"md-block p-0\" md-no-float>\n<input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.frontend_url\" \nname=\"frontend_url\" placeholder=\"Frontend URL\" readonly=\"readonly\"></md-input-container></div><div flex layout=\"row\" \nclass=\"mr-20\"><div flex class=\"pr-10 mr-10\"><span class=\"label\">Booking Number Initials <span class=\"red-fg\">*</span> \n</span><br><div class=\"font-size-14 pt-15\">{{ctrl.parent.forwarderInfo.domain_data.shipment_initials}} <span \nng-show=\"ctrl.parent.forwarderInfo.domain_data.shipment_initial_length\">\n- Incremental length : {{ctrl.parent.forwarderInfo.domain_data.shipment_initial_length}}</span></div></div></div></div>\n<div flex><div layout=\"row\" layout-xs=\"column\"><div flex class=\"mr-25\"><span class=\"label\">\nEnter Terms & Conditions Link</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" type=\"url\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.terms_and_condtion\" \nname=\"terms_and_condtion\" placeholder=\"Enter Terms and condition link\"><div \nng-messages=\"webAppFrm.terms_and_condtion.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Invalid link.</span>\n</div></div></md-input-container></div><div flex><span class=\"label\">Common Email <span class=\"red-fg\">*</span></span>\n<div layout=\"row\"><md-input-container class=\"md-block p-0\" md-no-float flex><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.common_email\" \nname=\"common_email\" placeholder=\"Common email\" ng-pattern=\"ctrl.parent.util.commonEmailRegex\" \nng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\"><div \nng-messages=\"webAppFrm.common_email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Common email is required.\n</span></div><div ng-message=\"pattern\"><span>Valid email is required.</span></div></div></md-input-container><span \nclass=\"pt-15\" ng-if=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain\">\n@{{ctrl.parent.forwarderInfo.domain_data.mailgun_domain}}</span></div></div></div><div layout=\"row\" layout-xs=\"column\">\n<div flex class=\"mr-25\"><span class=\"label\">Redirect URL</span><md-input-container class=\"md-block p-0\" md-no-float>\n<input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.redirect_base_url\" \nname=\"redirect_base_url\" placeholder=\"Redirect baseurl\" readonly=\"readonly\"></md-input-container></div><div flex><span \nclass=\"label\">SMS Sender ID</span><md-input-container class=\"md-block p-0\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.forwarderInfo.domain_data.sms_sender_id\" \nname=\"sms_sender_id\" placeholder=\"SMS sender ID\" onkeyup=\"this.value = this.value.toUpperCase()\" \nng-pattern=\"/^[a-zA-Z_-]*$/\"><div ng-messages=\"webAppFrm.sms_sender_id.$error\" role=\"alert\"><div ng-message=\"pattern\">\n<span>Invalid SMS Sender ID.</span></div></div></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\">\n<div flex layout=\"row\" class=\"mr-25\"><div flex class=\"pr-10 mr-10\"><span class=\"label\">Quote Number Initials <span \nclass=\"red-fg\">*</span> </span><br><div class=\"font-size-14 pt-15\">\n{{ctrl.parent.forwarderInfo.domain_data.quote_initials}} <span \nng-show=\"ctrl.parent.forwarderInfo.domain_data.quote_initial_length\">\n- Incremental length : {{ctrl.parent.forwarderInfo.domain_data.quote_initial_length}}</span></div></div></div><div \nflex><span class=\"label\">Common Email Reply to <span class=\"red-fg\">*</span></span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.reply_to\" name=\"reply_to\" placeholder=\"Common email reply to\" \ntype=\"email\" ng-required=\"ctrl.parent.forwarderInfo.domain_data.mailgun_domain_verified_status == \'true\'\" \nng-pattern=\"ctrl.parent.util.emailRegex\"><div ng-messages=\"webAppFrm.reply_to.$error\" role=\"alert\"><div \nng-message=\"required\"><span>email is required.</span></div><div ng-message=\"pattern\"><span>Enter a valid Email Id\n</span></div></div></md-input-container></div></div></div></div><div class=\"font-size-18\"><b>API</b> Configuration\n</div><ng-form name=\"configration\"><div layout=\"row\" class=\"mt-15\" layout-xs=\"column\"><div flex class=\"mr-20\"><span \nclass=\"label\">Config <span class=\"red-fg\">*</span></span><md-input-container class=\"md-block mt-8 p-0\" md-no-float>\n<md-select ng-model=\"ctrl.parent.oauthGenerate.environment\" placeholder=\"Select Config\" name=\"environment\"><md-option \nvalue=\"Production\">Production</md-option><md-option value=\"Sandbox\">Sandbox</md-option></md-select>\n</md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">Daily Limit <span class=\"red-fg\">*</span></span>\n<md-input-container class=\"md-block mt-8 p-0\" md-no-float><input type=\"number\" \nng-model=\"ctrl.parent.oauthGenerate.limit\" name=\"daily_limit\" placeholder=\"Enter Daily Limit\"></md-input-container>\n</div><div flex class=\"mr-20\"><span class=\"label\">Expiry Days <span class=\"red-fg\">*</span></span><md-input-container \nclass=\"md-block mt-8 p-0\" md-no-float><input type=\"number\" ng-model=\"ctrl.parent.oauthGenerate.trialExpiryInDays\" \nname=\"expiry_day\" placeholder=\"Enter Expiry Days\"></md-input-container></div><div flex class=\"mt-20\"><md-button \nmd-no-ink class=\"md-accent-btn w-70 m-0\" ng-click=\"ctrl.parent.fnClientGenerate(ctrl.parent.oauthGenerate)\" \nng-disabled=\"ctrl.parent.oauthGenerate.environment === null || ctrl.parent.oauthGenerate.limit === null || ctrl.parent.oauthGenerate.trialExpiryInDays === null\">\nSave</md-button></div></div></ng-form><div layout-xs=\"column\" class=\"mt-1 mb-10\" \nng-repeat=\"(key, client) in ctrl.parent.clientsObj\"><div layout=\"row\" layout-align=\"start\" ng-if=\"client.length !== 0\" \nlayout-gt-sm=\"row\"><div class=\"font-size-15 font-weight-500\">{{ key }}</div><div><md-switch md-no-ink md-invert \naria-label=\"Switch 7\" ng-model=\"client[0].enabled\" class=\"enabled-switch-button\" \nng-change=\"ctrl.parent.fnEnableDisableApi(client[0])\"></md-switch></div></div><product-api-config clientdata=\"client\" \ndisplaytype=\'\"row\"\' iseditable=\"true\"></product-api-config></div><div layout=\"row\" class=\"mt-15\" layout-xs=\"column\">\n<div flex class=\"mr-20\"><span class=\"label\">Minimum App Version</span><md-input-container class=\"md-block p-0\" \nmd-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.min_version\" name=\"min_version\" placeholder=\"Enter version\">\n</md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">Maximum App Version</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.max_version\" name=\"max_version\" placeholder=\"Enter version\">\n</md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">Android App Link</span><md-input-container \nclass=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" type=\"url\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.android_link\" name=\"android_link\" \nplaceholder=\"Enter android link\"></md-input-container></div><div flex class=\"mr-20\"><span class=\"label\">ios App Link\n</span><md-input-container class=\"md-block p-0\" md-no-float><input class=\"panel-select md-input-focused\" type=\"url\" \nng-model=\"ctrl.parent.forwarderInfo.domain_data.app_config.ios_link\" name=\"ios_link\" placeholder=\"Enter ios link\">\n</md-input-container></div></div><div class=\"font-size-18\"><b>Terms and Conditions</b></div><div layout=\"row\" \nclass=\"mt-15\" layout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Terms and condition for FCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.tnc_fcl\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Standard terms and condition for FCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.std_tnc_fcl\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Terms and condition for LCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.tnc_lcl\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Standard terms and condition for LCL</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.std_tnc_lcl\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Terms and condition for AIR</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.tnc_air\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div><div layout=\"row\" class=\"mt-15\" \nlayout-xs=\"column\"><div flex class=\"mr-20\"><span class=\"label\">Standard terms and condition for AIR</span><div \nclass=\"quote-editor\"><ng-ckeditor ng-model=\"ctrl.parent.forwarderInfo.std_tnc_air\" \nng-config=\"ctrl.parent.util.ckEditorConfig\"></ng-ckeditor></div></div></div></div></ms-horizontal-stepper-step><div \nclass=\"red-fg theme_div ml-10 mt-20\">*Please fill all mandatory details.</div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/roles/dialogs/permission/user-permissions.html","<md-dialog id=\"user-permission\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"white-bg black-fg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"font-size-16 font-weight-600\">PERMISSIONS</span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" class=\"black-fg\">\n</md-icon></md-button></div><div layout=\"row\" flex=\"100\" class=\"white-bg black-fg\"><div layout=\"row\" \nclass=\"font-weight-600 font-size-17 ml-25 pt-15\" flex=\"50\" layout-align=\"start center\">\nUser : {{ctrl.parent.shipper_user_name}}</div><div layout=\"row\" class=\"mr-10\" layout-align=\"end end\" flex=\"50\">\n<md-button md-no-ink class=\"md-accent-btn\" ng-click=\"ctrl.parent.addModule(ctrl.parent.modulePermissions.length)\" \ntitle=\"Add module\">+ Add Module</md-button></div></div></md-toolbar><md-dialog-content ms-scroll class=\"pt-0\"><div \nclass=\"search_div mt-20 ml-15\" layout=\"row\" flex=\"50\" flex-xs=\"100\"><md-input-container \nclass=\"md-block m-0 p-0 b h-35 width100\" md-no-float><md-icon md-font-icon=\"icon-magnify\" class=\"grey-400-fg s22\">\n</md-icon><input class=\"border-none pt-8 pl-30\" ng-model=\"searchPermissions\" name=\"searchQuotes\" \nplaceholder=\"Search Modules\"></md-input-container></div><div class=\"simple-table-container status_table\"><div \nclass=\"white-bg md-whiteframe-4dp rate_table\"><table class=\"simple text-center\" ms-responsive-table><thead><tr><th \nrowspan=\"2\">Module</th><th rowspan=\"2\">Code</th><th colspan=\"4\" class=\"border-none\">Permission</th><th rowspan=\"2\">\nAction</th></tr><tr><th>Create <span class=\"pl-15 grey-400-fg\">|</span></th><th>Read <span class=\"pl-15 grey-400-fg\">|\n</span></th><th>Update <span class=\"pl-15 grey-400-fg\">|</span></th><th>Delete</th></tr></thead><tbody><tr \nng-repeat=\"permission in ctrl.parent.modulePermissions | filter : searchPermissions track by $index\" \nng-if=\"permission.is_assigned==1\"><td><span class=\"text-capitalize\" ng-if=\"!ctrl.parent.editMode[$index]\">\n{{permission.title}}</span><md-input-container md-no-float class=\"selectbox\" ng-if=\"ctrl.parent.editMode[$index]\">\n<md-select ng-model=\"permission.module_code\" name=\"module_code\" class=\"m-0 select_box\" placeholder=\"Select Module\" \nng-change=\"ctrl.parent.moduleChange(permission)\" required focus-me=\"{{ctrl.parent.editMode[$index]}}\" \nmd-on-close=\"searchModule = \'\'\"><md-select-header><input ng-model=\"searchModule\" type=\"search\" \nplaceholder=\"Search Module\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"module in ctrl.parent.available_modules | filter : searchModule\" ng-value=\"module.module_code\">\n{{module.title}}</md-option></md-select></md-input-container></td><td>{{permission.module_code}}</td><td><md-checkbox \nmd-no-ink ng-model=\"permission.permissions.create\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"ml-5\" \nng-disabled=\"!permission.is_custom\"></md-checkbox></td><td><md-checkbox md-no-ink \nng-model=\"permission.permissions.read\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"ml-5\" \nng-disabled=\"!permission.is_custom\"></md-checkbox></td><td><md-checkbox md-no-ink \nng-model=\"permission.permissions.edit\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"ml-5\" \nng-disabled=\"!permission.is_custom\"></md-checkbox></td><td><md-checkbox md-no-ink \nng-model=\"permission.permissions.delete\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"ml-5\" \nng-disabled=\"!permission.is_custom\"></md-checkbox></td><td><md-icon ng-if=\"permission.is_custom === true\" \nclass=\"cursor delete_icon font-size-20\" md-font-icon=\"icon-minus-circle\" title=\"Remove\" \nng-click=\"ctrl.parent.removeModule(permission,$index)\"></md-icon><span ng-if=\"permission.is_custom === false\">-</span>\n</td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><md-button md-no-ink class=\"md-accent-btn\" ng-click=\"ctrl.parent.fnSubmitUserPermission()\" title=\"Submit\" \nng-disabled=\"taskForm.$invalid\">Submit</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/roles/dialogs/shipperForm/shipper_form.html","<md-dialog id=\"create-shipper\" class=\"shipper popup-md\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div>{{ctrl.parent.shipperInfo.form_heading}} Company</div><span flex></span><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog(\'CloseBy Icon\')\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><form name=\"shippers_form\" novalidate \nautocomplete=\"off\" \nng-submit=\"ctrl.parent.submit_shipper(shippers_form, ctrl.parent.shipperInfo , ctrl.parent.shipperInfo.button_type)\">\n<md-dialog-content class=\"body pt-0\"><md-tabs md-border-bottom md-dynamic-height \nmd-selected=\"ctrl.parent.selectedIndex\"><md-tab label=\"General\"><md-content><div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\" \nng-if=\"ctrl.parent.util.isFreightbro\"><label>Select Forwarder</label><div shimmer-effect-full width=\"100%\" \nheight=\"30px\" class=\"mt-15\" ng-if=\"ctrl.parent.forwarderLoading\" ng-repeat=\"shimmer in [1]\"></div><md-input-container \nclass=\"input_container\" md-no-float ng-if=\"!ctrl.parent.shipperInfo.updateView && !ctrl.parent.forwarderLoading\">\n<md-select class=\"panel-select\" md-no-asterisk name=\"roles\" placeholder=\"Forwarder\" \nng-model=\"ctrl.parent.shipperInfo.assignor_company_id\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-Forwarder-Change\' ,ctrl.parent.shipperInfo.form_heading, searchCompany )\" \nmd-on-close=\"searchCompany = \'\'\" required><md-select-header><input ng-model=\"searchCompany\" type=\"search\" \nplaceholder=\"Search Company\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"\"><md-option ng-value=\"roles.id\" \nng-repeat=\"roles in ctrl.parent.forwarderList | orderBy:\'company_name\' | filter : {\'company_name\':searchCompany}\"><span\n class=\"font-weight-600\">{{roles.company_name}}</span></md-option></md-optgroup></md-select><div \nng-messages=\"shippers_form.roles.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please select forwarder.</span>\n</div></div></md-input-container><p ng-if=\"ctrl.parent.shipperInfo.updateView\" ng-bind=\"ctrl.parent.AssignorName\"></p>\n</div><div layout=\"column\" flex=\"100\" layout-xs=\"column\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label>\nCompany Name</label><md-input-container class=\"input_container\" md-no-float><input id=\"shipper-company-name\" \nclass=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper,\'validation-error\':ctrl.parent.companyNameValidation}\" \nng-model=\"ctrl.parent.shipperInfo.company_name\" name=\"company_name\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.company_name) ? \'N/A\' : \'Company name\' }} \" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" ng-keyup=\"ctrl.parent.companyNameValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-CompanyName-Change\',ctrl.parent.shipperInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"shippers_form.company_name.$error\" role=\"alert\"><div ng-if=\"ctrl.parent.companyNameValidation\" \nclass=\"validation-error-text\"><span>Enter Company Name</span></div></div></md-input-container></div></div><div \nlayout=\"column\" flex=\"100\" class=\"row-spacing\" layout-xs=\"column\"><label flex=\"15\" flex-xs=\"100\" class=\"mb-6-imp\">Type\n</label><md-radio-group ng-model=\"ctrl.parent.shipperInfo.type\" layout=\"row\" flex flex-xs=\"100\" layout-xs=\"column\" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-CompanyType-Change\',ctrl.parent.shipperInfo.type ,ctrl.parent.shipperInfo.form_heading)\">\n<md-radio-button md-no-ink value=\"SHIPPER\" class=\"md-primary\">Customer</md-radio-button><md-radio-button md-no-ink \nvalue=\"CONSIGNOR\" class=\"md-primary\">Consignor</md-radio-button><md-radio-button md-no-ink value=\"CONSIGNEE\" \nclass=\"md-primary\">Consignee</md-radio-button></md-radio-group></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nclass=\"row-spacing\"><div layout=\"column\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\"><label>Email ID</label>\n<md-input-container class=\"input_container\" md-no-float><input id=\"shipper-email\" \nclass=\"panel-select md-input-focused\" title=\"{{ctrl.parent.shipperInfo.company_email}}\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\': ctrl.parent.shipperInfo.viewShipper || (ctrl.parent.shipperInfo.updateView && !ctrl.parent.editEmail),\'validation-error\':ctrl.parent.emailValidation }\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-EmailId-Change\',ctrl.parent.shipperInfo.form_heading)\" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper || (ctrl.parent.shipperInfo.updateView && !ctrl.parent.editEmail)\" \nng-keyup=\"ctrl.parent.emailValidation=false\" ng-model=\"ctrl.parent.shipperInfo.company_email\" type=\"email\" \nname=\"company_email\" \nplaceholder=\"{{ (ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.company_email) ? \'N/A\' : \'Email\'}}\" \nng-pattern=\"ctrl.parent.util.emailRegex\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-if=\"ctrl.parent.emailValidation && !shippers_form.company_email.$error.pattern\" class=\"validation-error-text\"><span>\nEnter a valid Email Id</span></div><div ng-messages=\"shippers_form.company_email.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span translate=\"Email must be a valid e-mail address\">Email must be a valid e-mail address</span>\n</div></div></md-input-container></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><label>Phone Number</label><md-input-container \nclass=\"mobile-spacing input_container\" md-no-float><input id=\"shipper-phone\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" \nclass=\"panel-select md-input-focused tel-input\" type=\"tel\" title=\"{{ctrl.parent.shipperInfo.company_phone_number}}\" \nng-model=\"ctrl.parent.shipperInfo.company_phone_number\" \nplaceholder=\"{{ (ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.company_phone_number) ? \'N/A\' : \'Phone Number\'}}\" \nname=\"company_phone_number\" ng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" ng-maxlength=\"40\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-PhoneNumber-Change\' ,ctrl.parent.shipperInfo.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"shippers_form.company_phone_number.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><label>Point of Contact</label><md-input-container class=\"input_container\" \nmd-no-float><input id=\"point-of-contract\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.shipperInfo.point_of_contact\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-PointOfContact-Change\',ctrl.parent.shipperInfo.form_heading)\" \nname=\"point_of_contact\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.point_of_contact) ? \'N/A\' : \'Point of Contact\' }}\" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label>\nCompany Reference</label><md-input-container class=\"input_container\" md-no-float><input id=\"shipper-iec\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" \nclass=\"panel-select md-input-focused\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"ctrl.parent.shipperInfo.iec_number\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-ExporterReferenceID-Change\',ctrl.parent.shipperInfo.form_heading)\" \nname=\"iec_number\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.iec_number) ? \'N/A\' : \'Reference ID\' }}\" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"shippers_form.iec_number.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nCompany Reference is invalid.</span></div></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><label>\nLanguage <span class=\"error\">*</span></label><div shimmer-effect-full width=\"100%\" height=\"30px\" class=\"mt-15\" \nng-if=\"ctrl.parent.languageLoading\" ng-repeat=\"shimmer in [1]\"></div><md-input-container class=\"input_container\" \nmd-no-float ng-if=\"!ctrl.parent.languageLoading\"><md-select \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper,\'validation-error\':ctrl.parent.languageValidation}\" \nclass=\"panel-select\" ng-model=\"ctrl.parent.shipperInfo.company_default_language\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-Language-Change\', ctrl.parent.shipperInfo.company_default_language, ctrl.parent.shipperInfo.form_heading); ctrl.parent.languageValidation=false\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.company_default_language) ? \'N/A\' : \'Select Language\' }}\" \nmd-on-close=\"searchLanguage = \'\'\" ng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" name=\"company_default_language\" \nrequired><md-select-header><input ng-model=\"searchLanguage\" type=\"search\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.company_default_language) ? \'N/A\' : \'Search Language\' }}\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-option \nng-repeat=\"language in ctrl.parent.languageList | orderBy:\'language_name\' | filter : {language_name : searchLanguage}\" \nng-value=\"language.language_code\">{{language.language_name}}</md-option></md-select><div \nng-if=\"ctrl.parent.languageValidation\" class=\"validation-error-text\"><span>Please select a language</span></div>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div \nlayout=\"column\" flex=\"100\" class=\"feild-spacing mobile-spacing\" flex-xs=\"100\"><label>Street Address</label>\n<md-input-container class=\"input_container\" md-no-float><input class=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" \ntitle=\"{{ctrl.parent.shipperInfo.company_address}}\" ng-model=\"ctrl.parent.shipperInfo.company_address\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-CompanyAddress-Change\',ctrl.parent.shipperInfo.form_heading)\" \nname=\"company_address\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.company_address) ? \'N/A\' : \'Street Address\' }} \" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div \nlayout=\"column\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\"><label>Country</label><div shimmer-effect-full \nwidth=\"100%\" height=\"30px\" class=\"mt-15\" ng-if=\"vm.isDataLoading\" ng-repeat=\"shimmer in [1]\"></div><md-input-container \nclass=\"input_container\" md-no-float ng-if=\"!vm.isDataLoading\"><md-select \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" class=\"panel-select\" \nng-model=\"ctrl.parent.shipperInfo.country\" \nng-change=\"ctrl.parent.countrySelected(ctrl.parent.shipperInfo.country); ctrl.parent.fnTrackEvent(\'Shipper-Country-Change\', ctrl.parent.shipperInfo.country ,ctrl.parent.shipperInfo.form_heading,searchCountry)\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.country) ? \'N/A\' : \'Choose Country\' }}\" \nmd-on-close=\"ctrl.parent.searchCountry = \'\'\" ng-disabled=\"ctrl.parent.shipperInfo.viewShipper\"><md-select-header><input\n ng-model=\"searchCountry\" type=\"search\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.country) ? \'N/A\' : \'Search Country\' }}\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-option \nng-repeat=\"country in ctrl.parent.countryList  | orderBy:\'country_name\' | filter : {country_name : searchCountry}\" \nng-value=\"country.country_name\">{{country.country_name}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"50\" class=\"feild-spacing mobile-spacing\" flex-xs=\"100\" class=\"mobile-spacing\"><label>State\n</label><div shimmer-effect-full width=\"100%\" height=\"30px\" class=\"mt-15\" ng-if=\"vm.isDataLoading\" \nng-repeat=\"shimmer in [1]\"></div><md-input-container class=\"input_container\" md-no-float ng-if=\"!vm.isDataLoading\">\n<md-select \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper || !ctrl.parent.stateList.length}\" \nclass=\"panel-select\" ng-disabled=\"!ctrl.parent.stateList.length || ctrl.parent.shipperInfo.viewShipper \" \nng-model=\"ctrl.parent.shipperInfo.state\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-State-Change\',ctrl.parent.shipperInfo.form_heading, searchStates)\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.state) ? \'N/A\' : \'State\' }}\" \nmd-on-close=\"searchStates = \'\'\"><md-select-header><input ng-model=\"searchStates\" type=\"search\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.state) ? \'N/A\' : \'Search States\' }}\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-option ng-repeat=\"state in ctrl.parent.stateList | orderBy:\'state_name\' | filter : {state_name : searchStates}\" \nng-value=\"state.state_name\">{{state.state_name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"50\" class=\"feild-spacing\" \nflex-xs=\"100\"><label>City</label><md-input-container class=\"input_container\" md-no-float><input \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.shipperInfo.city\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-City-Change\',ctrl.parent.shipperInfo.form_heading)\" name=\"city\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.city) ? \'N/A\' : \'City\'}} \" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div layout=\"column\" flex=\"50\" class=\"feild-spacing\" flex-xs=\"100\"><label>\nZip Code/ Postal Code</label><md-input-container class=\"input_container\" md-no-float><input \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.shipperInfo.postal_code\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-PostalCode-Change\',ctrl.parent.shipperInfo.form_heading)\" \nng-pattern=\"/[A-Za-z0-9][A-Za-z0-9\\- ]{0,10}[A-Za-z0-9]$/\" name=\"postal_code\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.postal_code) ? \'N/A\' : \'Postal code\'}} \" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div></div></div></md-content></md-tab><md-tab label=\"Integration Details\" \nng-if=\"ctrl.parent.tms_enabled\"><md-content><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div \nlayout=\"column\" flex=\"100\" layout-xs=\"column\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label>\nExternal Reference Code<md-icon id=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" class=\"mr-5\"><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\">Reference number of the customer in the source system</md-tooltip></md-icon>\n</label><md-input-container class=\"input_container\" md-no-float><input id=\"external_reference_id\" ng-maxlength=\"256\" \nclass=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper,\'validation-error\':ctrl.parent.tmsReferenceIDValidation}\" \nng-model=\"ctrl.parent.shipperInfo.external_reference_id\" name=\"external_reference_id\" \nng-keyup=\"ctrl.parent.tmsReferenceIDValidation=false\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.external_reference_id) ? \'N/A\' : \'TMS Reference Code\' }} \" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-ExternalReferenceId-Change\',ctrl.parent.shipperInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"shippers_form.external_reference_id.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span>\nReference code must not exceed 256 characters.</span></div><div ng-if=\"ctrl.parent.tmsReferenceIDValidation\" \nclass=\"validation-error-text\"><span>Enter Reference code</span></div></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" flex=\"100\" layout-xs=\"column\" \nflex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><label>Closest Port</label><md-input-container \nclass=\"input_container\" md-no-float><input id=\"closest_port\" ng-maxlength=\"5\" class=\"panel-select md-input-focused\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.shipperInfo.viewShipper}\" \nng-model=\"ctrl.parent.shipperInfo.closest_port\" name=\"closest_port\" \nplaceholder=\"{{(ctrl.parent.shipperInfo.viewShipper && !ctrl.parent.shipperInfo.closest_port) ? \'N/A\' : \'Closest Port\' }} \" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-ExternalReferenceId-Change\',ctrl.parent.shipperInfo.form_heading )\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"shippers_form.closest_port.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span>Enter Valid Port</span>\n</div></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nlayout-align=\"space-between\" layout-wrap class=\"row-spacing footer_div\"><div flex=\"100\" layout=\"column\" \nlayout-xs=\"column\" layout-wrap><div flex layout-wrap class=\"user_type_check mt-10\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.shipperInfo.is_debtor\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"ml-5 mb-0 mt-5\" \nng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-Debtor-Change\',ctrl.parent.shipperInfo.form_heading,\'\');ctrl.parent.shipperType=false\">\nDebtor</md-checkbox><md-checkbox md-no-ink ng-model=\"ctrl.parent.shipperInfo.is_creditor\" ng-true-value=\"1\" \nng-false-value=\"0\" class=\"ml-5 mb-0 mt-5\" ng-disabled=\"ctrl.parent.shipperInfo.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'Shipper-Creditor-Change\' ,ctrl.parent.shipperInfo.form_heading,\'\');ctrl.parent.shipperType=false\">\nCreditor</md-checkbox></div></div><div ng-if=\"ctrl.parent.shipperType\" class=\"validation-error-text\"><span>\nSelect any one</span></div></div></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions class=\"footer\">\n<div layout=\"row\" class=\"m-10\" layout-align=\"end end\" ng-if=\"!ctrl.parent.shipperInfo.viewShipper\"><md-button \nmd-no-ink class=\"md-primary-btn\" ng-click=\"ctrl.parent.cancelDialog(\'CancelBy Button\')\" title=\"Cancel edit\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn\" type=\"submit\">{{ctrl.parent.shipperInfo.button_type}}\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/roles/dialogs/userForm/user_form.html","<md-dialog id=\"create-user\" class=\"popup-md\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div>{{ctrl.parent.createData.form_heading}} User</div><span flex></span><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog(\'CloseBy Icon\')\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"body\"><div><form\n name=\"user_form\"><md-tabs md-border-bottom md-dynamic-height md-selected=\"ctrl.parent.selectedIndex\"><md-tab \nlabel=\"General\"><md-content><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" \nflex-xs=\"100\" layout=\"column\" class=\"feild-spacing\" \nng-show=\"!ctrl.parent.createData.updateView && !ctrl.parent.util.isShipper\"><label>User Type</label><md-input-container\n class=\"input_container\" md-no-float><md-select name=\"roles\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.loginTypeValidation}\" class=\"panel-select\" \nng-model=\"ctrl.parent.loginType\" ng-change=\"ctrl.parent.fnChangeCreatedOf(ctrl.parent.loginType , \'userChanged\')\" \nplaceholder=\"company type of user\" ng-keyup=\"ctrl.parent.validationObj.loginTypeValidation=false\"><md-option \nng-value=\"roles\" ng-repeat=\"roles in ctrl.parent.userOfList track by $index\"><span \nng-bind=\"roles == \'Own\' ? \'Internal\' : (roles == \'Shipper\' ? \'Customer\' : roles) \"></span></md-option></md-select><div \nng-if=\"ctrl.parent.validationObj.loginTypeValidation\" class=\"validation-error-text\"><span>\nSelect the User Type from the dropdown</span></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nlayout=\"column\" class=\"feild-spacing mobile-spacing\"><label>User Role</label><md-input-container \nclass=\"input_container\" md-no-float><md-select md-no-asterisk class=\"panel-select\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper,\'validation-error\':ctrl.parent.validationObj.roleValidation}\" \nng-model=\"ctrl.parent.createData.user_data.role_id\" name=\"role_id\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.role_id) ? \'N/A\' : \'Select Role\' }}\" \nmd-on-close=\"searchRoles = \'\'\" ng-disabled=\"ctrl.parent.createData.viewShipper\" \nmd-on-open=\"ctrl.parent.validationObj.roleValidation=false\" ng-change=\"ctrl.parent.syncCustomerActiveStatus()\">\n<md-select-header><input ng-model=\"searchRoles\" type=\"search\" placeholder=\"Search Role\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"\"><md-option \nng-repeat=\"role in ctrl.parent.rolesList |  filter : {\'name\': searchRoles} | orderBy:\'name\'\" ng-value=\"role.id\">\n{{role.name}} <span ng-show=\"role.type == \'GLOBAL\'\" class=\"global_role_select\">{{role.type}}</span></md-option>\n</md-optgroup></md-select><div ng-if=\"ctrl.parent.validationObj.roleValidation\" class=\"validation-error-text\"><span>\nSelect the Role Type</span></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div \nflex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing mobile-spacing row-spacing\" \nng-if=\"ctrl.parent.createData.updateView\"><label>Selected Company</label><md-input-container class=\"input_container\" \nmd-no-float><input ng-model=\"ctrl.parent.createData.user_data.company_name\" ng-disabled=\"true\" name=\"selected_company\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.company_name) ? \'N/A\' : \'Selected Company\' }} \" \nclass=\"panel-select md-input-focused nameData\" required></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing row-spacing\" ng-if=\"ctrl.parent.loginType != \'Own\' && !ctrl.parent.createData.updateView\" \nlayout=\"column\"><label>Company Name</label><md-input-container class=\"input_container\" md-no-float \nng-if=\"!ctrl.parent.createData.updateView\"><md-select class=\"panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.companyNameValidation}\" name=\"company_name\" \nng-model=\"ctrl.parent.createData.user_data.user_company_id\" \nng-change=\"ctrl.parent.getRolesList(ctrl.parent.createData.user_data.user_company_id,ctrl.parent.loginType);ctrl.parent.fnTrackEvent(\'User-CompanyName-Change\', ctrl.parent.createData.form_heading ,searchCompany)\" \nplaceholder=\"Company\" md-on-close=\"searchCompany = \'\';ctrl.parent.validationObj.companyNameValidation=false\">\n<md-select-header><input ng-model=\"searchCompany\" ng-model-options=\"{debounce: 500}\" type=\"search\" \nplaceholder=\"Search Company\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\" ng-change=\"ctrl.parent.getShipperList(searchCompany)\" md-min-length=\"2\"></md-select-header><div \nlayout=\"column\" flex=\"100\" layout-wrap layout-align=\"center center\" class=\"mv-20 pt-10\" ng-if=\"ctrl.parent.listLoader\">\n<md-progress-circular></md-progress-circular></div><md-optgroup label=\"\" ng-hide=\"ctrl.parent.listLoader\"><md-option \nng-repeat=\"user in ctrl.parent.getCompanyList | orderBy:\'company_name\'\" ng-value=\"user.id\">{{user.company_name}}\n</md-option></md-optgroup></md-select><div ng-if=\"ctrl.parent.validationObj.companyNameValidation\" \nclass=\"validation-error-text\"><span>Enter Company Name</span></div></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing\">\n<label>First Name</label><md-input-container class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.createData.user_data.user_first_name\" name=\"user_first_name\" ng-maxlength=\"25\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.user_first_name) ? \'N/A\' : \'First name\' }}\" \nclass=\"md-input-focused panel-select nameData\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper,\'validation-error\':ctrl.parent.validationObj.firstNameValidation}\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" ng-keyup=\"ctrl.parent.validationObj.firstNameValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-FirstName-Change\', ctrl.parent.createData.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"user_form.user_first_name.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span>\nFirst Name must not exceed 25 characters.</span></div></div><div ng-if=\"ctrl.parent.validationObj.firstNameValidation\" \nclass=\"validation-error-text\"><span>Enter First Name</span></div></md-input-container></div><div flex=\"50\" \nflex-xs=\"100\" layout=\"column\" class=\"feild-spacing mobile-spacing\"><label>Last Name</label><md-input-container \nclass=\"input_container\" md-no-float><input ng-model=\"ctrl.parent.createData.user_data.user_last_name\" \nname=\"user_last_name\" ng-maxlength=\"25\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.user_last_name) ? \'N/A\' : \'Last name\' }} \" \nclass=\"md-input-focused panel-select nameData\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper,\'validation-error\':ctrl.parent.validationObj.lastNameValidation}\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" ng-keyup=\"ctrl.parent.validationObj.lastNameValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-LastName-Change\' , ctrl.parent.createData.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"user_form.user_last_name.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span>\nLast Name must not exceed 25 characters.</span></div></div><div ng-if=\"ctrl.parent.validationObj.lastNameValidation\" \nclass=\"validation-error-text\"><span>Enter Last Name</span></div></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing\">\n<label>Phone Number</label><md-input-container class=\"input_container\" md-no-float><input \nclass=\"md-input-focused panel-select tel-input\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper}\" type=\"tel\" \ntitle=\"{{ctrl.parent.createData.user_data.user_mobile}}\" ng-model=\"ctrl.parent.createData.user_data.user_mobile\" \nplaceholder=\"Phone Number\" name=\"user_mobile\" ng-disabled=\"ctrl.parent.createData.viewShipper\" ng-maxlength=\"40\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-PhoneNumber-Change\',ctrl.parent.createData.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"user_form.user_mobile.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nlayout=\"column\" class=\"mobile-spacing feild-spacing\"><label>Email ID</label><md-input-container \nclass=\"input_container\" md-no-float ng-hide=\"ctrl.parent.createData.updateView\"><input \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.emailValidation}\" class=\"md-input-focused panel-select\" \nng-model=\"ctrl.parent.createData.user_data.email\" type=\"email\" name=\"email\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.email) ? \'N/A\' : \'Email\' }} \" \nng-pattern=\"ctrl.parent.util.emailRegex\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-EmailId-Change\',ctrl.parent.createData.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-keyup=\"ctrl.parent.validationObj.emailValidation=false\"><div ng-messages=\"user_form.email.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span translate=\"Email must be a valid e-mail address\">Email must be a valid e-mail address</span>\n</div></div><div ng-if=\"ctrl.parent.validationObj.emailValidation && !user_form.email.$error.pattern\" \nclass=\"validation-error-text\"><span>Enter a valid Email Id</span></div></md-input-container><div \nclass=\"pt-8 pb-10 pl-5 mt-6 panel-select-disabled\" title=\"{{ctrl.parent.createData.user_data.email}}\" \nng-bind=\"ctrl.parent.createData.user_data.email\" ng-show=\"ctrl.parent.createData.updateView\"></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\" ng-if=\"!ctrl.parent.createData.viewShipper\"><div \nflex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing\"><label>Password</label><md-input-container \nclass=\"input_container\" md-no-float><input type=\"{{ctrl.parent.showPassword ? \'text\' : \'password\'}}\" \nng-model=\"ctrl.parent.createData.user_data.password\" id=\"user_pwd\" name=\"password\" placeholder=\"Password\" \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.passwordValidation}\" \nng-pattern=\"/^(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\" \nng-keyup=\"ctrl.parent.validatePassword();ctrl.parent.validationObj.passwordValidation=false;ctrl.parent.syncCustomerActiveStatus()\" \nng-focus=\"ctrl.parent.showPassErr(\'focus\')\" class=\"md-input-focused panel-select pr-rem\" \nng-blur=\"ctrl.parent.showPassErr(\'blur\')\" autocomplete=\"new-password\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-Password-Change\' ,ctrl.parent.createData.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"{{ctrl.parent.showPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon pt-4-imp mr-8-imp grey-500-fg pointer\" ng-click=\"ctrl.parent.togglePassword(\'password\')\"></md-icon><div\n ng-messages=\"user_form.password.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Invalid password.</span></div>\n</div><div ng-if=\"ctrl.parent.validationObj.passwordValidation\" class=\"validation-error-text\"><span>Enter a Password\n</span></div></md-input-container><div id=\"message\"><div class=\"indigo-fg mt-20\">Password must contain the following:\n</div><div id=\"special\" class=\"passInvalid\">A <b>special</b> character</div><div id=\"number\" class=\"passInvalid\">A <b>\nnumber</b></div><div id=\"length\" class=\"passInvalid\">Minimum <b>8 characters</b></div></div></div><div flex=\"50\" \nflex-xs=\"100\" layout=\"column\" class=\"feild-spacing mobile-spacing\"><label>Confirm Password</label><md-input-container \nclass=\"input_container\" md-no-float><input type=\"{{ctrl.parent.showCurrentPassword ? \'text\' : \'password\'}}\" \nng-model=\"ctrl.parent.createData.user_data.user_confirm_password\" name=\"user_confirm_password\" \nplaceholder=\"Confirm password\" \nonkeypress=\"var k = event ? event.which : window.event.keyCode;if (k == 32) return false\" \nng-keyup=\";ctrl.parent.validationObj.confirmPasswordValidation=false;ctrl.parent.pass_Error=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-ConfirmPassword-Change\',ctrl.parent.createData.form_heading)\" \nclass=\"md-input-focused panel-select pr-rem\" \nng-class=\"{\'validation-error\':(ctrl.parent.pass_Error||ctrl.parent.validationObj.confirmPasswordValidation )}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n<md-icon md-font-icon=\"{{ctrl.parent.showCurrentPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon pt-4-imp mr-8-imp grey-500-fg pointer\" ng-click=\"ctrl.parent.togglePassword(\'user_confirm_password\')\">\n</md-icon><div ng-if=\"ctrl.parent.validationObj.confirmPasswordValidation && !ctrl.parent.pass_Error\" \nclass=\"validation-error-text\"><span>Enter Confirm Password</span></div><div ng-if=\"ctrl.parent.pass_Error\" \nclass=\"validation-error-text\">Password doesn\'t match</div></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" class=\"row-spacing\" layout-align-gt-xs=\"center end\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><div><label class=\"mb-6-imp\">User Currency</label><currency-dropdown \nfield-value=\"ctrl.parent.createData.user_data.user_base_currency\" full-border=\"true\" \nis-disabled=\"ctrl.parent.createData.viewShipper\" page-source=\"\'Users\'\"></currency-dropdown></div></div><div flex=\"50\" \nflex-xs=\"100\" layout=\"column\" class=\"feild-spacing mobile-spacing\"><div layout=\"column\" flex><label>Number Format\n</label><span class=\"font-size-11\">Select your number display format</span></div><md-input-container \nclass=\"input_container\" md-no-float><md-select class=\"panel-select\" ng-disabled=\"ctrl.parent.createData.viewShipper\" \nng-model=\"ctrl.parent.createData.user_data.number_formates\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-NumberFormat-Change\',{\'Source\':ctrl.parent.createData.form_heading == \'Create\' ? \'Add\' : \'Edit\',\'Value\':ctrl.parent.number_formates[ctrl.parent.createData.user_data.number_formates].number_mask})\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper}\"><md-option ng-value=\"optkey\" \nng-repeat=\"(optkey,optvalue) in ctrl.parent.number_formates\">{{optvalue.number_mask}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" \nflex-xs=\"100\" layout=\"column\" class=\"feild-spacing\"><div layout=\"column\" flex><label>Measurement System</label><span \nclass=\"font-size-11\">Select your measurement unit display format</span></div><md-input-container \nclass=\"input_container\" md-no-float><md-select id=\"userform_select\" class=\"panel-select\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" ng-model=\"ctrl.parent.createData.user_data.metric_system\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-Measurement-Change\',{\'Source\':ctrl.parent.createData.form_heading == \'Create\' ? \'Add\' : \'Edit\',\'Value\':ctrl.parent.createData.user_data.metric_system})\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper}\"><md-option id=\"user_selectopt\" \nng-value=\"opt\" ng-repeat=\"opt in ctrl.parent.units\">{{opt}}</md-option></md-select></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing\"><div layout=\"column\" flex><label>Decimal Places</label>\n<span class=\"font-size-11\">Select the number of decimals for displaying and calculating rates</span></div>\n<md-input-container class=\"input_container\" md-no-float><md-select id=\"userform_select\" class=\"panel-select\" \nng-selected=\"2\" ng-model=\"ctrl.parent.createData.user_data.precision_decimals\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-precision_decimals-Change\',{\'Source\':ctrl.parent.createData.form_heading == \'Create\' ? \'Add\' : \'Edit\',\'Value\':ctrl.parent.createData.user_data.precision_decimals})\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper}\"><md-option id=\"user_selectopt\" \nng-value=\"opt\" \nng-selected=\"ctrl.parent.createData.user_data.precision_decimals ? opt == ctrl.parent.createData.user_data.precision_decimals : opt==2\" \nng-repeat=\"opt in [2,3]\">{{opt}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div layout=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"50\" \nflex-xs=\"100\" \nng-if=\"(ctrl.parent.util.isAdmin || ctrl.parent.util.isFreightbro) && ((!ctrl.parent.createData.updateView && (ctrl.parent.loginType==\'Own\'||ctrl.parent.loginType==\'Forwarder\')) || (ctrl.parent.createData.updateView && ctrl.parent.createData.user_data.user_category == \'FORWARDER\'))&&(ctrl.parent.util.solution_type === \'WLS\') && !ctrl.parent.disableAutoInquiryInput\">\n<div>Auto-Inquiry for every Search</div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"center start\" \nclass=\"mt-10\"><div layout=\"row\" layout-padding layout-wrap class=\"pt-0 pb-0\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.createData.user_data.auto_inquiry_fcl\" ng-disabled=\"ctrl.parent.createData.viewShipper\" \nng-true-value=\"1\" ng-false-value=\"0\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-AutoInquiry-Change\' ,ctrl.parent.createData.form_heading )\">FCL</md-checkbox>\n<md-checkbox md-no-ink ng-model=\"ctrl.parent.createData.user_data.auto_inquiry_lcl\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-AutoInquiry-Change\' ,ctrl.parent.createData.form_heading )\">LCL</md-checkbox>\n<md-checkbox md-no-ink ng-model=\"ctrl.parent.createData.user_data.auto_inquiry_air\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-AutoInquiry-Change\' ,ctrl.parent.createData.form_heading )\">AIR</md-checkbox>\n</div></div></div><div layout-sm=\"column\" layout-xs=\"column\" flex=\"50\" flex-xs=\"100\" layout=\"column\" \nclass=\"mobile-spacing\"><div>User Status</div><div layout=\"row\" layout-align=\"left center\" layout-wrap class=\"mt-6\"><div\n class=\"pr-20 font-size-13\">Deactivate</div><md-switch md-no-ink \nng-model=\"ctrl.parent.createData.user_data.active_status\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Switch 1\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" ng-change=\"ctrl.parent.onUserStatusChange()\" \nclass=\"m-0 p-0 md-primary\"></md-switch><div class=\"pl-20 font-size-13\">Activate</div></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" layout-align=\"space-between\" layout-wrap class=\"row-spacing footer_div\"><div\n flex=\"100\" layout=\"column\" layout-xs=\"column\" layout-wrap \nng-if=\"(ctrl.parent.userCategory == \'FORWARDER-ADMIN\' || ctrl.parent.util.isFreightbro) && ((!ctrl.parent.createData.updateView && (ctrl.parent.loginType==\'Own\' || ctrl.parent.loginType==\'Forwarder\' )) || (ctrl.parent.createData.updateView && ctrl.parent.createData.user_data.user_category == \'FORWARDER\')) && ctrl.parent.util.userProfile.user.role.is_super_role\">\n<div>User Team</div><div flex layout-wrap class=\"user_type_check mt-10\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.createData.user_data.is_sales_cordinator\" ng-true-value=\"1\" ng-false-value=\"0\" \nclass=\"ml-5 mb-0 mt-5\" ng-disabled=\"ctrl.parent.createData.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-UserTeam-Change\',ctrl.parent.createData.form_heading,\'\')\">Sales Co-ordinator\n</md-checkbox><md-checkbox md-no-ink ng-model=\"ctrl.parent.createData.user_data.is_pricing_user\" ng-true-value=\"1\" \nng-false-value=\"0\" class=\"ml-5 mb-0 mt-5\" ng-disabled=\"ctrl.parent.createData.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-UserTeam-Change\' ,ctrl.parent.createData.form_heading,\'\')\">Pricing\n</md-checkbox></div></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" \nflex-xs=\"100\" layout=\"column\" ng-if=\"ctrl.parent.createData.user_data.user_category.toLowerCase() == \'forwarder\'\" \nclass=\"mobile-spacing feild-spacing\"><label>Tags</label><md-input-container class=\"input_container\" md-no-float>\n<md-select class=\"panel-select multi-select-width\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper}\" \nng-model=\"ctrl.parent.createData.user_data.tags\" multiple=\"multiple\" name=\"tags\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.tags) ? \'N/A\' :(!ctrl.parent.tagsList.length ? \'Tags Not Available!\' : \'Select Tags\') }}\" \nng-disabled=\"ctrl.parent.tagsList.length == 0 || ctrl.parent.createData.viewShipper\" md-on-close=\"searchTags = \'\'\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-Tags-Change\', ctrl.parent.createData.form_heading ,searchTags)\">\n<md-select-header><input ng-model=\"searchTags\" type=\"search\" placeholder=\"Search Tags\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"\"><md-option \nng-repeat=\"tag in ctrl.parent.tagsList | orderBy:\'name\' | filter : {\'name\':searchTags}\" ng-value=\"tag._id\"><div \nclass=\"uppercase\"><md-icon md-font-icon=\"icon-tag-text-outline\" class=\"{{tag.tag_color}} pointer s18 mr-5\"></md-icon>\n{{tag.name}}</div></md-option></md-optgroup></md-select></md-input-container></div></div></md-content></md-tab><md-tab \nlabel=\"Integration Details\" ng-if=\"ctrl.parent.tms_enabled\"><md-content><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\" \nng-if=\"ctrl.parent.createData.user_data.user_category.toLowerCase() == \'forwarder\'\"><div flex=\"50\" flex-xs=\"100\" \nlayout=\"column\" class=\"feild-spacing\"><label>TMS Branch</label><div class=\"user-tms-suggest\" \nng-if=\"!ctrl.parent.createData.viewShipper\"><md-input-container class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.createData.user_data.branch_id\" name=\"branch_id\" ng-maxlength=\"256\" placeholder=\"TMS Branch\" \nautocomplete=\"off\" class=\"md-input-focused panel-select nameData\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.branchValidation}\" \nng-keyup=\"ctrl.parent.validationObj.branchValidation=false; ctrl.parent.openTmsSuggestions(\'branch\')\" \nng-focus=\"ctrl.parent.openTmsSuggestions(\'branch\')\" ng-blur=\"ctrl.parent.closeTmsSuggestions(\'branch\')\" \nng-change=\"ctrl.parent.onTmsFieldInput(\'branch\')\"><div ng-messages=\"user_form.branch_id.$error\" role=\"alert\"><div \nng-message=\"maxlength\"><span>Branch Id must not exceed 256 characters.</span></div><div \nng-if=\"ctrl.parent.validationObj.branchValidation\" class=\"validation-error-text\"><span>Enter Branch Name</span></div>\n</div></md-input-container><ul class=\"user-tms-suggest-menu\" ng-show=\"ctrl.parent.tmsSuggest.open === \'branch\'\" \nng-mousedown=\"$event.preventDefault()\"><li ng-repeat=\"opt in ctrl.parent.tmsSuggest.filtered track by opt\" \nng-mousedown=\"ctrl.parent.selectTmsSuggestion(\'branch\', opt)\">{{opt}}</li><li class=\"user-tms-suggest-empty\" \nng-if=\"!ctrl.parent.tmsSuggest.filtered.length\">No results found</li></ul></div><md-input-container \nclass=\"input_container\" md-no-float ng-if=\"ctrl.parent.createData.viewShipper\"><input \nng-model=\"ctrl.parent.createData.user_data.branch_id\" name=\"branch_id\" ng-maxlength=\"256\" \nplaceholder=\"{{!ctrl.parent.createData.user_data.branch_id ? \'N/A\' : \'TMS Branch\' }}\" \nclass=\"md-input-focused panel-select nameData pt-8 pb-10 panel-select-disabled\" ng-disabled=\"true\">\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing mobile-spacing\"><label>\nTMS Department</label><div class=\"user-tms-suggest\" ng-if=\"!ctrl.parent.createData.viewShipper\"><md-input-container \nclass=\"input_container\" md-no-float><input ng-model=\"ctrl.parent.createData.user_data.department\" name=\"department\" \nng-maxlength=\"256\" placeholder=\"TMS Department\" autocomplete=\"off\" class=\"md-input-focused panel-select nameData\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.departmentValidation}\" \nng-keyup=\"ctrl.parent.validationObj.departmentValidation=false; ctrl.parent.openTmsSuggestions(\'department\')\" \nng-focus=\"ctrl.parent.openTmsSuggestions(\'department\')\" ng-blur=\"ctrl.parent.closeTmsSuggestions(\'department\')\" \nng-change=\"ctrl.parent.onTmsFieldInput(\'department\')\"><div ng-messages=\"user_form.department.$error\" role=\"alert\"><div \nng-message=\"maxlength\"><span>TMS Department must not exceed 256 characters.</span></div><div \nng-if=\"ctrl.parent.validationObj.departmentValidation\" class=\"validation-error-text\"><span>Enter TMS Department</span>\n</div></div></md-input-container><ul class=\"user-tms-suggest-menu\" \nng-show=\"ctrl.parent.tmsSuggest.open === \'department\'\" ng-mousedown=\"$event.preventDefault()\"><li \nng-repeat=\"opt in ctrl.parent.tmsSuggest.filtered track by opt\" \nng-mousedown=\"ctrl.parent.selectTmsSuggestion(\'department\', opt)\">{{opt}}</li><li class=\"user-tms-suggest-empty\" \nng-if=\"!ctrl.parent.tmsSuggest.filtered.length\">No results found</li></ul></div><md-input-container \nclass=\"input_container\" md-no-float ng-if=\"ctrl.parent.createData.viewShipper\"><input \nng-model=\"ctrl.parent.createData.user_data.department\" name=\"department\" ng-maxlength=\"256\" \nplaceholder=\"{{!ctrl.parent.createData.user_data.department ? \'N/A\' : \'TMS Department\' }} \" \nclass=\"md-input-focused panel-select nameData pt-8 pb-10 panel-select-disabled\" ng-disabled=\"true\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing mb-20\"><div \nflex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing\" \nng-if=\"ctrl.parent.createData.user_data.user_category.toLowerCase() == \'forwarder\'\"><label>TMS Company</label><div \nclass=\"user-tms-suggest\" ng-if=\"!ctrl.parent.createData.viewShipper\"><md-input-container class=\"input_container\" \nmd-no-float><input ng-model=\"ctrl.parent.createData.user_data.tms_company\" name=\"tms_company\" ng-maxlength=\"256\" \nplaceholder=\"TMS Company\" autocomplete=\"off\" class=\"md-input-focused panel-select nameData\" \nng-class=\"{\'validation-error\':ctrl.parent.validationObj.tmsCompanyValidation}\" \nng-keyup=\"ctrl.parent.validationObj.tmsCompanyValidation=false; ctrl.parent.openTmsSuggestions(\'company\')\" \nng-focus=\"ctrl.parent.openTmsSuggestions(\'company\')\" ng-blur=\"ctrl.parent.closeTmsSuggestions(\'company\')\" \nng-change=\"ctrl.parent.onTmsFieldInput(\'company\')\"><div ng-messages=\"user_form.tms_company.$error\" role=\"alert\"><div \nng-message=\"maxlength\"><span>TMS Company must not exceed 256 characters.</span></div><div \nng-if=\"ctrl.parent.validationObj.tmsCompanyValidation\" class=\"validation-error-text\"><span>Enter TMS Company</span>\n</div></div></md-input-container><ul class=\"user-tms-suggest-menu\" ng-show=\"ctrl.parent.tmsSuggest.open === \'company\'\" \nng-mousedown=\"$event.preventDefault()\"><li ng-repeat=\"opt in ctrl.parent.tmsSuggest.filtered track by opt\" \nng-mousedown=\"ctrl.parent.selectTmsSuggestion(\'company\', opt)\">{{opt}}</li><li class=\"user-tms-suggest-empty\" \nng-if=\"!ctrl.parent.tmsSuggest.filtered.length\">No results found</li></ul></div><md-input-container \nclass=\"input_container\" md-no-float ng-if=\"ctrl.parent.createData.viewShipper\"><input \nng-model=\"ctrl.parent.createData.user_data.tms_company\" name=\"tms_company\" ng-maxlength=\"256\" \nplaceholder=\"{{!ctrl.parent.createData.user_data.tms_company ? \'N/A\' : \'TMS Company\' }}\" \nclass=\"md-input-focused panel-select nameData pt-8 pb-10 panel-select-disabled\" ng-disabled=\"true\">\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing mobile-spacing\"><label>\n{{ ctrl.parent.createData.user_data.user_category.toLowerCase() == \'forwarder\' ? \'TMS User Reference Code\' : \'External Reference Code\' }}\n<md-icon id=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" class=\"mr-5\" \nng-if=\"ctrl.parent.createData.user_data.user_category.toLowerCase() == \'forwarder\'\"><md-tooltip md-autohide=\"true\" \nmd-direction=\"top\">Reference number of the customer in the source system</md-tooltip></md-icon></label>\n<md-input-container class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.createData.user_data.reference_id\" name=\"reference_id\" ng-maxlength=\"256\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.reference_id) ? \'N/A\' : \'Reference Code\' }} \" \nclass=\"md-input-focused panel-select nameData\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper,\'validation-error\':ctrl.parent.validationObj.tmsReferenceIDValidation}\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" ng-keyup=\"ctrl.parent.validationObj.tmsReferenceIDValidation=false\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-ReferenceId-Change\' , ctrl.parent.createData.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"user_form.reference_id.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span>\nReference code must not exceed 256 characters.</span></div><div \nng-if=\"ctrl.parent.validationObj.tmsReferenceIDValidation\" class=\"validation-error-text\"><span>Enter Reference Code\n</span></div></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nclass=\"row-spacing mb-20\" ng-if=\"ctrl.parent.createData.user_data.user_category.toLowerCase() == \'forwarder\'\"><div \nflex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"feild-spacing\"><label>TMS Owner<md-icon id=\"info-icon\" \nmd-font-icon=\"s18 icon-information-outline\" class=\"mr-5\"><md-tooltip md-autohide=\"true\" md-direction=\"top\">\nOwner Company Code of the data in Source system</md-tooltip></md-icon></label><md-input-container \nclass=\"input_container\" md-no-float><input ng-model=\"ctrl.parent.createData.user_data.tms_owner\" name=\"tms_owner\" \nng-maxlength=\"256\" \nplaceholder=\"{{(ctrl.parent.createData.viewShipper && !ctrl.parent.createData.user_data.tms_owner) ? \'N/A\' : \'TMS Owner\' }}\" \nclass=\"md-input-focused panel-select nameData\" \nng-class=\"{\'pt-8 pb-10 panel-select-disabled\':ctrl.parent.createData.viewShipper}\" \nng-disabled=\"ctrl.parent.createData.viewShipper\" \nng-change=\"ctrl.parent.fnTrackEvent(\'User-TMSOwner-Change\', ctrl.parent.createData.form_heading)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><div \nng-messages=\"user_form.tms_owner.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span>\nTMS Owner must not exceed 256 characters.</span></div></div></md-input-container></div></div></md-content></md-tab>\n</md-tabs></form></div></md-dialog-content><md-dialog-actions class=\"footer\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"end center\" ng-if=\"!ctrl.parent.createData.viewShipper\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"ctrl.parent.cancelDialog(\'CancelBy Button\')\" title=\"Cancel edit\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn\" type=\"submit\" \nng-click=\"ctrl.parent.submitShipperUser(ctrl.parent.createData.user_data,ctrl.parent.createData.button_type,user_form)\" \ntitle=\"SAVE\">{{ctrl.parent.createData.button_type}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/roles/shipper/filter-shipper/filter-shipper.html","<div id=\"filter-shipper\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon mr-10\"></md-icon><span \nclass=\"font-size-16 Font-Bold grey-fg\" flex>Filters </span><span \nclass=\"font-size-13 pointer md-link-fg font-weight-600 pointer\" ng-click=\"vm.clearFilter()\">Clear All</span></div>\n<md-divider></md-divider><div class=\"content no-padding\" ms-scroll ng-style=\"vm.maxFilterHeight\"><div \nshimmer-effect-full width=\"95%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" ng-if=\"vm.filterLoader\" \nng-repeat=\"shimmer in [1,2,3,4,5,6,7,8,9]\"></div><md-list class=\"no-padding\"><md-list-item class=\"no-padding\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"mb-10\"><div><span class=\"font-size-14 font-weight-600\">Company Name \n</span><span ng-if=\"vm.companyFilterConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{vm.companyFilterConditions.selectedCount}}</span></div></div><div layout=\"row\" layout-align=\"space-between center\" \nflex class=\"searchbox-outline mb-10\"><div id=\"companyName\" class=\"w-150-f\"><multi-select-chips \nmd-input-id=\"\'companyName\'\" options-data-obj=\"vm.filterobj.company_name\" query-conditions=\"vm.companyFilterConditions\" \ncallback=\"vm.callBackComapnySearch(payload)\"></multi-select-chips></div></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-0\"><div><span class=\"font-size-14 font-weight-600\">\nDate Range</span><md-icon md-font-icon=\"icon-information-outline\" class=\"s16 mb-2 grey-fg pointer\"><md-tooltip \nmd-direction=\"right\" md-delay=\"300\">Created On</md-tooltip></md-icon><span \nng-if=\"vm.filterobj.date_range.from || vm.filterobj.date_range.to\" class=\"filter-count md-component-bg white-fg\">1\n</span></div></div><div layout-align=\"space-between center\" class=\"mb-15\"><date-range-picker \nmd-input-id=\"\'shipper_date_range\'\" callback=\"vm.setDatePicker(date)\" date-range-value=\"vm.filterobj.date_range\" \nis-reset-date-picker=\"vm.shipperfilterdata.isResetFilter\"></date-range-picker></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-10\"><div><span class=\"font-size-14 font-weight-600\">\nCompany Type</span></div></div><div layout=\"column\" class=\"mb-15\"><md-radio-group ng-model=\"vm.filterobj.company_type\" \nng-change=\"vm.setCompanyTypeFilter(vm.filterobj.company_type)\"><md-radio-button value=\"ALL\" class=\"md-primary mb-5\">All\n</md-radio-button><md-radio-button value=\"SHIPPER\" class=\"md-primary mb-5\">Customer</md-radio-button><md-radio-button \nvalue=\"CONSIGNEE\" class=\"md-primary mb-5\">Consignee</md-radio-button><md-radio-button value=\"CONSIGNOR\" \nclass=\"md-primary mb-5\">Consignor</md-radio-button></md-radio-group></div></div></md-list-item></md-list></div></div>");
$templateCache.put("app/main/roles/user/filter-shipperusers/filter-shipperusers.html","<div id=\"filter-usersPage\"><div class=\"pt-20 ph-20 pb-15\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"assets/icons/custom/filter-new.svg\" class=\"w-20 h-20 filter-icon mr-10\"></md-icon><span \nclass=\"font-size-16 Font-Bold grey-fg\" flex>Filters </span><span \nclass=\"font-size-13 pointer md-link-fg font-weight-600\" ng-click=\"vm.clearFilter()\">Clear All</span></div><md-divider>\n</md-divider><div class=\"content no-padding\"><div shimmer-effect-full width=\"95%\" height=\"30px\" mh=\"10px\" \nclass=\"mv-20\" ng-if=\"vm.filterLoader\" ng-repeat=\"shimmer in [1,2,3,4,5,6,7,8,9]\"></div><md-list class=\"no-padding\">\n<md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.util.isShipper\" flex><div \nlayout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\">\n<div><span class=\"font-size-14 font-weight-600\">User Type </span><span ng-if=\"vm.filterobj.user_type\" \nclass=\"filter-count md-component-bg white-fg\">1 </span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><md-radio-group \nng-model=\"vm.userData.defaultvalue\"><md-radio-button ng-click=\"vm.changeUser(userType )\" md-no-ink \nng-value=\"userType.type\" ng-repeat=\"userType in vm.filterobj.user_type\" class=\"md-primary checkbox-margin\">\n{{userType.name}}</md-radio-button></md-radio-group></div></div></md-list-item><md-list-item class=\"no-padding\" \nlayout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.shipper_user || vm.util.isShipper\"><div layout=\"column\" flex \nclass=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex><div><span \nclass=\"font-size-14 font-weight-600\" ng-if=\"!vm.util.isShipper\">Customer Details </span><span \nclass=\"font-size-14 font-weight-600\" ng-if=\"vm.util.isShipper\">User Details </span><span \nng-if=\"vm.cutomerFilterConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{vm.cutomerFilterConditions.selectedCount}}</span></div></div><div layout=\"row\" layout-align=\"space-between center\" \nflex class=\"searchbox-outline mb-10\"><div id=\"userCustomerDetails\" class=\"w-150-f\"><multi-select-chips \nmd-input-id=\"\'created-by-filter\'\" options-data-obj=\"vm.filterobj.customer_details\" \nquery-conditions=\"vm.cutomerFilterConditions\" callback=\"vm.callBackCustomersSearch(payload)\"></multi-select-chips>\n</div></div></div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.forwarder_user && !vm.util.isShipper\"><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div><span class=\"font-size-14 font-weight-600\">User Details </span><span \nng-if=\"vm.userFilterConditions.selectedCount\" class=\"filter-count md-component-bg white-fg\">\n{{vm.userFilterConditions.selectedCount}}</span></div></div><div layout=\"row\" layout-align=\"space-between center\" flex \nclass=\"searchbox-outline mb-10\"><div id=\"userDetails\" class=\"w-150-f\"><multi-select-chips md-input-id=\"\'users-filter\'\" \noptions-data-obj=\"vm.filterobj.user_details\" query-conditions=\"vm.userFilterConditions\" \ncallback=\"vm.callBackUserSearch(payload)\"></multi-select-chips></div></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-10\"><div><span class=\"font-size-14 font-weight-600\">\nRoles</span> <span ng-if=\"vm.filterListObject.roles.query_value.length\" class=\"filter-count md-component-bg white-fg\">\n{{vm.filterListObject.roles.query_value.length}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><div id=\"roles\" class=\"w-150-f\">\n<multi-select-chips md-input-id=\"\'roles-filter\'\" query-conditions=\"vm.rolesFilterConditions\" \ncallback=\"vm.callBackRolesSearch(payload)\" options-data-obj=\"vm.filterobj.roles\"></multi-select-chips></div></div>\n</div></md-list-item><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" flex class=\"ph-20 pt-15 bb\"><div layout=\"row\" layout-align=\"space-between center\" flex class=\"mb-5\">\n<div><span class=\"font-size-14 font-weight-600\">Date Range</span><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16 mb-2 grey-fg pointer\"><md-tooltip md-direction=\"right\" md-delay=\"300\">Created On</md-tooltip></md-icon><span\n ng-if=\"vm.filterobj.date_range.from || vm.filterobj.date_range.to\" class=\"filter-count md-component-bg white-fg\">1\n</span></div></div><div layout-align=\"space-between center\" flex class=\"searchbox-outline mb-15\"><date-range-picker \nmd-input-id=\"\'user_date_range\'\" callback=\"vm.setDatePicker(date)\" date-range-value=\"vm.filterobj.date_range\" \nis-reset-date-picker=\"vm.userData.isResetFilter\"></date-range-picker></div></div></md-list-item><md-list-item \nclass=\"no-padding\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" flex class=\"ph-20 pt-15 bb\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"mb-15\"><div><span class=\"font-size-14 font-weight-600\">\nStatus</span> <span ng-if=\"vm.radioReset\" class=\"filter-count md-component-bg white-fg\">1</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"searchbox-outline mb-10\"><md-radio-group \nng-model=\"vm.radioReset\"><md-radio-button ng-click=\"vm.filtertoggle(statusValue)\" md-no-ink ng-value=\"statusValue\" \nng-repeat=\"statusValue in vm.filterobj.status\" class=\"md-primary checkbox-margin\">{{statusValue}}</md-radio-button>\n</md-radio-group></div></div></md-list-item></md-list></div></div>");
$templateCache.put("app/main/search/components/recent-search-card/recent-search-card.html","<div class=\"offer-card pointer\"><div class=\"p-8\"><div layout=\"row\" class=\"ph-8 pv-8\" layout-align=\"space-between\"><div \nclass=\"text-truncate port-names\" title=\"{{$ctrl.searchcard.result_meta.search_param.origin_location.location_string}}\" \nng-class=\"{\'inline-flex\' : !$ctrl.hideShimmer}\"><span \nng-if=\"$ctrl.searchcard.result_meta.search_param.mode!=\'AIR\' && $ctrl.hideShimmer\"><md-icon \nclass=\"w-15 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( $ctrl.searchcard.result_meta.search_param.origin_location.place_type !== \'Door\' && !$ctrl.searchcard.result_meta.search_param.origin_location.is_major_port && !$ctrl.searchcard.result_meta.search_param.origin_location.is_icd_port) }\" \nmd-svg-src=\"{{ $ctrl.searchcard.result_meta.search_param.origin_location.place_type !== \'Door\' ? \n            ((!$ctrl.searchcard.result_meta.search_param.origin_location.is_icd_port && $ctrl.searchcard.result_meta.search_param.origin_location.is_major_port) || ($ctrl.searchcard.result_meta.search_param.origin_location.is_icd_port && $ctrl.searchcard.result_meta.search_param.origin_location.is_major_port) || (!$ctrl.searchcard.result_meta.search_param.origin_location.is_icd_port && !$ctrl.searchcard.result_meta.search_param.origin_location.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!$ctrl.searchcard.result_meta.search_param.origin_location.is_primary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' ) }}\">\n</md-icon></span><span ng-if=\"$ctrl.searchcard.result_meta.search_param.mode==\'AIR\' && $ctrl.hideShimmer\"><img \nsrc=\"assets/icons/custom/search-bar/air_pod.svg\" class=\"w-15 h-15 mr-5\"> </span><span ng-if=\"!$ctrl.hideShimmer\" \nshimmer-effect-full width=\"150px\" height=\"15px\" class=\"ml-10\"></span>\n {{$ctrl.searchcard.result_meta.search_param.origin_location.location_string}}</div><div><div \nng-if=\"!$ctrl.hideShimmer\" class=\"pincode-portcode\" shimmer-effect-full width=\"100%\" height=\"15px\"></div><div \nng-if=\"($ctrl.searchcard.result_meta.search_param.user_nearby_origin.length > 1)\"><div class=\"parent\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.user_nearby_origin[0].place_type!== \'Door\' && $ctrl.searchcard.result_meta.search_param.user_nearby_origin[0].global_port_code\">\n<div class=\"class-1 class\">&nbsp;</div><div class=\"class-2 class\">&nbsp;</div><div class=\"class-3 class\">\n{{ $ctrl.searchcard.result_meta.search_param.user_nearby_origin[0].global_port_code }}<md-tooltip md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nng-repeat=\"port in $ctrl.searchcard.result_meta.search_param.user_nearby_origin\">{{ port.location_string }}</div>\n</md-tooltip></div></div><div class=\"parent\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.user_nearby_origin[0].place_type === \'Door\' && $ctrl.util.getPincode($ctrl.searchcard.result_meta.search_param.user_nearby_origin[0])\">\n<div class=\"class-1 class\">&nbsp;</div><div class=\"class-2 class\">&nbsp;</div><div class=\"class-3 class\"><span \nng-bind=\"$ctrl.util.getPincode($ctrl.searchcard.result_meta.search_param.user_nearby_origin[0])\"></span></div>\n<md-tooltip ng-if=\"$ctrl.searchcard.result_meta.search_param.user_nearby_origin.length > 1\" md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nng-repeat=\"port in $ctrl.searchcard.result_meta.search_param.user_nearby_origin\">{{ port.location_string }}</div>\n</md-tooltip></div></div><div \nng-if=\"!$ctrl.searchcard.result_meta.search_param.user_nearby_origin || !$ctrl.searchcard.result_meta.search_param.user_nearby_origin.length || ($ctrl.searchcard.result_meta.search_param.user_nearby_origin.length==1)\">\n<div class=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.origin_location.place_type !== \'Door\' && $ctrl.searchcard.result_meta.search_param.origin_location.global_port_code\">\n{{ $ctrl.searchcard.result_meta.search_param.origin_location.global_port_code }}</div><div class=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.origin_location.place_type === \'Door\' && $ctrl.util.getPincode($ctrl.searchcard.result_meta.search_param.origin_location)\" \nng-bind=\"$ctrl.util.getPincode($ctrl.searchcard.result_meta.search_param.origin_location)\"></div></div></div></div><div\n layout=\"row\" class=\"ph-8 pv-8\" layout-align=\"space-between\"><div class=\"text-truncate port-names\" \ntitle=\"{{$ctrl.searchcard.result_meta.search_param.destination_location.location_string}}\" \nng-class=\"{\'inline-flex\' : !$ctrl.hideShimmer}\"><span \nng-if=\"$ctrl.searchcard.result_meta.search_param.mode!==\'AIR\' && $ctrl.hideShimmer\"><md-icon \nclass=\"w-15 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( $ctrl.searchcard.result_meta.search_param.destination_location.place_type !== \'Door\' && !$ctrl.searchcard.result_meta.search_param.destination_location.is_major_port && !$ctrl.searchcard.result_meta.search_param.destination_location.is_icd_port) }\" \nmd-svg-src=\"{{ $ctrl.searchcard.result_meta.search_param.destination_location.place_type !== \'Door\' ? \n            ((!$ctrl.searchcard.result_meta.search_param.destination_location.is_icd_port && $ctrl.searchcard.result_meta.search_param.destination_location.is_major_port) || ($ctrl.searchcard.result_meta.search_param.destination_location.is_icd_port && $ctrl.searchcard.result_meta.search_param.destination_location.is_major_port) || (!$ctrl.searchcard.result_meta.search_param.destination_location.is_icd_port && !$ctrl.searchcard.result_meta.search_param.destination_location.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!$ctrl.searchcard.result_meta.search_param.destination_location.is_primary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' ) }}\">\n</md-icon></span><span ng-if=\"$ctrl.searchcard.result_meta.search_param.mode==\'AIR\' && $ctrl.hideShimmer\"><img \nsrc=\"assets/icons/custom/search-bar/air_pol.svg\" class=\"w-15 h-15 mr-5\"> </span><span ng-if=\"!$ctrl.hideShimmer\" \nshimmer-effect-full width=\"150px\" height=\"15px\" class=\"ml-10\"></span>\n {{$ctrl.searchcard.result_meta.search_param.destination_location.location_string}}</div><div><div \nng-if=\"!$ctrl.hideShimmer\" class=\"pincode-portcode\" shimmer-effect-full width=\"100%\" height=\"15px\"></div><div \nng-if=\"!$ctrl.searchcard.result_meta.search_param.user_nearby_destination  || !$ctrl.searchcard.result_meta.search_param.user_nearby_destination.length || ($ctrl.searchcard.result_meta.search_param.user_nearby_destination.length==1)\">\n<div class=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.destination_location.place_type !== \'Door\' && $ctrl.searchcard.result_meta.search_param.destination_location.global_port_code\">\n{{ $ctrl.searchcard.result_meta.search_param.destination_location.global_port_code }}</div><div \nclass=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.destination_location.place_type === \'Door\'&& $ctrl.util.getPincode($ctrl.searchcard.result_meta.search_param.destination_location)\" \nng-bind=\"$ctrl.util.getPincode($ctrl.searchcard.result_meta.search_param.destination_location)\"></div></div><div \nng-if=\"($ctrl.searchcard.result_meta.search_param.user_nearby_destination.length > 1)\"><div class=\"parent\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.user_nearby_destination[0].place_type!== \'Door\' && $ctrl.searchcard.result_meta.search_param.user_nearby_destination[0].global_port_code\">\n<div class=\"class-1 class\">&nbsp;</div><div class=\"class-2 class\">&nbsp;</div><div class=\"class-3 class\">\n{{ $ctrl.searchcard.result_meta.search_param.user_nearby_destination[0].global_port_code }}<md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nng-repeat=\"port in $ctrl.searchcard.result_meta.search_param.user_nearby_destination\">{{ port.location_string }}</div>\n</md-tooltip></div></div><div class=\"parent\" \nng-if=\"$ctrl.searchcard.result_meta.search_param.user_nearby_destination[0].place_type === \'Door\' && $ctrl.util.getPincode( $ctrl.searchcard.result_meta.search_param.user_nearby_destination[0])\">\n<div class=\"class-1 class\">&nbsp;</div><div class=\"class-2 class\">&nbsp;</div><div class=\"class-3 class\"><span \nng-bind=\"$ctrl.util.getPincode( $ctrl.searchcard.result_meta.search_param.user_nearby_destination[0])\"></span></div>\n<md-tooltip ng-if=\"$ctrl.searchcard.result_meta.search_param.user_nearby_destination.length > 1\" md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\"><div \nng-repeat=\"port in $ctrl.searchcard.result_meta.search_param.user_nearby_destination\">{{ port.location_string }}</div>\n</md-tooltip></div></div></div></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"ph-15 pt-5 grey-fg font-size-13\"><div><span ng-if=\"!$ctrl.hideShimmer\" \nshimmer-effect-full width=\"100px\" height=\"15px\" class=\"mb-20\"></span><div class=\"mode-div\">\n{{$ctrl.searchcard.result_meta.search_param.mode }}</div><div class=\"load\" ng-if=\"$ctrl.hideShimmer\"><span \nng-if=\"$ctrl.searchcard.result_meta.search_param.mode==\'SEA-FCL\'\">\n{{ $ctrl.formLoadData($ctrl.searchcard.result_meta.search_param.load_data)}}</span> <span \nng-if=\"$ctrl.searchcard.result_meta.search_param.mode!=\'SEA-FCL\'\">\nChargeable Wt. {{$ctrl.searchcard.result_meta.search_param.load_data.load_meta.chargeable_weight | currencyMask: 2}} {{$ctrl.searchcard.result_meta.search_param.load_data.load_meta.calculated_weight_unit}}\n</span></div></div><div ng-if=\"$ctrl.hideShimmer\"><span>{{$ctrl.getTimeStampValue($ctrl.searchcard.created_at) }} ago\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"grey-fg\"></md-icon></span></div></div></div>");
$templateCache.put("app/main/search/components/recent-search-card/recent-search-ftl.html","<div class=\"offer-card pointer\"><div class=\"p-8\"><div layout=\"row\" class=\"ph-8 pv-8\" layout-align=\"space-between\"><div \nclass=\"text-truncate port-names\" title=\" {{$ctrl.recentSearchLocation($ctrl.searchcard.origin[0])}}\" \nng-class=\"{\'inline-flex\' : !$ctrl.hideShimmer}\"><span ng-if=\"$ctrl.hideShimmer\"><md-icon class=\"w-15 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( $ctrl.searchcard.origin[0].placeType !== \'Door\' && !$ctrl.searchcard.origin[0].isMajorPort && !$ctrl.searchcard.origin[0].isIcdPort) }\" \nmd-svg-src=\"{{ $ctrl.searchcard.origin[0].placeType !== \'Door\' ? \n              ((!$ctrl.searchcard.origin[0].isIcdPort && $ctrl.searchcard.origin[0].isMajorPort) || ($ctrl.searchcard.origin[0].isIcdPort && $ctrl.searchcard.origin[0].isMajorPort) || (!$ctrl.searchcard.origin[0].isIcdPort && !$ctrl.searchcard.origin[0].isMajorPort) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!$ctrl.searchcard.origin[0].isPrimary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' ) }}\">\n</md-icon></span><span ng-if=\"!$ctrl.hideShimmer\" shimmer-effect-full width=\"150px\" height=\"15px\" class=\"ml-10\"></span>\n {{$ctrl.recentSearchLocation($ctrl.searchcard.origin[0])}}</div><div><div ng-if=\"!$ctrl.hideShimmer\" \nclass=\"pincode-portcode\" shimmer-effect-full width=\"100%\" height=\"15px\"></div><div><div class=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.origin[0].placeType !== \'Door\' && $ctrl.searchcard.origin[0].globalPortCode\">\n{{ $ctrl.searchcard.origin[0].globalPortCode }}</div><div class=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.origin[0].placeType === \'Door\'  && $ctrl.searchcard.origin[0].pincode\">\n{{ $ctrl.searchcard.origin[0].pincode }}</div></div></div></div><div layout=\"row\" class=\"ph-8 pv-8\" \nlayout-align=\"space-between\"><div class=\"text-truncate port-names\" \ntitle=\" {{$ctrl.recentSearchLocation($ctrl.searchcard.destination[0])}}\" \nng-class=\"{\'inline-flex\' : !$ctrl.hideShimmer}\"><span ng-if=\"$ctrl.searchcard.mode!==\'AIR\' && $ctrl.hideShimmer\">\n<md-icon class=\"w-15 h-15 mr-5 mb-2\" \nng-class=\"{ \'w-12 h-12\' : ( $ctrl.searchcard.destination[0].placeType !== \'Door\' && !$ctrl.searchcard.destination[0].isMajorPort && !$ctrl.searchcard.destination[0].isIcdPort) }\" \nmd-svg-src=\"{{ $ctrl.searchcard.destination[0].placeType !== \'Door\' ? \n              ((!$ctrl.searchcard.destination[0].isIcdPort && $ctrl.searchcard.destination[0].isMajorPort) || ($ctrl.searchcard.destination[0].isIcdPort && $ctrl.searchcard.destination[0].isMajorPort) || (!$ctrl.searchcard.destination[0].isIcdPort && !$ctrl.searchcard.destination[0].isMajorPort) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') : (!$ctrl.searchcard.destination[0].isPrimary ? \'assets/icons/custom/search-bar/door.svg\' : \'assets/icons/custom/search-bar/primary_location.svg\' ) }}\">\n</md-icon></span><span ng-if=\"$ctrl.searchcard.mode==\'AIR\' && $ctrl.hideShimmer\"><img \nsrc=\"assets/icons/custom/search-bar/air_pol.svg\" class=\"w-15 h-15 mr-5\"> </span><span ng-if=\"!$ctrl.hideShimmer\" \nshimmer-effect-full width=\"150px\" height=\"15px\" class=\"ml-10\"></span>\n {{$ctrl.recentSearchLocation($ctrl.searchcard.destination[0])}}</div><div><div ng-if=\"!$ctrl.hideShimmer\" \nclass=\"pincode-portcode\" shimmer-effect-full width=\"100%\" height=\"15px\"></div><div><div class=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.destination[0].placeType !== \'Door\' && $ctrl.searchcard.destination[0].globalPortCode\">\n{{ $ctrl.searchcard.destination[0].globalPortCode }}</div><div class=\"pincode-portcode\" \nng-if=\"$ctrl.searchcard.destination[0].placeType === \'Door\' &&  $ctrl.searchcard.destination[0].pincode\">\n{{ $ctrl.searchcard.destination[0].pincode }}</div></div></div></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"ph-15 pt-5 grey-fg font-size-13\"><div><span ng-if=\"!$ctrl.hideShimmer\" \nshimmer-effect-full width=\"100px\" height=\"15px\" class=\"mb-20\"></span><div class=\"mode-div\">{{$ctrl.searchcard.mode }}\n</div><div class=\"load\" ng-if=\"$ctrl.hideShimmer\"><span>{{$ctrl.formLoadData($ctrl.searchcard.loads)}}</span></div>\n</div><div ng-if=\"$ctrl.hideShimmer\"><span>{{$ctrl.getTimeStampValue($ctrl.searchcard.createdAt) }} ago<md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"grey-fg\"></md-icon></span></div></div></div>");
$templateCache.put("app/main/search/dialogs/exclusive-service/exclusive-service.html","<md-dialog id=\"exclusive-service\"><md-toolbar class=\"white-bg black-fg bb\" ng-if=\"!ctrl.parent.showSuccessMsg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div class=\"font-size-14 Font-Bold\">\nExclusive Shanghai / Hong Kong service</div><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"md-primary-fg s20\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pt-20\" \nng-if=\"!ctrl.parent.showSuccessMsg\"><div><div layout=\"row\" class=\"pb-15\"><div><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle s10 mr-8\n            \"></md-icon></div>\nWe are capable of handling General, Hazardous & Temperature controlled cargo</div><div layout=\"row\" class=\"pb-15\"><div>\n<md-icon md-font-icon=\"icon-checkbox-blank-circle s10 mr-8\n            \"></md-icon></div>\nExports from Shanghai & Hong Kong are available for all major cities with a single HAWB</div><div layout=\"row\" \nclass=\"pb-15\"><div><md-icon md-font-icon=\"icon-checkbox-blank-circle s10 mr-8\n            \"></md-icon></div>\nEnd to end Turn-Around-Time is 3 days from Origin to Destination</div><div layout=\"row\" class=\"pb-15\"><div><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle s10 mr-8\n            \"></md-icon></div>\nPalletized / DG / Temperature controlled rates will be on basis of actual cargo</div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"pt-10\"><div class=\"font-size-14\"><div>To get in touch directly,</div><div \nclass=\"Font-Bold\">Call on <a href=\"tel:18001031028\" class=\"md-link-fg\">1800 1031 028</a></div></div><md-button \nmd-no-ink class=\"md-accent-btn\" ng-disabled=\"ctrl.parent.disableInterestedBtn\" \nng-click=\"ctrl.parent.interestedCustomersApi()\">Interested</md-button></div></div></md-dialog-content>\n<md-dialog-content class=\"pt-8\" ng-if=\"ctrl.parent.showSuccessMsg\"><div layout=\"row\" layout-align=\"end end\"><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md-primary-fg s20\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"pb-20 pt-5 font-size-16\"><md-icon \nmd-svg-icon=\"assets/icons/custom/tick-mark-icon.svg\" class=\"w-100 h-100\"></md-icon><div class=\"mt-20\">Thank you!</div>\n<div class=\"pt-10\">Our team will get in touch with you shortly.</div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/search/views/inquiry-modals/inquiry-modal.html","<md-dialog id=\"inquiry-modal\" class=\"dialogbox\" ng-cloak><md-dialog-content class=\"p-0\"><section \nng-show=\"ctrl.parent.inquryDone\" class=\"background-modal-header\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"pt-40 pb-30\"><div class=\"font-size-14 blue text-bold text-uppercase border-blue\"><span>Inquiry Id - </span><a \nclass=\"md-link-fg pointer td-none\" ng-click=\"ctrl.parent.fnGoToInquiry(ctrl.parent.inquiryValue.inquiry_id)\" \nng-if=\"ctrl.parent.util.navPermission.inquiry\"><span>{{ ctrl.parent.inquiryValue.inquiry_number }}</span> <a \nclass=\"md-link-fg td-none\" ng-if=\"!ctrl.parent.util.navPermission.inquiry\"><span>\n{{ ctrl.parent.inquiryValue.inquiry_number }}</span></a></a></div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"mb-20\"><md-icon md-svg-icon=\"assets/icons/custom/approved-signal.svg\" \nclass=\"w-65 h-65 match_icon\"></md-icon><p class=\"font-size-18 modal-green text-capitalize font-weight-700 mt-10 mb-0\">\nrequest received</p><p class=\"font-size-12 grey-fg mt-5 mb-20\">We have shared your Inquiry with <b>Team</b></p></div>\n</section><section ng-show=\"!ctrl.parent.inquryDone\"><div layout=\"column\" layout-align=\"center center\" \nclass=\"mt-60 mb-15\"><md-icon md-svg-icon=\"assets/icons/custom/cancel.svg\" class=\"w-100 h-100 match_icon\"></md-icon><p \nclass=\"font-size-18 color-red text-capitalize font-weight-900 mt-25 mb-0\">enquiry failed !</p></div></section><section \nng-show=\"ctrl.parent.inquryDone\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"font-size-16 item-color font-weight-600 text-center ph-30 mv-25\">Rates will be shared with you<br>\nRevisit the Inquiry for the same</div></section><section ng-show=\"!ctrl.parent.inquryDone\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"font-size-14 item-color text-bold text-center ph-30 mb-50\">\n{{ctrl.parent.inquiryValue.message}}</div></section><footer class=\"bt\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"pointer\" ng-show=\"ctrl.parent.inquryDone\"><p \nclass=\"font-size-14 item-color-light pv-18 font-weight-700 text-bold text-uppercase m-0 spacing-footer\" \nng-if=\"!ctrl.parent.isWebView\" ng-click=\"ctrl.parent.fnInquiryDone()\" \nng-class=\"{\'br\' : ctrl.parent.util.navPermission.inquiry}\">back to search</p><p \nclass=\"font-size-14 blue pv-18 font-weight-700 text-bold text-uppercase m-0 spacing-footer\" \nng-click=\"ctrl.parent.fnGoToInquiry(ctrl.parent.inquiryValue.inquiry_id)\" \nng-if=\"ctrl.parent.util.navPermission.inquiry && !ctrl.parent.isWebView\">view inquiry</p><p \nclass=\"font-size-14 item-color-light pv-18 font-weight-700 text-bold text-uppercase m-0 spacing-footer\" \nng-click=\"ctrl.parent.closeDialog()\" ng-if=\"ctrl.parent.isWebView\">Close</p></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"background-modal-red pointer\" ng-show=\"!ctrl.parent.inquryDone\" \nng-click=\"ctrl.parent.closeDialog()\"><p \nclass=\"font-size-16 color-white pv-18 font-weight-900 text-bold text-uppercase\">Go Back</p></div></footer>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/search/views/search-history/search-history.html","<div id=\"search-history\" ng-if=\"vm.util.navPermission.search[1]\"><div layout=\"row\" layout-padding \nlayout-align=\"space-between center\" class=\"pt-10 pb-0 ph-0\"><div class=\"font-size-20 title Font-Bold\"><md-icon \nmd-font-icon=\"icon-backup-restore\" class=\"title-icon\"></md-icon>Recent Searches</div><div><span \nclass=\"md-link-btn show-all pointer\" \nng-click=\"!vm.showAllSearches[vm.activeSearchTab] ? vm.showAll(\'recent_searches\') : vm.goBackToSearch(\'recent_searches\')\">\nShow {{vm.showAllSearches[vm.activeSearchTab] ? \'Less\' : \'All\'}}</span></div></div><md-content layout=\"column\" \nwhen-scrolled=\"vm.activeSearchTab !=\'FTL\'? vm.loadMoreSearches() : vm.loadMoreFtlSearches()\" ms-scroll \nng-style=\"vm.maxHeight\" id=\"searchList\" class=\"searches-list\"><div ng-if=\"vm.activeSearchTab !=\'FTL\'\"><div flex \nlayout=\"row\" class=\"scroll_container width100 p-0 searchHistory\" ng-if=\"vm.lastSearchArray.length\" \nng-class=\"{\'layout-wrap\': vm.showAllSearches[vm.activeSearchTab]}\"><recent-search-card \nclass=\"search-div min-width-460 font-size-12 b pointer mt-10 p-8 mr-10\" \nng-repeat=\"searchItem in vm.lastSearchArray  |  limitTo:( vm.showAllSearches[vm.activeSearchTab] ? \'\' : vm.showCardLimit()) track by searchItem.id+ $index\" \nsearchcard=\"searchItem\" mode=\"vm.activeSearchTab\" ng-click=\"vm.quoteSearch(searchItem,$index)\"></recent-search-card>\n</div><div flex layout=\"row\" class=\"scroll_container width100 p-0 searchHistory\" \nng-if=\"!vm.lastSearchArray.length && !vm.noSearchHistory && !vm.SearchHistoryReceived\" \nng-class=\"{\'layout-wrap\': vm.showAllSearches[vm.activeSearchTab]}\"><recent-search-card \nclass=\"search-div min-width-460 font-size-12 b pointer mt-10 p-8 mr-10\" \nng-repeat=\"searchItem in [1,2,3]  |  limitTo:( vm.showAllSearches[vm.activeSearchTab] ? \'\' : vm.showCardLimit())\" \nserachcard=\"searchItem\" mode=\"vm.activeSearchTab\"></recent-search-card></div></div><div \nng-if=\"vm.activeSearchTab ==\'FTL\'\"><div flex layout=\"row\" class=\"scroll_container width100 p-0 searchHistory\" \nng-if=\"vm.lastSearchArray.length\" ng-class=\"{\'layout-wrap\': vm.showAllSearches[vm.activeSearchTab]}\"><recent-search-ftl\n class=\"search-div min-width-460 font-size-12 b pointer mt-10 p-8 mr-10\" \nng-repeat=\"searchItem in vm.lastSearchArray  |  limitTo:( vm.showAllSearches[vm.activeSearchTab] ? \'\' : vm.showCardLimit()) track by searchItem.id+ $index\" \nsearchcard=\"searchItem\" mode=\"vm.activeSearchTab\" ng-click=\"vm.resultFtlSearch(searchItem,$index)\"></recent-search-ftl>\n</div><div flex layout=\"row\" class=\"scroll_container width100 p-0 searchHistory\" \nng-if=\"!vm.lastSearchArray.length && !vm.noSearchHistory && !vm.SearchHistoryReceived\" \nng-class=\"{\'layout-wrap\': vm.showAllSearches[vm.activeSearchTab]}\"><recent-search-ftl \nclass=\"search-div min-width-460 font-size-12 b pointer mt-10 p-8 mr-10\" \nng-repeat=\"searchItem in [1,2,3]  |  limitTo:( vm.showAllSearches[vm.activeSearchTab] ? \'\' : vm.showCardLimit())\" \nserachcard=\"searchItem\" mode=\"vm.activeSearchTab\"></recent-search-ftl></div></div></md-content><div layout=\"row\" \nclass=\"pv-20\" ng-if=\"!vm.lastSearchArray.length && (vm.noSearchHistory || vm.SearchHistoryReceived)\"><div \nlayout=\"column\" flex=\"100\" layout-align=\"center center\" layout-wrap class=\"ph-20 pv-20\"><div class=\"font-size-22\">\nNo Search History Available.</div></div></div></div>");
$templateCache.put("app/main/search/views/super-offers/super-offers.html","<div class=\"super-offers\" ng-if=\"vm.specialRates.length\"><div layout=\"row\" layout-padding \nlayout-align=\"space-between center\" class=\"pt-10 pb-0 ph-0\"><div class=\"font-size-20 title Font-Bold\"><md-icon \nmd-font-icon=\"icon-wallet-giftcard\" class=\"title-icon\"></md-icon>Offers</div><div><span \nclass=\"md-primary-fg b md-primary-border show-all pointer\" \nng-click=\"!vm.showAllOffers ? vm.showAll(\'offers\') : vm.goBackToSearch(\'offers\')\">\nShow {{vm.showAllOffers ? \'Less\' : \'All\'}}</span></div></div><div layout=\"row\" class=\"pb-10\"><div flex layout=\"row\" \nclass=\"scroll_container width100 p-0 superOffers\" layout-padding ng-class=\"{\'layout-wrap\': vm.showAllOffers}\"><div \nng-repeat=\"specialRates in vm.specialRates | limitTo:( vm.showAllOffers ? \'\' : vm.showCardLimit()) \"><offer-card \nng-repeat=\"rates in specialRates.rates | limitTo: 1 track by $index\" \nng-click=\"vm.fnSpecialRateResult(specialRates,rates)\" offercard=\"specialRates\" rates=\"rates\"></offer-card></div></div>\n</div></div>");
$templateCache.put("app/main/settings/dialogs/company-group-form/company-group-form.html","<md-dialog class=\"company-group-dialog popup-sm\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><div>\n{{ctrl.parent.button_name === \'Add\' ? \'Create New Company Group\' : \'Edit Company Group\'}}</div></div><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close fg-AAA8AD\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"body\"><form name=\"companyGroupFrm\" \nclass=\"font-size-13\"><div><span><label>Company Group Name</label></span><md-input-container class=\"md-block pt-6-imp\" \nmd-no-float><input ng-model=\"ctrl.parent.companyGroup_data.groupName\" \nng-class=\"{\'validation-error\': ctrl.parent.groupNameValidation || ctrl.parent.duplicateValidation}\" \nclass=\"panel-select\" name=\"groupName\" placeholder=\"Enter Company Group Name\" autocomplete=\"off\" \nng-keyup=\"ctrl.parent.groupNameValidation=false; ctrl.parent.duplicateValidation=false\"><div \nng-if=\"ctrl.parent.groupNameValidation\" class=\"validation-error-text\"><span>Enter the Company Group Name</span></div>\n<div ng-if=\"ctrl.parent.duplicateValidation\" class=\"validation-error-text\"><span>\n{{ctrl.parent.companyGroup_data.groupName}} already exists!</span></div></md-input-container></div><div \nclass=\"row-spacing\"><span><label>Company Type</label></span><md-input-container class=\"md-block pt-6-imp\" md-no-float>\n<md-select ng-model=\"ctrl.parent.displayCompanyType\" name=\"companyType\" class=\"panel-select\" \nplaceholder=\"Select Company Type\" ng-init=\"ctrl.parent.displayCompanyType = \'Customer\'\"><md-option value=\"Customer\">\nCustomer</md-option></md-select></md-input-container></div><div class=\"row-spacing\"><span><label>Companies</label>\n</span><md-input-container class=\"md-block pt-6-imp\" md-no-float><md-select \nng-model=\"ctrl.parent.companyGroup_data.companyIds\" name=\"companies\" \nng-class=\"{\'validation-error\': ctrl.parent.companyValidation}\" class=\"panel-select selectbox multi-select-width\" \nplaceholder=\"Select Companies\" multiple=\"multiple\" md-on-close=\"searchCompany = \'\'\" \nmd-on-open=\"ctrl.parent.companyValidation=false\"><md-select-header><input ng-model=\"searchCompany\" type=\"search\" \nplaceholder=\"Search Companies\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"\"><md-option \nng-repeat=\"company in ctrl.parent.customerCompanies | filter:searchCompany\" ng-value=\"company.id\"><div>\n{{company.company_name}}</div><div class=\"font-size-10 user-subText\">{{company.company_email}}</div></md-option>\n</md-optgroup></md-select><div ng-if=\"ctrl.parent.companyValidation\" class=\"validation-error-text\"><span>\nSelect at least one company</span></div></md-input-container></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\" class=\"white-bg footer\" layout-wrap flex-xs=\"100\"><div class=\"mv-10\"><md-button \nmd-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10 save1\" ng-click=\"ctrl.parent.fnSubmitCompanyGroup()\" \nng-disabled=\"ctrl.parent.submit_disabled\">{{ctrl.parent.button_name}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/company-group-view/company-group-view.html","<md-dialog class=\"company-group-view-dialog popup-sm\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><div>Company Group Details\n</div></div><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"body\"><div \nclass=\"font-size-13\"><div class=\"mb-20\"><span class=\"font-weight-600\">Group Name:</span> <span class=\"ml-10\">\n{{ctrl.parent.selectedCompanyGroup.groupName}}</span></div><div class=\"mb-20\"><span class=\"font-weight-600\">\nCompany Type:</span> <span class=\"ml-10\">Customer</span></div><div class=\"mb-20\"><span class=\"font-weight-600\">\nCreated Date:</span> <span class=\"ml-10\">{{ctrl.parent.selectedCompanyGroup.createdAt | date:\'dd/MM/yyyy\'}}</span>\n</div><div class=\"mb-20\"><span class=\"font-weight-600\">Companies ({{ctrl.parent.selectedCompanies.length}}):</span>\n</div><div ng-if=\"ctrl.parent.selectedCompanies.length > 0\" class=\"company-list\"><div \nng-repeat=\"company in ctrl.parent.selectedCompanies track by $index\" class=\"company-item mb-10 p-10\" \nstyle=\"border: 1px solid #e0e0e0; border-radius: 4px\"><div class=\"font-weight-600\">{{company.company_name}}</div><div \nclass=\"font-size-12 grey-500-fg\">{{company.company_email}}</div></div></div><div \nng-if=\"ctrl.parent.selectedCompanies.length === 0\" class=\"text-center grey-500-fg\">No companies assigned to this group\n</div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/dialogs/confirm-leave/confirm-leave.html","<md-dialog id=\"confirm-leave\" class=\"popup-xs\"><md-dialog-content layout=\"column\" layout-align=\"center center\" \nclass=\"body pb-5\"><div>Do you want to delete this rate card ?</div><div class=\"grey-fg font-size-11 font-weight-600\">\nWithout saving the changes.</div></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\" \nlayout-align=\"end center\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.confirmLeave(\'no\', $event)\" title=\"Cancel\">No</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" ng-click=\"ctrl.parent.confirmLeave(\'yes\', $event)\" \nng-disabled=\"ctrl.parent.deleteBtn\" title=\"Delete\">Yes</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/edit-logo/edit-logo.html","<md-dialog id=\"companyEditLogo\" class=\"edit-logo popup-md\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools pv-10\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h-21\"><div>\nEdit Logo</div><div class=\"font-size-11 fg-AAA8AD h-15\">logo format (.png, .jpg, .jpeg), size not more like than 10mb.\n</div></div><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"pv-15 ph-20\"><div flex><span class=\"label\" translate=\"Select logo style\">Select logo style</span><md-radio-group\n class=\"mt-5\" layout=\"row\" flex=\"100\" layout-wrap ng-model=\"ctrl.parent.logoStyle\" \nng-change=\"ctrl.parent.fnlogoStyleChange(ctrl.parent.image)\"><md-radio-button md-no-ink value=\"rectangle\" \nclass=\"md-primary\">Rectangle</md-radio-button><md-radio-button md-no-ink value=\"square\" class=\"md-primary\">Square\n</md-radio-button></md-radio-group></div><div class=\"cropper-box\"><image id=\"image\" class=\"cropper-img\" \nng-src=\"{{ctrl.parent.util.sanitizeQueryParams(ctrl.parent.src)}}\"></div></md-dialog-content><md-dialog-actions \nclass=\"sticky-strip bottom-0 card_shadow bt\" layout=\"row\" layout-align=\"end center\" class=\"white-bg bt\" layout-wrap \nflex-xs=\"100\"><md-button md-no-ink class=\"md-accent-btn ml-10 save1\" ng-click=\"ctrl.parent.saveImg($event)\" \ntype=\"submit\">Done</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/role-form/role-add.html","<md-dialog class=\"role-dialog popup-sm\"><md-toolbar class=\"white-bg black-fg\"><div class=\"md-toolbar-tools\" flex=\"100\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div>Create Role</div></div><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog(\'Role-Create-Close-Click\')\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><form name=\"roleFrm\"><md-dialog-content \nclass=\"body\"><div ng-if=\"ctrl.parent.util.isFreightbro\"><span class=\"label\"><span translate=\"Type\">Type</span></span>\n<md-input-container class=\"md-block pt-6-imp\" md-no-float><md-select class=\"select-box\" \nng-model=\"ctrl.parent.roles.type\" placeholder=\"Select Type\" \nng-change=\"ctrl.parent.fnChangeRolesType(ctrl.parent.roles.type)\"><md-option value=\"GLOBAL\">Global</md-option>\n<md-option value=\"USER_DEFINED\">User Defined</md-option></md-select></md-input-container></div><div \nng-class=\"{\'row-spacing\':ctrl.parent.util.isFreightbro}\" \nng-show=\"ctrl.parent.util.isFreightbro || ctrl.parent.util.isAdmin\"><div class=\"pb-6-imp\"><label \ntranslate=\"Created_For\">Created For</label><md-input-container class=\"md-block pt-6-imp\" md-no-float><md-select \nclass=\"panel-select\" ng-class=\"{\'validation-error\':ctrl.parent.createdForValidation}\" \nng-model=\"ctrl.parent.roles.created_for\" name=\"created_for\" placeholder=\"Select User Type\" \nng-change=\"ctrl.parent.fnChangeCreateFor(ctrl.parent.roles.created_for)\" md-on-open=\"ctrl.parent.createdForValidation\">\n<md-option value=\"FORWARDER\">Forwarder</md-option><md-option value=\"SHIPPER\">Customer</md-option></md-select>\n</md-input-container><div ng-if=\"ctrl.parent.createdForValidation\" class=\"validation-error-text\"><span>\nSelect the User Type from the dropdown</span></div></div></div><div class=\"row-spacing\"><label translate=\"Roles\">Roles\n</label><md-input-container class=\"md-block pt-6-imp\" md-no-float><input ng-model=\"ctrl.parent.roles.name\" \nng-change=\"ctrl.parent.fnTrackAnalytics(\'Role-RoleName-Change\')\" \nng-model-options=\"{\n                        updateOn: \'default blur onchange\',\n                        debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                      }\" \nng-class=\"{\'validation-error\':(ctrl.parent.rolesValidation || ctrl.parent.roleNameValidation)}\" class=\"panel-select\" \nname=\"role_name\" placeholder=\"Role Name\" autocomplete=\"off\" \nng-keyup=\"ctrl.parent.rolesValidation=false;ctrl.parent.roleNameValidation=false\"><div \nng-if=\"ctrl.parent.rolesValidation\" class=\"validation-error-text\"><span>Enter the Role Name</span></div><div \nng-if=\"ctrl.parent.roleNameValidation\" class=\"validation-error-text\"><span>Role{{vm.roles.name}} already exist !</span>\n</div></md-input-container></div><div class=\"row-spacing\" layout=\"row\" \nng-show=\"ctrl.parent.util.isFreightbro || ctrl.parent.util.isAdmin\" ng-if=\"ctrl.parent.moduleList.length > 0\"><div \nclass=\"mr-30\"><span><span translate=\"Access All Data\">Access All Data</span> <span class=\"icon\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"info-icon pointer\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"white-fg brad-4 font-weight-400 font-size-11\" style=\"display: table;opacity: 1;background: rgba(51,51,51,0.9)\">\nUser assigned to this role would have access to all data of Enquiries, Quotes & Shipments</md-tooltip></span></span>\n<div layout=\"row\" layout-align=\"left center\"><div class=\"pr-20\">No</div><md-input-container><md-switch md-no-ink \nng-model=\"ctrl.parent.roles.is_super_role\" aria-label=\"Switch 1\" class=\"m-0 pr-8\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-change=\"ctrl.parent.fnDefaultAccessModule()\"></md-switch></md-input-container><div class=\"pl-20\">Yes</div></div>\n</div><div><span><span translate=\"Access Unpublished Rates\">Access Unpublished Rates</span> <span class=\"icon\"><md-icon\n md-font-icon=\"icon-information-outline\" class=\"info-icon pointer\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"white-fg brad-4 font-weight-400 font-size-11\" style=\"display: table;opacity: 1;background: rgba(51,51,51,0.9)\">\nAllows user to fetch unpublished rates</md-tooltip></span></span><div layout=\"row\" layout-align=\"left center\"><div \nclass=\"pr-20\">No</div><md-input-container><md-switch md-no-ink \nng-model=\"ctrl.parent.roles.is_unpublished_rates_allowed\" aria-label=\"Access Unpublished Rates\" class=\"m-0 pr-8\" \nng-true-value=\"1\" ng-false-value=\"0\"></md-switch></md-input-container><div class=\"pl-20\">Yes</div></div></div></div>\n<div class=\"row-spacing\" ng-show=\"ctrl.parent.util.isFreightbro || ctrl.parent.util.isAdmin\"><label \ntranslate=\"Accessible Pricing Levels\">Accessible Pricing Levels</label><md-input-container class=\"md-block pt-6-imp\" \nmd-no-float><md-select class=\"panel-select\" ng-model=\"ctrl.parent.roles.accessible_pricing_levels\" \nplaceholder=\"Select Pricing Levels\" multiple=\"multiple\"><md-option ng-repeat=\"level in ctrl.parent.pricingLevels\" \nng-value=\"level\">{{level}}</md-option></md-select></md-input-container></div><div class=\"row-spacing mb-6-imp\" \nng-if=\"ctrl.parent.moduleList.length > 0\"><span translate=\"Search_Modules\">Search Modules</span></div><md-menu \nmd-position-mode=\"left bottom\" class=\"pt-3-imp dropdown\"><div><md-input-container md-no-float \nclass=\"dropdown panel-select pt-6-imp width-full p-0 m-0\" ng-class=\"{\'validation-error\':ctrl.parent.moduleValidation}\" \nplaceholder=\"Role Name\"><div layout=\"row\" layout-align=\"space-between center\" \nng-click=\"$mdMenu.open();ctrl.parent.moduleValidation=false\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" \nflex=\"80\"><div truncate=\"{{ctrl.parent.detailBoxString}}\" class=\"mt-2 pb-5 hide-overflow text-truncate\" \nng-class=\"{\'placeholder-style\': !ctrl.parent.detailBoxString}\">\n{{ctrl.parent.detailBoxString ? ctrl.parent.detailBoxString : \"Select Modules\"}}<md-tooltip \nng-if=\"ctrl.parent.detailBoxTooltip\" md-direction=\"bottom\" \nclass=\"white-fg bg-343434 font-size-12 text-left pv-5 ph-10\" \nstyle=\"display: table;opacity: 1; height: auto; white-space: pre-line\"><span>{{ctrl.parent.detailBoxTooltip}}</span>\n</md-tooltip></div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"search-arrow-icon\"></md-icon></div>\n</md-input-container></div><md-menu-content width=\"5\" class=\"p-10\"><md-menu-item><md-input-container class=\"md-block\" \nmd-no-float><input ng-model=\"ctrl.parent.search_module_name\" class=\"panel-select\" name=\"search_module_name\" \nplaceholder=\"Search Modules\"></md-input-container></md-menu-item><md-menu-item \nng-repeat=\"module in ctrl.parent.moduleList  | filter : {\'module_name\': ctrl.parent.search_module_name} track by $index\" \nclass=\"dropdown-menu\"><div layout=\"column\"><div layout=\"row\"><md-checkbox md-no-ink flex=\"5\" class=\"md-primary-fg\" \nng-model=\"module.isSelected\" \nng-change=\"ctrl.parent.fnSelectAllPermission(module.isSelected,module);ctrl.parent.fnTrackAnalytics(\'Role-SearchModule-Change\',{\'serch query\':ctrl.parent.search_module_name})\" \nng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox><div class=\"label pl-5\">{{module.title || module.module_name}}</div>\n</div><div class=\"permission_div mb-20 ml-25\" layout=\"column\" layout-align=\"start start\" ng-if=\"module.isSelected\"><div\n layout=\"row\" class=\"mr-15\"><md-checkbox md-no-ink class=\"m-0\" ng-model=\"module.create\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-change=\"ctrl.parent.fnChangePermission(module)\"></md-checkbox><span class=\"pt-5\" \ntranslate=\"Create\">Create</span></div><div layout=\"row\" class=\"mt-10 mr-15\"><md-checkbox md-no-ink class=\"m-0\" \nng-model=\"module.read\" ng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"ctrl.parent.fnChangePermission(module)\">\n</md-checkbox><span class=\"pt-5\" translate=\"Read\">Read</span></div><div layout=\"row\" class=\"mt-10 mr-15\"><md-checkbox \nmd-no-ink class=\"md-warn m-0\" ng-model=\"module.edit\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-change=\"ctrl.parent.fnChangePermission(module)\"></md-checkbox><span class=\"pt-5\" translate=\"Update\">Update</span>\n</div><div layout=\"row\" class=\"mt-10 mr-15\"><md-checkbox md-no-ink class=\"m-0\" ng-model=\"module.delete\" \nng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"ctrl.parent.fnChangePermission(module)\"></md-checkbox><span \nclass=\"pt-5\" translate=\"Delete\">Delete</span></div></div></div></md-menu-item></md-menu-content></md-menu><div \nng-if=\"ctrl.parent.moduleValidation\" class=\"validation-error-text\"><span>Select Modules</span></div>\n</md-dialog-content></form><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"white-bg footer\" \nlayout-wrap flex-xs=\"100\"><div class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(\'Role-Create-Cancel-Click\')\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10 save1\" ng-click=\"ctrl.parent.fnSubmitRoles()\">Create</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/settings/dialogs/role-form/role-edit.html","<md-dialog class=\"role-dialog edit-role-dialog popup-md\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><div>\n{{ctrl.parent.roles.name}}</div></div><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog(\'Role-Edit-Close-Click\')\"><md-icon md-font-icon=\"icon-close fg-AAA8AD\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"body\"><form><div class=\"role-settings-section mb-20\" \nng-if=\"ctrl.parent.allowOperation(ctrl.parent.roles)\"><div class=\"row-spacing\" \nng-show=\"ctrl.parent.util.isFreightbro || ctrl.parent.util.isAdmin\"><label translate=\"Role Name\">Role Name</label>\n<md-input-container class=\"md-block pt-6-imp\" md-no-float><input ng-model=\"ctrl.parent.roles.name\" \nclass=\"panel-select\" name=\"role_name\" placeholder=\"Role Name\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-spacing\" layout=\"row\" ng-show=\"ctrl.parent.util.isFreightbro || ctrl.parent.util.isAdmin\"><div \nclass=\"mr-30\"><span><span translate=\"Access All Data\">Access All Data</span> <span class=\"icon\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"info-icon pointer\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"white-fg brad-4 font-weight-400 font-size-11\" style=\"display: table;opacity: 1;background: rgba(51,51,51,0.9)\">\nUser assigned to this role would have access to all data of Enquiries, Quotes & Shipments</md-tooltip></span></span>\n<div layout=\"row\" layout-align=\"left center\"><div class=\"pr-20\">No</div><md-input-container><md-switch md-no-ink \nng-model=\"ctrl.parent.roles.is_super_role\" aria-label=\"Switch 1\" class=\"m-0 pr-8\" ng-true-value=\"1\" ng-false-value=\"0\">\n</md-switch></md-input-container><div class=\"pl-20\">Yes</div></div></div><div><span><span \ntranslate=\"Access Unpublished Rates\">Access Unpublished Rates</span> <span class=\"icon\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"info-icon pointer\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"white-fg brad-4 font-weight-400 font-size-11\" style=\"display: table;opacity: 1;background: rgba(51,51,51,0.9)\">\nAllows user to fetch unpublished rates</md-tooltip></span></span><div layout=\"row\" layout-align=\"left center\"><div \nclass=\"pr-20\">No</div><md-input-container><md-switch md-no-ink \nng-model=\"ctrl.parent.roles.is_unpublished_rates_allowed\" aria-label=\"Access Unpublished Rates\" class=\"m-0 pr-8\" \nng-true-value=\"1\" ng-false-value=\"0\"></md-switch></md-input-container><div class=\"pl-20\">Yes</div></div></div></div>\n<div class=\"row-spacing\" ng-show=\"ctrl.parent.util.isFreightbro || ctrl.parent.util.isAdmin\"><label \ntranslate=\"Accessible Pricing Levels\">Accessible Pricing Levels</label><md-input-container class=\"md-block pt-6-imp\" \nmd-no-float><md-select class=\"panel-select\" ng-model=\"ctrl.parent.roles.accessible_pricing_levels\" \nplaceholder=\"Select Pricing Levels\" multiple=\"multiple\"><md-option ng-repeat=\"level in ctrl.parent.pricingLevels\" \nng-value=\"level\">{{level}}</md-option></md-select></md-input-container></div></div><div class=\"permission_exp\"><div \nclass=\"permission_form\" ng-if=\"ctrl.parent.allowOperation(ctrl.parent.roles)\"><div layout=\"row\" flex=\"100\" \nclass=\"text-center font-size-13 font-weight-600\"><div flex=\"20\" translate=\"Modules\">Modules</div><div flex=\"60\" \ntranslate=\"Permission\">Permission</div><div flex=\"20\" translate=\"Action\">Action</div></div><div layout=\"row\" \nflex=\"100\" class=\"pv-8\"><div flex=\"20\" class=\"mv-5\"><md-select ng-model=\"ctrl.parent.roles.module\" \nplaceholder=\"Select Module\" name=\"module\" class=\"m-0 panel-select\" \nng-change=\"ctrl.parent.fnValidateModuleFrm(ctrl.parent.roles)\" md-on-close=\"searchModule = \'\'\"><md-select-header><input\n ng-model=\"searchModule\" type=\"search\" placeholder=\"Search Modules\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"\"><md-option \nng-repeat=\"mod in ctrl.parent.roles.moduleList | orderBy:\'module_name\' | filter:{ \'module_name\':  searchModule }\" \nng-value=\"mod\">{{mod.module_name}}</md-option></md-optgroup></md-select></div><div flex=\"60\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"permission_div border-none p-10\" layout=\"row\" \nlayout-align=\"space-between start\" flex=\"100\"><div layout=\"row\" class=\"create_check mr-15\"><md-checkbox md-no-ink \nclass=\"m-0\" ng-model=\"ctrl.parent.roles.module.create\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-change=\"ctrl.parent.fnChangePermission(ctrl.parent.roles.module)\"></md-checkbox><span \nclass=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Create\">Create</span></div><div layout=\"row\" \nclass=\"read_check mr-15\"><md-checkbox md-no-ink class=\"m-0\" ng-model=\"ctrl.parent.roles.module.read\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-change=\"ctrl.parent.fnChangePermission(ctrl.parent.roles.module)\"></md-checkbox><span \nclass=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Read\">Read</span></div><div layout=\"row\" \nclass=\"update_check mr-15\"><md-checkbox md-no-ink class=\"md-warn m-0\" ng-model=\"ctrl.parent.roles.module.edit\" \nng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"ctrl.parent.fnChangePermission(ctrl.parent.roles.module)\">\n</md-checkbox><span class=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Update\">Update</span></div><div \nlayout=\"row\" class=\"delete_check mr-15\"><md-checkbox md-no-ink class=\"m-0\" ng-model=\"ctrl.parent.roles.module.delete\" \nng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"ctrl.parent.fnChangePermission(ctrl.parent.roles.module)\">\n</md-checkbox><span class=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Delete\">Delete</span></div></div>\n</div><div flex=\"20\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"green-300-fg pointer\" ng-click=\"ctrl.parent.addModule(ctrl.parent.roles)\"></md-icon></div></div></div><div \nclass=\"module_list_div\"><div ng-repeat=\"module in ctrl.parent.roles.modules\" ng-if=\"!module.is_removed\"><div \nlayout=\"row\" flex=\"100\" class=\"pv-8\"><div flex=\"20\" class=\"font-weight-600 text-center font-size-12 grey-fg pt-10\">\n{{module.module_name}}</div><div flex=\"60\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"permission_div border-none p-10\" layout=\"row\" layout-align=\"space-between start\" flex=\"100\"><div layout=\"row\" \nclass=\"create_check mr-15\"><md-checkbox md-no-ink class=\"m-0\" ng-model=\"module.create\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"ctrl.parent.roles.type == \'GLOBAL\' && !ctrl.parent.util.isFreightbro\" \nng-change=\"ctrl.parent.fnChangePermission(module)\"></md-checkbox><span \nclass=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Create\">Create</span></div><div layout=\"row\" \nclass=\"read_check mr-15\"><md-checkbox md-no-ink class=\"m-0\" ng-model=\"module.read\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"ctrl.parent.roles.type == \'GLOBAL\' && !ctrl.parent.util.isFreightbro\" \nng-change=\"ctrl.parent.fnChangePermission(module)\"></md-checkbox><span \nclass=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Read\">Read</span></div><div layout=\"row\" \nclass=\"update_check mr-15\"><md-checkbox md-no-ink class=\"md-warn m-0\" ng-model=\"module.edit\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"ctrl.parent.roles.type == \'GLOBAL\' && !ctrl.parent.util.isFreightbro\" \nng-change=\"ctrl.parent.fnChangePermission(module)\"></md-checkbox><span \nclass=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Update\">Update</span></div><div layout=\"row\" \nclass=\"delete_check mr-15\"><md-checkbox md-no-ink class=\"m-0\" ng-model=\"module.delete\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"ctrl.parent.roles.type == \'GLOBAL\' && !ctrl.parent.util.isFreightbro\" \nng-change=\"ctrl.parent.fnChangePermission(module)\"></md-checkbox><span \nclass=\"text-center ml-5 font-size-10 grey-600-fg\" translate=\"Delete\">Delete</span></div></div></div><div flex=\"20\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"red-300-fg pointer\" \nng-click=\"ctrl.parent.fnDeleteModule(module,$event)\" ng-if=\"ctrl.parent.allowOperation(ctrl.parent.roles)\"></md-icon>\n</div></div></div></div></div></form></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\" \nlayout-align=\"end center\" class=\"white-bg bt\" layout-wrap flex-xs=\"100\"><div class=\"mv-10\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog(\'Role-Edit-Cancel-Click\')\">Cancel</md-button><md-button\n md-no-ink class=\"md-accent-btn ml-10 save1\" \nng-click=\"ctrl.parent.fnUpdateRole(ctrl.parent.roles,ctrl.parent.editedIndex)\" \nng-if=\"(ctrl.parent.rolePermission[2] && (ctrl.parent.roles.type === \'GLOBAL\'&& ctrl.parent.util.isFreightbro || ctrl.parent.roles.type !== \'GLOBAL\'))\">\nUpdate</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/show-user/show-users.html","<md-dialog id=\"show-users\" class=\"user\"><md-toolbar class=\"modal_title white-bg black-fg border-bottom\"><div \nclass=\"md-toolbar-tools\"><div class=\"font-size-16 font-weight-600 pl-5\">Users</div><span flex></span><md-button \nmd-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close black-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><div layout=\"column\" \nclass=\"mb-10\" flex=\"50\" flex-xs=\"100\" ng-repeat=\"user in ctrl.parent.showUsersList track by $index\"><div layout=\"row\">\n<div><ng-avatar string=\"{{user.user_first_name}}  {{user.user_last_name}}\" round-shape=\"true\" auto-color=\"true\">\n</ng-avatar></div><div class=\"pt-8 pl-10 font-size-14 pointer\" ng-click=\"ctrl.parent.viewUsersModule()\">\n{{user.user_first_name}} {{user.user_last_name}}</div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/dialogs/tag-form/tag-form.html","<md-dialog class=\"tag-dialog popup-sm\"><md-toolbar class=\"modal_title white-bg black-fg\"><div class=\"md-toolbar-tools\" \nflex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><div>Create Tag</div></div><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close fg-AAA8AD\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"body\"><form name=\"tagsFrm\"><div><span><label \ntranslate=\"Create_New\">Create New</label></span><div layout=\"row\" flex=\"100\" class=\"mt-6-imp\"><div flex=\"60\">\n<md-input-container class=\"md-block\" md-no-float style=\"margin-right: 20px\"><input ng-model=\"ctrl.parent.tag_name\" \nng-class=\"{\'validation-error\':(ctrl.parent.tagnameValidation || ctrl.parent.tagValidation)}\" class=\"panel-select\" \nonkeyup=\"this.value = this.value.toUpperCase()\" name=\"tag_name\" placeholder=\"Enter Tag Name\" autocomplete=\"off\" \nng-keyup=\"ctrl.parent.tagnameValidation=false;ctrl.parent.tagValidation=false\"></md-input-container><div \nng-if=\"ctrl.parent.tagnameValidation\" class=\"validation-error-text\"><span>Enter the desired Tag Name</span></div><div \nng-if=\"ctrl.parent.tagValidation\" class=\"validation-error-text\"><span>{{ctrl.parent.tag_name}}already exist !</span>\n</div></div><md-input-container class=\"md-block\" md-no-float flex=\"40\"><md-select class=\"panel-select\" \nng-model=\"ctrl.parent.tag_color\"><md-option ng-value=\"tag_color\" \nng-repeat=\"tag_color in ctrl.parent.tag_color_arr track by $index\"><md-icon md-font-icon=\"icon-tag-text-outline\" \nclass=\"{{tag_color}} s18\"></md-icon></md-option></md-select></md-input-container></div></div></form>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\" layout-align=\"end center\" class=\"white-bg bt\" \nlayout-wrap flex-xs=\"100\"><div class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10 save1\" \nng-click=\"ctrl.parent.fnSubmitTag(tagsFrm)\">Create</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/team-form/team-form.html","<md-dialog class=\"team-dialog popup-sm\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\" flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div><div>Create New Team</div>\n</div><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"body\"><form \nname=\"teamFrm\" class=\"font-size-13\"><div><span><label translate=\"Team_Name\">Team Name</label></span><md-input-container\n class=\"md-block pt-6-imp\" md-no-float><input ng-model=\"ctrl.parent.team_data.name\" \nng-class=\"{\'validation-error\':ctrl.parent.teamnameValidation || ctrl.parent.teamValidation}\" class=\"panel-select\" \nname=\"name\" placeholder=\"Enter Team Name\" class=\"team_name\" autocomplete=\"off\" \nng-keyup=\"ctrl.parent.teamnameValidation=false;ctrl.parent.teamValidation=false\" \nng-change=\"ctrl.parent.fnTrackAnalytics(\'Team-TeamName-Change\')\" \nng-model-options=\"{\n                        updateOn: \'default blur onchange\',\n                        debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                      }\">\n<div ng-if=\"ctrl.parent.teamnameValidation\" class=\"validation-error-text\"><span>Enter the Team Name</span></div><div \nng-if=\"ctrl.parent.teamValidation\" class=\"validation-error-text\"><span>\n{{ctrl.parent.team_data.name}} team already exist !</span></div></md-input-container></div><div class=\"row-spacing\">\n<span><label translate=\"Manager\">Manager</label></span><md-input-container class=\"md-block pt-6-imp\" md-no-float>\n<md-select ng-model=\"ctrl.parent.team_data.managers\" name=\"managers\" \nng-class=\"{\'validation-error\':ctrl.parent.managerValidation}\" class=\"panel-select selectbox multi-select-width\" \nplaceholder=\"Select Manager\" multiple=\"multiple\" md-on-close=\"searchManager = \'\'\" \nmd-on-open=\"ctrl.parent.managerValidation=false\" ng-change=\"ctrl.parent.fnTrackAnalytics(\'Team-Manager-Change\')\">\n<md-select-header><input ng-model=\"searchManager\" type=\"search\" placeholder=\"Search Managers\" \nclass=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"\"><md-option \nng-repeat=\"manager in ctrl.parent.managerList | orderBy:\'user_first_name\' | multipleKey :searchManager:{user_first_name:\'user_first_name\',user_last_name:\'user_last_name\'}\" \nng-value=\"manager.id\"><div>{{manager.user_first_name}} {{manager.user_last_name}}</div><div \nclass=\"font-size-10 user-subText\">{{manager.email}}</div></md-option></md-optgroup></md-select><div \nng-if=\"ctrl.parent.managerValidation\" class=\"validation-error-text\"><span>Select the Team Manager</span></div>\n</md-input-container></div><div class=\"row-spacing\"><span translate=\"Team_Manager\">Team Members</span>\n<md-input-container class=\"md-block pt-6-imp\" md-no-float><md-select ng-model=\"ctrl.parent.team_data.members\" \nname=\"members\" class=\"panel-select selectbox multi-select-width\" placeholder=\"Select Team Members\" \nmd-on-close=\"searchMembers = \'\'\" multiple=\"multiple\" \nng-change=\"ctrl.parent.fnTrackAnalytics(\'Team-TeamMember-Change\')\"><md-select-header><input ng-model=\"searchMembers\" \ntype=\"search\" placeholder=\"Search Members\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"\"><md-option \nng-repeat=\"member in ctrl.parent.membersList | orderBy:\'user_first_name\'  | multipleKey :searchMembers:{user_first_name:\'user_first_name\',user_last_name:\'user_last_name\'}\" \nng-value=\"member.id\"><div>{{member.user_first_name}} {{member.user_last_name}}</div><div \nclass=\"font-size-10 user-subText\">{{member.email}}</div></md-option></md-optgroup></md-select></md-input-container>\n</div><div class=\"row-spacing\" ng-if=\"ctrl.parent.teamList.length > 0\"><span translate=\"Assign_Parent_Team\">\nAssign Parent Team</span><md-input-container class=\"md-block pt-6-imp\" md-no-float><md-select \nng-model=\"ctrl.parent.team_data.parent\" class=\"panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.parenTeamValidation}\" md-on-open=\"ctrl.parent.parenTeamValidation=false\" \nname=\"parent\" placeholder=\"Select Parent Team\" md-on-close=\"searchParentTeam.name = \'\'\" \nng-change=\"ctrl.parent.fnTrackAnalytics(\'Team-ParentTeam-Change\')\"><md-select-header><input \nng-model=\"searchParentTeam.name\" type=\"search\" placeholder=\"Search Team\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"team in ctrl.parent.teamList  | orderBy:\'name\'| filter :{\'name\':searchParentTeam.name } \" \nng-value=\"team._id\">{{team.name}}</md-option></md-select><div ng-if=\"ctrl.parent.parenTeamValidation\" \nclass=\"validation-error-text\"><span>Team name and parent team name can not be same!</span></div></md-input-container>\n</div></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"white-bg footer\" \nlayout-wrap flex-xs=\"100\"><div class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10 save1\" \nng-click=\"ctrl.parent.fnSubmitTeam()\">{{ctrl.parent.button_name}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/team-view/team-view.html","<md-dialog id=\"team-view\"><md-toolbar class=\"modal_title white-bg black-fg\"><div class=\"md-toolbar-tools\"><div>\nTeam View</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\">\n<md-icon md-font-icon=\"icon-close fg-AAA8AD\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nshimmer-effect-full width=\"97%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" ng-if=\"ctrl.parent.isTeamLoading\" \nng-repeat=\"shimmer in [1,2,3,4]\"></div><div class=\"tree mt-50\"><ul><li ng-repeat=\"category in ctrl.parent.children\" \nng-include=\"\'categoryTree\'\"></li></ul><script type=\"text/ng-template\" id=\"categoryTree\">\n<a>\n                    <div layout=\"row\" flex=\"100\" class=\"font-size-14\">\n                        <div>\n                            <md-icon md-font-icon=\"icon-account-multiple\" class=\"grey-fg profile_icon\"></md-icon>\n                        </div>\n                        <div>\n                            <span class=\"black-fg\">{{category.name}}</span>\n                            <br>\n                            <span class=\"grey-500-fg\">{{category.managers.length}} <span ng-show=\"category.managers.length <= 1 || !category.managers\">Manager</span> <span  ng-show=\"category.managers.length > 1\">Managers</span></span><br>\n                            <span class=\"grey-500-fg\">{{category.members.length}} <span ng-show=\"category.members.length <= 1 || !category.members\">Member</span> <span  ng-show=\"category.members.length > 1\">Members</span></span>\n                        </div>\n                    </div>\n                </a>\n                <ul ng-if=\"category.children && category.children.length > 0\">\n                    <li ng-repeat=\"category in category.children\" ng-include=\"\'categoryTree\'\"> </li>\n                </ul>\n</script></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/additional-service/additional-service.html","<md-dialog id=\"additional-service\"><div layout=\"row\" layout-padding class=\"border-bottom mh-15 mt-15 mb-0 pl-0\" \nlayout-xs=\"column\" flex=\"100\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5px\" flex=\"50\" flex-xs=\"100\">\nEDIT ADDITIONAL SERVICES</div><div layout=\"row\" layout-align=\"end end\" flex=\"50\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-close\" class=\"mr-5\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div><md-dialog-content>\n<div layout=\"column\" flex=\"100\"><div class=\"font-weight-600 font-size-14\">Insurance</div><div layout=\"row\">\n<md-input-container md-no-float class=\"mv-0 ml-0 mr-10\"><input required name=\"clientName\" ng-model=\"ccc\">\n</md-input-container><md-input-container md-no-float class=\"m-0\"><md-select name=\"type\" ng-model=\"USD\" ng-value=\"USD\">\n<md-option ng-value=\"USD\">USD</md-option><md-option ng-value=\"AED\">AED</md-option></md-select></md-input-container><div\n layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"mr-5 font-size-20 cancel-icon\"></md-icon></div></div><div class=\"font-weight-600 font-size-14\">\nTemperature Control</div><div layout=\"row\" class=\"border-bottom\"><md-input-container md-no-float \nclass=\"mv-0 ml-0 mr-10\"><input required name=\"clientName\" ng-model=\"aaa\"></md-input-container><md-input-container \nmd-no-float class=\"m-0\"><md-select name=\"type\" ng-model=\"temp\" ng-value=\"Cb\"><md-option ng-value=\"Cb\">Cb</md-option>\n<md-option ng-value=\"C\">C</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><md-icon md-font-icon=\"icon-cancel\" class=\"mr-5 font-size-20 cancel-icon\"></md-icon></div></div><div \nlayout=\"column\"><div layout=\"row\" class=\"mt-20\" flex=\"100\" layout-xs=\"column\"><div class=\"service_list\" flex=\"50\" \nflex-xs=\"100\"><div layout=\"row\" flex=\"100\"><div flex=\"80\">Zone Regulation</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"20\"><md-icon md-font-icon=\"icon-plus-circle green-fg\n                                \" \nclass=\"mr-5 font-size-20\"></md-icon></div></div><div layout=\"row\" flex=\"100\"><div flex=\"80\">Customs</div><div \nlayout=\"row\" layout-align=\"end end\" flex=\"20\"><md-icon \nmd-font-icon=\"icon-plus-circle green-fg\n                                \" class=\"mr-5 font-size-20\"></md-icon></div>\n</div><div layout=\"row\" flex=\"100\"><div flex=\"80\">Fumigation</div><div layout=\"row\" layout-align=\"end end\" flex=\"20\">\n<md-icon md-font-icon=\"icon-plus-circle green-fg\n                                \" class=\"mr-5 font-size-20\"></md-icon>\n</div></div></div><div flex=\"50\" flex-xs=\"100\"><div layout=\"row\" flex=\"100\"><div flex=\"80\">Zone Regulation</div><div \nlayout=\"row\" layout-align=\"end end\" flex=\"20\"><md-icon \nmd-font-icon=\"icon-plus-circle green-fg\n                                \" class=\"mr-5 font-size-20\"></md-icon></div>\n</div><div layout=\"row\" flex=\"100\"><div flex=\"80\">Customs</div><div layout=\"row\" layout-align=\"end end\" flex=\"20\">\n<md-icon md-font-icon=\"icon-plus-circle green-fg\n                                \" class=\"mr-5 font-size-20\"></md-icon>\n</div></div><div layout=\"row\" flex=\"100\"><div flex=\"80\">Fumigation</div><div layout=\"row\" layout-align=\"end end\" \nflex=\"20\"><md-icon md-font-icon=\"icon-plus-circle green-fg\n                                \" class=\"mr-5 font-size-20\">\n</md-icon></div></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\">Cancel</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/air-schedule-edit/air-schedule-edit.html","<md-dialog id=\"air-schedule-edit\" class=\"popup-md\"><form autocomplete=\"off\" name=\"airScheduleForm\" \nng-submit=\"ctrl.parent.fnSaveAirSchedule()\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\" flex=\"80\">{{ctrl.parent.scheduleModalTitle}} Schedule</div><div layout=\"row\" layout-align=\"end end\" \nflex=\"20\" class=\"p-0\"><md-icon md-font-icon=\"icon-close\" class=\"mr-5 fg-AAA8AD pointer\" \nng-click=\"ctrl.parent.cancelDialog();\"></md-icon></div></div><md-dialog-content class=\"body\"><div layout=\"row\" \nflex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Origin Airport</span><br>\n<md-input-container md-no-float class=\"panel-select-disabled text-truncate\" \ntitle=\"{{ctrl.parent.edit_schedule_track.origin_port_name}}\">\n{{ctrl.parent.edit_schedule_track.origin_port}} - {{ctrl.parent.edit_schedule_track.origin_port_name}}\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Destination Airport\n</span><br><md-input-container md-no-float class=\"panel-select-disabled text-truncate\" \ntitle=\"{{ctrl.parent.edit_schedule_track.destination_port_name}}\">\n{{ctrl.parent.edit_schedule_track.destination_port}} - {{ctrl.parent.edit_schedule_track.destination_port_name }}\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" \nflex-xs=\"100\" class=\"feild-spacing\"><span>Aircraft Type</span><br><md-input-container md-no-float class=\"input_text\">\n<input class=\"panel-select md-input-focused\" id=\"aircraftType\" name=\"aircraftType\" \nng-model=\"ctrl.parent.edit_schedule_track.aircraft_type\" placeholder=\"Aircraft Type\"></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Flight Number</span><br><md-input-container \nmd-no-float class=\"input_text\"><input class=\"panel-select md-input-focused\" id=\"flightNumber\" name=\"flightNumber\" \nng-model=\"ctrl.parent.edit_schedule_track.flight_number\" placeholder=\"Flight Number\"></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\">\n<span>Origin Departure</span><br><md-input-container md-no-float class=\"input_text mv-8\"><input \nclass=\"panel-select md-input-focused\" autocomplete=\"off\" \nng-class=\"{\'validation-error\':ctrl.parent.departureTimeValidation}\" name=\"origin-departure\" id=\"originDeparture\" \nclass=\"ml-0 pl-5\" ng-model=\"ctrl.parent.originDeparture\" name=\"originDeparture\" \nplaceholder=\"Origin Departure Date and Time\" start-view=\"month\" format=\"YYYY-MM-DD HH:mm\" \nmoment-picker=\"ctrl.parent.edit_schedule_track.departure_time\" max-date=\"ctrl.parent.edit_schedule_track.arrival_time\" \nng-click=\"ctrl.parent.departureTimeValidation=false;ctrl.parent.sameTimeValidation=false\"><div \nng-if=\"ctrl.parent.departureTimeValidation\"><div class=\"validation-error-text\">Enter Origin Departure</div></div>\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Destination Arrival\n</span><br><md-input-container md-no-float class=\"input_text mv-8\"><input class=\"panel-select md-input-focused\" \nautocomplete=\"off\" ng-class=\"{\'validation-error\':ctrl.parent.arrivalTimeValidation || ctrl.parent.sameTimeValidation}\" \nname=\"destination-arrival\" id=\"destinationArrival\" class=\"ml-0 pl-5\" ng-model=\"ctrl.parent.destinationArrival\" \nname=\"destinationArrival\" placeholder=\"Destination Departure Date and Time\" start-view=\"month\" \nformat=\"YYYY-MM-DD HH:mm\" moment-picker=\"ctrl.parent.edit_schedule_track.arrival_time\" \nmin-date=\"ctrl.parent.edit_schedule_track.departure_time\" \nng-click=\"ctrl.parent.arrivalTimeValidation=false;ctrl.parent.sameTimeValidation=false\"><div \nng-if=\"ctrl.parent.arrivalTimeValidation && !ctrl.parent.sameTimeValidation\"><div class=\"validation-error-text\">\nEnter Destination Arrival</div></div><div ng-if=\"!ctrl.parent.arrivalTimeValidation && ctrl.parent.sameTimeValidation\">\n<div class=\"validation-error-text lh-13\">Origin Departure and Destination Arrival time cannot be same</div></div>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" \nflex-xs=\"100\" class=\"feild-spacing\"><span>Transit Time</span><br><div flex layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container md-no-float class=\"input_text bb-grey mr-5 fd-reverse mv-8\" \nflex layout=\"row\" layout-align=\"space-between center\"><input \nclass=\"time-input panel-select md-input-focused ml-0 pl-5 w-100 h-30\" type=\"number\" \nng-model=\"ctrl.parent.edit_schedule_track.air_transit_time.hh\" name=\"hours\" min=\"1\" placeholder=\"00\"> <span \nclass=\"grey-fg\">hrs</span></md-input-container><md-input-container md-no-float \nclass=\"input_text bb-grey fd-reverse mv-8\" flex layout=\"row\" layout-align=\"space-between center\"><input \nclass=\"time-input panel-select ml-0 pl-5 w-100 h-30 text-center\" type=\"number\" \nng-model=\"ctrl.parent.edit_schedule_track.air_transit_time.mm\" name=\"minutes\" min=\"1\" max=\"59\" placeholder=\"00\"> <span \nclass=\"grey-fg\">mins</span></md-input-container></div></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><span>Days of Service</span><br><md-input-container md-no-float \nclass=\"input_text h-40 p-0 search_select_box mv-8\"><md-select class=\"panel-select selectLiner\" name=\"service_days\" \nng-model=\"ctrl.parent.edit_schedule_track.service_days\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Days of Service\" multiple=\"multiple\"><md-option ng-value=\"day\" \nng-repeat=\"day in ctrl.parent.daysOfService track by $index\">{{day}}</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\" layout-wrap flex=\"100\" class=\"row-spacing\"><div layout=\"column\" layout-wrap \nclass=\"w-auto-mob p-0 mb-20\"><div class=\"label-text pt-5\">Non Stop</div><div class=\"pt-6\"><div layout=\"row\" flex=\"100\" \nclass=\"non-stop w-120\"><md-button md-no-ink class=\"font-size-12 font-weight-800 br-4 m-0\" \nng-click=\"ctrl.parent.fnClickNonStop(true);\" ng-class=\"{\'active_nonStop\' : ctrl.parent.edit_schedule_track.non_stop }\">\nYes</md-button><md-button md-no-ink class=\"font-size-12 font-weight-800 br-4 m-0\" \nng-click=\"ctrl.parent.fnClickNonStop(false)\" \nng-class=\"{\'active_nonStop\' : !ctrl.parent.edit_schedule_track.non_stop };\">No</md-button></div></div></div><div \nlayout=\"column\" flex=\"100\" class=\"mt-20\" ng-class=\"{\'mt-0\':ctrl.parent.util.isXSScreen}\" \nng-if=\"!ctrl.parent.edit_schedule_track.non_stop\" \nng-repeat=\"port in ctrl.parent.edit_schedule_track.schedule_track track by $index\"><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\" flex-order-xs=\"2\"><span>\nvia Airport Name</span><br><md-input-container md-no-float class=\"input_text mv-8\"><md-autocomplete \nclass=\"panel-select\" ng-click=\"ctrl.parent.portValidation=false\" md-input-name=\"via_port\" \nng-class=\"{\'validation-error\':ctrl.parent.portValidation && !port.portcode_portname}\" md-selected-item=\"port.viaPort\" \nmd-search-text=\"port.portcode_portname\" \nmd-items=\"item in ctrl.parent.getPort(port.portcode_portname, ctrl.parent.edit_schedule_track.mode)\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" \nplaceholder=\"via AirPort Name\" md-clear-button=\"false\" md-menu-class=\"autocomplete-custom-template\"><md-item-template>\n<span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{port.portcode_portname}}\" were found.</md-not-found></md-autocomplete><div \nng-if=\"ctrl.parent.portValidation && !port.portcode_portname\"><div class=\"validation-error-text\">Enter Valid Airport\n</div></div></md-input-container></div><div class=\"add-viaPort text-right mt-10\" flex=\"50\" flex-xs=\"100\" \nflex-order-xs=\"1\"><button class=\"button-border red-400-fg h-35 ph-15 white-bg red-border remove-btn\" type=\"button\" \ntitle=\"Remove\" ng-if=\"ctrl.parent.edit_schedule_track.schedule_track.length != 1\" \nng-click=\"ctrl.parent.removeViaPort($index);\">Remove</button></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Arrival Date and Time\n</span><br><md-input-container md-no-float class=\"input_text h-40 mv-8\"><input autocomplete=\"off\" \nclass=\"panel-select md-input-focused form-control dateTimePickerInput\" id=\"arrival_{{$index}}\" \nng-model=\"port.arrivalTime\" start-view=\"month\" placeholder=\"Arrival Date and Time\" format=\"YYYY-MM-DD HH:mm\" \nmoment-picker=\"port.arrival_time\" title=\"Arrival Date and Time\" max-date=\"port.departure_time\"></md-input-container>\n</div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Departure Date and Time</span><br>\n<md-input-container md-no-float class=\"input_text mv-8 h-40\"><input autocomplete=\"off\" \nclass=\"panel-select md-input-focused form-control dateTimePickerInput\" id=\"departure_{{$index}}\" \nng-model=\"port.departureTime\" start-view=\"month\" placeholder=\"Departure Date and Time\" format=\"YYYY-MM-DD HH:mm\" \nmoment-picker=\"port.departure_time\" title=\"Departure Date and Time\" min-date=\"port.arrival_time\"></md-input-container>\n</div></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" layout-align=\"end\" \nng-if=\"!ctrl.parent.edit_schedule_track.non_stop\"><div class=\"add-viaPort\"><div \nclass=\"text-right md-link-fg pointer pb-10\" ng-click=\"ctrl.parent.addViaPort();\">Add via Airport</div></div></div>\n</div></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog();\" title=\"Cancel edit\">Cancel</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/shipments/dialogs/cargowise-charge-mapping/cargowise-charge-mapping.html","<md-dialog id=\"charge-mapping\" class=\"popup-lg\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\">Charge Mapping</div><div layout=\"row\" layout-align=\"end end\" class=\"p-0\" flex-xs=\"10\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div>\n<md-dialog-content class=\"body\"><div layout=\"column\" flex=\"100\" class=\"stepper-head\" \nng-if=\"!(!ctrl.parent.showUnmappedCharge && ctrl.parent.isEmpty(ctrl.parent.mappedCharges) || (ctrl.parent.showUnmappedCharge && ctrl.parent.isEmpty(ctrl.parent.mappedCharges) && ctrl.parent.isEmpty(ctrl.parent.unmappedCharges)))\">\n<div layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"stepper-bar-container h-90\"><ul \nclass=\"stepper-bar justify-center\" layout=\"row\" flex=\"100\"><li class=\"active\" ng-click=\"ctrl.parent.fnPrevScreen(1)\">\nMapping Validation</li><li>Done</li></ul></div></div><div layout=\"row\" flex=\"100\" \nclass=\"stepper-bar-container mt-15 p-0\"><div layout=\"column\" flex=\"100\" ng-show=\"ctrl.parent.showScreen == 1\"><form \nname=\"ctrl.parent.chargeMappingForm\"><md-expansion-panel \nng-if=\"!ctrl.parent.isEmpty(ctrl.parent.chargeMappingObj.chargeMap)&& !ctrl.parent.isEmpty(ctrl.parent.mappedCharges)\">\n<md-expansion-panel-collapsed ng-click=\"$ctrl.panelMappedExpansion()\" class=\"bb pointer\" \nng-style=\"{\'display\': ctrl.parent.isMappedPanelOpened  ? \'none\' : \'flex\' }\">Mapped Charges <span class=\"ml-auto\">\nView Charges<md-icon md-font-icon=\"icon-chevron-down\"></md-icon></span></md-expansion-panel-collapsed>\n<md-expansion-panel-expanded \nng-style=\"{\'display\': !ctrl.parent.isMappedPanelOpened  ? \'none\' : \'block\' ,opacity: !ctrl.parent.isMappedPanelOpened  ? \'0\' : \'1\',\'max-height\' : !ctrl.parent.isMappedPanelOpened  ? \'48px\' : \'fit-content\' }\" \nng-class=\"{\'md-show\':ctrl.parent.isMappedPanelOpened }\"><md-expansion-panel-header class=\"pointer\" \nng-click=\"$ctrl.panelMappedExpansion(); $panel.collapse();\">Mapped Charges <span class=\"ml-auto\"><md-icon \nmd-font-icon=\"icon-chevron-up\"></md-icon></span></md-expansion-panel-header><md-expansion-panel-content \nclass=\"font-size-14 opacity bb\"><div layout=\"row\" layout-align=\"start center\" class=\"pb-15\"><div flex=\"45\" \nclass=\"min-width-100 font-bold\">Freightify Charge Code</div><div style=\"visibility: hidden\"><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"mh-10 pointer\"></md-icon></div><div flex=\"45\" \nclass=\"min-width-100 font-bold ml-15\">TMS Charge Code</div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pb-15\" ng-repeat=\"(charge_key, charge_value) in ctrl.parent.mappedCharges track by $index\"><div flex=\"45\" \nclass=\"min-width-100\"><div class=\"charge_name_div\">{{charge_value.platform.chargeName}}<md-tooltip \nng-if=\"charge_value.platform.chargeName\" md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display:table;opacity: 1\">{{charge_value.platform.chargeName}}</md-tooltip></div></div><div><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"mh-10 pointer\"></md-icon></div><div flex=\"45\" class=\"mt-3 ml-15 min-width-100\">\n<md-input-container md-no-float class=\"inline-flex width-100-per m-0\" title=\"{{charge_value.partner.chargeName}}\" \nid=\"{{charge_key + \'_partnerCharge\'}}\" ng-keyup=\"ctrl.parent.removeValidation(charge_key,\'_partnerCharge\')\" \nng-class=\"{\'error-border-auto\' : ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\']}\" \nng-mouseleave=\"focusedCharge=false\" ng-mouseenter=\"focusedCharge=true\"><md-autocomplete \nclass=\"width-100-per min-width-100\" md-selected-item=\"selectedCharge\" md-input-name=\"{{charge_key}}\" \nmd-search-text=\"charge_value.partner.chargeName\" \nmd-selected-item-change=\" ctrl.parent.fnChargeSelection(selectedCharge,charge_key)\" \nmd-items=\"item in  ctrl.parent.getChargeList(charge_value.partner.chargeName)\" md-item-text=\"item.chargeName\" \nmd-min-length=\"3\" md-no-cache=\"false\" md-require-match=\"true\" md-delay=\"300\" md-clear-button=\"focusedCharge\" \nplaceholder=\"Enter Charge name\"><md-item-template><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\n{{item.chargeName}}</md-tooltip><span class=\"text-dropdown\" md-highlight-text=\"charge_value.partner.chargeName\" \nflex=\"80\" md-highlight-flags=\"^i\" title=\"{{item.chargeName}}\">{{item.chargeName}} </span><span class=\"code-color\" \nlayout-align=\"center center\" flex=\"20\" ng-if=\"item.chargeId && item.chargeId !== null\" ng-bind=\"item.chargeId\"></span>\n</div></md-item-template><md-not-found><div>No matches found.</div></md-not-found></md-autocomplete><div \nclass=\"charge_code\" \nng-if=\"charge_value.partner.chargeId && charge_value.partner.chargeId !== null && !focusedCharge && !ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\'] && !ctrl.parent.chargeMappingForm[charge_key].$error[\'required\']\" \nng-bind=\"charge_value.partner.chargeId\"></div></md-input-container></div></div></md-expansion-panel-content>\n</md-expansion-panel-expanded></md-expansion-panel><md-expansion-panel \nng-if=\"!ctrl.parent.isEmpty(ctrl.parent.chargeMappingObj.chargeMap)\"><md-expansion-panel-collapsed class=\"pointer\" \nng-style=\"{\'display\': ctrl.parent.isPanelOpened  ? \'none\' : \'flex\' }\" ng-click=\"ctrl.parent.panelExpansion()\">\nUnmapped Charges<div class=\"ml-auto\" layout=\"row\" layout-align=\"start center\"><span>View Charges<md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon></span></div></md-expansion-panel-collapsed><md-expansion-panel-expanded \nng-style=\"{\'display\': !ctrl.parent.isPanelOpened  ? \'none\' : \'block\' ,opacity: !ctrl.parent.isPanelOpened  ? \'0\' : \'1\',\'max-height\' : !ctrl.parent.isPanelOpened  ? \'48px\' : \'fit-content\'}\" \nng-class=\"{\'md-show\':ctrl.parent.isPanelOpened }\"><md-expansion-panel-header class=\"pointer\" \nng-click=\"ctrl.parent.panelExpansion(); $panel.collapse();\">Unmappded Charges<div class=\"ml-auto\" layout=\"row\" \nlayout-align=\"start center\"><div flex layout-wrap class=\"mt-10\" layout=\"row\" ng-if=\"ctrl.parent.showUnmappedCharge\">\n<div layout=\"column\" class=\"line-height-23 mr-5\">Sync without Unmapped Charges <span layout-wrap \nclass=\"font-size-8 line-height-6\"><md-icon id=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" \nclass=\"mr-5 fg-icon-red\"></md-icon>The Unmapped charges will not be transferred to TMS</span></div><md-checkbox \nmd-no-ink ng-model=\"ctrl.parent.chargeMappingObj.isUnmapped\" ng-true-value=\"true\" ng-false-value=\"false\" \nclass=\"ml-5 mb-0 h-30\" ng-click=\"ctrl.parent.checkUnmapped($event)\"></md-checkbox></div><span><md-icon \nmd-font-icon=\"icon-chevron-up\"></md-icon></span></div></md-expansion-panel-header><md-expansion-panel-content \nclass=\"font-size-14 opacity\"><div layout=\"row\" layout-align=\"start center\" class=\"pb-15\" \nng-if=\"ctrl.parent.unmapped.length\"><div flex=\"45\" class=\"min-width-100 font-bold\">Freightify Charge Code</div><div \nstyle=\"visibility: hidden\"><md-icon md-font-icon=\"icon-arrow-right\" class=\"mh-10 pointer\"></md-icon></div><div \nflex=\"45\" class=\"min-width-100 font-bold ml-15\">TMS Charge Code</div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pb-15\" \nng-repeat=\"(charge_key, charge_value) in ctrl.parent.unmappedCharges track by $index\" \nng-if=\"ctrl.parent.unmapped.length\"><div flex=\"45\" class=\"min-width-100\"><div class=\"charge_name_div\">\n{{charge_value.platform.chargeName}}<md-tooltip ng-if=\"charge_value.platform.chargeName\" md-direction=\"top\" \nclass=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\n{{charge_value.platform.chargeName}}</md-tooltip></div></div><div><md-icon md-font-icon=\"icon-arrow-right\" \nclass=\"mh-10 pointer\"></md-icon></div><div flex=\"45\" class=\"mt-3 ml-15 min-width-100\"><md-input-container md-no-float \nclass=\"inline-flex width-100-per m-0\" title=\"{{charge_value.partner.chargeName}}\" \nid=\"{{charge_key + \'_partnerCharge\'}}\" ng-keyup=\"ctrl.parent.removeValidation(charge_key,\'_partnerCharge\')\" \nng-class=\"{\'error-border-auto\' : ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\']}\" \nng-mouseleave=\"focusedCharge=false\" ng-mouseenter=\"focusedCharge=true\"><md-autocomplete \nclass=\"width-100-per min-width-100\" md-selected-item=\"selectedCharge\" md-input-name=\"{{charge_key}}\" \nmd-search-text=\"charge_value.partner.chargeName\" \nmd-selected-item-change=\" ctrl.parent.fnChargeSelection(selectedCharge,charge_key)\" \nmd-items=\"item in  ctrl.parent.getChargeList(charge_value.partner.chargeName)\" md-item-text=\"item.chargeName\" \nmd-min-length=\"3\" md-no-cache=\"false\" md-require-match=\"true\" md-delay=\"300\" md-clear-button=\"focusedCharge\" \nplaceholder=\"Enter Charge Name\"><md-item-template><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-tooltip \nmd-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" style=\"display:table;opacity: 1\">\n{{item.chargeName}}</md-tooltip><span class=\"text-dropdown\" md-highlight-text=\"charge_value.partner.chargeName\" \nflex=\"80\" md-highlight-flags=\"^i\" title=\"{{item.chargeName}}\">{{item.chargeName}} </span><span class=\"code-color\" \nlayout-align=\"center center\" flex=\"20\" ng-if=\"item.chargeId && item.chargeId !== null\" ng-bind=\"item.chargeId\"></span>\n</div></md-item-template><md-not-found><div>No matches found.</div></md-not-found></md-autocomplete><div \nclass=\"charge_code\" \nng-if=\"charge_value.partner.chargeId && charge_value.partner.chargeId !== null && !focusedCharge && !ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\'] && !ctrl.parent.chargeMappingForm[charge_key].$error[\'required\']\" \nng-bind=\"charge_value.partner.chargeId\"></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pb-15 empty-state\" ng-if=\"!ctrl.parent.unmapped.length\"><span layout-wrap \nclass=\"font-size-16 text-center\"><md-icon id=\"info-icon\" md-font-icon=\"s18 icon-information-outline\" \nclass=\"mr-5 fg-icon-alert\"></md-icon>All charges have been mapped - Validate the charge and click \'Submit\' to proceed\n</span></div></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><div layout=\"row\" \nlayout-align=\"start center\" class=\"pb-15 empty-state\" ng-if=\"!ctrl.parent.chargeMappingObj.chargeMap\">\nNo charge mapping found.</div></form><div class=\"empty-state text-center pv-50\" \nng-if=\"!ctrl.parent.showUnmappedCharge && ctrl.parent.isEmpty(ctrl.parent.mappedCharges) || (ctrl.parent.showUnmappedCharge && ctrl.parent.isEmpty(ctrl.parent.mappedCharges) && ctrl.parent.isEmpty(ctrl.parent.unmappedCharges))\">\nPlease note that the booking you are going to send does not contain charges information!</div></div><div class=\"h-200\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" ng-show=\"ctrl.parent.showScreen == 2\"><div class=\"w-200\" \nng-if=\"!ctrl.parent.chargeMappingErr.status\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-20\">\nLoading...</div></div><div layout=\"row\" flex=\"100\" class=\"w-50 h-50\" ng-if=\"ctrl.parent.chargeMappingErr.status\">\n<md-icon ng-if=\"ctrl.parent.chargeMappingErr.status==\'COMPLETED\'\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"w-50 h-50 tick_success\"></md-icon><md-icon md-font-icon=\"icon-close-circle\" \nng-if=\"ctrl.parent.chargeMappingErr.status==\'FAILED\'\" class=\"w-50 h-50 tick_error\"></md-icon></div><div \nclass=\"pb-15 font-size-16\" ng-if=\"ctrl.parent.chargeMappingErr.status==\'FAILED\'\">\n{{ctrl.parent.chargeMappingErr.message}}</div><div class=\"pb-15 text-center\" \nng-if=\"ctrl.parent.chargeMappingErr.status==\'COMPLETED\'\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-20 font-bold pb-5\">Successfully sent</div><div class=\"font-size-14 fg-4B5563\">\nYour shipment has been successfully sent to Cargo Wise.</div><div class=\"font-size-14 fg-4B5563\">\nYour shipment ID can be found in the update section of the booking summary</div></div></div></div></md-dialog-content>\n<md-dialog-actions class=\"footer\" layout=\"row\"><div class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\" \nng-disabled=\"!ctrl.parent.chargeMappingErr.status && ctrl.parent.showScreen == 2\">Close</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\" \nng-click=\"ctrl.parent.validateChargeMapping(ctrl.parent.chargeMappingForm)\" ng-if=\"ctrl.parent.showScreen == 1\">Submit\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/carrier-booking/carrier-booking.html","<md-dialog class=\"popup-lg\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div flex=\"90\" flex-xs=\"90\" \nclass=\"p-0\">Charges Details</div><div layout=\"row\" layout-align=\"end end\" flex=\"30\" flex-xs=\"30\" \nclass=\"icon_size fg-AAA8AD p-0\"><md-icon md-font-icon=\"icon-close fg-AAA8AD m-0 cursor\" \nng-click=\"ctrl.parent.cancelDialog(\'SD-CB-CD-CloseIcon\')\"></md-icon></div></div><md-dialog-content class=\"body\"><div \nshimmer-effect width=\"100%\" height=\"100%\" class=\"white-bg\" \nng-if=\"ctrl.parent.showData || ctrl.parent.callingConversionApi\"></div><div ng-if=\"!ctrl.parent.showData\"><div \nlayout-align=\"start center\">Current Rate</div><rate-display class=\"p-10\" \ncurrent-card=\"ctrl.parent.carrierBookingData.original_rate\" mode=\"ctrl.parent.shipment_meta.mode\" \nrate-type=\"\'current\'\" load-data=\"ctrl.parent.shipment_meta.load_data\" search-param=\"ctrl.parent.shipment_meta\">\n</rate-display><div class=\"min-height-500\"><div layout-align=\"start center\" \nng-if=\"ctrl.parent.carrierBookingData.new_rates.length\">New Rate</div><rate-display class=\"p-10\" \nng-repeat=\"card in ctrl.parent.carrierBookingData.new_rates\" current-card=\"card\" \ncallback=\"ctrl.parent.fnCardSelection(selectedCard)\" mode=\"ctrl.parent.shipment_meta.mode\" rate-type=\"\'new\'\" \nload-data=\"ctrl.parent.shipment_meta.load_data\" search-param=\"ctrl.parent.shipment_meta\"></rate-display></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><div layout-align=\"end center\" class=\"mv-10\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog(\'SD-CB-CD-Cancel\')\" title=\"Cancel\">Cancel</md-button>\n<md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Confirm\" \nng-disabled=\"ctrl.parent.bookingBtnDisabled\" ng-click=\"ctrl.parent.fncarrierBooking()\">Book Now</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/change-status/change-status.html","<md-dialog id=\"change-status\" class=\"popup-sm\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\" flex=\"90\">{{ctrl.parent.statusDataCopy.status}}</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\" \nflex-xs=\"10\"><md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-Close-Click\')\"></md-icon></div></div>\n<md-dialog-content class=\"body\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><label class=\"flex-25\">\nDate & Time</label><md-input-container md-no-float class=\"input_box flex-75\"><input \nclass=\"panel-select md-input-focused\" autocomplete=\"off\" id=\"milestoneDate\" \nng-click=\"ctrl.parent.milestoneValidation=false;ctrl.parent.util.callMixpanel(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-Date&Time-Change\')\" \nclass=\"ml-0 pl-5\" ng-class=\"{\'validation-error\':ctrl.parent.milestoneValidation}\" \nng-model=\"ctrl.parent.milestone_date\" name=\"milestoneDate\" placeholder=\"Enter Date & Time\" start-view=\"month\" \nformat=\"YYYY-MM-DD HH:mm\" moment-picker=\"ctrl.parent.statusDataCopy.milestone_date\" min-date=\"ctrl.parent.min_date\">\n<div ng-if=\"ctrl.parent.milestoneValidation\" class=\"validation-error-text\"><span>\nEnter the Date and Time of the Milestone</span></div></md-input-container></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"start center\" class=\"row-spacing\"><label class=\"flex-25\">Comment</label><md-input-container md-no-float \nclass=\"input_box flex-75\"><input class=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.statusDataCopy.comment\" \nname=\"comment\" placeholder=\"Comment (optional)\" \nng-change=\"ctrl.parent.util.callMixpanel(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-Comment-Change\',ctrl.parent.statusDataCopy.comment)\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div class=\"pr-20\"><div layout=\"row\" flex=\"100\" class=\"row-spacing\"><div flex class=\"pt-6\">\nSend Email Notification</div><div layout=\"row\" layout-align=\"left center\" flex=\"33\"><div class=\"pr-20\">No</div>\n<md-switch md-no-ink ng-model=\"ctrl.parent.statusDataCopy.send_email\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"Switch 1\" class=\"m-0 p-0\" \nng-change=\"ctrl.parent.statusDataCopy.send_email ? ctrl.parent.util.callMixpanel(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-SendEmailNotification-Yes-Click\'):ctrl.parent.util.callMixpanel(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-SendEmailNotification-No-Click\') \" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-switch><div class=\"pl-20\">Yes</div></div></div><div layout=\"row\" flex=\"100\" class=\"row-spacing\"><div flex \nclass=\"pt-6\">Send comment in Notification</div><div layout=\"row\" layout-align=\"left center\" flex=\"33\"><div \nclass=\"pr-20\">No</div><md-switch md-no-ink ng-model=\"ctrl.parent.statusDataCopy.send_comment\" ng-true-value=\"1\" \nng-false-value=\"0\" aria-label=\"Switch 2\" class=\"m-0 p-0\" \nng-change=\"ctrl.parent.statusDataCopy.send_comment ? ctrl.parent.util.callMixpanel(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-SendCommentInNotification-Yes-Click\'):ctrl.parent.util.callMixpanel(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-SendCommentInNotification-No-Click\') \" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-switch><div class=\"pl-20\">Yes</div></div></div></div></md-dialog-content><md-dialog-actions class=\"footer\" \nlayout=\"row\"><div class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-Cancel-Click\')\" title=\"Cancel edit\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\" \nng-click=\"ctrl.parent.fnSubmitStatus(ctrl.parent.statusDataCopy);ctrl.parent.util.callMixpanel(\'SD-\'+ctrl.parent.statusDataCopy.status+\'-Save-Click\',ctrl.parent.statusDataCopy)\">\nSave</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/charge-mapping/charge-mapping.html","<md-dialog id=\"charge-mapping\" class=\"popup-lg\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nclass=\"p-0\">Charge Mapping</div><div layout=\"row\" layout-align=\"end end\" class=\"p-0\" flex-xs=\"10\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog($event)\"></md-icon></div></div>\n<md-dialog-content class=\"body\"><div layout=\"column\" flex=\"100\" class=\"stepper-head\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"stepper-bar-container h-90\"><ul class=\"stepper-bar\" layout=\"row\" flex=\"100\"><li \nclass=\"active\" ng-click=\"ctrl.parent.fnPrevScreen(1)\">Mapping Validation</li><li \nng-click=\"ctrl.parent.fnPrevScreen(2)\">Nominated Booking Confirmation</li><li>Done</li></ul></div></div><div \nlayout=\"row\" flex=\"100\" class=\"stepper-bar-container mt-15 pt-20 pl-15\"><div layout=\"column\" flex=\"100\" \nng-show=\"ctrl.parent.showScreen == 1\"><form name=\"ctrl.parent.chargeMappingForm\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"pb-15\" \nng-repeat=\"(charge_key, charge_value) in ctrl.parent.chargeMappingObj.chargeMap track by $index\"><div flex=\"15\" \nclass=\"min-width-100\"><div class=\"charge_name_div\">{{charge_value.platform.chargeName}}<md-tooltip \nng-if=\"charge_value.platform.chargeName\" md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display: table; opacity: 1\">{{charge_value.platform.chargeName}}</md-tooltip></div></div><div><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"mh-10 pointer\"></md-icon></div><div flex=\"25\" class=\"mt-3 ml-15 min-width-100\">\n<md-input-container md-no-float class=\"inline-flex width-100-per m-0\" title=\"{{charge_value.partner.chargeName}}\" \nid=\"{{charge_key + \'_partnerCharge\'}}\" ng-keyup=\"ctrl.parent.removeValidation(charge_key)\" \nng-class=\"{\'error-border-auto\' : ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\']}\" \nng-mouseleave=\"focusedCharge=false\" ng-mouseenter=\"focusedCharge=true\"><md-autocomplete \nclass=\"width-100-per min-width-100\" md-selected-item=\"selectedCharge\" md-input-name=\"{{charge_key}}\" \nmd-search-text=\"charge_value.partner.chargeName\" \nmd-selected-item-change=\" ctrl.parent.fnChargeSelection(selectedCharge,charge_key)\" \nmd-items=\"item in  ctrl.parent.getChargeList(charge_value.partner.chargeName)\" md-item-text=\"item.chargeName\" \nmd-min-length=\"3\" md-no-cache=\"false\" md-require-match=\"true\" md-delay=\"300\" md-clear-button=\"focusedCharge\" \nplaceholder=\"Enter Charge name\" ng-required=\"true\"><md-item-template><md-tooltip md-direction=\"top\">{{item.chargeName}}\n</md-tooltip><span md-highlight-text=\"charge_value.partner.chargeName\" md-highlight-flags=\"^i\">{{item.chargeName}}\n</span></md-item-template><md-not-found><div>No matches found.</div></md-not-found></md-autocomplete><div \nclass=\"charge_code\" \nng-if=\"charge_value.partner.chargeId && charge_value.partner.chargeId !== null && !focusedCharge && !ctrl.parent.chargeMappingForm[charge_key].$error[\'md-require-match\'] && !ctrl.parent.chargeMappingForm[charge_key].$error[\'required\']\" \nng-bind=\"charge_value.partner.chargeId\"></div></md-input-container></div><div flex=\"20\" \nclass=\"mt-3 ml-15 min-width-100\"><md-input-container md-no-float class=\"input_container inline-flex width-100-per m-0\" \ntitle=\"{{charge_value.agent.agent_name}}\" id=\"{{charge_key + \'_agent\'}}\" \nng-keyup=\"ctrl.parent.removeValidation(charge_key,\'agent\')\" \nng-class=\"{\'error-border-auto\' : (ctrl.parent.chargeMappingForm[charge_key+\'_agent\'].$error[\'md-require-match\'] || ctrl.parent.chargeMappingForm[charge_key+\'_agent\'].$error[\'required\'])}\" \nng-mouseleave=\"focusedAgent=false\" ng-mouseenter=\"focusedAgent=true\"><md-autocomplete \nclass=\"width-100-per min-width-100\" md-selected-item=\"selectedAgent\" md-input-name=\"{{charge_key}}_agent\" \nmd-search-text=\"charge_value.agent.agent_name\" \nmd-selected-item-change=\" ctrl.parent.fnAgentSelection(selectedAgent,charge_key)\" \nmd-items=\"item in  ctrl.parent.getAgentList(charge_value.agent.agent_name)\" md-item-text=\"item.agent_name\" \nmd-min-length=\"3\" md-no-cache=\"false\" md-require-match=\"true\" md-delay=\"300\" md-clear-button=\"focusedAgent\" \nplaceholder=\"Select Service Provider\" ng-required=\"true\"><md-item-template><md-tooltip md-direction=\"top\">\n{{item.agent_name}}</md-tooltip><span md-highlight-text=\"charge_value.agent.agent_name\" md-highlight-flags=\"^i\">\n{{item.agent_name}}</span></md-item-template><md-not-found><div>No matches found.</div></md-not-found>\n</md-autocomplete></md-input-container></div><div flex=\"15\" class=\"ml-15 min-width-100\"><div \nclass=\"charge_name_div width-100-per\" ng-class=\"{\'grey-fg text-italic\':!charge_value.agent.reference_id}\" \nid=\"{{charge_key + \'_agent_code\'}}\">\n{{charge_value.agent.reference_id ? charge_value.agent.reference_id : \'Service Provider Code\'}}<md-tooltip \nng-if=\"charge_value.agent.reference_id\" md-direction=\"top\" class=\"white-fg bg-343434 font-size-12 text-left p-10\" \nstyle=\"display: table; opacity: 1\">{{charge_value.agent.reference_id}}</md-tooltip></div></div><div flex=\"20\" \nclass=\"mt-3 ml-15 pr-15 min-width-100\"><md-input-container class=\"input_container inline-flex width-100-per m-0\" \nmd-no-float title=\"{{charge_value.serviceLeg}}\"><md-select id=\"{{charge_key + \'_leg_name\'}}\" \nng-change=\"ctrl.parent.fnLegSelect(charge_key,charge_value)\" \nng-class=\"{\'panel-select-disabled\': (!(charge_value.agent && charge_value.agent.reference_id))}\" \nng-disabled=\"!(charge_value.agent && charge_value.agent.reference_id)\" name=\"leg_name\" \nclass=\"panel-select agent-select\" ng-model=\"charge_value.serviceLeg\" placeholder=\"Leg Name\"><md-option \nng-repeat=\"(legKey , legValue) in ctrl.parent.chargeMappingObj.serviceLegsMap\" ng-value=\"legKey\">{{legKey}}</md-option>\n</md-select></md-input-container></div></div></form></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"quoteDetails\" flex=\"100\" ng-show=\"ctrl.parent.showScreen == 2\"><form name=\"sendShipmentForm\"><div layout=\"row\">\n<div class=\"font-bold w-120\">Payment Type<span class=\"red-600-fg\">*</span></div><md-input-container \nclass=\"input_container inline-flex width-100-per m-0\" md-no-float><md-select name=\"paymentMethod\" \nclass=\"panel-select agent-select\" ng-model=\"ctrl.parent.chargeMappingObj.paymentMethod\" \nplaceholder=\"Select Payment Type\" required><md-option \nng-repeat=\"paymentMethod in ctrl.parent.chargeMappingObj.paymentMethodMap\" ng-value=\"paymentMethod.value\">\n{{paymentMethod.label}}</md-option></md-select></md-input-container></div><div><div class=\"font-bold\">Select</div>\n<md-radio-group ng-model=\"ctrl.parent.chargeMappingObj.is_nominated\" layout=\"row\" flex=\"100\" layout-wrap \nng-change=\"ctrl.parent.fnNominatedChange()\"><md-radio-button md-no-ink ng-value=\"true\" class=\"md-accent\">Nominated\n</md-radio-button><md-radio-button md-no-ink ng-value=\"false\" class=\"md-accent\">Non-Nominated</md-radio-button>\n</md-radio-group></div><div class=\"mt-15 material-outline\"><div class=\"font-bold\">Inter Booking ID</div>\n<md-input-container md-no-float class=\"input_box mt-0\"><input name=\"nominated_id\" \nng-disabled=\"!ctrl.parent.chargeMappingObj.is_nominated\" placeholder=\"Inter Booking ID\" class=\"mb-3 panel-select\" \nng-class=\"{\'validation-error\':ctrl.parent.isNominatedIdEmpty}\" ng-required=\"ctrl.parent.chargeMappingObj.is_nominated\" \nng-model=\"ctrl.parent.chargeMappingObj.nominated_id\" ng-keyup=\"ctrl.parent.isNominatedIdEmpty=false\"><div \nng-if=\"ctrl.parent.isNominatedIdEmpty\" class=\"validation-error-text\"><span>Inter Booking ID is required.</span></div>\n</md-input-container></div></form></div><div class=\"h-200\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nng-show=\"ctrl.parent.showScreen == 3\"><div class=\"w-200\" ng-if=\"!ctrl.parent.chargeMappingErr.status\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-20\">Loading...</div></div><div layout=\"row\" flex=\"100\" \nclass=\"w-50 h-50\" ng-if=\"ctrl.parent.chargeMappingErr.status\"><md-icon \nng-if=\"ctrl.parent.chargeMappingErr.status==\'COMPLETED\'\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"w-50 h-50 tick_success\"></md-icon><md-icon md-font-icon=\"icon-close-circle\" \nng-if=\"ctrl.parent.chargeMappingErr.status==\'FAILED\'\" class=\"w-50 h-50 tick_error\"></md-icon></div><div \nclass=\"pb-15 font-size-16\" ng-if=\"ctrl.parent.chargeMappingErr.status==\'FAILED\'\">\n{{ctrl.parent.chargeMappingErr.message}}</div><div class=\"pb-15 text-center\" \nng-if=\"ctrl.parent.chargeMappingErr.status==\'COMPLETED\'\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-20 font-bold pb-5\">Successfully sent</div><div class=\"font-size-14 fg-4B5563\">\nYour shipment has been successfully sent to OTM.</div><div class=\"font-size-14 fg-4B5563\">\nYour transaction ID can be found in the update section of the booking summary</div></div></div></div>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><div class=\"mv-10\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog($event)\" title=\"Cancel edit\" \nng-disabled=\"!ctrl.parent.chargeMappingErr.status && ctrl.parent.showScreen == 3\">Close</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\" \nng-click=\"ctrl.parent.validateChargeMapping(ctrl.parent.chargeMappingForm)\" ng-if=\"ctrl.parent.showScreen == 1\">Next\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\" \nng-click=\"ctrl.parent.fnSubmitCharges(ctrl.parent.chargeMappingForm)\" ng-if=\"ctrl.parent.showScreen == 2\">Submit\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/comment/comment.html","<md-dialog id=\"comment-dialog\" class=\"popup-sm\"><md-toolbar class=\"modal_title\"><div class=\"md-toolbar-tools\"><span>\nComment</span> <span flex></span><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\">\n<md-icon md-font-icon=\"icon-close\" class=\"fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon>\n</md-button></div></md-toolbar><form name=\"comment_form\"><md-dialog-content class=\"body\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"pt-5 pb-5\"><md-input-container ng-if=\"ctrl.parent.permission[2]\" md-no-float \nclass=\"height-container inputwidth\"><textarea name=\"share\" placeholder=\"Add comments\" \nng-change=\"ctrl.parent.newComment()\" ng-model=\"ctrl.parent.comment\" value=\"ctrl.parent.comment\" \nclass=\"border text-container\" ng-class=\"{\'validation-error\':ctrl.parent.commentValidation}\" \nng-keyup=\"ctrl.parent.commentValidation=false;\" rows=\"3\" max-rows=\"6\"></textarea><div \nng-if=\"ctrl.parent.commentValidation\" class=\"validation-error-text\">Enter your comment</div></md-input-container><div \nclass=\"p-15 big-comment\" ng-if=\"!ctrl.parent.permission[2]\">{{ctrl.parent.comment}}</div></div></md-dialog-content>\n</form><md-dialog-actions layout=\"row\"><div class=\"m-10\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" \nng-click=\"ctrl.parent.closeComment(ctrl.parent.commentData._id, ctrl.parent.commentData.index)\" type=\"submit\" \ntitle=\"Save\">Done</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/commodity-edit/commodity-edit.html","<md-dialog id=\"commodity-edit\" class=\"popup-sm\"><form name=\"commodityForm\" ng-submit=\"ctrl.parent.saveCommodity()\"><div\n layout=\"row\" layout-padding class=\"header m-0\" flex=\"100\"><div class=\"p-0\" flex=\"90\" flex-xs=\"90\">\n{{ctrl.parent.commodityModalTitle}} Commodity Details</div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" \nflex=\"10\" flex-xs=\"10\"><md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog();\">\n</md-icon></div></div><md-dialog-content class=\"body\"><div layout=\"column\" flex=\"100\"><div class=\"mb-6-imp\">Cargo Type\n</div><div flex=\"100\"><cargo-type-selection id=\"shipment_cargo\" cargo-type-data=\"ctrl.parent.editCommodity.cargo_type\" \nis-valid=\"ctrl.parent.cargoValidation\" full-border=\"true\" hazardous-value=\"ctrl.parent.editCommodity.hazardous\" \nis-disabled=\"ctrl.parent.isCargoTypeDisabled\" category=\"\'comd\'\" mode=\"ctrl.parent.shipment_meta.mode\" \nng-keyup=\"ctrl.parent.cargoValidationError = false;\" callback=\"ctrl.parent.fnCargoChange(value)\">\n</cargo-type-selection></div><div ng-if=\"ctrl.parent.cargoValidation\" class=\"validation-error-text\"><span>\nSelect the Cargo Type</span></div></div><div layout=\"column\" flex=\"100\" class=\"row-spacing\"><div class=\"mb-6-imp\">\nCommodity</div><div flex=\"100\"><md-input-container md-no-float class=\"w-100p mv-0 commodity_input\"><commodity-chips \nis-valid=\"ctrl.parent.commodityValidation\" md-input-id=\"\'commodity_id_web\'\" category=\"\'comd\'\" \ncommodity-array=\"ctrl.parent.editCommodity.commodity_data\"></commodity-chips></md-input-container><div \nng-if=\"ctrl.parent.commodityValidation\" class=\"validation-error-text\"><span>Enter the Commodity to proceed</span></div>\n</div></div><div layout=\"column\" flex=\"100\" class=\"row-spacing\"><div>HS Code</div><div flex=\"100\"><md-input-container \nmd-no-float class=\"input_box mv-0\"><input name=\"commodityForm.hs_code\" class=\"panel-select md-input-focused\" \nng-model=\"ctrl.parent.editCommodity.hs_code\" placeholder=\"Enter HS Code\"></md-input-container></div></div><div \nlayout=\"column\" flex=\"100\" class=\"row-spacing\"><div class=\"mb-6-imp\">Select IMCO Code</div><div flex-xs=\"100\">\n<md-input-container md-no-float class=\"w-100-imp input-box mv-0\"><md-select name=\"type\" \nng-model=\"ctrl.parent.selected_imco\" \nng-class=\"{\'panel-select-disabled\':!ctrl.parent.editCommodity.hazardous,\'imco-placeholder\':ctrl.parent.selected_imco==0,\'validation-error\':ctrl.parent.imcoValidation}\" \nng-change=\"ctrl.parent.trackEvent(\'\',\'\',\'\',\'SD-Commodity-IMCOCode\')\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nclass=\"code-box panel-select\" md-on-open=\"ctrl.parent.imcoValidation=false\" placeholder=\"Select IMCO Code\" \nng-disabled=\"!ctrl.parent.editCommodity.hazardous\"><md-option class=\"mb-10\" style=\"height:100%\" ng-value=\"0\">\nSelect IMCO code</md-option><md-option class=\"mb-10\" style=\"height:100%\" \nng-repeat=\"imcoCode in ctrl.parent.IMCO_CodeList track by $index\" ng-value=\"imcoCode.class_number\"><span \nclass=\"font-weight-600\">{{imcoCode.class_name}}</span><br><span class=\"gray-fg font-size-12\" \nng-repeat=\"list in imcoCode.list track by $index\">{{list}}<br></span></md-option></md-select></md-input-container><div \nng-if=\"ctrl.parent.imcoValidation\" class=\"validation-error-text\"><span>Select IMCO code</span></div></div></div>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><div class=\"mv-10\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog();ctrl.parent.trackEvent(\'\',\'\',\'\',\'SD-Comdmodity-Cancel\')\" title=\"Cancel\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Save\">Save</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/confirm-delete/confirm-delete.html","<md-dialog id=\"confirm-delete\" class=\"popup-xs\"><md-dialog-content class=\"body\" layout=\"column\"><span class=\"pv-10\">\n<span \nng-if=\"ctrl.parent.deleteType === \'Role\' || ctrl.parent.deleteType === \'User\' || ctrl.parent.deleteType === \'Team\'\">\nYou can\'t undo this. Delete the <span ng-if=\"ctrl.parent.deleteType === \'Role\'\">user</span>\n {{ctrl.parent.deleteType | lowercase}} <span ng-if=\"ctrl.parent.deleteType === \'User\'\">profile</span> anyway? </span>\n<span \nng-if=\"!(ctrl.parent.deleteType === \'Role\' || ctrl.parent.deleteType === \'User\' || ctrl.parent.deleteType === \'Team\' || ctrl.parent.deleteType === \'Template\' ||  ctrl.parent.deleteType === \'Invoice\' || ctrl.parent.deleteType ===\'Carrier-Booking\')\">\nDo you want to delete this {{ctrl.parent.deleteType | lowercase}} ?</span> <span \nng-if=\"ctrl.parent.deleteType === \'Invoice\'\">Do you want to delete this document ?</span> <span \nng-if=\"ctrl.parent.deleteType === \'Template\'\">Are you sure to delete the {{ctrl.parent.deleteContent}} ?</span> <span \nng-if=\"ctrl.parent.deleteType ===\'Carrier-Booking\'\">Are you sure you want to cancel this booking?</span></span><div \nng-if=\"(ctrl.parent.deleteType === \'Customer\' || ctrl.parent.deleteType === \'Consignee\' || ctrl.parent.deleteType === \'Consignor\') && ctrl.parent.noOfShipperUser > 0\" \nclass=\"note-text\">Note: All the users <span class=\"Font-Bold\">( {{ctrl.parent.noOfShipperUser}} )</span>\n under this company will also be deleted .</div><div ng-if=\"ctrl.parent.deleteType === \'Carrier-Booking\'\" \nclass=\"note-text\"><span ng-if=\"ctrl.parent.shipment_meta.mode === \'AIR\'\">\nNote: You might incur cancellation charges, please check the conditions with airline before proceeding. </span><span \nng-if=\"ctrl.parent.shipment_meta.mode != \'AIR\'\">\nNote: You might incur cancellation charges, please check the conditions with carrier before proceeding.</span></div>\n<div class=\"pt-10 note-text\" layout-align=\"start center\"></div><div layout=\"row\" class=\"row-spacing\" \nlayout-align=\"start center\" flex=\"80\" flex-xs=\"100\" layout-wrap \nng-if=\"ctrl.parent.showPermanentDiv && ctrl.parent.util.isFreightbro\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.permanentDelete\"></md-checkbox><span class=\"label\">Permanent Delete.</span></div>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\" layout-align=\"end center\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(ctrl.parent.deleteType === \'Role\' ?\'Role-Delete-Cancel-Click\':\'\' , \'DeleteCancel\')\" \ntitle=\"Cancel\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" \nng-click=\"ctrl.parent.fnDeleteData(ctrl.parent.deleteName )\" ng-disabled=\"ctrl.parent.deleteBtn\" \ntitle=\"{{ctrl.parent.deleteBtnText ? ctrl.parent.deleteBtnText : \'Yes, Delete\'}}\">\n{{ctrl.parent.deleteBtnText ? ctrl.parent.deleteBtnText : \'Yes, Delete\' }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/confirm-shipper-creation/confirm-shipper-creation.html","<md-dialog id=\"confirm-shipper-creation\" class=\"popup-xs\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\">\n<div flex=\"80\" flex-xs=\"90\" class=\"p-0\">{{ctrl.parent.data.title}}</div><div layout=\"row\" layout-align=\"end end\" \nflex=\"20\" flex-xs=\"10\" class=\"p-0\"><md-icon md-font-icon=\"icon-close\" class=\"pointer m-0 fg-AAA8AD\" \nng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div><md-dialog-content class=\"body\" layout=\"column\"><div \nng-if=\"ctrl.parent.data.content\" class=\"body-content\" ng-bind-html=\"ctrl.parent.data.content\"></div><div \nng-if=\"ctrl.parent.data.errorMessage\" class=\"body-content\"><ul><li \nng-repeat=\"message in ctrl.parent.data.errorMessage\">{{message}}</li></ul></div></md-dialog-content><md-dialog-actions \nclass=\"footer\" layout=\"row\" layout-align=\"end center\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog()\" ng-if=\"!ctrl.parent.data.addShipper\" title=\"Cancel\">No</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" ng-if=\"!ctrl.parent.data.addShipper\" \nng-click=\"ctrl.parent.fnCargowiseIntergration(ctrl.parent.data.newBooking,\'\', ctrl.parent.data.submenus ,ctrl.parent.data.new_org,ctrl.parent.data.partner,ctrl.parent.data.type,ctrl.parent.data.mapping);ctrl.parent.cancelDialog()\" \ntitle=\"yes\">Yes</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" ng-click=\"ctrl.parent.cancelDialog()\" \nng-if=\"ctrl.parent.data.addShipper\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/delete-confirmation/deleteConfirmation.html","<md-dialog id=\"shipment-delete\" class=\"popup-sm\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div>Delete {{ctrl.parent.deleteData.title}}</div><span flex></span><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog();\"><md-icon md-font-icon=\"icon-close\" class=\"fg-AAA8AD\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"m-0 body pb-0\"><div \nlayout=\"row\" layout-align=\"start center\" flex=\"100\" flex-xs=\"100\" layout-wrap><span class=\"content-popup\">\nDo you want to delete this <span class=\"font-weight-600\">{{ctrl.parent.deleteData.title}}</span>?</span></div><div \nlayout=\"row\" layout-align=\"start center\" flex=\"80\" flex-xs=\"100\" layout-wrap \nclass=\"font-size-15 mt-20 black-400-fg font-weight-400\"><span>{{ ctrl.parent.deleteData.source_title2 }} </span>: <span\n class=\"ph-10\" ng-if=\"ctrl.parent.associatesResponse.quote_ids.length\"><span class=\"md-link-fg pointer\" \nng-repeat=\"quote in ctrl.parent.associatesResponse.quote_ids track by $index\" \nng-click=\"ctrl.parent.fnLinkRedirection(quote._id, \'quote\');\">{{ quote.quote_id }} {{!$last ? \', \' : \'\'}} </span>\n</span><span class=\"ph-10 fg-6b6b6b\" ng-if=\"!ctrl.parent.associatesResponse.quote_ids.length\">Not available</span>\n</div><div layout=\"row\" layout-align=\"start center\" flex=\"80\" flex-xs=\"100\" layout-wrap \nclass=\"font-size-15 mb-20 mt-13 black-400-fg font-weight-400\"><span>{{ ctrl.parent.deleteData.source_title3 }} </span>\n: <span class=\"ph-10\" ng-if=\"ctrl.parent.associatesResponse.inquiry_ids.length\"><span class=\"md-link-fg pointer\" \nng-repeat=\"inquiry in ctrl.parent.associatesResponse.inquiry_ids track by $index\" \nng-click=\"ctrl.parent.fnLinkRedirection(inquiry._id, \'inquiry\');\">{{ inquiry.inquiry_id }} {{!$last ? \', \' : \'\'}}\n</span> </span><span class=\"ph-10 fg-6b6b6b\" ng-if=\"!ctrl.parent.associatesResponse.inquiry_ids.length\">Not available\n</span></div><div ng-if=\"ctrl.parent.deleteData.source_id3 != \'\' || ctrl.parent.deleteData.source_id2 != \'\'\"><div \nlayout=\"row\" layout-align=\"start center\" flex=\"80\" flex-xs=\"100\" layout-wrap class=\"mt-40 mb-0\"><span class=\"label\">\nQuick Action</span></div><div layout=\"row\" flex=\"100\" flex-xs=\"100\" layout-wrap><md-checkbox md-no-ink s16 \nng-model=\"ctrl.parent.deleteData.deleteSources\" \nng-disabled=\"ctrl.parent.deleteData.source_id1 == \'\' && ctrl.parent.deleteData.source_id2 == \'\'\"></md-checkbox><span \nclass=\"sub-label\">Yes,Delete related Enquiries & Quotes.</span></div><div layout=\"row\" flex=\"100\" flex-xs=\"100\" \nlayout-wrap ng-if=\"ctrl.parent.util.isFreightbro\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.deleteData.permanentDelete\"></md-checkbox><span class=\"pb-5 sub-label\">Delete Permanently.</span>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"footer\" layout-wrap>\n<div layout=\"row\" layout-align=\"end center\" class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"ctrl.parent.cancelDialog();\" title=\"Cancel\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn\" \ntype=\"submit\" ng-click=\"ctrl.parent.fnConfirmDeleteCard();\" title=\"Confirm\">Confirm</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/edit-address/edit-address.html","<md-dialog id=\"shipment-delete\" class=\"popup-md\"><md-toolbar class=\"modal_title white-bg black-fg\"><div \nclass=\"md-toolbar-tools\"><div>\n{{ctrl.parent.currentAddress ? \'Edit\' : \'Add\'}} {{ctrl.parent.currentAddressType == \'origin_address\' ? \'Pick Up\' : \'Delivery\'}}\n</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog();\"><md-icon \nmd-font-icon=\"icon-close\" class=\"fg-AAA8AD\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"m-0 body pb-0\"><door-address address-data=\"ctrl.parent.currentAddress\" \nlabel=\"{{ctrl.parent.currentAddressType == \'origin_address\' ? \'Pick Up\' : \'Delivery\'}}\"></door-address>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"footer mt-10\" layout-wrap><div \nlayout=\"row\" layout-align=\"end center\" class=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"ctrl.parent.cancelDialog();\" title=\"Cancel\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn\" \ntype=\"submit\" ng-click=\"ctrl.parent.fnSubmitDoorAdress();\" title=\"Submit\">Submit</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/shipments/dialogs/edit-management/edit-management.html","<md-dialog id=\"edit-management\" class=\"popup-sm\"><div layout=\"row\" class=\"header\" flex=\"100\"><div flex=\"90\">\nEdit Management Details</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\"><md-icon md-font-icon=\"icon-close\" \nclass=\"fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog(\'Close\')\"></md-icon></div></div><form name=\"managementFrm\">\n<md-dialog-content class=\"body\"><div layout=\"column\" flex=\"100\"><label>Shipment Specialist</label><md-input-container \nmd-no-float class=\"input_box mt-5\"><md-select class=\"panel-select\" name=\"type\" ng-model=\"ctrl.parent.ship_Expert\" \nng-model-options=\"{ trackBy: \'$value.id\'}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Select Shipment Specialist\" md-on-open=\"searchSpecialist=\'\'\" md-on-close=\"searchSpecialist=\'\'\">\n<md-select-header class=\"demo-select-header select-header\"><input ng-model=\"searchSpecialist\" type=\"search\" \nplaceholder=\"Search\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\"><md-icon flex=\"10\" \nmd-font-icon=\"icon-magnify\" class=\"icon-search fg-AAA8AD md-custom-theme md-font material-icons icon-magnify flex-10\" \nrole=\"img\" aria-label=\"icon-magnify\"></md-icon></md-select-header><md-option ng-value=\"{{user}}\" \nng-repeat=\"user in ctrl.parent.usersList | filter : {\'name\': searchSpecialist}\" class=\"mb-5\"><div>{{user.name}}</div>\n<div class=\"user-subText font-size-10\">{{user.email}}</div></md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" class=\"row-spacing\"><label>Documentation Expert</label><md-input-container md-no-float \nclass=\"input_box mt-5\"><md-select class=\"panel-select\" name=\"type\" ng-model=\"ctrl.parent.doc_Expert\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Select Documentation Expert\" md-on-open=\"searchDocExpert=\'\'\" md-on-close=\"searchDocExpert=\'\'\">\n<md-select-header class=\"demo-select-header select-header\"><input ng-model=\"searchDocExpert\" type=\"search\" \nplaceholder=\"Search\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\"><md-icon flex=\"10\" \nmd-font-icon=\"icon-magnify\" class=\"icon-search fg-AAA8AD md-custom-theme md-font material-icons icon-magnify flex-10\" \nrole=\"img\" aria-label=\"icon-magnify\"></md-icon></md-select-header><md-option ng-value=\"{{user}}\" \nng-repeat=\"user in ctrl.parent.usersList | filter : {\'name\': searchDocExpert}\" class=\"mb-5\"><div>{{user.name}}</div>\n<div class=\"user-subText font-size-10\">{{user.email}}</div></md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" class=\"row-spacing\"><label>Forwarder/Customer Success Manager</label><md-input-container \nmd-no-float class=\"input_box mt-5\"><md-select class=\"panel-select\" name=\"type\" ng-model=\"ctrl.parent.cust_Expert\" \nng-model-options=\"{ trackBy: \'$value.id\'}\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nplaceholder=\"Select Forwarder/Customer Success Manager\" md-on-open=\"searchManager=\'\'\" md-on-close=\"searchManager=\'\'\">\n<md-select-header class=\"demo-select-header select-header\"><input ng-model=\"searchManager\" type=\"search\" \nplaceholder=\"Search user\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\"><md-icon \nflex=\"10\" md-font-icon=\"icon-magnify\" \nclass=\"icon-search fg-AAA8AD md-custom-theme md-font material-icons icon-magnify flex-10\" role=\"img\" \naria-label=\"icon-magnify\"></md-icon></md-select-header><md-option ng-value=\"{{user}}\" \nng-repeat=\"user in ctrl.parent.usersList | filter : {\'name\': searchManager}\" class=\"mb-5\"><div>{{user.name}}</div><div \nclass=\"user-subText font-size-10\">{{user.email}}</div></md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(\'Cancel\')\" title=\"Cancel edit\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" title=\"SAVE\" \nng-click=\"ctrl.parent.fnSubmitMgtDetails(ctrl.parent.ship_Expert,ctrl.parent.doc_Expert,ctrl.parent.cust_Expert)\" \nng-disabled=\"ctrl.parent.managementFrm\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/edit-shipment/edit-shipment.html","<md-dialog id=\"edit-shipment\" class=\"popup-md\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div \nflex=\"90\" class=\"p-0\" flex-xs=\"90\">Edit Booking Details</div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" \nflex=\"10\" flex-xs=\"10\"><md-icon md-font-icon=\"icon-close fg-AAA8AD mr-0 cursor\" \nng-click=\"ctrl.parent.cancelDialog(\'\')\"></md-icon></div></div><form name=\"editFrm\"><md-dialog-content \nclass=\"body pb-0\"><div layout=\"{{ctrl.parent.editShipment_meta.mode != \'AIR\'? row : column}}\" layout-xs=\"column\"><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\" ng-if=\"ctrl.parent.editShipment_meta.mode != \'AIR\'\"><div>\nTracking Container</div><div flex=\"100\"><md-input-container md-no-float class=\"input_box mt-5 mv-0\"><input \nname=\"liner_shipment_id\" ng-model=\"ctrl.parent.editShipment_meta.liner_shipment_id\" \nplaceholder=\"Enter Tracking Container\" minlength=\"7\" maxlength=\"20\" class=\"panel-select md-input-focused\" \nng-model-options=\"{ debounce: 1000 }\" ng-change=\"ctrl.parent.trackEvent(\'TrackingContainer-Change\')\"><div \nng-messages=\"editFrm.liner_shipment_id.$error\"><div ng-message=\"minlength\">Minimum 7 characters required.</div></div>\n</md-input-container></div></div><div flex=\"50\" flex-xs=\"100\" class=\"mobile-spacing feild-spacing mobile_input\"><span>\nOther Details</span><md-input-container md-no-float class=\"input_box mt-5 mv-0\"><input name=\"other_details\" \nng-model=\"ctrl.parent.editShipment_meta.other_details\" maxlength=\"100\" ng-model-options=\"{ debounce: 1000 }\" \nng-change=\"ctrl.parent.trackEvent(\'OtherDetails-Change\')\" class=\"panel-select md-input-focused\" \nplaceholder=\"Enter Other Details\"></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"display-input feild-spacing mobile_input\" \nng-if=\"ctrl.parent.editShipment_meta.mode != \'AIR\'\"><div>Tracking BL</div><md-input-container md-no-float \nclass=\"input_box mt-5 mv-0\"><input class=\"panel-select md-input-focused\" name=\"bl_number\" \nng-class=\"{\'validation-error\': ctrl.parent.isBLInvalid}\" ng-model=\"ctrl.parent.editShipment_meta.bl_number\" \nid=\"bl_number\" placeholder=\"Enter Tracking BL\" ng-model-options=\"{ debounce: 1000 }\" \nng-change=\"ctrl.parent.trackEvent(\'TrackingBL-Change\')\" maxlength=\"30\" \nng-keydown=\"editFrm.bl_number.$error = false;ctrl.parent.isBLInvalid = false;\"><div ng-if=\"ctrl.parent.isBLInvalid\" \nng-messages=\"ctrl.parent.isBLInvalid\">{{ctrl.parent.errorMsg}}</div><div ng-if=\"editFrm.bl_number.$error === true\" \nng-messages=\"editFrm.bl_number.$error\">BL number must contain atleast one letter, one digit & avoid special character\n</div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"mobile-spacing feild-spacing mobile_input\"><span>\nSearch Reference</span><md-input-container md-no-float class=\"input_box mt-5 mv-0\"><input name=\"quote_name\" \nng-model=\"ctrl.parent.editShipment_meta.quote_name\" ng-model-options=\"{ debounce: 1000 }\" \nclass=\"panel-select md-input-focused\" placeholder=\"Enter Search Reference\"></md-input-container></div></div><div \nlayout=\"row\" ng-if=\"ctrl.parent.editShipment_meta.mode == \'AIR\'\" layout-xs=\"column\" class=\"row-spacing\"><div \nlayout=\"column\" flex=\"100\" ng-if=\"ctrl.parent.editShipment_meta.mode == \'AIR\'\" class=\"feild-spacing\"><div>HAWB</div>\n<div flex=\"100\"><md-input-container md-no-float class=\"input_box mt-5 mv-0\"><input name=\"hawb\" \nng-model=\"ctrl.parent.editShipment_meta.awb_object.hawb\" ng-model-options=\"{ debounce: 1000 }\" \nclass=\"panel-select md-input-focused\" placeholder=\"Enter HAWB Number\" maxlength=\"16\"></md-input-container></div></div>\n<div layout=\"column\" flex=\"100\" class=\"feild-spacing mobile-spacing\" \nng-if=\"ctrl.parent.editShipment_meta.mode == \'AIR\'\"><div>MAWB</div><div flex=\"100\"><md-input-container md-no-float \nclass=\"input_box mt-5 mv-0\"><input name=\"mawb\" ng-model=\"ctrl.parent.editShipment_meta.awb_object.mawb\" \nng-model-options=\"{ debounce: 1000 }\" class=\"panel-select md-input-focused\" placeholder=\"Enter MAWB Number\">\n</md-input-container></div></div></div><div layout=\"row\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" \nflex-xs=\"100\" class=\"display-input feild-spacing mobile_input\"><span>Origin Port</span><br><md-input-container \nmd-no-float class=\"panel-select p-35-imp input_box\" \nng-class=\"{\'validation-error\':ctrl.parent.orginValidation,\'panel-select-disabled\':ctrl.parent.editShipment_meta.carrier_booking_reference}\" \nng-if=\"ctrl.parent.shipmentEdit\" layout=\"row\" layout-align=\"start center\" ng-mouseleave=\"focused=false\" \nng-mouseenter=\"focused=true\" ng-keyup=\"ctrl.parent.orginValidation=false\"><md-tooltip \nclass=\"bg-343434 font-size-11 shipment-edit-popup-tooltip pointer-events-none\" md-direction=\"top\" \nng-if=\"ctrl.parent.editShipment_meta.carrier_booking_reference\">\nYou already have a carrier booking with this origin. changing the info can make the booking invalid.</md-tooltip>\n<md-icon class=\"mh-5 icon-size-autocomplete\" \nng-class=\"{\'icon-size-12 mt-2-imp\' : ( ctrl.parent.editShipment_meta.pol.place_type !== \'Door\' && !ctrl.parent.editShipment_meta.pol.is_major_port && !ctrl.parent.editShipment_meta.pol.is_icd_port), \'icon-size-10 mt-6\' : !ctrl.parent.editShipment_meta.pol}\" \nmd-svg-src=\"{{ ctrl.parent.editShipment_meta.pol ?\n                      (ctrl.parent.editShipment_meta.pol.place_type!== \'Door\' ?\n                      ((!ctrl.parent.editShipment_meta.pol.is_icd_port && ctrl.parent.editShipment_meta.pol.is_major_port) || (ctrl.parent.editShipment_meta.pol.is_icd_port && ctrl.parent.editShipment_meta.pol.is_major_port) || (!ctrl.parent.editShipment_meta.pol.is_icd_port && !ctrl.parent.editShipment_meta.pol.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') :\n                      \'assets/icons/custom/search-bar/door.svg\') :\n                      \'assets/icons/custom/search-bar/empty.svg\' }}\">\n</md-icon><md-autocomplete ng-disabled=\"ctrl.parent.editShipment_meta.carrier_booking_reference\" \nclass=\"auto-complete-style port-autocomplete mobile_input port-min-width\" md-input-name=\"fcl_origin_port\" \nmd-selected-item=\"ctrl.parent.editShipment_meta.pol\" md-search-text=\"ctrl.parent.fcl_originSearchText\" \nmd-selected-item-change=\"ctrl.parent.showUpdateScheduleMsg=true;ctrl.parent.selectedPort(ctrl.parent.editShipment_meta)\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.fcl_originSearchText,ctrl.parent.editShipment_meta.mode, \'origin\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" md-require-match=\"true\" \nplaceholder=\"Select Origin Port\" md-menu-class=\"autocomplete-custom-template-search\" md-select-on-focus=\"true\" \nmd-menu-container-class=\"custom-container search-autocomplete\" md-clear-button=\"focused\"><md-item-template><span \nclass=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div class=\"font-size-12 p-10\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\">\n<div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && ctrl.parent.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && ctrl.parent.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && ctrl.parent.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && ctrl.parent.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && ctrl.parent.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!ctrl.parent.fcl_originSearchText || ctrl.parent.fcl_originSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\">\n<div class=\"black-fg font-size-13\" \ncompile-html=\"ctrl.parent.util.searchHighlight(item.portname,ctrl.parent.fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">\n{{item.global_port_code}}</span></div></div></span><span class=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div \nclass=\"font-size-12 p-10 port-hover-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"center center\" style=\"pointer-events: none\"><div ng-show=\"ctrl.parent.fcl_originSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!ctrl.parent.fcl_originSearchText || ctrl.parent.fcl_originSearchText.length < 2\">\n<md-icon class=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\">\n<div class=\"black-fg font-size-14\" \ncompile-html=\"ctrl.parent.util.searchHighlight(item.location,ctrl.parent.fcl_originSearchText)\"></div><div \nclass=\"grey-fg font-size-12\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found>No ports matching \"{{ctrl.parent.fcl_originSearchText}}\" were found.</md-not-found>\n</md-autocomplete><div class=\"autocomplete-port\" \nng-if=\"ctrl.parent.editShipment_meta.pol && ctrl.parent.editShipment_meta.pol.place_type!==\'Door\'  && !focused\" \nlayout=\"row\" layout-align=\"center center\">\n{{ctrl.parent.editShipment_meta.pol.global_port_code || ctrl.parent.editShipment_meta.pol.port_code}}</div><div \nng-if=\"ctrl.parent.editShipment_meta.pol && ctrl.parent.editShipment_meta.pol.place_type===\'Door\' && ctrl.parent.editShipment_meta.pol.pin_code_ui && !focused   \" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{ctrl.parent.editShipment_meta.pol.pin_code_ui}}</span></div></md-input-container><div \nng-if=\"ctrl.parent.orginValidation\" class=\"validation-error-text\"><span>Enter Valid Origin Port</span></div>\n<md-input-container layout=\"row\" layout-align=\"start center\" md-no-float \nclass=\"panel-select-disabled p-35-imp input_box mt-5\" ng-if=\"!ctrl.parent.shipmentEdit\"><md-icon \nclass=\"mh-5 icon-size-autocomplete\" \nng-class=\"{\'icon-size-12 mt-2-imp\' : ( ctrl.parent.editShipment_meta.pol.place_type !== \'Door\' && !ctrl.parent.editShipment_meta.pol.is_major_port && !ctrl.parent.editShipment_meta.pol.is_icd_port), \'icon-size-10 mt-6\' : !ctrl.parent.editShipment_meta.pol,\'panel-select-disabled\':ctrl.parent.editShipment_meta.carrier_booking_reference}\" \nmd-svg-src=\"{{ ctrl.parent.editShipment_meta.pol ?\n                      (ctrl.parent.editShipment_meta.pol.place_type!== \'Door\' ?\n                      ((!ctrl.parent.editShipment_meta.pol.is_icd_port && ctrl.parent.editShipment_meta.pol.is_major_port) || (ctrl.parent.editShipment_meta.pol.is_icd_port && ctrl.parent.editShipment_meta.pol.is_major_port) || (!ctrl.parent.editShipment_meta.pol.is_icd_port && !ctrl.parent.editShipment_meta.pol.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') :\n                      \'assets/icons/custom/search-bar/door.svg\') :\n                      \'assets/icons/custom/search-bar/empty.svg\' }}\">\n</md-icon><div><input class=\"custom-input\" name=\"fcl_origin_port\" \nng-model=\"ctrl.parent.editShipment_meta.pol.portcode_portname\" \ntitle=\"{{ctrl.parent.editShipment_meta.pol.portcode_portname}}\" placeholder=\"Origin Port\" readonly=\"readonly\"></div>\n<div ng-if=\"ctrl.parent.editShipment_meta.pol && ctrl.parent.editShipment_meta.pol.place_type!==\'Door\'  && !focused \" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{ctrl.parent.editShipment_meta.pol.global_port_code || ctrl.parent.editShipment_meta.pol.port_code}}</div><div \nng-if=\"ctrl.parent.editShipment_meta.pol && ctrl.parent.editShipment_meta.pol.place_type===\'Door\' && ctrl.parent.editShipment_meta.pol.pin_code_ui && !focused   \" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{ctrl.parent.editShipment_meta.pol.pin_code_ui}}</span></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"mobile-spacing feild-spacing mobile_input\"><span>Destination Port</span><br><md-input-container md-no-float \nclass=\"panel-select p-35-imp input_box mt-5\" \nng-class=\"{\'validation-error\':(ctrl.parent.destinationValidation || ctrl.parent.samePortValidation),\'panel-select-disabled\':ctrl.parent.editShipment_meta.carrier_booking_reference}\" \nng-if=\"ctrl.parent.shipmentEdit\" layout=\"row\" layout-align=\"start center\" ng-mouseleave=\"focusedDestination=false\" \nng-mouseenter=\"focusedDestination=true\" \nng-keyup=\"ctrl.parent.destinationValidation=false;ctrl.parent.samePortValidation=false\"><md-tooltip \nng-if=\"ctrl.parent.editShipment_meta.carrier_booking_reference\" \nclass=\"bg-343434 font-size-11 shipment-edit-popup-tooltip pointer-events-none\" md-direction=\"top\">\nYou already have a carrier booking with this destination. changing the info can make the booking invalid.</md-tooltip>\n<md-icon class=\"mh-5 icon-size-autocomplete\" \nng-class=\"{\'icon-size-12 mt-2-imp\' : ( ctrl.parent.editShipment_meta.pod.place_type !== \'Door\' && !ctrl.parent.editShipment_meta.pod.is_major_port && !ctrl.parent.editShipment_meta.pod.is_icd_port), \'icon-size-10\' : !ctrl.parent.editShipment_meta.pod}\" \nmd-svg-src=\"{{ ctrl.parent.editShipment_meta.pod ?\n                      (ctrl.parent.editShipment_meta.pod.place_type!== \'Door\' ?\n                      ((!ctrl.parent.editShipment_meta.pod.is_icd_port && ctrl.parent.editShipment_meta.pod.is_major_port) || (ctrl.parent.editShipment_meta.pod.is_icd_port && ctrl.parent.editShipment_meta.pod.is_major_port) || (!ctrl.parent.editShipment_meta.pod.is_icd_port && !ctrl.parent.editShipment_meta.pod.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') :\n                      \'assets/icons/custom/search-bar/door.svg\') :\n                      \'assets/icons/custom/search-bar/empty.svg\' }}\">\n</md-icon><md-autocomplete ng-disabled=\"ctrl.parent.editShipment_meta.carrier_booking_reference\" \nclass=\"auto-complete-style mobile_input port-autocomplete port-min-width\" md-input-name=\"fcl_destination_port\" \nmd-selected-item=\"ctrl.parent.editShipment_meta.pod\" md-search-text=\"ctrl.parent.fcl_destinationSearchText\" \nmd-selected-item-change=\"ctrl.parent.showUpdateScheduleMsg=true;ctrl.parent.selectedPort(ctrl.parent.editShipment_meta)\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.fcl_destinationSearchText,ctrl.parent.editShipment_meta.mode, \'destination\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" md-require-match=\"true\" \nplaceholder=\"Select Destination Port\" md-clear-button=\"focusedDestination\" md-select-on-focus=\"true\" \nmd-menu-class=\"autocomplete-custom-template-search\" md-menu-container-class=\"custom-container search-autocomplete\">\n<md-item-template><span class=\"item-metadata\" ng-if=\"item.place_type===\'Port\' || item.place_type===\'Airport\'\"><div \nclass=\"font-size-12 p-10\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\"><div \nng-show=\"item.place_type===\'Port\' && item.is_major_port && !item.is_icd_port && ctrl.parent.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && !item.is_major_port && !item.is_icd_port && ctrl.parent.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/minor_port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && !item.is_major_port && ctrl.parent.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/icd.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Port\' && item.is_icd_port && item.is_major_port && ctrl.parent.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/port.svg\')\" class=\"icon-bg\"></div><div \nng-show=\"item.place_type===\'Airport\' && ctrl.parent.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/air_pod.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"!ctrl.parent.fcl_destinationSearchText || ctrl.parent.fcl_destinationSearchText < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\"><div \nclass=\"black-fg font-size-13\" \ncompile-html=\"ctrl.parent.util.searchHighlight(item.portname,ctrl.parent.fcl_destinationSearchText)\"></div><div \nclass=\"grey-fg font-size-11\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"pointer-events: none\" ng-if=\"item.global_port_code\"><span class=\"b brad-5 grey-fg ph-8 pv-5 font-size-11\">\n{{item.global_port_code}}</span></div></div></span><span class=\"item-metadata\" ng-if=\"item.place_type==\'Door\'\"><div \nclass=\"font-weight-600 font-size-12 p-10 port-hover-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"center center\" style=\"pointer-events: none\"><div \nng-show=\"ctrl.parent.fcl_destinationSearchText.length >= 2\" \nstyle=\"background-image: url(\'assets/icons/custom/search-bar/door.svg\')\" class=\"icon-bg\"></div><div layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"!ctrl.parent.fcl_destinationSearchText || ctrl.parent.fcl_destinationSearchText < 2\"><md-icon \nclass=\"w-15 h-15 mh-5\" md-svg-src=\"assets/icons/custom/ic_history.svg\"></md-icon></div><div class=\"pl-8 pb-5\"><div \nclass=\"black-fg font-size-14\" \ncompile-html=\"ctrl.parent.util.searchHighlight(item.location,ctrl.parent.fcl_destinationSearchText)\"></div><div \nclass=\"grey-fg font-size-12\">{{item.city}}</div></div></div><div layout=\"row\" layout-align=\"center center\" \nng-show=\"item.pin_code_ui\" style=\"pointer-events: none\"><span \nclass=\"b brad-5 grey-fg ph-8 pv-5 font-size-14 port-hover-code\">{{item.pin_code_ui}}</span></div></div></span>\n</md-item-template><md-not-found>No ports matching \"{{ctrl.parent.fcl_destinationSearchText}}\" were found.\n</md-not-found></md-autocomplete><div \nng-if=\"ctrl.parent.editShipment_meta.pod && ctrl.parent.editShipment_meta.pod.place_type!==\'Door\' && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{ctrl.parent.editShipment_meta.pod.global_port_code || ctrl.parent.editShipment_meta.pod.port_code}}</div><div \nng-if=\"ctrl.parent.editShipment_meta.pod && ctrl.parent.editShipment_meta.pod.place_type===\'Door\' && ctrl.parent.editShipment_meta.pod.pin_code_ui && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{ctrl.parent.editShipment_meta.pod.pin_code_ui}}</span></div></md-input-container><div \nng-show=\"ctrl.parent.destinationValidation\" class=\"validation-error-text\"><span>Enter Valid Destination Port</span>\n</div><div class=\"validation-error-text\" ng-if=\"ctrl.parent.samePortValidation\"><span>\nOrigin and destination port cannot be same!</span></div><md-input-container layout=\"row\" layout-align=\"start center\" \nmd-no-float class=\"panel-select-disabled p-35-imp input_box mt-5\" ng-if=\"!ctrl.parent.shipmentEdit\"><md-icon \nclass=\"mh-5 icon-size-autocomplete\" \nng-class=\"{\'icon-size-12 mt-2-imp\' : ( ctrl.parent.editShipment_meta.pod.place_type !== \'Door\' && !ctrl.parent.editShipment_meta.pod.is_major_port && !ctrl.parent.editShipment_meta.pod.is_icd_port), \'icon-size-10\' : !ctrl.parent.editShipment_meta.pod,\'panel-select-disabled\':ctrl.parent.editShipment_meta.carrier_booking_reference}\" \nmd-svg-src=\"{{ ctrl.parent.editShipment_meta.pod ?\n                      (ctrl.parent.editShipment_meta.pod.place_type!== \'Door\' ?\n                      ((!ctrl.parent.editShipment_meta.pod.is_icd_port && ctrl.parent.editShipment_meta.pod.is_major_port) || (ctrl.parent.editShipment_meta.pod.is_icd_port && ctrl.parent.editShipment_meta.pod.is_major_port) || (!ctrl.parent.editShipment_meta.pod.is_icd_port && !ctrl.parent.editShipment_meta.pod.is_major_port) ? \'assets/icons/custom/search-bar/port.svg\' : \'assets/icons/custom/search-bar/icd.svg\') :\n                      \'assets/icons/custom/search-bar/door.svg\') :\n                      \'assets/icons/custom/search-bar/empty.svg\' }}\">\n</md-icon><div><input class=\"custom-input\" name=\"fcl_destination_port\" \nng-model=\"ctrl.parent.editShipment_meta.pod.portcode_portname\" \ntitle=\"{{ctrl.parent.editShipment_meta.pod.portcode_portname}}\" placeholder=\"Destination Port\" readonly=\"readonly\">\n</div><div \nng-if=\"ctrl.parent.editShipment_meta.pod && ctrl.parent.editShipment_meta.pod.place_type!==\'Door\' && !focusedDestination \" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\">\n{{ctrl.parent.editShipment_meta.pod.global_port_code || ctrl.parent.editShipment_meta.pod.port_code}}</div><div \nng-if=\"ctrl.parent.editShipment_meta.pod && ctrl.parent.editShipment_meta.pod.place_type===\'Door\' && ctrl.parent.editShipment_meta.pod.pin_code_ui && !focusedDestination\" \nclass=\"autocomplete-port\" layout=\"row\" layout-align=\"center center\"><span class=\"text-truncate\">\n{{ctrl.parent.editShipment_meta.pod.pin_code_ui}}</span></div></md-input-container></div></div><div layout=\"row\" \nlayout-xs=\"column\" class=\"group-spacing\"><div flex=\"50\" flex-xs=\"100\"><div>Other Details <span class=\"sub-text\">\n( optional )</span></div></div></div><div layout=\"row\" layout-xs=\"column\" class=\"row-spacing\" \nng-if=\"ctrl.parent.editShipment_meta.mode == \'AIR\'\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>\nFlight UUID</span><md-input-container md-no-float class=\"input_box mt-5 mv-0\"><input name=\"flightUUID\" \nng-model=\"ctrl.parent.editShipment_meta.additional_attributes.flightUUID\" ng-model-options=\"{ debounce: 1000 }\" \nclass=\"panel-select md-input-focused ellipsis-100\" placeholder=\"Enter Flight UUID\"></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Rate ID</span><md-input-container md-no-float \nclass=\"input_box mt-5 mv-0\"><input name=\"rateId\" ng-model=\"ctrl.parent.editShipment_meta.additional_attributes.rateId\" \nng-model-options=\"{ debounce: 1000 }\" class=\"panel-select md-input-focused ellipsis-100\" placeholder=\"Enter Rate ID\">\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><div>{{ctrl.parent.editShipment_meta.mode == \'AIR\' ? \'Airline\' : \'Carrier Name\'}}</div><div \nflex=\"100\"><md-input-container md-no-float class=\"input_box\" \nng-if=\"ctrl.parent.shipmentEdit && ctrl.parent.editShipment_meta.mode !== \'AIR\'\">{{value.carrier_code}}<md-select \nclass=\"panel-select\" ng-model=\"ctrl.parent.editShipment_meta.carrier_info\" \nng-model-options=\"{trackBy: \'$value.carrier_code\', debounce: 1000}\" name=\"type\" placeholder=\"Select carrier\"><md-option\n ng-value=\"liner\" ng-repeat=\"liner in ctrl.parent.subvendorList\" title=\"{{liner.name}}\">{{liner.name}}</md-option>\n</md-select></md-input-container><md-input-container md-no-float class=\"input_box mt-5\" \nng-class=\"{\'panel-select-disabled\':ctrl.parent.editShipment_meta.carrier_booking_reference}\" \nng-if=\"ctrl.parent.shipmentEdit && ctrl.parent.editShipment_meta.mode == \'AIR\'\"><md-tooltip \nclass=\"bg-343434 font-size-11 shipment-edit-popup-tooltip pointer-events-none\" md-direction=\"top\" \nng-if=\"ctrl.parent.editShipment_meta.carrier_booking_reference\">\nYou already have a carrier booking with this carrier. changing the info can make the booking invalid..</md-tooltip>\n<md-select ng-disabled=\"ctrl.parent.editShipment_meta.carrier_booking_reference\" class=\"panel-select\" \nng-model=\"ctrl.parent.editShipment_meta.airline\" ng-model-options=\"{trackBy: \'$value.code\',debounce: 1000}\" \nname=\"type\" placeholder=\"Select airline\" md-on-close=\"searchAirline = \'\'\"><md-select-header><input \nng-model=\"searchAirline\" type=\"search\" placeholder=\"Search Airline Name (IATA Code / Airline Prefix Code)\" \nclass=\"demo-header-searchbox _md-text panel-select md-input-focused\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"\"><md-option \nng-repeat=\"liner in ctrl.parent.getAirline | filter : searchAirline\" ng-value=\"liner\" title=\"{{liner.name}}\">\n{{liner.name}} ({{liner.code ? liner.code : \'-\'}} / {{liner.prefix ? liner.prefix : \'-\'}})</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container md-no-float class=\"panel-select-disabled input_box mt-5\" \nng-if=\"!ctrl.parent.shipmentEdit\"><input ng-if=\"ctrl.parent.editShipment_meta.mode != \'AIR\'\" name=\"type\" \nng-model=\"ctrl.parent.editShipment_meta.carrier_info.name\" title=\"{{ctrl.parent.editShipment_meta.carrier_info.name}}\" \nclass=\"disableInput md-input-focused\" placeholder=\"Carrier\" readonly=\"readonly\"> <input \nng-if=\"ctrl.parent.editShipment_meta.mode == \'AIR\'\" title=\"{{ctrl.parent.editShipment_meta.airline.name}}\" name=\"type\" \nng-model=\"ctrl.parent.editShipment_meta.airline.name\" class=\"disableInput md-input-focused\" placeholder=\"Airline\" \nreadonly=\"readonly\"></md-input-container></div></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\">\n<div>Incoterms</div><div flex=\"100\"><incoterm-select incoterm=\"ctrl.parent.editShipment_meta.incoterm\" \nimpo-expo=\"ctrl.parent.editShipment_meta.impo_expo\" full-border=\"true\" select-panel-width=\"\'260\'\" \ncallback=\"ctrl.incotermsWarning=true;\"></incoterm-select><div class=\"inco-note-text\" \nng-if=\"ctrl.incotermsWarning && $root.domainData.domain_info.ENABLE_INCOTERM_SEARCH\"><div>\nThe charges will not modify automatically according to the selected incoterm. Please check and modify.</div></div>\n</div></div></div><div layout=\"row\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><div>{{ctrl.parent.shipment_meta.mode != \'AIR\' ? \'Voyage\' : \'Flight Number\' }}</div><div \nflex=\"100\"><md-input-container md-no-float class=\"input_box mt-5 mb-0\"><input name=\"voyage\" \nng-model=\"ctrl.parent.editShipment_meta.carrier_info.voyage\" ng-model-options=\"{ debounce: 1000 }\" \nclass=\"panel-select md-input-focused\" placeholder=\"Enter Voyage\"></md-input-container></div></div><div flex=\"50\" \nflex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><div>Type</div><div flex=\"100\"><md-input-container md-no-float \nclass=\"blue-border-clr input_box mt-5 mb-0\"><md-select class=\"panel-select\" \nng-model=\"ctrl.parent.editShipment_meta.search_type\" name=\"type\" ng-model-options=\"{ debounce: 1000 }\" \nplaceholder=\"Select type\"><md-option value=\"door to door\">Door to Door</md-option><md-option value=\"door to port\">\nDoor to Port</md-option><md-option value=\"port to port\">Port to Port</md-option><md-option value=\"port to door\">\nPort to Door</md-option></md-select></md-input-container></div></div></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><div>Sailing Date</div><div flex=\"100\">\n<date-picker model-value=\"ctrl.parent.editShipment_meta.departure_date\" md-input-id=\"\'sailing_date\'\" \nis-editable=\"true\" is-disabled=\"false\" input-required=\"false\" input-name=\"\'departure_date\'\" \ndate-placeholder=\"\'Sailing Date\'\" full-border=\"true\" date-format=\"true\" \nis-validate=\"editFrm.departure_date.$touched && editFrm.departure_date.$error.required\" \ncallback=\"ctrl.parent.editShipment_meta.departure_date=value;\"></date-picker><div \nng-messages=\"editFrm.departure_date.$error\" class=\"validation-error-text\"><div ng-message=\"valid\"><span>\nSelect Valid Date</span></div></div></div></div><div flex=\"50\" flex-xs=\"100\" class=\"mobile-spacing feild-spacing\"><div \nflex=\"100\">Delivery Date</div><div flex=\"100\"><date-picker model-value=\"ctrl.parent.editShipment_meta.arrival_date\" \nis-validate=\"editFrm.arrival_date.$error.valid\" md-input-id=\"\'delivery_date\'\" is-editable=\"true\" is-disabled=\"false\" \ninput-required=\"false\" input-name=\"\'arrival_date\'\" full-border=\"true\" date-placeholder=\"\'Delivery Date\'\" \ndate-format=\"true\" full-border=\"true\" min-date-value=\"ctrl.parent.todayDate\" \ncallback=\"ctrl.parent.editShipment_meta.arrival_date=value;\"></date-picker><div \nng-messages=\"editFrm.arrival_date.$touched && editFrm.arrival_date.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div></div></div></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"row-spacing\" ng-if=\"ctrl.parent.showUpdateScheduleMsg\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s14 grey-fg mr-5\"></md-icon><div class=\"font-size-14 font-weight-600 indigo-fg\" flex=\"100\">\nPlease update the schedules</div></div></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><div \nclass=\"mv-10\"><md-button md-no-ink class=\"md-primary-btn\" ng-click=\"ctrl.parent.cancelDialog(\'\')\" title=\"Cancel\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn\" type=\"submit\" \nng-click=\"ctrl.parent.fnSaveEditShipment(ctrl.parent.editShipment_meta,editFrm)\" title=\"Save\">Save</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/modify-deadline/modify-deadline.html","<md-dialog id=\"modify-deadline\"><div layout=\"row\" layout-padding class=\"border-bottom mh-15 mt-15 mb-0 pl-0\" \nflex=\"100\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"90\">MODIFY DEADLINE</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"10\"><md-icon md-font-icon=\"icon-close\" class=\"mr-5\" ng-click=\"ctrl.parent.cancelDialog()\">\n</md-icon></div></div><md-dialog-content class=\"font-size-14\"><div layout=\"column\" flex=\"100\"><label>\nPlease enter a new deadline date</label><date-picker is-editable=\"true\" is-disabled=\"false\" input-required=\"false\" \ninput-name=\"\'date\'\" full-border=\"false\" date-format=\"true\" model-value=\"ctrl.parent.newDeadlineDate\" \ncallback=\"ctrl.parent.newDeadlineDate = value\"></date-picker></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button md-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" \nng-click=\"ctrl.parent.changedDeadline(ctrl.parent.deadlineId, ctrl.parent.deadlineIndex)\" type=\"submit\" title=\"SAVE\">\nDone</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/new-party/new-party.html","<md-toolbar class=\"modal_title\"><div class=\"md-toolbar-tools\"><div><span>\n{{$ctrl.editPartyModalTitle == \'Add\' ? \'Select\' : $ctrl.editPartyModalTitle}}</span> <span \nng-class=\"{\'text-uppercase \':$ctrl.fixCategory ==\'Cha\'}\">{{$ctrl.fixCategory}}</span> <span ng-if=\"!$ctrl.fixCategory\">\nNew Party </span><span \nng-if=\"$ctrl.editPartyModalTitle == \'Add\' && $ctrl.fixCategory && $ctrl.fixCategory.toLowerCase() !== \'notify party\' && !$ctrl.util.isShipper\" \nclass=\"add-party-link\" ng-click=\"$ctrl.navigateToShipper($ctrl.fixCategory.toLowerCase())\">+ Add {{$ctrl.fixCategory}}\n</span></div><span flex></span><md-button md-no-ink class=\"md-icon-button\"><md-icon md-font-icon=\"icon-close\" \nclass=\"fg-AAA8AD cursor\" ng-click=\"$ctrl.cancelDialog($ctrl.fixCategory,\'close\')\"></md-icon></md-button></div>\n</md-toolbar><form name=\"partyForm\" class=\"overflow-auto\"><div layout=\"row\"><md-dialog-content flex=\"100\"><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\" \nng-if=\"$ctrl.fixCategory == \'\' && $ctrl.fixCategory != \'Notify Party\' && $ctrl.isFromQuote!=\'Quotes\'\"><span>\nCategory Name </span><br><md-input-container md-no-float class=\"input_text\"><input name=\"category\" \nclass=\"panel-select md-input-focused\" ng-class=\"{\'validation-error\':$ctrl.validationObj.categoryValidation}\" \nng-model=\"$ctrl.editParty.category\" placeholder=\"Category Name\" \nng-keyup=\"$ctrl.validationObj.categoryValidation=false\"><div ng-if=\"$ctrl.validationObj.categoryValidation\" \nclass=\"validation-error-text\"><span>Category is required.</span></div></md-input-container><p \nng-if=\"$ctrl.fixCategory != \'\' && $ctrl.fixCategory != \'Notify Party\'\">{{$ctrl.fixCategory}}</p><md-input-container \nmd-no-float class=\"input_text\" ng-if=\"$ctrl.fixCategory == \'Notify Party\'\"><md-select name=\"category\" \nclass=\"panel-select\" ng-model=\"$ctrl.editParty.category\" md-no-asterisk placeholder=\"Category Name\" \nng-change=\"$ctrl.restPartyObj($ctrl.editParty.category)\" \nng-model-options=\"{\n                        updateOn: \'default blur onchange\',\n                        debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                      }\">\n<md-option ng-value=\"type\" ng-repeat=\"type in $ctrl.partyTypes\"><span>{{type.replace(\'_\',\' \').toUpperCase()}}</span>\n</md-option></md-select><div ng-messages=\"partyForm.category.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCategory is required.</span></div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><span>Company Name</span><br><md-input-container md-no-float class=\"input_text\">\n<md-autocomplete class=\"panel-select\" ng-class=\"{\'validation-error\':$ctrl.validationObj.companyValidation}\" \nmd-input-name=\"company\" md-selected-item=\"$ctrl.searchPartyData\" \nmd-selected-item-change=\"$ctrl.setPartyDetails($ctrl.searchPartyData, $ctrl.editParty)\" \nmd-search-text-change=\"$ctrl.onCompanyTextChange($ctrl.editParty.company_name)\" \nmd-search-text=\"$ctrl.editParty.company_name\" \nmd-items=\"item in $ctrl.getCompanyList($ctrl.editParty.company_name, $ctrl.editParty.category, $ctrl.editParty)\" \nmd-item-text=\"item.company_name\" md-no-cache=\"true\" md-delay=\"300\" md-min-length=\"1\" \nplaceholder=\"{{$ctrl.canCreateNewCompany($ctrl.editParty.category) ? \'Type company name or select from dropdown\' : \'Select company from dropdown\'}}\" \nmd-require-match=\"!$ctrl.canCreateNewCompany($ctrl.editParty.category)\" md-menu-class=\"autocomplete-custom-template\" \nmd-clear-button=\"false\" md-escape-options=\"blur\" \nng-keyup=\"$ctrl.validationObj.companyValidation=false;$ctrl.validationObj.emailValidation=false\"><md-item-template>\n<span class=\"item-metadata\" title=\"{{item.company_name}}\">{{item.company_name}}</span></md-item-template><md-not-found \nng-if=\"$ctrl.canCreateNewCompany($ctrl.editParty.category)\">\nNo company matching \"{{$ctrl.editParty.company_name}}\" found. You can continue with this name to create a new company.\n</md-not-found><md-not-found ng-if=\"!$ctrl.canCreateNewCompany($ctrl.editParty.category)\">\nNo company matching \"{{$ctrl.editParty.company_name}}\" found. Please select from existing companies only.\n</md-not-found></md-autocomplete><div ng-if=\"$ctrl.validationObj.companyValidation \" class=\"validation-error-text\">\n<span>Enter Company Name</span></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nclass=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Name</span><br><md-input-container \nmd-no-float class=\"input_text\"><input class=\"panel-select md-input-focused\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.nameValidation}\" name=\"name\" ng-model=\"$ctrl.editParty.name\" \nplaceholder=\"Name\" ng-keyup=\"$ctrl.validationObj.nameValidation=false\" ng-model-options=\"{ debounce: 1000 }\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'name\',$ctrl.editParty.name)\"><div \nng-if=\"$ctrl.validationObj.nameValidation \" class=\"validation-error-text\"><span>Enter Name</span></div>\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Email ID</span><br>\n<md-input-container md-no-float class=\"input_text\"><input class=\"panel-select md-input-focused\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.emailValidation}\" name=\"email\" ng-model=\"$ctrl.editParty.email\" \nng-pattern=\"$ctrl.util.emailRegex\" placeholder=\"Email\" ng-keyup=\"$ctrl.validationObj.emailValidation=false\" \nng-model-options=\"{ debounce: 1000 }\" ng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Email\',$ctrl.editParty.email)\">\n<div ng-messages=\"partyForm.email.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Enter a valid Email Id</span>\n</div></div><div ng-if=\"$ctrl.validationObj.emailValidation && !partyForm.email.$error.pattern\" \nclass=\"validation-error-text\"><span>Enter a valid Email Id</span></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\" ng-if=\"$ctrl.isFromQuote!=\'Quotes\'\"><div flex=\"50\" \nflex-xs=\"100\" class=\"feild-spacing\"><span>Expiry Date</span><br><date-picker md-input-id=\"\'expiry_date\'\" \nis-validate=\"($ctrl.validationObj.expiryValidation || (partyForm.expiry.$touched && partyForm.expiry.$error.valid))\" \nis-editable=\"true\" is-disabled=\"false\" input-required=\"true\" input-name=\"\'expiry\'\" full-border=\"true\" \ndate-placeholder=\"\'Select Expiry Date\'\" date-format=\"true\" full-border=\"true\" min-date-value=\"$ctrl.partyExpiryMin\" \nmodel-value=\"$ctrl.editParty.expiry_date\" \ncallback=\"$ctrl.editParty.expiry_date=value;$ctrl.validationObj.expiryValidation=false;$ctrl.trackEvent($ctrl.fixCategory,\'expiry date\',$ctrl.editParty.expiry_date)\">\n</date-picker><div ng-if=\"$ctrl.validationObj.expiryValidation \" class=\"validation-error-text\"><span>Select Expiry Date\n</span></div><div \nng-messages=\"!$ctrl.validationObj.expiryValidation && partyForm.expiry.$touched && partyForm.expiry.$error\" \nclass=\"validation-error-text\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div></div><div flex=\"50\" \nflex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Permissions</span><br><md-input-container md-no-float \nclass=\"input_text\"><md-select name=\"roles\" class=\"panel-select multi-select-width\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.permissionValidation}\" ng-model=\"$ctrl.selectUser\" \nng-model-options=\"{trackBy:\'$value.name\', debounce: 500}\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'permissions\',$ctrl.selectUser)\" multiple=\"multiple\" md-no-asterisk \nplaceholder=\"Select Permission\" md-on-open=\"$ctrl.validationObj.permissionValidation=false\"><md-optgroup><md-option \nng-repeat=\"roles in $ctrl.userRoles track by roles.id\" ng-value=\"roles\"><span>{{roles.description}}</span></md-option>\n</md-optgroup></md-select><div ng-if=\"$ctrl.validationObj.permissionValidation\" class=\"validation-error-text\"><span>\nSelect the Permission</span></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" \nclass=\"row-spacing\" ng-if=\"$ctrl.isFromQuote!=\'Quotes\'\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><div>\nUser Status</div><md-radio-group ng-model=\"$ctrl.editParty.revoke\" layout=\"row\" class=\"mt-6-imp\"><md-radio-button \nmd-no-ink value=\"0\" ng-click=\"$ctrl.trackEvent($ctrl.fixCategory,\'activate\')\" \nng-class=\"$ctrl.editParty.revoke == 0 ? \'md-primary\' : \'deactive_status\'\" class=\"checkbox-margin\">Activate\n</md-radio-button><md-radio-button md-no-ink value=\"1\" ng-click=\"$ctrl.trackEvent($ctrl.fixCategory,\'deactivate\')\" \nng-class=\"$ctrl.editParty.revoke == 1 ? \'md-primary\' : \'deactive_status\'\">Deactivate</md-radio-button></md-radio-group>\n</div><div flex=\"50\" layout=\"column\" flex-xs=\"100\" class=\"feild-spacing\"><div>Send Notification</div><div layout=\"row\" \nlayout-align=\"left center\"><div class=\"pr-20\">No</div><md-switch md-no-ink \nng-model=\"$ctrl.editParty.send_notification\" ng-true-value=\"true\" ng-false-value=\"false\" aria-label=\"Switch 1\" \nclass=\"mt-5\" ng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'send notification\')\"></md-switch><div class=\"pl-20\">Yes\n</div></div></div></div><div layout=\"row\" layout-xs=\"column\" class=\"group-spacing\"><div flex=\"50\" flex-xs=\"100\"><div>\nOther Details <span class=\"sub-text\">( optional )</span></div></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Phone\n</span><br><md-input-container md-no-float class=\"input_text\"><input class=\"panel-select md-input-focused tel-input\" \ntype=\"tel\" ng-model=\"$ctrl.editParty.contact\" placeholder=\"Phone Number\" name=\"contact\" ng-maxlength=\"40\" \nng-model-options=\"{ debounce: 1000 }\" ng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Phone\',$ctrl.editParty.contact)\">\n<div ng-messages=\"partyForm.contact.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><span>Street Address</span><br><md-input-container md-no-float class=\"input_text\"><input \nname=\"address\" class=\"panel-select md-input-focused\" ng-model=\"$ctrl.editParty.address\" placeholder=\"Street Address\" \nng-model-options=\"{\n                                        updateOn: \'default blur onchange\',\n                                        debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                      }\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Address\',$ctrl.editParty.address)\"></md-input-container></div></div><div\n layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\">\n<span>Point of Contact</span><br><md-input-container md-no-float class=\"input_text\"><input name=\"point_of_contact\" \nclass=\"panel-select md-input-focused\" ng-model=\"$ctrl.editParty.point_of_contact\" placeholder=\"Point of Contact\" \nng-model-options=\"{ debounce: 1000 }\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'PointOfContact\',$ctrl.editParty.point_of_contact)\"></md-input-container>\n</div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Reference ID</span><br><md-input-container md-no-float \nng-class=\"{\'panel-select-disabled\':($ctrl.editParty.company_id || ($ctrl.editPartyModalTitle == \'Edit\'))}\" \nclass=\"input_text\"><input class=\"panel-select\" \nng-class=\"{\'no-cursor\':($ctrl.editParty.company_id || ($ctrl.editPartyModalTitle == \'Edit\'))}\" name=\"iec_number\" \nng-model=\"$ctrl.editParty.iec_number\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" placeholder=\"Reference ID\" \nng-disabled=\"$ctrl.editParty.company_id || $ctrl.editPartyModalTitle == \'Edit\'\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'ExporterReferenceID\',$ctrl.editParty.iec_number)\"><div \nng-messages=\"partyForm.iec_number.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Reference ID is invalid.</span>\n</div></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div \nflex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Country</span><br><div shimmer-effect-full width=\"100%\" \nheight=\"30px\" class=\"mt-15\" ng-if=\"$ctrl.isDataLoading\" ng-repeat=\"shimmer in [1]\"></div><md-input-container \nclass=\"input_text\" md-no-float ng-if=\"!$ctrl.isDataLoading\"><md-select class=\"panel-select\" \nng-model=\"$ctrl.editParty.country\" ng-change=\"$ctrl.countrySelected($ctrl.editParty.country)\" placeholder=\"Country\" \nmd-on-close=\"searchCountry = \'\'\"><md-select-header><input ng-model=\"searchCountry\" type=\"search\" \nplaceholder=\"Search Country\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"country in $ctrl.countryList  | orderBy:\'country_name\' | filter : {country_name : searchCountry}\" \nng-value=\"country.country_name\">{{country.country_name}}</md-option></md-select></md-input-container></div><div \nflex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>State</span><br><div shimmer-effect-full width=\"100%\" \nheight=\"30px\" class=\"mt-15\" ng-if=\"$ctrl.isDataLoading\" ng-repeat=\"shimmer in [1]\"></div><md-input-container \nclass=\"input_text\" md-no-float ng-if=\"!$ctrl.isDataLoading\"><md-select class=\"panel-select\" \nng-disabled=\"!$ctrl.stateList.length\" ng-class=\"{\'panel-select-disabled\':!$ctrl.stateList.length}\" \nng-model=\"$ctrl.editParty.state\" placeholder=\"State\" md-on-close=\"searchStates = \'\'\"><md-select-header><input \nng-model=\"searchStates\" type=\"search\" placeholder=\"Search States\" class=\"demo-header-searchbox _md-text\" \nng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"state in $ctrl.stateList | orderBy:\'state_name\' | filter : {state_name : searchStates}\" \nng-value=\"state.state_name\">{{state.state_name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\">\n<span>City</span><br><md-input-container md-no-float class=\"input_text\"><input name=\"city\" \nclass=\"panel-select md-input-focused\" ng-model=\"$ctrl.editParty.city\" placeholder=\"City\" \nng-model-options=\"{ debounce: 1000 }\" ng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'City\',$ctrl.editParty.city)\">\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Zip Code/ Postal Code</span><br>\n<md-input-container md-no-float class=\"input_text\"><input name=\"postal_code\" class=\"panel-select md-input-focused\" \nng-pattern=\"/[A-Za-z0-9][A-Za-z0-9\\- ]{0,10}[A-Za-z0-9]$/\" ng-model=\"$ctrl.editParty.postal_code\" \nplaceholder=\"Postal Code\" ng-model-options=\"{ debounce: 1000 }\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'PostalCode\',$ctrl.editParty.postal_code)\"></md-input-container></div>\n</div></md-dialog-content></div></form><md-dialog-actions class=\"footer\" layout=\"row\" layout-xs=\"column\"><div \nclass=\"mv-10\" layout=\"row\" flex=\"60\" flex-xs=\"100\" layout-align=\"end center\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"$ctrl.cancelDialog($ctrl.fixCategory,\'cancel\')\" title=\"Cancel edit\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" ng-click=\"$ctrl.fnSaveParty(partyForm,$ctrl.fixCategory)\" \ntitle=\"SAVE\">Save</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/shipments/dialogs/new-party/new-user-quote.html","<md-toolbar class=\"modal_title\"><div class=\"md-toolbar-tools\"><div><span>{{$ctrl.editPartyModalTitle}}</span> <span \nng-class=\"{\'text-uppercase \':$ctrl.fixCategory ==\'Cha\'}\">{{$ctrl.fixCategory}}</span> <span ng-if=\"!$ctrl.fixCategory\">\nNew Party </span></div><span flex></span><md-button md-no-ink class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-close\" class=\"fg-AAA8AD cursor\" ng-click=\"$ctrl.cancelDialog($ctrl.fixCategory,\'close\')\"></md-icon>\n</md-button></div></md-toolbar><form name=\"partyForm\" ng-submit=\"$ctrl.fnSaveParty(partyForm,$ctrl.fixCategory)\"><div \nlayout=\"row\"><md-dialog-content flex=\"100\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" \nflex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Company Name</span><br><md-input-container md-no-float \nclass=\"input_text\"><md-autocomplete class=\"panel-select\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.companyValidation}\" md-input-name=\"company\" \nmd-selected-item=\"$ctrl.searchPartyData\" \nmd-search-text-change=\"$ctrl.onCompanyTextChange($ctrl.editParty.company_name); $ctrl.trackEvent($ctrl.fixCategory,\'Company\',$ctrl.editParty.company_name)\" \nmd-search-text=\"$ctrl.editParty.company_name\" \nmd-items=\"item in $ctrl.getCompanyList($ctrl.editParty.company_name, $ctrl.editParty.category, $ctrl.editParty)\" \nmd-item-text=\"item.company_name\" md-no-cache=\"true\" md-delay=\"300\" md-min-length=\"1\" md-require-match=\"false\" \nplaceholder=\"Type company name or select from dropdown\" md-menu-class=\"autocomplete-custom-template\" \nmd-clear-button=\"false\" md-escape-options=\"blur\" ng-keyup=\"$ctrl.validationObj.companyValidation=false\">\n<md-item-template><span class=\"item-metadata\" title=\"{{item.company_name}}\">{{item.company_name}}</span>\n</md-item-template><md-not-found>\nNo company matching \"{{$ctrl.editParty.company_name}}\" were found. You can continue with this name to create a new customer.\n</md-not-found></md-autocomplete><div ng-if=\"$ctrl.validationObj.companyValidation \" class=\"validation-error-text\">\n<span>Enter Company Name</span></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\">\n<span>Customer Email</span><br><md-input-container md-no-float class=\"input_text\"><input \nclass=\"panel-select md-input-focused\" ng-class=\"{\'validation-error\':$ctrl.validationObj.emailValidation}\" name=\"email\" \nng-model=\"$ctrl.editParty.email\" ng-pattern=\"$ctrl.util.emailRegex\" placeholder=\"Email\" \nng-keyup=\"$ctrl.validationObj.emailValidation=false\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Email\',$ctrl.editParty.email)\"><div \nng-messages=\"partyForm.email.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Enter a valid Email Id</span></div>\n</div><div ng-if=\"$ctrl.validationObj.emailValidation && !partyForm.email.$error.pattern\" \nclass=\"validation-error-text\"><span>Enter a valid Email Id</span></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\">\n<span>First Name</span><br><md-input-container md-no-float class=\"input_text\"><input \nclass=\"panel-select md-input-focused\" ng-class=\"{\'validation-error\':$ctrl.validationObj.firstNameValidation}\" \nname=\"firstName\" ng-model=\"$ctrl.editParty.firstName\" placeholder=\"First Name\" \nng-keyup=\"$ctrl.validationObj.firstNameValidation=false\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Name\',$ctrl.editParty.firstName)\"><div \nng-if=\"$ctrl.validationObj.firstNameValidation \" class=\"validation-error-text\"><span>Enter First Name</span></div>\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Last Name</span><br>\n<md-input-container md-no-float class=\"input_text\"><input class=\"panel-select md-input-focused\" \nng-class=\"{\'validation-error\':$ctrl.validationObj.lastNameValidation}\" \nng-keyup=\"$ctrl.validationObj.lastNameValidation=false\" name=\"lastName\" ng-model=\"$ctrl.editParty.lastName\" \nplaceholder=\"Last Name\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Name\',$ctrl.editParty.lastName)\"><div \nng-if=\"$ctrl.validationObj.lastNameValidation \" class=\"validation-error-text\"><span>Enter Last Name</span></div>\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" class=\"group-spacing\"><div flex=\"50\" \nflex-xs=\"100\"><div>Other Details <span class=\"sub-text\">( optional )</span></div></div></div><div layout=\"row\" \nflex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\">\n<span>Phone</span><br><md-input-container md-no-float class=\"input_text\"><input \nclass=\"panel-select md-input-focused tel-input\" type=\"tel\" ng-model=\"$ctrl.editParty.contact\" \nplaceholder=\"Phone Number\" name=\"contact\" ng-maxlength=\"40\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Phone\',$ctrl.editParty.contact)\"><div \nng-messages=\"partyForm.contact.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing\"><span>Street Address</span><br><md-input-container md-no-float class=\"input_text\"><input \nname=\"address\" class=\"panel-select md-input-focused\" ng-model=\"$ctrl.editParty.address\" placeholder=\"Street Address\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-change=\"$ctrl.trackEvent($ctrl.fixCategory,\'Address\',$ctrl.editParty.address)\"></md-input-container></div></div>\n</md-dialog-content></div><md-dialog-actions class=\"footer\" layout=\"row\" layout-xs=\"column\"><div class=\"mv-10\" \nlayout=\"row\" flex=\"60\" flex-xs=\"100\" layout-align=\"end center\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"$ctrl.cancelDialog($ctrl.fixCategory,\'cancel\')\" title=\"Cancel edit\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" type=\"submit\" title=\"SAVE\">Save</md-button></div></md-dialog-actions></form>");
$templateCache.put("app/main/shipments/dialogs/otp-popup/otp.html","<md-dialog id=\"otp-dialog\" class=\"popup-xs\"><div layout=\"row\" layout-padding class=\"header p-20\" flex=\"100\"><div \nclass=\"ph-0 pv-10\" flex=\"95\">Please Enter OTP</div><div layout=\"row\" layout-align=\"end end\" class=\"p-0 m-0\" flex=\"5\">\n<md-icon md-font-icon=\"icon-close\" class=\"fg-AAA8AD pointer\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div>\n</div><md-dialog-content class=\"body\"><div ng-if=\"ctrl.parent.dataErr == false && ctrl.parent.otpVerified == false\">\n<div ng-show=\"ctrl.parent.sendingOtp\" class=\"dialog-text font-size-14 center-center font-weight-400 pl-5 pb-5px\" \nflex=\"100\">Sending one time password to your Email...</div><div layout=\"row\" layout-align=\"center center\">\n<md-progress-circular ng-if=\"ctrl.parent.sendingOtp\" class=\"md-accent\" md-diameter=\"32\" md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"!ctrl.parent.sendingOtp\" \nclass=\"dialog-text font-size-14 center-center font-weight-400 pl-5 pb-5px\" flex=\"100\">\nWe have sent one time password to your Email</div><input id=\"otp-input1\" class=\"otp-input\" type=\"number\" maxlength=\"1\" \nng-model=\"ctrl.parent.a\" move-next-on-maxlength restrict-to=\"[0-9]\" ng-keyup=\"ctrl.parent.otpCheck()\"> <input \nclass=\"otp-input\" type=\"number\" maxlength=\"1\" ng-model=\"ctrl.parent.b\" move-next-on-maxlength restrict-to=\"[0-9]\" \nng-keyup=\"ctrl.parent.otpCheck()\"> <input class=\"otp-input\" type=\"number\" maxlength=\"1\" ng-model=\"ctrl.parent.c\" \nmove-next-on-maxlength restrict-to=\"[0-9]\" ng-keyup=\"ctrl.parent.otpCheck()\"> <input class=\"otp-input\" type=\"number\" \nmaxlength=\"1\" ng-model=\"ctrl.parent.d\" move-next-on-maxlength restrict-to=\"[0-9]\" ng-keyup=\"ctrl.parent.otpCheck()\"> \n<input class=\"otp-input\" type=\"number\" maxlength=\"1\" ng-model=\"ctrl.parent.e\" move-next-on-maxlength \nrestrict-to=\"[0-9]\" ng-keyup=\"ctrl.parent.otpCheck()\"> <input class=\"otp-input\" type=\"number\" maxlength=\"1\" \nng-model=\"ctrl.parent.f\" move-next-on-maxlength restrict-to=\"[0-9]\" ng-keyup=\"ctrl.parent.otpCheck()\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"error\">{{ctrl.parent.otpError}}</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" ng-if=\"ctrl.parent.dataErr == true\" class=\"error\"><h2>\nSomething went wrong, try again.</h2></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\" \nng-if=\"ctrl.parent.dataErr == false && ctrl.parent.otpVerified == true\"><h2>Success!</h2><div flex=\"10\" class=\"pt-5\">\n<md-icon md-svg-src=\"assets/icons/custom/group-10.svg\"></md-icon></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" ng-if=\"ctrl.parent.otpVerified == false && ctrl.parent.dataErr == false\"><md-button md-no-ink \nng-disabled=\"!ctrl.parent.enableResend\" class=\"h-35\" ng-click=\"ctrl.parent.generateOtp();\" title=\"RESEND\">Resend\n</md-button><md-button md-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"CANCEL\">\nCancel</md-button><md-button md-no-ink ng-disabled=\"ctrl.parent.disableOtpBtn\" class=\"md-accent-btn ml-10\" \nng-click=\"ctrl.parent.checkOtp();\" type=\"submit\" title=\"VERIFY\">Verify</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/references-edit/references-edit.html","<md-dialog id=\"references-edit\" aria-label=\"Edit References\" class=\"popup-md\"><div layout=\"row\" layout-padding \nclass=\"header\" flex=\"100\"><div class=\"p-0\">Edit References</div><div layout=\"row\" layout-align=\"end end\" class=\"p-0\" \nflex-xs=\"10\"><md-icon md-font-icon=\"icon-close fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog(\'SD-References-Cancel-Click\')\"></md-icon></div></div><md-dialog-content \nclass=\"body\"><div layout=\"column\" flex=\"100\"><div class=\"simple-table-container references-table-container\"><table \nclass=\"simple references-table\"><thead><tr><th class=\"p-8 text-left\">Label</th><th class=\"p-8 text-left\">Value</th><th \nclass=\"p-8 text-left\">Internal Remarks (not processed)</th><th class=\"p-8 text-center\">Action</th></tr></thead><tbody>\n<tr ng-repeat=\"reference in ctrl.parent.editReferences track by $index\"><td class=\"p-8 font-size-13\">\n<md-input-container md-no-float class=\"inputwidth100 mb-0\"><input type=\"text\" ng-model=\"reference.reference_label\" \nplaceholder=\"Label\" readonly=\"readonly\" title=\"{{reference.reference_label}}\"></md-input-container></td><td \nclass=\"p-8 font-size-13\"><md-input-container md-no-float class=\"inputwidth100 mb-8\"><textarea \nng-model=\"reference.reference_value\" placeholder=\"Value\" required rows=\"2\" max-rows=\"4\" md-no-autogrow=\"false\">\n                  </textarea></md-input-container></td><td class=\"p-8 font-size-13\"><md-input-container md-no-float \nclass=\"inputwidth100 mb-8\"><textarea ng-model=\"reference.comment\" placeholder=\"Enter Internal Remarks\" rows=\"2\" \nmax-rows=\"4\" md-no-autogrow=\"false\">\n                  </textarea></md-input-container></td><td \nclass=\"p-8 font-size-13 text-center action-col\"><div layout=\"row\" layout-align=\"center center\"><div><md-icon \nmd-font-icon=\"icon-minus-circle-outline red-400-fg s20 cursor mr-5\" ng-click=\"ctrl.parent.fnRemoveReference($index)\">\n</md-icon></div></div></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"footer\"><span flex></span><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.cancelDialog(\'SD-References-Cancel-Click\')\">Cancel</md-button><md-button md-no-ink \nclass=\"md-accent-btn ml-10\" ng-click=\"ctrl.parent.closeReferencesModal()\">Save</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/shipments/dialogs/reject-reason/reject-reason.html","<md-dialog id=\"reject-reason\" class=\"popup-sm\"><form name=\"rejectReasonForm\" \nng-submit=\"ctrl.parent.setStatus(\'REJECTED\', ctrl.parent.rejectIndex, ctrl.parent.rejectData,rejectReasonForm)\"><div \nlayout=\"row\" flex=\"100\" class=\"header\"><div flex=\"90\" class=\"p-0\">Reason For Rejection</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"10\" class=\"p-0\"><md-icon md-font-icon=\"icon-close\" class=\"fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div><md-dialog-content class=\"body\"><div flex=\"100\" \nlayout=\"row\" layout-align=\"start center\">Provide reason for rejection</div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"pt-5 pb-5\"><md-input-container md-no-float class=\"height-container inputwidth100\">\n<textarea name=\"reason\" ng-model=\"ctrl.parent.rejectComment\" md-maxlength=\"180\" class=\"border text-container\" \nng-class=\"{\'validation-error\':ctrl.parent.reasonValidation}\" placeholder=\"\" rows=\"3\" max-rows=\"6\" \nng-keyup=\"ctrl.parent.reasonValidation=false\"></textarea><div ng-messages=\"rejectReasonForm.reason.$error\" \nclass=\"validation-error-text\"><div ng-message=\"md-maxlength\">That\'s too long!!</div></div><div \nng-if=\"ctrl.parent.reasonValidation\" class=\"validation-error-text\">Mention the Reason For Rejection</div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><div class=\"m-10\">\n<md-button md-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\">Cancel</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\">Done</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/remark-edit/remark-edit.html","<md-dialog id=\"remarks-edit\"><div layout=\"row\" layout-padding class=\"border-bottom mh-15 mt-15 mb-0 pl-0\" flex=\"100\">\n<div class=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"90\">REMARKS</div><div layout=\"row\" layout-align=\"end end\" \nflex=\"10\"><md-icon md-font-icon=\"icon-close\" class=\"mr-5\" ng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div>\n<md-dialog-content class=\"font-size-14\"><div layout=\"column\" class=\"mv-20 font-size-14\"><label class=\"font-weight-600\">\nRemarks</label><md-input-container md-no-float class=\"mt-10 mb-0\"><textarea name=\"remarks\" placeholder=\"Enter remarks\">\n</textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\">Cancel</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"SAVE\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/schedule-edit/schedule-edit.html","<md-dialog id=\"schedule-edit\" class=\"popup-md\"><form name=\"scheduleForm\" \nng-submit=\"ctrl.parent.saveScheduleTrack(scheduleForm)\"><div layout=\"row\" layout-padding class=\"header\" flex=\"100\"><div\n class=\"p-0\" flex=\"80\" layout-align=\"start center\">{{ctrl.parent.scheduleModalTitle}} Schedule Track</div><div \nclass=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"20\"><md-icon md-font-icon=\"icon-close\" \nclass=\"m-0 fg-AAA8AD pointer\" ng-click=\"ctrl.parent.cancelDialog();\"></md-icon></div></div><md-dialog-content \nclass=\"body\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>\nLocation<br><md-autocomplete \nng-if=\"ctrl.parent.scheduleModalTitle == \'Add\' || ctrl.parent.scheduleModalTitle == \'Add New\'\" \nng-class=\"{\'validation-error\':ctrl.parent.locationValidation}\" md-input-name=\"schedule_track_port\" \nmd-selected-item=\"ctrl.parent.trackPort\" md-search-text=\"ctrl.parent.trackText\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.trackText, ctrl.parent.edit_schedule_track.mode)\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" placeholder=\"Location\" \nmd-menu-class=\"autocomplete-custom-template\" class=\"panel-select input_text\" \nng-keyup=\"ctrl.parent.locationValidation=false\"><md-item-template><span class=\"item-metadata\">\n{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{ctrl.parent.trackText}}\" were found.</md-not-found></md-autocomplete><div \nng-if=\"ctrl.parent.locationValidation\" class=\"validation-error-text\"><div>Enter Valid Location</div></div>\n<md-input-container ng-show=\"ctrl.parent.scheduleModalTitle == \'Edit\'\" class=\"input_text\" md-no-float><input \nclass=\"panel-select md-input-focused\" ng-model=\"ctrl.parent.edit_schedule_track.port_name\" \nng-disabled=\"ctrl.parent.scheduleModalTitle == \'Edit\'\"></md-input-container></span></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><span>Service</span><br><md-input-container md-no-float class=\"input_text\"><input \nclass=\"panel-select md-input-focused\" name=\"serviceName\" ng-model=\"ctrl.parent.edit_schedule_track.service_name\" \nng-keyup=\"ctrl.parent.serviceValidation=false\" placeholder=\"Service\" \nng-class=\"{\'validation-error\':ctrl.parent.serviceValidation}\"><div ng-if=\"ctrl.parent.serviceValidation\" \nclass=\"validation-error-text\"><span>Enter the Service</span></div></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" layout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>Vessel\n</span><br><md-input-container md-no-float class=\"input_text\"><input class=\"panel-select md-input-focused\" \nname=\"vesselName\" ng-keyup=\"ctrl.parent.vesselValidation=false\" \nng-class=\"{\'validation-error\':ctrl.parent.vesselValidation}\" ng-model=\"ctrl.parent.edit_schedule_track.vessel\" \nplaceholder=\"Vessel\"><div ng-messages=\"scheduleForm.vesselName.$error\" role=\"alert\"><div \nng-if=\"ctrl.parent.vesselValidation\" class=\"validation-error-text\"><span>Enter the Vessel Name</span></div></div>\n</md-input-container></div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Voyage Reference\n</span><br><md-input-container md-no-float class=\"input_text\"><input class=\"panel-select md-input-focused\" \nname=\"voyageName\" ng-model=\"ctrl.parent.edit_schedule_track.voyage\" placeholder=\"Voyage Reference\"><div \nng-messages=\"scheduleForm.voyageName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nVoyage reference is required.</span></div></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"group-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span>VGM Cutoff</span><br>\n<date-picker md-input-id=\"\'vgmcuttoff\'\" model-value=\"ctrl.parent.edit_schedule_track.vgm_cutoff\" \nis-validate=\"scheduleForm.vgmName.$touched && scheduleForm.vgmName.$error.valid\" is-editable=\"true\" \nis-disabled=\"false\" input-required=\"false\" full-border=\"true\" input-name=\"\'vgmName\'\" date-placeholder=\"\'VGM cutoff\'\" \ndate-format=\"false\" min-date-value=\"ctrl.parent.scheduleExpiryMin\" \ncallback=\"ctrl.parent.edit_schedule_track.vgm_cutoff = value;\"></date-picker><div \nng-messages=\"scheduleForm.vgmName.$touched && scheduleForm.vgmName.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div></div><div flex=\"50\" flex-xs=\"100\" \nclass=\"feild-spacing mobile-spacing\"><span>Port Cutoff</span><br><date-picker md-input-id=\"\'portcurtoff\'\" \nmodel-value=\"ctrl.parent.edit_schedule_track.port_cutoff\" \nis-validate=\"scheduleForm.portCutName.$touched && scheduleForm.portCutName.$error.valid\" is-editable=\"true\" \nis-disabled=\"false\" full-border=\"true\" input-required=\"false\" full-border=\"true\" input-name=\"\'portCutName\'\" \ndate-placeholder=\"\'Port Cutoff\'\" date-format=\"true\" min-date-value=\"ctrl.parent.scheduleExpiryMin\" \ncallback=\"ctrl.parent.edit_schedule_track.port_cutoff= value;\"></date-picker><div \nng-messages=\"scheduleForm.portCutName.$touched && scheduleForm.portCutName.$error\" class=\"validation-error-text\"><div \nng-message=\"valid\"><span>Select Valid Date</span></div></div></div></div><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\" class=\"row-spacing\"><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing\"><span class=\"mb-6\">\nDeparture Date</span><br><date-picker md-input-id=\"\'departuredate\'\" is-validate=\"ctrl.parent.departureValidation\" \nmodel-value=\"ctrl.parent.edit_schedule_track.departure_time\" is-editable=\"true\" is-disabled=\"false\" full-border=\"true\" \ninput-required=\"false\" full-border=\"true\" input-name=\"\'departure_time\'\" date-placeholder=\"\'Departure Date\'\" \ndate-format=\"false\" min-date-value=\"ctrl.parent.scheduleExpiryMin\" \ncallback=\"ctrl.parent.edit_schedule_track.departure_time= value;ctrl.parent.departureValidation=false;\"></date-picker>\n<div \nng-messages=\"!ctrl.parent.departureValidation && scheduleForm.departure_time.$touched && scheduleForm.departure_time.$error\" \nclass=\"validation-error-text mt-3\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"ctrl.parent.departureValidation\" class=\"validation-error-text mt-3\"><span>Select the Departure Date</span></div>\n</div><div flex=\"50\" flex-xs=\"100\" class=\"feild-spacing mobile-spacing\"><span>Arrival Date</span><date-picker \nmd-input-id=\"\'arrival\'\" is-validate=\"ctrl.parent.arrivalValidation\" \nmodel-value=\"ctrl.parent.edit_schedule_track.arrival_time\" is-editable=\"true\" is-disabled=\"false\" full-border=\"true\" \ninput-required=\"false\" full-border=\"true\" input-name=\"\'arrival_time\'\" date-placeholder=\"\'Arrival Date\'\" \ndate-format=\"true\" min-date-value=\"ctrl.parent.scheduleExpiryMin\" \ncallback=\"ctrl.parent.edit_schedule_track.arrival_time = value;ctrl.parent.arrivalValidation=false;\"></date-picker><div\n \nng-messages=\"!ctrl.parent.arrivalValidation && scheduleForm.arrival_time.$touched && scheduleForm.arrival_time.$error\" \nclass=\"validation-error-text mt-3\"><div ng-message=\"valid\"><span>Select Valid Date</span></div></div><div \nng-if=\"ctrl.parent.arrivalValidation\" class=\"validation-error-text mt-3\"><span>Select the Arrival Date</span></div>\n</div></div></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><div class=\"mv-10\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog();\" title=\"Cancel edit\">Cancel</md-button><md-button \nmd-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"SAVE\">Save</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/shipments/dialogs/schedule-select/schedule-select.html","<md-dialog class=\"schedule-select-modal popup-lg\" ng-class=\"{\'w-400\':!ctrl.parent.viewScheduleList.length}\"><div \nlayout=\"row\" layout-padding class=\"header\" flex=\"100\"><div class=\"p-0\" flex=\"90\" flex-xs=\"90\">Select Schedule</div><div\n layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" class=\"icon_size fg-AAA8AD p-0\"><md-icon \nmd-font-icon=\"icon-close m-0 fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog();ctrl.parent.trackEvent(\'\',\'\',\'\',\'SD-NoSchedule-close\')\"></md-icon></div></div>\n<md-dialog-content class=\"body\" ng-if=\"ctrl.parent.scheduleVisible === true\"><div layout=\"row\" layout-wrap \nclass=\"ph-20\" ng-if=\"ctrl.parent.viewScheduleList.length\"><div layout=\"column\" layout-align=\"start start\" flex=\"100\" \nflex-gt-xs=\"40\" class=\"p-0 scroll\"><div class=\"outer mv-10 pointer\" \nng-repeat=\"schedule in  ctrl.parent.viewScheduleList track by $index\" \nng-click=\"ctrl.parent.setCurrentSchedule(schedule)\" \nng-class=\"{\'outer_container\' : ctrl.parent.current_schedule._id == schedule._id}\"><div layout=\"row\" layout-wrap \nlayout-align=\"center center\" class=\"font-size-14 font-weight-600 pt-15 ph-10\">\n{{schedule.transit_time}} - {{schedule.service_name}}</div><div layout=\"row\" layout-wrap class=\"ph-15 pv-10\"><div \nlayout=\"column\" layout-align=\"center start\" flex=\"30\" flex-gt-xs=\"30\"><p class=\"font-size-14 font-weight-600 mv-5\">\n{{schedule.origin_port}}</p><p class=\"font-size-14 m-0\">{{ schedule.departure_time | UTCToLocal : \'d MMM, yyyy\' }}</p>\n</div><div layout=\"column\" layout-align=\"center center\" flex=\"30\" flex-gt-xs=\"30\" class=\"text-center mh-5\"><p \nclass=\"font-size-12 m-0 pt-10\"><span class=\"grey-fg\" ng-hide=\"schedule.schedule_track.length < 3\">via</span><br><span \nclass=\"font-size-12\">{{schedule.via_port}}</span></p></div><div layout=\"column\" layout-align=\" center end\" flex=\"30\" \nflex-gt-xs=\"30\"><p class=\"font-size-14 font-weight-600 mv-5\">{{schedule.destination_port}}</p><p \nclass=\"font-size-14 m-0 text-right\">{{ schedule.arrival_time | UTCToLocal : \'d MMM, yyyy\' }}</p></div></div></div>\n</div><div class=\"pr-10 pb-20 mt-10 route_div\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\" \nng-if=\"ctrl.parent.current_schedule.schedule_track.length > 0\"><div layout=\"column\" class=\"ph-15\" \nng-repeat=\"schedule_track in ctrl.parent.current_schedule.schedule_track track by $index\"><div layout=\"row\" \nclass=\"show_schedule pt-5\" ng-if=\"($first || $last)\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80\" \nng-class=\"{\'mt-12\':!$first}\" ng-if=\"!$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 mt-12\" ng-if=\"$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"ship_schedule_sect\" ng-class=\"{\'border-left\' : !$last,\'mt-10\': $first}\"><p \nclass=\"card_text_bold source_name\"><md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon \nclass=\"icon-class\" md-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>\n{{ schedule_track.port_name }}</span></p><div layout=\"column\" class=\"pb-20\" ng-if=\"!$last\"><div layout=\"row\"><div \nclass=\"track_text\" flex>VGM Cutoff</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vgm_cutoff != \"\" ? (schedule_track.vgm_cutoff | UTCToLocal : ctrl.parent.util.dateFormat) : \'NA\' }}\n</div></div><div layout=\"row\"><div class=\"track_text\" flex>Port Cutoff</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.port_cutoff != \"\" ? (schedule_track.port_cutoff | UTCToLocal : ctrl.parent.util.dateFormat) : \'NA\'}}\n</div></div><div layout=\"row\"><div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.service_name != \"\" ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vessel != \"\" ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" \nflex>Voyage Ref.</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.voyage != \"\" ? schedule_track.voyage : \'NA\'}}</div></div></div></div></div><div layout=\"row\" \nclass=\"show_schedule pt-5\" ng-class=\"{\'pv-20\' : !vm.util.isMobileDevice}\" ng-if=\"(!$first && !$last)\"><div \nflex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 mt-12\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"ship_schedule_sect border-left\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" \nmd-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} </span>\n<span>(Arrival)</span></p></div></div><div layout=\"row\" class=\"show_schedule pt-5\" ng-if=\"(!$first && !$last)\"><div \nflex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 mt-12\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"ship_schedule_sect border-left\"><p class=\"card_text_bold source_name\"><md-icon \nmd-font-icon=\"icon-flickr-after\" class=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" \nmd-svg-src=\"assets/icons/custom/icon-ship.svg\" class=\"\"></md-icon></span><span>{{ schedule_track.port_name }} </span>\n<span>(Departure)</span></p><div layout=\"column\" class=\"pb-20\"><div layout=\"row\"><div class=\"track_text\" flex>\nVGM Cutoff</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vgm_cutoff != \"\" ? (schedule_track.vgm_cutoff | UTCToLocal : ctrl.parent.util.dateFormat) : \'NA\' }}\n</div></div><div layout=\"row\"><div class=\"track_text\" flex>Port Cutoff</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.port_cutoff != \"\" ? (schedule_track.port_cutoff | UTCToLocal : ctrl.parent.util.dateFormat) : \'NA\'}}\n</div></div><div layout=\"row\"><div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.service_name != \"\" ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vessel != \"\" ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" \nflex>Voyage Ref.</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.voyage != \"\" ? schedule_track.voyage : \'NA\'}}</div></div></div></div></div></div></div><div \nclass=\"pr-10 pb-20 mt-10 pt-20 route_div scroll h-552 grey-100-bg grey-600-fg\" layout-align=\"center center\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"60\" ng-if=\"!ctrl.parent.current_schedule.schedule_track\"><div>\nNo schedule has been selected.</div><div>Please select the schedule from the list.</div></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap class=\"ph-20\" ng-if=\"!ctrl.parent.viewScheduleList.length\"><h2>\nSorry, No schedules available.</h2></div><div layout=\"row\" layout-align=\"end center\" layout-wrap class=\"p-20\"></div>\n</md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\" ng-if=\"ctrl.parent.viewScheduleList.length\"><div \nclass=\"mv-10\"><md-button md-no-ink class=\"md-accent-btn w-150\" ng-disabled=\"ctrl.parent.scheduleBtn\" \ntitle=\"Select schedule\" ng-click=\"ctrl.parent.selectedSchedule(ctrl.parent.current_schedule)\">Select Schedule\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/upload-invoice/add-invoice.html","<md-dialog id=\"edit-invoice\" class=\"popup-sm\"><div layout=\"row\" layout-padding class=\"header mb-0\" flex=\"100\"><div \nclass=\"p-0\" flex=\"90\">Add Invoice Details</div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"10\"><md-icon \nmd-font-icon=\"icon-close\" class=\"fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog(\'SD-Invoice-Close-Click\')\">\n</md-icon></div></div><form name=\"uploadInvoiceFrm\"><md-dialog-content class=\"body\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\">Invoice Date</div><div flex=\"100\" layout=\"row\"><date-picker style=\"width:97.5%\" \nmodel-value=\"ctrl.parent.addInvoice.created_date\" md-input-id=\"\'created_date\'\" is-editable=\"true\" is-disabled=\"false\" \ninput-required=\"false\" full-border=\"true\" input-name=\"\'created_date\'\" date-placeholder=\"\'Invoice Date\'\" \ndate-format=\"\'true\'\" min-date-value=\"ctrl.parent.todayDate\" callback=\"ctrl.parent.addInvoice.created_date=value;\">\n</date-picker></div><div flex=\"100\" layout=\"row\" layout-align=\"start center\" class=\"input_box row-spacing\">\nCredit (In days)</div><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"100\" \nmd-no-float class=\"mt-6 mb-0 font-size-14\"><input name=\"credit\" class=\"panel-select md-input-focused border-none\" \nplaceholder=\"Credit\" ng-model=\"ctrl.parent.addInvoice.credit\" type=\"number\" min=\"0\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div flex=\"100\" layout=\"row\" layout-align=\"start center\" class=\"row-spacing\">\nPayment Due Date</div><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><date-picker style=\"width:100%\" \nmodel-value=\"ctrl.parent.addInvoice.due_date\" md-input-id=\"\'payment_date\'\" is-editable=\"true\" is-disabled=\"false\" \nfull-border=\"true\" input-required=\"false\" full-border=\"true\" input-name=\"\'due_date\'\" \ndate-placeholder=\"\'Payment Due Date\'\" date-format=\"true\" min-date-value=\"ctrl.parent.todayDate\" \ncallback=\"ctrl.parent.addInvoice.due_date=value;\"></date-picker></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"input_box row-spacing\">Invoice Amount</div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"100\" md-no-float class=\"mt-6 mb-0 font-size-14\"><input \nname=\"share\" ng-model=\"ctrl.parent.addInvoice.amount\" type=\"number\" class=\"panel-select md-input-focused\" \nplaceholder=\"Amount\" min=\"0\" name=\"amount\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" class=\"row-spacing\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\">Upload invoice :</div><div class=\"font-size-14 font-weight-600 pt-10\" flex=\"100\"><input \ntype=\"file\" id=\"fileInput\" ngf-select=\"ctrl.parent.fileValidation=false\" ng-model=\"ctrl.parent.invoiceFile\" \nname=\"invoiceFile\" accept=\".pdf\" ngf-max-size=\"10MB\" ngf-pattern=\"\'.pdf\'\" ngf-model-invalid=\"errorFile\" class=\"w-180\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><br>\n<div ng-if=\"ctrl.parent.fileValidation\" class=\"validation-error-text\">Upload PDF file to add Invoice details</div><span\n class=\"font-size-12 dimgrey-fg\">* Upload only PDF files.</span><br><span \nng-show=\"uploadInvoiceFrm.invoiceFile.$error.maxSize && !ctrl.parent.fileValidation\" class=\"validation-error-text\">\nThis file is too large, maximum file size is 10MB.</span> <span \nng-show=\"uploadInvoiceFrm.invoiceFile.$error.pattern && !ctrl.parent.fileValidation\" class=\"validation-error-text\">\nPlease upload only pdf format file.</span><div layout=\"column\" flex=\"100\" ng-show=\"ctrl.parent.showProgressBar\" \nclass=\"ph-20 pt-15\"><md-progress-linear md-mode=\"indeterminate\" class=\"p-15\"></md-progress-linear><div layout=\"row\" \nflex=\"100\"><span class=\"text-left font-weight-800 font-style-italic\" flex=\"100\"><i class=\"font-size-16\">Processing...\n</i></span></div></div></div></div></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><md-button \nmd-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog(\'SD-Invoice-Cancel-Click\')\" title=\"Cancel\">\nCancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" \nng-click=\"ctrl.parent.createInvoice(ctrl.parent.addInvoice,ctrl.parent.invoiceFile,uploadInvoiceFrm)\" type=\"submit\" \ntitle=\"Save\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/shipments/dialogs/upload-invoice/edit-invoice.html","<md-dialog id=\"edit-invoice\" class=\"popup-sm\"><div layout=\"row\" layout-padding class=\"header mb-0\" flex=\"100\"><div \nclass=\"p-0\" flex=\"90\">Edit Invoice Details</div><div class=\"p-0\" layout=\"row\" layout-align=\"end end\" flex=\"10\"><md-icon\n md-font-icon=\"icon-close\" class=\"fg-AAA8AD cursor\" ng-click=\"ctrl.parent.cancelDialog(\'SD-Invoice-Close-Click\')\">\n</md-icon></div></div><form name=\"uploadInvoiceFrm\"><md-dialog-content class=\"body\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"input_box\">Invoice Date</div><div flex=\"100\" layout=\"row\"><date-picker \nstyle=\"width:97.5%\" model-value=\"ctrl.parent.editInvoice.created_date\" md-input-id=\"\'invoice_date\'\" is-editable=\"true\" \nis-disabled=\"false\" full-border=\"true\" input-required=\"false\" input-name=\"\'created_date\'\" \ndate-placeholder=\"\'Invoice Date\'\" date-format=\"true\" callback=\"ctrl.parent.editInvoice.created_date=value;\">\n</date-picker></div><div flex=\"100\" layout=\"row\" layout-align=\"start center\" class=\"row-spacing input_box\">\nCredit (In days)</div><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><md-input-container md-no-float \nclass=\"mt-0 mb-0 font-size-14\"><input name=\"credit\" class=\"panel-select md-input-focused border-none w-350\" \nplaceholder=\"Credit\" ng-model=\"ctrl.parent.editInvoice.credit\" type=\"number\" min=\"0\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div flex=\"100\" layout=\"row\" layout-align=\"start center\" class=\"input_box row-spacing\">\nPayment Due Date</div><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><date-picker style=\"width:97.5%\" \nmodel-value=\"ctrl.parent.editInvoice.due_date\" md-input-id=\"\'invoice_date\'\" is-editable=\"true\" is-disabled=\"false\" \nfull-border=\"true\" input-required=\"false\" input-name=\"\'due_date\'\" date-placeholder=\"\'Payment Due Date\'\" \ndate-format=\"true\" callback=\"ctrl.parent.editInvoice.due_date=value;\"></date-picker></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"input_box row-spacing\">Invoice Amount</div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"mt-0 mb-0 font-size-14\"><input name=\"share\" \nng-model=\"ctrl.parent.editInvoice.amount\" type=\"number\" min=\"0\" \nclass=\"panel-select md-input-focused border-none w-350\" placeholder=\"Amount\" name=\"amount\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\">\n</md-input-container></div><div layout=\"row\" flex=\"100\" ng-if=\"ctrl.parent.editInvoice.url != null\" \nclass=\"row-spacing font-size-16\"><a ng-href=\"{{ctrl.parent.util.sanitizeQueryParams(ctrl.parent.editInvoice.url)}}\" \ntarget=\"_blank\" rel=\"noopener\" class=\"md-link-fg\">Preview Uploaded file</a></div><div class=\"custom-divider\" \nng-if=\"ctrl.parent.editInvoice.url != null\"></div><div layout=\"row\" flex=\"100\"><div \nclass=\"font-size-14 font-weight-600 pt-20\" flex=\"50\"><input type=\"file\" id=\"fileInput\" \nngf-select=\"ctrl.parent.fileValidation=false\" ng-model=\"ctrl.parent.invoiceFile\" name=\"invoiceFile\" \nngf-max-size=\"10MB\" accept=\".pdf\" ngf-pattern=\"\'.pdf\'\" ngf-model-invalid=\"errorFile\" class=\"w-180\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\"><br>\n<div ng-if=\"ctrl.parent.fileValidation\" class=\"validation-error-text\">Upload PDF file to add Invoice details</div><span\n class=\"font-size-12 dimgrey-fg\">* Upload only PDF files.</span><br><span \nng-show=\"uploadInvoiceFrm.invoiceFile.$error.maxSize  && !ctrl.parent.fileValidation\" class=\"validation-error-text\">\nThis file is too large, maximum file size is 10MB.</span> <span \nng-show=\"uploadInvoiceFrm.invoiceFile.$error.pattern  && !ctrl.parent.fileValidation\" class=\"validation-error-text\">\nPlease upload only pdf format file.</span><div layout=\"column\" flex=\"100\" ng-show=\"ctrl.parent.showProgressBar\" \nclass=\"ph-20 pt-15\"><md-progress-linear md-mode=\"indeterminate\" class=\"p-15\"></md-progress-linear><div layout=\"row\" \nflex=\"100\"><span class=\"text-left font-weight-800 font-style-italic\" flex=\"100\"><i class=\"font-size-16\">Processing...\n</i></span></div></div></div></div></md-dialog-content><md-dialog-actions class=\"footer\" layout=\"row\"><md-button \nmd-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog(\'SD-Invoice-Cancel-Click\')\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" \nng-click=\"ctrl.parent.createInvoice(ctrl.parent.editInvoice,ctrl.parent.invoiceFile,uploadInvoiceFrm)\" type=\"submit\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/shipments/shipment_details/shipment-meta/shipment-meta.html","<div id=\"shipment-meta\"><import-file-status-bar importstatusobj=\"vm.responseStatusData\" \ncallback=\"vm.removeResponse(\'\',index)\"></import-file-status-bar><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"mv-20\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between end\" \nlayout-align-xs=\"space-between start\" flex=\"100\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"font-size-12 md-link-fg ml-30 pointer\" ng-click=\"vm.goBack()\" \nng-if=\"!(vm.util.isWebView() || vm.util.isSharedPage())\">Booking /</div><div layout=\"row\"><div \nng-click=\"vm.goBack(\'backIcon\')\" ng-if=\"!(vm.util.isWebView() || vm.util.isSharedPage())\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"mr-5 mt-5 pointer\"></md-icon></div><div \nng-bind=\"vm.shipment_meta.shipment_id ? vm.shipment_meta.shipment_id : \'N/A\'\" class=\"page_title\"></div><div><div \nclass=\"status_meta_div\" \nng-bind=\"vm.shipment_meta.current_status.status ? vm.shipment_meta.current_status.status : \'N/A\'\" \nng-style=\"vm.util.getStatusColor(vm.shipment_meta.current_status.color_code)\"></div></div></div></div><div \nlayout=\"row\" layout-padding class=\"p-0\" layout-wrap><div layout=\"row\" layout-align=\"center center\" \nclass=\"font-size-12 mt-5\"><div class=\"text-italic red-400-fg\" ng-if=\"vm.sendToErrType==401\"><md-icon \nmd-font-icon=\"icon-no\" class=\"red-400-fg s20 sentToErrIcon\"></md-icon>Access denied due to wrong credentials</div><div \nclass=\"text-italic orange-fg\" ng-if=\"vm.sendToErrType==422\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"orange-fg s20 sentToErrIcon\"></md-icon>Contact support for invalid dataset</div><div \nclass=\"text-italic green-fg\" ng-if=\"vm.sendToErrType==200\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\n            \" class=\"green-fg s20 sentToErrIcon\"></md-icon>\nSuccessfully Synced!</div></div><sync-button erpdata=\"vm.erp_data\" shipmentdata=\"vm.shipment_data\" \nresponsestatusdata=\"vm.responseStatusData\" sendtoerrtype=\"vm.sendToErrType\" entity=\"\'shipment\'\" \nshipmentmeta=\"vm.shipment_meta\" class=\"p-0\" \nng-if=\"!vm.util.isShipper && (vm.util.isAdmin || vm.util.isFreightbro)  && !vm.util.isSharedPage()\"></sync-button><div \nclass=\"p-0\" \nng-if=\"vm.shipment_data.button && vm.shipment_data.button.carrier_booking && vm.shipment_data.button.carrier_booking.is_visible\">\n<md-button md-no-ink class=\"md-primary-btn with-icon mb-0\" \nng-disabled=\"!vm.shipment_data.button.carrier_booking.is_enabled\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.proceedCarrierBooking($event)\"><md-icon \nng-if=\"vm.shipment_data.button.carrier_booking.data.icon && !vm.loadingCarrierBtn\" \nmd-svg-icon=\"assets/icons/custom/search-bar/flash_on_black_24dp.svg\" class=\"icon-procced s16\"></md-icon><span \nng-if=\"vm.shipment_data.button.carrier_booking.data.text && !vm.loadingCarrierBtn\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-12\" ng-if=\"vm.shipment_data.button.carrier_booking.data.message\">\n{{vm.shipment_data.button.carrier_booking.data.message}}</md-tooltip>\n{{vm.shipment_data.button.carrier_booking.data.text}}</span><md-icon ng-if=\"vm.loadingCarrierBtn\" \nmd-font-icon=\"icon-refresh\" class=\"s16 refresh-spacing\"></md-icon><span ng-if=\"vm.loadingCarrierBtn\">Loading</span>\n</md-button></div><md-menu md-offset=\"0 -5\" ng-if=\"vm.statusPermission[0] && vm.statusPermission[1]\"><md-button \nmd-no-ink aria-label=\"Open demo menu\" class=\"md-primary-btn with-icon mb-0\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.openStatusMenu($mdMenu, $event)\"><span class=\"pr-2\" \nng-bind=\"((vm.shipment_meta.current_status.status==\'\') || (vm.shipment_meta.current_status.status==null)) ? \'N/A\' : vm.shipment_meta.current_status.status\">\n</span><md-icon class=\"s18 m-0\" md-font-icon=\"icon-chevron-down\"></md-icon></md-button><md-menu-content width=\"5\">\n<md-menu-item class=\"mt-10 mb-5\" \nng-repeat=\"statusObj in vm.statusList | filter : {is_completed : \'true\'} track by $index\" \nng-click=\"vm.fnOpenChangeStatus(statusObj,$index,$event)\"><md-button md-no-ink><div layout=\"row\"><div flex=\"10\" \nclass=\"pt-5\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\n                    \" class=\"md-link-fg\"></md-icon>\n</div><div layout=\"column\" flex=\"90\" class=\"ml-10\"><span flex=\"30\" class=\"ship_text\" ng-bind=\"statusObj.status\"></span>\n <span flex class=\"font-size-10 grey-500-fg\" ng-bind=\"statusObj.changed_date | UTCToLocal : \'d MMM, yyyy\'\"></span>\n</div></div></md-button></md-menu-item><md-menu-item class=\"mt-10 mb-5\" \nng-repeat=\"statusObj in vm.statusList | filter : {is_completed : \'false\'} track by $index\" \nng-click=\"vm.fnOpenChangeStatus(statusObj,$index,$event)\"><md-button md-no-ink><div layout=\"row\"><div flex=\"10\">\n<md-icon class=\"blank_circle_icon grey-300-fg\" md-font-icon=\"icon-checkbox-blank-circle\"></md-icon></div><div \nlayout=\"column\" flex=\"90\" class=\"ml-10\"><span flex=\"100\" class=\"ship_text\" ng-bind=\"statusObj.status\"></span></div>\n</div></md-button></md-menu-item></md-menu-content></md-menu><md-button md-no-ink \nclass=\"md-primary-btn with-icon mb-0\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.shipment_meta.permission[2]\" \nng-click=\"vm.fnOpenEditShipment(vm.shipment_meta,$event)\"><md-icon class=\"mr-5 s14 m-0\" md-font-icon=\"icon-pencil\">\n</md-icon>Edit</md-button></div></div></div><div flex=\"100\" layout-xs=\"column\" layout=\"row\"><md-card flex=\"100\" \nflex-sm=\"100\" flex-xs=\"100\" class=\"brad-4 m-0\"><md-card-content class=\"pv-0 ph-15\"><div layout=\"row\" layout-padding \nlayout-wrap class=\"ph-0 pv-10\"><div class=\"max-width-200\"><div class=\"heading\">Origin</div><div \nclass=\"sub-heading text-truncate\" title=\"{{vm.shipment_meta.pickup_address.location_string}}\" \nng-bind=\"vm.shipment_meta.pickup_address.location_string\"></div></div><div class=\"max-width-200\"><div class=\"heading\">\nDestination</div><div class=\"sub-heading text-truncate\" title=\"{{vm.shipment_meta.delivery_address.location_string}}\" \nng-bind=\"vm.shipment_meta.delivery_address.location_string\"></div></div><div class=\"max-width-200\"><div \nclass=\"heading\">Load Details</div><span ng-show=\"vm.loadShimmer\" shimmer-effect-full width=\"100%\" height=\"15px\" \nclass=\"inline-block\"></span><div class=\"sub-heading text-truncate\" ng-if=\"!vm.loadShimmer\" ng-bind=\"vm.loadDispaly\">\n</div><md-tooltip ng-if=\"vm.shipment_meta.load_data.load_meta\" md-direction=\"top\" class=\"font-size-12 tooltip-height\">\n<div compile-html=\"vm.loadTooltip\"></div></md-tooltip></div><div class=\"max-width-200\" \nng-if=\"vm.shipment_meta.mode === \'SEA-FCL\'\"><div class=\"heading\">Origin Service Mode</div><div \nclass=\"sub-heading text-truncate\" \ntitle=\"{{vm.shipment_meta.origin_service_mode ? vm.shipment_meta.origin_service_mode : \'-\'}}\" \nng-bind=\"vm.shipment_meta.origin_service_mode ? vm.shipment_meta.origin_service_mode : \'-\'\"></div></div><div \nclass=\"max-width-200\" ng-if=\"vm.shipment_meta.mode === \'SEA-FCL\'\"><div class=\"heading\">Destination Service Mode</div>\n<div class=\"sub-heading text-truncate\" \ntitle=\"{{vm.shipment_meta.destination_service_mode ? vm.shipment_meta.destination_service_mode : \'-\'}}\" \nng-bind=\"vm.shipment_meta.destination_service_mode ? vm.shipment_meta.destination_service_mode : \'-\'\"></div></div><div \nclass=\"max-width-100\"><div class=\"heading\">Incoterms</div><div layout=\"row\" class=\"sub-heading\"><div \ntitle=\"{{ vm.shipment_meta.incoterm ? vm.shipment_meta.incoterm : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.incoterm ? vm.shipment_meta.incoterm : \'N/A\'\"></div><div \nng-if=\"vm.shipment_meta.impo_expo && vm.shipment_meta.incoterm\">- {{vm.shipment_meta.impo_expo}}</div></div></div><div \nclass=\"max-width-100\" ng-if=\"!vm.maskLiner && !vm.sharedMaskLiner\"><div class=\"heading\" \nng-bind=\"vm.shipment_meta.mode != \'AIR\' ? \'Carrier Name\' : \'Airline Name\'\"></div><div \nng-if=\"vm.shipment_meta.mode != \'AIR\'\" class=\"sub-heading text-truncate\" \ntitle=\"{{ vm.shipment_meta.carrier_info.name ? vm.shipment_meta.carrier_info.name : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.carrier_info.name ? vm.shipment_meta.carrier_info.name : \'N/A\'\"></div><div \nng-if=\"vm.shipment_meta.mode == \'AIR\'\" class=\"sub-heading text-truncate\" \ntitle=\"{{ vm.shipment_meta.airline.name ? vm.shipment_meta.airline.name : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.airline.name ? vm.shipment_meta.airline.name : \'N/A\'\"></div></div><div class=\"max-width-100\">\n<div class=\"heading\" ng-bind=\"vm.shipment_meta.mode != \'AIR\' ? \'Voyage\' : \'Flight Number\'\"></div><div \nclass=\"sub-heading text-truncate\" \ntitle=\"{{ vm.shipment_meta.carrier_info.voyage ?  vm.shipment_meta.carrier_info.voyage : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.carrier_info.voyage ?  vm.shipment_meta.carrier_info.voyage : \'N/A\'\"></div></div><div><div \nclass=\"heading\">Rollable</div><div class=\"sub-heading\" \ntitle=\"{{ vm.shipment_meta.rollable_available ? \'Yes\' : \'No\' }}\" \nng-bind=\"vm.shipment_meta.rollable_available ? \'Yes\' : \'No\'\"></div></div><div class=\"max-width-100\"><div \nclass=\"heading\">Sailing Date</div><div class=\"sub-heading text-truncate\" \ntitle=\"{{ vm.shipment_meta.departure_date ? (vm.shipment_meta.departure_date | NoTimeZone : \'d MMM yyyy\') : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.departure_date ? (vm.shipment_meta.departure_date | NoTimeZone : \'d MMM yyyy\') : \'N/A\'\">\n</div></div><div class=\"max-width-100\"><div class=\"heading\">Delivery Date</div><div class=\"sub-heading text-truncate\" \ntitle=\"{{ vm.shipment_meta.arrival_date ? (vm.shipment_meta.arrival_date | NoTimeZone : \'d MMM yyyy\') : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.arrival_date ? (vm.shipment_meta.arrival_date | NoTimeZone : \'d MMM yyyy\') : \'N/A\'\"></div>\n</div><div class=\"max-width-120\" ng-if=\"vm.shipment_meta.co2eData\"><div class=\"heading\"><md-icon \nmd-svg-src=\"assets/icons/custom/co2-icon.svg\" class=\"icon-class-10 mr-5\"></md-icon>CO<sub>2</sub> emission</div><span \nng-show=\"vm.spinRefreshIcon\" shimmer-effect-full width=\"100%\" height=\"15px\" class=\"inline-block\"></span><div \nng-if=\"!vm.spinRefreshIcon\" class=\"sub-heading line-height-12\" layout=\"row\"><div class=\"text-truncate\">\n{{(vm.shipment_meta.co2eData.co2e.total | currencyMask: 2) +\' \' +\'g\'}}</div><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer co2e-{{vm.shipment_meta.shipment_id}}\" \nng-click=\"vm.shareQuoteService.showCo2ContainerData($event, vm.shipment_meta.shipment_id,vm.shipment_meta.co2eData)\">\n</md-icon></div></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"ph-0 pv-10\"><div layout=\"row\" layout-padding layout-wrap flex class=\"ph-0 pv-0\"><div class=\"max-width-150\"><div \nclass=\"heading\">Customer</div><div class=\"text-truncate sub-heading\" ng-if=\"vm.shipperList.length>0\">\n{{vm.shipperList[0]}} <span class=\"font-size-11\">{{ vm.shipperListCompany[0] }}</span> <span \nng-show=\"vm.shipperList.length>1\">, {{vm.shipperList[1]}}</span><span ng-show=\"vm.shipperList.length>2\">\n +{{vm.shipperList.length-2}} more</span><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg black-fg font-size-14\" style=\"height: fit-content\"><span \nng-repeat=\"shipper in vm.shipperList track by $index\"><span ng-bind=\"shipper\"></span> <span class=\"font-size-11\">\n{{vm.shipperListCompany[$index]}}</span><br></span></md-tooltip></div><div class=\"sub-heading pointer md-link-fg\" \nng-if=\"vm.shipperList==\'\'\" ng-click=\"vm.fnAddParty(\'\',\'\',\'Add\',\'shipper\')\">Add Customer Name</div></div><div \nclass=\"max-width-150\"><div class=\"heading\">External Reference</div><div class=\"text-truncate sub-heading\" \nng-if=\"vm.shipperList.length>0\"><span class=\"font-size-11\">{{ vm.shipperReferenceCompany[0] }}</span></div></div><div \nclass=\"max-width-150\"><div class=\"heading\">Consignee Name</div><div class=\"sub-heading text-truncate\" \nng-if=\"vm.consigneesList.length>0\">{{vm.consigneesList[0]}}<span ng-show=\"vm.consigneesList.length>1\">\n, {{vm.consigneesList[1]}}</span><span ng-show=\"vm.consigneesList.length>2\"> +{{vm.consigneesList.length-2}} more\n</span><md-tooltip md-direction=\"Bottom\" class=\"md-whiteframe-2dp white-bg black-fg font-size-14\" \nstyle=\"height: fit-content\"><span ng-repeat=\"consignee in vm.consigneesList track by $index\"><span ng-bind=\"consignee\">\n</span><br></span></md-tooltip></div><div class=\"sub-heading pointer md-link-fg\" ng-if=\"vm.consigneesList==\'\'\" \nng-click=\"vm.fnAddParty(\'\',\'\',\'Add\',\'consignee\')\">Add Consignee Name</div></div><div class=\"max-width-150\"><div \nclass=\"heading\">Booking Specialist</div><div class=\"sub-heading text-truncate\" ng-if=\"vm.ShipmentExpert\" \nng-bind=\"vm.ShipmentExpert.name\"><md-tooltip md-direction=\"Bottom\" \nclass=\"md-whiteframe-2dp white-bg black-fg h-90 p-10\" style=\"width:fit-content\"><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" layout-align=\"center center\" flex><img class=\"w-50 h-50 avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><div layout=\"column\" flex=\"70\" class=\"pl-10 pr-20 pt-5\"><span flex=\"35\" \nclass=\"font-weight-600 font-size-14\" ng-bind=\"(vm.ShipmentExpert.name==null)? \'N/A\' : vm.ShipmentExpert.name\"></span> \n<span flex=\"30\" class=\"grey-500-fg font-size-14\" \nng-bind=\"(vm.ShipmentExpert.email==null)? \'N/A\' : vm.ShipmentExpert.email\"></span> <span flex=\"30\" \nclass=\"grey-500-fg font-size-14\" ng-bind=\"(vm.ShipmentExpert.contact==null)? \'N/A\' : vm.ShipmentExpert.contact\"></span>\n</div></div></md-tooltip></div><div class=\"sub-heading\" \nng-if=\"(!vm.ShipmentExpert) || (vm.shipment_meta.management.length==0) || vm.ShipmentExpert.name==null\">N/A</div></div>\n<div class=\"max-width-150\"><div class=\"heading\">Document Expert</div><div class=\"sub-heading text-truncate\" \nng-if=\"vm.documentExpert\" ng-bind=\"vm.documentExpert.name==\'\' ? \'N/A\' : vm.documentExpert.name\"><md-tooltip \nmd-direction=\"Bottom\" class=\"md-whiteframe-2dp white-bg black-fg h-90 p-10\" style=\"width:fit-content\"><div \nlayout=\"row\" flex=\"100\"><div layout=\"column\" layout-align=\"center center\" flex><img class=\"w-50 h-50 avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><div layout=\"column\" flex=\"70\" class=\"pl-10 pr-20 pt-5\"><span flex=\"35\" \nclass=\"font-weight-600 font-size-14\" ng-bind=\"(vm.documentExpert.name==null)? \'N/A\' : vm.documentExpert.name\"></span> \n<span flex=\"30\" class=\"grey-500-fg font-size-14\" \nng-bind=\"(vm.documentExpert.email==null)? \'N/A\' : vm.documentExpert.email\"></span> <span flex=\"30\" \nclass=\"grey-500-fg font-size-14\" ng-bind=\"(vm.documentExpert.contact==null)? \'N/A\' : vm.documentExpert.contact\"></span>\n</div></div></md-tooltip></div><div class=\"sub-heading\" \nng-if=\"(!vm.documentExpert) || (vm.shipment_meta.management.length==0)|| vm.documentExpert.name==null\">N/A</div></div>\n<div><div class=\"heading\">Mode</div><div class=\"sub-heading\" title=\"{{vm.shipment_meta.mode}}\" \nng-bind=\"vm.shipment_meta.mode\"></div></div><div class=\"max-width-120\"><div class=\"heading\">Commodity</div><div \nclass=\"text-truncate sub-heading\" title=\"{{vm.shipment_meta.commodity ? vm.shipment_meta.commodity.name : \'N/A\'}}\" \nng-bind=\"vm.shipment_meta.commodity ? vm.shipment_meta.commodity.name : \'N/A\'\"></div></div><div class=\"max-width-120\">\n<div class=\"heading\">Created By</div><div class=\"text-truncate sub-heading\" \ntitle=\"{{vm.shipment_meta.created_by ? vm.shipment_meta.created_by.user_first_name + \' \' + vm.shipment_meta.created_by.user_last_name : \'N/A\'}}\" \nng-bind=\"vm.shipment_meta.created_by ? vm.shipment_meta.created_by.user_first_name + \' \' + vm.shipment_meta.created_by.user_last_name : \'N/A\'\">\n</div></div></div><div layout=\"row\" flex class=\"w-70\" ng-if=\"vm.shipment_meta.documents.length>0\"><div \nclass=\"attachment-sect sub-heading ph-10\"><md-icon md-font-icon=\"icon-attachment\" class=\"attachment-icon s16\">\n</md-icon>{{vm.shipment_meta.documents.length}}</div></div></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/shipments/tabs/billinginfo/billinginfo.html","<div id=\"shipment-billing-info\" class=\"custom_scroll\"><div layout=\"column\" class=\"pv-15\"><div layout=\"row\" layout-wrap>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"60\" layout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"!vm.getInvoiceData\"></md-card><md-card ng-if=\"(vm.permission.rate[1])\" ng-show=\"vm.getInvoiceData\">\n<md-card-content class=\"ph-20 pt-5\" layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" \nlayout=\"column\" class=\"pv-10 border-bottom\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"70\" \nlayout-wrap><div class=\"font-size-16 font-weight-600\">BILLING INFO</div><md-button class=\"md-accent-btn with-icon\" \nng-if=\"vm.permission.rate[0] && !vm.util.isShipper\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.fnAddOrEditCard()\"><md-icon class=\"mr-5 s14 ml-0\" md-font-icon=\"icon-pencil\"></md-icon>\n{{vm.ratePopupAction}}</md-button></div></div><div flex=\"100\" layout=\"column\" class=\"font-size-14 border-radius mt-20\" \nng-class=\"{\'border\': !(vm.all_in_quote_setting == \'all_in_total\' && vm.userData.type.user_category == \'SHIPPER\' ) }\" \nng-if=\"(vm.bill_rates.length)\"><billing-info-charges bill-rates=\"vm.bill_rates\" source-data=\"vm.sourceData\" \nis-own-vendor-rate=\"vm.isOwnVendorRate\" ng-if=\"vm.bill_rates.length\" all-in-quote-setting=\"vm.all_in_quote_setting\" \nuser-data=\"vm.userData\" mode=\"vm.ShipmentsDetails.mode\"></billing-info-charges></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"!vm.bill_rates.length\">Sorry, No Rates Available.</div></md-card-content></md-card><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-20 font-size-16 text-italic\" layout-padding ng-if=\"!vm.permission.rate[1]\">\nYou don\'t have permission to access this section.</div></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"40\" \nlayout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\"></md-card><md-card \nng-if=\"(vm.permission.invoice[1])\" ng-show=\"vm.getData\"><md-card-content class=\"pv-5\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" \nclass=\"font-size-16 font-weight-600 pv-10 border-bottom\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><div class=\"font-size-16 font-weight-600\">INVOICE</div><div class=\"font-size-14\" \nng-if=\"(vm.invoiceData!=null)&&(vm.permission.invoice[2])\"><md-icon class=\"icon-16 cursor\" title=\"Edit\" \nmd-svg-src=\"assets/icons/custom/edit-icon.svg\" ng-click=\"vm.editInvoiceDetail(vm.invoiceData,$event)\"></md-icon></div>\n</div></div><div flex=\"100\" layout=\"column\"><div class=\"pt-10 ph-0\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"pv-10 font-size-14\">Invoice Date : <span class=\"ml-5\">\n{{((vm.invoiceData.created_date==null)||(vm.invoiceData.length==0)) ? \"N/A\" : (vm.invoiceData.created_date | UTCToLocal : \'d LLLL yyyy\')}}\n</span></div><div layout=\"row\" layout-align=\"start center\" class=\"pv-10 font-size-14\">Credit (In days): <span \nclass=\"ml-5\">{{(((vm.invoiceData.credit == null)||(vm.invoiceData.length==0)) ? \"N/A\" : vm.invoiceData.credit)}}</span>\n</div><div layout=\"row\" layout-align=\"start center\" class=\"pv-10 font-size-14\">Payment Due Date : <span class=\"ml-5\">\n{{(((vm.invoiceData.due_date==null)||(vm.invoiceData.length==0)) ? \"N/A\" : (vm.invoiceData.due_date | UTCToLocal : \'d LLLL yyyy\'))}}\n</span></div><div layout=\"row\" layout-align=\"start center\" class=\"pv-10 font-size-14\">Invoice Amount : <span \nclass=\"ml-5\">{{(((vm.invoiceData.amount == null)||(vm.invoiceData.length==0)) ? \"N/A\" : vm.invoiceData.amount)}}</span>\n</div><div class=\"uplodeTable pv-10\" ng-if=\"vm.invoiceData.name != null\"><table class=\"simple view_table\" \nms-responsive-table><tbody><tr class=\"h-50\"><td class=\"file_name\"><div layout=\"row\" flex=\"50\"><md-icon \nclass=\"mr-15 w-35 h-35\" md-svg-src=\"assets/icons/custom/pdf-icon-color.svg\"></md-icon><span \nng-class=\"{\'text-truncate\' : vm.util.isMobileDevice}\">\n{{(((vm.invoiceData.name == null)||(vm.invoiceData.length==0))? \'N/A\':vm.invoiceData.name)}}<br><span class=\"opacity\">\n{{(((vm.invoiceData.size == null)||(vm.invoiceData.length==0))?\'N/A\': vm.invoiceData.size)}}</span></span></div></td>\n<td class=\"text-right\"><md-icon class=\"file_icon mr-15 cursor\" ng-if=\"vm.permission.invoice[3]\" \nng-click=\"vm.deleteInvoiceFile(vm.invoiceData,$event)\" title=\"Delete\" md-svg-src=\"assets/icons/custom/delete-icon.svg\">\n</md-icon><a ng-href=\"{{vm.util.sanitizeQueryParams(vm.invoiceData.url)}}\" download target=\"_blank\" rel=\"noopener\" \nng-if=\"(vm.invoiceData.name != null)||(vm.invoiceData!=null)\"><md-icon class=\"file_icon mr-15 cursor\" title=\"Download\" \nmd-svg-src=\"assets/icons/custom/download-icon.svg\"></md-icon></a></td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\" class=\"font-size-16 text-italic pv-15 b brad-5 mb-10\" \nng-if=\"vm.invoiceData.name == null\">No Invoice available</div><div layout=\"row\" layout-align=\"center center\" \nclass=\"m-0 p-5\" ng-if=\"(!vm.invoiceData)&&(vm.permission.invoice[0])\"><md-button md-no-ink class=\"md-accent-btn\" \nng-click=\"vm.uploadInvoiceModal($event)\">+ Add Invoice</md-button></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"pb-20 font-size-14\" ng-show=\"$root.domainData.domain_info.TERMS_AND_CONDTION.length > 0\"><a \nclass=\"cursor md-link-fg\" ng-href=\"{{vm.util.sanitizeQueryParams($root.domainData.domain_info.TERMS_AND_CONDTION)}}\" \ntarget=\"_blank\" rel=\"noopener\">Terms & Conditions</a></div></div></div></md-card-content></md-card><md-card hide>\n<md-card-content class=\"pv-10\" layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" \nclass=\"font-size-16 font-weight-600 pv-10 border-bottom\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><div class=\"font-size-16 font-weight-600\">REMARKS</div><div class=\"font-size-14\"><md-icon \nclass=\"icon-16 cursor\" title=\"Edit Remarks\" ng-click=\"vm.fnOpenRemarkModal($event)\" \nmd-svg-src=\"assets/icons/custom/edit-icon.svg\"></md-icon></div></div></div><div flex=\"100\" layout=\"column\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"font-size-14\"><ol class=\"pv-0 ph-10 m-10\"><li class=\"pv-10\">\nLorem ipsum sit amet dolor lorem ipsum sit amet dolor lorem ipsum sit amet dolor</li><li class=\"pv-10\">\nLorem ipsum sit amet dolor lorem ipsum sit amet dolor lorem ipsum sit amet dolor</li></ol></div></div>\n</md-card-content></md-card></div></div></div></div>");
$templateCache.put("app/main/shipments/tabs/carrierbillinginfo/carrierbillinginfo.html","<div id=\"carrier-billing-info\" class=\"custom_scroll\"><div layout=\"column\" class=\"pv-15\"><div layout=\"row\" layout-wrap>\n<div layout=\"column\" flex=\"100\" layout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" \nng-if=\"!vm.getCarrierData\"></md-card><md-card ng-if=\"(vm.permission.carrier_billing[1] && vm.getCarrierData)\">\n<md-card-content layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" \nclass=\"pv-10 border-bottom\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"70\" layout-wrap><div \nclass=\"font-size-16 font-weight-600 fg-333333 pl-20\">CARRIER BILLING INFO</div></div></div><div flex=\"100\" \nlayout=\"column\" ng-if=\"vm.bill_rates.legs.length\"><div layout=\"row\" layout-wrap class=\"pt-10\"><charges-display \nflex=\"100\" charges-data=\"vm.bill_rates.legs\" mode=\"vm.ShipmentsDetails.mode\"></charges-display><div layout=\"row\" \nlayout-wrap flex=\"100\" class=\"mt-10\"><div layout=\"row\" flex=\"70\" flex-gt-xs=\"70\"><div class=\"pl-10 pt-2 font-size-11\">\n<div ng-if=\"vm.showExchangeRates\"><a class=\"pointer md-link-fg Font-Bold\" \nng-click=\"vm.util.redirectToExchangeRatesLink(\'Shipment\',ShipmentService.shipmentManagementObj.shipment_meta._id, vm.cardVendorId, \'SD-CBInfo-ViewExchangeRates\')\">\nView Exchange Rates<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s16 ml-5\"></md-icon></a></div></div>\n</div><div layout=\"row\" layout-align=\"end center\" flex=\"30\" flex-gt-xs=\"30\"><div \nclass=\"fg-333333 padding-carrier-info-table\"><span class=\"font-size-11\">Total</span>&nbsp; <span class=\"Font-Bold s13\">\n{{vm.bill_rates.card_total.currency + \' \' + (vm.bill_rates.card_total.cost | currencyMask: 2) }}</span></div></div>\n</div></div></div><div layout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"mv-10 font-size-16 text-italic\" \nlayout-padding ng-if=\"!vm.bill_rates.legs\">Sorry,No rates are available.</div></md-card-content></md-card><div \nlayout=\"column\" layout-align=\"center center\" class=\"mt-20 font-size-16 text-italic\" layout-padding \nng-if=\"!vm.permission.carrier_billing[1]\">You don\'t have permission to access this section.</div></div></div></div>\n</div>");
$templateCache.put("app/main/shipments/tabs/contact/contact.html","<div id=\"shipment-management\"><div layout=\"column\" class=\"pv-15\"><div layout=\"row\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"33\" layout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\">\n</md-card><md-card ng-if=\"vm.permission.source[1]\" ng-show=\"vm.getData\"><md-card-content class=\"ph-20 pt-5\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" class=\"pv-10 border-bottom\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"33\" layout-wrap><div class=\"font-size-16 font-weight-600\">SOURCE\n</div></div></div><div class=\"mt-20 font-size-14\" flex=\"100\" layout=\"column\" ng-if=\"vm.sourceData\"><div class=\"mb-15\">\n<b>Rate Provider : </b><span class=\"pl-5\" ng-class=\"{\'grey-fg\' : !vm.sourceData.rate_provider.vendor.vendor_name}\">\n{{(((vm.sourceData.rate_provider.vendor.vendor_name==\"\") || (vm.sourceData.rate_provider.vendor.vendor_name==null)) ? \'N/A\' : vm.sourceData.rate_provider.vendor.vendor_name)}}\n</span></div><div class=\"mb-15\"><b>Contact : </b><span class=\"pl-5\" ng-class=\"{\'grey-fg\' : !vm.sourceData.contact}\">\n{{(((vm.sourceData.contact==\"\") || (vm.sourceData.contact==null)) ? \'N/A\' : vm.sourceData.contact)}}</span></div><div \nclass=\"mb-10\"><b>Email : </b><span class=\"pl-5\" ng-class=\"{\'grey-fg\' : !vm.sourceData.email}\">\n{{(((vm.sourceData.email==\"\") || (vm.sourceData.email==null)) ? \'N/A\' : vm.sourceData.email)}}</span></div></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"!vm.sourceData\">sorry, Source Data Not Available.</div></md-card-content></md-card></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"33\" layout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\">\n</md-card><md-card ng-if=\"vm.permission.management[1]\" ng-show=\"vm.getData\"><md-card-content class=\"pv-5\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" \nclass=\"font-size-16 font-weight-600 pv-10 border-bottom\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><div class=\"font-size-16 font-weight-600\">MANAGEMENT</div><div class=\"font-size-14\" \nng-if=\"vm.permission.management[2]\"><md-icon class=\"icon-16 cursor\" title=\"Edit\" \nmd-svg-src=\"assets/icons/custom/edit-icon.svg\" \nng-click=\"vm.fnOpenEditdeatils(vm.shipperExpert,vm.documentExpert,vm.customerExpert,$event)\"></md-icon></div></div>\n</div><div flex=\"100\" layout=\"column\" ng-if=\"vm.managementData\"><div class=\"pv-10 ph-0\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"pv-10 font-size-14 font-weight-600\">Booking Specialist</div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pt-5 pb-10 font-size-14\" ng-class=\"{\'grey-fg\' : !vm.shipperExpert.name}\"><span>\n{{(vm.shipperExpert.name==null)?\'N/A\' : vm.shipperExpert.name}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pv-10 font-size-14 font-weight-600\">Documentation Expert</div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pt-5 pb-10 font-size-14\" ng-class=\"{\'grey-fg\' : !vm.documentExpert.name}\"><span>\n{{(vm.documentExpert.name==null)?\'N/A\' : vm.documentExpert.name}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pv-10 font-size-14 font-weight-600\">Forwarder/Customer Success Manager</div><div \nlayout=\"row\" layout-align=\"start center\" class=\"pt-5 pb-10 font-size-14\" \nng-class=\"{\'grey-fg\' : !vm.customerExpert.name}\"><span>\n{{(vm.customerExpert.name==null)?\'N/A\' : vm.customerExpert.name}}</span></div></div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" layout-padding ng-if=\"!vm.managementData\">\nsorry, Management Data Not Available.</div></md-card-content></md-card></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"33\" layout-wrap><md-card><md-card-content class=\"pv-10\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div flex=\"100\" layout=\"column\" class=\"font-size-16 font-weight-600 pv-10 border-bottom\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"font-size-16 font-weight-600\">AGENT DETAILS</div></div>\n</div><div flex=\"100\" layout=\"column\" class=\"font-size-14 pt-10\"><div layout=\"row\" layout-align=\"start center\" \nflex=\"70\" layout-wrap><div layout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"33\" class=\"text-truncate\">\n<div class=\"font-weight-600 pv-10\">Agent Name</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.agent_name}\" \ntitle=\"{{vm.sourceData.agent.agent_name}}\">\n{{(((vm.sourceData.agent.agent_name==\"\") || (vm.sourceData.agent.agent_name==null)) ? \'N/A\' : vm.sourceData.agent.agent_name)}}\n</div></div><div layout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"33\" class=\"text-truncate\"><div \nclass=\"font-weight-600 pv-10\">Agent Type</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.agent_type}\" \ntitle=\"{{vm.sourceData.agent.agent_type}}\">\n{{(((vm.sourceData.agent.agent_type==\"\") || (vm.sourceData.agent.agent_type==null)) ? \'N/A\' : vm.sourceData.agent.agent_type)}}\n</div></div><div layout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"33\" class=\"text-truncate\"><div \nclass=\"font-weight-600 pv-10\">Mobile</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.mobile}\" \ntitle=\"{{vm.sourceData.agent.mobile}}\">\n{{(((vm.sourceData.agent.mobile==\"\") || (vm.sourceData.agent.mobile==null)) ? \'N/A\' : vm.sourceData.agent.mobile)}}\n</div></div></div><div class=\"pt-10\" layout=\"row\" layout-align=\"start center\" flex=\"70\" layout-wrap><div \nlayout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"33\" class=\"text-truncate\"><div \nclass=\"font-weight-600 pv-10\">Phone</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.phone}\" \ntitle=\"{{vm.sourceData.agent.phone}}\">\n{{(((vm.sourceData.agent.phone==\"\") || (vm.sourceData.agent.phone==null)) ? \'N/A\' : vm.sourceData.agent.phone)}}</div>\n</div><div layout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"33\" class=\"text-truncate\"><div \nclass=\"font-weight-600 pv-10\">Email</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.email}\" \ntitle=\"{{vm.sourceData.agent.email}}\">\n{{(((vm.sourceData.agent.email==\"\") || (vm.sourceData.agent.email==null)) ? \'N/A\' : vm.sourceData.agent.email)}}</div>\n</div><div layout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"33\" class=\"text-truncate\"><div \nclass=\"font-weight-600 pv-10\">Contact Person</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.contact_person}\" \ntitle=\"{{vm.sourceData.agent.contact_person}}\">\n{{(((vm.sourceData.agent.contact_person==\"\") || (vm.sourceData.agent.contact_person==null)) ? \'N/A\' : vm.sourceData.agent.contact_person)}}\n</div></div></div><div class=\"pt-10\" layout=\"row\" layout-align=\"start center\" flex=\"70\" layout-wrap><div \nlayout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"33\" class=\"text-truncate\"><div \nclass=\"font-weight-600 pv-10\">City</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.city}\" \ntitle=\"{{vm.sourceData.agent.city}}\">\n{{(((vm.sourceData.agent.city==\"\") || (vm.sourceData.agent.city==null)) ? \'N/A\' : vm.sourceData.agent.city)}}</div>\n</div><div layout=\"column\" layout-align=\"start start\" flex class=\"text-truncate\"><div class=\"font-weight-600 pv-10\">\nCountry</div><div ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.country}\" title=\"{{vm.sourceData.agent.country}}\">\n{{(((vm.sourceData.agent.country==\"\") || (vm.sourceData.agent.country==null)) ? \'N/A\' : vm.sourceData.agent.country)}}\n</div></div></div><div layout=\"row\" class=\"pt-20\" flex=\"100\" layout-wrap><div layout=\"column\" \nlayout-align=\"start start\" class=\"text-truncate\"><div class=\"font-weight-600 pv-10\">Address</div><div \nclass=\"word-wrap\" ng-class=\"{\'grey-fg\' : !vm.sourceData.agent.address}\">\n{{(((vm.sourceData.agent.address==\"\") || (vm.sourceData.agent.address==null)) ? \'N/A\' : vm.sourceData.agent.address)}}\n</div></div></div></div></md-card-content></md-card></div></div></div></div>");
$templateCache.put("app/main/shipments/tabs/containers/containers.html","<div ng-if=\"!dataErr\" id=\"shipment-containers\"><div layout=\"column\" class=\"pv-15\"><div layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" layout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"!vm.getData\"></md-card><md-card ng-show=\"vm.getData\"><md-card-content \nng-if=\"vm.containerList.length!==0 && vm.containerList.length!==undefined\" class=\"ph-20 pt-5\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" class=\"pv-10 border-bottom\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"70\" layout-wrap><div class=\"font-size-16 font-weight-600\">CONTAINERS</div>\n</div></div><div flex=\"100\" flex-gt-xs=\"100\" layout=\"column\" class=\"font-size-14 mt-20\"><div class=\"\"><table \nclass=\"view_table\" ms-responsive-table><thead><tr><th class=\"file_heading pr-20\">Sr No.</th><th class=\"file_heading\">\nType</th><th class=\"file_heading\">Container Number</th><th class=\"file_heading\">Seal Number</th><th \nclass=\"file_heading\">MBL Number</th><th class=\"file_heading\">HBL Number</th><th class=\"file_heading\">\nEmpty Container Pickup</th><th class=\"file_heading\">Empty Container Dropoff</th><th class=\"file_heading\">Company</th>\n</tr></thead><tbody><tr ng-repeat=\"data in vm.containerList track by $index\"><td \nclass=\"file_name font-weight-600 ph-15\">{{$index + 1}}</td><td class=\"file_name\"><md-input-container md-no-float \nclass=\"m-0 h-40 font-size-14\"><input name=\"share\" class=\"border-radius-2 input-disabled\" disabled=\"disabled\" \nplaceholder=\"\" ng-model=\"data.container_type\" ng-value=\"data.container_type\"></md-input-container></td><td \nclass=\"file_name\"><md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input name=\"share\" \nclass=\"border-radius-2\" ng-disabled=\"!vm.permission[2]\" ng-class=\"{\'input-disabled\':!vm.permission[2]}\" placeholder=\"\" \nng-model=\"data.container_number\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-value=\"data.container_number\"></md-input-container></td><td class=\"file_name\"><md-input-container md-no-float \nclass=\"m-0 h-40 font-size-14\"><input name=\"share\" class=\"border-radius-2\" ng-disabled=\"!vm.permission[2]\" \nng-class=\"{\'input-disabled\':!vm.permission[2]}\" placeholder=\"\" ng-model=\"data.seal_number\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-value=\"data.seal_number\"></md-input-container></td><td class=\"file_name\"><md-input-container md-no-float \nclass=\"m-0 h-40 font-size-14\"><input name=\"share\" class=\"border-radius-2\" ng-disabled=\"!vm.permission[2]\" \nng-class=\"{\'input-disabled\':!vm.permission[2]}\" placeholder=\"\" ng-model=\"data.bl_number\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-value=\"data.bl_number\"></md-input-container></td><td class=\"file_name\"><md-input-container md-no-float \nclass=\"m-0 h-40 font-size-14\"><input name=\"share\" class=\"border-radius-2\" ng-disabled=\"!vm.permission[2]\" \nng-class=\"{\'input-disabled\':!vm.permission[2]}\" placeholder=\"\" ng-model=\"data.tare_weight\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-value=\"data.tare_weight\"></md-input-container></td><td class=\"file_name\"><md-input-container md-no-float \nclass=\"m-0 h-40 font-size-14\"><input name=\"share\" class=\"border-radius-2\" ng-disabled=\"!vm.permission[2]\" \nng-class=\"{\'input-disabled\':!vm.permission[2]}\" placeholder=\"\" ng-model=\"data.empty_container_pickup\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-value=\"data.empty_container_pickup\"></md-input-container></td><td class=\"file_name\"><md-input-container md-no-float \nclass=\"m-0 h-40 font-size-14\"><input name=\"share\" class=\"border-radius-2\" ng-disabled=\"!vm.permission[2]\" \nng-class=\"{\'input-disabled\':!vm.permission[2]}\" placeholder=\"\" ng-model=\"data.empty_conatiner_drop_off\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-value=\"data.empty_conatiner_drop_off\"></md-input-container></td><td class=\"file_name\"><md-input-container \nmd-no-float class=\"m-0 h-40 font-size-14\"><input name=\"share\" class=\"border-radius-2\" ng-disabled=\"!vm.permission[2]\" \nng-class=\"{\'input-disabled\':!vm.permission[2]}\" placeholder=\"\" ng-model=\"data.company\" \nng-model-options=\"{updateOn: \'default blur onchange\',debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }}\" \nng-value=\"data.company\"></md-input-container></td></tr></tbody></table></div></div><div flex=\"100\" layout=\"column\" \nclass=\"pv-10\" hide><div layout=\"row\" layout-align=\"center center\" flex=\"100\" layout-wrap><div \nclass=\"font-size-14 green-fg\"><md-icon md-font-icon=\"icon-plus-circle icon-20 green-fg\" \nng-click=\"vm.trackEvent(\'SD-AddContainer-Click\')\" class=\"mr-5\"></md-icon><span>Add Container</span></div></div></div>\n<div ng-if=\"vm.containerList.length!==0 && vm.containerList.length!==undefined && vm.permission[2]\" flex=\"100\" \nlayout=\"column\" class=\"pv-10\"><div layout=\"row\" layout-align=\"end center\" flex=\"100\" layout-wrap><md-button md-no-ink \nng-disabled=\"vm.disableSaveButton\" ng-click=\"vm.updateContainer()\" class=\"md-accent-btn\" title=\"Save\">Save</md-button>\n</div></div></md-card-content><md-card-content \nng-if=\"vm.containerList.length==0 || vm.containerList.length==undefined\" class=\"ph-20 pt-5\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><h2>No data available!</h2></md-card-content></md-card></div></div></div>\n</div><div ng-if=\"dataErr\"><div class=\"no-data\">No data available!</div></div>");
$templateCache.put("app/main/shipments/tabs/documents/documents.html","<div ng-if=\"!dataErr\" id=\"shipment-documents\"><div layout=\"column\" class=\"pv-15\"><div layout=\"row\" layout-wrap><div \nng-if=\"vm.permission[0]\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" layout-wrap><md-card shimmer-effect width=\"100%\" \nheight=\"100%\" ng-show=\"!vm.getData\"></md-card><md-card ng-show=\"vm.getData\"><md-card-content class=\"ph-20 pt-5\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" class=\"pv-10 border-bottom mb-5\">\n<div layout=\"row\" layout-align=\"space-between center\" flex=\"70\" layout-wrap><div class=\"font-size-16 font-weight-600\">\nUPLOAD FILES</div></div></div><div flex=\"100\" flex-gt-xs=\"40\" layout=\"column\" class=\"font-size-14 browse\">\n<file-drag-and-drop file-type=\"vm.fileType\" file-size=\"vm.fileSize\" file-size-error-message=\"vm.fileSizeErrorMessage\" \nfile-type-error-messsage=\"vm.fileTypeErrorMesssage\" callback=\"vm.setFile(file)\" page-source=\"\'SD\'\">\n</file-drag-and-drop></div><div flex=\"100\" flex-gt-xs=\"30\" layout=\"column\" class=\"font-size-13 fg-333333 ph-20\"><div \nlayout=\"column\"><div layout=\"row\" class=\"pb-5\">Enter FileName<span class=\"red-fg\">*</span></div><md-input-container \nmd-no-float class=\"m-0\"><input ng-keyup=\"vm.checkFields()\" name=\"share\" ng-model=\"vm.file.name\" class=\"panel-selct\" \nplaceholder=\"Enter File Name\" ng-model-options=\"{ debounce: 500 }\" \nng-model-options=\"{\n                                        updateOn: \'default blur onchange\',\n                                        debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                      }\">\n</md-input-container></div><div layout=\"column\" class=\"selectType\"><div class=\"pb-20\" layout=\"column\" flex=\"100\"><div \nlayout=\"row\" class=\"pb-5\">File Type<span class=\"red-fg\">*</span></div><md-input-container md-no-float class=\"m-0\">\n<md-select ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.checkFields();\" ng-model=\"vm.file.type\" \ntitle=\"file type\" class=\"panel-selct\" placeholder=\"Select File Type\" \nng-model-options=\"{\n                                            updateOn: \'default blur onchange\',\n                                            debounce: { \'default\': 300, \'blur\': 0, \'onchange\': 700 }\n                                          }\">\n<md-option ng-repeat=\"type in vm.fileTypeList\" ng-value=\"type\">{{type}}</md-option></md-select></md-input-container>\n</div></div><div ng-class=\"{\'hidden\': vm.isShipper}\" layout=\"column\"><div layout=\"row\" class=\"pb-5\">Approval Required\n</div><div layout=\"row\" layout-align=\"start center\"><span class=\"pr-20 toggle-text\">No</span><md-switch md-no-ink \nng-model=\"vm.file.is_approval_required\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" aria-label=\"Switch 1\" class=\"mv-5\">\n</md-switch><span class=\"pl-20 toggle-text\">Yes</span></div></div></div><div flex=\"100\" flex-gt-xs=\"30\" \nlayout=\"column\" class=\"ph-20 pb-5 pt-25 commentSec\"><div><div layout=\"row\" class=\"pb-5\">Comments</div>\n<md-input-container md-no-float class=\"m-0 w-100p\"><textarea name=\"share\" ng-model=\"vm.file.comment\" \nng-model-options=\"{ debounce: 500 }\" class=\"panel-selct p-5 comment-textarea placeholder-style\" \nrows=\"{{vm.file.is_approval_required == \'0\' ? \'4\' : \'1\'}}\" placeholder=\"Enter Comments\"></textarea>\n</md-input-container></div><div class=\"pb-25\" layout=\"column\" flex=\"100\" \nng-class=\"{\'hidden\': vm.file.is_approval_required == \'0\'}\"><div layout=\"row\">Approval Deadline<span class=\"red-fg\">*\n</span></div><date-picker md-input-id=\"\'deadline_date\'\" \nis-validate=\"myForm.deadline_date.$touched && myForm.deadline_date.$error.required\" is-editable=\"true\" \nis-disabled=\"false\" full-border=\"false\" input-required=\"true\" input-name=\"\'deadline_date\'\" \ndate-placeholder=\"\'Enter Approval Deadline\'\" date-format=\"true\" min-date-value=\"vm.dateMin\" \nmodel-value=\"vm.file.approval_deadline\" callback=\"vm.file.approval_deadline=value;\"></date-picker><div \nng-messages=\"myForm.deadline_date.$touched && myForm.deadline_date.$error\" role=\"alert\"><div ng-message=\"valid\"><span>\nSelect Valid Date</span></div></div></div></div><div layout=\"column\" flex=\"100\" layout-align=\"end end\"><div \nng-show=\"vm.errMsg == true\" class=\"font-size-14 red-fg\">Don\'t leave the * fields empty</div><div \nng-show=\"vm.noFile == true\" class=\"font-size-14 red-fg\">Select a file to upload!</div><div \nng-show=\"vm.sameData == true\" class=\"font-size-14 red-fg\">Can\'t send same data again</div></div><div layout=\"column\" \nflex=\"100\"><div layout=\"row\" layout-align=\"end center\" class=\"pb-10\"><md-button md-no-ink \nclass=\"md-primary-btn mr-10 w-130\" ng-click=\"vm.resetInputs();\" title=\"Clear\">Clear</md-button><md-button md-no-ink \nng-disabled=\"vm.disableUploadButton\" class=\"md-accent-btn ml-10 w-130\" ng-click=\"vm.uploadFile(vm.picFile);\" \ntitle=\"Upload File\">Upload File</md-button></div></div></md-card-content></md-card></div><div \nng-if=\"vm.DocumentList.length!==0 && vm.DocumentList.length!==undefined\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nlayout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\"></md-card><md-card \nng-show=\"vm.getData \" style=\"width: 100%\"><md-card-content \nng-if=\"vm.DocumentList.length!==0 || vm.DocumentList.length!==undefined\" class=\"ph-20 pt-5\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"row\" class=\"pv-10 border-bottom\"><div flex=\"50\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"font-size-16 font-weight-600\">DOCUMENTS</div></div><div \nlayout=\"row\" layout-align=\"end center\" flex=\"50\"><div ng-if=\"vm.syncShimmer\"><div shimmer-effect-full width=\"140px\" \nheight=\"40px\" class=\"mt-4\"></div></div><div><quote-sync-button \nintegrationoptions=\"vm.uiData.integrationComponentOptions\" callback=\"vm.syncData(submenus  )\"></quote-sync-button>\n</div><md-button md-no-ink class=\"md-accent-btn mb-0\" ng-disabled=\"vm.disabledDownloadAllBtn\" \nng-click=\"vm.downloadAllFile(data.location);\" ng-if=\"!vm.isShareable\">Download all</md-button></div></div><div \nclass=\"bg-535353 ph-40\" id=\"shared-footer-quote\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\" ng-if=\"vm.documentSelection\"><div layout=\"row\" layout-align=\"start center\" \nflex-xs=\"100\" flex-sm=\"50\" flex=\"40\" class=\"font-size-14 white-fg pv-5\"><b class=\"pr-5\">\n{{ vm.selectedSyncDocument.length}}</b>Document(s) Selected</div><div layout=\"row\" flex-xs=\"100\" flex-sm=\"100\" \nflex=\"25\" layout-align=\"end end\" class=\"w-250\"><md-button md-no-ink class=\"md-primary-btn\" \nng-click=\"vm.cancelSelectionMenu()\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn\" \nng-disabled=\"vm.selectedSyncDocument.length==0\" ng-click=\"vm.fetchSyncData($event);vm.documentSelection=false\">Proceed\n</md-button></div></div><div flex=\"100\" flex-gt-xs=\"100\" layout=\"column\" class=\"font-size-14 mt-20\"><div><table \nclass=\"simple view_table\" ms-responsive-table><thead><tr><th ng-if=\"vm.documentSelection\"><div flex=\"10\" \nclass=\"w-60 p-5\" layout-align=\"space-around center\"><md-checkbox md-no-ink ng-click=\"vm.toggleAllCheckbox($event)\">\n</md-checkbox></div></th><th class=\"file_heading pl-15\">Document Name</th><th class=\"file_heading\">Type</th><th \nclass=\"file_heading\">Uploaded By</th><th class=\"file_heading\">Uploaded On</th><th ng-if=\"vm.permission[2]\" \nclass=\"file_heading\">Action/Status</th><th ng-if=\"vm.tms_enabled\" class=\"file_heading\">TMS Last Synced Date</th><th \nng-if=\"vm.tms_enabled\" class=\"file_heading\">TMS Status</th><th class=\"file_heading\">Comments</th><th \nclass=\"file_heading\">Deadline</th><th></th></tr></thead><tbody><tr class=\"h-50\" \nng-repeat=\"data in vm.DocumentList track by $index\"><td ng-if=\"vm.documentSelection\"><div flex=\"10\" class=\"w-60 p-5\" \nlayout-align=\"space-around center\"><md-checkbox ng-disabled=\"data.sync_status.toLowerCase() ===\'success\'\" md-no-ink \nng-model=\"data.checked\" ng-click=\"vm.toggleCheckbox($event,data)\"></md-checkbox><md-tooltip md-direction=\"top\" \nng-if=\"data.sync_status.toLowerCase() ===\'success\'\">Document is already synced</md-tooltip></div></td><td \nclass=\"file_name font-weight-600 big-name\"><div ng-if=\"data.has_expired == 1\" class=\"deadline_expired\">Deadline Expired\n</div><span class=\"big-name\" ng-class=\"{\'not-active\':data.has_expired == 1}\" title=\"{{data.file_name}}\">\n{{data.file_name}}</span></td><td ng-class=\"{\'not-active\':data.has_expired == 1}\" class=\"file_name\">\n{{data.type | uppercase}}</td><td ng-class=\"{\'not-active\':data.has_expired == 1}\" class=\"file_name\">\n{{data.uploaded_by_name}}</td><td ng-class=\"{\'not-active\':data.has_expired == 1}\" class=\"file_name\">\n{{data.time_ago}} ago</td><td ng-if=\"vm.permission[2] || vm.isShareable\" \nng-class=\"{\'not-active\':data.has_expired == 1}\" class=\"file_name\"><md-button md-no-ink \nng-class=\"{\'disabled-btn\':data.has_expired == 1}\" \nng-show=\"data.is_approval_required==1 && data.status!==\'APPROVED\' && data.status!==\'REJECTED\'\" \nng-disabled=\"data.has_expired == 1 || vm.disableClick == true\" \nclass=\"font-size-12 md-accent-fg md-hue-1 white-bg border-amber m-5 button-border\" title=\"Approve\" \nng-if=\"vm.permission[2] || vm.isShareable\" ng-click=\"vm.setStatus(\'APPROVED\', $index, data);\">APPROVE</md-button>\n<md-button md-no-ink ng-class=\"{\'disabled-btn\':data.has_expired == 1}\" \nng-show=\"data.is_approval_required==1 && data.status!==\'APPROVED\' && data.status!==\'REJECTED\'\" \nng-disabled=\"data.has_expired == 1 || vm.disableClick == true\" \nclass=\"font-size-12 red-fg white-bg border-red m-5 button-border\" ng-if=\"vm.permission[2] || vm.isShareable\" \nng-click=\"vm.fnOpenRejectResonModal($event, $index, data);\" title=\"Reject\">REJECT</md-button><md-button md-no-ink \nng-show=\"data.status==\'REJECTED\' && data.is_approval_required != 0\" \nclass=\"font-size-10 mv-0 rejected-btn border-radios-10 button-border\">REJECTED<md-tooltip ng-if=\"data.reject_reason\" \nmd-direction=\"right\" class=\"white-bg black-fg md-whiteframe-2dp reject-reason\" \nstyle=\"height: auto;\n                              max-width: 20%;\n                              word-wrap: break-word;\n                              white-space: unset\">\nReason: {{data.reject_reason}}</md-tooltip></md-button><md-button md-no-ink \nng-show=\"data.status==\'APPROVED\' && data.is_approval_required != 0\" \nclass=\"font-size-10 mv-0 approved-btn border-radios-10 button-border\">APPROVED</md-button><div \nng-show=\"data.is_approval_required==0\">N/A</div></td><td ng-if=\"vm.tms_enabled\" \nng-class=\"{\'not-active\':data.has_expired == 1}\" class=\"file_name\">\n{{data.synced_at ? (data.synced_at | date : \'dd MMM yyyy\'):\'N/A\'}}</td><td ng-if=\"vm.tms_enabled\" \nng-class=\"{\'not-active\':data.has_expired == 1}\" class=\"file_name\"><div \nng-class=\"{\'intergration-code-success\': data.sync_status.toLowerCase() ===\'success\' ,\'intergration-code-failed\' :  data.sync_status.toLowerCase() ===\'failed\' }\">\n{{data.sync_status ? data.sync_status ===\'success\'? \'Synced to \'+vm.shipment_meta.partner : data.sync_status ===\'failed\' ? \'Failed to Sync\' : \'N/A\' : \'N/A\'}}\n</div></td><td ng-class=\"{\'not-active\':data.has_expired == 1}\" ng-disabled=\"data.has_expired == 1\" \nng-if=\"data.comment!==\'\' && data.comment!==\'undefined\' && data.comment!==undefined && data.comment!==null\" \nclass=\"comment-td comment-width\"><span class=\"text-show-content-table\">{{data.comment}}</span> <span \nclass=\"font-weight-600 cursor\" ng-click=\"vm.fnOpenCommentModal($event, data, $index);\">\n{{data.comment.length > 18 ? \'Read more\' : \'Edit\'}}</span></td><td ng-class=\"{\'not-active\':data.has_expired == 1}\" \nng-disabled=\"data.has_expired == 1\" \nng-if=\"data.comment==\'\' || data.comment==\'undefined\' || data.comment==undefined || data.comment==null\" \nclass=\"comment-td\"><span class=\"font-weight-600 cursor\" ng-if=\"vm.permission[2]\" \nng-click=\"vm.fnOpenCommentModal($event, data, $index);vm.trackEvent(\'SD-AddComments-Click\')\">Add Comment</span><span \nng-if=\"!vm.permission[2]\">N/A</span></td><td class=\"file_name\"><span ng-if=\"data.approval_deadline\">\n{{data.approval_deadline | UTCToLocal : \'d MMM, yyyy\' }}</span> <span ng-if=\"!data.approval_deadline\">N/A</span><br>\n<span ng-show=\"data.has_expired == 1\" class=\"pl-15\"><u class=\"cursor\" ng-if=\"vm.permission[2] && !vm.isShipper\" \nng-click=\"vm.fnOpenModifyDateModal($event, data._id, $index)\" title=\"Modify Deadline\">Modify.</u></span></td><td \nng-class=\"{\'not-active\':data.has_expired == 1}\" class=\"text-right\"><md-icon md-font-icon=\"icon-sync\" \nclass=\"ile_icon mr-15 cursor\" ng-if=\"vm.tms_enabled &&  data.sync_status ===\'failed\' \" ng-click=\"vm.reSyncData(data)\">\n</md-icon><a ng-href=\"{{vm.util.sanitizeQueryParams(data.location)}}\" ng-disabled=\"data.has_expired == 1\" download \ntarget=\"_blank\" rel=\"noopener\"><md-icon class=\"file_icon mr-15 cursor\" \nmd-svg-src=\"assets/icons/custom/download-icon.svg\" title=\"Download\"></md-icon></a><md-icon ng-if=\"vm.permission[3]\" \nng-click=\"vm.fnOpenConfirmDeleteModal(data._id, $index, $event);\" ng-disabled=\"data.has_expired == 1\" \nclass=\"file_icon mr-15 cursor\" md-svg-src=\"assets/icons/custom/delete-icon.svg\" title=\"Delete\"></md-icon></td></tr>\n</tbody></table></div></div></md-card-content></md-card></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nlayout-wrap><md-card><md-card-content ng-if=\"vm.DocumentList.length==0 && vm.getData\" class=\"ph-20 pt-5\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><h2>No Document available!</h2></md-card-content></md-card></div></div></div>\n</div><div ng-if=\"dataErr\"><div class=\"no-data\">No data available!</div></div>");
$templateCache.put("app/main/shipments/tabs/feed/feed.html","<div id=\"shipment-feed\"><div layout-gt-sm=\"row\" layout=\"column\" layout-padding class=\"mt-25\" \nlayout-align=\"space-between\"><div flex-gt-sm=\"70\" flex=\"100\" class=\"mr-20\" ng-if=\"vm.permission.activity_feed[1]\"><div \nshimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\" class=\"b white-bg mb-20\"></div><div \nclass=\"b white-bg mb-20\" ng-if=\"vm.permission.activity_feed[0]\" ng-show=\"vm.getData\"><div layout=\"row\" \nclass=\"share-border-botton mh-15\"><p class=\"font-size-16 font-weight-600 pl-5 pt-15 pb-5px mt-0\">SHARE UPDATES</p>\n</div><div layout=\"column\" class=\"text-feed m-20 brad-4 font-size-14 cursor\"><ng-ckeditor ng-model=\"vm.postText\" \nng-config=\"vm.util.ckEditorConfig\"></ng-ckeditor><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"fg-4a4a4a font-size-18 Font-Bold mh-10 pt-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.send_notification\" class=\"md-primary\">Send Notification</md-checkbox></div><md-button md-no-ink \nclass=\"md-accent-btn mr-10 mb-10\" ng-disabled=\"vm.disabledPost\" ng-click=\"vm.fnSubmitPost()\" title=\"Post\">Post\n</md-button></div></div></div><div ng-repeat=\"activity in vm.feedData track by $index\" \nng-if=\"vm.permission.activity_feed[1]\" ng-show=\"vm.getData\"><div compile-html=\"activity.feed\"></div></div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\" ng-if=\"vm.feedData\" hide><md-button md-no-ink \nclass=\"cursor load_more text-capitalize\" flex=\"100\" title=\"Load more...\">Load More ...</md-button></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"!vm.permission.activity_feed[1] && !vm.feedData\">You don\'t have permission to access this section.</div></div>\n<div flex-gt-sm=\"30\" flex=\"100\" class=\"major_event b white-bg\" ng-if=\"vm.permission.status[1]\"><div shimmer-effect \nwidth=\"100%\" height=\"100%\" ng-show=\"!vm.getData\"></div><div layout=\"row\" ng-show=\"vm.getData\"><p \nclass=\"font-size-16 font-weight-600 p-15 mt-0\">MAJOR EVENTS</p></div><div layout=\"column\" class=\"pb-15 font-size-14\" \nng-repeat=\"status in vm.statusData track by $index\" ng-show=\"vm.getData\"><div layout=\"row\" class=\"ph-15\"><div><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"md-link-fg s30\"></md-icon></div><div class=\"pl-15 pr-20\"><span \nclass=\"ship_text\">{{status.status}}</span><br><span class=\"font-size-10 opacity\">\n{{status.milestone_date| UTCToLocal : \'d MMM yyyy, h:mm a\'}}</span></div></div><div ng-if=\"!$last\"><span \nclass=\"vertical_seperator\"></span></div></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"font-size-16 text-italic\" layout-padding ng-if=\"vm.statusData.length==0\">Sorry, status not available.</div>\n</div></div></div>");
$templateCache.put("app/main/shipments/tabs/products/products.html","<div ng-if=\"!dataErr\" id=\"shipment-products\"><div layout=\"column\" class=\"pv-15\"><div layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" layout-wrap><md-card shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"!vm.getData\"></md-card><md-card ng-show=\"vm.getData\"><md-card-content class=\"ph-20 pt-5\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" layout=\"column\" class=\"pv-10 border-bottom\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"70\" layout-wrap><div class=\"font-size-16 font-weight-600\">PRODUCTS</div>\n</div></div><div layout=\"row\" layout-align=\"end center\" flex=\"100\" layout-wrap><div \nclass=\"font-size-14 green-fg add-btn mr-15 mt-10\" ng-if=\"vm.permission[0]\" ng-click=\"vm.addRow()\"><md-icon \nmd-font-icon=\"icon-plus-circle icon-20 green-fg\" class=\"mr-5\"></md-icon><span><u>Add Product</u></span></div></div><div\n flex=\"100\" flex-gt-xs=\"100\" layout=\"column\" class=\"font-size-14 mt-20\"><div class=\"\"><table \nng-if=\"vm.productList.length!==0 && vm.productList.length!==undefined\" class=\"view_table\" ms-responsive-table><thead>\n<tr><th class=\"file_heading\"></th><th class=\"file_heading pr-20\">Sr No.</th><th class=\"file_heading\">SKU_ID<span \nclass=\"font-size-16 red-fg\">*</span></th><th class=\"file_heading\">Product Number<span class=\"font-size-16 red-fg\">*\n</span></th><th class=\"file_heading\">Description</th><th class=\"file_heading\">Qty * Unit Size</th><th \nclass=\"file_heading\">Gross Weight<span class=\"font-size-16 red-fg\">*</span></th><th class=\"file_heading\">CBM<span \nclass=\"font-size-16 red-fg\">*</span></th><th class=\"file_heading\">Invoice Details</th><th class=\"file_heading\">\nSB Details</th></tr></thead><tbody><tr ng-repeat=\"data in vm.productList track by $index\"><td><div \nclass=\"font-size-14 red-fg add-btn mr-10\" ng-if=\"vm.permission[3]\" \nng-click=\"vm.fnOpenConfirmDeleteModal(data._id, $index, $event)\"><md-icon \nmd-font-icon=\"icon-minus-circle icon-20 remove_icon\" class=\"mr-5\"></md-icon></div></td><td \nclass=\"file_name font-weight-600 ph-15\">{{$index + 1}}</td><td class=\"file_name\"><md-input-container md-no-float \nclass=\"m-0 h-40 font-size-14\"><input ng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" \nclass=\"border-radius-2\" placeholder=\"\" ng-model=\"data.sku_id\" ng-value=\"data.sku_id\"></md-input-container></td><td \nclass=\"file_name\"><md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input \nng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" class=\"border-radius-2\" placeholder=\"\" \nng-model=\"data.product_number\" ng-value=\"data.product_number\"></md-input-container></td><td class=\"file_name\">\n<md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input \nng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" class=\"border-radius-2\" placeholder=\"\" \nng-model=\"data.description\" ng-value=\"data.description\"></md-input-container></td><td class=\"file_name\">\n<md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input \nng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" class=\"border-radius-2\" placeholder=\"\" \nng-model=\"data.quantity_size\" ng-value=\"data.quantity_size\"></md-input-container></td><td class=\"file_name\">\n<md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input \nng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" class=\"border-radius-2\" placeholder=\"\" \nng-model=\"data.gross_weight\" ng-value=\"data.gross_weight\"></md-input-container></td><td class=\"file_name\">\n<md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input \nng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" class=\"border-radius-2\" placeholder=\"\" \nng-model=\"data.weight_unit\" ng-value=\"data.weight_unit\"></md-input-container></td><td class=\"file_name\">\n<md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input \nng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" class=\"border-radius-2\" placeholder=\"\" \nng-model=\"data.invoice_details\" ng-value=\"data.invoice_details\"></md-input-container></td><td class=\"file_name\">\n<md-input-container md-no-float class=\"m-0 h-40 font-size-14\"><input \nng-readonly=\"!vm.permission[2] || !vm.permission[0]\" name=\"share\" class=\"border-radius-2\" placeholder=\"\" \nng-model=\"data.sb_details\" ng-value=\"data.sb_details\"></md-input-container></td></tr></tbody></table></div></div><div \nng-if=\"vm.productList.length!==0 && vm.productList.length!==undefined\" flex=\"100\" layout=\"column\" class=\"pv-10\"><div \nlayout=\"row\" layout-align=\"end center\" flex=\"100\" layout-wrap><md-button md-no-ink ng-disabled=\"vm.disableSaveButton\" \nng-if=\"vm.permission[0] || vm.permission[2]\" ng-click=\"vm.saveProducts()\" class=\"md-accent-btn\">Save</md-button></div>\n</div></md-card-content><md-card-content ng-if=\"vm.productList.length==0 || vm.productList.length==undefined\" \nclass=\"ph-20 pt-5\" layout=\"row\" layout-align=\"center center\" layout-wrap><h2>No data available!</h2></md-card-content>\n</md-card></div></div></div></div><div ng-if=\"dataErr\"><div class=\"no-data\">No data available!</div></div>");
$templateCache.put("app/main/shipments/tabs/quotes/quotes.html","<div id=\"shipment-quotes\"><div layout=\"row\" flex=\"100\" class=\"mt-20\" layout-xs=\"column\"><div \nclass=\"widget-group white-bg border p-20 mt-25 LHS_div\" layout=\"row\" \nflex-gt-sm=\"{{vm.util.activatedTheme !== \'transpost\' ? 70: 100}}\" flex=\"100\" layout-wrap \nng-class=\"{\'mr-20\' : vm.quotePermission[0]}\"><div flex=\"100\" layout=\"column\" \nclass=\"ph-0 pt-0 pb-20 mb-20 border-bottom\"><div shimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\"></div>\n<div layout=\"row\" layout-wrap ng-show=\"vm.getData\"><div><span class=\"font-size-16 font-weight-600 pr-15\">QUOTES</span>\n</div><div><div class=\"status_meta_div allinquote-tag-color\" ng-if=\"vm.all_in_quote && !vm.util.isShipper\" \nng-bind=\"vm.util.allInQuoteOptions[vm.all_in_quote]\"></div></div></div></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"mv-10 font-size-16 text-italic\" \nng-if=\"vm.quotePermission[1] && !vm.quotes.cards.length\" layout-padding ng-show=\"vm.getData\">\nSorry, No Quotes available.</div><div layout=\"column\" layout-align=\"center center\" \nclass=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"(!vm.quotePermission[1] && !vm.quotes.cards.length) || (!vm.quotePermission[1])\">\nYou don\'t have permission to access this section.</div><div layout=\"row\" ng-show=\"vm.getData\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"30\" flex-gt-md=\"25\" class=\"w-300\" \nng-repeat=\"card_item in vm.quotes.cards track by $index\" ng-if=\"vm.quotePermission[1] && vm.quotes.cards.length\"><div \nclass=\"white-bg card_box_shadow unSelected_card\" \nng-style=\"{ \'border\' : (card_item.meta.is_booked)  ? \'1px solid #3B82F6\' : \'collapse\' }\" \nng-include=\"\'app/main/quotes/dialogs/rate-card/rate-card.html\'\"></div></ms-widget></div></div><div \nclass=\"widget-group white-bg border p-20 mt-25\" flex-gt-sm=\"30\" flex=\"100\" ng-if=\"vm.quotePermission[0]\"><div \nflex=\"100\" layout=\"column\" class=\"ph-0 pt-0 pb-20 border-bottom\"><div shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"!vm.getData\"></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap ng-show=\"vm.getData\"><div\n layout=\"row\" layout-align=\"start center\" flex=\"70\" layout-wrap><span class=\"font-size-16 font-weight-600 pr-15\">\nUPLOADED QUOTES</span></div></div></div><div ms-scroll class=\"content\" ng-show=\"vm.getData\"><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\" class=\"mv-20\" layout-wrap ng-if=\"vm.quotePermission[0]\"><div \nclass=\"dragDropSection\" layout=\"row\" layout-align=\"center center\" flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><form \nname=\"myForm\" enctype=\"multipart/form-data\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\" layout-margin \nlayout-wrap><div layout-align=\"center center\" layout=\"column\" flex=\"100\" ng-if=\"!vm.picFile\" class=\"uploadFile mt-15\">\n<md-button md-no-ink class=\"md-link-btn mv-0\" ng-click=\"vm.selectFile()\" title=\"BROWSE FILES\">Browse Files</md-button>\n<div class=\"font-size-12 pv-10 opacity\">Max. 1 File at a time</div><input type=\"file\" id=\"fileInput_doc\" ngf-select \nng-model=\"vm.picFile\" name=\"file_doc\" ngf-max-size=\"20MB\" \naccept=\".xls,.doc,.docx,application/pdf,application/vnd.ms-excel,image/*, zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed\" \nngf-pattern=\"\'.pdf,.xls,.csv,.xlsx,.doc,.docx,.zip,image/*\'\" required ngf-model-invalid=\"errorFile\" hide><br><span \nng-show=\"myForm.file_doc.$error.maxSize\" class=\"font-size-14 red-fg\">This file is too large, maximum file size is 20MB.\n</span> <span ng-show=\"myForm.file_doc.$error.pattern\" class=\"font-size-14 red-fg\">\nPlease upload only .pdf,.xls,.csv,.xlsx,.doc,.docx,.zip format or image files.</span></div><div \nlayout-align=\"center center\" layout=\"column\" flex=\"100\" ng-if=\"vm.picFile\" class=\"uploadFile\"><md-icon class=\"h-40\" \nmd-svg-src=\"assets/icons/custom/file-icon.svg\"></md-icon><span class=\"pt-15 text-truncate\">{{vm.picFile.name}}</span>\n<br><div layout-align=\"center center\" layout=\"row\" flex=\"100\" flex><div layout-align=\"center center\" layout=\"column\" \nclass=\"ph-20\"><button ng-click=\"vm.picFile = null;\" id=\"remove_doc\" ng-show=\"vm.picFile\" class=\"border-bottom grey-fg\">\nRemove</button></div><div layout-align=\"center center\" layout=\"column\" class=\"ph-20\"><button \nng-click=\"vm.uploadQuotes(vm.picFile)\" ng-disabled=\"vm.uploadButton\" ng-show=\"vm.picFile\" \nclass=\"md-accent-btn w-65 p-5\">Upload</button></div></div></div></div><div layout=\"column\" flex=\"100\" \nng-show=\"vm.onSelect\" class=\"ph-0 pt-15\"><md-progress-linear md-mode=\"indeterminate\" class=\"p-15\"></md-progress-linear>\n<div layout=\"row\" layout-padding flex=\"100\"><span class=\"text-left font-weight-800 font-style-italic\" flex=\"100\"><i \nclass=\"font-size-12\">1 File/s Uploading</i></span> <span class=\"text-right opacity\" hide flex=\"50\"><u>CANCEL UPLOAD</u>\n</span></div><span ng-show=\"vm.picFile.result\">Upload Successful</span> <span class=\"err\" ng-show=\"vm.errorMsg\">\n{{vm.errorMsg}}</span><br></div></form></div></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"mv-10 font-size-16 text-italic\" ng-if=\"vm.quotePermission[1] && !vm.uploadedQuotes.length\" layout-padding><span \nng-if=\"vm.quotePermission[0]\">Please upload quotes. </span><span ng-if=\"!vm.quotePermission[0]\">\nYou don\'t have permission to access this section.</span></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"mv-10 font-size-16 text-italic\" layout-padding ng-if=\"!vm.quotePermission[1]\">\nYou don\'t have permission to access this section.</div><div layout=\"row\" flex=\"100\" class=\"mv-20\" \nng-repeat=\"uploadedFile in vm.uploadedQuotes track by $index\" \nng-if=\"vm.quotePermission[1] && vm.uploadedQuotes.length\"><div layout=\"column\" layout-align=\"start start\" flex=\"10\" \nclass=\"mr-15\"><md-icon class=\"quote_file_icon ml-0\" md-svg-src=\"assets/icons/custom/file-icon.svg\"></md-icon></div><div\n layout=\"column\" layout-align=\"start start\" flex=\"70\"><div class=\"font-size-14 font-weight-600 text-truncate\" \nflex=\"70\" layout-wrap>{{uploadedFile.name}}</div><div class=\"font-size-12 font-weight-500 text-italic\">Uploaded by : \n<span>{{uploadedFile.user.name}} </span></div></div><div layout=\"row\" layout-align=\"center start\" flex=\"20\" flex><div \nclass=\"font-size-14 font-weight-600\" ng-if=\"vm.quotePermission[3]\"><md-icon class=\"file_icon mr-10 cursor\" \nmd-svg-src=\"assets/icons/custom/delete-icon.svg\" title=\"Delete\" \nng-click=\"vm.fnOpenConfirmDeleteModal(uploadedFile.id,$index)\"></md-icon></div><div \nclass=\"font-size-14 font-weight-600\"><a ng-href=\"{{vm.util.sanitizeQueryParams(uploadedFile.location)}}\" download>\n<md-icon class=\"file_icon mr-0 cursor\" md-svg-src=\"assets/icons/custom/download-icon.svg\" title=\"Download\"></md-icon>\n</a></div></div></div></div></div></div></div>");
$templateCache.put("app/main/shipments/tabs/rateproviderbillinginfo/rateproviderbillinginfo.html","<md-card shimmer-effect width=\"100%\" ng-if=\"!vm.isRatesLoaded\"></md-card><md-card \nng-if=\"vm.isRatesLoaded && vm.permission.rateProviderBilling[1]\"><div flex=\"100\" layout=\"column\" \nclass=\"pv-10 border-bottom\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"70\" layout-wrap><div \nclass=\"font-size-16 font-weight-600 p-20\">RATE PROVIDER BILLING INFO</div></div></div><charges-display \nmode=\"vm.ShipmentsDetails.mode\" ng-if=\"(vm.bill_rates.length)\" charges-data=\"vm.bill_rates\" \npage-source=\"\'rateProviderBilling\'\"></charges-display><div layout=\"row\" layout-align=\"end center\" class=\"p-20\" \nng-if=\"vm.bill_rates.length\"><div class=\"font-size-16 pr-20\">Total</div><div \nclass=\"pr-20 font-size-16 font-weight-600\">\n{{ vm.bill_rates[0].leg_total_currency + \' \' + ( vm.total| currencyMask : 2) }}</div></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"!vm.bill_rates.length\">Sorry, No Rates Available.</div></md-card><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-20 font-size-16 text-italic\" layout-padding \nng-if=\"!vm.permission.rateProviderBilling[1]\">You don\'t have permission to access this section.</div>");
$templateCache.put("app/main/shipments/tabs/shipmentdetails/shipmentdetails.html","<div id=\"shipment-details\"><div layout-gt-sm=\"row\" layout-padding layout=\"column\" class=\"mt-10 ph-0\"><div \nlayout=\"column\" flex=\"33\" class=\"LHS_div\"><div shimmer-effect width=\"100%\" height=\"100%\" class=\"b white-bg mb-20\" \nng-show=\"!vm.getData\"></div><div class=\"b mt-20 white-bg\" ng-show=\"vm.getData\"><div layout=\"row\" layout-padding \nclass=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" layout-xs=\"column\" flex=\"100\"><div \nclass=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">References</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"50\" flex-xs=\"100\" \nng-if=\"vm.shipment_meta.references && vm.shipment_meta.references.length > 0\"><md-button md-no-ink \nclass=\"md-link-btn with-icon\" ng-click=\"vm.fnOpenReferencesModal($event)\" title=\"Edit References\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s14 schedule-icon\"></md-icon><span>Edit</span></md-button></div></div><md-content \nms-scroll class=\"max-height-0\"><div layout=\"row\" flex=\"100\" layout-xs=\"row\" layout-wrap \nclass=\"pt-20 ph-20 pb-10 font-size-13 fg-333333\"><div flex=\"33\" flex-xs=\"50\" class=\"mb-20 pr-5\"><span \nclass=\"font-weight-600\">Inquiry No.</span><br><div \nng-class=\"{\'md-link-fg pointer\' : !vm.isSharedshipment && !vm.util.isShipper}\" ng-if=\"vm.shipment_meta.inquiry_number\" \nng-click=\"vm.fnViewInquiryDetails(vm.shipment_meta.inquiry_id)\" title=\"{{ vm.shipment_meta.inquiry_number }}\" \nng-bind=\"vm.shipment_meta.inquiry_number\"></div><div ng-if=\"!vm.shipment_meta.inquiry_number\">N/A</div></div><div \nflex=\"33\" flex-xs=\"50\" class=\"mb-20 pr-5\"><span class=\"font-weight-600\">Quotation No.</span><br><div \nng-class=\"{\'md-link-fg pointer\' : !vm.isSharedshipment && !vm.util.isShipper}\" ng-if=\"vm.shipment_meta.quote_no\" \nng-click=\"vm.fnViewQuoteDetails(vm.shipment_meta.quote_id)\" title=\"{{ vm.shipment_meta.quote_no }}\" \nng-bind=\"vm.shipment_meta.quote_no\"></div><div ng-if=\"!vm.shipment_meta.quote_no\">N/A</div></div><div flex=\"33\" \nflex-xs=\"50\" class=\"mb-20 pr-5\"><span class=\"font-weight-600\">Search Reference</span><br><div \nclass=\"text-truncate max-width-300\" title=\"{{ vm.shipment_meta.quote_name ? vm.shipment_meta.quote_name : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.quote_name ? vm.shipment_meta.quote_name : \'N/A\'\"></div></div><div flex=\"33\" flex-xs=\"50\" \nclass=\"mb-20 pr-5\" ng-if=\"vm.shipment_meta.mode != \'AIR\'\"><span class=\"font-weight-600\">Tracking Container </span><br>\n<div title=\"{{ vm.shipment_meta.liner_shipment_id ? vm.shipment_meta.liner_shipment_id : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.liner_shipment_id ? vm.shipment_meta.liner_shipment_id : \'N/A\'\"></div></div><div flex=\"33\" \nflex-xs=\"50\" class=\"mb-20 pr-5\"><span class=\"font-weight-600\">Booking ID</span><br><div \ntitle=\"{{ vm.shipment_meta.shipment_id ? vm.shipment_meta.shipment_id : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.shipment_id ? vm.shipment_meta.shipment_id : \'N/A\'\"></div></div><div flex=\"33\" flex-xs=\"50\" \nclass=\"mb-20 pr-5\" ng-if=\"vm.shipment_meta.other_details\"><span class=\"font-weight-600\">Other Details</span><br><div \nclass=\"text-truncate max-width-300\" \ntitle=\"{{ vm.shipment_meta.other_details ? vm.shipment_meta.other_details : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.other_details ? vm.shipment_meta.other_details : \'N/A\'\"></div></div><div flex=\"33\" \nflex-xs=\"50\" class=\"mb-20 pr-10\" \nng-if=\"vm.shipment_meta.mode === \'AIR\' && vm.shipment_meta.additional_attributes.rateId\"><span class=\"font-weight-600\">\nRate ID</span><br><div layout=\"row\"><div class=\"text-truncate max-width-300\" \nng-class=\"{\'fg-3B82F6\':vm.shipment_meta.additional_attributes.rateId}\" \ntitle=\"{{vm.shipment_meta.additional_attributes.rateId ?  vm.shipment_meta.additional_attributes.rateId : \'N/A\' }}\" \nng-bind=\" vm.shipment_meta.additional_attributes.rateId ?  vm.shipment_meta.additional_attributes.rateId: \'N/A\'\"></div>\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s16 pointer content-copy\" \nng-if=\"vm.shipment_meta.additional_attributes.rateId\" \nng-click=\"vm.fnCopyID( vm.shipment_meta.additional_attributes.rateId)\"><md-tooltip md-direction=\"top\">{{vm.isIdCopied}}\n</md-tooltip></md-icon></div></div><div flex=\"33\" flex-xs=\"50\" class=\"mb-20 pr-10\" \nng-if=\"vm.shipment_meta.mode === \'AIR\' && vm.shipment_meta.additional_attributes.flightUUID\"><span \nclass=\"font-weight-600\">Flight ID</span><br><div layout=\"row\"><div class=\"text-truncate max-width-300\" \nng-class=\"{\'fg-3B82F6\':vm.shipment_meta.additional_attributes.flightUUID}\" \ntitle=\"{{vm.shipment_meta.additional_attributes.flightUUID ?  vm.shipment_meta.additional_attributes.flightUUID : \'N/A\' }}\" \nng-bind=\" vm.shipment_meta.additional_attributes.flightUUID ?  vm.shipment_meta.additional_attributes.flightUUID: \'N/A\'\">\n</div><md-icon md-font-icon=\"icon-content-copy\" class=\"s16 pointer content-copy\" \nng-if=\"vm.shipment_meta.additional_attributes.flightUUID\" \nng-click=\"vm.fnCopyID( vm.shipment_meta.additional_attributes.flightUUID)\"><md-tooltip md-direction=\"top\">\n{{vm.isIdCopied}}</md-tooltip></md-icon></div></div><div flex=\"33\" flex-xs=\"50\" class=\"mb-20 pr-10\" \nng-if=\" vm.shipment_meta.carrier_booking_reference\"><span class=\"font-weight-600\">Carrier Booking ID</span><br><div \nlayout=\"row\"><div class=\"text-truncate max-width-300\" \nng-class=\"{\'fg-3B82F6\':vm.shipment_meta.carrier_booking_reference}\" \ntitle=\"{{vm.shipment_meta.carrier_booking_reference ?  vm.shipment_meta.carrier_booking_reference : \'N/A\' }}\" \nng-bind=\" vm.shipment_meta.carrier_booking_reference ?  vm.shipment_meta.carrier_booking_reference: \'N/A\'\"></div>\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s16 pointer content-copy\" \nng-if=\"vm.shipment_meta.carrier_booking_reference\" ng-click=\"vm.fnCopyID( vm.shipment_meta.carrier_booking_reference)\">\n<md-tooltip md-direction=\"top\">{{vm.isIdCopied}}</md-tooltip></md-icon></div></div><div flex=\"33\" flex-xs=\"50\" \nclass=\"mb-20\" \nng-if=\"vm.shipment_meta.additional_attributes && vm.shipment_meta.additional_attributes.current_booking_id\"><span \nclass=\"font-weight-600\">{{vm.shipment_meta.partner}} Booking ID</span><br><div layout=\"row\"><div class=\"md-link-fg\" \ntitle=\"{{ vm.shipment_meta.additional_attributes.current_booking_id}}\" \nng-bind=\"vm.shipment_meta.additional_attributes.current_booking_id\"></div><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s14 pointer content-copy ml-5\" \nng-click=\"vm.fnCopyID( vm.shipment_meta.additional_attributes.current_booking_id )\"><md-tooltip md-direction=\"top\">\n{{vm.isIdCopied}}</md-tooltip></md-icon></div></div><div flex=\"33\" flex-xs=\"50\" class=\"mb-20\" \nng-if=\"vm.shipment_meta.additional_attributes && vm.shipment_meta.additional_attributes.current_shipment_id\"><span \nclass=\"font-weight-600\">{{vm.shipment_meta.partner}} Shipment ID</span><br><div layout=\"row\"><div class=\"md-link-fg\" \ntitle=\"{{ vm.shipment_meta.additional_attributes.current_shipment_id}}\" \nng-bind=\"vm.shipment_meta.additional_attributes.current_shipment_id\"></div><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s14 pointer content-copy ml-5\" \nng-click=\"vm.fnCopyID( vm.shipment_meta.additional_attributes.current_shipment_id )\"><md-tooltip md-direction=\"top\">\n{{vm.isIdCopied}}</md-tooltip></md-icon></div></div><div flex=\"33\" flex-xs=\"50\" class=\"mb-10\" \nng-if=\"vm.shipment_meta.mode === \'AIR\'\"><span class=\"font-weight-600\">HAWB</span><br><div \ntitle=\"{{ vm.shipment_meta.awb_object.hawb ? vm.shipment_meta.awb_object.hawb : \'N/A\' }}\" \nng-bind=\"vm.shipment_meta.awb_object.hawb ? vm.shipment_meta.awb_object.hawb : \'N/A\'\"></div></div><div flex=\"33\" \nflex-xs=\"50\" class=\"mb-20 pr-10\" ng-if=\"vm.shipment_meta.mode === \'AIR\'\"><span class=\"font-weight-600\">MAWB</span><br>\n<div layout=\"row\"><div class=\"text-truncate max-width-300\" ng-class=\"{\'fg-3B82F6\':vm.shipment_meta.awb_object.mawb}\" \ntitle=\"{{vm.shipment_meta.awb_object.mawb ?  vm.shipment_meta.awb_object.mawb : \'N/A\' }}\" \nng-bind=\" vm.shipment_meta.awb_object.mawb ?  vm.shipment_meta.awb_object.mawb: \'N/A\'\"></div><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s16 pointer content-copy\" ng-if=\"vm.shipment_meta.awb_object.mawb\" \nng-click=\"vm.fnCopyID( vm.shipment_meta.awb_object.mawb)\"><md-tooltip md-direction=\"top\">{{vm.isIdCopied}}</md-tooltip>\n</md-icon></div></div><div layout=\"column\" flex=\"100\" \nng-if=\"vm.shipment_meta.references && vm.shipment_meta.references.length > 0\" class=\"pb-10\"><div \nclass=\"package-table-container mt-10\"><table class=\"package-table\"><thead><tr><th \nclass=\"p-8 text-left load_td width-5\">#</th><th class=\"p-8 text-left load_td width-20\">Name</th><th \nclass=\"p-8 text-left load_td width-30\">Value</th><th class=\"p-8 text-left load_td width-25\">\nInternal Remarks (not processed)</th><th class=\"p-8 text-left load_td width-20\">Added By</th></tr></thead><tbody><tr \nng-repeat=\"reference in vm.shipment_meta.references\"><td class=\"p-8 font-size-13\">{{ $index + 1 }}</td><td \nclass=\"p-8 font-size-13\">{{ reference.reference_label || \'N/A\' }}</td><td class=\"p-8 font-size-13\"><div \ntitle=\"{{reference.reference_value}}\" class=\"truncate-remarks\">{{ reference.reference_value || \'N/A\' }}</div></td><td \nclass=\"p-8 font-size-13\"><div title=\"{{reference.comment}}\" class=\"truncate-remarks\">{{ reference.comment || \'N/A\' }}\n</div></td><td class=\"p-8 font-size-13\">{{ reference.added_by || \'N/A\' }}</td></tr></tbody></table></div></div></div>\n</md-content></div><div shimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\" class=\"b white-bg mb-20\"></div>\n<div class=\"load-details b mt-20 white-bg\" ng-show=\"vm.getData\"><div layout=\"row\" layout-align=\"space-between\" \nlayout-padding class=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" flex=\"100\"><div \nclass=\"font-size-16 font-weight-600 pl-5 pb-5\">Load Details</div><div layout=\"row\" layout-align=\"end center\" \nclass=\"panel-select panel-select-load-detail\" ng-if=\"vm.shipment_meta.mode != \'SEA-FCL\' && vm.permission.load[2]\"><form\n name=\"vm.searchBarForm\"><md-button md-no-ink class=\"md-link-btn with-icon\" ng-click=\"vm.showLoadDetailPanel($event)\" \ntitle=\"Edit Load\"><md-icon md-font-icon=\"icon-pencil\" class=\"s14 schedule-icon\"></md-icon><span>Edit</span></md-button>\n</form></div></div><div layout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" \nng-if=\"vm.permission.load[1] && !vm.load_data && vm.getData\" layout-padding>Sorry, load details not available.</div>\n<div layout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"(!vm.permission.load[1] && !vm.load_data) || (!vm.permission.load[1])\">\nYou don\'t have permission to access this section.</div><div layout=\"column\" \nng-if=\"vm.permission.load[1] && vm.load_data\"><md-expansion-panel \nng-if=\"vm.shipment_meta.mode == \'SEA-FCL\' && vm.showLoad\" md-component-id=\"loadOnePanel\" class=\"expansion_div\" \nng-repeat=\"loadDetail in vm.load_data.load_details_value track by $index\"><md-expansion-panel-collapsed \nclass=\"p-5 pointer\"><div layout=\"row\" flex=\"100\" ng-if=\"vm.shipmentEdit && vm.permission.load[2]\"><div \nclass=\"min-with-container\" flex=\"50\">{{loadDetail.qty}} x<md-input-container md-no-float class=\"p-0 m-0\"><md-select \nng-model=\"loadDetail.type\" name=\"type\" ng-click=\"$event.stopPropagation()\" \nmd-selected-text=\"loadDetail.type? loadDetail.type:\'Choose\'\" placeholder=\"Choose\" \nng-class=\"{\'red-border\':!loadDetail.type , \'value-placeholder\' : loadDetail.type}\" class=\"blue-border-clr ph-15\">\n<md-option ng-repeat=\"loadType in vm.loadTypeArr | filter: vm.loadFilter\" ng-value=\"loadType.load_code\">\n{{loadType.load_code}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><md-expansion-panel-icon></md-expansion-panel-icon></div></div><div layout=\"row\" flex=\"100\" \nng-if=\"!vm.shipmentEdit || !vm.permission.load[2]\"><div class=\"min-with-container\" flex=\"50\">{{loadDetail.qty}} x <span\n ng-class=\"\'load-\'+loadDetail.type | customeSplit:\'G\':0\" class=\"ml-5\">{{loadDetail.type | customeSplit:\'G\':0 }}</span>\n</div><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-expansion-panel-icon></md-expansion-panel-icon></div>\n</div></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header \nng-click=\"$panel.collapse()\" class=\"pointer\"><div layout=\"row\" flex=\"100\" \nng-if=\"vm.shipmentEdit && vm.permission.load[2]\"><div class=\"min-with-container\" flex=\"50\">{{loadDetail.qty}} x\n<md-input-container md-no-float class=\"p-0 m-0\"><md-select ng-model=\"loadDetail.type\" name=\"type\" \nng-click=\"$event.stopPropagation()\" md-selected-text=\"loadDetail.type? loadDetail.type:\'Choose\'\" placeholder=\"Choose\" \nng-class=\"{\'red-border\':!loadDetail.type,\'value-placeholder\' : loadDetail.type}\" class=\"blue-border-clr ph-15\">\n<md-option ng-repeat=\"loadType in vm.loadTypeArr | filter: vm.loadFilter\" ng-value=\"loadType.load_code\">\n{{loadType.load_code}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><md-expansion-panel-icon></md-expansion-panel-icon></div></div><div layout=\"row\" flex=\"100\" \nng-if=\"!vm.shipmentEdit || !vm.permission.load[2]\"><div class=\"min-with-container\" flex=\"50\">{{loadDetail.qty}} x <span\n ng-class=\"\'load-\'+loadDetail.type | customeSplit:\'G\':0\" class=\"ml-5\">{{loadDetail.type | customeSplit:\'G\':0 }}</span>\n</div><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-expansion-panel-icon></md-expansion-panel-icon></div>\n</div></md-expansion-panel-header><md-expansion-panel-content class=\"p-5 expansion-table\"><form name=\"loadForm\" \nng-if=\"vm.shipmentEdit && vm.permission.load[2]\"><div layout=\"column\" flex=\"100\" class=\"MobileTableView\"><table \nclass=\"load-table\" borderless ng-if=\"loadDetail.load_metrics.length\" flex=\"100\"><thead><tr><th class=\"load_td\">SN</th>\n<th class=\"load_td\">Total Shipment Volume</th><th class=\"load_td\">Total Shipment Weight</th><th class=\"load_td\"></th>\n</tr></thead><tbody><tr ng-repeat=\"loadMetrics in loadDetail.load_metrics track by $index\"><td class=\"font-size-14\">\n{{$index+1}}</td><td class=\"font-size-14\"><div layout=\"row\" class=\"load_div h-40 w-130 brad-4\"><md-input-container \nmd-no-float class=\"m-0 p-0\"><input step=\"any\" id=\"{{loadDetail.type}}_volume_qty_{{$index+1}}\" type=\"number\" \nng-model=\"loadMetrics.volume_qty\" min=\"0\" required></md-input-container><md-select name=\"type\" class=\"m-0 h-30 ph-5\" \nng-model=\"loadMetrics.volume_unit\"><md-option value=\"CBM\">CBM</md-option><md-option value=\"CFT\">CFT</md-option>\n</md-select></div></td><td class=\"font-size-14\"><div layout=\"row\" class=\"load_div h-40 w-130 brad-4\">\n<md-input-container md-no-float class=\"m-0 p-0\"><input step=\"any\" id=\"{{loadDetail.type}}_weight_qty_{{$index+1}}\" \ntype=\"number\" ng-model=\"loadMetrics.weight_qty\" min=\"0\" required></md-input-container><md-select name=\"type\" \nclass=\"m-0 h-30 ph-5\" ng-model=\"loadMetrics.weight_unit\"><md-option value=\"KGs\">KG</md-option><md-option value=\"Tons\">\nMT</md-option></md-select></div></td><td class=\"font-size-14\"><div><md-icon class=\"ml-5 w-16 h-16 pointer\" \nmd-svg-src=\"assets/icons/custom/duplicate-icon.svg\" title=\"Duplicate\" \nng-click=\"vm.duplicateLoad(loadMetrics,$parent.$index,loadDetail._id)\"></md-icon><md-icon \nclass=\"ml-5 icon s16 opacity pointer icon-cancel\" md-font-icon=\"icon-cancel\" \nng-click=\"vm.fnOpenConfirmDeleteModal(\'load\',$parent.$index,$index)\" title=\"Remove\"></md-icon></div></td></tr></tbody>\n</table></div></form><table class=\"load-table table_without_input\" borderless \nng-if=\"loadDetail.load_metrics.length && !vm.shipmentEdit || !vm.permission.load[2]\"><thead><tr><th class=\"load_td\">SN\n</th><th class=\"load_td\">Total Shipment Volume</th><th class=\"load_td\">Total Shipment Weight</th></tr></thead><tbody>\n<tr ng-repeat=\"loadMetrics in loadDetail.load_metrics track by $index\" class=\"line-height-2\"><td class=\"font-size-14\">\n<div layout=\"row\" flex=\"100\" class=\"flex\">{{$index+1}}</div></td><td class=\"font-size-14\"><div layout=\"row\"><div \nflex=\"50\">{{loadMetrics.volume_qty | currencyMask:2}}</div><div flex=\"50\">{{loadMetrics.volume_unit}}</div></div></td>\n<td class=\"font-size-14\"><div layout=\"row\"><div flex=\"50\">{{loadMetrics.weight_qty | currencyMask:2}}</div><div \nflex=\"50\">\n{{loadMetrics.weight_unit === \'KGs\' ? \'KG\' : (loadMetrics.weight_unit === \'LBs\' ? \'LB\' : loadMetrics.weight_unit)}}\n</div></div></td></tr></tbody></table></md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel>\n<div layout=\"row\" layout-align=\"center center\" flex=\"100\" layout-margin \nng-if=\"vm.shipmentEdit && vm.permission.load[2] && vm.shipment_meta.mode == \'SEA-FCL\'\"><div flex=\"50\" layout=\"column\" \nlayout-align=\"center center\"><md-button md-no-ink class=\"md-link-btn with-icon\" ng-click=\"vm.addNewLoad();\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s14 schedule-icon\"></md-icon><span>Add Load</span></md-button></div><div \nflex=\"50\" layout=\"column\" layout-align=\"end center\"><md-button md-no-ink \nng-if=\"vm.load_data.load_details_value.length\" ng-click=\"vm.fnSaveLoad(vm.load_data)\" class=\"md-accent-btn\" \nng-disabled=\"vm.disableLoadUpdate\" title=\"Update\">Update</md-button></div></div><div shimmer-effect-full width=\"97%\" \nheight=\"30px\" mh=\"10px\" mv=\"5px\" ng-if=\"vm.shipment_meta.mode == \'SEA-FCL\' && !vm.showLoad\"></div><div \nng-if=\"vm.shipment_meta.mode == \'AIR\'\"><div flex=\"100\" class=\"font-size-14 p-20\">{{vm.loadDispaly}}</div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap flex=\"100\" ng-if=\"vm.shipment_meta.mode == \'SEA-LCL\'\" \nclass=\"p-20\"><div flex=\"33\" flex-xs=\"50\" class=\"mb-20 pr-5\" ng-repeat=\"loadDetail in vm.lclLoadArray\" \nng-if=\"loadDetail.value != \'N/A\' && !loadDetail.type\"><span class=\"font-weight-600\">{{ loadDetail.name }}</span><br>\n<div class=\"pt-5\" title=\"{{ loadDetail.value }}\">{{ loadDetail.value }}</div></div><div layout=\"column\" flex=\"100\" \nng-repeat=\"loadDetail in vm.lclLoadArray\" \nng-if=\"loadDetail.type === \'package_table\' && !(vm.load_data && vm.load_data.load_type === \'total_shipment\')\" \nclass=\"mb-10\"><div class=\"package-table-container mt-10\"><table class=\"package-table\" \nng-if=\"loadDetail.value.length > 0\"><thead><tr><th class=\"p-8 text-left\">#</th><th class=\"p-8 text-left\" \nng-if=\"vm.hasPackageTypes(loadDetail.value)\">Type</th><th class=\"p-8 text-left\">Qty</th><th class=\"p-8 text-left\">\nDimensions (L×W×H)</th><th class=\"p-8 text-left\">Weight</th><th class=\"p-8 text-left\">Volume</th></tr></thead><tbody>\n<tr ng-repeat=\"pkg in loadDetail.value\"><td class=\"p-8\">{{ $index + 1 }}</td><td class=\"p-8\" \nng-if=\"vm.hasPackageTypes(loadDetail.value)\">{{ pkg.type || \'N/A\' }}</td><td class=\"p-8\">{{ pkg.qty || \'N/A\' }}</td><td\n class=\"p-8\"><span ng-if=\"pkg.length && pkg.breadth && pkg.height\">\n{{ pkg.length | currencyMask:2 }} × {{ pkg.breadth | currencyMask:2 }} × {{ pkg.height | currencyMask:2 }} {{ vm.load_data.load_meta.dimension_unit || \'CMS\' }} \n</span><span ng-if=\"!(pkg.length && pkg.breadth && pkg.height)\">N/A</span></td><td class=\"p-8\"><span \nng-if=\"pkg.weight\">{{ pkg.weight | currencyMask:2 }} {{ vm.load_data.load_meta.input_weight_unit || \'KGs\' }} </span>\n<span ng-if=\"!pkg.weight\">N/A</span></td><td class=\"p-8\"><span ng-if=\"pkg.volume\">\n{{ pkg.volume >= 1000000 ? (pkg.volume / 1000000 | currencyMask:6) + \' CBM\' : (pkg.volume | currencyMask:2) + \' CMQ\' }} \n</span><span ng-if=\"!pkg.volume\">N/A</span></td></tr></tbody></table></div></div></div></div></div><div shimmer-effect \nwidth=\"100%\" height=\"100%\" class=\"b white-bg\" ng-show=\"!vm.getData\"></div><div \nclass=\"Commodity-details b mt-20 white-bg pb-10\" ng-show=\"vm.getData\"><div layout=\"row\" layout-padding \nclass=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" layout-xs=\"column\" flex=\"100\"><div \nclass=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">Commodity Details</div></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" \nng-if=\"vm.permission.commodity[1] && !vm.commodity.length\" layout-padding>Sorry, commodities details not available.\n</div><div layout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"(!vm.permission.commodity[1] && !vm.commodity.length) || (!vm.permission.commodity[1])\">\nYou don\'t have permission to access this section.</div><md-content ms-scroll class=\"max-height-0\" \nng-if=\"vm.permission.commodity[1] && vm.commodity.length\"><div layout=\"row\" flex=\"100\" layout-xs=\"row\" layout-wrap \nclass=\"p-20 font-size-14\" ng-repeat=\"commodity in vm.commodity track by $index\"><div flex-xs=\"30\" flex=\"25\" \nng-class=\"{\'mt-20\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">Cargo Type</span><br><div \nclass=\"pt-15 pr-5\" title=\"{{commodity.cargo_type == null ? \'N/A\' : commodity.cargo_type.name}}\">\n{{commodity.cargo_type == null ? \'N/A\' : commodity.cargo_type.name}} <span \nng-show=\"commodity.hazardous && commodity.imco_code != 0\">(IMCO Code : {{commodity.imco_code}})</span></div></div><div \nflex-xs=\"20\" flex=\"20\" class=\"mr-5\"><span class=\"font-weight-600\">HS Code</span><br><div class=\"pt-15 text-truncate\" \ntitle=\"{{commodity.hs_code==null ? \'N/A\' : commodity.hs_code}}\">{{commodity.hs_code==null ? \'N/A\' : commodity.hs_code}}\n</div></div><div flex-xs=\"50\" flex=\"45\" class=\"mr-5\"><span class=\"font-weight-600\">Commodity</span><br><div \nclass=\"pt-15 word-break-word\" title=\"{{!commodity.name ? \'N/A\' : commodity.name}}\">\n{{!commodity.name ? \'N/A\' : commodity.name}}</div></div><div flex flex-xs=\"50\" \nng-class=\"{\'mt-30\' : vm.util.isMobileDevice}\"><md-icon class=\"mh-5 mt-8 w-15 h-15 pointer\" \nng-click=\"vm.fnOpenCommodityModal(commodity,$index,\'Edit\')\" md-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" \ntitle=\"Edit\" ng-if=\"vm.permission.commodity[2]\"></md-icon><md-icon \nclass=\"ml-5 w-15 h-15 cancel-icon pointer custom-delete\" md-font-icon=\"icon-cancel\" \nng-click=\"vm.fnOpenConfirmDeleteModal(\'commodity\',\'\',commodity._id)\" title=\"Remove\" ng-if=\"vm.permission.commodity[3]\">\n</md-icon></div></div></md-content><div layout=\"row\" layout-align=\"center center\" flex=\"100\" layout-margin \nng-if=\"vm.permission.commodity[0]\" class=\"mt-0\"><md-button md-no-ink class=\"md-link-btn with-icon\" \nng-click=\"vm.fnOpenCommodityModal(\'\',\'\',\'Add\')\" title=\"Add Commodity\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"s14 schedule-icon\"></md-icon><span>Add Commodity</span></md-button></div></div><div shimmer-effect width=\"100%\" \nheight=\"100%\" class=\"b white-bg mt-20\" ng-show=\"!vm.getData\"></div><div class=\"b white-bg mt-20 pb-10\" \nng-show=\"vm.getData &&  (vm.shipment_meta.delivery_address.place_type == \'Door\' || vm.shipment_meta.pickup_address.place_type == \'Door\')\">\n<div layout=\"row\" layout-padding class=\"parties_involved mb-0 pl-0\" layout-xs=\"column\" flex=\"100\" \nng-class=\"{\'border-bottom-withoutOp\':!vm.parties}\" ng-show=\"vm.getData\"><div \nclass=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">Pick Up/Delivery</div></div><div \nlayout=\"column\"><div ng-repeat=\"address_type in [\'origin_address\',\'destination_address\']\" \nng-if=\"vm.shipment_meta[vm.doorCheckArrey[address_type]].place_type == \'Door\'\"><md-expansion-panel \nmd-component-id=\"shipperInfo\" class=\"b mv-10 mh-20\" ng-if=\"vm.shipment_meta[address_type]\">\n<md-expansion-panel-collapsed class=\"pointer\"><div layout=\"row\" flex=\"100\"><div flex=\"50\"><span class=\"font-size-14\">\n{{address_type == \'origin_address\' ? \'Pick Up\' : \'Delivery\'}}</span></div><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><span><md-icon class=\"w-15 h-15 mr-5 pointer\" ng-click=\"vm.fnOpenDoorAddress($event,address_type)\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\"></md-icon><md-expansion-panel-icon></md-expansion-panel-icon>\n</span></div></div></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header \nclass=\"schedule-select\"><div layout=\"row\" flex=\"100\"><div flex=\"50\"><span class=\"font-size-14\">\n{{address_type == \'origin_address\' ? \'Pick Up\' : \'Delivery\'}}</span></div><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><span><md-icon class=\"w-15 h-15 mr-5 pointer\" ng-click=\"vm.fnOpenDoorAddress($event,address_type)\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\"></md-icon><md-expansion-panel-icon class=\"pointer\" \nng-click=\"$panel.collapse()\"></md-expansion-panel-icon></span></div></div></md-expansion-panel-header>\n<md-expansion-panel-content class=\"p-5 font-size-14 opacity\"><div layout=\"row\" flex=\"100\" class=\"p-15\" \nlayout-xs=\"column\" layout-wrap><div flex=\"50\" flex-xs=\"100\"><span class=\"font-weight-600\">Company Name</span><br><div \nclass=\"text-truncate\" \ntitle=\"{{vm.shipment_meta[address_type].company_name ? vm.shipment_meta[address_type].company_name : \'-\'}}\">\n{{vm.shipment_meta[address_type].company_name ? vm.shipment_meta[address_type].company_name : \'-\'}}</div></div><div \nflex=\"50\" flex-xs=\"100\" ng-class=\"{\'mt-10\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">Contact Email\n</span><br><div class=\"text-truncate\" \ntitle=\"{{vm.shipment_meta[address_type].contact_email ? vm.shipment_meta[address_type].contact_email : \'-\'}}\">\n{{vm.shipment_meta[address_type].contact_email ? vm.shipment_meta[address_type].contact_email : \'-\'}}</div></div></div>\n<div layout=\"row\" layout-xs=\"column\" layout-wrap \nng-class=\"{\'pt-0 ph-15 pb-15\' : vm.util.isMobileDevice,\'p-15\' : !vm.util.isMobileDevice}\"><div flex=\"50\" flex-xs=\"100\">\n<span class=\"font-weight-600\">Street Address</span><br><div class=\"text-truncate\" style=\"max-width: 200px\" \ntitle=\"{{vm.shipment_meta[address_type].street_address ? vm.shipment_meta[address_type].street_address : \'-\'}}\">\n{{vm.shipment_meta[address_type].street_address ? vm.shipment_meta[address_type].street_address : \'-\'}}</div></div><div\n flex=\"50\" flex-xs=\"100\" ng-class=\"{\'mt-10\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">City</span><br>\n<div class=\"text-truncate\" title=\"{{vm.shipment_meta[address_type].city ? vm.shipment_meta[address_type].city : \'-\'}}\">\n{{vm.shipment_meta[address_type].city ? vm.shipment_meta[address_type].city : \'-\'}}</div></div></div><div layout=\"row\" \nflex=\"100\" class=\"p-15\" layout-xs=\"column\" layout-wrap><div flex=\"50\" flex-xs=\"100\"><span class=\"font-weight-600\">\nCountry</span><br><div class=\"text-truncate\" \ntitle=\"{{vm.shipment_meta[address_type].country ? vm.shipment_meta[address_type].country : \'-\'}}\">\n{{vm.shipment_meta[address_type].country ? vm.shipment_meta[address_type].country : \'-\'}}</div></div><div flex=\"50\" \nflex-xs=\"100\" ng-class=\"{\'mt-10\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">Postal Code</span><br><div \nclass=\"text-truncate\" \ntitle=\"{{vm.shipment_meta[address_type].postal_code ? vm.shipment_meta[address_type].postal_code : \'-\'}}\">\n{{vm.shipment_meta[address_type].postal_code ? vm.shipment_meta[address_type].postal_code : \'-\'}}</div></div></div>\n</md-expansion-panel-content></md-expansion-panel-expanded></md-expansion-panel><div layout=\"row\" \nlayout-align=\"center center\" layout-padding class=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" flex=\"100\" \nng-if=\"!vm.shipment_meta[address_type]\"><div class=\"font-size-14 pl-5 pb-5\" flex=\"50\">\n{{address_type == \'origin_address\' ? \'Pick Up\' : \'Delivery\'}}</div><div layout=\"row\" layout-align=\"end end\" flex=\"50\">\n<md-button md-no-ink class=\"pl-5 md-link-btn\" ng-click=\"vm.fnOpenDoorAddress($event,address_type)\" \ntitle=\"Add {{address_type == \'origin_address\' ? \'Pick Up\' : \'Delivery\'}}\">+ Add</md-button></div></div></div></div>\n</div><div shimmer-effect width=\"100%\" height=\"100%\" class=\"b white-bg mt-20\" ng-show=\"!vm.getData\"></div><div \nclass=\"b white-bg mt-20 pb-10\" ng-show=\"vm.getData\"><div layout=\"row\" layout-padding \nclass=\"parties_involved mb-0 pl-0\" layout-xs=\"column\" flex=\"100\" ng-class=\"{\'border-bottom-withoutOp\':!vm.parties}\" \nng-show=\"vm.getData\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">Parties Involved</div>\n</div><div layout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"(!vm.permission.parties[1] && !vm.parties.length) || (!vm.permission.parties[1])\">\nYou don\'t have permission to access this section.</div><div layout=\"column\"><md-expansion-panel \nmd-component-id=\"shipperInfo\" class=\"b mv-10 mh-20\" ng-repeat=\"party in vm.parties track by $index\" \nng-if=\"vm.permission.parties[1]\"><md-expansion-panel-collapsed class=\"pointer\"><div layout=\"row\" flex=\"100\"><div \nflex=\"50\"><span class=\"font-size-14\">\n{{(party.category.toLowerCase() == \'notify_party\') ? \'Notify Party\' : (party.category.toLowerCase() == \'shipper\' ? \'Customer\' : (party.category.charAt(0).toUpperCase() + party.category.slice(1)) ) }}\n</span> <span class=\"font-size-10 pv-4 ml-5 expired pink-50-bg font-weight-600\" \nng-if=\"vm.getPartyStatusDisplay(party)\">{{vm.getPartyStatus(party)}}</span></div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><span><md-icon class=\"w-15 h-15 mr-5 pointer\" \nng-click=\"vm.fnOpenNewPartyModal(party,$index,\'Edit\',party.category)\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" ng-if=\"vm.permission.parties[2]\"></md-icon>\n<md-expansion-panel-icon></md-expansion-panel-icon></span></div></div></md-expansion-panel-collapsed>\n<md-expansion-panel-expanded><md-expansion-panel-header class=\"schedule-select\"><div layout=\"row\" flex=\"100\"><div \nflex=\"50\" class=\"font-size-14\">\n{{(party.category.toLowerCase() == \'notify_party\') ? \'Notify Party\' : (party.category.toLowerCase() == \'shipper\' ? \'Customer\' : (party.category.charAt(0).toUpperCase() + party.category.slice(1)) ) }}\n<span class=\"font-size-10 pv-4 ml-5 expired pink-50-bg\" ng-if=\"vm.getPartyStatusDisplay(party)\">\n{{vm.getPartyStatus(party)}}</span></div><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><span><md-icon \nclass=\"w-15 h-15 mr-5 pointer\" md-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" \nng-click=\"vm.fnOpenNewPartyModal(party,$index,\'Edit\',party.category)\" ng-if=\"vm.permission.parties[2]\"></md-icon>\n<md-expansion-panel-icon class=\"pointer\" ng-click=\"$panel.collapse()\"></md-expansion-panel-icon></span></div></div>\n</md-expansion-panel-header><md-expansion-panel-content class=\"p-5 font-size-14 opacity\"><div layout=\"row\" flex=\"100\" \nclass=\"p-15\" layout-xs=\"column\" layout-wrap><div flex=\"30\" flex-xs=\"100\"><span class=\"font-weight-600\">Contact person\n</span><br><div class=\"text-truncate\" title=\"{{party.name ? party.name : \'-\'}}\">{{party.name ? party.name : \'-\'}}</div>\n</div><div flex=\"40\" flex-xs=\"100\" ng-class=\"{\'mt-10\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">Company\n</span><br><div class=\"text-truncate\" title=\"{{party.company_name ? party.company_name : \'-\'}}\">\n{{party.company_name ? party.company_name : \'-\'}}</div></div><div flex=\"20\" flex-xs=\"100\" \nng-class=\"{\'mt-10\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">Email</span><br><div class=\"text-truncate\" \ntitle=\"{{party.email ? party.email : \'-\'}}\">{{party.email ? party.email : \'-\'}}</div></div></div><div layout=\"row\" \nlayout-xs=\"column\" layout-wrap \nng-class=\"{\'pt-0 ph-15 pb-15\' : vm.util.isMobileDevice,\'p-15\' : !vm.util.isMobileDevice}\"><div flex=\"30\" flex-xs=\"100\">\n<span class=\"font-weight-600\">Phone</span><br><div class=\"text-truncate\" \ntitle=\"{{party.contact ? party.contact : \'-\'}}\">{{party.contact ? party.contact : \'-\'}}</div></div><div flex=\"40\" \nflex-xs=\"100\" ng-class=\"{\'mt-10\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">Address</span><br><div \nclass=\"text-truncate\" title=\"{{party.address ? party.address : \'-\'}}\">{{party.address ? party.address : \'-\'}}</div>\n</div><div flex=\"20\" flex-xs=\"100\" ng-class=\"{\'mt-10\' : vm.util.isMobileDevice}\"><span class=\"font-weight-600\">\nExpiry Date</span><br><div title=\"{{party.expiry_date ? (party.expiry_date | UTCToLocal : \'dd/MM/yyyy\') : \'-\'}}\">\n{{party.expiry_date ? (party.expiry_date | UTCToLocal : \'dd/MM/yyyy\') : \'-\'}}</div></div></div><div layout=\"row\" \nlayout-xs=\"column\" layout-wrap \nng-class=\"{\'pt-0 ph-15 pb-15\' : vm.util.isMobileDevice,\'p-15\' : !vm.util.isMobileDevice}\"><div flex=\"40\" flex-xs=\"100\">\n<span class=\"font-weight-600\">External Reference</span><br><div class=\"text-truncate\" \ntitle=\"{{party.external_reference_id ? party.external_reference_id : \'-\'}}\">\n{{party.external_reference_id ? party.external_reference_id : \'-\'}}</div></div></div></md-expansion-panel-content>\n</md-expansion-panel-expanded></md-expansion-panel><div layout=\"row\" layout-align=\"center center\" layout-padding \nclass=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" flex=\"100\" ng-if=\"!vm.partyView.shipper && vm.permission.parties[0]\">\n<div class=\"font-size-14 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">Customer</div><div layout=\"row\" layout-align=\"end end\" \nflex=\"50\" flex-xs=\"100\"><md-button md-no-ink class=\"pl-5 md-link-btn with-icon\" \nng-click=\"vm.fnOpenNewPartyModal(\'\',\'\',\'Add\',\'shipper\',\'\',\'SD-shipper-Add\')\" title=\"Add Customer\">Select</md-button>\n</div></div><div layout=\"row\" layout-align=\"center center\" layout-padding \nclass=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" flex=\"100\" ng-if=\"!vm.partyView.consignee && vm.permission.parties[0]\">\n<div class=\"font-size-14 pl-5 pb-5\" flex=\"50\">Consignee</div><div layout=\"row\" layout-align=\"end end\" flex=\"50\" \nflex-xs=\"100\"><md-button md-no-ink class=\"pl-5 md-link-btn\" \nng-click=\"vm.fnOpenNewPartyModal(\'\',\'\',\'Add\',\'consignee\',\'\',\'SD-consigee-Add\')\" title=\"Add Consignee\">Select\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\" layout-padding \nclass=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" flex=\"100\" ng-if=\"!vm.partyView.consignor && vm.permission.parties[0]\">\n<div class=\"font-size-14 pl-5 pb-5\" flex=\"50\">Consignor</div><div layout=\"row\" layout-align=\"end end\" flex=\"50\" \nflex-xs=\"100\"><md-button md-no-ink class=\"pl-5 md-link-btn\" \nng-click=\"vm.fnOpenNewPartyModal(\'\',\'\',\'Add\',\'consignor\',\'\',\'SD-consignor-Add\')\" title=\"Add Consignor\">Select\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\" layout-padding \nclass=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" flex=\"100\" \nng-if=\"!vm.partyView.notifyParty && vm.permission.parties[0]\"><div class=\"font-size-14 pl-5 pb-5\" flex=\"50\">\nNotify Party</div><div layout=\"row\" layout-align=\"end end\" flex=\"50\"><md-button md-no-ink class=\"pl-5 md-link-btn\" \nng-click=\"vm.fnOpenNewPartyModal(\'\',\'\',\'Add\',\'notify_party\',\'\',\'SD-notify party-Add\')\" title=\"Add Notify Party\">\n+ Add/Select</md-button></div></div><div layout=\"row\" layout-align=\"center center\" layout-padding \nclass=\"mh-15 mb-0 pl-0\" flex=\"100\" \nng-if=\"!vm.partyView.shippers && vm.permission.parties[0] && vm.showShippersInParties\"><div \nclass=\"font-size-14 pl-5 pb-5\" flex=\"50\">Shippers</div><div layout=\"row\" layout-align=\"end end\" flex=\"50\"><md-button \nmd-no-ink class=\"pl-5 md-link-btn\" ng-click=\"vm.fnOpenNewPartyModal(\'\',\'\',\'Add\',\'Shippers\',\'\',\'SD-shippers-Add\')\" \ntitle=\"Add CHA\">+ Add</md-button></div></div></div></div></div><div layout=\"column\" flex=\"33\" class=\"LHS_div\"><div \nshimmer-effect width=\"100%\" height=\"100%\" ng-show=\"!vm.getData\" class=\"b white-bg\"></div><div class=\"schedule-details\" \nng-if=\"vm.shipment_meta.mode != \'AIR\' && vm.getData\"><div class=\"schedule-select b mt-20 white-bg\"><div layout=\"row\" \nlayout-padding class=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" layout-xs=\"column\" flex=\"100\"><div \nclass=\"font-size-16 font-weight-600 pl-5\" flex=\"50\" flex-xs=\"100\">Schedule Details</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"50\" flex-xs=\"100\" ng-if=\"vm.permission.schedule[0] || vm.permission.schedule[2]\" \nclass=\"pb-5\"><md-button md-no-ink class=\"md-link-btn with-icon m-0\" ng-click=\"vm.fnOpenSelectScheduleModal($event)\" \ntitle=\"Select new schedule\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s14 schedule-icon\"></md-icon><span>\nSelect new schedule</span></md-button></div></div><div layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.permission.schedule[1] && !vm.schedule && vm.getData\" layout-padding class=\"mv-10\"><span \nclass=\"mb-10 font-size-16 text-italic\">Sorry, No schedule details are available.</span><md-button md-no-ink \nclass=\"md-link-btn with-icon\" ng-if=\"vm.permission.schedule[0]\" ng-click=\"vm.fnOpenScheduleEdit(\'\',\'\',\'Add New\')\" \ntitle=\"Add shipment leg\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s14 schedule-icon\"></md-icon><span>\nAdd Schedule</span></md-button></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"(!vm.permission.schedule[1] && !vm.schedule) || (!vm.permission.schedule[1])\">\nYou don\'t have permission to access this section.</div><div class=\"m-15 pl-0\" \nng-if=\"vm.permission.schedule[1] && vm.schedule\"><div class=\"card_text_bold\">\n{{ vm.schedule.schedule_track.length > 2 ? (vm.schedule.schedule_track.length-2 +\'Transhipment\') : \'Direct\' }} - <span>\n{{vm.schedule.transit_time}}</span></div><div layout=\"row\"><div class=\"Etd_div\"><p class=\"card_text_bold\">ETD</p><p \nclass=\"card_text_normal\">{{vm.schedule.departure_time | UTCToLocal : \'d MMM yyyy\'}}</p><p class=\"card_text_normal\">\n{{vm.schedule.departure_time | UTCToLocal : \'EEEE\'}}</p></div><div class=\"eta_div\"><p class=\"card_text_bold\">ETA</p><p \nclass=\"card_text_normal\">{{vm.schedule.arrival_time | UTCToLocal : \'d MMM, yyyy\'}}</p><p class=\"card_text_normal\">\n{{vm.schedule.arrival_time | UTCToLocal : \'EEEE\'}}</p></div></div></div><div class=\"m-15 pl-0\" \nng-if=\"vm.permission.schedule[1] && vm.schedule && !vm.maskLiner && !vm.sharedMaskLiner\"><div layout=\"row\"><div \nclass=\"Etd_div\"><p class=\"card_text_bold\">Vessel</p><p class=\"card_text_normal\">{{vm.schedule.vessel}}</p></div><div \nclass=\"eta_div\"><p class=\"card_text_bold\">Voyage Reference</p><p class=\"card_text_normal\">{{vm.schedule.voyage}}</p>\n</div></div></div></div><div class=\"b white-bg schedule_route\" ng-if=\"vm.permission.schedule[1] && vm.schedule\"><div \nclass=\"pr-10\" layout=\"column\" ng-class=\"{\'ml-20\' : !vm.util.isMobileDevice}\"><div layout=\"column\" class=\"ph-15\" \nng-class=\"{\'pt-15\':$first, \'pb-15\':$last}\" ng-repeat=\"schedule_track in vm.schedule.schedule_track track by $index\">\n<div layout=\"row\" class=\"show_schedule pt-5\" ng-if=\"($first || $last)\"><div flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" \nclass=\"pr-10 w-80\" ng-class=\"{\'mt-12\':!$first}\" ng-if=\"!$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 mt-12\" ng-if=\"$last\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"ship_schedule_sect\" ng-class=\"{\'border-left\' : !$last,\'mt-10\': $first}\"><p \nclass=\"card_text_bold source_name text-truncate schedule_port_name\"><md-icon md-font-icon=\"icon-flickr-after\" \nclass=\"blue-dot font-size-25 mr-10\"></md-icon><span><md-icon class=\"mr-5\" \nmd-svg-src=\"assets/icons/custom/icon-ship.svg\"></md-icon></span><span class=\"port-name\" \ntitle=\"{{schedule_track.port_name}}\">{{ schedule_track.port_name }}</span></p><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\" class=\"edit_schedule pointer\" ng-if=\"!$last && vm.permission.schedule[2]\"><md-icon class=\"mh-5 w-15 h-15\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" ng-click=\"vm.fnOpenScheduleEdit(schedule_track,$index,\'Edit\')\" \ntitle=\"Edit Details\"></md-icon></div><div layout=\"column\" ng-if=\"!$last && !vm.maskLiner && !vm.sharedMaskLiner\" \nclass=\"mb-20\"><div layout=\"row\"><div class=\"track_text\" flex>VGM Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.vgm_cutoff ? (schedule_track.vgm_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\' }}</div></div><div \nlayout=\"row\"><div class=\"track_text\" flex>Port Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.port_cutoff ? (schedule_track.port_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\'}}</div></div><div\n layout=\"row\"><div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.service_name ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.vessel ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" flex>\nVoyage Ref.</div><div class=\"track_text eta_div\" flex>{{ schedule_track.voyage ? schedule_track.voyage : \'NA\'}}</div>\n</div></div></div></div><div layout=\"row\" ng-if=\"(!$first && !$last)\" class=\"mv-20\"><div flex-md=\"20\" flex-sm=\"20\" \nflex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.arrival_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p \nclass=\"card_text_bold source_name schedule_port_name\"><md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot\">\n</md-icon><span><md-icon class=\"icon-class\" md-svg-src=\"assets/icons/custom/icon-ship.svg\"></md-icon></span><span>\n{{ schedule_track.port_name }} </span><span>(Arrival)</span></p><div layout=\"row\" layout-align=\"end end\" flex=\"100\" \nclass=\"edit_schedule pointer\" ng-if=\"!$last && vm.permission.schedule[2]\"><md-icon class=\"mh-5 w-15 h-15\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" ng-click=\"vm.fnOpenScheduleEdit(schedule_track,$index,\'Edit\')\" \ntitle=\"Edit Details\"></md-icon></div></div></div><div layout=\"row\" ng-if=\"(!$first && !$last)\"><div flex-md=\"20\" \nflex-sm=\"20\" flex-xs=\"20\" class=\"pr-10 w-80 schedule_track_margin\"><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }}</p><p class=\"font-size-12 mv-5 mh-0 text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</p><p class=\"font-size-10 mv-5 mh-0 grey-fg text-end\">\n{{ schedule_track.departure_time | UTCToLocal : \'EEE\' | uppercase }}</p></div><div flex-md=\"80\" flex-sm=\"80\" \nflex-xs=\"80\" class=\"schedule_sect\" ng-class=\"{\'border-left\' : !$last}\"><p \nclass=\"card_text_bold text-truncate source_name schedule_port_name\"><md-icon md-font-icon=\"icon-flickr-after\" \nclass=\"blue-dot\"></md-icon><span><md-icon class=\"icon-class\" md-svg-src=\"assets/icons/custom/icon-ship.svg\"></md-icon>\n</span><span class=\"port-name\" title=\"{{schedule_track.port_name}}\">{{ schedule_track.port_name }} </span><span \ntitle=\"(departure)\">(Departure)</span></p><div layout=\"row\" layout-align=\"end end\" flex=\"100\" \nclass=\"edit_schedule pointer\" ng-if=\"!$last && vm.permission.schedule[2]\"><md-icon class=\"mh-5 w-15 h-15\" \nmd-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" ng-click=\"vm.fnOpenScheduleEdit(schedule_track,$index,\'Edit\')\" \ntitle=\"Edit Details\"></md-icon></div><div layout=\"column\" class=\"pb-20\" ng-if=\"!vm.maskLiner && !vm.sharedMaskLiner\">\n<div layout=\"row\"><div class=\"track_text\" flex>VGM Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.vgm_cutoff ? (schedule_track.vgm_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\' }}</div></div><div \nlayout=\"row\"><div class=\"track_text\" flex>Port Cutoff</div><div class=\"track_text eta_div\" flex>\n{{ schedule_track.port_cutoff ? (schedule_track.port_cutoff | UTCToLocal : vm.util.dateFormat) : \'NA\'}}</div></div><div\n layout=\"row\"><div class=\"track_text\" flex>Service</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.service_name != \"\" ? schedule_track.service_name : \'NA\'}}</div></div><div layout=\"row\"><div \nclass=\"track_text\" flex>Vessel</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.vessel != \"\" ? schedule_track.vessel : \'NA\'}}</div></div><div layout=\"row\"><div class=\"track_text\" \nflex>Voyage Ref.</div><div class=\"track_text eta_div\" flex>\n{{schedule_track.voyage != \"\" ? schedule_track.voyage : \'NA\'}}</div></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\" ng-if=\"vm.schedule && vm.permission.schedule[0]\"><md-button md-no-ink \nclass=\"md-link-btn with-icon mb-15\" ng-click=\"vm.fnOpenScheduleEdit(\'\',\'\',\'Add\')\" title=\"Add shipment leg\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s14 schedule-icon\"></md-icon><span>Add Schedule Leg</span></md-button></div>\n</div></div></div><div class=\"addition-services b mt-20 white-bg\" hide><div layout=\"row\" layout-padding \nclass=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" layout-xs=\"column\" flex=\"100\"><div \nclass=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">Additional Services</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"50\" flex-xs=\"100\"><md-icon class=\"mh-5 w-15 h-15 pointer\" \nng-click=\"vm.fnOpenAddtionalService($event)\" md-svg-src=\"assets/icons/custom/ship-edit-icon.svg\"></md-icon></div></div>\n<div layout=\"row\" flex=\"100\" class=\"p-5\"><div class=\"border-right m-15\" flex=\"50\"><span class=\"font-weight-600\">\nInsurance</span><br><div>$ 230</div><br><span class=\"font-weight-600\">Temerature Control</span><br><div>35 °C</div>\n</div><div flex=\"50\" layout=\"column\" class=\"p-15\"><div class=\"pb-5\">Zone Regulation</div><div class=\"pb-5\">Customs\n</div><div class=\"pb-5\">Fumigationn</div><div class=\"pb-5\">Zone Regulation</div><div class=\"pb-5\">Customs</div><div \nclass=\"pb-5\">Fumigationn</div></div></div></div><div class=\"schedule-details\" \nng-if=\"vm.shipment_meta.mode === \'AIR\' && vm.getData\"><div class=\"schedule-select b mt-20 white-bg\"><div layout=\"row\" \nlayout-padding class=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" layout-xs=\"column\" flex=\"100\"><div \nclass=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">Schedule Details</div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"50\" flex-xs=\"100\" \nng-if=\"(vm.permission.schedule[0] || vm.permission.schedule[2]) && vm.schedule\"><span class=\"pointer\" \ntitle=\"Select new schedule\"><md-icon class=\"mh-10 w-15 h-15\" md-svg-src=\"assets/icons/custom/ship-edit-icon.svg\" \nng-click=\"vm.fnOpenAirSchedule(vm.schedule,$index,\'Edit\',\'\', \'AIR\')\" title=\"Edit Details\"></md-icon></span><span \nclass=\"pointer\" title=\"Delete schedule\"><md-icon md-svg-src=\"assets/icons/custom/delete-icon.svg\" \nng-click=\"vm.fnOpenConfirmDeleteModal(\'air-schedule\')\" class=\"mh-5 w-15 h-15\"></md-icon></span></div></div><div \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.permission.schedule[1] && !vm.schedule\" layout-padding \nclass=\"mv-10\"><span class=\"mb-10 font-size-16 text-italic\">Sorry, No schedule details are available.</span><md-button \nmd-no-ink class=\"md-link-btn with-icon\" ng-if=\"vm.permission.schedule[0]\" \nng-click=\"vm.fnOpenAirSchedule(\'\',\'\',\'Add New\',\'\', \'AIR\')\" title=\"Add shipment leg\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s14 schedule-icon\"></md-icon><span>Add Schedule</span></md-button></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" layout-padding \nng-if=\"(!vm.permission.schedule[1] && !vm.schedule) || (!vm.permission.schedule[1])\">\nYou don\'t have permission to access this section.</div><div class=\"border-bottom-opacity mb-15 p-15\" layout=\"column\" \nng-if=\"vm.permission.schedule[1] && vm.schedule\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"Etd_div\"><p class=\"card_text_bold\">Departure Date and time</p><p class=\"card_text_normal\"><span class=\"mr-5\">\n{{vm.schedule.departure_time | UTCToLocal : \'dd MMM yyyy\'}} </span><span>\n{{vm.schedule.departure_time | UTCToLocal : \'HH:mm\'}}</span></p></div><div class=\"eta_div\"><p class=\"card_text_bold\">\nArrival Date and Time</p><p class=\"card_text_normal\"><span class=\"mr-5\">\n{{vm.schedule.arrival_time | UTCToLocal : \'dd MMM yyyy\'}} </span><span>\n{{vm.schedule.arrival_time | UTCToLocal : \'HH:mm\'}}</span></p></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-10\"><div class=\"Etd_div text-left\"><p class=\"card_text_bold\">Days of Service</p>\n<span class=\"card_text_normal\" ng-if=\"vm.schedule.service_days.length\" \nng-repeat=\"days in vm.schedule.service_days track by $index\">{{days}} <span ng-show=\"!$last\">,</span></span><p \nclass=\"card_text_normal mb-0\" ng-if=\"!vm.schedule.service_days.length\">N/A</p></div><div class=\"Etd_div text-left\"><p \nclass=\"card_text_bold\">Transit Time</p><p class=\"card_text_normal mb-0\">\n{{(vm.schedule.air_transit_time && (vm.schedule.air_transit_time.hh || vm.schedule.air_transit_time.mm)) ? ( (vm.schedule.air_transit_time.hh ? (\'0\' + vm.schedule.air_transit_time.hh).slice(-2) : \'00\')+ \':\' + (vm.schedule.air_transit_time.mm ?(\'0\' + vm.schedule.air_transit_time.mm).slice(-2) : \'00\')+ \' hrs\' ) : \'N/A\'}}\n</p></div><div class=\"Etd_div text-left\"><p class=\"card_text_bold\">Non-stop</p><p class=\"card_text_normal mb-0\">\n{{vm.schedule.non_stop == true ? \'Yes\' : \'No\' }}</p></div></div></div><div class=\"white-bg schedule_route\" \nng-if=\"vm.permission.schedule[1] && vm.schedule\"><div class=\"pr-10 ml-20\" layout=\"column\"><p class=\"card_text_bold\">\nSchedules</p><div layout=\"column\" class=\"p-15\"><div layout=\"row\" class=\"show_schedule pt-5 mb-20\" \nng-if=\"vm.schedule.origin_port\"><div flex=\"100\" class=\"ship_schedule_sect border-left pb-30\"><p \nclass=\"card_text_bold source_name mb-0 text-truncate\"><md-icon md-font-icon=\"icon-flickr-after\" \nclass=\"blue-dot font-size-25 mr-10\"></md-icon><span class=\"port-name\" ng-class=\"{\'ml-30\':vm.util.isXSScreen}\" \ntitle=\"{{vm.schedule.origin_port_name}}\">{{vm.schedule.origin_port}} - {{vm.schedule.origin_port_name}}</span></p><div \nclass=\"departure-sec\" ng-if=\"vm.schedule.departure_time\"><p class=\"font-size-12 mv-5 mh-0 grey-fg\">Departures</p><p \nclass=\"font-size-12 mv-5\"><span class=\"mr-10\">{{ vm.schedule.departure_time | UTCToLocal : \'dd MMM yyyy\' }} </span>\n<span>{{ vm.schedule.departure_time | UTCToLocal : \'HH:mm\' }}</span></p></div></div></div><div layout=\"row\" \nclass=\"show_schedule pt-5 mb-20\" ng-repeat=\"schedule_track in vm.schedule.schedule_track track by $index\"><div \nflex=\"100\" class=\"ship_schedule_sect border-left pb-30\"><p class=\"card_text_bold source_name mb-0 text-truncate\">\n<md-icon md-font-icon=\"icon-flickr-after\" class=\"blue-dot font-size-25 mr-10\"></md-icon><span class=\"port-name\" \nng-class=\"{\'ml-30\':vm.util.isXSScreen}\" title=\"{{schedule_track.port_name}}\">\n{{schedule_track.port_code}} - {{schedule_track.port_name}}</span></p><div layout=\"row\"><div class=\"arrival-sec mr-30\">\n<p class=\"font-size-12 mv-5 mh-0 grey-fg\">Arrival</p><p class=\"font-size-12 mv-5\" ng-if=\"schedule_track.arrival_time\">\n<span class=\"mr-12\">{{ schedule_track.arrival_time | UTCToLocal : \'dd MMM yyyy\' }} </span><span>\n{{ schedule_track.arrival_time | UTCToLocal : \'HH:mm\' }}</span></p><p class=\"font-size-12 mv-5\" \nng-if=\"!schedule_track.arrival_time\"><span class=\"mr-12\">NA</span></p></div><div class=\"departure-sec\"><p \nclass=\"font-size-12 mv-5 mh-0 grey-fg\">Departures</p><p class=\"font-size-12 mv-5\" \nng-if=\"schedule_track.departure_time\"><span class=\"mr-10\">\n{{ schedule_track.departure_time | UTCToLocal : \'dd MMM yyyy\' }} </span><span>\n{{ schedule_track.departure_time | UTCToLocal : \'HH:mm\' }}</span></p><p class=\"font-size-12 mv-5\" \nng-if=\"!schedule_track.departure_time\"><span class=\"mr-12\">NA</span></p></div></div></div></div><div layout=\"row\" \nclass=\"show_schedule pt-5\" ng-if=\"vm.schedule.destination_port\"><div flex=\"100\" class=\"ship_schedule_sect\"><p \nclass=\"card_text_bold source_name mb-0 text-truncate\"><md-icon md-font-icon=\"icon-flickr-after\" \nclass=\"blue-dot font-size-25 mr-10\"></md-icon><span class=\"port-name\" ng-class=\"{\'ml-30\':vm.util.isXSScreen}\" \ntitle=\"{{vm.schedule.destination_port_name}}\">{{vm.schedule.destination_port}} - {{vm.schedule.destination_port_name}}\n</span></p><div class=\"arrival-sec mr-30\" ng-if=\"vm.schedule.arrival_time\"><p class=\"font-size-12 mv-5 mh-0 grey-fg\">\nArrival</p><p class=\"font-size-12 mv-5\"><span class=\"mr-10\">\n{{ vm.schedule.arrival_time | UTCToLocal : \'dd MMM yyyy\' }} </span><span>\n{{ vm.schedule.arrival_time | UTCToLocal : \'HH:mm\' }}</span></p></div></div></div></div></div></div></div></div></div>\n<div layout=\"column\" flex=\"33\"><div id=\"shipment-feed\"><div shimmer-effect width=\"100%\" height=\"100%\" \nng-show=\"!vm.getData || vm.spinRefreshIcon\" class=\"b white-bg mb-20\"></div><div ng-show=\"vm.getData\" \nclass=\"b mt-20 white-bg\"><div layout=\"row\" layout-padding class=\"border-bottom-withoutOp mh-15 mb-0 pl-0\" \nlayout-align=\"space-between\" flex=\"100\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5\" flex=\"50\" flex-xs=\"100\">\nUpdates</div></div><div layout=\"column\" layout-align=\"center center\" class=\"mv-10 font-size-16 text-italic\" \nlayout-padding ng-if=\"!vm.permission.activity_feed[1] && !vm.permission.status[1]\">\nYou don\'t have permission to access this section.</div><div ng-if=\"vm.permission.status[1]\"><div layout=\"column\" \nclass=\"ph-15 font-size-14\" ng-repeat=\"status in vm.statusData track by $index\" ng-show=\"vm.getData\"><div layout=\"row\" \nclass=\"mt-10\"><div><md-icon class=\"avatar-wrapper mt-0 md-link-fg s30\" md-font-icon=\"icon-checkbox-marked-circle\">\n</md-icon></div><div class=\"pl-15 pr-20\"><span class=\"ship_text\">{{status.status}}</span><br><span \nclass=\"font-size-10 opacity\">{{status.milestone_date| UTCToLocal : \'d MMM yyyy, h:mm a\'}}</span></div></div><div \nng-if=\"!$last\"><span class=\"vertical_seperator\"></span></div></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"font-size-16 text-italic\" layout-padding ng-if=\"vm.statusData.length==0\">Sorry, status not available.</div>\n</div><div ng-if=\"vm.permission.activity_feed[1]\"><div ng-repeat=\"activity in vm.feedData track by $index\" \nng-if=\"vm.permission.activity_feed[1]\" ng-show=\"vm.getData\" class=\"feed-div\"><div compile-html=\"activity.feed\"></div>\n</div><div class=\"white-bg mb-10\" ng-if=\"vm.permission.activity_feed[0]\" ng-show=\"vm.getData\"><div layout=\"column\" \nclass=\"p-15 brad-4 font-size-14 pointer\"><ng-ckeditor ng-model=\"vm.postText\" \nng-config=\"vm.shipmentUpdatesEditorConfig\"></ng-ckeditor><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"mt-15\"><div class=\"fg-4a4a4a font-size-18 Font-Bold pt-10\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.send_notification\" ng-click=\"vm.trackEvent(\'\',\'\',\'\',\'SD-Update-SendNotification-click\')\" \nclass=\"md-primary\">Send Notification</md-checkbox></div><md-button md-no-ink class=\"md-accent-btn m-0\" \nng-disabled=\"vm.disabledPost\" ng-click=\"vm.fnSubmitPost()\" title=\"Post\">Post</md-button></div></div></div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\" ng-if=\"vm.feedData\" hide><md-button md-no-ink \nclass=\"pointer load_more text-capitalize\" flex=\"100\" title=\"Load more...\">Load More ...</md-button></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/shipments/tabs/tracking/tracking.html","<div id=\"shipment-tracking\" ng-if=\"vm.trackMode!==\'AIR\'\"><div layout=\"column\" class=\"shipment_info\" \nng-show=\"!vm.getData\"><div shimmer-effect width=\"100%\" height=\"100%\" layout=\"row\"></div></div><div layout=\"column\" \nclass=\"shipment_info\" ng-if=\"vm.getData\"><div ng-if=\"vm.noData && !vm.trackUrl\" class=\"ph-20 pt-5\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div layout=\"row\" layout-align=\"center center\"><h2>\n{{vm.showNoData || \'No Data Available\' }}</h2></div></div><div ng-if=\"vm.noData && vm.trackUrl\" class=\"ph-20 pt-5\" \nlayout=\"row\" layout-align=\"center center\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nclass=\"m-0 mv-20 p-5\"><a class=\"pointer md-link-fg Font-Bold font-size-16\" ng-click=\"vm.openTargetUrl(vm.trackUrl)\">\nTrack Here<md-icon md-font-icon=\"icon-arrow-right\" class=\"md-link-fg s16 ml-5\"></md-icon></a></div></div><div \nclass=\"refresh-container mt-20\" layout=\"row\" layout-align=\"end center\" flex=\"100\" ng-if=\"!vm.noData\"><div \nclass=\"pointer md-primary-fg\" layout=\"row\" layout-align=\"end start\" flex><md-button md-no-ink \nng-click=\"vm.getMilestoneData();vm.spinRefreshIcon = true;vm.getData = false;\" ng-disabled=\"vm.spinRefreshIcon\" \nclass=\"md-link-btn with-icon\" title=\"Refresh Tracking\"><md-icon md-font-icon=\"icon-sync\" class=\"s16\" \nng-class=\"{\'fa-spin\': vm.spinRefreshIcon}\"></md-icon><span class=\"pl-5\"><b>Refresh</b></span></md-button></div></div>\n<md-tabs md-dynamic-height md-border-bottom id=\"track-tabs\" ng-if=\"!vm.noData\"><md-tab label=\"Milestone\"><md-content>\n<div class=\"simple-table-container\"><div class=\"white-bg shipper_table mt-20\"><table \nclass=\"dataTable row-border hover\" id=\"container_table\" datatable=\"\" dt-options=\"vm.dtTrackingOptions\" \ndt-columns=\"vm.dtTrackingColumns\" dt-instance=\"vm.dtTrackingInstanceCallback\"></table></div></div></md-content>\n</md-tab></md-tabs></div></div><div ng-if=\"vm.trackMode===\'AIR\'\"><div class=\"air-tracking\"><div class=\"header\"><span>\nTrack and Trace</span></div><div class=\"tracking-details\"><div><div><span class=\"font-bold\">Rate ID</span> <input \ntype=\"text\" value=\"{{vm.shipmentService.shipmentManagementObj.shipment_meta.additional_attributes.rateId}}\"></div><div>\n<span class=\"font-bold\">Flight UUID</span> <input type=\"text\" \nvalue=\"{{vm.shipmentService.shipmentManagementObj.shipment_meta.additional_attributes.flightUUID}}\"></div><div><span \nclass=\"font-bold\">MAWB</span> <input type=\"text\" \nvalue=\"{{vm.shipmentService.shipmentManagementObj.shipment_meta.awb_object.mawb}}\"></div></div><div><md-tooltip \nmd-direction=\"top\" ng-if=\"vm.milestoneToggle.isHide\">Please refresh to know the updated status</md-tooltip><button \nmd-no-ink class=\"md-accent-btn w-130\" ng-click=\"vm.toggleMilestoneHandler()\" \nng-disabled=\"vm.milestoneToggle.btnText==\'Refresh\' && vm.milesStone.events[0].eventCode==\'confirmed\'\">\n{{vm.milestoneToggle.btnText}}</button></div></div><div ng-if=\"vm.milestoneToggle.isHide && vm.trackResLoaded\" \nclass=\"simple-table-container\"><div class=\"milesStone-header\"><span>Milestone</span></div><div \nclass=\"milesStone_table\" ng-if=\"vm.milesStone.events.length\"><table dt-options=\"vm.dtOptionsAir\" \nclass=\"dataTable row-border mileStoneTable row-border hover\" id=\"milesStone_tables\" datatable=\"ng\"><thead><tr><th><span\n class=\"file_heading column-title ml-15\">MAWB</span></th><th><span class=\"file_heading column-title\">Flight No</span>\n</th><th><span class=\"file_heading column-title\">Current Status</span></th><th><span class=\"file_heading column-title\">\nLocation</span></th><th><span class=\"file_heading column-title\">Origin Airport</span></th><th><span \nclass=\"file_heading column-title\">Destination Airport</span></th><th><span class=\"file_heading column-title\">Updated On\n</span></th></tr></thead><tbody><tr ng-repeat=\"milesStone in vm.milesStone.events track by $index\"><td>\n{{vm.milesStone.awb_number}}</td><td><span class=\"flight-no\">{{milesStone.flight_number}}</span><br><span>\n{{vm.milesStone.airline.name}}</span></td><td>{{milesStone.eventCode}}</td><td>{{milesStone.eventLocation}}</td><td>\n{{milesStone.origin}}</td><td>{{milesStone.destination}}</td><td>{{milesStone.updated_at | UTCToLocal : \'d MMM yyyy\' }}\n</td></tr></tbody></table></div><div class=\"text-center p-20\" ng-if=\"!vm.milesStone.events.length\"><span \nclass=\"font-size-15\">No data available</span></div></div><div shimmer-effect class=\"pb-10\" \nng-if=\"vm.milestoneToggle.isHide && !vm.trackResLoaded\"></div></div></div>");
$templateCache.put("app/main/track-n-trace/dialogs/add-milestone/add-milestone.html","<md-dialog id=\"add-milestone\"><form name=\"taskForm\" class=\"md-inline-form\" \nng-submit=\"ctrl.parent.submitMilestone(ctrl.parent.milestoneData)\" novalidate><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><b>\n{{ (ctrl.parent.isMilestoneUpdate) ? \'EDIT\' : \'ADD\' }} </b>AIR FREIGHT MILESTONE</span><md-button md-no-ink \nclass=\"md-icon-button\" ng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-0\" ms-scroll><div \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" class=\"p-20\" layout-align=\"space-around start\"><md-input-container \nmd-no-float class=\"inline-flex m-0 mr-20\" flex flex-xs=\"100\"><md-select ng-model=\"ctrl.parent.milestoneData.code\" \nplaceholder=\"Select Air Freight Milestone\" class=\"b brad-5 h-40 pl-10\" md-on-close=\"searchMilestone = \'\'\">\n<md-select-header><input ng-model=\"searchMilestone\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Search Milestone\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"milestone in ctrl.parent.milestonesList | filter : searchMilestone\" ng-value=\"milestone.code\">\n{{ milestone.desc + \' - \' + milestone.code }}</md-option></md-select></md-input-container><md-input-container \nmd-no-float class=\"inline-flex m-0 b white-bg brad-5 mt-2\" flex flex-xs=\"100\"><md-autocomplete \nmd-input-name=\"port_code\" md-selected-item=\"ctrl.parent.portData\" md-search-text=\"ctrl.parent.air_originSearchText\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.air_originSearchText,\'AIR\')\" md-item-text=\"item.portcode_portname\" \nmd-min-length=\"2\" md-no-cache=\"false\" md-delay=\"300\" md-require-match=\"true\" placeholder=\"Select AirLine Port\" \nmd-menu-class=\"autocomplete-custom-template\" md-clear-button=\"false\"><md-item-template><span class=\"item-metadata\">\n{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{ctrl.parent.air_originSearchText}}\" were found.</md-not-found></md-autocomplete>\n</md-input-container></div><md-divider class=\"dashed-border\"></md-divider><div layout=\"row\" layout-xs=\"column\" \nflex=\"100\" class=\"p-20 mt-15\" layout-padding><div flex flex-xs=\"100\"><div class=\"b brad-5 p-8\"><span><md-icon \nmd-font-icon=\"icon-calendar-clock\n                            \" class=\"grey-fg mr-10\"></md-icon></span><input \nclass=\"form-control dateTimePickerInput\" ng-model=\"ctrl.parent.milestoneData.time_stamp_actual2\" start-view=\"month\" \nplaceholder=\"Event Actual Date\" format=\"DD/MM/YYYY hh:mm a\" \nmoment-picker=\"ctrl.parent.milestoneData.time_stamp_actual\" title=\"Event Actual Date\"></div></div><div flex \nflex-xs=\"100\"><div class=\"b brad-5 p-8\"><span><md-icon md-font-icon=\"icon-calendar-clock\n                            \" \nclass=\"grey-fg mr-10\"></md-icon></span><input class=\"form-control dateTimePickerInput\" \nng-model=\"ctrl.parent.milestoneData.time_stamp_planned2\" start-view=\"month\" placeholder=\"Event Planned Date\" \nformat=\"DD/MM/YYYY hh:mm a\" title=\"Event Planned Date\" moment-picker=\"ctrl.parent.milestoneData.time_stamp_planned\">\n</div></div></div><div class=\"mt-8 ml-8\"><md-input-container md-no-float class=\"inline-flex m-0 input_container\" flex>\n<input class=\"input_box\" ng-model=\"ctrl.parent.milestoneData.flight_number\" placeholder=\"Flight No.\">\n</md-input-container></div><div class=\"load_detail_div\"><div class=\"font-weight-600 font-size-16\">Load Details</div>\n<div layout=\"row\" layout-xs=\"column\" class=\"mt-10\"><div flex class=\"mr-20\"><div layout=\"row\" flex=\"100\" class=\"flex\">\n<md-input-container md-no-float class=\"h-40 b pieces-border-radius\"><input class=\"border-none ml-0 pl-5\" type=\"number\" \nng-model=\"ctrl.parent.milestoneData.no_of_pieces\" name=\"length\" min=\"1\" placeholder=\"Pieces\"></md-input-container>\n<md-input-container md-no-float class=\"h-40 br bt bb\"><input class=\"border-none ml-0 pl-5\" type=\"number\" \nng-model=\"ctrl.parent.milestoneData.weight.value\" name=\"breadth\" min=\"1\" placeholder=\"Weight\"></md-input-container>\n<md-input-container class=\"bb bt br h-40 kgs-radius\" md-no-float><md-select name=\"dimension_unit\" \nng-model=\"ctrl.parent.milestoneData.weight.UOM\" placeholder=\"KG\" disabled=\"disabled\"><md-option value=\"KG\" \nselected=\"selected\">KG</md-option></md-select></md-input-container></div></div></div></div><div \nclass=\"font-weight-600 font-size-14 pl-25\">Description</div><div class=\"mt-8 ph-25\" flex><md-input-container \nmd-no-float class=\"mh-0 mt-0 inputWidth-100\"><textarea name=\"terms\" ng-model=\"ctrl.parent.milestoneData.details\" \nclass=\"input_box\" rows=\"3\" max-rows=\"3\" ng-focus=\"ctrl.parent.terms_condition_focus(\'termsConditions\')\" \nng-keyup=\"ctrl.parent.terms_condition_key_up($event,\'termsConditions\')\" id=\"termsConditions\"></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions><div layout=\"row\" layout-align=\"end end\" flex=\"100\">\n<md-button md-no-ink class=\"md-primary-btn mr-10\" ng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel\">Cancel\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"CONFIRM\">Confirm</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/track-n-trace/dialogs/confirm-sea-delete/confirm-sea-delete.html","<md-dialog id=\"confirm-delete-modal\" class=\"popup-xs\"><form name=\"deleteForm\" class=\"md-inline-form\" \nng-submit=\"ctrl.parent.deleteSeaTrack(ctrl.parent.deleteSeaData)\"><md-dialog-content class=\"body\"><div layout=\"column\" \nlayout-align=\"center start \"><p>Are you sure want to delete container No <span>\n\"{{ ctrl.parent.deleteSeaData.container_id }}\" </span>?</p></div><div layout=\"row\" layout-align=\"start center\" flex \nflex-xs=\"100\" class=\"note-text pt-10\"><div>Note : Once deleted this data will be marked as archived</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.closeDialog();ctrl.parent.fnTrackAnalytics(\'TT-TrackListData-Delete-No-Click\')\" title=\"No\">No\n</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" type=\"submit\" title=\"Yes\" \nng-click=\"ctrl.parent.fnTrackAnalytics(\'TT-TrackListData-Delete-Yes-Click\')\">Yes</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/track-n-trace/dialogs/edit-sea-track/edit-sea-track.html","<md-dialog id=\"shipment-edit\" class=\"popup-sm\"><form name=\"editForm\" class=\"md-inline-form\" \nng-submit=\"ctrl.parent.submitSeaTracking(ctrl.parent.EditContainerData, \'edit\')\"><md-toolbar \nclass=\"header-dialog white-bg black-fg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Edit Track and Trace</span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" class=\"fg-AAA8AD\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pd-0\" ms-scroll><div class=\"white-bg sea-tab\" \nlayout=\"column\" flex=\"100\" layout-padding layout-wrap><div class=\"search-div container-div\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><div><div layout=\"row\" layout-xs=\"column\" \nclass=\"b brad-5 p-0 mt-5 width-input-360\" layout-align-xs=\"start\" \nng-class=\"{\'border-red\': ctrl.parent.editLinerValidationError}\"><div layout=\"row\" flex class=\"pv-10 pl-15 pr-5 h-48\" \nlayout-align=\"start center\"><md-icon md-svg-icon=\"assets/icons/custom/boat-from-front-view.svg\" class=\"w-18 h-22 m-0\">\n</md-icon><md-select flex=\"100\" id=\"editLiner\" class=\"selectLiner pl-10 w-130\" name=\"selectLiner\" \nng-model=\"ctrl.parent.EditContainerData.carrier_pref\" placeholder=\"Select Liner\" md-on-close=\"editLinersearchTerm=\'\'\">\n<md-select-header class=\"b-none demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Search By Liner\" class=\"md-text\" ng-model=\"editLinersearchTerm\"></md-select-header><md-optgroup \nlabel=\"liners\"><md-option ng-value=\"liner\" \nng-repeat=\"liner in ctrl.parent.subvendorList\n                                        | filter:editLinersearchTerm track by liner.id\">\n{{liner.carrier_name}}</md-option></md-optgroup></md-select><div ng-if=\"ctrl.parent.editLinerValidationError\" \nclass=\"red-fg\"><md-icon md-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span>\n{{ ctrl.parent.editLinerValidationMsg }}</span></div></div><div layout=\"row\" layout-align=\"center center\" \nlayout-align-xs=\"space-between center\" flex class=\"ph-15 h-48 border-responsive\"><span class=\"text-switch pr-10\" \nng-class=\"{\'active\':ctrl.parent.EditContainerData.sea_track_type==\'Import\', \'grey-fg\':ctrl.parent.EditContainerData.sea_track_type!=\'Import\'}\">\nImport</span><md-switch md-no-ink ng-model=\"ctrl.parent.EditContainerData.sea_track_type\" aria-label=\"Switch 1\" \nclass=\"m-0\" ng-true-value=\"\'Export\'\" ng-false-value=\"\'Import\'\"></md-switch><span class=\"text-switch\" \nng-class=\"{\'active\':ctrl.parent.EditContainerData.sea_track_type==\'Export\', \'grey-fg\':ctrl.parent.EditContainerData.sea_track_type!=\'Export\'}\">\nExport</span></div></div><div layout=\"row\" flex flex-sm=\"40\" flex-xs=\"100\" class=\"width-input-360 mt-10 h-48\" \nng-class=\"{\'red-400-border\': ctrl.parent.editContainerNumValidationError}\"><div layout=\"row\" flex \nclass=\"b brad-5 m-0 p-0 h-48\" layout-align=\"start center\"><div class=\"pv-10 pl-15 pr-5\"><md-icon \nmd-svg-icon=\"assets/icons/custom/container-new.svg\" class=\"w-22 h-22\"></md-icon></div><md-input-container md-no-float \nclass=\"m-0 h-40 w-200\"><input id=\"editContainer\" type=\"text\" class=\"border-none sea-container-input w-200 pl-30\" \nng-model=\"ctrl.parent.EditContainerData.container_no\" name=\"container-number\" placeholder=\"Enter Container Number\" \nng-keyup=\"ctrl.parent.editContainerNumValidationError=false\"></md-input-container></div></div><div \nng-if=\"ctrl.parent.editContainerNumValidationError\" class=\"red-fg\"><md-icon \nmd-svg-src=\"assets/icons/custom/warning-icon.svg\" class=\"w-10 h-10\"></md-icon><span>\n{{ ctrl.parent.editContainerNumValidationMsg }}</span></div><div layout=\"row\" layout-align=\"start\" flex flex-sm=\"40\" \nflex-xs=\"100\" class=\"width-input-360 mt-10\"><md-icon md-font-icon=\"icon-information-outline\" class=\"info-icon\">\n</md-icon><div class=\"info-text gray-text\">\nPlease type container number carefully. Once the request is sent, it might take upto 30 mins to retrieve the tracking status\n</div></div></div></div></div></md-dialog-content><md-dialog-actions class=\"bt\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.closeDialog()\" title=\"Cancel\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" \ntype=\"submit\" title=\"Confirm\" ng-disabled=\"ctrl.parent.editTrackBtn\">Save</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/track-n-trace/dialogs/edit-track-shipment/edit-track-shipment.html","<md-dialog id=\"shipment-edit\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"white-bg black-fg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span\n class=\"title font-size-18\"><b>EDIT</b> SHIPMENT</span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" class=\"black-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-0\" ms-scroll><div class=\"pt-25 p-10 white-bg\" \nlayout=\"column\" flex=\"100\" layout-padding layout-wrap><div flex=\"100\" flex-xs=\"100\" flex-sm=\"100\"><div \nclass=\"font-weight-600 font-size-16 mb-15\">GENERAL</div><div layout-xs=\"column\"><md-input-container md-no-float \nclass=\"inline-flex mb-15 m-0\" title=\"Company Name\"><input class=\"input_box\" \nng-model=\"ctrl.parent.shipmentEditData.quote_created_for.company.company_name\" placeholder=\"Company Name\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container \nmd-no-float class=\"inline-flex m-0\" flex flex-xs=\"100\" title=\"Service\"><md-select name=\"service\" \nng-model=\"ctrl.parent.shipmentEditData.service\" placeholder=\"Select Service\" class=\"b brad-5 h-35 pl-10\"><md-option \nvalue=\"express\">Express</md-option><md-option value=\"normal\">Normal</md-option></md-select></md-input-container>\n<md-input-container md-no-float class=\"inline-flex mb-15 mh-5 mt-0 pt-5 pickup-date\" flex flex-xs=\"100\" \ntitle=\"Pickup Date\"><md-datepicker ng-model=\"ctrl.parent.shipmentEditData.cargo_ready_date\" \nmd-placeholder=\"Pickup Date*\" md-hide-icons=\"calendar\" md-open-on-focus flex class=\"pv-8 b brad-5\" \nonkeydown=\"return false\"></md-datepicker></md-input-container></div></div><div flex=\"100\" flex-xs=\"100\" flex-sm=\"100\">\n<div class=\"font-weight-600 font-size-16 mb-15\">ROUTE DETAILS</div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div\n flex class=\"pt-2 mr-15\"><div><md-input-container md-no-float class=\"inline-flex mb-15 m-0 b brad-5 white-bg\" \nlayout=\"row\" title=\"Origin port: {{ctrl.parent.shipmentEditData.pol.portcode_portname}}\"><div \nclass=\"port-label red-500-fg\">A</div><md-autocomplete required md-input-name=\"air_origin_port\" \nmd-selected-item=\"ctrl.parent.shipmentEditData.pol\" md-search-text=\"ctrl.parent.editAir_originSearchText\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.editAir_originSearchText,\'AIR\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Select Origin Port*\" md-menu-class=\"autocomplete-custom-template\" md-clear-button=\"false\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{ctrl.parent.editAir_originSearchText}}\" were found.</md-not-found><div \nng-messages=\"searchForm.air_origin_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></md-input-container></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\"><md-input-container \nmd-no-float class=\"inline-flex mb-15 m-0 pt-5 datepicker_input\" flex=\"100\" flex-xs=\"100\"><md-datepicker \nng-model=\"ctrl.parent.shipmentEditData.departure_date\" md-placeholder=\"Select ETD*\" md-hide-icons=\"calendar\" \nmd-open-on-focus flex class=\"pv-8 b brad-5\" onkeydown=\"return false\" title=\"ETD\"></md-datepicker></md-input-container>\n<md-input-container md-no-float class=\"inline-flex mb-15 mt-0 pt-5 datepicker_input pickup-date ml-10\" flex \nflex-xs=\"100\" title=\"ETD Time\" hide><input type=\"time\" name=\"etd_time\" ng-model=\"ctrl.parent.etd_time\" \nclass=\"pl-0 time_picker\"></md-input-container></div></div><div flex class=\"pt-2 mr-15\"><div><md-input-container \nmd-no-float class=\"inline-flex b mb-15 m-0 brad-5 white-bg\" layout=\"row\" \ntitle=\"Destination port: {{ctrl.parent.shipmentEditData.pod.portcode_portname}}\"><div class=\"port-label green-300-fg\">B\n</div><md-autocomplete required md-input-name=\"air_destination_port\" \nmd-selected-item=\"ctrl.parent.shipmentEditData.pod\" md-search-text=\"ctrl.parent.editAir_destinationSearchText\" \nmd-items=\"item in ctrl.parent.getPort(ctrl.parent.editAir_destinationSearchText,\'AIR\')\" \nmd-item-text=\"item.portcode_portname\" md-min-length=\"2\" md-no-cache=\"false\" md-delay=\"150\" md-require-match=\"true\" \nplaceholder=\"Select Destination Port*\" md-menu-class=\"autocomplete-custom-template\" md-clear-button=\"false\">\n<md-item-template><span class=\"item-metadata\">{{item.portcode_portname}}</span></md-item-template><md-not-found>\nNo ports matching \"{{ctrl.parent.editAir_destinationSearchText}}\" were found.</md-not-found><div \nng-messages=\"searchForm.air_destination_port.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-autocomplete></md-input-container></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\"><md-input-container \nmd-no-float class=\"inline-flex mb-15 m-0 pt-5 datepicker_input\" flex=\"100\" flex-xs=\"100\"><md-datepicker \nng-model=\"ctrl.parent.shipmentEditData.arrival_date\" md-placeholder=\"Select ETA*\" md-hide-icons=\"calendar\" \nmd-open-on-focus flex class=\"pv-8 b brad-5\" onkeydown=\"return false\" title=\"ETA\"></md-datepicker></md-input-container>\n<md-input-container md-no-float class=\"inline-flex mb-15 mt-0 pt-5 datepicker_input pickup-date ml-10\" flex \nflex-xs=\"100\" title=\"ETA Time\" hide><input type=\"time\" name=\"eta_time\" ng-model=\"ctrl.parent.eta_time\" \nclass=\"pl-0 time_picker\"></md-input-container></div></div><div flex flex-sm=\"25\" flex-xs=\"100\"><div><md-input-container\n md-no-float class=\"inline-flex mb-15 m-0\" title=\"MAWB\"><input class=\"input_box\" \nng-model=\"ctrl.parent.shipmentEditData.awb_object.mawb\" placeholder=\"Enter MAWB\" type=\"text\" maxlength=\"11\" \nminlength=\"11\" ng-pattern=\"/^[0-9]*$/\"></md-input-container></div><div><md-input-container md-no-float \nclass=\"inline-flex mb-15 m-0\" title=\"HAWB\"><input class=\"input_box\" \nng-model=\"ctrl.parent.shipmentEditData.awb_object.hawb\" placeholder=\"Enter HAWB\"></md-input-container></div></div>\n</div></div><div flex=\"100\"><div class=\"font-weight-600 font-size-16 mb-15\">AIRLINE DETAILS</div><div layout=\"row\" \nlayout-wrap><div flex><md-input-container md-no-float class=\"inline-flex mb-15 m-0\" title=\"Airline\"><md-select \nng-model=\"ctrl.parent.shipmentEditData.airlineData\" placeholder=\"Select Airline\" class=\"selectBox m-0 input_box pl-5\" \nmd-on-close=\"searchAirline = \'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchAirline\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" placeholder=\"Search Airline\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option ng-repeat=\"airline in ctrl.parent.airLineData | filter : searchAirline\" \nng-value=\"airline\">{{ airline.name + \' - \' + airline.code + \' - \' + airline.prefix }}</md-option><div \nng-if=\"ctrl.parent.airLineData && (ctrl.parent.airLineData | filter:searchAirline).length === 0\"><div \nclass=\"p-20 grey-fg font-size-13 font-weight-600\">No Airline found</div></div></md-select></md-input-container></div>\n<div flex title=\"Flight Number\"><md-input-container md-no-float class=\"inline-flex mb-15 m-0\"><input class=\"input_box\" \nng-model=\"ctrl.parent.shipmentEditData.carrier_info.voyage\" placeholder=\"Enter Flight Number\"></md-input-container>\n</div></div></div></div><md-divider></md-divider><div class=\"white-bg pb-20\"><div class=\"p-20 bb\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"font-weight-600 font-size-16\">LOAD DETAILS</div><div \nclass=\"md-link-fg font-weight-600 font-size-16 pointer\" ng-click=\"ctrl.parent.clearAllEdit();\">CLEAR ALL</div></div>\n<div class=\"MobileTableView\" layout=\"row\" flex=\"100\"><table class=\"load-table\" flex=\"100\"><thead><tr><th>Load No.</th>\n<th>Unit/Pallets No.</th><th>Qty</th><th>Gross. Wt.</th><th>Charge. Wt.</th><th>Remarks</th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"load in ctrl.parent.shipmentEditData.load track by $index\"><td><md-input-container md-no-float \nclass=\"inline-flex p-0 m-0\" flex><input class=\"input_box\" ng-model=\"load.load_number\" placeholder=\"Enter Load No.\" \ntype=\"text\" maxlength=\"32\"></md-input-container></td><td><md-input-container md-no-float class=\"inline-flex p-0 m-0\" \nflex><input class=\"input_box\" ng-model=\"load.pallet_no\" placeholder=\"Unit/Pallets No.\" type=\"text\" maxlength=\"32\">\n</md-input-container></td><td><md-input-container md-no-float class=\"inline-flex p-0 m-0\" flex><input \nclass=\"input_box\" ng-model=\"load.qty\" placeholder=\"Qty\" type=\"number\" onkeypress=\"return event.charCode >= 48\" min=\"1\">\n</md-input-container></td><td><div layout=\"row\" flex=\"100\" class=\"flex\"><md-input-container md-no-float \nclass=\"h-35 b pieces-border-radius p-0 m-0\"><input class=\"border-none ml-0\" type=\"number\" ng-model=\"load.gross_weight\" \nname=\"length\" onkeypress=\"return event.charCode >= 48\" min=\"1\" placeholder=\"Gross Wt.\"></md-input-container>\n<md-input-container class=\"bb bt br h-35 kgs-radius p-0 m-0\" md-no-float><md-select name=\"Gross Wt unit\" \nng-model=\"load.gross_weight_unit\" placeholder=\"KG\" required><md-option value=\"KG\">KG</md-option></md-select>\n</md-input-container></div></td><td><div layout=\"row\" flex=\"100\" class=\"flex\"><md-input-container md-no-float \nclass=\"h-35 b pieces-border-radius p-0 m-0\"><input class=\"border-none ml-0\" type=\"number\" \nng-model=\"load.chargeable_weight\" name=\"length\" onkeypress=\"return event.charCode >= 48\" min=\"1\" \nplaceholder=\"Chargable Wt.\"></md-input-container><md-input-container class=\"bb bt br h-35 kgs-radius p-0 m-0\" \nmd-no-float><md-select name=\"Chargeable Weight Unit\" ng-model=\"load.chargeable_weight_unit\" placeholder=\"KG\" required>\n<md-option value=\"KG\">KG</md-option></md-select></md-input-container></div></td><td><md-input-container md-no-float \nclass=\"inline-flex p-0 m-0 remark_input\" flex><input class=\"input_box\" ng-model=\"load.remarks\" placeholder=\"Remarks\">\n</md-input-container></td><td><md-icon md-font-icon=\"icon-plus-circle\" ng-click=\"ctrl.parent.addLoad($index);\" \nclass=\"green-fg\" ng-if=\"$first\"></md-icon><md-icon md-font-icon=\"icon-minus-circle\" \nng-click=\"ctrl.parent.removeLoad($index);\" class=\"red-fg\" ng-if=\"!$first\"></md-icon></td></tr></tbody></table></div>\n</div></md-dialog-content><md-dialog-actions class=\"white-fg font-weight-600 font-size-20\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button md-no-ink class=\"md-primary-btn mr-10\" \nng-click=\"ctrl.parent.closeDialog()\" title=\"Cancel\">Cancel</md-button><md-button md-no-ink class=\"md-accent-btn ml-10\" \ntype=\"submit\" ng-click=\"ctrl.parent.updateShipmentCall(ctrl.parent.shipmentEditData)\" title=\"Confirm\">Update\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/track-n-trace/dialogs/tracking-dialog/trackingDialog.html","<md-dialog id=\"milestone_modal\" class=\"popup-lg\"><div class=\"modal_title\"><div class=\"md-toolbar-tools\"><div \nclass=\"pl-10 pb-5\" flex=\"90\">Track & Trace</div><div layout=\"row\" layout-align=\"end end\" flex=\"10\" flex-xs=\"10\" \nclass=\"icon_size fg-AAA8AD\"><md-icon md-font-icon=\"icon-close m-10 fg-AAA8AD cursor\" \nng-click=\"ctrl.parent.cancelDialog()\"></md-icon></div></div></div><md-dialog-content class=\"body\"><div \nshimmer-effect-full width=\"100%\" height=\"30px\" mh=\"10px\" class=\"mv-20\" ng-if=\"ctrl.parent.isMilestoneLoading\" \nng-repeat=\"shimmer in [1,2,3,4]\"></div><div ng-if=\"!ctrl.parent.isMilestoneLoading && ctrl.parent.containerList\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" layout-align-xs=\"start start\" flex=\"100\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between\" class=\"ml-15 pv-10 pr-50 br responsive\" flex=\"70\" \nflex-xs=\"100\"><div class=\"font-size-14 pb-mob font-weight-600\"><span class=\"grey-fg\">Container Number </span><br>\n{{ctrl.parent.shipmentList.container_shipment_id ? ctrl.parent.shipmentList.container_shipment_id: \'--\'}}<md-tooltip \nmd-direction=\"bottom\">\n{{ctrl.parent.shipmentList.container_shipment_id ? ctrl.parent.shipmentList.container_shipment_id: \'--\'}}</md-tooltip>\n</div><div class=\"font-size-14 pb-mob font-weight-600 text-truncate\"><span class=\"grey-fg\">POL </span><br>\n{{ctrl.parent.shipmentList.pol_loc.name ? ctrl.parent.shipmentList.pol_loc.name: \'N/A\'}}<md-tooltip \nmd-direction=\"bottom\">{{ctrl.parent.shipmentList.pol_loc.name ? ctrl.parent.shipmentList.pol_loc.name: \'N/A\'}}\n</md-tooltip></div><div class=\"font-size-14 pb-mob font-weight-600 text-truncate\"><span class=\"grey-fg\">POD </span><br>\n{{ctrl.parent.shipmentList.pod_loc.name ? ctrl.parent.shipmentList.pod_loc.name: \'N/A\'}}<md-tooltip \nmd-direction=\"bottom\">{{ctrl.parent.shipmentList.pod_loc.name ? ctrl.parent.shipmentList.pod_loc.name: \'N/A\'}}\n</md-tooltip></div><div class=\"font-size-14 pb-mob font-weight-600\"><span class=\"grey-fg\">ETA </span><br>\n{{ctrl.parent.shipmentList.pod_vslarrival_planned_last!=null ?(ctrl.parent.shipmentList.pod_vslarrival_planned_last | date :\'dd-MMM-yyyy\' : \'UTC\'):\'N/A\'}}\n<md-tooltip md-direction=\"bottom\">\n{{ctrl.parent.shipmentList.pod_vslarrival_planned_last!=null ?(ctrl.parent.shipmentList.pod_vslarrival_planned_last | date :\'dd-MMM-yyyy\' : \'UTC\'):\'N/A\'}}\n</md-tooltip></div><div class=\"font-size-14 pb-mob font-weight-600\"><span class=\"grey-fg\">Departure date </span><br>\n{{ctrl.parent.shipmentList.pol_vsldeparture_planned_last != null ?(ctrl.parent.shipmentList.pol_vsldeparture_planned_last | date :\'dd-MMM yyyy\' : \'UTC\') : \'N/A\'}}\n<md-tooltip md-direction=\"bottom\">\n{{ctrl.parent.shipmentList.pol_vsldeparture_planned_last != null ?(ctrl.parent.shipmentList.pol_vsldeparture_planned_last | date :\'dd-MMM yyyy\' : \'UTC\') : \'N/A\'}}\n</md-tooltip></div></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-around center\" \nlayout-align-xs=\"start center\" class=\"ml-15 p-5\" flex=\"30\"><div \nclass=\"font-size-14 pb-mob font-weight-600 text-truncate\"><span class=\"grey-fg\">Created On </span><br>\n{{ctrl.parent.containerList.created ? (ctrl.parent.containerList.created | date : \'dd-MMM-yyyy\') : \'--\'}}<md-tooltip \nmd-direction=\"bottom\">\n{{ctrl.parent.containerList.created ? (ctrl.parent.containerList.created | date : \'dd-MMM-yyyy\') : \'--\'}}</md-tooltip>\n</div><div class=\"font-size-14 pb-mob font-weight-600 text-truncate\"><span class=\"grey-fg\">Created By </span><br>\n{{ctrl.parent.containerList.created_by ? (ctrl.parent.containerList.created_by.user_first_name + \' \' + ctrl.parent.containerList.created_by.user_last_name) : \'--\'}}\n<md-tooltip md-direction=\"bottom\">\n{{ctrl.parent.containerList.created_by ? (ctrl.parent.containerList.created_by.user_first_name + \' \' + ctrl.parent.containerList.created_by.user_last_name) : \'--\'}}\n</md-tooltip></div></div></div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Milestone\"><md-content><div \nng-show=\"!ctrl.parent.milestoneData.length\"><p class=\"font-size-20 text-center pv-30\">No Data available</p></div><div \nclass=\"simple-table-container\" ng-show=\"ctrl.parent.milestoneData.length\"><div \nclass=\"white-bg md-whiteframe-4dp shipper_table m-15\"><table class=\"simple text-center\" ms-responsive-table><thead><tr>\n<th class=\"border-right\"><div class=\"table-header\"><span class=\"file_heading\">Milestones</span></div></th><th \nclass=\"border-right\"><div class=\"table-header\"><span class=\"file_heading\">Location</span></div></th><th \nclass=\"border-right\"><div class=\"table-header\"><span class=\"file_heading\">Vessel Name</span></div></th><th \nclass=\"border-right\"><div class=\"table-header\"><span class=\"file_heading\">Planned date</span></div></th><th><div \nclass=\"table-header\"><span class=\"file_heading\">Actual Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"x in ctrl.parent.milestoneData\"><td class=\"border-right font-weight-600\">{{x.name}}</td><td \nclass=\"border-right font-weight-600\"><span ng-if=\"x.name != null\">{{x.location_name}}</span></td><td \nclass=\"border-right font-weight-600\">{{x.vessel ? x.vessel : \'-\'}}</td><td class=\"border-right font-weight-600\">\n{{x.planned_date ? (x.planned_date | date : \'dd-MMM-yyyy h:mm a\' : \'UTC\') : \'-\'}}</td><td class=\"font-weight-600\">\n{{x.actual_date ? (x.actual_date | date : \'dd-MMM-yyyy h:mm a\' : \'UTC\') : \'-\'}}</td></tr></tbody></table></div></div>\n</md-content></md-tab></md-tabs></div><div ng-if=\"!ctrl.parent.isMilestoneLoading && !ctrl.parent.containerList\"><p>\nNo data avaialable</p></div></md-dialog-content><md-dialog-actions class=\"footer\"></md-dialog-actions></md-dialog>\n<script id=\"custom-cached-info-window-template.html\" type=\"text/ng-template\">\n<div ng-non-bindable=\"\">\n            {{ctrl.parent.iwModal.key}}: {{ctrl.parent.iwModal.name}}<br/>\n            {{ctrl.parent.iwModal.timezone}}\n        </div>\n</script><script id=\"custom-cached-info-window-current-template.html\" type=\"text/ng-template\">\n<div ng-non-bindable=\"\">\n                {{ctrl.parent.currentMarker.pos_name}}<br/>\n                {{ctrl.parent.currentMarker.pos_datetime}}\n        </div>\n</script>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-component-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-warn fg_back\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-warn fg_next\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" id=\"stepper_submit\" class=\"md-accent md-warn fg_next\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/views/login-form.html","<div ng-if=\"vm.forgotToggle === false\"><div class=\"form-title\">Log in to your account</div><div layout=\"row\" \nlayout-align=\"center center\"><form name=\"loginForm\" novalidate ng-submit=\"vm.callLogin(\'username_password\',loginForm)\" \nlayout=\"column\" layout-align=\"start center\" ng-init=\"vm.init()\"><md-input-container class=\"md-block\" md-no-float \nng-if=\"vm.inputType===\'email\'\"><input class=\"custom-input\" ng-class=\"{\'red-border\':vm.loginError.message !== \'\'}\" \ntype=\"text\" id=\"userName\" name=\"email\" ng-model=\"vm.form.username\" required \nng-keyup=\"vm.resetPasswordError(); vm.checkTypeInput($event.currentTarget.value , \'userName\' );\" \nng-pattern=\"vm.util.emailRegex\" placeholder=\"Enter email/phone number\" md-no-asterisk><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"Email field is required\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"Email must be a valid e-mail address\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block full-w-mob\" md-no-float ng-if=\"vm.inputType===\'mobile\'\"><input\n id=\"userMobile\" ng-class=\"{\'red-border\':vm.loginError.message !== \'\'}\" class=\"custom-input\" type=\"tel\" \nng-model=\"vm.form.username\" ng-keyup=\"vm.checkTypeInput($event.currentTarget.value , \'userMobile\');\" \nplaceholder=\"Phone Number\" name=\"telInput\" ng-maxlength=\"40\"><div ng-messages=\"loginForm.telInput.$error\" \nclass=\"intl-err\"><div ng-message=\"maxlength\">Phone number must not exceed 40 characters</div></div>\n</md-input-container><md-input-container class=\"md-block mt-0\" md-no-float><input class=\"custom-input\" \nng-class=\"{\'red-border\':vm.loginError.message !== \'\'}\" type=\"{{vm.showPassword ? \'text\' : \'password\'}}\" \nname=\"password\" ng-model=\"vm.form.password\" ng-keyup=\"vm.resetPasswordError()\" required md-no-asterisk \nplaceholder=\"Password\"><md-icon md-font-icon=\"{{vm.showPassword ? \'icon-eye\' : \'icon-eye-off\'}}\" \nclass=\"eye-icon grey-500-fg\" ng-click=\"vm.togglePassword()\"></md-icon><div ng-messages=\"loginForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"Password field is required\">Password field is required</span>\n</div></div><div id=\"login-error\" ng-show=\"vm.loginError.message !== \'\'\" class=\"mt-5 red-fg\" \nng-if=\"!(vm.enbledEmailOtp && vm.enforce_otp_for_login)\"><div><span>{{vm.loginError.message}}</span></div></div>\n</md-input-container><md-input-container class=\"md-block mt-0 width-100-per\" md-no-float \nng-if=\"vm.enbledEmailOtp && vm.enforce_otp_for_login\"><input type=\"text\" class=\"custom-input width-100-per\" \nmaxlength=\"6\" id=\"otp_secret\" name=\"otp\" ng-model=\"vm.form.otp\" ng-keyup=\"vm.resetPasswordError()\" required \nplaceholder=\"Enter OTP\" md-no-asterisk ng-class=\"{\'red-border\':vm.loginError.message !== \'\'}\"><div \nng-messages=\"loginForm.otp.$error\" role=\"alert\"><div ng-message=\"required\"><span>OTP is required</span></div></div><div\n id=\"login-error\" ng-show=\"vm.loginError.message !== \'\'\" class=\"mt-5 red-fg\"><div><span>{{vm.loginError.message}}\n</span></div></div></md-input-container><div id=\"recaptcha\" class=\"g-recaptcha login-captcha\" \nng-if=\"$root.domainData.domain_info.PLATFORM_CAPTCHA.otp_login_captcha && !vm.enbledEmailOtp\"></div><md-button \nng-if=\"!vm.enbledEmailOtp && vm.enforce_otp_for_login\" type=\"submit\" md-no-ink \nclass=\"md-accent-btn with-icon submit-button\" ng-disabled=\"vm.sendOtpDisabled\">Send OTP<md-icon class=\"s14 ml-5\" \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><md-button \nng-if=\"vm.enbledEmailOtp || !vm.enforce_otp_for_login\" md-no-ink type=\"submit\" \nclass=\"md-accent-btn with-icon submit-button\" aria-label=\"LOGIN\" ng-disabled=\"vm.loginbtndisabled\" \ntranslate-attr-aria-label=\"LOG IN\">Log In<md-icon class=\"s14 ml-5\" md-font-icon=\"icon-arrow-right\"></md-icon>\n</md-button><div class=\"mt-15\"><div layout=\"row\" layout-align=\"space-between\" class=\"font-size-14 pt-0\" layout-padding>\n<div class=\"grey-fg text-center\">Forgot Password?</div><div ng-click=\"vm.forgotPassword()\" class=\"pointer md-link-fg\">\nReset Password</div></div><div class=\"text-center mt-15\" ng-if=\"$root.domainData.domain_info.REGISTRATION_ENABLED\"><div\n class=\"font-size-16 grey-700-fg\">Don\'t have an account? <a ng-href=\"{{vm.util.sanitizeQueryParams(\'/signup\')}}\" \nclass=\"md-link-fg pl-5\" ng-if=\"$root.domainData.domain_info.REGISTRATION_ENABLED\">Sign up</a></div></div></div></form>\n</div></div><div layout=\"row\" layout-align=\"center center\" class=\"mv-10\" ng-if=\"$root.domainData.domain_info.SHOW_SSO\">\n<hr style=\"width: 100%; border-top: 1px solid #ddd\"></div><div layout=\"row\" layout-align=\"center center\" class=\"mv-10\" \nng-if=\"$root.domainData.domain_info.SHOW_SSO\"><md-button class=\"md-raised md-primary sso-button\" \nng-click=\"vm.handleSSOButtonClick()\"><img src=\"assets/icons/custom/sso.png\" alt=\"SSO Icon\" class=\"sso-icon\">\n {{ $root.domainData.domain_info.SSO_BUTTON }}</md-button></div><div ng-if=\"vm.forgotToggle === true\"><div \nclass=\"form-title text-center\">{{vm.headerMessage}}</div><div id=\"recaptcha\" class=\"g-recaptcha login-captcha\" \nng-if=\"$root.domainData.domain_info.PLATFORM_CAPTCHA.password_reset_captcha && vm.sentEmail === false\"></div><form \nng-if=\"vm.sentEmail === false\" name=\"resetForm\" novalidate ng-submit=\"vm.resetLink(resetForm)\" layout=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" md-no-float><div layout=\"row\" class=\"mb-5\" \nlayout-align-xs=\"center center\"><input class=\"custom-input w-265\" type=\"email\" name=\"email\" ng-model=\"vm.resetEmail\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"Email\" ng-pattern=\"vm.util.emailRegex\" required \nng-keyup=\"vm.clearError()\"><md-button md-no-ink hide-xs type=\"submit\" class=\"md-accent-btn with-icon attached-button\" \naria-label=\"SEND RESET LINK\" ng-disabled=\"vm.disableResetBtn\" translate-attr-aria-label=\"SEND RESET LINK\"><div \nlayout=\"row\" layout-align=\"center center\"><div>Send reset link<md-icon class=\"s16 ml-5 mb-5\" \nmd-font-icon=\"icon-arrow-right\"></md-icon></div></div></md-button></div><div ng-messages=\"resetForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"Email field is required\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"Email must be a valid e-mail address\">\nEmail must be a valid e-mail address</span></div></div><div id=\"reset-error\" ng-show=\"vm.resetError.message !== \'\'\">\n<div><span class=\"red-fg\">{{vm.resetError.message}}</span></div></div></md-input-container><md-button hide show-xs \ntype=\"submit\" class=\"md-accent-btn with-icon attached-button\" aria-label=\"SEND RESET LINK\" \nng-disabled=\"vm.disableResetBtn\" translate-attr-aria-label=\"SEND RESET LINK\"><div layout=\"row\" \nlayout-align=\"center center\"><div>Send reset link<md-icon class=\"s16 ml-5 mb-5\" md-font-icon=\"icon-arrow-right\">\n</md-icon></div></div></md-button></form><div class=\"message\" ng-if=\"vm.sentEmail === true\"><div class=\"text-center\">\n<h2>{{vm.reset.message}}</h2></div></div><div class=\"text-center mt-10\"><a ng-click=\"vm.resetForm();\" \nclass=\"font-size-16 pointer md-link-fg\">Go back to login</a></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/views/login-otp.html","<div class=\"form-title\">{{vm.otpTitle}} with One Time Password (OTP)</div><form name=\"getOtpForm\" novalidate \nng-submit=\"vm.getOTP(getOtpForm)\" layout=\"column\" layout-align=\"center center\"><div id=\"recaptcha\" \nclass=\"g-recaptcha login-captcha\" ng-if=\"$root.domainData.domain_info.PLATFORM_CAPTCHA.otp_login_captcha\"></div>\n<md-input-container class=\"md-block\" md-no-float><div layout=\"row\" class=\"mb-5\" layout-align-xs=\"center center\"><input \nclass=\"custom-input w-250\" ng-class=\"{\'red-border\':vm.loginError.message !== \'\'}\" type=\"text\" id=\"email_otp\" \nname=\"email\" ng-model=\"vm.getOtpForm.username\" required ng-keyup=\"vm.resetPasswordError(\'otp\');\" \nng-pattern=\"vm.util.emailRegex\" placeholder=\"Enter Email ID\" md-no-asterisk><md-button hide-xs type=\"submit\" \nclass=\"md-accent-btn with-icon attached-button\" aria-label=\"GET OTP\" ng-disabled=\"vm.loginbtndisabled\" \ntranslate-attr-aria-label=\"GET OTP\">Send OTP<md-icon class=\"s16 ml-5 mb-5\" md-font-icon=\"icon-arrow-right\"></md-icon>\n</md-button></div><div ng-messages=\"getOtpForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"Email field is required\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"Email must be a valid e-mail address\">Email must be a valid e-mail address</span>\n</div></div><div class=\"red-fg mt-5\" id=\"login-error\" ng-show=\"vm.loginError.message !== \'\'\"><div><span>\n{{vm.loginError.message}}</span></div></div></md-input-container><md-button hide show-xs type=\"submit\" \nclass=\"md-accent-btn with-icon attached-button\" aria-label=\"GET OTP\" ng-disabled=\"vm.loginbtndisabled\" \ntranslate-attr-aria-label=\"GET OTP\">Send OTP<md-icon class=\"s16 ml-5 mb-5\" md-font-icon=\"icon-arrow-right\"></md-icon>\n</md-button></form><div layout=\"row\" layout-align=\"center center\" class=\"mt-5\"><span \nclass=\"font-size-16 pointer md-link-fg\" ng-click=\"vm.loginError.message=\'\';vm.switchScreen(\'login-pass\');\">\nLog in with Password</span></div>");
$templateCache.put("app/main/pages/auth/login-v2/views/otp-sent.html","<div class=\"form-title\">Log in to your account</div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"grey-600-fg font-size-16\">A OTP has been sent to<div class=\"font-size-14 pv-0 mt-10\" \nlayout-align=\"space-between\" layout=\"row\"><div>{{vm.getOtpForm.username}}</div><div \nclass=\"md-link-fg pointer Font-Bold pl-10\" ng-click=\"vm.switchScreen(\'request-otp\');\">Change</div></div></div><form \nname=\"submitLoginOtpForm\" novalidate ng-submit=\"vm.callLogin(\'username_otp\', submitLoginOtpForm)\" class=\"p-0\" \nlayout=\"column\" layout-align=\"center center\"><md-input-container class=\"md-block\" md-no-float><div><input type=\"text\" \nclass=\"custom-input w-265\" maxlength=\"6\" id=\"otp\" name=\"otp\" ng-model=\"vm.submitLoginOtpForm.otp\" \nng-keyup=\"vm.resetPasswordError(\'otp\')\" placeholder=\"Enter OTP\" md-no-asterisk ng-required=\"vm.checkIsRequired\" \nng-class=\"{\'red-border\':vm.loginError.message !== \'\'}\"><md-button md-no-ink type=\"submit\" \nclass=\"md-accent-btn with-icon attached-button w-100\" aria-label=\"LOGIN\" ng-disabled=\"vm.loginbtndisabled\" \ntranslate-attr-aria-label=\"LOG IN\">Log In<md-icon class=\"s16 ml-5 mb-5\" md-font-icon=\"icon-arrow-right\"></md-icon>\n</md-button></div><div ng-messages=\"submitLoginOtpForm.otp.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nOTP is required</span></div></div><div ng-if=\"vm.validateOtpError\"><span class=\"red-400-fg\">{{vm.validateOtpErrorMsg}}\n</span></div><div id=\"login-error\" ng-show=\"vm.loginError.message !== \'\'\"><span class=\"red-400-fg\">\n{{vm.loginError.message}}</span></div></md-input-container></form><div class=\"text-center mt-10\"><a \nng-click=\"vm.resendOTP()\" class=\"font-size-16 pointer md-link-fg\">Resend OTP</a></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/views/sign-up.html","<div ng-if=\"!vm.successSubmit && !vm.isOtpRequired\"><div class=\"form-title\">\nRegister to your {{$root.domainData.domain_info.domain_title}} account</div><form name=\"registerFrm\" \nng-submit=\"vm.submitRegisterForm(vm.registerFrm,registerFrm)\" layout=\"column\" layout-align=\"start center\" novalidate>\n<md-progress-circular class=\"md-primary\" md-diameter=\"44\" ng-if=\"vm.showRegisterLoader\"></md-progress-circular>\n<md-input-container class=\"md-block mt-0\" md-no-float ng-if=\"vm.registrationConfig.user_first_name.visible\"><input \nclass=\"custom-input\" type=\"text\" name=\"user_first_name\" ng-model=\"vm.registerFrm.user_first_name\" \nng-required=\"vm.registrationConfig.user_first_name.required\" md-no-asterisk placeholder=\"Enter First Name\"><div \nng-messages=\"registerFrm.user_first_name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nFirst name is required</div></div></md-input-container><md-input-container class=\"md-block mt-0\" md-no-float \nng-if=\"vm.registrationConfig.user_last_name.visible\"><input class=\"custom-input\" type=\"text\" name=\"user_last_name\" \nng-model=\"vm.registerFrm.user_last_name\" ng-required=\"vm.registrationConfig.user_last_name.required\" md-no-asterisk \nplaceholder=\"Enter Last Name\"><div ng-messages=\"registerFrm.user_last_name.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\">Last name is required</div></div></md-input-container><md-input-container \nclass=\"md-block mt-0\" md-no-float ng-if=\"vm.registrationConfig.mobile.visible\"><input class=\"tel-input custom-input\" \ntype=\"tel\" ng-model=\"vm.registerFrm.user_mobile\" placeholder=\"Phone Number\" name=\"user_mobile\" ng-maxlength=\"40\"><div \nng-messages=\"registerFrm.user_mobile.$error\" class=\"intl-err\"><div ng-message=\"maxlength\">\nPhone number must not exceed 40 characters</div></div></md-input-container><md-input-container class=\"md-block mt-0\" \nmd-no-float ng-if=\"vm.registrationConfig.iec_number.visible\"><input type=\"text\" name=\"IEC_code\" \nng-model=\"vm.registerFrm.IEC_code\" ng-required=\"vm.registrationConfig.iec_number.required\" md-no-asterisk \nclass=\"input-border custom-input\" placeholder=\"Enter Exporter Reference ID (Optional)\" minlength=\"10\" \nrestrict-to=\"[0-9]\"><div ng-messages=\"registerFrm.IEC_code.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"Exporter Reference ID is required\">Exporter Reference ID is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block mt-0\" md-no-float \nng-if=\"vm.registrationConfig.company_name.visible\"><input type=\"text\" name=\"company_name\" \nng-model=\"vm.registerFrm.company_name\" md-no-asterisk class=\"input-border custom-input\" \nplaceholder=\"Enter Company Name\" ng-required=\"vm.registrationConfig.company_name.required\"><div \nng-messages=\"registerFrm.company_name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"Company Name field is required\">Company Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block mt-0 signup-country-container\" md-no-float \nng-if=\"vm.registrationConfig.country.visible\" \nng-class=\"{\'ng-invalid ng-touched\': registerFrm.country.$invalid && registerFrm.country.$touched}\"><div \nshimmer-effect-full width=\"100%\" height=\"30px\" class=\"mt-15\" ng-if=\"vm.isCountryLoading\" ng-repeat=\"shimmer in [1]\">\n</div><md-select ng-if=\"!vm.isCountryLoading\" class=\"custom-input signup-country-select\" name=\"country\" \nng-model=\"vm.registerFrm.country\" placeholder=\"Enter Country\" ng-required=\"vm.registrationConfig.country.required\" \nmd-no-asterisk md-container-class=\"signup-country-select-menu\" \nng-class=\"{\'ng-invalid\': registerFrm.country.$invalid && registerFrm.country.$touched}\"><md-select-header><input \nng-model=\"searchCountry\" type=\"search\" placeholder=\"Search Country\" \nclass=\"demo-header-searchbox _md-text signup-country-search\" ng-keydown=\"$event.stopPropagation()\" autocomplete=\"off\">\n</md-select-header><md-option \nng-repeat=\"country in vm.countryList | orderBy:\'country_name\' | filter : {country_name : searchCountry}\" \nng-value=\"country.country_name\">{{country.country_name}}</md-option></md-select><div \nng-messages=\"registerFrm.country.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCountry is required</span></div></div></md-input-container><md-input-container class=\"md-block mt-0\" md-no-float \nng-if=\"vm.registrationConfig.email.visible\"><input type=\"email\" name=\"email\" ng-model=\"vm.registerFrm.email\" \nmd-no-asterisk ng-pattern=\"vm.util.emailRegex\" class=\"input-border custom-input\" placeholder=\"Enter Email\" \nng-required=\"vm.registrationConfig.email.required\"><div ng-messages=\"registerFrm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Email is required</span></div><div ng-message=\"pattern\"><span>\nEnter a valid Email Id</span></div></div></md-input-container><div id=\"recaptcha\" class=\"g-recaptcha signup-captcha\" \nng-if=\"$root.domainData.domain_info.PLATFORM_CAPTCHA.signup_captcha\"></div><md-button md-no-ink type=\"submit\" \nclass=\"md-accent-btn with-icon submit-button\" flex ng-disabled=\"vm.disableRegisterBtn\">Proceed to OTP<md-icon \nclass=\"s14 ml-5\" md-font-icon=\"icon-arrow-right\"></md-icon></md-button><div class=\"text-center mt-5 red-fg\" \nng-if=\"vm.signupError\">{{ vm.signupError }}</div><div class=\"text-center mt-15\"><a \nng-href=\"{{vm.util.sanitizeQueryParams(\'/login\')}}\" class=\"font-size-16 pointer md-link-fg\">\nAlready Registered? Login Here</a></div><div layout=\"row\" layout-align=\"center center\" class=\"mt-10\" \nng-show=\"vm.disableRegisterBtn\"><md-progress-circular class=\"md-primary\" md-diameter=\"44\"></md-progress-circular></div>\n</form></div><form name=\"otpFrm\" ng-if=\"vm.isOtpRequired && !vm.successSubmit\" style=\"margin-top: 20px\"><div \nclass=\"form-title\" style=\"margin-bottom: 20px\">{{vm.signupSuccessHeading}}</div><div class=\"font-size-16\" \nstyle=\"margin-bottom: 20px; max-width: 330px\">{{vm.signupSuccessSuheading}}</div><input class=\"custom-input\" \ntype=\"text\" name=\"otp\" ng-model=\"vm.otp\" ng-required md-no-asterisk placeholder=\"Enter the OTP\" \nstyle=\"margin-bottom: 20px\"><div ng-messages=\"otpFrm.otp.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\">OTP is required</div></div><md-button md-no-ink class=\"md-accent-btn with-icon submit-button\" \nng-click=\"vm.verifyOtp()\" style=\"margin-bottom: 20px\">Verify OTP</md-button><div class=\"text-center red-fg\" \nng-if=\"vm.otpError\" style=\"margin-top: 20px\">{{ vm.otpError }}</div><div class=\"text-center\" style=\"margin-top: 20px\">\n<button class=\"font-size-15 md-link-fg\" ng-click=\"vm.resendOTP()\" ng-disabled=\"!vm.canResendOTP\">Resend OTP</button>\n<div ng-if=\"!vm.canResendOTP\">You can resend OTP in {{vm.resendCooldown}} seconds.</div></div></form><div \nng-if=\"vm.successSubmit\" layout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"height-50-per\"><div><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"black-fg s100\"></md-icon></div><div class=\"font-size-30 mt-10\">\n{{vm.otpSignupSuccessHeading}}</div><div class=\"font-size-14 text-center mt-8 max-width-330\">\n{{vm.otpSignupSuccessSuheading}}</div><div class=\"mt-30\" ng-if=\"vm.registerFrm.email\"><span class=\"submitted-email\">\n{{vm.registerFrm.email}}</span></div></div>");
$templateCache.put("app/main/profile/dialogs/status-modal/quote-status/add-quote-status.html","<md-dialog id=\"add-status\"><md-toolbar class=\"modal_title white-bg black-fg border-bottom\"><div \nclass=\"md-toolbar-tools\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5\" translate=\"Add_Quote_Status\">\nAdd Quote Status</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close black-fg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><form name=\"addQuoteStatusFrm\"><div layout=\"column\"><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\"><div flex=\"100\" flex-xs=\"100\"><label class=\"font-size-14\"><span translate=\"Status_Name\">Status Name\n</span><span class=\"red-fg\">*</span> :</label><br><md-input-container class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.addQuoteStatus.status\" class=\"status_input\" name=\"status\" placeholder=\"Status Name\" required><div\n ng-messages=\"addQuoteStatusFrm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Status name is required.\n</span></div></div></md-input-container></div></div><div layout=\"column\" flex=\"100\"><label class=\"font-size-14\" \ntranslate=\"Description\">Description :</label><md-input-container flex class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.addQuoteStatus.description\" name=\"description\" placeholder=\"Enter Status Description\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" class=\"font-size-14 mt-20\"><label flex=\"20\" \nflex-xs=\"100\" translate=\"Notification\">Notification :</label><div \nng-class=\"{\'mt-10\' : ctrl.parent.util.isMobileDevice}\" class=\"mt-2\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.addQuoteStatus.sms\" ng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox><span \nclass=\"checkbox_label\" translate=\"SMS\">SMS</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.addQuoteStatus.email\" \nng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"EMAIL\">\nEmail</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.addQuoteStatus.fcm\" ng-true-value=\"1\" ng-false-value=\"0\" \nclass=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"BROWSER\">Browser</span></div></div>\n<md-dialog-actions layout=\"row\"><md-button md-no-ink class=\"button-border md-accent-fg md-hue-1 white-bg h-35\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\" translate=\"CANCEL\">CANCEL</md-button><md-button md-no-ink \nclass=\"md-accent-bg md-hue-1 white-fg border-radius h-35\" type=\"submit\" \nng-disabled=\"addQuoteStatusFrm.$invalid || ctrl.parent.addQuoteStatusFrmDisabled\" \nng-click=\"ctrl.parent.submitQuoteStatus(ctrl.parent.addQuoteStatus)\" title=\"SAVE\" translate=\"SAVE\">SAVE</md-button>\n</md-dialog-actions></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialogs/status-modal/quote-status/edit-quote-status.html","<md-dialog id=\"edit-status\"><md-toolbar class=\"modal_title white-bg black-fg border-bottom\"><div \nclass=\"md-toolbar-tools\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5\" translate=\"Edit_Quote_Status\">\nEdit Quote Status</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close black-fg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><form name=\"editQuoteStatusFrm\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div \nflex=\"100\" flex-xs=\"100\"><label class=\"font-size-14\"><span translate=\"Status_Name\">Status Name</span><span \nclass=\"red-fg\">*</span> :</label><br><md-input-container class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.editQuoteStatus.status\" class=\"status_input\" name=\"status\" placeholder=\"Status Name\" required>\n<div ng-messages=\"editQuoteStatusFrm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStatus name is required.</span></div></div></md-input-container></div></div><div layout=\"column\" flex=\"100\"><label \nclass=\"font-size-14\" translate=\"Description\">Description :</label><md-input-container flex class=\"input_container\" \nmd-no-float><input ng-model=\"ctrl.parent.editQuoteStatus.description\" name=\"description\" \nplaceholder=\"Enter Status Description\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"font-size-14 mt-20\"><label flex=\"20\" flex-xs=\"100\" translate=\"Notification\">Notification :</label><div \nng-class=\"{\'mt-10\' : ctrl.parent.util.isMobileDevice}\" class=\"mt-2\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editQuoteStatus.sms\" ng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox><span \nclass=\"checkbox_label\" translate=\"SMS\">SMS</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteStatus.email\" \nng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"EMAIL\">\nEmail</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.editQuoteStatus.fcm\" ng-true-value=\"1\" ng-false-value=\"0\" \nclass=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"BROWSER\">Browser</span></div></div>\n<md-dialog-actions layout=\"row\"><md-button md-no-ink class=\"button-border md-primary-fg md-hue-1 white-bg h-35\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\" translate=\"CANCEL\">CANCEL</md-button><md-button md-no-ink \nclass=\"md-primary-bg md-hue-1 white-fg border-radius h-35\" type=\"submit\" \nng-disabled=\"editQuoteStatusFrm.$invalid || ctrl.parent.editQuoteStatusFrmDisabled\" \nng-click=\"ctrl.parent.updateQuoteStatus(ctrl.parent.editQuoteStatus)\" title=\"SAVE\" translate=\"SAVE\">SAVE</md-button>\n</md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialogs/status-modal/shipment-status/add-shipment-status.html","<md-dialog id=\"add-status\"><md-toolbar class=\"modal_title white-bg black-fg border-bottom\"><div \nclass=\"md-toolbar-tools\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5\" translate=\"Add_Shipment_Status\">\nAdd Booking Status</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close black-fg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><form name=\"addStatusFrm\"><div layout=\"column\"><div layout=\"row\" flex=\"100\" \nlayout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\"><label class=\"font-size-14\"><span translate=\"Status_Name\">Status Name\n</span><span class=\"red-fg\">*</span> :</label><br><md-input-container class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.addShipmentStatus.status\" class=\"status_input\" name=\"status\" placeholder=\"Status Name\" required>\n<div ng-messages=\"addStatusFrm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Status name is required.\n</span></div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\"><label class=\"font-size-14\" \ntranslate=\"Max_Alloted_Time(Hours)\">Max alloted time(hours) :</label><br><md-input-container class=\"input_container\" \nmd-no-float><input ng-model=\"ctrl.parent.addShipmentStatus.max_alloted_hrs\" name=\"max_alloted_hrs\" placeholder=\"Time\" \ntype=\"number\" min=\"0\"></md-input-container></div></div><div layout=\"column\" flex=\"100\"><label class=\"font-size-14\" \ntranslate=\"Description\">Description :</label><md-input-container flex class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.addShipmentStatus.description\" name=\"description\" placeholder=\"Enter Status Description\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" class=\"font-size-14 mt-20\"><label flex=\"20\" \nflex-xs=\"100\" translate=\"Notification\">Notification :</label><div \nng-class=\"{\'mt-10\' : ctrl.parent.util.isMobileDevice}\" class=\"mt-2\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.addShipmentStatus.sms\" ng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox><span \nclass=\"checkbox_label\" translate=\"SMS\">SMS</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.addShipmentStatus.email\" \nng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"EMAIL\">\nEmail</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.addShipmentStatus.fcm\" ng-true-value=\"1\" ng-false-value=\"0\" \nclass=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"Browsr\">Browser</span></div></div><div \nlayout=\"row\" layout-xs=\"column\" class=\"font-size-14\"><label flex=\"20\" flex-xs=\"100\">Mode :</label><div \nng-class=\"{\'mt-10\' : ctrl.parent.util.isMobileDevice}\" class=\"mt-2\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.addShipmentStatus.fcl\" ng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox><span \nclass=\"checkbox_label\" translate=\"FCL\">FCL</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.addShipmentStatus.lcl\" \nng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"LCL\">\nLCL</span><md-checkbox md-no-ink ng-model=\"ctrl.parent.addShipmentStatus.air\" ng-true-value=\"1\" ng-false-value=\"0\" \nclass=\"checkbox_css\"></md-checkbox><span class=\"checkbox_label\" translate=\"AIR\">AIR</span></div></div>\n<md-dialog-actions layout=\"row\"><md-button md-no-ink class=\"button-border md-primary-fg md-hue-1 white-bg h-35\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\" translate=\"CANCEL\">CANCEL</md-button><md-button md-no-ink \nclass=\"md-primary-bg md-hue-1 white-fg border-radius h-35\" type=\"submit\" ng-disabled=\"addStatusFrm.$invalid\" \nng-click=\"ctrl.parent.submitShipmentStatus(ctrl.parent.addShipmentStatus)\" title=\"SAVE\" translate=\"SAVE\">SAVE\n</md-button></md-dialog-actions></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialogs/status-modal/shipment-status/edit-shipment-status.html","<md-dialog id=\"edit-status\"><md-toolbar class=\"modal_title white-bg black-fg border-bottom\"><div \nclass=\"md-toolbar-tools\"><div class=\"font-size-16 font-weight-600 pl-5 pb-5\" translate=\"Edit_Shipment_Status\">\nEdit Booking Status</div><span flex></span><md-button md-no-ink class=\"md-icon-button\" \nng-click=\"ctrl.parent.cancelDialog()\"><md-icon md-font-icon=\"icon-close black-fg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><form name=\"editStatusFrm\"><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div \nflex=\"50\" flex-xs=\"100\"><label class=\"font-size-14\"><span translate=\"Status_Name\">Status Name</span><span \nclass=\"red-fg\">*</span> :</label><br><md-input-container class=\"input_container\" md-no-float><input \nng-model=\"ctrl.parent.editShipmentStatus.status\" class=\"status_input\" name=\"status\" placeholder=\"Status Name\" required \nreadonly=\"readonly\"><div ng-messages=\"editStatusFrm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStatus name is required.</span></div></div></md-input-container></div><div flex=\"50\" flex-xs=\"100\"><label \nclass=\"font-size-14\" translate=\"Max_Allotted_Time(Hours)\">Max allotted time(hours) :</label><br><md-input-container \nclass=\"input_container\" md-no-float><input ng-model=\"ctrl.parent.editShipmentStatus.max_alloted_hrs\" \nname=\"max_alloted_hrs\" placeholder=\"Time\" type=\"number\" min=\"0\"></md-input-container></div></div><div layout=\"column\" \nflex=\"100\"><label class=\"font-size-14\" translate=\"Description\">Description :</label><md-input-container flex \nclass=\"input_container\" md-no-float><input ng-model=\"ctrl.parent.editShipmentStatus.description\" name=\"description\" \nplaceholder=\"Enter Status Description\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" class=\"font-size-14 mt-20\"><label flex=\"20\" flex-xs=\"100\" translate=\"Notification\">Notification :\n</label><div ng-class=\"{\'mt-10\' : ctrl.parent.util.isMobileDevice}\" class=\"mt-2\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editShipmentStatus.sms\" ng-true-value=\"1\" ng-false-value=\"0\" disabled=\"disabled\"></md-checkbox>\n<span class=\"checkbox_label\" translate=\"SMS\">SMS</span><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editShipmentStatus.email\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\" \ndisabled=\"disabled\"></md-checkbox><span class=\"checkbox_label\" translate=\"EMAIL\">Email</span><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editShipmentStatus.fcm\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\" \ndisabled=\"disabled\"></md-checkbox><span class=\"checkbox_label\" translate=\"BROWSER\">Browser</span></div></div><div \nlayout=\"row\" layout-xs=\"column\" class=\"font-size-14\"><label flex=\"20\" flex-xs=\"100\" translate=\"Mode\">Mode :</label><div\n ng-class=\"{\'mt-10\' : ctrl.parent.util.isMobileDevice}\" class=\"mt-2\"><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editShipmentStatus.fcl\" ng-true-value=\"1\" ng-false-value=\"0\" disabled=\"disabled\"></md-checkbox>\n<span class=\"checkbox_label\" translate=\"FCL\">FCL</span><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editShipmentStatus.lcl\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\" \ndisabled=\"disabled\"></md-checkbox><span class=\"checkbox_label\" translate=\"LCL\">LCL</span><md-checkbox md-no-ink \nng-model=\"ctrl.parent.editShipmentStatus.air\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"checkbox_css\" \ndisabled=\"disabled\"></md-checkbox><span class=\"checkbox_label\" translate=\"AIR\">AIR</span></div></div><md-dialog-actions\n layout=\"row\"><md-button md-no-ink class=\"button-border md-primary-fg md-hue-1 white-bg h-35\" \nng-click=\"ctrl.parent.cancelDialog()\" title=\"Cancel edit\" translate=\"CANCEL\">CANCEL</md-button><md-button md-no-ink \nclass=\"md-primary-bg md-hue-1 white-fg border-radius h-35\" type=\"submit\" ng-disabled=\"editStatusFrm.$invalid\" \nng-click=\"ctrl.parent.updateShipmentStatus(ctrl.parent.editShipmentStatus)\" title=\"SAVE\" translate=\"SAVE\">SAVE\n</md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/result/Dialogs/view-details/card-popup-meta/card-popup-meta.html","<div flex=\"100\" layout-xs=\"column\" layout=\"row\" id=\"card-popup-meta\"><md-card flex=\"100\" flex-sm=\"100\" flex-xs=\"100\" \nclass=\"brad-4 m-0\"><md-card-content class=\"pv-0 ph-0\"><div layout=\"column\" layout-padding class=\"p-20\"><div \nlayout=\"row\" layout-wrap class=\"p-0 pb-20\" ng-if=\"ctrl.parent.currentCard.meta.port_data.empty_container_pickup\">\n<md-icon md-svg-src=\"assets/icons/custom/pickup-truck.svg\" class=\"icon-bs\"></md-icon><div class=\"pr-20\" flex-sm=\"100\">\n<div class=\"heading\">Empty Container Pickup</div><div class=\"sub-heading\"><md-icon class=\"icon-size\" \nmd-svg-src=\"assets/icons/custom/search-bar/door.svg\"></md-icon>\n{{ctrl.parent.currentCard.meta.port_data.empty_container_pickup.port_name}}</div></div></div><div layout=\"row\" \nclass=\"p-0\" \nng-if=\"ctrl.parent.currentCard.meta.port_data.pickup_location || ctrl.parent.currentCard.meta.port_data.pickup_pincode_ui\">\n<md-icon md-svg-src=\"assets/icons/custom/search-bar/door.svg\" class=\"icon-bs h-16\"></md-icon><div layout=\"row\" \nlayout-wrap flex=\"100\"><div class=\"pr-20 pb-20 max-width-40-per min-width-180\"><div class=\"heading\">Pickup Door</div>\n<div class=\"sub-heading text-truncate\"><md-icon class=\"icon-size\" md-svg-src=\"assets/icons/custom/search-bar/door.svg\">\n</md-icon><md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.port_data.pickup_location ? ctrl.parent.currentCard.meta.port_data.pickup_location : ctrl.parent.currentCard.meta.port_data.pickup_pincode_ui }} , {{ ctrl.parent.currentCard.meta.port_data.pickup_country_name}}\n</md-tooltip>\n{{ctrl.parent.currentCard.meta.port_data.pickup_location ? ctrl.parent.currentCard.meta.port_data.pickup_location : ctrl.parent.currentCard.meta.port_data.pickup_pincode_ui}}, {{ ctrl.parent.currentCard.meta.port_data.pickup_country_name}}\n</div></div><div class=\"max-width-20-per min-width-130 pr-20 pb-20\"><div class=\"heading\">Pickup Service Type</div><div \nclass=\"sub-heading text-truncate\">\n{{ ctrl.parent.currentCard.meta.pickup_service ? ctrl.parent.currentCard.meta.pickup_service : \'-\' }}<md-tooltip \nng-if=\"ctrl.parent.currentCard.meta.pickup_service\" md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.pickup_service}}</md-tooltip></div></div><div \nclass=\"max-width-20-per min-width-130 pr-20 pb-20\"><div class=\"heading\">Pickup Haulage</div><div class=\"sub-heading\">\n<md-icon class=\"haulage-icon\" \nng-if=\"ctrl.parent.currentCard.meta.pickup_transport_mode && (ctrl.parent.currentCard.meta.pickup_transport_mode.toLowerCase() == \'road\' || ctrl.parent.currentCard.meta.pickup_transport_mode.toLowerCase() == \'barge\' || ctrl.parent.currentCard.meta.pickup_transport_mode.toLowerCase() == \'rail\' || ctrl.parent.currentCard.meta.pickup_transport_mode.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+ctrl.parent.currentCard.meta.pickup_transport_mode.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon>\n{{ctrl.parent.currentCard.meta.pickup_transport_mode ? ctrl.parent.currentCard.meta.pickup_transport_mode : \'-\'}}</div>\n</div><div class=\"max-width-40-per min-width-130 pr-20 pb-20\"><div class=\"heading\">Pickup Transporter</div><div \nclass=\"sub-heading text-truncate\"><md-icon ng-if=\"ctrl.parent.currentCard.meta.pickup_sub_vendor\" \nmd-svg-src=\"assets/icons/custom/user-icon.svg\" class=\"icon-size pr-6\"></md-icon>\n{{ctrl.parent.currentCard.meta.pickup_sub_vendor ? ctrl.parent.currentCard.meta.pickup_sub_vendor.sub_vendor_name : \'-\'}}\n<md-tooltip ng-if=\"ctrl.parent.currentCard.meta.pickup_sub_vendor\" md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.pickup_sub_vendor.sub_vendor_name}}</md-tooltip></div></div></div></div><md-divider \nng-if=\"ctrl.parent.currentCard.meta.port_data.pickup_location\"></md-divider><div layout=\"row\" class=\"p-0\"><md-icon \nmd-svg-src=\"assets/icons/custom/port-aaa8ad.svg\" class=\"icon-bs h-12 w-12\"></md-icon><div layout=\"row\" layout-wrap \nflex=\"100\"><div class=\"pr-20 pb-20 max-width-30-per min-width-180\" ng-if=\"ctrl.parent.currentCard.meta.via_pol\"><div \nclass=\"heading\">Port of Origin</div><div class=\"sub-heading text-truncate\"><md-icon class=\"icon-size\" \nmd-svg-src=\"assets/icons/custom/search-bar/icd.svg\"></md-icon>\n{{ctrl.parent.currentCard.meta.port_data.origin_port_code}}/ {{ctrl.parent.currentCard.meta.port_data.origin_portname}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.port_data.origin_port_code}}/ {{ctrl.parent.currentCard.meta.port_data.origin_portname}}\n</md-tooltip></div></div><div class=\"pr-20 pb-20 max-width-20-per min-width-130\" \nng-if=\"ctrl.parent.currentCard.meta.via_pol && ctrl.parent.currentCard.meta.haulage\"><div class=\"heading\">\nOrigin Haulage</div><div class=\"sub-heading text-truncate\"><md-icon class=\"haulage-icon\" \nng-if=\"ctrl.parent.currentCard.meta.haulage && (ctrl.parent.currentCard.meta.haulage.toLowerCase() == \'road\' || ctrl.parent.currentCard.meta.haulage.toLowerCase() == \'barge\' || ctrl.parent.currentCard.meta.haulage.toLowerCase() == \'rail\' || ctrl.parent.currentCard.meta.haulage.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+ctrl.parent.currentCard.meta.haulage.toLowerCase()+\'_haulage.svg\'}}\"></md-icon>\n{{ctrl.parent.currentCard.meta.haulage}}</div></div><div class=\"pr-20 pb-20 max-width-30-per min-width-180\"><div \nclass=\"heading\">Port of Loading</div><div class=\"sub-heading text-truncate\" \nng-if=\"ctrl.parent.currentCard.meta.via_pol\"><md-icon class=\"icon-size\" \nmd-svg-src=\"assets/icons/custom/search-bar/port.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.via_pol}}</md-tooltip>{{ctrl.parent.currentCard.meta.via_pol}}</div><div \nclass=\"sub-heading text-truncate\" ng-if=\"!ctrl.parent.currentCard.meta.via_pol\"><md-icon class=\"icon-size\" \nmd-svg-src=\"{{ctrl.parent.search_param.mode == \'AIR\' ? \'assets/icons/custom/search-bar/air_pod.svg\' : \'assets/icons/custom/search-bar/port.svg\'}}\">\n</md-icon><md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.port_data.origin_port_code}}/{{ctrl.parent.currentCard.meta.port_data.origin_portname}}\n</md-tooltip>\n{{ctrl.parent.currentCard.meta.port_data.origin_port_code}}/{{ctrl.parent.currentCard.meta.port_data.origin_portname}}\n</div></div><div class=\"pr-20 pb-20 max-width-30-per min-width-180\" \nng-if=\"ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.via_route\"><div \nclass=\"heading\">T/S</div><div class=\"sub-heading text-truncate\"><md-icon class=\"icon-size\" \nmd-svg-src=\"assets/icons/custom/search-bar/port.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\"><div \nclass=\"tooltip-width-control\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.via_route}}</div></md-tooltip>\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.via_route}}</div></div></div></div>\n<div layout=\"row\" class=\"p-0\"><md-icon md-svg-src=\"assets/icons/custom/liner-aaa8ad.svg\" class=\"icon-bs h-14 w-14\" \nng-if=\"ctrl.parent.search_param.mode != \'AIR\'\"></md-icon><md-icon md-svg-src=\"assets/icons/custom/roll-o-plane.svg\" \nclass=\"icon-bs icon-rotate\" ng-if=\"ctrl.parent.search_param.mode == \'AIR\'\"></md-icon><div layout=\"row\" layout-wrap \nclass=\"p-0\"><div class=\"max-width-250 pr-20 pb-20\" \nng-if=\"ctrl.parent.search_param.mode != \'AIR\' && !ctrl.parent.maskLiner\"><div class=\"heading\">Liner/Carrier</div><div \nclass=\"sub-heading text-truncate\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}\n</md-tooltip>\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.sub_vendor.sub_vendor_name}}</div>\n</div><div class=\"max-width-250 pr-20 pb-20\" ng-if=\"ctrl.parent.search_param.mode == \'AIR\' && !ctrl.parent.maskLiner\">\n<div class=\"heading\">AirLiner</div><div class=\"sub-heading text-truncate\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.airline.air_line_name}}</md-tooltip>\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.airline.air_line_name}}</div></div>\n<div class=\"max-width-150 pr-20 pb-20\" ng-if=\"!ctrl.parent.maskLiner\"><div class=\"heading\">Service Type</div><div \nclass=\"sub-heading text-truncate\"><span>\n{{ !ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.service_type ? \'\' : ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.service_type }}\n</span><span class=\"ph-3 mt-5 font-size-13\" \nng-if=\"(ctrl.parent.currentCard.meta.selected_schedule && ctrl.parent.currentCard.meta.selected_schedule.service_name) && ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.service_type\">\n| </span><span ng-if=\"ctrl.parent.search_param.mode!=\'AIR\' && ctrl.parent.currentCard.meta.selected_schedule\">\n{{ !ctrl.parent.currentCard.meta.selected_schedule.service_name ? \'\' : ctrl.parent.currentCard.meta.selected_schedule.service_name }}\n</span><span \nng-if=\"!((ctrl.parent.currentCard.meta.selected_schedule && ctrl.parent.currentCard.meta.selected_schedule.service_name) || ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.service_type)\">\nN/A</span></div></div><div class=\"max-width-250 pr-20 pb-20\" ng-if=\"ctrl.parent.search_param.mode === \'SEA-FCL\'\"><div \nclass=\"heading\">Origin Service Mode</div><div class=\"sub-heading text-truncate\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.origin_service_mode}}</md-tooltip>\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.origin_service_mode ? ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.origin_service_mode : \'-\'}}\n</div></div><div class=\"max-width-250 pr-20 pb-20\" ng-if=\"ctrl.parent.search_param.mode === \'SEA-FCL\'\"><div \nclass=\"heading\">Destination Service Mode</div><div class=\"sub-heading text-truncate\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.destination_service_mode}}\n</md-tooltip>\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.destination_service_mode ? ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.destination_service_mode : \'-\'}}\n</div></div><div class=\"max-width-120 pr-20 pb-20\"><div class=\"heading\">Transit Time</div><div \nclass=\"sub-heading text-truncate\" \nng-bind=\"ctrl.parent.currentCard.meta.selected_schedule ?(!ctrl.parent.currentCard.meta.selected_schedule.transit_time ? \'-\' : ctrl.parent.currentCard.meta.selected_schedule.transit_time) : (!ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.transit_time ? \'-\' : ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.transit_time )\">\n</div></div><div class=\"max-width-180 pr-20 pb-20\" ng-if=\"ctrl.parent.showContractCondition\"><div class=\"heading\">\nContract ID<md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control\" style=\"display:table;opacity: 1\">\nContract / Rate Agreement / Tariff / Spot Pricing Reference Number</md-tooltip><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"pl-5 pr-10 s12 pointer content-copy\" \nng-click=\"ctrl.parent.util.fnCopyID(ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.contract_number)\">\n</md-icon></div><div class=\"sub-heading contractIdTruncate\" style=\"-webkit-box-orient: vertical\" \nng-bind=\"ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.contract_number\"></div>\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.contract_number}}</div>\n</md-tooltip></div><div class=\"max-width-120 pr-20 pb-20\" \nng-if=\"ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.price_id && !ctrl.parent.maskLiner && ctrl.parent.util.showRateIdForContract(ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.tags)\">\n<div class=\"heading\">Rate ID</div><div class=\"sub-heading text-truncate\" \nng-bind=\"ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.price_id\"></div><md-tooltip \nmd-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control pointer-events-none\" \nstyle=\"display:table;opacity: 1\"><div class=\"tooltip-width-control\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.price_id }}</div></md-tooltip></div>\n<div class=\"max-width-120 pr-20 pb-20\" ng-if=\"ctrl.parent.search_param.mode != \'AIR\'\"><div class=\"heading\">Sailing Date\n</div><div class=\"sub-heading\" \nng-bind=\"!ctrl.parent.currentCard.meta.selected_schedule && !ctrl.parent.currentCard.data.buy_rates[ctrl.parent.l3_leg].rate_obj.sailing_date ? \'-\' : (ctrl.parent.currentCard.meta.selected_schedule.departure_time ? ctrl.parent.currentCard.meta.selected_schedule.departure_time : ctrl.parent.currentCard.data.buy_rates[ctrl.parent.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\')\">\n<md-tooltip \nng-if=\"ctrl.parent.currentCard.meta.selected_schedule || ctrl.parent.currentCard.data.buy_rates[ctrl.parent.l3_leg].rate_obj.sailing_date\" \nmd-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.selected_schedule.departure_time ? ctrl.parent.currentCard.meta.selected_schedule.departure_time : ctrl.parent.currentCard.data.buy_rates[ctrl.parent.l3_leg].rate_obj.sailing_date | UTCToLocal : \'d MMM yyyy\' }}\n</md-tooltip></div></div><div class=\"pr-20 pb-20\" \nng-if=\"!ctrl.parent.allowEditMainData && (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date || ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry)\">\n<div class=\"heading\">Effective Period</div><div class=\"max-width-170\" layout=\"row\"><div \nclass=\"sub-heading text-truncate max-width-170\" \nng-if=\"!ctrl.parent.allowEditMainData && ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date && ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry\">\n{{ (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date | NoTimeZone : \'d MMM yyyy\') + \" - \" + (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\')}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date | NoTimeZone : \'d MMM yyyy\') + \" - \" + (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\')}}\n</md-tooltip></div><div class=\"sub-heading text-truncate max-width-150\" \nng-if=\"!ctrl.parent.allowEditMainData && !ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date && ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry\">\n{{ \"Till \" + (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\')}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ \"Till \" + (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry | NoTimeZone : \'d MMM yyyy\')}}\n</md-tooltip></div><div class=\"sub-heading text-truncate max-width-150\" \nng-if=\"!ctrl.parent.allowEditMainData && ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date && !ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.expiry\">\n{{ \"From \" + (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date | NoTimeZone : \'d MMM yyyy\')}}\n<md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ \"From \" + (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.start_date | NoTimeZone : \'d MMM yyyy\')}}\n</md-tooltip></div><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"s14 fg-3F3851 pointer effective-period-{{\'meta-\'+ctrl.parent.currentCard._id}}\" \nng-if=\"ctrl.parent.util.fnCheckLoadExpiryLength(ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.detailed_effective_load , ctrl.parent.search_param.load_data.load_details_value) && ctrl.parent.search_param.mode === \'SEA-FCL\' \" \nng-click=\"ctrl.parent.shareQuoteService.showEffectivePeriodPanel($event,\'meta-\'+ctrl.parent.currentCard._id,ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.detailed_effective_load , ctrl.parent.search_param.load_data.load_details_value)\">\n</md-icon></div><date-picker id=\"expiry_date\" ng-if=\"ctrl.parent.allowEditMainData\" style=\"display: inline-block\" \nmd-input-id=\"\'Expiry_date\'\" is-validate=\"false\" is-editable=\"false\" date-disabled=\"false\" input-required=\"true\" \ninput-name=\"\'expiry\'\" full-border=\"false\" date-placeholder=\"\'Expiry date\'\" date-format=\"true\" \nmin-date-value=\"ctrl.parent.expMaxDate\" \nmodel-value=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.expiry\" \ncallback=\"ctrl.parent.currentCard.data.sell_rates[ctrl.parent.l3_leg].rate_obj.expiry=value\"></date-picker></div><div \nclass=\"max-width-130 pr-20 pb-20\" ng-if=\"ctrl.parent.currentCard.meta.co2eData\"><div class=\"heading\"><md-icon \nmd-svg-src=\"assets/icons/custom/co2-icon.svg\" class=\"icon-class-10 mr-5\"></md-icon>CO<sub>2</sub> emission</div><div \nclass=\"sub-heading line-height-12\" layout=\"row\"><div class=\"text-truncate\">\n{{(ctrl.parent.currentCard.meta.co2eData.co2e.total | currencyMask: 2) +\' \' +\'g\'}}</div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s14 fg-3F3851 pointer co2e-{{\'meta-\'+ctrl.parent.currentCard._id}}\" \nng-click=\"ctrl.parent.shareQuoteService.showCo2ContainerData($event,\'meta-\'+ctrl.parent.currentCard._id, ctrl.parent.currentCard.meta.co2eData)\">\n</md-icon></div></div><div class=\"max-width-120 pr-20 pb-20\" ng-if=\"ctrl.parent.search_param.mode == \'AIR\'\"><div \nclass=\"heading\">ETD</div><div class=\"sub-heading\" ng-if=\"ctrl.parent.carddata.meta.selected_schedule\">\n{{ctrl.parent.carddata.meta.selected_schedule.departure_time ? (ctrl.parent.carddata.meta.selected_schedule.departure_time | UTCToLocal : \'d MMM yyyy\') : \'-\' }}\n</div><div class=\"sub-heading\" ng-if=\"!ctrl.parent.carddata.meta.selected_schedule\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.departure_time ? (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.departure_time | UTCToLocal : \'d MMM yyyy\') : \'-\' }}\n</div></div><div class=\"max-width-120 pr-20 pb-20\" ng-if=\"ctrl.parent.search_param.mode == \'AIR\'\"><div class=\"heading\">\nETA</div><div class=\"sub-heading\" ng-if=\"ctrl.parent.carddata.meta.selected_schedule\">\n{{ctrl.parent.carddata.meta.selected_schedule.arrival_time ? (ctrl.parent.carddata.meta.selected_schedule.arrival_time | UTCToLocal : \'d MMM yyyy\') : \'-\' }}\n</div><div class=\"sub-heading\" ng-if=\"!ctrl.parent.carddata.meta.selected_schedule\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.arrival_time ? (ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.arrival_time | UTCToLocal : \'d MMM yyyy\') : \'-\' }}\n</div></div><div class=\"max-width-120 pr-20 pb-20\" ng-if=\"ctrl.parent.search_param.mode == \'AIR\'\"><div class=\"heading\">\nFrequency</div><div class=\"sub-heading\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.frequency ? ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.frequency : \'-\'}}\n</div></div></div></div><div layout=\"row\" class=\"p-0\"><md-icon md-svg-src=\"assets/icons/custom/port-aaa8ad.svg\" \nclass=\"icon-bs h-12 w-12\"></md-icon><div layout=\"row\" layout-wrap flex=\"100\"><div \nclass=\"pr-20 pb-20 max-width-40-per min-width-180\" ng-if=\"ctrl.parent.currentCard.meta.via_pod\"><div class=\"heading\">\nPort of Destination</div><div class=\"sub-heading text-truncate\"><md-icon class=\"icon-size\" \nmd-svg-src=\"assets/icons/custom/search-bar/icd.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.port_data.destination_port_code}}/{{ctrl.parent.currentCard.meta.port_data.destination_portname}}\n</md-tooltip>\n{{ctrl.parent.currentCard.meta.port_data.destination_port_code}}/{{ctrl.parent.currentCard.meta.port_data.destination_portname}}\n</div></div><div class=\"pr-20 pb-20 max-width-20-per min-width-130\" \nng-if=\"ctrl.parent.currentCard.meta.via_pod && ctrl.parent.currentCard.meta.destination_haulage\"><div class=\"heading\">\nDestination Haulage</div><div class=\"sub-heading text-truncate\"><md-icon class=\"haulage-icon\" \nng-if=\"ctrl.parent.currentCard.meta.destination_haulage && (ctrl.parent.currentCard.meta.destination_haulage.toLowerCase() == \'road\' || ctrl.parent.currentCard.meta.destination_haulage.toLowerCase() == \'barge\' || ctrl.parent.currentCard.meta.destination_haulage.toLowerCase() == \'rail\' || ctrl.parent.currentCard.meta.destination_haulage.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+ctrl.parent.currentCard.meta.destination_haulage.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon>{{ctrl.parent.currentCard.meta.destination_haulage}}</div></div><div \nclass=\"pr-20 pb-20 max-width-40-per min-width-180\"><div class=\"heading\">Port of Discharge</div><div \nclass=\"sub-heading text-truncate\" ng-if=\"ctrl.parent.currentCard.meta.via_pod\"><md-icon class=\"icon-size\" \nmd-svg-src=\"assets/icons/custom/search-bar/port.svg\"></md-icon><md-tooltip md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.via_pod}}</md-tooltip>{{ctrl.parent.currentCard.meta.via_pod}}</div><div \nclass=\"sub-heading text-truncate\" ng-if=\"!ctrl.parent.currentCard.meta.via_pod\"><md-icon class=\"icon-size\" \nmd-svg-src=\"{{ctrl.parent.search_param.mode == \'AIR\'? \'assets/icons/custom/search-bar/air_pol.svg\' : \'assets/icons/custom/search-bar/port.svg\'}}\">\n</md-icon><md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.port_data.destination_port_code}}/{{ctrl.parent.currentCard.meta.port_data.destination_portname}}\n</md-tooltip>\n{{ctrl.parent.currentCard.meta.port_data.destination_port_code}}/{{ctrl.parent.currentCard.meta.port_data.destination_portname}}\n</div></div></div></div><md-divider></md-divider><div layout=\"row\" class=\"p-0\" \nng-if=\"ctrl.parent.currentCard.meta.port_data.delivery_location || ctrl.parent.currentCard.meta.port_data.delivery_pincode_ui\">\n<md-icon md-svg-src=\"assets/icons/custom/search-bar/door.svg\" class=\"icon-bs h-16\"></md-icon><div layout=\"row\" \nlayout-wrap flex=\"100\"><div class=\"max-width-40-per min-width-180 pr-20 pb-20\"><div class=\"heading\">Delivery Door</div>\n<div class=\"sub-heading text-truncate\"><md-icon class=\"icon-size\" md-svg-src=\"assets/icons/custom/search-bar/door.svg\">\n</md-icon><md-tooltip md-direction=\"top\" class=\"font-size-11 white-fg bg-343434 p-10 text-center\" \nstyle=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.port_data.delivery_location ? ctrl.parent.currentCard.meta.port_data.delivery_location : ctrl.parent.currentCard.meta.port_data.delivery_pincode_ui}} , {{ ctrl.parent.currentCard.meta.port_data.delivery_country_name}}\n</md-tooltip>\n{{ctrl.parent.currentCard.meta.port_data.delivery_location ? ctrl.parent.currentCard.meta.port_data.delivery_location : ctrl.parent.currentCard.meta.port_data.delivery_pincode_ui}} , {{ ctrl.parent.currentCard.meta.port_data.delivery_country_name}}\n</div></div><div class=\"max-width-20-per min-width-130 pr-20 pb-20\"><div class=\"heading\">Delivery Service Type</div>\n<div class=\"sub-heading text-truncate\">\n{{ctrl.parent.currentCard.meta.delivery_service ? ctrl.parent.currentCard.meta.delivery_service : \'-\' }}<md-tooltip \nng-if=\"ctrl.parent.currentCard.meta.delivery_service\" md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center tooltip-width-control\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.delivery_service}}</md-tooltip></div></div><div \nclass=\"max-width-20-per min-width-130 pr-20 pb-20\"><div class=\"heading\">Delivery Haulage</div><div \nclass=\"sub-heading text-truncate\"><md-icon class=\"haulage-icon\" \nng-if=\"ctrl.parent.currentCard.meta.delivery_transport_mode && (ctrl.parent.currentCard.meta.delivery_transport_mode.toLowerCase() == \'road\' || ctrl.parent.currentCard.meta.delivery_transport_mode.toLowerCase() == \'barge\' || ctrl.parent.currentCard.meta.delivery_transport_mode.toLowerCase() == \'rail\' || ctrl.parent.currentCard.meta.delivery_transport_mode.toLowerCase() == \'truck\')\" \nmd-svg-src=\"{{\'assets/icons/custom/\'+ctrl.parent.currentCard.meta.delivery_transport_mode.toLowerCase()+\'_haulage.svg\'}}\">\n</md-icon>\n{{ctrl.parent.currentCard.meta.delivery_transport_mode ? ctrl.parent.currentCard.meta.delivery_transport_mode : \'-\'}}\n</div></div><div class=\"max-width-40-per min-width-130 pr-20 pb-20\"><div class=\"heading\">Delivery Transporter</div><div\n class=\"sub-heading\"><md-icon ng-if=\"ctrl.parent.currentCard.meta.delivery_sub_vendor\" \nmd-svg-src=\"assets/icons/custom/user-icon.svg\" class=\"icon-size pr-6\"></md-icon><md-tooltip \nng-if=\"ctrl.parent.currentCard.meta.delivery_sub_vendor\" md-direction=\"top\" \nclass=\"font-size-11 white-fg bg-343434 p-10 text-center\" style=\"display:table;opacity: 1\">\n{{ctrl.parent.currentCard.meta.delivery_sub_vendor.sub_vendor_name}}</md-tooltip>\n{{ctrl.parent.currentCard.meta.delivery_sub_vendor ? ctrl.parent.currentCard.meta.delivery_sub_vendor.sub_vendor_name : \'-\'}}\n</div></div></div></div><div layout=\"row\" layout-wrap class=\"p-0 pb-20\" \nng-if=\"ctrl.parent.currentCard.meta.port_data.empty_container_drop\"><md-icon \nmd-svg-src=\"assets/icons/custom/road_haulage.svg\" class=\"icon-bs\"></md-icon><div class=\"pr-20\"><div class=\"heading\">\nEmpty Container Drop</div><div class=\"sub-heading\"><md-icon class=\"icon-size\" \nmd-svg-src=\"assets/icons/custom/search-bar/door.svg\"></md-icon>\n{{ ctrl.parent.currentCard.meta.port_data.empty_container_drop.port_name}}</div></div></div><md-divider \nng-if=\"ctrl.parent.currentCard.meta.port_data.delivery_location\" class=\"p-0\"></md-divider><div layout=\"row\" \nclass=\"p-0\"><img src=\"assets/icons/custom/search-bar/cargo.png\" class=\"cargo-icon-bs\"><div layout=\"row\" layout-wrap \nclass=\"p-0\"><div class=\"max-width-120 pr-20 pt-10\"><div class=\"heading\">Incoterms</div><div class=\"sub-heading\" \nlayout=\"row\">{{ctrl.parent.search_param.inco_term ? ctrl.parent.search_param.inco_term : \'-\'}}<div \nng-if=\"ctrl.parent.search_param.impo_expo && ctrl.parent.search_param.inco_term\">\n- {{ctrl.parent.search_param.impo_expo}}</div></div></div><div class=\"max-width-120 pr-20 pt-10\"><div class=\"heading\">\nCargo Type</div><div class=\"sub-heading\">\n{{ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.cargo_type_data.name ? ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.cargo_type_data.name : \'-\'}}\n</div></div><div class=\"max-width-350 pr-20 pt-10\"><div class=\"heading\">Commodity</div><div class=\"sub-heading\"><span \nng-repeat=\"commodity in ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.commodity_data\">\n{{commodity}}<span ng-if=\"!$last\">,</span> </span><span \nng-if=\"!ctrl.parent.currentCard.data[ctrl.parent.buyOrSell][ctrl.parent.l3_leg].rate_obj.commodity_data.length\">-\n</span></div></div></div></div></div><md-divider></md-divider></md-card-content></md-card></div>");
$templateCache.put("app/main/shipments/dialogs/modify-legs/charge-meta/charge.html","<div class=\"simple-table-container\" id=\"charges-table\"><md-content><table class=\"simple\" ms-responsive-table><thead \nng-class=\"{\'shipper-header\':!$ctrl.isShowBuyCol}\"><tr><th class=\"w-250\" rowspan=\"2\"><div \nclass=\"table-header column-title font-weight-600 text-left\">Charges</div></th><th class=\"w-100\" rowspan=\"2\" \nng-if=\"$ctrl.legData.leg_code==\'additional_services\'\"><div class=\"table-header column-title font-weight-600\">Type</div>\n</th><th class=\"w-120\" rowspan=\"2\"><div class=\"table-header column-title font-weight-600 text-left\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\">Basis</div></th><th class=\"w-100 text-center\" \nng-class=\"{\'w-125 p-15\':!$ctrl.isShowBuyCol}\" ng-if=\"$ctrl.mode === \'SEA-FCL\'\" rowspan=\"2\"><div \nclass=\"table-header column-title font-weight-600\">Equipment<br ng-if=\"$ctrl.isShowBuyCol\">Type</div></th><th \nclass=\"text-center w-90\" rowspan=\"2\"><div class=\"table-header column-title font-weight-600\">Quantity</div></th><th \ncolspan=\"{{$ctrl.mode != \'SEA-FCL\' ? 4: 2}}\" ng-if=\"$ctrl.isShowBuyCol\" class=\"rates-bg\"><div \nclass=\"table-header text-center column-title font-weight-600\" ng-if=\"$ctrl.isShowBuyCol\">Buy Rates</div></th><th \ncolspan=\"{{$ctrl.mode != \'SEA-FCL\' ? 4: 2}}\" ng-if=\"$ctrl.isShowBuyCol\"><div \nclass=\"table-header text-center column-title font-weight-600\">Sell Rates</div></th><th class=\"text-center w-130\" \nrowspan=\"2\" ng-if=\"!$ctrl.isShowBuyCol\"><div class=\"table-header column-title font-weight-600\">Unit Price</div></th><th\n class=\"w-90\" ng-if=\"!$ctrl.isShowBuyCol\" ng-if=\"$ctrl.mode != \'SEA-FCL\'\"><div \nclass=\"table-header text-center column-title font-weight-600\">Min</div></th><th class=\"w-90\" \nng-if=\"!$ctrl.isShowBuyCol\" ng-if=\"$ctrl.mode != \'SEA-FCL\'\"><div \nclass=\"table-header text-center column-title font-weight-600\">Max</div></th><th class=\"text-center w-120\" rowspan=\"2\" \nng-if=\"!$ctrl.isShowBuyCol\"><div class=\"table-header column-title font-weight-600\">Amount</div></th><th rowspan=\"2\" \nclass=\"w-80\">Comments</th><th rowspan=\"2\" class=\"w-10\" ng-if=\"$ctrl.quoteEdit\">Action</th></tr><tr \nng-if=\"$ctrl.isShowBuyCol\"><th class=\"w-130 rates-bg text-center\">Unit Price</th><th class=\"rates-bg w-90 text-center\" \nng-if=\"$ctrl.mode != \'SEA-FCL\'\">Min</th><th class=\"rates-bg w-90 text-center\" ng-if=\"$ctrl.mode != \'SEA-FCL\'\">Max</th>\n<th class=\"w-120 rates-bg text-center\">Amount</th><th class=\"w-130 text-center\">Unit Price</th><th \nclass=\"w-90 text-center\" ng-if=\"$ctrl.mode != \'SEA-FCL\'\">Min</th><th class=\"w-90 text-center\" \nng-if=\"$ctrl.mode != \'SEA-FCL\'\">Max</th><th class=\"w-120 text-center\">Amount</th></tr></thead><tbody><tr \nng-class=\"{\'user-charge-class\':!$ctrl.legData.charges.charge_id}\" id=\"{{ $ctrl.legData.leg_code+\'_\'+ $index+\'_row\'}}\" \nng-repeat=\"charge in $ctrl.legData.charges track by $index\" ng-if=\"charge.status != \'REMOVED\'\" class=\"bg_row\"><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nclass=\"chargeName w-250\"><div class=\"content-border text-left\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_charge\'}}\">\n<div ng-if=\"!$ctrl.quoteEdit\" layout=\"row\" flex=\"100\" class=\"ph-8 remove-cursor pb-5\"><div layout-align=\"left center\" \nflex=\"75\" class=\"text-left\"><div layout=\"row\" class=\"pt-9\"><span ng-bind=\"charge.charge_name\" class=\"ellipsis-120\">\n<md-tooltip md-direction=\"top\" class=\"font-size-11\">{{charge.charge_name}}</md-tooltip></span><span class=\"pl-5\" \nng-bind=\"charge.container_type\"></span></div><span class=\"font-size-11\" \nng-if=\"charge.charge_type===\'SLAB\' && charge.calculated_slab && charge.calculated_slab.length\">\n{{charge.calculated_slab[0].from}} {{(charge.calculated_slab[0].from == null || charge.calculated_slab[0].from == undefined) ? \'0\' : (charge.slab_basis ? (charge.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \')+ \' to \'}} {{charge.calculated_slab[0].to}} {{(charge.calculated_slab[0].to ? (charge.slab_basis ? (charge.slab_basis | splitSubstring:\'per\':1:1).toUpperCase()+\' \' : \'KG \') : \'∞\')}}\n<md-icon class=\"s12\" position=\"bottom\" md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nWeight Range Charge</md-tooltip></md-icon></span></div></div><md-input-container md-no-float class=\"inline-flex\" \nng-if=\"$ctrl.quoteEdit\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'charge\');$ctrl.fnChargeTextChange(charge, $index, $ctrl.legData.leg_code,$event);\" \nrestrict-to=\"{{$ctrl.util.nonSpecialCharacterRegex}}\" title=\"{{charge.charge_name}}\"><md-autocomplete \nng-disabled=\"!$ctrl.legData.leg_name\" class=\"pl-8\" md-input-name=\"chargeName\" md-selected-item=\"selectedCharge\" \nmd-search-text=\"charge.charge_name\" \nmd-selected-item-change=\"$ctrl.fnChargeSelection(selectedCharge,charge, $ctrl.legData, $index)\" \nmd-items=\"item in $ctrl.getChargeList(charge.charge_name,$ctrl.legData, charge)\" md-item-text=\"item.charge_name\" \nmd-min-length=\"3\" md-input-id=\"{{$ctrl.legData.leg_code +\'_\'+ $index}}\" md-select-on-match=\"false\" \nmd-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"300\" placeholder=\"Charge Name\" ng-required=\"true\">\n<md-item-template><span md-highlight-text=\"charge.charge_name\" md-highlight-flags=\"^i\" title=\"{{item.charge_name}}\">\n{{item.charge_name}}</span></md-item-template></md-autocomplete><div \nclass=\"sticky-charge-sect-tag dim-charge-sect pb-5\" ng-if=\"charge.charge_category && charge.charge_category !== null\" \nng-bind=\"charge.charge_category\"></div></md-input-container></div><div class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_chargeError\'}}\">Please Enter</div><div layout=\"row\" \nclass=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_name && charge.charge_name.length<=2 && !charge.charge_id\">Enter the first three letter to search\n</div><div layout=\"row\" class=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_name.length> 2 && !charge.charge_id && !$ctrl.shareQuoteService.userDefinedChargeValidation\">\nAdding a user defined charge</div><div layout=\"row\" class=\"fg-333333 font-size-13 user-charge-class\" \nng-if=\"charge.charge_id && charge.charge_id.includes(\'UD\') && !$ctrl.shareQuoteService.userDefinedChargeValidation\">\nUser defined charge</div></td><td class=\"chargeName\" ng-if=\"$ctrl.legData.leg_code==\'additional_services\'\"><span \nng-repeat=\"leg in charge.leg track by $index\"><span ng-bind=\"leg.name\"></span> <span ng-if=\"!$last\">,</span></span>\n</td><td rowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol,\'basis-error-border\':charge.charge_basis.includes(\'%\') && charge.total_units === null}\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_chargeBasis\'}}\"><div \nclass=\"pt-8 pl-5 remove-cursor ellipsis-120 basis-ellipsis-100\" ng-class=\"{\'w-basis\':charge.charge_basis===\'per teu\'}\" \nng-if=\"charge.charge_basis.includes(\'dim\')\" ng-bind=\"charge.charge_basis\"><md-tooltip md-direction=\"top\" \nclass=\"font-size-11\">{{charge.charge_basis}}</md-tooltip></div><md-input-container md-no-float \nclass=\"inline-flex full-width\" ng-class=\"{\'w-basis\':charge.charge_basis===\'per teu\'}\" \nng-if=\"$ctrl.quoteEdit  && !charge.charge_basis.includes(\'dim\')\"><select class=\"custom_select full-width h-32\" \nng-change=\"$ctrl.fnGetContainerQty(charge,$index); $ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'basis\');\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_chargeBasis\'}}\" ng-model=\"charge.charge_basis\" placeholder=\"Basis\" \ntitle=\"{{charge.charge_basis}}\" class=\"m-0 select_currency rate_select_box\"><option \nng-repeat=\"basis in $ctrl.viewBasis\" value=\"{{basis}}\" \nng-if=\"(basis != $ctrl.constObj.FREIGHT_TOTAL_BASIS || ((($ctrl.legData.leg_code.includes(\'l2_\') || $ctrl.legData.leg_code.includes(\'l4_\')) && !$ctrl.legData.leg_code.includes(\'cha\')) && basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS)) &&  (basis != $ctrl.constObj.FREIGHT_BASIS || ((basis === $ctrl.constObj.FREIGHT_BASIS) && $ctrl.legData.leg_code.includes(\'l3_\')) && $ctrl.mode !== \'AIR\') && (basis != $ctrl.constObj.AIR_FREIGHT_BASIS || ((basis === $ctrl.constObj.AIR_FREIGHT_BASIS) && $ctrl.legData.leg_code.includes(\'l3_\')) && $ctrl.mode === \'AIR\') && (basis != $ctrl.constObj.PICKUP_BASIS ||  ((basis === $ctrl.constObj.PICKUP_BASIS) && $ctrl.legData.leg_code.includes(\'l1_\'))) && (basis != $ctrl.constObj.DELIVERY_BASIS || (((basis === $ctrl.constObj.DELIVERY_BASIS) && $ctrl.legData.leg_code.includes(\'l5_\'))))\">\n{{basis}}</option></select></md-input-container><md-icon ng-if=\"charge.charge_basis===\'per teu\'\" class=\"s12\" \nposition=\"bottom\" ng-class=\"{\'mb-5\':!$ctrl.quoteEdit  }\" md-font-icon=\"icon-information-outline\"><md-tooltip \nmd-direction=\"top\" class=\"tooltip-height\"><div>20 GP/RE/NR/OT/FR - 1 TEU</div><div>40 GP/HC/RE/HR/NR/OT/FR - 2 TEU\n</div><div>45HC - 2.25 TEU</div><div>53HC - 2.65 TEU</div></md-tooltip></md-icon></div><span \nclass=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_basisError\'}}\">Please Select</span> <span \nclass=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_duplicateBasis\'}}\">Already exist</span> <span \nng-show=\"charge.charge_basis.includes(\'%\') && charge.total_units === null\" class=\"error\">\n{{charge.charge_basis}} can not applied for this charge.</span></td><td \nng-if=\"!$ctrl.quoteEdit && $ctrl.mode === \'SEA-FCL\'\" \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border text-center p-8 remove-cursor\"><span ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\" \nclass=\"line-height-17\" \nng-bind=\"(charge.charge_basis === \'per equipment\' || charge.charge_basis === \'per kg\' || charge.charge_basis === \'per ton\' || charge.charge_basis === $ctrl.constObj.PICKUP_BASIS || charge.charge_basis === $ctrl.constObj.DELIVERY_BASIS || charge.charge_basis === $ctrl.constObj.FREIGHT_BASIS) ? charge.container_type : \'N/A\'\">\n</span></div></td><td ng-if=\"$ctrl.quoteEdit && $ctrl.mode === \'SEA-FCL\'\" \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border text-center\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_equipmentType\'}}\"><div \nng-if=\"charge.charge_basis !== \'per equipment\' && charge.charge_basis !== \'per kg\'  && charge.charge_basis !== \'per ton\' && charge.charge_basis !== $ctrl.constObj.PICKUP_BASIS && charge.charge_basis !== $ctrl.constObj.DELIVERY_BASIS && charge.charge_basis !== $ctrl.constObj.FREIGHT_BASIS \" \nclass=\"p-8\">N/A</div><md-input-container md-no-float \nng-if=\"charge.charge_basis === \'per equipment\' || charge.charge_basis === \'per kg\'  || charge.charge_basis === \'per ton\' || charge.charge_basis === $ctrl.constObj.PICKUP_BASIS || charge.charge_basis === $ctrl.constObj.DELIVERY_BASIS || charge.charge_basis === $ctrl.constObj.FREIGHT_BASIS\" \nclass=\"inline-flex full-width\"><select class=\"custom_select text-center mt-3 full-width\" \nng-change=\"$ctrl.fnGetContainerQty(charge,$index);$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'container\');\" \nng-model=\"charge.container_type\" placeholder=\"Equipment Type\" class=\"m-0 p-8 select_currency rate_select_box\"><option \nng-repeat=\"item in $ctrl.ShipmentsDetails.load_data.load_details_value\" value=\"{{item.type}}\">{{item.type}}</option>\n</select></md-input-container></div><span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_equipmentError\'}}\">Please Select</span> <span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_duplicateEquipment\'}}\">Already exists</span></td><td><div \nng-if=\"!charge.is_qty_editable || !$ctrl.quoteEdit || $ctrl.basisDisableList.includes(charge.charge_basis) || charge.charge_basis.includes(\'dim\')\" \nng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\" class=\"content-border text-center p-8 remove-cursor\"><span \nclass=\"line-height-17\" ng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type===\'INCREMENTAL\'\">\n{{charge.total_units == \'\' ? \'-\' : $ctrl.calculateQtyRange(charge, 0) | currencyMask }} | {{charge.slab[0].from}} - {{charge.slab[0].to}}\n<md-tooltip md-direction=\"top\">\n{{charge.total_units == \'\' ? \'-\' : $ctrl.calculateQtyRange(charge, 0) | currencyMask }} | {{charge.slab[0].from}} - {{charge.slab[0].to}}\n</md-tooltip></span><span class=\"line-height-17\" \nng-if=\"(charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\') || $ctrl.basisDisableList.includes(charge.charge_basis) || charge.charge_basis.includes(\'dim\')\" \nng-bind=\"charge.total_units == \'\' ? \'-\' : (charge.total_units | currencyMask)\"><md-tooltip md-direction=\"top\">\n{{charge.total_units == \'\' ? \'-\' : (charge.total_units | currencyMask)}}</md-tooltip></span><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s14 ml-2 mb-3\" \nid=\"{{\'charge_\'+$ctrl.legData.global_leg_id+\'_\'+$index}}\" \nng-if=\"$ctrl.ShipmentsDetails.load_data.load_details_value && ($ctrl.legData.global_leg_id == \'l1\' || $ctrl.legData.global_leg_id == \'l5\') && charge.charge_basis == \'per_w/m\' && $ctrl.mode !==  \'SEA-FCL\'\">\n<md-tooltip md-direction=\"bottom\" class=\"black-bg p-10 white-fg\" \nstyle=\"display:table;opacity:1;line-height:1.3; box-shadow: 0px 0px 20px #00000014\" class=\"font-size-10\"><div \nng-if=\"$ctrl.legData.global_leg_id == \'l1\'\"><table><tr><td>Gross Weight</td><td>\n{{$ctrl.ShipmentsDetails.load_data.load_details_value.origin.gross_weight | currencyMask}} {{$ctrl.ShipmentsDetails.load_data.load_details_value.origin.gross_weight_unit}}\n</td></tr><tr><td>Dimensional Weight</td><td>\n{{$ctrl.ShipmentsDetails.load_data.load_details_value.origin.dimensional_weight | currencyMask}} {{$ctrl.ShipmentsDetails.load_data.load_details_value.origin.dimensional_unit}}\n</td></tr><tr><td>Chargeable Weight</td><td>\n{{$ctrl.ShipmentsDetails.load_data.load_details_value.origin.chargeable_weight | currencyMask}} {{$ctrl.ShipmentsDetails.load_data.load_details_value.origin.chargeable_unit}}\n</td></tr></table></div><div ng-if=\"$ctrl.legData.global_leg_id == \'l5\'\"><table><tr><td>Gross Weight</td><td>\n{{$ctrl.ShipmentsDetails.load_data.load_details_value.destination.gross_weight | currencyMask}} {{$ctrl.ShipmentsDetails.load_data.load_details_value.destination.gross_weight_unit}}\n</td></tr><tr><td>Dimensional Weight</td><td>\n{{$ctrl.ShipmentsDetails.load_data.load_details_value.destination.dimensional_weight | currencyMask}} {{$ctrl.ShipmentsDetails.load_data.load_details_value.destination.dimensional_unit}}\n</td></tr><tr><td>Chargeable Weight</td><td>\n{{$ctrl.ShipmentsDetails.load_data.load_details_value.destination.chargeable_weight | currencyMask}} {{$ctrl.ShipmentsDetails.load_data.load_details_value.destination.chargeable_unit}}\n</td></tr></table></div></md-tooltip></md-icon></div><md-input-container md-no-float \nclass=\"inline-flex content-border\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_quantity\'}}\" \nng-if=\"charge.is_qty_editable && $ctrl.quoteEdit && !$ctrl.basisDisableList.includes(charge.charge_basis) && !charge.charge_basis.includes(\'dim\')\">\n<input ng-model=\"charge.total_units\" \nng-change=\"$ctrl.fnGetContainerQty(charge,i,\'qty_edit\');$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'quantity\');\" \nng-model-options=\"{ debounce: 100 }\" type=\"number\" step=\"any\" placeholder=\"Quantity\" name=\"quantity\" \nclass=\"m-0 select_box bottom-border text-center\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_quantity\'}}\">\n</md-input-container><span class=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_quantityError\'}}\">\nPlease Enter</span> <span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index + \'_quantityCharacter\'}}\">Invalid Input</span></td><td \nng-if=\"$ctrl.isShowBuyCol && (!$ctrl.editBuyRate )\" \nclass=\"{{$ctrl.legData.leg_code + $index+\'remove-rates-bg\'}} rates-bg remove-cursor\"><div class=\"content-border p-8\">\n<span class=\"pr-20 line-height-17\" \nng-class=\"{\'pl-37\':charge.charge_basis === \' $ctrl.constObj.PICKUP_BASIS\' || charge.charge_basis === $ctrl.constObj.DELIVERY_BASIS || charge.charge_basis === $ctrl.constObj.FREIGHT_BASIS|| charge.charge_basis === $ctrl.constObj.FREIGHT_TOTAL_BASIS}\" \nng-bind=\"charge.charge_basis === $ctrl.constObj.PICKUP_BASIS || charge.charge_basis === $ctrl.constObj.DELIVERY_BASIS || charge.charge_basis === $ctrl.constObj.FREIGHT_BASIS ? \'%\' : charge.buy.charge_currency\" \nng-if=\"!$ctrl.isString($ctrl.currentCard.data.buy_rates[$ctrl.legData.leg_code].rate_obj.charges[$index].per_unit_rate)\">\n</span> <span ng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-bind=\"$ctrl.fnCheckIsNaN($ctrl.currentCard.data.buy_rates[$ctrl.legData.leg_code].rate_obj.charges[$index], \'per_unit_rate\')\">\n</span> <span ng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type.toUpperCase()!==\'DIRECT\'\" \nng-bind=\"charge.buy.slab[0].cost\"></span></div></td><td ng-if=\"$ctrl.isShowBuyCol && $ctrl.editBuyRate \" \nclass=\"{{$ctrl.legData.leg_code + $index+\'remove-rates-bg\'}} rates-bg w-90\"><md-input-container md-no-float \nclass=\"inline-flex content-border pl-5\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_buyUnit\'}}\"><span \nclass=\"mt-5 currency-align\"><select ng-if=\"!(charge.charge_basis.includes(\'%\'))\" \nng-change=\"$ctrl.unitPriceCurrencyChange(charge,\'buy\')\" ng-model=\"charge.buy.charge_currency\" \nng-options=\"curr for curr in $ctrl.currencyList\" class=\"custom_select text-center\" placeholder=\"Currency\" \nclass=\"m-0 select_currency select_box selectpicker\"></select></span><div class=\"mh-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"charge.charge_basis.includes(\'%\')\">%</div><md-input-container md-no-float \nclass=\"inline-flex\"><input ng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-model-options=\"{ debounce: 100 }\" ng-change=\"$ctrl.unitPriceChange(charge, \'buy\');\" \nng-model=\"charge.buy.per_unit_rate\" title=\"{{charge.buy.per_unit_rate}}\" type=\"text\" step=\"any\" \nplaceholder=\"Unit Price\" name=\"unit_price\" class=\"m-0 select_box bottom-border pt-4\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+$index+\'_buyUnit\'}}\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'buyUnit\')\"> <input \nng-readonly=\"!$ctrl.calculateQtyRange(charge, 0)\" ng-model=\"charge.buy.slab[0].cost\" \ntitle=\"{{charge.buy.slab[0].cost}}\" \nng-if=\"charge.charge_type==\'SLAB\' &&\n                        charge.slab_type.toUpperCase()!==\'DIRECT\'\" \nng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" name=\"unit_price\" \nclass=\"m-0 select_box bottom-border pt-4\" id=\"{{$ctrl.legData.leg_code +\'_\'+$index+\'_0_buyUnit\'}}\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'buyUnit\')\" \nng-change=\"$ctrl.unitPriceChange(charge, \'buy\')\"></md-input-container></md-input-container><span \nclass=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index + \'_buyUnitError\'}}\">Please Enter</span> <span \nclass=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index + \'_buyUnitCharacter\'}}\">Invalid Input</span>\n</td><td ng-if=\"$ctrl.isShowBuyCol && (!$ctrl.editBuyRate) && $ctrl.mode != \'SEA-FCL\'\" \nclass=\"rates-bg remove-cursor {{$ctrl.legData.leg_code + $index+\'remove-rates-bg\'}}\"><div \nclass=\"content-border text-center pl-5 p-8 line-height-17\"><span ng-bind=\"charge.minimum_charge_cost | currencyMask\">\n</span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.isShowBuyCol && $ctrl.editBuyRate &&  $ctrl.mode != \'SEA-FCL\'\" \nclass=\"{{$ctrl.legData.leg_code + $index+\'remove-rates-bg\'}} rates-bg\"><md-input-container md-no-float \nclass=\"inline-flex content-border\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_buyMinimum\'}}\"><input \nng-model=\"charge.buy.minimum_charge_cost\" ng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'buyMinimum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Minimum Amount\" name=\"min_amount\" class=\"m-0 text-center select_box bottom-border pt-4\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_buy_min_unit\'}}\" ng-change=\"$ctrl.minimumChange(charge,\'buy\');\">\n</md-input-container><span class=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_buyMinimumError\'}}\">\nPlease Enter</span> <span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index + \'_buyMinimumCharacter\'}}\">Invalid Input</span></td><td \nng-if=\"$ctrl.isShowBuyCol && (!$ctrl.editBuyRate) && $ctrl.mode != \'SEA-FCL\'\" \nclass=\"rates-bg remove-cursor {{$ctrl.legData.leg_code + $index+\'remove-rates-bg\'}}\"><div \nclass=\"content-border text-center pl-5 p-8 line-height-17\"><span ng-bind=\"charge.maximum_charge_cost | currencyMask\">\n</span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.isShowBuyCol && $ctrl.editBuyRate &&  $ctrl.mode != \'SEA-FCL\'\" \nclass=\"{{$ctrl.legData.leg_code + $index+\'remove-rates-bg\'}} rates-bg\"><md-input-container md-no-float \nclass=\"inline-flex content-border\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_buyMaximum\'}}\"><input \nng-model=\"charge.buy.maximum_charge_cost\" ng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'buyMaximum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Maximum Amount\" name=\"max_amount\" class=\"m-0 text-center select_box bottom-border pt-4\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_buy_max_unit\'}}\" ng-change=\"$ctrl.maximumChange(charge,\'buy\')\">\n</md-input-container><span class=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_buyMaximumError\'}}\">\nMaximum must be greater than Minimum</span> <span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index + \'_buyMaximumCharacter\'}}\">Invalid Input</span></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.isShowBuyCol\" class=\"{{$ctrl.legData.leg_code + $index+\'remove-rates-bg\'}} rates-bg remove-cursor\"><div \nclass=\"content-border p-8\"><span class=\"pr-20 line-height-17\" \nng-if=\"!$ctrl.util.isString(charge.buy.charge_cost) || charge.buy.min_flag || charge.buy.max_flag\" \nng-bind=\"$ctrl.legData.buy.leg_currency\"></span> <span ng-bind=\"$ctrl.fnCheckIsNaN(charge.buy)\"></span> <sup \nclass=\"green-fg\" ng-if=\"charge.buy.min_flag\">*<md-tooltip md-direction=\"top\" class=\"font-size-10\">Minimum amount\n</md-tooltip></sup><sup class=\"green-fg\" ng-if=\"charge.buy.max_flag\">*<md-tooltip md-direction=\"top\" \nclass=\"font-size-10\">Maximum amount</md-tooltip></sup></div></td><td ng-if=\"!$ctrl.quoteEdit\"><div \nclass=\"content-border p-8 remove-cursor\" ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\"><span class=\"line-height-17\" \nng-class=\"{\'pr-5\':!$ctrl.isShowBuyCol, \'pr-20\':$ctrl.isShowBuyCol}\" ng-if=\"!$ctrl.isString(charge.per_unit_rate)\" \nng-bind=\"charge.charge_basis.includes(\'%\') ? \'%\' : charge.charge_currency\"></span> <span \nng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\" \nng-bind=\"$ctrl.fnCheckIsNaN(charge, \'per_unit_rate\')\"></span> <span \nng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type.toUpperCase()!==\'DIRECT\'\" ng-bind=\"charge.slab[0].cost\"></span>\n</div></td><td ng-if=\"$ctrl.quoteEdit\"><md-input-container md-no-float class=\"inline-flex content-border h-36\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellUnit\'}}\"><span ng-if=\"!charge.charge_basis.includes(\'%\')\"><select \nclass=\"font-size-13 custom_select currency-align text-center\" ng-model=\"charge.charge_currency\" placeholder=\"Currency\" \nclass=\"m-0 select_currency select_box selectpicker\" ng-change=\"$ctrl.unitPriceCurrencyChange(charge,\'sell\')\" \nng-options=\"curr for curr in $ctrl.currencyList\"></select></span><div class=\"mh-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"charge.charge_basis.includes(\'%\')\">%</div><md-input-container md-no-float \nclass=\"inline-flex\" ng-if=\"charge.charge_type!=\'SLAB\' || charge.slab_type.toUpperCase()===\'DIRECT\'\"><input \nng-model=\"charge.per_unit_rate\" title=\"{{charge.per_unit_rate}}\" ng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'sellUnit\')\" type=\"text\" step=\"any\" \nplaceholder=\"Unit Price\" name=\"unit_price\" class=\"m-0 select_box bottom-border font-size-13 pt-4\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_unit\'}}\" ng-change=\"$ctrl.unitPriceChange(charge, \'sell\');\">\n</md-input-container><md-input-container md-no-float class=\"inline-flex\" \nng-if=\"charge.charge_type==\'SLAB\' && charge.slab_type.toUpperCase()!==\'DIRECT\'\"><input \nng-readonly=\"!$ctrl.calculateQtyRange(charge, 0)\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'sellUnit\')\" ng-model=\"charge.slab[0].cost\" \ntitle=\"{{charge.slab[0].cost}}\" ng-model-options=\"{ debounce: 100 }\" type=\"text\" step=\"any\" placeholder=\"Unit Price\" \nname=\"unit_price\" class=\"m-0 select_box bottom-border font-size-13 pt-4\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+$index+\'_0_unit\'}}\" \nng-change=\"$ctrl.conversionOnPriceChange(charge, $ctrl.legData, $index);\"></md-input-container></md-input-container>\n<span class=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellUnitError\'}}\">Please Enter</span> \n<span class=\"error-text-position\" id=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellUnitCharacter\'}}\">Invalid Input\n</span></td><td ng-if=\"!$ctrl.quoteEdit &&  $ctrl.mode != \'SEA-FCL\'\"><div \nclass=\"content-border text-center p-8 remove-cursor\"><span ng-bind=\"charge.minimum_charge_cost  | currencyMask : 2\">\n</span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.quoteEdit && $ctrl.mode != \'SEA-FCL\'\"><md-input-container md-no-float class=\"inline-flex content-border\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellMinimum\'}}\"><input ng-model=\"charge.minimum_charge_cost\" \nng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'sellMinimum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Minimum Amount\" name=\"min_amount\" class=\"m-0 select_box bottom-border text-center pt-4\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_min_unit\'}}\" ng-change=\"$ctrl.minimumChange(charge,\'sell\');\">\n</md-input-container><span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellMinimumError\'}}\">Please Enter</span> <span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellMinimumCharacter\'}}\">Invalid Input</span></td><td \nng-if=\"!$ctrl.quoteEdit &&  $ctrl.mode != \'SEA-FCL\'\"><div class=\"content-border text-center p-8 remove-cursor\"><span \nng-bind=\"charge.maximum_charge_cost  | currencyMask : 2\"></span></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.quoteEdit && $ctrl.mode != \'SEA-FCL\'\"><md-input-container md-no-float class=\"inline-flex content-border\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellMaximum\'}}\"><input ng-model=\"charge.maximum_charge_cost\" \nng-model-options=\"{ debounce: 100 }\" \nng-keyup=\"$ctrl.fnChargeValidation($ctrl.legData.leg_code, $index,charge,\'sellMaximum\')\" type=\"text\" step=\"any\" \nplaceholder=\"Maximum Amount\" name=\"max_amount\" class=\"m-0 select_box bottom-border text-center pt-4\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_max_unit\'}}\" ng-change=\"$ctrl.maximumChange(charge,\'sell\')\">\n</md-input-container><span class=\"error-text-position\" \nid=\"{{$ctrl.legData.leg_code +\'_\'+ $index+\'_sellMaximumError\'}}\">Maximum must be greater than Minimum</span></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\"><div \nclass=\"content-border p-8 remove-cursor\" ng-class=\"{\'text-center\':!$ctrl.isShowBuyCol}\"><span \nng-class=\"{\'pr-5\':!$ctrl.isShowBuyCol, \'pr-20\':$ctrl.isShowBuyCol}\" class=\"line-height-17\" \nng-if=\"!$ctrl.util.isString(charge.charge_cost) || charge.min_flag || charge.max_flag\" \nng-bind=\"$ctrl.legData.leg_currency\"></span> <span ng-bind=\"$ctrl.fnCheckIsNaN(charge)\"></span> <sup class=\"green-fg\" \nng-if=\"charge.min_flag\">*<md-tooltip md-direction=\"top\" class=\"font-size-10\">Minimum amount</md-tooltip></sup><sup \nclass=\"green-fg\" ng-if=\"charge.max_flag\">*<md-tooltip md-direction=\"top\" class=\"font-size-10\">Maximum amount\n</md-tooltip></sup></div></td><td class=\"text-center\"><div \nng-if=\"!(charge.internal_comments || charge.external_comments)\"><md-icon class=\"comments-icon cursor\" \nmd-svg-src=\"assets/icons/custom/add_comment.svg\" title=\"Add\" ng-click=\"$ctrl.fnOpenCommentPanel($event , charge)\">\n</md-icon></div><div ng-if=\"(charge.internal_comments || charge.external_comments)\"><md-icon \nclass=\"comments-icon cursor\" md-svg-src=\"assets/icons/custom/edit_comment.svg\" title=\"Edit\" \nng-click=\"$ctrl.fnOpenCommentPanel($event , charge)\"></md-icon></div></td><td \nrowspan=\"{{(charge.slab_type===\'INCREMENTAL\')&&charge.charge_type==\'SLAB\'? charge.slab.length : 1}}\" \nng-if=\"$ctrl.quoteEdit\"><div layout=\"row\"><div><md-icon class=\"s20 cursor pt-7\" \nmd-font-icon=\"icon-minus-circle-outline red-400-fg\" title=\"Remove charge\" \nng-click=\"$ctrl.confirmDeleteCharge($ctrl.legData.leg_code,$ctrl.legData,$index)\" ng-if=\"$ctrl.quoteEdit\"></md-icon>\n</div><div><md-icon class=\"s20 cursor ml-7 pt-7\" md-font-icon=\"icon-plus-circle-outline green-400-fg\" \ntitle=\"Add charge\" ng-click=\"$ctrl.addNewCharge()\"></md-icon></div></div></td></tr></tbody></table></md-content></div>");
$templateCache.put("app/main/shipments/dialogs/modify-legs/leg/leg.html","<div layout=\"row\" layout-padding class=\"billing-leg header\" flex=\"100\"><div class=\"p-0\" flex=\"100\">\n{{$ctrl.action}} Charges</div><div layout=\"row\" class=\"p-0\" layout-align=\"end end\"><md-icon \nmd-font-icon=\"icon-close fg-AAA8AD m-0 pointer\" ng-click=\"$ctrl.cancelDialog();\"></md-icon></div></div>\n<md-dialog-content class=\"body billing-leg margin_bottom_7per\"><div \nng-repeat=\"legData in $ctrl.billingInfoData.rates track by $index\" ng-if=\"legData.leg_status != \'REMOVED\'\" \nng-class=\"{\'mt-20\':!($ctrl.util.isShipper || $ctrl.isShared),\'border-shipper\':$ctrl.util.isShipper || $ctrl.isShared}\" \nclass=\"pt-0 quotes-table position-relative buy_sell_rates\" id=\"{{legData.leg_code+\'_cardLeg\'}}\"><div layout=\"row\" \nflex=\"100\" layout-align=\"space-between center\" class=\"p-5 quotation-leg\" layout-wrap \nng-class=\"{\'leg-border-bottom\' :$ctrl.util.isShipper || $ctrl.isShared}\"><div layout-align=\"start center\" class=\"ph-5\">\n<md-input-container id=\"{{legData.leg_code + \'_leg\'}}\" md-no-float ng-keyup=\"$ctrl.fnLegNameChange(legData,$event)\" \nclass=\"leg-name panel-select\" restrict-to=\"{{$ctrl.util.nonSpecialCharacterRegex}}\"><md-autocomplete \nmd-input-name=\"legName\" md-selected-item=\"selectedLeg\" md-search-text=\"legData.leg_name\" \nmd-selected-item-change=\"$ctrl.fnLegSelected(selectedLeg,legData)\" md-input-id=\"{{legData.leg_code}}\" \nmd-items=\"item in $ctrl.fnGetLegList(legData.leg_name)\" md-item-text=\"item.leg_name\" md-min-length=\"3\" \nmd-select-on-match=\"false\" md-clear-button=\"false\" md-no-cache=\"false\" md-delay=\"300\" placeholder=\"Leg Name\" \nng-required=\"true\" class=\"leg-name-class\"><md-item-template><span md-highlight-text=\"legData.leg_name\" \nmd-highlight-flags=\"^i\">{{item.leg_name}}</span></md-item-template></md-autocomplete></md-input-container><span \nclass=\"legError\" id=\"{{legData.leg_code + \'_text\'}}\">Please enter leg name</span> <span class=\"legError\" \nid=\"{{legData.leg_code + \'_duplicateText\'}}\">Leg Name Already Exists</span></div><div layout=\"row\" \nlayout-align=\"end center\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nng-if=\"($ctrl.isOwnVendorRate) && $ctrl.sourceData && $ctrl.sourceData!={} && legData.batchcode\"><button \nng-repeat=\"batchcode in legData.batchcode track by $index\"><div ng-if=\"$ctrl.sourceData[batchcode].sourceFileUrl\"><div \nng-click=\"$ctrl.sourceDownload(batchcode)\"><div class=\"m-10 h-16 blue-600-fg Font-Bold pointer\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"mr-5\"><md-icon class=\"cursor blue-600-fg s16\" md-font-icon=\"icon-download\">\n</md-icon></div><div>Download Source {{$index+1}}</div><md-tooltip md-direction=\"top\" \nng-if=\"!$ctrl.util.isMobileDevice\">Download original source rate sheet</md-tooltip></div></div></div></button></div>\n<div layout=\"row\" layout-align=\"start center\"><button layout=\"row\" layout-align=\"center center\" \nclass=\"m-10 h-16 red-600-fg\" ng-click=\"$ctrl.fnDeleteLegConfirmation(legData)\"><div class=\"mr-5\"><md-icon \nclass=\"cursor red-600-fg s20\" md-font-icon=\"icon-delete\"></md-icon></div><div>Delete Leg</div></button></div><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"m-10 fg-333333\">Sub Total</div><div \nclass=\"total_div\" layout=\"row\"><div class=\"p-5\" ng-if=\"!$ctrl.quoteEdit\" ng-bind=\"sell_value.rate_obj.leg_currency\">\n</div><select ng-model=\"legData.leg_currency\" ng-options=\"curr for curr in $ctrl.currencyList\" placeholder=\"Currency\" \nclass=\"m-0 leg_curr_select border-left select_currency select_box\" ng-change=\"$ctrl.changeLegCurrency(legData)\">\n</select><div ng-bind=\"legData.leg_currency_cost | currencyMask: 2\" class=\"total-disabled\"></div></div></div></div>\n</div><charge leg-data=\"legData\" footer-obj=\"$ctrl.footerObj\" billing-info-data=\"$ctrl.billingInfoData\" \nrate-vendor-id=\"$ctrl.rateVendorId\" callback=\"$ctrl.changeLegCurrency(legData, \'fromCharge\')\"></charge><div \nclass=\"overlayLeg hide\" id=\"{{legData.leg_code+\'_askDeleteLeg\'}}\"><div class=\"delete-confirmation-div text-center\"><div\n layout=\"row\" layout-align=\"center center\" ng-if=\"$ctrl.billingInfoService.chargeDelete\"><p>\nDelete this {{$ctrl.billingInfoService.deleteChargeLineObj.charge_name}} ?</p></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"$ctrl.billingInfoService.legDelete\"><p>\nDelete this {{$ctrl.deleteLegObj.leg_name}} ?</p></div><div layout=\"row\" layout-align=\"center center\"><md-button \nmd-no-ink class=\"md-primary-btn mr-10\" ng-click=\"$ctrl.billingInfoService.cancelDelete(legData.leg_code)\">Close\n</md-button><md-button md-no-ink ng-if=\"$ctrl.billingInfoService.chargeDelete\" class=\"md-accent-btn ml-10\" \nng-disabled=\"$ctrl.billingInfoService.deleteChargeBtn\" ng-click=\"$ctrl.fnDeleteNewCharge(legData.leg_code)\">Yes, Delete\n</md-button><md-button md-no-ink ng-if=\"$ctrl.billingInfoService.legDelete\" class=\"md-accent-btn ml-10\" \nng-disabled=\"$ctrl.billingInfoService.deleteChargeBtn\" ng-click=\"$ctrl.fnDeleteLeg(legData)\">Yes, Delete</md-button>\n</div></div></div><div class=\"overlayLeg hide\" id=\"{{legData.leg_code+\'_reloadCurrency\'}}\"><div \nclass=\"replay-icon-div text-center\"><md-icon md-font-icon=\"icon-replay\" class=\"s50 grey-400-fg\"></md-icon></div></div>\n</div><div layout=\"row\" layout-align=\"start center\" class=\"mt-20\" flex=\"100\"><md-button layout=\"row\" md-no-ink \nclass=\"md-link-btn m-0\" title=\"Add Leg\" ng-click=\"$ctrl.addNewLeg()\"><div><md-icon \nmd-font-icon=\"icon-plus md-link-fg s20\" placeholder=\"Add leg\"></md-icon></div><div class=\"font-size-13\">Add Leg</div>\n</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"billing-leg sticky-bottom card_shadow footer-mobile-spacing\"><div layout=\"row\" flex=\"100\" class=\"pl-10\" \nlayout-wrap ng-if=\"!$ctrl.showData\"><div layout=\"column\" flex=\"15\" flex-xs=\"100\" flex-sm=\"25\" class=\"mr-15\" hide-xs \nhide-sm layout-align=\"center start\" layout-wrap ng-if=\"$ctrl.dimLegList.length\"><div class=\"pb-10\">DIM Calculation\n</div><div class=\"font-size-11\">{{$ctrl.dimLegList[0].cbm}} KG / CBM for {{$ctrl.dimLegList[0].leg_name}}<span \nng-show=\"$ctrl.dimLegList.length>1\">,{{$ctrl.dimLegList[1].cbm}} KG / CBM for {{$ctrl.dimLegList[1].leg_name}}</span>\n<span ng-show=\"$ctrl.dimLegList.length>2\" class=\"md-link-fg\">,+{{$ctrl.dimLegList.length-2}}</span><md-tooltip \nmd-direction=\"top\" class=\"md-whiteframe-2dp white-fg black-bg font-size-10 ph-20 line-height-20 pv-5\" \nstyle=\"height: fit-content\"><span ng-repeat=\"dim in $ctrl.dimLegList track by $index\"><span><span \nng-if=\"$ctrl.dimLegList.length>1\">{{$index+1}}.</span> {{dim.leg_name}}, {{dim.cbm}} KG/CBM</span><br></span>\n</md-tooltip></div></div><div layout=\"column\" flex=\"15\" flex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm \nlayout-align=\"center start\"><div class=\"pb-5\">BUY RATE</div><div class=\"font-weight-600\" layout=\"row\">\n{{$ctrl.billingInfoData.rates[0].leg_total_currency}} {{($ctrl.footerObj.buyTotalBaseCurr | currencyMask: 2)}}</div>\n</div><div layout=\"column\" flex=\"15\" flex-xs=\"10\" flex-sm=\"10\" class=\"mr-10 br\" hide-xs hide-sm \nlayout-align=\"center start\"><div class=\"pb-5\">SELL RATE</div><div class=\"font-weight-600\">\n{{$ctrl.billingInfoData.rates[0].leg_total_currency}} {{$ctrl.footerObj.sellTotalBaseCurr | currencyMask: 2}}</div>\n</div><div layout=\"column\" flex=\"30\" flex-xs=\"20\" flex-sm=\"20\" hide-xs hide-sm layout-align=\"center start\" \nng-class=\"{\'br\' : ($ctrl.fromInquiry && $ctrl.quoteEdit)}\"><div \nng-if=\"$ctrl.footerObj.sellTotalBaseCurr >= $ctrl.footerObj.buyTotalBaseCurr\"><md-icon md-font-icon=\"icon-trending-up\" \nclass=\"green-fg s20 mr-5\"></md-icon>You earn <span class=\"font-weight-600\">\n{{$ctrl.billingInfoData.rates[0].leg_total_currency}} {{($ctrl.footerObj.sellTotalBaseCurr - $ctrl.footerObj.buyTotalBaseCurr | currencyMask: 2)}}\n</span> <span class=\"green-fg mh-5\">{{$ctrl.footerObj.profit}}</span> on this rate</div><div \nng-if=\"$ctrl.footerObj.sellTotalBaseCurr < $ctrl.footerObj.buyTotalBaseCurr\"><md-icon \nmd-font-icon=\"icon-trending-down\" class=\"red-fg s20\"></md-icon><span class=\"red-fg mh-5\">\n{{$ctrl.footerObj.profit.substr(1)}} Loss</span> <span class=\"font-weight-600\">\n(-{{$ctrl.billingInfoData.rates[0].leg_total_currency}} {{(($ctrl.footerObj.buyTotalBaseCurr - $ctrl.footerObj.sellTotalBaseCurr) | currencyMask: 2)}})\n</span> on this rate</div><div ng-if=\"$ctrl.showExchangeRates && $ctrl.resultId\"><a \nclass=\"pointer md-link-fg Font-Bold\" ng-click=\"$ctrl.fnViewExchangeRate()\">View Exchange Rates<md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"md-link-fg s20 ml-5\"></md-icon></a></div></div><div flex layout=\"column\" \nlayout-align=\"center end\"><md-button md-no-ink class=\"md-accent-btn\" style=\"margin-right:0px\" \nng-disabled=\"$ctrl.disableDoneBtn\" ng-click=\"$ctrl.submitRate()\">Done</md-button></div></div></md-dialog-actions>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);